(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecd19"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecd19"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3cRH8", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $255c24c426761ab0$export$6503ec6e8aabbaf; }, function (v) { return $255c24c426761ab0$export$6503ec6e8aabbaf = v; });
var $255c24c426761ab0$export$6503ec6e8aabbaf;
var $255c24c426761ab0$export$f7ad0328861e2f03;
"use strict";
var $255c24c426761ab0$var$mapping = new Map();
function $255c24c426761ab0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$255c24c426761ab0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $255c24c426761ab0$var$resolve(id) {
    var resolved = $255c24c426761ab0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$255c24c426761ab0$export$6503ec6e8aabbaf = $255c24c426761ab0$var$register;
$255c24c426761ab0$export$f7ad0328861e2f03 = $255c24c426761ab0$var$resolve;

});

parcelRegister("kjrOk", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $ec9b279e13d7c108$export$bdfd709ae4826697; }, function (v) { return $ec9b279e13d7c108$export$bdfd709ae4826697 = v; });
var $ec9b279e13d7c108$export$bdfd709ae4826697;
var $ec9b279e13d7c108$export$c9e73fbda7da57b6;
var $ec9b279e13d7c108$export$5a759dc7a1cfb72a;
"use strict";
var $ec9b279e13d7c108$var$bundleURL = {};
function $ec9b279e13d7c108$var$getBundleURLCached(id) {
    var value = $ec9b279e13d7c108$var$bundleURL[id];
    if (!value) {
        value = $ec9b279e13d7c108$var$getBundleURL();
        $ec9b279e13d7c108$var$bundleURL[id] = value;
    }
    return value;
}
function $ec9b279e13d7c108$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ec9b279e13d7c108$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $ec9b279e13d7c108$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $ec9b279e13d7c108$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$ec9b279e13d7c108$export$bdfd709ae4826697 = $ec9b279e13d7c108$var$getBundleURLCached;
$ec9b279e13d7c108$export$c9e73fbda7da57b6 = $ec9b279e13d7c108$var$getBaseURL;
$ec9b279e13d7c108$export$5a759dc7a1cfb72a = $ec9b279e13d7c108$var$getOrigin;

});

parcelRegister("28uU7", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $18e44d0878ccc981$export$ffb0004e005737fa; }, function (v) { return $18e44d0878ccc981$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $18e44d0878ccc981$export$34b9dba7ce09269b; }, function (v) { return $18e44d0878ccc981$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $18e44d0878ccc981$export$25062201e9e25d76; }, function (v) { return $18e44d0878ccc981$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $18e44d0878ccc981$export$ffb0004e005737fa;
var $18e44d0878ccc981$export$34b9dba7ce09269b;
var $18e44d0878ccc981$export$25062201e9e25d76;
"use strict";

var $4DE7A = parcelRequire("4DE7A");
var $18e44d0878ccc981$var$k = Symbol.for("react.element"), $18e44d0878ccc981$var$l = Symbol.for("react.fragment"), $18e44d0878ccc981$var$m = Object.prototype.hasOwnProperty, $18e44d0878ccc981$var$n = $4DE7A.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $18e44d0878ccc981$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $18e44d0878ccc981$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$18e44d0878ccc981$var$m.call(a, b) && !$18e44d0878ccc981$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $18e44d0878ccc981$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $18e44d0878ccc981$var$n.current
    };
}
$18e44d0878ccc981$export$ffb0004e005737fa = $18e44d0878ccc981$var$l;
$18e44d0878ccc981$export$34b9dba7ce09269b = $18e44d0878ccc981$var$q;
$18e44d0878ccc981$export$25062201e9e25d76 = $18e44d0878ccc981$var$q;

});
parcelRegister("4DE7A", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lqywx"));

});
parcelRegister("lqywx", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $f996ce6a21d04de9$export$dca3b0875bd9a954; }, function (v) { return $f996ce6a21d04de9$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $f996ce6a21d04de9$export$16fa2f45be04daa8; }, function (v) { return $f996ce6a21d04de9$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f996ce6a21d04de9$export$ffb0004e005737fa; }, function (v) { return $f996ce6a21d04de9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $f996ce6a21d04de9$export$e2c29f18771995cb; }, function (v) { return $f996ce6a21d04de9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $f996ce6a21d04de9$export$221d75b3f55bb0bd; }, function (v) { return $f996ce6a21d04de9$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f996ce6a21d04de9$export$5f8d39834fd61797; }, function (v) { return $f996ce6a21d04de9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f996ce6a21d04de9$export$74bf444e3cd11ea5; }, function (v) { return $f996ce6a21d04de9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $f996ce6a21d04de9$export$ae55be85d98224ed; }, function (v) { return $f996ce6a21d04de9$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $f996ce6a21d04de9$export$e530037191fcd5d7; }, function (v) { return $f996ce6a21d04de9$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $f996ce6a21d04de9$export$fd42f52fd3ae1109; }, function (v) { return $f996ce6a21d04de9$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $f996ce6a21d04de9$export$c8a8987d4410bf2d; }, function (v) { return $f996ce6a21d04de9$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $f996ce6a21d04de9$export$d38cd72104c1f0e9; }, function (v) { return $f996ce6a21d04de9$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $f996ce6a21d04de9$export$7d1e3a5e95ceca43; }, function (v) { return $f996ce6a21d04de9$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $f996ce6a21d04de9$export$257a8862b851cb5b; }, function (v) { return $f996ce6a21d04de9$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $f996ce6a21d04de9$export$a8257692ac88316c; }, function (v) { return $f996ce6a21d04de9$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $f996ce6a21d04de9$export$488013bae63b21da; }, function (v) { return $f996ce6a21d04de9$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $f996ce6a21d04de9$export$7c73462e0d25e514; }, function (v) { return $f996ce6a21d04de9$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $f996ce6a21d04de9$export$7568632d0d33d16d; }, function (v) { return $f996ce6a21d04de9$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $f996ce6a21d04de9$export$88948ce120ea2619; }, function (v) { return $f996ce6a21d04de9$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $f996ce6a21d04de9$export$35808ee640e87ca7; }, function (v) { return $f996ce6a21d04de9$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $f996ce6a21d04de9$export$fae74005e78b1a27; }, function (v) { return $f996ce6a21d04de9$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $f996ce6a21d04de9$export$dc8fbce3eb94dc1e; }, function (v) { return $f996ce6a21d04de9$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $f996ce6a21d04de9$export$6a7bc4e911dc01cf; }, function (v) { return $f996ce6a21d04de9$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $f996ce6a21d04de9$export$6d9c69b0de29b591; }, function (v) { return $f996ce6a21d04de9$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $f996ce6a21d04de9$export$f680877a34711e37; }, function (v) { return $f996ce6a21d04de9$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $f996ce6a21d04de9$export$d5a552a76deda3c2; }, function (v) { return $f996ce6a21d04de9$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $f996ce6a21d04de9$export$aaabe4eda9ed9969; }, function (v) { return $f996ce6a21d04de9$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $f996ce6a21d04de9$export$e5c5a5f917a5871c; }, function (v) { return $f996ce6a21d04de9$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $f996ce6a21d04de9$export$1538c33de8887b59; }, function (v) { return $f996ce6a21d04de9$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $f996ce6a21d04de9$export$13e3392192263954; }, function (v) { return $f996ce6a21d04de9$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $f996ce6a21d04de9$export$b8f5890fc79d6aca; }, function (v) { return $f996ce6a21d04de9$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $f996ce6a21d04de9$export$60241385465d0a34; }, function (v) { return $f996ce6a21d04de9$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $f996ce6a21d04de9$export$306c0aa65ff9ec16; }, function (v) { return $f996ce6a21d04de9$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $f996ce6a21d04de9$export$7b286972b8d8ccbf; }, function (v) { return $f996ce6a21d04de9$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $f996ce6a21d04de9$export$83d89fbfd8236492; }, function (v) { return $f996ce6a21d04de9$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f996ce6a21d04de9$export$dca3b0875bd9a954;
var $f996ce6a21d04de9$export$16fa2f45be04daa8;
var $f996ce6a21d04de9$export$ffb0004e005737fa;
var $f996ce6a21d04de9$export$e2c29f18771995cb;
var $f996ce6a21d04de9$export$221d75b3f55bb0bd;
var $f996ce6a21d04de9$export$5f8d39834fd61797;
var $f996ce6a21d04de9$export$74bf444e3cd11ea5;
var $f996ce6a21d04de9$export$ae55be85d98224ed;
var $f996ce6a21d04de9$export$e530037191fcd5d7;
var $f996ce6a21d04de9$export$fd42f52fd3ae1109;
var $f996ce6a21d04de9$export$c8a8987d4410bf2d;
var $f996ce6a21d04de9$export$d38cd72104c1f0e9;
var $f996ce6a21d04de9$export$7d1e3a5e95ceca43;
var $f996ce6a21d04de9$export$257a8862b851cb5b;
var $f996ce6a21d04de9$export$a8257692ac88316c;
var $f996ce6a21d04de9$export$488013bae63b21da;
var $f996ce6a21d04de9$export$7c73462e0d25e514;
var $f996ce6a21d04de9$export$7568632d0d33d16d;
var $f996ce6a21d04de9$export$88948ce120ea2619;
var $f996ce6a21d04de9$export$35808ee640e87ca7;
var $f996ce6a21d04de9$export$fae74005e78b1a27;
var $f996ce6a21d04de9$export$dc8fbce3eb94dc1e;
var $f996ce6a21d04de9$export$6a7bc4e911dc01cf;
var $f996ce6a21d04de9$export$6d9c69b0de29b591;
var $f996ce6a21d04de9$export$f680877a34711e37;
var $f996ce6a21d04de9$export$d5a552a76deda3c2;
var $f996ce6a21d04de9$export$aaabe4eda9ed9969;
var $f996ce6a21d04de9$export$e5c5a5f917a5871c;
var $f996ce6a21d04de9$export$1538c33de8887b59;
var $f996ce6a21d04de9$export$13e3392192263954;
var $f996ce6a21d04de9$export$b8f5890fc79d6aca;
var $f996ce6a21d04de9$export$60241385465d0a34;
var $f996ce6a21d04de9$export$306c0aa65ff9ec16;
var $f996ce6a21d04de9$export$7b286972b8d8ccbf;
var $f996ce6a21d04de9$export$83d89fbfd8236492;
"use strict";
var $f996ce6a21d04de9$var$l = Symbol.for("react.element"), $f996ce6a21d04de9$var$n = Symbol.for("react.portal"), $f996ce6a21d04de9$var$p = Symbol.for("react.fragment"), $f996ce6a21d04de9$var$q = Symbol.for("react.strict_mode"), $f996ce6a21d04de9$var$r = Symbol.for("react.profiler"), $f996ce6a21d04de9$var$t = Symbol.for("react.provider"), $f996ce6a21d04de9$var$u = Symbol.for("react.context"), $f996ce6a21d04de9$var$v = Symbol.for("react.forward_ref"), $f996ce6a21d04de9$var$w = Symbol.for("react.suspense"), $f996ce6a21d04de9$var$x = Symbol.for("react.memo"), $f996ce6a21d04de9$var$y = Symbol.for("react.lazy"), $f996ce6a21d04de9$var$z = Symbol.iterator;
function $f996ce6a21d04de9$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f996ce6a21d04de9$var$z && a[$f996ce6a21d04de9$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f996ce6a21d04de9$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $f996ce6a21d04de9$var$C = Object.assign, $f996ce6a21d04de9$var$D = {};
function $f996ce6a21d04de9$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f996ce6a21d04de9$var$D;
    this.updater = e || $f996ce6a21d04de9$var$B;
}
$f996ce6a21d04de9$var$E.prototype.isReactComponent = {};
$f996ce6a21d04de9$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$f996ce6a21d04de9$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $f996ce6a21d04de9$var$F() {}
$f996ce6a21d04de9$var$F.prototype = $f996ce6a21d04de9$var$E.prototype;
function $f996ce6a21d04de9$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f996ce6a21d04de9$var$D;
    this.updater = e || $f996ce6a21d04de9$var$B;
}
var $f996ce6a21d04de9$var$H = $f996ce6a21d04de9$var$G.prototype = new $f996ce6a21d04de9$var$F;
$f996ce6a21d04de9$var$H.constructor = $f996ce6a21d04de9$var$G;
$f996ce6a21d04de9$var$C($f996ce6a21d04de9$var$H, $f996ce6a21d04de9$var$E.prototype);
$f996ce6a21d04de9$var$H.isPureReactComponent = !0;
var $f996ce6a21d04de9$var$I = Array.isArray, $f996ce6a21d04de9$var$J = Object.prototype.hasOwnProperty, $f996ce6a21d04de9$var$K = {
    current: null
}, $f996ce6a21d04de9$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f996ce6a21d04de9$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$f996ce6a21d04de9$var$J.call(b, d) && !$f996ce6a21d04de9$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $f996ce6a21d04de9$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $f996ce6a21d04de9$var$K.current
    };
}
function $f996ce6a21d04de9$var$N(a, b) {
    return {
        $$typeof: $f996ce6a21d04de9$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $f996ce6a21d04de9$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f996ce6a21d04de9$var$l;
}
function $f996ce6a21d04de9$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $f996ce6a21d04de9$var$P = /\/+/g;
function $f996ce6a21d04de9$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $f996ce6a21d04de9$var$escape("" + a.key) : b.toString(36);
}
function $f996ce6a21d04de9$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $f996ce6a21d04de9$var$l:
                case $f996ce6a21d04de9$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $f996ce6a21d04de9$var$Q(h, 0) : d, $f996ce6a21d04de9$var$I(c) ? (e = "", null != a && (e = a.replace($f996ce6a21d04de9$var$P, "$&/") + "/"), $f996ce6a21d04de9$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($f996ce6a21d04de9$var$O(c) && (c = $f996ce6a21d04de9$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($f996ce6a21d04de9$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($f996ce6a21d04de9$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $f996ce6a21d04de9$var$Q(k, g);
        h += $f996ce6a21d04de9$var$R(k, b, e, f, c);
    }
    else if (f = $f996ce6a21d04de9$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $f996ce6a21d04de9$var$Q(k, g++), h += $f996ce6a21d04de9$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $f996ce6a21d04de9$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $f996ce6a21d04de9$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $f996ce6a21d04de9$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $f996ce6a21d04de9$var$U = {
    current: null
}, $f996ce6a21d04de9$var$V = {
    transition: null
}, $f996ce6a21d04de9$var$W = {
    ReactCurrentDispatcher: $f996ce6a21d04de9$var$U,
    ReactCurrentBatchConfig: $f996ce6a21d04de9$var$V,
    ReactCurrentOwner: $f996ce6a21d04de9$var$K
};
$f996ce6a21d04de9$export$dca3b0875bd9a954 = {
    map: $f996ce6a21d04de9$var$S,
    forEach: function(a, b, e) {
        $f996ce6a21d04de9$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $f996ce6a21d04de9$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $f996ce6a21d04de9$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$f996ce6a21d04de9$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$f996ce6a21d04de9$export$16fa2f45be04daa8 = $f996ce6a21d04de9$var$E;
$f996ce6a21d04de9$export$ffb0004e005737fa = $f996ce6a21d04de9$var$p;
$f996ce6a21d04de9$export$e2c29f18771995cb = $f996ce6a21d04de9$var$r;
$f996ce6a21d04de9$export$221d75b3f55bb0bd = $f996ce6a21d04de9$var$G;
$f996ce6a21d04de9$export$5f8d39834fd61797 = $f996ce6a21d04de9$var$q;
$f996ce6a21d04de9$export$74bf444e3cd11ea5 = $f996ce6a21d04de9$var$w;
$f996ce6a21d04de9$export$ae55be85d98224ed = $f996ce6a21d04de9$var$W;
$f996ce6a21d04de9$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $f996ce6a21d04de9$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $f996ce6a21d04de9$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$f996ce6a21d04de9$var$J.call(b, f) && !$f996ce6a21d04de9$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $f996ce6a21d04de9$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$f996ce6a21d04de9$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $f996ce6a21d04de9$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $f996ce6a21d04de9$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$f996ce6a21d04de9$export$c8a8987d4410bf2d = $f996ce6a21d04de9$var$M;
$f996ce6a21d04de9$export$d38cd72104c1f0e9 = function(a) {
    var b = $f996ce6a21d04de9$var$M.bind(null, a);
    b.type = a;
    return b;
};
$f996ce6a21d04de9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$f996ce6a21d04de9$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $f996ce6a21d04de9$var$v,
        render: a
    };
};
$f996ce6a21d04de9$export$a8257692ac88316c = $f996ce6a21d04de9$var$O;
$f996ce6a21d04de9$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $f996ce6a21d04de9$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $f996ce6a21d04de9$var$T
    };
};
$f996ce6a21d04de9$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $f996ce6a21d04de9$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$f996ce6a21d04de9$export$7568632d0d33d16d = function(a) {
    var b = $f996ce6a21d04de9$var$V.transition;
    $f996ce6a21d04de9$var$V.transition = {};
    try {
        a();
    } finally{
        $f996ce6a21d04de9$var$V.transition = b;
    }
};
$f996ce6a21d04de9$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$f996ce6a21d04de9$export$35808ee640e87ca7 = function(a, b) {
    return $f996ce6a21d04de9$var$U.current.useCallback(a, b);
};
$f996ce6a21d04de9$export$fae74005e78b1a27 = function(a) {
    return $f996ce6a21d04de9$var$U.current.useContext(a);
};
$f996ce6a21d04de9$export$dc8fbce3eb94dc1e = function() {};
$f996ce6a21d04de9$export$6a7bc4e911dc01cf = function(a) {
    return $f996ce6a21d04de9$var$U.current.useDeferredValue(a);
};
$f996ce6a21d04de9$export$6d9c69b0de29b591 = function(a, b) {
    return $f996ce6a21d04de9$var$U.current.useEffect(a, b);
};
$f996ce6a21d04de9$export$f680877a34711e37 = function() {
    return $f996ce6a21d04de9$var$U.current.useId();
};
$f996ce6a21d04de9$export$d5a552a76deda3c2 = function(a, b, e) {
    return $f996ce6a21d04de9$var$U.current.useImperativeHandle(a, b, e);
};
$f996ce6a21d04de9$export$aaabe4eda9ed9969 = function(a, b) {
    return $f996ce6a21d04de9$var$U.current.useInsertionEffect(a, b);
};
$f996ce6a21d04de9$export$e5c5a5f917a5871c = function(a, b) {
    return $f996ce6a21d04de9$var$U.current.useLayoutEffect(a, b);
};
$f996ce6a21d04de9$export$1538c33de8887b59 = function(a, b) {
    return $f996ce6a21d04de9$var$U.current.useMemo(a, b);
};
$f996ce6a21d04de9$export$13e3392192263954 = function(a, b, e) {
    return $f996ce6a21d04de9$var$U.current.useReducer(a, b, e);
};
$f996ce6a21d04de9$export$b8f5890fc79d6aca = function(a) {
    return $f996ce6a21d04de9$var$U.current.useRef(a);
};
$f996ce6a21d04de9$export$60241385465d0a34 = function(a) {
    return $f996ce6a21d04de9$var$U.current.useState(a);
};
$f996ce6a21d04de9$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $f996ce6a21d04de9$var$U.current.useSyncExternalStore(a, b, e);
};
$f996ce6a21d04de9$export$7b286972b8d8ccbf = function() {
    return $f996ce6a21d04de9$var$U.current.useTransition();
};
$f996ce6a21d04de9$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("gv34t", function(module, exports) {
"use strict";
function $c031ec753bb0ab8e$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c031ec753bb0ab8e$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c031ec753bb0ab8e$var$checkDCE();

module.exports = (parcelRequire("lYEld"));

});
parcelRegister("lYEld", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $fffe7e7adcbe9002$export$ae55be85d98224ed; }, function (v) { return $fffe7e7adcbe9002$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $fffe7e7adcbe9002$export$d39a5bbd09211389; }, function (v) { return $fffe7e7adcbe9002$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $fffe7e7adcbe9002$export$882461b6382ed46c; }, function (v) { return $fffe7e7adcbe9002$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $fffe7e7adcbe9002$export$466bfc07425424d5; }, function (v) { return $fffe7e7adcbe9002$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $fffe7e7adcbe9002$export$cd75ccfd720a3cd4; }, function (v) { return $fffe7e7adcbe9002$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $fffe7e7adcbe9002$export$fa8d919ba61d84db; }, function (v) { return $fffe7e7adcbe9002$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $fffe7e7adcbe9002$export$757ceba2d55c277e; }, function (v) { return $fffe7e7adcbe9002$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $fffe7e7adcbe9002$export$b3890eb0ae9dca99; }, function (v) { return $fffe7e7adcbe9002$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $fffe7e7adcbe9002$export$502457920280e6be; }, function (v) { return $fffe7e7adcbe9002$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $fffe7e7adcbe9002$export$c78a37762a8d58e1; }, function (v) { return $fffe7e7adcbe9002$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $fffe7e7adcbe9002$export$dc54d992c10e8a18; }, function (v) { return $fffe7e7adcbe9002$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $fffe7e7adcbe9002$export$83d89fbfd8236492; }, function (v) { return $fffe7e7adcbe9002$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $fffe7e7adcbe9002$export$ae55be85d98224ed;
var $fffe7e7adcbe9002$export$d39a5bbd09211389;
var $fffe7e7adcbe9002$export$882461b6382ed46c;
var $fffe7e7adcbe9002$export$466bfc07425424d5;
var $fffe7e7adcbe9002$export$cd75ccfd720a3cd4;
var $fffe7e7adcbe9002$export$fa8d919ba61d84db;
var $fffe7e7adcbe9002$export$757ceba2d55c277e;
var $fffe7e7adcbe9002$export$b3890eb0ae9dca99;
var $fffe7e7adcbe9002$export$502457920280e6be;
var $fffe7e7adcbe9002$export$c78a37762a8d58e1;
var $fffe7e7adcbe9002$export$dc54d992c10e8a18;
var $fffe7e7adcbe9002$export$83d89fbfd8236492;
"use strict";

var $4DE7A = parcelRequire("4DE7A");

var $2hXd7 = parcelRequire("2hXd7");
function $fffe7e7adcbe9002$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $fffe7e7adcbe9002$var$da = new Set, $fffe7e7adcbe9002$var$ea = {};
function $fffe7e7adcbe9002$var$fa(a, b) {
    $fffe7e7adcbe9002$var$ha(a, b);
    $fffe7e7adcbe9002$var$ha(a + "Capture", b);
}
function $fffe7e7adcbe9002$var$ha(a, b) {
    $fffe7e7adcbe9002$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$fffe7e7adcbe9002$var$da.add(b[a]);
}
var $fffe7e7adcbe9002$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $fffe7e7adcbe9002$var$ja = Object.prototype.hasOwnProperty, $fffe7e7adcbe9002$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $fffe7e7adcbe9002$var$la = {}, $fffe7e7adcbe9002$var$ma = {};
function $fffe7e7adcbe9002$var$oa(a) {
    if ($fffe7e7adcbe9002$var$ja.call($fffe7e7adcbe9002$var$ma, a)) return !0;
    if ($fffe7e7adcbe9002$var$ja.call($fffe7e7adcbe9002$var$la, a)) return !1;
    if ($fffe7e7adcbe9002$var$ka.test(a)) return $fffe7e7adcbe9002$var$ma[a] = !0;
    $fffe7e7adcbe9002$var$la[a] = !0;
    return !1;
}
function $fffe7e7adcbe9002$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $fffe7e7adcbe9002$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $fffe7e7adcbe9002$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $fffe7e7adcbe9002$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $fffe7e7adcbe9002$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $fffe7e7adcbe9002$var$z[a] = new $fffe7e7adcbe9002$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $fffe7e7adcbe9002$var$z[b] = new $fffe7e7adcbe9002$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $fffe7e7adcbe9002$var$z[a] = new $fffe7e7adcbe9002$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $fffe7e7adcbe9002$var$z[a] = new $fffe7e7adcbe9002$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $fffe7e7adcbe9002$var$z[a] = new $fffe7e7adcbe9002$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $fffe7e7adcbe9002$var$z[a] = new $fffe7e7adcbe9002$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $fffe7e7adcbe9002$var$z[a] = new $fffe7e7adcbe9002$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $fffe7e7adcbe9002$var$z[a] = new $fffe7e7adcbe9002$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $fffe7e7adcbe9002$var$z[a] = new $fffe7e7adcbe9002$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $fffe7e7adcbe9002$var$ra = /[\-:]([a-z])/g;
function $fffe7e7adcbe9002$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($fffe7e7adcbe9002$var$ra, $fffe7e7adcbe9002$var$sa);
    $fffe7e7adcbe9002$var$z[b] = new $fffe7e7adcbe9002$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($fffe7e7adcbe9002$var$ra, $fffe7e7adcbe9002$var$sa);
    $fffe7e7adcbe9002$var$z[b] = new $fffe7e7adcbe9002$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($fffe7e7adcbe9002$var$ra, $fffe7e7adcbe9002$var$sa);
    $fffe7e7adcbe9002$var$z[b] = new $fffe7e7adcbe9002$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $fffe7e7adcbe9002$var$z[a] = new $fffe7e7adcbe9002$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$fffe7e7adcbe9002$var$z.xlinkHref = new $fffe7e7adcbe9002$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $fffe7e7adcbe9002$var$z[a] = new $fffe7e7adcbe9002$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $fffe7e7adcbe9002$var$ta(a, b, c, d) {
    var e = $fffe7e7adcbe9002$var$z.hasOwnProperty(b) ? $fffe7e7adcbe9002$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $fffe7e7adcbe9002$var$qa(b, c, e, d) && (c = null), d || null === e ? $fffe7e7adcbe9002$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $fffe7e7adcbe9002$var$ua = $4DE7A.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $fffe7e7adcbe9002$var$va = Symbol.for("react.element"), $fffe7e7adcbe9002$var$wa = Symbol.for("react.portal"), $fffe7e7adcbe9002$var$ya = Symbol.for("react.fragment"), $fffe7e7adcbe9002$var$za = Symbol.for("react.strict_mode"), $fffe7e7adcbe9002$var$Aa = Symbol.for("react.profiler"), $fffe7e7adcbe9002$var$Ba = Symbol.for("react.provider"), $fffe7e7adcbe9002$var$Ca = Symbol.for("react.context"), $fffe7e7adcbe9002$var$Da = Symbol.for("react.forward_ref"), $fffe7e7adcbe9002$var$Ea = Symbol.for("react.suspense"), $fffe7e7adcbe9002$var$Fa = Symbol.for("react.suspense_list"), $fffe7e7adcbe9002$var$Ga = Symbol.for("react.memo"), $fffe7e7adcbe9002$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $fffe7e7adcbe9002$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $fffe7e7adcbe9002$var$Ja = Symbol.iterator;
function $fffe7e7adcbe9002$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $fffe7e7adcbe9002$var$Ja && a[$fffe7e7adcbe9002$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $fffe7e7adcbe9002$var$A = Object.assign, $fffe7e7adcbe9002$var$La;
function $fffe7e7adcbe9002$var$Ma(a) {
    if (void 0 === $fffe7e7adcbe9002$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $fffe7e7adcbe9002$var$La = b && b[1] || "";
    }
    return "\n" + $fffe7e7adcbe9002$var$La + a;
}
var $fffe7e7adcbe9002$var$Na = !1;
function $fffe7e7adcbe9002$var$Oa(a, b) {
    if (!a || $fffe7e7adcbe9002$var$Na) return "";
    $fffe7e7adcbe9002$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $fffe7e7adcbe9002$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $fffe7e7adcbe9002$var$Ma(a) : "";
}
function $fffe7e7adcbe9002$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $fffe7e7adcbe9002$var$Ma(a.type);
        case 16:
            return $fffe7e7adcbe9002$var$Ma("Lazy");
        case 13:
            return $fffe7e7adcbe9002$var$Ma("Suspense");
        case 19:
            return $fffe7e7adcbe9002$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $fffe7e7adcbe9002$var$Oa(a.type, !1), a;
        case 11:
            return a = $fffe7e7adcbe9002$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $fffe7e7adcbe9002$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $fffe7e7adcbe9002$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $fffe7e7adcbe9002$var$ya:
            return "Fragment";
        case $fffe7e7adcbe9002$var$wa:
            return "Portal";
        case $fffe7e7adcbe9002$var$Aa:
            return "Profiler";
        case $fffe7e7adcbe9002$var$za:
            return "StrictMode";
        case $fffe7e7adcbe9002$var$Ea:
            return "Suspense";
        case $fffe7e7adcbe9002$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $fffe7e7adcbe9002$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $fffe7e7adcbe9002$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $fffe7e7adcbe9002$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $fffe7e7adcbe9002$var$Ga:
            return b = a.displayName || null, null !== b ? b : $fffe7e7adcbe9002$var$Qa(a.type) || "Memo";
        case $fffe7e7adcbe9002$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $fffe7e7adcbe9002$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $fffe7e7adcbe9002$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $fffe7e7adcbe9002$var$Qa(b);
        case 8:
            return b === $fffe7e7adcbe9002$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $fffe7e7adcbe9002$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $fffe7e7adcbe9002$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $fffe7e7adcbe9002$var$Ua(a) {
    var b = $fffe7e7adcbe9002$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $fffe7e7adcbe9002$var$Va(a) {
    a._valueTracker || (a._valueTracker = $fffe7e7adcbe9002$var$Ua(a));
}
function $fffe7e7adcbe9002$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $fffe7e7adcbe9002$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $fffe7e7adcbe9002$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $fffe7e7adcbe9002$var$Ya(a, b) {
    var c = b.checked;
    return $fffe7e7adcbe9002$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $fffe7e7adcbe9002$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $fffe7e7adcbe9002$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $fffe7e7adcbe9002$var$ab(a, b) {
    b = b.checked;
    null != b && $fffe7e7adcbe9002$var$ta(a, "checked", b, !1);
}
function $fffe7e7adcbe9002$var$bb(a, b) {
    $fffe7e7adcbe9002$var$ab(a, b);
    var c = $fffe7e7adcbe9002$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $fffe7e7adcbe9002$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $fffe7e7adcbe9002$var$cb(a, b.type, $fffe7e7adcbe9002$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $fffe7e7adcbe9002$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $fffe7e7adcbe9002$var$cb(a, b, c) {
    if ("number" !== b || $fffe7e7adcbe9002$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $fffe7e7adcbe9002$var$eb = Array.isArray;
function $fffe7e7adcbe9002$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $fffe7e7adcbe9002$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $fffe7e7adcbe9002$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($fffe7e7adcbe9002$var$p(91));
    return $fffe7e7adcbe9002$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $fffe7e7adcbe9002$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($fffe7e7adcbe9002$var$p(92));
            if ($fffe7e7adcbe9002$var$eb(c)) {
                if (1 < c.length) throw Error($fffe7e7adcbe9002$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $fffe7e7adcbe9002$var$Sa(c)
    };
}
function $fffe7e7adcbe9002$var$ib(a, b) {
    var c = $fffe7e7adcbe9002$var$Sa(b.value), d = $fffe7e7adcbe9002$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $fffe7e7adcbe9002$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $fffe7e7adcbe9002$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $fffe7e7adcbe9002$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $fffe7e7adcbe9002$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $fffe7e7adcbe9002$var$mb, $fffe7e7adcbe9002$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $fffe7e7adcbe9002$var$mb = $fffe7e7adcbe9002$var$mb || document.createElement("div");
        $fffe7e7adcbe9002$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $fffe7e7adcbe9002$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $fffe7e7adcbe9002$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $fffe7e7adcbe9002$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $fffe7e7adcbe9002$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($fffe7e7adcbe9002$var$pb).forEach(function(a) {
    $fffe7e7adcbe9002$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $fffe7e7adcbe9002$var$pb[b] = $fffe7e7adcbe9002$var$pb[a];
    });
});
function $fffe7e7adcbe9002$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $fffe7e7adcbe9002$var$pb.hasOwnProperty(a) && $fffe7e7adcbe9002$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $fffe7e7adcbe9002$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $fffe7e7adcbe9002$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $fffe7e7adcbe9002$var$tb = $fffe7e7adcbe9002$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $fffe7e7adcbe9002$var$ub(a, b) {
    if (b) {
        if ($fffe7e7adcbe9002$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($fffe7e7adcbe9002$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($fffe7e7adcbe9002$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($fffe7e7adcbe9002$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($fffe7e7adcbe9002$var$p(62));
    }
}
function $fffe7e7adcbe9002$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $fffe7e7adcbe9002$var$wb = null;
function $fffe7e7adcbe9002$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $fffe7e7adcbe9002$var$yb = null, $fffe7e7adcbe9002$var$zb = null, $fffe7e7adcbe9002$var$Ab = null;
function $fffe7e7adcbe9002$var$Bb(a) {
    if (a = $fffe7e7adcbe9002$var$Cb(a)) {
        if ("function" !== typeof $fffe7e7adcbe9002$var$yb) throw Error($fffe7e7adcbe9002$var$p(280));
        var b = a.stateNode;
        b && (b = $fffe7e7adcbe9002$var$Db(b), $fffe7e7adcbe9002$var$yb(a.stateNode, a.type, b));
    }
}
function $fffe7e7adcbe9002$var$Eb(a) {
    $fffe7e7adcbe9002$var$zb ? $fffe7e7adcbe9002$var$Ab ? $fffe7e7adcbe9002$var$Ab.push(a) : $fffe7e7adcbe9002$var$Ab = [
        a
    ] : $fffe7e7adcbe9002$var$zb = a;
}
function $fffe7e7adcbe9002$var$Fb() {
    if ($fffe7e7adcbe9002$var$zb) {
        var a = $fffe7e7adcbe9002$var$zb, b = $fffe7e7adcbe9002$var$Ab;
        $fffe7e7adcbe9002$var$Ab = $fffe7e7adcbe9002$var$zb = null;
        $fffe7e7adcbe9002$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$fffe7e7adcbe9002$var$Bb(b[a]);
    }
}
function $fffe7e7adcbe9002$var$Gb(a, b) {
    return a(b);
}
function $fffe7e7adcbe9002$var$Hb() {}
var $fffe7e7adcbe9002$var$Ib = !1;
function $fffe7e7adcbe9002$var$Jb(a, b, c) {
    if ($fffe7e7adcbe9002$var$Ib) return a(b, c);
    $fffe7e7adcbe9002$var$Ib = !0;
    try {
        return $fffe7e7adcbe9002$var$Gb(a, b, c);
    } finally{
        if ($fffe7e7adcbe9002$var$Ib = !1, null !== $fffe7e7adcbe9002$var$zb || null !== $fffe7e7adcbe9002$var$Ab) $fffe7e7adcbe9002$var$Hb(), $fffe7e7adcbe9002$var$Fb();
    }
}
function $fffe7e7adcbe9002$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $fffe7e7adcbe9002$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($fffe7e7adcbe9002$var$p(231, b, typeof c));
    return c;
}
var $fffe7e7adcbe9002$var$Lb = !1;
if ($fffe7e7adcbe9002$var$ia) try {
    var $fffe7e7adcbe9002$var$Mb = {};
    Object.defineProperty($fffe7e7adcbe9002$var$Mb, "passive", {
        get: function() {
            $fffe7e7adcbe9002$var$Lb = !0;
        }
    });
    window.addEventListener("test", $fffe7e7adcbe9002$var$Mb, $fffe7e7adcbe9002$var$Mb);
    window.removeEventListener("test", $fffe7e7adcbe9002$var$Mb, $fffe7e7adcbe9002$var$Mb);
} catch (a) {
    $fffe7e7adcbe9002$var$Lb = !1;
}
function $fffe7e7adcbe9002$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $fffe7e7adcbe9002$var$Ob = !1, $fffe7e7adcbe9002$var$Pb = null, $fffe7e7adcbe9002$var$Qb = !1, $fffe7e7adcbe9002$var$Rb = null, $fffe7e7adcbe9002$var$Sb = {
    onError: function(a) {
        $fffe7e7adcbe9002$var$Ob = !0;
        $fffe7e7adcbe9002$var$Pb = a;
    }
};
function $fffe7e7adcbe9002$var$Tb(a, b, c, d, e, f, g, h, k) {
    $fffe7e7adcbe9002$var$Ob = !1;
    $fffe7e7adcbe9002$var$Pb = null;
    $fffe7e7adcbe9002$var$Nb.apply($fffe7e7adcbe9002$var$Sb, arguments);
}
function $fffe7e7adcbe9002$var$Ub(a, b, c, d, e, f, g, h, k) {
    $fffe7e7adcbe9002$var$Tb.apply(this, arguments);
    if ($fffe7e7adcbe9002$var$Ob) {
        if ($fffe7e7adcbe9002$var$Ob) {
            var l = $fffe7e7adcbe9002$var$Pb;
            $fffe7e7adcbe9002$var$Ob = !1;
            $fffe7e7adcbe9002$var$Pb = null;
        } else throw Error($fffe7e7adcbe9002$var$p(198));
        $fffe7e7adcbe9002$var$Qb || ($fffe7e7adcbe9002$var$Qb = !0, $fffe7e7adcbe9002$var$Rb = l);
    }
}
function $fffe7e7adcbe9002$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $fffe7e7adcbe9002$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $fffe7e7adcbe9002$var$Xb(a) {
    if ($fffe7e7adcbe9002$var$Vb(a) !== a) throw Error($fffe7e7adcbe9002$var$p(188));
}
function $fffe7e7adcbe9002$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $fffe7e7adcbe9002$var$Vb(a);
        if (null === b) throw Error($fffe7e7adcbe9002$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $fffe7e7adcbe9002$var$Xb(e), a;
                if (f === d) return $fffe7e7adcbe9002$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($fffe7e7adcbe9002$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($fffe7e7adcbe9002$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($fffe7e7adcbe9002$var$p(190));
    }
    if (3 !== c.tag) throw Error($fffe7e7adcbe9002$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $fffe7e7adcbe9002$var$Zb(a) {
    a = $fffe7e7adcbe9002$var$Yb(a);
    return null !== a ? $fffe7e7adcbe9002$var$$b(a) : null;
}
function $fffe7e7adcbe9002$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $fffe7e7adcbe9002$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $fffe7e7adcbe9002$var$ac = $2hXd7.unstable_scheduleCallback, $fffe7e7adcbe9002$var$bc = $2hXd7.unstable_cancelCallback, $fffe7e7adcbe9002$var$cc = $2hXd7.unstable_shouldYield, $fffe7e7adcbe9002$var$dc = $2hXd7.unstable_requestPaint, $fffe7e7adcbe9002$var$B = $2hXd7.unstable_now, $fffe7e7adcbe9002$var$ec = $2hXd7.unstable_getCurrentPriorityLevel, $fffe7e7adcbe9002$var$fc = $2hXd7.unstable_ImmediatePriority, $fffe7e7adcbe9002$var$gc = $2hXd7.unstable_UserBlockingPriority, $fffe7e7adcbe9002$var$hc = $2hXd7.unstable_NormalPriority, $fffe7e7adcbe9002$var$ic = $2hXd7.unstable_LowPriority, $fffe7e7adcbe9002$var$jc = $2hXd7.unstable_IdlePriority, $fffe7e7adcbe9002$var$kc = null, $fffe7e7adcbe9002$var$lc = null;
function $fffe7e7adcbe9002$var$mc(a) {
    if ($fffe7e7adcbe9002$var$lc && "function" === typeof $fffe7e7adcbe9002$var$lc.onCommitFiberRoot) try {
        $fffe7e7adcbe9002$var$lc.onCommitFiberRoot($fffe7e7adcbe9002$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $fffe7e7adcbe9002$var$oc = Math.clz32 ? Math.clz32 : $fffe7e7adcbe9002$var$nc, $fffe7e7adcbe9002$var$pc = Math.log, $fffe7e7adcbe9002$var$qc = Math.LN2;
function $fffe7e7adcbe9002$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($fffe7e7adcbe9002$var$pc(a) / $fffe7e7adcbe9002$var$qc | 0) | 0;
}
var $fffe7e7adcbe9002$var$rc = 64, $fffe7e7adcbe9002$var$sc = 4194304;
function $fffe7e7adcbe9002$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $fffe7e7adcbe9002$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $fffe7e7adcbe9002$var$tc(h) : (f &= g, 0 !== f && (d = $fffe7e7adcbe9002$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $fffe7e7adcbe9002$var$tc(g) : 0 !== f && (d = $fffe7e7adcbe9002$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $fffe7e7adcbe9002$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $fffe7e7adcbe9002$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $fffe7e7adcbe9002$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $fffe7e7adcbe9002$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $fffe7e7adcbe9002$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $fffe7e7adcbe9002$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $fffe7e7adcbe9002$var$yc() {
    var a = $fffe7e7adcbe9002$var$rc;
    $fffe7e7adcbe9002$var$rc <<= 1;
    0 === ($fffe7e7adcbe9002$var$rc & 4194240) && ($fffe7e7adcbe9002$var$rc = 64);
    return a;
}
function $fffe7e7adcbe9002$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $fffe7e7adcbe9002$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $fffe7e7adcbe9002$var$oc(b);
    a[b] = c;
}
function $fffe7e7adcbe9002$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $fffe7e7adcbe9002$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $fffe7e7adcbe9002$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $fffe7e7adcbe9002$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $fffe7e7adcbe9002$var$C = 0;
function $fffe7e7adcbe9002$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $fffe7e7adcbe9002$var$Ec, $fffe7e7adcbe9002$var$Fc, $fffe7e7adcbe9002$var$Gc, $fffe7e7adcbe9002$var$Hc, $fffe7e7adcbe9002$var$Ic, $fffe7e7adcbe9002$var$Jc = !1, $fffe7e7adcbe9002$var$Kc = [], $fffe7e7adcbe9002$var$Lc = null, $fffe7e7adcbe9002$var$Mc = null, $fffe7e7adcbe9002$var$Nc = null, $fffe7e7adcbe9002$var$Oc = new Map, $fffe7e7adcbe9002$var$Pc = new Map, $fffe7e7adcbe9002$var$Qc = [], $fffe7e7adcbe9002$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $fffe7e7adcbe9002$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $fffe7e7adcbe9002$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $fffe7e7adcbe9002$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $fffe7e7adcbe9002$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $fffe7e7adcbe9002$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $fffe7e7adcbe9002$var$Pc.delete(b.pointerId);
    }
}
function $fffe7e7adcbe9002$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $fffe7e7adcbe9002$var$Cb(b), null !== b && $fffe7e7adcbe9002$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $fffe7e7adcbe9002$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $fffe7e7adcbe9002$var$Lc = $fffe7e7adcbe9002$var$Tc($fffe7e7adcbe9002$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $fffe7e7adcbe9002$var$Mc = $fffe7e7adcbe9002$var$Tc($fffe7e7adcbe9002$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $fffe7e7adcbe9002$var$Nc = $fffe7e7adcbe9002$var$Tc($fffe7e7adcbe9002$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $fffe7e7adcbe9002$var$Oc.set(f, $fffe7e7adcbe9002$var$Tc($fffe7e7adcbe9002$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $fffe7e7adcbe9002$var$Pc.set(f, $fffe7e7adcbe9002$var$Tc($fffe7e7adcbe9002$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $fffe7e7adcbe9002$var$Vc(a) {
    var b = $fffe7e7adcbe9002$var$Wc(a.target);
    if (null !== b) {
        var c = $fffe7e7adcbe9002$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $fffe7e7adcbe9002$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $fffe7e7adcbe9002$var$Ic(a.priority, function() {
                        $fffe7e7adcbe9002$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $fffe7e7adcbe9002$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $fffe7e7adcbe9002$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $fffe7e7adcbe9002$var$wb = d;
            c.target.dispatchEvent(d);
            $fffe7e7adcbe9002$var$wb = null;
        } else return b = $fffe7e7adcbe9002$var$Cb(c), null !== b && $fffe7e7adcbe9002$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $fffe7e7adcbe9002$var$Zc(a, b, c) {
    $fffe7e7adcbe9002$var$Xc(a) && c.delete(b);
}
function $fffe7e7adcbe9002$var$$c() {
    $fffe7e7adcbe9002$var$Jc = !1;
    null !== $fffe7e7adcbe9002$var$Lc && $fffe7e7adcbe9002$var$Xc($fffe7e7adcbe9002$var$Lc) && ($fffe7e7adcbe9002$var$Lc = null);
    null !== $fffe7e7adcbe9002$var$Mc && $fffe7e7adcbe9002$var$Xc($fffe7e7adcbe9002$var$Mc) && ($fffe7e7adcbe9002$var$Mc = null);
    null !== $fffe7e7adcbe9002$var$Nc && $fffe7e7adcbe9002$var$Xc($fffe7e7adcbe9002$var$Nc) && ($fffe7e7adcbe9002$var$Nc = null);
    $fffe7e7adcbe9002$var$Oc.forEach($fffe7e7adcbe9002$var$Zc);
    $fffe7e7adcbe9002$var$Pc.forEach($fffe7e7adcbe9002$var$Zc);
}
function $fffe7e7adcbe9002$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $fffe7e7adcbe9002$var$Jc || ($fffe7e7adcbe9002$var$Jc = !0, $2hXd7.unstable_scheduleCallback($2hXd7.unstable_NormalPriority, $fffe7e7adcbe9002$var$$c)));
}
function $fffe7e7adcbe9002$var$bd(a) {
    function b(b) {
        return $fffe7e7adcbe9002$var$ad(b, a);
    }
    if (0 < $fffe7e7adcbe9002$var$Kc.length) {
        $fffe7e7adcbe9002$var$ad($fffe7e7adcbe9002$var$Kc[0], a);
        for(var c = 1; c < $fffe7e7adcbe9002$var$Kc.length; c++){
            var d = $fffe7e7adcbe9002$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $fffe7e7adcbe9002$var$Lc && $fffe7e7adcbe9002$var$ad($fffe7e7adcbe9002$var$Lc, a);
    null !== $fffe7e7adcbe9002$var$Mc && $fffe7e7adcbe9002$var$ad($fffe7e7adcbe9002$var$Mc, a);
    null !== $fffe7e7adcbe9002$var$Nc && $fffe7e7adcbe9002$var$ad($fffe7e7adcbe9002$var$Nc, a);
    $fffe7e7adcbe9002$var$Oc.forEach(b);
    $fffe7e7adcbe9002$var$Pc.forEach(b);
    for(c = 0; c < $fffe7e7adcbe9002$var$Qc.length; c++)d = $fffe7e7adcbe9002$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $fffe7e7adcbe9002$var$Qc.length && (c = $fffe7e7adcbe9002$var$Qc[0], null === c.blockedOn);)$fffe7e7adcbe9002$var$Vc(c), null === c.blockedOn && $fffe7e7adcbe9002$var$Qc.shift();
}
var $fffe7e7adcbe9002$var$cd = $fffe7e7adcbe9002$var$ua.ReactCurrentBatchConfig, $fffe7e7adcbe9002$var$dd = !0;
function $fffe7e7adcbe9002$var$ed(a, b, c, d) {
    var e = $fffe7e7adcbe9002$var$C, f = $fffe7e7adcbe9002$var$cd.transition;
    $fffe7e7adcbe9002$var$cd.transition = null;
    try {
        $fffe7e7adcbe9002$var$C = 1, $fffe7e7adcbe9002$var$fd(a, b, c, d);
    } finally{
        $fffe7e7adcbe9002$var$C = e, $fffe7e7adcbe9002$var$cd.transition = f;
    }
}
function $fffe7e7adcbe9002$var$gd(a, b, c, d) {
    var e = $fffe7e7adcbe9002$var$C, f = $fffe7e7adcbe9002$var$cd.transition;
    $fffe7e7adcbe9002$var$cd.transition = null;
    try {
        $fffe7e7adcbe9002$var$C = 4, $fffe7e7adcbe9002$var$fd(a, b, c, d);
    } finally{
        $fffe7e7adcbe9002$var$C = e, $fffe7e7adcbe9002$var$cd.transition = f;
    }
}
function $fffe7e7adcbe9002$var$fd(a, b, c, d) {
    if ($fffe7e7adcbe9002$var$dd) {
        var e = $fffe7e7adcbe9002$var$Yc(a, b, c, d);
        if (null === e) $fffe7e7adcbe9002$var$hd(a, b, d, $fffe7e7adcbe9002$var$id, c), $fffe7e7adcbe9002$var$Sc(a, d);
        else if ($fffe7e7adcbe9002$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($fffe7e7adcbe9002$var$Sc(a, d), b & 4 && -1 < $fffe7e7adcbe9002$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $fffe7e7adcbe9002$var$Cb(e);
                null !== f && $fffe7e7adcbe9002$var$Ec(f);
                f = $fffe7e7adcbe9002$var$Yc(a, b, c, d);
                null === f && $fffe7e7adcbe9002$var$hd(a, b, d, $fffe7e7adcbe9002$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $fffe7e7adcbe9002$var$hd(a, b, d, null, c);
    }
}
var $fffe7e7adcbe9002$var$id = null;
function $fffe7e7adcbe9002$var$Yc(a, b, c, d) {
    $fffe7e7adcbe9002$var$id = null;
    a = $fffe7e7adcbe9002$var$xb(d);
    a = $fffe7e7adcbe9002$var$Wc(a);
    if (null !== a) {
        if (b = $fffe7e7adcbe9002$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $fffe7e7adcbe9002$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $fffe7e7adcbe9002$var$id = a;
    return null;
}
function $fffe7e7adcbe9002$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($fffe7e7adcbe9002$var$ec()){
                case $fffe7e7adcbe9002$var$fc:
                    return 1;
                case $fffe7e7adcbe9002$var$gc:
                    return 4;
                case $fffe7e7adcbe9002$var$hc:
                case $fffe7e7adcbe9002$var$ic:
                    return 16;
                case $fffe7e7adcbe9002$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $fffe7e7adcbe9002$var$kd = null, $fffe7e7adcbe9002$var$ld = null, $fffe7e7adcbe9002$var$md = null;
function $fffe7e7adcbe9002$var$nd() {
    if ($fffe7e7adcbe9002$var$md) return $fffe7e7adcbe9002$var$md;
    var a, b = $fffe7e7adcbe9002$var$ld, c = b.length, d, e = "value" in $fffe7e7adcbe9002$var$kd ? $fffe7e7adcbe9002$var$kd.value : $fffe7e7adcbe9002$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $fffe7e7adcbe9002$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $fffe7e7adcbe9002$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $fffe7e7adcbe9002$var$pd() {
    return !0;
}
function $fffe7e7adcbe9002$var$qd() {
    return !1;
}
function $fffe7e7adcbe9002$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $fffe7e7adcbe9002$var$pd : $fffe7e7adcbe9002$var$qd;
        this.isPropagationStopped = $fffe7e7adcbe9002$var$qd;
        return this;
    }
    $fffe7e7adcbe9002$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $fffe7e7adcbe9002$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $fffe7e7adcbe9002$var$pd);
        },
        persist: function() {},
        isPersistent: $fffe7e7adcbe9002$var$pd
    });
    return b;
}
var $fffe7e7adcbe9002$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $fffe7e7adcbe9002$var$td = $fffe7e7adcbe9002$var$rd($fffe7e7adcbe9002$var$sd), $fffe7e7adcbe9002$var$ud = $fffe7e7adcbe9002$var$A({}, $fffe7e7adcbe9002$var$sd, {
    view: 0,
    detail: 0
}), $fffe7e7adcbe9002$var$vd = $fffe7e7adcbe9002$var$rd($fffe7e7adcbe9002$var$ud), $fffe7e7adcbe9002$var$wd, $fffe7e7adcbe9002$var$xd, $fffe7e7adcbe9002$var$yd, $fffe7e7adcbe9002$var$Ad = $fffe7e7adcbe9002$var$A({}, $fffe7e7adcbe9002$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $fffe7e7adcbe9002$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $fffe7e7adcbe9002$var$yd && ($fffe7e7adcbe9002$var$yd && "mousemove" === a.type ? ($fffe7e7adcbe9002$var$wd = a.screenX - $fffe7e7adcbe9002$var$yd.screenX, $fffe7e7adcbe9002$var$xd = a.screenY - $fffe7e7adcbe9002$var$yd.screenY) : $fffe7e7adcbe9002$var$xd = $fffe7e7adcbe9002$var$wd = 0, $fffe7e7adcbe9002$var$yd = a);
        return $fffe7e7adcbe9002$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $fffe7e7adcbe9002$var$xd;
    }
}), $fffe7e7adcbe9002$var$Bd = $fffe7e7adcbe9002$var$rd($fffe7e7adcbe9002$var$Ad), $fffe7e7adcbe9002$var$Cd = $fffe7e7adcbe9002$var$A({}, $fffe7e7adcbe9002$var$Ad, {
    dataTransfer: 0
}), $fffe7e7adcbe9002$var$Dd = $fffe7e7adcbe9002$var$rd($fffe7e7adcbe9002$var$Cd), $fffe7e7adcbe9002$var$Ed = $fffe7e7adcbe9002$var$A({}, $fffe7e7adcbe9002$var$ud, {
    relatedTarget: 0
}), $fffe7e7adcbe9002$var$Fd = $fffe7e7adcbe9002$var$rd($fffe7e7adcbe9002$var$Ed), $fffe7e7adcbe9002$var$Gd = $fffe7e7adcbe9002$var$A({}, $fffe7e7adcbe9002$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fffe7e7adcbe9002$var$Hd = $fffe7e7adcbe9002$var$rd($fffe7e7adcbe9002$var$Gd), $fffe7e7adcbe9002$var$Id = $fffe7e7adcbe9002$var$A({}, $fffe7e7adcbe9002$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $fffe7e7adcbe9002$var$Jd = $fffe7e7adcbe9002$var$rd($fffe7e7adcbe9002$var$Id), $fffe7e7adcbe9002$var$Kd = $fffe7e7adcbe9002$var$A({}, $fffe7e7adcbe9002$var$sd, {
    data: 0
}), $fffe7e7adcbe9002$var$Ld = $fffe7e7adcbe9002$var$rd($fffe7e7adcbe9002$var$Kd), $fffe7e7adcbe9002$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $fffe7e7adcbe9002$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $fffe7e7adcbe9002$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $fffe7e7adcbe9002$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $fffe7e7adcbe9002$var$Od[a]) ? !!b[a] : !1;
}
function $fffe7e7adcbe9002$var$zd() {
    return $fffe7e7adcbe9002$var$Pd;
}
var $fffe7e7adcbe9002$var$Qd = $fffe7e7adcbe9002$var$A({}, $fffe7e7adcbe9002$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $fffe7e7adcbe9002$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $fffe7e7adcbe9002$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $fffe7e7adcbe9002$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $fffe7e7adcbe9002$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $fffe7e7adcbe9002$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $fffe7e7adcbe9002$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $fffe7e7adcbe9002$var$Rd = $fffe7e7adcbe9002$var$rd($fffe7e7adcbe9002$var$Qd), $fffe7e7adcbe9002$var$Sd = $fffe7e7adcbe9002$var$A({}, $fffe7e7adcbe9002$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $fffe7e7adcbe9002$var$Td = $fffe7e7adcbe9002$var$rd($fffe7e7adcbe9002$var$Sd), $fffe7e7adcbe9002$var$Ud = $fffe7e7adcbe9002$var$A({}, $fffe7e7adcbe9002$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $fffe7e7adcbe9002$var$zd
}), $fffe7e7adcbe9002$var$Vd = $fffe7e7adcbe9002$var$rd($fffe7e7adcbe9002$var$Ud), $fffe7e7adcbe9002$var$Wd = $fffe7e7adcbe9002$var$A({}, $fffe7e7adcbe9002$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fffe7e7adcbe9002$var$Xd = $fffe7e7adcbe9002$var$rd($fffe7e7adcbe9002$var$Wd), $fffe7e7adcbe9002$var$Yd = $fffe7e7adcbe9002$var$A({}, $fffe7e7adcbe9002$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $fffe7e7adcbe9002$var$Zd = $fffe7e7adcbe9002$var$rd($fffe7e7adcbe9002$var$Yd), $fffe7e7adcbe9002$var$$d = [
    9,
    13,
    27,
    32
], $fffe7e7adcbe9002$var$ae = $fffe7e7adcbe9002$var$ia && "CompositionEvent" in window, $fffe7e7adcbe9002$var$be = null;
$fffe7e7adcbe9002$var$ia && "documentMode" in document && ($fffe7e7adcbe9002$var$be = document.documentMode);
var $fffe7e7adcbe9002$var$ce = $fffe7e7adcbe9002$var$ia && "TextEvent" in window && !$fffe7e7adcbe9002$var$be, $fffe7e7adcbe9002$var$de = $fffe7e7adcbe9002$var$ia && (!$fffe7e7adcbe9002$var$ae || $fffe7e7adcbe9002$var$be && 8 < $fffe7e7adcbe9002$var$be && 11 >= $fffe7e7adcbe9002$var$be), $fffe7e7adcbe9002$var$ee = String.fromCharCode(32), $fffe7e7adcbe9002$var$fe = !1;
function $fffe7e7adcbe9002$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $fffe7e7adcbe9002$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $fffe7e7adcbe9002$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $fffe7e7adcbe9002$var$ie = !1;
function $fffe7e7adcbe9002$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $fffe7e7adcbe9002$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $fffe7e7adcbe9002$var$fe = !0;
            return $fffe7e7adcbe9002$var$ee;
        case "textInput":
            return a = b.data, a === $fffe7e7adcbe9002$var$ee && $fffe7e7adcbe9002$var$fe ? null : a;
        default:
            return null;
    }
}
function $fffe7e7adcbe9002$var$ke(a, b) {
    if ($fffe7e7adcbe9002$var$ie) return "compositionend" === a || !$fffe7e7adcbe9002$var$ae && $fffe7e7adcbe9002$var$ge(a, b) ? (a = $fffe7e7adcbe9002$var$nd(), $fffe7e7adcbe9002$var$md = $fffe7e7adcbe9002$var$ld = $fffe7e7adcbe9002$var$kd = null, $fffe7e7adcbe9002$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $fffe7e7adcbe9002$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $fffe7e7adcbe9002$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $fffe7e7adcbe9002$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$fffe7e7adcbe9002$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $fffe7e7adcbe9002$var$ne(a, b, c, d) {
    $fffe7e7adcbe9002$var$Eb(d);
    b = $fffe7e7adcbe9002$var$oe(b, "onChange");
    0 < b.length && (c = new $fffe7e7adcbe9002$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $fffe7e7adcbe9002$var$pe = null, $fffe7e7adcbe9002$var$qe = null;
function $fffe7e7adcbe9002$var$re(a) {
    $fffe7e7adcbe9002$var$se(a, 0);
}
function $fffe7e7adcbe9002$var$te(a) {
    var b = $fffe7e7adcbe9002$var$ue(a);
    if ($fffe7e7adcbe9002$var$Wa(b)) return a;
}
function $fffe7e7adcbe9002$var$ve(a, b) {
    if ("change" === a) return b;
}
var $fffe7e7adcbe9002$var$we = !1;
if ($fffe7e7adcbe9002$var$ia) {
    var $fffe7e7adcbe9002$var$xe;
    if ($fffe7e7adcbe9002$var$ia) {
        var $fffe7e7adcbe9002$var$ye = "oninput" in document;
        if (!$fffe7e7adcbe9002$var$ye) {
            var $fffe7e7adcbe9002$var$ze = document.createElement("div");
            $fffe7e7adcbe9002$var$ze.setAttribute("oninput", "return;");
            $fffe7e7adcbe9002$var$ye = "function" === typeof $fffe7e7adcbe9002$var$ze.oninput;
        }
        $fffe7e7adcbe9002$var$xe = $fffe7e7adcbe9002$var$ye;
    } else $fffe7e7adcbe9002$var$xe = !1;
    $fffe7e7adcbe9002$var$we = $fffe7e7adcbe9002$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $fffe7e7adcbe9002$var$Ae() {
    $fffe7e7adcbe9002$var$pe && ($fffe7e7adcbe9002$var$pe.detachEvent("onpropertychange", $fffe7e7adcbe9002$var$Be), $fffe7e7adcbe9002$var$qe = $fffe7e7adcbe9002$var$pe = null);
}
function $fffe7e7adcbe9002$var$Be(a) {
    if ("value" === a.propertyName && $fffe7e7adcbe9002$var$te($fffe7e7adcbe9002$var$qe)) {
        var b = [];
        $fffe7e7adcbe9002$var$ne(b, $fffe7e7adcbe9002$var$qe, a, $fffe7e7adcbe9002$var$xb(a));
        $fffe7e7adcbe9002$var$Jb($fffe7e7adcbe9002$var$re, b);
    }
}
function $fffe7e7adcbe9002$var$Ce(a, b, c) {
    "focusin" === a ? ($fffe7e7adcbe9002$var$Ae(), $fffe7e7adcbe9002$var$pe = b, $fffe7e7adcbe9002$var$qe = c, $fffe7e7adcbe9002$var$pe.attachEvent("onpropertychange", $fffe7e7adcbe9002$var$Be)) : "focusout" === a && $fffe7e7adcbe9002$var$Ae();
}
function $fffe7e7adcbe9002$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $fffe7e7adcbe9002$var$te($fffe7e7adcbe9002$var$qe);
}
function $fffe7e7adcbe9002$var$Ee(a, b) {
    if ("click" === a) return $fffe7e7adcbe9002$var$te(b);
}
function $fffe7e7adcbe9002$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $fffe7e7adcbe9002$var$te(b);
}
function $fffe7e7adcbe9002$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $fffe7e7adcbe9002$var$He = "function" === typeof Object.is ? Object.is : $fffe7e7adcbe9002$var$Ge;
function $fffe7e7adcbe9002$var$Ie(a, b) {
    if ($fffe7e7adcbe9002$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$fffe7e7adcbe9002$var$ja.call(b, e) || !$fffe7e7adcbe9002$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $fffe7e7adcbe9002$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $fffe7e7adcbe9002$var$Ke(a, b) {
    var c = $fffe7e7adcbe9002$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $fffe7e7adcbe9002$var$Je(c);
    }
}
function $fffe7e7adcbe9002$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $fffe7e7adcbe9002$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $fffe7e7adcbe9002$var$Me() {
    for(var a = window, b = $fffe7e7adcbe9002$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $fffe7e7adcbe9002$var$Xa(a.document);
    }
    return b;
}
function $fffe7e7adcbe9002$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $fffe7e7adcbe9002$var$Oe(a) {
    var b = $fffe7e7adcbe9002$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $fffe7e7adcbe9002$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $fffe7e7adcbe9002$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $fffe7e7adcbe9002$var$Ke(c, f);
                var g = $fffe7e7adcbe9002$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $fffe7e7adcbe9002$var$Pe = $fffe7e7adcbe9002$var$ia && "documentMode" in document && 11 >= document.documentMode, $fffe7e7adcbe9002$var$Qe = null, $fffe7e7adcbe9002$var$Re = null, $fffe7e7adcbe9002$var$Se = null, $fffe7e7adcbe9002$var$Te = !1;
function $fffe7e7adcbe9002$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $fffe7e7adcbe9002$var$Te || null == $fffe7e7adcbe9002$var$Qe || $fffe7e7adcbe9002$var$Qe !== $fffe7e7adcbe9002$var$Xa(d) || (d = $fffe7e7adcbe9002$var$Qe, "selectionStart" in d && $fffe7e7adcbe9002$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $fffe7e7adcbe9002$var$Se && $fffe7e7adcbe9002$var$Ie($fffe7e7adcbe9002$var$Se, d) || ($fffe7e7adcbe9002$var$Se = d, d = $fffe7e7adcbe9002$var$oe($fffe7e7adcbe9002$var$Re, "onSelect"), 0 < d.length && (b = new $fffe7e7adcbe9002$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $fffe7e7adcbe9002$var$Qe)));
}
function $fffe7e7adcbe9002$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $fffe7e7adcbe9002$var$We = {
    animationend: $fffe7e7adcbe9002$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $fffe7e7adcbe9002$var$Ve("Animation", "AnimationIteration"),
    animationstart: $fffe7e7adcbe9002$var$Ve("Animation", "AnimationStart"),
    transitionend: $fffe7e7adcbe9002$var$Ve("Transition", "TransitionEnd")
}, $fffe7e7adcbe9002$var$Xe = {}, $fffe7e7adcbe9002$var$Ye = {};
$fffe7e7adcbe9002$var$ia && ($fffe7e7adcbe9002$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $fffe7e7adcbe9002$var$We.animationend.animation, delete $fffe7e7adcbe9002$var$We.animationiteration.animation, delete $fffe7e7adcbe9002$var$We.animationstart.animation), "TransitionEvent" in window || delete $fffe7e7adcbe9002$var$We.transitionend.transition);
function $fffe7e7adcbe9002$var$Ze(a) {
    if ($fffe7e7adcbe9002$var$Xe[a]) return $fffe7e7adcbe9002$var$Xe[a];
    if (!$fffe7e7adcbe9002$var$We[a]) return a;
    var b = $fffe7e7adcbe9002$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $fffe7e7adcbe9002$var$Ye) return $fffe7e7adcbe9002$var$Xe[a] = b[c];
    return a;
}
var $fffe7e7adcbe9002$var$$e = $fffe7e7adcbe9002$var$Ze("animationend"), $fffe7e7adcbe9002$var$af = $fffe7e7adcbe9002$var$Ze("animationiteration"), $fffe7e7adcbe9002$var$bf = $fffe7e7adcbe9002$var$Ze("animationstart"), $fffe7e7adcbe9002$var$cf = $fffe7e7adcbe9002$var$Ze("transitionend"), $fffe7e7adcbe9002$var$df = new Map, $fffe7e7adcbe9002$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $fffe7e7adcbe9002$var$ff(a, b) {
    $fffe7e7adcbe9002$var$df.set(a, b);
    $fffe7e7adcbe9002$var$fa(b, [
        a
    ]);
}
for(var $fffe7e7adcbe9002$var$gf = 0; $fffe7e7adcbe9002$var$gf < $fffe7e7adcbe9002$var$ef.length; $fffe7e7adcbe9002$var$gf++){
    var $fffe7e7adcbe9002$var$hf = $fffe7e7adcbe9002$var$ef[$fffe7e7adcbe9002$var$gf], $fffe7e7adcbe9002$var$jf = $fffe7e7adcbe9002$var$hf.toLowerCase(), $fffe7e7adcbe9002$var$kf = $fffe7e7adcbe9002$var$hf[0].toUpperCase() + $fffe7e7adcbe9002$var$hf.slice(1);
    $fffe7e7adcbe9002$var$ff($fffe7e7adcbe9002$var$jf, "on" + $fffe7e7adcbe9002$var$kf);
}
$fffe7e7adcbe9002$var$ff($fffe7e7adcbe9002$var$$e, "onAnimationEnd");
$fffe7e7adcbe9002$var$ff($fffe7e7adcbe9002$var$af, "onAnimationIteration");
$fffe7e7adcbe9002$var$ff($fffe7e7adcbe9002$var$bf, "onAnimationStart");
$fffe7e7adcbe9002$var$ff("dblclick", "onDoubleClick");
$fffe7e7adcbe9002$var$ff("focusin", "onFocus");
$fffe7e7adcbe9002$var$ff("focusout", "onBlur");
$fffe7e7adcbe9002$var$ff($fffe7e7adcbe9002$var$cf, "onTransitionEnd");
$fffe7e7adcbe9002$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$fffe7e7adcbe9002$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$fffe7e7adcbe9002$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$fffe7e7adcbe9002$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$fffe7e7adcbe9002$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$fffe7e7adcbe9002$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$fffe7e7adcbe9002$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$fffe7e7adcbe9002$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$fffe7e7adcbe9002$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$fffe7e7adcbe9002$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $fffe7e7adcbe9002$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $fffe7e7adcbe9002$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($fffe7e7adcbe9002$var$lf));
function $fffe7e7adcbe9002$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $fffe7e7adcbe9002$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $fffe7e7adcbe9002$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fffe7e7adcbe9002$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fffe7e7adcbe9002$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($fffe7e7adcbe9002$var$Qb) throw a = $fffe7e7adcbe9002$var$Rb, $fffe7e7adcbe9002$var$Qb = !1, $fffe7e7adcbe9002$var$Rb = null, a;
}
function $fffe7e7adcbe9002$var$D(a, b) {
    var c = b[$fffe7e7adcbe9002$var$of];
    void 0 === c && (c = b[$fffe7e7adcbe9002$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($fffe7e7adcbe9002$var$pf(b, a, 2, !1), c.add(d));
}
function $fffe7e7adcbe9002$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $fffe7e7adcbe9002$var$pf(c, a, d, b);
}
var $fffe7e7adcbe9002$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $fffe7e7adcbe9002$var$sf(a) {
    if (!a[$fffe7e7adcbe9002$var$rf]) {
        a[$fffe7e7adcbe9002$var$rf] = !0;
        $fffe7e7adcbe9002$var$da.forEach(function(b) {
            "selectionchange" !== b && ($fffe7e7adcbe9002$var$mf.has(b) || $fffe7e7adcbe9002$var$qf(b, !1, a), $fffe7e7adcbe9002$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$fffe7e7adcbe9002$var$rf] || (b[$fffe7e7adcbe9002$var$rf] = !0, $fffe7e7adcbe9002$var$qf("selectionchange", !1, b));
    }
}
function $fffe7e7adcbe9002$var$pf(a, b, c, d) {
    switch($fffe7e7adcbe9002$var$jd(b)){
        case 1:
            var e = $fffe7e7adcbe9002$var$ed;
            break;
        case 4:
            e = $fffe7e7adcbe9002$var$gd;
            break;
        default:
            e = $fffe7e7adcbe9002$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$fffe7e7adcbe9002$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $fffe7e7adcbe9002$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $fffe7e7adcbe9002$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $fffe7e7adcbe9002$var$Jb(function() {
        var d = f, e = $fffe7e7adcbe9002$var$xb(c), g = [];
        a: {
            var h = $fffe7e7adcbe9002$var$df.get(a);
            if (void 0 !== h) {
                var k = $fffe7e7adcbe9002$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $fffe7e7adcbe9002$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $fffe7e7adcbe9002$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $fffe7e7adcbe9002$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $fffe7e7adcbe9002$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $fffe7e7adcbe9002$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $fffe7e7adcbe9002$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $fffe7e7adcbe9002$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $fffe7e7adcbe9002$var$Vd;
                        break;
                    case $fffe7e7adcbe9002$var$$e:
                    case $fffe7e7adcbe9002$var$af:
                    case $fffe7e7adcbe9002$var$bf:
                        k = $fffe7e7adcbe9002$var$Hd;
                        break;
                    case $fffe7e7adcbe9002$var$cf:
                        k = $fffe7e7adcbe9002$var$Xd;
                        break;
                    case "scroll":
                        k = $fffe7e7adcbe9002$var$vd;
                        break;
                    case "wheel":
                        k = $fffe7e7adcbe9002$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $fffe7e7adcbe9002$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $fffe7e7adcbe9002$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $fffe7e7adcbe9002$var$Kb(w, x), null != F && t.push($fffe7e7adcbe9002$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $fffe7e7adcbe9002$var$wb && (n = c.relatedTarget || c.fromElement) && ($fffe7e7adcbe9002$var$Wc(n) || n[$fffe7e7adcbe9002$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $fffe7e7adcbe9002$var$Wc(n) : null, null !== n && (J = $fffe7e7adcbe9002$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $fffe7e7adcbe9002$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $fffe7e7adcbe9002$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $fffe7e7adcbe9002$var$ue(k);
                        u = null == n ? h : $fffe7e7adcbe9002$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $fffe7e7adcbe9002$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $fffe7e7adcbe9002$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $fffe7e7adcbe9002$var$vf(F))u++;
                            for(; 0 < w - u;)t = $fffe7e7adcbe9002$var$vf(t), w--;
                            for(; 0 < u - w;)x = $fffe7e7adcbe9002$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $fffe7e7adcbe9002$var$vf(t);
                                x = $fffe7e7adcbe9002$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $fffe7e7adcbe9002$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $fffe7e7adcbe9002$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $fffe7e7adcbe9002$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $fffe7e7adcbe9002$var$ve;
                else if ($fffe7e7adcbe9002$var$me(h)) {
                    if ($fffe7e7adcbe9002$var$we) na = $fffe7e7adcbe9002$var$Fe;
                    else {
                        na = $fffe7e7adcbe9002$var$De;
                        var xa = $fffe7e7adcbe9002$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $fffe7e7adcbe9002$var$Ee);
                if (na && (na = na(a, d))) {
                    $fffe7e7adcbe9002$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $fffe7e7adcbe9002$var$cb(h, "number", h.value);
            }
            xa = d ? $fffe7e7adcbe9002$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($fffe7e7adcbe9002$var$me(xa) || "true" === xa.contentEditable) $fffe7e7adcbe9002$var$Qe = xa, $fffe7e7adcbe9002$var$Re = d, $fffe7e7adcbe9002$var$Se = null;
                    break;
                case "focusout":
                    $fffe7e7adcbe9002$var$Se = $fffe7e7adcbe9002$var$Re = $fffe7e7adcbe9002$var$Qe = null;
                    break;
                case "mousedown":
                    $fffe7e7adcbe9002$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $fffe7e7adcbe9002$var$Te = !1;
                    $fffe7e7adcbe9002$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($fffe7e7adcbe9002$var$Pe) break;
                case "keydown":
                case "keyup":
                    $fffe7e7adcbe9002$var$Ue(g, c, e);
            }
            var $a;
            if ($fffe7e7adcbe9002$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $fffe7e7adcbe9002$var$ie ? $fffe7e7adcbe9002$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($fffe7e7adcbe9002$var$de && "ko" !== c.locale && ($fffe7e7adcbe9002$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $fffe7e7adcbe9002$var$ie && ($a = $fffe7e7adcbe9002$var$nd()) : ($fffe7e7adcbe9002$var$kd = e, $fffe7e7adcbe9002$var$ld = "value" in $fffe7e7adcbe9002$var$kd ? $fffe7e7adcbe9002$var$kd.value : $fffe7e7adcbe9002$var$kd.textContent, $fffe7e7adcbe9002$var$ie = !0)), xa = $fffe7e7adcbe9002$var$oe(d, ba), 0 < xa.length && (ba = new $fffe7e7adcbe9002$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $fffe7e7adcbe9002$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $fffe7e7adcbe9002$var$ce ? $fffe7e7adcbe9002$var$je(a, c) : $fffe7e7adcbe9002$var$ke(a, c)) d = $fffe7e7adcbe9002$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $fffe7e7adcbe9002$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $fffe7e7adcbe9002$var$se(g, b);
    });
}
function $fffe7e7adcbe9002$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $fffe7e7adcbe9002$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $fffe7e7adcbe9002$var$Kb(a, c), null != f && d.unshift($fffe7e7adcbe9002$var$tf(a, f, e)), f = $fffe7e7adcbe9002$var$Kb(a, b), null != f && d.push($fffe7e7adcbe9002$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $fffe7e7adcbe9002$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $fffe7e7adcbe9002$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $fffe7e7adcbe9002$var$Kb(c, f), null != k && g.unshift($fffe7e7adcbe9002$var$tf(c, k, h))) : e || (k = $fffe7e7adcbe9002$var$Kb(c, f), null != k && g.push($fffe7e7adcbe9002$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $fffe7e7adcbe9002$var$xf = /\r\n?/g, $fffe7e7adcbe9002$var$yf = /\u0000|\uFFFD/g;
function $fffe7e7adcbe9002$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($fffe7e7adcbe9002$var$xf, "\n").replace($fffe7e7adcbe9002$var$yf, "");
}
function $fffe7e7adcbe9002$var$Af(a, b, c) {
    b = $fffe7e7adcbe9002$var$zf(b);
    if ($fffe7e7adcbe9002$var$zf(a) !== b && c) throw Error($fffe7e7adcbe9002$var$p(425));
}
function $fffe7e7adcbe9002$var$Bf() {}
var $fffe7e7adcbe9002$var$Cf = null, $fffe7e7adcbe9002$var$Df = null;
function $fffe7e7adcbe9002$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $fffe7e7adcbe9002$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $fffe7e7adcbe9002$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $fffe7e7adcbe9002$var$Hf = "function" === typeof Promise ? Promise : void 0, $fffe7e7adcbe9002$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $fffe7e7adcbe9002$var$Hf ? function(a) {
    return $fffe7e7adcbe9002$var$Hf.resolve(null).then(a).catch($fffe7e7adcbe9002$var$If);
} : $fffe7e7adcbe9002$var$Ff;
function $fffe7e7adcbe9002$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $fffe7e7adcbe9002$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $fffe7e7adcbe9002$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $fffe7e7adcbe9002$var$bd(b);
}
function $fffe7e7adcbe9002$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $fffe7e7adcbe9002$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $fffe7e7adcbe9002$var$Nf = Math.random().toString(36).slice(2), $fffe7e7adcbe9002$var$Of = "__reactFiber$" + $fffe7e7adcbe9002$var$Nf, $fffe7e7adcbe9002$var$Pf = "__reactProps$" + $fffe7e7adcbe9002$var$Nf, $fffe7e7adcbe9002$var$uf = "__reactContainer$" + $fffe7e7adcbe9002$var$Nf, $fffe7e7adcbe9002$var$of = "__reactEvents$" + $fffe7e7adcbe9002$var$Nf, $fffe7e7adcbe9002$var$Qf = "__reactListeners$" + $fffe7e7adcbe9002$var$Nf, $fffe7e7adcbe9002$var$Rf = "__reactHandles$" + $fffe7e7adcbe9002$var$Nf;
function $fffe7e7adcbe9002$var$Wc(a) {
    var b = a[$fffe7e7adcbe9002$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$fffe7e7adcbe9002$var$uf] || c[$fffe7e7adcbe9002$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $fffe7e7adcbe9002$var$Mf(a); null !== a;){
                if (c = a[$fffe7e7adcbe9002$var$Of]) return c;
                a = $fffe7e7adcbe9002$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $fffe7e7adcbe9002$var$Cb(a) {
    a = a[$fffe7e7adcbe9002$var$Of] || a[$fffe7e7adcbe9002$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $fffe7e7adcbe9002$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($fffe7e7adcbe9002$var$p(33));
}
function $fffe7e7adcbe9002$var$Db(a) {
    return a[$fffe7e7adcbe9002$var$Pf] || null;
}
var $fffe7e7adcbe9002$var$Sf = [], $fffe7e7adcbe9002$var$Tf = -1;
function $fffe7e7adcbe9002$var$Uf(a) {
    return {
        current: a
    };
}
function $fffe7e7adcbe9002$var$E(a) {
    0 > $fffe7e7adcbe9002$var$Tf || (a.current = $fffe7e7adcbe9002$var$Sf[$fffe7e7adcbe9002$var$Tf], $fffe7e7adcbe9002$var$Sf[$fffe7e7adcbe9002$var$Tf] = null, $fffe7e7adcbe9002$var$Tf--);
}
function $fffe7e7adcbe9002$var$G(a, b) {
    $fffe7e7adcbe9002$var$Tf++;
    $fffe7e7adcbe9002$var$Sf[$fffe7e7adcbe9002$var$Tf] = a.current;
    a.current = b;
}
var $fffe7e7adcbe9002$var$Vf = {}, $fffe7e7adcbe9002$var$H = $fffe7e7adcbe9002$var$Uf($fffe7e7adcbe9002$var$Vf), $fffe7e7adcbe9002$var$Wf = $fffe7e7adcbe9002$var$Uf(!1), $fffe7e7adcbe9002$var$Xf = $fffe7e7adcbe9002$var$Vf;
function $fffe7e7adcbe9002$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $fffe7e7adcbe9002$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $fffe7e7adcbe9002$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $fffe7e7adcbe9002$var$$f() {
    $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$Wf);
    $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$H);
}
function $fffe7e7adcbe9002$var$ag(a, b, c) {
    if ($fffe7e7adcbe9002$var$H.current !== $fffe7e7adcbe9002$var$Vf) throw Error($fffe7e7adcbe9002$var$p(168));
    $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$H, b);
    $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$Wf, c);
}
function $fffe7e7adcbe9002$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($fffe7e7adcbe9002$var$p(108, $fffe7e7adcbe9002$var$Ra(a) || "Unknown", e));
    return $fffe7e7adcbe9002$var$A({}, c, d);
}
function $fffe7e7adcbe9002$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $fffe7e7adcbe9002$var$Vf;
    $fffe7e7adcbe9002$var$Xf = $fffe7e7adcbe9002$var$H.current;
    $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$H, a);
    $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$Wf, $fffe7e7adcbe9002$var$Wf.current);
    return !0;
}
function $fffe7e7adcbe9002$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($fffe7e7adcbe9002$var$p(169));
    c ? (a = $fffe7e7adcbe9002$var$bg(a, b, $fffe7e7adcbe9002$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$Wf), $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$H), $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$H, a)) : $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$Wf);
    $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$Wf, c);
}
var $fffe7e7adcbe9002$var$eg = null, $fffe7e7adcbe9002$var$fg = !1, $fffe7e7adcbe9002$var$gg = !1;
function $fffe7e7adcbe9002$var$hg(a) {
    null === $fffe7e7adcbe9002$var$eg ? $fffe7e7adcbe9002$var$eg = [
        a
    ] : $fffe7e7adcbe9002$var$eg.push(a);
}
function $fffe7e7adcbe9002$var$ig(a) {
    $fffe7e7adcbe9002$var$fg = !0;
    $fffe7e7adcbe9002$var$hg(a);
}
function $fffe7e7adcbe9002$var$jg() {
    if (!$fffe7e7adcbe9002$var$gg && null !== $fffe7e7adcbe9002$var$eg) {
        $fffe7e7adcbe9002$var$gg = !0;
        var a = 0, b = $fffe7e7adcbe9002$var$C;
        try {
            var c = $fffe7e7adcbe9002$var$eg;
            for($fffe7e7adcbe9002$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $fffe7e7adcbe9002$var$eg = null;
            $fffe7e7adcbe9002$var$fg = !1;
        } catch (e) {
            throw null !== $fffe7e7adcbe9002$var$eg && ($fffe7e7adcbe9002$var$eg = $fffe7e7adcbe9002$var$eg.slice(a + 1)), $fffe7e7adcbe9002$var$ac($fffe7e7adcbe9002$var$fc, $fffe7e7adcbe9002$var$jg), e;
        } finally{
            $fffe7e7adcbe9002$var$C = b, $fffe7e7adcbe9002$var$gg = !1;
        }
    }
    return null;
}
var $fffe7e7adcbe9002$var$kg = [], $fffe7e7adcbe9002$var$lg = 0, $fffe7e7adcbe9002$var$mg = null, $fffe7e7adcbe9002$var$ng = 0, $fffe7e7adcbe9002$var$og = [], $fffe7e7adcbe9002$var$pg = 0, $fffe7e7adcbe9002$var$qg = null, $fffe7e7adcbe9002$var$rg = 1, $fffe7e7adcbe9002$var$sg = "";
function $fffe7e7adcbe9002$var$tg(a, b) {
    $fffe7e7adcbe9002$var$kg[$fffe7e7adcbe9002$var$lg++] = $fffe7e7adcbe9002$var$ng;
    $fffe7e7adcbe9002$var$kg[$fffe7e7adcbe9002$var$lg++] = $fffe7e7adcbe9002$var$mg;
    $fffe7e7adcbe9002$var$mg = a;
    $fffe7e7adcbe9002$var$ng = b;
}
function $fffe7e7adcbe9002$var$ug(a, b, c) {
    $fffe7e7adcbe9002$var$og[$fffe7e7adcbe9002$var$pg++] = $fffe7e7adcbe9002$var$rg;
    $fffe7e7adcbe9002$var$og[$fffe7e7adcbe9002$var$pg++] = $fffe7e7adcbe9002$var$sg;
    $fffe7e7adcbe9002$var$og[$fffe7e7adcbe9002$var$pg++] = $fffe7e7adcbe9002$var$qg;
    $fffe7e7adcbe9002$var$qg = a;
    var d = $fffe7e7adcbe9002$var$rg;
    a = $fffe7e7adcbe9002$var$sg;
    var e = 32 - $fffe7e7adcbe9002$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $fffe7e7adcbe9002$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $fffe7e7adcbe9002$var$rg = 1 << 32 - $fffe7e7adcbe9002$var$oc(b) + e | c << e | d;
        $fffe7e7adcbe9002$var$sg = f + a;
    } else $fffe7e7adcbe9002$var$rg = 1 << f | c << e | d, $fffe7e7adcbe9002$var$sg = a;
}
function $fffe7e7adcbe9002$var$vg(a) {
    null !== a.return && ($fffe7e7adcbe9002$var$tg(a, 1), $fffe7e7adcbe9002$var$ug(a, 1, 0));
}
function $fffe7e7adcbe9002$var$wg(a) {
    for(; a === $fffe7e7adcbe9002$var$mg;)$fffe7e7adcbe9002$var$mg = $fffe7e7adcbe9002$var$kg[--$fffe7e7adcbe9002$var$lg], $fffe7e7adcbe9002$var$kg[$fffe7e7adcbe9002$var$lg] = null, $fffe7e7adcbe9002$var$ng = $fffe7e7adcbe9002$var$kg[--$fffe7e7adcbe9002$var$lg], $fffe7e7adcbe9002$var$kg[$fffe7e7adcbe9002$var$lg] = null;
    for(; a === $fffe7e7adcbe9002$var$qg;)$fffe7e7adcbe9002$var$qg = $fffe7e7adcbe9002$var$og[--$fffe7e7adcbe9002$var$pg], $fffe7e7adcbe9002$var$og[$fffe7e7adcbe9002$var$pg] = null, $fffe7e7adcbe9002$var$sg = $fffe7e7adcbe9002$var$og[--$fffe7e7adcbe9002$var$pg], $fffe7e7adcbe9002$var$og[$fffe7e7adcbe9002$var$pg] = null, $fffe7e7adcbe9002$var$rg = $fffe7e7adcbe9002$var$og[--$fffe7e7adcbe9002$var$pg], $fffe7e7adcbe9002$var$og[$fffe7e7adcbe9002$var$pg] = null;
}
var $fffe7e7adcbe9002$var$xg = null, $fffe7e7adcbe9002$var$yg = null, $fffe7e7adcbe9002$var$I = !1, $fffe7e7adcbe9002$var$zg = null;
function $fffe7e7adcbe9002$var$Ag(a, b) {
    var c = $fffe7e7adcbe9002$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $fffe7e7adcbe9002$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $fffe7e7adcbe9002$var$xg = a, $fffe7e7adcbe9002$var$yg = $fffe7e7adcbe9002$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $fffe7e7adcbe9002$var$xg = a, $fffe7e7adcbe9002$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $fffe7e7adcbe9002$var$qg ? {
                id: $fffe7e7adcbe9002$var$rg,
                overflow: $fffe7e7adcbe9002$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $fffe7e7adcbe9002$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $fffe7e7adcbe9002$var$xg = a, $fffe7e7adcbe9002$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $fffe7e7adcbe9002$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $fffe7e7adcbe9002$var$Eg(a) {
    if ($fffe7e7adcbe9002$var$I) {
        var b = $fffe7e7adcbe9002$var$yg;
        if (b) {
            var c = b;
            if (!$fffe7e7adcbe9002$var$Cg(a, b)) {
                if ($fffe7e7adcbe9002$var$Dg(a)) throw Error($fffe7e7adcbe9002$var$p(418));
                b = $fffe7e7adcbe9002$var$Lf(c.nextSibling);
                var d = $fffe7e7adcbe9002$var$xg;
                b && $fffe7e7adcbe9002$var$Cg(a, b) ? $fffe7e7adcbe9002$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $fffe7e7adcbe9002$var$I = !1, $fffe7e7adcbe9002$var$xg = a);
            }
        } else {
            if ($fffe7e7adcbe9002$var$Dg(a)) throw Error($fffe7e7adcbe9002$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $fffe7e7adcbe9002$var$I = !1;
            $fffe7e7adcbe9002$var$xg = a;
        }
    }
}
function $fffe7e7adcbe9002$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $fffe7e7adcbe9002$var$xg = a;
}
function $fffe7e7adcbe9002$var$Gg(a) {
    if (a !== $fffe7e7adcbe9002$var$xg) return !1;
    if (!$fffe7e7adcbe9002$var$I) return $fffe7e7adcbe9002$var$Fg(a), $fffe7e7adcbe9002$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$fffe7e7adcbe9002$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $fffe7e7adcbe9002$var$yg)) {
        if ($fffe7e7adcbe9002$var$Dg(a)) throw $fffe7e7adcbe9002$var$Hg(), Error($fffe7e7adcbe9002$var$p(418));
        for(; b;)$fffe7e7adcbe9002$var$Ag(a, b), b = $fffe7e7adcbe9002$var$Lf(b.nextSibling);
    }
    $fffe7e7adcbe9002$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($fffe7e7adcbe9002$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $fffe7e7adcbe9002$var$yg = $fffe7e7adcbe9002$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $fffe7e7adcbe9002$var$yg = null;
        }
    } else $fffe7e7adcbe9002$var$yg = $fffe7e7adcbe9002$var$xg ? $fffe7e7adcbe9002$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $fffe7e7adcbe9002$var$Hg() {
    for(var a = $fffe7e7adcbe9002$var$yg; a;)a = $fffe7e7adcbe9002$var$Lf(a.nextSibling);
}
function $fffe7e7adcbe9002$var$Ig() {
    $fffe7e7adcbe9002$var$yg = $fffe7e7adcbe9002$var$xg = null;
    $fffe7e7adcbe9002$var$I = !1;
}
function $fffe7e7adcbe9002$var$Jg(a) {
    null === $fffe7e7adcbe9002$var$zg ? $fffe7e7adcbe9002$var$zg = [
        a
    ] : $fffe7e7adcbe9002$var$zg.push(a);
}
var $fffe7e7adcbe9002$var$Kg = $fffe7e7adcbe9002$var$ua.ReactCurrentBatchConfig;
function $fffe7e7adcbe9002$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $fffe7e7adcbe9002$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $fffe7e7adcbe9002$var$Mg = $fffe7e7adcbe9002$var$Uf(null), $fffe7e7adcbe9002$var$Ng = null, $fffe7e7adcbe9002$var$Og = null, $fffe7e7adcbe9002$var$Pg = null;
function $fffe7e7adcbe9002$var$Qg() {
    $fffe7e7adcbe9002$var$Pg = $fffe7e7adcbe9002$var$Og = $fffe7e7adcbe9002$var$Ng = null;
}
function $fffe7e7adcbe9002$var$Rg(a) {
    var b = $fffe7e7adcbe9002$var$Mg.current;
    $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$Mg);
    a._currentValue = b;
}
function $fffe7e7adcbe9002$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $fffe7e7adcbe9002$var$Tg(a, b) {
    $fffe7e7adcbe9002$var$Ng = a;
    $fffe7e7adcbe9002$var$Pg = $fffe7e7adcbe9002$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($fffe7e7adcbe9002$var$Ug = !0), a.firstContext = null);
}
function $fffe7e7adcbe9002$var$Vg(a) {
    var b = a._currentValue;
    if ($fffe7e7adcbe9002$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $fffe7e7adcbe9002$var$Og) {
            if (null === $fffe7e7adcbe9002$var$Ng) throw Error($fffe7e7adcbe9002$var$p(308));
            $fffe7e7adcbe9002$var$Og = a;
            $fffe7e7adcbe9002$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $fffe7e7adcbe9002$var$Og = $fffe7e7adcbe9002$var$Og.next = a;
    }
    return b;
}
var $fffe7e7adcbe9002$var$Wg = null;
function $fffe7e7adcbe9002$var$Xg(a) {
    null === $fffe7e7adcbe9002$var$Wg ? $fffe7e7adcbe9002$var$Wg = [
        a
    ] : $fffe7e7adcbe9002$var$Wg.push(a);
}
function $fffe7e7adcbe9002$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $fffe7e7adcbe9002$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $fffe7e7adcbe9002$var$Zg(a, d);
}
function $fffe7e7adcbe9002$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $fffe7e7adcbe9002$var$$g = !1;
function $fffe7e7adcbe9002$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $fffe7e7adcbe9002$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $fffe7e7adcbe9002$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $fffe7e7adcbe9002$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($fffe7e7adcbe9002$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $fffe7e7adcbe9002$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $fffe7e7adcbe9002$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $fffe7e7adcbe9002$var$Zg(a, c);
}
function $fffe7e7adcbe9002$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fffe7e7adcbe9002$var$Cc(a, c);
    }
}
function $fffe7e7adcbe9002$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $fffe7e7adcbe9002$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $fffe7e7adcbe9002$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $fffe7e7adcbe9002$var$A({}, q, r);
                            break a;
                        case 2:
                            $fffe7e7adcbe9002$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $fffe7e7adcbe9002$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $fffe7e7adcbe9002$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($fffe7e7adcbe9002$var$p(191, e));
            e.call(d);
        }
    }
}
var $fffe7e7adcbe9002$var$jh = (new $4DE7A.Component).refs;
function $fffe7e7adcbe9002$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $fffe7e7adcbe9002$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $fffe7e7adcbe9002$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $fffe7e7adcbe9002$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fffe7e7adcbe9002$var$L(), e = $fffe7e7adcbe9002$var$lh(a), f = $fffe7e7adcbe9002$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fffe7e7adcbe9002$var$dh(a, f, e);
        null !== b && ($fffe7e7adcbe9002$var$mh(b, a, e, d), $fffe7e7adcbe9002$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fffe7e7adcbe9002$var$L(), e = $fffe7e7adcbe9002$var$lh(a), f = $fffe7e7adcbe9002$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fffe7e7adcbe9002$var$dh(a, f, e);
        null !== b && ($fffe7e7adcbe9002$var$mh(b, a, e, d), $fffe7e7adcbe9002$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $fffe7e7adcbe9002$var$L(), d = $fffe7e7adcbe9002$var$lh(a), e = $fffe7e7adcbe9002$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $fffe7e7adcbe9002$var$dh(a, e, d);
        null !== b && ($fffe7e7adcbe9002$var$mh(b, a, d, c), $fffe7e7adcbe9002$var$eh(b, a, d));
    }
};
function $fffe7e7adcbe9002$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$fffe7e7adcbe9002$var$Ie(c, d) || !$fffe7e7adcbe9002$var$Ie(e, f) : !0;
}
function $fffe7e7adcbe9002$var$ph(a, b, c) {
    var d = !1, e = $fffe7e7adcbe9002$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $fffe7e7adcbe9002$var$Vg(f) : (e = $fffe7e7adcbe9002$var$Zf(b) ? $fffe7e7adcbe9002$var$Xf : $fffe7e7adcbe9002$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $fffe7e7adcbe9002$var$Yf(a, e) : $fffe7e7adcbe9002$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $fffe7e7adcbe9002$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $fffe7e7adcbe9002$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $fffe7e7adcbe9002$var$nh.enqueueReplaceState(b, b.state, null);
}
function $fffe7e7adcbe9002$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $fffe7e7adcbe9002$var$jh;
    $fffe7e7adcbe9002$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $fffe7e7adcbe9002$var$Vg(f) : (f = $fffe7e7adcbe9002$var$Zf(b) ? $fffe7e7adcbe9002$var$Xf : $fffe7e7adcbe9002$var$H.current, e.context = $fffe7e7adcbe9002$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($fffe7e7adcbe9002$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $fffe7e7adcbe9002$var$nh.enqueueReplaceState(e, e.state, null), $fffe7e7adcbe9002$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $fffe7e7adcbe9002$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($fffe7e7adcbe9002$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($fffe7e7adcbe9002$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $fffe7e7adcbe9002$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($fffe7e7adcbe9002$var$p(284));
        if (!c._owner) throw Error($fffe7e7adcbe9002$var$p(290, a));
    }
    return a;
}
function $fffe7e7adcbe9002$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($fffe7e7adcbe9002$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $fffe7e7adcbe9002$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $fffe7e7adcbe9002$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $fffe7e7adcbe9002$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $fffe7e7adcbe9002$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $fffe7e7adcbe9002$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $fffe7e7adcbe9002$var$Ha && $fffe7e7adcbe9002$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $fffe7e7adcbe9002$var$sh(a, b, c), d.return = a, d;
        d = $fffe7e7adcbe9002$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $fffe7e7adcbe9002$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $fffe7e7adcbe9002$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $fffe7e7adcbe9002$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $fffe7e7adcbe9002$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $fffe7e7adcbe9002$var$va:
                    return c = $fffe7e7adcbe9002$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $fffe7e7adcbe9002$var$sh(a, null, b), c.return = a, c;
                case $fffe7e7adcbe9002$var$wa:
                    return b = $fffe7e7adcbe9002$var$zh(b, a.mode, c), b.return = a, b;
                case $fffe7e7adcbe9002$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($fffe7e7adcbe9002$var$eb(b) || $fffe7e7adcbe9002$var$Ka(b)) return b = $fffe7e7adcbe9002$var$Ah(b, a.mode, c, null), b.return = a, b;
            $fffe7e7adcbe9002$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $fffe7e7adcbe9002$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $fffe7e7adcbe9002$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $fffe7e7adcbe9002$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($fffe7e7adcbe9002$var$eb(c) || $fffe7e7adcbe9002$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $fffe7e7adcbe9002$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $fffe7e7adcbe9002$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $fffe7e7adcbe9002$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $fffe7e7adcbe9002$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($fffe7e7adcbe9002$var$eb(d) || $fffe7e7adcbe9002$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $fffe7e7adcbe9002$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $fffe7e7adcbe9002$var$I && $fffe7e7adcbe9002$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $fffe7e7adcbe9002$var$I && $fffe7e7adcbe9002$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $fffe7e7adcbe9002$var$I && $fffe7e7adcbe9002$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $fffe7e7adcbe9002$var$Ka(h);
        if ("function" !== typeof l) throw Error($fffe7e7adcbe9002$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($fffe7e7adcbe9002$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $fffe7e7adcbe9002$var$I && $fffe7e7adcbe9002$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $fffe7e7adcbe9002$var$I && $fffe7e7adcbe9002$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $fffe7e7adcbe9002$var$I && $fffe7e7adcbe9002$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $fffe7e7adcbe9002$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $fffe7e7adcbe9002$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $fffe7e7adcbe9002$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $fffe7e7adcbe9002$var$Ha && $fffe7e7adcbe9002$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $fffe7e7adcbe9002$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $fffe7e7adcbe9002$var$ya ? (d = $fffe7e7adcbe9002$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $fffe7e7adcbe9002$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $fffe7e7adcbe9002$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $fffe7e7adcbe9002$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $fffe7e7adcbe9002$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $fffe7e7adcbe9002$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($fffe7e7adcbe9002$var$eb(f)) return n(a, d, f, h);
            if ($fffe7e7adcbe9002$var$Ka(f)) return t(a, d, f, h);
            $fffe7e7adcbe9002$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $fffe7e7adcbe9002$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $fffe7e7adcbe9002$var$Bh = $fffe7e7adcbe9002$var$vh(!0), $fffe7e7adcbe9002$var$Ch = $fffe7e7adcbe9002$var$vh(!1), $fffe7e7adcbe9002$var$Dh = {}, $fffe7e7adcbe9002$var$Eh = $fffe7e7adcbe9002$var$Uf($fffe7e7adcbe9002$var$Dh), $fffe7e7adcbe9002$var$Fh = $fffe7e7adcbe9002$var$Uf($fffe7e7adcbe9002$var$Dh), $fffe7e7adcbe9002$var$Gh = $fffe7e7adcbe9002$var$Uf($fffe7e7adcbe9002$var$Dh);
function $fffe7e7adcbe9002$var$Hh(a) {
    if (a === $fffe7e7adcbe9002$var$Dh) throw Error($fffe7e7adcbe9002$var$p(174));
    return a;
}
function $fffe7e7adcbe9002$var$Ih(a, b) {
    $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$Gh, b);
    $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$Fh, a);
    $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$Eh, $fffe7e7adcbe9002$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $fffe7e7adcbe9002$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $fffe7e7adcbe9002$var$lb(b, a);
    }
    $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$Eh);
    $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$Eh, b);
}
function $fffe7e7adcbe9002$var$Jh() {
    $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$Eh);
    $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$Fh);
    $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$Gh);
}
function $fffe7e7adcbe9002$var$Kh(a) {
    $fffe7e7adcbe9002$var$Hh($fffe7e7adcbe9002$var$Gh.current);
    var b = $fffe7e7adcbe9002$var$Hh($fffe7e7adcbe9002$var$Eh.current);
    var c = $fffe7e7adcbe9002$var$lb(b, a.type);
    b !== c && ($fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$Fh, a), $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$Eh, c));
}
function $fffe7e7adcbe9002$var$Lh(a) {
    $fffe7e7adcbe9002$var$Fh.current === a && ($fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$Eh), $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$Fh));
}
var $fffe7e7adcbe9002$var$M = $fffe7e7adcbe9002$var$Uf(0);
function $fffe7e7adcbe9002$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $fffe7e7adcbe9002$var$Nh = [];
function $fffe7e7adcbe9002$var$Oh() {
    for(var a = 0; a < $fffe7e7adcbe9002$var$Nh.length; a++)$fffe7e7adcbe9002$var$Nh[a]._workInProgressVersionPrimary = null;
    $fffe7e7adcbe9002$var$Nh.length = 0;
}
var $fffe7e7adcbe9002$var$Ph = $fffe7e7adcbe9002$var$ua.ReactCurrentDispatcher, $fffe7e7adcbe9002$var$Qh = $fffe7e7adcbe9002$var$ua.ReactCurrentBatchConfig, $fffe7e7adcbe9002$var$Rh = 0, $fffe7e7adcbe9002$var$N = null, $fffe7e7adcbe9002$var$O = null, $fffe7e7adcbe9002$var$P = null, $fffe7e7adcbe9002$var$Sh = !1, $fffe7e7adcbe9002$var$Th = !1, $fffe7e7adcbe9002$var$Uh = 0, $fffe7e7adcbe9002$var$Vh = 0;
function $fffe7e7adcbe9002$var$Q() {
    throw Error($fffe7e7adcbe9002$var$p(321));
}
function $fffe7e7adcbe9002$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$fffe7e7adcbe9002$var$He(a[c], b[c])) return !1;
    return !0;
}
function $fffe7e7adcbe9002$var$Xh(a, b, c, d, e, f) {
    $fffe7e7adcbe9002$var$Rh = f;
    $fffe7e7adcbe9002$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $fffe7e7adcbe9002$var$Ph.current = null === a || null === a.memoizedState ? $fffe7e7adcbe9002$var$Yh : $fffe7e7adcbe9002$var$Zh;
    a = c(d, e);
    if ($fffe7e7adcbe9002$var$Th) {
        f = 0;
        do {
            $fffe7e7adcbe9002$var$Th = !1;
            $fffe7e7adcbe9002$var$Uh = 0;
            if (25 <= f) throw Error($fffe7e7adcbe9002$var$p(301));
            f += 1;
            $fffe7e7adcbe9002$var$P = $fffe7e7adcbe9002$var$O = null;
            b.updateQueue = null;
            $fffe7e7adcbe9002$var$Ph.current = $fffe7e7adcbe9002$var$$h;
            a = c(d, e);
        }while ($fffe7e7adcbe9002$var$Th);
    }
    $fffe7e7adcbe9002$var$Ph.current = $fffe7e7adcbe9002$var$ai;
    b = null !== $fffe7e7adcbe9002$var$O && null !== $fffe7e7adcbe9002$var$O.next;
    $fffe7e7adcbe9002$var$Rh = 0;
    $fffe7e7adcbe9002$var$P = $fffe7e7adcbe9002$var$O = $fffe7e7adcbe9002$var$N = null;
    $fffe7e7adcbe9002$var$Sh = !1;
    if (b) throw Error($fffe7e7adcbe9002$var$p(300));
    return a;
}
function $fffe7e7adcbe9002$var$bi() {
    var a = 0 !== $fffe7e7adcbe9002$var$Uh;
    $fffe7e7adcbe9002$var$Uh = 0;
    return a;
}
function $fffe7e7adcbe9002$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $fffe7e7adcbe9002$var$P ? $fffe7e7adcbe9002$var$N.memoizedState = $fffe7e7adcbe9002$var$P = a : $fffe7e7adcbe9002$var$P = $fffe7e7adcbe9002$var$P.next = a;
    return $fffe7e7adcbe9002$var$P;
}
function $fffe7e7adcbe9002$var$di() {
    if (null === $fffe7e7adcbe9002$var$O) {
        var a = $fffe7e7adcbe9002$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $fffe7e7adcbe9002$var$O.next;
    var b = null === $fffe7e7adcbe9002$var$P ? $fffe7e7adcbe9002$var$N.memoizedState : $fffe7e7adcbe9002$var$P.next;
    if (null !== b) $fffe7e7adcbe9002$var$P = b, $fffe7e7adcbe9002$var$O = a;
    else {
        if (null === a) throw Error($fffe7e7adcbe9002$var$p(310));
        $fffe7e7adcbe9002$var$O = a;
        a = {
            memoizedState: $fffe7e7adcbe9002$var$O.memoizedState,
            baseState: $fffe7e7adcbe9002$var$O.baseState,
            baseQueue: $fffe7e7adcbe9002$var$O.baseQueue,
            queue: $fffe7e7adcbe9002$var$O.queue,
            next: null
        };
        null === $fffe7e7adcbe9002$var$P ? $fffe7e7adcbe9002$var$N.memoizedState = $fffe7e7adcbe9002$var$P = a : $fffe7e7adcbe9002$var$P = $fffe7e7adcbe9002$var$P.next = a;
    }
    return $fffe7e7adcbe9002$var$P;
}
function $fffe7e7adcbe9002$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $fffe7e7adcbe9002$var$fi(a) {
    var b = $fffe7e7adcbe9002$var$di(), c = b.queue;
    if (null === c) throw Error($fffe7e7adcbe9002$var$p(311));
    c.lastRenderedReducer = a;
    var d = $fffe7e7adcbe9002$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($fffe7e7adcbe9002$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $fffe7e7adcbe9002$var$N.lanes |= m;
                $fffe7e7adcbe9002$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $fffe7e7adcbe9002$var$He(d, b.memoizedState) || ($fffe7e7adcbe9002$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $fffe7e7adcbe9002$var$N.lanes |= f, $fffe7e7adcbe9002$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $fffe7e7adcbe9002$var$gi(a) {
    var b = $fffe7e7adcbe9002$var$di(), c = b.queue;
    if (null === c) throw Error($fffe7e7adcbe9002$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $fffe7e7adcbe9002$var$He(f, b.memoizedState) || ($fffe7e7adcbe9002$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $fffe7e7adcbe9002$var$hi() {}
function $fffe7e7adcbe9002$var$ii(a, b) {
    var c = $fffe7e7adcbe9002$var$N, d = $fffe7e7adcbe9002$var$di(), e = b(), f = !$fffe7e7adcbe9002$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $fffe7e7adcbe9002$var$Ug = !0);
    d = d.queue;
    $fffe7e7adcbe9002$var$ji($fffe7e7adcbe9002$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $fffe7e7adcbe9002$var$P && $fffe7e7adcbe9002$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $fffe7e7adcbe9002$var$li(9, $fffe7e7adcbe9002$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $fffe7e7adcbe9002$var$R) throw Error($fffe7e7adcbe9002$var$p(349));
        0 !== ($fffe7e7adcbe9002$var$Rh & 30) || $fffe7e7adcbe9002$var$ni(c, b, e);
    }
    return e;
}
function $fffe7e7adcbe9002$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $fffe7e7adcbe9002$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fffe7e7adcbe9002$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $fffe7e7adcbe9002$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $fffe7e7adcbe9002$var$oi(b) && $fffe7e7adcbe9002$var$pi(a);
}
function $fffe7e7adcbe9002$var$ki(a, b, c) {
    return c(function() {
        $fffe7e7adcbe9002$var$oi(b) && $fffe7e7adcbe9002$var$pi(a);
    });
}
function $fffe7e7adcbe9002$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$fffe7e7adcbe9002$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $fffe7e7adcbe9002$var$pi(a) {
    var b = $fffe7e7adcbe9002$var$Zg(a, 1);
    null !== b && $fffe7e7adcbe9002$var$mh(b, a, 1, -1);
}
function $fffe7e7adcbe9002$var$qi(a) {
    var b = $fffe7e7adcbe9002$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $fffe7e7adcbe9002$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $fffe7e7adcbe9002$var$ri.bind(null, $fffe7e7adcbe9002$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $fffe7e7adcbe9002$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $fffe7e7adcbe9002$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fffe7e7adcbe9002$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $fffe7e7adcbe9002$var$si() {
    return $fffe7e7adcbe9002$var$di().memoizedState;
}
function $fffe7e7adcbe9002$var$ti(a, b, c, d) {
    var e = $fffe7e7adcbe9002$var$ci();
    $fffe7e7adcbe9002$var$N.flags |= a;
    e.memoizedState = $fffe7e7adcbe9002$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $fffe7e7adcbe9002$var$ui(a, b, c, d) {
    var e = $fffe7e7adcbe9002$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $fffe7e7adcbe9002$var$O) {
        var g = $fffe7e7adcbe9002$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $fffe7e7adcbe9002$var$Wh(d, g.deps)) {
            e.memoizedState = $fffe7e7adcbe9002$var$li(b, c, f, d);
            return;
        }
    }
    $fffe7e7adcbe9002$var$N.flags |= a;
    e.memoizedState = $fffe7e7adcbe9002$var$li(1 | b, c, f, d);
}
function $fffe7e7adcbe9002$var$vi(a, b) {
    return $fffe7e7adcbe9002$var$ti(8390656, 8, a, b);
}
function $fffe7e7adcbe9002$var$ji(a, b) {
    return $fffe7e7adcbe9002$var$ui(2048, 8, a, b);
}
function $fffe7e7adcbe9002$var$wi(a, b) {
    return $fffe7e7adcbe9002$var$ui(4, 2, a, b);
}
function $fffe7e7adcbe9002$var$xi(a, b) {
    return $fffe7e7adcbe9002$var$ui(4, 4, a, b);
}
function $fffe7e7adcbe9002$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $fffe7e7adcbe9002$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $fffe7e7adcbe9002$var$ui(4, 4, $fffe7e7adcbe9002$var$yi.bind(null, b, a), c);
}
function $fffe7e7adcbe9002$var$Ai() {}
function $fffe7e7adcbe9002$var$Bi(a, b) {
    var c = $fffe7e7adcbe9002$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fffe7e7adcbe9002$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fffe7e7adcbe9002$var$Ci(a, b) {
    var c = $fffe7e7adcbe9002$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fffe7e7adcbe9002$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fffe7e7adcbe9002$var$Di(a, b, c) {
    if (0 === ($fffe7e7adcbe9002$var$Rh & 21)) return a.baseState && (a.baseState = !1, $fffe7e7adcbe9002$var$Ug = !0), a.memoizedState = c;
    $fffe7e7adcbe9002$var$He(c, b) || (c = $fffe7e7adcbe9002$var$yc(), $fffe7e7adcbe9002$var$N.lanes |= c, $fffe7e7adcbe9002$var$hh |= c, a.baseState = !0);
    return b;
}
function $fffe7e7adcbe9002$var$Ei(a, b) {
    var c = $fffe7e7adcbe9002$var$C;
    $fffe7e7adcbe9002$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $fffe7e7adcbe9002$var$Qh.transition;
    $fffe7e7adcbe9002$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $fffe7e7adcbe9002$var$C = c, $fffe7e7adcbe9002$var$Qh.transition = d;
    }
}
function $fffe7e7adcbe9002$var$Fi() {
    return $fffe7e7adcbe9002$var$di().memoizedState;
}
function $fffe7e7adcbe9002$var$Gi(a, b, c) {
    var d = $fffe7e7adcbe9002$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fffe7e7adcbe9002$var$Hi(a)) $fffe7e7adcbe9002$var$Ii(b, c);
    else if (c = $fffe7e7adcbe9002$var$Yg(a, b, c, d), null !== c) {
        var e = $fffe7e7adcbe9002$var$L();
        $fffe7e7adcbe9002$var$mh(c, a, d, e);
        $fffe7e7adcbe9002$var$Ji(c, b, d);
    }
}
function $fffe7e7adcbe9002$var$ri(a, b, c) {
    var d = $fffe7e7adcbe9002$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fffe7e7adcbe9002$var$Hi(a)) $fffe7e7adcbe9002$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($fffe7e7adcbe9002$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $fffe7e7adcbe9002$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $fffe7e7adcbe9002$var$Yg(a, b, e, d);
        null !== c && (e = $fffe7e7adcbe9002$var$L(), $fffe7e7adcbe9002$var$mh(c, a, d, e), $fffe7e7adcbe9002$var$Ji(c, b, d));
    }
}
function $fffe7e7adcbe9002$var$Hi(a) {
    var b = a.alternate;
    return a === $fffe7e7adcbe9002$var$N || null !== b && b === $fffe7e7adcbe9002$var$N;
}
function $fffe7e7adcbe9002$var$Ii(a, b) {
    $fffe7e7adcbe9002$var$Th = $fffe7e7adcbe9002$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $fffe7e7adcbe9002$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fffe7e7adcbe9002$var$Cc(a, c);
    }
}
var $fffe7e7adcbe9002$var$ai = {
    readContext: $fffe7e7adcbe9002$var$Vg,
    useCallback: $fffe7e7adcbe9002$var$Q,
    useContext: $fffe7e7adcbe9002$var$Q,
    useEffect: $fffe7e7adcbe9002$var$Q,
    useImperativeHandle: $fffe7e7adcbe9002$var$Q,
    useInsertionEffect: $fffe7e7adcbe9002$var$Q,
    useLayoutEffect: $fffe7e7adcbe9002$var$Q,
    useMemo: $fffe7e7adcbe9002$var$Q,
    useReducer: $fffe7e7adcbe9002$var$Q,
    useRef: $fffe7e7adcbe9002$var$Q,
    useState: $fffe7e7adcbe9002$var$Q,
    useDebugValue: $fffe7e7adcbe9002$var$Q,
    useDeferredValue: $fffe7e7adcbe9002$var$Q,
    useTransition: $fffe7e7adcbe9002$var$Q,
    useMutableSource: $fffe7e7adcbe9002$var$Q,
    useSyncExternalStore: $fffe7e7adcbe9002$var$Q,
    useId: $fffe7e7adcbe9002$var$Q,
    unstable_isNewReconciler: !1
}, $fffe7e7adcbe9002$var$Yh = {
    readContext: $fffe7e7adcbe9002$var$Vg,
    useCallback: function(a, b) {
        $fffe7e7adcbe9002$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $fffe7e7adcbe9002$var$Vg,
    useEffect: $fffe7e7adcbe9002$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $fffe7e7adcbe9002$var$ti(4194308, 4, $fffe7e7adcbe9002$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $fffe7e7adcbe9002$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $fffe7e7adcbe9002$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $fffe7e7adcbe9002$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $fffe7e7adcbe9002$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $fffe7e7adcbe9002$var$Gi.bind(null, $fffe7e7adcbe9002$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $fffe7e7adcbe9002$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $fffe7e7adcbe9002$var$qi,
    useDebugValue: $fffe7e7adcbe9002$var$Ai,
    useDeferredValue: function(a) {
        return $fffe7e7adcbe9002$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $fffe7e7adcbe9002$var$qi(!1), b = a[0];
        a = $fffe7e7adcbe9002$var$Ei.bind(null, a[1]);
        $fffe7e7adcbe9002$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $fffe7e7adcbe9002$var$N, e = $fffe7e7adcbe9002$var$ci();
        if ($fffe7e7adcbe9002$var$I) {
            if (void 0 === c) throw Error($fffe7e7adcbe9002$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $fffe7e7adcbe9002$var$R) throw Error($fffe7e7adcbe9002$var$p(349));
            0 !== ($fffe7e7adcbe9002$var$Rh & 30) || $fffe7e7adcbe9002$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $fffe7e7adcbe9002$var$vi($fffe7e7adcbe9002$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $fffe7e7adcbe9002$var$li(9, $fffe7e7adcbe9002$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $fffe7e7adcbe9002$var$ci(), b = $fffe7e7adcbe9002$var$R.identifierPrefix;
        if ($fffe7e7adcbe9002$var$I) {
            var c = $fffe7e7adcbe9002$var$sg;
            var d = $fffe7e7adcbe9002$var$rg;
            c = (d & ~(1 << 32 - $fffe7e7adcbe9002$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $fffe7e7adcbe9002$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $fffe7e7adcbe9002$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $fffe7e7adcbe9002$var$Zh = {
    readContext: $fffe7e7adcbe9002$var$Vg,
    useCallback: $fffe7e7adcbe9002$var$Bi,
    useContext: $fffe7e7adcbe9002$var$Vg,
    useEffect: $fffe7e7adcbe9002$var$ji,
    useImperativeHandle: $fffe7e7adcbe9002$var$zi,
    useInsertionEffect: $fffe7e7adcbe9002$var$wi,
    useLayoutEffect: $fffe7e7adcbe9002$var$xi,
    useMemo: $fffe7e7adcbe9002$var$Ci,
    useReducer: $fffe7e7adcbe9002$var$fi,
    useRef: $fffe7e7adcbe9002$var$si,
    useState: function() {
        return $fffe7e7adcbe9002$var$fi($fffe7e7adcbe9002$var$ei);
    },
    useDebugValue: $fffe7e7adcbe9002$var$Ai,
    useDeferredValue: function(a) {
        var b = $fffe7e7adcbe9002$var$di();
        return $fffe7e7adcbe9002$var$Di(b, $fffe7e7adcbe9002$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $fffe7e7adcbe9002$var$fi($fffe7e7adcbe9002$var$ei)[0], b = $fffe7e7adcbe9002$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fffe7e7adcbe9002$var$hi,
    useSyncExternalStore: $fffe7e7adcbe9002$var$ii,
    useId: $fffe7e7adcbe9002$var$Fi,
    unstable_isNewReconciler: !1
}, $fffe7e7adcbe9002$var$$h = {
    readContext: $fffe7e7adcbe9002$var$Vg,
    useCallback: $fffe7e7adcbe9002$var$Bi,
    useContext: $fffe7e7adcbe9002$var$Vg,
    useEffect: $fffe7e7adcbe9002$var$ji,
    useImperativeHandle: $fffe7e7adcbe9002$var$zi,
    useInsertionEffect: $fffe7e7adcbe9002$var$wi,
    useLayoutEffect: $fffe7e7adcbe9002$var$xi,
    useMemo: $fffe7e7adcbe9002$var$Ci,
    useReducer: $fffe7e7adcbe9002$var$gi,
    useRef: $fffe7e7adcbe9002$var$si,
    useState: function() {
        return $fffe7e7adcbe9002$var$gi($fffe7e7adcbe9002$var$ei);
    },
    useDebugValue: $fffe7e7adcbe9002$var$Ai,
    useDeferredValue: function(a) {
        var b = $fffe7e7adcbe9002$var$di();
        return null === $fffe7e7adcbe9002$var$O ? b.memoizedState = a : $fffe7e7adcbe9002$var$Di(b, $fffe7e7adcbe9002$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $fffe7e7adcbe9002$var$gi($fffe7e7adcbe9002$var$ei)[0], b = $fffe7e7adcbe9002$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fffe7e7adcbe9002$var$hi,
    useSyncExternalStore: $fffe7e7adcbe9002$var$ii,
    useId: $fffe7e7adcbe9002$var$Fi,
    unstable_isNewReconciler: !1
};
function $fffe7e7adcbe9002$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $fffe7e7adcbe9002$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $fffe7e7adcbe9002$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $fffe7e7adcbe9002$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $fffe7e7adcbe9002$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $fffe7e7adcbe9002$var$Oi(a, b, c) {
    c = $fffe7e7adcbe9002$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $fffe7e7adcbe9002$var$Pi || ($fffe7e7adcbe9002$var$Pi = !0, $fffe7e7adcbe9002$var$Qi = d);
        $fffe7e7adcbe9002$var$Mi(a, b);
    };
    return c;
}
function $fffe7e7adcbe9002$var$Ri(a, b, c) {
    c = $fffe7e7adcbe9002$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $fffe7e7adcbe9002$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $fffe7e7adcbe9002$var$Mi(a, b);
        "function" !== typeof d && (null === $fffe7e7adcbe9002$var$Si ? $fffe7e7adcbe9002$var$Si = new Set([
            this
        ]) : $fffe7e7adcbe9002$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $fffe7e7adcbe9002$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $fffe7e7adcbe9002$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $fffe7e7adcbe9002$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $fffe7e7adcbe9002$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $fffe7e7adcbe9002$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $fffe7e7adcbe9002$var$ch(-1, 1), b.tag = 2, $fffe7e7adcbe9002$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $fffe7e7adcbe9002$var$Xi = $fffe7e7adcbe9002$var$ua.ReactCurrentOwner, $fffe7e7adcbe9002$var$Ug = !1;
function $fffe7e7adcbe9002$var$Yi(a, b, c, d) {
    b.child = null === a ? $fffe7e7adcbe9002$var$Ch(b, null, c, d) : $fffe7e7adcbe9002$var$Bh(b, a.child, c, d);
}
function $fffe7e7adcbe9002$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $fffe7e7adcbe9002$var$Tg(b, e);
    d = $fffe7e7adcbe9002$var$Xh(a, b, c, d, f, e);
    c = $fffe7e7adcbe9002$var$bi();
    if (null !== a && !$fffe7e7adcbe9002$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fffe7e7adcbe9002$var$$i(a, b, e);
    $fffe7e7adcbe9002$var$I && c && $fffe7e7adcbe9002$var$vg(b);
    b.flags |= 1;
    $fffe7e7adcbe9002$var$Yi(a, b, d, e);
    return b.child;
}
function $fffe7e7adcbe9002$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$fffe7e7adcbe9002$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $fffe7e7adcbe9002$var$cj(a, b, f, d, e);
        a = $fffe7e7adcbe9002$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $fffe7e7adcbe9002$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $fffe7e7adcbe9002$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $fffe7e7adcbe9002$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $fffe7e7adcbe9002$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($fffe7e7adcbe9002$var$Ie(f, d) && a.ref === b.ref) {
            if ($fffe7e7adcbe9002$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($fffe7e7adcbe9002$var$Ug = !0);
            else return b.lanes = a.lanes, $fffe7e7adcbe9002$var$$i(a, b, e);
        }
    }
    return $fffe7e7adcbe9002$var$dj(a, b, c, d, e);
}
function $fffe7e7adcbe9002$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$fj, $fffe7e7adcbe9002$var$gj), $fffe7e7adcbe9002$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$fj, $fffe7e7adcbe9002$var$gj), $fffe7e7adcbe9002$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$fj, $fffe7e7adcbe9002$var$gj);
            $fffe7e7adcbe9002$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$fj, $fffe7e7adcbe9002$var$gj), $fffe7e7adcbe9002$var$gj |= d;
    $fffe7e7adcbe9002$var$Yi(a, b, e, c);
    return b.child;
}
function $fffe7e7adcbe9002$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $fffe7e7adcbe9002$var$dj(a, b, c, d, e) {
    var f = $fffe7e7adcbe9002$var$Zf(c) ? $fffe7e7adcbe9002$var$Xf : $fffe7e7adcbe9002$var$H.current;
    f = $fffe7e7adcbe9002$var$Yf(b, f);
    $fffe7e7adcbe9002$var$Tg(b, e);
    c = $fffe7e7adcbe9002$var$Xh(a, b, c, d, f, e);
    d = $fffe7e7adcbe9002$var$bi();
    if (null !== a && !$fffe7e7adcbe9002$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fffe7e7adcbe9002$var$$i(a, b, e);
    $fffe7e7adcbe9002$var$I && d && $fffe7e7adcbe9002$var$vg(b);
    b.flags |= 1;
    $fffe7e7adcbe9002$var$Yi(a, b, c, e);
    return b.child;
}
function $fffe7e7adcbe9002$var$ij(a, b, c, d, e) {
    if ($fffe7e7adcbe9002$var$Zf(c)) {
        var f = !0;
        $fffe7e7adcbe9002$var$cg(b);
    } else f = !1;
    $fffe7e7adcbe9002$var$Tg(b, e);
    if (null === b.stateNode) $fffe7e7adcbe9002$var$jj(a, b), $fffe7e7adcbe9002$var$ph(b, c, d), $fffe7e7adcbe9002$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $fffe7e7adcbe9002$var$Vg(l) : (l = $fffe7e7adcbe9002$var$Zf(c) ? $fffe7e7adcbe9002$var$Xf : $fffe7e7adcbe9002$var$H.current, l = $fffe7e7adcbe9002$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $fffe7e7adcbe9002$var$qh(b, g, d, l);
        $fffe7e7adcbe9002$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $fffe7e7adcbe9002$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $fffe7e7adcbe9002$var$Wf.current || $fffe7e7adcbe9002$var$$g ? ("function" === typeof m && ($fffe7e7adcbe9002$var$kh(b, c, m, d), k = b.memoizedState), (h = $fffe7e7adcbe9002$var$$g || $fffe7e7adcbe9002$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $fffe7e7adcbe9002$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $fffe7e7adcbe9002$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $fffe7e7adcbe9002$var$Vg(k) : (k = $fffe7e7adcbe9002$var$Zf(c) ? $fffe7e7adcbe9002$var$Xf : $fffe7e7adcbe9002$var$H.current, k = $fffe7e7adcbe9002$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $fffe7e7adcbe9002$var$qh(b, g, d, k);
        $fffe7e7adcbe9002$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $fffe7e7adcbe9002$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $fffe7e7adcbe9002$var$Wf.current || $fffe7e7adcbe9002$var$$g ? ("function" === typeof y && ($fffe7e7adcbe9002$var$kh(b, c, y, d), n = b.memoizedState), (l = $fffe7e7adcbe9002$var$$g || $fffe7e7adcbe9002$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $fffe7e7adcbe9002$var$kj(a, b, c, d, f, e);
}
function $fffe7e7adcbe9002$var$kj(a, b, c, d, e, f) {
    $fffe7e7adcbe9002$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $fffe7e7adcbe9002$var$dg(b, c, !1), $fffe7e7adcbe9002$var$$i(a, b, f);
    d = b.stateNode;
    $fffe7e7adcbe9002$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $fffe7e7adcbe9002$var$Bh(b, a.child, null, f), b.child = $fffe7e7adcbe9002$var$Bh(b, null, h, f)) : $fffe7e7adcbe9002$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $fffe7e7adcbe9002$var$dg(b, c, !0);
    return b.child;
}
function $fffe7e7adcbe9002$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $fffe7e7adcbe9002$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $fffe7e7adcbe9002$var$ag(a, b.context, !1);
    $fffe7e7adcbe9002$var$Ih(a, b.containerInfo);
}
function $fffe7e7adcbe9002$var$mj(a, b, c, d, e) {
    $fffe7e7adcbe9002$var$Ig();
    $fffe7e7adcbe9002$var$Jg(e);
    b.flags |= 256;
    $fffe7e7adcbe9002$var$Yi(a, b, c, d);
    return b.child;
}
var $fffe7e7adcbe9002$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $fffe7e7adcbe9002$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $fffe7e7adcbe9002$var$pj(a, b, c) {
    var d = b.pendingProps, e = $fffe7e7adcbe9002$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$M, e & 1);
    if (null === a) {
        $fffe7e7adcbe9002$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $fffe7e7adcbe9002$var$qj(g, d, 0, null), a = $fffe7e7adcbe9002$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $fffe7e7adcbe9002$var$oj(c), b.memoizedState = $fffe7e7adcbe9002$var$nj, a) : $fffe7e7adcbe9002$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $fffe7e7adcbe9002$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $fffe7e7adcbe9002$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $fffe7e7adcbe9002$var$wh(h, f) : (f = $fffe7e7adcbe9002$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $fffe7e7adcbe9002$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $fffe7e7adcbe9002$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $fffe7e7adcbe9002$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $fffe7e7adcbe9002$var$rj(a, b) {
    b = $fffe7e7adcbe9002$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $fffe7e7adcbe9002$var$tj(a, b, c, d) {
    null !== d && $fffe7e7adcbe9002$var$Jg(d);
    $fffe7e7adcbe9002$var$Bh(b, a.child, null, c);
    a = $fffe7e7adcbe9002$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $fffe7e7adcbe9002$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $fffe7e7adcbe9002$var$Li(Error($fffe7e7adcbe9002$var$p(422))), $fffe7e7adcbe9002$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $fffe7e7adcbe9002$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $fffe7e7adcbe9002$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $fffe7e7adcbe9002$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $fffe7e7adcbe9002$var$oj(g);
        b.memoizedState = $fffe7e7adcbe9002$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $fffe7e7adcbe9002$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($fffe7e7adcbe9002$var$p(419));
        d = $fffe7e7adcbe9002$var$Li(f, d, void 0);
        return $fffe7e7adcbe9002$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($fffe7e7adcbe9002$var$Ug || h) {
        d = $fffe7e7adcbe9002$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $fffe7e7adcbe9002$var$Zg(a, e), $fffe7e7adcbe9002$var$mh(d, a, e, -1));
        }
        $fffe7e7adcbe9002$var$uj();
        d = $fffe7e7adcbe9002$var$Li(Error($fffe7e7adcbe9002$var$p(421)));
        return $fffe7e7adcbe9002$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $fffe7e7adcbe9002$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $fffe7e7adcbe9002$var$yg = $fffe7e7adcbe9002$var$Lf(e.nextSibling);
    $fffe7e7adcbe9002$var$xg = b;
    $fffe7e7adcbe9002$var$I = !0;
    $fffe7e7adcbe9002$var$zg = null;
    null !== a && ($fffe7e7adcbe9002$var$og[$fffe7e7adcbe9002$var$pg++] = $fffe7e7adcbe9002$var$rg, $fffe7e7adcbe9002$var$og[$fffe7e7adcbe9002$var$pg++] = $fffe7e7adcbe9002$var$sg, $fffe7e7adcbe9002$var$og[$fffe7e7adcbe9002$var$pg++] = $fffe7e7adcbe9002$var$qg, $fffe7e7adcbe9002$var$rg = a.id, $fffe7e7adcbe9002$var$sg = a.overflow, $fffe7e7adcbe9002$var$qg = b);
    b = $fffe7e7adcbe9002$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $fffe7e7adcbe9002$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $fffe7e7adcbe9002$var$Sg(a.return, b, c);
}
function $fffe7e7adcbe9002$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $fffe7e7adcbe9002$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $fffe7e7adcbe9002$var$Yi(a, b, d.children, c);
    d = $fffe7e7adcbe9002$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $fffe7e7adcbe9002$var$wj(a, c, b);
            else if (19 === a.tag) $fffe7e7adcbe9002$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $fffe7e7adcbe9002$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $fffe7e7adcbe9002$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $fffe7e7adcbe9002$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $fffe7e7adcbe9002$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $fffe7e7adcbe9002$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $fffe7e7adcbe9002$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $fffe7e7adcbe9002$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $fffe7e7adcbe9002$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($fffe7e7adcbe9002$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $fffe7e7adcbe9002$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $fffe7e7adcbe9002$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $fffe7e7adcbe9002$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $fffe7e7adcbe9002$var$lj(b);
            $fffe7e7adcbe9002$var$Ig();
            break;
        case 5:
            $fffe7e7adcbe9002$var$Kh(b);
            break;
        case 1:
            $fffe7e7adcbe9002$var$Zf(b.type) && $fffe7e7adcbe9002$var$cg(b);
            break;
        case 4:
            $fffe7e7adcbe9002$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$M, $fffe7e7adcbe9002$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $fffe7e7adcbe9002$var$pj(a, b, c);
                $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$M, $fffe7e7adcbe9002$var$M.current & 1);
                a = $fffe7e7adcbe9002$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$M, $fffe7e7adcbe9002$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $fffe7e7adcbe9002$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$M, $fffe7e7adcbe9002$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $fffe7e7adcbe9002$var$ej(a, b, c);
    }
    return $fffe7e7adcbe9002$var$$i(a, b, c);
}
var $fffe7e7adcbe9002$var$Aj, $fffe7e7adcbe9002$var$Bj, $fffe7e7adcbe9002$var$Cj, $fffe7e7adcbe9002$var$Dj;
$fffe7e7adcbe9002$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$fffe7e7adcbe9002$var$Bj = function() {};
$fffe7e7adcbe9002$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $fffe7e7adcbe9002$var$Hh($fffe7e7adcbe9002$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $fffe7e7adcbe9002$var$Ya(a, e);
                d = $fffe7e7adcbe9002$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $fffe7e7adcbe9002$var$A({}, e, {
                    value: void 0
                });
                d = $fffe7e7adcbe9002$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $fffe7e7adcbe9002$var$gb(a, e);
                d = $fffe7e7adcbe9002$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $fffe7e7adcbe9002$var$Bf);
        }
        $fffe7e7adcbe9002$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($fffe7e7adcbe9002$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($fffe7e7adcbe9002$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $fffe7e7adcbe9002$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$fffe7e7adcbe9002$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $fffe7e7adcbe9002$var$Ej(a, b) {
    if (!$fffe7e7adcbe9002$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $fffe7e7adcbe9002$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $fffe7e7adcbe9002$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $fffe7e7adcbe9002$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $fffe7e7adcbe9002$var$S(b), null;
        case 1:
            return $fffe7e7adcbe9002$var$Zf(b.type) && $fffe7e7adcbe9002$var$$f(), $fffe7e7adcbe9002$var$S(b), null;
        case 3:
            d = b.stateNode;
            $fffe7e7adcbe9002$var$Jh();
            $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$Wf);
            $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$H);
            $fffe7e7adcbe9002$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $fffe7e7adcbe9002$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $fffe7e7adcbe9002$var$zg && ($fffe7e7adcbe9002$var$Gj($fffe7e7adcbe9002$var$zg), $fffe7e7adcbe9002$var$zg = null));
            $fffe7e7adcbe9002$var$Bj(a, b);
            $fffe7e7adcbe9002$var$S(b);
            return null;
        case 5:
            $fffe7e7adcbe9002$var$Lh(b);
            var e = $fffe7e7adcbe9002$var$Hh($fffe7e7adcbe9002$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $fffe7e7adcbe9002$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($fffe7e7adcbe9002$var$p(166));
                    $fffe7e7adcbe9002$var$S(b);
                    return null;
                }
                a = $fffe7e7adcbe9002$var$Hh($fffe7e7adcbe9002$var$Eh.current);
                if ($fffe7e7adcbe9002$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$fffe7e7adcbe9002$var$Of] = b;
                    d[$fffe7e7adcbe9002$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $fffe7e7adcbe9002$var$D("cancel", d);
                            $fffe7e7adcbe9002$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $fffe7e7adcbe9002$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $fffe7e7adcbe9002$var$lf.length; e++)$fffe7e7adcbe9002$var$D($fffe7e7adcbe9002$var$lf[e], d);
                            break;
                        case "source":
                            $fffe7e7adcbe9002$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $fffe7e7adcbe9002$var$D("error", d);
                            $fffe7e7adcbe9002$var$D("load", d);
                            break;
                        case "details":
                            $fffe7e7adcbe9002$var$D("toggle", d);
                            break;
                        case "input":
                            $fffe7e7adcbe9002$var$Za(d, f);
                            $fffe7e7adcbe9002$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $fffe7e7adcbe9002$var$D("invalid", d);
                            break;
                        case "textarea":
                            $fffe7e7adcbe9002$var$hb(d, f), $fffe7e7adcbe9002$var$D("invalid", d);
                    }
                    $fffe7e7adcbe9002$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $fffe7e7adcbe9002$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $fffe7e7adcbe9002$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $fffe7e7adcbe9002$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $fffe7e7adcbe9002$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $fffe7e7adcbe9002$var$Va(d);
                            $fffe7e7adcbe9002$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $fffe7e7adcbe9002$var$Va(d);
                            $fffe7e7adcbe9002$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $fffe7e7adcbe9002$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $fffe7e7adcbe9002$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$fffe7e7adcbe9002$var$Of] = b;
                    a[$fffe7e7adcbe9002$var$Pf] = d;
                    $fffe7e7adcbe9002$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $fffe7e7adcbe9002$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $fffe7e7adcbe9002$var$D("cancel", a);
                                $fffe7e7adcbe9002$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $fffe7e7adcbe9002$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $fffe7e7adcbe9002$var$lf.length; e++)$fffe7e7adcbe9002$var$D($fffe7e7adcbe9002$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $fffe7e7adcbe9002$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $fffe7e7adcbe9002$var$D("error", a);
                                $fffe7e7adcbe9002$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $fffe7e7adcbe9002$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $fffe7e7adcbe9002$var$Za(a, d);
                                e = $fffe7e7adcbe9002$var$Ya(a, d);
                                $fffe7e7adcbe9002$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $fffe7e7adcbe9002$var$A({}, d, {
                                    value: void 0
                                });
                                $fffe7e7adcbe9002$var$D("invalid", a);
                                break;
                            case "textarea":
                                $fffe7e7adcbe9002$var$hb(a, d);
                                e = $fffe7e7adcbe9002$var$gb(a, d);
                                $fffe7e7adcbe9002$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $fffe7e7adcbe9002$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $fffe7e7adcbe9002$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $fffe7e7adcbe9002$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $fffe7e7adcbe9002$var$ob(a, k) : "number" === typeof k && $fffe7e7adcbe9002$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($fffe7e7adcbe9002$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $fffe7e7adcbe9002$var$D("scroll", a) : null != k && $fffe7e7adcbe9002$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $fffe7e7adcbe9002$var$Va(a);
                                $fffe7e7adcbe9002$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $fffe7e7adcbe9002$var$Va(a);
                                $fffe7e7adcbe9002$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $fffe7e7adcbe9002$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $fffe7e7adcbe9002$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $fffe7e7adcbe9002$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $fffe7e7adcbe9002$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $fffe7e7adcbe9002$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $fffe7e7adcbe9002$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($fffe7e7adcbe9002$var$p(166));
                c = $fffe7e7adcbe9002$var$Hh($fffe7e7adcbe9002$var$Gh.current);
                $fffe7e7adcbe9002$var$Hh($fffe7e7adcbe9002$var$Eh.current);
                if ($fffe7e7adcbe9002$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$fffe7e7adcbe9002$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $fffe7e7adcbe9002$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $fffe7e7adcbe9002$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $fffe7e7adcbe9002$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$fffe7e7adcbe9002$var$Of] = b, b.stateNode = d;
            }
            $fffe7e7adcbe9002$var$S(b);
            return null;
        case 13:
            $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($fffe7e7adcbe9002$var$I && null !== $fffe7e7adcbe9002$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $fffe7e7adcbe9002$var$Hg(), $fffe7e7adcbe9002$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $fffe7e7adcbe9002$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($fffe7e7adcbe9002$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($fffe7e7adcbe9002$var$p(317));
                        f[$fffe7e7adcbe9002$var$Of] = b;
                    } else $fffe7e7adcbe9002$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $fffe7e7adcbe9002$var$S(b);
                    f = !1;
                } else null !== $fffe7e7adcbe9002$var$zg && ($fffe7e7adcbe9002$var$Gj($fffe7e7adcbe9002$var$zg), $fffe7e7adcbe9002$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($fffe7e7adcbe9002$var$M.current & 1) ? 0 === $fffe7e7adcbe9002$var$T && ($fffe7e7adcbe9002$var$T = 3) : $fffe7e7adcbe9002$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $fffe7e7adcbe9002$var$S(b);
            return null;
        case 4:
            return $fffe7e7adcbe9002$var$Jh(), $fffe7e7adcbe9002$var$Bj(a, b), null === a && $fffe7e7adcbe9002$var$sf(b.stateNode.containerInfo), $fffe7e7adcbe9002$var$S(b), null;
        case 10:
            return $fffe7e7adcbe9002$var$Rg(b.type._context), $fffe7e7adcbe9002$var$S(b), null;
        case 17:
            return $fffe7e7adcbe9002$var$Zf(b.type) && $fffe7e7adcbe9002$var$$f(), $fffe7e7adcbe9002$var$S(b), null;
        case 19:
            $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$M);
            f = b.memoizedState;
            if (null === f) return $fffe7e7adcbe9002$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $fffe7e7adcbe9002$var$Ej(f, !1);
                else {
                    if (0 !== $fffe7e7adcbe9002$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $fffe7e7adcbe9002$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $fffe7e7adcbe9002$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$M, $fffe7e7adcbe9002$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $fffe7e7adcbe9002$var$B() > $fffe7e7adcbe9002$var$Hj && (b.flags |= 128, d = !0, $fffe7e7adcbe9002$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $fffe7e7adcbe9002$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $fffe7e7adcbe9002$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$fffe7e7adcbe9002$var$I) return $fffe7e7adcbe9002$var$S(b), null;
                    } else 2 * $fffe7e7adcbe9002$var$B() - f.renderingStartTime > $fffe7e7adcbe9002$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $fffe7e7adcbe9002$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $fffe7e7adcbe9002$var$B(), b.sibling = null, c = $fffe7e7adcbe9002$var$M.current, $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$M, d ? c & 1 | 2 : c & 1), b;
            $fffe7e7adcbe9002$var$S(b);
            return null;
        case 22:
        case 23:
            return $fffe7e7adcbe9002$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($fffe7e7adcbe9002$var$gj & 1073741824) && ($fffe7e7adcbe9002$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $fffe7e7adcbe9002$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($fffe7e7adcbe9002$var$p(156, b.tag));
}
function $fffe7e7adcbe9002$var$Jj(a, b) {
    $fffe7e7adcbe9002$var$wg(b);
    switch(b.tag){
        case 1:
            return $fffe7e7adcbe9002$var$Zf(b.type) && $fffe7e7adcbe9002$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $fffe7e7adcbe9002$var$Jh(), $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$Wf), $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$H), $fffe7e7adcbe9002$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $fffe7e7adcbe9002$var$Lh(b), null;
        case 13:
            $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($fffe7e7adcbe9002$var$p(340));
                $fffe7e7adcbe9002$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$M), null;
        case 4:
            return $fffe7e7adcbe9002$var$Jh(), null;
        case 10:
            return $fffe7e7adcbe9002$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $fffe7e7adcbe9002$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $fffe7e7adcbe9002$var$Kj = !1, $fffe7e7adcbe9002$var$U = !1, $fffe7e7adcbe9002$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $fffe7e7adcbe9002$var$V = null;
function $fffe7e7adcbe9002$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $fffe7e7adcbe9002$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $fffe7e7adcbe9002$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $fffe7e7adcbe9002$var$W(a, b, d);
    }
}
var $fffe7e7adcbe9002$var$Oj = !1;
function $fffe7e7adcbe9002$var$Pj(a, b) {
    $fffe7e7adcbe9002$var$Cf = $fffe7e7adcbe9002$var$dd;
    a = $fffe7e7adcbe9002$var$Me();
    if ($fffe7e7adcbe9002$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $fffe7e7adcbe9002$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $fffe7e7adcbe9002$var$dd = !1;
    for($fffe7e7adcbe9002$var$V = b; null !== $fffe7e7adcbe9002$var$V;)if (b = $fffe7e7adcbe9002$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $fffe7e7adcbe9002$var$V = a;
    else for(; null !== $fffe7e7adcbe9002$var$V;){
        b = $fffe7e7adcbe9002$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $fffe7e7adcbe9002$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($fffe7e7adcbe9002$var$p(163));
            }
        } catch (F) {
            $fffe7e7adcbe9002$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $fffe7e7adcbe9002$var$V = a;
            break;
        }
        $fffe7e7adcbe9002$var$V = b.return;
    }
    n = $fffe7e7adcbe9002$var$Oj;
    $fffe7e7adcbe9002$var$Oj = !1;
    return n;
}
function $fffe7e7adcbe9002$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $fffe7e7adcbe9002$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $fffe7e7adcbe9002$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $fffe7e7adcbe9002$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $fffe7e7adcbe9002$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $fffe7e7adcbe9002$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$fffe7e7adcbe9002$var$Of], delete b[$fffe7e7adcbe9002$var$Pf], delete b[$fffe7e7adcbe9002$var$of], delete b[$fffe7e7adcbe9002$var$Qf], delete b[$fffe7e7adcbe9002$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $fffe7e7adcbe9002$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $fffe7e7adcbe9002$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $fffe7e7adcbe9002$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $fffe7e7adcbe9002$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $fffe7e7adcbe9002$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($fffe7e7adcbe9002$var$Wj(a, b, c), a = a.sibling; null !== a;)$fffe7e7adcbe9002$var$Wj(a, b, c), a = a.sibling;
}
function $fffe7e7adcbe9002$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($fffe7e7adcbe9002$var$Xj(a, b, c), a = a.sibling; null !== a;)$fffe7e7adcbe9002$var$Xj(a, b, c), a = a.sibling;
}
var $fffe7e7adcbe9002$var$X = null, $fffe7e7adcbe9002$var$Yj = !1;
function $fffe7e7adcbe9002$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$fffe7e7adcbe9002$var$ak(a, b, c), c = c.sibling;
}
function $fffe7e7adcbe9002$var$ak(a, b, c) {
    if ($fffe7e7adcbe9002$var$lc && "function" === typeof $fffe7e7adcbe9002$var$lc.onCommitFiberUnmount) try {
        $fffe7e7adcbe9002$var$lc.onCommitFiberUnmount($fffe7e7adcbe9002$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $fffe7e7adcbe9002$var$U || $fffe7e7adcbe9002$var$Mj(c, b);
        case 6:
            var d = $fffe7e7adcbe9002$var$X, e = $fffe7e7adcbe9002$var$Yj;
            $fffe7e7adcbe9002$var$X = null;
            $fffe7e7adcbe9002$var$Zj(a, b, c);
            $fffe7e7adcbe9002$var$X = d;
            $fffe7e7adcbe9002$var$Yj = e;
            null !== $fffe7e7adcbe9002$var$X && ($fffe7e7adcbe9002$var$Yj ? (a = $fffe7e7adcbe9002$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $fffe7e7adcbe9002$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $fffe7e7adcbe9002$var$X && ($fffe7e7adcbe9002$var$Yj ? (a = $fffe7e7adcbe9002$var$X, c = c.stateNode, 8 === a.nodeType ? $fffe7e7adcbe9002$var$Kf(a.parentNode, c) : 1 === a.nodeType && $fffe7e7adcbe9002$var$Kf(a, c), $fffe7e7adcbe9002$var$bd(a)) : $fffe7e7adcbe9002$var$Kf($fffe7e7adcbe9002$var$X, c.stateNode));
            break;
        case 4:
            d = $fffe7e7adcbe9002$var$X;
            e = $fffe7e7adcbe9002$var$Yj;
            $fffe7e7adcbe9002$var$X = c.stateNode.containerInfo;
            $fffe7e7adcbe9002$var$Yj = !0;
            $fffe7e7adcbe9002$var$Zj(a, b, c);
            $fffe7e7adcbe9002$var$X = d;
            $fffe7e7adcbe9002$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$fffe7e7adcbe9002$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $fffe7e7adcbe9002$var$Nj(c, b, g) : 0 !== (f & 4) && $fffe7e7adcbe9002$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $fffe7e7adcbe9002$var$Zj(a, b, c);
            break;
        case 1:
            if (!$fffe7e7adcbe9002$var$U && ($fffe7e7adcbe9002$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $fffe7e7adcbe9002$var$W(c, b, h);
            }
            $fffe7e7adcbe9002$var$Zj(a, b, c);
            break;
        case 21:
            $fffe7e7adcbe9002$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($fffe7e7adcbe9002$var$U = (d = $fffe7e7adcbe9002$var$U) || null !== c.memoizedState, $fffe7e7adcbe9002$var$Zj(a, b, c), $fffe7e7adcbe9002$var$U = d) : $fffe7e7adcbe9002$var$Zj(a, b, c);
            break;
        default:
            $fffe7e7adcbe9002$var$Zj(a, b, c);
    }
}
function $fffe7e7adcbe9002$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $fffe7e7adcbe9002$var$Lj);
        b.forEach(function(b) {
            var d = $fffe7e7adcbe9002$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $fffe7e7adcbe9002$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $fffe7e7adcbe9002$var$X = h.stateNode;
                        $fffe7e7adcbe9002$var$Yj = !1;
                        break a;
                    case 3:
                        $fffe7e7adcbe9002$var$X = h.stateNode.containerInfo;
                        $fffe7e7adcbe9002$var$Yj = !0;
                        break a;
                    case 4:
                        $fffe7e7adcbe9002$var$X = h.stateNode.containerInfo;
                        $fffe7e7adcbe9002$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $fffe7e7adcbe9002$var$X) throw Error($fffe7e7adcbe9002$var$p(160));
            $fffe7e7adcbe9002$var$ak(f, g, e);
            $fffe7e7adcbe9002$var$X = null;
            $fffe7e7adcbe9002$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $fffe7e7adcbe9002$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$fffe7e7adcbe9002$var$ek(b, a), b = b.sibling;
}
function $fffe7e7adcbe9002$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $fffe7e7adcbe9002$var$dk(b, a);
            $fffe7e7adcbe9002$var$fk(a);
            if (d & 4) {
                try {
                    $fffe7e7adcbe9002$var$Qj(3, a, a.return), $fffe7e7adcbe9002$var$Rj(3, a);
                } catch (t) {
                    $fffe7e7adcbe9002$var$W(a, a.return, t);
                }
                try {
                    $fffe7e7adcbe9002$var$Qj(5, a, a.return);
                } catch (t) {
                    $fffe7e7adcbe9002$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $fffe7e7adcbe9002$var$dk(b, a);
            $fffe7e7adcbe9002$var$fk(a);
            d & 512 && null !== c && $fffe7e7adcbe9002$var$Mj(c, c.return);
            break;
        case 5:
            $fffe7e7adcbe9002$var$dk(b, a);
            $fffe7e7adcbe9002$var$fk(a);
            d & 512 && null !== c && $fffe7e7adcbe9002$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $fffe7e7adcbe9002$var$ob(e, "");
                } catch (t) {
                    $fffe7e7adcbe9002$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $fffe7e7adcbe9002$var$ab(e, f);
                    $fffe7e7adcbe9002$var$vb(h, g);
                    var l = $fffe7e7adcbe9002$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $fffe7e7adcbe9002$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $fffe7e7adcbe9002$var$nb(e, q) : "children" === m ? $fffe7e7adcbe9002$var$ob(e, q) : $fffe7e7adcbe9002$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $fffe7e7adcbe9002$var$bb(e, f);
                            break;
                        case "textarea":
                            $fffe7e7adcbe9002$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $fffe7e7adcbe9002$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $fffe7e7adcbe9002$var$fb(e, !!f.multiple, f.defaultValue, !0) : $fffe7e7adcbe9002$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$fffe7e7adcbe9002$var$Pf] = f;
                } catch (t) {
                    $fffe7e7adcbe9002$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $fffe7e7adcbe9002$var$dk(b, a);
            $fffe7e7adcbe9002$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($fffe7e7adcbe9002$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $fffe7e7adcbe9002$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $fffe7e7adcbe9002$var$dk(b, a);
            $fffe7e7adcbe9002$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $fffe7e7adcbe9002$var$bd(b.containerInfo);
            } catch (t) {
                $fffe7e7adcbe9002$var$W(a, a.return, t);
            }
            break;
        case 4:
            $fffe7e7adcbe9002$var$dk(b, a);
            $fffe7e7adcbe9002$var$fk(a);
            break;
        case 13:
            $fffe7e7adcbe9002$var$dk(b, a);
            $fffe7e7adcbe9002$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($fffe7e7adcbe9002$var$gk = $fffe7e7adcbe9002$var$B()));
            d & 4 && $fffe7e7adcbe9002$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($fffe7e7adcbe9002$var$U = (l = $fffe7e7adcbe9002$var$U) || m, $fffe7e7adcbe9002$var$dk(b, a), $fffe7e7adcbe9002$var$U = l) : $fffe7e7adcbe9002$var$dk(b, a);
            $fffe7e7adcbe9002$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($fffe7e7adcbe9002$var$V = a, m = a.child; null !== m;){
                    for(q = $fffe7e7adcbe9002$var$V = m; null !== $fffe7e7adcbe9002$var$V;){
                        r = $fffe7e7adcbe9002$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $fffe7e7adcbe9002$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $fffe7e7adcbe9002$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $fffe7e7adcbe9002$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $fffe7e7adcbe9002$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $fffe7e7adcbe9002$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $fffe7e7adcbe9002$var$V = y) : $fffe7e7adcbe9002$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $fffe7e7adcbe9002$var$rb("display", g));
                            } catch (t) {
                                $fffe7e7adcbe9002$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $fffe7e7adcbe9002$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $fffe7e7adcbe9002$var$dk(b, a);
            $fffe7e7adcbe9002$var$fk(a);
            d & 4 && $fffe7e7adcbe9002$var$bk(a);
            break;
        case 21:
            break;
        default:
            $fffe7e7adcbe9002$var$dk(b, a), $fffe7e7adcbe9002$var$fk(a);
    }
}
function $fffe7e7adcbe9002$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($fffe7e7adcbe9002$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($fffe7e7adcbe9002$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($fffe7e7adcbe9002$var$ob(e, ""), d.flags &= -33);
                    var f = $fffe7e7adcbe9002$var$Vj(a);
                    $fffe7e7adcbe9002$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $fffe7e7adcbe9002$var$Vj(a);
                    $fffe7e7adcbe9002$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($fffe7e7adcbe9002$var$p(161));
            }
        } catch (k) {
            $fffe7e7adcbe9002$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $fffe7e7adcbe9002$var$ik(a, b, c) {
    $fffe7e7adcbe9002$var$V = a;
    $fffe7e7adcbe9002$var$jk(a, b, c);
}
function $fffe7e7adcbe9002$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $fffe7e7adcbe9002$var$V;){
        var e = $fffe7e7adcbe9002$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $fffe7e7adcbe9002$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $fffe7e7adcbe9002$var$U;
                h = $fffe7e7adcbe9002$var$Kj;
                var l = $fffe7e7adcbe9002$var$U;
                $fffe7e7adcbe9002$var$Kj = g;
                if (($fffe7e7adcbe9002$var$U = k) && !l) for($fffe7e7adcbe9002$var$V = e; null !== $fffe7e7adcbe9002$var$V;)g = $fffe7e7adcbe9002$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $fffe7e7adcbe9002$var$kk(e) : null !== k ? (k.return = g, $fffe7e7adcbe9002$var$V = k) : $fffe7e7adcbe9002$var$kk(e);
                for(; null !== f;)$fffe7e7adcbe9002$var$V = f, $fffe7e7adcbe9002$var$jk(f, b, c), f = f.sibling;
                $fffe7e7adcbe9002$var$V = e;
                $fffe7e7adcbe9002$var$Kj = h;
                $fffe7e7adcbe9002$var$U = l;
            }
            $fffe7e7adcbe9002$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $fffe7e7adcbe9002$var$V = f) : $fffe7e7adcbe9002$var$lk(a, b, c);
    }
}
function $fffe7e7adcbe9002$var$lk(a) {
    for(; null !== $fffe7e7adcbe9002$var$V;){
        var b = $fffe7e7adcbe9002$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $fffe7e7adcbe9002$var$U || $fffe7e7adcbe9002$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$fffe7e7adcbe9002$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $fffe7e7adcbe9002$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $fffe7e7adcbe9002$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $fffe7e7adcbe9002$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $fffe7e7adcbe9002$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($fffe7e7adcbe9002$var$p(163));
                }
                $fffe7e7adcbe9002$var$U || b.flags & 512 && $fffe7e7adcbe9002$var$Sj(b);
            } catch (r) {
                $fffe7e7adcbe9002$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $fffe7e7adcbe9002$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fffe7e7adcbe9002$var$V = c;
            break;
        }
        $fffe7e7adcbe9002$var$V = b.return;
    }
}
function $fffe7e7adcbe9002$var$hk(a) {
    for(; null !== $fffe7e7adcbe9002$var$V;){
        var b = $fffe7e7adcbe9002$var$V;
        if (b === a) {
            $fffe7e7adcbe9002$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fffe7e7adcbe9002$var$V = c;
            break;
        }
        $fffe7e7adcbe9002$var$V = b.return;
    }
}
function $fffe7e7adcbe9002$var$kk(a) {
    for(; null !== $fffe7e7adcbe9002$var$V;){
        var b = $fffe7e7adcbe9002$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $fffe7e7adcbe9002$var$Rj(4, b);
                    } catch (k) {
                        $fffe7e7adcbe9002$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $fffe7e7adcbe9002$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $fffe7e7adcbe9002$var$Sj(b);
                    } catch (k) {
                        $fffe7e7adcbe9002$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $fffe7e7adcbe9002$var$Sj(b);
                    } catch (k) {
                        $fffe7e7adcbe9002$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $fffe7e7adcbe9002$var$W(b, b.return, k);
        }
        if (b === a) {
            $fffe7e7adcbe9002$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $fffe7e7adcbe9002$var$V = h;
            break;
        }
        $fffe7e7adcbe9002$var$V = b.return;
    }
}
var $fffe7e7adcbe9002$var$mk = Math.ceil, $fffe7e7adcbe9002$var$nk = $fffe7e7adcbe9002$var$ua.ReactCurrentDispatcher, $fffe7e7adcbe9002$var$ok = $fffe7e7adcbe9002$var$ua.ReactCurrentOwner, $fffe7e7adcbe9002$var$pk = $fffe7e7adcbe9002$var$ua.ReactCurrentBatchConfig, $fffe7e7adcbe9002$var$K = 0, $fffe7e7adcbe9002$var$R = null, $fffe7e7adcbe9002$var$Y = null, $fffe7e7adcbe9002$var$Z = 0, $fffe7e7adcbe9002$var$gj = 0, $fffe7e7adcbe9002$var$fj = $fffe7e7adcbe9002$var$Uf(0), $fffe7e7adcbe9002$var$T = 0, $fffe7e7adcbe9002$var$qk = null, $fffe7e7adcbe9002$var$hh = 0, $fffe7e7adcbe9002$var$rk = 0, $fffe7e7adcbe9002$var$sk = 0, $fffe7e7adcbe9002$var$tk = null, $fffe7e7adcbe9002$var$uk = null, $fffe7e7adcbe9002$var$gk = 0, $fffe7e7adcbe9002$var$Hj = Infinity, $fffe7e7adcbe9002$var$vk = null, $fffe7e7adcbe9002$var$Pi = !1, $fffe7e7adcbe9002$var$Qi = null, $fffe7e7adcbe9002$var$Si = null, $fffe7e7adcbe9002$var$wk = !1, $fffe7e7adcbe9002$var$xk = null, $fffe7e7adcbe9002$var$yk = 0, $fffe7e7adcbe9002$var$zk = 0, $fffe7e7adcbe9002$var$Ak = null, $fffe7e7adcbe9002$var$Bk = -1, $fffe7e7adcbe9002$var$Ck = 0;
function $fffe7e7adcbe9002$var$L() {
    return 0 !== ($fffe7e7adcbe9002$var$K & 6) ? $fffe7e7adcbe9002$var$B() : -1 !== $fffe7e7adcbe9002$var$Bk ? $fffe7e7adcbe9002$var$Bk : $fffe7e7adcbe9002$var$Bk = $fffe7e7adcbe9002$var$B();
}
function $fffe7e7adcbe9002$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($fffe7e7adcbe9002$var$K & 2) && 0 !== $fffe7e7adcbe9002$var$Z) return $fffe7e7adcbe9002$var$Z & -$fffe7e7adcbe9002$var$Z;
    if (null !== $fffe7e7adcbe9002$var$Kg.transition) return 0 === $fffe7e7adcbe9002$var$Ck && ($fffe7e7adcbe9002$var$Ck = $fffe7e7adcbe9002$var$yc()), $fffe7e7adcbe9002$var$Ck;
    a = $fffe7e7adcbe9002$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $fffe7e7adcbe9002$var$jd(a.type);
    return a;
}
function $fffe7e7adcbe9002$var$mh(a, b, c, d) {
    if (50 < $fffe7e7adcbe9002$var$zk) throw $fffe7e7adcbe9002$var$zk = 0, $fffe7e7adcbe9002$var$Ak = null, Error($fffe7e7adcbe9002$var$p(185));
    $fffe7e7adcbe9002$var$Ac(a, c, d);
    if (0 === ($fffe7e7adcbe9002$var$K & 2) || a !== $fffe7e7adcbe9002$var$R) a === $fffe7e7adcbe9002$var$R && (0 === ($fffe7e7adcbe9002$var$K & 2) && ($fffe7e7adcbe9002$var$rk |= c), 4 === $fffe7e7adcbe9002$var$T && $fffe7e7adcbe9002$var$Dk(a, $fffe7e7adcbe9002$var$Z)), $fffe7e7adcbe9002$var$Ek(a, d), 1 === c && 0 === $fffe7e7adcbe9002$var$K && 0 === (b.mode & 1) && ($fffe7e7adcbe9002$var$Hj = $fffe7e7adcbe9002$var$B() + 500, $fffe7e7adcbe9002$var$fg && $fffe7e7adcbe9002$var$jg());
}
function $fffe7e7adcbe9002$var$Ek(a, b) {
    var c = a.callbackNode;
    $fffe7e7adcbe9002$var$wc(a, b);
    var d = $fffe7e7adcbe9002$var$uc(a, a === $fffe7e7adcbe9002$var$R ? $fffe7e7adcbe9002$var$Z : 0);
    if (0 === d) null !== c && $fffe7e7adcbe9002$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $fffe7e7adcbe9002$var$bc(c);
        if (1 === b) 0 === a.tag ? $fffe7e7adcbe9002$var$ig($fffe7e7adcbe9002$var$Fk.bind(null, a)) : $fffe7e7adcbe9002$var$hg($fffe7e7adcbe9002$var$Fk.bind(null, a)), $fffe7e7adcbe9002$var$Jf(function() {
            0 === ($fffe7e7adcbe9002$var$K & 6) && $fffe7e7adcbe9002$var$jg();
        }), c = null;
        else {
            switch($fffe7e7adcbe9002$var$Dc(d)){
                case 1:
                    c = $fffe7e7adcbe9002$var$fc;
                    break;
                case 4:
                    c = $fffe7e7adcbe9002$var$gc;
                    break;
                case 16:
                    c = $fffe7e7adcbe9002$var$hc;
                    break;
                case 536870912:
                    c = $fffe7e7adcbe9002$var$jc;
                    break;
                default:
                    c = $fffe7e7adcbe9002$var$hc;
            }
            c = $fffe7e7adcbe9002$var$Gk(c, $fffe7e7adcbe9002$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $fffe7e7adcbe9002$var$Hk(a, b) {
    $fffe7e7adcbe9002$var$Bk = -1;
    $fffe7e7adcbe9002$var$Ck = 0;
    if (0 !== ($fffe7e7adcbe9002$var$K & 6)) throw Error($fffe7e7adcbe9002$var$p(327));
    var c = a.callbackNode;
    if ($fffe7e7adcbe9002$var$Ik() && a.callbackNode !== c) return null;
    var d = $fffe7e7adcbe9002$var$uc(a, a === $fffe7e7adcbe9002$var$R ? $fffe7e7adcbe9002$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $fffe7e7adcbe9002$var$Jk(a, d);
    else {
        b = d;
        var e = $fffe7e7adcbe9002$var$K;
        $fffe7e7adcbe9002$var$K |= 2;
        var f = $fffe7e7adcbe9002$var$Kk();
        if ($fffe7e7adcbe9002$var$R !== a || $fffe7e7adcbe9002$var$Z !== b) $fffe7e7adcbe9002$var$vk = null, $fffe7e7adcbe9002$var$Hj = $fffe7e7adcbe9002$var$B() + 500, $fffe7e7adcbe9002$var$Lk(a, b);
        for(;;)try {
            $fffe7e7adcbe9002$var$Mk();
            break;
        } catch (h) {
            $fffe7e7adcbe9002$var$Nk(a, h);
        }
        $fffe7e7adcbe9002$var$Qg();
        $fffe7e7adcbe9002$var$nk.current = f;
        $fffe7e7adcbe9002$var$K = e;
        null !== $fffe7e7adcbe9002$var$Y ? b = 0 : ($fffe7e7adcbe9002$var$R = null, $fffe7e7adcbe9002$var$Z = 0, b = $fffe7e7adcbe9002$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $fffe7e7adcbe9002$var$xc(a), 0 !== e && (d = e, b = $fffe7e7adcbe9002$var$Ok(a, e)));
        if (1 === b) throw c = $fffe7e7adcbe9002$var$qk, $fffe7e7adcbe9002$var$Lk(a, 0), $fffe7e7adcbe9002$var$Dk(a, d), $fffe7e7adcbe9002$var$Ek(a, $fffe7e7adcbe9002$var$B()), c;
        if (6 === b) $fffe7e7adcbe9002$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$fffe7e7adcbe9002$var$Pk(e) && (b = $fffe7e7adcbe9002$var$Jk(a, d), 2 === b && (f = $fffe7e7adcbe9002$var$xc(a), 0 !== f && (d = f, b = $fffe7e7adcbe9002$var$Ok(a, f))), 1 === b)) throw c = $fffe7e7adcbe9002$var$qk, $fffe7e7adcbe9002$var$Lk(a, 0), $fffe7e7adcbe9002$var$Dk(a, d), $fffe7e7adcbe9002$var$Ek(a, $fffe7e7adcbe9002$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($fffe7e7adcbe9002$var$p(345));
                case 2:
                    $fffe7e7adcbe9002$var$Qk(a, $fffe7e7adcbe9002$var$uk, $fffe7e7adcbe9002$var$vk);
                    break;
                case 3:
                    $fffe7e7adcbe9002$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $fffe7e7adcbe9002$var$gk + 500 - $fffe7e7adcbe9002$var$B(), 10 < b)) {
                        if (0 !== $fffe7e7adcbe9002$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $fffe7e7adcbe9002$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $fffe7e7adcbe9002$var$Ff($fffe7e7adcbe9002$var$Qk.bind(null, a, $fffe7e7adcbe9002$var$uk, $fffe7e7adcbe9002$var$vk), b);
                        break;
                    }
                    $fffe7e7adcbe9002$var$Qk(a, $fffe7e7adcbe9002$var$uk, $fffe7e7adcbe9002$var$vk);
                    break;
                case 4:
                    $fffe7e7adcbe9002$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $fffe7e7adcbe9002$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $fffe7e7adcbe9002$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $fffe7e7adcbe9002$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $fffe7e7adcbe9002$var$Ff($fffe7e7adcbe9002$var$Qk.bind(null, a, $fffe7e7adcbe9002$var$uk, $fffe7e7adcbe9002$var$vk), d);
                        break;
                    }
                    $fffe7e7adcbe9002$var$Qk(a, $fffe7e7adcbe9002$var$uk, $fffe7e7adcbe9002$var$vk);
                    break;
                case 5:
                    $fffe7e7adcbe9002$var$Qk(a, $fffe7e7adcbe9002$var$uk, $fffe7e7adcbe9002$var$vk);
                    break;
                default:
                    throw Error($fffe7e7adcbe9002$var$p(329));
            }
        }
    }
    $fffe7e7adcbe9002$var$Ek(a, $fffe7e7adcbe9002$var$B());
    return a.callbackNode === c ? $fffe7e7adcbe9002$var$Hk.bind(null, a) : null;
}
function $fffe7e7adcbe9002$var$Ok(a, b) {
    var c = $fffe7e7adcbe9002$var$tk;
    a.current.memoizedState.isDehydrated && ($fffe7e7adcbe9002$var$Lk(a, b).flags |= 256);
    a = $fffe7e7adcbe9002$var$Jk(a, b);
    2 !== a && (b = $fffe7e7adcbe9002$var$uk, $fffe7e7adcbe9002$var$uk = c, null !== b && $fffe7e7adcbe9002$var$Gj(b));
    return a;
}
function $fffe7e7adcbe9002$var$Gj(a) {
    null === $fffe7e7adcbe9002$var$uk ? $fffe7e7adcbe9002$var$uk = a : $fffe7e7adcbe9002$var$uk.push.apply($fffe7e7adcbe9002$var$uk, a);
}
function $fffe7e7adcbe9002$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$fffe7e7adcbe9002$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $fffe7e7adcbe9002$var$Dk(a, b) {
    b &= ~$fffe7e7adcbe9002$var$sk;
    b &= ~$fffe7e7adcbe9002$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $fffe7e7adcbe9002$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $fffe7e7adcbe9002$var$Fk(a) {
    if (0 !== ($fffe7e7adcbe9002$var$K & 6)) throw Error($fffe7e7adcbe9002$var$p(327));
    $fffe7e7adcbe9002$var$Ik();
    var b = $fffe7e7adcbe9002$var$uc(a, 0);
    if (0 === (b & 1)) return $fffe7e7adcbe9002$var$Ek(a, $fffe7e7adcbe9002$var$B()), null;
    var c = $fffe7e7adcbe9002$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $fffe7e7adcbe9002$var$xc(a);
        0 !== d && (b = d, c = $fffe7e7adcbe9002$var$Ok(a, d));
    }
    if (1 === c) throw c = $fffe7e7adcbe9002$var$qk, $fffe7e7adcbe9002$var$Lk(a, 0), $fffe7e7adcbe9002$var$Dk(a, b), $fffe7e7adcbe9002$var$Ek(a, $fffe7e7adcbe9002$var$B()), c;
    if (6 === c) throw Error($fffe7e7adcbe9002$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $fffe7e7adcbe9002$var$Qk(a, $fffe7e7adcbe9002$var$uk, $fffe7e7adcbe9002$var$vk);
    $fffe7e7adcbe9002$var$Ek(a, $fffe7e7adcbe9002$var$B());
    return null;
}
function $fffe7e7adcbe9002$var$Rk(a, b) {
    var c = $fffe7e7adcbe9002$var$K;
    $fffe7e7adcbe9002$var$K |= 1;
    try {
        return a(b);
    } finally{
        $fffe7e7adcbe9002$var$K = c, 0 === $fffe7e7adcbe9002$var$K && ($fffe7e7adcbe9002$var$Hj = $fffe7e7adcbe9002$var$B() + 500, $fffe7e7adcbe9002$var$fg && $fffe7e7adcbe9002$var$jg());
    }
}
function $fffe7e7adcbe9002$var$Sk(a) {
    null !== $fffe7e7adcbe9002$var$xk && 0 === $fffe7e7adcbe9002$var$xk.tag && 0 === ($fffe7e7adcbe9002$var$K & 6) && $fffe7e7adcbe9002$var$Ik();
    var b = $fffe7e7adcbe9002$var$K;
    $fffe7e7adcbe9002$var$K |= 1;
    var c = $fffe7e7adcbe9002$var$pk.transition, d = $fffe7e7adcbe9002$var$C;
    try {
        if ($fffe7e7adcbe9002$var$pk.transition = null, $fffe7e7adcbe9002$var$C = 1, a) return a();
    } finally{
        $fffe7e7adcbe9002$var$C = d, $fffe7e7adcbe9002$var$pk.transition = c, $fffe7e7adcbe9002$var$K = b, 0 === ($fffe7e7adcbe9002$var$K & 6) && $fffe7e7adcbe9002$var$jg();
    }
}
function $fffe7e7adcbe9002$var$Ij() {
    $fffe7e7adcbe9002$var$gj = $fffe7e7adcbe9002$var$fj.current;
    $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$fj);
}
function $fffe7e7adcbe9002$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $fffe7e7adcbe9002$var$Gf(c));
    if (null !== $fffe7e7adcbe9002$var$Y) for(c = $fffe7e7adcbe9002$var$Y.return; null !== c;){
        var d = c;
        $fffe7e7adcbe9002$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $fffe7e7adcbe9002$var$$f();
                break;
            case 3:
                $fffe7e7adcbe9002$var$Jh();
                $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$Wf);
                $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$H);
                $fffe7e7adcbe9002$var$Oh();
                break;
            case 5:
                $fffe7e7adcbe9002$var$Lh(d);
                break;
            case 4:
                $fffe7e7adcbe9002$var$Jh();
                break;
            case 13:
                $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$M);
                break;
            case 19:
                $fffe7e7adcbe9002$var$E($fffe7e7adcbe9002$var$M);
                break;
            case 10:
                $fffe7e7adcbe9002$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $fffe7e7adcbe9002$var$Ij();
        }
        c = c.return;
    }
    $fffe7e7adcbe9002$var$R = a;
    $fffe7e7adcbe9002$var$Y = a = $fffe7e7adcbe9002$var$wh(a.current, null);
    $fffe7e7adcbe9002$var$Z = $fffe7e7adcbe9002$var$gj = b;
    $fffe7e7adcbe9002$var$T = 0;
    $fffe7e7adcbe9002$var$qk = null;
    $fffe7e7adcbe9002$var$sk = $fffe7e7adcbe9002$var$rk = $fffe7e7adcbe9002$var$hh = 0;
    $fffe7e7adcbe9002$var$uk = $fffe7e7adcbe9002$var$tk = null;
    if (null !== $fffe7e7adcbe9002$var$Wg) {
        for(b = 0; b < $fffe7e7adcbe9002$var$Wg.length; b++)if (c = $fffe7e7adcbe9002$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $fffe7e7adcbe9002$var$Wg = null;
    }
    return a;
}
function $fffe7e7adcbe9002$var$Nk(a, b) {
    do {
        var c = $fffe7e7adcbe9002$var$Y;
        try {
            $fffe7e7adcbe9002$var$Qg();
            $fffe7e7adcbe9002$var$Ph.current = $fffe7e7adcbe9002$var$ai;
            if ($fffe7e7adcbe9002$var$Sh) {
                for(var d = $fffe7e7adcbe9002$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $fffe7e7adcbe9002$var$Sh = !1;
            }
            $fffe7e7adcbe9002$var$Rh = 0;
            $fffe7e7adcbe9002$var$P = $fffe7e7adcbe9002$var$O = $fffe7e7adcbe9002$var$N = null;
            $fffe7e7adcbe9002$var$Th = !1;
            $fffe7e7adcbe9002$var$Uh = 0;
            $fffe7e7adcbe9002$var$ok.current = null;
            if (null === c || null === c.return) {
                $fffe7e7adcbe9002$var$T = 1;
                $fffe7e7adcbe9002$var$qk = b;
                $fffe7e7adcbe9002$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $fffe7e7adcbe9002$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $fffe7e7adcbe9002$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $fffe7e7adcbe9002$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $fffe7e7adcbe9002$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $fffe7e7adcbe9002$var$Ti(f, l, b);
                            $fffe7e7adcbe9002$var$uj();
                            break a;
                        }
                        k = Error($fffe7e7adcbe9002$var$p(426));
                    }
                } else if ($fffe7e7adcbe9002$var$I && h.mode & 1) {
                    var J = $fffe7e7adcbe9002$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $fffe7e7adcbe9002$var$Wi(J, g, h, f, b);
                        $fffe7e7adcbe9002$var$Jg($fffe7e7adcbe9002$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $fffe7e7adcbe9002$var$Ki(k, h);
                4 !== $fffe7e7adcbe9002$var$T && ($fffe7e7adcbe9002$var$T = 2);
                null === $fffe7e7adcbe9002$var$tk ? $fffe7e7adcbe9002$var$tk = [
                    f
                ] : $fffe7e7adcbe9002$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $fffe7e7adcbe9002$var$Oi(f, k, b);
                            $fffe7e7adcbe9002$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $fffe7e7adcbe9002$var$Si || !$fffe7e7adcbe9002$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $fffe7e7adcbe9002$var$Ri(f, h, b);
                                $fffe7e7adcbe9002$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $fffe7e7adcbe9002$var$Tk(c);
        } catch (na) {
            b = na;
            $fffe7e7adcbe9002$var$Y === c && null !== c && ($fffe7e7adcbe9002$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $fffe7e7adcbe9002$var$Kk() {
    var a = $fffe7e7adcbe9002$var$nk.current;
    $fffe7e7adcbe9002$var$nk.current = $fffe7e7adcbe9002$var$ai;
    return null === a ? $fffe7e7adcbe9002$var$ai : a;
}
function $fffe7e7adcbe9002$var$uj() {
    if (0 === $fffe7e7adcbe9002$var$T || 3 === $fffe7e7adcbe9002$var$T || 2 === $fffe7e7adcbe9002$var$T) $fffe7e7adcbe9002$var$T = 4;
    null === $fffe7e7adcbe9002$var$R || 0 === ($fffe7e7adcbe9002$var$hh & 268435455) && 0 === ($fffe7e7adcbe9002$var$rk & 268435455) || $fffe7e7adcbe9002$var$Dk($fffe7e7adcbe9002$var$R, $fffe7e7adcbe9002$var$Z);
}
function $fffe7e7adcbe9002$var$Jk(a, b) {
    var c = $fffe7e7adcbe9002$var$K;
    $fffe7e7adcbe9002$var$K |= 2;
    var d = $fffe7e7adcbe9002$var$Kk();
    if ($fffe7e7adcbe9002$var$R !== a || $fffe7e7adcbe9002$var$Z !== b) $fffe7e7adcbe9002$var$vk = null, $fffe7e7adcbe9002$var$Lk(a, b);
    for(;;)try {
        $fffe7e7adcbe9002$var$Uk();
        break;
    } catch (e) {
        $fffe7e7adcbe9002$var$Nk(a, e);
    }
    $fffe7e7adcbe9002$var$Qg();
    $fffe7e7adcbe9002$var$K = c;
    $fffe7e7adcbe9002$var$nk.current = d;
    if (null !== $fffe7e7adcbe9002$var$Y) throw Error($fffe7e7adcbe9002$var$p(261));
    $fffe7e7adcbe9002$var$R = null;
    $fffe7e7adcbe9002$var$Z = 0;
    return $fffe7e7adcbe9002$var$T;
}
function $fffe7e7adcbe9002$var$Uk() {
    for(; null !== $fffe7e7adcbe9002$var$Y;)$fffe7e7adcbe9002$var$Vk($fffe7e7adcbe9002$var$Y);
}
function $fffe7e7adcbe9002$var$Mk() {
    for(; null !== $fffe7e7adcbe9002$var$Y && !$fffe7e7adcbe9002$var$cc();)$fffe7e7adcbe9002$var$Vk($fffe7e7adcbe9002$var$Y);
}
function $fffe7e7adcbe9002$var$Vk(a) {
    var b = $fffe7e7adcbe9002$var$Wk(a.alternate, a, $fffe7e7adcbe9002$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $fffe7e7adcbe9002$var$Tk(a) : $fffe7e7adcbe9002$var$Y = b;
    $fffe7e7adcbe9002$var$ok.current = null;
}
function $fffe7e7adcbe9002$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $fffe7e7adcbe9002$var$Fj(c, b, $fffe7e7adcbe9002$var$gj), null !== c) {
                $fffe7e7adcbe9002$var$Y = c;
                return;
            }
        } else {
            c = $fffe7e7adcbe9002$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $fffe7e7adcbe9002$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $fffe7e7adcbe9002$var$T = 6;
                $fffe7e7adcbe9002$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $fffe7e7adcbe9002$var$Y = b;
            return;
        }
        $fffe7e7adcbe9002$var$Y = b = a;
    }while (null !== b);
    0 === $fffe7e7adcbe9002$var$T && ($fffe7e7adcbe9002$var$T = 5);
}
function $fffe7e7adcbe9002$var$Qk(a, b, c) {
    var d = $fffe7e7adcbe9002$var$C, e = $fffe7e7adcbe9002$var$pk.transition;
    try {
        $fffe7e7adcbe9002$var$pk.transition = null, $fffe7e7adcbe9002$var$C = 1, $fffe7e7adcbe9002$var$Xk(a, b, c, d);
    } finally{
        $fffe7e7adcbe9002$var$pk.transition = e, $fffe7e7adcbe9002$var$C = d;
    }
    return null;
}
function $fffe7e7adcbe9002$var$Xk(a, b, c, d) {
    do $fffe7e7adcbe9002$var$Ik();
    while (null !== $fffe7e7adcbe9002$var$xk);
    if (0 !== ($fffe7e7adcbe9002$var$K & 6)) throw Error($fffe7e7adcbe9002$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($fffe7e7adcbe9002$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $fffe7e7adcbe9002$var$Bc(a, f);
    a === $fffe7e7adcbe9002$var$R && ($fffe7e7adcbe9002$var$Y = $fffe7e7adcbe9002$var$R = null, $fffe7e7adcbe9002$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $fffe7e7adcbe9002$var$wk || ($fffe7e7adcbe9002$var$wk = !0, $fffe7e7adcbe9002$var$Gk($fffe7e7adcbe9002$var$hc, function() {
        $fffe7e7adcbe9002$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $fffe7e7adcbe9002$var$pk.transition;
        $fffe7e7adcbe9002$var$pk.transition = null;
        var g = $fffe7e7adcbe9002$var$C;
        $fffe7e7adcbe9002$var$C = 1;
        var h = $fffe7e7adcbe9002$var$K;
        $fffe7e7adcbe9002$var$K |= 4;
        $fffe7e7adcbe9002$var$ok.current = null;
        $fffe7e7adcbe9002$var$Pj(a, c);
        $fffe7e7adcbe9002$var$ek(c, a);
        $fffe7e7adcbe9002$var$Oe($fffe7e7adcbe9002$var$Df);
        $fffe7e7adcbe9002$var$dd = !!$fffe7e7adcbe9002$var$Cf;
        $fffe7e7adcbe9002$var$Df = $fffe7e7adcbe9002$var$Cf = null;
        a.current = c;
        $fffe7e7adcbe9002$var$ik(c, a, e);
        $fffe7e7adcbe9002$var$dc();
        $fffe7e7adcbe9002$var$K = h;
        $fffe7e7adcbe9002$var$C = g;
        $fffe7e7adcbe9002$var$pk.transition = f;
    } else a.current = c;
    $fffe7e7adcbe9002$var$wk && ($fffe7e7adcbe9002$var$wk = !1, $fffe7e7adcbe9002$var$xk = a, $fffe7e7adcbe9002$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($fffe7e7adcbe9002$var$Si = null);
    $fffe7e7adcbe9002$var$mc(c.stateNode, d);
    $fffe7e7adcbe9002$var$Ek(a, $fffe7e7adcbe9002$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($fffe7e7adcbe9002$var$Pi) throw $fffe7e7adcbe9002$var$Pi = !1, a = $fffe7e7adcbe9002$var$Qi, $fffe7e7adcbe9002$var$Qi = null, a;
    0 !== ($fffe7e7adcbe9002$var$yk & 1) && 0 !== a.tag && $fffe7e7adcbe9002$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $fffe7e7adcbe9002$var$Ak ? $fffe7e7adcbe9002$var$zk++ : ($fffe7e7adcbe9002$var$zk = 0, $fffe7e7adcbe9002$var$Ak = a) : $fffe7e7adcbe9002$var$zk = 0;
    $fffe7e7adcbe9002$var$jg();
    return null;
}
function $fffe7e7adcbe9002$var$Ik() {
    if (null !== $fffe7e7adcbe9002$var$xk) {
        var a = $fffe7e7adcbe9002$var$Dc($fffe7e7adcbe9002$var$yk), b = $fffe7e7adcbe9002$var$pk.transition, c = $fffe7e7adcbe9002$var$C;
        try {
            $fffe7e7adcbe9002$var$pk.transition = null;
            $fffe7e7adcbe9002$var$C = 16 > a ? 16 : a;
            if (null === $fffe7e7adcbe9002$var$xk) var d = !1;
            else {
                a = $fffe7e7adcbe9002$var$xk;
                $fffe7e7adcbe9002$var$xk = null;
                $fffe7e7adcbe9002$var$yk = 0;
                if (0 !== ($fffe7e7adcbe9002$var$K & 6)) throw Error($fffe7e7adcbe9002$var$p(331));
                var e = $fffe7e7adcbe9002$var$K;
                $fffe7e7adcbe9002$var$K |= 4;
                for($fffe7e7adcbe9002$var$V = a.current; null !== $fffe7e7adcbe9002$var$V;){
                    var f = $fffe7e7adcbe9002$var$V, g = f.child;
                    if (0 !== ($fffe7e7adcbe9002$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($fffe7e7adcbe9002$var$V = l; null !== $fffe7e7adcbe9002$var$V;){
                                    var m = $fffe7e7adcbe9002$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $fffe7e7adcbe9002$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $fffe7e7adcbe9002$var$V = q;
                                    else for(; null !== $fffe7e7adcbe9002$var$V;){
                                        m = $fffe7e7adcbe9002$var$V;
                                        var r = m.sibling, y = m.return;
                                        $fffe7e7adcbe9002$var$Tj(m);
                                        if (m === l) {
                                            $fffe7e7adcbe9002$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $fffe7e7adcbe9002$var$V = r;
                                            break;
                                        }
                                        $fffe7e7adcbe9002$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $fffe7e7adcbe9002$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $fffe7e7adcbe9002$var$V = g;
                    else b: for(; null !== $fffe7e7adcbe9002$var$V;){
                        f = $fffe7e7adcbe9002$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $fffe7e7adcbe9002$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $fffe7e7adcbe9002$var$V = x;
                            break b;
                        }
                        $fffe7e7adcbe9002$var$V = f.return;
                    }
                }
                var w = a.current;
                for($fffe7e7adcbe9002$var$V = w; null !== $fffe7e7adcbe9002$var$V;){
                    g = $fffe7e7adcbe9002$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $fffe7e7adcbe9002$var$V = u;
                    else b: for(g = w; null !== $fffe7e7adcbe9002$var$V;){
                        h = $fffe7e7adcbe9002$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $fffe7e7adcbe9002$var$Rj(9, h);
                            }
                        } catch (na) {
                            $fffe7e7adcbe9002$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $fffe7e7adcbe9002$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $fffe7e7adcbe9002$var$V = F;
                            break b;
                        }
                        $fffe7e7adcbe9002$var$V = h.return;
                    }
                }
                $fffe7e7adcbe9002$var$K = e;
                $fffe7e7adcbe9002$var$jg();
                if ($fffe7e7adcbe9002$var$lc && "function" === typeof $fffe7e7adcbe9002$var$lc.onPostCommitFiberRoot) try {
                    $fffe7e7adcbe9002$var$lc.onPostCommitFiberRoot($fffe7e7adcbe9002$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $fffe7e7adcbe9002$var$C = c, $fffe7e7adcbe9002$var$pk.transition = b;
        }
    }
    return !1;
}
function $fffe7e7adcbe9002$var$Yk(a, b, c) {
    b = $fffe7e7adcbe9002$var$Ki(c, b);
    b = $fffe7e7adcbe9002$var$Oi(a, b, 1);
    a = $fffe7e7adcbe9002$var$dh(a, b, 1);
    b = $fffe7e7adcbe9002$var$L();
    null !== a && ($fffe7e7adcbe9002$var$Ac(a, 1, b), $fffe7e7adcbe9002$var$Ek(a, b));
}
function $fffe7e7adcbe9002$var$W(a, b, c) {
    if (3 === a.tag) $fffe7e7adcbe9002$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $fffe7e7adcbe9002$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $fffe7e7adcbe9002$var$Si || !$fffe7e7adcbe9002$var$Si.has(d))) {
                a = $fffe7e7adcbe9002$var$Ki(c, a);
                a = $fffe7e7adcbe9002$var$Ri(b, a, 1);
                b = $fffe7e7adcbe9002$var$dh(b, a, 1);
                a = $fffe7e7adcbe9002$var$L();
                null !== b && ($fffe7e7adcbe9002$var$Ac(b, 1, a), $fffe7e7adcbe9002$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $fffe7e7adcbe9002$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $fffe7e7adcbe9002$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $fffe7e7adcbe9002$var$R === a && ($fffe7e7adcbe9002$var$Z & c) === c && (4 === $fffe7e7adcbe9002$var$T || 3 === $fffe7e7adcbe9002$var$T && ($fffe7e7adcbe9002$var$Z & 130023424) === $fffe7e7adcbe9002$var$Z && 500 > $fffe7e7adcbe9002$var$B() - $fffe7e7adcbe9002$var$gk ? $fffe7e7adcbe9002$var$Lk(a, 0) : $fffe7e7adcbe9002$var$sk |= c);
    $fffe7e7adcbe9002$var$Ek(a, b);
}
function $fffe7e7adcbe9002$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $fffe7e7adcbe9002$var$sc, $fffe7e7adcbe9002$var$sc <<= 1, 0 === ($fffe7e7adcbe9002$var$sc & 130023424) && ($fffe7e7adcbe9002$var$sc = 4194304)));
    var c = $fffe7e7adcbe9002$var$L();
    a = $fffe7e7adcbe9002$var$Zg(a, b);
    null !== a && ($fffe7e7adcbe9002$var$Ac(a, b, c), $fffe7e7adcbe9002$var$Ek(a, c));
}
function $fffe7e7adcbe9002$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $fffe7e7adcbe9002$var$Zk(a, c);
}
function $fffe7e7adcbe9002$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($fffe7e7adcbe9002$var$p(314));
    }
    null !== d && d.delete(b);
    $fffe7e7adcbe9002$var$Zk(a, c);
}
var $fffe7e7adcbe9002$var$Wk;
$fffe7e7adcbe9002$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $fffe7e7adcbe9002$var$Wf.current) $fffe7e7adcbe9002$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $fffe7e7adcbe9002$var$Ug = !1, $fffe7e7adcbe9002$var$zj(a, b, c);
            $fffe7e7adcbe9002$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $fffe7e7adcbe9002$var$Ug = !1, $fffe7e7adcbe9002$var$I && 0 !== (b.flags & 1048576) && $fffe7e7adcbe9002$var$ug(b, $fffe7e7adcbe9002$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $fffe7e7adcbe9002$var$jj(a, b);
            a = b.pendingProps;
            var e = $fffe7e7adcbe9002$var$Yf(b, $fffe7e7adcbe9002$var$H.current);
            $fffe7e7adcbe9002$var$Tg(b, c);
            e = $fffe7e7adcbe9002$var$Xh(null, b, d, a, e, c);
            var f = $fffe7e7adcbe9002$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $fffe7e7adcbe9002$var$Zf(d) ? (f = !0, $fffe7e7adcbe9002$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $fffe7e7adcbe9002$var$ah(b), e.updater = $fffe7e7adcbe9002$var$nh, b.stateNode = e, e._reactInternals = b, $fffe7e7adcbe9002$var$rh(b, d, a, c), b = $fffe7e7adcbe9002$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $fffe7e7adcbe9002$var$I && f && $fffe7e7adcbe9002$var$vg(b), $fffe7e7adcbe9002$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $fffe7e7adcbe9002$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $fffe7e7adcbe9002$var$$k(d);
                a = $fffe7e7adcbe9002$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $fffe7e7adcbe9002$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $fffe7e7adcbe9002$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $fffe7e7adcbe9002$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $fffe7e7adcbe9002$var$aj(null, b, d, $fffe7e7adcbe9002$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($fffe7e7adcbe9002$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fffe7e7adcbe9002$var$Lg(d, e), $fffe7e7adcbe9002$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fffe7e7adcbe9002$var$Lg(d, e), $fffe7e7adcbe9002$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $fffe7e7adcbe9002$var$lj(b);
                if (null === a) throw Error($fffe7e7adcbe9002$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $fffe7e7adcbe9002$var$bh(a, b);
                $fffe7e7adcbe9002$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $fffe7e7adcbe9002$var$Ki(Error($fffe7e7adcbe9002$var$p(423)), b);
                        b = $fffe7e7adcbe9002$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $fffe7e7adcbe9002$var$Ki(Error($fffe7e7adcbe9002$var$p(424)), b);
                        b = $fffe7e7adcbe9002$var$mj(a, b, d, c, e);
                        break a;
                    } else for($fffe7e7adcbe9002$var$yg = $fffe7e7adcbe9002$var$Lf(b.stateNode.containerInfo.firstChild), $fffe7e7adcbe9002$var$xg = b, $fffe7e7adcbe9002$var$I = !0, $fffe7e7adcbe9002$var$zg = null, c = $fffe7e7adcbe9002$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $fffe7e7adcbe9002$var$Ig();
                    if (d === e) {
                        b = $fffe7e7adcbe9002$var$$i(a, b, c);
                        break a;
                    }
                    $fffe7e7adcbe9002$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $fffe7e7adcbe9002$var$Kh(b), null === a && $fffe7e7adcbe9002$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $fffe7e7adcbe9002$var$Ef(d, e) ? g = null : null !== f && $fffe7e7adcbe9002$var$Ef(d, f) && (b.flags |= 32), $fffe7e7adcbe9002$var$hj(a, b), $fffe7e7adcbe9002$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $fffe7e7adcbe9002$var$Eg(b), null;
        case 13:
            return $fffe7e7adcbe9002$var$pj(a, b, c);
        case 4:
            return $fffe7e7adcbe9002$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $fffe7e7adcbe9002$var$Bh(b, null, d, c) : $fffe7e7adcbe9002$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fffe7e7adcbe9002$var$Lg(d, e), $fffe7e7adcbe9002$var$Zi(a, b, d, e, c);
        case 7:
            return $fffe7e7adcbe9002$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $fffe7e7adcbe9002$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $fffe7e7adcbe9002$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $fffe7e7adcbe9002$var$G($fffe7e7adcbe9002$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($fffe7e7adcbe9002$var$He(f.value, g)) {
                        if (f.children === e.children && !$fffe7e7adcbe9002$var$Wf.current) {
                            b = $fffe7e7adcbe9002$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $fffe7e7adcbe9002$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $fffe7e7adcbe9002$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($fffe7e7adcbe9002$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $fffe7e7adcbe9002$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $fffe7e7adcbe9002$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $fffe7e7adcbe9002$var$Tg(b, c), e = $fffe7e7adcbe9002$var$Vg(e), d = d(e), b.flags |= 1, $fffe7e7adcbe9002$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $fffe7e7adcbe9002$var$Lg(d, b.pendingProps), e = $fffe7e7adcbe9002$var$Lg(d.type, e), $fffe7e7adcbe9002$var$aj(a, b, d, e, c);
        case 15:
            return $fffe7e7adcbe9002$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fffe7e7adcbe9002$var$Lg(d, e), $fffe7e7adcbe9002$var$jj(a, b), b.tag = 1, $fffe7e7adcbe9002$var$Zf(d) ? (a = !0, $fffe7e7adcbe9002$var$cg(b)) : a = !1, $fffe7e7adcbe9002$var$Tg(b, c), $fffe7e7adcbe9002$var$ph(b, d, e), $fffe7e7adcbe9002$var$rh(b, d, e, c), $fffe7e7adcbe9002$var$kj(null, b, d, !0, a, c);
        case 19:
            return $fffe7e7adcbe9002$var$yj(a, b, c);
        case 22:
            return $fffe7e7adcbe9002$var$ej(a, b, c);
    }
    throw Error($fffe7e7adcbe9002$var$p(156, b.tag));
};
function $fffe7e7adcbe9002$var$Gk(a, b) {
    return $fffe7e7adcbe9002$var$ac(a, b);
}
function $fffe7e7adcbe9002$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $fffe7e7adcbe9002$var$Bg(a, b, c, d) {
    return new $fffe7e7adcbe9002$var$al(a, b, c, d);
}
function $fffe7e7adcbe9002$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $fffe7e7adcbe9002$var$$k(a) {
    if ("function" === typeof a) return $fffe7e7adcbe9002$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $fffe7e7adcbe9002$var$Da) return 11;
        if (a === $fffe7e7adcbe9002$var$Ga) return 14;
    }
    return 2;
}
function $fffe7e7adcbe9002$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $fffe7e7adcbe9002$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $fffe7e7adcbe9002$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $fffe7e7adcbe9002$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $fffe7e7adcbe9002$var$ya:
            return $fffe7e7adcbe9002$var$Ah(c.children, e, f, b);
        case $fffe7e7adcbe9002$var$za:
            g = 8;
            e |= 8;
            break;
        case $fffe7e7adcbe9002$var$Aa:
            return a = $fffe7e7adcbe9002$var$Bg(12, c, b, e | 2), a.elementType = $fffe7e7adcbe9002$var$Aa, a.lanes = f, a;
        case $fffe7e7adcbe9002$var$Ea:
            return a = $fffe7e7adcbe9002$var$Bg(13, c, b, e), a.elementType = $fffe7e7adcbe9002$var$Ea, a.lanes = f, a;
        case $fffe7e7adcbe9002$var$Fa:
            return a = $fffe7e7adcbe9002$var$Bg(19, c, b, e), a.elementType = $fffe7e7adcbe9002$var$Fa, a.lanes = f, a;
        case $fffe7e7adcbe9002$var$Ia:
            return $fffe7e7adcbe9002$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $fffe7e7adcbe9002$var$Ba:
                    g = 10;
                    break a;
                case $fffe7e7adcbe9002$var$Ca:
                    g = 9;
                    break a;
                case $fffe7e7adcbe9002$var$Da:
                    g = 11;
                    break a;
                case $fffe7e7adcbe9002$var$Ga:
                    g = 14;
                    break a;
                case $fffe7e7adcbe9002$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($fffe7e7adcbe9002$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $fffe7e7adcbe9002$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $fffe7e7adcbe9002$var$Ah(a, b, c, d) {
    a = $fffe7e7adcbe9002$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $fffe7e7adcbe9002$var$qj(a, b, c, d) {
    a = $fffe7e7adcbe9002$var$Bg(22, a, d, b);
    a.elementType = $fffe7e7adcbe9002$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $fffe7e7adcbe9002$var$xh(a, b, c) {
    a = $fffe7e7adcbe9002$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $fffe7e7adcbe9002$var$zh(a, b, c) {
    b = $fffe7e7adcbe9002$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $fffe7e7adcbe9002$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $fffe7e7adcbe9002$var$zc(0);
    this.expirationTimes = $fffe7e7adcbe9002$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $fffe7e7adcbe9002$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $fffe7e7adcbe9002$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $fffe7e7adcbe9002$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $fffe7e7adcbe9002$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $fffe7e7adcbe9002$var$ah(f);
    return a;
}
function $fffe7e7adcbe9002$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $fffe7e7adcbe9002$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $fffe7e7adcbe9002$var$el(a) {
    if (!a) return $fffe7e7adcbe9002$var$Vf;
    a = a._reactInternals;
    a: {
        if ($fffe7e7adcbe9002$var$Vb(a) !== a || 1 !== a.tag) throw Error($fffe7e7adcbe9002$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($fffe7e7adcbe9002$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($fffe7e7adcbe9002$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($fffe7e7adcbe9002$var$Zf(c)) return $fffe7e7adcbe9002$var$bg(a, c, b);
    }
    return b;
}
function $fffe7e7adcbe9002$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $fffe7e7adcbe9002$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $fffe7e7adcbe9002$var$el(null);
    c = a.current;
    d = $fffe7e7adcbe9002$var$L();
    e = $fffe7e7adcbe9002$var$lh(c);
    f = $fffe7e7adcbe9002$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $fffe7e7adcbe9002$var$dh(c, f, e);
    a.current.lanes = e;
    $fffe7e7adcbe9002$var$Ac(a, e, d);
    $fffe7e7adcbe9002$var$Ek(a, d);
    return a;
}
function $fffe7e7adcbe9002$var$gl(a, b, c, d) {
    var e = b.current, f = $fffe7e7adcbe9002$var$L(), g = $fffe7e7adcbe9002$var$lh(e);
    c = $fffe7e7adcbe9002$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $fffe7e7adcbe9002$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $fffe7e7adcbe9002$var$dh(e, b, g);
    null !== a && ($fffe7e7adcbe9002$var$mh(a, e, g, f), $fffe7e7adcbe9002$var$eh(a, e, g));
    return g;
}
function $fffe7e7adcbe9002$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $fffe7e7adcbe9002$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $fffe7e7adcbe9002$var$jl(a, b) {
    $fffe7e7adcbe9002$var$il(a, b);
    (a = a.alternate) && $fffe7e7adcbe9002$var$il(a, b);
}
function $fffe7e7adcbe9002$var$kl() {
    return null;
}
var $fffe7e7adcbe9002$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $fffe7e7adcbe9002$var$ml(a) {
    this._internalRoot = a;
}
$fffe7e7adcbe9002$var$nl.prototype.render = $fffe7e7adcbe9002$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($fffe7e7adcbe9002$var$p(409));
    $fffe7e7adcbe9002$var$gl(a, b, null, null);
};
$fffe7e7adcbe9002$var$nl.prototype.unmount = $fffe7e7adcbe9002$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $fffe7e7adcbe9002$var$Sk(function() {
            $fffe7e7adcbe9002$var$gl(null, a, null, null);
        });
        b[$fffe7e7adcbe9002$var$uf] = null;
    }
};
function $fffe7e7adcbe9002$var$nl(a) {
    this._internalRoot = a;
}
$fffe7e7adcbe9002$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $fffe7e7adcbe9002$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $fffe7e7adcbe9002$var$Qc.length && 0 !== b && b < $fffe7e7adcbe9002$var$Qc[c].priority; c++);
        $fffe7e7adcbe9002$var$Qc.splice(c, 0, a);
        0 === c && $fffe7e7adcbe9002$var$Vc(a);
    }
};
function $fffe7e7adcbe9002$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $fffe7e7adcbe9002$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $fffe7e7adcbe9002$var$ql() {}
function $fffe7e7adcbe9002$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $fffe7e7adcbe9002$var$hl(g);
                f.call(a);
            };
        }
        var g = $fffe7e7adcbe9002$var$fl(b, d, a, 0, null, !1, !1, "", $fffe7e7adcbe9002$var$ql);
        a._reactRootContainer = g;
        a[$fffe7e7adcbe9002$var$uf] = g.current;
        $fffe7e7adcbe9002$var$sf(8 === a.nodeType ? a.parentNode : a);
        $fffe7e7adcbe9002$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $fffe7e7adcbe9002$var$hl(k);
            h.call(a);
        };
    }
    var k = $fffe7e7adcbe9002$var$cl(a, 0, !1, null, null, !1, !1, "", $fffe7e7adcbe9002$var$ql);
    a._reactRootContainer = k;
    a[$fffe7e7adcbe9002$var$uf] = k.current;
    $fffe7e7adcbe9002$var$sf(8 === a.nodeType ? a.parentNode : a);
    $fffe7e7adcbe9002$var$Sk(function() {
        $fffe7e7adcbe9002$var$gl(b, k, c, d);
    });
    return k;
}
function $fffe7e7adcbe9002$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $fffe7e7adcbe9002$var$hl(g);
                h.call(a);
            };
        }
        $fffe7e7adcbe9002$var$gl(b, g, a, e);
    } else g = $fffe7e7adcbe9002$var$rl(c, b, a, e, d);
    return $fffe7e7adcbe9002$var$hl(g);
}
$fffe7e7adcbe9002$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $fffe7e7adcbe9002$var$tc(b.pendingLanes);
                0 !== c && ($fffe7e7adcbe9002$var$Cc(b, c | 1), $fffe7e7adcbe9002$var$Ek(b, $fffe7e7adcbe9002$var$B()), 0 === ($fffe7e7adcbe9002$var$K & 6) && ($fffe7e7adcbe9002$var$Hj = $fffe7e7adcbe9002$var$B() + 500, $fffe7e7adcbe9002$var$jg()));
            }
            break;
        case 13:
            $fffe7e7adcbe9002$var$Sk(function() {
                var b = $fffe7e7adcbe9002$var$Zg(a, 1);
                if (null !== b) {
                    var c = $fffe7e7adcbe9002$var$L();
                    $fffe7e7adcbe9002$var$mh(b, a, 1, c);
                }
            }), $fffe7e7adcbe9002$var$jl(a, 1);
    }
};
$fffe7e7adcbe9002$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $fffe7e7adcbe9002$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $fffe7e7adcbe9002$var$L();
            $fffe7e7adcbe9002$var$mh(b, a, 134217728, c);
        }
        $fffe7e7adcbe9002$var$jl(a, 134217728);
    }
};
$fffe7e7adcbe9002$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $fffe7e7adcbe9002$var$lh(a), c = $fffe7e7adcbe9002$var$Zg(a, b);
        if (null !== c) {
            var d = $fffe7e7adcbe9002$var$L();
            $fffe7e7adcbe9002$var$mh(c, a, b, d);
        }
        $fffe7e7adcbe9002$var$jl(a, b);
    }
};
$fffe7e7adcbe9002$var$Hc = function() {
    return $fffe7e7adcbe9002$var$C;
};
$fffe7e7adcbe9002$var$Ic = function(a, b) {
    var c = $fffe7e7adcbe9002$var$C;
    try {
        return $fffe7e7adcbe9002$var$C = a, b();
    } finally{
        $fffe7e7adcbe9002$var$C = c;
    }
};
$fffe7e7adcbe9002$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $fffe7e7adcbe9002$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $fffe7e7adcbe9002$var$Db(d);
                        if (!e) throw Error($fffe7e7adcbe9002$var$p(90));
                        $fffe7e7adcbe9002$var$Wa(d);
                        $fffe7e7adcbe9002$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $fffe7e7adcbe9002$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $fffe7e7adcbe9002$var$fb(a, !!c.multiple, b, !1);
    }
};
$fffe7e7adcbe9002$var$Gb = $fffe7e7adcbe9002$var$Rk;
$fffe7e7adcbe9002$var$Hb = $fffe7e7adcbe9002$var$Sk;
var $fffe7e7adcbe9002$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $fffe7e7adcbe9002$var$Cb,
        $fffe7e7adcbe9002$var$ue,
        $fffe7e7adcbe9002$var$Db,
        $fffe7e7adcbe9002$var$Eb,
        $fffe7e7adcbe9002$var$Fb,
        $fffe7e7adcbe9002$var$Rk
    ]
}, $fffe7e7adcbe9002$var$ul = {
    findFiberByHostInstance: $fffe7e7adcbe9002$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $fffe7e7adcbe9002$var$vl = {
    bundleType: $fffe7e7adcbe9002$var$ul.bundleType,
    version: $fffe7e7adcbe9002$var$ul.version,
    rendererPackageName: $fffe7e7adcbe9002$var$ul.rendererPackageName,
    rendererConfig: $fffe7e7adcbe9002$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $fffe7e7adcbe9002$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $fffe7e7adcbe9002$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $fffe7e7adcbe9002$var$ul.findFiberByHostInstance || $fffe7e7adcbe9002$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $fffe7e7adcbe9002$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$fffe7e7adcbe9002$var$wl.isDisabled && $fffe7e7adcbe9002$var$wl.supportsFiber) try {
        $fffe7e7adcbe9002$var$kc = $fffe7e7adcbe9002$var$wl.inject($fffe7e7adcbe9002$var$vl), $fffe7e7adcbe9002$var$lc = $fffe7e7adcbe9002$var$wl;
    } catch (a) {}
}
$fffe7e7adcbe9002$export$ae55be85d98224ed = $fffe7e7adcbe9002$var$tl;
$fffe7e7adcbe9002$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$fffe7e7adcbe9002$var$ol(b)) throw Error($fffe7e7adcbe9002$var$p(200));
    return $fffe7e7adcbe9002$var$dl(a, b, null, c);
};
$fffe7e7adcbe9002$export$882461b6382ed46c = function(a, b) {
    if (!$fffe7e7adcbe9002$var$ol(a)) throw Error($fffe7e7adcbe9002$var$p(299));
    var c = !1, d = "", e = $fffe7e7adcbe9002$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $fffe7e7adcbe9002$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$fffe7e7adcbe9002$var$uf] = b.current;
    $fffe7e7adcbe9002$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $fffe7e7adcbe9002$var$ml(b);
};
$fffe7e7adcbe9002$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($fffe7e7adcbe9002$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($fffe7e7adcbe9002$var$p(268, a));
    }
    a = $fffe7e7adcbe9002$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$fffe7e7adcbe9002$export$cd75ccfd720a3cd4 = function(a) {
    return $fffe7e7adcbe9002$var$Sk(a);
};
$fffe7e7adcbe9002$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$fffe7e7adcbe9002$var$pl(b)) throw Error($fffe7e7adcbe9002$var$p(200));
    return $fffe7e7adcbe9002$var$sl(null, a, b, !0, c);
};
$fffe7e7adcbe9002$export$757ceba2d55c277e = function(a, b, c) {
    if (!$fffe7e7adcbe9002$var$ol(a)) throw Error($fffe7e7adcbe9002$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $fffe7e7adcbe9002$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $fffe7e7adcbe9002$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$fffe7e7adcbe9002$var$uf] = b.current;
    $fffe7e7adcbe9002$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $fffe7e7adcbe9002$var$nl(b);
};
$fffe7e7adcbe9002$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$fffe7e7adcbe9002$var$pl(b)) throw Error($fffe7e7adcbe9002$var$p(200));
    return $fffe7e7adcbe9002$var$sl(null, a, b, !1, c);
};
$fffe7e7adcbe9002$export$502457920280e6be = function(a) {
    if (!$fffe7e7adcbe9002$var$pl(a)) throw Error($fffe7e7adcbe9002$var$p(40));
    return a._reactRootContainer ? ($fffe7e7adcbe9002$var$Sk(function() {
        $fffe7e7adcbe9002$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$fffe7e7adcbe9002$var$uf] = null;
        });
    }), !0) : !1;
};
$fffe7e7adcbe9002$export$c78a37762a8d58e1 = $fffe7e7adcbe9002$var$Rk;
$fffe7e7adcbe9002$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$fffe7e7adcbe9002$var$pl(c)) throw Error($fffe7e7adcbe9002$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($fffe7e7adcbe9002$var$p(38));
    return $fffe7e7adcbe9002$var$sl(a, b, c, !1, d);
};
$fffe7e7adcbe9002$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("2hXd7", function(module, exports) {
"use strict";

module.exports = (parcelRequire("aEpUX"));

});
parcelRegister("aEpUX", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $7c11be869c36aef0$export$c4744153514ff05d; }, function (v) { return $7c11be869c36aef0$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $7c11be869c36aef0$export$3e506c1ccc9cc1a7; }, function (v) { return $7c11be869c36aef0$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $7c11be869c36aef0$export$e26fe2ed2fa76875; }, function (v) { return $7c11be869c36aef0$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $7c11be869c36aef0$export$502329bbf4b505b1; }, function (v) { return $7c11be869c36aef0$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $7c11be869c36aef0$export$6e3807111c4874c4; }, function (v) { return $7c11be869c36aef0$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $7c11be869c36aef0$export$c27134553091fb3a; }, function (v) { return $7c11be869c36aef0$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $7c11be869c36aef0$export$33ee1acdc04fd2a2; }, function (v) { return $7c11be869c36aef0$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $7c11be869c36aef0$export$b00a404bbd5edef2; }, function (v) { return $7c11be869c36aef0$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $7c11be869c36aef0$export$8352ce38b91d0c62; }, function (v) { return $7c11be869c36aef0$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $7c11be869c36aef0$export$d66a1c1c77bd778b; }, function (v) { return $7c11be869c36aef0$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $7c11be869c36aef0$export$d3dfb8e4810cb555; }, function (v) { return $7c11be869c36aef0$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $7c11be869c36aef0$export$839f9183b0465a69; }, function (v) { return $7c11be869c36aef0$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $7c11be869c36aef0$export$72fdf0e06517287b; }, function (v) { return $7c11be869c36aef0$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $7c11be869c36aef0$export$4b844e58a3e414b4; }, function (v) { return $7c11be869c36aef0$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $7c11be869c36aef0$export$816d2913ae6b83b1; }, function (v) { return $7c11be869c36aef0$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $7c11be869c36aef0$export$61bcfe829111a1d0; }, function (v) { return $7c11be869c36aef0$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $7c11be869c36aef0$export$7ee8c9beb337bc3f; }, function (v) { return $7c11be869c36aef0$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $7c11be869c36aef0$export$b5836b71941fa3ed; }, function (v) { return $7c11be869c36aef0$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $7c11be869c36aef0$export$cf845f2c119da08a; }, function (v) { return $7c11be869c36aef0$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7c11be869c36aef0$export$c4744153514ff05d;
var $7c11be869c36aef0$export$3e506c1ccc9cc1a7;
var $7c11be869c36aef0$export$e26fe2ed2fa76875;
var $7c11be869c36aef0$export$502329bbf4b505b1;
var $7c11be869c36aef0$export$6e3807111c4874c4;
var $7c11be869c36aef0$export$c27134553091fb3a;
var $7c11be869c36aef0$export$33ee1acdc04fd2a2;
var $7c11be869c36aef0$export$b00a404bbd5edef2;
var $7c11be869c36aef0$export$8352ce38b91d0c62;
var $7c11be869c36aef0$export$d66a1c1c77bd778b;
var $7c11be869c36aef0$export$d3dfb8e4810cb555;
var $7c11be869c36aef0$export$839f9183b0465a69;
var $7c11be869c36aef0$export$72fdf0e06517287b;
var $7c11be869c36aef0$export$4b844e58a3e414b4;
var $7c11be869c36aef0$export$816d2913ae6b83b1;
var $7c11be869c36aef0$export$61bcfe829111a1d0;
var $7c11be869c36aef0$export$7ee8c9beb337bc3f;
var $7c11be869c36aef0$export$b5836b71941fa3ed;
var $7c11be869c36aef0$export$cf845f2c119da08a;
"use strict";
function $7c11be869c36aef0$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $7c11be869c36aef0$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $7c11be869c36aef0$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $7c11be869c36aef0$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $7c11be869c36aef0$var$g(C, c)) n < e && 0 > $7c11be869c36aef0$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $7c11be869c36aef0$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $7c11be869c36aef0$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $7c11be869c36aef0$var$l = performance;
    $7c11be869c36aef0$export$c4744153514ff05d = function() {
        return $7c11be869c36aef0$var$l.now();
    };
} else {
    var $7c11be869c36aef0$var$p = Date, $7c11be869c36aef0$var$q = $7c11be869c36aef0$var$p.now();
    $7c11be869c36aef0$export$c4744153514ff05d = function() {
        return $7c11be869c36aef0$var$p.now() - $7c11be869c36aef0$var$q;
    };
}
var $7c11be869c36aef0$var$r = [], $7c11be869c36aef0$var$t = [], $7c11be869c36aef0$var$u = 1, $7c11be869c36aef0$var$v = null, $7c11be869c36aef0$var$y = 3, $7c11be869c36aef0$var$z = !1, $7c11be869c36aef0$var$A = !1, $7c11be869c36aef0$var$B = !1, $7c11be869c36aef0$var$D = "function" === typeof setTimeout ? setTimeout : null, $7c11be869c36aef0$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $7c11be869c36aef0$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $7c11be869c36aef0$var$G(a) {
    for(var b = $7c11be869c36aef0$var$h($7c11be869c36aef0$var$t); null !== b;){
        if (null === b.callback) $7c11be869c36aef0$var$k($7c11be869c36aef0$var$t);
        else if (b.startTime <= a) $7c11be869c36aef0$var$k($7c11be869c36aef0$var$t), b.sortIndex = b.expirationTime, $7c11be869c36aef0$var$f($7c11be869c36aef0$var$r, b);
        else break;
        b = $7c11be869c36aef0$var$h($7c11be869c36aef0$var$t);
    }
}
function $7c11be869c36aef0$var$H(a) {
    $7c11be869c36aef0$var$B = !1;
    $7c11be869c36aef0$var$G(a);
    if (!$7c11be869c36aef0$var$A) {
        if (null !== $7c11be869c36aef0$var$h($7c11be869c36aef0$var$r)) $7c11be869c36aef0$var$A = !0, $7c11be869c36aef0$var$I($7c11be869c36aef0$var$J);
        else {
            var b = $7c11be869c36aef0$var$h($7c11be869c36aef0$var$t);
            null !== b && $7c11be869c36aef0$var$K($7c11be869c36aef0$var$H, b.startTime - a);
        }
    }
}
function $7c11be869c36aef0$var$J(a, b) {
    $7c11be869c36aef0$var$A = !1;
    $7c11be869c36aef0$var$B && ($7c11be869c36aef0$var$B = !1, $7c11be869c36aef0$var$E($7c11be869c36aef0$var$L), $7c11be869c36aef0$var$L = -1);
    $7c11be869c36aef0$var$z = !0;
    var c = $7c11be869c36aef0$var$y;
    try {
        $7c11be869c36aef0$var$G(b);
        for($7c11be869c36aef0$var$v = $7c11be869c36aef0$var$h($7c11be869c36aef0$var$r); null !== $7c11be869c36aef0$var$v && (!($7c11be869c36aef0$var$v.expirationTime > b) || a && !$7c11be869c36aef0$var$M());){
            var d = $7c11be869c36aef0$var$v.callback;
            if ("function" === typeof d) {
                $7c11be869c36aef0$var$v.callback = null;
                $7c11be869c36aef0$var$y = $7c11be869c36aef0$var$v.priorityLevel;
                var e = d($7c11be869c36aef0$var$v.expirationTime <= b);
                b = $7c11be869c36aef0$export$c4744153514ff05d();
                "function" === typeof e ? $7c11be869c36aef0$var$v.callback = e : $7c11be869c36aef0$var$v === $7c11be869c36aef0$var$h($7c11be869c36aef0$var$r) && $7c11be869c36aef0$var$k($7c11be869c36aef0$var$r);
                $7c11be869c36aef0$var$G(b);
            } else $7c11be869c36aef0$var$k($7c11be869c36aef0$var$r);
            $7c11be869c36aef0$var$v = $7c11be869c36aef0$var$h($7c11be869c36aef0$var$r);
        }
        if (null !== $7c11be869c36aef0$var$v) var w = !0;
        else {
            var m = $7c11be869c36aef0$var$h($7c11be869c36aef0$var$t);
            null !== m && $7c11be869c36aef0$var$K($7c11be869c36aef0$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $7c11be869c36aef0$var$v = null, $7c11be869c36aef0$var$y = c, $7c11be869c36aef0$var$z = !1;
    }
}
var $7c11be869c36aef0$var$N = !1, $7c11be869c36aef0$var$O = null, $7c11be869c36aef0$var$L = -1, $7c11be869c36aef0$var$P = 5, $7c11be869c36aef0$var$Q = -1;
function $7c11be869c36aef0$var$M() {
    return $7c11be869c36aef0$export$c4744153514ff05d() - $7c11be869c36aef0$var$Q < $7c11be869c36aef0$var$P ? !1 : !0;
}
function $7c11be869c36aef0$var$R() {
    if (null !== $7c11be869c36aef0$var$O) {
        var a = $7c11be869c36aef0$export$c4744153514ff05d();
        $7c11be869c36aef0$var$Q = a;
        var b = !0;
        try {
            b = $7c11be869c36aef0$var$O(!0, a);
        } finally{
            b ? $7c11be869c36aef0$var$S() : ($7c11be869c36aef0$var$N = !1, $7c11be869c36aef0$var$O = null);
        }
    } else $7c11be869c36aef0$var$N = !1;
}
var $7c11be869c36aef0$var$S;
if ("function" === typeof $7c11be869c36aef0$var$F) $7c11be869c36aef0$var$S = function() {
    $7c11be869c36aef0$var$F($7c11be869c36aef0$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $7c11be869c36aef0$var$T = new MessageChannel, $7c11be869c36aef0$var$U = $7c11be869c36aef0$var$T.port2;
    $7c11be869c36aef0$var$T.port1.onmessage = $7c11be869c36aef0$var$R;
    $7c11be869c36aef0$var$S = function() {
        $7c11be869c36aef0$var$U.postMessage(null);
    };
} else $7c11be869c36aef0$var$S = function() {
    $7c11be869c36aef0$var$D($7c11be869c36aef0$var$R, 0);
};
function $7c11be869c36aef0$var$I(a) {
    $7c11be869c36aef0$var$O = a;
    $7c11be869c36aef0$var$N || ($7c11be869c36aef0$var$N = !0, $7c11be869c36aef0$var$S());
}
function $7c11be869c36aef0$var$K(a, b) {
    $7c11be869c36aef0$var$L = $7c11be869c36aef0$var$D(function() {
        a($7c11be869c36aef0$export$c4744153514ff05d());
    }, b);
}
$7c11be869c36aef0$export$3e506c1ccc9cc1a7 = 5;
$7c11be869c36aef0$export$e26fe2ed2fa76875 = 1;
$7c11be869c36aef0$export$502329bbf4b505b1 = 4;
$7c11be869c36aef0$export$6e3807111c4874c4 = 3;
$7c11be869c36aef0$export$c27134553091fb3a = null;
$7c11be869c36aef0$export$33ee1acdc04fd2a2 = 2;
$7c11be869c36aef0$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$7c11be869c36aef0$export$8352ce38b91d0c62 = function() {
    $7c11be869c36aef0$var$A || $7c11be869c36aef0$var$z || ($7c11be869c36aef0$var$A = !0, $7c11be869c36aef0$var$I($7c11be869c36aef0$var$J));
};
$7c11be869c36aef0$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $7c11be869c36aef0$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$7c11be869c36aef0$export$d3dfb8e4810cb555 = function() {
    return $7c11be869c36aef0$var$y;
};
$7c11be869c36aef0$export$839f9183b0465a69 = function() {
    return $7c11be869c36aef0$var$h($7c11be869c36aef0$var$r);
};
$7c11be869c36aef0$export$72fdf0e06517287b = function(a) {
    switch($7c11be869c36aef0$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $7c11be869c36aef0$var$y;
    }
    var c = $7c11be869c36aef0$var$y;
    $7c11be869c36aef0$var$y = b;
    try {
        return a();
    } finally{
        $7c11be869c36aef0$var$y = c;
    }
};
$7c11be869c36aef0$export$4b844e58a3e414b4 = function() {};
$7c11be869c36aef0$export$816d2913ae6b83b1 = function() {};
$7c11be869c36aef0$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $7c11be869c36aef0$var$y;
    $7c11be869c36aef0$var$y = a;
    try {
        return b();
    } finally{
        $7c11be869c36aef0$var$y = c;
    }
};
$7c11be869c36aef0$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $7c11be869c36aef0$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $7c11be869c36aef0$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $7c11be869c36aef0$var$f($7c11be869c36aef0$var$t, a), null === $7c11be869c36aef0$var$h($7c11be869c36aef0$var$r) && a === $7c11be869c36aef0$var$h($7c11be869c36aef0$var$t) && ($7c11be869c36aef0$var$B ? ($7c11be869c36aef0$var$E($7c11be869c36aef0$var$L), $7c11be869c36aef0$var$L = -1) : $7c11be869c36aef0$var$B = !0, $7c11be869c36aef0$var$K($7c11be869c36aef0$var$H, c - d))) : (a.sortIndex = e, $7c11be869c36aef0$var$f($7c11be869c36aef0$var$r, a), $7c11be869c36aef0$var$A || $7c11be869c36aef0$var$z || ($7c11be869c36aef0$var$A = !0, $7c11be869c36aef0$var$I($7c11be869c36aef0$var$J)));
    return a;
};
$7c11be869c36aef0$export$b5836b71941fa3ed = $7c11be869c36aef0$var$M;
$7c11be869c36aef0$export$cf845f2c119da08a = function(a) {
    var b = $7c11be869c36aef0$var$y;
    return function() {
        var c = $7c11be869c36aef0$var$y;
        $7c11be869c36aef0$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $7c11be869c36aef0$var$y = c;
        }
    };
};

});




parcelRegister("j5BEa", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $de5bafd87d97947e$export$306c0aa65ff9ec16; }, function (v) { return $de5bafd87d97947e$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $de5bafd87d97947e$export$306c0aa65ff9ec16;
"use strict";

var $4DE7A = parcelRequire("4DE7A");
function $de5bafd87d97947e$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $de5bafd87d97947e$var$k = "function" === typeof Object.is ? Object.is : $de5bafd87d97947e$var$h, $de5bafd87d97947e$var$l = $4DE7A.useState, $de5bafd87d97947e$var$m = $4DE7A.useEffect, $de5bafd87d97947e$var$n = $4DE7A.useLayoutEffect, $de5bafd87d97947e$var$p = $4DE7A.useDebugValue;
function $de5bafd87d97947e$var$q(a, b) {
    var d = b(), f = $de5bafd87d97947e$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $de5bafd87d97947e$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $de5bafd87d97947e$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $de5bafd87d97947e$var$m(function() {
        $de5bafd87d97947e$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $de5bafd87d97947e$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $de5bafd87d97947e$var$p(d);
    return d;
}
function $de5bafd87d97947e$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$de5bafd87d97947e$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $de5bafd87d97947e$var$t(a, b) {
    return b();
}
var $de5bafd87d97947e$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $de5bafd87d97947e$var$t : $de5bafd87d97947e$var$q;
$de5bafd87d97947e$export$306c0aa65ff9ec16 = void 0 !== $4DE7A.useSyncExternalStore ? $4DE7A.useSyncExternalStore : $de5bafd87d97947e$var$u;

});

parcelRegister("fNSou", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $b815a01dc05f7ada$export$bf730a2d8bf68b42; }, function (v) { return $b815a01dc05f7ada$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b815a01dc05f7ada$export$bf730a2d8bf68b42;
"use strict";

var $4DE7A = parcelRequire("4DE7A");

var $lomSQ = parcelRequire("lomSQ");
function $b815a01dc05f7ada$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b815a01dc05f7ada$var$q = "function" === typeof Object.is ? Object.is : $b815a01dc05f7ada$var$p, $b815a01dc05f7ada$var$r = $lomSQ.useSyncExternalStore, $b815a01dc05f7ada$var$t = $4DE7A.useRef, $b815a01dc05f7ada$var$u = $4DE7A.useEffect, $b815a01dc05f7ada$var$v = $4DE7A.useMemo, $b815a01dc05f7ada$var$w = $4DE7A.useDebugValue;
$b815a01dc05f7ada$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $b815a01dc05f7ada$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $b815a01dc05f7ada$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($b815a01dc05f7ada$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $b815a01dc05f7ada$var$r(a, c[0], c[1]);
    $b815a01dc05f7ada$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $b815a01dc05f7ada$var$w(d);
    return d;
};

});
parcelRegister("lomSQ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("j5BEa"));

});


parcelRegister("34Pgq", function(module, exports) {
"use strict";

var $5Imz6 = parcelRequire("5Imz6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $23d982c8bcd76673$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $23d982c8bcd76673$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $23d982c8bcd76673$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $23d982c8bcd76673$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $23d982c8bcd76673$var$TYPE_STATICS = {};
$23d982c8bcd76673$var$TYPE_STATICS[$5Imz6.ForwardRef] = $23d982c8bcd76673$var$FORWARD_REF_STATICS;
$23d982c8bcd76673$var$TYPE_STATICS[$5Imz6.Memo] = $23d982c8bcd76673$var$MEMO_STATICS;
function $23d982c8bcd76673$var$getStatics(component) {
    // React v16.11 and below
    if ($5Imz6.isMemo(component)) return $23d982c8bcd76673$var$MEMO_STATICS;
     // React v16.12 and above
    return $23d982c8bcd76673$var$TYPE_STATICS[component["$$typeof"]] || $23d982c8bcd76673$var$REACT_STATICS;
}
var $23d982c8bcd76673$var$defineProperty = Object.defineProperty;
var $23d982c8bcd76673$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $23d982c8bcd76673$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $23d982c8bcd76673$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $23d982c8bcd76673$var$getPrototypeOf = Object.getPrototypeOf;
var $23d982c8bcd76673$var$objectPrototype = Object.prototype;
function $23d982c8bcd76673$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($23d982c8bcd76673$var$objectPrototype) {
            var inheritedComponent = $23d982c8bcd76673$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $23d982c8bcd76673$var$objectPrototype) $23d982c8bcd76673$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $23d982c8bcd76673$var$getOwnPropertyNames(sourceComponent);
        if ($23d982c8bcd76673$var$getOwnPropertySymbols) keys = keys.concat($23d982c8bcd76673$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $23d982c8bcd76673$var$getStatics(targetComponent);
        var sourceStatics = $23d982c8bcd76673$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$23d982c8bcd76673$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $23d982c8bcd76673$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $23d982c8bcd76673$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $23d982c8bcd76673$var$hoistNonReactStatics;

});
parcelRegister("5Imz6", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ko1nX"));

});
parcelRegister("ko1nX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $ed771fa5719bbf67$export$2b8d127b894957b9; }, function (v) { return $ed771fa5719bbf67$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $ed771fa5719bbf67$export$cea3a54a6425200c; }, function (v) { return $ed771fa5719bbf67$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $ed771fa5719bbf67$export$a7c73072b1a182ae; }, function (v) { return $ed771fa5719bbf67$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $ed771fa5719bbf67$export$9f27bc3417b4524d; }, function (v) { return $ed771fa5719bbf67$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $ed771fa5719bbf67$export$db77ccec0bb4ccac; }, function (v) { return $ed771fa5719bbf67$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $ed771fa5719bbf67$export$8392c0c9d3dcbd35; }, function (v) { return $ed771fa5719bbf67$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ed771fa5719bbf67$export$ffb0004e005737fa; }, function (v) { return $ed771fa5719bbf67$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $ed771fa5719bbf67$export$b624eff549462981; }, function (v) { return $ed771fa5719bbf67$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $ed771fa5719bbf67$export$7897aa7841a5380c; }, function (v) { return $ed771fa5719bbf67$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $ed771fa5719bbf67$export$602eac185826482c; }, function (v) { return $ed771fa5719bbf67$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $ed771fa5719bbf67$export$e2c29f18771995cb; }, function (v) { return $ed771fa5719bbf67$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ed771fa5719bbf67$export$5f8d39834fd61797; }, function (v) { return $ed771fa5719bbf67$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ed771fa5719bbf67$export$74bf444e3cd11ea5; }, function (v) { return $ed771fa5719bbf67$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $ed771fa5719bbf67$export$92387174baf9b227; }, function (v) { return $ed771fa5719bbf67$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $ed771fa5719bbf67$export$ec112efeb987d9c6; }, function (v) { return $ed771fa5719bbf67$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $ed771fa5719bbf67$export$b706b080d889d2c9; }, function (v) { return $ed771fa5719bbf67$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $ed771fa5719bbf67$export$5be5a87408f70ddc; }, function (v) { return $ed771fa5719bbf67$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $ed771fa5719bbf67$export$45a5e7f76e0caa8d; }, function (v) { return $ed771fa5719bbf67$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $ed771fa5719bbf67$export$455c2e768291efa6; }, function (v) { return $ed771fa5719bbf67$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $ed771fa5719bbf67$export$9522e17588c12572; }, function (v) { return $ed771fa5719bbf67$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $ed771fa5719bbf67$export$2110ac352bb060b9; }, function (v) { return $ed771fa5719bbf67$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $ed771fa5719bbf67$export$56885ab8b9c456ab; }, function (v) { return $ed771fa5719bbf67$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $ed771fa5719bbf67$export$d927fcb6adf8f9de; }, function (v) { return $ed771fa5719bbf67$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $ed771fa5719bbf67$export$b82d16f27459e05a; }, function (v) { return $ed771fa5719bbf67$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $ed771fa5719bbf67$export$522c17b4f5e123e8; }, function (v) { return $ed771fa5719bbf67$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $ed771fa5719bbf67$export$1aabd8a0274ecfd6; }, function (v) { return $ed771fa5719bbf67$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $ed771fa5719bbf67$export$9b621391a187a31a; }, function (v) { return $ed771fa5719bbf67$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $ed771fa5719bbf67$export$f5bbd400c2f4426f; }, function (v) { return $ed771fa5719bbf67$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ed771fa5719bbf67$export$2b8d127b894957b9;
var $ed771fa5719bbf67$export$cea3a54a6425200c;
var $ed771fa5719bbf67$export$a7c73072b1a182ae;
var $ed771fa5719bbf67$export$9f27bc3417b4524d;
var $ed771fa5719bbf67$export$db77ccec0bb4ccac;
var $ed771fa5719bbf67$export$8392c0c9d3dcbd35;
var $ed771fa5719bbf67$export$ffb0004e005737fa;
var $ed771fa5719bbf67$export$b624eff549462981;
var $ed771fa5719bbf67$export$7897aa7841a5380c;
var $ed771fa5719bbf67$export$602eac185826482c;
var $ed771fa5719bbf67$export$e2c29f18771995cb;
var $ed771fa5719bbf67$export$5f8d39834fd61797;
var $ed771fa5719bbf67$export$74bf444e3cd11ea5;
var $ed771fa5719bbf67$export$92387174baf9b227;
var $ed771fa5719bbf67$export$ec112efeb987d9c6;
var $ed771fa5719bbf67$export$b706b080d889d2c9;
var $ed771fa5719bbf67$export$5be5a87408f70ddc;
var $ed771fa5719bbf67$export$45a5e7f76e0caa8d;
var $ed771fa5719bbf67$export$455c2e768291efa6;
var $ed771fa5719bbf67$export$9522e17588c12572;
var $ed771fa5719bbf67$export$2110ac352bb060b9;
var $ed771fa5719bbf67$export$56885ab8b9c456ab;
var $ed771fa5719bbf67$export$d927fcb6adf8f9de;
var $ed771fa5719bbf67$export$b82d16f27459e05a;
var $ed771fa5719bbf67$export$522c17b4f5e123e8;
var $ed771fa5719bbf67$export$1aabd8a0274ecfd6;
var $ed771fa5719bbf67$export$9b621391a187a31a;
var $ed771fa5719bbf67$export$f5bbd400c2f4426f;
"use strict";
var $ed771fa5719bbf67$var$b = "function" === typeof Symbol && Symbol.for, $ed771fa5719bbf67$var$c = $ed771fa5719bbf67$var$b ? Symbol.for("react.element") : 60103, $ed771fa5719bbf67$var$d = $ed771fa5719bbf67$var$b ? Symbol.for("react.portal") : 60106, $ed771fa5719bbf67$var$e = $ed771fa5719bbf67$var$b ? Symbol.for("react.fragment") : 60107, $ed771fa5719bbf67$var$f = $ed771fa5719bbf67$var$b ? Symbol.for("react.strict_mode") : 60108, $ed771fa5719bbf67$var$g = $ed771fa5719bbf67$var$b ? Symbol.for("react.profiler") : 60114, $ed771fa5719bbf67$var$h = $ed771fa5719bbf67$var$b ? Symbol.for("react.provider") : 60109, $ed771fa5719bbf67$var$k = $ed771fa5719bbf67$var$b ? Symbol.for("react.context") : 60110, $ed771fa5719bbf67$var$l = $ed771fa5719bbf67$var$b ? Symbol.for("react.async_mode") : 60111, $ed771fa5719bbf67$var$m = $ed771fa5719bbf67$var$b ? Symbol.for("react.concurrent_mode") : 60111, $ed771fa5719bbf67$var$n = $ed771fa5719bbf67$var$b ? Symbol.for("react.forward_ref") : 60112, $ed771fa5719bbf67$var$p = $ed771fa5719bbf67$var$b ? Symbol.for("react.suspense") : 60113, $ed771fa5719bbf67$var$q = $ed771fa5719bbf67$var$b ? Symbol.for("react.suspense_list") : 60120, $ed771fa5719bbf67$var$r = $ed771fa5719bbf67$var$b ? Symbol.for("react.memo") : 60115, $ed771fa5719bbf67$var$t = $ed771fa5719bbf67$var$b ? Symbol.for("react.lazy") : 60116, $ed771fa5719bbf67$var$v = $ed771fa5719bbf67$var$b ? Symbol.for("react.block") : 60121, $ed771fa5719bbf67$var$w = $ed771fa5719bbf67$var$b ? Symbol.for("react.fundamental") : 60117, $ed771fa5719bbf67$var$x = $ed771fa5719bbf67$var$b ? Symbol.for("react.responder") : 60118, $ed771fa5719bbf67$var$y = $ed771fa5719bbf67$var$b ? Symbol.for("react.scope") : 60119;
function $ed771fa5719bbf67$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $ed771fa5719bbf67$var$c:
                switch(a = a.type, a){
                    case $ed771fa5719bbf67$var$l:
                    case $ed771fa5719bbf67$var$m:
                    case $ed771fa5719bbf67$var$e:
                    case $ed771fa5719bbf67$var$g:
                    case $ed771fa5719bbf67$var$f:
                    case $ed771fa5719bbf67$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ed771fa5719bbf67$var$k:
                            case $ed771fa5719bbf67$var$n:
                            case $ed771fa5719bbf67$var$t:
                            case $ed771fa5719bbf67$var$r:
                            case $ed771fa5719bbf67$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $ed771fa5719bbf67$var$d:
                return u;
        }
    }
}
function $ed771fa5719bbf67$var$A(a) {
    return $ed771fa5719bbf67$var$z(a) === $ed771fa5719bbf67$var$m;
}
$ed771fa5719bbf67$export$2b8d127b894957b9 = $ed771fa5719bbf67$var$l;
$ed771fa5719bbf67$export$cea3a54a6425200c = $ed771fa5719bbf67$var$m;
$ed771fa5719bbf67$export$a7c73072b1a182ae = $ed771fa5719bbf67$var$k;
$ed771fa5719bbf67$export$9f27bc3417b4524d = $ed771fa5719bbf67$var$h;
$ed771fa5719bbf67$export$db77ccec0bb4ccac = $ed771fa5719bbf67$var$c;
$ed771fa5719bbf67$export$8392c0c9d3dcbd35 = $ed771fa5719bbf67$var$n;
$ed771fa5719bbf67$export$ffb0004e005737fa = $ed771fa5719bbf67$var$e;
$ed771fa5719bbf67$export$b624eff549462981 = $ed771fa5719bbf67$var$t;
$ed771fa5719bbf67$export$7897aa7841a5380c = $ed771fa5719bbf67$var$r;
$ed771fa5719bbf67$export$602eac185826482c = $ed771fa5719bbf67$var$d;
$ed771fa5719bbf67$export$e2c29f18771995cb = $ed771fa5719bbf67$var$g;
$ed771fa5719bbf67$export$5f8d39834fd61797 = $ed771fa5719bbf67$var$f;
$ed771fa5719bbf67$export$74bf444e3cd11ea5 = $ed771fa5719bbf67$var$p;
$ed771fa5719bbf67$export$92387174baf9b227 = function(a) {
    return $ed771fa5719bbf67$var$A(a) || $ed771fa5719bbf67$var$z(a) === $ed771fa5719bbf67$var$l;
};
$ed771fa5719bbf67$export$ec112efeb987d9c6 = $ed771fa5719bbf67$var$A;
$ed771fa5719bbf67$export$b706b080d889d2c9 = function(a) {
    return $ed771fa5719bbf67$var$z(a) === $ed771fa5719bbf67$var$k;
};
$ed771fa5719bbf67$export$5be5a87408f70ddc = function(a) {
    return $ed771fa5719bbf67$var$z(a) === $ed771fa5719bbf67$var$h;
};
$ed771fa5719bbf67$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ed771fa5719bbf67$var$c;
};
$ed771fa5719bbf67$export$455c2e768291efa6 = function(a) {
    return $ed771fa5719bbf67$var$z(a) === $ed771fa5719bbf67$var$n;
};
$ed771fa5719bbf67$export$9522e17588c12572 = function(a) {
    return $ed771fa5719bbf67$var$z(a) === $ed771fa5719bbf67$var$e;
};
$ed771fa5719bbf67$export$2110ac352bb060b9 = function(a) {
    return $ed771fa5719bbf67$var$z(a) === $ed771fa5719bbf67$var$t;
};
$ed771fa5719bbf67$export$56885ab8b9c456ab = function(a) {
    return $ed771fa5719bbf67$var$z(a) === $ed771fa5719bbf67$var$r;
};
$ed771fa5719bbf67$export$d927fcb6adf8f9de = function(a) {
    return $ed771fa5719bbf67$var$z(a) === $ed771fa5719bbf67$var$d;
};
$ed771fa5719bbf67$export$b82d16f27459e05a = function(a) {
    return $ed771fa5719bbf67$var$z(a) === $ed771fa5719bbf67$var$g;
};
$ed771fa5719bbf67$export$522c17b4f5e123e8 = function(a) {
    return $ed771fa5719bbf67$var$z(a) === $ed771fa5719bbf67$var$f;
};
$ed771fa5719bbf67$export$1aabd8a0274ecfd6 = function(a) {
    return $ed771fa5719bbf67$var$z(a) === $ed771fa5719bbf67$var$p;
};
$ed771fa5719bbf67$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ed771fa5719bbf67$var$e || a === $ed771fa5719bbf67$var$m || a === $ed771fa5719bbf67$var$g || a === $ed771fa5719bbf67$var$f || a === $ed771fa5719bbf67$var$p || a === $ed771fa5719bbf67$var$q || "object" === typeof a && null !== a && (a.$$typeof === $ed771fa5719bbf67$var$t || a.$$typeof === $ed771fa5719bbf67$var$r || a.$$typeof === $ed771fa5719bbf67$var$h || a.$$typeof === $ed771fa5719bbf67$var$k || a.$$typeof === $ed771fa5719bbf67$var$n || a.$$typeof === $ed771fa5719bbf67$var$w || a.$$typeof === $ed771fa5719bbf67$var$x || a.$$typeof === $ed771fa5719bbf67$var$y || a.$$typeof === $ed771fa5719bbf67$var$v);
};
$ed771fa5719bbf67$export$f5bbd400c2f4426f = $ed771fa5719bbf67$var$z;

});



parcelRegister("lDN5u", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $fc135142f8b1b2fe$export$a7c73072b1a182ae; }, function (v) { return $fc135142f8b1b2fe$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $fc135142f8b1b2fe$export$9f27bc3417b4524d; }, function (v) { return $fc135142f8b1b2fe$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $fc135142f8b1b2fe$export$db77ccec0bb4ccac; }, function (v) { return $fc135142f8b1b2fe$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $fc135142f8b1b2fe$export$8392c0c9d3dcbd35; }, function (v) { return $fc135142f8b1b2fe$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $fc135142f8b1b2fe$export$ffb0004e005737fa; }, function (v) { return $fc135142f8b1b2fe$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $fc135142f8b1b2fe$export$b624eff549462981; }, function (v) { return $fc135142f8b1b2fe$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $fc135142f8b1b2fe$export$7897aa7841a5380c; }, function (v) { return $fc135142f8b1b2fe$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $fc135142f8b1b2fe$export$602eac185826482c; }, function (v) { return $fc135142f8b1b2fe$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $fc135142f8b1b2fe$export$e2c29f18771995cb; }, function (v) { return $fc135142f8b1b2fe$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $fc135142f8b1b2fe$export$5f8d39834fd61797; }, function (v) { return $fc135142f8b1b2fe$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $fc135142f8b1b2fe$export$74bf444e3cd11ea5; }, function (v) { return $fc135142f8b1b2fe$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $fc135142f8b1b2fe$export$998bcd577473dd93; }, function (v) { return $fc135142f8b1b2fe$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $fc135142f8b1b2fe$export$92387174baf9b227; }, function (v) { return $fc135142f8b1b2fe$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $fc135142f8b1b2fe$export$ec112efeb987d9c6; }, function (v) { return $fc135142f8b1b2fe$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $fc135142f8b1b2fe$export$b706b080d889d2c9; }, function (v) { return $fc135142f8b1b2fe$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $fc135142f8b1b2fe$export$5be5a87408f70ddc; }, function (v) { return $fc135142f8b1b2fe$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $fc135142f8b1b2fe$export$45a5e7f76e0caa8d; }, function (v) { return $fc135142f8b1b2fe$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $fc135142f8b1b2fe$export$455c2e768291efa6; }, function (v) { return $fc135142f8b1b2fe$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $fc135142f8b1b2fe$export$9522e17588c12572; }, function (v) { return $fc135142f8b1b2fe$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $fc135142f8b1b2fe$export$2110ac352bb060b9; }, function (v) { return $fc135142f8b1b2fe$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $fc135142f8b1b2fe$export$56885ab8b9c456ab; }, function (v) { return $fc135142f8b1b2fe$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $fc135142f8b1b2fe$export$d927fcb6adf8f9de; }, function (v) { return $fc135142f8b1b2fe$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $fc135142f8b1b2fe$export$b82d16f27459e05a; }, function (v) { return $fc135142f8b1b2fe$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $fc135142f8b1b2fe$export$522c17b4f5e123e8; }, function (v) { return $fc135142f8b1b2fe$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $fc135142f8b1b2fe$export$1aabd8a0274ecfd6; }, function (v) { return $fc135142f8b1b2fe$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $fc135142f8b1b2fe$export$3d6c20d97e46b957; }, function (v) { return $fc135142f8b1b2fe$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $fc135142f8b1b2fe$export$9b621391a187a31a; }, function (v) { return $fc135142f8b1b2fe$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $fc135142f8b1b2fe$export$f5bbd400c2f4426f; }, function (v) { return $fc135142f8b1b2fe$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fc135142f8b1b2fe$export$a7c73072b1a182ae;
var $fc135142f8b1b2fe$export$9f27bc3417b4524d;
var $fc135142f8b1b2fe$export$db77ccec0bb4ccac;
var $fc135142f8b1b2fe$export$8392c0c9d3dcbd35;
var $fc135142f8b1b2fe$export$ffb0004e005737fa;
var $fc135142f8b1b2fe$export$b624eff549462981;
var $fc135142f8b1b2fe$export$7897aa7841a5380c;
var $fc135142f8b1b2fe$export$602eac185826482c;
var $fc135142f8b1b2fe$export$e2c29f18771995cb;
var $fc135142f8b1b2fe$export$5f8d39834fd61797;
var $fc135142f8b1b2fe$export$74bf444e3cd11ea5;
var $fc135142f8b1b2fe$export$998bcd577473dd93;
var $fc135142f8b1b2fe$export$92387174baf9b227;
var $fc135142f8b1b2fe$export$ec112efeb987d9c6;
var $fc135142f8b1b2fe$export$b706b080d889d2c9;
var $fc135142f8b1b2fe$export$5be5a87408f70ddc;
var $fc135142f8b1b2fe$export$45a5e7f76e0caa8d;
var $fc135142f8b1b2fe$export$455c2e768291efa6;
var $fc135142f8b1b2fe$export$9522e17588c12572;
var $fc135142f8b1b2fe$export$2110ac352bb060b9;
var $fc135142f8b1b2fe$export$56885ab8b9c456ab;
var $fc135142f8b1b2fe$export$d927fcb6adf8f9de;
var $fc135142f8b1b2fe$export$b82d16f27459e05a;
var $fc135142f8b1b2fe$export$522c17b4f5e123e8;
var $fc135142f8b1b2fe$export$1aabd8a0274ecfd6;
var $fc135142f8b1b2fe$export$3d6c20d97e46b957;
var $fc135142f8b1b2fe$export$9b621391a187a31a;
var $fc135142f8b1b2fe$export$f5bbd400c2f4426f;
"use strict";
var $fc135142f8b1b2fe$var$b = Symbol.for("react.element"), $fc135142f8b1b2fe$var$c = Symbol.for("react.portal"), $fc135142f8b1b2fe$var$d = Symbol.for("react.fragment"), $fc135142f8b1b2fe$var$e = Symbol.for("react.strict_mode"), $fc135142f8b1b2fe$var$f = Symbol.for("react.profiler"), $fc135142f8b1b2fe$var$g = Symbol.for("react.provider"), $fc135142f8b1b2fe$var$h = Symbol.for("react.context"), $fc135142f8b1b2fe$var$k = Symbol.for("react.server_context"), $fc135142f8b1b2fe$var$l = Symbol.for("react.forward_ref"), $fc135142f8b1b2fe$var$m = Symbol.for("react.suspense"), $fc135142f8b1b2fe$var$n = Symbol.for("react.suspense_list"), $fc135142f8b1b2fe$var$p = Symbol.for("react.memo"), $fc135142f8b1b2fe$var$q = Symbol.for("react.lazy"), $fc135142f8b1b2fe$var$t = Symbol.for("react.offscreen"), $fc135142f8b1b2fe$var$u;
$fc135142f8b1b2fe$var$u = Symbol.for("react.module.reference");
function $fc135142f8b1b2fe$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $fc135142f8b1b2fe$var$b:
                switch(a = a.type, a){
                    case $fc135142f8b1b2fe$var$d:
                    case $fc135142f8b1b2fe$var$f:
                    case $fc135142f8b1b2fe$var$e:
                    case $fc135142f8b1b2fe$var$m:
                    case $fc135142f8b1b2fe$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $fc135142f8b1b2fe$var$k:
                            case $fc135142f8b1b2fe$var$h:
                            case $fc135142f8b1b2fe$var$l:
                            case $fc135142f8b1b2fe$var$q:
                            case $fc135142f8b1b2fe$var$p:
                            case $fc135142f8b1b2fe$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $fc135142f8b1b2fe$var$c:
                return r;
        }
    }
}
$fc135142f8b1b2fe$export$a7c73072b1a182ae = $fc135142f8b1b2fe$var$h;
$fc135142f8b1b2fe$export$9f27bc3417b4524d = $fc135142f8b1b2fe$var$g;
$fc135142f8b1b2fe$export$db77ccec0bb4ccac = $fc135142f8b1b2fe$var$b;
$fc135142f8b1b2fe$export$8392c0c9d3dcbd35 = $fc135142f8b1b2fe$var$l;
$fc135142f8b1b2fe$export$ffb0004e005737fa = $fc135142f8b1b2fe$var$d;
$fc135142f8b1b2fe$export$b624eff549462981 = $fc135142f8b1b2fe$var$q;
$fc135142f8b1b2fe$export$7897aa7841a5380c = $fc135142f8b1b2fe$var$p;
$fc135142f8b1b2fe$export$602eac185826482c = $fc135142f8b1b2fe$var$c;
$fc135142f8b1b2fe$export$e2c29f18771995cb = $fc135142f8b1b2fe$var$f;
$fc135142f8b1b2fe$export$5f8d39834fd61797 = $fc135142f8b1b2fe$var$e;
$fc135142f8b1b2fe$export$74bf444e3cd11ea5 = $fc135142f8b1b2fe$var$m;
$fc135142f8b1b2fe$export$998bcd577473dd93 = $fc135142f8b1b2fe$var$n;
$fc135142f8b1b2fe$export$92387174baf9b227 = function() {
    return !1;
};
$fc135142f8b1b2fe$export$ec112efeb987d9c6 = function() {
    return !1;
};
$fc135142f8b1b2fe$export$b706b080d889d2c9 = function(a) {
    return $fc135142f8b1b2fe$var$v(a) === $fc135142f8b1b2fe$var$h;
};
$fc135142f8b1b2fe$export$5be5a87408f70ddc = function(a) {
    return $fc135142f8b1b2fe$var$v(a) === $fc135142f8b1b2fe$var$g;
};
$fc135142f8b1b2fe$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $fc135142f8b1b2fe$var$b;
};
$fc135142f8b1b2fe$export$455c2e768291efa6 = function(a) {
    return $fc135142f8b1b2fe$var$v(a) === $fc135142f8b1b2fe$var$l;
};
$fc135142f8b1b2fe$export$9522e17588c12572 = function(a) {
    return $fc135142f8b1b2fe$var$v(a) === $fc135142f8b1b2fe$var$d;
};
$fc135142f8b1b2fe$export$2110ac352bb060b9 = function(a) {
    return $fc135142f8b1b2fe$var$v(a) === $fc135142f8b1b2fe$var$q;
};
$fc135142f8b1b2fe$export$56885ab8b9c456ab = function(a) {
    return $fc135142f8b1b2fe$var$v(a) === $fc135142f8b1b2fe$var$p;
};
$fc135142f8b1b2fe$export$d927fcb6adf8f9de = function(a) {
    return $fc135142f8b1b2fe$var$v(a) === $fc135142f8b1b2fe$var$c;
};
$fc135142f8b1b2fe$export$b82d16f27459e05a = function(a) {
    return $fc135142f8b1b2fe$var$v(a) === $fc135142f8b1b2fe$var$f;
};
$fc135142f8b1b2fe$export$522c17b4f5e123e8 = function(a) {
    return $fc135142f8b1b2fe$var$v(a) === $fc135142f8b1b2fe$var$e;
};
$fc135142f8b1b2fe$export$1aabd8a0274ecfd6 = function(a) {
    return $fc135142f8b1b2fe$var$v(a) === $fc135142f8b1b2fe$var$m;
};
$fc135142f8b1b2fe$export$3d6c20d97e46b957 = function(a) {
    return $fc135142f8b1b2fe$var$v(a) === $fc135142f8b1b2fe$var$n;
};
$fc135142f8b1b2fe$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $fc135142f8b1b2fe$var$d || a === $fc135142f8b1b2fe$var$f || a === $fc135142f8b1b2fe$var$e || a === $fc135142f8b1b2fe$var$m || a === $fc135142f8b1b2fe$var$n || a === $fc135142f8b1b2fe$var$t || "object" === typeof a && null !== a && (a.$$typeof === $fc135142f8b1b2fe$var$q || a.$$typeof === $fc135142f8b1b2fe$var$p || a.$$typeof === $fc135142f8b1b2fe$var$g || a.$$typeof === $fc135142f8b1b2fe$var$h || a.$$typeof === $fc135142f8b1b2fe$var$l || a.$$typeof === $fc135142f8b1b2fe$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$fc135142f8b1b2fe$export$f5bbd400c2f4426f = $fc135142f8b1b2fe$var$v;

});

parcelRegister("f36CY", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return dateTimestampInSeconds; });
$parcel$export(module.exports, "timestampInSeconds", function () { return timestampInSeconds; });

var $33M0i = parcelRequire("33M0i");

var $lUITW = parcelRequire("lUITW");
// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0, $lUITW.getGlobalObject)();
/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */ /**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ const dateTimestampSource = {
    nowSeconds: ()=>Date.now() / 1000
};
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    const { performance } = WINDOW;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    const timeOrigin = Date.now() - performance.now();
    return {
        now: ()=>performance.now(),
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        const perfHooks = (0, $33M0i.dynamicRequire)(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ const platformPerformance = (0, $33M0i.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
const timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: ()=>(platformPerformance.timeOrigin + platformPerformance.now()) / 1000
};
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */ const usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const browserPerformanceTimeOrigin = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance } = WINDOW;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
})();

});
parcelRegister("33M0i", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });
$parcel$export(module.exports, "dynamicRequire", function () { return dynamicRequire; });

var $h7eDV = parcelRequire("h7eDV");

var $eh5Zb = parcelRequire("eh5Zb");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $h7eDV.isBrowserBundle)() && Object.prototype.toString.call(typeof $eh5Zb !== "undefined" ? $eh5Zb : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("h7eDV", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $c75e72e3080d595f$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $c75e72e3080d595f$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $c75e72e3080d595f$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $c75e72e3080d595f$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("eh5Zb", function(module, exports) {

module.exports = module.exports;

});


parcelRegister("lUITW", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $ff41a86af57da71a$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $ff41a86af57da71a$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $ff41a86af57da71a$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $ff41a86af57da71a$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $ff41a86af57da71a$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $ff41a86af57da71a$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $ff41a86af57da71a$var$isGlobalObj(window) || typeof self == "object" && $ff41a86af57da71a$var$isGlobalObj(self) || typeof $parcel$global == "object" && $ff41a86af57da71a$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $ff41a86af57da71a$export$256479dc0cea61c4() {
    return $ff41a86af57da71a$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $ff41a86af57da71a$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $ff41a86af57da71a$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("i9Ee7", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $1ee7c6831f7c634f$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $1ee7c6831f7c634f$export$2e2bcd8739ae039 = fn;

});

parcelRegister("233YU", function(module, exports) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -
// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
(function(global, module1, define1) {
    function Alea(seed) {
        var me = this, mash = Mash();
        me.next = function() {
            var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
            me.s0 = me.s1;
            me.s1 = me.s2;
            return me.s2 = t - (me.c = t | 0);
        };
        // Apply the seeding algorithm from Baagoe.
        me.c = 1;
        me.s0 = mash(" ");
        me.s1 = mash(" ");
        me.s2 = mash(" ");
        me.s0 -= mash(seed);
        if (me.s0 < 0) me.s0 += 1;
        me.s1 -= mash(seed);
        if (me.s1 < 0) me.s1 += 1;
        me.s2 -= mash(seed);
        if (me.s2 < 0) me.s2 += 1;
        mash = null;
    }
    function copy(f, t) {
        t.c = f.c;
        t.s0 = f.s0;
        t.s1 = f.s1;
        t.s2 = f.s2;
        return t;
    }
    function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
            return xg.next() * 0x100000000 | 0;
        };
        prng.double = function() {
            return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
        };
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = String(data);
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.alea = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("eY8Tu", function(module, exports) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x << 11;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            return me.w ^= me.w >>> 19 ^ t ^ t >>> 8;
        };
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor128 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("7Uslr", function(module, exports) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x >>> 2;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            me.w = me.v;
            return (me.d = me.d + 362437 | 0) + (me.v = me.v ^ me.v << 4 ^ (t ^ t << 1)) | 0;
        };
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        me.v = 0;
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            if (k == strseed.length) me.d = me.x << 10 ^ me.x >>> 4;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        t.v = f.v;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorwow = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("fKOPV", function(module, exports) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            // Update xor generator.
            var X = me.x, i = me.i, t, v, w;
            t = X[i];
            t ^= t >>> 7;
            v = t ^ t << 24;
            t = X[i + 1 & 7];
            v ^= t ^ t >>> 10;
            t = X[i + 3 & 7];
            v ^= t ^ t >>> 3;
            t = X[i + 4 & 7];
            v ^= t ^ t << 7;
            t = X[i + 7 & 7];
            t = t ^ t << 13;
            v ^= t ^ t << 9;
            X[i] = v;
            me.i = i + 1 & 7;
            return v;
        };
        function init(me, seed) {
            var j, w, X = [];
            if (seed === (seed | 0)) // Seed state array using a 32-bit integer.
            w = X[0] = seed;
            else {
                // Seed state using a string.
                seed = "" + seed;
                for(j = 0; j < seed.length; ++j)X[j & 7] = X[j & 7] << 15 ^ seed.charCodeAt(j) + X[j + 1 & 7] << 13;
            }
            // Enforce an array length of 8, not all zeroes.
            while(X.length < 8)X.push(0);
            for(j = 0; j < 8 && X[j] === 0; ++j);
            if (j == 8) w = X[7] = -1;
            else w = X[j];
            me.x = X;
            me.i = 0;
            // Discard an initial 256 values.
            for(j = 256; j > 0; --j)me.next();
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.x = f.x.slice();
        t.i = f.i;
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.x) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorshift7 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("8fzIh", function(module, exports) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            var w = me.w, X = me.X, i = me.i, t, v;
            // Update Weyl generator.
            me.w = w = w + 0x61c88647 | 0;
            // Update xor generator.
            v = X[i + 34 & 127];
            t = X[i = i + 1 & 127];
            v ^= v << 13;
            t ^= t << 17;
            v ^= v >>> 15;
            t ^= t >>> 12;
            // Update Xor generator array state.
            v = X[i] = v ^ t;
            me.i = i;
            // Result is the combination.
            return v + (w ^ w >>> 16) | 0;
        };
        function init(me, seed) {
            var t, v, i, j, w, X = [], limit = 128;
            if (seed === (seed | 0)) {
                // Numeric seeds initialize v, which is used to generates X.
                v = seed;
                seed = null;
            } else {
                // String seeds are mixed into v and X one character at a time.
                seed = seed + "\x00";
                v = 0;
                limit = Math.max(limit, seed.length);
            }
            // Initialize circular array and weyl value.
            for(i = 0, j = -32; j < limit; ++j){
                // Put the unicode characters into the array, and shuffle them.
                if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
                // After 32 shuffles, take v as the starting w value.
                if (j === 0) w = v;
                v ^= v << 10;
                v ^= v >>> 15;
                v ^= v << 4;
                v ^= v >>> 13;
                if (j >= 0) {
                    w = w + 0x61c88647 | 0; // Weyl.
                    t = X[j & 127] ^= v + w; // Combine xor and weyl to init array.
                    i = 0 == t ? i + 1 : 0; // Count zeroes.
                }
            }
            // We have detected all zeroes; make the key nonzero.
            if (i >= 128) X[(seed && seed.length || 0) & 127] = -1;
            // Run the generator 512 times to further mix the state before using it.
            // Factoring this as a function slows the main generator, so it is just
            // unrolled here.  The weyl generator is not advanced while warming up.
            i = 127;
            for(j = 512; j > 0; --j){
                v = X[i + 34 & 127];
                t = X[i = i + 1 & 127];
                v ^= v << 13;
                t ^= t << 17;
                v ^= v >>> 15;
                t ^= t >>> 12;
                X[i] = v ^ t;
            }
            // Storing state as object members is faster than using closure variables.
            me.w = w;
            me.X = X;
            me.i = i;
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.i = f.i;
        t.w = f.w;
        t.X = f.X.slice();
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.X) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor4096 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("iVcM8", function(module, exports) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        // Set up generator function.
        me.next = function() {
            var b = me.b, c = me.c, d = me.d, a = me.a;
            b = b << 25 ^ b >>> 7 ^ c;
            c = c - d | 0;
            d = d << 24 ^ d >>> 8 ^ a;
            a = a - b | 0;
            me.b = b = b << 20 ^ b >>> 12 ^ c;
            me.c = c = c - d | 0;
            me.d = d << 16 ^ c >>> 16 ^ a;
            return me.a = a - b | 0;
        };
        /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */ me.a = 0;
        me.b = 0;
        me.c = -1640531527;
        me.d = 1367130551;
        if (seed === Math.floor(seed)) {
            // Integer seed.
            me.a = seed / 0x100000000 | 0;
            me.b = seed | 0;
        } else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 20; k++){
            me.b ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.a = f.a;
        t.b = f.b;
        t.c = f.c;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.tychei = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("bBs1K", function(module, exports) {
"use strict";

});

parcelRegister("eVtUR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eIwgG = parcelRequire("eIwgG");

var $addd984b040eafce$var$React = $eIwgG.__importStar((parcelRequire("4DE7A")));

var $a1NwE = parcelRequire("a1NwE");

var $31FDS = parcelRequire("31FDS");
function $addd984b040eafce$var$useIntl() {
    var intl = $addd984b040eafce$var$React.useContext($a1NwE.Context);
    (0, $31FDS.invariantIntlContext)(intl);
    return intl;
}
module.exports.default = $addd984b040eafce$var$useIntl;

});
parcelRegister("eIwgG", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $75d0c6a85d8a06c0$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $75d0c6a85d8a06c0$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $75d0c6a85d8a06c0$export$3c9a16f847548506; });
$parcel$export(module.exports, "__exportStar", function () { return $75d0c6a85d8a06c0$export$f33643c0debef087; });
$parcel$export(module.exports, "__spreadArray", function () { return $75d0c6a85d8a06c0$export$1216008129fb82ed; });
$parcel$export(module.exports, "__importStar", function () { return $75d0c6a85d8a06c0$export$c21735bcef00d192; });
$parcel$export(module.exports, "__importDefault", function () { return $75d0c6a85d8a06c0$export$da59b14a69baef04; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $75d0c6a85d8a06c0$var$extendStatics = function(d, b) {
    $75d0c6a85d8a06c0$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $75d0c6a85d8a06c0$var$extendStatics(d, b);
};
function $75d0c6a85d8a06c0$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $75d0c6a85d8a06c0$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $75d0c6a85d8a06c0$export$18ce0697a983be9b = function() {
    $75d0c6a85d8a06c0$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $75d0c6a85d8a06c0$export$18ce0697a983be9b.apply(this, arguments);
};
function $75d0c6a85d8a06c0$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $75d0c6a85d8a06c0$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $75d0c6a85d8a06c0$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $75d0c6a85d8a06c0$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $75d0c6a85d8a06c0$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $75d0c6a85d8a06c0$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $75d0c6a85d8a06c0$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $75d0c6a85d8a06c0$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $75d0c6a85d8a06c0$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $75d0c6a85d8a06c0$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $75d0c6a85d8a06c0$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $75d0c6a85d8a06c0$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $75d0c6a85d8a06c0$export$45d3717a4c69092e(o, m, p);
}
function $75d0c6a85d8a06c0$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $75d0c6a85d8a06c0$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $75d0c6a85d8a06c0$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($75d0c6a85d8a06c0$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $75d0c6a85d8a06c0$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $75d0c6a85d8a06c0$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $75d0c6a85d8a06c0$export$10c90e4f7922046c(v) {
    return this instanceof $75d0c6a85d8a06c0$export$10c90e4f7922046c ? (this.v = v, this) : new $75d0c6a85d8a06c0$export$10c90e4f7922046c(v);
}
function $75d0c6a85d8a06c0$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $75d0c6a85d8a06c0$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $75d0c6a85d8a06c0$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $75d0c6a85d8a06c0$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $75d0c6a85d8a06c0$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $75d0c6a85d8a06c0$export$19a8beecd37a4c45 === "function" ? $75d0c6a85d8a06c0$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $75d0c6a85d8a06c0$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $75d0c6a85d8a06c0$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $75d0c6a85d8a06c0$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $75d0c6a85d8a06c0$export$45d3717a4c69092e(result, mod, k);
    }
    $75d0c6a85d8a06c0$var$__setModuleDefault(result, mod);
    return result;
}
function $75d0c6a85d8a06c0$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $75d0c6a85d8a06c0$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $75d0c6a85d8a06c0$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $75d0c6a85d8a06c0$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $75d0c6a85d8a06c0$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $75d0c6a85d8a06c0$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $75d0c6a85d8a06c0$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $75d0c6a85d8a06c0$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $75d0c6a85d8a06c0$export$2e2bcd8739ae039 = {
    __extends: $75d0c6a85d8a06c0$export$a8ba968b8961cb8a,
    __assign: $75d0c6a85d8a06c0$export$18ce0697a983be9b,
    __rest: $75d0c6a85d8a06c0$export$3c9a16f847548506,
    __decorate: $75d0c6a85d8a06c0$export$29e00dfd3077644b,
    __param: $75d0c6a85d8a06c0$export$d5ad3fd78186038f,
    __metadata: $75d0c6a85d8a06c0$export$f1db080c865becb9,
    __awaiter: $75d0c6a85d8a06c0$export$1050f835b63b671e,
    __generator: $75d0c6a85d8a06c0$export$67ebef60e6f28a6,
    __createBinding: $75d0c6a85d8a06c0$export$45d3717a4c69092e,
    __exportStar: $75d0c6a85d8a06c0$export$f33643c0debef087,
    __values: $75d0c6a85d8a06c0$export$19a8beecd37a4c45,
    __read: $75d0c6a85d8a06c0$export$8d051b38c9118094,
    __spread: $75d0c6a85d8a06c0$export$afc72e2116322959,
    __spreadArrays: $75d0c6a85d8a06c0$export$6388937ca91ccae8,
    __spreadArray: $75d0c6a85d8a06c0$export$1216008129fb82ed,
    __await: $75d0c6a85d8a06c0$export$10c90e4f7922046c,
    __asyncGenerator: $75d0c6a85d8a06c0$export$e427f37a30a4de9b,
    __asyncDelegator: $75d0c6a85d8a06c0$export$bbd80228419bb833,
    __asyncValues: $75d0c6a85d8a06c0$export$e3b29a3d6162315f,
    __makeTemplateObject: $75d0c6a85d8a06c0$export$4fb47efe1390b86f,
    __importStar: $75d0c6a85d8a06c0$export$c21735bcef00d192,
    __importDefault: $75d0c6a85d8a06c0$export$da59b14a69baef04,
    __classPrivateFieldGet: $75d0c6a85d8a06c0$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $75d0c6a85d8a06c0$export$d40a35129aaff81f,
    __classPrivateFieldIn: $75d0c6a85d8a06c0$export$81fdc39f203e4e04,
    __addDisposableResource: $75d0c6a85d8a06c0$export$88ac25d8e944e405,
    __disposeResources: $75d0c6a85d8a06c0$export$8f076105dc360e92
};

});

parcelRegister("a1NwE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Context = module.exports.Provider = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $74d06a28a69491b5$var$React = $eIwgG.__importStar((parcelRequire("4DE7A")));

var $74d06a28a69491b5$var$hoist_non_react_statics_1 = $eIwgG.__importDefault((parcelRequire("34Pgq")));

var $31FDS = parcelRequire("31FDS");
function $74d06a28a69491b5$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $74d06a28a69491b5$var$IntlContext = typeof window !== "undefined" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $74d06a28a69491b5$var$React.createContext(null)) : $74d06a28a69491b5$var$React.createContext(null);
var $74d06a28a69491b5$var$IntlConsumer = $74d06a28a69491b5$var$IntlContext.Consumer, $74d06a28a69491b5$var$IntlProvider = $74d06a28a69491b5$var$IntlContext.Provider;
module.exports.Provider = $74d06a28a69491b5$var$IntlProvider;
module.exports.Context = $74d06a28a69491b5$var$IntlContext;
function $74d06a28a69491b5$var$injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $74d06a28a69491b5$var$React.createElement($74d06a28a69491b5$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $31FDS.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $74d06a28a69491b5$var$React.createElement(WrappedComponent, $eIwgG.__assign({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($74d06a28a69491b5$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, $74d06a28a69491b5$var$hoist_non_react_statics_1.default)($74d06a28a69491b5$var$React.forwardRef(function(props, ref) {
        return $74d06a28a69491b5$var$React.createElement(WithIntl, $eIwgG.__assign({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, $74d06a28a69491b5$var$hoist_non_react_statics_1.default)(WithIntl, WrappedComponent);
}
module.exports.default = $74d06a28a69491b5$var$injectIntl;

});
parcelRegister("31FDS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shallowEqual = module.exports.assignUniqueKeysToParts = module.exports.DEFAULT_INTL_CONFIG = module.exports.invariantIntlContext = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $2341c45e4dc8906d$var$React = $eIwgG.__importStar((parcelRequire("4DE7A")));

var $3gtsi = parcelRequire("3gtsi");

var $6RKOV = parcelRequire("6RKOV");
function $2341c45e4dc8906d$var$invariantIntlContext(intl) {
    (0, $3gtsi.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
module.exports.invariantIntlContext = $2341c45e4dc8906d$var$invariantIntlContext;
module.exports.DEFAULT_INTL_CONFIG = $eIwgG.__assign($eIwgG.__assign({}, $6RKOV.DEFAULT_INTL_CONFIG), {
    textComponent: $2341c45e4dc8906d$var$React.Fragment
});
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */ function $2341c45e4dc8906d$var$assignUniqueKeysToParts(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($2341c45e4dc8906d$var$React.Children.toArray(parts));
    };
}
module.exports.assignUniqueKeysToParts = $2341c45e4dc8906d$var$assignUniqueKeysToParts;
function $2341c45e4dc8906d$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
module.exports.shallowEqual = $2341c45e4dc8906d$var$shallowEqual;

});
parcelRegister("3gtsi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.invariant = module.exports.isMissingLocaleDataError = module.exports.defineProperty = module.exports.getMagnitude = module.exports.setMultiInternalSlots = module.exports.setInternalSlot = module.exports.isLiteralPart = module.exports.getMultiInternalSlots = module.exports.getInternalSlot = module.exports._formatToParts = void 0;

var $eIwgG = parcelRequire("eIwgG");

$eIwgG.__exportStar((parcelRequire("1nC8W")), module.exports);

$eIwgG.__exportStar((parcelRequire("16UgM")), module.exports);

$eIwgG.__exportStar((parcelRequire("haz9y")), module.exports);

$eIwgG.__exportStar((parcelRequire("7ZXeE")), module.exports);

$eIwgG.__exportStar((parcelRequire("iQ9Nx")), module.exports);

$eIwgG.__exportStar((parcelRequire("3fDvl")), module.exports);

$eIwgG.__exportStar((parcelRequire("dRPEu")), module.exports);

$eIwgG.__exportStar((parcelRequire("ff07o")), module.exports);

$eIwgG.__exportStar((parcelRequire("1zpTg")), module.exports);

$eIwgG.__exportStar((parcelRequire("bsbpg")), module.exports);

$eIwgG.__exportStar((parcelRequire("kUv4V")), module.exports);

$eIwgG.__exportStar((parcelRequire("cSwAp")), module.exports);

$eIwgG.__exportStar((parcelRequire("I0nxD")), module.exports);

$eIwgG.__exportStar((parcelRequire("bxIII")), module.exports);

$eIwgG.__exportStar((parcelRequire("6UqOf")), module.exports);

$eIwgG.__exportStar((parcelRequire("3sO81")), module.exports);

$eIwgG.__exportStar((parcelRequire("5giPY")), module.exports);

$eIwgG.__exportStar((parcelRequire("cPN6h")), module.exports);

$eIwgG.__exportStar((parcelRequire("9nsc6")), module.exports);

$eIwgG.__exportStar((parcelRequire("4x8kW")), module.exports);

$eIwgG.__exportStar((parcelRequire("jlJUB")), module.exports);

$eIwgG.__exportStar((parcelRequire("cvmB1")), module.exports);

$eIwgG.__exportStar((parcelRequire("ew2yd")), module.exports);

$eIwgG.__exportStar((parcelRequire("8gDXg")), module.exports);

$eIwgG.__exportStar((parcelRequire("ePJzc")), module.exports);

$eIwgG.__exportStar((parcelRequire("8tfDO")), module.exports);

$eIwgG.__exportStar((parcelRequire("i0NhQ")), module.exports);

$eIwgG.__exportStar((parcelRequire("GAvbb")), module.exports);

$eIwgG.__exportStar((parcelRequire("llqeG")), module.exports);

var $cynBD = parcelRequire("cynBD");
Object.defineProperty(module.exports, "_formatToParts", {
    enumerable: true,
    get: function() {
        return $eIwgG.__importDefault($cynBD).default;
    }
});

$eIwgG.__exportStar((parcelRequire("2LV04")), module.exports);

$eIwgG.__exportStar((parcelRequire("imLer")), module.exports);

var $eTSkB = parcelRequire("eTSkB");
Object.defineProperty(module.exports, "getInternalSlot", {
    enumerable: true,
    get: function() {
        return $eTSkB.getInternalSlot;
    }
});
Object.defineProperty(module.exports, "getMultiInternalSlots", {
    enumerable: true,
    get: function() {
        return $eTSkB.getMultiInternalSlots;
    }
});
Object.defineProperty(module.exports, "isLiteralPart", {
    enumerable: true,
    get: function() {
        return $eTSkB.isLiteralPart;
    }
});
Object.defineProperty(module.exports, "setInternalSlot", {
    enumerable: true,
    get: function() {
        return $eTSkB.setInternalSlot;
    }
});
Object.defineProperty(module.exports, "setMultiInternalSlots", {
    enumerable: true,
    get: function() {
        return $eTSkB.setMultiInternalSlots;
    }
});
Object.defineProperty(module.exports, "getMagnitude", {
    enumerable: true,
    get: function() {
        return $eTSkB.getMagnitude;
    }
});
Object.defineProperty(module.exports, "defineProperty", {
    enumerable: true,
    get: function() {
        return $eTSkB.defineProperty;
    }
});

var $bB2lu = parcelRequire("bB2lu");
Object.defineProperty(module.exports, "isMissingLocaleDataError", {
    enumerable: true,
    get: function() {
        return $bB2lu.isMissingLocaleDataError;
    }
});

$eIwgG.__exportStar((parcelRequire("34sz3")), module.exports);

$eIwgG.__exportStar((parcelRequire("5UwTC")), module.exports);

$eIwgG.__exportStar((parcelRequire("MgHgJ")), module.exports);

$eIwgG.__exportStar((parcelRequire("4DL3u")), module.exports);

$eIwgG.__exportStar((parcelRequire("8FDFF")), module.exports);

$eIwgG.__exportStar((parcelRequire("9HJ30")), module.exports);

var $eTSkB = parcelRequire("eTSkB");
Object.defineProperty(module.exports, "invariant", {
    enumerable: true,
    get: function() {
        return $eTSkB.invariant;
    }
});

$eIwgG.__exportStar((parcelRequire("itFDr")), module.exports);

});
parcelRegister("1nC8W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CanonicalizeLocaleList = void 0;
/**
 * http://ecma-international.org/ecma-402/7.0/index.html#sec-canonicalizelocalelist
 * @param locales
 */ function $101586daf38680bc$var$CanonicalizeLocaleList(locales) {
    // TODO
    return Intl.getCanonicalLocales(locales);
}
module.exports.CanonicalizeLocaleList = $101586daf38680bc$var$CanonicalizeLocaleList;

});

parcelRegister("16UgM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CanonicalizeTimeZoneName = void 0;
/**
 * https://tc39.es/ecma402/#sec-canonicalizetimezonename
 * @param tz
 */ function $0cf1fff6637b8c7b$var$CanonicalizeTimeZoneName(tz, _a) {
    var tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
    var uppercasedTz = tz.toUpperCase();
    var uppercasedZones = Object.keys(tzData).reduce(function(all, z) {
        all[z.toUpperCase()] = z;
        return all;
    }, {});
    var ianaTimeZone = uppercaseLinks[uppercasedTz] || uppercasedZones[uppercasedTz];
    if (ianaTimeZone === "Etc/UTC" || ianaTimeZone === "Etc/GMT") return "UTC";
    return ianaTimeZone;
}
module.exports.CanonicalizeTimeZoneName = $0cf1fff6637b8c7b$var$CanonicalizeTimeZoneName;

});

parcelRegister("haz9y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoerceOptionsToObject = void 0;

var $itFDr = parcelRequire("itFDr");
/**
 * https://tc39.es/ecma402/#sec-coerceoptionstoobject
 * @param options
 * @returns
 */ function $c7fea37ed7f3147b$var$CoerceOptionsToObject(options) {
    if (typeof options === "undefined") return Object.create(null);
    return (0, $itFDr.ToObject)(options);
}
module.exports.CoerceOptionsToObject = $c7fea37ed7f3147b$var$CoerceOptionsToObject;

});
parcelRegister("itFDr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.msFromTime = module.exports.OrdinaryHasInstance = module.exports.SecFromTime = module.exports.MinFromTime = module.exports.HourFromTime = module.exports.DateFromTime = module.exports.MonthFromTime = module.exports.InLeapYear = module.exports.DayWithinYear = module.exports.DaysInYear = module.exports.YearFromTime = module.exports.TimeFromYear = module.exports.DayFromYear = module.exports.WeekDay = module.exports.Day = module.exports.Type = module.exports.HasOwnProperty = module.exports.ArrayCreate = module.exports.SameValue = module.exports.ToObject = module.exports.TimeClip = module.exports.ToNumber = module.exports.ToString = void 0;
/**
 * https://tc39.es/ecma262/#sec-tostring
 */ function $d73b3b4e80aa1053$var$ToString(o) {
    // Only symbol is irregular...
    if (typeof o === "symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return String(o);
}
module.exports.ToString = $d73b3b4e80aa1053$var$ToString;
/**
 * https://tc39.es/ecma262/#sec-tonumber
 * @param val
 */ function $d73b3b4e80aa1053$var$ToNumber(val) {
    if (val === undefined) return NaN;
    if (val === null) return 0;
    if (typeof val === "boolean") return val ? 1 : 0;
    if (typeof val === "number") return val;
    if (typeof val === "symbol" || typeof val === "bigint") throw new TypeError("Cannot convert symbol/bigint to number");
    return Number(val);
}
module.exports.ToNumber = $d73b3b4e80aa1053$var$ToNumber;
/**
 * https://tc39.es/ecma262/#sec-tointeger
 * @param n
 */ function $d73b3b4e80aa1053$var$ToInteger(n) {
    var number = $d73b3b4e80aa1053$var$ToNumber(n);
    if (isNaN(number) || $d73b3b4e80aa1053$var$SameValue(number, -0)) return 0;
    if (isFinite(number)) return number;
    var integer = Math.floor(Math.abs(number));
    if (number < 0) integer = -integer;
    if ($d73b3b4e80aa1053$var$SameValue(integer, -0)) return 0;
    return integer;
}
/**
 * https://tc39.es/ecma262/#sec-timeclip
 * @param time
 */ function $d73b3b4e80aa1053$var$TimeClip(time) {
    if (!isFinite(time)) return NaN;
    if (Math.abs(time) > 8.64 * 1e15) return NaN;
    return $d73b3b4e80aa1053$var$ToInteger(time);
}
module.exports.TimeClip = $d73b3b4e80aa1053$var$TimeClip;
/**
 * https://tc39.es/ecma262/#sec-toobject
 * @param arg
 */ function $d73b3b4e80aa1053$var$ToObject(arg) {
    if (arg == null) throw new TypeError("undefined/null cannot be converted to object");
    return Object(arg);
}
module.exports.ToObject = $d73b3b4e80aa1053$var$ToObject;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-samevalue
 * @param x
 * @param y
 */ function $d73b3b4e80aa1053$var$SameValue(x, y) {
    if (Object.is) return Object.is(x, y);
    // SameValue algorithm
    if (x === y) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return x !== 0 || 1 / x === 1 / y;
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
}
module.exports.SameValue = $d73b3b4e80aa1053$var$SameValue;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-arraycreate
 * @param len
 */ function $d73b3b4e80aa1053$var$ArrayCreate(len) {
    return new Array(len);
}
module.exports.ArrayCreate = $d73b3b4e80aa1053$var$ArrayCreate;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-hasownproperty
 * @param o
 * @param prop
 */ function $d73b3b4e80aa1053$var$HasOwnProperty(o, prop) {
    return Object.prototype.hasOwnProperty.call(o, prop);
}
module.exports.HasOwnProperty = $d73b3b4e80aa1053$var$HasOwnProperty;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-type
 * @param x
 */ function $d73b3b4e80aa1053$var$Type(x) {
    if (x === null) return "Null";
    if (typeof x === "undefined") return "Undefined";
    if (typeof x === "function" || typeof x === "object") return "Object";
    if (typeof x === "number") return "Number";
    if (typeof x === "boolean") return "Boolean";
    if (typeof x === "string") return "String";
    if (typeof x === "symbol") return "Symbol";
    if (typeof x === "bigint") return "BigInt";
}
module.exports.Type = $d73b3b4e80aa1053$var$Type;
var $d73b3b4e80aa1053$var$MS_PER_DAY = 86400000;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#eqn-modulo
 * @param x
 * @param y
 * @return k of the same sign as y
 */ function $d73b3b4e80aa1053$var$mod(x, y) {
    return x - Math.floor(x / y) * y;
}
/**
 * https://tc39.es/ecma262/#eqn-Day
 * @param t
 */ function $d73b3b4e80aa1053$var$Day(t) {
    return Math.floor(t / $d73b3b4e80aa1053$var$MS_PER_DAY);
}
module.exports.Day = $d73b3b4e80aa1053$var$Day;
/**
 * https://tc39.es/ecma262/#sec-week-day
 * @param t
 */ function $d73b3b4e80aa1053$var$WeekDay(t) {
    return $d73b3b4e80aa1053$var$mod($d73b3b4e80aa1053$var$Day(t) + 4, 7);
}
module.exports.WeekDay = $d73b3b4e80aa1053$var$WeekDay;
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param y
 */ function $d73b3b4e80aa1053$var$DayFromYear(y) {
    return Date.UTC(y, 0) / $d73b3b4e80aa1053$var$MS_PER_DAY;
}
module.exports.DayFromYear = $d73b3b4e80aa1053$var$DayFromYear;
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param y
 */ function $d73b3b4e80aa1053$var$TimeFromYear(y) {
    return Date.UTC(y, 0);
}
module.exports.TimeFromYear = $d73b3b4e80aa1053$var$TimeFromYear;
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param t
 */ function $d73b3b4e80aa1053$var$YearFromTime(t) {
    return new Date(t).getUTCFullYear();
}
module.exports.YearFromTime = $d73b3b4e80aa1053$var$YearFromTime;
function $d73b3b4e80aa1053$var$DaysInYear(y) {
    if (y % 4 !== 0) return 365;
    if (y % 100 !== 0) return 366;
    if (y % 400 !== 0) return 365;
    return 366;
}
module.exports.DaysInYear = $d73b3b4e80aa1053$var$DaysInYear;
function $d73b3b4e80aa1053$var$DayWithinYear(t) {
    return $d73b3b4e80aa1053$var$Day(t) - $d73b3b4e80aa1053$var$DayFromYear($d73b3b4e80aa1053$var$YearFromTime(t));
}
module.exports.DayWithinYear = $d73b3b4e80aa1053$var$DayWithinYear;
function $d73b3b4e80aa1053$var$InLeapYear(t) {
    return $d73b3b4e80aa1053$var$DaysInYear($d73b3b4e80aa1053$var$YearFromTime(t)) === 365 ? 0 : 1;
}
module.exports.InLeapYear = $d73b3b4e80aa1053$var$InLeapYear;
/**
 * https://tc39.es/ecma262/#sec-month-number
 * @param t
 */ function $d73b3b4e80aa1053$var$MonthFromTime(t) {
    var dwy = $d73b3b4e80aa1053$var$DayWithinYear(t);
    var leap = $d73b3b4e80aa1053$var$InLeapYear(t);
    if (dwy >= 0 && dwy < 31) return 0;
    if (dwy < 59 + leap) return 1;
    if (dwy < 90 + leap) return 2;
    if (dwy < 120 + leap) return 3;
    if (dwy < 151 + leap) return 4;
    if (dwy < 181 + leap) return 5;
    if (dwy < 212 + leap) return 6;
    if (dwy < 243 + leap) return 7;
    if (dwy < 273 + leap) return 8;
    if (dwy < 304 + leap) return 9;
    if (dwy < 334 + leap) return 10;
    if (dwy < 365 + leap) return 11;
    throw new Error("Invalid time");
}
module.exports.MonthFromTime = $d73b3b4e80aa1053$var$MonthFromTime;
function $d73b3b4e80aa1053$var$DateFromTime(t) {
    var dwy = $d73b3b4e80aa1053$var$DayWithinYear(t);
    var mft = $d73b3b4e80aa1053$var$MonthFromTime(t);
    var leap = $d73b3b4e80aa1053$var$InLeapYear(t);
    if (mft === 0) return dwy + 1;
    if (mft === 1) return dwy - 30;
    if (mft === 2) return dwy - 58 - leap;
    if (mft === 3) return dwy - 89 - leap;
    if (mft === 4) return dwy - 119 - leap;
    if (mft === 5) return dwy - 150 - leap;
    if (mft === 6) return dwy - 180 - leap;
    if (mft === 7) return dwy - 211 - leap;
    if (mft === 8) return dwy - 242 - leap;
    if (mft === 9) return dwy - 272 - leap;
    if (mft === 10) return dwy - 303 - leap;
    if (mft === 11) return dwy - 333 - leap;
    throw new Error("Invalid time");
}
module.exports.DateFromTime = $d73b3b4e80aa1053$var$DateFromTime;
var $d73b3b4e80aa1053$var$HOURS_PER_DAY = 24;
var $d73b3b4e80aa1053$var$MINUTES_PER_HOUR = 60;
var $d73b3b4e80aa1053$var$SECONDS_PER_MINUTE = 60;
var $d73b3b4e80aa1053$var$MS_PER_SECOND = 1e3;
var $d73b3b4e80aa1053$var$MS_PER_MINUTE = $d73b3b4e80aa1053$var$MS_PER_SECOND * $d73b3b4e80aa1053$var$SECONDS_PER_MINUTE;
var $d73b3b4e80aa1053$var$MS_PER_HOUR = $d73b3b4e80aa1053$var$MS_PER_MINUTE * $d73b3b4e80aa1053$var$MINUTES_PER_HOUR;
function $d73b3b4e80aa1053$var$HourFromTime(t) {
    return $d73b3b4e80aa1053$var$mod(Math.floor(t / $d73b3b4e80aa1053$var$MS_PER_HOUR), $d73b3b4e80aa1053$var$HOURS_PER_DAY);
}
module.exports.HourFromTime = $d73b3b4e80aa1053$var$HourFromTime;
function $d73b3b4e80aa1053$var$MinFromTime(t) {
    return $d73b3b4e80aa1053$var$mod(Math.floor(t / $d73b3b4e80aa1053$var$MS_PER_MINUTE), $d73b3b4e80aa1053$var$MINUTES_PER_HOUR);
}
module.exports.MinFromTime = $d73b3b4e80aa1053$var$MinFromTime;
function $d73b3b4e80aa1053$var$SecFromTime(t) {
    return $d73b3b4e80aa1053$var$mod(Math.floor(t / $d73b3b4e80aa1053$var$MS_PER_SECOND), $d73b3b4e80aa1053$var$SECONDS_PER_MINUTE);
}
module.exports.SecFromTime = $d73b3b4e80aa1053$var$SecFromTime;
function $d73b3b4e80aa1053$var$IsCallable(fn) {
    return typeof fn === "function";
}
/**
 * The abstract operation OrdinaryHasInstance implements
 * the default algorithm for determining if an object O
 * inherits from the instance object inheritance path
 * provided by constructor C.
 * @param C class
 * @param O object
 * @param internalSlots internalSlots
 */ function $d73b3b4e80aa1053$var$OrdinaryHasInstance(C, O, internalSlots) {
    if (!$d73b3b4e80aa1053$var$IsCallable(C)) return false;
    if (internalSlots === null || internalSlots === void 0 ? void 0 : internalSlots.boundTargetFunction) {
        var BC = internalSlots === null || internalSlots === void 0 ? void 0 : internalSlots.boundTargetFunction;
        return O instanceof BC;
    }
    if (typeof O !== "object") return false;
    var P = C.prototype;
    if (typeof P !== "object") throw new TypeError("OrdinaryHasInstance called on an object with an invalid prototype property.");
    return Object.prototype.isPrototypeOf.call(P, O);
}
module.exports.OrdinaryHasInstance = $d73b3b4e80aa1053$var$OrdinaryHasInstance;
function $d73b3b4e80aa1053$var$msFromTime(t) {
    return $d73b3b4e80aa1053$var$mod(t, $d73b3b4e80aa1053$var$MS_PER_SECOND);
}
module.exports.msFromTime = $d73b3b4e80aa1053$var$msFromTime;

});


parcelRegister("7ZXeE", function(module, exports) {
"use strict";
/**
 * https://tc39.es/ecma402/#sec-getnumberoption
 * @param options
 * @param property
 * @param min
 * @param max
 * @param fallback
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetNumberOption = void 0;

var $10Xw3 = parcelRequire("10Xw3");
function $5d2c2dcda165e81b$var$GetNumberOption(options, property, minimum, maximum, fallback) {
    var val = options[property];
    // @ts-expect-error
    return (0, $10Xw3.DefaultNumberOption)(val, minimum, maximum, fallback);
}
module.exports.GetNumberOption = $5d2c2dcda165e81b$var$GetNumberOption;

});
parcelRegister("10Xw3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultNumberOption = void 0;
function $0bd3f52cd2eaf215$var$DefaultNumberOption(val, min, max, fallback) {
    if (val !== undefined) {
        val = Number(val);
        if (isNaN(val) || val < min || val > max) throw new RangeError("".concat(val, " is outside of range [").concat(min, ", ").concat(max, "]"));
        return Math.floor(val);
    }
    return fallback;
}
module.exports.DefaultNumberOption = $0bd3f52cd2eaf215$var$DefaultNumberOption;

});


parcelRegister("iQ9Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetOption = void 0;

var $itFDr = parcelRequire("itFDr");
/**
 * https://tc39.es/ecma402/#sec-getoption
 * @param opts
 * @param prop
 * @param type
 * @param values
 * @param fallback
 */ function $db74af068e160848$var$GetOption(opts, prop, type, values, fallback) {
    if (typeof opts !== "object") throw new TypeError("Options must be an object");
    var value = opts[prop];
    if (value !== undefined) {
        if (type !== "boolean" && type !== "string") throw new TypeError("invalid type");
        if (type === "boolean") value = Boolean(value);
        if (type === "string") value = (0, $itFDr.ToString)(value);
        if (values !== undefined && !values.filter(function(val) {
            return val == value;
        }).length) throw new RangeError("".concat(value, " is not within ").concat(values.join(", ")));
        return value;
    }
    return fallback;
}
module.exports.GetOption = $db74af068e160848$var$GetOption;

});

parcelRegister("3fDvl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetOptionsObject = void 0;
/**
 * https://tc39.es/ecma402/#sec-getoptionsobject
 * @param options
 * @returns
 */ function $25e16a941d151230$var$GetOptionsObject(options) {
    if (typeof options === "undefined") return Object.create(null);
    if (typeof options === "object") return options;
    throw new TypeError("Options must be an object");
}
module.exports.GetOptionsObject = $25e16a941d151230$var$GetOptionsObject;

});

parcelRegister("dRPEu", function(module, exports) {
"use strict";
/**
 * https://tc39.es/ecma402/#sec-getstringorbooleanoption
 * @param opts
 * @param prop
 * @param values
 * @param trueValue
 * @param falsyValue
 * @param fallback
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetStringOrBooleanOption = void 0;

var $itFDr = parcelRequire("itFDr");
function $a1884a9cecf1516a$var$GetStringOrBooleanOption(opts, prop, values, trueValue, falsyValue, fallback) {
    var value = opts[prop];
    if (value === undefined) return fallback;
    if (value === true) return trueValue;
    var valueBoolean = Boolean(value);
    if (valueBoolean === false) return falsyValue;
    value = (0, $itFDr.ToString)(value);
    if (value === "true" || value === "false") return fallback;
    if ((values || []).indexOf(value) === -1) throw new RangeError("Invalid value ".concat(value));
    return value;
}
module.exports.GetStringOrBooleanOption = $a1884a9cecf1516a$var$GetStringOrBooleanOption;

});

parcelRegister("ff07o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsSanctionedSimpleUnitIdentifier = module.exports.SIMPLE_UNITS = module.exports.removeUnitNamespace = module.exports.SANCTIONED_UNITS = void 0;
/**
 * https://tc39.es/ecma402/#table-sanctioned-simple-unit-identifiers
 */ module.exports.SANCTIONED_UNITS = [
    "angle-degree",
    "area-acre",
    "area-hectare",
    "concentr-percent",
    "digital-bit",
    "digital-byte",
    "digital-gigabit",
    "digital-gigabyte",
    "digital-kilobit",
    "digital-kilobyte",
    "digital-megabit",
    "digital-megabyte",
    "digital-petabyte",
    "digital-terabit",
    "digital-terabyte",
    "duration-day",
    "duration-hour",
    "duration-millisecond",
    "duration-minute",
    "duration-month",
    "duration-second",
    "duration-week",
    "duration-year",
    "length-centimeter",
    "length-foot",
    "length-inch",
    "length-kilometer",
    "length-meter",
    "length-mile-scandinavian",
    "length-mile",
    "length-millimeter",
    "length-yard",
    "mass-gram",
    "mass-kilogram",
    "mass-ounce",
    "mass-pound",
    "mass-stone",
    "temperature-celsius",
    "temperature-fahrenheit",
    "volume-fluid-ounce",
    "volume-gallon",
    "volume-liter",
    "volume-milliliter"
];
// In CLDR, the unit name always follows the form `namespace-unit` pattern.
// For example: `digital-bit` instead of `bit`. This function removes the namespace prefix.
function $b18859385befd8f6$var$removeUnitNamespace(unit) {
    return unit.slice(unit.indexOf("-") + 1);
}
module.exports.removeUnitNamespace = $b18859385befd8f6$var$removeUnitNamespace;
/**
 * https://tc39.es/ecma402/#table-sanctioned-simple-unit-identifiers
 */ module.exports.SIMPLE_UNITS = module.exports.SANCTIONED_UNITS.map($b18859385befd8f6$var$removeUnitNamespace);
/**
 * https://tc39.es/ecma402/#sec-issanctionedsimpleunitidentifier
 */ function $b18859385befd8f6$var$IsSanctionedSimpleUnitIdentifier(unitIdentifier) {
    return module.exports.SIMPLE_UNITS.indexOf(unitIdentifier) > -1;
}
module.exports.IsSanctionedSimpleUnitIdentifier = $b18859385befd8f6$var$IsSanctionedSimpleUnitIdentifier;

});

parcelRegister("1zpTg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsValidTimeZoneName = void 0;
/**
 * https://tc39.es/ecma402/#sec-isvalidtimezonename
 * @param tz
 * @param implDetails implementation details
 */ function $124d249d8170abc2$var$IsValidTimeZoneName(tz, _a) {
    var tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
    var uppercasedTz = tz.toUpperCase();
    var zoneNames = new Set();
    var linkNames = new Set();
    Object.keys(tzData).map(function(z) {
        return z.toUpperCase();
    }).forEach(function(z) {
        return zoneNames.add(z);
    });
    Object.keys(uppercaseLinks).forEach(function(linkName) {
        linkNames.add(linkName.toUpperCase());
        zoneNames.add(uppercaseLinks[linkName].toUpperCase());
    });
    return zoneNames.has(uppercasedTz) || linkNames.has(uppercasedTz);
}
module.exports.IsValidTimeZoneName = $124d249d8170abc2$var$IsValidTimeZoneName;

});

parcelRegister("bsbpg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsWellFormedCurrencyCode = void 0;
/**
 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
 * @param str string to convert
 */ function $856b28518941e73b$var$toUpperCase(str) {
    return str.replace(/([a-z])/g, function(_, c) {
        return c.toUpperCase();
    });
}
var $856b28518941e73b$var$NOT_A_Z_REGEX = /[^A-Z]/;
/**
 * https://tc39.es/ecma402/#sec-iswellformedcurrencycode
 */ function $856b28518941e73b$var$IsWellFormedCurrencyCode(currency) {
    currency = $856b28518941e73b$var$toUpperCase(currency);
    if (currency.length !== 3) return false;
    if ($856b28518941e73b$var$NOT_A_Z_REGEX.test(currency)) return false;
    return true;
}
module.exports.IsWellFormedCurrencyCode = $856b28518941e73b$var$IsWellFormedCurrencyCode;

});

parcelRegister("kUv4V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsWellFormedUnitIdentifier = void 0;

var $ff07o = parcelRequire("ff07o");
/**
 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
 * @param str string to convert
 */ function $f3912522640670c6$var$toLowerCase(str) {
    return str.replace(/([A-Z])/g, function(_, c) {
        return c.toLowerCase();
    });
}
/**
 * https://tc39.es/ecma402/#sec-iswellformedunitidentifier
 * @param unit
 */ function $f3912522640670c6$var$IsWellFormedUnitIdentifier(unit) {
    unit = $f3912522640670c6$var$toLowerCase(unit);
    if ((0, $ff07o.IsSanctionedSimpleUnitIdentifier)(unit)) return true;
    var units = unit.split("-per-");
    if (units.length !== 2) return false;
    var numerator = units[0], denominator = units[1];
    if (!(0, $ff07o.IsSanctionedSimpleUnitIdentifier)(numerator) || !(0, $ff07o.IsSanctionedSimpleUnitIdentifier)(denominator)) return false;
    return true;
}
module.exports.IsWellFormedUnitIdentifier = $f3912522640670c6$var$IsWellFormedUnitIdentifier;

});

parcelRegister("cSwAp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ApplyUnsignedRoundingMode = void 0;
function $9603ce202766e8fe$var$ApplyUnsignedRoundingMode(x, r1, r2, unsignedRoundingMode) {
    if (x === r1) return r1;
    if (unsignedRoundingMode === undefined) throw new Error("unsignedRoundingMode is mandatory");
    if (unsignedRoundingMode === "zero") return r1;
    if (unsignedRoundingMode === "infinity") return r2;
    var d1 = x - r1;
    var d2 = r2 - x;
    if (d1 < d2) return r1;
    if (d2 < d1) return r2;
    if (d1 !== d2) throw new Error("Unexpected error");
    if (unsignedRoundingMode === "half-zero") return r1;
    if (unsignedRoundingMode === "half-infinity") return r2;
    if (unsignedRoundingMode !== "half-even") throw new Error("Unexpected value for unsignedRoundingMode: ".concat(unsignedRoundingMode));
    var cardinality = r1 / (r2 - r1) % 2;
    if (cardinality === 0) return r1;
    return r2;
}
module.exports.ApplyUnsignedRoundingMode = $9603ce202766e8fe$var$ApplyUnsignedRoundingMode;

});

parcelRegister("I0nxD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollapseNumberRange = void 0;
/**
 * https://tc39.es/ecma402/#sec-collapsenumberrange
 */ function $08446760bf976925$var$CollapseNumberRange(result) {
    return result;
}
module.exports.CollapseNumberRange = $08446760bf976925$var$CollapseNumberRange;

});

parcelRegister("bxIII", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComputeExponent = void 0;

var $eTSkB = parcelRequire("eTSkB");

var $6UqOf = parcelRequire("6UqOf");

var $jlJUB = parcelRequire("jlJUB");
/**
 * The abstract operation ComputeExponent computes an exponent (power of ten) by which to scale x
 * according to the number formatting settings. It handles cases such as 999 rounding up to 1000,
 * requiring a different exponent.
 *
 * NOT IN SPEC: it returns [exponent, magnitude].
 */ function $867577435a8f0f36$var$ComputeExponent(numberFormat, x, _a) {
    var getInternalSlots = _a.getInternalSlots;
    if (x === 0) return [
        0,
        0
    ];
    if (x < 0) x = -x;
    var magnitude = (0, $eTSkB.getMagnitude)(x);
    var exponent = (0, $6UqOf.ComputeExponentForMagnitude)(numberFormat, magnitude, {
        getInternalSlots: getInternalSlots
    });
    // Preserve more precision by doing multiplication when exponent is negative.
    x = exponent < 0 ? x * Math.pow(10, -exponent) : x / Math.pow(10, exponent);
    var formatNumberResult = (0, $jlJUB.FormatNumericToString)(getInternalSlots(numberFormat), x);
    if (formatNumberResult.roundedNumber === 0) return [
        exponent,
        magnitude
    ];
    var newMagnitude = (0, $eTSkB.getMagnitude)(formatNumberResult.roundedNumber);
    if (newMagnitude === magnitude - exponent) return [
        exponent,
        magnitude
    ];
    return [
        (0, $6UqOf.ComputeExponentForMagnitude)(numberFormat, magnitude + 1, {
            getInternalSlots: getInternalSlots
        }),
        magnitude + 1
    ];
}
module.exports.ComputeExponent = $867577435a8f0f36$var$ComputeExponent;

});
parcelRegister("eTSkB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.invariant = module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = module.exports.defineProperty = module.exports.isLiteralPart = module.exports.getMultiInternalSlots = module.exports.getInternalSlot = module.exports.setMultiInternalSlots = module.exports.setInternalSlot = module.exports.repeat = module.exports.getMagnitude = void 0;
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $ad9058d19438a385$var$getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
module.exports.getMagnitude = $ad9058d19438a385$var$getMagnitude;
function $ad9058d19438a385$var$repeat(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
module.exports.repeat = $ad9058d19438a385$var$repeat;
function $ad9058d19438a385$var$setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
module.exports.setInternalSlot = $ad9058d19438a385$var$setInternalSlot;
function $ad9058d19438a385$var$setMultiInternalSlots(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $ad9058d19438a385$var$setInternalSlot(map, pl, k, props[k]);
    }
}
module.exports.setMultiInternalSlots = $ad9058d19438a385$var$setMultiInternalSlots;
function $ad9058d19438a385$var$getInternalSlot(map, pl, field) {
    return $ad9058d19438a385$var$getMultiInternalSlots(map, pl, field)[field];
}
module.exports.getInternalSlot = $ad9058d19438a385$var$getInternalSlot;
function $ad9058d19438a385$var$getMultiInternalSlots(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
module.exports.getMultiInternalSlots = $ad9058d19438a385$var$getMultiInternalSlots;
function $ad9058d19438a385$var$isLiteralPart(patternPart) {
    return patternPart.type === "literal";
}
module.exports.isLiteralPart = $ad9058d19438a385$var$isLiteralPart;
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/ function $ad9058d19438a385$var$defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
module.exports.defineProperty = $ad9058d19438a385$var$defineProperty;
module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function $ad9058d19438a385$var$invariant(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
module.exports.invariant = $ad9058d19438a385$var$invariant;

});

parcelRegister("6UqOf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComputeExponentForMagnitude = void 0;
/**
 * The abstract operation ComputeExponentForMagnitude computes an exponent by which to scale a
 * number of the given magnitude (power of ten of the most significant digit) according to the
 * locale and the desired notation (scientific, engineering, or compact).
 */ function $507cc4d683a26bc9$var$ComputeExponentForMagnitude(numberFormat, magnitude, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var notation = internalSlots.notation, dataLocaleData = internalSlots.dataLocaleData, numberingSystem = internalSlots.numberingSystem;
    switch(notation){
        case "standard":
            return 0;
        case "scientific":
            return magnitude;
        case "engineering":
            return Math.floor(magnitude / 3) * 3;
        default:
            // Let exponent be an implementation- and locale-dependent (ILD) integer by which to scale a
            // number of the given magnitude in compact notation for the current locale.
            var compactDisplay = internalSlots.compactDisplay, style = internalSlots.style, currencyDisplay = internalSlots.currencyDisplay;
            var thresholdMap = void 0;
            if (style === "currency" && currencyDisplay !== "name") {
                var currency = dataLocaleData.numbers.currency[numberingSystem] || dataLocaleData.numbers.currency[dataLocaleData.numbers.nu[0]];
                thresholdMap = currency.short;
            } else {
                var decimal = dataLocaleData.numbers.decimal[numberingSystem] || dataLocaleData.numbers.decimal[dataLocaleData.numbers.nu[0]];
                thresholdMap = compactDisplay === "long" ? decimal.long : decimal.short;
            }
            if (!thresholdMap) return 0;
            var num = String(Math.pow(10, magnitude));
            var thresholds = Object.keys(thresholdMap); // TODO: this can be pre-processed
            if (num < thresholds[0]) return 0;
            if (num > thresholds[thresholds.length - 1]) return thresholds[thresholds.length - 1].length - 1;
            var i = thresholds.indexOf(num);
            if (i === -1) return 0;
            // See https://unicode.org/reports/tr35/tr35-numbers.html#Compact_Number_Formats
            // Special handling if the pattern is precisely `0`.
            var magnitudeKey = thresholds[i];
            // TODO: do we need to handle plural here?
            var compactPattern = thresholdMap[magnitudeKey].other;
            if (compactPattern === "0") return 0;
            // Example: in zh-TW, `10000000` maps to `0000萬`. So we need to return 8 - 4 = 4 here.
            return magnitudeKey.length - thresholdMap[magnitudeKey].other.match(/0+/)[0].length;
    }
}
module.exports.ComputeExponentForMagnitude = $507cc4d683a26bc9$var$ComputeExponentForMagnitude;

});

parcelRegister("jlJUB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericToString = void 0;

var $itFDr = parcelRequire("itFDr");

var $llqeG = parcelRequire("llqeG");

var $eTSkB = parcelRequire("eTSkB");

var $GAvbb = parcelRequire("GAvbb");
/**
 * https://tc39.es/ecma402/#sec-formatnumberstring
 */ function $e16397a4fc019b4b$var$FormatNumericToString(intlObject, x) {
    var isNegative = x < 0 || (0, $itFDr.SameValue)(x, -0);
    if (isNegative) x = -x;
    var result;
    var rourndingType = intlObject.roundingType;
    switch(rourndingType){
        case "significantDigits":
            result = (0, $llqeG.ToRawPrecision)(x, intlObject.minimumSignificantDigits, intlObject.maximumSignificantDigits);
            break;
        case "fractionDigits":
            result = (0, $GAvbb.ToRawFixed)(x, intlObject.minimumFractionDigits, intlObject.maximumFractionDigits);
            break;
        default:
            result = (0, $llqeG.ToRawPrecision)(x, 1, 2);
            if (result.integerDigitsCount > 1) result = (0, $GAvbb.ToRawFixed)(x, 0, 0);
            break;
    }
    x = result.roundedNumber;
    var string = result.formattedString;
    var int = result.integerDigitsCount;
    var minInteger = intlObject.minimumIntegerDigits;
    if (int < minInteger) {
        var forwardZeros = (0, $eTSkB.repeat)("0", minInteger - int);
        string = forwardZeros + string;
    }
    if (isNegative) x = -x;
    return {
        roundedNumber: x,
        formattedString: string
    };
}
module.exports.FormatNumericToString = $e16397a4fc019b4b$var$FormatNumericToString;

});
parcelRegister("llqeG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ToRawPrecision = void 0;

var $eTSkB = parcelRequire("eTSkB");
function $f89fe9056cd7eab2$var$ToRawPrecision(x, minPrecision, maxPrecision) {
    var p = maxPrecision;
    var m;
    var e;
    var xFinal;
    if (x === 0) {
        m = (0, $eTSkB.repeat)("0", p);
        e = 0;
        xFinal = 0;
    } else {
        var xToString = x.toString();
        // If xToString is formatted as scientific notation, the number is either very small or very
        // large. If the precision of the formatted string is lower that requested max precision, we
        // should still infer them from the formatted string, otherwise the formatted result might have
        // precision loss (e.g. 1e41 will not have 0 in every trailing digits).
        var xToStringExponentIndex = xToString.indexOf("e");
        var _a = xToString.split("e"), xToStringMantissa = _a[0], xToStringExponent = _a[1];
        var xToStringMantissaWithoutDecimalPoint = xToStringMantissa.replace(".", "");
        if (xToStringExponentIndex >= 0 && xToStringMantissaWithoutDecimalPoint.length <= p) {
            e = +xToStringExponent;
            m = xToStringMantissaWithoutDecimalPoint + (0, $eTSkB.repeat)("0", p - xToStringMantissaWithoutDecimalPoint.length);
            xFinal = x;
        } else {
            e = (0, $eTSkB.getMagnitude)(x);
            var decimalPlaceOffset = e - p + 1;
            // n is the integer containing the required precision digits. To derive the formatted string,
            // we will adjust its decimal place in the logic below.
            var n = Math.round(adjustDecimalPlace(x, decimalPlaceOffset));
            // The rounding caused the change of magnitude, so we should increment `e` by 1.
            if (adjustDecimalPlace(n, p - 1) >= 10) {
                e = e + 1;
                // Divide n by 10 to swallow one precision.
                n = Math.floor(n / 10);
            }
            m = n.toString();
            // Equivalent of n * 10 ** (e - p + 1)
            xFinal = adjustDecimalPlace(n, p - 1 - e);
        }
    }
    var int;
    if (e >= p - 1) {
        m = m + (0, $eTSkB.repeat)("0", e - p + 1);
        int = e + 1;
    } else if (e >= 0) {
        m = "".concat(m.slice(0, e + 1), ".").concat(m.slice(e + 1));
        int = e + 1;
    } else {
        m = "0.".concat((0, $eTSkB.repeat)("0", -e - 1)).concat(m);
        int = 1;
    }
    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
        var cut = maxPrecision - minPrecision;
        while(cut > 0 && m[m.length - 1] === "0"){
            m = m.slice(0, -1);
            cut--;
        }
        if (m[m.length - 1] === ".") m = m.slice(0, -1);
    }
    return {
        formattedString: m,
        roundedNumber: xFinal,
        integerDigitsCount: int
    };
    // x / (10 ** magnitude), but try to preserve as much floating point precision as possible.
    function adjustDecimalPlace(x, magnitude) {
        return magnitude < 0 ? x * Math.pow(10, -magnitude) : x / Math.pow(10, magnitude);
    }
}
module.exports.ToRawPrecision = $f89fe9056cd7eab2$var$ToRawPrecision;

});

parcelRegister("GAvbb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ToRawFixed = void 0;

var $eTSkB = parcelRequire("eTSkB");
/**
 * TODO: dedup with intl-pluralrules and support BigInt
 * https://tc39.es/ecma402/#sec-torawfixed
 * @param x a finite non-negative Number or BigInt
 * @param minFraction and integer between 0 and 20
 * @param maxFraction and integer between 0 and 20
 */ function $08003cdfcf30ed51$var$ToRawFixed(x, minFraction, maxFraction) {
    var f = maxFraction;
    var n = Math.round(x * Math.pow(10, f));
    var xFinal = n / Math.pow(10, f);
    // n is a positive integer, but it is possible to be greater than 1e21.
    // In such case we will go the slow path.
    // See also: https://tc39.es/ecma262/#sec-numeric-types-number-tostring
    var m;
    if (n < 1e21) m = n.toString();
    else {
        m = n.toString();
        var _a = m.split("e"), mantissa = _a[0], exponent = _a[1];
        m = mantissa.replace(".", "");
        m = m + (0, $eTSkB.repeat)("0", Math.max(+exponent - m.length + 1, 0));
    }
    var int;
    if (f !== 0) {
        var k = m.length;
        if (k <= f) {
            var z = (0, $eTSkB.repeat)("0", f + 1 - k);
            m = z + m;
            k = f + 1;
        }
        var a = m.slice(0, k - f);
        var b = m.slice(k - f);
        m = "".concat(a, ".").concat(b);
        int = a.length;
    } else int = m.length;
    var cut = maxFraction - minFraction;
    while(cut > 0 && m[m.length - 1] === "0"){
        m = m.slice(0, -1);
        cut--;
    }
    if (m[m.length - 1] === ".") m = m.slice(0, -1);
    return {
        formattedString: m,
        roundedNumber: xFinal,
        integerDigitsCount: int
    };
}
module.exports.ToRawFixed = $08003cdfcf30ed51$var$ToRawFixed;

});



parcelRegister("3sO81", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CurrencyDigits = void 0;

var $itFDr = parcelRequire("itFDr");
/**
 * https://tc39.es/ecma402/#sec-currencydigits
 */ function $285adf15b70477e8$var$CurrencyDigits(c, _a) {
    var currencyDigitsData = _a.currencyDigitsData;
    return (0, $itFDr.HasOwnProperty)(currencyDigitsData, c) ? currencyDigitsData[c] : 2;
}
module.exports.CurrencyDigits = $285adf15b70477e8$var$CurrencyDigits;

});

parcelRegister("5giPY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatApproximately = void 0;
/**
 * https://tc39.es/ecma402/#sec-formatapproximately
 */ function $3d4d0f0c18048c76$var$FormatApproximately(numberFormat, result, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var symbols = internalSlots.dataLocaleData.numbers.symbols[internalSlots.numberingSystem];
    var approximatelySign = symbols.approximatelySign;
    result.push({
        type: "approximatelySign",
        value: approximatelySign
    });
    return result;
}
module.exports.FormatApproximately = $3d4d0f0c18048c76$var$FormatApproximately;

});

parcelRegister("cPN6h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericRange = void 0;

var $ePJzc = parcelRequire("ePJzc");
/**
 * https://tc39.es/ecma402/#sec-formatnumericrange
 */ function $958055bc989bff48$var$FormatNumericRange(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var parts = (0, $ePJzc.PartitionNumberRangePattern)(numberFormat, x, y, {
        getInternalSlots: getInternalSlots
    });
    return parts.map(function(part) {
        return part.value;
    }).join("");
}
module.exports.FormatNumericRange = $958055bc989bff48$var$FormatNumericRange;

});
parcelRegister("ePJzc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PartitionNumberRangePattern = void 0;

var $8gDXg = parcelRequire("8gDXg");

var $I0nxD = parcelRequire("I0nxD");

var $5giPY = parcelRequire("5giPY");
/**
 * https://tc39.es/ecma402/#sec-partitionnumberrangepattern
 */ function $acc92cb0c8132a3e$var$PartitionNumberRangePattern(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    if (isNaN(x) || isNaN(y)) throw new RangeError("Input must be a number");
    var result = [];
    var xResult = (0, $8gDXg.PartitionNumberPattern)(numberFormat, x, {
        getInternalSlots: getInternalSlots
    });
    var yResult = (0, $8gDXg.PartitionNumberPattern)(numberFormat, y, {
        getInternalSlots: getInternalSlots
    });
    if (xResult === yResult) return (0, $5giPY.FormatApproximately)(numberFormat, xResult, {
        getInternalSlots: getInternalSlots
    });
    for(var _i = 0, xResult_1 = xResult; _i < xResult_1.length; _i++){
        var r = xResult_1[_i];
        r.source = "startRange";
    }
    result = result.concat(xResult);
    var internalSlots = getInternalSlots(numberFormat);
    var symbols = internalSlots.dataLocaleData.numbers.symbols[internalSlots.numberingSystem];
    result.push({
        type: "literal",
        value: symbols.rangeSign,
        source: "shared"
    });
    for(var _b = 0, yResult_1 = yResult; _b < yResult_1.length; _b++){
        var r = yResult_1[_b];
        r.source = "endRange";
    }
    result = result.concat(yResult);
    return (0, $I0nxD.CollapseNumberRange)(result);
}
module.exports.PartitionNumberRangePattern = $acc92cb0c8132a3e$var$PartitionNumberRangePattern;

});
parcelRegister("8gDXg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PartitionNumberPattern = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $jlJUB = parcelRequire("jlJUB");

var $itFDr = parcelRequire("itFDr");

var $bxIII = parcelRequire("bxIII");

var $604ecf8e578471b3$var$format_to_parts_1 = $eIwgG.__importDefault((parcelRequire("cynBD")));
/**
 * https://tc39.es/ecma402/#sec-formatnumberstring
 */ function $604ecf8e578471b3$var$PartitionNumberPattern(numberFormat, x, _a) {
    var _b;
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var pl = internalSlots.pl, dataLocaleData = internalSlots.dataLocaleData, numberingSystem = internalSlots.numberingSystem;
    var symbols = dataLocaleData.numbers.symbols[numberingSystem] || dataLocaleData.numbers.symbols[dataLocaleData.numbers.nu[0]];
    var magnitude = 0;
    var exponent = 0;
    var n;
    if (isNaN(x)) n = symbols.nan;
    else if (x == Number.POSITIVE_INFINITY || x == Number.NEGATIVE_INFINITY) n = symbols.infinity;
    else {
        if (!(0, $itFDr.SameValue)(x, -0)) {
            if (!isFinite(x)) throw new Error("Input must be a mathematical value");
            if (internalSlots.style == "percent") x *= 100;
            _b = (0, $bxIII.ComputeExponent)(numberFormat, x, {
                getInternalSlots: getInternalSlots
            }), exponent = _b[0], magnitude = _b[1];
            // Preserve more precision by doing multiplication when exponent is negative.
            x = exponent < 0 ? x * Math.pow(10, -exponent) : x / Math.pow(10, exponent);
        }
        var formatNumberResult = (0, $jlJUB.FormatNumericToString)(internalSlots, x);
        n = formatNumberResult.formattedString;
        x = formatNumberResult.roundedNumber;
    }
    // Based on https://tc39.es/ecma402/#sec-getnumberformatpattern
    // We need to do this before `x` is rounded.
    var sign;
    var signDisplay = internalSlots.signDisplay;
    switch(signDisplay){
        case "never":
            sign = 0;
            break;
        case "auto":
            if ((0, $itFDr.SameValue)(x, 0) || x > 0 || isNaN(x)) sign = 0;
            else sign = -1;
            break;
        case "always":
            if ((0, $itFDr.SameValue)(x, 0) || x > 0 || isNaN(x)) sign = 1;
            else sign = -1;
            break;
        default:
            // x === 0 -> x is 0 or x is -0
            if (x === 0 || isNaN(x)) sign = 0;
            else if (x > 0) sign = 1;
            else sign = -1;
    }
    return (0, $604ecf8e578471b3$var$format_to_parts_1.default)({
        roundedNumber: x,
        formattedString: n,
        exponent: exponent,
        magnitude: magnitude,
        sign: sign
    }, internalSlots.dataLocaleData, pl, internalSlots);
}
module.exports.PartitionNumberPattern = $604ecf8e578471b3$var$PartitionNumberPattern;

});
parcelRegister("cynBD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $GAvbb = parcelRequire("GAvbb");

var $ubfX4 = parcelRequire("ubfX4");

var $3FweZ = parcelRequire("3FweZ");
// This is from: unicode-12.1.0/General_Category/Symbol/regex.js
// IE11 does not support unicode flag, otherwise this is just /\p{S}/u.
// /^\p{S}/u
var $923af8a903aebd39$var$CARET_S_UNICODE_REGEX = new RegExp("^".concat($3FweZ.S_UNICODE_REGEX.source));
// /\p{S}$/u
var $923af8a903aebd39$var$S_DOLLAR_UNICODE_REGEX = new RegExp("".concat($3FweZ.S_UNICODE_REGEX.source, "$"));
var $923af8a903aebd39$var$CLDR_NUMBER_PATTERN = /[#0](?:[\.,][#0]+)*/g;
function $923af8a903aebd39$var$formatToParts(numberResult, data, pl, options) {
    var sign = numberResult.sign, exponent = numberResult.exponent, magnitude = numberResult.magnitude;
    var notation = options.notation, style = options.style, numberingSystem = options.numberingSystem;
    var defaultNumberingSystem = data.numbers.nu[0];
    // #region Part 1: partition and interpolate the CLDR number pattern.
    // ----------------------------------------------------------
    var compactNumberPattern = null;
    if (notation === "compact" && magnitude) compactNumberPattern = $923af8a903aebd39$var$getCompactDisplayPattern(numberResult, pl, data, style, options.compactDisplay, options.currencyDisplay, numberingSystem);
    // This is used multiple times
    var nonNameCurrencyPart;
    if (style === "currency" && options.currencyDisplay !== "name") {
        var byCurrencyDisplay = data.currencies[options.currency];
        if (byCurrencyDisplay) switch(options.currencyDisplay){
            case "code":
                nonNameCurrencyPart = options.currency;
                break;
            case "symbol":
                nonNameCurrencyPart = byCurrencyDisplay.symbol;
                break;
            default:
                nonNameCurrencyPart = byCurrencyDisplay.narrow;
                break;
        }
        else // Fallback for unknown currency
        nonNameCurrencyPart = options.currency;
    }
    var numberPattern;
    if (!compactNumberPattern) {
        // Note: if the style is unit, or is currency and the currency display is name,
        // its unit parts will be interpolated in part 2. So here we can fallback to decimal.
        if (style === "decimal" || style === "unit" || style === "currency" && options.currencyDisplay === "name") {
            // Shortcut for decimal
            var decimalData = data.numbers.decimal[numberingSystem] || data.numbers.decimal[defaultNumberingSystem];
            numberPattern = $923af8a903aebd39$var$getPatternForSign(decimalData.standard, sign);
        } else if (style === "currency") {
            var currencyData = data.numbers.currency[numberingSystem] || data.numbers.currency[defaultNumberingSystem];
            // We replace number pattern part with `0` for easier postprocessing.
            numberPattern = $923af8a903aebd39$var$getPatternForSign(currencyData[options.currencySign], sign);
        } else {
            // percent
            var percentPattern = data.numbers.percent[numberingSystem] || data.numbers.percent[defaultNumberingSystem];
            numberPattern = $923af8a903aebd39$var$getPatternForSign(percentPattern, sign);
        }
    } else numberPattern = compactNumberPattern;
    // Extract the decimal number pattern string. It looks like "#,##0,00", which will later be
    // used to infer decimal group sizes.
    var decimalNumberPattern = $923af8a903aebd39$var$CLDR_NUMBER_PATTERN.exec(numberPattern)[0];
    // Now we start to substitute patterns
    // 1. replace strings like `0` and `#,##0.00` with `{0}`
    // 2. unquote characters (invariant: the quoted characters does not contain the special tokens)
    numberPattern = numberPattern.replace($923af8a903aebd39$var$CLDR_NUMBER_PATTERN, "{0}").replace(/'(.)'/g, "$1");
    // Handle currency spacing (both compact and non-compact).
    if (style === "currency" && options.currencyDisplay !== "name") {
        var currencyData = data.numbers.currency[numberingSystem] || data.numbers.currency[defaultNumberingSystem];
        // See `currencySpacing` substitution rule in TR-35.
        // Here we always assume the currencyMatch is "[:^S:]" and surroundingMatch is "[:digit:]".
        //
        // Example 1: for pattern "#,##0.00¤" with symbol "US$", we replace "¤" with the symbol,
        // but insert an extra non-break space before the symbol, because "[:^S:]" matches "U" in
        // "US$" and "[:digit:]" matches the latn numbering system digits.
        //
        // Example 2: for pattern "¤#,##0.00" with symbol "US$", there is no spacing between symbol
        // and number, because `$` does not match "[:^S:]".
        //
        // Implementation note: here we do the best effort to infer the insertion.
        // We also assume that `beforeInsertBetween` and `afterInsertBetween` will never be `;`.
        var afterCurrency = currencyData.currencySpacing.afterInsertBetween;
        if (afterCurrency && !$923af8a903aebd39$var$S_DOLLAR_UNICODE_REGEX.test(nonNameCurrencyPart)) numberPattern = numberPattern.replace("\xa4{0}", "\xa4".concat(afterCurrency, "{0}"));
        var beforeCurrency = currencyData.currencySpacing.beforeInsertBetween;
        if (beforeCurrency && !$923af8a903aebd39$var$CARET_S_UNICODE_REGEX.test(nonNameCurrencyPart)) numberPattern = numberPattern.replace("{0}\xa4", "{0}".concat(beforeCurrency, "\xa4"));
    }
    // The following tokens are special: `{0}`, `¤`, `%`, `-`, `+`, `{c:...}.
    var numberPatternParts = numberPattern.split(/({c:[^}]+}|\{0\}|[¤%\-\+])/g);
    var numberParts = [];
    var symbols = data.numbers.symbols[numberingSystem] || data.numbers.symbols[defaultNumberingSystem];
    for(var _i = 0, numberPatternParts_1 = numberPatternParts; _i < numberPatternParts_1.length; _i++){
        var part = numberPatternParts_1[_i];
        if (!part) continue;
        switch(part){
            case "{0}":
                // We only need to handle scientific and engineering notation here.
                numberParts.push.apply(numberParts, $923af8a903aebd39$var$paritionNumberIntoParts(symbols, numberResult, notation, exponent, numberingSystem, // If compact number pattern exists, do not insert group separators.
                !compactNumberPattern && Boolean(options.useGrouping), decimalNumberPattern));
                break;
            case "-":
                numberParts.push({
                    type: "minusSign",
                    value: symbols.minusSign
                });
                break;
            case "+":
                numberParts.push({
                    type: "plusSign",
                    value: symbols.plusSign
                });
                break;
            case "%":
                numberParts.push({
                    type: "percentSign",
                    value: symbols.percentSign
                });
                break;
            case "\xa4":
                // Computed above when handling currency spacing.
                numberParts.push({
                    type: "currency",
                    value: nonNameCurrencyPart
                });
                break;
            default:
                if (/^\{c:/.test(part)) numberParts.push({
                    type: "compact",
                    value: part.substring(3, part.length - 1)
                });
                else // literal
                numberParts.push({
                    type: "literal",
                    value: part
                });
                break;
        }
    }
    // #endregion
    // #region Part 2: interpolate unit pattern if necessary.
    // ----------------------------------------------
    switch(style){
        case "currency":
            // `currencyDisplay: 'name'` has similar pattern handling as units.
            if (options.currencyDisplay === "name") {
                var unitPattern = (data.numbers.currency[numberingSystem] || data.numbers.currency[defaultNumberingSystem]).unitPattern;
                // Select plural
                var unitName = void 0;
                var currencyNameData = data.currencies[options.currency];
                if (currencyNameData) unitName = $923af8a903aebd39$var$selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), currencyNameData.displayName);
                else // Fallback for unknown currency
                unitName = options.currency;
                // Do {0} and {1} substitution
                var unitPatternParts = unitPattern.split(/(\{[01]\})/g);
                var result = [];
                for(var _a = 0, unitPatternParts_1 = unitPatternParts; _a < unitPatternParts_1.length; _a++){
                    var part = unitPatternParts_1[_a];
                    switch(part){
                        case "{0}":
                            result.push.apply(result, numberParts);
                            break;
                        case "{1}":
                            result.push({
                                type: "currency",
                                value: unitName
                            });
                            break;
                        default:
                            if (part) result.push({
                                type: "literal",
                                value: part
                            });
                            break;
                    }
                }
                return result;
            } else return numberParts;
        case "unit":
            var unit = options.unit, unitDisplay = options.unitDisplay;
            var unitData = data.units.simple[unit];
            var unitPattern = void 0;
            if (unitData) // Simple unit pattern
            unitPattern = $923af8a903aebd39$var$selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), data.units.simple[unit][unitDisplay]);
            else {
                // See: http://unicode.org/reports/tr35/tr35-general.html#perUnitPatterns
                // If cannot find unit in the simple pattern, it must be "per" compound pattern.
                // Implementation note: we are not following TR-35 here because we need to format to parts!
                var _b = unit.split("-per-"), numeratorUnit = _b[0], denominatorUnit = _b[1];
                unitData = data.units.simple[numeratorUnit];
                var numeratorUnitPattern = $923af8a903aebd39$var$selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), data.units.simple[numeratorUnit][unitDisplay]);
                var perUnitPattern = data.units.simple[denominatorUnit].perUnit[unitDisplay];
                if (perUnitPattern) // perUnitPattern exists, combine it with numeratorUnitPattern
                unitPattern = perUnitPattern.replace("{0}", numeratorUnitPattern);
                else {
                    // get compoundUnit pattern (e.g. "{0} per {1}"), repalce {0} with numerator pattern and {1} with
                    // the denominator pattern in singular form.
                    var perPattern = data.units.compound.per[unitDisplay];
                    var denominatorPattern = $923af8a903aebd39$var$selectPlural(pl, 1, data.units.simple[denominatorUnit][unitDisplay]);
                    unitPattern = unitPattern = perPattern.replace("{0}", numeratorUnitPattern).replace("{1}", denominatorPattern.replace("{0}", ""));
                }
            }
            var result = [];
            // We need spacing around "{0}" because they are not treated as "unit" parts, but "literal".
            for(var _c = 0, _d = unitPattern.split(/(\s*\{0\}\s*)/); _c < _d.length; _c++){
                var part = _d[_c];
                var interpolateMatch = /^(\s*)\{0\}(\s*)$/.exec(part);
                if (interpolateMatch) {
                    // Space before "{0}"
                    if (interpolateMatch[1]) result.push({
                        type: "literal",
                        value: interpolateMatch[1]
                    });
                    // "{0}" itself
                    result.push.apply(result, numberParts);
                    // Space after "{0}"
                    if (interpolateMatch[2]) result.push({
                        type: "literal",
                        value: interpolateMatch[2]
                    });
                } else if (part) result.push({
                    type: "unit",
                    value: part
                });
            }
            return result;
        default:
            return numberParts;
    }
// #endregion
}
module.exports.default = $923af8a903aebd39$var$formatToParts;
// A subset of https://tc39.es/ecma402/#sec-partitionnotationsubpattern
// Plus the exponent parts handling.
function $923af8a903aebd39$var$paritionNumberIntoParts(symbols, numberResult, notation, exponent, numberingSystem, useGrouping, /**
 * This is the decimal number pattern without signs or symbols.
 * It is used to infer the group size when `useGrouping` is true.
 *
 * A typical value looks like "#,##0.00" (primary group size is 3).
 * Some locales like Hindi has secondary group size of 2 (e.g. "#,##,##0.00").
 */ decimalNumberPattern) {
    var result = [];
    // eslint-disable-next-line prefer-const
    var n = numberResult.formattedString, x = numberResult.roundedNumber;
    if (isNaN(x)) return [
        {
            type: "nan",
            value: n
        }
    ];
    else if (!isFinite(x)) return [
        {
            type: "infinity",
            value: n
        }
    ];
    var digitReplacementTable = $ubfX4.digitMapping[numberingSystem];
    if (digitReplacementTable) n = n.replace(/\d/g, function(digit) {
        return digitReplacementTable[+digit] || digit;
    });
    // TODO: Else use an implementation dependent algorithm to map n to the appropriate
    // representation of n in the given numbering system.
    var decimalSepIndex = n.indexOf(".");
    var integer;
    var fraction;
    if (decimalSepIndex > 0) {
        integer = n.slice(0, decimalSepIndex);
        fraction = n.slice(decimalSepIndex + 1);
    } else integer = n;
    // #region Grouping integer digits
    // The weird compact and x >= 10000 check is to ensure consistency with Node.js and Chrome.
    // Note that `de` does not have compact form for thousands, but Node.js does not insert grouping separator
    // unless the rounded number is greater than 10000:
    //   NumberFormat('de', {notation: 'compact', compactDisplay: 'short'}).format(1234) //=> "1234"
    //   NumberFormat('de').format(1234) //=> "1.234"
    if (useGrouping && (notation !== "compact" || x >= 10000)) {
        var groupSepSymbol = symbols.group;
        var groups = [];
        // > There may be two different grouping sizes: The primary grouping size used for the least
        // > significant integer group, and the secondary grouping size used for more significant groups.
        // > If a pattern contains multiple grouping separators, the interval between the last one and the
        // > end of the integer defines the primary grouping size, and the interval between the last two
        // > defines the secondary grouping size. All others are ignored.
        var integerNumberPattern = decimalNumberPattern.split(".")[0];
        var patternGroups = integerNumberPattern.split(",");
        var primaryGroupingSize = 3;
        var secondaryGroupingSize = 3;
        if (patternGroups.length > 1) primaryGroupingSize = patternGroups[patternGroups.length - 1].length;
        if (patternGroups.length > 2) secondaryGroupingSize = patternGroups[patternGroups.length - 2].length;
        var i = integer.length - primaryGroupingSize;
        if (i > 0) {
            // Slice the least significant integer group
            groups.push(integer.slice(i, i + primaryGroupingSize));
            // Then iteratively push the more signicant groups
            // TODO: handle surrogate pairs in some numbering system digits
            for(i -= secondaryGroupingSize; i > 0; i -= secondaryGroupingSize)groups.push(integer.slice(i, i + secondaryGroupingSize));
            groups.push(integer.slice(0, i + secondaryGroupingSize));
        } else groups.push(integer);
        while(groups.length > 0){
            var integerGroup = groups.pop();
            result.push({
                type: "integer",
                value: integerGroup
            });
            if (groups.length > 0) result.push({
                type: "group",
                value: groupSepSymbol
            });
        }
    } else result.push({
        type: "integer",
        value: integer
    });
    // #endregion
    if (fraction !== undefined) result.push({
        type: "decimal",
        value: symbols.decimal
    }, {
        type: "fraction",
        value: fraction
    });
    if ((notation === "scientific" || notation === "engineering") && isFinite(x)) {
        result.push({
            type: "exponentSeparator",
            value: symbols.exponential
        });
        if (exponent < 0) {
            result.push({
                type: "exponentMinusSign",
                value: symbols.minusSign
            });
            exponent = -exponent;
        }
        var exponentResult = (0, $GAvbb.ToRawFixed)(exponent, 0, 0);
        result.push({
            type: "exponentInteger",
            value: exponentResult.formattedString
        });
    }
    return result;
}
function $923af8a903aebd39$var$getPatternForSign(pattern, sign) {
    if (pattern.indexOf(";") < 0) pattern = "".concat(pattern, ";-").concat(pattern);
    var _a = pattern.split(";"), zeroPattern = _a[0], negativePattern = _a[1];
    switch(sign){
        case 0:
            return zeroPattern;
        case -1:
            return negativePattern;
        default:
            return negativePattern.indexOf("-") >= 0 ? negativePattern.replace(/-/g, "+") : "+".concat(zeroPattern);
    }
}
// Find the CLDR pattern for compact notation based on the magnitude of data and style.
//
// Example return value: "¤ {c:laki}000;¤{c:laki} -0" (`sw` locale):
// - Notice the `{c:...}` token that wraps the compact literal.
// - The consecutive zeros are normalized to single zero to match CLDR_NUMBER_PATTERN.
//
// Returning null means the compact display pattern cannot be found.
function $923af8a903aebd39$var$getCompactDisplayPattern(numberResult, pl, data, style, compactDisplay, currencyDisplay, numberingSystem) {
    var _a;
    var roundedNumber = numberResult.roundedNumber, sign = numberResult.sign, magnitude = numberResult.magnitude;
    var magnitudeKey = String(Math.pow(10, magnitude));
    var defaultNumberingSystem = data.numbers.nu[0];
    var pattern;
    if (style === "currency" && currencyDisplay !== "name") {
        var byNumberingSystem = data.numbers.currency;
        var currencyData = byNumberingSystem[numberingSystem] || byNumberingSystem[defaultNumberingSystem];
        // NOTE: compact notation ignores currencySign!
        var compactPluralRules = (_a = currencyData.short) === null || _a === void 0 ? void 0 : _a[magnitudeKey];
        if (!compactPluralRules) return null;
        pattern = $923af8a903aebd39$var$selectPlural(pl, roundedNumber, compactPluralRules);
    } else {
        var byNumberingSystem = data.numbers.decimal;
        var byCompactDisplay = byNumberingSystem[numberingSystem] || byNumberingSystem[defaultNumberingSystem];
        var compactPlaralRule = byCompactDisplay[compactDisplay][magnitudeKey];
        if (!compactPlaralRule) return null;
        pattern = $923af8a903aebd39$var$selectPlural(pl, roundedNumber, compactPlaralRule);
    }
    // See https://unicode.org/reports/tr35/tr35-numbers.html#Compact_Number_Formats
    // > If the value is precisely “0”, either explicit or defaulted, then the normal number format
    // > pattern for that sort of object is supplied.
    if (pattern === "0") return null;
    pattern = $923af8a903aebd39$var$getPatternForSign(pattern, sign)// Extract compact literal from the pattern
    .replace(/([^\s;\-\+\d¤]+)/g, "{c:$1}")// We replace one or more zeros with a single zero so it matches `CLDR_NUMBER_PATTERN`.
    .replace(/0+/, "0");
    return pattern;
}
function $923af8a903aebd39$var$selectPlural(pl, x, rules) {
    return rules[pl.select(x)] || rules.other;
}

});
parcelRegister("ubfX4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.digitMapping = void 0;
module.exports.digitMapping = {
    "adlm": [
        "\uD83A\uDD50",
        "\uD83A\uDD51",
        "\uD83A\uDD52",
        "\uD83A\uDD53",
        "\uD83A\uDD54",
        "\uD83A\uDD55",
        "\uD83A\uDD56",
        "\uD83A\uDD57",
        "\uD83A\uDD58",
        "\uD83A\uDD59"
    ],
    "ahom": [
        "\uD805\uDF30",
        "\uD805\uDF31",
        "\uD805\uDF32",
        "\uD805\uDF33",
        "\uD805\uDF34",
        "\uD805\uDF35",
        "\uD805\uDF36",
        "\uD805\uDF37",
        "\uD805\uDF38",
        "\uD805\uDF39"
    ],
    "arab": [
        "\u0660",
        "\u0661",
        "\u0662",
        "\u0663",
        "\u0664",
        "\u0665",
        "\u0666",
        "\u0667",
        "\u0668",
        "\u0669"
    ],
    "arabext": [
        "\u06F0",
        "\u06F1",
        "\u06F2",
        "\u06F3",
        "\u06F4",
        "\u06F5",
        "\u06F6",
        "\u06F7",
        "\u06F8",
        "\u06F9"
    ],
    "bali": [
        "\u1B50",
        "\u1B51",
        "\u1B52",
        "\u1B53",
        "\u1B54",
        "\u1B55",
        "\u1B56",
        "\u1B57",
        "\u1B58",
        "\u1B59"
    ],
    "beng": [
        "\u09E6",
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA",
        "\u09EB",
        "\u09EC",
        "\u09ED",
        "\u09EE",
        "\u09EF"
    ],
    "bhks": [
        "\uD807\uDC50",
        "\uD807\uDC51",
        "\uD807\uDC52",
        "\uD807\uDC53",
        "\uD807\uDC54",
        "\uD807\uDC55",
        "\uD807\uDC56",
        "\uD807\uDC57",
        "\uD807\uDC58",
        "\uD807\uDC59"
    ],
    "brah": [
        "\uD804\uDC66",
        "\uD804\uDC67",
        "\uD804\uDC68",
        "\uD804\uDC69",
        "\uD804\uDC6A",
        "\uD804\uDC6B",
        "\uD804\uDC6C",
        "\uD804\uDC6D",
        "\uD804\uDC6E",
        "\uD804\uDC6F"
    ],
    "cakm": [
        "\uD804\uDD36",
        "\uD804\uDD37",
        "\uD804\uDD38",
        "\uD804\uDD39",
        "\uD804\uDD3A",
        "\uD804\uDD3B",
        "\uD804\uDD3C",
        "\uD804\uDD3D",
        "\uD804\uDD3E",
        "\uD804\uDD3F"
    ],
    "cham": [
        "\uAA50",
        "\uAA51",
        "\uAA52",
        "\uAA53",
        "\uAA54",
        "\uAA55",
        "\uAA56",
        "\uAA57",
        "\uAA58",
        "\uAA59"
    ],
    "deva": [
        "\u0966",
        "\u0967",
        "\u0968",
        "\u0969",
        "\u096A",
        "\u096B",
        "\u096C",
        "\u096D",
        "\u096E",
        "\u096F"
    ],
    "diak": [
        "\uD806\uDD50",
        "\uD806\uDD51",
        "\uD806\uDD52",
        "\uD806\uDD53",
        "\uD806\uDD54",
        "\uD806\uDD55",
        "\uD806\uDD56",
        "\uD806\uDD57",
        "\uD806\uDD58",
        "\uD806\uDD59"
    ],
    "fullwide": [
        "\uFF10",
        "\uFF11",
        "\uFF12",
        "\uFF13",
        "\uFF14",
        "\uFF15",
        "\uFF16",
        "\uFF17",
        "\uFF18",
        "\uFF19"
    ],
    "gong": [
        "\uD807\uDDA0",
        "\uD807\uDDA1",
        "\uD807\uDDA2",
        "\uD807\uDDA3",
        "\uD807\uDDA4",
        "\uD807\uDDA5",
        "\uD807\uDDA6",
        "\uD807\uDDA7",
        "\uD807\uDDA8",
        "\uD807\uDDA9"
    ],
    "gonm": [
        "\uD807\uDD50",
        "\uD807\uDD51",
        "\uD807\uDD52",
        "\uD807\uDD53",
        "\uD807\uDD54",
        "\uD807\uDD55",
        "\uD807\uDD56",
        "\uD807\uDD57",
        "\uD807\uDD58",
        "\uD807\uDD59"
    ],
    "gujr": [
        "\u0AE6",
        "\u0AE7",
        "\u0AE8",
        "\u0AE9",
        "\u0AEA",
        "\u0AEB",
        "\u0AEC",
        "\u0AED",
        "\u0AEE",
        "\u0AEF"
    ],
    "guru": [
        "\u0A66",
        "\u0A67",
        "\u0A68",
        "\u0A69",
        "\u0A6A",
        "\u0A6B",
        "\u0A6C",
        "\u0A6D",
        "\u0A6E",
        "\u0A6F"
    ],
    "hanidec": [
        "\u3007",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D"
    ],
    "hmng": [
        "\uD81A\uDF50",
        "\uD81A\uDF51",
        "\uD81A\uDF52",
        "\uD81A\uDF53",
        "\uD81A\uDF54",
        "\uD81A\uDF55",
        "\uD81A\uDF56",
        "\uD81A\uDF57",
        "\uD81A\uDF58",
        "\uD81A\uDF59"
    ],
    "hmnp": [
        "\uD838\uDD40",
        "\uD838\uDD41",
        "\uD838\uDD42",
        "\uD838\uDD43",
        "\uD838\uDD44",
        "\uD838\uDD45",
        "\uD838\uDD46",
        "\uD838\uDD47",
        "\uD838\uDD48",
        "\uD838\uDD49"
    ],
    "java": [
        "\uA9D0",
        "\uA9D1",
        "\uA9D2",
        "\uA9D3",
        "\uA9D4",
        "\uA9D5",
        "\uA9D6",
        "\uA9D7",
        "\uA9D8",
        "\uA9D9"
    ],
    "kali": [
        "\uA900",
        "\uA901",
        "\uA902",
        "\uA903",
        "\uA904",
        "\uA905",
        "\uA906",
        "\uA907",
        "\uA908",
        "\uA909"
    ],
    "khmr": [
        "\u17E0",
        "\u17E1",
        "\u17E2",
        "\u17E3",
        "\u17E4",
        "\u17E5",
        "\u17E6",
        "\u17E7",
        "\u17E8",
        "\u17E9"
    ],
    "knda": [
        "\u0CE6",
        "\u0CE7",
        "\u0CE8",
        "\u0CE9",
        "\u0CEA",
        "\u0CEB",
        "\u0CEC",
        "\u0CED",
        "\u0CEE",
        "\u0CEF"
    ],
    "lana": [
        "\u1A80",
        "\u1A81",
        "\u1A82",
        "\u1A83",
        "\u1A84",
        "\u1A85",
        "\u1A86",
        "\u1A87",
        "\u1A88",
        "\u1A89"
    ],
    "lanatham": [
        "\u1A90",
        "\u1A91",
        "\u1A92",
        "\u1A93",
        "\u1A94",
        "\u1A95",
        "\u1A96",
        "\u1A97",
        "\u1A98",
        "\u1A99"
    ],
    "laoo": [
        "\u0ED0",
        "\u0ED1",
        "\u0ED2",
        "\u0ED3",
        "\u0ED4",
        "\u0ED5",
        "\u0ED6",
        "\u0ED7",
        "\u0ED8",
        "\u0ED9"
    ],
    "lepc": [
        "\u1A90",
        "\u1A91",
        "\u1A92",
        "\u1A93",
        "\u1A94",
        "\u1A95",
        "\u1A96",
        "\u1A97",
        "\u1A98",
        "\u1A99"
    ],
    "limb": [
        "\u1946",
        "\u1947",
        "\u1948",
        "\u1949",
        "\u194A",
        "\u194B",
        "\u194C",
        "\u194D",
        "\u194E",
        "\u194F"
    ],
    "mathbold": [
        "\uD835\uDFCE",
        "\uD835\uDFCF",
        "\uD835\uDFD0",
        "\uD835\uDFD1",
        "\uD835\uDFD2",
        "\uD835\uDFD3",
        "\uD835\uDFD4",
        "\uD835\uDFD5",
        "\uD835\uDFD6",
        "\uD835\uDFD7"
    ],
    "mathdbl": [
        "\uD835\uDFD8",
        "\uD835\uDFD9",
        "\uD835\uDFDA",
        "\uD835\uDFDB",
        "\uD835\uDFDC",
        "\uD835\uDFDD",
        "\uD835\uDFDE",
        "\uD835\uDFDF",
        "\uD835\uDFE0",
        "\uD835\uDFE1"
    ],
    "mathmono": [
        "\uD835\uDFF6",
        "\uD835\uDFF7",
        "\uD835\uDFF8",
        "\uD835\uDFF9",
        "\uD835\uDFFA",
        "\uD835\uDFFB",
        "\uD835\uDFFC",
        "\uD835\uDFFD",
        "\uD835\uDFFE",
        "\uD835\uDFFF"
    ],
    "mathsanb": [
        "\uD835\uDFEC",
        "\uD835\uDFED",
        "\uD835\uDFEE",
        "\uD835\uDFEF",
        "\uD835\uDFF0",
        "\uD835\uDFF1",
        "\uD835\uDFF2",
        "\uD835\uDFF3",
        "\uD835\uDFF4",
        "\uD835\uDFF5"
    ],
    "mathsans": [
        "\uD835\uDFE2",
        "\uD835\uDFE3",
        "\uD835\uDFE4",
        "\uD835\uDFE5",
        "\uD835\uDFE6",
        "\uD835\uDFE7",
        "\uD835\uDFE8",
        "\uD835\uDFE9",
        "\uD835\uDFEA",
        "\uD835\uDFEB"
    ],
    "mlym": [
        "\u0D66",
        "\u0D67",
        "\u0D68",
        "\u0D69",
        "\u0D6A",
        "\u0D6B",
        "\u0D6C",
        "\u0D6D",
        "\u0D6E",
        "\u0D6F"
    ],
    "modi": [
        "\uD805\uDE50",
        "\uD805\uDE51",
        "\uD805\uDE52",
        "\uD805\uDE53",
        "\uD805\uDE54",
        "\uD805\uDE55",
        "\uD805\uDE56",
        "\uD805\uDE57",
        "\uD805\uDE58",
        "\uD805\uDE59"
    ],
    "mong": [
        "\u1810",
        "\u1811",
        "\u1812",
        "\u1813",
        "\u1814",
        "\u1815",
        "\u1816",
        "\u1817",
        "\u1818",
        "\u1819"
    ],
    "mroo": [
        "\uD81A\uDE60",
        "\uD81A\uDE61",
        "\uD81A\uDE62",
        "\uD81A\uDE63",
        "\uD81A\uDE64",
        "\uD81A\uDE65",
        "\uD81A\uDE66",
        "\uD81A\uDE67",
        "\uD81A\uDE68",
        "\uD81A\uDE69"
    ],
    "mtei": [
        "\uABF0",
        "\uABF1",
        "\uABF2",
        "\uABF3",
        "\uABF4",
        "\uABF5",
        "\uABF6",
        "\uABF7",
        "\uABF8",
        "\uABF9"
    ],
    "mymr": [
        "\u1040",
        "\u1041",
        "\u1042",
        "\u1043",
        "\u1044",
        "\u1045",
        "\u1046",
        "\u1047",
        "\u1048",
        "\u1049"
    ],
    "mymrshan": [
        "\u1090",
        "\u1091",
        "\u1092",
        "\u1093",
        "\u1094",
        "\u1095",
        "\u1096",
        "\u1097",
        "\u1098",
        "\u1099"
    ],
    "mymrtlng": [
        "\uA9F0",
        "\uA9F1",
        "\uA9F2",
        "\uA9F3",
        "\uA9F4",
        "\uA9F5",
        "\uA9F6",
        "\uA9F7",
        "\uA9F8",
        "\uA9F9"
    ],
    "newa": [
        "\uD805\uDC50",
        "\uD805\uDC51",
        "\uD805\uDC52",
        "\uD805\uDC53",
        "\uD805\uDC54",
        "\uD805\uDC55",
        "\uD805\uDC56",
        "\uD805\uDC57",
        "\uD805\uDC58",
        "\uD805\uDC59"
    ],
    "nkoo": [
        "\u07C0",
        "\u07C1",
        "\u07C2",
        "\u07C3",
        "\u07C4",
        "\u07C5",
        "\u07C6",
        "\u07C7",
        "\u07C8",
        "\u07C9"
    ],
    "olck": [
        "\u1C50",
        "\u1C51",
        "\u1C52",
        "\u1C53",
        "\u1C54",
        "\u1C55",
        "\u1C56",
        "\u1C57",
        "\u1C58",
        "\u1C59"
    ],
    "orya": [
        "\u0B66",
        "\u0B67",
        "\u0B68",
        "\u0B69",
        "\u0B6A",
        "\u0B6B",
        "\u0B6C",
        "\u0B6D",
        "\u0B6E",
        "\u0B6F"
    ],
    "osma": [
        "\uD801\uDCA0",
        "\uD801\uDCA1",
        "\uD801\uDCA2",
        "\uD801\uDCA3",
        "\uD801\uDCA4",
        "\uD801\uDCA5",
        "\uD801\uDCA6",
        "\uD801\uDCA7",
        "\uD801\uDCA8",
        "\uD801\uDCA9"
    ],
    "rohg": [
        "\uD803\uDD30",
        "\uD803\uDD31",
        "\uD803\uDD32",
        "\uD803\uDD33",
        "\uD803\uDD34",
        "\uD803\uDD35",
        "\uD803\uDD36",
        "\uD803\uDD37",
        "\uD803\uDD38",
        "\uD803\uDD39"
    ],
    "saur": [
        "\uA8D0",
        "\uA8D1",
        "\uA8D2",
        "\uA8D3",
        "\uA8D4",
        "\uA8D5",
        "\uA8D6",
        "\uA8D7",
        "\uA8D8",
        "\uA8D9"
    ],
    "segment": [
        "\uD83E\uDFF0",
        "\uD83E\uDFF1",
        "\uD83E\uDFF2",
        "\uD83E\uDFF3",
        "\uD83E\uDFF4",
        "\uD83E\uDFF5",
        "\uD83E\uDFF6",
        "\uD83E\uDFF7",
        "\uD83E\uDFF8",
        "\uD83E\uDFF9"
    ],
    "shrd": [
        "\uD804\uDDD0",
        "\uD804\uDDD1",
        "\uD804\uDDD2",
        "\uD804\uDDD3",
        "\uD804\uDDD4",
        "\uD804\uDDD5",
        "\uD804\uDDD6",
        "\uD804\uDDD7",
        "\uD804\uDDD8",
        "\uD804\uDDD9"
    ],
    "sind": [
        "\uD804\uDEF0",
        "\uD804\uDEF1",
        "\uD804\uDEF2",
        "\uD804\uDEF3",
        "\uD804\uDEF4",
        "\uD804\uDEF5",
        "\uD804\uDEF6",
        "\uD804\uDEF7",
        "\uD804\uDEF8",
        "\uD804\uDEF9"
    ],
    "sinh": [
        "\u0DE6",
        "\u0DE7",
        "\u0DE8",
        "\u0DE9",
        "\u0DEA",
        "\u0DEB",
        "\u0DEC",
        "\u0DED",
        "\u0DEE",
        "\u0DEF"
    ],
    "sora": [
        "\uD804\uDCF0",
        "\uD804\uDCF1",
        "\uD804\uDCF2",
        "\uD804\uDCF3",
        "\uD804\uDCF4",
        "\uD804\uDCF5",
        "\uD804\uDCF6",
        "\uD804\uDCF7",
        "\uD804\uDCF8",
        "\uD804\uDCF9"
    ],
    "sund": [
        "\u1BB0",
        "\u1BB1",
        "\u1BB2",
        "\u1BB3",
        "\u1BB4",
        "\u1BB5",
        "\u1BB6",
        "\u1BB7",
        "\u1BB8",
        "\u1BB9"
    ],
    "takr": [
        "\uD805\uDEC0",
        "\uD805\uDEC1",
        "\uD805\uDEC2",
        "\uD805\uDEC3",
        "\uD805\uDEC4",
        "\uD805\uDEC5",
        "\uD805\uDEC6",
        "\uD805\uDEC7",
        "\uD805\uDEC8",
        "\uD805\uDEC9"
    ],
    "talu": [
        "\u19D0",
        "\u19D1",
        "\u19D2",
        "\u19D3",
        "\u19D4",
        "\u19D5",
        "\u19D6",
        "\u19D7",
        "\u19D8",
        "\u19D9"
    ],
    "tamldec": [
        "\u0BE6",
        "\u0BE7",
        "\u0BE8",
        "\u0BE9",
        "\u0BEA",
        "\u0BEB",
        "\u0BEC",
        "\u0BED",
        "\u0BEE",
        "\u0BEF"
    ],
    "telu": [
        "\u0C66",
        "\u0C67",
        "\u0C68",
        "\u0C69",
        "\u0C6A",
        "\u0C6B",
        "\u0C6C",
        "\u0C6D",
        "\u0C6E",
        "\u0C6F"
    ],
    "thai": [
        "\u0E50",
        "\u0E51",
        "\u0E52",
        "\u0E53",
        "\u0E54",
        "\u0E55",
        "\u0E56",
        "\u0E57",
        "\u0E58",
        "\u0E59"
    ],
    "tibt": [
        "\u0F20",
        "\u0F21",
        "\u0F22",
        "\u0F23",
        "\u0F24",
        "\u0F25",
        "\u0F26",
        "\u0F27",
        "\u0F28",
        "\u0F29"
    ],
    "tirh": [
        "\uD805\uDCD0",
        "\uD805\uDCD1",
        "\uD805\uDCD2",
        "\uD805\uDCD3",
        "\uD805\uDCD4",
        "\uD805\uDCD5",
        "\uD805\uDCD6",
        "\uD805\uDCD7",
        "\uD805\uDCD8",
        "\uD805\uDCD9"
    ],
    "vaii": [
        "\u1620",
        "\u1621",
        "\u1622",
        "\u1623",
        "\u1624",
        "\u1625",
        "\u1626",
        "\u1627",
        "\u1628",
        "\u1629"
    ],
    "wara": [
        "\uD806\uDCE0",
        "\uD806\uDCE1",
        "\uD806\uDCE2",
        "\uD806\uDCE3",
        "\uD806\uDCE4",
        "\uD806\uDCE5",
        "\uD806\uDCE6",
        "\uD806\uDCE7",
        "\uD806\uDCE8",
        "\uD806\uDCE9"
    ],
    "wcho": [
        "\uD838\uDEF0",
        "\uD838\uDEF1",
        "\uD838\uDEF2",
        "\uD838\uDEF3",
        "\uD838\uDEF4",
        "\uD838\uDEF5",
        "\uD838\uDEF6",
        "\uD838\uDEF7",
        "\uD838\uDEF8",
        "\uD838\uDEF9"
    ]
};

});

parcelRegister("3FweZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.S_UNICODE_REGEX = void 0;
// @generated from regex-gen.ts
module.exports.S_UNICODE_REGEX = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEE0-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDD78\uDD7A-\uDDCB\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6\uDF00-\uDF92\uDF94-\uDFCA]/;

});





parcelRegister("9nsc6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericRangeToParts = void 0;

var $ePJzc = parcelRequire("ePJzc");
/**
 * https://tc39.es/ecma402/#sec-formatnumericrangetoparts
 */ function $6d3c21d16f5c080c$var$FormatNumericRangeToParts(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var parts = (0, $ePJzc.PartitionNumberRangePattern)(numberFormat, x, y, {
        getInternalSlots: getInternalSlots
    });
    return parts.map(function(part, index) {
        return {
            type: part.type,
            value: part.value,
            source: part.source,
            result: index.toString()
        };
    });
}
module.exports.FormatNumericRangeToParts = $6d3c21d16f5c080c$var$FormatNumericRangeToParts;

});

parcelRegister("4x8kW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericToParts = void 0;

var $8gDXg = parcelRequire("8gDXg");

var $itFDr = parcelRequire("itFDr");
function $34d0b605fb01f11f$var$FormatNumericToParts(nf, x, implDetails) {
    var parts = (0, $8gDXg.PartitionNumberPattern)(nf, x, implDetails);
    var result = (0, $itFDr.ArrayCreate)(0);
    for(var _i = 0, parts_1 = parts; _i < parts_1.length; _i++){
        var part = parts_1[_i];
        result.push({
            type: part.type,
            value: part.value
        });
    }
    return result;
}
module.exports.FormatNumericToParts = $34d0b605fb01f11f$var$FormatNumericToParts;

});

parcelRegister("cvmB1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetUnsignedRoundingMode = void 0;
var $91a9e86627581753$var$negativeMapping = {
    ceil: "zero",
    floor: "infinity",
    expand: "infinity",
    trunc: "zero",
    halfCeil: "half-zero",
    halfFloor: "half-infinity",
    halfExpand: "half-infinity",
    halfTrunc: "half-zero",
    halfEven: "half-even"
};
var $91a9e86627581753$var$positiveMapping = {
    ceil: "infinity",
    floor: "zero",
    expand: "infinity",
    trunc: "zero",
    halfCeil: "half-infinity",
    halfFloor: "half-zero",
    halfExpand: "half-infinity",
    halfTrunc: "half-zero",
    halfEven: "half-even"
};
function $91a9e86627581753$var$GetUnsignedRoundingMode(roundingMode, isNegative) {
    if (isNegative) return $91a9e86627581753$var$negativeMapping[roundingMode];
    return $91a9e86627581753$var$positiveMapping[roundingMode];
}
module.exports.GetUnsignedRoundingMode = $91a9e86627581753$var$GetUnsignedRoundingMode;

});

parcelRegister("ew2yd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InitializeNumberFormat = void 0;

var $j8Gi0 = parcelRequire("j8Gi0");

var $1nC8W = parcelRequire("1nC8W");

var $haz9y = parcelRequire("haz9y");

var $7ZXeE = parcelRequire("7ZXeE");

var $iQ9Nx = parcelRequire("iQ9Nx");

var $dRPEu = parcelRequire("dRPEu");

var $eTSkB = parcelRequire("eTSkB");

var $3sO81 = parcelRequire("3sO81");

var $8tfDO = parcelRequire("8tfDO");

var $i0NhQ = parcelRequire("i0NhQ");
var $a916086a2f4d7c0f$var$VALID_ROUND_INCREMENT_VALUES = [
    1,
    2,
    5,
    10,
    20,
    25,
    50,
    100,
    200,
    250,
    500,
    1000,
    2000
];
/**
 * https://tc39.es/ecma402/#sec-initializenumberformat
 */ function $a916086a2f4d7c0f$var$InitializeNumberFormat(nf, locales, opts, _a) {
    var getInternalSlots = _a.getInternalSlots, localeData = _a.localeData, availableLocales = _a.availableLocales, numberingSystemNames = _a.numberingSystemNames, getDefaultLocale = _a.getDefaultLocale, currencyDigitsData = _a.currencyDigitsData;
    // @ts-ignore
    var requestedLocales = (0, $1nC8W.CanonicalizeLocaleList)(locales);
    var options = (0, $haz9y.CoerceOptionsToObject)(opts);
    var opt = Object.create(null);
    var matcher = (0, $iQ9Nx.GetOption)(options, "localeMatcher", "string", [
        "lookup",
        "best fit"
    ], "best fit");
    opt.localeMatcher = matcher;
    var numberingSystem = (0, $iQ9Nx.GetOption)(options, "numberingSystem", "string", undefined, undefined);
    if (numberingSystem !== undefined && numberingSystemNames.indexOf(numberingSystem) < 0) // 8.a. If numberingSystem does not match the Unicode Locale Identifier type nonterminal,
    // throw a RangeError exception.
    throw RangeError("Invalid numberingSystems: ".concat(numberingSystem));
    opt.nu = numberingSystem;
    var r = (0, $j8Gi0.ResolveLocale)(Array.from(availableLocales), requestedLocales, opt, // [[RelevantExtensionKeys]] slot, which is a constant
    [
        "nu"
    ], localeData, getDefaultLocale);
    var dataLocaleData = localeData[r.dataLocale];
    (0, $eTSkB.invariant)(!!dataLocaleData, "Missing locale data for ".concat(r.dataLocale));
    var internalSlots = getInternalSlots(nf);
    internalSlots.locale = r.locale;
    internalSlots.dataLocale = r.dataLocale;
    internalSlots.numberingSystem = r.nu;
    internalSlots.dataLocaleData = dataLocaleData;
    (0, $i0NhQ.SetNumberFormatUnitOptions)(nf, options, {
        getInternalSlots: getInternalSlots
    });
    var style = internalSlots.style;
    var mnfdDefault;
    var mxfdDefault;
    if (style === "currency") {
        var currency = internalSlots.currency;
        var cDigits = (0, $3sO81.CurrencyDigits)(currency, {
            currencyDigitsData: currencyDigitsData
        });
        mnfdDefault = cDigits;
        mxfdDefault = cDigits;
    } else {
        mnfdDefault = 0;
        mxfdDefault = style === "percent" ? 0 : 3;
    }
    var notation = (0, $iQ9Nx.GetOption)(options, "notation", "string", [
        "standard",
        "scientific",
        "engineering",
        "compact"
    ], "standard");
    internalSlots.notation = notation;
    (0, $8tfDO.SetNumberFormatDigitOptions)(internalSlots, options, mnfdDefault, mxfdDefault, notation);
    var roundingIncrement = (0, $7ZXeE.GetNumberOption)(options, "roundingIncrement", 1, 5000, 1);
    if ($a916086a2f4d7c0f$var$VALID_ROUND_INCREMENT_VALUES.indexOf(roundingIncrement) === -1) throw new RangeError("Invalid rounding increment value: ".concat(roundingIncrement, ".\nValid values are ").concat($a916086a2f4d7c0f$var$VALID_ROUND_INCREMENT_VALUES, "."));
    if (roundingIncrement !== 1 && internalSlots.roundingType !== "fractionDigits") throw new TypeError("For roundingIncrement > 1 only fractionDigits is a valid roundingType");
    if (roundingIncrement !== 1 && internalSlots.maximumFractionDigits !== internalSlots.minimumFractionDigits) throw new RangeError("With roundingIncrement > 1, maximumFractionDigits and minimumFractionDigits must be equal.");
    internalSlots.roundingIncrement = roundingIncrement;
    var trailingZeroDisplay = (0, $iQ9Nx.GetOption)(options, "trailingZeroDisplay", "string", [
        "auto",
        "stripIfInteger"
    ], "auto");
    internalSlots.trailingZeroDisplay = trailingZeroDisplay;
    var compactDisplay = (0, $iQ9Nx.GetOption)(options, "compactDisplay", "string", [
        "short",
        "long"
    ], "short");
    var defaultUseGrouping = "auto";
    if (notation === "compact") {
        internalSlots.compactDisplay = compactDisplay;
        defaultUseGrouping = "min2";
    }
    internalSlots.useGrouping = (0, $dRPEu.GetStringOrBooleanOption)(options, "useGrouping", [
        "min2",
        "auto",
        "always"
    ], "always", false, defaultUseGrouping);
    internalSlots.signDisplay = (0, $iQ9Nx.GetOption)(options, "signDisplay", "string", [
        "auto",
        "never",
        "always",
        "exceptZero",
        "negative"
    ], "auto");
    internalSlots.roundingMode = (0, $iQ9Nx.GetOption)(options, "roundingMode", "string", [
        "ceil",
        "floor",
        "expand",
        "trunc",
        "halfCeil",
        "halfFloor",
        "halfExpand",
        "halfTrunc",
        "halfEven"
    ], "halfExpand");
    return nf;
}
module.exports.InitializeNumberFormat = $a916086a2f4d7c0f$var$InitializeNumberFormat;

});
parcelRegister("j8Gi0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResolveLocale = module.exports.LookupSupportedLocales = module.exports.match = void 0;

var $4dQ88 = parcelRequire("4dQ88");

var $jGJYo = parcelRequire("jGJYo");
function $deef917f94e28ac4$var$match(requestedLocales, availableLocales, defaultLocale, opts) {
    return (0, $jGJYo.ResolveLocale)(availableLocales, (0, $4dQ88.CanonicalizeLocaleList)(requestedLocales), {
        localeMatcher: (opts === null || opts === void 0 ? void 0 : opts.algorithm) || "best fit"
    }, [], {}, function() {
        return defaultLocale;
    }).locale;
}
module.exports.match = $deef917f94e28ac4$var$match;

var $hOPr8 = parcelRequire("hOPr8");
Object.defineProperty(module.exports, "LookupSupportedLocales", {
    enumerable: true,
    get: function() {
        return $hOPr8.LookupSupportedLocales;
    }
});

var $jGJYo = parcelRequire("jGJYo");
Object.defineProperty(module.exports, "ResolveLocale", {
    enumerable: true,
    get: function() {
        return $jGJYo.ResolveLocale;
    }
});

});
parcelRegister("4dQ88", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CanonicalizeLocaleList = void 0;
/**
 * http://ecma-international.org/ecma-402/7.0/index.html#sec-canonicalizelocalelist
 * @param locales
 */ function $3130d04eccb67f94$var$CanonicalizeLocaleList(locales) {
    // TODO
    return Intl.getCanonicalLocales(locales);
}
module.exports.CanonicalizeLocaleList = $3130d04eccb67f94$var$CanonicalizeLocaleList;

});

parcelRegister("jGJYo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResolveLocale = void 0;

var $3fKI4 = parcelRequire("3fKI4");

var $4JtIr = parcelRequire("4JtIr");

var $20qwb = parcelRequire("20qwb");

var $9F8ll = parcelRequire("9F8ll");
/**
 * https://tc39.es/ecma402/#sec-resolvelocale
 */ function $e55599d63e4a3fdb$var$ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData, getDefaultLocale) {
    var matcher = options.localeMatcher;
    var r;
    if (matcher === "lookup") r = (0, $4JtIr.LookupMatcher)(Array.from(availableLocales), requestedLocales, getDefaultLocale);
    else r = (0, $3fKI4.BestFitMatcher)(Array.from(availableLocales), requestedLocales, getDefaultLocale);
    var foundLocale = r.locale;
    var result = {
        locale: "",
        dataLocale: foundLocale
    };
    var supportedExtension = "-u";
    for(var _i = 0, relevantExtensionKeys_1 = relevantExtensionKeys; _i < relevantExtensionKeys_1.length; _i++){
        var key = relevantExtensionKeys_1[_i];
        (0, $9F8ll.invariant)(foundLocale in localeData, "Missing locale data for ".concat(foundLocale));
        var foundLocaleData = localeData[foundLocale];
        (0, $9F8ll.invariant)(typeof foundLocaleData === "object" && foundLocaleData !== null, "locale data ".concat(key, " must be an object"));
        var keyLocaleData = foundLocaleData[key];
        (0, $9F8ll.invariant)(Array.isArray(keyLocaleData), "keyLocaleData for ".concat(key, " must be an array"));
        var value = keyLocaleData[0];
        (0, $9F8ll.invariant)(typeof value === "string" || value === null, "value must be string or null but got ".concat(typeof value, " in key ").concat(key));
        var supportedExtensionAddition = "";
        if (r.extension) {
            var requestedValue = (0, $20qwb.UnicodeExtensionValue)(r.extension, key);
            if (requestedValue !== undefined) {
                if (requestedValue !== "") {
                    if (~keyLocaleData.indexOf(requestedValue)) {
                        value = requestedValue;
                        supportedExtensionAddition = "-".concat(key, "-").concat(value);
                    }
                } else if (~requestedValue.indexOf("true")) {
                    value = "true";
                    supportedExtensionAddition = "-".concat(key);
                }
            }
        }
        if (key in options) {
            var optionsValue = options[key];
            (0, $9F8ll.invariant)(typeof optionsValue === "string" || typeof optionsValue === "undefined" || optionsValue === null, "optionsValue must be String, Undefined or Null");
            if (~keyLocaleData.indexOf(optionsValue)) {
                if (optionsValue !== value) {
                    value = optionsValue;
                    supportedExtensionAddition = "";
                }
            }
        }
        result[key] = value;
        supportedExtension += supportedExtensionAddition;
    }
    if (supportedExtension.length > 2) {
        var privateIndex = foundLocale.indexOf("-x-");
        if (privateIndex === -1) foundLocale = foundLocale + supportedExtension;
        else {
            var preExtension = foundLocale.slice(0, privateIndex);
            var postExtension = foundLocale.slice(privateIndex, foundLocale.length);
            foundLocale = preExtension + supportedExtension + postExtension;
        }
        foundLocale = Intl.getCanonicalLocales(foundLocale)[0];
    }
    result.locale = foundLocale;
    return result;
}
module.exports.ResolveLocale = $e55599d63e4a3fdb$var$ResolveLocale;

});
parcelRegister("3fKI4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BestFitMatcher = void 0;

var $9F8ll = parcelRequire("9F8ll");
/**
 * https://tc39.es/ecma402/#sec-bestfitmatcher
 * @param availableLocales
 * @param requestedLocales
 * @param getDefaultLocale
 */ function $25e70165cbc97c43$var$BestFitMatcher(availableLocales, requestedLocales, getDefaultLocale) {
    var foundLocale;
    var extension;
    for(var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++){
        var l = requestedLocales_1[_i];
        var matchedLocale = (0, $9F8ll.findBestMatch)(l.replace($9F8ll.UNICODE_EXTENSION_SEQUENCE_REGEX, ""), availableLocales);
        if (matchedLocale) {
            foundLocale = matchedLocale;
            var noExtensionLocale = l.replace($9F8ll.UNICODE_EXTENSION_SEQUENCE_REGEX, "");
            extension = l.slice(noExtensionLocale.length, l.length) || undefined;
            break;
        }
    }
    if (!foundLocale) return {
        locale: getDefaultLocale()
    };
    return {
        locale: foundLocale,
        extension: extension
    };
}
module.exports.BestFitMatcher = $25e70165cbc97c43$var$BestFitMatcher;

});
parcelRegister("9F8ll", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findBestMatch = module.exports.findMatchingDistance = module.exports.invariant = module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $h965K = parcelRequire("h965K");

var $5Q9VP = parcelRequire("5Q9VP");
module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function $708e6a35c6f226b5$var$invariant(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
module.exports.invariant = $708e6a35c6f226b5$var$invariant;
// This is effectively 2 languages in 2 different regions not even in the same cluster
var $708e6a35c6f226b5$var$DEFAULT_MATCHING_THRESHOLD = 840;
var $708e6a35c6f226b5$var$PROCESSED_DATA;
function $708e6a35c6f226b5$var$processData() {
    var _a, _b;
    if (!$708e6a35c6f226b5$var$PROCESSED_DATA) {
        var paradigmLocales = (_b = (_a = $h965K.data.supplemental.languageMatching["written-new"][0]) === null || _a === void 0 ? void 0 : _a.paradigmLocales) === null || _b === void 0 ? void 0 : _b._locales.split(" ");
        var matchVariables = $h965K.data.supplemental.languageMatching["written-new"].slice(1, 5);
        var data = $h965K.data.supplemental.languageMatching["written-new"].slice(5);
        var matches = data.map(function(d) {
            var key = Object.keys(d)[0];
            var value = d[key];
            return {
                supported: key,
                desired: value._desired,
                distance: +value._distance,
                oneway: value.oneway === "true" ? true : false
            };
        }, {});
        $708e6a35c6f226b5$var$PROCESSED_DATA = {
            matches: matches,
            matchVariables: matchVariables.reduce(function(all, d) {
                var key = Object.keys(d)[0];
                var value = d[key];
                all[key.slice(1)] = value._value.split("+");
                return all;
            }, {}),
            paradigmLocales: $eIwgG.__spreadArray($eIwgG.__spreadArray([], paradigmLocales, true), paradigmLocales.map(function(l) {
                return new Intl.Locale(l.replace(/_/g, "-")).maximize().toString();
            }), true)
        };
    }
    return $708e6a35c6f226b5$var$PROCESSED_DATA;
}
function $708e6a35c6f226b5$var$isMatched(locale, languageMatchInfoLocale, matchVariables) {
    var _a = languageMatchInfoLocale.split("-"), language = _a[0], script = _a[1], region = _a[2];
    var matches = true;
    if (region && region[0] === "$") {
        var shouldInclude = region[1] !== "!";
        var matchRegions = shouldInclude ? matchVariables[region.slice(1)] : matchVariables[region.slice(2)];
        var expandedMatchedRegions = matchRegions.map(function(r) {
            return $5Q9VP.regions[r] || [
                r
            ];
        }).reduce(function(all, list) {
            return $eIwgG.__spreadArray($eIwgG.__spreadArray([], all, true), list, true);
        }, []);
        matches && (matches = !(expandedMatchedRegions.indexOf(locale.region || "") > 1 != shouldInclude));
    } else matches && (matches = locale.region ? region === "*" || region === locale.region : true);
    matches && (matches = locale.script ? script === "*" || script === locale.script : true);
    matches && (matches = locale.language ? language === "*" || language === locale.language : true);
    return matches;
}
function $708e6a35c6f226b5$var$serializeLSR(lsr) {
    return [
        lsr.language,
        lsr.script,
        lsr.region
    ].filter(Boolean).join("-");
}
function $708e6a35c6f226b5$var$findMatchingDistanceForLSR(desired, supported, data) {
    for(var _i = 0, _a = data.matches; _i < _a.length; _i++){
        var d = _a[_i];
        var matches = $708e6a35c6f226b5$var$isMatched(desired, d.desired, data.matchVariables) && $708e6a35c6f226b5$var$isMatched(supported, d.supported, data.matchVariables);
        if (!d.oneway && !matches) matches = $708e6a35c6f226b5$var$isMatched(desired, d.supported, data.matchVariables) && $708e6a35c6f226b5$var$isMatched(supported, d.desired, data.matchVariables);
        if (matches) {
            var distance = d.distance * 10;
            if (data.paradigmLocales.indexOf($708e6a35c6f226b5$var$serializeLSR(desired)) > -1 != data.paradigmLocales.indexOf($708e6a35c6f226b5$var$serializeLSR(supported)) > -1) return distance - 1;
            return distance;
        }
    }
    throw new Error("No matching distance found");
}
function $708e6a35c6f226b5$var$findMatchingDistance(desired, supported) {
    var desiredLocale = new Intl.Locale(desired).maximize();
    var supportedLocale = new Intl.Locale(supported).maximize();
    var desiredLSR = {
        language: desiredLocale.language,
        script: desiredLocale.script || "",
        region: desiredLocale.region || ""
    };
    var supportedLSR = {
        language: supportedLocale.language,
        script: supportedLocale.script || "",
        region: supportedLocale.region || ""
    };
    var matchingDistance = 0;
    var data = $708e6a35c6f226b5$var$processData();
    if (desiredLSR.language !== supportedLSR.language) matchingDistance += $708e6a35c6f226b5$var$findMatchingDistanceForLSR({
        language: desiredLocale.language,
        script: "",
        region: ""
    }, {
        language: supportedLocale.language,
        script: "",
        region: ""
    }, data);
    if (desiredLSR.script !== supportedLSR.script) matchingDistance += $708e6a35c6f226b5$var$findMatchingDistanceForLSR({
        language: desiredLocale.language,
        script: desiredLSR.script,
        region: ""
    }, {
        language: supportedLocale.language,
        script: desiredLSR.script,
        region: ""
    }, data);
    if (desiredLSR.region !== supportedLSR.region) matchingDistance += $708e6a35c6f226b5$var$findMatchingDistanceForLSR(desiredLSR, supportedLSR, data);
    return matchingDistance;
}
module.exports.findMatchingDistance = $708e6a35c6f226b5$var$findMatchingDistance;
function $708e6a35c6f226b5$var$findBestMatch(desired, supportedLocales, threshold) {
    if (threshold === void 0) threshold = $708e6a35c6f226b5$var$DEFAULT_MATCHING_THRESHOLD;
    var bestMatch = undefined;
    var lowestDistance = Infinity;
    supportedLocales.forEach(function(supported, i) {
        // Add some weight to the distance based on the order of the supported locales
        var distance = $708e6a35c6f226b5$var$findMatchingDistance(desired, supported) + i;
        if (distance < lowestDistance) {
            lowestDistance = distance;
            bestMatch = supported;
        }
    });
    if (lowestDistance >= threshold) return;
    return bestMatch;
}
module.exports.findBestMatch = $708e6a35c6f226b5$var$findBestMatch;

});
parcelRegister("h965K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.data = void 0;
module.exports.data = {
    supplemental: {
        languageMatching: {
            "written-new": [
                {
                    paradigmLocales: {
                        _locales: "en en_GB es es_419 pt_BR pt_PT"
                    }
                },
                {
                    $enUS: {
                        _value: "AS+CA+GU+MH+MP+PH+PR+UM+US+VI"
                    }
                },
                {
                    $cnsar: {
                        _value: "HK+MO"
                    }
                },
                {
                    $americas: {
                        _value: "019"
                    }
                },
                {
                    $maghreb: {
                        _value: "MA+DZ+TN+LY+MR+EH"
                    }
                },
                {
                    no: {
                        _desired: "nb",
                        _distance: "1"
                    }
                },
                {
                    bs: {
                        _desired: "hr",
                        _distance: "4"
                    }
                },
                {
                    bs: {
                        _desired: "sh",
                        _distance: "4"
                    }
                },
                {
                    hr: {
                        _desired: "sh",
                        _distance: "4"
                    }
                },
                {
                    sr: {
                        _desired: "sh",
                        _distance: "4"
                    }
                },
                {
                    aa: {
                        _desired: "ssy",
                        _distance: "4"
                    }
                },
                {
                    de: {
                        _desired: "gsw",
                        _distance: "4",
                        _oneway: "true"
                    }
                },
                {
                    de: {
                        _desired: "lb",
                        _distance: "4",
                        _oneway: "true"
                    }
                },
                {
                    no: {
                        _desired: "da",
                        _distance: "8"
                    }
                },
                {
                    nb: {
                        _desired: "da",
                        _distance: "8"
                    }
                },
                {
                    ru: {
                        _desired: "ab",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ach",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    nl: {
                        _desired: "af",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ak",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "am",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "ay",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "az",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ur: {
                        _desired: "bal",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "be",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "bem",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "bh",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "bn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "bo",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "br",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "ca",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fil: {
                        _desired: "ceb",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "chr",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ckb",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "co",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "crs",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    sk: {
                        _desired: "cs",
                        _distance: "20"
                    }
                },
                {
                    en: {
                        _desired: "cy",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ee",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "eo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "eu",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    da: {
                        _desired: "fo",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    nl: {
                        _desired: "fy",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ga",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "gaa",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "gd",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "gl",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "gn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "gu",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ha",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "haw",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "ht",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "hy",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ia",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ig",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "is",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    id: {
                        _desired: "jv",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ka",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "kg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "kk",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "km",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "kn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "kri",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    tr: {
                        _desired: "ku",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "ky",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    it: {
                        _desired: "la",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "lg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "ln",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "lo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "loz",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "lua",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "mai",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "mfe",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "mg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "mi",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ml",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "mn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "mr",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    id: {
                        _desired: "ms",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "mt",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "my",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ne",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    nb: {
                        _desired: "nn",
                        _distance: "20"
                    }
                },
                {
                    no: {
                        _desired: "nn",
                        _distance: "20"
                    }
                },
                {
                    en: {
                        _desired: "nso",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ny",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "nyn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "oc",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "om",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "or",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "pa",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "pcm",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ps",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "qu",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    de: {
                        _desired: "rm",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "rn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "rw",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "sa",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sd",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "si",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "so",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sq",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "st",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    id: {
                        _desired: "su",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sw",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ta",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "te",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "tg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ti",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "tk",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "tlh",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "tn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "to",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "tt",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "tum",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "ug",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "uk",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ur",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "uz",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "wo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "xh",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "yi",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "yo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "za",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "zu",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "aao",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "abh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "abv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acx",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "adf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "aeb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "aec",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "afb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ajp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "apc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "apd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "arq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ars",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ary",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "arz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "auz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "avl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "bbz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "pga",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "shu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ssh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    az: {
                        _desired: "azb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    et: {
                        _desired: "vro",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "ffm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fub",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fue",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fui",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "gnw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "gui",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "gun",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "nhd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    iu: {
                        _desired: "ikt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "enb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "eyo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "niq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "oki",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "pko",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "sgc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "tec",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "tuy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kok: {
                        _desired: "gom",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kpe: {
                        _desired: "gkp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "ida",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lkb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lko",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lks",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lri",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lrm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lsm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lto",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lts",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lwg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "nle",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "nyd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "rag",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    lv: {
                        _desired: "ltg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bhr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bjq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bmm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bzc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "msh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "skg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "tdx",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "tkg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "txy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "xmv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "xmw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mn: {
                        _desired: "mvf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "bjn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "btj",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "bve",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "bvu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "coa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "dup",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "hji",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "id",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "jak",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "jax",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "kvb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "kvr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "kxd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "lce",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "lcf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "liw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "max",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "meo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mfa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mfb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "min",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mqg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "msi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mui",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "orn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "ors",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "pel",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "pse",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "tmw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "urk",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "vkk",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "vkt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "xmm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "zlm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "zmi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ne: {
                        _desired: "dty",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    om: {
                        _desired: "gax",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    om: {
                        _desired: "hae",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    om: {
                        _desired: "orc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    or: {
                        _desired: "spv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ps: {
                        _desired: "pbt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ps: {
                        _desired: "pst",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qub",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qud",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qug",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quk",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qul",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qup",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qur",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qus",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qux",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qva",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qve",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvj",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvs",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qwa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qwc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qwh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qws",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sc: {
                        _desired: "sdc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sc: {
                        _desired: "sdn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sc: {
                        _desired: "sro",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sq: {
                        _desired: "aae",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sq: {
                        _desired: "aat",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sq: {
                        _desired: "aln",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    syr: {
                        _desired: "aii",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    uz: {
                        _desired: "uzs",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    yi: {
                        _desired: "yih",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "cdo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "cjy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "cpx",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "czh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "czo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "gan",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "hak",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "hsn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "lzh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "mnp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "nan",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "wuu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "yue",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "*": {
                        _desired: "*",
                        _distance: "80"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "am-Ethi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "az-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "bn-Beng",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "bo-Tibt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "hy-Armn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ka-Geor",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "km-Khmr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "kn-Knda",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "lo-Laoo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ml-Mlym",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "my-Mymr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ne-Deva",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "or-Orya",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "pa-Guru",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ps-Arab",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "sd-Arab",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "si-Sinh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ta-Taml",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "te-Telu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ti-Ethi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "tk-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ur-Arab",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "uz-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "yi-Hebr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "sr-Cyrl": {
                        _desired: "sr-Latn",
                        _distance: "5"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "za-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "zh-Hani",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hant": {
                        _desired: "zh-Hani",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ar-Arab": {
                        _desired: "ar-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "bn-Beng": {
                        _desired: "bn-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "gu-Gujr": {
                        _desired: "gu-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "hi-Deva": {
                        _desired: "hi-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "kn-Knda": {
                        _desired: "kn-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ml-Mlym": {
                        _desired: "ml-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "mr-Deva": {
                        _desired: "mr-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ta-Taml": {
                        _desired: "ta-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "te-Telu": {
                        _desired: "te-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "zh-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Latn",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Hani",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Hira",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Kana",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Hrkt",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Hrkt": {
                        _desired: "ja-Hira",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Hrkt": {
                        _desired: "ja-Kana",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Kore": {
                        _desired: "ko-Hani",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Kore": {
                        _desired: "ko-Hang",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Kore": {
                        _desired: "ko-Jamo",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Hang": {
                        _desired: "ko-Jamo",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "*-*": {
                        _desired: "*-*",
                        _distance: "50"
                    }
                },
                {
                    "ar-*-$maghreb": {
                        _desired: "ar-*-$maghreb",
                        _distance: "4"
                    }
                },
                {
                    "ar-*-$!maghreb": {
                        _desired: "ar-*-$!maghreb",
                        _distance: "4"
                    }
                },
                {
                    "ar-*-*": {
                        _desired: "ar-*-*",
                        _distance: "5"
                    }
                },
                {
                    "en-*-$enUS": {
                        _desired: "en-*-$enUS",
                        _distance: "4"
                    }
                },
                {
                    "en-*-GB": {
                        _desired: "en-*-$!enUS",
                        _distance: "3"
                    }
                },
                {
                    "en-*-$!enUS": {
                        _desired: "en-*-$!enUS",
                        _distance: "4"
                    }
                },
                {
                    "en-*-*": {
                        _desired: "en-*-*",
                        _distance: "5"
                    }
                },
                {
                    "es-*-$americas": {
                        _desired: "es-*-$americas",
                        _distance: "4"
                    }
                },
                {
                    "es-*-$!americas": {
                        _desired: "es-*-$!americas",
                        _distance: "4"
                    }
                },
                {
                    "es-*-*": {
                        _desired: "es-*-*",
                        _distance: "5"
                    }
                },
                {
                    "pt-*-$americas": {
                        _desired: "pt-*-$americas",
                        _distance: "4"
                    }
                },
                {
                    "pt-*-$!americas": {
                        _desired: "pt-*-$!americas",
                        _distance: "4"
                    }
                },
                {
                    "pt-*-*": {
                        _desired: "pt-*-*",
                        _distance: "5"
                    }
                },
                {
                    "zh-Hant-$cnsar": {
                        _desired: "zh-Hant-$cnsar",
                        _distance: "4"
                    }
                },
                {
                    "zh-Hant-$!cnsar": {
                        _desired: "zh-Hant-$!cnsar",
                        _distance: "4"
                    }
                },
                {
                    "zh-Hant-*": {
                        _desired: "zh-Hant-*",
                        _distance: "5"
                    }
                },
                {
                    "*-*-*": {
                        _desired: "*-*-*",
                        _distance: "4"
                    }
                }
            ]
        }
    }
};

});

parcelRegister("5Q9VP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.regions = void 0;
// This file is generated from regions-gen.ts
module.exports.regions = {
    "001": [
        "001",
        "001-status-grouping",
        "002",
        "005",
        "009",
        "011",
        "013",
        "014",
        "015",
        "017",
        "018",
        "019",
        "021",
        "029",
        "030",
        "034",
        "035",
        "039",
        "053",
        "054",
        "057",
        "061",
        "142",
        "143",
        "145",
        "150",
        "151",
        "154",
        "155",
        "AC",
        "AD",
        "AE",
        "AF",
        "AG",
        "AI",
        "AL",
        "AM",
        "AO",
        "AQ",
        "AR",
        "AS",
        "AT",
        "AU",
        "AW",
        "AX",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BL",
        "BM",
        "BN",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BT",
        "BV",
        "BW",
        "BY",
        "BZ",
        "CA",
        "CC",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CK",
        "CL",
        "CM",
        "CN",
        "CO",
        "CP",
        "CQ",
        "CR",
        "CU",
        "CV",
        "CW",
        "CX",
        "CY",
        "CZ",
        "DE",
        "DG",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EA",
        "EC",
        "EE",
        "EG",
        "EH",
        "ER",
        "ES",
        "ET",
        "EU",
        "EZ",
        "FI",
        "FJ",
        "FK",
        "FM",
        "FO",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GF",
        "GG",
        "GH",
        "GI",
        "GL",
        "GM",
        "GN",
        "GP",
        "GQ",
        "GR",
        "GS",
        "GT",
        "GU",
        "GW",
        "GY",
        "HK",
        "HM",
        "HN",
        "HR",
        "HT",
        "HU",
        "IC",
        "ID",
        "IE",
        "IL",
        "IM",
        "IN",
        "IO",
        "IQ",
        "IR",
        "IS",
        "IT",
        "JE",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KP",
        "KR",
        "KW",
        "KY",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LI",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "LY",
        "MA",
        "MC",
        "MD",
        "ME",
        "MF",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MO",
        "MP",
        "MQ",
        "MR",
        "MS",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NC",
        "NE",
        "NF",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NU",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PF",
        "PG",
        "PH",
        "PK",
        "PL",
        "PM",
        "PN",
        "PR",
        "PS",
        "PT",
        "PW",
        "PY",
        "QA",
        "QO",
        "RE",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SH",
        "SI",
        "SJ",
        "SK",
        "SL",
        "SM",
        "SN",
        "SO",
        "SR",
        "SS",
        "ST",
        "SV",
        "SX",
        "SY",
        "SZ",
        "TA",
        "TC",
        "TD",
        "TF",
        "TG",
        "TH",
        "TJ",
        "TK",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TW",
        "TZ",
        "UA",
        "UG",
        "UM",
        "UN",
        "US",
        "UY",
        "UZ",
        "VA",
        "VC",
        "VE",
        "VG",
        "VI",
        "VN",
        "VU",
        "WF",
        "WS",
        "XK",
        "YE",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "002": [
        "002",
        "002-status-grouping",
        "011",
        "014",
        "015",
        "017",
        "018",
        "202",
        "AO",
        "BF",
        "BI",
        "BJ",
        "BW",
        "CD",
        "CF",
        "CG",
        "CI",
        "CM",
        "CV",
        "DJ",
        "DZ",
        "EA",
        "EG",
        "EH",
        "ER",
        "ET",
        "GA",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GW",
        "IC",
        "IO",
        "KE",
        "KM",
        "LR",
        "LS",
        "LY",
        "MA",
        "MG",
        "ML",
        "MR",
        "MU",
        "MW",
        "MZ",
        "NA",
        "NE",
        "NG",
        "RE",
        "RW",
        "SC",
        "SD",
        "SH",
        "SL",
        "SN",
        "SO",
        "SS",
        "ST",
        "SZ",
        "TD",
        "TF",
        "TG",
        "TN",
        "TZ",
        "UG",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "003": [
        "003",
        "013",
        "021",
        "029",
        "AG",
        "AI",
        "AW",
        "BB",
        "BL",
        "BM",
        "BQ",
        "BS",
        "BZ",
        "CA",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "GD",
        "GL",
        "GP",
        "GT",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PM",
        "PR",
        "SV",
        "SX",
        "TC",
        "TT",
        "US",
        "VC",
        "VG",
        "VI"
    ],
    "005": [
        "005",
        "AR",
        "BO",
        "BR",
        "BV",
        "CL",
        "CO",
        "EC",
        "FK",
        "GF",
        "GS",
        "GY",
        "PE",
        "PY",
        "SR",
        "UY",
        "VE"
    ],
    "009": [
        "009",
        "053",
        "054",
        "057",
        "061",
        "AC",
        "AQ",
        "AS",
        "AU",
        "CC",
        "CK",
        "CP",
        "CX",
        "DG",
        "FJ",
        "FM",
        "GU",
        "HM",
        "KI",
        "MH",
        "MP",
        "NC",
        "NF",
        "NR",
        "NU",
        "NZ",
        "PF",
        "PG",
        "PN",
        "PW",
        "QO",
        "SB",
        "TA",
        "TK",
        "TO",
        "TV",
        "UM",
        "VU",
        "WF",
        "WS"
    ],
    "011": [
        "011",
        "BF",
        "BJ",
        "CI",
        "CV",
        "GH",
        "GM",
        "GN",
        "GW",
        "LR",
        "ML",
        "MR",
        "NE",
        "NG",
        "SH",
        "SL",
        "SN",
        "TG"
    ],
    "013": [
        "013",
        "BZ",
        "CR",
        "GT",
        "HN",
        "MX",
        "NI",
        "PA",
        "SV"
    ],
    "014": [
        "014",
        "BI",
        "DJ",
        "ER",
        "ET",
        "IO",
        "KE",
        "KM",
        "MG",
        "MU",
        "MW",
        "MZ",
        "RE",
        "RW",
        "SC",
        "SO",
        "SS",
        "TF",
        "TZ",
        "UG",
        "YT",
        "ZM",
        "ZW"
    ],
    "015": [
        "015",
        "DZ",
        "EA",
        "EG",
        "EH",
        "IC",
        "LY",
        "MA",
        "SD",
        "TN"
    ],
    "017": [
        "017",
        "AO",
        "CD",
        "CF",
        "CG",
        "CM",
        "GA",
        "GQ",
        "ST",
        "TD"
    ],
    "018": [
        "018",
        "BW",
        "LS",
        "NA",
        "SZ",
        "ZA"
    ],
    "019": [
        "003",
        "005",
        "013",
        "019",
        "019-status-grouping",
        "021",
        "029",
        "419",
        "AG",
        "AI",
        "AR",
        "AW",
        "BB",
        "BL",
        "BM",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BV",
        "BZ",
        "CA",
        "CL",
        "CO",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "EC",
        "FK",
        "GD",
        "GF",
        "GL",
        "GP",
        "GS",
        "GT",
        "GY",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PE",
        "PM",
        "PR",
        "PY",
        "SR",
        "SV",
        "SX",
        "TC",
        "TT",
        "US",
        "UY",
        "VC",
        "VE",
        "VG",
        "VI"
    ],
    "021": [
        "021",
        "BM",
        "CA",
        "GL",
        "PM",
        "US"
    ],
    "029": [
        "029",
        "AG",
        "AI",
        "AW",
        "BB",
        "BL",
        "BQ",
        "BS",
        "CU",
        "CW",
        "DM",
        "DO",
        "GD",
        "GP",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "PR",
        "SX",
        "TC",
        "TT",
        "VC",
        "VG",
        "VI"
    ],
    "030": [
        "030",
        "CN",
        "HK",
        "JP",
        "KP",
        "KR",
        "MN",
        "MO",
        "TW"
    ],
    "034": [
        "034",
        "AF",
        "BD",
        "BT",
        "IN",
        "IR",
        "LK",
        "MV",
        "NP",
        "PK"
    ],
    "035": [
        "035",
        "BN",
        "ID",
        "KH",
        "LA",
        "MM",
        "MY",
        "PH",
        "SG",
        "TH",
        "TL",
        "VN"
    ],
    "039": [
        "039",
        "AD",
        "AL",
        "BA",
        "ES",
        "GI",
        "GR",
        "HR",
        "IT",
        "ME",
        "MK",
        "MT",
        "PT",
        "RS",
        "SI",
        "SM",
        "VA",
        "XK"
    ],
    "053": [
        "053",
        "AU",
        "CC",
        "CX",
        "HM",
        "NF",
        "NZ"
    ],
    "054": [
        "054",
        "FJ",
        "NC",
        "PG",
        "SB",
        "VU"
    ],
    "057": [
        "057",
        "FM",
        "GU",
        "KI",
        "MH",
        "MP",
        "NR",
        "PW",
        "UM"
    ],
    "061": [
        "061",
        "AS",
        "CK",
        "NU",
        "PF",
        "PN",
        "TK",
        "TO",
        "TV",
        "WF",
        "WS"
    ],
    "142": [
        "030",
        "034",
        "035",
        "142",
        "143",
        "145",
        "AE",
        "AF",
        "AM",
        "AZ",
        "BD",
        "BH",
        "BN",
        "BT",
        "CN",
        "CY",
        "GE",
        "HK",
        "ID",
        "IL",
        "IN",
        "IQ",
        "IR",
        "JO",
        "JP",
        "KG",
        "KH",
        "KP",
        "KR",
        "KW",
        "KZ",
        "LA",
        "LB",
        "LK",
        "MM",
        "MN",
        "MO",
        "MV",
        "MY",
        "NP",
        "OM",
        "PH",
        "PK",
        "PS",
        "QA",
        "SA",
        "SG",
        "SY",
        "TH",
        "TJ",
        "TL",
        "TM",
        "TR",
        "TW",
        "UZ",
        "VN",
        "YE"
    ],
    "143": [
        "143",
        "KG",
        "KZ",
        "TJ",
        "TM",
        "UZ"
    ],
    "145": [
        "145",
        "AE",
        "AM",
        "AZ",
        "BH",
        "CY",
        "GE",
        "IL",
        "IQ",
        "JO",
        "KW",
        "LB",
        "OM",
        "PS",
        "QA",
        "SA",
        "SY",
        "TR",
        "YE"
    ],
    "150": [
        "039",
        "150",
        "151",
        "154",
        "155",
        "AD",
        "AL",
        "AT",
        "AX",
        "BA",
        "BE",
        "BG",
        "BY",
        "CH",
        "CQ",
        "CZ",
        "DE",
        "DK",
        "EE",
        "ES",
        "FI",
        "FO",
        "FR",
        "GB",
        "GG",
        "GI",
        "GR",
        "HR",
        "HU",
        "IE",
        "IM",
        "IS",
        "IT",
        "JE",
        "LI",
        "LT",
        "LU",
        "LV",
        "MC",
        "MD",
        "ME",
        "MK",
        "MT",
        "NL",
        "NO",
        "PL",
        "PT",
        "RO",
        "RS",
        "RU",
        "SE",
        "SI",
        "SJ",
        "SK",
        "SM",
        "UA",
        "VA",
        "XK"
    ],
    "151": [
        "151",
        "BG",
        "BY",
        "CZ",
        "HU",
        "MD",
        "PL",
        "RO",
        "RU",
        "SK",
        "UA"
    ],
    "154": [
        "154",
        "AX",
        "CQ",
        "DK",
        "EE",
        "FI",
        "FO",
        "GB",
        "GG",
        "IE",
        "IM",
        "IS",
        "JE",
        "LT",
        "LV",
        "NO",
        "SE",
        "SJ"
    ],
    "155": [
        "155",
        "AT",
        "BE",
        "CH",
        "DE",
        "FR",
        "LI",
        "LU",
        "MC",
        "NL"
    ],
    "202": [
        "011",
        "014",
        "017",
        "018",
        "202",
        "AO",
        "BF",
        "BI",
        "BJ",
        "BW",
        "CD",
        "CF",
        "CG",
        "CI",
        "CM",
        "CV",
        "DJ",
        "ER",
        "ET",
        "GA",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GW",
        "IO",
        "KE",
        "KM",
        "LR",
        "LS",
        "MG",
        "ML",
        "MR",
        "MU",
        "MW",
        "MZ",
        "NA",
        "NE",
        "NG",
        "RE",
        "RW",
        "SC",
        "SH",
        "SL",
        "SN",
        "SO",
        "SS",
        "ST",
        "SZ",
        "TD",
        "TF",
        "TG",
        "TZ",
        "UG",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "419": [
        "005",
        "013",
        "029",
        "419",
        "AG",
        "AI",
        "AR",
        "AW",
        "BB",
        "BL",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BV",
        "BZ",
        "CL",
        "CO",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "EC",
        "FK",
        "GD",
        "GF",
        "GP",
        "GS",
        "GT",
        "GY",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PE",
        "PR",
        "PY",
        "SR",
        "SV",
        "SX",
        "TC",
        "TT",
        "UY",
        "VC",
        "VE",
        "VG",
        "VI"
    ],
    "EU": [
        "AT",
        "BE",
        "BG",
        "CY",
        "CZ",
        "DE",
        "DK",
        "EE",
        "ES",
        "EU",
        "FI",
        "FR",
        "GR",
        "HR",
        "HU",
        "IE",
        "IT",
        "LT",
        "LU",
        "LV",
        "MT",
        "NL",
        "PL",
        "PT",
        "RO",
        "SE",
        "SI",
        "SK"
    ],
    "EZ": [
        "AT",
        "BE",
        "CY",
        "DE",
        "EE",
        "ES",
        "EZ",
        "FI",
        "FR",
        "GR",
        "IE",
        "IT",
        "LT",
        "LU",
        "LV",
        "MT",
        "NL",
        "PT",
        "SI",
        "SK"
    ],
    "QO": [
        "AC",
        "AQ",
        "CP",
        "DG",
        "QO",
        "TA"
    ],
    "UN": [
        "AD",
        "AE",
        "AF",
        "AG",
        "AL",
        "AM",
        "AO",
        "AR",
        "AT",
        "AU",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BN",
        "BO",
        "BR",
        "BS",
        "BT",
        "BW",
        "BY",
        "BZ",
        "CA",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CL",
        "CM",
        "CN",
        "CO",
        "CR",
        "CU",
        "CV",
        "CY",
        "CZ",
        "DE",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ER",
        "ES",
        "ET",
        "FI",
        "FJ",
        "FM",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GR",
        "GT",
        "GW",
        "GY",
        "HN",
        "HR",
        "HT",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IQ",
        "IR",
        "IS",
        "IT",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KP",
        "KR",
        "KW",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LI",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "LY",
        "MA",
        "MC",
        "MD",
        "ME",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MR",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NE",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PG",
        "PH",
        "PK",
        "PL",
        "PT",
        "PW",
        "PY",
        "QA",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SI",
        "SK",
        "SL",
        "SM",
        "SN",
        "SO",
        "SR",
        "SS",
        "ST",
        "SV",
        "SY",
        "SZ",
        "TD",
        "TG",
        "TH",
        "TJ",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TZ",
        "UA",
        "UG",
        "UN",
        "US",
        "UY",
        "UZ",
        "VC",
        "VE",
        "VN",
        "VU",
        "WS",
        "YE",
        "ZA",
        "ZM",
        "ZW"
    ]
};

});



parcelRegister("4JtIr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LookupMatcher = void 0;

var $1Q5o5 = parcelRequire("1Q5o5");

var $9F8ll = parcelRequire("9F8ll");
/**
 * https://tc39.es/ecma402/#sec-lookupmatcher
 * @param availableLocales
 * @param requestedLocales
 * @param getDefaultLocale
 */ function $37226a5256e17dc5$var$LookupMatcher(availableLocales, requestedLocales, getDefaultLocale) {
    var result = {
        locale: ""
    };
    for(var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++){
        var locale = requestedLocales_1[_i];
        var noExtensionLocale = locale.replace($9F8ll.UNICODE_EXTENSION_SEQUENCE_REGEX, "");
        var availableLocale = (0, $1Q5o5.BestAvailableLocale)(availableLocales, noExtensionLocale);
        if (availableLocale) {
            result.locale = availableLocale;
            if (locale !== noExtensionLocale) result.extension = locale.slice(noExtensionLocale.length, locale.length);
            return result;
        }
    }
    result.locale = getDefaultLocale();
    return result;
}
module.exports.LookupMatcher = $37226a5256e17dc5$var$LookupMatcher;

});
parcelRegister("1Q5o5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BestAvailableLocale = void 0;
/**
 * https://tc39.es/ecma402/#sec-bestavailablelocale
 * @param availableLocales
 * @param locale
 */ function $156ed397a65c03b5$var$BestAvailableLocale(availableLocales, locale) {
    var candidate = locale;
    while(true){
        if (availableLocales.indexOf(candidate) > -1) return candidate;
        var pos = candidate.lastIndexOf("-");
        if (!~pos) return undefined;
        if (pos >= 2 && candidate[pos - 2] === "-") pos -= 2;
        candidate = candidate.slice(0, pos);
    }
}
module.exports.BestAvailableLocale = $156ed397a65c03b5$var$BestAvailableLocale;

});


parcelRegister("20qwb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnicodeExtensionValue = void 0;

var $9F8ll = parcelRequire("9F8ll");
/**
 * https://tc39.es/ecma402/#sec-unicodeextensionvalue
 * @param extension
 * @param key
 */ function $176026c8e0ee745e$var$UnicodeExtensionValue(extension, key) {
    (0, $9F8ll.invariant)(key.length === 2, "key must have 2 elements");
    var size = extension.length;
    var searchValue = "-".concat(key, "-");
    var pos = extension.indexOf(searchValue);
    if (pos !== -1) {
        var start = pos + 4;
        var end = start;
        var k = start;
        var done = false;
        while(!done){
            var e = extension.indexOf("-", k);
            var len = void 0;
            if (e === -1) len = size - k;
            else len = e - k;
            if (len === 2) done = true;
            else if (e === -1) {
                end = size;
                done = true;
            } else {
                end = e;
                k = e + 1;
            }
        }
        return extension.slice(start, end);
    }
    searchValue = "-".concat(key);
    pos = extension.indexOf(searchValue);
    if (pos !== -1 && pos + 3 === size) return "";
    return undefined;
}
module.exports.UnicodeExtensionValue = $176026c8e0ee745e$var$UnicodeExtensionValue;

});


parcelRegister("hOPr8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LookupSupportedLocales = void 0;

var $1Q5o5 = parcelRequire("1Q5o5");

var $9F8ll = parcelRequire("9F8ll");
/**
 * https://tc39.es/ecma402/#sec-lookupsupportedlocales
 * @param availableLocales
 * @param requestedLocales
 */ function $cf8f0171fce0cce5$var$LookupSupportedLocales(availableLocales, requestedLocales) {
    var subset = [];
    for(var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++){
        var locale = requestedLocales_1[_i];
        var noExtensionLocale = locale.replace($9F8ll.UNICODE_EXTENSION_SEQUENCE_REGEX, "");
        var availableLocale = (0, $1Q5o5.BestAvailableLocale)(availableLocales, noExtensionLocale);
        if (availableLocale) subset.push(availableLocale);
    }
    return subset;
}
module.exports.LookupSupportedLocales = $cf8f0171fce0cce5$var$LookupSupportedLocales;

});


parcelRegister("8tfDO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetNumberFormatDigitOptions = void 0;

var $7ZXeE = parcelRequire("7ZXeE");

var $10Xw3 = parcelRequire("10Xw3");

var $iQ9Nx = parcelRequire("iQ9Nx");
/**
 * https://tc39.es/ecma402/#sec-setnfdigitoptions
 */ function $62ad2a2e640058cd$var$SetNumberFormatDigitOptions(internalSlots, opts, mnfdDefault, mxfdDefault, notation) {
    var mnid = (0, $7ZXeE.GetNumberOption)(opts, "minimumIntegerDigits", 1, 21, 1);
    var mnfd = opts.minimumFractionDigits;
    var mxfd = opts.maximumFractionDigits;
    var mnsd = opts.minimumSignificantDigits;
    var mxsd = opts.maximumSignificantDigits;
    internalSlots.minimumIntegerDigits = mnid;
    var roundingPriority = (0, $iQ9Nx.GetOption)(opts, "roundingPriority", "string", [
        "auto",
        "morePrecision",
        "lessPrecision"
    ], "auto");
    var hasSd = mnsd !== undefined || mxsd !== undefined;
    var hasFd = mnfd !== undefined || mxfd !== undefined;
    var needSd = true;
    var needFd = true;
    if (roundingPriority === "auto") {
        needSd = hasSd;
        if (hasSd || !hasFd && notation === "compact") needFd = false;
    }
    if (needSd) {
        if (hasSd) {
            mnsd = (0, $10Xw3.DefaultNumberOption)(mnsd, 1, 21, 1);
            mxsd = (0, $10Xw3.DefaultNumberOption)(mxsd, mnsd, 21, 21);
            internalSlots.minimumSignificantDigits = mnsd;
            internalSlots.maximumSignificantDigits = mxsd;
        } else {
            internalSlots.minimumSignificantDigits = 1;
            internalSlots.maximumSignificantDigits = 21;
        }
    }
    if (needFd) {
        if (hasFd) {
            // @ts-expect-error
            mnfd = (0, $10Xw3.DefaultNumberOption)(mnfd, 0, 20, undefined);
            // @ts-expect-error
            mxfd = (0, $10Xw3.DefaultNumberOption)(mxfd, 0, 20, undefined);
            if (mnfd === undefined) mnfd = Math.min(mnfdDefault, mxfd);
            else if (mxfd === undefined) mxfd = Math.max(mxfdDefault, mnfd);
            else if (mnfd > mxfd) throw new RangeError("Invalid range, ".concat(mnfd, " > ").concat(mxfd));
            internalSlots.minimumFractionDigits = mnfd;
            internalSlots.maximumFractionDigits = mxfd;
        } else {
            internalSlots.minimumFractionDigits = mnfdDefault;
            internalSlots.maximumFractionDigits = mxfdDefault;
        }
    }
    if (needSd || needFd) {
        if (roundingPriority === "morePrecision") internalSlots.roundingType = "morePrecision";
        else if (roundingPriority === "lessPrecision") internalSlots.roundingType = "lessPrecision";
        else if (hasSd) internalSlots.roundingType = "significantDigits";
        else internalSlots.roundingType = "fractionDigits";
    } else {
        internalSlots.roundingType = "morePrecision";
        internalSlots.minimumFractionDigits = 0;
        internalSlots.maximumFractionDigits = 0;
        internalSlots.minimumSignificantDigits = 1;
        internalSlots.maximumSignificantDigits = 2;
    }
}
module.exports.SetNumberFormatDigitOptions = $62ad2a2e640058cd$var$SetNumberFormatDigitOptions;

});

parcelRegister("i0NhQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetNumberFormatUnitOptions = void 0;

var $iQ9Nx = parcelRequire("iQ9Nx");

var $bsbpg = parcelRequire("bsbpg");

var $kUv4V = parcelRequire("kUv4V");
/**
 * https://tc39.es/ecma402/#sec-setnumberformatunitoptions
 */ function $d1ce757054063aff$var$SetNumberFormatUnitOptions(nf, options, _a) {
    if (options === void 0) options = Object.create(null);
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(nf);
    var style = (0, $iQ9Nx.GetOption)(options, "style", "string", [
        "decimal",
        "percent",
        "currency",
        "unit"
    ], "decimal");
    internalSlots.style = style;
    var currency = (0, $iQ9Nx.GetOption)(options, "currency", "string", undefined, undefined);
    if (currency !== undefined && !(0, $bsbpg.IsWellFormedCurrencyCode)(currency)) throw RangeError("Malformed currency code");
    if (style === "currency" && currency === undefined) throw TypeError("currency cannot be undefined");
    var currencyDisplay = (0, $iQ9Nx.GetOption)(options, "currencyDisplay", "string", [
        "code",
        "symbol",
        "narrowSymbol",
        "name"
    ], "symbol");
    var currencySign = (0, $iQ9Nx.GetOption)(options, "currencySign", "string", [
        "standard",
        "accounting"
    ], "standard");
    var unit = (0, $iQ9Nx.GetOption)(options, "unit", "string", undefined, undefined);
    if (unit !== undefined && !(0, $kUv4V.IsWellFormedUnitIdentifier)(unit)) throw RangeError("Invalid unit argument for Intl.NumberFormat()");
    if (style === "unit" && unit === undefined) throw TypeError("unit cannot be undefined");
    var unitDisplay = (0, $iQ9Nx.GetOption)(options, "unitDisplay", "string", [
        "short",
        "narrow",
        "long"
    ], "short");
    if (style === "currency") {
        internalSlots.currency = currency.toUpperCase();
        internalSlots.currencyDisplay = currencyDisplay;
        internalSlots.currencySign = currencySign;
    }
    if (style === "unit") {
        internalSlots.unit = unit;
        internalSlots.unitDisplay = unitDisplay;
    }
}
module.exports.SetNumberFormatUnitOptions = $d1ce757054063aff$var$SetNumberFormatUnitOptions;

});


parcelRegister("2LV04", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PartitionPattern = void 0;

var $eTSkB = parcelRequire("eTSkB");
/**
 * https://tc39.es/ecma402/#sec-partitionpattern
 * @param pattern
 */ function $204c2f929b6da49f$var$PartitionPattern(pattern) {
    var result = [];
    var beginIndex = pattern.indexOf("{");
    var endIndex = 0;
    var nextIndex = 0;
    var length = pattern.length;
    while(beginIndex < pattern.length && beginIndex > -1){
        endIndex = pattern.indexOf("}", beginIndex);
        (0, $eTSkB.invariant)(endIndex > beginIndex, "Invalid pattern ".concat(pattern));
        if (beginIndex > nextIndex) result.push({
            type: "literal",
            value: pattern.substring(nextIndex, beginIndex)
        });
        result.push({
            type: pattern.substring(beginIndex + 1, endIndex),
            value: undefined
        });
        nextIndex = endIndex + 1;
        beginIndex = pattern.indexOf("{", nextIndex);
    }
    if (nextIndex < length) result.push({
        type: "literal",
        value: pattern.substring(nextIndex, length)
    });
    return result;
}
module.exports.PartitionPattern = $204c2f929b6da49f$var$PartitionPattern;

});

parcelRegister("imLer", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SupportedLocales = void 0;

var $j8Gi0 = parcelRequire("j8Gi0");

var $itFDr = parcelRequire("itFDr");

var $iQ9Nx = parcelRequire("iQ9Nx");
/**
 * https://tc39.es/ecma402/#sec-supportedlocales
 * @param availableLocales
 * @param requestedLocales
 * @param options
 */ function $d5eeeb5a7cd18d2f$var$SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = "best fit";
    if (options !== undefined) {
        options = (0, $itFDr.ToObject)(options);
        matcher = (0, $iQ9Nx.GetOption)(options, "localeMatcher", "string", [
            "lookup",
            "best fit"
        ], "best fit");
    }
    if (matcher === "best fit") return (0, $j8Gi0.LookupSupportedLocales)(Array.from(availableLocales), requestedLocales);
    return (0, $j8Gi0.LookupSupportedLocales)(Array.from(availableLocales), requestedLocales);
}
module.exports.SupportedLocales = $d5eeeb5a7cd18d2f$var$SupportedLocales;

});

parcelRegister("bB2lu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMissingLocaleDataError = void 0;

var $eIwgG = parcelRequire("eIwgG");
var $8714f833e71ec2a4$var$MissingLocaleDataError = /** @class */ function(_super) {
    $eIwgG.__extends(MissingLocaleDataError, _super);
    function MissingLocaleDataError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "MISSING_LOCALE_DATA";
        return _this;
    }
    return MissingLocaleDataError;
}(Error);
function $8714f833e71ec2a4$var$isMissingLocaleDataError(e) {
    return e.type === "MISSING_LOCALE_DATA";
}
module.exports.isMissingLocaleDataError = $8714f833e71ec2a4$var$isMissingLocaleDataError;

});

parcelRegister("34sz3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5UwTC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangePatternType = void 0;
var $44dbb32c1a47df28$var$RangePatternType;
(function(RangePatternType) {
    RangePatternType["startRange"] = "startRange";
    RangePatternType["shared"] = "shared";
    RangePatternType["endRange"] = "endRange";
})($44dbb32c1a47df28$var$RangePatternType || (module.exports.RangePatternType = $44dbb32c1a47df28$var$RangePatternType = {}));

});

parcelRegister("MgHgJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4DL3u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8FDFF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9HJ30", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("6RKOV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIntl = module.exports.formatNumberToParts = module.exports.formatNumber = module.exports.formatRelativeTime = module.exports.formatPlural = module.exports.formatList = module.exports.formatDisplayName = module.exports.formatTimeToParts = module.exports.formatTime = module.exports.formatDateToParts = module.exports.formatDate = module.exports.formatMessage = module.exports.getNamedFormat = module.exports.createFormatters = module.exports.DEFAULT_INTL_CONFIG = module.exports.filterProps = module.exports.createIntlCache = module.exports.defineMessage = module.exports.defineMessages = void 0;

var $eIwgG = parcelRequire("eIwgG");

$eIwgG.__exportStar((parcelRequire("eJEy4")), module.exports);
function $4ffc02da327e00a6$var$defineMessages(msgs) {
    return msgs;
}
module.exports.defineMessages = $4ffc02da327e00a6$var$defineMessages;
function $4ffc02da327e00a6$var$defineMessage(msg) {
    return msg;
}
module.exports.defineMessage = $4ffc02da327e00a6$var$defineMessage;

var $gCJ4u = parcelRequire("gCJ4u");
Object.defineProperty(module.exports, "createIntlCache", {
    enumerable: true,
    get: function() {
        return $gCJ4u.createIntlCache;
    }
});
Object.defineProperty(module.exports, "filterProps", {
    enumerable: true,
    get: function() {
        return $gCJ4u.filterProps;
    }
});
Object.defineProperty(module.exports, "DEFAULT_INTL_CONFIG", {
    enumerable: true,
    get: function() {
        return $gCJ4u.DEFAULT_INTL_CONFIG;
    }
});
Object.defineProperty(module.exports, "createFormatters", {
    enumerable: true,
    get: function() {
        return $gCJ4u.createFormatters;
    }
});
Object.defineProperty(module.exports, "getNamedFormat", {
    enumerable: true,
    get: function() {
        return $gCJ4u.getNamedFormat;
    }
});

$eIwgG.__exportStar((parcelRequire("8hOmc")), module.exports);

var $aQNFd = parcelRequire("aQNFd");
Object.defineProperty(module.exports, "formatMessage", {
    enumerable: true,
    get: function() {
        return $aQNFd.formatMessage;
    }
});

var $ajk9N = parcelRequire("ajk9N");
Object.defineProperty(module.exports, "formatDate", {
    enumerable: true,
    get: function() {
        return $ajk9N.formatDate;
    }
});
Object.defineProperty(module.exports, "formatDateToParts", {
    enumerable: true,
    get: function() {
        return $ajk9N.formatDateToParts;
    }
});
Object.defineProperty(module.exports, "formatTime", {
    enumerable: true,
    get: function() {
        return $ajk9N.formatTime;
    }
});
Object.defineProperty(module.exports, "formatTimeToParts", {
    enumerable: true,
    get: function() {
        return $ajk9N.formatTimeToParts;
    }
});

var $2l9gB = parcelRequire("2l9gB");
Object.defineProperty(module.exports, "formatDisplayName", {
    enumerable: true,
    get: function() {
        return $2l9gB.formatDisplayName;
    }
});

var $fiJox = parcelRequire("fiJox");
Object.defineProperty(module.exports, "formatList", {
    enumerable: true,
    get: function() {
        return $fiJox.formatList;
    }
});

var $9z4X1 = parcelRequire("9z4X1");
Object.defineProperty(module.exports, "formatPlural", {
    enumerable: true,
    get: function() {
        return $9z4X1.formatPlural;
    }
});

var $bSofV = parcelRequire("bSofV");
Object.defineProperty(module.exports, "formatRelativeTime", {
    enumerable: true,
    get: function() {
        return $bSofV.formatRelativeTime;
    }
});

var $4GCna = parcelRequire("4GCna");
Object.defineProperty(module.exports, "formatNumber", {
    enumerable: true,
    get: function() {
        return $4GCna.formatNumber;
    }
});
Object.defineProperty(module.exports, "formatNumberToParts", {
    enumerable: true,
    get: function() {
        return $4GCna.formatNumberToParts;
    }
});

var $1cRd2 = parcelRequire("1cRd2");
Object.defineProperty(module.exports, "createIntl", {
    enumerable: true,
    get: function() {
        return $1cRd2.createIntl;
    }
});

});
parcelRegister("eJEy4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gCJ4u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getNamedFormat = module.exports.createFormatters = module.exports.createIntlCache = module.exports.DEFAULT_INTL_CONFIG = module.exports.filterProps = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $8kYn6 = parcelRequire("8kYn6");

var $b2bpw = parcelRequire("b2bpw");

var $8hOmc = parcelRequire("8hOmc");
function $c1a32830ef75d3c3$var$filterProps(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
module.exports.filterProps = $c1a32830ef75d3c3$var$filterProps;
var $c1a32830ef75d3c3$var$defaultErrorHandler = function(error) {};
var $c1a32830ef75d3c3$var$defaultWarnHandler = function(warning) {};
module.exports.DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $c1a32830ef75d3c3$var$defaultErrorHandler,
    onWarn: $c1a32830ef75d3c3$var$defaultWarnHandler
};
function $c1a32830ef75d3c3$var$createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
module.exports.createIntlCache = $c1a32830ef75d3c3$var$createIntlCache;
function $c1a32830ef75d3c3$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */ function $c1a32830ef75d3c3$var$createFormatters(cache) {
    if (cache === void 0) cache = $c1a32830ef75d3c3$var$createIntlCache();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $b2bpw.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, $eIwgG.__spreadArray([
            void 0
        ], args, false)))();
    }, {
        cache: $c1a32830ef75d3c3$var$createFastMemoizeCache(cache.dateTime),
        strategy: $b2bpw.strategies.variadic
    });
    var getNumberFormat = (0, $b2bpw.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, $eIwgG.__spreadArray([
            void 0
        ], args, false)))();
    }, {
        cache: $c1a32830ef75d3c3$var$createFastMemoizeCache(cache.number),
        strategy: $b2bpw.strategies.variadic
    });
    var getPluralRules = (0, $b2bpw.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, $eIwgG.__spreadArray([
            void 0
        ], args, false)))();
    }, {
        cache: $c1a32830ef75d3c3$var$createFastMemoizeCache(cache.pluralRules),
        strategy: $b2bpw.strategies.variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $b2bpw.memoize)(function(message, locales, overrideFormats, opts) {
            return new $8kYn6.IntlMessageFormat(message, locales, overrideFormats, $eIwgG.__assign({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $c1a32830ef75d3c3$var$createFastMemoizeCache(cache.message),
            strategy: $b2bpw.strategies.variadic
        }),
        getRelativeTimeFormat: (0, $b2bpw.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, $eIwgG.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $c1a32830ef75d3c3$var$createFastMemoizeCache(cache.relativeTime),
            strategy: $b2bpw.strategies.variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $b2bpw.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, $eIwgG.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $c1a32830ef75d3c3$var$createFastMemoizeCache(cache.list),
            strategy: $b2bpw.strategies.variadic
        }),
        getDisplayNames: (0, $b2bpw.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, $eIwgG.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $c1a32830ef75d3c3$var$createFastMemoizeCache(cache.displayNames),
            strategy: $b2bpw.strategies.variadic
        })
    };
}
module.exports.createFormatters = $c1a32830ef75d3c3$var$createFormatters;
function $c1a32830ef75d3c3$var$getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new $8hOmc.UnsupportedFormatterError("No ".concat(type, " format named: ").concat(name)));
}
module.exports.getNamedFormat = $c1a32830ef75d3c3$var$getNamedFormat;

});
parcelRegister("8kYn6", function(module, exports) {
"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eIwgG = parcelRequire("eIwgG");


$eIwgG.__exportStar((parcelRequire("inclu")), module.exports);

$eIwgG.__exportStar((parcelRequire("h9tAt")), module.exports);

$eIwgG.__exportStar((parcelRequire("8Rsmd")), module.exports);
module.exports.default = (parcelRequire("h9tAt")).IntlMessageFormat;

});
parcelRegister("h9tAt", function(module, exports) {
"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntlMessageFormat = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $ash9y = parcelRequire("ash9y");

var $b2bpw = parcelRequire("b2bpw");

var $inclu = parcelRequire("inclu");
// -- MessageFormat --------------------------------------------------------
function $c7ca3a5547fa2a06$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return $eIwgG.__assign($eIwgG.__assign($eIwgG.__assign({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = $eIwgG.__assign($eIwgG.__assign({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $c7ca3a5547fa2a06$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $c7ca3a5547fa2a06$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, $eIwgG.__assign({}, defaultConfig));
}
function $c7ca3a5547fa2a06$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $c7ca3a5547fa2a06$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $b2bpw.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, $eIwgG.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $c7ca3a5547fa2a06$var$createFastMemoizeCache(cache.number),
            strategy: $b2bpw.strategies.variadic
        }),
        getDateTimeFormat: (0, $b2bpw.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, $eIwgG.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $c7ca3a5547fa2a06$var$createFastMemoizeCache(cache.dateTime),
            strategy: $b2bpw.strategies.variadic
        }),
        getPluralRules: (0, $b2bpw.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, $eIwgG.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $c7ca3a5547fa2a06$var$createFastMemoizeCache(cache.pluralRules),
            strategy: $b2bpw.strategies.variadic
        })
    };
}
var $c7ca3a5547fa2a06$var$IntlMessageFormat = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== $inclu.PART_TYPE.literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $inclu.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = $eIwgG.__rest(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, $eIwgG.__assign($eIwgG.__assign({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $c7ca3a5547fa2a06$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $c7ca3a5547fa2a06$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = $ash9y.parse;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();
module.exports.IntlMessageFormat = $c7ca3a5547fa2a06$var$IntlMessageFormat;

});
parcelRegister("ash9y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._Parser = module.exports.parse = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $7MBHK = parcelRequire("7MBHK");

var $kFcHt = parcelRequire("kFcHt");

function $79c9d32e146ca95f$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, (parcelRequire("jdbJG")).isSelectElement)(el) || (0, (parcelRequire("jdbJG")).isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $79c9d32e146ca95f$var$pruneLocation(el.options[k].value);
        }
        else if ((0, (parcelRequire("jdbJG")).isNumberElement)(el) && (0, (parcelRequire("jdbJG")).isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, (parcelRequire("jdbJG")).isDateElement)(el) || (0, (parcelRequire("jdbJG")).isTimeElement)(el)) && (0, (parcelRequire("jdbJG")).isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, (parcelRequire("jdbJG")).isTagElement)(el)) $79c9d32e146ca95f$var$pruneLocation(el.children);
    });
}
function $79c9d32e146ca95f$var$parse(message, opts) {
    if (opts === void 0) opts = {};
    opts = $eIwgG.__assign({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new $kFcHt.Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError($7MBHK.ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $79c9d32e146ca95f$var$pruneLocation(result.val);
    return result.val;
}
module.exports.parse = $79c9d32e146ca95f$var$parse;

$eIwgG.__exportStar((parcelRequire("jdbJG")), module.exports);
// only for testing
module.exports._Parser = $kFcHt.Parser;

});
parcelRegister("7MBHK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorKind = void 0;
var $5aaa4374d2667883$var$ErrorKind;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($5aaa4374d2667883$var$ErrorKind || (module.exports.ErrorKind = $5aaa4374d2667883$var$ErrorKind = {}));

});

parcelRegister("kFcHt", function(module, exports) {
"use strict";
var $f0b17cf458732d60$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $7MBHK = parcelRequire("7MBHK");

var $jdbJG = parcelRequire("jdbJG");

var $er47z = parcelRequire("er47z");

var $iL4tO = parcelRequire("iL4tO");

var $7zfy1 = parcelRequire("7zfy1");
var $f0b17cf458732d60$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat($er47z.SPACE_SEPARATOR_REGEX.source, "*"));
var $f0b17cf458732d60$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat($er47z.SPACE_SEPARATOR_REGEX.source, "*$"));
function $f0b17cf458732d60$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $f0b17cf458732d60$var$hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var $f0b17cf458732d60$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $f0b17cf458732d60$var$hasNativeFromEntries = !!Object.fromEntries;
var $f0b17cf458732d60$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $f0b17cf458732d60$var$hasTrimStart = !!String.prototype.trimStart;
var $f0b17cf458732d60$var$hasTrimEnd = !!String.prototype.trimEnd;
var $f0b17cf458732d60$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $f0b17cf458732d60$var$isSafeInteger = $f0b17cf458732d60$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $f0b17cf458732d60$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $f0b17cf458732d60$var$re = $f0b17cf458732d60$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $f0b17cf458732d60$var$REGEX_SUPPORTS_U_AND_Y = (($f0b17cf458732d60$var$_a = $f0b17cf458732d60$var$re.exec("a")) === null || $f0b17cf458732d60$var$_a === void 0 ? void 0 : $f0b17cf458732d60$var$_a[0]) === "a";
} catch (_) {
    $f0b17cf458732d60$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $f0b17cf458732d60$var$startsWith = $f0b17cf458732d60$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $f0b17cf458732d60$var$fromCodePoint = $f0b17cf458732d60$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $f0b17cf458732d60$var$fromEntries = // native
$f0b17cf458732d60$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $f0b17cf458732d60$var$codePointAt = $f0b17cf458732d60$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $f0b17cf458732d60$var$trimStart = $f0b17cf458732d60$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($f0b17cf458732d60$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $f0b17cf458732d60$var$trimEnd = $f0b17cf458732d60$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($f0b17cf458732d60$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $f0b17cf458732d60$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $f0b17cf458732d60$var$matchIdentifierAtIndex;
if ($f0b17cf458732d60$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $f0b17cf458732d60$var$IDENTIFIER_PREFIX_RE_1 = $f0b17cf458732d60$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $f0b17cf458732d60$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $f0b17cf458732d60$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $f0b17cf458732d60$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$f0b17cf458732d60$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $f0b17cf458732d60$var$codePointAt(s, index);
        if (c === undefined || $f0b17cf458732d60$var$_isWhiteSpace(c) || $f0b17cf458732d60$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $f0b17cf458732d60$var$fromCodePoint.apply(void 0, match);
};
var $f0b17cf458732d60$var$Parser = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: $jdbJG.TYPE.pound,
                    location: $f0b17cf458732d60$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error($7MBHK.ErrorKind.UNMATCHED_CLOSING_TAG, $f0b17cf458732d60$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $f0b17cf458732d60$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: $jdbJG.TYPE.literal,
                value: "<".concat(tagName, "/>"),
                location: $f0b17cf458732d60$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$f0b17cf458732d60$var$_isAlpha(this.char())) return this.error($7MBHK.ErrorKind.INVALID_TAG, $f0b17cf458732d60$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error($7MBHK.ErrorKind.UNMATCHED_CLOSING_TAG, $f0b17cf458732d60$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error($7MBHK.ErrorKind.INVALID_TAG, $f0b17cf458732d60$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: $jdbJG.TYPE.tag,
                        value: tagName,
                        children: children,
                        location: $f0b17cf458732d60$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error($7MBHK.ErrorKind.UNCLOSED_TAG, $f0b17cf458732d60$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error($7MBHK.ErrorKind.INVALID_TAG, $f0b17cf458732d60$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $f0b17cf458732d60$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $f0b17cf458732d60$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: $jdbJG.TYPE.literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$f0b17cf458732d60$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $f0b17cf458732d60$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $f0b17cf458732d60$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error($7MBHK.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $f0b17cf458732d60$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error($7MBHK.ErrorKind.EMPTY_ARGUMENT, $f0b17cf458732d60$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error($7MBHK.ErrorKind.MALFORMED_ARGUMENT, $f0b17cf458732d60$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error($7MBHK.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $f0b17cf458732d60$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: $jdbJG.TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $f0b17cf458732d60$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error($7MBHK.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $f0b17cf458732d60$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error($7MBHK.ErrorKind.MALFORMED_ARGUMENT, $f0b17cf458732d60$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $f0b17cf458732d60$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $f0b17cf458732d60$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error($7MBHK.ErrorKind.EXPECT_ARGUMENT_TYPE, $f0b17cf458732d60$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $f0b17cf458732d60$var$trimEnd(result.val);
                    if (style.length === 0) return this.error($7MBHK.ErrorKind.EXPECT_ARGUMENT_STYLE, $f0b17cf458732d60$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $f0b17cf458732d60$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $f0b17cf458732d60$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $f0b17cf458732d60$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $f0b17cf458732d60$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: $jdbJG.TYPE.number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error($7MBHK.ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $7zfy1.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: $jdbJG.SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $iL4tO.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? $jdbJG.TYPE.date : $jdbJG.TYPE.time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? $jdbJG.TYPE.number : argType === "date" ? $jdbJG.TYPE.date : $jdbJG.TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error($7MBHK.ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, $f0b17cf458732d60$var$createLocation(typeEndPosition_1, $eIwgG.__assign({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error($7MBHK.ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $f0b17cf458732d60$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger($7MBHK.ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $7MBHK.ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $f0b17cf458732d60$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: $jdbJG.TYPE.select,
                        value: value,
                        options: $f0b17cf458732d60$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: $jdbJG.TYPE.plural,
                        value: value,
                        options: $f0b17cf458732d60$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error($7MBHK.ErrorKind.INVALID_ARGUMENT_TYPE, $f0b17cf458732d60$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error($7MBHK.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $f0b17cf458732d60$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error($7MBHK.ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $f0b17cf458732d60$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $iL4tO.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error($7MBHK.ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: $jdbJG.SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $iL4tO.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger($7MBHK.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, $7MBHK.ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $f0b17cf458732d60$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? $7MBHK.ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR : $7MBHK.ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? $7MBHK.ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : $7MBHK.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $f0b17cf458732d60$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $f0b17cf458732d60$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? $7MBHK.ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR : $7MBHK.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, $f0b17cf458732d60$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error($7MBHK.ErrorKind.MISSING_OTHER_CLAUSE, $f0b17cf458732d60$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $f0b17cf458732d60$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$f0b17cf458732d60$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $f0b17cf458732d60$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($f0b17cf458732d60$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $f0b17cf458732d60$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
module.exports.Parser = $f0b17cf458732d60$var$Parser;
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $f0b17cf458732d60$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $f0b17cf458732d60$var$_isAlphaOrSlash(codepoint) {
    return $f0b17cf458732d60$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $f0b17cf458732d60$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $f0b17cf458732d60$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $f0b17cf458732d60$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("jdbJG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNumberElement = module.exports.createLiteralElement = module.exports.isDateTimeSkeleton = module.exports.isNumberSkeleton = module.exports.isTagElement = module.exports.isPoundElement = module.exports.isPluralElement = module.exports.isSelectElement = module.exports.isTimeElement = module.exports.isDateElement = module.exports.isNumberElement = module.exports.isArgumentElement = module.exports.isLiteralElement = module.exports.SKELETON_TYPE = module.exports.TYPE = void 0;
var $dfc855afac966db5$var$TYPE;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($dfc855afac966db5$var$TYPE || (module.exports.TYPE = $dfc855afac966db5$var$TYPE = {}));
var $dfc855afac966db5$var$SKELETON_TYPE;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($dfc855afac966db5$var$SKELETON_TYPE || (module.exports.SKELETON_TYPE = $dfc855afac966db5$var$SKELETON_TYPE = {}));
/**
 * Type Guards
 */ function $dfc855afac966db5$var$isLiteralElement(el) {
    return el.type === $dfc855afac966db5$var$TYPE.literal;
}
module.exports.isLiteralElement = $dfc855afac966db5$var$isLiteralElement;
function $dfc855afac966db5$var$isArgumentElement(el) {
    return el.type === $dfc855afac966db5$var$TYPE.argument;
}
module.exports.isArgumentElement = $dfc855afac966db5$var$isArgumentElement;
function $dfc855afac966db5$var$isNumberElement(el) {
    return el.type === $dfc855afac966db5$var$TYPE.number;
}
module.exports.isNumberElement = $dfc855afac966db5$var$isNumberElement;
function $dfc855afac966db5$var$isDateElement(el) {
    return el.type === $dfc855afac966db5$var$TYPE.date;
}
module.exports.isDateElement = $dfc855afac966db5$var$isDateElement;
function $dfc855afac966db5$var$isTimeElement(el) {
    return el.type === $dfc855afac966db5$var$TYPE.time;
}
module.exports.isTimeElement = $dfc855afac966db5$var$isTimeElement;
function $dfc855afac966db5$var$isSelectElement(el) {
    return el.type === $dfc855afac966db5$var$TYPE.select;
}
module.exports.isSelectElement = $dfc855afac966db5$var$isSelectElement;
function $dfc855afac966db5$var$isPluralElement(el) {
    return el.type === $dfc855afac966db5$var$TYPE.plural;
}
module.exports.isPluralElement = $dfc855afac966db5$var$isPluralElement;
function $dfc855afac966db5$var$isPoundElement(el) {
    return el.type === $dfc855afac966db5$var$TYPE.pound;
}
module.exports.isPoundElement = $dfc855afac966db5$var$isPoundElement;
function $dfc855afac966db5$var$isTagElement(el) {
    return el.type === $dfc855afac966db5$var$TYPE.tag;
}
module.exports.isTagElement = $dfc855afac966db5$var$isTagElement;
function $dfc855afac966db5$var$isNumberSkeleton(el) {
    return !!(el && typeof el === "object" && el.type === $dfc855afac966db5$var$SKELETON_TYPE.number);
}
module.exports.isNumberSkeleton = $dfc855afac966db5$var$isNumberSkeleton;
function $dfc855afac966db5$var$isDateTimeSkeleton(el) {
    return !!(el && typeof el === "object" && el.type === $dfc855afac966db5$var$SKELETON_TYPE.dateTime);
}
module.exports.isDateTimeSkeleton = $dfc855afac966db5$var$isDateTimeSkeleton;
function $dfc855afac966db5$var$createLiteralElement(value) {
    return {
        type: $dfc855afac966db5$var$TYPE.literal,
        value: value
    };
}
module.exports.createLiteralElement = $dfc855afac966db5$var$createLiteralElement;
function $dfc855afac966db5$var$createNumberElement(value, style) {
    return {
        type: $dfc855afac966db5$var$TYPE.number,
        value: value,
        style: style
    };
}
module.exports.createNumberElement = $dfc855afac966db5$var$createNumberElement;

});

parcelRegister("er47z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WHITE_SPACE_REGEX = module.exports.SPACE_SEPARATOR_REGEX = void 0;
// @generated from regex-gen.ts
module.exports.SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
module.exports.WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("iL4tO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eIwgG = parcelRequire("eIwgG");

$eIwgG.__exportStar((parcelRequire("6jrI7")), module.exports);

$eIwgG.__exportStar((parcelRequire("apw23")), module.exports);

});
parcelRegister("6jrI7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseDateTimeSkeleton = void 0;
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $498a032590a23609$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */ function $498a032590a23609$var$parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace($498a032590a23609$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}
module.exports.parseDateTimeSkeleton = $498a032590a23609$var$parseDateTimeSkeleton;

});

parcelRegister("apw23", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseNumberSkeleton = module.exports.parseNumberSkeletonFromString = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $fZdsk = parcelRequire("fZdsk");
function $7945161463de32d3$var$parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split($fZdsk.WHITE_SPACE_REGEX).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
module.exports.parseNumberSkeletonFromString = $7945161463de32d3$var$parseNumberSkeletonFromString;
function $7945161463de32d3$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $7945161463de32d3$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $7945161463de32d3$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $7945161463de32d3$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $7945161463de32d3$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $7945161463de32d3$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($7945161463de32d3$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $7945161463de32d3$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $7945161463de32d3$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$7945161463de32d3$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $7945161463de32d3$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $7945161463de32d3$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */ function $7945161463de32d3$var$parseNumberSkeleton(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $7945161463de32d3$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = $eIwgG.__assign($eIwgG.__assign($eIwgG.__assign({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return $eIwgG.__assign($eIwgG.__assign({}, all), $7945161463de32d3$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = $eIwgG.__assign($eIwgG.__assign($eIwgG.__assign({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return $eIwgG.__assign($eIwgG.__assign({}, all), $7945161463de32d3$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($7945161463de32d3$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($7945161463de32d3$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($7945161463de32d3$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($7945161463de32d3$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = $eIwgG.__assign($eIwgG.__assign({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = $eIwgG.__assign($eIwgG.__assign({}, result), $7945161463de32d3$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($7945161463de32d3$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = $eIwgG.__assign($eIwgG.__assign({}, result), $7945161463de32d3$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $7945161463de32d3$var$parseSign(token.stem);
        if (signOpts) result = $eIwgG.__assign($eIwgG.__assign({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $7945161463de32d3$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = $eIwgG.__assign($eIwgG.__assign({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}
module.exports.parseNumberSkeleton = $7945161463de32d3$var$parseNumberSkeleton;

});
parcelRegister("fZdsk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WHITE_SPACE_REGEX = void 0;
// @generated from regex-gen.ts
module.exports.WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("7zfy1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBestPattern = void 0;

var $k4xOE = parcelRequire("k4xOE");
/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */ function $5827dcbff5247d37$var$getBestPattern(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $5827dcbff5247d37$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
module.exports.getBestPattern = $5827dcbff5247d37$var$getBestPattern;
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $5827dcbff5247d37$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = $k4xOE.timeData[regionTag || ""] || $k4xOE.timeData[languageTag || ""] || $k4xOE.timeData["".concat(languageTag, "-001")] || $k4xOE.timeData["001"];
    return hourCycles[0];
}

});
parcelRegister("k4xOE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.timeData = void 0;
// @generated from time-data-gen.ts
// prettier-ignore  
module.exports.timeData = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("b2bpw", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $8088bb8d3af0f393$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "strategies", function () { return $8088bb8d3af0f393$export$c5491a8691a23b9e; });
//
// Main
//
function $8088bb8d3af0f393$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $8088bb8d3af0f393$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $8088bb8d3af0f393$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $8088bb8d3af0f393$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $8088bb8d3af0f393$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $8088bb8d3af0f393$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $8088bb8d3af0f393$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $8088bb8d3af0f393$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $8088bb8d3af0f393$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $8088bb8d3af0f393$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $8088bb8d3af0f393$var$monadic : $8088bb8d3af0f393$var$variadic;
    return $8088bb8d3af0f393$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $8088bb8d3af0f393$var$strategyVariadic(fn, options) {
    return $8088bb8d3af0f393$var$assemble(fn, this, $8088bb8d3af0f393$var$variadic, options.cache.create(), options.serializer);
}
function $8088bb8d3af0f393$var$strategyMonadic(fn, options) {
    return $8088bb8d3af0f393$var$assemble(fn, this, $8088bb8d3af0f393$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $8088bb8d3af0f393$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $8088bb8d3af0f393$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$8088bb8d3af0f393$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$8088bb8d3af0f393$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $8088bb8d3af0f393$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $8088bb8d3af0f393$var$ObjectWithoutPrototypeCache();
    }
};
var $8088bb8d3af0f393$export$c5491a8691a23b9e = {
    variadic: $8088bb8d3af0f393$var$strategyVariadic,
    monadic: $8088bb8d3af0f393$var$strategyMonadic
};

});

parcelRegister("inclu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatToParts = module.exports.isFormatXMLElementFn = module.exports.PART_TYPE = void 0;

var $ash9y = parcelRequire("ash9y");

var $8Rsmd = parcelRequire("8Rsmd");
var $d603f38f6012dc65$var$PART_TYPE;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($d603f38f6012dc65$var$PART_TYPE || (module.exports.PART_TYPE = $d603f38f6012dc65$var$PART_TYPE = {}));
function $d603f38f6012dc65$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $d603f38f6012dc65$var$PART_TYPE.literal || part.type !== $d603f38f6012dc65$var$PART_TYPE.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $d603f38f6012dc65$var$isFormatXMLElementFn(el) {
    return typeof el === "function";
}
module.exports.isFormatXMLElementFn = $d603f38f6012dc65$var$isFormatXMLElementFn;
// TODO(skeleton): add skeleton support
function $d603f38f6012dc65$var$formatToParts(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $ash9y.isLiteralElement)(els[0])) return [
        {
            type: $d603f38f6012dc65$var$PART_TYPE.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $ash9y.isLiteralElement)(el)) {
            result.push({
                type: $d603f38f6012dc65$var$PART_TYPE.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $ash9y.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $d603f38f6012dc65$var$PART_TYPE.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new $8Rsmd.MissingValueError(varName, originalMessage);
        var value = values[varName];
        if ((0, $ash9y.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $d603f38f6012dc65$var$PART_TYPE.literal : $d603f38f6012dc65$var$PART_TYPE.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $ash9y.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $ash9y.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $d603f38f6012dc65$var$PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $ash9y.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $ash9y.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $d603f38f6012dc65$var$PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $ash9y.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $ash9y.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $d603f38f6012dc65$var$PART_TYPE.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $ash9y.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$d603f38f6012dc65$var$isFormatXMLElementFn(formatFn)) throw new $8Rsmd.InvalidValueTypeError(value_1, "function", originalMessage);
            var parts = $d603f38f6012dc65$var$formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $d603f38f6012dc65$var$PART_TYPE.literal : $d603f38f6012dc65$var$PART_TYPE.object,
                    value: c
                };
            }));
        }
        if ((0, $ash9y.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new $8Rsmd.InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $d603f38f6012dc65$var$formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $ash9y.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new $8Rsmd.FormatError('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', $8Rsmd.ErrorCode.MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new $8Rsmd.InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $d603f38f6012dc65$var$formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $d603f38f6012dc65$var$mergeLiteral(result);
}
module.exports.formatToParts = $d603f38f6012dc65$var$formatToParts;

});
parcelRegister("8Rsmd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MissingValueError = module.exports.InvalidValueTypeError = module.exports.InvalidValueError = module.exports.FormatError = module.exports.ErrorCode = void 0;

var $eIwgG = parcelRequire("eIwgG");
var $673945290c5ffed7$var$ErrorCode;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($673945290c5ffed7$var$ErrorCode || (module.exports.ErrorCode = $673945290c5ffed7$var$ErrorCode = {}));
var $673945290c5ffed7$var$FormatError = /** @class */ function(_super) {
    $eIwgG.__extends(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
module.exports.FormatError = $673945290c5ffed7$var$FormatError;
var $673945290c5ffed7$var$InvalidValueError = /** @class */ function(_super) {
    $eIwgG.__extends(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $673945290c5ffed7$var$ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($673945290c5ffed7$var$FormatError);
module.exports.InvalidValueError = $673945290c5ffed7$var$InvalidValueError;
var $673945290c5ffed7$var$InvalidValueTypeError = /** @class */ function(_super) {
    $eIwgG.__extends(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $673945290c5ffed7$var$ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($673945290c5ffed7$var$FormatError);
module.exports.InvalidValueTypeError = $673945290c5ffed7$var$InvalidValueTypeError;
var $673945290c5ffed7$var$MissingValueError = /** @class */ function(_super) {
    $eIwgG.__extends(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $673945290c5ffed7$var$ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($673945290c5ffed7$var$FormatError);
module.exports.MissingValueError = $673945290c5ffed7$var$MissingValueError;

});




parcelRegister("8hOmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MissingTranslationError = module.exports.MessageFormatError = module.exports.IntlFormatError = module.exports.MissingDataError = module.exports.InvalidConfigError = module.exports.UnsupportedFormatterError = module.exports.IntlError = module.exports.IntlErrorCode = void 0;

var $eIwgG = parcelRequire("eIwgG");
var $6086f9196d794e52$var$IntlErrorCode;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($6086f9196d794e52$var$IntlErrorCode || (module.exports.IntlErrorCode = $6086f9196d794e52$var$IntlErrorCode = {}));
var $6086f9196d794e52$var$IntlError = /** @class */ function(_super) {
    $eIwgG.__extends(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
module.exports.IntlError = $6086f9196d794e52$var$IntlError;
var $6086f9196d794e52$var$UnsupportedFormatterError = /** @class */ function(_super) {
    $eIwgG.__extends(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $6086f9196d794e52$var$IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($6086f9196d794e52$var$IntlError);
module.exports.UnsupportedFormatterError = $6086f9196d794e52$var$UnsupportedFormatterError;
var $6086f9196d794e52$var$InvalidConfigError = /** @class */ function(_super) {
    $eIwgG.__extends(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $6086f9196d794e52$var$IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($6086f9196d794e52$var$IntlError);
module.exports.InvalidConfigError = $6086f9196d794e52$var$InvalidConfigError;
var $6086f9196d794e52$var$MissingDataError = /** @class */ function(_super) {
    $eIwgG.__extends(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $6086f9196d794e52$var$IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($6086f9196d794e52$var$IntlError);
module.exports.MissingDataError = $6086f9196d794e52$var$MissingDataError;
var $6086f9196d794e52$var$IntlFormatError = /** @class */ function(_super) {
    $eIwgG.__extends(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $6086f9196d794e52$var$IntlErrorCode.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($6086f9196d794e52$var$IntlError);
module.exports.IntlFormatError = $6086f9196d794e52$var$IntlFormatError;
var $6086f9196d794e52$var$MessageFormatError = /** @class */ function(_super) {
    $eIwgG.__extends(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($6086f9196d794e52$var$IntlFormatError);
module.exports.MessageFormatError = $6086f9196d794e52$var$MessageFormatError;
var $6086f9196d794e52$var$MissingTranslationError = /** @class */ function(_super) {
    $eIwgG.__extends(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $6086f9196d794e52$var$IntlErrorCode.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($6086f9196d794e52$var$IntlError);
module.exports.MissingTranslationError = $6086f9196d794e52$var$MissingTranslationError;

});


parcelRegister("aQNFd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatMessage = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $3C7dM = parcelRequire("3C7dM");

var $8kYn6 = parcelRequire("8kYn6");

var $8hOmc = parcelRequire("8hOmc");

var $ash9y = parcelRequire("ash9y");
function $7e6548e27ace5063$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = $eIwgG.__assign({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $7e6548e27ace5063$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys($eIwgG.__assign($eIwgG.__assign({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = $eIwgG.__assign($eIwgG.__assign({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $7e6548e27ace5063$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = $8kYn6.IntlMessageFormat.formats;
    return $eIwgG.__assign($eIwgG.__assign($eIwgG.__assign({}, mfFormats), f1), {
        date: $7e6548e27ace5063$var$deepMergeOptions($7e6548e27ace5063$var$setTimeZoneInOptions(mfFormats.date, timeZone), $7e6548e27ace5063$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $7e6548e27ace5063$var$deepMergeOptions($7e6548e27ace5063$var$setTimeZoneInOptions(mfFormats.time, timeZone), $7e6548e27ace5063$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $7e6548e27ace5063$var$formatMessage = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $3C7dM.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === $ash9y.TYPE.literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = $eIwgG.__assign($eIwgG.__assign({}, defaultRichTextElements), values || {});
    formats = $7e6548e27ace5063$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $7e6548e27ace5063$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new $8hOmc.MissingTranslationError(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new $8hOmc.MessageFormatError('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, $eIwgG.__assign({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new $8hOmc.MessageFormatError('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new $8hOmc.MessageFormatError('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};
module.exports.formatMessage = $7e6548e27ace5063$var$formatMessage;

});
parcelRegister("3C7dM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.invariant = module.exports.isMissingLocaleDataError = module.exports.defineProperty = module.exports.getMagnitude = module.exports.setMultiInternalSlots = module.exports.setInternalSlot = module.exports.isLiteralPart = module.exports.getMultiInternalSlots = module.exports.getInternalSlot = module.exports._formatToParts = void 0;

var $eIwgG = parcelRequire("eIwgG");

$eIwgG.__exportStar((parcelRequire("51U6O")), module.exports);

$eIwgG.__exportStar((parcelRequire("fCLzX")), module.exports);

$eIwgG.__exportStar((parcelRequire("eo8HH")), module.exports);

$eIwgG.__exportStar((parcelRequire("hoLlz")), module.exports);

$eIwgG.__exportStar((parcelRequire("1LY2e")), module.exports);

$eIwgG.__exportStar((parcelRequire("YCTkz")), module.exports);

$eIwgG.__exportStar((parcelRequire("gH4FO")), module.exports);

$eIwgG.__exportStar((parcelRequire("cVV1p")), module.exports);

$eIwgG.__exportStar((parcelRequire("3ORLh")), module.exports);

$eIwgG.__exportStar((parcelRequire("L3kEB")), module.exports);

$eIwgG.__exportStar((parcelRequire("jkhUU")), module.exports);

$eIwgG.__exportStar((parcelRequire("9B98e")), module.exports);

$eIwgG.__exportStar((parcelRequire("7rHow")), module.exports);

$eIwgG.__exportStar((parcelRequire("hOgkO")), module.exports);

$eIwgG.__exportStar((parcelRequire("5qSfT")), module.exports);

$eIwgG.__exportStar((parcelRequire("ggmtP")), module.exports);

$eIwgG.__exportStar((parcelRequire("gHt8R")), module.exports);

$eIwgG.__exportStar((parcelRequire("cT5Nn")), module.exports);

$eIwgG.__exportStar((parcelRequire("krb5m")), module.exports);

$eIwgG.__exportStar((parcelRequire("jmqIJ")), module.exports);

$eIwgG.__exportStar((parcelRequire("jUA1h")), module.exports);

$eIwgG.__exportStar((parcelRequire("gNPgY")), module.exports);

$eIwgG.__exportStar((parcelRequire("2Yiy5")), module.exports);

$eIwgG.__exportStar((parcelRequire("js46X")), module.exports);

$eIwgG.__exportStar((parcelRequire("fvnKm")), module.exports);

$eIwgG.__exportStar((parcelRequire("5do86")), module.exports);

$eIwgG.__exportStar((parcelRequire("clykw")), module.exports);

$eIwgG.__exportStar((parcelRequire("iDQ56")), module.exports);

$eIwgG.__exportStar((parcelRequire("hIGRw")), module.exports);

var $aT7Sg = parcelRequire("aT7Sg");
Object.defineProperty(module.exports, "_formatToParts", {
    enumerable: true,
    get: function() {
        return $eIwgG.__importDefault($aT7Sg).default;
    }
});

$eIwgG.__exportStar((parcelRequire("8CmPa")), module.exports);

$eIwgG.__exportStar((parcelRequire("k1ODG")), module.exports);

var $kuWop = parcelRequire("kuWop");
Object.defineProperty(module.exports, "getInternalSlot", {
    enumerable: true,
    get: function() {
        return $kuWop.getInternalSlot;
    }
});
Object.defineProperty(module.exports, "getMultiInternalSlots", {
    enumerable: true,
    get: function() {
        return $kuWop.getMultiInternalSlots;
    }
});
Object.defineProperty(module.exports, "isLiteralPart", {
    enumerable: true,
    get: function() {
        return $kuWop.isLiteralPart;
    }
});
Object.defineProperty(module.exports, "setInternalSlot", {
    enumerable: true,
    get: function() {
        return $kuWop.setInternalSlot;
    }
});
Object.defineProperty(module.exports, "setMultiInternalSlots", {
    enumerable: true,
    get: function() {
        return $kuWop.setMultiInternalSlots;
    }
});
Object.defineProperty(module.exports, "getMagnitude", {
    enumerable: true,
    get: function() {
        return $kuWop.getMagnitude;
    }
});
Object.defineProperty(module.exports, "defineProperty", {
    enumerable: true,
    get: function() {
        return $kuWop.defineProperty;
    }
});

var $8q0zc = parcelRequire("8q0zc");
Object.defineProperty(module.exports, "isMissingLocaleDataError", {
    enumerable: true,
    get: function() {
        return $8q0zc.isMissingLocaleDataError;
    }
});

$eIwgG.__exportStar((parcelRequire("3uegr")), module.exports);

$eIwgG.__exportStar((parcelRequire("iHV3H")), module.exports);

$eIwgG.__exportStar((parcelRequire("ePyoG")), module.exports);

$eIwgG.__exportStar((parcelRequire("7VnGo")), module.exports);

$eIwgG.__exportStar((parcelRequire("citf9")), module.exports);

$eIwgG.__exportStar((parcelRequire("3cCv2")), module.exports);

var $kuWop = parcelRequire("kuWop");
Object.defineProperty(module.exports, "invariant", {
    enumerable: true,
    get: function() {
        return $kuWop.invariant;
    }
});

$eIwgG.__exportStar((parcelRequire("ggNGK")), module.exports);

});
parcelRegister("51U6O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CanonicalizeLocaleList = void 0;
/**
 * http://ecma-international.org/ecma-402/7.0/index.html#sec-canonicalizelocalelist
 * @param locales
 */ function $3a9891cd01ec774f$var$CanonicalizeLocaleList(locales) {
    // TODO
    return Intl.getCanonicalLocales(locales);
}
module.exports.CanonicalizeLocaleList = $3a9891cd01ec774f$var$CanonicalizeLocaleList;

});

parcelRegister("fCLzX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CanonicalizeTimeZoneName = void 0;
/**
 * https://tc39.es/ecma402/#sec-canonicalizetimezonename
 * @param tz
 */ function $b5ff4fd244b58537$var$CanonicalizeTimeZoneName(tz, _a) {
    var tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
    var uppercasedTz = tz.toUpperCase();
    var uppercasedZones = Object.keys(tzData).reduce(function(all, z) {
        all[z.toUpperCase()] = z;
        return all;
    }, {});
    var ianaTimeZone = uppercaseLinks[uppercasedTz] || uppercasedZones[uppercasedTz];
    if (ianaTimeZone === "Etc/UTC" || ianaTimeZone === "Etc/GMT") return "UTC";
    return ianaTimeZone;
}
module.exports.CanonicalizeTimeZoneName = $b5ff4fd244b58537$var$CanonicalizeTimeZoneName;

});

parcelRegister("eo8HH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoerceOptionsToObject = void 0;

var $ggNGK = parcelRequire("ggNGK");
/**
 * https://tc39.es/ecma402/#sec-coerceoptionstoobject
 * @param options
 * @returns
 */ function $a79a0efdbcfe5118$var$CoerceOptionsToObject(options) {
    if (typeof options === "undefined") return Object.create(null);
    return (0, $ggNGK.ToObject)(options);
}
module.exports.CoerceOptionsToObject = $a79a0efdbcfe5118$var$CoerceOptionsToObject;

});
parcelRegister("ggNGK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.msFromTime = module.exports.OrdinaryHasInstance = module.exports.SecFromTime = module.exports.MinFromTime = module.exports.HourFromTime = module.exports.DateFromTime = module.exports.MonthFromTime = module.exports.InLeapYear = module.exports.DayWithinYear = module.exports.DaysInYear = module.exports.YearFromTime = module.exports.TimeFromYear = module.exports.DayFromYear = module.exports.WeekDay = module.exports.Day = module.exports.Type = module.exports.HasOwnProperty = module.exports.ArrayCreate = module.exports.SameValue = module.exports.ToObject = module.exports.TimeClip = module.exports.ToNumber = module.exports.ToString = void 0;
/**
 * https://tc39.es/ecma262/#sec-tostring
 */ function $bd84af0e72c33175$var$ToString(o) {
    // Only symbol is irregular...
    if (typeof o === "symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return String(o);
}
module.exports.ToString = $bd84af0e72c33175$var$ToString;
/**
 * https://tc39.es/ecma262/#sec-tonumber
 * @param val
 */ function $bd84af0e72c33175$var$ToNumber(val) {
    if (val === undefined) return NaN;
    if (val === null) return 0;
    if (typeof val === "boolean") return val ? 1 : 0;
    if (typeof val === "number") return val;
    if (typeof val === "symbol" || typeof val === "bigint") throw new TypeError("Cannot convert symbol/bigint to number");
    return Number(val);
}
module.exports.ToNumber = $bd84af0e72c33175$var$ToNumber;
/**
 * https://tc39.es/ecma262/#sec-tointeger
 * @param n
 */ function $bd84af0e72c33175$var$ToInteger(n) {
    var number = $bd84af0e72c33175$var$ToNumber(n);
    if (isNaN(number) || $bd84af0e72c33175$var$SameValue(number, -0)) return 0;
    if (isFinite(number)) return number;
    var integer = Math.floor(Math.abs(number));
    if (number < 0) integer = -integer;
    if ($bd84af0e72c33175$var$SameValue(integer, -0)) return 0;
    return integer;
}
/**
 * https://tc39.es/ecma262/#sec-timeclip
 * @param time
 */ function $bd84af0e72c33175$var$TimeClip(time) {
    if (!isFinite(time)) return NaN;
    if (Math.abs(time) > 8.64 * 1e15) return NaN;
    return $bd84af0e72c33175$var$ToInteger(time);
}
module.exports.TimeClip = $bd84af0e72c33175$var$TimeClip;
/**
 * https://tc39.es/ecma262/#sec-toobject
 * @param arg
 */ function $bd84af0e72c33175$var$ToObject(arg) {
    if (arg == null) throw new TypeError("undefined/null cannot be converted to object");
    return Object(arg);
}
module.exports.ToObject = $bd84af0e72c33175$var$ToObject;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-samevalue
 * @param x
 * @param y
 */ function $bd84af0e72c33175$var$SameValue(x, y) {
    if (Object.is) return Object.is(x, y);
    // SameValue algorithm
    if (x === y) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return x !== 0 || 1 / x === 1 / y;
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
}
module.exports.SameValue = $bd84af0e72c33175$var$SameValue;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-arraycreate
 * @param len
 */ function $bd84af0e72c33175$var$ArrayCreate(len) {
    return new Array(len);
}
module.exports.ArrayCreate = $bd84af0e72c33175$var$ArrayCreate;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-hasownproperty
 * @param o
 * @param prop
 */ function $bd84af0e72c33175$var$HasOwnProperty(o, prop) {
    return Object.prototype.hasOwnProperty.call(o, prop);
}
module.exports.HasOwnProperty = $bd84af0e72c33175$var$HasOwnProperty;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-type
 * @param x
 */ function $bd84af0e72c33175$var$Type(x) {
    if (x === null) return "Null";
    if (typeof x === "undefined") return "Undefined";
    if (typeof x === "function" || typeof x === "object") return "Object";
    if (typeof x === "number") return "Number";
    if (typeof x === "boolean") return "Boolean";
    if (typeof x === "string") return "String";
    if (typeof x === "symbol") return "Symbol";
    if (typeof x === "bigint") return "BigInt";
}
module.exports.Type = $bd84af0e72c33175$var$Type;
var $bd84af0e72c33175$var$MS_PER_DAY = 86400000;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#eqn-modulo
 * @param x
 * @param y
 * @return k of the same sign as y
 */ function $bd84af0e72c33175$var$mod(x, y) {
    return x - Math.floor(x / y) * y;
}
/**
 * https://tc39.es/ecma262/#eqn-Day
 * @param t
 */ function $bd84af0e72c33175$var$Day(t) {
    return Math.floor(t / $bd84af0e72c33175$var$MS_PER_DAY);
}
module.exports.Day = $bd84af0e72c33175$var$Day;
/**
 * https://tc39.es/ecma262/#sec-week-day
 * @param t
 */ function $bd84af0e72c33175$var$WeekDay(t) {
    return $bd84af0e72c33175$var$mod($bd84af0e72c33175$var$Day(t) + 4, 7);
}
module.exports.WeekDay = $bd84af0e72c33175$var$WeekDay;
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param y
 */ function $bd84af0e72c33175$var$DayFromYear(y) {
    return Date.UTC(y, 0) / $bd84af0e72c33175$var$MS_PER_DAY;
}
module.exports.DayFromYear = $bd84af0e72c33175$var$DayFromYear;
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param y
 */ function $bd84af0e72c33175$var$TimeFromYear(y) {
    return Date.UTC(y, 0);
}
module.exports.TimeFromYear = $bd84af0e72c33175$var$TimeFromYear;
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param t
 */ function $bd84af0e72c33175$var$YearFromTime(t) {
    return new Date(t).getUTCFullYear();
}
module.exports.YearFromTime = $bd84af0e72c33175$var$YearFromTime;
function $bd84af0e72c33175$var$DaysInYear(y) {
    if (y % 4 !== 0) return 365;
    if (y % 100 !== 0) return 366;
    if (y % 400 !== 0) return 365;
    return 366;
}
module.exports.DaysInYear = $bd84af0e72c33175$var$DaysInYear;
function $bd84af0e72c33175$var$DayWithinYear(t) {
    return $bd84af0e72c33175$var$Day(t) - $bd84af0e72c33175$var$DayFromYear($bd84af0e72c33175$var$YearFromTime(t));
}
module.exports.DayWithinYear = $bd84af0e72c33175$var$DayWithinYear;
function $bd84af0e72c33175$var$InLeapYear(t) {
    return $bd84af0e72c33175$var$DaysInYear($bd84af0e72c33175$var$YearFromTime(t)) === 365 ? 0 : 1;
}
module.exports.InLeapYear = $bd84af0e72c33175$var$InLeapYear;
/**
 * https://tc39.es/ecma262/#sec-month-number
 * @param t
 */ function $bd84af0e72c33175$var$MonthFromTime(t) {
    var dwy = $bd84af0e72c33175$var$DayWithinYear(t);
    var leap = $bd84af0e72c33175$var$InLeapYear(t);
    if (dwy >= 0 && dwy < 31) return 0;
    if (dwy < 59 + leap) return 1;
    if (dwy < 90 + leap) return 2;
    if (dwy < 120 + leap) return 3;
    if (dwy < 151 + leap) return 4;
    if (dwy < 181 + leap) return 5;
    if (dwy < 212 + leap) return 6;
    if (dwy < 243 + leap) return 7;
    if (dwy < 273 + leap) return 8;
    if (dwy < 304 + leap) return 9;
    if (dwy < 334 + leap) return 10;
    if (dwy < 365 + leap) return 11;
    throw new Error("Invalid time");
}
module.exports.MonthFromTime = $bd84af0e72c33175$var$MonthFromTime;
function $bd84af0e72c33175$var$DateFromTime(t) {
    var dwy = $bd84af0e72c33175$var$DayWithinYear(t);
    var mft = $bd84af0e72c33175$var$MonthFromTime(t);
    var leap = $bd84af0e72c33175$var$InLeapYear(t);
    if (mft === 0) return dwy + 1;
    if (mft === 1) return dwy - 30;
    if (mft === 2) return dwy - 58 - leap;
    if (mft === 3) return dwy - 89 - leap;
    if (mft === 4) return dwy - 119 - leap;
    if (mft === 5) return dwy - 150 - leap;
    if (mft === 6) return dwy - 180 - leap;
    if (mft === 7) return dwy - 211 - leap;
    if (mft === 8) return dwy - 242 - leap;
    if (mft === 9) return dwy - 272 - leap;
    if (mft === 10) return dwy - 303 - leap;
    if (mft === 11) return dwy - 333 - leap;
    throw new Error("Invalid time");
}
module.exports.DateFromTime = $bd84af0e72c33175$var$DateFromTime;
var $bd84af0e72c33175$var$HOURS_PER_DAY = 24;
var $bd84af0e72c33175$var$MINUTES_PER_HOUR = 60;
var $bd84af0e72c33175$var$SECONDS_PER_MINUTE = 60;
var $bd84af0e72c33175$var$MS_PER_SECOND = 1e3;
var $bd84af0e72c33175$var$MS_PER_MINUTE = $bd84af0e72c33175$var$MS_PER_SECOND * $bd84af0e72c33175$var$SECONDS_PER_MINUTE;
var $bd84af0e72c33175$var$MS_PER_HOUR = $bd84af0e72c33175$var$MS_PER_MINUTE * $bd84af0e72c33175$var$MINUTES_PER_HOUR;
function $bd84af0e72c33175$var$HourFromTime(t) {
    return $bd84af0e72c33175$var$mod(Math.floor(t / $bd84af0e72c33175$var$MS_PER_HOUR), $bd84af0e72c33175$var$HOURS_PER_DAY);
}
module.exports.HourFromTime = $bd84af0e72c33175$var$HourFromTime;
function $bd84af0e72c33175$var$MinFromTime(t) {
    return $bd84af0e72c33175$var$mod(Math.floor(t / $bd84af0e72c33175$var$MS_PER_MINUTE), $bd84af0e72c33175$var$MINUTES_PER_HOUR);
}
module.exports.MinFromTime = $bd84af0e72c33175$var$MinFromTime;
function $bd84af0e72c33175$var$SecFromTime(t) {
    return $bd84af0e72c33175$var$mod(Math.floor(t / $bd84af0e72c33175$var$MS_PER_SECOND), $bd84af0e72c33175$var$SECONDS_PER_MINUTE);
}
module.exports.SecFromTime = $bd84af0e72c33175$var$SecFromTime;
function $bd84af0e72c33175$var$IsCallable(fn) {
    return typeof fn === "function";
}
/**
 * The abstract operation OrdinaryHasInstance implements
 * the default algorithm for determining if an object O
 * inherits from the instance object inheritance path
 * provided by constructor C.
 * @param C class
 * @param O object
 * @param internalSlots internalSlots
 */ function $bd84af0e72c33175$var$OrdinaryHasInstance(C, O, internalSlots) {
    if (!$bd84af0e72c33175$var$IsCallable(C)) return false;
    if (internalSlots === null || internalSlots === void 0 ? void 0 : internalSlots.boundTargetFunction) {
        var BC = internalSlots === null || internalSlots === void 0 ? void 0 : internalSlots.boundTargetFunction;
        return O instanceof BC;
    }
    if (typeof O !== "object") return false;
    var P = C.prototype;
    if (typeof P !== "object") throw new TypeError("OrdinaryHasInstance called on an object with an invalid prototype property.");
    return Object.prototype.isPrototypeOf.call(P, O);
}
module.exports.OrdinaryHasInstance = $bd84af0e72c33175$var$OrdinaryHasInstance;
function $bd84af0e72c33175$var$msFromTime(t) {
    return $bd84af0e72c33175$var$mod(t, $bd84af0e72c33175$var$MS_PER_SECOND);
}
module.exports.msFromTime = $bd84af0e72c33175$var$msFromTime;

});


parcelRegister("hoLlz", function(module, exports) {
"use strict";
/**
 * https://tc39.es/ecma402/#sec-getnumberoption
 * @param options
 * @param property
 * @param min
 * @param max
 * @param fallback
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetNumberOption = void 0;

var $fZ7bI = parcelRequire("fZ7bI");
function $caa967a68ac017ac$var$GetNumberOption(options, property, minimum, maximum, fallback) {
    var val = options[property];
    // @ts-expect-error
    return (0, $fZ7bI.DefaultNumberOption)(val, minimum, maximum, fallback);
}
module.exports.GetNumberOption = $caa967a68ac017ac$var$GetNumberOption;

});
parcelRegister("fZ7bI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultNumberOption = void 0;
function $ba3220e388052212$var$DefaultNumberOption(val, min, max, fallback) {
    if (val !== undefined) {
        val = Number(val);
        if (isNaN(val) || val < min || val > max) throw new RangeError("".concat(val, " is outside of range [").concat(min, ", ").concat(max, "]"));
        return Math.floor(val);
    }
    return fallback;
}
module.exports.DefaultNumberOption = $ba3220e388052212$var$DefaultNumberOption;

});


parcelRegister("1LY2e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetOption = void 0;

var $ggNGK = parcelRequire("ggNGK");
/**
 * https://tc39.es/ecma402/#sec-getoption
 * @param opts
 * @param prop
 * @param type
 * @param values
 * @param fallback
 */ function $14a8bff304f7a8d9$var$GetOption(opts, prop, type, values, fallback) {
    if (typeof opts !== "object") throw new TypeError("Options must be an object");
    var value = opts[prop];
    if (value !== undefined) {
        if (type !== "boolean" && type !== "string") throw new TypeError("invalid type");
        if (type === "boolean") value = Boolean(value);
        if (type === "string") value = (0, $ggNGK.ToString)(value);
        if (values !== undefined && !values.filter(function(val) {
            return val == value;
        }).length) throw new RangeError("".concat(value, " is not within ").concat(values.join(", ")));
        return value;
    }
    return fallback;
}
module.exports.GetOption = $14a8bff304f7a8d9$var$GetOption;

});

parcelRegister("YCTkz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetOptionsObject = void 0;
/**
 * https://tc39.es/ecma402/#sec-getoptionsobject
 * @param options
 * @returns
 */ function $0b63c5bd4cfb4721$var$GetOptionsObject(options) {
    if (typeof options === "undefined") return Object.create(null);
    if (typeof options === "object") return options;
    throw new TypeError("Options must be an object");
}
module.exports.GetOptionsObject = $0b63c5bd4cfb4721$var$GetOptionsObject;

});

parcelRegister("gH4FO", function(module, exports) {
"use strict";
/**
 * https://tc39.es/ecma402/#sec-getstringorbooleanoption
 * @param opts
 * @param prop
 * @param values
 * @param trueValue
 * @param falsyValue
 * @param fallback
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetStringOrBooleanOption = void 0;

var $ggNGK = parcelRequire("ggNGK");
function $c274498502b6102f$var$GetStringOrBooleanOption(opts, prop, values, trueValue, falsyValue, fallback) {
    var value = opts[prop];
    if (value === undefined) return fallback;
    if (value === true) return trueValue;
    var valueBoolean = Boolean(value);
    if (valueBoolean === false) return falsyValue;
    value = (0, $ggNGK.ToString)(value);
    if (value === "true" || value === "false") return fallback;
    if ((values || []).indexOf(value) === -1) throw new RangeError("Invalid value ".concat(value));
    return value;
}
module.exports.GetStringOrBooleanOption = $c274498502b6102f$var$GetStringOrBooleanOption;

});

parcelRegister("cVV1p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsSanctionedSimpleUnitIdentifier = module.exports.SIMPLE_UNITS = module.exports.removeUnitNamespace = module.exports.SANCTIONED_UNITS = void 0;
/**
 * https://tc39.es/ecma402/#table-sanctioned-simple-unit-identifiers
 */ module.exports.SANCTIONED_UNITS = [
    "angle-degree",
    "area-acre",
    "area-hectare",
    "concentr-percent",
    "digital-bit",
    "digital-byte",
    "digital-gigabit",
    "digital-gigabyte",
    "digital-kilobit",
    "digital-kilobyte",
    "digital-megabit",
    "digital-megabyte",
    "digital-petabyte",
    "digital-terabit",
    "digital-terabyte",
    "duration-day",
    "duration-hour",
    "duration-millisecond",
    "duration-minute",
    "duration-month",
    "duration-second",
    "duration-week",
    "duration-year",
    "length-centimeter",
    "length-foot",
    "length-inch",
    "length-kilometer",
    "length-meter",
    "length-mile-scandinavian",
    "length-mile",
    "length-millimeter",
    "length-yard",
    "mass-gram",
    "mass-kilogram",
    "mass-ounce",
    "mass-pound",
    "mass-stone",
    "temperature-celsius",
    "temperature-fahrenheit",
    "volume-fluid-ounce",
    "volume-gallon",
    "volume-liter",
    "volume-milliliter"
];
// In CLDR, the unit name always follows the form `namespace-unit` pattern.
// For example: `digital-bit` instead of `bit`. This function removes the namespace prefix.
function $96a70a395c600f6b$var$removeUnitNamespace(unit) {
    return unit.slice(unit.indexOf("-") + 1);
}
module.exports.removeUnitNamespace = $96a70a395c600f6b$var$removeUnitNamespace;
/**
 * https://tc39.es/ecma402/#table-sanctioned-simple-unit-identifiers
 */ module.exports.SIMPLE_UNITS = module.exports.SANCTIONED_UNITS.map($96a70a395c600f6b$var$removeUnitNamespace);
/**
 * https://tc39.es/ecma402/#sec-issanctionedsimpleunitidentifier
 */ function $96a70a395c600f6b$var$IsSanctionedSimpleUnitIdentifier(unitIdentifier) {
    return module.exports.SIMPLE_UNITS.indexOf(unitIdentifier) > -1;
}
module.exports.IsSanctionedSimpleUnitIdentifier = $96a70a395c600f6b$var$IsSanctionedSimpleUnitIdentifier;

});

parcelRegister("3ORLh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsValidTimeZoneName = void 0;
/**
 * https://tc39.es/ecma402/#sec-isvalidtimezonename
 * @param tz
 * @param implDetails implementation details
 */ function $2c7fbe902e5b1bda$var$IsValidTimeZoneName(tz, _a) {
    var tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
    var uppercasedTz = tz.toUpperCase();
    var zoneNames = new Set();
    var linkNames = new Set();
    Object.keys(tzData).map(function(z) {
        return z.toUpperCase();
    }).forEach(function(z) {
        return zoneNames.add(z);
    });
    Object.keys(uppercaseLinks).forEach(function(linkName) {
        linkNames.add(linkName.toUpperCase());
        zoneNames.add(uppercaseLinks[linkName].toUpperCase());
    });
    return zoneNames.has(uppercasedTz) || linkNames.has(uppercasedTz);
}
module.exports.IsValidTimeZoneName = $2c7fbe902e5b1bda$var$IsValidTimeZoneName;

});

parcelRegister("L3kEB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsWellFormedCurrencyCode = void 0;
/**
 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
 * @param str string to convert
 */ function $08d6f997a5607419$var$toUpperCase(str) {
    return str.replace(/([a-z])/g, function(_, c) {
        return c.toUpperCase();
    });
}
var $08d6f997a5607419$var$NOT_A_Z_REGEX = /[^A-Z]/;
/**
 * https://tc39.es/ecma402/#sec-iswellformedcurrencycode
 */ function $08d6f997a5607419$var$IsWellFormedCurrencyCode(currency) {
    currency = $08d6f997a5607419$var$toUpperCase(currency);
    if (currency.length !== 3) return false;
    if ($08d6f997a5607419$var$NOT_A_Z_REGEX.test(currency)) return false;
    return true;
}
module.exports.IsWellFormedCurrencyCode = $08d6f997a5607419$var$IsWellFormedCurrencyCode;

});

parcelRegister("jkhUU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsWellFormedUnitIdentifier = void 0;

var $cVV1p = parcelRequire("cVV1p");
/**
 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
 * @param str string to convert
 */ function $e11dc882b66ee44e$var$toLowerCase(str) {
    return str.replace(/([A-Z])/g, function(_, c) {
        return c.toLowerCase();
    });
}
/**
 * https://tc39.es/ecma402/#sec-iswellformedunitidentifier
 * @param unit
 */ function $e11dc882b66ee44e$var$IsWellFormedUnitIdentifier(unit) {
    unit = $e11dc882b66ee44e$var$toLowerCase(unit);
    if ((0, $cVV1p.IsSanctionedSimpleUnitIdentifier)(unit)) return true;
    var units = unit.split("-per-");
    if (units.length !== 2) return false;
    var numerator = units[0], denominator = units[1];
    if (!(0, $cVV1p.IsSanctionedSimpleUnitIdentifier)(numerator) || !(0, $cVV1p.IsSanctionedSimpleUnitIdentifier)(denominator)) return false;
    return true;
}
module.exports.IsWellFormedUnitIdentifier = $e11dc882b66ee44e$var$IsWellFormedUnitIdentifier;

});

parcelRegister("9B98e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ApplyUnsignedRoundingMode = void 0;
function $6fcea71e1e271819$var$ApplyUnsignedRoundingMode(x, r1, r2, unsignedRoundingMode) {
    if (x === r1) return r1;
    if (unsignedRoundingMode === undefined) throw new Error("unsignedRoundingMode is mandatory");
    if (unsignedRoundingMode === "zero") return r1;
    if (unsignedRoundingMode === "infinity") return r2;
    var d1 = x - r1;
    var d2 = r2 - x;
    if (d1 < d2) return r1;
    if (d2 < d1) return r2;
    if (d1 !== d2) throw new Error("Unexpected error");
    if (unsignedRoundingMode === "half-zero") return r1;
    if (unsignedRoundingMode === "half-infinity") return r2;
    if (unsignedRoundingMode !== "half-even") throw new Error("Unexpected value for unsignedRoundingMode: ".concat(unsignedRoundingMode));
    var cardinality = r1 / (r2 - r1) % 2;
    if (cardinality === 0) return r1;
    return r2;
}
module.exports.ApplyUnsignedRoundingMode = $6fcea71e1e271819$var$ApplyUnsignedRoundingMode;

});

parcelRegister("7rHow", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollapseNumberRange = void 0;
/**
 * https://tc39.es/ecma402/#sec-collapsenumberrange
 */ function $56bcb746b8fb73c3$var$CollapseNumberRange(result) {
    return result;
}
module.exports.CollapseNumberRange = $56bcb746b8fb73c3$var$CollapseNumberRange;

});

parcelRegister("hOgkO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComputeExponent = void 0;

var $kuWop = parcelRequire("kuWop");

var $5qSfT = parcelRequire("5qSfT");

var $jUA1h = parcelRequire("jUA1h");
/**
 * The abstract operation ComputeExponent computes an exponent (power of ten) by which to scale x
 * according to the number formatting settings. It handles cases such as 999 rounding up to 1000,
 * requiring a different exponent.
 *
 * NOT IN SPEC: it returns [exponent, magnitude].
 */ function $cf73c6e5c328abc8$var$ComputeExponent(numberFormat, x, _a) {
    var getInternalSlots = _a.getInternalSlots;
    if (x === 0) return [
        0,
        0
    ];
    if (x < 0) x = -x;
    var magnitude = (0, $kuWop.getMagnitude)(x);
    var exponent = (0, $5qSfT.ComputeExponentForMagnitude)(numberFormat, magnitude, {
        getInternalSlots: getInternalSlots
    });
    // Preserve more precision by doing multiplication when exponent is negative.
    x = exponent < 0 ? x * Math.pow(10, -exponent) : x / Math.pow(10, exponent);
    var formatNumberResult = (0, $jUA1h.FormatNumericToString)(getInternalSlots(numberFormat), x);
    if (formatNumberResult.roundedNumber === 0) return [
        exponent,
        magnitude
    ];
    var newMagnitude = (0, $kuWop.getMagnitude)(formatNumberResult.roundedNumber);
    if (newMagnitude === magnitude - exponent) return [
        exponent,
        magnitude
    ];
    return [
        (0, $5qSfT.ComputeExponentForMagnitude)(numberFormat, magnitude + 1, {
            getInternalSlots: getInternalSlots
        }),
        magnitude + 1
    ];
}
module.exports.ComputeExponent = $cf73c6e5c328abc8$var$ComputeExponent;

});
parcelRegister("kuWop", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.invariant = module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = module.exports.defineProperty = module.exports.isLiteralPart = module.exports.getMultiInternalSlots = module.exports.getInternalSlot = module.exports.setMultiInternalSlots = module.exports.setInternalSlot = module.exports.repeat = module.exports.getMagnitude = void 0;
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $eec3e78e6fd31676$var$getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
module.exports.getMagnitude = $eec3e78e6fd31676$var$getMagnitude;
function $eec3e78e6fd31676$var$repeat(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
module.exports.repeat = $eec3e78e6fd31676$var$repeat;
function $eec3e78e6fd31676$var$setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
module.exports.setInternalSlot = $eec3e78e6fd31676$var$setInternalSlot;
function $eec3e78e6fd31676$var$setMultiInternalSlots(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $eec3e78e6fd31676$var$setInternalSlot(map, pl, k, props[k]);
    }
}
module.exports.setMultiInternalSlots = $eec3e78e6fd31676$var$setMultiInternalSlots;
function $eec3e78e6fd31676$var$getInternalSlot(map, pl, field) {
    return $eec3e78e6fd31676$var$getMultiInternalSlots(map, pl, field)[field];
}
module.exports.getInternalSlot = $eec3e78e6fd31676$var$getInternalSlot;
function $eec3e78e6fd31676$var$getMultiInternalSlots(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
module.exports.getMultiInternalSlots = $eec3e78e6fd31676$var$getMultiInternalSlots;
function $eec3e78e6fd31676$var$isLiteralPart(patternPart) {
    return patternPart.type === "literal";
}
module.exports.isLiteralPart = $eec3e78e6fd31676$var$isLiteralPart;
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/ function $eec3e78e6fd31676$var$defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
module.exports.defineProperty = $eec3e78e6fd31676$var$defineProperty;
module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function $eec3e78e6fd31676$var$invariant(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
module.exports.invariant = $eec3e78e6fd31676$var$invariant;

});

parcelRegister("5qSfT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComputeExponentForMagnitude = void 0;
/**
 * The abstract operation ComputeExponentForMagnitude computes an exponent by which to scale a
 * number of the given magnitude (power of ten of the most significant digit) according to the
 * locale and the desired notation (scientific, engineering, or compact).
 */ function $3f49776fafbc37e8$var$ComputeExponentForMagnitude(numberFormat, magnitude, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var notation = internalSlots.notation, dataLocaleData = internalSlots.dataLocaleData, numberingSystem = internalSlots.numberingSystem;
    switch(notation){
        case "standard":
            return 0;
        case "scientific":
            return magnitude;
        case "engineering":
            return Math.floor(magnitude / 3) * 3;
        default:
            // Let exponent be an implementation- and locale-dependent (ILD) integer by which to scale a
            // number of the given magnitude in compact notation for the current locale.
            var compactDisplay = internalSlots.compactDisplay, style = internalSlots.style, currencyDisplay = internalSlots.currencyDisplay;
            var thresholdMap = void 0;
            if (style === "currency" && currencyDisplay !== "name") {
                var currency = dataLocaleData.numbers.currency[numberingSystem] || dataLocaleData.numbers.currency[dataLocaleData.numbers.nu[0]];
                thresholdMap = currency.short;
            } else {
                var decimal = dataLocaleData.numbers.decimal[numberingSystem] || dataLocaleData.numbers.decimal[dataLocaleData.numbers.nu[0]];
                thresholdMap = compactDisplay === "long" ? decimal.long : decimal.short;
            }
            if (!thresholdMap) return 0;
            var num = String(Math.pow(10, magnitude));
            var thresholds = Object.keys(thresholdMap); // TODO: this can be pre-processed
            if (num < thresholds[0]) return 0;
            if (num > thresholds[thresholds.length - 1]) return thresholds[thresholds.length - 1].length - 1;
            var i = thresholds.indexOf(num);
            if (i === -1) return 0;
            // See https://unicode.org/reports/tr35/tr35-numbers.html#Compact_Number_Formats
            // Special handling if the pattern is precisely `0`.
            var magnitudeKey = thresholds[i];
            // TODO: do we need to handle plural here?
            var compactPattern = thresholdMap[magnitudeKey].other;
            if (compactPattern === "0") return 0;
            // Example: in zh-TW, `10000000` maps to `0000萬`. So we need to return 8 - 4 = 4 here.
            return magnitudeKey.length - thresholdMap[magnitudeKey].other.match(/0+/)[0].length;
    }
}
module.exports.ComputeExponentForMagnitude = $3f49776fafbc37e8$var$ComputeExponentForMagnitude;

});

parcelRegister("jUA1h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericToString = void 0;

var $ggNGK = parcelRequire("ggNGK");

var $hIGRw = parcelRequire("hIGRw");

var $kuWop = parcelRequire("kuWop");

var $iDQ56 = parcelRequire("iDQ56");
/**
 * https://tc39.es/ecma402/#sec-formatnumberstring
 */ function $e7ef300996563d16$var$FormatNumericToString(intlObject, x) {
    var isNegative = x < 0 || (0, $ggNGK.SameValue)(x, -0);
    if (isNegative) x = -x;
    var result;
    var rourndingType = intlObject.roundingType;
    switch(rourndingType){
        case "significantDigits":
            result = (0, $hIGRw.ToRawPrecision)(x, intlObject.minimumSignificantDigits, intlObject.maximumSignificantDigits);
            break;
        case "fractionDigits":
            result = (0, $iDQ56.ToRawFixed)(x, intlObject.minimumFractionDigits, intlObject.maximumFractionDigits);
            break;
        default:
            result = (0, $hIGRw.ToRawPrecision)(x, 1, 2);
            if (result.integerDigitsCount > 1) result = (0, $iDQ56.ToRawFixed)(x, 0, 0);
            break;
    }
    x = result.roundedNumber;
    var string = result.formattedString;
    var int = result.integerDigitsCount;
    var minInteger = intlObject.minimumIntegerDigits;
    if (int < minInteger) {
        var forwardZeros = (0, $kuWop.repeat)("0", minInteger - int);
        string = forwardZeros + string;
    }
    if (isNegative) x = -x;
    return {
        roundedNumber: x,
        formattedString: string
    };
}
module.exports.FormatNumericToString = $e7ef300996563d16$var$FormatNumericToString;

});
parcelRegister("hIGRw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ToRawPrecision = void 0;

var $kuWop = parcelRequire("kuWop");
function $ce67cb4a3d0d0861$var$ToRawPrecision(x, minPrecision, maxPrecision) {
    var p = maxPrecision;
    var m;
    var e;
    var xFinal;
    if (x === 0) {
        m = (0, $kuWop.repeat)("0", p);
        e = 0;
        xFinal = 0;
    } else {
        var xToString = x.toString();
        // If xToString is formatted as scientific notation, the number is either very small or very
        // large. If the precision of the formatted string is lower that requested max precision, we
        // should still infer them from the formatted string, otherwise the formatted result might have
        // precision loss (e.g. 1e41 will not have 0 in every trailing digits).
        var xToStringExponentIndex = xToString.indexOf("e");
        var _a = xToString.split("e"), xToStringMantissa = _a[0], xToStringExponent = _a[1];
        var xToStringMantissaWithoutDecimalPoint = xToStringMantissa.replace(".", "");
        if (xToStringExponentIndex >= 0 && xToStringMantissaWithoutDecimalPoint.length <= p) {
            e = +xToStringExponent;
            m = xToStringMantissaWithoutDecimalPoint + (0, $kuWop.repeat)("0", p - xToStringMantissaWithoutDecimalPoint.length);
            xFinal = x;
        } else {
            e = (0, $kuWop.getMagnitude)(x);
            var decimalPlaceOffset = e - p + 1;
            // n is the integer containing the required precision digits. To derive the formatted string,
            // we will adjust its decimal place in the logic below.
            var n = Math.round(adjustDecimalPlace(x, decimalPlaceOffset));
            // The rounding caused the change of magnitude, so we should increment `e` by 1.
            if (adjustDecimalPlace(n, p - 1) >= 10) {
                e = e + 1;
                // Divide n by 10 to swallow one precision.
                n = Math.floor(n / 10);
            }
            m = n.toString();
            // Equivalent of n * 10 ** (e - p + 1)
            xFinal = adjustDecimalPlace(n, p - 1 - e);
        }
    }
    var int;
    if (e >= p - 1) {
        m = m + (0, $kuWop.repeat)("0", e - p + 1);
        int = e + 1;
    } else if (e >= 0) {
        m = "".concat(m.slice(0, e + 1), ".").concat(m.slice(e + 1));
        int = e + 1;
    } else {
        m = "0.".concat((0, $kuWop.repeat)("0", -e - 1)).concat(m);
        int = 1;
    }
    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
        var cut = maxPrecision - minPrecision;
        while(cut > 0 && m[m.length - 1] === "0"){
            m = m.slice(0, -1);
            cut--;
        }
        if (m[m.length - 1] === ".") m = m.slice(0, -1);
    }
    return {
        formattedString: m,
        roundedNumber: xFinal,
        integerDigitsCount: int
    };
    // x / (10 ** magnitude), but try to preserve as much floating point precision as possible.
    function adjustDecimalPlace(x, magnitude) {
        return magnitude < 0 ? x * Math.pow(10, -magnitude) : x / Math.pow(10, magnitude);
    }
}
module.exports.ToRawPrecision = $ce67cb4a3d0d0861$var$ToRawPrecision;

});

parcelRegister("iDQ56", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ToRawFixed = void 0;

var $kuWop = parcelRequire("kuWop");
/**
 * TODO: dedup with intl-pluralrules and support BigInt
 * https://tc39.es/ecma402/#sec-torawfixed
 * @param x a finite non-negative Number or BigInt
 * @param minFraction and integer between 0 and 20
 * @param maxFraction and integer between 0 and 20
 */ function $d92444c9c2f647a3$var$ToRawFixed(x, minFraction, maxFraction) {
    var f = maxFraction;
    var n = Math.round(x * Math.pow(10, f));
    var xFinal = n / Math.pow(10, f);
    // n is a positive integer, but it is possible to be greater than 1e21.
    // In such case we will go the slow path.
    // See also: https://tc39.es/ecma262/#sec-numeric-types-number-tostring
    var m;
    if (n < 1e21) m = n.toString();
    else {
        m = n.toString();
        var _a = m.split("e"), mantissa = _a[0], exponent = _a[1];
        m = mantissa.replace(".", "");
        m = m + (0, $kuWop.repeat)("0", Math.max(+exponent - m.length + 1, 0));
    }
    var int;
    if (f !== 0) {
        var k = m.length;
        if (k <= f) {
            var z = (0, $kuWop.repeat)("0", f + 1 - k);
            m = z + m;
            k = f + 1;
        }
        var a = m.slice(0, k - f);
        var b = m.slice(k - f);
        m = "".concat(a, ".").concat(b);
        int = a.length;
    } else int = m.length;
    var cut = maxFraction - minFraction;
    while(cut > 0 && m[m.length - 1] === "0"){
        m = m.slice(0, -1);
        cut--;
    }
    if (m[m.length - 1] === ".") m = m.slice(0, -1);
    return {
        formattedString: m,
        roundedNumber: xFinal,
        integerDigitsCount: int
    };
}
module.exports.ToRawFixed = $d92444c9c2f647a3$var$ToRawFixed;

});



parcelRegister("ggmtP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CurrencyDigits = void 0;

var $ggNGK = parcelRequire("ggNGK");
/**
 * https://tc39.es/ecma402/#sec-currencydigits
 */ function $bd6f94076e018532$var$CurrencyDigits(c, _a) {
    var currencyDigitsData = _a.currencyDigitsData;
    return (0, $ggNGK.HasOwnProperty)(currencyDigitsData, c) ? currencyDigitsData[c] : 2;
}
module.exports.CurrencyDigits = $bd6f94076e018532$var$CurrencyDigits;

});

parcelRegister("gHt8R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatApproximately = void 0;
/**
 * https://tc39.es/ecma402/#sec-formatapproximately
 */ function $c287447596ce616b$var$FormatApproximately(numberFormat, result, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var symbols = internalSlots.dataLocaleData.numbers.symbols[internalSlots.numberingSystem];
    var approximatelySign = symbols.approximatelySign;
    result.push({
        type: "approximatelySign",
        value: approximatelySign
    });
    return result;
}
module.exports.FormatApproximately = $c287447596ce616b$var$FormatApproximately;

});

parcelRegister("cT5Nn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericRange = void 0;

var $fvnKm = parcelRequire("fvnKm");
/**
 * https://tc39.es/ecma402/#sec-formatnumericrange
 */ function $961f1df31357891f$var$FormatNumericRange(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var parts = (0, $fvnKm.PartitionNumberRangePattern)(numberFormat, x, y, {
        getInternalSlots: getInternalSlots
    });
    return parts.map(function(part) {
        return part.value;
    }).join("");
}
module.exports.FormatNumericRange = $961f1df31357891f$var$FormatNumericRange;

});
parcelRegister("fvnKm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PartitionNumberRangePattern = void 0;

var $js46X = parcelRequire("js46X");

var $7rHow = parcelRequire("7rHow");

var $gHt8R = parcelRequire("gHt8R");
/**
 * https://tc39.es/ecma402/#sec-partitionnumberrangepattern
 */ function $b49c2be0a92a3e41$var$PartitionNumberRangePattern(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    if (isNaN(x) || isNaN(y)) throw new RangeError("Input must be a number");
    var result = [];
    var xResult = (0, $js46X.PartitionNumberPattern)(numberFormat, x, {
        getInternalSlots: getInternalSlots
    });
    var yResult = (0, $js46X.PartitionNumberPattern)(numberFormat, y, {
        getInternalSlots: getInternalSlots
    });
    if (xResult === yResult) return (0, $gHt8R.FormatApproximately)(numberFormat, xResult, {
        getInternalSlots: getInternalSlots
    });
    for(var _i = 0, xResult_1 = xResult; _i < xResult_1.length; _i++){
        var r = xResult_1[_i];
        r.source = "startRange";
    }
    result = result.concat(xResult);
    var internalSlots = getInternalSlots(numberFormat);
    var symbols = internalSlots.dataLocaleData.numbers.symbols[internalSlots.numberingSystem];
    result.push({
        type: "literal",
        value: symbols.rangeSign,
        source: "shared"
    });
    for(var _b = 0, yResult_1 = yResult; _b < yResult_1.length; _b++){
        var r = yResult_1[_b];
        r.source = "endRange";
    }
    result = result.concat(yResult);
    return (0, $7rHow.CollapseNumberRange)(result);
}
module.exports.PartitionNumberRangePattern = $b49c2be0a92a3e41$var$PartitionNumberRangePattern;

});
parcelRegister("js46X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PartitionNumberPattern = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $jUA1h = parcelRequire("jUA1h");

var $ggNGK = parcelRequire("ggNGK");

var $hOgkO = parcelRequire("hOgkO");

var $e293d23e7a85b08c$var$format_to_parts_1 = $eIwgG.__importDefault((parcelRequire("aT7Sg")));
/**
 * https://tc39.es/ecma402/#sec-formatnumberstring
 */ function $e293d23e7a85b08c$var$PartitionNumberPattern(numberFormat, x, _a) {
    var _b;
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var pl = internalSlots.pl, dataLocaleData = internalSlots.dataLocaleData, numberingSystem = internalSlots.numberingSystem;
    var symbols = dataLocaleData.numbers.symbols[numberingSystem] || dataLocaleData.numbers.symbols[dataLocaleData.numbers.nu[0]];
    var magnitude = 0;
    var exponent = 0;
    var n;
    if (isNaN(x)) n = symbols.nan;
    else if (x == Number.POSITIVE_INFINITY || x == Number.NEGATIVE_INFINITY) n = symbols.infinity;
    else {
        if (!(0, $ggNGK.SameValue)(x, -0)) {
            if (!isFinite(x)) throw new Error("Input must be a mathematical value");
            if (internalSlots.style == "percent") x *= 100;
            _b = (0, $hOgkO.ComputeExponent)(numberFormat, x, {
                getInternalSlots: getInternalSlots
            }), exponent = _b[0], magnitude = _b[1];
            // Preserve more precision by doing multiplication when exponent is negative.
            x = exponent < 0 ? x * Math.pow(10, -exponent) : x / Math.pow(10, exponent);
        }
        var formatNumberResult = (0, $jUA1h.FormatNumericToString)(internalSlots, x);
        n = formatNumberResult.formattedString;
        x = formatNumberResult.roundedNumber;
    }
    // Based on https://tc39.es/ecma402/#sec-getnumberformatpattern
    // We need to do this before `x` is rounded.
    var sign;
    var signDisplay = internalSlots.signDisplay;
    switch(signDisplay){
        case "never":
            sign = 0;
            break;
        case "auto":
            if ((0, $ggNGK.SameValue)(x, 0) || x > 0 || isNaN(x)) sign = 0;
            else sign = -1;
            break;
        case "always":
            if ((0, $ggNGK.SameValue)(x, 0) || x > 0 || isNaN(x)) sign = 1;
            else sign = -1;
            break;
        default:
            // x === 0 -> x is 0 or x is -0
            if (x === 0 || isNaN(x)) sign = 0;
            else if (x > 0) sign = 1;
            else sign = -1;
    }
    return (0, $e293d23e7a85b08c$var$format_to_parts_1.default)({
        roundedNumber: x,
        formattedString: n,
        exponent: exponent,
        magnitude: magnitude,
        sign: sign
    }, internalSlots.dataLocaleData, pl, internalSlots);
}
module.exports.PartitionNumberPattern = $e293d23e7a85b08c$var$PartitionNumberPattern;

});
parcelRegister("aT7Sg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iDQ56 = parcelRequire("iDQ56");

var $keYhL = parcelRequire("keYhL");

var $f51T3 = parcelRequire("f51T3");
// This is from: unicode-12.1.0/General_Category/Symbol/regex.js
// IE11 does not support unicode flag, otherwise this is just /\p{S}/u.
// /^\p{S}/u
var $7ed526174254a1bf$var$CARET_S_UNICODE_REGEX = new RegExp("^".concat($f51T3.S_UNICODE_REGEX.source));
// /\p{S}$/u
var $7ed526174254a1bf$var$S_DOLLAR_UNICODE_REGEX = new RegExp("".concat($f51T3.S_UNICODE_REGEX.source, "$"));
var $7ed526174254a1bf$var$CLDR_NUMBER_PATTERN = /[#0](?:[\.,][#0]+)*/g;
function $7ed526174254a1bf$var$formatToParts(numberResult, data, pl, options) {
    var sign = numberResult.sign, exponent = numberResult.exponent, magnitude = numberResult.magnitude;
    var notation = options.notation, style = options.style, numberingSystem = options.numberingSystem;
    var defaultNumberingSystem = data.numbers.nu[0];
    // #region Part 1: partition and interpolate the CLDR number pattern.
    // ----------------------------------------------------------
    var compactNumberPattern = null;
    if (notation === "compact" && magnitude) compactNumberPattern = $7ed526174254a1bf$var$getCompactDisplayPattern(numberResult, pl, data, style, options.compactDisplay, options.currencyDisplay, numberingSystem);
    // This is used multiple times
    var nonNameCurrencyPart;
    if (style === "currency" && options.currencyDisplay !== "name") {
        var byCurrencyDisplay = data.currencies[options.currency];
        if (byCurrencyDisplay) switch(options.currencyDisplay){
            case "code":
                nonNameCurrencyPart = options.currency;
                break;
            case "symbol":
                nonNameCurrencyPart = byCurrencyDisplay.symbol;
                break;
            default:
                nonNameCurrencyPart = byCurrencyDisplay.narrow;
                break;
        }
        else // Fallback for unknown currency
        nonNameCurrencyPart = options.currency;
    }
    var numberPattern;
    if (!compactNumberPattern) {
        // Note: if the style is unit, or is currency and the currency display is name,
        // its unit parts will be interpolated in part 2. So here we can fallback to decimal.
        if (style === "decimal" || style === "unit" || style === "currency" && options.currencyDisplay === "name") {
            // Shortcut for decimal
            var decimalData = data.numbers.decimal[numberingSystem] || data.numbers.decimal[defaultNumberingSystem];
            numberPattern = $7ed526174254a1bf$var$getPatternForSign(decimalData.standard, sign);
        } else if (style === "currency") {
            var currencyData = data.numbers.currency[numberingSystem] || data.numbers.currency[defaultNumberingSystem];
            // We replace number pattern part with `0` for easier postprocessing.
            numberPattern = $7ed526174254a1bf$var$getPatternForSign(currencyData[options.currencySign], sign);
        } else {
            // percent
            var percentPattern = data.numbers.percent[numberingSystem] || data.numbers.percent[defaultNumberingSystem];
            numberPattern = $7ed526174254a1bf$var$getPatternForSign(percentPattern, sign);
        }
    } else numberPattern = compactNumberPattern;
    // Extract the decimal number pattern string. It looks like "#,##0,00", which will later be
    // used to infer decimal group sizes.
    var decimalNumberPattern = $7ed526174254a1bf$var$CLDR_NUMBER_PATTERN.exec(numberPattern)[0];
    // Now we start to substitute patterns
    // 1. replace strings like `0` and `#,##0.00` with `{0}`
    // 2. unquote characters (invariant: the quoted characters does not contain the special tokens)
    numberPattern = numberPattern.replace($7ed526174254a1bf$var$CLDR_NUMBER_PATTERN, "{0}").replace(/'(.)'/g, "$1");
    // Handle currency spacing (both compact and non-compact).
    if (style === "currency" && options.currencyDisplay !== "name") {
        var currencyData = data.numbers.currency[numberingSystem] || data.numbers.currency[defaultNumberingSystem];
        // See `currencySpacing` substitution rule in TR-35.
        // Here we always assume the currencyMatch is "[:^S:]" and surroundingMatch is "[:digit:]".
        //
        // Example 1: for pattern "#,##0.00¤" with symbol "US$", we replace "¤" with the symbol,
        // but insert an extra non-break space before the symbol, because "[:^S:]" matches "U" in
        // "US$" and "[:digit:]" matches the latn numbering system digits.
        //
        // Example 2: for pattern "¤#,##0.00" with symbol "US$", there is no spacing between symbol
        // and number, because `$` does not match "[:^S:]".
        //
        // Implementation note: here we do the best effort to infer the insertion.
        // We also assume that `beforeInsertBetween` and `afterInsertBetween` will never be `;`.
        var afterCurrency = currencyData.currencySpacing.afterInsertBetween;
        if (afterCurrency && !$7ed526174254a1bf$var$S_DOLLAR_UNICODE_REGEX.test(nonNameCurrencyPart)) numberPattern = numberPattern.replace("\xa4{0}", "\xa4".concat(afterCurrency, "{0}"));
        var beforeCurrency = currencyData.currencySpacing.beforeInsertBetween;
        if (beforeCurrency && !$7ed526174254a1bf$var$CARET_S_UNICODE_REGEX.test(nonNameCurrencyPart)) numberPattern = numberPattern.replace("{0}\xa4", "{0}".concat(beforeCurrency, "\xa4"));
    }
    // The following tokens are special: `{0}`, `¤`, `%`, `-`, `+`, `{c:...}.
    var numberPatternParts = numberPattern.split(/({c:[^}]+}|\{0\}|[¤%\-\+])/g);
    var numberParts = [];
    var symbols = data.numbers.symbols[numberingSystem] || data.numbers.symbols[defaultNumberingSystem];
    for(var _i = 0, numberPatternParts_1 = numberPatternParts; _i < numberPatternParts_1.length; _i++){
        var part = numberPatternParts_1[_i];
        if (!part) continue;
        switch(part){
            case "{0}":
                // We only need to handle scientific and engineering notation here.
                numberParts.push.apply(numberParts, $7ed526174254a1bf$var$paritionNumberIntoParts(symbols, numberResult, notation, exponent, numberingSystem, // If compact number pattern exists, do not insert group separators.
                !compactNumberPattern && Boolean(options.useGrouping), decimalNumberPattern));
                break;
            case "-":
                numberParts.push({
                    type: "minusSign",
                    value: symbols.minusSign
                });
                break;
            case "+":
                numberParts.push({
                    type: "plusSign",
                    value: symbols.plusSign
                });
                break;
            case "%":
                numberParts.push({
                    type: "percentSign",
                    value: symbols.percentSign
                });
                break;
            case "\xa4":
                // Computed above when handling currency spacing.
                numberParts.push({
                    type: "currency",
                    value: nonNameCurrencyPart
                });
                break;
            default:
                if (/^\{c:/.test(part)) numberParts.push({
                    type: "compact",
                    value: part.substring(3, part.length - 1)
                });
                else // literal
                numberParts.push({
                    type: "literal",
                    value: part
                });
                break;
        }
    }
    // #endregion
    // #region Part 2: interpolate unit pattern if necessary.
    // ----------------------------------------------
    switch(style){
        case "currency":
            // `currencyDisplay: 'name'` has similar pattern handling as units.
            if (options.currencyDisplay === "name") {
                var unitPattern = (data.numbers.currency[numberingSystem] || data.numbers.currency[defaultNumberingSystem]).unitPattern;
                // Select plural
                var unitName = void 0;
                var currencyNameData = data.currencies[options.currency];
                if (currencyNameData) unitName = $7ed526174254a1bf$var$selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), currencyNameData.displayName);
                else // Fallback for unknown currency
                unitName = options.currency;
                // Do {0} and {1} substitution
                var unitPatternParts = unitPattern.split(/(\{[01]\})/g);
                var result = [];
                for(var _a = 0, unitPatternParts_1 = unitPatternParts; _a < unitPatternParts_1.length; _a++){
                    var part = unitPatternParts_1[_a];
                    switch(part){
                        case "{0}":
                            result.push.apply(result, numberParts);
                            break;
                        case "{1}":
                            result.push({
                                type: "currency",
                                value: unitName
                            });
                            break;
                        default:
                            if (part) result.push({
                                type: "literal",
                                value: part
                            });
                            break;
                    }
                }
                return result;
            } else return numberParts;
        case "unit":
            var unit = options.unit, unitDisplay = options.unitDisplay;
            var unitData = data.units.simple[unit];
            var unitPattern = void 0;
            if (unitData) // Simple unit pattern
            unitPattern = $7ed526174254a1bf$var$selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), data.units.simple[unit][unitDisplay]);
            else {
                // See: http://unicode.org/reports/tr35/tr35-general.html#perUnitPatterns
                // If cannot find unit in the simple pattern, it must be "per" compound pattern.
                // Implementation note: we are not following TR-35 here because we need to format to parts!
                var _b = unit.split("-per-"), numeratorUnit = _b[0], denominatorUnit = _b[1];
                unitData = data.units.simple[numeratorUnit];
                var numeratorUnitPattern = $7ed526174254a1bf$var$selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), data.units.simple[numeratorUnit][unitDisplay]);
                var perUnitPattern = data.units.simple[denominatorUnit].perUnit[unitDisplay];
                if (perUnitPattern) // perUnitPattern exists, combine it with numeratorUnitPattern
                unitPattern = perUnitPattern.replace("{0}", numeratorUnitPattern);
                else {
                    // get compoundUnit pattern (e.g. "{0} per {1}"), repalce {0} with numerator pattern and {1} with
                    // the denominator pattern in singular form.
                    var perPattern = data.units.compound.per[unitDisplay];
                    var denominatorPattern = $7ed526174254a1bf$var$selectPlural(pl, 1, data.units.simple[denominatorUnit][unitDisplay]);
                    unitPattern = unitPattern = perPattern.replace("{0}", numeratorUnitPattern).replace("{1}", denominatorPattern.replace("{0}", ""));
                }
            }
            var result = [];
            // We need spacing around "{0}" because they are not treated as "unit" parts, but "literal".
            for(var _c = 0, _d = unitPattern.split(/(\s*\{0\}\s*)/); _c < _d.length; _c++){
                var part = _d[_c];
                var interpolateMatch = /^(\s*)\{0\}(\s*)$/.exec(part);
                if (interpolateMatch) {
                    // Space before "{0}"
                    if (interpolateMatch[1]) result.push({
                        type: "literal",
                        value: interpolateMatch[1]
                    });
                    // "{0}" itself
                    result.push.apply(result, numberParts);
                    // Space after "{0}"
                    if (interpolateMatch[2]) result.push({
                        type: "literal",
                        value: interpolateMatch[2]
                    });
                } else if (part) result.push({
                    type: "unit",
                    value: part
                });
            }
            return result;
        default:
            return numberParts;
    }
// #endregion
}
module.exports.default = $7ed526174254a1bf$var$formatToParts;
// A subset of https://tc39.es/ecma402/#sec-partitionnotationsubpattern
// Plus the exponent parts handling.
function $7ed526174254a1bf$var$paritionNumberIntoParts(symbols, numberResult, notation, exponent, numberingSystem, useGrouping, /**
 * This is the decimal number pattern without signs or symbols.
 * It is used to infer the group size when `useGrouping` is true.
 *
 * A typical value looks like "#,##0.00" (primary group size is 3).
 * Some locales like Hindi has secondary group size of 2 (e.g. "#,##,##0.00").
 */ decimalNumberPattern) {
    var result = [];
    // eslint-disable-next-line prefer-const
    var n = numberResult.formattedString, x = numberResult.roundedNumber;
    if (isNaN(x)) return [
        {
            type: "nan",
            value: n
        }
    ];
    else if (!isFinite(x)) return [
        {
            type: "infinity",
            value: n
        }
    ];
    var digitReplacementTable = $keYhL.digitMapping[numberingSystem];
    if (digitReplacementTable) n = n.replace(/\d/g, function(digit) {
        return digitReplacementTable[+digit] || digit;
    });
    // TODO: Else use an implementation dependent algorithm to map n to the appropriate
    // representation of n in the given numbering system.
    var decimalSepIndex = n.indexOf(".");
    var integer;
    var fraction;
    if (decimalSepIndex > 0) {
        integer = n.slice(0, decimalSepIndex);
        fraction = n.slice(decimalSepIndex + 1);
    } else integer = n;
    // #region Grouping integer digits
    // The weird compact and x >= 10000 check is to ensure consistency with Node.js and Chrome.
    // Note that `de` does not have compact form for thousands, but Node.js does not insert grouping separator
    // unless the rounded number is greater than 10000:
    //   NumberFormat('de', {notation: 'compact', compactDisplay: 'short'}).format(1234) //=> "1234"
    //   NumberFormat('de').format(1234) //=> "1.234"
    if (useGrouping && (notation !== "compact" || x >= 10000)) {
        var groupSepSymbol = symbols.group;
        var groups = [];
        // > There may be two different grouping sizes: The primary grouping size used for the least
        // > significant integer group, and the secondary grouping size used for more significant groups.
        // > If a pattern contains multiple grouping separators, the interval between the last one and the
        // > end of the integer defines the primary grouping size, and the interval between the last two
        // > defines the secondary grouping size. All others are ignored.
        var integerNumberPattern = decimalNumberPattern.split(".")[0];
        var patternGroups = integerNumberPattern.split(",");
        var primaryGroupingSize = 3;
        var secondaryGroupingSize = 3;
        if (patternGroups.length > 1) primaryGroupingSize = patternGroups[patternGroups.length - 1].length;
        if (patternGroups.length > 2) secondaryGroupingSize = patternGroups[patternGroups.length - 2].length;
        var i = integer.length - primaryGroupingSize;
        if (i > 0) {
            // Slice the least significant integer group
            groups.push(integer.slice(i, i + primaryGroupingSize));
            // Then iteratively push the more signicant groups
            // TODO: handle surrogate pairs in some numbering system digits
            for(i -= secondaryGroupingSize; i > 0; i -= secondaryGroupingSize)groups.push(integer.slice(i, i + secondaryGroupingSize));
            groups.push(integer.slice(0, i + secondaryGroupingSize));
        } else groups.push(integer);
        while(groups.length > 0){
            var integerGroup = groups.pop();
            result.push({
                type: "integer",
                value: integerGroup
            });
            if (groups.length > 0) result.push({
                type: "group",
                value: groupSepSymbol
            });
        }
    } else result.push({
        type: "integer",
        value: integer
    });
    // #endregion
    if (fraction !== undefined) result.push({
        type: "decimal",
        value: symbols.decimal
    }, {
        type: "fraction",
        value: fraction
    });
    if ((notation === "scientific" || notation === "engineering") && isFinite(x)) {
        result.push({
            type: "exponentSeparator",
            value: symbols.exponential
        });
        if (exponent < 0) {
            result.push({
                type: "exponentMinusSign",
                value: symbols.minusSign
            });
            exponent = -exponent;
        }
        var exponentResult = (0, $iDQ56.ToRawFixed)(exponent, 0, 0);
        result.push({
            type: "exponentInteger",
            value: exponentResult.formattedString
        });
    }
    return result;
}
function $7ed526174254a1bf$var$getPatternForSign(pattern, sign) {
    if (pattern.indexOf(";") < 0) pattern = "".concat(pattern, ";-").concat(pattern);
    var _a = pattern.split(";"), zeroPattern = _a[0], negativePattern = _a[1];
    switch(sign){
        case 0:
            return zeroPattern;
        case -1:
            return negativePattern;
        default:
            return negativePattern.indexOf("-") >= 0 ? negativePattern.replace(/-/g, "+") : "+".concat(zeroPattern);
    }
}
// Find the CLDR pattern for compact notation based on the magnitude of data and style.
//
// Example return value: "¤ {c:laki}000;¤{c:laki} -0" (`sw` locale):
// - Notice the `{c:...}` token that wraps the compact literal.
// - The consecutive zeros are normalized to single zero to match CLDR_NUMBER_PATTERN.
//
// Returning null means the compact display pattern cannot be found.
function $7ed526174254a1bf$var$getCompactDisplayPattern(numberResult, pl, data, style, compactDisplay, currencyDisplay, numberingSystem) {
    var _a;
    var roundedNumber = numberResult.roundedNumber, sign = numberResult.sign, magnitude = numberResult.magnitude;
    var magnitudeKey = String(Math.pow(10, magnitude));
    var defaultNumberingSystem = data.numbers.nu[0];
    var pattern;
    if (style === "currency" && currencyDisplay !== "name") {
        var byNumberingSystem = data.numbers.currency;
        var currencyData = byNumberingSystem[numberingSystem] || byNumberingSystem[defaultNumberingSystem];
        // NOTE: compact notation ignores currencySign!
        var compactPluralRules = (_a = currencyData.short) === null || _a === void 0 ? void 0 : _a[magnitudeKey];
        if (!compactPluralRules) return null;
        pattern = $7ed526174254a1bf$var$selectPlural(pl, roundedNumber, compactPluralRules);
    } else {
        var byNumberingSystem = data.numbers.decimal;
        var byCompactDisplay = byNumberingSystem[numberingSystem] || byNumberingSystem[defaultNumberingSystem];
        var compactPlaralRule = byCompactDisplay[compactDisplay][magnitudeKey];
        if (!compactPlaralRule) return null;
        pattern = $7ed526174254a1bf$var$selectPlural(pl, roundedNumber, compactPlaralRule);
    }
    // See https://unicode.org/reports/tr35/tr35-numbers.html#Compact_Number_Formats
    // > If the value is precisely “0”, either explicit or defaulted, then the normal number format
    // > pattern for that sort of object is supplied.
    if (pattern === "0") return null;
    pattern = $7ed526174254a1bf$var$getPatternForSign(pattern, sign)// Extract compact literal from the pattern
    .replace(/([^\s;\-\+\d¤]+)/g, "{c:$1}")// We replace one or more zeros with a single zero so it matches `CLDR_NUMBER_PATTERN`.
    .replace(/0+/, "0");
    return pattern;
}
function $7ed526174254a1bf$var$selectPlural(pl, x, rules) {
    return rules[pl.select(x)] || rules.other;
}

});
parcelRegister("keYhL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.digitMapping = void 0;
module.exports.digitMapping = {
    "adlm": [
        "\uD83A\uDD50",
        "\uD83A\uDD51",
        "\uD83A\uDD52",
        "\uD83A\uDD53",
        "\uD83A\uDD54",
        "\uD83A\uDD55",
        "\uD83A\uDD56",
        "\uD83A\uDD57",
        "\uD83A\uDD58",
        "\uD83A\uDD59"
    ],
    "ahom": [
        "\uD805\uDF30",
        "\uD805\uDF31",
        "\uD805\uDF32",
        "\uD805\uDF33",
        "\uD805\uDF34",
        "\uD805\uDF35",
        "\uD805\uDF36",
        "\uD805\uDF37",
        "\uD805\uDF38",
        "\uD805\uDF39"
    ],
    "arab": [
        "\u0660",
        "\u0661",
        "\u0662",
        "\u0663",
        "\u0664",
        "\u0665",
        "\u0666",
        "\u0667",
        "\u0668",
        "\u0669"
    ],
    "arabext": [
        "\u06F0",
        "\u06F1",
        "\u06F2",
        "\u06F3",
        "\u06F4",
        "\u06F5",
        "\u06F6",
        "\u06F7",
        "\u06F8",
        "\u06F9"
    ],
    "bali": [
        "\u1B50",
        "\u1B51",
        "\u1B52",
        "\u1B53",
        "\u1B54",
        "\u1B55",
        "\u1B56",
        "\u1B57",
        "\u1B58",
        "\u1B59"
    ],
    "beng": [
        "\u09E6",
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA",
        "\u09EB",
        "\u09EC",
        "\u09ED",
        "\u09EE",
        "\u09EF"
    ],
    "bhks": [
        "\uD807\uDC50",
        "\uD807\uDC51",
        "\uD807\uDC52",
        "\uD807\uDC53",
        "\uD807\uDC54",
        "\uD807\uDC55",
        "\uD807\uDC56",
        "\uD807\uDC57",
        "\uD807\uDC58",
        "\uD807\uDC59"
    ],
    "brah": [
        "\uD804\uDC66",
        "\uD804\uDC67",
        "\uD804\uDC68",
        "\uD804\uDC69",
        "\uD804\uDC6A",
        "\uD804\uDC6B",
        "\uD804\uDC6C",
        "\uD804\uDC6D",
        "\uD804\uDC6E",
        "\uD804\uDC6F"
    ],
    "cakm": [
        "\uD804\uDD36",
        "\uD804\uDD37",
        "\uD804\uDD38",
        "\uD804\uDD39",
        "\uD804\uDD3A",
        "\uD804\uDD3B",
        "\uD804\uDD3C",
        "\uD804\uDD3D",
        "\uD804\uDD3E",
        "\uD804\uDD3F"
    ],
    "cham": [
        "\uAA50",
        "\uAA51",
        "\uAA52",
        "\uAA53",
        "\uAA54",
        "\uAA55",
        "\uAA56",
        "\uAA57",
        "\uAA58",
        "\uAA59"
    ],
    "deva": [
        "\u0966",
        "\u0967",
        "\u0968",
        "\u0969",
        "\u096A",
        "\u096B",
        "\u096C",
        "\u096D",
        "\u096E",
        "\u096F"
    ],
    "diak": [
        "\uD806\uDD50",
        "\uD806\uDD51",
        "\uD806\uDD52",
        "\uD806\uDD53",
        "\uD806\uDD54",
        "\uD806\uDD55",
        "\uD806\uDD56",
        "\uD806\uDD57",
        "\uD806\uDD58",
        "\uD806\uDD59"
    ],
    "fullwide": [
        "\uFF10",
        "\uFF11",
        "\uFF12",
        "\uFF13",
        "\uFF14",
        "\uFF15",
        "\uFF16",
        "\uFF17",
        "\uFF18",
        "\uFF19"
    ],
    "gong": [
        "\uD807\uDDA0",
        "\uD807\uDDA1",
        "\uD807\uDDA2",
        "\uD807\uDDA3",
        "\uD807\uDDA4",
        "\uD807\uDDA5",
        "\uD807\uDDA6",
        "\uD807\uDDA7",
        "\uD807\uDDA8",
        "\uD807\uDDA9"
    ],
    "gonm": [
        "\uD807\uDD50",
        "\uD807\uDD51",
        "\uD807\uDD52",
        "\uD807\uDD53",
        "\uD807\uDD54",
        "\uD807\uDD55",
        "\uD807\uDD56",
        "\uD807\uDD57",
        "\uD807\uDD58",
        "\uD807\uDD59"
    ],
    "gujr": [
        "\u0AE6",
        "\u0AE7",
        "\u0AE8",
        "\u0AE9",
        "\u0AEA",
        "\u0AEB",
        "\u0AEC",
        "\u0AED",
        "\u0AEE",
        "\u0AEF"
    ],
    "guru": [
        "\u0A66",
        "\u0A67",
        "\u0A68",
        "\u0A69",
        "\u0A6A",
        "\u0A6B",
        "\u0A6C",
        "\u0A6D",
        "\u0A6E",
        "\u0A6F"
    ],
    "hanidec": [
        "\u3007",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D"
    ],
    "hmng": [
        "\uD81A\uDF50",
        "\uD81A\uDF51",
        "\uD81A\uDF52",
        "\uD81A\uDF53",
        "\uD81A\uDF54",
        "\uD81A\uDF55",
        "\uD81A\uDF56",
        "\uD81A\uDF57",
        "\uD81A\uDF58",
        "\uD81A\uDF59"
    ],
    "hmnp": [
        "\uD838\uDD40",
        "\uD838\uDD41",
        "\uD838\uDD42",
        "\uD838\uDD43",
        "\uD838\uDD44",
        "\uD838\uDD45",
        "\uD838\uDD46",
        "\uD838\uDD47",
        "\uD838\uDD48",
        "\uD838\uDD49"
    ],
    "java": [
        "\uA9D0",
        "\uA9D1",
        "\uA9D2",
        "\uA9D3",
        "\uA9D4",
        "\uA9D5",
        "\uA9D6",
        "\uA9D7",
        "\uA9D8",
        "\uA9D9"
    ],
    "kali": [
        "\uA900",
        "\uA901",
        "\uA902",
        "\uA903",
        "\uA904",
        "\uA905",
        "\uA906",
        "\uA907",
        "\uA908",
        "\uA909"
    ],
    "khmr": [
        "\u17E0",
        "\u17E1",
        "\u17E2",
        "\u17E3",
        "\u17E4",
        "\u17E5",
        "\u17E6",
        "\u17E7",
        "\u17E8",
        "\u17E9"
    ],
    "knda": [
        "\u0CE6",
        "\u0CE7",
        "\u0CE8",
        "\u0CE9",
        "\u0CEA",
        "\u0CEB",
        "\u0CEC",
        "\u0CED",
        "\u0CEE",
        "\u0CEF"
    ],
    "lana": [
        "\u1A80",
        "\u1A81",
        "\u1A82",
        "\u1A83",
        "\u1A84",
        "\u1A85",
        "\u1A86",
        "\u1A87",
        "\u1A88",
        "\u1A89"
    ],
    "lanatham": [
        "\u1A90",
        "\u1A91",
        "\u1A92",
        "\u1A93",
        "\u1A94",
        "\u1A95",
        "\u1A96",
        "\u1A97",
        "\u1A98",
        "\u1A99"
    ],
    "laoo": [
        "\u0ED0",
        "\u0ED1",
        "\u0ED2",
        "\u0ED3",
        "\u0ED4",
        "\u0ED5",
        "\u0ED6",
        "\u0ED7",
        "\u0ED8",
        "\u0ED9"
    ],
    "lepc": [
        "\u1A90",
        "\u1A91",
        "\u1A92",
        "\u1A93",
        "\u1A94",
        "\u1A95",
        "\u1A96",
        "\u1A97",
        "\u1A98",
        "\u1A99"
    ],
    "limb": [
        "\u1946",
        "\u1947",
        "\u1948",
        "\u1949",
        "\u194A",
        "\u194B",
        "\u194C",
        "\u194D",
        "\u194E",
        "\u194F"
    ],
    "mathbold": [
        "\uD835\uDFCE",
        "\uD835\uDFCF",
        "\uD835\uDFD0",
        "\uD835\uDFD1",
        "\uD835\uDFD2",
        "\uD835\uDFD3",
        "\uD835\uDFD4",
        "\uD835\uDFD5",
        "\uD835\uDFD6",
        "\uD835\uDFD7"
    ],
    "mathdbl": [
        "\uD835\uDFD8",
        "\uD835\uDFD9",
        "\uD835\uDFDA",
        "\uD835\uDFDB",
        "\uD835\uDFDC",
        "\uD835\uDFDD",
        "\uD835\uDFDE",
        "\uD835\uDFDF",
        "\uD835\uDFE0",
        "\uD835\uDFE1"
    ],
    "mathmono": [
        "\uD835\uDFF6",
        "\uD835\uDFF7",
        "\uD835\uDFF8",
        "\uD835\uDFF9",
        "\uD835\uDFFA",
        "\uD835\uDFFB",
        "\uD835\uDFFC",
        "\uD835\uDFFD",
        "\uD835\uDFFE",
        "\uD835\uDFFF"
    ],
    "mathsanb": [
        "\uD835\uDFEC",
        "\uD835\uDFED",
        "\uD835\uDFEE",
        "\uD835\uDFEF",
        "\uD835\uDFF0",
        "\uD835\uDFF1",
        "\uD835\uDFF2",
        "\uD835\uDFF3",
        "\uD835\uDFF4",
        "\uD835\uDFF5"
    ],
    "mathsans": [
        "\uD835\uDFE2",
        "\uD835\uDFE3",
        "\uD835\uDFE4",
        "\uD835\uDFE5",
        "\uD835\uDFE6",
        "\uD835\uDFE7",
        "\uD835\uDFE8",
        "\uD835\uDFE9",
        "\uD835\uDFEA",
        "\uD835\uDFEB"
    ],
    "mlym": [
        "\u0D66",
        "\u0D67",
        "\u0D68",
        "\u0D69",
        "\u0D6A",
        "\u0D6B",
        "\u0D6C",
        "\u0D6D",
        "\u0D6E",
        "\u0D6F"
    ],
    "modi": [
        "\uD805\uDE50",
        "\uD805\uDE51",
        "\uD805\uDE52",
        "\uD805\uDE53",
        "\uD805\uDE54",
        "\uD805\uDE55",
        "\uD805\uDE56",
        "\uD805\uDE57",
        "\uD805\uDE58",
        "\uD805\uDE59"
    ],
    "mong": [
        "\u1810",
        "\u1811",
        "\u1812",
        "\u1813",
        "\u1814",
        "\u1815",
        "\u1816",
        "\u1817",
        "\u1818",
        "\u1819"
    ],
    "mroo": [
        "\uD81A\uDE60",
        "\uD81A\uDE61",
        "\uD81A\uDE62",
        "\uD81A\uDE63",
        "\uD81A\uDE64",
        "\uD81A\uDE65",
        "\uD81A\uDE66",
        "\uD81A\uDE67",
        "\uD81A\uDE68",
        "\uD81A\uDE69"
    ],
    "mtei": [
        "\uABF0",
        "\uABF1",
        "\uABF2",
        "\uABF3",
        "\uABF4",
        "\uABF5",
        "\uABF6",
        "\uABF7",
        "\uABF8",
        "\uABF9"
    ],
    "mymr": [
        "\u1040",
        "\u1041",
        "\u1042",
        "\u1043",
        "\u1044",
        "\u1045",
        "\u1046",
        "\u1047",
        "\u1048",
        "\u1049"
    ],
    "mymrshan": [
        "\u1090",
        "\u1091",
        "\u1092",
        "\u1093",
        "\u1094",
        "\u1095",
        "\u1096",
        "\u1097",
        "\u1098",
        "\u1099"
    ],
    "mymrtlng": [
        "\uA9F0",
        "\uA9F1",
        "\uA9F2",
        "\uA9F3",
        "\uA9F4",
        "\uA9F5",
        "\uA9F6",
        "\uA9F7",
        "\uA9F8",
        "\uA9F9"
    ],
    "newa": [
        "\uD805\uDC50",
        "\uD805\uDC51",
        "\uD805\uDC52",
        "\uD805\uDC53",
        "\uD805\uDC54",
        "\uD805\uDC55",
        "\uD805\uDC56",
        "\uD805\uDC57",
        "\uD805\uDC58",
        "\uD805\uDC59"
    ],
    "nkoo": [
        "\u07C0",
        "\u07C1",
        "\u07C2",
        "\u07C3",
        "\u07C4",
        "\u07C5",
        "\u07C6",
        "\u07C7",
        "\u07C8",
        "\u07C9"
    ],
    "olck": [
        "\u1C50",
        "\u1C51",
        "\u1C52",
        "\u1C53",
        "\u1C54",
        "\u1C55",
        "\u1C56",
        "\u1C57",
        "\u1C58",
        "\u1C59"
    ],
    "orya": [
        "\u0B66",
        "\u0B67",
        "\u0B68",
        "\u0B69",
        "\u0B6A",
        "\u0B6B",
        "\u0B6C",
        "\u0B6D",
        "\u0B6E",
        "\u0B6F"
    ],
    "osma": [
        "\uD801\uDCA0",
        "\uD801\uDCA1",
        "\uD801\uDCA2",
        "\uD801\uDCA3",
        "\uD801\uDCA4",
        "\uD801\uDCA5",
        "\uD801\uDCA6",
        "\uD801\uDCA7",
        "\uD801\uDCA8",
        "\uD801\uDCA9"
    ],
    "rohg": [
        "\uD803\uDD30",
        "\uD803\uDD31",
        "\uD803\uDD32",
        "\uD803\uDD33",
        "\uD803\uDD34",
        "\uD803\uDD35",
        "\uD803\uDD36",
        "\uD803\uDD37",
        "\uD803\uDD38",
        "\uD803\uDD39"
    ],
    "saur": [
        "\uA8D0",
        "\uA8D1",
        "\uA8D2",
        "\uA8D3",
        "\uA8D4",
        "\uA8D5",
        "\uA8D6",
        "\uA8D7",
        "\uA8D8",
        "\uA8D9"
    ],
    "segment": [
        "\uD83E\uDFF0",
        "\uD83E\uDFF1",
        "\uD83E\uDFF2",
        "\uD83E\uDFF3",
        "\uD83E\uDFF4",
        "\uD83E\uDFF5",
        "\uD83E\uDFF6",
        "\uD83E\uDFF7",
        "\uD83E\uDFF8",
        "\uD83E\uDFF9"
    ],
    "shrd": [
        "\uD804\uDDD0",
        "\uD804\uDDD1",
        "\uD804\uDDD2",
        "\uD804\uDDD3",
        "\uD804\uDDD4",
        "\uD804\uDDD5",
        "\uD804\uDDD6",
        "\uD804\uDDD7",
        "\uD804\uDDD8",
        "\uD804\uDDD9"
    ],
    "sind": [
        "\uD804\uDEF0",
        "\uD804\uDEF1",
        "\uD804\uDEF2",
        "\uD804\uDEF3",
        "\uD804\uDEF4",
        "\uD804\uDEF5",
        "\uD804\uDEF6",
        "\uD804\uDEF7",
        "\uD804\uDEF8",
        "\uD804\uDEF9"
    ],
    "sinh": [
        "\u0DE6",
        "\u0DE7",
        "\u0DE8",
        "\u0DE9",
        "\u0DEA",
        "\u0DEB",
        "\u0DEC",
        "\u0DED",
        "\u0DEE",
        "\u0DEF"
    ],
    "sora": [
        "\uD804\uDCF0",
        "\uD804\uDCF1",
        "\uD804\uDCF2",
        "\uD804\uDCF3",
        "\uD804\uDCF4",
        "\uD804\uDCF5",
        "\uD804\uDCF6",
        "\uD804\uDCF7",
        "\uD804\uDCF8",
        "\uD804\uDCF9"
    ],
    "sund": [
        "\u1BB0",
        "\u1BB1",
        "\u1BB2",
        "\u1BB3",
        "\u1BB4",
        "\u1BB5",
        "\u1BB6",
        "\u1BB7",
        "\u1BB8",
        "\u1BB9"
    ],
    "takr": [
        "\uD805\uDEC0",
        "\uD805\uDEC1",
        "\uD805\uDEC2",
        "\uD805\uDEC3",
        "\uD805\uDEC4",
        "\uD805\uDEC5",
        "\uD805\uDEC6",
        "\uD805\uDEC7",
        "\uD805\uDEC8",
        "\uD805\uDEC9"
    ],
    "talu": [
        "\u19D0",
        "\u19D1",
        "\u19D2",
        "\u19D3",
        "\u19D4",
        "\u19D5",
        "\u19D6",
        "\u19D7",
        "\u19D8",
        "\u19D9"
    ],
    "tamldec": [
        "\u0BE6",
        "\u0BE7",
        "\u0BE8",
        "\u0BE9",
        "\u0BEA",
        "\u0BEB",
        "\u0BEC",
        "\u0BED",
        "\u0BEE",
        "\u0BEF"
    ],
    "telu": [
        "\u0C66",
        "\u0C67",
        "\u0C68",
        "\u0C69",
        "\u0C6A",
        "\u0C6B",
        "\u0C6C",
        "\u0C6D",
        "\u0C6E",
        "\u0C6F"
    ],
    "thai": [
        "\u0E50",
        "\u0E51",
        "\u0E52",
        "\u0E53",
        "\u0E54",
        "\u0E55",
        "\u0E56",
        "\u0E57",
        "\u0E58",
        "\u0E59"
    ],
    "tibt": [
        "\u0F20",
        "\u0F21",
        "\u0F22",
        "\u0F23",
        "\u0F24",
        "\u0F25",
        "\u0F26",
        "\u0F27",
        "\u0F28",
        "\u0F29"
    ],
    "tirh": [
        "\uD805\uDCD0",
        "\uD805\uDCD1",
        "\uD805\uDCD2",
        "\uD805\uDCD3",
        "\uD805\uDCD4",
        "\uD805\uDCD5",
        "\uD805\uDCD6",
        "\uD805\uDCD7",
        "\uD805\uDCD8",
        "\uD805\uDCD9"
    ],
    "vaii": [
        "\u1620",
        "\u1621",
        "\u1622",
        "\u1623",
        "\u1624",
        "\u1625",
        "\u1626",
        "\u1627",
        "\u1628",
        "\u1629"
    ],
    "wara": [
        "\uD806\uDCE0",
        "\uD806\uDCE1",
        "\uD806\uDCE2",
        "\uD806\uDCE3",
        "\uD806\uDCE4",
        "\uD806\uDCE5",
        "\uD806\uDCE6",
        "\uD806\uDCE7",
        "\uD806\uDCE8",
        "\uD806\uDCE9"
    ],
    "wcho": [
        "\uD838\uDEF0",
        "\uD838\uDEF1",
        "\uD838\uDEF2",
        "\uD838\uDEF3",
        "\uD838\uDEF4",
        "\uD838\uDEF5",
        "\uD838\uDEF6",
        "\uD838\uDEF7",
        "\uD838\uDEF8",
        "\uD838\uDEF9"
    ]
};

});

parcelRegister("f51T3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.S_UNICODE_REGEX = void 0;
// @generated from regex-gen.ts
module.exports.S_UNICODE_REGEX = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEE0-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDD78\uDD7A-\uDDCB\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6\uDF00-\uDF92\uDF94-\uDFCA]/;

});





parcelRegister("krb5m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericRangeToParts = void 0;

var $fvnKm = parcelRequire("fvnKm");
/**
 * https://tc39.es/ecma402/#sec-formatnumericrangetoparts
 */ function $ee0eed9fe09917f5$var$FormatNumericRangeToParts(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var parts = (0, $fvnKm.PartitionNumberRangePattern)(numberFormat, x, y, {
        getInternalSlots: getInternalSlots
    });
    return parts.map(function(part, index) {
        return {
            type: part.type,
            value: part.value,
            source: part.source,
            result: index.toString()
        };
    });
}
module.exports.FormatNumericRangeToParts = $ee0eed9fe09917f5$var$FormatNumericRangeToParts;

});

parcelRegister("jmqIJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericToParts = void 0;

var $js46X = parcelRequire("js46X");

var $ggNGK = parcelRequire("ggNGK");
function $e184cc8c1ce924b2$var$FormatNumericToParts(nf, x, implDetails) {
    var parts = (0, $js46X.PartitionNumberPattern)(nf, x, implDetails);
    var result = (0, $ggNGK.ArrayCreate)(0);
    for(var _i = 0, parts_1 = parts; _i < parts_1.length; _i++){
        var part = parts_1[_i];
        result.push({
            type: part.type,
            value: part.value
        });
    }
    return result;
}
module.exports.FormatNumericToParts = $e184cc8c1ce924b2$var$FormatNumericToParts;

});

parcelRegister("gNPgY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetUnsignedRoundingMode = void 0;
var $c3b8fea0d405341a$var$negativeMapping = {
    ceil: "zero",
    floor: "infinity",
    expand: "infinity",
    trunc: "zero",
    halfCeil: "half-zero",
    halfFloor: "half-infinity",
    halfExpand: "half-infinity",
    halfTrunc: "half-zero",
    halfEven: "half-even"
};
var $c3b8fea0d405341a$var$positiveMapping = {
    ceil: "infinity",
    floor: "zero",
    expand: "infinity",
    trunc: "zero",
    halfCeil: "half-infinity",
    halfFloor: "half-zero",
    halfExpand: "half-infinity",
    halfTrunc: "half-zero",
    halfEven: "half-even"
};
function $c3b8fea0d405341a$var$GetUnsignedRoundingMode(roundingMode, isNegative) {
    if (isNegative) return $c3b8fea0d405341a$var$negativeMapping[roundingMode];
    return $c3b8fea0d405341a$var$positiveMapping[roundingMode];
}
module.exports.GetUnsignedRoundingMode = $c3b8fea0d405341a$var$GetUnsignedRoundingMode;

});

parcelRegister("2Yiy5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InitializeNumberFormat = void 0;

var $8IhHp = parcelRequire("8IhHp");

var $51U6O = parcelRequire("51U6O");

var $eo8HH = parcelRequire("eo8HH");

var $hoLlz = parcelRequire("hoLlz");

var $1LY2e = parcelRequire("1LY2e");

var $gH4FO = parcelRequire("gH4FO");

var $kuWop = parcelRequire("kuWop");

var $ggmtP = parcelRequire("ggmtP");

var $5do86 = parcelRequire("5do86");

var $clykw = parcelRequire("clykw");
var $229f92c94cdc35fc$var$VALID_ROUND_INCREMENT_VALUES = [
    1,
    2,
    5,
    10,
    20,
    25,
    50,
    100,
    200,
    250,
    500,
    1000,
    2000
];
/**
 * https://tc39.es/ecma402/#sec-initializenumberformat
 */ function $229f92c94cdc35fc$var$InitializeNumberFormat(nf, locales, opts, _a) {
    var getInternalSlots = _a.getInternalSlots, localeData = _a.localeData, availableLocales = _a.availableLocales, numberingSystemNames = _a.numberingSystemNames, getDefaultLocale = _a.getDefaultLocale, currencyDigitsData = _a.currencyDigitsData;
    // @ts-ignore
    var requestedLocales = (0, $51U6O.CanonicalizeLocaleList)(locales);
    var options = (0, $eo8HH.CoerceOptionsToObject)(opts);
    var opt = Object.create(null);
    var matcher = (0, $1LY2e.GetOption)(options, "localeMatcher", "string", [
        "lookup",
        "best fit"
    ], "best fit");
    opt.localeMatcher = matcher;
    var numberingSystem = (0, $1LY2e.GetOption)(options, "numberingSystem", "string", undefined, undefined);
    if (numberingSystem !== undefined && numberingSystemNames.indexOf(numberingSystem) < 0) // 8.a. If numberingSystem does not match the Unicode Locale Identifier type nonterminal,
    // throw a RangeError exception.
    throw RangeError("Invalid numberingSystems: ".concat(numberingSystem));
    opt.nu = numberingSystem;
    var r = (0, $8IhHp.ResolveLocale)(Array.from(availableLocales), requestedLocales, opt, // [[RelevantExtensionKeys]] slot, which is a constant
    [
        "nu"
    ], localeData, getDefaultLocale);
    var dataLocaleData = localeData[r.dataLocale];
    (0, $kuWop.invariant)(!!dataLocaleData, "Missing locale data for ".concat(r.dataLocale));
    var internalSlots = getInternalSlots(nf);
    internalSlots.locale = r.locale;
    internalSlots.dataLocale = r.dataLocale;
    internalSlots.numberingSystem = r.nu;
    internalSlots.dataLocaleData = dataLocaleData;
    (0, $clykw.SetNumberFormatUnitOptions)(nf, options, {
        getInternalSlots: getInternalSlots
    });
    var style = internalSlots.style;
    var mnfdDefault;
    var mxfdDefault;
    if (style === "currency") {
        var currency = internalSlots.currency;
        var cDigits = (0, $ggmtP.CurrencyDigits)(currency, {
            currencyDigitsData: currencyDigitsData
        });
        mnfdDefault = cDigits;
        mxfdDefault = cDigits;
    } else {
        mnfdDefault = 0;
        mxfdDefault = style === "percent" ? 0 : 3;
    }
    var notation = (0, $1LY2e.GetOption)(options, "notation", "string", [
        "standard",
        "scientific",
        "engineering",
        "compact"
    ], "standard");
    internalSlots.notation = notation;
    (0, $5do86.SetNumberFormatDigitOptions)(internalSlots, options, mnfdDefault, mxfdDefault, notation);
    var roundingIncrement = (0, $hoLlz.GetNumberOption)(options, "roundingIncrement", 1, 5000, 1);
    if ($229f92c94cdc35fc$var$VALID_ROUND_INCREMENT_VALUES.indexOf(roundingIncrement) === -1) throw new RangeError("Invalid rounding increment value: ".concat(roundingIncrement, ".\nValid values are ").concat($229f92c94cdc35fc$var$VALID_ROUND_INCREMENT_VALUES, "."));
    if (roundingIncrement !== 1 && internalSlots.roundingType !== "fractionDigits") throw new TypeError("For roundingIncrement > 1 only fractionDigits is a valid roundingType");
    if (roundingIncrement !== 1 && internalSlots.maximumFractionDigits !== internalSlots.minimumFractionDigits) throw new RangeError("With roundingIncrement > 1, maximumFractionDigits and minimumFractionDigits must be equal.");
    internalSlots.roundingIncrement = roundingIncrement;
    var trailingZeroDisplay = (0, $1LY2e.GetOption)(options, "trailingZeroDisplay", "string", [
        "auto",
        "stripIfInteger"
    ], "auto");
    internalSlots.trailingZeroDisplay = trailingZeroDisplay;
    var compactDisplay = (0, $1LY2e.GetOption)(options, "compactDisplay", "string", [
        "short",
        "long"
    ], "short");
    var defaultUseGrouping = "auto";
    if (notation === "compact") {
        internalSlots.compactDisplay = compactDisplay;
        defaultUseGrouping = "min2";
    }
    internalSlots.useGrouping = (0, $gH4FO.GetStringOrBooleanOption)(options, "useGrouping", [
        "min2",
        "auto",
        "always"
    ], "always", false, defaultUseGrouping);
    internalSlots.signDisplay = (0, $1LY2e.GetOption)(options, "signDisplay", "string", [
        "auto",
        "never",
        "always",
        "exceptZero",
        "negative"
    ], "auto");
    internalSlots.roundingMode = (0, $1LY2e.GetOption)(options, "roundingMode", "string", [
        "ceil",
        "floor",
        "expand",
        "trunc",
        "halfCeil",
        "halfFloor",
        "halfExpand",
        "halfTrunc",
        "halfEven"
    ], "halfExpand");
    return nf;
}
module.exports.InitializeNumberFormat = $229f92c94cdc35fc$var$InitializeNumberFormat;

});
parcelRegister("8IhHp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResolveLocale = module.exports.LookupSupportedLocales = module.exports.match = void 0;

var $4UdlU = parcelRequire("4UdlU");

var $cSEXV = parcelRequire("cSEXV");
function $658029734804dee0$var$match(requestedLocales, availableLocales, defaultLocale, opts) {
    return (0, $cSEXV.ResolveLocale)(availableLocales, (0, $4UdlU.CanonicalizeLocaleList)(requestedLocales), {
        localeMatcher: (opts === null || opts === void 0 ? void 0 : opts.algorithm) || "best fit"
    }, [], {}, function() {
        return defaultLocale;
    }).locale;
}
module.exports.match = $658029734804dee0$var$match;

var $dJNoW = parcelRequire("dJNoW");
Object.defineProperty(module.exports, "LookupSupportedLocales", {
    enumerable: true,
    get: function() {
        return $dJNoW.LookupSupportedLocales;
    }
});

var $cSEXV = parcelRequire("cSEXV");
Object.defineProperty(module.exports, "ResolveLocale", {
    enumerable: true,
    get: function() {
        return $cSEXV.ResolveLocale;
    }
});

});
parcelRegister("4UdlU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CanonicalizeLocaleList = void 0;
/**
 * http://ecma-international.org/ecma-402/7.0/index.html#sec-canonicalizelocalelist
 * @param locales
 */ function $3926bfe801e855e2$var$CanonicalizeLocaleList(locales) {
    // TODO
    return Intl.getCanonicalLocales(locales);
}
module.exports.CanonicalizeLocaleList = $3926bfe801e855e2$var$CanonicalizeLocaleList;

});

parcelRegister("cSEXV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResolveLocale = void 0;

var $eaYZN = parcelRequire("eaYZN");

var $aBlOT = parcelRequire("aBlOT");

var $eXYWp = parcelRequire("eXYWp");

var $k68wz = parcelRequire("k68wz");
/**
 * https://tc39.es/ecma402/#sec-resolvelocale
 */ function $960a4e0ee795e1e7$var$ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData, getDefaultLocale) {
    var matcher = options.localeMatcher;
    var r;
    if (matcher === "lookup") r = (0, $aBlOT.LookupMatcher)(Array.from(availableLocales), requestedLocales, getDefaultLocale);
    else r = (0, $eaYZN.BestFitMatcher)(Array.from(availableLocales), requestedLocales, getDefaultLocale);
    var foundLocale = r.locale;
    var result = {
        locale: "",
        dataLocale: foundLocale
    };
    var supportedExtension = "-u";
    for(var _i = 0, relevantExtensionKeys_1 = relevantExtensionKeys; _i < relevantExtensionKeys_1.length; _i++){
        var key = relevantExtensionKeys_1[_i];
        (0, $k68wz.invariant)(foundLocale in localeData, "Missing locale data for ".concat(foundLocale));
        var foundLocaleData = localeData[foundLocale];
        (0, $k68wz.invariant)(typeof foundLocaleData === "object" && foundLocaleData !== null, "locale data ".concat(key, " must be an object"));
        var keyLocaleData = foundLocaleData[key];
        (0, $k68wz.invariant)(Array.isArray(keyLocaleData), "keyLocaleData for ".concat(key, " must be an array"));
        var value = keyLocaleData[0];
        (0, $k68wz.invariant)(typeof value === "string" || value === null, "value must be string or null but got ".concat(typeof value, " in key ").concat(key));
        var supportedExtensionAddition = "";
        if (r.extension) {
            var requestedValue = (0, $eXYWp.UnicodeExtensionValue)(r.extension, key);
            if (requestedValue !== undefined) {
                if (requestedValue !== "") {
                    if (~keyLocaleData.indexOf(requestedValue)) {
                        value = requestedValue;
                        supportedExtensionAddition = "-".concat(key, "-").concat(value);
                    }
                } else if (~requestedValue.indexOf("true")) {
                    value = "true";
                    supportedExtensionAddition = "-".concat(key);
                }
            }
        }
        if (key in options) {
            var optionsValue = options[key];
            (0, $k68wz.invariant)(typeof optionsValue === "string" || typeof optionsValue === "undefined" || optionsValue === null, "optionsValue must be String, Undefined or Null");
            if (~keyLocaleData.indexOf(optionsValue)) {
                if (optionsValue !== value) {
                    value = optionsValue;
                    supportedExtensionAddition = "";
                }
            }
        }
        result[key] = value;
        supportedExtension += supportedExtensionAddition;
    }
    if (supportedExtension.length > 2) {
        var privateIndex = foundLocale.indexOf("-x-");
        if (privateIndex === -1) foundLocale = foundLocale + supportedExtension;
        else {
            var preExtension = foundLocale.slice(0, privateIndex);
            var postExtension = foundLocale.slice(privateIndex, foundLocale.length);
            foundLocale = preExtension + supportedExtension + postExtension;
        }
        foundLocale = Intl.getCanonicalLocales(foundLocale)[0];
    }
    result.locale = foundLocale;
    return result;
}
module.exports.ResolveLocale = $960a4e0ee795e1e7$var$ResolveLocale;

});
parcelRegister("eaYZN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BestFitMatcher = void 0;

var $k68wz = parcelRequire("k68wz");
/**
 * https://tc39.es/ecma402/#sec-bestfitmatcher
 * @param availableLocales
 * @param requestedLocales
 * @param getDefaultLocale
 */ function $a521505bbfaabbbd$var$BestFitMatcher(availableLocales, requestedLocales, getDefaultLocale) {
    var foundLocale;
    var extension;
    for(var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++){
        var l = requestedLocales_1[_i];
        var matchedLocale = (0, $k68wz.findBestMatch)(l.replace($k68wz.UNICODE_EXTENSION_SEQUENCE_REGEX, ""), availableLocales);
        if (matchedLocale) {
            foundLocale = matchedLocale;
            var noExtensionLocale = l.replace($k68wz.UNICODE_EXTENSION_SEQUENCE_REGEX, "");
            extension = l.slice(noExtensionLocale.length, l.length) || undefined;
            break;
        }
    }
    if (!foundLocale) return {
        locale: getDefaultLocale()
    };
    return {
        locale: foundLocale,
        extension: extension
    };
}
module.exports.BestFitMatcher = $a521505bbfaabbbd$var$BestFitMatcher;

});
parcelRegister("k68wz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findBestMatch = module.exports.findMatchingDistance = module.exports.invariant = module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $5jNo4 = parcelRequire("5jNo4");

var $g7YcX = parcelRequire("g7YcX");
module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function $ea1afaf3bcf7a4b7$var$invariant(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
module.exports.invariant = $ea1afaf3bcf7a4b7$var$invariant;
// This is effectively 2 languages in 2 different regions not even in the same cluster
var $ea1afaf3bcf7a4b7$var$DEFAULT_MATCHING_THRESHOLD = 840;
var $ea1afaf3bcf7a4b7$var$PROCESSED_DATA;
function $ea1afaf3bcf7a4b7$var$processData() {
    var _a, _b;
    if (!$ea1afaf3bcf7a4b7$var$PROCESSED_DATA) {
        var paradigmLocales = (_b = (_a = $5jNo4.data.supplemental.languageMatching["written-new"][0]) === null || _a === void 0 ? void 0 : _a.paradigmLocales) === null || _b === void 0 ? void 0 : _b._locales.split(" ");
        var matchVariables = $5jNo4.data.supplemental.languageMatching["written-new"].slice(1, 5);
        var data = $5jNo4.data.supplemental.languageMatching["written-new"].slice(5);
        var matches = data.map(function(d) {
            var key = Object.keys(d)[0];
            var value = d[key];
            return {
                supported: key,
                desired: value._desired,
                distance: +value._distance,
                oneway: value.oneway === "true" ? true : false
            };
        }, {});
        $ea1afaf3bcf7a4b7$var$PROCESSED_DATA = {
            matches: matches,
            matchVariables: matchVariables.reduce(function(all, d) {
                var key = Object.keys(d)[0];
                var value = d[key];
                all[key.slice(1)] = value._value.split("+");
                return all;
            }, {}),
            paradigmLocales: $eIwgG.__spreadArray($eIwgG.__spreadArray([], paradigmLocales, true), paradigmLocales.map(function(l) {
                return new Intl.Locale(l.replace(/_/g, "-")).maximize().toString();
            }), true)
        };
    }
    return $ea1afaf3bcf7a4b7$var$PROCESSED_DATA;
}
function $ea1afaf3bcf7a4b7$var$isMatched(locale, languageMatchInfoLocale, matchVariables) {
    var _a = languageMatchInfoLocale.split("-"), language = _a[0], script = _a[1], region = _a[2];
    var matches = true;
    if (region && region[0] === "$") {
        var shouldInclude = region[1] !== "!";
        var matchRegions = shouldInclude ? matchVariables[region.slice(1)] : matchVariables[region.slice(2)];
        var expandedMatchedRegions = matchRegions.map(function(r) {
            return $g7YcX.regions[r] || [
                r
            ];
        }).reduce(function(all, list) {
            return $eIwgG.__spreadArray($eIwgG.__spreadArray([], all, true), list, true);
        }, []);
        matches && (matches = !(expandedMatchedRegions.indexOf(locale.region || "") > 1 != shouldInclude));
    } else matches && (matches = locale.region ? region === "*" || region === locale.region : true);
    matches && (matches = locale.script ? script === "*" || script === locale.script : true);
    matches && (matches = locale.language ? language === "*" || language === locale.language : true);
    return matches;
}
function $ea1afaf3bcf7a4b7$var$serializeLSR(lsr) {
    return [
        lsr.language,
        lsr.script,
        lsr.region
    ].filter(Boolean).join("-");
}
function $ea1afaf3bcf7a4b7$var$findMatchingDistanceForLSR(desired, supported, data) {
    for(var _i = 0, _a = data.matches; _i < _a.length; _i++){
        var d = _a[_i];
        var matches = $ea1afaf3bcf7a4b7$var$isMatched(desired, d.desired, data.matchVariables) && $ea1afaf3bcf7a4b7$var$isMatched(supported, d.supported, data.matchVariables);
        if (!d.oneway && !matches) matches = $ea1afaf3bcf7a4b7$var$isMatched(desired, d.supported, data.matchVariables) && $ea1afaf3bcf7a4b7$var$isMatched(supported, d.desired, data.matchVariables);
        if (matches) {
            var distance = d.distance * 10;
            if (data.paradigmLocales.indexOf($ea1afaf3bcf7a4b7$var$serializeLSR(desired)) > -1 != data.paradigmLocales.indexOf($ea1afaf3bcf7a4b7$var$serializeLSR(supported)) > -1) return distance - 1;
            return distance;
        }
    }
    throw new Error("No matching distance found");
}
function $ea1afaf3bcf7a4b7$var$findMatchingDistance(desired, supported) {
    var desiredLocale = new Intl.Locale(desired).maximize();
    var supportedLocale = new Intl.Locale(supported).maximize();
    var desiredLSR = {
        language: desiredLocale.language,
        script: desiredLocale.script || "",
        region: desiredLocale.region || ""
    };
    var supportedLSR = {
        language: supportedLocale.language,
        script: supportedLocale.script || "",
        region: supportedLocale.region || ""
    };
    var matchingDistance = 0;
    var data = $ea1afaf3bcf7a4b7$var$processData();
    if (desiredLSR.language !== supportedLSR.language) matchingDistance += $ea1afaf3bcf7a4b7$var$findMatchingDistanceForLSR({
        language: desiredLocale.language,
        script: "",
        region: ""
    }, {
        language: supportedLocale.language,
        script: "",
        region: ""
    }, data);
    if (desiredLSR.script !== supportedLSR.script) matchingDistance += $ea1afaf3bcf7a4b7$var$findMatchingDistanceForLSR({
        language: desiredLocale.language,
        script: desiredLSR.script,
        region: ""
    }, {
        language: supportedLocale.language,
        script: desiredLSR.script,
        region: ""
    }, data);
    if (desiredLSR.region !== supportedLSR.region) matchingDistance += $ea1afaf3bcf7a4b7$var$findMatchingDistanceForLSR(desiredLSR, supportedLSR, data);
    return matchingDistance;
}
module.exports.findMatchingDistance = $ea1afaf3bcf7a4b7$var$findMatchingDistance;
function $ea1afaf3bcf7a4b7$var$findBestMatch(desired, supportedLocales, threshold) {
    if (threshold === void 0) threshold = $ea1afaf3bcf7a4b7$var$DEFAULT_MATCHING_THRESHOLD;
    var bestMatch = undefined;
    var lowestDistance = Infinity;
    supportedLocales.forEach(function(supported, i) {
        // Add some weight to the distance based on the order of the supported locales
        var distance = $ea1afaf3bcf7a4b7$var$findMatchingDistance(desired, supported) + i;
        if (distance < lowestDistance) {
            lowestDistance = distance;
            bestMatch = supported;
        }
    });
    if (lowestDistance >= threshold) return;
    return bestMatch;
}
module.exports.findBestMatch = $ea1afaf3bcf7a4b7$var$findBestMatch;

});
parcelRegister("5jNo4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.data = void 0;
module.exports.data = {
    supplemental: {
        languageMatching: {
            "written-new": [
                {
                    paradigmLocales: {
                        _locales: "en en_GB es es_419 pt_BR pt_PT"
                    }
                },
                {
                    $enUS: {
                        _value: "AS+CA+GU+MH+MP+PH+PR+UM+US+VI"
                    }
                },
                {
                    $cnsar: {
                        _value: "HK+MO"
                    }
                },
                {
                    $americas: {
                        _value: "019"
                    }
                },
                {
                    $maghreb: {
                        _value: "MA+DZ+TN+LY+MR+EH"
                    }
                },
                {
                    no: {
                        _desired: "nb",
                        _distance: "1"
                    }
                },
                {
                    bs: {
                        _desired: "hr",
                        _distance: "4"
                    }
                },
                {
                    bs: {
                        _desired: "sh",
                        _distance: "4"
                    }
                },
                {
                    hr: {
                        _desired: "sh",
                        _distance: "4"
                    }
                },
                {
                    sr: {
                        _desired: "sh",
                        _distance: "4"
                    }
                },
                {
                    aa: {
                        _desired: "ssy",
                        _distance: "4"
                    }
                },
                {
                    de: {
                        _desired: "gsw",
                        _distance: "4",
                        _oneway: "true"
                    }
                },
                {
                    de: {
                        _desired: "lb",
                        _distance: "4",
                        _oneway: "true"
                    }
                },
                {
                    no: {
                        _desired: "da",
                        _distance: "8"
                    }
                },
                {
                    nb: {
                        _desired: "da",
                        _distance: "8"
                    }
                },
                {
                    ru: {
                        _desired: "ab",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ach",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    nl: {
                        _desired: "af",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ak",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "am",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "ay",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "az",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ur: {
                        _desired: "bal",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "be",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "bem",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "bh",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "bn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "bo",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "br",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "ca",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fil: {
                        _desired: "ceb",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "chr",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ckb",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "co",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "crs",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    sk: {
                        _desired: "cs",
                        _distance: "20"
                    }
                },
                {
                    en: {
                        _desired: "cy",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ee",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "eo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "eu",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    da: {
                        _desired: "fo",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    nl: {
                        _desired: "fy",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ga",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "gaa",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "gd",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "gl",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "gn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "gu",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ha",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "haw",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "ht",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "hy",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ia",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ig",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "is",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    id: {
                        _desired: "jv",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ka",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "kg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "kk",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "km",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "kn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "kri",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    tr: {
                        _desired: "ku",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "ky",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    it: {
                        _desired: "la",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "lg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "ln",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "lo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "loz",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "lua",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "mai",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "mfe",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "mg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "mi",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ml",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "mn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "mr",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    id: {
                        _desired: "ms",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "mt",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "my",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ne",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    nb: {
                        _desired: "nn",
                        _distance: "20"
                    }
                },
                {
                    no: {
                        _desired: "nn",
                        _distance: "20"
                    }
                },
                {
                    en: {
                        _desired: "nso",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ny",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "nyn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "oc",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "om",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "or",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "pa",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "pcm",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ps",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "qu",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    de: {
                        _desired: "rm",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "rn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "rw",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "sa",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sd",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "si",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "so",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sq",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "st",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    id: {
                        _desired: "su",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sw",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ta",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "te",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "tg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ti",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "tk",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "tlh",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "tn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "to",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "tt",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "tum",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "ug",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "uk",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ur",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "uz",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "wo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "xh",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "yi",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "yo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "za",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "zu",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "aao",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "abh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "abv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acx",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "adf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "aeb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "aec",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "afb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ajp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "apc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "apd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "arq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ars",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ary",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "arz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "auz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "avl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "bbz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "pga",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "shu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ssh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    az: {
                        _desired: "azb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    et: {
                        _desired: "vro",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "ffm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fub",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fue",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fui",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "gnw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "gui",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "gun",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "nhd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    iu: {
                        _desired: "ikt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "enb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "eyo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "niq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "oki",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "pko",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "sgc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "tec",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "tuy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kok: {
                        _desired: "gom",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kpe: {
                        _desired: "gkp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "ida",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lkb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lko",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lks",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lri",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lrm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lsm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lto",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lts",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lwg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "nle",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "nyd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "rag",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    lv: {
                        _desired: "ltg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bhr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bjq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bmm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bzc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "msh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "skg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "tdx",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "tkg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "txy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "xmv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "xmw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mn: {
                        _desired: "mvf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "bjn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "btj",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "bve",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "bvu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "coa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "dup",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "hji",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "id",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "jak",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "jax",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "kvb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "kvr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "kxd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "lce",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "lcf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "liw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "max",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "meo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mfa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mfb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "min",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mqg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "msi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mui",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "orn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "ors",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "pel",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "pse",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "tmw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "urk",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "vkk",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "vkt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "xmm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "zlm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "zmi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ne: {
                        _desired: "dty",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    om: {
                        _desired: "gax",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    om: {
                        _desired: "hae",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    om: {
                        _desired: "orc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    or: {
                        _desired: "spv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ps: {
                        _desired: "pbt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ps: {
                        _desired: "pst",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qub",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qud",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qug",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quk",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qul",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qup",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qur",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qus",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qux",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qva",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qve",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvj",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvs",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qwa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qwc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qwh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qws",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sc: {
                        _desired: "sdc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sc: {
                        _desired: "sdn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sc: {
                        _desired: "sro",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sq: {
                        _desired: "aae",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sq: {
                        _desired: "aat",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sq: {
                        _desired: "aln",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    syr: {
                        _desired: "aii",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    uz: {
                        _desired: "uzs",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    yi: {
                        _desired: "yih",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "cdo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "cjy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "cpx",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "czh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "czo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "gan",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "hak",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "hsn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "lzh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "mnp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "nan",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "wuu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "yue",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "*": {
                        _desired: "*",
                        _distance: "80"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "am-Ethi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "az-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "bn-Beng",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "bo-Tibt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "hy-Armn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ka-Geor",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "km-Khmr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "kn-Knda",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "lo-Laoo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ml-Mlym",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "my-Mymr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ne-Deva",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "or-Orya",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "pa-Guru",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ps-Arab",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "sd-Arab",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "si-Sinh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ta-Taml",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "te-Telu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ti-Ethi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "tk-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ur-Arab",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "uz-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "yi-Hebr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "sr-Cyrl": {
                        _desired: "sr-Latn",
                        _distance: "5"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "za-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "zh-Hani",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hant": {
                        _desired: "zh-Hani",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ar-Arab": {
                        _desired: "ar-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "bn-Beng": {
                        _desired: "bn-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "gu-Gujr": {
                        _desired: "gu-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "hi-Deva": {
                        _desired: "hi-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "kn-Knda": {
                        _desired: "kn-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ml-Mlym": {
                        _desired: "ml-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "mr-Deva": {
                        _desired: "mr-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ta-Taml": {
                        _desired: "ta-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "te-Telu": {
                        _desired: "te-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "zh-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Latn",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Hani",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Hira",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Kana",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Hrkt",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Hrkt": {
                        _desired: "ja-Hira",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Hrkt": {
                        _desired: "ja-Kana",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Kore": {
                        _desired: "ko-Hani",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Kore": {
                        _desired: "ko-Hang",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Kore": {
                        _desired: "ko-Jamo",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Hang": {
                        _desired: "ko-Jamo",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "*-*": {
                        _desired: "*-*",
                        _distance: "50"
                    }
                },
                {
                    "ar-*-$maghreb": {
                        _desired: "ar-*-$maghreb",
                        _distance: "4"
                    }
                },
                {
                    "ar-*-$!maghreb": {
                        _desired: "ar-*-$!maghreb",
                        _distance: "4"
                    }
                },
                {
                    "ar-*-*": {
                        _desired: "ar-*-*",
                        _distance: "5"
                    }
                },
                {
                    "en-*-$enUS": {
                        _desired: "en-*-$enUS",
                        _distance: "4"
                    }
                },
                {
                    "en-*-GB": {
                        _desired: "en-*-$!enUS",
                        _distance: "3"
                    }
                },
                {
                    "en-*-$!enUS": {
                        _desired: "en-*-$!enUS",
                        _distance: "4"
                    }
                },
                {
                    "en-*-*": {
                        _desired: "en-*-*",
                        _distance: "5"
                    }
                },
                {
                    "es-*-$americas": {
                        _desired: "es-*-$americas",
                        _distance: "4"
                    }
                },
                {
                    "es-*-$!americas": {
                        _desired: "es-*-$!americas",
                        _distance: "4"
                    }
                },
                {
                    "es-*-*": {
                        _desired: "es-*-*",
                        _distance: "5"
                    }
                },
                {
                    "pt-*-$americas": {
                        _desired: "pt-*-$americas",
                        _distance: "4"
                    }
                },
                {
                    "pt-*-$!americas": {
                        _desired: "pt-*-$!americas",
                        _distance: "4"
                    }
                },
                {
                    "pt-*-*": {
                        _desired: "pt-*-*",
                        _distance: "5"
                    }
                },
                {
                    "zh-Hant-$cnsar": {
                        _desired: "zh-Hant-$cnsar",
                        _distance: "4"
                    }
                },
                {
                    "zh-Hant-$!cnsar": {
                        _desired: "zh-Hant-$!cnsar",
                        _distance: "4"
                    }
                },
                {
                    "zh-Hant-*": {
                        _desired: "zh-Hant-*",
                        _distance: "5"
                    }
                },
                {
                    "*-*-*": {
                        _desired: "*-*-*",
                        _distance: "4"
                    }
                }
            ]
        }
    }
};

});

parcelRegister("g7YcX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.regions = void 0;
// This file is generated from regions-gen.ts
module.exports.regions = {
    "001": [
        "001",
        "001-status-grouping",
        "002",
        "005",
        "009",
        "011",
        "013",
        "014",
        "015",
        "017",
        "018",
        "019",
        "021",
        "029",
        "030",
        "034",
        "035",
        "039",
        "053",
        "054",
        "057",
        "061",
        "142",
        "143",
        "145",
        "150",
        "151",
        "154",
        "155",
        "AC",
        "AD",
        "AE",
        "AF",
        "AG",
        "AI",
        "AL",
        "AM",
        "AO",
        "AQ",
        "AR",
        "AS",
        "AT",
        "AU",
        "AW",
        "AX",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BL",
        "BM",
        "BN",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BT",
        "BV",
        "BW",
        "BY",
        "BZ",
        "CA",
        "CC",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CK",
        "CL",
        "CM",
        "CN",
        "CO",
        "CP",
        "CQ",
        "CR",
        "CU",
        "CV",
        "CW",
        "CX",
        "CY",
        "CZ",
        "DE",
        "DG",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EA",
        "EC",
        "EE",
        "EG",
        "EH",
        "ER",
        "ES",
        "ET",
        "EU",
        "EZ",
        "FI",
        "FJ",
        "FK",
        "FM",
        "FO",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GF",
        "GG",
        "GH",
        "GI",
        "GL",
        "GM",
        "GN",
        "GP",
        "GQ",
        "GR",
        "GS",
        "GT",
        "GU",
        "GW",
        "GY",
        "HK",
        "HM",
        "HN",
        "HR",
        "HT",
        "HU",
        "IC",
        "ID",
        "IE",
        "IL",
        "IM",
        "IN",
        "IO",
        "IQ",
        "IR",
        "IS",
        "IT",
        "JE",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KP",
        "KR",
        "KW",
        "KY",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LI",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "LY",
        "MA",
        "MC",
        "MD",
        "ME",
        "MF",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MO",
        "MP",
        "MQ",
        "MR",
        "MS",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NC",
        "NE",
        "NF",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NU",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PF",
        "PG",
        "PH",
        "PK",
        "PL",
        "PM",
        "PN",
        "PR",
        "PS",
        "PT",
        "PW",
        "PY",
        "QA",
        "QO",
        "RE",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SH",
        "SI",
        "SJ",
        "SK",
        "SL",
        "SM",
        "SN",
        "SO",
        "SR",
        "SS",
        "ST",
        "SV",
        "SX",
        "SY",
        "SZ",
        "TA",
        "TC",
        "TD",
        "TF",
        "TG",
        "TH",
        "TJ",
        "TK",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TW",
        "TZ",
        "UA",
        "UG",
        "UM",
        "UN",
        "US",
        "UY",
        "UZ",
        "VA",
        "VC",
        "VE",
        "VG",
        "VI",
        "VN",
        "VU",
        "WF",
        "WS",
        "XK",
        "YE",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "002": [
        "002",
        "002-status-grouping",
        "011",
        "014",
        "015",
        "017",
        "018",
        "202",
        "AO",
        "BF",
        "BI",
        "BJ",
        "BW",
        "CD",
        "CF",
        "CG",
        "CI",
        "CM",
        "CV",
        "DJ",
        "DZ",
        "EA",
        "EG",
        "EH",
        "ER",
        "ET",
        "GA",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GW",
        "IC",
        "IO",
        "KE",
        "KM",
        "LR",
        "LS",
        "LY",
        "MA",
        "MG",
        "ML",
        "MR",
        "MU",
        "MW",
        "MZ",
        "NA",
        "NE",
        "NG",
        "RE",
        "RW",
        "SC",
        "SD",
        "SH",
        "SL",
        "SN",
        "SO",
        "SS",
        "ST",
        "SZ",
        "TD",
        "TF",
        "TG",
        "TN",
        "TZ",
        "UG",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "003": [
        "003",
        "013",
        "021",
        "029",
        "AG",
        "AI",
        "AW",
        "BB",
        "BL",
        "BM",
        "BQ",
        "BS",
        "BZ",
        "CA",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "GD",
        "GL",
        "GP",
        "GT",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PM",
        "PR",
        "SV",
        "SX",
        "TC",
        "TT",
        "US",
        "VC",
        "VG",
        "VI"
    ],
    "005": [
        "005",
        "AR",
        "BO",
        "BR",
        "BV",
        "CL",
        "CO",
        "EC",
        "FK",
        "GF",
        "GS",
        "GY",
        "PE",
        "PY",
        "SR",
        "UY",
        "VE"
    ],
    "009": [
        "009",
        "053",
        "054",
        "057",
        "061",
        "AC",
        "AQ",
        "AS",
        "AU",
        "CC",
        "CK",
        "CP",
        "CX",
        "DG",
        "FJ",
        "FM",
        "GU",
        "HM",
        "KI",
        "MH",
        "MP",
        "NC",
        "NF",
        "NR",
        "NU",
        "NZ",
        "PF",
        "PG",
        "PN",
        "PW",
        "QO",
        "SB",
        "TA",
        "TK",
        "TO",
        "TV",
        "UM",
        "VU",
        "WF",
        "WS"
    ],
    "011": [
        "011",
        "BF",
        "BJ",
        "CI",
        "CV",
        "GH",
        "GM",
        "GN",
        "GW",
        "LR",
        "ML",
        "MR",
        "NE",
        "NG",
        "SH",
        "SL",
        "SN",
        "TG"
    ],
    "013": [
        "013",
        "BZ",
        "CR",
        "GT",
        "HN",
        "MX",
        "NI",
        "PA",
        "SV"
    ],
    "014": [
        "014",
        "BI",
        "DJ",
        "ER",
        "ET",
        "IO",
        "KE",
        "KM",
        "MG",
        "MU",
        "MW",
        "MZ",
        "RE",
        "RW",
        "SC",
        "SO",
        "SS",
        "TF",
        "TZ",
        "UG",
        "YT",
        "ZM",
        "ZW"
    ],
    "015": [
        "015",
        "DZ",
        "EA",
        "EG",
        "EH",
        "IC",
        "LY",
        "MA",
        "SD",
        "TN"
    ],
    "017": [
        "017",
        "AO",
        "CD",
        "CF",
        "CG",
        "CM",
        "GA",
        "GQ",
        "ST",
        "TD"
    ],
    "018": [
        "018",
        "BW",
        "LS",
        "NA",
        "SZ",
        "ZA"
    ],
    "019": [
        "003",
        "005",
        "013",
        "019",
        "019-status-grouping",
        "021",
        "029",
        "419",
        "AG",
        "AI",
        "AR",
        "AW",
        "BB",
        "BL",
        "BM",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BV",
        "BZ",
        "CA",
        "CL",
        "CO",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "EC",
        "FK",
        "GD",
        "GF",
        "GL",
        "GP",
        "GS",
        "GT",
        "GY",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PE",
        "PM",
        "PR",
        "PY",
        "SR",
        "SV",
        "SX",
        "TC",
        "TT",
        "US",
        "UY",
        "VC",
        "VE",
        "VG",
        "VI"
    ],
    "021": [
        "021",
        "BM",
        "CA",
        "GL",
        "PM",
        "US"
    ],
    "029": [
        "029",
        "AG",
        "AI",
        "AW",
        "BB",
        "BL",
        "BQ",
        "BS",
        "CU",
        "CW",
        "DM",
        "DO",
        "GD",
        "GP",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "PR",
        "SX",
        "TC",
        "TT",
        "VC",
        "VG",
        "VI"
    ],
    "030": [
        "030",
        "CN",
        "HK",
        "JP",
        "KP",
        "KR",
        "MN",
        "MO",
        "TW"
    ],
    "034": [
        "034",
        "AF",
        "BD",
        "BT",
        "IN",
        "IR",
        "LK",
        "MV",
        "NP",
        "PK"
    ],
    "035": [
        "035",
        "BN",
        "ID",
        "KH",
        "LA",
        "MM",
        "MY",
        "PH",
        "SG",
        "TH",
        "TL",
        "VN"
    ],
    "039": [
        "039",
        "AD",
        "AL",
        "BA",
        "ES",
        "GI",
        "GR",
        "HR",
        "IT",
        "ME",
        "MK",
        "MT",
        "PT",
        "RS",
        "SI",
        "SM",
        "VA",
        "XK"
    ],
    "053": [
        "053",
        "AU",
        "CC",
        "CX",
        "HM",
        "NF",
        "NZ"
    ],
    "054": [
        "054",
        "FJ",
        "NC",
        "PG",
        "SB",
        "VU"
    ],
    "057": [
        "057",
        "FM",
        "GU",
        "KI",
        "MH",
        "MP",
        "NR",
        "PW",
        "UM"
    ],
    "061": [
        "061",
        "AS",
        "CK",
        "NU",
        "PF",
        "PN",
        "TK",
        "TO",
        "TV",
        "WF",
        "WS"
    ],
    "142": [
        "030",
        "034",
        "035",
        "142",
        "143",
        "145",
        "AE",
        "AF",
        "AM",
        "AZ",
        "BD",
        "BH",
        "BN",
        "BT",
        "CN",
        "CY",
        "GE",
        "HK",
        "ID",
        "IL",
        "IN",
        "IQ",
        "IR",
        "JO",
        "JP",
        "KG",
        "KH",
        "KP",
        "KR",
        "KW",
        "KZ",
        "LA",
        "LB",
        "LK",
        "MM",
        "MN",
        "MO",
        "MV",
        "MY",
        "NP",
        "OM",
        "PH",
        "PK",
        "PS",
        "QA",
        "SA",
        "SG",
        "SY",
        "TH",
        "TJ",
        "TL",
        "TM",
        "TR",
        "TW",
        "UZ",
        "VN",
        "YE"
    ],
    "143": [
        "143",
        "KG",
        "KZ",
        "TJ",
        "TM",
        "UZ"
    ],
    "145": [
        "145",
        "AE",
        "AM",
        "AZ",
        "BH",
        "CY",
        "GE",
        "IL",
        "IQ",
        "JO",
        "KW",
        "LB",
        "OM",
        "PS",
        "QA",
        "SA",
        "SY",
        "TR",
        "YE"
    ],
    "150": [
        "039",
        "150",
        "151",
        "154",
        "155",
        "AD",
        "AL",
        "AT",
        "AX",
        "BA",
        "BE",
        "BG",
        "BY",
        "CH",
        "CQ",
        "CZ",
        "DE",
        "DK",
        "EE",
        "ES",
        "FI",
        "FO",
        "FR",
        "GB",
        "GG",
        "GI",
        "GR",
        "HR",
        "HU",
        "IE",
        "IM",
        "IS",
        "IT",
        "JE",
        "LI",
        "LT",
        "LU",
        "LV",
        "MC",
        "MD",
        "ME",
        "MK",
        "MT",
        "NL",
        "NO",
        "PL",
        "PT",
        "RO",
        "RS",
        "RU",
        "SE",
        "SI",
        "SJ",
        "SK",
        "SM",
        "UA",
        "VA",
        "XK"
    ],
    "151": [
        "151",
        "BG",
        "BY",
        "CZ",
        "HU",
        "MD",
        "PL",
        "RO",
        "RU",
        "SK",
        "UA"
    ],
    "154": [
        "154",
        "AX",
        "CQ",
        "DK",
        "EE",
        "FI",
        "FO",
        "GB",
        "GG",
        "IE",
        "IM",
        "IS",
        "JE",
        "LT",
        "LV",
        "NO",
        "SE",
        "SJ"
    ],
    "155": [
        "155",
        "AT",
        "BE",
        "CH",
        "DE",
        "FR",
        "LI",
        "LU",
        "MC",
        "NL"
    ],
    "202": [
        "011",
        "014",
        "017",
        "018",
        "202",
        "AO",
        "BF",
        "BI",
        "BJ",
        "BW",
        "CD",
        "CF",
        "CG",
        "CI",
        "CM",
        "CV",
        "DJ",
        "ER",
        "ET",
        "GA",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GW",
        "IO",
        "KE",
        "KM",
        "LR",
        "LS",
        "MG",
        "ML",
        "MR",
        "MU",
        "MW",
        "MZ",
        "NA",
        "NE",
        "NG",
        "RE",
        "RW",
        "SC",
        "SH",
        "SL",
        "SN",
        "SO",
        "SS",
        "ST",
        "SZ",
        "TD",
        "TF",
        "TG",
        "TZ",
        "UG",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "419": [
        "005",
        "013",
        "029",
        "419",
        "AG",
        "AI",
        "AR",
        "AW",
        "BB",
        "BL",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BV",
        "BZ",
        "CL",
        "CO",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "EC",
        "FK",
        "GD",
        "GF",
        "GP",
        "GS",
        "GT",
        "GY",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PE",
        "PR",
        "PY",
        "SR",
        "SV",
        "SX",
        "TC",
        "TT",
        "UY",
        "VC",
        "VE",
        "VG",
        "VI"
    ],
    "EU": [
        "AT",
        "BE",
        "BG",
        "CY",
        "CZ",
        "DE",
        "DK",
        "EE",
        "ES",
        "EU",
        "FI",
        "FR",
        "GR",
        "HR",
        "HU",
        "IE",
        "IT",
        "LT",
        "LU",
        "LV",
        "MT",
        "NL",
        "PL",
        "PT",
        "RO",
        "SE",
        "SI",
        "SK"
    ],
    "EZ": [
        "AT",
        "BE",
        "CY",
        "DE",
        "EE",
        "ES",
        "EZ",
        "FI",
        "FR",
        "GR",
        "IE",
        "IT",
        "LT",
        "LU",
        "LV",
        "MT",
        "NL",
        "PT",
        "SI",
        "SK"
    ],
    "QO": [
        "AC",
        "AQ",
        "CP",
        "DG",
        "QO",
        "TA"
    ],
    "UN": [
        "AD",
        "AE",
        "AF",
        "AG",
        "AL",
        "AM",
        "AO",
        "AR",
        "AT",
        "AU",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BN",
        "BO",
        "BR",
        "BS",
        "BT",
        "BW",
        "BY",
        "BZ",
        "CA",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CL",
        "CM",
        "CN",
        "CO",
        "CR",
        "CU",
        "CV",
        "CY",
        "CZ",
        "DE",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ER",
        "ES",
        "ET",
        "FI",
        "FJ",
        "FM",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GR",
        "GT",
        "GW",
        "GY",
        "HN",
        "HR",
        "HT",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IQ",
        "IR",
        "IS",
        "IT",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KP",
        "KR",
        "KW",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LI",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "LY",
        "MA",
        "MC",
        "MD",
        "ME",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MR",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NE",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PG",
        "PH",
        "PK",
        "PL",
        "PT",
        "PW",
        "PY",
        "QA",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SI",
        "SK",
        "SL",
        "SM",
        "SN",
        "SO",
        "SR",
        "SS",
        "ST",
        "SV",
        "SY",
        "SZ",
        "TD",
        "TG",
        "TH",
        "TJ",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TZ",
        "UA",
        "UG",
        "UN",
        "US",
        "UY",
        "UZ",
        "VC",
        "VE",
        "VN",
        "VU",
        "WS",
        "YE",
        "ZA",
        "ZM",
        "ZW"
    ]
};

});



parcelRegister("aBlOT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LookupMatcher = void 0;

var $5OH55 = parcelRequire("5OH55");

var $k68wz = parcelRequire("k68wz");
/**
 * https://tc39.es/ecma402/#sec-lookupmatcher
 * @param availableLocales
 * @param requestedLocales
 * @param getDefaultLocale
 */ function $7b7e490d21f02a4a$var$LookupMatcher(availableLocales, requestedLocales, getDefaultLocale) {
    var result = {
        locale: ""
    };
    for(var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++){
        var locale = requestedLocales_1[_i];
        var noExtensionLocale = locale.replace($k68wz.UNICODE_EXTENSION_SEQUENCE_REGEX, "");
        var availableLocale = (0, $5OH55.BestAvailableLocale)(availableLocales, noExtensionLocale);
        if (availableLocale) {
            result.locale = availableLocale;
            if (locale !== noExtensionLocale) result.extension = locale.slice(noExtensionLocale.length, locale.length);
            return result;
        }
    }
    result.locale = getDefaultLocale();
    return result;
}
module.exports.LookupMatcher = $7b7e490d21f02a4a$var$LookupMatcher;

});
parcelRegister("5OH55", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BestAvailableLocale = void 0;
/**
 * https://tc39.es/ecma402/#sec-bestavailablelocale
 * @param availableLocales
 * @param locale
 */ function $43c30a43733e0d69$var$BestAvailableLocale(availableLocales, locale) {
    var candidate = locale;
    while(true){
        if (availableLocales.indexOf(candidate) > -1) return candidate;
        var pos = candidate.lastIndexOf("-");
        if (!~pos) return undefined;
        if (pos >= 2 && candidate[pos - 2] === "-") pos -= 2;
        candidate = candidate.slice(0, pos);
    }
}
module.exports.BestAvailableLocale = $43c30a43733e0d69$var$BestAvailableLocale;

});


parcelRegister("eXYWp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnicodeExtensionValue = void 0;

var $k68wz = parcelRequire("k68wz");
/**
 * https://tc39.es/ecma402/#sec-unicodeextensionvalue
 * @param extension
 * @param key
 */ function $ae55d9054022f633$var$UnicodeExtensionValue(extension, key) {
    (0, $k68wz.invariant)(key.length === 2, "key must have 2 elements");
    var size = extension.length;
    var searchValue = "-".concat(key, "-");
    var pos = extension.indexOf(searchValue);
    if (pos !== -1) {
        var start = pos + 4;
        var end = start;
        var k = start;
        var done = false;
        while(!done){
            var e = extension.indexOf("-", k);
            var len = void 0;
            if (e === -1) len = size - k;
            else len = e - k;
            if (len === 2) done = true;
            else if (e === -1) {
                end = size;
                done = true;
            } else {
                end = e;
                k = e + 1;
            }
        }
        return extension.slice(start, end);
    }
    searchValue = "-".concat(key);
    pos = extension.indexOf(searchValue);
    if (pos !== -1 && pos + 3 === size) return "";
    return undefined;
}
module.exports.UnicodeExtensionValue = $ae55d9054022f633$var$UnicodeExtensionValue;

});


parcelRegister("dJNoW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LookupSupportedLocales = void 0;

var $5OH55 = parcelRequire("5OH55");

var $k68wz = parcelRequire("k68wz");
/**
 * https://tc39.es/ecma402/#sec-lookupsupportedlocales
 * @param availableLocales
 * @param requestedLocales
 */ function $a005cc6130ca7df9$var$LookupSupportedLocales(availableLocales, requestedLocales) {
    var subset = [];
    for(var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++){
        var locale = requestedLocales_1[_i];
        var noExtensionLocale = locale.replace($k68wz.UNICODE_EXTENSION_SEQUENCE_REGEX, "");
        var availableLocale = (0, $5OH55.BestAvailableLocale)(availableLocales, noExtensionLocale);
        if (availableLocale) subset.push(availableLocale);
    }
    return subset;
}
module.exports.LookupSupportedLocales = $a005cc6130ca7df9$var$LookupSupportedLocales;

});


parcelRegister("5do86", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetNumberFormatDigitOptions = void 0;

var $hoLlz = parcelRequire("hoLlz");

var $fZ7bI = parcelRequire("fZ7bI");

var $1LY2e = parcelRequire("1LY2e");
/**
 * https://tc39.es/ecma402/#sec-setnfdigitoptions
 */ function $3cc0e24a379fad60$var$SetNumberFormatDigitOptions(internalSlots, opts, mnfdDefault, mxfdDefault, notation) {
    var mnid = (0, $hoLlz.GetNumberOption)(opts, "minimumIntegerDigits", 1, 21, 1);
    var mnfd = opts.minimumFractionDigits;
    var mxfd = opts.maximumFractionDigits;
    var mnsd = opts.minimumSignificantDigits;
    var mxsd = opts.maximumSignificantDigits;
    internalSlots.minimumIntegerDigits = mnid;
    var roundingPriority = (0, $1LY2e.GetOption)(opts, "roundingPriority", "string", [
        "auto",
        "morePrecision",
        "lessPrecision"
    ], "auto");
    var hasSd = mnsd !== undefined || mxsd !== undefined;
    var hasFd = mnfd !== undefined || mxfd !== undefined;
    var needSd = true;
    var needFd = true;
    if (roundingPriority === "auto") {
        needSd = hasSd;
        if (hasSd || !hasFd && notation === "compact") needFd = false;
    }
    if (needSd) {
        if (hasSd) {
            mnsd = (0, $fZ7bI.DefaultNumberOption)(mnsd, 1, 21, 1);
            mxsd = (0, $fZ7bI.DefaultNumberOption)(mxsd, mnsd, 21, 21);
            internalSlots.minimumSignificantDigits = mnsd;
            internalSlots.maximumSignificantDigits = mxsd;
        } else {
            internalSlots.minimumSignificantDigits = 1;
            internalSlots.maximumSignificantDigits = 21;
        }
    }
    if (needFd) {
        if (hasFd) {
            // @ts-expect-error
            mnfd = (0, $fZ7bI.DefaultNumberOption)(mnfd, 0, 20, undefined);
            // @ts-expect-error
            mxfd = (0, $fZ7bI.DefaultNumberOption)(mxfd, 0, 20, undefined);
            if (mnfd === undefined) mnfd = Math.min(mnfdDefault, mxfd);
            else if (mxfd === undefined) mxfd = Math.max(mxfdDefault, mnfd);
            else if (mnfd > mxfd) throw new RangeError("Invalid range, ".concat(mnfd, " > ").concat(mxfd));
            internalSlots.minimumFractionDigits = mnfd;
            internalSlots.maximumFractionDigits = mxfd;
        } else {
            internalSlots.minimumFractionDigits = mnfdDefault;
            internalSlots.maximumFractionDigits = mxfdDefault;
        }
    }
    if (needSd || needFd) {
        if (roundingPriority === "morePrecision") internalSlots.roundingType = "morePrecision";
        else if (roundingPriority === "lessPrecision") internalSlots.roundingType = "lessPrecision";
        else if (hasSd) internalSlots.roundingType = "significantDigits";
        else internalSlots.roundingType = "fractionDigits";
    } else {
        internalSlots.roundingType = "morePrecision";
        internalSlots.minimumFractionDigits = 0;
        internalSlots.maximumFractionDigits = 0;
        internalSlots.minimumSignificantDigits = 1;
        internalSlots.maximumSignificantDigits = 2;
    }
}
module.exports.SetNumberFormatDigitOptions = $3cc0e24a379fad60$var$SetNumberFormatDigitOptions;

});

parcelRegister("clykw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetNumberFormatUnitOptions = void 0;

var $1LY2e = parcelRequire("1LY2e");

var $L3kEB = parcelRequire("L3kEB");

var $jkhUU = parcelRequire("jkhUU");
/**
 * https://tc39.es/ecma402/#sec-setnumberformatunitoptions
 */ function $8fd2136d13c19c43$var$SetNumberFormatUnitOptions(nf, options, _a) {
    if (options === void 0) options = Object.create(null);
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(nf);
    var style = (0, $1LY2e.GetOption)(options, "style", "string", [
        "decimal",
        "percent",
        "currency",
        "unit"
    ], "decimal");
    internalSlots.style = style;
    var currency = (0, $1LY2e.GetOption)(options, "currency", "string", undefined, undefined);
    if (currency !== undefined && !(0, $L3kEB.IsWellFormedCurrencyCode)(currency)) throw RangeError("Malformed currency code");
    if (style === "currency" && currency === undefined) throw TypeError("currency cannot be undefined");
    var currencyDisplay = (0, $1LY2e.GetOption)(options, "currencyDisplay", "string", [
        "code",
        "symbol",
        "narrowSymbol",
        "name"
    ], "symbol");
    var currencySign = (0, $1LY2e.GetOption)(options, "currencySign", "string", [
        "standard",
        "accounting"
    ], "standard");
    var unit = (0, $1LY2e.GetOption)(options, "unit", "string", undefined, undefined);
    if (unit !== undefined && !(0, $jkhUU.IsWellFormedUnitIdentifier)(unit)) throw RangeError("Invalid unit argument for Intl.NumberFormat()");
    if (style === "unit" && unit === undefined) throw TypeError("unit cannot be undefined");
    var unitDisplay = (0, $1LY2e.GetOption)(options, "unitDisplay", "string", [
        "short",
        "narrow",
        "long"
    ], "short");
    if (style === "currency") {
        internalSlots.currency = currency.toUpperCase();
        internalSlots.currencyDisplay = currencyDisplay;
        internalSlots.currencySign = currencySign;
    }
    if (style === "unit") {
        internalSlots.unit = unit;
        internalSlots.unitDisplay = unitDisplay;
    }
}
module.exports.SetNumberFormatUnitOptions = $8fd2136d13c19c43$var$SetNumberFormatUnitOptions;

});


parcelRegister("8CmPa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PartitionPattern = void 0;

var $kuWop = parcelRequire("kuWop");
/**
 * https://tc39.es/ecma402/#sec-partitionpattern
 * @param pattern
 */ function $646393c0aefefedd$var$PartitionPattern(pattern) {
    var result = [];
    var beginIndex = pattern.indexOf("{");
    var endIndex = 0;
    var nextIndex = 0;
    var length = pattern.length;
    while(beginIndex < pattern.length && beginIndex > -1){
        endIndex = pattern.indexOf("}", beginIndex);
        (0, $kuWop.invariant)(endIndex > beginIndex, "Invalid pattern ".concat(pattern));
        if (beginIndex > nextIndex) result.push({
            type: "literal",
            value: pattern.substring(nextIndex, beginIndex)
        });
        result.push({
            type: pattern.substring(beginIndex + 1, endIndex),
            value: undefined
        });
        nextIndex = endIndex + 1;
        beginIndex = pattern.indexOf("{", nextIndex);
    }
    if (nextIndex < length) result.push({
        type: "literal",
        value: pattern.substring(nextIndex, length)
    });
    return result;
}
module.exports.PartitionPattern = $646393c0aefefedd$var$PartitionPattern;

});

parcelRegister("k1ODG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SupportedLocales = void 0;

var $8IhHp = parcelRequire("8IhHp");

var $ggNGK = parcelRequire("ggNGK");

var $1LY2e = parcelRequire("1LY2e");
/**
 * https://tc39.es/ecma402/#sec-supportedlocales
 * @param availableLocales
 * @param requestedLocales
 * @param options
 */ function $e94b2e7becba0e4e$var$SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = "best fit";
    if (options !== undefined) {
        options = (0, $ggNGK.ToObject)(options);
        matcher = (0, $1LY2e.GetOption)(options, "localeMatcher", "string", [
            "lookup",
            "best fit"
        ], "best fit");
    }
    if (matcher === "best fit") return (0, $8IhHp.LookupSupportedLocales)(Array.from(availableLocales), requestedLocales);
    return (0, $8IhHp.LookupSupportedLocales)(Array.from(availableLocales), requestedLocales);
}
module.exports.SupportedLocales = $e94b2e7becba0e4e$var$SupportedLocales;

});

parcelRegister("8q0zc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMissingLocaleDataError = void 0;

var $eIwgG = parcelRequire("eIwgG");
var $621130f8dd1cc58b$var$MissingLocaleDataError = /** @class */ function(_super) {
    $eIwgG.__extends(MissingLocaleDataError, _super);
    function MissingLocaleDataError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "MISSING_LOCALE_DATA";
        return _this;
    }
    return MissingLocaleDataError;
}(Error);
function $621130f8dd1cc58b$var$isMissingLocaleDataError(e) {
    return e.type === "MISSING_LOCALE_DATA";
}
module.exports.isMissingLocaleDataError = $621130f8dd1cc58b$var$isMissingLocaleDataError;

});

parcelRegister("3uegr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iHV3H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangePatternType = void 0;
var $d9e880cadc3214fe$var$RangePatternType;
(function(RangePatternType) {
    RangePatternType["startRange"] = "startRange";
    RangePatternType["shared"] = "shared";
    RangePatternType["endRange"] = "endRange";
})($d9e880cadc3214fe$var$RangePatternType || (module.exports.RangePatternType = $d9e880cadc3214fe$var$RangePatternType = {}));

});

parcelRegister("ePyoG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7VnGo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("citf9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3cCv2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRegister("ajk9N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatTimeToParts = module.exports.formatDateToParts = module.exports.formatDateTimeRange = module.exports.formatTime = module.exports.formatDate = module.exports.getFormatter = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $gCJ4u = parcelRequire("gCJ4u");

var $8hOmc = parcelRequire("8hOmc");
var $781b507cb4307605$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem",
    "fractionalSecondDigits"
];
function $781b507cb4307605$var$getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = $eIwgG.__assign($eIwgG.__assign({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $gCJ4u.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $gCJ4u.filterProps)(options, $781b507cb4307605$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = $eIwgG.__assign($eIwgG.__assign({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
module.exports.getFormatter = $781b507cb4307605$var$getFormatter;
function $781b507cb4307605$var$formatDate(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $781b507cb4307605$var$getFormatter(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new $8hOmc.IntlFormatError("Error formatting date.", config.locale, e));
    }
    return String(date);
}
module.exports.formatDate = $781b507cb4307605$var$formatDate;
function $781b507cb4307605$var$formatTime(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $781b507cb4307605$var$getFormatter(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new $8hOmc.IntlFormatError("Error formatting time.", config.locale, e));
    }
    return String(date);
}
module.exports.formatTime = $781b507cb4307605$var$formatTime;
function $781b507cb4307605$var$formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $gCJ4u.filterProps)(options, $781b507cb4307605$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new $8hOmc.IntlFormatError("Error formatting date time range.", config.locale, e));
    }
    return String(from);
}
module.exports.formatDateTimeRange = $781b507cb4307605$var$formatDateTimeRange;
function $781b507cb4307605$var$formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $781b507cb4307605$var$getFormatter(config, "date", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new $8hOmc.IntlFormatError("Error formatting date.", config.locale, e));
    }
    return [];
}
module.exports.formatDateToParts = $781b507cb4307605$var$formatDateToParts;
function $781b507cb4307605$var$formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $781b507cb4307605$var$getFormatter(config, "time", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new $8hOmc.IntlFormatError("Error formatting time.", config.locale, e));
    }
    return [];
}
module.exports.formatTimeToParts = $781b507cb4307605$var$formatTimeToParts;

});

parcelRegister("2l9gB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatDisplayName = void 0;

var $gCJ4u = parcelRequire("gCJ4u");

var $8kYn6 = parcelRequire("8kYn6");

var $8hOmc = parcelRequire("8hOmc");
var $1b44bb1b96c4c2ed$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $1b44bb1b96c4c2ed$var$formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new $8kYn6.FormatError('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', $8kYn6.ErrorCode.MISSING_INTL_API));
    var filteredOptions = (0, $gCJ4u.filterProps)(options, $1b44bb1b96c4c2ed$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new $8hOmc.IntlFormatError("Error formatting display name.", locale, e));
    }
}
module.exports.formatDisplayName = $1b44bb1b96c4c2ed$var$formatDisplayName;

});

parcelRegister("fiJox", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatListToParts = module.exports.formatList = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $gCJ4u = parcelRequire("gCJ4u");

var $8kYn6 = parcelRequire("8kYn6");

var $8hOmc = parcelRequire("8hOmc");
var $b23bbfe682f314c0$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
var $b23bbfe682f314c0$var$now = Date.now();
function $b23bbfe682f314c0$var$generateToken(i) {
    return "".concat($b23bbfe682f314c0$var$now, "_").concat(i, "_").concat($b23bbfe682f314c0$var$now);
}
function $b23bbfe682f314c0$var$formatList(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $b23bbfe682f314c0$var$formatListToParts(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
module.exports.formatList = $b23bbfe682f314c0$var$formatList;
function $b23bbfe682f314c0$var$formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new $8kYn6.FormatError('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', $8kYn6.ErrorCode.MISSING_INTL_API));
    var filteredOptions = (0, $gCJ4u.filterProps)(options, $b23bbfe682f314c0$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $b23bbfe682f314c0$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : $eIwgG.__assign($eIwgG.__assign({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new $8hOmc.IntlFormatError("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}
module.exports.formatListToParts = $b23bbfe682f314c0$var$formatListToParts;

});

parcelRegister("9z4X1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatPlural = void 0;

var $gCJ4u = parcelRequire("gCJ4u");

var $8hOmc = parcelRequire("8hOmc");

var $8kYn6 = parcelRequire("8kYn6");
var $6f6b3916a8b58b0e$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $6f6b3916a8b58b0e$var$formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new $8kYn6.FormatError('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', $8kYn6.ErrorCode.MISSING_INTL_API));
    var filteredOptions = (0, $gCJ4u.filterProps)(options, $6f6b3916a8b58b0e$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new $8hOmc.IntlFormatError("Error formatting plural.", locale, e));
    }
    return "other";
}
module.exports.formatPlural = $6f6b3916a8b58b0e$var$formatPlural;

});

parcelRegister("bSofV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatRelativeTime = void 0;

var $gCJ4u = parcelRequire("gCJ4u");

var $8kYn6 = parcelRequire("8kYn6");

var $8hOmc = parcelRequire("8hOmc");
var $023b37f5dbf383bd$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $023b37f5dbf383bd$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $gCJ4u.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $gCJ4u.filterProps)(options, $023b37f5dbf383bd$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $023b37f5dbf383bd$var$formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new $8kYn6.FormatError('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', $8kYn6.ErrorCode.MISSING_INTL_API));
    try {
        return $023b37f5dbf383bd$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new $8hOmc.IntlFormatError("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}
module.exports.formatRelativeTime = $023b37f5dbf383bd$var$formatRelativeTime;

});

parcelRegister("4GCna", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatNumberToParts = module.exports.formatNumber = module.exports.getFormatter = void 0;

var $gCJ4u = parcelRequire("gCJ4u");

var $8hOmc = parcelRequire("8hOmc");
var $3698d9b4500eb595$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function $3698d9b4500eb595$var$getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $gCJ4u.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $gCJ4u.filterProps)(options, $3698d9b4500eb595$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
module.exports.getFormatter = $3698d9b4500eb595$var$getFormatter;
function $3698d9b4500eb595$var$formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $3698d9b4500eb595$var$getFormatter(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new $8hOmc.IntlFormatError("Error formatting number.", config.locale, e));
    }
    return String(value);
}
module.exports.formatNumber = $3698d9b4500eb595$var$formatNumber;
function $3698d9b4500eb595$var$formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $3698d9b4500eb595$var$getFormatter(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new $8hOmc.IntlFormatError("Error formatting number.", config.locale, e));
    }
    return [];
}
module.exports.formatNumberToParts = $3698d9b4500eb595$var$formatNumberToParts;

});

parcelRegister("1cRd2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIntl = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $gCJ4u = parcelRequire("gCJ4u");

var $8hOmc = parcelRequire("8hOmc");

var $4GCna = parcelRequire("4GCna");

var $bSofV = parcelRequire("bSofV");

var $ajk9N = parcelRequire("ajk9N");

var $9z4X1 = parcelRequire("9z4X1");

var $aQNFd = parcelRequire("aQNFd");

var $fiJox = parcelRequire("fiJox");

var $2l9gB = parcelRequire("2l9gB");
function $0e102faab07f82e2$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $0e102faab07f82e2$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $0e102faab07f82e2$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */ function $0e102faab07f82e2$var$createIntl(config, cache) {
    var formatters = (0, $gCJ4u.createFormatters)(cache);
    var resolvedConfig = $eIwgG.__assign($eIwgG.__assign({}, $gCJ4u.DEFAULT_INTL_CONFIG), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new $8hOmc.InvalidConfigError('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new $8hOmc.MissingDataError('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new $8hOmc.MissingDataError('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $0e102faab07f82e2$var$verifyConfigMessages(resolvedConfig);
    return $eIwgG.__assign($eIwgG.__assign({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: $4GCna.formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: $4GCna.formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: $bSofV.formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: $ajk9N.formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: $ajk9N.formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: $ajk9N.formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: $ajk9N.formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: $ajk9N.formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: $9z4X1.formatPlural.bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: $aQNFd.formatMessage.bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: $aQNFd.formatMessage.bind(null, resolvedConfig, formatters),
        formatList: $fiJox.formatList.bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: $fiJox.formatListToParts.bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: $2l9gB.formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}
module.exports.createIntl = $0e102faab07f82e2$var$createIntl;

});





parcelRegister("85suM", function(module, exports) {
"use strict";
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIntl = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $6RKOV = parcelRequire("6RKOV");

var $5e34e4f1774c671a$var$React = $eIwgG.__importStar((parcelRequire("4DE7A")));

var $31FDS = parcelRequire("31FDS");

var $a1NwE = parcelRequire("a1NwE");

var $dwdux = parcelRequire("dwdux");
function $5e34e4f1774c671a$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $5e34e4f1774c671a$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $dwdux.isFormatXMLElementFn)(v) ? (0, $31FDS.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $5e34e4f1774c671a$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $5e34e4f1774c671a$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = $6RKOV.formatMessage.apply(void 0, $eIwgG.__spreadArray([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $5e34e4f1774c671a$var$React.Children.toArray(chunks);
    return chunks;
};
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */ var $5e34e4f1774c671a$var$createIntl = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = $eIwgG.__rest(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $5e34e4f1774c671a$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $6RKOV.createIntl)($eIwgG.__assign($eIwgG.__assign($eIwgG.__assign({}, $31FDS.DEFAULT_INTL_CONFIG), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return $eIwgG.__assign($eIwgG.__assign({}, coreIntl), {
        formatMessage: $5e34e4f1774c671a$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $5e34e4f1774c671a$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};
module.exports.createIntl = $5e34e4f1774c671a$var$createIntl;
var $5e34e4f1774c671a$var$IntlProvider = /** @class */ function(_super) {
    $eIwgG.__extends(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $6RKOV.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, module.exports.createIntl)($5e34e4f1774c671a$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $5e34e4f1774c671a$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $5e34e4f1774c671a$var$processIntlConfig(props);
        if (!(0, $31FDS.shallowEqual)(prevConfig, config)) return {
            intl: (0, module.exports.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $31FDS.invariantIntlContext)(this.state.intl);
        return $5e34e4f1774c671a$var$React.createElement($a1NwE.Provider, {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = $31FDS.DEFAULT_INTL_CONFIG;
    return IntlProvider;
}($5e34e4f1774c671a$var$React.PureComponent);
module.exports.default = $5e34e4f1774c671a$var$IntlProvider;

});
parcelRegister("dwdux", function(module, exports) {
"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eIwgG = parcelRequire("eIwgG");


$eIwgG.__exportStar((parcelRequire("jkKuO")), module.exports);

$eIwgG.__exportStar((parcelRequire("jiYyY")), module.exports);

$eIwgG.__exportStar((parcelRequire("af4ig")), module.exports);
module.exports.default = (parcelRequire("jiYyY")).IntlMessageFormat;

});
parcelRegister("jiYyY", function(module, exports) {
"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntlMessageFormat = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $b3snn = parcelRequire("b3snn");

var $b2bpw = parcelRequire("b2bpw");

var $jkKuO = parcelRequire("jkKuO");
// -- MessageFormat --------------------------------------------------------
function $e0dead4e758ba903$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return $eIwgG.__assign($eIwgG.__assign($eIwgG.__assign({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = $eIwgG.__assign($eIwgG.__assign({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $e0dead4e758ba903$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $e0dead4e758ba903$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, $eIwgG.__assign({}, defaultConfig));
}
function $e0dead4e758ba903$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $e0dead4e758ba903$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $b2bpw.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, $eIwgG.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $e0dead4e758ba903$var$createFastMemoizeCache(cache.number),
            strategy: $b2bpw.strategies.variadic
        }),
        getDateTimeFormat: (0, $b2bpw.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, $eIwgG.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $e0dead4e758ba903$var$createFastMemoizeCache(cache.dateTime),
            strategy: $b2bpw.strategies.variadic
        }),
        getPluralRules: (0, $b2bpw.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, $eIwgG.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $e0dead4e758ba903$var$createFastMemoizeCache(cache.pluralRules),
            strategy: $b2bpw.strategies.variadic
        })
    };
}
var $e0dead4e758ba903$var$IntlMessageFormat = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== $jkKuO.PART_TYPE.literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $jkKuO.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = $eIwgG.__rest(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, $eIwgG.__assign($eIwgG.__assign({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $e0dead4e758ba903$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $e0dead4e758ba903$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = $b3snn.parse;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();
module.exports.IntlMessageFormat = $e0dead4e758ba903$var$IntlMessageFormat;

});
parcelRegister("b3snn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._Parser = module.exports.parse = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $cWUap = parcelRequire("cWUap");

var $1qM2L = parcelRequire("1qM2L");

function $80c5fc6964d4b263$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, (parcelRequire("7dbsu")).isSelectElement)(el) || (0, (parcelRequire("7dbsu")).isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $80c5fc6964d4b263$var$pruneLocation(el.options[k].value);
        }
        else if ((0, (parcelRequire("7dbsu")).isNumberElement)(el) && (0, (parcelRequire("7dbsu")).isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, (parcelRequire("7dbsu")).isDateElement)(el) || (0, (parcelRequire("7dbsu")).isTimeElement)(el)) && (0, (parcelRequire("7dbsu")).isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, (parcelRequire("7dbsu")).isTagElement)(el)) $80c5fc6964d4b263$var$pruneLocation(el.children);
    });
}
function $80c5fc6964d4b263$var$parse(message, opts) {
    if (opts === void 0) opts = {};
    opts = $eIwgG.__assign({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new $1qM2L.Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError($cWUap.ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $80c5fc6964d4b263$var$pruneLocation(result.val);
    return result.val;
}
module.exports.parse = $80c5fc6964d4b263$var$parse;

$eIwgG.__exportStar((parcelRequire("7dbsu")), module.exports);
// only for testing
module.exports._Parser = $1qM2L.Parser;

});
parcelRegister("cWUap", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorKind = void 0;
var $96d67868c8dd7180$var$ErrorKind;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($96d67868c8dd7180$var$ErrorKind || (module.exports.ErrorKind = $96d67868c8dd7180$var$ErrorKind = {}));

});

parcelRegister("1qM2L", function(module, exports) {
"use strict";
var $10ad7c9fc55182e3$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $cWUap = parcelRequire("cWUap");

var $7dbsu = parcelRequire("7dbsu");

var $6fwy4 = parcelRequire("6fwy4");

var $jre1J = parcelRequire("jre1J");

var $i5tt9 = parcelRequire("i5tt9");
var $10ad7c9fc55182e3$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat($6fwy4.SPACE_SEPARATOR_REGEX.source, "*"));
var $10ad7c9fc55182e3$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat($6fwy4.SPACE_SEPARATOR_REGEX.source, "*$"));
function $10ad7c9fc55182e3$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $10ad7c9fc55182e3$var$hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var $10ad7c9fc55182e3$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $10ad7c9fc55182e3$var$hasNativeFromEntries = !!Object.fromEntries;
var $10ad7c9fc55182e3$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $10ad7c9fc55182e3$var$hasTrimStart = !!String.prototype.trimStart;
var $10ad7c9fc55182e3$var$hasTrimEnd = !!String.prototype.trimEnd;
var $10ad7c9fc55182e3$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $10ad7c9fc55182e3$var$isSafeInteger = $10ad7c9fc55182e3$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $10ad7c9fc55182e3$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $10ad7c9fc55182e3$var$re = $10ad7c9fc55182e3$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $10ad7c9fc55182e3$var$REGEX_SUPPORTS_U_AND_Y = (($10ad7c9fc55182e3$var$_a = $10ad7c9fc55182e3$var$re.exec("a")) === null || $10ad7c9fc55182e3$var$_a === void 0 ? void 0 : $10ad7c9fc55182e3$var$_a[0]) === "a";
} catch (_) {
    $10ad7c9fc55182e3$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $10ad7c9fc55182e3$var$startsWith = $10ad7c9fc55182e3$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $10ad7c9fc55182e3$var$fromCodePoint = $10ad7c9fc55182e3$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $10ad7c9fc55182e3$var$fromEntries = // native
$10ad7c9fc55182e3$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $10ad7c9fc55182e3$var$codePointAt = $10ad7c9fc55182e3$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $10ad7c9fc55182e3$var$trimStart = $10ad7c9fc55182e3$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($10ad7c9fc55182e3$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $10ad7c9fc55182e3$var$trimEnd = $10ad7c9fc55182e3$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($10ad7c9fc55182e3$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $10ad7c9fc55182e3$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $10ad7c9fc55182e3$var$matchIdentifierAtIndex;
if ($10ad7c9fc55182e3$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $10ad7c9fc55182e3$var$IDENTIFIER_PREFIX_RE_1 = $10ad7c9fc55182e3$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $10ad7c9fc55182e3$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $10ad7c9fc55182e3$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $10ad7c9fc55182e3$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$10ad7c9fc55182e3$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $10ad7c9fc55182e3$var$codePointAt(s, index);
        if (c === undefined || $10ad7c9fc55182e3$var$_isWhiteSpace(c) || $10ad7c9fc55182e3$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $10ad7c9fc55182e3$var$fromCodePoint.apply(void 0, match);
};
var $10ad7c9fc55182e3$var$Parser = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: $7dbsu.TYPE.pound,
                    location: $10ad7c9fc55182e3$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error($cWUap.ErrorKind.UNMATCHED_CLOSING_TAG, $10ad7c9fc55182e3$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $10ad7c9fc55182e3$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: $7dbsu.TYPE.literal,
                value: "<".concat(tagName, "/>"),
                location: $10ad7c9fc55182e3$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$10ad7c9fc55182e3$var$_isAlpha(this.char())) return this.error($cWUap.ErrorKind.INVALID_TAG, $10ad7c9fc55182e3$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error($cWUap.ErrorKind.UNMATCHED_CLOSING_TAG, $10ad7c9fc55182e3$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error($cWUap.ErrorKind.INVALID_TAG, $10ad7c9fc55182e3$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: $7dbsu.TYPE.tag,
                        value: tagName,
                        children: children,
                        location: $10ad7c9fc55182e3$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error($cWUap.ErrorKind.UNCLOSED_TAG, $10ad7c9fc55182e3$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error($cWUap.ErrorKind.INVALID_TAG, $10ad7c9fc55182e3$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $10ad7c9fc55182e3$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $10ad7c9fc55182e3$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: $7dbsu.TYPE.literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$10ad7c9fc55182e3$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $10ad7c9fc55182e3$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $10ad7c9fc55182e3$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error($cWUap.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $10ad7c9fc55182e3$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error($cWUap.ErrorKind.EMPTY_ARGUMENT, $10ad7c9fc55182e3$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error($cWUap.ErrorKind.MALFORMED_ARGUMENT, $10ad7c9fc55182e3$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error($cWUap.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $10ad7c9fc55182e3$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: $7dbsu.TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $10ad7c9fc55182e3$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error($cWUap.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $10ad7c9fc55182e3$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error($cWUap.ErrorKind.MALFORMED_ARGUMENT, $10ad7c9fc55182e3$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $10ad7c9fc55182e3$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $10ad7c9fc55182e3$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error($cWUap.ErrorKind.EXPECT_ARGUMENT_TYPE, $10ad7c9fc55182e3$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $10ad7c9fc55182e3$var$trimEnd(result.val);
                    if (style.length === 0) return this.error($cWUap.ErrorKind.EXPECT_ARGUMENT_STYLE, $10ad7c9fc55182e3$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $10ad7c9fc55182e3$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $10ad7c9fc55182e3$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $10ad7c9fc55182e3$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $10ad7c9fc55182e3$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: $7dbsu.TYPE.number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error($cWUap.ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $i5tt9.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: $7dbsu.SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $jre1J.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? $7dbsu.TYPE.date : $7dbsu.TYPE.time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? $7dbsu.TYPE.number : argType === "date" ? $7dbsu.TYPE.date : $7dbsu.TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error($cWUap.ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, $10ad7c9fc55182e3$var$createLocation(typeEndPosition_1, $eIwgG.__assign({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error($cWUap.ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $10ad7c9fc55182e3$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger($cWUap.ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $cWUap.ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $10ad7c9fc55182e3$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: $7dbsu.TYPE.select,
                        value: value,
                        options: $10ad7c9fc55182e3$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: $7dbsu.TYPE.plural,
                        value: value,
                        options: $10ad7c9fc55182e3$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error($cWUap.ErrorKind.INVALID_ARGUMENT_TYPE, $10ad7c9fc55182e3$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error($cWUap.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $10ad7c9fc55182e3$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error($cWUap.ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $10ad7c9fc55182e3$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $jre1J.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error($cWUap.ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: $7dbsu.SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $jre1J.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger($cWUap.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, $cWUap.ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $10ad7c9fc55182e3$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? $cWUap.ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR : $cWUap.ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? $cWUap.ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : $cWUap.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $10ad7c9fc55182e3$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $10ad7c9fc55182e3$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? $cWUap.ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR : $cWUap.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, $10ad7c9fc55182e3$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error($cWUap.ErrorKind.MISSING_OTHER_CLAUSE, $10ad7c9fc55182e3$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $10ad7c9fc55182e3$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$10ad7c9fc55182e3$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $10ad7c9fc55182e3$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($10ad7c9fc55182e3$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $10ad7c9fc55182e3$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
module.exports.Parser = $10ad7c9fc55182e3$var$Parser;
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $10ad7c9fc55182e3$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $10ad7c9fc55182e3$var$_isAlphaOrSlash(codepoint) {
    return $10ad7c9fc55182e3$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $10ad7c9fc55182e3$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $10ad7c9fc55182e3$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $10ad7c9fc55182e3$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("7dbsu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNumberElement = module.exports.createLiteralElement = module.exports.isDateTimeSkeleton = module.exports.isNumberSkeleton = module.exports.isTagElement = module.exports.isPoundElement = module.exports.isPluralElement = module.exports.isSelectElement = module.exports.isTimeElement = module.exports.isDateElement = module.exports.isNumberElement = module.exports.isArgumentElement = module.exports.isLiteralElement = module.exports.SKELETON_TYPE = module.exports.TYPE = void 0;
var $5402a2b7bde304b1$var$TYPE;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($5402a2b7bde304b1$var$TYPE || (module.exports.TYPE = $5402a2b7bde304b1$var$TYPE = {}));
var $5402a2b7bde304b1$var$SKELETON_TYPE;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($5402a2b7bde304b1$var$SKELETON_TYPE || (module.exports.SKELETON_TYPE = $5402a2b7bde304b1$var$SKELETON_TYPE = {}));
/**
 * Type Guards
 */ function $5402a2b7bde304b1$var$isLiteralElement(el) {
    return el.type === $5402a2b7bde304b1$var$TYPE.literal;
}
module.exports.isLiteralElement = $5402a2b7bde304b1$var$isLiteralElement;
function $5402a2b7bde304b1$var$isArgumentElement(el) {
    return el.type === $5402a2b7bde304b1$var$TYPE.argument;
}
module.exports.isArgumentElement = $5402a2b7bde304b1$var$isArgumentElement;
function $5402a2b7bde304b1$var$isNumberElement(el) {
    return el.type === $5402a2b7bde304b1$var$TYPE.number;
}
module.exports.isNumberElement = $5402a2b7bde304b1$var$isNumberElement;
function $5402a2b7bde304b1$var$isDateElement(el) {
    return el.type === $5402a2b7bde304b1$var$TYPE.date;
}
module.exports.isDateElement = $5402a2b7bde304b1$var$isDateElement;
function $5402a2b7bde304b1$var$isTimeElement(el) {
    return el.type === $5402a2b7bde304b1$var$TYPE.time;
}
module.exports.isTimeElement = $5402a2b7bde304b1$var$isTimeElement;
function $5402a2b7bde304b1$var$isSelectElement(el) {
    return el.type === $5402a2b7bde304b1$var$TYPE.select;
}
module.exports.isSelectElement = $5402a2b7bde304b1$var$isSelectElement;
function $5402a2b7bde304b1$var$isPluralElement(el) {
    return el.type === $5402a2b7bde304b1$var$TYPE.plural;
}
module.exports.isPluralElement = $5402a2b7bde304b1$var$isPluralElement;
function $5402a2b7bde304b1$var$isPoundElement(el) {
    return el.type === $5402a2b7bde304b1$var$TYPE.pound;
}
module.exports.isPoundElement = $5402a2b7bde304b1$var$isPoundElement;
function $5402a2b7bde304b1$var$isTagElement(el) {
    return el.type === $5402a2b7bde304b1$var$TYPE.tag;
}
module.exports.isTagElement = $5402a2b7bde304b1$var$isTagElement;
function $5402a2b7bde304b1$var$isNumberSkeleton(el) {
    return !!(el && typeof el === "object" && el.type === $5402a2b7bde304b1$var$SKELETON_TYPE.number);
}
module.exports.isNumberSkeleton = $5402a2b7bde304b1$var$isNumberSkeleton;
function $5402a2b7bde304b1$var$isDateTimeSkeleton(el) {
    return !!(el && typeof el === "object" && el.type === $5402a2b7bde304b1$var$SKELETON_TYPE.dateTime);
}
module.exports.isDateTimeSkeleton = $5402a2b7bde304b1$var$isDateTimeSkeleton;
function $5402a2b7bde304b1$var$createLiteralElement(value) {
    return {
        type: $5402a2b7bde304b1$var$TYPE.literal,
        value: value
    };
}
module.exports.createLiteralElement = $5402a2b7bde304b1$var$createLiteralElement;
function $5402a2b7bde304b1$var$createNumberElement(value, style) {
    return {
        type: $5402a2b7bde304b1$var$TYPE.number,
        value: value,
        style: style
    };
}
module.exports.createNumberElement = $5402a2b7bde304b1$var$createNumberElement;

});

parcelRegister("6fwy4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WHITE_SPACE_REGEX = module.exports.SPACE_SEPARATOR_REGEX = void 0;
// @generated from regex-gen.ts
module.exports.SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
module.exports.WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("jre1J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eIwgG = parcelRequire("eIwgG");

$eIwgG.__exportStar((parcelRequire("hXBUd")), module.exports);

$eIwgG.__exportStar((parcelRequire("2yd7q")), module.exports);

});
parcelRegister("hXBUd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseDateTimeSkeleton = void 0;
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $d13559a19803bed7$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */ function $d13559a19803bed7$var$parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace($d13559a19803bed7$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}
module.exports.parseDateTimeSkeleton = $d13559a19803bed7$var$parseDateTimeSkeleton;

});

parcelRegister("2yd7q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseNumberSkeleton = module.exports.parseNumberSkeletonFromString = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $af41c = parcelRequire("af41c");
function $1db8eed8c3608353$var$parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split($af41c.WHITE_SPACE_REGEX).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
module.exports.parseNumberSkeletonFromString = $1db8eed8c3608353$var$parseNumberSkeletonFromString;
function $1db8eed8c3608353$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $1db8eed8c3608353$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $1db8eed8c3608353$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $1db8eed8c3608353$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $1db8eed8c3608353$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $1db8eed8c3608353$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($1db8eed8c3608353$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $1db8eed8c3608353$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $1db8eed8c3608353$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$1db8eed8c3608353$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $1db8eed8c3608353$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $1db8eed8c3608353$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */ function $1db8eed8c3608353$var$parseNumberSkeleton(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $1db8eed8c3608353$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = $eIwgG.__assign($eIwgG.__assign($eIwgG.__assign({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return $eIwgG.__assign($eIwgG.__assign({}, all), $1db8eed8c3608353$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = $eIwgG.__assign($eIwgG.__assign($eIwgG.__assign({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return $eIwgG.__assign($eIwgG.__assign({}, all), $1db8eed8c3608353$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($1db8eed8c3608353$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($1db8eed8c3608353$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($1db8eed8c3608353$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($1db8eed8c3608353$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = $eIwgG.__assign($eIwgG.__assign({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = $eIwgG.__assign($eIwgG.__assign({}, result), $1db8eed8c3608353$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($1db8eed8c3608353$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = $eIwgG.__assign($eIwgG.__assign({}, result), $1db8eed8c3608353$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $1db8eed8c3608353$var$parseSign(token.stem);
        if (signOpts) result = $eIwgG.__assign($eIwgG.__assign({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $1db8eed8c3608353$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = $eIwgG.__assign($eIwgG.__assign({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}
module.exports.parseNumberSkeleton = $1db8eed8c3608353$var$parseNumberSkeleton;

});
parcelRegister("af41c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WHITE_SPACE_REGEX = void 0;
// @generated from regex-gen.ts
module.exports.WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("i5tt9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBestPattern = void 0;

var $iHDIp = parcelRequire("iHDIp");
/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */ function $d2af8d91e2a6c442$var$getBestPattern(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $d2af8d91e2a6c442$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
module.exports.getBestPattern = $d2af8d91e2a6c442$var$getBestPattern;
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $d2af8d91e2a6c442$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = $iHDIp.timeData[regionTag || ""] || $iHDIp.timeData[languageTag || ""] || $iHDIp.timeData["".concat(languageTag, "-001")] || $iHDIp.timeData["001"];
    return hourCycles[0];
}

});
parcelRegister("iHDIp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.timeData = void 0;
// @generated from time-data-gen.ts
// prettier-ignore  
module.exports.timeData = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("jkKuO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatToParts = module.exports.isFormatXMLElementFn = module.exports.PART_TYPE = void 0;

var $b3snn = parcelRequire("b3snn");

var $af4ig = parcelRequire("af4ig");
var $e133f3af5e7b300f$var$PART_TYPE;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($e133f3af5e7b300f$var$PART_TYPE || (module.exports.PART_TYPE = $e133f3af5e7b300f$var$PART_TYPE = {}));
function $e133f3af5e7b300f$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $e133f3af5e7b300f$var$PART_TYPE.literal || part.type !== $e133f3af5e7b300f$var$PART_TYPE.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $e133f3af5e7b300f$var$isFormatXMLElementFn(el) {
    return typeof el === "function";
}
module.exports.isFormatXMLElementFn = $e133f3af5e7b300f$var$isFormatXMLElementFn;
// TODO(skeleton): add skeleton support
function $e133f3af5e7b300f$var$formatToParts(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $b3snn.isLiteralElement)(els[0])) return [
        {
            type: $e133f3af5e7b300f$var$PART_TYPE.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $b3snn.isLiteralElement)(el)) {
            result.push({
                type: $e133f3af5e7b300f$var$PART_TYPE.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $b3snn.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $e133f3af5e7b300f$var$PART_TYPE.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new $af4ig.MissingValueError(varName, originalMessage);
        var value = values[varName];
        if ((0, $b3snn.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $e133f3af5e7b300f$var$PART_TYPE.literal : $e133f3af5e7b300f$var$PART_TYPE.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $b3snn.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $b3snn.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $e133f3af5e7b300f$var$PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $b3snn.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $b3snn.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $e133f3af5e7b300f$var$PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $b3snn.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $b3snn.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $e133f3af5e7b300f$var$PART_TYPE.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $b3snn.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$e133f3af5e7b300f$var$isFormatXMLElementFn(formatFn)) throw new $af4ig.InvalidValueTypeError(value_1, "function", originalMessage);
            var parts = $e133f3af5e7b300f$var$formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $e133f3af5e7b300f$var$PART_TYPE.literal : $e133f3af5e7b300f$var$PART_TYPE.object,
                    value: c
                };
            }));
        }
        if ((0, $b3snn.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new $af4ig.InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $e133f3af5e7b300f$var$formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $b3snn.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new $af4ig.FormatError('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', $af4ig.ErrorCode.MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new $af4ig.InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $e133f3af5e7b300f$var$formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $e133f3af5e7b300f$var$mergeLiteral(result);
}
module.exports.formatToParts = $e133f3af5e7b300f$var$formatToParts;

});
parcelRegister("af4ig", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MissingValueError = module.exports.InvalidValueTypeError = module.exports.InvalidValueError = module.exports.FormatError = module.exports.ErrorCode = void 0;

var $eIwgG = parcelRequire("eIwgG");
var $774ea2bcf5e378b1$var$ErrorCode;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($774ea2bcf5e378b1$var$ErrorCode || (module.exports.ErrorCode = $774ea2bcf5e378b1$var$ErrorCode = {}));
var $774ea2bcf5e378b1$var$FormatError = /** @class */ function(_super) {
    $eIwgG.__extends(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
module.exports.FormatError = $774ea2bcf5e378b1$var$FormatError;
var $774ea2bcf5e378b1$var$InvalidValueError = /** @class */ function(_super) {
    $eIwgG.__extends(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $774ea2bcf5e378b1$var$ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($774ea2bcf5e378b1$var$FormatError);
module.exports.InvalidValueError = $774ea2bcf5e378b1$var$InvalidValueError;
var $774ea2bcf5e378b1$var$InvalidValueTypeError = /** @class */ function(_super) {
    $eIwgG.__extends(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $774ea2bcf5e378b1$var$ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($774ea2bcf5e378b1$var$FormatError);
module.exports.InvalidValueTypeError = $774ea2bcf5e378b1$var$InvalidValueTypeError;
var $774ea2bcf5e378b1$var$MissingValueError = /** @class */ function(_super) {
    $eIwgG.__extends(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $774ea2bcf5e378b1$var$ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($774ea2bcf5e378b1$var$FormatError);
module.exports.MissingValueError = $774ea2bcf5e378b1$var$MissingValueError;

});





parcelRegister("aE98L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eIwgG = parcelRequire("eIwgG");

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $7c04bae6d7775952$var$React = $eIwgG.__importStar((parcelRequire("4DE7A")));

var $3gtsi = parcelRequire("3gtsi");

var $7c04bae6d7775952$var$useIntl_1 = $eIwgG.__importDefault((parcelRequire("eVtUR")));
var $7c04bae6d7775952$var$MINUTE = 60;
var $7c04bae6d7775952$var$HOUR = 3600;
var $7c04bae6d7775952$var$DAY = 86400;
function $7c04bae6d7775952$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $7c04bae6d7775952$var$MINUTE) return "second";
    if (absValue < $7c04bae6d7775952$var$HOUR) return "minute";
    if (absValue < $7c04bae6d7775952$var$DAY) return "hour";
    return "day";
}
function $7c04bae6d7775952$var$getDurationInSeconds(unit) {
    switch(unit){
        case "second":
            return 1;
        case "minute":
            return $7c04bae6d7775952$var$MINUTE;
        case "hour":
            return $7c04bae6d7775952$var$HOUR;
        default:
            return $7c04bae6d7775952$var$DAY;
    }
}
function $7c04bae6d7775952$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case "second":
            return value;
        case "minute":
            return value * $7c04bae6d7775952$var$MINUTE;
        default:
            return value * $7c04bae6d7775952$var$HOUR;
    }
}
var $7c04bae6d7775952$var$INCREMENTABLE_UNITS = [
    "second",
    "minute",
    "hour"
];
function $7c04bae6d7775952$var$canIncrement(unit) {
    if (unit === void 0) unit = "second";
    return $7c04bae6d7775952$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $7c04bae6d7775952$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $7c04bae6d7775952$var$useIntl_1.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = $eIwgG.__rest(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === "function") return children(formattedRelativeTime);
    if (Text) return $7c04bae6d7775952$var$React.createElement(Text, null, formattedRelativeTime);
    return $7c04bae6d7775952$var$React.createElement($7c04bae6d7775952$var$React.Fragment, null, formattedRelativeTime);
};
var $7c04bae6d7775952$var$FormattedRelativeTime = function(_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = $eIwgG.__rest(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $3gtsi.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $7c04bae6d7775952$var$canIncrement(unit)), "Cannot schedule update with unit longer than hour");
    var _b = $7c04bae6d7775952$var$React.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = $7c04bae6d7775952$var$React.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = $7c04bae6d7775952$var$React.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($7c04bae6d7775952$var$canIncrement(unit) ? $7c04bae6d7775952$var$valueToSeconds(value, unit) : 0);
    }
    $7c04bae6d7775952$var$React.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$7c04bae6d7775952$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $7c04bae6d7775952$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === "day") return clearUpdateTimer;
        var unitDuration = $7c04bae6d7775952$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($7c04bae6d7775952$var$canIncrement(unit) && typeof currentValueInSeconds === "number" && updateIntervalInSeconds) {
        currentUnit = $7c04bae6d7775952$var$selectUnit(currentValueInSeconds);
        var unitDuration = $7c04bae6d7775952$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $7c04bae6d7775952$var$React.createElement($7c04bae6d7775952$var$SimpleFormattedRelativeTime, $eIwgG.__assign({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$7c04bae6d7775952$var$FormattedRelativeTime.displayName = "FormattedRelativeTime";
$7c04bae6d7775952$var$FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: "second"
};
module.exports.default = $7c04bae6d7775952$var$FormattedRelativeTime;

});

parcelRegister("gl6Q3", function(module, exports) {
"use strict";
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eIwgG = parcelRequire("eIwgG");

var $be53e97c94126ce6$var$React = $eIwgG.__importStar((parcelRequire("4DE7A")));

var $be53e97c94126ce6$var$useIntl_1 = $eIwgG.__importDefault((parcelRequire("eVtUR")));
var $be53e97c94126ce6$var$FormattedPlural = function(props) {
    var _a = (0, $be53e97c94126ce6$var$useIntl_1.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === "function") return children(formattedPlural);
    if (Text) return $be53e97c94126ce6$var$React.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$be53e97c94126ce6$var$FormattedPlural.defaultProps = {
    type: "cardinal"
};
$be53e97c94126ce6$var$FormattedPlural.displayName = "FormattedPlural";
module.exports.default = $be53e97c94126ce6$var$FormattedPlural;

});

parcelRegister("9Jpl6", function(module, exports) {
"use strict";
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eIwgG = parcelRequire("eIwgG");

var $715bf8e9e56dac1b$var$React = $eIwgG.__importStar((parcelRequire("4DE7A")));

var $715bf8e9e56dac1b$var$useIntl_1 = $eIwgG.__importDefault((parcelRequire("eVtUR")));

var $31FDS = parcelRequire("31FDS");
function $715bf8e9e56dac1b$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = $eIwgG.__rest(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = $eIwgG.__rest(nextProps, [
        "values"
    ]);
    return (0, $31FDS.shallowEqual)(nextValues, values) && (0, $31FDS.shallowEqual)(otherProps, nextOtherProps);
}
function $715bf8e9e56dac1b$var$FormattedMessage(props) {
    var intl = (0, $715bf8e9e56dac1b$var$useIntl_1.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $715bf8e9e56dac1b$var$React.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $715bf8e9e56dac1b$var$React.createElement(Component, null, $715bf8e9e56dac1b$var$React.Children.toArray(nodes));
    return $715bf8e9e56dac1b$var$React.createElement($715bf8e9e56dac1b$var$React.Fragment, null, nodes);
}
$715bf8e9e56dac1b$var$FormattedMessage.displayName = "FormattedMessage";
var $715bf8e9e56dac1b$var$MemoizedFormattedMessage = $715bf8e9e56dac1b$var$React.memo($715bf8e9e56dac1b$var$FormattedMessage, $715bf8e9e56dac1b$var$areEqual);
$715bf8e9e56dac1b$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
module.exports.default = $715bf8e9e56dac1b$var$MemoizedFormattedMessage;

});

parcelRegister("lsukT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eIwgG = parcelRequire("eIwgG");

var $f9f3be9d3dd8dcb4$var$React = $eIwgG.__importStar((parcelRequire("4DE7A")));

var $f9f3be9d3dd8dcb4$var$useIntl_1 = $eIwgG.__importDefault((parcelRequire("eVtUR")));
var $f9f3be9d3dd8dcb4$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $f9f3be9d3dd8dcb4$var$useIntl_1.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = $eIwgG.__rest(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === "function") return children(formattedValue);
    var Text = intl.textComponent || $f9f3be9d3dd8dcb4$var$React.Fragment;
    return $f9f3be9d3dd8dcb4$var$React.createElement(Text, null, formattedValue);
};
$f9f3be9d3dd8dcb4$var$FormattedDateTimeRange.displayName = "FormattedDateTimeRange";
module.exports.default = $f9f3be9d3dd8dcb4$var$FormattedDateTimeRange;

});

parcelRegister("fmSD5", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b3034957adc6c234$var$ReactIs, $b3034957adc6c234$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("bTlHI"))();

});
parcelRegister("bTlHI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $iTshx = parcelRequire("iTshx");
function $8a85aab852104171$var$emptyFunction() {}
function $8a85aab852104171$var$emptyFunctionWithReset() {}
$8a85aab852104171$var$emptyFunctionWithReset.resetWarningCache = $8a85aab852104171$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iTshx) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $8a85aab852104171$var$emptyFunctionWithReset,
        resetWarningCache: $8a85aab852104171$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iTshx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $dc134d3bf417c3df$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $dc134d3bf417c3df$var$ReactPropTypesSecret;

});



parcelRegister("aOZ8D", function(module, exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $7e0dffa881a3961e$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $7e0dffa881a3961e$var$NEWLINE_REGEX = /\n/g;
var $7e0dffa881a3961e$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $7e0dffa881a3961e$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $7e0dffa881a3961e$var$COLON_REGEX = /^:\s*/;
var $7e0dffa881a3961e$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $7e0dffa881a3961e$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $7e0dffa881a3961e$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $7e0dffa881a3961e$var$NEWLINE = "\n";
var $7e0dffa881a3961e$var$FORWARD_SLASH = "/";
var $7e0dffa881a3961e$var$ASTERISK = "*";
var $7e0dffa881a3961e$var$EMPTY_STRING = "";
// types
var $7e0dffa881a3961e$var$TYPE_COMMENT = "comment";
var $7e0dffa881a3961e$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($7e0dffa881a3961e$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($7e0dffa881a3961e$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($7e0dffa881a3961e$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($7e0dffa881a3961e$var$FORWARD_SLASH != style.charAt(0) || $7e0dffa881a3961e$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($7e0dffa881a3961e$var$EMPTY_STRING != style.charAt(i) && ($7e0dffa881a3961e$var$ASTERISK != style.charAt(i) || $7e0dffa881a3961e$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($7e0dffa881a3961e$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $7e0dffa881a3961e$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($7e0dffa881a3961e$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($7e0dffa881a3961e$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($7e0dffa881a3961e$var$VALUE_REGEX);
        var ret = pos({
            type: $7e0dffa881a3961e$var$TYPE_DECLARATION,
            property: $7e0dffa881a3961e$var$trim(prop[0].replace($7e0dffa881a3961e$var$COMMENT_REGEX, $7e0dffa881a3961e$var$EMPTY_STRING)),
            value: val ? $7e0dffa881a3961e$var$trim(val[0].replace($7e0dffa881a3961e$var$COMMENT_REGEX, $7e0dffa881a3961e$var$EMPTY_STRING)) : $7e0dffa881a3961e$var$EMPTY_STRING
        });
        // ;
        match($7e0dffa881a3961e$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $7e0dffa881a3961e$var$trim(str) {
    return str ? str.replace($7e0dffa881a3961e$var$TRIM_REGEX, $7e0dffa881a3961e$var$EMPTY_STRING) : $7e0dffa881a3961e$var$EMPTY_STRING;
}

});

parcelRegister("4Fm0Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "resetIdCounter", function () { return $365c1101de59193c$export$4fba683129f6ab1e; });
$parcel$export(module.exports, "default", function () { return $365c1101de59193c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "useSelect", function () { return $365c1101de59193c$export$e64b2f635402ca43; });
$parcel$export(module.exports, "useCombobox", function () { return $365c1101de59193c$export$7a023a466c03eb3d; });
$parcel$export(module.exports, "useMultipleSelection", function () { return $365c1101de59193c$export$134e7e7faed1473a; });

var $50biD = parcelRequire("50biD");

var $dBd5b = parcelRequire("dBd5b");

var $aw3S5 = parcelRequire("aw3S5");

var $2ogmM = parcelRequire("2ogmM");

var $fmSD5 = parcelRequire("fmSD5");

var $4DE7A = parcelRequire("4DE7A");

var $iI505 = parcelRequire("iI505");

var $h504q = parcelRequire("h504q");

var $eIwgG = parcelRequire("eIwgG");
var $365c1101de59193c$var$idCounter = 0;
/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */ function $365c1101de59193c$var$cbToCb(cb) {
    return typeof cb === "function" ? cb : $365c1101de59193c$var$noop;
}
function $365c1101de59193c$var$noop() {}
/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */ function $365c1101de59193c$var$scrollIntoView(node, menuNode) {
    if (!node) return;
    var actions = (0, $h504q.compute)(node, {
        boundary: menuNode,
        block: "nearest",
        scrollMode: "if-needed"
    });
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        el.scrollTop = top;
        el.scrollLeft = left;
    });
}
/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @param {Window} environment The window context where downshift renders.
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */ function $365c1101de59193c$var$isOrContainsNode(parent, child, environment) {
    var result = parent === child || child instanceof environment.Node && parent.contains && parent.contains(child);
    return result;
}
/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */ function $365c1101de59193c$var$debounce(fn, time) {
    var timeoutId;
    function cancel() {
        if (timeoutId) clearTimeout(timeoutId);
    }
    function wrapper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        cancel();
        timeoutId = setTimeout(function() {
            timeoutId = null;
            fn.apply(void 0, args);
        }, time);
    }
    wrapper.cancel = cancel;
    return wrapper;
}
/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */ function $365c1101de59193c$var$callAllEventHandlers() {
    for(var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)fns[_key2] = arguments[_key2];
    return function(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return fns.some(function(fn) {
            if (fn) fn.apply(void 0, [
                event
            ].concat(args));
            return event.preventDownshiftDefault || event.hasOwnProperty("nativeEvent") && event.nativeEvent.preventDownshiftDefault;
        });
    };
}
function $365c1101de59193c$var$handleRefs() {
    for(var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)refs[_key4] = arguments[_key4];
    return function(node) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(node);
            else if (ref) ref.current = node;
        });
    };
}
/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */ function $365c1101de59193c$var$generateId() {
    return String($365c1101de59193c$var$idCounter++);
}
/**
 * Resets idCounter to 0. Used for SSR.
 */ function $365c1101de59193c$export$4fba683129f6ab1e() {
    // istanbul ignore next
    if ("useId" in (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A)))) {
        console.warn("It is not necessary to call resetIdCounter when using React 18+");
        return;
    }
    $365c1101de59193c$var$idCounter = 0;
}
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specify if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */ function $365c1101de59193c$var$getA11yStatusMessage$1(_ref2) {
    var isOpen = _ref2.isOpen, resultCount = _ref2.resultCount, previousResultCount = _ref2.previousResultCount;
    if (!isOpen) return "";
    if (!resultCount) return "No results are available.";
    if (resultCount !== previousResultCount) return resultCount + " result" + (resultCount === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select.";
    return "";
}
/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */ function $365c1101de59193c$var$unwrapArray(arg, defaultValue) {
    arg = Array.isArray(arg) ? /* istanbul ignore next (preact) */ arg[0] : arg;
    if (!arg && defaultValue) return defaultValue;
    else return arg;
}
/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */ function $365c1101de59193c$var$isDOMElement(element) {
    // then we assume this is react
    return typeof element.type === "string";
}
/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */ function $365c1101de59193c$var$getElementProps(element) {
    return element.props;
}
/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */ function $365c1101de59193c$var$requiredProp(fnName, propName) {
    // eslint-disable-next-line no-console
    console.error('The property "' + propName + '" is required in "' + fnName + '"');
}
var $365c1101de59193c$var$stateKeys = [
    "highlightedIndex",
    "inputValue",
    "isOpen",
    "selectedItem",
    "type"
];
/**
 * @param {Object} state the state object
 * @return {Object} state that is relevant to downshift
 */ function $365c1101de59193c$var$pickState(state) {
    if (state === void 0) state = {};
    var result = {};
    $365c1101de59193c$var$stateKeys.forEach(function(k) {
        if (state.hasOwnProperty(k)) result[k] = state[k];
    });
    return result;
}
/**
 * This will perform a shallow merge of the given state object
 * with the state coming from props
 * (for the controlled component scenario)
 * This is used in state updater functions so they're referencing
 * the right state regardless of where it comes from.
 *
 * @param {Object} state The state of the component/hook.
 * @param {Object} props The props that may contain controlled values.
 * @returns {Object} The merged controlled state.
 */ function $365c1101de59193c$var$getState(state, props) {
    return Object.keys(state).reduce(function(prevState, key) {
        prevState[key] = $365c1101de59193c$var$isControlledProp(props, key) ? props[key] : state[key];
        return prevState;
    }, {});
}
/**
 * This determines whether a prop is a "controlled prop" meaning it is
 * state which is controlled by the outside of this component rather
 * than within this component.
 *
 * @param {Object} props The props that may contain controlled values.
 * @param {String} key the key to check
 * @return {Boolean} whether it is a controlled controlled prop
 */ function $365c1101de59193c$var$isControlledProp(props, key) {
    return props[key] !== undefined;
}
/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */ function $365c1101de59193c$var$normalizeArrowKey(event) {
    var key = event.key, keyCode = event.keyCode;
    /* istanbul ignore next (ie) */ if (keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0) return "Arrow" + key;
    return key;
}
/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */ function $365c1101de59193c$var$isPlainObject(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}
/**
 * Returns the next non-disabled highlightedIndex value.
 *
 * @param {number} start The current highlightedIndex.
 * @param {number} offset The offset from the current highlightedIndex to start searching.
 * @param {unknown[]} items The items array.
 * @param {(item: unknown, index: number) => boolean} isItemDisabled Function that tells if an item is disabled or not.
 * @param {boolean?} circular If the search reaches the end, if it can search again starting from the other end.
 * @returns {number} The next highlightedIndex.
 */ function $365c1101de59193c$var$getHighlightedIndex(start, offset, items, isItemDisabled, circular) {
    if (circular === void 0) circular = false;
    var count = items.length;
    if (count === 0) return -1;
    var itemsLastIndex = count - 1;
    if (typeof start !== "number" || start < 0 || start > itemsLastIndex) start = offset > 0 ? -1 : itemsLastIndex + 1;
    var current = start + offset;
    if (current < 0) current = circular ? itemsLastIndex : 0;
    else if (current > itemsLastIndex) current = circular ? 0 : itemsLastIndex;
    var highlightedIndex = $365c1101de59193c$var$getNonDisabledIndex(current, offset < 0, items, isItemDisabled, circular);
    if (highlightedIndex === -1) return start >= count ? -1 : start;
    return highlightedIndex;
}
/**
 * Returns the next non-disabled highlightedIndex value.
 *
 * @param {number} start The current highlightedIndex.
 * @param {boolean} backwards If true, it will search backwards from the start.
 * @param {unknown[]} items The items array.
 * @param {(item: unknown, index: number) => boolean} isItemDisabled Function that tells if an item is disabled or not.
 * @param {boolean} circular If the search reaches the end, if it can search again starting from the other end.
 * @returns {number} The next non-disabled index.
 */ function $365c1101de59193c$var$getNonDisabledIndex(start, backwards, items, isItemDisabled, circular) {
    if (circular === void 0) circular = false;
    var count = items.length;
    if (backwards) for(var index = start; index >= 0; index--){
        if (!isItemDisabled(items[index], index)) return index;
    }
    else for(var _index = start; _index < count; _index++){
        if (!isItemDisabled(items[_index], _index)) return _index;
    }
    if (circular) return $365c1101de59193c$var$getNonDisabledIndex(backwards ? count - 1 : 0, backwards, items, isItemDisabled);
    return -1;
}
/**
 * Checks if event target is within the downshift elements.
 *
 * @param {EventTarget} target Target to check.
 * @param {HTMLElement[]} downshiftElements The elements that form downshift (list, toggle button etc).
 * @param {Window} environment The window context where downshift renders.
 * @param {boolean} checkActiveElement Whether to also check activeElement.
 *
 * @returns {boolean} Whether or not the target is within downshift elements.
 */ function $365c1101de59193c$var$targetWithinDownshift(target, downshiftElements, environment, checkActiveElement) {
    if (checkActiveElement === void 0) checkActiveElement = true;
    return environment && downshiftElements.some(function(contextNode) {
        return contextNode && ($365c1101de59193c$var$isOrContainsNode(contextNode, target, environment) || checkActiveElement && $365c1101de59193c$var$isOrContainsNode(contextNode, environment.document.activeElement, environment));
    });
}
// eslint-disable-next-line import/no-mutable-exports
var $365c1101de59193c$var$validateControlledUnchanged = $365c1101de59193c$var$noop;
var $365c1101de59193c$var$cleanupStatus = $365c1101de59193c$var$debounce(function(documentProp) {
    $365c1101de59193c$var$getStatusDiv(documentProp).textContent = "";
}, 500);
/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */ function $365c1101de59193c$var$getStatusDiv(documentProp) {
    var statusDiv = documentProp.getElementById("a11y-status-message");
    if (statusDiv) return statusDiv;
    statusDiv = documentProp.createElement("div");
    statusDiv.setAttribute("id", "a11y-status-message");
    statusDiv.setAttribute("role", "status");
    statusDiv.setAttribute("aria-live", "polite");
    statusDiv.setAttribute("aria-relevant", "additions text");
    Object.assign(statusDiv.style, {
        border: "0",
        clip: "rect(0 0 0 0)",
        height: "1px",
        margin: "-1px",
        overflow: "hidden",
        padding: "0",
        position: "absolute",
        width: "1px"
    });
    documentProp.body.appendChild(statusDiv);
    return statusDiv;
}
/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */ function $365c1101de59193c$var$setStatus(status, documentProp) {
    if (!status || !documentProp) return;
    var div = $365c1101de59193c$var$getStatusDiv(documentProp);
    div.textContent = status;
    $365c1101de59193c$var$cleanupStatus(documentProp);
}
var $365c1101de59193c$var$unknown = 0;
var $365c1101de59193c$var$mouseUp = 1;
var $365c1101de59193c$var$itemMouseEnter = 2;
var $365c1101de59193c$var$keyDownArrowUp = 3;
var $365c1101de59193c$var$keyDownArrowDown = 4;
var $365c1101de59193c$var$keyDownEscape = 5;
var $365c1101de59193c$var$keyDownEnter = 6;
var $365c1101de59193c$var$keyDownHome = 7;
var $365c1101de59193c$var$keyDownEnd = 8;
var $365c1101de59193c$var$clickItem = 9;
var $365c1101de59193c$var$blurInput = 10;
var $365c1101de59193c$var$changeInput = 11;
var $365c1101de59193c$var$keyDownSpaceButton = 12;
var $365c1101de59193c$var$clickButton = 13;
var $365c1101de59193c$var$blurButton = 14;
var $365c1101de59193c$var$controlledPropUpdatedSelectedItem = 15;
var $365c1101de59193c$var$touchEnd = 16;
var $365c1101de59193c$var$stateChangeTypes$3 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    unknown: $365c1101de59193c$var$unknown,
    mouseUp: $365c1101de59193c$var$mouseUp,
    itemMouseEnter: $365c1101de59193c$var$itemMouseEnter,
    keyDownArrowUp: $365c1101de59193c$var$keyDownArrowUp,
    keyDownArrowDown: $365c1101de59193c$var$keyDownArrowDown,
    keyDownEscape: $365c1101de59193c$var$keyDownEscape,
    keyDownEnter: $365c1101de59193c$var$keyDownEnter,
    keyDownHome: $365c1101de59193c$var$keyDownHome,
    keyDownEnd: $365c1101de59193c$var$keyDownEnd,
    clickItem: $365c1101de59193c$var$clickItem,
    blurInput: $365c1101de59193c$var$blurInput,
    changeInput: $365c1101de59193c$var$changeInput,
    keyDownSpaceButton: $365c1101de59193c$var$keyDownSpaceButton,
    clickButton: $365c1101de59193c$var$clickButton,
    blurButton: $365c1101de59193c$var$blurButton,
    controlledPropUpdatedSelectedItem: $365c1101de59193c$var$controlledPropUpdatedSelectedItem,
    touchEnd: $365c1101de59193c$var$touchEnd
});
var $365c1101de59193c$var$_excluded$4 = [
    "refKey",
    "ref"
], $365c1101de59193c$var$_excluded2$3 = [
    "onClick",
    "onPress",
    "onKeyDown",
    "onKeyUp",
    "onBlur"
], $365c1101de59193c$var$_excluded3$2 = [
    "onKeyDown",
    "onBlur",
    "onChange",
    "onInput",
    "onChangeText"
], $365c1101de59193c$var$_excluded4$1 = [
    "refKey",
    "ref"
], $365c1101de59193c$var$_excluded5 = [
    "onMouseMove",
    "onMouseDown",
    "onClick",
    "onPress",
    "index",
    "item"
];
var $365c1101de59193c$var$Downshift = /*#__PURE__*/ function() {
    var Downshift = /*#__PURE__*/ function(_Component) {
        (0, $2ogmM.default)(Downshift, _Component);
        function Downshift(_props) {
            var _this;
            _this = _Component.call(this, _props) || this;
            // fancy destructuring + defaults + aliases
            // this basically says each value of state should either be set to
            // the initial value or the default value if the initial value is not provided
            _this.id = _this.props.id || "downshift-" + $365c1101de59193c$var$generateId();
            _this.menuId = _this.props.menuId || _this.id + "-menu";
            _this.labelId = _this.props.labelId || _this.id + "-label";
            _this.inputId = _this.props.inputId || _this.id + "-input";
            _this.getItemId = _this.props.getItemId || function(index) {
                return _this.id + "-item-" + index;
            };
            _this.items = [];
            // itemCount can be changed asynchronously
            // from within downshift (so it can't come from a prop)
            // this is why we store it as an instance and use
            // getItemCount rather than just use items.length
            // (to support windowing + async)
            _this.itemCount = null;
            _this.previousResultCount = 0;
            _this.timeoutIds = [];
            /**
       * @param {Function} fn the function to call after the time
       * @param {Number} time the time to wait
       */ _this.internalSetTimeout = function(fn, time) {
                var id = setTimeout(function() {
                    _this.timeoutIds = _this.timeoutIds.filter(function(i) {
                        return i !== id;
                    });
                    fn();
                }, time);
                _this.timeoutIds.push(id);
            };
            _this.setItemCount = function(count) {
                _this.itemCount = count;
            };
            _this.unsetItemCount = function() {
                _this.itemCount = null;
            };
            _this.isItemDisabled = function(_item, index) {
                var currentElementNode = _this.getItemNodeFromIndex(index);
                return currentElementNode && currentElementNode.hasAttribute("disabled");
            };
            _this.setHighlightedIndex = function(highlightedIndex, otherStateToSet) {
                if (highlightedIndex === void 0) highlightedIndex = _this.props.defaultHighlightedIndex;
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $365c1101de59193c$var$pickState(otherStateToSet);
                _this.internalSetState((0, $dBd5b.default)({
                    highlightedIndex: highlightedIndex
                }, otherStateToSet));
            };
            _this.clearSelection = function(cb) {
                _this.internalSetState({
                    selectedItem: null,
                    inputValue: "",
                    highlightedIndex: _this.props.defaultHighlightedIndex,
                    isOpen: _this.props.defaultIsOpen
                }, cb);
            };
            _this.selectItem = function(item, otherStateToSet, cb) {
                otherStateToSet = $365c1101de59193c$var$pickState(otherStateToSet);
                _this.internalSetState((0, $dBd5b.default)({
                    isOpen: _this.props.defaultIsOpen,
                    highlightedIndex: _this.props.defaultHighlightedIndex,
                    selectedItem: item,
                    inputValue: _this.props.itemToString(item)
                }, otherStateToSet), cb);
            };
            _this.selectItemAtIndex = function(itemIndex, otherStateToSet, cb) {
                var item = _this.items[itemIndex];
                if (item == null) return;
                _this.selectItem(item, otherStateToSet, cb);
            };
            _this.selectHighlightedItem = function(otherStateToSet, cb) {
                return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
            };
            // any piece of our state can live in two places:
            // 1. Uncontrolled: it's internal (this.state)
            //    We will call this.setState to update that state
            // 2. Controlled: it's external (this.props)
            //    We will call this.props.onStateChange to update that state
            //
            // In addition, we'll call this.props.onChange if the
            // selectedItem is changed.
            _this.internalSetState = function(stateToSet, cb) {
                var isItemSelected, onChangeArg;
                var onStateChangeArg = {};
                var isStateToSetFunction = typeof stateToSet === "function";
                // we want to call `onInputValueChange` before the `setState` call
                // so someone controlling the `inputValue` state gets notified of
                // the input change as soon as possible. This avoids issues with
                // preserving the cursor position.
                // See https://github.com/downshift-js/downshift/issues/217 for more info.
                if (!isStateToSetFunction && stateToSet.hasOwnProperty("inputValue")) _this.props.onInputValueChange(stateToSet.inputValue, (0, $dBd5b.default)({}, _this.getStateAndHelpers(), stateToSet));
                return _this.setState(function(state) {
                    var _newStateToSet;
                    state = _this.getState(state);
                    var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet;
                    // Your own function that could modify the state that will be set.
                    newStateToSet = _this.props.stateReducer(state, newStateToSet);
                    // checks if an item is selected, regardless of if it's different from
                    // what was selected before
                    // used to determine if onSelect and onChange callbacks should be called
                    isItemSelected = newStateToSet.hasOwnProperty("selectedItem");
                    // this keeps track of the object we want to call with setState
                    var nextState = {};
                    // we need to call on change if the outside world is controlling any of our state
                    // and we're trying to update that state. OR if the selection has changed and we're
                    // trying to update the selection
                    if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) onChangeArg = newStateToSet.selectedItem;
                    (_newStateToSet = newStateToSet).type || (_newStateToSet.type = $365c1101de59193c$var$unknown);
                    Object.keys(newStateToSet).forEach(function(key) {
                        // onStateChangeArg should only have the state that is
                        // actually changing
                        if (state[key] !== newStateToSet[key]) onStateChangeArg[key] = newStateToSet[key];
                        // the type is useful for the onStateChangeArg
                        // but we don't actually want to set it in internal state.
                        // this is an undocumented feature for now... Not all internalSetState
                        // calls support it and I'm not certain we want them to yet.
                        // But it enables users controlling the isOpen state to know when
                        // the isOpen state changes due to mouseup events which is quite handy.
                        if (key === "type") return;
                        newStateToSet[key];
                        // if it's coming from props, then we don't care to set it internally
                        if (!$365c1101de59193c$var$isControlledProp(_this.props, key)) nextState[key] = newStateToSet[key];
                    });
                    // if stateToSet is a function, then we weren't able to call onInputValueChange
                    // earlier, so we'll call it now that we know what the inputValue state will be.
                    if (isStateToSetFunction && newStateToSet.hasOwnProperty("inputValue")) _this.props.onInputValueChange(newStateToSet.inputValue, (0, $dBd5b.default)({}, _this.getStateAndHelpers(), newStateToSet));
                    return nextState;
                }, function() {
                    // call the provided callback if it's a function
                    $365c1101de59193c$var$cbToCb(cb)();
                    // only call the onStateChange and onChange callbacks if
                    // we have relevant information to pass them.
                    var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
                    if (hasMoreStateThanType) _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers());
                    if (isItemSelected) _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers());
                    if (onChangeArg !== undefined) _this.props.onChange(onChangeArg, _this.getStateAndHelpers());
                    // this is currently undocumented and therefore subject to change
                    // We'll try to not break it, but just be warned.
                    _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
                });
            };
            //////////////////////////// ROOT
            _this.rootRef = function(node) {
                return _this._rootNode = node;
            };
            _this.getRootProps = function(_temp, _temp2) {
                var _extends2;
                var _ref = _temp === void 0 ? {} : _temp, _ref$refKey = _ref.refKey, refKey = _ref$refKey === void 0 ? "ref" : _ref$refKey, ref = _ref.ref, rest = (0, $50biD.default)(_ref, $365c1101de59193c$var$_excluded$4);
                var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$suppressRefErro = _ref2.suppressRefError, suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
                // this is used in the render to know whether the user has called getRootProps.
                // It uses that to know whether to apply the props automatically
                _this.getRootProps.called = true;
                _this.getRootProps.refKey = refKey;
                _this.getRootProps.suppressRefError = suppressRefError;
                var _this$getState = _this.getState(), isOpen = _this$getState.isOpen;
                return (0, $dBd5b.default)((_extends2 = {}, _extends2[refKey] = $365c1101de59193c$var$handleRefs(ref, _this.rootRef), _extends2.role = "combobox", _extends2["aria-expanded"] = isOpen, _extends2["aria-haspopup"] = "listbox", _extends2["aria-owns"] = isOpen ? _this.menuId : undefined, _extends2["aria-labelledby"] = _this.labelId, _extends2), rest);
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\ ROOT
            _this.keyDownHandlers = {
                ArrowDown: function ArrowDown(event) {
                    var _this2 = this;
                    event.preventDefault();
                    if (this.getState().isOpen) {
                        var amount = event.shiftKey ? 5 : 1;
                        this.moveHighlightedIndex(amount, {
                            type: $365c1101de59193c$var$keyDownArrowDown
                        });
                    } else this.internalSetState({
                        isOpen: true,
                        type: $365c1101de59193c$var$keyDownArrowDown
                    }, function() {
                        var itemCount = _this2.getItemCount();
                        if (itemCount > 0) {
                            var _this2$getState = _this2.getState(), highlightedIndex = _this2$getState.highlightedIndex;
                            var nextHighlightedIndex = $365c1101de59193c$var$getHighlightedIndex(highlightedIndex, 1, {
                                length: itemCount
                            }, _this2.isItemDisabled, true);
                            _this2.setHighlightedIndex(nextHighlightedIndex, {
                                type: $365c1101de59193c$var$keyDownArrowDown
                            });
                        }
                    });
                },
                ArrowUp: function ArrowUp(event) {
                    var _this3 = this;
                    event.preventDefault();
                    if (this.getState().isOpen) {
                        var amount = event.shiftKey ? -5 : -1;
                        this.moveHighlightedIndex(amount, {
                            type: $365c1101de59193c$var$keyDownArrowUp
                        });
                    } else this.internalSetState({
                        isOpen: true,
                        type: $365c1101de59193c$var$keyDownArrowUp
                    }, function() {
                        var itemCount = _this3.getItemCount();
                        if (itemCount > 0) {
                            var _this3$getState = _this3.getState(), highlightedIndex = _this3$getState.highlightedIndex;
                            var nextHighlightedIndex = $365c1101de59193c$var$getHighlightedIndex(highlightedIndex, -1, {
                                length: itemCount
                            }, _this3.isItemDisabled, true);
                            _this3.setHighlightedIndex(nextHighlightedIndex, {
                                type: $365c1101de59193c$var$keyDownArrowUp
                            });
                        }
                    });
                },
                Enter: function Enter(event) {
                    if (event.which === 229) return;
                    var _this$getState2 = this.getState(), isOpen = _this$getState2.isOpen, highlightedIndex = _this$getState2.highlightedIndex;
                    if (isOpen && highlightedIndex != null) {
                        event.preventDefault();
                        var item = this.items[highlightedIndex];
                        var itemNode = this.getItemNodeFromIndex(highlightedIndex);
                        if (item == null || itemNode && itemNode.hasAttribute("disabled")) return;
                        this.selectHighlightedItem({
                            type: $365c1101de59193c$var$keyDownEnter
                        });
                    }
                },
                Escape: function Escape(event) {
                    event.preventDefault();
                    this.reset((0, $dBd5b.default)({
                        type: $365c1101de59193c$var$keyDownEscape
                    }, !this.state.isOpen && {
                        selectedItem: null,
                        inputValue: ""
                    }));
                }
            };
            //////////////////////////// BUTTON
            _this.buttonKeyDownHandlers = (0, $dBd5b.default)({}, _this.keyDownHandlers, {
                " ": function _(event) {
                    event.preventDefault();
                    this.toggleMenu({
                        type: $365c1101de59193c$var$keyDownSpaceButton
                    });
                }
            });
            _this.inputKeyDownHandlers = (0, $dBd5b.default)({}, _this.keyDownHandlers, {
                Home: function Home(event) {
                    var _this$getState3 = this.getState(), isOpen = _this$getState3.isOpen;
                    if (!isOpen) return;
                    event.preventDefault();
                    var itemCount = this.getItemCount();
                    if (itemCount <= 0 || !isOpen) return;
                    // get next non-disabled starting downwards from 0 if that's disabled.
                    var newHighlightedIndex = $365c1101de59193c$var$getNonDisabledIndex(0, false, {
                        length: itemCount
                    }, this.isItemDisabled);
                    this.setHighlightedIndex(newHighlightedIndex, {
                        type: $365c1101de59193c$var$keyDownHome
                    });
                },
                End: function End(event) {
                    var _this$getState4 = this.getState(), isOpen = _this$getState4.isOpen;
                    if (!isOpen) return;
                    event.preventDefault();
                    var itemCount = this.getItemCount();
                    if (itemCount <= 0 || !isOpen) return;
                    // get next non-disabled starting upwards from last index if that's disabled.
                    var newHighlightedIndex = $365c1101de59193c$var$getNonDisabledIndex(itemCount - 1, true, {
                        length: itemCount
                    }, this.isItemDisabled);
                    this.setHighlightedIndex(newHighlightedIndex, {
                        type: $365c1101de59193c$var$keyDownEnd
                    });
                }
            });
            _this.getToggleButtonProps = function(_temp3) {
                var _ref3 = _temp3 === void 0 ? {} : _temp3, onClick = _ref3.onClick;
                _ref3.onPress;
                var onKeyDown = _ref3.onKeyDown, onKeyUp = _ref3.onKeyUp, onBlur = _ref3.onBlur, rest = (0, $50biD.default)(_ref3, $365c1101de59193c$var$_excluded2$3);
                var _this$getState5 = _this.getState(), isOpen = _this$getState5.isOpen;
                var enabledEventHandlers = {
                    onClick: $365c1101de59193c$var$callAllEventHandlers(onClick, _this.buttonHandleClick),
                    onKeyDown: $365c1101de59193c$var$callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
                    onKeyUp: $365c1101de59193c$var$callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
                    onBlur: $365c1101de59193c$var$callAllEventHandlers(onBlur, _this.buttonHandleBlur)
                };
                var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
                return (0, $dBd5b.default)({
                    type: "button",
                    role: "button",
                    "aria-label": isOpen ? "close menu" : "open menu",
                    "aria-haspopup": true,
                    "data-toggle": true
                }, eventHandlers, rest);
            };
            _this.buttonHandleKeyUp = function(event) {
                // Prevent click event from emitting in Firefox
                event.preventDefault();
            };
            _this.buttonHandleKeyDown = function(event) {
                var key = $365c1101de59193c$var$normalizeArrowKey(event);
                if (_this.buttonKeyDownHandlers[key]) _this.buttonKeyDownHandlers[key].call((0, $aw3S5.default)(_this), event);
            };
            _this.buttonHandleClick = function(event) {
                event.preventDefault();
                // handle odd case for Safari and Firefox which
                // don't give the button the focus properly.
                /* istanbul ignore if (can't reasonably test this) */ if (_this.props.environment) {
                    var _this$props$environme = _this.props.environment.document, body = _this$props$environme.body, activeElement = _this$props$environme.activeElement;
                    if (body && body === activeElement) event.target.focus();
                }
                // Ensure that toggle of menu occurs after the potential blur event in iOS
                _this.internalSetTimeout(function() {
                    return _this.toggleMenu({
                        type: $365c1101de59193c$var$clickButton
                    });
                });
            };
            _this.buttonHandleBlur = function(event) {
                var blurTarget = event.target; // Save blur target for comparison with activeElement later
                // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element
                _this.internalSetTimeout(function() {
                    if (_this.isMouseDown || !_this.props.environment) return;
                    var activeElement = _this.props.environment.document.activeElement;
                    if ((activeElement == null || activeElement.id !== _this.inputId) && activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
                    ) _this.reset({
                        type: $365c1101de59193c$var$blurButton
                    });
                });
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ BUTTON
            /////////////////////////////// LABEL
            _this.getLabelProps = function(props) {
                return (0, $dBd5b.default)({
                    htmlFor: _this.inputId,
                    id: _this.labelId
                }, props);
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ LABEL
            /////////////////////////////// INPUT
            _this.getInputProps = function(_temp4) {
                var _ref4 = _temp4 === void 0 ? {} : _temp4, onKeyDown = _ref4.onKeyDown, onBlur = _ref4.onBlur, onChange = _ref4.onChange, onInput = _ref4.onInput;
                _ref4.onChangeText;
                var rest = (0, $50biD.default)(_ref4, $365c1101de59193c$var$_excluded3$2);
                var onChangeKey;
                var eventHandlers = {};
                onChangeKey = "onChange";
                var _this$getState6 = _this.getState(), inputValue = _this$getState6.inputValue, isOpen = _this$getState6.isOpen, highlightedIndex = _this$getState6.highlightedIndex;
                if (!rest.disabled) {
                    var _eventHandlers;
                    eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = $365c1101de59193c$var$callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = $365c1101de59193c$var$callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = $365c1101de59193c$var$callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
                }
                return (0, $dBd5b.default)({
                    "aria-autocomplete": "list",
                    "aria-activedescendant": isOpen && typeof highlightedIndex === "number" && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : undefined,
                    "aria-controls": isOpen ? _this.menuId : undefined,
                    "aria-labelledby": rest && rest["aria-label"] ? undefined : _this.labelId,
                    // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
                    // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
                    autoComplete: "off",
                    value: inputValue,
                    id: _this.inputId
                }, eventHandlers, rest);
            };
            _this.inputHandleKeyDown = function(event) {
                var key = $365c1101de59193c$var$normalizeArrowKey(event);
                if (key && _this.inputKeyDownHandlers[key]) _this.inputKeyDownHandlers[key].call((0, $aw3S5.default)(_this), event);
            };
            _this.inputHandleChange = function(event) {
                _this.internalSetState({
                    type: $365c1101de59193c$var$changeInput,
                    isOpen: true,
                    inputValue: event.target.value,
                    highlightedIndex: _this.props.defaultHighlightedIndex
                });
            };
            _this.inputHandleBlur = function() {
                // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
                _this.internalSetTimeout(function() {
                    var _activeElement$datase;
                    if (_this.isMouseDown || !_this.props.environment) return;
                    var activeElement = _this.props.environment.document.activeElement;
                    var downshiftButtonIsActive = (activeElement == null || (_activeElement$datase = activeElement.dataset) == null ? void 0 : _activeElement$datase.toggle) && _this._rootNode && _this._rootNode.contains(activeElement);
                    if (!downshiftButtonIsActive) _this.reset({
                        type: $365c1101de59193c$var$blurInput
                    });
                });
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ INPUT
            /////////////////////////////// MENU
            _this.menuRef = function(node) {
                _this._menuNode = node;
            };
            _this.getMenuProps = function(_temp5, _temp6) {
                var _extends3;
                var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$refKey = _ref5.refKey, refKey = _ref5$refKey === void 0 ? "ref" : _ref5$refKey, ref = _ref5.ref, props = (0, $50biD.default)(_ref5, $365c1101de59193c$var$_excluded4$1);
                var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$suppressRefErro = _ref6.suppressRefError, suppressRefError = _ref6$suppressRefErro === void 0 ? false : _ref6$suppressRefErro;
                _this.getMenuProps.called = true;
                _this.getMenuProps.refKey = refKey;
                _this.getMenuProps.suppressRefError = suppressRefError;
                return (0, $dBd5b.default)((_extends3 = {}, _extends3[refKey] = $365c1101de59193c$var$handleRefs(ref, _this.menuRef), _extends3.role = "listbox", _extends3["aria-labelledby"] = props && props["aria-label"] ? undefined : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ MENU
            /////////////////////////////// ITEM
            _this.getItemProps = function(_temp7) {
                var _enabledEventHandlers;
                var _ref7 = _temp7 === void 0 ? {} : _temp7, onMouseMove = _ref7.onMouseMove, onMouseDown = _ref7.onMouseDown, onClick = _ref7.onClick;
                _ref7.onPress;
                var index = _ref7.index, _ref7$item = _ref7.item, item = _ref7$item === void 0 ? /* istanbul ignore next */ undefined : _ref7$item, rest = (0, $50biD.default)(_ref7, $365c1101de59193c$var$_excluded5);
                if (index === undefined) {
                    _this.items.push(item);
                    index = _this.items.indexOf(item);
                } else _this.items[index] = item;
                var onSelectKey = "onClick";
                var customClickHandler = onClick;
                var enabledEventHandlers = (_enabledEventHandlers = {
                    // onMouseMove is used over onMouseEnter here. onMouseMove
                    // is only triggered on actual mouse movement while onMouseEnter
                    // can fire on DOM changes, interrupting keyboard navigation
                    onMouseMove: $365c1101de59193c$var$callAllEventHandlers(onMouseMove, function() {
                        if (index === _this.getState().highlightedIndex) return;
                        _this.setHighlightedIndex(index, {
                            type: $365c1101de59193c$var$itemMouseEnter
                        });
                        // We never want to manually scroll when changing state based
                        // on `onMouseMove` because we will be moving the element out
                        // from under the user which is currently scrolling/moving the
                        // cursor
                        _this.avoidScrolling = true;
                        _this.internalSetTimeout(function() {
                            return _this.avoidScrolling = false;
                        }, 250);
                    }),
                    onMouseDown: $365c1101de59193c$var$callAllEventHandlers(onMouseDown, function(event) {
                        // This prevents the activeElement from being changed
                        // to the item so it can remain with the current activeElement
                        // which is a more common use case.
                        event.preventDefault();
                    })
                }, _enabledEventHandlers[onSelectKey] = $365c1101de59193c$var$callAllEventHandlers(customClickHandler, function() {
                    _this.selectItemAtIndex(index, {
                        type: $365c1101de59193c$var$clickItem
                    });
                }), _enabledEventHandlers);
                // Passing down the onMouseDown handler to prevent redirect
                // of the activeElement if clicking on disabled items
                var eventHandlers = rest.disabled ? {
                    onMouseDown: enabledEventHandlers.onMouseDown
                } : enabledEventHandlers;
                return (0, $dBd5b.default)({
                    id: _this.getItemId(index),
                    role: "option",
                    "aria-selected": _this.getState().highlightedIndex === index
                }, eventHandlers, rest);
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ ITEM
            _this.clearItems = function() {
                _this.items = [];
            };
            _this.reset = function(otherStateToSet, cb) {
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $365c1101de59193c$var$pickState(otherStateToSet);
                _this.internalSetState(function(_ref8) {
                    var selectedItem = _ref8.selectedItem;
                    return (0, $dBd5b.default)({
                        isOpen: _this.props.defaultIsOpen,
                        highlightedIndex: _this.props.defaultHighlightedIndex,
                        inputValue: _this.props.itemToString(selectedItem)
                    }, otherStateToSet);
                }, cb);
            };
            _this.toggleMenu = function(otherStateToSet, cb) {
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $365c1101de59193c$var$pickState(otherStateToSet);
                _this.internalSetState(function(_ref9) {
                    var isOpen = _ref9.isOpen;
                    return (0, $dBd5b.default)({
                        isOpen: !isOpen
                    }, isOpen && {
                        highlightedIndex: _this.props.defaultHighlightedIndex
                    }, otherStateToSet);
                }, function() {
                    var _this$getState7 = _this.getState(), isOpen = _this$getState7.isOpen, highlightedIndex = _this$getState7.highlightedIndex;
                    if (isOpen) {
                        if (_this.getItemCount() > 0 && typeof highlightedIndex === "number") _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
                    }
                    $365c1101de59193c$var$cbToCb(cb)();
                });
            };
            _this.openMenu = function(cb) {
                _this.internalSetState({
                    isOpen: true
                }, cb);
            };
            _this.closeMenu = function(cb) {
                _this.internalSetState({
                    isOpen: false
                }, cb);
            };
            _this.updateStatus = $365c1101de59193c$var$debounce(function() {
                var _this$props;
                if (!((_this$props = _this.props) != null && (_this$props = _this$props.environment) != null && _this$props.document)) return;
                var state = _this.getState();
                var item = _this.items[state.highlightedIndex];
                var resultCount = _this.getItemCount();
                var status = _this.props.getA11yStatusMessage((0, $dBd5b.default)({
                    itemToString: _this.props.itemToString,
                    previousResultCount: _this.previousResultCount,
                    resultCount: resultCount,
                    highlightedItem: item
                }, state));
                _this.previousResultCount = resultCount;
                $365c1101de59193c$var$setStatus(status, _this.props.environment.document);
            }, 200);
            var _this$props2 = _this.props, defaultHighlightedIndex = _this$props2.defaultHighlightedIndex, _this$props2$initialH = _this$props2.initialHighlightedIndex, _highlightedIndex = _this$props2$initialH === void 0 ? defaultHighlightedIndex : _this$props2$initialH, defaultIsOpen = _this$props2.defaultIsOpen, _this$props2$initialI = _this$props2.initialIsOpen, _isOpen = _this$props2$initialI === void 0 ? defaultIsOpen : _this$props2$initialI, _this$props2$initialI2 = _this$props2.initialInputValue, _inputValue = _this$props2$initialI2 === void 0 ? "" : _this$props2$initialI2, _this$props2$initialS = _this$props2.initialSelectedItem, _selectedItem = _this$props2$initialS === void 0 ? null : _this$props2$initialS;
            var _state = _this.getState({
                highlightedIndex: _highlightedIndex,
                isOpen: _isOpen,
                inputValue: _inputValue,
                selectedItem: _selectedItem
            });
            if (_state.selectedItem != null && _this.props.initialInputValue === undefined) _state.inputValue = _this.props.itemToString(_state.selectedItem);
            _this.state = _state;
            return _this;
        }
        var _proto = Downshift.prototype;
        /**
     * Clear all running timeouts
     */ _proto.internalClearTimeouts = function internalClearTimeouts() {
            this.timeoutIds.forEach(function(id) {
                clearTimeout(id);
            });
            this.timeoutIds = [];
        } /**
     * Gets the state based on internal state or props
     * If a state value is passed via props, then that
     * is the value given, otherwise it's retrieved from
     * stateToMerge
     *
     * @param {Object} stateToMerge defaults to this.state
     * @return {Object} the state
     */ ;
        _proto.getState = function getState$1(stateToMerge) {
            if (stateToMerge === void 0) stateToMerge = this.state;
            return $365c1101de59193c$var$getState(stateToMerge, this.props);
        };
        _proto.getItemCount = function getItemCount() {
            // things read better this way. They're in priority order:
            // 1. `this.itemCount`
            // 2. `this.props.itemCount`
            // 3. `this.items.length`
            var itemCount = this.items.length;
            if (this.itemCount != null) itemCount = this.itemCount;
            else if (this.props.itemCount !== undefined) itemCount = this.props.itemCount;
            return itemCount;
        };
        _proto.getItemNodeFromIndex = function getItemNodeFromIndex(index) {
            return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(index)) : null;
        };
        _proto.scrollHighlightedItemIntoView = function scrollHighlightedItemIntoView() {
            var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
            this.props.scrollIntoView(node, this._menuNode);
        };
        _proto.moveHighlightedIndex = function moveHighlightedIndex(amount, otherStateToSet) {
            var itemCount = this.getItemCount();
            var _this$getState8 = this.getState(), highlightedIndex = _this$getState8.highlightedIndex;
            if (itemCount > 0) {
                var nextHighlightedIndex = $365c1101de59193c$var$getHighlightedIndex(highlightedIndex, amount, {
                    length: itemCount
                }, this.isItemDisabled, true);
                this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
            }
        };
        _proto.getStateAndHelpers = function getStateAndHelpers() {
            var _this$getState9 = this.getState(), highlightedIndex = _this$getState9.highlightedIndex, inputValue = _this$getState9.inputValue, selectedItem = _this$getState9.selectedItem, isOpen = _this$getState9.isOpen;
            var itemToString = this.props.itemToString;
            var id = this.id;
            var getRootProps = this.getRootProps, getToggleButtonProps = this.getToggleButtonProps, getLabelProps = this.getLabelProps, getMenuProps = this.getMenuProps, getInputProps = this.getInputProps, getItemProps = this.getItemProps, openMenu = this.openMenu, closeMenu = this.closeMenu, toggleMenu = this.toggleMenu, selectItem = this.selectItem, selectItemAtIndex = this.selectItemAtIndex, selectHighlightedItem = this.selectHighlightedItem, setHighlightedIndex = this.setHighlightedIndex, clearSelection = this.clearSelection, clearItems = this.clearItems, reset = this.reset, setItemCount = this.setItemCount, unsetItemCount = this.unsetItemCount, setState = this.internalSetState;
            return {
                // prop getters
                getRootProps: getRootProps,
                getToggleButtonProps: getToggleButtonProps,
                getLabelProps: getLabelProps,
                getMenuProps: getMenuProps,
                getInputProps: getInputProps,
                getItemProps: getItemProps,
                // actions
                reset: reset,
                openMenu: openMenu,
                closeMenu: closeMenu,
                toggleMenu: toggleMenu,
                selectItem: selectItem,
                selectItemAtIndex: selectItemAtIndex,
                selectHighlightedItem: selectHighlightedItem,
                setHighlightedIndex: setHighlightedIndex,
                clearSelection: clearSelection,
                clearItems: clearItems,
                setItemCount: setItemCount,
                unsetItemCount: unsetItemCount,
                setState: setState,
                // props
                itemToString: itemToString,
                // derived
                id: id,
                // state
                highlightedIndex: highlightedIndex,
                inputValue: inputValue,
                isOpen: isOpen,
                selectedItem: selectedItem
            };
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this4 = this;
            /* istanbul ignore if (react-native or SSR) */ if (!this.props.environment) this.cleanup = function() {
                _this4.internalClearTimeouts();
            };
            else {
                // this.isMouseDown helps us track whether the mouse is currently held down.
                // This is useful when the user clicks on an item in the list, but holds the mouse
                // down long enough for the list to disappear (because the blur event fires on the input)
                // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
                // trigger hiding the menu.
                var onMouseDown = function onMouseDown() {
                    _this4.isMouseDown = true;
                };
                var onMouseUp = function onMouseUp(event) {
                    _this4.isMouseDown = false;
                    // if the target element or the activeElement is within a downshift node
                    // then we don't want to reset downshift
                    var contextWithinDownshift = $365c1101de59193c$var$targetWithinDownshift(event.target, [
                        _this4._rootNode,
                        _this4._menuNode
                    ], _this4.props.environment);
                    if (!contextWithinDownshift && _this4.getState().isOpen) _this4.reset({
                        type: $365c1101de59193c$var$mouseUp
                    }, function() {
                        return _this4.props.onOuterClick(_this4.getStateAndHelpers());
                    });
                };
                // Touching an element in iOS gives focus and hover states, but touching out of
                // the element will remove hover, and persist the focus state, resulting in the
                // blur event not being triggered.
                // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
                // If the user taps outside of Downshift, the component should be reset,
                // but not if the user is swiping
                var onTouchStart = function onTouchStart() {
                    _this4.isTouchMove = false;
                };
                var onTouchMove = function onTouchMove() {
                    _this4.isTouchMove = true;
                };
                var onTouchEnd = function onTouchEnd(event) {
                    var contextWithinDownshift = $365c1101de59193c$var$targetWithinDownshift(event.target, [
                        _this4._rootNode,
                        _this4._menuNode
                    ], _this4.props.environment, false);
                    if (!_this4.isTouchMove && !contextWithinDownshift && _this4.getState().isOpen) _this4.reset({
                        type: $365c1101de59193c$var$touchEnd
                    }, function() {
                        return _this4.props.onOuterClick(_this4.getStateAndHelpers());
                    });
                };
                var environment = this.props.environment;
                environment.addEventListener("mousedown", onMouseDown);
                environment.addEventListener("mouseup", onMouseUp);
                environment.addEventListener("touchstart", onTouchStart);
                environment.addEventListener("touchmove", onTouchMove);
                environment.addEventListener("touchend", onTouchEnd);
                this.cleanup = function() {
                    _this4.internalClearTimeouts();
                    _this4.updateStatus.cancel();
                    environment.removeEventListener("mousedown", onMouseDown);
                    environment.removeEventListener("mouseup", onMouseUp);
                    environment.removeEventListener("touchstart", onTouchStart);
                    environment.removeEventListener("touchmove", onTouchMove);
                    environment.removeEventListener("touchend", onTouchEnd);
                };
            }
        };
        _proto.shouldScroll = function shouldScroll(prevState, prevProps) {
            var _ref10 = this.props.highlightedIndex === undefined ? this.getState() : this.props, currentHighlightedIndex = _ref10.highlightedIndex;
            var _ref11 = prevProps.highlightedIndex === undefined ? prevState : prevProps, prevHighlightedIndex = _ref11.highlightedIndex;
            var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
            var scrollWhenNavigating = currentHighlightedIndex !== prevHighlightedIndex;
            return scrollWhenOpen || scrollWhenNavigating;
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($365c1101de59193c$var$isControlledProp(this.props, "selectedItem") && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) this.internalSetState({
                type: $365c1101de59193c$var$controlledPropUpdatedSelectedItem,
                inputValue: this.props.itemToString(this.props.selectedItem)
            });
            if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) this.scrollHighlightedItemIntoView();
            this.updateStatus();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.cleanup(); // avoids memory leak
        };
        _proto.render = function render() {
            var children = $365c1101de59193c$var$unwrapArray(this.props.children, $365c1101de59193c$var$noop);
            // because the items are rerendered every time we call the children
            // we clear this out each render and it will be populated again as
            // getItemProps is called.
            this.clearItems();
            // we reset this so we know whether the user calls getRootProps during
            // this render. If they do then we don't need to do anything,
            // if they don't then we need to clone the element they return and
            // apply the props for them.
            this.getRootProps.called = false;
            this.getRootProps.refKey = undefined;
            this.getRootProps.suppressRefError = undefined;
            // we do something similar for getMenuProps
            this.getMenuProps.called = false;
            this.getMenuProps.refKey = undefined;
            this.getMenuProps.suppressRefError = undefined;
            // we do something similar for getLabelProps
            this.getLabelProps.called = false;
            // and something similar for getInputProps
            this.getInputProps.called = false;
            var element = $365c1101de59193c$var$unwrapArray(children(this.getStateAndHelpers()));
            if (!element) return null;
            if (this.getRootProps.called || this.props.suppressRefError) return element;
            else if ($365c1101de59193c$var$isDOMElement(element)) // they didn't apply the root props, but we can clone
            // this and apply the props ourselves
            return /*#__PURE__*/ (0, $4DE7A.cloneElement)(element, this.getRootProps($365c1101de59193c$var$getElementProps(element)));
            /* istanbul ignore next */ return undefined;
        };
        return Downshift;
    }((0, $4DE7A.Component));
    Downshift.defaultProps = {
        defaultHighlightedIndex: null,
        defaultIsOpen: false,
        getA11yStatusMessage: $365c1101de59193c$var$getA11yStatusMessage$1,
        itemToString: function itemToString(i) {
            if (i == null) return "";
            return String(i);
        },
        onStateChange: $365c1101de59193c$var$noop,
        onInputValueChange: $365c1101de59193c$var$noop,
        onUserAction: $365c1101de59193c$var$noop,
        onChange: $365c1101de59193c$var$noop,
        onSelect: $365c1101de59193c$var$noop,
        onOuterClick: $365c1101de59193c$var$noop,
        selectedItemChanged: function selectedItemChanged(prevItem, item) {
            return prevItem !== item;
        },
        environment: /* istanbul ignore next (ssr) */ typeof window === "undefined" || false ? undefined : window,
        stateReducer: function stateReducer(state, stateToSet) {
            return stateToSet;
        },
        suppressRefError: false,
        scrollIntoView: $365c1101de59193c$var$scrollIntoView
    };
    Downshift.stateChangeTypes = $365c1101de59193c$var$stateChangeTypes$3;
    return Downshift;
}();
var $365c1101de59193c$export$2e2bcd8739ae039 = $365c1101de59193c$var$Downshift;
function $365c1101de59193c$var$validateGetMenuPropsCalledCorrectly(node, _ref12) {
    var refKey = _ref12.refKey;
    if (!node) // eslint-disable-next-line no-console
    console.error('downshift: The ref prop "' + refKey + '" from getMenuProps was not applied correctly on your menu element.');
}
function $365c1101de59193c$var$validateGetRootPropsCalledCorrectly(element, _ref13) {
    var refKey = _ref13.refKey;
    var refKeySpecified = refKey !== "ref";
    var isComposite = !$365c1101de59193c$var$isDOMElement(element);
    if (isComposite && !refKeySpecified && !(0, $iI505.isForwardRef)(element)) // eslint-disable-next-line no-console
    console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps");
    else if (!isComposite && refKeySpecified) // eslint-disable-next-line no-console
    console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + refKey + '"');
    if (!(0, $iI505.isForwardRef)(element) && !$365c1101de59193c$var$getElementProps(element)[refKey]) // eslint-disable-next-line no-console
    console.error('downshift: You must apply the ref prop "' + refKey + '" from getRootProps onto your root element.');
}
var $365c1101de59193c$var$_excluded$3 = [
    "isInitialMount",
    "highlightedIndex",
    "items",
    "environment"
];
var $365c1101de59193c$var$dropdownDefaultStateValues = {
    highlightedIndex: -1,
    isOpen: false,
    selectedItem: null,
    inputValue: ""
};
function $365c1101de59193c$var$callOnChangeProps(action, state, newState) {
    var props = action.props, type = action.type;
    var changes = {};
    Object.keys(state).forEach(function(key) {
        $365c1101de59193c$var$invokeOnChangeHandler(key, action, state, newState);
        if (newState[key] !== state[key]) changes[key] = newState[key];
    });
    if (props.onStateChange && Object.keys(changes).length) props.onStateChange((0, $dBd5b.default)({
        type: type
    }, changes));
}
function $365c1101de59193c$var$invokeOnChangeHandler(key, action, state, newState) {
    var props = action.props, type = action.type;
    var handler = "on" + $365c1101de59193c$var$capitalizeString(key) + "Change";
    if (props[handler] && newState[key] !== undefined && newState[key] !== state[key]) props[handler]((0, $dBd5b.default)({
        type: type
    }, newState));
}
/**
 * Default state reducer that returns the changes.
 *
 * @param {Object} s state.
 * @param {Object} a action with changes.
 * @returns {Object} changes.
 */ function $365c1101de59193c$var$stateReducer(s, a) {
    return a.changes;
}
/**
 * Returns a message to be added to aria-live region when item is selected.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */ function $365c1101de59193c$var$getA11ySelectionMessage(selectionParameters) {
    var selectedItem = selectionParameters.selectedItem, itemToStringLocal = selectionParameters.itemToString;
    return selectedItem ? itemToStringLocal(selectedItem) + " has been selected." : "";
}
/**
 * Debounced call for updating the a11y message.
 */ var $365c1101de59193c$var$updateA11yStatus = $365c1101de59193c$var$debounce(function(getA11yMessage, document) {
    $365c1101de59193c$var$setStatus(getA11yMessage(), document);
}, 200);
// istanbul ignore next
var $365c1101de59193c$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $4DE7A.useLayoutEffect) : (0, $4DE7A.useEffect);
// istanbul ignore next
var $365c1101de59193c$var$useElementIds = "useId" in (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A)) // Avoid conditional useId call
) ? function useElementIds(_ref) {
    var id = _ref.id, labelId = _ref.labelId, menuId = _ref.menuId, getItemId = _ref.getItemId, toggleButtonId = _ref.toggleButtonId, inputId = _ref.inputId;
    // Avoid conditional useId call
    var reactId = "downshift-" + (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useId();
    if (!id) id = reactId;
    var elementIdsRef = (0, $4DE7A.useRef)({
        labelId: labelId || id + "-label",
        menuId: menuId || id + "-menu",
        getItemId: getItemId || function(index) {
            return id + "-item-" + index;
        },
        toggleButtonId: toggleButtonId || id + "-toggle-button",
        inputId: inputId || id + "-input"
    });
    return elementIdsRef.current;
} : function useElementIds(_ref2) {
    var _ref2$id = _ref2.id, id = _ref2$id === void 0 ? "downshift-" + $365c1101de59193c$var$generateId() : _ref2$id, labelId = _ref2.labelId, menuId = _ref2.menuId, getItemId = _ref2.getItemId, toggleButtonId = _ref2.toggleButtonId, inputId = _ref2.inputId;
    var elementIdsRef = (0, $4DE7A.useRef)({
        labelId: labelId || id + "-label",
        menuId: menuId || id + "-menu",
        getItemId: getItemId || function(index) {
            return id + "-item-" + index;
        },
        toggleButtonId: toggleButtonId || id + "-toggle-button",
        inputId: inputId || id + "-input"
    });
    return elementIdsRef.current;
};
function $365c1101de59193c$var$getItemAndIndex(itemProp, indexProp, items, errorMessage) {
    var item, index;
    if (itemProp === undefined) {
        if (indexProp === undefined) throw new Error(errorMessage);
        item = items[indexProp];
        index = indexProp;
    } else {
        index = indexProp === undefined ? items.indexOf(itemProp) : indexProp;
        item = itemProp;
    }
    return [
        item,
        index
    ];
}
function $365c1101de59193c$var$itemToString(item) {
    return item ? String(item) : "";
}
function $365c1101de59193c$var$isAcceptedCharacterKey(key) {
    return /^\S{1}$/.test(key);
}
function $365c1101de59193c$var$capitalizeString(string) {
    return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}
function $365c1101de59193c$var$useLatestRef(val) {
    var ref = (0, $4DE7A.useRef)(val);
    // technically this is not "concurrent mode safe" because we're manipulating
    // the value during render (so it's not idempotent). However, the places this
    // hook is used is to support memoizing callbacks which will be called
    // *during* render, so we need the latest values *during* render.
    // If not for this, then we'd probably want to use useLayoutEffect instead.
    ref.current = val;
    return ref;
}
/**
 * Computes the controlled state using a the previous state, props,
 * two reducers, one from downshift and an optional one from the user.
 * Also calls the onChange handlers for state values that have changed.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} props The hook props, also passed to createInitialState.
 * @param {Function} createInitialState Function that returns the initial state.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $365c1101de59193c$var$useEnhancedReducer(reducer, props, createInitialState) {
    var prevStateRef = (0, $4DE7A.useRef)();
    var actionRef = (0, $4DE7A.useRef)();
    var enhancedReducer = (0, $4DE7A.useCallback)(function(state, action) {
        actionRef.current = action;
        state = $365c1101de59193c$var$getState(state, action.props);
        var changes = reducer(state, action);
        var newState = action.props.stateReducer(state, (0, $dBd5b.default)({}, action, {
            changes: changes
        }));
        return newState;
    }, [
        reducer
    ]);
    var _useReducer = (0, $4DE7A.useReducer)(enhancedReducer, props, createInitialState), state = _useReducer[0], dispatch = _useReducer[1];
    var propsRef = $365c1101de59193c$var$useLatestRef(props);
    var dispatchWithProps = (0, $4DE7A.useCallback)(function(action) {
        return dispatch((0, $dBd5b.default)({
            props: propsRef.current
        }, action));
    }, [
        propsRef
    ]);
    var action = actionRef.current;
    (0, $4DE7A.useEffect)(function() {
        if (action && prevStateRef.current && prevStateRef.current !== state) $365c1101de59193c$var$callOnChangeProps(action, $365c1101de59193c$var$getState(prevStateRef.current, action.props), state);
        prevStateRef.current = state;
    }, [
        state,
        props,
        action
    ]);
    return [
        state,
        dispatchWithProps
    ];
}
/**
 * Wraps the useEnhancedReducer and applies the controlled prop values before
 * returning the new state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} props The hook props, also passed to createInitialState.
 * @param {Function} createInitialState Function that returns the initial state.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $365c1101de59193c$var$useControlledReducer$1(reducer, props, createInitialState) {
    var _useEnhancedReducer = $365c1101de59193c$var$useEnhancedReducer(reducer, props, createInitialState), state = _useEnhancedReducer[0], dispatch = _useEnhancedReducer[1];
    return [
        $365c1101de59193c$var$getState(state, props),
        dispatch
    ];
}
var $365c1101de59193c$var$defaultProps$3 = {
    itemToString: $365c1101de59193c$var$itemToString,
    stateReducer: $365c1101de59193c$var$stateReducer,
    getA11ySelectionMessage: $365c1101de59193c$var$getA11ySelectionMessage,
    scrollIntoView: $365c1101de59193c$var$scrollIntoView,
    environment: /* istanbul ignore next (ssr) */ typeof window === "undefined" || false ? undefined : window
};
function $365c1101de59193c$var$getDefaultValue$1(props, propKey, defaultStateValues) {
    if (defaultStateValues === void 0) defaultStateValues = $365c1101de59193c$var$dropdownDefaultStateValues;
    var defaultValue = props["default" + $365c1101de59193c$var$capitalizeString(propKey)];
    if (defaultValue !== undefined) return defaultValue;
    return defaultStateValues[propKey];
}
function $365c1101de59193c$var$getInitialValue$1(props, propKey, defaultStateValues) {
    if (defaultStateValues === void 0) defaultStateValues = $365c1101de59193c$var$dropdownDefaultStateValues;
    var value = props[propKey];
    if (value !== undefined) return value;
    var initialValue = props["initial" + $365c1101de59193c$var$capitalizeString(propKey)];
    if (initialValue !== undefined) return initialValue;
    return $365c1101de59193c$var$getDefaultValue$1(props, propKey, defaultStateValues);
}
function $365c1101de59193c$var$getInitialState$2(props) {
    var selectedItem = $365c1101de59193c$var$getInitialValue$1(props, "selectedItem");
    var isOpen = $365c1101de59193c$var$getInitialValue$1(props, "isOpen");
    var highlightedIndex = $365c1101de59193c$var$getInitialValue$1(props, "highlightedIndex");
    var inputValue = $365c1101de59193c$var$getInitialValue$1(props, "inputValue");
    return {
        highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.indexOf(selectedItem) : highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
function $365c1101de59193c$var$getHighlightedIndexOnOpen(props, state, offset) {
    var items = props.items, initialHighlightedIndex = props.initialHighlightedIndex, defaultHighlightedIndex = props.defaultHighlightedIndex;
    var selectedItem = state.selectedItem, highlightedIndex = state.highlightedIndex;
    if (items.length === 0) return -1;
    // initialHighlightedIndex will give value to highlightedIndex on initial state only.
    if (initialHighlightedIndex !== undefined && highlightedIndex === initialHighlightedIndex) return initialHighlightedIndex;
    if (defaultHighlightedIndex !== undefined) return defaultHighlightedIndex;
    if (selectedItem) return items.indexOf(selectedItem);
    if (offset === 0) return -1;
    return offset < 0 ? items.length - 1 : 0;
}
/**
 * Reuse the movement tracking of mouse and touch events.
 *
 * @param {boolean} isOpen Whether the dropdown is open or not.
 * @param {Array<Object>} downshiftElementRefs Downshift element refs to track movement (toggleButton, menu etc.)
 * @param {Object} environment Environment where component/hook exists.
 * @param {Function} handleBlur Handler on blur from mouse or touch.
 * @returns {Object} Ref containing whether mouseDown or touchMove event is happening
 */ function $365c1101de59193c$var$useMouseAndTouchTracker(isOpen, downshiftElementRefs, environment, handleBlur) {
    var mouseAndTouchTrackersRef = (0, $4DE7A.useRef)({
        isMouseDown: false,
        isTouchMove: false
    });
    (0, $4DE7A.useEffect)(function() {
        if (!environment) return;
        // The same strategy for checking if a click occurred inside or outside downshift
        // as in downshift.js.
        var onMouseDown = function onMouseDown() {
            mouseAndTouchTrackersRef.current.isMouseDown = true;
        };
        var onMouseUp = function onMouseUp(event) {
            mouseAndTouchTrackersRef.current.isMouseDown = false;
            if (isOpen && !$365c1101de59193c$var$targetWithinDownshift(event.target, downshiftElementRefs.map(function(ref) {
                return ref.current;
            }), environment)) handleBlur();
        };
        var onTouchStart = function onTouchStart() {
            mouseAndTouchTrackersRef.current.isTouchMove = false;
        };
        var onTouchMove = function onTouchMove() {
            mouseAndTouchTrackersRef.current.isTouchMove = true;
        };
        var onTouchEnd = function onTouchEnd(event) {
            if (isOpen && !mouseAndTouchTrackersRef.current.isTouchMove && !$365c1101de59193c$var$targetWithinDownshift(event.target, downshiftElementRefs.map(function(ref) {
                return ref.current;
            }), environment, false)) handleBlur();
        };
        environment.addEventListener("mousedown", onMouseDown);
        environment.addEventListener("mouseup", onMouseUp);
        environment.addEventListener("touchstart", onTouchStart);
        environment.addEventListener("touchmove", onTouchMove);
        environment.addEventListener("touchend", onTouchEnd);
        // eslint-disable-next-line consistent-return
        return function cleanup() {
            environment.removeEventListener("mousedown", onMouseDown);
            environment.removeEventListener("mouseup", onMouseUp);
            environment.removeEventListener("touchstart", onTouchStart);
            environment.removeEventListener("touchmove", onTouchMove);
            environment.removeEventListener("touchend", onTouchEnd);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen,
        environment
    ]);
    return mouseAndTouchTrackersRef;
}
/* istanbul ignore next */ // eslint-disable-next-line import/no-mutable-exports
var $365c1101de59193c$var$useGetterPropsCalledChecker = function useGetterPropsCalledChecker() {
    return $365c1101de59193c$var$noop;
};
function $365c1101de59193c$var$useA11yMessageSetter(getA11yMessage, dependencyArray, _ref3) {
    var isInitialMount = _ref3.isInitialMount, highlightedIndex = _ref3.highlightedIndex, items = _ref3.items, environment = _ref3.environment, rest = (0, $50biD.default)(_ref3, $365c1101de59193c$var$_excluded$3);
    // Sets a11y status message on changes in state.
    (0, $4DE7A.useEffect)(function() {
        if (isInitialMount || false || !(environment != null && environment.document)) return;
        $365c1101de59193c$var$updateA11yStatus(function() {
            return getA11yMessage((0, $dBd5b.default)({
                highlightedIndex: highlightedIndex,
                highlightedItem: items[highlightedIndex],
                resultCount: items.length
            }, rest));
        }, environment.document);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencyArray);
}
function $365c1101de59193c$var$useScrollIntoView(_ref4) {
    var highlightedIndex = _ref4.highlightedIndex, isOpen = _ref4.isOpen, itemRefs = _ref4.itemRefs, getItemNodeFromIndex = _ref4.getItemNodeFromIndex, menuElement = _ref4.menuElement, scrollIntoViewProp = _ref4.scrollIntoView;
    // used not to scroll on highlight by mouse.
    var shouldScrollRef = (0, $4DE7A.useRef)(true);
    // Scroll on highlighted item if change comes from keyboard.
    $365c1101de59193c$var$useIsomorphicLayoutEffect(function() {
        if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) return;
        if (shouldScrollRef.current === false) shouldScrollRef.current = true;
        else scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex), menuElement);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        highlightedIndex
    ]);
    return shouldScrollRef;
}
// eslint-disable-next-line import/no-mutable-exports
var $365c1101de59193c$var$useControlPropsValidator = $365c1101de59193c$var$noop;
/**
 * Handles selection on Enter / Alt + ArrowUp. Closes the menu and resets the highlighted index, unless there is a highlighted.
 * In that case, selects the item and resets to defaults for open state and highlighted idex.
 * @param {Object} props The useCombobox props.
 * @param {number} highlightedIndex The index from the state.
 * @param {boolean} inputValue Also return the input value for state.
 * @returns The changes for the state.
 */ function $365c1101de59193c$var$getChangesOnSelection(props, highlightedIndex, inputValue) {
    var _props$items;
    if (inputValue === void 0) inputValue = true;
    var shouldSelect = ((_props$items = props.items) == null ? void 0 : _props$items.length) && highlightedIndex >= 0;
    return (0, $dBd5b.default)({
        isOpen: false,
        highlightedIndex: -1
    }, shouldSelect && (0, $dBd5b.default)({
        selectedItem: props.items[highlightedIndex],
        isOpen: $365c1101de59193c$var$getDefaultValue$1(props, "isOpen"),
        highlightedIndex: $365c1101de59193c$var$getDefaultValue$1(props, "highlightedIndex")
    }, inputValue && {
        inputValue: props.itemToString(props.items[highlightedIndex])
    }));
}
// Shared between all exports.
var $365c1101de59193c$var$commonPropTypes = {
    environment: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        addEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
        removeEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
        document: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
            createElement: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
            getElementById: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
            activeElement: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).any.isRequired,
            body: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).any.isRequired
        }).isRequired,
        Node: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired
    }),
    itemToString: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    stateReducer: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func
};
// Shared between useSelect, useCombobox, Downshift.
var $365c1101de59193c$var$commonDropdownPropTypes = (0, $dBd5b.default)({}, $365c1101de59193c$var$commonPropTypes, {
    getA11yStatusMessage: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    highlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    defaultHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    initialHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    defaultIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    initialIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    selectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).any,
    initialSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).any,
    defaultSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).any,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    labelId: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    menuId: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    getItemId: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    toggleButtonId: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    onSelectedItemChange: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    onHighlightedIndexChange: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    onIsOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    scrollIntoView: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func
});
function $365c1101de59193c$var$downshiftCommonReducer(state, action, stateChangeTypes) {
    var type = action.type, props = action.props;
    var changes;
    switch(type){
        case stateChangeTypes.ItemMouseMove:
            changes = {
                highlightedIndex: action.disabled ? -1 : action.index
            };
            break;
        case stateChangeTypes.MenuMouseLeave:
            changes = {
                highlightedIndex: -1
            };
            break;
        case stateChangeTypes.ToggleButtonClick:
        case stateChangeTypes.FunctionToggleMenu:
            changes = {
                isOpen: !state.isOpen,
                highlightedIndex: state.isOpen ? -1 : $365c1101de59193c$var$getHighlightedIndexOnOpen(props, state, 0)
            };
            break;
        case stateChangeTypes.FunctionOpenMenu:
            changes = {
                isOpen: true,
                highlightedIndex: $365c1101de59193c$var$getHighlightedIndexOnOpen(props, state, 0)
            };
            break;
        case stateChangeTypes.FunctionCloseMenu:
            changes = {
                isOpen: false
            };
            break;
        case stateChangeTypes.FunctionSetHighlightedIndex:
            changes = {
                highlightedIndex: action.highlightedIndex
            };
            break;
        case stateChangeTypes.FunctionSetInputValue:
            changes = {
                inputValue: action.inputValue
            };
            break;
        case stateChangeTypes.FunctionReset:
            changes = {
                highlightedIndex: $365c1101de59193c$var$getDefaultValue$1(props, "highlightedIndex"),
                isOpen: $365c1101de59193c$var$getDefaultValue$1(props, "isOpen"),
                selectedItem: $365c1101de59193c$var$getDefaultValue$1(props, "selectedItem"),
                inputValue: $365c1101de59193c$var$getDefaultValue$1(props, "inputValue")
            };
            break;
        default:
            throw new Error("Reducer called without proper action type.");
    }
    return (0, $dBd5b.default)({}, state, changes);
}
/* eslint-enable complexity */ function $365c1101de59193c$var$getItemIndexByCharacterKey(_a) {
    var keysSoFar = _a.keysSoFar, highlightedIndex = _a.highlightedIndex, items = _a.items, itemToString = _a.itemToString, isItemDisabled = _a.isItemDisabled;
    var lowerCasedKeysSoFar = keysSoFar.toLowerCase();
    for(var index = 0; index < items.length; index++){
        // if we already have a search query in progress, we also consider the current highlighted item.
        var offsetIndex = (index + highlightedIndex + (keysSoFar.length < 2 ? 1 : 0)) % items.length;
        var item = items[offsetIndex];
        if (item !== undefined && itemToString(item).toLowerCase().startsWith(lowerCasedKeysSoFar) && !isItemDisabled(item, offsetIndex)) return offsetIndex;
    }
    return highlightedIndex;
}
var $365c1101de59193c$var$propTypes$2 = (0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, $365c1101de59193c$var$commonDropdownPropTypes), {
    items: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).array.isRequired,
    isItemDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    getA11ySelectionMessage: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func
});
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specift if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */ function $365c1101de59193c$var$getA11yStatusMessage(_a) {
    var isOpen = _a.isOpen, resultCount = _a.resultCount, previousResultCount = _a.previousResultCount;
    if (!isOpen) return "";
    if (!resultCount) return "No results are available.";
    if (resultCount !== previousResultCount) return "".concat(resultCount, " result").concat(resultCount === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.");
    return "";
}
var $365c1101de59193c$var$defaultProps$2 = (0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, $365c1101de59193c$var$defaultProps$3), {
    getA11yStatusMessage: $365c1101de59193c$var$getA11yStatusMessage,
    isItemDisabled: function() {
        return false;
    }
});
// eslint-disable-next-line import/no-mutable-exports
var $365c1101de59193c$var$validatePropTypes$2 = $365c1101de59193c$var$noop;
var $365c1101de59193c$var$ToggleButtonClick$1 = 0;
var $365c1101de59193c$var$ToggleButtonKeyDownArrowDown = 1;
var $365c1101de59193c$var$ToggleButtonKeyDownArrowUp = 2;
var $365c1101de59193c$var$ToggleButtonKeyDownCharacter = 3;
var $365c1101de59193c$var$ToggleButtonKeyDownEscape = 4;
var $365c1101de59193c$var$ToggleButtonKeyDownHome = 5;
var $365c1101de59193c$var$ToggleButtonKeyDownEnd = 6;
var $365c1101de59193c$var$ToggleButtonKeyDownEnter = 7;
var $365c1101de59193c$var$ToggleButtonKeyDownSpaceButton = 8;
var $365c1101de59193c$var$ToggleButtonKeyDownPageUp = 9;
var $365c1101de59193c$var$ToggleButtonKeyDownPageDown = 10;
var $365c1101de59193c$var$ToggleButtonBlur = 11;
var $365c1101de59193c$var$MenuMouseLeave$1 = 12;
var $365c1101de59193c$var$ItemMouseMove$1 = 13;
var $365c1101de59193c$var$ItemClick$1 = 14;
var $365c1101de59193c$var$FunctionToggleMenu$1 = 15;
var $365c1101de59193c$var$FunctionOpenMenu$1 = 16;
var $365c1101de59193c$var$FunctionCloseMenu$1 = 17;
var $365c1101de59193c$var$FunctionSetHighlightedIndex$1 = 18;
var $365c1101de59193c$var$FunctionSelectItem$1 = 19;
var $365c1101de59193c$var$FunctionSetInputValue$1 = 20;
var $365c1101de59193c$var$FunctionReset$2 = 21;
var $365c1101de59193c$var$stateChangeTypes$2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ToggleButtonClick: $365c1101de59193c$var$ToggleButtonClick$1,
    ToggleButtonKeyDownArrowDown: $365c1101de59193c$var$ToggleButtonKeyDownArrowDown,
    ToggleButtonKeyDownArrowUp: $365c1101de59193c$var$ToggleButtonKeyDownArrowUp,
    ToggleButtonKeyDownCharacter: $365c1101de59193c$var$ToggleButtonKeyDownCharacter,
    ToggleButtonKeyDownEscape: $365c1101de59193c$var$ToggleButtonKeyDownEscape,
    ToggleButtonKeyDownHome: $365c1101de59193c$var$ToggleButtonKeyDownHome,
    ToggleButtonKeyDownEnd: $365c1101de59193c$var$ToggleButtonKeyDownEnd,
    ToggleButtonKeyDownEnter: $365c1101de59193c$var$ToggleButtonKeyDownEnter,
    ToggleButtonKeyDownSpaceButton: $365c1101de59193c$var$ToggleButtonKeyDownSpaceButton,
    ToggleButtonKeyDownPageUp: $365c1101de59193c$var$ToggleButtonKeyDownPageUp,
    ToggleButtonKeyDownPageDown: $365c1101de59193c$var$ToggleButtonKeyDownPageDown,
    ToggleButtonBlur: $365c1101de59193c$var$ToggleButtonBlur,
    MenuMouseLeave: $365c1101de59193c$var$MenuMouseLeave$1,
    ItemMouseMove: $365c1101de59193c$var$ItemMouseMove$1,
    ItemClick: $365c1101de59193c$var$ItemClick$1,
    FunctionToggleMenu: $365c1101de59193c$var$FunctionToggleMenu$1,
    FunctionOpenMenu: $365c1101de59193c$var$FunctionOpenMenu$1,
    FunctionCloseMenu: $365c1101de59193c$var$FunctionCloseMenu$1,
    FunctionSetHighlightedIndex: $365c1101de59193c$var$FunctionSetHighlightedIndex$1,
    FunctionSelectItem: $365c1101de59193c$var$FunctionSelectItem$1,
    FunctionSetInputValue: $365c1101de59193c$var$FunctionSetInputValue$1,
    FunctionReset: $365c1101de59193c$var$FunctionReset$2
});
/* eslint-disable complexity */ function $365c1101de59193c$var$downshiftSelectReducer(state, action) {
    var _props$items;
    var type = action.type, props = action.props, altKey = action.altKey;
    var changes;
    switch(type){
        case $365c1101de59193c$var$ItemClick$1:
            changes = {
                isOpen: $365c1101de59193c$var$getDefaultValue$1(props, "isOpen"),
                highlightedIndex: $365c1101de59193c$var$getDefaultValue$1(props, "highlightedIndex"),
                selectedItem: props.items[action.index]
            };
            break;
        case $365c1101de59193c$var$ToggleButtonKeyDownCharacter:
            var lowercasedKey = action.key;
            var inputValue = "" + state.inputValue + lowercasedKey;
            var prevHighlightedIndex = !state.isOpen && state.selectedItem ? props.items.indexOf(state.selectedItem) : state.highlightedIndex;
            var highlightedIndex = $365c1101de59193c$var$getItemIndexByCharacterKey({
                keysSoFar: inputValue,
                highlightedIndex: prevHighlightedIndex,
                items: props.items,
                itemToString: props.itemToString,
                isItemDisabled: props.isItemDisabled
            });
            changes = {
                inputValue: inputValue,
                highlightedIndex: highlightedIndex,
                isOpen: true
            };
            break;
        case $365c1101de59193c$var$ToggleButtonKeyDownArrowDown:
            var _highlightedIndex = state.isOpen ? $365c1101de59193c$var$getHighlightedIndex(state.highlightedIndex, 1, props.items, props.isItemDisabled) : altKey && state.selectedItem == null ? -1 : $365c1101de59193c$var$getHighlightedIndexOnOpen(props, state, 1);
            changes = {
                highlightedIndex: _highlightedIndex,
                isOpen: true
            };
            break;
        case $365c1101de59193c$var$ToggleButtonKeyDownArrowUp:
            if (state.isOpen && altKey) changes = $365c1101de59193c$var$getChangesOnSelection(props, state.highlightedIndex, false);
            else {
                var _highlightedIndex2 = state.isOpen ? $365c1101de59193c$var$getHighlightedIndex(state.highlightedIndex, -1, props.items, props.isItemDisabled) : $365c1101de59193c$var$getHighlightedIndexOnOpen(props, state, -1);
                changes = {
                    highlightedIndex: _highlightedIndex2,
                    isOpen: true
                };
            }
            break;
        // only triggered when menu is open.
        case $365c1101de59193c$var$ToggleButtonKeyDownEnter:
        case $365c1101de59193c$var$ToggleButtonKeyDownSpaceButton:
            changes = $365c1101de59193c$var$getChangesOnSelection(props, state.highlightedIndex, false);
            break;
        case $365c1101de59193c$var$ToggleButtonKeyDownHome:
            changes = {
                highlightedIndex: $365c1101de59193c$var$getNonDisabledIndex(0, false, props.items, props.isItemDisabled),
                isOpen: true
            };
            break;
        case $365c1101de59193c$var$ToggleButtonKeyDownEnd:
            changes = {
                highlightedIndex: $365c1101de59193c$var$getNonDisabledIndex(props.items.length - 1, true, props.items, props.isItemDisabled),
                isOpen: true
            };
            break;
        case $365c1101de59193c$var$ToggleButtonKeyDownPageUp:
            changes = {
                highlightedIndex: $365c1101de59193c$var$getHighlightedIndex(state.highlightedIndex, -10, props.items, props.isItemDisabled)
            };
            break;
        case $365c1101de59193c$var$ToggleButtonKeyDownPageDown:
            changes = {
                highlightedIndex: $365c1101de59193c$var$getHighlightedIndex(state.highlightedIndex, 10, props.items, props.isItemDisabled)
            };
            break;
        case $365c1101de59193c$var$ToggleButtonKeyDownEscape:
            changes = {
                isOpen: false,
                highlightedIndex: -1
            };
            break;
        case $365c1101de59193c$var$ToggleButtonBlur:
            changes = (0, $dBd5b.default)({
                isOpen: false,
                highlightedIndex: -1
            }, state.highlightedIndex >= 0 && ((_props$items = props.items) == null ? void 0 : _props$items.length) && {
                selectedItem: props.items[state.highlightedIndex]
            });
            break;
        case $365c1101de59193c$var$FunctionSelectItem$1:
            changes = {
                selectedItem: action.selectedItem
            };
            break;
        default:
            return $365c1101de59193c$var$downshiftCommonReducer(state, action, $365c1101de59193c$var$stateChangeTypes$2);
    }
    return (0, $dBd5b.default)({}, state, changes);
}
/* eslint-enable complexity */ var $365c1101de59193c$var$_excluded$2 = [
    "onMouseLeave",
    "refKey",
    "ref"
], $365c1101de59193c$var$_excluded2$2 = [
    "onBlur",
    "onClick",
    "onPress",
    "onKeyDown",
    "refKey",
    "ref"
], $365c1101de59193c$var$_excluded3$1 = [
    "item",
    "index",
    "onMouseMove",
    "onClick",
    "onMouseDown",
    "onPress",
    "refKey",
    "disabled",
    "ref"
];
$365c1101de59193c$export$e64b2f635402ca43.stateChangeTypes = $365c1101de59193c$var$stateChangeTypes$2;
function $365c1101de59193c$export$e64b2f635402ca43(userProps) {
    if (userProps === void 0) userProps = {};
    $365c1101de59193c$var$validatePropTypes$2(userProps, $365c1101de59193c$export$e64b2f635402ca43);
    // Props defaults and destructuring.
    var props = (0, $dBd5b.default)({}, $365c1101de59193c$var$defaultProps$2, userProps);
    var items = props.items, scrollIntoView = props.scrollIntoView, environment = props.environment, itemToString = props.itemToString, getA11ySelectionMessage = props.getA11ySelectionMessage, getA11yStatusMessage = props.getA11yStatusMessage;
    // Initial state depending on controlled props.
    var _useControlledReducer = $365c1101de59193c$var$useControlledReducer$1($365c1101de59193c$var$downshiftSelectReducer, props, $365c1101de59193c$var$getInitialState$2), state = _useControlledReducer[0], dispatch = _useControlledReducer[1];
    var isOpen = state.isOpen, highlightedIndex = state.highlightedIndex, selectedItem = state.selectedItem, inputValue = state.inputValue;
    // Element efs.
    var toggleButtonRef = (0, $4DE7A.useRef)(null);
    var menuRef = (0, $4DE7A.useRef)(null);
    var itemRefs = (0, $4DE7A.useRef)({});
    // used to keep the inputValue clearTimeout object between renders.
    var clearTimeoutRef = (0, $4DE7A.useRef)(null);
    // prevent id re-generation between renders.
    var elementIds = $365c1101de59193c$var$useElementIds(props);
    // used to keep track of how many items we had on previous cycle.
    var previousResultCountRef = (0, $4DE7A.useRef)();
    var isInitialMountRef = (0, $4DE7A.useRef)(true);
    // utility callback to get item element.
    var latest = $365c1101de59193c$var$useLatestRef({
        state: state,
        props: props
    });
    // Some utils.
    var getItemNodeFromIndex = (0, $4DE7A.useCallback)(function(index) {
        return itemRefs.current[elementIds.getItemId(index)];
    }, [
        elementIds
    ]);
    // Effects.
    // Sets a11y status message on changes in state.
    $365c1101de59193c$var$useA11yMessageSetter(getA11yStatusMessage, [
        isOpen,
        highlightedIndex,
        inputValue,
        items
    ], (0, $dBd5b.default)({
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString
    }, state));
    // Sets a11y status message on changes in selectedItem.
    $365c1101de59193c$var$useA11yMessageSetter(getA11ySelectionMessage, [
        selectedItem
    ], (0, $dBd5b.default)({
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString
    }, state));
    // Scroll on highlighted item if change comes from keyboard.
    var shouldScrollRef = $365c1101de59193c$var$useScrollIntoView({
        menuElement: menuRef.current,
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        itemRefs: itemRefs,
        scrollIntoView: scrollIntoView,
        getItemNodeFromIndex: getItemNodeFromIndex
    });
    // Sets cleanup for the keysSoFar callback, debounded after 500ms.
    (0, $4DE7A.useEffect)(function() {
        // init the clean function here as we need access to dispatch.
        clearTimeoutRef.current = $365c1101de59193c$var$debounce(function(outerDispatch) {
            outerDispatch({
                type: $365c1101de59193c$var$FunctionSetInputValue$1,
                inputValue: ""
            });
        }, 500);
        // Cancel any pending debounced calls on mount
        return function() {
            clearTimeoutRef.current.cancel();
        };
    }, []);
    // Invokes the keysSoFar callback set up above.
    (0, $4DE7A.useEffect)(function() {
        if (!inputValue) return;
        clearTimeoutRef.current(dispatch);
    }, [
        dispatch,
        inputValue
    ]);
    $365c1101de59193c$var$useControlPropsValidator({
        isInitialMount: isInitialMountRef.current,
        props: props,
        state: state
    });
    (0, $4DE7A.useEffect)(function() {
        if (isInitialMountRef.current) return;
        previousResultCountRef.current = items.length;
    });
    // Focus the toggle button on first render if required.
    (0, $4DE7A.useEffect)(function() {
        var focusOnOpen = $365c1101de59193c$var$getInitialValue$1(props, "isOpen");
        if (focusOnOpen && toggleButtonRef.current) toggleButtonRef.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Add mouse/touch events to document.
    var mouseAndTouchTrackersRef = $365c1101de59193c$var$useMouseAndTouchTracker(isOpen, [
        menuRef,
        toggleButtonRef
    ], environment, function() {
        dispatch({
            type: $365c1101de59193c$var$ToggleButtonBlur
        });
    });
    var setGetterPropCallInfo = $365c1101de59193c$var$useGetterPropsCalledChecker("getMenuProps", "getToggleButtonProps");
    // Make initial ref false.
    (0, $4DE7A.useEffect)(function() {
        isInitialMountRef.current = false;
        return function() {
            isInitialMountRef.current = true;
        };
    }, []);
    // Reset itemRefs on close.
    (0, $4DE7A.useEffect)(function() {
        if (!isOpen) itemRefs.current = {};
    }, [
        isOpen
    ]);
    // Event handler functions.
    var toggleButtonKeyDownHandlers = (0, $4DE7A.useMemo)(function() {
        return {
            ArrowDown: function ArrowDown(event) {
                event.preventDefault();
                dispatch({
                    type: $365c1101de59193c$var$ToggleButtonKeyDownArrowDown,
                    altKey: event.altKey
                });
            },
            ArrowUp: function ArrowUp(event) {
                event.preventDefault();
                dispatch({
                    type: $365c1101de59193c$var$ToggleButtonKeyDownArrowUp,
                    altKey: event.altKey
                });
            },
            Home: function Home(event) {
                event.preventDefault();
                dispatch({
                    type: $365c1101de59193c$var$ToggleButtonKeyDownHome
                });
            },
            End: function End(event) {
                event.preventDefault();
                dispatch({
                    type: $365c1101de59193c$var$ToggleButtonKeyDownEnd
                });
            },
            Escape: function Escape() {
                if (latest.current.state.isOpen) dispatch({
                    type: $365c1101de59193c$var$ToggleButtonKeyDownEscape
                });
            },
            Enter: function Enter(event) {
                event.preventDefault();
                dispatch({
                    type: latest.current.state.isOpen ? $365c1101de59193c$var$ToggleButtonKeyDownEnter : $365c1101de59193c$var$ToggleButtonClick$1
                });
            },
            PageUp: function PageUp(event) {
                if (latest.current.state.isOpen) {
                    event.preventDefault();
                    dispatch({
                        type: $365c1101de59193c$var$ToggleButtonKeyDownPageUp
                    });
                }
            },
            PageDown: function PageDown(event) {
                if (latest.current.state.isOpen) {
                    event.preventDefault();
                    dispatch({
                        type: $365c1101de59193c$var$ToggleButtonKeyDownPageDown
                    });
                }
            },
            " ": function _(event) {
                event.preventDefault();
                var currentState = latest.current.state;
                if (!currentState.isOpen) {
                    dispatch({
                        type: $365c1101de59193c$var$ToggleButtonClick$1
                    });
                    return;
                }
                if (currentState.inputValue) dispatch({
                    type: $365c1101de59193c$var$ToggleButtonKeyDownCharacter,
                    key: " "
                });
                else dispatch({
                    type: $365c1101de59193c$var$ToggleButtonKeyDownSpaceButton
                });
            }
        };
    }, [
        dispatch,
        latest
    ]);
    // Action functions.
    var toggleMenu = (0, $4DE7A.useCallback)(function() {
        dispatch({
            type: $365c1101de59193c$var$FunctionToggleMenu$1
        });
    }, [
        dispatch
    ]);
    var closeMenu = (0, $4DE7A.useCallback)(function() {
        dispatch({
            type: $365c1101de59193c$var$FunctionCloseMenu$1
        });
    }, [
        dispatch
    ]);
    var openMenu = (0, $4DE7A.useCallback)(function() {
        dispatch({
            type: $365c1101de59193c$var$FunctionOpenMenu$1
        });
    }, [
        dispatch
    ]);
    var setHighlightedIndex = (0, $4DE7A.useCallback)(function(newHighlightedIndex) {
        dispatch({
            type: $365c1101de59193c$var$FunctionSetHighlightedIndex$1,
            highlightedIndex: newHighlightedIndex
        });
    }, [
        dispatch
    ]);
    var selectItem = (0, $4DE7A.useCallback)(function(newSelectedItem) {
        dispatch({
            type: $365c1101de59193c$var$FunctionSelectItem$1,
            selectedItem: newSelectedItem
        });
    }, [
        dispatch
    ]);
    var reset = (0, $4DE7A.useCallback)(function() {
        dispatch({
            type: $365c1101de59193c$var$FunctionReset$2
        });
    }, [
        dispatch
    ]);
    var setInputValue = (0, $4DE7A.useCallback)(function(newInputValue) {
        dispatch({
            type: $365c1101de59193c$var$FunctionSetInputValue$1,
            inputValue: newInputValue
        });
    }, [
        dispatch
    ]);
    // Getter functions.
    var getLabelProps = (0, $4DE7A.useCallback)(function(labelProps) {
        return (0, $dBd5b.default)({
            id: elementIds.labelId,
            htmlFor: elementIds.toggleButtonId
        }, labelProps);
    }, [
        elementIds
    ]);
    var getMenuProps = (0, $4DE7A.useCallback)(function(_temp, _temp2) {
        var _extends2;
        var _ref = _temp === void 0 ? {} : _temp, onMouseLeave = _ref.onMouseLeave, _ref$refKey = _ref.refKey, refKey = _ref$refKey === void 0 ? "ref" : _ref$refKey, ref = _ref.ref, rest = (0, $50biD.default)(_ref, $365c1101de59193c$var$_excluded$2);
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$suppressRefErro = _ref2.suppressRefError, suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
        var menuHandleMouseLeave = function menuHandleMouseLeave() {
            dispatch({
                type: $365c1101de59193c$var$MenuMouseLeave$1
            });
        };
        setGetterPropCallInfo("getMenuProps", suppressRefError, refKey, menuRef);
        return (0, $dBd5b.default)((_extends2 = {}, _extends2[refKey] = $365c1101de59193c$var$handleRefs(ref, function(menuNode) {
            menuRef.current = menuNode;
        }), _extends2.id = elementIds.menuId, _extends2.role = "listbox", _extends2["aria-labelledby"] = rest && rest["aria-label"] ? undefined : "" + elementIds.labelId, _extends2.onMouseLeave = $365c1101de59193c$var$callAllEventHandlers(onMouseLeave, menuHandleMouseLeave), _extends2), rest);
    }, [
        dispatch,
        setGetterPropCallInfo,
        elementIds
    ]);
    var getToggleButtonProps = (0, $4DE7A.useCallback)(function(_temp3, _temp4) {
        var _extends3;
        var _ref3 = _temp3 === void 0 ? {} : _temp3, onBlur = _ref3.onBlur, onClick = _ref3.onClick;
        _ref3.onPress;
        var onKeyDown = _ref3.onKeyDown, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, ref = _ref3.ref, rest = (0, $50biD.default)(_ref3, $365c1101de59193c$var$_excluded2$2);
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$suppressRefErro = _ref4.suppressRefError, suppressRefError = _ref4$suppressRefErro === void 0 ? false : _ref4$suppressRefErro;
        var latestState = latest.current.state;
        var toggleButtonHandleClick = function toggleButtonHandleClick() {
            dispatch({
                type: $365c1101de59193c$var$ToggleButtonClick$1
            });
        };
        var toggleButtonHandleBlur = function toggleButtonHandleBlur() {
            if (latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown) dispatch({
                type: $365c1101de59193c$var$ToggleButtonBlur
            });
        };
        var toggleButtonHandleKeyDown = function toggleButtonHandleKeyDown(event) {
            var key = $365c1101de59193c$var$normalizeArrowKey(event);
            if (key && toggleButtonKeyDownHandlers[key]) toggleButtonKeyDownHandlers[key](event);
            else if ($365c1101de59193c$var$isAcceptedCharacterKey(key)) dispatch({
                type: $365c1101de59193c$var$ToggleButtonKeyDownCharacter,
                key: key
            });
        };
        var toggleProps = (0, $dBd5b.default)((_extends3 = {}, _extends3[refKey] = $365c1101de59193c$var$handleRefs(ref, function(toggleButtonNode) {
            toggleButtonRef.current = toggleButtonNode;
        }), _extends3["aria-activedescendant"] = latestState.isOpen && latestState.highlightedIndex > -1 ? elementIds.getItemId(latestState.highlightedIndex) : "", _extends3["aria-controls"] = elementIds.menuId, _extends3["aria-expanded"] = latest.current.state.isOpen, _extends3["aria-haspopup"] = "listbox", _extends3["aria-labelledby"] = rest && rest["aria-label"] ? undefined : "" + elementIds.labelId, _extends3.id = elementIds.toggleButtonId, _extends3.role = "combobox", _extends3.tabIndex = 0, _extends3.onBlur = $365c1101de59193c$var$callAllEventHandlers(onBlur, toggleButtonHandleBlur), _extends3), rest);
        if (!rest.disabled) {
            toggleProps.onClick = $365c1101de59193c$var$callAllEventHandlers(onClick, toggleButtonHandleClick);
            toggleProps.onKeyDown = $365c1101de59193c$var$callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
        }
        setGetterPropCallInfo("getToggleButtonProps", suppressRefError, refKey, toggleButtonRef);
        return toggleProps;
    }, [
        latest,
        elementIds,
        setGetterPropCallInfo,
        dispatch,
        mouseAndTouchTrackersRef,
        toggleButtonKeyDownHandlers
    ]);
    var getItemProps = (0, $4DE7A.useCallback)(function(_temp5) {
        var _extends4;
        var _ref5 = _temp5 === void 0 ? {} : _temp5, itemProp = _ref5.item, indexProp = _ref5.index, onMouseMove = _ref5.onMouseMove, onClick = _ref5.onClick, onMouseDown = _ref5.onMouseDown;
        _ref5.onPress;
        var _ref5$refKey = _ref5.refKey, refKey = _ref5$refKey === void 0 ? "ref" : _ref5$refKey, disabledProp = _ref5.disabled, ref = _ref5.ref, rest = (0, $50biD.default)(_ref5, $365c1101de59193c$var$_excluded3$1);
        if (disabledProp !== undefined) console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useSelect.');
        var _latest$current = latest.current, latestState = _latest$current.state, latestProps = _latest$current.props;
        var _getItemAndIndex = $365c1101de59193c$var$getItemAndIndex(itemProp, indexProp, latestProps.items, "Pass either item or index to getItemProps!"), item = _getItemAndIndex[0], index = _getItemAndIndex[1];
        var disabled = latestProps.isItemDisabled(item, index);
        var itemHandleMouseMove = function itemHandleMouseMove() {
            if (index === latestState.highlightedIndex) return;
            shouldScrollRef.current = false;
            dispatch({
                type: $365c1101de59193c$var$ItemMouseMove$1,
                index: index,
                disabled: disabled
            });
        };
        var itemHandleClick = function itemHandleClick() {
            dispatch({
                type: $365c1101de59193c$var$ItemClick$1,
                index: index
            });
        };
        var itemHandleMouseDown = function itemHandleMouseDown(e) {
            return e.preventDefault();
        }; // keep focus on the toggle after item click select.
        var itemProps = (0, $dBd5b.default)((_extends4 = {}, _extends4[refKey] = $365c1101de59193c$var$handleRefs(ref, function(itemNode) {
            if (itemNode) itemRefs.current[elementIds.getItemId(index)] = itemNode;
        }), _extends4["aria-disabled"] = disabled, _extends4["aria-selected"] = "" + (item === latestState.selectedItem), _extends4.id = elementIds.getItemId(index), _extends4.role = "option", _extends4), rest);
        if (!disabled) itemProps.onClick = $365c1101de59193c$var$callAllEventHandlers(onClick, itemHandleClick);
        itemProps.onMouseMove = $365c1101de59193c$var$callAllEventHandlers(onMouseMove, itemHandleMouseMove);
        itemProps.onMouseDown = $365c1101de59193c$var$callAllEventHandlers(onMouseDown, itemHandleMouseDown);
        return itemProps;
    }, [
        latest,
        elementIds,
        shouldScrollRef,
        dispatch
    ]);
    return {
        // prop getters.
        getToggleButtonProps: getToggleButtonProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getItemProps: getItemProps,
        // actions.
        toggleMenu: toggleMenu,
        openMenu: openMenu,
        closeMenu: closeMenu,
        setHighlightedIndex: setHighlightedIndex,
        selectItem: selectItem,
        reset: reset,
        setInputValue: setInputValue,
        // state.
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
var $365c1101de59193c$var$InputKeyDownArrowDown = 0;
var $365c1101de59193c$var$InputKeyDownArrowUp = 1;
var $365c1101de59193c$var$InputKeyDownEscape = 2;
var $365c1101de59193c$var$InputKeyDownHome = 3;
var $365c1101de59193c$var$InputKeyDownEnd = 4;
var $365c1101de59193c$var$InputKeyDownPageUp = 5;
var $365c1101de59193c$var$InputKeyDownPageDown = 6;
var $365c1101de59193c$var$InputKeyDownEnter = 7;
var $365c1101de59193c$var$InputChange = 8;
var $365c1101de59193c$var$InputBlur = 9;
var $365c1101de59193c$var$InputClick = 10;
var $365c1101de59193c$var$MenuMouseLeave = 11;
var $365c1101de59193c$var$ItemMouseMove = 12;
var $365c1101de59193c$var$ItemClick = 13;
var $365c1101de59193c$var$ToggleButtonClick = 14;
var $365c1101de59193c$var$FunctionToggleMenu = 15;
var $365c1101de59193c$var$FunctionOpenMenu = 16;
var $365c1101de59193c$var$FunctionCloseMenu = 17;
var $365c1101de59193c$var$FunctionSetHighlightedIndex = 18;
var $365c1101de59193c$var$FunctionSelectItem = 19;
var $365c1101de59193c$var$FunctionSetInputValue = 20;
var $365c1101de59193c$var$FunctionReset$1 = 21;
var $365c1101de59193c$var$ControlledPropUpdatedSelectedItem = 22;
var $365c1101de59193c$var$stateChangeTypes$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    InputKeyDownArrowDown: $365c1101de59193c$var$InputKeyDownArrowDown,
    InputKeyDownArrowUp: $365c1101de59193c$var$InputKeyDownArrowUp,
    InputKeyDownEscape: $365c1101de59193c$var$InputKeyDownEscape,
    InputKeyDownHome: $365c1101de59193c$var$InputKeyDownHome,
    InputKeyDownEnd: $365c1101de59193c$var$InputKeyDownEnd,
    InputKeyDownPageUp: $365c1101de59193c$var$InputKeyDownPageUp,
    InputKeyDownPageDown: $365c1101de59193c$var$InputKeyDownPageDown,
    InputKeyDownEnter: $365c1101de59193c$var$InputKeyDownEnter,
    InputChange: $365c1101de59193c$var$InputChange,
    InputBlur: $365c1101de59193c$var$InputBlur,
    InputClick: $365c1101de59193c$var$InputClick,
    MenuMouseLeave: $365c1101de59193c$var$MenuMouseLeave,
    ItemMouseMove: $365c1101de59193c$var$ItemMouseMove,
    ItemClick: $365c1101de59193c$var$ItemClick,
    ToggleButtonClick: $365c1101de59193c$var$ToggleButtonClick,
    FunctionToggleMenu: $365c1101de59193c$var$FunctionToggleMenu,
    FunctionOpenMenu: $365c1101de59193c$var$FunctionOpenMenu,
    FunctionCloseMenu: $365c1101de59193c$var$FunctionCloseMenu,
    FunctionSetHighlightedIndex: $365c1101de59193c$var$FunctionSetHighlightedIndex,
    FunctionSelectItem: $365c1101de59193c$var$FunctionSelectItem,
    FunctionSetInputValue: $365c1101de59193c$var$FunctionSetInputValue,
    FunctionReset: $365c1101de59193c$var$FunctionReset$1,
    ControlledPropUpdatedSelectedItem: $365c1101de59193c$var$ControlledPropUpdatedSelectedItem
});
function $365c1101de59193c$var$getInitialState$1(props) {
    var initialState = $365c1101de59193c$var$getInitialState$2(props);
    var selectedItem = initialState.selectedItem;
    var inputValue = initialState.inputValue;
    if (inputValue === "" && selectedItem && props.defaultInputValue === undefined && props.initialInputValue === undefined && props.inputValue === undefined) inputValue = props.itemToString(selectedItem);
    return (0, $dBd5b.default)({}, initialState, {
        inputValue: inputValue
    });
}
var $365c1101de59193c$var$propTypes$1 = (0, $dBd5b.default)({}, $365c1101de59193c$var$commonDropdownPropTypes, {
    items: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).array.isRequired,
    isItemDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    selectedItemChanged: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    getA11ySelectionMessage: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    inputValue: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    defaultInputValue: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    initialInputValue: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    inputId: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    onInputValueChange: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func
});
/**
 * The useCombobox version of useControlledReducer, which also
 * checks if the controlled prop selectedItem changed between
 * renders. If so, it will also update inputValue with its
 * string equivalent. It uses the common useEnhancedReducer to
 * compute the rest of the state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} props The hook props, also passed to createInitialState.
 * @param {Function} createInitialState Function that returns the initial state.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $365c1101de59193c$var$useControlledReducer(reducer, props, createInitialState) {
    var previousSelectedItemRef = (0, $4DE7A.useRef)();
    var _useEnhancedReducer = $365c1101de59193c$var$useEnhancedReducer(reducer, props, createInitialState), state = _useEnhancedReducer[0], dispatch = _useEnhancedReducer[1];
    // ToDo: if needed, make same approach as selectedItemChanged from Downshift.
    (0, $4DE7A.useEffect)(function() {
        if (!$365c1101de59193c$var$isControlledProp(props, "selectedItem")) return;
        if (props.selectedItemChanged(previousSelectedItemRef.current, props.selectedItem)) dispatch({
            type: $365c1101de59193c$var$ControlledPropUpdatedSelectedItem,
            inputValue: props.itemToString(props.selectedItem)
        });
        previousSelectedItemRef.current = state.selectedItem === previousSelectedItemRef.current ? props.selectedItem : state.selectedItem;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state.selectedItem,
        props.selectedItem
    ]);
    return [
        $365c1101de59193c$var$getState(state, props),
        dispatch
    ];
}
// eslint-disable-next-line import/no-mutable-exports
var $365c1101de59193c$var$validatePropTypes$1 = $365c1101de59193c$var$noop;
var $365c1101de59193c$var$defaultProps$1 = (0, $dBd5b.default)({}, $365c1101de59193c$var$defaultProps$3, {
    selectedItemChanged: function selectedItemChanged(prevItem, item) {
        return prevItem !== item;
    },
    getA11yStatusMessage: $365c1101de59193c$var$getA11yStatusMessage$1,
    isItemDisabled: function isItemDisabled() {
        return false;
    }
});
/* eslint-disable complexity */ function $365c1101de59193c$var$downshiftUseComboboxReducer(state, action) {
    var _props$items;
    var type = action.type, props = action.props, altKey = action.altKey;
    var changes;
    switch(type){
        case $365c1101de59193c$var$ItemClick:
            changes = {
                isOpen: $365c1101de59193c$var$getDefaultValue$1(props, "isOpen"),
                highlightedIndex: $365c1101de59193c$var$getDefaultValue$1(props, "highlightedIndex"),
                selectedItem: props.items[action.index],
                inputValue: props.itemToString(props.items[action.index])
            };
            break;
        case $365c1101de59193c$var$InputKeyDownArrowDown:
            if (state.isOpen) changes = {
                highlightedIndex: $365c1101de59193c$var$getHighlightedIndex(state.highlightedIndex, 1, props.items, props.isItemDisabled, true)
            };
            else changes = {
                highlightedIndex: altKey && state.selectedItem == null ? -1 : $365c1101de59193c$var$getHighlightedIndexOnOpen(props, state, 1),
                isOpen: props.items.length >= 0
            };
            break;
        case $365c1101de59193c$var$InputKeyDownArrowUp:
            if (state.isOpen) {
                if (altKey) changes = $365c1101de59193c$var$getChangesOnSelection(props, state.highlightedIndex);
                else changes = {
                    highlightedIndex: $365c1101de59193c$var$getHighlightedIndex(state.highlightedIndex, -1, props.items, props.isItemDisabled, true)
                };
            } else changes = {
                highlightedIndex: $365c1101de59193c$var$getHighlightedIndexOnOpen(props, state, -1),
                isOpen: props.items.length >= 0
            };
            break;
        case $365c1101de59193c$var$InputKeyDownEnter:
            changes = $365c1101de59193c$var$getChangesOnSelection(props, state.highlightedIndex);
            break;
        case $365c1101de59193c$var$InputKeyDownEscape:
            changes = (0, $dBd5b.default)({
                isOpen: false,
                highlightedIndex: -1
            }, !state.isOpen && {
                selectedItem: null,
                inputValue: ""
            });
            break;
        case $365c1101de59193c$var$InputKeyDownPageUp:
            changes = {
                highlightedIndex: $365c1101de59193c$var$getHighlightedIndex(state.highlightedIndex, -10, props.items, props.isItemDisabled, true)
            };
            break;
        case $365c1101de59193c$var$InputKeyDownPageDown:
            changes = {
                highlightedIndex: $365c1101de59193c$var$getHighlightedIndex(state.highlightedIndex, 10, props.items, props.isItemDisabled, true)
            };
            break;
        case $365c1101de59193c$var$InputKeyDownHome:
            changes = {
                highlightedIndex: $365c1101de59193c$var$getNonDisabledIndex(0, false, props.items, props.isItemDisabled)
            };
            break;
        case $365c1101de59193c$var$InputKeyDownEnd:
            changes = {
                highlightedIndex: $365c1101de59193c$var$getNonDisabledIndex(props.items.length - 1, true, props.items, props.isItemDisabled)
            };
            break;
        case $365c1101de59193c$var$InputBlur:
            changes = (0, $dBd5b.default)({
                isOpen: false,
                highlightedIndex: -1
            }, state.highlightedIndex >= 0 && ((_props$items = props.items) == null ? void 0 : _props$items.length) && action.selectItem && {
                selectedItem: props.items[state.highlightedIndex],
                inputValue: props.itemToString(props.items[state.highlightedIndex])
            });
            break;
        case $365c1101de59193c$var$InputChange:
            changes = {
                isOpen: true,
                highlightedIndex: $365c1101de59193c$var$getDefaultValue$1(props, "highlightedIndex"),
                inputValue: action.inputValue
            };
            break;
        case $365c1101de59193c$var$InputClick:
            changes = {
                isOpen: !state.isOpen,
                highlightedIndex: state.isOpen ? -1 : $365c1101de59193c$var$getHighlightedIndexOnOpen(props, state, 0)
            };
            break;
        case $365c1101de59193c$var$FunctionSelectItem:
            changes = {
                selectedItem: action.selectedItem,
                inputValue: props.itemToString(action.selectedItem)
            };
            break;
        case $365c1101de59193c$var$ControlledPropUpdatedSelectedItem:
            changes = {
                inputValue: action.inputValue
            };
            break;
        default:
            return $365c1101de59193c$var$downshiftCommonReducer(state, action, $365c1101de59193c$var$stateChangeTypes$1);
    }
    return (0, $dBd5b.default)({}, state, changes);
}
/* eslint-enable complexity */ var $365c1101de59193c$var$_excluded$1 = [
    "onMouseLeave",
    "refKey",
    "ref"
], $365c1101de59193c$var$_excluded2$1 = [
    "item",
    "index",
    "refKey",
    "ref",
    "onMouseMove",
    "onMouseDown",
    "onClick",
    "onPress",
    "disabled"
], $365c1101de59193c$var$_excluded3 = [
    "onClick",
    "onPress",
    "refKey",
    "ref"
], $365c1101de59193c$var$_excluded4 = [
    "onKeyDown",
    "onChange",
    "onInput",
    "onBlur",
    "onChangeText",
    "onClick",
    "refKey",
    "ref"
];
$365c1101de59193c$export$7a023a466c03eb3d.stateChangeTypes = $365c1101de59193c$var$stateChangeTypes$1;
function $365c1101de59193c$export$7a023a466c03eb3d(userProps) {
    if (userProps === void 0) userProps = {};
    $365c1101de59193c$var$validatePropTypes$1(userProps, $365c1101de59193c$export$7a023a466c03eb3d);
    // Props defaults and destructuring.
    var props = (0, $dBd5b.default)({}, $365c1101de59193c$var$defaultProps$1, userProps);
    var items = props.items, scrollIntoView = props.scrollIntoView, environment = props.environment, getA11yStatusMessage = props.getA11yStatusMessage, getA11ySelectionMessage = props.getA11ySelectionMessage, itemToString = props.itemToString;
    // Initial state depending on controlled props.
    var _useControlledReducer = $365c1101de59193c$var$useControlledReducer($365c1101de59193c$var$downshiftUseComboboxReducer, props, $365c1101de59193c$var$getInitialState$1), state = _useControlledReducer[0], dispatch = _useControlledReducer[1];
    var isOpen = state.isOpen, highlightedIndex = state.highlightedIndex, selectedItem = state.selectedItem, inputValue = state.inputValue;
    // Element refs.
    var menuRef = (0, $4DE7A.useRef)(null);
    var itemRefs = (0, $4DE7A.useRef)({});
    var inputRef = (0, $4DE7A.useRef)(null);
    var toggleButtonRef = (0, $4DE7A.useRef)(null);
    var isInitialMountRef = (0, $4DE7A.useRef)(true);
    // prevent id re-generation between renders.
    var elementIds = $365c1101de59193c$var$useElementIds(props);
    // used to keep track of how many items we had on previous cycle.
    var previousResultCountRef = (0, $4DE7A.useRef)();
    // utility callback to get item element.
    var latest = $365c1101de59193c$var$useLatestRef({
        state: state,
        props: props
    });
    var getItemNodeFromIndex = (0, $4DE7A.useCallback)(function(index) {
        return itemRefs.current[elementIds.getItemId(index)];
    }, [
        elementIds
    ]);
    // Effects.
    // Sets a11y status message on changes in state.
    $365c1101de59193c$var$useA11yMessageSetter(getA11yStatusMessage, [
        isOpen,
        highlightedIndex,
        inputValue,
        items
    ], (0, $dBd5b.default)({
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString
    }, state));
    // Sets a11y status message on changes in selectedItem.
    $365c1101de59193c$var$useA11yMessageSetter(getA11ySelectionMessage, [
        selectedItem
    ], (0, $dBd5b.default)({
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString
    }, state));
    // Scroll on highlighted item if change comes from keyboard.
    var shouldScrollRef = $365c1101de59193c$var$useScrollIntoView({
        menuElement: menuRef.current,
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        itemRefs: itemRefs,
        scrollIntoView: scrollIntoView,
        getItemNodeFromIndex: getItemNodeFromIndex
    });
    $365c1101de59193c$var$useControlPropsValidator({
        isInitialMount: isInitialMountRef.current,
        props: props,
        state: state
    });
    // Focus the input on first render if required.
    (0, $4DE7A.useEffect)(function() {
        var focusOnOpen = $365c1101de59193c$var$getInitialValue$1(props, "isOpen");
        if (focusOnOpen && inputRef.current) inputRef.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $4DE7A.useEffect)(function() {
        if (isInitialMountRef.current) return;
        previousResultCountRef.current = items.length;
    });
    // Add mouse/touch events to document.
    var mouseAndTouchTrackersRef = $365c1101de59193c$var$useMouseAndTouchTracker(isOpen, [
        inputRef,
        menuRef,
        toggleButtonRef
    ], environment, function() {
        dispatch({
            type: $365c1101de59193c$var$InputBlur,
            selectItem: false
        });
    });
    var setGetterPropCallInfo = $365c1101de59193c$var$useGetterPropsCalledChecker("getInputProps", "getMenuProps");
    // Make initial ref false.
    (0, $4DE7A.useEffect)(function() {
        isInitialMountRef.current = false;
        return function() {
            isInitialMountRef.current = true;
        };
    }, []);
    // Reset itemRefs on close.
    (0, $4DE7A.useEffect)(function() {
        if (!isOpen) itemRefs.current = {};
    }, [
        isOpen
    ]);
    // Reset itemRefs on close.
    (0, $4DE7A.useEffect)(function() {
        var _inputRef$current;
        if (!isOpen || !(environment != null && environment.document) || !(inputRef != null && (_inputRef$current = inputRef.current) != null && _inputRef$current.focus)) return;
        if (environment.document.activeElement !== inputRef.current) inputRef.current.focus();
    }, [
        isOpen,
        environment
    ]);
    /* Event handler functions */ var inputKeyDownHandlers = (0, $4DE7A.useMemo)(function() {
        return {
            ArrowDown: function ArrowDown(event) {
                event.preventDefault();
                dispatch({
                    type: $365c1101de59193c$var$InputKeyDownArrowDown,
                    altKey: event.altKey
                });
            },
            ArrowUp: function ArrowUp(event) {
                event.preventDefault();
                dispatch({
                    type: $365c1101de59193c$var$InputKeyDownArrowUp,
                    altKey: event.altKey
                });
            },
            Home: function Home(event) {
                if (!latest.current.state.isOpen) return;
                event.preventDefault();
                dispatch({
                    type: $365c1101de59193c$var$InputKeyDownHome
                });
            },
            End: function End(event) {
                if (!latest.current.state.isOpen) return;
                event.preventDefault();
                dispatch({
                    type: $365c1101de59193c$var$InputKeyDownEnd
                });
            },
            Escape: function Escape(event) {
                var latestState = latest.current.state;
                if (latestState.isOpen || latestState.inputValue || latestState.selectedItem || latestState.highlightedIndex > -1) {
                    event.preventDefault();
                    dispatch({
                        type: $365c1101de59193c$var$InputKeyDownEscape
                    });
                }
            },
            Enter: function Enter(event) {
                var latestState = latest.current.state;
                // if closed or no highlighted index, do nothing.
                if (!latestState.isOpen || event.which === 229 // if IME composing, wait for next Enter keydown event.
                ) return;
                event.preventDefault();
                dispatch({
                    type: $365c1101de59193c$var$InputKeyDownEnter
                });
            },
            PageUp: function PageUp(event) {
                if (latest.current.state.isOpen) {
                    event.preventDefault();
                    dispatch({
                        type: $365c1101de59193c$var$InputKeyDownPageUp
                    });
                }
            },
            PageDown: function PageDown(event) {
                if (latest.current.state.isOpen) {
                    event.preventDefault();
                    dispatch({
                        type: $365c1101de59193c$var$InputKeyDownPageDown
                    });
                }
            }
        };
    }, [
        dispatch,
        latest
    ]);
    // Getter props.
    var getLabelProps = (0, $4DE7A.useCallback)(function(labelProps) {
        return (0, $dBd5b.default)({
            id: elementIds.labelId,
            htmlFor: elementIds.inputId
        }, labelProps);
    }, [
        elementIds
    ]);
    var getMenuProps = (0, $4DE7A.useCallback)(function(_temp, _temp2) {
        var _extends2;
        var _ref = _temp === void 0 ? {} : _temp, onMouseLeave = _ref.onMouseLeave, _ref$refKey = _ref.refKey, refKey = _ref$refKey === void 0 ? "ref" : _ref$refKey, ref = _ref.ref, rest = (0, $50biD.default)(_ref, $365c1101de59193c$var$_excluded$1);
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$suppressRefErro = _ref2.suppressRefError, suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
        setGetterPropCallInfo("getMenuProps", suppressRefError, refKey, menuRef);
        return (0, $dBd5b.default)((_extends2 = {}, _extends2[refKey] = $365c1101de59193c$var$handleRefs(ref, function(menuNode) {
            menuRef.current = menuNode;
        }), _extends2.id = elementIds.menuId, _extends2.role = "listbox", _extends2["aria-labelledby"] = rest && rest["aria-label"] ? undefined : "" + elementIds.labelId, _extends2.onMouseLeave = $365c1101de59193c$var$callAllEventHandlers(onMouseLeave, function() {
            dispatch({
                type: $365c1101de59193c$var$MenuMouseLeave
            });
        }), _extends2), rest);
    }, [
        dispatch,
        setGetterPropCallInfo,
        elementIds
    ]);
    var getItemProps = (0, $4DE7A.useCallback)(function(_temp3) {
        var _extends3, _ref4;
        var _ref3 = _temp3 === void 0 ? {} : _temp3, itemProp = _ref3.item, indexProp = _ref3.index, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, ref = _ref3.ref, onMouseMove = _ref3.onMouseMove, onMouseDown = _ref3.onMouseDown, onClick = _ref3.onClick;
        _ref3.onPress;
        var disabledProp = _ref3.disabled, rest = (0, $50biD.default)(_ref3, $365c1101de59193c$var$_excluded2$1);
        if (disabledProp !== undefined) console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
        var _latest$current = latest.current, latestProps = _latest$current.props, latestState = _latest$current.state;
        var _getItemAndIndex = $365c1101de59193c$var$getItemAndIndex(itemProp, indexProp, latestProps.items, "Pass either item or index to getItemProps!"), item = _getItemAndIndex[0], index = _getItemAndIndex[1];
        var disabled = latestProps.isItemDisabled(item, index);
        var onSelectKey = "onClick";
        var customClickHandler = onClick;
        var itemHandleMouseMove = function itemHandleMouseMove() {
            if (index === latestState.highlightedIndex) return;
            shouldScrollRef.current = false;
            dispatch({
                type: $365c1101de59193c$var$ItemMouseMove,
                index: index,
                disabled: disabled
            });
        };
        var itemHandleClick = function itemHandleClick() {
            dispatch({
                type: $365c1101de59193c$var$ItemClick,
                index: index
            });
        };
        var itemHandleMouseDown = function itemHandleMouseDown(e) {
            return e.preventDefault();
        }; // keep focus on the input after item click select.
        return (0, $dBd5b.default)((_extends3 = {}, _extends3[refKey] = $365c1101de59193c$var$handleRefs(ref, function(itemNode) {
            if (itemNode) itemRefs.current[elementIds.getItemId(index)] = itemNode;
        }), _extends3["aria-disabled"] = disabled, _extends3["aria-selected"] = "" + (index === latestState.highlightedIndex), _extends3.id = elementIds.getItemId(index), _extends3.role = "option", _extends3), !disabled && (_ref4 = {}, _ref4[onSelectKey] = $365c1101de59193c$var$callAllEventHandlers(customClickHandler, itemHandleClick), _ref4), {
            onMouseMove: $365c1101de59193c$var$callAllEventHandlers(onMouseMove, itemHandleMouseMove),
            onMouseDown: $365c1101de59193c$var$callAllEventHandlers(onMouseDown, itemHandleMouseDown)
        }, rest);
    }, [
        dispatch,
        latest,
        shouldScrollRef,
        elementIds
    ]);
    var getToggleButtonProps = (0, $4DE7A.useCallback)(function(_temp4) {
        var _extends4;
        var _ref5 = _temp4 === void 0 ? {} : _temp4, onClick = _ref5.onClick;
        _ref5.onPress;
        var _ref5$refKey = _ref5.refKey, refKey = _ref5$refKey === void 0 ? "ref" : _ref5$refKey, ref = _ref5.ref, rest = (0, $50biD.default)(_ref5, $365c1101de59193c$var$_excluded3);
        var latestState = latest.current.state;
        var toggleButtonHandleClick = function toggleButtonHandleClick() {
            dispatch({
                type: $365c1101de59193c$var$ToggleButtonClick
            });
        };
        return (0, $dBd5b.default)((_extends4 = {}, _extends4[refKey] = $365c1101de59193c$var$handleRefs(ref, function(toggleButtonNode) {
            toggleButtonRef.current = toggleButtonNode;
        }), _extends4["aria-controls"] = elementIds.menuId, _extends4["aria-expanded"] = latestState.isOpen, _extends4.id = elementIds.toggleButtonId, _extends4.tabIndex = -1, _extends4), !rest.disabled && (0, $dBd5b.default)({}, {
            onClick: $365c1101de59193c$var$callAllEventHandlers(onClick, toggleButtonHandleClick)
        }), rest);
    }, [
        dispatch,
        latest,
        elementIds
    ]);
    var getInputProps = (0, $4DE7A.useCallback)(function(_temp5, _temp6) {
        var _extends5;
        var _ref6 = _temp5 === void 0 ? {} : _temp5, onKeyDown = _ref6.onKeyDown, onChange = _ref6.onChange, onInput = _ref6.onInput, onBlur = _ref6.onBlur;
        _ref6.onChangeText;
        var onClick = _ref6.onClick, _ref6$refKey = _ref6.refKey, refKey = _ref6$refKey === void 0 ? "ref" : _ref6$refKey, ref = _ref6.ref, rest = (0, $50biD.default)(_ref6, $365c1101de59193c$var$_excluded4);
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressRefErro = _ref7.suppressRefError, suppressRefError = _ref7$suppressRefErro === void 0 ? false : _ref7$suppressRefErro;
        setGetterPropCallInfo("getInputProps", suppressRefError, refKey, inputRef);
        var latestState = latest.current.state;
        var inputHandleKeyDown = function inputHandleKeyDown(event) {
            var key = $365c1101de59193c$var$normalizeArrowKey(event);
            if (key && inputKeyDownHandlers[key]) inputKeyDownHandlers[key](event);
        };
        var inputHandleChange = function inputHandleChange(event) {
            dispatch({
                type: $365c1101de59193c$var$InputChange,
                inputValue: event.target.value
            });
        };
        var inputHandleBlur = function inputHandleBlur(event) {
            /* istanbul ignore else */ if (environment != null && environment.document && latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown) {
                var isBlurByTabChange = event.relatedTarget === null && environment.document.activeElement !== environment.document.body;
                dispatch({
                    type: $365c1101de59193c$var$InputBlur,
                    selectItem: !isBlurByTabChange
                });
            }
        };
        var inputHandleClick = function inputHandleClick() {
            dispatch({
                type: $365c1101de59193c$var$InputClick
            });
        };
        /* istanbul ignore next (preact) */ var onChangeKey = "onChange";
        var eventHandlers = {};
        if (!rest.disabled) {
            var _eventHandlers;
            eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = $365c1101de59193c$var$callAllEventHandlers(onChange, onInput, inputHandleChange), _eventHandlers.onKeyDown = $365c1101de59193c$var$callAllEventHandlers(onKeyDown, inputHandleKeyDown), _eventHandlers.onBlur = $365c1101de59193c$var$callAllEventHandlers(onBlur, inputHandleBlur), _eventHandlers.onClick = $365c1101de59193c$var$callAllEventHandlers(onClick, inputHandleClick), _eventHandlers);
        }
        return (0, $dBd5b.default)((_extends5 = {}, _extends5[refKey] = $365c1101de59193c$var$handleRefs(ref, function(inputNode) {
            inputRef.current = inputNode;
        }), _extends5["aria-activedescendant"] = latestState.isOpen && latestState.highlightedIndex > -1 ? elementIds.getItemId(latestState.highlightedIndex) : "", _extends5["aria-autocomplete"] = "list", _extends5["aria-controls"] = elementIds.menuId, _extends5["aria-expanded"] = latestState.isOpen, _extends5["aria-labelledby"] = rest && rest["aria-label"] ? undefined : elementIds.labelId, _extends5.autoComplete = "off", _extends5.id = elementIds.inputId, _extends5.role = "combobox", _extends5.value = latestState.inputValue, _extends5), eventHandlers, rest);
    }, [
        setGetterPropCallInfo,
        latest,
        elementIds,
        inputKeyDownHandlers,
        dispatch,
        mouseAndTouchTrackersRef,
        environment
    ]);
    // returns
    var toggleMenu = (0, $4DE7A.useCallback)(function() {
        dispatch({
            type: $365c1101de59193c$var$FunctionToggleMenu
        });
    }, [
        dispatch
    ]);
    var closeMenu = (0, $4DE7A.useCallback)(function() {
        dispatch({
            type: $365c1101de59193c$var$FunctionCloseMenu
        });
    }, [
        dispatch
    ]);
    var openMenu = (0, $4DE7A.useCallback)(function() {
        dispatch({
            type: $365c1101de59193c$var$FunctionOpenMenu
        });
    }, [
        dispatch
    ]);
    var setHighlightedIndex = (0, $4DE7A.useCallback)(function(newHighlightedIndex) {
        dispatch({
            type: $365c1101de59193c$var$FunctionSetHighlightedIndex,
            highlightedIndex: newHighlightedIndex
        });
    }, [
        dispatch
    ]);
    var selectItem = (0, $4DE7A.useCallback)(function(newSelectedItem) {
        dispatch({
            type: $365c1101de59193c$var$FunctionSelectItem,
            selectedItem: newSelectedItem
        });
    }, [
        dispatch
    ]);
    var setInputValue = (0, $4DE7A.useCallback)(function(newInputValue) {
        dispatch({
            type: $365c1101de59193c$var$FunctionSetInputValue,
            inputValue: newInputValue
        });
    }, [
        dispatch
    ]);
    var reset = (0, $4DE7A.useCallback)(function() {
        dispatch({
            type: $365c1101de59193c$var$FunctionReset$1
        });
    }, [
        dispatch
    ]);
    return {
        // prop getters.
        getItemProps: getItemProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getInputProps: getInputProps,
        getToggleButtonProps: getToggleButtonProps,
        // actions.
        toggleMenu: toggleMenu,
        openMenu: openMenu,
        closeMenu: closeMenu,
        setHighlightedIndex: setHighlightedIndex,
        setInputValue: setInputValue,
        selectItem: selectItem,
        reset: reset,
        // state.
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
var $365c1101de59193c$var$defaultStateValues = {
    activeIndex: -1,
    selectedItems: []
};
/**
 * Returns the initial value for a state key in the following order:
 * 1. controlled prop, 2. initial prop, 3. default prop, 4. default
 * value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */ function $365c1101de59193c$var$getInitialValue(props, propKey) {
    return $365c1101de59193c$var$getInitialValue$1(props, propKey, $365c1101de59193c$var$defaultStateValues);
}
/**
 * Returns the default value for a state key in the following order:
 * 1. controlled prop, 2. default prop, 3. default value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */ function $365c1101de59193c$var$getDefaultValue(props, propKey) {
    return $365c1101de59193c$var$getDefaultValue$1(props, propKey, $365c1101de59193c$var$defaultStateValues);
}
/**
 * Gets the initial state based on the provided props. It uses initial, default
 * and controlled props related to state in order to compute the initial value.
 *
 * @param {Object} props Props passed to the hook.
 * @returns {Object} The initial state.
 */ function $365c1101de59193c$var$getInitialState(props) {
    var activeIndex = $365c1101de59193c$var$getInitialValue(props, "activeIndex");
    var selectedItems = $365c1101de59193c$var$getInitialValue(props, "selectedItems");
    return {
        activeIndex: activeIndex,
        selectedItems: selectedItems
    };
}
/**
 * Returns true if dropdown keydown operation is permitted. Should not be
 * allowed on keydown with modifier keys (ctrl, alt, shift, meta), on
 * input element with text content that is either highlighted or selection
 * cursor is not at the starting position.
 *
 * @param {KeyboardEvent} event The event from keydown.
 * @returns {boolean} Whether the operation is allowed.
 */ function $365c1101de59193c$var$isKeyDownOperationPermitted(event) {
    if (event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) return false;
    var element = event.target;
    if (element instanceof HTMLInputElement && // if element is a text input
    element.value !== "" && // and we have text in it
    // and cursor is either not at the start or is currently highlighting text.
    (element.selectionStart !== 0 || element.selectionEnd !== 0)) return false;
    return true;
}
/**
 * Returns a message to be added to aria-live region when item is removed.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */ function $365c1101de59193c$var$getA11yRemovalMessage(selectionParameters) {
    var removedSelectedItem = selectionParameters.removedSelectedItem, itemToStringLocal = selectionParameters.itemToString;
    return itemToStringLocal(removedSelectedItem) + " has been removed.";
}
var $365c1101de59193c$var$propTypes = (0, $dBd5b.default)({}, $365c1101de59193c$var$commonPropTypes, {
    selectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).array,
    initialSelectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).array,
    defaultSelectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).array,
    getA11yRemovalMessage: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    initialActiveIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    defaultActiveIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    onActiveIndexChange: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    onSelectedItemsChange: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    keyNavigationNext: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    keyNavigationPrevious: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
});
var $365c1101de59193c$var$defaultProps = {
    itemToString: $365c1101de59193c$var$defaultProps$3.itemToString,
    stateReducer: $365c1101de59193c$var$defaultProps$3.stateReducer,
    environment: $365c1101de59193c$var$defaultProps$3.environment,
    getA11yRemovalMessage: $365c1101de59193c$var$getA11yRemovalMessage,
    keyNavigationNext: "ArrowRight",
    keyNavigationPrevious: "ArrowLeft"
};
// eslint-disable-next-line import/no-mutable-exports
var $365c1101de59193c$var$validatePropTypes = $365c1101de59193c$var$noop;
var $365c1101de59193c$var$SelectedItemClick = 0;
var $365c1101de59193c$var$SelectedItemKeyDownDelete = 1;
var $365c1101de59193c$var$SelectedItemKeyDownBackspace = 2;
var $365c1101de59193c$var$SelectedItemKeyDownNavigationNext = 3;
var $365c1101de59193c$var$SelectedItemKeyDownNavigationPrevious = 4;
var $365c1101de59193c$var$DropdownKeyDownNavigationPrevious = 5;
var $365c1101de59193c$var$DropdownKeyDownBackspace = 6;
var $365c1101de59193c$var$DropdownClick = 7;
var $365c1101de59193c$var$FunctionAddSelectedItem = 8;
var $365c1101de59193c$var$FunctionRemoveSelectedItem = 9;
var $365c1101de59193c$var$FunctionSetSelectedItems = 10;
var $365c1101de59193c$var$FunctionSetActiveIndex = 11;
var $365c1101de59193c$var$FunctionReset = 12;
var $365c1101de59193c$var$stateChangeTypes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    SelectedItemClick: $365c1101de59193c$var$SelectedItemClick,
    SelectedItemKeyDownDelete: $365c1101de59193c$var$SelectedItemKeyDownDelete,
    SelectedItemKeyDownBackspace: $365c1101de59193c$var$SelectedItemKeyDownBackspace,
    SelectedItemKeyDownNavigationNext: $365c1101de59193c$var$SelectedItemKeyDownNavigationNext,
    SelectedItemKeyDownNavigationPrevious: $365c1101de59193c$var$SelectedItemKeyDownNavigationPrevious,
    DropdownKeyDownNavigationPrevious: $365c1101de59193c$var$DropdownKeyDownNavigationPrevious,
    DropdownKeyDownBackspace: $365c1101de59193c$var$DropdownKeyDownBackspace,
    DropdownClick: $365c1101de59193c$var$DropdownClick,
    FunctionAddSelectedItem: $365c1101de59193c$var$FunctionAddSelectedItem,
    FunctionRemoveSelectedItem: $365c1101de59193c$var$FunctionRemoveSelectedItem,
    FunctionSetSelectedItems: $365c1101de59193c$var$FunctionSetSelectedItems,
    FunctionSetActiveIndex: $365c1101de59193c$var$FunctionSetActiveIndex,
    FunctionReset: $365c1101de59193c$var$FunctionReset
});
/* eslint-disable complexity */ function $365c1101de59193c$var$downshiftMultipleSelectionReducer(state, action) {
    var type = action.type, index = action.index, props = action.props, selectedItem = action.selectedItem;
    var activeIndex = state.activeIndex, selectedItems = state.selectedItems;
    var changes;
    switch(type){
        case $365c1101de59193c$var$SelectedItemClick:
            changes = {
                activeIndex: index
            };
            break;
        case $365c1101de59193c$var$SelectedItemKeyDownNavigationPrevious:
            changes = {
                activeIndex: activeIndex - 1 < 0 ? 0 : activeIndex - 1
            };
            break;
        case $365c1101de59193c$var$SelectedItemKeyDownNavigationNext:
            changes = {
                activeIndex: activeIndex + 1 >= selectedItems.length ? -1 : activeIndex + 1
            };
            break;
        case $365c1101de59193c$var$SelectedItemKeyDownBackspace:
        case $365c1101de59193c$var$SelectedItemKeyDownDelete:
            if (activeIndex < 0) break;
            var newActiveIndex = activeIndex;
            if (selectedItems.length === 1) newActiveIndex = -1;
            else if (activeIndex === selectedItems.length - 1) newActiveIndex = selectedItems.length - 2;
            changes = (0, $dBd5b.default)({
                selectedItems: [].concat(selectedItems.slice(0, activeIndex), selectedItems.slice(activeIndex + 1))
            }, {
                activeIndex: newActiveIndex
            });
            break;
        case $365c1101de59193c$var$DropdownKeyDownNavigationPrevious:
            changes = {
                activeIndex: selectedItems.length - 1
            };
            break;
        case $365c1101de59193c$var$DropdownKeyDownBackspace:
            changes = {
                selectedItems: selectedItems.slice(0, selectedItems.length - 1)
            };
            break;
        case $365c1101de59193c$var$FunctionAddSelectedItem:
            changes = {
                selectedItems: [].concat(selectedItems, [
                    selectedItem
                ])
            };
            break;
        case $365c1101de59193c$var$DropdownClick:
            changes = {
                activeIndex: -1
            };
            break;
        case $365c1101de59193c$var$FunctionRemoveSelectedItem:
            var _newActiveIndex = activeIndex;
            var selectedItemIndex = selectedItems.indexOf(selectedItem);
            if (selectedItemIndex < 0) break;
            if (selectedItems.length === 1) _newActiveIndex = -1;
            else if (selectedItemIndex === selectedItems.length - 1) _newActiveIndex = selectedItems.length - 2;
            changes = {
                selectedItems: [].concat(selectedItems.slice(0, selectedItemIndex), selectedItems.slice(selectedItemIndex + 1)),
                activeIndex: _newActiveIndex
            };
            break;
        case $365c1101de59193c$var$FunctionSetSelectedItems:
            var newSelectedItems = action.selectedItems;
            changes = {
                selectedItems: newSelectedItems
            };
            break;
        case $365c1101de59193c$var$FunctionSetActiveIndex:
            var _newActiveIndex2 = action.activeIndex;
            changes = {
                activeIndex: _newActiveIndex2
            };
            break;
        case $365c1101de59193c$var$FunctionReset:
            changes = {
                activeIndex: $365c1101de59193c$var$getDefaultValue(props, "activeIndex"),
                selectedItems: $365c1101de59193c$var$getDefaultValue(props, "selectedItems")
            };
            break;
        default:
            throw new Error("Reducer called without proper action type.");
    }
    return (0, $dBd5b.default)({}, state, changes);
}
var $365c1101de59193c$var$_excluded = [
    "refKey",
    "ref",
    "onClick",
    "onKeyDown",
    "selectedItem",
    "index"
], $365c1101de59193c$var$_excluded2 = [
    "refKey",
    "ref",
    "onKeyDown",
    "onClick",
    "preventKeyAction"
];
$365c1101de59193c$export$134e7e7faed1473a.stateChangeTypes = $365c1101de59193c$var$stateChangeTypes;
function $365c1101de59193c$export$134e7e7faed1473a(userProps) {
    if (userProps === void 0) userProps = {};
    $365c1101de59193c$var$validatePropTypes(userProps, $365c1101de59193c$export$134e7e7faed1473a);
    // Props defaults and destructuring.
    var props = (0, $dBd5b.default)({}, $365c1101de59193c$var$defaultProps, userProps);
    var getA11yRemovalMessage = props.getA11yRemovalMessage, itemToString = props.itemToString, environment = props.environment, keyNavigationNext = props.keyNavigationNext, keyNavigationPrevious = props.keyNavigationPrevious;
    // Reducer init.
    var _useControlledReducer = $365c1101de59193c$var$useControlledReducer$1($365c1101de59193c$var$downshiftMultipleSelectionReducer, props, $365c1101de59193c$var$getInitialState), state = _useControlledReducer[0], dispatch = _useControlledReducer[1];
    var activeIndex = state.activeIndex, selectedItems = state.selectedItems;
    // Refs.
    var isInitialMountRef = (0, $4DE7A.useRef)(true);
    var dropdownRef = (0, $4DE7A.useRef)(null);
    var previousSelectedItemsRef = (0, $4DE7A.useRef)(selectedItems);
    var selectedItemRefs = (0, $4DE7A.useRef)();
    selectedItemRefs.current = [];
    var latest = $365c1101de59193c$var$useLatestRef({
        state: state,
        props: props
    });
    // Effects.
    /* Sets a11y status message on changes in selectedItem. */ (0, $4DE7A.useEffect)(function() {
        if (isInitialMountRef.current || false || !(environment != null && environment.document)) return;
        if (selectedItems.length < previousSelectedItemsRef.current.length) {
            var removedSelectedItem = previousSelectedItemsRef.current.find(function(item) {
                return selectedItems.indexOf(item) < 0;
            });
            $365c1101de59193c$var$setStatus(getA11yRemovalMessage({
                itemToString: itemToString,
                resultCount: selectedItems.length,
                removedSelectedItem: removedSelectedItem,
                activeIndex: activeIndex,
                activeSelectedItem: selectedItems[activeIndex]
            }), environment.document);
        }
        previousSelectedItemsRef.current = selectedItems;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedItems.length
    ]);
    // Sets focus on active item.
    (0, $4DE7A.useEffect)(function() {
        if (isInitialMountRef.current) return;
        if (activeIndex === -1 && dropdownRef.current) dropdownRef.current.focus();
        else if (selectedItemRefs.current[activeIndex]) selectedItemRefs.current[activeIndex].focus();
    }, [
        activeIndex
    ]);
    $365c1101de59193c$var$useControlPropsValidator({
        isInitialMount: isInitialMountRef.current,
        props: props,
        state: state
    });
    var setGetterPropCallInfo = $365c1101de59193c$var$useGetterPropsCalledChecker("getDropdownProps");
    // Make initial ref false.
    (0, $4DE7A.useEffect)(function() {
        isInitialMountRef.current = false;
        return function() {
            isInitialMountRef.current = true;
        };
    }, []);
    // Event handler functions.
    var selectedItemKeyDownHandlers = (0, $4DE7A.useMemo)(function() {
        var _ref;
        return _ref = {}, _ref[keyNavigationPrevious] = function() {
            dispatch({
                type: $365c1101de59193c$var$SelectedItemKeyDownNavigationPrevious
            });
        }, _ref[keyNavigationNext] = function() {
            dispatch({
                type: $365c1101de59193c$var$SelectedItemKeyDownNavigationNext
            });
        }, _ref.Delete = function Delete() {
            dispatch({
                type: $365c1101de59193c$var$SelectedItemKeyDownDelete
            });
        }, _ref.Backspace = function Backspace() {
            dispatch({
                type: $365c1101de59193c$var$SelectedItemKeyDownBackspace
            });
        }, _ref;
    }, [
        dispatch,
        keyNavigationNext,
        keyNavigationPrevious
    ]);
    var dropdownKeyDownHandlers = (0, $4DE7A.useMemo)(function() {
        var _ref2;
        return _ref2 = {}, _ref2[keyNavigationPrevious] = function(event) {
            if ($365c1101de59193c$var$isKeyDownOperationPermitted(event)) dispatch({
                type: $365c1101de59193c$var$DropdownKeyDownNavigationPrevious
            });
        }, _ref2.Backspace = function Backspace(event) {
            if ($365c1101de59193c$var$isKeyDownOperationPermitted(event)) dispatch({
                type: $365c1101de59193c$var$DropdownKeyDownBackspace
            });
        }, _ref2;
    }, [
        dispatch,
        keyNavigationPrevious
    ]);
    // Getter props.
    var getSelectedItemProps = (0, $4DE7A.useCallback)(function(_temp) {
        var _extends2;
        var _ref3 = _temp === void 0 ? {} : _temp, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, ref = _ref3.ref, onClick = _ref3.onClick, onKeyDown = _ref3.onKeyDown, selectedItemProp = _ref3.selectedItem, indexProp = _ref3.index, rest = (0, $50biD.default)(_ref3, $365c1101de59193c$var$_excluded);
        var latestState = latest.current.state;
        var _getItemAndIndex = $365c1101de59193c$var$getItemAndIndex(selectedItemProp, indexProp, latestState.selectedItems, "Pass either item or index to getSelectedItemProps!"), index = _getItemAndIndex[1];
        var isFocusable = index > -1 && index === latestState.activeIndex;
        var selectedItemHandleClick = function selectedItemHandleClick() {
            dispatch({
                type: $365c1101de59193c$var$SelectedItemClick,
                index: index
            });
        };
        var selectedItemHandleKeyDown = function selectedItemHandleKeyDown(event) {
            var key = $365c1101de59193c$var$normalizeArrowKey(event);
            if (key && selectedItemKeyDownHandlers[key]) selectedItemKeyDownHandlers[key](event);
        };
        return (0, $dBd5b.default)((_extends2 = {}, _extends2[refKey] = $365c1101de59193c$var$handleRefs(ref, function(selectedItemNode) {
            if (selectedItemNode) selectedItemRefs.current.push(selectedItemNode);
        }), _extends2.tabIndex = isFocusable ? 0 : -1, _extends2.onClick = $365c1101de59193c$var$callAllEventHandlers(onClick, selectedItemHandleClick), _extends2.onKeyDown = $365c1101de59193c$var$callAllEventHandlers(onKeyDown, selectedItemHandleKeyDown), _extends2), rest);
    }, [
        dispatch,
        latest,
        selectedItemKeyDownHandlers
    ]);
    var getDropdownProps = (0, $4DE7A.useCallback)(function(_temp2, _temp3) {
        var _extends3;
        var _ref4 = _temp2 === void 0 ? {} : _temp2, _ref4$refKey = _ref4.refKey, refKey = _ref4$refKey === void 0 ? "ref" : _ref4$refKey, ref = _ref4.ref, onKeyDown = _ref4.onKeyDown, onClick = _ref4.onClick, _ref4$preventKeyActio = _ref4.preventKeyAction, preventKeyAction = _ref4$preventKeyActio === void 0 ? false : _ref4$preventKeyActio, rest = (0, $50biD.default)(_ref4, $365c1101de59193c$var$_excluded2);
        var _ref5 = _temp3 === void 0 ? {} : _temp3, _ref5$suppressRefErro = _ref5.suppressRefError, suppressRefError = _ref5$suppressRefErro === void 0 ? false : _ref5$suppressRefErro;
        setGetterPropCallInfo("getDropdownProps", suppressRefError, refKey, dropdownRef);
        var dropdownHandleKeyDown = function dropdownHandleKeyDown(event) {
            var key = $365c1101de59193c$var$normalizeArrowKey(event);
            if (key && dropdownKeyDownHandlers[key]) dropdownKeyDownHandlers[key](event);
        };
        var dropdownHandleClick = function dropdownHandleClick() {
            dispatch({
                type: $365c1101de59193c$var$DropdownClick
            });
        };
        return (0, $dBd5b.default)((_extends3 = {}, _extends3[refKey] = $365c1101de59193c$var$handleRefs(ref, function(dropdownNode) {
            if (dropdownNode) dropdownRef.current = dropdownNode;
        }), _extends3), !preventKeyAction && {
            onKeyDown: $365c1101de59193c$var$callAllEventHandlers(onKeyDown, dropdownHandleKeyDown),
            onClick: $365c1101de59193c$var$callAllEventHandlers(onClick, dropdownHandleClick)
        }, rest);
    }, [
        dispatch,
        dropdownKeyDownHandlers,
        setGetterPropCallInfo
    ]);
    // returns
    var addSelectedItem = (0, $4DE7A.useCallback)(function(selectedItem) {
        dispatch({
            type: $365c1101de59193c$var$FunctionAddSelectedItem,
            selectedItem: selectedItem
        });
    }, [
        dispatch
    ]);
    var removeSelectedItem = (0, $4DE7A.useCallback)(function(selectedItem) {
        dispatch({
            type: $365c1101de59193c$var$FunctionRemoveSelectedItem,
            selectedItem: selectedItem
        });
    }, [
        dispatch
    ]);
    var setSelectedItems = (0, $4DE7A.useCallback)(function(newSelectedItems) {
        dispatch({
            type: $365c1101de59193c$var$FunctionSetSelectedItems,
            selectedItems: newSelectedItems
        });
    }, [
        dispatch
    ]);
    var setActiveIndex = (0, $4DE7A.useCallback)(function(newActiveIndex) {
        dispatch({
            type: $365c1101de59193c$var$FunctionSetActiveIndex,
            activeIndex: newActiveIndex
        });
    }, [
        dispatch
    ]);
    var reset = (0, $4DE7A.useCallback)(function() {
        dispatch({
            type: $365c1101de59193c$var$FunctionReset
        });
    }, [
        dispatch
    ]);
    return {
        getSelectedItemProps: getSelectedItemProps,
        getDropdownProps: getDropdownProps,
        addSelectedItem: addSelectedItem,
        removeSelectedItem: removeSelectedItem,
        setSelectedItems: setSelectedItems,
        setActiveIndex: setActiveIndex,
        reset: reset,
        selectedItems: selectedItems,
        activeIndex: activeIndex
    };
}

});
parcelRegister("50biD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a45b7b4245d8c8d$export$2e2bcd8739ae039; });
function $3a45b7b4245d8c8d$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("dBd5b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e68e0fc90236222$export$2e2bcd8739ae039; });
function $9e68e0fc90236222$export$2e2bcd8739ae039() {
    $9e68e0fc90236222$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9e68e0fc90236222$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("aw3S5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a7fe54f52cab345$export$2e2bcd8739ae039; });
function $7a7fe54f52cab345$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("2ogmM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bda84ae17f34429$export$2e2bcd8739ae039; });

var $3zDKB = parcelRequire("3zDKB");
function $1bda84ae17f34429$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $3zDKB.default)(subClass, superClass);
}

});
parcelRegister("3zDKB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29a379a33684976d$export$2e2bcd8739ae039; });
function $29a379a33684976d$export$2e2bcd8739ae039(o, p) {
    $29a379a33684976d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $29a379a33684976d$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("iI505", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lDN5u"));

});

parcelRegister("h504q", function(module, exports) {

$parcel$export(module.exports, "compute", function () { return $c6f2f5433f55a54b$export$3b12cb22b12b954b; });
const $c6f2f5433f55a54b$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $c6f2f5433f55a54b$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $c6f2f5433f55a54b$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $c6f2f5433f55a54b$var$e(o.overflowY, n) || $c6f2f5433f55a54b$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $c6f2f5433f55a54b$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $c6f2f5433f55a54b$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $c6f2f5433f55a54b$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$c6f2f5433f55a54b$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $c6f2f5433f55a54b$var$t(W) && p(W);){
        if (W = $c6f2f5433f55a54b$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $c6f2f5433f55a54b$var$n(W) && !$c6f2f5433f55a54b$var$n(document.documentElement) || null != W && $c6f2f5433f55a54b$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: n, width: l, top: r, right: i, bottom: s, left: d } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && x >= r && I <= s && R >= d && C <= i) return L;
        const h = getComputedStyle(e), a = parseInt(h.borderLeftWidth, 10), g = parseInt(h.borderTopWidth, 10), p = parseInt(h.borderRightWidth, 10), W = parseInt(h.borderBottomWidth, 10);
        let T = 0, B = 0;
        const F = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - a - p : 0, V = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - g - W : 0, S = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : l / e.offsetWidth : 0, X = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : n / e.offsetHeight : 0;
        if (m === e) T = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $c6f2f5433f55a54b$var$o(M, M + H, H, g, W, M + k, M + k + v, v) : k - H / 2, B = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $c6f2f5433f55a54b$var$o(y, y + b, b, a, p, y + D, y + D + E, E), T = Math.max(0, T + M), B = Math.max(0, B + y);
        else {
            T = "start" === f ? k - r - g : "end" === f ? k - s + W + V : "nearest" === f ? $c6f2f5433f55a54b$var$o(r, s, n, g, W + V, k, k + v, v) : k - (r + n / 2) + V / 2, B = "start" === u ? D - d - a : "center" === u ? D - (d + l / 2) + F / 2 : "end" === u ? D - i + p + F : $c6f2f5433f55a54b$var$o(d, i, l, a, p + F, D, D + E, E);
            const { scrollLeft: t, scrollTop: h } = e;
            T = 0 === X ? 0 : Math.max(0, Math.min(h + T / X, e.scrollHeight - n / X + V)), B = 0 === S ? 0 : Math.max(0, Math.min(t + B / S, e.scrollWidth - l / S + F)), k += h - T, D += t - B;
        }
        L.push({
            el: e,
            top: T,
            left: B
        });
    }
    return L;
};

});


parcelRegister("3yVPP", function(module, exports) {
"use strict";
/**
 * The main constructor class for the Pelias client
 */ var $298168dce9bb6042$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $298168dce9bb6042$var$index_1 = $298168dce9bb6042$var$__importDefault((parcelRequire("41sny")));

const $298168dce9bb6042$var$index_2 = $298168dce9bb6042$var$__importDefault((parcelRequire("luZIu")));
class $298168dce9bb6042$var$Pelias {
    // Subclasses handle validation of configuration
    constructor(config){
        this.search = new $298168dce9bb6042$var$index_1.default(config);
        this.autocomplete = new $298168dce9bb6042$var$index_2.default(config);
    }
}
module.exports.default = $298168dce9bb6042$var$Pelias;

});
parcelRegister("41sny", function(module, exports) {
"use strict";
var $2edd44e2b4641187$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/**
 * A fluent interface for forward geocoding in Pelias
 */ const $2edd44e2b4641187$var$Constants = $2edd44e2b4641187$var$__importStar((parcelRequire("7VnjC")));

var $6pPBj = parcelRequire("6pPBj");

const $2edd44e2b4641187$var$parameterSet = $2edd44e2b4641187$var$__importStar((parcelRequire("lrsbE")));
// Auto-instantiate in case caller forgets 'new' so as not to pollute the global namespace
// TODO: take a formed search object so the use doesn't have to use the fluent setters
class $2edd44e2b4641187$var$Search {
    constructor(config){
        this.setSearchTerm = $2edd44e2b4641187$var$parameterSet.setSearchTerm.bind(this, "_searchObject");
        this.setFocusPoint = $2edd44e2b4641187$var$parameterSet.setFocusPoint.bind(this, "_searchObject");
        this.setResultsLimit = $2edd44e2b4641187$var$parameterSet.setResultsLimit.bind(this, "_searchObject");
        this.setBoundaryCountry = $2edd44e2b4641187$var$parameterSet.setBoundaryCountry.bind(this, "_searchObject");
        this.setBoundaryRectangle = $2edd44e2b4641187$var$parameterSet.setBoundaryRectangle.bind(this, "_searchObject");
        this.setBoundaryCircle = $2edd44e2b4641187$var$parameterSet.setBoundaryCircle.bind(this, "_searchObject");
        this.setBoundaryAdminArea = $2edd44e2b4641187$var$parameterSet.setBoundaryAdminArea.bind(this, "_searchObject");
        this.setDataSources = $2edd44e2b4641187$var$parameterSet.setDataSources.bind(this, "_searchObject");
        this.setLayers = $2edd44e2b4641187$var$parameterSet.setLayers.bind(this, "_searchObject");
        this.execute = ()=>{
            const query = $2edd44e2b4641187$var$buildSearchQueryString(this._searchObject);
            return $6pPBj.search(this._baseUrl, query).then((response)=>{
                return response;
            });
        };
        this._searchObject = {
            searchTerm: undefined,
            apiKey: config.apiKey || undefined
        };
        if (!("peliasUrl" in config)) throw new Error("peliasUrl must be specified in the constructor");
        this._baseUrl = config.peliasUrl;
    }
}
// Search takes a GET request with a variety of query string params
const $2edd44e2b4641187$var$buildSearchQueryString = (searchObject)=>{
    const paramsArray = [];
    if (searchObject.searchTerm) paramsArray.push([
        $2edd44e2b4641187$var$Constants.QS_TEXT,
        searchObject.searchTerm
    ]);
    if (searchObject.apiKey) paramsArray.push([
        $2edd44e2b4641187$var$Constants.QS_API_KEY,
        searchObject.apiKey
    ]);
    if (searchObject.focusPoint) {
        paramsArray.push([
            $2edd44e2b4641187$var$Constants.QS_FOCUS_LAT,
            searchObject.focusPoint.lat
        ]);
        paramsArray.push([
            $2edd44e2b4641187$var$Constants.QS_FOCUS_LONG,
            searchObject.focusPoint.lon
        ]);
    }
    if (searchObject.resultsLimit) paramsArray.push([
        $2edd44e2b4641187$var$Constants.QS_RESULTS_LIMIT,
        searchObject.resultsLimit
    ]);
    if (searchObject.boundaryCountry) paramsArray.push([
        $2edd44e2b4641187$var$Constants.QS_BOUNDARY_COUNTRY,
        searchObject.boundaryCountry
    ]);
    if (searchObject.boundaryRectangle) {
        paramsArray.push([
            $2edd44e2b4641187$var$Constants.QS_BOUNDARY_RECT_MIN_LAT,
            searchObject.boundaryRectangle.min_lat
        ]);
        paramsArray.push([
            $2edd44e2b4641187$var$Constants.QS_BOUNDARY_RECT_MAX_LAT,
            searchObject.boundaryRectangle.max_lat
        ]);
        paramsArray.push([
            $2edd44e2b4641187$var$Constants.QS_BOUNDARY_RECT_MIN_LON,
            searchObject.boundaryRectangle.min_lon
        ]);
        paramsArray.push([
            $2edd44e2b4641187$var$Constants.QS_BOUNDARY_RECT_MAX_LON,
            searchObject.boundaryRectangle.max_lon
        ]);
    }
    if (searchObject.boundaryCircle) {
        paramsArray.push([
            $2edd44e2b4641187$var$Constants.QS_BOUNDARY_CIRCLE_LAT,
            searchObject.boundaryCircle.lat
        ]);
        paramsArray.push([
            $2edd44e2b4641187$var$Constants.QS_BOUNDARY_CIRCLE_LON,
            searchObject.boundaryCircle.lon
        ]);
        paramsArray.push([
            $2edd44e2b4641187$var$Constants.QS_BOUNDARY_CIRCLE_RADIUS,
            searchObject.boundaryCircle.radius
        ]);
    }
    if (searchObject.boundaryAdminArea) paramsArray.push([
        $2edd44e2b4641187$var$Constants.QS_BOUNDARY_ADMIN_AREA,
        searchObject.boundaryAdminArea
    ]);
    if (searchObject.dataSources) paramsArray.push([
        $2edd44e2b4641187$var$Constants.QS_DATA_SOURCES,
        searchObject.dataSources.join(",")
    ]);
    if (searchObject.layers) paramsArray.push([
        $2edd44e2b4641187$var$Constants.QS_LAYERS,
        searchObject.layers.join(",")
    ]);
    const searchParams = paramsArray.map((keyValPair)=>{
        return `${encodeURIComponent(keyValPair[0])}=${encodeURIComponent(keyValPair[1])}`;
    }).join("&");
    return searchParams;
};
module.exports.default = $2edd44e2b4641187$var$Search;

});
parcelRegister("7VnjC", function(module, exports) {
"use strict";
/**
 * Constants
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Search types
module.exports.GET = "GET";
module.exports.POST = "POST";
// URLs
module.exports.SEARCH_ENDPOINT = "/v1/search?";
module.exports.AUTOCOMPLETE_ENDPOINT = "/v1/autocomplete?";
// Query string params
module.exports.QS_TEXT = "text";
module.exports.QS_API_KEY = "api_key";
module.exports.QS_FOCUS_LAT = "focus.point.lat";
module.exports.QS_FOCUS_LONG = "focus.point.lon";
module.exports.QS_RESULTS_LIMIT = "size";
module.exports.QS_BOUNDARY_COUNTRY = "boundary.country";
module.exports.QS_BOUNDARY_RECT_MIN_LAT = "boundary.rect.min_lat";
module.exports.QS_BOUNDARY_RECT_MAX_LAT = "boundary.rect.max_lat";
module.exports.QS_BOUNDARY_RECT_MIN_LON = "boundary.rect.min_lon";
module.exports.QS_BOUNDARY_RECT_MAX_LON = "boundary.rect.max_lon";
module.exports.QS_BOUNDARY_CIRCLE_LAT = "boundary.circle.lat";
module.exports.QS_BOUNDARY_CIRCLE_LON = "boundary.circle.lon";
module.exports.QS_BOUNDARY_CIRCLE_RADIUS = "boundary.circle.radius";
module.exports.QS_BOUNDARY_ADMIN_AREA = "boundary.gid";
module.exports.QS_DATA_SOURCES = "sources";
module.exports.QS_LAYERS = "layers";
// Data sources
module.exports.DATA_SOURCE_OPENSTREETMAP = "osm";
module.exports.DATA_SOURCE_OPENADDRESSES = "oa";
module.exports.DATA_SOURCE_WHOSONFIRST = "wof";
module.exports.DATA_SOURCE_GEONAMES = "gn";
// Layers
module.exports.PLACE_TYPE_ADDRESS = "address";
module.exports.PLACE_TYPE_VENUE = "venue";
module.exports.PLACE_TYPE_NEIGHBOURHOOD = "neighbourhood";
module.exports.PLACE_TYPE_LOCALITY = "locality";
module.exports.PLACE_TYPE_BOROUGH = "borough";
module.exports.PLACE_TYPE_LOCALADMIN = "localadmin";
module.exports.PLACE_TYPE_COUNTY = "county";
module.exports.PLACE_TYPE_MACROCOUNTY = "macrocounty";
module.exports.PLACE_TYPE_REGION = "region";
module.exports.PLACE_TYPE_MACROREGION = "macroregion";
module.exports.PLACE_TYPE_COUNTRY = "country";
module.exports.PLACE_TYPE_COARSE = "coarse";
// Mins and maxes
module.exports.MIN_LAT = "min_lat";
module.exports.MAX_LAT = "max_lat";
module.exports.MIN_LON = "min_lon";
module.exports.MAX_LON = "max_lon";
module.exports.LAT = "lat";
module.exports.LON = "lon";
module.exports.RADIUS = "radius";

});

parcelRegister("6pPBj", function(module, exports) {
"use strict";
/**
 * Fetch utilities
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7VnjC = parcelRequire("7VnjC");
module.exports.search = (baseUrl, queryString)=>{
    return $4abd1ab7fb123da7$var$fetchGet(`${baseUrl}${$7VnjC.SEARCH_ENDPOINT}`, queryString);
};
module.exports.autocomplete = (baseUrl, queryString)=>{
    return $4abd1ab7fb123da7$var$throttledFetchGet(500, `${baseUrl}${$7VnjC.AUTOCOMPLETE_ENDPOINT}`, queryString);
};
// Fetch helpers
const $4abd1ab7fb123da7$var$checkResponse = (response)=>{
    return response.ok ? response : Promise.reject(new Error("Error in fetch: " + response.status));
};
const $4abd1ab7fb123da7$var$getJson = (response)=>{
    return response.json();
};
const $4abd1ab7fb123da7$var$fetchGet = (url, queryString)=>{
    const fetchUrl = queryString ? `${url}${queryString}` : url;
    return fetch(fetchUrl).then($4abd1ab7fb123da7$var$checkResponse).then($4abd1ab7fb123da7$var$getJson).catch((error)=>{
        throw new Error(`Error fetching data: ${error}`);
    });
};
const $4abd1ab7fb123da7$var$throttledFetchGet = (timeout, url, queryString)=>{
    let wait = false; // Initially, we're not waiting
    if (!wait) {
        if (queryString) return $4abd1ab7fb123da7$var$fetchGet(url, queryString);
        else return $4abd1ab7fb123da7$var$fetchGet(url);
        wait = true; // Prevent future invocations
        setTimeout(function() {
            wait = false; // And allow future invocations
        }, timeout);
    }
};

});

parcelRegister("lrsbE", function(module, exports) {
"use strict";
/**
 * Parameters to be set for Pelias searches. Uses 'this' so each search module can import identical functions
 * and apply to the internal search object.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gKN0t = parcelRequire("gKN0t");
module.exports.setSearchTerm = function(objectKey, searchTerm) {
    if (!$gKN0t.isValidString(searchTerm)) throw new Error("Search term should be a nonempty string");
    this[objectKey].searchTerm = searchTerm;
    return this;
};
// Set a locale to search near - require both lat and long
module.exports.setFocusPoint = function(objectKey, point) {
    if (!$gKN0t.isNumeric(point.lat) || !$gKN0t.isNumeric(point.lon)) throw new Error("Lat and long values should be numeric floating-point coordinates");
    this[objectKey].focusPoint = point;
    return this;
};
// Set a locale to search near - require both lat and long
module.exports.setResultsLimit = function(objectKey, limit) {
    if (!Number.isInteger(limit)) throw new Error("Limit should be an integer");
    this[objectKey].resultsLimit = limit;
    return this;
};
// Restrict search to a boundary country
module.exports.setBoundaryCountry = function(objectKey, boundaryCountry) {
    if (!$gKN0t.isValidString(boundaryCountry)) throw new Error("Boundary country should be a nonempty string");
    this[objectKey].boundaryCountry = boundaryCountry;
    return this;
};
// Restrict search to a boundary rectangle
module.exports.setBoundaryRectangle = function(objectKey, boundaryRectangle) {
    if (!$gKN0t.isValidBoundaryRectangle(boundaryRectangle)) throw new Error("Boundary rectangle should be an object with keys min_lat, max_lat, min_lon, max_lon. Values should be floating-point coordinates");
    this[objectKey].boundaryRectangle = boundaryRectangle;
    return this;
};
// Restrict search to a boundary circle
module.exports.setBoundaryCircle = function(objectKey, boundaryCircle) {
    if (!$gKN0t.isValidBoundaryCircle(boundaryCircle)) throw new Error("Boundary circle should be an object with keys lat, lon, and radius. Lat and lon should be floating-point coordinates, radius may be floating point or integer");
    this[objectKey].boundaryCircle = boundaryCircle;
    return this;
};
// Restrict search to a boundary admin area
module.exports.setBoundaryAdminArea = function(objectKey, boundaryAdminArea) {
    if (!$gKN0t.isValidString(boundaryAdminArea)) throw new Error("Boundary admin area should be a nonempty string");
    this[objectKey].boundaryAdminArea = boundaryAdminArea;
    return this;
};
// Restrict search to a specific data source
module.exports.setDataSources = function(objectKey, dataSources) {
    if (!$gKN0t.isValidDataSources(dataSources)) throw new Error("Data sources should be an array with one or more of: oa, osm, wof, gn");
    this[objectKey].dataSources = dataSources;
    return this;
};
// Restrict search to a specific layer
module.exports.setLayers = function(objectKey, layers) {
    if (!$gKN0t.isValidLayers(layers)) throw new Error("Data sources should be an array with one or more of: venue, address, street, neighbourhood, borough, localadmin, locality, county, macrocounty, region, macroregion, country, coarse");
    this[objectKey].layers = layers;
    return this;
};

});
parcelRegister("gKN0t", function(module, exports) {
"use strict";
/**
 * Fetch utilities
 */ var $0325ca24cf8ceebf$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $0325ca24cf8ceebf$var$Constants = $0325ca24cf8ceebf$var$__importStar((parcelRequire("7VnjC")));
module.exports.isValidString = (string)=>{
    return string && string.length > 0;
};
// stolen from Angular: https://github.com/angular/angular/blob/4.3.x/packages/common/src/pipes/number_pipe.ts#L172
module.exports.isNumeric = (value)=>{
    return value !== null && typeof value !== "undefined" && !isNaN(value - parseFloat(value));
};
// TODO: Allow variation in key capitalization, e.g. Lat, LAT
module.exports.isValidBoundaryRectangle = (value)=>{
    if (!(value instanceof Object)) return false;
    if (!($0325ca24cf8ceebf$var$Constants.MIN_LAT in value && $0325ca24cf8ceebf$var$Constants.MAX_LAT in value && $0325ca24cf8ceebf$var$Constants.MIN_LON in value && $0325ca24cf8ceebf$var$Constants.MAX_LON in value)) return false;
    if (!(module.exports.isNumeric(value[$0325ca24cf8ceebf$var$Constants.MIN_LAT]) && module.exports.isNumeric(value[$0325ca24cf8ceebf$var$Constants.MAX_LAT]) && module.exports.isNumeric(value[$0325ca24cf8ceebf$var$Constants.MIN_LON]) && module.exports.isNumeric(value[$0325ca24cf8ceebf$var$Constants.MAX_LON]))) return false;
    return true;
};
module.exports.isValidBoundaryCircle = (value)=>{
    if (!(value instanceof Object)) return false;
    if (!($0325ca24cf8ceebf$var$Constants.LAT in value && $0325ca24cf8ceebf$var$Constants.LON in value && $0325ca24cf8ceebf$var$Constants.RADIUS in value)) return false;
    if (!(module.exports.isNumeric(value[$0325ca24cf8ceebf$var$Constants.LAT]) && module.exports.isNumeric(value[$0325ca24cf8ceebf$var$Constants.LON]) && module.exports.isNumeric(value[$0325ca24cf8ceebf$var$Constants.RADIUS]))) return false;
    return true;
};
module.exports.isValidDataSources = (value)=>{
    const validDataSources = [
        $0325ca24cf8ceebf$var$Constants.DATA_SOURCE_GEONAMES,
        $0325ca24cf8ceebf$var$Constants.DATA_SOURCE_OPENADDRESSES,
        $0325ca24cf8ceebf$var$Constants.DATA_SOURCE_OPENSTREETMAP,
        $0325ca24cf8ceebf$var$Constants.DATA_SOURCE_WHOSONFIRST
    ];
    if (!Array.isArray(value)) return false;
    if (value.length === 0) return false;
    // Use Array.reduce to validate each element in the array - don't silently ignore
    // invalid values
    // It's expected that these may come in various cases, so convert to lower if the value is a string
    return value.reduce((isValidArray, dataSource)=>{
        return isValidArray && typeof dataSource === "string" && validDataSources.includes(dataSource.toLowerCase());
    }, true);
};
module.exports.isValidLayers = (value)=>{
    const validLayers = [
        $0325ca24cf8ceebf$var$Constants.PLACE_TYPE_ADDRESS,
        $0325ca24cf8ceebf$var$Constants.PLACE_TYPE_BOROUGH,
        $0325ca24cf8ceebf$var$Constants.PLACE_TYPE_COARSE,
        $0325ca24cf8ceebf$var$Constants.PLACE_TYPE_COUNTRY,
        $0325ca24cf8ceebf$var$Constants.PLACE_TYPE_COUNTY,
        $0325ca24cf8ceebf$var$Constants.PLACE_TYPE_LOCALADMIN,
        $0325ca24cf8ceebf$var$Constants.PLACE_TYPE_LOCALITY,
        $0325ca24cf8ceebf$var$Constants.PLACE_TYPE_MACROCOUNTY,
        $0325ca24cf8ceebf$var$Constants.PLACE_TYPE_MACROREGION,
        $0325ca24cf8ceebf$var$Constants.PLACE_TYPE_NEIGHBOURHOOD,
        $0325ca24cf8ceebf$var$Constants.PLACE_TYPE_REGION,
        $0325ca24cf8ceebf$var$Constants.PLACE_TYPE_VENUE
    ];
    if (!Array.isArray(value)) return false;
    if (value.length === 0) return false;
    // Use Array.reduce to validate each element in the array - don't silently ignore
    // invalid values
    // It's expected that these may come in various cases, so convert to lower if the value is a string
    return value.reduce((isValidArray, layer)=>{
        return isValidArray && typeof layer === "string" && validLayers.includes(layer.toLowerCase());
    }, true);
};

});



parcelRegister("luZIu", function(module, exports) {
"use strict";
var $fa6c45f36b595f7e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/**
 * A fluent interface for autocomplete searches in Pelias
 */ const $fa6c45f36b595f7e$var$Constants = $fa6c45f36b595f7e$var$__importStar((parcelRequire("7VnjC")));

var $6pPBj = parcelRequire("6pPBj");

const $fa6c45f36b595f7e$var$parameterSet = $fa6c45f36b595f7e$var$__importStar((parcelRequire("lrsbE")));
// TODO: take a formed search object so the use doesn't have to use the fluent setters
class $fa6c45f36b595f7e$var$Autocomplete {
    constructor(config){
        this.setSearchTerm = $fa6c45f36b595f7e$var$parameterSet.setSearchTerm.bind(this, "_autocompleteObject");
        this.setFocusPoint = $fa6c45f36b595f7e$var$parameterSet.setFocusPoint.bind(this, "_autocompleteObject");
        this.setBoundaryCountry = $fa6c45f36b595f7e$var$parameterSet.setBoundaryCountry.bind(this, "_autocompleteObject");
        this.setBoundaryRectangle = $fa6c45f36b595f7e$var$parameterSet.setBoundaryRectangle.bind(this, "_autocompleteObject");
        this.setDataSources = $fa6c45f36b595f7e$var$parameterSet.setDataSources.bind(this, "_autocompleteObject");
        this.setLayers = $fa6c45f36b595f7e$var$parameterSet.setLayers.bind(this, "_autocompleteObject");
        this.execute = ()=>{
            const query = $fa6c45f36b595f7e$var$buildAutocompleteQueryString(this._autocompleteObject);
            return $6pPBj.autocomplete(this._baseUrl, query).then((response)=>{
                return response;
            });
        };
        this._autocompleteObject = {
            searchTerm: undefined,
            apiKey: config.apiKey || undefined
        };
        if (!("peliasUrl" in config)) throw new Error("peliasUrl must be specified in the constructor");
        this._baseUrl = config.peliasUrl;
    }
}
// Search takes a GET request with a variety of query string params
const $fa6c45f36b595f7e$var$buildAutocompleteQueryString = (autocompleteObject)=>{
    const paramsArray = [];
    if (autocompleteObject.searchTerm) paramsArray.push([
        $fa6c45f36b595f7e$var$Constants.QS_TEXT,
        autocompleteObject.searchTerm
    ]);
    if (autocompleteObject.apiKey) paramsArray.push([
        $fa6c45f36b595f7e$var$Constants.QS_API_KEY,
        autocompleteObject.apiKey
    ]);
    if (autocompleteObject.focusPoint) {
        paramsArray.push([
            $fa6c45f36b595f7e$var$Constants.QS_FOCUS_LAT,
            autocompleteObject.focusPoint.lat
        ]);
        paramsArray.push([
            $fa6c45f36b595f7e$var$Constants.QS_FOCUS_LONG,
            autocompleteObject.focusPoint.lon
        ]);
    }
    if (autocompleteObject.boundaryCountry) paramsArray.push([
        $fa6c45f36b595f7e$var$Constants.QS_BOUNDARY_COUNTRY,
        autocompleteObject.boundaryCountry
    ]);
    if (autocompleteObject.boundaryRectangle) {
        paramsArray.push([
            $fa6c45f36b595f7e$var$Constants.QS_BOUNDARY_RECT_MIN_LAT,
            autocompleteObject.boundaryRectangle.min_lat
        ]);
        paramsArray.push([
            $fa6c45f36b595f7e$var$Constants.QS_BOUNDARY_RECT_MAX_LAT,
            autocompleteObject.boundaryRectangle.max_lat
        ]);
        paramsArray.push([
            $fa6c45f36b595f7e$var$Constants.QS_BOUNDARY_RECT_MIN_LON,
            autocompleteObject.boundaryRectangle.min_lon
        ]);
        paramsArray.push([
            $fa6c45f36b595f7e$var$Constants.QS_BOUNDARY_RECT_MAX_LON,
            autocompleteObject.boundaryRectangle.max_lon
        ]);
    }
    if (autocompleteObject.dataSources) paramsArray.push([
        $fa6c45f36b595f7e$var$Constants.QS_DATA_SOURCES,
        autocompleteObject.dataSources.join(",")
    ]);
    if (autocompleteObject.layers) paramsArray.push([
        $fa6c45f36b595f7e$var$Constants.QS_LAYERS,
        autocompleteObject.layers.join(",")
    ]);
    const autocompleteParams = paramsArray.map((keyValPair)=>{
        return `${encodeURIComponent(keyValPair[0])}=${encodeURIComponent(keyValPair[1])}`;
    }).join("&");
    return autocompleteParams;
};
module.exports.default = $fa6c45f36b595f7e$var$Autocomplete;

});


parcelRegister("ccOiY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $8e2da08b30d8bf26$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $8e2da08b30d8bf26$export$2e2bcd8739ae039; });
function $8e2da08b30d8bf26$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $8e2da08b30d8bf26$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $8e2da08b30d8bf26$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $8e2da08b30d8bf26$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $8e2da08b30d8bf26$export$2e2bcd8739ae039 = $8e2da08b30d8bf26$export$4f5d2d50c9deca37;

});

parcelRegister("hCzNk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browserPrefixToKey = $cd41c056e0169702$var$browserPrefixToKey;
module.exports.browserPrefixToStyle = $cd41c056e0169702$var$browserPrefixToStyle;
module.exports.default = void 0;
module.exports.getPrefix = $cd41c056e0169702$var$getPrefix;
var $cd41c056e0169702$var$prefixes = [
    "Moz",
    "Webkit",
    "O",
    "ms"
];
function $cd41c056e0169702$var$getPrefix() /*: string*/ {
    var _window$document, _window$document$docu;
    var prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === "undefined") return ""; // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
    if (!style) return "";
    if (prop in style) return "";
    for(var i = 0; i < $cd41c056e0169702$var$prefixes.length; i++){
        if ($cd41c056e0169702$var$browserPrefixToKey(prop, $cd41c056e0169702$var$prefixes[i]) in style) return $cd41c056e0169702$var$prefixes[i];
    }
    return "";
}
function $cd41c056e0169702$var$browserPrefixToKey(prop, prefix) /*: string*/ {
    return prefix ? "".concat(prefix).concat($cd41c056e0169702$var$kebabToTitleCase(prop)) : prop;
}
function $cd41c056e0169702$var$browserPrefixToStyle(prop, prefix) /*: string*/ {
    return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function $cd41c056e0169702$var$kebabToTitleCase(str) /*: string*/ {
    var out = "";
    var shouldCapitalize = true;
    for(var i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === "-") shouldCapitalize = true;
        else out += str[i];
    }
    return out;
} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var $cd41c056e0169702$var$_default = $cd41c056e0169702$var$getPrefix();
module.exports.default = $cd41c056e0169702$var$_default;

});

parcelRegister("eOfHa", function(module, exports) {
"use strict";
function $ac81e8f1d3f553a5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ac81e8f1d3f553a5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ac81e8f1d3f553a5$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac81e8f1d3f553a5$var$React = $ac81e8f1d3f553a5$var$_interopRequireWildcard((parcelRequire("4DE7A")));

var $ac81e8f1d3f553a5$var$_propTypes = $ac81e8f1d3f553a5$var$_interopRequireDefault((parcelRequire("fmSD5")));

var $ac81e8f1d3f553a5$var$_reactDom = $ac81e8f1d3f553a5$var$_interopRequireDefault((parcelRequire("gv34t")));

var $aZZKx = parcelRequire("aZZKx");

var $kNRmj = parcelRequire("kNRmj");

var $euSu7 = parcelRequire("euSu7");

var $ac81e8f1d3f553a5$var$_log = $ac81e8f1d3f553a5$var$_interopRequireDefault((parcelRequire("9jJTo")));
function $ac81e8f1d3f553a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ac81e8f1d3f553a5$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ac81e8f1d3f553a5$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ac81e8f1d3f553a5$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $ac81e8f1d3f553a5$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ac81e8f1d3f553a5$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ac81e8f1d3f553a5$var$_slicedToArray(arr, i) {
    return $ac81e8f1d3f553a5$var$_arrayWithHoles(arr) || $ac81e8f1d3f553a5$var$_iterableToArrayLimit(arr, i) || $ac81e8f1d3f553a5$var$_unsupportedIterableToArray(arr, i) || $ac81e8f1d3f553a5$var$_nonIterableRest();
}
function $ac81e8f1d3f553a5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ac81e8f1d3f553a5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ac81e8f1d3f553a5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ac81e8f1d3f553a5$var$_arrayLikeToArray(o, minLen);
}
function $ac81e8f1d3f553a5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ac81e8f1d3f553a5$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ac81e8f1d3f553a5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ac81e8f1d3f553a5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ac81e8f1d3f553a5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ac81e8f1d3f553a5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ac81e8f1d3f553a5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ac81e8f1d3f553a5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ac81e8f1d3f553a5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ac81e8f1d3f553a5$var$_setPrototypeOf(subClass, superClass);
}
function $ac81e8f1d3f553a5$var$_setPrototypeOf(o, p) {
    $ac81e8f1d3f553a5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ac81e8f1d3f553a5$var$_setPrototypeOf(o, p);
}
function $ac81e8f1d3f553a5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ac81e8f1d3f553a5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ac81e8f1d3f553a5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ac81e8f1d3f553a5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ac81e8f1d3f553a5$var$_possibleConstructorReturn(this, result);
    };
}
function $ac81e8f1d3f553a5$var$_possibleConstructorReturn(self, call) {
    if (call && ($ac81e8f1d3f553a5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ac81e8f1d3f553a5$var$_assertThisInitialized(self);
}
function $ac81e8f1d3f553a5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ac81e8f1d3f553a5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ac81e8f1d3f553a5$var$_getPrototypeOf(o) {
    $ac81e8f1d3f553a5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ac81e8f1d3f553a5$var$_getPrototypeOf(o);
}
function $ac81e8f1d3f553a5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Simple abstraction for dragging events names.
var $ac81e8f1d3f553a5$var$eventsFor = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        stop: "touchend"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        stop: "mouseup"
    }
}; // Default to mouse events.
var $ac81e8f1d3f553a5$var$dragEventFor = $ac81e8f1d3f553a5$var$eventsFor.mouse;
/*:: type DraggableCoreState = {
  dragging: boolean,
  lastX: number,
  lastY: number,
  touchIdentifier: ?number
};*/ /*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
var $ac81e8f1d3f553a5$var$DraggableCore = /*#__PURE__*/ function(_React$Component) {
    $ac81e8f1d3f553a5$var$_inherits(DraggableCore, _React$Component);
    var _super = $ac81e8f1d3f553a5$var$_createSuper(DraggableCore);
    function DraggableCore() {
        var _this;
        $ac81e8f1d3f553a5$var$_classCallCheck(this, DraggableCore);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $ac81e8f1d3f553a5$var$_defineProperty($ac81e8f1d3f553a5$var$_assertThisInitialized(_this), "state", {
            dragging: false,
            // Used while dragging to determine deltas.
            lastX: NaN,
            lastY: NaN,
            touchIdentifier: null
        });
        $ac81e8f1d3f553a5$var$_defineProperty($ac81e8f1d3f553a5$var$_assertThisInitialized(_this), "mounted", false);
        $ac81e8f1d3f553a5$var$_defineProperty($ac81e8f1d3f553a5$var$_assertThisInitialized(_this), "handleDragStart", function(e) {
            // Make it possible to attach event handlers on top of this one.
            _this.props.onMouseDown(e); // Only accept left-clicks.
            if (!_this.props.allowAnyClick && typeof e.button === "number" && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)
            var thisNode = _this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
            var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, $aZZKx.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, $aZZKx.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) return;
             // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === "touchstart") e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            var touchIdentifier = (0, $aZZKx.getTouchIdentifier)(e);
            _this.setState({
                touchIdentifier: touchIdentifier
            }); // Get the current drag point from the event. This is used as the offset.
            var position = (0, $kNRmj.getControlPosition)(e, touchIdentifier, $ac81e8f1d3f553a5$var$_assertThisInitialized(_this));
            if (position == null) return; // not possible but satisfies flow
            var x = position.x, y = position.y; // Create an event object with all the data parents need to make a decision here.
            var coreEvent = (0, $kNRmj.createCoreData)($ac81e8f1d3f553a5$var$_assertThisInitialized(_this), x, y);
            (0, $ac81e8f1d3f553a5$var$_log.default)("DraggableCore: handleDragStart: %j", coreEvent); // Call event handler. If it returns explicit false, cancel.
            (0, $ac81e8f1d3f553a5$var$_log.default)("calling", _this.props.onStart);
            var shouldUpdate = _this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (_this.props.enableUserSelectHack) (0, $aZZKx.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            _this.setState({
                dragging: true,
                lastX: x,
                lastY: y
            }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, $aZZKx.addEvent)(ownerDocument, $ac81e8f1d3f553a5$var$dragEventFor.move, _this.handleDrag);
            (0, $aZZKx.addEvent)(ownerDocument, $ac81e8f1d3f553a5$var$dragEventFor.stop, _this.handleDragStop);
        });
        $ac81e8f1d3f553a5$var$_defineProperty($ac81e8f1d3f553a5$var$_assertThisInitialized(_this), "handleDrag", function(e) {
            // Get the current drag point from the event. This is used as the offset.
            var position = (0, $kNRmj.getControlPosition)(e, _this.state.touchIdentifier, $ac81e8f1d3f553a5$var$_assertThisInitialized(_this));
            if (position == null) return;
            var x = position.x, y = position.y; // Snap to grid if prop has been provided
            if (Array.isArray(_this.props.grid)) {
                var deltaX = x - _this.state.lastX, deltaY = y - _this.state.lastY;
                var _snapToGrid = (0, $kNRmj.snapToGrid)(_this.props.grid, deltaX, deltaY);
                var _snapToGrid2 = $ac81e8f1d3f553a5$var$_slicedToArray(_snapToGrid, 2);
                deltaX = _snapToGrid2[0];
                deltaY = _snapToGrid2[1];
                if (!deltaX && !deltaY) return; // skip useless drag
                x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
            }
            var coreEvent = (0, $kNRmj.createCoreData)($ac81e8f1d3f553a5$var$_assertThisInitialized(_this), x, y);
            (0, $ac81e8f1d3f553a5$var$_log.default)("DraggableCore: handleDrag: %j", coreEvent); // Call event handler. If it returns explicit false, trigger end.
            var shouldUpdate = _this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || _this.mounted === false) {
                try {
                    // $FlowIgnore
                    _this.handleDragStop(new MouseEvent("mouseup"));
                } catch (err) {
                    // Old browsers
                    var event = document.createEvent("MouseEvents"); // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    _this.handleDragStop(event);
                }
                return;
            }
            _this.setState({
                lastX: x,
                lastY: y
            });
        });
        $ac81e8f1d3f553a5$var$_defineProperty($ac81e8f1d3f553a5$var$_assertThisInitialized(_this), "handleDragStop", function(e) {
            if (!_this.state.dragging) return;
            var position = (0, $kNRmj.getControlPosition)(e, _this.state.touchIdentifier, $ac81e8f1d3f553a5$var$_assertThisInitialized(_this));
            if (position == null) return;
            var x = position.x, y = position.y; // Snap to grid if prop has been provided
            if (Array.isArray(_this.props.grid)) {
                var deltaX = x - _this.state.lastX || 0;
                var deltaY = y - _this.state.lastY || 0;
                var _snapToGrid3 = (0, $kNRmj.snapToGrid)(_this.props.grid, deltaX, deltaY);
                var _snapToGrid4 = $ac81e8f1d3f553a5$var$_slicedToArray(_snapToGrid3, 2);
                deltaX = _snapToGrid4[0];
                deltaY = _snapToGrid4[1];
                x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
            }
            var coreEvent = (0, $kNRmj.createCoreData)($ac81e8f1d3f553a5$var$_assertThisInitialized(_this), x, y); // Call event handler
            var shouldContinue = _this.props.onStop(e, coreEvent);
            if (shouldContinue === false || _this.mounted === false) return false;
            var thisNode = _this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (_this.props.enableUserSelectHack) (0, $aZZKx.removeUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, $ac81e8f1d3f553a5$var$_log.default)("DraggableCore: handleDragStop: %j", coreEvent); // Reset the el.
            _this.setState({
                dragging: false,
                lastX: NaN,
                lastY: NaN
            });
            if (thisNode) {
                // Remove event handlers
                (0, $ac81e8f1d3f553a5$var$_log.default)("DraggableCore: Removing handlers");
                (0, $aZZKx.removeEvent)(thisNode.ownerDocument, $ac81e8f1d3f553a5$var$dragEventFor.move, _this.handleDrag);
                (0, $aZZKx.removeEvent)(thisNode.ownerDocument, $ac81e8f1d3f553a5$var$dragEventFor.stop, _this.handleDragStop);
            }
        });
        $ac81e8f1d3f553a5$var$_defineProperty($ac81e8f1d3f553a5$var$_assertThisInitialized(_this), "onMouseDown", function(e) {
            $ac81e8f1d3f553a5$var$dragEventFor = $ac81e8f1d3f553a5$var$eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return _this.handleDragStart(e);
        });
        $ac81e8f1d3f553a5$var$_defineProperty($ac81e8f1d3f553a5$var$_assertThisInitialized(_this), "onMouseUp", function(e) {
            $ac81e8f1d3f553a5$var$dragEventFor = $ac81e8f1d3f553a5$var$eventsFor.mouse;
            return _this.handleDragStop(e);
        });
        $ac81e8f1d3f553a5$var$_defineProperty($ac81e8f1d3f553a5$var$_assertThisInitialized(_this), "onTouchStart", function(e) {
            // We're on a touch device now, so change the event handlers
            $ac81e8f1d3f553a5$var$dragEventFor = $ac81e8f1d3f553a5$var$eventsFor.touch;
            return _this.handleDragStart(e);
        });
        $ac81e8f1d3f553a5$var$_defineProperty($ac81e8f1d3f553a5$var$_assertThisInitialized(_this), "onTouchEnd", function(e) {
            // We're on a touch device now, so change the event handlers
            $ac81e8f1d3f553a5$var$dragEventFor = $ac81e8f1d3f553a5$var$eventsFor.touch;
            return _this.handleDragStop(e);
        });
        return _this;
    }
    $ac81e8f1d3f553a5$var$_createClass(DraggableCore, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
                // https://developers.google.com/web/updates/2017/01/scrolling-intervention
                var thisNode = this.findDOMNode();
                if (thisNode) (0, $aZZKx.addEvent)(thisNode, $ac81e8f1d3f553a5$var$eventsFor.touch.start, this.onTouchStart, {
                    passive: false
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
                // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
                var thisNode = this.findDOMNode();
                if (thisNode) {
                    var ownerDocument = thisNode.ownerDocument;
                    (0, $aZZKx.removeEvent)(ownerDocument, $ac81e8f1d3f553a5$var$eventsFor.mouse.move, this.handleDrag);
                    (0, $aZZKx.removeEvent)(ownerDocument, $ac81e8f1d3f553a5$var$eventsFor.touch.move, this.handleDrag);
                    (0, $aZZKx.removeEvent)(ownerDocument, $ac81e8f1d3f553a5$var$eventsFor.mouse.stop, this.handleDragStop);
                    (0, $aZZKx.removeEvent)(ownerDocument, $ac81e8f1d3f553a5$var$eventsFor.touch.stop, this.handleDragStop);
                    (0, $aZZKx.removeEvent)(thisNode, $ac81e8f1d3f553a5$var$eventsFor.touch.start, this.onTouchStart, {
                        passive: false
                    });
                    if (this.props.enableUserSelectHack) (0, $aZZKx.removeUserSelectStyles)(ownerDocument);
                }
            } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
        },
        {
            key: "findDOMNode",
            value: function findDOMNode() /*: ?HTMLElement*/ {
                var _this$props, _this$props2, _this$props2$nodeRef;
                return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$nodeRef = _this$props2.nodeRef) === null || _this$props2$nodeRef === void 0 ? void 0 : _this$props2$nodeRef.current : $ac81e8f1d3f553a5$var$_reactDom.default.findDOMNode(this);
            }
        },
        {
            key: "render",
            value: function render() /*: React.Element<any>*/ {
                // Reuse the child provided
                // This makes it flexible to use whatever element is wanted (div, ul, etc)
                return /*#__PURE__*/ $ac81e8f1d3f553a5$var$React.cloneElement($ac81e8f1d3f553a5$var$React.Children.only(this.props.children), {
                    // Note: mouseMove handler is attached to document so it will still function
                    // when the user drags quickly and leaves the bounds of the element.
                    onMouseDown: this.onMouseDown,
                    onMouseUp: this.onMouseUp,
                    // onTouchStart is added on `componentDidMount` so they can be added with
                    // {passive: false}, which allows it to cancel. See
                    // https://developers.google.com/web/updates/2017/01/scrolling-intervention
                    onTouchEnd: this.onTouchEnd
                });
            }
        }
    ]);
    return DraggableCore;
}($ac81e8f1d3f553a5$var$React.Component);
module.exports.default = $ac81e8f1d3f553a5$var$DraggableCore;
$ac81e8f1d3f553a5$var$_defineProperty($ac81e8f1d3f553a5$var$DraggableCore, "displayName", "DraggableCore");
$ac81e8f1d3f553a5$var$_defineProperty($ac81e8f1d3f553a5$var$DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: $ac81e8f1d3f553a5$var$_propTypes.default.bool,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: $ac81e8f1d3f553a5$var$_propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: $ac81e8f1d3f553a5$var$_propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function offsetParent(props, propName) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: $ac81e8f1d3f553a5$var$_propTypes.default.arrayOf($ac81e8f1d3f553a5$var$_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: $ac81e8f1d3f553a5$var$_propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: $ac81e8f1d3f553a5$var$_propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: $ac81e8f1d3f553a5$var$_propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: $ac81e8f1d3f553a5$var$_propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: $ac81e8f1d3f553a5$var$_propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: $ac81e8f1d3f553a5$var$_propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: $ac81e8f1d3f553a5$var$_propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: $ac81e8f1d3f553a5$var$_propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $euSu7.dontSetMe,
    style: $euSu7.dontSetMe,
    transform: $euSu7.dontSetMe
});
$ac81e8f1d3f553a5$var$_defineProperty($ac81e8f1d3f553a5$var$DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    disabled: false,
    enableUserSelectHack: true,
    onStart: function onStart() {},
    onDrag: function onDrag() {},
    onStop: function onStop() {},
    onMouseDown: function onMouseDown() {},
    scale: 1
});

});
parcelRegister("aZZKx", function(module, exports) {
"use strict";
function $801f801909f2b73b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $801f801909f2b73b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $801f801909f2b73b$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addClassName = $801f801909f2b73b$var$addClassName;
module.exports.addEvent = $801f801909f2b73b$var$addEvent;
module.exports.addUserSelectStyles = $801f801909f2b73b$var$addUserSelectStyles;
module.exports.createCSSTransform = $801f801909f2b73b$var$createCSSTransform;
module.exports.createSVGTransform = $801f801909f2b73b$var$createSVGTransform;
module.exports.getTouch = $801f801909f2b73b$var$getTouch;
module.exports.getTouchIdentifier = $801f801909f2b73b$var$getTouchIdentifier;
module.exports.getTranslation = $801f801909f2b73b$var$getTranslation;
module.exports.innerHeight = $801f801909f2b73b$var$innerHeight;
module.exports.innerWidth = $801f801909f2b73b$var$innerWidth;
module.exports.matchesSelector = $801f801909f2b73b$var$matchesSelector;
module.exports.matchesSelectorAndParentsTo = $801f801909f2b73b$var$matchesSelectorAndParentsTo;
module.exports.offsetXYFromParent = $801f801909f2b73b$var$offsetXYFromParent;
module.exports.outerHeight = $801f801909f2b73b$var$outerHeight;
module.exports.outerWidth = $801f801909f2b73b$var$outerWidth;
module.exports.removeClassName = $801f801909f2b73b$var$removeClassName;
module.exports.removeEvent = $801f801909f2b73b$var$removeEvent;
module.exports.removeUserSelectStyles = $801f801909f2b73b$var$removeUserSelectStyles;

var $euSu7 = parcelRequire("euSu7");

var $801f801909f2b73b$var$_getPrefix = $801f801909f2b73b$var$_interopRequireWildcard((parcelRequire("hCzNk")));
function $801f801909f2b73b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($801f801909f2b73b$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $801f801909f2b73b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $801f801909f2b73b$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $801f801909f2b73b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $801f801909f2b73b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $801f801909f2b73b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $801f801909f2b73b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $801f801909f2b73b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $801f801909f2b73b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $801f801909f2b73b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $801f801909f2b73b$var$matchesSelectorFunc = "";
function $801f801909f2b73b$var$matchesSelector(el, selector) /*: boolean*/ {
    if (!$801f801909f2b73b$var$matchesSelectorFunc) $801f801909f2b73b$var$matchesSelectorFunc = (0, $euSu7.findInArray)([
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector"
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, $euSu7.isFunction)(el[method]);
    });
     // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, $euSu7.isFunction)(el[$801f801909f2b73b$var$matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable
    return el[$801f801909f2b73b$var$matchesSelectorFunc](selector);
} // Works up the tree to the draggable itself attempting to match selector.
function $801f801909f2b73b$var$matchesSelectorAndParentsTo(el, selector, baseNode) /*: boolean*/ {
    var node = el;
    do {
        if ($801f801909f2b73b$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        node = node.parentNode;
    }while (node);
    return false;
}
function $801f801909f2b73b$var$addEvent(el, event, handler, inputOptions) /*: void*/ {
    if (!el) return;
    var options = $801f801909f2b73b$var$_objectSpread({
        capture: true
    }, inputOptions); // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent("on" + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el["on" + event] = handler;
}
function $801f801909f2b73b$var$removeEvent(el, event, handler, inputOptions) /*: void*/ {
    if (!el) return;
    var options = $801f801909f2b73b$var$_objectSpread({
        capture: true
    }, inputOptions); // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent("on" + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el["on" + event] = null;
}
function $801f801909f2b73b$var$outerHeight(node) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    var height = node.clientHeight;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, $euSu7.int)(computedStyle.borderTopWidth);
    height += (0, $euSu7.int)(computedStyle.borderBottomWidth);
    return height;
}
function $801f801909f2b73b$var$outerWidth(node) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    var width = node.clientWidth;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, $euSu7.int)(computedStyle.borderLeftWidth);
    width += (0, $euSu7.int)(computedStyle.borderRightWidth);
    return width;
}
function $801f801909f2b73b$var$innerHeight(node) /*: number*/ {
    var height = node.clientHeight;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, $euSu7.int)(computedStyle.paddingTop);
    height -= (0, $euSu7.int)(computedStyle.paddingBottom);
    return height;
}
function $801f801909f2b73b$var$innerWidth(node) /*: number*/ {
    var width = node.clientWidth;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, $euSu7.int)(computedStyle.paddingLeft);
    width -= (0, $euSu7.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function $801f801909f2b73b$var$offsetXYFromParent(evt, offsetParent, scale) /*: ControlPosition*/ {
    var isBody = offsetParent === offsetParent.ownerDocument.body;
    var offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $801f801909f2b73b$var$createCSSTransform(controlPos, positionOffset) /*: Object*/ {
    var translation = $801f801909f2b73b$var$getTranslation(controlPos, positionOffset, "px");
    return $801f801909f2b73b$var$_defineProperty({}, (0, $801f801909f2b73b$var$_getPrefix.browserPrefixToKey)("transform", $801f801909f2b73b$var$_getPrefix.default), translation);
}
function $801f801909f2b73b$var$createSVGTransform(controlPos, positionOffset) /*: string*/ {
    var translation = $801f801909f2b73b$var$getTranslation(controlPos, positionOffset, "");
    return translation;
}
function $801f801909f2b73b$var$getTranslation(_ref2, positionOffset, unitSuffix) /*: string*/ {
    var x = _ref2.x, y = _ref2.y;
    var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
    if (positionOffset) {
        var defaultX = "".concat(typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix);
        var defaultY = "".concat(typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix);
        translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
    }
    return translation;
}
function $801f801909f2b73b$var$getTouch(e, identifier) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, $euSu7.findInArray)(e.targetTouches, function(t) {
        return identifier === t.identifier;
    }) || e.changedTouches && (0, $euSu7.findInArray)(e.changedTouches, function(t) {
        return identifier === t.identifier;
    });
}
function $801f801909f2b73b$var$getTouchIdentifier(e) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
} // User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function $801f801909f2b73b$var$addUserSelectStyles(doc) {
    if (!doc) return;
    var styleEl = doc.getElementById("react-draggable-style-el");
    if (!styleEl) {
        styleEl = doc.createElement("style");
        styleEl.type = "text/css";
        styleEl.id = "react-draggable-style-el";
        styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
        styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
        doc.getElementsByTagName("head")[0].appendChild(styleEl);
    }
    if (doc.body) $801f801909f2b73b$var$addClassName(doc.body, "react-draggable-transparent-selection");
}
function $801f801909f2b73b$var$removeUserSelectStyles(doc) {
    if (!doc) return;
    try {
        if (doc.body) $801f801909f2b73b$var$removeClassName(doc.body, "react-draggable-transparent-selection"); // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            var selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== "Caret") selection.removeAllRanges();
        }
    } catch (e) {}
}
function $801f801909f2b73b$var$addClassName(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) el.className += " ".concat(className);
}
function $801f801909f2b73b$var$removeClassName(el, className) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), "g"), "");
}

});
parcelRegister("euSu7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dontSetMe = $a8de218e6a185049$var$dontSetMe;
module.exports.findInArray = $a8de218e6a185049$var$findInArray;
module.exports.int = $a8de218e6a185049$var$int;
module.exports.isFunction = $a8de218e6a185049$var$isFunction;
module.exports.isNum = $a8de218e6a185049$var$isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function $a8de218e6a185049$var$findInArray(array, callback) /*: any*/ {
    for(var i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $a8de218e6a185049$var$isFunction(func) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function $a8de218e6a185049$var$isNum(num) /*: boolean %checks*/ {
    return typeof num === "number" && !isNaN(num);
}
function $a8de218e6a185049$var$int(a) /*: number*/ {
    return parseInt(a, 10);
}
function $a8de218e6a185049$var$dontSetMe(props, propName, componentName) /*: ?Error*/ {
    if (props[propName]) return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
}

});


parcelRegister("kNRmj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canDragX = $f251c631a5e90aad$var$canDragX;
module.exports.canDragY = $f251c631a5e90aad$var$canDragY;
module.exports.createCoreData = $f251c631a5e90aad$var$createCoreData;
module.exports.createDraggableData = $f251c631a5e90aad$var$createDraggableData;
module.exports.getBoundPosition = $f251c631a5e90aad$var$getBoundPosition;
module.exports.getControlPosition = $f251c631a5e90aad$var$getControlPosition;
module.exports.snapToGrid = $f251c631a5e90aad$var$snapToGrid;

var $euSu7 = parcelRequire("euSu7");

var $aZZKx = parcelRequire("aZZKx");
function $f251c631a5e90aad$var$getBoundPosition(draggable, x, y) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ]; // Clone new bounds
    var bounds = draggable.props.bounds;
    bounds = typeof bounds === "string" ? bounds : $f251c631a5e90aad$var$cloneBounds(bounds);
    var node = $f251c631a5e90aad$var$findDOMNode(draggable);
    if (typeof bounds === "string") {
        var ownerDocument = node.ownerDocument;
        var ownerWindow = ownerDocument.defaultView;
        var boundNode;
        if (bounds === "parent") boundNode = node.parentNode;
        else boundNode = ownerDocument.querySelector(bounds);
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        var boundNodeEl = boundNode; // for Flow, can't seem to refine correctly
        var nodeStyle = ownerWindow.getComputedStyle(node);
        var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, $euSu7.int)(boundNodeStyle.paddingLeft) + (0, $euSu7.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, $euSu7.int)(boundNodeStyle.paddingTop) + (0, $euSu7.int)(nodeStyle.marginTop),
            right: (0, $aZZKx.innerWidth)(boundNodeEl) - (0, $aZZKx.outerWidth)(node) - node.offsetLeft + (0, $euSu7.int)(boundNodeStyle.paddingRight) - (0, $euSu7.int)(nodeStyle.marginRight),
            bottom: (0, $aZZKx.innerHeight)(boundNodeEl) - (0, $aZZKx.outerHeight)(node) - node.offsetTop + (0, $euSu7.int)(boundNodeStyle.paddingBottom) - (0, $euSu7.int)(nodeStyle.marginBottom)
        };
    } // Keep x and y below right and bottom limits...
    if ((0, $euSu7.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, $euSu7.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.
    if ((0, $euSu7.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, $euSu7.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $f251c631a5e90aad$var$snapToGrid(grid, pendingX, pendingY) /*: [number, number]*/ {
    var x = Math.round(pendingX / grid[0]) * grid[0];
    var y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $f251c631a5e90aad$var$canDragX(draggable) /*: boolean*/ {
    return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function $f251c631a5e90aad$var$canDragY(draggable) /*: boolean*/ {
    return draggable.props.axis === "both" || draggable.props.axis === "y";
} // Get {x, y} positions from event.
function $f251c631a5e90aad$var$getControlPosition(e, touchIdentifier, draggableCore) /*: ?ControlPosition*/ {
    var touchObj = typeof touchIdentifier === "number" ? (0, $aZZKx.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === "number" && !touchObj) return null; // not the right touch
    var node = $f251c631a5e90aad$var$findDOMNode(draggableCore); // User can provide an offsetParent if desired.
    var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, $aZZKx.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
} // Create an data object exposed by <DraggableCore>'s events
function $f251c631a5e90aad$var$createCoreData(draggable, x, y) /*: DraggableData*/ {
    var state = draggable.state;
    var isStart = !(0, $euSu7.isNum)(state.lastX);
    var node = $f251c631a5e90aad$var$findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - state.lastX,
        deltaY: y - state.lastY,
        lastX: state.lastX,
        lastY: state.lastY,
        x: x,
        y: y
    };
} // Create an data exposed by <Draggable>'s events
function $f251c631a5e90aad$var$createDraggableData(draggable, coreData) /*: DraggableData*/ {
    var scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
} // A lot faster than stringify/parse
function $f251c631a5e90aad$var$cloneBounds(bounds) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $f251c631a5e90aad$var$findDOMNode(draggable) /*: HTMLElement*/ {
    var node = draggable.findDOMNode();
    if (!node) throw new Error("<DraggableCore>: Unmounted during event!");
     // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

});

parcelRegister("9jJTo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6c897cb00cab59f6$var$log;
/*eslint no-console:0*/ function $6c897cb00cab59f6$var$log() {
    var _console;
}

});


var $dacb60b4a8b72d9f$exports = {};


(parcelRequire("3cRH8")).register((parcelRequire("kjrOk")).getBundleURL("5D0wD"), JSON.parse('["5D0wD","main.js","2QIXb","logo_horizontal.430beba6.svg","7mCCf","streetmix-plus.68cd7941.svg","725mG","forums.51f20df5.svg","jPnm6","google.7467d21e.svg","czXQO","slack.f7fc8c2e.svg","2gWn0","warning_alert.4eede6c8.svg","jDlfJ","warning_error.77ec3a4f.svg","cZd4f","numo.8fff37bf.svg","1I2uK","codeforamerica.506a3ceb.png","fntbD","mozilla.a364f65c.svg","e3SUe","wm-icon-animated.b8b2b365.svg","83vJl","1F620.49614bd7.svg","9DXMz","1F641.c7d9ee53.svg","2Q2vs","1F610.71d15170.svg","jdDBa","1F60A.8a356ca2.svg","g4G4h","1F60D.827fe010.svg","fGX7O","main.css"]'));

/**
 * Streetmix
 *
 */ "use strict";
var $f15c226ae83425ec$exports = {};
"use strict";
var $f15c226ae83425ec$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$f15c226ae83425ec$exports = // eslint-disable-next-line es/no-global-this -- safe
$f15c226ae83425ec$var$check(typeof globalThis == "object" && globalThis) || $f15c226ae83425ec$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$f15c226ae83425ec$var$check(typeof self == "object" && self) || $f15c226ae83425ec$var$check(typeof $parcel$global == "object" && $parcel$global) || $f15c226ae83425ec$var$check(typeof $f15c226ae83425ec$exports == "object" && $f15c226ae83425ec$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


var $a0dcf23c5a770a17$exports = {};
"use strict";
var $74f43415f059679c$exports = {};
"use strict";
$74f43415f059679c$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$a0dcf23c5a770a17$exports = !$74f43415f059679c$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $0dd23fb31b34e54e$exports = {};
"use strict";
var $e8293524b8a3c076$exports = {};
"use strict";
var $9f4fe1f27df707da$exports = {};
"use strict";
var $88972db07a8828dd$exports = {};
"use strict";

$88972db07a8828dd$exports = !$74f43415f059679c$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $9f4fe1f27df707da$var$FunctionPrototype = Function.prototype;
var $9f4fe1f27df707da$var$call = $9f4fe1f27df707da$var$FunctionPrototype.call;
var $9f4fe1f27df707da$var$uncurryThisWithBind = $88972db07a8828dd$exports && $9f4fe1f27df707da$var$FunctionPrototype.bind.bind($9f4fe1f27df707da$var$call, $9f4fe1f27df707da$var$call);
$9f4fe1f27df707da$exports = $88972db07a8828dd$exports ? $9f4fe1f27df707da$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $9f4fe1f27df707da$var$call.apply(fn, arguments);
    };
};



var $5c717df53b8d533a$exports = {};
"use strict";
var $28037836d3181f91$exports = {};
"use strict";
var $28037836d3181f91$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $28037836d3181f91$var$IS_HTMLDDA = typeof $28037836d3181f91$var$documentAll == "undefined" && $28037836d3181f91$var$documentAll !== undefined;
$28037836d3181f91$exports = {
    all: $28037836d3181f91$var$documentAll,
    IS_HTMLDDA: $28037836d3181f91$var$IS_HTMLDDA
};


var $5c717df53b8d533a$var$documentAll = $28037836d3181f91$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$5c717df53b8d533a$exports = $28037836d3181f91$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $5c717df53b8d533a$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


var $157a284e0766dd8e$exports = {};
"use strict";

var $2cff4c49640a3231$exports = {};
"use strict";
var $b6bcb5f83b47fa34$exports = {};
"use strict";
var $a99f577b427e43bd$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$a99f577b427e43bd$exports = function(it) {
    return it === null || it === undefined;
};


var $b6bcb5f83b47fa34$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$b6bcb5f83b47fa34$exports = function(it) {
    if ($a99f577b427e43bd$exports(it)) throw new $b6bcb5f83b47fa34$var$$TypeError("Can't call method on " + it);
    return it;
};


var $2cff4c49640a3231$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$2cff4c49640a3231$exports = function(argument) {
    return $2cff4c49640a3231$var$$Object($b6bcb5f83b47fa34$exports(argument));
};


var $157a284e0766dd8e$var$hasOwnProperty = $9f4fe1f27df707da$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$157a284e0766dd8e$exports = Object.hasOwn || function hasOwn(it, key) {
    return $157a284e0766dd8e$var$hasOwnProperty($2cff4c49640a3231$exports(it), key);
};



var $66eaf0165c15da97$exports = {};
"use strict";


var $66eaf0165c15da97$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $66eaf0165c15da97$var$getDescriptor = $a0dcf23c5a770a17$exports && Object.getOwnPropertyDescriptor;
var $66eaf0165c15da97$var$EXISTS = $157a284e0766dd8e$exports($66eaf0165c15da97$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $66eaf0165c15da97$var$PROPER = $66eaf0165c15da97$var$EXISTS && (function something() {}).name === "something";
var $66eaf0165c15da97$var$CONFIGURABLE = $66eaf0165c15da97$var$EXISTS && (!$a0dcf23c5a770a17$exports || $a0dcf23c5a770a17$exports && $66eaf0165c15da97$var$getDescriptor($66eaf0165c15da97$var$FunctionPrototype, "name").configurable);
$66eaf0165c15da97$exports = {
    EXISTS: $66eaf0165c15da97$var$EXISTS,
    PROPER: $66eaf0165c15da97$var$PROPER,
    CONFIGURABLE: $66eaf0165c15da97$var$CONFIGURABLE
};


var $e8293524b8a3c076$require$CONFIGURABLE_FUNCTION_NAME = $66eaf0165c15da97$exports.CONFIGURABLE;
var $073a5279b9c9b941$exports = {};
"use strict";


var $caa386a1c72a6a51$exports = {};
"use strict";

var $e7348875cfd0b6ef$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $e7348875cfd0b6ef$var$defineProperty = Object.defineProperty;
$e7348875cfd0b6ef$exports = function(key, value) {
    try {
        $e7348875cfd0b6ef$var$defineProperty($f15c226ae83425ec$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $f15c226ae83425ec$exports[key] = value;
    }
    return value;
};


var $caa386a1c72a6a51$var$SHARED = "__core-js_shared__";
var $caa386a1c72a6a51$var$store = $f15c226ae83425ec$exports[$caa386a1c72a6a51$var$SHARED] || $e7348875cfd0b6ef$exports($caa386a1c72a6a51$var$SHARED, {});
$caa386a1c72a6a51$exports = $caa386a1c72a6a51$var$store;


var $073a5279b9c9b941$var$functionToString = $9f4fe1f27df707da$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$5c717df53b8d533a$exports($caa386a1c72a6a51$exports.inspectSource)) $caa386a1c72a6a51$exports.inspectSource = function(it) {
    return $073a5279b9c9b941$var$functionToString(it);
};
$073a5279b9c9b941$exports = $caa386a1c72a6a51$exports.inspectSource;


var $6977b9424853584f$exports = {};
"use strict";
var $c92297e502bb7f1b$exports = {};
"use strict";


var $c92297e502bb7f1b$var$WeakMap = $f15c226ae83425ec$exports.WeakMap;
$c92297e502bb7f1b$exports = $5c717df53b8d533a$exports($c92297e502bb7f1b$var$WeakMap) && /native code/.test(String($c92297e502bb7f1b$var$WeakMap));



var $42b05d948cc94343$exports = {};
"use strict";


var $42b05d948cc94343$var$documentAll = $28037836d3181f91$exports.all;
$42b05d948cc94343$exports = $28037836d3181f91$exports.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $5c717df53b8d533a$exports(it) || it === $42b05d948cc94343$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $5c717df53b8d533a$exports(it);
};


var $7e5a9998baa652f2$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $9f306fabc920baa3$export$2d1720544b23b823;
"use strict";

var $6c0cf762d2d29930$exports = {};
"use strict";


var $2ac0cbfabeafe1fb$exports = {};
"use strict";


var $2ac0cbfabeafe1fb$var$document = $f15c226ae83425ec$exports.document;
// typeof document.createElement is 'object' in old IE
var $2ac0cbfabeafe1fb$var$EXISTS = $42b05d948cc94343$exports($2ac0cbfabeafe1fb$var$document) && $42b05d948cc94343$exports($2ac0cbfabeafe1fb$var$document.createElement);
$2ac0cbfabeafe1fb$exports = function(it) {
    return $2ac0cbfabeafe1fb$var$EXISTS ? $2ac0cbfabeafe1fb$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$6c0cf762d2d29930$exports = !$a0dcf23c5a770a17$exports && !$74f43415f059679c$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($2ac0cbfabeafe1fb$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


var $de801605167b57f6$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$de801605167b57f6$exports = $a0dcf23c5a770a17$exports && $74f43415f059679c$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $704929e20c6cac0a$exports = {};
"use strict";

var $704929e20c6cac0a$var$$String = String;
var $704929e20c6cac0a$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$704929e20c6cac0a$exports = function(argument) {
    if ($42b05d948cc94343$exports(argument)) return argument;
    throw new $704929e20c6cac0a$var$$TypeError($704929e20c6cac0a$var$$String(argument) + " is not an object");
};


var $61211463e7bcd6b2$exports = {};
"use strict";
var $a14fd19c22cf62bd$exports = {};
"use strict";
var $f4093159827c6b26$exports = {};
"use strict";

var $f4093159827c6b26$var$call = Function.prototype.call;
$f4093159827c6b26$exports = $88972db07a8828dd$exports ? $f4093159827c6b26$var$call.bind($f4093159827c6b26$var$call) : function() {
    return $f4093159827c6b26$var$call.apply($f4093159827c6b26$var$call, arguments);
};



var $36ed0f7192f435e0$exports = {};
"use strict";
var $b8ea96c154cbe99b$exports = {};
"use strict";


var $b8ea96c154cbe99b$var$aFunction = function(argument) {
    return $5c717df53b8d533a$exports(argument) ? argument : undefined;
};
$b8ea96c154cbe99b$exports = function(namespace, method) {
    return arguments.length < 2 ? $b8ea96c154cbe99b$var$aFunction($f15c226ae83425ec$exports[namespace]) : $f15c226ae83425ec$exports[namespace] && $f15c226ae83425ec$exports[namespace][method];
};



var $3ebdbce249bfe864$exports = {};
"use strict";

$3ebdbce249bfe864$exports = $9f4fe1f27df707da$exports({}.isPrototypeOf);


var $83ea3a015fc551ca$exports = {};
"use strict";
var $c89e0303b4f51647$exports = {};
"use strict";
var $c61dd49338cf00be$exports = {};
"use strict";

var $afe893cfdbf38dcb$exports = {};
"use strict";
$afe893cfdbf38dcb$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $c61dd49338cf00be$var$process = $f15c226ae83425ec$exports.process;
var $c61dd49338cf00be$var$Deno = $f15c226ae83425ec$exports.Deno;
var $c61dd49338cf00be$var$versions = $c61dd49338cf00be$var$process && $c61dd49338cf00be$var$process.versions || $c61dd49338cf00be$var$Deno && $c61dd49338cf00be$var$Deno.version;
var $c61dd49338cf00be$var$v8 = $c61dd49338cf00be$var$versions && $c61dd49338cf00be$var$versions.v8;
var $c61dd49338cf00be$var$match, $c61dd49338cf00be$var$version;
if ($c61dd49338cf00be$var$v8) {
    $c61dd49338cf00be$var$match = $c61dd49338cf00be$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $c61dd49338cf00be$var$version = $c61dd49338cf00be$var$match[0] > 0 && $c61dd49338cf00be$var$match[0] < 4 ? 1 : +($c61dd49338cf00be$var$match[0] + $c61dd49338cf00be$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$c61dd49338cf00be$var$version && $afe893cfdbf38dcb$exports) {
    $c61dd49338cf00be$var$match = $afe893cfdbf38dcb$exports.match(/Edge\/(\d+)/);
    if (!$c61dd49338cf00be$var$match || $c61dd49338cf00be$var$match[1] >= 74) {
        $c61dd49338cf00be$var$match = $afe893cfdbf38dcb$exports.match(/Chrome\/(\d+)/);
        if ($c61dd49338cf00be$var$match) $c61dd49338cf00be$var$version = +$c61dd49338cf00be$var$match[1];
    }
}
$c61dd49338cf00be$exports = $c61dd49338cf00be$var$version;




var $c89e0303b4f51647$var$$String = $f15c226ae83425ec$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$c89e0303b4f51647$exports = !!Object.getOwnPropertySymbols && !$74f43415f059679c$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$c89e0303b4f51647$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $c61dd49338cf00be$exports && $c61dd49338cf00be$exports < 41;
});


$83ea3a015fc551ca$exports = $c89e0303b4f51647$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $36ed0f7192f435e0$var$$Object = Object;
$36ed0f7192f435e0$exports = $83ea3a015fc551ca$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $b8ea96c154cbe99b$exports("Symbol");
    return $5c717df53b8d533a$exports($Symbol) && $3ebdbce249bfe864$exports($Symbol.prototype, $36ed0f7192f435e0$var$$Object(it));
};


var $b05026cfbbf9899e$exports = {};
"use strict";
var $9b2b3ea08eccde72$exports = {};
"use strict";

var $61987aca7fe1d459$exports = {};
"use strict";
var $61987aca7fe1d459$var$$String = String;
$61987aca7fe1d459$exports = function(argument) {
    try {
        return $61987aca7fe1d459$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $9b2b3ea08eccde72$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$9b2b3ea08eccde72$exports = function(argument) {
    if ($5c717df53b8d533a$exports(argument)) return argument;
    throw new $9b2b3ea08eccde72$var$$TypeError($61987aca7fe1d459$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$b05026cfbbf9899e$exports = function(V, P) {
    var func = V[P];
    return $a99f577b427e43bd$exports(func) ? undefined : $9b2b3ea08eccde72$exports(func);
};


var $041757ac061b2875$exports = {};
"use strict";



var $041757ac061b2875$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$041757ac061b2875$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $5c717df53b8d533a$exports(fn = input.toString) && !$42b05d948cc94343$exports(val = $f4093159827c6b26$exports(fn, input))) return val;
    if ($5c717df53b8d533a$exports(fn = input.valueOf) && !$42b05d948cc94343$exports(val = $f4093159827c6b26$exports(fn, input))) return val;
    if (pref !== "string" && $5c717df53b8d533a$exports(fn = input.toString) && !$42b05d948cc94343$exports(val = $f4093159827c6b26$exports(fn, input))) return val;
    throw new $041757ac061b2875$var$$TypeError("Can't convert object to primitive value");
};


var $bc302ad56689cbe3$exports = {};
"use strict";

var $376219e9d1c315f2$exports = {};
"use strict";
var $bd6f1f41daa59b6b$exports = {};
"use strict";
$bd6f1f41daa59b6b$exports = false;



($376219e9d1c315f2$exports = function(key, value) {
    return $caa386a1c72a6a51$exports[key] || ($caa386a1c72a6a51$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.34.0",
    mode: $bd6f1f41daa59b6b$exports ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.34.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});



var $0dc1d96c46d424bf$exports = {};
"use strict";

var $0dc1d96c46d424bf$var$id = 0;
var $0dc1d96c46d424bf$var$postfix = Math.random();
var $0dc1d96c46d424bf$var$toString = $9f4fe1f27df707da$exports(1.0.toString);
$0dc1d96c46d424bf$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $0dc1d96c46d424bf$var$toString(++$0dc1d96c46d424bf$var$id + $0dc1d96c46d424bf$var$postfix, 36);
};




var $bc302ad56689cbe3$var$Symbol = $f15c226ae83425ec$exports.Symbol;
var $bc302ad56689cbe3$var$WellKnownSymbolsStore = $376219e9d1c315f2$exports("wks");
var $bc302ad56689cbe3$var$createWellKnownSymbol = $83ea3a015fc551ca$exports ? $bc302ad56689cbe3$var$Symbol["for"] || $bc302ad56689cbe3$var$Symbol : $bc302ad56689cbe3$var$Symbol && $bc302ad56689cbe3$var$Symbol.withoutSetter || $0dc1d96c46d424bf$exports;
$bc302ad56689cbe3$exports = function(name) {
    if (!$157a284e0766dd8e$exports($bc302ad56689cbe3$var$WellKnownSymbolsStore, name)) $bc302ad56689cbe3$var$WellKnownSymbolsStore[name] = $c89e0303b4f51647$exports && $157a284e0766dd8e$exports($bc302ad56689cbe3$var$Symbol, name) ? $bc302ad56689cbe3$var$Symbol[name] : $bc302ad56689cbe3$var$createWellKnownSymbol("Symbol." + name);
    return $bc302ad56689cbe3$var$WellKnownSymbolsStore[name];
};


var $a14fd19c22cf62bd$var$$TypeError = TypeError;
var $a14fd19c22cf62bd$var$TO_PRIMITIVE = $bc302ad56689cbe3$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$a14fd19c22cf62bd$exports = function(input, pref) {
    if (!$42b05d948cc94343$exports(input) || $36ed0f7192f435e0$exports(input)) return input;
    var exoticToPrim = $b05026cfbbf9899e$exports(input, $a14fd19c22cf62bd$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $f4093159827c6b26$exports(exoticToPrim, input, pref);
        if (!$42b05d948cc94343$exports(result) || $36ed0f7192f435e0$exports(result)) return result;
        throw new $a14fd19c22cf62bd$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $041757ac061b2875$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$61211463e7bcd6b2$exports = function(argument) {
    var key = $a14fd19c22cf62bd$exports(argument, "string");
    return $36ed0f7192f435e0$exports(key) ? key : key + "";
};


var $9f306fabc920baa3$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $9f306fabc920baa3$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $9f306fabc920baa3$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $9f306fabc920baa3$var$ENUMERABLE = "enumerable";
var $9f306fabc920baa3$var$CONFIGURABLE = "configurable";
var $9f306fabc920baa3$var$WRITABLE = "writable";
$9f306fabc920baa3$export$2d1720544b23b823 = $a0dcf23c5a770a17$exports ? $de801605167b57f6$exports ? function defineProperty(O, P, Attributes) {
    $704929e20c6cac0a$exports(O);
    P = $61211463e7bcd6b2$exports(P);
    $704929e20c6cac0a$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $9f306fabc920baa3$var$WRITABLE in Attributes && !Attributes[$9f306fabc920baa3$var$WRITABLE]) {
        var current = $9f306fabc920baa3$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$9f306fabc920baa3$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $9f306fabc920baa3$var$CONFIGURABLE in Attributes ? Attributes[$9f306fabc920baa3$var$CONFIGURABLE] : current[$9f306fabc920baa3$var$CONFIGURABLE],
                enumerable: $9f306fabc920baa3$var$ENUMERABLE in Attributes ? Attributes[$9f306fabc920baa3$var$ENUMERABLE] : current[$9f306fabc920baa3$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $9f306fabc920baa3$var$$defineProperty(O, P, Attributes);
} : $9f306fabc920baa3$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $704929e20c6cac0a$exports(O);
    P = $61211463e7bcd6b2$exports(P);
    $704929e20c6cac0a$exports(Attributes);
    if ($6c0cf762d2d29930$exports) try {
        return $9f306fabc920baa3$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $9f306fabc920baa3$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};


var $e0f181a8b4949a22$exports = {};
"use strict";
$e0f181a8b4949a22$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$7e5a9998baa652f2$exports = $a0dcf23c5a770a17$exports ? function(object, key, value) {
    return $9f306fabc920baa3$export$2d1720544b23b823(object, key, $e0f181a8b4949a22$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $dfcdde4620bfe45a$exports = {};
"use strict";


var $dfcdde4620bfe45a$var$keys = $376219e9d1c315f2$exports("keys");
$dfcdde4620bfe45a$exports = function(key) {
    return $dfcdde4620bfe45a$var$keys[key] || ($dfcdde4620bfe45a$var$keys[key] = $0dc1d96c46d424bf$exports(key));
};


var $4e69f514a119f738$exports = {};
"use strict";
$4e69f514a119f738$exports = {};


var $6977b9424853584f$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $6977b9424853584f$var$TypeError = $f15c226ae83425ec$exports.TypeError;
var $6977b9424853584f$var$WeakMap = $f15c226ae83425ec$exports.WeakMap;
var $6977b9424853584f$var$set, $6977b9424853584f$var$get, $6977b9424853584f$var$has;
var $6977b9424853584f$var$enforce = function(it) {
    return $6977b9424853584f$var$has(it) ? $6977b9424853584f$var$get(it) : $6977b9424853584f$var$set(it, {});
};
var $6977b9424853584f$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$42b05d948cc94343$exports(it) || (state = $6977b9424853584f$var$get(it)).type !== TYPE) throw new $6977b9424853584f$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($c92297e502bb7f1b$exports || $caa386a1c72a6a51$exports.state) {
    var $6977b9424853584f$var$store = $caa386a1c72a6a51$exports.state || ($caa386a1c72a6a51$exports.state = new $6977b9424853584f$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $6977b9424853584f$var$store.get = $6977b9424853584f$var$store.get;
    $6977b9424853584f$var$store.has = $6977b9424853584f$var$store.has;
    $6977b9424853584f$var$store.set = $6977b9424853584f$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $6977b9424853584f$var$set = function(it, metadata) {
        if ($6977b9424853584f$var$store.has(it)) throw new $6977b9424853584f$var$TypeError($6977b9424853584f$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $6977b9424853584f$var$store.set(it, metadata);
        return metadata;
    };
    $6977b9424853584f$var$get = function(it) {
        return $6977b9424853584f$var$store.get(it) || {};
    };
    $6977b9424853584f$var$has = function(it) {
        return $6977b9424853584f$var$store.has(it);
    };
} else {
    var $6977b9424853584f$var$STATE = $dfcdde4620bfe45a$exports("state");
    $4e69f514a119f738$exports[$6977b9424853584f$var$STATE] = true;
    $6977b9424853584f$var$set = function(it, metadata) {
        if ($157a284e0766dd8e$exports(it, $6977b9424853584f$var$STATE)) throw new $6977b9424853584f$var$TypeError($6977b9424853584f$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $7e5a9998baa652f2$exports(it, $6977b9424853584f$var$STATE, metadata);
        return metadata;
    };
    $6977b9424853584f$var$get = function(it) {
        return $157a284e0766dd8e$exports(it, $6977b9424853584f$var$STATE) ? it[$6977b9424853584f$var$STATE] : {};
    };
    $6977b9424853584f$var$has = function(it) {
        return $157a284e0766dd8e$exports(it, $6977b9424853584f$var$STATE);
    };
}
$6977b9424853584f$exports = {
    set: $6977b9424853584f$var$set,
    get: $6977b9424853584f$var$get,
    has: $6977b9424853584f$var$has,
    enforce: $6977b9424853584f$var$enforce,
    getterFor: $6977b9424853584f$var$getterFor
};


var $e8293524b8a3c076$var$enforceInternalState = $6977b9424853584f$exports.enforce;
var $e8293524b8a3c076$var$getInternalState = $6977b9424853584f$exports.get;
var $e8293524b8a3c076$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $e8293524b8a3c076$var$defineProperty = Object.defineProperty;
var $e8293524b8a3c076$var$stringSlice = $9f4fe1f27df707da$exports("".slice);
var $e8293524b8a3c076$var$replace = $9f4fe1f27df707da$exports("".replace);
var $e8293524b8a3c076$var$join = $9f4fe1f27df707da$exports([].join);
var $e8293524b8a3c076$var$CONFIGURABLE_LENGTH = $a0dcf23c5a770a17$exports && !$74f43415f059679c$exports(function() {
    return $e8293524b8a3c076$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $e8293524b8a3c076$var$TEMPLATE = String(String).split("String");
var $e8293524b8a3c076$var$makeBuiltIn = $e8293524b8a3c076$exports = function(value, name, options) {
    if ($e8293524b8a3c076$var$stringSlice($e8293524b8a3c076$var$$String(name), 0, 7) === "Symbol(") name = "[" + $e8293524b8a3c076$var$replace($e8293524b8a3c076$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$157a284e0766dd8e$exports(value, "name") || $e8293524b8a3c076$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($a0dcf23c5a770a17$exports) $e8293524b8a3c076$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($e8293524b8a3c076$var$CONFIGURABLE_LENGTH && options && $157a284e0766dd8e$exports(options, "arity") && value.length !== options.arity) $e8293524b8a3c076$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $157a284e0766dd8e$exports(options, "constructor") && options.constructor) {
            if ($a0dcf23c5a770a17$exports) $e8293524b8a3c076$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $e8293524b8a3c076$var$enforceInternalState(value);
    if (!$157a284e0766dd8e$exports(state, "source")) state.source = $e8293524b8a3c076$var$join($e8293524b8a3c076$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $e8293524b8a3c076$var$makeBuiltIn(function toString() {
    return $5c717df53b8d533a$exports(this) && $e8293524b8a3c076$var$getInternalState(this).source || $073a5279b9c9b941$exports(this);
}, "toString");



$0dd23fb31b34e54e$exports = function(target, name, descriptor) {
    if (descriptor.get) $e8293524b8a3c076$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $e8293524b8a3c076$exports(descriptor.set, name, {
        setter: true
    });
    return $9f306fabc920baa3$export$2d1720544b23b823(target, name, descriptor);
};


var $0935d5d2c13e8b24$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$0935d5d2c13e8b24$exports = function() {
    var that = $704929e20c6cac0a$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};



// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $2c63ec04a4ef0a99$var$RegExp = $f15c226ae83425ec$exports.RegExp;
var $2c63ec04a4ef0a99$var$RegExpPrototype = $2c63ec04a4ef0a99$var$RegExp.prototype;
var $2c63ec04a4ef0a99$var$FORCED = $a0dcf23c5a770a17$exports && $74f43415f059679c$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $2c63ec04a4ef0a99$var$RegExp(".", "d");
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = "";
    var expected = INDICES_SUPPORT ? "dgimsy" : "gimsy";
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: "s",
        global: "g",
        ignoreCase: "i",
        multiline: "m",
        sticky: "y"
    };
    if (INDICES_SUPPORT) pairs.hasIndices = "d";
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($2c63ec04a4ef0a99$var$RegExpPrototype, "flags").get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($2c63ec04a4ef0a99$var$FORCED) $0dd23fb31b34e54e$exports($2c63ec04a4ef0a99$var$RegExpPrototype, "flags", {
    configurable: true,
    get: $0935d5d2c13e8b24$exports
});


"use strict";


var $075335069f3df110$exports = {};
"use strict";
var $a0e98215756e32b2$exports = {};
"use strict";
// eslint-disable-next-line es/no-typed-arrays -- safe
$a0e98215756e32b2$exports = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";







var $4020a0df4be35de1$exports = {};
"use strict";
var $b3c09226d0807451$exports = {};
"use strict";

var $b3c09226d0807451$var$TO_STRING_TAG = $bc302ad56689cbe3$exports("toStringTag");
var $b3c09226d0807451$var$test = {};
$b3c09226d0807451$var$test[$b3c09226d0807451$var$TO_STRING_TAG] = "z";
$b3c09226d0807451$exports = String($b3c09226d0807451$var$test) === "[object z]";



var $e135b923393ad6cb$exports = {};
"use strict";

var $e135b923393ad6cb$var$toString = $9f4fe1f27df707da$exports({}.toString);
var $e135b923393ad6cb$var$stringSlice = $9f4fe1f27df707da$exports("".slice);
$e135b923393ad6cb$exports = function(it) {
    return $e135b923393ad6cb$var$stringSlice($e135b923393ad6cb$var$toString(it), 8, -1);
};



var $4020a0df4be35de1$var$TO_STRING_TAG = $bc302ad56689cbe3$exports("toStringTag");
var $4020a0df4be35de1$var$$Object = Object;
// ES3 wrong here
var $4020a0df4be35de1$var$CORRECT_ARGUMENTS = $e135b923393ad6cb$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $4020a0df4be35de1$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$4020a0df4be35de1$exports = $b3c09226d0807451$exports ? $e135b923393ad6cb$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $4020a0df4be35de1$var$tryGet(O = $4020a0df4be35de1$var$$Object(it), $4020a0df4be35de1$var$TO_STRING_TAG)) == "string" ? tag : $4020a0df4be35de1$var$CORRECT_ARGUMENTS ? $e135b923393ad6cb$exports(O) : (result = $e135b923393ad6cb$exports(O)) === "Object" && $5c717df53b8d533a$exports(O.callee) ? "Arguments" : result;
};




var $ba7fdff3b770f3c7$exports = {};
"use strict";




$ba7fdff3b770f3c7$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($5c717df53b8d533a$exports(value)) $e8293524b8a3c076$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $e7348875cfd0b6ef$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $9f306fabc920baa3$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};




var $4cd81123e9998126$exports = {};
"use strict";




var $69e1bd1d19421dd8$exports = {};
"use strict";

$69e1bd1d19421dd8$exports = !$74f43415f059679c$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $4cd81123e9998126$var$IE_PROTO = $dfcdde4620bfe45a$exports("IE_PROTO");
var $4cd81123e9998126$var$$Object = Object;
var $4cd81123e9998126$var$ObjectPrototype = $4cd81123e9998126$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$4cd81123e9998126$exports = $69e1bd1d19421dd8$exports ? $4cd81123e9998126$var$$Object.getPrototypeOf : function(O) {
    var object = $2cff4c49640a3231$exports(O);
    if ($157a284e0766dd8e$exports(object, $4cd81123e9998126$var$IE_PROTO)) return object[$4cd81123e9998126$var$IE_PROTO];
    var constructor = object.constructor;
    if ($5c717df53b8d533a$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $4cd81123e9998126$var$$Object ? $4cd81123e9998126$var$ObjectPrototype : null;
};


var $61c0848bbefa3fe4$exports = {};
"use strict";
var $e639e0204c7d041f$exports = {};
"use strict";


$e639e0204c7d041f$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $9f4fe1f27df707da$exports($9b2b3ea08eccde72$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};



var $597aef8e66c2bd15$exports = {};
"use strict";

var $597aef8e66c2bd15$var$$String = String;
var $597aef8e66c2bd15$var$$TypeError = TypeError;
$597aef8e66c2bd15$exports = function(argument) {
    if (typeof argument == "object" || $5c717df53b8d533a$exports(argument)) return argument;
    throw new $597aef8e66c2bd15$var$$TypeError("Can't set " + $597aef8e66c2bd15$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$61c0848bbefa3fe4$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $e639e0204c7d041f$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $704929e20c6cac0a$exports(O);
        $597aef8e66c2bd15$exports(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);





var $075335069f3df110$var$enforceInternalState = $6977b9424853584f$exports.enforce;
var $075335069f3df110$var$getInternalState = $6977b9424853584f$exports.get;
var $075335069f3df110$var$Int8Array = $f15c226ae83425ec$exports.Int8Array;
var $075335069f3df110$var$Int8ArrayPrototype = $075335069f3df110$var$Int8Array && $075335069f3df110$var$Int8Array.prototype;
var $075335069f3df110$var$Uint8ClampedArray = $f15c226ae83425ec$exports.Uint8ClampedArray;
var $075335069f3df110$var$Uint8ClampedArrayPrototype = $075335069f3df110$var$Uint8ClampedArray && $075335069f3df110$var$Uint8ClampedArray.prototype;
var $075335069f3df110$var$TypedArray = $075335069f3df110$var$Int8Array && $4cd81123e9998126$exports($075335069f3df110$var$Int8Array);
var $075335069f3df110$var$TypedArrayPrototype = $075335069f3df110$var$Int8ArrayPrototype && $4cd81123e9998126$exports($075335069f3df110$var$Int8ArrayPrototype);
var $075335069f3df110$var$ObjectPrototype = Object.prototype;
var $075335069f3df110$var$TypeError = $f15c226ae83425ec$exports.TypeError;
var $075335069f3df110$var$TO_STRING_TAG = $bc302ad56689cbe3$exports("toStringTag");
var $075335069f3df110$var$TYPED_ARRAY_TAG = $0dc1d96c46d424bf$exports("TYPED_ARRAY_TAG");
var $075335069f3df110$var$TYPED_ARRAY_CONSTRUCTOR = "TypedArrayConstructor";
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var $075335069f3df110$var$NATIVE_ARRAY_BUFFER_VIEWS = $a0e98215756e32b2$exports && !!$61c0848bbefa3fe4$exports && $4020a0df4be35de1$exports($f15c226ae83425ec$exports.opera) !== "Opera";
var $075335069f3df110$var$TYPED_ARRAY_TAG_REQUIRED = false;
var $075335069f3df110$var$NAME, $075335069f3df110$var$Constructor, $075335069f3df110$var$Prototype;
var $075335069f3df110$var$TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var $075335069f3df110$var$BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var $075335069f3df110$var$isView = function isView(it) {
    if (!$42b05d948cc94343$exports(it)) return false;
    var klass = $4020a0df4be35de1$exports(it);
    return klass === "DataView" || $157a284e0766dd8e$exports($075335069f3df110$var$TypedArrayConstructorsList, klass) || $157a284e0766dd8e$exports($075335069f3df110$var$BigIntArrayConstructorsList, klass);
};
var $075335069f3df110$var$getTypedArrayConstructor = function(it) {
    var proto = $4cd81123e9998126$exports(it);
    if (!$42b05d948cc94343$exports(proto)) return;
    var state = $075335069f3df110$var$getInternalState(proto);
    return state && $157a284e0766dd8e$exports(state, $075335069f3df110$var$TYPED_ARRAY_CONSTRUCTOR) ? state[$075335069f3df110$var$TYPED_ARRAY_CONSTRUCTOR] : $075335069f3df110$var$getTypedArrayConstructor(proto);
};
var $075335069f3df110$var$isTypedArray = function(it) {
    if (!$42b05d948cc94343$exports(it)) return false;
    var klass = $4020a0df4be35de1$exports(it);
    return $157a284e0766dd8e$exports($075335069f3df110$var$TypedArrayConstructorsList, klass) || $157a284e0766dd8e$exports($075335069f3df110$var$BigIntArrayConstructorsList, klass);
};
var $075335069f3df110$var$aTypedArray = function(it) {
    if ($075335069f3df110$var$isTypedArray(it)) return it;
    throw new $075335069f3df110$var$TypeError("Target is not a typed array");
};
var $075335069f3df110$var$aTypedArrayConstructor = function(C) {
    if ($5c717df53b8d533a$exports(C) && (!$61c0848bbefa3fe4$exports || $3ebdbce249bfe864$exports($075335069f3df110$var$TypedArray, C))) return C;
    throw new $075335069f3df110$var$TypeError($61987aca7fe1d459$exports(C) + " is not a typed array constructor");
};
var $075335069f3df110$var$exportTypedArrayMethod = function(KEY, property, forced, options) {
    if (!$a0dcf23c5a770a17$exports) return;
    if (forced) for(var ARRAY in $075335069f3df110$var$TypedArrayConstructorsList){
        var TypedArrayConstructor = $f15c226ae83425ec$exports[ARRAY];
        if (TypedArrayConstructor && $157a284e0766dd8e$exports(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!$075335069f3df110$var$TypedArrayPrototype[KEY] || forced) $ba7fdff3b770f3c7$exports($075335069f3df110$var$TypedArrayPrototype, KEY, forced ? property : $075335069f3df110$var$NATIVE_ARRAY_BUFFER_VIEWS && $075335069f3df110$var$Int8ArrayPrototype[KEY] || property, options);
};
var $075335069f3df110$var$exportTypedArrayStaticMethod = function(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!$a0dcf23c5a770a17$exports) return;
    if ($61c0848bbefa3fe4$exports) {
        if (forced) for(ARRAY in $075335069f3df110$var$TypedArrayConstructorsList){
            TypedArrayConstructor = $f15c226ae83425ec$exports[ARRAY];
            if (TypedArrayConstructor && $157a284e0766dd8e$exports(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!$075335069f3df110$var$TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return $ba7fdff3b770f3c7$exports($075335069f3df110$var$TypedArray, KEY, forced ? property : $075335069f3df110$var$NATIVE_ARRAY_BUFFER_VIEWS && $075335069f3df110$var$TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in $075335069f3df110$var$TypedArrayConstructorsList){
        TypedArrayConstructor = $f15c226ae83425ec$exports[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) $ba7fdff3b770f3c7$exports(TypedArrayConstructor, KEY, property);
    }
};
for($075335069f3df110$var$NAME in $075335069f3df110$var$TypedArrayConstructorsList){
    $075335069f3df110$var$Constructor = $f15c226ae83425ec$exports[$075335069f3df110$var$NAME];
    $075335069f3df110$var$Prototype = $075335069f3df110$var$Constructor && $075335069f3df110$var$Constructor.prototype;
    if ($075335069f3df110$var$Prototype) $075335069f3df110$var$enforceInternalState($075335069f3df110$var$Prototype)[$075335069f3df110$var$TYPED_ARRAY_CONSTRUCTOR] = $075335069f3df110$var$Constructor;
    else $075335069f3df110$var$NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for($075335069f3df110$var$NAME in $075335069f3df110$var$BigIntArrayConstructorsList){
    $075335069f3df110$var$Constructor = $f15c226ae83425ec$exports[$075335069f3df110$var$NAME];
    $075335069f3df110$var$Prototype = $075335069f3df110$var$Constructor && $075335069f3df110$var$Constructor.prototype;
    if ($075335069f3df110$var$Prototype) $075335069f3df110$var$enforceInternalState($075335069f3df110$var$Prototype)[$075335069f3df110$var$TYPED_ARRAY_CONSTRUCTOR] = $075335069f3df110$var$Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!$075335069f3df110$var$NATIVE_ARRAY_BUFFER_VIEWS || !$5c717df53b8d533a$exports($075335069f3df110$var$TypedArray) || $075335069f3df110$var$TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    $075335069f3df110$var$TypedArray = function TypedArray() {
        throw new $075335069f3df110$var$TypeError("Incorrect invocation");
    };
    if ($075335069f3df110$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($075335069f3df110$var$NAME in $075335069f3df110$var$TypedArrayConstructorsList)if ($f15c226ae83425ec$exports[$075335069f3df110$var$NAME]) $61c0848bbefa3fe4$exports($f15c226ae83425ec$exports[$075335069f3df110$var$NAME], $075335069f3df110$var$TypedArray);
    }
}
if (!$075335069f3df110$var$NATIVE_ARRAY_BUFFER_VIEWS || !$075335069f3df110$var$TypedArrayPrototype || $075335069f3df110$var$TypedArrayPrototype === $075335069f3df110$var$ObjectPrototype) {
    $075335069f3df110$var$TypedArrayPrototype = $075335069f3df110$var$TypedArray.prototype;
    if ($075335069f3df110$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($075335069f3df110$var$NAME in $075335069f3df110$var$TypedArrayConstructorsList)if ($f15c226ae83425ec$exports[$075335069f3df110$var$NAME]) $61c0848bbefa3fe4$exports($f15c226ae83425ec$exports[$075335069f3df110$var$NAME].prototype, $075335069f3df110$var$TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if ($075335069f3df110$var$NATIVE_ARRAY_BUFFER_VIEWS && $4cd81123e9998126$exports($075335069f3df110$var$Uint8ClampedArrayPrototype) !== $075335069f3df110$var$TypedArrayPrototype) $61c0848bbefa3fe4$exports($075335069f3df110$var$Uint8ClampedArrayPrototype, $075335069f3df110$var$TypedArrayPrototype);
if ($a0dcf23c5a770a17$exports && !$157a284e0766dd8e$exports($075335069f3df110$var$TypedArrayPrototype, $075335069f3df110$var$TO_STRING_TAG)) {
    $075335069f3df110$var$TYPED_ARRAY_TAG_REQUIRED = true;
    $0dd23fb31b34e54e$exports($075335069f3df110$var$TypedArrayPrototype, $075335069f3df110$var$TO_STRING_TAG, {
        configurable: true,
        get: function() {
            return $42b05d948cc94343$exports(this) ? this[$075335069f3df110$var$TYPED_ARRAY_TAG] : undefined;
        }
    });
    for($075335069f3df110$var$NAME in $075335069f3df110$var$TypedArrayConstructorsList)if ($f15c226ae83425ec$exports[$075335069f3df110$var$NAME]) $7e5a9998baa652f2$exports($f15c226ae83425ec$exports[$075335069f3df110$var$NAME], $075335069f3df110$var$TYPED_ARRAY_TAG, $075335069f3df110$var$NAME);
}
$075335069f3df110$exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: $075335069f3df110$var$NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: $075335069f3df110$var$TYPED_ARRAY_TAG_REQUIRED && $075335069f3df110$var$TYPED_ARRAY_TAG,
    aTypedArray: $075335069f3df110$var$aTypedArray,
    aTypedArrayConstructor: $075335069f3df110$var$aTypedArrayConstructor,
    exportTypedArrayMethod: $075335069f3df110$var$exportTypedArrayMethod,
    exportTypedArrayStaticMethod: $075335069f3df110$var$exportTypedArrayStaticMethod,
    getTypedArrayConstructor: $075335069f3df110$var$getTypedArrayConstructor,
    isView: $075335069f3df110$var$isView,
    isTypedArray: $075335069f3df110$var$isTypedArray,
    TypedArray: $075335069f3df110$var$TypedArray,
    TypedArrayPrototype: $075335069f3df110$var$TypedArrayPrototype
};


var $2b8d0a773fa32671$exports = {};
"use strict";
var $84308523d8506a49$exports = {};
"use strict";
var $1951278c367e88a9$exports = {};
"use strict";
var $6370e70afd364fa3$exports = {};
"use strict";
var $6370e70afd364fa3$var$ceil = Math.ceil;
var $6370e70afd364fa3$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$6370e70afd364fa3$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $6370e70afd364fa3$var$floor : $6370e70afd364fa3$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$1951278c367e88a9$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $6370e70afd364fa3$exports(number);
};


var $84308523d8506a49$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$84308523d8506a49$exports = function(argument) {
    return argument > 0 ? $84308523d8506a49$var$min($1951278c367e88a9$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$2b8d0a773fa32671$exports = function(obj) {
    return $84308523d8506a49$exports(obj.length);
};


var $997930c96a58aa96$exports = {};
"use strict";
var $6d290e67e68100a7$exports = {};
"use strict";

var $6d290e67e68100a7$var$$RangeError = RangeError;
$6d290e67e68100a7$exports = function(it) {
    var result = $1951278c367e88a9$exports(it);
    if (result < 0) throw new $6d290e67e68100a7$var$$RangeError("The argument can't be less than 0");
    return result;
};


var $997930c96a58aa96$var$$RangeError = RangeError;
$997930c96a58aa96$exports = function(it, BYTES) {
    var offset = $6d290e67e68100a7$exports(it);
    if (offset % BYTES) throw new $997930c96a58aa96$var$$RangeError("Wrong offset");
    return offset;
};




var $d0aae79ccc71d159$var$RangeError = $f15c226ae83425ec$exports.RangeError;
var $d0aae79ccc71d159$var$Int8Array = $f15c226ae83425ec$exports.Int8Array;
var $d0aae79ccc71d159$var$Int8ArrayPrototype = $d0aae79ccc71d159$var$Int8Array && $d0aae79ccc71d159$var$Int8Array.prototype;
var $d0aae79ccc71d159$var$$set = $d0aae79ccc71d159$var$Int8ArrayPrototype && $d0aae79ccc71d159$var$Int8ArrayPrototype.set;
var $d0aae79ccc71d159$var$aTypedArray = $075335069f3df110$exports.aTypedArray;
var $d0aae79ccc71d159$var$exportTypedArrayMethod = $075335069f3df110$exports.exportTypedArrayMethod;
var $d0aae79ccc71d159$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !$74f43415f059679c$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    $f4093159827c6b26$exports($d0aae79ccc71d159$var$$set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var $d0aae79ccc71d159$var$TO_OBJECT_BUG = $d0aae79ccc71d159$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && $075335069f3df110$exports.NATIVE_ARRAY_BUFFER_VIEWS && $74f43415f059679c$exports(function() {
    var array = new $d0aae79ccc71d159$var$Int8Array(2);
    array.set(1);
    array.set("2", 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
$d0aae79ccc71d159$var$exportTypedArrayMethod("set", function set(arrayLike /* , offset */ ) {
    $d0aae79ccc71d159$var$aTypedArray(this);
    var offset = $997930c96a58aa96$exports(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = $2cff4c49640a3231$exports(arrayLike);
    if ($d0aae79ccc71d159$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return $f4093159827c6b26$exports($d0aae79ccc71d159$var$$set, this, src, offset);
    var length = this.length;
    var len = $2b8d0a773fa32671$exports(src);
    var index = 0;
    if (len + offset > length) throw new $d0aae79ccc71d159$var$RangeError("Wrong length");
    while(index < len)this[offset + index] = src[index++];
}, !$d0aae79ccc71d159$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || $d0aae79ccc71d159$var$TO_OBJECT_BUG);


"use strict";
"use strict";
var $1f6d14d12d1d3775$exports = {};
"use strict";

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $fdb2c522ba5345a2$export$2d1720544b23b823;
"use strict";


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $3fecf1cbcccd62c7$export$2d1720544b23b823;
"use strict";
var $3fecf1cbcccd62c7$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $3fecf1cbcccd62c7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $3fecf1cbcccd62c7$var$NASHORN_BUG = $3fecf1cbcccd62c7$var$getOwnPropertyDescriptor && !$3fecf1cbcccd62c7$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$3fecf1cbcccd62c7$export$2d1720544b23b823 = $3fecf1cbcccd62c7$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $3fecf1cbcccd62c7$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $3fecf1cbcccd62c7$var$$propertyIsEnumerable;



var $ddc15676e79ea880$exports = {};
"use strict";
var $d092693a4e6ae56a$exports = {};
"use strict";



var $d092693a4e6ae56a$var$$Object = Object;
var $d092693a4e6ae56a$var$split = $9f4fe1f27df707da$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$d092693a4e6ae56a$exports = $74f43415f059679c$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$d092693a4e6ae56a$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $e135b923393ad6cb$exports(it) === "String" ? $d092693a4e6ae56a$var$split(it, "") : $d092693a4e6ae56a$var$$Object(it);
} : $d092693a4e6ae56a$var$$Object;



$ddc15676e79ea880$exports = function(it) {
    return $d092693a4e6ae56a$exports($b6bcb5f83b47fa34$exports(it));
};





// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $fdb2c522ba5345a2$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$fdb2c522ba5345a2$export$2d1720544b23b823 = $a0dcf23c5a770a17$exports ? $fdb2c522ba5345a2$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $ddc15676e79ea880$exports(O);
    P = $61211463e7bcd6b2$exports(P);
    if ($6c0cf762d2d29930$exports) try {
        return $fdb2c522ba5345a2$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($157a284e0766dd8e$exports(O, P)) return $e0f181a8b4949a22$exports(!$f4093159827c6b26$exports($3fecf1cbcccd62c7$export$2d1720544b23b823, O, P), O[P]);
};


var $1f6d14d12d1d3775$require$getOwnPropertyDescriptor = $fdb2c522ba5345a2$export$2d1720544b23b823;



var $f81d322d0bf8a32f$exports = {};
"use strict";

var $b72315a3b969b0e8$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $30dde5caf2be90a1$export$2d1720544b23b823;
"use strict";
var $acce448b05035494$exports = {};
"use strict";



var $318db0efeaf4984b$exports = {};
"use strict";

var $ca63936712bf642a$exports = {};
"use strict";

var $ca63936712bf642a$var$max = Math.max;
var $ca63936712bf642a$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$ca63936712bf642a$exports = function(index, length) {
    var integer = $1951278c367e88a9$exports(index);
    return integer < 0 ? $ca63936712bf642a$var$max(integer + length, 0) : $ca63936712bf642a$var$min(integer, length);
};



// `Array.prototype.{ indexOf, includes }` methods implementation
var $318db0efeaf4984b$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $ddc15676e79ea880$exports($this);
        var length = $2b8d0a773fa32671$exports(O);
        var index = $ca63936712bf642a$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$318db0efeaf4984b$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $318db0efeaf4984b$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $318db0efeaf4984b$var$createMethod(false)
};


var $acce448b05035494$require$indexOf = $318db0efeaf4984b$exports.indexOf;

var $acce448b05035494$var$push = $9f4fe1f27df707da$exports([].push);
$acce448b05035494$exports = function(object, names) {
    var O = $ddc15676e79ea880$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$157a284e0766dd8e$exports($4e69f514a119f738$exports, key) && $157a284e0766dd8e$exports(O, key) && $acce448b05035494$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($157a284e0766dd8e$exports(O, key = names[i++])) ~$acce448b05035494$require$indexOf(result, key) || $acce448b05035494$var$push(result, key);
    return result;
};


var $8e5a53170252586f$exports = {};
"use strict";
// IE8- don't enum bug keys
$8e5a53170252586f$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $30dde5caf2be90a1$var$hiddenKeys = $8e5a53170252586f$exports.concat("length", "prototype");
$30dde5caf2be90a1$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $acce448b05035494$exports(O, $30dde5caf2be90a1$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $27e91b23e2086476$export$2d1720544b23b823;
"use strict";
$27e91b23e2086476$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $b72315a3b969b0e8$var$concat = $9f4fe1f27df707da$exports([].concat);
// all object keys, includes non-enumerable and symbols
$b72315a3b969b0e8$exports = $b8ea96c154cbe99b$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $30dde5caf2be90a1$export$2d1720544b23b823($704929e20c6cac0a$exports(it));
    var getOwnPropertySymbols = $27e91b23e2086476$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $b72315a3b969b0e8$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$f81d322d0bf8a32f$exports = function(target, source, exceptions) {
    var keys = $b72315a3b969b0e8$exports(source);
    var defineProperty = $9f306fabc920baa3$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $fdb2c522ba5345a2$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$157a284e0766dd8e$exports(target, key) && !(exceptions && $157a284e0766dd8e$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $49dcf15c2a82679d$exports = {};
"use strict";


var $49dcf15c2a82679d$var$replacement = /#|\.prototype\./;
var $49dcf15c2a82679d$var$isForced = function(feature, detection) {
    var value = $49dcf15c2a82679d$var$data[$49dcf15c2a82679d$var$normalize(feature)];
    return value === $49dcf15c2a82679d$var$POLYFILL ? true : value === $49dcf15c2a82679d$var$NATIVE ? false : $5c717df53b8d533a$exports(detection) ? $74f43415f059679c$exports(detection) : !!detection;
};
var $49dcf15c2a82679d$var$normalize = $49dcf15c2a82679d$var$isForced.normalize = function(string) {
    return String(string).replace($49dcf15c2a82679d$var$replacement, ".").toLowerCase();
};
var $49dcf15c2a82679d$var$data = $49dcf15c2a82679d$var$isForced.data = {};
var $49dcf15c2a82679d$var$NATIVE = $49dcf15c2a82679d$var$isForced.NATIVE = "N";
var $49dcf15c2a82679d$var$POLYFILL = $49dcf15c2a82679d$var$isForced.POLYFILL = "P";
$49dcf15c2a82679d$exports = $49dcf15c2a82679d$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $1f6d14d12d1d3775$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $f15c226ae83425ec$exports;
    else if (STATIC) target = $f15c226ae83425ec$exports[TARGET] || $e7348875cfd0b6ef$exports(TARGET, {});
    else target = ($f15c226ae83425ec$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $1f6d14d12d1d3775$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $49dcf15c2a82679d$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $f81d322d0bf8a32f$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $7e5a9998baa652f2$exports(sourceProperty, "sham", true);
        $ba7fdff3b770f3c7$exports(target, key, sourceProperty, options);
    }
};



var $fe2e0364938045f0$exports = {};
"use strict";

var $27fbe4a76703fb6e$exports = {};
"use strict";

var $27fbe4a76703fb6e$var$FunctionPrototype = Function.prototype;
var $27fbe4a76703fb6e$var$apply = $27fbe4a76703fb6e$var$FunctionPrototype.apply;
var $27fbe4a76703fb6e$var$call = $27fbe4a76703fb6e$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$27fbe4a76703fb6e$exports = typeof Reflect == "object" && Reflect.apply || ($88972db07a8828dd$exports ? $27fbe4a76703fb6e$var$call.bind($27fbe4a76703fb6e$var$apply) : function() {
    return $27fbe4a76703fb6e$var$call.apply($27fbe4a76703fb6e$var$apply, arguments);
});


var $06b5eec0878d4f79$exports = {};
"use strict";
var $f84991eaf952b045$exports = {};
"use strict";


$f84991eaf952b045$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($e135b923393ad6cb$exports(fn) === "Function") return $9f4fe1f27df707da$exports(fn);
};




var $06b5eec0878d4f79$var$bind = $f84991eaf952b045$exports($f84991eaf952b045$exports.bind);
// optional / simple context binding
$06b5eec0878d4f79$exports = function(fn, that) {
    $9b2b3ea08eccde72$exports(fn);
    return that === undefined ? fn : $88972db07a8828dd$exports ? $06b5eec0878d4f79$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $71a39a82aa4aaa22$exports = {};
"use strict";

$71a39a82aa4aaa22$exports = $b8ea96c154cbe99b$exports("document", "documentElement");


var $bfeb7b9dea63b4d5$exports = {};
"use strict";

$bfeb7b9dea63b4d5$exports = $9f4fe1f27df707da$exports([].slice);



var $498e4b6045c36f42$exports = {};
"use strict";
var $498e4b6045c36f42$var$$TypeError = TypeError;
$498e4b6045c36f42$exports = function(passed, required) {
    if (passed < required) throw new $498e4b6045c36f42$var$$TypeError("Not enough arguments");
    return passed;
};


var $9ba967d06e43e68a$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$9ba967d06e43e68a$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($afe893cfdbf38dcb$exports);


var $e64fc82fd67142bf$exports = {};
"use strict";


$e64fc82fd67142bf$exports = $e135b923393ad6cb$exports($f15c226ae83425ec$exports.process) === "process";


var $fe2e0364938045f0$var$set = $f15c226ae83425ec$exports.setImmediate;
var $fe2e0364938045f0$var$clear = $f15c226ae83425ec$exports.clearImmediate;
var $fe2e0364938045f0$var$process = $f15c226ae83425ec$exports.process;
var $fe2e0364938045f0$var$Dispatch = $f15c226ae83425ec$exports.Dispatch;
var $fe2e0364938045f0$var$Function = $f15c226ae83425ec$exports.Function;
var $fe2e0364938045f0$var$MessageChannel = $f15c226ae83425ec$exports.MessageChannel;
var $fe2e0364938045f0$var$String = $f15c226ae83425ec$exports.String;
var $fe2e0364938045f0$var$counter = 0;
var $fe2e0364938045f0$var$queue = {};
var $fe2e0364938045f0$var$ONREADYSTATECHANGE = "onreadystatechange";
var $fe2e0364938045f0$var$$location, $fe2e0364938045f0$var$defer, $fe2e0364938045f0$var$channel, $fe2e0364938045f0$var$port;
$74f43415f059679c$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $fe2e0364938045f0$var$$location = $f15c226ae83425ec$exports.location;
});
var $fe2e0364938045f0$var$run = function(id) {
    if ($157a284e0766dd8e$exports($fe2e0364938045f0$var$queue, id)) {
        var fn = $fe2e0364938045f0$var$queue[id];
        delete $fe2e0364938045f0$var$queue[id];
        fn();
    }
};
var $fe2e0364938045f0$var$runner = function(id) {
    return function() {
        $fe2e0364938045f0$var$run(id);
    };
};
var $fe2e0364938045f0$var$eventListener = function(event) {
    $fe2e0364938045f0$var$run(event.data);
};
var $fe2e0364938045f0$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $f15c226ae83425ec$exports.postMessage($fe2e0364938045f0$var$String(id), $fe2e0364938045f0$var$$location.protocol + "//" + $fe2e0364938045f0$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$fe2e0364938045f0$var$set || !$fe2e0364938045f0$var$clear) {
    $fe2e0364938045f0$var$set = function setImmediate(handler) {
        $498e4b6045c36f42$exports(arguments.length, 1);
        var fn = $5c717df53b8d533a$exports(handler) ? handler : $fe2e0364938045f0$var$Function(handler);
        var args = $bfeb7b9dea63b4d5$exports(arguments, 1);
        $fe2e0364938045f0$var$queue[++$fe2e0364938045f0$var$counter] = function() {
            $27fbe4a76703fb6e$exports(fn, undefined, args);
        };
        $fe2e0364938045f0$var$defer($fe2e0364938045f0$var$counter);
        return $fe2e0364938045f0$var$counter;
    };
    $fe2e0364938045f0$var$clear = function clearImmediate(id) {
        delete $fe2e0364938045f0$var$queue[id];
    };
    // Node.js 0.8-
    if ($e64fc82fd67142bf$exports) $fe2e0364938045f0$var$defer = function(id) {
        $fe2e0364938045f0$var$process.nextTick($fe2e0364938045f0$var$runner(id));
    };
    else if ($fe2e0364938045f0$var$Dispatch && $fe2e0364938045f0$var$Dispatch.now) $fe2e0364938045f0$var$defer = function(id) {
        $fe2e0364938045f0$var$Dispatch.now($fe2e0364938045f0$var$runner(id));
    };
    else if ($fe2e0364938045f0$var$MessageChannel && !$9ba967d06e43e68a$exports) {
        $fe2e0364938045f0$var$channel = new $fe2e0364938045f0$var$MessageChannel();
        $fe2e0364938045f0$var$port = $fe2e0364938045f0$var$channel.port2;
        $fe2e0364938045f0$var$channel.port1.onmessage = $fe2e0364938045f0$var$eventListener;
        $fe2e0364938045f0$var$defer = $06b5eec0878d4f79$exports($fe2e0364938045f0$var$port.postMessage, $fe2e0364938045f0$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($f15c226ae83425ec$exports.addEventListener && $5c717df53b8d533a$exports($f15c226ae83425ec$exports.postMessage) && !$f15c226ae83425ec$exports.importScripts && $fe2e0364938045f0$var$$location && $fe2e0364938045f0$var$$location.protocol !== "file:" && !$74f43415f059679c$exports($fe2e0364938045f0$var$globalPostMessageDefer)) {
        $fe2e0364938045f0$var$defer = $fe2e0364938045f0$var$globalPostMessageDefer;
        $f15c226ae83425ec$exports.addEventListener("message", $fe2e0364938045f0$var$eventListener, false);
    // IE8-
    } else if ($fe2e0364938045f0$var$ONREADYSTATECHANGE in $2ac0cbfabeafe1fb$exports("script")) $fe2e0364938045f0$var$defer = function(id) {
        $71a39a82aa4aaa22$exports.appendChild($2ac0cbfabeafe1fb$exports("script"))[$fe2e0364938045f0$var$ONREADYSTATECHANGE] = function() {
            $71a39a82aa4aaa22$exports.removeChild(this);
            $fe2e0364938045f0$var$run(id);
        };
    };
    else $fe2e0364938045f0$var$defer = function(id) {
        setTimeout($fe2e0364938045f0$var$runner(id), 0);
    };
}
$fe2e0364938045f0$exports = {
    set: $fe2e0364938045f0$var$set,
    clear: $fe2e0364938045f0$var$clear
};


var $01a8c25da1d77dc0$require$clearImmediate = $fe2e0364938045f0$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$1f6d14d12d1d3775$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $f15c226ae83425ec$exports.clearImmediate !== $01a8c25da1d77dc0$require$clearImmediate
}, {
    clearImmediate: $01a8c25da1d77dc0$require$clearImmediate
});


"use strict";



var $3fe8c8f98480917e$require$setTask = $fe2e0364938045f0$exports.set;
var $de6d9e4a21372e74$exports = {};
"use strict";



var $85c225b035c1a42f$exports = {};
"use strict";
/* global Bun -- Bun case */ $85c225b035c1a42f$exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";





var $de6d9e4a21372e74$var$Function = $f15c226ae83425ec$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $de6d9e4a21372e74$var$WRAP = /MSIE .\./.test($afe893cfdbf38dcb$exports) || $85c225b035c1a42f$exports && function() {
    var version = $f15c226ae83425ec$exports.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$de6d9e4a21372e74$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $de6d9e4a21372e74$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $498e4b6045c36f42$exports(arguments.length, 1) > firstParamIndex;
        var fn = $5c717df53b8d533a$exports(handler) ? handler : $de6d9e4a21372e74$var$Function(handler);
        var params = boundArgs ? $bfeb7b9dea63b4d5$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $27fbe4a76703fb6e$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $3fe8c8f98480917e$var$setImmediate = $f15c226ae83425ec$exports.setImmediate ? $de6d9e4a21372e74$exports($3fe8c8f98480917e$require$setTask, false) : $3fe8c8f98480917e$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$1f6d14d12d1d3775$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $f15c226ae83425ec$exports.setImmediate !== $3fe8c8f98480917e$var$setImmediate
}, {
    setImmediate: $3fe8c8f98480917e$var$setImmediate
});




var $6dd45a7735069a79$exports = {};
"use strict";

$6dd45a7735069a79$exports = (parcelRequire("28uU7"));


parcelRequire("4DE7A");
var $a4406f9443c22771$export$882461b6382ed46c;
var $a4406f9443c22771$export$757ceba2d55c277e;
"use strict";

var $gv34t = parcelRequire("gv34t");
var $a4406f9443c22771$var$i;
$a4406f9443c22771$export$882461b6382ed46c = $gv34t.createRoot;
$a4406f9443c22771$export$757ceba2d55c277e = $gv34t.hydrateRoot;


// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $lomSQ = parcelRequire("lomSQ");
var $0e9e902466a53ebe$exports = {};
"use strict";

$0e9e902466a53ebe$exports = (parcelRequire("fNSou"));



var $gv34t = parcelRequire("gv34t");


var $gv34t = parcelRequire("gv34t");
// Default to a dummy "batch" implementation that just runs the callback
function $fd58dfd92c1ce9e7$var$defaultNoopBatch(callback) {
    callback();
}
let $fd58dfd92c1ce9e7$var$batch = $fd58dfd92c1ce9e7$var$defaultNoopBatch; // Allow injecting another batching function later
const $fd58dfd92c1ce9e7$export$4b9874722d0da7bc = (newBatch)=>$fd58dfd92c1ce9e7$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $fd58dfd92c1ce9e7$export$fc47d4c0ba3bd2c6 = ()=>$fd58dfd92c1ce9e7$var$batch;



var $4DE7A = parcelRequire("4DE7A");

var $4DE7A = parcelRequire("4DE7A");

var $4DE7A = parcelRequire("4DE7A");
const $4f838bea6f2b220e$var$ContextKey = Symbol.for(`react-redux-context`);
const $4f838bea6f2b220e$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $4f838bea6f2b220e$var$getContext() {
    var _gT$ContextKey;
    if (!$4DE7A.createContext) return {};
    const contextMap = (_gT$ContextKey = $4f838bea6f2b220e$var$gT[$4f838bea6f2b220e$var$ContextKey]) != null ? _gT$ContextKey : $4f838bea6f2b220e$var$gT[$4f838bea6f2b220e$var$ContextKey] = new Map();
    let realContext = contextMap.get($4DE7A.createContext);
    if (!realContext) {
        realContext = $4DE7A.createContext(null);
        contextMap.set($4DE7A.createContext, realContext);
    }
    return realContext;
}
const $4f838bea6f2b220e$export$cc80c08dc91f1c00 = /*#__PURE__*/ $4f838bea6f2b220e$var$getContext();
var $4f838bea6f2b220e$export$2e2bcd8739ae039 = $4f838bea6f2b220e$export$cc80c08dc91f1c00;


function $31a3e1d2dbabcd26$export$d4d6226d5fc61558(context = (0, $4f838bea6f2b220e$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $4DE7A.useContext)(context);
        return contextValue;
    };
}
const $31a3e1d2dbabcd26$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $31a3e1d2dbabcd26$export$d4d6226d5fc61558();



const $92a06142c77dd196$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};


let $5be681cecefb99e4$var$useSyncExternalStoreWithSelector = (0, $92a06142c77dd196$export$20656a4825650bd0);
const $5be681cecefb99e4$export$e2e6e3f3f3b782e3 = (fn)=>{
    $5be681cecefb99e4$var$useSyncExternalStoreWithSelector = fn;
};
const $5be681cecefb99e4$var$refEquality = (a, b)=>a === b;
function $5be681cecefb99e4$export$2b53f90d2bd1cbfb(context = (0, $4f838bea6f2b220e$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $4f838bea6f2b220e$export$cc80c08dc91f1c00) ? (0, $31a3e1d2dbabcd26$export$c1275ca9a6fd3ec5) : (0, $31a3e1d2dbabcd26$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $5be681cecefb99e4$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $4DE7A.useRef)(true);
        const wrappedSelector = (0, $4DE7A.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $5be681cecefb99e4$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $4DE7A.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $5be681cecefb99e4$export$2105062e25df4afe = /*#__PURE__*/ $5be681cecefb99e4$export$2b53f90d2bd1cbfb();



var $dBd5b = parcelRequire("dBd5b");

var $50biD = parcelRequire("50biD");

var $34Pgq = parcelRequire("34Pgq");

var $4DE7A = parcelRequire("4DE7A");

var $iI505 = parcelRequire("iI505");

var $50biD = parcelRequire("50biD");
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ae9290a0776df216$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $d45551e98adf91f9$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $ae9290a0776df216$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $d45551e98adf91f9$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $d45551e98adf91f9$var$verify(mapStateToProps, "mapStateToProps");
    $d45551e98adf91f9$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $d45551e98adf91f9$var$verify(mergeProps, "mergeProps");
}


const $ba27c93925db613f$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $ba27c93925db613f$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $ba27c93925db613f$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $50biD.default)(_ref, $ba27c93925db613f$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $ba27c93925db613f$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $448f10649155f1dc$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $11937c3ec79aa2c0$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $ec6f0e76d1dcb95f$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $11937c3ec79aa2c0$export$2e2bcd8739ae039)(value)) (0, $ae9290a0776df216$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $1e57f55f4ef0abd2$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $1e57f55f4ef0abd2$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $1e57f55f4ef0abd2$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $1e57f55f4ef0abd2$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $1e57f55f4ef0abd2$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $3d34cc1171bb8f8d$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $c310f93b4647ad49$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $1e57f55f4ef0abd2$export$710f7c60f68acd3e)((dispatch)=>(0, $448f10649155f1dc$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $1e57f55f4ef0abd2$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $1e57f55f4ef0abd2$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : (0, $3d34cc1171bb8f8d$export$19ef7b929f7e2559)(mapDispatchToProps, "mapDispatchToProps");
}




function $66d0a580aaef8da2$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $1e57f55f4ef0abd2$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === "function" ? (0, $1e57f55f4ef0abd2$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : (0, $3d34cc1171bb8f8d$export$19ef7b929f7e2559)(mapStateToProps, "mapStateToProps");
}



var $dBd5b = parcelRequire("dBd5b");


function $90e42e500c39467d$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $dBd5b.default)({}, ownProps, stateProps, dispatchProps);
}
function $90e42e500c39467d$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $90e42e500c39467d$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$90e42e500c39467d$export$691c327fc30bc857 : typeof mergeProps === "function" ? $90e42e500c39467d$export$5b105939c84b5234(mergeProps) : (0, $3d34cc1171bb8f8d$export$19ef7b929f7e2559)(mergeProps, "mergeProps");
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $86f1f97925e65c2e$var$createListenerCollection() {
    const batch = (0, $fd58dfd92c1ce9e7$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $86f1f97925e65c2e$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $86f1f97925e65c2e$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $86f1f97925e65c2e$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $86f1f97925e65c2e$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $86f1f97925e65c2e$var$nullListeners;
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $4DE7A = parcelRequire("4DE7A");
const $41a3ea345c0c42da$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $41a3ea345c0c42da$export$700979bc83e7db82 = $41a3ea345c0c42da$export$71594e8a50f746f4 ? $4DE7A.useLayoutEffect : $4DE7A.useEffect;


function $e29db01be96e9a68$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $e29db01be96e9a68$export$2e2bcd8739ae039(objA, objB) {
    if ($e29db01be96e9a68$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$e29db01be96e9a68$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $a4829965bb94612b$var$_excluded = [
    "reactReduxForwardedRef"
];
let $a4829965bb94612b$var$useSyncExternalStore = (0, $92a06142c77dd196$export$20656a4825650bd0);
const $a4829965bb94612b$export$36d45daa6a4925b8 = (fn)=>{
    $a4829965bb94612b$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $a4829965bb94612b$var$EMPTY_ARRAY = [
    null,
    0
];
const $a4829965bb94612b$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $a4829965bb94612b$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $a4829965bb94612b$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $41a3ea345c0c42da$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $a4829965bb94612b$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $a4829965bb94612b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $a4829965bb94612b$var$initStateUpdates = ()=>$a4829965bb94612b$var$EMPTY_ARRAY;
function $a4829965bb94612b$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $a4829965bb94612b$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $a4829965bb94612b$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $a4829965bb94612b$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $e29db01be96e9a68$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $e29db01be96e9a68$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $e29db01be96e9a68$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $4f838bea6f2b220e$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $66d0a580aaef8da2$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $c310f93b4647ad49$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $90e42e500c39467d$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $4DE7A.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $50biD.default)(props, $a4829965bb94612b$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $4DE7A.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $iI505.isContextConsumer)(/*#__PURE__*/ $4DE7A.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $4DE7A.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $4DE7A.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $ba27c93925db613f$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $4DE7A.useMemo(()=>{
                if (!shouldHandleStateChanges) return $a4829965bb94612b$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $86f1f97925e65c2e$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $4DE7A.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $dBd5b.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $4DE7A.useRef();
            const lastWrapperProps = $4DE7A.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $4DE7A.useRef();
            const renderIsScheduled = $4DE7A.useRef(false);
            const isProcessingDispatch = $4DE7A.useRef(false);
            const isMounted = $4DE7A.useRef(false);
            const latestSubscriptionCallbackError = $4DE7A.useRef();
            (0, $41a3ea345c0c42da$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $4DE7A.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $4DE7A.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $a4829965bb94612b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $a4829965bb94612b$var$useIsomorphicLayoutEffectWithArgs($a4829965bb94612b$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $a4829965bb94612b$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $41a3ea345c0c42da$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $4DE7A.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $4DE7A.createElement(WrappedComponent, (0, $dBd5b.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $4DE7A.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $4DE7A.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $4DE7A.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $4DE7A.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $4DE7A.createElement(Connect, (0, $dBd5b.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($34Pgq)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($34Pgq)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $a4829965bb94612b$export$2e2bcd8739ae039 = $a4829965bb94612b$var$connect;



var $4DE7A = parcelRequire("4DE7A");



function $4dd147938665f4da$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $4DE7A.useMemo(()=>{
        const subscription = (0, $86f1f97925e65c2e$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $4DE7A.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $41a3ea345c0c42da$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $4f838bea6f2b220e$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $4DE7A.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $4dd147938665f4da$export$2e2bcd8739ae039 = $4dd147938665f4da$var$Provider;







function $2b9527c9819079a2$export$671dba69185d0304(context = (0, $4f838bea6f2b220e$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $4f838bea6f2b220e$export$cc80c08dc91f1c00) ? (0, $31a3e1d2dbabcd26$export$c1275ca9a6fd3ec5) : (0, $31a3e1d2dbabcd26$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $2b9527c9819079a2$export$6ccbb43953eebf8 = /*#__PURE__*/ $2b9527c9819079a2$export$671dba69185d0304();


function $80615d9151c4c54f$export$bc9b55530897c558(context = (0, $4f838bea6f2b220e$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $4f838bea6f2b220e$export$cc80c08dc91f1c00) ? (0, $2b9527c9819079a2$export$6ccbb43953eebf8) : (0, $2b9527c9819079a2$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $80615d9151c4c54f$export$8ad76b76a4c905f8 = /*#__PURE__*/ $80615d9151c4c54f$export$bc9b55530897c558();









(0, $5be681cecefb99e4$export$e2e6e3f3f3b782e3)((0, $0e9e902466a53ebe$exports.useSyncExternalStoreWithSelector));
(0, $a4829965bb94612b$export$36d45daa6a4925b8)((0, $lomSQ.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $fd58dfd92c1ce9e7$export$4b9874722d0da7bc)((0, $gv34t.unstable_batchedUpdates));



var $lUITW = parcelRequire("lUITW");
/** Prefix for logging strings */ const $4b1176a6f20e7b1f$var$PREFIX = "Sentry Logger ";
const $4b1176a6f20e7b1f$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $4b1176a6f20e7b1f$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $4b1176a6f20e7b1f$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $lUITW.GLOBAL_OBJ))) return callback();
    const console = (0, $lUITW.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($4b1176a6f20e7b1f$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $4b1176a6f20e7b1f$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $4b1176a6f20e7b1f$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        }
    };
    if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) $4b1176a6f20e7b1f$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $4b1176a6f20e7b1f$export$cda52e2a8927a2ca(()=>{
                (0, $lUITW.GLOBAL_OBJ).console[name](`${$4b1176a6f20e7b1f$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $4b1176a6f20e7b1f$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $4b1176a6f20e7b1f$export$af88d00dbe7f521 = $4b1176a6f20e7b1f$var$makeLogger();


var $f36CY = parcelRequire("f36CY");
var $lUITW = parcelRequire("lUITW");// eslint-disable-next-line @typescript-eslint/unbound-method
const $6c61789183b19ab1$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$export$e6127cc7fe7395c3(wat) {
    switch($6c61789183b19ab1$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $6c61789183b19ab1$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$var$isBuiltin(wat, className) {
    return $6c61789183b19ab1$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$export$9f9636d330b71954(wat) {
    return $6c61789183b19ab1$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$export$ef9e2056653f0c8e(wat) {
    return $6c61789183b19ab1$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$export$12e869b2a583f783(wat) {
    return $6c61789183b19ab1$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$export$844ec244b1367d54(wat) {
    return $6c61789183b19ab1$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$export$53b83ca8eaab0383(wat) {
    return $6c61789183b19ab1$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $6c61789183b19ab1$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $6c61789183b19ab1$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$export$49841c62b9eff15(wat) {
    return $6c61789183b19ab1$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $6c61789183b19ab1$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$export$bc2894c7158efbac(wat) {
    return $6c61789183b19ab1$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6c61789183b19ab1$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}



var $lUITW = parcelRequire("lUITW");
// eslint-disable-next-line deprecation/deprecation
const $f89c4fd7ab146b2a$var$WINDOW = (0, $lUITW.getGlobalObject)();
const $f89c4fd7ab146b2a$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $f89c4fd7ab146b2a$export$5647df6b7814ac86(elem, options = {}) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $f89c4fd7ab146b2a$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $f89c4fd7ab146b2a$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $f89c4fd7ab146b2a$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $6c61789183b19ab1$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $f89c4fd7ab146b2a$export$1cfafeee2987818b() {
    try {
        return $f89c4fd7ab146b2a$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f89c4fd7ab146b2a$export$c660c1f3ab49225c(selector) {
    if ($f89c4fd7ab146b2a$var$WINDOW.document && $f89c4fd7ab146b2a$var$WINDOW.document.querySelector) return $f89c4fd7ab146b2a$var$WINDOW.document.querySelector(selector);
    return null;
}





/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $60afb67600f3a77a$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $60afb67600f3a77a$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $60afb67600f3a77a$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $6c61789183b19ab1$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $60afb67600f3a77a$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $6c61789183b19ab1$export$844ec244b1367d54)(value)) return false;
    if ((0, $6c61789183b19ab1$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $6c61789183b19ab1$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $60afb67600f3a77a$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$60afb67600f3a77a$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $74b7af9ca2a070de$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $74b7af9ca2a070de$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $74b7af9ca2a070de$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $74b7af9ca2a070de$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $74b7af9ca2a070de$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $74b7af9ca2a070de$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $74b7af9ca2a070de$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $74b7af9ca2a070de$export$62ff257738bf57f5(value) {
    if ((0, $6c61789183b19ab1$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$74b7af9ca2a070de$var$getOwnProperties(value)
    };
    else if ((0, $6c61789183b19ab1$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $74b7af9ca2a070de$var$serializeEventTarget(value.target),
            currentTarget: $74b7af9ca2a070de$var$serializeEventTarget(value.currentTarget),
            ...$74b7af9ca2a070de$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $6c61789183b19ab1$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $74b7af9ca2a070de$var$serializeEventTarget(target) {
    try {
        return (0, $6c61789183b19ab1$export$45a5e7f76e0caa8d)(target) ? (0, $f89c4fd7ab146b2a$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $74b7af9ca2a070de$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $74b7af9ca2a070de$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($74b7af9ca2a070de$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $60afb67600f3a77a$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $60afb67600f3a77a$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $74b7af9ca2a070de$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $74b7af9ca2a070de$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $74b7af9ca2a070de$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ((0, $6c61789183b19ab1$export$53b83ca8eaab0383)(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $74b7af9ca2a070de$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($74b7af9ca2a070de$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $74b7af9ca2a070de$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $6c61789183b19ab1$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




var $lUITW = parcelRequire("lUITW");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $3b650695bc2391ad$export$19f53698e68b2496() {
    const gbl = (0, $lUITW.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>crypto.getRandomValues(new Uint8Array(1))[0];
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $3b650695bc2391ad$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $3b650695bc2391ad$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $3b650695bc2391ad$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $3b650695bc2391ad$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $3b650695bc2391ad$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $3b650695bc2391ad$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $3b650695bc2391ad$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $3b650695bc2391ad$export$d364f2020ab30578(input) {
    const match = input.match($3b650695bc2391ad$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $3b650695bc2391ad$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $60afb67600f3a77a$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $60afb67600f3a77a$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $60afb67600f3a77a$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $3b650695bc2391ad$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $74b7af9ca2a070de$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $3b650695bc2391ad$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $417b285f8867e44d$export$849dbeeeda01ae98 = "production";



var $f36CY = parcelRequire("f36CY");

var $lUITW = parcelRequire("lUITW");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $43317b8e021dd6a3$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($43317b8e021dd6a3$var$States || ($43317b8e021dd6a3$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $43317b8e021dd6a3$export$1fda8aa4d135f8aa(value) {
    return new $43317b8e021dd6a3$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $43317b8e021dd6a3$export$78e43115b553f358(reason) {
    return new $43317b8e021dd6a3$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $43317b8e021dd6a3$export$6f292d4960313241 {
    constructor(executor){
        $43317b8e021dd6a3$export$6f292d4960313241.prototype.__init.call(this);
        $43317b8e021dd6a3$export$6f292d4960313241.prototype.__init2.call(this);
        $43317b8e021dd6a3$export$6f292d4960313241.prototype.__init3.call(this);
        $43317b8e021dd6a3$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $43317b8e021dd6a3$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $43317b8e021dd6a3$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $43317b8e021dd6a3$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($43317b8e021dd6a3$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($43317b8e021dd6a3$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $43317b8e021dd6a3$var$States.PENDING) return;
            if ((0, $6c61789183b19ab1$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $43317b8e021dd6a3$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $43317b8e021dd6a3$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $43317b8e021dd6a3$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}


/**
 * Returns the global event processors.
 */ function $fee1bd2c7a674a45$export$3c4238858b85e8ac() {
    return (0, $lUITW.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */ function $fee1bd2c7a674a45$export$8e4e25f54d456511(callback) {
    $fee1bd2c7a674a45$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $fee1bd2c7a674a45$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $43317b8e021dd6a3$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && processor.id && result === null && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $6c61789183b19ab1$export$f5b060c2914b97c8)(result)) result.then((final)=>$fee1bd2c7a674a45$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $fee1bd2c7a674a45$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



var $f36CY = parcelRequire("f36CY");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $8ddda6fac19e03d9$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $f36CY.timestampInSeconds)();
    const session = {
        sid: (0, $3b650695bc2391ad$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$8ddda6fac19e03d9$var$sessionToJSON(session)
    };
    if (context) $8ddda6fac19e03d9$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $8ddda6fac19e03d9$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $f36CY.timestampInSeconds)();
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $3b650695bc2391ad$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $8ddda6fac19e03d9$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $8ddda6fac19e03d9$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $8ddda6fac19e03d9$var$sessionToJSON(session) {
    return (0, $74b7af9ca2a070de$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $ae6ef75877262323$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $ae6ef75877262323$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /** Transaction Name */ /** Span */ /** Session */ /** Request Mode Session Status */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $ae6ef75877262323$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */ static clone(scope) {
        const newScope = new $ae6ef75877262323$export$775b6bb06e53a214();
        if (scope) {
            newScope._breadcrumbs = [
                ...scope._breadcrumbs
            ];
            newScope._tags = {
                ...scope._tags
            };
            newScope._extra = {
                ...scope._extra
            };
            newScope._contexts = {
                ...scope._contexts
            };
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = [
                ...scope._eventProcessors
            ];
            newScope._requestSession = scope._requestSession;
            newScope._attachments = [
                ...scope._attachments
            ];
            newScope._sdkProcessingMetadata = {
                ...scope._sdkProcessingMetadata
            };
            newScope._propagationContext = {
                ...scope._propagationContext
            };
        }
        return newScope;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this._user = user || {};
        if (this._session) (0, $8ddda6fac19e03d9$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSpan() {
        return this._span;
    }
    /**
   * @inheritDoc
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this.getSpan();
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === "function") {
            const updatedScope = captureContext(this);
            return updatedScope instanceof $ae6ef75877262323$export$775b6bb06e53a214 ? updatedScope : this;
        }
        if (captureContext instanceof $ae6ef75877262323$export$775b6bb06e53a214) {
            this._tags = {
                ...this._tags,
                ...captureContext._tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext._extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext._contexts
            };
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
            if (captureContext._propagationContext) this._propagationContext = captureContext._propagationContext;
        } else if ((0, $6c61789183b19ab1$export$53b83ca8eaab0383)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = {
                ...this._tags,
                ...captureContext.tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext.contexts
            };
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
            if (captureContext.propagationContext) this._propagationContext = captureContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $ae6ef75877262323$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $ae6ef75877262323$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $f36CY.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ getAttachments() {
        return this._attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */ applyToEvent(event, hint = {}, additionalEventProcessors) {
        if (this._extra && Object.keys(this._extra).length) event.extra = {
            ...this._extra,
            ...event.extra
        };
        if (this._tags && Object.keys(this._tags).length) event.tags = {
            ...this._tags,
            ...event.tags
        };
        if (this._user && Object.keys(this._user).length) event.user = {
            ...this._user,
            ...event.user
        };
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = {
            ...this._contexts,
            ...event.contexts
        };
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = {
                trace: this._span.getTraceContext(),
                ...event.contexts
            };
            const transaction = this._span.transaction;
            if (transaction) {
                event.sdkProcessingMetadata = {
                    dynamicSamplingContext: transaction.getDynamicSamplingContext(),
                    ...event.sdkProcessingMetadata
                };
                const transactionName = transaction.name;
                if (transactionName) event.tags = {
                    transaction: transactionName,
                    ...event.tags
                };
            }
        }
        this._applyFingerprint(event);
        const scopeBreadcrumbs = this._getBreadcrumbs();
        const breadcrumbs = [
            ...event.breadcrumbs || [],
            ...scopeBreadcrumbs
        ];
        event.breadcrumbs = breadcrumbs.length > 0 ? breadcrumbs : undefined;
        event.sdkProcessingMetadata = {
            ...event.sdkProcessingMetadata,
            ...this._sdkProcessingMetadata,
            propagationContext: this._propagationContext
        };
        // TODO (v8): Update this order to be: Global > Client > Scope
        return (0, $fee1bd2c7a674a45$export$bf2a096c3e883e79)([
            ...additionalEventProcessors || [],
            ...(0, $fee1bd2c7a674a45$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ], event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Get the breadcrumbs for this scope.
   */ _getBreadcrumbs() {
        return this._breadcrumbs;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */ _applyFingerprint(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? (0, $3b650695bc2391ad$export$3131421a7d01b4fb)(event.fingerprint) : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    }
}
function $ae6ef75877262323$var$generatePropagationContext() {
    return {
        traceId: (0, $3b650695bc2391ad$export$19f53698e68b2496)(),
        spanId: (0, $3b650695bc2391ad$export$19f53698e68b2496)().substring(16)
    };
}



/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $6bae4b7b360739a4$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $6bae4b7b360739a4$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ class $6bae4b7b360739a4$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */ constructor(client, scope = new (0, $ae6ef75877262323$export$775b6bb06e53a214)(), _version = $6bae4b7b360739a4$export$24a86ef7798177e4){
        this._version = _version;
        this._stack = [
            {
                scope: scope
            }
        ];
        if (client) this.bindClient(client);
    }
    /**
   * @inheritDoc
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * @inheritDoc
   */ bindClient(client) {
        const top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    }
    /**
   * @inheritDoc
   */ pushScope() {
        // We want to clone the content of prev scope
        const scope = (0, $ae6ef75877262323$export$775b6bb06e53a214).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   */ popScope() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   */ withScope(callback) {
        const scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this.getStackTop().client;
    }
    /** Returns the scope of the top stack. */ getScope() {
        return this.getStackTop().scope;
    }
    /** Returns the scope stack for domains or the process. */ getStack() {
        return this._stack;
    }
    /** Returns the topmost scope layer in the order domain > local > process. */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $3b650695bc2391ad$export$19f53698e68b2496)();
        const syntheticException = new Error("Sentry syntheticException");
        this._withClient((client, scope)=>{
            client.captureException(exception, {
                originalException: exception,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $3b650695bc2391ad$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        this._withClient((client, scope)=>{
            client.captureMessage(message, level, {
                originalException: message,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $3b650695bc2391ad$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        this._withClient((client, scope)=>{
            client.captureEvent(event, {
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, hint) {
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $6bae4b7b360739a4$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $f36CY.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $4b1176a6f20e7b1f$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this.getScope().setUser(user);
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this.getScope().setTags(tags);
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this.getScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.getScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this.getScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        this.getScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   */ configureScope(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        const oldHub = $6bae4b7b360739a4$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $6bae4b7b360739a4$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        const client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && !result) {
            const client = this.getClient();
            if (!client) // eslint-disable-next-line no-console
            console.warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else // eslint-disable-next-line no-console
            console.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   */ endSession() {
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $8ddda6fac19e03d9$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   */ startSession(context) {
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $417b285f8867e44d$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $lUITW.GLOBAL_OBJ).navigator || {};
        const session = (0, $8ddda6fac19e03d9$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $8ddda6fac19e03d9$export$531818e825e774db)(currentSession, {
            status: "exited"
        });
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */ shouldSendDefaultPii() {
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */ _withClient(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(client, scope);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $6bae4b7b360739a4$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $6bae4b7b360739a4$export$19eade501500c6c1() {
    (0, $lUITW.GLOBAL_OBJ).__SENTRY__ = (0, $lUITW.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $lUITW.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ function $6bae4b7b360739a4$export$4188a14ad302d1bc(hub) {
    const registry = $6bae4b7b360739a4$export$19eade501500c6c1();
    const oldHub = $6bae4b7b360739a4$export$bfa8a924a84a76b7(registry);
    $6bae4b7b360739a4$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ function $6bae4b7b360739a4$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $6bae4b7b360739a4$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $6bae4b7b360739a4$var$getGlobalHub(registry);
}
function $6bae4b7b360739a4$var$getGlobalHub(registry = $6bae4b7b360739a4$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$6bae4b7b360739a4$var$hasHubOnCarrier(registry) || $6bae4b7b360739a4$export$bfa8a924a84a76b7(registry).isOlderThan($6bae4b7b360739a4$export$24a86ef7798177e4)) $6bae4b7b360739a4$export$849f05434e95d2f2(registry, new $6bae4b7b360739a4$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $6bae4b7b360739a4$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ function $6bae4b7b360739a4$export$236689a79f5aa020(carrier, parent = $6bae4b7b360739a4$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$6bae4b7b360739a4$var$hasHubOnCarrier(carrier) || $6bae4b7b360739a4$export$bfa8a924a84a76b7(carrier).isOlderThan($6bae4b7b360739a4$export$24a86ef7798177e4)) {
        const globalHubTopStack = parent.getStackTop();
        $6bae4b7b360739a4$export$849f05434e95d2f2(carrier, new $6bae4b7b360739a4$export$8c41bb232f1008b1(globalHubTopStack.client, (0, $ae6ef75877262323$export$775b6bb06e53a214).clone(globalHubTopStack.scope)));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $6bae4b7b360739a4$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $6bae4b7b360739a4$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $6bae4b7b360739a4$export$70d775fb1f267027(callback, options = {}) {
    const registry = $6bae4b7b360739a4$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $6bae4b7b360739a4$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $6bae4b7b360739a4$export$bfa8a924a84a76b7(carrier) {
    return (0, $lUITW.getGlobalSingleton)("hub", ()=>new $6bae4b7b360739a4$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $6bae4b7b360739a4$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}




const $f4365ba8c8e60c77$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $f4365ba8c8e60c77$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $f4365ba8c8e60c77$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $3b650695bc2391ad$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $f4365ba8c8e60c77$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $f4365ba8c8e60c77$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $f4365ba8c8e60c77$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $f4365ba8c8e60c77$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/** Setup a single integration.  */ function $f4365ba8c8e60c77$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    integrationIndex[integration.name] = integration;
    if ($f4365ba8c8e60c77$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        integration.setupOnce((0, $fee1bd2c7a674a45$export$8e4e25f54d456511), (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c));
        $f4365ba8c8e60c77$export$b14a8888f80a0b3e.push(integration.name);
    }
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $f4365ba8c8e60c77$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}


/** Regular expression used to parse a Dsn. */ const $03fe2394ad772485$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $03fe2394ad772485$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $03fe2394ad772485$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $03fe2394ad772485$export$b892860177f70a30(str) {
    const match = $03fe2394ad772485$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        // eslint-disable-next-line no-console
        console.error(`Invalid Sentry Dsn: ${str}`);
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $03fe2394ad772485$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $03fe2394ad772485$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $03fe2394ad772485$var$validateDsn(dsn) {
    if (!(typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$03fe2394ad772485$var$isValidProtocol(protocol)) {
        (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $03fe2394ad772485$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $03fe2394ad772485$export$b892860177f70a30(from) : $03fe2394ad772485$var$dsnFromComponents(from);
    if (!components || !$03fe2394ad772485$var$validateDsn(components)) return undefined;
    return components;
}


const $990f87ed31df4d12$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $990f87ed31df4d12$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $990f87ed31df4d12$var$_getIngestEndpoint(dsn) {
    return `${$990f87ed31df4d12$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $990f87ed31df4d12$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $74b7af9ca2a070de$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $990f87ed31df4d12$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $990f87ed31df4d12$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$990f87ed31df4d12$var$_getIngestEndpoint(dsn)}?${$990f87ed31df4d12$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $990f87ed31df4d12$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $03fe2394ad772485$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$990f87ed31df4d12$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $03fe2394ad772485$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}



/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $51cdf70134b9ec4d$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
    }
    const hub = (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)();
    const scope = hub.getScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    hub.bindClient(client);
}

var $7bb4492ac633bb96$exports = {};

$parcel$export($7bb4492ac633bb96$exports, "FunctionToString", function () { return $98c935cfb85a6f6d$export$da4704525c20ae79; });
$parcel$export($7bb4492ac633bb96$exports, "InboundFilters", function () { return $dace088d25be73e3$export$2ffbb5359dcc6be4; });

let $98c935cfb85a6f6d$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ class $98c935cfb85a6f6d$export$da4704525c20ae79 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "FunctionToString";
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $98c935cfb85a6f6d$export$da4704525c20ae79.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $98c935cfb85a6f6d$var$originalFunctionToString = Function.prototype.toString;
        // intrinsics (like Function.prototype) might be immutable in some environments
        // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Function.prototype.toString = function(...args) {
                const context = (0, $74b7af9ca2a070de$export$e6cc1e135e2092e5)(this) || this;
                return $98c935cfb85a6f6d$var$originalFunctionToString.apply(context, args);
            };
        } catch (e) {
        // ignore errors here, just don't patch this
        }
    }
}
$98c935cfb85a6f6d$export$da4704525c20ae79.__initStatic();



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $dace088d25be73e3$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
const $dace088d25be73e3$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*healthcheck.*$/,
    /^.*healthy.*$/,
    /^.*live.*$/,
    /^.*ready.*$/,
    /^.*heartbeat.*$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ /** Inbound filters configurable by the user */ class $dace088d25be73e3$export$2ffbb5359dcc6be4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "InboundFilters";
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $dace088d25be73e3$export$2ffbb5359dcc6be4.id;
        this._options = options;
    }
    /**
   * @inheritDoc
   */ setupOnce(_addGlobaleventProcessor, _getCurrentHub) {
    // noop
    }
    /** @inheritDoc */ processEvent(event, _eventHint, client) {
        const clientOptions = client.getOptions();
        const options = $dace088d25be73e3$export$6620a151868b99aa(this._options, clientOptions);
        return $dace088d25be73e3$export$3c6361fddf6cd929(event, options) ? null : event;
    }
}
$dace088d25be73e3$export$2ffbb5359dcc6be4.__initStatic();
/** JSDoc */ function $dace088d25be73e3$export$6620a151868b99aa(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $dace088d25be73e3$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $dace088d25be73e3$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
/** JSDoc */ function $dace088d25be73e3$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $dace088d25be73e3$var$_isSentryError(event)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $3b650695bc2391ad$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($dace088d25be73e3$var$_isIgnoredError(event, options.ignoreErrors)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $3b650695bc2391ad$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($dace088d25be73e3$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $3b650695bc2391ad$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($dace088d25be73e3$var$_isDeniedUrl(event, options.denyUrls)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $3b650695bc2391ad$export$4157119e2b157127)(event)}.\nUrl: ${$dace088d25be73e3$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$dace088d25be73e3$var$_isAllowedUrl(event, options.allowUrls)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $3b650695bc2391ad$export$4157119e2b157127)(event)}.\nUrl: ${$dace088d25be73e3$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $dace088d25be73e3$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $dace088d25be73e3$var$_getPossibleEventMessages(event).some((message)=>(0, $60afb67600f3a77a$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $dace088d25be73e3$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $60afb67600f3a77a$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $dace088d25be73e3$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $dace088d25be73e3$var$_getEventFilterUrl(event);
    return !url ? false : (0, $60afb67600f3a77a$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $dace088d25be73e3$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $dace088d25be73e3$var$_getEventFilterUrl(event);
    return !url ? true : (0, $60afb67600f3a77a$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $dace088d25be73e3$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && possibleMessages.length === 0) (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $3b650695bc2391ad$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $dace088d25be73e3$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $dace088d25be73e3$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $dace088d25be73e3$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $dace088d25be73e3$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $3b650695bc2391ad$export$4157119e2b157127)(event)}`);
        return null;
    }
}







/**
 * Does this filename look like it's part of the app code?
 */ function $9fd74e0770590d2b$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.includes(":\\") && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $9fd74e0770590d2b$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $9fd74e0770590d2b$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $7b788481046e0790$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $7b788481046e0790$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $7b788481046e0790$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $7b788481046e0790$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $7b788481046e0790$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($7b788481046e0790$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $7b788481046e0790$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $7b788481046e0790$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $7b788481046e0790$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $7b788481046e0790$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $7b788481046e0790$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($7b788481046e0790$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($7b788481046e0790$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $7b788481046e0790$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $7b788481046e0790$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $7b788481046e0790$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $7b788481046e0790$var$defaultFunctionName;
        return fn.name || $7b788481046e0790$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $7b788481046e0790$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $7b788481046e0790$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $9fd74e0770590d2b$export$35059013cd4a06db)(getModule)
    ];
}




var $lUITW = parcelRequire("lUITW");
// eslint-disable-next-line deprecation/deprecation
const $2559764c46e3b6dd$var$WINDOW = (0, $lUITW.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $2559764c46e3b6dd$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $2559764c46e3b6dd$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $2559764c46e3b6dd$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $2559764c46e3b6dd$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $2559764c46e3b6dd$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $2559764c46e3b6dd$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $2559764c46e3b6dd$export$c82d238e23c40b21() {
    if (!$2559764c46e3b6dd$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($2559764c46e3b6dd$export$18cf36ed71d733e7($2559764c46e3b6dd$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $2559764c46e3b6dd$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $2559764c46e3b6dd$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $2559764c46e3b6dd$export$531055a6c684a70a() {
    return "ReportingObserver" in $2559764c46e3b6dd$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $2559764c46e3b6dd$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$2559764c46e3b6dd$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}



var $lUITW = parcelRequire("lUITW");

var $lUITW = parcelRequire("lUITW");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $7cb33b7d088bc773$var$WINDOW = (0, $lUITW.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $7cb33b7d088bc773$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chrome = $7cb33b7d088bc773$var$WINDOW.chrome;
    const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $7cb33b7d088bc773$var$WINDOW && !!$7cb33b7d088bc773$var$WINDOW.history.pushState && !!$7cb33b7d088bc773$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}


// eslint-disable-next-line deprecation/deprecation
const $c812a0861244a9f9$var$WINDOW = (0, $lUITW.getGlobalObject)();
const $c812a0861244a9f9$export$55b6bb1e45c6cf59 = "__sentry_xhr_v2__";
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ const $c812a0861244a9f9$var$handlers = {};
const $c812a0861244a9f9$var$instrumented = {};
/** Instruments given API */ function $c812a0861244a9f9$var$instrument(type) {
    if ($c812a0861244a9f9$var$instrumented[type]) return;
    $c812a0861244a9f9$var$instrumented[type] = true;
    switch(type){
        case "console":
            $c812a0861244a9f9$var$instrumentConsole();
            break;
        case "dom":
            $c812a0861244a9f9$export$3014bbf0af0e1d4a();
            break;
        case "xhr":
            $c812a0861244a9f9$export$c67d533bf77cbf54();
            break;
        case "fetch":
            $c812a0861244a9f9$var$instrumentFetch();
            break;
        case "history":
            $c812a0861244a9f9$var$instrumentHistory();
            break;
        case "error":
            $c812a0861244a9f9$var$instrumentError();
            break;
        case "unhandledrejection":
            $c812a0861244a9f9$var$instrumentUnhandledRejection();
            break;
        default:
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn("unknown instrumentation type:", type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c812a0861244a9f9$export$285b9172a3741fb7(type, callback) {
    $c812a0861244a9f9$var$handlers[type] = $c812a0861244a9f9$var$handlers[type] || [];
    $c812a0861244a9f9$var$handlers[type].push(callback);
    $c812a0861244a9f9$var$instrument(type);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $c812a0861244a9f9$export$b17eab759a1cb5fe() {
    Object.keys($c812a0861244a9f9$var$handlers).forEach((key)=>{
        $c812a0861244a9f9$var$handlers[key] = undefined;
    });
}
/** JSDoc */ function $c812a0861244a9f9$var$triggerHandlers(type, data) {
    if (!type || !$c812a0861244a9f9$var$handlers[type]) return;
    for (const handler of $c812a0861244a9f9$var$handlers[type] || [])try {
        handler(data);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $7b788481046e0790$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
/** JSDoc */ function $c812a0861244a9f9$var$instrumentConsole() {
    if (!("console" in (0, $lUITW.GLOBAL_OBJ))) return;
    (0, $4b1176a6f20e7b1f$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $lUITW.GLOBAL_OBJ).console)) return;
        (0, $74b7af9ca2a070de$export$9563e054e6f787fb)((0, $lUITW.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $4b1176a6f20e7b1f$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                $c812a0861244a9f9$var$triggerHandlers("console", {
                    args: args,
                    level: level
                });
                const log = (0, $4b1176a6f20e7b1f$export$77c4ce905194557b)[level];
                log && log.apply((0, $lUITW.GLOBAL_OBJ).console, args);
            };
        });
    });
}
/** JSDoc */ function $c812a0861244a9f9$var$instrumentFetch() {
    if (!(0, $2559764c46e3b6dd$export$c82d238e23c40b21)()) return;
    (0, $74b7af9ca2a070de$export$9563e054e6f787fb)((0, $lUITW.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $c812a0861244a9f9$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            $c812a0861244a9f9$var$triggerHandlers("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $lUITW.GLOBAL_OBJ), args).then((response)=>{
                $c812a0861244a9f9$var$triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                });
                return response;
            }, (error)=>{
                $c812a0861244a9f9$var$triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                });
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $c812a0861244a9f9$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $c812a0861244a9f9$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($c812a0861244a9f9$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request
 */ function $c812a0861244a9f9$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $c812a0861244a9f9$var$getUrlFromResource(url),
            method: $c812a0861244a9f9$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $c812a0861244a9f9$var$getUrlFromResource(arg),
        method: $c812a0861244a9f9$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
/** JSDoc */ function $c812a0861244a9f9$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$c812a0861244a9f9$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $74b7af9ca2a070de$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const url = args[1];
            const xhrInfo = this[$c812a0861244a9f9$export$55b6bb1e45c6cf59] = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $6c61789183b19ab1$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $6c61789183b19ab1$export$844ec244b1367d54)(url) && xhrInfo.method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$c812a0861244a9f9$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    $c812a0861244a9f9$var$triggerHandlers("xhr", {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: this
                    });
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $74b7af9ca2a070de$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $74b7af9ca2a070de$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$c812a0861244a9f9$export$55b6bb1e45c6cf59];
                    if (xhrInfo) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $74b7af9ca2a070de$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$c812a0861244a9f9$export$55b6bb1e45c6cf59];
            if (sentryXhrData && args[0] !== undefined) sentryXhrData.body = args[0];
            $c812a0861244a9f9$var$triggerHandlers("xhr", {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
let $c812a0861244a9f9$var$lastHref;
/** JSDoc */ function $c812a0861244a9f9$var$instrumentHistory() {
    if (!(0, $7cb33b7d088bc773$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $c812a0861244a9f9$var$WINDOW.onpopstate;
    $c812a0861244a9f9$var$WINDOW.onpopstate = function(...args) {
        const to = $c812a0861244a9f9$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $c812a0861244a9f9$var$lastHref;
        $c812a0861244a9f9$var$lastHref = to;
        $c812a0861244a9f9$var$triggerHandlers("history", {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $c812a0861244a9f9$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $c812a0861244a9f9$var$lastHref = to;
                $c812a0861244a9f9$var$triggerHandlers("history", {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $74b7af9ca2a070de$export$9563e054e6f787fb)($c812a0861244a9f9$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $74b7af9ca2a070de$export$9563e054e6f787fb)($c812a0861244a9f9$var$WINDOW.history, "replaceState", historyReplacementFunction);
}
const $c812a0861244a9f9$var$debounceDuration = 1000;
let $c812a0861244a9f9$var$debounceTimerID;
let $c812a0861244a9f9$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $c812a0861244a9f9$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c812a0861244a9f9$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== "keypress") return false;
    try {
        const target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $c812a0861244a9f9$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $c812a0861244a9f9$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($c812a0861244a9f9$var$shouldSkipDOMEvent(event)) return;
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($c812a0861244a9f9$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $c812a0861244a9f9$var$lastCapturedEvent = event;
        } else if ($c812a0861244a9f9$var$shouldShortcircuitPreviousDebounce($c812a0861244a9f9$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $c812a0861244a9f9$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c812a0861244a9f9$var$debounceTimerID);
        $c812a0861244a9f9$var$debounceTimerID = $c812a0861244a9f9$var$WINDOW.setTimeout(()=>{
            $c812a0861244a9f9$var$debounceTimerID = undefined;
        }, $c812a0861244a9f9$var$debounceDuration);
    };
}
/** JSDoc */ function $c812a0861244a9f9$export$3014bbf0af0e1d4a() {
    if (!$c812a0861244a9f9$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = $c812a0861244a9f9$var$triggerHandlers.bind(null, "dom");
    const globalDOMEventHandler = $c812a0861244a9f9$var$makeDOMEventHandler(triggerDOMHandler, true);
    $c812a0861244a9f9$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $c812a0861244a9f9$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $c812a0861244a9f9$var$WINDOW[target] && $c812a0861244a9f9$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $74b7af9ca2a070de$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $c812a0861244a9f9$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $74b7af9ca2a070de$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
let $c812a0861244a9f9$var$_oldOnErrorHandler = null;
/** JSDoc */ function $c812a0861244a9f9$var$instrumentError() {
    $c812a0861244a9f9$var$_oldOnErrorHandler = $c812a0861244a9f9$var$WINDOW.onerror;
    $c812a0861244a9f9$var$WINDOW.onerror = function(msg, url, line, column, error) {
        $c812a0861244a9f9$var$triggerHandlers("error", {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($c812a0861244a9f9$var$_oldOnErrorHandler && !$c812a0861244a9f9$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $c812a0861244a9f9$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $c812a0861244a9f9$var$WINDOW.onerror.__SENTRY_INSTRUMENTED__ = true;
}
let $c812a0861244a9f9$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $c812a0861244a9f9$var$instrumentUnhandledRejection() {
    $c812a0861244a9f9$var$_oldOnUnhandledRejectionHandler = $c812a0861244a9f9$var$WINDOW.onunhandledrejection;
    $c812a0861244a9f9$var$WINDOW.onunhandledrejection = function(e) {
        $c812a0861244a9f9$var$triggerHandlers("unhandledrejection", e);
        if ($c812a0861244a9f9$var$_oldOnUnhandledRejectionHandler && !$c812a0861244a9f9$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $c812a0861244a9f9$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $c812a0861244a9f9$var$WINDOW.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $fb8b185dbe330d58$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a5c642510209d97a$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $a5c642510209d97a$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $a5c642510209d97a$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $a5c642510209d97a$export$a3295358bff77e(object, depth);
    if ($a5c642510209d97a$var$jsonSize(normalized) > maxSize) return $a5c642510209d97a$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $a5c642510209d97a$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $fb8b185dbe330d58$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $6c61789183b19ab1$export$c9f5652083b8129d)(value)) return value;
    const stringified = $a5c642510209d97a$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $a5c642510209d97a$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $74b7af9ca2a070de$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $a5c642510209d97a$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $a5c642510209d97a$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $6c61789183b19ab1$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $6c61789183b19ab1$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $7b788481046e0790$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $a5c642510209d97a$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $a5c642510209d97a$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $a5c642510209d97a$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a5c642510209d97a$var$jsonSize(value) {
    return $a5c642510209d97a$var$utf8Length(JSON.stringify(value));
}



/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $a26bfeaec133359b$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $a26bfeaec133359b$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $a26bfeaec133359b$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $a26bfeaec133359b$export$604a45d95a155e2b(envelope, types) {
    return $a26bfeaec133359b$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $a26bfeaec133359b$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $a26bfeaec133359b$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $a26bfeaec133359b$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $a26bfeaec133359b$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $a5c642510209d97a$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $a26bfeaec133359b$var$concatBuffers(parts);
}
function $a26bfeaec133359b$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $a26bfeaec133359b$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $a26bfeaec133359b$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $a26bfeaec133359b$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $74b7af9ca2a070de$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $a26bfeaec133359b$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $a26bfeaec133359b$export$b11169581eeaf237(type) {
    return $a26bfeaec133359b$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from from the metadata or an events */ function $a26bfeaec133359b$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $a26bfeaec133359b$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $03fe2394ad772485$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $74b7af9ca2a070de$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}

/** An error emitted by Sentry SDKs and related utilities. */ class $1e28be3d2d82b3e4$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $72db65f5a0b968d3$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $72db65f5a0b968d3$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $a26bfeaec133359b$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $03fe2394ad772485$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $a26bfeaec133359b$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $72db65f5a0b968d3$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $a26bfeaec133359b$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $72db65f5a0b968d3$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $a26bfeaec133359b$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $a26bfeaec133359b$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}






/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatchs the `createDsc` lifecycle hook as a side effect.
 */ function $73a5bc21da1dc86b$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $74b7af9ca2a070de$export$d25f2688db1bb433)({
        environment: options.environment || (0, $417b285f8867e44d$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}



var $f36CY = parcelRequire("f36CY");
var $lUITW = parcelRequire("lUITW");



/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $57a5a9367c7cf5e6$export$2d67fb380bd11267(options, event, hint, scope, client) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $3b650695bc2391ad$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $f36CY.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $57a5a9367c7cf5e6$var$applyClientOptions(prepared, options);
    $57a5a9367c7cf5e6$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $57a5a9367c7cf5e6$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    let finalScope = scope;
    if (hint.captureContext) finalScope = (0, $ae6ef75877262323$export$775b6bb06e53a214).clone(finalScope).update(hint.captureContext);
    // We prepare the result here with a resolved Event.
    let result = (0, $43317b8e021dd6a3$export$1fda8aa4d135f8aa)(prepared);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    //
    // We need to check for the existence of `finalScope.getAttachments`
    // because `getAttachments` can be undefined if users are using an older version
    // of `@sentry/core` that does not have the `getAttachments` method.
    // See: https://github.com/getsentry/sentry-javascript/issues/5229
    if (finalScope) {
        // Collect attachments from the hint and scope
        if (finalScope.getAttachments) {
            const attachments = [
                ...hint.attachments || [],
                ...finalScope.getAttachments()
            ];
            if (attachments.length) hint.attachments = attachments;
        }
        // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint, clientEventProcessors);
    } else // Apply client & global event processors even if there is no scope
    // TODO (v8): Update the order to be Global > Client
    result = (0, $fee1bd2c7a674a45$export$bf2a096c3e883e79)([
        ...clientEventProcessors,
        ...(0, $fee1bd2c7a674a45$export$3c4238858b85e8ac)()
    ], prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $57a5a9367c7cf5e6$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $57a5a9367c7cf5e6$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $57a5a9367c7cf5e6$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $417b285f8867e44d$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $60afb67600f3a77a$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $60afb67600f3a77a$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $60afb67600f3a77a$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $57a5a9367c7cf5e6$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $57a5a9367c7cf5e6$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $lUITW.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $57a5a9367c7cf5e6$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $57a5a9367c7cf5e6$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $57a5a9367c7cf5e6$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $57a5a9367c7cf5e6$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $57a5a9367c7cf5e6$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $a5c642510209d97a$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $a5c642510209d97a$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $a5c642510209d97a$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $a5c642510209d97a$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $a5c642510209d97a$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
        if (span.data) span.data = (0, $a5c642510209d97a$export$a3295358bff77e)(span.data, depth, maxBreadth);
        return span;
    });
    return normalized;
}


const $fa6a3983d13b6123$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $fa6a3983d13b6123$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $03fe2394ad772485$export$128827c3562ec0cb)(options.dsn);
        else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $990f87ed31df4d12$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $3b650695bc2391ad$export$6de4ffac6a2f1098)(exception)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).log($fa6a3983d13b6123$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const promisedEvent = (0, $6c61789183b19ab1$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(String(message), level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $3b650695bc2391ad$export$6de4ffac6a2f1098)(hint.originalException)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).log($fa6a3983d13b6123$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $8ddda6fac19e03d9$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
            return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
        });
        else return (0, $43317b8e021dd6a3$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Sets up the integrations
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) {
            this._integrations = (0, $f4365ba8c8e60c77$export$51abed9797baa598)(this, this._options.integrations);
            this._integrationsInitialized = true;
        }
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */ getIntegrationById(integrationId) {
        return this._integrations[integrationId];
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        (0, $f4365ba8c8e60c77$export$e7390a03b70a6f2f)(this, integration, this._integrations);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $72db65f5a0b968d3$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $a26bfeaec133359b$export$d650323442802f6f)(env, (0, $a26bfeaec133359b$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $72db65f5a0b968d3$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $8ddda6fac19e03d9$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $43317b8e021dd6a3$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $57a5a9367c7cf5e6$export$2d67fb380bd11267)(options, event, hint, scope, this).then((evt)=>{
            if (evt === null) return evt;
            // If a trace context is not set on the event, we use the propagationContext set on the event to
            // generate a trace context. If the propagationContext does not have a dynamic sampling context, we
            // also generate one for it.
            const { propagationContext: propagationContext } = evt.sdkProcessingMetadata || {};
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $73a5bc21da1dc86b$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $fa6a3983d13b6123$var$isTransactionEvent(event);
        const isError = $fa6a3983d13b6123$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $43317b8e021dd6a3$export$78e43115b553f358)(new (0, $1e28be3d2d82b3e4$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        return this._prepareEvent(event, hint, scope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $1e28be3d2d82b3e4$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $fa6a3983d13b6123$var$processBeforeSend(options, prepared, hint);
            return $fa6a3983d13b6123$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $1e28be3d2d82b3e4$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $1e28be3d2d82b3e4$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $1e28be3d2d82b3e4$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).error("Error while sending event:", reason);
        });
        else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $fa6a3983d13b6123$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $6c61789183b19ab1$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $6c61789183b19ab1$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $1e28be3d2d82b3e4$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $1e28be3d2d82b3e4$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $6c61789183b19ab1$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $1e28be3d2d82b3e4$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $fa6a3983d13b6123$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($fa6a3983d13b6123$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($fa6a3983d13b6123$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $fa6a3983d13b6123$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $fa6a3983d13b6123$var$isTransactionEvent(event) {
    return event.type === "transaction";
}

const $d71c911714d1a1f8$export$31499a9cd224b78c = "7.73.0";




var $f36CY = parcelRequire("f36CY");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $f2ebc5a01d1b177d$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $f36CY.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $a26bfeaec133359b$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $h7eDV = parcelRequire("h7eDV");


/**
 * This function creates an exception from a JavaScript Error
 */ function $9c3f0f93d5ffe10b$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $9c3f0f93d5ffe10b$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $9c3f0f93d5ffe10b$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $9c3f0f93d5ffe10b$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const hub = (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)();
    const client = hub.getClient();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $6c61789183b19ab1$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $9c3f0f93d5ffe10b$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $a5c642510209d97a$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $9c3f0f93d5ffe10b$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $9c3f0f93d5ffe10b$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $9c3f0f93d5ffe10b$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $9c3f0f93d5ffe10b$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $9c3f0f93d5ffe10b$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $9c3f0f93d5ffe10b$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $9c3f0f93d5ffe10b$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($9c3f0f93d5ffe10b$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $9c3f0f93d5ffe10b$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $9c3f0f93d5ffe10b$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $9c3f0f93d5ffe10b$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $3b650695bc2391ad$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $43317b8e021dd6a3$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $9c3f0f93d5ffe10b$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $9c3f0f93d5ffe10b$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $43317b8e021dd6a3$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $9c3f0f93d5ffe10b$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $6c61789183b19ab1$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $9c3f0f93d5ffe10b$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $6c61789183b19ab1$export$ef9e2056653f0c8e)(exception) || (0, $6c61789183b19ab1$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $9c3f0f93d5ffe10b$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $6c61789183b19ab1$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $9c3f0f93d5ffe10b$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $3b650695bc2391ad$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $6c61789183b19ab1$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $9c3f0f93d5ffe10b$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $6c61789183b19ab1$export$53b83ca8eaab0383)(exception) || (0, $6c61789183b19ab1$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $9c3f0f93d5ffe10b$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $3b650695bc2391ad$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $9c3f0f93d5ffe10b$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $3b650695bc2391ad$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $3b650695bc2391ad$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $9c3f0f93d5ffe10b$export$47d86ae4b3c9994(stackParser, input, syntheticException, attachStacktrace) {
    const event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        const frames = $9c3f0f93d5ffe10b$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: input,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    return event;
}
function $9c3f0f93d5ffe10b$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $74b7af9ca2a070de$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $6c61789183b19ab1$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $6c61789183b19ab1$export$9671ea99bd126ace)(exception)) {
        const className = $9c3f0f93d5ffe10b$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $9c3f0f93d5ffe10b$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}




// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $578bd50dbbc4ca80$export$f5282963edea4a68(exception, captureContext) {
    return (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().captureException(exception, {
        captureContext: captureContext
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */ function $578bd50dbbc4ca80$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */ function $578bd50dbbc4ca80$export$1462b974fdcf6ba2(event, hint) {
    return (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */ function $578bd50dbbc4ca80$export$99d44f04437e9cb8(callback) {
    (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function $578bd50dbbc4ca80$export$efda9a273d7a036d(breadcrumb) {
    (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $578bd50dbbc4ca80$export$2f04de43fe27971a(name, context) {
    (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $578bd50dbbc4ca80$export$bb4922da0dd51b92(extras) {
    (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $578bd50dbbc4ca80$export$8e8e7789d42ed61d(key, extra) {
    (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $578bd50dbbc4ca80$export$74a8fb34822092e6(tags) {
    (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $578bd50dbbc4ca80$export$a37d07ee78eb4569(key, value) {
    (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $578bd50dbbc4ca80$export$8b6bb3dd62a01be2(user) {
    (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */ function $578bd50dbbc4ca80$export$ec58d9285c204497(callback) {
    (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().withScope(callback);
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */ function $578bd50dbbc4ca80$export$e262da7ae6480481(context, customSamplingContext) {
    return (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $578bd50dbbc4ca80$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const hub = (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)();
    const scope = hub.getScope();
    const client = hub.getClient();
    if (!client) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $3b650695bc2391ad$export$19f53698e68b2496)();
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $578bd50dbbc4ca80$export$4909b86c8034bf73(timeout) {
    const client = (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().getClient();
    if (client) return client.flush(timeout);
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $578bd50dbbc4ca80$export$8360e631d277ea4d(timeout) {
    const client = (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().getClient();
    if (client) return client.close(timeout);
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $578bd50dbbc4ca80$export$5d4e9fd7fac8e617() {
    return (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().lastEventId();
}



var $lUITW = parcelRequire("lUITW");
const $b8c60adede782494$export$56d8a8a25bd48b81 = (0, $lUITW.GLOBAL_OBJ);
let $b8c60adede782494$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $b8c60adede782494$export$b79738ab10c590b2() {
    return $b8c60adede782494$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $b8c60adede782494$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $b8c60adede782494$var$ignoreOnError++;
    setTimeout(()=>{
        $b8c60adede782494$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $b8c60adede782494$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $74b7af9ca2a070de$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$b8c60adede782494$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $b8c60adede782494$export$1265a142ff5ba165();
            (0, $578bd50dbbc4ca80$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $3b650695bc2391ad$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $3b650695bc2391ad$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $578bd50dbbc4ca80$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $74b7af9ca2a070de$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $74b7af9ca2a070de$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $d3f6c9bf7e7f003b$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $03fe2394ad772485$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $d3f6c9bf7e7f003b$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $a26bfeaec133359b$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $d3f6c9bf7e7f003b$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $00896f509ecfc73c$export$1df9218a526d318d extends (0, $fa6a3983d13b6123$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $b8c60adede782494$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $h7eDV.getSDKSource)();
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: "sentry.javascript.browser",
            packages: [
                {
                    name: `${sdkSource}:@sentry/browser`,
                    version: (0, $d71c911714d1a1f8$export$31499a9cd224b78c)
                }
            ],
            version: (0, $d71c911714d1a1f8$export$31499a9cd224b78c)
        };
        super(options);
        if (options.sendClientReports && (0, $b8c60adede782494$export$56d8a8a25bd48b81).document) (0, $b8c60adede782494$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $b8c60adede782494$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $9c3f0f93d5ffe10b$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $9c3f0f93d5ffe10b$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $d3f6c9bf7e7f003b$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $f2ebc5a01d1b177d$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $03fe2394ad772485$export$44d472fbb931a776)(this._dsn));
        this._sendEnvelope(envelope);
    }
}







/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Global handlers */ class $c5d4bb2919b1064b$export$204155decbc90e5a {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "GlobalHandlers";
    }
    /**
   * @inheritDoc
   */ /** JSDoc */ /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */ /** JSDoc */ constructor(options){
        this.name = $c5d4bb2919b1064b$export$204155decbc90e5a.id;
        this._options = {
            onerror: true,
            onunhandledrejection: true,
            ...options
        };
        this._installFunc = {
            onerror: $c5d4bb2919b1064b$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $c5d4bb2919b1064b$var$_installGlobalOnUnhandledRejectionHandler
        };
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        Error.stackTraceLimit = 50;
        const options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(const key in options){
            const installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $c5d4bb2919b1064b$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    }
}
$c5d4bb2919b1064b$export$204155decbc90e5a.__initStatic();
/** JSDoc */ function $c5d4bb2919b1064b$var$_installGlobalOnErrorHandler() {
    (0, $c812a0861244a9f9$export$285b9172a3741fb7)("error", // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data)=>{
        const [hub, stackParser, attachStacktrace] = $c5d4bb2919b1064b$var$getHubAndOptions();
        if (!hub.getIntegration($c5d4bb2919b1064b$export$204155decbc90e5a)) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        if ((0, $b8c60adede782494$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return;
        const event = error === undefined && (0, $6c61789183b19ab1$export$844ec244b1367d54)(msg) ? $c5d4bb2919b1064b$var$_eventFromIncompleteOnError(msg, url, line, column) : $c5d4bb2919b1064b$var$_enhanceEventWithInitialFrame((0, $9c3f0f93d5ffe10b$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        $c5d4bb2919b1064b$var$addMechanismAndCapture(hub, error, event, "onerror");
    });
}
/** JSDoc */ function $c5d4bb2919b1064b$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $c812a0861244a9f9$export$285b9172a3741fb7)("unhandledrejection", // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        const [hub, stackParser, attachStacktrace] = $c5d4bb2919b1064b$var$getHubAndOptions();
        if (!hub.getIntegration($c5d4bb2919b1064b$export$204155decbc90e5a)) return;
        let error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ("reason" in e) error = e.reason;
            else if ("detail" in e && "reason" in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $b8c60adede782494$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return true;
        const event = (0, $6c61789183b19ab1$export$c3825b437cbdea5c)(error) ? $c5d4bb2919b1064b$var$_eventFromRejectionWithPrimitive(error) : (0, $9c3f0f93d5ffe10b$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        $c5d4bb2919b1064b$var$addMechanismAndCapture(hub, error, event, "onunhandledrejection");
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $c5d4bb2919b1064b$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c5d4bb2919b1064b$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $6c61789183b19ab1$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $c5d4bb2919b1064b$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c5d4bb2919b1064b$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $6c61789183b19ab1$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $f89c4fd7ab146b2a$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $c5d4bb2919b1064b$var$globalHandlerLog(type) {
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $c5d4bb2919b1064b$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $3b650695bc2391ad$export$c69a9a0313b03bb1)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $c5d4bb2919b1064b$var$getHubAndOptions() {
    const hub = (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)();
    const client = hub.getClient();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return [
        hub,
        options.stackParser,
        options.attachStacktrace
    ];
}




const $36fc6a324cf2694d$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ class $36fc6a324cf2694d$export$f1a018517668e6d3 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "TryCatch";
    }
    /**
   * @inheritDoc
   */ /** JSDoc */ /**
   * @inheritDoc
   */ constructor(options){
        this.name = $36fc6a324cf2694d$export$f1a018517668e6d3.id;
        this._options = {
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true,
            ...options
        };
    }
    /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */ setupOnce() {
        if (this._options.setTimeout) (0, $74b7af9ca2a070de$export$9563e054e6f787fb)((0, $b8c60adede782494$export$56d8a8a25bd48b81), "setTimeout", $36fc6a324cf2694d$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $74b7af9ca2a070de$export$9563e054e6f787fb)((0, $b8c60adede782494$export$56d8a8a25bd48b81), "setInterval", $36fc6a324cf2694d$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $74b7af9ca2a070de$export$9563e054e6f787fb)((0, $b8c60adede782494$export$56d8a8a25bd48b81), "requestAnimationFrame", $36fc6a324cf2694d$var$_wrapRAF);
        if (this._options.XMLHttpRequest && "XMLHttpRequest" in (0, $b8c60adede782494$export$56d8a8a25bd48b81)) (0, $74b7af9ca2a070de$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $36fc6a324cf2694d$var$_wrapXHR);
        const eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $36fc6a324cf2694d$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($36fc6a324cf2694d$var$_wrapEventTarget);
        }
    }
}
$36fc6a324cf2694d$export$f1a018517668e6d3.__initStatic();
/** JSDoc */ function $36fc6a324cf2694d$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $b8c60adede782494$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $7b788481046e0790$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $36fc6a324cf2694d$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $b8c60adede782494$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $7b788481046e0790$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
/** JSDoc */ function $36fc6a324cf2694d$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $74b7af9ca2a070de$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $7b788481046e0790$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $74b7af9ca2a070de$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $7b788481046e0790$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $b8c60adede782494$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $36fc6a324cf2694d$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $b8c60adede782494$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $74b7af9ca2a070de$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $b8c60adede782494$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $7b788481046e0790$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $b8c60adede782494$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $7b788481046e0790$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $74b7af9ca2a070de$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $31a2413eebb2e6e3$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $31a2413eebb2e6e3$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $31a2413eebb2e6e3$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $31a2413eebb2e6e3$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    .replace(":80", "").replace(":443", "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $f2289477ce760d32$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $f2289477ce760d32$export$e01cef29b4327697(level) {
    return $f2289477ce760d32$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $f2289477ce760d32$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $f2289477ce760d32$export$411d0ffdba845b6c.includes(level) ? level : "log";
}



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $6443e9bf40712756$var$MAX_ALLOWED_STRING_LENGTH = 1024;
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ class $6443e9bf40712756$export$2dc68d50d56fbbd {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Breadcrumbs";
    }
    /**
   * @inheritDoc
   */ /**
   * Options of the breadcrumbs integration.
   */ // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
    /**
   * @inheritDoc
   */ constructor(options){
        this.name = $6443e9bf40712756$export$2dc68d50d56fbbd.id;
        this.options = {
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true,
            ...options
        };
    }
    /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */ setupOnce() {
        if (this.options.console) (0, $c812a0861244a9f9$export$285b9172a3741fb7)("console", $6443e9bf40712756$var$_consoleBreadcrumb);
        if (this.options.dom) (0, $c812a0861244a9f9$export$285b9172a3741fb7)("dom", $6443e9bf40712756$var$_domBreadcrumb(this.options.dom));
        if (this.options.xhr) (0, $c812a0861244a9f9$export$285b9172a3741fb7)("xhr", $6443e9bf40712756$var$_xhrBreadcrumb);
        if (this.options.fetch) (0, $c812a0861244a9f9$export$285b9172a3741fb7)("fetch", $6443e9bf40712756$var$_fetchBreadcrumb);
        if (this.options.history) (0, $c812a0861244a9f9$export$285b9172a3741fb7)("history", $6443e9bf40712756$var$_historyBreadcrumb);
        if (this.options.sentry) {
            const client = (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().getClient();
            client && client.on && client.on("beforeSendEvent", $6443e9bf40712756$var$addSentryBreadcrumb);
        }
    }
}
$6443e9bf40712756$export$2dc68d50d56fbbd.__initStatic();
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $6443e9bf40712756$var$addSentryBreadcrumb(event) {
    (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().addBreadcrumb({
        category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
        event_id: event.event_id,
        level: event.level,
        message: (0, $3b650695bc2391ad$export$4157119e2b157127)(event)
    }, {
        event: event
    });
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $6443e9bf40712756$var$_domBreadcrumb(dom) {
    function _innerDomBreadcrumb(handlerData) {
        let target;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $6443e9bf40712756$var$MAX_ALLOWED_STRING_LENGTH) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$6443e9bf40712756$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$6443e9bf40712756$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $6443e9bf40712756$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            target = $6443e9bf40712756$var$_isEvent(event) ? (0, $f89c4fd7ab146b2a$export$5647df6b7814ac86)(event.target, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            }) : (0, $f89c4fd7ab146b2a$export$5647df6b7814ac86)(event, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: `ui.${handlerData.name}`,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ function $6443e9bf40712756$var$_consoleBreadcrumb(handlerData) {
    const breadcrumb = {
        category: "console",
        data: {
            arguments: handlerData.args,
            logger: "console"
        },
        level: (0, $f2289477ce760d32$export$d771ef054122c30a)(handlerData.level),
        message: (0, $60afb67600f3a77a$export$465e9d514283d4fd)(handlerData.args, " ")
    };
    if (handlerData.level === "assert") {
        if (handlerData.args[0] === false) {
            breadcrumb.message = `Assertion failed: ${(0, $60afb67600f3a77a$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $6443e9bf40712756$var$_xhrBreadcrumb(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
    const sentryXhrData = handlerData.xhr[0, $c812a0861244a9f9$export$55b6bb1e45c6cf59];
    // We only capture complete, non-sentry requests
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
    const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
    const data = {
        method: method,
        url: url,
        status_code: status_code
    };
    const hint = {
        xhr: handlerData.xhr,
        input: body,
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp
    };
    (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().addBreadcrumb({
        category: "xhr",
        data: data,
        type: "http"
    }, hint);
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $6443e9bf40712756$var$_fetchBreadcrumb(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
    // We only capture complete fetch requests
    if (!endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) {
        const data = handlerData.fetchData;
        const hint = {
            data: handlerData.error,
            input: handlerData.args,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: "fetch",
            data: data,
            level: "error",
            type: "http"
        }, hint);
    } else {
        const data = {
            ...handlerData.fetchData,
            status_code: handlerData.response && handlerData.response.status
        };
        const hint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: "fetch",
            data: data,
            type: "http"
        }, hint);
    }
}
/**
 * Creates breadcrumbs from history API calls
 */ function $6443e9bf40712756$var$_historyBreadcrumb(handlerData) {
    let from = handlerData.from;
    let to = handlerData.to;
    const parsedLoc = (0, $31a2413eebb2e6e3$export$7a5253c0f62e0150)((0, $b8c60adede782494$export$56d8a8a25bd48b81).location.href);
    let parsedFrom = (0, $31a2413eebb2e6e3$export$7a5253c0f62e0150)(from);
    const parsedTo = (0, $31a2413eebb2e6e3$export$7a5253c0f62e0150)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().addBreadcrumb({
        category: "navigation",
        data: {
            from: from,
            to: to
        }
    });
}
function $6443e9bf40712756$var$_isEvent(event) {
    return !!event && !!event.target;
}




/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $e7e66f91c8de41f3$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $6c61789183b19ab1$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $e7e66f91c8de41f3$var$truncateAggregateExceptions($e7e66f91c8de41f3$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $e7e66f91c8de41f3$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ((0, $6c61789183b19ab1$export$49034edbe6b62415)(error[key], Error)) {
        $e7e66f91c8de41f3$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $e7e66f91c8de41f3$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $e7e66f91c8de41f3$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $6c61789183b19ab1$export$49034edbe6b62415)(childError, Error)) {
            $e7e66f91c8de41f3$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $e7e66f91c8de41f3$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $e7e66f91c8de41f3$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $e7e66f91c8de41f3$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        is_exception_group: true,
        exception_id: exceptionId
    };
}
function $e7e66f91c8de41f3$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $e7e66f91c8de41f3$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $60afb67600f3a77a$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $81b5e723bc969648$var$DEFAULT_KEY = "cause";
const $81b5e723bc969648$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ class $81b5e723bc969648$export$8d1e60aaf616fb4f {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "LinkedErrors";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $81b5e723bc969648$export$8d1e60aaf616fb4f.id;
        this._key = options.key || $81b5e723bc969648$var$DEFAULT_KEY;
        this._limit = options.limit || $81b5e723bc969648$var$DEFAULT_LIMIT;
    }
    /** @inheritdoc */ setupOnce() {
    // noop
    }
    /**
   * @inheritDoc
   */ preprocessEvent(event, hint, client) {
        const options = client.getOptions();
        (0, $e7e66f91c8de41f3$export$b91c38ed7d8ae9b2)((0, $9c3f0f93d5ffe10b$export$a6c2d27607295951), options.stackParser, options.maxValueLength, this._key, this._limit, event, hint);
    }
}
$81b5e723bc969648$export$8d1e60aaf616fb4f.__initStatic();



/** HttpContext integration collects information about HTTP request headers */ class $8f68cf7afd5d8c7f$export$5d2ee9a544b09a94 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "HttpContext";
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $8f68cf7afd5d8c7f$export$5d2ee9a544b09a94.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
    // noop
    }
    /** @inheritDoc */ preprocessEvent(event) {
        // if none of the information we want exists, don't bother
        if (!(0, $b8c60adede782494$export$56d8a8a25bd48b81).navigator && !(0, $b8c60adede782494$export$56d8a8a25bd48b81).location && !(0, $b8c60adede782494$export$56d8a8a25bd48b81).document) return;
        // grab as much info as exists and add it to the event
        const url = event.request && event.request.url || (0, $b8c60adede782494$export$56d8a8a25bd48b81).location && (0, $b8c60adede782494$export$56d8a8a25bd48b81).location.href;
        const { referrer: referrer } = (0, $b8c60adede782494$export$56d8a8a25bd48b81).document || {};
        const { userAgent: userAgent } = (0, $b8c60adede782494$export$56d8a8a25bd48b81).navigator || {};
        const headers = {
            ...event.request && event.request.headers,
            ...referrer && {
                Referer: referrer
            },
            ...userAgent && {
                "User-Agent": userAgent
            }
        };
        const request = {
            ...event.request,
            ...url && {
                url: url
            },
            headers: headers
        };
        event.request = request;
    }
}
$8f68cf7afd5d8c7f$export$5d2ee9a544b09a94.__initStatic();



/** Deduplication filter */ class $71de10041b07e4e7$export$688d98c249d31ad3 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Dedupe";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(){
        this.name = $71de10041b07e4e7$export$688d98c249d31ad3.id;
    }
    /** @inheritDoc */ setupOnce(_addGlobaleventProcessor, _getCurrentHub) {
    // noop
    }
    /**
   * @inheritDoc
   */ processEvent(currentEvent) {
        // We want to ignore any non-error type events, e.g. transactions or replays
        // These should never be deduped, and also not be compared against as _previousEvent.
        if (currentEvent.type) return currentEvent;
        // Juuust in case something goes wrong
        try {
            if ($71de10041b07e4e7$var$_shouldDropEvent(currentEvent, this._previousEvent)) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                return null;
            }
        } catch (_oO) {} // eslint-disable-line no-empty
        return this._previousEvent = currentEvent;
    }
}
$71de10041b07e4e7$export$688d98c249d31ad3.__initStatic();
/** JSDoc */ function $71de10041b07e4e7$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($71de10041b07e4e7$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($71de10041b07e4e7$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $71de10041b07e4e7$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$71de10041b07e4e7$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$71de10041b07e4e7$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $71de10041b07e4e7$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $71de10041b07e4e7$var$_getExceptionFromEvent(previousEvent);
    const currentException = $71de10041b07e4e7$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$71de10041b07e4e7$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$71de10041b07e4e7$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $71de10041b07e4e7$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $71de10041b07e4e7$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $71de10041b07e4e7$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $71de10041b07e4e7$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $71de10041b07e4e7$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $71de10041b07e4e7$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}



// global reference to slice
const $20341c809d1924de$var$UNKNOWN_FUNCTION = "?";
const $20341c809d1924de$var$OPERA10_PRIORITY = 10;
const $20341c809d1924de$var$OPERA11_PRIORITY = 20;
const $20341c809d1924de$var$CHROME_PRIORITY = 30;
const $20341c809d1924de$var$WINJS_PRIORITY = 40;
const $20341c809d1924de$var$GECKO_PRIORITY = 50;
function $20341c809d1924de$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $20341c809d1924de$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $20341c809d1924de$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $20341c809d1924de$var$chrome = (line)=>{
    const parts = $20341c809d1924de$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $20341c809d1924de$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $20341c809d1924de$var$extractSafariExtensionDetails(parts[1] || $20341c809d1924de$var$UNKNOWN_FUNCTION, parts[2]);
        return $20341c809d1924de$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $20341c809d1924de$export$263a749fff749872 = [
    $20341c809d1924de$var$CHROME_PRIORITY,
    $20341c809d1924de$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $20341c809d1924de$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $20341c809d1924de$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $20341c809d1924de$var$gecko = (line)=>{
    const parts = $20341c809d1924de$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $20341c809d1924de$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $20341c809d1924de$var$UNKNOWN_FUNCTION;
        [func, filename] = $20341c809d1924de$var$extractSafariExtensionDetails(func, filename);
        return $20341c809d1924de$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $20341c809d1924de$export$cdba47a5dd2804d = [
    $20341c809d1924de$var$GECKO_PRIORITY,
    $20341c809d1924de$var$gecko
];
const $20341c809d1924de$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $20341c809d1924de$var$winjs = (line)=>{
    const parts = $20341c809d1924de$var$winjsRegex.exec(line);
    return parts ? $20341c809d1924de$var$createFrame(parts[2], parts[1] || $20341c809d1924de$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $20341c809d1924de$export$179460296da408e8 = [
    $20341c809d1924de$var$WINJS_PRIORITY,
    $20341c809d1924de$var$winjs
];
const $20341c809d1924de$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $20341c809d1924de$var$opera10 = (line)=>{
    const parts = $20341c809d1924de$var$opera10Regex.exec(line);
    return parts ? $20341c809d1924de$var$createFrame(parts[2], parts[3] || $20341c809d1924de$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $20341c809d1924de$export$f892b52c880ffc7a = [
    $20341c809d1924de$var$OPERA10_PRIORITY,
    $20341c809d1924de$var$opera10
];
const $20341c809d1924de$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $20341c809d1924de$var$opera11 = (line)=>{
    const parts = $20341c809d1924de$var$opera11Regex.exec(line);
    return parts ? $20341c809d1924de$var$createFrame(parts[5], parts[3] || parts[4] || $20341c809d1924de$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $20341c809d1924de$export$af11af13f09fb0dc = [
    $20341c809d1924de$var$OPERA11_PRIORITY,
    $20341c809d1924de$var$opera11
];
const $20341c809d1924de$export$7197c0fe6554c079 = [
    $20341c809d1924de$export$263a749fff749872,
    $20341c809d1924de$export$cdba47a5dd2804d,
    $20341c809d1924de$export$179460296da408e8
];
const $20341c809d1924de$export$2b2b997d81bf3907 = (0, $7b788481046e0790$export$a5739666fb2d03d4)(...$20341c809d1924de$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $20341c809d1924de$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $20341c809d1924de$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $10f7600103e2a2da$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $10f7600103e2a2da$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $10f7600103e2a2da$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $10f7600103e2a2da$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $10f7600103e2a2da$export$6c91fec22056810a(limits, category, now = Date.now()) {
    return $10f7600103e2a2da$export$b89fc7b2e4c799e7(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $10f7600103e2a2da$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories] = limit.split(":", 2);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";"))updatedRateLimits[category] = now + delay;
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $10f7600103e2a2da$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $12236a60e96b9638$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $43317b8e021dd6a3$export$78e43115b553f358)(new (0, $1e28be3d2d82b3e4$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $43317b8e021dd6a3$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $43317b8e021dd6a3$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


const $bdd9ea59c27ad8ae$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $bdd9ea59c27ad8ae$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $12236a60e96b9638$export$85a4f67f852183e6)(options.bufferSize || $bdd9ea59c27ad8ae$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $a26bfeaec133359b$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const envelopeItemDataCategory = (0, $a26bfeaec133359b$export$b11169581eeaf237)(type);
            if ((0, $10f7600103e2a2da$export$6c91fec22056810a)(rateLimits, envelopeItemDataCategory)) {
                const event = $bdd9ea59c27ad8ae$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", envelopeItemDataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $43317b8e021dd6a3$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $a26bfeaec133359b$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $a26bfeaec133359b$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $bdd9ea59c27ad8ae$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $a26bfeaec133359b$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $a26bfeaec133359b$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $10f7600103e2a2da$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $1e28be3d2d82b3e4$export$5949942ba2a7c0e2)) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $43317b8e021dd6a3$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $bdd9ea59c27ad8ae$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}





let $bae0d4dc4267aa06$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $bae0d4dc4267aa06$export$8be2119ce08e3379() {
    if ($bae0d4dc4267aa06$var$cachedFetchImpl) return $bae0d4dc4267aa06$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $2559764c46e3b6dd$export$18cf36ed71d733e7)((0, $b8c60adede782494$export$56d8a8a25bd48b81).fetch)) return $bae0d4dc4267aa06$var$cachedFetchImpl = (0, $b8c60adede782494$export$56d8a8a25bd48b81).fetch.bind((0, $b8c60adede782494$export$56d8a8a25bd48b81));
    const document = (0, $b8c60adede782494$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $b8c60adede782494$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $bae0d4dc4267aa06$var$cachedFetchImpl = fetchImpl.bind((0, $b8c60adede782494$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $bae0d4dc4267aa06$export$d499686d2dd738c6() {
    $bae0d4dc4267aa06$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $6998468ace9489aa$export$b2311068c46d7cc8(options, nativeFetch = (0, $bae0d4dc4267aa06$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $bae0d4dc4267aa06$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $43317b8e021dd6a3$export$78e43115b553f358)(e);
        }
    }
    return (0, $bdd9ea59c27ad8ae$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $96bbfa089a97a222$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $96bbfa089a97a222$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $43317b8e021dd6a3$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $96bbfa089a97a222$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $bdd9ea59c27ad8ae$export$d09f50d9ab7f7b69)(options, makeRequest);
}


const $df1078b31513eaed$export$5ef831fccfce35e5 = [
    new (0, $7bb4492ac633bb96$exports).InboundFilters(),
    new (0, $7bb4492ac633bb96$exports).FunctionToString(),
    new (0, $36fc6a324cf2694d$export$f1a018517668e6d3)(),
    new (0, $6443e9bf40712756$export$2dc68d50d56fbbd)(),
    new (0, $c5d4bb2919b1064b$export$204155decbc90e5a)(),
    new (0, $81b5e723bc969648$export$8d1e60aaf616fb4f)(),
    new (0, $71de10041b07e4e7$export$688d98c249d31ad3)(),
    new (0, $8f68cf7afd5d8c7f$export$5d2ee9a544b09a94)()
];
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $df1078b31513eaed$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $df1078b31513eaed$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $b8c60adede782494$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $b8c60adede782494$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $b8c60adede782494$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $7b788481046e0790$export$1d5cf88b347146d4)(options.stackParser || (0, $20341c809d1924de$export$2b2b997d81bf3907)),
        integrations: (0, $f4365ba8c8e60c77$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $2559764c46e3b6dd$export$edf3cb81fd7d2a3e)() ? (0, $6998468ace9489aa$export$b2311068c46d7cc8) : (0, $96bbfa089a97a222$export$5e1441cee30d5a39))
    };
    (0, $51cdf70134b9ec4d$export$5333c3f1c58d9bc1)((0, $00896f509ecfc73c$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $df1078b31513eaed$var$startSessionTracking();
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $df1078b31513eaed$export$3a8fd680da42627b(options = {}, hub = (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)()) {
    // doesn't work without a document (React Native)
    if (!(0, $b8c60adede782494$export$56d8a8a25bd48b81).document) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) options.eventId = hub.lastEventId();
    const script = (0, $b8c60adede782494$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $990f87ed31df4d12$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const injectionPoint = (0, $b8c60adede782494$export$56d8a8a25bd48b81).document.head || (0, $b8c60adede782494$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $df1078b31513eaed$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $df1078b31513eaed$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $df1078b31513eaed$export$4997ffc0176396a6(fn) {
    return (0, $b8c60adede782494$export$4997ffc0176396a6)(fn)();
}
function $df1078b31513eaed$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $df1078b31513eaed$var$startSessionTracking() {
    if (typeof (0, $b8c60adede782494$export$56d8a8a25bd48b81).document === "undefined") {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4b1176a6f20e7b1f$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    const hub = (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $df1078b31513eaed$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $c812a0861244a9f9$export$285b9172a3741fb7)("history", ({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $df1078b31513eaed$var$startSessionOnHub((0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)());
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $df1078b31513eaed$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $6bae4b7b360739a4$export$a07cdf6544bbd7c)().getClient();
    if (client) client.captureUserFeedback(feedback);
}




var $1306f19c5d950727$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1306f19c5d950727$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $1306f19c5d950727$exports));
try {
    regeneratorRuntime = $1306f19c5d950727$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $1306f19c5d950727$var$runtime;
    else Function("r", "regeneratorRuntime = r")($1306f19c5d950727$var$runtime);
}


var $9a6b60a71fe287c3$var$HANDJS = $9a6b60a71fe287c3$var$HANDJS || {};
(function() {
    // If the user agent already supports Pointer Events, do nothing
    if (window.PointerEvent) return;
    // Polyfilling indexOf for old browsers
    if (!Array.prototype.indexOf) Array.prototype.indexOf = function(searchElement) {
        var t = Object(this);
        var len = t.length >>> 0;
        if (len === 0) return -1;
        var n = 0;
        if (arguments.length > 0) {
            n = Number(arguments[1]);
            if (n !== n) n = 0;
            else if (n !== 0 && n !== Infinity && n !== -Infinity) n = (n > 0 || -1) * Math.floor(Math.abs(n));
        }
        if (n >= len) return -1;
        var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
        for(; k < len; k++){
            if (k in t && t[k] === searchElement) return k;
        }
        return -1;
    };
    //Polyfilling forEach for old browsers
    if (!Array.prototype.forEach) Array.prototype.forEach = function(method, thisArg) {
        if (!this || !(method instanceof Function)) throw new TypeError();
        for(var i = 0; i < this.length; i++)method.call(thisArg, this[i], i, this);
    };
    // Polyfilling trim for old browsers
    if (!String.prototype.trim) String.prototype.trim = function() {
        return this.replace(/^\s+|\s+$/, "");
    };
    // Installing Hand.js
    var supportedEventsNames = [
        "pointerdown",
        "pointerup",
        "pointermove",
        "pointerover",
        "pointerout",
        "pointercancel",
        "pointerenter",
        "pointerleave"
    ];
    var upperCaseEventsNames = [
        "PointerDown",
        "PointerUp",
        "PointerMove",
        "PointerOver",
        "PointerOut",
        "PointerCancel",
        "PointerEnter",
        "PointerLeave"
    ];
    var POINTER_TYPE_TOUCH = "touch";
    var POINTER_TYPE_PEN = "pen";
    var POINTER_TYPE_MOUSE = "mouse";
    var previousTargets = {};
    var checkPreventDefault = function(node) {
        while(node && !node.handjs_forcePreventDefault)node = node.parentNode;
        return !!node || window.handjs_forcePreventDefault;
    };
    // Touch events
    var generateTouchClonedEvent = function(sourceEvent, newName, canBubble, target, relatedTarget) {
        // Considering touch events are almost like super mouse events
        var evObj;
        if (document.createEvent) {
            evObj = document.createEvent("MouseEvents");
            evObj.initMouseEvent(newName, canBubble, true, window, 1, sourceEvent.screenX, sourceEvent.screenY, sourceEvent.clientX, sourceEvent.clientY, sourceEvent.ctrlKey, sourceEvent.altKey, sourceEvent.shiftKey, sourceEvent.metaKey, sourceEvent.button, relatedTarget || sourceEvent.relatedTarget);
        } else {
            evObj = document.createEventObject();
            evObj.screenX = sourceEvent.screenX;
            evObj.screenY = sourceEvent.screenY;
            evObj.clientX = sourceEvent.clientX;
            evObj.clientY = sourceEvent.clientY;
            evObj.ctrlKey = sourceEvent.ctrlKey;
            evObj.altKey = sourceEvent.altKey;
            evObj.shiftKey = sourceEvent.shiftKey;
            evObj.metaKey = sourceEvent.metaKey;
            evObj.button = sourceEvent.button;
            evObj.relatedTarget = relatedTarget || sourceEvent.relatedTarget;
        }
        // offsets
        if (evObj.offsetX === undefined) {
            if (sourceEvent.offsetX !== undefined) {
                // For Opera which creates readonly properties
                if (Object && Object.defineProperty !== undefined) {
                    Object.defineProperty(evObj, "offsetX", {
                        writable: true
                    });
                    Object.defineProperty(evObj, "offsetY", {
                        writable: true
                    });
                }
                evObj.offsetX = sourceEvent.offsetX;
                evObj.offsetY = sourceEvent.offsetY;
            } else if (Object && Object.defineProperty !== undefined) {
                Object.defineProperty(evObj, "offsetX", {
                    get: function() {
                        if (this.currentTarget && this.currentTarget.offsetLeft) return sourceEvent.clientX - this.currentTarget.offsetLeft;
                        return sourceEvent.clientX;
                    }
                });
                Object.defineProperty(evObj, "offsetY", {
                    get: function() {
                        if (this.currentTarget && this.currentTarget.offsetTop) return sourceEvent.clientY - this.currentTarget.offsetTop;
                        return sourceEvent.clientY;
                    }
                });
            } else if (sourceEvent.layerX !== undefined) {
                evObj.offsetX = sourceEvent.layerX - sourceEvent.currentTarget.offsetLeft;
                evObj.offsetY = sourceEvent.layerY - sourceEvent.currentTarget.offsetTop;
            }
        }
        // adding missing properties
        if (sourceEvent.isPrimary !== undefined) evObj.isPrimary = sourceEvent.isPrimary;
        else evObj.isPrimary = true;
        if (sourceEvent.pressure) evObj.pressure = sourceEvent.pressure;
        else {
            var button = 0;
            if (sourceEvent.which !== undefined) button = sourceEvent.which;
            else if (sourceEvent.button !== undefined) button = sourceEvent.button;
            evObj.pressure = button === 0 ? 0 : 0.5;
        }
        if (sourceEvent.rotation) evObj.rotation = sourceEvent.rotation;
        else evObj.rotation = 0;
        // Timestamp
        if (sourceEvent.hwTimestamp) evObj.hwTimestamp = sourceEvent.hwTimestamp;
        else evObj.hwTimestamp = 0;
        // Tilts
        if (sourceEvent.tiltX) evObj.tiltX = sourceEvent.tiltX;
        else evObj.tiltX = 0;
        if (sourceEvent.tiltY) evObj.tiltY = sourceEvent.tiltY;
        else evObj.tiltY = 0;
        // Width and Height
        if (sourceEvent.height) evObj.height = sourceEvent.height;
        else evObj.height = 0;
        if (sourceEvent.width) evObj.width = sourceEvent.width;
        else evObj.width = 0;
        // preventDefault
        evObj.preventDefault = function() {
            if (sourceEvent.preventDefault !== undefined) sourceEvent.preventDefault();
        };
        // stopPropagation
        if (evObj.stopPropagation !== undefined) {
            var current = evObj.stopPropagation;
            evObj.stopPropagation = function() {
                if (sourceEvent.stopPropagation !== undefined) sourceEvent.stopPropagation();
                current.call(this);
            };
        }
        // Pointer values
        evObj.pointerId = sourceEvent.pointerId;
        evObj.pointerType = sourceEvent.pointerType;
        switch(evObj.pointerType){
            case 2:
                evObj.pointerType = POINTER_TYPE_TOUCH;
                break;
            case 3:
                evObj.pointerType = POINTER_TYPE_PEN;
                break;
            case 4:
                evObj.pointerType = POINTER_TYPE_MOUSE;
                break;
        }
        // Fire event
        if (target) target.dispatchEvent(evObj);
        else if (sourceEvent.target) sourceEvent.target.dispatchEvent(evObj);
        else sourceEvent.srcElement.fireEvent("on" + getMouseEquivalentEventName(newName), evObj); // We must fallback to mouse event for very old browsers
    };
    var generateMouseProxy = function(evt, eventName, canBubble, target, relatedTarget) {
        evt.pointerId = 1;
        evt.pointerType = POINTER_TYPE_MOUSE;
        generateTouchClonedEvent(evt, eventName, canBubble, target, relatedTarget);
    };
    var generateTouchEventProxy = function(name, touchPoint, target, eventObject, canBubble, relatedTarget) {
        var touchPointId = touchPoint.identifier + 2; // Just to not override mouse id
        touchPoint.pointerId = touchPointId;
        touchPoint.pointerType = POINTER_TYPE_TOUCH;
        touchPoint.currentTarget = target;
        if (eventObject.preventDefault !== undefined) touchPoint.preventDefault = function() {
            eventObject.preventDefault();
        };
        generateTouchClonedEvent(touchPoint, name, canBubble, target, relatedTarget);
    };
    var checkEventRegistration = function(node, eventName) {
        return node.__handjsGlobalRegisteredEvents && node.__handjsGlobalRegisteredEvents[eventName];
    };
    var findEventRegisteredNode = function(node, eventName) {
        while(node && !checkEventRegistration(node, eventName))node = node.parentNode;
        if (node) return node;
        else if (checkEventRegistration(window, eventName)) return window;
    };
    var generateTouchEventProxyIfRegistered = function(eventName, touchPoint, target, eventObject, canBubble, relatedTarget) {
        if (findEventRegisteredNode(target, eventName)) generateTouchEventProxy(eventName, touchPoint, target, eventObject, canBubble, relatedTarget);
    };
    //var handleOtherEvent = function (eventObject, name, useLocalTarget, checkRegistration) {
    //    if (eventObject.preventManipulation)
    //        eventObject.preventManipulation();
    //    for (var i = 0; i < eventObject.changedTouches.length; ++i) {
    //        var touchPoint = eventObject.changedTouches[i];
    //        if (useLocalTarget) {
    //            previousTargets[touchPoint.identifier] = touchPoint.target;
    //        }
    //        if (checkRegistration) {
    //            generateTouchEventProxyIfRegistered(name, touchPoint, previousTargets[touchPoint.identifier], eventObject, true);
    //        } else {
    //            generateTouchEventProxy(name, touchPoint, previousTargets[touchPoint.identifier], eventObject, true);
    //        }
    //    }
    //};
    var getMouseEquivalentEventName = function(eventName) {
        return eventName.toLowerCase().replace("pointer", "mouse");
    };
    var getPrefixEventName = function(prefix, eventName) {
        var upperCaseIndex = supportedEventsNames.indexOf(eventName);
        var newEventName = prefix + upperCaseEventsNames[upperCaseIndex];
        return newEventName;
    };
    var registerOrUnregisterEvent = function(item, name, func, enable) {
        if (item.__handjsRegisteredEvents === undefined) item.__handjsRegisteredEvents = [];
        if (enable) {
            if (item.__handjsRegisteredEvents[name] !== undefined) {
                item.__handjsRegisteredEvents[name]++;
                return;
            }
            item.__handjsRegisteredEvents[name] = 1;
            item.addEventListener(name, func, false);
        } else {
            if (item.__handjsRegisteredEvents.indexOf(name) !== -1) {
                item.__handjsRegisteredEvents[name]--;
                if (item.__handjsRegisteredEvents[name] !== 0) return;
            }
            item.removeEventListener(name, func);
            item.__handjsRegisteredEvents[name] = 0;
        }
    };
    var setTouchAware = function(item, eventName, enable) {
        // Leaving tokens
        if (!item.__handjsGlobalRegisteredEvents) item.__handjsGlobalRegisteredEvents = [];
        if (enable) {
            if (item.__handjsGlobalRegisteredEvents[eventName] !== undefined) {
                item.__handjsGlobalRegisteredEvents[eventName]++;
                return;
            }
            item.__handjsGlobalRegisteredEvents[eventName] = 1;
        } else if (item.__handjsGlobalRegisteredEvents[eventName] !== undefined) {
            item.__handjsGlobalRegisteredEvents[eventName]--;
            if (item.__handjsGlobalRegisteredEvents[eventName] < 0) item.__handjsGlobalRegisteredEvents[eventName] = 0;
        }
        var nameGenerator;
        var eventGenerator;
        if (window.MSPointerEvent) {
            nameGenerator = function(name) {
                return getPrefixEventName("MS", name);
            };
            eventGenerator = generateTouchClonedEvent;
        } else {
            nameGenerator = getMouseEquivalentEventName;
            eventGenerator = generateMouseProxy;
        }
        switch(eventName){
            case "pointerenter":
            case "pointerleave":
                var targetEvent = nameGenerator(eventName);
                if (item["on" + targetEvent.toLowerCase()] !== undefined) registerOrUnregisterEvent(item, targetEvent, function(evt) {
                    eventGenerator(evt, eventName);
                }, enable);
                break;
        }
    };
    // Intercept addEventListener calls by changing the prototype
    var interceptAddEventListener = function(root) {
        var current = root.prototype ? root.prototype.addEventListener : root.addEventListener;
        var customAddEventListener = function(name, func, capture) {
            // Branch when a PointerXXX is used
            if (supportedEventsNames.indexOf(name) !== -1) setTouchAware(this, name, true);
            if (current === undefined) this.attachEvent("on" + getMouseEquivalentEventName(name), func);
            else current.call(this, name, func, capture);
        };
        if (root.prototype) root.prototype.addEventListener = customAddEventListener;
        else root.addEventListener = customAddEventListener;
    };
    // Intercept removeEventListener calls by changing the prototype
    var interceptRemoveEventListener = function(root) {
        var current = root.prototype ? root.prototype.removeEventListener : root.removeEventListener;
        var customRemoveEventListener = function(name, func, capture) {
            // Release when a PointerXXX is used
            if (supportedEventsNames.indexOf(name) !== -1) setTouchAware(this, name, false);
            if (current === undefined) this.detachEvent(getMouseEquivalentEventName(name), func);
            else current.call(this, name, func, capture);
        };
        if (root.prototype) root.prototype.removeEventListener = customRemoveEventListener;
        else root.removeEventListener = customRemoveEventListener;
    };
    // Hooks
    interceptAddEventListener(window);
    interceptAddEventListener(window.HTMLElement || window.Element);
    interceptAddEventListener(document);
    if (!navigator.isCocoonJS) {
        interceptAddEventListener(HTMLBodyElement);
        interceptAddEventListener(HTMLDivElement);
        interceptAddEventListener(HTMLImageElement);
        interceptAddEventListener(HTMLUListElement);
        interceptAddEventListener(HTMLAnchorElement);
        interceptAddEventListener(HTMLLIElement);
        interceptAddEventListener(HTMLTableElement);
        if (window.HTMLSpanElement) interceptAddEventListener(HTMLSpanElement);
    }
    if (window.HTMLCanvasElement) interceptAddEventListener(HTMLCanvasElement);
    if (!navigator.isCocoonJS && window.SVGElement) interceptAddEventListener(SVGElement);
    interceptRemoveEventListener(window);
    interceptRemoveEventListener(window.HTMLElement || window.Element);
    interceptRemoveEventListener(document);
    if (!navigator.isCocoonJS) {
        interceptRemoveEventListener(HTMLBodyElement);
        interceptRemoveEventListener(HTMLDivElement);
        interceptRemoveEventListener(HTMLImageElement);
        interceptRemoveEventListener(HTMLUListElement);
        interceptRemoveEventListener(HTMLAnchorElement);
        interceptRemoveEventListener(HTMLLIElement);
        interceptRemoveEventListener(HTMLTableElement);
        if (window.HTMLSpanElement) interceptRemoveEventListener(HTMLSpanElement);
    }
    if (window.HTMLCanvasElement) interceptRemoveEventListener(HTMLCanvasElement);
    if (!navigator.isCocoonJS && window.SVGElement) interceptRemoveEventListener(SVGElement);
    // Prevent mouse event from being dispatched after Touch Events action
    var touching = false;
    var touchTimer = -1;
    function setTouchTimer() {
        touching = true;
        clearTimeout(touchTimer);
        touchTimer = setTimeout(function() {
            touching = false;
        }, 700);
    // 1. Mobile browsers dispatch mouse events 300ms after touchend
    // 2. Chrome for Android dispatch mousedown for long-touch about 650ms
    // Result: Blocking Mouse Events for 700ms.
    }
    function getFirstCommonNode(x, y) {
        while(x){
            if (x.contains(y)) return x;
            x = x.parentNode;
        }
        return null;
    }
    //generateProxy receives a node to dispatch the event
    function dispatchPointerEnter(currentTarget, relatedTarget, generateProxy) {
        var commonParent = getFirstCommonNode(currentTarget, relatedTarget);
        var node = currentTarget;
        var nodelist = [];
        while(node && node !== commonParent){
            if (checkEventRegistration(node, "pointerenter")) nodelist.push(node);
            node = node.parentNode;
        }
        while(nodelist.length > 0)generateProxy(nodelist.pop());
    }
    //generateProxy receives a node to dispatch the event
    function dispatchPointerLeave(currentTarget, relatedTarget, generateProxy) {
        var commonParent = getFirstCommonNode(currentTarget, relatedTarget);
        var node = currentTarget;
        while(node && node !== commonParent){
            if (checkEventRegistration(node, "pointerleave")) generateProxy(node);
            node = node.parentNode;
        }
    }
    // Handling events on window to prevent unwanted super-bubbling
    // All mouse events are affected by touch fallback
    function applySimpleEventTunnels(nameGenerator, eventGenerator) {
        [
            "pointerdown",
            "pointermove",
            "pointerup",
            "pointerover",
            "pointerout"
        ].forEach(function(eventName) {
            window.addEventListener(nameGenerator(eventName), function(evt) {
                if (!touching && findEventRegisteredNode(evt.target, eventName)) eventGenerator(evt, eventName, true);
            });
        });
        if (window["on" + nameGenerator("pointerenter").toLowerCase()] === undefined) window.addEventListener(nameGenerator("pointerover"), function(evt) {
            if (touching) return;
            var foundNode = findEventRegisteredNode(evt.target, "pointerenter");
            if (!foundNode || foundNode === window) return;
            else if (!foundNode.contains(evt.relatedTarget)) dispatchPointerEnter(foundNode, evt.relatedTarget, function(targetNode) {
                eventGenerator(evt, "pointerenter", false, targetNode, evt.relatedTarget);
            });
        });
        if (window["on" + nameGenerator("pointerleave").toLowerCase()] === undefined) window.addEventListener(nameGenerator("pointerout"), function(evt) {
            if (touching) return;
            var foundNode = findEventRegisteredNode(evt.target, "pointerleave");
            if (!foundNode || foundNode === window) return;
            else if (!foundNode.contains(evt.relatedTarget)) dispatchPointerLeave(foundNode, evt.relatedTarget, function(targetNode) {
                eventGenerator(evt, "pointerleave", false, targetNode, evt.relatedTarget);
            });
        });
    }
    (function() {
        if (window.MSPointerEvent) //IE 10
        applySimpleEventTunnels(function(name) {
            return getPrefixEventName("MS", name);
        }, generateTouchClonedEvent);
        else {
            applySimpleEventTunnels(getMouseEquivalentEventName, generateMouseProxy);
            // Handling move on window to detect pointerleave/out/over
            if (window.ontouchstart !== undefined) {
                window.addEventListener("touchstart", function(eventObject) {
                    for(var i = 0; i < eventObject.changedTouches.length; ++i){
                        var touchPoint = eventObject.changedTouches[i];
                        previousTargets[touchPoint.identifier] = touchPoint.target;
                        generateTouchEventProxyIfRegistered("pointerover", touchPoint, touchPoint.target, eventObject, true);
                        //pointerenter should not be bubbled
                        dispatchPointerEnter(touchPoint.target, null, function(targetNode) {
                            generateTouchEventProxy("pointerenter", touchPoint, targetNode, eventObject, false);
                        });
                        generateTouchEventProxyIfRegistered("pointerdown", touchPoint, touchPoint.target, eventObject, true);
                    }
                    setTouchTimer();
                });
                window.addEventListener("touchend", function(eventObject) {
                    for(var i = 0; i < eventObject.changedTouches.length; ++i){
                        var touchPoint = eventObject.changedTouches[i];
                        var currentTarget = previousTargets[touchPoint.identifier];
                        generateTouchEventProxyIfRegistered("pointerup", touchPoint, currentTarget, eventObject, true);
                        generateTouchEventProxyIfRegistered("pointerout", touchPoint, currentTarget, eventObject, true);
                        //pointerleave should not be bubbled
                        dispatchPointerLeave(currentTarget, null, function(targetNode) {
                            generateTouchEventProxy("pointerleave", touchPoint, targetNode, eventObject, false);
                        });
                    }
                    setTouchTimer();
                });
                window.addEventListener("touchmove", function(eventObject) {
                    for(var i = 0; i < eventObject.changedTouches.length; ++i){
                        var touchPoint = eventObject.changedTouches[i];
                        var newTarget = document.elementFromPoint(touchPoint.clientX, touchPoint.clientY);
                        var currentTarget = previousTargets[touchPoint.identifier];
                        // If force preventDefault
                        if (currentTarget && checkPreventDefault(currentTarget) === true) eventObject.preventDefault();
                        generateTouchEventProxyIfRegistered("pointermove", touchPoint, currentTarget, eventObject, true);
                        if (!navigator.isCocoonJS) {
                            var newTarget = document.elementFromPoint(touchPoint.clientX, touchPoint.clientY);
                            if (currentTarget === newTarget) continue; // We can skip this as the pointer is effectively over the current target
                            if (currentTarget) {
                                // Raise out
                                generateTouchEventProxyIfRegistered("pointerout", touchPoint, currentTarget, eventObject, true, newTarget);
                                // Raise leave
                                if (!currentTarget.contains(newTarget)) dispatchPointerLeave(currentTarget, newTarget, function(targetNode) {
                                    generateTouchEventProxy("pointerleave", touchPoint, targetNode, eventObject, false, newTarget);
                                });
                            }
                            if (newTarget) {
                                // Raise over
                                generateTouchEventProxyIfRegistered("pointerover", touchPoint, newTarget, eventObject, true, currentTarget);
                                // Raise enter
                                if (!newTarget.contains(currentTarget)) dispatchPointerEnter(newTarget, currentTarget, function(targetNode) {
                                    generateTouchEventProxy("pointerenter", touchPoint, targetNode, eventObject, false, currentTarget);
                                });
                            }
                            previousTargets[touchPoint.identifier] = newTarget;
                        }
                    }
                    setTouchTimer();
                });
                window.addEventListener("touchcancel", function(eventObject) {
                    for(var i = 0; i < eventObject.changedTouches.length; ++i){
                        var touchPoint = eventObject.changedTouches[i];
                        generateTouchEventProxyIfRegistered("pointercancel", touchPoint, previousTargets[touchPoint.identifier], eventObject, true);
                    }
                });
            }
        }
    })();
    // Extension to navigator
    if (navigator.pointerEnabled === undefined) {
        // Indicates if the browser will fire pointer events for pointing input
        navigator.pointerEnabled = true;
        // IE
        if (navigator.msPointerEnabled) navigator.maxTouchPoints = navigator.msMaxTouchPoints;
    }
})();
(function() {
    if (window.PointerEvent) return;
    // Handling touch-action css rule
    if (document.styleSheets && document.addEventListener) document.addEventListener("DOMContentLoaded", function() {
        if (document.body.style.touchAction !== undefined) return;
        var globalRegex = new RegExp(".+?{.*?}", "m");
        var selectorRegex = new RegExp(".+?{", "m");
        var filterStylesheet = function(unfilteredSheet) {
            var filter = globalRegex.exec(unfilteredSheet);
            if (!filter) return;
            var block = filter[0];
            unfilteredSheet = unfilteredSheet.replace(block, "").trim();
            var selectorText = selectorRegex.exec(block)[0].replace("{", "").trim();
            // Checking if the user wanted to deactivate the default behavior
            if (block.replace(/\s/g, "").indexOf("touch-action:none") !== -1) {
                var elements = document.querySelectorAll(selectorText);
                for(var elementIndex = 0; elementIndex < elements.length; elementIndex++){
                    var element = elements[elementIndex];
                    if (element.style.msTouchAction !== undefined) element.style.msTouchAction = "none";
                    else element.handjs_forcePreventDefault = true;
                }
            }
            return unfilteredSheet;
        };
        var processStylesheet = function(unfilteredSheet) {
            if (window.setImmediate) {
                if (unfilteredSheet) setImmediate(processStylesheet, filterStylesheet(unfilteredSheet));
            } else while(unfilteredSheet)unfilteredSheet = filterStylesheet(unfilteredSheet);
        }; // Looking for touch-action in referenced stylesheets
        try {
            for(var index = 0; index < document.styleSheets.length; index++){
                var sheet = document.styleSheets[index];
                if (sheet.href == null) continue;
                // Loading the original stylesheet
                var xhr = new XMLHttpRequest();
                xhr.open("get", sheet.href);
                xhr.send();
                var unfilteredSheet = xhr.responseText.replace(/(\n|\r)/g, "");
                processStylesheet(unfilteredSheet);
            }
        } catch (e) {
        // Silently fail...
        }
        // Looking for touch-action in inline styles
        var styles = document.getElementsByTagName("style");
        for(var index = 0; index < styles.length; index++){
            var inlineSheet = styles[index];
            var inlineUnfilteredSheet = inlineSheet.innerHTML.replace(/(\n|\r)/g, "").trim();
            processStylesheet(inlineUnfilteredSheet);
        }
    }, false);
})();


if (!document.monetization) {
    document.monetization = document.createElement("div");
    document.monetization.state = "stopped";
    document.addEventListener("monetization-v1", function(event) {
        const { type: type, detail: detail } = event.detail;
        if (type === "monetizationstatechange") document.monetization.state = detail.state;
        else document.monetization.dispatchEvent(new CustomEvent(type, {
            detail: detail
        }));
    });
}


var $ab3fbf1086cff2b4$exports = {};
/* canvas-toBlob.js
 * A canvas.toBlob() implementation.
 * 2013-12-27
 * 
 * By Eli Grey, http://eligrey.com and Devin Samarin, https://github.com/eboyjr
 * License: X11/MIT
 *   See https://github.com/eligrey/canvas-toBlob.js/blob/master/LICENSE.md
 */ /*global self */ /*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
  plusplus: true */ /*! @source http://purl.eligrey.com/github/canvas-toBlob.js/blob/master/canvas-toBlob.js */ (function(view) {
    "use strict";
    var Uint8Array = view.Uint8Array, HTMLCanvasElement = view.HTMLCanvasElement, canvas_proto = HTMLCanvasElement && HTMLCanvasElement.prototype, is_base64_regex = /\s*;\s*base64\s*(?:;|$)/i, to_data_url = "toDataURL", base64_ranks, decode_base64 = function(base64) {
        var len = base64.length, buffer = new Uint8Array(len / 4 * 3 | 0), i = 0, outptr = 0, last = [
            0,
            0
        ], state = 0, save = 0, rank, code, undef;
        while(len--){
            code = base64.charCodeAt(i++);
            rank = base64_ranks[code - 43];
            if (rank !== 255 && rank !== undef) {
                last[1] = last[0];
                last[0] = code;
                save = save << 6 | rank;
                state++;
                if (state === 4) {
                    buffer[outptr++] = save >>> 16;
                    if (last[1] !== 61 /* padding character */ ) buffer[outptr++] = save >>> 8;
                    if (last[0] !== 61 /* padding character */ ) buffer[outptr++] = save;
                    state = 0;
                }
            }
        }
        // 2/3 chance there's going to be some null bytes at the end, but that
        // doesn't really matter with most image formats.
        // If it somehow matters for you, truncate the buffer up outptr.
        return buffer;
    };
    if (Uint8Array) base64_ranks = new Uint8Array([
        62,
        -1,
        -1,
        -1,
        63,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        -1,
        -1,
        -1,
        0,
        -1,
        -1,
        -1,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51
    ]);
    if (HTMLCanvasElement && !canvas_proto.toBlob) {
        canvas_proto.toBlob = function(callback, type /*, ...args*/ ) {
            if (!type) type = "image/png";
            if (this.mozGetAsFile) {
                callback(this.mozGetAsFile("canvas", type));
                return;
            }
            if (this.msToBlob && /^\s*image\/png\s*(?:$|;)/i.test(type)) {
                callback(this.msToBlob());
                return;
            }
            var args = Array.prototype.slice.call(arguments, 1), dataURI = this[to_data_url].apply(this, args), header_end = dataURI.indexOf(","), data = dataURI.substring(header_end + 1), is_base64 = is_base64_regex.test(dataURI.substring(0, header_end)), blob;
            if (Blob.fake) {
                // no reason to decode a data: URI that's just going to become a data URI again
                blob = new Blob;
                if (is_base64) blob.encoding = "base64";
                else blob.encoding = "URI";
                blob.data = data;
                blob.size = data.length;
            } else if (Uint8Array) {
                if (is_base64) blob = new Blob([
                    decode_base64(data)
                ], {
                    type: type
                });
                else blob = new Blob([
                    decodeURIComponent(data)
                ], {
                    type: type
                });
            }
            callback(blob);
        };
        if (canvas_proto.toDataURLHD) canvas_proto.toBlobHD = function() {
            to_data_url = "toDataURLHD";
            var blob = this.toBlob();
            to_data_url = "toDataURL";
            return blob;
        };
        else canvas_proto.toBlobHD = canvas_proto.toBlob;
    }
})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || $ab3fbf1086cff2b4$exports.content || $ab3fbf1086cff2b4$exports);


var $8c500350d1616f35$exports = {};
/* Blob.js
 * A Blob implementation.
 * 2014-07-24
 *
 * By Eli Grey, http://eligrey.com
 * By Devin Samarin, https://github.com/dsamarin
 * License: X11/MIT
 *   See https://github.com/eligrey/Blob.js/blob/master/LICENSE.md
 */ /*global self, unescape */ /*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
  plusplus: true */ /*! @source http://purl.eligrey.com/github/Blob.js/blob/master/Blob.js */ (function(view) {
    "use strict";
    view.URL = view.URL || view.webkitURL;
    if (view.Blob && view.URL) try {
        new Blob;
        return;
    } catch (e) {}
    // Internally we use a BlobBuilder implementation to base Blob off of
    // in order to support older browsers that only have BlobBuilder
    var BlobBuilder = view.BlobBuilder || view.WebKitBlobBuilder || view.MozBlobBuilder || function(view) {
        var get_class = function(object) {
            return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
        }, FakeBlobBuilder = function BlobBuilder() {
            this.data = [];
        }, FakeBlob = function Blob1(data, type, encoding) {
            this.data = data;
            this.size = data.length;
            this.type = type;
            this.encoding = encoding;
        }, FBB_proto = FakeBlobBuilder.prototype, FB_proto = FakeBlob.prototype, FileReaderSync = view.FileReaderSync, FileException = function(type) {
            this.code = this[this.name = type];
        }, file_ex_codes = "NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "), file_ex_code = file_ex_codes.length, real_URL = view.URL || view.webkitURL || view, real_create_object_URL = real_URL.createObjectURL, real_revoke_object_URL = real_URL.revokeObjectURL, URL = real_URL, btoa = view.btoa, atob = view.atob, ArrayBuffer = view.ArrayBuffer, Uint8Array1 = view.Uint8Array, origin = /^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;
        FakeBlob.fake = FB_proto.fake = true;
        while(file_ex_code--)FileException.prototype[file_ex_codes[file_ex_code]] = file_ex_code + 1;
        // Polyfill URL
        if (!real_URL.createObjectURL) URL = view.URL = function(uri) {
            var uri_info = document.createElementNS("http://www.w3.org/1999/xhtml", "a"), uri_origin;
            uri_info.href = uri;
            if (!("origin" in uri_info)) {
                if (uri_info.protocol.toLowerCase() === "data:") uri_info.origin = null;
                else {
                    uri_origin = uri.match(origin);
                    uri_info.origin = uri_origin && uri_origin[1];
                }
            }
            return uri_info;
        };
        URL.createObjectURL = function(blob) {
            var type = blob.type, data_URI_header;
            if (type === null) type = "application/octet-stream";
            if (blob instanceof FakeBlob) {
                data_URI_header = "data:" + type;
                if (blob.encoding === "base64") return data_URI_header + ";base64," + blob.data;
                else if (blob.encoding === "URI") return data_URI_header + "," + decodeURIComponent(blob.data);
                if (btoa) return data_URI_header + ";base64," + btoa(blob.data);
                else return data_URI_header + "," + encodeURIComponent(blob.data);
            } else if (real_create_object_URL) return real_create_object_URL.call(real_URL, blob);
        };
        URL.revokeObjectURL = function(object_URL) {
            if (object_URL.substring(0, 5) !== "data:" && real_revoke_object_URL) real_revoke_object_URL.call(real_URL, object_URL);
        };
        FBB_proto.append = function(data /*, endings*/ ) {
            var bb = this.data;
            // decode data to a binary string
            if (Uint8Array1 && (data instanceof ArrayBuffer || data instanceof Uint8Array1)) {
                var str = "", buf = new Uint8Array1(data), i = 0, buf_len = buf.length;
                for(; i < buf_len; i++)str += String.fromCharCode(buf[i]);
                bb.push(str);
            } else if (get_class(data) === "Blob" || get_class(data) === "File") {
                if (FileReaderSync) {
                    var fr = new FileReaderSync;
                    bb.push(fr.readAsBinaryString(data));
                } else // async FileReader won't work as BlobBuilder is sync
                throw new FileException("NOT_READABLE_ERR");
            } else if (data instanceof FakeBlob) {
                if (data.encoding === "base64" && atob) bb.push(atob(data.data));
                else if (data.encoding === "URI") bb.push(decodeURIComponent(data.data));
                else if (data.encoding === "raw") bb.push(data.data);
            } else {
                if (typeof data !== "string") data += ""; // convert unsupported types to strings
                // decode UTF-16 to binary string
                bb.push(unescape(encodeURIComponent(data)));
            }
        };
        FBB_proto.getBlob = function(type) {
            if (!arguments.length) type = null;
            return new FakeBlob(this.data.join(""), type, "raw");
        };
        FBB_proto.toString = function() {
            return "[object BlobBuilder]";
        };
        FB_proto.slice = function(start, end, type) {
            var args = arguments.length;
            if (args < 3) type = null;
            return new FakeBlob(this.data.slice(start, args > 1 ? end : this.data.length), type, this.encoding);
        };
        FB_proto.toString = function() {
            return "[object Blob]";
        };
        FB_proto.close = function() {
            this.size = 0;
            delete this.data;
        };
        return FakeBlobBuilder;
    }(view);
    view.Blob = function(blobParts, options) {
        var type = options ? options.type || "" : "";
        var builder = new BlobBuilder();
        if (blobParts) {
            for(var i = 0, len = blobParts.length; i < len; i++)if (Uint8Array && blobParts[i] instanceof Uint8Array) builder.append(blobParts[i].buffer);
            else builder.append(blobParts[i]);
        }
        var blob = builder.getBlob(type);
        if (!blob.slice && blob.webkitSlice) blob.slice = blob.webkitSlice;
        return blob;
    };
    var getPrototypeOf = Object.getPrototypeOf || function(object) {
        return object.__proto__;
    };
    view.Blob.prototype = getPrototypeOf(new view.Blob());
})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || $8c500350d1616f35$exports.content || $8c500350d1616f35$exports);


/**
 * CustomEvent polyfill for IE & Edge
 * source: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
 */ (function() {
    if (typeof window.CustomEvent === "function") return false;
    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
})();


/**
 * Element.closest() polyfill for Internet Explorer IE 9+
 * Matches jQuery.closest()
 *
 * source: https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
 * usage: https://caniuse.com/#feat=element-closest
 */ if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
if (!Element.prototype.closest) Element.prototype.closest = function(s) {
    var el = this;
    if (!document.documentElement.contains(el)) return null;
    do {
        if (el.matches(s)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null);
    return null;
};


/**
 * Element.remove() polyfill for Internet Explorer 9+
 * Matches jQuery.remove()
 *
 * source: https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove
 * usage: https://caniuse.com/#feat=childnode-remove
 */ // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function(arr) {
    arr.forEach(function(item) {
        if (item.hasOwnProperty("remove")) return;
        Object.defineProperty(item, "remove", {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
                this.parentNode.removeChild(this);
            }
        });
    });
})([
    Element.prototype,
    CharacterData.prototype,
    DocumentType.prototype
]);


/**
 * Initiates Redux store.
 *
 * Redux Toolkit is a framework on top of Redux that provides common middleware
 * and helps enforce best practices by default. We're outsourcing opinions
 * to the Redux ecosystem, which saves us time and reduces our need to write
 * excess boilerplate Redux code by hand.
 *
 * The @reduxjs/toolkit package automatically installs `redux` and
 * `redux-thunk`. In development environments, it will also automatically
 * enable the Redux DevTools extension, and install middleware to check for
 * immutability violations and non-serializable data.
 *
 * To help with not mutating data by accident, reducers created by either
 * `createSlice` or `createReducer` will be wrapped with `produce` from the
 * `immer` library, which allows us to write code that appears to mutate
 * state, and will instead return the correct immutable result. This is magic!
 * It's important to remember that magic is happening!
 *
 * For more info: https://redux-toolkit.js.org/
 *
 */ 
var $i9Ee7 = parcelRequire("i9Ee7");
function $a5b0299dba3afa01$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a5b0299dba3afa01$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a5b0299dba3afa01$export$2e2bcd8739ae039(o);
}



function $8f0c6baea4acb442$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $a5b0299dba3afa01$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $a5b0299dba3afa01$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $d9871e6a3209a06e$export$2e2bcd8739ae039(t) {
    var i = (0, $8f0c6baea4acb442$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $a5b0299dba3afa01$export$2e2bcd8739ae039)(i) ? i : String(i);
}


function $9de128d34a0b9d2d$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $d9871e6a3209a06e$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $648553c03264a504$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $648553c03264a504$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $648553c03264a504$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9de128d34a0b9d2d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $648553c03264a504$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $d0affe2ff19fe4b6$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $d0affe2ff19fe4b6$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $d0affe2ff19fe4b6$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $d0affe2ff19fe4b6$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $d0affe2ff19fe4b6$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $d0affe2ff19fe4b6$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $d0affe2ff19fe4b6$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $d0affe2ff19fe4b6$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $d0affe2ff19fe4b6$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d0affe2ff19fe4b6$var$isDate(val)) return "date";
    if ($d0affe2ff19fe4b6$var$isError(val)) return "error";
    var constructorName = $d0affe2ff19fe4b6$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d0affe2ff19fe4b6$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d0affe2ff19fe4b6$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d0affe2ff19fe4b6$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d0affe2ff19fe4b6$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $d0affe2ff19fe4b6$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(1));
        return enhancer($d0affe2ff19fe4b6$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$d0affe2ff19fe4b6$var$isPlainObject(action)) throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $d0affe2ff19fe4b6$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$d0affe2ff19fe4b6$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $d0affe2ff19fe4b6$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$d0affe2ff19fe4b6$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $d0affe2ff19fe4b6$export$8928921ea2d3b126 = $d0affe2ff19fe4b6$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $d0affe2ff19fe4b6$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $d0affe2ff19fe4b6$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $d0affe2ff19fe4b6$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d0affe2ff19fe4b6$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $d0affe2ff19fe4b6$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d0affe2ff19fe4b6$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $d0affe2ff19fe4b6$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $d0affe2ff19fe4b6$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $d0affe2ff19fe4b6$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $d0affe2ff19fe4b6$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $d0affe2ff19fe4b6$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $d0affe2ff19fe4b6$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $d0affe2ff19fe4b6$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d0affe2ff19fe4b6$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d0affe2ff19fe4b6$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $d0affe2ff19fe4b6$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $d0affe2ff19fe4b6$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($d0affe2ff19fe4b6$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $d0affe2ff19fe4b6$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $648553c03264a504$export$2e2bcd8739ae039)((0, $648553c03264a504$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $44e5fc722a9bc7be$var$NOT_FOUND = "NOT_FOUND";
function $44e5fc722a9bc7be$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $44e5fc722a9bc7be$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $44e5fc722a9bc7be$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $44e5fc722a9bc7be$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $44e5fc722a9bc7be$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $44e5fc722a9bc7be$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $44e5fc722a9bc7be$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $44e5fc722a9bc7be$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $44e5fc722a9bc7be$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $44e5fc722a9bc7be$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $44e5fc722a9bc7be$var$createSingletonCache(comparator) : $44e5fc722a9bc7be$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $44e5fc722a9bc7be$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $bb5ac58d2597f8dc$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $bb5ac58d2597f8dc$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $bb5ac58d2597f8dc$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $bb5ac58d2597f8dc$export$595d22ed68ca2841 = /* #__PURE__ */ $bb5ac58d2597f8dc$export$5943f4447f6ef248((0, $44e5fc722a9bc7be$export$281bff7f05488aa2));
var $bb5ac58d2597f8dc$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $bb5ac58d2597f8dc$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $73f1dbfc2ba5d59c$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $73f1dbfc2ba5d59c$var$thunk = $73f1dbfc2ba5d59c$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$73f1dbfc2ba5d59c$var$thunk.withExtraArgument = $73f1dbfc2ba5d59c$var$createThunkMiddleware;
var $73f1dbfc2ba5d59c$export$2e2bcd8739ae039 = $73f1dbfc2ba5d59c$var$thunk;



var $eh5Zb = parcelRequire("eh5Zb");
var $a3ccb5670e466352$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a3ccb5670e466352$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $a3ccb5670e466352$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $a3ccb5670e466352$var$__defProp = Object.defineProperty;
var $a3ccb5670e466352$var$__defProps = Object.defineProperties;
var $a3ccb5670e466352$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $a3ccb5670e466352$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a3ccb5670e466352$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a3ccb5670e466352$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a3ccb5670e466352$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $a3ccb5670e466352$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $a3ccb5670e466352$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($a3ccb5670e466352$var$__hasOwnProp.call(b, prop)) $a3ccb5670e466352$var$__defNormalProp(a, prop, b[prop]);
    if ($a3ccb5670e466352$var$__getOwnPropSymbols) for(var _i = 0, _c = $a3ccb5670e466352$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($a3ccb5670e466352$var$__propIsEnum.call(b, prop)) $a3ccb5670e466352$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a3ccb5670e466352$var$__spreadProps = function(a, b) {
    return $a3ccb5670e466352$var$__defProps(a, $a3ccb5670e466352$var$__getOwnPropDescs(b));
};
var $a3ccb5670e466352$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $a3ccb5670e466352$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $bb5ac58d2597f8dc$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $a3ccb5670e466352$var$__spreadArray([
            (0, $i9Ee7.isDraft)(value) ? (0, $i9Ee7.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $a3ccb5670e466352$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $d0affe2ff19fe4b6$export$f672e0b6f7222cd7;
    return (0, $d0affe2ff19fe4b6$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $a3ccb5670e466352$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $a3ccb5670e466352$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
function $a3ccb5670e466352$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $a3ccb5670e466352$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $a3ccb5670e466352$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $a3ccb5670e466352$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $a3ccb5670e466352$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $a3ccb5670e466352$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $a3ccb5670e466352$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $a3ccb5670e466352$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $a3ccb5670e466352$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $a3ccb5670e466352$var$freezeDraftable(val) {
    return (0, $i9Ee7.isDraftable)(val) ? (0, $i9Ee7.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $a3ccb5670e466352$var$isProduction = true;
var $a3ccb5670e466352$var$prefix = "Invariant failed";
function $a3ccb5670e466352$var$invariant(condition, message) {
    if (condition) return;
    if ($a3ccb5670e466352$var$isProduction) throw new Error($a3ccb5670e466352$var$prefix);
    throw new Error($a3ccb5670e466352$var$prefix + ": " + (message || ""));
}
function $a3ccb5670e466352$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $a3ccb5670e466352$var$getSerialize(serializer, decycler), indent);
}
function $a3ccb5670e466352$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $a3ccb5670e466352$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $a3ccb5670e466352$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $a3ccb5670e466352$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $a3ccb5670e466352$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $a3ccb5670e466352$var$trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $a3ccb5670e466352$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $a3ccb5670e466352$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $a3ccb5670e466352$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $a3ccb5670e466352$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $a3ccb5670e466352$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $a3ccb5670e466352$export$53b83ca8eaab0383(val);
}
function $a3ccb5670e466352$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $a3ccb5670e466352$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $a3ccb5670e466352$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $a3ccb5670e466352$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $a3ccb5670e466352$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$a3ccb5670e466352$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $a3ccb5670e466352$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $a3ccb5670e466352$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $a3ccb5670e466352$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $a3ccb5670e466352$export$36c1185aeee5b0a6(options);
    };
}
function $a3ccb5670e466352$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new $a3ccb5670e466352$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($a3ccb5670e466352$var$isBoolean(thunk)) middlewareArray.push((0, $73f1dbfc2ba5d59c$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $73f1dbfc2ba5d59c$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $a3ccb5670e466352$var$IS_PRODUCTION = true;
function $a3ccb5670e466352$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $a3ccb5670e466352$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($a3ccb5670e466352$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $d0affe2ff19fe4b6$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$a3ccb5670e466352$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$a3ccb5670e466352$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $d0affe2ff19fe4b6$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $d0affe2ff19fe4b6$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $a3ccb5670e466352$var$composeWithDevTools($a3ccb5670e466352$var$__spreadValues({
        trace: !$a3ccb5670e466352$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $a3ccb5670e466352$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $a3ccb5670e466352$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $d0affe2ff19fe4b6$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function $a3ccb5670e466352$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $a3ccb5670e466352$var$__spreadValues($a3ccb5670e466352$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $a3ccb5670e466352$export$b956e38827fca970(action) {
    return $a3ccb5670e466352$export$53b83ca8eaab0383(action) && "type" in action;
}
function $a3ccb5670e466352$export$ebd532f9034651f3(action) {
    return $a3ccb5670e466352$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($a3ccb5670e466352$var$isValidKey);
}
function $a3ccb5670e466352$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $a3ccb5670e466352$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/mapBuilders.ts
function $a3ccb5670e466352$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) throw new Error("addCase cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $a3ccb5670e466352$var$isStateFunction(x) {
    return typeof x === "function";
}
var $a3ccb5670e466352$var$hasWarnedAboutObjectNotation = false;
function $a3ccb5670e466352$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $a3ccb5670e466352$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($a3ccb5670e466352$var$isStateFunction(initialState)) getInitialState = function() {
        return $a3ccb5670e466352$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $a3ccb5670e466352$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $a3ccb5670e466352$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $i9Ee7.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $i9Ee7.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $i9Ee7.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $a3ccb5670e466352$var$hasWarnedAboutObjectNotation2 = false;
function $a3ccb5670e466352$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $a3ccb5670e466352$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $eh5Zb;
    var initialState = typeof options.initialState == "function" ? options.initialState : $a3ccb5670e466352$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $a3ccb5670e466352$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $a3ccb5670e466352$export$309c7a02b0b0bc62(type, prepareCallback) : $a3ccb5670e466352$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $a3ccb5670e466352$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $a3ccb5670e466352$var$__spreadValues($a3ccb5670e466352$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $a3ccb5670e466352$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $a3ccb5670e466352$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $a3ccb5670e466352$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($a3ccb5670e466352$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $a3ccb5670e466352$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $a3ccb5670e466352$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $a3ccb5670e466352$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $a3ccb5670e466352$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $a3ccb5670e466352$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $a3ccb5670e466352$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $a3ccb5670e466352$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $a3ccb5670e466352$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $a3ccb5670e466352$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $a3ccb5670e466352$var$createSingleArgumentStateOperator(mutator) {
    var operator = $a3ccb5670e466352$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $a3ccb5670e466352$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $a3ccb5670e466352$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $i9Ee7.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $i9Ee7.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $a3ccb5670e466352$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $a3ccb5670e466352$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $a3ccb5670e466352$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $a3ccb5670e466352$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $a3ccb5670e466352$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $a3ccb5670e466352$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $a3ccb5670e466352$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $a3ccb5670e466352$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $a3ccb5670e466352$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $a3ccb5670e466352$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $a3ccb5670e466352$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $a3ccb5670e466352$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $a3ccb5670e466352$var$__spreadValues($a3ccb5670e466352$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $a3ccb5670e466352$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $a3ccb5670e466352$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $a3ccb5670e466352$var$createStateOperator(addOneMutably),
        addMany: $a3ccb5670e466352$var$createStateOperator(addManyMutably),
        setOne: $a3ccb5670e466352$var$createStateOperator(setOneMutably),
        setMany: $a3ccb5670e466352$var$createStateOperator(setManyMutably),
        setAll: $a3ccb5670e466352$var$createStateOperator(setAllMutably),
        updateOne: $a3ccb5670e466352$var$createStateOperator(updateOneMutably),
        updateMany: $a3ccb5670e466352$var$createStateOperator(updateManyMutably),
        upsertOne: $a3ccb5670e466352$var$createStateOperator(upsertOneMutably),
        upsertMany: $a3ccb5670e466352$var$createStateOperator(upsertManyMutably),
        removeOne: $a3ccb5670e466352$var$createStateOperator(removeOneMutably),
        removeMany: $a3ccb5670e466352$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $a3ccb5670e466352$var$createSortedStateAdapter(selectId, sort) {
    var _c = $a3ccb5670e466352$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $a3ccb5670e466352$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($a3ccb5670e466352$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $a3ccb5670e466352$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $a3ccb5670e466352$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $a3ccb5670e466352$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $a3ccb5670e466352$var$createStateOperator(addOneMutably),
        updateOne: $a3ccb5670e466352$var$createStateOperator(updateOneMutably),
        upsertOne: $a3ccb5670e466352$var$createStateOperator(upsertOneMutably),
        setOne: $a3ccb5670e466352$var$createStateOperator(setOneMutably),
        setMany: $a3ccb5670e466352$var$createStateOperator(setManyMutably),
        setAll: $a3ccb5670e466352$var$createStateOperator(setAllMutably),
        addMany: $a3ccb5670e466352$var$createStateOperator(addManyMutably),
        updateMany: $a3ccb5670e466352$var$createStateOperator(updateManyMutably),
        upsertMany: $a3ccb5670e466352$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $a3ccb5670e466352$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $a3ccb5670e466352$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $a3ccb5670e466352$var$createInitialStateFactory();
    var selectorsFactory = $a3ccb5670e466352$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $a3ccb5670e466352$var$createSortedStateAdapter(selectId, sortComparer) : $a3ccb5670e466352$var$createUnsortedStateAdapter(selectId);
    return $a3ccb5670e466352$var$__spreadValues($a3ccb5670e466352$var$__spreadValues($a3ccb5670e466352$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $a3ccb5670e466352$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $a3ccb5670e466352$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $a3ccb5670e466352$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $a3ccb5670e466352$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $a3ccb5670e466352$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $a3ccb5670e466352$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $a3ccb5670e466352$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $a3ccb5670e466352$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $a3ccb5670e466352$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $a3ccb5670e466352$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $a3ccb5670e466352$var$__spreadProps($a3ccb5670e466352$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $a3ccb5670e466352$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $a3ccb5670e466352$var$__spreadProps($a3ccb5670e466352$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $a3ccb5670e466352$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $a3ccb5670e466352$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $a3ccb5670e466352$var$__spreadProps($a3ccb5670e466352$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $a3ccb5670e466352$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $a3ccb5670e466352$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $a3ccb5670e466352$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$a3ccb5670e466352$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $a3ccb5670e466352$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $a3ccb5670e466352$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $a3ccb5670e466352$var$RejectWithValue) throw result;
                                                if (result instanceof $a3ccb5670e466352$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $a3ccb5670e466352$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($a3ccb5670e466352$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $a3ccb5670e466352$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $a3ccb5670e466352$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var $a3ccb5670e466352$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var $a3ccb5670e466352$var$matches = function(matcher, action) {
    if ($a3ccb5670e466352$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $a3ccb5670e466352$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $a3ccb5670e466352$var$matches(matcher, action);
        });
    };
}
function $a3ccb5670e466352$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $a3ccb5670e466352$var$matches(matcher, action);
        });
    };
}
function $a3ccb5670e466352$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $a3ccb5670e466352$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $a3ccb5670e466352$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $a3ccb5670e466352$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$a3ccb5670e466352$var$isAsyncThunkArray(asyncThunks)) return $a3ccb5670e466352$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $a3ccb5670e466352$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $a3ccb5670e466352$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $a3ccb5670e466352$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$a3ccb5670e466352$var$isAsyncThunkArray(asyncThunks)) return $a3ccb5670e466352$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $a3ccb5670e466352$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $a3ccb5670e466352$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $a3ccb5670e466352$export$9dd1fb32974da385($a3ccb5670e466352$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$a3ccb5670e466352$var$isAsyncThunkArray(asyncThunks)) return $a3ccb5670e466352$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $a3ccb5670e466352$export$9dd1fb32974da385($a3ccb5670e466352$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $a3ccb5670e466352$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $a3ccb5670e466352$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$a3ccb5670e466352$var$isAsyncThunkArray(asyncThunks)) return $a3ccb5670e466352$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $a3ccb5670e466352$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $a3ccb5670e466352$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $a3ccb5670e466352$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$a3ccb5670e466352$var$isAsyncThunkArray(asyncThunks)) return $a3ccb5670e466352$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $a3ccb5670e466352$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $a3ccb5670e466352$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $a3ccb5670e466352$var$noop = function() {};
var $a3ccb5670e466352$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $a3ccb5670e466352$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $a3ccb5670e466352$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $a3ccb5670e466352$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $a3ccb5670e466352$var$task = "task";
var $a3ccb5670e466352$var$listener = "listener";
var $a3ccb5670e466352$var$completed = "completed";
var $a3ccb5670e466352$var$cancelled = "cancelled";
var $a3ccb5670e466352$var$taskCancelled = "task-" + $a3ccb5670e466352$var$cancelled;
var $a3ccb5670e466352$var$taskCompleted = "task-" + $a3ccb5670e466352$var$completed;
var $a3ccb5670e466352$var$listenerCancelled = $a3ccb5670e466352$var$listener + "-" + $a3ccb5670e466352$var$cancelled;
var $a3ccb5670e466352$var$listenerCompleted = $a3ccb5670e466352$var$listener + "-" + $a3ccb5670e466352$var$completed;
var $a3ccb5670e466352$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $a3ccb5670e466352$var$task + " " + $a3ccb5670e466352$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $a3ccb5670e466352$var$validateActive = function(signal) {
    if (signal.aborted) throw new $a3ccb5670e466352$export$cb1bdac908fed7f(signal.reason);
};
function $a3ccb5670e466352$var$raceWithSignal(signal, promise2) {
    var cleanup = $a3ccb5670e466352$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $a3ccb5670e466352$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $a3ccb5670e466352$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $a3ccb5670e466352$var$noop;
    });
}
var $a3ccb5670e466352$var$runTask = function(task2, cleanUp) {
    return $a3ccb5670e466352$var$__async(void 0, null, function() {
        var value, error_1;
        return $a3ccb5670e466352$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $a3ccb5670e466352$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $a3ccb5670e466352$var$createPause = function(signal) {
    return function(promise2) {
        return $a3ccb5670e466352$var$catchRejection($a3ccb5670e466352$var$raceWithSignal(signal, promise2).then(function(output) {
            $a3ccb5670e466352$var$validateActive(signal);
            return output;
        }));
    };
};
var $a3ccb5670e466352$var$createDelay = function(signal) {
    var pause = $a3ccb5670e466352$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $a3ccb5670e466352$var$assign = Object.assign;
var $a3ccb5670e466352$var$INTERNAL_NIL_TOKEN = {};
var $a3ccb5670e466352$var$alm = "listenerMiddleware";
var $a3ccb5670e466352$var$createFork = function(parentAbortSignal) {
    var linkControllers = function(controller) {
        return $a3ccb5670e466352$var$addAbortSignalListener(parentAbortSignal, function() {
            return $a3ccb5670e466352$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor) {
        $a3ccb5670e466352$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $a3ccb5670e466352$var$runTask(function() {
            return $a3ccb5670e466352$var$__async(void 0, null, function() {
                var result2;
                return $a3ccb5670e466352$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $a3ccb5670e466352$var$validateActive(parentAbortSignal);
                            $a3ccb5670e466352$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $a3ccb5670e466352$var$createPause(childAbortController.signal),
                                    delay: $a3ccb5670e466352$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $a3ccb5670e466352$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $a3ccb5670e466352$var$abortControllerWithReason(childAbortController, $a3ccb5670e466352$var$taskCompleted);
        });
        return {
            result: $a3ccb5670e466352$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $a3ccb5670e466352$var$abortControllerWithReason(childAbortController, $a3ccb5670e466352$var$taskCancelled);
            }
        };
    };
};
var $a3ccb5670e466352$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $a3ccb5670e466352$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $a3ccb5670e466352$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $a3ccb5670e466352$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $a3ccb5670e466352$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $a3ccb5670e466352$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $a3ccb5670e466352$var$catchRejection(take(predicate, timeout));
    };
};
var $a3ccb5670e466352$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $a3ccb5670e466352$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $a3ccb5670e466352$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $a3ccb5670e466352$var$createListenerEntry = function(options) {
    var _c = $a3ccb5670e466352$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $a3ccb5670e466352$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $a3ccb5670e466352$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $a3ccb5670e466352$var$abortControllerWithReason(controller, $a3ccb5670e466352$var$listenerCancelled);
    });
};
var $a3ccb5670e466352$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($a3ccb5670e466352$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $a3ccb5670e466352$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $a3ccb5670e466352$export$f03a6b845d3fb58b = $a3ccb5670e466352$export$309c7a02b0b0bc62($a3ccb5670e466352$var$alm + "/add");
var $a3ccb5670e466352$export$b1b8022855fb2b71 = $a3ccb5670e466352$export$309c7a02b0b0bc62($a3ccb5670e466352$var$alm + "/removeAll");
var $a3ccb5670e466352$export$b03e9483f936dccb = $a3ccb5670e466352$export$309c7a02b0b0bc62($a3ccb5670e466352$var$alm + "/remove");
var $a3ccb5670e466352$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $a3ccb5670e466352$var$__spreadArray([
        $a3ccb5670e466352$var$alm + "/error"
    ], args));
};
function $a3ccb5670e466352$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $a3ccb5670e466352$var$defaultErrorHandler : _c;
    $a3ccb5670e466352$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $a3ccb5670e466352$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $a3ccb5670e466352$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $a3ccb5670e466352$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $a3ccb5670e466352$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $a3ccb5670e466352$var$__async(_this, null, function() {
            var internalTaskController, take, listenerError_1;
            return $a3ccb5670e466352$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $a3ccb5670e466352$var$createTakePattern(startListening, internalTaskController.signal);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $a3ccb5670e466352$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $a3ccb5670e466352$var$createDelay(internalTaskController.signal),
                                pause: $a3ccb5670e466352$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $a3ccb5670e466352$var$createFork(internalTaskController.signal),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $a3ccb5670e466352$var$abortControllerWithReason(controller, $a3ccb5670e466352$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $a3ccb5670e466352$export$cb1bdac908fed7f)) $a3ccb5670e466352$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        $a3ccb5670e466352$var$abortControllerWithReason(internalTaskController, $a3ccb5670e466352$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $a3ccb5670e466352$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$a3ccb5670e466352$export$b956e38827fca970(action)) return next(action);
                if ($a3ccb5670e466352$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($a3ccb5670e466352$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($a3ccb5670e466352$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $a3ccb5670e466352$var$INTERNAL_NIL_TOKEN) throw new Error($a3ccb5670e466352$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $a3ccb5670e466352$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $a3ccb5670e466352$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $a3ccb5670e466352$export$8fb31c0f05df007b = "RTK_autoBatch";
var $a3ccb5670e466352$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$a3ccb5670e466352$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $a3ccb5670e466352$var$promise;
var $a3ccb5670e466352$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($a3ccb5670e466352$var$promise || ($a3ccb5670e466352$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $a3ccb5670e466352$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $a3ccb5670e466352$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $a3ccb5670e466352$var$createQueueWithTimer(10);
var $a3ccb5670e466352$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $a3ccb5670e466352$var$queueMicrotaskShim : options.type === "raf" ? $a3ccb5670e466352$var$rAF : options.type === "callback" ? options.queueNotification : $a3ccb5670e466352$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$a3ccb5670e466352$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $i9Ee7.enableES5)();




/**
 * # Locale levels
 *
 * Locales are grouped into four levels of "readiness" for production.
 *
 *    1.  Incomplete or in progress, available for translators to test,
 *        but not for end-users.
 *    2.  Complete or nearly complete, available for quality assurance
 *        & feedback with small group of users.
 *    3.  Complete and ready for production use.
 *    4.  This is a special category for the "default" locale, which is
 *        English. This should never be disabled and we don't have a special
 *        flag to toggle group 4 on or off. It's always on.
 *
 * Levels are lower bounds and inclusive. In other words, allowing level 1
 * means all locales 1 or higher are enabled. You cannot _only_ turn on level 1
 * but not level 2 for example.
 *
 */ // Locale levels stored as constants
/* eslint-disable no-unused-vars */ const $b8c344dce25738f3$var$LOCALES_LEVEL_1 = 1;
const $b8c344dce25738f3$var$LOCALES_LEVEL_2 = 2;
/* eslint-enable no-unused-vars */ const $b8c344dce25738f3$var$LOCALES_LEVEL_3 = 3;
const $b8c344dce25738f3$var$LOCALES_LEVEL_4 = 4;
const $b8c344dce25738f3$export$1af4c7e47ad72f44 = "en";
const $b8c344dce25738f3$export$42a04c3fc76cd4a8 = $b8c344dce25738f3$var$LOCALES_LEVEL_4;
const $b8c344dce25738f3$export$21116d1a7177ca8e = $b8c344dce25738f3$var$LOCALES_LEVEL_3;


"use strict";
function $073aec6a648b9779$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $40c158859770d723$var$toString } = Object.prototype;
const { getPrototypeOf: $40c158859770d723$var$getPrototypeOf } = Object;
const $40c158859770d723$var$kindOf = ((cache)=>(thing)=>{
        const str = $40c158859770d723$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $40c158859770d723$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$40c158859770d723$var$kindOf(thing) === type;
};
const $40c158859770d723$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $40c158859770d723$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $40c158859770d723$var$isUndefined = $40c158859770d723$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $40c158859770d723$var$isBuffer(val) {
    return val !== null && !$40c158859770d723$var$isUndefined(val) && val.constructor !== null && !$40c158859770d723$var$isUndefined(val.constructor) && $40c158859770d723$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $40c158859770d723$var$isArrayBuffer = $40c158859770d723$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $40c158859770d723$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $40c158859770d723$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $40c158859770d723$var$isString = $40c158859770d723$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $40c158859770d723$var$isFunction = $40c158859770d723$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $40c158859770d723$var$isNumber = $40c158859770d723$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $40c158859770d723$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $40c158859770d723$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $40c158859770d723$var$isPlainObject = (val)=>{
    if ($40c158859770d723$var$kindOf(val) !== "object") return false;
    const prototype = $40c158859770d723$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $40c158859770d723$var$isDate = $40c158859770d723$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $40c158859770d723$var$isFile = $40c158859770d723$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $40c158859770d723$var$isBlob = $40c158859770d723$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $40c158859770d723$var$isFileList = $40c158859770d723$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $40c158859770d723$var$isStream = (val)=>$40c158859770d723$var$isObject(val) && $40c158859770d723$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $40c158859770d723$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $40c158859770d723$var$isFunction(thing.append) && ((kind = $40c158859770d723$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $40c158859770d723$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $40c158859770d723$var$isURLSearchParams = $40c158859770d723$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $40c158859770d723$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $40c158859770d723$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($40c158859770d723$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $40c158859770d723$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $40c158859770d723$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $40c158859770d723$var$isContextDefined = (context)=>!$40c158859770d723$var$isUndefined(context) && context !== $40c158859770d723$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $40c158859770d723$var$merge() {
    const { caseless: caseless } = $40c158859770d723$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $40c158859770d723$var$findKey(result, key) || key;
        if ($40c158859770d723$var$isPlainObject(result[targetKey]) && $40c158859770d723$var$isPlainObject(val)) result[targetKey] = $40c158859770d723$var$merge(result[targetKey], val);
        else if ($40c158859770d723$var$isPlainObject(val)) result[targetKey] = $40c158859770d723$var$merge({}, val);
        else if ($40c158859770d723$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $40c158859770d723$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $40c158859770d723$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $40c158859770d723$var$forEach(b, (val, key)=>{
        if (thisArg && $40c158859770d723$var$isFunction(val)) a[key] = (0, $073aec6a648b9779$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $40c158859770d723$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $40c158859770d723$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $40c158859770d723$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $40c158859770d723$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $40c158859770d723$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $40c158859770d723$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($40c158859770d723$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$40c158859770d723$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $40c158859770d723$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $40c158859770d723$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $40c158859770d723$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $40c158859770d723$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $40c158859770d723$var$isHTMLForm = $40c158859770d723$var$kindOfTest("HTMLFormElement");
const $40c158859770d723$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $40c158859770d723$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $40c158859770d723$var$isRegExp = $40c158859770d723$var$kindOfTest("RegExp");
const $40c158859770d723$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $40c158859770d723$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $40c158859770d723$var$freezeMethods = (obj)=>{
    $40c158859770d723$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($40c158859770d723$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$40c158859770d723$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $40c158859770d723$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $40c158859770d723$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $40c158859770d723$var$noop = ()=>{};
const $40c158859770d723$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $40c158859770d723$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $40c158859770d723$var$DIGIT = "0123456789";
const $40c158859770d723$var$ALPHABET = {
    DIGIT: $40c158859770d723$var$DIGIT,
    ALPHA: $40c158859770d723$var$ALPHA,
    ALPHA_DIGIT: $40c158859770d723$var$ALPHA + $40c158859770d723$var$ALPHA.toUpperCase() + $40c158859770d723$var$DIGIT
};
const $40c158859770d723$var$generateString = (size = 16, alphabet = $40c158859770d723$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $40c158859770d723$var$isSpecCompliantForm(thing) {
    return !!(thing && $40c158859770d723$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $40c158859770d723$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($40c158859770d723$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $40c158859770d723$var$isArray(source) ? [] : {};
                $40c158859770d723$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$40c158859770d723$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $40c158859770d723$var$isAsyncFn = $40c158859770d723$var$kindOfTest("AsyncFunction");
const $40c158859770d723$var$isThenable = (thing)=>thing && ($40c158859770d723$var$isObject(thing) || $40c158859770d723$var$isFunction(thing)) && $40c158859770d723$var$isFunction(thing.then) && $40c158859770d723$var$isFunction(thing.catch);
var $40c158859770d723$export$2e2bcd8739ae039 = {
    isArray: $40c158859770d723$var$isArray,
    isArrayBuffer: $40c158859770d723$var$isArrayBuffer,
    isBuffer: $40c158859770d723$var$isBuffer,
    isFormData: $40c158859770d723$var$isFormData,
    isArrayBufferView: $40c158859770d723$var$isArrayBufferView,
    isString: $40c158859770d723$var$isString,
    isNumber: $40c158859770d723$var$isNumber,
    isBoolean: $40c158859770d723$var$isBoolean,
    isObject: $40c158859770d723$var$isObject,
    isPlainObject: $40c158859770d723$var$isPlainObject,
    isUndefined: $40c158859770d723$var$isUndefined,
    isDate: $40c158859770d723$var$isDate,
    isFile: $40c158859770d723$var$isFile,
    isBlob: $40c158859770d723$var$isBlob,
    isRegExp: $40c158859770d723$var$isRegExp,
    isFunction: $40c158859770d723$var$isFunction,
    isStream: $40c158859770d723$var$isStream,
    isURLSearchParams: $40c158859770d723$var$isURLSearchParams,
    isTypedArray: $40c158859770d723$var$isTypedArray,
    isFileList: $40c158859770d723$var$isFileList,
    forEach: $40c158859770d723$var$forEach,
    merge: $40c158859770d723$var$merge,
    extend: $40c158859770d723$var$extend,
    trim: $40c158859770d723$var$trim,
    stripBOM: $40c158859770d723$var$stripBOM,
    inherits: $40c158859770d723$var$inherits,
    toFlatObject: $40c158859770d723$var$toFlatObject,
    kindOf: $40c158859770d723$var$kindOf,
    kindOfTest: $40c158859770d723$var$kindOfTest,
    endsWith: $40c158859770d723$var$endsWith,
    toArray: $40c158859770d723$var$toArray,
    forEachEntry: $40c158859770d723$var$forEachEntry,
    matchAll: $40c158859770d723$var$matchAll,
    isHTMLForm: $40c158859770d723$var$isHTMLForm,
    hasOwnProperty: $40c158859770d723$var$hasOwnProperty,
    hasOwnProp: $40c158859770d723$var$hasOwnProperty,
    reduceDescriptors: $40c158859770d723$var$reduceDescriptors,
    freezeMethods: $40c158859770d723$var$freezeMethods,
    toObjectSet: $40c158859770d723$var$toObjectSet,
    toCamelCase: $40c158859770d723$var$toCamelCase,
    noop: $40c158859770d723$var$noop,
    toFiniteNumber: $40c158859770d723$var$toFiniteNumber,
    findKey: $40c158859770d723$var$findKey,
    global: $40c158859770d723$var$_global,
    isContextDefined: $40c158859770d723$var$isContextDefined,
    ALPHABET: $40c158859770d723$var$ALPHABET,
    generateString: $40c158859770d723$var$generateString,
    isSpecCompliantForm: $40c158859770d723$var$isSpecCompliantForm,
    toJSONObject: $40c158859770d723$var$toJSONObject,
    isAsyncFn: $40c158859770d723$var$isAsyncFn,
    isThenable: $40c158859770d723$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $3b8a1bd6f77afeba$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $40c158859770d723$export$2e2bcd8739ae039).inherits($3b8a1bd6f77afeba$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $40c158859770d723$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $3b8a1bd6f77afeba$var$prototype = $3b8a1bd6f77afeba$var$AxiosError.prototype;
const $3b8a1bd6f77afeba$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $3b8a1bd6f77afeba$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($3b8a1bd6f77afeba$var$AxiosError, $3b8a1bd6f77afeba$var$descriptors);
Object.defineProperty($3b8a1bd6f77afeba$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$3b8a1bd6f77afeba$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($3b8a1bd6f77afeba$var$prototype);
    (0, $40c158859770d723$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $3b8a1bd6f77afeba$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $3b8a1bd6f77afeba$export$2e2bcd8739ae039 = $3b8a1bd6f77afeba$var$AxiosError;


// eslint-disable-next-line strict
var $a0a549399cba0f33$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c0e4e057fae580e6$export$a143d493d941bafc;
var $c0e4e057fae580e6$export$e4cf37d7f6fb9e0a;
var $c0e4e057fae580e6$export$f99ded8fe4b79145;
var $c0e4e057fae580e6$export$599f31c3813fae4d;
"use strict";
var $1098f597ee301616$export$a48f0734ac7c2329;
var $1098f597ee301616$export$d622b2ad8d90c771;
var $1098f597ee301616$export$6100ba28696e12de;
"use strict";
$1098f597ee301616$export$a48f0734ac7c2329 = $1098f597ee301616$var$byteLength;
$1098f597ee301616$export$d622b2ad8d90c771 = $1098f597ee301616$var$toByteArray;
$1098f597ee301616$export$6100ba28696e12de = $1098f597ee301616$var$fromByteArray;
var $1098f597ee301616$var$lookup = [];
var $1098f597ee301616$var$revLookup = [];
var $1098f597ee301616$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $1098f597ee301616$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $1098f597ee301616$var$i = 0, $1098f597ee301616$var$len = $1098f597ee301616$var$code.length; $1098f597ee301616$var$i < $1098f597ee301616$var$len; ++$1098f597ee301616$var$i){
    $1098f597ee301616$var$lookup[$1098f597ee301616$var$i] = $1098f597ee301616$var$code[$1098f597ee301616$var$i];
    $1098f597ee301616$var$revLookup[$1098f597ee301616$var$code.charCodeAt($1098f597ee301616$var$i)] = $1098f597ee301616$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$1098f597ee301616$var$revLookup["-".charCodeAt(0)] = 62;
$1098f597ee301616$var$revLookup["_".charCodeAt(0)] = 63;
function $1098f597ee301616$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $1098f597ee301616$var$byteLength(b64) {
    var lens = $1098f597ee301616$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $1098f597ee301616$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $1098f597ee301616$var$toByteArray(b64) {
    var tmp;
    var lens = $1098f597ee301616$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $1098f597ee301616$var$Arr($1098f597ee301616$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $1098f597ee301616$var$revLookup[b64.charCodeAt(i)] << 18 | $1098f597ee301616$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $1098f597ee301616$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $1098f597ee301616$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $1098f597ee301616$var$revLookup[b64.charCodeAt(i)] << 2 | $1098f597ee301616$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $1098f597ee301616$var$revLookup[b64.charCodeAt(i)] << 10 | $1098f597ee301616$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $1098f597ee301616$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $1098f597ee301616$var$tripletToBase64(num) {
    return $1098f597ee301616$var$lookup[num >> 18 & 0x3F] + $1098f597ee301616$var$lookup[num >> 12 & 0x3F] + $1098f597ee301616$var$lookup[num >> 6 & 0x3F] + $1098f597ee301616$var$lookup[num & 0x3F];
}
function $1098f597ee301616$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($1098f597ee301616$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $1098f597ee301616$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($1098f597ee301616$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($1098f597ee301616$var$lookup[tmp >> 2] + $1098f597ee301616$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($1098f597ee301616$var$lookup[tmp >> 10] + $1098f597ee301616$var$lookup[tmp >> 4 & 0x3F] + $1098f597ee301616$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $e9afdd1646bebbed$export$aafa59e2e03f2942;
var $e9afdd1646bebbed$export$68d8715fc104d294;
$e9afdd1646bebbed$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$e9afdd1646bebbed$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $c0e4e057fae580e6$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$c0e4e057fae580e6$export$a143d493d941bafc = $c0e4e057fae580e6$var$Buffer;
$c0e4e057fae580e6$export$e4cf37d7f6fb9e0a = $c0e4e057fae580e6$var$SlowBuffer;
$c0e4e057fae580e6$export$f99ded8fe4b79145 = 50;
var $c0e4e057fae580e6$var$K_MAX_LENGTH = 0x7fffffff;
$c0e4e057fae580e6$export$599f31c3813fae4d = $c0e4e057fae580e6$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c0e4e057fae580e6$var$Buffer.TYPED_ARRAY_SUPPORT = $c0e4e057fae580e6$var$typedArraySupport();
if (!$c0e4e057fae580e6$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c0e4e057fae580e6$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c0e4e057fae580e6$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$c0e4e057fae580e6$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c0e4e057fae580e6$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$c0e4e057fae580e6$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c0e4e057fae580e6$var$createBuffer(length) {
    if (length > $c0e4e057fae580e6$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c0e4e057fae580e6$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c0e4e057fae580e6$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c0e4e057fae580e6$var$allocUnsafe(arg);
    }
    return $c0e4e057fae580e6$var$from(arg, encodingOrOffset, length);
}
$c0e4e057fae580e6$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c0e4e057fae580e6$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $c0e4e057fae580e6$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c0e4e057fae580e6$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c0e4e057fae580e6$var$isInstance(value, ArrayBuffer) || value && $c0e4e057fae580e6$var$isInstance(value.buffer, ArrayBuffer)) return $c0e4e057fae580e6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($c0e4e057fae580e6$var$isInstance(value, SharedArrayBuffer) || value && $c0e4e057fae580e6$var$isInstance(value.buffer, SharedArrayBuffer))) return $c0e4e057fae580e6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c0e4e057fae580e6$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $c0e4e057fae580e6$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $c0e4e057fae580e6$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c0e4e057fae580e6$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c0e4e057fae580e6$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c0e4e057fae580e6$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c0e4e057fae580e6$var$Buffer, Uint8Array);
function $c0e4e057fae580e6$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c0e4e057fae580e6$var$alloc(size, fill, encoding) {
    $c0e4e057fae580e6$var$assertSize(size);
    if (size <= 0) return $c0e4e057fae580e6$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $c0e4e057fae580e6$var$createBuffer(size).fill(fill, encoding) : $c0e4e057fae580e6$var$createBuffer(size).fill(fill);
    return $c0e4e057fae580e6$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c0e4e057fae580e6$var$Buffer.alloc = function(size, fill, encoding) {
    return $c0e4e057fae580e6$var$alloc(size, fill, encoding);
};
function $c0e4e057fae580e6$var$allocUnsafe(size) {
    $c0e4e057fae580e6$var$assertSize(size);
    return $c0e4e057fae580e6$var$createBuffer(size < 0 ? 0 : $c0e4e057fae580e6$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c0e4e057fae580e6$var$Buffer.allocUnsafe = function(size) {
    return $c0e4e057fae580e6$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c0e4e057fae580e6$var$Buffer.allocUnsafeSlow = function(size) {
    return $c0e4e057fae580e6$var$allocUnsafe(size);
};
function $c0e4e057fae580e6$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$c0e4e057fae580e6$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $c0e4e057fae580e6$var$byteLength(string, encoding) | 0;
    var buf = $c0e4e057fae580e6$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c0e4e057fae580e6$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $c0e4e057fae580e6$var$checked(array.length) | 0;
    var buf = $c0e4e057fae580e6$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c0e4e057fae580e6$var$fromArrayView(arrayView) {
    if ($c0e4e057fae580e6$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $c0e4e057fae580e6$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c0e4e057fae580e6$var$fromArrayLike(arrayView);
}
function $c0e4e057fae580e6$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c0e4e057fae580e6$var$Buffer.prototype);
    return buf;
}
function $c0e4e057fae580e6$var$fromObject(obj) {
    if ($c0e4e057fae580e6$var$Buffer.isBuffer(obj)) {
        var len = $c0e4e057fae580e6$var$checked(obj.length) | 0;
        var buf = $c0e4e057fae580e6$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $c0e4e057fae580e6$var$numberIsNaN(obj.length)) return $c0e4e057fae580e6$var$createBuffer(0);
        return $c0e4e057fae580e6$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $c0e4e057fae580e6$var$fromArrayLike(obj.data);
}
function $c0e4e057fae580e6$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c0e4e057fae580e6$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c0e4e057fae580e6$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $c0e4e057fae580e6$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c0e4e057fae580e6$var$Buffer.alloc(+length);
}
$c0e4e057fae580e6$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c0e4e057fae580e6$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c0e4e057fae580e6$var$Buffer.compare = function compare(a, b) {
    if ($c0e4e057fae580e6$var$isInstance(a, Uint8Array)) a = $c0e4e057fae580e6$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c0e4e057fae580e6$var$isInstance(b, Uint8Array)) b = $c0e4e057fae580e6$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c0e4e057fae580e6$var$Buffer.isBuffer(a) || !$c0e4e057fae580e6$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c0e4e057fae580e6$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$c0e4e057fae580e6$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c0e4e057fae580e6$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $c0e4e057fae580e6$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($c0e4e057fae580e6$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $c0e4e057fae580e6$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c0e4e057fae580e6$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c0e4e057fae580e6$var$byteLength(string, encoding) {
    if ($c0e4e057fae580e6$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c0e4e057fae580e6$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $c0e4e057fae580e6$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $c0e4e057fae580e6$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c0e4e057fae580e6$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c0e4e057fae580e6$var$Buffer.byteLength = $c0e4e057fae580e6$var$byteLength;
function $c0e4e057fae580e6$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $c0e4e057fae580e6$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $c0e4e057fae580e6$var$utf8Slice(this, start, end);
        case "ascii":
            return $c0e4e057fae580e6$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $c0e4e057fae580e6$var$latin1Slice(this, start, end);
        case "base64":
            return $c0e4e057fae580e6$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c0e4e057fae580e6$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c0e4e057fae580e6$var$Buffer.prototype._isBuffer = true;
function $c0e4e057fae580e6$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c0e4e057fae580e6$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$c0e4e057fae580e6$var$swap(this, i, i + 1);
    return this;
};
$c0e4e057fae580e6$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $c0e4e057fae580e6$var$swap(this, i, i + 3);
        $c0e4e057fae580e6$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c0e4e057fae580e6$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $c0e4e057fae580e6$var$swap(this, i, i + 7);
        $c0e4e057fae580e6$var$swap(this, i + 1, i + 6);
        $c0e4e057fae580e6$var$swap(this, i + 2, i + 5);
        $c0e4e057fae580e6$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c0e4e057fae580e6$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $c0e4e057fae580e6$var$utf8Slice(this, 0, length);
    return $c0e4e057fae580e6$var$slowToString.apply(this, arguments);
};
$c0e4e057fae580e6$var$Buffer.prototype.toLocaleString = $c0e4e057fae580e6$var$Buffer.prototype.toString;
$c0e4e057fae580e6$var$Buffer.prototype.equals = function equals(b) {
    if (!$c0e4e057fae580e6$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $c0e4e057fae580e6$var$Buffer.compare(this, b) === 0;
};
$c0e4e057fae580e6$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $c0e4e057fae580e6$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($c0e4e057fae580e6$var$customInspectSymbol) $c0e4e057fae580e6$var$Buffer.prototype[$c0e4e057fae580e6$var$customInspectSymbol] = $c0e4e057fae580e6$var$Buffer.prototype.inspect;
$c0e4e057fae580e6$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c0e4e057fae580e6$var$isInstance(target, Uint8Array)) target = $c0e4e057fae580e6$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c0e4e057fae580e6$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c0e4e057fae580e6$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c0e4e057fae580e6$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $c0e4e057fae580e6$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c0e4e057fae580e6$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c0e4e057fae580e6$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c0e4e057fae580e6$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $c0e4e057fae580e6$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c0e4e057fae580e6$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c0e4e057fae580e6$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c0e4e057fae580e6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c0e4e057fae580e6$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c0e4e057fae580e6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c0e4e057fae580e6$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c0e4e057fae580e6$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c0e4e057fae580e6$var$utf8Write(buf, string, offset, length) {
    return $c0e4e057fae580e6$var$blitBuffer($c0e4e057fae580e6$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c0e4e057fae580e6$var$asciiWrite(buf, string, offset, length) {
    return $c0e4e057fae580e6$var$blitBuffer($c0e4e057fae580e6$var$asciiToBytes(string), buf, offset, length);
}
function $c0e4e057fae580e6$var$base64Write(buf, string, offset, length) {
    return $c0e4e057fae580e6$var$blitBuffer($c0e4e057fae580e6$var$base64ToBytes(string), buf, offset, length);
}
function $c0e4e057fae580e6$var$ucs2Write(buf, string, offset, length) {
    return $c0e4e057fae580e6$var$blitBuffer($c0e4e057fae580e6$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c0e4e057fae580e6$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $c0e4e057fae580e6$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $c0e4e057fae580e6$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $c0e4e057fae580e6$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $c0e4e057fae580e6$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c0e4e057fae580e6$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c0e4e057fae580e6$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c0e4e057fae580e6$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $1098f597ee301616$export$6100ba28696e12de(buf);
    else return $1098f597ee301616$export$6100ba28696e12de(buf.slice(start, end));
}
function $c0e4e057fae580e6$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c0e4e057fae580e6$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $c0e4e057fae580e6$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c0e4e057fae580e6$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $c0e4e057fae580e6$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c0e4e057fae580e6$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c0e4e057fae580e6$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c0e4e057fae580e6$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c0e4e057fae580e6$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $c0e4e057fae580e6$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c0e4e057fae580e6$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c0e4e057fae580e6$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c0e4e057fae580e6$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c0e4e057fae580e6$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$c0e4e057fae580e6$var$Buffer.prototype.readUintLE = $c0e4e057fae580e6$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c0e4e057fae580e6$var$Buffer.prototype.readUintBE = $c0e4e057fae580e6$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c0e4e057fae580e6$var$Buffer.prototype.readUint8 = $c0e4e057fae580e6$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c0e4e057fae580e6$var$Buffer.prototype.readUint16LE = $c0e4e057fae580e6$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c0e4e057fae580e6$var$Buffer.prototype.readUint16BE = $c0e4e057fae580e6$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c0e4e057fae580e6$var$Buffer.prototype.readUint32LE = $c0e4e057fae580e6$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c0e4e057fae580e6$var$Buffer.prototype.readUint32BE = $c0e4e057fae580e6$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c0e4e057fae580e6$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c0e4e057fae580e6$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c0e4e057fae580e6$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c0e4e057fae580e6$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c0e4e057fae580e6$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c0e4e057fae580e6$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c0e4e057fae580e6$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c0e4e057fae580e6$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, 4, this.length);
    return $e9afdd1646bebbed$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$c0e4e057fae580e6$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, 4, this.length);
    return $e9afdd1646bebbed$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$c0e4e057fae580e6$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, 8, this.length);
    return $e9afdd1646bebbed$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$c0e4e057fae580e6$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkOffset(offset, 8, this.length);
    return $e9afdd1646bebbed$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $c0e4e057fae580e6$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c0e4e057fae580e6$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$c0e4e057fae580e6$var$Buffer.prototype.writeUintLE = $c0e4e057fae580e6$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c0e4e057fae580e6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c0e4e057fae580e6$var$Buffer.prototype.writeUintBE = $c0e4e057fae580e6$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c0e4e057fae580e6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c0e4e057fae580e6$var$Buffer.prototype.writeUint8 = $c0e4e057fae580e6$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c0e4e057fae580e6$var$Buffer.prototype.writeUint16LE = $c0e4e057fae580e6$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c0e4e057fae580e6$var$Buffer.prototype.writeUint16BE = $c0e4e057fae580e6$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c0e4e057fae580e6$var$Buffer.prototype.writeUint32LE = $c0e4e057fae580e6$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c0e4e057fae580e6$var$Buffer.prototype.writeUint32BE = $c0e4e057fae580e6$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c0e4e057fae580e6$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c0e4e057fae580e6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c0e4e057fae580e6$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c0e4e057fae580e6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c0e4e057fae580e6$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c0e4e057fae580e6$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c0e4e057fae580e6$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c0e4e057fae580e6$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c0e4e057fae580e6$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c0e4e057fae580e6$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $c0e4e057fae580e6$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $e9afdd1646bebbed$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c0e4e057fae580e6$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c0e4e057fae580e6$var$writeFloat(this, value, offset, true, noAssert);
};
$c0e4e057fae580e6$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c0e4e057fae580e6$var$writeFloat(this, value, offset, false, noAssert);
};
function $c0e4e057fae580e6$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0e4e057fae580e6$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $e9afdd1646bebbed$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c0e4e057fae580e6$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c0e4e057fae580e6$var$writeDouble(this, value, offset, true, noAssert);
};
$c0e4e057fae580e6$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c0e4e057fae580e6$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c0e4e057fae580e6$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c0e4e057fae580e6$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c0e4e057fae580e6$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$c0e4e057fae580e6$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $c0e4e057fae580e6$var$Buffer.isBuffer(val) ? val : $c0e4e057fae580e6$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $c0e4e057fae580e6$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c0e4e057fae580e6$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c0e4e057fae580e6$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $c0e4e057fae580e6$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $c0e4e057fae580e6$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c0e4e057fae580e6$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c0e4e057fae580e6$var$base64ToBytes(str) {
    return $1098f597ee301616$export$d622b2ad8d90c771($c0e4e057fae580e6$var$base64clean(str));
}
function $c0e4e057fae580e6$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c0e4e057fae580e6$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c0e4e057fae580e6$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $c0e4e057fae580e6$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $c18651625cb92972$require$Buffer = $c0e4e057fae580e6$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $c18651625cb92972$var$isVisitable(thing) {
    return (0, $40c158859770d723$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $40c158859770d723$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $c18651625cb92972$var$removeBrackets(key) {
    return (0, $40c158859770d723$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $c18651625cb92972$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $c18651625cb92972$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $c18651625cb92972$var$isFlatArray(arr) {
    return (0, $40c158859770d723$export$2e2bcd8739ae039).isArray(arr) && !arr.some($c18651625cb92972$var$isVisitable);
}
const $c18651625cb92972$var$predicates = (0, $40c158859770d723$export$2e2bcd8739ae039).toFlatObject((0, $40c158859770d723$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $c18651625cb92972$var$toFormData(obj, formData, options) {
    if (!(0, $40c158859770d723$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $a0a549399cba0f33$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $40c158859770d723$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $40c158859770d723$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $40c158859770d723$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $40c158859770d723$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $40c158859770d723$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $40c158859770d723$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $40c158859770d723$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $40c158859770d723$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $c18651625cb92972$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $40c158859770d723$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $40c158859770d723$export$2e2bcd8739ae039).isArray(value) && $c18651625cb92972$var$isFlatArray(value) || ((0, $40c158859770d723$export$2e2bcd8739ae039).isFileList(value) || (0, $40c158859770d723$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $40c158859770d723$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $c18651625cb92972$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $40c158859770d723$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $c18651625cb92972$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($c18651625cb92972$var$isVisitable(value)) return true;
        formData.append($c18651625cb92972$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($c18651625cb92972$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $c18651625cb92972$var$isVisitable
    });
    function build(value, path) {
        if ((0, $40c158859770d723$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $40c158859770d723$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $40c158859770d723$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $40c158859770d723$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $40c158859770d723$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $c18651625cb92972$export$2e2bcd8739ae039 = $c18651625cb92972$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $96ed211cc39a1edb$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $96ed211cc39a1edb$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $c18651625cb92972$export$2e2bcd8739ae039)(params, this, options);
}
const $96ed211cc39a1edb$var$prototype = $96ed211cc39a1edb$var$AxiosURLSearchParams.prototype;
$96ed211cc39a1edb$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$96ed211cc39a1edb$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $96ed211cc39a1edb$var$encode);
    } : $96ed211cc39a1edb$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $96ed211cc39a1edb$export$2e2bcd8739ae039 = $96ed211cc39a1edb$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $21553c155663de96$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $21553c155663de96$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $21553c155663de96$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $40c158859770d723$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $96ed211cc39a1edb$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $1281d9b6f516cb8a$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $40c158859770d723$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $1281d9b6f516cb8a$export$2e2bcd8739ae039 = $1281d9b6f516cb8a$var$InterceptorManager;





"use strict";
var $c9fdbda1ade21846$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $7da78e599006ebc6$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $96ed211cc39a1edb$export$2e2bcd8739ae039);


"use strict";
var $f94c42ff9af0674e$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $2e13198613b22148$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $39128fb7cf9b23eb$var$isStandardBrowserEnv = (()=>{
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
})();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $39128fb7cf9b23eb$var$isStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $39128fb7cf9b23eb$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $7da78e599006ebc6$export$2e2bcd8739ae039,
        FormData: $f94c42ff9af0674e$export$2e2bcd8739ae039,
        Blob: $2e13198613b22148$export$2e2bcd8739ae039
    },
    isStandardBrowserEnv: $39128fb7cf9b23eb$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $39128fb7cf9b23eb$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


"use strict";
function $c481b070593d44c1$export$2e2bcd8739ae039(data, options) {
    return (0, $c18651625cb92972$export$2e2bcd8739ae039)(data, new (0, $39128fb7cf9b23eb$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $39128fb7cf9b23eb$export$2e2bcd8739ae039).isNode && (0, $40c158859770d723$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $45b2c692682353d7$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $40c158859770d723$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $45b2c692682353d7$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $45b2c692682353d7$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $40c158859770d723$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $40c158859770d723$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $40c158859770d723$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $40c158859770d723$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $45b2c692682353d7$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $40c158859770d723$export$2e2bcd8739ae039).isFormData(formData) && (0, $40c158859770d723$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $40c158859770d723$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($45b2c692682353d7$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $45b2c692682353d7$export$2e2bcd8739ae039 = $45b2c692682353d7$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $9099212a92b0b081$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $40c158859770d723$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $40c158859770d723$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $9099212a92b0b081$var$defaults = {
    transitional: (0, $c9fdbda1ade21846$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $40c158859770d723$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $40c158859770d723$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $40c158859770d723$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $45b2c692682353d7$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $40c158859770d723$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $40c158859770d723$export$2e2bcd8739ae039).isBuffer(data) || (0, $40c158859770d723$export$2e2bcd8739ae039).isStream(data) || (0, $40c158859770d723$export$2e2bcd8739ae039).isFile(data) || (0, $40c158859770d723$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $40c158859770d723$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $40c158859770d723$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $c481b070593d44c1$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $40c158859770d723$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $c18651625cb92972$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $9099212a92b0b081$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $9099212a92b0b081$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $40c158859770d723$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).from(e, (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $39128fb7cf9b23eb$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $39128fb7cf9b23eb$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $40c158859770d723$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $9099212a92b0b081$var$defaults.headers[method] = {};
});
var $9099212a92b0b081$export$2e2bcd8739ae039 = $9099212a92b0b081$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $282764cdca4038c8$var$ignoreDuplicateOf = (0, $40c158859770d723$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $282764cdca4038c8$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $282764cdca4038c8$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $c9c51e80a5ac4a5a$var$$internals = Symbol("internals");
function $c9c51e80a5ac4a5a$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c9c51e80a5ac4a5a$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $40c158859770d723$export$2e2bcd8739ae039).isArray(value) ? value.map($c9c51e80a5ac4a5a$var$normalizeValue) : String(value);
}
function $c9c51e80a5ac4a5a$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c9c51e80a5ac4a5a$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c9c51e80a5ac4a5a$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $40c158859770d723$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $40c158859770d723$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $40c158859770d723$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $40c158859770d723$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c9c51e80a5ac4a5a$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c9c51e80a5ac4a5a$var$buildAccessors(obj, header) {
    const accessorName = (0, $40c158859770d723$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c9c51e80a5ac4a5a$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c9c51e80a5ac4a5a$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $40c158859770d723$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c9c51e80a5ac4a5a$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $40c158859770d723$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $40c158859770d723$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $40c158859770d723$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c9c51e80a5ac4a5a$var$isValidHeaderName(header)) setHeaders((0, $282764cdca4038c8$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c9c51e80a5ac4a5a$var$normalizeHeader(header);
        if (header) {
            const key = (0, $40c158859770d723$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c9c51e80a5ac4a5a$var$parseTokens(value);
                if ((0, $40c158859770d723$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $40c158859770d723$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $c9c51e80a5ac4a5a$var$normalizeHeader(header);
        if (header) {
            const key = (0, $40c158859770d723$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c9c51e80a5ac4a5a$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c9c51e80a5ac4a5a$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $40c158859770d723$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c9c51e80a5ac4a5a$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $40c158859770d723$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c9c51e80a5ac4a5a$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $40c158859770d723$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $40c158859770d723$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c9c51e80a5ac4a5a$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c9c51e80a5ac4a5a$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c9c51e80a5ac4a5a$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $40c158859770d723$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $40c158859770d723$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c9c51e80a5ac4a5a$var$$internals] = this[$c9c51e80a5ac4a5a$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c9c51e80a5ac4a5a$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c9c51e80a5ac4a5a$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $40c158859770d723$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$c9c51e80a5ac4a5a$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $40c158859770d723$export$2e2bcd8739ae039).reduceDescriptors($c9c51e80a5ac4a5a$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $40c158859770d723$export$2e2bcd8739ae039).freezeMethods($c9c51e80a5ac4a5a$var$AxiosHeaders);
var $c9c51e80a5ac4a5a$export$2e2bcd8739ae039 = $c9c51e80a5ac4a5a$var$AxiosHeaders;


"use strict";
function $84ca340c8333b4f2$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $9099212a92b0b081$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c9c51e80a5ac4a5a$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $40c158859770d723$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $7b399b4dad41cc5a$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $7ce129bb59faf1f7$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $40c158859770d723$export$2e2bcd8739ae039).inherits($7ce129bb59faf1f7$var$CanceledError, (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $7ce129bb59faf1f7$export$2e2bcd8739ae039 = $7ce129bb59faf1f7$var$CanceledError;







"use strict";
function $003c9feef712a12d$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




"use strict";
var $942c357780579da4$export$2e2bcd8739ae039 = (0, $39128fb7cf9b23eb$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $40c158859770d723$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $40c158859770d723$export$2e2bcd8739ae039).isString(path)) cookie.push("path=" + path);
            if ((0, $40c158859770d723$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();



"use strict";
function $f137f494305ab2a5$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $b90bbb9a9c89cdb0$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $cbfe947ae24961c4$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $f137f494305ab2a5$export$2e2bcd8739ae039)(requestedURL)) return (0, $b90bbb9a9c89cdb0$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $1a33bf89edff0481$export$2e2bcd8739ae039 = (0, $39128fb7cf9b23eb$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $40c158859770d723$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $683bd3c606eda39f$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $847f07e5838fb105$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $847f07e5838fb105$export$2e2bcd8739ae039 = $847f07e5838fb105$var$speedometer;


"use strict";
function $56e73f5b073926fd$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $847f07e5838fb105$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $56e73f5b073926fd$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $56e73f5b073926fd$export$2e2bcd8739ae039 = $56e73f5b073926fd$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $c9c51e80a5ac4a5a$export$2e2bcd8739ae039).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $40c158859770d723$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $39128fb7cf9b23eb$export$2e2bcd8739ae039).isStandardBrowserEnv || (0, $39128fb7cf9b23eb$export$2e2bcd8739ae039).isStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if (!requestHeaders.getContentType(/^\s*multipart\/form-data/)) requestHeaders.setContentType("multipart/form-data"); // mobile/desktop app frameworks
            else if ((0, $40c158859770d723$export$2e2bcd8739ae039).isString(contentType = requestHeaders.getContentType())) // fix semicolon duplication issue for ReactNative FormData implementation
            requestHeaders.setContentType(contentType.replace(/^\s*(multipart\/form-data);+/, "$1"));
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $cbfe947ae24961c4$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $21553c155663de96$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c9c51e80a5ac4a5a$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $003c9feef712a12d$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039)("Request aborted", (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039)("Network Error", (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $c9fdbda1ade21846$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).ETIMEDOUT : (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $39128fb7cf9b23eb$export$2e2bcd8739ae039).isStandardBrowserEnv) {
            // Add xsrf header
            // regarding CVE-2023-45857 config.withCredentials condition was removed temporarily
            const xsrfValue = (0, $1a33bf89edff0481$export$2e2bcd8739ae039)(fullPath) && config.xsrfCookieName && (0, $942c357780579da4$export$2e2bcd8739ae039).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $40c158859770d723$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $40c158859770d723$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $56e73f5b073926fd$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $56e73f5b073926fd$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $7ce129bb59faf1f7$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $683bd3c606eda39f$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $39128fb7cf9b23eb$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $2311092e997da686$var$knownAdapters = {
    http: (0, $a0a549399cba0f33$export$2e2bcd8739ae039),
    xhr: (0, $56e73f5b073926fd$export$2e2bcd8739ae039)
};
(0, $40c158859770d723$export$2e2bcd8739ae039).forEach($2311092e997da686$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $2311092e997da686$var$renderReason = (reason)=>`- ${reason}`;
const $2311092e997da686$var$isResolvedHandle = (adapter)=>(0, $40c158859770d723$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $2311092e997da686$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $40c158859770d723$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$2311092e997da686$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $2311092e997da686$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($2311092e997da686$var$renderReason).join("\n") : " " + $2311092e997da686$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $2311092e997da686$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $d6151d2ffbf1ef6e$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $7ce129bb59faf1f7$export$2e2bcd8739ae039)(null, config);
}
function $d6151d2ffbf1ef6e$export$2e2bcd8739ae039(config) {
    $d6151d2ffbf1ef6e$var$throwIfCancellationRequested(config);
    config.headers = (0, $c9c51e80a5ac4a5a$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $84ca340c8333b4f2$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $2311092e997da686$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $9099212a92b0b081$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $d6151d2ffbf1ef6e$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $84ca340c8333b4f2$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $c9c51e80a5ac4a5a$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7b399b4dad41cc5a$export$2e2bcd8739ae039)(reason)) {
            $d6151d2ffbf1ef6e$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $84ca340c8333b4f2$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $c9c51e80a5ac4a5a$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $e9061693411c83c1$var$headersToObject = (thing)=>thing instanceof (0, $c9c51e80a5ac4a5a$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $e9061693411c83c1$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $40c158859770d723$export$2e2bcd8739ae039).isPlainObject(target) && (0, $40c158859770d723$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $40c158859770d723$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $40c158859770d723$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $40c158859770d723$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $40c158859770d723$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $40c158859770d723$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $40c158859770d723$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $40c158859770d723$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $40c158859770d723$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $40c158859770d723$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($e9061693411c83c1$var$headersToObject(a), $e9061693411c83c1$var$headersToObject(b), true)
    };
    (0, $40c158859770d723$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $40c158859770d723$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $a3a46fb85d7768cd$export$a4ad2735b021c132 = "1.6.0";



"use strict";
const $fb8d36b8e70728ee$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $fb8d36b8e70728ee$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $fb8d36b8e70728ee$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $fb8d36b8e70728ee$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $a3a46fb85d7768cd$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$fb8d36b8e70728ee$var$deprecatedWarnings[opt]) {
            $fb8d36b8e70728ee$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $fb8d36b8e70728ee$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039)("options must be an object", (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $fb8d36b8e70728ee$export$2e2bcd8739ae039 = {
    assertOptions: $fb8d36b8e70728ee$var$assertOptions,
    validators: $fb8d36b8e70728ee$var$validators
};



"use strict";
const $f616d03ed7eaa508$var$validators = (0, $fb8d36b8e70728ee$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $f616d03ed7eaa508$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $1281d9b6f516cb8a$export$2e2bcd8739ae039)(),
            response: new (0, $1281d9b6f516cb8a$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $e9061693411c83c1$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $fb8d36b8e70728ee$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $f616d03ed7eaa508$var$validators.transitional($f616d03ed7eaa508$var$validators.boolean),
            forcedJSONParsing: $f616d03ed7eaa508$var$validators.transitional($f616d03ed7eaa508$var$validators.boolean),
            clarifyTimeoutError: $f616d03ed7eaa508$var$validators.transitional($f616d03ed7eaa508$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $40c158859770d723$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $fb8d36b8e70728ee$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $f616d03ed7eaa508$var$validators.function,
                serialize: $f616d03ed7eaa508$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $40c158859770d723$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $40c158859770d723$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c9c51e80a5ac4a5a$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $d6151d2ffbf1ef6e$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $d6151d2ffbf1ef6e$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $e9061693411c83c1$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $cbfe947ae24961c4$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $21553c155663de96$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $40c158859770d723$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $f616d03ed7eaa508$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $e9061693411c83c1$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $40c158859770d723$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $e9061693411c83c1$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $f616d03ed7eaa508$var$Axios.prototype[method] = generateHTTPMethod();
    $f616d03ed7eaa508$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $f616d03ed7eaa508$export$2e2bcd8739ae039 = $f616d03ed7eaa508$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $012181a4d2b8920b$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $7ce129bb59faf1f7$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $012181a4d2b8920b$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $012181a4d2b8920b$export$2e2bcd8739ae039 = $012181a4d2b8920b$var$CancelToken;






"use strict";
function $b1bb2bcf3eacad76$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $32a5e38be8475697$export$2e2bcd8739ae039(payload) {
    return (0, $40c158859770d723$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $ab14d509c9a1c28e$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($ab14d509c9a1c28e$var$HttpStatusCode).forEach(([key, value])=>{
    $ab14d509c9a1c28e$var$HttpStatusCode[value] = key;
});
var $ab14d509c9a1c28e$export$2e2bcd8739ae039 = $ab14d509c9a1c28e$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $c4e1eb2fba6bd6ed$var$createInstance(defaultConfig) {
    const context = new (0, $f616d03ed7eaa508$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $073aec6a648b9779$export$2e2bcd8739ae039)((0, $f616d03ed7eaa508$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $40c158859770d723$export$2e2bcd8739ae039).extend(instance, (0, $f616d03ed7eaa508$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $40c158859770d723$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $c4e1eb2fba6bd6ed$var$createInstance((0, $e9061693411c83c1$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $c4e1eb2fba6bd6ed$var$axios = $c4e1eb2fba6bd6ed$var$createInstance((0, $9099212a92b0b081$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$c4e1eb2fba6bd6ed$var$axios.Axios = (0, $f616d03ed7eaa508$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$c4e1eb2fba6bd6ed$var$axios.CanceledError = (0, $7ce129bb59faf1f7$export$2e2bcd8739ae039);
$c4e1eb2fba6bd6ed$var$axios.CancelToken = (0, $012181a4d2b8920b$export$2e2bcd8739ae039);
$c4e1eb2fba6bd6ed$var$axios.isCancel = (0, $7b399b4dad41cc5a$export$2e2bcd8739ae039);
$c4e1eb2fba6bd6ed$var$axios.VERSION = (0, $a3a46fb85d7768cd$export$a4ad2735b021c132);
$c4e1eb2fba6bd6ed$var$axios.toFormData = (0, $c18651625cb92972$export$2e2bcd8739ae039);
// Expose AxiosError class
$c4e1eb2fba6bd6ed$var$axios.AxiosError = (0, $3b8a1bd6f77afeba$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$c4e1eb2fba6bd6ed$var$axios.Cancel = $c4e1eb2fba6bd6ed$var$axios.CanceledError;
// Expose all/spread
$c4e1eb2fba6bd6ed$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$c4e1eb2fba6bd6ed$var$axios.spread = (0, $b1bb2bcf3eacad76$export$2e2bcd8739ae039);
// Expose isAxiosError
$c4e1eb2fba6bd6ed$var$axios.isAxiosError = (0, $32a5e38be8475697$export$2e2bcd8739ae039);
// Expose mergeConfig
$c4e1eb2fba6bd6ed$var$axios.mergeConfig = (0, $e9061693411c83c1$export$2e2bcd8739ae039);
$c4e1eb2fba6bd6ed$var$axios.AxiosHeaders = (0, $c9c51e80a5ac4a5a$export$2e2bcd8739ae039);
$c4e1eb2fba6bd6ed$var$axios.formToJSON = (thing)=>(0, $45b2c692682353d7$export$2e2bcd8739ae039)((0, $40c158859770d723$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$c4e1eb2fba6bd6ed$var$axios.getAdapter = (0, $2311092e997da686$export$2e2bcd8739ae039).getAdapter;
$c4e1eb2fba6bd6ed$var$axios.HttpStatusCode = (0, $ab14d509c9a1c28e$export$2e2bcd8739ae039);
$c4e1eb2fba6bd6ed$var$axios.default = $c4e1eb2fba6bd6ed$var$axios;
var // this module should only have a default export
$c4e1eb2fba6bd6ed$export$2e2bcd8739ae039 = $c4e1eb2fba6bd6ed$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $892734f1a566c47d$export$1c00760e9e5a4e95, AxiosError: $892734f1a566c47d$export$c1fbed17c2f6a328, CanceledError: $892734f1a566c47d$export$1ab0c6b20d94fa14, isCancel: $892734f1a566c47d$export$3b22524397b493c6, CancelToken: $892734f1a566c47d$export$fd08e3cb425f0d61, VERSION: $892734f1a566c47d$export$a4ad2735b021c132, all: $892734f1a566c47d$export$84bf76cd7afc7469, Cancel: $892734f1a566c47d$export$848c9b7ead0df967, isAxiosError: $892734f1a566c47d$export$fbafdbe06a5b5a9a, spread: $892734f1a566c47d$export$3ae0fd4797ed47c8, toFormData: $892734f1a566c47d$export$10ae0d317ea97f8b, AxiosHeaders: $892734f1a566c47d$export$4e7d6ff0f3e6520, HttpStatusCode: $892734f1a566c47d$export$a972f69c851492b3, formToJSON: $892734f1a566c47d$export$86d7c59254d6a2c9, getAdapter: $892734f1a566c47d$export$17ddc20a97d669e2, mergeConfig: $892734f1a566c47d$export$7ec1ebcfa9d8bd6a } = (0, $c4e1eb2fba6bd6ed$export$2e2bcd8739ae039);


var $02201000017ee191$exports = {};
"use strict";
const $02201000017ee191$var$denyList = new Set([
    "ENOTFOUND",
    "ENETUNREACH",
    // SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
    "UNABLE_TO_GET_ISSUER_CERT",
    "UNABLE_TO_GET_CRL",
    "UNABLE_TO_DECRYPT_CERT_SIGNATURE",
    "UNABLE_TO_DECRYPT_CRL_SIGNATURE",
    "UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY",
    "CERT_SIGNATURE_FAILURE",
    "CRL_SIGNATURE_FAILURE",
    "CERT_NOT_YET_VALID",
    "CERT_HAS_EXPIRED",
    "CRL_NOT_YET_VALID",
    "CRL_HAS_EXPIRED",
    "ERROR_IN_CERT_NOT_BEFORE_FIELD",
    "ERROR_IN_CERT_NOT_AFTER_FIELD",
    "ERROR_IN_CRL_LAST_UPDATE_FIELD",
    "ERROR_IN_CRL_NEXT_UPDATE_FIELD",
    "OUT_OF_MEM",
    "DEPTH_ZERO_SELF_SIGNED_CERT",
    "SELF_SIGNED_CERT_IN_CHAIN",
    "UNABLE_TO_GET_ISSUER_CERT_LOCALLY",
    "UNABLE_TO_VERIFY_LEAF_SIGNATURE",
    "CERT_CHAIN_TOO_LONG",
    "CERT_REVOKED",
    "INVALID_CA",
    "PATH_LENGTH_EXCEEDED",
    "INVALID_PURPOSE",
    "CERT_UNTRUSTED",
    "CERT_REJECTED",
    "HOSTNAME_MISMATCH"
]);
// TODO: Use `error?.code` when targeting Node.js 14
$02201000017ee191$exports = (error)=>!$02201000017ee191$var$denyList.has(error && error.code);


function $d49df7caa85fb2bf$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $d49df7caa85fb2bf$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $d49df7caa85fb2bf$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $d49df7caa85fb2bf$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $d49df7caa85fb2bf$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d49df7caa85fb2bf$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d49df7caa85fb2bf$var$ownKeys(Object(source), true).forEach(function(key) {
            $d49df7caa85fb2bf$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d49df7caa85fb2bf$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d49df7caa85fb2bf$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d49df7caa85fb2bf$export$76a88f7de6507443 = "axios-retry";
function $d49df7caa85fb2bf$export$476aa014e2fd89d5(error) {
    var CODE_EXCLUDE_LIST = [
        "ERR_CANCELED",
        "ECONNABORTED"
    ];
    return !error.response && Boolean(error.code) && // Prevents retrying cancelled requests
    !CODE_EXCLUDE_LIST.includes(error.code) && // Prevents retrying timed out & cancelled requests
    (0, (/*@__PURE__*/$parcel$interopDefault($02201000017ee191$exports)))(error) // Prevents retrying unsafe errors
    ;
}
var $d49df7caa85fb2bf$var$SAFE_HTTP_METHODS = [
    "get",
    "head",
    "options"
];
var $d49df7caa85fb2bf$var$IDEMPOTENT_HTTP_METHODS = $d49df7caa85fb2bf$var$SAFE_HTTP_METHODS.concat([
    "put",
    "delete"
]);
function $d49df7caa85fb2bf$export$5f1dc21fa925930b(error) {
    return error.code !== "ECONNABORTED" && (!error.response || error.response.status >= 500 && error.response.status <= 599);
}
function $d49df7caa85fb2bf$export$693cf906fd8817e5(error) {
    if (!error.config) // Cannot determine if the request can be retried
    return false;
    return $d49df7caa85fb2bf$export$5f1dc21fa925930b(error) && $d49df7caa85fb2bf$var$SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function $d49df7caa85fb2bf$export$d26799ad4978234d(error) {
    if (!error.config) // Cannot determine if the request can be retried
    return false;
    return $d49df7caa85fb2bf$export$5f1dc21fa925930b(error) && $d49df7caa85fb2bf$var$IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function $d49df7caa85fb2bf$export$606bf0a2b170eb2(error) {
    return $d49df7caa85fb2bf$export$476aa014e2fd89d5(error) || $d49df7caa85fb2bf$export$d26799ad4978234d(error);
}
/**
 * @return {number} - delay in milliseconds, always 0
 */ function $d49df7caa85fb2bf$var$noDelay() {
    return 0;
}
function $d49df7caa85fb2bf$export$ce2bf54576c66713() {
    var retryNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var error = arguments.length > 1 ? arguments[1] : undefined;
    var delayFactor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var delay = Math.pow(2, retryNumber) * delayFactor;
    var randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
    return delay + randomSum;
}
/**
 * Initializes and returns the retry state for the given request/config
 * @param  {AxiosRequestConfig} config
 * @return {Object}
 */ function $d49df7caa85fb2bf$var$getCurrentState(config) {
    var currentState = config[$d49df7caa85fb2bf$export$76a88f7de6507443] || {};
    currentState.retryCount = currentState.retryCount || 0;
    config[$d49df7caa85fb2bf$export$76a88f7de6507443] = currentState;
    return currentState;
}
/**
 * Returns the axios-retry options for the current request
 * @param  {AxiosRequestConfig} config
 * @param  {AxiosRetryConfig} defaultOptions
 * @return {AxiosRetryConfig}
 */ function $d49df7caa85fb2bf$var$getRequestOptions(config, defaultOptions) {
    return $d49df7caa85fb2bf$var$_objectSpread($d49df7caa85fb2bf$var$_objectSpread({}, defaultOptions), config[$d49df7caa85fb2bf$export$76a88f7de6507443]);
}
/**
 * @param  {Axios} axios
 * @param  {AxiosRequestConfig} config
 */ function $d49df7caa85fb2bf$var$fixConfig(axios, config) {
    if (axios.defaults.agent === config.agent) delete config.agent;
    if (axios.defaults.httpAgent === config.httpAgent) delete config.httpAgent;
    if (axios.defaults.httpsAgent === config.httpsAgent) delete config.httpsAgent;
}
/**
 * Checks retryCondition if request can be retried. Handles it's retruning value or Promise.
 * @param  {number} retries
 * @param  {Function} retryCondition
 * @param  {Object} currentState
 * @param  {Error} error
 * @return {boolean}
 */ function $d49df7caa85fb2bf$var$shouldRetry(_x, _x2, _x3, _x4) {
    return $d49df7caa85fb2bf$var$_shouldRetry.apply(this, arguments);
}
/**
 * Adds response interceptors to an axios instance to retry requests failed due to network issues
 *
 * @example
 *
 * import axios from 'axios';
 *
 * axiosRetry(axios, { retries: 3 });
 *
 * axios.get('http://example.com/test') // The first request fails and the second returns 'ok'
 *   .then(result => {
 *     result.data; // 'ok'
 *   });
 *
 * // Exponential back-off retry delay between requests
 * axiosRetry(axios, { retryDelay : axiosRetry.exponentialDelay});
 *
 * // Custom retry delay
 * axiosRetry(axios, { retryDelay : (retryCount) => {
 *   return retryCount * 1000;
 * }});
 *
 * // Also works with custom axios instances
 * const client = axios.create({ baseURL: 'http://example.com' });
 * axiosRetry(client, { retries: 3 });
 *
 * client.get('/test') // The first request fails and the second returns 'ok'
 *   .then(result => {
 *     result.data; // 'ok'
 *   });
 *
 * // Allows request-specific configuration
 * client
 *   .get('/test', {
 *     'axios-retry': {
 *       retries: 0
 *     }
 *   })
 *   .catch(error => { // The first request fails
 *     error !== undefined
 *   });
 *
 * @param {Axios} axios An axios instance (the axios object or one created from axios.create)
 * @param {Object} [defaultOptions]
 * @param {number} [defaultOptions.retries=3] Number of retries
 * @param {boolean} [defaultOptions.shouldResetTimeout=false]
 *        Defines if the timeout should be reset between retries
 * @param {Function} [defaultOptions.retryCondition=isNetworkOrIdempotentRequestError]
 *        A function to determine if the error can be retried
 * @param {Function} [defaultOptions.retryDelay=noDelay]
 *        A function to determine the delay between retry requests
 * @param {Function} [defaultOptions.onRetry=()=>{}]
 *        A function to get notified when a retry occurs
 * @return {{ requestInterceptorId: number, responseInterceptorId: number }}
 *        The ids of the interceptors added to the request and to the response (so they can be ejected at a later time)
 */ function $d49df7caa85fb2bf$var$_shouldRetry() {
    $d49df7caa85fb2bf$var$_shouldRetry = $d49df7caa85fb2bf$var$_asyncToGenerator(function*(retries, retryCondition, currentState, error) {
        var shouldRetryOrPromise = currentState.retryCount < retries && retryCondition(error); // This could be a promise
        if (typeof shouldRetryOrPromise === "object") try {
            var shouldRetryPromiseResult = yield shouldRetryOrPromise; // keep return true unless shouldRetryPromiseResult return false for compatibility
            return shouldRetryPromiseResult !== false;
        } catch (_err) {
            return false;
        }
        return shouldRetryOrPromise;
    });
    return $d49df7caa85fb2bf$var$_shouldRetry.apply(this, arguments);
}
function $d49df7caa85fb2bf$export$2e2bcd8739ae039(axios, defaultOptions) {
    var requestInterceptorId = axios.interceptors.request.use((config)=>{
        var currentState = $d49df7caa85fb2bf$var$getCurrentState(config);
        currentState.lastRequestTime = Date.now();
        return config;
    });
    var responseInterceptorId = axios.interceptors.response.use(null, /*#__PURE__*/ function() {
        var _ref = $d49df7caa85fb2bf$var$_asyncToGenerator(function*(error) {
            var { config: config } = error; // If we have no information to retry the request
            if (!config) return Promise.reject(error);
            var { retries: retries = 3, retryCondition: retryCondition = $d49df7caa85fb2bf$export$606bf0a2b170eb2, retryDelay: retryDelay = $d49df7caa85fb2bf$var$noDelay, shouldResetTimeout: shouldResetTimeout = false, onRetry: onRetry = ()=>{} } = $d49df7caa85fb2bf$var$getRequestOptions(config, defaultOptions);
            var currentState = $d49df7caa85fb2bf$var$getCurrentState(config);
            if (yield $d49df7caa85fb2bf$var$shouldRetry(retries, retryCondition, currentState, error)) {
                currentState.retryCount += 1;
                var delay = retryDelay(currentState.retryCount, error); // Axios fails merging this configuration to the default configuration because it has an issue
                // with circular structures: https://github.com/mzabriskie/axios/issues/370
                $d49df7caa85fb2bf$var$fixConfig(axios, config);
                if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
                    var lastRequestDuration = Date.now() - currentState.lastRequestTime;
                    var timeout = config.timeout - lastRequestDuration - delay;
                    if (timeout <= 0) return Promise.reject(error);
                    config.timeout = timeout;
                }
                config.transformRequest = [
                    (data)=>data
                ];
                yield onRetry(currentState.retryCount, error, config);
                return new Promise((resolve)=>setTimeout(()=>resolve(axios(config)), delay));
            }
            return Promise.reject(error);
        });
        return function(_x5) {
            return _ref.apply(this, arguments);
        };
    }());
    return {
        requestInterceptorId: requestInterceptorId,
        responseInterceptorId: responseInterceptorId
    };
} // Compatibility with CommonJS
$d49df7caa85fb2bf$export$2e2bcd8739ae039.isNetworkError = $d49df7caa85fb2bf$export$476aa014e2fd89d5;
$d49df7caa85fb2bf$export$2e2bcd8739ae039.isSafeRequestError = $d49df7caa85fb2bf$export$693cf906fd8817e5;
$d49df7caa85fb2bf$export$2e2bcd8739ae039.isIdempotentRequestError = $d49df7caa85fb2bf$export$d26799ad4978234d;
$d49df7caa85fb2bf$export$2e2bcd8739ae039.isNetworkOrIdempotentRequestError = $d49df7caa85fb2bf$export$606bf0a2b170eb2;
$d49df7caa85fb2bf$export$2e2bcd8739ae039.exponentialDelay = $d49df7caa85fb2bf$export$ce2bf54576c66713;
$d49df7caa85fb2bf$export$2e2bcd8739ae039.isRetryableError = $d49df7caa85fb2bf$export$5f1dc21fa925930b;


const $4ff1018a457d25d0$var$MAX_API_RETRY = 3;
const $4ff1018a457d25d0$var$BASE_URL_API_V1 = "/api/v1";
const $4ff1018a457d25d0$var$BASE_URL_SERVICES = "/services";
class $4ff1018a457d25d0$var$APIClient {
    constructor(){
        this.getFlags = async ()=>{
            return await this.client.get(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/flags`);
        };
        this.getAppTranslations = async (locale)=>{
            return await this.client.get(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/translate/${locale}/main`);
        };
        this.getSegmentTranslations = async (locale)=>{
            return await this.client.get(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/translate/${locale}/segment-info`);
        };
        // DEPRECATED: Use RTK Query's api, which caches user data
        this.getUser = async (userId)=>{
            return await this.client.get(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/users/${userId}`);
        };
        // Replaces (puts) the `data` object representing user settings
        this.putUserSettings = async (userId, payload)=>{
            return await this.client.put(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/users/${userId}`, payload);
        };
        // Patches user account information (if allowed)
        this.patchUser = async (userId, payload)=>{
            return await this.client.patch(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/users/${userId}`, payload);
        };
        this.deleteUserLoginToken = async (userId)=>{
            return await this.client.delete(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/users/${userId}/login-token`);
        };
        this.getGalleryForUser = async (userId)=>{
            return await this.client.get(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/users/${userId}/streets`);
        };
        // Optional config is allowed for situations where we need to send a
        // custom header
        this.getStreet = async (streetId, config = {})=>{
            return await this.client.get(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/streets/${streetId}`, config);
        };
        // Internally, getting street data with UUID (above) is preferred, but
        // public URLs provide only creator ID and namespaced ID for cleaner URLs.
        // Use this method if all we have are those
        this.getStreetWithParams = async (creatorId, namespacedId)=>{
            const params = new URLSearchParams({
                namespacedId: encodeURIComponent(namespacedId)
            });
            // creatorId can be undefined (e.g. anonymous streets)
            if (creatorId) params.append("creatorId", encodeURIComponent(creatorId));
            return await this.client.get(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/streets/?${params.toString()}`);
        };
        this.postStreet = async (payload)=>{
            return await this.client.post(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/streets`, payload);
        };
        this.putStreet = async (streetId, payload)=>{
            return await this.client.put(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/streets/${streetId}`, payload);
        };
        this.deleteStreet = async (streetId)=>{
            return await this.client.delete(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/streets/${streetId}`);
        };
        this.deleteStreetImage = async (streetId)=>{
            return await this.client.delete(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/streets/images/${streetId}`);
        };
        this.getGalleryForAllStreets = async ()=>{
            return await this.client.get(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/streets?count=200`);
        };
        this.getSentimentSurveyStreet = async ()=>{
            return await this.client.get(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/votes`);
        };
        this.postSentimentSurveyVote = async (payload)=>{
            return await this.client.post(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/votes`, payload);
        };
        this.putSentimentSurveyComment = async (payload)=>{
            return await this.client.put(`${$4ff1018a457d25d0$var$BASE_URL_API_V1}/votes`, payload);
        };
        this.getChangelog = async ()=>{
            return await this.client.get(`${$4ff1018a457d25d0$var$BASE_URL_SERVICES}/changelog`);
        };
        this.getGeoIp = async ()=>{
            return await this.client.get(`${$4ff1018a457d25d0$var$BASE_URL_SERVICES}/geoip`);
        };
        this.client = (0, $c4e1eb2fba6bd6ed$export$2e2bcd8739ae039).create({
            responseType: "json"
        });
        // Adds exponential backoff to requests
        (0, $d49df7caa85fb2bf$export$2e2bcd8739ae039)(this.client, {
            retries: $4ff1018a457d25d0$var$MAX_API_RETRY,
            retryDelay: (0, $d49df7caa85fb2bf$export$ce2bf54576c66713),
            onRetry: function(retryCount) {
                // Displays the "no connection" toast after maximum retry count
                // has been hit.
                // TODO: differentiate between "no internet connection"
                // and "server is down" errors.
                if (retryCount >= $4ff1018a457d25d0$var$MAX_API_RETRY) window.dispatchEvent(new window.CustomEvent("stmx:api_max_connection"));
            }
        });
    }
}
const $4ff1018a457d25d0$var$client = new $4ff1018a457d25d0$var$APIClient();
const { getFlags: $4ff1018a457d25d0$export$d5815430bcc75df0, getAppTranslations: $4ff1018a457d25d0$export$fdd8593485e9ccdf, getSegmentTranslations: $4ff1018a457d25d0$export$f53247e8d24ece1f, getUser: $4ff1018a457d25d0$export$7cbf767827cd68ba, putUserSettings: $4ff1018a457d25d0$export$3befcc9cfa75b6ee, patchUser: $4ff1018a457d25d0$export$bf950db3913272ff, getGalleryForUser: $4ff1018a457d25d0$export$7956c5d98062f5ca, deleteUserLoginToken: $4ff1018a457d25d0$export$4f0b80810ad83086, getStreet: $4ff1018a457d25d0$export$2dd550e2c4d39aa8, getStreetWithParams: $4ff1018a457d25d0$export$1a6b3c65eaa634f4, postStreet: $4ff1018a457d25d0$export$7a037a213e933b06, putStreet: $4ff1018a457d25d0$export$b77a954a15cadc5a, deleteStreet: $4ff1018a457d25d0$export$2f7a71aad44a0498, deleteStreetImage: $4ff1018a457d25d0$export$117f21e29661dcff, getGalleryForAllStreets: $4ff1018a457d25d0$export$1ec8042d33b4a69a, getSentimentSurveyStreet: $4ff1018a457d25d0$export$e4a64bc72c1553c4, postSentimentSurveyVote: $4ff1018a457d25d0$export$58f7aad3486f5b80, putSentimentSurveyComment: $4ff1018a457d25d0$export$4ce1f0e4022d30be, getChangelog: $4ff1018a457d25d0$export$52ce36ac14d2526d, getGeoIp: $4ff1018a457d25d0$export$d0f3c7c6645f9f65 } = $4ff1018a457d25d0$var$client;
var $4ff1018a457d25d0$export$2e2bcd8739ae039 = $4ff1018a457d25d0$var$client;


const $0083fa256c596554$var$initialState = {
    locale: (0, $b8c344dce25738f3$export$1af4c7e47ad72f44),
    messages: {},
    segmentInfo: {},
    isLoading: false,
    requestedLocale: null
};
function $0083fa256c596554$var$flattenObject(obj) {
    const toReturn = {};
    let flatObject;
    Object.keys(obj).forEach((i)=>{
        if (typeof obj[i] === "object" && !Array.isArray(obj[i])) {
            flatObject = $0083fa256c596554$var$flattenObject(obj[i]);
            Object.keys(flatObject).forEach((x)=>{
                toReturn[i + "." + x] = flatObject[x];
            });
        } else toReturn[i] = obj[i];
    });
    return toReturn;
}
const $0083fa256c596554$export$7343075cd7f756c5 = (0, $a3ccb5670e466352$export$6abd22dc03e5063f)("locale/changeLocale", async (locale)=>{
    const messages = await (0, $4ff1018a457d25d0$export$fdd8593485e9ccdf)(locale);
    const segmentInfo = await (0, $4ff1018a457d25d0$export$f53247e8d24ece1f)(locale);
    return {
        locale: locale,
        translation: {
            messages: messages.data,
            segmentInfo: segmentInfo.data
        }
    };
});
const $0083fa256c596554$var$localeSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "locale",
    initialState: $0083fa256c596554$var$initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($0083fa256c596554$export$7343075cd7f756c5.pending, (state, action)=>{
            state.isLoading = true;
            state.requestedLocale = action.meta.arg;
        }).addCase($0083fa256c596554$export$7343075cd7f756c5.fulfilled, (state, action)=>{
            const { locale: locale, translation: translation } = action.payload;
            const { messages: messages, segmentInfo: segmentInfo = {} } = translation;
            state.locale = locale;
            state.messages = $0083fa256c596554$var$flattenObject(messages);
            state.segmentInfo = $0083fa256c596554$var$flattenObject(segmentInfo);
            state.isLoading = false;
            state.requestedLocale = null;
            const el = document.querySelector("html");
            if (el) el.lang = locale;
        }).addCase($0083fa256c596554$export$7343075cd7f756c5.rejected, (state)=>{
            state.isLoading = false;
            state.requestedLocale = null;
        });
    }
});
var $0083fa256c596554$export$2e2bcd8739ae039 = $0083fa256c596554$var$localeSlice.reducer;


const $9dbab908c178b0dc$var$initialState = {
    readOnly: false,
    printing: false,
    everythingLoaded: false,
    contentDirection: "ltr",
    // Used to remember the "last street" ID when making a copy of a street
    // looked at in a previous tab. Its value is copied from the `lastStreetId`
    // value from the `settings` reducer, so that it can be remembered
    priorLastStreetId: null
};
const $9dbab908c178b0dc$var$appSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "app",
    initialState: $9dbab908c178b0dc$var$initialState,
    reducers: {
        setAppFlags (state, action) {
            return {
                ...state,
                ...action.payload
            };
        },
        startPrinting (state) {
            state.printing = true;
        },
        stopPrinting (state) {
            state.printing = false;
        },
        everythingLoaded (state) {
            state.everythingLoaded = true;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase((0, $0083fa256c596554$export$7343075cd7f756c5).fulfilled, (state, action)=>{
            const direction = [
                "ar",
                "dv",
                "fa",
                "he"
            ].includes(action.payload.locale) ? "rtl" : "ltr";
            state.contentDirection = direction;
        });
    }
});
const { setAppFlags: $9dbab908c178b0dc$export$af2e4444750bad23, startPrinting: $9dbab908c178b0dc$export$e000c6e7623fb0b, stopPrinting: $9dbab908c178b0dc$export$616269833dda0c1, everythingLoaded: $9dbab908c178b0dc$export$eef62c34974c5385 } = $9dbab908c178b0dc$var$appSlice.actions;
var $9dbab908c178b0dc$export$2e2bcd8739ae039 = $9dbab908c178b0dc$var$appSlice.reducer;



const $5bcb824489dec0b9$var$initialState = {
    forceLeftHandTraffic: false,
    forceNonRetina: false,
    forceOfflineMode: false,
    forceReadOnly: false
};
const $5bcb824489dec0b9$var$debugSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "debug",
    initialState: $5bcb824489dec0b9$var$initialState,
    reducers: {
        setDebugFlags (state, action) {
            return {
                ...state,
                ...action.payload
            };
        }
    }
});
const { setDebugFlags: $5bcb824489dec0b9$export$8a1358e3ea016db0 } = $5bcb824489dec0b9$var$debugSlice.actions;
var $5bcb824489dec0b9$export$2e2bcd8739ae039 = $5bcb824489dec0b9$var$debugSlice.reducer;



// It may be desirable to simplify the shape of this state object
// to just a string - see the menus state for example.
// This used to have more properties in an earlier implementation,
// and is currently selected as a prop object by the <DialogRoot>
// component, which means this can't be refactored until that is.
const $cdf0aaca62d15025$var$initialState = {
    name: null
};
const $cdf0aaca62d15025$var$dialogsSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "dialogs",
    initialState: $cdf0aaca62d15025$var$initialState,
    reducers: {
        showDialog (state, action) {
            state.name = action.payload;
        },
        clearDialogs (state, action) {
            state.name = null;
        }
    }
});
const { showDialog: $cdf0aaca62d15025$export$61e0a65f251cfdb3, clearDialogs: $cdf0aaca62d15025$export$8c29086285c64d2d } = $cdf0aaca62d15025$var$dialogsSlice.actions;
var $cdf0aaca62d15025$export$2e2bcd8739ae039 = $cdf0aaca62d15025$var$dialogsSlice.reducer;



const $5e173785b5fcb8ed$var$initialState = {
    errorType: null,
    abortEverything: false
};
const $5e173785b5fcb8ed$var$errorsSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "errors",
    initialState: $5e173785b5fcb8ed$var$initialState,
    reducers: {
        showError: {
            reducer (state, action) {
                state.errorType = action.payload.errorType;
                state.abortEverything = action.payload.abortEverything || false;
            },
            prepare (errorType, abortEverything) {
                return {
                    payload: {
                        errorType: errorType,
                        abortEverything: abortEverything
                    }
                };
            }
        },
        hideError (state, action) {
            state.errorType = null;
            state.abortEverything = false;
        }
    }
});
const { showError: $5e173785b5fcb8ed$export$3879b24e8245693d, hideError: $5e173785b5fcb8ed$export$ef18f38624819fc7 } = $5e173785b5fcb8ed$var$errorsSlice.actions;
var $5e173785b5fcb8ed$export$2e2bcd8739ae039 = $5e173785b5fcb8ed$var$errorsSlice.reducer;



var $1a20834c9368169a$exports = {};
$1a20834c9368169a$exports = JSON.parse('{"COLOR_MODE_TOGGLE":{"label":"UI \u2014 Color mode (e.g. dark mode) themes","defaultValue":false},"GEOTAG":{"label":"UI \u2014 Geotagging","defaultValue":true},"ANALYTICS":{"label":"UI \u2014 Street analytics","defaultValue":true},"EDIT_STREET_WIDTH":{"label":"UI \u2014 Edit street width","defaultValue":true},"EDIT_STREET_NAME":{"label":"UI \u2014 Edit street name","defaultValue":true},"EDIT_BUILDINGS_LEFT":{"label":"UI \u2014 Edit left-side buildings","defaultValue":true},"EDIT_BUILDINGS_RIGHT":{"label":"UI \u2014 Edit right-side buildings","defaultValue":true},"SENTIMENT_SURVEY":{"label":"Survey sentiment","defaultValue":true},"ENVIRONMENT_ANIMATIONS":{"label":"Environment animations","defaultValue":false},"SAVE_UNDO":{"label":"Save undo data to server","defaultValue":false,"enabled":false},"INFO_BUBBLE_HOVER_POLYGON":{"label":"Info bubble \u2014 [debug] show Tognazzini zone","defaultValue":false},"ELEVATION_CONTROLS_UNLOCKED":{"label":"Info bubble \u2014 elevation property controls (unlocked)","defaultValue":false},"LOCALES_LEVEL_1":{"label":"Locales \u2014 level 1+ (in progress)","defaultValue":false},"LOCALES_LEVEL_2":{"label":"Locales \u2014 level 2+ (complete, in testing)","defaultValue":false},"LOCALES_LEVEL_3":{"label":"Locales \u2014 level 3 (complete, final)","defaultValue":true},"SEGMENT_3D_PARKING":{"label":"Segment \u2014 3d angled parking","defaultValue":false,"enabled":false},"SEGMENT_CROSSWALK":{"label":"Segment \u2014 crosswalk","defaultValue":false},"SEGMENT_DRAINAGE_CHANNEL_UNLOCKED":{"label":"Segment \u2014 drainage channel (unlocked)","defaultValue":false},"SEGMENT_INCEPTION_TRAIN":{"label":"Segment \u2014 the train from \u201CInception\u201D","defaultValue":false},"VARIANT_MIXED_DRIVE_LANES_1":{"label":"Variant \u2014 mixed-traffic drive lane (with bus) (unlocked)","defaultValue":false},"VARIANT_MIXED_DRIVE_LANES_2":{"label":"Variant \u2014 mixed-traffic drive lane (with bike) (unlocked)","defaultValue":false},"VARIANT_TWOWAY_BIKES":{"label":"Variant \u2014 two-way bike lanes (enabled)","defaultValue":true},"VARIANT_TWOWAY_BIKES_UNLOCKED":{"label":"Variant \u2014 two-way bike lanes (unlocked)","defaultValue":false},"DEBUG_SEGMENT_CANVAS_RECTANGLES":{"label":"Segment \u2014 [debug] canvas rectangles","defaultValue":false},"SAVE_AS_IMAGE_CUSTOM_DPI":{"label":"Save images at custom scale","defaultValue":false},"ALWAYS_DISPLAY_WHATS_NEW":{"label":"Always display the What\u2019s New dialog","defaultValue":false},"SILLY_CLOWNS":{"label":"Silly clowns","defaultValue":false}}');



function $1ac426dbdd197303$var$generateInitialFlags(flags) {
    return Object.entries(flags).reduce((obj, item)=>{
        const [key, value] = item;
        obj[key] = {
            // Keep all original properties
            ...value,
            // Add new ones
            value: value.defaultValue,
            source: "initial"
        };
        return obj;
    }, {});
}
const $1ac426dbdd197303$export$a20893735c88ec6c = (0, $a3ccb5670e466352$export$6abd22dc03e5063f)("flags/getInitialFlags", async ()=>{
    const response = await (0, $4ff1018a457d25d0$export$d5815430bcc75df0)();
    return response.data;
});
const $1ac426dbdd197303$var$flagsSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "flags",
    // TODO: Remove static initial flag setting and only rely on API
    // can't be removed right now because there are other dependencies of this
    initialState: $1ac426dbdd197303$var$generateInitialFlags((0, (/*@__PURE__*/$parcel$interopDefault($1a20834c9368169a$exports)))),
    reducers: {
        setFeatureFlag (state, action) {
            const flag = state[action.payload.flag];
            state[action.payload.flag] = {
                ...flag,
                value: action.payload.value,
                source: "session"
            };
        },
        setFlagOverrides (state, action) {
            return {
                ...state,
                ...action.payload
            };
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($1ac426dbdd197303$export$a20893735c88ec6c.fulfilled, (state, action)=>{
            state = $1ac426dbdd197303$var$generateInitialFlags(action.payload);
        });
    }
});
const { setFeatureFlag: $1ac426dbdd197303$export$4672beabf7ff6568, setFlagOverrides: $1ac426dbdd197303$export$777418efeb425152 } = $1ac426dbdd197303$var$flagsSlice.actions;
var $1ac426dbdd197303$export$2e2bcd8739ae039 = $1ac426dbdd197303$var$flagsSlice.reducer;



const $11a2d10829f32488$var$initialState = {
    visible: false,
    instant: false,
    userId: null,
    mode: "none",
    streets: []
};
const $11a2d10829f32488$export$b0805fae593918eb = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "gallery",
    initialState: $11a2d10829f32488$var$initialState,
    reducers: {
        showGallery (state, action) {
            state.visible = true;
            state.userId = action.payload;
            state.mode = "none";
        },
        hideGallery (state, action) {
            state.visible = false;
        },
        deleteGalleryStreet (state, action) {
            state.streets = state.streets.filter((street)=>{
                return street.id !== action.payload;
            });
        },
        setGalleryUserId (state, action) {
            state.userId = action.payload;
        }
    },
    extraReducers: (builder)=>{
        // Referring to these action types by string instead of the generated
        // variables is because importing the action module during store/slice
        // creation will import other dependent modules too early. We can also
        // solve this by declaring action types in a separate file (similar to
        // basic Redux syntax)
        builder.addCase("gallery/openGallery/pending", (state, action)=>{
            state.visible = true;
            state.instant = action.meta.arg.instant ?? false;
            state.userId = action.meta.arg.userId ?? null;
            state.mode = "loading";
        }).addCase("gallery/openGallery/fulfilled", (state, action)=>{
            state.mode = "gallery";
            state.streets = action.payload.streets;
        }).addCase("gallery/openGallery/rejected", (state, action)=>{
            // Log this error because otherwise it's swallowed
            console.error("gallery/openGallery/rejected", action.error.stack);
            state.mode = "error";
            // A rejection occurs with an optional value. The `killGallery` value
            // can be sent, which means we want to close the gallery immediately.
            // If the rejection occurs without a value, then `action.payload` will
            // be undefined.
            if (action.payload?.killGallery === true) {
                state.visible = false;
                state.instant = true;
            }
        }).addCase("gallery/closeGallery/fulfilled", (state, action)=>{
            state.visible = false;
            state.instant = action.payload.instant ?? false;
        }).addCase("gallery/closeGallery/rejected", (state, action)=>{
            // Log this error because otherwise it's swallowed
            console.error("gallery/closeGallery/rejected", action.error.stack);
        });
    }
});
const { showGallery: $11a2d10829f32488$export$1f7a8438a694c61f, hideGallery: $11a2d10829f32488$export$2da3e68033eaa011, deleteGalleryStreet: $11a2d10829f32488$export$242a355b0f5dc10e, setGalleryUserId: $11a2d10829f32488$export$dba372f8d7162f61 } = $11a2d10829f32488$export$b0805fae593918eb.actions;
var $11a2d10829f32488$export$2e2bcd8739ae039 = $11a2d10829f32488$export$b0805fae593918eb.reducer;




const $fae5ee319b50e8ae$export$3ad672c487977d14 = (0, $a3ccb5670e466352$export$6abd22dc03e5063f).withTypes();



const $d00d4a7cfa2eb020$var$initialState = {
    visible: false,
    mouseInside: false,
    descriptionVisible: false,
    hoverPolygon: []
};
const $d00d4a7cfa2eb020$export$66b6779e6c2fa2a = (0, $fae5ee319b50e8ae$export$3ad672c487977d14)("infoBubble/showInfoBubble", (_, { dispatch: dispatch })=>{
    dispatch($d00d4a7cfa2eb020$var$infoBubbleSlice.actions.show());
}, {
    condition: (_, { getState: getState })=>{
        if (getState().infoBubble.visible) return false;
    }
});
const $d00d4a7cfa2eb020$export$7f56ba0a026268ef = (0, $fae5ee319b50e8ae$export$3ad672c487977d14)("infoBubble/showInfoBubble", (_, { dispatch: dispatch })=>{
    dispatch($d00d4a7cfa2eb020$var$infoBubbleSlice.actions.hide());
}, {
    condition: (_, { getState: getState })=>{
        if (!getState().infoBubble.visible) return false;
    }
});
const $d00d4a7cfa2eb020$var$infoBubbleSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "infoBubble",
    initialState: $d00d4a7cfa2eb020$var$initialState,
    reducers: {
        show (state) {
            state.visible = true;
            // When show is requested, hide description
            state.descriptionVisible = false;
        },
        hide (state) {
            state.visible = false;
            state.descriptionVisible = false;
            state.mouseInside = false;
        },
        updateHoverPolygon (state, action) {
            state.hoverPolygon = action.payload;
        },
        setInfoBubbleMouseInside (state, action) {
            state.mouseInside = action.payload;
        },
        showDescription (state) {
            state.descriptionVisible = true;
        },
        hideDescription (state) {
            state.descriptionVisible = false;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase((0, $9dbab908c178b0dc$export$e000c6e7623fb0b), (state)=>{
            state.visible = false;
            state.descriptionVisible = false;
            state.mouseInside = false;
        });
    }
});
const { show: $d00d4a7cfa2eb020$export$57bf213be019eeb0, hide: $d00d4a7cfa2eb020$export$fe8985bb6374093c, updateHoverPolygon: $d00d4a7cfa2eb020$export$444e9dbe49f408c2, setInfoBubbleMouseInside: $d00d4a7cfa2eb020$export$627024eef420e1c1, showDescription: $d00d4a7cfa2eb020$export$cc5a1e335d2e250d, hideDescription: $d00d4a7cfa2eb020$export$5a112bdb8c45cc8d } = $d00d4a7cfa2eb020$var$infoBubbleSlice.actions;
var $d00d4a7cfa2eb020$export$2e2bcd8739ae039 = $d00d4a7cfa2eb020$var$infoBubbleSlice.reducer;





var $27f7c30d8d4181dc$exports = {};
$27f7c30d8d4181dc$exports = JSON.parse('{"sidewalk":{"name":"Sidewalk","nameKey":"sidewalk","owner":"PEDESTRIAN","zIndex":30,"defaultWidth":6,"rules":{"minWidth":6},"defaultElevation":1,"enableElevation":true,"variants":["sidewalk-density"],"details":{"dense":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"vehicles":[{"id":"pedestrian","variants":{"density":"dense"}}]}},"normal":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"vehicles":[{"id":"pedestrian","variants":{"density":"normal"}}]}},"sparse":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"vehicles":[{"id":"pedestrian","variants":{"density":"sparse"}}]}},"empty":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}]}}}},"sidewalk-tree":{"name":"Sidewalk tree","nameKey":"sidewalk-tree","owner":"NATURE","zIndex":22,"defaultWidth":4,"variants":["tree-type"],"details":{"big":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"tree","variants":{"type":"big"}}]}},"palm-tree":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"tree","variants":{"type":"palm-tree"}}]}}}},"sidewalk-bike-rack":{"name":"Bike rack","nameKey":"bike-rack","owner":"BIKE","zIndex":23,"defaultWidth":5,"defaultVariant":"left|sidewalk","variants":["orientation","bike-rack-elevation"],"details":{"left|sidewalk-parallel":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"bike-rack","variants":{"direction|orientation":["parallel","left"]}}]}},"right|sidewalk-parallel":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"bike-rack","variants":{"direction|orientation":["parallel","right"]}}]}},"left|sidewalk":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"bike-rack","variants":{"direction|orientation":["perpendicular","left"]}}]}},"right|sidewalk":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"bike-rack","variants":{"direction|orientation":["perpendicular","right"]}}]}},"left|road":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"objects":[{"id":"bike-rack","variants":{"direction|orientation":["perpendicular","left"]}}]}},"right|road":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"objects":[{"id":"bike-rack","variants":{"direction|orientation":["perpendicular","right"]}}]}}}},"sidewalk-bench":{"name":"Bench","nameKey":"bench","owner":"PEDESTRIAN","zIndex":24,"defaultWidth":4,"variants":["bench-orientation"],"details":{"left":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"bench","variants":{"orientation":"left"}}]}},"center":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"bench","variants":{"orientation":"center"}}]}},"right":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"bench","variants":{"orientation":"right"}}]}}}},"outdoor-dining":{"name":"Outdoor dining","nameKey":"outdoor-dining","owner":"PEDESTRIAN","zIndex":24,"defaultWidth":8,"unlockCondition":"SIGN_IN","variants":["occupants","elevation"],"details":{"occupied|sidewalk":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"outdoor-dining","variants":{"occupants":"occupied"}}]}},"empty|sidewalk":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"outdoor-dining","variants":{"occupants":"empty"}}]}},"occupied|road":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left"},{"id":"markings--lane-right"}],"objects":[{"id":"outdoor-dining","variants":{"occupants":"occupied"}}]}},"empty|road":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left"},{"id":"markings--lane-right"}],"objects":[{"id":"outdoor-dining","variants":{"occupants":"empty"}}]}}}},"sidewalk-wayfinding":{"name":"Wayfinding sign","nameKey":"wayfinding-sign","owner":"PEDESTRIAN","zIndex":21,"defaultWidth":4,"description":{"key":"wayfinding-sign","image":"wayfinding-02.jpg"},"variants":["wayfinding-type"],"details":{"large":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"wayfinding-sign","variants":{"type":"large"}}]}},"medium":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"wayfinding-sign","variants":{"type":"medium"}}]}},"small":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"wayfinding-sign","variants":{"type":"small"}}]}}}},"sidewalk-lamp":{"name":"Lamp","nameKey":"sidewalk-lamp","owner":"PEDESTRIAN","zIndex":19,"defaultWidth":4,"defaultVariant":"both|traditional","variants":["lamp-orientation","lamp-type"],"details":{"right|modern":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"lamp","variants":{"type|orientation":["modern","right"]}}]}},"both|modern":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"lamp","variants":{"type|orientation":["modern","both"]}}]}},"left|modern":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"lamp","variants":{"type|orientation":["modern","left"]}}]}},"right|traditional":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"lamp","variants":{"type|orientation":["traditional","right"]}}]}},"both|traditional":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"lamp","variants":{"type|orientation":["traditional","both"]}}]}},"left|traditional":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"lamp","variants":{"type|orientation":["traditional","left"]}}]}},"right|pride":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"lamp","variants":{"type|orientation":["modern","right"]}},{"id":"pride-banner","variants":{"orientation":"right"}}]}},"left|pride":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"lamp","variants":{"type|orientation":["modern","left"]}},{"id":"pride-banner","variants":{"orientation":"left"}}]}},"both|pride":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"lamp","variants":{"type|orientation":["modern","both"]}},{"id":"pride-banner","variants":{"orientation":"both"}}]}}}},"utilities":{"name":"Utility pole","nameKey":"utility-pole","owner":"NONE","zIndex":10,"defaultWidth":4,"unlockCondition":"SIGN_IN","variants":["orientation"],"details":{"left":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"utility-pole","variants":{"orientation":"left"}}]}},"right":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"utility-pole","variants":{"orientation":"right"}}]}}}},"parklet":{"name":"Parklet","nameKey":"parklet","owner":"NATURE","zIndex":15,"defaultWidth":8,"description":{"key":"parklet","image":"parklets-01.jpg"},"rules":{"minWidth":8},"variants":["orientation"],"details":{"left":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"objects":[{"id":"parklet","variants":{"orientation":"left"}}]}},"right":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"objects":[{"id":"parklet","variants":{"orientation":"right"}}]}}}},"street-vendor":{"name":"Street vendor","nameKey":"street-vendor","owner":"PEDESTRIAN","zIndex":24,"defaultWidth":4,"rules":{"minWidth":4},"defaultElevation":1,"enableElevation":true,"unlockCondition":"SIGN_IN","defaultVariant":"table|concrete","variants":["vendor-type","ground"],"details":{"handcart|concrete":{"rules":{"minWidth":3},"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"street-vendor","variants":{"vendor-type":"handcart"}}]}},"table|concrete":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"street-vendor","variants":{"vendor-type":"table"}}]}},"tarp|concrete":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"street-vendor","variants":{"vendor-type":"tarp"}}]}},"platform|concrete":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"street-vendor","variants":{"vendor-type":"platform"}}]}},"handcart|asphalt":{"rules":{"minWidth":3},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"objects":[{"id":"street-vendor","variants":{"vendor-type":"handcart"}}]}},"table|asphalt":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"objects":[{"id":"street-vendor","variants":{"vendor-type":"table"}}]}},"tarp|asphalt":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"objects":[{"id":"street-vendor","variants":{"vendor-type":"tarp"}}]}},"platform|asphalt":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"objects":[{"id":"street-vendor","variants":{"vendor-type":"platform"}}]}}}},"divider":{"name":"Buffer","nameKey":"divider","owner":"NATURE","zIndex":20,"defaultWidth":2,"defaultVariant":"flowers","variants":["divider-type"],"details":{"planting-strip":{"name":"Planting strip","nameKey":"planting-strip","components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"planting-strip","variants":{"type":"grass"}}]}},"planter-box":{"name":"Planter box","nameKey":"planter-box","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--stripes-diagonal"},{"id":"markings--lane-left"},{"id":"markings--lane-right"}],"objects":[{"id":"planter-box","variants":{"type":"default"}}]}},"median":{"name":"Median","nameKey":"median","components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}]}},"striped-buffer":{"name":"Buffer","nameKey":"divider","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--stripes-diagonal"},{"id":"markings--lane-left"},{"id":"markings--lane-right"}]}},"bush":{"name":"Planting strip","nameKey":"planting-strip","components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"planting-strip","variants":{"type":"grass"}},{"id":"planting-strip","variants":{"type":"bush"}}]}},"flowers":{"name":"Planting strip","nameKey":"planting-strip","components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"planting-strip","variants":{"type":"grass"}},{"id":"planting-strip","variants":{"type":"flowers"}}]}},"big-tree":{"name":"Planting strip","nameKey":"planting-strip","components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"planting-strip","variants":{"type":"grass"}},{"id":"tree","variants":{"type":"big"}}]}},"palm-tree":{"name":"Planting strip","nameKey":"planting-strip","components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"planting-strip","variants":{"type":"grass"}},{"id":"tree","variants":{"type":"palm-tree"}}]}},"bollard":{"name":"Bollard","nameKey":"bollard","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--stripes-diagonal"},{"id":"markings--lane-left"},{"id":"markings--lane-right"}],"objects":[{"id":"bollard","variants":{"type":"default"}}]}},"dome":{"name":"Traffic exclusion dome","nameKey":"dome","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--stripes-diagonal"},{"id":"markings--lane-left"},{"id":"markings--lane-right"}],"objects":[{"id":"dome","variants":{"type":"default"}}]}}}},"crosswalk":{"name":"Crosswalk","nameKey":"crosswalk","defaultWidth":10,"defaultVariant":"zebra-crossing","defaultElevation":0,"enableElevation":true,"enableWithFlag":"SEGMENT_CROSSWALK","variants":["crosswalk-type"],"details":{"zebra-crossing":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--crosswalk-zebra"}]}},"zebra-crossing-bike":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--crosswalk-zebra-bike"}]}}}},"temporary":{"name":"Temporary barrier","nameKey":"temporary-barrier","zIndex":20,"defaultWidth":2,"defaultVariant":"traffic-cone","unlockCondition":"SIGN_IN","variants":["temporary-barrier-type"],"details":{"barricade":{"name":"Barricade","nameKey":"barricade","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"objects":[{"id":"barricade","variants":{"type":"default"}}]}},"traffic-cone":{"name":"Traffic cone","nameKey":"traffic-cone","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"objects":[{"id":"traffic-cone","variants":{"type":"default"}}]}},"jersey-barrier-concrete":{"name":"Jersey barrier","nameKey":"jersey-barrier","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"objects":[{"id":"jersey-barrier","variants":{"material":"concrete"}}]}},"jersey-barrier-plastic":{"name":"Jersey barrier","nameKey":"jersey-barrier","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"objects":[{"id":"jersey-barrier","variants":{"material":"plastic"}}]}}}},"drainage-channel":{"name":"Drainage channel","nameKey":"drainage-channel","owner":"UTILITY","unlockWithFlag":"SEGMENT_DRAINAGE_CHANNEL_UNLOCKED","unlockCondition":"SUBSCRIBE","defaultWidth":3.333,"variants":["drainage-sides"],"details":{"slanted":{"components":{"lanes":[{"id":"drainage","variants":{"color":"regular"}}],"objects":[{"id":"open-drain","variants":{"drainage-sides":["slanted"]}}]}},"vertical":{"components":{"lanes":[{"id":"drainage","variants":{"color":"regular"}}],"objects":[{"id":"open-drain","variants":{"drainage-sides":["vertical"]}}]}}}},"scooter":{"name":"Electric scooter","nameKey":"scooter","owner":"BIKE","zIndex":16,"defaultWidth":5,"rules":{"minWidth":4},"variants":["direction","bike-asphalt"],"details":{"inbound|regular":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"scooter","variants":{"direction":"inbound"}}]}},"outbound|regular":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"scooter","variants":{"direction":"outbound"}}]}},"inbound|green":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"green"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"scooter","variants":{"direction":"inbound"}}]}},"outbound|green":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"green"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"scooter","variants":{"direction":"outbound"}}]}},"inbound|red":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"scooter","variants":{"direction":"inbound"}}]}},"outbound|red":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"scooter","variants":{"direction":"outbound"}}]}}}},"scooter-drop-zone":{"name":"Scooter drop zone","nameKey":"scooter-drop-zone","owner":"FLEX","zIndex":21,"defaultWidth":5,"defaultVariant":"right|sidewalk|empty","variants":["orientation","scooter-elevation","scooter-riders"],"details":{"left|sidewalk|empty":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left-half"},{"id":"markings--lane-right-half"},{"id":"markings--lane-horiz"}],"vehicles":[{"id":"scooter","variants":{"riders|orientation":["empty","left"]}}]}},"right|sidewalk|empty":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left-half"},{"id":"markings--lane-right-half"},{"id":"markings--lane-horiz"}],"vehicles":[{"id":"scooter","variants":{"riders|orientation":["empty","right"]}}]}},"left|sidewalk|sparse":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left-half"},{"id":"markings--lane-right-half"},{"id":"markings--lane-horiz"}],"vehicles":[{"id":"scooter","variants":{"riders|orientation":["sparse","left"]}}]}},"right|sidewalk|sparse":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left-half"},{"id":"markings--lane-right-half"},{"id":"markings--lane-horiz"}],"vehicles":[{"id":"scooter","variants":{"riders|orientation":["sparse","right"]}}]}},"left|road|empty":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left-half"},{"id":"markings--lane-right-half"},{"id":"markings--lane-horiz"}],"vehicles":[{"id":"scooter","variants":{"riders|orientation":["empty","left"]}}]}},"right|road|empty":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left-half"},{"id":"markings--lane-right-half"},{"id":"markings--lane-horiz"}],"vehicles":[{"id":"scooter","variants":{"riders|orientation":["empty","right"]}}]}},"left|road|sparse":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left-half"},{"id":"markings--lane-right-half"},{"id":"markings--lane-horiz"}],"vehicles":[{"id":"scooter","variants":{"riders|orientation":["sparse","left"]}}]}},"right|road|sparse":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left-half"},{"id":"markings--lane-right-half"},{"id":"markings--lane-horiz"}],"vehicles":[{"id":"scooter","variants":{"riders|orientation":["sparse","right"]}}]}}}},"bike-lane":{"name":"Bike lane","nameKey":"bike-lane","owner":"BIKE","zIndex":16,"defaultWidth":6,"description":{"key":"bike-lane","image":"bike-lane-02.jpg"},"rules":{"minWidth":5},"variants":["bike-direction","bike-asphalt","elevation"],"details":{"inbound|regular|road":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-01","inbound"]}}]}},"outbound|regular|road":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-01","outbound"]}}]}},"twoway-left|regular|road":{"name":"Two-way bike lane","nameKey":"twoway-bike-lane","rules":{"minWidth":10},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--twoway-left"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-02","inbound"]},"offsetX":"-50%"},{"id":"bike","variants":{"type|direction":["biker-01","outbound"]},"offsetX":"50%"}]}},"twoway-right|regular|road":{"name":"Two-way bike lane","nameKey":"twoway-bike-lane","rules":{"minWidth":10},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--twoway-right"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-02","inbound"]},"offsetX":"50%"},{"id":"bike","variants":{"type|direction":["biker-01","outbound"]},"offsetX":"-50%"}]}},"inbound|green|road":{"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"asphalt","variants":{"color":"green"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-01","inbound"]}}]}},"outbound|green|road":{"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"asphalt","variants":{"color":"green"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-01","outbound"]}}]}},"twoway-left|green|road":{"name":"Two-way bike lane","nameKey":"twoway-bike-lane","rules":{"minWidth":10},"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"asphalt","variants":{"color":"green"}}],"markings":[{"id":"markings--twoway-left"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-02","inbound"]},"offsetX":"-50%"},{"id":"bike","variants":{"type|direction":["biker-01","outbound"]},"offsetX":"50%"}]}},"twoway-right|green|road":{"name":"Two-way bike lane","nameKey":"twoway-bike-lane","rules":{"minWidth":10},"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"asphalt","variants":{"color":"green"}}],"markings":[{"id":"markings--twoway-right"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-02","inbound"]},"offsetX":"50%"},{"id":"bike","variants":{"type|direction":["biker-01","outbound"]},"offsetX":"-50%"}]}},"inbound|red|road":{"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-01","inbound"]}}]}},"outbound|red|road":{"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-01","outbound"]}}]}},"twoway-left|red|road":{"name":"Two-way bike lane","nameKey":"twoway-bike-lane","rules":{"minWidth":10},"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--twoway-left"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-02","inbound"]},"offsetX":"-50%"},{"id":"bike","variants":{"type|direction":["biker-01","outbound"]},"offsetX":"50%"}]}},"twoway-right|red|road":{"name":"Two-way bike lane","nameKey":"twoway-bike-lane","rules":{"minWidth":10},"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--twoway-right"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-02","inbound"]},"offsetX":"50%"},{"id":"bike","variants":{"type|direction":["biker-01","outbound"]},"offsetX":"-50%"}]}},"inbound|regular|sidewalk":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"black"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-01","inbound"]}}]}},"outbound|regular|sidewalk":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"black"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-01","outbound"]}}]}},"twoway-left|regular|sidewalk":{"name":"Two-way bike lane","nameKey":"twoway-bike-lane","rules":{"minWidth":10},"components":{"lanes":[{"id":"sidewalk","variants":{"color":"black"}}],"markings":[{"id":"markings--twoway-left"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-02","inbound"]},"offsetX":"-50%"},{"id":"bike","variants":{"type|direction":["biker-01","outbound"]},"offsetX":"50%"}]}},"twoway-right|regular|sidewalk":{"name":"Two-way bike lane","nameKey":"twoway-bike-lane","rules":{"minWidth":10},"components":{"lanes":[{"id":"sidewalk","variants":{"color":"black"}}],"markings":[{"id":"markings--twoway-right"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-02","inbound"]},"offsetX":"50%"},{"id":"bike","variants":{"type|direction":["biker-01","outbound"]},"offsetX":"-50%"}]}},"inbound|green|sidewalk":{"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"sidewalk","variants":{"color":"green"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-01","inbound"]}}]}},"outbound|green|sidewalk":{"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"sidewalk","variants":{"color":"green"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-01","outbound"]}}]}},"twoway-left|green|sidewalk":{"name":"Two-way bike lane","nameKey":"twoway-bike-lane","rules":{"minWidth":10},"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"sidewalk","variants":{"color":"green"}}],"markings":[{"id":"markings--twoway-left"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-02","inbound"]},"offsetX":"-50%"},{"id":"bike","variants":{"type|direction":["biker-01","outbound"]},"offsetX":"50%"}]}},"twoway-right|green|sidewalk":{"name":"Two-way bike lane","nameKey":"twoway-bike-lane","rules":{"minWidth":10},"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"sidewalk","variants":{"color":"green"}}],"markings":[{"id":"markings--twoway-right"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-02","inbound"]},"offsetX":"50%"},{"id":"bike","variants":{"type|direction":["biker-01","outbound"]},"offsetX":"-50%"}]}},"inbound|red|sidewalk":{"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"sidewalk","variants":{"color":"red"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-01","inbound"]}}]}},"outbound|red|sidewalk":{"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"sidewalk","variants":{"color":"red"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-01","outbound"]}}]}},"twoway-left|red|sidewalk":{"name":"Two-way bike lane","nameKey":"twoway-bike-lane","rules":{"minWidth":10},"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"sidewalk","variants":{"color":"red"}}],"markings":[{"id":"markings--twoway-left"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-02","inbound"]},"offsetX":"-50%"},{"id":"bike","variants":{"type|direction":["biker-01","outbound"]},"offsetX":"50%"}]}},"twoway-right|red|sidewalk":{"name":"Two-way bike lane","nameKey":"twoway-bike-lane","rules":{"minWidth":10},"description":{"key":"colored-bike-lane","image":"bike-lane-colored-01.jpg"},"components":{"lanes":[{"id":"sidewalk","variants":{"color":"red"}}],"markings":[{"id":"markings--twoway-right"}],"vehicles":[{"id":"bike","variants":{"type|direction":["biker-02","inbound"]},"offsetX":"50%"},{"id":"bike","variants":{"type|direction":["biker-01","outbound"]},"offsetX":"-50%"}]}}}},"bikeshare":{"name":"Bikeshare station","nameKey":"bikeshare-station","owner":"FLEX","zIndex":21,"defaultWidth":7,"rules":{"minWidth":7,"maxWidth":10},"variants":["orientation","elevation"],"details":{"left|road":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left"},{"id":"markings--lane-right"}],"objects":[{"id":"bikeshare","variants":{"orientation":"left"}}]}},"right|road":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left"},{"id":"markings--lane-right"}],"objects":[{"id":"bikeshare","variants":{"orientation":"right"}}]}},"left|sidewalk":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"bikeshare","variants":{"orientation":"left"}}]}},"right|sidewalk":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"bikeshare","variants":{"orientation":"right"}}]}}}},"food-truck":{"name":"Food truck","nameKey":"foodtruck","owner":"FLEX","zIndex":20,"defaultWidth":10,"rules":{"minWidth":10},"variants":["orientation"],"details":{"left":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"food-truck","variants":{"orientation":"left"}}]}},"right":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"food-truck","variants":{"orientation":"right"}}]}}}},"flex-zone":{"name":"Flex zone","nameKey":"flex-zone","owner":"FLEX","zIndex":15,"defaultWidth":7,"rules":{"minWidth":7,"maxWidth":10},"variants":["flex-type","direction","orientation"],"details":{"taxi|inbound|left":{"name":"Taxi loading zone","nameKey":"taxi-pick-up","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-right"}],"vehicles":[{"id":"taxi","variants":{"direction|orientation":["inbound","left"]}}]}},"taxi|inbound|right":{"name":"Taxi loading zone","nameKey":"taxi-pick-up","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left"}],"vehicles":[{"id":"taxi","variants":{"direction|orientation":["inbound","right"]}}]}},"taxi|outbound|left":{"name":"Taxi loading zone","nameKey":"taxi-pick-up","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-right"}],"vehicles":[{"id":"taxi","variants":{"direction|orientation":["outbound","left"]}}]}},"taxi|outbound|right":{"name":"Taxi loading zone","nameKey":"taxi-pick-up","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left"}],"vehicles":[{"id":"taxi","variants":{"direction|orientation":["outbound","right"]}}]}},"rideshare|inbound|left":{"name":"Rideshare loading zone","nameKey":"rideshare-pick-up","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-right"}],"vehicles":[{"id":"rideshare","variants":{"direction|orientation":["inbound","left"]}}]}},"rideshare|inbound|right":{"name":"Rideshare loading zone","nameKey":"rideshare-pick-up","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left"}],"vehicles":[{"id":"rideshare","variants":{"direction|orientation":["inbound","right"]}}]}},"rideshare|outbound|left":{"name":"Rideshare loading zone","nameKey":"rideshare-pick-up","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-right"}],"vehicles":[{"id":"rideshare","variants":{"direction|orientation":["outbound","left"]}}]}},"rideshare|outbound|right":{"name":"Rideshare loading zone","nameKey":"rideshare-pick-up","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--lane-left"}],"vehicles":[{"id":"rideshare","variants":{"direction|orientation":["outbound","right"]}}]}}}},"flex-zone-curb":{"name":"Waiting area","nameKey":"flex-zone-curb","owner":"FLEX","zIndex":30,"defaultWidth":4,"variants":["waiting-area","orientation"],"details":{"sparse|left":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"pickup-sign","variants":{"orientation":"right"}},{"id":"person-waiting","variants":{"orientation":"right"}}]}},"sparse|right":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"pickup-sign","variants":{"orientation":"left"}},{"id":"person-waiting","variants":{"orientation":"left"}}]}},"empty|left":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"pickup-sign","variants":{"orientation":"right"}}]}},"empty|right":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"pickup-sign","variants":{"orientation":"left"}}]}}}},"parking-lane":{"name":"Parking lane","nameKey":"parking-lane","owner":"CAR","zIndex":13,"defaultWidth":7,"rules":{"minWidth":7,"maxWidth":10},"variants":["parking-lane-direction","parking-lane-orientation"],"details":{"inbound|left":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--parking-left"}],"vehicles":[{"id":"car","offsetX":-80,"variants":{"direction|orientation":["inbound","left"]}}]}},"inbound|right":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--parking-right"}],"vehicles":[{"id":"car","offsetX":-80,"variants":{"direction|orientation":["inbound","right"]}}]}},"outbound|left":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--parking-left"}],"vehicles":[{"id":"car","offsetX":-80,"variants":{"direction|orientation":["outbound","left"]}}]}},"outbound|right":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--parking-right"}],"vehicles":[{"id":"car","offsetX":-80,"variants":{"direction|orientation":["outbound","right"]}}]}},"sideways|left":{"name":"Perpendicular parking","nameKey":"perpendicular-parking","rules":{"minWidth":14,"maxWidth":20},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"car","variants":{"direction|orientation":["sideways","left"]}}]}},"sideways|right":{"name":"Perpendicular parking","nameKey":"perpendicular-parking","rules":{"minWidth":14,"maxWidth":20},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"car","variants":{"direction|orientation":["sideways","right"]}}]}},"angled-front-left|left":{"name":"Angled parking","nameKey":"angled-parking","rules":{"minWidth":14,"maxWidth":18},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"car","variants":{"direction|orientation":["angled-front-left","left"]}}]}},"angled-front-right|left":{"name":"Angled parking","nameKey":"angled-parking","rules":{"minWidth":14,"maxWidth":18},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"car","variants":{"direction|orientation":["angled-front-right","left"]}}]}},"angled-rear-left|left":{"name":"Angled parking","nameKey":"angled-parking","rules":{"minWidth":14,"maxWidth":18},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"car","variants":{"direction|orientation":["angled-rear-left","left"]}}]}},"angled-rear-right|left":{"name":"Angled parking","nameKey":"angled-parking","rules":{"minWidth":14,"maxWidth":18},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"car","variants":{"direction|orientation":["angled-rear-right","left"]}}]}},"angled-front-left|right":{"name":"Angled parking","nameKey":"angled-parking","rules":{"minWidth":14,"maxWidth":18},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"car","variants":{"direction|orientation":["angled-front-left","right"]}}]}},"angled-front-right|right":{"name":"Angled parking","nameKey":"angled-parking","rules":{"minWidth":14,"maxWidth":18},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"car","variants":{"direction|orientation":["angled-front-right","right"]}}]}},"angled-rear-left|right":{"name":"Angled parking","nameKey":"angled-parking","rules":{"minWidth":14,"maxWidth":18},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"car","variants":{"direction|orientation":["angled-rear-left","right"]}}]}},"angled-rear-right|right":{"name":"Angled parking","nameKey":"angled-parking","rules":{"minWidth":14,"maxWidth":18},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"car","variants":{"direction|orientation":["angled-rear-right","right"]}}]}}}},"drive-lane":{"name":"Drive lane","nameKey":"drive-lane","owner":"CAR","zIndex":14,"defaultWidth":10,"rules":{"minWidth":8,"maxWidth":11.9},"variants":["direction","car-type"],"details":{"inbound|car":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"car","variants":{"direction":"inbound"}}]}},"outbound|car":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"car","variants":{"direction":"outbound"}}]}},"inbound|car-with-bus":{"name":"Mixed-traffic drive lane","nameKey":"mixed-drive-lane","rules":{"minWidth":10},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"bus-alt","variants":{"direction":"inbound"}},{"id":"car","variants":{"direction":"inbound"}}]}},"outbound|car-with-bus":{"name":"Mixed-traffic drive lane","nameKey":"mixed-drive-lane","rules":{"minWidth":10},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"bus-alt","variants":{"direction":"outbound"}},{"id":"car","variants":{"direction":"outbound"}}]}},"inbound|car-with-bike":{"name":"Mixed-traffic drive lane","nameKey":"mixed-drive-lane","rules":{"dangerous":true},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"car","variants":{"direction":"inbound"}},{"id":"bike","offsetX":30,"variants":{"type|direction":["biker-02","inbound"]}}],"effects":[{"id":"biker-stress","offsetX":20,"variants":{"type":"sweat-drop"}}]}},"outbound|car-with-bike":{"name":"Mixed-traffic drive lane","nameKey":"mixed-drive-lane","rules":{"dangerous":true},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"car","variants":{"direction":"outbound"}},{"id":"bike","offsetX":-30,"variants":{"type|direction":["biker-02","outbound"]}}]}},"inbound|sharrow":{"name":"Sharrow","nameKey":"sharrow","rules":{"minWidth":12,"maxWidth":14},"defaultWidth":14,"description":{"key":"sharrow","image":"sharrow-01.jpg"},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--sharrow-inbound"}],"vehicles":[{"id":"car","variants":{"direction":"inbound"}},{"id":"bike","variants":{"type|direction":["biker-02","inbound"]}}]}},"outbound|sharrow":{"name":"Sharrow","nameKey":"sharrow","rules":{"minWidth":12,"maxWidth":14},"defaultWidth":14,"description":{"key":"sharrow","image":"sharrow-01.jpg"},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--sharrow-outbound"}],"vehicles":[{"id":"car","variants":{"direction":"outbound"}},{"id":"bike","variants":{"type|direction":["biker-02","outbound"]}}]}},"inbound|bus":{"rules":{"minWidth":10},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"bus","variants":{"direction":"inbound"}}]}},"outbound|bus":{"rules":{"minWidth":10},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"bus","variants":{"direction":"outbound"}}]}},"inbound|truck":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"truck","variants":{"direction":"inbound"}}]}},"outbound|truck":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"truck","variants":{"direction":"outbound"}}]}},"inbound|microvan":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"microvan","variants":{"direction":"inbound"}}]}},"outbound|microvan":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"microvan","variants":{"direction":"outbound"}}]}},"inbound|av":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"av","variants":{"direction":"inbound"}}]}},"outbound|av":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"av","variants":{"direction":"outbound"}}]}},"inbound|motorcycle-sidecar":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"motorcycle-sidecar","variants":{"direction":"inbound"}}]}},"outbound|motorcycle-sidecar":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"motorcycle-sidecar","variants":{"direction":"outbound"}}]}},"inbound|pedestrian":{"name":"Pedestrian","nameKey":"pedestrian","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"pedestrian","variants":{"density":"normal"}}]}},"outbound|pedestrian":{"name":"Pedestrian","nameKey":"pedestrian","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"pedestrian","variants":{"density":"normal"}}]}}}},"turn-lane":{"name":"Turn lane","nameKey":"turn-lane","owner":"CAR","zIndex":13,"defaultWidth":10,"rules":{"minWidth":9,"maxWidth":12},"variants":["direction","turn-lane-orientation"],"details":{"inbound|left":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--left-inbound"}],"vehicles":[{"id":"car","variants":{"direction|turn-orientation":["inbound","right"]}}]}},"inbound|left-straight":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--left-straight-inbound"}],"vehicles":[{"id":"car","variants":{"direction|turn-orientation":["inbound","right"]}}]}},"inbound|straight":{"name":"No turn lane","nameKey":"turn-lane-straight","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound"}],"vehicles":[{"id":"car","variants":{"direction":"inbound"}}]}},"inbound|right-straight":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--right-straight-inbound"}],"vehicles":[{"id":"car","variants":{"direction|turn-orientation":["inbound","left"]}}]}},"inbound|right":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--right-inbound"}],"vehicles":[{"id":"car","variants":{"direction|turn-orientation":["inbound","left"]}}]}},"inbound|both":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--both-inbound"}],"vehicles":[{"id":"car","variants":{"direction|turn-orientation":["inbound","right"]}}]}},"inbound|left-right-straight":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--left-right-straight-inbound"}],"vehicles":[{"id":"car","variants":{"direction|turn-orientation":["inbound","right"]}}]}},"inbound|shared":{"name":"Center turn lane","nameKey":"turn-lane-center","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--shared-inbound"},{"id":"markings--center-lane-left"},{"id":"markings--center-lane-right"}]}},"outbound|left":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--left-outbound"}],"vehicles":[{"id":"car","variants":{"direction|turn-orientation":["outbound","left"]}}]}},"outbound|left-straight":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--left-straight-outbound"}],"vehicles":[{"id":"car","variants":{"direction|turn-orientation":["outbound","left"]}}]}},"outbound|straight":{"name":"No turn lane","nameKey":"turn-lane-straight","components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound"}],"vehicles":[{"id":"car","variants":{"direction":"outbound"}}]}},"outbound|right-straight":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--right-straight-outbound"}],"vehicles":[{"id":"car","variants":{"direction|turn-orientation":["outbound","right"]}}]}},"outbound|right":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--right-outbound"}],"vehicles":[{"id":"car","variants":{"direction|turn-orientation":["outbound","right"]}}]}},"outbound|both":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--both-outbound"}],"vehicles":[{"id":"car","variants":{"direction|turn-orientation":["outbound","left"]}}]}},"outbound|left-right-straight":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--left-right-straight-outbound"}],"vehicles":[{"id":"car","variants":{"direction|turn-orientation":["outbound","left"]}}]}},"outbound|shared":{"name":"Center turn lane","nameKey":"turn-lane-center","rules":{"minWidth":10,"maxWidth":16},"defaultWidth":12,"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--shared-outbound"},{"id":"markings--center-lane-left"},{"id":"markings--center-lane-right"}]}}}},"bus-lane":{"name":"Bus lane","nameKey":"bus-lane","owner":"TRANSIT","zIndex":15,"defaultWidth":12,"rules":{"minWidth":10,"maxWidth":13},"variants":["direction","bus-asphalt","bus-type"],"details":{"inbound|regular|typical":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"bus","variants":{"direction":"inbound"}}]}},"outbound|regular|typical":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"bus","variants":{"direction":"outbound"}}]}},"inbound|colored|typical":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"bus","variants":{"direction":"inbound"}}]}},"outbound|colored|typical":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"bus","variants":{"direction":"outbound"}}]}},"inbound|shared|typical":{"name":"Shared bus/bike lane","nameKey":"bus-lane-shared","defaultWidth":14,"rules":{"minWidth":12,"maxWidth":14},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--sharrow-inbound"},{"id":"markings--lane-left"},{"id":"markings--lane-right"}],"vehicles":[{"id":"bus","variants":{"direction":"inbound"}},{"id":"bike","offsetX":30,"variants":{"type|direction":["biker-02","inbound"]}}]}},"outbound|shared|typical":{"name":"Shared bus/bike lane","nameKey":"bus-lane-shared","defaultWidth":14,"rules":{"minWidth":12,"maxWidth":14},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--sharrow-outbound"},{"id":"markings--lane-left"},{"id":"markings--lane-right"}],"vehicles":[{"id":"bus","variants":{"direction":"outbound"}},{"id":"bike","offsetX":-30,"variants":{"type|direction":["biker-02","outbound"]}}]}},"inbound|regular|double-decker":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"double-decker-bus","variants":{"direction":"inbound"}}]}},"outbound|regular|double-decker":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"double-decker-bus","variants":{"direction":"outbound"}}]}},"inbound|colored|double-decker":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"double-decker-bus","variants":{"direction":"inbound"}}]}},"outbound|colored|double-decker":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"double-decker-bus","variants":{"direction":"outbound"}}]}},"inbound|shared|double-decker":{"name":"Shared bus/bike lane","nameKey":"bus-lane-shared","defaultWidth":14,"rules":{"minWidth":12,"maxWidth":14},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--sharrow-inbound"},{"id":"markings--lane-left"},{"id":"markings--lane-right"}],"vehicles":[{"id":"double-decker-bus","variants":{"direction":"inbound"}},{"id":"bike","offsetX":30,"variants":{"type|direction":["biker-02","inbound"]}}]}},"outbound|shared|double-decker":{"name":"Shared bus/bike lane","nameKey":"bus-lane-shared","defaultWidth":14,"rules":{"minWidth":12,"maxWidth":14},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--sharrow-outbound"},{"id":"markings--lane-left"},{"id":"markings--lane-right"}],"vehicles":[{"id":"double-decker-bus","variants":{"direction":"outbound"}},{"id":"bike","offsetX":-30,"variants":{"type|direction":["biker-02","outbound"]}}]}},"inbound|regular|av-shuttle":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"av-shuttle","variants":{"direction":"inbound"}}]}},"outbound|regular|av-shuttle":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"av-shuttle","variants":{"direction":"outbound"}}]}},"inbound|colored|av-shuttle":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"av-shuttle","variants":{"direction":"inbound"}}]}},"outbound|colored|av-shuttle":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"av-shuttle","variants":{"direction":"outbound"}}]}},"inbound|shared|av-shuttle":{"name":"Shared bus/bike lane","nameKey":"bus-lane-shared","defaultWidth":14,"rules":{"minWidth":12,"maxWidth":14},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--sharrow-inbound"},{"id":"markings--lane-left"},{"id":"markings--lane-right"}],"vehicles":[{"id":"av-shuttle","variants":{"direction":"inbound"}},{"id":"bike","offsetX":30,"variants":{"type|direction":["biker-02","inbound"]}}]}},"outbound|shared|av-shuttle":{"name":"Shared bus/bike lane","nameKey":"bus-lane-shared","defaultWidth":14,"rules":{"minWidth":12,"maxWidth":14},"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--sharrow-outbound"},{"id":"markings--lane-left"},{"id":"markings--lane-right"}],"vehicles":[{"id":"av-shuttle","variants":{"direction":"outbound"}},{"id":"bike","offsetX":-30,"variants":{"type|direction":["biker-02","outbound"]}}]}}}},"streetcar":{"name":"Streetcar","nameKey":"streetcar","owner":"TRANSIT","zIndex":15,"defaultWidth":12,"rules":{"minWidth":10,"maxWidth":14},"variants":["direction","public-transit-asphalt"],"details":{"inbound|regular":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--streetcar-track-01"},{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"streetcar","variants":{"direction":"inbound"}}]}},"outbound|regular":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--streetcar-track-01"},{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"streetcar","variants":{"direction":"outbound"}}]}},"inbound|colored":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--streetcar-track-02"},{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"streetcar","variants":{"direction":"inbound"}}]}},"outbound|colored":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--streetcar-track-02"},{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"streetcar","variants":{"direction":"outbound"}}]}},"inbound|grass":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"green"}}],"markings":[{"id":"markings--streetcar-track-02"},{"id":"markings--straight-inbound-light"}],"objects":[{"id":"planting-strip","variants":{"type":"grass"}}],"vehicles":[{"id":"streetcar","variants":{"direction":"inbound"}}]}},"outbound|grass":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"green"}}],"markings":[{"id":"markings--streetcar-track-02"},{"id":"markings--straight-outbound-light"}],"objects":[{"id":"planting-strip","variants":{"type":"grass"}}],"vehicles":[{"id":"streetcar","variants":{"direction":"outbound"}}]}}}},"light-rail":{"name":"Light rail","nameKey":"light-rail","owner":"TRANSIT","zIndex":15,"defaultWidth":12,"rules":{"minWidth":10,"maxWidth":14},"variants":["direction","public-transit-asphalt"],"details":{"inbound|regular":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"gray"}}],"markings":[{"id":"markings--streetcar-track-02"},{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"light-rail","variants":{"direction":"inbound"}}]}},"outbound|regular":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"gray"}}],"markings":[{"id":"markings--streetcar-track-02"},{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"light-rail","variants":{"direction":"outbound"}}]}},"inbound|colored":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--streetcar-track-02"},{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"light-rail","variants":{"direction":"inbound"}}]}},"outbound|colored":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--streetcar-track-02"},{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"light-rail","variants":{"direction":"outbound"}}]}},"inbound|grass":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"green"}}],"objects":[{"id":"planting-strip","variants":{"type":"grass"}}],"markings":[{"id":"markings--streetcar-track-02"},{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"light-rail","variants":{"direction":"inbound"}}]}},"outbound|grass":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"green"}}],"objects":[{"id":"planting-strip","variants":{"type":"grass"}}],"markings":[{"id":"markings--streetcar-track-02"},{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"light-rail","variants":{"direction":"outbound"}}]}}}},"transit-shelter":{"name":"Transit shelter","nameKey":"transit-shelter","owner":"TRANSIT","zIndex":20,"defaultWidth":9,"defaultVariant":"right|street-level","rules":{"minWidth":9},"variants":["orientation","transit-shelter-elevation"],"details":{"left|street-level":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"transit-shelter","variants":{"type|orientation":["transit-shelter-01","left"]}}]}},"right|street-level":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"transit-shelter","variants":{"type|orientation":["transit-shelter-01","right"]}}]}},"left|light-rail":{"description":{"key":"transit-shelter-elevated","image":"transit-station-elevated.jpg"},"rules":{"minWidth":8},"components":{"lanes":[{"id":"raised-sidewalk","variants":{"type":"default"}}],"objects":[{"id":"transit-shelter","variants":{"type|orientation":["transit-shelter-02","left"]}}]}},"right|light-rail":{"description":{"key":"transit-shelter-elevated","image":"transit-station-elevated.jpg"},"rules":{"minWidth":8},"components":{"lanes":[{"id":"raised-sidewalk","variants":{"type":"default"}}],"objects":[{"id":"transit-shelter","variants":{"type|orientation":["transit-shelter-02","right"]}}]}}}},"brt-station":{"name":"BRT station","nameKey":"brt-station","owner":"TRANSIT","zIndex":20,"defaultWidth":13.3333,"unlockCondition":"SIGN_IN","defaultVariant":"center","paletteDefaultWidth":10,"rules":{"minWidth":13.3333},"variants":["brt-station-orientation"],"details":{"left":{"rules":{"minWidth":10},"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"brt-station","variants":{"orientation":["left"]}}]}},"right":{"rules":{"minWidth":10},"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"brt-station","variants":{"orientation":["right"]}}]}},"center":{"components":{"lanes":[{"id":"sidewalk","variants":{"color":"regular"}}],"objects":[{"id":"brt-station","variants":{"orientation":["center"]}}]}}}},"brt-lane":{"name":"Bus rapid transit lane","nameKey":"brt-lane","owner":"TRANSIT","zIndex":15,"defaultWidth":11.66666,"unlockCondition":"SIGN_IN","rules":{"minWidth":11.5,"maxWidth":13},"variants":["direction","brt-asphalt"],"details":{"inbound|regular":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"brt-bus","variants":{"direction":"inbound"}}]}},"outbound|regular":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"brt-bus","variants":{"direction":"outbound"}}]}},"inbound|red":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--straight-inbound-light"}],"vehicles":[{"id":"brt-bus","variants":{"direction":"inbound"}}]}},"outbound|red":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"red"}}],"markings":[{"id":"markings--straight-outbound-light"}],"vehicles":[{"id":"brt-bus","variants":{"direction":"outbound"}}]}}}},"train":{"name":"\u201CInception\u201D train","nameKey":"inception-train","owner":"TRANSIT","zIndex":10,"defaultWidth":14,"enableWithFlag":"SEGMENT_INCEPTION_TRAIN","description":{"key":"inception-train","image":"train.jpg"},"rules":{"minWidth":14},"variants":[""],"details":{"":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"train","variants":{"type":"default"}}]}}}},"magic-carpet":{"name":"Magic carpet","nameKey":"magic-carpet","defaultWidth":10,"unlockCondition":"SIGN_IN","defaultVariant":"jasmine-aladdin","variants":["magic-carpet-occupants"],"details":{"aladdin":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"magic-carpet","variants":{"magic-carpet-occupants":"aladdin"}}]}},"jasmine":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"magic-carpet","variants":{"magic-carpet-occupants":"jasmine"}}]}},"aladdin-jasmine":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"magic-carpet","variants":{"magic-carpet-occupants":"aladdin-jasmine"}}]}},"jasmine-aladdin":{"components":{"lanes":[{"id":"asphalt","variants":{"color":"regular"}}],"vehicles":[{"id":"magic-carpet","variants":{"magic-carpet-occupants":"jasmine-aladdin"}}]}}}}}');


/**
 * Replacement for lodash's uniq().
 *
 * Creates a duplicate-free version of an array, in which only the first
 * occurrence of each element is kept. The order of result values is
 * determined by the order they occur in the array.
 *
 * This is the vanilla JS implementation via
 * https://youmightnotneed.com/lodash/#uniq
 * (Using Array.from() instead of the spread operator)
 *
 * WARNING: This is not a drop in replacement solution and it might not work
 * for some edge cases.
 *
 * @param {Array} arr - array of items to convert to unique values
 * @returns Array
 */ function $4bfa44e801f4950c$export$7a5d5c156e7dc406(arr) {
    return Array.from(new Set(arr));
}


var $9c58c773e5ab7013$exports = {};
$9c58c773e5ab7013$exports = JSON.parse('{"lanes":{"asphalt":{"elevation":0,"variants":{"color":{"regular":{"graphics":{"repeat":"ground--asphalt"}},"red":{"graphics":{"repeat":"ground--asphalt-red"}},"green":{"graphics":{"repeat":"ground--asphalt-green"}},"gray":{"graphics":{"repeat":"ground--asphalt-gray"}}}}},"sidewalk":{"elevation":1,"variants":{"color":{"regular":{"graphics":{"repeat":"ground--concrete"}},"black":{"graphics":{"repeat":"ground--asphalt"}},"red":{"graphics":{"repeat":"ground--asphalt-red"}},"green":{"graphics":{"repeat":"ground--asphalt-green"}},"gray":{"graphics":{"repeat":"ground--asphalt-gray"}}},"density":{"empty":{"graphics":{"repeat":"ground--concrete"}}}}},"raised-sidewalk":{"elevation":2,"variants":{"type":{"default":{"graphics":{"repeat":"ground--concrete"}}}}},"drainage":{"elevation":-2,"variants":{"color":{"regular":{"graphics":{"repeat":"ground--concrete"}}}}}},"markings":{"markings--lane-right":{"graphics":{"right":"markings--lane-right"}},"markings--lane-left":{"graphics":{"left":"markings--lane-left"}},"markings--straight-inbound-light":{"graphics":{"center":"markings--straight-inbound-light"}},"markings--straight-outbound-light":{"graphics":{"center":"markings--straight-outbound-light"}},"markings--lane-left-half":{"graphics":{"left":"markings--lane-left-half"}},"markings--lane-right-half":{"graphics":{"right":"markings--lane-right-half"}},"markings--lane-horiz":{"graphics":{"repeat":"markings--lane-horiz"}},"markings--sharrow-inbound":{"graphics":{"center":"markings--sharrow-inbound"}},"markings--sharrow-outbound":{"graphics":{"center":"markings--sharrow-outbound"}},"markings--left-inbound":{"graphics":{"center":"markings--left-inbound"}},"markings--left-straight-inbound":{"graphics":{"center":"markings--left-straight-inbound"}},"markings--straight-inbound":{"graphics":{"center":"markings--straight-inbound"}},"markings--right-straight-inbound":{"graphics":{"center":"markings--right-straight-inbound"}},"markings--right-inbound":{"graphics":{"center":"markings--right-inbound"}},"markings--both-inbound":{"graphics":{"center":"markings--both-inbound"}},"markings--left-right-straight-inbound":{"graphics":{"center":"markings--left-right-straight-inbound"}},"markings--shared-inbound":{"graphics":{"center":"markings--shared-inbound"}},"markings--center-lane-left":{"graphics":{"left":"markings--center-lane-left"}},"markings--center-lane-right":{"graphics":{"right":"markings--center-lane-right"}},"markings--left-outbound":{"graphics":{"center":"markings--left-outbound"}},"markings--left-straight-outbound":{"graphics":{"center":"markings--left-straight-outbound"}},"markings--straight-outbound":{"graphics":{"center":"markings--straight-outbound"}},"markings--right-straight-outbound":{"graphics":{"center":"markings--right-straight-outbound"}},"markings--right-outbound":{"graphics":{"center":"markings--right-outbound"}},"markings--both-outbound":{"graphics":{"center":"markings--both-outbound"}},"markings--left-right-straight-outbound":{"graphics":{"center":"markings--left-right-straight-outbound"}},"markings--shared-outbound":{"graphics":{"center":"markings--shared-outbound"}},"markings--streetcar-track-01":{"graphics":{"center":"markings--streetcar-track-01"}},"markings--streetcar-track-02":{"graphics":{"center":"markings--streetcar-track-02"}},"markings--stripes-diagonal":{"graphics":{"repeat":"markings--stripes-diagonal"}},"markings--parking-left":{"graphics":{"right":"markings--parking-left"}},"markings--parking-right":{"graphics":{"left":"markings--parking-right"}},"markings--twoway-left":{"graphics":{"center":[{"id":"markings--center-lane"},{"id":"markings--straight-inbound-light","offsetX":"-50%"},{"id":"markings--straight-outbound-light","offsetX":"50%"}]}},"markings--twoway-right":{"graphics":{"center":[{"id":"markings--center-lane"},{"id":"markings--straight-inbound-light","offsetX":"50%"},{"id":"markings--straight-outbound-light","offsetX":"-50%"}]}},"markings--crosswalk-zebra":{"graphics":{"repeat":"markings--crosswalk-zebra"}},"markings--crosswalk-zebra-bike":{"graphics":{"repeat":"markings--crosswalk-zebra-bike"}}},"objects":{"pickup-sign":{"name":"Pickup sign","nameKey":"pickup-sign","owner":"FLEX","zIndex":30,"variants":{"orientation":{"left":{"graphics":{"right":"curb--pickup-sign-left"}},"right":{"graphics":{"left":"curb--pickup-sign-right"}}}}},"person-waiting":{"name":"Person waiting","nameKey":"person-waiting","zIndex":30,"variants":{"orientation":{"left":{"graphics":{"center":"curb--person-waiting-01-left"}},"right":{"graphics":{"center":"curb--person-waiting-01-right"}}}}},"utility-pole":{"name":"Utility pole","nameKey":"utility-pole","owner":"NONE","zIndex":10,"variants":{"orientation":{"left":{"graphics":{"center":"utilities--utility-pole-left"}},"right":{"graphics":{"center":"utilities--utility-pole-right"}}}}},"tree":{"name":"Tree","nameKey":"tree","owner":"NATURE","zIndex":22,"variants":{"type":{"big":{"graphics":{"center":"trees--tree"}},"palm-tree":{"graphics":{"center":"trees--palm-tree"}}}}},"bike-rack":{"name":"Bike rack","nameKey":"bike-rack","owner":"BIKE","zIndex":23,"variants":{"direction|orientation":{"parallel":{"left":{"graphics":{"left":"bikes--bike-rack-parallel-left"}},"right":{"graphics":{"right":"bikes--bike-rack-parallel-right"}}},"perpendicular":{"left":{"graphics":{"left":"bikes--bike-rack-perpendicular-left"}},"right":{"graphics":{"right":"bikes--bike-rack-perpendicular-right"}}}}}},"bench":{"name":"Bench","nameKey":"bench","owner":"PEDESTRIAN","zIndex":24,"variants":{"orientation":{"left":{"graphics":{"left":"furniture--bench-left"}},"center":{"graphics":{"center":"furniture--bench-center"}},"right":{"graphics":{"right":"furniture--bench-right"}}}}},"outdoor-dining":{"name":"Outdoor dining","nameKey":"outdoor-dining","owner":"PEDESTRIAN","zIndex":20,"variants":{"occupants":{"occupied":{"graphics":{"center":"furniture--cafe-seating-occupied"}},"empty":{"graphics":{"center":"furniture--cafe-seating"}}}}},"wayfinding-sign":{"name":"Wayfinding sign","nameKey":"wayfinding-sign","owner":"PEDESTRIAN","zIndex":21,"variants":{"type":{"small":{"graphics":{"center":"wayfinding--nyc-wayfinding-pylon-small"}},"medium":{"graphics":{"center":"wayfinding--nyc-wayfinding-pylon-medium"}},"large":{"graphics":{"center":"wayfinding--nyc-wayfinding-pylon-large"}}}}},"lamp":{"name":"Lamp","nameKey":"lamp","owner":"PEDESTRIAN","zIndex":19,"variants":{"type|orientation":{"modern":{"right":{"graphics":{"right":"lamps--lamp-modern-right"}},"left":{"graphics":{"left":"lamps--lamp-modern-left"}},"both":{"graphics":{"center":"lamps--lamp-modern-both"}}},"traditional":{"right":{"graphics":{"right":"lamps--lamp-traditional-right"}},"left":{"graphics":{"left":"lamps--lamp-traditional-left"}},"both":{"graphics":{"center":"lamps--lamp-traditional-center"}}}}}},"pride-banner":{"name":"Pride banner","nameKey":"pride-banner","variants":{"orientation":{"left":{"graphics":{"left":"lamps--pride-banner-left"}},"right":{"graphics":{"right":"lamps--pride-banner-right"}},"both":{"graphics":{"center":{"id":"lamps--pride-banner-left","offsetX":49}}}}}},"parklet":{"name":"Parklet","nameKey":"parklet","owner":"NATURE","zIndex":15,"variants":{"orientation":{"left":{"graphics":{"left":"parklet--yerba-buena-parklet-left-v02"}},"right":{"graphics":{"right":"parklet--yerba-buena-parklet-right-v02"}}}}},"street-vendor":{"name":"Street vendor","nameKey":"street-vendor","zIndex":24,"variants":{"vendor-type":{"handcart":{"graphics":{"center":"vendors--vendor-handcart"}},"platform":{"graphics":{"center":"vendors--vendor-platform"}},"table":{"graphics":{"center":"vendors--vendor-table"}},"tarp":{"graphics":{"center":"vendors--vendor-tarp"}}}}},"bikeshare":{"name":"Bikeshare station","nameKey":"bikeshare-station","owner":"FLEX","zIndex":21,"variants":{"orientation":{"left":{"graphics":{"left":"bikes--bikeshare-left"}},"right":{"graphics":{"right":"bikes--bikeshare-right"}}}}},"planting-strip":{"name":"Planting strip","nameKey":"planting-strip","owner":"NATURE","zIndex":20,"variants":{"type":{"grass":{"graphics":{"repeat":"plants--grass"}},"bush":{"graphics":{"scatter":{"sprites":["plants--bush"],"minSpacing":-3,"maxSpacing":3,"padding":2}}},"flowers":{"graphics":{"scatter":{"sprites":["plants--flowers-red",{"id":"plants--flowers-orange","width":4,"disallowFirst":true,"weight":20},{"id":"plants--flowers-yellow","width":4,"disallowFirst":true},{"id":"plants--flowers-white","width":4,"disallowFirst":true,"weight":20},{"id":"plants--flowers-blue","width":4,"disallowFirst":true,"weight":10}],"minSpacing":-3,"maxSpacing":3,"padding":2}}}}}},"planter-box":{"name":"Planter box","nameKey":"planter-box","owner":"NATURE","zIndex":20,"variants":{"type":{"default":{"graphics":{"center":"dividers--planter-box"}}}}},"bollard":{"name":"Bollard","nameKey":"bollard","zIndex":20,"variants":{"type":{"default":{"graphics":{"center":"dividers--bollard"}}}}},"dome":{"name":"Traffic exclusion dome","nameKey":"dome","zIndex":20,"variants":{"type":{"default":{"graphics":{"center":"dividers--dome"}}}}},"transit-shelter":{"name":"Transit shelter","nameKey":"transit-shelter","owner":"TRANSIT","zIndex":20,"variants":{"type|orientation":{"transit-shelter-01":{"left":{"graphics":{"left":"transit--transit-shelter-01-left"}},"right":{"graphics":{"right":"transit--transit-shelter-01-right"}}},"transit-shelter-02":{"left":{"graphics":{"left":"transit--transit-shelter-02-left"}},"right":{"graphics":{"right":"transit--transit-shelter-02-right"}}}}}},"brt-station":{"name":"BRT station","nameKey":"brt-station","owner":"TRANSIT","zIndex":20,"variants":{"orientation":{"left":{"graphics":{"quirks":{"minWidth":6.75},"repeat":{"id":"transit--brt-station-piece-center","padding":1.5},"left":"transit--brt-station-piece-left-edge","right":"transit--brt-station-piece-right-platform","scatter":{"pool":"people","minSpacing":0,"maxSpacing":2.5,"originY":-36,"padding":7}}},"right":{"graphics":{"quirks":{"minWidth":6.75},"repeat":{"id":"transit--brt-station-piece-center","padding":1.5},"right":"transit--brt-station-piece-right-edge","left":"transit--brt-station-piece-left-platform","scatter":{"pool":"people","minSpacing":0,"maxSpacing":2.5,"originY":-36,"padding":7}}},"center":{"graphics":{"quirks":{"minWidth":6.75},"repeat":{"id":"transit--brt-station-piece-center","padding":1.5},"left":"transit--brt-station-piece-left-platform","right":"transit--brt-station-piece-right-platform","scatter":{"pool":"people","minSpacing":0,"maxSpacing":2.5,"originY":-36,"padding":7}}}}}},"traffic-cone":{"name":"Traffic cone","nameKey":"traffic-cone","zIndex":20,"variants":{"type":{"default":{"graphics":{"center":"construction--cone"}}}}},"jersey-barrier":{"name":"Jersey barrier","nameKey":"jersey-barrier","zIndex":20,"variants":{"material":{"concrete":{"graphics":{"center":"construction--jersey-barrier-concrete"}},"plastic":{"graphics":{"center":"construction--jersey-barrier-plastic"}}}}},"barricade":{"name":"Barricade","nameKey":"barricade","zIndex":20,"variants":{"type":{"default":{"graphics":{"center":"construction--barricade"}}}}},"open-drain":{"variants":{"drainage-sides":{"slanted":{"graphics":{"quirks":{"minWidth":3.3333},"repeat":"utilities--drainage-channel-piece-center","left":"utilities--drainage-channel-piece-left-slanted","right":"utilities--drainage-channel-piece-right-slanted"}},"vertical":{"graphics":{"quirks":{"minWidth":2.6666},"repeat":"utilities--drainage-channel-piece-center","left":"utilities--drainage-channel-piece-left-vertical","right":"utilities--drainage-channel-piece-right-vertical"}}}}}},"vehicles":{"pedestrian":{"name":"Pedestrian","nameKey":"pedestrian","owner":"PEDESTRIAN","variants":{"density":{"normal":{"graphics":{"scatter":{"pool":"people","minSpacing":0,"maxSpacing":5,"padding":2}}},"dense":{"graphics":{"scatter":{"pool":"people","minSpacing":0,"maxSpacing":1.5,"padding":2}}},"sparse":{"graphics":{"scatter":{"pool":"people","minSpacing":3.5,"maxSpacing":11.8333,"padding":2}}}}}},"scooter":{"name":"Electric scooter","nameKey":"scooter","owner":"BIKE","zIndex":16,"variants":{"direction":{"inbound":{"graphics":{"center":["scooters--scooter-inbound"]}},"outbound":{"graphics":{"center":["scooters--scooter-outbound"]}}},"riders|orientation":{"empty":{"left":{"graphics":{"left":"scooters--scooter-left-docked"}},"right":{"graphics":{"right":"scooters--scooter-right-docked"}}},"sparse":{"left":{"graphics":{"left":"scooters--scooter-left-rider"}},"right":{"graphics":{"right":"scooters--scooter-right-rider"}}}}}},"taxi":{"name":"Taxi","nameKey":"taxi","owner":"FLEX","zIndex":15,"variants":{"direction|orientation":{"inbound":{"left":{"graphics":{"center":"vehicles--taxi-inbound-door-left"}},"right":{"graphics":{"center":"vehicles--taxi-inbound-door-right"}}},"outbound":{"left":{"graphics":{"center":"vehicles--taxi-outbound-door-left"}},"right":{"graphics":{"center":"vehicles--taxi-outbound-door-right"}}}}}},"rideshare":{"name":"Rideshare","nameKey":"rideshare","owner":"FLEX","zIndex":15,"variants":{"direction|orientation":{"inbound":{"left":{"graphics":{"center":"vehicles--rideshare-inbound-door-left"}},"right":{"graphics":{"center":"vehicles--rideshare-inbound-door-right"}}},"outbound":{"left":{"graphics":{"center":"vehicles--rideshare-outbound-door-left"}},"right":{"graphics":{"center":"vehicles--rideshare-outbound-door-right"}}}}}},"train":{"name":"\u201CInception\u201D train","nameKey":"inception-train","owner":"TRANSIT","zIndex":10,"variants":{"type":{"default":{"graphics":{"center":"secret--inception-train"}}}}},"bike":{"name":"Bike","nameKey":"bike","owner":"BIKE","zIndex":16,"variants":{"type|direction":{"biker-01":{"inbound":{"graphics":{"center":"bikes--biker-01-inbound"}},"outbound":{"graphics":{"center":"bikes--biker-01-outbound"}}},"biker-02":{"inbound":{"graphics":{"center":"bikes--biker-02-inbound"}},"outbound":{"graphics":{"center":"bikes--biker-02-outbound"}}}}}},"car":{"name":"Car","nameKey":"car","owner":"CAR","zIndex":14,"variants":{"direction":{"inbound":{"graphics":{"center":"vehicles--car-inbound"}},"outbound":{"graphics":{"center":"vehicles--car-outbound"}}},"direction|turn-orientation":{"inbound":{"right":{"graphics":{"center":"vehicles--car-inbound-turn-signal-right"}},"left":{"graphics":{"center":"vehicles--car-inbound-turn-signal-left"}}},"outbound":{"right":{"graphics":{"center":"vehicles--car-outbound-turn-signal-right"}},"left":{"graphics":{"center":"vehicles--car-outbound-turn-signal-left"}}}},"direction|orientation":{"inbound":{"left":{"graphics":{"left":"vehicles--car-inbound"}},"right":{"graphics":{"right":"vehicles--car-inbound"}}},"outbound":{"left":{"graphics":{"left":"vehicles--car-outbound"}},"right":{"graphics":{"right":"vehicles--car-outbound"}}},"sideways":{"left":{"graphics":{"left":"vehicles--car-sideways-left"}},"right":{"graphics":{"right":"vehicles--car-sideways-right"}}},"angled-front-left":{"left":{"graphics":{"left":"vehicles--car-angled-front-left"}},"right":{"graphics":{"right":"vehicles--car-angled-front-left"}}},"angled-front-right":{"left":{"graphics":{"left":"vehicles--car-angled-front-right"}},"right":{"graphics":{"right":"vehicles--car-angled-front-right"}}},"angled-rear-left":{"left":{"graphics":{"left":"vehicles--car-angled-rear-left"}},"right":{"graphics":{"right":"vehicles--car-angled-rear-left"}}},"angled-rear-right":{"left":{"graphics":{"left":"vehicles--car-angled-rear-right"}},"right":{"graphics":{"right":"vehicles--car-angled-rear-right"}}}}}},"microvan":{"name":"Microvan","nameKey":"microvan","owner":"CAR","zIndex":14,"variants":{"direction":{"inbound":{"graphics":{"center":"vehicles--microvan-inbound"}},"outbound":{"graphics":{"center":"vehicles--microvan-outbound"}}}}},"av":{"name":"Autonomous vehicle","nameKey":"av","owner":"CAR","zIndex":14,"variants":{"direction":{"inbound":{"graphics":{"center":"vehicles--av-inbound"}},"outbound":{"graphics":{"center":"vehicles--av-outbound"}}}}},"motorcycle-sidecar":{"name":"Motorcycle with sidecar","nameKey":"motorcycle-sidecar","owner":"CAR","zIndex":14,"variants":{"direction":{"inbound":{"graphics":{"center":"vehicles--krz-motorbike-inbound"}},"outbound":{"graphics":{"center":"vehicles--krz-motorbike-outbound"}}}}},"truck":{"name":"Truck","nameKey":"truck","owner":"CAR","zIndex":14,"variants":{"direction":{"inbound":{"graphics":{"center":"vehicles--truck-inbound"}},"outbound":{"graphics":{"center":"vehicles--truck-outbound"}}}}},"food-truck":{"name":"Food truck","nameKey":"foodtruck","owner":"FLEX","zIndex":20,"variants":{"orientation":{"left":{"graphics":{"center":"vehicles--foodtruck-left"}},"right":{"graphics":{"center":"vehicles--foodtruck-right"}}}}},"streetcar":{"name":"Streetcar","nameKey":"streetcar","owner":"TRANSIT","zIndex":15,"variants":{"direction":{"inbound":{"graphics":{"center":"transit--streetcar-inbound"}},"outbound":{"graphics":{"center":"transit--streetcar-outbound"}}}}},"light-rail":{"name":"Light rail","nameKey":"light-rail","owner":"TRANSIT","zIndex":15,"variants":{"direction":{"inbound":{"graphics":{"center":"transit--light-rail-inbound"}},"outbound":{"graphics":{"center":"transit--light-rail-outbound"}}}}},"bus":{"name":"Bus","nameKey":"bus","owner":"TRANSIT","zIndex":15,"variants":{"direction":{"inbound":{"graphics":{"center":"transit--bus-inbound"}},"outbound":{"graphics":{"center":"transit--bus-outbound"}}}}},"bus-alt":{"name":"Bus","nameKey":"bus","owner":"TRANSIT","zIndex":15,"variants":{"direction":{"inbound":{"graphics":{"center":"transit--bus-inbound-alt"}},"outbound":{"graphics":{"center":"transit--bus-outbound-alt"}}}}},"brt-bus":{"name":"BRT","nameKey":"brt-bus","owner":"TRANSIT","zIndex":15,"variants":{"direction":{"inbound":{"graphics":{"center":"transit--brt-bus-inbound"}},"outbound":{"graphics":{"center":"transit--brt-bus-outbound"}}}}},"double-decker-bus":{"name":"Double decker bus","nameKey":"double-decker","owner":"TRANSIT","zIndex":15,"variants":{"direction":{"inbound":{"graphics":{"center":"transit--double-decker-bus-inbound"}},"outbound":{"graphics":{"center":"transit--double-decker-bus-outbound"}}}}},"av-shuttle":{"name":"Autonomous shuttle","nameKey":"av-shuttle","owner":"TRANSIT","zIndex":15,"variants":{"direction":{"inbound":{"graphics":{"center":"transit--av-shuttle-inbound"}},"outbound":{"graphics":{"center":"transit--av-shuttle-outbound"}}}}},"magic-carpet":{"name":"Magic carpet","nameKey":"magic-carpet","zIndex":14,"variants":{"magic-carpet-occupants":{"aladdin":{"graphics":{"center":{"id":"vehicles--magic-carpet-aladdin","originY":-325}}},"jasmine":{"graphics":{"center":{"id":"vehicles--magic-carpet-jasmine","originY":-325}}},"aladdin-jasmine":{"graphics":{"center":{"id":"vehicles--magic-carpet-aladdin-jasmine","originY":-325}}},"jasmine-aladdin":{"graphics":{"center":{"id":"vehicles--magic-carpet-jasmine-aladdin","originY":-325}}}}}}},"effects":{"biker-stress":{"name":"Biker stress","nameKey":"biker-stress","variants":{"type":{"sweat-drop":{"graphics":{"center":"effects--sweat-drop"}}}}}}}');




const $2e4d77ae69ad5c32$export$d4338585ede77139 = {
    LANES: "lanes",
    MARKINGS: "markings",
    OBJECTS: "objects",
    VEHICLES: "vehicles",
    EFFECTS: "effects"
};
function $2e4d77ae69ad5c32$export$a98ae23047ac0797(type, variant) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($27f7c30d8d4181dc$exports)))[type]?.details?.[variant];
}
function $2e4d77ae69ad5c32$export$7193e2029c8d3aba(group, id) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9c58c773e5ab7013$exports)))[group]?.[id] ?? (0, $0cc5ae9f1eba4866$export$ec56f5044d30d333);
}
/**
 * Retrieves the information for all items that make up a particular component
 * group by looking up the component group and item id in `SEGMENT_COMPONENTS`.
 *
 * @param {string} group - component group name (i.e. `markings`, `lanes`,
 *    `objects`, or `vehicles`)
 * @param {Array} groupItems - items that make up the component group in shape
 *    of [{ id, variants }]
 * @returns {object} componentGroupInfo - returns object in shape of { id:
 *    { characteristics, rules, variants } }
 */ function $2e4d77ae69ad5c32$var$getComponentGroupInfo(group, groupItems) {
    return groupItems.reduce((obj, item)=>{
        obj[item.id] = $2e4d77ae69ad5c32$export$7193e2029c8d3aba(group, item.id);
        return obj;
    }, {});
}
/**
 * Allows for customizable positioning of sprites based on offsetX and offsetY.
 * If a sprite has an offset, return a graphics object in shape of { id,
 * offsetX, offsetY }. If no offset, return the original graphics object.
 *
 * @param {object} graphics
 * @param {number|undefined} offsetX
 * @param {number|undefined} offsetY
 * @returns {object} graphicsWithOffsets
 */ function $2e4d77ae69ad5c32$var$applyOffsetsIfAnyToSprites(graphics, offsetX, offsetY) {
    if (!offsetX && !offsetY) return graphics;
    return Object.entries(graphics).reduce((graphicsWithOffsets, [key, id])=>{
        graphicsWithOffsets[key] = {
            id: id,
            offsetX: offsetX,
            offsetY: offsetY
        };
        return graphicsWithOffsets;
    }, {});
}
/**
 * Retrieves all graphics definitions for the component group based on each
 * `variant` specified for each component group item.
 *
 * @param {Array} groupItems - items that make up the component group in shape
 *    of [ { id, variants } ]
 * @param {object} componentGroupInfo - definition of each item from
 *    `SEGMENT_COMPONENTS` in shape of: { id: { characteristics, rules,
 *     variants } }
 * @returns {Array} componentGroupVariants - returns array of graphic
 *    definitions in shape of [ { graphics } ]
 */ function $2e4d77ae69ad5c32$var$getComponentGroupVariants(groupItems, componentGroupInfo) {
    return groupItems.reduce((array, item)=>{
        const { id: id, offsetX: offsetX, offsetY: offsetY, variants: variants } = item;
        // groupItemVariants - all variants possible for the particular group item
        const groupItemVariants = componentGroupInfo[id] && componentGroupInfo[id].variants;
        if (groupItemVariants && variants) Object.entries(variants).forEach(([variantName, variantKey])=>{
            // variantInfo - graphics definition for specific variants defined by
            // group item
            let variantInfo = groupItemVariants[variantName] ?? (0, $0cc5ae9f1eba4866$export$c246448899355b18);
            const variantKeys = Array.isArray(variantKey) ? variantKey : [
                variantKey
            ];
            variantKeys.forEach((key)=>{
                variantInfo = variantInfo?.[key] ?? (0, $0cc5ae9f1eba4866$export$c246448899355b18);
            });
            const graphics = $2e4d77ae69ad5c32$var$applyOffsetsIfAnyToSprites(variantInfo.graphics, offsetX, offsetY);
            array.push(graphics);
        });
        return array;
    }, []);
}
/**
 * A segment may contain multiple graphics for the same graphics type ('left',
 * 'right', 'repeat', 'center'). When encountering a new graphic for the same
 * graphics type, this function creates a new array that contains both the new
 * graphic as well as the existing graphics.
 *
 * @param {Array|string} target
 * @param {Array|string} source
 * @returns {Array} graphicsInfo
 */ function $2e4d77ae69ad5c32$var$appendVariantSprites(target, source) {
    const targetArray = Array.isArray(target) ? target : [
        target
    ];
    const sourceArray = Array.isArray(source) ? source : [
        source
    ];
    const graphicsInfo = targetArray.concat(sourceArray);
    return (0, $4bfa44e801f4950c$export$7a5d5c156e7dc406)(graphicsInfo);
}
/**
 * Merges the array of graphic definition objects needed to render the segment
 * into a single object.
 *
 * @param {Array} variantGraphics
 * @returns {object} graphics
 */ function $2e4d77ae69ad5c32$var$mergeVariantGraphics(variantGraphics) {
    return variantGraphics.reduce((graphics, variantInfo)=>{
        if (variantInfo) Object.keys(variantInfo).forEach((key)=>{
            const target = graphics[key];
            const source = variantInfo[key];
            if (target) graphics[key] = $2e4d77ae69ad5c32$var$appendVariantSprites(target, source);
            else graphics[key] = source;
        });
        return graphics;
    }, {});
}
function $2e4d77ae69ad5c32$export$389bf7711de3951d(details, segmentRules) {
    const { rules: rules, ...segmentInfoOverrides } = details;
    return Object.assign({}, segmentRules, rules, segmentInfoOverrides);
}
/**
 * Based on the list of `lanes`, `markings`, `objects`, and/or `vehicles`
 * components that makes up the segment `type` and `variant`, this function
 * creates a graphics object with all the sprite definitions needed to
 * render the segment.
 *
 * @param {Object} components - all segment components that make up the
 *    segment `type` and `variant`
 * @returns {Object} sprites - all sprite definitions necessary to render the
 *    segment
 */ const $2e4d77ae69ad5c32$var$gatherAnalytics = (componentArray, mapSection)=>{
    // so what do we have?
    if (!componentArray) return [];
    // if (componentArray.length > 0) {
    //   console.log({ withAnalytics, componentArray })
    // }
    return {};
};
function $2e4d77ae69ad5c32$export$2c6827c64264988e({ objects: objects, lanes: lanes, vehicles: vehicles, markings: markings }) {
    // 1) Loop through each component group that makes up the segment.
    const analytics = {};
    analytics.vehicles = $2e4d77ae69ad5c32$var$gatherAnalytics(vehicles, "vehicles");
    analytics.objects = $2e4d77ae69ad5c32$var$gatherAnalytics(objects, "objects");
    analytics.lanes = $2e4d77ae69ad5c32$var$gatherAnalytics(lanes, "lanes");
    analytics.markings = $2e4d77ae69ad5c32$var$gatherAnalytics(markings, "markings");
    return analytics;
}
function $2e4d77ae69ad5c32$export$fa11934e65823f59(components) {
    // 1) Loop through each component group that makes up the segment.
    const sprites = Object.entries(components).reduce((graphicsArray, componentGroup)=>{
        const [group, groupItems] = componentGroup;
        // 2) For each component group, look up the segment information for every
        // item that makes up the component group.
        // componentGroupInfo = [ { characteristics, rules, variants } ]
        const componentGroupInfo = $2e4d77ae69ad5c32$var$getComponentGroupInfo(group, groupItems);
        // The "markings" component group does not have any variants, so we do
        // not have to go through the variants in order to get the sprite
        // definitions.
        if (group === $2e4d77ae69ad5c32$export$d4338585ede77139.MARKINGS) Object.values(componentGroupInfo).forEach((groupItem)=>{
            graphicsArray.push(groupItem.graphics);
        });
        else {
            // componentGroupVariants = [ { graphics } ]
            // 3) For each component group, look up the segment variant graphics
            // for every item that makes up the component group.
            const componentGroupVariants = $2e4d77ae69ad5c32$var$getComponentGroupVariants(groupItems, componentGroupInfo);
            if (componentGroupVariants.length) // 4) Combine the variant graphics for each component group into one
            // array
            componentGroupVariants.forEach((groupItemVariants)=>{
                graphicsArray.push(groupItemVariants);
            });
        }
        return graphicsArray;
    }, []);
    // 5) Combine the variant graphics into one graphics definition object.
    return $2e4d77ae69ad5c32$var$mergeVariantGraphics(sprites);
}


var $cdbf44d0de1d97d7$exports = {};
$cdbf44d0de1d97d7$exports = JSON.parse('{"markings--straight-inbound-light":{"id":"markings--straight-inbound-light","originY":120},"markings--straight-outbound-light":{"id":"markings--straight-outbound-light","originY":120},"markings--straight-inbound":{"id":"markings--straight-inbound","originY":120},"markings--straight-outbound":{"id":"markings--straight-outbound","originY":120},"markings--left-inbound":{"id":"markings--left-inbound","originY":120},"markings--left-outbound":{"id":"markings--left-outbound","originY":120},"markings--left-straight-inbound":{"id":"markings--left-straight-inbound","originY":120},"markings--left-straight-outbound":{"id":"markings--left-straight-outbound","originY":120},"markings--right-inbound":{"id":"markings--right-inbound","originY":120},"markings--right-outbound":{"id":"markings--right-outbound","originY":120},"markings--right-straight-inbound":{"id":"markings--right-straight-inbound","originY":120},"markings--right-straight-outbound":{"id":"markings--right-straight-outbound","originY":120},"markings--both-inbound":{"id":"markings--both-inbound","originY":120},"markings--both-outbound":{"id":"markings--both-outbound","originY":120},"markings--left-right-straight-inbound":{"id":"markings--left-right-straight-inbound","originY":120},"markings--left-right-straight-outbound":{"id":"markings--left-right-straight-outbound","originY":120},"markings--shared-inbound":{"id":"markings--shared-inbound","originY":120},"markings--shared-outbound":{"id":"markings--shared-outbound","originY":120},"markings--sharrow-inbound":{"id":"markings--sharrow-inbound","originY":120},"markings--sharrow-outbound":{"id":"markings--sharrow-outbound","originY":120},"markings--lane-left":{"id":"markings--lane-left","originY":120},"markings--lane-right":{"id":"markings--lane-right","originY":120},"markings--lane-left-half":{"id":"markings--lane-left-half","originY":120},"markings--lane-right-half":{"id":"markings--lane-right-half","originY":120},"markings--lane-horiz":{"id":"markings--lane-horiz","originY":120},"markings--center-lane":{"id":"markings--center-lane","originY":120},"markings--center-lane-left":{"id":"markings--center-lane-left","originY":120},"markings--center-lane-right":{"id":"markings--center-lane-right","originY":120},"markings--parking-left":{"id":"markings--parking-left","originY":120},"markings--parking-right":{"id":"markings--parking-right","originY":120},"markings--streetcar-track-01":{"id":"markings--streetcar-track-01","originY":120},"markings--streetcar-track-02":{"id":"markings--streetcar-track-02","originY":120},"markings--stripes-diagonal":{"id":"markings--stripes-diagonal","originY":120},"markings--crosswalk-zebra":{"id":"markings--crosswalk-zebra","originY":120},"markings--crosswalk-zebra-bike":{"id":"markings--crosswalk-zebra-bike","originY":120},"lamps--lamp-modern-left":{"id":"lamps--lamp-modern-left","offsetX":-315},"lamps--lamp-modern-right":{"id":"lamps--lamp-modern-right","offsetX":-315},"lamps--lamp-traditional-right":{"id":"lamps--lamp-traditional-right","offsetX":-45},"lamps--lamp-traditional-left":{"id":"lamps--lamp-traditional-left","offsetX":-45},"lamps--pride-banner-right":{"id":"lamps--pride-banner-right","offsetX":-83,"originY":-536},"lamps--pride-banner-left":{"id":"lamps--pride-banner-left","offsetX":-83,"originY":-536},"effects--sweat-drop":{"id":"effects--sweat-drop","originY":-160},"missing":{"id":"missing"}}');


const $0cc5ae9f1eba4866$export$fca129adbb061794 = {
    NONE: "none",
    CAR: "car",
    BIKE: "bike",
    PEDESTRIAN: "pedestrian",
    TRANSIT: "transit",
    NATURE: "nature",
    FLEX: "flex",
    UTILITY: "utility"
};
const $0cc5ae9f1eba4866$export$ec56f5044d30d333 = {
    unknown: true,
    name: "Unknown",
    owner: "NONE",
    zIndex: 1,
    variants: [],
    details: {}
};
const $0cc5ae9f1eba4866$export$c246448899355b18 = {
    unknown: true,
    name: "Unknown",
    graphics: {
        center: "missing"
    }
};
function $0cc5ae9f1eba4866$export$6f0b746a8dc0c47d() {
    return 0, (/*@__PURE__*/$parcel$interopDefault($27f7c30d8d4181dc$exports));
}
function $0cc5ae9f1eba4866$export$999c0cd701be1fe2() {
    return Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($27f7c30d8d4181dc$exports)))).map((id)=>{
        const segment = {
            ...(0, (/*@__PURE__*/$parcel$interopDefault($27f7c30d8d4181dc$exports)))[id]
        };
        segment.id = id;
        return segment;
    });
}
function $0cc5ae9f1eba4866$export$c3985e6b9763d4c2(type) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($27f7c30d8d4181dc$exports)))[type] || $0cc5ae9f1eba4866$export$ec56f5044d30d333;
}
function $0cc5ae9f1eba4866$export$a7e4a724089e6511(type, variant) {
    const segmentLookup = (0, $2e4d77ae69ad5c32$export$a98ae23047ac0797)(type, variant);
    const { rules: rules } = $0cc5ae9f1eba4866$export$c3985e6b9763d4c2(type);
    if (!segmentLookup || !segmentLookup.components) return $0cc5ae9f1eba4866$export$c246448899355b18;
    const { components: components, ...details } = segmentLookup;
    const variantInfo = (0, $2e4d77ae69ad5c32$export$389bf7711de3951d)(details, rules);
    variantInfo.graphics = (0, $2e4d77ae69ad5c32$export$fa11934e65823f59)(components);
    // Assuming a segment has one "lane" component, a segment's elevation can be found using the id
    // of the first item in the "lane" component group.
    const lane = (0, $2e4d77ae69ad5c32$export$7193e2029c8d3aba)((0, $2e4d77ae69ad5c32$export$d4338585ede77139).LANES, components.lanes[0].id);
    variantInfo.elevation = lane.elevation;
    return variantInfo;
}
function $0cc5ae9f1eba4866$export$28d35a9efc690b32(sprite) {
    let def;
    if (typeof sprite === "object" && sprite.id) def = {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($cdbf44d0de1d97d7$exports)))[sprite.id] || {
            id: sprite.id
        },
        ...sprite
    };
    else // Clone the original to prevent downstream consumers from accidentally
    // modifying the reference
    def = {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($cdbf44d0de1d97d7$exports)))[sprite] || {
            id: sprite
        }
    };
    return def;
}


const $f22063bb59944341$var$VARIANT_SEPARATOR = "|";
function $f22063bb59944341$export$4ad6a18860f0a250(segmentType, variantString) {
    const variantArray = {};
    const variantSplit = variantString.split($f22063bb59944341$var$VARIANT_SEPARATOR);
    const segment = (0, $0cc5ae9f1eba4866$export$c3985e6b9763d4c2)(segmentType);
    if (segment && segment.variants) for(const i in segment.variants){
        const variantName = segment.variants[i];
        variantArray[variantName] = variantSplit[i];
    }
    return variantArray;
}
function $f22063bb59944341$export$ee6cd03efc4c2fda(variant) {
    return Object.values(variant).join($f22063bb59944341$var$VARIANT_SEPARATOR);
}


const $2a9a05c10189c2fe$export$a312938bcd95f73c = 1;
const $2a9a05c10189c2fe$export$fe67c041c7fe7c2 = 2;
const $2a9a05c10189c2fe$export$1d24f35997388cf = 10;
const $2a9a05c10189c2fe$export$59cfd33ad5cf1eb5 = 400;
const $2a9a05c10189c2fe$export$1b78ec9723991b5b = 0.01;
const $2a9a05c10189c2fe$export$cb0b75edbeba6d1a = "day";
const $2a9a05c10189c2fe$export$c5891348590052ef = -1;
const $2a9a05c10189c2fe$export$71fb380783452ca7 = -2;
const $2a9a05c10189c2fe$export$7af673c5969ee7ae = -3;
const $2a9a05c10189c2fe$export$9c2554d45cd8fa3 = "giz";


// Originally, our images were drawn at 2x for Retina display.
// As we've moved to vector images, "2x" is meaningless, but the intrinsic
// height/width dimensions have not changed.
const $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8 = 2.54;
const $e1cc3cddc7acf1a4$export$cf9ad17145f68381 = 12 // pixels
;
const $e1cc3cddc7acf1a4$export$15ebb2a9274a9953 = $e1cc3cddc7acf1a4$export$cf9ad17145f68381 * $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8 // pixels
;
const $e1cc3cddc7acf1a4$export$256c1c4ce479d4eb = 1 / 0.3 * 0.25 // This is equal to 0.25m in our conversion rate
;
const $e1cc3cddc7acf1a4$export$2b083f3fca24a6b6 = 400;
const $e1cc3cddc7acf1a4$export$f5d69cc55972365c = 40 // pixels
;
const $e1cc3cddc7acf1a4$export$bd07f8babb22a89f = 1;
const $e1cc3cddc7acf1a4$export$1603ba7a45cd1a72 = 2;
const $e1cc3cddc7acf1a4$export$529213ff1df6a1b5 = 3;
const $e1cc3cddc7acf1a4$export$fccc01258576ea7b = 4;
const $e1cc3cddc7acf1a4$export$c7ef544a1adca2d6 = 0.25;
const $e1cc3cddc7acf1a4$export$474261edb3c0b6ca = 0.5;
const $e1cc3cddc7acf1a4$export$dbafd772cd28647 = 0.5;
const $e1cc3cddc7acf1a4$export$b2b225ef5ec57165 = 1 / 6;
const $e1cc3cddc7acf1a4$export$fa164b74c4a93529 = 2 / 6;
const $e1cc3cddc7acf1a4$export$89f47eebe5aba3a7 = 2 / 6;
const $e1cc3cddc7acf1a4$export$5ed14aee9e214d04 = 0;
const $e1cc3cddc7acf1a4$export$78a78b4ad4d2f0b9 = 2;
const $e1cc3cddc7acf1a4$export$e9db4516ea26d802 = 3;
const $e1cc3cddc7acf1a4$export$e552ca0126db39e7 = 50;
const $e1cc3cddc7acf1a4$export$8b837123dd5f6a79 = 360;
const $e1cc3cddc7acf1a4$export$9b73353ccd49a9a9 = 20;
const $e1cc3cddc7acf1a4$export$7211beef3b5b06fd = "left";
const $e1cc3cddc7acf1a4$export$876aaa6ed6810492 = "right";



const $8b007b7ac0907036$var$initialState = {
    segments: [],
    remainingWidth: 0,
    environment: (0, $2a9a05c10189c2fe$export$cb0b75edbeba6d1a),
    userUpdated: false,
    leftBuildingHeight: 0,
    rightBuildingHeight: 0,
    immediateRemoval: true
};
const $8b007b7ac0907036$var$streetSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "street",
    initialState: $8b007b7ac0907036$var$initialState,
    reducers: {
        // This completely replaces arbitrary street data. The other actions below
        // are much more surgical and should be used instead of this one for small
        // updates. Use this one if you need to batch multiple actions into one.
        updateStreetData (state, action) {
            return {
                ...state,
                ...action.payload,
                immediateRemoval: true
            };
        },
        addSegment: {
            reducer (state, action) {
                const { index: index, segment: segment } = action.payload;
                state.segments.splice(index, 0, segment);
            },
            prepare (index, segment) {
                return {
                    payload: {
                        index: index,
                        segment: segment
                    }
                };
            }
        },
        removeSegment: {
            reducer (state, action) {
                const { index: index, immediate: immediate } = action.payload;
                state.segments.splice(index, 1);
                state.immediateRemoval = immediate;
            },
            prepare (index, immediate = true) {
                return {
                    payload: {
                        index: index,
                        immediate: immediate
                    }
                };
            }
        },
        moveSegment: {
            reducer (state, action) {
                const { fromIndex: fromIndex, toIndex: toIndex } = action.payload;
                const segment = state.segments[fromIndex];
                state.segments.splice(fromIndex, 1);
                state.segments.splice(toIndex, 0, segment);
            },
            prepare (fromIndex, toIndex) {
                return {
                    payload: {
                        fromIndex: fromIndex,
                        toIndex: toIndex
                    }
                };
            }
        },
        updateShowAnalytics (state, action) {
            state.showAnalytics = action.payload;
        },
        updateCapacitySource (state, action) {
            state.capacitySource = action.payload;
        },
        updateSegments: {
            reducer (state, action) {
                const { segments: segments, occupiedWidth: occupiedWidth, remainingWidth: remainingWidth } = action.payload;
                state.segments = segments;
                state.occupiedWidth = occupiedWidth;
                state.remainingWidth = remainingWidth;
            },
            prepare (segments, occupiedWidth, remainingWidth) {
                return {
                    payload: {
                        segments: segments,
                        occupiedWidth: occupiedWidth,
                        remainingWidth: remainingWidth
                    }
                };
            }
        },
        clearSegments (state, action) {
            state.segments = [];
            state.immediateRemoval = true;
        },
        changeSegmentWidth: {
            reducer (state, action) {
                const { index: index, width: width } = action.payload;
                state.segments[index].width = width;
            },
            prepare (index, width) {
                return {
                    payload: {
                        index: index,
                        width: width
                    }
                };
            }
        },
        changeSegmentVariant: {
            reducer (state, action) {
                const { index: index, set: set, selection: selection } = action.payload;
                const segment = state.segments[index];
                // Monkey-patch
                // Address a situation where the .variant property may not
                // exist. Ideally, it should always be present and be an
                // object. If it doesn't exist, create an empty object now.
                // TODO: Guarantee that segment always the `variant` property
                // and remove this.
                segment.variant = segment.variant ?? {};
                segment.variant[set] = selection;
                segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(segment.variant);
                // When an element is changed, we also need to set the segment's
                // elevation from the new variant information. Sometimes a
                // variant has different elevations, see "divider" type for example
                // NOTE: skip this if `enableElevation` is on
                const segmentInfo = (0, $0cc5ae9f1eba4866$export$c3985e6b9763d4c2)(segment.type);
                const variantInfo = (0, $0cc5ae9f1eba4866$export$a7e4a724089e6511)(segment.type, segment.variantString);
                if (segmentInfo.enableElevation !== true) segment.elevation = variantInfo.elevation;
            },
            prepare (index, set, selection) {
                return {
                    payload: {
                        index: index,
                        set: set,
                        selection: selection
                    }
                };
            }
        },
        changeSegmentProperties: {
            reducer (state, action) {
                const { index: index, properties: properties } = action.payload;
                Object.assign(state.segments[index], properties);
            },
            prepare (index, properties) {
                return {
                    payload: {
                        index: index,
                        properties: properties
                    }
                };
            }
        },
        saveStreetName: {
            reducer (state, action) {
                const { streetName: streetName, userUpdated: userUpdated } = action.payload;
                if (state.userUpdated && userUpdated || !state.userUpdated) {
                    if (typeof streetName === "string") // Normalize street name input
                    // TODO: Consider whether to limit street name length here
                    state.name = streetName.trim();
                    else // If a streetname is null, unset it
                    state.name = null;
                }
                if (userUpdated) state.userUpdated = true;
            },
            prepare (streetName, userUpdated) {
                return {
                    payload: {
                        streetName: streetName,
                        userUpdated: userUpdated
                    }
                };
            }
        },
        saveCreatorId (state, action) {
            state.creatorId = action.payload;
        },
        saveStreetId: {
            reducer (state, action) {
                const { id: id, namespacedId: namespacedId } = action.payload;
                // Why is this not always present?
                if (id) state.id = id;
                state.namespacedId = namespacedId;
            },
            prepare (id, namespacedId) {
                return {
                    payload: {
                        id: id,
                        namespacedId: namespacedId
                    }
                };
            }
        },
        updateStreetIdMetadata (state, action) {
            const { creatorId: creatorId, id: id, namespacedId: namespacedId } = action.payload;
            state.creatorId = creatorId;
            state.id = id;
            state.namespacedId = namespacedId;
        },
        // TODO: validate time (payload) is a string matching ISO string format
        setUpdateTime (state, action) {
            state.updatedAt = action.payload;
            state.clientUpdatedAt = action.payload;
        },
        saveOriginalStreetId (state, action) {
            state.originalStreetId = action.payload;
        },
        updateEditCount (state, action) {
            state.editCount = action.payload;
        },
        setUnits (state, action) {
            state.units = action.payload;
        },
        updateStreetWidth (state, action) {
            state.width = action.payload;
        },
        updateSchemaVersion (state, action) {
            state.schemaVersion = action.payload;
        },
        addLocation (state, action) {
            state.location = action.payload;
        },
        clearLocation (state, action) {
            state.location = null;
            // If the street name was added as a result of geotagging, but not
            // updated by the user, then clearing the location also resets the
            // street name
            if (!state.userUpdated) state.name = null;
        },
        // TODO: Buildings could be a child slice?
        addBuildingFloor (state, action) {
            const position = action.payload;
            switch(position){
                case 0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd:
                    state.leftBuildingHeight = Math.min(state.leftBuildingHeight + 1, (0, $e1cc3cddc7acf1a4$export$9b73353ccd49a9a9));
                    break;
                case 0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492:
                    state.rightBuildingHeight = Math.min(state.rightBuildingHeight + 1, (0, $e1cc3cddc7acf1a4$export$9b73353ccd49a9a9));
                    break;
                default:
                    break;
            }
        },
        removeBuildingFloor (state, action) {
            const position = action.payload;
            switch(position){
                case 0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd:
                    state.leftBuildingHeight = Math.max(state.leftBuildingHeight - 1, 1);
                    break;
                case 0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492:
                    state.rightBuildingHeight = Math.max(state.rightBuildingHeight - 1, 1);
                    break;
                default:
                    break;
            }
        },
        setBuildingFloorValue: {
            reducer (state, action) {
                const value = Number.parseInt(action.payload.value, 10);
                if (Number.isNaN(value)) return;
                const { position: position } = action.payload;
                switch(position){
                    case 0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd:
                        state.leftBuildingHeight = Math.min(Math.max(value, 1), (0, $e1cc3cddc7acf1a4$export$9b73353ccd49a9a9));
                        break;
                    case 0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492:
                        state.rightBuildingHeight = Math.min(Math.max(value, 1), (0, $e1cc3cddc7acf1a4$export$9b73353ccd49a9a9));
                        break;
                    default:
                        break;
                }
            },
            prepare (position, value) {
                return {
                    payload: {
                        position: position,
                        value: value
                    }
                };
            }
        },
        setBuildingVariant: {
            reducer (state, action) {
                const { position: position, variant: variant } = action.payload;
                if (!variant) return;
                switch(position){
                    case 0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd:
                        state.leftBuildingVariant = variant;
                        break;
                    case 0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492:
                        state.rightBuildingVariant = variant;
                        break;
                    default:
                        break;
                }
            },
            prepare (position, variant) {
                return {
                    payload: {
                        position: position,
                        variant: variant
                    }
                };
            }
        },
        setEnvironment (state, action) {
            state.environment = action.payload;
        }
    }
});
const { updateStreetData: $8b007b7ac0907036$export$abace6e40841f465, addSegment: $8b007b7ac0907036$export$1c43f9ac826b6462, removeSegment: $8b007b7ac0907036$export$d0365e48b58231c3, moveSegment: $8b007b7ac0907036$export$55ccf7f86f8c547, updateSegments: $8b007b7ac0907036$export$6a7fdf0c7a380248, updateShowAnalytics: $8b007b7ac0907036$export$69ad636194e76aaf, updateCapacitySource: $8b007b7ac0907036$export$5e4f004acdec411e, clearSegments: $8b007b7ac0907036$export$a69bfd14b8dc5d4d, changeSegmentWidth: $8b007b7ac0907036$export$e370ec602acb2164, changeSegmentVariant: $8b007b7ac0907036$export$1fcfea2408a636c0, changeSegmentProperties: $8b007b7ac0907036$export$ab16e687658adf3f, saveStreetName: $8b007b7ac0907036$export$eb36756120db063a, saveCreatorId: $8b007b7ac0907036$export$5edca91ccdd4a230, saveStreetId: $8b007b7ac0907036$export$750a818a04268f3, updateStreetIdMetadata: $8b007b7ac0907036$export$31a813945c518bcb, setUpdateTime: $8b007b7ac0907036$export$f85cd13c464f6e72, saveOriginalStreetId: $8b007b7ac0907036$export$2d8fcfbae302074f, updateEditCount: $8b007b7ac0907036$export$1cc6e452ae697b42, setUnits: $8b007b7ac0907036$export$c84001c9e3ebd004, updateStreetWidth: $8b007b7ac0907036$export$c61bfb5183745fe1, updateSchemaVersion: $8b007b7ac0907036$export$3afcb05a67a7e64a, addLocation: $8b007b7ac0907036$export$f664da56b7f6aade, clearLocation: $8b007b7ac0907036$export$951047f7fbed997e, addBuildingFloor: $8b007b7ac0907036$export$2ddfb6d386c1281f, removeBuildingFloor: $8b007b7ac0907036$export$3774ee57e8d91092, setBuildingFloorValue: $8b007b7ac0907036$export$149c168440d6be8, setBuildingVariant: $8b007b7ac0907036$export$42d56e5baa9ff42b, setEnvironment: $8b007b7ac0907036$export$333037a86af0852f } = $8b007b7ac0907036$var$streetSlice.actions;
var $8b007b7ac0907036$export$2e2bcd8739ae039 = $8b007b7ac0907036$var$streetSlice.reducer;


const $5b2c2d9c813ed442$var$initialState = {
    markerLocation: null,
    addressInformation: {},
    rawInputString: null
};
const $5b2c2d9c813ed442$var$mapSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "map",
    initialState: $5b2c2d9c813ed442$var$initialState,
    reducers: {
        setMapState (state, action) {
            return {
                ...state,
                ...action.payload
            };
        },
        resetMapState () {
            return $5b2c2d9c813ed442$var$initialState;
        }
    },
    extraReducers: (builder)=>{
        // If location is cleared from the street, also reset map state.
        builder.addCase((0, $8b007b7ac0907036$export$951047f7fbed997e), (state)=>$5b2c2d9c813ed442$var$initialState);
    }
});
const { setMapState: $5b2c2d9c813ed442$export$190ceb974fb80f01, resetMapState: $5b2c2d9c813ed442$export$2612bdf4c0ed64d7 } = $5b2c2d9c813ed442$var$mapSlice.actions;
var $5b2c2d9c813ed442$export$2e2bcd8739ae039 = $5b2c2d9c813ed442$var$mapSlice.reducer;





const $3857de86d8e7589b$var$initialState = null;
const $3857de86d8e7589b$var$menusSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "menus",
    initialState: $3857de86d8e7589b$var$initialState,
    reducers: {
        showMenu (state, action) {
            return action.payload;
        },
        clearMenus (state) {
            return null;
        }
    },
    // Certain other actions in the app will also hide menus.
    extraReducers: (builder)=>{
        builder.addCase("gallery/openGallery/pending", (state)=>null).addCase((0, $cdf0aaca62d15025$export$61e0a65f251cfdb3), (state)=>null).addCase((0, $9dbab908c178b0dc$export$e000c6e7623fb0b), (state)=>null);
    }
});
const { showMenu: $3857de86d8e7589b$export$978857af675b1906, clearMenus: $3857de86d8e7589b$export$72f2284798989788 } = $3857de86d8e7589b$var$menusSlice.actions;
var $3857de86d8e7589b$export$2e2bcd8739ae039 = $3857de86d8e7589b$var$menusSlice.reducer;



const $ea458c15ce872cdc$export$8fb1017c0fcda1f2 = "/services/auth/just-signed-in";
const $ea458c15ce872cdc$export$3ae46e95ba6bc5da = "/new";
const $ea458c15ce872cdc$export$429952ed111074be = "/copy-last";
const $ea458c15ce872cdc$export$a2f884de85292fcc = "/gallery";
const $ea458c15ce872cdc$export$dc5f3e43ad7e20d7 = "/error";
const $ea458c15ce872cdc$export$b36ab1ea8869f936 = "/help";
const $ea458c15ce872cdc$export$151b51d71f05f143 = "/survey-finished";
const $ea458c15ce872cdc$export$92749ba741d24778 = "no-twitter-request-token";
const $ea458c15ce872cdc$export$89c51d790cd3b8fb = "no-twitter-access-token";
const $ea458c15ce872cdc$export$14a04031658e30cc = "no-access-token";
const $ea458c15ce872cdc$export$b9c806d46ea9d197 = "authentication-api-problem";
const $ea458c15ce872cdc$export$58cbfa1605fc1c1 = "access-denied";
const $ea458c15ce872cdc$export$e18d42a3291f46e5 = "/streetmix/7";
const $ea458c15ce872cdc$export$3af3ea5b418067c6 = [
    "/services",
    $ea458c15ce872cdc$export$3ae46e95ba6bc5da,
    $ea458c15ce872cdc$export$429952ed111074be,
    $ea458c15ce872cdc$export$a2f884de85292fcc,
    $ea458c15ce872cdc$export$dc5f3e43ad7e20d7,
    $ea458c15ce872cdc$export$b36ab1ea8869f936,
    $ea458c15ce872cdc$export$151b51d71f05f143,
    "/streets",
    "/terms-of-service",
    "/privacy-policy",
    "/map",
    "/survey"
];
const $ea458c15ce872cdc$export$acb4d8914445708a = "~";
const $ea458c15ce872cdc$export$d741617d68d238f5 = "light";
const $ea458c15ce872cdc$export$fb86e74aa5a87996 = "dark";
const $ea458c15ce872cdc$export$6897e1d0e3ecb51c = "auto";




const $91ffa8e8b26e8ad0$var$initialState = {
    lastStreetId: null,
    lastStreetNamespacedId: null,
    lastStreetCreatorId: null,
    newStreetPreference: (0, $2a9a05c10189c2fe$export$a312938bcd95f73c),
    saveAsImageTransparentSky: false,
    saveAsImageSegmentNamesAndWidths: false,
    saveAsImageStreetName: false,
    saveAsImageWatermark: true,
    colorMode: (0, $ea458c15ce872cdc$export$d741617d68d238f5),
    locale: null,
    units: null
};
const $91ffa8e8b26e8ad0$var$settingsSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "settings",
    initialState: $91ffa8e8b26e8ad0$var$initialState,
    reducers: {
        updateSettings (state, action) {
            return {
                ...state,
                ...action.payload
            };
        },
        setUserUnits (state, action) {
            const units = action.payload;
            state.units = units;
        },
        setUserColorMode (state, action) {
            const mode = action.payload;
            state.colorMode = mode;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase((0, $0083fa256c596554$export$7343075cd7f756c5).fulfilled, (state, action)=>{
            state.locale = action.payload.locale;
        });
    }
});
const { updateSettings: $91ffa8e8b26e8ad0$export$f558026a994b6051, setUserUnits: $91ffa8e8b26e8ad0$export$df095147a62dd3c4, setUserColorMode: $91ffa8e8b26e8ad0$export$c017d343292b73d0 } = $91ffa8e8b26e8ad0$var$settingsSlice.actions;
var $91ffa8e8b26e8ad0$export$2e2bcd8739ae039 = $91ffa8e8b26e8ad0$var$settingsSlice.reducer;




const $c8f034bd96be731d$var$initialState = {
    // "Phone" detection is based on "max screen size"
    phone: typeof window.matchMedia !== "undefined" && (window.matchMedia("only screen and (max-device-width: 480px)").matches || window.matchMedia("only screen and (max-device-height: 480px)").matches) || false,
    safari: navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome") || false,
    windows: navigator.userAgent.includes("Windows") || false,
    offline: false,
    devicePixelRatio: window.devicePixelRatio || 1.0
};
const $c8f034bd96be731d$var$systemSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "system",
    initialState: $c8f034bd96be731d$var$initialState,
    reducers: {
        setSystemFlags (state, action) {
            return {
                ...state,
                ...action.payload
            };
        }
    }
});
const { setSystemFlags: $c8f034bd96be731d$export$5270136fc5522349 } = $c8f034bd96be731d$var$systemSlice.actions;
var $c8f034bd96be731d$export$2e2bcd8739ae039 = $c8f034bd96be731d$var$systemSlice.reducer;



/**
 * Toasts are objects with the following signature.
 *
 * provided by dispatch:
 * mode - string (optional) - type of toast, if any. one of 'success', 'warning', or empty
 *              changes appearance, and possibly aria role.
 * component - enum (optional) - special toast that is attached to code.
 *              special toasts wrap toast components, so they can also use their own
 *              text. when calling a component, none of the other properties are required
 * title - string (optional) - a title to display if any
 * message - string (required) - a message to display. required if component is not specified
 * action (label) - string (optional) - a button action label. buttons trigger code so
 *              usually they're only attached through components. but this can override the
 *              label possibly.
 * duration (default: 6000 (ms), forever: null ) - number. time to expire if different length
 *              is required. if you want it to be on screen indefinitely set duration to
 *              Infinity, so it never expires. this means the only way to remove the toast is
 *              to dismiss it (whether by user interaction or other code)
 *
 * auto generated:
 * timestamp (auto generated at time of execution) - use this as unique id
 *    TODO: collisions on this are possible, but we can ignore that for now
 */ const $ed796acc6691d871$var$initialState = [];
const $ed796acc6691d871$var$toastsSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "toasts",
    initialState: $ed796acc6691d871$var$initialState,
    reducers: {
        addToast: {
            reducer (state, action) {
                state.push(action.payload);
            },
            prepare (toast) {
                return {
                    payload: {
                        ...toast,
                        // The timestamp is used to identify when a toast is generated,
                        // and currently does double duty as a unique identifier. This
                        // must be done here (in an action creator prepare()) as opposed
                        // to the reducer because this is *not* a pure function.
                        timestamp: Date.now()
                    }
                };
            }
        },
        destroyToast (state, action) {
            return state.filter((item)=>item.timestamp !== action.payload);
        }
    }
});
const { addToast: $ed796acc6691d871$export$2cb648f4e71e8121, destroyToast: $ed796acc6691d871$export$2babc7f6097192ff } = $ed796acc6691d871$var$toastsSlice.actions;
var $ed796acc6691d871$export$2e2bcd8739ae039 = $ed796acc6691d871$var$toastsSlice.reducer;




const $cb9eeb171d537a5a$var$initialState = {
    welcomePanelVisible: false,
    welcomePanelDismissed: false,
    toolboxVisible: false,
    activeSegment: null,
    draggingState: null,
    draggingType: 0,
    resizeGuidesVisible: false
};
const $cb9eeb171d537a5a$var$uiSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "ui",
    initialState: $cb9eeb171d537a5a$var$initialState,
    reducers: {
        setWelcomePanelVisible (state, action) {
            state.welcomePanelVisible = true;
        },
        setWelcomePanelDismissed (state, action) {
            state.welcomePanelDismissed = true;
            state.welcomePanelVisible = false;
        },
        setActiveSegment (state, action) {
            // If we're in the middle of a resize drag state, do not set a new
            // active segment.
            if (!state.resizeGuidesVisible) state.activeSegment = action.payload;
        },
        initDraggingState (state, action) {
            state.draggingType = action.payload;
        },
        updateDraggingState (state, action) {
            if (!action.payload) state.draggingState = null;
            else state.draggingState = {
                segmentBeforeEl: action.payload.segmentBeforeEl,
                segmentAfterEl: action.payload.segmentAfterEl,
                draggedSegment: action.payload.draggedSegment
            };
        },
        clearDraggingState (state, action) {
            state.draggingState = null;
            state.draggingType = (0, $e1cc3cddc7acf1a4$export$5ed14aee9e214d04);
        },
        setDraggingType (state, action) {
            state.draggingType = action.payload;
            state.resizeGuidesVisible = action.payload === (0, $e1cc3cddc7acf1a4$export$e9db4516ea26d802);
        },
        toggleToolbox (state, action) {
            state.toolboxVisible = !state.toolboxVisible;
        }
    }
});
const { setWelcomePanelVisible: $cb9eeb171d537a5a$export$a7ea15a59aa12c50, setWelcomePanelDismissed: $cb9eeb171d537a5a$export$3369e50a27dc5360, setActiveSegment: $cb9eeb171d537a5a$export$20b4b8898e0d9c76, initDraggingState: $cb9eeb171d537a5a$export$cb642e0702fc5c43, updateDraggingState: $cb9eeb171d537a5a$export$ba0bd4c7b78378ac, clearDraggingState: $cb9eeb171d537a5a$export$df5412d804d98b77, setDraggingType: $cb9eeb171d537a5a$export$762b34a064c02e3b, toggleToolbox: $cb9eeb171d537a5a$export$8cfc7625e381dff9 } = $cb9eeb171d537a5a$var$uiSlice.actions;
var $cb9eeb171d537a5a$export$2e2bcd8739ae039 = $cb9eeb171d537a5a$var$uiSlice.reducer;



const $0e3fada570e844f5$export$24df5979dca24738 = 100;
const $0e3fada570e844f5$var$initialState = {
    stack: [],
    position: 0
};
/**
 * If undoStack is higher than limit, trim earliest entries so that stack is
 * within the undo limit.
 */ function $0e3fada570e844f5$var$trimUndoStack(undoStack) {
    const diff = undoStack.length - $0e3fada570e844f5$export$24df5979dca24738;
    if (diff > 0) return undoStack.slice(diff);
    else return undoStack;
}
/**
 * Each item in the stack should share the same meta data.
 *
 * @todo maybe we shouldn't keep repeated info in the stack, but each item
 *          in the stack are currently just street data objects
 * @param {Array} undoStack - the undo stack to unify
 * @param {Object} street - the street containing properties that should be
 *          copied to all other streets in the stack
 */ function $0e3fada570e844f5$var$unifyUndoStack(undoStack, street) {
    return undoStack.map((item)=>{
        item.id = street.id;
        item.name = street.name;
        item.namespacedId = street.namespacedId;
        item.creatorId = street.creatorId;
        item.updatedAt = street.updatedAt;
        return item;
    });
}
const $0e3fada570e844f5$var$undoSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "undo",
    initialState: $0e3fada570e844f5$var$initialState,
    reducers: {
        undo (state, action) {
            const newPosition = state.position - 1;
            state.stack[state.position] = action.payload;
            state.position = newPosition < 0 ? 0 : newPosition;
        },
        redo (state, action) {
            const newPosition = state.position + 1;
            const stackSize = state.stack.length - 1;
            state.position = newPosition > stackSize ? stackSize : newPosition;
        },
        resetUndoStack (state, action) {
            state.stack = [];
            state.position = 0;
        },
        replaceUndoStack (state, action) {
            state.stack = action.payload.stack;
            // Make sure given position is set to a value within stack length
            state.position = Math.min(action.payload.position, action.payload.stack.length - 1);
        },
        createNewUndo (state, action) {
            const position = state.position;
            // Create a shallow copy of the original undo stack up to the current
            // current position. This removes future undo path in case we undo a
            // few times and then do something undoable.
            let stack = state.stack.slice(0, position);
            // Add the latest state
            const street = action.payload;
            stack.push({
                ...street
            });
            // Post-process stack data
            stack = $0e3fada570e844f5$var$trimUndoStack(stack);
            stack = $0e3fada570e844f5$var$unifyUndoStack(stack, street);
            // Update
            state.stack = stack;
            state.position = Math.min(position, $0e3fada570e844f5$export$24df5979dca24738) + 1;
        },
        /**
     * Sometimes street metadata is updated and we need to update the undo
     * stack data to match the street metadata. There are better ways of doing
     * this. One way is to make the undo stack listen for dispatches to update
     * streets and then automatically unify the undo stack in response, instead
     * of needing code to manually "remember" to dispatch this action. Another
     * way to do this is to refactor our undo stack behavior to be a sequence
     * of change objects, rather than copies of street state, which means we
     * don't need to maintain consistent metadata at each level of the stack.
     * (This is our preferred option.)
     */ unifyStack (state, action) {
            state.stack = $0e3fada570e844f5$var$unifyUndoStack(state.stack, action.payload);
        }
    }
});
const { undo: $0e3fada570e844f5$export$21f930c44940fd98, redo: $0e3fada570e844f5$export$1688e416fee0a49e, resetUndoStack: $0e3fada570e844f5$export$bedafa63ac02a207, replaceUndoStack: $0e3fada570e844f5$export$608c067bf56d9e0, createNewUndo: $0e3fada570e844f5$export$beae92f3b524112c, unifyStack: $0e3fada570e844f5$export$30fa48a523ba578b } = $0e3fada570e844f5$var$undoSlice.actions;
var $0e3fada570e844f5$export$2e2bcd8739ae039 = $0e3fada570e844f5$var$undoSlice.reducer;



var $98448114ff4d3ef1$exports = {};
$98448114ff4d3ef1$exports = JSON.parse('{"USER":{"key":"user","text":"User","value":"USER","flags":{"VARIANT_TWOWAY_BIKES":true}},"ADMIN":{"key":"admin","text":"Administrator","value":"ADMIN","flags":{"LOCALES_LEVEL_1":true,"COLOR_MODE_TOGGLE":true}},"BETA_TESTER":{"key":"beta_tester","text":"Beta tester","value":"BETA_TESTER","flags":{"LOCALES_LEVEL_1":true,"ELEVATION_CONTROLS_UNLOCKED":true,"SEGMENT_CROSSWALK":true,"SEGMENT_DRAINAGE_CHANNEL_UNLOCKED":true,"VARIANT_TWOWAY_BIKES_UNLOCKED":true,"VARIANT_MIXED_DRIVE_LANES_1":true,"VARIANT_MIXED_DRIVE_LANES_2":true,"COLOR_MODE_TOGGLE":true}},"ITDP":{"key":"itdp","text":"ITDP user","value":"ITDP","flags":{"ELEVATION_CONTROLS_UNLOCKED":true,"SEGMENT_DRAINAGE_CHANNEL_UNLOCKED":true,"VARIANT_TWOWAY_BIKES_UNLOCKED":true,"VARIANT_MIXED_DRIVE_LANES_1":true,"VARIANT_MIXED_DRIVE_LANES_2":true}},"TRANSLATOR":{"key":"translator","text":"Translator","value":"TRANSLATOR","flags":{"LOCALES_LEVEL_1":true}},"SUBSCRIBER_1":{"key":"subscriber_1","text":"Subscriber tier 1","value":"SUBSCRIBER_1","flags":{"SAVE_AS_IMAGE_CUSTOM_DPI":true}},"SUBSCRIBER_2":{"key":"subscriber_2","text":"Subscriber tier 2","value":"SUBSCRIBER_2","flags":{}},"SUBSCRIBER_3":{"key":"subscriber_3","text":"Subscriber tier 3","value":"SUBSCRIBER_3","flags":{}}}');



const $ca8c478b1d098cf7$var$initialState = {
    signInData: null,
    signedIn: false,
    isSubscriber: false,
    isCoilPluginSubscriber: false,
    geolocation: {
        attempted: false,
        data: null,
        error: null
    }
};
const $ca8c478b1d098cf7$export$468558a22f9ceef8 = (0, $a3ccb5670e466352$export$6abd22dc03e5063f)("user/detectGeolocation", async ()=>{
    const response = await (0, $4ff1018a457d25d0$export$d0f3c7c6645f9f65)();
    return response.data;
});
const $ca8c478b1d098cf7$var$userSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
    name: "user",
    initialState: $ca8c478b1d098cf7$var$initialState,
    reducers: {
        setSignInData (state, action) {
            state.signInData = action.payload;
            state.signedIn = true;
            if (action.payload.details?.roles?.includes((0, (/*@__PURE__*/$parcel$interopDefault($98448114ff4d3ef1$exports))).SUBSCRIBER_1.value)) state.isSubscriber = true;
        },
        clearSignInData (state, action) {
            state.signInData = null;
            state.signedIn = false;
            state.isSubscriber = false;
            state.isCoilPluginSubscriber = false;
        },
        setCoilPluginSubscriber (state, action) {
            state.isCoilPluginSubscriber = action.payload;
            // Also set `isSubscriber` if the user is signed in.
            if (action.payload && state.signedIn) state.isSubscriber = true;
            else // Unset isSubscriber only if the user doesn't have the role elsewhere
            if (state.signInData?.details?.roles?.includes((0, (/*@__PURE__*/$parcel$interopDefault($98448114ff4d3ef1$exports))).SUBSCRIBER_1.value) !== true) state.isSubscriber = false;
        },
        updateDisplayName (state, action) {
            if (state.signInData?.details) state.signInData.details.displayName = action.payload;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($ca8c478b1d098cf7$export$468558a22f9ceef8.pending, (state)=>{
            // Reset state when pending
            state.geolocation.attempted = false;
            state.geolocation.data = null;
            state.geolocation.error = null;
        }).addCase($ca8c478b1d098cf7$export$468558a22f9ceef8.fulfilled, (state, action)=>{
            state.geolocation.attempted = true;
            state.geolocation.data = action.payload;
            state.geolocation.error = null;
        }).addCase($ca8c478b1d098cf7$export$468558a22f9ceef8.rejected, (state, action)=>{
            state.geolocation.attempted = true;
            state.geolocation.data = null;
            state.geolocation.error = action.error.message ?? action.error;
        });
    }
});
const { setSignInData: $ca8c478b1d098cf7$export$27668919860020c, clearSignInData: $ca8c478b1d098cf7$export$efff0b7a5c54c9dd, setCoilPluginSubscriber: $ca8c478b1d098cf7$export$a57169b6b0b32e47, updateDisplayName: $ca8c478b1d098cf7$export$acb032659de1ea6d } = $ca8c478b1d098cf7$var$userSlice.actions;
var $ca8c478b1d098cf7$export$2e2bcd8739ae039 = $ca8c478b1d098cf7$var$userSlice.reducer;


const $ef401f325b6f76ea$var$reducers = {
    app: $9dbab908c178b0dc$export$2e2bcd8739ae039,
    debug: $5bcb824489dec0b9$export$2e2bcd8739ae039,
    dialogs: $cdf0aaca62d15025$export$2e2bcd8739ae039,
    errors: $5e173785b5fcb8ed$export$2e2bcd8739ae039,
    flags: $1ac426dbdd197303$export$2e2bcd8739ae039,
    gallery: $11a2d10829f32488$export$2e2bcd8739ae039,
    history: $0e3fada570e844f5$export$2e2bcd8739ae039,
    infoBubble: $d00d4a7cfa2eb020$export$2e2bcd8739ae039,
    locale: $0083fa256c596554$export$2e2bcd8739ae039,
    map: $5b2c2d9c813ed442$export$2e2bcd8739ae039,
    menus: $3857de86d8e7589b$export$2e2bcd8739ae039,
    settings: $91ffa8e8b26e8ad0$export$2e2bcd8739ae039,
    street: $8b007b7ac0907036$export$2e2bcd8739ae039,
    system: $c8f034bd96be731d$export$2e2bcd8739ae039,
    toasts: $ed796acc6691d871$export$2e2bcd8739ae039,
    ui: $cb9eeb171d537a5a$export$2e2bcd8739ae039,
    user: $ca8c478b1d098cf7$export$2e2bcd8739ae039
};
var $ef401f325b6f76ea$export$2e2bcd8739ae039 = $ef401f325b6f76ea$var$reducers;



var $i9Ee7 = parcelRequire("i9Ee7");

var $i9Ee7 = parcelRequire("i9Ee7");


var $eh5Zb = parcelRequire("eh5Zb");
var $e80dfc866a603375$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e80dfc866a603375$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $e80dfc866a603375$var$__defProp = Object.defineProperty;
var $e80dfc866a603375$var$__defProps = Object.defineProperties;
var $e80dfc866a603375$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $e80dfc866a603375$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e80dfc866a603375$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e80dfc866a603375$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e80dfc866a603375$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $e80dfc866a603375$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $e80dfc866a603375$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($e80dfc866a603375$var$__hasOwnProp.call(b, prop)) $e80dfc866a603375$var$__defNormalProp(a, prop, b[prop]);
    if ($e80dfc866a603375$var$__getOwnPropSymbols) for(var _j = 0, _k = $e80dfc866a603375$var$__getOwnPropSymbols(b); _j < _k.length; _j++){
        var prop = _k[_j];
        if ($e80dfc866a603375$var$__propIsEnum.call(b, prop)) $e80dfc866a603375$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e80dfc866a603375$var$__spreadProps = function(a, b) {
    return $e80dfc866a603375$var$__defProps(a, $e80dfc866a603375$var$__getOwnPropDescs(b));
};
var $e80dfc866a603375$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($e80dfc866a603375$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $e80dfc866a603375$var$__getOwnPropSymbols) for(var _j = 0, _k = $e80dfc866a603375$var$__getOwnPropSymbols(source); _j < _k.length; _j++){
        var prop = _k[_j];
        if (exclude.indexOf(prop) < 0 && $e80dfc866a603375$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $e80dfc866a603375$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/query/core/apiState.ts
var $e80dfc866a603375$export$f4258b89f6bad1d6;
(function(QueryStatus2) {
    QueryStatus2["uninitialized"] = "uninitialized";
    QueryStatus2["pending"] = "pending";
    QueryStatus2["fulfilled"] = "fulfilled";
    QueryStatus2["rejected"] = "rejected";
})($e80dfc866a603375$export$f4258b89f6bad1d6 || ($e80dfc866a603375$export$f4258b89f6bad1d6 = {}));
function $e80dfc866a603375$var$getRequestStatusFlags(status) {
    return {
        status: status,
        isUninitialized: status === $e80dfc866a603375$export$f4258b89f6bad1d6.uninitialized,
        isLoading: status === $e80dfc866a603375$export$f4258b89f6bad1d6.pending,
        isSuccess: status === $e80dfc866a603375$export$f4258b89f6bad1d6.fulfilled,
        isError: status === $e80dfc866a603375$export$f4258b89f6bad1d6.rejected
    };
}
// src/query/utils/isAbsoluteUrl.ts
function $e80dfc866a603375$var$isAbsoluteUrl(url) {
    return new RegExp("(^|:)//").test(url);
}
// src/query/utils/joinUrls.ts
var $e80dfc866a603375$var$withoutTrailingSlash = function(url) {
    return url.replace(/\/$/, "");
};
var $e80dfc866a603375$var$withoutLeadingSlash = function(url) {
    return url.replace(/^\//, "");
};
function $e80dfc866a603375$var$joinUrls(base, url) {
    if (!base) return url;
    if (!url) return base;
    if ($e80dfc866a603375$var$isAbsoluteUrl(url)) return url;
    var delimiter = base.endsWith("/") || !url.startsWith("?") ? "/" : "";
    base = $e80dfc866a603375$var$withoutTrailingSlash(base);
    url = $e80dfc866a603375$var$withoutLeadingSlash(url);
    return "" + base + delimiter + url;
}
// src/query/utils/flatten.ts
var $e80dfc866a603375$var$flatten = function(arr) {
    return [].concat.apply([], arr);
};
// src/query/utils/isOnline.ts
function $e80dfc866a603375$var$isOnline() {
    return typeof navigator === "undefined" ? true : navigator.onLine === void 0 ? true : navigator.onLine;
}
// src/query/utils/isDocumentVisible.ts
function $e80dfc866a603375$var$isDocumentVisible() {
    if (typeof document === "undefined") return true;
    return document.visibilityState !== "hidden";
}
var $e80dfc866a603375$var$isPlainObject = (0, $a3ccb5670e466352$export$53b83ca8eaab0383);
function $e80dfc866a603375$export$b64d4502a1c929bd(oldObj, newObj) {
    if (oldObj === newObj || !($e80dfc866a603375$var$isPlainObject(oldObj) && $e80dfc866a603375$var$isPlainObject(newObj) || Array.isArray(oldObj) && Array.isArray(newObj))) return newObj;
    var newKeys = Object.keys(newObj);
    var oldKeys = Object.keys(oldObj);
    var isSameObject = newKeys.length === oldKeys.length;
    var mergeObj = Array.isArray(newObj) ? [] : {};
    for(var _j = 0, newKeys_1 = newKeys; _j < newKeys_1.length; _j++){
        var key = newKeys_1[_j];
        mergeObj[key] = $e80dfc866a603375$export$b64d4502a1c929bd(oldObj[key], newObj[key]);
        if (isSameObject) isSameObject = oldObj[key] === mergeObj[key];
    }
    return isSameObject ? oldObj : mergeObj;
}
var $e80dfc866a603375$var$defaultFetchFn = function() {
    var args = [];
    for(var _j = 0; _j < arguments.length; _j++)args[_j] = arguments[_j];
    return fetch.apply(void 0, args);
};
var $e80dfc866a603375$var$defaultValidateStatus = function(response) {
    return response.status >= 200 && response.status <= 299;
};
var $e80dfc866a603375$var$defaultIsJsonContentType = function(headers) {
    return /ion\/(vnd\.api\+)?json/.test(headers.get("content-type") || "");
};
function $e80dfc866a603375$var$stripUndefined(obj) {
    if (!(0, $a3ccb5670e466352$export$53b83ca8eaab0383)(obj)) return obj;
    var copy = $e80dfc866a603375$var$__spreadValues({}, obj);
    for(var _j = 0, _k = Object.entries(copy); _j < _k.length; _j++){
        var _l = _k[_j], k = _l[0], v = _l[1];
        if (v === void 0) delete copy[k];
    }
    return copy;
}
function $e80dfc866a603375$export$adcf4c6133c49b4e(_a) {
    var _this = this;
    if (_a === void 0) _a = {};
    var _b = _a, baseUrl = _b.baseUrl, _j = _b.prepareHeaders, prepareHeaders = _j === void 0 ? function(x) {
        return x;
    } : _j, _k = _b.fetchFn, fetchFn = _k === void 0 ? $e80dfc866a603375$var$defaultFetchFn : _k, paramsSerializer = _b.paramsSerializer, _l = _b.isJsonContentType, isJsonContentType = _l === void 0 ? $e80dfc866a603375$var$defaultIsJsonContentType : _l, _m = _b.jsonContentType, jsonContentType = _m === void 0 ? "application/json" : _m, jsonReplacer = _b.jsonReplacer, defaultTimeout = _b.timeout, globalResponseHandler = _b.responseHandler, globalValidateStatus = _b.validateStatus, baseFetchOptions = $e80dfc866a603375$var$__objRest(_b, [
        "baseUrl",
        "prepareHeaders",
        "fetchFn",
        "paramsSerializer",
        "isJsonContentType",
        "jsonContentType",
        "jsonReplacer",
        "timeout",
        "responseHandler",
        "validateStatus"
    ]);
    if (typeof fetch === "undefined" && fetchFn === $e80dfc866a603375$var$defaultFetchFn) console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments.");
    return function(arg, api) {
        return $e80dfc866a603375$var$__async(_this, null, function() {
            var signal, getState, extra, endpoint, forced, type, meta, _a2, url, _j, headers, _k, params, _l, responseHandler, _m, validateStatus, _o, timeout, rest, config, _p, isJsonifiable, divider, query, request, requestClone, response, timedOut, timeoutId, e_1, responseClone, resultData, responseText, handleResponseError_1, e_2;
            return $e80dfc866a603375$var$__generator(this, function(_q) {
                switch(_q.label){
                    case 0:
                        signal = api.signal, getState = api.getState, extra = api.extra, endpoint = api.endpoint, forced = api.forced, type = api.type;
                        _a2 = typeof arg == "string" ? {
                            url: arg
                        } : arg, url = _a2.url, _j = _a2.headers, headers = _j === void 0 ? new Headers(baseFetchOptions.headers) : _j, _k = _a2.params, params = _k === void 0 ? void 0 : _k, _l = _a2.responseHandler, responseHandler = _l === void 0 ? globalResponseHandler != null ? globalResponseHandler : "json" : _l, _m = _a2.validateStatus, validateStatus = _m === void 0 ? globalValidateStatus != null ? globalValidateStatus : $e80dfc866a603375$var$defaultValidateStatus : _m, _o = _a2.timeout, timeout = _o === void 0 ? defaultTimeout : _o, rest = $e80dfc866a603375$var$__objRest(_a2, [
                            "url",
                            "headers",
                            "params",
                            "responseHandler",
                            "validateStatus",
                            "timeout"
                        ]);
                        config = $e80dfc866a603375$var$__spreadValues($e80dfc866a603375$var$__spreadProps($e80dfc866a603375$var$__spreadValues({}, baseFetchOptions), {
                            signal: signal
                        }), rest);
                        headers = new Headers($e80dfc866a603375$var$stripUndefined(headers));
                        _p = config;
                        return [
                            4 /*yield*/ ,
                            prepareHeaders(headers, {
                                getState: getState,
                                extra: extra,
                                endpoint: endpoint,
                                forced: forced,
                                type: type
                            })
                        ];
                    case 1:
                        _p.headers = _q.sent() || headers;
                        isJsonifiable = function(body) {
                            return typeof body === "object" && ((0, $a3ccb5670e466352$export$53b83ca8eaab0383)(body) || Array.isArray(body) || typeof body.toJSON === "function");
                        };
                        if (!config.headers.has("content-type") && isJsonifiable(config.body)) config.headers.set("content-type", jsonContentType);
                        if (isJsonifiable(config.body) && isJsonContentType(config.headers)) config.body = JSON.stringify(config.body, jsonReplacer);
                        if (params) {
                            divider = ~url.indexOf("?") ? "&" : "?";
                            query = paramsSerializer ? paramsSerializer(params) : new URLSearchParams($e80dfc866a603375$var$stripUndefined(params));
                            url += divider + query;
                        }
                        url = $e80dfc866a603375$var$joinUrls(baseUrl, url);
                        request = new Request(url, config);
                        requestClone = request.clone();
                        meta = {
                            request: requestClone
                        };
                        timedOut = false, timeoutId = timeout && setTimeout(function() {
                            timedOut = true;
                            api.abort();
                        }, timeout);
                        _q.label = 2;
                    case 2:
                        _q.trys.push([
                            2,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetchFn(request)
                        ];
                    case 3:
                        response = _q.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        e_1 = _q.sent();
                        return [
                            2 /*return*/ ,
                            {
                                error: {
                                    status: timedOut ? "TIMEOUT_ERROR" : "FETCH_ERROR",
                                    error: String(e_1)
                                },
                                meta: meta
                            }
                        ];
                    case 5:
                        if (timeoutId) clearTimeout(timeoutId);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        responseClone = response.clone();
                        meta.response = responseClone;
                        responseText = "";
                        _q.label = 7;
                    case 7:
                        _q.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                handleResponse(response, responseHandler).then(function(r) {
                                    return resultData = r;
                                }, function(e) {
                                    return handleResponseError_1 = e;
                                }),
                                responseClone.text().then(function(r) {
                                    return responseText = r;
                                }, function() {})
                            ])
                        ];
                    case 8:
                        _q.sent();
                        if (handleResponseError_1) throw handleResponseError_1;
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_2 = _q.sent();
                        return [
                            2 /*return*/ ,
                            {
                                error: {
                                    status: "PARSING_ERROR",
                                    originalStatus: response.status,
                                    data: responseText,
                                    error: String(e_2)
                                },
                                meta: meta
                            }
                        ];
                    case 10:
                        return [
                            2 /*return*/ ,
                            validateStatus(response, resultData) ? {
                                data: resultData,
                                meta: meta
                            } : {
                                error: {
                                    status: response.status,
                                    data: resultData
                                },
                                meta: meta
                            }
                        ];
                }
            });
        });
    };
    function handleResponse(response, responseHandler) {
        return $e80dfc866a603375$var$__async(this, null, function() {
            var text;
            return $e80dfc866a603375$var$__generator(this, function(_j) {
                switch(_j.label){
                    case 0:
                        if (typeof responseHandler === "function") return [
                            2 /*return*/ ,
                            responseHandler(response)
                        ];
                        if (responseHandler === "content-type") responseHandler = isJsonContentType(response.headers) ? "json" : "text";
                        if (!(responseHandler === "json")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 1:
                        text = _j.sent();
                        return [
                            2 /*return*/ ,
                            text.length ? JSON.parse(text) : null
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            response.text()
                        ];
                }
            });
        });
    }
}
// src/query/HandledError.ts
var $e80dfc866a603375$var$HandledError = /** @class */ function() {
    function HandledError(value, meta) {
        if (meta === void 0) meta = void 0;
        this.value = value;
        this.meta = meta;
    }
    return HandledError;
}();
// src/query/retry.ts
function $e80dfc866a603375$var$defaultBackoff(attempt, maxRetries) {
    if (attempt === void 0) attempt = 0;
    if (maxRetries === void 0) maxRetries = 5;
    return $e80dfc866a603375$var$__async(this, null, function() {
        var attempts, timeout;
        return $e80dfc866a603375$var$__generator(this, function(_j) {
            switch(_j.label){
                case 0:
                    attempts = Math.min(attempt, maxRetries);
                    timeout = ~~((Math.random() + 0.4) * (300 << attempts));
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            return setTimeout(function(res) {
                                return resolve(res);
                            }, timeout);
                        })
                    ];
                case 1:
                    _j.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $e80dfc866a603375$var$fail(e) {
    throw Object.assign(new $e80dfc866a603375$var$HandledError({
        error: e
    }), {
        throwImmediately: true
    });
}
var $e80dfc866a603375$var$EMPTY_OPTIONS = {};
var $e80dfc866a603375$var$retryWithBackoff = function(baseQuery, defaultOptions) {
    return function(args, api, extraOptions) {
        return $e80dfc866a603375$var$__async(void 0, null, function() {
            var possibleMaxRetries, maxRetries, defaultRetryCondition, options, retry2, result, e_3;
            return $e80dfc866a603375$var$__generator(this, function(_j) {
                switch(_j.label){
                    case 0:
                        possibleMaxRetries = [
                            5,
                            (defaultOptions || $e80dfc866a603375$var$EMPTY_OPTIONS).maxRetries,
                            (extraOptions || $e80dfc866a603375$var$EMPTY_OPTIONS).maxRetries
                        ].filter(function(x) {
                            return x !== void 0;
                        });
                        maxRetries = possibleMaxRetries.slice(-1)[0];
                        defaultRetryCondition = function(_, __, _j) {
                            var attempt = _j.attempt;
                            return attempt <= maxRetries;
                        };
                        options = $e80dfc866a603375$var$__spreadValues($e80dfc866a603375$var$__spreadValues({
                            maxRetries: maxRetries,
                            backoff: $e80dfc866a603375$var$defaultBackoff,
                            retryCondition: defaultRetryCondition
                        }, defaultOptions), extraOptions);
                        retry2 = 0;
                        _j.label = 1;
                    case 1:
                        _j.label = 2;
                    case 2:
                        _j.trys.push([
                            2,
                            4,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            baseQuery(args, api, extraOptions)
                        ];
                    case 3:
                        result = _j.sent();
                        if (result.error) throw new $e80dfc866a603375$var$HandledError(result);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 4:
                        e_3 = _j.sent();
                        retry2++;
                        if (e_3.throwImmediately) {
                            if (e_3 instanceof $e80dfc866a603375$var$HandledError) return [
                                2 /*return*/ ,
                                e_3.value
                            ];
                            throw e_3;
                        }
                        if (e_3 instanceof $e80dfc866a603375$var$HandledError && !options.retryCondition(e_3.value.error, args, {
                            attempt: retry2,
                            baseQueryApi: api,
                            extraOptions: extraOptions
                        })) return [
                            2 /*return*/ ,
                            e_3.value
                        ];
                        return [
                            4 /*yield*/ ,
                            options.backoff(retry2, options.maxRetries)
                        ];
                    case 5:
                        _j.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
};
var $e80dfc866a603375$export$9369b12211e1fce4 = /* @__PURE__ */ Object.assign($e80dfc866a603375$var$retryWithBackoff, {
    fail: $e80dfc866a603375$var$fail
});
var $e80dfc866a603375$var$onFocus = /* @__PURE__ */ (0, $a3ccb5670e466352$export$309c7a02b0b0bc62)("__rtkq/focused");
var $e80dfc866a603375$var$onFocusLost = /* @__PURE__ */ (0, $a3ccb5670e466352$export$309c7a02b0b0bc62)("__rtkq/unfocused");
var $e80dfc866a603375$var$onOnline = /* @__PURE__ */ (0, $a3ccb5670e466352$export$309c7a02b0b0bc62)("__rtkq/online");
var $e80dfc866a603375$var$onOffline = /* @__PURE__ */ (0, $a3ccb5670e466352$export$309c7a02b0b0bc62)("__rtkq/offline");
var $e80dfc866a603375$var$initialized = false;
function $e80dfc866a603375$export$120c0dbb0351414c(dispatch, customHandler) {
    function defaultHandler() {
        var handleFocus = function() {
            return dispatch($e80dfc866a603375$var$onFocus());
        };
        var handleFocusLost = function() {
            return dispatch($e80dfc866a603375$var$onFocusLost());
        };
        var handleOnline = function() {
            return dispatch($e80dfc866a603375$var$onOnline());
        };
        var handleOffline = function() {
            return dispatch($e80dfc866a603375$var$onOffline());
        };
        var handleVisibilityChange = function() {
            if (window.document.visibilityState === "visible") handleFocus();
            else handleFocusLost();
        };
        if (!$e80dfc866a603375$var$initialized) {
            if (typeof window !== "undefined" && window.addEventListener) {
                window.addEventListener("visibilitychange", handleVisibilityChange, false);
                window.addEventListener("focus", handleFocus, false);
                window.addEventListener("online", handleOnline, false);
                window.addEventListener("offline", handleOffline, false);
                $e80dfc866a603375$var$initialized = true;
            }
        }
        var unsubscribe = function() {
            window.removeEventListener("focus", handleFocus);
            window.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
            $e80dfc866a603375$var$initialized = false;
        };
        return unsubscribe;
    }
    return customHandler ? customHandler(dispatch, {
        onFocus: $e80dfc866a603375$var$onFocus,
        onFocusLost: $e80dfc866a603375$var$onFocusLost,
        onOffline: $e80dfc866a603375$var$onOffline,
        onOnline: $e80dfc866a603375$var$onOnline
    }) : defaultHandler();
}
// src/query/endpointDefinitions.ts
var $e80dfc866a603375$var$DefinitionType;
(function(DefinitionType2) {
    DefinitionType2["query"] = "query";
    DefinitionType2["mutation"] = "mutation";
})($e80dfc866a603375$var$DefinitionType || ($e80dfc866a603375$var$DefinitionType = {}));
function $e80dfc866a603375$var$isQueryDefinition(e) {
    return e.type === $e80dfc866a603375$var$DefinitionType.query;
}
function $e80dfc866a603375$var$isMutationDefinition(e) {
    return e.type === $e80dfc866a603375$var$DefinitionType.mutation;
}
function $e80dfc866a603375$var$calculateProvidedBy(description, result, error, queryArg, meta, assertTagTypes) {
    if ($e80dfc866a603375$var$isFunction(description)) return description(result, error, queryArg, meta).map($e80dfc866a603375$var$expandTagDescription).map(assertTagTypes);
    if (Array.isArray(description)) return description.map($e80dfc866a603375$var$expandTagDescription).map(assertTagTypes);
    return [];
}
function $e80dfc866a603375$var$isFunction(t) {
    return typeof t === "function";
}
function $e80dfc866a603375$var$expandTagDescription(description) {
    return typeof description === "string" ? {
        type: description
    } : description;
}
// src/query/utils/isNotNullish.ts
function $e80dfc866a603375$var$isNotNullish(v) {
    return v != null;
}
// src/query/core/buildInitiate.ts
var $e80dfc866a603375$var$forceQueryFnSymbol = Symbol("forceQueryFn");
var $e80dfc866a603375$var$isUpsertQuery = function(arg) {
    return typeof arg[$e80dfc866a603375$var$forceQueryFnSymbol] === "function";
};
function $e80dfc866a603375$var$buildInitiate(_j) {
    var serializeQueryArgs = _j.serializeQueryArgs, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, api = _j.api, context = _j.context;
    var runningQueries = new Map();
    var runningMutations = new Map();
    var _k = api.internalActions, unsubscribeQueryResult = _k.unsubscribeQueryResult, removeMutationResult = _k.removeMutationResult, updateSubscriptionOptions = _k.updateSubscriptionOptions;
    return {
        buildInitiateQuery: buildInitiateQuery,
        buildInitiateMutation: buildInitiateMutation,
        getRunningQueryThunk: getRunningQueryThunk,
        getRunningMutationThunk: getRunningMutationThunk,
        getRunningQueriesThunk: getRunningQueriesThunk,
        getRunningMutationsThunk: getRunningMutationsThunk,
        getRunningOperationPromises: getRunningOperationPromises,
        removalWarning: removalWarning
    };
    function removalWarning() {
        throw new Error("This method had to be removed due to a conceptual bug in RTK.\n       Please see https://github.com/reduxjs/redux-toolkit/pull/2481 for details.\n       See https://redux-toolkit.js.org/rtk-query/usage/server-side-rendering for new guidance on SSR.");
    }
    function getRunningOperationPromises() {
        typeof $eh5Zb;
        var extract = function(v) {
            return Array.from(v.values()).flatMap(function(queriesForStore) {
                return queriesForStore ? Object.values(queriesForStore) : [];
            });
        };
        return $e80dfc866a603375$var$__spreadArray($e80dfc866a603375$var$__spreadArray([], extract(runningQueries)), extract(runningMutations)).filter($e80dfc866a603375$var$isNotNullish);
    }
    function getRunningQueryThunk(endpointName, queryArgs) {
        return function(dispatch) {
            var _a;
            var endpointDefinition = context.endpointDefinitions[endpointName];
            var queryCacheKey = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            return (_a = runningQueries.get(dispatch)) == null ? void 0 : _a[queryCacheKey];
        };
    }
    function getRunningMutationThunk(_endpointName, fixedCacheKeyOrRequestId) {
        return function(dispatch) {
            var _a;
            return (_a = runningMutations.get(dispatch)) == null ? void 0 : _a[fixedCacheKeyOrRequestId];
        };
    }
    function getRunningQueriesThunk() {
        return function(dispatch) {
            return Object.values(runningQueries.get(dispatch) || {}).filter($e80dfc866a603375$var$isNotNullish);
        };
    }
    function getRunningMutationsThunk() {
        return function(dispatch) {
            return Object.values(runningMutations.get(dispatch) || {}).filter($e80dfc866a603375$var$isNotNullish);
        };
    }
    function middlewareWarning(dispatch) {
        var registered;
    }
    function buildInitiateQuery(endpointName, endpointDefinition) {
        var queryAction = function(arg, _j) {
            var _k = _j === void 0 ? {} : _j, _l = _k.subscribe, subscribe = _l === void 0 ? true : _l, forceRefetch = _k.forceRefetch, subscriptionOptions = _k.subscriptionOptions, _m = $e80dfc866a603375$var$forceQueryFnSymbol, forceQueryFn = _k[_m];
            return function(dispatch, getState) {
                var _j;
                var _a;
                var queryCacheKey = serializeQueryArgs({
                    queryArgs: arg,
                    endpointDefinition: endpointDefinition,
                    endpointName: endpointName
                });
                var thunk = queryThunk((_j = {
                    type: "query",
                    subscribe: subscribe,
                    forceRefetch: forceRefetch,
                    subscriptionOptions: subscriptionOptions,
                    endpointName: endpointName,
                    originalArgs: arg,
                    queryCacheKey: queryCacheKey
                }, _j[$e80dfc866a603375$var$forceQueryFnSymbol] = forceQueryFn, _j));
                var selector = api.endpoints[endpointName].select(arg);
                var thunkResult = dispatch(thunk);
                var stateAfter = selector(getState());
                middlewareWarning(dispatch);
                var requestId = thunkResult.requestId, abort = thunkResult.abort;
                var skippedSynchronously = stateAfter.requestId !== requestId;
                var runningQuery = (_a = runningQueries.get(dispatch)) == null ? void 0 : _a[queryCacheKey];
                var selectFromState = function() {
                    return selector(getState());
                };
                var statePromise = Object.assign(forceQueryFn ? thunkResult.then(selectFromState) : skippedSynchronously && !runningQuery ? Promise.resolve(stateAfter) : Promise.all([
                    runningQuery,
                    thunkResult
                ]).then(selectFromState), {
                    arg: arg,
                    requestId: requestId,
                    subscriptionOptions: subscriptionOptions,
                    queryCacheKey: queryCacheKey,
                    abort: abort,
                    unwrap: function() {
                        return $e80dfc866a603375$var$__async(this, null, function() {
                            var result;
                            return $e80dfc866a603375$var$__generator(this, function(_j) {
                                switch(_j.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            statePromise
                                        ];
                                    case 1:
                                        result = _j.sent();
                                        if (result.isError) throw result.error;
                                        return [
                                            2 /*return*/ ,
                                            result.data
                                        ];
                                }
                            });
                        });
                    },
                    refetch: function() {
                        return dispatch(queryAction(arg, {
                            subscribe: false,
                            forceRefetch: true
                        }));
                    },
                    unsubscribe: function() {
                        if (subscribe) dispatch(unsubscribeQueryResult({
                            queryCacheKey: queryCacheKey,
                            requestId: requestId
                        }));
                    },
                    updateSubscriptionOptions: function(options) {
                        statePromise.subscriptionOptions = options;
                        dispatch(updateSubscriptionOptions({
                            endpointName: endpointName,
                            requestId: requestId,
                            queryCacheKey: queryCacheKey,
                            options: options
                        }));
                    }
                });
                if (!runningQuery && !skippedSynchronously && !forceQueryFn) {
                    var running_1 = runningQueries.get(dispatch) || {};
                    running_1[queryCacheKey] = statePromise;
                    runningQueries.set(dispatch, running_1);
                    statePromise.then(function() {
                        delete running_1[queryCacheKey];
                        if (!Object.keys(running_1).length) runningQueries.delete(dispatch);
                    });
                }
                return statePromise;
            };
        };
        return queryAction;
    }
    function buildInitiateMutation(endpointName) {
        return function(arg, _j) {
            var _k = _j === void 0 ? {} : _j, _l = _k.track, track = _l === void 0 ? true : _l, fixedCacheKey = _k.fixedCacheKey;
            return function(dispatch, getState) {
                var thunk = mutationThunk({
                    type: "mutation",
                    endpointName: endpointName,
                    originalArgs: arg,
                    track: track,
                    fixedCacheKey: fixedCacheKey
                });
                var thunkResult = dispatch(thunk);
                middlewareWarning(dispatch);
                var requestId = thunkResult.requestId, abort = thunkResult.abort, unwrap = thunkResult.unwrap;
                var returnValuePromise = thunkResult.unwrap().then(function(data) {
                    return {
                        data: data
                    };
                }).catch(function(error) {
                    return {
                        error: error
                    };
                });
                var reset = function() {
                    dispatch(removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                };
                var ret = Object.assign(returnValuePromise, {
                    arg: thunkResult.arg,
                    requestId: requestId,
                    abort: abort,
                    unwrap: unwrap,
                    unsubscribe: reset,
                    reset: reset
                });
                var running = runningMutations.get(dispatch) || {};
                runningMutations.set(dispatch, running);
                running[requestId] = ret;
                ret.then(function() {
                    delete running[requestId];
                    if (!Object.keys(running).length) runningMutations.delete(dispatch);
                });
                if (fixedCacheKey) {
                    running[fixedCacheKey] = ret;
                    ret.then(function() {
                        if (running[fixedCacheKey] === ret) {
                            delete running[fixedCacheKey];
                            if (!Object.keys(running).length) runningMutations.delete(dispatch);
                        }
                    });
                }
                return ret;
            };
        };
    }
}
function $e80dfc866a603375$var$defaultTransformResponse(baseQueryReturnValue) {
    return baseQueryReturnValue;
}
function $e80dfc866a603375$var$buildThunks(_j) {
    var _this = this;
    var reducerPath = _j.reducerPath, baseQuery = _j.baseQuery, endpointDefinitions = _j.context.endpointDefinitions, serializeQueryArgs = _j.serializeQueryArgs, api = _j.api;
    var patchQueryData = function(endpointName, args, patches) {
        return function(dispatch) {
            var endpointDefinition = endpointDefinitions[endpointName];
            dispatch(api.internalActions.queryResultPatched({
                queryCacheKey: serializeQueryArgs({
                    queryArgs: args,
                    endpointDefinition: endpointDefinition,
                    endpointName: endpointName
                }),
                patches: patches
            }));
        };
    };
    var updateQueryData = function(endpointName, args, updateRecipe) {
        return function(dispatch, getState) {
            var _j, _k;
            var currentState = api.endpoints[endpointName].select(args)(getState());
            var ret = {
                patches: [],
                inversePatches: [],
                undo: function() {
                    return dispatch(api.util.patchQueryData(endpointName, args, ret.inversePatches));
                }
            };
            if (currentState.status === $e80dfc866a603375$export$f4258b89f6bad1d6.uninitialized) return ret;
            if ("data" in currentState) {
                if ((0, $i9Ee7.isDraftable)(currentState.data)) {
                    var _l = (0, $i9Ee7.produceWithPatches)(currentState.data, updateRecipe), patches = _l[1], inversePatches = _l[2];
                    (_j = ret.patches).push.apply(_j, patches);
                    (_k = ret.inversePatches).push.apply(_k, inversePatches);
                } else {
                    var value = updateRecipe(currentState.data);
                    ret.patches.push({
                        op: "replace",
                        path: [],
                        value: value
                    });
                    ret.inversePatches.push({
                        op: "replace",
                        path: [],
                        value: currentState.data
                    });
                }
            }
            dispatch(api.util.patchQueryData(endpointName, args, ret.patches));
            return ret;
        };
    };
    var upsertQueryData = function(endpointName, args, value) {
        return function(dispatch) {
            var _j;
            return dispatch(api.endpoints[endpointName].initiate(args, (_j = {
                subscribe: false,
                forceRefetch: true
            }, _j[$e80dfc866a603375$var$forceQueryFnSymbol] = function() {
                return {
                    data: value
                };
            }, _j)));
        };
    };
    var executeEndpoint = function(_0, _1) {
        return $e80dfc866a603375$var$__async(_this, [
            _0,
            _1
        ], function(arg, _j) {
            var endpointDefinition, transformResponse, result, baseQueryApi_1, forceQueryFn, what, err, _k, _l, key, _m, error_1, catchedError, transformErrorResponse, _o, e_4;
            var _p, _q;
            var signal = _j.signal, abort = _j.abort, rejectWithValue = _j.rejectWithValue, fulfillWithValue = _j.fulfillWithValue, dispatch = _j.dispatch, getState = _j.getState, extra = _j.extra;
            return $e80dfc866a603375$var$__generator(this, function(_r) {
                switch(_r.label){
                    case 0:
                        endpointDefinition = endpointDefinitions[arg.endpointName];
                        _r.label = 1;
                    case 1:
                        _r.trys.push([
                            1,
                            8,
                            ,
                            13
                        ]);
                        transformResponse = $e80dfc866a603375$var$defaultTransformResponse;
                        result = void 0;
                        baseQueryApi_1 = {
                            signal: signal,
                            abort: abort,
                            dispatch: dispatch,
                            getState: getState,
                            extra: extra,
                            endpoint: arg.endpointName,
                            type: arg.type,
                            forced: arg.type === "query" ? isForcedQuery(arg, getState()) : void 0
                        };
                        forceQueryFn = arg.type === "query" ? arg[$e80dfc866a603375$var$forceQueryFnSymbol] : void 0;
                        if (!forceQueryFn) return [
                            3 /*break*/ ,
                            2
                        ];
                        result = forceQueryFn();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        if (!endpointDefinition.query) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            baseQuery(endpointDefinition.query(arg.originalArgs), baseQueryApi_1, endpointDefinition.extraOptions)
                        ];
                    case 3:
                        result = _r.sent();
                        if (endpointDefinition.transformResponse) transformResponse = endpointDefinition.transformResponse;
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            endpointDefinition.queryFn(arg.originalArgs, baseQueryApi_1, endpointDefinition.extraOptions, function(arg2) {
                                return baseQuery(arg2, baseQueryApi_1, endpointDefinition.extraOptions);
                            })
                        ];
                    case 5:
                        result = _r.sent();
                        _r.label = 6;
                    case 6:
                        typeof $eh5Zb;
                        if (result.error) throw new $e80dfc866a603375$var$HandledError(result.error, result.meta);
                        _m = fulfillWithValue;
                        return [
                            4 /*yield*/ ,
                            transformResponse(result.data, result.meta, arg.originalArgs)
                        ];
                    case 7:
                        return [
                            2 /*return*/ ,
                            _m.apply(void 0, [
                                _r.sent(),
                                (_p = {
                                    fulfilledTimeStamp: Date.now(),
                                    baseQueryMeta: result.meta
                                }, _p[0, $a3ccb5670e466352$export$8fb31c0f05df007b] = true, _p)
                            ])
                        ];
                    case 8:
                        error_1 = _r.sent();
                        catchedError = error_1;
                        if (!(catchedError instanceof $e80dfc866a603375$var$HandledError)) return [
                            3 /*break*/ ,
                            12
                        ];
                        transformErrorResponse = $e80dfc866a603375$var$defaultTransformResponse;
                        if (endpointDefinition.query && endpointDefinition.transformErrorResponse) transformErrorResponse = endpointDefinition.transformErrorResponse;
                        _r.label = 9;
                    case 9:
                        _r.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        _o = rejectWithValue;
                        return [
                            4 /*yield*/ ,
                            transformErrorResponse(catchedError.value, catchedError.meta, arg.originalArgs)
                        ];
                    case 10:
                        return [
                            2 /*return*/ ,
                            _o.apply(void 0, [
                                _r.sent(),
                                (_q = {
                                    baseQueryMeta: catchedError.meta
                                }, _q[0, $a3ccb5670e466352$export$8fb31c0f05df007b] = true, _q)
                            ])
                        ];
                    case 11:
                        e_4 = _r.sent();
                        catchedError = e_4;
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 12:
                        typeof $eh5Zb;
                        console.error(catchedError);
                        throw catchedError;
                    case 13:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    function isForcedQuery(arg, state) {
        var _a, _b, _c, _d;
        var requestState = (_b = (_a = state[reducerPath]) == null ? void 0 : _a.queries) == null ? void 0 : _b[arg.queryCacheKey];
        var baseFetchOnMountOrArgChange = (_c = state[reducerPath]) == null ? void 0 : _c.config.refetchOnMountOrArgChange;
        var fulfilledVal = requestState == null ? void 0 : requestState.fulfilledTimeStamp;
        var refetchVal = (_d = arg.forceRefetch) != null ? _d : arg.subscribe && baseFetchOnMountOrArgChange;
        if (refetchVal) return refetchVal === true || (Number(new Date()) - Number(fulfilledVal)) / 1e3 >= refetchVal;
        return false;
    }
    var queryThunk = (0, $a3ccb5670e466352$export$6abd22dc03e5063f)(reducerPath + "/executeQuery", executeEndpoint, {
        getPendingMeta: function() {
            var _j;
            return _j = {
                startedTimeStamp: Date.now()
            }, _j[0, $a3ccb5670e466352$export$8fb31c0f05df007b] = true, _j;
        },
        condition: function(queryThunkArgs, _j) {
            var getState = _j.getState;
            var _a, _b, _c;
            var state = getState();
            var requestState = (_b = (_a = state[reducerPath]) == null ? void 0 : _a.queries) == null ? void 0 : _b[queryThunkArgs.queryCacheKey];
            var fulfilledVal = requestState == null ? void 0 : requestState.fulfilledTimeStamp;
            var currentArg = queryThunkArgs.originalArgs;
            var previousArg = requestState == null ? void 0 : requestState.originalArgs;
            var endpointDefinition = endpointDefinitions[queryThunkArgs.endpointName];
            if ($e80dfc866a603375$var$isUpsertQuery(queryThunkArgs)) return true;
            if ((requestState == null ? void 0 : requestState.status) === "pending") return false;
            if (isForcedQuery(queryThunkArgs, state)) return true;
            if ($e80dfc866a603375$var$isQueryDefinition(endpointDefinition) && ((_c = endpointDefinition == null ? void 0 : endpointDefinition.forceRefetch) == null ? void 0 : _c.call(endpointDefinition, {
                currentArg: currentArg,
                previousArg: previousArg,
                endpointState: requestState,
                state: state
            }))) return true;
            if (fulfilledVal) return false;
            return true;
        },
        dispatchConditionRejection: true
    });
    var mutationThunk = (0, $a3ccb5670e466352$export$6abd22dc03e5063f)(reducerPath + "/executeMutation", executeEndpoint, {
        getPendingMeta: function() {
            var _j;
            return _j = {
                startedTimeStamp: Date.now()
            }, _j[0, $a3ccb5670e466352$export$8fb31c0f05df007b] = true, _j;
        }
    });
    var hasTheForce = function(options) {
        return "force" in options;
    };
    var hasMaxAge = function(options) {
        return "ifOlderThan" in options;
    };
    var prefetch = function(endpointName, arg, options) {
        return function(dispatch, getState) {
            var force = hasTheForce(options) && options.force;
            var maxAge = hasMaxAge(options) && options.ifOlderThan;
            var queryAction = function(force2) {
                if (force2 === void 0) force2 = true;
                return api.endpoints[endpointName].initiate(arg, {
                    forceRefetch: force2
                });
            };
            var latestStateValue = api.endpoints[endpointName].select(arg)(getState());
            if (force) dispatch(queryAction());
            else if (maxAge) {
                var lastFulfilledTs = latestStateValue == null ? void 0 : latestStateValue.fulfilledTimeStamp;
                if (!lastFulfilledTs) {
                    dispatch(queryAction());
                    return;
                }
                var shouldRetrigger = (Number(new Date()) - Number(new Date(lastFulfilledTs))) / 1e3 >= maxAge;
                if (shouldRetrigger) dispatch(queryAction());
            } else dispatch(queryAction(false));
        };
    };
    function matchesEndpoint(endpointName) {
        return function(action) {
            var _a, _b;
            return ((_b = (_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.arg) == null ? void 0 : _b.endpointName) === endpointName;
        };
    }
    function buildMatchThunkActions(thunk, endpointName) {
        return {
            matchPending: (0, $a3ccb5670e466352$export$9dd1fb32974da385)((0, $a3ccb5670e466352$export$872dec21e9a69476)(thunk), matchesEndpoint(endpointName)),
            matchFulfilled: (0, $a3ccb5670e466352$export$9dd1fb32974da385)((0, $a3ccb5670e466352$export$1da80a6ef1307441)(thunk), matchesEndpoint(endpointName)),
            matchRejected: (0, $a3ccb5670e466352$export$9dd1fb32974da385)((0, $a3ccb5670e466352$export$a5c5d27e3994c5be)(thunk), matchesEndpoint(endpointName))
        };
    }
    return {
        queryThunk: queryThunk,
        mutationThunk: mutationThunk,
        prefetch: prefetch,
        updateQueryData: updateQueryData,
        upsertQueryData: upsertQueryData,
        patchQueryData: patchQueryData,
        buildMatchThunkActions: buildMatchThunkActions
    };
}
function $e80dfc866a603375$var$calculateProvidedByThunk(action, type, endpointDefinitions, assertTagType) {
    return $e80dfc866a603375$var$calculateProvidedBy(endpointDefinitions[action.meta.arg.endpointName][type], (0, $a3ccb5670e466352$export$1da80a6ef1307441)(action) ? action.payload : void 0, (0, $a3ccb5670e466352$export$fcc3388fb56de601)(action) ? action.payload : void 0, action.meta.arg.originalArgs, "baseQueryMeta" in action.meta ? action.meta.baseQueryMeta : void 0, assertTagType);
}
function $e80dfc866a603375$var$updateQuerySubstateIfExists(state, queryCacheKey, update) {
    var substate = state[queryCacheKey];
    if (substate) update(substate);
}
function $e80dfc866a603375$var$getMutationCacheKey(id) {
    var _a;
    return (_a = "arg" in id ? id.arg.fixedCacheKey : id.fixedCacheKey) != null ? _a : id.requestId;
}
function $e80dfc866a603375$var$updateMutationSubstateIfExists(state, id, update) {
    var substate = state[$e80dfc866a603375$var$getMutationCacheKey(id)];
    if (substate) update(substate);
}
var $e80dfc866a603375$var$initialState = {};
function $e80dfc866a603375$var$buildSlice(_j) {
    var reducerPath = _j.reducerPath, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, _k = _j.context, definitions = _k.endpointDefinitions, apiUid = _k.apiUid, extractRehydrationInfo = _k.extractRehydrationInfo, hasRehydrationInfo = _k.hasRehydrationInfo, assertTagType = _j.assertTagType, config = _j.config;
    var resetApiState = (0, $a3ccb5670e466352$export$309c7a02b0b0bc62)(reducerPath + "/resetApiState");
    var querySlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
        name: reducerPath + "/queries",
        initialState: $e80dfc866a603375$var$initialState,
        reducers: {
            removeQueryResult: {
                reducer: function(draft, _j) {
                    var queryCacheKey = _j.payload.queryCacheKey;
                    delete draft[queryCacheKey];
                },
                prepare: (0, $a3ccb5670e466352$export$39fcd5145ec5e4e2)()
            },
            queryResultPatched: function(draft, _j) {
                var _k = _j.payload, queryCacheKey = _k.queryCacheKey, patches = _k.patches;
                $e80dfc866a603375$var$updateQuerySubstateIfExists(draft, queryCacheKey, function(substate) {
                    substate.data = (0, $i9Ee7.applyPatches)(substate.data, patches.concat());
                });
            }
        },
        extraReducers: function(builder) {
            builder.addCase(queryThunk.pending, function(draft, _j) {
                var meta = _j.meta, arg = _j.meta.arg;
                var _a, _b;
                var upserting = $e80dfc866a603375$var$isUpsertQuery(arg);
                if (arg.subscribe || upserting) (_b = draft[_a = arg.queryCacheKey]) != null ? _b : draft[_a] = {
                    status: $e80dfc866a603375$export$f4258b89f6bad1d6.uninitialized,
                    endpointName: arg.endpointName
                };
                $e80dfc866a603375$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, function(substate) {
                    substate.status = $e80dfc866a603375$export$f4258b89f6bad1d6.pending;
                    substate.requestId = upserting && substate.requestId ? substate.requestId : meta.requestId;
                    if (arg.originalArgs !== void 0) substate.originalArgs = arg.originalArgs;
                    substate.startedTimeStamp = meta.startedTimeStamp;
                });
            }).addCase(queryThunk.fulfilled, function(draft, _j) {
                var meta = _j.meta, payload = _j.payload;
                $e80dfc866a603375$var$updateQuerySubstateIfExists(draft, meta.arg.queryCacheKey, function(substate) {
                    var _a;
                    if (substate.requestId !== meta.requestId && !$e80dfc866a603375$var$isUpsertQuery(meta.arg)) return;
                    var merge = definitions[meta.arg.endpointName].merge;
                    substate.status = $e80dfc866a603375$export$f4258b89f6bad1d6.fulfilled;
                    if (merge) {
                        if (substate.data !== void 0) {
                            var fulfilledTimeStamp_1 = meta.fulfilledTimeStamp, arg_1 = meta.arg, baseQueryMeta_1 = meta.baseQueryMeta, requestId_1 = meta.requestId;
                            var newData = (0, $i9Ee7.default)(substate.data, function(draftSubstateData) {
                                return merge(draftSubstateData, payload, {
                                    arg: arg_1.originalArgs,
                                    baseQueryMeta: baseQueryMeta_1,
                                    fulfilledTimeStamp: fulfilledTimeStamp_1,
                                    requestId: requestId_1
                                });
                            });
                            substate.data = newData;
                        } else substate.data = payload;
                    } else substate.data = ((_a = definitions[meta.arg.endpointName].structuralSharing) != null ? _a : true) ? $e80dfc866a603375$export$b64d4502a1c929bd((0, $i9Ee7.isDraft)(substate.data) ? (0, $i9Ee7.original)(substate.data) : substate.data, payload) : payload;
                    delete substate.error;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(queryThunk.rejected, function(draft, _j) {
                var _k = _j.meta, condition = _k.condition, arg = _k.arg, requestId = _k.requestId, error = _j.error, payload = _j.payload;
                $e80dfc866a603375$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, function(substate) {
                    if (condition) ;
                    else {
                        if (substate.requestId !== requestId) return;
                        substate.status = $e80dfc866a603375$export$f4258b89f6bad1d6.rejected;
                        substate.error = payload != null ? payload : error;
                    }
                });
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var queries = extractRehydrationInfo(action).queries;
                for(var _j = 0, _k = Object.entries(queries); _j < _k.length; _j++){
                    var _l = _k[_j], key = _l[0], entry = _l[1];
                    if ((entry == null ? void 0 : entry.status) === $e80dfc866a603375$export$f4258b89f6bad1d6.fulfilled || (entry == null ? void 0 : entry.status) === $e80dfc866a603375$export$f4258b89f6bad1d6.rejected) draft[key] = entry;
                }
            });
        }
    });
    var mutationSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
        name: reducerPath + "/mutations",
        initialState: $e80dfc866a603375$var$initialState,
        reducers: {
            removeMutationResult: {
                reducer: function(draft, _j) {
                    var payload = _j.payload;
                    var cacheKey = $e80dfc866a603375$var$getMutationCacheKey(payload);
                    if (cacheKey in draft) delete draft[cacheKey];
                },
                prepare: (0, $a3ccb5670e466352$export$39fcd5145ec5e4e2)()
            }
        },
        extraReducers: function(builder) {
            builder.addCase(mutationThunk.pending, function(draft, _j) {
                var meta = _j.meta, _k = _j.meta, requestId = _k.requestId, arg = _k.arg, startedTimeStamp = _k.startedTimeStamp;
                if (!arg.track) return;
                draft[$e80dfc866a603375$var$getMutationCacheKey(meta)] = {
                    requestId: requestId,
                    status: $e80dfc866a603375$export$f4258b89f6bad1d6.pending,
                    endpointName: arg.endpointName,
                    startedTimeStamp: startedTimeStamp
                };
            }).addCase(mutationThunk.fulfilled, function(draft, _j) {
                var payload = _j.payload, meta = _j.meta;
                if (!meta.arg.track) return;
                $e80dfc866a603375$var$updateMutationSubstateIfExists(draft, meta, function(substate) {
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = $e80dfc866a603375$export$f4258b89f6bad1d6.fulfilled;
                    substate.data = payload;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(mutationThunk.rejected, function(draft, _j) {
                var payload = _j.payload, error = _j.error, meta = _j.meta;
                if (!meta.arg.track) return;
                $e80dfc866a603375$var$updateMutationSubstateIfExists(draft, meta, function(substate) {
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = $e80dfc866a603375$export$f4258b89f6bad1d6.rejected;
                    substate.error = payload != null ? payload : error;
                });
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var mutations = extractRehydrationInfo(action).mutations;
                for(var _j = 0, _k = Object.entries(mutations); _j < _k.length; _j++){
                    var _l = _k[_j], key = _l[0], entry = _l[1];
                    if (((entry == null ? void 0 : entry.status) === $e80dfc866a603375$export$f4258b89f6bad1d6.fulfilled || (entry == null ? void 0 : entry.status) === $e80dfc866a603375$export$f4258b89f6bad1d6.rejected) && key !== (entry == null ? void 0 : entry.requestId)) draft[key] = entry;
                }
            });
        }
    });
    var invalidationSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
        name: reducerPath + "/invalidation",
        initialState: $e80dfc866a603375$var$initialState,
        reducers: {},
        extraReducers: function(builder) {
            builder.addCase(querySlice.actions.removeQueryResult, function(draft, _j) {
                var queryCacheKey = _j.payload.queryCacheKey;
                for(var _k = 0, _l = Object.values(draft); _k < _l.length; _k++){
                    var tagTypeSubscriptions = _l[_k];
                    for(var _m = 0, _o = Object.values(tagTypeSubscriptions); _m < _o.length; _m++){
                        var idSubscriptions = _o[_m];
                        var foundAt = idSubscriptions.indexOf(queryCacheKey);
                        if (foundAt !== -1) idSubscriptions.splice(foundAt, 1);
                    }
                }
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var _a, _b, _c, _d;
                var provided = extractRehydrationInfo(action).provided;
                for(var _j = 0, _k = Object.entries(provided); _j < _k.length; _j++){
                    var _l = _k[_j], type = _l[0], incomingTags = _l[1];
                    for(var _m = 0, _o = Object.entries(incomingTags); _m < _o.length; _m++){
                        var _p = _o[_m], id = _p[0], cacheKeys = _p[1];
                        var subscribedQueries = (_d = (_b = (_a = draft[type]) != null ? _a : draft[type] = {})[_c = id || "__internal_without_id"]) != null ? _d : _b[_c] = [];
                        for(var _q = 0, cacheKeys_1 = cacheKeys; _q < cacheKeys_1.length; _q++){
                            var queryCacheKey = cacheKeys_1[_q];
                            var alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                            if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                        }
                    }
                }
            }).addMatcher((0, $a3ccb5670e466352$export$2c3435c7647f7b0d)((0, $a3ccb5670e466352$export$1da80a6ef1307441)(queryThunk), (0, $a3ccb5670e466352$export$fcc3388fb56de601)(queryThunk)), function(draft, action) {
                var _a, _b, _c, _d;
                var providedTags = $e80dfc866a603375$var$calculateProvidedByThunk(action, "providesTags", definitions, assertTagType);
                var queryCacheKey = action.meta.arg.queryCacheKey;
                for(var _j = 0, _k = Object.values(draft); _j < _k.length; _j++){
                    var tagTypeSubscriptions = _k[_j];
                    for(var _l = 0, _m = Object.values(tagTypeSubscriptions); _l < _m.length; _l++){
                        var idSubscriptions = _m[_l];
                        var foundAt = idSubscriptions.indexOf(queryCacheKey);
                        if (foundAt !== -1) idSubscriptions.splice(foundAt, 1);
                    }
                }
                for(var _o = 0, providedTags_1 = providedTags; _o < providedTags_1.length; _o++){
                    var _p = providedTags_1[_o], type = _p.type, id = _p.id;
                    var subscribedQueries = (_d = (_b = (_a = draft[type]) != null ? _a : draft[type] = {})[_c = id || "__internal_without_id"]) != null ? _d : _b[_c] = [];
                    var alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                    if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                }
            });
        }
    });
    var subscriptionSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
        name: reducerPath + "/subscriptions",
        initialState: $e80dfc866a603375$var$initialState,
        reducers: {
            updateSubscriptionOptions: function(d, a) {},
            unsubscribeQueryResult: function(d, a) {},
            internal_probeSubscription: function(d, a) {}
        }
    });
    var internalSubscriptionsSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
        name: reducerPath + "/internalSubscriptions",
        initialState: $e80dfc866a603375$var$initialState,
        reducers: {
            subscriptionsUpdated: {
                reducer: function(state, action) {
                    return (0, $i9Ee7.applyPatches)(state, action.payload);
                },
                prepare: (0, $a3ccb5670e466352$export$39fcd5145ec5e4e2)()
            }
        }
    });
    var configSlice = (0, $a3ccb5670e466352$export$4d8d9bd83c24ae8b)({
        name: reducerPath + "/config",
        initialState: $e80dfc866a603375$var$__spreadValues({
            online: $e80dfc866a603375$var$isOnline(),
            focused: $e80dfc866a603375$var$isDocumentVisible(),
            middlewareRegistered: false
        }, config),
        reducers: {
            middlewareRegistered: function(state, _j) {
                var payload = _j.payload;
                state.middlewareRegistered = state.middlewareRegistered === "conflict" || apiUid !== payload ? "conflict" : true;
            }
        },
        extraReducers: function(builder) {
            builder.addCase($e80dfc866a603375$var$onOnline, function(state) {
                state.online = true;
            }).addCase($e80dfc866a603375$var$onOffline, function(state) {
                state.online = false;
            }).addCase($e80dfc866a603375$var$onFocus, function(state) {
                state.focused = true;
            }).addCase($e80dfc866a603375$var$onFocusLost, function(state) {
                state.focused = false;
            }).addMatcher(hasRehydrationInfo, function(draft) {
                return $e80dfc866a603375$var$__spreadValues({}, draft);
            });
        }
    });
    var combinedReducer = (0, $d0affe2ff19fe4b6$export$66e4520cdb265d18)({
        queries: querySlice.reducer,
        mutations: mutationSlice.reducer,
        provided: invalidationSlice.reducer,
        subscriptions: internalSubscriptionsSlice.reducer,
        config: configSlice.reducer
    });
    var reducer = function(state, action) {
        return combinedReducer(resetApiState.match(action) ? void 0 : state, action);
    };
    var actions = $e80dfc866a603375$var$__spreadProps($e80dfc866a603375$var$__spreadValues($e80dfc866a603375$var$__spreadValues($e80dfc866a603375$var$__spreadValues($e80dfc866a603375$var$__spreadValues($e80dfc866a603375$var$__spreadValues({}, configSlice.actions), querySlice.actions), subscriptionSlice.actions), internalSubscriptionsSlice.actions), mutationSlice.actions), {
        unsubscribeMutationResult: mutationSlice.actions.removeMutationResult,
        resetApiState: resetApiState
    });
    return {
        reducer: reducer,
        actions: actions
    };
}
// src/query/core/buildSelectors.ts
var $e80dfc866a603375$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol.for("RTKQ/skipToken");
var $e80dfc866a603375$export$8b2f5cccb7eda71d = $e80dfc866a603375$export$1aa5a89531b7670d;
var $e80dfc866a603375$var$initialSubState = {
    status: $e80dfc866a603375$export$f4258b89f6bad1d6.uninitialized
};
var $e80dfc866a603375$var$defaultQuerySubState = /* @__PURE__ */ (0, $i9Ee7.default)($e80dfc866a603375$var$initialSubState, function() {});
var $e80dfc866a603375$var$defaultMutationSubState = /* @__PURE__ */ (0, $i9Ee7.default)($e80dfc866a603375$var$initialSubState, function() {});
function $e80dfc866a603375$var$buildSelectors(_j) {
    var serializeQueryArgs = _j.serializeQueryArgs, reducerPath = _j.reducerPath;
    var selectSkippedQuery = function(state) {
        return $e80dfc866a603375$var$defaultQuerySubState;
    };
    var selectSkippedMutation = function(state) {
        return $e80dfc866a603375$var$defaultMutationSubState;
    };
    return {
        buildQuerySelector: buildQuerySelector,
        buildMutationSelector: buildMutationSelector,
        selectInvalidatedBy: selectInvalidatedBy
    };
    function withRequestFlags(substate) {
        return $e80dfc866a603375$var$__spreadValues($e80dfc866a603375$var$__spreadValues({}, substate), $e80dfc866a603375$var$getRequestStatusFlags(substate.status));
    }
    function selectInternalState(rootState) {
        var state = rootState[reducerPath];
        return state;
    }
    function buildQuerySelector(endpointName, endpointDefinition) {
        return function(queryArgs) {
            var serializedArgs = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            var selectQuerySubstate = function(state) {
                var _a, _b, _c;
                return (_c = (_b = (_a = selectInternalState(state)) == null ? void 0 : _a.queries) == null ? void 0 : _b[serializedArgs]) != null ? _c : $e80dfc866a603375$var$defaultQuerySubState;
            };
            var finalSelectQuerySubState = queryArgs === $e80dfc866a603375$export$1aa5a89531b7670d ? selectSkippedQuery : selectQuerySubstate;
            return (0, $bb5ac58d2597f8dc$export$595d22ed68ca2841)(finalSelectQuerySubState, withRequestFlags);
        };
    }
    function buildMutationSelector() {
        return function(id) {
            var _a;
            var mutationId;
            if (typeof id === "object") mutationId = (_a = $e80dfc866a603375$var$getMutationCacheKey(id)) != null ? _a : $e80dfc866a603375$export$1aa5a89531b7670d;
            else mutationId = id;
            var selectMutationSubstate = function(state) {
                var _a2, _b, _c;
                return (_c = (_b = (_a2 = selectInternalState(state)) == null ? void 0 : _a2.mutations) == null ? void 0 : _b[mutationId]) != null ? _c : $e80dfc866a603375$var$defaultMutationSubState;
            };
            var finalSelectMutationSubstate = mutationId === $e80dfc866a603375$export$1aa5a89531b7670d ? selectSkippedMutation : selectMutationSubstate;
            return (0, $bb5ac58d2597f8dc$export$595d22ed68ca2841)(finalSelectMutationSubstate, withRequestFlags);
        };
    }
    function selectInvalidatedBy(state, tags) {
        var _a;
        var apiState = state[reducerPath];
        var toInvalidate = new Set();
        for(var _j = 0, _k = tags.map($e80dfc866a603375$var$expandTagDescription); _j < _k.length; _j++){
            var tag = _k[_j];
            var provided = apiState.provided[tag.type];
            if (!provided) continue;
            var invalidateSubscriptions = (_a = tag.id !== void 0 ? provided[tag.id] : $e80dfc866a603375$var$flatten(Object.values(provided))) != null ? _a : [];
            for(var _l = 0, invalidateSubscriptions_1 = invalidateSubscriptions; _l < invalidateSubscriptions_1.length; _l++){
                var invalidate = invalidateSubscriptions_1[_l];
                toInvalidate.add(invalidate);
            }
        }
        return $e80dfc866a603375$var$flatten(Array.from(toInvalidate.values()).map(function(queryCacheKey) {
            var querySubState = apiState.queries[queryCacheKey];
            return querySubState ? [
                {
                    queryCacheKey: queryCacheKey,
                    endpointName: querySubState.endpointName,
                    originalArgs: querySubState.originalArgs
                }
            ] : [];
        }));
    }
}
var $e80dfc866a603375$var$cache = WeakMap ? new WeakMap() : void 0;
var $e80dfc866a603375$export$db8e4edac9bbb67b = function(_j) {
    var endpointName = _j.endpointName, queryArgs = _j.queryArgs;
    var serialized = "";
    var cached = $e80dfc866a603375$var$cache == null ? void 0 : $e80dfc866a603375$var$cache.get(queryArgs);
    if (typeof cached === "string") serialized = cached;
    else {
        var stringified = JSON.stringify(queryArgs, function(key, value) {
            return (0, $a3ccb5670e466352$export$53b83ca8eaab0383)(value) ? Object.keys(value).sort().reduce(function(acc, key2) {
                acc[key2] = value[key2];
                return acc;
            }, {}) : value;
        });
        if ((0, $a3ccb5670e466352$export$53b83ca8eaab0383)(queryArgs)) $e80dfc866a603375$var$cache == null || $e80dfc866a603375$var$cache.set(queryArgs, stringified);
        serialized = stringified;
    }
    return endpointName + "(" + serialized + ")";
};
function $e80dfc866a603375$export$f957748792d43646() {
    var modules = [];
    for(var _j = 0; _j < arguments.length; _j++)modules[_j] = arguments[_j];
    return function baseCreateApi(options) {
        var extractRehydrationInfo = (0, $44e5fc722a9bc7be$export$281bff7f05488aa2)(function(action) {
            var _a, _b;
            return (_b = options.extractRehydrationInfo) == null ? void 0 : _b.call(options, action, {
                reducerPath: (_a = options.reducerPath) != null ? _a : "api"
            });
        });
        var optionsWithDefaults = $e80dfc866a603375$var$__spreadProps($e80dfc866a603375$var$__spreadValues({
            reducerPath: "api",
            keepUnusedDataFor: 60,
            refetchOnMountOrArgChange: false,
            refetchOnFocus: false,
            refetchOnReconnect: false
        }, options), {
            extractRehydrationInfo: extractRehydrationInfo,
            serializeQueryArgs: function(queryArgsApi) {
                var finalSerializeQueryArgs = $e80dfc866a603375$export$db8e4edac9bbb67b;
                if ("serializeQueryArgs" in queryArgsApi.endpointDefinition) {
                    var endpointSQA_1 = queryArgsApi.endpointDefinition.serializeQueryArgs;
                    finalSerializeQueryArgs = function(queryArgsApi2) {
                        var initialResult = endpointSQA_1(queryArgsApi2);
                        if (typeof initialResult === "string") return initialResult;
                        else return $e80dfc866a603375$export$db8e4edac9bbb67b($e80dfc866a603375$var$__spreadProps($e80dfc866a603375$var$__spreadValues({}, queryArgsApi2), {
                            queryArgs: initialResult
                        }));
                    };
                } else if (options.serializeQueryArgs) finalSerializeQueryArgs = options.serializeQueryArgs;
                return finalSerializeQueryArgs(queryArgsApi);
            },
            tagTypes: $e80dfc866a603375$var$__spreadArray([], options.tagTypes || [])
        });
        var context = {
            endpointDefinitions: {},
            batch: function(fn) {
                fn();
            },
            apiUid: (0, $a3ccb5670e466352$export$ac4959f4f1338dfc)(),
            extractRehydrationInfo: extractRehydrationInfo,
            hasRehydrationInfo: (0, $44e5fc722a9bc7be$export$281bff7f05488aa2)(function(action) {
                return extractRehydrationInfo(action) != null;
            })
        };
        var api = {
            injectEndpoints: injectEndpoints,
            enhanceEndpoints: function(_j) {
                var addTagTypes = _j.addTagTypes, endpoints = _j.endpoints;
                if (addTagTypes) for(var _k = 0, addTagTypes_1 = addTagTypes; _k < addTagTypes_1.length; _k++){
                    var eT = addTagTypes_1[_k];
                    if (!optionsWithDefaults.tagTypes.includes(eT)) optionsWithDefaults.tagTypes.push(eT);
                }
                if (endpoints) for(var _l = 0, _m = Object.entries(endpoints); _l < _m.length; _l++){
                    var _o = _m[_l], endpointName = _o[0], partialDefinition = _o[1];
                    if (typeof partialDefinition === "function") partialDefinition(context.endpointDefinitions[endpointName]);
                    else Object.assign(context.endpointDefinitions[endpointName] || {}, partialDefinition);
                }
                return api;
            }
        };
        var initializedModules = modules.map(function(m) {
            return m.init(api, optionsWithDefaults, context);
        });
        function injectEndpoints(inject) {
            var evaluatedEndpoints = inject.endpoints({
                query: function(x) {
                    return $e80dfc866a603375$var$__spreadProps($e80dfc866a603375$var$__spreadValues({}, x), {
                        type: $e80dfc866a603375$var$DefinitionType.query
                    });
                },
                mutation: function(x) {
                    return $e80dfc866a603375$var$__spreadProps($e80dfc866a603375$var$__spreadValues({}, x), {
                        type: $e80dfc866a603375$var$DefinitionType.mutation
                    });
                }
            });
            for(var _j = 0, _k = Object.entries(evaluatedEndpoints); _j < _k.length; _j++){
                var _l = _k[_j], endpointName = _l[0], definition = _l[1];
                if (!inject.overrideExisting && endpointName in context.endpointDefinitions) {
                    typeof $eh5Zb;
                    continue;
                }
                context.endpointDefinitions[endpointName] = definition;
                for(var _m = 0, initializedModules_1 = initializedModules; _m < initializedModules_1.length; _m++){
                    var m = initializedModules_1[_m];
                    m.injectEndpoint(endpointName, definition);
                }
            }
            return api;
        }
        return api.injectEndpoints({
            endpoints: options.endpoints
        });
    };
}
// src/query/fakeBaseQuery.ts
function $e80dfc866a603375$export$f72b22d3ac378bae() {
    return function() {
        throw new Error("When using `fakeBaseQuery`, all queries & mutations must use the `queryFn` definition syntax.");
    };
}
// src/query/core/buildMiddleware/cacheCollection.ts
function $e80dfc866a603375$var$isObjectEmpty(obj) {
    for(var k in obj)return false;
    return true;
}
var $e80dfc866a603375$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS = 2147482.647;
var $e80dfc866a603375$var$buildCacheCollectionHandler = function(_j) {
    var reducerPath = _j.reducerPath, api = _j.api, context = _j.context, internalState = _j.internalState;
    var _k = api.internalActions, removeQueryResult = _k.removeQueryResult, unsubscribeQueryResult = _k.unsubscribeQueryResult;
    function anySubscriptionsRemainingForKey(queryCacheKey) {
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        return !!subscriptions && !$e80dfc866a603375$var$isObjectEmpty(subscriptions);
    }
    var currentRemovalTimeouts = {};
    var handler = function(action, mwApi, internalState2) {
        var _a;
        if (unsubscribeQueryResult.match(action)) {
            var state = mwApi.getState()[reducerPath];
            var queryCacheKey = action.payload.queryCacheKey;
            handleUnsubscribe(queryCacheKey, (_a = state.queries[queryCacheKey]) == null ? void 0 : _a.endpointName, mwApi, state.config);
        }
        if (api.util.resetApiState.match(action)) for(var _j = 0, _k = Object.entries(currentRemovalTimeouts); _j < _k.length; _j++){
            var _l = _k[_j], key = _l[0], timeout = _l[1];
            if (timeout) clearTimeout(timeout);
            delete currentRemovalTimeouts[key];
        }
        if (context.hasRehydrationInfo(action)) {
            var state = mwApi.getState()[reducerPath];
            var queries = context.extractRehydrationInfo(action).queries;
            for(var _m = 0, _o = Object.entries(queries); _m < _o.length; _m++){
                var _p = _o[_m], queryCacheKey = _p[0], queryState = _p[1];
                handleUnsubscribe(queryCacheKey, queryState == null ? void 0 : queryState.endpointName, mwApi, state.config);
            }
        }
    };
    function handleUnsubscribe(queryCacheKey, endpointName, api2, config) {
        var _a;
        var endpointDefinition = context.endpointDefinitions[endpointName];
        var keepUnusedDataFor = (_a = endpointDefinition == null ? void 0 : endpointDefinition.keepUnusedDataFor) != null ? _a : config.keepUnusedDataFor;
        if (keepUnusedDataFor === Infinity) return;
        var finalKeepUnusedDataFor = Math.max(0, Math.min(keepUnusedDataFor, $e80dfc866a603375$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS));
        if (!anySubscriptionsRemainingForKey(queryCacheKey)) {
            var currentTimeout = currentRemovalTimeouts[queryCacheKey];
            if (currentTimeout) clearTimeout(currentTimeout);
            currentRemovalTimeouts[queryCacheKey] = setTimeout(function() {
                if (!anySubscriptionsRemainingForKey(queryCacheKey)) api2.dispatch(removeQueryResult({
                    queryCacheKey: queryCacheKey
                }));
                delete currentRemovalTimeouts[queryCacheKey];
            }, finalKeepUnusedDataFor * 1e3);
        }
    }
    return handler;
};
var $e80dfc866a603375$var$buildInvalidationByTagsHandler = function(_j) {
    var reducerPath = _j.reducerPath, context = _j.context, endpointDefinitions = _j.context.endpointDefinitions, mutationThunk = _j.mutationThunk, api = _j.api, assertTagType = _j.assertTagType, refetchQuery = _j.refetchQuery;
    var removeQueryResult = api.internalActions.removeQueryResult;
    var isThunkActionWithTags = (0, $a3ccb5670e466352$export$2c3435c7647f7b0d)((0, $a3ccb5670e466352$export$1da80a6ef1307441)(mutationThunk), (0, $a3ccb5670e466352$export$fcc3388fb56de601)(mutationThunk));
    var handler = function(action, mwApi) {
        if (isThunkActionWithTags(action)) invalidateTags($e80dfc866a603375$var$calculateProvidedByThunk(action, "invalidatesTags", endpointDefinitions, assertTagType), mwApi);
        if (api.util.invalidateTags.match(action)) invalidateTags($e80dfc866a603375$var$calculateProvidedBy(action.payload, void 0, void 0, void 0, void 0, assertTagType), mwApi);
    };
    function invalidateTags(tags, mwApi) {
        var rootState = mwApi.getState();
        var state = rootState[reducerPath];
        var toInvalidate = api.util.selectInvalidatedBy(rootState, tags);
        context.batch(function() {
            var _a;
            var valuesArray = Array.from(toInvalidate.values());
            for(var _j = 0, valuesArray_1 = valuesArray; _j < valuesArray_1.length; _j++){
                var queryCacheKey = valuesArray_1[_j].queryCacheKey;
                var querySubState = state.queries[queryCacheKey];
                var subscriptionSubState = (_a = state.subscriptions[queryCacheKey]) != null ? _a : {};
                if (querySubState) {
                    if (Object.keys(subscriptionSubState).length === 0) mwApi.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== $e80dfc866a603375$export$f4258b89f6bad1d6.uninitialized) mwApi.dispatch(refetchQuery(querySubState, queryCacheKey));
                }
            }
        });
    }
    return handler;
};
// src/query/core/buildMiddleware/polling.ts
var $e80dfc866a603375$var$buildPollingHandler = function(_j) {
    var reducerPath = _j.reducerPath, queryThunk = _j.queryThunk, api = _j.api, refetchQuery = _j.refetchQuery, internalState = _j.internalState;
    var currentPolls = {};
    var handler = function(action, mwApi) {
        if (api.internalActions.updateSubscriptionOptions.match(action) || api.internalActions.unsubscribeQueryResult.match(action)) updatePollingInterval(action.payload, mwApi);
        if (queryThunk.pending.match(action) || queryThunk.rejected.match(action) && action.meta.condition) updatePollingInterval(action.meta.arg, mwApi);
        if (queryThunk.fulfilled.match(action) || queryThunk.rejected.match(action) && !action.meta.condition) startNextPoll(action.meta.arg, mwApi);
        if (api.util.resetApiState.match(action)) clearPolls();
    };
    function startNextPoll(_j, api2) {
        var queryCacheKey = _j.queryCacheKey;
        var state = api2.getState()[reducerPath];
        var querySubState = state.queries[queryCacheKey];
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === $e80dfc866a603375$export$f4258b89f6bad1d6.uninitialized) return;
        var lowestPollingInterval = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) return;
        var currentPoll = currentPolls[queryCacheKey];
        if (currentPoll == null ? void 0 : currentPoll.timeout) {
            clearTimeout(currentPoll.timeout);
            currentPoll.timeout = void 0;
        }
        var nextPollTimestamp = Date.now() + lowestPollingInterval;
        var currentInterval = currentPolls[queryCacheKey] = {
            nextPollTimestamp: nextPollTimestamp,
            pollingInterval: lowestPollingInterval,
            timeout: setTimeout(function() {
                currentInterval.timeout = void 0;
                api2.dispatch(refetchQuery(querySubState, queryCacheKey));
            }, lowestPollingInterval)
        };
    }
    function updatePollingInterval(_j, api2) {
        var queryCacheKey = _j.queryCacheKey;
        var state = api2.getState()[reducerPath];
        var querySubState = state.queries[queryCacheKey];
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === $e80dfc866a603375$export$f4258b89f6bad1d6.uninitialized) return;
        var lowestPollingInterval = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) {
            cleanupPollForKey(queryCacheKey);
            return;
        }
        var currentPoll = currentPolls[queryCacheKey];
        var nextPollTimestamp = Date.now() + lowestPollingInterval;
        if (!currentPoll || nextPollTimestamp < currentPoll.nextPollTimestamp) startNextPoll({
            queryCacheKey: queryCacheKey
        }, api2);
    }
    function cleanupPollForKey(key) {
        var existingPoll = currentPolls[key];
        if (existingPoll == null ? void 0 : existingPoll.timeout) clearTimeout(existingPoll.timeout);
        delete currentPolls[key];
    }
    function clearPolls() {
        for(var _j = 0, _k = Object.keys(currentPolls); _j < _k.length; _j++){
            var key = _k[_j];
            cleanupPollForKey(key);
        }
    }
    function findLowestPollingInterval(subscribers) {
        if (subscribers === void 0) subscribers = {};
        var lowestPollingInterval = Number.POSITIVE_INFINITY;
        for(var key in subscribers)if (!!subscribers[key].pollingInterval) lowestPollingInterval = Math.min(subscribers[key].pollingInterval, lowestPollingInterval);
        return lowestPollingInterval;
    }
    return handler;
};
// src/query/core/buildMiddleware/windowEventHandling.ts
var $e80dfc866a603375$var$buildWindowEventHandler = function(_j) {
    var reducerPath = _j.reducerPath, context = _j.context, api = _j.api, refetchQuery = _j.refetchQuery, internalState = _j.internalState;
    var removeQueryResult = api.internalActions.removeQueryResult;
    var handler = function(action, mwApi) {
        if ($e80dfc866a603375$var$onFocus.match(action)) refetchValidQueries(mwApi, "refetchOnFocus");
        if ($e80dfc866a603375$var$onOnline.match(action)) refetchValidQueries(mwApi, "refetchOnReconnect");
    };
    function refetchValidQueries(api2, type) {
        var state = api2.getState()[reducerPath];
        var queries = state.queries;
        var subscriptions = internalState.currentSubscriptions;
        context.batch(function() {
            for(var _j = 0, _k = Object.keys(subscriptions); _j < _k.length; _j++){
                var queryCacheKey = _k[_j];
                var querySubState = queries[queryCacheKey];
                var subscriptionSubState = subscriptions[queryCacheKey];
                if (!subscriptionSubState || !querySubState) continue;
                var shouldRefetch = Object.values(subscriptionSubState).some(function(sub) {
                    return sub[type] === true;
                }) || Object.values(subscriptionSubState).every(function(sub) {
                    return sub[type] === void 0;
                }) && state.config[type];
                if (shouldRefetch) {
                    if (Object.keys(subscriptionSubState).length === 0) api2.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== $e80dfc866a603375$export$f4258b89f6bad1d6.uninitialized) api2.dispatch(refetchQuery(querySubState, queryCacheKey));
                }
            }
        });
    }
    return handler;
};
var $e80dfc866a603375$var$neverResolvedError = new Error("Promise never resolved before cacheEntryRemoved.");
var $e80dfc866a603375$var$buildCacheLifecycleHandler = function(_j) {
    var api = _j.api, reducerPath = _j.reducerPath, context = _j.context, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, internalState = _j.internalState;
    var isQueryThunk = (0, $a3ccb5670e466352$export$6aa4142d99c1abce)(queryThunk);
    var isMutationThunk = (0, $a3ccb5670e466352$export$6aa4142d99c1abce)(mutationThunk);
    var isFulfilledThunk = (0, $a3ccb5670e466352$export$1da80a6ef1307441)(queryThunk, mutationThunk);
    var lifecycleMap = {};
    var handler = function(action, mwApi, stateBefore) {
        var cacheKey = getCacheKey(action);
        if (queryThunk.pending.match(action)) {
            var oldState = stateBefore[reducerPath].queries[cacheKey];
            var state = mwApi.getState()[reducerPath].queries[cacheKey];
            if (!oldState && state) handleNewKey(action.meta.arg.endpointName, action.meta.arg.originalArgs, cacheKey, mwApi, action.meta.requestId);
        } else if (mutationThunk.pending.match(action)) {
            var state = mwApi.getState()[reducerPath].mutations[cacheKey];
            if (state) handleNewKey(action.meta.arg.endpointName, action.meta.arg.originalArgs, cacheKey, mwApi, action.meta.requestId);
        } else if (isFulfilledThunk(action)) {
            var lifecycle = lifecycleMap[cacheKey];
            if (lifecycle == null ? void 0 : lifecycle.valueResolved) {
                lifecycle.valueResolved({
                    data: action.payload,
                    meta: action.meta.baseQueryMeta
                });
                delete lifecycle.valueResolved;
            }
        } else if (api.internalActions.removeQueryResult.match(action) || api.internalActions.removeMutationResult.match(action)) {
            var lifecycle = lifecycleMap[cacheKey];
            if (lifecycle) {
                delete lifecycleMap[cacheKey];
                lifecycle.cacheEntryRemoved();
            }
        } else if (api.util.resetApiState.match(action)) for(var _j = 0, _k = Object.entries(lifecycleMap); _j < _k.length; _j++){
            var _l = _k[_j], cacheKey2 = _l[0], lifecycle = _l[1];
            delete lifecycleMap[cacheKey2];
            lifecycle.cacheEntryRemoved();
        }
    };
    function getCacheKey(action) {
        if (isQueryThunk(action)) return action.meta.arg.queryCacheKey;
        if (isMutationThunk(action)) return action.meta.requestId;
        if (api.internalActions.removeQueryResult.match(action)) return action.payload.queryCacheKey;
        if (api.internalActions.removeMutationResult.match(action)) return $e80dfc866a603375$var$getMutationCacheKey(action.payload);
        return "";
    }
    function handleNewKey(endpointName, originalArgs, queryCacheKey, mwApi, requestId) {
        var endpointDefinition = context.endpointDefinitions[endpointName];
        var onCacheEntryAdded = endpointDefinition == null ? void 0 : endpointDefinition.onCacheEntryAdded;
        if (!onCacheEntryAdded) return;
        var lifecycle = {};
        var cacheEntryRemoved = new Promise(function(resolve) {
            lifecycle.cacheEntryRemoved = resolve;
        });
        var cacheDataLoaded = Promise.race([
            new Promise(function(resolve) {
                lifecycle.valueResolved = resolve;
            }),
            cacheEntryRemoved.then(function() {
                throw $e80dfc866a603375$var$neverResolvedError;
            })
        ]);
        cacheDataLoaded.catch(function() {});
        lifecycleMap[queryCacheKey] = lifecycle;
        var selector = api.endpoints[endpointName].select(endpointDefinition.type === $e80dfc866a603375$var$DefinitionType.query ? originalArgs : queryCacheKey);
        var extra = mwApi.dispatch(function(_, __, extra2) {
            return extra2;
        });
        var lifecycleApi = $e80dfc866a603375$var$__spreadProps($e80dfc866a603375$var$__spreadValues({}, mwApi), {
            getCacheEntry: function() {
                return selector(mwApi.getState());
            },
            requestId: requestId,
            extra: extra,
            updateCachedData: endpointDefinition.type === $e80dfc866a603375$var$DefinitionType.query ? function(updateRecipe) {
                return mwApi.dispatch(api.util.updateQueryData(endpointName, originalArgs, updateRecipe));
            } : void 0,
            cacheDataLoaded: cacheDataLoaded,
            cacheEntryRemoved: cacheEntryRemoved
        });
        var runningHandler = onCacheEntryAdded(originalArgs, lifecycleApi);
        Promise.resolve(runningHandler).catch(function(e) {
            if (e === $e80dfc866a603375$var$neverResolvedError) return;
            throw e;
        });
    }
    return handler;
};
var $e80dfc866a603375$var$buildQueryLifecycleHandler = function(_j) {
    var api = _j.api, context = _j.context, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk;
    var isPendingThunk = (0, $a3ccb5670e466352$export$872dec21e9a69476)(queryThunk, mutationThunk);
    var isRejectedThunk = (0, $a3ccb5670e466352$export$a5c5d27e3994c5be)(queryThunk, mutationThunk);
    var isFullfilledThunk = (0, $a3ccb5670e466352$export$1da80a6ef1307441)(queryThunk, mutationThunk);
    var lifecycleMap = {};
    var handler = function(action, mwApi) {
        var _a, _b, _c;
        if (isPendingThunk(action)) {
            var _j = action.meta, requestId = _j.requestId, _k = _j.arg, endpointName_1 = _k.endpointName, originalArgs_1 = _k.originalArgs;
            var endpointDefinition = context.endpointDefinitions[endpointName_1];
            var onQueryStarted = endpointDefinition == null ? void 0 : endpointDefinition.onQueryStarted;
            if (onQueryStarted) {
                var lifecycle_1 = {};
                var queryFulfilled = new Promise(function(resolve, reject) {
                    lifecycle_1.resolve = resolve;
                    lifecycle_1.reject = reject;
                });
                queryFulfilled.catch(function() {});
                lifecycleMap[requestId] = lifecycle_1;
                var selector_1 = api.endpoints[endpointName_1].select(endpointDefinition.type === $e80dfc866a603375$var$DefinitionType.query ? originalArgs_1 : requestId);
                var extra = mwApi.dispatch(function(_, __, extra2) {
                    return extra2;
                });
                var lifecycleApi = $e80dfc866a603375$var$__spreadProps($e80dfc866a603375$var$__spreadValues({}, mwApi), {
                    getCacheEntry: function() {
                        return selector_1(mwApi.getState());
                    },
                    requestId: requestId,
                    extra: extra,
                    updateCachedData: endpointDefinition.type === $e80dfc866a603375$var$DefinitionType.query ? function(updateRecipe) {
                        return mwApi.dispatch(api.util.updateQueryData(endpointName_1, originalArgs_1, updateRecipe));
                    } : void 0,
                    queryFulfilled: queryFulfilled
                });
                onQueryStarted(originalArgs_1, lifecycleApi);
            }
        } else if (isFullfilledThunk(action)) {
            var _l = action.meta, requestId = _l.requestId, baseQueryMeta = _l.baseQueryMeta;
            (_a = lifecycleMap[requestId]) == null || _a.resolve({
                data: action.payload,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        } else if (isRejectedThunk(action)) {
            var _m = action.meta, requestId = _m.requestId, rejectedWithValue = _m.rejectedWithValue, baseQueryMeta = _m.baseQueryMeta;
            (_c = lifecycleMap[requestId]) == null || _c.reject({
                error: (_b = action.payload) != null ? _b : action.error,
                isUnhandledError: !rejectedWithValue,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        }
    };
    return handler;
};
// src/query/core/buildMiddleware/devMiddleware.ts
var $e80dfc866a603375$var$buildDevCheckHandler = function(_j) {
    var api = _j.api, apiUid = _j.context.apiUid, reducerPath = _j.reducerPath;
    return function(action, mwApi) {
        var _a, _b;
        if (api.util.resetApiState.match(action)) mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
        typeof $eh5Zb;
    };
};
var $e80dfc866a603375$var$promise;
var $e80dfc866a603375$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($e80dfc866a603375$var$promise || ($e80dfc866a603375$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $e80dfc866a603375$var$buildBatchedActionsHandler = function(_j) {
    var api = _j.api, queryThunk = _j.queryThunk, internalState = _j.internalState;
    var subscriptionsPrefix = api.reducerPath + "/subscriptions";
    var previousSubscriptions = null;
    var dispatchQueued = false;
    var _k = api.internalActions, updateSubscriptionOptions = _k.updateSubscriptionOptions, unsubscribeQueryResult = _k.unsubscribeQueryResult;
    var actuallyMutateSubscriptions = function(mutableState, action) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        if (updateSubscriptionOptions.match(action)) {
            var _j = action.payload, queryCacheKey = _j.queryCacheKey, requestId = _j.requestId, options = _j.options;
            if ((_a = mutableState == null ? void 0 : mutableState[queryCacheKey]) == null ? void 0 : _a[requestId]) mutableState[queryCacheKey][requestId] = options;
            return true;
        }
        if (unsubscribeQueryResult.match(action)) {
            var _k = action.payload, queryCacheKey = _k.queryCacheKey, requestId = _k.requestId;
            if (mutableState[queryCacheKey]) delete mutableState[queryCacheKey][requestId];
            return true;
        }
        if (api.internalActions.removeQueryResult.match(action)) {
            delete mutableState[action.payload.queryCacheKey];
            return true;
        }
        if (queryThunk.pending.match(action)) {
            var _l = action.meta, arg = _l.arg, requestId = _l.requestId;
            if (arg.subscribe) {
                var substate = (_c = mutableState[_b = arg.queryCacheKey]) != null ? _c : mutableState[_b] = {};
                substate[requestId] = (_e = (_d = arg.subscriptionOptions) != null ? _d : substate[requestId]) != null ? _e : {};
                return true;
            }
        }
        if (queryThunk.rejected.match(action)) {
            var _m = action.meta, condition = _m.condition, arg = _m.arg, requestId = _m.requestId;
            if (condition && arg.subscribe) {
                var substate = (_g = mutableState[_f = arg.queryCacheKey]) != null ? _g : mutableState[_f] = {};
                substate[requestId] = (_i = (_h = arg.subscriptionOptions) != null ? _h : substate[requestId]) != null ? _i : {};
                return true;
            }
        }
        return false;
    };
    return function(action, mwApi) {
        var _a, _b;
        if (!previousSubscriptions) previousSubscriptions = JSON.parse(JSON.stringify(internalState.currentSubscriptions));
        if (api.util.resetApiState.match(action)) {
            previousSubscriptions = internalState.currentSubscriptions = {};
            return [
                true,
                false
            ];
        }
        if (api.internalActions.internal_probeSubscription.match(action)) {
            var _j = action.payload, queryCacheKey = _j.queryCacheKey, requestId = _j.requestId;
            var hasSubscription = !!((_a = internalState.currentSubscriptions[queryCacheKey]) == null ? void 0 : _a[requestId]);
            return [
                false,
                hasSubscription
            ];
        }
        var didMutate = actuallyMutateSubscriptions(internalState.currentSubscriptions, action);
        if (didMutate) {
            if (!dispatchQueued) {
                $e80dfc866a603375$var$queueMicrotaskShim(function() {
                    var newSubscriptions = JSON.parse(JSON.stringify(internalState.currentSubscriptions));
                    var _j = (0, $i9Ee7.produceWithPatches)(previousSubscriptions, function() {
                        return newSubscriptions;
                    }), patches = _j[1];
                    mwApi.next(api.internalActions.subscriptionsUpdated(patches));
                    previousSubscriptions = newSubscriptions;
                    dispatchQueued = false;
                });
                dispatchQueued = true;
            }
            var isSubscriptionSliceAction = !!((_b = action.type) == null ? void 0 : _b.startsWith(subscriptionsPrefix));
            var isAdditionalSubscriptionAction = queryThunk.rejected.match(action) && action.meta.condition && !!action.meta.arg.subscribe;
            var actionShouldContinue = !isSubscriptionSliceAction && !isAdditionalSubscriptionAction;
            return [
                actionShouldContinue,
                false
            ];
        }
        return [
            true,
            false
        ];
    };
};
// src/query/core/buildMiddleware/index.ts
function $e80dfc866a603375$var$buildMiddleware(input) {
    var reducerPath = input.reducerPath, queryThunk = input.queryThunk, api = input.api, context = input.context;
    var apiUid = context.apiUid;
    var actions = {
        invalidateTags: (0, $a3ccb5670e466352$export$309c7a02b0b0bc62)(reducerPath + "/invalidateTags")
    };
    var isThisApiSliceAction = function(action) {
        return !!action && typeof action.type === "string" && action.type.startsWith(reducerPath + "/");
    };
    var handlerBuilders = [
        $e80dfc866a603375$var$buildDevCheckHandler,
        $e80dfc866a603375$var$buildCacheCollectionHandler,
        $e80dfc866a603375$var$buildInvalidationByTagsHandler,
        $e80dfc866a603375$var$buildPollingHandler,
        $e80dfc866a603375$var$buildCacheLifecycleHandler,
        $e80dfc866a603375$var$buildQueryLifecycleHandler
    ];
    var middleware = function(mwApi) {
        var initialized2 = false;
        var internalState = {
            currentSubscriptions: {}
        };
        var builderArgs = $e80dfc866a603375$var$__spreadProps($e80dfc866a603375$var$__spreadValues({}, input), {
            internalState: internalState,
            refetchQuery: refetchQuery
        });
        var handlers = handlerBuilders.map(function(build) {
            return build(builderArgs);
        });
        var batchedActionsHandler = $e80dfc866a603375$var$buildBatchedActionsHandler(builderArgs);
        var windowEventsHandler = $e80dfc866a603375$var$buildWindowEventHandler(builderArgs);
        return function(next) {
            return function(action) {
                if (!initialized2) {
                    initialized2 = true;
                    mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
                }
                var mwApiWithNext = $e80dfc866a603375$var$__spreadProps($e80dfc866a603375$var$__spreadValues({}, mwApi), {
                    next: next
                });
                var stateBefore = mwApi.getState();
                var _j = batchedActionsHandler(action, mwApiWithNext, stateBefore), actionShouldContinue = _j[0], hasSubscription = _j[1];
                var res;
                if (actionShouldContinue) res = next(action);
                else res = hasSubscription;
                if (!!mwApi.getState()[reducerPath]) {
                    windowEventsHandler(action, mwApiWithNext, stateBefore);
                    if (isThisApiSliceAction(action) || context.hasRehydrationInfo(action)) for(var _k = 0, handlers_1 = handlers; _k < handlers_1.length; _k++){
                        var handler = handlers_1[_k];
                        handler(action, mwApiWithNext, stateBefore);
                    }
                }
                return res;
            };
        };
    };
    return {
        middleware: middleware,
        actions: actions
    };
    function refetchQuery(querySubState, queryCacheKey, override) {
        if (override === void 0) override = {};
        return queryThunk($e80dfc866a603375$var$__spreadValues({
            type: "query",
            endpointName: querySubState.endpointName,
            originalArgs: querySubState.originalArgs,
            subscribe: false,
            forceRefetch: true,
            queryCacheKey: queryCacheKey
        }, override));
    }
}
// src/query/tsHelpers.ts
function $e80dfc866a603375$var$assertCast(v) {}
function $e80dfc866a603375$var$safeAssign(target) {
    var args = [];
    for(var _j = 1; _j < arguments.length; _j++)args[_j - 1] = arguments[_j];
    Object.assign.apply(Object, $e80dfc866a603375$var$__spreadArray([
        target
    ], args));
}
var $e80dfc866a603375$var$coreModuleName = /* @__PURE__ */ Symbol();
var $e80dfc866a603375$export$eb718ff92afd6f9b = function() {
    return {
        name: $e80dfc866a603375$var$coreModuleName,
        init: function(api, _j, context) {
            var baseQuery = _j.baseQuery, tagTypes = _j.tagTypes, reducerPath = _j.reducerPath, serializeQueryArgs = _j.serializeQueryArgs, keepUnusedDataFor = _j.keepUnusedDataFor, refetchOnMountOrArgChange = _j.refetchOnMountOrArgChange, refetchOnFocus = _j.refetchOnFocus, refetchOnReconnect = _j.refetchOnReconnect;
            (0, $i9Ee7.enablePatches)();
            $e80dfc866a603375$var$assertCast(serializeQueryArgs);
            var assertTagType = function(tag) {
                typeof $eh5Zb;
                return tag;
            };
            Object.assign(api, {
                reducerPath: reducerPath,
                endpoints: {},
                internalActions: {
                    onOnline: $e80dfc866a603375$var$onOnline,
                    onOffline: $e80dfc866a603375$var$onOffline,
                    onFocus: $e80dfc866a603375$var$onFocus,
                    onFocusLost: $e80dfc866a603375$var$onFocusLost
                },
                util: {}
            });
            var _k = $e80dfc866a603375$var$buildThunks({
                baseQuery: baseQuery,
                reducerPath: reducerPath,
                context: context,
                api: api,
                serializeQueryArgs: serializeQueryArgs
            }), queryThunk = _k.queryThunk, mutationThunk = _k.mutationThunk, patchQueryData = _k.patchQueryData, updateQueryData = _k.updateQueryData, upsertQueryData = _k.upsertQueryData, prefetch = _k.prefetch, buildMatchThunkActions = _k.buildMatchThunkActions;
            var _l = $e80dfc866a603375$var$buildSlice({
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                reducerPath: reducerPath,
                assertTagType: assertTagType,
                config: {
                    refetchOnFocus: refetchOnFocus,
                    refetchOnReconnect: refetchOnReconnect,
                    refetchOnMountOrArgChange: refetchOnMountOrArgChange,
                    keepUnusedDataFor: keepUnusedDataFor,
                    reducerPath: reducerPath
                }
            }), reducer = _l.reducer, sliceActions = _l.actions;
            $e80dfc866a603375$var$safeAssign(api.util, {
                patchQueryData: patchQueryData,
                updateQueryData: updateQueryData,
                upsertQueryData: upsertQueryData,
                prefetch: prefetch,
                resetApiState: sliceActions.resetApiState
            });
            $e80dfc866a603375$var$safeAssign(api.internalActions, sliceActions);
            var _m = $e80dfc866a603375$var$buildMiddleware({
                reducerPath: reducerPath,
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                api: api,
                assertTagType: assertTagType
            }), middleware = _m.middleware, middlewareActions = _m.actions;
            $e80dfc866a603375$var$safeAssign(api.util, middlewareActions);
            $e80dfc866a603375$var$safeAssign(api, {
                reducer: reducer,
                middleware: middleware
            });
            var _o = $e80dfc866a603375$var$buildSelectors({
                serializeQueryArgs: serializeQueryArgs,
                reducerPath: reducerPath
            }), buildQuerySelector = _o.buildQuerySelector, buildMutationSelector = _o.buildMutationSelector, selectInvalidatedBy = _o.selectInvalidatedBy;
            $e80dfc866a603375$var$safeAssign(api.util, {
                selectInvalidatedBy: selectInvalidatedBy
            });
            var _p = $e80dfc866a603375$var$buildInitiate({
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                context: context
            }), buildInitiateQuery = _p.buildInitiateQuery, buildInitiateMutation = _p.buildInitiateMutation, getRunningMutationThunk = _p.getRunningMutationThunk, getRunningMutationsThunk = _p.getRunningMutationsThunk, getRunningQueriesThunk = _p.getRunningQueriesThunk, getRunningQueryThunk = _p.getRunningQueryThunk, getRunningOperationPromises = _p.getRunningOperationPromises, removalWarning = _p.removalWarning;
            $e80dfc866a603375$var$safeAssign(api.util, {
                getRunningOperationPromises: getRunningOperationPromises,
                getRunningOperationPromise: removalWarning,
                getRunningMutationThunk: getRunningMutationThunk,
                getRunningMutationsThunk: getRunningMutationsThunk,
                getRunningQueryThunk: getRunningQueryThunk,
                getRunningQueriesThunk: getRunningQueriesThunk
            });
            return {
                name: $e80dfc866a603375$var$coreModuleName,
                injectEndpoint: function(endpointName, definition) {
                    var _a, _b;
                    var anyApi = api;
                    (_b = (_a = anyApi.endpoints)[endpointName]) != null ? _b : _a[endpointName] = {};
                    if ($e80dfc866a603375$var$isQueryDefinition(definition)) $e80dfc866a603375$var$safeAssign(anyApi.endpoints[endpointName], {
                        name: endpointName,
                        select: buildQuerySelector(endpointName, definition),
                        initiate: buildInitiateQuery(endpointName, definition)
                    }, buildMatchThunkActions(queryThunk, endpointName));
                    else if ($e80dfc866a603375$var$isMutationDefinition(definition)) $e80dfc866a603375$var$safeAssign(anyApi.endpoints[endpointName], {
                        name: endpointName,
                        select: buildMutationSelector(),
                        initiate: buildInitiateMutation(endpointName)
                    }, buildMatchThunkActions(mutationThunk, endpointName));
                }
            };
        }
    };
};
// src/query/core/index.ts
var $e80dfc866a603375$export$9cdc2b9a8d94c842 = /* @__PURE__ */ $e80dfc866a603375$export$f957748792d43646($e80dfc866a603375$export$eb718ff92afd6f9b());




var $4DE7A = parcelRequire("4DE7A");

var $gv34t = parcelRequire("gv34t");

var $eh5Zb = parcelRequire("eh5Zb");
var $3946ce0da0f4955f$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $3946ce0da0f4955f$var$__defProp = Object.defineProperty;
var $3946ce0da0f4955f$var$__defProps = Object.defineProperties;
var $3946ce0da0f4955f$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $3946ce0da0f4955f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3946ce0da0f4955f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3946ce0da0f4955f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3946ce0da0f4955f$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $3946ce0da0f4955f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $3946ce0da0f4955f$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($3946ce0da0f4955f$var$__hasOwnProp.call(b, prop)) $3946ce0da0f4955f$var$__defNormalProp(a, prop, b[prop]);
    if ($3946ce0da0f4955f$var$__getOwnPropSymbols) for(var _i = 0, _c = $3946ce0da0f4955f$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($3946ce0da0f4955f$var$__propIsEnum.call(b, prop)) $3946ce0da0f4955f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3946ce0da0f4955f$var$__spreadProps = function(a, b) {
    return $3946ce0da0f4955f$var$__defProps(a, $3946ce0da0f4955f$var$__getOwnPropDescs(b));
};
function $3946ce0da0f4955f$var$useStableQueryArgs(queryArgs, serialize, endpointDefinition, endpointName) {
    var incoming = (0, $4DE7A.useMemo)(function() {
        return {
            queryArgs: queryArgs,
            serialized: typeof queryArgs == "object" ? serialize({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) : queryArgs
        };
    }, [
        queryArgs,
        serialize,
        endpointDefinition,
        endpointName
    ]);
    var cache2 = (0, $4DE7A.useRef)(incoming);
    (0, $4DE7A.useEffect)(function() {
        if (cache2.current.serialized !== incoming.serialized) cache2.current = incoming;
    }, [
        incoming
    ]);
    return cache2.current.serialized === incoming.serialized ? cache2.current.queryArgs : queryArgs;
}
// src/query/react/constants.ts
var $3946ce0da0f4955f$var$UNINITIALIZED_VALUE = Symbol();
function $3946ce0da0f4955f$var$useShallowStableValue(value) {
    var cache2 = (0, $4DE7A.useRef)(value);
    (0, $4DE7A.useEffect)(function() {
        if (!(0, $e29db01be96e9a68$export$2e2bcd8739ae039)(cache2.current, value)) cache2.current = value;
    }, [
        value
    ]);
    return (0, $e29db01be96e9a68$export$2e2bcd8739ae039)(cache2.current, value) ? cache2.current : value;
}
var $3946ce0da0f4955f$var$cache = WeakMap ? new WeakMap() : void 0;
var $3946ce0da0f4955f$var$defaultSerializeQueryArgs = function(_c) {
    var endpointName = _c.endpointName, queryArgs = _c.queryArgs;
    var serialized = "";
    var cached = $3946ce0da0f4955f$var$cache == null ? void 0 : $3946ce0da0f4955f$var$cache.get(queryArgs);
    if (typeof cached === "string") serialized = cached;
    else {
        var stringified = JSON.stringify(queryArgs, function(key, value) {
            return (0, $a3ccb5670e466352$export$53b83ca8eaab0383)(value) ? Object.keys(value).sort().reduce(function(acc, key2) {
                acc[key2] = value[key2];
                return acc;
            }, {}) : value;
        });
        if ((0, $a3ccb5670e466352$export$53b83ca8eaab0383)(queryArgs)) $3946ce0da0f4955f$var$cache == null || $3946ce0da0f4955f$var$cache.set(queryArgs, stringified);
        serialized = stringified;
    }
    return endpointName + "(" + serialized + ")";
};
// src/query/react/buildHooks.ts
var $3946ce0da0f4955f$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && !!window.document && !!window.document.createElement ? (0, $4DE7A.useLayoutEffect) : (0, $4DE7A.useEffect);
var $3946ce0da0f4955f$var$defaultMutationStateSelector = function(x) {
    return x;
};
var $3946ce0da0f4955f$var$noPendingQueryStateSelector = function(selected) {
    if (selected.isUninitialized) return $3946ce0da0f4955f$var$__spreadProps($3946ce0da0f4955f$var$__spreadValues({}, selected), {
        isUninitialized: false,
        isFetching: true,
        isLoading: selected.data !== void 0 ? false : true,
        status: (0, $e80dfc866a603375$export$f4258b89f6bad1d6).pending
    });
    return selected;
};
function $3946ce0da0f4955f$var$buildHooks(_c) {
    var api = _c.api, _d = _c.moduleOptions, batch = _d.batch, useDispatch = _d.useDispatch, useSelector = _d.useSelector, useStore = _d.useStore, unstable__sideEffectsInRender = _d.unstable__sideEffectsInRender, serializeQueryArgs = _c.serializeQueryArgs, context = _c.context;
    var usePossiblyImmediateEffect = unstable__sideEffectsInRender ? function(cb) {
        return cb();
    } : (0, $4DE7A.useEffect);
    return {
        buildQueryHooks: buildQueryHooks,
        buildMutationHook: buildMutationHook,
        usePrefetch: usePrefetch
    };
    function queryStatePreSelector(currentState, lastResult, queryArgs) {
        if ((lastResult == null ? void 0 : lastResult.endpointName) && currentState.isUninitialized) {
            var endpointName = lastResult.endpointName;
            var endpointDefinition = context.endpointDefinitions[endpointName];
            if (serializeQueryArgs({
                queryArgs: lastResult.originalArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) === serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            })) lastResult = void 0;
        }
        var data = currentState.isSuccess ? currentState.data : lastResult == null ? void 0 : lastResult.data;
        if (data === void 0) data = currentState.data;
        var hasData = data !== void 0;
        var isFetching = currentState.isLoading;
        var isLoading = !hasData && isFetching;
        var isSuccess = currentState.isSuccess || isFetching && hasData;
        return $3946ce0da0f4955f$var$__spreadProps($3946ce0da0f4955f$var$__spreadValues({}, currentState), {
            data: data,
            currentData: currentState.data,
            isFetching: isFetching,
            isLoading: isLoading,
            isSuccess: isSuccess
        });
    }
    function usePrefetch(endpointName, defaultOptions) {
        var dispatch = useDispatch();
        var stableDefaultOptions = $3946ce0da0f4955f$var$useShallowStableValue(defaultOptions);
        return (0, $4DE7A.useCallback)(function(arg, options) {
            return dispatch(api.util.prefetch(endpointName, arg, $3946ce0da0f4955f$var$__spreadValues($3946ce0da0f4955f$var$__spreadValues({}, stableDefaultOptions), options)));
        }, [
            endpointName,
            dispatch,
            stableDefaultOptions
        ]);
    }
    function buildQueryHooks(name) {
        var useQuerySubscription = function(arg, _c) {
            var _d = _c === void 0 ? {} : _c, refetchOnReconnect = _d.refetchOnReconnect, refetchOnFocus = _d.refetchOnFocus, refetchOnMountOrArgChange = _d.refetchOnMountOrArgChange, _e = _d.skip, skip = _e === void 0 ? false : _e, _f = _d.pollingInterval, pollingInterval = _f === void 0 ? 0 : _f;
            var initiate = api.endpoints[name].initiate;
            var dispatch = useDispatch();
            var stableArg = $3946ce0da0f4955f$var$useStableQueryArgs(skip ? (0, $e80dfc866a603375$export$1aa5a89531b7670d) : arg, $3946ce0da0f4955f$var$defaultSerializeQueryArgs, context.endpointDefinitions[name], name);
            var stableSubscriptionOptions = $3946ce0da0f4955f$var$useShallowStableValue({
                refetchOnReconnect: refetchOnReconnect,
                refetchOnFocus: refetchOnFocus,
                pollingInterval: pollingInterval
            });
            var lastRenderHadSubscription = (0, $4DE7A.useRef)(false);
            var promiseRef = (0, $4DE7A.useRef)();
            var _g = promiseRef.current || {}, queryCacheKey = _g.queryCacheKey, requestId = _g.requestId;
            var currentRenderHasSubscription = false;
            if (queryCacheKey && requestId) {
                var returnedValue = dispatch(api.internalActions.internal_probeSubscription({
                    queryCacheKey: queryCacheKey,
                    requestId: requestId
                }));
                currentRenderHasSubscription = !!returnedValue;
            }
            var subscriptionRemoved = !currentRenderHasSubscription && lastRenderHadSubscription.current;
            usePossiblyImmediateEffect(function() {
                lastRenderHadSubscription.current = currentRenderHasSubscription;
            });
            usePossiblyImmediateEffect(function() {
                if (subscriptionRemoved) promiseRef.current = void 0;
            }, [
                subscriptionRemoved
            ]);
            usePossiblyImmediateEffect(function() {
                var _a;
                var lastPromise = promiseRef.current;
                typeof $eh5Zb;
                if (stableArg === (0, $e80dfc866a603375$export$1aa5a89531b7670d)) {
                    lastPromise == null || lastPromise.unsubscribe();
                    promiseRef.current = void 0;
                    return;
                }
                var lastSubscriptionOptions = (_a = promiseRef.current) == null ? void 0 : _a.subscriptionOptions;
                if (!lastPromise || lastPromise.arg !== stableArg) {
                    lastPromise == null || lastPromise.unsubscribe();
                    var promise = dispatch(initiate(stableArg, {
                        subscriptionOptions: stableSubscriptionOptions,
                        forceRefetch: refetchOnMountOrArgChange
                    }));
                    promiseRef.current = promise;
                } else if (stableSubscriptionOptions !== lastSubscriptionOptions) lastPromise.updateSubscriptionOptions(stableSubscriptionOptions);
            }, [
                dispatch,
                initiate,
                refetchOnMountOrArgChange,
                stableArg,
                stableSubscriptionOptions,
                subscriptionRemoved
            ]);
            (0, $4DE7A.useEffect)(function() {
                return function() {
                    var _a;
                    (_a = promiseRef.current) == null || _a.unsubscribe();
                    promiseRef.current = void 0;
                };
            }, []);
            return (0, $4DE7A.useMemo)(function() {
                return {
                    refetch: function() {
                        var _a;
                        if (!promiseRef.current) throw new Error("Cannot refetch a query that has not been started yet.");
                        return (_a = promiseRef.current) == null ? void 0 : _a.refetch();
                    }
                };
            }, []);
        };
        var useLazyQuerySubscription = function(_c) {
            var _d = _c === void 0 ? {} : _c, refetchOnReconnect = _d.refetchOnReconnect, refetchOnFocus = _d.refetchOnFocus, _e = _d.pollingInterval, pollingInterval = _e === void 0 ? 0 : _e;
            var initiate = api.endpoints[name].initiate;
            var dispatch = useDispatch();
            var _f = (0, $4DE7A.useState)($3946ce0da0f4955f$var$UNINITIALIZED_VALUE), arg = _f[0], setArg = _f[1];
            var promiseRef = (0, $4DE7A.useRef)();
            var stableSubscriptionOptions = $3946ce0da0f4955f$var$useShallowStableValue({
                refetchOnReconnect: refetchOnReconnect,
                refetchOnFocus: refetchOnFocus,
                pollingInterval: pollingInterval
            });
            usePossiblyImmediateEffect(function() {
                var _a, _b;
                var lastSubscriptionOptions = (_a = promiseRef.current) == null ? void 0 : _a.subscriptionOptions;
                if (stableSubscriptionOptions !== lastSubscriptionOptions) (_b = promiseRef.current) == null || _b.updateSubscriptionOptions(stableSubscriptionOptions);
            }, [
                stableSubscriptionOptions
            ]);
            var subscriptionOptionsRef = (0, $4DE7A.useRef)(stableSubscriptionOptions);
            usePossiblyImmediateEffect(function() {
                subscriptionOptionsRef.current = stableSubscriptionOptions;
            }, [
                stableSubscriptionOptions
            ]);
            var trigger = (0, $4DE7A.useCallback)(function(arg2, preferCacheValue) {
                if (preferCacheValue === void 0) preferCacheValue = false;
                var promise;
                batch(function() {
                    var _a;
                    (_a = promiseRef.current) == null || _a.unsubscribe();
                    promiseRef.current = promise = dispatch(initiate(arg2, {
                        subscriptionOptions: subscriptionOptionsRef.current,
                        forceRefetch: !preferCacheValue
                    }));
                    setArg(arg2);
                });
                return promise;
            }, [
                dispatch,
                initiate
            ]);
            (0, $4DE7A.useEffect)(function() {
                return function() {
                    var _a;
                    (_a = promiseRef == null ? void 0 : promiseRef.current) == null || _a.unsubscribe();
                };
            }, []);
            (0, $4DE7A.useEffect)(function() {
                if (arg !== $3946ce0da0f4955f$var$UNINITIALIZED_VALUE && !promiseRef.current) trigger(arg, true);
            }, [
                arg,
                trigger
            ]);
            return (0, $4DE7A.useMemo)(function() {
                return [
                    trigger,
                    arg
                ];
            }, [
                trigger,
                arg
            ]);
        };
        var useQueryState = function(arg, _c) {
            var _d = _c === void 0 ? {} : _c, _e = _d.skip, skip = _e === void 0 ? false : _e, selectFromResult = _d.selectFromResult;
            var select = api.endpoints[name].select;
            var stableArg = $3946ce0da0f4955f$var$useStableQueryArgs(skip ? (0, $e80dfc866a603375$export$1aa5a89531b7670d) : arg, serializeQueryArgs, context.endpointDefinitions[name], name);
            var lastValue = (0, $4DE7A.useRef)();
            var selectDefaultResult = (0, $4DE7A.useMemo)(function() {
                return (0, $bb5ac58d2597f8dc$export$595d22ed68ca2841)([
                    select(stableArg),
                    function(_, lastResult) {
                        return lastResult;
                    },
                    function(_) {
                        return stableArg;
                    }
                ], queryStatePreSelector);
            }, [
                select,
                stableArg
            ]);
            var querySelector = (0, $4DE7A.useMemo)(function() {
                return selectFromResult ? (0, $bb5ac58d2597f8dc$export$595d22ed68ca2841)([
                    selectDefaultResult
                ], selectFromResult) : selectDefaultResult;
            }, [
                selectDefaultResult,
                selectFromResult
            ]);
            var currentState = useSelector(function(state) {
                return querySelector(state, lastValue.current);
            }, (0, $e29db01be96e9a68$export$2e2bcd8739ae039));
            var store = useStore();
            var newLastValue = selectDefaultResult(store.getState(), lastValue.current);
            $3946ce0da0f4955f$var$useIsomorphicLayoutEffect(function() {
                lastValue.current = newLastValue;
            }, [
                newLastValue
            ]);
            return currentState;
        };
        return {
            useQueryState: useQueryState,
            useQuerySubscription: useQuerySubscription,
            useLazyQuerySubscription: useLazyQuerySubscription,
            useLazyQuery: function(options) {
                var _c = useLazyQuerySubscription(options), trigger = _c[0], arg = _c[1];
                var queryStateResults = useQueryState(arg, $3946ce0da0f4955f$var$__spreadProps($3946ce0da0f4955f$var$__spreadValues({}, options), {
                    skip: arg === $3946ce0da0f4955f$var$UNINITIALIZED_VALUE
                }));
                var info = (0, $4DE7A.useMemo)(function() {
                    return {
                        lastArg: arg
                    };
                }, [
                    arg
                ]);
                return (0, $4DE7A.useMemo)(function() {
                    return [
                        trigger,
                        queryStateResults,
                        info
                    ];
                }, [
                    trigger,
                    queryStateResults,
                    info
                ]);
            },
            useQuery: function(arg, options) {
                var querySubscriptionResults = useQuerySubscription(arg, options);
                var queryStateResults = useQueryState(arg, $3946ce0da0f4955f$var$__spreadValues({
                    selectFromResult: arg === (0, $e80dfc866a603375$export$1aa5a89531b7670d) || (options == null ? void 0 : options.skip) ? void 0 : $3946ce0da0f4955f$var$noPendingQueryStateSelector
                }, options));
                var data = queryStateResults.data, status = queryStateResults.status, isLoading = queryStateResults.isLoading, isSuccess = queryStateResults.isSuccess, isError = queryStateResults.isError, error = queryStateResults.error;
                (0, $4DE7A.useDebugValue)({
                    data: data,
                    status: status,
                    isLoading: isLoading,
                    isSuccess: isSuccess,
                    isError: isError,
                    error: error
                });
                return (0, $4DE7A.useMemo)(function() {
                    return $3946ce0da0f4955f$var$__spreadValues($3946ce0da0f4955f$var$__spreadValues({}, queryStateResults), querySubscriptionResults);
                }, [
                    queryStateResults,
                    querySubscriptionResults
                ]);
            }
        };
    }
    function buildMutationHook(name) {
        return function(_c) {
            var _d = _c === void 0 ? {} : _c, _e = _d.selectFromResult, selectFromResult = _e === void 0 ? $3946ce0da0f4955f$var$defaultMutationStateSelector : _e, fixedCacheKey = _d.fixedCacheKey;
            var _f = api.endpoints[name], select = _f.select, initiate = _f.initiate;
            var dispatch = useDispatch();
            var _g = (0, $4DE7A.useState)(), promise = _g[0], setPromise = _g[1];
            (0, $4DE7A.useEffect)(function() {
                return function() {
                    if (!(promise == null ? void 0 : promise.arg.fixedCacheKey)) promise == null || promise.reset();
                };
            }, [
                promise
            ]);
            var triggerMutation = (0, $4DE7A.useCallback)(function(arg) {
                var promise2 = dispatch(initiate(arg, {
                    fixedCacheKey: fixedCacheKey
                }));
                setPromise(promise2);
                return promise2;
            }, [
                dispatch,
                initiate,
                fixedCacheKey
            ]);
            var requestId = (promise || {}).requestId;
            var mutationSelector = (0, $4DE7A.useMemo)(function() {
                return (0, $bb5ac58d2597f8dc$export$595d22ed68ca2841)([
                    select({
                        fixedCacheKey: fixedCacheKey,
                        requestId: promise == null ? void 0 : promise.requestId
                    })
                ], selectFromResult);
            }, [
                select,
                promise,
                selectFromResult,
                fixedCacheKey
            ]);
            var currentState = useSelector(mutationSelector, (0, $e29db01be96e9a68$export$2e2bcd8739ae039));
            var originalArgs = fixedCacheKey == null ? promise == null ? void 0 : promise.arg.originalArgs : void 0;
            var reset = (0, $4DE7A.useCallback)(function() {
                batch(function() {
                    if (promise) setPromise(void 0);
                    if (fixedCacheKey) dispatch(api.internalActions.removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                });
            }, [
                dispatch,
                fixedCacheKey,
                promise,
                requestId
            ]);
            var endpointName = currentState.endpointName, data = currentState.data, status = currentState.status, isLoading = currentState.isLoading, isSuccess = currentState.isSuccess, isError = currentState.isError, error = currentState.error;
            (0, $4DE7A.useDebugValue)({
                endpointName: endpointName,
                data: data,
                status: status,
                isLoading: isLoading,
                isSuccess: isSuccess,
                isError: isError,
                error: error
            });
            var finalState = (0, $4DE7A.useMemo)(function() {
                return $3946ce0da0f4955f$var$__spreadProps($3946ce0da0f4955f$var$__spreadValues({}, currentState), {
                    originalArgs: originalArgs,
                    reset: reset
                });
            }, [
                currentState,
                originalArgs,
                reset
            ]);
            return (0, $4DE7A.useMemo)(function() {
                return [
                    triggerMutation,
                    finalState
                ];
            }, [
                triggerMutation,
                finalState
            ]);
        };
    }
}
// src/query/endpointDefinitions.ts
var $3946ce0da0f4955f$var$DefinitionType;
(function(DefinitionType2) {
    DefinitionType2["query"] = "query";
    DefinitionType2["mutation"] = "mutation";
})($3946ce0da0f4955f$var$DefinitionType || ($3946ce0da0f4955f$var$DefinitionType = {}));
function $3946ce0da0f4955f$var$isQueryDefinition(e) {
    return e.type === $3946ce0da0f4955f$var$DefinitionType.query;
}
function $3946ce0da0f4955f$var$isMutationDefinition(e) {
    return e.type === $3946ce0da0f4955f$var$DefinitionType.mutation;
}
// src/query/utils/capitalize.ts
function $3946ce0da0f4955f$var$capitalize(str) {
    return str.replace(str[0], str[0].toUpperCase());
}
// src/query/tsHelpers.ts
function $3946ce0da0f4955f$var$safeAssign(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    Object.assign.apply(Object, $3946ce0da0f4955f$var$__spreadArray([
        target
    ], args));
}
var $3946ce0da0f4955f$var$reactHooksModuleName = /* @__PURE__ */ Symbol();
var $3946ce0da0f4955f$export$8b98f9e72008ec90 = function(_c) {
    var _d = _c === void 0 ? {} : _c, _e = _d.batch, batch = _e === void 0 ? (0, $gv34t.unstable_batchedUpdates) : _e, _f = _d.useDispatch, useDispatch = _f === void 0 ? (0, $80615d9151c4c54f$export$8ad76b76a4c905f8) : _f, _g = _d.useSelector, useSelector = _g === void 0 ? (0, $5be681cecefb99e4$export$2105062e25df4afe) : _g, _h = _d.useStore, useStore = _h === void 0 ? (0, $2b9527c9819079a2$export$6ccbb43953eebf8) : _h, _j = _d.unstable__sideEffectsInRender, unstable__sideEffectsInRender = _j === void 0 ? false : _j;
    return {
        name: $3946ce0da0f4955f$var$reactHooksModuleName,
        init: function(api, _c, context) {
            var serializeQueryArgs = _c.serializeQueryArgs;
            var anyApi = api;
            var _d = $3946ce0da0f4955f$var$buildHooks({
                api: api,
                moduleOptions: {
                    batch: batch,
                    useDispatch: useDispatch,
                    useSelector: useSelector,
                    useStore: useStore,
                    unstable__sideEffectsInRender: unstable__sideEffectsInRender
                },
                serializeQueryArgs: serializeQueryArgs,
                context: context
            }), buildQueryHooks = _d.buildQueryHooks, buildMutationHook = _d.buildMutationHook, usePrefetch = _d.usePrefetch;
            $3946ce0da0f4955f$var$safeAssign(anyApi, {
                usePrefetch: usePrefetch
            });
            $3946ce0da0f4955f$var$safeAssign(context, {
                batch: batch
            });
            return {
                injectEndpoint: function(endpointName, definition) {
                    if ($3946ce0da0f4955f$var$isQueryDefinition(definition)) {
                        var _c = buildQueryHooks(endpointName), useQuery = _c.useQuery, useLazyQuery = _c.useLazyQuery, useLazyQuerySubscription = _c.useLazyQuerySubscription, useQueryState = _c.useQueryState, useQuerySubscription = _c.useQuerySubscription;
                        $3946ce0da0f4955f$var$safeAssign(anyApi.endpoints[endpointName], {
                            useQuery: useQuery,
                            useLazyQuery: useLazyQuery,
                            useLazyQuerySubscription: useLazyQuerySubscription,
                            useQueryState: useQueryState,
                            useQuerySubscription: useQuerySubscription
                        });
                        api["use" + $3946ce0da0f4955f$var$capitalize(endpointName) + "Query"] = useQuery;
                        api["useLazy" + $3946ce0da0f4955f$var$capitalize(endpointName) + "Query"] = useLazyQuery;
                    } else if ($3946ce0da0f4955f$var$isMutationDefinition(definition)) {
                        var useMutation = buildMutationHook(endpointName);
                        $3946ce0da0f4955f$var$safeAssign(anyApi.endpoints[endpointName], {
                            useMutation: useMutation
                        });
                        api["use" + $3946ce0da0f4955f$var$capitalize(endpointName) + "Mutation"] = useMutation;
                    }
                }
            };
        }
    };
};
function $3946ce0da0f4955f$export$f4e57f6132f56752(props) {
    var store = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useState(function() {
        var _c;
        return (0, $a3ccb5670e466352$export$7d8a5b498da695ac)({
            reducer: (_c = {}, _c[props.api.reducerPath] = props.api.reducer, _c),
            middleware: function(gDM) {
                return gDM().concat(props.api.middleware);
            }
        });
    })[0];
    (0, $4DE7A.useEffect)(function() {
        return props.setupListeners === false ? void 0 : (0, $e80dfc866a603375$export$120c0dbb0351414c)(store.dispatch, props.setupListeners);
    }, [
        props.setupListeners,
        store.dispatch
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, $4dd147938665f4da$export$2e2bcd8739ae039), {
        store: store,
        context: props.context
    }, props.children);
}
// src/query/react/index.ts
var $3946ce0da0f4955f$export$9cdc2b9a8d94c842 = /* @__PURE__ */ (0, $e80dfc866a603375$export$f957748792d43646)((0, $e80dfc866a603375$export$eb718ff92afd6f9b)(), $3946ce0da0f4955f$export$8b98f9e72008ec90());



const $e2f405c0a03fcace$export$fa2ce3b580907083 = (0, $3946ce0da0f4955f$export$9cdc2b9a8d94c842)({
    reducerPath: "streetmixApi",
    baseQuery: (0, $e80dfc866a603375$export$adcf4c6133c49b4e)({
        // Only uses the API endpoints, not the service endpoints for now.
        baseUrl: "/api/v1/"
    }),
    endpoints: (builder)=>({
            getUser: builder.query({
                queryFn: (userId, _api, _extraOptions, baseQuery)=>{
                    if (userId === null) return {
                        data: null
                    };
                    else return baseQuery(`users/${userId}`);
                }
            })
        })
});
const { useGetUserQuery: $e2f405c0a03fcace$export$9beb97f355b95ab9 } = $e2f405c0a03fcace$export$fa2ce3b580907083;


const $81878321270eabd6$var$store = (0, $a3ccb5670e466352$export$7d8a5b498da695ac)({
    reducer: {
        ...(0, $ef401f325b6f76ea$export$2e2bcd8739ae039),
        [(0, $e2f405c0a03fcace$export$fa2ce3b580907083).reducerPath]: (0, $e2f405c0a03fcace$export$fa2ce3b580907083).reducer
    },
    // Disable these checks in development mode, as they can be performance-
    // heavy and create a lot warning spam in console. See this issue for info:
    // https://github.com/reduxjs/redux-toolkit/issues/415
    // Yes, this means the checks don't run at all. They can be helpful when
    // writing new reducers, or refactoring them, so it's fine to temporarily
    // re-enable them when you need them. Otherwise, leave it false so that
    // the development experience isn't unnecessarily crippled.
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false
        }).concat((0, $e2f405c0a03fcace$export$fa2ce3b580907083).middleware)
});
var $81878321270eabd6$export$2e2bcd8739ae039 = $81878321270eabd6$var$store;
function $81878321270eabd6$export$7eabfc5ef2a68f64(select, onChange) {
    let currentState;
    function handleChange() {
        const nextState = select($81878321270eabd6$var$store.getState());
        if (nextState !== currentState) {
            currentState = nextState;
            onChange(currentState);
        }
    }
    const unsubscribe = $81878321270eabd6$var$store.subscribe(handleChange);
    // handleChange()
    return unsubscribe;
}


/**
 * system_capabilities
 *
 * Detect capabilities and features of the current system (device,
 * browser, connection, etc).
 *
 */ /**
 * Environment variables are passed in as strings. This means falsy values are
 * implicitly converted to strings, which become truthy as a result.
 *
 * This function parses incoming variables and converts them to boolean.
 */ function $63b5c9d178f1431e$var$parseBoolean(value) {
    switch(value){
        case "true":
            return true;
        default:
            return false;
    }
}
const $63b5c9d178f1431e$export$83401e34d5e11bf4 = "production";
const $63b5c9d178f1431e$export$f38a48430246a886 = undefined;
const $63b5c9d178f1431e$export$8732fc1e436c2534 = undefined;
const $63b5c9d178f1431e$export$f04aeb1fc450ccb6 = undefined;
const $63b5c9d178f1431e$export$952b01be3de2f5b2 = $63b5c9d178f1431e$var$parseBoolean(undefined);
const $63b5c9d178f1431e$export$620b2e0c341943a2 = undefined;
const $63b5c9d178f1431e$export$669561b7c46fd3f7 = undefined;
const $63b5c9d178f1431e$export$458778b94eb61719 = "";
const $63b5c9d178f1431e$export$6ed6116aaa4a07d6 = "";




/**
 * debug_settings
 *
 * Change the state of the application based on overrides
 * provided in the URL string. This is executed immediately
 * during the preinit stage, so it should depend on no
 * data, nor does it have access to any application state.
 * Later scripts may use these settings.
 *
 */ 

const $6fccecb363574db8$export$1c9f709888824e05 = {
    forceLeftHandTraffic: false,
    forceNonRetina: false,
    forceOfflineMode: false,
    forceReadOnly: false
};
const $6fccecb363574db8$var$params = new URLSearchParams(window.location.search);
// Historically, params were valueless and they we had our own string
// parsing code, but now we use the `URLSearchParams` global interface.
// For backwards compatibility, only the presence of a key indicates
// truthiness. Recent usage will upgrade truthy values to `1`. However,
// the value doesn't mean anything for these keys, for now.
if ($6fccecb363574db8$var$params.has("debug-force-left-hand-traffic")) $6fccecb363574db8$export$1c9f709888824e05.forceLeftHandTraffic = true;
if ($6fccecb363574db8$var$params.has("debug-force-non-retina")) $6fccecb363574db8$export$1c9f709888824e05.forceNonRetina = true;
if ($6fccecb363574db8$var$params.has("debug-force-offline")) $6fccecb363574db8$export$1c9f709888824e05.forceOfflineMode = true;
if ($6fccecb363574db8$var$params.has("debug-force-read-only")) $6fccecb363574db8$export$1c9f709888824e05.forceReadOnly = true;
(0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $5bcb824489dec0b9$export$8a1358e3ea016db0)({
    ...$6fccecb363574db8$export$1c9f709888824e05
}));


function $c28638c59a37cdde$export$8f5274ca1f2bd1c0() {
    const system = {};
    if ((0, $6fccecb363574db8$export$1c9f709888824e05).forceOfflineMode || (0, $63b5c9d178f1431e$export$952b01be3de2f5b2) === true) system.offline = true;
    if ((0, $6fccecb363574db8$export$1c9f709888824e05).forceNonRetina) system.devicePixelRatio = 1.0;
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $c8f034bd96be731d$export$5270136fc5522349)(system));
}




const $036006ab2c0b720b$export$46884518790eaa90 = {
    initial: 0,
    role: 1,
    user: 2,
    session: 3
};
function $036006ab2c0b720b$export$74f321e99710cbf6() {
    $036006ab2c0b720b$var$initLocalStorageUpdateListener();
    $036006ab2c0b720b$var$initRedrawPaletteUpdateListener();
}
function $036006ab2c0b720b$var$whatAreTheFlagsWeNeedToSave(flags) {
    return Object.entries(flags)// filter out all non-user set flags
    .filter(([key, flag])=>flag.source === "session")// filter out flags that equal default values
    .filter(([key, flag])=>flag.value !== flag.defaultValue)// convert back to obj but simplify it to just the value
    .reduce((obj, [key, flag])=>{
        obj[key] = flag.value;
        return obj;
    }, {});
}
function $036006ab2c0b720b$var$initLocalStorageUpdateListener() {
    const select = (state)=>state.flags;
    const onChange = (flags)=>{
        const toSet = $036006ab2c0b720b$var$whatAreTheFlagsWeNeedToSave(flags);
        window.localStorage.setItem("flags", JSON.stringify(toSet));
    };
    return (0, $81878321270eabd6$export$7eabfc5ef2a68f64)(select, onChange);
}
function $036006ab2c0b720b$var$initRedrawPaletteUpdateListener() {
    const select = (state)=>state.flags.SEGMENT_INCEPTION_TRAIN.value;
    const onChange = ()=>{
        window.dispatchEvent(new window.CustomEvent("stmx:force_palette_redraw"));
    };
    return (0, $81878321270eabd6$export$7eabfc5ef2a68f64)(select, onChange);
}
function $036006ab2c0b720b$export$b787f9ce4416a661(flags, source) {
    if (!flags) return;
    const flagsOverrides = {
        source: source,
        flags: []
    };
    return Object.entries(flags).reduce((obj, item)=>{
        const [key, value] = item;
        const flag = {
            flag: key,
            value: value
        };
        flagsOverrides.flags.push(flag);
        return obj;
    }, flagsOverrides);
}
function $036006ab2c0b720b$export$fa34ce778e8ebcc9(defaultFlags, ...overrides) {
    // Quickly clone the defaultFlags object by converting it to a string
    // and then back to an object. The source of this can come from state
    // and we need to avoid mutating it.
    const initialFlags = JSON.parse(JSON.stringify(defaultFlags));
    const newFlags = overrides.reduce((accumulatedFlags, currentFlags)=>{
        // Handle a situation where currentFlags could be `undefined`
        // TODO: fix this (it's basically a type error.)
        if (!currentFlags) return accumulatedFlags;
        const { source: source, flags: flags } = currentFlags;
        flags.forEach((item)=>{
            const { flag: flag, value: value } = item;
            const previousFlag = accumulatedFlags[flag];
            if (previousFlag) {
                const previousPriority = $036006ab2c0b720b$export$46884518790eaa90[previousFlag.source] || 0;
                const newPriority = $036006ab2c0b720b$export$46884518790eaa90[source.split(":")[0]] || 0;
                if (newPriority > previousPriority) {
                    previousFlag.value = value;
                    previousFlag.source = source;
                }
            }
        });
        return accumulatedFlags;
    }, initialFlags);
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $1ac426dbdd197303$export$777418efeb425152)(newFlags));
    return newFlags;
}


/*! js-cookie v3.0.5 | MIT */ /* eslint-disable no-var */ function $f1e510e7f49b22d8$var$assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)target[key] = source[key];
    }
    return target;
}
/* eslint-enable no-var */ /* eslint-disable no-var */ var $f1e510e7f49b22d8$var$defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
/* eslint-enable no-var */ /* eslint-disable no-var */ function $f1e510e7f49b22d8$var$init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === "undefined") return;
        attributes = $f1e510e7f49b22d8$var$assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = "";
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += "; " + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
        }
        return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === "undefined" || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split("; ") : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split("=");
            var value = parts.slice(1).join("=");
            try {
                var found = decodeURIComponent(parts[0]);
                jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (e) {}
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, "", $f1e510e7f49b22d8$var$assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return $f1e510e7f49b22d8$var$init(this.converter, $f1e510e7f49b22d8$var$assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return $f1e510e7f49b22d8$var$init($f1e510e7f49b22d8$var$assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var $f1e510e7f49b22d8$export$2e2bcd8739ae039 = $f1e510e7f49b22d8$var$init($f1e510e7f49b22d8$var$defaultConverter, {
    path: "/"
});


function $e1f926fe3025af48$var$e(e) {
    this.message = e;
}
$e1f926fe3025af48$var$e.prototype = new Error, $e1f926fe3025af48$var$e.prototype.name = "InvalidCharacterError";
var $e1f926fe3025af48$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $e1f926fe3025af48$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $e1f926fe3025af48$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($e1f926fe3025af48$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $e1f926fe3025af48$var$r(t);
    }
}
function $e1f926fe3025af48$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $e1f926fe3025af48$var$o(e, r) {
    if ("string" != typeof e) throw new $e1f926fe3025af48$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($e1f926fe3025af48$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $e1f926fe3025af48$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$e1f926fe3025af48$export$b9721ef022f71a68.prototype = new Error, $e1f926fe3025af48$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $e1f926fe3025af48$export$2e2bcd8739ae039 = $e1f926fe3025af48$var$o;





function $e67fd05cb5630e00$export$d9633e935e40fe0c() {
    // Run this if browser has the monetization plugin installed. Logged-in
    // users will automatically get subscription benefits regardless of any
    // connected monetization providers
    if (document.monetization) {
        document.monetization.addEventListener("monetizationstart", (event)=>{
            console.log("monetization start!", event.detail);
            (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ca8c478b1d098cf7$export$a57169b6b0b32e47)(true));
            const signedIn = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().user.signedIn;
            if (!signedIn) {
                (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ed796acc6691d871$export$2cb648f4e71e8121)({
                    component: "TOAST_WEB_MONETIZATION",
                    duration: Infinity
                }));
                window.localStorage.setItem("wm-sign-in-notification", "true");
            } else if (window.localStorage.getItem("wm-sign-in-notification") === "true") {
                (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ed796acc6691d871$export$2cb648f4e71e8121)({
                    component: "TOAST_WEB_MONETIZATION_SUCCESS",
                    duration: 10000
                }));
                window.localStorage.removeItem("wm-sign-in-notification");
            }
        });
        document.monetization.addEventListener("monetizationstop", (event)=>{
            console.log("monetization stop!", event.detail);
            (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ca8c478b1d098cf7$export$a57169b6b0b32e47)(false));
        });
        document.monetization.addEventListener("monetizationpending", (event)=>{
            console.log("monetization pending!", event.detail);
        });
    // document.monetization.addEventListener('monetizationprogress', (event) => {
    //   console.log('monetization progress!', event.detail)
    // })
    // Otherwise, create a placeholder monetization object. The Coil OAuth Web
    // Monetization (OWM) script relies on this.
    } else {
        document.monetization = document.createElement("div");
        document.monetization.state = "stopped";
    }
    const btpToken = (0, $f1e510e7f49b22d8$export$2e2bcd8739ae039).get("btpToken");
    if (btpToken) try {
        const jwt = (0, $e1f926fe3025af48$export$2e2bcd8739ae039)(btpToken);
        console.log(jwt);
        console.log("issued at " + new Date(jwt.iat * 1000));
        console.log("expires at " + new Date(jwt.exp * 1000));
        document.coilMonetizationPolyfill.init({
            btpToken: btpToken
        });
        // The btpToken lasts about 30 minutes, so every 30 minutes, refresh the token
        // Note: a btpToken is a JSON Web Token (JWT) and contains the `iat` (issued
        // at) from `exp` (expires at) values. We may be able to fine-tune the refresh
        // timer by subtracting `iat` from `exp` and setting timeouts instead of a
        // fixed interval. This might be considered for later optimization.
        window.setInterval(function() {
            document.coilMonetizationPolyfill.refreshBtpToken(btpToken);
        }, 1800000);
    } catch (err) {
        console.error("caught error doing token stuff", err);
    }
}


/**
 * load_resources
 *
 * Loads images, etc and tracks progress. (WIP)
 */ const $898fc845a8d311b5$export$6c746a5570b8b35c = new Map();
// Image tileset loading
const $898fc845a8d311b5$var$IMAGES_TO_BE_LOADED = [
    "/assets/icons.svg",
    "/assets/illustrations.svg",
    "/assets/images.svg",
    "/images/wordmark.svg",
    "/images/wordmark_black.svg",
    "/images/wordmark_white.svg",
    "/images/sky-front.svg",
    "/images/sky-rear.svg"
];
const $898fc845a8d311b5$var$SVGStagingEl = document.getElementById("svg");
const $898fc845a8d311b5$var$loading = [];
async function $898fc845a8d311b5$export$211b51324b5b532c() {
    for (const url of $898fc845a8d311b5$var$IMAGES_TO_BE_LOADED)$898fc845a8d311b5$var$loading.push($898fc845a8d311b5$var$loadImage(url));
    return Promise.all($898fc845a8d311b5$var$loading);
}
async function $898fc845a8d311b5$var$loadImage(url) {
    try {
        const response = await window.fetch(url);
        const body = await response.text();
        $898fc845a8d311b5$var$SVGStagingEl.innerHTML += body;
        // ctx.drawImage() can only draw things that are images, so you can't draw
        // an SVG directly. You also can't <use> a symbol reference from inside an
        // image tag. So we have to create an image using a reconstructed SVG as a
        // data-URI. Here, let's cache all the artwork svgs as image elements,
        // and include the original svg + width/height information, to assist with
        // later rendering to canvas
        // Get all the <symbol>s
        const symbolEls = $898fc845a8d311b5$var$SVGStagingEl.querySelectorAll("symbol");
        for (const svg of symbolEls){
            // Skip icons, we don't need to cache these
            if (svg.id.indexOf("icon-") === 0) continue;
            // Simplify id, removing namespace prefix
            const id = svg.id.replace(/^image-/, "");
            // Get a string representation of symbol so we can reconstruct an image element
            const svgHTML = $898fc845a8d311b5$var$convertSVGSymbolToSVGHTML(svg);
            $898fc845a8d311b5$var$cacheSVGObject(id, svg, svgHTML);
        }
        // Captures anything with its own viewbox, whether that's an svg file
        // or symbol elements within a svg.
        const svgEls = $898fc845a8d311b5$var$SVGStagingEl.querySelectorAll("svg[viewBox]");
        for (const svg of svgEls){
            // Right now none of these have ids, use the url
            const id = url;
            // Get a string representation of symbol so we can reconstruct an image element
            const svgHTML = $898fc845a8d311b5$var$getSVGOuterHTML(svg);
            $898fc845a8d311b5$var$cacheSVGObject(id, svg, svgHTML);
        }
        return body;
    } catch (error) {
        console.error("loading svg error", error);
    }
}
/**
 * Gets a string representation of an <svg>
 *
 * @param {SVGElement} svg
 * @return {string}
 */ function $898fc845a8d311b5$var$getSVGOuterHTML(svg) {
    // Height and width values are required to render to canvas in Firefox.
    //
    // Applications that export SVG may set width and height values that differ from viewBox
    // values. This can have unexpected results during canvas rendering in different browsers.
    //
    // Here's a real-world example:
    // If `width="100%"` and `height="100%"` and the `viewBox` is in pixels, Chrome will ignore
    // `viewBox` values and scale the rendered SVG images; Firefox won't render anything at all.
    //
    // As a result, we let the `viewBox` values be the single source of truth, and force
    // `width` and `height` attributes to match.
    if (svg.getAttribute("viewBox")) {
        svg.setAttribute("width", svg.viewBox.baseVal.width);
        svg.setAttribute("height", svg.viewBox.baseVal.height);
    }
    let outerHTML = svg.outerHTML;
    // The `outerHTML` property is not available on IE / Edge
    // so if it's not present, use this alternate method below
    if (typeof outerHTML === "undefined") outerHTML = new window.XMLSerializer().serializeToString(svg);
    return outerHTML;
}
/**
 * Gets a string representation of an svg <symbol>'s contents
 *
 * @param {SVGSymbolElement}
 * @return {string}
 */ function $898fc845a8d311b5$var$getSVGSymbolInnerHTML(symbol) {
    let innerHTML = symbol.innerHTML;
    // The `innerHTML` property is not available on IE / Edge
    // so if it's not present, use this alternate method below
    // which iterates through each of the symbol's child nodes and
    // serializes each element to a string.
    if (typeof innerHTML === "undefined") {
        innerHTML = "";
        Array.prototype.slice.call(symbol.childNodes).forEach(function(node, index) {
            innerHTML += new window.XMLSerializer().serializeToString(node);
        });
    }
    return innerHTML;
}
/**
 * Given a <symbol> element wrap it in an <svg> so that it can be rendered
 * as an individual image
 *
 * @param {SVGSymbolElement} symbol
 * @return {string}
 */ function $898fc845a8d311b5$var$convertSVGSymbolToSVGHTML(symbol) {
    // Get a string representation of <symbol>
    const symbolHTML = $898fc845a8d311b5$var$getSVGSymbolInnerHTML(symbol);
    // Create a new svg from the <symbol>
    // SVG element requires the 'xmlns' namespace, as well as the original viewBox attribute
    // The width and height values are required in Firefox
    // and to display them at the correct size in IE / Edge
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${symbol.viewBox}" width="${symbol.viewBox.baseVal.width}" height="${symbol.viewBox.baseVal.height}">${symbolHTML}</svg>`;
}
/**
 * Caches the processed SVG object to the image cache
 *
 * @param {string} id - key to identify the svg
 * @param {SVGElement|SVGSymbolElement} svg - original DOM nodes
 * @param {string} svgHTML - string representation of SVG
 */ function $898fc845a8d311b5$var$cacheSVGObject(id, svg, svgHTML) {
    // Browsers appear to do better with base-64 URLs rather than Blobs
    // (Chrome works with blobs, but setting width and height on SVG
    // makes rendering intermittent)
    const src = "data:image/svg+xml;base64," + window.btoa(svgHTML);
    const img = new Image();
    img.src = src;
    // Store properties on svg cache, using its simplified id as the key
    $898fc845a8d311b5$export$6c746a5570b8b35c.set(id, {
        el: svg,
        src: src,
        img: img,
        width: svg.viewBox.baseVal.width,
        height: svg.viewBox.baseVal.height
    });
}


/**
 * locale.js
 * handles internationalization (i18n)
 *
 */ var $125c2b0d01eab677$exports = {};
$125c2b0d01eab677$exports = JSON.parse('[{"label":"\u12A0\u121B\u122D\u129B","name":"Amharic","value":"am","key":"i18n.lang.am","level":3},{"label":"\u0644\u063A\u0629 \u0639\u0631\u0628\u064A\u0629","name":"Arabic","value":"ar","key":"i18n.lang.ar","level":3},{"label":"Catal\xe0","name":"Catalan","value":"ca","key":"i18n.lang.ca","level":3},{"label":"\u010De\u0161tina","name":"Czech","value":"cs","key":"i18n.lang.cs","level":3},{"label":"Deutsch","name":"German","value":"de","key":"i18n.lang.de","level":3},{"label":"English","name":"English","value":"en","key":"i18n.lang.en","level":4},{"label":"English (United Kingdom)","name":"English (United Kingdom)","value":"en-GB","key":"i18n.lang.en-gb","level":1},{"label":"Espa\xf1ol","name":"Spanish","value":"es","key":"i18n.lang.es","level":1},{"label":"Espa\xf1ol (Am\xe9rica Latina)","name":"Spanish (Latin America)","value":"es-419","key":"i18n.lang.es-419","level":3},{"label":"Espa\xf1ol (Espa\xf1a)","name":"Spanish (Spain)","value":"es-ES","key":"i18n.lang.es-es","level":3},{"label":"Espa\xf1ol (M\xe9xico)","name":"Spanish (Mexico)","value":"es-MX","key":"i18n.lang.es-mx","level":3},{"label":"Suomi","name":"Finnish","value":"fi","key":"i18n.lang.fi","level":3},{"label":"Filipino","name":"Filipino","value":"fil","key":"i18n.lang.fil","level":1},{"label":"Fran\xe7ais","name":"French","value":"fr","key":"i18n.lang.fr","level":3},{"label":"bahasa Indonesia","name":"Indonesian","value":"id","key":"i18n.lang.id","level":3},{"label":"Italiano","name":"Italian","value":"it","key":"i18n.lang.it","level":3},{"label":"\u65E5\u672C\u8A9E","name":"Japanese","value":"ja","key":"i18n.lang.ja","level":3},{"label":"\uD55C\uAD6D\uC5B4","name":"Korean","value":"ko","key":"i18n.lang.ko","level":3},{"label":"Nederlands","name":"Dutch (Netherlands)","value":"nl-NL","key":"i18n.lang.nl-nl","level":1},{"label":"Bokm\xe5l","name":"Norwegian Bokm\xe5l","value":"nb-NO","key":"i18n.lang.nb-no","level":3},{"label":"Polski","name":"Polish","value":"pl","key":"i18n.lang.pl","level":3},{"label":"Portugu\xeas (Brasil)","name":"Portuguese (Brazil)","value":"pt-BR","key":"i18n.lang.pt-br","level":3},{"label":"Roemeense","name":"Romanian","value":"ro-RO","key":"i18n.lang.ro-ro","level":1},{"label":"\u0420\u0443\u0441\u0441\u043A\u0438\u0439","name":"Russian","value":"ru","key":"i18n.lang.ru","level":3},{"label":"Svenska","name":"Swedish","value":"sv","key":"i18n.lang.sv","level":3},{"label":"T\xfcrk\xe7e","name":"Turkish","value":"tr","key":"i18n.lang.tr","level":3},{"label":"\u7B80\u4F53\u4E2D\u6587","name":"Simplified Chinese","value":"zh-Hans","key":"i18n.lang.zh-hans","level":3},{"label":"\u7E41\u9AD4\u4E2D\u6587","name":"Traditional Chinese","value":"zh-Hant","key":"i18n.lang.zh-hant","level":3}]');


/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $eIwgG = parcelRequire("eIwgG");

var $eIwgG = parcelRequire("eIwgG");
var $df31c3e96ee792ec$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($df31c3e96ee792ec$export$896afd8541959ee5 || ($df31c3e96ee792ec$export$896afd8541959ee5 = {}));



var $eIwgG = parcelRequire("eIwgG");

var $327cb2ddd0bef578$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($327cb2ddd0bef578$export$b87f371cbc396fcf || ($327cb2ddd0bef578$export$b87f371cbc396fcf = {}));
var $327cb2ddd0bef578$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($327cb2ddd0bef578$export$906452485466fa53 || ($327cb2ddd0bef578$export$906452485466fa53 = {}));
function $327cb2ddd0bef578$export$cfa10c5697238752(el) {
    return el.type === $327cb2ddd0bef578$export$b87f371cbc396fcf.literal;
}
function $327cb2ddd0bef578$export$4f55724281bdfaf9(el) {
    return el.type === $327cb2ddd0bef578$export$b87f371cbc396fcf.argument;
}
function $327cb2ddd0bef578$export$e11187b219e191e1(el) {
    return el.type === $327cb2ddd0bef578$export$b87f371cbc396fcf.number;
}
function $327cb2ddd0bef578$export$32d811605da75f40(el) {
    return el.type === $327cb2ddd0bef578$export$b87f371cbc396fcf.date;
}
function $327cb2ddd0bef578$export$34ec46f596b1702f(el) {
    return el.type === $327cb2ddd0bef578$export$b87f371cbc396fcf.time;
}
function $327cb2ddd0bef578$export$dcfe1c11d168b5a1(el) {
    return el.type === $327cb2ddd0bef578$export$b87f371cbc396fcf.select;
}
function $327cb2ddd0bef578$export$6c796d116f0a4fbc(el) {
    return el.type === $327cb2ddd0bef578$export$b87f371cbc396fcf.plural;
}
function $327cb2ddd0bef578$export$c0ece297bdd0c082(el) {
    return el.type === $327cb2ddd0bef578$export$b87f371cbc396fcf.pound;
}
function $327cb2ddd0bef578$export$5c83de34745812b(el) {
    return el.type === $327cb2ddd0bef578$export$b87f371cbc396fcf.tag;
}
function $327cb2ddd0bef578$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $327cb2ddd0bef578$export$906452485466fa53.number);
}
function $327cb2ddd0bef578$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $327cb2ddd0bef578$export$906452485466fa53.dateTime);
}
function $327cb2ddd0bef578$export$f0ac572c1121c662(value) {
    return {
        type: $327cb2ddd0bef578$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $327cb2ddd0bef578$export$425e864b0ba114f1(value, style) {
    return {
        type: $327cb2ddd0bef578$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $b185ecd1166981f9$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $b185ecd1166981f9$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $2db107aad1a7ad6e$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $2db107aad1a7ad6e$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($2db107aad1a7ad6e$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "short" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}



var $eIwgG = parcelRequire("eIwgG");
// @generated from regex-gen.ts
var $6257973da985ed66$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $abeaf91097450e2b$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $6257973da985ed66$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $abeaf91097450e2b$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $abeaf91097450e2b$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $abeaf91097450e2b$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $abeaf91097450e2b$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $abeaf91097450e2b$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $abeaf91097450e2b$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($abeaf91097450e2b$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $abeaf91097450e2b$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $abeaf91097450e2b$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$abeaf91097450e2b$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $abeaf91097450e2b$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $abeaf91097450e2b$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $abeaf91097450e2b$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $abeaf91097450e2b$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $eIwgG.__assign)((0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, all), $abeaf91097450e2b$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $eIwgG.__assign)((0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, all), $abeaf91097450e2b$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($abeaf91097450e2b$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($abeaf91097450e2b$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($abeaf91097450e2b$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($abeaf91097450e2b$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, result), $abeaf91097450e2b$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($abeaf91097450e2b$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, result), $abeaf91097450e2b$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $abeaf91097450e2b$var$parseSign(token.stem);
        if (signOpts) result = (0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $abeaf91097450e2b$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}




// @generated from time-data-gen.ts
// prettier-ignore  
var $10a21ef095940d48$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};


function $5c1d80a88456ee7e$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $5c1d80a88456ee7e$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $5c1d80a88456ee7e$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $10a21ef095940d48$export$a8c9209db4084317)[regionTag || ""] || (0, $10a21ef095940d48$export$a8c9209db4084317)[languageTag || ""] || (0, $10a21ef095940d48$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $10a21ef095940d48$export$a8c9209db4084317)["001"];
    return hourCycles[0];
}


var $1a45908662504ec0$var$_a;
var $1a45908662504ec0$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $b185ecd1166981f9$export$523451f94304dd6c).source, "*"));
var $1a45908662504ec0$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $b185ecd1166981f9$export$523451f94304dd6c).source, "*$"));
function $1a45908662504ec0$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $1a45908662504ec0$var$hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var $1a45908662504ec0$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $1a45908662504ec0$var$hasNativeFromEntries = !!Object.fromEntries;
var $1a45908662504ec0$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $1a45908662504ec0$var$hasTrimStart = !!String.prototype.trimStart;
var $1a45908662504ec0$var$hasTrimEnd = !!String.prototype.trimEnd;
var $1a45908662504ec0$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $1a45908662504ec0$var$isSafeInteger = $1a45908662504ec0$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $1a45908662504ec0$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $1a45908662504ec0$var$re = $1a45908662504ec0$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $1a45908662504ec0$var$REGEX_SUPPORTS_U_AND_Y = (($1a45908662504ec0$var$_a = $1a45908662504ec0$var$re.exec("a")) === null || $1a45908662504ec0$var$_a === void 0 ? void 0 : $1a45908662504ec0$var$_a[0]) === "a";
} catch (_) {
    $1a45908662504ec0$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $1a45908662504ec0$var$startsWith = $1a45908662504ec0$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $1a45908662504ec0$var$fromCodePoint = $1a45908662504ec0$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $1a45908662504ec0$var$fromEntries = // native
$1a45908662504ec0$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $1a45908662504ec0$var$codePointAt = $1a45908662504ec0$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $1a45908662504ec0$var$trimStart = $1a45908662504ec0$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($1a45908662504ec0$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $1a45908662504ec0$var$trimEnd = $1a45908662504ec0$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($1a45908662504ec0$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $1a45908662504ec0$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $1a45908662504ec0$var$matchIdentifierAtIndex;
if ($1a45908662504ec0$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $1a45908662504ec0$var$IDENTIFIER_PREFIX_RE_1 = $1a45908662504ec0$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $1a45908662504ec0$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $1a45908662504ec0$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $1a45908662504ec0$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$1a45908662504ec0$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $1a45908662504ec0$var$codePointAt(s, index);
        if (c === undefined || $1a45908662504ec0$var$_isWhiteSpace(c) || $1a45908662504ec0$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $1a45908662504ec0$var$fromCodePoint.apply(void 0, match);
};
var $1a45908662504ec0$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $327cb2ddd0bef578$export$b87f371cbc396fcf).pound,
                    location: $1a45908662504ec0$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $1a45908662504ec0$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $1a45908662504ec0$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $327cb2ddd0bef578$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $1a45908662504ec0$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$1a45908662504ec0$var$_isAlpha(this.char())) return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).INVALID_TAG, $1a45908662504ec0$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $1a45908662504ec0$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).INVALID_TAG, $1a45908662504ec0$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $327cb2ddd0bef578$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $1a45908662504ec0$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).UNCLOSED_TAG, $1a45908662504ec0$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).INVALID_TAG, $1a45908662504ec0$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $1a45908662504ec0$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $1a45908662504ec0$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $327cb2ddd0bef578$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$1a45908662504ec0$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $1a45908662504ec0$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $1a45908662504ec0$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $1a45908662504ec0$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).EMPTY_ARGUMENT, $1a45908662504ec0$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).MALFORMED_ARGUMENT, $1a45908662504ec0$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $1a45908662504ec0$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $327cb2ddd0bef578$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $1a45908662504ec0$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $1a45908662504ec0$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).MALFORMED_ARGUMENT, $1a45908662504ec0$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $1a45908662504ec0$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $1a45908662504ec0$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $1a45908662504ec0$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $1a45908662504ec0$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $1a45908662504ec0$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $1a45908662504ec0$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $1a45908662504ec0$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $1a45908662504ec0$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $1a45908662504ec0$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $327cb2ddd0bef578$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $5c1d80a88456ee7e$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $327cb2ddd0bef578$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $2db107aad1a7ad6e$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $327cb2ddd0bef578$export$b87f371cbc396fcf).date : (0, $327cb2ddd0bef578$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $327cb2ddd0bef578$export$b87f371cbc396fcf).number : argType === "date" ? (0, $327cb2ddd0bef578$export$b87f371cbc396fcf).date : (0, $327cb2ddd0bef578$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $1a45908662504ec0$var$createLocation(typeEndPosition_1, (0, $eIwgG.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $1a45908662504ec0$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $df31c3e96ee792ec$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $1a45908662504ec0$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $327cb2ddd0bef578$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $1a45908662504ec0$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $327cb2ddd0bef578$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $1a45908662504ec0$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $1a45908662504ec0$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $1a45908662504ec0$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $1a45908662504ec0$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $abeaf91097450e2b$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $327cb2ddd0bef578$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $abeaf91097450e2b$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $df31c3e96ee792ec$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $1a45908662504ec0$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $df31c3e96ee792ec$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $df31c3e96ee792ec$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $1a45908662504ec0$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $1a45908662504ec0$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $df31c3e96ee792ec$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $1a45908662504ec0$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $df31c3e96ee792ec$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $1a45908662504ec0$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $1a45908662504ec0$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$1a45908662504ec0$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $1a45908662504ec0$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($1a45908662504ec0$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $1a45908662504ec0$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $1a45908662504ec0$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $1a45908662504ec0$var$_isAlphaOrSlash(codepoint) {
    return $1a45908662504ec0$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $1a45908662504ec0$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $1a45908662504ec0$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $1a45908662504ec0$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}



function $9d646e75fcf9ce49$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $327cb2ddd0bef578$export$dcfe1c11d168b5a1)(el) || (0, $327cb2ddd0bef578$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $9d646e75fcf9ce49$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $327cb2ddd0bef578$export$e11187b219e191e1)(el) && (0, $327cb2ddd0bef578$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $327cb2ddd0bef578$export$32d811605da75f40)(el) || (0, $327cb2ddd0bef578$export$34ec46f596b1702f)(el)) && (0, $327cb2ddd0bef578$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $327cb2ddd0bef578$export$5c83de34745812b)(el)) $9d646e75fcf9ce49$var$pruneLocation(el.children);
    });
}
function $9d646e75fcf9ce49$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $eIwgG.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $1a45908662504ec0$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $df31c3e96ee792ec$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $9d646e75fcf9ce49$var$pruneLocation(result.val);
    return result.val;
}
var $9d646e75fcf9ce49$export$d3c1bfa0f7d806e9 = (0, $1a45908662504ec0$export$7acfa6ed01010e37);



var $b2bpw = parcelRequire("b2bpw");


var $eIwgG = parcelRequire("eIwgG");
var $4279355e5628abaf$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($4279355e5628abaf$export$d4e71bc0b80dc0fb || ($4279355e5628abaf$export$d4e71bc0b80dc0fb = {}));
var $4279355e5628abaf$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $eIwgG.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $4279355e5628abaf$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $eIwgG.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $4279355e5628abaf$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($4279355e5628abaf$export$7369836851cc1329);
var $4279355e5628abaf$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $eIwgG.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $4279355e5628abaf$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($4279355e5628abaf$export$7369836851cc1329);
var $4279355e5628abaf$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $eIwgG.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $4279355e5628abaf$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($4279355e5628abaf$export$7369836851cc1329);


var $42d0479f15995a15$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($42d0479f15995a15$export$49694c2877b44c57 || ($42d0479f15995a15$export$49694c2877b44c57 = {}));
function $42d0479f15995a15$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $42d0479f15995a15$export$49694c2877b44c57.literal || part.type !== $42d0479f15995a15$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $42d0479f15995a15$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $42d0479f15995a15$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $327cb2ddd0bef578$export$cfa10c5697238752)(els[0])) return [
        {
            type: $42d0479f15995a15$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $327cb2ddd0bef578$export$cfa10c5697238752)(el)) {
            result.push({
                type: $42d0479f15995a15$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $327cb2ddd0bef578$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $42d0479f15995a15$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $4279355e5628abaf$export$8bfc137e4d23fdf0)(varName, originalMessage);
        var value = values[varName];
        if ((0, $327cb2ddd0bef578$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $42d0479f15995a15$export$49694c2877b44c57.literal : $42d0479f15995a15$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $327cb2ddd0bef578$export$32d811605da75f40)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $327cb2ddd0bef578$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $42d0479f15995a15$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $327cb2ddd0bef578$export$34ec46f596b1702f)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $327cb2ddd0bef578$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $42d0479f15995a15$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $327cb2ddd0bef578$export$e11187b219e191e1)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $327cb2ddd0bef578$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $42d0479f15995a15$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $327cb2ddd0bef578$export$5c83de34745812b)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$42d0479f15995a15$export$df0c12a2d414a163(formatFn)) throw new (0, $4279355e5628abaf$export$cbc0db47c750f7c9)(value_1, "function", originalMessage);
            var parts = $42d0479f15995a15$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $42d0479f15995a15$export$49694c2877b44c57.literal : $42d0479f15995a15$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $327cb2ddd0bef578$export$dcfe1c11d168b5a1)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $4279355e5628abaf$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $42d0479f15995a15$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $327cb2ddd0bef578$export$6c796d116f0a4fbc)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $4279355e5628abaf$export$7369836851cc1329)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $4279355e5628abaf$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $4279355e5628abaf$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $42d0479f15995a15$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $42d0479f15995a15$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $1de860c9179c5649$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $eIwgG.__assign)((0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $1de860c9179c5649$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $1de860c9179c5649$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $eIwgG.__assign)({}, defaultConfig));
}
function $1de860c9179c5649$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $1de860c9179c5649$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $b2bpw.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $eIwgG.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $1de860c9179c5649$var$createFastMemoizeCache(cache.number),
            strategy: (0, $b2bpw.strategies).variadic
        }),
        getDateTimeFormat: (0, $b2bpw.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $eIwgG.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $1de860c9179c5649$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $b2bpw.strategies).variadic
        }),
        getPluralRules: (0, $b2bpw.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $eIwgG.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $1de860c9179c5649$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $b2bpw.strategies).variadic
        })
    };
}
var $1de860c9179c5649$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $42d0479f15995a15$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $42d0479f15995a15$export$275d4a3bb5f66fda)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $eIwgG.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $1de860c9179c5649$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $1de860c9179c5649$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $9d646e75fcf9ce49$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();





async function $4daaf0496059b305$export$837ecaa4d8b8583a() {
    // See if there is a requested locale via the lang param
    const paramLocale = new URLSearchParams(window.location.search).get("lang");
    // Default language is set by browser, or is English if undetermined
    const defaultLocale = navigator.language || (0, $b8c344dce25738f3$export$1af4c7e47ad72f44);
    // Current language is the one set by Streetmix or is the browser default, if unset
    let requestedLocale;
    // Try to read locale from param first; second, a stored value from LocalStorage;
    // if it fails (access denied, etc) then ignore this error and go with the browser's
    // locale or default
    try {
        requestedLocale = paramLocale || JSON.parse(window.localStorage.getItem("settings")).locale || defaultLocale;
    } catch (err) {
        requestedLocale = defaultLocale;
    }
    // Listen for switches in language direction (right-to-left vs left-to-right)
    $4daaf0496059b305$var$initRtlChangedListener();
    // Change app locale
    const locale = $4daaf0496059b305$export$f706f5d6959e9268(requestedLocale);
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $0083fa256c596554$export$7343075cd7f756c5)(locale));
}
/**
 * Whenever the language changes, this listener will apply the document's text
 * direction. Required to support right-to-left languages like Arabic, Hebrew, etc.
 */ function $4daaf0496059b305$var$initRtlChangedListener() {
    const select = (state)=>state.app.contentDirection;
    const onChange = (direction)=>{
        document.documentElement.dir = direction;
    };
    return (0, $81878321270eabd6$export$7eabfc5ef2a68f64)(select, onChange);
}
function $4daaf0496059b305$export$25868d1e8e76735f(key, fallback = "", options = {}) {
    const locale = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().locale;
    let message;
    if (options.ns === "segment-info") message = locale.segmentInfo[key];
    else message = locale.messages[key];
    if (!message) return fallback;
    // If message is an array (e.g. segment descriptions), return as is; don't format
    if (Array.isArray(message)) return message;
    const msg = new (0, $1de860c9179c5649$export$d342343268debc40)(message || fallback, locale.locale);
    return msg.format(options);
}
/**
 * Gets the current locale level. See `./constants.js` for a description
 * of what each level is.
 *
 * @returns {Number} between 1-4
 */ function $4daaf0496059b305$var$getLocaleLevel() {
    const flags = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().flags;
    // The lowest level marked "true" takes priority.
    let level = 4;
    if (flags.LOCALES_LEVEL_3.value) level = 3;
    if (flags.LOCALES_LEVEL_2.value) level = 2;
    if (flags.LOCALES_LEVEL_1.value) level = 1;
    return level;
}
function $4daaf0496059b305$export$dcd88f9e8a73bead() {
    const level = $4daaf0496059b305$var$getLocaleLevel();
    return (0, (/*@__PURE__*/$parcel$interopDefault($125c2b0d01eab677$exports)))// Remove languages that aren't enabled
    .filter((item)=>item.level >= level)// Sort the list of languages alphabetically
    .sort((a, b)=>{
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
    });
}
function $4daaf0496059b305$export$f706f5d6959e9268(proposedLocale) {
    const locales = $4daaf0496059b305$export$dcd88f9e8a73bead();
    let locale = (0, $b8c344dce25738f3$export$1af4c7e47ad72f44);
    // Is the proposed locale in the current list?
    let exactFound = false;
    for(let i = 0; i < locales.length; i++)if (proposedLocale === locales[i].value) {
        exactFound = true;
        locale = locales[i].value;
        break;
    }
    if (exactFound) return locale;
    // If there is not an exact match, is the proposed locale a subset of a primary language?
    // e.g. en-AU vs en
    let supersetFound = false;
    for(let i = 0; i < locales.length; i++)if (proposedLocale.indexOf(locales[i].value) === 0) {
        locale = locales[i].value;
        supersetFound = true;
        break;
    }
    if (supersetFound) return locale;
    // If neither exact or subset, is there a "fuzzy" match with another region's locale?
    // e.g. pt-PT vs pt-BR.
    let fuzzyMatch = false;
    const primaryTag = proposedLocale.split("-")[0];
    for(let i = 0; i < locales.length; i++)if (primaryTag === locales[i].value.split("-")[0]) {
        locale = locales[i].value;
        fuzzyMatch = true;
        break;
    }
    if (fuzzyMatch) return locale;
    // Finally, return DEFAULT_LOCALE if nothing else matches
    return locale;
}



let $5824ec4f3474e945$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $5824ec4f3474e945$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $5824ec4f3474e945$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$5824ec4f3474e945$export$a5cee9e955a615e5(alphabet, size, $5824ec4f3474e945$export$4385e60b38654f68);
let $5824ec4f3474e945$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");


var $762e491bbbc71e6b$export$2e2bcd8739ae039 = $762e491bbbc71e6b$var$clone;
/*
  Deep clones all properties except functions

  var arr = [1, 2, 3];
  var subObj = {aa: 1};
  var obj = {a: 3, b: 5, c: arr, d: subObj};
  var objClone = clone(obj);
  arr.push(4);
  subObj.bb = 2;
  obj; // {a: 3, b: 5, c: [1, 2, 3, 4], d: {aa: 1}}
  objClone; // {a: 3, b: 5, c: [1, 2, 3], d: {aa: 1, bb: 2}}
*/ function $762e491bbbc71e6b$var$clone(obj) {
    let result = obj;
    var type = ({}).toString.call(obj).slice(8, -1);
    if (type == "Set") return new Set([
        ...obj
    ].map((value)=>$762e491bbbc71e6b$var$clone(value)));
    if (type == "Map") return new Map([
        ...obj
    ].map((kv)=>[
            $762e491bbbc71e6b$var$clone(kv[0]),
            $762e491bbbc71e6b$var$clone(kv[1])
        ]));
    if (type == "Date") return new Date(obj.getTime());
    if (type == "RegExp") return RegExp(obj.source, $762e491bbbc71e6b$var$getRegExpFlags(obj));
    if (type == "Array" || type == "Object") {
        result = Array.isArray(obj) ? [] : {};
        for(var key in obj)// include prototype properties
        result[key] = $762e491bbbc71e6b$var$clone(obj[key]);
    }
    // primitives and non-supported objects (e.g. functions) land here
    return result;
}
function $762e491bbbc71e6b$var$getRegExpFlags(regExp) {
    if (typeof regExp.source.flags == "string") return regExp.source.flags;
    else {
        var flags = [];
        regExp.global && flags.push("g");
        regExp.ignoreCase && flags.push("i");
        regExp.multiline && flags.push("m");
        regExp.sticky && flags.push("y");
        regExp.unicode && flags.push("u");
        return flags.join("");
    }
}


const $685dc95e6c00aa0d$export$7c4422d33ae56848 = {
    false: [
        // Right-hand traffic
        {
            type: "sidewalk",
            variant: {
                "sidewalk-density": "dense"
            },
            width: 6
        },
        {
            type: "sidewalk-tree",
            variant: {
                "tree-type": "big"
            },
            width: 2
        },
        {
            type: "transit-shelter",
            variant: {
                orientation: "left",
                "transit-shelter-elevation": "street-level"
            },
            width: 9
        },
        {
            type: "sidewalk-lamp",
            variant: {
                "lamp-orientation": "right",
                "lamp-type": "modern"
            },
            width: 2
        },
        {
            type: "bus-lane",
            variant: {
                direction: "inbound",
                "bus-asphalt": "shared",
                "bus-type": "typical"
            },
            width: 12
        },
        {
            type: "drive-lane",
            variant: {
                direction: "inbound",
                "car-type": "car"
            },
            width: 9
        },
        {
            type: "divider",
            variant: {
                "divider-type": "bush"
            },
            width: 3
        },
        {
            type: "turn-lane",
            variant: {
                direction: "outbound",
                "turn-lane-orientation": "left-straight"
            },
            width: 10
        },
        {
            type: "parking-lane",
            variant: {
                "parking-lane-direction": "outbound",
                "parking-lane-orientation": "right"
            },
            width: 7
        },
        {
            type: "divider",
            variant: {
                "divider-type": "planter-box"
            },
            width: 4
        },
        {
            type: "bike-lane",
            variant: {
                direction: "outbound",
                "bike-asphalt": "green",
                elevation: "road"
            },
            width: 6
        },
        {
            type: "sidewalk-lamp",
            variant: {
                "lamp-orientation": "left",
                "lamp-type": "modern"
            },
            width: 2
        },
        {
            type: "sidewalk-tree",
            variant: {
                "tree-type": "big"
            },
            width: 2
        },
        {
            type: "sidewalk",
            variant: {
                "sidewalk-density": "normal"
            },
            width: 6
        }
    ],
    true: [
        // Left-hand traffic
        {
            type: "sidewalk",
            variant: {
                "sidewalk-density": "normal"
            },
            width: 6
        },
        {
            type: "sidewalk-tree",
            variant: {
                "tree-type": "big"
            },
            width: 2
        },
        {
            type: "sidewalk-lamp",
            variant: {
                "lamp-orientation": "right",
                "lamp-type": "modern"
            },
            width: 2
        },
        {
            type: "bike-lane",
            variant: {
                direction: "outbound",
                "bike-asphalt": "green",
                elevation: "road"
            },
            width: 6
        },
        {
            type: "divider",
            variant: {
                "divider-type": "planter-box"
            },
            width: 4
        },
        {
            type: "parking-lane",
            variant: {
                "parking-lane-direction": "outbound",
                "parking-lane-orientation": "left"
            },
            width: 7
        },
        {
            type: "turn-lane",
            variant: {
                direction: "outbound",
                "turn-lane-orientation": "right-straight"
            },
            width: 10
        },
        {
            type: "divider",
            variant: {
                "divider-type": "bush"
            },
            width: 3
        },
        {
            type: "drive-lane",
            variant: {
                direction: "inbound",
                "car-type": "car"
            },
            width: 9
        },
        {
            type: "bus-lane",
            variant: {
                direction: "inbound",
                "bus-asphalt": "shared",
                "bus-type": "typical"
            },
            width: 12
        },
        {
            type: "sidewalk-lamp",
            variant: {
                "lamp-orientation": "left",
                "lamp-type": "modern"
            },
            width: 2
        },
        {
            type: "transit-shelter",
            variant: {
                orientation: "right",
                "transit-shelter-elevation": "street-level"
            },
            width: 9
        },
        {
            type: "sidewalk-tree",
            variant: {
                "tree-type": "big"
            },
            width: 2
        },
        {
            type: "sidewalk",
            variant: {
                "sidewalk-density": "dense"
            },
            width: 6
        }
    ]
};


/**
 * app_settings
 *
 * Change the state of the application based on combinations of
 * debug and system settings.
 *
 */ 


// Just set readOnly
const $9bf07f90c2c537c3$var$system = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().system;
const $9bf07f90c2c537c3$export$729c8b7179294ba = {
    readOnly: $9bf07f90c2c537c3$var$system.phone || (0, $6fccecb363574db8$export$1c9f709888824e05).forceReadOnly
};
(0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $9dbab908c178b0dc$export$af2e4444750bad23)($9bf07f90c2c537c3$export$729c8b7179294ba));



var $3b0883627b239985$exports = {};
/*! For license information please see shifty.js.LICENSE.txt */ !function(e, t) {
    $3b0883627b239985$exports = t();
}(self, function() {
    return function() {
        "use strict";
        var e = {
            55: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.setBezierFunction = t.getCubicBezierTransition = void 0;
                const i = n(188);
                t.getCubicBezierTransition = (e = .25, t = .25, n = .75, i = .75)=>(s)=>(function(e, t, n, i, s, r) {
                            let a = 0, o = 0, u = 0, l = 0, c = 0, h = 0;
                            const p = (e)=>((a * e + o) * e + u) * e, d = (e)=>(3 * a * e + 2 * o) * e + u, _ = (e)=>e >= 0 ? e : 0 - e;
                            var f, g;
                            return u = 3 * t, o = 3 * (i - t) - u, a = 1 - u - o, h = 3 * n, c = 3 * (s - n) - h, l = 1 - h - c, f = e, g = ((e)=>1 / (200 * e))(r), ((e)=>((l * e + c) * e + h) * e)(((e, t)=>{
                                let n, i, s, r, a, o;
                                for(s = e, o = 0; o < 8; o++){
                                    if (r = p(s) - e, _(r) < t) return s;
                                    if (a = d(s), _(a) < 1e-6) break;
                                    s -= r / a;
                                }
                                if (n = 0, i = 1, s = e, s < n) return n;
                                if (s > i) return i;
                                for(; n < i;){
                                    if (r = p(s), _(r - e) < t) return s;
                                    e > r ? n = s : i = s, s = .5 * (i - n) + n;
                                }
                                return s;
                            })(f, g));
                        })(s, e, t, n, i, 1), t.setBezierFunction = (e, n, s, r, a)=>{
                    const o = (0, t.getCubicBezierTransition)(n, s, r, a);
                    return o.displayName = e, o.x1 = n, o.y1 = s, o.x2 = r, o.y2 = a, i.Tweenable.easing[e] = o;
                };
            },
            607: function(e, t, n) {
                var i = this && this.__createBinding || (Object.create ? function(e, t, n, i) {
                    void 0 === i && (i = n);
                    var s = Object.getOwnPropertyDescriptor(t, n);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, i, s);
                } : function(e, t, n, i) {
                    void 0 === i && (i = n), e[i] = t[n];
                }), s = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || i(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.VERSION = t.standardEasingFunctions = t.setBezierFunction = t.Scene = t.interpolate = t.tween = t.Tweenable = t.shouldScheduleUpdate = t.processTweens = void 0;
                const r = n(188);
                Object.defineProperty(t, "processTweens", {
                    enumerable: !0,
                    get: function() {
                        return r.processTweens;
                    }
                }), Object.defineProperty(t, "shouldScheduleUpdate", {
                    enumerable: !0,
                    get: function() {
                        return r.shouldScheduleUpdate;
                    }
                }), Object.defineProperty(t, "Tweenable", {
                    enumerable: !0,
                    get: function() {
                        return r.Tweenable;
                    }
                }), Object.defineProperty(t, "tween", {
                    enumerable: !0,
                    get: function() {
                        return r.tween;
                    }
                });
                var a = n(166);
                Object.defineProperty(t, "interpolate", {
                    enumerable: !0,
                    get: function() {
                        return a.interpolate;
                    }
                });
                var o = n(147);
                Object.defineProperty(t, "Scene", {
                    enumerable: !0,
                    get: function() {
                        return o.Scene;
                    }
                });
                var u = n(55);
                Object.defineProperty(t, "setBezierFunction", {
                    enumerable: !0,
                    get: function() {
                        return u.setBezierFunction;
                    }
                });
                var l = n(64);
                Object.defineProperty(t, "standardEasingFunctions", {
                    enumerable: !0,
                    get: function() {
                        return l.standardEasingFunctions;
                    }
                }), s(n(699), t), t.VERSION = String("3.0.3");
            },
            166: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.interpolate = void 0;
                const i = n(188), s = new i.Tweenable, { filters: r } = i.Tweenable;
                t.interpolate = (e, t, n, a = i.Tweenable.easing.linear, o = 0)=>{
                    const u = Object.assign({}, e), l = (0, i.composeEasingObject)(e, a);
                    s._filters.length = 0, s.setState({}), s._currentState = u, s._originalState = e, s._targetState = t, s._easing = l;
                    for(const e in r)r[e].doesApply(s) && s._filters.push(r[e]);
                    s._applyFilter("tweenCreated"), s._applyFilter("beforeTween");
                    const c = (0, i.tweenProps)(n, u, e, t, 1, o, l);
                    return s._applyFilter("afterTween"), c;
                };
            },
            147: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Scene = void 0, t.Scene = class {
                    constructor(...e){
                        this._tweenables = [], e.forEach(this.add.bind(this));
                    }
                    get tweenables() {
                        return [
                            ...this._tweenables
                        ];
                    }
                    get promises() {
                        return this._tweenables.map((e)=>e.then());
                    }
                    add(e) {
                        return this._tweenables.push(e), e;
                    }
                    remove(e) {
                        const t = this._tweenables.indexOf(e);
                        return t > -1 && this._tweenables.splice(t, 1), e;
                    }
                    empty() {
                        return this.tweenables.map(this.remove.bind(this));
                    }
                    get isPlaying() {
                        return this._tweenables.some(({ isPlaying: e })=>e);
                    }
                    tween() {
                        return this._tweenables.forEach((e)=>e.tween()), this;
                    }
                    pause() {
                        return this._tweenables.forEach((e)=>e.pause()), this;
                    }
                    resume() {
                        return this._tweenables.filter(({ hasEnded: e })=>!e).forEach((e)=>e.resume()), this;
                    }
                    stop(e) {
                        return this._tweenables.forEach((t)=>t.stop(e)), this;
                    }
                };
            },
            64: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.standardEasingFunctions = void 0, t.standardEasingFunctions = Object.freeze({
                    linear: (e)=>e,
                    easeInQuad: (e)=>Math.pow(e, 2),
                    easeOutQuad: (e)=>-(Math.pow(e - 1, 2) - 1),
                    easeInOutQuad: (e)=>(e /= .5) < 1 ? .5 * Math.pow(e, 2) : -0.5 * ((e -= 2) * e - 2),
                    easeInCubic: (e)=>Math.pow(e, 3),
                    easeOutCubic: (e)=>Math.pow(e - 1, 3) + 1,
                    easeInOutCubic: (e)=>(e /= .5) < 1 ? .5 * Math.pow(e, 3) : .5 * (Math.pow(e - 2, 3) + 2),
                    easeInQuart: (e)=>Math.pow(e, 4),
                    easeOutQuart: (e)=>-(Math.pow(e - 1, 4) - 1),
                    easeInOutQuart: (e)=>(e /= .5) < 1 ? .5 * Math.pow(e, 4) : -0.5 * ((e -= 2) * Math.pow(e, 3) - 2),
                    easeInQuint: (e)=>Math.pow(e, 5),
                    easeOutQuint: (e)=>Math.pow(e - 1, 5) + 1,
                    easeInOutQuint: (e)=>(e /= .5) < 1 ? .5 * Math.pow(e, 5) : .5 * (Math.pow(e - 2, 5) + 2),
                    easeInSine: (e)=>1 - Math.cos(e * (Math.PI / 2)),
                    easeOutSine: (e)=>Math.sin(e * (Math.PI / 2)),
                    easeInOutSine: (e)=>-0.5 * (Math.cos(Math.PI * e) - 1),
                    easeInExpo: (e)=>0 === e ? 0 : Math.pow(2, 10 * (e - 1)),
                    easeOutExpo: (e)=>1 === e ? 1 : 1 - Math.pow(2, -10 * e),
                    easeInOutExpo: (e)=>0 === e ? 0 : 1 === e ? 1 : (e /= .5) < 1 ? .5 * Math.pow(2, 10 * (e - 1)) : .5 * (2 - Math.pow(2, -10 * --e)),
                    easeInCirc: (e)=>-(Math.sqrt(1 - e * e) - 1),
                    easeOutCirc: (e)=>Math.sqrt(1 - Math.pow(e - 1, 2)),
                    easeInOutCirc: (e)=>(e /= .5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : .5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
                    easeOutBounce: (e)=>e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + .75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + .9375 : 7.5625 * (e -= 2.625 / 2.75) * e + .984375,
                    easeInBack: (e)=>{
                        const t = 1.70158;
                        return e * e * ((t + 1) * e - t);
                    },
                    easeOutBack: (e)=>{
                        const t = 1.70158;
                        return (e -= 1) * e * ((t + 1) * e + t) + 1;
                    },
                    easeInOutBack: (e)=>{
                        let t = 1.70158;
                        return (e /= .5) < 1 ? e * e * ((1 + (t *= 1.525)) * e - t) * .5 : .5 * ((e -= 2) * e * ((1 + (t *= 1.525)) * e + t) + 2);
                    },
                    elastic: (e)=>-1 * Math.pow(4, -8 * e) * Math.sin((6 * e - 1) * (2 * Math.PI) / 2) + 1,
                    swingFromTo: (e)=>{
                        let t = 1.70158;
                        return (e /= .5) < 1 ? e * e * ((1 + (t *= 1.525)) * e - t) * .5 : .5 * ((e -= 2) * e * ((1 + (t *= 1.525)) * e + t) + 2);
                    },
                    swingFrom: (e)=>{
                        const t = 1.70158;
                        return e * e * ((t + 1) * e - t);
                    },
                    swingTo: (e)=>{
                        const t = 1.70158;
                        return (e -= 1) * e * ((t + 1) * e + t) + 1;
                    },
                    bounce: (e)=>e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + .75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + .9375 : 7.5625 * (e -= 2.625 / 2.75) * e + .984375,
                    bouncePast: (e)=>e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 2 - (7.5625 * (e -= 1.5 / 2.75) * e + .75) : e < 2.5 / 2.75 ? 2 - (7.5625 * (e -= 2.25 / 2.75) * e + .9375) : 2 - (7.5625 * (e -= 2.625 / 2.75) * e + .984375),
                    easeFromTo: (e)=>(e /= .5) < 1 ? .5 * Math.pow(e, 4) : -0.5 * ((e -= 2) * Math.pow(e, 3) - 2),
                    easeFrom: (e)=>Math.pow(e, 4),
                    easeTo: (e)=>Math.pow(e, .25)
                });
            },
            432: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.afterTween = t.beforeTween = t.tweenCreated = t.doesApply = void 0;
                const i = n(699), s = /(\d|-|\.)/, r = /([^\-0-9.]+)/g, a = /[0-9.-]+/g, o = (()=>{
                    const e = a.source, t = /,\s*/.source;
                    return new RegExp(`rgba?\\(${e}${t}${e}${t}${e}(${t}${e})?\\)`, "g");
                })(), u = /^.*\(/, l = /#([0-9]|[a-f]){3,6}/gi, c = "VAL", h = (e, t)=>e.map((e, n)=>`_${t}_${n}`), p = (e)=>{
                    let t = e.match(r);
                    return t ? (1 === t.length || e.charAt(0).match(s)) && t.unshift("") : t = [
                        "",
                        ""
                    ], t.join(c);
                };
                function d(e) {
                    return parseInt(e, 16);
                }
                const _ = (e)=>`rgb(${((e)=>{
                        if (3 === (e = e.replace(/#/, "")).length) {
                            const [t, n, i] = e.split("");
                            e = t + t + n + n + i + i;
                        }
                        return [
                            d(e.substring(0, 2)),
                            d(e.substring(2, 4)),
                            d(e.substring(4, 6))
                        ];
                    })(e).join(",")})`, f = (e, t, n)=>{
                    const i = t.match(e);
                    let s = t.replace(e, c);
                    return i && i.forEach((e)=>s = s.replace(c, n(e))), s;
                }, g = (e)=>{
                    for(const t in e){
                        const n = e[t];
                        "string" == typeof n && n.match(l) && (e[t] = f(l, n, _));
                    }
                }, w = (e)=>{
                    var t, n;
                    const i = null !== (t = e.match(a)) && void 0 !== t ? t : [], s = i.slice(0, 3).map((e)=>Math.floor(Number(e))), r = null === (n = e.match(u)) || void 0 === n ? void 0 : n[0];
                    if (3 === i.length) return `${r}${s.join(",")})`;
                    if (4 === i.length) return `${r}${s.join(",")},${i[3]})`;
                    throw new Error(`Invalid rgbChunk: ${e}`);
                }, m = (e)=>{
                    var t;
                    return null !== (t = e.match(a)) && void 0 !== t ? t : [];
                }, b = (e, t)=>{
                    const n = {};
                    return t.forEach((t)=>{
                        n[t] = e[t], delete e[t];
                    }), n;
                }, y = (e, t)=>t.map((t)=>Number(e[t])), v = (e, t)=>(t.forEach((t)=>e = e.replace(c, String(+t.toFixed(4)))), e);
                t.doesApply = (e)=>{
                    for(const t in e._currentState)if ("string" == typeof e._currentState[t]) return !0;
                    return !1;
                }, t.tweenCreated = function(e) {
                    const { _currentState: t, _originalState: n, _targetState: i } = e;
                    [
                        t,
                        n,
                        i
                    ].forEach(g), e._tokenData = ((e)=>{
                        var t;
                        const n = {};
                        for(const i in e){
                            const s = e[i];
                            "string" == typeof s && (n[i] = {
                                formatString: p(s),
                                chunkNames: h(null === (t = m(s)) || void 0 === t ? void 0 : t.map(Number), i)
                            });
                        }
                        return n;
                    })(t);
                }, t.beforeTween = function(e) {
                    const { _currentState: t, _originalState: n, _targetState: s, _easing: r, _tokenData: a } = e;
                    "function" != typeof r && a && ((e, t)=>{
                        var n;
                        for(const s in t){
                            const { chunkNames: r } = t[s], a = e[s];
                            if ("string" == typeof a) {
                                const t = a.split(" "), s = t[t.length - 1];
                                for(let a = 0; a < r.length; a++){
                                    const o = r[a], u = null !== (n = t[a]) && void 0 !== n ? n : s;
                                    (0, i.isEasingKey)(u) && (e[o] = u);
                                }
                            } else r.forEach((t)=>e[t] = a);
                            delete e[s];
                        }
                    })(r, a), [
                        t,
                        n,
                        s
                    ].forEach((e)=>((e, t)=>{
                            for(const n in t)m(String(e[n])).forEach((i, s)=>e[t[n].chunkNames[s]] = +i), delete e[n];
                        })(e, null != a ? a : {}));
                }, t.afterTween = function(e) {
                    const { _currentState: t, _originalState: n, _targetState: i, _easing: s, _tokenData: r } = e;
                    [
                        t,
                        n,
                        i
                    ].forEach((e)=>((e, t)=>{
                            for(const n in t){
                                const { chunkNames: i, formatString: s } = t[n], r = v(s, y(b(e, i), i));
                                e[n] = f(o, r, w);
                            }
                        })(e, null != r ? r : {})), "function" != typeof s && r && ((e, t)=>{
                        for(const n in t){
                            const { chunkNames: i } = t[n], s = e[i[0]];
                            e[n] = "string" == typeof s ? i.map((t)=>{
                                const n = e[t];
                                return delete e[t], n;
                            }).join(" ") : s;
                        }
                    })(s, r);
                };
            },
            188: function(e, t, n) {
                var i, s = this && this.__createBinding || (Object.create ? function(e, t, n, i) {
                    void 0 === i && (i = n);
                    var s = Object.getOwnPropertyDescriptor(t, n);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, i, s);
                } : function(e, t, n, i) {
                    void 0 === i && (i = n), e[i] = t[n];
                }), r = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), a = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && s(t, e, n);
                    return r(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.shouldScheduleUpdate = t.tween = t.Tweenable = t.composeEasingObject = t.scheduleUpdate = t.processTweens = t.tweenProps = t.getListTail = t.getListHead = t.resetList = void 0;
                const o = n(64), u = n(55), l = n(699), c = a(n(432)), h = "linear", p = "undefined" != typeof window ? window : n.g, d = "afterTween", _ = "beforeTween", f = "string", g = "function";
                let w = p.requestAnimationFrame;
                w || (w = "undefined" == typeof window ? setTimeout : window.webkitRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || window.mozCancelRequestAnimationFrame && window.mozRequestAnimationFrame || setTimeout);
                const m = ()=>{};
                let b = null, y = null;
                t.resetList = ()=>{
                    b = y = null;
                }, t.getListHead = ()=>b, t.getListTail = ()=>y, t.tweenProps = (e, t, n, i, s, r, a)=>{
                    var u;
                    let l, c = 0;
                    const h = e < r ? 0 : (e - r) / s;
                    let p;
                    for(const e in t){
                        if (typeof a === g) p = a;
                        else {
                            const t = a[e];
                            p = typeof t === g ? t : null !== (u = T.easing[t]) && void 0 !== u ? u : o.standardEasingFunctions.linear;
                        }
                        c = p(h), l = n[e], t[e] = l + (i[e] - l) * c;
                    }
                    return t;
                };
                const v = (e, n)=>{
                    var i;
                    let s = null !== (i = e._timestamp) && void 0 !== i ? i : 0;
                    const r = e._currentState, a = e._delay;
                    if (n < s + a) return;
                    let o = e._duration;
                    const u = e._targetState, l = s + a + o;
                    let c = n > l ? l : n;
                    e._hasEnded = c >= l;
                    const h = o - (l - c);
                    if (e._hasEnded) return e._render(u, h, e._data), e.stop(!0);
                    e._applyFilter(_), c < s + a ? s = o = c = 1 : s += a, (0, t.tweenProps)(c, r, e._originalState, u, o, s, e._easing), e._applyFilter(d), e._render(r, h, e._data);
                };
                t.processTweens = ()=>{
                    let e;
                    const t = T.now();
                    let n = b;
                    for(; n;)e = n._next, v(n, t), n = e;
                };
                const { now: S } = Date;
                let O, j = !1;
                t.scheduleUpdate = ()=>{
                    O = S(), j && w.call(p, t.scheduleUpdate, 16.666666666666668), (0, t.processTweens)();
                }, t.composeEasingObject = (e, t = h, n = {})=>{
                    if (typeof t === f && (0, l.isEasingKey)(t)) return T.easing[t];
                    if (Array.isArray(t)) return (0, u.getCubicBezierTransition)(...t);
                    if ("object" == typeof n) {
                        if (typeof t === f || typeof t === g) for(const i in e)n[i] = t;
                        else for(const i in e)n[i] = t[i] || h;
                    }
                    return n;
                };
                const M = (()=>{
                    let e, t;
                    return (n)=>{
                        e = null, t = null, n === b ? (b = n._next, b ? b._previous = null : y = null) : n === y ? (y = n._previous, y ? y._next = null : b = null) : (e = n._previous, t = n._next, e && (e._next = t), t && (t._previous = e)), n._previous = n._next = null;
                    };
                })(), P = typeof Promise === g ? Promise : null;
                class T {
                    constructor(e = {}, t){
                        this[i] = "Promise", this._next = null, this._previous = null, this._config = {}, this._data = {}, this._delay = 0, this._duration = 500, this._filters = [], this._timestamp = null, this._hasEnded = !1, this._resolve = null, this._reject = null, this._originalState = {}, this._targetState = {}, this._start = m, this._render = m, this._promiseCtor = P, this._promise = null, this._isPlaying = !1, this._pausedAtTime = null, this._easing = {}, this._currentState = e || {}, t && this.setConfig(t);
                    }
                    _applyFilter(e) {
                        var t;
                        for(let n = this._filters.length; n > 0; n--){
                            const i = this._filters[n - n];
                            null === (t = i[e]) || void 0 === t || t.call(i, this);
                        }
                    }
                    tween(e) {
                        return this._isPlaying && this.stop(), !e && this._config || this.setConfig(e), this._pausedAtTime = null, this._timestamp = T.now(), this._start(this.state, this._data), this._delay && this._render(this._currentState, 0, this._data), this._resume(this._timestamp);
                    }
                    setConfig(e = {}) {
                        var n;
                        const { _config: i } = this;
                        let s;
                        for(s in e)i[s] = e[s];
                        const { promise: r = this._promiseCtor, start: a = m, finish: o, render: u = m } = i;
                        this._data = i.data || this._data, this._isPlaying = !1, this._pausedAtTime = null, this._delay = e.delay || 0, this._start = a, this._render = u, this._duration = i.duration || 500, this._promiseCtor = r, o && (this._resolve = o);
                        const { from: l, to: c = {} } = e, { _currentState: h, _originalState: p, _targetState: d } = this;
                        for(const e in l)h[e] = l[e];
                        let _ = !1;
                        for(const e in h){
                            const t = h[e];
                            _ || typeof t !== f || (_ = !0), p[e] = t, d[e] = null !== (n = c[e]) && void 0 !== n ? n : t;
                        }
                        if (this._easing = (0, t.composeEasingObject)(this._currentState, i.easing, this._easing), this._filters.length = 0, _) {
                            for(const e in T.filters)T.filters[e].doesApply(this) && this._filters.push(T.filters[e]);
                            this._applyFilter("tweenCreated");
                        }
                        return this;
                    }
                    then(e, t) {
                        if (!this._promiseCtor) throw new Error("Promise implementation is unavailable");
                        return this._promise = new this._promiseCtor((e, t)=>{
                            this._resolve = e, this._reject = t;
                        }), this._promise.then(e, t);
                    }
                    catch(e) {
                        return this.then().catch(e);
                    }
                    finally(e) {
                        return this.then().finally(e);
                    }
                    get state() {
                        return Object.assign({}, this._currentState);
                    }
                    setState(e) {
                        this._currentState = e;
                    }
                    pause() {
                        return this._isPlaying ? (this._pausedAtTime = T.now(), this._isPlaying = !1, M(this), this) : this;
                    }
                    resume() {
                        return this._resume();
                    }
                    _resume(e = T.now()) {
                        return null === this._timestamp ? this.tween() : (this._isPlaying && this._promise || (this._pausedAtTime && (this._timestamp += e - this._pausedAtTime, this._pausedAtTime = null), this._isPlaying = !0, null === b ? (b = this, y = this) : (this._previous = y, y && (y._next = this), y = this)), this);
                    }
                    seek(e) {
                        var t;
                        e = Math.max(e, 0);
                        const n = T.now();
                        return (null !== (t = this._timestamp) && void 0 !== t ? t : 0) + e === 0 || (this._timestamp = n - e, v(this, n)), this;
                    }
                    stop(e = !1) {
                        var n;
                        return this._isPlaying ? (this._isPlaying = !1, M(this), e && (this._applyFilter(_), (0, t.tweenProps)(1, this._currentState, this._originalState, this._targetState, 1, 0, this._easing), this._applyFilter(d), this._applyFilter("afterTweenEnd")), null === (n = this._resolve) || void 0 === n || n.call(this, {
                            data: this._data,
                            state: this._currentState,
                            tweenable: this
                        }), this._resolve = null, this._reject = null, this) : this;
                    }
                    cancel(e = !1) {
                        var t;
                        const { _currentState: n, _data: i, _isPlaying: s } = this;
                        return s ? (null === (t = this._reject) || void 0 === t || t.call(this, {
                            data: i,
                            state: n,
                            tweenable: this
                        }), this._resolve = null, this._reject = null, this.stop(e)) : this;
                    }
                    get isPlaying() {
                        return this._isPlaying;
                    }
                    get hasEnded() {
                        return this._hasEnded;
                    }
                    data(e = null) {
                        return e && (this._data = Object.assign({}, e)), this._data;
                    }
                    dispose() {
                        for(const e in this)delete this[e];
                    }
                }
                t.Tweenable = T, i = Symbol.toStringTag, T.now = ()=>O, T.setScheduleFunction = (e)=>w = e, T.filters = {
                    token: c
                }, T.easing = Object.create(o.standardEasingFunctions), t.tween = function(e = {}) {
                    return new T({}, {}).tween(e);
                }, t.shouldScheduleUpdate = (e)=>{
                    e && j || (j = e, e && (0, t.scheduleUpdate)());
                }, (0, t.shouldScheduleUpdate)(!0);
            },
            699: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isEasingKey = void 0;
                const i = n(188);
                t.isEasingKey = (e)=>e in i.Tweenable.easing;
            }
        }, t = {};
        function n(i) {
            var s = t[i];
            if (void 0 !== s) return s.exports;
            var r = t[i] = {
                exports: {}
            };
            return e[i].call(r.exports, r, r.exports, n), r.exports;
        }
        return n.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), n(607);
    }();
});


var $6a0542dba83ef44c$exports = {};
(function(name, root, factory) {
    $6a0542dba83ef44c$exports = factory();
    $6a0542dba83ef44c$exports["default"] = factory();
})("slugify", $6a0542dba83ef44c$exports, function() {
    var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","\xa2":"cent","\xa3":"pound","\xa4":"currency","\xa5":"yen","\xa9":"(c)","\xaa":"a","\xae":"(r)","\xba":"o","\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xc6":"AE","\xc7":"C","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xd0":"D","\xd1":"N","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xdd":"Y","\xde":"TH","\xdf":"ss","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xe6":"ae","\xe7":"c","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xf0":"d","\xf1":"n","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xfd":"y","\xfe":"th","\xff":"y","\u0100":"A","\u0101":"a","\u0102":"A","\u0103":"a","\u0104":"A","\u0105":"a","\u0106":"C","\u0107":"c","\u010C":"C","\u010D":"c","\u010E":"D","\u010F":"d","\u0110":"DJ","\u0111":"dj","\u0112":"E","\u0113":"e","\u0116":"E","\u0117":"e","\u0118":"e","\u0119":"e","\u011A":"E","\u011B":"e","\u011E":"G","\u011F":"g","\u0122":"G","\u0123":"g","\u0128":"I","\u0129":"i","\u012A":"i","\u012B":"i","\u012E":"I","\u012F":"i","\u0130":"I","\u0131":"i","\u0136":"k","\u0137":"k","\u013B":"L","\u013C":"l","\u013D":"L","\u013E":"l","\u0141":"L","\u0142":"l","\u0143":"N","\u0144":"n","\u0145":"N","\u0146":"n","\u0147":"N","\u0148":"n","\u014C":"O","\u014D":"o","\u0150":"O","\u0151":"o","\u0152":"OE","\u0153":"oe","\u0154":"R","\u0155":"r","\u0158":"R","\u0159":"r","\u015A":"S","\u015B":"s","\u015E":"S","\u015F":"s","\u0160":"S","\u0161":"s","\u0162":"T","\u0163":"t","\u0164":"T","\u0165":"t","\u0168":"U","\u0169":"u","\u016A":"u","\u016B":"u","\u016E":"U","\u016F":"u","\u0170":"U","\u0171":"u","\u0172":"U","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017A":"z","\u017B":"Z","\u017C":"z","\u017D":"Z","\u017E":"z","\u018F":"E","\u0192":"f","\u01A0":"O","\u01A1":"o","\u01AF":"U","\u01B0":"u","\u01C8":"LJ","\u01C9":"lj","\u01CB":"NJ","\u01CC":"nj","\u0218":"S","\u0219":"s","\u021A":"T","\u021B":"t","\u0259":"e","\u02DA":"o","\u0386":"A","\u0388":"E","\u0389":"H","\u038A":"I","\u038C":"O","\u038E":"Y","\u038F":"W","\u0390":"i","\u0391":"A","\u0392":"B","\u0393":"G","\u0394":"D","\u0395":"E","\u0396":"Z","\u0397":"H","\u0398":"8","\u0399":"I","\u039A":"K","\u039B":"L","\u039C":"M","\u039D":"N","\u039E":"3","\u039F":"O","\u03A0":"P","\u03A1":"R","\u03A3":"S","\u03A4":"T","\u03A5":"Y","\u03A6":"F","\u03A7":"X","\u03A8":"PS","\u03A9":"W","\u03AA":"I","\u03AB":"Y","\u03AC":"a","\u03AD":"e","\u03AE":"h","\u03AF":"i","\u03B0":"y","\u03B1":"a","\u03B2":"b","\u03B3":"g","\u03B4":"d","\u03B5":"e","\u03B6":"z","\u03B7":"h","\u03B8":"8","\u03B9":"i","\u03BA":"k","\u03BB":"l","\u03BC":"m","\u03BD":"n","\u03BE":"3","\u03BF":"o","\u03C0":"p","\u03C1":"r","\u03C2":"s","\u03C3":"s","\u03C4":"t","\u03C5":"y","\u03C6":"f","\u03C7":"x","\u03C8":"ps","\u03C9":"w","\u03CA":"i","\u03CB":"y","\u03CC":"o","\u03CD":"y","\u03CE":"w","\u0401":"Yo","\u0402":"DJ","\u0404":"Ye","\u0406":"I","\u0407":"Yi","\u0408":"J","\u0409":"LJ","\u040A":"NJ","\u040B":"C","\u040F":"DZ","\u0410":"A","\u0411":"B","\u0412":"V","\u0413":"G","\u0414":"D","\u0415":"E","\u0416":"Zh","\u0417":"Z","\u0418":"I","\u0419":"J","\u041A":"K","\u041B":"L","\u041C":"M","\u041D":"N","\u041E":"O","\u041F":"P","\u0420":"R","\u0421":"S","\u0422":"T","\u0423":"U","\u0424":"F","\u0425":"H","\u0426":"C","\u0427":"Ch","\u0428":"Sh","\u0429":"Sh","\u042A":"U","\u042B":"Y","\u042C":"","\u042D":"E","\u042E":"Yu","\u042F":"Ya","\u0430":"a","\u0431":"b","\u0432":"v","\u0433":"g","\u0434":"d","\u0435":"e","\u0436":"zh","\u0437":"z","\u0438":"i","\u0439":"j","\u043A":"k","\u043B":"l","\u043C":"m","\u043D":"n","\u043E":"o","\u043F":"p","\u0440":"r","\u0441":"s","\u0442":"t","\u0443":"u","\u0444":"f","\u0445":"h","\u0446":"c","\u0447":"ch","\u0448":"sh","\u0449":"sh","\u044A":"u","\u044B":"y","\u044C":"","\u044D":"e","\u044E":"yu","\u044F":"ya","\u0451":"yo","\u0452":"dj","\u0454":"ye","\u0456":"i","\u0457":"yi","\u0458":"j","\u0459":"lj","\u045A":"nj","\u045B":"c","\u045D":"u","\u045F":"dz","\u0490":"G","\u0491":"g","\u0492":"GH","\u0493":"gh","\u049A":"KH","\u049B":"kh","\u04A2":"NG","\u04A3":"ng","\u04AE":"UE","\u04AF":"ue","\u04B0":"U","\u04B1":"u","\u04BA":"H","\u04BB":"h","\u04D8":"AE","\u04D9":"ae","\u04E8":"OE","\u04E9":"oe","\u0531":"A","\u0532":"B","\u0533":"G","\u0534":"D","\u0535":"E","\u0536":"Z","\u0537":"E\'","\u0538":"Y\'","\u0539":"T\'","\u053A":"JH","\u053B":"I","\u053C":"L","\u053D":"X","\u053E":"C\'","\u053F":"K","\u0540":"H","\u0541":"D\'","\u0542":"GH","\u0543":"TW","\u0544":"M","\u0545":"Y","\u0546":"N","\u0547":"SH","\u0549":"CH","\u054A":"P","\u054B":"J","\u054C":"R\'","\u054D":"S","\u054E":"V","\u054F":"T","\u0550":"R","\u0551":"C","\u0553":"P\'","\u0554":"Q\'","\u0555":"O\'\'","\u0556":"F","\u0587":"EV","\u0621":"a","\u0622":"aa","\u0623":"a","\u0624":"u","\u0625":"i","\u0626":"e","\u0627":"a","\u0628":"b","\u0629":"h","\u062A":"t","\u062B":"th","\u062C":"j","\u062D":"h","\u062E":"kh","\u062F":"d","\u0630":"th","\u0631":"r","\u0632":"z","\u0633":"s","\u0634":"sh","\u0635":"s","\u0636":"dh","\u0637":"t","\u0638":"z","\u0639":"a","\u063A":"gh","\u0641":"f","\u0642":"q","\u0643":"k","\u0644":"l","\u0645":"m","\u0646":"n","\u0647":"h","\u0648":"w","\u0649":"a","\u064A":"y","\u064B":"an","\u064C":"on","\u064D":"en","\u064E":"a","\u064F":"u","\u0650":"e","\u0652":"","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u067E":"p","\u0686":"ch","\u0698":"zh","\u06A9":"k","\u06AF":"g","\u06CC":"y","\u06F0":"0","\u06F1":"1","\u06F2":"2","\u06F3":"3","\u06F4":"4","\u06F5":"5","\u06F6":"6","\u06F7":"7","\u06F8":"8","\u06F9":"9","\u0E3F":"baht","\u10D0":"a","\u10D1":"b","\u10D2":"g","\u10D3":"d","\u10D4":"e","\u10D5":"v","\u10D6":"z","\u10D7":"t","\u10D8":"i","\u10D9":"k","\u10DA":"l","\u10DB":"m","\u10DC":"n","\u10DD":"o","\u10DE":"p","\u10DF":"zh","\u10E0":"r","\u10E1":"s","\u10E2":"t","\u10E3":"u","\u10E4":"f","\u10E5":"k","\u10E6":"gh","\u10E7":"q","\u10E8":"sh","\u10E9":"ch","\u10EA":"ts","\u10EB":"dz","\u10EC":"ts","\u10ED":"ch","\u10EE":"kh","\u10EF":"j","\u10F0":"h","\u1E62":"S","\u1E63":"s","\u1E80":"W","\u1E81":"w","\u1E82":"W","\u1E83":"w","\u1E84":"W","\u1E85":"w","\u1E9E":"SS","\u1EA0":"A","\u1EA1":"a","\u1EA2":"A","\u1EA3":"a","\u1EA4":"A","\u1EA5":"a","\u1EA6":"A","\u1EA7":"a","\u1EA8":"A","\u1EA9":"a","\u1EAA":"A","\u1EAB":"a","\u1EAC":"A","\u1EAD":"a","\u1EAE":"A","\u1EAF":"a","\u1EB0":"A","\u1EB1":"a","\u1EB2":"A","\u1EB3":"a","\u1EB4":"A","\u1EB5":"a","\u1EB6":"A","\u1EB7":"a","\u1EB8":"E","\u1EB9":"e","\u1EBA":"E","\u1EBB":"e","\u1EBC":"E","\u1EBD":"e","\u1EBE":"E","\u1EBF":"e","\u1EC0":"E","\u1EC1":"e","\u1EC2":"E","\u1EC3":"e","\u1EC4":"E","\u1EC5":"e","\u1EC6":"E","\u1EC7":"e","\u1EC8":"I","\u1EC9":"i","\u1ECA":"I","\u1ECB":"i","\u1ECC":"O","\u1ECD":"o","\u1ECE":"O","\u1ECF":"o","\u1ED0":"O","\u1ED1":"o","\u1ED2":"O","\u1ED3":"o","\u1ED4":"O","\u1ED5":"o","\u1ED6":"O","\u1ED7":"o","\u1ED8":"O","\u1ED9":"o","\u1EDA":"O","\u1EDB":"o","\u1EDC":"O","\u1EDD":"o","\u1EDE":"O","\u1EDF":"o","\u1EE0":"O","\u1EE1":"o","\u1EE2":"O","\u1EE3":"o","\u1EE4":"U","\u1EE5":"u","\u1EE6":"U","\u1EE7":"u","\u1EE8":"U","\u1EE9":"u","\u1EEA":"U","\u1EEB":"u","\u1EEC":"U","\u1EED":"u","\u1EEE":"U","\u1EEF":"u","\u1EF0":"U","\u1EF1":"u","\u1EF2":"Y","\u1EF3":"y","\u1EF4":"Y","\u1EF5":"y","\u1EF6":"Y","\u1EF7":"y","\u1EF8":"Y","\u1EF9":"y","\u2013":"-","\u2018":"\'","\u2019":"\'","\u201C":"\\"","\u201D":"\\"","\u201E":"\\"","\u2020":"+","\u2022":"*","\u2026":"...","\u20A0":"ecu","\u20A2":"cruzeiro","\u20A3":"french franc","\u20A4":"lira","\u20A5":"mill","\u20A6":"naira","\u20A7":"peseta","\u20A8":"rupee","\u20A9":"won","\u20AA":"new shequel","\u20AB":"dong","\u20AC":"euro","\u20AD":"kip","\u20AE":"tugrik","\u20AF":"drachma","\u20B0":"penny","\u20B1":"peso","\u20B2":"guarani","\u20B3":"austral","\u20B4":"hryvnia","\u20B5":"cedi","\u20B8":"kazakhstani tenge","\u20B9":"indian rupee","\u20BA":"turkish lira","\u20BD":"russian ruble","\u20BF":"bitcoin","\u2120":"sm","\u2122":"tm","\u2202":"d","\u2206":"delta","\u2211":"sum","\u221E":"infinity","\u2665":"love","\u5143":"yuan","\u5186":"yen","\uFDFC":"rial","\uFEF5":"laa","\uFEF7":"laa","\uFEF9":"lai","\uFEFB":"la"}');
    var locales = JSON.parse('{"bg":{"\u0419":"Y","\u0426":"Ts","\u0429":"Sht","\u042A":"A","\u042C":"Y","\u0439":"y","\u0446":"ts","\u0449":"sht","\u044A":"a","\u044C":"y"},"de":{"\xc4":"AE","\xe4":"ae","\xd6":"OE","\xf6":"oe","\xdc":"UE","\xfc":"ue","\xdf":"ss","%":"prozent","&":"und","|":"oder","\u2211":"summe","\u221E":"unendlich","\u2665":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","\xa2":"centavos","\xa3":"libras","\xa4":"moneda","\u20A3":"francos","\u2211":"suma","\u221E":"infinito","\u2665":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","\xa2":"centime","\xa3":"livre","\xa4":"devise","\u20A3":"franc","\u2211":"somme","\u221E":"infini","\u2665":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","\xa2":"centavo","\u2211":"soma","\xa3":"libra","\u221E":"infinito","\u2665":"amor"},"uk":{"\u0418":"Y","\u0438":"y","\u0419":"Y","\u0439":"y","\u0426":"Ts","\u0446":"ts","\u0425":"Kh","\u0445":"kh","\u0429":"Shch","\u0449":"shch","\u0413":"H","\u0433":"h"},"vi":{"\u0110":"D","\u0111":"d"},"da":{"\xd8":"OE","\xf8":"oe","\xc5":"AA","\xe5":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"st\xf8rre end"},"nb":{"&":"og","\xc5":"AA","\xc6":"AE","\xd8":"OE","\xe5":"aa","\xe6":"ae","\xf8":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","\xc5":"AA","\xc4":"AE","\xd6":"OE","\xe5":"aa","\xe4":"ae","\xf6":"oe"}}');
    function replace(string, options) {
        if (typeof string !== "string") throw new Error("slugify: string argument expected");
        options = typeof options === "string" ? {
            replacement: options
        } : options || {};
        var locale = locales[options.locale] || {};
        var replacement = options.replacement === undefined ? "-" : options.replacement;
        var trim = options.trim === undefined ? true : options.trim;
        var slug = string.normalize().split("")// replace characters based on charMap
        .reduce(function(result, ch) {
            var appendChar = locale[ch];
            if (appendChar === undefined) appendChar = charMap[ch];
            if (appendChar === undefined) appendChar = ch;
            if (appendChar === replacement) appendChar = " ";
            return result + appendChar// remove not allowed characters
            .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
        }, "");
        if (options.strict) slug = slug.replace(/[^A-Za-z0-9\s]/g, "");
        if (trim) slug = slug.trim();
        // Replace spaces with replacement character, treating multiple consecutive
        // spaces as a single space.
        slug = slug.replace(/\s+/g, replacement);
        if (options.lower) slug = slug.toLowerCase();
        return slug;
    }
    replace.extend = function(customMap) {
        Object.assign(charMap, customMap);
    };
    return replace;
});


function $ec5f57ce491b339b$export$640758d8e8e3d19e(el) {
    // In addition to the DOM's left and top offset properties, we also
    // account for CSS transforms, via the `matrix` object
    const style = window.getComputedStyle(el);
    const matrix = new DOMMatrixReadOnly(style.transform);
    return [
        el.offsetLeft + matrix.m41,
        el.offsetTop + matrix.m42
    ];
}
function $ec5f57ce491b339b$export$a92df11a83653854(el, includeScroll = false) {
    const pos = [
        0,
        0
    ];
    do {
        const [x, y] = $ec5f57ce491b339b$export$640758d8e8e3d19e(el);
        pos[0] += x;
        pos[1] += y;
        const parent = el.offsetParent;
        if (includeScroll && parent) {
            pos[0] -= parent.scrollLeft;
            pos[1] -= parent.scrollTop;
        }
        el = parent;
    }while (el); // eslint-disable-line @typescript-eslint/strict-boolean-expressions
    return pos;
}
function $ec5f57ce491b339b$export$bb4bab168f0533a8(slug) {
    if (slug === null || typeof slug === "undefined") return;
    // Remove certain replacements mapped by slugify
    (0, (/*@__PURE__*/$parcel$interopDefault($6a0542dba83ef44c$exports))).extend({
        "|": "",
        "%": "",
        $: ""
    });
    const slugified = (0, (/*@__PURE__*/$parcel$interopDefault($6a0542dba83ef44c$exports)))(slug, {
        replacement: "-",
        remove: /[*+=~.,<>(){}'"!?:;@#$%^&*|\\/[\]]/g,
        lower: true
    });
    // Remove any trailing or leading hyphens, which slugify doesn't clean up
    return slugified.replace(/^[-]+|[-]+$/g, "");
}
function $ec5f57ce491b339b$export$e3607ec2d7a891c4(el, props, duration) {
    const initialProps = Object.keys(props).reduce((acc, prop)=>{
        if (typeof el[prop] !== "undefined") acc[prop] = el[prop];
        else acc[prop] = 0;
        return acc;
    }, {});
    (0, $3b0883627b239985$exports.tween)({
        from: initialProps,
        to: props,
        duration: duration,
        render: (state)=>Object.assign(el, state)
    });
}
function $ec5f57ce491b339b$export$78234eee43b97e81(url) {
    // Based on is-url-external
    // @see: https://github.com/mrded/is-url-external
    const { hostname: hostname } = window.location;
    const urlHostname = function(url) {
        if (/^https?:\/\//.test(url)) {
            // Absolute URL
            // The easy way to parse an URL, is to create <a> element.
            // @see: https://gist.github.com/jlong/2428561
            const parser = document.createElement("a");
            parser.href = url;
            return parser.hostname;
        }
        // Relative URL
        return window.location.hostname;
    }(url);
    return hostname !== urlHostname;
}





const $4fd11a0514b0f864$export$d460bc3f6742cc13 = 1;
const $4fd11a0514b0f864$export$e446af77b1e2d289 = 2;
const $4fd11a0514b0f864$export$f3a5b4072e475415 = 3;


function $62b1ef0171009a7b$var$isInfoBubbleVisible() {
    return (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().infoBubble.visible;
}
const $62b1ef0171009a7b$export$8a66765a71c06fe6 = {
    hoverPolygon: null,
    segmentEl: null,
    type: null,
    considerMouseX: null,
    considerMouseY: null,
    considerSegmentEl: null,
    considerType: null,
    suppressed: false,
    suppressTimerId: -1,
    /**
   * Suppressing the infobubble momentarily hides it (if shown) and delays
   * opening it again for some amount of time.
   */ suppress: function() {
        if (!$62b1ef0171009a7b$export$8a66765a71c06fe6.suppressed) {
            $62b1ef0171009a7b$export$8a66765a71c06fe6.hide();
            $62b1ef0171009a7b$export$8a66765a71c06fe6.hideSegment(true);
            $62b1ef0171009a7b$export$8a66765a71c06fe6.suppressed = true;
        }
        window.clearTimeout($62b1ef0171009a7b$export$8a66765a71c06fe6.suppressTimerId);
        $62b1ef0171009a7b$export$8a66765a71c06fe6.suppressTimerId = window.setTimeout($62b1ef0171009a7b$export$8a66765a71c06fe6.unsuppress, 100);
    },
    unsuppress: function() {
        $62b1ef0171009a7b$export$8a66765a71c06fe6.suppressed = false;
        window.clearTimeout($62b1ef0171009a7b$export$8a66765a71c06fe6.suppressTimerId);
    },
    _withinHoverPolygon: function(x, y) {
        const hoverPolygon = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().infoBubble.hoverPolygon;
        return $62b1ef0171009a7b$var$_isPointInPoly(hoverPolygon, [
            x,
            y
        ]);
    },
    hideSegment: function(fast) {
        if ($62b1ef0171009a7b$export$8a66765a71c06fe6.segmentEl) {
            $62b1ef0171009a7b$export$8a66765a71c06fe6.segmentEl.classList.remove("hover");
            (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $cb9eeb171d537a5a$export$20b4b8898e0d9c76)(null));
            const el = $62b1ef0171009a7b$export$8a66765a71c06fe6.segmentEl;
            if (fast) {
                el.classList.add("immediate-show-drag-handles");
                window.setTimeout(function() {
                    el.classList.remove("immediate-show-drag-handles");
                }, 0);
            } else el.classList.remove("immediate-show-drag-handles");
            $62b1ef0171009a7b$export$8a66765a71c06fe6.segmentEl.classList.remove("show-drag-handles");
            $62b1ef0171009a7b$export$8a66765a71c06fe6.segmentEl = null;
        }
    },
    hide: function() {
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $d00d4a7cfa2eb020$export$7f56ba0a026268ef)());
    },
    /**
   * Determines whether to display the info bubble for a given segment.
   */ considerShowing: function(event, segmentEl, type) {
        // Bail under UI conditions where we shouldn't show the info bubble
        if (Boolean((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().menus) === true || (0, $9bf07f90c2c537c3$export$729c8b7179294ba).readOnly) return;
        // Bail if we are requesting the info bubble for the element already being displayed
        if (segmentEl === $62b1ef0171009a7b$export$8a66765a71c06fe6.segmentEl && type === $62b1ef0171009a7b$export$8a66765a71c06fe6.type) return;
        if (event) {
            $62b1ef0171009a7b$export$8a66765a71c06fe6.considerMouseX = event.pageX;
            $62b1ef0171009a7b$export$8a66765a71c06fe6.considerMouseY = event.pageY;
        } else {
            const pos = (0, $ec5f57ce491b339b$export$a92df11a83653854)(segmentEl);
            $62b1ef0171009a7b$export$8a66765a71c06fe6.considerMouseX = pos[0] - document.querySelector("#street-section-outer").scrollLeft;
            $62b1ef0171009a7b$export$8a66765a71c06fe6.considerMouseY = pos[1];
        }
        $62b1ef0171009a7b$export$8a66765a71c06fe6.considerSegmentEl = segmentEl;
        $62b1ef0171009a7b$export$8a66765a71c06fe6.considerType = type;
        if (!$62b1ef0171009a7b$var$isInfoBubbleVisible() || !$62b1ef0171009a7b$export$8a66765a71c06fe6._withinHoverPolygon($62b1ef0171009a7b$export$8a66765a71c06fe6.considerMouseX, $62b1ef0171009a7b$export$8a66765a71c06fe6.considerMouseY)) $62b1ef0171009a7b$export$8a66765a71c06fe6.show(false);
    },
    dontConsiderShowing: function() {
        $62b1ef0171009a7b$export$8a66765a71c06fe6.considerSegmentEl = null;
        $62b1ef0171009a7b$export$8a66765a71c06fe6.considerType = null;
    },
    // TODO rename
    show: function(force) {
        if ($62b1ef0171009a7b$export$8a66765a71c06fe6.suppressed) {
            window.setTimeout($62b1ef0171009a7b$export$8a66765a71c06fe6.show, 100);
            return;
        }
        if ((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().ui.draggingType !== (0, $e1cc3cddc7acf1a4$export$5ed14aee9e214d04)) return;
        if (!$62b1ef0171009a7b$export$8a66765a71c06fe6.considerType) {
            $62b1ef0171009a7b$export$8a66765a71c06fe6.hide();
            $62b1ef0171009a7b$export$8a66765a71c06fe6.hideSegment(false);
            return;
        }
        const segmentEl = $62b1ef0171009a7b$export$8a66765a71c06fe6.considerSegmentEl;
        const type = $62b1ef0171009a7b$export$8a66765a71c06fe6.considerType;
        if (segmentEl === $62b1ef0171009a7b$export$8a66765a71c06fe6.segmentEl && type === $62b1ef0171009a7b$export$8a66765a71c06fe6.type && !force) return;
        $62b1ef0171009a7b$export$8a66765a71c06fe6.hideSegment(true);
        $62b1ef0171009a7b$export$8a66765a71c06fe6.segmentEl = segmentEl;
        $62b1ef0171009a7b$export$8a66765a71c06fe6.type = type;
        if (type !== (0, $4fd11a0514b0f864$export$e446af77b1e2d289) && type !== (0, $4fd11a0514b0f864$export$f3a5b4072e475415)) {
            if (segmentEl) {
                segmentEl.classList.add("hover");
                segmentEl.classList.add("show-drag-handles");
            }
            if ($62b1ef0171009a7b$var$isInfoBubbleVisible()) segmentEl.classList.add("immediate-show-drag-handles");
        }
        let dataNo = segmentEl.dataNo;
        if (typeof dataNo === "undefined") dataNo = type === (0, $4fd11a0514b0f864$export$e446af77b1e2d289) ? (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd) : (0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492);
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $cb9eeb171d537a5a$export$20b4b8898e0d9c76)(dataNo));
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $d00d4a7cfa2eb020$export$66b6779e6c2fa2a)());
    }
};
function $62b1ef0171009a7b$var$_isPointInPoly(vs = [], point) {
    const x = point[0];
    const y = point[1];
    let inside = false;
    for(let i = 0, j = vs.length - 1; i < vs.length; j = i++){
        const xi = vs[i][0];
        const yi = vs[i][1];
        const xj = vs[j][0];
        const yj = vs[j][1];
        // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}




const $c098fdb90228b950$export$c9756beb4aae2c8d = 1;
const $c098fdb90228b950$export$95a57d0e83881bf = 2;
















function $5bb3a44e0e01d545$export$29ee64aa80b9fa13() {
    return (0, $5824ec4f3474e945$export$ac4959f4f1338dfc)();
}







const $b6e16a46f37cea3c$export$5b9bdfc897c11cc2 = {
    segmentEl: null,
    floatingEl: null,
    mouseX: null,
    mouseY: null,
    elX: null,
    elY: null,
    width: null,
    originalX: null,
    originalWidth: null,
    right: false
};
let $b6e16a46f37cea3c$var$__BUGFIX_SUPPRESS_WRONG_MOUSEENTER_HANDLER = false;
function $b6e16a46f37cea3c$export$4883359709ecef8e() {
    $b6e16a46f37cea3c$var$__BUGFIX_SUPPRESS_WRONG_MOUSEENTER_HANDLER = false;
}
function $b6e16a46f37cea3c$export$3663c9a87c5e8e0() {
    return $b6e16a46f37cea3c$var$__BUGFIX_SUPPRESS_WRONG_MOUSEENTER_HANDLER;
}
function $b6e16a46f37cea3c$export$5934e6aec88f0d99() {
    const select = (state)=>state.ui.draggingType;
    const onChange = (draggingType)=>{
        document.body.classList.remove("segment-move-dragging");
        document.body.classList.remove("segment-resize-dragging");
        switch(draggingType){
            case 0, $e1cc3cddc7acf1a4$export$e9db4516ea26d802:
                document.body.classList.add("segment-resize-dragging");
                break;
            case 0, $e1cc3cddc7acf1a4$export$78a78b4ad4d2f0b9:
                document.body.classList.add("segment-move-dragging");
                break;
        }
    };
    return (0, $81878321270eabd6$export$7eabfc5ef2a68f64)(select, onChange);
}
function $b6e16a46f37cea3c$var$handleSegmentResizeStart(event) {
    let x, y;
    if ((0, $9bf07f90c2c537c3$export$729c8b7179294ba).readOnly) return;
    if (event.touches && event.touches[0]) {
        x = event.touches[0].pageX;
        y = event.touches[0].pageY;
    } else {
        x = event.pageX;
        y = event.pageY;
    }
    (0, $8d9791e5769125e5$export$996926525e13f61e)(true);
    const el = event.target.closest(".drag-handle");
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $cb9eeb171d537a5a$export$762b34a064c02e3b)((0, $e1cc3cddc7acf1a4$export$e9db4516ea26d802)));
    const pos = (0, $ec5f57ce491b339b$export$a92df11a83653854)(el);
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.right = el.classList.contains("drag-handle-right");
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.floatingEl = document.createElement("div");
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.floatingEl.classList.add("drag-handle");
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.floatingEl.classList.add("floating");
    if (el.classList.contains("drag-handle-left")) $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.floatingEl.classList.add("drag-handle-left");
    else $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.floatingEl.classList.add("drag-handle-right");
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.floatingEl.style.left = pos[0] - document.querySelector("#street-section-outer").scrollLeft + "px";
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.floatingEl.style.top = pos[1] + "px";
    document.body.appendChild($b6e16a46f37cea3c$export$5b9bdfc897c11cc2.floatingEl);
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.mouseX = x;
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.mouseY = y;
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.elX = pos[0];
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.elY = pos[1];
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.originalX = $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.elX;
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.originalWidth = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street.segments[el.parentNode.dataNo].width;
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.segmentEl = el.parentNode;
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.segmentEl.classList.add("hover");
    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hide();
    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hideSegment(true);
    (0, $edbb716917ec500c$export$10edf1ecc36bc190)();
    window.setTimeout(function() {
        $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.segmentEl.classList.add("hover");
    }, 0);
}
function $b6e16a46f37cea3c$var$handleSegmentResizeMove(event) {
    let x, y, resizeType;
    if (event.touches && event.touches[0]) {
        x = event.touches[0].pageX;
        y = event.touches[0].pageY;
    } else {
        x = event.pageX;
        y = event.pageY;
    }
    const deltaX = x - $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.mouseX;
    let deltaFromOriginal = $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.elX - $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.originalX;
    if (!$b6e16a46f37cea3c$export$5b9bdfc897c11cc2.right) deltaFromOriginal = -deltaFromOriginal;
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.width = $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.originalWidth + deltaFromOriginal / (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * 2;
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.elX += deltaX;
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.floatingEl.style.left = $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.elX - document.querySelector("#street-section-outer").scrollLeft + "px";
    const precise = event.shiftKey;
    if (precise) resizeType = (0, $edbb716917ec500c$export$824fe03c7a14ac41);
    else resizeType = (0, $edbb716917ec500c$export$4e57158d36b8042);
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.width = (0, $edbb716917ec500c$export$825f60ee61d83e5f)($b6e16a46f37cea3c$export$5b9bdfc897c11cc2.segmentEl.dataNo, resizeType, $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.width);
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.mouseX = x;
    $b6e16a46f37cea3c$export$5b9bdfc897c11cc2.mouseY = y;
}
function $b6e16a46f37cea3c$export$3b58b8d35cad22b9(event) {
    if ((0, $9bf07f90c2c537c3$export$729c8b7179294ba).readOnly || event.touches && event.touches.length !== 1) return;
    if (event.target.closest(".drag-handle")) {
        $b6e16a46f37cea3c$var$handleSegmentResizeStart(event);
        event.preventDefault();
    }
}
function $b6e16a46f37cea3c$export$f964eeba1b6307d(event, canvasEl) {
    const { remainingWidth: remainingWidth } = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    let x, y;
    if (event.touches && event.touches[0]) {
        x = event.touches[0].pageX;
        y = event.touches[0].pageY;
    } else {
        x = event.x;
        y = event.y;
    }
    const { top: top, bottom: bottom, left: left, right: right } = canvasEl.getBoundingClientRect();
    const withinCanvasY = y >= top && y <= bottom;
    let withinCanvasX = x >= left && x <= right;
    if (!withinCanvasX && remainingWidth < 0) {
        const margin = remainingWidth * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) / 2;
        const newLeft = left + margin - (0, $e1cc3cddc7acf1a4$export$f5d69cc55972365c);
        const newRight = right - margin + (0, $e1cc3cddc7acf1a4$export$f5d69cc55972365c);
        withinCanvasX = x >= newLeft && x <= newRight;
    }
    const withinCanvas = withinCanvasX && withinCanvasY;
    if ($b6e16a46f37cea3c$var$oldDraggingState) $b6e16a46f37cea3c$var$oldDraggingState.withinCanvas = withinCanvas;
    return withinCanvas;
}
function $b6e16a46f37cea3c$export$78da0617e7531321(event) {
    const { draggingType: draggingType } = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().ui;
    if (draggingType === (0, $e1cc3cddc7acf1a4$export$5ed14aee9e214d04)) return;
    else if (draggingType === (0, $e1cc3cddc7acf1a4$export$e9db4516ea26d802)) $b6e16a46f37cea3c$var$handleSegmentResizeMove(event);
    event.preventDefault();
}
function $b6e16a46f37cea3c$var$doDropHeuristics(draggedItem, draggedItemType) {
    // Automatically figure out width
    const street = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    const { variantString: variantString, type: type, actualWidth: actualWidth } = draggedItem;
    if (draggedItemType === $b6e16a46f37cea3c$export$4624c240901a6889.PALETTE_SEGMENT) {
        if (street.remainingWidth > 0 && actualWidth > street.remainingWidth) {
            const segmentMinWidth = (0, $0cc5ae9f1eba4866$export$a7e4a724089e6511)(type, variantString).minWidth || 0;
            if (street.remainingWidth >= (0, $e1cc3cddc7acf1a4$export$256c1c4ce479d4eb) && street.remainingWidth >= segmentMinWidth) draggedItem.actualWidth = (0, $edbb716917ec500c$export$e06f682fb9edb199)(street.remainingWidth, (0, $edbb716917ec500c$export$12e0a54c23e0f7be)((0, $edbb716917ec500c$export$bef0bdcd5a467cae), street.units));
        }
    }
    // Automatically figure out variants
    const { segmentBeforeEl: segmentBeforeEl, segmentAfterEl: segmentAfterEl } = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().ui.draggingState;
    const left = segmentAfterEl !== undefined ? street.segments[segmentAfterEl] : null;
    const right = segmentBeforeEl !== undefined ? street.segments[segmentBeforeEl] : null;
    const leftOwner = left && (0, $0cc5ae9f1eba4866$export$fca129adbb061794)[(0, $0cc5ae9f1eba4866$export$c3985e6b9763d4c2)(left.type).owner];
    const rightOwner = right && (0, $0cc5ae9f1eba4866$export$fca129adbb061794)[(0, $0cc5ae9f1eba4866$export$c3985e6b9763d4c2)(right.type).owner];
    const leftOwnerAsphalt = leftOwner === (0, $0cc5ae9f1eba4866$export$fca129adbb061794).CAR || leftOwner === (0, $0cc5ae9f1eba4866$export$fca129adbb061794).BIKE || leftOwner === (0, $0cc5ae9f1eba4866$export$fca129adbb061794).TRANSIT;
    const rightOwnerAsphalt = rightOwner === (0, $0cc5ae9f1eba4866$export$fca129adbb061794).CAR || rightOwner === (0, $0cc5ae9f1eba4866$export$fca129adbb061794).BIKE || rightOwner === (0, $0cc5ae9f1eba4866$export$fca129adbb061794).TRANSIT;
    const leftVariant = left && (0, $f22063bb59944341$export$4ad6a18860f0a250)(left.type, left.variantString);
    const rightVariant = right && (0, $f22063bb59944341$export$4ad6a18860f0a250)(right.type, right.variantString);
    const variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(type, variantString);
    const segmentInfo = (0, $0cc5ae9f1eba4866$export$c3985e6b9763d4c2)(type);
    // Direction
    if (segmentInfo.variants.indexOf("direction") !== -1) {
        if (leftVariant && leftVariant.direction) variant.direction = leftVariant.direction;
        else if (rightVariant && rightVariant.direction) variant.direction = rightVariant.direction;
    }
    // Parking lane orientation
    if (segmentInfo.variants.indexOf("parking-lane-orientation") !== -1) {
        if (!right || !rightOwnerAsphalt) variant["parking-lane-orientation"] = "right";
        else if (!left || !leftOwnerAsphalt) variant["parking-lane-orientation"] = "left";
    }
    // Parklet orientation
    if (type === "parklet") {
        if (left && leftOwnerAsphalt) variant.orientation = "right";
        else if (right && rightOwnerAsphalt) variant.orientation = "left";
    }
    // Turn lane orientation
    if (segmentInfo.variants.indexOf("turn-lane-orientation") !== -1) {
        if (!right || !rightOwnerAsphalt) variant["turn-lane-orientation"] = "right";
        else if (!left || !leftOwnerAsphalt) variant["turn-lane-orientation"] = "left";
    }
    // Transit shelter orientation and elevation
    if (type === "transit-shelter") {
        if (left && leftOwner === (0, $0cc5ae9f1eba4866$export$fca129adbb061794).TRANSIT) variant.orientation = "right";
        else if (right && rightOwner === (0, $0cc5ae9f1eba4866$export$fca129adbb061794).TRANSIT) variant.orientation = "left";
    }
    if (segmentInfo.variants.indexOf("transit-shelter-elevation") !== -1) {
        if (variant.orientation === "right" && left && left.type === "light-rail") variant["transit-shelter-elevation"] = "light-rail";
        else if (variant.orientation === "left" && right && right.type === "light-rail") variant["transit-shelter-elevation"] = "light-rail";
    }
    // BRT station orientation
    if (type === "brt-station") {
        // Default orientation is center
        variant["brt-station-orientation"] = "center";
        if (left && leftOwner === (0, $0cc5ae9f1eba4866$export$fca129adbb061794).TRANSIT) variant["brt-station-orientation"] = "right";
        else if (right && rightOwner === (0, $0cc5ae9f1eba4866$export$fca129adbb061794).TRANSIT) variant["brt-station-orientation"] = "left";
    }
    // Bike rack orientation
    if (type === "sidewalk-bike-rack") {
        if (left && leftOwner !== (0, $0cc5ae9f1eba4866$export$fca129adbb061794).PEDESTRIAN) variant.orientation = "left";
        else if (right && rightOwner !== (0, $0cc5ae9f1eba4866$export$fca129adbb061794).PEDESTRIAN) variant.orientation = "right";
    }
    // Lamp orientation
    if (segmentInfo.variants.indexOf("lamp-orientation") !== -1) {
        if (left && right && leftOwnerAsphalt && rightOwnerAsphalt) variant["lamp-orientation"] = "both";
        else if (left && leftOwnerAsphalt) variant["lamp-orientation"] = "left";
        else if (right && rightOwnerAsphalt) variant["lamp-orientation"] = "right";
        else if (left && right) variant["lamp-orientation"] = "both";
        else if (left) variant["lamp-orientation"] = "left";
        else if (right) variant["lamp-orientation"] = "right";
        else variant["lamp-orientation"] = "both";
    }
    draggedItem.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
}
function $b6e16a46f37cea3c$export$ca543ff484c1cc6d(event) {
    const { draggingType: draggingType } = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().ui;
    switch(draggingType){
        case 0, $e1cc3cddc7acf1a4$export$5ed14aee9e214d04:
            return;
        case 0, $e1cc3cddc7acf1a4$export$e9db4516ea26d802:
            (0, $edbb716917ec500c$export$b1a25f75617446a5)(event);
            break;
    }
    event.preventDefault();
}
function $b6e16a46f37cea3c$var$handleSegmentDragStart() {
    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hide();
    (0, $edbb716917ec500c$export$10edf1ecc36bc190)();
}
function $b6e16a46f37cea3c$var$handleSegmentDragEnd() {
    $b6e16a46f37cea3c$var$oldDraggingState = null;
    (0, $edbb716917ec500c$export$3058040811eebf87)();
    (0, $2f44915f6f87dcf5$export$b2eeaeff46616de5)(false);
    document.body.classList.remove("not-within-canvas");
}
const $b6e16a46f37cea3c$export$4624c240901a6889 = {
    SEGMENT: "SEGMENT",
    PALETTE_SEGMENT: "PALETTE_SEGMENT"
};
const $b6e16a46f37cea3c$export$980f51409408fd87 = {
    canDrag (props) {
        return !(0, $81878321270eabd6$export$2e2bcd8739ae039).getState().app.readOnly;
    },
    isDragging (props, monitor) {
        return monitor.getItem().id === props.segment.id;
    },
    beginDrag (props, monitor, component) {
        $b6e16a46f37cea3c$var$handleSegmentDragStart();
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $cb9eeb171d537a5a$export$762b34a064c02e3b)((0, $e1cc3cddc7acf1a4$export$78a78b4ad4d2f0b9)));
        return {
            id: props.segment.id,
            dataNo: props.dataNo,
            variantString: props.segment.variantString,
            type: props.segment.type,
            label: props.segment.label,
            actualWidth: props.segment.width,
            elevation: props.segment.elevation
        };
    },
    endDrag (props, monitor, component) {
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $cb9eeb171d537a5a$export$df5412d804d98b77)());
        if (!monitor.didDrop()) {
            // if no object returned by a drop handler, check if it is still within the canvas
            const withinCanvas = $b6e16a46f37cea3c$var$oldDraggingState && $b6e16a46f37cea3c$var$oldDraggingState.withinCanvas;
            if (withinCanvas) $b6e16a46f37cea3c$var$handleSegmentCanvasDrop(monitor.getItem(), monitor.getItemType());
            else if (monitor.getItemType() === $b6e16a46f37cea3c$export$4624c240901a6889.SEGMENT) // if existing segment is dropped outside canvas, delete it
            (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$d0365e48b58231c3)(props.dataNo));
        }
        $b6e16a46f37cea3c$var$handleSegmentDragEnd();
    }
};
const $b6e16a46f37cea3c$export$26ee54c509c9c33 = {
    canDrag (props) {
        return !(0, $81878321270eabd6$export$2e2bcd8739ae039).getState().app.readOnly;
    },
    beginDrag (props, monitor, component) {
        $b6e16a46f37cea3c$var$handleSegmentDragStart();
        // Initialize an empty draggingState object in Redux for palette segments
        // in order to add event listener in StreetEditable once dragging begins.
        // Also set the dragging type to MOVE. We use one action creator here and
        // one dispatch to reduce batch renders.
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $cb9eeb171d537a5a$export$cb642e0702fc5c43)((0, $e1cc3cddc7acf1a4$export$78a78b4ad4d2f0b9)));
        const type = props.segment.id;
        // The preview drag should match artwork in the thumbnail. The variant
        // string is specified by `defaultVariant`. If the property isn't present,
        // use the first defined variant in segment details.
        const variantString = props.segment.defaultVariant || Object.keys(props.segment.details).shift();
        // This allows dropped segment to be created with the correct elevation value
        let elevation = 0;
        if (props.segment.defaultElevation !== undefined) elevation = props.segment.defaultElevation;
        else {
            const variantInfo = (0, $0cc5ae9f1eba4866$export$a7e4a724089e6511)(type, variantString);
            elevation = variantInfo.elevation;
        }
        return {
            id: (0, $5bb3a44e0e01d545$export$29ee64aa80b9fa13)(),
            type: type,
            variantString: variantString,
            actualWidth: props.segment.defaultWidth,
            elevation: elevation
        };
    },
    endDrag (props, monitor, component) {
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $cb9eeb171d537a5a$export$df5412d804d98b77)());
        const withinCanvas = $b6e16a46f37cea3c$var$oldDraggingState?.withinCanvas;
        if (!monitor.didDrop() && withinCanvas) $b6e16a46f37cea3c$var$handleSegmentCanvasDrop(monitor.getItem(), monitor.getItemType());
        $b6e16a46f37cea3c$var$handleSegmentDragEnd();
    }
};
function $b6e16a46f37cea3c$export$547f4e518ca74a90(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging()
    };
}
function $b6e16a46f37cea3c$export$7cfc0c87baff46a6(dataNo, draggingState) {
    const { segmentBeforeEl: segmentBeforeEl, segmentAfterEl: segmentAfterEl } = draggingState;
    let spaceBetweenSegments = 0;
    if (dataNo >= segmentBeforeEl) {
        spaceBetweenSegments += (0, $e1cc3cddc7acf1a4$export$f5d69cc55972365c);
        if (segmentAfterEl === undefined) spaceBetweenSegments += (0, $e1cc3cddc7acf1a4$export$f5d69cc55972365c);
    }
    if (dataNo > segmentAfterEl) {
        spaceBetweenSegments += (0, $e1cc3cddc7acf1a4$export$f5d69cc55972365c);
        if (segmentBeforeEl === undefined) spaceBetweenSegments += (0, $e1cc3cddc7acf1a4$export$f5d69cc55972365c);
    }
    return spaceBetweenSegments;
}
let $b6e16a46f37cea3c$var$oldDraggingState;
// Checks to see if Redux dragging state needs to be updated, and if so, dispatches action.
// This prevents a constant dispatch of the updateDraggingState action which causes the
// dragging of the segment to be laggy and choppy.
function $b6e16a46f37cea3c$var$updateIfDraggingStateChanged(segmentBeforeEl, segmentAfterEl, draggedItem, draggedItemType) {
    let changed = false;
    if ($b6e16a46f37cea3c$var$oldDraggingState) changed = segmentBeforeEl !== $b6e16a46f37cea3c$var$oldDraggingState.segmentBeforeEl || segmentAfterEl !== $b6e16a46f37cea3c$var$oldDraggingState.segmentAfterEl || draggedItem.dataNo !== $b6e16a46f37cea3c$var$oldDraggingState.draggedSegment;
    else changed = true;
    if (changed) {
        $b6e16a46f37cea3c$var$oldDraggingState = {
            segmentBeforeEl: segmentBeforeEl,
            segmentAfterEl: segmentAfterEl,
            draggedSegment: draggedItem.dataNo
        };
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $cb9eeb171d537a5a$export$ba0bd4c7b78378ac)({
            segmentBeforeEl: segmentBeforeEl,
            segmentAfterEl: segmentAfterEl,
            draggedSegment: draggedItem.dataNo
        }));
        $b6e16a46f37cea3c$var$doDropHeuristics(draggedItem, draggedItemType);
    }
    return changed;
}
const $b6e16a46f37cea3c$export$c1a15083e52d3549 = {
    canDrop (props, monitor) {
        const type = monitor.getItemType();
        return type === $b6e16a46f37cea3c$export$4624c240901a6889.SEGMENT || type === $b6e16a46f37cea3c$export$4624c240901a6889.PALETTE_SEGMENT;
    },
    hover (props, monitor, component) {
        if (!monitor.canDrop()) return;
        const dragIndex = monitor.getItem().dataNo;
        const hoverIndex = props.dataNo;
        const hoveredSegment = component.streetSegment;
        const { left: left } = hoveredSegment.getBoundingClientRect();
        const hoverMiddleX = Math.round(left + props.actualWidth * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) / 2);
        const { x: x } = monitor.getClientOffset();
        // Ignore hovering over the dragged segment after dragging state is already set.
        // This prevents react-dnd's hover method from being confused on what to update
        // draggingState as when the dragged segment is behind another segment.
        if (dragIndex === hoverIndex && $b6e16a46f37cea3c$var$oldDraggingState) return;
        if (dragIndex === hoverIndex) $b6e16a46f37cea3c$var$updateIfDraggingStateChanged(dragIndex, undefined, monitor.getItem(), monitor.getItemType());
        else {
            const { segments: segments } = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
            const segmentBeforeEl = x > hoverMiddleX && hoverIndex !== segments.length - 1 ? hoverIndex + 1 : hoverIndex === segments.length - 1 ? undefined : hoverIndex;
            const segmentAfterEl = x > hoverMiddleX && hoverIndex !== 0 ? hoverIndex : hoverIndex === 0 ? undefined : hoverIndex - 1;
            $b6e16a46f37cea3c$var$updateIfDraggingStateChanged(segmentBeforeEl, segmentAfterEl, monitor.getItem(), monitor.getItemType());
        }
    }
};
function $b6e16a46f37cea3c$var$handleSegmentCanvasDrop(draggedItem, type) {
    // `oldDraggingState` can be `null` or undefined, if so, bail
    if (!$b6e16a46f37cea3c$var$oldDraggingState) return;
    const { segmentBeforeEl: segmentBeforeEl, segmentAfterEl: segmentAfterEl, draggedSegment: draggedSegment } = $b6e16a46f37cea3c$var$oldDraggingState;
    // If dropped in same position as dragged segment was before, return
    if (segmentBeforeEl === draggedSegment && segmentAfterEl === undefined) {
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $cb9eeb171d537a5a$export$20b4b8898e0d9c76)(draggedSegment));
        return;
    }
    const newSegment = {
        id: draggedItem.id ?? (0, $5824ec4f3474e945$export$ac4959f4f1338dfc)(),
        type: draggedItem.type,
        variantString: draggedItem.variantString,
        width: draggedItem.actualWidth,
        elevation: draggedItem.elevation,
        label: draggedItem.label
    };
    newSegment.variant = draggedItem.variant || (0, $f22063bb59944341$export$4ad6a18860f0a250)(newSegment.type, newSegment.variantString);
    let newIndex = segmentAfterEl !== undefined ? segmentAfterEl + 1 : segmentBeforeEl;
    if (type === $b6e16a46f37cea3c$export$4624c240901a6889.SEGMENT) {
        newIndex = newIndex <= draggedSegment ? newIndex : newIndex - 1;
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$55ccf7f86f8c547)(draggedSegment, newIndex));
        // Immediately after a segment move action, react-dnd can incorrectly trigger
        // the onMouseEnter handler on another <Segment /> component that is in the
        // previous component's location. This sets a variable which <Segment /> uses
        // to suppress a single instance of the onMouseEnter handler. The bug is tracked here
        // (https://github.com/streetmix/streetmix/pull/1262) and here (https://github.com/react-dnd/react-dnd/issues/1102).
        $b6e16a46f37cea3c$var$__BUGFIX_SUPPRESS_WRONG_MOUSEENTER_HANDLER = true;
    } else (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$1c43f9ac826b6462)(newIndex, newSegment));
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $cb9eeb171d537a5a$export$20b4b8898e0d9c76)(newIndex));
}
/**
 * Determines if segment was dropped/hovered on left or right side of street
 *
 * @param {Node} segment - reference to StreetEditable
 * @param {Number} droppedPosition - x position of dropped segment in reference
 *    to StreetEditable
 * @returns {string} - left, right, or null if dropped/hovered over a segment
 */ function $b6e16a46f37cea3c$var$isOverLeftOrRightCanvas(segment, droppedPosition) {
    const { remainingWidth: remainingWidth } = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    const { left: left, right: right } = segment.getBoundingClientRect();
    const emptySegmentWidth = remainingWidth * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) / 2;
    return droppedPosition < left + emptySegmentWidth ? "left" : droppedPosition > right - emptySegmentWidth ? "right" : null;
}
const $b6e16a46f37cea3c$export$ab49c599a2b7246 = {
    hover (props, monitor, component) {
        if (!monitor.canDrop()) return;
        if (monitor.isOver({
            shallow: true
        })) {
            const position = $b6e16a46f37cea3c$var$isOverLeftOrRightCanvas(component.streetSectionEditable, monitor.getClientOffset().x);
            if (!position) return;
            const { segments: segments } = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
            const segmentBeforeEl = position === "left" ? 0 : undefined;
            const segmentAfterEl = position === "left" ? undefined : segments.length - 1;
            $b6e16a46f37cea3c$var$updateIfDraggingStateChanged(segmentBeforeEl, segmentAfterEl, monitor.getItem(), monitor.getItemType());
        }
    },
    drop (props, monitor, component) {
        const draggedItem = monitor.getItem();
        const draggedItemType = monitor.getItemType();
        $b6e16a46f37cea3c$var$handleSegmentCanvasDrop(draggedItem, draggedItemType);
        return {
            withinCanvas: true
        };
    }
};
function $b6e16a46f37cea3c$export$24f60742cb520ad4(connect, monitor) {
    return {
        connectDropTarget: connect.dropTarget()
    };
}


const $edbb716917ec500c$var$SHORT_DELAY = 100;
const $edbb716917ec500c$export$bef0bdcd5a467cae = 0;
const $edbb716917ec500c$export$fb22fa3ad2794469 = 1;
const $edbb716917ec500c$export$4e57158d36b8042 = 2;
const $edbb716917ec500c$export$824fe03c7a14ac41 = 3;
const $edbb716917ec500c$export$56609dbdc016f0b0 = 4;
const $edbb716917ec500c$var$NORMALIZE_PRECISION = 5;
function $edbb716917ec500c$export$825f60ee61d83e5f(dataNo, resizeType, width, units) {
    // @TODO: don't read state for units; this is a temp kludge because the drag resizing
    // handler doesn't currently have access to the units. So if it's not provided, grab it
    // from state
    const resolution = $edbb716917ec500c$export$12e0a54c23e0f7be(resizeType, units || (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street.units);
    width = $edbb716917ec500c$export$e06f682fb9edb199(width, resolution);
    $edbb716917ec500c$export$3058040811eebf87();
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$e370ec602acb2164)(dataNo, width));
    (0, $2f44915f6f87dcf5$export$b2eeaeff46616de5)();
    return width;
}
function $edbb716917ec500c$export$70024803e1355933() {
    $edbb716917ec500c$export$825f60ee61d83e5f((0, $b6e16a46f37cea3c$export$5b9bdfc897c11cc2).segmentEl.dataNo, $edbb716917ec500c$export$bef0bdcd5a467cae, (0, $b6e16a46f37cea3c$export$5b9bdfc897c11cc2).originalWidth);
    $edbb716917ec500c$export$b1a25f75617446a5();
}
function $edbb716917ec500c$export$3686c0f8435095fd(canvasRef, streetOuterRef, dontDelay = false) {
    const streetSectionCanvas = canvasRef || document.querySelector("#street-section-canvas");
    const streetSectionOuter = streetOuterRef || document.querySelector("#street-section-outer");
    const prevMargin = Number.parseInt(streetSectionCanvas.style.marginLeft, 10) || (0, $e1cc3cddc7acf1a4$export$8b837123dd5f6a79);
    const { remainingWidth: remainingWidth } = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    let streetMargin = Math.round(-remainingWidth * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) / 2);
    if (!streetMargin || streetMargin < (0, $e1cc3cddc7acf1a4$export$8b837123dd5f6a79)) streetMargin = (0, $e1cc3cddc7acf1a4$export$8b837123dd5f6a79);
    const deltaMargin = streetMargin - prevMargin;
    if (!deltaMargin) return false;
    const maxScrollLeft = streetSectionOuter.scrollWidth - streetSectionOuter.clientWidth;
    // When scrolled all the way to right and decreasing occupiedWidth, an empty strip
    // of space is shown briefly before being scrolled if updating streetMargin.
    // When scrolled all the way to left and decreasing occupiedWidth, cannot update
    // scrollLeft to keep current segments in view (scrollLeft = 0)
    // Current solution is to delay updating margin until street is not scrolled all
    // the way to right or all the way to left or viewport was resized.
    const delayUpdate = !dontDelay && deltaMargin < 0 && (Math.abs(deltaMargin) > streetSectionOuter.scrollLeft || streetSectionOuter.scrollLeft === maxScrollLeft);
    if (!delayUpdate) {
        streetSectionCanvas.style.marginLeft = streetMargin + 25 + "px";
        streetSectionCanvas.style.marginRight = streetMargin + 25 + "px";
    }
    return !delayUpdate;
}
function $edbb716917ec500c$export$b1a25f75617446a5(event) {
    (0, $8d9791e5769125e5$export$996926525e13f61e)(false);
    $edbb716917ec500c$export$3686c0f8435095fd();
    (0, $2f44915f6f87dcf5$export$b2eeaeff46616de5)();
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $cb9eeb171d537a5a$export$762b34a064c02e3b)((0, $e1cc3cddc7acf1a4$export$5ed14aee9e214d04)));
    const el = (0, $b6e16a46f37cea3c$export$5b9bdfc897c11cc2).floatingEl;
    el.remove();
    (0, $b6e16a46f37cea3c$export$5b9bdfc897c11cc2).segmentEl.classList.add("immediate-show-drag-handles");
    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).considerSegmentEl = (0, $b6e16a46f37cea3c$export$5b9bdfc897c11cc2).segmentEl;
    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).show(false);
    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).considerShowing(event, (0, $b6e16a46f37cea3c$export$5b9bdfc897c11cc2).segmentEl, (0, $4fd11a0514b0f864$export$d460bc3f6742cc13));
}
function $edbb716917ec500c$export$7828ec063292032d(units) {
    if (units === (0, $c098fdb90228b950$export$c9756beb4aae2c8d)) return 0, $e1cc3cddc7acf1a4$export$c7ef544a1adca2d6;
    return 0, $e1cc3cddc7acf1a4$export$b2b225ef5ec57165;
}
function $edbb716917ec500c$export$aef8954b4bff46a2(units) {
    if (units === (0, $c098fdb90228b950$export$c9756beb4aae2c8d)) return 0, $e1cc3cddc7acf1a4$export$474261edb3c0b6ca;
    return 0, $e1cc3cddc7acf1a4$export$fa164b74c4a93529;
}
function $edbb716917ec500c$export$3062d9efefbcf045(units) {
    if (units === (0, $c098fdb90228b950$export$c9756beb4aae2c8d)) return 0, $e1cc3cddc7acf1a4$export$dbafd772cd28647;
    return 0, $e1cc3cddc7acf1a4$export$89f47eebe5aba3a7;
}
function $edbb716917ec500c$export$12e0a54c23e0f7be(resizeType, units) {
    switch(resizeType){
        case $edbb716917ec500c$export$bef0bdcd5a467cae:
        case $edbb716917ec500c$export$56609dbdc016f0b0:
        case $edbb716917ec500c$export$824fe03c7a14ac41:
            return $edbb716917ec500c$export$7828ec063292032d(units);
        case $edbb716917ec500c$export$fb22fa3ad2794469:
            return $edbb716917ec500c$export$aef8954b4bff46a2(units);
        case $edbb716917ec500c$export$4e57158d36b8042:
            return $edbb716917ec500c$export$3062d9efefbcf045(units);
        default:
            // Always return this resolution if `resizeType` is undefined or wrong value
            return $edbb716917ec500c$export$7828ec063292032d(units);
    }
}
function $edbb716917ec500c$export$e06f682fb9edb199(width, resolution) {
    if (width < (0, $e1cc3cddc7acf1a4$export$256c1c4ce479d4eb)) width = (0, $e1cc3cddc7acf1a4$export$256c1c4ce479d4eb);
    else if (width > (0, $e1cc3cddc7acf1a4$export$2b083f3fca24a6b6)) width = (0, $e1cc3cddc7acf1a4$export$2b083f3fca24a6b6);
    width = Math.round(width / resolution) * resolution;
    width = Number.parseFloat(width.toFixed($edbb716917ec500c$var$NORMALIZE_PRECISION));
    return width;
}
function $edbb716917ec500c$export$63a50d43863b1a83(segments, units) {
    return segments.map((segment)=>({
            ...segment,
            width: $edbb716917ec500c$export$e06f682fb9edb199(segment.width, $edbb716917ec500c$export$12e0a54c23e0f7be($edbb716917ec500c$export$bef0bdcd5a467cae, units))
        }));
}
function $edbb716917ec500c$export$10edf1ecc36bc190() {
    if ((0, $62b1ef0171009a7b$export$8a66765a71c06fe6).segmentEl) {
        (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).segmentEl.classList.remove("show-drag-handles");
        window.setTimeout(function() {
            (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hide();
            (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hideSegment(true);
        }, 0);
    }
}
function $edbb716917ec500c$export$3058040811eebf87() {
    document.body.classList.add("immediate-segment-resize");
    window.setTimeout(function() {
        document.body.classList.remove("immediate-segment-resize");
    }, $edbb716917ec500c$var$SHORT_DELAY);
}













const $5af1a42dad139206$export$4fd720569787ab6f = {
    NOT_FOUND: 1,
    SIGN_OUT: 2,
    NO_STREET: 3,
    FORCE_RELOAD_SIGN_IN: 4,
    FORCE_RELOAD_SIGN_OUT: 5,
    STREET_DELETED_ELSEWHERE: 6,
    NEW_STREET_SERVER_FAILURE: 7,
    ACCESS_DENIED: 9,
    AUTH_PROBLEM_NO_TWITTER_REQUEST_TOKEN: 10,
    AUTH_PROBLEM_NO_TWITTER_ACCESS_TOKEN: 11,
    AUTH_PROBLEM_API_PROBLEM: 12,
    GENERIC_ERROR: 13,
    UNSUPPORTED_BROWSER: 14,
    STREET_404: 15,
    STREET_404_BUT_LINK_TO_USER: 16,
    STREET_410_BUT_LINK_TO_USER: 17,
    CANNOT_CREATE_NEW_STREET_ON_PHONE: 18,
    SIGN_IN_SERVER_FAILURE: 19,
    SIGN_IN_401: 20,
    STREET_DATA_FAILURE: 21,
    GALLERY_STREET_FAILURE: 22,
    AUTH_PROBLEM_NO_ACCESS_TOKEN: 23,
    AUTH_EXPIRED: 24
};
function $5af1a42dad139206$export$3879b24e8245693d(errorType, newAbortEverything) {
    // Dispatch everythingLoaded to hide the loading window
    // for cases where error appears immediately on load
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $9dbab908c178b0dc$export$eef62c34974c5385)());
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $5e173785b5fcb8ed$export$3879b24e8245693d)(errorType, newAbortEverything));
}
function $5af1a42dad139206$export$e1f8658b27c7773a(errorUrl) {
    let errorType;
    // TODO const
    switch(errorUrl){
        case 0, $ea458c15ce872cdc$export$92749ba741d24778:
            errorType = $5af1a42dad139206$export$4fd720569787ab6f.AUTH_PROBLEM_NO_TWITTER_REQUEST_TOKEN;
            break;
        case 0, $ea458c15ce872cdc$export$89c51d790cd3b8fb:
            errorType = $5af1a42dad139206$export$4fd720569787ab6f.AUTH_PROBLEM_NO_TWITTER_ACCESS_TOKEN;
            break;
        case 0, $ea458c15ce872cdc$export$14a04031658e30cc:
            errorType = $5af1a42dad139206$export$4fd720569787ab6f.AUTH_PROBLEM_NO_ACCESS_TOKEN;
            break;
        case 0, $ea458c15ce872cdc$export$b9c806d46ea9d197:
            errorType = $5af1a42dad139206$export$4fd720569787ab6f.AUTH_PROBLEM_API_PROBLEM;
            break;
        case 0, $ea458c15ce872cdc$export$58cbfa1605fc1c1:
            errorType = $5af1a42dad139206$export$4fd720569787ab6f.ACCESS_DENIED;
            break;
        default:
            errorType = $5af1a42dad139206$export$4fd720569787ab6f.GENERIC_ERROR;
            break;
    }
    $5af1a42dad139206$export$3879b24e8245693d(errorType, true);
}











const $4b803bff0fdd2b7e$export$9db87636c3c46ccc = "-";
let $4b803bff0fdd2b7e$var$errorUrl = "";
function $4b803bff0fdd2b7e$export$50b7a8a7b6f81872() {
    return $4b803bff0fdd2b7e$var$errorUrl;
}
function $4b803bff0fdd2b7e$export$8378cb52a6ed7e05() {
    // Get current pathname. The pathname will contain an initial `/` followed
    // by the path of the URL. The root pathname should always be `/`. It may
    // be possible for the URL to contain a trailing slash, but we don't want
    // that, so remove it, if present. This will cause the root pathname to be
    // an empty string.
    const pathname = window.location.pathname.replace(/\/+$/, "");
    // parts being split, although we really don't need to
    // filter out empty string parts
    const urlParts = pathname.split(/\//).filter((x)=>x !== "");
    // Continue where we left off… or start with a default (demo) street
    if (pathname === "/" || pathname === "") (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).CONTINUE);
    else if (pathname === (0, $ea458c15ce872cdc$export$3ae46e95ba6bc5da)) (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).NEW_STREET);
    else if (pathname === (0, $ea458c15ce872cdc$export$429952ed111074be)) (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).NEW_STREET_COPY_LAST);
    else if (pathname === (0, $ea458c15ce872cdc$export$8fb1017c0fcda1f2)) (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).JUST_SIGNED_IN);
    else if (pathname.startsWith((0, $ea458c15ce872cdc$export$dc5f3e43ad7e20d7))) {
        (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).ERROR);
        $4b803bff0fdd2b7e$var$errorUrl = urlParts[1];
    // Global gallery
    } else if (pathname === (0, $ea458c15ce872cdc$export$a2f884de85292fcc)) (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).GLOBAL_GALLERY);
    else if (pathname === (0, $ea458c15ce872cdc$export$151b51d71f05f143)) (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).SURVEY_FINISHED);
    else if (urlParts.length === 1 && urlParts[0]) {
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $11a2d10829f32488$export$dba372f8d7162f61)(urlParts[0]));
        (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).USER_GALLERY);
    // TODO add is integer urlParts[1]
    // Existing street by an anonymous person
    } else if (urlParts.length === 2 && urlParts[0] === $4b803bff0fdd2b7e$export$9db87636c3c46ccc && urlParts[1]) {
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$5edca91ccdd4a230)(null));
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$750a818a04268f3)(null, urlParts[1]));
        (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).EXISTING_STREET);
    // Existing street by a user person
    } else if (urlParts.length >= 2 && urlParts[0] && urlParts[1]) {
        let creatorId = urlParts[0];
        if (creatorId.charAt(0) === (0, $ea458c15ce872cdc$export$acb4d8914445708a)) creatorId = creatorId.substr(1);
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$5edca91ccdd4a230)(creatorId));
        // if `urlParts[1]` is not an integer, redirect to user's gallery
        if (Number.isInteger(window.parseInt(urlParts[1])) === false) {
            (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $11a2d10829f32488$export$dba372f8d7162f61)(urlParts[0]));
            (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).USER_GALLERY);
        } else {
            (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$750a818a04268f3)(null, urlParts[1]));
            (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).EXISTING_STREET);
        }
    // 404: Catch-all
    } else (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).NOT_FOUND);
}
function $4b803bff0fdd2b7e$export$2caf090e31c8ca49(street) {
    let url = "/";
    if (street.creatorId) {
        // Add a initial slash to the creator check to match reserved paths
        if ((0, $ea458c15ce872cdc$export$3af3ea5b418067c6).indexOf("/" + street.creatorId) !== -1) url += (0, $ea458c15ce872cdc$export$acb4d8914445708a);
        url += street.creatorId;
    } else url += $4b803bff0fdd2b7e$export$9db87636c3c46ccc;
    url += "/";
    url += street.namespacedId;
    if (street.creatorId) {
        const slug = (0, $ec5f57ce491b339b$export$bb4bab168f0533a8)(street.name);
        if (slug) url += "/" + window.encodeURIComponent(slug);
    }
    return url;
}
function $4b803bff0fdd2b7e$export$591a8e3f6304beb0(forceGalleryUrl, userId = null) {
    let url;
    if (forceGalleryUrl) {
        const slug = userId || "gallery/";
        url = "/" + slug;
    } else url = $4b803bff0fdd2b7e$export$2caf090e31c8ca49((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street);
    const params = new URLSearchParams(window.location.search);
    // Historically, params were valueless and they we had our own string
    // parsing code, but now we use the `URLSearchParams` global interface.
    // For clarity, truthy values are set to the value of 1.
    if ((0, $6fccecb363574db8$export$1c9f709888824e05).forceLeftHandTraffic) params.set("debug-force-left-hand-traffic", 1);
    if ((0, $6fccecb363574db8$export$1c9f709888824e05).forceNonRetina) params.set("debug-force-non-retina", 1);
    if ((0, $6fccecb363574db8$export$1c9f709888824e05).forceReadOnly) params.set("debug-force-read-only", 1);
    if ((0, $6fccecb363574db8$export$1c9f709888824e05).forceOfflineMode) params.set("debug-force-offline", 1);
    // If we have params, append to the URL
    if (params.size > 0) url += `?${params.toString()}`;
    window.history.replaceState(null, "", url);
}


const $20dec064f3771e9c$export$240b20df485e8ed6 = {
    CONTINUE: 1,
    NEW_STREET: 2,
    NEW_STREET_COPY_LAST: 3,
    JUST_SIGNED_IN: 4,
    EXISTING_STREET: 5,
    NOT_FOUND: 6,
    SIGN_OUT: 7,
    FORCE_RELOAD_SIGN_IN: 8,
    FORCE_RELOAD_SIGN_OUT: 9,
    USER_GALLERY: 10,
    GLOBAL_GALLERY: 11,
    ERROR: 13,
    UNSUPPORTED_BROWSER: 14,
    STREET_404: 15,
    STREET_404_BUT_LINK_TO_USER: 16,
    STREET_410_BUT_LINK_TO_USER: 17,
    ABOUT: 18,
    AUTH_EXPIRED: 19,
    SURVEY_FINISHED: 20
};
let $20dec064f3771e9c$var$mode;
function $20dec064f3771e9c$export$1fc0f6205829e19c() {
    return $20dec064f3771e9c$var$mode;
}
function $20dec064f3771e9c$export$d4f039427a1beff1(value) {
    $20dec064f3771e9c$var$mode = value;
}
function $20dec064f3771e9c$export$eb2f560d6088705b() {
    (0, $09d66509dd0bbd69$export$a61c8ed8b4f8b308)(true);
    switch($20dec064f3771e9c$var$mode){
        case $20dec064f3771e9c$export$240b20df485e8ed6.ERROR:
            (0, $5af1a42dad139206$export$e1f8658b27c7773a)((0, $4b803bff0fdd2b7e$export$50b7a8a7b6f81872)());
            break;
        // Deprecated
        case $20dec064f3771e9c$export$240b20df485e8ed6.UNSUPPORTED_BROWSER:
            (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).UNSUPPORTED_BROWSER, true);
            break;
        case $20dec064f3771e9c$export$240b20df485e8ed6.AUTH_EXPIRED:
            (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).AUTH_EXPIRED, true);
            break;
        case $20dec064f3771e9c$export$240b20df485e8ed6.NOT_FOUND:
            (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).NOT_FOUND, true);
            break;
        case $20dec064f3771e9c$export$240b20df485e8ed6.STREET_404:
            (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).STREET_404, true);
            break;
        case $20dec064f3771e9c$export$240b20df485e8ed6.STREET_404_BUT_LINK_TO_USER:
            (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).STREET_404_BUT_LINK_TO_USER, true);
            break;
        case $20dec064f3771e9c$export$240b20df485e8ed6.STREET_410_BUT_LINK_TO_USER:
            (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).STREET_410_BUT_LINK_TO_USER, true);
            break;
        case $20dec064f3771e9c$export$240b20df485e8ed6.SIGN_OUT:
            (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).SIGN_OUT, true);
            break;
        case $20dec064f3771e9c$export$240b20df485e8ed6.FORCE_RELOAD_SIGN_OUT:
            (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).FORCE_RELOAD_SIGN_OUT, true);
            break;
        case $20dec064f3771e9c$export$240b20df485e8ed6.FORCE_RELOAD_SIGN_IN:
            (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).FORCE_RELOAD_SIGN_IN, true);
            break;
        case $20dec064f3771e9c$export$240b20df485e8ed6.NEW_STREET:
            (0, $09d66509dd0bbd69$export$a61c8ed8b4f8b308)(false);
            break;
        case $20dec064f3771e9c$export$240b20df485e8ed6.NEW_STREET_COPY_LAST:
            (0, $09d66509dd0bbd69$export$a61c8ed8b4f8b308)(false);
            break;
        case $20dec064f3771e9c$export$240b20df485e8ed6.CONTINUE:
        case $20dec064f3771e9c$export$240b20df485e8ed6.USER_GALLERY:
        case $20dec064f3771e9c$export$240b20df485e8ed6.GLOBAL_GALLERY:
            (0, $09d66509dd0bbd69$export$a61c8ed8b4f8b308)(false);
            break;
        case $20dec064f3771e9c$export$240b20df485e8ed6.JUST_SIGNED_IN:
            (0, $09d66509dd0bbd69$export$a61c8ed8b4f8b308)(false);
            break;
        case $20dec064f3771e9c$export$240b20df485e8ed6.SURVEY_FINISHED:
            (0, $09d66509dd0bbd69$export$a61c8ed8b4f8b308)(false);
            break;
        case $20dec064f3771e9c$export$240b20df485e8ed6.EXISTING_STREET:
            (0, $09d66509dd0bbd69$export$a61c8ed8b4f8b308)(false);
            break;
    }
}







/**
 * Create blocking fetch requests.
 * Display a blocking shield when a request is in progress.
 * Only one of these should be active at any time and
 * no other fetch / xhr / ajax should exist when they do.
 */ function $875b7806636140c5$export$15b481ad22e551c2(mode = "load") {
    window.dispatchEvent(new window.CustomEvent("stmx:show_blocking_shield", {
        detail: {
            mode: mode
        }
    }));
}
function $875b7806636140c5$export$befb70afd9e7350d(showCancel = false) {
    window.dispatchEvent(new window.CustomEvent("stmx:darken_blocking_shield", {
        detail: {
            showCancel: !!showCancel
        }
    }));
}
function $875b7806636140c5$export$f15d98cd9142bd86() {
    window.dispatchEvent(new window.CustomEvent("stmx:hide_blocking_shield"));
}


let $ec6ccb5735a32e28$var$blockingAjaxRequest;
let $ec6ccb5735a32e28$var$blockingAjaxRequestDoneFunc;
let $ec6ccb5735a32e28$var$blockingAjaxRequestCancelFunc;
let $ec6ccb5735a32e28$var$blockingAjaxRequestInProgress = false;
function $ec6ccb5735a32e28$export$81d426b48108b404() {
    return $ec6ccb5735a32e28$var$blockingAjaxRequestInProgress;
}
function $ec6ccb5735a32e28$export$1d38de5ce0ec4945(mode, request, doneFunc, cancelFunc) {
    (0, $875b7806636140c5$export$15b481ad22e551c2)(mode);
    $ec6ccb5735a32e28$var$blockingAjaxRequestInProgress = true;
    $ec6ccb5735a32e28$var$blockingAjaxRequest = request;
    $ec6ccb5735a32e28$var$blockingAjaxRequestDoneFunc = doneFunc;
    $ec6ccb5735a32e28$var$blockingAjaxRequestCancelFunc = cancelFunc;
    $ec6ccb5735a32e28$var$makeBlockingAjaxRequest();
}
function $ec6ccb5735a32e28$var$successBlockingAjaxRequest(data) {
    (0, $875b7806636140c5$export$f15d98cd9142bd86)();
    $ec6ccb5735a32e28$var$blockingAjaxRequestInProgress = false;
    $ec6ccb5735a32e28$var$blockingAjaxRequestDoneFunc(data);
}
function $ec6ccb5735a32e28$var$errorBlockingAjaxRequest() {
    (0, $875b7806636140c5$export$befb70afd9e7350d)($ec6ccb5735a32e28$var$blockingAjaxRequestCancelFunc);
}
function $ec6ccb5735a32e28$var$makeBlockingAjaxRequest() {
    window.fetch($ec6ccb5735a32e28$var$blockingAjaxRequest.url, $ec6ccb5735a32e28$var$blockingAjaxRequest).then((response)=>{
        if (!response.ok) throw response;
        return response.json();
    }).then($ec6ccb5735a32e28$var$successBlockingAjaxRequest).catch($ec6ccb5735a32e28$var$errorBlockingAjaxRequest);
}
function $ec6ccb5735a32e28$export$3094dd6b6c3704b6() {
    $ec6ccb5735a32e28$var$makeBlockingAjaxRequest();
}
function $ec6ccb5735a32e28$export$d3587b5143154d9() {
    $ec6ccb5735a32e28$var$blockingAjaxRequestInProgress = false;
    $ec6ccb5735a32e28$var$blockingAjaxRequestCancelFunc();
}













function $b66cc4ceae9b725e$export$11e81b241ba16333() {
    return (0, $762e491bbbc71e6b$export$2e2bcd8739ae039)((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().history.stack);
}
function $b66cc4ceae9b725e$export$57e3eed88cb66286() {
    return (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().history.position;
}
function $b66cc4ceae9b725e$export$283a3ddc6f6f78a5() {
    // set current street to the thing we just updated
    const { position: position, stack: stack } = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().history;
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$abace6e40841f465)((0, $762e491bbbc71e6b$export$2e2bcd8739ae039)(stack[position])));
    (0, $edbb716917ec500c$export$3058040811eebf87)();
    (0, $8d9791e5769125e5$export$4cb3d51df0d60a35)();
    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hide();
    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hideSegment();
    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).dontConsiderShowing();
    (0, $8d9791e5769125e5$export$a816daed016d4c40)(true);
}
function $b66cc4ceae9b725e$export$5dc8a18b66217cb8(lastStreet = {}, currentStreet) {
    // If just the street name has changed, don't make a new undo step for it.
    if (lastStreet.name !== currentStreet.name) return;
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $0e3fada570e844f5$export$beae92f3b524112c)((0, $762e491bbbc71e6b$export$2e2bcd8739ae039)(lastStreet)));
}
function $b66cc4ceae9b725e$export$6e81a82123b449bb() {
    const street = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $0e3fada570e844f5$export$30fa48a523ba578b)(street));
}








/**
 * auth0-js v9.24.0
 * Author: Auth0
 * Date: 2023-12-13
 * License: MIT
 */ 
var $eh5Zb = parcelRequire("eh5Zb");
var $bdd166eca2c549e0$var$commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $bdd166eca2c549e0$var$createCommonjsModule(fn, module) {
    return fn(module = {
        exports: {}
    }, module.exports), module.exports;
}
var $bdd166eca2c549e0$var$urlJoin = $bdd166eca2c549e0$var$createCommonjsModule(function(module) {
    var context, definition;
    context = $bdd166eca2c549e0$var$commonjsGlobal, definition = function() {
        function normalize(strArray) {
            var resultArray = [];
            if (0 === strArray.length) return "";
            if ("string" != typeof strArray[0]) throw new TypeError("Url must be a string. Received " + strArray[0]);
            if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
                var first = strArray.shift();
                strArray[0] = first + strArray[0];
            }
            strArray[0].match(/^file:\/\/\//) ? strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1:///") : strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1://");
            for(var i = 0; i < strArray.length; i++){
                var component = strArray[i];
                if ("string" != typeof component) throw new TypeError("Url must be a string. Received " + component);
                "" !== component && (i > 0 && (component = component.replace(/^[\/]+/, "")), component = i < strArray.length - 1 ? component.replace(/[\/]+$/, "") : component.replace(/[\/]+$/, "/"), resultArray.push(component));
            }
            var str = resultArray.join("/"), parts = (str = str.replace(/\/(\?|&|#[^!])/g, "$1")).split("?");
            return str = parts.shift() + (parts.length > 0 ? "?" : "") + parts.join("&");
        }
        return function() {
            return normalize("object" == typeof arguments[0] ? arguments[0] : [].slice.call(arguments));
        };
    }, module.exports ? module.exports = definition() : context.urljoin = definition();
}), $bdd166eca2c549e0$var$origSymbol = "undefined" != typeof Symbol && Symbol, $bdd166eca2c549e0$var$test = {
    foo: {}
}, $bdd166eca2c549e0$var$$Object = Object, $bdd166eca2c549e0$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ", $bdd166eca2c549e0$var$toStr = Object.prototype.toString, $bdd166eca2c549e0$var$max = Math.max, $bdd166eca2c549e0$var$concatty = function(a, b) {
    for(var arr = [], i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
}, $bdd166eca2c549e0$var$slicy = function(arrLike, offset) {
    for(var arr = [], i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
}, $bdd166eca2c549e0$var$joiny = function(arr, joiner) {
    for(var str = "", i = 0; i < arr.length; i += 1)str += arr[i], i + 1 < arr.length && (str += joiner);
    return str;
}, $bdd166eca2c549e0$var$functionBind = Function.prototype.bind || function(that) {
    var target = this;
    if ("function" != typeof target || "[object Function]" !== $bdd166eca2c549e0$var$toStr.apply(target)) throw new TypeError($bdd166eca2c549e0$var$ERROR_MESSAGE + target);
    for(var bound, args = $bdd166eca2c549e0$var$slicy(arguments, 1), binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $bdd166eca2c549e0$var$concatty(args, arguments));
            return Object(result) === result ? result : this;
        }
        return target.apply(that, $bdd166eca2c549e0$var$concatty(args, arguments));
    }, boundLength = $bdd166eca2c549e0$var$max(0, target.length - args.length), boundArgs = [], i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    if (bound = Function("binder", "return function (" + $bdd166eca2c549e0$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder), target.prototype) {
        var Empty = function() {};
        Empty.prototype = target.prototype, bound.prototype = new Empty, Empty.prototype = null;
    }
    return bound;
}, $bdd166eca2c549e0$var$src = $bdd166eca2c549e0$var$functionBind.call(Function.call, Object.prototype.hasOwnProperty), $bdd166eca2c549e0$var$$SyntaxError = SyntaxError, $bdd166eca2c549e0$var$$Function = Function, $bdd166eca2c549e0$var$$TypeError = TypeError, $bdd166eca2c549e0$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $bdd166eca2c549e0$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
}, $bdd166eca2c549e0$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($bdd166eca2c549e0$var$$gOPD) try {
    $bdd166eca2c549e0$var$$gOPD({}, "");
} catch (e) {
    $bdd166eca2c549e0$var$$gOPD = null;
}
var $bdd166eca2c549e0$var$throwTypeError = function() {
    throw new $bdd166eca2c549e0$var$$TypeError;
}, $bdd166eca2c549e0$var$ThrowTypeError = $bdd166eca2c549e0$var$$gOPD ? function() {
    try {
        return $bdd166eca2c549e0$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            return $bdd166eca2c549e0$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $bdd166eca2c549e0$var$throwTypeError;
        }
    }
}() : $bdd166eca2c549e0$var$throwTypeError, $bdd166eca2c549e0$var$hasSymbols$1 = "function" == typeof $bdd166eca2c549e0$var$origSymbol && "function" == typeof Symbol && "symbol" == typeof $bdd166eca2c549e0$var$origSymbol("foo") && "symbol" == typeof Symbol("bar") && function() {
    if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
    if ("symbol" == typeof Symbol.iterator) return !0;
    var obj = {}, sym = Symbol("test"), symObj = Object(sym);
    if ("string" == typeof sym) return !1;
    if ("[object Symbol]" !== Object.prototype.toString.call(sym)) return !1;
    if ("[object Symbol]" !== Object.prototype.toString.call(symObj)) return !1;
    for(sym in obj[sym] = 42, obj)return !1;
    if ("function" == typeof Object.keys && 0 !== Object.keys(obj).length) return !1;
    if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(obj).length) return !1;
    var syms = Object.getOwnPropertySymbols(obj);
    if (1 !== syms.length || syms[0] !== sym) return !1;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return !1;
    if ("function" == typeof Object.getOwnPropertyDescriptor) {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (42 !== descriptor.value || !0 !== descriptor.enumerable) return !1;
    }
    return !0;
}(), $bdd166eca2c549e0$var$hasProto$1 = {
    __proto__: $bdd166eca2c549e0$var$test
}.foo === $bdd166eca2c549e0$var$test.foo && !(({
    __proto__: null
}) instanceof $bdd166eca2c549e0$var$$Object), $bdd166eca2c549e0$var$getProto = Object.getPrototypeOf || ($bdd166eca2c549e0$var$hasProto$1 ? function(x) {
    return x.__proto__;
} : null), $bdd166eca2c549e0$var$needsEval = {}, $bdd166eca2c549e0$var$TypedArray = "undefined" != typeof Uint8Array && $bdd166eca2c549e0$var$getProto ? $bdd166eca2c549e0$var$getProto(Uint8Array) : void 0, $bdd166eca2c549e0$var$INTRINSICS = {
    "%AggregateError%": "undefined" == typeof AggregateError ? void 0 : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer,
    "%ArrayIteratorPrototype%": $bdd166eca2c549e0$var$hasSymbols$1 && $bdd166eca2c549e0$var$getProto ? $bdd166eca2c549e0$var$getProto([][Symbol.iterator]()) : void 0,
    "%AsyncFromSyncIteratorPrototype%": void 0,
    "%AsyncFunction%": $bdd166eca2c549e0$var$needsEval,
    "%AsyncGenerator%": $bdd166eca2c549e0$var$needsEval,
    "%AsyncGeneratorFunction%": $bdd166eca2c549e0$var$needsEval,
    "%AsyncIteratorPrototype%": $bdd166eca2c549e0$var$needsEval,
    "%Atomics%": "undefined" == typeof Atomics ? void 0 : Atomics,
    "%BigInt%": "undefined" == typeof BigInt ? void 0 : BigInt,
    "%BigInt64Array%": "undefined" == typeof BigInt64Array ? void 0 : BigInt64Array,
    "%BigUint64Array%": "undefined" == typeof BigUint64Array ? void 0 : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": "undefined" == typeof DataView ? void 0 : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": "undefined" == typeof Float32Array ? void 0 : Float32Array,
    "%Float64Array%": "undefined" == typeof Float64Array ? void 0 : Float64Array,
    "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? void 0 : FinalizationRegistry,
    "%Function%": $bdd166eca2c549e0$var$$Function,
    "%GeneratorFunction%": $bdd166eca2c549e0$var$needsEval,
    "%Int8Array%": "undefined" == typeof Int8Array ? void 0 : Int8Array,
    "%Int16Array%": "undefined" == typeof Int16Array ? void 0 : Int16Array,
    "%Int32Array%": "undefined" == typeof Int32Array ? void 0 : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $bdd166eca2c549e0$var$hasSymbols$1 && $bdd166eca2c549e0$var$getProto ? $bdd166eca2c549e0$var$getProto($bdd166eca2c549e0$var$getProto([][Symbol.iterator]())) : void 0,
    "%JSON%": "object" == typeof JSON ? JSON : void 0,
    "%Map%": "undefined" == typeof Map ? void 0 : Map,
    "%MapIteratorPrototype%": "undefined" != typeof Map && $bdd166eca2c549e0$var$hasSymbols$1 && $bdd166eca2c549e0$var$getProto ? $bdd166eca2c549e0$var$getProto((new Map)[Symbol.iterator]()) : void 0,
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": "undefined" == typeof Promise ? void 0 : Promise,
    "%Proxy%": "undefined" == typeof Proxy ? void 0 : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": "undefined" == typeof Reflect ? void 0 : Reflect,
    "%RegExp%": RegExp,
    "%Set%": "undefined" == typeof Set ? void 0 : Set,
    "%SetIteratorPrototype%": "undefined" != typeof Set && $bdd166eca2c549e0$var$hasSymbols$1 && $bdd166eca2c549e0$var$getProto ? $bdd166eca2c549e0$var$getProto((new Set)[Symbol.iterator]()) : void 0,
    "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $bdd166eca2c549e0$var$hasSymbols$1 && $bdd166eca2c549e0$var$getProto ? $bdd166eca2c549e0$var$getProto(""[Symbol.iterator]()) : void 0,
    "%Symbol%": $bdd166eca2c549e0$var$hasSymbols$1 ? Symbol : void 0,
    "%SyntaxError%": $bdd166eca2c549e0$var$$SyntaxError,
    "%ThrowTypeError%": $bdd166eca2c549e0$var$ThrowTypeError,
    "%TypedArray%": $bdd166eca2c549e0$var$TypedArray,
    "%TypeError%": $bdd166eca2c549e0$var$$TypeError,
    "%Uint8Array%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array,
    "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
    "%Uint16Array%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array,
    "%Uint32Array%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": "undefined" == typeof WeakMap ? void 0 : WeakMap,
    "%WeakRef%": "undefined" == typeof WeakRef ? void 0 : WeakRef,
    "%WeakSet%": "undefined" == typeof WeakSet ? void 0 : WeakSet
};
if ($bdd166eca2c549e0$var$getProto) try {
    null.error;
} catch (e) {
    var $bdd166eca2c549e0$var$errorProto = $bdd166eca2c549e0$var$getProto($bdd166eca2c549e0$var$getProto(e));
    $bdd166eca2c549e0$var$INTRINSICS["%Error.prototype%"] = $bdd166eca2c549e0$var$errorProto;
}
var $bdd166eca2c549e0$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
}, $bdd166eca2c549e0$var$$concat = $bdd166eca2c549e0$var$functionBind.call(Function.call, Array.prototype.concat), $bdd166eca2c549e0$var$$spliceApply = $bdd166eca2c549e0$var$functionBind.call(Function.apply, Array.prototype.splice), $bdd166eca2c549e0$var$$replace = $bdd166eca2c549e0$var$functionBind.call(Function.call, String.prototype.replace), $bdd166eca2c549e0$var$$strSlice = $bdd166eca2c549e0$var$functionBind.call(Function.call, String.prototype.slice), $bdd166eca2c549e0$var$$exec = $bdd166eca2c549e0$var$functionBind.call(Function.call, RegExp.prototype.exec), $bdd166eca2c549e0$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, $bdd166eca2c549e0$var$reEscapeChar = /\\(\\)?/g, $bdd166eca2c549e0$var$stringToPath = function(string) {
    var first = $bdd166eca2c549e0$var$$strSlice(string, 0, 1), last = $bdd166eca2c549e0$var$$strSlice(string, -1);
    if ("%" === first && "%" !== last) throw new $bdd166eca2c549e0$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    if ("%" === last && "%" !== first) throw new $bdd166eca2c549e0$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    return $bdd166eca2c549e0$var$$replace(string, $bdd166eca2c549e0$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $bdd166eca2c549e0$var$$replace(subString, $bdd166eca2c549e0$var$reEscapeChar, "$1") : number || match;
    }), result;
}, $bdd166eca2c549e0$var$getBaseIntrinsic = function(name, allowMissing) {
    var alias, intrinsicName = name;
    if ($bdd166eca2c549e0$var$src($bdd166eca2c549e0$var$LEGACY_ALIASES, intrinsicName) && (intrinsicName = "%" + (alias = $bdd166eca2c549e0$var$LEGACY_ALIASES[intrinsicName])[0] + "%"), $bdd166eca2c549e0$var$src($bdd166eca2c549e0$var$INTRINSICS, intrinsicName)) {
        var value = $bdd166eca2c549e0$var$INTRINSICS[intrinsicName];
        if (value === $bdd166eca2c549e0$var$needsEval && (value = function doEval(name) {
            var value;
            if ("%AsyncFunction%" === name) value = $bdd166eca2c549e0$var$getEvalledConstructor("async function () {}");
            else if ("%GeneratorFunction%" === name) value = $bdd166eca2c549e0$var$getEvalledConstructor("function* () {}");
            else if ("%AsyncGeneratorFunction%" === name) value = $bdd166eca2c549e0$var$getEvalledConstructor("async function* () {}");
            else if ("%AsyncGenerator%" === name) {
                var fn = doEval("%AsyncGeneratorFunction%");
                fn && (value = fn.prototype);
            } else if ("%AsyncIteratorPrototype%" === name) {
                var gen = doEval("%AsyncGenerator%");
                gen && $bdd166eca2c549e0$var$getProto && (value = $bdd166eca2c549e0$var$getProto(gen.prototype));
            }
            return $bdd166eca2c549e0$var$INTRINSICS[name] = value, value;
        }(intrinsicName)), void 0 === value && !allowMissing) throw new $bdd166eca2c549e0$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $bdd166eca2c549e0$var$$SyntaxError("intrinsic " + name + " does not exist!");
}, $bdd166eca2c549e0$var$getIntrinsic = function(name, allowMissing) {
    if ("string" != typeof name || 0 === name.length) throw new $bdd166eca2c549e0$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && "boolean" != typeof allowMissing) throw new $bdd166eca2c549e0$var$$TypeError('"allowMissing" argument must be a boolean');
    if (null === $bdd166eca2c549e0$var$$exec(/^%?[^%]*%?$/, name)) throw new $bdd166eca2c549e0$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $bdd166eca2c549e0$var$stringToPath(name), intrinsicBaseName = parts.length > 0 ? parts[0] : "", intrinsic = $bdd166eca2c549e0$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing), intrinsicRealName = intrinsic.name, value = intrinsic.value, skipFurtherCaching = !1, alias = intrinsic.alias;
    alias && (intrinsicBaseName = alias[0], $bdd166eca2c549e0$var$$spliceApply(parts, $bdd166eca2c549e0$var$$concat([
        0,
        1
    ], alias)));
    for(var i = 1, isOwn = !0; i < parts.length; i += 1){
        var part = parts[i], first = $bdd166eca2c549e0$var$$strSlice(part, 0, 1), last = $bdd166eca2c549e0$var$$strSlice(part, -1);
        if (('"' === first || "'" === first || "`" === first || '"' === last || "'" === last || "`" === last) && first !== last) throw new $bdd166eca2c549e0$var$$SyntaxError("property names with quotes must have matching quotes");
        if ("constructor" !== part && isOwn || (skipFurtherCaching = !0), $bdd166eca2c549e0$var$src($bdd166eca2c549e0$var$INTRINSICS, intrinsicRealName = "%" + (intrinsicBaseName += "." + part) + "%")) value = $bdd166eca2c549e0$var$INTRINSICS[intrinsicRealName];
        else if (null != value) {
            if (!(part in value)) {
                if (!allowMissing) throw new $bdd166eca2c549e0$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return;
            }
            if ($bdd166eca2c549e0$var$$gOPD && i + 1 >= parts.length) {
                var desc = $bdd166eca2c549e0$var$$gOPD(value, part);
                value = (isOwn = !!desc) && "get" in desc && !("originalValue" in desc.get) ? desc.get : value[part];
            } else isOwn = $bdd166eca2c549e0$var$src(value, part), value = value[part];
            isOwn && !skipFurtherCaching && ($bdd166eca2c549e0$var$INTRINSICS[intrinsicRealName] = value);
        }
    }
    return value;
}, $bdd166eca2c549e0$var$callBind = $bdd166eca2c549e0$var$createCommonjsModule(function(module) {
    var $apply = $bdd166eca2c549e0$var$getIntrinsic("%Function.prototype.apply%"), $call = $bdd166eca2c549e0$var$getIntrinsic("%Function.prototype.call%"), $reflectApply = $bdd166eca2c549e0$var$getIntrinsic("%Reflect.apply%", !0) || $bdd166eca2c549e0$var$functionBind.call($call, $apply), $gOPD = $bdd166eca2c549e0$var$getIntrinsic("%Object.getOwnPropertyDescriptor%", !0), $defineProperty = $bdd166eca2c549e0$var$getIntrinsic("%Object.defineProperty%", !0), $max = $bdd166eca2c549e0$var$getIntrinsic("%Math.max%");
    if ($defineProperty) try {
        $defineProperty({}, "a", {
            value: 1
        });
    } catch (e) {
        $defineProperty = null;
    }
    module.exports = function(originalFunction) {
        var func = $reflectApply($bdd166eca2c549e0$var$functionBind, $call, arguments);
        if ($gOPD && $defineProperty) {
            var desc = $gOPD(func, "length");
            desc.configurable && $defineProperty(func, "length", {
                value: 1 + $max(0, originalFunction.length - (arguments.length - 1))
            });
        }
        return func;
    };
    var applyBind = function() {
        return $reflectApply($bdd166eca2c549e0$var$functionBind, $apply, arguments);
    };
    $defineProperty ? $defineProperty(module.exports, "apply", {
        value: applyBind
    }) : module.exports.apply = applyBind;
}), $bdd166eca2c549e0$var$$indexOf = ($bdd166eca2c549e0$var$callBind.apply, $bdd166eca2c549e0$var$callBind($bdd166eca2c549e0$var$getIntrinsic("String.prototype.indexOf"))), $bdd166eca2c549e0$var$callBound = function(name, allowMissing) {
    var intrinsic = $bdd166eca2c549e0$var$getIntrinsic(name, !!allowMissing);
    return "function" == typeof intrinsic && $bdd166eca2c549e0$var$$indexOf(name, ".prototype.") > -1 ? $bdd166eca2c549e0$var$callBind(intrinsic) : intrinsic;
}, $bdd166eca2c549e0$var$semver = function(n) {
    return n && n.default || n;
}(Object.freeze({
    __proto__: null,
    default: {}
})), $bdd166eca2c549e0$var$hasMap = "function" == typeof Map && Map.prototype, $bdd166eca2c549e0$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $bdd166eca2c549e0$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, $bdd166eca2c549e0$var$mapSize = $bdd166eca2c549e0$var$hasMap && $bdd166eca2c549e0$var$mapSizeDescriptor && "function" == typeof $bdd166eca2c549e0$var$mapSizeDescriptor.get ? $bdd166eca2c549e0$var$mapSizeDescriptor.get : null, $bdd166eca2c549e0$var$mapForEach = $bdd166eca2c549e0$var$hasMap && Map.prototype.forEach, $bdd166eca2c549e0$var$hasSet = "function" == typeof Set && Set.prototype, $bdd166eca2c549e0$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $bdd166eca2c549e0$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, $bdd166eca2c549e0$var$setSize = $bdd166eca2c549e0$var$hasSet && $bdd166eca2c549e0$var$setSizeDescriptor && "function" == typeof $bdd166eca2c549e0$var$setSizeDescriptor.get ? $bdd166eca2c549e0$var$setSizeDescriptor.get : null, $bdd166eca2c549e0$var$setForEach = $bdd166eca2c549e0$var$hasSet && Set.prototype.forEach, $bdd166eca2c549e0$var$weakMapHas = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null, $bdd166eca2c549e0$var$weakSetHas = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null, $bdd166eca2c549e0$var$weakRefDeref = "function" == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null, $bdd166eca2c549e0$var$booleanValueOf = Boolean.prototype.valueOf, $bdd166eca2c549e0$var$objectToString = Object.prototype.toString, $bdd166eca2c549e0$var$functionToString = Function.prototype.toString, $bdd166eca2c549e0$var$$match = String.prototype.match, $bdd166eca2c549e0$var$$slice = String.prototype.slice, $bdd166eca2c549e0$var$$replace$1 = String.prototype.replace, $bdd166eca2c549e0$var$$toUpperCase = String.prototype.toUpperCase, $bdd166eca2c549e0$var$$toLowerCase = String.prototype.toLowerCase, $bdd166eca2c549e0$var$$test = RegExp.prototype.test, $bdd166eca2c549e0$var$$concat$1 = Array.prototype.concat, $bdd166eca2c549e0$var$$join = Array.prototype.join, $bdd166eca2c549e0$var$$arrSlice = Array.prototype.slice, $bdd166eca2c549e0$var$$floor = Math.floor, $bdd166eca2c549e0$var$bigIntValueOf = "function" == typeof BigInt ? BigInt.prototype.valueOf : null, $bdd166eca2c549e0$var$gOPS = Object.getOwnPropertySymbols, $bdd166eca2c549e0$var$symToString = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? Symbol.prototype.toString : null, $bdd166eca2c549e0$var$hasShammedSymbols = "function" == typeof Symbol && "object" == typeof Symbol.iterator, $bdd166eca2c549e0$var$toStringTag = "function" == typeof Symbol && Symbol.toStringTag && (typeof Symbol.toStringTag === $bdd166eca2c549e0$var$hasShammedSymbols || "symbol") ? Symbol.toStringTag : null, $bdd166eca2c549e0$var$isEnumerable = Object.prototype.propertyIsEnumerable, $bdd166eca2c549e0$var$gPO = ("function" == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
    return O.__proto__;
} : null);
function $bdd166eca2c549e0$var$addNumericSeparator(num, str) {
    if (num === 1 / 0 || num === -1 / 0 || num != num || num && num > -1000 && num < 1e3 || $bdd166eca2c549e0$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if ("number" == typeof num) {
        var int = num < 0 ? -$bdd166eca2c549e0$var$$floor(-num) : $bdd166eca2c549e0$var$$floor(num);
        if (int !== num) {
            var intStr = String(int), dec = $bdd166eca2c549e0$var$$slice.call(str, intStr.length + 1);
            return $bdd166eca2c549e0$var$$replace$1.call(intStr, sepRegex, "$&_") + "." + $bdd166eca2c549e0$var$$replace$1.call($bdd166eca2c549e0$var$$replace$1.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $bdd166eca2c549e0$var$$replace$1.call(str, sepRegex, "$&_");
}
var $bdd166eca2c549e0$var$inspectCustom = $bdd166eca2c549e0$var$semver.custom, $bdd166eca2c549e0$var$inspectSymbol = $bdd166eca2c549e0$var$isSymbol($bdd166eca2c549e0$var$inspectCustom) ? $bdd166eca2c549e0$var$inspectCustom : null, $bdd166eca2c549e0$var$objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($bdd166eca2c549e0$var$has(opts, "quoteStyle") && "single" !== opts.quoteStyle && "double" !== opts.quoteStyle) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($bdd166eca2c549e0$var$has(opts, "maxStringLength") && ("number" == typeof opts.maxStringLength ? opts.maxStringLength < 0 && opts.maxStringLength !== 1 / 0 : null !== opts.maxStringLength)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = !$bdd166eca2c549e0$var$has(opts, "customInspect") || opts.customInspect;
    if ("boolean" != typeof customInspect && "symbol" !== customInspect) throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($bdd166eca2c549e0$var$has(opts, "indent") && null !== opts.indent && "	" !== opts.indent && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($bdd166eca2c549e0$var$has(opts, "numericSeparator") && "boolean" != typeof opts.numericSeparator) throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (void 0 === obj) return "undefined";
    if (null === obj) return "null";
    if ("boolean" == typeof obj) return obj ? "true" : "false";
    if ("string" == typeof obj) return function inspectString(str, opts) {
        if (str.length > opts.maxStringLength) {
            var remaining = str.length - opts.maxStringLength, trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
            return inspectString($bdd166eca2c549e0$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
        }
        return $bdd166eca2c549e0$var$wrapQuotes($bdd166eca2c549e0$var$$replace$1.call($bdd166eca2c549e0$var$$replace$1.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $bdd166eca2c549e0$var$lowbyte), "single", opts);
    }(obj, opts);
    if ("number" == typeof obj) {
        if (0 === obj) return 1 / 0 / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $bdd166eca2c549e0$var$addNumericSeparator(obj, str) : str;
    }
    if ("bigint" == typeof obj) {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $bdd166eca2c549e0$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = void 0 === opts.depth ? 5 : opts.depth;
    if (void 0 === depth && (depth = 0), depth >= maxDepth && maxDepth > 0 && "object" == typeof obj) return $bdd166eca2c549e0$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = function(opts, depth) {
        var baseIndent;
        if ("	" === opts.indent) baseIndent = "	";
        else {
            if (!("number" == typeof opts.indent && opts.indent > 0)) return null;
            baseIndent = $bdd166eca2c549e0$var$$join.call(Array(opts.indent + 1), " ");
        }
        return {
            base: baseIndent,
            prev: $bdd166eca2c549e0$var$$join.call(Array(depth + 1), baseIndent)
        };
    }(opts, depth);
    if (void 0 === seen) seen = [];
    else if ($bdd166eca2c549e0$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from && (seen = $bdd166eca2c549e0$var$$arrSlice.call(seen)).push(from), noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            return $bdd166eca2c549e0$var$has(opts, "quoteStyle") && (newOpts.quoteStyle = opts.quoteStyle), inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if ("function" == typeof obj && !$bdd166eca2c549e0$var$isRegExp(obj)) {
        var name = function(f) {
            if (f.name) return f.name;
            var m = $bdd166eca2c549e0$var$$match.call($bdd166eca2c549e0$var$functionToString.call(f), /^function\s*([\w$]+)/);
            if (m) return m[1];
            return null;
        }(obj), keys = $bdd166eca2c549e0$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $bdd166eca2c549e0$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($bdd166eca2c549e0$var$isSymbol(obj)) {
        var symString = $bdd166eca2c549e0$var$hasShammedSymbols ? $bdd166eca2c549e0$var$$replace$1.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $bdd166eca2c549e0$var$symToString.call(obj);
        return "object" != typeof obj || $bdd166eca2c549e0$var$hasShammedSymbols ? symString : $bdd166eca2c549e0$var$markBoxed(symString);
    }
    if (function(x) {
        if (!x || "object" != typeof x) return !1;
        if ("undefined" != typeof HTMLElement && x instanceof HTMLElement) return !0;
        return "string" == typeof x.nodeName && "function" == typeof x.getAttribute;
    }(obj)) {
        for(var s = "<" + $bdd166eca2c549e0$var$$toLowerCase.call(String(obj.nodeName)), attrs = obj.attributes || [], i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $bdd166eca2c549e0$var$wrapQuotes($bdd166eca2c549e0$var$quote(attrs[i].value), "double", opts);
        return s += ">", obj.childNodes && obj.childNodes.length && (s += "..."), s += "</" + $bdd166eca2c549e0$var$$toLowerCase.call(String(obj.nodeName)) + ">";
    }
    if ($bdd166eca2c549e0$var$isArray(obj)) {
        if (0 === obj.length) return "[]";
        var xs = $bdd166eca2c549e0$var$arrObjKeys(obj, inspect);
        return indent && !function(xs) {
            for(var i = 0; i < xs.length; i++)if ($bdd166eca2c549e0$var$indexOf(xs[i], "\n") >= 0) return !1;
            return !0;
        }(xs) ? "[" + $bdd166eca2c549e0$var$indentedJoin(xs, indent) + "]" : "[ " + $bdd166eca2c549e0$var$$join.call(xs, ", ") + " ]";
    }
    if (function(obj) {
        return !("[object Error]" !== $bdd166eca2c549e0$var$toStr$1(obj) || $bdd166eca2c549e0$var$toStringTag && "object" == typeof obj && $bdd166eca2c549e0$var$toStringTag in obj);
    }(obj)) {
        var parts = $bdd166eca2c549e0$var$arrObjKeys(obj, inspect);
        return "cause" in Error.prototype || !("cause" in obj) || $bdd166eca2c549e0$var$isEnumerable.call(obj, "cause") ? 0 === parts.length ? "[" + String(obj) + "]" : "{ [" + String(obj) + "] " + $bdd166eca2c549e0$var$$join.call(parts, ", ") + " }" : "{ [" + String(obj) + "] " + $bdd166eca2c549e0$var$$join.call($bdd166eca2c549e0$var$$concat$1.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
    }
    if ("object" == typeof obj && customInspect) {
        if ($bdd166eca2c549e0$var$inspectSymbol && "function" == typeof obj[$bdd166eca2c549e0$var$inspectSymbol] && $bdd166eca2c549e0$var$semver) return $bdd166eca2c549e0$var$semver(obj, {
            depth: maxDepth - depth
        });
        if ("symbol" !== customInspect && "function" == typeof obj.inspect) return obj.inspect();
    }
    if (function(x) {
        if (!$bdd166eca2c549e0$var$mapSize || !x || "object" != typeof x) return !1;
        try {
            $bdd166eca2c549e0$var$mapSize.call(x);
            try {
                $bdd166eca2c549e0$var$setSize.call(x);
            } catch (s) {
                return !0;
            }
            return x instanceof Map;
        } catch (e) {}
        return !1;
    }(obj)) {
        var mapParts = [];
        return $bdd166eca2c549e0$var$mapForEach && $bdd166eca2c549e0$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, !0) + " => " + inspect(value, obj));
        }), $bdd166eca2c549e0$var$collectionOf("Map", $bdd166eca2c549e0$var$mapSize.call(obj), mapParts, indent);
    }
    if (function(x) {
        if (!$bdd166eca2c549e0$var$setSize || !x || "object" != typeof x) return !1;
        try {
            $bdd166eca2c549e0$var$setSize.call(x);
            try {
                $bdd166eca2c549e0$var$mapSize.call(x);
            } catch (m) {
                return !0;
            }
            return x instanceof Set;
        } catch (e) {}
        return !1;
    }(obj)) {
        var setParts = [];
        return $bdd166eca2c549e0$var$setForEach && $bdd166eca2c549e0$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        }), $bdd166eca2c549e0$var$collectionOf("Set", $bdd166eca2c549e0$var$setSize.call(obj), setParts, indent);
    }
    if (function(x) {
        if (!$bdd166eca2c549e0$var$weakMapHas || !x || "object" != typeof x) return !1;
        try {
            $bdd166eca2c549e0$var$weakMapHas.call(x, $bdd166eca2c549e0$var$weakMapHas);
            try {
                $bdd166eca2c549e0$var$weakSetHas.call(x, $bdd166eca2c549e0$var$weakSetHas);
            } catch (s) {
                return !0;
            }
            return x instanceof WeakMap;
        } catch (e) {}
        return !1;
    }(obj)) return $bdd166eca2c549e0$var$weakCollectionOf("WeakMap");
    if (function(x) {
        if (!$bdd166eca2c549e0$var$weakSetHas || !x || "object" != typeof x) return !1;
        try {
            $bdd166eca2c549e0$var$weakSetHas.call(x, $bdd166eca2c549e0$var$weakSetHas);
            try {
                $bdd166eca2c549e0$var$weakMapHas.call(x, $bdd166eca2c549e0$var$weakMapHas);
            } catch (s) {
                return !0;
            }
            return x instanceof WeakSet;
        } catch (e) {}
        return !1;
    }(obj)) return $bdd166eca2c549e0$var$weakCollectionOf("WeakSet");
    if (function(x) {
        if (!$bdd166eca2c549e0$var$weakRefDeref || !x || "object" != typeof x) return !1;
        try {
            return $bdd166eca2c549e0$var$weakRefDeref.call(x), !0;
        } catch (e) {}
        return !1;
    }(obj)) return $bdd166eca2c549e0$var$weakCollectionOf("WeakRef");
    if (function(obj) {
        return !("[object Number]" !== $bdd166eca2c549e0$var$toStr$1(obj) || $bdd166eca2c549e0$var$toStringTag && "object" == typeof obj && $bdd166eca2c549e0$var$toStringTag in obj);
    }(obj)) return $bdd166eca2c549e0$var$markBoxed(inspect(Number(obj)));
    if (function(obj) {
        if (!obj || "object" != typeof obj || !$bdd166eca2c549e0$var$bigIntValueOf) return !1;
        try {
            return $bdd166eca2c549e0$var$bigIntValueOf.call(obj), !0;
        } catch (e) {}
        return !1;
    }(obj)) return $bdd166eca2c549e0$var$markBoxed(inspect($bdd166eca2c549e0$var$bigIntValueOf.call(obj)));
    if (function(obj) {
        return !("[object Boolean]" !== $bdd166eca2c549e0$var$toStr$1(obj) || $bdd166eca2c549e0$var$toStringTag && "object" == typeof obj && $bdd166eca2c549e0$var$toStringTag in obj);
    }(obj)) return $bdd166eca2c549e0$var$markBoxed($bdd166eca2c549e0$var$booleanValueOf.call(obj));
    if (function(obj) {
        return !("[object String]" !== $bdd166eca2c549e0$var$toStr$1(obj) || $bdd166eca2c549e0$var$toStringTag && "object" == typeof obj && $bdd166eca2c549e0$var$toStringTag in obj);
    }(obj)) return $bdd166eca2c549e0$var$markBoxed(inspect(String(obj)));
    if (!function(obj) {
        return !("[object Date]" !== $bdd166eca2c549e0$var$toStr$1(obj) || $bdd166eca2c549e0$var$toStringTag && "object" == typeof obj && $bdd166eca2c549e0$var$toStringTag in obj);
    }(obj) && !$bdd166eca2c549e0$var$isRegExp(obj)) {
        var ys = $bdd166eca2c549e0$var$arrObjKeys(obj, inspect), isPlainObject = $bdd166eca2c549e0$var$gPO ? $bdd166eca2c549e0$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object, protoTag = obj instanceof Object ? "" : "null prototype", stringTag = !isPlainObject && $bdd166eca2c549e0$var$toStringTag && Object(obj) === obj && $bdd166eca2c549e0$var$toStringTag in obj ? $bdd166eca2c549e0$var$$slice.call($bdd166eca2c549e0$var$toStr$1(obj), 8, -1) : protoTag ? "Object" : "", tag = (isPlainObject || "function" != typeof obj.constructor ? "" : obj.constructor.name ? obj.constructor.name + " " : "") + (stringTag || protoTag ? "[" + $bdd166eca2c549e0$var$$join.call($bdd166eca2c549e0$var$$concat$1.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        return 0 === ys.length ? tag + "{}" : indent ? tag + "{" + $bdd166eca2c549e0$var$indentedJoin(ys, indent) + "}" : tag + "{ " + $bdd166eca2c549e0$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $bdd166eca2c549e0$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = "double" === (opts.quoteStyle || defaultStyle) ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $bdd166eca2c549e0$var$quote(s) {
    return $bdd166eca2c549e0$var$$replace$1.call(String(s), /"/g, "&quot;");
}
function $bdd166eca2c549e0$var$isArray(obj) {
    return !("[object Array]" !== $bdd166eca2c549e0$var$toStr$1(obj) || $bdd166eca2c549e0$var$toStringTag && "object" == typeof obj && $bdd166eca2c549e0$var$toStringTag in obj);
}
function $bdd166eca2c549e0$var$isRegExp(obj) {
    return !("[object RegExp]" !== $bdd166eca2c549e0$var$toStr$1(obj) || $bdd166eca2c549e0$var$toStringTag && "object" == typeof obj && $bdd166eca2c549e0$var$toStringTag in obj);
}
function $bdd166eca2c549e0$var$isSymbol(obj) {
    if ($bdd166eca2c549e0$var$hasShammedSymbols) return obj && "object" == typeof obj && obj instanceof Symbol;
    if ("symbol" == typeof obj) return !0;
    if (!obj || "object" != typeof obj || !$bdd166eca2c549e0$var$symToString) return !1;
    try {
        return $bdd166eca2c549e0$var$symToString.call(obj), !0;
    } catch (e) {}
    return !1;
}
var $bdd166eca2c549e0$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $bdd166eca2c549e0$var$has(obj, key) {
    return $bdd166eca2c549e0$var$hasOwn.call(obj, key);
}
function $bdd166eca2c549e0$var$toStr$1(obj) {
    return $bdd166eca2c549e0$var$objectToString.call(obj);
}
function $bdd166eca2c549e0$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++)if (xs[i] === x) return i;
    return -1;
}
function $bdd166eca2c549e0$var$lowbyte(c) {
    var n = c.charCodeAt(0), x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    return x ? "\\" + x : "\\x" + (n < 16 ? "0" : "") + $bdd166eca2c549e0$var$$toUpperCase.call(n.toString(16));
}
function $bdd166eca2c549e0$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $bdd166eca2c549e0$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $bdd166eca2c549e0$var$collectionOf(type, size, entries, indent) {
    return type + " (" + size + ") {" + (indent ? $bdd166eca2c549e0$var$indentedJoin(entries, indent) : $bdd166eca2c549e0$var$$join.call(entries, ", ")) + "}";
}
function $bdd166eca2c549e0$var$indentedJoin(xs, indent) {
    if (0 === xs.length) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $bdd166eca2c549e0$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $bdd166eca2c549e0$var$arrObjKeys(obj, inspect) {
    var isArr = $bdd166eca2c549e0$var$isArray(obj), xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $bdd166eca2c549e0$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var symMap, syms = "function" == typeof $bdd166eca2c549e0$var$gOPS ? $bdd166eca2c549e0$var$gOPS(obj) : [];
    if ($bdd166eca2c549e0$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj)$bdd166eca2c549e0$var$has(obj, key) && (isArr && String(Number(key)) === key && key < obj.length || $bdd166eca2c549e0$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol || ($bdd166eca2c549e0$var$$test.call(/[^\w$]/, key) ? xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj)) : xs.push(key + ": " + inspect(obj[key], obj))));
    if ("function" == typeof $bdd166eca2c549e0$var$gOPS) for(var j = 0; j < syms.length; j++)$bdd166eca2c549e0$var$isEnumerable.call(obj, syms[j]) && xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    return xs;
}
var $bdd166eca2c549e0$var$$TypeError$1 = $bdd166eca2c549e0$var$getIntrinsic("%TypeError%"), $bdd166eca2c549e0$var$$WeakMap = $bdd166eca2c549e0$var$getIntrinsic("%WeakMap%", !0), $bdd166eca2c549e0$var$$Map = $bdd166eca2c549e0$var$getIntrinsic("%Map%", !0), $bdd166eca2c549e0$var$$weakMapGet = $bdd166eca2c549e0$var$callBound("WeakMap.prototype.get", !0), $bdd166eca2c549e0$var$$weakMapSet = $bdd166eca2c549e0$var$callBound("WeakMap.prototype.set", !0), $bdd166eca2c549e0$var$$weakMapHas = $bdd166eca2c549e0$var$callBound("WeakMap.prototype.has", !0), $bdd166eca2c549e0$var$$mapGet = $bdd166eca2c549e0$var$callBound("Map.prototype.get", !0), $bdd166eca2c549e0$var$$mapSet = $bdd166eca2c549e0$var$callBound("Map.prototype.set", !0), $bdd166eca2c549e0$var$$mapHas = $bdd166eca2c549e0$var$callBound("Map.prototype.has", !0), $bdd166eca2c549e0$var$listGetNode = function(list, key) {
    for(var curr, prev = list; null !== (curr = prev.next); prev = curr)if (curr.key === key) return prev.next = curr.next, curr.next = list.next, list.next = curr, curr;
}, $bdd166eca2c549e0$var$sideChannel = function() {
    var $wm, $m, $o, channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $bdd166eca2c549e0$var$$TypeError$1("Side channel does not contain " + $bdd166eca2c549e0$var$objectInspect(key));
        },
        get: function(key) {
            if ($bdd166eca2c549e0$var$$WeakMap && key && ("object" == typeof key || "function" == typeof key)) {
                if ($wm) return $bdd166eca2c549e0$var$$weakMapGet($wm, key);
            } else if ($bdd166eca2c549e0$var$$Map) {
                if ($m) return $bdd166eca2c549e0$var$$mapGet($m, key);
            } else if ($o) return function(objects, key) {
                var node = $bdd166eca2c549e0$var$listGetNode(objects, key);
                return node && node.value;
            }($o, key);
        },
        has: function(key) {
            if ($bdd166eca2c549e0$var$$WeakMap && key && ("object" == typeof key || "function" == typeof key)) {
                if ($wm) return $bdd166eca2c549e0$var$$weakMapHas($wm, key);
            } else if ($bdd166eca2c549e0$var$$Map) {
                if ($m) return $bdd166eca2c549e0$var$$mapHas($m, key);
            } else if ($o) return function(objects, key) {
                return !!$bdd166eca2c549e0$var$listGetNode(objects, key);
            }($o, key);
            return !1;
        },
        set: function(key, value) {
            $bdd166eca2c549e0$var$$WeakMap && key && ("object" == typeof key || "function" == typeof key) ? ($wm || ($wm = new $bdd166eca2c549e0$var$$WeakMap), $bdd166eca2c549e0$var$$weakMapSet($wm, key, value)) : $bdd166eca2c549e0$var$$Map ? ($m || ($m = new $bdd166eca2c549e0$var$$Map), $bdd166eca2c549e0$var$$mapSet($m, key, value)) : ($o || ($o = {
                key: {},
                next: null
            }), function(objects, key, value) {
                var node = $bdd166eca2c549e0$var$listGetNode(objects, key);
                node ? node.value = value : objects.next = {
                    key: key,
                    next: objects.next,
                    value: value
                };
            }($o, key, value));
        }
    };
    return channel;
}, $bdd166eca2c549e0$var$replace = String.prototype.replace, $bdd166eca2c549e0$var$percentTwenties = /%20/g, $bdd166eca2c549e0$var$Format_RFC3986 = "RFC3986", $bdd166eca2c549e0$var$formats = {
    default: $bdd166eca2c549e0$var$Format_RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $bdd166eca2c549e0$var$replace.call(value, $bdd166eca2c549e0$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: "RFC1738",
    RFC3986: $bdd166eca2c549e0$var$Format_RFC3986
}, $bdd166eca2c549e0$var$has$1 = Object.prototype.hasOwnProperty, $bdd166eca2c549e0$var$isArray$1 = Array.isArray, $bdd166eca2c549e0$var$hexTable = function() {
    for(var array = [], i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}(), $bdd166eca2c549e0$var$arrayToObject = function(source, options) {
    for(var obj = options && options.plainObjects ? Object.create(null) : {}, i = 0; i < source.length; ++i)void 0 !== source[i] && (obj[i] = source[i]);
    return obj;
}, $bdd166eca2c549e0$var$utils = {
    arrayToObject: $bdd166eca2c549e0$var$arrayToObject,
    assign: function(target, source) {
        return Object.keys(source).reduce(function(acc, key) {
            return acc[key] = source[key], acc;
        }, target);
    },
    combine: function(a, b) {
        return [].concat(a, b);
    },
    compact: function(value) {
        for(var queue = [
            {
                obj: {
                    o: value
                },
                prop: "o"
            }
        ], refs = [], i = 0; i < queue.length; ++i)for(var item = queue[i], obj = item.obj[item.prop], keys = Object.keys(obj), j = 0; j < keys.length; ++j){
            var key = keys[j], val = obj[key];
            "object" == typeof val && null !== val && -1 === refs.indexOf(val) && (queue.push({
                obj: obj,
                prop: key
            }), refs.push(val));
        }
        return function(queue) {
            for(; queue.length > 1;){
                var item = queue.pop(), obj = item.obj[item.prop];
                if ($bdd166eca2c549e0$var$isArray$1(obj)) {
                    for(var compacted = [], j = 0; j < obj.length; ++j)void 0 !== obj[j] && compacted.push(obj[j]);
                    item.obj[item.prop] = compacted;
                }
            }
        }(queue), value;
    },
    decode: function(str, decoder, charset) {
        var strWithoutPlus = str.replace(/\+/g, " ");
        if ("iso-8859-1" === charset) return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
        try {
            return decodeURIComponent(strWithoutPlus);
        } catch (e) {
            return strWithoutPlus;
        }
    },
    encode: function(str, defaultEncoder, charset, kind, format) {
        if (0 === str.length) return str;
        var string = str;
        if ("symbol" == typeof str ? string = Symbol.prototype.toString.call(str) : "string" != typeof str && (string = String(str)), "iso-8859-1" === charset) return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
            return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
        });
        for(var out = "", i = 0; i < string.length; ++i){
            var c = string.charCodeAt(i);
            45 === c || 46 === c || 95 === c || 126 === c || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || format === $bdd166eca2c549e0$var$formats.RFC1738 && (40 === c || 41 === c) ? out += string.charAt(i) : c < 128 ? out += $bdd166eca2c549e0$var$hexTable[c] : c < 2048 ? out += $bdd166eca2c549e0$var$hexTable[192 | c >> 6] + $bdd166eca2c549e0$var$hexTable[128 | 63 & c] : c < 55296 || c >= 57344 ? out += $bdd166eca2c549e0$var$hexTable[224 | c >> 12] + $bdd166eca2c549e0$var$hexTable[128 | c >> 6 & 63] + $bdd166eca2c549e0$var$hexTable[128 | 63 & c] : (i += 1, c = 65536 + ((1023 & c) << 10 | 1023 & string.charCodeAt(i)), out += $bdd166eca2c549e0$var$hexTable[240 | c >> 18] + $bdd166eca2c549e0$var$hexTable[128 | c >> 12 & 63] + $bdd166eca2c549e0$var$hexTable[128 | c >> 6 & 63] + $bdd166eca2c549e0$var$hexTable[128 | 63 & c]);
        }
        return out;
    },
    isBuffer: function(obj) {
        return !(!obj || "object" != typeof obj) && !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
    },
    isRegExp: function(obj) {
        return "[object RegExp]" === Object.prototype.toString.call(obj);
    },
    maybeMap: function(val, fn) {
        if ($bdd166eca2c549e0$var$isArray$1(val)) {
            for(var mapped = [], i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
            return mapped;
        }
        return fn(val);
    },
    merge: function merge(target, source, options) {
        if (!source) return target;
        if ("object" != typeof source) {
            if ($bdd166eca2c549e0$var$isArray$1(target)) target.push(source);
            else {
                if (!target || "object" != typeof target) return [
                    target,
                    source
                ];
                (options && (options.plainObjects || options.allowPrototypes) || !$bdd166eca2c549e0$var$has$1.call(Object.prototype, source)) && (target[source] = !0);
            }
            return target;
        }
        if (!target || "object" != typeof target) return [
            target
        ].concat(source);
        var mergeTarget = target;
        return $bdd166eca2c549e0$var$isArray$1(target) && !$bdd166eca2c549e0$var$isArray$1(source) && (mergeTarget = $bdd166eca2c549e0$var$arrayToObject(target, options)), $bdd166eca2c549e0$var$isArray$1(target) && $bdd166eca2c549e0$var$isArray$1(source) ? (source.forEach(function(item, i) {
            if ($bdd166eca2c549e0$var$has$1.call(target, i)) {
                var targetItem = target[i];
                targetItem && "object" == typeof targetItem && item && "object" == typeof item ? target[i] = merge(targetItem, item, options) : target.push(item);
            } else target[i] = item;
        }), target) : Object.keys(source).reduce(function(acc, key) {
            var value = source[key];
            return $bdd166eca2c549e0$var$has$1.call(acc, key) ? acc[key] = merge(acc[key], value, options) : acc[key] = value, acc;
        }, mergeTarget);
    }
}, $bdd166eca2c549e0$var$has$2 = Object.prototype.hasOwnProperty, $bdd166eca2c549e0$var$arrayPrefixGenerators = {
    brackets: function(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function(prefix) {
        return prefix;
    }
}, $bdd166eca2c549e0$var$isArray$2 = Array.isArray, $bdd166eca2c549e0$var$push = Array.prototype.push, $bdd166eca2c549e0$var$pushToArray = function(arr, valueOrArray) {
    $bdd166eca2c549e0$var$push.apply(arr, $bdd166eca2c549e0$var$isArray$2(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
}, $bdd166eca2c549e0$var$toISO = Date.prototype.toISOString, $bdd166eca2c549e0$var$defaultFormat = $bdd166eca2c549e0$var$formats.default, $bdd166eca2c549e0$var$defaults = {
    addQueryPrefix: !1,
    allowDots: !1,
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encoder: $bdd166eca2c549e0$var$utils.encode,
    encodeValuesOnly: !1,
    format: $bdd166eca2c549e0$var$defaultFormat,
    formatter: $bdd166eca2c549e0$var$formats.formatters[$bdd166eca2c549e0$var$defaultFormat],
    indices: !1,
    serializeDate: function(date) {
        return $bdd166eca2c549e0$var$toISO.call(date);
    },
    skipNulls: !1,
    strictNullHandling: !1
}, $bdd166eca2c549e0$var$sentinel = {}, $bdd166eca2c549e0$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel$1) {
    for(var obj = object, tmpSc = sideChannel$1, step = 0, findFlag = !1; void 0 !== (tmpSc = tmpSc.get($bdd166eca2c549e0$var$sentinel)) && !findFlag;){
        var pos = tmpSc.get(object);
        if (step += 1, void 0 !== pos) {
            if (pos === step) throw new RangeError("Cyclic object value");
            findFlag = !0;
        }
        void 0 === tmpSc.get($bdd166eca2c549e0$var$sentinel) && (step = 0);
    }
    if ("function" == typeof filter ? obj = filter(prefix, obj) : obj instanceof Date ? obj = serializeDate(obj) : "comma" === generateArrayPrefix && $bdd166eca2c549e0$var$isArray$2(obj) && (obj = $bdd166eca2c549e0$var$utils.maybeMap(obj, function(value) {
        return value instanceof Date ? serializeDate(value) : value;
    })), null === obj) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $bdd166eca2c549e0$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if (function(v) {
        return "string" == typeof v || "number" == typeof v || "boolean" == typeof v || "symbol" == typeof v || "bigint" == typeof v;
    }(obj) || $bdd166eca2c549e0$var$utils.isBuffer(obj)) return encoder ? [
        formatter(encodeValuesOnly ? prefix : encoder(prefix, $bdd166eca2c549e0$var$defaults.encoder, charset, "key", format)) + "=" + formatter(encoder(obj, $bdd166eca2c549e0$var$defaults.encoder, charset, "value", format))
    ] : [
        formatter(prefix) + "=" + formatter(String(obj))
    ];
    var objKeys, values = [];
    if (void 0 === obj) return values;
    if ("comma" === generateArrayPrefix && $bdd166eca2c549e0$var$isArray$2(obj)) encodeValuesOnly && encoder && (obj = $bdd166eca2c549e0$var$utils.maybeMap(obj, encoder)), objKeys = [
        {
            value: obj.length > 0 ? obj.join(",") || null : void 0
        }
    ];
    else if ($bdd166eca2c549e0$var$isArray$2(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var adjustedPrefix = commaRoundTrip && $bdd166eca2c549e0$var$isArray$2(obj) && 1 === obj.length ? prefix + "[]" : prefix, j = 0; j < objKeys.length; ++j){
        var key = objKeys[j], value = "object" == typeof key && void 0 !== key.value ? key.value : obj[key];
        if (!skipNulls || null !== value) {
            var keyPrefix = $bdd166eca2c549e0$var$isArray$2(obj) ? "function" == typeof generateArrayPrefix ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
            sideChannel$1.set(object, step);
            var valueSideChannel = $bdd166eca2c549e0$var$sideChannel();
            valueSideChannel.set($bdd166eca2c549e0$var$sentinel, sideChannel$1), $bdd166eca2c549e0$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, "comma" === generateArrayPrefix && encodeValuesOnly && $bdd166eca2c549e0$var$isArray$2(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
        }
    }
    return values;
}, $bdd166eca2c549e0$var$has$3 = Object.prototype.hasOwnProperty, $bdd166eca2c549e0$var$isArray$3 = Array.isArray, $bdd166eca2c549e0$var$defaults$1 = {
    allowDots: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decoder: $bdd166eca2c549e0$var$utils.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictNullHandling: !1
}, $bdd166eca2c549e0$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
}, $bdd166eca2c549e0$var$parseArrayValue = function(val, options) {
    return val && "string" == typeof val && options.comma && val.indexOf(",") > -1 ? val.split(",") : val;
}, $bdd166eca2c549e0$var$parseKeys = function(givenKey, val, options, valuesParsed) {
    if (givenKey) {
        var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey, child = /(\[[^[\]]*])/g, segment = options.depth > 0 && /(\[[^[\]]*])/.exec(key), parent = segment ? key.slice(0, segment.index) : key, keys = [];
        if (parent) {
            if (!options.plainObjects && $bdd166eca2c549e0$var$has$3.call(Object.prototype, parent) && !options.allowPrototypes) return;
            keys.push(parent);
        }
        for(var i = 0; options.depth > 0 && null !== (segment = child.exec(key)) && i < options.depth;){
            if (i += 1, !options.plainObjects && $bdd166eca2c549e0$var$has$3.call(Object.prototype, segment[1].slice(1, -1)) && !options.allowPrototypes) return;
            keys.push(segment[1]);
        }
        return segment && keys.push("[" + key.slice(segment.index) + "]"), function(chain, val, options, valuesParsed) {
            for(var leaf = valuesParsed ? val : $bdd166eca2c549e0$var$parseArrayValue(val, options), i = chain.length - 1; i >= 0; --i){
                var obj, root = chain[i];
                if ("[]" === root && options.parseArrays) obj = [].concat(leaf);
                else {
                    obj = options.plainObjects ? Object.create(null) : {};
                    var cleanRoot = "[" === root.charAt(0) && "]" === root.charAt(root.length - 1) ? root.slice(1, -1) : root, index = parseInt(cleanRoot, 10);
                    options.parseArrays || "" !== cleanRoot ? !isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit ? (obj = [])[index] = leaf : "__proto__" !== cleanRoot && (obj[cleanRoot] = leaf) : obj = {
                        0: leaf
                    };
                }
                leaf = obj;
            }
            return leaf;
        }(keys, val, options, valuesParsed);
    }
}, $bdd166eca2c549e0$var$lib = {
    formats: $bdd166eca2c549e0$var$formats,
    parse: function(str, opts) {
        var options = function(opts) {
            if (!opts) return $bdd166eca2c549e0$var$defaults$1;
            if (null !== opts.decoder && void 0 !== opts.decoder && "function" != typeof opts.decoder) throw new TypeError("Decoder has to be a function.");
            if (void 0 !== opts.charset && "utf-8" !== opts.charset && "iso-8859-1" !== opts.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
            var charset = void 0 === opts.charset ? $bdd166eca2c549e0$var$defaults$1.charset : opts.charset;
            return {
                allowDots: void 0 === opts.allowDots ? $bdd166eca2c549e0$var$defaults$1.allowDots : !!opts.allowDots,
                allowPrototypes: "boolean" == typeof opts.allowPrototypes ? opts.allowPrototypes : $bdd166eca2c549e0$var$defaults$1.allowPrototypes,
                allowSparse: "boolean" == typeof opts.allowSparse ? opts.allowSparse : $bdd166eca2c549e0$var$defaults$1.allowSparse,
                arrayLimit: "number" == typeof opts.arrayLimit ? opts.arrayLimit : $bdd166eca2c549e0$var$defaults$1.arrayLimit,
                charset: charset,
                charsetSentinel: "boolean" == typeof opts.charsetSentinel ? opts.charsetSentinel : $bdd166eca2c549e0$var$defaults$1.charsetSentinel,
                comma: "boolean" == typeof opts.comma ? opts.comma : $bdd166eca2c549e0$var$defaults$1.comma,
                decoder: "function" == typeof opts.decoder ? opts.decoder : $bdd166eca2c549e0$var$defaults$1.decoder,
                delimiter: "string" == typeof opts.delimiter || $bdd166eca2c549e0$var$utils.isRegExp(opts.delimiter) ? opts.delimiter : $bdd166eca2c549e0$var$defaults$1.delimiter,
                depth: "number" == typeof opts.depth || !1 === opts.depth ? +opts.depth : $bdd166eca2c549e0$var$defaults$1.depth,
                ignoreQueryPrefix: !0 === opts.ignoreQueryPrefix,
                interpretNumericEntities: "boolean" == typeof opts.interpretNumericEntities ? opts.interpretNumericEntities : $bdd166eca2c549e0$var$defaults$1.interpretNumericEntities,
                parameterLimit: "number" == typeof opts.parameterLimit ? opts.parameterLimit : $bdd166eca2c549e0$var$defaults$1.parameterLimit,
                parseArrays: !1 !== opts.parseArrays,
                plainObjects: "boolean" == typeof opts.plainObjects ? opts.plainObjects : $bdd166eca2c549e0$var$defaults$1.plainObjects,
                strictNullHandling: "boolean" == typeof opts.strictNullHandling ? opts.strictNullHandling : $bdd166eca2c549e0$var$defaults$1.strictNullHandling
            };
        }(opts);
        if ("" === str || null == str) return options.plainObjects ? Object.create(null) : {};
        for(var tempObj = "string" == typeof str ? function(str, options) {
            var i, obj = {
                __proto__: null
            }, cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str, limit = options.parameterLimit === 1 / 0 ? void 0 : options.parameterLimit, parts = cleanStr.split(options.delimiter, limit), skipIndex = -1, charset = options.charset;
            if (options.charsetSentinel) for(i = 0; i < parts.length; ++i)0 === parts[i].indexOf("utf8=") && ("utf8=%E2%9C%93" === parts[i] ? charset = "utf-8" : "utf8=%26%2310003%3B" === parts[i] && (charset = "iso-8859-1"), skipIndex = i, i = parts.length);
            for(i = 0; i < parts.length; ++i)if (i !== skipIndex) {
                var key, val, part = parts[i], bracketEqualsPos = part.indexOf("]="), pos = -1 === bracketEqualsPos ? part.indexOf("=") : bracketEqualsPos + 1;
                -1 === pos ? (key = options.decoder(part, $bdd166eca2c549e0$var$defaults$1.decoder, charset, "key"), val = options.strictNullHandling ? null : "") : (key = options.decoder(part.slice(0, pos), $bdd166eca2c549e0$var$defaults$1.decoder, charset, "key"), val = $bdd166eca2c549e0$var$utils.maybeMap($bdd166eca2c549e0$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                    return options.decoder(encodedVal, $bdd166eca2c549e0$var$defaults$1.decoder, charset, "value");
                })), val && options.interpretNumericEntities && "iso-8859-1" === charset && (val = $bdd166eca2c549e0$var$interpretNumericEntities(val)), part.indexOf("[]=") > -1 && (val = $bdd166eca2c549e0$var$isArray$3(val) ? [
                    val
                ] : val), $bdd166eca2c549e0$var$has$3.call(obj, key) ? obj[key] = $bdd166eca2c549e0$var$utils.combine(obj[key], val) : obj[key] = val;
            }
            return obj;
        }(str, options) : str, obj = options.plainObjects ? Object.create(null) : {}, keys = Object.keys(tempObj), i = 0; i < keys.length; ++i){
            var key = keys[i], newObj = $bdd166eca2c549e0$var$parseKeys(key, tempObj[key], options, "string" == typeof str);
            obj = $bdd166eca2c549e0$var$utils.merge(obj, newObj, options);
        }
        return !0 === options.allowSparse ? obj : $bdd166eca2c549e0$var$utils.compact(obj);
    },
    stringify: function(object, opts) {
        var objKeys, obj = object, options = function(opts) {
            if (!opts) return $bdd166eca2c549e0$var$defaults;
            if (null !== opts.encoder && void 0 !== opts.encoder && "function" != typeof opts.encoder) throw new TypeError("Encoder has to be a function.");
            var charset = opts.charset || $bdd166eca2c549e0$var$defaults.charset;
            if (void 0 !== opts.charset && "utf-8" !== opts.charset && "iso-8859-1" !== opts.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
            var format = $bdd166eca2c549e0$var$formats.default;
            if (void 0 !== opts.format) {
                if (!$bdd166eca2c549e0$var$has$2.call($bdd166eca2c549e0$var$formats.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
                format = opts.format;
            }
            var formatter = $bdd166eca2c549e0$var$formats.formatters[format], filter = $bdd166eca2c549e0$var$defaults.filter;
            return ("function" == typeof opts.filter || $bdd166eca2c549e0$var$isArray$2(opts.filter)) && (filter = opts.filter), {
                addQueryPrefix: "boolean" == typeof opts.addQueryPrefix ? opts.addQueryPrefix : $bdd166eca2c549e0$var$defaults.addQueryPrefix,
                allowDots: void 0 === opts.allowDots ? $bdd166eca2c549e0$var$defaults.allowDots : !!opts.allowDots,
                charset: charset,
                charsetSentinel: "boolean" == typeof opts.charsetSentinel ? opts.charsetSentinel : $bdd166eca2c549e0$var$defaults.charsetSentinel,
                delimiter: void 0 === opts.delimiter ? $bdd166eca2c549e0$var$defaults.delimiter : opts.delimiter,
                encode: "boolean" == typeof opts.encode ? opts.encode : $bdd166eca2c549e0$var$defaults.encode,
                encoder: "function" == typeof opts.encoder ? opts.encoder : $bdd166eca2c549e0$var$defaults.encoder,
                encodeValuesOnly: "boolean" == typeof opts.encodeValuesOnly ? opts.encodeValuesOnly : $bdd166eca2c549e0$var$defaults.encodeValuesOnly,
                filter: filter,
                format: format,
                formatter: formatter,
                serializeDate: "function" == typeof opts.serializeDate ? opts.serializeDate : $bdd166eca2c549e0$var$defaults.serializeDate,
                skipNulls: "boolean" == typeof opts.skipNulls ? opts.skipNulls : $bdd166eca2c549e0$var$defaults.skipNulls,
                sort: "function" == typeof opts.sort ? opts.sort : null,
                strictNullHandling: "boolean" == typeof opts.strictNullHandling ? opts.strictNullHandling : $bdd166eca2c549e0$var$defaults.strictNullHandling
            };
        }(opts);
        "function" == typeof options.filter ? obj = (0, options.filter)("", obj) : $bdd166eca2c549e0$var$isArray$2(options.filter) && (objKeys = options.filter);
        var arrayFormat, keys = [];
        if ("object" != typeof obj || null === obj) return "";
        arrayFormat = opts && opts.arrayFormat in $bdd166eca2c549e0$var$arrayPrefixGenerators ? opts.arrayFormat : opts && "indices" in opts ? opts.indices ? "indices" : "repeat" : "indices";
        var generateArrayPrefix = $bdd166eca2c549e0$var$arrayPrefixGenerators[arrayFormat];
        if (opts && "commaRoundTrip" in opts && "boolean" != typeof opts.commaRoundTrip) throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
        var commaRoundTrip = "comma" === generateArrayPrefix && opts && opts.commaRoundTrip;
        objKeys || (objKeys = Object.keys(obj)), options.sort && objKeys.sort(options.sort);
        for(var sideChannel$1 = $bdd166eca2c549e0$var$sideChannel(), i = 0; i < objKeys.length; ++i){
            var key = objKeys[i];
            options.skipNulls && null === obj[key] || $bdd166eca2c549e0$var$pushToArray(keys, $bdd166eca2c549e0$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel$1));
        }
        var joined = keys.join(options.delimiter), prefix = !0 === options.addQueryPrefix ? "?" : "";
        return options.charsetSentinel && ("iso-8859-1" === options.charset ? prefix += "utf8=%26%2310003%3B&" : prefix += "utf8=%E2%9C%93&"), joined.length > 0 ? prefix + joined : "";
    }
}, $bdd166eca2c549e0$var$componentEmitter = $bdd166eca2c549e0$var$createCommonjsModule(function(module) {
    function Emitter(obj) {
        if (obj) return function(obj) {
            for(var key in Emitter.prototype)obj[key] = Emitter.prototype[key];
            return obj;
        }(obj);
    }
    module.exports = Emitter, Emitter.prototype.on = Emitter.prototype.addEventListener = function(event, fn) {
        return this._callbacks = this._callbacks || {}, (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn), this;
    }, Emitter.prototype.once = function(event, fn) {
        function on() {
            this.off(event, on), fn.apply(this, arguments);
        }
        return on.fn = fn, this.on(event, on), this;
    }, Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function(event, fn) {
        if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
        var cb, callbacks = this._callbacks["$" + event];
        if (!callbacks) return this;
        if (1 == arguments.length) return delete this._callbacks["$" + event], this;
        for(var i = 0; i < callbacks.length; i++)if ((cb = callbacks[i]) === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
        return 0 === callbacks.length && delete this._callbacks["$" + event], this;
    }, Emitter.prototype.emit = function(event) {
        this._callbacks = this._callbacks || {};
        for(var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event], i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
        if (callbacks) {
            i = 0;
            for(var len = (callbacks = callbacks.slice(0)).length; i < len; ++i)callbacks[i].apply(this, args);
        }
        return this;
    }, Emitter.prototype.listeners = function(event) {
        return this._callbacks = this._callbacks || {}, this._callbacks["$" + event] || [];
    }, Emitter.prototype.hasListeners = function(event) {
        return !!this.listeners(event).length;
    };
}), $bdd166eca2c549e0$var$fastSafeStringify = $bdd166eca2c549e0$var$stringify$1;
$bdd166eca2c549e0$var$stringify$1.default = $bdd166eca2c549e0$var$stringify$1, $bdd166eca2c549e0$var$stringify$1.stable = $bdd166eca2c549e0$var$deterministicStringify, $bdd166eca2c549e0$var$stringify$1.stableStringify = $bdd166eca2c549e0$var$deterministicStringify;
var $bdd166eca2c549e0$var$arr = [], $bdd166eca2c549e0$var$replacerStack = [];
function $bdd166eca2c549e0$var$defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
function $bdd166eca2c549e0$var$stringify$1(obj, replacer, spacer, options) {
    var res;
    void 0 === options && (options = $bdd166eca2c549e0$var$defaultOptions()), function decirc(val, k, edgeIndex, stack, parent, depth, options) {
        var i;
        if (depth += 1, "object" == typeof val && null !== val) {
            for(i = 0; i < stack.length; i++)if (stack[i] === val) return void $bdd166eca2c549e0$var$setReplace("[Circular]", val, k, parent);
            if (void 0 !== options.depthLimit && depth > options.depthLimit) return void $bdd166eca2c549e0$var$setReplace("[...]", val, k, parent);
            if (void 0 !== options.edgesLimit && edgeIndex + 1 > options.edgesLimit) return void $bdd166eca2c549e0$var$setReplace("[...]", val, k, parent);
            if (stack.push(val), Array.isArray(val)) for(i = 0; i < val.length; i++)decirc(val[i], i, i, stack, val, depth, options);
            else {
                var keys = Object.keys(val);
                for(i = 0; i < keys.length; i++){
                    var key = keys[i];
                    decirc(val[key], key, i, stack, val, depth, options);
                }
            }
            stack.pop();
        }
    }(obj, "", 0, [], void 0, 0, options);
    try {
        res = 0 === $bdd166eca2c549e0$var$replacerStack.length ? JSON.stringify(obj, replacer, spacer) : JSON.stringify(obj, $bdd166eca2c549e0$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        for(; 0 !== $bdd166eca2c549e0$var$arr.length;){
            var part = $bdd166eca2c549e0$var$arr.pop();
            4 === part.length ? Object.defineProperty(part[0], part[1], part[3]) : part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $bdd166eca2c549e0$var$setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    void 0 !== propertyDescriptor.get ? propertyDescriptor.configurable ? (Object.defineProperty(parent, k, {
        value: replace
    }), $bdd166eca2c549e0$var$arr.push([
        parent,
        k,
        val,
        propertyDescriptor
    ])) : $bdd166eca2c549e0$var$replacerStack.push([
        val,
        k,
        replace
    ]) : (parent[k] = replace, $bdd166eca2c549e0$var$arr.push([
        parent,
        k,
        val
    ]));
}
function $bdd166eca2c549e0$var$compareFunction(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function $bdd166eca2c549e0$var$deterministicStringify(obj, replacer, spacer, options) {
    void 0 === options && (options = $bdd166eca2c549e0$var$defaultOptions());
    var res, tmp = function deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
        var i;
        if (depth += 1, "object" == typeof val && null !== val) {
            for(i = 0; i < stack.length; i++)if (stack[i] === val) return void $bdd166eca2c549e0$var$setReplace("[Circular]", val, k, parent);
            try {
                if ("function" == typeof val.toJSON) return;
            } catch (_) {
                return;
            }
            if (void 0 !== options.depthLimit && depth > options.depthLimit) return void $bdd166eca2c549e0$var$setReplace("[...]", val, k, parent);
            if (void 0 !== options.edgesLimit && edgeIndex + 1 > options.edgesLimit) return void $bdd166eca2c549e0$var$setReplace("[...]", val, k, parent);
            if (stack.push(val), Array.isArray(val)) for(i = 0; i < val.length; i++)deterministicDecirc(val[i], i, i, stack, val, depth, options);
            else {
                var tmp = {}, keys = Object.keys(val).sort($bdd166eca2c549e0$var$compareFunction);
                for(i = 0; i < keys.length; i++){
                    var key = keys[i];
                    deterministicDecirc(val[key], key, i, stack, val, depth, options), tmp[key] = val[key];
                }
                if (void 0 === parent) return tmp;
                $bdd166eca2c549e0$var$arr.push([
                    parent,
                    k,
                    val
                ]), parent[k] = tmp;
            }
            stack.pop();
        }
    }(obj, "", 0, [], void 0, 0, options) || obj;
    try {
        res = 0 === $bdd166eca2c549e0$var$replacerStack.length ? JSON.stringify(tmp, replacer, spacer) : JSON.stringify(tmp, $bdd166eca2c549e0$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        for(; 0 !== $bdd166eca2c549e0$var$arr.length;){
            var part = $bdd166eca2c549e0$var$arr.pop();
            4 === part.length ? Object.defineProperty(part[0], part[1], part[3]) : part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $bdd166eca2c549e0$var$replaceGetterValues(replacer) {
    return replacer = void 0 !== replacer ? replacer : function(k, v) {
        return v;
    }, function(key, val) {
        if ($bdd166eca2c549e0$var$replacerStack.length > 0) for(var i = 0; i < $bdd166eca2c549e0$var$replacerStack.length; i++){
            var part = $bdd166eca2c549e0$var$replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2], $bdd166eca2c549e0$var$replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}
var $bdd166eca2c549e0$var$utils$1 = $bdd166eca2c549e0$var$createCommonjsModule(function(module, exports) {
    function _typeof(obj) {
        return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        })(obj);
    }
    function _createForOfIteratorHelper(o, allowArrayLike) {
        var it = "undefined" != typeof Symbol && o[Symbol.iterator] || o["@@iterator"];
        if (!it) {
            if (Array.isArray(o) || (it = function(o, minLen) {
                if (!o) return;
                if ("string" == typeof o) return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                "Object" === n && o.constructor && (n = o.constructor.name);
                if ("Map" === n || "Set" === n) return Array.from(o);
                if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }(o)) || allowArrayLike && o && "number" == typeof o.length) {
                it && (o = it);
                var i = 0, F = function() {};
                return {
                    s: F,
                    n: function() {
                        return i >= o.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: o[i++]
                        };
                    },
                    e: function(_e) {
                        throw _e;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var err, normalCompletion = !0, didErr = !1;
        return {
            s: function() {
                it = it.call(o);
            },
            n: function() {
                var step = it.next();
                return normalCompletion = step.done, step;
            },
            e: function(_e2) {
                didErr = !0, err = _e2;
            },
            f: function() {
                try {
                    normalCompletion || null == it.return || it.return();
                } finally{
                    if (didErr) throw err;
                }
            }
        };
    }
    function _arrayLikeToArray(arr, len) {
        (null == len || len > arr.length) && (len = arr.length);
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    exports.type = function(string_) {
        return string_.split(/ *; */).shift();
    }, exports.params = function(value) {
        var _step, object = {}, _iterator = _createForOfIteratorHelper(value.split(/ *; */));
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var parts = _step.value.split(/ *= */), key = parts.shift(), _value = parts.shift();
                key && _value && (object[key] = _value);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return object;
    }, exports.parseLinks = function(value) {
        var _step2, object = {}, _iterator2 = _createForOfIteratorHelper(value.split(/ *, */));
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var parts = _step2.value.split(/ *; */), url = parts[0].slice(1, -1);
                object[parts[1].split(/ *= */)[1].slice(1, -1)] = url;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        return object;
    }, exports.cleanHeader = function(header, changesOrigin) {
        return delete header["content-type"], delete header["content-length"], delete header["transfer-encoding"], delete header.host, changesOrigin && (delete header.authorization, delete header.cookie), header;
    }, exports.isObject = function(object) {
        return null !== object && "object" === _typeof(object);
    }, exports.hasOwn = Object.hasOwn || function(object, property) {
        if (null == object) throw new TypeError("Cannot convert undefined or null to object");
        return Object.prototype.hasOwnProperty.call(new Object(object), property);
    }, exports.mixin = function(target, source) {
        for(var key in source)exports.hasOwn(source, key) && (target[key] = source[key]);
    };
});
$bdd166eca2c549e0$var$utils$1.type, $bdd166eca2c549e0$var$utils$1.params, $bdd166eca2c549e0$var$utils$1.parseLinks, $bdd166eca2c549e0$var$utils$1.cleanHeader, $bdd166eca2c549e0$var$utils$1.isObject, $bdd166eca2c549e0$var$utils$1.hasOwn, $bdd166eca2c549e0$var$utils$1.mixin;
function $bdd166eca2c549e0$var$_typeof(obj) {
    return ($bdd166eca2c549e0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    })(obj);
}
var $bdd166eca2c549e0$var$isObject = $bdd166eca2c549e0$var$utils$1.isObject, $bdd166eca2c549e0$var$hasOwn$1 = $bdd166eca2c549e0$var$utils$1.hasOwn, $bdd166eca2c549e0$var$requestBase = $bdd166eca2c549e0$var$RequestBase;
function $bdd166eca2c549e0$var$RequestBase() {}
$bdd166eca2c549e0$var$RequestBase.prototype.clearTimeout = function() {
    return clearTimeout(this._timer), clearTimeout(this._responseTimeoutTimer), clearTimeout(this._uploadTimeoutTimer), delete this._timer, delete this._responseTimeoutTimer, delete this._uploadTimeoutTimer, this;
}, $bdd166eca2c549e0$var$RequestBase.prototype.parse = function(fn) {
    return this._parser = fn, this;
}, $bdd166eca2c549e0$var$RequestBase.prototype.responseType = function(value) {
    return this._responseType = value, this;
}, $bdd166eca2c549e0$var$RequestBase.prototype.serialize = function(fn) {
    return this._serializer = fn, this;
}, $bdd166eca2c549e0$var$RequestBase.prototype.timeout = function(options) {
    if (!options || "object" !== $bdd166eca2c549e0$var$_typeof(options)) return this._timeout = options, this._responseTimeout = 0, this._uploadTimeout = 0, this;
    for(var option in options)if ($bdd166eca2c549e0$var$hasOwn$1(options, option)) switch(option){
        case "deadline":
            this._timeout = options.deadline;
            break;
        case "response":
            this._responseTimeout = options.response;
            break;
        case "upload":
            this._uploadTimeout = options.upload;
            break;
        default:
            console.warn("Unknown timeout option", option);
    }
    return this;
}, $bdd166eca2c549e0$var$RequestBase.prototype.retry = function(count, fn) {
    return 0 !== arguments.length && !0 !== count || (count = 1), count <= 0 && (count = 0), this._maxRetries = count, this._retries = 0, this._retryCallback = fn, this;
};
var $bdd166eca2c549e0$var$ERROR_CODES = new Set([
    "ETIMEDOUT",
    "ECONNRESET",
    "EADDRINUSE",
    "ECONNREFUSED",
    "EPIPE",
    "ENOTFOUND",
    "ENETUNREACH",
    "EAI_AGAIN"
]), $bdd166eca2c549e0$var$STATUS_CODES = new Set([
    408,
    413,
    429,
    500,
    502,
    503,
    504,
    521,
    522,
    524
]);
$bdd166eca2c549e0$var$RequestBase.prototype._shouldRetry = function(error, res) {
    if (!this._maxRetries || this._retries++ >= this._maxRetries) return !1;
    if (this._retryCallback) try {
        var override = this._retryCallback(error, res);
        if (!0 === override) return !0;
        if (!1 === override) return !1;
    } catch (err) {
        console.error(err);
    }
    if (res && res.status && $bdd166eca2c549e0$var$STATUS_CODES.has(res.status)) return !0;
    if (error) {
        if (error.code && $bdd166eca2c549e0$var$ERROR_CODES.has(error.code)) return !0;
        if (error.timeout && "ECONNABORTED" === error.code) return !0;
        if (error.crossDomain) return !0;
    }
    return !1;
}, $bdd166eca2c549e0$var$RequestBase.prototype._retry = function() {
    return this.clearTimeout(), this.req && (this.req = null, this.req = this.request()), this._aborted = !1, this.timedout = !1, this.timedoutError = null, this._end();
}, $bdd166eca2c549e0$var$RequestBase.prototype.then = function(resolve, reject) {
    var _this = this;
    if (!this._fullfilledPromise) {
        var self1 = this;
        this._endCalled && console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises"), this._fullfilledPromise = new Promise(function(resolve, reject) {
            self1.on("abort", function() {
                if (!(_this._maxRetries && _this._maxRetries > _this._retries)) {
                    if (_this.timedout && _this.timedoutError) reject(_this.timedoutError);
                    else {
                        var error = new Error("Aborted");
                        error.code = "ABORTED", error.status = _this.status, error.method = _this.method, error.url = _this.url, reject(error);
                    }
                }
            }), self1.end(function(error, res) {
                error ? reject(error) : resolve(res);
            });
        });
    }
    return this._fullfilledPromise.then(resolve, reject);
}, $bdd166eca2c549e0$var$RequestBase.prototype.catch = function(callback) {
    return this.then(void 0, callback);
}, $bdd166eca2c549e0$var$RequestBase.prototype.use = function(fn) {
    return fn(this), this;
}, $bdd166eca2c549e0$var$RequestBase.prototype.ok = function(callback) {
    if ("function" != typeof callback) throw new Error("Callback required");
    return this._okCallback = callback, this;
}, $bdd166eca2c549e0$var$RequestBase.prototype._isResponseOK = function(res) {
    return !!res && (this._okCallback ? this._okCallback(res) : res.status >= 200 && res.status < 300);
}, $bdd166eca2c549e0$var$RequestBase.prototype.get = function(field) {
    return this._header[field.toLowerCase()];
}, $bdd166eca2c549e0$var$RequestBase.prototype.getHeader = $bdd166eca2c549e0$var$RequestBase.prototype.get, $bdd166eca2c549e0$var$RequestBase.prototype.set = function(field, value) {
    if ($bdd166eca2c549e0$var$isObject(field)) {
        for(var key in field)$bdd166eca2c549e0$var$hasOwn$1(field, key) && this.set(key, field[key]);
        return this;
    }
    return this._header[field.toLowerCase()] = value, this.header[field] = value, this;
}, $bdd166eca2c549e0$var$RequestBase.prototype.unset = function(field) {
    return delete this._header[field.toLowerCase()], delete this.header[field], this;
}, $bdd166eca2c549e0$var$RequestBase.prototype.field = function(name, value, options) {
    if (null == name) throw new Error(".field(name, val) name can not be empty");
    if (this._data) throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
    if ($bdd166eca2c549e0$var$isObject(name)) {
        for(var key in name)$bdd166eca2c549e0$var$hasOwn$1(name, key) && this.field(key, name[key]);
        return this;
    }
    if (Array.isArray(value)) {
        for(var i in value)$bdd166eca2c549e0$var$hasOwn$1(value, i) && this.field(name, value[i]);
        return this;
    }
    if (null == value) throw new Error(".field(name, val) val can not be empty");
    return "boolean" == typeof value && (value = String(value)), options ? this._getFormData().append(name, value, options) : this._getFormData().append(name, value), this;
}, $bdd166eca2c549e0$var$RequestBase.prototype.abort = function() {
    if (this._aborted) return this;
    if (this._aborted = !0, this.xhr && this.xhr.abort(), this.req) {
        if ($bdd166eca2c549e0$var$semver.gte($eh5Zb.version, "v13.0.0") && $bdd166eca2c549e0$var$semver.lt($eh5Zb.version, "v14.0.0")) throw new Error("Superagent does not work in v13 properly with abort() due to Node.js core changes");
        $bdd166eca2c549e0$var$semver.gte($eh5Zb.version, "v14.0.0") && (this.req.destroyed = !0), this.req.abort();
    }
    return this.clearTimeout(), this.emit("abort"), this;
}, $bdd166eca2c549e0$var$RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
    switch(options.type){
        case "basic":
            this.set("Authorization", "Basic ".concat(base64Encoder("".concat(user, ":").concat(pass))));
            break;
        case "auto":
            this.username = user, this.password = pass;
            break;
        case "bearer":
            this.set("Authorization", "Bearer ".concat(user));
    }
    return this;
}, $bdd166eca2c549e0$var$RequestBase.prototype.withCredentials = function(on) {
    return void 0 === on && (on = !0), this._withCredentials = on, this;
}, $bdd166eca2c549e0$var$RequestBase.prototype.redirects = function(n) {
    return this._maxRedirects = n, this;
}, $bdd166eca2c549e0$var$RequestBase.prototype.maxResponseSize = function(n) {
    if ("number" != typeof n) throw new TypeError("Invalid argument");
    return this._maxResponseSize = n, this;
}, $bdd166eca2c549e0$var$RequestBase.prototype.toJSON = function() {
    return {
        method: this.method,
        url: this.url,
        data: this._data,
        headers: this._header
    };
}, $bdd166eca2c549e0$var$RequestBase.prototype.send = function(data) {
    var isObject_ = $bdd166eca2c549e0$var$isObject(data), type = this._header["content-type"];
    if (this._formData) throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
    if (isObject_ && !this._data) Array.isArray(data) ? this._data = [] : this._isHost(data) || (this._data = {});
    else if (data && this._data && this._isHost(this._data)) throw new Error("Can't merge these send calls");
    if (isObject_ && $bdd166eca2c549e0$var$isObject(this._data)) for(var key in data)$bdd166eca2c549e0$var$hasOwn$1(data, key) && (this._data[key] = data[key]);
    else "string" == typeof data ? (type || this.type("form"), (type = this._header["content-type"]) && (type = type.toLowerCase().trim()), this._data = "application/x-www-form-urlencoded" === type ? this._data ? "".concat(this._data, "&").concat(data) : data : (this._data || "") + data) : this._data = data;
    return !isObject_ || this._isHost(data) || type || this.type("json"), this;
}, $bdd166eca2c549e0$var$RequestBase.prototype.sortQuery = function(sort) {
    return this._sort = void 0 === sort || sort, this;
}, $bdd166eca2c549e0$var$RequestBase.prototype._finalizeQueryString = function() {
    var query = this._query.join("&");
    if (query && (this.url += (this.url.includes("?") ? "&" : "?") + query), this._query.length = 0, this._sort) {
        var index = this.url.indexOf("?");
        if (index >= 0) {
            var queryArray = this.url.slice(index + 1).split("&");
            "function" == typeof this._sort ? queryArray.sort(this._sort) : queryArray.sort(), this.url = this.url.slice(0, index) + "?" + queryArray.join("&");
        }
    }
}, $bdd166eca2c549e0$var$RequestBase.prototype._appendQueryString = function() {
    console.warn("Unsupported");
}, $bdd166eca2c549e0$var$RequestBase.prototype._timeoutError = function(reason, timeout, errno) {
    if (!this._aborted) {
        var error = new Error("".concat(reason + timeout, "ms exceeded"));
        error.timeout = timeout, error.code = "ECONNABORTED", error.errno = errno, this.timedout = !0, this.timedoutError = error, this.abort(), this.callback(error);
    }
}, $bdd166eca2c549e0$var$RequestBase.prototype._setTimeouts = function() {
    var self1 = this;
    this._timeout && !this._timer && (this._timer = setTimeout(function() {
        self1._timeoutError("Timeout of ", self1._timeout, "ETIME");
    }, this._timeout)), this._responseTimeout && !this._responseTimeoutTimer && (this._responseTimeoutTimer = setTimeout(function() {
        self1._timeoutError("Response timeout of ", self1._responseTimeout, "ETIMEDOUT");
    }, this._responseTimeout));
};
var $bdd166eca2c549e0$var$responseBase = $bdd166eca2c549e0$var$ResponseBase;
function $bdd166eca2c549e0$var$ResponseBase() {}
function $bdd166eca2c549e0$var$_toConsumableArray(arr) {
    return function(arr) {
        if (Array.isArray(arr)) return $bdd166eca2c549e0$var$_arrayLikeToArray(arr);
    }(arr) || function(iter) {
        if ("undefined" != typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) return Array.from(iter);
    }(arr) || $bdd166eca2c549e0$var$_unsupportedIterableToArray(arr) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $bdd166eca2c549e0$var$_unsupportedIterableToArray(o, minLen) {
    if (o) {
        if ("string" == typeof o) return $bdd166eca2c549e0$var$_arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        return "Object" === n && o.constructor && (n = o.constructor.name), "Map" === n || "Set" === n ? Array.from(o) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $bdd166eca2c549e0$var$_arrayLikeToArray(o, minLen) : void 0;
    }
}
function $bdd166eca2c549e0$var$_arrayLikeToArray(arr, len) {
    (null == len || len > arr.length) && (len = arr.length);
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bdd166eca2c549e0$var$Agent() {
    this._defaults = [];
}
$bdd166eca2c549e0$var$ResponseBase.prototype.get = function(field) {
    return this.header[field.toLowerCase()];
}, $bdd166eca2c549e0$var$ResponseBase.prototype._setHeaderProperties = function(header) {
    var ct = header["content-type"] || "";
    this.type = $bdd166eca2c549e0$var$utils$1.type(ct);
    var parameters = $bdd166eca2c549e0$var$utils$1.params(ct);
    for(var key in parameters)Object.prototype.hasOwnProperty.call(parameters, key) && (this[key] = parameters[key]);
    this.links = {};
    try {
        header.link && (this.links = $bdd166eca2c549e0$var$utils$1.parseLinks(header.link));
    } catch (_unused) {}
}, $bdd166eca2c549e0$var$ResponseBase.prototype._setStatusProperties = function(status) {
    var type = Math.trunc(status / 100);
    this.statusCode = status, this.status = this.statusCode, this.statusType = type, this.info = 1 === type, this.ok = 2 === type, this.redirect = 3 === type, this.clientError = 4 === type, this.serverError = 5 === type, this.error = (4 === type || 5 === type) && this.toError(), this.created = 201 === status, this.accepted = 202 === status, this.noContent = 204 === status, this.badRequest = 400 === status, this.unauthorized = 401 === status, this.notAcceptable = 406 === status, this.forbidden = 403 === status, this.notFound = 404 === status, this.unprocessableEntity = 422 === status;
};
for(var $bdd166eca2c549e0$var$_loop = function() {
    var fn = $bdd166eca2c549e0$var$_arr[$bdd166eca2c549e0$var$_i];
    $bdd166eca2c549e0$var$Agent.prototype[fn] = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this._defaults.push({
            fn: fn,
            args: args
        }), this;
    };
}, $bdd166eca2c549e0$var$_i = 0, $bdd166eca2c549e0$var$_arr = [
    "use",
    "on",
    "once",
    "set",
    "query",
    "type",
    "accept",
    "auth",
    "withCredentials",
    "sortQuery",
    "retry",
    "ok",
    "redirects",
    "timeout",
    "buffer",
    "serialize",
    "parse",
    "ca",
    "key",
    "pfx",
    "cert",
    "disableTLSCerts"
]; $bdd166eca2c549e0$var$_i < $bdd166eca2c549e0$var$_arr.length; $bdd166eca2c549e0$var$_i++)$bdd166eca2c549e0$var$_loop();
$bdd166eca2c549e0$var$Agent.prototype._setDefaults = function(request) {
    var _step, _iterator = function(o, allowArrayLike) {
        var it = "undefined" != typeof Symbol && o[Symbol.iterator] || o["@@iterator"];
        if (!it) {
            if (Array.isArray(o) || (it = $bdd166eca2c549e0$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && "number" == typeof o.length) {
                it && (o = it);
                var i = 0, F = function() {};
                return {
                    s: F,
                    n: function() {
                        return i >= o.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: o[i++]
                        };
                    },
                    e: function(_e) {
                        throw _e;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var err, normalCompletion = !0, didErr = !1;
        return {
            s: function() {
                it = it.call(o);
            },
            n: function() {
                var step = it.next();
                return normalCompletion = step.done, step;
            },
            e: function(_e2) {
                didErr = !0, err = _e2;
            },
            f: function() {
                try {
                    normalCompletion || null == it.return || it.return();
                } finally{
                    if (didErr) throw err;
                }
            }
        };
    }(this._defaults);
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var def = _step.value;
            request[def.fn].apply(request, $bdd166eca2c549e0$var$_toConsumableArray(def.args));
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
};
for(var $bdd166eca2c549e0$var$agentBase = $bdd166eca2c549e0$var$Agent, $bdd166eca2c549e0$var$client = $bdd166eca2c549e0$var$createCommonjsModule(function(module, exports) {
    function _typeof(obj) {
        return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        })(obj);
    }
    function _createForOfIteratorHelper(o, allowArrayLike) {
        var it = "undefined" != typeof Symbol && o[Symbol.iterator] || o["@@iterator"];
        if (!it) {
            if (Array.isArray(o) || (it = function(o, minLen) {
                if (!o) return;
                if ("string" == typeof o) return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                "Object" === n && o.constructor && (n = o.constructor.name);
                if ("Map" === n || "Set" === n) return Array.from(o);
                if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }(o)) || allowArrayLike && o && "number" == typeof o.length) {
                it && (o = it);
                var i = 0, F = function() {};
                return {
                    s: F,
                    n: function() {
                        return i >= o.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: o[i++]
                        };
                    },
                    e: function(_e) {
                        throw _e;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var err, normalCompletion = !0, didErr = !1;
        return {
            s: function() {
                it = it.call(o);
            },
            n: function() {
                var step = it.next();
                return normalCompletion = step.done, step;
            },
            e: function(_e2) {
                didErr = !0, err = _e2;
            },
            f: function() {
                try {
                    normalCompletion || null == it.return || it.return();
                } finally{
                    if (didErr) throw err;
                }
            }
        };
    }
    function _arrayLikeToArray(arr, len) {
        (null == len || len > arr.length) && (len = arr.length);
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    var root;
    "undefined" != typeof window ? root = window : "undefined" == typeof self ? (console.warn("Using browser-only version of superagent in non-browser environment"), root = void 0) : root = self;
    var isObject = $bdd166eca2c549e0$var$utils$1.isObject, mixin = $bdd166eca2c549e0$var$utils$1.mixin, hasOwn = $bdd166eca2c549e0$var$utils$1.hasOwn;
    function noop() {}
    module.exports = function(method, url) {
        return "function" == typeof url ? new exports.Request("GET", method).end(url) : 1 === arguments.length ? new exports.Request("GET", method) : new exports.Request(method, url);
    };
    var request = exports = module.exports;
    exports.Request = Request, request.getXHR = function() {
        if (root.XMLHttpRequest && (!root.location || "file:" !== root.location.protocol || !root.ActiveXObject)) return new XMLHttpRequest;
        try {
            return new ActiveXObject("Microsoft.XMLHTTP");
        } catch (_unused) {}
        try {
            return new ActiveXObject("Msxml2.XMLHTTP.6.0");
        } catch (_unused2) {}
        try {
            return new ActiveXObject("Msxml2.XMLHTTP.3.0");
        } catch (_unused3) {}
        try {
            return new ActiveXObject("Msxml2.XMLHTTP");
        } catch (_unused4) {}
        throw new Error("Browser-only version of superagent could not find XHR");
    };
    var trim = "".trim ? function(s) {
        return s.trim();
    } : function(s) {
        return s.replace(/(^\s*|\s*$)/g, "");
    };
    function serialize(object) {
        if (!isObject(object)) return object;
        var pairs = [];
        for(var key in object)hasOwn(object, key) && pushEncodedKeyValuePair(pairs, key, object[key]);
        return pairs.join("&");
    }
    function pushEncodedKeyValuePair(pairs, key, value) {
        if (void 0 !== value) {
            if (null !== value) {
                if (Array.isArray(value)) {
                    var _step, _iterator = _createForOfIteratorHelper(value);
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;)pushEncodedKeyValuePair(pairs, key, _step.value);
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                } else if (isObject(value)) for(var subkey in value)hasOwn(value, subkey) && pushEncodedKeyValuePair(pairs, "".concat(key, "[").concat(subkey, "]"), value[subkey]);
                else pairs.push(encodeURI(key) + "=" + encodeURIComponent(value));
            } else pairs.push(encodeURI(key));
        }
    }
    function parseString(string_) {
        for(var pair, pos, object = {}, pairs = string_.split("&"), i = 0, length_ = pairs.length; i < length_; ++i)-1 === (pos = (pair = pairs[i]).indexOf("=")) ? object[decodeURIComponent(pair)] = "" : object[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
        return object;
    }
    function isJSON(mime) {
        return /[/+]json($|[^-\w])/i.test(mime);
    }
    function Response(request_) {
        this.req = request_, this.xhr = this.req.xhr, this.text = "HEAD" !== this.req.method && ("" === this.xhr.responseType || "text" === this.xhr.responseType) || void 0 === this.xhr.responseType ? this.xhr.responseText : null, this.statusText = this.req.xhr.statusText;
        var status = this.xhr.status;
        1223 === status && (status = 204), this._setStatusProperties(status), this.headers = function(string_) {
            for(var index, line, field, value, lines = string_.split(/\r?\n/), fields = {}, i = 0, length_ = lines.length; i < length_; ++i)-1 !== (index = (line = lines[i]).indexOf(":")) && (field = line.slice(0, index).toLowerCase(), value = trim(line.slice(index + 1)), fields[field] = value);
            return fields;
        }(this.xhr.getAllResponseHeaders()), this.header = this.headers, this.header["content-type"] = this.xhr.getResponseHeader("content-type"), this._setHeaderProperties(this.header), null === this.text && request_._responseType ? this.body = this.xhr.response : this.body = "HEAD" === this.req.method ? null : this._parseBody(this.text ? this.text : this.xhr.response);
    }
    function Request(method, url) {
        var self1 = this;
        this._query = this._query || [], this.method = method, this.url = url, this.header = {}, this._header = {}, this.on("end", function() {
            var new_error, error = null, res = null;
            try {
                res = new Response(self1);
            } catch (err) {
                return (error = new Error("Parser is unable to parse the response")).parse = !0, error.original = err, self1.xhr ? (error.rawResponse = void 0 === self1.xhr.responseType ? self1.xhr.responseText : self1.xhr.response, error.status = self1.xhr.status ? self1.xhr.status : null, error.statusCode = error.status) : (error.rawResponse = null, error.status = null), self1.callback(error);
            }
            self1.emit("response", res);
            try {
                self1._isResponseOK(res) || (new_error = new Error(res.statusText || res.text || "Unsuccessful HTTP response"));
            } catch (err) {
                new_error = err;
            }
            new_error ? (new_error.original = error, new_error.response = res, new_error.status = res.status, self1.callback(new_error, res)) : self1.callback(null, res);
        });
    }
    request.serializeObject = serialize, request.parseString = parseString, request.types = {
        html: "text/html",
        json: "application/json",
        xml: "text/xml",
        urlencoded: "application/x-www-form-urlencoded",
        form: "application/x-www-form-urlencoded",
        "form-data": "application/x-www-form-urlencoded"
    }, request.serialize = {
        "application/x-www-form-urlencoded": $bdd166eca2c549e0$var$lib.stringify,
        "application/json": $bdd166eca2c549e0$var$fastSafeStringify
    }, request.parse = {
        "application/x-www-form-urlencoded": parseString,
        "application/json": JSON.parse
    }, mixin(Response.prototype, $bdd166eca2c549e0$var$responseBase.prototype), Response.prototype._parseBody = function(string_) {
        var parse = request.parse[this.type];
        return this.req._parser ? this.req._parser(this, string_) : (!parse && isJSON(this.type) && (parse = request.parse["application/json"]), parse && string_ && (string_.length > 0 || string_ instanceof Object) ? parse(string_) : null);
    }, Response.prototype.toError = function() {
        var req = this.req, method = req.method, url = req.url, message = "cannot ".concat(method, " ").concat(url, " (").concat(this.status, ")"), error = new Error(message);
        return error.status = this.status, error.method = method, error.url = url, error;
    }, request.Response = Response, $bdd166eca2c549e0$var$componentEmitter(Request.prototype), mixin(Request.prototype, $bdd166eca2c549e0$var$requestBase.prototype), Request.prototype.type = function(type) {
        return this.set("Content-Type", request.types[type] || type), this;
    }, Request.prototype.accept = function(type) {
        return this.set("Accept", request.types[type] || type), this;
    }, Request.prototype.auth = function(user, pass, options) {
        1 === arguments.length && (pass = ""), "object" === _typeof(pass) && null !== pass && (options = pass, pass = ""), options || (options = {
            type: "function" == typeof btoa ? "basic" : "auto"
        });
        var encoder = options.encoder ? options.encoder : function(string) {
            if ("function" == typeof btoa) return btoa(string);
            throw new Error("Cannot use basic auth, btoa is not a function");
        };
        return this._auth(user, pass, options, encoder);
    }, Request.prototype.query = function(value) {
        return "string" != typeof value && (value = serialize(value)), value && this._query.push(value), this;
    }, Request.prototype.attach = function(field, file, options) {
        if (file) {
            if (this._data) throw new Error("superagent can't mix .send() and .attach()");
            this._getFormData().append(field, file, options || file.name);
        }
        return this;
    }, Request.prototype._getFormData = function() {
        return this._formData || (this._formData = new root.FormData), this._formData;
    }, Request.prototype.callback = function(error, res) {
        if (this._shouldRetry(error, res)) return this._retry();
        var fn = this._callback;
        this.clearTimeout(), error && (this._maxRetries && (error.retries = this._retries - 1), this.emit("error", error)), fn(error, res);
    }, Request.prototype.crossDomainError = function() {
        var error = new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.");
        error.crossDomain = !0, error.status = this.status, error.method = this.method, error.url = this.url, this.callback(error);
    }, Request.prototype.agent = function() {
        return console.warn("This is not supported in browser version of superagent"), this;
    }, Request.prototype.ca = Request.prototype.agent, Request.prototype.buffer = Request.prototype.ca, Request.prototype.write = function() {
        throw new Error("Streaming is not supported in browser version of superagent");
    }, Request.prototype.pipe = Request.prototype.write, Request.prototype._isHost = function(object) {
        return object && "object" === _typeof(object) && !Array.isArray(object) && "[object Object]" !== Object.prototype.toString.call(object);
    }, Request.prototype.end = function(fn) {
        this._endCalled && console.warn("Warning: .end() was called twice. This is not supported in superagent"), this._endCalled = !0, this._callback = fn || noop, this._finalizeQueryString(), this._end();
    }, Request.prototype._setUploadTimeout = function() {
        var self1 = this;
        this._uploadTimeout && !this._uploadTimeoutTimer && (this._uploadTimeoutTimer = setTimeout(function() {
            self1._timeoutError("Upload timeout of ", self1._uploadTimeout, "ETIMEDOUT");
        }, this._uploadTimeout));
    }, Request.prototype._end = function() {
        if (this._aborted) return this.callback(new Error("The request has been aborted even before .end() was called"));
        var self1 = this;
        this.xhr = request.getXHR();
        var xhr = this.xhr, data = this._formData || this._data;
        this._setTimeouts(), xhr.addEventListener("readystatechange", function() {
            var readyState = xhr.readyState;
            if (readyState >= 2 && self1._responseTimeoutTimer && clearTimeout(self1._responseTimeoutTimer), 4 === readyState) {
                var status;
                try {
                    status = xhr.status;
                } catch (_unused5) {
                    status = 0;
                }
                if (!status) {
                    if (self1.timedout || self1._aborted) return;
                    return self1.crossDomainError();
                }
                self1.emit("end");
            }
        });
        var handleProgress = function(direction, e) {
            e.total > 0 && (e.percent = e.loaded / e.total * 100, 100 === e.percent && clearTimeout(self1._uploadTimeoutTimer)), e.direction = direction, self1.emit("progress", e);
        };
        if (this.hasListeners("progress")) try {
            xhr.addEventListener("progress", handleProgress.bind(null, "download")), xhr.upload && xhr.upload.addEventListener("progress", handleProgress.bind(null, "upload"));
        } catch (_unused6) {}
        xhr.upload && this._setUploadTimeout();
        try {
            this.username && this.password ? xhr.open(this.method, this.url, !0, this.username, this.password) : xhr.open(this.method, this.url, !0);
        } catch (err) {
            return this.callback(err);
        }
        if (this._withCredentials && (xhr.withCredentials = !0), !this._formData && "GET" !== this.method && "HEAD" !== this.method && "string" != typeof data && !this._isHost(data)) {
            var contentType = this._header["content-type"], _serialize = this._serializer || request.serialize[contentType ? contentType.split(";")[0] : ""];
            !_serialize && isJSON(contentType) && (_serialize = request.serialize["application/json"]), _serialize && (data = _serialize(data));
        }
        for(var field in this.header)null !== this.header[field] && hasOwn(this.header, field) && xhr.setRequestHeader(field, this.header[field]);
        this._responseType && (xhr.responseType = this._responseType), this.emit("request", this), xhr.send(void 0 === data ? null : data);
    }, request.agent = function() {
        return new $bdd166eca2c549e0$var$agentBase;
    };
    for(var _loop = function() {
        var method = _arr[_i];
        $bdd166eca2c549e0$var$agentBase.prototype[method.toLowerCase()] = function(url, fn) {
            var request_ = new request.Request(method, url);
            return this._setDefaults(request_), fn && request_.end(fn), request_;
        };
    }, _i = 0, _arr = [
        "GET",
        "POST",
        "OPTIONS",
        "PATCH",
        "PUT",
        "DELETE"
    ]; _i < _arr.length; _i++)_loop();
    function del(url, data, fn) {
        var request_ = request("DELETE", url);
        return "function" == typeof data && (fn = data, data = null), data && request_.send(data), fn && request_.end(fn), request_;
    }
    $bdd166eca2c549e0$var$agentBase.prototype.del = $bdd166eca2c549e0$var$agentBase.prototype.delete, request.get = function(url, data, fn) {
        var request_ = request("GET", url);
        return "function" == typeof data && (fn = data, data = null), data && request_.query(data), fn && request_.end(fn), request_;
    }, request.head = function(url, data, fn) {
        var request_ = request("HEAD", url);
        return "function" == typeof data && (fn = data, data = null), data && request_.query(data), fn && request_.end(fn), request_;
    }, request.options = function(url, data, fn) {
        var request_ = request("OPTIONS", url);
        return "function" == typeof data && (fn = data, data = null), data && request_.send(data), fn && request_.end(fn), request_;
    }, request.del = del, request.delete = del, request.patch = function(url, data, fn) {
        var request_ = request("PATCH", url);
        return "function" == typeof data && (fn = data, data = null), data && request_.send(data), fn && request_.end(fn), request_;
    }, request.post = function(url, data, fn) {
        var request_ = request("POST", url);
        return "function" == typeof data && (fn = data, data = null), data && request_.send(data), fn && request_.end(fn), request_;
    }, request.put = function(url, data, fn) {
        var request_ = request("PUT", url);
        return "function" == typeof data && (fn = data, data = null), data && request_.send(data), fn && request_.end(fn), request_;
    };
}), $bdd166eca2c549e0$var$byteLength_1 = ($bdd166eca2c549e0$var$client.Request, function(b64) {
    var lens = $bdd166eca2c549e0$var$getLens(b64), validLen = lens[0], placeHoldersLen = lens[1];
    return 3 * (validLen + placeHoldersLen) / 4 - placeHoldersLen;
}), $bdd166eca2c549e0$var$toByteArray_1 = function(b64) {
    var tmp, i, lens = $bdd166eca2c549e0$var$getLens(b64), validLen = lens[0], placeHoldersLen = lens[1], arr = new $bdd166eca2c549e0$var$Arr(function(b64, validLen, placeHoldersLen) {
        return 3 * (validLen + placeHoldersLen) / 4 - placeHoldersLen;
    }(0, validLen, placeHoldersLen)), curByte = 0, len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    for(i = 0; i < len; i += 4)tmp = $bdd166eca2c549e0$var$revLookup[b64.charCodeAt(i)] << 18 | $bdd166eca2c549e0$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $bdd166eca2c549e0$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $bdd166eca2c549e0$var$revLookup[b64.charCodeAt(i + 3)], arr[curByte++] = tmp >> 16 & 255, arr[curByte++] = tmp >> 8 & 255, arr[curByte++] = 255 & tmp;
    2 === placeHoldersLen && (tmp = $bdd166eca2c549e0$var$revLookup[b64.charCodeAt(i)] << 2 | $bdd166eca2c549e0$var$revLookup[b64.charCodeAt(i + 1)] >> 4, arr[curByte++] = 255 & tmp);
    1 === placeHoldersLen && (tmp = $bdd166eca2c549e0$var$revLookup[b64.charCodeAt(i)] << 10 | $bdd166eca2c549e0$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $bdd166eca2c549e0$var$revLookup[b64.charCodeAt(i + 2)] >> 2, arr[curByte++] = tmp >> 8 & 255, arr[curByte++] = 255 & tmp);
    return arr;
}, $bdd166eca2c549e0$var$fromByteArray_1 = function(uint8) {
    for(var tmp, len = uint8.length, extraBytes = len % 3, parts = [], i = 0, len2 = len - extraBytes; i < len2; i += 16383)parts.push($bdd166eca2c549e0$var$encodeChunk(uint8, i, i + 16383 > len2 ? len2 : i + 16383));
    1 === extraBytes ? (tmp = uint8[len - 1], parts.push($bdd166eca2c549e0$var$lookup[tmp >> 2] + $bdd166eca2c549e0$var$lookup[tmp << 4 & 63] + "==")) : 2 === extraBytes && (tmp = (uint8[len - 2] << 8) + uint8[len - 1], parts.push($bdd166eca2c549e0$var$lookup[tmp >> 10] + $bdd166eca2c549e0$var$lookup[tmp >> 4 & 63] + $bdd166eca2c549e0$var$lookup[tmp << 2 & 63] + "="));
    return parts.join("");
}, $bdd166eca2c549e0$var$lookup = [], $bdd166eca2c549e0$var$revLookup = [], $bdd166eca2c549e0$var$Arr = "undefined" != typeof Uint8Array ? Uint8Array : Array, $bdd166eca2c549e0$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $bdd166eca2c549e0$var$i = 0, $bdd166eca2c549e0$var$len = $bdd166eca2c549e0$var$code.length; $bdd166eca2c549e0$var$i < $bdd166eca2c549e0$var$len; ++$bdd166eca2c549e0$var$i)$bdd166eca2c549e0$var$lookup[$bdd166eca2c549e0$var$i] = $bdd166eca2c549e0$var$code[$bdd166eca2c549e0$var$i], $bdd166eca2c549e0$var$revLookup[$bdd166eca2c549e0$var$code.charCodeAt($bdd166eca2c549e0$var$i)] = $bdd166eca2c549e0$var$i;
function $bdd166eca2c549e0$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var validLen = b64.indexOf("=");
    return -1 === validLen && (validLen = len), [
        validLen,
        validLen === len ? 0 : 4 - validLen % 4
    ];
}
function $bdd166eca2c549e0$var$encodeChunk(uint8, start, end) {
    for(var tmp, num, output = [], i = start; i < end; i += 3)tmp = (uint8[i] << 16 & 16711680) + (uint8[i + 1] << 8 & 65280) + (255 & uint8[i + 2]), output.push($bdd166eca2c549e0$var$lookup[(num = tmp) >> 18 & 63] + $bdd166eca2c549e0$var$lookup[num >> 12 & 63] + $bdd166eca2c549e0$var$lookup[num >> 6 & 63] + $bdd166eca2c549e0$var$lookup[63 & num]);
    return output.join("");
}
$bdd166eca2c549e0$var$revLookup["-".charCodeAt(0)] = 62, $bdd166eca2c549e0$var$revLookup["_".charCodeAt(0)] = 63;
var $bdd166eca2c549e0$var$base64Js = {
    byteLength: $bdd166eca2c549e0$var$byteLength_1,
    toByteArray: $bdd166eca2c549e0$var$toByteArray_1,
    fromByteArray: $bdd166eca2c549e0$var$fromByteArray_1
};
var $bdd166eca2c549e0$var$base64Url = {
    encode: function(str) {
        return $bdd166eca2c549e0$var$base64Js.fromByteArray(function(str) {
            for(var arr = new Array(str.length), a = 0; a < str.length; a++)arr[a] = str.charCodeAt(a);
            return arr;
        }(str)).replace(/\+/g, "-").replace(/\//g, "_");
    },
    decode: function(str) {
        return str = (function(str) {
            var mod = str.length % 4;
            return 0 === mod ? str : str + new Array(1 + (4 - mod)).join("=");
        })(str).replace(/-/g, "+").replace(/_/g, "/"), function(array) {
            for(var result = "", i = 0; i < array.length; i++)result += String.fromCharCode(array[i]);
            return result;
        }($bdd166eca2c549e0$var$base64Js.toByteArray(str));
    }
}, $bdd166eca2c549e0$export$83d89fbfd8236492 = {
    raw: "9.24.0"
}, $bdd166eca2c549e0$var$toString = Object.prototype.toString;
function $bdd166eca2c549e0$var$attribute(o, attr, type, text) {
    if (type = "array" === type ? "object" : type, o && typeof o[attr] !== type) throw new Error(text);
}
function $bdd166eca2c549e0$var$variable(o, type, text) {
    if (typeof o !== type) throw new Error(text);
}
function $bdd166eca2c549e0$var$value(o, values, text) {
    if (-1 === values.indexOf(o)) throw new Error(text);
}
var $bdd166eca2c549e0$var$assert = {
    check: function(o, config, attributes) {
        if (config.optional && !o || $bdd166eca2c549e0$var$variable(o, config.type, config.message), "object" === config.type && attributes) for(var keys = Object.keys(attributes), index = 0; index < keys.length; index++){
            var a = keys[index];
            attributes[a].optional && !o[a] || attributes[a].condition && !attributes[a].condition(o) || ($bdd166eca2c549e0$var$attribute(o, a, attributes[a].type, attributes[a].message), attributes[a].values && $bdd166eca2c549e0$var$value(o[a], attributes[a].values, attributes[a].value_message));
        }
    },
    attribute: $bdd166eca2c549e0$var$attribute,
    variable: $bdd166eca2c549e0$var$variable,
    value: $bdd166eca2c549e0$var$value,
    isArray: function(array) {
        return this.supportsIsArray() ? Array.isArray(array) : "[object Array]" === $bdd166eca2c549e0$var$toString.call(array);
    },
    supportsIsArray: function() {
        return null != Array.isArray;
    }
};
function $bdd166eca2c549e0$var$objectAssignPolyfill(target) {
    if (null == target) throw new TypeError("Cannot convert first argument to object");
    for(var to = Object(target), i = 1; i < arguments.length; i++){
        var nextSource = arguments[i];
        if (null != nextSource) for(var keysArray = Object.keys(Object(nextSource)), nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++){
            var nextKey = keysArray[nextIndex], desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            void 0 !== desc && desc.enumerable && (to[nextKey] = nextSource[nextKey]);
        }
    }
    return to;
}
var $bdd166eca2c549e0$var$objectAssign = {
    get: function() {
        return Object.assign ? Object.assign : $bdd166eca2c549e0$var$objectAssignPolyfill;
    },
    objectAssignPolyfill: $bdd166eca2c549e0$var$objectAssignPolyfill
};
function $bdd166eca2c549e0$var$pick(object, keys) {
    return keys.reduce(function(prev, key) {
        return object[key] && (prev[key] = object[key]), prev;
    }, {});
}
function $bdd166eca2c549e0$var$objectValues(obj) {
    var values = [];
    for(var key in obj)values.push(obj[key]);
    return values;
}
function $bdd166eca2c549e0$var$extend() {
    var params = $bdd166eca2c549e0$var$objectValues(arguments);
    return params.unshift({}), $bdd166eca2c549e0$var$objectAssign.get().apply(void 0, params);
}
function $bdd166eca2c549e0$var$getLocationFromUrl(href) {
    var match = href.match(/^(https?:|file:|chrome-extension:)\/\/(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return match && {
        href: href,
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7]
    };
}
function $bdd166eca2c549e0$var$trim(options, key) {
    var trimmed = $bdd166eca2c549e0$var$extend(options);
    return options[key] && (trimmed[key] = options[key].trim()), trimmed;
}
var $bdd166eca2c549e0$var$objectHelper = {
    toSnakeCase: function toSnakeCase(object, exceptions) {
        return "object" != typeof object || $bdd166eca2c549e0$var$assert.isArray(object) || null === object ? object : (exceptions = exceptions || [], Object.keys(object).reduce(function(p, key) {
            return p[-1 === exceptions.indexOf(key) ? function(str) {
                for(var code, newKey = "", index = 0, wasPrevNumber = !0, wasPrevUppercase = !0; index < str.length;)code = str.charCodeAt(index), !wasPrevUppercase && code >= 65 && code <= 90 || !wasPrevNumber && code >= 48 && code <= 57 ? (newKey += "_", newKey += str[index].toLowerCase()) : newKey += str[index].toLowerCase(), wasPrevNumber = code >= 48 && code <= 57, wasPrevUppercase = code >= 65 && code <= 90, index++;
                return newKey;
            }(key) : key] = toSnakeCase(object[key]), p;
        }, {}));
    },
    toCamelCase: function toCamelCase(object, exceptions, options) {
        return "object" != typeof object || $bdd166eca2c549e0$var$assert.isArray(object) || null === object ? object : (exceptions = exceptions || [], options = options || {}, Object.keys(object).reduce(function(p, key) {
            var parts, newKey = -1 === exceptions.indexOf(key) ? (parts = key.split("_")).reduce(function(p, c) {
                return p + c.charAt(0).toUpperCase() + c.slice(1);
            }, parts.shift()) : key;
            return p[newKey] = toCamelCase(object[newKey] || object[key], [], options), options.keepOriginal && (p[key] = toCamelCase(object[key], [], options)), p;
        }, {}));
    },
    blacklist: function(object, blacklistedKeys) {
        return Object.keys(object).reduce(function(p, key) {
            return -1 === blacklistedKeys.indexOf(key) && (p[key] = object[key]), p;
        }, {});
    },
    merge: function(object, keys) {
        return {
            base: keys ? $bdd166eca2c549e0$var$pick(object, keys) : object,
            with: function(object2, keys2) {
                return object2 = keys2 ? $bdd166eca2c549e0$var$pick(object2, keys2) : object2, $bdd166eca2c549e0$var$extend(this.base, object2);
            }
        };
    },
    pick: $bdd166eca2c549e0$var$pick,
    getKeysNotIn: function(obj, allowedKeys) {
        var notAllowed = [];
        for(var key in obj)-1 === allowedKeys.indexOf(key) && notAllowed.push(key);
        return notAllowed;
    },
    extend: $bdd166eca2c549e0$var$extend,
    getOriginFromUrl: function(url) {
        if (url) {
            var parsed = $bdd166eca2c549e0$var$getLocationFromUrl(url);
            if (!parsed) return null;
            var origin = parsed.protocol + "//" + parsed.hostname;
            return parsed.port && (origin += ":" + parsed.port), origin;
        }
    },
    getLocationFromUrl: $bdd166eca2c549e0$var$getLocationFromUrl,
    trimUserDetails: function(options) {
        return function(options, keys) {
            return keys.reduce($bdd166eca2c549e0$var$trim, options);
        }(options, [
            "username",
            "email",
            "phoneNumber"
        ]);
    },
    updatePropertyOn: function updatePropertyOn(obj, path, value) {
        "string" == typeof path && (path = path.split("."));
        var next = path[0];
        obj.hasOwnProperty(next) && (1 === path.length ? obj[next] = value : updatePropertyOn(obj[next], path.slice(1), value));
    }
};
function $bdd166eca2c549e0$var$RequestWrapper(req) {
    this.request = req, this.method = req.method, this.url = req.url, this.body = req._data, this.headers = req._header;
}
function $bdd166eca2c549e0$var$RequestObj(req) {
    this.request = req;
}
function $bdd166eca2c549e0$var$RequestBuilder(options) {
    this._sendTelemetry = !1 !== options._sendTelemetry || options._sendTelemetry, this._telemetryInfo = options._telemetryInfo || null, this._timesToRetryFailedRequests = options._timesToRetryFailedRequests, this.headers = options.headers || {}, this._universalLoginPage = options.universalLoginPage;
}
function $bdd166eca2c549e0$var$getWindow() {
    return window;
}
$bdd166eca2c549e0$var$RequestWrapper.prototype.abort = function() {
    this.request.abort();
}, $bdd166eca2c549e0$var$RequestWrapper.prototype.getMethod = function() {
    return this.method;
}, $bdd166eca2c549e0$var$RequestWrapper.prototype.getBody = function() {
    return this.body;
}, $bdd166eca2c549e0$var$RequestWrapper.prototype.getUrl = function() {
    return this.url;
}, $bdd166eca2c549e0$var$RequestWrapper.prototype.getHeaders = function() {
    return this.headers;
}, $bdd166eca2c549e0$var$RequestObj.prototype.set = function(key, value) {
    return this.request = this.request.set(key, value), this;
}, $bdd166eca2c549e0$var$RequestObj.prototype.send = function(body) {
    return this.request = this.request.send($bdd166eca2c549e0$var$objectHelper.trimUserDetails(body)), this;
}, $bdd166eca2c549e0$var$RequestObj.prototype.withCredentials = function() {
    return this.request = this.request.withCredentials(), this;
}, $bdd166eca2c549e0$var$RequestObj.prototype.end = function(cb) {
    return this.request.end(cb), new $bdd166eca2c549e0$var$RequestWrapper(this.request);
}, $bdd166eca2c549e0$var$RequestBuilder.prototype.setCommonConfiguration = function(ongoingRequest, options) {
    if (options = options || {}, this._timesToRetryFailedRequests > 0 && (ongoingRequest = ongoingRequest.retry(this._timesToRetryFailedRequests)), options.noHeaders) return ongoingRequest;
    var headers = this.headers;
    ongoingRequest = ongoingRequest.set("Content-Type", "application/json"), options.xRequestLanguage && (ongoingRequest = ongoingRequest.set("X-Request-Language", options.xRequestLanguage));
    for(var keys = Object.keys(this.headers), a = 0; a < keys.length; a++)ongoingRequest = ongoingRequest.set(keys[a], headers[keys[a]]);
    return this._sendTelemetry && (ongoingRequest = ongoingRequest.set("Auth0-Client", this.getTelemetryData())), ongoingRequest;
}, $bdd166eca2c549e0$var$RequestBuilder.prototype.getTelemetryData = function() {
    var telemetryName = this._universalLoginPage ? "auth0.js-ulp" : "auth0.js", clientInfo = {
        name: telemetryName,
        version: $bdd166eca2c549e0$export$83d89fbfd8236492.raw
    };
    this._telemetryInfo && ((clientInfo = $bdd166eca2c549e0$var$objectHelper.extend({}, this._telemetryInfo)).env = $bdd166eca2c549e0$var$objectHelper.extend({}, this._telemetryInfo.env), clientInfo.env[telemetryName] = $bdd166eca2c549e0$export$83d89fbfd8236492.raw);
    var jsonClientInfo = JSON.stringify(clientInfo);
    return $bdd166eca2c549e0$var$base64Url.encode(jsonClientInfo);
}, $bdd166eca2c549e0$var$RequestBuilder.prototype.get = function(url, options) {
    return new $bdd166eca2c549e0$var$RequestObj(this.setCommonConfiguration($bdd166eca2c549e0$var$client.get(url), options));
}, $bdd166eca2c549e0$var$RequestBuilder.prototype.post = function(url, options) {
    return new $bdd166eca2c549e0$var$RequestObj(this.setCommonConfiguration($bdd166eca2c549e0$var$client.post(url), options));
}, $bdd166eca2c549e0$var$RequestBuilder.prototype.patch = function(url, options) {
    return new $bdd166eca2c549e0$var$RequestObj(this.setCommonConfiguration($bdd166eca2c549e0$var$client.patch(url), options));
};
var $bdd166eca2c549e0$var$windowHelper = {
    redirect: function(url) {
        $bdd166eca2c549e0$var$getWindow().location = url;
    },
    getDocument: function() {
        return $bdd166eca2c549e0$var$getWindow().document;
    },
    getWindow: $bdd166eca2c549e0$var$getWindow,
    getOrigin: function() {
        var location = $bdd166eca2c549e0$var$getWindow().location, origin = location.origin;
        return origin || (origin = $bdd166eca2c549e0$var$objectHelper.getOriginFromUrl(location.href)), origin;
    }
};
function $bdd166eca2c549e0$var$DummyStorage() {}
$bdd166eca2c549e0$var$DummyStorage.prototype.getItem = function() {
    return null;
}, $bdd166eca2c549e0$var$DummyStorage.prototype.removeItem = function() {}, $bdd166eca2c549e0$var$DummyStorage.prototype.setItem = function() {};
var $bdd166eca2c549e0$var$js_cookie = $bdd166eca2c549e0$var$createCommonjsModule(function(module, exports) {
    var factory;
    factory = function() {
        function extend() {
            for(var i = 0, result = {}; i < arguments.length; i++){
                var attributes = arguments[i];
                for(var key in attributes)result[key] = attributes[key];
            }
            return result;
        }
        function decode(s) {
            return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
        }
        return function init(converter) {
            function api() {}
            function set(key, value, attributes) {
                if ("undefined" != typeof document) {
                    "number" == typeof (attributes = extend({
                        path: "/"
                    }, api.defaults, attributes)).expires && (attributes.expires = new Date(1 * new Date + 864e5 * attributes.expires)), attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
                    try {
                        var result = JSON.stringify(value);
                        /^[\{\[]/.test(result) && (value = result);
                    } catch (e) {}
                    value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                    var stringifiedAttributes = "";
                    for(var attributeName in attributes)attributes[attributeName] && (stringifiedAttributes += "; " + attributeName, !0 !== attributes[attributeName] && (stringifiedAttributes += "=" + attributes[attributeName].split(";")[0]));
                    return document.cookie = key + "=" + value + stringifiedAttributes;
                }
            }
            function get(key, json) {
                if ("undefined" != typeof document) {
                    for(var jar = {}, cookies = document.cookie ? document.cookie.split("; ") : [], i = 0; i < cookies.length; i++){
                        var parts = cookies[i].split("="), cookie = parts.slice(1).join("=");
                        json || '"' !== cookie.charAt(0) || (cookie = cookie.slice(1, -1));
                        try {
                            var name = decode(parts[0]);
                            if (cookie = (converter.read || converter)(cookie, name) || decode(cookie), json) try {
                                cookie = JSON.parse(cookie);
                            } catch (e) {}
                            if (jar[name] = cookie, key === name) break;
                        } catch (e) {}
                    }
                    return key ? jar[key] : jar;
                }
            }
            return api.set = set, api.get = function(key) {
                return get(key, !1);
            }, api.getJSON = function(key) {
                return get(key, !0);
            }, api.remove = function(key, attributes) {
                set(key, "", extend(attributes, {
                    expires: -1
                }));
            }, api.defaults = {}, api.withConverter = init, api;
        }(function() {});
    }, module.exports = factory();
});
function $bdd166eca2c549e0$var$buildCompatCookieKey(key) {
    return "_" + key + "_compat";
}
function $bdd166eca2c549e0$var$CookieStorage(options) {
    this._options = options || {};
}
function $bdd166eca2c549e0$var$Warn(options) {
    this.disableWarnings = options.disableWarnings;
}
function $bdd166eca2c549e0$var$StorageHandler(options) {
    if (this.warn = new $bdd166eca2c549e0$var$Warn({}), this.storage = new $bdd166eca2c549e0$var$CookieStorage(options), !0 === options.__tryLocalStorageFirst) try {
        var localStorage = $bdd166eca2c549e0$var$windowHelper.getWindow().localStorage;
        localStorage && (this.storage = localStorage);
    } catch (e) {
        this.warn.warning(e), this.warn.warning("Can't use localStorage. Using CookieStorage instead.");
    }
}
function $bdd166eca2c549e0$var$Storage(options) {
    this.handler = new $bdd166eca2c549e0$var$StorageHandler(options);
}
function $bdd166eca2c549e0$var$SSODataStorage(options) {
    this.storage = new $bdd166eca2c549e0$var$Storage(options);
}
function $bdd166eca2c549e0$var$buildResponse(error, description) {
    return {
        error: error,
        errorDescription: description
    };
}
$bdd166eca2c549e0$var$CookieStorage.prototype.getItem = function(key) {
    return $bdd166eca2c549e0$var$js_cookie.get(key) || $bdd166eca2c549e0$var$js_cookie.get($bdd166eca2c549e0$var$buildCompatCookieKey(key));
}, $bdd166eca2c549e0$var$CookieStorage.prototype.removeItem = function(key) {
    var params = {};
    this._options.cookieDomain && (params.domain = this._options.cookieDomain), $bdd166eca2c549e0$var$js_cookie.remove(key, params), $bdd166eca2c549e0$var$js_cookie.remove($bdd166eca2c549e0$var$buildCompatCookieKey(key), params);
}, $bdd166eca2c549e0$var$CookieStorage.prototype.setItem = function(key, value, options) {
    var params = $bdd166eca2c549e0$var$objectHelper.extend({
        expires: 1
    }, options);
    if ("https:" === $bdd166eca2c549e0$var$windowHelper.getWindow().location.protocol && (params.secure = !0, params.sameSite = "none", this._options.legacySameSiteCookie)) {
        var legacyOptions = $bdd166eca2c549e0$var$objectHelper.blacklist(params, [
            "sameSite"
        ]);
        $bdd166eca2c549e0$var$js_cookie.set($bdd166eca2c549e0$var$buildCompatCookieKey(key), value, legacyOptions);
    }
    this._options.cookieDomain && (params.domain = this._options.cookieDomain), $bdd166eca2c549e0$var$js_cookie.set(key, value, params);
}, $bdd166eca2c549e0$var$Warn.prototype.warning = function(message) {
    this.disableWarnings || console.warn(message);
}, $bdd166eca2c549e0$var$StorageHandler.prototype.failover = function() {
    this.storage instanceof $bdd166eca2c549e0$var$DummyStorage ? this.warn.warning("DummyStorage: ignore failover") : this.storage instanceof $bdd166eca2c549e0$var$CookieStorage ? (this.warn.warning("CookieStorage: failing over DummyStorage"), this.storage = new $bdd166eca2c549e0$var$DummyStorage) : (this.warn.warning("LocalStorage: failing over CookieStorage"), this.storage = new $bdd166eca2c549e0$var$CookieStorage);
}, $bdd166eca2c549e0$var$StorageHandler.prototype.getItem = function(key) {
    try {
        return this.storage.getItem(key);
    } catch (e) {
        return this.warn.warning(e), this.failover(), this.getItem(key);
    }
}, $bdd166eca2c549e0$var$StorageHandler.prototype.removeItem = function(key) {
    try {
        return this.storage.removeItem(key);
    } catch (e) {
        return this.warn.warning(e), this.failover(), this.removeItem(key);
    }
}, $bdd166eca2c549e0$var$StorageHandler.prototype.setItem = function(key, value, options) {
    try {
        return this.storage.setItem(key, value, options);
    } catch (e) {
        return this.warn.warning(e), this.failover(), this.setItem(key, value, options);
    }
}, $bdd166eca2c549e0$var$Storage.prototype.getItem = function(key) {
    var value = this.handler.getItem(key);
    try {
        return JSON.parse(value);
    } catch (_) {
        return value;
    }
}, $bdd166eca2c549e0$var$Storage.prototype.removeItem = function(key) {
    return this.handler.removeItem(key);
}, $bdd166eca2c549e0$var$Storage.prototype.setItem = function(key, value, options) {
    var json = JSON.stringify(value);
    return this.handler.setItem(key, json, options);
}, $bdd166eca2c549e0$var$SSODataStorage.prototype.set = function(connection, sub) {
    var ssodata = {
        lastUsedConnection: connection,
        lastUsedSub: sub
    };
    this.storage.setItem("auth0.ssodata", JSON.stringify(ssodata));
}, $bdd166eca2c549e0$var$SSODataStorage.prototype.get = function() {
    var ssodata = this.storage.getItem("auth0.ssodata");
    if (ssodata) return JSON.parse(ssodata);
};
var $bdd166eca2c549e0$var$error = {
    buildResponse: $bdd166eca2c549e0$var$buildResponse,
    invalidToken: function(description) {
        return $bdd166eca2c549e0$var$buildResponse("invalid_token", description);
    }
};
function $bdd166eca2c549e0$var$wrapCallback(cb, options) {
    return (options = options || {}).ignoreCasing = !!options.ignoreCasing && options.ignoreCasing, function(err, data) {
        var errObj;
        return err || data ? (!err && data.err && (err = data.err, data = null), !err && data.error && (err = data, data = null), err ? (errObj = {
            original: err
        }, $bdd166eca2c549e0$var$objectHelper.updatePropertyOn(errObj, "original.response.req._data.password", "*****"), err.response && err.response.statusCode && (errObj.statusCode = err.response.statusCode), err.response && err.response.statusText && (errObj.statusText = err.response.statusText), err.response && err.response.body && (err = err.response.body), err.err && (err = err.err), errObj.code = err.code || err.error || err.error_code || err.status || null, errObj.description = err.errorDescription || err.error_description || err.description || err.error || err.details || err.err || null, options.forceLegacyError && (errObj.error = errObj.code, errObj.error_description = errObj.description), err.error_codes && err.error_details && (errObj.errorDetails = {
            codes: err.error_codes,
            details: err.error_details
        }), err.name && (errObj.name = err.name), err.policy && (errObj.policy = err.policy), cb(errObj)) : !data.type || "text/html" !== data.type && "text/plain" !== data.type ? options.ignoreCasing ? cb(null, data.body || data) : cb(null, $bdd166eca2c549e0$var$objectHelper.toCamelCase(data.body || data, [], {
            keepOriginal: options.keepOriginalCasing
        })) : cb(null, data.text)) : cb($bdd166eca2c549e0$var$error.buildResponse("generic_error", "Something went wrong"));
    };
}
var $bdd166eca2c549e0$var$tokenParams = [
    "realm",
    "audience",
    "otp",
    "client_id",
    "client_secret",
    "redirect_uri",
    "scope",
    "code",
    "grant_type",
    "username",
    "password",
    "refresh_token",
    "assertion",
    "client_assertion",
    "client_assertion_type",
    "code_verifier"
], $bdd166eca2c549e0$var$authorizeParams = [
    "connection",
    "connection_scope",
    "auth0Client",
    "owp",
    "device",
    "realm",
    "organization",
    "invitation",
    "protocol",
    "_csrf",
    "_intstate",
    "login_ticket",
    "client_id",
    "response_type",
    "response_mode",
    "redirect_uri",
    "audience",
    "scope",
    "state",
    "nonce",
    "display",
    "prompt",
    "screen_hint",
    "max_age",
    "ui_locales",
    "claims_locales",
    "id_token_hint",
    "login_hint",
    "acr_values",
    "claims",
    "registration",
    "request",
    "request_uri",
    "code_challenge",
    "code_challenge_method",
    "access_type",
    "display"
];
var $bdd166eca2c549e0$var$parametersWhitelist = {
    oauthTokenParams: function(warn, params) {
        return $bdd166eca2c549e0$var$objectHelper.pick(params, $bdd166eca2c549e0$var$tokenParams);
    },
    oauthAuthorizeParams: function(warn, params) {
        var notAllowed = $bdd166eca2c549e0$var$objectHelper.getKeysNotIn(params, $bdd166eca2c549e0$var$authorizeParams);
        return notAllowed.length > 0 && warn.warning("Following parameters are not allowed on the `/authorize` endpoint: [" + notAllowed.join(",") + "]"), params;
    }
}, $bdd166eca2c549e0$var$t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $bdd166eca2c549e0$var$e(t) {
    var e = {
        exports: {}
    };
    return t(e, e.exports), e.exports;
}
var $bdd166eca2c549e0$var$r = $bdd166eca2c549e0$var$e(function(e, r) {
    e.exports = function() {
        function e(t) {
            return "function" == typeof t;
        }
        var r = Array.isArray ? Array.isArray : function(t) {
            return "[object Array]" === Object.prototype.toString.call(t);
        }, i = 0, n = void 0, o = void 0, s = function(t, e) {
            l[i] = t, l[i + 1] = e, 2 === (i += 2) && (o ? o(d) : w());
        }, h = "undefined" != typeof window ? window : void 0, u = h || {}, a = u.MutationObserver || u.WebKitMutationObserver, f = "undefined" == typeof self && "undefined" != typeof $eh5Zb && "[object process]" === ({}).toString.call($eh5Zb), c = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
        function p() {
            var t = setTimeout;
            return function() {
                return t(d, 1);
            };
        }
        var l = new Array(1e3);
        function d() {
            for(var t = 0; t < i; t += 2)(0, l[t])(l[t + 1]), l[t] = void 0, l[t + 1] = void 0;
            i = 0;
        }
        var m, v, y, g, w = void 0;
        function T(t, e) {
            var r = this, i = new this.constructor(S);
            void 0 === i[_] && N(i);
            var n = r._state;
            if (n) {
                var o = arguments[n - 1];
                s(function() {
                    return O(n, i, o, r._result);
                });
            } else C(r, i, t, e);
            return i;
        }
        function b(t) {
            if (t && "object" == typeof t && t.constructor === this) return t;
            var e = new this(S);
            return E(e, t), e;
        }
        w = f ? function() {
            return $eh5Zb.nextTick(d);
        } : a ? (v = 0, y = new a(d), g = document.createTextNode(""), y.observe(g, {
            characterData: !0
        }), function() {
            g.data = v = ++v % 2;
        }) : c ? ((m = new MessageChannel).port1.onmessage = d, function() {
            return m.port2.postMessage(0);
        }) : void 0 === h ? function() {
            try {
                var t = Function("return this")().require("vertx");
                return void 0 !== (n = t.runOnLoop || t.runOnContext) ? function() {
                    n(d);
                } : p();
            } catch (t) {
                return p();
            }
        }() : p();
        var _ = Math.random().toString(36).substring(2);
        function S() {}
        var A = void 0;
        function x(t, r, i) {
            r.constructor === t.constructor && i === T && r.constructor.resolve === b ? function(t, e) {
                1 === e._state ? I(t, e._result) : 2 === e._state ? M(t, e._result) : C(e, void 0, function(e) {
                    return E(t, e);
                }, function(e) {
                    return M(t, e);
                });
            }(t, r) : void 0 === i ? I(t, r) : e(i) ? function(t, e, r) {
                s(function(t) {
                    var i = !1, n = function(r, n, o, s) {
                        try {
                            r.call(n, function(r) {
                                i || (i = !0, e !== r ? E(t, r) : I(t, r));
                            }, function(e) {
                                i || (i = !0, M(t, e));
                            });
                        } catch (t) {
                            return t;
                        }
                    }(r, e);
                    !i && n && (i = !0, M(t, n));
                }, t);
            }(t, r, i) : I(t, r);
        }
        function E(t, e) {
            if (t === e) M(t, new TypeError("You cannot resolve a promise with itself"));
            else if (n = typeof (i = e), null === i || "object" !== n && "function" !== n) I(t, e);
            else {
                var r = void 0;
                try {
                    r = e.then;
                } catch (e) {
                    return void M(t, e);
                }
                x(t, e, r);
            }
            var i, n;
        }
        function k(t) {
            t._onerror && t._onerror(t._result), R(t);
        }
        function I(t, e) {
            t._state === A && (t._result = e, t._state = 1, 0 !== t._subscribers.length && s(R, t));
        }
        function M(t, e) {
            t._state === A && (t._state = 2, t._result = e, s(k, t));
        }
        function C(t, e, r, i) {
            var n = t._subscribers, o = n.length;
            t._onerror = null, n[o] = e, n[o + 1] = r, n[o + 2] = i, 0 === o && t._state && s(R, t);
        }
        function R(t) {
            var e = t._subscribers, r = t._state;
            if (0 !== e.length) {
                for(var i = void 0, n = void 0, o = t._result, s = 0; s < e.length; s += 3)n = e[s + r], (i = e[s]) ? O(r, i, n, o) : n(o);
                t._subscribers.length = 0;
            }
        }
        function O(t, r, i, n) {
            var o = e(i), s = void 0, h = void 0, u = !0;
            if (o) {
                try {
                    s = i(n);
                } catch (t) {
                    u = !1, h = t;
                }
                if (r === s) return void M(r, new TypeError("A promises callback cannot return that same promise."));
            } else s = n;
            r._state !== A || (o && u ? E(r, s) : !1 === u ? M(r, h) : 1 === t ? I(r, s) : 2 === t && M(r, s));
        }
        var j = 0;
        function N(t) {
            t[_] = j++, t._state = void 0, t._result = void 0, t._subscribers = [];
        }
        var P = function() {
            function t(t, e) {
                this._instanceConstructor = t, this.promise = new t(S), this.promise[_] || N(this.promise), r(e) ? (this.length = e.length, this._remaining = e.length, this._result = new Array(this.length), 0 === this.length ? I(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(e), 0 === this._remaining && I(this.promise, this._result))) : M(this.promise, new Error("Array Methods must be provided an Array"));
            }
            return t.prototype._enumerate = function(t) {
                for(var e = 0; this._state === A && e < t.length; e++)this._eachEntry(t[e], e);
            }, t.prototype._eachEntry = function(t, e) {
                var r = this._instanceConstructor, i = r.resolve;
                if (i === b) {
                    var n = void 0, o = void 0, s = !1;
                    try {
                        n = t.then;
                    } catch (t) {
                        s = !0, o = t;
                    }
                    if (n === T && t._state !== A) this._settledAt(t._state, e, t._result);
                    else if ("function" != typeof n) this._remaining--, this._result[e] = t;
                    else if (r === V) {
                        var h = new r(S);
                        s ? M(h, o) : x(h, t, n), this._willSettleAt(h, e);
                    } else this._willSettleAt(new r(function(e) {
                        return e(t);
                    }), e);
                } else this._willSettleAt(i(t), e);
            }, t.prototype._settledAt = function(t, e, r) {
                var i = this.promise;
                i._state === A && (this._remaining--, 2 === t ? M(i, r) : this._result[e] = r), 0 === this._remaining && I(i, this._result);
            }, t.prototype._willSettleAt = function(t, e) {
                var r = this;
                C(t, void 0, function(t) {
                    return r._settledAt(1, e, t);
                }, function(t) {
                    return r._settledAt(2, e, t);
                });
            }, t;
        }(), V = function() {
            function t(e) {
                this[_] = j++, this._result = this._state = void 0, this._subscribers = [], S !== e && ("function" != typeof e && function() {
                    throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                }(), this instanceof t ? function(t, e) {
                    try {
                        e(function(e) {
                            E(t, e);
                        }, function(e) {
                            M(t, e);
                        });
                    } catch (e) {
                        M(t, e);
                    }
                }(this, e) : function() {
                    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                }());
            }
            return t.prototype.catch = function(t) {
                return this.then(null, t);
            }, t.prototype.finally = function(t) {
                var r = this, i = r.constructor;
                return e(t) ? r.then(function(e) {
                    return i.resolve(t()).then(function() {
                        return e;
                    });
                }, function(e) {
                    return i.resolve(t()).then(function() {
                        throw e;
                    });
                }) : r.then(t, t);
            }, t;
        }();
        return V.prototype.then = T, V.all = function(t) {
            return new P(this, t).promise;
        }, V.race = function(t) {
            var e = this;
            return r(t) ? new e(function(r, i) {
                for(var n = t.length, o = 0; o < n; o++)e.resolve(t[o]).then(r, i);
            }) : new e(function(t, e) {
                return e(new TypeError("You must pass an array to race."));
            });
        }, V.resolve = b, V.reject = function(t) {
            var e = new this(S);
            return M(e, t), e;
        }, V._setScheduler = function(t) {
            o = t;
        }, V._setAsap = function(t) {
            s = t;
        }, V._asap = s, V.polyfill = function() {
            var e = void 0;
            if (void 0 !== $bdd166eca2c549e0$var$t) e = $bdd166eca2c549e0$var$t;
            else if ("undefined" != typeof self) e = self;
            else try {
                e = Function("return this")();
            } catch (t) {
                throw new Error("polyfill failed because global object is unavailable in this environment");
            }
            var r = e.Promise;
            if (r) {
                var i = null;
                try {
                    i = Object.prototype.toString.call(r.resolve());
                } catch (t) {}
                if ("[object Promise]" === i && !r.cast) return;
            }
            e.Promise = V;
        }, V.Promise = V, V;
    }();
}), $bdd166eca2c549e0$var$i$1 = {
    __proto__: null,
    default: {}
}, $bdd166eca2c549e0$var$n = $bdd166eca2c549e0$var$e(function(e, r) {
    var n;
    e.exports = n = n || function(e, r) {
        var n;
        if ("undefined" != typeof window && window.crypto && (n = window.crypto), "undefined" != typeof self && self.crypto && (n = self.crypto), "undefined" != typeof globalThis && globalThis.crypto && (n = globalThis.crypto), !n && "undefined" != typeof window && window.msCrypto && (n = window.msCrypto), !n && void 0 !== $bdd166eca2c549e0$var$t && $bdd166eca2c549e0$var$t.crypto && (n = $bdd166eca2c549e0$var$t.crypto), !n) try {
            n = $bdd166eca2c549e0$var$i$1;
        } catch (t) {}
        var o = function() {
            if (n) {
                if ("function" == typeof n.getRandomValues) try {
                    return n.getRandomValues(new Uint32Array(1))[0];
                } catch (t) {}
                if ("function" == typeof n.randomBytes) try {
                    return n.randomBytes(4).readInt32LE();
                } catch (t) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        }, s = Object.create || function() {
            function t() {}
            return function(e) {
                var r;
                return t.prototype = e, r = new t, t.prototype = null, r;
            };
        }(), h = {}, u = h.lib = {}, a = u.Base = {
            extend: function(t) {
                var e = s(this);
                return t && e.mixIn(t), e.hasOwnProperty("init") && this.init !== e.init || (e.init = function() {
                    e.$super.init.apply(this, arguments);
                }), e.init.prototype = e, e.$super = this, e;
            },
            create: function() {
                var t = this.extend();
                return t.init.apply(t, arguments), t;
            },
            init: function() {},
            mixIn: function(t) {
                for(var e in t)t.hasOwnProperty(e) && (this[e] = t[e]);
                t.hasOwnProperty("toString") && (this.toString = t.toString);
            },
            clone: function() {
                return this.init.prototype.extend(this);
            }
        }, f = u.WordArray = a.extend({
            init: function(t, e) {
                t = this.words = t || [], this.sigBytes = null != e ? e : 4 * t.length;
            },
            toString: function(t) {
                return (t || p).stringify(this);
            },
            concat: function(t) {
                var e = this.words, r = t.words, i = this.sigBytes, n = t.sigBytes;
                if (this.clamp(), i % 4) for(var o = 0; o < n; o++)e[i + o >>> 2] |= (r[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 24 - (i + o) % 4 * 8;
                else for(var s = 0; s < n; s += 4)e[i + s >>> 2] = r[s >>> 2];
                return this.sigBytes += n, this;
            },
            clamp: function() {
                var t = this.words, r = this.sigBytes;
                t[r >>> 2] &= 4294967295 << 32 - r % 4 * 8, t.length = e.ceil(r / 4);
            },
            clone: function() {
                var t = a.clone.call(this);
                return t.words = this.words.slice(0), t;
            },
            random: function(t) {
                for(var e = [], r = 0; r < t; r += 4)e.push(o());
                return new f.init(e, t);
            }
        }), c = h.enc = {}, p = c.Hex = {
            stringify: function(t) {
                for(var e = t.words, r = t.sigBytes, i = [], n = 0; n < r; n++){
                    var o = e[n >>> 2] >>> 24 - n % 4 * 8 & 255;
                    i.push((o >>> 4).toString(16)), i.push((15 & o).toString(16));
                }
                return i.join("");
            },
            parse: function(t) {
                for(var e = t.length, r = [], i = 0; i < e; i += 2)r[i >>> 3] |= parseInt(t.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new f.init(r, e / 2);
            }
        }, l = c.Latin1 = {
            stringify: function(t) {
                for(var e = t.words, r = t.sigBytes, i = [], n = 0; n < r; n++)i.push(String.fromCharCode(e[n >>> 2] >>> 24 - n % 4 * 8 & 255));
                return i.join("");
            },
            parse: function(t) {
                for(var e = t.length, r = [], i = 0; i < e; i++)r[i >>> 2] |= (255 & t.charCodeAt(i)) << 24 - i % 4 * 8;
                return new f.init(r, e);
            }
        }, d = c.Utf8 = {
            stringify: function(t) {
                try {
                    return decodeURIComponent(escape(l.stringify(t)));
                } catch (t) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            parse: function(t) {
                return l.parse(unescape(encodeURIComponent(t)));
            }
        }, m = u.BufferedBlockAlgorithm = a.extend({
            reset: function() {
                this._data = new f.init, this._nDataBytes = 0;
            },
            _append: function(t) {
                "string" == typeof t && (t = d.parse(t)), this._data.concat(t), this._nDataBytes += t.sigBytes;
            },
            _process: function(t) {
                var r, i = this._data, n = i.words, o = i.sigBytes, s = this.blockSize, h = o / (4 * s), u = (h = t ? e.ceil(h) : e.max((0 | h) - this._minBufferSize, 0)) * s, a = e.min(4 * u, o);
                if (u) {
                    for(var c = 0; c < u; c += s)this._doProcessBlock(n, c);
                    r = n.splice(0, u), i.sigBytes -= a;
                }
                return new f.init(r, a);
            },
            clone: function() {
                var t = a.clone.call(this);
                return t._data = this._data.clone(), t;
            },
            _minBufferSize: 0
        });
        u.Hasher = m.extend({
            cfg: a.extend(),
            init: function(t) {
                this.cfg = this.cfg.extend(t), this.reset();
            },
            reset: function() {
                m.reset.call(this), this._doReset();
            },
            update: function(t) {
                return this._append(t), this._process(), this;
            },
            finalize: function(t) {
                return t && this._append(t), this._doFinalize();
            },
            blockSize: 16,
            _createHelper: function(t) {
                return function(e, r) {
                    return new t.init(r).finalize(e);
                };
            },
            _createHmacHelper: function(t) {
                return function(e, r) {
                    return new v.HMAC.init(t, r).finalize(e);
                };
            }
        });
        var v = h.algo = {};
        return h;
    }(Math);
}), $bdd166eca2c549e0$var$o = $bdd166eca2c549e0$var$e(function(t, e) {
    var r;
    t.exports = (r = $bdd166eca2c549e0$var$n, function(t) {
        var e = r, i = e.lib, n = i.WordArray, o = i.Hasher, s = e.algo, h = [], u = [];
        !function() {
            function e(e) {
                for(var r = t.sqrt(e), i = 2; i <= r; i++)if (!(e % i)) return !1;
                return !0;
            }
            function r(t) {
                return 4294967296 * (t - (0 | t)) | 0;
            }
            for(var i = 2, n = 0; n < 64;)e(i) && (n < 8 && (h[n] = r(t.pow(i, .5))), u[n] = r(t.pow(i, 1 / 3)), n++), i++;
        }();
        var a = [], f = s.SHA256 = o.extend({
            _doReset: function() {
                this._hash = new n.init(h.slice(0));
            },
            _doProcessBlock: function(t, e) {
                for(var r = this._hash.words, i = r[0], n = r[1], o = r[2], s = r[3], h = r[4], f = r[5], c = r[6], p = r[7], l = 0; l < 64; l++){
                    if (l < 16) a[l] = 0 | t[e + l];
                    else {
                        var d = a[l - 15], m = a[l - 2];
                        a[l] = ((d << 25 | d >>> 7) ^ (d << 14 | d >>> 18) ^ d >>> 3) + a[l - 7] + ((m << 15 | m >>> 17) ^ (m << 13 | m >>> 19) ^ m >>> 10) + a[l - 16];
                    }
                    var v = i & n ^ i & o ^ n & o, y = p + ((h << 26 | h >>> 6) ^ (h << 21 | h >>> 11) ^ (h << 7 | h >>> 25)) + (h & f ^ ~h & c) + u[l] + a[l];
                    p = c, c = f, f = h, h = s + y | 0, s = o, o = n, n = i, i = y + (((i << 30 | i >>> 2) ^ (i << 19 | i >>> 13) ^ (i << 10 | i >>> 22)) + v) | 0;
                }
                r[0] = r[0] + i | 0, r[1] = r[1] + n | 0, r[2] = r[2] + o | 0, r[3] = r[3] + s | 0, r[4] = r[4] + h | 0, r[5] = r[5] + f | 0, r[6] = r[6] + c | 0, r[7] = r[7] + p | 0;
            },
            _doFinalize: function() {
                var e = this._data, r = e.words, i = 8 * this._nDataBytes, n = 8 * e.sigBytes;
                return r[n >>> 5] |= 128 << 24 - n % 32, r[14 + (n + 64 >>> 9 << 4)] = t.floor(i / 4294967296), r[15 + (n + 64 >>> 9 << 4)] = i, e.sigBytes = 4 * r.length, this._process(), this._hash;
            },
            clone: function() {
                var t = o.clone.call(this);
                return t._hash = this._hash.clone(), t;
            }
        });
        e.SHA256 = o._createHelper(f), e.HmacSHA256 = o._createHmacHelper(f);
    }(Math), r.SHA256);
}), $bdd166eca2c549e0$var$s = $bdd166eca2c549e0$var$e(function(t, e) {
    var r, i;
    t.exports = (i = (r = $bdd166eca2c549e0$var$n).lib.WordArray, r.enc.Base64 = {
        stringify: function(t) {
            var e = t.words, r = t.sigBytes, i = this._map;
            t.clamp();
            for(var n = [], o = 0; o < r; o += 3)for(var s = (e[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 16 | (e[o + 1 >>> 2] >>> 24 - (o + 1) % 4 * 8 & 255) << 8 | e[o + 2 >>> 2] >>> 24 - (o + 2) % 4 * 8 & 255, h = 0; h < 4 && o + .75 * h < r; h++)n.push(i.charAt(s >>> 6 * (3 - h) & 63));
            var u = i.charAt(64);
            if (u) for(; n.length % 4;)n.push(u);
            return n.join("");
        },
        parse: function(t) {
            var e = t.length, r = this._map, n = this._reverseMap;
            if (!n) {
                n = this._reverseMap = [];
                for(var o = 0; o < r.length; o++)n[r.charCodeAt(o)] = o;
            }
            var s = r.charAt(64);
            if (s) {
                var h = t.indexOf(s);
                -1 !== h && (e = h);
            }
            return function(t, e, r) {
                for(var n = [], o = 0, s = 0; s < e; s++)if (s % 4) {
                    var h = r[t.charCodeAt(s - 1)] << s % 4 * 2, u = r[t.charCodeAt(s)] >>> 6 - s % 4 * 2;
                    n[o >>> 2] |= (h | u) << 24 - o % 4 * 8, o++;
                }
                return i.create(n, o);
            }(t, e, n);
        },
        _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    }, r.enc.Base64);
}), $bdd166eca2c549e0$var$h = $bdd166eca2c549e0$var$e(function(t, e) {
    t.exports = $bdd166eca2c549e0$var$n.enc.Hex;
}), $bdd166eca2c549e0$var$u = $bdd166eca2c549e0$var$e(function(e, r) {
    (function() {
        var t;
        function r(t, e, r) {
            null != t && ("number" == typeof t ? this.fromNumber(t, e, r) : this.fromString(t, null == e && "string" != typeof t ? 256 : e));
        }
        function i() {
            return new r(null);
        }
        var n = "undefined" != typeof navigator;
        n && "Microsoft Internet Explorer" == navigator.appName ? (r.prototype.am = function(t, e, r, i, n, o) {
            for(var s = 32767 & e, h = e >> 15; --o >= 0;){
                var u = 32767 & this[t], a = this[t++] >> 15, f = h * u + a * s;
                n = ((u = s * u + ((32767 & f) << 15) + r[i] + (1073741823 & n)) >>> 30) + (f >>> 15) + h * a + (n >>> 30), r[i++] = 1073741823 & u;
            }
            return n;
        }, t = 30) : n && "Netscape" != navigator.appName ? (r.prototype.am = function(t, e, r, i, n, o) {
            for(; --o >= 0;){
                var s = e * this[t++] + r[i] + n;
                n = Math.floor(s / 67108864), r[i++] = 67108863 & s;
            }
            return n;
        }, t = 26) : (r.prototype.am = function(t, e, r, i, n, o) {
            for(var s = 16383 & e, h = e >> 14; --o >= 0;){
                var u = 16383 & this[t], a = this[t++] >> 14, f = h * u + a * s;
                n = ((u = s * u + ((16383 & f) << 14) + r[i] + n) >> 28) + (f >> 14) + h * a, r[i++] = 268435455 & u;
            }
            return n;
        }, t = 28), r.prototype.DB = t, r.prototype.DM = (1 << t) - 1, r.prototype.DV = 1 << t, r.prototype.FV = Math.pow(2, 52), r.prototype.F1 = 52 - t, r.prototype.F2 = 2 * t - 52;
        var o, s, h = new Array;
        for(o = "0".charCodeAt(0), s = 0; s <= 9; ++s)h[o++] = s;
        for(o = "a".charCodeAt(0), s = 10; s < 36; ++s)h[o++] = s;
        for(o = "A".charCodeAt(0), s = 10; s < 36; ++s)h[o++] = s;
        function u(t) {
            return "0123456789abcdefghijklmnopqrstuvwxyz".charAt(t);
        }
        function a(t, e) {
            var r = h[t.charCodeAt(e)];
            return null == r ? -1 : r;
        }
        function f(t) {
            var e = i();
            return e.fromInt(t), e;
        }
        function c(t) {
            var e, r = 1;
            return 0 != (e = t >>> 16) && (t = e, r += 16), 0 != (e = t >> 8) && (t = e, r += 8), 0 != (e = t >> 4) && (t = e, r += 4), 0 != (e = t >> 2) && (t = e, r += 2), 0 != (e = t >> 1) && (t = e, r += 1), r;
        }
        function p(t) {
            this.m = t;
        }
        function l(t) {
            this.m = t, this.mp = t.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << t.DB - 15) - 1, this.mt2 = 2 * t.t;
        }
        function d(t, e) {
            return t & e;
        }
        function m(t, e) {
            return t | e;
        }
        function v(t, e) {
            return t ^ e;
        }
        function y(t, e) {
            return t & ~e;
        }
        function g(t) {
            if (0 == t) return -1;
            var e = 0;
            return 0 == (65535 & t) && (t >>= 16, e += 16), 0 == (255 & t) && (t >>= 8, e += 8), 0 == (15 & t) && (t >>= 4, e += 4), 0 == (3 & t) && (t >>= 2, e += 2), 0 == (1 & t) && ++e, e;
        }
        function w(t) {
            for(var e = 0; 0 != t;)t &= t - 1, ++e;
            return e;
        }
        function T() {}
        function b(t) {
            return t;
        }
        function _(t) {
            this.r2 = i(), this.q3 = i(), r.ONE.dlShiftTo(2 * t.t, this.r2), this.mu = this.r2.divide(t), this.m = t;
        }
        p.prototype.convert = function(t) {
            return t.s < 0 || t.compareTo(this.m) >= 0 ? t.mod(this.m) : t;
        }, p.prototype.revert = function(t) {
            return t;
        }, p.prototype.reduce = function(t) {
            t.divRemTo(this.m, null, t);
        }, p.prototype.mulTo = function(t, e, r) {
            t.multiplyTo(e, r), this.reduce(r);
        }, p.prototype.sqrTo = function(t, e) {
            t.squareTo(e), this.reduce(e);
        }, l.prototype.convert = function(t) {
            var e = i();
            return t.abs().dlShiftTo(this.m.t, e), e.divRemTo(this.m, null, e), t.s < 0 && e.compareTo(r.ZERO) > 0 && this.m.subTo(e, e), e;
        }, l.prototype.revert = function(t) {
            var e = i();
            return t.copyTo(e), this.reduce(e), e;
        }, l.prototype.reduce = function(t) {
            for(; t.t <= this.mt2;)t[t.t++] = 0;
            for(var e = 0; e < this.m.t; ++e){
                var r = 32767 & t[e], i = r * this.mpl + ((r * this.mph + (t[e] >> 15) * this.mpl & this.um) << 15) & t.DM;
                for(t[r = e + this.m.t] += this.m.am(0, i, t, e, 0, this.m.t); t[r] >= t.DV;)t[r] -= t.DV, t[++r]++;
            }
            t.clamp(), t.drShiftTo(this.m.t, t), t.compareTo(this.m) >= 0 && t.subTo(this.m, t);
        }, l.prototype.mulTo = function(t, e, r) {
            t.multiplyTo(e, r), this.reduce(r);
        }, l.prototype.sqrTo = function(t, e) {
            t.squareTo(e), this.reduce(e);
        }, r.prototype.copyTo = function(t) {
            for(var e = this.t - 1; e >= 0; --e)t[e] = this[e];
            t.t = this.t, t.s = this.s;
        }, r.prototype.fromInt = function(t) {
            this.t = 1, this.s = t < 0 ? -1 : 0, t > 0 ? this[0] = t : t < -1 ? this[0] = t + this.DV : this.t = 0;
        }, r.prototype.fromString = function(t, e) {
            var i;
            if (16 == e) i = 4;
            else if (8 == e) i = 3;
            else if (256 == e) i = 8;
            else if (2 == e) i = 1;
            else if (32 == e) i = 5;
            else {
                if (4 != e) return void this.fromRadix(t, e);
                i = 2;
            }
            this.t = 0, this.s = 0;
            for(var n = t.length, o = !1, s = 0; --n >= 0;){
                var h = 8 == i ? 255 & t[n] : a(t, n);
                h < 0 ? "-" == t.charAt(n) && (o = !0) : (o = !1, 0 == s ? this[this.t++] = h : s + i > this.DB ? (this[this.t - 1] |= (h & (1 << this.DB - s) - 1) << s, this[this.t++] = h >> this.DB - s) : this[this.t - 1] |= h << s, (s += i) >= this.DB && (s -= this.DB));
            }
            8 == i && 0 != (128 & t[0]) && (this.s = -1, s > 0 && (this[this.t - 1] |= (1 << this.DB - s) - 1 << s)), this.clamp(), o && r.ZERO.subTo(this, this);
        }, r.prototype.clamp = function() {
            for(var t = this.s & this.DM; this.t > 0 && this[this.t - 1] == t;)--this.t;
        }, r.prototype.dlShiftTo = function(t, e) {
            var r;
            for(r = this.t - 1; r >= 0; --r)e[r + t] = this[r];
            for(r = t - 1; r >= 0; --r)e[r] = 0;
            e.t = this.t + t, e.s = this.s;
        }, r.prototype.drShiftTo = function(t, e) {
            for(var r = t; r < this.t; ++r)e[r - t] = this[r];
            e.t = Math.max(this.t - t, 0), e.s = this.s;
        }, r.prototype.lShiftTo = function(t, e) {
            var r, i = t % this.DB, n = this.DB - i, o = (1 << n) - 1, s = Math.floor(t / this.DB), h = this.s << i & this.DM;
            for(r = this.t - 1; r >= 0; --r)e[r + s + 1] = this[r] >> n | h, h = (this[r] & o) << i;
            for(r = s - 1; r >= 0; --r)e[r] = 0;
            e[s] = h, e.t = this.t + s + 1, e.s = this.s, e.clamp();
        }, r.prototype.rShiftTo = function(t, e) {
            e.s = this.s;
            var r = Math.floor(t / this.DB);
            if (r >= this.t) e.t = 0;
            else {
                var i = t % this.DB, n = this.DB - i, o = (1 << i) - 1;
                e[0] = this[r] >> i;
                for(var s = r + 1; s < this.t; ++s)e[s - r - 1] |= (this[s] & o) << n, e[s - r] = this[s] >> i;
                i > 0 && (e[this.t - r - 1] |= (this.s & o) << n), e.t = this.t - r, e.clamp();
            }
        }, r.prototype.subTo = function(t, e) {
            for(var r = 0, i = 0, n = Math.min(t.t, this.t); r < n;)i += this[r] - t[r], e[r++] = i & this.DM, i >>= this.DB;
            if (t.t < this.t) {
                for(i -= t.s; r < this.t;)i += this[r], e[r++] = i & this.DM, i >>= this.DB;
                i += this.s;
            } else {
                for(i += this.s; r < t.t;)i -= t[r], e[r++] = i & this.DM, i >>= this.DB;
                i -= t.s;
            }
            e.s = i < 0 ? -1 : 0, i < -1 ? e[r++] = this.DV + i : i > 0 && (e[r++] = i), e.t = r, e.clamp();
        }, r.prototype.multiplyTo = function(t, e) {
            var i = this.abs(), n = t.abs(), o = i.t;
            for(e.t = o + n.t; --o >= 0;)e[o] = 0;
            for(o = 0; o < n.t; ++o)e[o + i.t] = i.am(0, n[o], e, o, 0, i.t);
            e.s = 0, e.clamp(), this.s != t.s && r.ZERO.subTo(e, e);
        }, r.prototype.squareTo = function(t) {
            for(var e = this.abs(), r = t.t = 2 * e.t; --r >= 0;)t[r] = 0;
            for(r = 0; r < e.t - 1; ++r){
                var i = e.am(r, e[r], t, 2 * r, 0, 1);
                (t[r + e.t] += e.am(r + 1, 2 * e[r], t, 2 * r + 1, i, e.t - r - 1)) >= e.DV && (t[r + e.t] -= e.DV, t[r + e.t + 1] = 1);
            }
            t.t > 0 && (t[t.t - 1] += e.am(r, e[r], t, 2 * r, 0, 1)), t.s = 0, t.clamp();
        }, r.prototype.divRemTo = function(t, e, n) {
            var o = t.abs();
            if (!(o.t <= 0)) {
                var s = this.abs();
                if (s.t < o.t) return null != e && e.fromInt(0), void (null != n && this.copyTo(n));
                null == n && (n = i());
                var h = i(), u = this.s, a = t.s, f = this.DB - c(o[o.t - 1]);
                f > 0 ? (o.lShiftTo(f, h), s.lShiftTo(f, n)) : (o.copyTo(h), s.copyTo(n));
                var p = h.t, l = h[p - 1];
                if (0 != l) {
                    var d = l * (1 << this.F1) + (p > 1 ? h[p - 2] >> this.F2 : 0), m = this.FV / d, v = (1 << this.F1) / d, y = 1 << this.F2, g = n.t, w = g - p, T = null == e ? i() : e;
                    for(h.dlShiftTo(w, T), n.compareTo(T) >= 0 && (n[n.t++] = 1, n.subTo(T, n)), r.ONE.dlShiftTo(p, T), T.subTo(h, h); h.t < p;)h[h.t++] = 0;
                    for(; --w >= 0;){
                        var b = n[--g] == l ? this.DM : Math.floor(n[g] * m + (n[g - 1] + y) * v);
                        if ((n[g] += h.am(0, b, n, w, 0, p)) < b) for(h.dlShiftTo(w, T), n.subTo(T, n); n[g] < --b;)n.subTo(T, n);
                    }
                    null != e && (n.drShiftTo(p, e), u != a && r.ZERO.subTo(e, e)), n.t = p, n.clamp(), f > 0 && n.rShiftTo(f, n), u < 0 && r.ZERO.subTo(n, n);
                }
            }
        }, r.prototype.invDigit = function() {
            if (this.t < 1) return 0;
            var t = this[0];
            if (0 == (1 & t)) return 0;
            var e = 3 & t;
            return (e = (e = (e = (e = e * (2 - (15 & t) * e) & 15) * (2 - (255 & t) * e) & 255) * (2 - ((65535 & t) * e & 65535)) & 65535) * (2 - t * e % this.DV) % this.DV) > 0 ? this.DV - e : -e;
        }, r.prototype.isEven = function() {
            return 0 == (this.t > 0 ? 1 & this[0] : this.s);
        }, r.prototype.exp = function(t, e) {
            if (t > 4294967295 || t < 1) return r.ONE;
            var n = i(), o = i(), s = e.convert(this), h = c(t) - 1;
            for(s.copyTo(n); --h >= 0;)if (e.sqrTo(n, o), (t & 1 << h) > 0) e.mulTo(o, s, n);
            else {
                var u = n;
                n = o, o = u;
            }
            return e.revert(n);
        }, r.prototype.toString = function(t) {
            if (this.s < 0) return "-" + this.negate().toString(t);
            var e;
            if (16 == t) e = 4;
            else if (8 == t) e = 3;
            else if (2 == t) e = 1;
            else if (32 == t) e = 5;
            else {
                if (4 != t) return this.toRadix(t);
                e = 2;
            }
            var r, i = (1 << e) - 1, n = !1, o = "", s = this.t, h = this.DB - s * this.DB % e;
            if (s-- > 0) for(h < this.DB && (r = this[s] >> h) > 0 && (n = !0, o = u(r)); s >= 0;)h < e ? (r = (this[s] & (1 << h) - 1) << e - h, r |= this[--s] >> (h += this.DB - e)) : (r = this[s] >> (h -= e) & i, h <= 0 && (h += this.DB, --s)), r > 0 && (n = !0), n && (o += u(r));
            return n ? o : "0";
        }, r.prototype.negate = function() {
            var t = i();
            return r.ZERO.subTo(this, t), t;
        }, r.prototype.abs = function() {
            return this.s < 0 ? this.negate() : this;
        }, r.prototype.compareTo = function(t) {
            var e = this.s - t.s;
            if (0 != e) return e;
            var r = this.t;
            if (0 != (e = r - t.t)) return this.s < 0 ? -e : e;
            for(; --r >= 0;)if (0 != (e = this[r] - t[r])) return e;
            return 0;
        }, r.prototype.bitLength = function() {
            return this.t <= 0 ? 0 : this.DB * (this.t - 1) + c(this[this.t - 1] ^ this.s & this.DM);
        }, r.prototype.mod = function(t) {
            var e = i();
            return this.abs().divRemTo(t, null, e), this.s < 0 && e.compareTo(r.ZERO) > 0 && t.subTo(e, e), e;
        }, r.prototype.modPowInt = function(t, e) {
            var r;
            return r = t < 256 || e.isEven() ? new p(e) : new l(e), this.exp(t, r);
        }, r.ZERO = f(0), r.ONE = f(1), T.prototype.convert = b, T.prototype.revert = b, T.prototype.mulTo = function(t, e, r) {
            t.multiplyTo(e, r);
        }, T.prototype.sqrTo = function(t, e) {
            t.squareTo(e);
        }, _.prototype.convert = function(t) {
            if (t.s < 0 || t.t > 2 * this.m.t) return t.mod(this.m);
            if (t.compareTo(this.m) < 0) return t;
            var e = i();
            return t.copyTo(e), this.reduce(e), e;
        }, _.prototype.revert = function(t) {
            return t;
        }, _.prototype.reduce = function(t) {
            for(t.drShiftTo(this.m.t - 1, this.r2), t.t > this.m.t + 1 && (t.t = this.m.t + 1, t.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); t.compareTo(this.r2) < 0;)t.dAddOffset(1, this.m.t + 1);
            for(t.subTo(this.r2, t); t.compareTo(this.m) >= 0;)t.subTo(this.m, t);
        }, _.prototype.mulTo = function(t, e, r) {
            t.multiplyTo(e, r), this.reduce(r);
        }, _.prototype.sqrTo = function(t, e) {
            t.squareTo(e), this.reduce(e);
        };
        var S, A, D, B = [
            2,
            3,
            5,
            7,
            11,
            13,
            17,
            19,
            23,
            29,
            31,
            37,
            41,
            43,
            47,
            53,
            59,
            61,
            67,
            71,
            73,
            79,
            83,
            89,
            97,
            101,
            103,
            107,
            109,
            113,
            127,
            131,
            137,
            139,
            149,
            151,
            157,
            163,
            167,
            173,
            179,
            181,
            191,
            193,
            197,
            199,
            211,
            223,
            227,
            229,
            233,
            239,
            241,
            251,
            257,
            263,
            269,
            271,
            277,
            281,
            283,
            293,
            307,
            311,
            313,
            317,
            331,
            337,
            347,
            349,
            353,
            359,
            367,
            373,
            379,
            383,
            389,
            397,
            401,
            409,
            419,
            421,
            431,
            433,
            439,
            443,
            449,
            457,
            461,
            463,
            467,
            479,
            487,
            491,
            499,
            503,
            509,
            521,
            523,
            541,
            547,
            557,
            563,
            569,
            571,
            577,
            587,
            593,
            599,
            601,
            607,
            613,
            617,
            619,
            631,
            641,
            643,
            647,
            653,
            659,
            661,
            673,
            677,
            683,
            691,
            701,
            709,
            719,
            727,
            733,
            739,
            743,
            751,
            757,
            761,
            769,
            773,
            787,
            797,
            809,
            811,
            821,
            823,
            827,
            829,
            839,
            853,
            857,
            859,
            863,
            877,
            881,
            883,
            887,
            907,
            911,
            919,
            929,
            937,
            941,
            947,
            953,
            967,
            971,
            977,
            983,
            991,
            997
        ], x = 67108864 / B[B.length - 1];
        function E() {
            var t;
            t = (new Date).getTime(), A[D++] ^= 255 & t, A[D++] ^= t >> 8 & 255, A[D++] ^= t >> 16 & 255, A[D++] ^= t >> 24 & 255, D >= j && (D -= j);
        }
        if (r.prototype.chunkSize = function(t) {
            return Math.floor(Math.LN2 * this.DB / Math.log(t));
        }, r.prototype.toRadix = function(t) {
            if (null == t && (t = 10), 0 == this.signum() || t < 2 || t > 36) return "0";
            var e = this.chunkSize(t), r = Math.pow(t, e), n = f(r), o = i(), s = i(), h = "";
            for(this.divRemTo(n, o, s); o.signum() > 0;)h = (r + s.intValue()).toString(t).substr(1) + h, o.divRemTo(n, o, s);
            return s.intValue().toString(t) + h;
        }, r.prototype.fromRadix = function(t, e) {
            this.fromInt(0), null == e && (e = 10);
            for(var i = this.chunkSize(e), n = Math.pow(e, i), o = !1, s = 0, h = 0, u = 0; u < t.length; ++u){
                var f = a(t, u);
                f < 0 ? "-" == t.charAt(u) && 0 == this.signum() && (o = !0) : (h = e * h + f, ++s >= i && (this.dMultiply(n), this.dAddOffset(h, 0), s = 0, h = 0));
            }
            s > 0 && (this.dMultiply(Math.pow(e, s)), this.dAddOffset(h, 0)), o && r.ZERO.subTo(this, this);
        }, r.prototype.fromNumber = function(t, e, i) {
            if ("number" == typeof e) {
                if (t < 2) this.fromInt(1);
                else for(this.fromNumber(t, i), this.testBit(t - 1) || this.bitwiseTo(r.ONE.shiftLeft(t - 1), m, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(e);)this.dAddOffset(2, 0), this.bitLength() > t && this.subTo(r.ONE.shiftLeft(t - 1), this);
            } else {
                var n = new Array, o = 7 & t;
                n.length = 1 + (t >> 3), e.nextBytes(n), o > 0 ? n[0] &= (1 << o) - 1 : n[0] = 0, this.fromString(n, 256);
            }
        }, r.prototype.bitwiseTo = function(t, e, r) {
            var i, n, o = Math.min(t.t, this.t);
            for(i = 0; i < o; ++i)r[i] = e(this[i], t[i]);
            if (t.t < this.t) {
                for(n = t.s & this.DM, i = o; i < this.t; ++i)r[i] = e(this[i], n);
                r.t = this.t;
            } else {
                for(n = this.s & this.DM, i = o; i < t.t; ++i)r[i] = e(n, t[i]);
                r.t = t.t;
            }
            r.s = e(this.s, t.s), r.clamp();
        }, r.prototype.changeBit = function(t, e) {
            var i = r.ONE.shiftLeft(t);
            return this.bitwiseTo(i, e, i), i;
        }, r.prototype.addTo = function(t, e) {
            for(var r = 0, i = 0, n = Math.min(t.t, this.t); r < n;)i += this[r] + t[r], e[r++] = i & this.DM, i >>= this.DB;
            if (t.t < this.t) {
                for(i += t.s; r < this.t;)i += this[r], e[r++] = i & this.DM, i >>= this.DB;
                i += this.s;
            } else {
                for(i += this.s; r < t.t;)i += t[r], e[r++] = i & this.DM, i >>= this.DB;
                i += t.s;
            }
            e.s = i < 0 ? -1 : 0, i > 0 ? e[r++] = i : i < -1 && (e[r++] = this.DV + i), e.t = r, e.clamp();
        }, r.prototype.dMultiply = function(t) {
            this[this.t] = this.am(0, t - 1, this, 0, 0, this.t), ++this.t, this.clamp();
        }, r.prototype.dAddOffset = function(t, e) {
            if (0 != t) {
                for(; this.t <= e;)this[this.t++] = 0;
                for(this[e] += t; this[e] >= this.DV;)this[e] -= this.DV, ++e >= this.t && (this[this.t++] = 0), ++this[e];
            }
        }, r.prototype.multiplyLowerTo = function(t, e, r) {
            var i, n = Math.min(this.t + t.t, e);
            for(r.s = 0, r.t = n; n > 0;)r[--n] = 0;
            for(i = r.t - this.t; n < i; ++n)r[n + this.t] = this.am(0, t[n], r, n, 0, this.t);
            for(i = Math.min(t.t, e); n < i; ++n)this.am(0, t[n], r, n, 0, e - n);
            r.clamp();
        }, r.prototype.multiplyUpperTo = function(t, e, r) {
            --e;
            var i = r.t = this.t + t.t - e;
            for(r.s = 0; --i >= 0;)r[i] = 0;
            for(i = Math.max(e - this.t, 0); i < t.t; ++i)r[this.t + i - e] = this.am(e - i, t[i], r, 0, 0, this.t + i - e);
            r.clamp(), r.drShiftTo(1, r);
        }, r.prototype.modInt = function(t) {
            if (t <= 0) return 0;
            var e = this.DV % t, r = this.s < 0 ? t - 1 : 0;
            if (this.t > 0) {
                if (0 == e) r = this[0] % t;
                else for(var i = this.t - 1; i >= 0; --i)r = (e * r + this[i]) % t;
            }
            return r;
        }, r.prototype.millerRabin = function(t) {
            var e = this.subtract(r.ONE), n = e.getLowestSetBit();
            if (n <= 0) return !1;
            var o = e.shiftRight(n);
            (t = t + 1 >> 1) > B.length && (t = B.length);
            for(var s = i(), h = 0; h < t; ++h){
                s.fromInt(B[Math.floor(Math.random() * B.length)]);
                var u = s.modPow(o, this);
                if (0 != u.compareTo(r.ONE) && 0 != u.compareTo(e)) {
                    for(var a = 1; a++ < n && 0 != u.compareTo(e);)if (0 == (u = u.modPowInt(2, this)).compareTo(r.ONE)) return !1;
                    if (0 != u.compareTo(e)) return !1;
                }
            }
            return !0;
        }, r.prototype.clone = function() {
            var t = i();
            return this.copyTo(t), t;
        }, r.prototype.intValue = function() {
            if (this.s < 0) {
                if (1 == this.t) return this[0] - this.DV;
                if (0 == this.t) return -1;
            } else {
                if (1 == this.t) return this[0];
                if (0 == this.t) return 0;
            }
            return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
        }, r.prototype.byteValue = function() {
            return 0 == this.t ? this.s : this[0] << 24 >> 24;
        }, r.prototype.shortValue = function() {
            return 0 == this.t ? this.s : this[0] << 16 >> 16;
        }, r.prototype.signum = function() {
            return this.s < 0 ? -1 : this.t <= 0 || 1 == this.t && this[0] <= 0 ? 0 : 1;
        }, r.prototype.toByteArray = function() {
            var t = this.t, e = new Array;
            e[0] = this.s;
            var r, i = this.DB - t * this.DB % 8, n = 0;
            if (t-- > 0) for(i < this.DB && (r = this[t] >> i) != (this.s & this.DM) >> i && (e[n++] = r | this.s << this.DB - i); t >= 0;)i < 8 ? (r = (this[t] & (1 << i) - 1) << 8 - i, r |= this[--t] >> (i += this.DB - 8)) : (r = this[t] >> (i -= 8) & 255, i <= 0 && (i += this.DB, --t)), 0 != (128 & r) && (r |= -256), 0 == n && (128 & this.s) != (128 & r) && ++n, (n > 0 || r != this.s) && (e[n++] = r);
            return e;
        }, r.prototype.equals = function(t) {
            return 0 == this.compareTo(t);
        }, r.prototype.min = function(t) {
            return this.compareTo(t) < 0 ? this : t;
        }, r.prototype.max = function(t) {
            return this.compareTo(t) > 0 ? this : t;
        }, r.prototype.and = function(t) {
            var e = i();
            return this.bitwiseTo(t, d, e), e;
        }, r.prototype.or = function(t) {
            var e = i();
            return this.bitwiseTo(t, m, e), e;
        }, r.prototype.xor = function(t) {
            var e = i();
            return this.bitwiseTo(t, v, e), e;
        }, r.prototype.andNot = function(t) {
            var e = i();
            return this.bitwiseTo(t, y, e), e;
        }, r.prototype.not = function() {
            for(var t = i(), e = 0; e < this.t; ++e)t[e] = this.DM & ~this[e];
            return t.t = this.t, t.s = ~this.s, t;
        }, r.prototype.shiftLeft = function(t) {
            var e = i();
            return t < 0 ? this.rShiftTo(-t, e) : this.lShiftTo(t, e), e;
        }, r.prototype.shiftRight = function(t) {
            var e = i();
            return t < 0 ? this.lShiftTo(-t, e) : this.rShiftTo(t, e), e;
        }, r.prototype.getLowestSetBit = function() {
            for(var t = 0; t < this.t; ++t)if (0 != this[t]) return t * this.DB + g(this[t]);
            return this.s < 0 ? this.t * this.DB : -1;
        }, r.prototype.bitCount = function() {
            for(var t = 0, e = this.s & this.DM, r = 0; r < this.t; ++r)t += w(this[r] ^ e);
            return t;
        }, r.prototype.testBit = function(t) {
            var e = Math.floor(t / this.DB);
            return e >= this.t ? 0 != this.s : 0 != (this[e] & 1 << t % this.DB);
        }, r.prototype.setBit = function(t) {
            return this.changeBit(t, m);
        }, r.prototype.clearBit = function(t) {
            return this.changeBit(t, y);
        }, r.prototype.flipBit = function(t) {
            return this.changeBit(t, v);
        }, r.prototype.add = function(t) {
            var e = i();
            return this.addTo(t, e), e;
        }, r.prototype.subtract = function(t) {
            var e = i();
            return this.subTo(t, e), e;
        }, r.prototype.multiply = function(t) {
            var e = i();
            return this.multiplyTo(t, e), e;
        }, r.prototype.divide = function(t) {
            var e = i();
            return this.divRemTo(t, e, null), e;
        }, r.prototype.remainder = function(t) {
            var e = i();
            return this.divRemTo(t, null, e), e;
        }, r.prototype.divideAndRemainder = function(t) {
            var e = i(), r = i();
            return this.divRemTo(t, e, r), new Array(e, r);
        }, r.prototype.modPow = function(t, e) {
            var r, n, o = t.bitLength(), s = f(1);
            if (o <= 0) return s;
            r = o < 18 ? 1 : o < 48 ? 3 : o < 144 ? 4 : o < 768 ? 5 : 6, n = o < 8 ? new p(e) : e.isEven() ? new _(e) : new l(e);
            var h = new Array, u = 3, a = r - 1, d = (1 << r) - 1;
            if (h[1] = n.convert(this), r > 1) {
                var m = i();
                for(n.sqrTo(h[1], m); u <= d;)h[u] = i(), n.mulTo(m, h[u - 2], h[u]), u += 2;
            }
            var v, y, g = t.t - 1, w = !0, T = i();
            for(o = c(t[g]) - 1; g >= 0;){
                for(o >= a ? v = t[g] >> o - a & d : (v = (t[g] & (1 << o + 1) - 1) << a - o, g > 0 && (v |= t[g - 1] >> this.DB + o - a)), u = r; 0 == (1 & v);)v >>= 1, --u;
                if ((o -= u) < 0 && (o += this.DB, --g), w) h[v].copyTo(s), w = !1;
                else {
                    for(; u > 1;)n.sqrTo(s, T), n.sqrTo(T, s), u -= 2;
                    u > 0 ? n.sqrTo(s, T) : (y = s, s = T, T = y), n.mulTo(T, h[v], s);
                }
                for(; g >= 0 && 0 == (t[g] & 1 << o);)n.sqrTo(s, T), y = s, s = T, T = y, --o < 0 && (o = this.DB - 1, --g);
            }
            return n.revert(s);
        }, r.prototype.modInverse = function(t) {
            var e = t.isEven();
            if (this.isEven() && e || 0 == t.signum()) return r.ZERO;
            for(var i = t.clone(), n = this.clone(), o = f(1), s = f(0), h = f(0), u = f(1); 0 != i.signum();){
                for(; i.isEven();)i.rShiftTo(1, i), e ? (o.isEven() && s.isEven() || (o.addTo(this, o), s.subTo(t, s)), o.rShiftTo(1, o)) : s.isEven() || s.subTo(t, s), s.rShiftTo(1, s);
                for(; n.isEven();)n.rShiftTo(1, n), e ? (h.isEven() && u.isEven() || (h.addTo(this, h), u.subTo(t, u)), h.rShiftTo(1, h)) : u.isEven() || u.subTo(t, u), u.rShiftTo(1, u);
                i.compareTo(n) >= 0 ? (i.subTo(n, i), e && o.subTo(h, o), s.subTo(u, s)) : (n.subTo(i, n), e && h.subTo(o, h), u.subTo(s, u));
            }
            return 0 != n.compareTo(r.ONE) ? r.ZERO : u.compareTo(t) >= 0 ? u.subtract(t) : u.signum() < 0 ? (u.addTo(t, u), u.signum() < 0 ? u.add(t) : u) : u;
        }, r.prototype.pow = function(t) {
            return this.exp(t, new T);
        }, r.prototype.gcd = function(t) {
            var e = this.s < 0 ? this.negate() : this.clone(), r = t.s < 0 ? t.negate() : t.clone();
            if (e.compareTo(r) < 0) {
                var i = e;
                e = r, r = i;
            }
            var n = e.getLowestSetBit(), o = r.getLowestSetBit();
            if (o < 0) return e;
            for(n < o && (o = n), o > 0 && (e.rShiftTo(o, e), r.rShiftTo(o, r)); e.signum() > 0;)(n = e.getLowestSetBit()) > 0 && e.rShiftTo(n, e), (n = r.getLowestSetBit()) > 0 && r.rShiftTo(n, r), e.compareTo(r) >= 0 ? (e.subTo(r, e), e.rShiftTo(1, e)) : (r.subTo(e, r), r.rShiftTo(1, r));
            return o > 0 && r.lShiftTo(o, r), r;
        }, r.prototype.isProbablePrime = function(t) {
            var e, r = this.abs();
            if (1 == r.t && r[0] <= B[B.length - 1]) {
                for(e = 0; e < B.length; ++e)if (r[0] == B[e]) return !0;
                return !1;
            }
            if (r.isEven()) return !1;
            for(e = 1; e < B.length;){
                for(var i = B[e], n = e + 1; n < B.length && i < x;)i *= B[n++];
                for(i = r.modInt(i); e < n;)if (i % B[e++] == 0) return !1;
            }
            return r.millerRabin(t);
        }, r.prototype.square = function() {
            var t = i();
            return this.squareTo(t), t;
        }, r.prototype.Barrett = _, null == A) {
            var k;
            if (A = new Array, D = 0, "undefined" != typeof window && window.crypto) {
                if (window.crypto.getRandomValues) {
                    var I = new Uint8Array(32);
                    for(window.crypto.getRandomValues(I), k = 0; k < 32; ++k)A[D++] = I[k];
                } else if ("Netscape" == navigator.appName && navigator.appVersion < "5") {
                    var M = window.crypto.random(32);
                    for(k = 0; k < M.length; ++k)A[D++] = 255 & M.charCodeAt(k);
                }
            }
            for(; D < j;)k = Math.floor(65536 * Math.random()), A[D++] = k >>> 8, A[D++] = 255 & k;
            D = 0, E();
        }
        function C() {
            if (null == S) {
                for(E(), (S = new O).init(A), D = 0; D < A.length; ++D)A[D] = 0;
                D = 0;
            }
            return S.next();
        }
        function R() {}
        function O() {
            this.i = 0, this.j = 0, this.S = new Array;
        }
        R.prototype.nextBytes = function(t) {
            var e;
            for(e = 0; e < t.length; ++e)t[e] = C();
        }, O.prototype.init = function(t) {
            var e, r, i;
            for(e = 0; e < 256; ++e)this.S[e] = e;
            for(r = 0, e = 0; e < 256; ++e)i = this.S[e], this.S[e] = this.S[r = r + this.S[e] + t[e % t.length] & 255], this.S[r] = i;
            this.i = 0, this.j = 0;
        }, O.prototype.next = function() {
            var t;
            return this.i = this.i + 1 & 255, this.j = this.j + this.S[this.i] & 255, t = this.S[this.i], this.S[this.i] = this.S[this.j], this.S[this.j] = t, this.S[t + this.S[this.i] & 255];
        };
        var j = 256;
        e.exports = {
            default: r,
            BigInteger: r,
            SecureRandom: R
        };
    }).call($bdd166eca2c549e0$var$t);
}), $bdd166eca2c549e0$var$a = {
    sha1: "3021300906052b0e03021a05000414",
    sha224: "302d300d06096086480165030402040500041c",
    sha256: "3031300d060960864801650304020105000420",
    sha384: "3041300d060960864801650304020205000430",
    sha512: "3051300d060960864801650304020305000440",
    md2: "3020300c06082a864886f70d020205000410",
    md5: "3020300c06082a864886f70d020505000410",
    ripemd160: "3021300906052b2403020105000414"
}, $bdd166eca2c549e0$var$f = {
    sha256: $bdd166eca2c549e0$var$o
};
function $bdd166eca2c549e0$var$c(t, e) {
    if (this.n = null, this.e = 0, !(null != t && null != e && t.length > 0 && e.length > 0)) throw new Error("Invalid key data");
    this.n = new $bdd166eca2c549e0$var$u.BigInteger(t, 16), this.e = parseInt(e, 16);
}
$bdd166eca2c549e0$var$c.prototype.verify = function(t, e) {
    e = e.replace(/[^0-9a-f]|[\s\n]]/gi, "");
    var r = new $bdd166eca2c549e0$var$u.BigInteger(e, 16);
    if (r.bitLength() > this.n.bitLength()) throw new Error("Signature does not match with the key modulus.");
    var i = function(t) {
        for(var e in $bdd166eca2c549e0$var$a){
            var r = $bdd166eca2c549e0$var$a[e], i = r.length;
            if (t.substring(0, i) === r) return {
                alg: e,
                hash: t.substring(i)
            };
        }
        return [];
    }(r.modPowInt(this.e, this.n).toString(16).replace(/^1f+00/, ""));
    if (0 === i.length) return !1;
    if (!$bdd166eca2c549e0$var$f.hasOwnProperty(i.alg)) throw new Error("Hashing algorithm is not supported.");
    var n = $bdd166eca2c549e0$var$f[i.alg](t).toString();
    return i.hash === n;
};
for(var $bdd166eca2c549e0$var$p = [], $bdd166eca2c549e0$var$l = [], $bdd166eca2c549e0$var$d = "undefined" != typeof Uint8Array ? Uint8Array : Array, $bdd166eca2c549e0$var$m = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $bdd166eca2c549e0$var$v = 0; $bdd166eca2c549e0$var$v < 64; ++$bdd166eca2c549e0$var$v)$bdd166eca2c549e0$var$p[$bdd166eca2c549e0$var$v] = $bdd166eca2c549e0$var$m[$bdd166eca2c549e0$var$v], $bdd166eca2c549e0$var$l[$bdd166eca2c549e0$var$m.charCodeAt($bdd166eca2c549e0$var$v)] = $bdd166eca2c549e0$var$v;
$bdd166eca2c549e0$var$l["-".charCodeAt(0)] = 62, $bdd166eca2c549e0$var$l["_".charCodeAt(0)] = 63;
var $bdd166eca2c549e0$var$y = function(t) {
    var e, r, i = function(t) {
        var e = t.length;
        if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var r = t.indexOf("=");
        return -1 === r && (r = e), [
            r,
            r === e ? 0 : 4 - r % 4
        ];
    }(t), n = i[0], o = i[1], s = new $bdd166eca2c549e0$var$d(function(t, e, r) {
        return 3 * (e + r) / 4 - r;
    }(0, n, o)), h = 0, u = o > 0 ? n - 4 : n;
    for(r = 0; r < u; r += 4)e = $bdd166eca2c549e0$var$l[t.charCodeAt(r)] << 18 | $bdd166eca2c549e0$var$l[t.charCodeAt(r + 1)] << 12 | $bdd166eca2c549e0$var$l[t.charCodeAt(r + 2)] << 6 | $bdd166eca2c549e0$var$l[t.charCodeAt(r + 3)], s[h++] = e >> 16 & 255, s[h++] = e >> 8 & 255, s[h++] = 255 & e;
    return 2 === o && (e = $bdd166eca2c549e0$var$l[t.charCodeAt(r)] << 2 | $bdd166eca2c549e0$var$l[t.charCodeAt(r + 1)] >> 4, s[h++] = 255 & e), 1 === o && (e = $bdd166eca2c549e0$var$l[t.charCodeAt(r)] << 10 | $bdd166eca2c549e0$var$l[t.charCodeAt(r + 1)] << 4 | $bdd166eca2c549e0$var$l[t.charCodeAt(r + 2)] >> 2, s[h++] = e >> 8 & 255, s[h++] = 255 & e), s;
};
function $bdd166eca2c549e0$var$g(t) {
    var e = t.length % 4;
    return 0 === e ? t : t + new Array(4 - e + 1).join("=");
}
function $bdd166eca2c549e0$var$w(t) {
    return t = $bdd166eca2c549e0$var$g(t).replace(/\-/g, "+").replace(/_/g, "/"), decodeURIComponent((function(t) {
        for(var e = "", r = 0; r < t.length; r++)e += String.fromCharCode(t[r]);
        return e;
    })($bdd166eca2c549e0$var$y(t)).split("").map(function(t) {
        return "%" + ("00" + t.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
}
function $bdd166eca2c549e0$var$T(t) {
    return function(t) {
        for(var e = "", r = 0; r < t.length; r++){
            var i = t[r].toString(16);
            e += 2 === i.length ? i : "0" + i;
        }
        return e;
    }($bdd166eca2c549e0$var$y($bdd166eca2c549e0$var$g(t)));
}
var $bdd166eca2c549e0$var$b = $bdd166eca2c549e0$var$e(function(e) {
    var r, i;
    r = $bdd166eca2c549e0$var$t, i = function() {
        return function() {
            return function(t) {
                var e = [];
                if (0 === t.length) return "";
                if ("string" != typeof t[0]) throw new TypeError("Url must be a string. Received " + t[0]);
                if (t[0].match(/^[^/:]+:\/*$/) && t.length > 1) {
                    var r = t.shift();
                    t[0] = r + t[0];
                }
                t[0] = t[0].match(/^file:\/\/\//) ? t[0].replace(/^([^/:]+):\/*/, "$1:///") : t[0].replace(/^([^/:]+):\/*/, "$1://");
                for(var i = 0; i < t.length; i++){
                    var n = t[i];
                    if ("string" != typeof n) throw new TypeError("Url must be a string. Received " + n);
                    "" !== n && (i > 0 && (n = n.replace(/^[\/]+/, "")), n = n.replace(/[\/]+$/, i < t.length - 1 ? "" : "/"), e.push(n));
                }
                var o = e.join("/"), s = (o = o.replace(/\/(\?|&|#[^!])/g, "$1")).split("?");
                return s.shift() + (s.length > 0 ? "?" : "") + s.join("&");
            }("object" == typeof arguments[0] ? arguments[0] : [].slice.call(arguments));
        };
    }, e.exports ? e.exports = i() : r.urljoin = i();
});
function $bdd166eca2c549e0$var$_(t, e) {
    return e = e || {}, new Promise(function(r, i) {
        var n = new XMLHttpRequest, o = [], s = [], h = {}, u = function() {
            return {
                ok: 2 == (n.status / 100 | 0),
                statusText: n.statusText,
                status: n.status,
                url: n.responseURL,
                text: function() {
                    return Promise.resolve(n.responseText);
                },
                json: function() {
                    return Promise.resolve(n.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        n.response
                    ]));
                },
                clone: u,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return s;
                    },
                    get: function(t) {
                        return h[t.toLowerCase()];
                    },
                    has: function(t) {
                        return t.toLowerCase() in h;
                    }
                }
            };
        };
        for(var a in n.open(e.method || "get", t, !0), n.onload = function() {
            n.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(t, e, r) {
                o.push(e = e.toLowerCase()), s.push([
                    e,
                    r
                ]), h[e] = h[e] ? h[e] + "," + r : r;
            }), r(u());
        }, n.onerror = i, n.withCredentials = "include" == e.credentials, e.headers)n.setRequestHeader(a, e.headers[a]);
        n.send(e.body || null);
    });
}
function $bdd166eca2c549e0$var$S(t) {
    if (t.ok) return t.json();
    var e = new Error(t.statusText);
    return e.response = t, Promise.reject(e);
}
function $bdd166eca2c549e0$var$A(t) {
    this.name = "ConfigurationError", this.message = t || "";
}
function $bdd166eca2c549e0$var$D(t) {
    this.name = "TokenValidationError", this.message = t || "";
}
$bdd166eca2c549e0$var$A.prototype = Error.prototype, $bdd166eca2c549e0$var$D.prototype = Error.prototype;
var $bdd166eca2c549e0$var$B = function() {
    function t() {}
    var e = t.prototype;
    return e.get = function() {
        return null;
    }, e.has = function() {
        return null;
    }, e.set = function() {
        return null;
    }, t;
}();
$bdd166eca2c549e0$var$r.polyfill();
var $bdd166eca2c549e0$var$x = "RS256", $bdd166eca2c549e0$var$E = function(t) {
    return "number" == typeof t;
}, $bdd166eca2c549e0$var$k = function() {
    return new Date;
};
function $bdd166eca2c549e0$var$I(t) {
    var e = t || {};
    if (this.jwksCache = e.jwksCache || new $bdd166eca2c549e0$var$B, this.expectedAlg = e.expectedAlg || "RS256", this.issuer = e.issuer, this.audience = e.audience, this.leeway = 0 === e.leeway ? 0 : e.leeway || 60, this.jwksURI = e.jwksURI, this.maxAge = e.maxAge, this.__clock = "function" == typeof e.__clock ? e.__clock : $bdd166eca2c549e0$var$k, this.leeway < 0 || this.leeway > 300) throw new $bdd166eca2c549e0$var$A("The leeway should be positive and lower than five minutes.");
    if ($bdd166eca2c549e0$var$x !== this.expectedAlg) throw new $bdd166eca2c549e0$var$A('Signature algorithm of "' + this.expectedAlg + '" is not supported. Expected the ID token to be signed with "' + $bdd166eca2c549e0$var$x + '".');
}
function $bdd166eca2c549e0$var$PluginHandler(webAuth, plugins) {
    this.plugins = plugins;
    for(var a = 0; a < this.plugins.length; a++){
        if (this.plugins[a].version !== $bdd166eca2c549e0$export$83d89fbfd8236492.raw) {
            var pluginName = "";
            throw this.plugins[a].constructor && this.plugins[a].constructor.name && (pluginName = this.plugins[a].constructor.name), new Error("Plugin " + pluginName + " version (" + this.plugins[a].version + ") is not compatible with the SDK version (" + $bdd166eca2c549e0$export$83d89fbfd8236492.raw + ")");
        }
        this.plugins[a].setWebAuth(webAuth);
    }
}
$bdd166eca2c549e0$var$I.prototype.verify = function(t, e, r) {
    if (!r && e && "function" == typeof e && (r = e, e = void 0), !t) return r(new $bdd166eca2c549e0$var$D("ID token is required but missing"), null);
    var i = this.decode(t);
    if (i instanceof Error) return r(new $bdd166eca2c549e0$var$D("ID token could not be decoded"), null);
    var n = i.encoded.header + "." + i.encoded.payload, o = $bdd166eca2c549e0$var$T(i.encoded.signature), s = i.header.alg, h = i.header.kid, u = i.payload.aud, a = i.payload.sub, f = i.payload.iss, c = i.payload.exp, p = i.payload.nbf, l = i.payload.iat, d = i.payload.azp, m = i.payload.auth_time, v = i.payload.nonce, y = this.__clock(), g = this;
    if (g.expectedAlg !== s) return r(new $bdd166eca2c549e0$var$D('Signature algorithm of "' + s + '" is not supported. Expected the ID token to be signed with "' + $bdd166eca2c549e0$var$x + '".'), null);
    this.getRsaVerifier(f, h, function(t, s) {
        if (t) return r(t, null);
        if (!s.verify(n, o)) return r(new $bdd166eca2c549e0$var$D("Invalid ID token signature."), null);
        if (!f || "string" != typeof f) return r(new $bdd166eca2c549e0$var$D("Issuer (iss) claim must be a string present in the ID token"), null);
        if (g.issuer !== f) return r(new $bdd166eca2c549e0$var$D('Issuer (iss) claim mismatch in the ID token, expected "' + g.issuer + '", found "' + f + '"'), null);
        if (!a || "string" != typeof a) return r(new $bdd166eca2c549e0$var$D("Subject (sub) claim must be a string present in the ID token"), null);
        if (!u || "string" != typeof u && !Array.isArray(u)) return r(new $bdd166eca2c549e0$var$D("Audience (aud) claim must be a string or array of strings present in the ID token"), null);
        if (Array.isArray(u) && !u.includes(g.audience)) return r(new $bdd166eca2c549e0$var$D('Audience (aud) claim mismatch in the ID token; expected "' + g.audience + '" but was not one of "' + u.join(", ") + '"'), null);
        if ("string" == typeof u && g.audience !== u) return r(new $bdd166eca2c549e0$var$D('Audience (aud) claim mismatch in the ID token; expected "' + g.audience + '" but found "' + u + '"'), null);
        if (e) {
            if (!v || "string" != typeof v) return r(new $bdd166eca2c549e0$var$D("Nonce (nonce) claim must be a string present in the ID token"), null);
            if (v !== e) return r(new $bdd166eca2c549e0$var$D('Nonce (nonce) claim value mismatch in the ID token; expected "' + e + '", found "' + v + '"'), null);
        }
        if (Array.isArray(u) && u.length > 1) {
            if (!d || "string" != typeof d) return r(new $bdd166eca2c549e0$var$D("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values"), null);
            if (d !== g.audience) return r(new $bdd166eca2c549e0$var$D('Authorized Party (azp) claim mismatch in the ID token; expected "' + g.audience + '", found "' + d + '"'), null);
        }
        if (!c || !$bdd166eca2c549e0$var$E(c)) return r(new $bdd166eca2c549e0$var$D("Expiration Time (exp) claim must be a number present in the ID token"), null);
        if (!l || !$bdd166eca2c549e0$var$E(l)) return r(new $bdd166eca2c549e0$var$D("Issued At (iat) claim must be a number present in the ID token"), null);
        var h = c + g.leeway, w = new Date(0);
        if (w.setUTCSeconds(h), y > w) return r(new $bdd166eca2c549e0$var$D('Expiration Time (exp) claim error in the ID token; current time "' + y + '" is after expiration time "' + w + '"'), null);
        if (p && $bdd166eca2c549e0$var$E(p)) {
            var T = p - g.leeway, b = new Date(0);
            if (b.setUTCSeconds(T), y < b) return r(new $bdd166eca2c549e0$var$D('Not Before Time (nbf) claim error in the ID token; current time "' + y + '" is before the not before time "' + b + '"'), null);
        }
        if (g.maxAge) {
            if (!m || !$bdd166eca2c549e0$var$E(m)) return r(new $bdd166eca2c549e0$var$D("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified"), null);
            var _ = m + g.maxAge + g.leeway, S = new Date(0);
            if (S.setUTCSeconds(_), y > S) return r(new $bdd166eca2c549e0$var$D('Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time "' + y + '" is after last auth time at "' + S + '"'), null);
        }
        return r(null, i.payload);
    });
}, $bdd166eca2c549e0$var$I.prototype.getRsaVerifier = function(t, e, r) {
    var i = this, n = t + e;
    Promise.resolve(this.jwksCache.has(n)).then(function(r) {
        var o, s;
        return r ? i.jwksCache.get(n) : (s = (o = {
            jwksURI: i.jwksURI,
            iss: t,
            kid: e
        }).jwksURI || $bdd166eca2c549e0$var$b(o.iss, ".well-known", "jwks.json"), ("undefined" == fetch ? $bdd166eca2c549e0$var$_ : fetch)(s).then($bdd166eca2c549e0$var$S).then(function(t) {
            var e, r, i, n = null;
            for(e = 0; e < t.keys.length && null === n; e++)(r = t.keys[e]).kid === o.kid && (n = r);
            if (!n) throw new Error('Could not find a public key for Key ID (kid) "' + o.kid + '"');
            return {
                modulus: $bdd166eca2c549e0$var$T((i = n).n),
                exp: $bdd166eca2c549e0$var$T(i.e)
            };
        }).catch(function(t) {
            throw t;
        }));
    }).then(function(t) {
        if (!t || !t.modulus || !t.exp) throw new Error("Empty keyInfo in response");
        return Promise.resolve(i.jwksCache.set(n, t)).then(function() {
            r && r(null, new $bdd166eca2c549e0$var$c(t.modulus, t.exp));
        });
    }).catch(function(t) {
        r && r(t);
    });
}, $bdd166eca2c549e0$var$I.prototype.decode = function(t) {
    var e, r, i = t.split(".");
    if (3 !== i.length) return new $bdd166eca2c549e0$var$D("Cannot decode a malformed JWT");
    try {
        e = JSON.parse($bdd166eca2c549e0$var$w(i[0])), r = JSON.parse($bdd166eca2c549e0$var$w(i[1]));
    } catch (t) {
        return new $bdd166eca2c549e0$var$D("Token header or payload is not valid JSON");
    }
    return {
        header: e,
        payload: r,
        encoded: {
            header: i[0],
            payload: i[1],
            signature: i[2]
        }
    };
}, $bdd166eca2c549e0$var$I.prototype.validateAccessToken = function(t, e, r, i) {
    if (this.expectedAlg !== e) return i(new $bdd166eca2c549e0$var$D('Signature algorithm of "' + e + '" is not supported. Expected "' + this.expectedAlg + '"'));
    var n, u = $bdd166eca2c549e0$var$o(t), a = $bdd166eca2c549e0$var$h.stringify(u), f = a.substring(0, a.length / 2), c = $bdd166eca2c549e0$var$h.parse(f), p = $bdd166eca2c549e0$var$s.stringify(c);
    return i((n = {
        "+": "-",
        "/": "_",
        "=": ""
    }, p.replace(/[+/=]/g, function(t) {
        return n[t];
    }) !== r ? new $bdd166eca2c549e0$var$D("Invalid access_token") : null));
}, $bdd166eca2c549e0$var$PluginHandler.prototype.get = function(extensibilityPoint) {
    for(var a = 0; a < this.plugins.length; a++)if (this.plugins[a].supports(extensibilityPoint)) return this.plugins[a].init();
    return null;
};
var $bdd166eca2c549e0$var$random = {
    randomString: function(length) {
        var bytes = new Uint8Array(length), result = [], charset = "0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~", cryptoObj = $bdd166eca2c549e0$var$windowHelper.getWindow().crypto || $bdd166eca2c549e0$var$windowHelper.getWindow().msCrypto;
        if (!cryptoObj) return null;
        for(var random = cryptoObj.getRandomValues(bytes), a = 0; a < random.length; a++)result.push(charset[random[a] % charset.length]);
        return result.join("");
    }
};
function $bdd166eca2c549e0$var$TransactionManager(options) {
    var transaction = options.transaction || {};
    this.namespace = transaction.namespace || "com.auth0.auth.", this.keyLength = transaction.keyLength || 32, this.stateExpiration = options.stateExpiration ? options.stateExpiration / 60 / 24 : 1 / 48, this.storage = new $bdd166eca2c549e0$var$Storage(options), this.options = options;
}
function $bdd166eca2c549e0$var$IframeHandler(options) {
    if (this.url = options.url, this.callback = options.callback, this.timeout = options.timeout || 6e4, this.timeoutCallback = options.timeoutCallback || null, this.eventListenerType = options.eventListenerType || "message", this.iframe = null, this.timeoutHandle = null, this._destroyTimeout = null, this.transientMessageEventListener = null, this.proxyEventListener = null, this.eventValidator = options.eventValidator || {
        isValid: function() {
            return !0;
        }
    }, "function" != typeof this.callback) throw new Error("options.callback must be a function");
}
function $bdd166eca2c549e0$var$WebMessageHandler(webAuth) {
    this.webAuth = webAuth, this.warn = new $bdd166eca2c549e0$var$Warn(webAuth.baseOptions);
}
function $bdd166eca2c549e0$var$CrossOriginAuthentication(webAuth, options) {
    this.webAuth = webAuth, this.baseOptions = options, this.request = new $bdd166eca2c549e0$var$RequestBuilder(options), this.webMessageHandler = new $bdd166eca2c549e0$var$WebMessageHandler(webAuth), this.storage = new $bdd166eca2c549e0$var$Storage(options);
}
function $bdd166eca2c549e0$var$createKey(origin, coId) {
    return [
        "co/verifier",
        encodeURIComponent(origin),
        encodeURIComponent(coId)
    ].join("/");
}
function $bdd166eca2c549e0$var$Redirect(auth0, options) {
    this.webAuth = auth0, this.baseOptions = options, this.crossOriginAuthentication = new $bdd166eca2c549e0$var$CrossOriginAuthentication(auth0, this.baseOptions), this.warn = new $bdd166eca2c549e0$var$Warn({
        disableWarnings: !!options._disableDeprecationWarnings
    });
}
$bdd166eca2c549e0$var$TransactionManager.prototype.process = function(options) {
    if (!options.responseType) throw new Error("responseType is required");
    var lastUsedConnection = options.realm || options.connection, responseTypeIncludesIdToken = -1 !== options.responseType.indexOf("id_token"), transaction = this.generateTransaction(options.appState, options.state, options.nonce, lastUsedConnection, responseTypeIncludesIdToken, options.organization);
    return options.state || (options.state = transaction.state), responseTypeIncludesIdToken && !options.nonce && (options.nonce = transaction.nonce), options;
}, $bdd166eca2c549e0$var$TransactionManager.prototype.generateTransaction = function(appState, state, nonce, lastUsedConnection, generateNonce, organization) {
    if (state = state || $bdd166eca2c549e0$var$random.randomString(this.keyLength), nonce = nonce || (generateNonce ? $bdd166eca2c549e0$var$random.randomString(this.keyLength) : null), !($bdd166eca2c549e0$var$windowHelper.getWindow().location.host === this.options.domain)) {
        var transactionPayload = {
            nonce: nonce,
            appState: appState,
            state: state,
            lastUsedConnection: lastUsedConnection
        };
        organization && (transactionPayload.organization = organization), this.storage.setItem(this.namespace + state, transactionPayload, {
            expires: this.stateExpiration
        });
    }
    return {
        state: state,
        nonce: nonce
    };
}, $bdd166eca2c549e0$var$TransactionManager.prototype.getStoredTransaction = function(state) {
    var transactionData;
    return transactionData = this.storage.getItem(this.namespace + state), this.clearTransaction(state), transactionData;
}, $bdd166eca2c549e0$var$TransactionManager.prototype.clearTransaction = function(state) {
    this.storage.removeItem(this.namespace + state);
}, $bdd166eca2c549e0$var$IframeHandler.prototype.init = function() {
    var _this = this, _window = $bdd166eca2c549e0$var$windowHelper.getWindow();
    switch(this.iframe = _window.document.createElement("iframe"), this.iframe.style.display = "none", this.proxyEventListener = function(e) {
        _this.eventListener(e);
    }, this.eventListenerType){
        case "message":
            this.eventSourceObject = _window;
            break;
        case "load":
            this.eventSourceObject = this.iframe;
            break;
        default:
            throw new Error("Unsupported event listener type: " + this.eventListenerType);
    }
    this.eventSourceObject.addEventListener(this.eventListenerType, this.proxyEventListener, !1), _window.document.body.appendChild(this.iframe), this.iframe.src = this.url, this.timeoutHandle = setTimeout(function() {
        _this.timeoutHandler();
    }, this.timeout);
}, $bdd166eca2c549e0$var$IframeHandler.prototype.eventListener = function(event) {
    var eventData = {
        event: event,
        sourceObject: this.eventSourceObject
    };
    this.eventValidator.isValid(eventData) && (this.destroy(), this.callback(eventData));
}, $bdd166eca2c549e0$var$IframeHandler.prototype.timeoutHandler = function() {
    this.destroy(), this.timeoutCallback && this.timeoutCallback();
}, $bdd166eca2c549e0$var$IframeHandler.prototype.destroy = function() {
    var _this = this;
    clearTimeout(this.timeoutHandle), this._destroyTimeout = setTimeout(function() {
        _this.eventSourceObject.removeEventListener(_this.eventListenerType, _this.proxyEventListener, !1), _this.iframe.parentNode && _this.iframe.parentNode.removeChild(_this.iframe);
    }, 0);
}, $bdd166eca2c549e0$var$WebMessageHandler.prototype.run = function(options, cb) {
    var _this = this;
    options.responseMode = "web_message", options.prompt = "none";
    var currentOrigin = $bdd166eca2c549e0$var$windowHelper.getOrigin(), redirectUriOrigin = $bdd166eca2c549e0$var$objectHelper.getOriginFromUrl(options.redirectUri);
    if (redirectUriOrigin && currentOrigin !== redirectUriOrigin) return cb({
        error: "origin_mismatch",
        error_description: "The redirectUri's origin (" + redirectUriOrigin + ") should match the window's origin (" + currentOrigin + ")."
    });
    !function(authorizeUrl, options, callback) {
        new $bdd166eca2c549e0$var$IframeHandler({
            url: authorizeUrl,
            eventListenerType: "message",
            callback: function(eventData) {
                callback(null, eventData);
            },
            timeout: options.timeout,
            eventValidator: {
                isValid: function(eventData) {
                    return !(!eventData.event.data || "authorization_response" !== eventData.event.data.type || options.state !== eventData.event.data.response.state);
                }
            },
            timeoutCallback: function() {
                callback({
                    error: "timeout",
                    error_description: "Timeout during executing web_message communication",
                    state: options.state
                });
            }
        }).init();
    }(this.webAuth.client.buildAuthorizeUrl(options), options, function(err, eventData) {
        var error = err;
        if (!err && eventData.event.data.response.error && (error = eventData.event.data.response), !error) {
            var parsedHash = eventData.event.data.response;
            return _this.webAuth.validateAuthenticationResponse(options, parsedHash, cb);
        }
        return "consent_required" === error.error && "localhost" === $bdd166eca2c549e0$var$windowHelper.getWindow().location.hostname && _this.warn.warning("Consent Required. Consent can't be skipped on localhost. Read more here: https://auth0.com/docs/api-auth/user-consent#skipping-consent-for-first-party-clients"), _this.webAuth.transactionManager.clearTransaction(error.state), cb($bdd166eca2c549e0$var$objectHelper.pick(error, [
            "error",
            "error_description"
        ]));
    });
}, $bdd166eca2c549e0$var$CrossOriginAuthentication.prototype.login = function(options, cb) {
    var _this = this, url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "/co/authenticate");
    options.username = options.username || options.email, delete options.email;
    var authenticateBody = {
        client_id: options.clientID || this.baseOptions.clientID,
        username: options.username
    };
    options.password && (authenticateBody.password = options.password), options.otp && (authenticateBody.otp = options.otp);
    var realm = options.realm || this.baseOptions.realm;
    if (realm) {
        var credentialType = options.credentialType || this.baseOptions.credentialType || "http://auth0.com/oauth/grant-type/password-realm";
        authenticateBody.realm = realm, authenticateBody.credential_type = credentialType;
    } else authenticateBody.credential_type = "password";
    this.request.post(url).withCredentials().send(authenticateBody).end(function(err, data) {
        if (err) {
            var errorObject = err.response && err.response.body || {
                error: "request_error",
                error_description: JSON.stringify(err)
            };
            return $bdd166eca2c549e0$var$wrapCallback(cb, {
                forceLegacyError: !0
            })(errorObject);
        }
        function doAuth() {
            var popupMode = !0 === options.popup;
            options = $bdd166eca2c549e0$var$objectHelper.blacklist(options, [
                "password",
                "credentialType",
                "otp",
                "popup",
                "onRedirecting"
            ]);
            var authorizeOptions = $bdd166eca2c549e0$var$objectHelper.merge(options).with({
                loginTicket: data.body.login_ticket
            }), key = $bdd166eca2c549e0$var$createKey(_this.baseOptions.rootUrl, data.body.co_id);
            _this.storage.setItem(key, data.body.co_verifier, {
                expires: 1 / 96
            }), popupMode ? _this.webMessageHandler.run(authorizeOptions, $bdd166eca2c549e0$var$wrapCallback(cb, {
                forceLegacyError: !0
            })) : _this.webAuth.authorize(authorizeOptions);
        }
        "function" == typeof options.onRedirecting ? options.onRedirecting(doAuth) : doAuth();
    });
}, $bdd166eca2c549e0$var$CrossOriginAuthentication.prototype.callback = function() {
    var targetOrigin = decodeURIComponent(function(name) {
        var parts = ("&" + $bdd166eca2c549e0$var$windowHelper.getWindow().location.hash.substring(1)).split("&" + name + "=");
        if (2 === parts.length) return parts.pop().split("&").shift();
    }("origin")), theWindow = $bdd166eca2c549e0$var$windowHelper.getWindow(), _this = this;
    theWindow.addEventListener("message", function(evt) {
        if ("co_verifier_request" === evt.data.type) {
            var key = $bdd166eca2c549e0$var$createKey(evt.origin, evt.data.request.id), verifier = function(storage, key) {
                try {
                    var verifier = storage.getItem(key);
                    return storage.removeItem(key), verifier || "";
                } catch (e) {
                    return "";
                }
            }(_this.storage, key);
            evt.source.postMessage({
                type: "co_verifier_response",
                response: {
                    verifier: verifier
                }
            }, evt.origin);
        }
    }), theWindow.parent.postMessage({
        type: "ready"
    }, targetOrigin);
}, $bdd166eca2c549e0$var$Redirect.prototype.loginWithCredentials = function(options, cb) {
    options.realm = options.realm || options.connection, delete options.connection, this.crossOriginAuthentication.login(options, cb);
}, $bdd166eca2c549e0$var$Redirect.prototype.signupAndLogin = function(options, cb) {
    var _this = this;
    return this.webAuth.client.dbConnection.signup(options, function(err) {
        return err ? cb(err) : (options.realm = options.realm || options.connection, delete options.connection, _this.webAuth.login(options, cb));
    });
};
var $bdd166eca2c549e0$var$winchan = $bdd166eca2c549e0$var$createCommonjsModule(function(module) {
    var WinChan = function() {
        function addListener(w, event, cb) {
            w.attachEvent ? w.attachEvent("on" + event, cb) : w.addEventListener && w.addEventListener(event, cb, !1);
        }
        function removeListener(w, event, cb) {
            w.detachEvent ? w.detachEvent("on" + event, cb) : w.removeEventListener && w.removeEventListener(event, cb, !1);
        }
        function extractOrigin(url) {
            /^https?:\/\//.test(url) || (url = window.location.href);
            var m = /^(https?:\/\/[\-_a-zA-Z\.0-9:]+)/.exec(url);
            return m ? m[1] : url;
        }
        var isIE = function() {
            if ("undefined" == typeof navigator) return !1;
            var rv = -1, ua = navigator.userAgent;
            if ("Microsoft Internet Explorer" === navigator.appName) null != new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})").exec(ua) && (rv = parseFloat(RegExp.$1));
            else if (ua.indexOf("Trident") > -1) null !== new RegExp("rv:([0-9]{2,2}[.0-9]{0,})").exec(ua) && (rv = parseFloat(RegExp.$1));
            return rv >= 8;
        }();
        return "undefined" != typeof window && window.JSON && window.JSON.stringify && window.JSON.parse && window.postMessage ? {
            open: function(opts, cb) {
                if (!cb) throw "missing required callback argument";
                var err, iframe;
                opts.url || (err = "missing required 'url' parameter"), opts.relay_url || (err = "missing required 'relay_url' parameter"), err && setTimeout(function() {
                    cb(err);
                }, 0), opts.window_name || (opts.window_name = null), opts.window_features && !function() {
                    try {
                        var userAgent = navigator.userAgent;
                        return -1 != userAgent.indexOf("Fennec/") || -1 != userAgent.indexOf("Firefox/") && -1 != userAgent.indexOf("Android");
                    } catch (e) {}
                    return !1;
                }() || (opts.window_features = void 0);
                var messageTarget, origin = opts.origin || extractOrigin(opts.url);
                if (origin !== extractOrigin(opts.relay_url)) return setTimeout(function() {
                    cb("invalid arguments: origin of url and relay_url must match");
                }, 0);
                isIE && ((iframe = document.createElement("iframe")).setAttribute("src", opts.relay_url), iframe.style.display = "none", iframe.setAttribute("name", "__winchan_relay_frame"), document.body.appendChild(iframe), messageTarget = iframe.contentWindow);
                var w = opts.popup || window.open(opts.url, opts.window_name, opts.window_features);
                opts.popup && (w.location.href = opts.url), messageTarget || (messageTarget = w);
                var closeInterval = setInterval(function() {
                    w && w.closed && (cleanup(), cb && (cb("User closed the popup window"), cb = null));
                }, 500), req = JSON.stringify({
                    a: "request",
                    d: opts.params
                });
                function cleanup() {
                    if (iframe && document.body.removeChild(iframe), iframe = void 0, closeInterval && (closeInterval = clearInterval(closeInterval)), removeListener(window, "message", onMessage), removeListener(window, "unload", cleanup), w) try {
                        w.close();
                    } catch (securityViolation) {
                        messageTarget.postMessage("die", origin);
                    }
                    w = messageTarget = void 0;
                }
                function onMessage(e) {
                    if (e.origin === origin) {
                        try {
                            var d = JSON.parse(e.data);
                        } catch (err) {
                            if (cb) return cb(err);
                            throw err;
                        }
                        "ready" === d.a ? messageTarget.postMessage(req, origin) : "error" === d.a ? (cleanup(), cb && (cb(d.d), cb = null)) : "response" === d.a && (cleanup(), cb && (cb(null, d.d), cb = null));
                    }
                }
                return addListener(window, "unload", cleanup), addListener(window, "message", onMessage), {
                    originalPopup: w,
                    close: cleanup,
                    focus: function() {
                        if (w) try {
                            w.focus();
                        } catch (e) {}
                    }
                };
            },
            onOpen: function(cb) {
                var o = "*", msgTarget = isIE ? function() {
                    for(var frames = window.opener.frames, i = frames.length - 1; i >= 0; i--)try {
                        if (frames[i].location.protocol === window.location.protocol && frames[i].location.host === window.location.host && "__winchan_relay_frame" === frames[i].name) return frames[i];
                    } catch (e) {}
                }() : window.opener;
                if (!msgTarget) throw "can't find relay frame";
                function doPost(msg) {
                    msg = JSON.stringify(msg), isIE ? msgTarget.doPost(msg, o) : msgTarget.postMessage(msg, o);
                }
                function onDie(e) {
                    if ("die" === e.data) try {
                        window.close();
                    } catch (o_O) {}
                }
                addListener(isIE ? msgTarget : window, "message", function onMessage(e) {
                    var d;
                    try {
                        d = JSON.parse(e.data);
                    } catch (err) {}
                    d && "request" === d.a && (removeListener(window, "message", onMessage), o = e.origin, cb && setTimeout(function() {
                        cb(o, d.d, function(r) {
                            cb = void 0, doPost({
                                a: "response",
                                d: r
                            });
                        });
                    }, 0));
                }), addListener(isIE ? msgTarget : window, "message", onDie);
                try {
                    doPost({
                        a: "ready"
                    });
                } catch (e) {
                    addListener(msgTarget, "load", function(e) {
                        doPost({
                            a: "ready"
                        });
                    });
                }
                var onUnload = function() {
                    try {
                        removeListener(isIE ? msgTarget : window, "message", onDie);
                    } catch (ohWell) {}
                    cb && doPost({
                        a: "error",
                        d: "client closed window"
                    }), cb = void 0;
                    try {
                        window.close();
                    } catch (e) {}
                };
                return addListener(window, "unload", onUnload), {
                    detach: function() {
                        removeListener(window, "unload", onUnload);
                    }
                };
            }
        } : {
            open: function(url, winopts, arg, cb) {
                setTimeout(function() {
                    cb("unsupported browser");
                }, 0);
            },
            onOpen: function(cb) {
                setTimeout(function() {
                    cb("unsupported browser");
                }, 0);
            }
        };
    }();
    module.exports && (module.exports = WinChan);
});
var $bdd166eca2c549e0$var$urlHelper = {
    extractOrigin: function(url) {
        /^https?:\/\//.test(url) || (url = window.location.href);
        var m = /^(https?:\/\/[-_a-zA-Z.0-9:]+)/.exec(url);
        return m ? m[1] : url;
    }
};
function $bdd166eca2c549e0$var$PopupHandler() {
    this._current_popup = null;
}
function $bdd166eca2c549e0$var$Popup(webAuth, options) {
    this.baseOptions = options, this.baseOptions.popupOrigin = options.popupOrigin, this.client = webAuth.client, this.webAuth = webAuth, this.transactionManager = new $bdd166eca2c549e0$var$TransactionManager(this.baseOptions), this.crossOriginAuthentication = new $bdd166eca2c549e0$var$CrossOriginAuthentication(webAuth, this.baseOptions), this.warn = new $bdd166eca2c549e0$var$Warn({
        disableWarnings: !!options._disableDeprecationWarnings
    });
}
function $bdd166eca2c549e0$var$SilentAuthenticationHandler(options) {
    this.authenticationUrl = options.authenticationUrl, this.timeout = options.timeout || 6e4, this.handler = null, this.postMessageDataType = options.postMessageDataType || !1, this.postMessageOrigin = options.postMessageOrigin || $bdd166eca2c549e0$var$windowHelper.getWindow().location.origin || $bdd166eca2c549e0$var$windowHelper.getWindow().location.protocol + "//" + $bdd166eca2c549e0$var$windowHelper.getWindow().location.hostname + ($bdd166eca2c549e0$var$windowHelper.getWindow().location.port ? ":" + $bdd166eca2c549e0$var$windowHelper.getWindow().location.port : "");
}
function $bdd166eca2c549e0$var$UsernamePassword(options) {
    this.baseOptions = options, this.request = new $bdd166eca2c549e0$var$RequestBuilder(options), this.transactionManager = new $bdd166eca2c549e0$var$TransactionManager(this.baseOptions);
}
function $bdd166eca2c549e0$var$HostedPages(client, options) {
    this.baseOptions = options, this.client = client, this.baseOptions.universalLoginPage = !0, this.request = new $bdd166eca2c549e0$var$RequestBuilder(this.baseOptions), this.warn = new $bdd166eca2c549e0$var$Warn({
        disableWarnings: !!options._disableDeprecationWarnings
    });
}
$bdd166eca2c549e0$var$PopupHandler.prototype.calculatePosition = function(options) {
    var width = options.width || 500, height = options.height || 600, _window = $bdd166eca2c549e0$var$windowHelper.getWindow(), screenX = void 0 !== _window.screenX ? _window.screenX : _window.screenLeft, screenY = void 0 !== _window.screenY ? _window.screenY : _window.screenTop, outerWidth = void 0 !== _window.outerWidth ? _window.outerWidth : _window.document.body.clientWidth, outerHeight = void 0 !== _window.outerHeight ? _window.outerHeight : _window.document.body.clientHeight;
    return {
        width: width,
        height: height,
        left: options.left || screenX + (outerWidth - width) / 2,
        top: options.top || screenY + (outerHeight - height) / 2
    };
}, $bdd166eca2c549e0$var$PopupHandler.prototype.preload = function(options) {
    var _this = this, _window = $bdd166eca2c549e0$var$windowHelper.getWindow(), popupPosition = this.calculatePosition(options.popupOptions || {}), popupOptions = $bdd166eca2c549e0$var$objectHelper.merge(popupPosition).with(options.popupOptions), url = options.url || "about:blank", windowFeatures = $bdd166eca2c549e0$var$lib.stringify(popupOptions, {
        encode: !1,
        delimiter: ","
    });
    return this._current_popup && !this._current_popup.closed || (this._current_popup = _window.open(url, "auth0_signup_popup", windowFeatures), this._current_popup.kill = function() {
        this.close(), _this._current_popup = null;
    }), this._current_popup;
}, $bdd166eca2c549e0$var$PopupHandler.prototype.load = function(url, relayUrl, options, cb) {
    var _this = this, popupPosition = this.calculatePosition(options.popupOptions || {}), popupOptions = $bdd166eca2c549e0$var$objectHelper.merge(popupPosition).with(options.popupOptions), winchanOptions = $bdd166eca2c549e0$var$objectHelper.merge({
        url: url,
        relay_url: relayUrl,
        window_features: $bdd166eca2c549e0$var$lib.stringify(popupOptions, {
            delimiter: ",",
            encode: !1
        }),
        popup: this._current_popup
    }).with(options), popup = $bdd166eca2c549e0$var$winchan.open(winchanOptions, function(err, data) {
        if (!err || "SyntaxError" !== err.name) return _this._current_popup = null, cb(err, data);
    });
    return popup.focus(), popup;
}, $bdd166eca2c549e0$var$Popup.prototype.buildPopupHandler = function() {
    var pluginHandler = this.baseOptions.plugins.get("popup.getPopupHandler");
    return pluginHandler ? pluginHandler.getPopupHandler() : new $bdd166eca2c549e0$var$PopupHandler;
}, $bdd166eca2c549e0$var$Popup.prototype.preload = function(options) {
    options = options || {};
    var popup = this.buildPopupHandler();
    return popup.preload(options), popup;
}, $bdd166eca2c549e0$var$Popup.prototype.getPopupHandler = function(options, preload) {
    return options.popupHandler ? options.popupHandler : preload ? this.preload(options) : this.buildPopupHandler();
}, $bdd166eca2c549e0$var$Popup.prototype.callback = function(options) {
    var _this = this, theWindow = $bdd166eca2c549e0$var$windowHelper.getWindow(), originUrl = (options = options || {}).popupOrigin || this.baseOptions.popupOrigin || $bdd166eca2c549e0$var$windowHelper.getOrigin();
    theWindow.opener ? $bdd166eca2c549e0$var$winchan.onOpen(function(popupOrigin, r, cb) {
        if (popupOrigin !== originUrl) return cb({
            error: "origin_mismatch",
            error_description: "The popup's origin (" + popupOrigin + ") should match the `popupOrigin` parameter (" + originUrl + ")."
        });
        _this.webAuth.parseHash(options || {}, function(err, data) {
            return cb(err || data);
        });
    }) : theWindow.doPost = function(msg) {
        theWindow.parent && theWindow.parent.postMessage(msg, originUrl);
    };
}, $bdd166eca2c549e0$var$Popup.prototype.authorize = function(options, cb) {
    var url, relayUrl, popOpts = {}, pluginHandler = this.baseOptions.plugins.get("popup.authorize"), params = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "scope",
        "domain",
        "audience",
        "tenant",
        "responseType",
        "redirectUri",
        "_csrf",
        "state",
        "_intstate",
        "nonce",
        "organization",
        "invitation"
    ]).with($bdd166eca2c549e0$var$objectHelper.blacklist(options, [
        "popupHandler"
    ]));
    return $bdd166eca2c549e0$var$assert.check(params, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        responseType: {
            type: "string",
            message: "responseType option is required"
        }
    }), relayUrl = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "relay.html"), options.owp ? params.owp = !0 : (popOpts.origin = $bdd166eca2c549e0$var$urlHelper.extractOrigin(params.redirectUri), relayUrl = params.redirectUri), options.popupOptions && (popOpts.popupOptions = $bdd166eca2c549e0$var$objectHelper.pick(options.popupOptions, [
        "width",
        "height",
        "top",
        "left"
    ])), pluginHandler && (params = pluginHandler.processParams(params)), (params = this.transactionManager.process(params)).scope = params.scope || "openid profile email", delete params.domain, url = this.client.buildAuthorizeUrl(params), this.getPopupHandler(options).load(url, relayUrl, popOpts, $bdd166eca2c549e0$var$wrapCallback(cb, {
        keepOriginalCasing: !0
    }));
}, $bdd166eca2c549e0$var$Popup.prototype.loginWithCredentials = function(options, cb) {
    options.realm = options.realm || options.connection, options.popup = !0, options = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "redirectUri",
        "responseType",
        "state",
        "nonce",
        "timeout"
    ]).with($bdd166eca2c549e0$var$objectHelper.blacklist(options, [
        "popupHandler",
        "connection"
    ])), options = this.transactionManager.process(options), this.crossOriginAuthentication.login(options, cb);
}, $bdd166eca2c549e0$var$Popup.prototype.passwordlessVerify = function(options, cb) {
    var _this = this;
    return this.client.passwordless.verify($bdd166eca2c549e0$var$objectHelper.blacklist(options, [
        "popupHandler"
    ]), function(err) {
        if (err) return cb(err);
        options.username = options.phoneNumber || options.email, options.password = options.verificationCode, delete options.email, delete options.phoneNumber, delete options.verificationCode, delete options.type, _this.client.loginWithResourceOwner(options, cb);
    });
}, $bdd166eca2c549e0$var$Popup.prototype.signupAndLogin = function(options, cb) {
    var _this = this;
    return this.client.dbConnection.signup(options, function(err) {
        if (err) return cb(err);
        _this.loginWithCredentials(options, cb);
    });
}, $bdd166eca2c549e0$var$SilentAuthenticationHandler.create = function(options) {
    return new $bdd166eca2c549e0$var$SilentAuthenticationHandler(options);
}, $bdd166eca2c549e0$var$SilentAuthenticationHandler.prototype.login = function(usePostMessage, callback) {
    this.handler = new $bdd166eca2c549e0$var$IframeHandler({
        auth0: this.auth0,
        url: this.authenticationUrl,
        eventListenerType: usePostMessage ? "message" : "load",
        callback: this.getCallbackHandler(callback, usePostMessage),
        timeout: this.timeout,
        eventValidator: this.getEventValidator(),
        timeoutCallback: function() {
            callback(null, "#error=timeout&error_description=Timeout+during+authentication+renew.");
        },
        usePostMessage: usePostMessage || !1
    }), this.handler.init();
}, $bdd166eca2c549e0$var$SilentAuthenticationHandler.prototype.getEventValidator = function() {
    var _this = this;
    return {
        isValid: function(eventData) {
            switch(eventData.event.type){
                case "message":
                    return eventData.event.origin === _this.postMessageOrigin && eventData.event.source === _this.handler.iframe.contentWindow && (!1 === _this.postMessageDataType || eventData.event.data.type && eventData.event.data.type === _this.postMessageDataType);
                case "load":
                    if ("about:" === eventData.sourceObject.contentWindow.location.protocol) return !1;
                default:
                    return !0;
            }
        }
    };
}, $bdd166eca2c549e0$var$SilentAuthenticationHandler.prototype.getCallbackHandler = function(callback, usePostMessage) {
    return function(eventData) {
        var callbackValue;
        callbackValue = usePostMessage ? "object" == typeof eventData.event.data && eventData.event.data.hash ? eventData.event.data.hash : eventData.event.data : eventData.sourceObject.contentWindow.location.hash, callback(null, callbackValue);
    };
}, $bdd166eca2c549e0$var$UsernamePassword.prototype.login = function(options, cb) {
    var url, body;
    return url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "usernamepassword", "login"), options.username = options.username || options.email, options = $bdd166eca2c549e0$var$objectHelper.blacklist(options, [
        "email",
        "onRedirecting"
    ]), body = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "redirectUri",
        "tenant",
        "responseType",
        "responseMode",
        "scope",
        "audience"
    ]).with(options), body = this.transactionManager.process(body), body = $bdd166eca2c549e0$var$objectHelper.toSnakeCase(body, [
        "auth0Client"
    ]), this.request.post(url).send(body).end($bdd166eca2c549e0$var$wrapCallback(cb));
}, $bdd166eca2c549e0$var$UsernamePassword.prototype.callback = function(formHtml) {
    var div, _document = $bdd166eca2c549e0$var$windowHelper.getDocument();
    (div = _document.createElement("div")).innerHTML = formHtml, _document.body.appendChild(div).children[0].submit();
}, $bdd166eca2c549e0$var$HostedPages.prototype.login = function(options, cb) {
    if ($bdd166eca2c549e0$var$windowHelper.getWindow().location.host !== this.baseOptions.domain) throw new Error("This method is meant to be used only inside the Universal Login Page.");
    var usernamePassword, params = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "redirectUri",
        "tenant",
        "responseType",
        "responseMode",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce"
    ]).with(options);
    return $bdd166eca2c549e0$var$assert.check(params, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        responseType: {
            type: "string",
            message: "responseType option is required"
        }
    }), (usernamePassword = new $bdd166eca2c549e0$var$UsernamePassword(this.baseOptions)).login(params, function(err, data) {
        if (err) return cb(err);
        function doAuth() {
            usernamePassword.callback(data);
        }
        if ("function" == typeof options.onRedirecting) return options.onRedirecting(function() {
            doAuth();
        });
        doAuth();
    });
}, $bdd166eca2c549e0$var$HostedPages.prototype.signupAndLogin = function(options, cb) {
    var _this = this;
    return _this.client.client.dbConnection.signup(options, function(err) {
        return err ? cb(err) : _this.login(options, cb);
    });
}, $bdd166eca2c549e0$var$HostedPages.prototype.getSSOData = function(withActiveDirectories, cb) {
    var url, params = "";
    return "function" == typeof withActiveDirectories && (cb = withActiveDirectories, withActiveDirectories = !1), $bdd166eca2c549e0$var$assert.check(withActiveDirectories, {
        type: "boolean",
        message: "withActiveDirectories parameter is not valid"
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), withActiveDirectories && (params = "?" + $bdd166eca2c549e0$var$lib.stringify({
        ldaps: 1,
        client_id: this.baseOptions.clientID
    })), url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "user", "ssodata", params), this.request.get(url, {
        noHeaders: !0
    }).withCredentials().end($bdd166eca2c549e0$var$wrapCallback(cb));
};
var $bdd166eca2c549e0$var$noop = function() {}, $bdd166eca2c549e0$var$captchaSolved = $bdd166eca2c549e0$var$noop, $bdd166eca2c549e0$var$defaults$2 = {
    lang: "en",
    templates: {
        auth0: function(challenge) {
            var message = "code" === challenge.type ? "Enter the code shown above" : "Solve the formula shown above";
            return '<div class="captcha-challenge">\n  <img src="' + challenge.image + '" />\n  <button type="button" class="captcha-reload">\u21BA</button>\n</div>\n<input type="text" name="captcha"\n  class="form-control captcha-control"\n  placeholder="' + message + '" />';
        },
        recaptcha_v2: function() {
            return '<div class="recaptcha" ></div><input type="hidden" name="captcha" />';
        },
        recaptcha_enterprise: function() {
            return '<div class="recaptcha" ></div><input type="hidden" name="captcha" />';
        },
        hcaptcha: function() {
            return '<div class="hcaptcha" ></div><input type="hidden" name="captcha" />';
        },
        friendly_captcha: function() {
            return '<div class="friendly-captcha" ></div><input type="hidden" name="captcha" />';
        },
        arkose: function() {
            return '<div class="arkose" ></div><input type="hidden" name="captcha" />';
        },
        auth0_v2: function() {
            return '<div class="auth0_v2" ></div><input type="hidden" name="captcha" />';
        },
        error: function() {
            return '<div class="error" style="color: red;">Error getting the bot detection challenge. Please contact the system administrator.</div>';
        }
    }
};
function $bdd166eca2c549e0$var$handleAuth0Provider(element, options, challenge, load) {
    element.innerHTML = options.templates[challenge.provider](challenge), element.querySelector(".captcha-reload").addEventListener("click", function(e) {
        e.preventDefault(), load();
    });
}
function $bdd166eca2c549e0$var$globalForCaptchaProvider(provider) {
    switch(provider){
        case "recaptcha_v2":
            return window.grecaptcha;
        case "recaptcha_enterprise":
            return window.grecaptcha.enterprise;
        case "hcaptcha":
            return window.hcaptcha;
        case "friendly_captcha":
            return window.friendlyChallenge;
        case "arkose":
            return window.arkose;
        case "auth0_v2":
            return window.turnstile;
        default:
            throw new Error("Unknown captcha provider");
    }
}
function $bdd166eca2c549e0$var$loadScript(url, attributes) {
    var script = window.document.createElement("script");
    for(var attr in attributes)attr.startsWith("data-") ? script.dataset[attr.replace("data-", "")] = attributes[attr] : script[attr] = attributes[attr];
    script.src = url, window.document.body.appendChild(script);
}
function $bdd166eca2c549e0$var$removeScript(url) {
    window.document.querySelectorAll('script[src="' + url + '"]').forEach(function(script) {
        script.remove();
    });
}
function $bdd166eca2c549e0$var$injectCaptchaScript(element, opts, callback, setValue) {
    var callbackName = opts.provider + "Callback_" + Math.floor(1000001 * Math.random()), attributes = {
        async: !0,
        defer: !0
    }, scriptSrc = function(provider, lang, callback, clientSubdomain, siteKey) {
        switch(provider){
            case "recaptcha_v2":
                return "https://www.recaptcha.net/recaptcha/api.js?hl=" + lang + "&onload=" + callback;
            case "recaptcha_enterprise":
                return "https://www.recaptcha.net/recaptcha/enterprise.js?render=explicit&hl=" + lang + "&onload=" + callback;
            case "hcaptcha":
                return "https://js.hcaptcha.com/1/api.js?hl=" + lang + "&onload=" + callback;
            case "friendly_captcha":
                return "https://cdn.jsdelivr.net/npm/friendly-challenge@0.9.12/widget.min.js";
            case "arkose":
                return "https://" + clientSubdomain + ".arkoselabs.com/v2/" + siteKey + "/api.js";
            case "auth0_v2":
                return "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=" + callback;
            default:
                throw new Error("Unknown captcha provider");
        }
    }(opts.provider, opts.lang, callbackName, opts.clientSubdomain, opts.siteKey);
    if ("arkose" === opts.provider) {
        var retryCount = 0;
        attributes["data-callback"] = callbackName, attributes.onerror = function() {
            if (retryCount < 3) return $bdd166eca2c549e0$var$removeScript(scriptSrc), $bdd166eca2c549e0$var$loadScript(scriptSrc, attributes), void retryCount++;
            $bdd166eca2c549e0$var$removeScript(scriptSrc), setValue("BYPASS_CAPTCHA");
        }, window[callbackName] = function(arkose) {
            window.arkose = arkose, callback(arkose);
        };
    } else window[callbackName] = function() {
        delete window[callbackName], callback();
    }, "friendly_captcha" === opts.provider && (attributes.onload = window[callbackName]);
    $bdd166eca2c549e0$var$loadScript(scriptSrc, attributes);
}
function $bdd166eca2c549e0$var$handleCaptchaProvider(element, options, challenge) {
    var captchaClass, widgetId = element.hasAttribute("data-wid") && element.getAttribute("data-wid");
    function setValue(value) {
        element.querySelector('input[name="captcha"]').value = value || "";
    }
    if ("friendly_captcha" === challenge.provider && window.auth0FCInstance) return setValue(), void window.auth0FCInstance.reset();
    if ("arkose" === challenge.provider && $bdd166eca2c549e0$var$globalForCaptchaProvider(challenge.provider)) return setValue(), void $bdd166eca2c549e0$var$globalForCaptchaProvider(challenge.provider).reset();
    if (widgetId) return setValue(), void $bdd166eca2c549e0$var$globalForCaptchaProvider(challenge.provider).reset(widgetId);
    switch(element.innerHTML = options.templates[challenge.provider](challenge), challenge.provider){
        case "recaptcha_enterprise":
        case "recaptcha_v2":
            captchaClass = ".recaptcha";
            break;
        case "hcaptcha":
            captchaClass = ".hcaptcha";
            break;
        case "friendly_captcha":
            captchaClass = ".friendly-captcha";
            break;
        case "arkose":
            captchaClass = ".arkose";
            break;
        case "auth0_v2":
            captchaClass = ".auth0_v2";
    }
    var captchaDiv = element.querySelector(captchaClass);
    $bdd166eca2c549e0$var$injectCaptchaScript(0, {
        lang: options.lang,
        provider: challenge.provider,
        clientSubdomain: challenge.clientSubdomain,
        siteKey: challenge.siteKey
    }, function(arkose) {
        var global1 = $bdd166eca2c549e0$var$globalForCaptchaProvider(challenge.provider);
        if ("arkose" === challenge.provider) {
            var retryCount = 0;
            arkose.setConfig({
                onCompleted: function(response) {
                    setValue(response.token), $bdd166eca2c549e0$var$captchaSolved();
                },
                onError: function() {
                    retryCount < 3 ? (setValue(), arkose.reset(), setTimeout(function() {
                        arkose.run();
                    }, 500), retryCount++) : setValue("BYPASS_CAPTCHA");
                }
            });
        } else if ("friendly_captcha" === challenge.provider) window.auth0FCInstance = new global1.WidgetInstance(captchaDiv, {
            sitekey: challenge.siteKey,
            language: options.lang,
            doneCallback: function(solution) {
                setValue(solution);
            },
            errorCallback: function() {
                setValue();
            }
        });
        else {
            var renderParams = {
                callback: setValue,
                "expired-callback": function() {
                    setValue();
                },
                "error-callback": function() {
                    setValue();
                },
                sitekey: challenge.siteKey
            };
            "auth0_v2" === challenge.provider && (renderParams.language = options.lang, renderParams.theme = "light"), widgetId = global1.render(captchaDiv, renderParams), element.setAttribute("data-wid", widgetId);
        }
    }, setValue);
}
var $bdd166eca2c549e0$var$captcha = {
    render: function(auth0Client, element, options, callback) {
        function load(done) {
            done = done || $bdd166eca2c549e0$var$noop, auth0Client.getChallenge(function(err, challenge) {
                return err ? (element.innerHTML = options.templates.error(err), done(err)) : challenge.required ? (element.style.display = "", "auth0" === challenge.provider ? $bdd166eca2c549e0$var$handleAuth0Provider(element, options, challenge, load) : "recaptcha_v2" !== challenge.provider && "recaptcha_enterprise" !== challenge.provider && "hcaptcha" !== challenge.provider && "friendly_captcha" !== challenge.provider && "arkose" !== challenge.provider && "auth0_v2" !== challenge.provider || $bdd166eca2c549e0$var$handleCaptchaProvider(element, options, challenge), void ("arkose" === challenge.provider ? done(null, {
                    triggerCaptcha: function(solvedCallback) {
                        $bdd166eca2c549e0$var$globalForCaptchaProvider(challenge.provider).run(), $bdd166eca2c549e0$var$captchaSolved = solvedCallback;
                    }
                }) : done())) : (element.style.display = "none", void (element.innerHTML = ""));
            });
        }
        return options = $bdd166eca2c549e0$var$objectHelper.merge($bdd166eca2c549e0$var$defaults$2).with(options || {}), load(callback), {
            reload: load,
            getValue: function() {
                var captchaInput = element.querySelector('input[name="captcha"]');
                if (captchaInput) return captchaInput.value;
            }
        };
    },
    renderPasswordless: function(auth0Client, element, options, callback) {
        function load(done) {
            done = done || $bdd166eca2c549e0$var$noop, auth0Client.passwordless.getChallenge(function(err, challenge) {
                return err ? (element.innerHTML = options.templates.error(err), done(err)) : challenge.required ? (element.style.display = "", "auth0" === challenge.provider ? $bdd166eca2c549e0$var$handleAuth0Provider(element, options, challenge, load) : "recaptcha_v2" !== challenge.provider && "recaptcha_enterprise" !== challenge.provider && "hcaptcha" !== challenge.provider && "friendly_captcha" !== challenge.provider && "arkose" !== challenge.provider && "auth0_v2" !== challenge.provider || $bdd166eca2c549e0$var$handleCaptchaProvider(element, options, challenge), void ("arkose" === challenge.provider ? done(null, {
                    triggerCaptcha: function(solvedCallback) {
                        $bdd166eca2c549e0$var$globalForCaptchaProvider(challenge.provider).run(), $bdd166eca2c549e0$var$captchaSolved = solvedCallback;
                    }
                }) : done())) : (element.style.display = "none", void (element.innerHTML = ""));
            });
        }
        return options = $bdd166eca2c549e0$var$objectHelper.merge($bdd166eca2c549e0$var$defaults$2).with(options || {}), load(callback), {
            reload: load,
            getValue: function() {
                var captchaInput = element.querySelector('input[name="captcha"]');
                if (captchaInput) return captchaInput.value;
            }
        };
    }
};
function $bdd166eca2c549e0$var$defaultClock() {
    return new Date;
}
function $bdd166eca2c549e0$export$d1b7252873cb8575(options) {
    $bdd166eca2c549e0$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        domain: {
            type: "string",
            message: "domain option is required"
        },
        clientID: {
            type: "string",
            message: "clientID option is required"
        },
        responseType: {
            optional: !0,
            type: "string",
            message: "responseType is not valid"
        },
        responseMode: {
            optional: !0,
            type: "string",
            message: "responseMode is not valid"
        },
        redirectUri: {
            optional: !0,
            type: "string",
            message: "redirectUri is not valid"
        },
        scope: {
            optional: !0,
            type: "string",
            message: "scope is not valid"
        },
        audience: {
            optional: !0,
            type: "string",
            message: "audience is not valid"
        },
        popupOrigin: {
            optional: !0,
            type: "string",
            message: "popupOrigin is not valid"
        },
        leeway: {
            optional: !0,
            type: "number",
            message: "leeway is not valid"
        },
        plugins: {
            optional: !0,
            type: "array",
            message: "plugins is not valid"
        },
        maxAge: {
            optional: !0,
            type: "number",
            message: "maxAge is not valid"
        },
        stateExpiration: {
            optional: !0,
            type: "number",
            message: "stateExpiration is not valid"
        },
        legacySameSiteCookie: {
            optional: !0,
            type: "boolean",
            message: "legacySameSiteCookie option is not valid"
        },
        _disableDeprecationWarnings: {
            optional: !0,
            type: "boolean",
            message: "_disableDeprecationWarnings option is not valid"
        },
        _sendTelemetry: {
            optional: !0,
            type: "boolean",
            message: "_sendTelemetry option is not valid"
        },
        _telemetryInfo: {
            optional: !0,
            type: "object",
            message: "_telemetryInfo option is not valid"
        },
        _timesToRetryFailedRequests: {
            optional: !0,
            type: "number",
            message: "_timesToRetryFailedRequests option is not valid"
        }
    }), options.overrides && $bdd166eca2c549e0$var$assert.check(options.overrides, {
        type: "object",
        message: "overrides option is not valid"
    }, {
        __tenant: {
            optional: !0,
            type: "string",
            message: "__tenant option is required"
        },
        __token_issuer: {
            optional: !0,
            type: "string",
            message: "__token_issuer option is required"
        },
        __jwks_uri: {
            optional: !0,
            type: "string",
            message: "__jwks_uri is required"
        }
    }), this.baseOptions = options, this.baseOptions.plugins = new $bdd166eca2c549e0$var$PluginHandler(this, this.baseOptions.plugins || []), this.baseOptions._sendTelemetry = !1 !== this.baseOptions._sendTelemetry || this.baseOptions._sendTelemetry, this.baseOptions._timesToRetryFailedRequests = options._timesToRetryFailedRequests ? parseInt(options._timesToRetryFailedRequests) : 0, this.baseOptions.tenant = this.baseOptions.overrides && this.baseOptions.overrides.__tenant || this.baseOptions.domain.split(".")[0], this.baseOptions.token_issuer = this.baseOptions.overrides && this.baseOptions.overrides.__token_issuer || "https://" + this.baseOptions.domain + "/", this.baseOptions.jwksURI = this.baseOptions.overrides && this.baseOptions.overrides.__jwks_uri, !1 !== options.legacySameSiteCookie && (this.baseOptions.legacySameSiteCookie = !0), this.transactionManager = new $bdd166eca2c549e0$var$TransactionManager(this.baseOptions), this.client = new $bdd166eca2c549e0$export$d9e3c9dc7eaad0c3(this.baseOptions), this.redirect = new $bdd166eca2c549e0$var$Redirect(this, this.baseOptions), this.popup = new $bdd166eca2c549e0$var$Popup(this, this.baseOptions), this.crossOriginAuthentication = new $bdd166eca2c549e0$var$CrossOriginAuthentication(this, this.baseOptions), this.webMessageHandler = new $bdd166eca2c549e0$var$WebMessageHandler(this), this._universalLogin = new $bdd166eca2c549e0$var$HostedPages(this, this.baseOptions), this.ssodataStorage = new $bdd166eca2c549e0$var$SSODataStorage(this.baseOptions);
}
function $bdd166eca2c549e0$var$PasswordlessAuthentication(request, options) {
    this.baseOptions = options, this.request = request;
}
function $bdd166eca2c549e0$var$DBConnection(request, options) {
    this.baseOptions = options, this.request = request;
}
function $bdd166eca2c549e0$export$d9e3c9dc7eaad0c3(auth0, options) {
    2 === arguments.length ? this.auth0 = auth0 : options = auth0, $bdd166eca2c549e0$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        domain: {
            type: "string",
            message: "domain option is required"
        },
        clientID: {
            type: "string",
            message: "clientID option is required"
        },
        responseType: {
            optional: !0,
            type: "string",
            message: "responseType is not valid"
        },
        responseMode: {
            optional: !0,
            type: "string",
            message: "responseMode is not valid"
        },
        redirectUri: {
            optional: !0,
            type: "string",
            message: "redirectUri is not valid"
        },
        scope: {
            optional: !0,
            type: "string",
            message: "scope is not valid"
        },
        audience: {
            optional: !0,
            type: "string",
            message: "audience is not valid"
        },
        _disableDeprecationWarnings: {
            optional: !0,
            type: "boolean",
            message: "_disableDeprecationWarnings option is not valid"
        },
        _sendTelemetry: {
            optional: !0,
            type: "boolean",
            message: "_sendTelemetry option is not valid"
        },
        _telemetryInfo: {
            optional: !0,
            type: "object",
            message: "_telemetryInfo option is not valid"
        }
    }), this.baseOptions = options, this.baseOptions._sendTelemetry = !1 !== this.baseOptions._sendTelemetry || this.baseOptions._sendTelemetry, this.baseOptions.rootUrl = this.baseOptions.domain && 0 === this.baseOptions.domain.toLowerCase().indexOf("http") ? this.baseOptions.domain : "https://" + this.baseOptions.domain, this.request = new $bdd166eca2c549e0$var$RequestBuilder(this.baseOptions), this.passwordless = new $bdd166eca2c549e0$var$PasswordlessAuthentication(this.request, this.baseOptions), this.dbConnection = new $bdd166eca2c549e0$var$DBConnection(this.request, this.baseOptions), this.warn = new $bdd166eca2c549e0$var$Warn({
        disableWarnings: !!options._disableDeprecationWarnings
    }), this.ssodataStorage = new $bdd166eca2c549e0$var$SSODataStorage(this.baseOptions);
}
function $bdd166eca2c549e0$export$cbb26d9fbbee6ab2(options) {
    $bdd166eca2c549e0$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        domain: {
            type: "string",
            message: "domain option is required"
        },
        token: {
            type: "string",
            message: "token option is required"
        },
        _sendTelemetry: {
            optional: !0,
            type: "boolean",
            message: "_sendTelemetry option is not valid"
        },
        _telemetryInfo: {
            optional: !0,
            type: "object",
            message: "_telemetryInfo option is not valid"
        }
    }), this.baseOptions = options, this.baseOptions.headers = {
        Authorization: "Bearer " + this.baseOptions.token
    }, this.request = new $bdd166eca2c549e0$var$RequestBuilder(this.baseOptions), this.baseOptions.rootUrl = $bdd166eca2c549e0$var$urlJoin("https://" + this.baseOptions.domain, "api", "v2");
}
$bdd166eca2c549e0$export$d1b7252873cb8575.prototype.parseHash = function(options, cb) {
    var parsedQs, err;
    cb || "function" != typeof options ? options = options || {} : (cb = options, options = {});
    var hashStr = void 0 === options.hash ? $bdd166eca2c549e0$var$windowHelper.getWindow().location.hash : options.hash;
    if (hashStr = hashStr.replace(/^#?\/?/, ""), (parsedQs = $bdd166eca2c549e0$var$lib.parse(hashStr)).hasOwnProperty("error")) return err = $bdd166eca2c549e0$var$error.buildResponse(parsedQs.error, parsedQs.error_description), parsedQs.state && (err.state = parsedQs.state), cb(err);
    if (!parsedQs.hasOwnProperty("access_token") && !parsedQs.hasOwnProperty("id_token") && !parsedQs.hasOwnProperty("refresh_token")) return cb(null, null);
    var responseTypes = (this.baseOptions.responseType || options.responseType || "").split(" ");
    return responseTypes.length > 0 && -1 !== responseTypes.indexOf("token") && !parsedQs.hasOwnProperty("access_token") ? cb($bdd166eca2c549e0$var$error.buildResponse("invalid_hash", "response_type contains `token`, but the parsed hash does not contain an `access_token` property")) : responseTypes.length > 0 && -1 !== responseTypes.indexOf("id_token") && !parsedQs.hasOwnProperty("id_token") ? cb($bdd166eca2c549e0$var$error.buildResponse("invalid_hash", "response_type contains `id_token`, but the parsed hash does not contain an `id_token` property")) : this.validateAuthenticationResponse(options, parsedQs, cb);
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.validateAuthenticationResponse = function(options, parsedHash, cb) {
    var _this = this;
    options.__enableIdPInitiatedLogin = options.__enableIdPInitiatedLogin || options.__enableImpersonation;
    var state = parsedHash.state, transaction = this.transactionManager.getStoredTransaction(state), transactionState = options.state || transaction && transaction.state || null, transactionStateMatchesState = transactionState === state;
    if (!(!state && !transactionState && options.__enableIdPInitiatedLogin) && !transactionStateMatchesState) return cb({
        error: "invalid_token",
        errorDescription: "`state` does not match."
    });
    var transactionNonce = options.nonce || transaction && transaction.nonce || null, transactionOrganization = transaction && transaction.organization, appState = options.state || transaction && transaction.appState || null, callback = function(err, payload) {
        if (err) return cb(err);
        var sub;
        transaction && transaction.lastUsedConnection && (payload && (sub = payload.sub), _this.ssodataStorage.set(transaction.lastUsedConnection, sub));
        return cb(null, function(qsParams, appState, token) {
            return {
                accessToken: qsParams.access_token || null,
                idToken: qsParams.id_token || null,
                idTokenPayload: token || null,
                appState: appState || null,
                refreshToken: qsParams.refresh_token || null,
                state: qsParams.state || null,
                expiresIn: qsParams.expires_in ? parseInt(qsParams.expires_in, 10) : null,
                tokenType: qsParams.token_type || null,
                scope: qsParams.scope || null
            };
        }(parsedHash, appState, payload));
    };
    return parsedHash.id_token ? this.validateToken(parsedHash.id_token, transactionNonce, function(validationError, payload) {
        if (!validationError) {
            if (transactionOrganization) {
                if (0 === transactionOrganization.indexOf("org_")) {
                    if (!payload.org_id) return callback($bdd166eca2c549e0$var$error.invalidToken("Organization Id (org_id) claim must be a string present in the ID token"));
                    if (payload.org_id !== transactionOrganization) return callback($bdd166eca2c549e0$var$error.invalidToken('Organization Id (org_id) claim value mismatch in the ID token; expected "' + transactionOrganization + '", found "' + payload.org_id + '"'));
                } else {
                    if (!payload.org_name) return callback($bdd166eca2c549e0$var$error.invalidToken("Organization Name (org_name) claim must be a string present in the ID token"));
                    if (payload.org_name !== transactionOrganization.toLowerCase()) return callback($bdd166eca2c549e0$var$error.invalidToken('Organization Name (org_name) claim value mismatch in the ID token; expected "' + transactionOrganization + '", found "' + payload.org_name + '"'));
                }
            }
            return parsedHash.access_token && payload.at_hash ? (new $bdd166eca2c549e0$var$I).validateAccessToken(parsedHash.access_token, "RS256", payload.at_hash, function(err) {
                return err ? callback($bdd166eca2c549e0$var$error.invalidToken(err.message)) : callback(null, payload);
            }) : callback(null, payload);
        }
        if ("invalid_token" !== validationError.error || validationError.errorDescription && validationError.errorDescription.indexOf("Nonce (nonce) claim value mismatch in the ID token") > -1) return callback(validationError);
        var decodedToken = (new $bdd166eca2c549e0$var$I).decode(parsedHash.id_token);
        if ("HS256" !== decodedToken.header.alg) return callback(validationError);
        if ((decodedToken.payload.nonce || null) !== transactionNonce) return callback({
            error: "invalid_token",
            errorDescription: 'Nonce (nonce) claim value mismatch in the ID token; expected "' + transactionNonce + '", found "' + decodedToken.payload.nonce + '"'
        });
        if (!parsedHash.access_token) return callback({
            error: "invalid_token",
            description: "The id_token cannot be validated because it was signed with the HS256 algorithm and public clients (like a browser) can\u2019t store secrets. Please read the associated doc for possible ways to fix this. Read more: https://auth0.com/docs/errors/libraries/auth0-js/invalid-token#parsing-an-hs256-signed-id-token-without-an-access-token"
        });
        return _this.client.userInfo(parsedHash.access_token, function(errUserInfo, profile) {
            return errUserInfo ? callback(errUserInfo) : callback(null, profile);
        });
    }) : callback(null, null);
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.validateToken = function(token, nonce, cb) {
    new $bdd166eca2c549e0$var$I({
        issuer: this.baseOptions.token_issuer,
        jwksURI: this.baseOptions.jwksURI,
        audience: this.baseOptions.clientID,
        leeway: this.baseOptions.leeway || 60,
        maxAge: this.baseOptions.maxAge,
        __clock: this.baseOptions.__clock || $bdd166eca2c549e0$var$defaultClock
    }).verify(token, nonce, function(err, payload) {
        if (err) return cb($bdd166eca2c549e0$var$error.invalidToken(err.message));
        cb(null, payload);
    });
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.renewAuth = function(options, cb) {
    var usePostMessage = !!options.usePostMessage, postMessageDataType = options.postMessageDataType || !1, postMessageOrigin = options.postMessageOrigin || $bdd166eca2c549e0$var$windowHelper.getWindow().origin, timeout = options.timeout, _this = this, params = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "redirectUri",
        "responseType",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce"
    ]).with(options);
    params.responseType = params.responseType || "token", params.responseMode = params.responseMode || "fragment", params = this.transactionManager.process(params), $bdd166eca2c549e0$var$assert.check(params, {
        type: "object",
        message: "options parameter is not valid"
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), params.prompt = "none", params = $bdd166eca2c549e0$var$objectHelper.blacklist(params, [
        "usePostMessage",
        "tenant",
        "postMessageDataType",
        "postMessageOrigin"
    ]), $bdd166eca2c549e0$var$SilentAuthenticationHandler.create({
        authenticationUrl: this.client.buildAuthorizeUrl(params),
        postMessageDataType: postMessageDataType,
        postMessageOrigin: postMessageOrigin,
        timeout: timeout
    }).login(usePostMessage, function(err, hash) {
        if ("object" == typeof hash) return cb(err, hash);
        _this.parseHash({
            hash: hash
        }, cb);
    });
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.checkSession = function(options, cb) {
    var params = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "redirectUri",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce"
    ]).with(options);
    return "code" === params.responseType ? cb({
        error: "error",
        error_description: "responseType can't be `code`"
    }) : (options.nonce || (params = this.transactionManager.process(params)), params.redirectUri ? ($bdd166eca2c549e0$var$assert.check(params, {
        type: "object",
        message: "options parameter is not valid"
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), params = $bdd166eca2c549e0$var$objectHelper.blacklist(params, [
        "usePostMessage",
        "tenant",
        "postMessageDataType"
    ]), void this.webMessageHandler.run(params, $bdd166eca2c549e0$var$wrapCallback(cb, {
        forceLegacyError: !0,
        ignoreCasing: !0
    }))) : cb({
        error: "error",
        error_description: "redirectUri can't be empty"
    }));
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.changePassword = function(options, cb) {
    return this.client.dbConnection.changePassword(options, cb);
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.passwordlessStart = function(options, cb) {
    var authParams = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "responseType",
        "responseMode",
        "redirectUri",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce"
    ]).with(options.authParams);
    return options.authParams = this.transactionManager.process(authParams), this.client.passwordless.start(options, cb);
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.signup = function(options, cb) {
    return this.client.dbConnection.signup(options, cb);
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.authorize = function(options) {
    var params = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "responseMode",
        "redirectUri",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce",
        "organization",
        "invitation"
    ]).with(options);
    $bdd166eca2c549e0$var$assert.check(params, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        responseType: {
            type: "string",
            message: "responseType option is required"
        }
    }), (params = this.transactionManager.process(params)).scope = params.scope || "openid profile email", $bdd166eca2c549e0$var$windowHelper.redirect(this.client.buildAuthorizeUrl(params));
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.signupAndAuthorize = function(options, cb) {
    var _this = this;
    return this.client.dbConnection.signup($bdd166eca2c549e0$var$objectHelper.blacklist(options, [
        "popupHandler"
    ]), function(err) {
        if (err) return cb(err);
        options.realm = options.connection, options.username || (options.username = options.email), _this.client.login(options, cb);
    });
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.login = function(options, cb) {
    var params = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "redirectUri",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce",
        "onRedirecting",
        "organization",
        "invitation"
    ]).with(options);
    params = this.transactionManager.process(params), $bdd166eca2c549e0$var$windowHelper.getWindow().location.host === this.baseOptions.domain ? (params.connection = params.realm, delete params.realm, this._universalLogin.login(params, cb)) : this.crossOriginAuthentication.login(params, cb);
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.passwordlessLogin = function(options, cb) {
    var params = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "redirectUri",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce",
        "onRedirecting"
    ]).with(options);
    if (params = this.transactionManager.process(params), $bdd166eca2c549e0$var$windowHelper.getWindow().location.host === this.baseOptions.domain) this.passwordlessVerify(params, cb);
    else {
        var crossOriginOptions = $bdd166eca2c549e0$var$objectHelper.extend({
            credentialType: "http://auth0.com/oauth/grant-type/passwordless/otp",
            realm: params.connection,
            username: params.email || params.phoneNumber,
            otp: params.verificationCode
        }, $bdd166eca2c549e0$var$objectHelper.blacklist(params, [
            "connection",
            "email",
            "phoneNumber",
            "verificationCode"
        ]));
        this.crossOriginAuthentication.login(crossOriginOptions, cb);
    }
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.crossOriginAuthenticationCallback = function() {
    this.crossOriginVerification();
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.crossOriginVerification = function() {
    this.crossOriginAuthentication.callback();
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.logout = function(options) {
    $bdd166eca2c549e0$var$windowHelper.redirect(this.client.buildLogoutUrl(options));
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.passwordlessVerify = function(options, cb) {
    var _this = this, params = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "responseMode",
        "redirectUri",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce",
        "onRedirecting"
    ]).with(options);
    return $bdd166eca2c549e0$var$assert.check(params, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        responseType: {
            type: "string",
            message: "responseType option is required"
        }
    }), params = this.transactionManager.process(params), this.client.passwordless.verify(params, function(err) {
        if (err) return cb(err);
        function doAuth() {
            $bdd166eca2c549e0$var$windowHelper.redirect(_this.client.passwordless.buildVerifyUrl(params));
        }
        if ("function" == typeof options.onRedirecting) return options.onRedirecting(function() {
            doAuth();
        });
        doAuth();
    });
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.renderCaptcha = function(element, options, callback) {
    return $bdd166eca2c549e0$var$captcha.render(this.client, element, options, callback);
}, $bdd166eca2c549e0$export$d1b7252873cb8575.prototype.renderPasswordlessCaptcha = function(element, options, callback) {
    return $bdd166eca2c549e0$var$captcha.renderPasswordless(this.client, element, options, callback);
}, $bdd166eca2c549e0$var$PasswordlessAuthentication.prototype.buildVerifyUrl = function(options) {
    var params, qString;
    return $bdd166eca2c549e0$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        connection: {
            type: "string",
            message: "connection option is required"
        },
        verificationCode: {
            type: "string",
            message: "verificationCode option is required"
        },
        phoneNumber: {
            optional: !1,
            type: "string",
            message: "phoneNumber option is required",
            condition: function(o) {
                return !o.email;
            }
        },
        email: {
            optional: !1,
            type: "string",
            message: "email option is required",
            condition: function(o) {
                return !o.phoneNumber;
            }
        }
    }), params = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "responseMode",
        "redirectUri",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "protocol",
        "nonce"
    ]).with(options), this.baseOptions._sendTelemetry && (params.auth0Client = this.request.getTelemetryData()), params = $bdd166eca2c549e0$var$objectHelper.toSnakeCase(params, [
        "auth0Client"
    ]), qString = $bdd166eca2c549e0$var$lib.stringify(params), $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "passwordless", "verify_redirect", "?" + qString);
}, $bdd166eca2c549e0$var$PasswordlessAuthentication.prototype.start = function(options, cb) {
    var url, body;
    $bdd166eca2c549e0$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        connection: {
            type: "string",
            message: "connection option is required"
        },
        send: {
            type: "string",
            message: "send option is required",
            values: [
                "link",
                "code"
            ],
            value_message: "send is not valid ([link, code])"
        },
        phoneNumber: {
            optional: !0,
            type: "string",
            message: "phoneNumber option is required",
            condition: function(o) {
                return "code" === o.send || !o.email;
            }
        },
        email: {
            optional: !0,
            type: "string",
            message: "email option is required",
            condition: function(o) {
                return "link" === o.send || !o.phoneNumber;
            }
        },
        authParams: {
            optional: !0,
            type: "object",
            message: "authParams option is required"
        }
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "passwordless", "start");
    var xRequestLanguage = options.xRequestLanguage;
    delete options.xRequestLanguage, (body = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "redirectUri",
        "scope"
    ]).with(options)).scope && (body.authParams = body.authParams || {}, body.authParams.scope = body.authParams.scope || body.scope), body.redirectUri && (body.authParams = body.authParams || {}, body.authParams.redirect_uri = body.authParams.redirectUri || body.redirectUri), body.responseType && (body.authParams = body.authParams || {}, body.authParams.response_type = body.authParams.responseType || body.responseType), delete body.redirectUri, delete body.responseType, delete body.scope, body = $bdd166eca2c549e0$var$objectHelper.toSnakeCase(body, [
        "auth0Client",
        "authParams"
    ]);
    var postOptions = xRequestLanguage ? {
        xRequestLanguage: xRequestLanguage
    } : void 0;
    return this.request.post(url, postOptions).send(body).end($bdd166eca2c549e0$var$wrapCallback(cb));
}, $bdd166eca2c549e0$var$PasswordlessAuthentication.prototype.verify = function(options, cb) {
    var url, cleanOption;
    return $bdd166eca2c549e0$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        connection: {
            type: "string",
            message: "connection option is required"
        },
        verificationCode: {
            type: "string",
            message: "verificationCode option is required"
        },
        phoneNumber: {
            optional: !1,
            type: "string",
            message: "phoneNumber option is required",
            condition: function(o) {
                return !o.email;
            }
        },
        email: {
            optional: !1,
            type: "string",
            message: "email option is required",
            condition: function(o) {
                return !o.phoneNumber;
            }
        }
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), cleanOption = $bdd166eca2c549e0$var$objectHelper.pick(options, [
        "connection",
        "verificationCode",
        "phoneNumber",
        "email",
        "auth0Client",
        "clientID"
    ]), cleanOption = $bdd166eca2c549e0$var$objectHelper.toSnakeCase(cleanOption, [
        "auth0Client"
    ]), url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "passwordless", "verify"), this.request.post(url).send(cleanOption).end($bdd166eca2c549e0$var$wrapCallback(cb));
}, $bdd166eca2c549e0$var$PasswordlessAuthentication.prototype.getChallenge = function(cb) {
    if ($bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), !this.baseOptions.state) return cb();
    var url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "passwordless", "challenge");
    return this.request.post(url).send({
        state: this.baseOptions.state
    }).end($bdd166eca2c549e0$var$wrapCallback(cb, {
        ignoreCasing: !0
    }));
}, $bdd166eca2c549e0$var$DBConnection.prototype.signup = function(options, cb) {
    var url, body, metadata;
    return $bdd166eca2c549e0$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        connection: {
            type: "string",
            message: "connection option is required"
        },
        email: {
            type: "string",
            message: "email option is required"
        },
        password: {
            type: "string",
            message: "password option is required"
        }
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "dbconnections", "signup"), metadata = (body = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "state"
    ]).with(options)).user_metadata || body.userMetadata, body = $bdd166eca2c549e0$var$objectHelper.blacklist(body, [
        "scope",
        "userMetadata",
        "user_metadata"
    ]), body = $bdd166eca2c549e0$var$objectHelper.toSnakeCase(body, [
        "auth0Client"
    ]), metadata && (body.user_metadata = metadata), this.request.post(url).send(body).end($bdd166eca2c549e0$var$wrapCallback(cb));
}, $bdd166eca2c549e0$var$DBConnection.prototype.changePassword = function(options, cb) {
    var url, body;
    return $bdd166eca2c549e0$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        connection: {
            type: "string",
            message: "connection option is required"
        },
        email: {
            type: "string",
            message: "email option is required"
        }
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "dbconnections", "change_password"), body = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID"
    ]).with(options, [
        "email",
        "connection"
    ]), body = $bdd166eca2c549e0$var$objectHelper.toSnakeCase(body, [
        "auth0Client"
    ]), this.request.post(url).send(body).end($bdd166eca2c549e0$var$wrapCallback(cb));
}, $bdd166eca2c549e0$export$d9e3c9dc7eaad0c3.prototype.buildAuthorizeUrl = function(options) {
    var params, qString;
    return $bdd166eca2c549e0$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }), params = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "responseMode",
        "redirectUri",
        "scope",
        "audience"
    ]).with(options), $bdd166eca2c549e0$var$assert.check(params, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        clientID: {
            type: "string",
            message: "clientID option is required"
        },
        redirectUri: {
            optional: !0,
            type: "string",
            message: "redirectUri option is required"
        },
        responseType: {
            type: "string",
            message: "responseType option is required"
        },
        nonce: {
            type: "string",
            message: "nonce option is required",
            condition: function(o) {
                return -1 === o.responseType.indexOf("code") && -1 !== o.responseType.indexOf("id_token");
            }
        },
        scope: {
            optional: !0,
            type: "string",
            message: "scope option is required"
        },
        audience: {
            optional: !0,
            type: "string",
            message: "audience option is required"
        }
    }), this.baseOptions._sendTelemetry && (params.auth0Client = this.request.getTelemetryData()), params.connection_scope && $bdd166eca2c549e0$var$assert.isArray(params.connection_scope) && (params.connection_scope = params.connection_scope.join(",")), params = $bdd166eca2c549e0$var$objectHelper.blacklist(params, [
        "username",
        "popupOptions",
        "domain",
        "tenant",
        "timeout",
        "appState"
    ]), params = $bdd166eca2c549e0$var$objectHelper.toSnakeCase(params, [
        "auth0Client"
    ]), params = $bdd166eca2c549e0$var$parametersWhitelist.oauthAuthorizeParams(this.warn, params), qString = $bdd166eca2c549e0$var$lib.stringify(params), $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "authorize", "?" + qString);
}, $bdd166eca2c549e0$export$d9e3c9dc7eaad0c3.prototype.buildLogoutUrl = function(options) {
    var params, qString;
    return $bdd166eca2c549e0$var$assert.check(options, {
        optional: !0,
        type: "object",
        message: "options parameter is not valid"
    }), params = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID"
    ]).with(options || {}), this.baseOptions._sendTelemetry && (params.auth0Client = this.request.getTelemetryData()), params = $bdd166eca2c549e0$var$objectHelper.toSnakeCase(params, [
        "auth0Client",
        "returnTo"
    ]), qString = $bdd166eca2c549e0$var$lib.stringify($bdd166eca2c549e0$var$objectHelper.blacklist(params, [
        "federated"
    ])), options && void 0 !== options.federated && !1 !== options.federated && "false" !== options.federated && (qString += "&federated"), $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "v2", "logout", "?" + qString);
}, $bdd166eca2c549e0$export$d9e3c9dc7eaad0c3.prototype.loginWithDefaultDirectory = function(options, cb) {
    return $bdd166eca2c549e0$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        username: {
            type: "string",
            message: "username option is required"
        },
        password: {
            type: "string",
            message: "password option is required"
        },
        scope: {
            optional: !0,
            type: "string",
            message: "scope option is required"
        },
        audience: {
            optional: !0,
            type: "string",
            message: "audience option is required"
        }
    }), options.grantType = "password", this.oauthToken(options, cb);
}, $bdd166eca2c549e0$export$d9e3c9dc7eaad0c3.prototype.login = function(options, cb) {
    return $bdd166eca2c549e0$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        username: {
            type: "string",
            message: "username option is required"
        },
        password: {
            type: "string",
            message: "password option is required"
        },
        realm: {
            type: "string",
            message: "realm option is required"
        },
        scope: {
            optional: !0,
            type: "string",
            message: "scope option is required"
        },
        audience: {
            optional: !0,
            type: "string",
            message: "audience option is required"
        }
    }), options.grantType = "http://auth0.com/oauth/grant-type/password-realm", this.oauthToken(options, cb);
}, $bdd166eca2c549e0$export$d9e3c9dc7eaad0c3.prototype.oauthToken = function(options, cb) {
    var url, body;
    return $bdd166eca2c549e0$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "oauth", "token"), body = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "scope",
        "audience"
    ]).with(options), $bdd166eca2c549e0$var$assert.check(body, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        clientID: {
            type: "string",
            message: "clientID option is required"
        },
        grantType: {
            type: "string",
            message: "grantType option is required"
        },
        scope: {
            optional: !0,
            type: "string",
            message: "scope option is required"
        },
        audience: {
            optional: !0,
            type: "string",
            message: "audience option is required"
        }
    }), body = $bdd166eca2c549e0$var$objectHelper.toSnakeCase(body, [
        "auth0Client"
    ]), body = $bdd166eca2c549e0$var$parametersWhitelist.oauthTokenParams(this.warn, body), this.request.post(url).send(body).end($bdd166eca2c549e0$var$wrapCallback(cb));
}, $bdd166eca2c549e0$export$d9e3c9dc7eaad0c3.prototype.loginWithResourceOwner = function(options, cb) {
    var url, body;
    return $bdd166eca2c549e0$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        username: {
            type: "string",
            message: "username option is required"
        },
        password: {
            type: "string",
            message: "password option is required"
        },
        connection: {
            type: "string",
            message: "connection option is required"
        },
        scope: {
            optional: !0,
            type: "string",
            message: "scope option is required"
        }
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "oauth", "ro"), body = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "scope"
    ]).with(options, [
        "username",
        "password",
        "scope",
        "connection",
        "device"
    ]), (body = $bdd166eca2c549e0$var$objectHelper.toSnakeCase(body, [
        "auth0Client"
    ])).grant_type = body.grant_type || "password", this.request.post(url).send(body).end($bdd166eca2c549e0$var$wrapCallback(cb));
}, $bdd166eca2c549e0$export$d9e3c9dc7eaad0c3.prototype.getSSOData = function(withActiveDirectories, cb) {
    if (this.auth0 || (this.auth0 = new $bdd166eca2c549e0$export$d1b7252873cb8575(this.baseOptions)), $bdd166eca2c549e0$var$windowHelper.getWindow().location.host === this.baseOptions.domain) return this.auth0._universalLogin.getSSOData(withActiveDirectories, cb);
    "function" == typeof withActiveDirectories && (cb = withActiveDirectories), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    });
    var clientId = this.baseOptions.clientID, ssodataInformation = this.ssodataStorage.get() || {};
    this.auth0.checkSession({
        responseType: "token id_token",
        scope: "openid profile email",
        connection: ssodataInformation.lastUsedConnection,
        timeout: 5e3
    }, function(err, result) {
        return err ? "login_required" === err.error ? cb(null, {
            sso: !1
        }) : ("consent_required" === err.error && (err.error_description = "Consent required. When using `getSSOData`, the user has to be authenticated with the following scope: `openid profile email`."), cb(err, {
            sso: !1
        })) : ssodataInformation.lastUsedSub && ssodataInformation.lastUsedSub !== result.idTokenPayload.sub ? cb(err, {
            sso: !1
        }) : cb(null, {
            lastUsedConnection: {
                name: ssodataInformation.lastUsedConnection
            },
            lastUsedUserID: result.idTokenPayload.sub,
            lastUsedUsername: result.idTokenPayload.email || result.idTokenPayload.name,
            lastUsedClientID: clientId,
            sessionClients: [
                clientId
            ],
            sso: !0
        });
    });
}, $bdd166eca2c549e0$export$d9e3c9dc7eaad0c3.prototype.userInfo = function(accessToken, cb) {
    var url;
    return $bdd166eca2c549e0$var$assert.check(accessToken, {
        type: "string",
        message: "accessToken parameter is not valid"
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "userinfo"), this.request.get(url).set("Authorization", "Bearer " + accessToken).end($bdd166eca2c549e0$var$wrapCallback(cb, {
        ignoreCasing: !0
    }));
}, $bdd166eca2c549e0$export$d9e3c9dc7eaad0c3.prototype.getChallenge = function(cb) {
    if ($bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), !this.baseOptions.state) return cb();
    var url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "usernamepassword", "challenge");
    return this.request.post(url).send({
        state: this.baseOptions.state
    }).end($bdd166eca2c549e0$var$wrapCallback(cb, {
        ignoreCasing: !0
    }));
}, $bdd166eca2c549e0$export$d9e3c9dc7eaad0c3.prototype.delegation = function(options, cb) {
    var url, body;
    return $bdd166eca2c549e0$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        grant_type: {
            type: "string",
            message: "grant_type option is required"
        }
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "delegation"), body = $bdd166eca2c549e0$var$objectHelper.merge(this.baseOptions, [
        "clientID"
    ]).with(options), body = $bdd166eca2c549e0$var$objectHelper.toSnakeCase(body, [
        "auth0Client"
    ]), this.request.post(url).send(body).end($bdd166eca2c549e0$var$wrapCallback(cb));
}, $bdd166eca2c549e0$export$d9e3c9dc7eaad0c3.prototype.getUserCountry = function(cb) {
    var url;
    return $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "user", "geoloc", "country"), this.request.get(url).end($bdd166eca2c549e0$var$wrapCallback(cb));
}, $bdd166eca2c549e0$export$cbb26d9fbbee6ab2.prototype.getUser = function(userId, cb) {
    var url;
    return $bdd166eca2c549e0$var$assert.check(userId, {
        type: "string",
        message: "userId parameter is not valid"
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "users", userId), this.request.get(url).end($bdd166eca2c549e0$var$wrapCallback(cb, {
        ignoreCasing: !0
    }));
}, $bdd166eca2c549e0$export$cbb26d9fbbee6ab2.prototype.patchUserMetadata = function(userId, userMetadata, cb) {
    var url;
    return $bdd166eca2c549e0$var$assert.check(userId, {
        type: "string",
        message: "userId parameter is not valid"
    }), $bdd166eca2c549e0$var$assert.check(userMetadata, {
        type: "object",
        message: "userMetadata parameter is not valid"
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "users", userId), this.request.patch(url).send({
        user_metadata: userMetadata
    }).end($bdd166eca2c549e0$var$wrapCallback(cb, {
        ignoreCasing: !0
    }));
}, $bdd166eca2c549e0$export$cbb26d9fbbee6ab2.prototype.patchUserAttributes = function(userId, user, cb) {
    var url;
    return $bdd166eca2c549e0$var$assert.check(userId, {
        type: "string",
        message: "userId parameter is not valid"
    }), $bdd166eca2c549e0$var$assert.check(user, {
        type: "object",
        message: "user parameter is not valid"
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "users", userId), this.request.patch(url).send(user).end($bdd166eca2c549e0$var$wrapCallback(cb, {
        ignoreCasing: !0
    }));
}, $bdd166eca2c549e0$export$cbb26d9fbbee6ab2.prototype.linkUser = function(userId, secondaryUserToken, cb) {
    var url;
    return $bdd166eca2c549e0$var$assert.check(userId, {
        type: "string",
        message: "userId parameter is not valid"
    }), $bdd166eca2c549e0$var$assert.check(secondaryUserToken, {
        type: "string",
        message: "secondaryUserToken parameter is not valid"
    }), $bdd166eca2c549e0$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $bdd166eca2c549e0$var$urlJoin(this.baseOptions.rootUrl, "users", userId, "identities"), this.request.post(url).send({
        link_with: secondaryUserToken
    }).end($bdd166eca2c549e0$var$wrapCallback(cb, {
        ignoreCasing: !0
    }));
};
var $bdd166eca2c549e0$var$index = {
    Authentication: $bdd166eca2c549e0$export$d9e3c9dc7eaad0c3,
    Management: $bdd166eca2c549e0$export$cbb26d9fbbee6ab2,
    WebAuth: $bdd166eca2c549e0$export$d1b7252873cb8575,
    version: $bdd166eca2c549e0$export$83d89fbfd8236492
};
var $bdd166eca2c549e0$export$2e2bcd8739ae039 = $bdd166eca2c549e0$var$index;



function $faa7738054cea9e6$export$2e2bcd8739ae039() {
    return new (0, $bdd166eca2c549e0$export$d1b7252873cb8575)({
        domain: (0, $63b5c9d178f1431e$export$6ed6116aaa4a07d6) ?? "",
        clientID: (0, $63b5c9d178f1431e$export$458778b94eb61719) ?? "",
        scope: "openid profile screen_name offline_access email"
    });
}


const $f3d8f18722148e05$var$AUTH0_SIGN_IN_CALLBACK_URL = new URL("/services/auth/sign-in-callback", window.location.origin).href;
function $f3d8f18722148e05$export$d3501e855596718a() {
    window.location.reload();
}
function $f3d8f18722148e05$export$7f31ee2b5ad7de8c() {
    window.location.href = "/";
}
function $f3d8f18722148e05$export$a22ca88ad1ac21dd(sameWindow) {
    if (sameWindow) window.location.replace((0, $ea458c15ce872cdc$export$3ae46e95ba6bc5da));
    else window.location.href = (0, $ea458c15ce872cdc$export$3ae46e95ba6bc5da);
}
function $f3d8f18722148e05$export$a87b9917f4982a24() {
    window.location.href = (0, $ea458c15ce872cdc$export$e18d42a3291f46e5);
}
function $f3d8f18722148e05$export$96352d11af64d2e5() {
    const auth0 = (0, $faa7738054cea9e6$export$2e2bcd8739ae039)();
    auth0.authorize({
        responseType: "code",
        connection: "twitter",
        redirectUri: $f3d8f18722148e05$var$AUTH0_SIGN_IN_CALLBACK_URL
    });
}
function $f3d8f18722148e05$export$12c5a7cb8eb9b109() {
    const auth0 = (0, $faa7738054cea9e6$export$2e2bcd8739ae039)();
    auth0.authorize({
        responseType: "code",
        connection: "facebook",
        redirectUri: $f3d8f18722148e05$var$AUTH0_SIGN_IN_CALLBACK_URL
    });
}
function $f3d8f18722148e05$export$d31f12173d341be5() {
    const auth0 = (0, $faa7738054cea9e6$export$2e2bcd8739ae039)();
    auth0.authorize({
        responseType: "code",
        connection: "google-oauth2",
        redirectUri: $f3d8f18722148e05$var$AUTH0_SIGN_IN_CALLBACK_URL
    });
}
function $f3d8f18722148e05$export$d3179f1c9b9fc645(email, callback) {
    const auth0 = (0, $faa7738054cea9e6$export$2e2bcd8739ae039)();
    auth0.passwordlessStart({
        send: "link",
        email: email,
        connection: "email",
        authParams: {
            redirectUri: $f3d8f18722148e05$var$AUTH0_SIGN_IN_CALLBACK_URL,
            responseType: "code"
        }
    }, (err, res)=>{
        callback(err, res);
    });
}



















function $8a3f808dfa88cc0c$export$b1486147269f520a() {
    (0, $8d9791e5769125e5$export$996926525e13f61e)(true);
    (0, $8d9791e5769125e5$export$cc66adb823d23a6)();
    (0, $2f44915f6f87dcf5$export$b2eeaeff46616de5)();
    (0, $8d9791e5769125e5$export$996926525e13f61e)(false);
    (0, $8d9791e5769125e5$export$ed20678efa7800e4)();
    (0, $a7e2543fa152618e$export$6d965942225efd51)(false);
}
function $8a3f808dfa88cc0c$export$1563f5079ee61708() {
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $91ffa8e8b26e8ad0$export$f558026a994b6051)({
        newStreetPreference: (0, $2a9a05c10189c2fe$export$a312938bcd95f73c)
    }));
    $8a3f808dfa88cc0c$export$b1486147269f520a();
}
function $8a3f808dfa88cc0c$export$a20f0d151f82e88e() {
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $91ffa8e8b26e8ad0$export$f558026a994b6051)({
        newStreetPreference: (0, $2a9a05c10189c2fe$export$fe67c041c7fe7c2)
    }));
    (0, $8d9791e5769125e5$export$996926525e13f61e)(true);
    (0, $8d9791e5769125e5$export$a221a6108238e80d)();
    (0, $2f44915f6f87dcf5$export$b2eeaeff46616de5)();
    (0, $8d9791e5769125e5$export$996926525e13f61e)(false);
    (0, $8d9791e5769125e5$export$ed20678efa7800e4)();
    (0, $a7e2543fa152618e$export$6d965942225efd51)(false);
}






var $23a883339fc52481$exports = {};
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.

var $233YU = parcelRequire("233YU");

var $eY8Tu = parcelRequire("eY8Tu");

var $7Uslr = parcelRequire("7Uslr");

var $fKOPV = parcelRequire("fKOPV");

var $8fzIh = parcelRequire("8fzIh");

var $iVcM8 = parcelRequire("iVcM8");
var $b06bb84ec1dcc6bb$exports = {};

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ (function(global, pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var width = 256, chunks = 6, digits = 52, rngname = "random", startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
        var key = [];
        options = options == true ? {
            entropy: true
        } : options || {};
        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(options.entropy ? [
            seed,
            tostring(pool)
        ] : seed == null ? autoseed() : seed, 3), key);
        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);
        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks), d = startdenom, x = 0; //   and no 'extra last byte'.
            while(n < significance){
                n = (n + x) * width; //   shifting numerator and
                d *= width; //   denominator and generating a
                x = arc4.g(1); //   new least-significant-byte.
            }
            while(n >= overflow){
                n /= 2; //   last byte, shift everything
                d /= 2; //   right using integer math until
                x >>>= 1; //   we have exactly the desired bits.
            }
            return (n + x) / d; // Form the number within [0, 1).
        };
        prng.int32 = function() {
            return arc4.g(4) | 0;
        };
        prng.quick = function() {
            return arc4.g(4) / 0x100000000;
        };
        prng.double = prng;
        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);
        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback || function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) copy(state, arc4);
                // Only provide the .state method if requested via options.state.
                prng.state = function() {
                    return copy(arc4, {});
                };
            }
            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) {
                math[rngname] = prng;
                return seed;
            } else return prng;
        })(prng, shortseed, "global" in options ? options.global : this == math, options.state);
    }
    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
        var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
        // The empty key [] is treated as [0].
        if (!keylen) key = [
            keylen++
        ];
        // Set up S using the standard key scheduling algorithm.
        while(i < width)s[i] = i++;
        for(i = 0; i < width; i++){
            s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
            s[j] = t;
        }
        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0, i = me.i, j = me.j, s = me.S;
            while(count--){
                t = s[i = mask & i + 1];
                r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
            }
            me.i = i;
            me.j = j;
            return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }
    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }
    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
        var result = [], typ = typeof obj, prop;
        if (depth && typ == "object") {
            for(prop in obj)try {
                result.push(flatten(obj[prop], depth - 1));
            } catch (e) {}
        }
        return result.length ? result : typ == "string" ? obj : obj + "\x00";
    }
    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
        var stringseed = seed + "", smear, j = 0;
        while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
        return tostring(key);
    }
    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
        try {
            var out;
            if (nodecrypto && (out = nodecrypto.randomBytes)) // The use of 'out' to remember randomBytes makes tight minified code.
            out = out(width);
            else {
                out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
            }
            return tostring(out);
        } catch (e) {
            var browser = global.navigator, plugins = browser && browser.plugins;
            return [
                +new Date,
                global,
                plugins,
                global.screen,
                tostring(pool)
            ];
        }
    }
    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }
    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    if (0, $b06bb84ec1dcc6bb$exports) {
        $b06bb84ec1dcc6bb$exports = seedrandom;
        // When in node.js, try using crypto package for autoseeding.
        try {
            nodecrypto = (parcelRequire("bBs1K"));
        } catch (ex) {}
    } else if (typeof define == "function" && define.amd) define(function() {
        return seedrandom;
    });
    else // When included as a plain script, set up Math.seedrandom global.
    math["seed" + rngname] = seedrandom;
// End anonymous scope, and pass initial values.
})(// global: `self` in browsers (including strict mode and web workers),
// otherwise `this` in Node and other environments
typeof self !== "undefined" ? self : $b06bb84ec1dcc6bb$exports, [], Math // math: package containing random, pow, and seedrandom
);


$b06bb84ec1dcc6bb$exports.alea = $233YU;
$b06bb84ec1dcc6bb$exports.xor128 = $eY8Tu;
$b06bb84ec1dcc6bb$exports.xorwow = $7Uslr;
$b06bb84ec1dcc6bb$exports.xorshift7 = $fKOPV;
$b06bb84ec1dcc6bb$exports.xor4096 = $8fzIh;
$b06bb84ec1dcc6bb$exports.tychei = $iVcM8;
$23a883339fc52481$exports = $b06bb84ec1dcc6bb$exports;





// Initialized a memoized instance of Intl.NumberFormat
const $9d270f5a79da1a95$var$NumberFormat = $9d270f5a79da1a95$var$memoizeFormatConstructor(Intl.NumberFormat);
function $9d270f5a79da1a95$export$f5dd818bff069720(number, locale, options = {}) {
    return $9d270f5a79da1a95$var$NumberFormat(locale, options).format(number);
}
// -- Utilities ---------------------------------------------------------------
/**
 * These utility functions create a memoized formatter, since calling
 * `new Intl.NumberFormat` multiple times in succession is a performance hit.
 *
 * See https://github.com/yahoo/intl-format-cache for inspiration and reference.
 * @todo: Simplify (or abstract out) the memoization process
 */ function $9d270f5a79da1a95$var$getCacheId(inputs) {
    return JSON.stringify(inputs.map((input)=>input && typeof input === "object" ? $9d270f5a79da1a95$var$orderedProps(input) : input));
}
function $9d270f5a79da1a95$var$orderedProps(obj) {
    return Object.keys(obj).sort().map((k)=>({
            [k]: obj[k]
        }));
}
function $9d270f5a79da1a95$var$memoizeFormatConstructor(FormatConstructor) {
    const cache = {};
    return (...args)=>{
        const cacheId = $9d270f5a79da1a95$var$getCacheId(args);
        let format = cacheId && cache[cacheId];
        if (!format) {
            format = new FormatConstructor(...args);
            if (cacheId) cache[cacheId] = format;
        }
        return format;
    };
}


const $83fecf775ebd2a37$var$IMPERIAL_METRIC_MULTIPLIER = 0.3;
const $83fecf775ebd2a37$var$METRIC_PRECISION = 3;
const $83fecf775ebd2a37$var$IMPERIAL_PRECISION = 3;
const $83fecf775ebd2a37$var$WIDTH_INPUT_CONVERSION = [
    {
        text: "m",
        multiplier: 1 / $83fecf775ebd2a37$var$IMPERIAL_METRIC_MULTIPLIER
    },
    {
        text: "\u043C",
        multiplier: 1 / $83fecf775ebd2a37$var$IMPERIAL_METRIC_MULTIPLIER
    },
    {
        text: "cm",
        multiplier: 0.01 / $83fecf775ebd2a37$var$IMPERIAL_METRIC_MULTIPLIER
    },
    {
        text: '"',
        multiplier: 1 / 12
    },
    {
        text: "\u2033",
        multiplier: 1 / 12
    },
    {
        text: "in",
        multiplier: 1 / 12
    },
    {
        text: "in.",
        multiplier: 1 / 12
    },
    {
        text: "inch",
        multiplier: 1 / 12
    },
    {
        text: "inches",
        multiplier: 1 / 12
    },
    {
        text: "'",
        multiplier: 1
    },
    {
        text: "\u2032",
        multiplier: 1
    },
    {
        text: "ft",
        multiplier: 1
    },
    {
        text: "ft.",
        multiplier: 1
    },
    {
        text: "feet",
        multiplier: 1
    }
];
const $83fecf775ebd2a37$var$IMPERIAL_VULGAR_FRACTIONS = {
    ".125": "\u215B",
    ".25": "\xbc",
    ".375": "\u215C",
    ".5": "\xbd",
    ".625": "\u215D",
    ".75": "\xbe",
    ".875": "\u215E"
};
function $83fecf775ebd2a37$export$53a59fd02fe9885d(widthInput, units) {
    if (!widthInput || !units) return;
    // Normalize certain input quirks. Spaces (more common at end or beginning of input)
    // go away, and comma-based decimals turn into period-based decimals
    widthInput = widthInput.replace(/ /g, "");
    widthInput = widthInput.replace(/,/g, ".");
    for(const i in $83fecf775ebd2a37$var$IMPERIAL_VULGAR_FRACTIONS)if (widthInput.indexOf($83fecf775ebd2a37$var$IMPERIAL_VULGAR_FRACTIONS[i]) !== -1) widthInput = widthInput.replace(new RegExp($83fecf775ebd2a37$var$IMPERIAL_VULGAR_FRACTIONS[i]), i);
    let width;
    // The conditional makes sure we only split and parse separately when the input includes ' as any character except the last
    if (widthInput.indexOf("'") !== -1 && widthInput.length > widthInput.indexOf("'") + 1) {
        widthInput = widthInput.split("'");
        widthInput[0] += "'" // Add the ' to the first value so the parser knows to convert in feet, not in unitless, when in metric
        ;
        width = widthInput.reduce(function(prev, cur) {
            if (cur.indexOf('"') === -1) // Assuming anything coming after feet is going to be inches
            cur += '"';
            return $83fecf775ebd2a37$var$parseStringForUnits(prev.toString()) + $83fecf775ebd2a37$var$parseStringForUnits(cur.toString(), units);
        });
    } else width = $83fecf775ebd2a37$var$parseStringForUnits(widthInput, units);
    return width;
}
function $83fecf775ebd2a37$export$f87bc2ba75a381c(width, units, locale) {
    let widthText = "";
    // LEGACY: Not all uses of this function pass in locale
    if (!locale) locale = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().locale.locale;
    switch(units){
        case 0, $c098fdb90228b950$export$c9756beb4aae2c8d:
            widthText = $83fecf775ebd2a37$export$54e6b45bbe358ed6(width, locale) // also converts to string
            ;
            widthText += "\u2032";
            break;
        case 0, $c098fdb90228b950$export$95a57d0e83881bf:
        default:
            widthText = $83fecf775ebd2a37$export$a05e78ee40994883(width, (0, $c098fdb90228b950$export$95a57d0e83881bf), locale);
            // Locale-specific units
            switch(locale){
                // In Russian, the Cyrillic м is common in vernacular usage.
                // This is in defiance of SI, but should be friendlier.
                case "ru":
                    widthText += " \u043C";
                    break;
                // In Arabic, use the same character that the USDM uses for metric units
                case "ar":
                    widthText += " \u0645";
                    break;
                default:
                    widthText += " m";
                    break;
            }
            break;
    }
    return widthText;
}
function $83fecf775ebd2a37$export$a05e78ee40994883(value, units, locale) {
    let string = "";
    if (!value) return "0";
    // Force the use of Western Arabic numerals in Arabic locale
    if (locale === "ar") locale += "-u-nu-latn";
    switch(units){
        case 0, $c098fdb90228b950$export$c9756beb4aae2c8d:
            string = (0, $9d270f5a79da1a95$export$f5dd818bff069720)(value, locale, {
                style: "decimal",
                maximumFractionDigits: $83fecf775ebd2a37$var$IMPERIAL_PRECISION
            });
            break;
        case 0, $c098fdb90228b950$export$95a57d0e83881bf:
        default:
            {
                const convertedValue = $83fecf775ebd2a37$var$convertImperialMeasurementToMetric(value);
                string = (0, $9d270f5a79da1a95$export$f5dd818bff069720)(convertedValue, locale, {
                    style: "decimal",
                    maximumFractionDigits: $83fecf775ebd2a37$var$METRIC_PRECISION
                });
                break;
            }
    }
    return string;
}
/**
 * Given a measurement value (stored internally in Streetmix as imperial units),
 * return a metric quantity with three decimal points.
 *
 * @param {Number} value, assuming imperial units
 * @returns {Number} value in metric units
 */ function $83fecf775ebd2a37$var$convertImperialMeasurementToMetric(value) {
    return (value * $83fecf775ebd2a37$var$IMPERIAL_METRIC_MULTIPLIER).toFixed($83fecf775ebd2a37$var$METRIC_PRECISION);
}
function $83fecf775ebd2a37$export$54e6b45bbe358ed6(value, locale) {
    // Determine if there is a vulgar fraction to display
    const remainder = value - Math.floor(value);
    const fraction = $83fecf775ebd2a37$var$IMPERIAL_VULGAR_FRACTIONS[remainder.toString().substr(1)];
    if (fraction) {
        // Non-zero trailing number
        if (Math.floor(value)) return $83fecf775ebd2a37$export$a05e78ee40994883(Math.floor(value), (0, $c098fdb90228b950$export$c9756beb4aae2c8d), locale) + fraction;
        else return fraction;
    }
    // Otherwise, just return the stringified value without fractions
    return $83fecf775ebd2a37$export$a05e78ee40994883(value, (0, $c098fdb90228b950$export$c9756beb4aae2c8d), locale);
}
/**
 * Given a width in any unit (including no unit), parses for units and returns
 * value multiplied by the appropriate multiplier.
 *
 * @param {String} widthInput to convert to number
 * @param {Number} units - either SETTINGS_UNITS_METRIC or SETTINGS_UNITS_IMPERIAL
 * @returns {Number} formatted width as number
 */ function $83fecf775ebd2a37$var$parseStringForUnits(widthInput, units) {
    if (widthInput.indexOf("-") !== -1) widthInput = widthInput.replace(/-/g, "") // Dashes would mean negative in the parseFloat
    ;
    let width = Number.parseFloat(widthInput);
    if (width) {
        let multiplier;
        if (units === (0, $c098fdb90228b950$export$95a57d0e83881bf)) // Checks for a unitless input when metric
        multiplier = 1 / $83fecf775ebd2a37$var$IMPERIAL_METRIC_MULTIPLIER;
        else // Default multiplier, is true if units are imperial
        // TODO: metric units should be default
        multiplier = 1;
        for(const i in $83fecf775ebd2a37$var$WIDTH_INPUT_CONVERSION)if (widthInput.match(new RegExp("[\\d\\.]" + $83fecf775ebd2a37$var$WIDTH_INPUT_CONVERSION[i].text + "$"))) {
            multiplier = $83fecf775ebd2a37$var$WIDTH_INPUT_CONVERSION[i].multiplier;
            break;
        }
        width *= multiplier;
        return width;
    } else return 0 // Allows for leading zeros, like 0'7"
    ;
}






const $2690ac3abe906938$var$MAX_CANVAS_HEIGHT = 2048;
const $2690ac3abe906938$export$c96efbd0faab9278 = 44;
const $2690ac3abe906938$export$68f9303c71cd9a6d = {
    grass: {
        id: "grass",
        label: "Grass",
        spriteId: "buildings--grass",
        hasFloors: false,
        sameOnBothSides: true
    },
    fence: {
        id: "fence",
        label: "Empty lot",
        spriteId: "buildings--fenced-lot",
        hasFloors: false
    },
    "parking-lot": {
        id: "parking-lot",
        label: "Parking lot",
        spriteId: "buildings--parking-lot",
        hasFloors: false,
        repeatHalf: true
    },
    waterfront: {
        id: "waterfront",
        label: "Waterfront",
        spriteId: "buildings--waterfront",
        hasFloors: false,
        alignAtBaseline: true,
        repeatHalf: true
    },
    residential: {
        id: "residential",
        label: "Home",
        spriteId: "buildings--residential",
        hasFloors: true,
        variantsCount: 0,
        floorHeight: 10,
        roofHeight: 6,
        mainFloorHeight: 24.5
    },
    narrow: {
        id: "narrow",
        label: "Building",
        spriteId: "buildings--apartments-narrow",
        hasFloors: true,
        variantsCount: 1,
        floorHeight: 10,
        roofHeight: 2,
        mainFloorHeight: 14,
        overhangWidth: 17
    },
    wide: {
        id: "wide",
        label: "Building",
        spriteId: "buildings--apartments-wide",
        hasFloors: true,
        variantsCount: 1,
        floorHeight: 10,
        roofHeight: 2,
        mainFloorHeight: 14,
        overhangWidth: 22
    },
    arcade: {
        id: "arcade",
        label: "Arcade building",
        spriteId: "buildings--arcade",
        hasFloors: true,
        variantsCount: 1,
        floorHeight: 10,
        roofHeight: 6,
        mainFloorHeight: 14,
        overhangWidth: 15
    },
    "compound-wall": {
        id: "compound-wall",
        label: "Compound wall",
        spriteId: "buildings--compound-wall",
        hasFloors: false
    }
};
/**
 * Create sprite id given variant and position
 *
 * @param {string} variant
 * @param {string} position - either "left" or "right"
 * @returns {string}
 */ function $2690ac3abe906938$var$getSpriteId(variant, position) {
    const building = $2690ac3abe906938$export$68f9303c71cd9a6d[variant];
    return building.spriteId + (building.sameOnBothSides ? "" : "-" + position);
}
function $2690ac3abe906938$export$1b6ddfb770453bfd(variant, position, floors = 1) {
    const building = $2690ac3abe906938$export$68f9303c71cd9a6d[variant];
    let height;
    if (building.hasFloors) height = (building.roofHeight + building.floorHeight * (floors - 1) + building.mainFloorHeight) * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381);
    else {
        const id = $2690ac3abe906938$var$getSpriteId(variant, position);
        const svg = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(id);
        height = svg.height / (0, $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8);
    }
    return height;
}
function $2690ac3abe906938$export$dbfef12841a1472a(variant, position, floors) {
    const CURB_HEIGHT = 6;
    return ($2690ac3abe906938$export$1b6ddfb770453bfd(variant, position, floors) - CURB_HEIGHT) / (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381);
}
function $2690ac3abe906938$export$d0cdab6355f6b245(variant, position, floors, units, formatMessage) {
    let text = formatMessage({
        id: "building.floors-count",
        defaultMessage: "{count, plural, one {# floor} other {# floors}}"
    }, {
        count: floors
    });
    const realHeight = $2690ac3abe906938$export$dbfef12841a1472a(variant, position, floors);
    const prettifiedHeight = (0, $83fecf775ebd2a37$export$f87bc2ba75a381c)(realHeight, units);
    text += ` (${prettifiedHeight})`;
    return text;
}
function $2690ac3abe906938$export$617d1ea5740d0e6f(ctx, variant, floors, position, totalWidth, totalHeight, offsetLeft, multiplier, dpi, shadeIn = false) {
    const building = $2690ac3abe906938$export$68f9303c71cd9a6d[variant];
    const spriteId = $2690ac3abe906938$var$getSpriteId(variant, position);
    const svg = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(spriteId);
    const buildingHeight = $2690ac3abe906938$export$1b6ddfb770453bfd(variant, position, floors);
    let offsetTop = totalHeight - buildingHeight * multiplier;
    // Adjust offset if the building should be aligned at baseline instead of ground plane
    if (building.alignAtBaseline) offsetTop += $2690ac3abe906938$export$c96efbd0faab9278;
    // Some building sprites tile itself, while others tile just half of it
    let width, x, lastX, firstX;
    if (building.repeatHalf) {
        width = svg.width / (0, $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8) / 2 // 2 = halfway point is where repeat starts.
        ;
        if (position === (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd)) {
            x = 0 // repeat the left half of this sprite
            ;
            lastX = svg.width / 2 // anchor the right half of this sprite
            ;
        } else {
            x = svg.width / 2 // repeat the right half of this sprite
            ;
            firstX = 0 // anchor the left half of this sprite
            ;
        }
    } else width = svg.width / (0, $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8);
    // For buildings in the left position, align building to the right
    let leftPosShift = 0;
    if (position === (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd)) {
        if (!building.hasFloors) // takes into consideration tiling
        leftPosShift = totalWidth % width - (width + width);
        else leftPosShift = totalWidth - width;
    }
    // Multifloor buildings
    if (building.hasFloors) {
        const height = svg.height // actual pixels, don't need to divide by TILESET_POINT_PER_PIXEL
        ;
        // bottom floor
        (0, $2f44915f6f87dcf5$export$d183e74c32825504)(spriteId, ctx, 0, height - building.mainFloorHeight * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * (0, $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8), undefined, building.mainFloorHeight * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381), offsetLeft + leftPosShift * multiplier, offsetTop + (buildingHeight - building.mainFloorHeight * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381)) * multiplier, undefined, building.mainFloorHeight * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381), multiplier, dpi);
        // middle floors
        const randomGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($23a883339fc52481$exports)))((0, $5bb3a44e0e01d545$export$29ee64aa80b9fa13)());
        for(let i = 1; i < floors; i++){
            const variant = building.variantsCount === 0 ? 0 : Math.floor(randomGenerator() * building.variantsCount) + 1;
            (0, $2f44915f6f87dcf5$export$d183e74c32825504)(spriteId, ctx, 0, height - building.mainFloorHeight * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * (0, $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8) - building.floorHeight * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * variant * (0, $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8), // 168 - (building.floorHeight * TILE_SIZE * variant), // 0 - 240 + (120 * building.variantsCount) - (building.floorHeight * TILE_SIZE * variant),
            undefined, building.floorHeight * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381), offsetLeft + leftPosShift * multiplier, offsetTop + buildingHeight * multiplier - (building.mainFloorHeight + building.floorHeight * i) * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier, undefined, building.floorHeight * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381), multiplier, dpi);
        }
        // roof
        (0, $2f44915f6f87dcf5$export$d183e74c32825504)(spriteId, ctx, 0, height - building.mainFloorHeight * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * (0, $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8) - building.floorHeight * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * building.variantsCount * (0, $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8) - building.roofHeight * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * (0, $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8), undefined, building.roofHeight * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381), offsetLeft + leftPosShift * multiplier, offsetTop + buildingHeight * multiplier - (building.mainFloorHeight + building.floorHeight * (floors - 1) + building.roofHeight) * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier, undefined, building.roofHeight * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381), multiplier, dpi);
    } else {
        // Single floor buildings
        // Determine how much tiling happens
        const count = Math.floor(totalWidth / width) + 2;
        let currentX;
        for(let i = 0; i < count; i++){
            if (i === 0 && typeof firstX !== "undefined") currentX = firstX;
            else if (i === count - 1 && typeof lastX !== "undefined") currentX = lastX;
            else currentX = x;
            (0, $2f44915f6f87dcf5$export$d183e74c32825504)(spriteId, ctx, currentX, undefined, width, undefined, offsetLeft + (leftPosShift + i * width) * multiplier, offsetTop, width, undefined, multiplier, dpi);
        }
    }
    // If street width is exceeded, fade buildings
    // Note: it would make sense to also fade out buildings when drawing large canvases but that would
    // shade in the entire background erroneously
    if (shadeIn === true) $2690ac3abe906938$var$shadeInContext(ctx);
}
/**
 * Fills the building rendered area with a color
 *
 * @param {CanvasRenderingContext2D} ctx
 */ function $2690ac3abe906938$var$shadeInContext(ctx) {
    ctx.save();
    ctx.globalCompositeOperation = "source-atop";
    // TODO const
    ctx.fillStyle = "rgba(204, 163, 173, .9)";
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.restore();
}
function $2690ac3abe906938$export$1078ade21bd4346(el, variant, position, floors, shadeIn) {
    const elementWidth = el.offsetWidth;
    // Determine building dimensions
    const building = $2690ac3abe906938$export$68f9303c71cd9a6d[variant];
    const overhangWidth = typeof building.overhangWidth === "number" ? building.overhangWidth : 0;
    const buildingHeight = $2690ac3abe906938$export$1b6ddfb770453bfd(variant, position, floors);
    // Determine canvas dimensions from building dimensions
    const width = elementWidth + overhangWidth;
    const height = Math.min($2690ac3abe906938$var$MAX_CANVAS_HEIGHT, buildingHeight);
    // Create canvas
    const canvasEl = document.createElement("canvas");
    const oldCanvasEl = el.querySelector("canvas");
    const dpi = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().system.devicePixelRatio;
    canvasEl.width = width * dpi;
    canvasEl.height = (height + $2690ac3abe906938$export$c96efbd0faab9278) * dpi;
    canvasEl.style.width = width + "px";
    canvasEl.style.height = height + $2690ac3abe906938$export$c96efbd0faab9278 + "px";
    // Replace previous canvas if present, otherwise append a new one
    if (oldCanvasEl) el.replaceChild(canvasEl, oldCanvasEl);
    else el.appendChild(canvasEl);
    const ctx = canvasEl.getContext("2d");
    $2690ac3abe906938$export$617d1ea5740d0e6f(ctx, variant, floors, position, width, height, 0, 1.0, dpi, shadeIn);
}






function $147ff5013dcadf6f$export$819db45aec5fcbe5(ctx, x1, y1, x2, y2, dpi) {
    x1 *= dpi;
    y1 *= dpi;
    x2 *= dpi;
    y2 *= dpi;
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
}
function $147ff5013dcadf6f$export$98cc1a966ac2e225(ctx, x1, y1, x2, y2, text, dpi) {
    x1 += 2;
    x2 -= 2;
    $147ff5013dcadf6f$export$819db45aec5fcbe5(ctx, x1, y1, x2, y2, dpi);
    if (text) {
        ctx.font = 12 * dpi + "px Arial";
        ctx.textAlign = "center";
        ctx.fillText(text, (x1 + x2) / 2 * dpi, y1 * dpi - 10);
    }
}





var $163a5484259277ed$exports = {};
$163a5484259277ed$exports = JSON.parse('{"day":{"name":"Day","backgroundColor":"#a9ccdb"},"twilight":{"name":"Twilight","backgroundGradient":[["#5583be",0],["#eebaa5",0.4],["#de7d8e",0.8]],"cloudOpacity":0.85},"sunset":{"name":"Sunset","enabled":false,"backgroundGradient":[["#020b1a"],["#3e5879"],["#9ba5ae"],["#dcb697"],["#fc7001"],["#dd723c"],["#ad4a28"],["#040308"]],"cloudOpacity":0.65},"dusk":{"name":"Dusk","backgroundGradient":[["#020b1a"],["#3e5879"],["#ec6127",0.5],["#ffbb65",0.7]],"cloudOpacity":0.5,"invertUITextColor":true},"sunrise":{"_comment":"Renamed to \'Dawn\'","enabled":false,"name":"Sunrise","backgroundGradient":["#a9ccdb","#b7d6fd","#fbce96",["#dd771e",0.9],"#58151a"]},"dawn":{"name":"Dawn","backgroundGradient":["#a9ccdb","#b7d6fd","#fbce96",["#dd771e",0.9],"#58151a"]},"night":{"name":"Night","iconImage":"environs--icon-night","backgroundImage":"sky--stars","_commentBackgroundColor":"Fall back to solid color in case image is broken","backgroundGradient":[["#01051600",0],["#01081777",0.33],["#031641",0.66],["#061c45",1]],"backgroundColor":"#000928","backgroundObjects":[{"image":"sky--moon","width":116,"height":116,"top":0.2,"left":0.8}],"cloudOpacity":0.2,"invertUITextColor":true},"supermoon":{"name":"Night","enabled":false,"iconImage":"environs--icon-night","backgroundImage":"sky--stars","backgroundGradient":[["#01051600",0],["#01081777",0.33],["#031641",0.66],["#061c45",1]],"backgroundColor":"#000928","backgroundObjects":[{"image":"sky--super-blood-wolf-moon","width":116,"height":116,"top":0.2,"left":0.8}],"cloudOpacity":0.2,"invertUITextColor":true},"karl":{"name":"Fog","backgroundColor":"#e2f0f2","foregroundGradient":[["rgba(255,255,255,0.85)",0],["rgba(192,192,192,0.5)",0.85],["transparent",1]]},"holodeck":{"name":"Holodeck","iconImage":"environs--icon-holodeck","backgroundColor":"#141414","backgroundImage":"sky--holodeck-grid","cloudOpacity":0,"invertUITextColor":true}}');



function $3506aa481686351c$export$c59a9ae64e82508e(array) {
    // Normalize all values
    const stops = array.map((item)=>{
        // If the value is an array, turn it into a string
        if (Array.isArray(item)) {
            const [color, position] = item;
            // Position is recorded as a value between 0 and 1, but is optional
            let percentage;
            if (position) percentage = ` ${position * 100}%`;
            return color + (percentage || "");
        }
        // Otherwise assume it's a string and return as-is
        return item;
    });
    return `linear-gradient(${stops.join(", ")})`;
}
/**
 * Converts information from environs.json to create a string that can
 * be accepted by the CSS `background` property.
 *
 * @param {String} url - path to image
 * @returns {String} - CSS value
 */ function $3506aa481686351c$var$makeCSSBackgroundImageDeclaration(url) {
    const asset = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(url);
    if (asset) return `url('${asset.src}') top/${asset.width}px repeat`;
}
/**
 * Converts information from environs.json to create a style object
 * that can be used directly in React for elements that accept the
 * style prop, e.g. `<div style={style} />`
 *
 * @param {Object} - single environs data from environs.json
 * @param {Boolean} - if `true`, add images to the style definition.
 *   Images are not good for icons where the images won't be visible
 *   and special images need to be used. Default value is `true`.
 * @returns {Object} - style object that can be passed to a `style` prop
 */ function $3506aa481686351c$var$makeReactStyleObject(env, renderImages = true) {
    const style = {};
    // If an error causes `env` to be undefined, return an empty object.
    if (!env) return style;
    const background = [];
    if (env.backgroundGradient) background.push($3506aa481686351c$export$c59a9ae64e82508e(env.backgroundGradient));
    if (renderImages) {
        if (env.backgroundImage) background.push($3506aa481686351c$var$makeCSSBackgroundImageDeclaration(env.backgroundImage));
    }
    // Background colors must occur last in the `background` list
    if (env.backgroundColor) background.push(env.backgroundColor);
    style.background = background.join(", ");
    return style;
}
function $3506aa481686351c$export$f03b9872349a4467(array) {
    // If the value is a string, wrap it in an array
    const stops = array.map((item)=>{
        if (typeof item === "string") return [
            item
        ];
        // Otherwise, return the original array, but spread it
        // so that the values are cloned. We don't want later
        // transformations to modify the original values.
        return [
            ...item
        ];
    });
    // If the first item doesn't have a stop, make it 0
    if (typeof stops[0][1] === "undefined") stops[0][1] = 0;
    // If the last item doesn't have a stop, make it 1
    if (typeof stops[stops.length - 1][1] === "undefined") stops[stops.length - 1][1] = 1;
    // Now go through each color stops and fill in missing stops
    let previousStop = stops[0][1];
    for(let i = 0; i < stops.length; i++)if (typeof previousStop !== "undefined") {
        const stop = stops[i][1];
        if (typeof stop === "undefined") {
            let n = i;
            while(typeof stops[n][1] === "undefined")n++;
            const steps = n - i + 1;
            const nextStep = stops[n][1];
            const stepSize = (nextStep - previousStop) / steps;
            for(let j = i; j < n; j++)previousStop = stops[j][1] = previousStop + stepSize;
        } else previousStop = stop;
    }
    return stops;
}
function $3506aa481686351c$export$553e874a5cd79aa6(id) {
    let env = (0, (/*@__PURE__*/$parcel$interopDefault($163a5484259277ed$exports)))[id];
    if (!env) {
        env = (0, (/*@__PURE__*/$parcel$interopDefault($163a5484259277ed$exports)))[0, $2a9a05c10189c2fe$export$cb0b75edbeba6d1a];
        id = (0, $2a9a05c10189c2fe$export$cb0b75edbeba6d1a);
    }
    return {
        ...env,
        id: id,
        style: $3506aa481686351c$var$makeReactStyleObject(env),
        iconStyle: $3506aa481686351c$var$makeReactStyleObject(env, false)
    };
}
function $3506aa481686351c$export$c69de11924434777() {
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($163a5484259277ed$exports)))).filter(([key, value])=>value.enabled !== false).map(([key, value])=>$3506aa481686351c$export$553e874a5cd79aa6(key));
}
function $3506aa481686351c$export$b3917f912083d46a() {
    const select = (state)=>({
            ...$3506aa481686351c$export$553e874a5cd79aa6(state.street.environment)
        });
    const onChange = (state)=>{
        // `invertUITextColor` may not be defined, so coerce it to `false` with Boolean()
        document.body.classList.toggle("dark-environs-invert-ui", Boolean(state.invertUITextColor));
    };
    return (0, $81878321270eabd6$export$7eabfc5ef2a68f64)(select, onChange);
}








const $0cbfb6ac69a402ec$var$BOTTOM_BACKGROUND = "rgb(216, 211, 203)";
const $0cbfb6ac69a402ec$var$BACKGROUND_DIRT_COLOUR = "rgb(53, 45, 39)";
const $0cbfb6ac69a402ec$var$SILHOUETTE_FILL_COLOUR = "rgb(240, 240, 240)";
const $0cbfb6ac69a402ec$var$SEGMENT_NAME_FONT = "Rubik";
const $0cbfb6ac69a402ec$var$SEGMENT_NAME_FONT_SIZE = 12;
const $0cbfb6ac69a402ec$var$SEGMENT_NAME_FONT_WEIGHT = "400";
const $0cbfb6ac69a402ec$var$STREET_NAME_FONT = "overpass";
const $0cbfb6ac69a402ec$var$STREET_NAME_FONT_SIZE = 70;
const $0cbfb6ac69a402ec$var$STREET_NAME_FONT_WEIGHT = "700";
const $0cbfb6ac69a402ec$var$WATERMARK_FONT = "Rubik";
const $0cbfb6ac69a402ec$var$WATERMARK_FONT_SIZE = 24;
const $0cbfb6ac69a402ec$var$WATERMARK_FONT_WEIGHT = "600";
const $0cbfb6ac69a402ec$var$WATERMARK_RIGHT_MARGIN = 15;
const $0cbfb6ac69a402ec$var$WATERMARK_BOTTOM_MARGIN = 15;
const $0cbfb6ac69a402ec$var$WATERMARK_DARK_COLOR = "#333333";
const $0cbfb6ac69a402ec$var$WATERMARK_LIGHT_COLOR = "#cccccc";
const $0cbfb6ac69a402ec$var$WORDMARK_MARGIN = 4;
/**
 * Draws sky.
 *
 * @param {CanvasRenderingContext2D} ctx - the canvas context to draw on
 * @param {Object} street - street data
 * @param {Number} width - width of area to draw
 * @param {Number} height - width of area to draw
 * @param {Number} dpi - pixel density of canvas
 * @param {Number} multiplier - scale factor of image
 * @param {Number} horizonLine - vertical height of horizon
 * @param {Number} groundLevel - vertical height of ground
 * @modifies {CanvasRenderingContext2D} ctx
 */ function $0cbfb6ac69a402ec$var$drawSky(ctx, street, width, height, dpi, multiplier, horizonLine, groundLevel) {
    const env = (0, $3506aa481686351c$export$553e874a5cd79aa6)(street.environment);
    // Solid color fill
    if (env.backgroundColor) $0cbfb6ac69a402ec$var$drawBackgroundColor(ctx, width, horizonLine, dpi, env.backgroundColor);
    // Background image fill
    if (env.backgroundImage) $0cbfb6ac69a402ec$var$drawBackgroundImage(ctx, width, height, dpi, multiplier, env.backgroundImage);
    // Gradient fill
    if (env.backgroundGradient) $0cbfb6ac69a402ec$var$drawBackgroundGradient(ctx, width, horizonLine, dpi, env.backgroundGradient);
    // Background objects
    if (env.backgroundObjects) $0cbfb6ac69a402ec$var$drawBackgroundObjects(ctx, width, height, dpi, multiplier, env.backgroundObjects);
    // Clouds
    $0cbfb6ac69a402ec$var$drawClouds(ctx, width, groundLevel, dpi, env);
}
/**
 * Draws a layer of background color
 *
 * @param {CanvasRenderingContext2D} ctx - the canvas context to draw on
 * @param {Number} width - width of area to draw
 * @param {Number} height - height of area to draw
 * @param {Number} dpi - pixel density of canvas
 * @param {string} color - color to render
 * @modifies {CanvasRenderingContext2D} ctx
 */ function $0cbfb6ac69a402ec$var$drawBackgroundColor(ctx, width, height, dpi, color) {
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, width * dpi, height * dpi);
}
/**
 * Draws background image as a repeating pattern.
 *
 * @param {CanvasRenderingContext2D} ctx - the canvas context to draw on
 * @param {Number} width - width of area to draw
 * @param {Number} height - height of area to draw
 * @param {Number} dpi - pixel density of canvas
 * @param {Object} imageId - image ID to render
 * @modifies {CanvasRenderingContext2D} ctx
 */ function $0cbfb6ac69a402ec$var$drawBackgroundImage(ctx, width, height, dpi, multiplier, imageId) {
    const img = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(imageId);
    for(let i = 0; i < Math.floor(height / img.height * multiplier) + 1; i++)for(let j = 0; j < Math.floor(width / img.width * multiplier) + 1; j++)ctx.drawImage(img.img, 0, 0, img.width, img.height, j * img.width * dpi * multiplier, i * img.height * dpi * multiplier, img.width * dpi * multiplier, img.height * dpi * multiplier);
}
/**
 * Draws background linear gradient.
 *
 * @param {CanvasRenderingContext2D} ctx - the canvas context to draw on
 * @param {Number} width - width of area to draw
 * @param {Number} height - height of area to draw
 * @param {Number} dpi - pixel density of canvas
 * @param {Array} backgroundGradient - environs definition of gradient
 * @modifies {CanvasRenderingContext2D} ctx
 */ function $0cbfb6ac69a402ec$var$drawBackgroundGradient(ctx, width, height, dpi, backgroundGradient) {
    const gradient = ctx.createLinearGradient(0, 0, 0, height * dpi);
    // Make color stops
    const stops = (0, $3506aa481686351c$export$f03b9872349a4467)(backgroundGradient);
    for(let i = 0; i < stops.length; i++){
        const [color, stop] = stops[i];
        gradient.addColorStop(stop, color);
    }
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width * dpi, height * dpi);
}
/**
 * Draws background linear gradient.
 *
 * @param {CanvasRenderingContext2D} ctx - the canvas context to draw on
 * @param {Number} width - width of area to draw
 * @param {Number} height - height of area to draw
 * @param {Number} dpi - scale factor of image
 * @param {Array} objects - environs definition of background objects
 * @modifies {CanvasRenderingContext2D} ctx
 */ function $0cbfb6ac69a402ec$var$drawBackgroundObjects(ctx, width, height, dpi, multiplier, objects) {
    objects.forEach((object)=>{
        const { image: imageId, width: imageWidth, height: imageHeight, top: top, left: left } = object;
        const image = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(imageId).img;
        ctx.drawImage(image, // Left and top values are "percentage" values
        // and sets where the center of the image is
        (left * width - imageWidth / 2) * dpi * multiplier, (top * height - imageHeight / 2) * dpi * multiplier, imageWidth * dpi * multiplier, imageHeight * dpi * multiplier);
    });
}
/**
 * Draws clouds.
 *
 * @param {CanvasRenderingContext2D} ctx - the canvas context to draw on
 * @param {Number} width - width of area to draw
 * @param {Number} height - height of area to draw
 * @param {Number} dpi - pixel density of canvas
 * @param {Object} env - environs settings
 * @modifies {CanvasRenderingContext2D} ctx
 */ function $0cbfb6ac69a402ec$var$drawClouds(ctx, width, height, dpi, env) {
    // Handle cloud opacity
    ctx.save();
    ctx.globalAlpha = env.cloudOpacity ?? 1;
    // Grab images
    const skyFrontImg = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("/images/sky-front.svg");
    const skyRearImg = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("/images/sky-rear.svg");
    // Source images are 2x what they need to be for the math to work
    // so until we resize the intrinsic size of the images, we have to
    // do this and then size it back up later
    const skyFrontWidth = skyFrontImg.width / 2;
    const skyFrontHeight = skyFrontImg.height / 2;
    const skyRearWidth = skyRearImg.width / 2;
    const skyRearHeight = skyRearImg.height / 2;
    // TODO document magic numbers
    // y1 = top edge of sky-front image
    const y1 = height - skyFrontHeight;
    for(let i = 0; i < Math.floor(width / skyFrontWidth) + 1; i++)ctx.drawImage(skyFrontImg.img, 0, 0, skyFrontWidth * 2, skyFrontHeight * 2, i * skyFrontWidth * dpi, y1 * dpi, skyFrontWidth * dpi, skyFrontHeight * dpi);
    // TODO document magic numbers
    // y2 = top edge of sky-rear is 120 pixels above the top edge of sky-front
    const y2 = height - skyFrontHeight - 120;
    for(let i = 0; i < Math.floor(width / skyRearWidth) + 1; i++)ctx.drawImage(skyRearImg.img, 0, 0, skyRearWidth * 2, skyRearHeight * 2, i * skyRearWidth * dpi, y2 * dpi, skyRearWidth * dpi, skyRearHeight * dpi);
    // Restore global opacity
    ctx.restore();
}
/**
 * Draws ground.
 *
 * @param {CanvasRenderingContext2D} ctx - the canvas context to draw on
 * @param {Object} street - street data
 * @param {Number} width - width of area to draw
 * @param {Number} dpi - pixel density of canvas
 * @param {Number} multiplier - scale factor of image
 * @param {Number} horizonLine - vertical height of horizon
 * @param {Number} groundLevel - vertical height of ground
 * @modifies {CanvasRenderingContext2D} ctx
 */ function $0cbfb6ac69a402ec$var$drawGround(ctx, street, width, dpi, multiplier, horizonLine, groundLevel) {
    ctx.fillStyle = $0cbfb6ac69a402ec$var$BACKGROUND_DIRT_COLOUR;
    ctx.fillRect(0, horizonLine * dpi, width * dpi, 25 * multiplier * dpi);
    ctx.fillRect(0, groundLevel * dpi, (width / 2 - street.width * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier / 2) * dpi, 20 * multiplier * dpi);
    ctx.fillRect((width / 2 + street.width * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier / 2) * dpi, groundLevel * dpi, width * dpi, 20 * multiplier * dpi);
}
/**
 * Draws buildings.
 *
 * @param {CanvasRenderingContext2D} ctx - the canvas context to draw on
 * @param {Object} street - street data
 * @param {Number} width - width of area to draw
 * @param {Number} dpi - pixel density of canvas
 * @param {Number} multiplier - scale factor of image
 * @param {Number} groundLevel - vertical height of ground
 * @param {Number} buildingOffsetLeft
 * @modifies {CanvasRenderingContext2D} ctx
 */ function $0cbfb6ac69a402ec$var$drawBuildings(ctx, street, width, dpi, multiplier, groundLevel, buildingOffsetLeft) {
    const buildingWidth = buildingOffsetLeft / multiplier;
    // Left building
    const x1 = width / 2 - street.width * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier / 2;
    const leftBuilding = (0, $2690ac3abe906938$export$68f9303c71cd9a6d)[street.leftBuildingVariant];
    const leftOverhang = typeof leftBuilding.overhangWidth === "number" ? leftBuilding.overhangWidth : 0;
    (0, $2690ac3abe906938$export$617d1ea5740d0e6f)(ctx, street.leftBuildingVariant, street.leftBuildingHeight, "left", buildingWidth, groundLevel, x1 - (buildingWidth - leftOverhang) * multiplier, multiplier, dpi);
    // Right building
    const x2 = width / 2 + street.width * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier / 2;
    const rightBuilding = (0, $2690ac3abe906938$export$68f9303c71cd9a6d)[street.rightBuildingVariant];
    const rightOverhang = typeof rightBuilding.overhangWidth === "number" ? rightBuilding.overhangWidth : 0;
    (0, $2690ac3abe906938$export$617d1ea5740d0e6f)(ctx, street.rightBuildingVariant, street.rightBuildingHeight, "right", buildingWidth, groundLevel, x2 - rightOverhang * multiplier, multiplier, dpi);
}
/**
 * Draws segments.
 *
 * @param {CanvasRenderingContext2D} ctx - the canvas context to draw on
 * @param {Object} street - street data
 * @param {Number} dpi - pixel density of canvas
 * @param {Number} multiplier - scale factor of image
 * @param {Number} groundLevel - vertical height of ground
 * @param {Number} offsetLeft - left position to start from
 * @modifies {CanvasRenderingContext2D} ctx
 */ function $0cbfb6ac69a402ec$var$drawSegments(ctx, street, dpi, multiplier, groundLevel, offsetLeft) {
    // Collect z-indexes
    const zIndexes = [];
    for (const segment of street.segments){
        const segmentInfo = (0, $0cc5ae9f1eba4866$export$c3985e6b9763d4c2)(segment.type);
        if (zIndexes.indexOf(segmentInfo.zIndex) === -1) zIndexes.push(segmentInfo.zIndex);
    }
    // Render objects at each z-index level
    for (const zIndex of zIndexes){
        let currentOffsetLeft = offsetLeft;
        for (const segment of street.segments){
            const segmentInfo = (0, $0cc5ae9f1eba4866$export$c3985e6b9763d4c2)(segment.type);
            if (segmentInfo.zIndex === zIndex) {
                const variantInfo = (0, $0cc5ae9f1eba4866$export$a7e4a724089e6511)(segment.type, segment.variantString);
                const dimensions = (0, $2f44915f6f87dcf5$export$ef14b8f1a495a8b9)(variantInfo, segment.width);
                const randSeed = segment.id;
                (0, $2f44915f6f87dcf5$export$23deed70993953e5)(ctx, segment.type, segment.variantString, segment.width, currentOffsetLeft + dimensions.left * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier, groundLevel, segment.elevation, randSeed, multiplier, dpi);
            }
            currentOffsetLeft += segment.width * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier;
        }
    }
}
/**
 * Draws the segment names background.
 *
 *  * Draws segments.
 *
 * @param {CanvasRenderingContext2D} ctx - the canvas context to draw on
 * @param {Number} width - width of area to draw
 * @param {Number} height - height of area to draw
 * @param {Number} dpi - pixel density of canvas
 * @param {Number} multiplier - scale factor of image
 * @param {Number} groundLevel - vertical height of ground
 * @modifies {CanvasRenderingContext2D} ctx
 */ function $0cbfb6ac69a402ec$var$drawSegmentNamesBackground(ctx, width, height, dpi, multiplier, groundLevel) {
    ctx.fillStyle = $0cbfb6ac69a402ec$var$BOTTOM_BACKGROUND;
    ctx.fillRect(0, (groundLevel + (0, $2690ac3abe906938$export$c96efbd0faab9278) * multiplier) * dpi, width * dpi, (height - groundLevel - (0, $2690ac3abe906938$export$c96efbd0faab9278) * multiplier) * dpi);
}
/**
 * Draws segment names and widths.
 *
 * @param {CanvasRenderingContext2D} ctx - the canvas context to draw on
 * @param {Number} dpi - pixel density of canvas
 * @param {Number} multiplier - scale factor of image
 * @param {Number} groundLevel - vertical height of ground
 * @param {Number} offsetLeft - left position to start from
 * @modifies {CanvasRenderingContext2D} ctx
 */ function $0cbfb6ac69a402ec$var$drawSegmentNamesAndWidths(ctx, street, dpi, multiplier, groundLevel, offsetLeft) {
    ctx.save();
    ctx.strokeStyle = "black";
    ctx.lineWidth = 0.25 * dpi;
    ctx.font = `normal ${$0cbfb6ac69a402ec$var$SEGMENT_NAME_FONT_WEIGHT} ${$0cbfb6ac69a402ec$var$SEGMENT_NAME_FONT_SIZE * dpi}px ${$0cbfb6ac69a402ec$var$SEGMENT_NAME_FONT},sans-serif`;
    ctx.fillStyle = "black";
    ctx.textAlign = "center";
    ctx.textBaseline = "top";
    for(const i in street.segments){
        const segment = street.segments[i];
        const availableWidth = segment.width * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier;
        let left = offsetLeft;
        if (i === 0) left--;
        // Left line
        (0, $147ff5013dcadf6f$export$819db45aec5fcbe5)(ctx, left, groundLevel + (0, $2690ac3abe906938$export$c96efbd0faab9278) * multiplier, left, groundLevel + 125 * multiplier, dpi);
        const x = (offsetLeft + availableWidth / 2) * dpi;
        // Width label
        let text = (0, $83fecf775ebd2a37$export$f87bc2ba75a381c)(segment.width, street.units);
        let textWidth = ctx.measureText(text).width / dpi;
        while(textWidth > availableWidth - 10 * multiplier && text.indexOf("\u200A") !== -1){
            text = text.substr(0, text.lastIndexOf("\u200A"));
            textWidth = ctx.measureText(text).width / dpi;
        }
        ctx.fillText(text, x, (groundLevel + 60 * multiplier) * dpi);
        // Segment name label
        const name = segment.label || (0, $2f44915f6f87dcf5$export$d5e75d6299e9897e)(segment.type, segment.variantString);
        const nameWidth = ctx.measureText(name).width / dpi;
        if (nameWidth <= availableWidth - 10 * multiplier) ctx.fillText(name, x, (groundLevel + 83 * multiplier) * dpi);
        offsetLeft += availableWidth;
    }
    // Final right-hand side line
    const left = offsetLeft + 1;
    (0, $147ff5013dcadf6f$export$819db45aec5fcbe5)(ctx, left, groundLevel + (0, $2690ac3abe906938$export$c96efbd0faab9278) * multiplier, left, groundLevel + 125 * multiplier, dpi);
    ctx.restore();
}
/**
 * Turns drawn objects on canvas into a single-colour silhouette
 *
 * @param {CanvasRenderingContext2D} ctx - the canvas context to draw on
 * @param {Number} width - width of area to draw
 * @param {Number} height - height of area to draw
 * @param {Number} dpi - pixel density of canvas
 * @modifies {CanvasRenderingContext2D} ctx
 */ function $0cbfb6ac69a402ec$var$drawSilhouette(ctx, width, height, dpi) {
    ctx.globalCompositeOperation = "source-atop";
    ctx.fillStyle = $0cbfb6ac69a402ec$var$SILHOUETTE_FILL_COLOUR;
    ctx.fillRect(0, 0, width * dpi, height * dpi);
}
/**
 * Draws street nameplate
 *
 * @param {CanvasRenderingContext2D} ctx - the canvas context to draw on
 * @param {Object} street - street data
 * @param {Number} width - width of area to draw
 * @param {Number} dpi - pixel density of canvas
 * @modifies {CanvasRenderingContext2D} ctx
 */ function $0cbfb6ac69a402ec$var$drawStreetNameplate(ctx, street, width, dpi) {
    let text = street.name || (0, $4daaf0496059b305$export$25868d1e8e76735f)("street.default-name", "Unnamed St");
    ctx.textAlign = "center";
    ctx.textBaseline = "center";
    ctx.font = `normal ${$0cbfb6ac69a402ec$var$STREET_NAME_FONT_WEIGHT} ${$0cbfb6ac69a402ec$var$STREET_NAME_FONT_SIZE * dpi}px ${$0cbfb6ac69a402ec$var$STREET_NAME_FONT},sans-serif`;
    // Handles long names
    let measurement = ctx.measureText(text);
    let needToBeElided = false;
    while(measurement.width > (width - 200) * dpi){
        text = text.substr(0, text.length - 1);
        measurement = ctx.measureText(text);
        needToBeElided = true;
    }
    if (needToBeElided) text += "\u2026";
    // Street nameplate
    ctx.fillStyle = "white";
    const x1 = width * dpi / 2 - (measurement.width / 2 + 45 * dpi);
    const x2 = width * dpi / 2 + (measurement.width / 2 + 45 * dpi);
    const y1 = 15 * dpi;
    const y2 = 135 * dpi;
    ctx.fillRect(x1, y1, x2 - x1, y2 - y1);
    // Street nameplate border
    ctx.strokeStyle = "black";
    ctx.lineWidth = 5 * dpi;
    ctx.strokeRect(x1 + 5 * dpi * 2, y1 + 5 * dpi * 2, x2 - x1 - 5 * dpi * 4, y2 - y1 - 5 * dpi * 4);
    const x = width * dpi / 2;
    const baselineCorrection = 27;
    const y = (75 + baselineCorrection) * dpi;
    ctx.strokeStyle = "transparent";
    ctx.fillStyle = "black";
    ctx.fillText(text, x, y);
}
/**
 * Draws a "made with Streetmix" watermark on the lower right of the image.
 *
 * @todo Make it work with rtl
 * @param {CanvasRenderingContext2D} ctx - the canvas context to draw on.
 * @param {Number} dpi - pixel density of canvas
 * @param {Boolean} invert - if `true`, render light text for dark background
 * @modifies {CanvasRenderingContext2D}
 */ function $0cbfb6ac69a402ec$var$drawWatermark(ctx, dpi, invert = false) {
    const text = (0, $4daaf0496059b305$export$25868d1e8e76735f)("export.watermark", "Made with {streetmixWordmark}", {
        // Replace the {placeholder} with itself. Later, this is used to
        // render the logo image in place of the text.
        streetmixWordmark: "{streetmixWordmark}"
    });
    const wordmarkImage = invert ? (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("/images/wordmark_white.svg") : (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("/images/wordmark_black.svg");
    // Separate string so that we can render a wordmark with an image
    const strings = text.replace(/{/g, "||{").replace(/}/g, "}||").split("||");
    // Set text render options
    ctx.textAlign = "right";
    ctx.textBaseline = "alphabetic";
    ctx.font = `normal ${$0cbfb6ac69a402ec$var$WATERMARK_FONT_WEIGHT} ${$0cbfb6ac69a402ec$var$WATERMARK_FONT_SIZE * dpi}px ${$0cbfb6ac69a402ec$var$WATERMARK_FONT},sans-serif`;
    ctx.fillStyle = invert ? $0cbfb6ac69a402ec$var$WATERMARK_LIGHT_COLOR : $0cbfb6ac69a402ec$var$WATERMARK_DARK_COLOR;
    // Set starting X/Y positions so that watermark is aligned right and bottom of image
    const startRightX = ctx.canvas.width - $0cbfb6ac69a402ec$var$WATERMARK_RIGHT_MARGIN * dpi;
    const startBottomY = ctx.canvas.height - $0cbfb6ac69a402ec$var$WATERMARK_BOTTOM_MARGIN * dpi;
    // Set wordmark width and height based on image scale (dpi)
    const logoWidth = wordmarkImage.width * dpi;
    const logoHeight = wordmarkImage.height * dpi;
    // Keep track of where we are on the X-position.
    let currentRightX = startRightX;
    // Render each part of the string.
    for(let i = strings.length - 1; i >= 0; i--){
        const string = strings[i];
        // If we see the wordmark placeholder, render the image.
        if (string === "{streetmixWordmark}") {
            const margin = $0cbfb6ac69a402ec$var$WORDMARK_MARGIN * dpi;
            const logoLeftX = currentRightX - logoWidth - margin;
            const logoTopY = startBottomY - logoHeight + dpi // Additional adjustment for visual alignment
            ;
            ctx.drawImage(wordmarkImage.img, logoLeftX, logoTopY, logoWidth, logoHeight);
            // Update X position.
            currentRightX = logoLeftX - margin;
        } else {
            ctx.fillText(string, currentRightX, startBottomY);
            // Update X position.
            currentRightX = currentRightX - ctx.measureText(string).width;
        }
    }
}
function $0cbfb6ac69a402ec$export$c20d51295249d0f5(ctx, street, { width: width, height: height, dpi: dpi, multiplier: multiplier, silhouette: silhouette, bottomAligned: bottomAligned, transparentSky: transparentSky, segmentNamesAndWidths: segmentNamesAndWidths, streetName: streetName, watermark: watermark = true }) {
    // Calculations
    // Determine how wide the street is
    let occupiedWidth = 0;
    for (const segment of street.segments)occupiedWidth += segment.width;
    let offsetTop;
    if (bottomAligned) offsetTop = height - 180 * multiplier;
    else offsetTop = (height + 5 * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier) / 2;
    if (segmentNamesAndWidths) offsetTop -= (0, $464cf4d7282b8d55$export$2f79f1d2061e5ebd) * multiplier;
    const offsetLeft = (width - occupiedWidth * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier) / 2;
    const buildingOffsetLeft = (width - street.width * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier) / 2;
    const groundLevel = offsetTop + 135 * multiplier;
    const horizonLine = groundLevel + 20 * multiplier;
    // Sky
    if (!transparentSky) $0cbfb6ac69a402ec$var$drawSky(ctx, street, width, height, dpi, multiplier, horizonLine, groundLevel);
    // Ground
    $0cbfb6ac69a402ec$var$drawGround(ctx, street, width, dpi, multiplier, horizonLine, groundLevel);
    // Buildings
    $0cbfb6ac69a402ec$var$drawBuildings(ctx, street, width, dpi, multiplier, groundLevel, buildingOffsetLeft);
    // Segments
    $0cbfb6ac69a402ec$var$drawSegments(ctx, street, dpi, multiplier, groundLevel, offsetLeft);
    // Segment names background
    if (segmentNamesAndWidths || silhouette) $0cbfb6ac69a402ec$var$drawSegmentNamesBackground(ctx, width, height, dpi, multiplier, groundLevel);
    // Segment names
    if (segmentNamesAndWidths) $0cbfb6ac69a402ec$var$drawSegmentNamesAndWidths(ctx, street, dpi, multiplier, groundLevel, offsetLeft);
    // Silhouette
    if (silhouette) $0cbfb6ac69a402ec$var$drawSilhouette(ctx, width, height, dpi);
    // Street nameplate
    if (streetName) $0cbfb6ac69a402ec$var$drawStreetNameplate(ctx, street, width, dpi);
    // Watermark
    if (watermark) $0cbfb6ac69a402ec$var$drawWatermark(ctx, dpi, !segmentNamesAndWidths);
}



// This can be adjusted to create much more hi-definition images
const $464cf4d7282b8d55$var$SAVE_AS_IMAGE_DPI = 2.0;
const $464cf4d7282b8d55$var$SAVE_AS_IMAGE_MIN_HEIGHT = 400;
const $464cf4d7282b8d55$var$SAVE_AS_IMAGE_MIN_HEIGHT_WITH_STREET_NAME = $464cf4d7282b8d55$var$SAVE_AS_IMAGE_MIN_HEIGHT + 150;
const $464cf4d7282b8d55$var$SAVE_AS_IMAGE_BOTTOM_PADDING = 60;
const $464cf4d7282b8d55$export$2f79f1d2061e5ebd = 65;
function $464cf4d7282b8d55$export$1948dfdf2eab675b(street, transparentSky, segmentNamesAndWidths, streetName, dpi = $464cf4d7282b8d55$var$SAVE_AS_IMAGE_DPI, watermark = true) {
    const width = (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * street.width + (0, $e1cc3cddc7acf1a4$export$8b837123dd5f6a79) * 2;
    const leftHeight = (0, $2690ac3abe906938$export$1b6ddfb770453bfd)(street.leftBuildingVariant, "left", street.leftBuildingHeight);
    const rightHeight = (0, $2690ac3abe906938$export$1b6ddfb770453bfd)(street.rightBuildingVariant, "right", street.rightBuildingHeight);
    let height = Math.max(leftHeight, rightHeight);
    if (height < $464cf4d7282b8d55$var$SAVE_AS_IMAGE_MIN_HEIGHT) height = $464cf4d7282b8d55$var$SAVE_AS_IMAGE_MIN_HEIGHT;
    if (streetName && height < $464cf4d7282b8d55$var$SAVE_AS_IMAGE_MIN_HEIGHT_WITH_STREET_NAME) height = $464cf4d7282b8d55$var$SAVE_AS_IMAGE_MIN_HEIGHT_WITH_STREET_NAME;
    height += $464cf4d7282b8d55$var$SAVE_AS_IMAGE_BOTTOM_PADDING;
    if (segmentNamesAndWidths) height += $464cf4d7282b8d55$export$2f79f1d2061e5ebd;
    const el = document.createElement("canvas");
    el.width = width * dpi;
    el.height = height * dpi;
    const ctx = el.getContext("2d");
    (0, $0cbfb6ac69a402ec$export$c20d51295249d0f5)(ctx, street, {
        width: width,
        height: height,
        dpi: dpi,
        multiplier: 1.0,
        silhouette: false,
        bottomAligned: true,
        transparentSky: transparentSky,
        segmentNamesAndWidths: segmentNamesAndWidths,
        streetName: streetName,
        watermark: watermark
    });
    return el;
}
// Save thumbnail if necessary every 30 minutes (1800000 ms)
const $464cf4d7282b8d55$var$SAVE_THUMBNAIL_TIME_INTERVAL = 1800000;
let $464cf4d7282b8d55$var$_lastSavedTimestamp;
const $464cf4d7282b8d55$export$58b08e286bcfe4aa = {
    INITIAL: "INITIAL",
    SHARE: "SHARE",
    TIMER: "TIMER",
    BEFOREUNLOAD: "BEFOREUNLOAD",
    PREVIOUS_STREET: "PREVIOUS_STREET"
};
function $464cf4d7282b8d55$export$b97fb1447d437ad4() {
    // return _savedThumbnail
    return true;
}
function $464cf4d7282b8d55$export$bbdde34c424fcda1() {
    // Save street thumbnail on initial street render.
    $464cf4d7282b8d55$export$aa778ba3835fe593((0, $8d9791e5769125e5$export$c5cc62253c2d0728)((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street), $464cf4d7282b8d55$export$58b08e286bcfe4aa.INITIAL);
    const select = (state)=>{
        const street = {
            editCount: state.street.editCount,
            id: state.street.id
        };
        return JSON.stringify(street);
    };
    const onChange = ()=>{
        const timestamp = Date.now();
        const timeElapsed = timestamp - $464cf4d7282b8d55$var$_lastSavedTimestamp;
        // _savedThumbnail = false
        // Save street thumbnail every 30 minutes if any changes to street.
        if (timeElapsed && timeElapsed >= $464cf4d7282b8d55$var$SAVE_THUMBNAIL_TIME_INTERVAL) {
            const street = (0, $8d9791e5769125e5$export$c5cc62253c2d0728)((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street);
            $464cf4d7282b8d55$export$aa778ba3835fe593(street, $464cf4d7282b8d55$export$58b08e286bcfe4aa.TIMER);
        }
    };
    return (0, $81878321270eabd6$export$7eabfc5ef2a68f64)(select, onChange);
}
async function $464cf4d7282b8d55$export$aa778ba3835fe593(street, event) {
// if (_savedThumbnail) return
// _lastSavedTimestamp = Date.now()
// const thumbnail = getStreetImage(street, false, false, true, 2.0, false)
// try {
//   // .toDataURL is not available on IE11 when SVGs are part of the canvas.
//   const dataUrl = thumbnail.toDataURL('image/png')
//   const details = {
//     image: dataUrl,
//     event,
//     editCount: street.editCount,
//     creatorId: street.creatorId
//   }
//   // Check if street is default or empty street.
//   // If a signed-in user adopts an existing street, the editCount is set to 0 even if it isn't a DEFAULT or EMPTY street.
//   // Only if the street has an editCount = 0 and has no originalStreetId, should we set the streetType.
//   if (street.editCount === 0 && !street.originalStreetId) {
//     const streetType = (street.segments.length) ? 'DEFAULT_STREET' : 'EMPTY_STREET'
//     details.streetType = streetType
//   }
//   const url = '/api/v1/streets/' + street.id + '/images'
//   const options = {
//     method: 'POST',
//     body: JSON.stringify(details),
//     headers: {
//       'Content-Type': 'text/plain'
//     }
//   }
//   const response = await window.fetch(url, options)
//   if (response.ok) {
//     console.log('Updated street thumbnail.')
//     _savedThumbnail = true
//   } else {
//     const results = await response.json()
//     // For now, we are only saving street thumbnails once (when the street first renders)
//     // Any other situation (i.e. timer, share menu) returns an error that does not need to be logged.
//     if (results.status !== 501) {
//       throw new Error(results.msg)
//     }
//   }
// } catch (err) {
//   console.log('Unable to save street thumbnail. ', err)
// }
}
async function $464cf4d7282b8d55$export$57c112dfb3650dff(streetId) {
    try {
        // As this function returns a Promise, awaiting it allows rejected
        // Promises to be caught by the `catch` block below.
        await (0, $4ff1018a457d25d0$export$117f21e29661dcff)(streetId);
    } catch (error) {
        console.error("Unable to delete street thumbnail.", error);
    }
}


const $a7e2543fa152618e$var$SAVE_STREET_DELAY = 500;
let $a7e2543fa152618e$var$saveStreetTimerId = -1;
let $a7e2543fa152618e$var$saveStreetIncomplete = false;
function $a7e2543fa152618e$export$3cd29177e30262af() {
    return $a7e2543fa152618e$var$saveStreetIncomplete;
}
function $a7e2543fa152618e$export$19a1b332b364071c(value) {
    $a7e2543fa152618e$var$saveStreetIncomplete = value;
}
let $a7e2543fa152618e$var$latestRequestId;
async function $a7e2543fa152618e$export$2d2f36bd3726f30a() {
    const settings = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().settings;
    if (settings.newStreetPreference === (0, $2a9a05c10189c2fe$export$fe67c041c7fe7c2)) (0, $8d9791e5769125e5$export$a221a6108238e80d)();
    else (0, $8d9791e5769125e5$export$cc66adb823d23a6)();
    const transmission = $a7e2543fa152618e$export$b2a47c65bb51f942();
    (0, $4ff1018a457d25d0$export$7a037a213e933b06)(transmission).then($a7e2543fa152618e$var$receiveNewStreet).catch($a7e2543fa152618e$var$errorReceiveNewStreet);
}
function $a7e2543fa152618e$var$receiveNewStreet({ data: data }) {
    $a7e2543fa152618e$export$e789544db07f16ef(data.id, data.namespacedId);
    $a7e2543fa152618e$export$6d965942225efd51(true);
}
function $a7e2543fa152618e$var$errorReceiveNewStreet({ response: response }) {
    if (response.status === 401) (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).AUTH_EXPIRED, true);
    else (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).NEW_STREET_SERVER_FAILURE, true);
}
async function $a7e2543fa152618e$export$69c14310aee1f1aa() {
    const street = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    try {
        const response = await (0, $4ff1018a457d25d0$export$1a6b3c65eaa634f4)(street.creatorId, street.namespacedId);
        $a7e2543fa152618e$var$receiveStreet(response.data);
    } catch (error) {
        $a7e2543fa152618e$var$errorReceiveStreet(error);
    }
}
function $a7e2543fa152618e$var$errorReceiveStreet(error) {
    const data = error.response.data;
    const mode = (0, $20dec064f3771e9c$export$1fc0f6205829e19c)();
    if (mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).CONTINUE || mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).USER_GALLERY || mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).GLOBAL_GALLERY) (0, $f3d8f18722148e05$export$a22ca88ad1ac21dd)();
    else if (data.status === 404 || data.status === 410) {
        if ((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street.creatorId) {
            if (data.status === 410) (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).STREET_410_BUT_LINK_TO_USER);
            else (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).STREET_404_BUT_LINK_TO_USER);
        } else (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).STREET_404);
        // TODO swap for showError (here and elsewhere)
        (0, $20dec064f3771e9c$export$eb2f560d6088705b)();
    } else (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).NEW_STREET_SERVER_FAILURE, true);
}
function $a7e2543fa152618e$export$6d965942225efd51(initial) {
    if ((0, $9bf07f90c2c537c3$export$729c8b7179294ba).readOnly) return;
    const transmission = $a7e2543fa152618e$export$b2a47c65bb51f942();
    const street = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    (0, $4ff1018a457d25d0$export$b77a954a15cadc5a)(street.id, transmission).then(()=>{
        $a7e2543fa152618e$export$19a1b332b364071c(false);
        if (initial) $a7e2543fa152618e$var$confirmSaveStreetToServerInitial();
    });
}
function $a7e2543fa152618e$var$confirmSaveStreetToServerInitial() {
    (0, $09d66509dd0bbd69$export$a61c8ed8b4f8b308)(true);
    (0, $09d66509dd0bbd69$export$2e099ed765eee04b)();
}
function $a7e2543fa152618e$var$clearScheduledSavingStreetToServer() {
    window.clearTimeout($a7e2543fa152618e$var$saveStreetTimerId);
}
async function $a7e2543fa152618e$export$4f8b1ea2fe2a665e() {
    // Don’t do it with any network services pending
    // NOTE: this used to check for all nonblocking requests,
    // but this system is getting refactored away -- so we're
    // not really checking against all pending requests anymore.
    if ((0, $ec6ccb5735a32e28$export$81d426b48108b404)() || $a7e2543fa152618e$var$saveStreetIncomplete || (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().errors.abortEverything || (0, $838500e3591ab346$export$210b982e99667452)()) return;
    $a7e2543fa152618e$var$latestRequestId = Date.now();
    const streetId = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street.id;
    try {
        const response = await (0, $4ff1018a457d25d0$export$2dd550e2c4d39aa8)(streetId, {
            headers: {
                "x-streetmix-request-id": $a7e2543fa152618e$var$latestRequestId
            }
        });
        // Response headers are lower-case via Axios
        const requestId = response.headers["x-streetmix-request-id"];
        // Throw an error if response is stale
        if ($a7e2543fa152618e$var$latestRequestId !== Number.parseInt(requestId, 10)) throw new Error("1");
        // Handle response data
        $a7e2543fa152618e$var$receiveStreetForVerification(response.data);
    } catch (error) {
        // Silently throw away stale responses
        if (error.message === "1") return;
        // Otherwise, handle the error
        console.log(error);
        $a7e2543fa152618e$var$errorReceiveStreetForVerification(error.response);
    }
}
/**
 * Compare the `clientUpdatedAt` value of local data to server data.
 * We don't use `updatedAt` which is only updated on the server. We use
 * `clientUpdatedAt` which is only used to validate the age of local data.
 * If local data is outdated, then we replace it with the updated data.
 *
 * @param {Object} transmission - server data
 */ function $a7e2543fa152618e$var$receiveStreetForVerification(transmission) {
    const localUpdatedAt = new Date((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street.clientUpdatedAt);
    const serverUpdatedAt = new Date(transmission.clientUpdatedAt);
    if (serverUpdatedAt && localUpdatedAt && serverUpdatedAt > localUpdatedAt) {
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ed796acc6691d871$export$2cb648f4e71e8121)({
            method: "warning",
            message: (0, $4daaf0496059b305$export$25868d1e8e76735f)("toast.reloaded", "Your street was reloaded from the server as it was modified elsewhere.")
        }));
        (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).suppress();
        $a7e2543fa152618e$export$1ab2b4c3ab16ec32(transmission, null, null, false);
        // Update everything, but don't re-save the street to the server,
        // which will re-invalidate the local copy.
        (0, $8d9791e5769125e5$export$a816daed016d4c40)(true, false);
    }
}
function $a7e2543fa152618e$var$errorReceiveStreetForVerification(data) {
    // 404 should never happen here, since 410 designates streets that have
    // been deleted (but remain hidden on the server)
    if ((0, $9be7409470745503$export$1ae390d25d018ea4)() && (data.status === 404 || data.status === 410)) (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).STREET_DELETED_ELSEWHERE, true);
}
function $a7e2543fa152618e$var$receiveStreet(transmission) {
    $a7e2543fa152618e$export$1ab2b4c3ab16ec32(transmission, null, null, true);
    (0, $09d66509dd0bbd69$export$a61c8ed8b4f8b308)(true);
    // Legacy - remove once everything is Promise-based.
    (0, $09d66509dd0bbd69$export$2e099ed765eee04b)();
}
function $a7e2543fa152618e$var$unpackStreetDataFromServerTransmission(transmission) {
    // Catch a data error where a user's street might be retrieved
    // without any data in it (so-called error 9B)
    if (!transmission.data) {
        (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).STREET_DATA_FAILURE);
        return;
    }
    const street = (0, $762e491bbbc71e6b$export$2e2bcd8739ae039)(transmission.data.street);
    street.creatorId = transmission.creatorId || null;
    street.originalStreetId = transmission.originalStreetId || null;
    street.updatedAt = transmission.updatedAt || null;
    street.clientUpdatedAt = transmission.clientUpdatedAt || null;
    street.name = transmission.name || null;
    street.location = transmission.data.street.location || null;
    // FIXME just read it and do 0 otherwise
    if (typeof transmission.data.street.editCount === "undefined") // console.log('editCount read is empty')
    street.editCount = null;
    else street.editCount = transmission.data.street.editCount;
    return street;
}
function $a7e2543fa152618e$export$1ab2b4c3ab16ec32(transmission, id, namespacedId, checkIfNeedsToBeRemixed) {
    const street = $a7e2543fa152618e$var$unpackStreetDataFromServerTransmission(transmission);
    let updatedSchema = (0, $8d9791e5769125e5$export$40f838ff08fe7f5d)(street);
    const undoStack = (0, $b66cc4ceae9b725e$export$11e81b241ba16333)();
    for(let i = 0; i < undoStack.length; i++)if ((0, $8d9791e5769125e5$export$40f838ff08fe7f5d)(undoStack[i])) updatedSchema = true;
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$abace6e40841f465)(street));
    if (transmission.data.undoStack) (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $0e3fada570e844f5$export$608c067bf56d9e0)({
        stack: (0, $762e491bbbc71e6b$export$2e2bcd8739ae039)(transmission.data.undoStack),
        position: transmission.data.undoPosition
    }));
    else (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $0e3fada570e844f5$export$bedafa63ac02a207)());
    if (id) $a7e2543fa152618e$export$e789544db07f16ef(id, namespacedId);
    else $a7e2543fa152618e$export$e789544db07f16ef(transmission.id, transmission.namespacedId);
    if (checkIfNeedsToBeRemixed) {
        if (!(0, $9be7409470745503$export$1ae390d25d018ea4)() || street.creatorId !== (0, $9be7409470745503$export$6e84777bbb4941aa)().userId) (0, $838500e3591ab346$export$39d63917f0c88400)(true);
        else (0, $838500e3591ab346$export$39d63917f0c88400)(false);
        if (updatedSchema && !(0, $838500e3591ab346$export$210b982e99667452)()) $a7e2543fa152618e$export$6d965942225efd51();
    }
}
function $a7e2543fa152618e$export$b2a47c65bb51f942() {
    const data = {};
    data.street = (0, $8d9791e5769125e5$export$c5cc62253c2d0728)((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street);
    // Those go above data in the structure, so they need to be cleared here
    delete data.street.name;
    delete data.street.originalStreetId;
    delete data.street.updatedAt;
    delete data.street.clientUpdatedAt;
    // This will be implied through authorization header
    delete data.street.creatorId;
    if ((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().flags.SAVE_UNDO.value === true) {
        data.undoStack = (0, $762e491bbbc71e6b$export$2e2bcd8739ae039)((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().undo.stack);
        data.undoPosition = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().undo.position;
    }
    const street = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    const transmission = {
        name: street.name,
        originalStreetId: street.originalStreetId,
        data: data,
        clientUpdatedAt: street.clientUpdatedAt
    };
    return transmission;
}
function $a7e2543fa152618e$export$adb3c13aa3612943() {
    const transmission = $a7e2543fa152618e$export$b2a47c65bb51f942();
    return JSON.stringify(transmission);
}
function $a7e2543fa152618e$export$e789544db07f16ef(newId, newNamespacedId) {
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$750a818a04268f3)(newId, newNamespacedId));
    (0, $b66cc4ceae9b725e$export$6e81a82123b449bb)();
    $a7e2543fa152618e$export$109830048ac00593();
}
function $a7e2543fa152618e$export$109830048ac00593() {
    const street = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $91ffa8e8b26e8ad0$export$f558026a994b6051)({
        lastStreetId: street.id,
        lastStreetNamespacedId: street.namespacedId,
        lastStreetCreatorId: street.creatorId
    }));
}
function $a7e2543fa152618e$export$43e18255cf2aefbc() {
    $a7e2543fa152618e$var$saveStreetIncomplete = true;
    $a7e2543fa152618e$var$clearScheduledSavingStreetToServer();
    if ((0, $838500e3591ab346$export$210b982e99667452)()) (0, $838500e3591ab346$export$6658ad06634d906a)();
    else $a7e2543fa152618e$var$saveStreetTimerId = window.setTimeout(function() {
        $a7e2543fa152618e$export$6d965942225efd51(false);
    }, $a7e2543fa152618e$var$SAVE_STREET_DELAY);
}
function $a7e2543fa152618e$export$335b7f5f1cc4de5() {
    const streetId = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().app.priorLastStreetId;
    (0, $ec6ccb5735a32e28$export$1d38de5ce0ec4945)("load", {
        // TODO const
        url: "/api/v1/streets/" + streetId,
        method: "GET"
    }, $a7e2543fa152618e$var$receiveLastStreet, $a7e2543fa152618e$var$cancelReceiveLastStreet);
}
function $a7e2543fa152618e$var$cancelReceiveLastStreet() {
    (0, $8a3f808dfa88cc0c$export$b1486147269f520a)();
}
function $a7e2543fa152618e$var$receiveLastStreet(transmission) {
    (0, $8d9791e5769125e5$export$996926525e13f61e)(true);
    const street = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    $a7e2543fa152618e$export$1ab2b4c3ab16ec32(transmission, street.id, street.namespacedId, false);
    const priorLastStreetId = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().app.priorLastStreetId;
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$2d8fcfbae302074f)(priorLastStreetId));
    (0, $838500e3591ab346$export$6c06397a3b45b6d0)();
    if ((0, $9be7409470745503$export$1ae390d25d018ea4)()) (0, $8d9791e5769125e5$export$a6cf4b5bbe4714cf)((0, $9be7409470745503$export$6e84777bbb4941aa)().userId);
    else (0, $8d9791e5769125e5$export$a6cf4b5bbe4714cf)(null);
    (0, $8d9791e5769125e5$export$4cb3d51df0d60a35)();
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$1cc6e452ae697b42)(0));
    // console.log('editCount = 0 on last street!')
    // COMMENT - update street state to change originalStreetId above;
    // now have to update again to change edit count - how to fix?
    (0, $b66cc4ceae9b725e$export$6e81a82123b449bb)();
    (0, $2f44915f6f87dcf5$export$b2eeaeff46616de5)();
    (0, $8d9791e5769125e5$export$996926525e13f61e)(false);
    (0, $8d9791e5769125e5$export$ed20678efa7800e4)();
    $a7e2543fa152618e$export$6d965942225efd51(false);
}
function $a7e2543fa152618e$export$f3d0bdebcf71c93b(id) {
    (0, $4ff1018a457d25d0$export$2f7a71aad44a0498)(id);
    // Delete street thumbnail from Cloudinary.
    // TODO: handle this from the backend!
    (0, $464cf4d7282b8d55$export$57c112dfb3650dff)(id);
    // Prevents new street submenu from showing the last street
    const settings = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().settings;
    if (settings.lastStreetId === id) (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $91ffa8e8b26e8ad0$export$f558026a994b6051)({
        lastStreetId: null,
        lastStreetCreatorId: null,
        lastStreetNamespacedId: null
    }));
}


const $838500e3591ab346$var$STREET_NAME_REMIX_SUFFIX = "(remix)";
let $838500e3591ab346$var$remixOnFirstEdit = false;
function $838500e3591ab346$export$210b982e99667452() {
    return $838500e3591ab346$var$remixOnFirstEdit;
}
function $838500e3591ab346$export$39d63917f0c88400(value) {
    $838500e3591ab346$var$remixOnFirstEdit = value;
}
// Auto “promote” (remix) the street if you just signed in and the street
// was anonymous
let $838500e3591ab346$var$promoteStreet = false;
function $838500e3591ab346$export$7dd404efba2534f8() {
    return $838500e3591ab346$var$promoteStreet;
}
function $838500e3591ab346$export$241049b71dea1a83(value) {
    $838500e3591ab346$var$promoteStreet = value;
}
function $838500e3591ab346$export$6658ad06634d906a() {
    let dontAddSuffix;
    if ((0, $9bf07f90c2c537c3$export$729c8b7179294ba).readOnly) return;
    $838500e3591ab346$var$remixOnFirstEdit = false;
    if ((0, $9be7409470745503$export$1ae390d25d018ea4)()) (0, $8d9791e5769125e5$export$a6cf4b5bbe4714cf)((0, $9be7409470745503$export$6e84777bbb4941aa)().userId);
    else (0, $8d9791e5769125e5$export$a6cf4b5bbe4714cf)(null);
    const street = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$2d8fcfbae302074f)(street.id));
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$1cc6e452ae697b42)(0));
    (0, $b66cc4ceae9b725e$export$6e81a82123b449bb)();
    const undoStack = (0, $b66cc4ceae9b725e$export$11e81b241ba16333)();
    const undoPosition = (0, $b66cc4ceae9b725e$export$57e3eed88cb66286)();
    if (undoStack[undoPosition - 1] && undoStack[undoPosition - 1].name !== street.name) // The street was remixed as a result of editing its name. Don’t be
    // a douche and add (remixed) to it then.
    dontAddSuffix = true;
    else dontAddSuffix = false;
    if (!$838500e3591ab346$var$promoteStreet && !dontAddSuffix) $838500e3591ab346$export$6c06397a3b45b6d0();
    const transmission = (0, $a7e2543fa152618e$export$adb3c13aa3612943)();
    (0, $ec6ccb5735a32e28$export$1d38de5ce0ec4945)("remix", {
        // TODO const
        url: "/api/v1/streets",
        method: "POST",
        body: transmission,
        credentials: "include",
        headers: {
            "Content-Type": "application/json"
        }
    }, $838500e3591ab346$var$receiveRemixedStreet);
}
function $838500e3591ab346$var$receiveRemixedStreet(data) {
    if (!$838500e3591ab346$var$promoteStreet) {
        if ((0, $9be7409470745503$export$1ae390d25d018ea4)()) (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ed796acc6691d871$export$2cb648f4e71e8121)({
            message: (0, $4daaf0496059b305$export$25868d1e8e76735f)("toast.remixing", "Now editing a freshly-made duplicate of the original street. The duplicate has been put in your gallery.")
        }));
        else (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ed796acc6691d871$export$2cb648f4e71e8121)({
            message: (0, $4daaf0496059b305$export$25868d1e8e76735f)("toast.remixing-sign-in", "Now editing a freshly-made duplicate of the original street. Sign in to start your own gallery of streets."),
            component: "TOAST_SIGN_IN",
            duration: 12000
        }));
    }
    (0, $a7e2543fa152618e$export$e789544db07f16ef)(data.id, data.namespacedId);
    (0, $a7e2543fa152618e$export$6d965942225efd51)(false);
}
function $838500e3591ab346$export$6c06397a3b45b6d0() {
    const street = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    // Bail if street is unnamed
    if (!street.name) return;
    if (street.name.substr(street.name.length - $838500e3591ab346$var$STREET_NAME_REMIX_SUFFIX.length, $838500e3591ab346$var$STREET_NAME_REMIX_SUFFIX.length) !== $838500e3591ab346$var$STREET_NAME_REMIX_SUFFIX) {
        const newStreetName = street.name + " " + $838500e3591ab346$var$STREET_NAME_REMIX_SUFFIX;
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$eb36756120db063a)(newStreetName, false));
    }
}










var $952fa6927178102c$export$2e2bcd8739ae039 = $952fa6927178102c$var$debounce;
function $952fa6927178102c$var$debounce(fn, wait, callFirst) {
    var timeout = null;
    var debouncedFn = null;
    var clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            debouncedFn = null;
            timeout = null;
        }
    };
    var flush = function() {
        var call = debouncedFn;
        clear();
        if (call) call();
    };
    var debounceWrapper = function() {
        if (!wait) return fn.apply(this, arguments);
        var context = this;
        var args = arguments;
        var callNow = callFirst && !timeout;
        clear();
        debouncedFn = function() {
            fn.apply(context, args);
        };
        timeout = setTimeout(function() {
            timeout = null;
            if (!callNow) {
                var call = debouncedFn;
                debouncedFn = null;
                return call();
            }
        }, wait);
        if (callNow) return debouncedFn();
    };
    debounceWrapper.cancel = clear;
    debounceWrapper.flush = flush;
    return debounceWrapper;
}








const $ace8e83c2a1e413b$var$LOCAL_STORAGE_SETTINGS_ID = "settings";
const $ace8e83c2a1e413b$var$SAVE_SETTINGS_DELAY = 500;
function $ace8e83c2a1e413b$export$54453bb1ffd2fd71() {
    // Get server settings.
    let serverSettings = {};
    const signInData = (0, $9be7409470745503$export$6e84777bbb4941aa)();
    if ((0, $9be7409470745503$export$1ae390d25d018ea4)() && signInData.details) serverSettings = signInData.details.data;
    // Get local settings.
    // Skip this if localStorage is corrupted
    let localSettings = {};
    try {
        if (window.localStorage.getItem($ace8e83c2a1e413b$var$LOCAL_STORAGE_SETTINGS_ID)) localSettings = JSON.parse(window.localStorage.getItem($ace8e83c2a1e413b$var$LOCAL_STORAGE_SETTINGS_ID));
    } catch (err) {
        console.error(err);
    }
    // Merge settings to a new object. Server settings take priority and will
    // overwrite local settings.
    const settings = Object.assign({}, localSettings, serverSettings);
    // Except for last street settings -- if we've just signed in, local settings
    // take priority.
    const currentMode = (0, $20dec064f3771e9c$export$1fc0f6205829e19c)();
    if (currentMode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).JUST_SIGNED_IN) {
        settings.lastStreetId = localSettings.lastStreetId;
        settings.lastStreetNamespacedId = localSettings.lastStreetNamespacedId;
        settings.lastStreetCreatorId = localSettings.lastStreetCreatorId;
    }
    // This is a temporary value used only for the "fetch last street"
    // functionality (this can happen either through the welcome panel)
    // or the /copy-last convenience URL.
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $9dbab908c178b0dc$export$af2e4444750bad23)({
        priorLastStreetId: settings.lastStreetId
    }));
    // Update our application state.
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $91ffa8e8b26e8ad0$export$f558026a994b6051)(settings));
}
/**
 * Save settings to LocalStorage. This should only be called after the settings
 * reducer has updated. This is meant to mirror application state that
 * should persist across browser sessions and even different users.
 *
 * @param {Object} settings
 */ function $ace8e83c2a1e413b$var$saveSettingsLocally(settings) {
    try {
        window.localStorage.setItem($ace8e83c2a1e413b$var$LOCAL_STORAGE_SETTINGS_ID, JSON.stringify(settings));
    } catch (err) {
    // Ignore localstorage write errors.
    }
}
function $ace8e83c2a1e413b$var$saveSettingsToServer(settings) {
    if (!(0, $9be7409470745503$export$1ae390d25d018ea4)() || (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().errors.abortEverything) return;
    const userId = (0, $9be7409470745503$export$6e84777bbb4941aa)().userId;
    (0, $4ff1018a457d25d0$export$3befcc9cfa75b6ee)(userId, {
        data: settings
    });
}
function $ace8e83c2a1e413b$var$persistSettingsToBackends(settings) {
    // Mirror the settings to local storage (so they persist across browser
    // sessions) and also to the server (to a user account, if the user is
    // signed in).
    $ace8e83c2a1e413b$var$saveSettingsLocally(settings);
    $ace8e83c2a1e413b$var$saveSettingsToServer(settings);
}
function $ace8e83c2a1e413b$export$9e63be9ae2928d00() {
    const select = (state)=>state.settings;
    const onChange = (0, $952fa6927178102c$export$2e2bcd8739ae039)($ace8e83c2a1e413b$var$persistSettingsToBackends, $ace8e83c2a1e413b$var$SAVE_SETTINGS_DELAY);
    return (0, $81878321270eabd6$export$7eabfc5ef2a68f64)(select, onChange);
}


const $9be7409470745503$var$USER_ID_COOKIE = "user_id";
const $9be7409470745503$var$SIGN_IN_TOKEN_COOKIE = "login_token";
const $9be7409470745503$var$REFRESH_TOKEN_COOKIE = "refresh_token";
const $9be7409470745503$var$LOCAL_STORAGE_SIGN_IN_ID = "sign-in";
function $9be7409470745503$export$7abc584011c1e113() {
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $cdf0aaca62d15025$export$61e0a65f251cfdb3)("SIGN_IN"));
}
function $9be7409470745503$export$6e84777bbb4941aa() {
    return (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().user.signInData || {};
}
function $9be7409470745503$export$1ae390d25d018ea4() {
    return (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().user.signedIn;
}
/**
 * Clears sign in data on the client side. Use this when authentication
 * data has become corrupted or expired on the client side and needs to be reset.
 * Do not use this to sign out a user. For that, use signOut(), which ensures
 * that sign out data is also sent to the server.
 */ function $9be7409470745503$var$clearAllClientSignInData() {
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ca8c478b1d098cf7$export$efff0b7a5c54c9dd)());
    window.localStorage.removeItem($9be7409470745503$var$LOCAL_STORAGE_SIGN_IN_ID);
    $9be7409470745503$var$removeSignInCookies();
}
function $9be7409470745503$export$525554425ef185b9() {
    if ($9be7409470745503$export$1ae390d25d018ea4() && !window.localStorage[$9be7409470745503$var$LOCAL_STORAGE_SIGN_IN_ID]) {
        (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).FORCE_RELOAD_SIGN_OUT);
        (0, $20dec064f3771e9c$export$eb2f560d6088705b)();
    } else if (!$9be7409470745503$export$1ae390d25d018ea4() && window.localStorage[$9be7409470745503$var$LOCAL_STORAGE_SIGN_IN_ID]) {
        (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).FORCE_RELOAD_SIGN_IN);
        (0, $20dec064f3771e9c$export$eb2f560d6088705b)();
    }
}
function $9be7409470745503$var$saveSignInDataLocally() {
    const signInData = $9be7409470745503$export$6e84777bbb4941aa();
    if (signInData) window.localStorage.setItem($9be7409470745503$var$LOCAL_STORAGE_SIGN_IN_ID, JSON.stringify(signInData));
    else window.localStorage.removeItem($9be7409470745503$var$LOCAL_STORAGE_SIGN_IN_ID);
}
function $9be7409470745503$var$removeSignInCookies() {
    (0, $f1e510e7f49b22d8$export$2e2bcd8739ae039).remove($9be7409470745503$var$SIGN_IN_TOKEN_COOKIE);
    (0, $f1e510e7f49b22d8$export$2e2bcd8739ae039).remove($9be7409470745503$var$REFRESH_TOKEN_COOKIE);
    (0, $f1e510e7f49b22d8$export$2e2bcd8739ae039).remove($9be7409470745503$var$USER_ID_COOKIE);
}
async function $9be7409470745503$export$8fbaa7a7148eca2f() {
    const signInCookie = (0, $f1e510e7f49b22d8$export$2e2bcd8739ae039).get($9be7409470745503$var$SIGN_IN_TOKEN_COOKIE);
    const refreshCookie = (0, $f1e510e7f49b22d8$export$2e2bcd8739ae039).get($9be7409470745503$var$REFRESH_TOKEN_COOKIE);
    const userIdCookie = (0, $f1e510e7f49b22d8$export$2e2bcd8739ae039).get($9be7409470745503$var$USER_ID_COOKIE);
    if (signInCookie && userIdCookie && refreshCookie) {
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ca8c478b1d098cf7$export$27668919860020c)({
            token: signInCookie,
            refreshToken: refreshCookie,
            userId: userIdCookie
        }));
        $9be7409470745503$var$saveSignInDataLocally();
    } else if (window.localStorage[$9be7409470745503$var$LOCAL_STORAGE_SIGN_IN_ID]) {
        // old login data is in localstorage but we don't have the cookies we need
        $9be7409470745503$var$clearAllClientSignInData();
        (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).AUTH_EXPIRED);
        (0, $20dec064f3771e9c$export$eb2f560d6088705b)();
        return true;
    }
    const signInData = $9be7409470745503$export$6e84777bbb4941aa();
    // Check if token is valid
    // Note that jwtDecode does not actually validate tokens. We will need
    // another library to do that. For now, we use the try/catch to see if
    // throws an error. If so, we log and report this error so we can see
    // why tokens are invalid, then we force clearing all data so that user
    // can reset and start over.
    try {
        if (signInData.token) (0, $e1f926fe3025af48$export$2e2bcd8739ae039)(signInData.token);
    } catch (error) {
        $578bd50dbbc4ca80$export$45654777c133ae80("Error parsing jwt token ", signInData?.token);
        $9be7409470745503$var$clearAllClientSignInData();
        (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).AUTH_EXPIRED);
        (0, $20dec064f3771e9c$export$eb2f560d6088705b)();
        return true;
    }
    const storage = JSON.parse(window.localStorage.getItem("flags"));
    const sessionOverrides = (0, $036006ab2c0b720b$export$b787f9ce4416a661)(storage, "session");
    let flagOverrides = [];
    if (signInData && signInData.token && signInData.userId) {
        const decoded = (0, $e1f926fe3025af48$export$2e2bcd8739ae039)(signInData.token);
        // Check if token has expired
        const currentDate = new Date();
        const expDate = new Date(decoded.exp * 1000);
        // Set the expiration date to one day early so that tokens
        // don't wait till the last moment to refresh
        expDate.setDate(expDate.getDate() - 1);
        if (currentDate >= expDate) await $9be7409470745503$var$refreshLoginToken(signInData.refreshToken);
        flagOverrides = await $9be7409470745503$var$fetchSignInDetails(signInData.userId);
    } else (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ca8c478b1d098cf7$export$efff0b7a5c54c9dd)());
    if (!flagOverrides) flagOverrides = [];
    (0, $036006ab2c0b720b$export$fa34ce778e8ebcc9)((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().flags, ...flagOverrides, sessionOverrides);
    $9be7409470745503$var$_signInLoaded();
    return true;
}
/**
 *
 * @param {String} refreshToken
 * @returns {Object}
 */ async function $9be7409470745503$var$refreshLoginToken(refreshToken) {
    const requestBody = JSON.stringify({
        token: refreshToken
    });
    try {
        const response = await window.fetch("/services/auth/refresh-login-token", {
            method: "post",
            headers: {
                "Content-Type": "application/json"
            },
            body: requestBody
        });
        if (!response.ok) throw response;
    } catch (error) {
        $9be7409470745503$var$errorRefreshLoginToken(error);
    }
}
function $9be7409470745503$var$errorRefreshLoginToken(data) {
    if (data.status === 401) {
        $9be7409470745503$var$signOut(true);
        (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).SIGN_IN_401, true);
        return;
    } else if (data.status === 503) {
        (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).SIGN_IN_SERVER_FAILURE, true);
        return;
    }
    // Fail silently
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ca8c478b1d098cf7$export$efff0b7a5c54c9dd)());
}
/**
 *
 * @param {String} userId
 * @returns {Array}
 */ async function $9be7409470745503$var$fetchSignInDetails(userId) {
    try {
        // TODO: See if it's possible to use RTK Query's implementation of getUser
        // because that will cache user details.
        const response = await (0, $4ff1018a457d25d0$export$7cbf767827cd68ba)(userId);
        if (response.status !== 200) throw response;
        const { flags: flags, roles: roles = [] } = response.data;
        const flagOverrides = [
            // all role flag overrides
            ...roles.map((key)=>(0, $036006ab2c0b720b$export$b787f9ce4416a661)((0, (/*@__PURE__*/$parcel$interopDefault($98448114ff4d3ef1$exports)))[key].flags, `role:${key}`)),
            // user flag overrides
            (0, $036006ab2c0b720b$export$b787f9ce4416a661)(flags, "user")
        ];
        $9be7409470745503$var$receiveSignInDetails(response.data);
        return flagOverrides;
    } catch (error) {
        $9be7409470745503$var$errorReceiveSignInDetails(error);
    }
}
function $9be7409470745503$var$receiveSignInDetails(details) {
    const signInData = {
        ...$9be7409470745503$export$6e84777bbb4941aa(),
        details: details
    };
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ca8c478b1d098cf7$export$27668919860020c)(signInData));
    $9be7409470745503$var$saveSignInDataLocally();
}
function $9be7409470745503$var$errorReceiveSignInDetails(data) {
    if (data.status === 401) {
        $9be7409470745503$var$signOut(true);
        // showError(ERRORS.SIGN_IN_401, true)
        // TODO: Check to make sure that this is the correct place to display
        // this. Currently, this will display for all 401 errors, not just
        // when a valid user who was previously signed in has been signed out.
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ed796acc6691d871$export$2cb648f4e71e8121)({
            message: (0, $4daaf0496059b305$export$25868d1e8e76735f)("error.auth-expired", "We automatically signed you out due to inactivity. Please sign in again."),
            component: "TOAST_SIGN_IN",
            duration: Infinity
        }));
        return;
    } else if (data.status === 503) {
        (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).SIGN_IN_SERVER_FAILURE, true);
        return;
    }
    // Fail silently
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ca8c478b1d098cf7$export$efff0b7a5c54c9dd)());
}
function $9be7409470745503$export$7c4b99b23af54de1(event) {
    $9be7409470745503$var$signOut(false);
    if (event) event.preventDefault();
}
function $9be7409470745503$var$signOut(quiet) {
    const signInData = $9be7409470745503$export$6e84777bbb4941aa();
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $91ffa8e8b26e8ad0$export$f558026a994b6051)({
        lastStreetId: null,
        lastStreetNamespacedId: null,
        lastStreetCreatorId: null
    }));
    $9be7409470745503$var$sendSignOutToServer(signInData.userId, quiet);
}
function $9be7409470745503$var$sendSignOutToServer(userId, quiet) {
    return (0, $4ff1018a457d25d0$export$4f0b80810ad83086)(userId).then((response)=>{
        if (!quiet) $9be7409470745503$var$receiveSignOutConfirmationFromServer();
    }).catch($9be7409470745503$var$errorReceiveSignOutConfirmationFromServer).finally(()=>{
        $9be7409470745503$var$removeSignInCookies();
        window.localStorage.removeItem($9be7409470745503$var$LOCAL_STORAGE_SIGN_IN_ID);
    });
}
function $9be7409470745503$var$receiveSignOutConfirmationFromServer() {
    (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).SIGN_OUT);
    (0, $20dec064f3771e9c$export$eb2f560d6088705b)();
}
function $9be7409470745503$var$errorReceiveSignOutConfirmationFromServer() {
    (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).SIGN_OUT);
    (0, $20dec064f3771e9c$export$eb2f560d6088705b)();
}
function $9be7409470745503$var$_signInLoaded() {
    (0, $ace8e83c2a1e413b$export$54453bb1ffd2fd71)();
    const street = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    let mode = (0, $20dec064f3771e9c$export$1fc0f6205829e19c)();
    const surveyStreetId = (0, $f1e510e7f49b22d8$export$2e2bcd8739ae039).get("last_survey_url");
    // hack to return user to the survey street after signing in
    if (surveyStreetId) {
        (0, $f1e510e7f49b22d8$export$2e2bcd8739ae039).remove("last_survey_url");
        if (mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).JUST_SIGNED_IN) window.location = surveyStreetId;
    }
    if (mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).CONTINUE || mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).JUST_SIGNED_IN || mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).USER_GALLERY || mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).SURVEY_FINISHED || mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).GLOBAL_GALLERY) {
        const settings = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().settings;
        if (settings.lastStreetId) {
            (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$31a813945c518bcb)({
                creatorId: settings.lastStreetCreatorId,
                id: settings.lastStreetId,
                namespacedId: settings.lastStreetNamespacedId
            }));
            if (mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).JUST_SIGNED_IN && !street.creatorId) (0, $838500e3591ab346$export$241049b71dea1a83)(true);
            if (mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).SURVEY_FINISHED) {
                (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ed796acc6691d871$export$2cb648f4e71e8121)({
                    message: (0, $4daaf0496059b305$export$25868d1e8e76735f)("error.survey-finished", "Survey complete. Congratulations and thank you!"),
                    duration: Infinity
                }));
                (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).CONTINUE);
            }
            if (mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).JUST_SIGNED_IN) (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).CONTINUE);
        } else (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).NEW_STREET);
    }
    mode = (0, $20dec064f3771e9c$export$1fc0f6205829e19c)();
    switch(mode){
        case (0, $20dec064f3771e9c$export$240b20df485e8ed6).EXISTING_STREET:
        case (0, $20dec064f3771e9c$export$240b20df485e8ed6).CONTINUE:
        case (0, $20dec064f3771e9c$export$240b20df485e8ed6).USER_GALLERY:
        case (0, $20dec064f3771e9c$export$240b20df485e8ed6).GLOBAL_GALLERY:
            (0, $a7e2543fa152618e$export$69c14310aee1f1aa)();
            break;
        case (0, $20dec064f3771e9c$export$240b20df485e8ed6).NEW_STREET:
        case (0, $20dec064f3771e9c$export$240b20df485e8ed6).NEW_STREET_COPY_LAST:
            if ((0, $9bf07f90c2c537c3$export$729c8b7179294ba).readOnly) (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).CANNOT_CREATE_NEW_STREET_ON_PHONE, true);
            else (0, $a7e2543fa152618e$export$2d2f36bd3726f30a)();
            break;
    }
}












function $d07093f2761e7137$export$2c2a96700b1e1660(width, units) {
    const resolution = (0, $edbb716917ec500c$export$7828ec063292032d)(units);
    if (width < (0, $2a9a05c10189c2fe$export$1d24f35997388cf)) width = (0, $2a9a05c10189c2fe$export$1d24f35997388cf);
    else if (width > (0, $2a9a05c10189c2fe$export$59cfd33ad5cf1eb5)) width = (0, $2a9a05c10189c2fe$export$59cfd33ad5cf1eb5);
    width = Math.round(width / resolution) * resolution;
    return width;
}
/**
 * Adds up all the segment widths to get the total occupied width
 * An empty array should return 0
 *
 * @param {Array} segments
 * @returns {Number} occupiedWidth
 */ function $d07093f2761e7137$var$calculateOccupiedWidth(segments = []) {
    return segments.map((segment)=>segment.width).reduce((occupiedWidth, width)=>occupiedWidth + width, 0);
}
/**
 * Subtracts occupied width from street width to get remaining width.
 *
 * @param {Number} streetWidth
 * @param {Number} occupiedWidth
 * @returns {Number} remainingWidth
 */ function $d07093f2761e7137$var$calculateRemainingWidth(streetWidth, occupiedWidth) {
    let remainingWidth = streetWidth - occupiedWidth;
    // Rounding problems :·(
    if (Math.abs(remainingWidth) < (0, $2a9a05c10189c2fe$export$1b78ec9723991b5b)) remainingWidth = 0;
    return remainingWidth;
}
function $d07093f2761e7137$export$c5f7f64da67f2025(street) {
    // Determine occupied and remaining width
    const occupiedWidth = $d07093f2761e7137$var$calculateOccupiedWidth(street.segments);
    const remainingWidth = $d07093f2761e7137$var$calculateRemainingWidth(street.width, occupiedWidth);
    // Add warnings to segments, if necessary.
    // The position is the left pixel position of each segment. This is initialized
    // with the left pixel of the first segment and will be modified when looking at
    // each subsequent segment.
    let position = street.width / 2 - occupiedWidth / 2;
    // Creates an empty array so that we can clone original segments into it.
    const segments = [];
    street.segments.forEach((segment)=>{
        const variantInfo = (0, $0cc5ae9f1eba4866$export$a7e4a724089e6511)(segment.type, segment.variantString);
        const warnings = [];
        // Apply a warning if any portion of the segment exceeds the boundaries of
        // the street.
        if (remainingWidth < 0 && (position < 0 || position + segment.width > street.width)) warnings[0, $e1cc3cddc7acf1a4$export$bd07f8babb22a89f] = true;
        else warnings[0, $e1cc3cddc7acf1a4$export$bd07f8babb22a89f] = false;
        // Apply a warning if segment width is less than the minimum width
        // defined for this segment type.
        if (variantInfo.minWidth && segment.width < variantInfo.minWidth) warnings[0, $e1cc3cddc7acf1a4$export$1603ba7a45cd1a72] = true;
        else warnings[0, $e1cc3cddc7acf1a4$export$1603ba7a45cd1a72] = false;
        // Apply a warning if segment width is greater than the maximum width
        // defined for this segment type.
        if (variantInfo.maxWidth && segment.width > variantInfo.maxWidth) warnings[0, $e1cc3cddc7acf1a4$export$529213ff1df6a1b5] = true;
        else warnings[0, $e1cc3cddc7acf1a4$export$529213ff1df6a1b5] = false;
        // Apply a warning if the segment type and variant is the mixed-use
        // drive lane with bicycle, which is a dangerous existing condition
        if (variantInfo.dangerous === true) warnings[0, $e1cc3cddc7acf1a4$export$fccc01258576ea7b] = true;
        else warnings[0, $e1cc3cddc7acf1a4$export$fccc01258576ea7b] = false;
        // Increment the position counter.
        position += segment.width;
        segments.push({
            ...segment,
            warnings: warnings
        });
    });
    return {
        occupiedWidth: occupiedWidth,
        remainingWidth: remainingWidth,
        segments: segments
    };
}






const $2fdd636378463894$var$COUNTRIES_IMPERIAL_UNITS = [
    "US"
];
let $2fdd636378463894$var$leftHandTraffic = false;
function $2fdd636378463894$export$441b5880739e813() {
    return $2fdd636378463894$var$leftHandTraffic;
}
const $2fdd636378463894$var$COUNTRIES_LEFT_HAND_TRAFFIC = [
    "AI",
    "AG",
    "AU",
    "BS",
    "BD",
    "BB",
    "BM",
    "BT",
    "BW",
    "BN",
    "KY",
    "CX",
    "CC",
    "CK",
    "CY",
    "DM",
    "TL",
    "FK",
    "FJ",
    "GD",
    "GG",
    "GY",
    "HK",
    "IN",
    "ID",
    "IE",
    "IM",
    "JM",
    "JP",
    "JE",
    "KE",
    "KI",
    "LS",
    "MO",
    "MW",
    "MY",
    "MV",
    "MT",
    "MU",
    "MS",
    "MZ",
    "NA",
    "NR",
    "NP",
    "NZ",
    "NU",
    "NF",
    "PK",
    "PG",
    "PN",
    "SH",
    "KN",
    "LC",
    "VC",
    "WS",
    "SC",
    "SG",
    "SB",
    "ZA",
    "LK",
    "SR",
    "SZ",
    "TZ",
    "TH",
    "TK",
    "TO",
    "TT",
    "TC",
    "TV",
    "UG",
    "GB",
    "VG",
    "VI",
    "ZM",
    "ZW"
];
function $2fdd636378463894$export$378deebf84b03442(countryCode) {
    if ($2fdd636378463894$var$COUNTRIES_LEFT_HAND_TRAFFIC.indexOf(countryCode) !== -1) $2fdd636378463894$var$leftHandTraffic = true;
    if ((0, $6fccecb363574db8$export$1c9f709888824e05).forceLeftHandTraffic) $2fdd636378463894$var$leftHandTraffic = true;
    $2fdd636378463894$export$8f34250e59cd2595(countryCode);
}
function $2fdd636378463894$export$8f34250e59cd2595(countryCode) {
    const localStorageUnits = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().settings.units;
    let unitType;
    if (localStorageUnits) unitType = localStorageUnits;
    else if ($2fdd636378463894$var$COUNTRIES_IMPERIAL_UNITS.indexOf(countryCode) !== -1) unitType = (0, $c098fdb90228b950$export$c9756beb4aae2c8d);
    else unitType = (0, $c098fdb90228b950$export$95a57d0e83881bf);
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $91ffa8e8b26e8ad0$export$df095147a62dd3c4)(unitType));
}
function $2fdd636378463894$export$79f1031a34509c7(newUnits) {
    let fromUndo;
    const street = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    if (street.units === newUnits) return;
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$c84001c9e3ebd004)(newUnits));
    // If the user converts and then straight converts back, we just reach
    // to undo stack instead of double conversion (which could be lossy).
    const undoStack = (0, $b66cc4ceae9b725e$export$11e81b241ba16333)();
    const undoPosition = (0, $b66cc4ceae9b725e$export$57e3eed88cb66286)();
    if (undoStack[undoPosition - 1] && undoStack[undoPosition - 1].units === newUnits) fromUndo = true;
    else fromUndo = false;
    (0, $8d9791e5769125e5$export$996926525e13f61e)(true);
    if (!fromUndo) {
        const segments = (0, $edbb716917ec500c$export$63a50d43863b1a83)(street.segments, street.units);
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$6a7fdf0c7a380248)(segments));
        if (street.remainingWidth === 0) {
            let width = 0;
            for(const i in street.segments)width += street.segments[i].width;
            (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$c61bfb5183745fe1)(width));
        } else (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$c61bfb5183745fe1)((0, $d07093f2761e7137$export$2c2a96700b1e1660)(street.width, newUnits)));
    } else (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$abace6e40841f465)((0, $762e491bbbc71e6b$export$2e2bcd8739ae039)(undoStack[undoPosition - 1])));
    (0, $2f44915f6f87dcf5$export$b2eeaeff46616de5)();
    (0, $8d9791e5769125e5$export$996926525e13f61e)(false);
    (0, $8d9791e5769125e5$export$f86dbb9897d7ebae)();
}










const $8d9791e5769125e5$var$DEFAULT_BUILDING_HEIGHT_LEFT = 4;
const $8d9791e5769125e5$var$DEFAULT_BUILDING_HEIGHT_RIGHT = 3;
const $8d9791e5769125e5$var$DEFAULT_BUILDING_VARIANT_LEFT = "narrow";
const $8d9791e5769125e5$var$DEFAULT_BUILDING_VARIANT_RIGHT = "wide";
const $8d9791e5769125e5$var$DEFAULT_BUILDING_HEIGHT_EMPTY = 1;
const $8d9791e5769125e5$var$DEFAULT_BUILDING_VARIANT_EMPTY = "grass";
const $8d9791e5769125e5$var$DEFAULT_STREET_WIDTH = 80;
let $8d9791e5769125e5$var$_lastStreet;
function $8d9791e5769125e5$export$ed20678efa7800e4() {
    $8d9791e5769125e5$var$_lastStreet = $8d9791e5769125e5$export$c5cc62253c2d0728((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street);
}
const $8d9791e5769125e5$var$LATEST_SCHEMA_VERSION = 27;
// 1: starting point
// 2: adding leftBuildingHeight and rightBuildingHeight
// 3: adding leftBuildingVariant and rightBuildingVariant
// 4: adding transit shelter elevation
// 5: adding another lamp type (traditional)
// 6: colored streetcar lanes
// 7: colored bus and light rail lanes
// 8: colored bike lane
// 9: second car type: truck
// 10: sidewalk density
// 11: unify median and planting strip into divider
// 12: getting rid of small tree
// 13: bike rack elevation
// 14: wayfinding has three types
// 15: sidewalks have rand seed
// 16: stop saving undo stack
// 17: alternative colors for bike lanes
// 18: change lat/lng format from array to object
// 19: add environment
// 20: add sidewalk-level bike lanes
// 21: add sidewalk-level bikeshare docks
// 22: add random seed to drive lanes for pedestrians
// 23: add unique id to each segment
// 24: remove random seed from any segment
// 25: add bus type
// 26: add elevation properties to segments
// 27: bugfix missing elevation properties from previous schema
function $8d9791e5769125e5$var$incrementSchemaVersion(street) {
    let segment, variant;
    if (!street.schemaVersion) {
        // Fix a bug in 2018 where a street does not have a schema version when it should.
        if (street.createdAt && street.createdAt.indexOf("2018") === 0 || street.updatedAt && street.updatedAt.indexOf("2018") === 0) street.schemaVersion = 17;
        else street.schemaVersion = 1;
    }
    switch(street.schemaVersion){
        case 1:
            street.leftBuildingHeight = $8d9791e5769125e5$var$DEFAULT_BUILDING_HEIGHT_LEFT;
            street.rightBuildingHeight = $8d9791e5769125e5$var$DEFAULT_BUILDING_HEIGHT_RIGHT;
            break;
        case 2:
            street.leftBuildingVariant = $8d9791e5769125e5$var$DEFAULT_BUILDING_VARIANT_LEFT;
            street.rightBuildingVariant = $8d9791e5769125e5$var$DEFAULT_BUILDING_VARIANT_RIGHT;
            break;
        case 3:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "transit-shelter") {
                    variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
                    variant["transit-shelter-elevation"] = "street-level";
                    segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
                }
            }
            break;
        case 4:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "sidewalk-lamp") {
                    variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
                    variant["lamp-type"] = "modern";
                    segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
                }
            }
            break;
        case 5:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "streetcar") {
                    variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
                    variant["public-transit-asphalt"] = "regular";
                    segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
                }
            }
            break;
        case 6:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "bus-lane") {
                    variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
                    variant["bus-asphalt"] = "regular";
                    segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
                } else if (segment.type === "light-rail") {
                    variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
                    variant["public-transit-asphalt"] = "regular";
                    segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
                }
            }
            break;
        case 7:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "bike-lane") {
                    variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
                    variant["bike-asphalt"] = "regular";
                    segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
                }
            }
            break;
        case 8:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "drive-lane") {
                    variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
                    variant["car-type"] = "car";
                    segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
                }
            }
            break;
        case 9:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "sidewalk") {
                    variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
                    variant["sidewalk-density"] = "normal";
                    segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
                }
            }
            break;
        case 10:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "planting-strip") {
                    segment.type = "divider";
                    if (segment.variantString === "") segment.variantString = "planting-strip";
                } else if (segment.type === "small-median") {
                    segment.type = "divider";
                    segment.variantString = "median";
                }
            }
            break;
        case 11:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "divider") {
                    if (segment.variantString === "small-tree") segment.variantString = "big-tree";
                } else if (segment.type === "sidewalk-tree") {
                    if (segment.variantString === "small") segment.variantString = "big";
                }
            }
            break;
        case 12:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "sidewalk-bike-rack") {
                    variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
                    variant["bike-rack-elevation"] = "sidewalk";
                    segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
                }
            }
            break;
        case 13:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "sidewalk-wayfinding") {
                    variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
                    variant["wayfinding-type"] = "large";
                    segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
                }
            }
            break;
        case 14:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "sidewalk") // With schema version 24, we no longer need randseeds
                // for segments, so don't bother generating a new one here,
                // just fill this in for placeholder effect
                segment.randSeed = 35;
            }
            break;
        case 15:
            (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $0e3fada570e844f5$export$bedafa63ac02a207)());
            break;
        case 16:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "bike-lane") {
                    variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
                    if (variant["bike-asphalt"] === "colored") variant["bike-asphalt"] = "green";
                    segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
                }
            }
            break;
        case 17:
            if (street.location && Array.isArray(street.location.latlng)) street.location.latlng = {
                lat: street.location.latlng[0],
                lng: street.location.latlng[1]
            };
            break;
        case 18:
            if (!street.environment) street.environment = (0, $2a9a05c10189c2fe$export$cb0b75edbeba6d1a);
            break;
        case 19:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "bike-lane") {
                    variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
                    variant.elevation = "road";
                    segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
                }
            }
            break;
        case 20:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "bikeshare") {
                    variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
                    variant.elevation = "road";
                    segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
                }
            }
            break;
        case 21:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "drive-lane") // With schema version 24, we no longer need randseeds
                // for segments, so don't bother generating a new one here,
                // just fill this in for placeholder effect
                segment.randSeed = 36;
            }
            break;
        case 22:
            for(const i in street.segments){
                segment = street.segments[i];
                if (!segment.id) segment.id = (0, $5824ec4f3474e945$export$ac4959f4f1338dfc)();
            }
            break;
        case 23:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.randSeed) delete segment.randSeed;
            }
            break;
        case 24:
            for(const i in street.segments){
                segment = street.segments[i];
                if (segment.type === "bus-lane") {
                    variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
                    variant["bus-type"] = "typical";
                    segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(variant);
                }
            }
            break;
        case 25:
            for(const i in street.segments){
                segment = street.segments[i];
                const variantInfo = (0, $0cc5ae9f1eba4866$export$a7e4a724089e6511)(segment.type, segment.variantString);
                segment.elevation = variantInfo.elevation;
            }
            break;
        // Fixes a bug in the previous schema version where new streets would
        // be created without elevation properties, this migration backfills them
        case 26:
            for(const i in street.segments){
                segment = street.segments[i];
                if (typeof segment.elevation === "undefined") {
                    const variantInfo = (0, $0cc5ae9f1eba4866$export$a7e4a724089e6511)(segment.type, segment.variantString);
                    segment.elevation = variantInfo.elevation;
                }
            }
            break;
    }
    street.schemaVersion++;
    return street;
}
function $8d9791e5769125e5$export$40f838ff08fe7f5d(street) {
    let updated = false;
    while(!street.schemaVersion || street.schemaVersion < $8d9791e5769125e5$var$LATEST_SCHEMA_VERSION){
        street = $8d9791e5769125e5$var$incrementSchemaVersion(street);
        updated = true;
    }
    // Do some work to update segment data, although they're not technically
    // part of the schema (yet?)
    street.segments = street.segments.map((segment)=>{
        // Alternate method of storing variants as object key-value pairs,
        // instead of a string. We might gradually migrate toward this.
        segment.variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
        return segment;
    });
    return updated;
}
function $8d9791e5769125e5$export$a6cf4b5bbe4714cf(newId) {
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$5edca91ccdd4a230)(newId));
    (0, $b66cc4ceae9b725e$export$6e81a82123b449bb)();
    (0, $a7e2543fa152618e$export$109830048ac00593)();
}
function $8d9791e5769125e5$export$4cb3d51df0d60a35() {
    const updateTime = new Date().toISOString();
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$f85cd13c464f6e72)(updateTime));
    (0, $b66cc4ceae9b725e$export$6e81a82123b449bb)();
}
let $8d9791e5769125e5$var$ignoreStreetChanges = false;
function $8d9791e5769125e5$export$996926525e13f61e(value) {
    $8d9791e5769125e5$var$ignoreStreetChanges = value;
}
function $8d9791e5769125e5$export$f86dbb9897d7ebae() {
    if ($8d9791e5769125e5$var$ignoreStreetChanges || (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().errors.abortEverything) return;
    const street = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    const currentData = $8d9791e5769125e5$export$c5cc62253c2d0728(street);
    if (JSON.stringify(currentData) !== JSON.stringify($8d9791e5769125e5$var$_lastStreet)) {
        if (street.editCount !== null) (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$1cc6e452ae697b42)(street.editCount + 1));
        $8d9791e5769125e5$export$4cb3d51df0d60a35();
        // Some parts of the UI need to know this happened to respond to it
        // TODO: figure out appropriate event name
        window.dispatchEvent(new window.CustomEvent("stmx:save_street"));
        (0, $b66cc4ceae9b725e$export$5dc8a18b66217cb8)($8d9791e5769125e5$var$_lastStreet, currentData);
        (0, $a7e2543fa152618e$export$43e18255cf2aefbc)();
        $8d9791e5769125e5$var$_lastStreet = currentData;
    }
}
function $8d9791e5769125e5$export$c5cc62253c2d0728(street) {
    const newData = {
        schemaVersion: street.schemaVersion,
        showAnalytics: street.showAnalytics,
        capacitySource: street.capacitySource,
        width: street.width,
        name: street.name,
        id: street.id,
        namespacedId: street.namespacedId,
        creatorId: street.creatorId,
        originalStreetId: street.originalStreetId,
        units: street.units,
        location: street.location,
        userUpdated: street.userUpdated,
        environment: street.environment,
        leftBuildingHeight: street.leftBuildingHeight,
        rightBuildingHeight: street.rightBuildingHeight,
        leftBuildingVariant: street.leftBuildingVariant,
        rightBuildingVariant: street.rightBuildingVariant,
        segments: street.segments.map((origSegment)=>{
            const segment = {
                id: origSegment.id,
                type: origSegment.type,
                variantString: origSegment.variantString,
                width: origSegment.width,
                elevation: origSegment.elevation,
                label: origSegment.label
            };
            return segment;
        })
    };
    if (street.editCount !== null) newData.editCount = street.editCount;
    return newData;
}
function $8d9791e5769125e5$var$fillDefaultSegments(units) {
    const segments = [];
    const leftHandTraffic = (0, $2fdd636378463894$export$441b5880739e813)();
    for(const i in (0, $685dc95e6c00aa0d$export$7c4422d33ae56848)[leftHandTraffic]){
        const segment = (0, $762e491bbbc71e6b$export$2e2bcd8739ae039)((0, $685dc95e6c00aa0d$export$7c4422d33ae56848)[leftHandTraffic][i]);
        segment.variantString = (0, $f22063bb59944341$export$ee6cd03efc4c2fda)(segment.variant);
        const variantInfo = (0, $0cc5ae9f1eba4866$export$a7e4a724089e6511)(segment.type, segment.variantString);
        segment.id = (0, $5824ec4f3474e945$export$ac4959f4f1338dfc)();
        segment.width = (0, $edbb716917ec500c$export$e06f682fb9edb199)(segment.width, (0, $edbb716917ec500c$export$12e0a54c23e0f7be)((0, $edbb716917ec500c$export$bef0bdcd5a467cae), units));
        segment.elevation = variantInfo.elevation;
        segment.warnings = [];
        segments.push(segment);
    }
    return segments;
}
function $8d9791e5769125e5$export$cc66adb823d23a6() {
    const units = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().settings.units;
    const currentDate = new Date().toISOString();
    const defaultStreet = {
        units: units,
        location: null,
        name: null,
        showAnalytics: true,
        userUpdated: false,
        editCount: 0,
        width: (0, $d07093f2761e7137$export$2c2a96700b1e1660)($8d9791e5769125e5$var$DEFAULT_STREET_WIDTH, units),
        environment: (0, $2a9a05c10189c2fe$export$cb0b75edbeba6d1a),
        leftBuildingHeight: $8d9791e5769125e5$var$DEFAULT_BUILDING_HEIGHT_LEFT,
        leftBuildingVariant: $8d9791e5769125e5$var$DEFAULT_BUILDING_VARIANT_LEFT,
        rightBuildingHeight: $8d9791e5769125e5$var$DEFAULT_BUILDING_HEIGHT_RIGHT,
        rightBuildingVariant: $8d9791e5769125e5$var$DEFAULT_BUILDING_VARIANT_RIGHT,
        schemaVersion: $8d9791e5769125e5$var$LATEST_SCHEMA_VERSION,
        segments: $8d9791e5769125e5$var$fillDefaultSegments(units),
        updatedAt: currentDate,
        clientUpdatedAt: currentDate,
        creatorId: (0, $9be7409470745503$export$1ae390d25d018ea4)() && (0, $9be7409470745503$export$6e84777bbb4941aa)().userId || null
    };
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$abace6e40841f465)(defaultStreet));
    if ((0, $9be7409470745503$export$1ae390d25d018ea4)()) (0, $a7e2543fa152618e$export$109830048ac00593)();
}
function $8d9791e5769125e5$export$a221a6108238e80d() {
    const units = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().settings.units;
    const currentDate = new Date().toISOString();
    const emptyStreet = {
        units: units,
        location: null,
        name: null,
        showAnalytics: true,
        userUpdated: false,
        editCount: 0,
        width: (0, $d07093f2761e7137$export$2c2a96700b1e1660)($8d9791e5769125e5$var$DEFAULT_STREET_WIDTH, units),
        environment: (0, $2a9a05c10189c2fe$export$cb0b75edbeba6d1a),
        leftBuildingHeight: $8d9791e5769125e5$var$DEFAULT_BUILDING_HEIGHT_EMPTY,
        leftBuildingVariant: $8d9791e5769125e5$var$DEFAULT_BUILDING_VARIANT_EMPTY,
        rightBuildingHeight: $8d9791e5769125e5$var$DEFAULT_BUILDING_HEIGHT_EMPTY,
        rightBuildingVariant: $8d9791e5769125e5$var$DEFAULT_BUILDING_VARIANT_EMPTY,
        schemaVersion: $8d9791e5769125e5$var$LATEST_SCHEMA_VERSION,
        segments: [],
        updatedAt: currentDate,
        clientUpdatedAt: currentDate,
        creatorId: (0, $9be7409470745503$export$1ae390d25d018ea4)() && (0, $9be7409470745503$export$6e84777bbb4941aa)().userId || null
    };
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$abace6e40841f465)(emptyStreet));
    if ((0, $9be7409470745503$export$1ae390d25d018ea4)()) (0, $a7e2543fa152618e$export$109830048ac00593)();
}
function $8d9791e5769125e5$export$a816daed016d4c40(dontScroll, save = true) {
    $8d9791e5769125e5$export$996926525e13f61e(true);
    // TODO Verify that we don't need to dispatch an update width event here
    (0, $2f44915f6f87dcf5$export$b2eeaeff46616de5)();
    $8d9791e5769125e5$export$996926525e13f61e(false);
    $8d9791e5769125e5$export$ed20678efa7800e4();
    if (save === true) (0, $a7e2543fa152618e$export$43e18255cf2aefbc)();
}





function $8b400d6ab7c299d4$export$416b4e58a6f40906(percent) {
    return Number.parseFloat(percent) / 100;
}





/**
 * Replacement for lodash's maxBy().
 *
 * This method is like _.max except that it accepts iteratee which is
 * invoked for each element in array to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * This is the vanilla JS implementation via
 * https://youmightnotneed.com/lodash/#maxBy
 *
 * WARNING: This is not a drop in replacement solution and it might not work
 * for some edge cases.
 *
 * For instance: if not all objects in the array have the same properties,
 * this will fail to find the correct object.
 *
 * @param {Array} arr - array of items to find the max value
 * @param {Function} func - selector function
 * @returns *
 */ function $8347da9a3bac75c5$export$ad1963a493908da4(arr, func) {
    const max = Math.max(...arr.map(func));
    return arr.find((item)=>func(item) === max);
}





const $a3683c18389a345c$var$DEFAULT_SELECTION_WEIGHT = 50;
const $a3683c18389a345c$var$DEFAULT_SCATTER_SPACING_MIN = 0;
const $a3683c18389a345c$var$DEFAULT_SCATTER_SPACING_MAX = 3 // in feet
;
/**
 * Given a pool of entities, with defined widths, get the maximum width value
 * This number is used during rendering to adjust sprites for center alignment
 *
 * @param {Array} pool - of objects to draw from
 * @returns {Number} - maximum street width in feet
 */ function $a3683c18389a345c$var$getSpriteMaxWidth(pool) {
    return (0, $8347da9a3bac75c5$export$ad1963a493908da4)(pool, (s)=>s.width).width;
}
/**
 * Using the random generator function, perform a weighted random selection
 * from a pool of entities, then clone and return the object for that entity.
 *
 * @param {Array} pool - of entities to draw from. See the heredoc for
 *    getRandomObjects() for the expected data structure of entities.
 * @param {Function} randomGenerator - random generator function created
 *    from randSeed. Do not recreate random generator function within a loop,
 *    because that is not performant.
 */ function $a3683c18389a345c$var$pickRandomEntityFromPool(pool, randomGenerator) {
    const totalWeight = pool.reduce((sum, entity)=>{
        return sum + (entity.weight || $a3683c18389a345c$var$DEFAULT_SELECTION_WEIGHT);
    }, 0);
    const randomNumber = Math.floor(randomGenerator() * totalWeight);
    let pickedEntityIndex;
    let searchWeight = 0;
    for(let i = 0; i < pool.length; i++){
        const entity = pool[i];
        searchWeight += entity.weight || $a3683c18389a345c$var$DEFAULT_SELECTION_WEIGHT;
        if (randomNumber < searchWeight) {
            pickedEntityIndex = i;
            break;
        }
    }
    // Clone the entity and return it
    return Object.assign({}, pool[pickedEntityIndex]);
}
function $a3683c18389a345c$export$31779924ce936af1(pool, maxWidth, randSeed = 9123984, minSpacing, maxSpacing, maxSpriteWidth, spacingAdjustment = 0, padding = 0) {
    const randomGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($23a883339fc52481$exports)))(randSeed);
    const objects = [];
    let runningWidth = 0;
    let previousEntityId = null;
    let currentEntityId = null;
    let lastWidth = 0;
    // Pick (draw) objects from the pool until we have at least one object, and
    // until we hit the maximum width given. `padding` is used to so that
    // we don't render objects too closely to the edge of a segment.
    while(objects.length === 0 || runningWidth < maxWidth - padding * 2){
        let object;
        // Special choosing logic only for larger pools.
        if (pool.length >= 4) do {
            object = $a3683c18389a345c$var$pickRandomEntityFromPool(pool, randomGenerator);
            currentEntityId = object.id;
        }while (// Don't pick the same object twice in a row, and avoid picking
        // certain objects as the first object in a list. This is because
        // some objects are "special" and look strange when on their own,
        // but can diversify when included in a list.
        currentEntityId === previousEntityId || objects.length === 0 && object.disallowFirst === true);
        else {
            object = $a3683c18389a345c$var$pickRandomEntityFromPool(pool, randomGenerator);
            currentEntityId = object.id;
        }
        previousEntityId = currentEntityId;
        object.left = runningWidth;
        // Calculate the amount of space to allocate to this object,
        // creating space for placing the next object (if any).
        // First, take into account the object's defined sprite width.
        // Then add `minSpacing`, the minimum spacing between sprites.
        // Next, add a variable distance between sprites. This number
        // is randomly chosen between `minSpacing` and `maxSpacing.`
        // The `randomGenerator()` must be used to ensure that this random
        // number is consistent across renders.
        // Lastly, this is further tweaked by adding a `spacingAdjustment`
        // value, which can adjust overall density. In the case of people,
        // this value makes sprites slightly denser, to account for the
        // transparent space around each person sprite's defined width.
        lastWidth = object.width + minSpacing + randomGenerator() * (maxSpacing - minSpacing) + spacingAdjustment;
        runningWidth += lastWidth;
        objects.push(object);
    }
    // After exiting the loop, remove the space allocated for the next object,
    // by undoing the addition of `lastWidth` to `runningWidth`.
    // TODO: Refactor this behavior.
    const totalWidth = runningWidth - lastWidth;
    // The left position of sprites are along the left edge.
    // This correction adjusts the actual left render position, based on the
    // width of the first and last sprites, to better balance centering the
    // sprites within the segment.
    const firstObjectCorrection = (maxSpriteWidth - objects[0].width) / 2;
    const lastObjectCorrection = (maxSpriteWidth - objects[objects.length - 1].width) / 2;
    let startLeft = (maxWidth - totalWidth) / 2;
    if (objects.length === 1) startLeft += firstObjectCorrection;
    else startLeft += (firstObjectCorrection + lastObjectCorrection) / 2;
    return [
        objects,
        startLeft
    ];
}
function $a3683c18389a345c$export$adcc0d79ef7fdf66(sprites, ctx, width, offsetLeft, groundLevel, randSeed, minSpacing = $a3683c18389a345c$var$DEFAULT_SCATTER_SPACING_MIN, maxSpacing = $a3683c18389a345c$var$DEFAULT_SCATTER_SPACING_MAX, adjustment = 0, padding = 0, multiplier, dpi) {
    // Pool must be an array of objects. If an array of strings
    // is passed in, look up its sprite information from the string
    // id and convert to object.
    const pool = sprites.map((sprite)=>{
        if (typeof sprite === "string") {
            const svg = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(sprite);
            return {
                id: sprite,
                width: svg.width / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953)
            };
        }
        // Pass objects through as-is
        return sprite;
    });
    const maxSpriteWidth = $a3683c18389a345c$var$getSpriteMaxWidth(pool);
    const [objects, startLeft] = $a3683c18389a345c$export$31779924ce936af1(pool, width, randSeed, minSpacing, maxSpacing, maxSpriteWidth, adjustment, padding);
    for (const object of objects){
        const id = object.id;
        const sprite = (0, $0cc5ae9f1eba4866$export$28d35a9efc690b32)(id);
        const svg = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(id);
        const distanceFromGround = multiplier * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * ((svg.height - (sprite.originY ?? object.originY ?? 0)) / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953));
        (0, $2f44915f6f87dcf5$export$d183e74c32825504)(id, ctx, undefined, undefined, undefined, undefined, offsetLeft + (object.left - // Adjust offset according to the svg viewbox width
        svg.width / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953) / 2 - // Adjust according to sprite's defined "hitbox" width
        (maxSpriteWidth - object.width) / 2 + startLeft) * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier, groundLevel - distanceFromGround, undefined, undefined, multiplier, dpi);
    }
}



var $fa64363c7ce044b6$exports = {};
$fa64363c7ce044b6$exports = JSON.parse('[{"id":"people-01","width":2,"name":"Nora"},{"id":"people-02","width":2},{"id":"people-03","width":2},{"id":"people-04","width":2},{"id":"people-05","width":2},{"id":"people-06","width":2},{"id":"people-07","width":2},{"id":"people-08","width":2},{"id":"people-09","width":2},{"id":"people-10","width":2},{"id":"people-11","width":2},{"id":"people-12","width":2},{"id":"people-13","width":2},{"id":"people-14","width":3},{"id":"people-15","width":2},{"id":"people-16","width":3,"name":"Lou"},{"id":"people-17","width":3},{"id":"people-18","width":3},{"id":"people-19","width":3,"disallowFirst":true},{"id":"people-20","width":3,"disallowFirst":true},{"id":"people-21","width":1},{"id":"people-22","width":1},{"id":"people-23","width":3,"name":"Katie"},{"id":"people-24","width":4},{"id":"people-25","width":2},{"id":"people-26","width":3},{"id":"people-27","width":2},{"id":"people-28","width":3},{"id":"people-29","width":4},{"id":"people-30","width":3},{"id":"people-31","width":2},{"id":"johnny-01","width":3,"name":"Johnny","disallowFirst":true,"weight":10},{"id":"johnny-02","width":3,"name":"Johnny","disallowFirst":true,"weight":5},{"id":"junebug-01","width":3,"name":"Junebug","disallowFirst":true,"weight":10},{"id":"junebug-02","width":3,"name":"Junebug","disallowFirst":true,"weight":5},{"id":"bernie","width":3,"name":"Bernie","weight":1}]');


// Adjust spacing between people to be slightly closer
const $2f44915f6f87dcf5$var$PERSON_SPACING_ADJUSTMENT = -0.5 // in feet
;
const $2f44915f6f87dcf5$var$PERSON_SPRITE_OFFSET_Y = 10 // in pixels
;
function $2f44915f6f87dcf5$export$d183e74c32825504(id, ctx, sx = 0, sy = 0, sw, sh, dx, dy, dw, dh, multiplier = 1, dpi) {
    // If asked to render a source or destination image with width or height
    // that is equal to or less than 0, bail. Attempting to render such an image
    // will throw an IndexSizeError error in Firefox.
    if (sw <= 0 || sh <= 0 || dw <= 0 || dh <= 0) return;
    // Settings
    const state = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState();
    dpi = dpi || state.system.devicePixelRatio || 1;
    const debugRect = state.flags.DEBUG_SEGMENT_CANVAS_RECTANGLES.value || false;
    // Get image definition
    const svg = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(id);
    // Source width and height is based off of intrinsic image width and height,
    // but it can be overridden in the parameters, e.g. when repeating sprites
    // in a sequence and the last sprite needs to be truncated
    sw = sw === undefined ? svg.width : sw * (0, $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8);
    sh = sh === undefined ? svg.height : sh * (0, $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8);
    // We can't read `.naturalWidth` and `.naturalHeight` properties from
    // the image in IE11, which returns 0. This is why width and height are
    // stored as properties from when the image is first cached
    // All images are drawn at 2x pixel dimensions so divide in half to get
    // actual width / height value then multiply by system pixel density
    //
    // dw/dh (and later sw/sh) can be 0, so don't use falsy checks
    dw = dw === undefined ? svg.width / (0, $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8) : dw;
    dh = dh === undefined ? svg.height / (0, $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8) : dh;
    dw *= multiplier * dpi;
    dh *= multiplier * dpi;
    // Set render dimensions based on pixel density
    dx *= dpi;
    dy *= dpi;
    // These rectangles are telling us that we're drawing at the right places.
    if (debugRect === true) {
        ctx.fillStyle = "rgba(0, 0, 0, 0.2)";
        ctx.fillRect(dx, dy, dw, dh);
    }
    // Round all values to whole numbers when we render. Decimal values can
    // introduce tiny "seams" at tiled assets, for example.
    ctx.drawImage(svg.img, Math.round(sx), Math.round(sy), Math.round(sw), Math.round(sh), Math.round(dx), Math.round(dy), // destination sprites round up to prevent gaps in tiled sprites
    Math.ceil(dw), Math.ceil(dh));
}
function $2f44915f6f87dcf5$export$ef14b8f1a495a8b9(variantInfo, actualWidth = 0) {
    // Convert actualWidth to units that work with images' intrinsic dimensions
    const displayWidth = actualWidth * (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953);
    const center = displayWidth / 2;
    let left = center;
    let right = center;
    let newLeft, newRight;
    const graphics = variantInfo.graphics;
    if (graphics.center) {
        const sprites = Array.isArray(graphics.center) ? graphics.center : [
            graphics.center
        ];
        for(let l = 0; l < sprites.length; l++){
            const sprite = (0, $0cc5ae9f1eba4866$export$28d35a9efc690b32)(sprites[l]);
            const svg = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(sprite.id);
            // If svg is missing, let it not affect this calculation
            if (svg) {
                newLeft = center - svg.width / 2 + (sprite.offsetX || 0);
                newRight = center + svg.width / 2 + (sprite.offsetX || 0);
                if (newLeft < left) left = newLeft;
                if (newRight > right) right = newRight;
            }
        }
    }
    if (graphics.left) {
        const sprites = Array.isArray(graphics.left) ? graphics.left : [
            graphics.left
        ];
        for(let l = 0; l < sprites.length; l++){
            const sprite = (0, $0cc5ae9f1eba4866$export$28d35a9efc690b32)(sprites[l]);
            const svg = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(sprite.id);
            if (svg) {
                newLeft = sprite.offsetX || 0;
                newRight = svg.width + (sprite.offsetX || 0);
                if (newLeft < left) left = newLeft;
                if (newRight > right) right = newRight;
            }
        }
    }
    if (graphics.right) {
        const sprites = Array.isArray(graphics.right) ? graphics.right : [
            graphics.right
        ];
        for(let l = 0; l < sprites.length; l++){
            const sprite = (0, $0cc5ae9f1eba4866$export$28d35a9efc690b32)(sprites[l]);
            const svg = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(sprite.id);
            if (svg) {
                newLeft = displayWidth - (sprite.offsetX || 0) - svg.width;
                newRight = displayWidth - (sprite.offsetX || 0);
                if (newLeft < left) left = newLeft;
                if (newRight > right) right = newRight;
            }
        }
    }
    if (graphics.repeat && graphics.repeat[0]) {
        newLeft = center - displayWidth / 2;
        newRight = center + displayWidth / 2;
        if (newLeft < left) left = newLeft;
        if (newRight > right) right = newRight;
    }
    // If a segment has a "minimum renderable width", the left and right values
    // are overridden based on the `quirks.minWidth` property. This prevents
    // left/right assets from rendering in strange positions.
    if (graphics.quirks?.minWidth) {
        const minDimension = graphics.quirks.minWidth * (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953);
        if (displayWidth < minDimension) {
            left = (displayWidth - minDimension) / 2;
            right = (minDimension - displayWidth) / 2 + displayWidth;
        }
    }
    return {
        left: left / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953),
        right: right / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953),
        center: center / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953)
    };
}
const $2f44915f6f87dcf5$var$GROUND_LEVEL_OFFSETY = {
    ASPHALT: 0,
    CURB: 18,
    RAISED_CURB: 94,
    DRAINAGE: -50
};
/**
 * Originally a sprite's dy position was calculated using: dy = offsetTop +
 * (multiplier * TILE_SIZE * (sprite.offsetY || 0)). In order to remove
 * `offsetY` from `SPRITE_DEF`, we are defining the `offsetY` for all "ground",
 * or "lane", sprites in pixels in `GROUND_LEVEL_OFFSETY`. This was calculated
 * by taking the difference of the `offsetY` value for ground level 0 and the
 * `offsetY` for the elevation of the current segment. Using `elevation`, which
 * is defined for each segment based on the "ground" component being used, this
 * function returns the `GROUND_LEVEL_OFFSETY` for that `elevation`. If not
 * found, it returns null.
 *
 * @param {Number} elevation
 * @returns {?Number} groundLevelOffset
 */ function $2f44915f6f87dcf5$var$getGroundLevelOffset(elevation) {
    switch(elevation){
        case -2:
            return $2f44915f6f87dcf5$var$GROUND_LEVEL_OFFSETY.DRAINAGE;
        case 0:
            return $2f44915f6f87dcf5$var$GROUND_LEVEL_OFFSETY.ASPHALT;
        case 1:
            return $2f44915f6f87dcf5$var$GROUND_LEVEL_OFFSETY.CURB;
        case 2:
            return $2f44915f6f87dcf5$var$GROUND_LEVEL_OFFSETY.RAISED_CURB;
        default:
            return null;
    }
}
function $2f44915f6f87dcf5$export$23deed70993953e5(ctx, type, variantString, actualWidth, offsetLeft, groundBaseline, elevation = 0, randSeed, multiplier, dpi) {
    const variantInfo = (0, $0cc5ae9f1eba4866$export$a7e4a724089e6511)(type, variantString);
    const graphics = variantInfo.graphics;
    // TODO: refactor this variable
    const segmentWidth = actualWidth * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381);
    const dimensions = $2f44915f6f87dcf5$export$ef14b8f1a495a8b9(variantInfo, actualWidth);
    const left = dimensions.left;
    const minWidthQuirk = graphics.quirks?.minWidth;
    const groundLevelOffset = $2f44915f6f87dcf5$var$getGroundLevelOffset(elevation);
    const groundLevel = groundBaseline - multiplier * (groundLevelOffset / (0, $e1cc3cddc7acf1a4$export$e0fc1c07afb6e5a8) || 0);
    if (graphics.repeat) {
        // Convert single string or object values to single-item array
        let sprites = Array.isArray(graphics.repeat) ? graphics.repeat : [
            graphics.repeat
        ];
        // Convert array of strings into array of objects
        // If already an object, pass through
        sprites = sprites.map((def)=>typeof def === "string" ? {
                id: def
            } : def);
        for(let l = 0; l < sprites.length; l++){
            const sprite = (0, $0cc5ae9f1eba4866$export$28d35a9efc690b32)(sprites[l].id);
            const svg = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(sprite.id);
            // Skip drawing if sprite is missing
            if (!svg) continue;
            let width = svg.width / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953) * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381);
            const padding = sprites[l].padding ?? 0;
            let drawWidth;
            // If quirks.minWidth is defined, and the segment width is less than that
            // value, then the draw width is the minimum renderable width, not the
            // segment width. Skip this for ground assets.
            if (minWidthQuirk && actualWidth < minWidthQuirk && !sprite.id.includes("ground")) drawWidth = minWidthQuirk * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) - padding * 2 * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381);
            else drawWidth = segmentWidth - padding * 2 * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381);
            const countX = Math.floor(drawWidth / width) + 1;
            let repeatStartX;
            if (left < 0) {
                // If quirks.minWidth is defined, and the segment width is less than
                // that value, then render the left edge at minimum width boundary,
                // don't reposition it along the segment's left edge. Skip this process
                // if it's a ground asset.
                if (minWidthQuirk && actualWidth < minWidthQuirk && !sprite.id.includes("ground")) repeatStartX = 0;
                else // This is for rendering beyond the left edge of the segment
                repeatStartX = -left * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381);
            } else // This is the normal render logic.
            repeatStartX = 0;
            // The distance between the top of the sprite and the ground is
            // calculated by subtracting the height of the sprite with the # of
            // pixels to get to the point of the sprite which should align with
            // the ground.
            const distanceFromGround = multiplier * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * ((svg.height - (sprite.originY || 0)) / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953));
            // Right now only ground items repeat in the Y direction
            const height = svg.height / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953) * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381);
            // countY should always be at minimum 1.
            const countY = sprite.id.startsWith("ground--") ? Math.ceil((ctx.canvas.height / dpi - groundLevel) / height) : 1;
            for(let i = 0; i < countX; i++){
                // remainder
                if (i === countX - 1) width = drawWidth - (countX - 1) * width;
                for(let j = 0; j < countY; j++)// If the sprite being rendered is the ground, dy is equal to the
                // groundLevel. If not, dy is equal to the groundLevel minus the
                // distance the sprite will be from the ground.
                $2f44915f6f87dcf5$export$d183e74c32825504(sprite.id, ctx, undefined, undefined, width, undefined, offsetLeft + padding * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier + (repeatStartX + i * (svg.width / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953)) * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381)) * multiplier, sprite.id.startsWith("ground--") ? groundLevel + height * j : groundLevel - distanceFromGround, width, undefined, multiplier, dpi);
            }
        }
    }
    if (graphics.left) {
        const sprites = Array.isArray(graphics.left) ? graphics.left : [
            graphics.left
        ];
        for(let l = 0; l < sprites.length; l++){
            const sprite = (0, $0cc5ae9f1eba4866$export$28d35a9efc690b32)(sprites[l]);
            const svg = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(sprite.id);
            // Skip drawing if sprite is missing
            if (!svg) continue;
            let x;
            // If quirks.minWidth is defined, and the segment width is less than that
            // value, then render a left-aligned asset at minimum width boundary,
            // don't reposition it along the segment's left edge.
            // Note: this doesn't take into account the sprite.offsetX because no
            // asset with quirks.minWidth has offsetX defined right now.
            if (minWidthQuirk && actualWidth < minWidthQuirk) x = 0;
            else // This is the normal render logic.
            x = 0 + (-left + (sprite.offsetX / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953) || 0)) * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier;
            const distanceFromGround = multiplier * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * ((svg.height - (sprite.originY || 0)) / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953));
            $2f44915f6f87dcf5$export$d183e74c32825504(sprite.id, ctx, undefined, undefined, undefined, undefined, offsetLeft + x, groundLevel - distanceFromGround, undefined, undefined, multiplier, dpi);
        }
    }
    if (graphics.right) {
        const sprites = Array.isArray(graphics.right) ? graphics.right : [
            graphics.right
        ];
        for(let l = 0; l < sprites.length; l++){
            const sprite = (0, $0cc5ae9f1eba4866$export$28d35a9efc690b32)(sprites[l]);
            const svg = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(sprite.id);
            // Skip drawing if sprite is missing
            if (!svg) continue;
            let x;
            // If quirks.minWidth is defined, and the segment width is less than that
            // value, then render a right-aligned asset at minimum width boundary,
            // don't reposition it along the segment's right edge.
            // Note: this doesn't take into account the sprite.offsetX because no
            // asset with quirks.minWidth has offsetX defined right now.
            if (minWidthQuirk && actualWidth < minWidthQuirk) x = (minWidthQuirk - svg.width / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953)) * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier;
            else // This is the normal render logic.
            x = (-left + actualWidth - svg.width / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953) - (sprite.offsetX / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953) || 0)) * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier;
            const distanceFromGround = multiplier * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * ((svg.height - (sprite.originY || 0)) / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953));
            $2f44915f6f87dcf5$export$d183e74c32825504(sprite.id, ctx, undefined, undefined, undefined, undefined, offsetLeft + x, groundLevel - distanceFromGround, undefined, undefined, multiplier, dpi);
        }
    }
    if (graphics.center) {
        const sprites = Array.isArray(graphics.center) ? graphics.center : [
            graphics.center
        ];
        for(let l = 0; l < sprites.length; l++){
            const sprite = (0, $0cc5ae9f1eba4866$export$28d35a9efc690b32)(sprites[l]);
            const svg = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(sprite.id);
            // Skip drawing if sprite is missing
            if (!svg) continue;
            const center = dimensions.center;
            const offsetByPercentage = sprite.offsetX && typeof sprite.offsetX === "string" && sprite.offsetX.endsWith("%");
            const offsetX = offsetByPercentage ? 0 : sprite.offsetX;
            const x = (center - svg.width / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953) / 2 - left - (offsetByPercentage ? (0, $8b400d6ab7c299d4$export$416b4e58a6f40906)(sprite.offsetX) * center : 0) - (offsetX / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953) || 0)) * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier;
            const distanceFromGround = multiplier * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * ((svg.height - (sprite.originY || 0)) / (0, $e1cc3cddc7acf1a4$export$15ebb2a9274a9953));
            $2f44915f6f87dcf5$export$d183e74c32825504(sprite.id, ctx, undefined, undefined, undefined, undefined, offsetLeft + x, groundLevel - distanceFromGround, undefined, undefined, multiplier, dpi);
        }
    }
    // Draw items that are scattered from a pool of assets
    // Only used for random people generation right now
    if (graphics.scatter) {
        if (graphics.scatter.pool === "people") {
            const originY = (graphics.scatter.originY ?? graphics.scatter.originY + $2f44915f6f87dcf5$var$PERSON_SPRITE_OFFSET_Y) || $2f44915f6f87dcf5$var$PERSON_SPRITE_OFFSET_Y;
            const people = (0, (/*@__PURE__*/$parcel$interopDefault($fa64363c7ce044b6$exports))).map((person)=>{
                return {
                    ...person,
                    id: `people--${person.id}`,
                    originY: originY
                };
            });
            (0, $a3683c18389a345c$export$adcc0d79ef7fdf66)(people, ctx, actualWidth, offsetLeft - left * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier, groundLevel, randSeed, graphics.scatter.minSpacing, graphics.scatter.maxSpacing, $2f44915f6f87dcf5$var$PERSON_SPACING_ADJUSTMENT, graphics.scatter.padding, multiplier, dpi);
        }
        if (graphics.scatter.sprites) (0, $a3683c18389a345c$export$adcc0d79ef7fdf66)(graphics.scatter.sprites, ctx, actualWidth, offsetLeft - left * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) * multiplier, groundLevel, randSeed, graphics.scatter.minSpacing, graphics.scatter.maxSpacing, 0, graphics.scatter.padding, multiplier, dpi);
    }
}
function $2f44915f6f87dcf5$export$d5e75d6299e9897e(type, variantString) {
    const segmentInfo = (0, $0cc5ae9f1eba4866$export$c3985e6b9763d4c2)(type);
    const variantInfo = (0, $0cc5ae9f1eba4866$export$a7e4a724089e6511)(type, variantString);
    const defaultName = variantInfo.name || segmentInfo.name;
    const nameKey = variantInfo.nameKey || segmentInfo.nameKey;
    const key = `segments.${nameKey}`;
    return (0, $4daaf0496059b305$export$25868d1e8e76735f)(key, defaultName, {
        ns: "segment-info"
    });
}
function $2f44915f6f87dcf5$export$b2eeaeff46616de5() {
    const street = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street;
    const updatedStreet = (0, $d07093f2761e7137$export$c5f7f64da67f2025)(street);
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$6a7fdf0c7a380248)(updatedStreet.segments, updatedStreet.occupiedWidth, updatedStreet.remainingWidth));
    (0, $8d9791e5769125e5$export$f86dbb9897d7ebae)();
}
/**
 * Process / sanitize segment labels
 *
 * @params {string} name - Segment label to check
 * @returns {string} - normalized / sanitized segment label
 */ function $2f44915f6f87dcf5$var$normalizeSegmentLabel(label) {
    if (!label) return "";
    label = label.trim();
    if (label.length > (0, $e1cc3cddc7acf1a4$export$e552ca0126db39e7)) label = label.substr(0, (0, $e1cc3cddc7acf1a4$export$e552ca0126db39e7)) + "\u2026";
    return label;
}
function $2f44915f6f87dcf5$export$d56d73a7ccbe2018(segment, position) {
    const prevLabel = segment.label || $2f44915f6f87dcf5$export$d5e75d6299e9897e(segment.type, segment.variantString);
    const label = $2f44915f6f87dcf5$var$normalizeSegmentLabel(window.prompt((0, $4daaf0496059b305$export$25868d1e8e76735f)("prompt.segment-label", "New segment label:"), prevLabel));
    if (label && label !== prevLabel) {
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$ab16e687658adf3f)(position, {
            label: label
        }));
        $2f44915f6f87dcf5$export$b2eeaeff46616de5();
    }
}
function $2f44915f6f87dcf5$export$a3c673416be46295(position) {
    if (!position && position !== 0) return;
    let segmentEl;
    if (position === (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd)) segmentEl = document.querySelectorAll(".street-section-building")[0];
    else if (position === (0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492)) segmentEl = document.querySelectorAll(".street-section-building")[1];
    else {
        const segments = document.getElementById("street-section-editable").querySelectorAll(".segment");
        segmentEl = segments[position];
    }
    return segmentEl;
}






function $3c6cc20750b66eb4$export$a4b0a77da065d947(street) {
    let title = "";
    if (street.creatorId && (!(0, $9be7409470745503$export$1ae390d25d018ea4)() || (0, $9be7409470745503$export$6e84777bbb4941aa)().userId !== street.creatorId)) title = $3c6cc20750b66eb4$export$74146f0a5cce1d3e(street);
    else title = $3c6cc20750b66eb4$export$23286240952da4c9(street);
    document.title = title;
}
function $3c6cc20750b66eb4$export$23286240952da4c9(street) {
    const streetName = street.name || (0, $4daaf0496059b305$export$25868d1e8e76735f)("street.default-name", "Unnamed St");
    return `${streetName} \u{2013} Streetmix`;
}
function $3c6cc20750b66eb4$export$74146f0a5cce1d3e(street) {
    const streetName = street.name || (0, $4daaf0496059b305$export$25868d1e8e76735f)("street.default-name", "Unnamed St");
    return `${streetName} (by ${street.creatorId}) \u{2013} Streetmix`;
}





function $a497055cdd7884dc$export$f02c0c945aac363d() {
    // We create a string representation of the two values we need to compare
    const select = (state)=>JSON.stringify({
            name: state.street.name,
            creatorId: state.street.creatorId,
            namespacedId: state.street.namespacedId
        });
    const onChange = (string)=>{
        const street = JSON.parse(string);
        (0, $b66cc4ceae9b725e$export$6e81a82123b449bb)();
        (0, $4b803bff0fdd2b7e$export$591a8e3f6304beb0)();
        (0, $3c6cc20750b66eb4$export$a4b0a77da065d947)(street);
    };
    return (0, $81878321270eabd6$export$7eabfc5ef2a68f64)(select, onChange);
}





function $80a33a2a986105c3$export$52efb9b4108e6eb8() {
    // We create a string representation of the values we need to compare
    const select = (state)=>JSON.stringify({
            leftBuildingHeight: state.street.leftBuildingHeight,
            leftBuildingVariant: state.street.leftBuildingVariant,
            rightBuildingHeight: state.street.rightBuildingHeight,
            rightBuildingVariant: state.street.rightBuildingVariant,
            name: state.street.name,
            location: state.street.location,
            environment: state.street.environment
        });
    const onChange = ()=>{
        (0, $8d9791e5769125e5$export$f86dbb9897d7ebae)();
    };
    return (0, $81878321270eabd6$export$7eabfc5ef2a68f64)(select, onChange);
}























let $ff38ac1d71741186$var$lastRequestedStreetId = null;
function $ff38ac1d71741186$export$6889ba5d1a5cf5ad(id) {
    // Save previous street's thumbnail before switching streets.
    (0, $464cf4d7282b8d55$export$aa778ba3835fe593)((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street, (0, $464cf4d7282b8d55$export$58b08e286bcfe4aa).PREVIOUS_STREET);
    $ff38ac1d71741186$var$fetchGalleryStreet(id);
}
function $ff38ac1d71741186$var$fetchGalleryStreet(streetId) {
    (0, $875b7806636140c5$export$15b481ad22e551c2)();
    $ff38ac1d71741186$var$lastRequestedStreetId = streetId;
    (0, $4ff1018a457d25d0$export$2dd550e2c4d39aa8)(streetId).then((response)=>{
        (0, $875b7806636140c5$export$f15d98cd9142bd86)();
        return response.data;
    }).then($ff38ac1d71741186$var$receiveGalleryStreet).catch($ff38ac1d71741186$var$errorReceiveGalleryStreet);
}
// TODO similar to receiveLastStreet
function $ff38ac1d71741186$var$receiveGalleryStreet(transmission) {
    // Reject stale transmissions
    if (transmission.id !== $ff38ac1d71741186$var$lastRequestedStreetId) return;
    (0, $8d9791e5769125e5$export$996926525e13f61e)(true);
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $5e173785b5fcb8ed$export$ef18f38624819fc7)());
    (0, $a7e2543fa152618e$export$1ab2b4c3ab16ec32)(transmission, null, null, true);
    // Some parts of the UI need to know this happened to respond to it
    window.dispatchEvent(new window.CustomEvent("stmx:receive_gallery_street"));
    (0, $2f44915f6f87dcf5$export$b2eeaeff46616de5)();
    (0, $8d9791e5769125e5$export$996926525e13f61e)(false);
    (0, $8d9791e5769125e5$export$ed20678efa7800e4)();
    // Save new street's thumbnail.
    (0, $464cf4d7282b8d55$export$aa778ba3835fe593)((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street, (0, $464cf4d7282b8d55$export$58b08e286bcfe4aa).INITIAL);
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $5b2c2d9c813ed442$export$2612bdf4c0ed64d7)());
}
function $ff38ac1d71741186$var$errorReceiveGalleryStreet(err) {
    console.log(err);
    (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).GALLERY_STREET_FAILURE, false);
// updateGallerySelection()
}
async function $ff38ac1d71741186$export$c6ace8a485846f08(userId) {
    try {
        if (userId) {
            const response = await (0, $4ff1018a457d25d0$export$7956c5d98062f5ca)(userId);
            const streets = $ff38ac1d71741186$var$receiveGalleryData(response.data);
            return streets;
        } else {
            const response = await (0, $4ff1018a457d25d0$export$1ec8042d33b4a69a)();
            const streets = $ff38ac1d71741186$var$receiveGalleryData(response.data);
            return streets;
        }
    } catch (error) {
        // If the error is a 404, throw up a not-found page
        if (error.response.status === 404) {
            (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).NOT_FOUND);
            (0, $20dec064f3771e9c$export$eb2f560d6088705b)();
        }
        // Re-throw the original error. This is caught by Redux Toolkit's
        // `asyncThunkCreator` and dispatches a rejected action
        throw error;
    }
}
function $ff38ac1d71741186$var$receiveGalleryData(transmission) {
    // Prepare data object
    const streets = transmission.streets.map((street)=>{
        // There is a bug where sometimes street data is non-existent for an
        // unknown reason. Skip over so that the rest of gallery will display
        if (!street.data) return {};
        // This mutates street data in place (not preferred; TODO: fix later)
        (0, $8d9791e5769125e5$export$40f838ff08fe7f5d)(street.data.street);
        return street;
    });
    if ((0, $20dec064f3771e9c$export$1fc0f6205829e19c)() === (0, $20dec064f3771e9c$export$240b20df485e8ed6).USER_GALLERY && streets.length || (0, $20dec064f3771e9c$export$1fc0f6205829e19c)() === (0, $20dec064f3771e9c$export$240b20df485e8ed6).GLOBAL_GALLERY) $ff38ac1d71741186$export$6889ba5d1a5cf5ad(streets[0].id);
    return streets;
}








function $70b589c7079d3be9$export$f117ea785a607ea6() {
    // Add event listeners to handle when a window is switched away from view,
    // then returns to view again. If the Page Visibility API exists, we use this.
    // If the Page Visibility API does not exist (or is vendor-prefixed in much
    // older browsers), use the much-less-precise `focus` event.
    if (typeof document.hidden !== "undefined") document.addEventListener("visibilitychange", $70b589c7079d3be9$var$onVisibilityChange, false);
    else window.addEventListener("focus", $70b589c7079d3be9$export$97ad26898864c84f);
}
function $70b589c7079d3be9$export$97ad26898864c84f() {
    const state = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState();
    if (state.errors.abortEverything || state.gallery.visible) return;
    (0, $a7e2543fa152618e$export$4f8b1ea2fe2a665e)();
    // Save settings on window focus, so the last edited street is the one you’re
    // currently looking at (in case you’re looking at many streets in various
    // tabs). We don't pass in any new settings to save, but calling this does
    // trigger mirroring the app state to localstorage and user account.
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $91ffa8e8b26e8ad0$export$f558026a994b6051)());
}
function $70b589c7079d3be9$var$onVisibilityChange() {
    if (document.visibilityState !== "hidden") $70b589c7079d3be9$export$97ad26898864c84f();
}


const $8d60d83c2ee769b2$export$a2488c4469b72767 = (0, $a3ccb5670e466352$export$6abd22dc03e5063f)("gallery/openGallery", async ({ userId: userId, instant: instant = false }, { dispatch: dispatch, rejectWithValue: rejectWithValue })=>{
    (0, $4b803bff0fdd2b7e$export$591a8e3f6304beb0)(true, userId);
    (0, $edbb716917ec500c$export$10edf1ecc36bc190)();
    // TODO: Handle modes better.
    if ((0, $20dec064f3771e9c$export$1fc0f6205829e19c)() === (0, $20dec064f3771e9c$export$240b20df485e8ed6).USER_GALLERY || (0, $20dec064f3771e9c$export$1fc0f6205829e19c)() === (0, $20dec064f3771e9c$export$240b20df485e8ed6).GLOBAL_GALLERY) // Prevents showing old street before the proper street loads
    (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).NO_STREET, false);
    // Fetch data and catch errors if fetch goes wrong
    try {
        const streets = await (0, $ff38ac1d71741186$export$c6ace8a485846f08)(userId);
        return {
            streets: streets
        };
    } catch (error) {
        // If the server error is 404, special rejection value
        // to display a "not-found" screen without the gallery
        if (error.response?.status === 404) return rejectWithValue({
            killGallery: true
        });
        // Re-throw original error for normal rejection
        throw error;
    }
});
const $8d60d83c2ee769b2$export$4e47f300f46a8155 = (0, $a3ccb5670e466352$export$6abd22dc03e5063f)("gallery/closeGallery", ({ instant: instant = false } = {}, { dispatch: dispatch, getState: getState })=>{
    const state = getState();
    if (!state.errors.abortEverything) (0, $4b803bff0fdd2b7e$export$591a8e3f6304beb0)();
    (0, $70b589c7079d3be9$export$97ad26898864c84f)();
    (0, $20dec064f3771e9c$export$d4f039427a1beff1)((0, $20dec064f3771e9c$export$240b20df485e8ed6).CONTINUE);
    return {
        instant: instant
    };
}, {
    condition: (arg, { getState: getState })=>{
        const { visible: visible } = getState().gallery;
        // If gallery isn't visible, don't dispatch again
        if (!visible) return false;
    }
});











function $1dd91eb948d057ca$export$749cc622dd2e4b80(event) {
    const state = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState();
    // Don't display this in offline mode
    if (state.system.offline) return;
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ed796acc6691d871$export$2cb648f4e71e8121)({
        component: "TOAST_NO_CONNECTION",
        mode: "warning",
        duration: Infinity
    }));
}
function $1dd91eb948d057ca$var$checkIfChangesSaved() {
    if ((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().errors.abortEverything) return;
    let showWarning = false;
    if ((0, $a7e2543fa152618e$export$3cd29177e30262af)()) showWarning = true;
    // If thumbnail needs to be saved before window close, show warning.
    if (!(0, $464cf4d7282b8d55$export$b97fb1447d437ad4)()) showWarning = true;
    if (showWarning) {
        (0, $464cf4d7282b8d55$export$aa778ba3835fe593)((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().street, (0, $464cf4d7282b8d55$export$58b08e286bcfe4aa).BEFOREUNLOAD);
        return true;
    }
}
function $1dd91eb948d057ca$export$771fea967fb43461(event) {
    const shouldPrompt = $1dd91eb948d057ca$var$checkIfChangesSaved();
    if (shouldPrompt) {
        // HTML specification for prompting users if they want to leave
        // Not supported in all browsers
        event.preventDefault();
        // Custom text prompts are no longer displayed in most browsers. See:
        // https://developers.google.com/web/updates/2016/04/chrome-51-deprecations?hl=en#remove_custom_messages_in_onbeforeunload_dialogs
        // `event.returnValue` just needs to be set to _any_ string or a string
        // is returned from this handler. The browser-defined prompt will display.
        // No translation is needed.
        const string = "Your changes have not been saved yet.";
        event.returnValue = string;
        return string;
    }
}














function $846d9bfc81d2582a$export$adbfba29f0dd9074() {
    const state = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState();
    if (!state) return false;
    const signedIn = state.user?.signedIn || false;
    const creatorId = state.street?.creatorId || null;
    const userId = state.user?.signInData?.userId || null;
    if (signedIn && creatorId && creatorId === userId) return true;
    else if (!creatorId && !signedIn && !(0, $838500e3591ab346$export$210b982e99667452)()) return true;
    return false;
}





const $7e4b1d33bc4e936e$export$6e8acc5113ad37bb = (0, $a3ccb5670e466352$export$6abd22dc03e5063f)("history/handleUndo", function(arg, { dispatch: dispatch, getState: getState }) {
    const { position: position } = getState().history;
    const { street: street } = getState();
    // Don’t allow undo/redo unless you own the street
    if (position > 0 && (0, $846d9bfc81d2582a$export$adbfba29f0dd9074)()) {
        // Before undoing, send a copy of the current street data
        // to update data at the current position
        dispatch((0, $0e3fada570e844f5$export$21f930c44940fd98)((0, $8d9791e5769125e5$export$c5cc62253c2d0728)(street)));
        (0, $b66cc4ceae9b725e$export$283a3ddc6f6f78a5)();
    } else dispatch((0, $ed796acc6691d871$export$2cb648f4e71e8121)({
        message: (0, $4daaf0496059b305$export$25868d1e8e76735f)("toast.no-undo", "Nothing to undo."),
        duration: 4000
    }));
});
const $7e4b1d33bc4e936e$export$1a0a23265463691b = (0, $a3ccb5670e466352$export$6abd22dc03e5063f)("history/handleRedo", function(arg, { dispatch: dispatch, getState: getState }) {
    const { position: position, stack: stack } = getState().history;
    // Don’t allow undo/redo unless you own the street
    if (position >= 0 && position < stack.length - 1 && (0, $846d9bfc81d2582a$export$adbfba29f0dd9074)()) {
        dispatch((0, $0e3fada570e844f5$export$1688e416fee0a49e)());
        (0, $b66cc4ceae9b725e$export$283a3ddc6f6f78a5)();
    } else dispatch((0, $ed796acc6691d871$export$2cb648f4e71e8121)({
        message: (0, $4daaf0496059b305$export$25868d1e8e76735f)("toast.no-redo", "Nothing to redo."),
        duration: 4000
    }));
});



/**
 * keypress
 *
 * Handles registration, removal, and processing of keyboard inputs.
 * Some inspiration:
 *    - Mousetrap.js (https://craig.is/killing/mice)
 *    - Keypress.js (http://dmauro.github.io/Keypress/)
 *    - keymaster.js (https://github.com/madrobby/keymaster)
 *
 * @module keypress
 * @requires event-tracking
 * @exports startListening
 * @exports registerKeypress
 * @exports deregisterKeypress
 */ /**
 * Refocusing on the body immediately after some other element is
 * removed from the page allows the application to continue to receive
 * keydown events. (Otherwise the browser could capture those events
 * and do browser default actions instead.)
 * However, loseAnyFocus() is very aggressive, because if it is called at
 * the wrong time, it could cause the user to lose focus on something
 * (like an input box) improperly, so be very careful when using it.
 */ function $a23f2f80a71fc2aa$export$25f99d22563e3d91() {
    document.body.focus();
}
function $a23f2f80a71fc2aa$export$ea52154170d3a977() {
    return document.activeElement === document.body;
}


// Keep track of all registered commands here
const $89f2807011121cdf$var$inputs = {};
// Utility functions
const $89f2807011121cdf$var$noop = function() {};
const $89f2807011121cdf$var$returnTrue = function() {
    return true;
};
function $89f2807011121cdf$export$5a3c9ae1fa6d7e61() {
    window.addEventListener("keydown", $89f2807011121cdf$var$onGlobalKeyDown);
}
function $89f2807011121cdf$export$bc520ed1c57f0d75(commands, options, callback) {
    // Defaults
    // For shiftKey, metaKey, and altKey, specifies what it should
    // match on the event object reported by the browser. For instance,
    // if event.metaKey is false, it means the command must be executed
    // only if the meta key (ctrl or command depending on the OS) is not
    // pressed. (Note that ctrlKey will be internally mapped to behave
    // the same as metaKey here.) The distinction is strict, pass the
    // value 'optional' to make the system ignore whether a key is pressed.
    const defaults = {
        shiftKey: false,
        metaKey: false,
        altKey: false,
        onKeypress: $89f2807011121cdf$var$noop,
        condition: $89f2807011121cdf$var$returnTrue,
        preventDefault: true,
        stopPropagation: false,
        requireFocusOnBody: true,
        fireOnce: false
    };
    // Check if the second argument is the options object or the callback function
    if (typeof arguments[1] === "object") options = arguments[1];
    else if (typeof arguments[1] === "function") {
        // The second argument is the callback function
        // You cannot pass two callback functions
        options = {};
        callback = arguments[1];
    }
    const originalCommands = commands;
    const commandObj = $89f2807011121cdf$var$processCommands(commands);
    // Process each command input
    for(const key in commandObj){
        const commands = commandObj[key];
        for (const command of commands){
            // Get default settings
            for(const keyDefault in defaults)if (typeof command[keyDefault] === "undefined") command[keyDefault] = defaults[keyDefault];
            // Store the original commands entry
            // This helps with deregistering later
            command.originalCommands = originalCommands;
            // Special case for 'ESC' key; it defaults to global (window) focus
            if (key === "Esc" || key === "Escape") {
                command.requireFocusOnBody = false;
                command.stopPropagation = true;
            }
            // Attach callback function to execute
            if (typeof callback === "function") command.onKeypress = callback;
            // If options are specified, replace defaults
            // This basically allows other code to override settings via the
            // options object - it's dumb, but there's no protection against it,
            // and who knows, could be useful in edge cases
            for(const k in options)command[k] = options[k];
            // Add processed commands to module's inputs holder
            if (typeof $89f2807011121cdf$var$inputs[key] === "undefined") $89f2807011121cdf$var$inputs[key] = [];
            $89f2807011121cdf$var$inputs[key].push(command);
        }
    }
}
function $89f2807011121cdf$export$86df18839624bc06(commands, callback) {
    const commandObj = $89f2807011121cdf$var$processCommands(commands);
    // Process each command input
    for(const key in commandObj){
        const commands = commandObj[key];
        for (const command of commands){
            const items = $89f2807011121cdf$var$inputs[key];
            let x = items && items.length || 0;
            // Break if the derigestered command is not found (may have not been registered,
            // or already deregistered)
            if (x === 0) break;
            // A reverse while loop quickly removes all duplicates that matches
            while(x--){
                const item = items[x];
                if (item.onKeypress === callback || typeof callback === "undefined") {
                    // Check for equality for command + function
                    const isShiftOrOptional = item.shiftKey === command.shiftKey || item.shiftKey === "optional";
                    const isAltOrOptional = item.altKey === command.altKey || item.altKey === "optional";
                    const isMetaOrOptional = item.metaKey === command.metaKey || item.metaKey === "optional";
                    if (isShiftOrOptional && isAltOrOptional && isMetaOrOptional) // If matches, remove it from the command list.
                    $89f2807011121cdf$var$inputs[key].splice(x, 1);
                }
            }
        }
    }
}
/**
 * Processes commands
 *
 * @private
 * @param {(string|string[])} commands
 *    Human readable key or key combination to listen for, in the form of "a"
 *    or "shift a" or "control alt a". If multiple keys should perform the
 *    same action, pass in an array of strings, e.g. `['a', 'b', 'meta d']`
 * @returns object
 */ function $89f2807011121cdf$var$processCommands(commands) {
    // If a string, force to one-element array, otherwise expect an array of strings
    if (typeof commands === "string") commands = new Array(commands);
    const commandsObj = {};
    // Process each command input
    for (let command of commands){
        // Normalize command
        //  - adjust to lower case
        //  - normalize 'esc' to 'escape'
        //  - replace command/cmd/control/ctrl to meta (this does not remove dupes)
        command = command.toLowerCase().replace(/(command|cmd|control|ctrl)/g, "meta").split(" ");
        const settings = {
            shiftKey: false,
            altKey: false,
            metaKey: false
        };
        // Check for existence of modifier keys
        // Modifier keys are removed from input array
        const isShift = command.indexOf("shift");
        if (isShift > -1) {
            settings.shiftKey = true;
            command.splice(isShift, 1);
        }
        const isAlt = command.indexOf("alt");
        if (isAlt > -1) {
            settings.altKey = true;
            command.splice(isAlt, 1);
        }
        const isMeta = command.indexOf("meta");
        if (isMeta > -1) {
            settings.metaKey = true;
            command.splice(isMeta, 1);
        }
        // First remaining item in the input array is the key to test for.
        // Does not support multi-keys, so rest of input (if provided) is ignored.
        const key = command[0];
        // key might be a single string or an array
        if (key) {
            let keys = [];
            // If key is a string, convert to single-element array
            // Can't do a shortcut version of these with string :-/
            if (typeof key === "string") keys.push(key);
            else if (Array.isArray(key)) keys = key;
            for (const key of keys){
                let processedKey;
                switch(key){
                    case "esc":
                        processedKey = "escape";
                        break;
                    case "left":
                        processedKey = "arrowleft";
                        break;
                    case "right":
                        processedKey = "arrowright";
                        break;
                    default:
                        processedKey = key;
                        break;
                }
                settings.key = processedKey;
                if (typeof commandsObj[processedKey] === "undefined") commandsObj[processedKey] = [];
                commandsObj[processedKey].push(settings);
            }
        }
    }
    return commandsObj;
}
function $89f2807011121cdf$var$onGlobalKeyDown(event) {
    const toExecute = [];
    const key = event.key;
    // There is a bug in Chrome where events can be fired with an
    // undefined `key` property, which does not adhere to spec.
    // This can be duplicated by autofilling an input with 1Password,
    // and it may be caused by other tools as well.
    if (typeof key === "undefined") return;
    // Find the right command object
    const commandsForKey = $89f2807011121cdf$var$inputs[key.toLowerCase()];
    if (!commandsForKey || commandsForKey.length === 0) return;
    // Check if the right meta keys are down
    for (const item of commandsForKey)if ((item.shiftKey === event.shiftKey || item.shiftKey === "optional") && (item.altKey === event.altKey || item.altKey === "optional") && (item.metaKey === event.metaKey || item.metaKey === event.ctrlKey || item.metaKey === "optional")) toExecute.push(item);
    // Execute input's callbacks, if found
    for (const input of toExecute)$89f2807011121cdf$var$execute(input, event);
}
/**
 * Executes an input's callback function
 *
 * @private
 * @param {object} input - The input object to execute
 * @param {Event} [event] - The browser's `Event` object created when `keydown` is fired
 */ function $89f2807011121cdf$var$execute(input, event) {
    // Check if condition is satisfied
    if (!input.condition()) return;
    // Check if focus is on the correct place
    if (input.requireFocusOnBody === true && (0, $a23f2f80a71fc2aa$export$ea52154170d3a977)() === false) return;
    if (event && input.preventDefault) event.preventDefault();
    if (event && input.stopPropagation) event.stopPropagation();
    // Execute callback
    // Pass event through to callback function
    input.onKeypress(event);
    // Deregisters the input immediately if it is only supposed to be executed once
    if (input.fireOnce === true) $89f2807011121cdf$export$86df18839624bc06(input.originalCommands, input.onKeypress);
}



function $ff8002e1d36943dc$export$5f296c918980eccb(event) {
    switch(event.key){
        case "Esc":
        case "Escape":
            {
                const { draggingType: draggingType } = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().ui;
                if (draggingType === (0, $e1cc3cddc7acf1a4$export$e9db4516ea26d802)) (0, $edbb716917ec500c$export$70024803e1355933)();
                else if (draggingType === (0, $e1cc3cddc7acf1a4$export$78a78b4ad4d2f0b9)) // We don't handle this here anymore
                // TODO: Double check on side effects of not handling this
                return;
                else return;
                event.preventDefault();
                break;
            }
    }
}
function $ff8002e1d36943dc$export$9ed36b811bca4a56() {
    // In case anyone tries a save shortcut key out of reflex,
    // we inform the user that it's not necessary.
    (0, $89f2807011121cdf$export$bc520ed1c57f0d75)("ctrl s", function() {
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ed796acc6691d871$export$2cb648f4e71e8121)({
            message: (0, $4daaf0496059b305$export$25868d1e8e76735f)("toast.no-save", "No need to save by hand; Streetmix automatically saves your street!")
        }));
    });
    // Catch-all for the Ctrl-S shortcut from ever trying to
    // save the page contents
    (0, $89f2807011121cdf$export$bc520ed1c57f0d75)("ctrl s", {
        preventDefault: true,
        requireFocusOnBody: false
    }, ()=>{} // noop
    );
    // Catch-all for the backspace or delete buttons to prevent
    // browsers from going back in history
    (0, $89f2807011121cdf$export$bc520ed1c57f0d75)([
        "backspace",
        "delete"
    ], {
        preventDefault: true,
        requireFocusOnBody: true
    }, ()=>{} // noop
    );
    // Secret menu to toggle feature flags
    // Only active in development/staging
    (0, $89f2807011121cdf$export$bc520ed1c57f0d75)("shift f", ()=>{
        if ((0, $63b5c9d178f1431e$export$83401e34d5e11bf4) !== "production" || (0, $9be7409470745503$export$1ae390d25d018ea4)() && (0, $9be7409470745503$export$6e84777bbb4941aa)().details.roles.includes((0, (/*@__PURE__*/$parcel$interopDefault($98448114ff4d3ef1$exports))).ADMIN.value)) (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $cdf0aaca62d15025$export$61e0a65f251cfdb3)("FEATURE_FLAGS"));
    });
    // Undo
    (0, $89f2807011121cdf$export$bc520ed1c57f0d75)("ctrl z", {
        preventDefault: true,
        requireFocusOnBody: true,
        shiftKey: false
    }, ()=>{
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $7e4b1d33bc4e936e$export$6e8acc5113ad37bb)());
    });
    // Redo
    (0, $89f2807011121cdf$export$bc520ed1c57f0d75)([
        "shift ctrl z",
        "ctrl y"
    ], {
        preventDefault: true,
        requireFocusOnBody: true
    }, ()=>{
        (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $7e4b1d33bc4e936e$export$1a0a23265463691b)());
    });
}




let $7e17dc93f2b84ce7$var$streetSectionTop;
function $7e17dc93f2b84ce7$export$8734426d8f1593a2() {
    return $7e17dc93f2b84ce7$var$streetSectionTop;
}
function $7e17dc93f2b84ce7$export$c7b050c836e7ea75() {
    const viewportHeight = window.innerHeight;
    const streetSectionHeight = document.querySelector("#street-section-inner")?.offsetHeight;
    // Find the top of the palette element. If element is not present (it
    // not be rendered in some cases, e.g. when the app is in read-only mode),
    // use the viewport height.
    const paletteTop = document.querySelector(".palette-container")?.offsetTop || viewportHeight;
    // TODO const
    if (viewportHeight - streetSectionHeight > 450) $7e17dc93f2b84ce7$var$streetSectionTop = (viewportHeight - streetSectionHeight - 450) / 2 + 450 + 80;
    else $7e17dc93f2b84ce7$var$streetSectionTop = viewportHeight - streetSectionHeight + 70;
    if ((0, $9bf07f90c2c537c3$export$729c8b7179294ba).readOnly) $7e17dc93f2b84ce7$var$streetSectionTop += 80;
    // TODO const
    if ($7e17dc93f2b84ce7$var$streetSectionTop + streetSectionHeight > paletteTop - 20 + 180) // gallery height
    $7e17dc93f2b84ce7$var$streetSectionTop = paletteTop - 20 - streetSectionHeight + 180;
}
function $7e17dc93f2b84ce7$export$45b39e67d4ce4921() {
    $7e17dc93f2b84ce7$export$c7b050c836e7ea75();
    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).show(true);
}



function $ec8f13c33683bd3c$export$40a4ed63e5cb7043() {
    window.addEventListener("storage", (0, $9be7409470745503$export$525554425ef185b9));
    window.addEventListener("resize", (0, $7e17dc93f2b84ce7$export$45b39e67d4ce4921));
    window.addEventListener("pointerdown", (0, $b6e16a46f37cea3c$export$3b58b8d35cad22b9));
    window.addEventListener("pointermove", (0, $b6e16a46f37cea3c$export$78da0617e7531321));
    window.addEventListener("pointerup", (0, $b6e16a46f37cea3c$export$ca543ff484c1cc6d));
    window.addEventListener("keydown", (0, $ff8002e1d36943dc$export$5f296c918980eccb));
    window.addEventListener("beforeunload", (0, $1dd91eb948d057ca$export$771fea967fb43461));
    window.addEventListener("offline", (0, $1dd91eb948d057ca$export$749cc622dd2e4b80));
    window.addEventListener("stmx:api_max_connection", (0, $1dd91eb948d057ca$export$749cc622dd2e4b80));
    (0, $70b589c7079d3be9$export$f117ea785a607ea6)();
}







let $09d66509dd0bbd69$var$serverContacted;
function $09d66509dd0bbd69$export$a61c8ed8b4f8b308(value) {
    $09d66509dd0bbd69$var$serverContacted = value;
}
function $09d66509dd0bbd69$var$preInit() {
    (0, $c28638c59a37cdde$export$8f5274ca1f2bd1c0)();
    (0, $8d9791e5769125e5$export$996926525e13f61e)(true);
    let language = window.navigator.userLanguage || window.navigator.language;
    if (language) {
        language = language.substr(0, 2).toUpperCase();
        (0, $2fdd636378463894$export$378deebf84b03442)(language);
    }
    (0, $ff8002e1d36943dc$export$9ed36b811bca4a56)();
    // Start listening for keypresses
    (0, $89f2807011121cdf$export$5a3c9ae1fa6d7e61)();
    $09d66509dd0bbd69$var$observeStoreToUpdateBodyClasses();
}
async function $09d66509dd0bbd69$export$2a47f398eeff8b01() {
    $09d66509dd0bbd69$var$preInit();
    window.dispatchEvent(new window.CustomEvent("stmx:init"));
    (0, $4b803bff0fdd2b7e$export$8378cb52a6ed7e05)();
    (0, $20dec064f3771e9c$export$eb2f560d6088705b)();
    if ((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().errors.abortEverything) return;
    (0, $e67fd05cb5630e00$export$d9633e935e40fe0c)();
    // Asynchronously loading…
    // Geolocation
    // …detect country from IP for units, left/right-hand driving, and
    // adding location to streets
    // This dispatch returns a Promise. We await it so we can update
    // settings when it's retrieved. TODO: handle this in Redux
    const geo = await (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ca8c478b1d098cf7$export$468558a22f9ceef8)());
    if (geo?.payload?.country_code) (0, $2fdd636378463894$export$378deebf84b03442)(geo.payload.country_code);
    // Parallel tasks
    await Promise.all([
        (0, $898fc845a8d311b5$export$211b51324b5b532c)(),
        (0, $4daaf0496059b305$export$837ecaa4d8b8583a)()
    ]);
    // Sign in
    // …sign in info from our API (if not previously cached) – and subsequent
    // street data if necessary (depending on the mode)
    await (0, $9be7409470745503$export$8fbaa7a7148eca2f)();
    // Note that we are waiting for sign in and image info to show the page,
    // but we give up on country info if it’s more than 1000ms.
    $09d66509dd0bbd69$export$2e099ed765eee04b();
}
function $09d66509dd0bbd69$export$2e099ed765eee04b() {
    if ((0, $81878321270eabd6$export$2e2bcd8739ae039).getState().errors.abortEverything) return;
    if ($09d66509dd0bbd69$var$serverContacted) $09d66509dd0bbd69$var$onEverythingLoaded();
}
function $09d66509dd0bbd69$var$onEverythingLoaded() {
    if ((0, $20dec064f3771e9c$export$1fc0f6205829e19c)() === (0, $20dec064f3771e9c$export$240b20df485e8ed6).NEW_STREET_COPY_LAST) (0, $a7e2543fa152618e$export$335b7f5f1cc4de5)();
    (0, $2f44915f6f87dcf5$export$b2eeaeff46616de5)();
    (0, $8d9791e5769125e5$export$996926525e13f61e)(false);
    (0, $8d9791e5769125e5$export$ed20678efa7800e4)();
    (0, $80a33a2a986105c3$export$52efb9b4108e6eb8)();
    (0, $036006ab2c0b720b$export$74f321e99710cbf6)();
    (0, $ace8e83c2a1e413b$export$9e63be9ae2928d00)();
    (0, $464cf4d7282b8d55$export$bbdde34c424fcda1)();
    (0, $a497055cdd7884dc$export$f02c0c945aac363d)();
    (0, $3506aa481686351c$export$b3917f912083d46a)();
    (0, $b6e16a46f37cea3c$export$5934e6aec88f0d99)();
    (0, $ec8f13c33683bd3c$export$40a4ed63e5cb7043)();
    $09d66509dd0bbd69$var$showConsoleMessage();
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $9dbab908c178b0dc$export$eef62c34974c5385)());
    const mode = (0, $20dec064f3771e9c$export$1fc0f6205829e19c)();
    if (mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).USER_GALLERY) (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8d60d83c2ee769b2$export$a2488c4469b72767)({
        userId: (0, $81878321270eabd6$export$2e2bcd8739ae039).getState().gallery.userId,
        instant: true
    }));
    else if (mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).GLOBAL_GALLERY) (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8d60d83c2ee769b2$export$a2488c4469b72767)({
        instant: true
    }));
    if ((0, $838500e3591ab346$export$7dd404efba2534f8)()) (0, $838500e3591ab346$export$6658ad06634d906a)();
    // Display "support Streetmix" dialog for returning users
    if (mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).EXISTING_STREET || mode === (0, $20dec064f3771e9c$export$240b20df485e8ed6).CONTINUE) {
        let welcomeDismissed;
        let canDisplayWhatsNew = false;
        const LSKEY_WELCOME_DISMISSED = "settings-welcome-dismissed";
        const LSKEY_WHATSNEW_LAST_TIMESTAMP = "whatsnew-last-timestamp";
        const whatsNewTimestamp = 1537222458620 // Hard-coded value
        ;
        const state = (0, $81878321270eabd6$export$2e2bcd8739ae039).getState();
        const whatsNewFlag = state.flags.ALWAYS_DISPLAY_WHATS_NEW.value;
        const locale = state.locale.locale;
        if (window.localStorage[LSKEY_WELCOME_DISMISSED]) welcomeDismissed = JSON.parse(window.localStorage[LSKEY_WELCOME_DISMISSED]);
        if (window.localStorage[LSKEY_WHATSNEW_LAST_TIMESTAMP]) {
            if (whatsNewTimestamp > window.localStorage[LSKEY_WHATSNEW_LAST_TIMESTAMP]) canDisplayWhatsNew = true;
        } else canDisplayWhatsNew = true;
        // When to display the What's new dialog?
        // - Store a hardcoded timestamp value here for the what's new dialog.
        // - When we display the what's new dialog, store that timestamp on user's localstorage.
        // On each load, check to see if that timestamp is there, and if so, compare
        // with the hardcoded value.
        // - If we are showing the welcome message, do not show What's New.
        // - If locale is not English, do not show What's New. (We haven't localized it.)
        // - If LocalStorage has no What's New timestamp, display What's New.
        // - If LocalStorage has a timestamp value older than current, display What's New.
        if (welcomeDismissed && canDisplayWhatsNew && locale === "en" || whatsNewFlag) {
            (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $cdf0aaca62d15025$export$61e0a65f251cfdb3)("WHATS_NEW"));
            window.localStorage[LSKEY_WHATSNEW_LAST_TIMESTAMP] = whatsNewTimestamp;
        }
    }
}
function $09d66509dd0bbd69$var$showConsoleMessage() {
    console.log(`%c
  ____  _    %cWelcome to%c   _             _      _
 / ___|| |_ _ __ ___  ___| |_ _ __ ___ (_)_  _| |
 \\___ \\| __| '__/ _ \\/ _ \\ __| '_ \` _ \\| \\ \\/ / |
  ___) | |_| | |  __/  __/ |_| | | | | | |>  <|_|
 |____/ \\__|_|  \\___|\\___|\\__|_| |_| |_|_/_/\\_(_)
%c..:                                            :..
..:    Contribute to our open-source code!     :..
..:   https://github.com/streetmix/streetmix   :..
%c..:                                            :..
..:          Please sponsor our work!          :..
..:    https://opencollective.com/streetmix    :..`, "font-family: monospace; color: green", "font-family: monospace; color: gray", "font-family: monospace; color: green", "font-family: monospace; color: blue", "font-family: monospace; color: red");
}
/**
 * Toggle features based on system state. (This allows toggling to debug things,
 * which will allow us to remove the debug URL parameters as a future TODO)
 */ function $09d66509dd0bbd69$var$observeStoreToUpdateBodyClasses() {
    const select = (state)=>({
            system: state.system,
            app: state.app
        });
    const onChange = (state)=>{
        document.body.classList.toggle("windows", state.system.windows);
        document.body.classList.toggle("safari", state.system.safari);
        document.body.classList.toggle("phone", state.system.phone);
        document.body.classList.toggle("read-only", state.app.readOnly);
    };
    return (0, $81878321270eabd6$export$7eabfc5ef2a68f64)(select, onChange);
}




var $4DE7A = parcelRequire("4DE7A");
var $d05758791eb139fa$exports = {};
"use strict";
Object.defineProperty($d05758791eb139fa$exports, "__esModule", {
    value: true
});
$d05758791eb139fa$exports.FormattedListParts = $d05758791eb139fa$exports.FormattedNumberParts = $d05758791eb139fa$exports.FormattedTimeParts = $d05758791eb139fa$exports.FormattedDateParts = $d05758791eb139fa$exports.FormattedDisplayName = $d05758791eb139fa$exports.FormattedList = $d05758791eb139fa$exports.FormattedNumber = $d05758791eb139fa$exports.FormattedTime = $d05758791eb139fa$exports.FormattedDate = $d05758791eb139fa$exports.defineMessage = $d05758791eb139fa$exports.defineMessages = $d05758791eb139fa$exports.ReactIntlError = $d05758791eb139fa$exports.ReactIntlErrorCode = $d05758791eb139fa$exports.MissingTranslationError = $d05758791eb139fa$exports.MessageFormatError = $d05758791eb139fa$exports.MissingDataError = $d05758791eb139fa$exports.InvalidConfigError = $d05758791eb139fa$exports.UnsupportedFormatterError = $d05758791eb139fa$exports.createIntlCache = $d05758791eb139fa$exports.useIntl = $d05758791eb139fa$exports.injectIntl = $d05758791eb139fa$exports.createIntl = $d05758791eb139fa$exports.RawIntlProvider = $d05758791eb139fa$exports.IntlProvider = $d05758791eb139fa$exports.IntlContext = $d05758791eb139fa$exports.FormattedRelativeTime = $d05758791eb139fa$exports.FormattedPlural = $d05758791eb139fa$exports.FormattedMessage = $d05758791eb139fa$exports.FormattedDateTimeRange = void 0;

var $eIwgG = parcelRequire("eIwgG");
var $3e656165af881f1f$exports = {};
"use strict";
Object.defineProperty($3e656165af881f1f$exports, "__esModule", {
    value: true
});
$3e656165af881f1f$exports.createFormattedComponent = $3e656165af881f1f$exports.createFormattedDateTimePartsComponent = $3e656165af881f1f$exports.FormattedListParts = $3e656165af881f1f$exports.FormattedNumberParts = void 0;

var $eIwgG = parcelRequire("eIwgG");

var $3e656165af881f1f$var$React = $eIwgG.__importStar((parcelRequire("4DE7A")));

var $3e656165af881f1f$var$useIntl_1 = $eIwgG.__importDefault((parcelRequire("eVtUR")));
var $3e656165af881f1f$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($3e656165af881f1f$var$DisplayName || ($3e656165af881f1f$var$DisplayName = {}));
var $3e656165af881f1f$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($3e656165af881f1f$var$DisplayNameParts || ($3e656165af881f1f$var$DisplayNameParts = {}));
var $3e656165af881f1f$var$FormattedNumberParts = function(props) {
    var intl = (0, $3e656165af881f1f$var$useIntl_1.default)();
    var value = props.value, children = props.children, formatProps = $eIwgG.__rest(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$3e656165af881f1f$exports.FormattedNumberParts = $3e656165af881f1f$var$FormattedNumberParts;
$3e656165af881f1f$exports.FormattedNumberParts.displayName = "FormattedNumberParts";
var $3e656165af881f1f$var$FormattedListParts = function(props) {
    var intl = (0, $3e656165af881f1f$var$useIntl_1.default)();
    var value = props.value, children = props.children, formatProps = $eIwgG.__rest(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$3e656165af881f1f$exports.FormattedListParts = $3e656165af881f1f$var$FormattedListParts;
$3e656165af881f1f$exports.FormattedNumberParts.displayName = "FormattedNumberParts";
function $3e656165af881f1f$var$createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function(props) {
        var intl = (0, $3e656165af881f1f$var$useIntl_1.default)();
        var value = props.value, children = props.children, formatProps = $eIwgG.__rest(props, [
            "value",
            "children"
        ]);
        var date = typeof value === "string" ? new Date(value || 0) : value;
        var formattedParts = name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $3e656165af881f1f$var$DisplayNameParts[name];
    return ComponentParts;
}
$3e656165af881f1f$exports.createFormattedDateTimePartsComponent = $3e656165af881f1f$var$createFormattedDateTimePartsComponent;
function $3e656165af881f1f$var$createFormattedComponent(name) {
    var Component = function(props) {
        var intl = (0, $3e656165af881f1f$var$useIntl_1.default)();
        var value = props.value, children = props.children, formatProps = $eIwgG.__rest(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        var Text = intl.textComponent || $3e656165af881f1f$var$React.Fragment;
        return $3e656165af881f1f$var$React.createElement(Text, null, formattedValue);
    };
    Component.displayName = $3e656165af881f1f$var$DisplayName[name];
    return Component;
}
$3e656165af881f1f$exports.createFormattedComponent = $3e656165af881f1f$var$createFormattedComponent;



var $d05758791eb139fa$var$injectIntl_1 = $eIwgG.__importStar((parcelRequire("a1NwE")));
$d05758791eb139fa$exports.injectIntl = $d05758791eb139fa$var$injectIntl_1.default;
Object.defineProperty($d05758791eb139fa$exports, "RawIntlProvider", {
    enumerable: true,
    get: function() {
        return $d05758791eb139fa$var$injectIntl_1.Provider;
    }
});
Object.defineProperty($d05758791eb139fa$exports, "IntlContext", {
    enumerable: true,
    get: function() {
        return $d05758791eb139fa$var$injectIntl_1.Context;
    }
});

var $d05758791eb139fa$var$useIntl_1 = $eIwgG.__importDefault((parcelRequire("eVtUR")));
$d05758791eb139fa$exports.useIntl = $d05758791eb139fa$var$useIntl_1.default;

var $d05758791eb139fa$var$provider_1 = $eIwgG.__importStar((parcelRequire("85suM")));
$d05758791eb139fa$exports.IntlProvider = $d05758791eb139fa$var$provider_1.default;
Object.defineProperty($d05758791eb139fa$exports, "createIntl", {
    enumerable: true,
    get: function() {
        return $d05758791eb139fa$var$provider_1.createIntl;
    }
});

var $d05758791eb139fa$var$relative_1 = $eIwgG.__importDefault((parcelRequire("aE98L")));
$d05758791eb139fa$exports.FormattedRelativeTime = $d05758791eb139fa$var$relative_1.default;

var $d05758791eb139fa$var$plural_1 = $eIwgG.__importDefault((parcelRequire("gl6Q3")));
$d05758791eb139fa$exports.FormattedPlural = $d05758791eb139fa$var$plural_1.default;

var $d05758791eb139fa$var$message_1 = $eIwgG.__importDefault((parcelRequire("9Jpl6")));
$d05758791eb139fa$exports.FormattedMessage = $d05758791eb139fa$var$message_1.default;

var $d05758791eb139fa$var$dateTimeRange_1 = $eIwgG.__importDefault((parcelRequire("lsukT")));
$d05758791eb139fa$exports.FormattedDateTimeRange = $d05758791eb139fa$var$dateTimeRange_1.default;

var $6RKOV = parcelRequire("6RKOV");
Object.defineProperty($d05758791eb139fa$exports, "createIntlCache", {
    enumerable: true,
    get: function() {
        return $6RKOV.createIntlCache;
    }
});
Object.defineProperty($d05758791eb139fa$exports, "UnsupportedFormatterError", {
    enumerable: true,
    get: function() {
        return $6RKOV.UnsupportedFormatterError;
    }
});
Object.defineProperty($d05758791eb139fa$exports, "InvalidConfigError", {
    enumerable: true,
    get: function() {
        return $6RKOV.InvalidConfigError;
    }
});
Object.defineProperty($d05758791eb139fa$exports, "MissingDataError", {
    enumerable: true,
    get: function() {
        return $6RKOV.MissingDataError;
    }
});
Object.defineProperty($d05758791eb139fa$exports, "MessageFormatError", {
    enumerable: true,
    get: function() {
        return $6RKOV.MessageFormatError;
    }
});
Object.defineProperty($d05758791eb139fa$exports, "MissingTranslationError", {
    enumerable: true,
    get: function() {
        return $6RKOV.MissingTranslationError;
    }
});
Object.defineProperty($d05758791eb139fa$exports, "ReactIntlErrorCode", {
    enumerable: true,
    get: function() {
        return $6RKOV.IntlErrorCode;
    }
});
Object.defineProperty($d05758791eb139fa$exports, "ReactIntlError", {
    enumerable: true,
    get: function() {
        return $6RKOV.IntlError;
    }
});
function $d05758791eb139fa$var$defineMessages(msgs) {
    return msgs;
}
$d05758791eb139fa$exports.defineMessages = $d05758791eb139fa$var$defineMessages;
function $d05758791eb139fa$var$defineMessage(msg) {
    return msg;
}
$d05758791eb139fa$exports.defineMessage = $d05758791eb139fa$var$defineMessage;
// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./src/types').CustomFormatConfig`
$d05758791eb139fa$exports.FormattedDate = (0, $3e656165af881f1f$exports.createFormattedComponent)("formatDate");
$d05758791eb139fa$exports.FormattedTime = (0, $3e656165af881f1f$exports.createFormattedComponent)("formatTime");
$d05758791eb139fa$exports.FormattedNumber = (0, $3e656165af881f1f$exports.createFormattedComponent)("formatNumber");
$d05758791eb139fa$exports.FormattedList = (0, $3e656165af881f1f$exports.createFormattedComponent)("formatList");
$d05758791eb139fa$exports.FormattedDisplayName = (0, $3e656165af881f1f$exports.createFormattedComponent)("formatDisplayName");
$d05758791eb139fa$exports.FormattedDateParts = (0, $3e656165af881f1f$exports.createFormattedDateTimePartsComponent)("formatDate");
$d05758791eb139fa$exports.FormattedTimeParts = (0, $3e656165af881f1f$exports.createFormattedDateTimePartsComponent)("formatTime");

Object.defineProperty($d05758791eb139fa$exports, "FormattedNumberParts", {
    enumerable: true,
    get: function() {
        return $3e656165af881f1f$exports.FormattedNumberParts;
    }
});
Object.defineProperty($d05758791eb139fa$exports, "FormattedListParts", {
    enumerable: true,
    get: function() {
        return $3e656165af881f1f$exports.FormattedListParts;
    }
});




var $4DE7A = parcelRequire("4DE7A");
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ function $2daa4a08f076625e$export$f5708dca728d7177(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}


var $0da669d2ada77527$export$3fc3a33e48b33945 = "dnd-core/INIT_COORDS";
var $0da669d2ada77527$export$98f9b4193e6b55e6 = "dnd-core/BEGIN_DRAG";
var $0da669d2ada77527$export$22d1d88e2de0d0e0 = "dnd-core/PUBLISH_DRAG_SOURCE";
var $0da669d2ada77527$export$9d358706ccac3727 = "dnd-core/HOVER";
var $0da669d2ada77527$export$b4af72c40fd57063 = "dnd-core/DROP";
var $0da669d2ada77527$export$d300627d16aeb9cc = "dnd-core/END_DRAG";


function $8b6157ce26a40fbc$export$844048139dfc906d(clientOffset, sourceClientOffset) {
    return {
        type: (0, $0da669d2ada77527$export$3fc3a33e48b33945),
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}


function $5f6072b7bb395caa$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5f6072b7bb395caa$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5f6072b7bb395caa$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5f6072b7bb395caa$var$_typeof(obj);
}
function $5f6072b7bb395caa$export$3988ae62b71be9a3(obj, path, defaultValue) {
    return path.split(".").reduce(function(a, c) {
        return a && a[c] ? a[c] : defaultValue || null;
    }, obj);
}
function $5f6072b7bb395caa$export$5d14bf425b37f49e(items, item) {
    return items.filter(function(i) {
        return i !== item;
    });
}
function $5f6072b7bb395caa$export$844ec244b1367d54(input) {
    return typeof input === "string";
}
function $5f6072b7bb395caa$export$a6cdc56e425d0d0a(input) {
    return $5f6072b7bb395caa$var$_typeof(input) === "object";
}
function $5f6072b7bb395caa$export$6444ef5cd411280c(itemsA, itemsB) {
    var map = new Map();
    var insertItem = function insertItem(item) {
        map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    var result = [];
    map.forEach(function(count, key) {
        if (count === 1) result.push(key);
    });
    return result;
}
function $5f6072b7bb395caa$export$bc86dfbf7795668c(itemsA, itemsB) {
    return itemsA.filter(function(t) {
        return itemsB.indexOf(t) > -1;
    });
}



var $873b0f1bd3d8e44a$var$ResetCoordinatesAction = {
    type: (0, $0da669d2ada77527$export$3fc3a33e48b33945),
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function $873b0f1bd3d8e44a$export$d6542eb0d76867d6(manager) {
    return function beginDrag() {
        var sourceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            publishSource: true
        };
        var _options$publishSourc = options.publishSource, publishSource = _options$publishSourc === void 0 ? true : _options$publishSourc, clientOffset = options.clientOffset, getSourceClientOffset = options.getSourceClientOffset;
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry(); // Initialize the coordinates using the client offset
        manager.dispatch((0, $8b6157ce26a40fbc$export$844048139dfc906d)(clientOffset));
        $873b0f1bd3d8e44a$var$verifyInvariants(sourceIds, monitor, registry); // Get the draggable source
        var sourceId = $873b0f1bd3d8e44a$var$getDraggableSource(sourceIds, monitor);
        if (sourceId === null) {
            manager.dispatch($873b0f1bd3d8e44a$var$ResetCoordinatesAction);
            return;
        } // Get the source client offset
        var sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) throw new Error("getSourceClientOffset must be defined");
            $873b0f1bd3d8e44a$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        } // Initialize the full coordinates
        manager.dispatch((0, $8b6157ce26a40fbc$export$844048139dfc906d)(clientOffset, sourceClientOffset));
        var source = registry.getSource(sourceId);
        var item = source.beginDrag(monitor, sourceId); // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) return undefined;
        $873b0f1bd3d8e44a$var$verifyItemIsObject(item);
        registry.pinSource(sourceId);
        var itemType = registry.getSourceType(sourceId);
        return {
            type: (0, $0da669d2ada77527$export$98f9b4193e6b55e6),
            payload: {
                itemType: itemType,
                item: item,
                sourceId: sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function $873b0f1bd3d8e44a$var$verifyInvariants(sourceIds, monitor, registry) {
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(!monitor.isDragging(), "Cannot call beginDrag while dragging.");
    sourceIds.forEach(function(sourceId) {
        (0, $2daa4a08f076625e$export$f5708dca728d7177)(registry.getSource(sourceId), "Expected sourceIds to be registered.");
    });
}
function $873b0f1bd3d8e44a$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof getSourceClientOffset === "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function $873b0f1bd3d8e44a$var$verifyItemIsObject(item) {
    (0, $2daa4a08f076625e$export$f5708dca728d7177)((0, $5f6072b7bb395caa$export$a6cdc56e425d0d0a)(item), "Item must be an object.");
}
function $873b0f1bd3d8e44a$var$getDraggableSource(sourceIds, monitor) {
    var sourceId = null;
    for(var i = sourceIds.length - 1; i >= 0; i--)if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
    }
    return sourceId;
}



function $131cbd712487bda9$export$1675a481db21e714(manager) {
    return function publishDragSource() {
        var monitor = manager.getMonitor();
        if (monitor.isDragging()) return {
            type: (0, $0da669d2ada77527$export$22d1d88e2de0d0e0)
        };
    };
}



function $0c70f113351fdf25$export$2d6239ff106f142f(targetType, draggedItemType) {
    if (draggedItemType === null) return targetType === null;
    return Array.isArray(targetType) ? targetType.some(function(t) {
        return t === draggedItemType;
    }) : targetType === draggedItemType;
}



function $95bf6bb0aeb2fdc5$export$2f85b44a1d72ad03(manager) {
    return function hover(targetIdsArg) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, clientOffset = _ref.clientOffset;
        $95bf6bb0aeb2fdc5$var$verifyTargetIdsIsArray(targetIdsArg);
        var targetIds = targetIdsArg.slice(0);
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        $95bf6bb0aeb2fdc5$var$checkInvariants(targetIds, monitor, registry);
        var draggedItemType = monitor.getItemType();
        $95bf6bb0aeb2fdc5$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        $95bf6bb0aeb2fdc5$var$hoverAllTargets(targetIds, monitor, registry);
        return {
            type: (0, $0da669d2ada77527$export$9d358706ccac3727),
            payload: {
                targetIds: targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function $95bf6bb0aeb2fdc5$var$verifyTargetIdsIsArray(targetIdsArg) {
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(Array.isArray(targetIdsArg), "Expected targetIds to be an array.");
}
function $95bf6bb0aeb2fdc5$var$checkInvariants(targetIds, monitor, registry) {
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(monitor.isDragging(), "Cannot call hover while not dragging.");
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(!monitor.didDrop(), "Cannot call hover after drop.");
    for(var i = 0; i < targetIds.length; i++){
        var targetId = targetIds[i];
        (0, $2daa4a08f076625e$export$f5708dca728d7177)(targetIds.lastIndexOf(targetId) === i, "Expected targetIds to be unique in the passed array.");
        var target = registry.getTarget(targetId);
        (0, $2daa4a08f076625e$export$f5708dca728d7177)(target, "Expected targetIds to be registered.");
    }
}
function $95bf6bb0aeb2fdc5$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(var i = targetIds.length - 1; i >= 0; i--){
        var targetId = targetIds[i];
        var targetType = registry.getTargetType(targetId);
        if (!(0, $0c70f113351fdf25$export$2d6239ff106f142f)(targetType, draggedItemType)) targetIds.splice(i, 1);
    }
}
function $95bf6bb0aeb2fdc5$var$hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        var target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}





function $248e75a0889ae4e3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $248e75a0889ae4e3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $248e75a0889ae4e3$var$ownKeys(Object(source), true).forEach(function(key) {
            $248e75a0889ae4e3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $248e75a0889ae4e3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $248e75a0889ae4e3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $248e75a0889ae4e3$export$9f5cbae8d079dda0(manager) {
    return function drop() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        $248e75a0889ae4e3$var$verifyInvariants(monitor);
        var targetIds = $248e75a0889ae4e3$var$getDroppableTargets(monitor); // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach(function(targetId, index) {
            var dropResult = $248e75a0889ae4e3$var$determineDropResult(targetId, index, registry, monitor);
            var action = {
                type: (0, $0da669d2ada77527$export$b4af72c40fd57063),
                payload: {
                    dropResult: $248e75a0889ae4e3$var$_objectSpread($248e75a0889ae4e3$var$_objectSpread({}, options), dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function $248e75a0889ae4e3$var$verifyInvariants(monitor) {
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(monitor.isDragging(), "Cannot call drop while not dragging.");
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(!monitor.didDrop(), "Cannot call drop twice during one drag operation.");
}
function $248e75a0889ae4e3$var$determineDropResult(targetId, index, registry, monitor) {
    var target = registry.getTarget(targetId);
    var dropResult = target ? target.drop(monitor, targetId) : undefined;
    $248e75a0889ae4e3$var$verifyDropResultType(dropResult);
    if (typeof dropResult === "undefined") dropResult = index === 0 ? {} : monitor.getDropResult();
    return dropResult;
}
function $248e75a0889ae4e3$var$verifyDropResultType(dropResult) {
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof dropResult === "undefined" || (0, $5f6072b7bb395caa$export$a6cdc56e425d0d0a)(dropResult), "Drop result must either be an object or undefined.");
}
function $248e75a0889ae4e3$var$getDroppableTargets(monitor) {
    var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}




function $47b68d1d980f9942$export$2f5c7d4805260fdf(manager) {
    return function endDrag() {
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        $47b68d1d980f9942$var$verifyIsDragging(monitor);
        var sourceId = monitor.getSourceId();
        if (sourceId != null) {
            var source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: (0, $0da669d2ada77527$export$d300627d16aeb9cc)
        };
    };
}
function $47b68d1d980f9942$var$verifyIsDragging(monitor) {
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(monitor.isDragging(), "Cannot call endDrag while not dragging.");
}



function $97ce65fe8ed13423$export$ac1b80e79f04247f(manager) {
    return {
        beginDrag: (0, $873b0f1bd3d8e44a$export$d6542eb0d76867d6)(manager),
        publishDragSource: (0, $131cbd712487bda9$export$1675a481db21e714)(manager),
        hover: (0, $95bf6bb0aeb2fdc5$export$2f85b44a1d72ad03)(manager),
        drop: (0, $248e75a0889ae4e3$export$9f5cbae8d079dda0)(manager),
        endDrag: (0, $47b68d1d980f9942$export$2f5c7d4805260fdf)(manager)
    };
}


function $deb68607e6e34bcf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $deb68607e6e34bcf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $deb68607e6e34bcf$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $deb68607e6e34bcf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $deb68607e6e34bcf$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $deb68607e6e34bcf$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $deb68607e6e34bcf$export$1141bbf61324c55f = /*#__PURE__*/ function() {
    function DragDropManagerImpl(store, monitor) {
        var _this = this;
        $deb68607e6e34bcf$var$_classCallCheck(this, DragDropManagerImpl);
        $deb68607e6e34bcf$var$_defineProperty(this, "store", void 0);
        $deb68607e6e34bcf$var$_defineProperty(this, "monitor", void 0);
        $deb68607e6e34bcf$var$_defineProperty(this, "backend", void 0);
        $deb68607e6e34bcf$var$_defineProperty(this, "isSetUp", false);
        $deb68607e6e34bcf$var$_defineProperty(this, "handleRefCountChange", function() {
            var shouldSetUp = _this.store.getState().refCount > 0;
            if (_this.backend) {
                if (shouldSetUp && !_this.isSetUp) {
                    _this.backend.setup();
                    _this.isSetUp = true;
                } else if (!shouldSetUp && _this.isSetUp) {
                    _this.backend.teardown();
                    _this.isSetUp = false;
                }
            }
        });
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
    $deb68607e6e34bcf$var$_createClass(DragDropManagerImpl, [
        {
            key: "receiveBackend",
            value: function receiveBackend(backend) {
                this.backend = backend;
            }
        },
        {
            key: "getMonitor",
            value: function getMonitor() {
                return this.monitor;
            }
        },
        {
            key: "getBackend",
            value: function getBackend() {
                return this.backend;
            }
        },
        {
            key: "getRegistry",
            value: function getRegistry() {
                return this.monitor.registry;
            }
        },
        {
            key: "getActions",
            value: function getActions() {
                /* eslint-disable-next-line @typescript-eslint/no-this-alias */ var manager = this;
                var dispatch = this.store.dispatch;
                function bindActionCreator(actionCreator) {
                    return function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        var action = actionCreator.apply(manager, args);
                        if (typeof action !== "undefined") dispatch(action);
                    };
                }
                var actions = (0, $97ce65fe8ed13423$export$ac1b80e79f04247f)(this);
                return Object.keys(actions).reduce(function(boundActions, key) {
                    var action = actions[key];
                    boundActions[key] = bindActionCreator(action);
                    return boundActions;
                }, {});
            }
        },
        {
            key: "dispatch",
            value: function dispatch(action) {
                this.store.dispatch(action);
            }
        }
    ]);
    return DragDropManagerImpl;
}();




var $dbf52f5949ba3eaf$export$2116cbe61f6a442a = function strictEquality(a, b) {
    return a === b;
};
function $dbf52f5949ba3eaf$export$102b20725d4d2263(offsetA, offsetB) {
    if (!offsetA && !offsetB) return true;
    else if (!offsetA || !offsetB) return false;
    else return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
function $dbf52f5949ba3eaf$export$94fd53d40f0652a(a, b) {
    var isEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $dbf52f5949ba3eaf$export$2116cbe61f6a442a;
    if (a.length !== b.length) return false;
    for(var i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) return false;
    }
    return true;
}


function $48afd727940a32fb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $48afd727940a32fb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $48afd727940a32fb$var$ownKeys(Object(source), true).forEach(function(key) {
            $48afd727940a32fb$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $48afd727940a32fb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $48afd727940a32fb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $48afd727940a32fb$var$initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function $48afd727940a32fb$export$533b26079ad0b4b() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $48afd727940a32fb$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var payload = action.payload;
    switch(action.type){
        case 0, $0da669d2ada77527$export$3fc3a33e48b33945:
        case 0, $0da669d2ada77527$export$98f9b4193e6b55e6:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case 0, $0da669d2ada77527$export$9d358706ccac3727:
            if ((0, $dbf52f5949ba3eaf$export$102b20725d4d2263)(state.clientOffset, payload.clientOffset)) return state;
            return $48afd727940a32fb$var$_objectSpread($48afd727940a32fb$var$_objectSpread({}, state), {}, {
                clientOffset: payload.clientOffset
            });
        case 0, $0da669d2ada77527$export$d300627d16aeb9cc:
        case 0, $0da669d2ada77527$export$b4af72c40fd57063:
            return $48afd727940a32fb$var$initialState;
        default:
            return state;
    }
}



var $052270500d6f3261$export$b36933c81fb1c092 = "dnd-core/ADD_SOURCE";
var $052270500d6f3261$export$2c313542981556ae = "dnd-core/ADD_TARGET";
var $052270500d6f3261$export$13332566b98b8783 = "dnd-core/REMOVE_SOURCE";
var $052270500d6f3261$export$82ace346d17d8869 = "dnd-core/REMOVE_TARGET";
function $052270500d6f3261$export$bc333c64f07a75c4(sourceId) {
    return {
        type: $052270500d6f3261$export$b36933c81fb1c092,
        payload: {
            sourceId: sourceId
        }
    };
}
function $052270500d6f3261$export$9dd68fe78f37278b(targetId) {
    return {
        type: $052270500d6f3261$export$2c313542981556ae,
        payload: {
            targetId: targetId
        }
    };
}
function $052270500d6f3261$export$c724aacd61334138(sourceId) {
    return {
        type: $052270500d6f3261$export$13332566b98b8783,
        payload: {
            sourceId: sourceId
        }
    };
}
function $052270500d6f3261$export$20ae7ec87f7f8696(targetId) {
    return {
        type: $052270500d6f3261$export$82ace346d17d8869,
        payload: {
            targetId: targetId
        }
    };
}



function $5ee13175d8f41d83$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5ee13175d8f41d83$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5ee13175d8f41d83$var$ownKeys(Object(source), true).forEach(function(key) {
            $5ee13175d8f41d83$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5ee13175d8f41d83$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5ee13175d8f41d83$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5ee13175d8f41d83$var$initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function $5ee13175d8f41d83$export$533b26079ad0b4b() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $5ee13175d8f41d83$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var payload = action.payload;
    switch(action.type){
        case 0, $0da669d2ada77527$export$98f9b4193e6b55e6:
            return $5ee13175d8f41d83$var$_objectSpread($5ee13175d8f41d83$var$_objectSpread({}, state), {}, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case 0, $0da669d2ada77527$export$22d1d88e2de0d0e0:
            return $5ee13175d8f41d83$var$_objectSpread($5ee13175d8f41d83$var$_objectSpread({}, state), {}, {
                isSourcePublic: true
            });
        case 0, $0da669d2ada77527$export$9d358706ccac3727:
            return $5ee13175d8f41d83$var$_objectSpread($5ee13175d8f41d83$var$_objectSpread({}, state), {}, {
                targetIds: payload.targetIds
            });
        case 0, $052270500d6f3261$export$82ace346d17d8869:
            if (state.targetIds.indexOf(payload.targetId) === -1) return state;
            return $5ee13175d8f41d83$var$_objectSpread($5ee13175d8f41d83$var$_objectSpread({}, state), {}, {
                targetIds: (0, $5f6072b7bb395caa$export$5d14bf425b37f49e)(state.targetIds, payload.targetId)
            });
        case 0, $0da669d2ada77527$export$b4af72c40fd57063:
            return $5ee13175d8f41d83$var$_objectSpread($5ee13175d8f41d83$var$_objectSpread({}, state), {}, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case 0, $0da669d2ada77527$export$d300627d16aeb9cc:
            return $5ee13175d8f41d83$var$_objectSpread($5ee13175d8f41d83$var$_objectSpread({}, state), {}, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}



function $3729247164284198$export$533b26079ad0b4b() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $052270500d6f3261$export$b36933c81fb1c092:
        case 0, $052270500d6f3261$export$2c313542981556ae:
            return state + 1;
        case 0, $052270500d6f3261$export$13332566b98b8783:
        case 0, $052270500d6f3261$export$82ace346d17d8869:
            return state - 1;
        default:
            return state;
    }
}






var $4244a49fa55ef1ad$export$c53d0f541b41b88e = [];
var $4244a49fa55ef1ad$export$61b49a5ae59d663 = [];
$4244a49fa55ef1ad$export$c53d0f541b41b88e.__IS_NONE__ = true;
$4244a49fa55ef1ad$export$61b49a5ae59d663.__IS_ALL__ = true;
function $4244a49fa55ef1ad$export$3347776eeed47180(dirtyIds, handlerIds) {
    if (dirtyIds === $4244a49fa55ef1ad$export$c53d0f541b41b88e) return false;
    if (dirtyIds === $4244a49fa55ef1ad$export$61b49a5ae59d663 || typeof handlerIds === "undefined") return true;
    var commonIds = (0, $5f6072b7bb395caa$export$bc86dfbf7795668c)(handlerIds, dirtyIds);
    return commonIds.length > 0;
}



function $86805a82e4a5f7a6$export$533b26079ad0b4b() {
    var _state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $4244a49fa55ef1ad$export$c53d0f541b41b88e);
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $0da669d2ada77527$export$9d358706ccac3727:
            break;
        case 0, $052270500d6f3261$export$b36933c81fb1c092:
        case 0, $052270500d6f3261$export$2c313542981556ae:
        case 0, $052270500d6f3261$export$82ace346d17d8869:
        case 0, $052270500d6f3261$export$13332566b98b8783:
            return 0, $4244a49fa55ef1ad$export$c53d0f541b41b88e;
        case 0, $0da669d2ada77527$export$98f9b4193e6b55e6:
        case 0, $0da669d2ada77527$export$22d1d88e2de0d0e0:
        case 0, $0da669d2ada77527$export$d300627d16aeb9cc:
        case 0, $0da669d2ada77527$export$b4af72c40fd57063:
        default:
            return 0, $4244a49fa55ef1ad$export$61b49a5ae59d663;
    }
    var _action$payload = action.payload, _action$payload$targe = _action$payload.targetIds, targetIds = _action$payload$targe === void 0 ? [] : _action$payload$targe, _action$payload$prevT = _action$payload.prevTargetIds, prevTargetIds = _action$payload$prevT === void 0 ? [] : _action$payload$prevT;
    var result = (0, $5f6072b7bb395caa$export$6444ef5cd411280c)(targetIds, prevTargetIds);
    var didChange = result.length > 0 || !(0, $dbf52f5949ba3eaf$export$94fd53d40f0652a)(targetIds, prevTargetIds);
    if (!didChange) return 0, $4244a49fa55ef1ad$export$c53d0f541b41b88e;
     // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    var innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}


function $30941b7b221592fe$export$533b26079ad0b4b() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return state + 1;
}



function $f7d0f50d929afad2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f7d0f50d929afad2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f7d0f50d929afad2$var$ownKeys(Object(source), true).forEach(function(key) {
            $f7d0f50d929afad2$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f7d0f50d929afad2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f7d0f50d929afad2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f7d0f50d929afad2$export$533b26079ad0b4b() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    return {
        dirtyHandlerIds: (0, $86805a82e4a5f7a6$export$533b26079ad0b4b)(state.dirtyHandlerIds, {
            type: action.type,
            payload: $f7d0f50d929afad2$var$_objectSpread($f7d0f50d929afad2$var$_objectSpread({}, action.payload), {}, {
                prevTargetIds: (0, $5f6072b7bb395caa$export$3988ae62b71be9a3)(state, "dragOperation.targetIds", [])
            })
        }),
        dragOffset: (0, $48afd727940a32fb$export$533b26079ad0b4b)(state.dragOffset, action),
        refCount: (0, $3729247164284198$export$533b26079ad0b4b)(state.refCount, action),
        dragOperation: (0, $5ee13175d8f41d83$export$533b26079ad0b4b)(state.dragOperation, action),
        stateId: (0, $30941b7b221592fe$export$533b26079ad0b4b)(state.stateId)
    };
}




/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $b911b97c5eb8bd96$export$e16d8520af44a096(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
function $b911b97c5eb8bd96$export$4e2d2ead65e5f7e3(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $b911b97c5eb8bd96$export$b6a5970fca17c71e(state) {
    var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset, initialSourceClientOffset = state.initialSourceClientOffset;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return $b911b97c5eb8bd96$export$4e2d2ead65e5f7e3($b911b97c5eb8bd96$export$e16d8520af44a096(clientOffset, initialSourceClientOffset), initialClientOffset);
}
function $b911b97c5eb8bd96$export$b57ee1a41eb1620b(state) {
    var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset;
    if (!clientOffset || !initialClientOffset) return null;
    return $b911b97c5eb8bd96$export$4e2d2ead65e5f7e3(clientOffset, initialClientOffset);
}



function $f24b03c2b2712ead$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f24b03c2b2712ead$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f24b03c2b2712ead$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f24b03c2b2712ead$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f24b03c2b2712ead$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f24b03c2b2712ead$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $f24b03c2b2712ead$export$e220263e518daaed = /*#__PURE__*/ function() {
    function DragDropMonitorImpl(store, registry) {
        $f24b03c2b2712ead$var$_classCallCheck(this, DragDropMonitorImpl);
        $f24b03c2b2712ead$var$_defineProperty(this, "store", void 0);
        $f24b03c2b2712ead$var$_defineProperty(this, "registry", void 0);
        this.store = store;
        this.registry = registry;
    }
    $f24b03c2b2712ead$var$_createClass(DragDropMonitorImpl, [
        {
            key: "subscribeToStateChange",
            value: function subscribeToStateChange(listener) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    handlerIds: undefined
                };
                var handlerIds = options.handlerIds;
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof listener === "function", "listener must be a function.");
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof handlerIds === "undefined" || Array.isArray(handlerIds), "handlerIds, when specified, must be an array of strings.");
                var prevStateId = this.store.getState().stateId;
                var handleChange = function handleChange() {
                    var state = _this.store.getState();
                    var currentStateId = state.stateId;
                    try {
                        var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, $4244a49fa55ef1ad$export$3347776eeed47180)(state.dirtyHandlerIds, handlerIds);
                        if (!canSkipListener) listener();
                    } finally{
                        prevStateId = currentStateId;
                    }
                };
                return this.store.subscribe(handleChange);
            }
        },
        {
            key: "subscribeToOffsetChange",
            value: function subscribeToOffsetChange(listener) {
                var _this2 = this;
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof listener === "function", "listener must be a function.");
                var previousState = this.store.getState().dragOffset;
                var handleChange = function handleChange() {
                    var nextState = _this2.store.getState().dragOffset;
                    if (nextState === previousState) return;
                    previousState = nextState;
                    listener();
                };
                return this.store.subscribe(handleChange);
            }
        },
        {
            key: "canDragSource",
            value: function canDragSource(sourceId) {
                if (!sourceId) return false;
                var source = this.registry.getSource(sourceId);
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(source, "Expected to find a valid source. sourceId=".concat(sourceId));
                if (this.isDragging()) return false;
                return source.canDrag(this, sourceId);
            }
        },
        {
            key: "canDropOnTarget",
            value: function canDropOnTarget(targetId) {
                // undefined on initial render
                if (!targetId) return false;
                var target = this.registry.getTarget(targetId);
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(target, "Expected to find a valid target. targetId=".concat(targetId));
                if (!this.isDragging() || this.didDrop()) return false;
                var targetType = this.registry.getTargetType(targetId);
                var draggedItemType = this.getItemType();
                return (0, $0c70f113351fdf25$export$2d6239ff106f142f)(targetType, draggedItemType) && target.canDrop(this, targetId);
            }
        },
        {
            key: "isDragging",
            value: function isDragging() {
                return Boolean(this.getItemType());
            }
        },
        {
            key: "isDraggingSource",
            value: function isDraggingSource(sourceId) {
                // undefined on initial render
                if (!sourceId) return false;
                var source = this.registry.getSource(sourceId, true);
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(source, "Expected to find a valid source. sourceId=".concat(sourceId));
                if (!this.isDragging() || !this.isSourcePublic()) return false;
                var sourceType = this.registry.getSourceType(sourceId);
                var draggedItemType = this.getItemType();
                if (sourceType !== draggedItemType) return false;
                return source.isDragging(this, sourceId);
            }
        },
        {
            key: "isOverTarget",
            value: function isOverTarget(targetId) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    shallow: false
                };
                // undefined on initial render
                if (!targetId) return false;
                var shallow = options.shallow;
                if (!this.isDragging()) return false;
                var targetType = this.registry.getTargetType(targetId);
                var draggedItemType = this.getItemType();
                if (draggedItemType && !(0, $0c70f113351fdf25$export$2d6239ff106f142f)(targetType, draggedItemType)) return false;
                var targetIds = this.getTargetIds();
                if (!targetIds.length) return false;
                var index = targetIds.indexOf(targetId);
                if (shallow) return index === targetIds.length - 1;
                else return index > -1;
            }
        },
        {
            key: "getItemType",
            value: function getItemType() {
                return this.store.getState().dragOperation.itemType;
            }
        },
        {
            key: "getItem",
            value: function getItem() {
                return this.store.getState().dragOperation.item;
            }
        },
        {
            key: "getSourceId",
            value: function getSourceId() {
                return this.store.getState().dragOperation.sourceId;
            }
        },
        {
            key: "getTargetIds",
            value: function getTargetIds() {
                return this.store.getState().dragOperation.targetIds;
            }
        },
        {
            key: "getDropResult",
            value: function getDropResult() {
                return this.store.getState().dragOperation.dropResult;
            }
        },
        {
            key: "didDrop",
            value: function didDrop() {
                return this.store.getState().dragOperation.didDrop;
            }
        },
        {
            key: "isSourcePublic",
            value: function isSourcePublic() {
                return Boolean(this.store.getState().dragOperation.isSourcePublic);
            }
        },
        {
            key: "getInitialClientOffset",
            value: function getInitialClientOffset() {
                return this.store.getState().dragOffset.initialClientOffset;
            }
        },
        {
            key: "getInitialSourceClientOffset",
            value: function getInitialSourceClientOffset() {
                return this.store.getState().dragOffset.initialSourceClientOffset;
            }
        },
        {
            key: "getClientOffset",
            value: function getClientOffset() {
                return this.store.getState().dragOffset.clientOffset;
            }
        },
        {
            key: "getSourceClientOffset",
            value: function getSourceClientOffset() {
                return (0, $b911b97c5eb8bd96$export$b6a5970fca17c71e)(this.store.getState().dragOffset);
            }
        },
        {
            key: "getDifferenceFromInitialOffset",
            value: function getDifferenceFromInitialOffset() {
                return (0, $b911b97c5eb8bd96$export$b57ee1a41eb1620b)(this.store.getState().dragOffset);
            }
        }
    ]);
    return DragDropMonitorImpl;
}();




var $bc1e0bafce4cec4c$var$nextUniqueId = 0;
function $bc1e0bafce4cec4c$export$dbfb29c8f2c7bb44() {
    return $bc1e0bafce4cec4c$var$nextUniqueId++;
}


var $0ebb1057093fbba1$export$bb8f0843d7d66cb0;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})($0ebb1057093fbba1$export$bb8f0843d7d66cb0 || ($0ebb1057093fbba1$export$bb8f0843d7d66cb0 = {}));



function $4b3785e6187abac6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4b3785e6187abac6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4b3785e6187abac6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4b3785e6187abac6$var$_typeof(obj);
}
function $4b3785e6187abac6$export$a7a13c013ce18993(source) {
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof source.canDrag === "function", "Expected canDrag to be a function.");
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof source.beginDrag === "function", "Expected beginDrag to be a function.");
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof source.endDrag === "function", "Expected endDrag to be a function.");
}
function $4b3785e6187abac6$export$77d3cd1340fdeb5a(target) {
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof target.canDrop === "function", "Expected canDrop to be a function.");
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof target.hover === "function", "Expected hover to be a function.");
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof target.drop === "function", "Expected beginDrag to be a function.");
}
function $4b3785e6187abac6$export$831a593efd22380d(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach(function(t) {
            return $4b3785e6187abac6$export$831a593efd22380d(t, false);
        });
        return;
    }
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof type === "string" || $4b3785e6187abac6$var$_typeof(type) === "symbol", allowArray ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}


// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const $1a4312bf2b321998$var$scope = typeof $parcel$global !== "undefined" ? $parcel$global : self;
const $1a4312bf2b321998$var$BrowserMutationObserver = $1a4312bf2b321998$var$scope.MutationObserver || $1a4312bf2b321998$var$scope.WebKitMutationObserver;
function $1a4312bf2b321998$export$27a7cafb047f3c77(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
function $1a4312bf2b321998$export$2785f4493cc9ca62(callback) {
    let toggle = 1;
    const observer = new $1a4312bf2b321998$var$BrowserMutationObserver(callback);
    const node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const $1a4312bf2b321998$export$29545a1340296ce3 = typeof $1a4312bf2b321998$var$BrowserMutationObserver === "function" ? // They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
$1a4312bf2b321998$export$2785f4493cc9ca62 : // 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
$1a4312bf2b321998$export$27a7cafb047f3c77;


class $6560dd9c27baa8cb$export$d3f0708de0e313ed {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q, requestFlush: requestFlush } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++)q[scan] = q[scan + this.index];
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = (0, $1a4312bf2b321998$export$29545a1340296ce3)(this.flush);
        this.requestErrorThrow = (0, $1a4312bf2b321998$export$27a7cafb047f3c77)(()=>{
            // Throw first error
            if (this.pendingErrors.length) throw this.pendingErrors.shift();
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
 // original foundation for this library.
 // http://www.nonblocking.io/2011/06/windownexttick.html
 // Safari 6.0.5 (at least) intermittently fails to create message ports on a
 // page's first load. Thankfully, this version of Safari supports
 // MutationObservers, so we don't need to fall back in that case.
 // function makeRequestCallFromMessageChannel(callback) {
 //     var channel = new MessageChannel();
 //     channel.port1.onmessage = callback;
 //     return function requestCall() {
 //         channel.port2.postMessage(0);
 //     };
 // }
 // For reasons explained above, we are also unable to use `setImmediate`
 // under any circumstances.
 // Even if we were, there is another bug in Internet Explorer 10.
 // It is not sufficient to assign `setImmediate` to `requestFlush` because
 // `setImmediate` must be called *by name* and therefore must be wrapped in a
 // closure.
 // Never forget.
 // function makeRequestCallFromSetImmediate(callback) {
 //     return function requestCall() {
 //         setImmediate(callback);
 //     };
 // }
 // Safari 6.0 has a problem where timers will get lost while the user is
 // scrolling. This problem does not impact ASAP because Safari 6.0 supports
 // mutation observers, so that implementation is used instead.
 // However, if we ever elect to use timers in Safari, the prevalent work-around
 // is to add a scroll event listener that calls for a flush.
 // `setTimeout` does not call the passed callback if the delay is less than
 // approximately 7 in web workers in Firefox 8 through 18, and sometimes not
 // even then.
 // This is for `asap.js` only.
 // Its name will be periodically randomized to break any code that depends on
 // // its existence.
 // rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
 // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js


// `call`, just like a function.
class $0656e0ed467a45e9$export$c84b69da61b33d93 {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}


class $84ebd5ce67ed411a$export$4577931b6c22c63b {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new (0, $0656e0ed467a45e9$export$c84b69da61b33d93)(this.onError, (t)=>tasks[tasks.length] = t);
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}


const $4941ec89c5c7ec0e$var$asapQueue = new (0, $6560dd9c27baa8cb$export$d3f0708de0e313ed)();
const $4941ec89c5c7ec0e$var$taskFactory = new (0, $84ebd5ce67ed411a$export$4577931b6c22c63b)($4941ec89c5c7ec0e$var$asapQueue.registerPendingError);
function $4941ec89c5c7ec0e$export$dc4d482300a341e1(task) {
    $4941ec89c5c7ec0e$var$asapQueue.enqueueTask($4941ec89c5c7ec0e$var$taskFactory.create(task));
}








function $23aca40314d7d1e2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $23aca40314d7d1e2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $23aca40314d7d1e2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $23aca40314d7d1e2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $23aca40314d7d1e2$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $23aca40314d7d1e2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $23aca40314d7d1e2$var$_slicedToArray(arr, i) {
    return $23aca40314d7d1e2$var$_arrayWithHoles(arr) || $23aca40314d7d1e2$var$_iterableToArrayLimit(arr, i) || $23aca40314d7d1e2$var$_unsupportedIterableToArray(arr, i) || $23aca40314d7d1e2$var$_nonIterableRest();
}
function $23aca40314d7d1e2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $23aca40314d7d1e2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $23aca40314d7d1e2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $23aca40314d7d1e2$var$_arrayLikeToArray(o, minLen);
}
function $23aca40314d7d1e2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $23aca40314d7d1e2$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $23aca40314d7d1e2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $23aca40314d7d1e2$var$getNextHandlerId(role) {
    var id = (0, $bc1e0bafce4cec4c$export$dbfb29c8f2c7bb44)().toString();
    switch(role){
        case (0, $0ebb1057093fbba1$export$bb8f0843d7d66cb0).SOURCE:
            return "S".concat(id);
        case (0, $0ebb1057093fbba1$export$bb8f0843d7d66cb0).TARGET:
            return "T".concat(id);
        default:
            throw new Error("Unknown Handler Role: ".concat(role));
    }
}
function $23aca40314d7d1e2$var$parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case "S":
            return (0, $0ebb1057093fbba1$export$bb8f0843d7d66cb0).SOURCE;
        case "T":
            return (0, $0ebb1057093fbba1$export$bb8f0843d7d66cb0).TARGET;
        default:
            (0, $2daa4a08f076625e$export$f5708dca728d7177)(false, "Cannot parse handler ID: ".concat(handlerId));
    }
}
function $23aca40314d7d1e2$var$mapContainsValue(map, searchValue) {
    var entries = map.entries();
    var isDone = false;
    do {
        var _entries$next = entries.next(), done = _entries$next.done, _entries$next$value = $23aca40314d7d1e2$var$_slicedToArray(_entries$next.value, 2), value = _entries$next$value[1];
        if (value === searchValue) return true;
        isDone = !!done;
    }while (!isDone);
    return false;
}
var $23aca40314d7d1e2$export$60ceab237232d5db = /*#__PURE__*/ function() {
    function HandlerRegistryImpl(store) {
        $23aca40314d7d1e2$var$_classCallCheck(this, HandlerRegistryImpl);
        $23aca40314d7d1e2$var$_defineProperty(this, "types", new Map());
        $23aca40314d7d1e2$var$_defineProperty(this, "dragSources", new Map());
        $23aca40314d7d1e2$var$_defineProperty(this, "dropTargets", new Map());
        $23aca40314d7d1e2$var$_defineProperty(this, "pinnedSourceId", null);
        $23aca40314d7d1e2$var$_defineProperty(this, "pinnedSource", null);
        $23aca40314d7d1e2$var$_defineProperty(this, "store", void 0);
        this.store = store;
    }
    $23aca40314d7d1e2$var$_createClass(HandlerRegistryImpl, [
        {
            key: "addSource",
            value: function addSource(type, source) {
                (0, $4b3785e6187abac6$export$831a593efd22380d)(type);
                (0, $4b3785e6187abac6$export$a7a13c013ce18993)(source);
                var sourceId = this.addHandler((0, $0ebb1057093fbba1$export$bb8f0843d7d66cb0).SOURCE, type, source);
                this.store.dispatch((0, $052270500d6f3261$export$bc333c64f07a75c4)(sourceId));
                return sourceId;
            }
        },
        {
            key: "addTarget",
            value: function addTarget(type, target) {
                (0, $4b3785e6187abac6$export$831a593efd22380d)(type, true);
                (0, $4b3785e6187abac6$export$77d3cd1340fdeb5a)(target);
                var targetId = this.addHandler((0, $0ebb1057093fbba1$export$bb8f0843d7d66cb0).TARGET, type, target);
                this.store.dispatch((0, $052270500d6f3261$export$9dd68fe78f37278b)(targetId));
                return targetId;
            }
        },
        {
            key: "containsHandler",
            value: function containsHandler(handler) {
                return $23aca40314d7d1e2$var$mapContainsValue(this.dragSources, handler) || $23aca40314d7d1e2$var$mapContainsValue(this.dropTargets, handler);
            }
        },
        {
            key: "getSource",
            value: function getSource(sourceId) {
                var includePinned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(this.isSourceId(sourceId), "Expected a valid source ID.");
                var isPinned = includePinned && sourceId === this.pinnedSourceId;
                var source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
                return source;
            }
        },
        {
            key: "getTarget",
            value: function getTarget(targetId) {
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(this.isTargetId(targetId), "Expected a valid target ID.");
                return this.dropTargets.get(targetId);
            }
        },
        {
            key: "getSourceType",
            value: function getSourceType(sourceId) {
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(this.isSourceId(sourceId), "Expected a valid source ID.");
                return this.types.get(sourceId);
            }
        },
        {
            key: "getTargetType",
            value: function getTargetType(targetId) {
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(this.isTargetId(targetId), "Expected a valid target ID.");
                return this.types.get(targetId);
            }
        },
        {
            key: "isSourceId",
            value: function isSourceId(handlerId) {
                var role = $23aca40314d7d1e2$var$parseRoleFromHandlerId(handlerId);
                return role === (0, $0ebb1057093fbba1$export$bb8f0843d7d66cb0).SOURCE;
            }
        },
        {
            key: "isTargetId",
            value: function isTargetId(handlerId) {
                var role = $23aca40314d7d1e2$var$parseRoleFromHandlerId(handlerId);
                return role === (0, $0ebb1057093fbba1$export$bb8f0843d7d66cb0).TARGET;
            }
        },
        {
            key: "removeSource",
            value: function removeSource(sourceId) {
                var _this = this;
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(this.getSource(sourceId), "Expected an existing source.");
                this.store.dispatch((0, $052270500d6f3261$export$c724aacd61334138)(sourceId));
                (0, $4941ec89c5c7ec0e$export$dc4d482300a341e1)(function() {
                    _this.dragSources.delete(sourceId);
                    _this.types.delete(sourceId);
                });
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(targetId) {
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(this.getTarget(targetId), "Expected an existing target.");
                this.store.dispatch((0, $052270500d6f3261$export$20ae7ec87f7f8696)(targetId));
                this.dropTargets.delete(targetId);
                this.types.delete(targetId);
            }
        },
        {
            key: "pinSource",
            value: function pinSource(sourceId) {
                var source = this.getSource(sourceId);
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(source, "Expected an existing source.");
                this.pinnedSourceId = sourceId;
                this.pinnedSource = source;
            }
        },
        {
            key: "unpinSource",
            value: function unpinSource() {
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(this.pinnedSource, "No source is pinned at the time.");
                this.pinnedSourceId = null;
                this.pinnedSource = null;
            }
        },
        {
            key: "addHandler",
            value: function addHandler(role, type, handler) {
                var id = $23aca40314d7d1e2$var$getNextHandlerId(role);
                this.types.set(id, type);
                if (role === (0, $0ebb1057093fbba1$export$bb8f0843d7d66cb0).SOURCE) this.dragSources.set(id, handler);
                else if (role === (0, $0ebb1057093fbba1$export$bb8f0843d7d66cb0).TARGET) this.dropTargets.set(id, handler);
                return id;
            }
        }
    ]);
    return HandlerRegistryImpl;
}();


function $06fbbb2c7597c993$export$ff47aa43d5fd3e5d(backendFactory) {
    var globalContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var backendOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var debugMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var store = $06fbbb2c7597c993$var$makeStoreInstance(debugMode);
    var monitor = new (0, $f24b03c2b2712ead$export$e220263e518daaed)(store, new (0, $23aca40314d7d1e2$export$60ceab237232d5db)(store));
    var manager = new (0, $deb68607e6e34bcf$export$1141bbf61324c55f)(store, monitor);
    var backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function $06fbbb2c7597c993$var$makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    var reduxDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__;
    return (0, $d0affe2ff19fe4b6$export$f51a9068ac82ea43)((0, $f7d0f50d929afad2$export$533b26079ad0b4b), debugMode && reduxDevTools && reduxDevTools({
        name: "dnd-core",
        instanceId: "dnd-core"
    }));
}



var $4DE7A = parcelRequire("4DE7A");
var $da3b103bf3c94d3b$export$2d5c5ceac203fc1e = (0, $4DE7A.createContext)({
    dragDropManager: undefined
});


var $4c46f063ffae98fb$var$_excluded = [
    "children"
];
function $4c46f063ffae98fb$var$_slicedToArray(arr, i) {
    return $4c46f063ffae98fb$var$_arrayWithHoles(arr) || $4c46f063ffae98fb$var$_iterableToArrayLimit(arr, i) || $4c46f063ffae98fb$var$_unsupportedIterableToArray(arr, i) || $4c46f063ffae98fb$var$_nonIterableRest();
}
function $4c46f063ffae98fb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4c46f063ffae98fb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4c46f063ffae98fb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4c46f063ffae98fb$var$_arrayLikeToArray(o, minLen);
}
function $4c46f063ffae98fb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4c46f063ffae98fb$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $4c46f063ffae98fb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $4c46f063ffae98fb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4c46f063ffae98fb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4c46f063ffae98fb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4c46f063ffae98fb$var$refCount = 0;
var $4c46f063ffae98fb$var$INSTANCE_SYM = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var $4c46f063ffae98fb$export$9861489d68213f9c = (0, $4DE7A.memo)(function DndProvider(_ref) {
    var children = _ref.children, props = $4c46f063ffae98fb$var$_objectWithoutProperties(_ref, $4c46f063ffae98fb$var$_excluded);
    var _getDndContextValue = $4c46f063ffae98fb$var$getDndContextValue(props), _getDndContextValue2 = $4c46f063ffae98fb$var$_slicedToArray(_getDndContextValue, 2), manager = _getDndContextValue2[0], isGlobalInstance = _getDndContextValue2[1]; // memoized from props
    /**
   * If the global context was used to store the DND context
   * then where theres no more references to it we should
   * clean it up to avoid memory leaks
   */ (0, $4DE7A.useEffect)(function() {
        if (isGlobalInstance) {
            var context = $4c46f063ffae98fb$var$getGlobalContext();
            ++$4c46f063ffae98fb$var$refCount;
            return function() {
                if (--$4c46f063ffae98fb$var$refCount === 0) context[$4c46f063ffae98fb$var$INSTANCE_SYM] = null;
            };
        }
    }, []);
    return (0, $6dd45a7735069a79$exports.jsx)((0, $da3b103bf3c94d3b$export$2d5c5ceac203fc1e).Provider, Object.assign({
        value: manager
    }, {
        children: children
    }), void 0);
});
function $4c46f063ffae98fb$var$getDndContextValue(props) {
    if ("manager" in props) {
        var _manager = {
            dragDropManager: props.manager
        };
        return [
            _manager,
            false
        ];
    }
    var manager = $4c46f063ffae98fb$var$createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    var isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
function $4c46f063ffae98fb$var$createSingletonDndContext(backend) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $4c46f063ffae98fb$var$getGlobalContext();
    var options = arguments.length > 2 ? arguments[2] : undefined;
    var debugMode = arguments.length > 3 ? arguments[3] : undefined;
    var ctx = context;
    if (!ctx[$4c46f063ffae98fb$var$INSTANCE_SYM]) ctx[$4c46f063ffae98fb$var$INSTANCE_SYM] = {
        dragDropManager: (0, $06fbbb2c7597c993$export$ff47aa43d5fd3e5d)(backend, context, options, debugMode)
    };
    return ctx[$4c46f063ffae98fb$var$INSTANCE_SYM];
}
function $4c46f063ffae98fb$var$getGlobalContext() {
    return typeof $parcel$global !== "undefined" ? $parcel$global : window;
}



var $4DE7A = parcelRequire("4DE7A");
const $ca61ba5b50f7e65b$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $4DE7A.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $ca61ba5b50f7e65b$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /*#__PURE__*/ (0, $4DE7A.createElement)($ca61ba5b50f7e65b$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $ca61ba5b50f7e65b$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $4DE7A.useContext)($ca61ba5b50f7e65b$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $ca61ba5b50f7e65b$export$2881499e37b75b9a = $ca61ba5b50f7e65b$export$c760c09fdd558351;


var $ed8ffa8849fb38c5$export$2e2bcd8739ae039 = function(event, check) {
    return {
        _isMBTransition: true,
        event: event,
        check: check
    };
};


var $9b521fca47cd4e7e$export$91e99a52278bf8a5 = (0, $ed8ffa8849fb38c5$export$2e2bcd8739ae039)("touchstart", function(event) {
    return event.touches != null; // eslint-disable-line no-eq-null, eqeqeq
});
var $9b521fca47cd4e7e$export$9528ec74b6ffc6f = (0, $ed8ffa8849fb38c5$export$2e2bcd8739ae039)("dragstart", function(event) {
    if (event.type) return event.type.indexOf("drag") !== -1 || event.type.indexOf("drop") !== -1;
    return false;
});
var $9b521fca47cd4e7e$export$6863e369d9a30d41 = (0, $ed8ffa8849fb38c5$export$2e2bcd8739ae039)("mousedown", function(event) {
    if (event.type) return event.type.indexOf("touch") === -1 && event.type.indexOf("mouse") !== -1;
    return false;
});



function $aae5996c0806e21b$var$_createForOfIteratorHelper(o) {
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $aae5996c0806e21b$var$_unsupportedIterableToArray(o))) {
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var it, normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $aae5996c0806e21b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aae5996c0806e21b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aae5996c0806e21b$var$_arrayLikeToArray(o, minLen);
}
function $aae5996c0806e21b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $aae5996c0806e21b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $aae5996c0806e21b$export$52bf9e690b06895 = function PreviewList() {
    var _this = this;
    $aae5996c0806e21b$var$_classCallCheck(this, PreviewList);
    this.register = function(preview) {
        _this.previews.push(preview);
    };
    this.unregister = function(preview) {
        var index;
        while((index = _this.previews.indexOf(preview)) !== -1)_this.previews.splice(index, 1);
    };
    this.backendChanged = function(backend) {
        var _iterator = $aae5996c0806e21b$var$_createForOfIteratorHelper(_this.previews), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var preview = _step.value;
                preview.backendChanged(backend);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    this.previews = [];
};



function $314f1f8c466d0735$var$_toConsumableArray(arr) {
    return $314f1f8c466d0735$var$_arrayWithoutHoles(arr) || $314f1f8c466d0735$var$_iterableToArray(arr) || $314f1f8c466d0735$var$_unsupportedIterableToArray(arr) || $314f1f8c466d0735$var$_nonIterableSpread();
}
function $314f1f8c466d0735$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $314f1f8c466d0735$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $314f1f8c466d0735$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $314f1f8c466d0735$var$_arrayLikeToArray(o, minLen);
}
function $314f1f8c466d0735$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $314f1f8c466d0735$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $314f1f8c466d0735$var$_arrayLikeToArray(arr);
}
function $314f1f8c466d0735$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $314f1f8c466d0735$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $314f1f8c466d0735$export$2e2bcd8739ae039 = function _default(manager, context, sourceOptions) {
    var _this = this;
    $314f1f8c466d0735$var$_classCallCheck(this, _default);
    this.setup = function() {
        if (typeof window === "undefined") return;
        if (_this.constructor.isSetUp) throw new Error("Cannot have two MultiBackends at the same time.");
        _this.constructor.isSetUp = true;
        _this.addEventListeners(window);
        _this.backends[_this.current].instance.setup();
    };
    this.teardown = function() {
        if (typeof window === "undefined") return;
        _this.constructor.isSetUp = false;
        _this.removeEventListeners(window);
        _this.backends[_this.current].instance.teardown();
    };
    this.connectDragSource = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _this.connectBackend("connectDragSource", args);
    };
    this.connectDragPreview = function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return _this.connectBackend("connectDragPreview", args);
    };
    this.connectDropTarget = function() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return _this.connectBackend("connectDropTarget", args);
    };
    this.previewEnabled = function() {
        return _this.backends[_this.current].preview;
    };
    this.addEventListeners = function(target) {
        _this.backends.forEach(function(backend) {
            if (backend.transition) target.addEventListener(backend.transition.event, _this.backendSwitcher, true);
        });
    };
    this.removeEventListeners = function(target) {
        _this.backends.forEach(function(backend) {
            if (backend.transition) target.removeEventListener(backend.transition.event, _this.backendSwitcher, true);
        });
    };
    this.backendSwitcher = function(event) {
        var oldBackend = _this.current;
        var i = 0;
        _this.backends.some(function(backend) {
            if (i !== _this.current && backend.transition && backend.transition.check(event)) {
                _this.current = i;
                return true;
            }
            i += 1;
            return false;
        });
        if (_this.current !== oldBackend) {
            _this.backends[oldBackend].instance.teardown();
            Object.keys(_this.nodes).forEach(function(id) {
                var node = _this.nodes[id];
                node.handler();
                node.handler = _this.callBackend(node.func, node.args);
            });
            _this.previews.backendChanged(_this);
            var newBackend = _this.backends[_this.current];
            newBackend.instance.setup();
            if (newBackend.skipDispatchOnTransition) return;
            var newEvent = null;
            try {
                newEvent = new event.constructor(event.type, event);
            } catch (_e) {
                newEvent = document.createEvent("Event");
                newEvent.initEvent(event.type, event.bubbles, event.cancelable);
            }
            event.target.dispatchEvent(newEvent);
        }
    };
    this.callBackend = function(func, args) {
        var _this$backends$_this$;
        return (_this$backends$_this$ = _this.backends[_this.current].instance)[func].apply(_this$backends$_this$, $314f1f8c466d0735$var$_toConsumableArray(args));
    };
    this.connectBackend = function(func, args) {
        var nodeId = "".concat(func, "_").concat(args[0]);
        var handler = _this.callBackend(func, args);
        _this.nodes[nodeId] = {
            func: func,
            args: args,
            handler: handler
        };
        return function() {
            var _this$nodes$nodeId;
            var r = (_this$nodes$nodeId = _this.nodes[nodeId]).handler.apply(_this$nodes$nodeId, arguments);
            delete _this.nodes[nodeId];
            return r;
        };
    };
    var options = Object.assign({
        backends: []
    }, sourceOptions || {});
    if (options.backends.length < 1) throw new Error("You must specify at least one Backend, if you are coming from 2.x.x (or don't understand this error)\n        see this guide: https://github.com/louisbrunner/dnd-multi-backend/tree/master/packages/react-dnd-multi-backend#migrating-from-2xx");
    this.current = 0;
    this.previews = new (0, $aae5996c0806e21b$export$52bf9e690b06895)();
    this.backends = [];
    options.backends.forEach(function(backend) {
        if (!backend.backend) throw new Error("You must specify a 'backend' property in your Backend entry: ".concat(backend));
        var transition = backend.transition;
        if (transition && !transition._isMBTransition) throw new Error("You must specify a valid 'transition' property (either undefined or the return of 'createTransition') in your Backend entry: ".concat(backend));
        _this.backends.push({
            instance: backend.backend(manager, context, backend.options),
            preview: backend.preview || false,
            transition: transition,
            skipDispatchOnTransition: Boolean(backend.skipDispatchOnTransition)
        });
    });
    this.nodes = {};
} // DnD Backend API
;


var $55109fca61883a44$export$2e2bcd8739ae039 = function(manager, context, options) {
    return new (0, $314f1f8c466d0735$export$2e2bcd8739ae039)(manager, context, options);
};



var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");


function $0a51c8983d139968$var$_extends() {
    $0a51c8983d139968$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0a51c8983d139968$var$_extends.apply(this, arguments);
}
var $0a51c8983d139968$export$6fdda551c33ce3de = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createContext(null);
var $0a51c8983d139968$export$9861489d68213f9c = function DndProvider(props) {
    var previewPortal = (0, $4DE7A.useRef)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement($0a51c8983d139968$export$6fdda551c33ce3de.Provider, {
        value: previewPortal.current
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, $4c46f063ffae98fb$export$9861489d68213f9c), $0a51c8983d139968$var$_extends({
        backend: (0, $55109fca61883a44$export$2e2bcd8739ae039)
    }, props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("div", {
        ref: previewPortal
    }));
};
$0a51c8983d139968$export$9861489d68213f9c.propTypes = {
    manager: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).any,
    context: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).any,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).any,
    debugMode: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool
};



var $4DE7A = parcelRequire("4DE7A");

var $gv34t = parcelRequire("gv34t");

var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");

var $4DE7A = parcelRequire("4DE7A");

var $4DE7A = parcelRequire("4DE7A");


function $92bd7e5ec84c680c$export$49db7e1a057ab0fa() {
    var _useContext = (0, $4DE7A.useContext)((0, $da3b103bf3c94d3b$export$2d5c5ceac203fc1e)), dragDropManager = _useContext.dragDropManager;
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(dragDropManager != null, "Expected drag drop context");
    return dragDropManager;
}


var $3a2418269a304bcd$exports = {};
"use strict";
// do not edit .js files directly - edit src/index.jst
$3a2418269a304bcd$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};



var $4DE7A = parcelRequire("4DE7A");

var $4DE7A = parcelRequire("4DE7A");
var $ab9f50304c8c2b9b$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $4DE7A.useLayoutEffect) : (0, $4DE7A.useEffect);


function $51b93a4e96061290$var$_slicedToArray(arr, i) {
    return $51b93a4e96061290$var$_arrayWithHoles(arr) || $51b93a4e96061290$var$_iterableToArrayLimit(arr, i) || $51b93a4e96061290$var$_unsupportedIterableToArray(arr, i) || $51b93a4e96061290$var$_nonIterableRest();
}
function $51b93a4e96061290$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $51b93a4e96061290$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $51b93a4e96061290$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $51b93a4e96061290$var$_arrayLikeToArray(o, minLen);
}
function $51b93a4e96061290$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $51b93a4e96061290$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $51b93a4e96061290$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $51b93a4e96061290$export$e32e64a4387f290a(monitor, collect, onUpdate) {
    var _useState = (0, $4DE7A.useState)(function() {
        return collect(monitor);
    }), _useState2 = $51b93a4e96061290$var$_slicedToArray(_useState, 2), collected = _useState2[0], setCollected = _useState2[1];
    var updateCollected = (0, $4DE7A.useCallback)(function() {
        var nextValue = collect(monitor); // This needs to be a deep-equality check because some monitor-collected values
        // include XYCoord objects that may be equivalent, but do not have instance equality.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3a2418269a304bcd$exports)))(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) onUpdate();
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]); // update the collected properties after react renders.
    // Note that the "Dustbin Stress Test" fails if this is not
    // done when the component updates
    (0, $ab9f50304c8c2b9b$export$700979bc83e7db82)(updateCollected);
    return [
        collected,
        updateCollected
    ];
}


function $0efc44f5acc26a86$var$_slicedToArray(arr, i) {
    return $0efc44f5acc26a86$var$_arrayWithHoles(arr) || $0efc44f5acc26a86$var$_iterableToArrayLimit(arr, i) || $0efc44f5acc26a86$var$_unsupportedIterableToArray(arr, i) || $0efc44f5acc26a86$var$_nonIterableRest();
}
function $0efc44f5acc26a86$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0efc44f5acc26a86$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0efc44f5acc26a86$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0efc44f5acc26a86$var$_arrayLikeToArray(o, minLen);
}
function $0efc44f5acc26a86$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0efc44f5acc26a86$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $0efc44f5acc26a86$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0efc44f5acc26a86$export$d7d88e78e2243a79(collect) {
    var dragDropManager = (0, $92bd7e5ec84c680c$export$49db7e1a057ab0fa)();
    var monitor = dragDropManager.getMonitor();
    var _useCollector = (0, $51b93a4e96061290$export$e32e64a4387f290a)(monitor, collect), _useCollector2 = $0efc44f5acc26a86$var$_slicedToArray(_useCollector, 2), collected = _useCollector2[0], updateCollected = _useCollector2[1];
    (0, $4DE7A.useEffect)(function() {
        return monitor.subscribeToOffsetChange(updateCollected);
    });
    (0, $4DE7A.useEffect)(function() {
        return monitor.subscribeToStateChange(updateCollected);
    });
    return collected;
}


var $4b50946387d68136$var$getStyle = function getStyle(currentOffset) {
    var transform = "translate(".concat(currentOffset.x, "px, ").concat(currentOffset.y, "px)");
    return {
        pointerEvents: "none",
        position: "fixed",
        top: 0,
        left: 0,
        transform: transform,
        WebkitTransform: transform
    };
};
var $4b50946387d68136$export$50539fd3054c9e7b = function usePreview() {
    var collectedProps = (0, $0efc44f5acc26a86$export$d7d88e78e2243a79)(function(monitor) {
        return {
            currentOffset: monitor.getSourceClientOffset(),
            isDragging: monitor.isDragging(),
            itemType: monitor.getItemType(),
            item: monitor.getItem()
        };
    });
    if (!collectedProps.isDragging || collectedProps.currentOffset === null) return {
        display: false
    };
    return {
        display: true,
        itemType: collectedProps.itemType,
        item: collectedProps.item,
        style: $4b50946387d68136$var$getStyle(collectedProps.currentOffset)
    };
};



var $4DE7A = parcelRequire("4DE7A");
var $25386dadb2c1649f$export$841858b892ce1f4c = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createContext();


function $d4dad2af1b4bb10b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d4dad2af1b4bb10b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d4dad2af1b4bb10b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d4dad2af1b4bb10b$export$133773870222880f = function Preview(props) {
    var _usePreview = (0, $4b50946387d68136$export$50539fd3054c9e7b)(), display = _usePreview.display, data = $d4dad2af1b4bb10b$var$_objectWithoutProperties(_usePreview, [
        "display"
    ]);
    if (!display) return null;
    var child;
    if (props.children && typeof props.children === "function") child = props.children(data);
    else if (props.children) child = props.children;
    else child = props.generator(data);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, $25386dadb2c1649f$export$841858b892ce1f4c).Provider, {
        value: data
    }, child);
};
$d4dad2af1b4bb10b$export$133773870222880f.propTypes = {
    generator: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func
    ])
};




var $8b2fd1078dbd2d53$export$2e2bcd8739ae039 = (0, $d4dad2af1b4bb10b$export$133773870222880f);



var $4DE7A = parcelRequire("4DE7A");

function $c755b8100f48b94c$var$_slicedToArray(arr, i) {
    return $c755b8100f48b94c$var$_arrayWithHoles(arr) || $c755b8100f48b94c$var$_iterableToArrayLimit(arr, i) || $c755b8100f48b94c$var$_unsupportedIterableToArray(arr, i) || $c755b8100f48b94c$var$_nonIterableRest();
}
function $c755b8100f48b94c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c755b8100f48b94c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c755b8100f48b94c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c755b8100f48b94c$var$_arrayLikeToArray(o, minLen);
}
function $c755b8100f48b94c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c755b8100f48b94c$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c755b8100f48b94c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $c755b8100f48b94c$export$e801b5b21026279e = function useObservePreviews() {
    var _useState = (0, $4DE7A.useState)(false), _useState2 = $c755b8100f48b94c$var$_slicedToArray(_useState, 2), enabled = _useState2[0], setEnabled = _useState2[1];
    var dndContext = (0, $4DE7A.useContext)((0, $da3b103bf3c94d3b$export$2d5c5ceac203fc1e));
    (0, $4DE7A.useEffect)(function() {
        var backend = dndContext.dragDropManager.getBackend();
        var observer = {
            backendChanged: function backendChanged(cbackend) {
                setEnabled(cbackend.previewEnabled());
            }
        };
        setEnabled(backend.previewEnabled());
        backend.previews.register(observer);
        return function() {
            backend.previews.unregister(observer);
        };
    }, [
        dndContext,
        setEnabled
    ]);
    return enabled;
};



var $deb07a307bdce3b4$export$133773870222880f = function Preview(props) {
    var enabled = (0, $c755b8100f48b94c$export$e801b5b21026279e)();
    var portal = (0, $4DE7A.useContext)((0, $0a51c8983d139968$export$6fdda551c33ce3de));
    if (!enabled) return null;
    var result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, $8b2fd1078dbd2d53$export$2e2bcd8739ae039), props);
    if (portal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gv34t))).createPortal(result, portal);
    return result;
};
$deb07a307bdce3b4$export$133773870222880f.Context = (0, $25386dadb2c1649f$export$841858b892ce1f4c);
$deb07a307bdce3b4$export$133773870222880f.propTypes = (0, $8b2fd1078dbd2d53$export$2e2bcd8739ae039).propTypes;




var $7f28af1dea51099f$export$50539fd3054c9e7b = function usePreview() {
    var enabled = (0, $c755b8100f48b94c$export$e801b5b21026279e)();
    var result = (0, $4b50946387d68136$export$50539fd3054c9e7b)();
    if (!enabled) return {
        display: false
    };
    return result;
};






// cheap lodash replacements
function $447f770ba027b67b$export$fc10aeed3a532e2a(fn) {
    var result = null;
    var memoized = function memoized() {
        if (result == null) result = fn();
        return result;
    };
    return memoized;
}
function $447f770ba027b67b$export$5d14bf425b37f49e(items, item) {
    return items.filter(function(i) {
        return i !== item;
    });
}
function $447f770ba027b67b$export$971dd5b0dfd021b6(itemsA, itemsB) {
    var set = new Set();
    var insertItem = function insertItem(item) {
        return set.add(item);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    var result = [];
    set.forEach(function(key) {
        return result.push(key);
    });
    return result;
}


function $e34aa2be7ec3fa69$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e34aa2be7ec3fa69$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e34aa2be7ec3fa69$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e34aa2be7ec3fa69$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e34aa2be7ec3fa69$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e34aa2be7ec3fa69$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $e34aa2be7ec3fa69$export$9ff3e6eb5c734d0d = /*#__PURE__*/ function() {
    function EnterLeaveCounter(isNodeInDocument) {
        $e34aa2be7ec3fa69$var$_classCallCheck(this, EnterLeaveCounter);
        $e34aa2be7ec3fa69$var$_defineProperty(this, "entered", []);
        $e34aa2be7ec3fa69$var$_defineProperty(this, "isNodeInDocument", void 0);
        this.isNodeInDocument = isNodeInDocument;
    }
    $e34aa2be7ec3fa69$var$_createClass(EnterLeaveCounter, [
        {
            key: "enter",
            value: function enter(enteringNode) {
                var _this = this;
                var previousLength = this.entered.length;
                var isNodeEntered = function isNodeEntered(node) {
                    return _this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
                };
                this.entered = (0, $447f770ba027b67b$export$971dd5b0dfd021b6)(this.entered.filter(isNodeEntered), [
                    enteringNode
                ]);
                return previousLength === 0 && this.entered.length > 0;
            }
        },
        {
            key: "leave",
            value: function leave(leavingNode) {
                var previousLength = this.entered.length;
                this.entered = (0, $447f770ba027b67b$export$5d14bf425b37f49e)(this.entered.filter(this.isNodeInDocument), leavingNode);
                return previousLength > 0 && this.entered.length === 0;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.entered = [];
            }
        }
    ]);
    return EnterLeaveCounter;
}();



var $a8602507b71462dd$export$b7d78993b74f766d = (0, $447f770ba027b67b$export$fc10aeed3a532e2a)(function() {
    return /firefox/i.test(navigator.userAgent);
});
var $a8602507b71462dd$export$95df08bae54cb4df = (0, $447f770ba027b67b$export$fc10aeed3a532e2a)(function() {
    return Boolean(window.safari);
});


function $df46fe4c6022588b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $df46fe4c6022588b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $df46fe4c6022588b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $df46fe4c6022588b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $df46fe4c6022588b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $df46fe4c6022588b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $df46fe4c6022588b$export$6d87c156c5199b02 = /*#__PURE__*/ function() {
    function MonotonicInterpolant(xs, ys) {
        $df46fe4c6022588b$var$_classCallCheck(this, MonotonicInterpolant);
        $df46fe4c6022588b$var$_defineProperty(this, "xs", void 0);
        $df46fe4c6022588b$var$_defineProperty(this, "ys", void 0);
        $df46fe4c6022588b$var$_defineProperty(this, "c1s", void 0);
        $df46fe4c6022588b$var$_defineProperty(this, "c2s", void 0);
        $df46fe4c6022588b$var$_defineProperty(this, "c3s", void 0);
        var length = xs.length; // Rearrange xs and ys so that xs is sorted
        var indexes = [];
        for(var i = 0; i < length; i++)indexes.push(i);
        indexes.sort(function(a, b) {
            return xs[a] < xs[b] ? -1 : 1;
        }); // Get consecutive differences and slopes
        var dys = [];
        var dxs = [];
        var ms = [];
        var dx;
        var dy;
        for(var _i = 0; _i < length - 1; _i++){
            dx = xs[_i + 1] - xs[_i];
            dy = ys[_i + 1] - ys[_i];
            dxs.push(dx);
            dys.push(dy);
            ms.push(dy / dx);
        } // Get degree-1 coefficients
        var c1s = [
            ms[0]
        ];
        for(var _i2 = 0; _i2 < dxs.length - 1; _i2++){
            var m2 = ms[_i2];
            var mNext = ms[_i2 + 1];
            if (m2 * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[_i2];
                var dxNext = dxs[_i2 + 1];
                var common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]); // Get degree-2 and degree-3 coefficients
        var c2s = [];
        var c3s = [];
        var m;
        for(var _i3 = 0; _i3 < c1s.length - 1; _i3++){
            m = ms[_i3];
            var c1 = c1s[_i3];
            var invDx = 1 / dxs[_i3];
            var _common = c1 + c1s[_i3 + 1] - m - m;
            c2s.push((m - c1 - _common) * invDx);
            c3s.push(_common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
    $df46fe4c6022588b$var$_createClass(MonotonicInterpolant, [
        {
            key: "interpolate",
            value: function interpolate(x) {
                var xs = this.xs, ys = this.ys, c1s = this.c1s, c2s = this.c2s, c3s = this.c3s; // The rightmost point in the dataset should give an exact result
                var i = xs.length - 1;
                if (x === xs[i]) return ys[i];
                 // Search for the interval x is in, returning the corresponding y if x is one of the original xs
                var low = 0;
                var high = c3s.length - 1;
                var mid;
                while(low <= high){
                    mid = Math.floor(0.5 * (low + high));
                    var xHere = xs[mid];
                    if (xHere < x) low = mid + 1;
                    else if (xHere > x) high = mid - 1;
                    else return ys[mid];
                }
                i = Math.max(0, high); // Interpolate
                var diff = x - xs[i];
                var diffSq = diff * diff;
                return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
            }
        }
    ]);
    return MonotonicInterpolant;
}();


var $1fbab4d950914c71$var$ELEMENT_NODE = 1;
function $1fbab4d950914c71$export$8419e8612027b1d8(node) {
    var el = node.nodeType === $1fbab4d950914c71$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return null;
    var _el$getBoundingClient = el.getBoundingClientRect(), top = _el$getBoundingClient.top, left = _el$getBoundingClient.left;
    return {
        x: left,
        y: top
    };
}
function $1fbab4d950914c71$export$710c829989c68339(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function $1fbab4d950914c71$var$isImageNode(node) {
    var _document$documentEle;
    return node.nodeName === "IMG" && ((0, $a8602507b71462dd$export$b7d78993b74f766d)() || !((_document$documentEle = document.documentElement) !== null && _document$documentEle !== void 0 && _document$documentEle.contains(node)));
}
function $1fbab4d950914c71$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight; // Work around @2x coordinate discrepancies in browsers
    if ((0, $a8602507b71462dd$export$95df08bae54cb4df)() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth: dragPreviewWidth,
        dragPreviewHeight: dragPreviewHeight
    };
}
function $1fbab4d950914c71$export$e99fdbb90efc75c5(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    var isImage = $1fbab4d950914c71$var$isImageNode(dragPreview);
    var dragPreviewNode = isImage ? sourceNode : dragPreview;
    var dragPreviewNodeOffsetFromClient = $1fbab4d950914c71$export$8419e8612027b1d8(dragPreviewNode);
    var offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    var sourceWidth = sourceNode.offsetWidth, sourceHeight = sourceNode.offsetHeight;
    var anchorX = anchorPoint.anchorX, anchorY = anchorPoint.anchorY;
    var _getDragPreviewSize = $1fbab4d950914c71$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight), dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth, dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;
    var calculateYOffset = function calculateYOffset() {
        var interpolantY = new (0, $df46fe4c6022588b$export$6d87c156c5199b02)([
            0,
            0.5,
            1
        ], [
            offsetFromDragPreview.y,
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        var y = interpolantY.interpolate(anchorY); // Work around Safari 8 positioning bug
        if ((0, $a8602507b71462dd$export$95df08bae54cb4df)() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    var calculateXOffset = function calculateXOffset() {
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        var interpolantX = new (0, $df46fe4c6022588b$export$6d87c156c5199b02)([
            0,
            0.5,
            1
        ], [
            offsetFromDragPreview.x,
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    }; // Force offsets if specified in the options.
    var offsetX = offsetPoint.offsetX, offsetY = offsetPoint.offsetY;
    var isManualOffsetX = offsetX === 0 || offsetX;
    var isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}


var $badf87e403ca6f3e$exports = {};

$parcel$export($badf87e403ca6f3e$exports, "FILE", function () { return $badf87e403ca6f3e$export$1802dbfd31b58482; });
$parcel$export($badf87e403ca6f3e$exports, "URL", function () { return $badf87e403ca6f3e$export$61abde59b50deb8e; });
$parcel$export($badf87e403ca6f3e$exports, "TEXT", function () { return $badf87e403ca6f3e$export$d597759d33be802e; });
$parcel$export($badf87e403ca6f3e$exports, "HTML", function () { return $badf87e403ca6f3e$export$9dcd2b1ca4768128; });
var $badf87e403ca6f3e$export$1802dbfd31b58482 = "__NATIVE_FILE__";
var $badf87e403ca6f3e$export$61abde59b50deb8e = "__NATIVE_URL__";
var $badf87e403ca6f3e$export$d597759d33be802e = "__NATIVE_TEXT__";
var $badf87e403ca6f3e$export$9dcd2b1ca4768128 = "__NATIVE_HTML__";


function $e627011de4a87a40$export$dc02f6a7b68f305f(dataTransfer, typesToTry, defaultValue) {
    var result = typesToTry.reduce(function(resultSoFar, typeToTry) {
        return resultSoFar || dataTransfer.getData(typeToTry);
    }, "");
    return result != null ? result : defaultValue;
}


var $48206712e9157fe8$var$_nativeTypesConfig;
function $48206712e9157fe8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $48206712e9157fe8$export$8cc89d9b8cb1bd88 = ($48206712e9157fe8$var$_nativeTypesConfig = {}, $48206712e9157fe8$var$_defineProperty($48206712e9157fe8$var$_nativeTypesConfig, $badf87e403ca6f3e$export$1802dbfd31b58482, {
    exposeProperties: {
        files: function files(dataTransfer) {
            return Array.prototype.slice.call(dataTransfer.files);
        },
        items: function items(dataTransfer) {
            return dataTransfer.items;
        },
        dataTransfer: function dataTransfer(_dataTransfer) {
            return _dataTransfer;
        }
    },
    matchesTypes: [
        "Files"
    ]
}), $48206712e9157fe8$var$_defineProperty($48206712e9157fe8$var$_nativeTypesConfig, $badf87e403ca6f3e$export$9dcd2b1ca4768128, {
    exposeProperties: {
        html: function html(dataTransfer, matchesTypes) {
            return (0, $e627011de4a87a40$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, "");
        },
        dataTransfer: function dataTransfer(_dataTransfer2) {
            return _dataTransfer2;
        }
    },
    matchesTypes: [
        "Html",
        "text/html"
    ]
}), $48206712e9157fe8$var$_defineProperty($48206712e9157fe8$var$_nativeTypesConfig, $badf87e403ca6f3e$export$61abde59b50deb8e, {
    exposeProperties: {
        urls: function urls(dataTransfer, matchesTypes) {
            return (0, $e627011de4a87a40$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, "").split("\n");
        },
        dataTransfer: function dataTransfer(_dataTransfer3) {
            return _dataTransfer3;
        }
    },
    matchesTypes: [
        "Url",
        "text/uri-list"
    ]
}), $48206712e9157fe8$var$_defineProperty($48206712e9157fe8$var$_nativeTypesConfig, $badf87e403ca6f3e$export$d597759d33be802e, {
    exposeProperties: {
        text: function text(dataTransfer, matchesTypes) {
            return (0, $e627011de4a87a40$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, "");
        },
        dataTransfer: function dataTransfer(_dataTransfer4) {
            return _dataTransfer4;
        }
    },
    matchesTypes: [
        "Text",
        "text/plain"
    ]
}), $48206712e9157fe8$var$_nativeTypesConfig);


function $ddc6bc73f8aaad28$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ddc6bc73f8aaad28$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ddc6bc73f8aaad28$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ddc6bc73f8aaad28$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ddc6bc73f8aaad28$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ddc6bc73f8aaad28$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $ddc6bc73f8aaad28$export$f22384f077cf51c4 = /*#__PURE__*/ function() {
    function NativeDragSource(config) {
        $ddc6bc73f8aaad28$var$_classCallCheck(this, NativeDragSource);
        $ddc6bc73f8aaad28$var$_defineProperty(this, "item", void 0);
        $ddc6bc73f8aaad28$var$_defineProperty(this, "config", void 0);
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
    $ddc6bc73f8aaad28$var$_createClass(NativeDragSource, [
        {
            key: "initializeExposedProperties",
            value: function initializeExposedProperties() {
                var _this = this;
                Object.keys(this.config.exposeProperties).forEach(function(property) {
                    Object.defineProperty(_this.item, property, {
                        configurable: true,
                        enumerable: true,
                        get: function get() {
                            // eslint-disable-next-line no-console
                            console.warn("Browser doesn't allow reading \"".concat(property, '" until the drop event.'));
                            return null;
                        }
                    });
                });
            }
        },
        {
            key: "loadDataTransfer",
            value: function loadDataTransfer(dataTransfer) {
                var _this2 = this;
                if (dataTransfer) {
                    var newProperties = {};
                    Object.keys(this.config.exposeProperties).forEach(function(property) {
                        newProperties[property] = {
                            value: _this2.config.exposeProperties[property](dataTransfer, _this2.config.matchesTypes),
                            configurable: true,
                            enumerable: true
                        };
                    });
                    Object.defineProperties(this.item, newProperties);
                }
            }
        },
        {
            key: "canDrag",
            value: function canDrag() {
                return true;
            }
        },
        {
            key: "beginDrag",
            value: function beginDrag() {
                return this.item;
            }
        },
        {
            key: "isDragging",
            value: function isDragging(monitor, handle) {
                return handle === monitor.getSourceId();
            }
        },
        {
            key: "endDrag",
            value: function endDrag() {}
        }
    ]);
    return NativeDragSource;
}();


function $d554ceda1e092cbf$export$ada362c01636774d(type, dataTransfer) {
    var result = new (0, $ddc6bc73f8aaad28$export$f22384f077cf51c4)((0, $48206712e9157fe8$export$8cc89d9b8cb1bd88)[type]);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function $d554ceda1e092cbf$export$11b547ed8c182c11(dataTransfer) {
    if (!dataTransfer) return null;
    var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys((0, $48206712e9157fe8$export$8cc89d9b8cb1bd88)).filter(function(nativeItemType) {
        var matchesTypes = (0, $48206712e9157fe8$export$8cc89d9b8cb1bd88)[nativeItemType].matchesTypes;
        return matchesTypes.some(function(t) {
            return dataTransferTypes.indexOf(t) > -1;
        });
    })[0] || null;
}



function $30c40fd8b6180788$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $30c40fd8b6180788$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $30c40fd8b6180788$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $30c40fd8b6180788$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $30c40fd8b6180788$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $30c40fd8b6180788$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $30c40fd8b6180788$export$2b3a268803e49e64 = /*#__PURE__*/ function() {
    function OptionsReader(globalContext, options) {
        $30c40fd8b6180788$var$_classCallCheck(this, OptionsReader);
        $30c40fd8b6180788$var$_defineProperty(this, "ownerDocument", null);
        $30c40fd8b6180788$var$_defineProperty(this, "globalContext", void 0);
        $30c40fd8b6180788$var$_defineProperty(this, "optionsArgs", void 0);
        this.globalContext = globalContext;
        this.optionsArgs = options;
    }
    $30c40fd8b6180788$var$_createClass(OptionsReader, [
        {
            key: "window",
            get: function get() {
                if (this.globalContext) return this.globalContext;
                else if (typeof window !== "undefined") return window;
                return undefined;
            }
        },
        {
            key: "document",
            get: function get() {
                var _this$globalContext;
                if ((_this$globalContext = this.globalContext) !== null && _this$globalContext !== void 0 && _this$globalContext.document) return this.globalContext.document;
                else if (this.window) return this.window.document;
                else return undefined;
            }
        },
        {
            key: "rootElement",
            get: function get() {
                var _this$optionsArgs;
                return ((_this$optionsArgs = this.optionsArgs) === null || _this$optionsArgs === void 0 ? void 0 : _this$optionsArgs.rootElement) || this.window;
            }
        }
    ]);
    return OptionsReader;
}();


function $332d47d927b05394$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $332d47d927b05394$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $332d47d927b05394$var$ownKeys(Object(source), true).forEach(function(key) {
            $332d47d927b05394$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $332d47d927b05394$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $332d47d927b05394$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $332d47d927b05394$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $332d47d927b05394$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $332d47d927b05394$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $332d47d927b05394$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $332d47d927b05394$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $332d47d927b05394$export$3a01990c235a9281 = /*#__PURE__*/ function() {
    // React-Dnd Components
    // Internal State
    function HTML5BackendImpl(manager, globalContext, options) {
        var _this = this;
        $332d47d927b05394$var$_classCallCheck(this, HTML5BackendImpl);
        $332d47d927b05394$var$_defineProperty(this, "options", void 0);
        $332d47d927b05394$var$_defineProperty(this, "actions", void 0);
        $332d47d927b05394$var$_defineProperty(this, "monitor", void 0);
        $332d47d927b05394$var$_defineProperty(this, "registry", void 0);
        $332d47d927b05394$var$_defineProperty(this, "enterLeaveCounter", void 0);
        $332d47d927b05394$var$_defineProperty(this, "sourcePreviewNodes", new Map());
        $332d47d927b05394$var$_defineProperty(this, "sourcePreviewNodeOptions", new Map());
        $332d47d927b05394$var$_defineProperty(this, "sourceNodes", new Map());
        $332d47d927b05394$var$_defineProperty(this, "sourceNodeOptions", new Map());
        $332d47d927b05394$var$_defineProperty(this, "dragStartSourceIds", null);
        $332d47d927b05394$var$_defineProperty(this, "dropTargetIds", []);
        $332d47d927b05394$var$_defineProperty(this, "dragEnterTargetIds", []);
        $332d47d927b05394$var$_defineProperty(this, "currentNativeSource", null);
        $332d47d927b05394$var$_defineProperty(this, "currentNativeHandle", null);
        $332d47d927b05394$var$_defineProperty(this, "currentDragSourceNode", null);
        $332d47d927b05394$var$_defineProperty(this, "altKeyPressed", false);
        $332d47d927b05394$var$_defineProperty(this, "mouseMoveTimeoutTimer", null);
        $332d47d927b05394$var$_defineProperty(this, "asyncEndDragFrameId", null);
        $332d47d927b05394$var$_defineProperty(this, "dragOverTargetIds", null);
        $332d47d927b05394$var$_defineProperty(this, "lastClientOffset", null);
        $332d47d927b05394$var$_defineProperty(this, "hoverRafId", null);
        $332d47d927b05394$var$_defineProperty(this, "getSourceClientOffset", function(sourceId) {
            var source = _this.sourceNodes.get(sourceId);
            return source && (0, $1fbab4d950914c71$export$8419e8612027b1d8)(source) || null;
        });
        $332d47d927b05394$var$_defineProperty(this, "endDragNativeItem", function() {
            if (!_this.isDraggingNativeItem()) return;
            _this.actions.endDrag();
            if (_this.currentNativeHandle) _this.registry.removeSource(_this.currentNativeHandle);
            _this.currentNativeHandle = null;
            _this.currentNativeSource = null;
        });
        $332d47d927b05394$var$_defineProperty(this, "isNodeInDocument", function(node) {
            // Check the node either in the main document or in the current context
            return Boolean(node && _this.document && _this.document.body && _this.document.body.contains(node));
        });
        $332d47d927b05394$var$_defineProperty(this, "endDragIfSourceWasRemovedFromDOM", function() {
            var node = _this.currentDragSourceNode;
            if (node == null || _this.isNodeInDocument(node)) return;
            if (_this.clearCurrentDragSourceNode() && _this.monitor.isDragging()) _this.actions.endDrag();
        });
        $332d47d927b05394$var$_defineProperty(this, "handleTopDragStartCapture", function() {
            _this.clearCurrentDragSourceNode();
            _this.dragStartSourceIds = [];
        });
        $332d47d927b05394$var$_defineProperty(this, "handleTopDragStart", function(e) {
            if (e.defaultPrevented) return;
            var dragStartSourceIds = _this.dragStartSourceIds;
            _this.dragStartSourceIds = null;
            var clientOffset = (0, $1fbab4d950914c71$export$710c829989c68339)(e); // Avoid crashing if we missed a drop event or our previous drag died
            if (_this.monitor.isDragging()) _this.actions.endDrag();
             // Don't publish the source just yet (see why below)
            _this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: _this.getSourceClientOffset,
                clientOffset: clientOffset
            });
            var dataTransfer = e.dataTransfer;
            var nativeType = (0, $d554ceda1e092cbf$export$11b547ed8c182c11)(dataTransfer);
            if (_this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === "function") {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    var sourceId = _this.monitor.getSourceId();
                    var sourceNode = _this.sourceNodes.get(sourceId);
                    var dragPreview = _this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        var _this$getCurrentSourc = _this.getCurrentSourcePreviewNodeOptions(), anchorX = _this$getCurrentSourc.anchorX, anchorY = _this$getCurrentSourc.anchorY, offsetX = _this$getCurrentSourc.offsetX, offsetY = _this$getCurrentSourc.offsetY;
                        var anchorPoint = {
                            anchorX: anchorX,
                            anchorY: anchorY
                        };
                        var offsetPoint = {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                        var dragPreviewOffset = (0, $1fbab4d950914c71$export$e99fdbb90efc75c5)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer === null || dataTransfer === void 0 || dataTransfer.setData("application/json", {});
                } catch (err) {} // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                _this.setCurrentDragSourceNode(e.target); // Now we are ready to publish the drag source.. or are we not?
                var _this$getCurrentSourc2 = _this.getCurrentSourcePreviewNodeOptions(), captureDraggingState = _this$getCurrentSourc2.captureDraggingState;
                if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                // is able to screenshot the current (not yet dragging) state.
                //
                // It also neatly avoids a situation where render() returns null
                // in the same tick for the source element, and browser freaks out.
                setTimeout(function() {
                    return _this.actions.publishDragSource();
                }, 0);
                else // In some cases the user may want to override this behavior, e.g.
                // to work around IE not supporting custom drag previews.
                //
                // When using a custom drag layer, the only way to prevent
                // the default drag preview from drawing in IE is to screenshot
                // the dragging state in which the node itself has zero opacity
                // and height. In this case, though, returning null from render()
                // will abruptly end the dragging, which is not obvious.
                //
                // This is the reason such behavior is strictly opt-in.
                _this.actions.publishDragSource();
            } else if (nativeType) // A native item (such as URL) dragged from inside the document
            _this.beginDragNativeItem(nativeType);
            else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute("draggable"))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
            // Just let it drag. It's a native type (URL or text) and will be picked up in
            // dragenter handler.
            return;
            else // If by this time no drag source reacted, tell browser not to drag.
            e.preventDefault();
        });
        $332d47d927b05394$var$_defineProperty(this, "handleTopDragEndCapture", function() {
            if (_this.clearCurrentDragSourceNode() && _this.monitor.isDragging()) // Firefox can dispatch this event in an infinite loop
            // if dragend handler does something like showing an alert.
            // Only proceed if we have not handled it already.
            _this.actions.endDrag();
        });
        $332d47d927b05394$var$_defineProperty(this, "handleTopDragEnterCapture", function(e) {
            _this.dragEnterTargetIds = [];
            var isFirstEnter = _this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || _this.monitor.isDragging()) return;
            var dataTransfer = e.dataTransfer;
            var nativeType = (0, $d554ceda1e092cbf$export$11b547ed8c182c11)(dataTransfer);
            if (nativeType) // A native item (such as file or URL) dragged from outside the document
            _this.beginDragNativeItem(nativeType, dataTransfer);
        });
        $332d47d927b05394$var$_defineProperty(this, "handleTopDragEnter", function(e) {
            var dragEnterTargetIds = _this.dragEnterTargetIds;
            _this.dragEnterTargetIds = [];
            if (!_this.monitor.isDragging()) // This is probably a native item type we don't understand.
            return;
            _this.altKeyPressed = e.altKey; // If the target changes position as the result of `dragenter`, `dragover` might still
            // get dispatched despite target being no longer there. The easy solution is to check
            // whether there actually is a target before firing `hover`.
            if (dragEnterTargetIds.length > 0) _this.actions.hover(dragEnterTargetIds, {
                clientOffset: (0, $1fbab4d950914c71$export$710c829989c68339)(e)
            });
            var canDrop = dragEnterTargetIds.some(function(targetId) {
                return _this.monitor.canDropOnTarget(targetId);
            });
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
            }
        });
        $332d47d927b05394$var$_defineProperty(this, "handleTopDragOverCapture", function() {
            _this.dragOverTargetIds = [];
        });
        $332d47d927b05394$var$_defineProperty(this, "handleTopDragOver", function(e) {
            var dragOverTargetIds = _this.dragOverTargetIds;
            _this.dragOverTargetIds = [];
            if (!_this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
                return;
            }
            _this.altKeyPressed = e.altKey;
            _this.lastClientOffset = (0, $1fbab4d950914c71$export$710c829989c68339)(e);
            if (_this.hoverRafId === null && typeof requestAnimationFrame !== "undefined") _this.hoverRafId = requestAnimationFrame(function() {
                if (_this.monitor.isDragging()) _this.actions.hover(dragOverTargetIds || [], {
                    clientOffset: _this.lastClientOffset
                });
                _this.hoverRafId = null;
            });
            var canDrop = (dragOverTargetIds || []).some(function(targetId) {
                return _this.monitor.canDropOnTarget(targetId);
            });
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
            } else if (_this.isDraggingNativeItem()) // Don't show a nice cursor but still prevent default
            // "drop and blow away the whole document" action.
            e.preventDefault();
            else {
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
            }
        });
        $332d47d927b05394$var$_defineProperty(this, "handleTopDragLeaveCapture", function(e) {
            if (_this.isDraggingNativeItem()) e.preventDefault();
            var isLastLeave = _this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) return;
            if (_this.isDraggingNativeItem()) setTimeout(function() {
                return _this.endDragNativeItem();
            }, 0);
        });
        $332d47d927b05394$var$_defineProperty(this, "handleTopDropCapture", function(e) {
            _this.dropTargetIds = [];
            if (_this.isDraggingNativeItem()) {
                var _this$currentNativeSo;
                e.preventDefault();
                (_this$currentNativeSo = _this.currentNativeSource) === null || _this$currentNativeSo === void 0 || _this$currentNativeSo.loadDataTransfer(e.dataTransfer);
            } else if ((0, $d554ceda1e092cbf$export$11b547ed8c182c11)(e.dataTransfer)) // Dragging some elements, like <a> and <img> may still behave like a native drag event,
            // even if the current drag event matches a user-defined type.
            // Stop the default behavior when we're not expecting a native item to be dropped.
            e.preventDefault();
            _this.enterLeaveCounter.reset();
        });
        $332d47d927b05394$var$_defineProperty(this, "handleTopDrop", function(e) {
            var dropTargetIds = _this.dropTargetIds;
            _this.dropTargetIds = [];
            _this.actions.hover(dropTargetIds, {
                clientOffset: (0, $1fbab4d950914c71$export$710c829989c68339)(e)
            });
            _this.actions.drop({
                dropEffect: _this.getCurrentDropEffect()
            });
            if (_this.isDraggingNativeItem()) _this.endDragNativeItem();
            else if (_this.monitor.isDragging()) _this.actions.endDrag();
        });
        $332d47d927b05394$var$_defineProperty(this, "handleSelectStart", function(e) {
            var target = e.target; // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== "function") return;
             // Inputs and textareas should be selectable
            if (target.tagName === "INPUT" || target.tagName === "SELECT" || target.tagName === "TEXTAREA" || target.isContentEditable) return;
             // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        });
        this.options = new (0, $30c40fd8b6180788$export$2b3a268803e49e64)(globalContext, options);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new (0, $e34aa2be7ec3fa69$export$9ff3e6eb5c734d0d)(this.isNodeInDocument);
    }
    /**
   * Generate profiling statistics for the HTML5Backend.
   */ $332d47d927b05394$var$_createClass(HTML5BackendImpl, [
        {
            key: "profile",
            value: function profile() {
                var _this$dragStartSource, _this$dragOverTargetI;
                return {
                    sourcePreviewNodes: this.sourcePreviewNodes.size,
                    sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
                    sourceNodeOptions: this.sourceNodeOptions.size,
                    sourceNodes: this.sourceNodes.size,
                    dragStartSourceIds: ((_this$dragStartSource = this.dragStartSourceIds) === null || _this$dragStartSource === void 0 ? void 0 : _this$dragStartSource.length) || 0,
                    dropTargetIds: this.dropTargetIds.length,
                    dragEnterTargetIds: this.dragEnterTargetIds.length,
                    dragOverTargetIds: ((_this$dragOverTargetI = this.dragOverTargetIds) === null || _this$dragOverTargetI === void 0 ? void 0 : _this$dragOverTargetI.length) || 0
                };
            } // public for test
        },
        {
            key: "window",
            get: function get() {
                return this.options.window;
            }
        },
        {
            key: "document",
            get: function get() {
                return this.options.document;
            }
        },
        {
            key: "rootElement",
            get: function get() {
                return this.options.rootElement;
            }
        },
        {
            key: "setup",
            value: function setup() {
                var root = this.rootElement;
                if (root === undefined) return;
                if (root.__isReactDndBackendSetUp) throw new Error("Cannot have two HTML5 backends at the same time.");
                root.__isReactDndBackendSetUp = true;
                this.addEventListeners(root);
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                var root = this.rootElement;
                if (root === undefined) return;
                root.__isReactDndBackendSetUp = false;
                this.removeEventListeners(this.rootElement);
                this.clearCurrentDragSourceNode();
                if (this.asyncEndDragFrameId) {
                    var _this$window;
                    (_this$window = this.window) === null || _this$window === void 0 || _this$window.cancelAnimationFrame(this.asyncEndDragFrameId);
                }
            }
        },
        {
            key: "connectDragPreview",
            value: function connectDragPreview(sourceId, node, options) {
                var _this2 = this;
                this.sourcePreviewNodeOptions.set(sourceId, options);
                this.sourcePreviewNodes.set(sourceId, node);
                return function() {
                    _this2.sourcePreviewNodes.delete(sourceId);
                    _this2.sourcePreviewNodeOptions.delete(sourceId);
                };
            }
        },
        {
            key: "connectDragSource",
            value: function connectDragSource(sourceId, node, options) {
                var _this3 = this;
                this.sourceNodes.set(sourceId, node);
                this.sourceNodeOptions.set(sourceId, options);
                var handleDragStart = function handleDragStart(e) {
                    return _this3.handleDragStart(e, sourceId);
                };
                var handleSelectStart = function handleSelectStart(e) {
                    return _this3.handleSelectStart(e);
                };
                node.setAttribute("draggable", "true");
                node.addEventListener("dragstart", handleDragStart);
                node.addEventListener("selectstart", handleSelectStart);
                return function() {
                    _this3.sourceNodes.delete(sourceId);
                    _this3.sourceNodeOptions.delete(sourceId);
                    node.removeEventListener("dragstart", handleDragStart);
                    node.removeEventListener("selectstart", handleSelectStart);
                    node.setAttribute("draggable", "false");
                };
            }
        },
        {
            key: "connectDropTarget",
            value: function connectDropTarget(targetId, node) {
                var _this4 = this;
                var handleDragEnter = function handleDragEnter(e) {
                    return _this4.handleDragEnter(e, targetId);
                };
                var handleDragOver = function handleDragOver(e) {
                    return _this4.handleDragOver(e, targetId);
                };
                var handleDrop = function handleDrop(e) {
                    return _this4.handleDrop(e, targetId);
                };
                node.addEventListener("dragenter", handleDragEnter);
                node.addEventListener("dragover", handleDragOver);
                node.addEventListener("drop", handleDrop);
                return function() {
                    node.removeEventListener("dragenter", handleDragEnter);
                    node.removeEventListener("dragover", handleDragOver);
                    node.removeEventListener("drop", handleDrop);
                };
            }
        },
        {
            key: "addEventListeners",
            value: function addEventListeners(target) {
                // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
                if (!target.addEventListener) return;
                target.addEventListener("dragstart", this.handleTopDragStart);
                target.addEventListener("dragstart", this.handleTopDragStartCapture, true);
                target.addEventListener("dragend", this.handleTopDragEndCapture, true);
                target.addEventListener("dragenter", this.handleTopDragEnter);
                target.addEventListener("dragenter", this.handleTopDragEnterCapture, true);
                target.addEventListener("dragleave", this.handleTopDragLeaveCapture, true);
                target.addEventListener("dragover", this.handleTopDragOver);
                target.addEventListener("dragover", this.handleTopDragOverCapture, true);
                target.addEventListener("drop", this.handleTopDrop);
                target.addEventListener("drop", this.handleTopDropCapture, true);
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners(target) {
                // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
                if (!target.removeEventListener) return;
                target.removeEventListener("dragstart", this.handleTopDragStart);
                target.removeEventListener("dragstart", this.handleTopDragStartCapture, true);
                target.removeEventListener("dragend", this.handleTopDragEndCapture, true);
                target.removeEventListener("dragenter", this.handleTopDragEnter);
                target.removeEventListener("dragenter", this.handleTopDragEnterCapture, true);
                target.removeEventListener("dragleave", this.handleTopDragLeaveCapture, true);
                target.removeEventListener("dragover", this.handleTopDragOver);
                target.removeEventListener("dragover", this.handleTopDragOverCapture, true);
                target.removeEventListener("drop", this.handleTopDrop);
                target.removeEventListener("drop", this.handleTopDropCapture, true);
            }
        },
        {
            key: "getCurrentSourceNodeOptions",
            value: function getCurrentSourceNodeOptions() {
                var sourceId = this.monitor.getSourceId();
                var sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
                return $332d47d927b05394$var$_objectSpread({
                    dropEffect: this.altKeyPressed ? "copy" : "move"
                }, sourceNodeOptions || {});
            }
        },
        {
            key: "getCurrentDropEffect",
            value: function getCurrentDropEffect() {
                if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
                return "copy";
                return this.getCurrentSourceNodeOptions().dropEffect;
            }
        },
        {
            key: "getCurrentSourcePreviewNodeOptions",
            value: function getCurrentSourcePreviewNodeOptions() {
                var sourceId = this.monitor.getSourceId();
                var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
                return $332d47d927b05394$var$_objectSpread({
                    anchorX: 0.5,
                    anchorY: 0.5,
                    captureDraggingState: false
                }, sourcePreviewNodeOptions || {});
            }
        },
        {
            key: "isDraggingNativeItem",
            value: function isDraggingNativeItem() {
                var itemType = this.monitor.getItemType();
                return Object.keys($badf87e403ca6f3e$exports).some(function(key) {
                    return $badf87e403ca6f3e$exports[key] === itemType;
                });
            }
        },
        {
            key: "beginDragNativeItem",
            value: function beginDragNativeItem(type, dataTransfer) {
                this.clearCurrentDragSourceNode();
                this.currentNativeSource = (0, $d554ceda1e092cbf$export$ada362c01636774d)(type, dataTransfer);
                this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
                this.actions.beginDrag([
                    this.currentNativeHandle
                ]);
            }
        },
        {
            key: "setCurrentDragSourceNode",
            value: function setCurrentDragSourceNode(node) {
                var _this5 = this;
                this.clearCurrentDragSourceNode();
                this.currentDragSourceNode = node; // A timeout of > 0 is necessary to resolve Firefox issue referenced
                // See:
                //   * https://github.com/react-dnd/react-dnd/pull/928
                //   * https://github.com/react-dnd/react-dnd/issues/869
                var MOUSE_MOVE_TIMEOUT = 1000; // Receiving a mouse event in the middle of a dragging operation
                // means it has ended and the drag source node disappeared from DOM,
                // so the browser didn't dispatch the dragend event.
                //
                // We need to wait before we start listening for mousemove events.
                // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
                // immediately in some browsers.
                //
                // See:
                //   * https://github.com/react-dnd/react-dnd/pull/928
                //   * https://github.com/react-dnd/react-dnd/issues/869
                //
                this.mouseMoveTimeoutTimer = setTimeout(function() {
                    var _this5$rootElement;
                    return (_this5$rootElement = _this5.rootElement) === null || _this5$rootElement === void 0 ? void 0 : _this5$rootElement.addEventListener("mousemove", _this5.endDragIfSourceWasRemovedFromDOM, true);
                }, MOUSE_MOVE_TIMEOUT);
            }
        },
        {
            key: "clearCurrentDragSourceNode",
            value: function clearCurrentDragSourceNode() {
                if (this.currentDragSourceNode) {
                    this.currentDragSourceNode = null;
                    if (this.rootElement) {
                        var _this$window2;
                        (_this$window2 = this.window) === null || _this$window2 === void 0 || _this$window2.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                        this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
                    }
                    this.mouseMoveTimeoutTimer = null;
                    return true;
                }
                return false;
            }
        },
        {
            key: "handleDragStart",
            value: function handleDragStart(e, sourceId) {
                if (e.defaultPrevented) return;
                if (!this.dragStartSourceIds) this.dragStartSourceIds = [];
                this.dragStartSourceIds.unshift(sourceId);
            }
        },
        {
            key: "handleDragEnter",
            value: function handleDragEnter(e, targetId) {
                this.dragEnterTargetIds.unshift(targetId);
            }
        },
        {
            key: "handleDragOver",
            value: function handleDragOver(e, targetId) {
                if (this.dragOverTargetIds === null) this.dragOverTargetIds = [];
                this.dragOverTargetIds.unshift(targetId);
            }
        },
        {
            key: "handleDrop",
            value: function handleDrop(e, targetId) {
                this.dropTargetIds.unshift(targetId);
            }
        }
    ]);
    return HTML5BackendImpl;
}();



var $a7f417e231983d05$var$emptyImage;
function $a7f417e231983d05$export$bf32f66787bcad4b() {
    if (!$a7f417e231983d05$var$emptyImage) {
        $a7f417e231983d05$var$emptyImage = new Image();
        $a7f417e231983d05$var$emptyImage.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
    }
    return $a7f417e231983d05$var$emptyImage;
}


var $8956e4b9503941ab$export$f4f61d779bb20744 = function createBackend(manager, context, options) {
    return new (0, $332d47d927b05394$export$3a01990c235a9281)(manager, context, options);
};



var $44edc4bf75447885$export$77315d8e4e38ac8f;
(function(ListenerType) {
    ListenerType["mouse"] = "mouse";
    ListenerType["touch"] = "touch";
    ListenerType["keyboard"] = "keyboard";
})($44edc4bf75447885$export$77315d8e4e38ac8f || ($44edc4bf75447885$export$77315d8e4e38ac8f = {}));


// Used for MouseEvent.buttons (note the s on the end).
var $b6ef6e8aae716822$var$MouseButtons = {
    Left: 1,
    Right: 2,
    Center: 4
}; // Used for e.button (note the lack of an s on the end).
var $b6ef6e8aae716822$var$MouseButton = {
    Left: 0,
    Center: 1,
    Right: 2
};
function $b6ef6e8aae716822$export$c64909add7c8d190(e) {
    // For touch events, button will be undefined. If e.button is defined,
    // then it should be MouseButton.Left.
    return e.button === undefined || e.button === $b6ef6e8aae716822$var$MouseButton.Left;
}
function $b6ef6e8aae716822$export$23bc6ab5d304a5(e) {
    // Touch events will have buttons be undefined, while mouse events will have e.buttons's left button
    // bit field unset if the left mouse button has been released
    return e.buttons === undefined || (e.buttons & $b6ef6e8aae716822$var$MouseButtons.Left) === 0;
}
function $b6ef6e8aae716822$export$c4dfce035d43d1e0(e) {
    return !!e.targetTouches;
}



var $2228bfd67c68f655$var$ELEMENT_NODE = 1;
function $2228bfd67c68f655$export$8419e8612027b1d8(node) {
    var el = node.nodeType === $2228bfd67c68f655$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return undefined;
    var _el$getBoundingClient = el.getBoundingClientRect(), top = _el$getBoundingClient.top, left = _el$getBoundingClient.left;
    return {
        x: left,
        y: top
    };
}
function $2228bfd67c68f655$export$149d0d89063ea9ba(e, lastTargetTouchFallback) {
    if (e.targetTouches.length === 1) return $2228bfd67c68f655$export$710c829989c68339(e.targetTouches[0]);
    else if (lastTargetTouchFallback && e.touches.length === 1) {
        if (e.touches[0].target === lastTargetTouchFallback.target) return $2228bfd67c68f655$export$710c829989c68339(e.touches[0]);
    }
}
function $2228bfd67c68f655$export$710c829989c68339(e, lastTargetTouchFallback) {
    if ((0, $b6ef6e8aae716822$export$c4dfce035d43d1e0)(e)) return $2228bfd67c68f655$export$149d0d89063ea9ba(e, lastTargetTouchFallback);
    else return {
        x: e.clientX,
        y: e.clientY
    };
}


function $eda2b3a93a47f5e9$export$9f17032d917177de(x1, y1, x2, y2) {
    return Math.sqrt(Math.pow(Math.abs(x2 - x1), 2) + Math.pow(Math.abs(y2 - y1), 2));
}
function $eda2b3a93a47f5e9$export$7c909de71a662f4d(x1, y1, x2, y2, angleRanges) {
    if (!angleRanges) return false;
    var angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI + 180;
    for(var i = 0; i < angleRanges.length; ++i){
        if ((angleRanges[i].start == null || angle >= angleRanges[i].start) && (angleRanges[i].end == null || angle <= angleRanges[i].end)) return true;
    }
    return false;
}


var $df2256e716d37ec3$export$a8f436d4c8f15a1f = function() {
    // simular to jQuery's test
    var supported = false;
    try {
        addEventListener("test", function() {}, Object.defineProperty({}, "passive", {
            get: function get() {
                supported = true;
                return true;
            }
        }));
    } catch (e) {}
    return supported;
}();


function $43ab2ff5dd1e7dc9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $43ab2ff5dd1e7dc9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $43ab2ff5dd1e7dc9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $43ab2ff5dd1e7dc9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $43ab2ff5dd1e7dc9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $43ab2ff5dd1e7dc9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $43ab2ff5dd1e7dc9$export$2b3a268803e49e64 = /*#__PURE__*/ function() {
    function OptionsReader(args, context) {
        $43ab2ff5dd1e7dc9$var$_classCallCheck(this, OptionsReader);
        $43ab2ff5dd1e7dc9$var$_defineProperty(this, "args", void 0);
        $43ab2ff5dd1e7dc9$var$_defineProperty(this, "context", void 0);
        this.args = args;
        this.context = context;
    }
    $43ab2ff5dd1e7dc9$var$_createClass(OptionsReader, [
        {
            key: "delay",
            get: function get() {
                var _this$args$delay;
                return (_this$args$delay = this.args.delay) !== null && _this$args$delay !== void 0 ? _this$args$delay : 0;
            }
        },
        {
            key: "scrollAngleRanges",
            get: function get() {
                return this.args.scrollAngleRanges;
            }
        },
        {
            key: "getDropTargetElementsAtPoint",
            get: function get() {
                return this.args.getDropTargetElementsAtPoint;
            }
        },
        {
            key: "ignoreContextMenu",
            get: function get() {
                var _this$args$ignoreCont;
                return (_this$args$ignoreCont = this.args.ignoreContextMenu) !== null && _this$args$ignoreCont !== void 0 ? _this$args$ignoreCont : false;
            }
        },
        {
            key: "enableHoverOutsideTarget",
            get: function get() {
                var _this$args$enableHove;
                return (_this$args$enableHove = this.args.enableHoverOutsideTarget) !== null && _this$args$enableHove !== void 0 ? _this$args$enableHove : false;
            }
        },
        {
            key: "enableKeyboardEvents",
            get: function get() {
                var _this$args$enableKeyb;
                return (_this$args$enableKeyb = this.args.enableKeyboardEvents) !== null && _this$args$enableKeyb !== void 0 ? _this$args$enableKeyb : false;
            }
        },
        {
            key: "enableMouseEvents",
            get: function get() {
                var _this$args$enableMous;
                return (_this$args$enableMous = this.args.enableMouseEvents) !== null && _this$args$enableMous !== void 0 ? _this$args$enableMous : false;
            }
        },
        {
            key: "enableTouchEvents",
            get: function get() {
                var _this$args$enableTouc;
                return (_this$args$enableTouc = this.args.enableTouchEvents) !== null && _this$args$enableTouc !== void 0 ? _this$args$enableTouc : true;
            }
        },
        {
            key: "touchSlop",
            get: function get() {
                return this.args.touchSlop || 0;
            }
        },
        {
            key: "delayTouchStart",
            get: function get() {
                var _ref, _this$args$delayTouch, _this$args, _this$args2;
                return (_ref = (_this$args$delayTouch = (_this$args = this.args) === null || _this$args === void 0 ? void 0 : _this$args.delayTouchStart) !== null && _this$args$delayTouch !== void 0 ? _this$args$delayTouch : (_this$args2 = this.args) === null || _this$args2 === void 0 ? void 0 : _this$args2.delay) !== null && _ref !== void 0 ? _ref : 0;
            }
        },
        {
            key: "delayMouseStart",
            get: function get() {
                var _ref2, _this$args$delayMouse, _this$args3, _this$args4;
                return (_ref2 = (_this$args$delayMouse = (_this$args3 = this.args) === null || _this$args3 === void 0 ? void 0 : _this$args3.delayMouseStart) !== null && _this$args$delayMouse !== void 0 ? _this$args$delayMouse : (_this$args4 = this.args) === null || _this$args4 === void 0 ? void 0 : _this$args4.delay) !== null && _ref2 !== void 0 ? _ref2 : 0;
            }
        },
        {
            key: "window",
            get: function get() {
                if (this.context && this.context.window) return this.context.window;
                else if (typeof window !== "undefined") return window;
                return undefined;
            }
        },
        {
            key: "document",
            get: function get() {
                var _this$context;
                if ((_this$context = this.context) !== null && _this$context !== void 0 && _this$context.document) return this.context.document;
                if (this.window) return this.window.document;
                return undefined;
            }
        },
        {
            key: "rootElement",
            get: function get() {
                var _this$args5;
                return ((_this$args5 = this.args) === null || _this$args5 === void 0 ? void 0 : _this$args5.rootElement) || this.document;
            }
        }
    ]);
    return OptionsReader;
}();


var $ab532156454a5aeb$var$_eventNames;
function $ab532156454a5aeb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ab532156454a5aeb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ab532156454a5aeb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ab532156454a5aeb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ab532156454a5aeb$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ab532156454a5aeb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $ab532156454a5aeb$var$eventNames = ($ab532156454a5aeb$var$_eventNames = {}, $ab532156454a5aeb$var$_defineProperty($ab532156454a5aeb$var$_eventNames, (0, $44edc4bf75447885$export$77315d8e4e38ac8f).mouse, {
    start: "mousedown",
    move: "mousemove",
    end: "mouseup",
    contextmenu: "contextmenu"
}), $ab532156454a5aeb$var$_defineProperty($ab532156454a5aeb$var$_eventNames, (0, $44edc4bf75447885$export$77315d8e4e38ac8f).touch, {
    start: "touchstart",
    move: "touchmove",
    end: "touchend"
}), $ab532156454a5aeb$var$_defineProperty($ab532156454a5aeb$var$_eventNames, (0, $44edc4bf75447885$export$77315d8e4e38ac8f).keyboard, {
    keydown: "keydown"
}), $ab532156454a5aeb$var$_eventNames);
var $ab532156454a5aeb$export$d96f7f27c2e7d149 = /*#__PURE__*/ function() {
    // React-DnD Dependencies
    // Internal State
    // Patch for iOS 13, discussion over #1585
    function TouchBackendImpl(manager, context, options) {
        var _this = this;
        $ab532156454a5aeb$var$_classCallCheck(this, TouchBackendImpl);
        $ab532156454a5aeb$var$_defineProperty(this, "options", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "actions", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "monitor", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "sourceNodes", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "sourcePreviewNodes", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "sourcePreviewNodeOptions", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "targetNodes", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "_mouseClientOffset", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "_isScrolling", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "listenerTypes", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "moveStartSourceIds", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "waitingForDelay", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "timeout", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "dragOverTargetIds", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "draggedSourceNode", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "draggedSourceNodeRemovalObserver", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "lastTargetTouchFallback", void 0);
        $ab532156454a5aeb$var$_defineProperty(this, "getSourceClientOffset", function(sourceId) {
            var element = _this.sourceNodes.get(sourceId);
            return element && (0, $2228bfd67c68f655$export$8419e8612027b1d8)(element);
        });
        $ab532156454a5aeb$var$_defineProperty(this, "handleTopMoveStartCapture", function(e) {
            if (!(0, $b6ef6e8aae716822$export$c64909add7c8d190)(e)) return;
            _this.moveStartSourceIds = [];
        });
        $ab532156454a5aeb$var$_defineProperty(this, "handleMoveStart", function(sourceId) {
            // Just because we received an event doesn't necessarily mean we need to collect drag sources.
            // We only collect start collecting drag sources on touch and left mouse events.
            if (Array.isArray(_this.moveStartSourceIds)) _this.moveStartSourceIds.unshift(sourceId);
        });
        $ab532156454a5aeb$var$_defineProperty(this, "handleTopMoveStart", function(e) {
            if (!(0, $b6ef6e8aae716822$export$c64909add7c8d190)(e)) return;
             // Don't prematurely preventDefault() here since it might:
            // 1. Mess up scrolling
            // 2. Mess up long tap (which brings up context menu)
            // 3. If there's an anchor link as a child, tap won't be triggered on link
            var clientOffset = (0, $2228bfd67c68f655$export$710c829989c68339)(e);
            if (clientOffset) {
                if ((0, $b6ef6e8aae716822$export$c4dfce035d43d1e0)(e)) _this.lastTargetTouchFallback = e.targetTouches[0];
                _this._mouseClientOffset = clientOffset;
            }
            _this.waitingForDelay = false;
        });
        $ab532156454a5aeb$var$_defineProperty(this, "handleTopMoveStartDelay", function(e) {
            if (!(0, $b6ef6e8aae716822$export$c64909add7c8d190)(e)) return;
            var delay = e.type === $ab532156454a5aeb$var$eventNames.touch.start ? _this.options.delayTouchStart : _this.options.delayMouseStart;
            _this.timeout = setTimeout(_this.handleTopMoveStart.bind(_this, e), delay);
            _this.waitingForDelay = true;
        });
        $ab532156454a5aeb$var$_defineProperty(this, "handleTopMoveCapture", function() {
            _this.dragOverTargetIds = [];
        });
        $ab532156454a5aeb$var$_defineProperty(this, "handleMove", function(_evt, targetId) {
            if (_this.dragOverTargetIds) _this.dragOverTargetIds.unshift(targetId);
        });
        $ab532156454a5aeb$var$_defineProperty(this, "handleTopMove", function(e) {
            if (_this.timeout) clearTimeout(_this.timeout);
            if (!_this.document || _this.waitingForDelay) return;
            var moveStartSourceIds = _this.moveStartSourceIds, dragOverTargetIds = _this.dragOverTargetIds;
            var enableHoverOutsideTarget = _this.options.enableHoverOutsideTarget;
            var clientOffset = (0, $2228bfd67c68f655$export$710c829989c68339)(e, _this.lastTargetTouchFallback);
            if (!clientOffset) return;
             // If the touch move started as a scroll, or is is between the scroll angles
            if (_this._isScrolling || !_this.monitor.isDragging() && (0, $eda2b3a93a47f5e9$export$7c909de71a662f4d)(_this._mouseClientOffset.x || 0, _this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y, _this.options.scrollAngleRanges)) {
                _this._isScrolling = true;
                return;
            } // If we're not dragging and we've moved a little, that counts as a drag start
            if (!_this.monitor.isDragging() && // eslint-disable-next-line no-prototype-builtins
            _this._mouseClientOffset.hasOwnProperty("x") && moveStartSourceIds && (0, $eda2b3a93a47f5e9$export$9f17032d917177de)(_this._mouseClientOffset.x || 0, _this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y) > (_this.options.touchSlop ? _this.options.touchSlop : 0)) {
                _this.moveStartSourceIds = undefined;
                _this.actions.beginDrag(moveStartSourceIds, {
                    clientOffset: _this._mouseClientOffset,
                    getSourceClientOffset: _this.getSourceClientOffset,
                    publishSource: false
                });
            }
            if (!_this.monitor.isDragging()) return;
            var sourceNode = _this.sourceNodes.get(_this.monitor.getSourceId());
            _this.installSourceNodeRemovalObserver(sourceNode);
            _this.actions.publishDragSource();
            if (e.cancelable) e.preventDefault(); // Get the node elements of the hovered DropTargets
            var dragOverTargetNodes = (dragOverTargetIds || []).map(function(key) {
                return _this.targetNodes.get(key);
            }).filter(function(e) {
                return !!e;
            }); // Get the a ordered list of nodes that are touched by
            var elementsAtPoint = _this.options.getDropTargetElementsAtPoint ? _this.options.getDropTargetElementsAtPoint(clientOffset.x, clientOffset.y, dragOverTargetNodes) : _this.document.elementsFromPoint(clientOffset.x, clientOffset.y); // Extend list with parents that are not receiving elementsFromPoint events (size 0 elements and svg groups)
            var elementsAtPointExtended = [];
            for(var nodeId in elementsAtPoint){
                // eslint-disable-next-line no-prototype-builtins
                if (!elementsAtPoint.hasOwnProperty(nodeId)) continue;
                var currentNode = elementsAtPoint[nodeId];
                elementsAtPointExtended.push(currentNode);
                while(currentNode){
                    currentNode = currentNode.parentElement;
                    if (currentNode && elementsAtPointExtended.indexOf(currentNode) === -1) elementsAtPointExtended.push(currentNode);
                }
            }
            var orderedDragOverTargetIds = elementsAtPointExtended // Filter off nodes that arent a hovered DropTargets nodes
            .filter(function(node) {
                return dragOverTargetNodes.indexOf(node) > -1;
            }) // Map back the nodes elements to targetIds
            .map(function(node) {
                return _this._getDropTargetId(node);
            }) // Filter off possible null rows
            .filter(function(node) {
                return !!node;
            }).filter(function(id, index, ids) {
                return ids.indexOf(id) === index;
            }); // Invoke hover for drop targets when source node is still over and pointer is outside
            if (enableHoverOutsideTarget) for(var targetId in _this.targetNodes){
                var targetNode = _this.targetNodes.get(targetId);
                if (sourceNode && targetNode && targetNode.contains(sourceNode) && orderedDragOverTargetIds.indexOf(targetId) === -1) {
                    orderedDragOverTargetIds.unshift(targetId);
                    break;
                }
            }
             // Reverse order because dnd-core reverse it before calling the DropTarget drop methods
            orderedDragOverTargetIds.reverse();
            _this.actions.hover(orderedDragOverTargetIds, {
                clientOffset: clientOffset
            });
        });
        $ab532156454a5aeb$var$_defineProperty(this, "_getDropTargetId", function(node) {
            var keys = _this.targetNodes.keys();
            var next = keys.next();
            while(next.done === false){
                var targetId = next.value;
                if (node === _this.targetNodes.get(targetId)) return targetId;
                else next = keys.next();
            }
            return undefined;
        });
        $ab532156454a5aeb$var$_defineProperty(this, "handleTopMoveEndCapture", function(e) {
            _this._isScrolling = false;
            _this.lastTargetTouchFallback = undefined;
            if (!(0, $b6ef6e8aae716822$export$23bc6ab5d304a5)(e)) return;
            if (!_this.monitor.isDragging() || _this.monitor.didDrop()) {
                _this.moveStartSourceIds = undefined;
                return;
            }
            if (e.cancelable) e.preventDefault();
            _this._mouseClientOffset = {};
            _this.uninstallSourceNodeRemovalObserver();
            _this.actions.drop();
            _this.actions.endDrag();
        });
        $ab532156454a5aeb$var$_defineProperty(this, "handleCancelOnEscape", function(e) {
            if (e.key === "Escape" && _this.monitor.isDragging()) {
                _this._mouseClientOffset = {};
                _this.uninstallSourceNodeRemovalObserver();
                _this.actions.endDrag();
            }
        });
        this.options = new (0, $43ab2ff5dd1e7dc9$export$2b3a268803e49e64)(options, context);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.sourceNodes = new Map();
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.targetNodes = new Map();
        this.listenerTypes = [];
        this._mouseClientOffset = {};
        this._isScrolling = false;
        if (this.options.enableMouseEvents) this.listenerTypes.push((0, $44edc4bf75447885$export$77315d8e4e38ac8f).mouse);
        if (this.options.enableTouchEvents) this.listenerTypes.push((0, $44edc4bf75447885$export$77315d8e4e38ac8f).touch);
        if (this.options.enableKeyboardEvents) this.listenerTypes.push((0, $44edc4bf75447885$export$77315d8e4e38ac8f).keyboard);
    }
    /**
   * Generate profiling statistics for the HTML5Backend.
   */ $ab532156454a5aeb$var$_createClass(TouchBackendImpl, [
        {
            key: "profile",
            value: function profile() {
                var _this$dragOverTargetI;
                return {
                    sourceNodes: this.sourceNodes.size,
                    sourcePreviewNodes: this.sourcePreviewNodes.size,
                    sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
                    targetNodes: this.targetNodes.size,
                    dragOverTargetIds: ((_this$dragOverTargetI = this.dragOverTargetIds) === null || _this$dragOverTargetI === void 0 ? void 0 : _this$dragOverTargetI.length) || 0
                };
            } // public for test
        },
        {
            key: "document",
            get: function get() {
                return this.options.document;
            }
        },
        {
            key: "setup",
            value: function setup() {
                var root = this.options.rootElement;
                if (!root) return;
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(!TouchBackendImpl.isSetUp, "Cannot have two Touch backends at the same time.");
                TouchBackendImpl.isSetUp = true;
                this.addEventListener(root, "start", this.getTopMoveStartHandler());
                this.addEventListener(root, "start", this.handleTopMoveStartCapture, true);
                this.addEventListener(root, "move", this.handleTopMove);
                this.addEventListener(root, "move", this.handleTopMoveCapture, true);
                this.addEventListener(root, "end", this.handleTopMoveEndCapture, true);
                if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) this.addEventListener(root, "contextmenu", this.handleTopMoveEndCapture);
                if (this.options.enableKeyboardEvents) this.addEventListener(root, "keydown", this.handleCancelOnEscape, true);
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                var root = this.options.rootElement;
                if (!root) return;
                TouchBackendImpl.isSetUp = false;
                this._mouseClientOffset = {};
                this.removeEventListener(root, "start", this.handleTopMoveStartCapture, true);
                this.removeEventListener(root, "start", this.handleTopMoveStart);
                this.removeEventListener(root, "move", this.handleTopMoveCapture, true);
                this.removeEventListener(root, "move", this.handleTopMove);
                this.removeEventListener(root, "end", this.handleTopMoveEndCapture, true);
                if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) this.removeEventListener(root, "contextmenu", this.handleTopMoveEndCapture);
                if (this.options.enableKeyboardEvents) this.removeEventListener(root, "keydown", this.handleCancelOnEscape, true);
                this.uninstallSourceNodeRemovalObserver();
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(subject, event, handler, capture) {
                var options = (0, $df2256e716d37ec3$export$a8f436d4c8f15a1f) ? {
                    capture: capture,
                    passive: false
                } : capture;
                this.listenerTypes.forEach(function(listenerType) {
                    var evt = $ab532156454a5aeb$var$eventNames[listenerType][event];
                    if (evt) subject.addEventListener(evt, handler, options);
                });
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(subject, event, handler, capture) {
                var options = (0, $df2256e716d37ec3$export$a8f436d4c8f15a1f) ? {
                    capture: capture,
                    passive: false
                } : capture;
                this.listenerTypes.forEach(function(listenerType) {
                    var evt = $ab532156454a5aeb$var$eventNames[listenerType][event];
                    if (evt) subject.removeEventListener(evt, handler, options);
                });
            }
        },
        {
            key: "connectDragSource",
            value: function connectDragSource(sourceId, node) {
                var _this2 = this;
                var handleMoveStart = this.handleMoveStart.bind(this, sourceId);
                this.sourceNodes.set(sourceId, node);
                this.addEventListener(node, "start", handleMoveStart);
                return function() {
                    _this2.sourceNodes.delete(sourceId);
                    _this2.removeEventListener(node, "start", handleMoveStart);
                };
            }
        },
        {
            key: "connectDragPreview",
            value: function connectDragPreview(sourceId, node, options) {
                var _this3 = this;
                this.sourcePreviewNodeOptions.set(sourceId, options);
                this.sourcePreviewNodes.set(sourceId, node);
                return function() {
                    _this3.sourcePreviewNodes.delete(sourceId);
                    _this3.sourcePreviewNodeOptions.delete(sourceId);
                };
            }
        },
        {
            key: "connectDropTarget",
            value: function connectDropTarget(targetId, node) {
                var _this4 = this;
                var root = this.options.rootElement;
                if (!this.document || !root) return function() {
                /* noop */ };
                var handleMove = function handleMove(e) {
                    if (!_this4.document || !root || !_this4.monitor.isDragging()) return;
                    var coords;
                    /**
         * Grab the coordinates for the current mouse/touch position
         */ switch(e.type){
                        case $ab532156454a5aeb$var$eventNames.mouse.move:
                            coords = {
                                x: e.clientX,
                                y: e.clientY
                            };
                            break;
                        case $ab532156454a5aeb$var$eventNames.touch.move:
                            coords = {
                                x: e.touches[0].clientX,
                                y: e.touches[0].clientY
                            };
                            break;
                    }
                    /**
         * Use the coordinates to grab the element the drag ended on.
         * If the element is the same as the target node (or any of it's children) then we have hit a drop target and can handle the move.
         */ var droppedOn = coords != null ? _this4.document.elementFromPoint(coords.x, coords.y) : undefined;
                    var childMatch = droppedOn && node.contains(droppedOn);
                    if (droppedOn === node || childMatch) return _this4.handleMove(e, targetId);
                };
                /**
       * Attaching the event listener to the body so that touchmove will work while dragging over multiple target elements.
       */ this.addEventListener(this.document.body, "move", handleMove);
                this.targetNodes.set(targetId, node);
                return function() {
                    if (_this4.document) {
                        _this4.targetNodes.delete(targetId);
                        _this4.removeEventListener(_this4.document.body, "move", handleMove);
                    }
                };
            }
        },
        {
            key: "getTopMoveStartHandler",
            value: function getTopMoveStartHandler() {
                if (!this.options.delayTouchStart && !this.options.delayMouseStart) return this.handleTopMoveStart;
                return this.handleTopMoveStartDelay;
            }
        },
        {
            key: "installSourceNodeRemovalObserver",
            value: function installSourceNodeRemovalObserver(node) {
                var _this5 = this;
                this.uninstallSourceNodeRemovalObserver();
                this.draggedSourceNode = node;
                this.draggedSourceNodeRemovalObserver = new MutationObserver(function() {
                    if (node && !node.parentElement) {
                        _this5.resurrectSourceNode();
                        _this5.uninstallSourceNodeRemovalObserver();
                    }
                });
                if (!node || !node.parentElement) return;
                this.draggedSourceNodeRemovalObserver.observe(node.parentElement, {
                    childList: true
                });
            }
        },
        {
            key: "resurrectSourceNode",
            value: function resurrectSourceNode() {
                if (this.document && this.draggedSourceNode) {
                    this.draggedSourceNode.style.display = "none";
                    this.draggedSourceNode.removeAttribute("data-reactid");
                    this.document.body.appendChild(this.draggedSourceNode);
                }
            }
        },
        {
            key: "uninstallSourceNodeRemovalObserver",
            value: function uninstallSourceNodeRemovalObserver() {
                if (this.draggedSourceNodeRemovalObserver) this.draggedSourceNodeRemovalObserver.disconnect();
                this.draggedSourceNodeRemovalObserver = undefined;
                this.draggedSourceNode = undefined;
            }
        }
    ]);
    return TouchBackendImpl;
}();
$ab532156454a5aeb$var$_defineProperty($ab532156454a5aeb$export$d96f7f27c2e7d149, "isSetUp", void 0);



var $2ddee4e88aa8f08e$export$b4d0180dbe086f87 = function createBackend(manager) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return new (0, $ab532156454a5aeb$export$d96f7f27c2e7d149)(manager, context, options);
};



var $3ff372f1a8f93628$export$2e2bcd8739ae039 = {
    backends: [
        {
            backend: (0, $8956e4b9503941ab$export$f4f61d779bb20744),
            transition: (0, $9b521fca47cd4e7e$export$6863e369d9a30d41)
        },
        {
            backend: (0, $2ddee4e88aa8f08e$export$b4d0180dbe086f87),
            options: {
                enableMouseEvents: true
            },
            preview: true,
            transition: (0, $9b521fca47cd4e7e$export$91e99a52278bf8a5)
        }
    ]
};




var $4DE7A = parcelRequire("4DE7A");



const $c738fd431d4d7b5f$export$8ad76b76a4c905f8 = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8);
const $c738fd431d4d7b5f$export$2105062e25df4afe = (0, $5be681cecefb99e4$export$2105062e25df4afe);




var $4DE7A = parcelRequire("4DE7A");

// THIS FILE IS AUTO GENERATED
var $b0e012ee4072786f$export$a0f7048edafc45cd = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];



var $4DE7A = parcelRequire("4DE7A");

var $4DE7A = parcelRequire("4DE7A");
var $1ae844fcbf370d59$export$4a4ef469214f8641 = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var $1ae844fcbf370d59$export$a49f528ae1a4d0ed = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createContext && (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createContext($1ae844fcbf370d59$export$4a4ef469214f8641);


var $2226cc54c1b91b60$var$__assign = undefined && undefined.__assign || function() {
    $2226cc54c1b91b60$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2226cc54c1b91b60$var$__assign.apply(this, arguments);
};
var $2226cc54c1b91b60$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $2226cc54c1b91b60$var$Tree2Element(tree) {
    return tree && tree.map(function(node, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement(node.tag, $2226cc54c1b91b60$var$__assign({
            key: i
        }, node.attr), $2226cc54c1b91b60$var$Tree2Element(node.child));
    });
}
function $2226cc54c1b91b60$export$6fce6cce1e9a936d(data) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement($2226cc54c1b91b60$export$a188ecdd443fe91a, $2226cc54c1b91b60$var$__assign({
            attr: $2226cc54c1b91b60$var$__assign({}, data.attr)
        }, props), $2226cc54c1b91b60$var$Tree2Element(data.child));
    };
}
function $2226cc54c1b91b60$export$a188ecdd443fe91a(props) {
    var elem = function(conf) {
        var attr = props.attr, size = props.size, title = props.title, svgProps = $2226cc54c1b91b60$var$__rest(props, [
            "attr",
            "size",
            "title"
        ]);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("svg", $2226cc54c1b91b60$var$__assign({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: $2226cc54c1b91b60$var$__assign($2226cc54c1b91b60$var$__assign({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("title", null, title), props.children);
    };
    return (0, $1ae844fcbf370d59$export$a49f528ae1a4d0ed) !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, $1ae844fcbf370d59$export$a49f528ae1a4d0ed).Consumer, null, function(conf) {
        return elem(conf);
    }) : elem((0, $1ae844fcbf370d59$export$4a4ef469214f8641));
}





function $6ec9aef169c6b70a$export$774e6cc4446baa8b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "40",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M204.23 274.44c2.9-18.06 4.2-35.52-.5-47.59-4-10.38-12.7-16.19-23.2-20.15L88 176.76c-12-4-23.21-10.7-24-23.94-1-17 14-28 29-24 0 0 88 31.14 163 31.14s162-31 162-31c18-5 30 9 30 23.79 0 14.21-11 19.21-24 23.94l-88 31.91c-8 3-21 9-26 18.18-6 10.75-5 29.53-2.1 47.59l5.9 29.63 37.41 163.9c2.8 13.15-6.3 25.44-19.4 27.74S308 489 304.12 476.28l-37.56-115.93q-2.71-8.34-4.8-16.87L256 320l-5.3 21.65q-2.52 10.35-5.8 20.48L208 476.18c-4 12.85-14.5 21.75-27.6 19.46s-22.4-15.59-19.46-27.74l37.39-163.83z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$29557f4460e01ab5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 112c-66.82 17.92-119.55 32-192 32s-125.18-14.08-192-32l-16 51c48 20.53 96.71 35.16 147.2 53.2L144 496l56.4 16L246 336h20l45.6 176 56.4-16-51.2-279.8C367.26 199.93 416 183.53 464 164zm-192 0a56 56 0 1156-56 56.06 56.06 0 01-56 56z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e2ca0e20a2a551c8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 112a56 56 0 1156-56 56.06 56.06 0 01-56 56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M432 112.8l-.45.12-.42.13c-1 .28-2 .58-3 .89-18.61 5.46-108.93 30.92-172.56 30.92-59.13 0-141.28-22-167.56-29.47a73.79 73.79 0 00-8-2.58c-19-5-32 14.3-32 31.94 0 17.47 15.7 25.79 31.55 31.76v.28l95.22 29.74c9.73 3.73 12.33 7.54 13.6 10.84 4.13 10.59.83 31.56-.34 38.88l-5.8 45-32.19 176.19q-.15.72-.27 1.47l-.23 1.27c-2.32 16.15 9.54 31.82 32 31.82 19.6 0 28.25-13.53 32-31.94s28-157.57 42-157.57 42.84 157.57 42.84 157.57c3.75 18.41 12.4 31.94 32 31.94 22.52 0 34.38-15.74 32-31.94a57.17 57.17 0 00-.76-4.06L329 301.27l-5.79-45c-4.19-26.21-.82-34.87.32-36.9a1.09 1.09 0 00.08-.15c1.08-2 6-6.48 17.48-10.79l89.28-31.21a16.9 16.9 0 001.62-.52c16-6 32-14.3 32-31.93S451 107.81 432 112.8z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7a5164469fd6a9f2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 176v160m80-80H176"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9a8be9fc3e1d458(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm96 224h-80v80h-32v-80h-80v-32h80v-80h32v80h80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3400c19356259392(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 224h-64v64a16 16 0 01-32 0v-64h-64a16 16 0 010-32h64v-64a16 16 0 0132 0v64h64a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d4ae54674922e301(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 112v288m144-144H112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$74832c9587301809(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 112v288m144-144H112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$72275052bb5a53a0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 112v288m144-144H112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f74af0883b1bc6d8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M407.72 224c-3.4 0-14.79.1-18 .3l-64.9 1.7a1.83 1.83 0 01-1.69-.9L193.55 67.56a9 9 0 00-6.66-3.56H160l73 161a2.35 2.35 0 01-2.26 3.35l-121.69 1.8a8.06 8.06 0 01-6.6-3.1l-37-45c-3-3.9-8.62-6-13.51-6H33.08c-1.29 0-1.1 1.21-.75 2.43l19.84 71.42a16.3 16.3 0 010 11.9L32.31 333c-.59 1.95-.52 3 1.77 3H52c8.14 0 9.25-1.06 13.41-6.3l37.7-45.7a8.19 8.19 0 016.6-3.1l120.68 2.7a2.7 2.7 0 012.43 3.74L160 448h26.64a9 9 0 006.65-3.55L323.14 287c.39-.6 2-.9 2.69-.9l63.9 1.7c3.3.2 14.59.3 18 .3C452 288.1 480 275.93 480 256s-27.88-32-72.28-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e03701dec7ee1ce6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.72 208c-2.72 0-14.44.08-18.67.31l-57.77 1.52L198.06 48h-62.81l74.59 164.61-97.31 1.44L68.25 160H16.14l20.61 94.18c.15.54.33 1.07.53 1.59a.26.26 0 010 .15 15.42 15.42 0 00-.53 1.58L15.86 352h51.78l45.45-55 96.77 2.17L135.24 464h63l133-161.75 57.77 1.54c4.29.23 16 .31 18.66.31 24.35 0 44.27-3.34 59.21-9.94C492.22 283 496 265.46 496 256c0-30.06-33-48-88.28-48zm-71.29 87.9z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$891530ed102c43fc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.62 464H160a16 16 0 01-14.57-22.6l64.46-142.25L113.1 297l-35.3 42.77C71.07 348.23 65.7 352 52 352H34.08a17.66 17.66 0 01-14.7-7.06c-2.38-3.21-4.72-8.65-2.44-16.41l19.82-71c.15-.53.33-1.06.53-1.58a.38.38 0 000-.15 14.82 14.82 0 01-.53-1.59l-19.84-71.45c-2.15-7.61.2-12.93 2.56-16.06a16.83 16.83 0 0113.6-6.7H52c10.23 0 20.16 4.59 26 12l34.57 42.05 97.32-1.44-64.44-142A16 16 0 01160 48h26.91a25 25 0 0119.35 9.8l125.05 152 57.77-1.52c4.23-.23 15.95-.31 18.66-.31C463 208 496 225.94 496 256c0 9.46-3.78 27-29.07 38.16-14.93 6.6-34.85 9.94-59.21 9.94-2.68 0-14.37-.08-18.66-.31l-57.76-1.54-125.36 152a25 25 0 01-19.32 9.75z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$47cedc0dde54d181(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M416.07 272a160 160 0 10-160 160 160 160 0 00160-160zM142.12 91.21A46.67 46.67 0 00112 80l-2.79.08C83.66 81.62 64 104 64.07 131c0 13.21 4.66 19.37 10.88 27.23a4.55 4.55 0 003.24 1.77h.88a3.23 3.23 0 002.54-1.31L142.38 99a5.38 5.38 0 001.55-4 5.26 5.26 0 00-1.81-3.79zm227.76 0A46.67 46.67 0 01400 80l2.79.08C428.34 81.62 448 104 447.93 131c0 13.21-4.66 19.37-10.88 27.23a4.55 4.55 0 01-3.24 1.76h-.88a3.23 3.23 0 01-2.54-1.31L369.62 99a5.38 5.38 0 01-1.55-4 5.26 5.26 0 011.81-3.79z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256.07 160v112h-80m240 160l-40-40m-280 40l40-40"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5388abe157f0a237(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.79 64.11l-3.27-.1H400c-14.73 0-28.55 5.91-40.52 15S344 96 344 96l88 86s11.25-5.71 17.61-13.85 14.28-18.08 14.32-37.11c.07-35.49-26.33-64.89-60.14-66.93zm-295.58 0l3.27-.1h.52c14.73 0 28.55 5.91 40.52 15S168 96 168 96l-88 86s-11.25-5.71-17.61-13.85S48.11 150.07 48.07 131C48 95.55 74.4 66.15 108.21 64.11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M391.3 384.6a.06.06 0 010-.08C425 344 441 288.24 427 229.23c-13.64-57.52-72.67-115.69-130.34-128.66C182 74.79 80.07 161.71 80.07 272a175.15 175.15 0 0040.78 112.52.06.06 0 010 .08L73 432a.06.06 0 000 .08l23 22.51a.06.06 0 00.08 0l47.43-47.37a.06.06 0 01.08 0 175.64 175.64 0 00225.05 0h.07L416 454.59a.06.06 0 00.08 0L440 432zM272.07 288H160v-31.9l.05-.05h80V144h32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$da6aaa1633dff969(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.59 110.46A21.41 21.41 0 00152.48 79 62.67 62.67 0 00112 64l-3.27.09h-.48C74.4 66.15 48 95.55 48.07 131c0 19 8 29.06 14.32 37.11a20.61 20.61 0 0014.7 7.8c.26 0 .7.05 2 .05a19.06 19.06 0 0013.75-5.89zm250.2-46.35l-3.27-.1H400a62.67 62.67 0 00-40.52 15 21.41 21.41 0 00-1.11 31.44l60.77 59.65a19.06 19.06 0 0013.79 5.9c1.28 0 1.72 0 2-.05a20.61 20.61 0 0014.69-7.8c6.36-8.05 14.28-18.08 14.32-37.11.06-35.49-26.34-64.89-60.15-66.93z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256.07 96c-97 0-176 78.95-176 176a175.23 175.23 0 0040.81 112.56l-36.12 36.13a16 16 0 1022.63 22.62l36.12-36.12a175.63 175.63 0 00225.12 0l36.13 36.12a16 16 0 1022.63-22.62l-36.13-36.13A175.17 175.17 0 00432.07 272c0-97-78.95-176-176-176zm16 176a16 16 0 01-16 16h-80a16 16 0 010-32h64v-96a16 16 0 0132 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d7e5a1073495950b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "384",
                    "height": "256",
                    "x": "64",
                    "y": "176",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28.87",
                    "ry": "28.87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M144 80h224m-256 48h288"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$36befa116b961b59(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 64h256v32H128zm-32 48h320v32H96zm368 336H48V160h416z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$49c8e3475fd5555c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 96H144a16 16 0 010-32h224a16 16 0 010 32zm32 48H112a16 16 0 010-32h288a16 16 0 010 32zm19.13 304H92.87A44.92 44.92 0 0148 403.13V204.87A44.92 44.92 0 0192.87 160h326.26A44.92 44.92 0 01464 204.87v198.26A44.92 44.92 0 01419.13 448z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bc1789c99b725c7d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M250.26 166.05L256 288l5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 367.91a20 20 0 1120-20 20 20 0 01-20 20z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$26efc7446a1b9669(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M240 304h32l6-160h-44l6 160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm20 319.91h-40v-40h40zM272 304h-32l-6-160h44z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b94ac53e07e4ef87(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 319.91a20 20 0 1120-20 20 20 0 01-20 20zm21.72-201.15l-5.74 122a16 16 0 01-32 0l-5.74-121.94v-.05a21.74 21.74 0 1143.44 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b22c549c6826fec7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 80c-8.66 0-16.58 7.36-16 16l8 216a8 8 0 008 8h0a8 8 0 008-8l8-216c.58-8.64-7.34-16-16-16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "416",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5eba120f9738a709(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M240 80l8 240h16l8-240h-32zm0 320h32v32h-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bcf454ee44bb1627(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 80c-8.66 0-16.58 7.36-16 16l8 216a8 8 0 008 8h0a8 8 0 008-8l8-216c.58-8.64-7.34-16-16-16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "416",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6783a21ce87acb4b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "267.57",
                    "ry": "173.44",
                    "transform": "rotate(-45 256 256.002)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M334.04 177.96L177.96 334.04M278.3 278.3l-44.6-44.6m89.19 0l-44.59-44.59m178.38 22.29L300.6 55.32m-89.2 401.36L55.32 300.6m178.38 22.29l-44.59-44.59"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$215e40a96f41130a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.9 120.51c-44.75 44.56-67.29 101.05-78.64 145.9l202.31 201.44c45.05-11.3 101.78-33.74 146.53-78.3s67.29-101.05 78.64-145.91L267.43 42.21C222.38 53.51 165.65 76 120.9 120.51zm259 257.83zm-45-224.2l22.52 22.42-33.78 33.63 22.52 22.42L323.55 255 301 232.61 278.52 255 301 277.45l-22.51 22.42L256 277.45l-22.52 22.42L256 322.29l-22.52 22.42L211 322.29l-33.78 33.63-22.55-22.42 33.78-33.63-22.52-22.42L188.45 255 211 277.45 233.48 255 211 232.61l22.51-22.42L256 232.61l22.52-22.42L256 187.77l22.52-22.42L301 187.77zm143.58 44.27C485.85 143.65 464 48.05 464 48.05s-96.14-21.88-151.14-14.54c-2.54.33-5.21.72-8 1.14l172.47 171.71c.43-2.76.81-5.42 1.15-7.95zM33.52 311.65C26.15 366.41 48.05 464 48.05 464s60 16 99.86 16a391.92 391.92 0 0051.23-3.45c2.54-.33 5.21-.72 8-1.15L34.67 303.7c-.43 2.76-.81 5.42-1.15 7.95z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$beec1025f6b34ca6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M122.06 122.06c-44.37 44.37-66.71 100.61-78 145.28l200.6 200.56c44.67-11.25 100.91-33.59 145.28-78s66.71-100.61 78-145.28L267.34 44.1c-44.67 11.25-100.91 33.59-145.28 77.96zm256.73 256.72zM300.65 189L323 166.71A15.78 15.78 0 01345.29 189L323 211.35l11.16 11.17a15.78 15.78 0 01-22.32 22.32l-11.16-11.16L278.32 256l11.16 11.16a15.78 15.78 0 11-22.32 22.32L256 278.32l-22.32 22.33 11.16 11.16a15.78 15.78 0 11-22.32 22.32L211.35 323 189 345.29A15.78 15.78 0 01166.71 323L189 300.65l-11.16-11.17a15.78 15.78 0 0122.32-22.32l11.16 11.16L233.68 256l-11.16-11.16a15.78 15.78 0 1122.32-22.32L256 233.68l22.32-22.33-11.16-11.16a15.78 15.78 0 0122.32-22.32zm175.92 10.63c7.31-54.53 4-120.26-20-144.21s-89.68-27.3-144.21-20c-2.51.34-5.16.72-7.91 1.15l171 171c.4-2.78.78-5.43 1.12-7.94zM35.43 312.37c-7.31 54.53-4 120.26 20 144.21C72.17 473.33 109.34 480 148.84 480a387 387 0 0050.79-3.43c2.51-.34 5.16-.72 7.91-1.15l-171-171c-.39 2.79-.77 5.44-1.11 7.95z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2f531d10a7b5304e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M344 280l88-88m-200 24l64 64M80 320l104-104"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "456",
                    "cy": "168",
                    "r": "24",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "320",
                    "cy": "304",
                    "r": "24",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "208",
                    "cy": "192",
                    "r": "24",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "56",
                    "cy": "344",
                    "r": "24",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b903f50318e1e6ad(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M450 128a46 46 0 00-44.11 59l-71.37 71.36a45.88 45.88 0 00-29 0l-52.91-52.91a46 46 0 10-89.12 0L75 293.88A46.08 46.08 0 10106.11 325l87.37-87.36a45.85 45.85 0 0029 0l52.92 52.92a46 46 0 1089.12 0L437 218.12A46 46 0 10450 128z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$385fa4dd4446a998(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 128a40 40 0 00-37.23 54.6l-84.17 84.17a39.86 39.86 0 00-29.2 0l-60.17-60.17a40 40 0 10-74.46 0L70.6 306.77a40 40 0 1022.63 22.63L193.4 229.23a39.86 39.86 0 0029.2 0l60.17 60.17a40 40 0 1074.46 0l84.17-84.17A40 40 0 10456 128z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$770910909d9d4c0f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M360 94.59V296m83.13-83.13L296 360m121.41 0H216m83.13 83.13l-144-144M152 416V216m-83.13 83.13l144-144M94.59 152H288m-75.13-83.13L360 216"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d2e0dbe366babd17(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 48l129.49 128.18V48H216zm-34.53 10.38L80 134h176l-74.53-75.62zM336 344h128V216L336 344zm118-162L378 80v176l76-74zM48 166v128l128-128H48zm282 288l102-76H256l74 76zM58 330l76 102V256l-76 74zm287.49-107.88l-55.55-55.46h-67.88l-55.55 55.46v67.76l55.62 55.52c.44 0 .88-.06 1.33-.06h66.48l55.55-55.46zM165.98 336.09L166 464h128L165.98 336.09z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$339cab20bc1303bb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M250.54 129.17l-67.8-67.8A209.65 209.65 0 0086.32 136h161.4a4 4 0 002.82-6.83zM167.72 168H67.63a207.34 207.34 0 00-16.15 125.9l119.06-119.07a4 4 0 00-2.82-6.83zm176.28-.28V67.56a207.82 207.82 0 00-125.89-16.08l119.06 119.06a4 4 0 006.83-2.82zm116.52 50.38L341.46 337.17a4 4 0 002.82 6.83h100.09a207.34 207.34 0 0016.15-125.9zm-77.69 32.44l67.83-67.82A209.08 209.08 0 00376 86.2v161.52a4 4 0 006.83 2.82zm-161.15 91.23a8 8 0 005.54 2.23h59.66a8 8 0 005.7-2.39l49.18-50a8 8 0 002.3-5.62l-.06-60.81a8 8 0 00-2.38-5.69l-50-49.25a8 8 0 00-5.63-2.3l-60.84.06a8 8 0 00-5.69 2.38l-49.25 50a8 8 0 00-2.3 5.63l.06 60.78a8 8 0 002.45 5.76zm39.78 41.06l67.8 67.8A209.65 209.65 0 00425.68 376h-161.4a4 4 0 00-2.82 6.83zM168 344.28v100.16a207.82 207.82 0 00125.89 16.08L174.83 341.46a4 4 0 00-6.83 2.82zm-38.83-82.82l-67.83 67.83A209.1 209.1 0 00136 425.8V264.28a4 4 0 00-6.83-2.82z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5db025b388105cd1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "64",
                    "y": "64",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "216",
                    "y": "64",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "368",
                    "y": "64",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "64",
                    "y": "216",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "216",
                    "y": "216",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "368",
                    "y": "216",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "64",
                    "y": "368",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "216",
                    "y": "368",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "368",
                    "y": "368",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6c9b849b465589e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "48",
                    "y": "48",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "200",
                    "y": "48",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "352",
                    "y": "48",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "48",
                    "y": "200",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "200",
                    "y": "200",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "352",
                    "y": "200",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "48",
                    "y": "352",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "200",
                    "y": "352",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "352",
                    "y": "352",
                    "rx": "8",
                    "ry": "8"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ee495b4c7c8a71fa(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 160a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zM104 312a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zM104 464a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$21d9d0f71242ae6c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 152v256a40.12 40.12 0 0040 40h272a40.12 40.12 0 0040-40V152"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "80",
                    "x": "48",
                    "y": "64",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 304l-64 64-64-64m64 41.89V224"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a21f29be886b8e2a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "80",
                    "x": "32",
                    "y": "48",
                    "rx": "12",
                    "ry": "12"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M64 160v280a24 24 0 0024 24h336a24 24 0 0024-24V160zm192 230.63L169.32 304 192 281.32l48 48.05V208h32v121.37l48.07-48.07 22.61 22.64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3db5850dc3841299(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 164v244a56 56 0 0056 56h272a56 56 0 0056-56V164a4 4 0 00-4-4H68a4 4 0 00-4 4zm267 151.63l-63.69 63.68a16 16 0 01-22.62 0L181 315.63c-6.09-6.09-6.65-16-.85-22.38a16 16 0 0123.16-.56L240 329.37V224.45c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 224v105.37l36.69-36.68a16 16 0 0123.16.56c5.8 6.37 5.24 16.29-.85 22.38z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "80",
                    "x": "32",
                    "y": "48",
                    "rx": "32",
                    "ry": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7bda703917647ff7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M249.38 336L170 256l79.38-80m-68.35 80H342"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2cdff5951fda7480(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm224-80.09L208.42 240H358v32H208.42L272 336.09l-22.7 22.54L147.46 256 249.3 153.37z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$dd595a47da3cbb94(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm212.65-91.36a16 16 0 01.09 22.63L208.42 240H342a16 16 0 010 32H208.42l52.32 52.73A16 16 0 11238 347.27l-79.39-80a16 16 0 010-22.54l79.39-80a16 16 0 0122.65-.09z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2731386b1e632732(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M244 400L100 256l144-144M120 256h292"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3004cfd76528422c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M244 400L100 256l144-144M120 256h292"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7e9f1671ccbd560c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M244 400L100 256l144-144M120 256h292"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$389d4f73840ae16b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 262.62L256 342l80-79.38m-80 68.35V170"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1c413ca05033d46a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c114.87 0 208-93.13 208-208S370.87 48 256 48 48 141.13 48 256s93.13 208 208 208zm-80.09-224L240 303.58V154h32v149.58L336.09 240l22.54 22.71L256 364.54 153.37 262.7z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2f60f9b3b2d866e6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c114.87 0 208-93.13 208-208S370.87 48 256 48 48 141.13 48 256s93.13 208 208 208zm-91.36-212.65a16 16 0 0122.63-.09L240 303.58V170a16 16 0 0132 0v133.58l52.73-52.32A16 16 0 11347.27 274l-80 79.39a16 16 0 01-22.54 0l-80-79.39a16 16 0 01-.09-22.65z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bfa240b6fe900fa7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 268l144 144 144-144M256 392V100"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2b6ac439276aa258(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M112 268l144 144 144-144M256 392V100"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$eb379c06de4962ed(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 268l144 144 144-144M256 392V100"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d27f438c87917eab(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M262.62 336L342 256l-79.38-80m68.35 80H170"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3b358e0617300c99(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-224 80.09L303.58 272H154v-32h149.58L240 175.91l22.71-22.54L364.54 256 262.7 358.63z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$76a8f08e47c329fa(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-212.65 91.36a16 16 0 01-.09-22.63L303.58 272H170a16 16 0 010-32h133.58l-52.32-52.73A16 16 0 11274 164.73l79.39 80a16 16 0 010 22.54l-79.39 80a16 16 0 01-22.65.09z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4bd5e49af01bc137(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M268 112l144 144-144 144m124-144H100"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bd46882ea2ea3016(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M268 112l144 144-144 144m124-144H100"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f77b4ef6c97b2804(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M268 112l144 144-144 144m124-144H100"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$91dd639c66dc62ab(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M266.91 327.74v-37.32c-57.07 0-84.51 13.47-108.58 38.68-5.4 5.65-15 1.32-14.29-6.43 5.45-61.45 34.14-117.09 122.87-117.09v-37.32a8.32 8.32 0 0114-6L365.42 242a8.2 8.2 0 010 11.94L281 333.71a8.32 8.32 0 01-14.09-5.97z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 256c0 106 86 192 192 192s192-86 192-192S362 64 256 64 64 150 64 256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$17f3256f1b63ab2b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm98 88c0-68.13 22.67-137.14 119.17-137.14V152L366 248l-100.83 96v-54.86c-66.69 0-91.32 19.29-119.17 54.86z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$91b8ef729d857e1f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm96 66.67c5.45-61.45 34.14-117.09 122.87-117.09v-37.32a8.32 8.32 0 0114-6L365.42 242a8.2 8.2 0 010 11.94L281 333.71a8.32 8.32 0 01-14-6v-37.29c-57.07 0-84.51 13.47-108.58 38.68-5.49 5.65-15.07 1.32-14.42-6.43z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$136b4b3455435c53(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 256L272 88v96C103.57 184 64 304.77 64 424c48.61-62.24 91.6-96 208-96v96z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8407231ce95a2e19(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 399.26C48 335.19 62.44 284 90.91 247c34.38-44.67 88.68-68.77 161.56-71.75V72L464 252 252.47 432V329.35c-44.25 1.19-77.66 7.58-104.27 19.84-28.75 13.25-49.6 33.05-72.08 58.7L48 440z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6bc8da42d70eb3d0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M58.79 439.13A16 16 0 0148 424c0-73.1 14.68-131.56 43.65-173.77 35-51 90.21-78.46 164.35-81.87V88a16 16 0 0127.05-11.57l176 168a16 16 0 010 23.14l-176 168A16 16 0 01256 424v-79.77c-45 1.36-79 8.65-106.07 22.64-29.25 15.12-50.46 37.71-73.32 67a16 16 0 01-17.82 5.28z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d688e6abb237acb9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.09 327.74v-37.32c57.07 0 84.51 13.47 108.58 38.68 5.4 5.65 15 1.32 14.29-6.43-5.45-61.45-34.14-117.09-122.87-117.09v-37.32a8.32 8.32 0 00-14.05-6L146.58 242a8.2 8.2 0 000 11.94L231 333.71a8.32 8.32 0 0014.09-5.97z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$93e894c5e3517361(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm-9.17 241.14V344L146 248l100.83-96v54.86c96.5 0 119.17 69 119.17 137.14-27.85-35.57-52.48-54.86-119.17-54.86z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3c77998ccffb1fcb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm97.67 281.1c-24.07-25.21-51.51-38.68-108.58-38.68v37.32a8.32 8.32 0 01-14.05 6L146.58 254a8.2 8.2 0 010-11.94L231 162.29a8.32 8.32 0 0114.05 6v37.32c88.73 0 117.42 55.64 122.87 117.09.73 7.72-8.85 12.05-14.25 6.4z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$56751e106518979(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M240 424v-96c116.4 0 159.39 33.76 208 96 0-119.23-39.57-240-208-240V88L64 256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4e282c9bae512b4e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 440l-28.12-32.11c-22.48-25.65-43.33-45.45-72.08-58.7-26.61-12.26-60-18.65-104.27-19.84V432L48 252 259.53 72v103.21c72.88 3 127.18 27.08 161.56 71.75C449.56 284 464 335.19 464 399.26z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4a19f772270fe12d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 440a16 16 0 01-12.61-6.15c-22.86-29.27-44.07-51.86-73.32-67C335 352.88 301 345.59 256 344.23V424a16 16 0 01-27 11.57l-176-168a16 16 0 010-23.14l176-168A16 16 0 01256 88v80.36c74.14 3.41 129.38 30.91 164.35 81.87C449.32 292.44 464 350.9 464 424a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$648fec8308ef7198(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 249.38L256 170l80 79.38m-80-68.35V342"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c6c0bc41ec6ceae7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm80.09 224L272 208.42V358h-32V208.42L175.91 272l-22.54-22.7L256 147.46 358.63 249.3z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7a4f9e2f8b189fd5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm91.36 212.65a16 16 0 01-22.63.09L272 208.42V342a16 16 0 01-32 0V208.42l-52.73 52.32A16 16 0 11164.73 238l80-79.39a16 16 0 0122.54 0l80 79.39a16 16 0 01.09 22.65z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$11cb29f85b6536c8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 244l144-144 144 144M256 120v292"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$56905d925e0c12a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M112 244l144-144 144 144M256 120v292"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b21f882adc211ec6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 244l144-144 144 144M256 120v292"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$54ce56ff4025af22(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448.08 256.08c0-106-86-192-192-192s-192 86-192 192 86 192 192 192 192-85.97 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "28",
                    "d": "M300.81 358.29c-20.83 7.42-34.05 9.59-54.19 9.59-61.17 0-106.39-50.07-101-111.84S205 144.21 266.14 144.21c68.92 0 106.79 45.55 101.47 106.55-4 45.54-32.8 58.66-47.89 56-14.2-2.55-25.92-15.52-23.75-40.35l5.62-44.66c-7.58-9.17-28.11-18-49.93-14.54C231.77 210.3 209 228 206.56 256s14.49 50.84 39.93 50.84 47.86-18.39 50.69-50.84"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e23f5ea2d71d6edb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.41 48.74c-114.85 0-208 93.11-208 208s93.12 208 208 208 208-93.12 208-208-93.16-208-208-208zM381.22 252c-2.85 32.63-16.78 49.7-28 58.26s-24.69 12.34-36.33 10.26a41.63 41.63 0 01-27-17.52 60.84 60.84 0 01-43.72 17.9 51.65 51.65 0 01-38.55-16.83c-11.39-12.42-17-30.36-15.33-49.23 3.05-35 30.92-57.39 56.87-61.48 27.21-4.29 52.24 6.54 62.91 19.46l3.84 4.66-6.34 50.38c-1.19 14.34 3.29 23.48 12.29 25.1 2.39.42 8.11-.13 14.38-4.93 6.72-5.15 15.14-16 17.1-38.47 2.32-26.55-4.35-49.19-19.28-65.49-15.5-16.9-39.1-25.84-68.24-25.84-54 0-101.81 44.43-106.57 99-2.29 26.2 5.66 50.68 22.39 68.93C198 344 221 353.88 246.29 353.88c19 0 30.61-2.05 49.49-8.78l13.22-4.69 9.39 26.37-13.19 4.7c-21.82 7.77-36.68 10.4-58.88 10.4-33.28 0-63.57-13.06-85.3-36.77-22.09-24.11-32.62-56.17-29.65-90.29 2.91-33.33 18.46-64.63 43.77-88.12s57.57-36.49 90.7-36.49c37.2 0 67.94 12.08 88.88 34.93 20.05 21.91 29.48 52.75 26.5 86.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M253.51 221c-14.83 2.33-31.55 15.84-33.34 36.26-1 11.06 2 21.22 8.08 27.87a23.63 23.63 0 0017.91 7.75c19.7 0 33.8-14.79 36.8-38.59l1.75-13.89h.09l1.65-13.11a49.63 49.63 0 00-32.94-6.3z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9644a5c55436b61b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.46 48.74c-114.84 0-208 93.11-208 208s93.12 208 208 208 208-93.12 208-208-93.15-208-208-208zM380.28 252c-2.85 32.63-16.79 49.7-28 58.26S327.61 322.58 316 320.5a41.61 41.61 0 01-26.82-17.19 62.06 62.06 0 01-44 17.57 51.66 51.66 0 01-38.55-16.83c-11.38-12.42-17-30.36-15.32-49.23 3-35 30.91-57.39 56.87-61.48 27.2-4.29 52.23 6.54 62.9 19.46l3.85 4.66-6.34 50.38c-1.19 14.34 3.28 23.48 12.29 25.1 2.39.42 8.1-.13 14.37-4.93 6.72-5.15 15.14-16 17.1-38.47 2.35-26.54-4.35-49.19-19.25-65.49-15.49-16.9-39.09-25.84-68.23-25.84-54 0-101.81 44.43-106.58 99-2.28 26.2 5.67 50.68 22.4 68.93 16.36 17.86 39.31 27.74 64.66 27.74 19 0 30.61-2.05 49.48-8.78a14 14 0 019.4 26.38c-21.82 7.77-36.68 10.4-58.88 10.4-33.28 0-63.57-13.06-85.3-36.77C138 321 127.42 288.94 130.4 254.82c2.91-33.33 18.45-64.63 43.77-88.12s57.57-36.49 90.7-36.49c37.2 0 67.93 12.08 88.87 34.93 20.09 21.91 29.51 52.75 26.54 86.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M252.57 221c-14.83 2.33-31.56 15.84-33.34 36.26-1 11.06 2 21.22 8.07 27.87a23.65 23.65 0 0017.91 7.75c20.31 0 34.73-14.94 36.75-38.06a14 14 0 01.34-2.07l3.2-25.45a49.61 49.61 0 00-32.93-6.3z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$91f3372aa3c4ad7c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 254.27c-4.5 51-40.12 80-80.55 80s-67.34-35.82-63.45-80 37.12-80 77.55-80 70.33 36 66.45 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M319.77 415.77c-28.56 12-47.28 14.5-79.28 14.5-97.2 0-169-78.8-160.49-176s94.31-176 191.51-176C381 78.27 441.19 150 432.73 246c-6.31 71.67-52.11 92.32-76.09 88.07-22.56-4-41.18-24.42-37.74-63.5l8.48-96.25"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e759f42494c04c93(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.6 115.78c-32.07-35-79.47-53.51-137.09-53.51-51 0-100.69 19.8-139.82 55.76s-63.13 83.84-67.63 134.83c-4.55 51.67 11.41 100.29 44.94 136.9 33.37 36.44 80.07 56.51 131.49 56.51 32.52 0 53.61-2.36 85.48-15.75l14.75-6.2-12.4-29.5-14.75 6.18c-27.15 11.4-43.78 13.25-73.08 13.25-42.34 0-80.65-16.38-107.89-46.12-27.4-29.92-40.42-69.86-36.66-112.48 7.84-89 86.6-161.4 175.57-161.4 48.4 0 87.65 14.91 113.49 43.13 24.61 26.87 35.6 63.92 31.79 107.15-3.29 37.35-17.76 55.74-29.32 64.6-11 8.44-22 10.18-28 9.11-17.68-3.13-26.87-20.46-24.59-46.29l9.93-109.12L311.9 160l-2 22.29a79.69 79.69 0 00-57.32-24c-23.8 0-46.54 10.07-64 28.37-16.77 17.53-27.23 41.05-29.45 66.22-2.45 27.87 5.75 54.34 22.51 72.64a76.14 76.14 0 0056.88 24.77A93 93 0 00310 318a60 60 0 0042.88 31.81c16.89 3 36.73-2.69 53.08-15.21 30.19-23.13 39.36-60.19 41.74-87.2 4.52-51.7-9.7-98.4-40.1-131.62zm-126.34 186a62.19 62.19 0 01-42.81 16.53 43.94 43.94 0 01-33.28-14.38c-10.71-11.7-15.9-29.27-14.23-48.22 3.23-36.68 30.29-65.4 61.61-65.4a48.16 48.16 0 0135.88 15.82c10.87 11.87 16.2 28.87 14.63 46.73-1.78 20.28-9.33 37.14-21.8 48.88z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$511c8880ed562cab(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 254.27c-4.5 51-40.12 80-80.55 80s-67.34-35.82-63.45-80 37.12-80 77.55-80 70.33 36 66.45 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M319.77 415.77c-28.56 12-47.28 14.5-79.28 14.5-97.2 0-169-78.8-160.49-176s94.31-176 191.51-176C381 78.27 441.19 150 432.73 246c-6.31 71.67-52.11 92.32-76.09 88.07-22.56-4-41.18-24.42-37.74-63.5l8.48-96.25"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cc29bb38b2ab385d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M216.08 192v143.85a40.08 40.08 0 0080.15 0l.13-188.55a67.94 67.94 0 10-135.87 0v189.82a95.51 95.51 0 10191 0V159.74"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d910ef1b45ed586d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M216.08 192v143.55a40.08 40.08 0 0080.15 0l.13-188.55a67.94 67.94 0 10-135.87 0v189.82a95.51 95.51 0 00191 0V159.44"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9405a29cf00f101f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M216.08 192v143.85a40.08 40.08 0 0080.15 0l.13-188.55a67.94 67.94 0 10-135.87 0v189.82a95.51 95.51 0 10191 0V159.74"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6959b1bb6f900758(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M135.19 390.14a28.79 28.79 0 0021.68 9.86h246.26A29 29 0 00432 371.13V140.87A29 29 0 00403.13 112H156.87a28.84 28.84 0 00-21.67 9.84v0L46.33 256l88.86 134.11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336.67 192.33L206.66 322.34m130.01 0L206.66 192.33m130.01 0L206.66 322.34m130.01 0L206.66 192.33"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1473d6f2a8f32041(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 96L32 256l112 160h304V96zm215.3 226.34L336.67 345l-65-65-65 65L184 322.34l65-65-65-65 22.63-22.63 65 65 65-65 22.63 22.63-65 65z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8eacccd61bf49949(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.13 96H156.87a44.9 44.9 0 00-33.68 15.27 15.88 15.88 0 00-1.91 2.7L32 247.75a16 16 0 000 16.5l89.15 133.57a16.24 16.24 0 002 2.88 44.89 44.89 0 0033.7 15.3h246.28A44.92 44.92 0 00448 371.13V140.87A44.92 44.92 0 00403.13 96zM348 311a16 16 0 11-22.63 22.62L271.67 280 218 333.65A16 16 0 01195.35 311L249 257.33l-53.69-53.69A16 16 0 01218 181l53.69 53.7 53.67-53.7A16 16 0 01348 203.64l-53.7 53.69z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4b449c72a6989a95(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 256v128m64-64H192M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3f7f70ea516fb63(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm156 187h-64v64h-32v-64h-64v-32h64v-64h32v64h64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fb5bea58c445671e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.66 169.4A31.86 31.86 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.78 31.78 0 00-9.34-22.6zM320 336h-48v48a16 16 0 01-32 0v-48h-48a16 16 0 010-32h48v-48a16 16 0 0132 0v48h48a16 16 0 010 32zm16-176H176v-16a80 80 0 01160 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e6b53f9b4173f648(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 264l-89.6 112-38.4-44.88"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$89e1b486369a5321(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm50.81 252.12l-61.37-71.72 24.31-20.81L230 350.91l87.51-109.4 25 20z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a605833f34eb449e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.65 169.4A31.82 31.82 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.75 31.75 0 00-9.35-22.6zM332.49 274l-89.6 112a16 16 0 01-12.23 6h-.26a16 16 0 01-12.16-5.6l-38.4-44.88a16 16 0 1124.32-20.8L230 350.91 307.51 254a16 16 0 0125 20zM336 160H176v-16a80 80 0 01160 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2f1aa96723dfeb3b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 224v16a96 96 0 0096 96h0a96 96 0 0096-96v-16"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$417404ab142721d1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm188 91a112 112 0 01-224 0v-32h32v32a80 80 0 00160 0v-32h32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ca8809ea7e75befb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.65 169.4A31.82 31.82 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.75 31.75 0 00-9.35-22.6zM176 144a80 80 0 01160 0v16H176zm192 96a112 112 0 01-224 0v-16a16 16 0 0132 0v16a80 80 0 00160 0v-16a16 16 0 0132 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3b42b9f6e157c633(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$91765fb7dc7afd00(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 320H192M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4d9e97b229ee5bb1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm156 187H176v-32h160z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9d205e2d29c641c7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.66 169.4A31.86 31.86 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.78 31.78 0 00-9.34-22.6zM320 336H192a16 16 0 010-32h128a16 16 0 010 32zm16-176H176v-16a80 80 0 01160 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$df3b31134f1f52c3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 160v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-40 0H180v-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$80555a661250e8f1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.65 169.4A31.82 31.82 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.75 31.75 0 00-9.35-22.6zM176 144a80 80 0 01160 0v16H176z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$45f0a71d3cc9c7c9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M414.11 153.82C429.66 264.4 345.85 357.09 282.54 366s-169.48-57.5-185-167.68a159.82 159.82 0 11316.53-44.49z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M236.06 308.05c-32.83-13-67.08-43.1-82.27-85.46M367.7 495.78c-32.83-13-63.31-40.06-78.5-82.41"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M266.71 368.21l-9.17 49.61 63.31-8.9-22.49-45.16-31.65 4.45z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$aa64ec080fc8fa8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391 307.27c32.75-46.35 46.59-101.63 39-155.68C416.47 55.59 327.38-11.54 231.38 2S68.24 104.53 81.73 200.53c7.57 53.89 36.12 103.16 80.37 138.74 26.91 21.64 57.59 36.1 86.05 41.33l-8.36 45.23a8 8 0 009 9.38L279 431c15.9 35.87 41.65 60.48 78.41 75l14.88 5.88 11.77-29.75-14.88-5.89c-26.35-10.42-44.48-26.16-57-49.92l21.84-3.07a8 8 0 006.05-11.49l-20.49-41.16c25.98-12.87 51.49-35.18 71.42-63.33zm-160.82 15.66c-41.26-16.32-76.3-52.7-91.45-94.94l-5.4-15.06 30.12-10.8 5.4 15.06c14.5 40.44 47.27 65.77 73.1 76l14.88 5.88-11.77 29.76z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$24a8c716f555abfd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391 307.27c32.75-46.35 46.59-101.63 39-155.68A175.82 175.82 0 00231.38 2c-96 13.49-163.14 102.58-149.65 198.58 7.57 53.89 36.12 103.16 80.37 138.74 24.58 19.68 52.31 33.5 78.62 39.68a8 8 0 016 9.22l-4.87 26.38a16.29 16.29 0 001.48 10.57 16 16 0 0014.2 8.61 15.21 15.21 0 002.23-.16l17.81-2.5a2 2 0 012.09 1.14c16.72 36.31 45.46 63.85 82.15 78.36a16 16 0 0021-9.65c2.83-8.18-1.64-17.07-9.68-20.28a118.57 118.57 0 01-59.3-51.88 2 2 0 011.45-3l7.4-1a16.54 16.54 0 0010.08-5.23 16 16 0 002.39-17.8l-12.06-24.23a8 8 0 013.26-10.55c23.59-13.17 46.45-34 64.65-59.73zm-154.9 16.78a16 16 0 01-5.88-1.12c-41.26-16.32-76.3-52.7-91.45-94.94a16 16 0 1130.12-10.8c14.5 40.44 47.27 65.77 73.1 76a16 16 0 01-5.89 30.88z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ebb622521291f3cd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M108.92 108.92l294.16 294.16"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7f9d378671ec6364(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM432 256a175.09 175.09 0 01-35.8 106.26L149.74 115.8A175.09 175.09 0 01256 80c97.05 0 176 79 176 176zm-352 0a175.09 175.09 0 0135.8-106.26L362.26 396.2A175.09 175.09 0 01256 432c-97 0-176-78.95-176-176z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$86cafe12ccbc5d11(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "200",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M114.58 114.58l282.84 282.84"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1ab5c6ec13c34dd1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "560.87",
                    "height": "176.25",
                    "x": "-24.43",
                    "y": "167.88",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "88.12",
                    "ry": "88.12",
                    "transform": "rotate(-45 256 256.002)"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "196",
                    "x": "169.41",
                    "y": "156.59",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32",
                    "transform": "rotate(45 257.409 254.582)"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "208",
                    "r": "16"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "304",
                    "cy": "256",
                    "r": "16"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "208",
                    "cy": "256",
                    "r": "16"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "304",
                    "r": "16"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a0920a0db2f249a4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M27.71 337.1a40 40 0 000 56.54l90.65 90.65a40 40 0 0056.54 0l75.1-75.1L102.81 262zM496 147.1a39.87 39.87 0 00-11.75-28.38l-91-91a40.14 40.14 0 00-56.75 0L264 100.28 411.72 248l72.53-72.53A39.85 39.85 0 00496 147.1zM273.06 386.19l116-116L241.77 123l-116 116zm19.63-141.5a16 16 0 110 22.62 16 16 0 010-22.62zm-48-48a16 16 0 110 22.62 16 16 0 010-22.62zm0 96a16 16 0 110 22.62 16 16 0 010-22.62zm-25.38-48a16 16 0 11-22.62 0 16 16 0 0122.62 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$46d4bea465f007b1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M275.8 157a16 16 0 00-22.63 0l-93.34 93.34a16 16 0 000 22.63l79.2 79.2a16 16 0 0022.63 0L355 258.83a16 16 0 000-22.63zM137.21 295.6a47.81 47.81 0 01-9.43-13.38L69 341a72.2 72.2 0 000 102 72.37 72.37 0 00102 0l58.77-58.76a47.81 47.81 0 01-13.38-9.43zM392 48a71.55 71.55 0 00-51 21l-55.92 55.91a48.05 48.05 0 0113.36 9.45l79.19 79.19a48.05 48.05 0 019.45 13.36L443 171a72 72 0 00-51-123z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M275.8 157a16 16 0 00-22.63 0l-93.34 93.34a16 16 0 000 22.63l79.2 79.2a16 16 0 0022.63 0L355 258.83a16 16 0 000-22.63zm-56.49 110.31a16 16 0 110-22.62 16 16 0 010 22.62zm48 48a16 16 0 110-22.62 16 16 0 010 22.62zm0-96a16 16 0 110-22.62 16 16 0 010 22.62zm48 48a16 16 0 110-22.62 16 16 0 010 22.62zm150.3-220.92a104.38 104.38 0 00-147.25 0l-69.76 69.89a4 4 0 004.2 6.58 35.74 35.74 0 0111.69-2.54 47.7 47.7 0 0133.94 14.06l79.19 79.19a47.7 47.7 0 0114.06 33.94 35.68 35.68 0 01-2.54 11.69 4 4 0 006.58 4.2l69.89-69.76a104.38 104.38 0 000-147.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M254.34 386.83a47.91 47.91 0 01-33.94-14l-79.19-79.23a47.81 47.81 0 01-9.43-13.38c-4.59-9.7-1.39-25 2.48-36.9a4 4 0 00-6.64-4l-77.23 77.04a104.12 104.12 0 00147.25 147.25l72.75-72.88a4 4 0 00-4.21-6.58c-4.18 1.58-8.4 2.68-11.84 2.68z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$55530002ed106891(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M32 32v432a16 16 0 0016 16h432"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "192",
                    "x": "96",
                    "y": "224",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "20",
                    "ry": "20"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "240",
                    "x": "240",
                    "y": "176",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "20",
                    "ry": "20"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "304",
                    "x": "383.64",
                    "y": "112",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "20",
                    "ry": "20"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d81f84a7cebd36b0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 496H16V16h32v448h448v32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M192 432H80V208h112zm144 0H224V160h112zm143.64 0h-112V96h112z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$46e7e02709a7ce32(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 496H48a32 32 0 01-32-32V32a16 16 0 0132 0v432h432a16 16 0 010 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M156 432h-40a36 36 0 01-36-36V244a36 36 0 0136-36h40a36 36 0 0136 36v152a36 36 0 01-36 36zm144 0h-40a36 36 0 01-36-36V196a36 36 0 0136-36h40a36 36 0 0136 36v200a36 36 0 01-36 36zm143.64 0h-40a36 36 0 01-36-36V132a36 36 0 0136-36h40a36 36 0 0136 36v264a36 36 0 01-36 36z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$db3cdce3484ebca7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 256h416"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "32",
                    "height": "256",
                    "x": "384",
                    "y": "128",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "32",
                    "height": "256",
                    "x": "96",
                    "y": "128",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "128",
                    "x": "32",
                    "y": "192",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "128",
                    "x": "464",
                    "y": "192",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a786e68ea11a5b5d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 176h-58v-64h-76v122H150V112H74v64H16v160h58v64h76V278h212v122h76v-64h58V176z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d77b40fb68fd6782(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M467 176a29.94 29.94 0 00-25.32 12.5 2 2 0 01-3.64-1.14v-36.65c0-20.75-16.34-38.21-37.08-38.7A38 38 0 00362 150v82a2 2 0 01-2 2H152a2 2 0 01-2-2v-81.29c0-20.75-16.34-38.21-37.08-38.7A38 38 0 0074 150v37.38a2 2 0 01-3.64 1.14A29.94 29.94 0 0045 176c-16.3.51-29 14.31-29 30.62v98.72c0 16.31 12.74 30.11 29 30.62a29.94 29.94 0 0025.32-12.5 2 2 0 013.68 1.16v36.67C74 382 90.34 399.5 111.08 400A38 38 0 00150 362v-82a2 2 0 012-2h208a2 2 0 012 2v81.29c0 20.75 16.34 38.21 37.08 38.7A38 38 0 00438 362v-37.38a2 2 0 013.64-1.14A29.94 29.94 0 00467 336c16.3-.51 29-14.31 29-30.62v-98.74c0-16.31-12.74-30.11-29-30.64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2219cf51379c615a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 400.33l35.13-.33A29 29 0 00448 371.13V140.87A29 29 0 00419.13 112l-35.13.33M128 112l-36.8.33c-15.88 0-27.2 13-27.2 28.87v230.27c0 15.87 11.32 28.86 27.2 28.86L128 400m256-208v128m-64-160v192m-64-176v160m-64-176v192m-64-160v128"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4c149dcf9c49d456(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 400.33l48-.33V112l-48 .33M112 112l-48 .33v288l48-.33m272-208v128m-64-160v192m-64-176v160m-64-176v192m-64-160v128"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$44f42607ce1c29f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M419.13 96H419l-35.05.33L128 96h-.16l-36.74.33C66.93 96.38 48 116.07 48 141.2v230.27c0 25.15 19 44.86 43.2 44.86h.15l36.71-.33 255.92.33h.17l35.07-.33A44.91 44.91 0 00464 371.13V140.87A44.92 44.92 0 00419.13 96zM144 320a16 16 0 01-32 0V192a16 16 0 0132 0zm64 32a16 16 0 01-32 0V160a16 16 0 0132 0zm64-16a16 16 0 01-32 0V176a16 16 0 0132 0zm64 16a16 16 0 01-32 0V160a16 16 0 0132 0zm64-32a16 16 0 01-32 0V192a16 16 0 0132 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a77e1dc42a6596a9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M294.25 108.6l-60.57 17.59m83.45 29.92l-51.5 36.4m90.26 2.36l-36.4 51.5m83.91-28.62l-17.59 60.57"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "192",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432.94 255.05a192 192 0 01-176.31-180.7M108.54 294.31l17.59-60.57m29.92 83.45l36.4-51.5m2.36 90.26l51.5-36.4m-28.62 83.91l60.57-17.59M255 433.61A192 192 0 0074.29 256.69"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ed5caa7c84c56f08(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.16 56.2a13.88 13.88 0 01-3.42 8.91l-.11 5.13-27.71-.57c0 1.3.09 2.61.16 3.91a177.33 177.33 0 003.45 26.31l24.72-7.18 7.81 26.88-24.71 7.18a177.21 177.21 0 0013.34 27.69l21.27-15 16.16 22.86-21.29 15.05q5.25 6.33 11.11 12.19c3.91 3.91 8 7.6 12.2 11.1l15.71-22.22 22.86 16.16L358 216.75a178.78 178.78 0 0027.68 13.32l7.49-25.8 26.89 7.81-7.5 25.83a177.8 177.8 0 0031 3.67l-.41-24.67 17.41-.29A208 208 0 00301.82 52.93a13.65 13.65 0 01.34 3.27zM214 441.64l27.91.49a177.46 177.46 0 00-3.62-29.95l-24.14 7-7.81-26.88 24.11-7a177.92 177.92 0 00-13.33-27.68L196.79 372l-16.16-22.86L201 334.73c-3.49-4.22-7.19-8.3-11.09-12.2s-8-7.62-12.19-11.12l-13.91 19.68L141 314.93l13.9-19.66a177.26 177.26 0 00-27.7-13.33l-6.37 21.94-26.89-7.81 6.38-22a177.32 177.32 0 00-26.32-3.4c-1.59-.09-3.18-.16-4.78-.2l.4 22.34-17.71.32a207.88 207.88 0 00161.81 166.48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M444.65 302.67l-.55-33.06a206 206 0 01-39.33-4.74L397 291.8l-26.94-7.8 7.83-27a206.91 206.91 0 01-36.06-17.35l-16.36 23.15-22.86-16.16 16.33-23.11a204.21 204.21 0 01-30-30l-22.19 15.67-16.16-22.87 22.17-15.67a206 206 0 01-17.38-36.06l-25.75 7.48-7.81-26.89 25.73-7.47q-2-9.21-3.18-18.64h-.47l-.78-14-.33-6-17.94-.32a13.38 13.38 0 01-1.79-.16l-6.35-.13.06-2.47a14 14 0 01-5.66-11.49 13.27 13.27 0 01.13-1.67A208 208 0 0052.16 217.43l16.1-.28.45 25.18 6.83.38 14 .77v.48q9.42 1.17 18.64 3.18l6.68-23L141.7 232l-6.7 23a205.3 205.3 0 0136.06 17.38l14.53-20.56L208.47 268 194 288.5a203.5 203.5 0 0130 30l21.3-15 16.16 22.86-21.36 15.05a206.86 206.86 0 0117.34 36.06l25.27-7.33 7.81 26.86-25.24 7.33a205.9 205.9 0 014.72 38.3l29.42.53-.29 16.48a207.94 207.94 0 00160-157.21z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$17d7b9f01653cb8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444 295.67l-.47-26.07a205.42 205.42 0 01-39.27-4.73l-5 17.35a14 14 0 11-26.88-7.81l5-17.38a206.47 206.47 0 01-36.05-17.35l-10.44 14.77a14 14 0 01-22.87-16.16l10.41-14.73a204.8 204.8 0 01-30-30L273.71 204a14 14 0 01-16.16-22.87l14.74-10.42a205.3 205.3 0 01-17.38-36.06l-17.32 5a14 14 0 11-7.81-26.89l17.3-5a205.88 205.88 0 01-4.43-32.59q-.17-3-.24-6l-18.22-.33a14 14 0 01-13.74-14A208 208 0 0055 202.42a16 16 0 0115 15.66l.44 24.43c1.58.05 3.16.11 4.73.2a205.88 205.88 0 0132.59 4.43l5-17.3a14 14 0 0126.89 7.81l-5 17.32a205.21 205.21 0 0136 17.38L181 257.61a14 14 0 0122.87 16.16l-10.39 14.73a205.65 205.65 0 0115.79 14.23 203.79 203.79 0 0114.23 15.79l14.73-10.41A14 14 0 01254.39 331l-14.76 10.43A206.86 206.86 0 01257 377.47l17.38-5.05a14 14 0 017.81 26.89l-17.35 5a205.89 205.89 0 014.7 38.28l18.27.33a16 16 0 0115.71 16.28 11.69 11.69 0 01-.08 1.19 208 208 0 00153.39-151.03A14 14 0 01444 295.67z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M301.49 56.2A14 14 0 01287.5 70h-.25l-16.81-.3c.05 1.31.1 2.62.17 3.93a178.83 178.83 0 003.44 26.31l16.29-4.74a14 14 0 017.81 26.8l-16.27 4.73a178.06 178.06 0 0013.33 27.69l13.84-9.78a14 14 0 1116.16 22.87l-13.86 9.79q5.25 6.33 11.12 12.19c3.9 3.91 8 7.6 12.2 11.1l9.78-13.84A14 14 0 11367.32 203l-9.76 13.8a178.83 178.83 0 0027.68 13.33l4.76-16.28a14 14 0 0126.89 7.81l-4.73 16.26a177.72 177.72 0 0030.95 3.65l-.16-9a14 14 0 0113.75-14.24h.25a14.67 14.67 0 012.59.25 208 208 0 00-158-163.51c-.06.4-.04.76-.05 1.13zm-93.05 401.35a16 16 0 0116.28-15.71l16.76.29a178.49 178.49 0 00-3.62-29.95l-16.26 4.72a14 14 0 11-7.81-26.9l16.21-4.7a177.92 177.92 0 00-13.33-27.68l-13.8 9.76a14 14 0 11-16.16-22.87l13.84-9.78c-3.5-4.22-7.19-8.3-11.1-12.2s-8-7.62-12.19-11.12l-9.79 13.86a14 14 0 11-22.87-16.16l9.78-13.84a177.16 177.16 0 00-27.69-13.33L122 298.21a14 14 0 11-26.9-7.81l4.73-16.29a177.32 177.32 0 00-26.31-3.44c-.89-.05-1.79-.08-2.68-.12l.16 10.59a16 16 0 01-15.71 16.28H55a16 16 0 01-3.94-.51 208 208 0 00157.65 163.87 15.72 15.72 0 01-.27-3.23z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$58131472bfca4dd8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M68.4 192A20.38 20.38 0 0048 212.2a17.87 17.87 0 00.8 5.5L100.5 400a40.46 40.46 0 0039.1 29.5h232.8a40.88 40.88 0 0039.3-29.5l51.7-182.3.6-5.5a20.38 20.38 0 00-20.4-20.2H68.4zm193.32 160.07A42.07 42.07 0 11304 310a42.27 42.27 0 01-42.28 42.07z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 192l96-128 96 128"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$824bc4e2af2bced0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M339.2 217.6L256 106.67 172.8 217.6l-25.6-19.2 96-128a16 16 0 0125.6 0l96 128z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M441.59 192H70.41a12 12 0 00-11.68 14.77L112.59 434h286.82l53.86-227.23A12 12 0 00441.59 192zM256 351.66A37.71 37.71 0 11293.89 314 37.88 37.88 0 01256 351.66z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c4a0251af23e8f46(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.11 192H360L268.8 70.4a16 16 0 00-25.6 0L152 192H87.89a32.57 32.57 0 00-32.62 32.44 30.3 30.3 0 001.31 9l46.27 163.14a50.72 50.72 0 0048.84 36.91h208.62a51.21 51.21 0 0049-36.86l46.33-163.36a15.62 15.62 0 00.46-2.36l.53-4.93a13.3 13.3 0 00.09-1.55A32.57 32.57 0 00424.11 192zM256 106.67L320 192H192zm0 245a37.7 37.7 0 1137.88-37.7A37.87 37.87 0 01256 351.63z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$159fa0d9a327ffcf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "192",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432.94 255.05a192 192 0 01-176.31-180.7M255 433.61A192 192 0 0074.29 256.69m45.95-136.45l271.52 271.52m-271.52 0l271.52-271.52"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4d6c28854073f2e7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 233.37l34.45-34.45a207.08 207.08 0 01-50.12-135.25c0-5 .19-10.05.54-15A207.09 207.09 0 00120.67 98zm57.14-57.14L391.33 98A207.07 207.07 0 00273 48.8c-.41 4.9-.64 9.86-.64 14.87a175.25 175.25 0 0040.78 112.56zm22.63 22.63a175.25 175.25 0 00112.56 40.81c5 0 10-.23 14.87-.64A207.07 207.07 0 00414 120.67zM176.23 313.14a175.23 175.23 0 00-112.56-40.81q-7.52 0-14.87.64A207.07 207.07 0 0098 391.33zM256 278.63l-34.45 34.45a207.08 207.08 0 0150.12 135.25c0 5-.19 10.05-.54 15A207.06 207.06 0 00391.33 414zm192.33-6.96a207.08 207.08 0 01-135.25-50.12L278.63 256 414 391.33a207.09 207.09 0 0049.39-120.2c-5.01.35-10.02.54-15.06.54zM233.37 256L98 120.67a207.06 207.06 0 00-49.39 120.2c5-.35 10-.54 15-.54a207.08 207.08 0 01135.25 50.12zm-112.7 158A207.07 207.07 0 00239 463.2q.63-7.35.64-14.87a175.23 175.23 0 00-40.81-112.56z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8bccc36911a23cba(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 233.37l34.45-34.45a207.08 207.08 0 01-50.12-135.25c0-5 .19-10.05.54-15A207.09 207.09 0 00120.67 98zm57.14-57.14L391.33 98A207.07 207.07 0 00273 48.8c-.41 4.9-.64 9.86-.64 14.87a175.25 175.25 0 0040.78 112.56zm22.63 22.63a175.25 175.25 0 00112.56 40.81c5 0 10-.23 14.87-.64A207.07 207.07 0 00414 120.67zM176.23 313.14a175.23 175.23 0 00-112.56-40.81q-7.52 0-14.87.64A207.07 207.07 0 0098 391.33zM256 278.63l-34.45 34.45a207.08 207.08 0 0150.12 135.25c0 5-.19 10.05-.54 15A207.06 207.06 0 00391.33 414zm192.33-6.96a207.08 207.08 0 01-135.25-50.12L278.63 256 414 391.33a207.09 207.09 0 0049.39-120.2c-5.01.35-10.02.54-15.06.54zM233.37 256L98 120.67a207.06 207.06 0 00-49.39 120.2c5-.35 10-.54 15-.54a207.08 207.08 0 01135.25 50.12zm-112.7 158A207.07 207.07 0 00239 463.2q.63-7.35.64-14.87a175.23 175.23 0 00-40.81-112.56z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b012a24547c163e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 322.3V189.7A29.74 29.74 0 0177.7 160h137.44l24.4-32H77.7A61.77 61.77 0 0016 189.7v132.6A61.77 61.77 0 0077.7 384h96.85a22.57 22.57 0 01.26-7.32l.15-.75.21-.73 6.5-23.2H77.7A29.74 29.74 0 0148 322.3zM386.3 128h-98.64a22.69 22.69 0 01-.27 7.2l-.15.74-.21.73-6.54 23.33H386.3a29.74 29.74 0 0129.7 29.7v132.6a29.74 29.74 0 01-29.7 29.7H247l-24.42 32H386.3a61.77 61.77 0 0061.7-61.7V189.7a61.77 61.77 0 00-61.7-61.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M162.65 294.16a24.37 24.37 0 01-21.56-13 25 25 0 011.42-25.83l.31-.46.33-.44L197.62 183H89.69a20 20 0 00-20 20v106a20 20 0 0020 20h98.42l9.78-34.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M276.07 280.89l27.07-35.49a5.2 5.2 0 00.77-1.91 5 5 0 00.08-.66 5 5 0 00-.08-1.29 5.11 5.11 0 00-.68-1.75 4.76 4.76 0 00-.78-.95 3.48 3.48 0 00-.48-.38 4 4 0 00-1.11-.55 4.28 4.28 0 00-1.31-.2h-61.62l12.12-43.21 3.23-11.5 6.21-22.16.51-1.84 7.79-27.76a3.51 3.51 0 00.05-.55v-.16c0-.05 0-.26-.05-.38s0-.09 0-.14a2.2 2.2 0 00-.17-.45 3.77 3.77 0 00-.26-.39l-.09-.1a2.73 2.73 0 00-.25-.23l-.1-.08a3.14 3.14 0 00-.39-.24 2 2 0 00-.41-.14h-.59a2.3 2.3 0 00-.45 0 1.9 1.9 0 00-.42.15l-.13.07-.3.21-.11.1a2.4 2.4 0 00-.36.41l-18 23.63-13.14 17.22-9.85 12.83-63.71 83.55a5.72 5.72 0 00-.44.8 4.78 4.78 0 00-.35 1.09 4.7 4.7 0 00-.08 1.29 4.86 4.86 0 002 3.71 4.74 4.74 0 00.54.31 4.31 4.31 0 001.89.43h61.62L194.42 380.6a3.64 3.64 0 000 .56v.15a2.32 2.32 0 00.06.38.58.58 0 000 .14 2.2 2.2 0 00.17.45 3.62 3.62 0 00.26.38l.09.1.25.24a.39.39 0 01.1.08 2.22 2.22 0 00.39.23 2.83 2.83 0 00.41.14h.13a1.86 1.86 0 00.33 0h.13a2.32 2.32 0 00.45-.06 2.05 2.05 0 00.41-.16l.13-.07.3-.21.11-.09a2.4 2.4 0 00.36-.41L221.82 352l17.53-23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M319.5 256.93l-.46.6L264.51 329h109.8a20 20 0 0020-20V203a20 20 0 00-20-20H274.05l-9.74 34.73h35.24A24.35 24.35 0 01321 230.5a25.21 25.21 0 01-1 25.79zM480 202.67a16 16 0 00-16 16v74.66a16 16 0 0032 0v-74.66a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b27de8eb52ff52a7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M306.68 237.62h-66.5l15.33-54.7 6.43-22.92 3.94-14 4.29-15.33a3.56 3.56 0 00.06-.44v-.19a1.85 1.85 0 000-.23 2 2 0 000-.24v-.14c0-.1-.07-.19-.11-.29v-.05a2.33 2.33 0 00-2-1.35h-.1a2.25 2.25 0 00-1.8 1l-12.5 17.15-18.82 25.55-8.36 11.48-35.41 48.6L160 274.26h66.44l-30 107a3.93 3.93 0 00-.06.48v.1a1.94 1.94 0 000 .34.29.29 0 000 .09 3 3 0 00.07.32v.06a1.83 1.83 0 00.14.32 2.38 2.38 0 001.52 1.16h.57a2.1 2.1 0 001.31-.5l.06-.05a2.6 2.6 0 00.42-.45L223.3 352l13-17.82z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M289.78 134.55l-.14.74-.21.73-6.72 24H417V352H248.05l-23.33 32H449V128H290.13a22.62 22.62 0 01-.35 6.55zM49 160h169.49l23.31-32H17v256h159.49a22.73 22.73 0 01.34-6.67l.15-.75.2-.73 6.69-23.85H49z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M264.76 329.08h130.55V182.92H276.28l-9.73 34.7H346l-23.16 31.78-58.08 79.68zM160 294.26h-39.31l23.15-31.78 57.95-79.56H70.69v146.16h119.6l9.77-34.82H160zm305-91.59h32v106.67h-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$391a5d7cc11722e4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 322.3V189.7A29.74 29.74 0 0177.7 160h137.44l24.4-32H77.7A61.77 61.77 0 0016 189.7v132.6A61.77 61.77 0 0077.7 384h96.85a22.57 22.57 0 01.26-7.32l.15-.75.21-.73 6.5-23.2H77.7A29.74 29.74 0 0148 322.3zM386.3 128h-98.64a22.69 22.69 0 01-.27 7.2l-.15.74-.21.73-6.54 23.33H386.3a29.74 29.74 0 0129.7 29.7v132.6a29.74 29.74 0 01-29.7 29.7H247l-24.42 32H386.3a61.77 61.77 0 0061.7-61.7V189.7a61.77 61.77 0 00-61.7-61.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M162.65 294.16a24.37 24.37 0 01-21.56-13 25 25 0 011.42-25.83l.31-.46.33-.44L197.62 183H89.69a20 20 0 00-20 20v106a20 20 0 0020 20h98.42l9.78-34.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M276.07 280.89l27.07-35.49a5.2 5.2 0 00.77-1.91 5 5 0 00.08-.66 5 5 0 00-.08-1.29 5.11 5.11 0 00-.68-1.75 4.76 4.76 0 00-.78-.95 3.48 3.48 0 00-.48-.38 4 4 0 00-1.11-.55 4.28 4.28 0 00-1.31-.2h-61.62l12.12-43.21 3.23-11.5 6.21-22.16.51-1.84 7.79-27.76a3.51 3.51 0 00.05-.55v-.16c0-.05 0-.26-.05-.38s0-.09 0-.14a2.2 2.2 0 00-.17-.45 3.77 3.77 0 00-.26-.39l-.09-.1a2.73 2.73 0 00-.25-.23l-.1-.08a3.14 3.14 0 00-.39-.24 2 2 0 00-.41-.14h-.59a2.3 2.3 0 00-.45 0 1.9 1.9 0 00-.42.15l-.13.07-.3.21-.11.1a2.4 2.4 0 00-.36.41l-18 23.63-13.14 17.22-9.85 12.83-63.71 83.55a5.72 5.72 0 00-.44.8 4.78 4.78 0 00-.35 1.09 4.7 4.7 0 00-.08 1.29 4.86 4.86 0 002 3.71 4.74 4.74 0 00.54.31 4.31 4.31 0 001.89.43h61.62L194.42 380.6a3.64 3.64 0 000 .56v.15a2.32 2.32 0 00.06.38.58.58 0 000 .14 2.2 2.2 0 00.17.45 3.62 3.62 0 00.26.38l.09.1.25.24a.39.39 0 01.1.08 2.22 2.22 0 00.39.23 2.83 2.83 0 00.41.14h.13a1.86 1.86 0 00.33 0h.13a2.32 2.32 0 00.45-.06 2.05 2.05 0 00.41-.16l.13-.07.3-.21.11-.09a2.4 2.4 0 00.36-.41L221.82 352l17.53-23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M319.5 256.93l-.46.6L264.51 329h109.8a20 20 0 0020-20V203a20 20 0 00-20-20H274.05l-9.74 34.73h35.24A24.35 24.35 0 01321 230.5a25.21 25.21 0 01-1 25.79zM480 202.67a16 16 0 00-16 16v74.66a16 16 0 0032 0v-74.66a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3a7c793eed7852cb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "400",
                    "height": "224",
                    "x": "31",
                    "y": "144",
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "45.7",
                    "ry": "45.7"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M479 218.67v74.66"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$18a450e4a52a18ee(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M32 144h400v224H32zm448 74.67v74.66"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$74b1371065c91551(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "400",
                    "height": "224",
                    "x": "31",
                    "y": "144",
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "45.7",
                    "ry": "45.7"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M479 218.67v74.66"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9c6d5e0d9029d496(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "400",
                    "height": "224",
                    "x": "32",
                    "y": "144",
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "45.7",
                    "ry": "45.7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "292.63",
                    "height": "114.14",
                    "x": "85.69",
                    "y": "198.93",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "4",
                    "ry": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M480 218.67v74.66"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7c8c3a7a129d94bf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 384h432V128H17zm32-224h368v192H49z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M70.69 182.94h324.63v146.13H70.69zM465 202.67h32v106.67h-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2c39dd27227fea56(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "400",
                    "height": "224",
                    "x": "32",
                    "y": "144",
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "45.7",
                    "ry": "45.7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "292.63",
                    "height": "114.14",
                    "x": "85.69",
                    "y": "198.93",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "4",
                    "ry": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M480 218.67v74.66"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5623168dad9e2e9f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "400",
                    "height": "224",
                    "x": "32",
                    "y": "144",
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "45.7",
                    "ry": "45.7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "154.31",
                    "height": "114.13",
                    "x": "85.69",
                    "y": "198.93",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "4",
                    "ry": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M480 218.67v74.66"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$512695e1cc9591bd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 384h432V128H17zm32-224h368v192H49z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M70.69 182.92H256v146.16H70.69zM465 202.67h32v106.67h-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$70df793738705273(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "400",
                    "height": "224",
                    "x": "32",
                    "y": "144",
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "45.7",
                    "ry": "45.7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "154.31",
                    "height": "114.13",
                    "x": "85.69",
                    "y": "198.93",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "4",
                    "ry": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M480 218.67v74.66"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$278c76f3f2422641(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M445.2 48.05L398 48H128c-54.3 0-64 35.7-64 48 30.3 4.2 48 8 48 40v264a64 64 0 0064 64h192a64 64 0 0064-64V96c0-19 11.5-38.35 12.6-40 1.2-1.9 3.4-4.4 3.4-5.5s-.3-2.45-2.8-2.45zM112 176h320"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2a0befc59613eb62(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M453.55 54.7L464 32H128.4c-27.74 0-49 6.57-63.31 19.51C54.39 61.27 48 74.89 48 88v24h16c31 0 32 16.79 32 35v313a20 20 0 0020 20h312a20 20 0 0020-20V96c0-17.16 2.28-34.14 5.55-41.3zM416 96v64H128v-22c0-36.15-21-51-41.77-53.46C89 70 105.7 64.05 128.4 64.05h289.92A221.83 221.83 0 00416 96z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$87927fc0a03a4304(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444 32H128c-19.38 0-45.9 4.34-64.11 24.77C52.17 69.92 48 85.66 48 96a16 16 0 0013.8 15.85C91.7 116 96 117.79 96 136v264a80.07 80.07 0 0080 80h192a80.11 80.11 0 0080-80V96c0-12.55 7.46-27.25 10-31.36l.1-.14c.22-.35.5-.72.78-1.1 2-2.79 5.09-7 5.09-12.95C464 39.79 454.89 32 444 32zM84.11 83.08c5.24-8.87 17.17-19 44.29-19h294.43C419.3 72.87 416 84.27 416 96v64H128v-24c0-37.32-21.35-48.14-43.89-52.92z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5c2797e3d07fdb37(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 240H96V136a40.12 40.12 0 0140-40h240a40.12 40.12 0 0140 40v104zM48 416V304a64.19 64.19 0 0164-64h288a64.19 64.19 0 0164 64v112"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 416v-8a24.07 24.07 0 0124-24h368a24.07 24.07 0 0124 24v8M112 240v-16a32.09 32.09 0 0132-32h80a32.09 32.09 0 0132 32v16m0 0v-16a32.09 32.09 0 0132-32h80a32.09 32.09 0 0132 32v16"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c316f9bd73e71917(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 224V96a16 16 0 00-16-16H96a16 16 0 00-16 16v128a48 48 0 00-48 48v160h36v-32h376v32h36V272a48 48 0 00-48-48zm-192 0H120v-32a16 16 0 0116-16h88a16 16 0 0116 16zm32-32a16 16 0 0116-16h88a16 16 0 0116 16v32H272z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7803aad93e6ea21b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 230.7a79.44 79.44 0 00-32-6.7H112a79.51 79.51 0 00-32 6.69A80.09 80.09 0 0032 304v112a16 16 0 0032 0v-8a8.1 8.1 0 018-8h368a8.1 8.1 0 018 8v8a16 16 0 0032 0V304a80.09 80.09 0 00-48-73.3zM376 80H136a56 56 0 00-56 56v72a4 4 0 005.11 3.84A95.5 95.5 0 01112 208h4.23a4 4 0 004-3.55A32 32 0 01152 176h56a32 32 0 0131.8 28.45 4 4 0 004 3.55h24.46a4 4 0 004-3.55A32 32 0 01304 176h56a32 32 0 0131.8 28.45 4 4 0 004 3.55h4.2a95.51 95.51 0 0126.89 3.85A4 4 0 00432 208v-72a56 56 0 00-56-56z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$89f6fb811c3edaa8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 200v240a40.12 40.12 0 01-40 40H136a40.12 40.12 0 01-40-40V224"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M352 224h40a56.16 56.16 0 0156 56v80a56.16 56.16 0 01-56 56h-40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M224 256v160m64-160v160M160 256v160m160-304a48 48 0 010 96c-13.25 0-29.31-7.31-38-16H160c-8 22-27 32-48 32a48 48 0 010-96 47.91 47.91 0 0126 9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M91.86 132.43a40 40 0 1160.46-52S160 91 160 96m-14.17-31.29C163.22 44.89 187.57 32 216 32c52.38 0 94 42.84 94 95.21a95 95 0 01-1.67 17.79"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$85478242480b329c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 208h-80v-5.74A63.93 63.93 0 00321.65 96a111 111 0 00-27.59-47.29A108.62 108.62 0 00216 16c-29.91 0-57.78 12.28-79 34.67a56 56 0 00-67.51 77.51c-1 .86-1.91 1.74-2.83 2.66A63.56 63.56 0 0048 176.26a62.65 62.65 0 0020.77 46.54A65 65 0 0080 231v249a16 16 0 0016 16h256a16 16 0 0016-16v-48h80a16 16 0 0016-16V224a16 16 0 00-16-16zM176 432h-32V240h32zm64 0h-32V240h32zm64 0h-32V240h32zm16-240c-8.33 0-20.55-5.18-26.69-11.31l-4.68-4.69H148.79L145 186.53c-5.81 16-18.83 20.41-28.73 21.29a34.08 34.08 0 01-25.91-8.67 31 31 0 01-10.32-23 31.8 31.8 0 019.33-22.71c.16-.17.33-.32.5-.49A31.78 31.78 0 01112 144c.09 0 9.12.34 16.4 5.8l12.8 9.6 19.2-25.6-12.8-9.6A63.69 63.69 0 00112 112a64.79 64.79 0 00-14 1.55 24 24 0 0141.4-23.68l.23.35.4.46a35.78 35.78 0 015 8.94l5.62 15 30-11.24-5.62-15a68.2 68.2 0 00-10-17.74c-.38-.52-.79-1-1.19-1.51C178.38 55.45 196.64 48 216 48a76.86 76.86 0 0155.23 23.18A80.2 80.2 0 01292.61 142l-3 15.72 31.43 6 3-15.72a111.78 111.78 0 001.96-19.43 32 32 0 01-6 63.43zm112 208h-64V240h64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$729c85390177f4a9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 208h-24v-5.74A63.93 63.93 0 00321.65 96a111 111 0 00-27.59-47.29A108.62 108.62 0 00216 16c-29.91 0-57.78 12.28-79 34.68a56 56 0 00-67.51 77.54A63.91 63.91 0 0080 231.39V440a56.06 56.06 0 0056 56h176a56.06 56.06 0 0056-56v-8h24a72.08 72.08 0 0072-72v-80a72.08 72.08 0 00-72-72zM176 416a16 16 0 01-32 0V256a16 16 0 0132 0zm64 0a16 16 0 01-32 0V256a16 16 0 0132 0zm64 0a16 16 0 01-32 0V256a16 16 0 0132 0zm16-224c-8.33 0-20.55-5.18-26.69-11.31A16 16 0 00282 176H160a16 16 0 00-15 10.53c-6.83 18.68-23.6 21.47-33 21.47a32 32 0 010-64c.09 0 9.12.34 16.4 5.8a16 16 0 1019.2-25.6A63.69 63.69 0 00112 112a63.55 63.55 0 00-14 1.57A24 24 0 01120 80a23.78 23.78 0 0119.38 9.84 51.35 51.35 0 014.71 7.9A16 16 0 00176 96c0-6.77-3.61-15.17-10.76-25-.46-.63-1-1.25-1.45-1.86C178.39 55.44 196.64 48 216 48a76.86 76.86 0 0155.23 23.18A80.2 80.2 0 01292.61 142a16 16 0 0012.73 18.71 16.29 16.29 0 003 .28 16 16 0 0015.7-13 111.78 111.78 0 001.96-19.42 32 32 0 01-6 63.43zm112 168a40 40 0 01-40 40h-24V240h24a40 40 0 0140 40z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$66efc6b789f5f62(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M388 288a76 76 0 1076 76 76.24 76.24 0 00-76-76zm-264 0a76 76 0 1076 76 76.24 76.24 0 00-76-76z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 360v-86l-64-42 80-88 40 72h56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 136a31.89 31.89 0 0032-32.1A31.55 31.55 0 00320.2 72a32 32 0 10-.2 64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f5903f9ce1d0eb32(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 192l-29.5-60.1C284.32 118 284.32 118 264 118c-13.26 0-14.76 0-23 7.3l-71.7 69.1c-8.3 8.45-9.3 9.45-9.3 26.6 0 12.67 3.78 14.61 18.51 22.9L240 278v90h32V254s-29-17-48.3-30l48.9-51.5c18.7 28.5 27.3 51.5 38 51.5H384v-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M388 448a92 92 0 1192-92 92.1 92.1 0 01-92 92zm0-152a60 60 0 1060 60 60.07 60.07 0 00-60-60zM124 448a92 92 0 1192-92 92.1 92.1 0 01-92 92zm0-152a60 60 0 1060 60 60.07 60.07 0 00-60-60zm196-168a31.89 31.89 0 0032-32.1A31.55 31.55 0 00320.2 64a32 32 0 10-.2 64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4a545eaf1d18d3d6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M388 448a92 92 0 1192-92 92.1 92.1 0 01-92 92zm0-152a60 60 0 1060 60 60.07 60.07 0 00-60-60zM124 448a92 92 0 1192-92 92.1 92.1 0 01-92 92zm0-152a60 60 0 1060 60 60.07 60.07 0 00-60-60zm196-168a31.89 31.89 0 0032-32.1A31.55 31.55 0 00320.2 64a32 32 0 10-.2 64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M367.55 192h-43.76a4 4 0 01-3.51-2.08l-31.74-58.17a31 31 0 00-49.38-7.75l-69.86 70.4a32.56 32.56 0 00-9.3 22.4c0 17.4 12.6 23.6 18.5 27.1 28.5 16.42 48.57 28.43 59.58 35.1a4 4 0 011.92 3.41v69.12c0 8.61 6.62 16 15.23 16.43A16 16 0 00272 352v-86a16 16 0 00-6.66-13l-37-26.61a4 4 0 01-.58-6l42-44.79a4 4 0 016.42.79L298 215.77a16 16 0 0014 8.23h56a16 16 0 0016-16.77c-.42-8.61-7.84-15.23-16.45-15.23z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8cee1d6b8f660e36(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 352l224-192L256 48v416l112-112-224-192"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2c4c47a9f0fc62f6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M397.41 161.13L236-.28v212.8l-94.17-80.72-26 30.37L225.27 256 115.8 349.83l26 30.37 94.2-80.72v212.8l161.41-161.41L286.73 256zM276 96.28l62.59 62.59L276 212.52zm62.58 256.85L276 415.72V299.48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$35504ad66ea44ff2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M388 160.77a20 20 0 00-5.85-14.91l-112-112A20 20 0 00236 48v164.52l-79-67.71a20 20 0 00-26 30.38L225.27 256 131 336.81a20 20 0 1026 30.38l79-67.71V464a20 20 0 0034.14 14.14l112-112a20 20 0 00-1.14-29.33L286.73 256 381 175.19a20 20 0 007-14.42zm-49.42 192.36L276 415.72V299.49zM276 212.52V96.28l62.59 62.59z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7a8050066e445e0a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M461.93 261.05c-2-4.76-6.71-7.83-11.67-9.49l-187.18-74.48a23.78 23.78 0 00-14.17 0l-187 74.52c-5 1.56-9.83 4.77-11.81 9.53s-2.94 9.37-1 15.08l46.53 119.15a7.46 7.46 0 007.47 4.64c26.69-1.68 50.31-15.23 68.38-32.5a7.66 7.66 0 0110.49 0C201.29 386 227 400 256 400s54.56-14 73.88-32.54a7.67 7.67 0 0110.5 0c18.07 17.28 41.69 30.86 68.38 32.54a7.45 7.45 0 007.46-4.61l46.7-119.16c1.98-4.78.99-10.41-.99-15.18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M416 473.14a6.84 6.84 0 00-3.56-6c-27.08-14.55-51.77-36.82-62.63-48a10.05 10.05 0 00-12.72-1.51c-50.33 32.42-111.61 32.44-161.95.05a10.09 10.09 0 00-12.82 1.56c-10.77 11.28-35.19 33.3-62.43 47.75a7.15 7.15 0 00-3.89 5.73 6.73 6.73 0 007.92 7.15c20.85-4.18 41-13.68 60.2-23.83a8.71 8.71 0 018-.06A185.14 185.14 0 00340 456a8.82 8.82 0 018.09.06c19.1 10 39.22 19.59 60 23.8a6.72 6.72 0 007.95-6.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 96V72a24.07 24.07 0 00-24-24h-80a24.07 24.07 0 00-24 24v24m224 137v-89a48.14 48.14 0 00-48-48H144a48.14 48.14 0 00-48 48v92m160-52.4v212.85"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$babfc1a055427d34(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.77 246.42c-2.13-6-7.23-9.55-12.56-11.95L432 221.38V92a20 20 0 00-20-20h-76V40a16 16 0 00-16-16H192a16 16 0 00-16 16v32h-76a20 20 0 00-20 20v129.46l-33.08 13.06c-5.33 2.4-10.58 6-12.72 12s-3.16 11.81-1 19L84.25 415.7h1.06c34.12 0 64-17.41 85.31-43.82 21.32 26.41 51.18 42.12 85.3 42.12s64-15.76 85.31-42.17c21.32 26.41 51.18 43.87 85.3 43.87h1.06l51.25-150.17c2.16-6 1.07-13.1-1.07-19.11zM256 152l-144 56.83V108a4 4 0 014-4h280a4 4 0 014 4v100.76z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M345.22 407c-52.25 36.26-126.35 36.25-178.6 0 0 0-45.64 63-94.64 63l13.33 1c29.86 0 58.65-11.73 85.31-25.59a185.33 185.33 0 00170.6 0c26.66 13.87 55.45 25.6 85.31 25.6l13.33-1C392.21 470 345.22 407 345.22 407z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f232a7e317710cd6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 473.14a6.83 6.83 0 00-3.57-6c-27.07-14.55-51.76-36.82-62.62-48a10.05 10.05 0 00-12.72-1.51c-50.33 32.42-111.61 32.44-161.95.05a10.09 10.09 0 00-12.82 1.56c-10.77 11.28-35.19 33.3-62.43 47.75a7.11 7.11 0 00-3.89 5.73 6.73 6.73 0 007.92 7.15c20.85-4.18 41-13.68 60.2-23.83a8.71 8.71 0 018-.06 185.14 185.14 0 00167.81 0 8.82 8.82 0 018.09.06c19.1 10 39.22 19.59 60 23.8a6.73 6.73 0 008-6.71zm60.71-226.23c-3.49-8.39-10.9-14.89-20.9-18.35L432 219.08V136a64 64 0 00-64-64h-32v-8a40 40 0 00-40-40h-80a40 40 0 00-40 40v8h-32a64 64 0 00-64 64v83.15l-23.58 9.39c-9.94 3.3-17.63 10-21.15 18.44-2.45 5.89-5.25 15-1.3 26.46l.1.3 46.66 119.44A23.33 23.33 0 00102.58 408c.5 0 1 0 1.53-.05 31.32-2 56-17.27 72.6-31.61C200.42 396.81 228.31 408 256 408s55.43-11.2 79.14-31.7c16.59 14.36 41.3 29.67 72.61 31.65a23.36 23.36 0 0023.37-14.74l46.65-119c3.28-8.09 2.9-17.76-1.06-27.3zM269 154.21l-1.14-.4a39.53 39.53 0 00-23.73 0l-.58.18-126.07 50.23a4 4 0 01-5.48-3.72V136a32 32 0 0132-32h224a32 32 0 0132 32v64.44a4 4 0 01-5.48 3.72z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$666a9c0151ddaf93(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "40",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M199.3 295.62h0l-30.4 172.2a24 24 0 0019.5 27.8 23.76 23.76 0 0027.6-19.5l21-119.9v.2s5.2-32.5 17.5-32.5h3.1c12.5 0 17.5 32.5 17.5 32.5v-.1l21 119.9a23.92 23.92 0 1047.1-8.4l-30.4-172.2-4.9-29.7c-2.9-18.1-4.2-47.6.5-59.7 4-10.4 14.13-14.2 23.2-14.2H424a24 24 0 000-48H88a24 24 0 000 48h92.5c9.23 0 19.2 3.8 23.2 14.2 4.7 12.1 3.4 41.6.5 59.7z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f05a6e5351f2e6cd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H48v52h144l-32 325.13 51 6.87 21.65-192h47.02L301 512l51-6.98L320 180h144v-52z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$30eab5680f0b1957(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M437 128H75a27 27 0 000 54h101.88c6.91 0 15 3.09 19.58 15 5.35 13.83 2.73 40.54-.57 61.23l-4.32 24.45a.42.42 0 01-.12.35l-34.6 196.81A27.43 27.43 0 00179 511.58a27.06 27.06 0 0031.42-22.29l23.91-136.8S242 320 256 320c14.23 0 21.74 32.49 21.74 32.49l23.91 136.92a27.24 27.24 0 1053.62-9.6L320.66 283a.45.45 0 00-.11-.35l-4.33-24.45c-3.3-20.69-5.92-47.4-.57-61.23 4.56-11.88 12.91-15 19.28-15H437a27 27 0 000-54z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$410a3653c08e4ae8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M273.38 368.33c-.81-9.23-8.86-16.44-18.55-16.44a18.63 18.63 0 00-18.2 14.11l-18.2 88.38a35.75 35.75 0 00-.93 7.88c0 19.93 16.68 33.78 37.33 33.78s37.34-13.85 37.34-33.78a36.16 36.16 0 00-1.29-9.45zm137.67 39.53a41.78 41.78 0 00-5.95-4.35l-69.53-48.59c-6.77-4.25-14-4.13-19.25 1a13.53 13.53 0 00-2 17.2l52.5 69a36.57 36.57 0 004 4.69c9.1 10.17 29.28 10.73 40.37 0 10.94-10.91 10.81-30.35-.14-38.95zm52.25-71.98h-70.42c-4.55 0-8.88 3.35-8.88 8.16s2.95 7.85 6.92 9.16l66.43 20.55C467 376 480 367.4 480 356.66c0-13.66-7.6-20.78-16.7-20.78zM128.22 344c0-5-4.55-8.16-9.45-8.16H48.35c-8.87 0-16.35 9.58-16.35 20.32S44.62 376 54.3 373.75l67.43-20.55c4.39-1.31 6.49-4.2 6.49-9.2zm48.33 11L107 403.38a32.34 32.34 0 00-6 4.35 26.33 26.33 0 000 38.56 29.39 29.39 0 0040.36 0 30.75 30.75 0 004-4.68L197.9 373c3.5-5.58 2.92-12.49-2-17.06a15 15 0 00-19.35-.94z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M368 125.09c0-55.7-49.22-89.16-94.2-93.06a8 8 0 00-8.69 7.71c-3.12 76-109.38 110.69-119.87 178.68-7 45.4 16.65 72.37 34.31 85.78a15.94 15.94 0 0023.93-5.62c22.5-45.86 74.33-63.49 109.72-85.94 42.88-27.2 54.8-56.44 54.8-87.55z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M240 95.7c-12.82-23-30.51-31-59.16-31.63a3.86 3.86 0 00-4.06 3.51c-.95 34.22-32.78 44.85-32.78 73.15 0 19.37 5.39 29 17.16 39.28m191.29-1.25c8.6 14.31 15.55 30.08 15.55 48 0 52.52-42.47 93.1-94.86 93.1a94.42 94.42 0 01-65.14-26"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$930a49221d1e3b00(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M199.89 336l-15.25-5.62a100.35 100.35 0 01-32-23.08c-13.93-14.9-29.29-40.71-23.38-79.11 5.2-33.73 44.2-74.21 69.34-97.87 27.24-25.62 66-65.85 64.15-99.15L262 16h15.18C328.53 16 384 53.62 384 114.41c0 45.57-22 77.61-68.91 106.9-8 5-16.44 9.66-25.42 14.53-30.63 16.62-75.29 49.83-85.73 85.32zm-18.7-222.41C201 95 218.91 78.15 227.62 59.79q-2.76-1.68-5.7-3.09c-11.87-5.69-26.1-8.34-44.76-8.34h-16.94l.56 16.49c.47 14.06-6.06 22.51-14.33 33.21C137.8 109.26 128 121.94 128 141c0 10.23 1.29 18.76 4.2 26.36q3.5-5.31 7.61-10.63c12.19-15.73 27.05-29.68 41.38-43.14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M330.34 239.85c-9.31 5.9-19 11.14-29.25 16.71-32.65 17.69-63.48 34.44-73.23 67.44l-.6 2a110.5 110.5 0 0045.87 10c29.66 0 57.45-11.13 78.24-31.36A107.38 107.38 0 00384 227a92.39 92.39 0 00-5.59-31c-11.35 16.18-27.14 30.58-48.07 43.85zM268.72 360h-25.44a4 4 0 00-3.92 3.22l-25.36 128a4 4 0 003.92 4.78h76.26a4 4 0 003.92-4.78l-25.41-128a4 4 0 00-3.97-3.22zm56.96-5.68l-11.36 11.36a4 4 0 00-.5 5.05l59.47 89.21a4 4 0 006.16.61l41.1-41.1a4 4 0 00-.61-6.16l-89.21-59.47a4 4 0 00-5.05.5zM388 336a4 4 0 00-4 4v8.61a4 4 0 003.34 3.95l88 14.66a4 4 0 004.66-3.94V340a4 4 0 00-4-4zm-201.68 18.32l11.36 11.36a4 4 0 01.5 5.05l-59.47 89.21a4 4 0 01-6.16.61l-41.1-41.1a4 4 0 01.61-6.16l89.21-59.47a4 4 0 015.05.5zM124 336H36a4 4 0 00-4 4v23.28a4 4 0 004.66 3.94l88-14.66a4 4 0 003.34-3.95V340a4 4 0 00-4-4z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d1d9a6c11ad35bac(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M273.38 368.37c-.81-9.23-8.86-16.44-18.55-16.44a18.63 18.63 0 00-18.2 14.07l-18.2 88.36a35.59 35.59 0 00-.93 7.87c0 19.93 16.68 33.77 37.33 33.77s37.34-13.84 37.34-33.77a36.16 36.16 0 00-1.29-9.45zm137.67 39.52a42.66 42.66 0 00-5.95-4.36L335.57 355c-6.77-4.24-14-4.13-19.25 1a13.52 13.52 0 00-2 17.19l52.5 69a38 38 0 004 4.69c9.1 10.16 29.28 10.72 40.37 0 10.94-10.96 10.81-30.39-.14-38.99zm52.25-71.96h-70.42c-4.55 0-8.88 3.35-8.88 8.15s2.95 7.85 6.92 9.16l66.43 20.55C467 376 480 367.44 480 356.71c0-13.63-7.6-20.78-16.7-20.78zm-335.08 8.15c0-4.95-4.55-8.15-9.45-8.15H48.35c-8.87 0-16.35 9.58-16.35 20.31S44.62 376 54.3 373.79l67.43-20.55c4.39-1.31 6.49-4.24 6.49-9.16zm48.33 10.97L107 403.41a32.29 32.29 0 00-6 4.34 26.33 26.33 0 000 38.56 29.41 29.41 0 0040.36 0 30.75 30.75 0 004-4.68L197.9 373c3.5-5.57 2.92-12.48-2-17a15 15 0 00-19.35-.95zm116.91-112.66c10-5.42 19.45-10.54 28.31-16.16 42.46-26.92 62.23-59 62.23-101 0-64.66-56.07-104.4-108.82-109-6.49-.57-15-.42-19.91 3.88s-5.88 12.56-6.15 19.1c-1.38 33.61-28.38 59-57 85.86-28 26.3-56.93 53.49-62.71 91-8.41 54.68 21.74 86.71 40.46 100.93a31.88 31.88 0 0019.3 6.51 32.32 32.32 0 007.41-.87 31.75 31.75 0 0021.27-16.95c14.91-30.39 45.77-47.12 75.61-63.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M139.82 156.57c12.22-15.76 27-29.68 41.37-43.15 19.92-18.72 37.81-35.58 46.5-53.86-12.24-7.37-27.36-11.36-46.51-11.36-17.79 0-20.39 5.18-20.39 19.06 0 12.56-6.53 20.54-14.34 30.65C137.8 109.1 128 121.77 128 140.84c0 10.23 1.29 18.77 4.2 26.37q3.5-5.32 7.62-10.64zm190.52 83.17c-9.33 5.92-19 11.16-29.25 16.71-28.91 15.68-56.21 30.48-68.88 56.28a62.6 62.6 0 01-1.88 3.61 8 8 0 003.89 11.3c12.31 5.1 25.13 8.27 38.91 8.27a111.42 111.42 0 0078.24-31.37A107.45 107.45 0 00384 226.85a86.56 86.56 0 00-1.33-15 8 8 0 00-13.8-4c-10.18 11.47-22.93 22-38.53 31.89z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a73b3c77a03dc679(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 160c16-63.16 76.43-95.41 208-96a15.94 15.94 0 0116 16v288a16 16 0 01-16 16c-128 0-177.45 25.81-208 64-30.37-38-80-64-208-64-9.88 0-16-8.05-16-17.93V80a15.94 15.94 0 0116-16c131.57.59 192 32.84 208 96zm0 0v288"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9855e3c28dc5826e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 48c-67.61.29-117.87 9.6-154.24 25.69-27.14 12-37.76 21.08-37.76 51.84V448c41.57-37.5 78.46-48 224-48V48zM48 48c67.61.29 117.87 9.6 154.24 25.69 27.14 12 37.76 21.08 37.76 51.84V448c-41.57-37.5-78.46-48-224-48V48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$32f115f2ef6dd277(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M202.24 74C166.11 56.75 115.61 48.3 48 48a31.36 31.36 0 00-17.92 5.33A32 32 0 0016 79.9V366c0 19.34 13.76 33.93 32 33.93 71.07 0 142.36 6.64 185.06 47a4.11 4.11 0 006.94-3V106.82a15.89 15.89 0 00-5.46-12A143 143 0 00202.24 74zm279.68-20.7A31.33 31.33 0 00464 48c-67.61.3-118.11 8.71-154.24 26a143.31 143.31 0 00-32.31 20.78 15.93 15.93 0 00-5.45 12v337.13a3.93 3.93 0 006.68 2.81c25.67-25.5 70.72-46.82 185.36-46.81a32 32 0 0032-32v-288a32 32 0 00-14.12-26.61z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f3606a8f46335b00(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 48H160a48 48 0 00-48 48v368l144-128 144 128V96a48 48 0 00-48-48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2aada03b28ec4976(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 480L256 357.41 96 480V32h320z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ef191ee24563ed62(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480a16 16 0 01-10.63-4L256 357.41 122.63 476A16 16 0 0196 464V96a64.07 64.07 0 0164-64h192a64.07 64.07 0 0164 64v368a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$aab9c09e6df7396d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 80V64a48.14 48.14 0 0148-48h224a48.14 48.14 0 0148 48v368l-80-64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 96H112a48.14 48.14 0 00-48 48v352l152-128 152 128V144a48.14 48.14 0 00-48-48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$885488c325a980a0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 0v48h304v368l48 32V0H112z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M48 80v432l168-124 168 124V80H48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1dd0e1177c435c9a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H176a64.11 64.11 0 00-62 48h228a74 74 0 0174 74v304.89l22 17.6a16 16 0 0019.34.5 16.41 16.41 0 006.66-13.42V64a64 64 0 00-64-64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 80H112a64 64 0 00-64 64v351.62A16.36 16.36 0 0054.6 509a16 16 0 0019.71-.71L216 388.92l141.69 119.32a16 16 0 0019.6.79 16.4 16.4 0 006.71-13.44V144a64 64 0 00-64-64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bc99e22371a04b5e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "288",
                    "cy": "200",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "296",
                    "cy": "128",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "360",
                    "cy": "168",
                    "r": "24"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b593c933253f3420(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM286 230a28 28 0 1128-28 28 28 0 01-28 28zm8-76a28 28 0 1128-28 28 28 0 01-28 28zm68 44a28 28 0 1128-28 28 28 0 01-28 28z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2e07ccba77dbac21(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM288 224a24 24 0 1124-24 24 24 0 01-24 24zm8-72a24 24 0 1124-24 24 24 0 01-24 24zm64 40a24 24 0 1124-24 24 24 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ec72349245c0aa65(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "320",
                    "x": "32",
                    "y": "128",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 128V96a32 32 0 0132-32h160a32 32 0 0132 32v32m112 112H32m288 0v24a8 8 0 01-8 8H200a8 8 0 01-8-8v-24"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9eaf8d2e52ad967c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 288H176v-32H16v196a12 12 0 0012 12h456a12 12 0 0012-12V256H336zm160-164a12 12 0 00-12-12H384V56a8 8 0 00-8-8H136a8 8 0 00-8 8v56H28a12 12 0 00-12 12v100h480zm-152-12H168V88h176z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$67a4ebc359eea8aa(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M336 80H176a16 16 0 00-16 16v16h192V96a16 16 0 00-16-16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M496 176a64.07 64.07 0 00-64-64h-48V96a48.05 48.05 0 00-48-48H176a48.05 48.05 0 00-48 48v16H80a64.07 64.07 0 00-64 64v48h480zm-144-64H160V96a16 16 0 0116-16h160a16 16 0 0116 16zm-16 152a24 24 0 01-24 24H200a24 24 0 01-24-24v-4a4 4 0 00-4-4H16v144a64 64 0 0064 64h352a64 64 0 0064-64V256H340a4 4 0 00-4 4z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6e6679f11c71fc19(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "384",
                    "x": "48",
                    "y": "64",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M397.82 64H114.18C77.69 64 48 94.15 48 131.2V176h16c0-16 16-32 32-32h320c16 0 32 16 32 32h16v-44.8c0-37.05-29.69-67.2-66.18-67.2z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b30c13233caf5bdb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64v384a16 16 0 0016 16h416a16 16 0 0016-16V64a16 16 0 00-16-16H48a16 16 0 00-16 16zm408 364H72a4 4 0 01-4-4V152a4 4 0 014-4h368a4 4 0 014 4v272a4 4 0 01-4 4z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6d7a45590e335edb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 48H96a64 64 0 00-64 64v288a64 64 0 0064 64h320a64 64 0 0064-64V112a64 64 0 00-64-64zm24 96H72a8 8 0 01-8-8v-24a32.09 32.09 0 0132-32h320a32.09 32.09 0 0132 32v24a8 8 0 01-8 8z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cba28ec6c7fb0a0d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M452.37 59.63h0a40.49 40.49 0 00-57.26 0L184 294.74c23.08 4.7 46.12 27.29 49.26 49.26l219.11-227.11a40.49 40.49 0 000-57.26zM138 336c-29.88 0-54 24.5-54 54.86 0 23.95-20.88 36.57-36 36.57C64.56 449.74 92.82 464 120 464c39.78 0 72-32.73 72-73.14 0-30.36-24.12-54.86-54-54.86z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$18cdaf94aab6c298(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 96l-64-64-244 260 64 64zM142 320c-36.52 0-66 30.63-66 68.57 0 25.43-31 45.72-44 45.72C52.24 462.17 86.78 480 120 480c48.62 0 88-40.91 88-91.43 0-37.94-29.48-68.57-66-68.57z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ee40c9759c8baf34(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M233.15 360.11a15.7 15.7 0 01-4.92-.77 16 16 0 01-10.92-13c-2.15-15-19.95-32.46-36.62-35.85a16 16 0 01-8.69-26.33l211.09-235.1c.19-.22.39-.43.59-.63a56.57 56.57 0 0179.89 0 56.51 56.51 0 01.11 79.78l-219 227a16 16 0 01-11.53 4.9zm-113.26 120c-32.14 0-65.45-16.89-84.85-43a16 16 0 0112.85-25.54c5.34 0 20-4.87 20-20.57 0-39.07 31.4-70.86 70-70.86s70 31.79 70 70.86c0 49.12-39.48 89.11-88 89.11z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d8eb094b06bbb688(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M370 378c28.89 23.52 46 46.07 46 86m-274-86c-28.89 23.52-46 46.06-46 86m288-256c28.89-23.52 32-56.07 32-96m-288 94c-28.89-23.52-32-54.06-32-94m368 176.13h-80m-256 0H48M256 192v256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 448h0c-70.4 0-128-57.6-128-128v-96.07c0-65.07 57.6-96 128-96h0c70.4 0 128 25.6 128 96V320c0 70.4-57.6 128-128 128z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M179.43 143.52a49.08 49.08 0 01-3.43-15.73A80 80 0 01255.79 48h.42A80 80 0 01336 127.79a41.91 41.91 0 01-3.12 14.3"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b2a92ae51c623574(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 304.13v-32h-80V215.2c29.42-27.95 32-64.76 32-103.2V96h-32v16c0 28-1.86 48.15-9.9 63.84C368 128 324.32 112 256 112c-39.8 0-75.19 7.06-100.43 24.32-14.9 10.19-25.2 24.91-32.7 39.72C114 160.57 112 140.82 112 112V96H80v16c0 37.44 2.59 73.36 32 101.2v58.93H32v32l80-.13c0 19 3.7 53.09 10.39 69.69C96.6 396.76 80 422.31 80 464v16h32v-16c0-27.66 9.1-44.71 26.17-61.32C160 448 177 464 240 464V176h32v288c65 0 80-16 101.83-61.32C390.9 419.29 400 436.35 400 464v16h32v-16c0-41.68-16.6-67.23-42.39-90.31C396.3 357.09 400 323 400 304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c-48.06 0-96 0-96 84 26.12-14 59.35-20 96-20 24.09 0 46.09 2.65 65.39 8 10.75 3 24.66 8.71 30.61 12 0-84-47.94-84-96-84z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5666ce1207479a3d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M463.55 272.13H400v-48.2q0-4.32-.27-8.47c29.57-27.88 32.25-64.63 32.27-103 0-8.61-6.64-16-15.25-16.41A16 16 0 00400 112c0 28-1.86 48.15-9.9 63.84-19.22-41.15-65.78-63.91-134.1-63.91-39.8 0-74.19 9.13-99.43 26.39-14.9 10.19-26.2 22.91-33.7 37.72C114 160.65 112 141 112 112.46c0-8.61-6.6-16-15.2-16.44A16 16 0 0080 112c0 37.63 2.61 73.73 32.44 101.63q-.43 5.06-.44 10.3v48.2H48.45c-8.61 0-16 6.62-16.43 15.23a16 16 0 0016 16.77h64V320a143.32 143.32 0 0010.39 53.69C96.74 396.64 80.18 422 80 463.34c0 8.74 6.62 16.3 15.36 16.65A16 16 0 00112 464c0-27.66 9.1-44.71 26.17-61.32A144.37 144.37 0 00220 459.42a16 16 0 0020-15.49V192.45c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 192v251.93a16 16 0 0020 15.49 144.4 144.4 0 0081.82-56.74c17 16.54 26.09 33.52 26.17 60.95a16.27 16.27 0 0015.1 16.37A16 16 0 00432 464c0-41.68-16.6-67.23-42.39-90.31A143.32 143.32 0 00400 320v-15.87h64a16 16 0 0016-16.77c-.42-8.61-7.84-15.23-16.45-15.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M321.39 104l.32.09c13.57 3.8 25.07-10.55 18.2-22.85A95.86 95.86 0 00256.21 32h-.42a95.87 95.87 0 00-84.19 50.13c-6.84 12.58 5.14 27 18.84 22.86 19.71-6 41.79-9.06 65.56-9.06 24.09 0 46.09 2.72 65.39 8.07z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ea970aa6eb21c59a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M393.87 190a32.1 32.1 0 01-45.25 0l-26.57-26.57a32.09 32.09 0 010-45.26L382.19 58a1 1 0 00-.3-1.64c-38.82-16.64-89.15-8.16-121.11 23.57-30.58 30.35-32.32 76-21.12 115.84a31.93 31.93 0 01-9.06 32.08L64 380a48.17 48.17 0 1068 68l153.86-167a31.93 31.93 0 0131.6-9.13c39.54 10.59 84.54 8.6 114.72-21.19 32.49-32 39.5-88.56 23.75-120.93a1 1 0 00-1.6-.26z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "96",
                    "cy": "416",
                    "r": "16"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bdd975b88151b7f9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M230 209.2L32 405.58 106.65 480l197.59-198.17c46.47 17.46 105.52 12.54 143-24.78 40.44-40.32 40.35-108 16.81-156.79l-87.33 87.06-52.32-52.13 87.33-87.06C363 24.46 294.67 24.34 254.23 64.66c-38.03 37.91-42.78 97.6-24.23 144.54z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3664797eb2a2e05b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M469.54 120.52a16 16 0 00-25.54-4L382.56 178a16.12 16.12 0 01-22.63 0l-26.56-26.6a16 16 0 010-22.63l61.18-61.19a16 16 0 00-4.78-25.92C343.56 21 285.88 31.78 249.51 67.88c-30.9 30.68-40.11 78.62-25.25 131.53a15.89 15.89 0 01-4.49 16L53.29 367.46a64.17 64.17 0 1090.6 90.64l153.68-166.85a15.9 15.9 0 0115.77-4.57 179.3 179.3 0 0046.22 6.37c33.4 0 62.71-10.81 83.85-31.64 39.15-38.57 45.12-103.99 26.13-140.89zM99.48 447.15a32 32 0 1128.34-28.35 32 32 0 01-28.34 28.35z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5e64bb082389ac60(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 384v-24c0-29 31.54-56.43 52-76 28.84-27.57 44-64.61 44-108 0-80-63.73-144-144-144a143.6 143.6 0 00-144 144c0 41.84 15.81 81.39 44 108 20.35 19.21 52 46.7 52 76v24m16 96h64m-80-48h96m-48-48V256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M294 240s-21.51 16-38 16-38-16-38-16"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ce254fbfd9a9c812(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 464h96v32h-96zm-16-48h128v32H192zM369.42 62.69C339.35 32.58 299.07 16 256 16A159.62 159.62 0 0096 176c0 46.62 17.87 90.23 49 119.64l4.36 4.09C167.37 316.57 192 339.64 192 360v40h48V269.11L195.72 244 214 217.72 256 240l41.29-22.39 19.1 25.68-44.39 26V400h48v-40c0-19.88 24.36-42.93 42.15-59.77l4.91-4.66C399.08 265 416 223.61 416 176a159.16 159.16 0 00-46.58-113.31z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e73be09c8f692da(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 464h-64a16 16 0 000 32h64a16 16 0 000-32zm16-48h-96a16 16 0 000 32h96a16 16 0 000-32zm65.42-353.31C339.35 32.58 299.07 16 256 16A159.62 159.62 0 0096 176c0 46.62 17.87 90.23 49 119.64l4.36 4.09C167.37 316.57 192 339.64 192 360v24a16 16 0 0016 16h24a8 8 0 008-8V274.82a8 8 0 00-5.13-7.47A130.73 130.73 0 01208.71 253a16 16 0 1118.58-26c7.4 5.24 21.65 13 28.71 13s21.31-7.78 28.73-13a16 16 0 0118.56 26 130.73 130.73 0 01-26.16 14.32 8 8 0 00-5.13 7.47V392a8 8 0 008 8h24a16 16 0 0016-16v-24c0-19.88 24.36-42.93 42.15-59.77l4.91-4.66C399.08 265 416 223.61 416 176a159.16 159.16 0 00-46.58-113.31z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6e828cfe0ca86961(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "352",
                    "height": "192",
                    "x": "80",
                    "y": "112",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "352",
                    "height": "128",
                    "x": "80",
                    "y": "304",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 112H112a32.09 32.09 0 01-32-32h0a32.09 32.09 0 0132-32h288a32.09 32.09 0 0132 32h0a32.09 32.09 0 01-32 32zM144 432v22a10 10 0 01-10 10h-28a10 10 0 01-10-10v-22zm272 0v22a10 10 0 01-10 10h-28a10 10 0 01-10-10v-22z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "368",
                    "cy": "368",
                    "r": "16",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "144",
                    "cy": "368",
                    "r": "16",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 112v192M80 80v288M432 80v288"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$27427ae1dbfc9420(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M400 64H112a16 16 0 000 32h288a16 16 0 000-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M424 32H88a24 24 0 00-24 24v360a32 32 0 0016 27.71V480h72v-32h208v32h72v-36.29A32 32 0 00448 416V56a24 24 0 00-24-24zM175.82 371.47a32 32 0 11-35.3-35.29 32.09 32.09 0 0135.3 35.29zM240 288H96V128h144zm16-192H96.46L96 64h320l-.46 32H256zm16 32h144v160H272zm64.18 236.53a32 32 0 1135.3 35.29 32.09 32.09 0 01-35.3-35.29z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1fb985b993a9885c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H112a48 48 0 00-48 48v320a47.91 47.91 0 0016 35.74V454a26 26 0 0026 26h28a26 26 0 0026-26v-6h192v6a26 26 0 0026 26h28a26 26 0 0026-26v-18.26A47.91 47.91 0 00448 400V80a48 48 0 00-48-48zM147.47 399.82a32 32 0 1128.35-28.35 32 32 0 01-28.35 28.35zM236 288H112a16 16 0 01-16-16V144a16 16 0 0116-16h124a4 4 0 014 4v152a4 4 0 01-4 4zm20-192H112.46c-8.6 0-16-6.6-16.44-15.19A16 16 0 01112 64h287.54c8.6 0 16 6.6 16.44 15.19A16 16 0 01400 96H256zm20 32h124a16 16 0 0116 16v128a16 16 0 01-16 16H276a4 4 0 01-4-4V132a4 4 0 014-4zm60.18 243.47a32 32 0 1128.35 28.35 32 32 0 01-28.35-28.35z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$501034f3d0be5449(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 416v64M80 32h192a32 32 0 0132 32v412a4 4 0 01-4 4H48h0V64a32 32 0 0132-32zm240 160h112a32 32 0 0132 32v256h0-160 0V208a16 16 0 0116-16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M98.08 431.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 240a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 320a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256",
                    "cy": "176",
                    "rx": "15.95",
                    "ry": "16.03",
                    "transform": "rotate(-45 255.99 175.996)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M258.08 111.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM400 400a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm-64 160a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2538e3f43de95465(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 176V16H32v480h128v-96h32v96h288V176zM112 432H80v-32h32zm0-80H80v-32h32zm0-80H80v-32h32zm0-80H80v-32h32zm0-80H80V80h32zm128-32h32v32h-32zm-48 272h-32v-32h32zm0-80h-32v-32h32zm0-80h-32v-32h32zm0-80h-32V80h32zm80 320h-32v-32h32zm0-80h-32v-32h32zm0-80h-32v-32h32zm0-80h-32v-32h32v32zm176 272H320v-32h32v-32h-32v-48h32v-32h-32v-48h32v-32h-32v-32h128z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M384 400h32v32h-32zm0-80h32v32h-32zm0-80h32v32h-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6432ebe29ea4580b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 176H320V64a48 48 0 00-48-48H80a48 48 0 00-48 48v416a16 16 0 0016 16h104a8 8 0 008-8v-71.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01192 416v72a8 8 0 008 8h264a16 16 0 0016-16V224a48 48 0 00-48-48zM98.08 431.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 240a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 320a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM444 464H320V208h112a16 16 0 0116 16v236a4 4 0 01-4 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M400 400a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm-64 160a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$afa40268dc71e3b5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 80h64a16 16 0 0116 16v34a46 46 0 01-46 46h-34M96 80h272v192a80 80 0 01-80 80H176a80 80 0 01-80-80V80h0zM64 416h336"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$71dd2775fca57f0a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64H80v254.34a19.83 19.83 0 005.86 14.14l29.65 29.66a19.87 19.87 0 0014.15 5.86h204.68a19.87 19.87 0 0014.15-5.86l29.65-29.66a19.83 19.83 0 005.86-14.14V192h32a16 16 0 0011.31-4.69l32-32A16 16 0 00464 144V80a16 16 0 00-16-16zm-16 73.37L409.37 160H384V96h48zM48 400h368v32H48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b626e1948449ea8c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 64H96a16 16 0 00-16 16v192a96.11 96.11 0 0096 96h112a96.11 96.11 0 0096-96v-80h18a62.07 62.07 0 0062-62V96a32 32 0 00-32-32zm0 66a30 30 0 01-30 30h-18V96h48zm-32 270H64a16 16 0 000 32h336a16 16 0 000-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$12ff6b0cddbe41d8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "288",
                    "height": "416",
                    "x": "112",
                    "y": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160.01 112H352v64H160.01z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "248",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "248",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "344",
                    "cy": "248",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "328",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "328",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "408",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "408",
                    "r": "24"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "128",
                    "x": "320",
                    "y": "304",
                    "rx": "24",
                    "ry": "24"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$389945dcc9fac435(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 48a16 16 0 00-16-16H112a16 16 0 00-16 16v416a16 16 0 0016 16h288a16 16 0 0016-16zM192 432h-48v-48h48zm0-80h-48v-48h48zm0-80h-48v-48h48zm88 160h-48v-48h48zm0-80h-48v-48h48zm0-80h-48v-48h48zm88 160h-48V304h48zm0-160h-48v-48h48zm0-96H144V80h224z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b1c44dc83c172e30(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 80a48.05 48.05 0 00-48-48H144a48.05 48.05 0 00-48 48v352a48.05 48.05 0 0048 48h224a48.05 48.05 0 0048-48zM168 432a24 24 0 1124-24 24 24 0 01-24 24zm0-80a24 24 0 1124-24 24 24 0 01-24 24zm0-80a24 24 0 1124-24 24 24 0 01-24 24zm88 160a24 24 0 1124-24 24 24 0 01-24 24zm0-80a24 24 0 1124-24 24 24 0 01-24 24zm0-80a24 24 0 1124-24 24 24 0 01-24 24zm112 136a24 24 0 01-48 0v-80a24 24 0 0148 0zm-24-136a24 24 0 1124-24 24 24 0 01-24 24zm19.31-100.69A16 16 0 01352 176H160a16 16 0 01-16-16V96a16 16 0 0116-16h192a16 16 0 0116 16v64a16 16 0 01-4.69 11.31z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1056a031a6449abe(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "384",
                    "x": "48",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 48v32m256-32v32m80 80H48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$197aa54758b5ab4c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 456a24 24 0 0024 24h400a24 24 0 0024-24V192H32zM480 87.77A23.8 23.8 0 00456 64h-55.92V32h-48v32H159.92V32h-48v32H56a23.8 23.8 0 00-24 23.77V144h448z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$33ce271df18637d0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128a64 64 0 00-64-64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4zM32 416a64 64 0 0064 64h320a64 64 0 0064-64V180a4 4 0 00-4-4H36a4 4 0 00-4 4z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bc2d1649e1ae58b9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "384",
                    "x": "48",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 48v32m256-32v32m80 80H48m256 100l43.42-32H352v168m-160.13-89.37c9.11 0 25.79-4.28 36.72-15.47a37.9 37.9 0 0011.13-27.26c0-26.12-22.59-39.9-47.89-39.9-21.4 0-33.52 11.61-37.85 18.93M149 374.16c4.88 8.27 19.71 25.84 43.88 25.84 28.59 0 52.12-15.94 52.12-43.82 0-12.62-3.66-24-11.58-32.07-12.36-12.64-31.25-17.48-41.55-17.48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$66d9597823731d74(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 456a24 24 0 0024 24h400a24 24 0 0024-24V176H32zm310.17-244H368v200h-32V256.29l-35.39 26.08-19-25.76zM222 335.3c-8.54-8.74-22.75-12.67-30.11-12.67h-16v-32h16c4.85 0 17.41-2.6 25.28-10.65a22 22 0 006.57-16.08c0-23.23-28.63-23.9-31.89-23.9-17.34 0-23.8 10.61-24.07 11.06l-8.13 13.78-27.56-16.27 8.14-13.77c7.64-13 25.22-26.8 51.62-26.8 16.44 0 31.76 4.77 43.13 13.42 13.39 10.2 20.76 25.28 20.76 42.48A54 54 0 01240 302.35c-1.15 1.18-2.36 2.28-3.59 3.35a66.18 66.18 0 018.42 7.23c10.56 10.8 16.14 25.75 16.14 43.25 0 18.06-7.61 34-21.42 44.92-12.17 9.61-28.75 14.9-46.7 14.9-27.87 0-48.48-18.16-57.66-33.7l-8.13-13.78 27.56-16.27 8.16 13.75c1.08 1.84 11.15 18 30.1 18 16.66 0 36.12-7.29 36.12-27.82 0-6.25-1.22-14.95-7-20.88zM456 64h-55.92V32h-48v32H159.92V32h-48v32H56a23.8 23.8 0 00-24 23.77V144h448V87.77A23.8 23.8 0 00456 64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2e076f6f92a94cd1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4v-12a64 64 0 00-64-64zm60 112H36a4 4 0 00-4 4v236a64 64 0 0064 64h320a64 64 0 0064-64V180a4 4 0 00-4-4zM239.58 401.1c-12.17 9.61-28.75 14.9-46.7 14.9-27.87 0-48.48-18.16-57.66-33.7a16 16 0 0127.56-16.3c1.08 1.84 11.15 18 30.1 18 16.66 0 36.12-7.29 36.12-27.82 0-6.25-1.22-14.95-7-20.88-8.54-8.74-22.75-12.67-30.11-12.67a16 16 0 010-32c4.85 0 17.41-2.6 25.28-10.65a22 22 0 006.57-16.08c0-23.23-28.63-23.9-31.89-23.9-17.34 0-23.8 10.61-24.07 11.06a16 16 0 11-27.55-16.26c7.64-13 25.22-26.8 51.62-26.8 16.44 0 31.76 4.77 43.13 13.42 13.39 10.2 20.76 25.28 20.76 42.48A54 54 0 01240 302.35c-1.15 1.18-2.36 2.28-3.59 3.35a66.18 66.18 0 018.42 7.23c10.56 10.8 16.14 25.75 16.14 43.25.03 18.06-7.58 34.01-21.39 44.92zM368 396a16 16 0 01-32 0V256.29l-22.51 16.59a16 16 0 11-19-25.76l43.42-32a16 16 0 019.49-3.12h4.6a16 16 0 0116 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$905ee76b9dd3c16f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "384",
                    "x": "48",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "296",
                    "cy": "232",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "376",
                    "cy": "232",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "296",
                    "cy": "312",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "376",
                    "cy": "312",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "136",
                    "cy": "312",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "216",
                    "cy": "312",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "136",
                    "cy": "392",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "216",
                    "cy": "392",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "296",
                    "cy": "392",
                    "r": "24"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 48v32m256-32v32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M464 160H48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ac4e680c6ce16839(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 456a24 24 0 0024 24h400a24 24 0 0024-24V176H32zm320-244a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm-80-80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm-80-80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm-80-80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zM456 64h-55.92V32h-48v32H159.92V32h-48v32H56a23.8 23.8 0 00-24 23.77V144h448V87.77A23.8 23.8 0 00456 64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a3826ae2dce5f6f2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128a64 64 0 00-64-64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4zM32 416a64 64 0 0064 64h320a64 64 0 0064-64V179a3 3 0 00-3-3H35a3 3 0 00-3 3zm344-208a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm-80-80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm-80-80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm-80-80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9ae6987a4ee03169(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M451 374c-15.88-16-54.34-39.35-73-48.76-24.3-12.24-26.3-13.24-45.4.95-12.74 9.47-21.21 17.93-36.12 14.75s-47.31-21.11-75.68-49.39-47.34-61.62-50.53-76.48 5.41-23.23 14.79-36c13.22-18 12.22-21 .92-45.3-8.81-18.9-32.84-57-48.9-72.8C119.9 44 119.9 47 108.83 51.6A160.15 160.15 0 0083 65.37C67 76 58.12 84.83 51.91 98.1s-9 44.38 23.07 102.64 54.57 88.05 101.14 134.49S258.5 406.64 310.85 436c64.76 36.27 89.6 29.2 102.91 23s22.18-15 32.83-31a159.09 159.09 0 0013.8-25.8C465 391.17 468 391.17 451 374z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f18930c047248832(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M478.94 370.14c-5.22-5.56-23.65-22-57.53-43.75-34.13-21.94-59.3-35.62-66.52-38.81a3.83 3.83 0 00-3.92.49c-11.63 9.07-31.21 25.73-32.26 26.63-6.78 5.81-6.78 5.81-12.33 4-9.76-3.2-40.08-19.3-66.5-45.78s-43.35-57.55-46.55-67.3c-1.83-5.56-1.83-5.56 4-12.34.9-1.05 17.57-20.63 26.64-32.25a3.83 3.83 0 00.49-3.92c-3.19-7.23-16.87-32.39-38.81-66.52-21.78-33.87-38.2-52.3-43.76-57.52a3.9 3.9 0 00-3.89-.87 322.35 322.35 0 00-56 25.45A338 338 0 0033.35 92a3.83 3.83 0 00-1.26 3.74c2.09 9.74 12.08 50.4 43.08 106.72 31.63 57.48 53.55 86.93 100 133.22S252 405.21 309.54 436.84c56.32 31 97 41 106.72 43.07a3.86 3.86 0 003.75-1.26A337.73 337.73 0 00454.35 430a322.7 322.7 0 0025.45-56 3.9 3.9 0 00-.86-3.86z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8348e95ade2d29dd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391 480c-19.52 0-46.94-7.06-88-30-49.93-28-88.55-53.85-138.21-103.38C116.91 298.77 93.61 267.79 61 208.45c-36.84-67-30.56-102.12-23.54-117.13C45.82 73.38 58.16 62.65 74.11 52a176.3 176.3 0 0128.64-15.2c1-.43 1.93-.84 2.76-1.21 4.95-2.23 12.45-5.6 21.95-2 6.34 2.38 12 7.25 20.86 16 18.17 17.92 43 57.83 52.16 77.43 6.15 13.21 10.22 21.93 10.23 31.71 0 11.45-5.76 20.28-12.75 29.81-1.31 1.79-2.61 3.5-3.87 5.16-7.61 10-9.28 12.89-8.18 18.05 2.23 10.37 18.86 41.24 46.19 68.51s57.31 42.85 67.72 45.07c5.38 1.15 8.33-.59 18.65-8.47 1.48-1.13 3-2.3 4.59-3.47 10.66-7.93 19.08-13.54 30.26-13.54h.06c9.73 0 18.06 4.22 31.86 11.18 18 9.08 59.11 33.59 77.14 51.78 8.77 8.84 13.66 14.48 16.05 20.81 3.6 9.53.21 17-2 22-.37.83-.78 1.74-1.21 2.75a176.49 176.49 0 01-15.29 28.58c-10.63 15.9-21.4 28.21-39.38 36.58A67.42 67.42 0 01391 480z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2a81b155c1744a6a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M350.54 148.68l-26.62-42.06C318.31 100.08 310.62 96 302 96h-92c-8.62 0-16.31 4.08-21.92 10.62l-26.62 42.06C155.85 155.23 148.62 160 140 160H80a32 32 0 00-32 32v192a32 32 0 0032 32h352a32 32 0 0032-32V192a32 32 0 00-32-32h-59c-8.65 0-16.85-4.77-22.46-11.32z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "272",
                    "r": "80",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M124 158v-22h-24v22"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1c3172f7e6a1e5ba(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M350.54 148.68l-26.62-42.06C318.31 100.08 310.62 96 302 96h-92c-8.62 0-16.31 4.08-21.92 10.62l-26.62 42.06C155.85 155.23 148.62 160 140 160H80a32 32 0 00-32 32v192a32 32 0 0032 32h352a32 32 0 0032-32V192a32 32 0 00-32-32h-59c-8.65 0-16.85-4.77-22.46-11.32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M124 158v-22h-24v22m235.76 127.22v-13.31a80 80 0 00-131-61.6M176 258.78v13.31a80 80 0 00130.73 61.8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M196 272l-20-20-20 20m200 0l-20 20-20-20"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b30dac1198db6fa2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 144h-83c-3 0-6.72-1.94-9.62-5l-27.31-42.79C326 80 320 80 302 80h-92c-18 0-23 0-34.07 16.21L148.62 139c-2.22 2.42-5.34 5-8.62 5v-16a8 8 0 00-8-8H92a8 8 0 00-8 8v16H56a24 24 0 00-24 24v240a24 24 0 0024 24h400a24 24 0 0024-24V168a24 24 0 00-24-24zM256 368c-47.82 0-87.76-34.23-95-80h-43.63L176 229.37 234.63 288H194a64.07 64.07 0 00102.63 33.49L320 343l-3.68 3.72A96.64 96.64 0 01256 368zm80-53.84L277.11 256H318a64.26 64.26 0 00-103-33.36L192 200l3.14-2.45A96.19 96.19 0 01255.76 176c47.85 0 87 34.19 94.24 80h44.92z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b08f4f495cc8e4e5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a29a17d79410b27b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "272",
                    "r": "64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M456 144h-83c-3 0-6.72-1.94-9.62-5L336.1 96.2C325 80 320 80 302 80h-92c-18 0-24 0-34.07 16.21L148.62 139c-2.22 2.42-5.34 5-8.62 5v-16a8 8 0 00-8-8H92a8 8 0 00-8 8v16H56a24 24 0 00-24 24v240a24 24 0 0024 24h400a24 24 0 0024-24V168a24 24 0 00-24-24zM260.51 367.9a96 96 0 1191.39-91.39 96.11 96.11 0 01-91.39 91.39z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a9cb62b5ad43553b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "272",
                    "r": "64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fe3c82b122478b75(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 224l37.78-88.15C123.93 121.5 139.6 112 157.11 112h197.78c17.51 0 33.18 9.5 39.33 23.85L432 224m-352 0h352v144H80zm32 144v32H80v-32m352 0v32h-32v-32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "144",
                    "cy": "288",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "368",
                    "cy": "288",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$61b6e358bc217e3b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.68 220.78a16.44 16.44 0 00-1-3.1l-48-112A16 16 0 00384 96H128a16 16 0 00-14.71 9.7l-48 112a16.44 16.44 0 00-1 3.1A16.15 16.15 0 0064 224v184a8 8 0 008 8h32a8 8 0 008-8v-24h288v24a8 8 0 008 8h32a8 8 0 008-8V224a16.15 16.15 0 00-.32-3.22zM144 320a32 32 0 1132-32 32 32 0 01-32 32zm224 0a32 32 0 1132-32 32 32 0 01-32 32zM104.26 208l34.29-80h234.9l34.29 80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c7aa83a911e1e4a9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M469.71 234.6c-7.33-9.73-34.56-16.43-46.08-33.94s-20.95-55.43-50.27-70S288 112 256 112s-88 4-117.36 18.63-38.75 52.52-50.27 70-38.75 24.24-46.08 33.97S29.8 305.84 32.94 336s9 48 9 48h86c14.08 0 18.66-5.29 47.46-8 31.6-3 62.6-4 80.6-4s50 1 81.58 4c28.8 2.73 33.53 8 47.46 8h85s5.86-17.84 9-48-2.04-91.67-9.33-101.4zM400 384h56v16h-56zm-344 0h56v16H56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M364.47 309.16c-5.91-6.83-25.17-12.53-50.67-16.35S279 288 256.2 288s-33.17 1.64-57.61 4.81-42.79 8.81-50.66 16.35C136.12 320.6 153.42 333.44 167 335c13.16 1.5 39.47.95 89.31.95s76.15.55 89.31-.95c13.56-1.65 29.62-13.6 18.85-25.84zm67.1-66.11a3.23 3.23 0 00-3.1-3c-11.81-.42-23.8.42-45.07 6.69a93.88 93.88 0 00-30.08 15.06c-2.28 1.78-1.47 6.59 1.39 7.1a455.32 455.32 0 0052.82 3.1c10.59 0 21.52-3 23.55-12.44a52.41 52.41 0 00.49-16.51zm-351.14 0a3.23 3.23 0 013.1-3c11.81-.42 23.8.42 45.07 6.69a93.88 93.88 0 0130.08 15.06c2.28 1.78 1.47 6.59-1.39 7.1a455.32 455.32 0 01-52.82 3.1c-10.59 0-21.52-3-23.55-12.44a52.41 52.41 0 01-.49-16.51z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432 192h16m-384 0h16m-2 19s46.35-12 178-12 178 12 178 12"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1cf22e5c223b3c7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 224c-3-5-32.61-17.79-32.61-17.79 5.15-2.66 8.67-3.21 8.67-14.21 0-12-.06-16-8.06-16h-27.14c-.11-.24-.23-.49-.34-.74-17.52-38.26-19.87-47.93-46-60.95C347.47 96.88 281.76 96 256 96s-91.47.88-126.49 18.31c-26.16 13-25.51 19.69-46 60.95 0 .11-.21.4-.4.74H55.94c-7.94 0-8 4-8 16 0 11 3.52 11.55 8.67 14.21C56.61 206.21 28 220 24 224s-8 32-8 80 4 96 4 96h11.94c0 14 2.06 16 8.06 16h80c6 0 8-2 8-16h256c0 14 2 16 8 16h82c4 0 6-3 6-16h12s4-49 4-96-5-75-8-80zm-362.74 44.94A516.94 516.94 0 0170.42 272c-20.42 0-21.12 1.31-22.56-11.44a72.16 72.16 0 01.51-17.51L49 240h3c12 0 23.27.51 44.55 6.78a98 98 0 0130.09 15.06C131 265 132 268 132 268zm247.16 72L368 352H144s.39-.61-5-11.18c-4-7.82 1-12.82 8.91-15.66C163.23 319.64 208 304 256 304s93.66 13.48 108.5 21.16C370 328 376.83 330 372.42 341zm-257-136.53a96.23 96.23 0 01-9.7.07c2.61-4.64 4.06-9.81 6.61-15.21 8-17 17.15-36.24 33.44-44.35 23.54-11.72 72.33-17 110.23-17s86.69 5.24 110.23 17c16.29 8.11 25.4 27.36 33.44 44.35 2.57 5.45 4 10.66 6.68 15.33-2 .11-4.3 0-9.79-.19zm347.72 56.11C461 273 463 272 441.58 272a516.94 516.94 0 01-54.84-3.06c-2.85-.51-3.66-5.32-1.38-7.1a93.84 93.84 0 0130.09-15.06c21.28-6.27 33.26-7.11 45.09-6.69a3.22 3.22 0 013.09 3 70.18 70.18 0 01-.49 17.47z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$29c88f8930e8d7fa(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.26 276.22c-3.6-40.41-9.53-48.28-11.77-51.24-5.15-6.84-13.39-11.31-22.11-16a3.6 3.6 0 01-.91-5.68 15.93 15.93 0 004.53-12.53A16.27 16.27 0 00447.65 176h-15.6a17 17 0 00-2 .13 8.5 8.5 0 00-1.41-.47c-9.24-19.53-21.89-46.27-48.11-59.32C341.64 97 270 96 256 96s-85.64 1-124.48 20.31c-26.22 13.05-38.87 39.79-48.11 59.32l-.08.16a6.52 6.52 0 00-1.35.34 17 17 0 00-2-.13H64.35A16.27 16.27 0 0048 190.77a15.93 15.93 0 004.59 12.47 3.6 3.6 0 01-.91 5.68c-8.72 4.72-17 9.19-22.11 16-2.24 3-8.16 10.83-11.77 51.24-2 22.74-2.3 46.28-.73 61.44 3.29 31.5 9.46 50.54 9.72 51.33a16 16 0 0013.2 10.87v.2a16 16 0 0016 16h56a16 16 0 0016-16c8.61 0 14.6-1.54 20.95-3.18a158.83 158.83 0 0128-4.91C207.45 389 237.79 388 256 388c17.84 0 49.52 1 80.08 3.91a159.16 159.16 0 0128.11 4.93c6.08 1.56 11.85 3 19.84 3.15a16 16 0 0016 16h56a16 16 0 0016-16v-.12A16 16 0 00485.27 389c.26-.79 6.43-19.83 9.72-51.33 1.57-15.17 1.29-38.67-.73-61.45zm-381.93-86.91c8-17 17.15-36.24 33.44-44.35 23.54-11.72 72.33-17 110.23-17s86.69 5.24 110.23 17c16.29 8.11 25.4 27.36 33.44 44.35l1 2.17a8 8 0 01-7.44 11.42C360 202 290 199.12 256 199.12s-104 2.95-137.28 3.85a8 8 0 01-7.44-11.42c.35-.74.72-1.49 1.05-2.24zm11.93 79.63A427.17 427.17 0 0172.42 272c-10.6 0-21.53-3-23.56-12.44-1.39-6.35-1.24-9.92-.49-13.51C49 243 50 240.78 55 240c13-2 20.27.51 41.55 6.78 14.11 4.15 24.29 9.68 30.09 14.06 2.91 2.16 1.36 7.8-2.38 8.1zm221.38 82c-13.16 1.5-39.48.95-89.34.95s-76.17.55-89.33-.95c-13.58-1.51-30.89-14.35-19.07-25.79 7.87-7.54 26.23-13.18 50.68-16.35s34.8-4.8 57.62-4.8 32.12 1 57.62 4.81 44.77 9.52 50.68 16.35c10.78 12.24-5.29 24.19-18.86 25.84zm117.5-91.39c-2 9.48-13 12.44-23.56 12.44a455.91 455.91 0 01-52.84-3.06c-3.06-.29-4.48-5.66-1.38-8.1 5.71-4.49 16-9.91 30.09-14.06 21.28-6.27 33.55-8.78 44.09-6.69 2.57.51 3.93 3.27 4.09 5a40.64 40.64 0 01-.49 14.48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$78acfdd7825207e0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.68 220.78a16 16 0 00-1-3.08l-37.78-88.16C400.19 109.17 379 96 354.89 96H157.11c-24.09 0-45.3 13.17-54 33.54L65.29 217.7A15.72 15.72 0 0064 224v176a16 16 0 0016 16h32a16 16 0 0016-16v-16h256v16a16 16 0 0016 16h32a16 16 0 0016-16V224a16.15 16.15 0 00-.32-3.22zM144 320a32 32 0 1132-32 32 32 0 01-32 32zm224 0a32 32 0 1132-32 32 32 0 01-32 32zM104.26 208l28.23-65.85C136.11 133.69 146 128 157.11 128h197.78c11.1 0 21 5.69 24.62 14.15L407.74 208z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c73f0d2081540a4d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "320",
                    "x": "48",
                    "y": "96",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "56",
                    "ry": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "60",
                    "d": "M48 192h416M128 300h48v20h-48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e2f259147987c589(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 416a16 16 0 0016 16h416a16 16 0 0016-16V222H32zm66-138a8 8 0 018-8h92a8 8 0 018 8v64a8 8 0 01-8 8h-92a8 8 0 01-8-8zM464 80H48a16 16 0 00-16 16v66h448V96a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f5a49d4b85516ae6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 376a56 56 0 0056 56h336a56 56 0 0056-56V222H32zm66-76a30 30 0 0130-30h48a30 30 0 0130 30v20a30 30 0 01-30 30h-48a30 30 0 01-30-30zM424 80H88a56 56 0 00-56 56v26h448v-26a56 56 0 00-56-56z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$803d09530531488c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M273.77 169.57l-89.09 74.13a16 16 0 000 24.6l89.09 74.13A16 16 0 00300 330.14V181.86a16 16 0 00-26.23-12.29z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$41a373d9d6f5c80f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm252 108.27L169.91 256 300 147.73z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d21d4c1b5e89e5c7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm252-74.14v148.28a16 16 0 01-26.23 12.29l-89.09-74.13a16 16 0 010-24.6l89.09-74.13A16 16 0 01300 181.86z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$afd6df0b8bb9b8c2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M321.94 98L158.82 237.78a24 24 0 000 36.44L321.94 414c15.57 13.34 39.62 2.28 39.62-18.22v-279.6c0-20.5-24.05-31.56-39.62-18.18z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d4dd6a75f15f6250(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 64L144 256l224 192V64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$476b60a1c6385dd4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M321.94 98L158.82 237.78a24 24 0 000 36.44L321.94 414c15.57 13.34 39.62 2.28 39.62-18.22v-279.6c0-20.5-24.05-31.56-39.62-18.18z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$90556702763e53b0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.43 238.23l-74.13 89.09a16 16 0 01-24.6 0l-74.13-89.09A16 16 0 01181.86 212h148.28a16 16 0 0112.29 26.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d7636dc37c1058d0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-99.73-44L256 342.09 147.73 212z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7478b94237b20e7a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-121.57-17.77l-74.13 89.09a16 16 0 01-24.6 0l-74.13-89.09A16 16 0 01181.86 212h148.28a16 16 0 0112.29 26.23z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f22e9d8cb6ae502e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2a1b41d05c063c3b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 144l192 224 192-224H64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c6c19d9b543c1274(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$38e087be0aa31771(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M238.23 342.43l89.09-74.13a16 16 0 000-24.6l-89.09-74.13A16 16 0 00212 181.86v148.28a16 16 0 0026.23 12.29z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$12eaa8a0982113af(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zM212 147.73L342.09 256 212 364.27z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b02277a18a704883(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-252 74.14V181.86a16 16 0 0126.23-12.29l89.09 74.13a16 16 0 010 24.6l-89.09 74.13A16 16 0 01212 330.14z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$864333d3b6c1a577(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M190.06 414l163.12-139.78a24 24 0 000-36.44L190.06 98c-15.57-13.34-39.62-2.28-39.62 18.22v279.6c0 20.5 24.05 31.56 39.62 18.18z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$68084e0103870a8a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 448l224-192L144 64v384z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$542d91f89df9c782(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M190.06 414l163.12-139.78a24 24 0 000-36.44L190.06 98c-15.57-13.34-39.62-2.28-39.62 18.22v279.6c0 20.5 24.05 31.56 39.62 18.18z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$edf1cd62645f9f1d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.43 273.77l-74.13-89.09a16 16 0 00-24.6 0l-74.13 89.09A16 16 0 00181.86 300h148.28a16 16 0 0012.29-26.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e7df4b8da5adfed0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zM147.73 300L256 169.91 364.27 300z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$379ec15df5eb004f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm74.14 252H181.86a16 16 0 01-12.29-26.23l74.13-89.09a16 16 0 0124.6 0l74.13 89.09A16 16 0 01330.14 300z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$61a920307ccbd9b7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414 321.94L274.22 158.82a24 24 0 00-36.44 0L98 321.94c-13.34 15.57-2.28 39.62 18.22 39.62h279.6c20.5 0 31.56-24.05 18.18-39.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4b98110ee4a51bc3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 368L256 144 64 368h384z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a8726a64c68b4ad6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414 321.94L274.22 158.82a24 24 0 00-36.44 0L98 321.94c-13.34 15.57-2.28 39.62 18.22 39.62h279.6c20.5 0 31.56-24.05 18.18-39.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ea1103a8e1be0206(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "176",
                    "cy": "416",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "400",
                    "cy": "416",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 80h64l48 272h256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 288h249.44a8 8 0 007.85-6.43l28.8-144a8 8 0 00-7.85-9.57H128"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cc437151c16a257f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "176",
                    "cy": "416",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "400",
                    "cy": "416",
                    "r": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M167.78 304h261.34l38.4-192H133.89l-8.47-48H32v32h66.58l48 272H432v-32H173.42l-5.64-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$772d1f4622871739(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "176",
                    "cy": "416",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "400",
                    "cy": "416",
                    "r": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M456.8 120.78a23.92 23.92 0 00-18.56-8.78H133.89l-6.13-34.78A16 16 0 00112 64H48a16 16 0 000 32h50.58l45.66 258.78A16 16 0 00160 368h256a16 16 0 000-32H173.42l-5.64-32h241.66A24.07 24.07 0 00433 284.71l28.8-144a24 24 0 00-5-19.93z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2044fa0b2fc189ba(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "256",
                    "x": "32",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16",
                    "transform": "rotate(180 256 208)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 384h384M96 432h320"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "208",
                    "r": "80",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M480 160a80 80 0 01-80-80M32 160a80 80 0 0080-80m368 176a80 80 0 00-80 80M32 256a80 80 0 0180 80"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$873cc3dead2b7787(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 368h416v32H48zm32 48h352v32H80zm400-240a96.11 96.11 0 01-96-96V64H128v16a96.11 96.11 0 01-96 96H16v64h16a96.11 96.11 0 0196 96v16h256v-16a96.11 96.11 0 0196-96h16v-64zM256 304a96 96 0 1196-96 96.11 96.11 0 01-96 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M96 80V64H16v80h16a64.07 64.07 0 0064-64zM32 272H16v80h80v-16a64.07 64.07 0 00-64-64zm448-128h16V64h-80v16a64.07 64.07 0 0064 64zm-64 192v16h80v-80h-16a64.07 64.07 0 00-64 64z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "208",
                    "r": "64"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a9ea87010815bbe(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 400H64a16 16 0 010-32h384a16 16 0 010 32zm-32 48H96a16 16 0 010-32h320a16 16 0 010 32zM32 272H16v48a32 32 0 0032 32h48v-16a64.07 64.07 0 00-64-64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 240h16v-64h-16a96.11 96.11 0 01-96-96V64H128v16a96.11 96.11 0 01-96 96H16v64h16a96.11 96.11 0 0196 96v16h256v-16a96.11 96.11 0 0196-96zm-224 64a96 96 0 1196-96 96.11 96.11 0 01-96 96z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "208",
                    "r": "64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M416 336v16h48a32 32 0 0032-32v-48h-16a64.07 64.07 0 00-64 64zm64-192h16V96a32 32 0 00-32-32h-48v16a64.07 64.07 0 0064 64zM96 80V64H48a32 32 0 00-32 32v48h16a64.07 64.07 0 0064-64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d190acf57bf2be97(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "320",
                    "x": "416",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "240",
                    "x": "288",
                    "y": "176",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "176",
                    "x": "160",
                    "y": "240",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "112",
                    "x": "32",
                    "y": "304",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$25d265fb337d47a2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 432h-96V80h96zm-128 0h-96V160h96zm-128 0h-96V224h96zm-128 0H16V288h96z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3d50b0b96973274e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472 432h-48a24 24 0 01-24-24V104a24 24 0 0124-24h48a24 24 0 0124 24v304a24 24 0 01-24 24zm-128 0h-48a24 24 0 01-24-24V184a24 24 0 0124-24h48a24 24 0 0124 24v224a24 24 0 01-24 24zm-128 0h-48a24 24 0 01-24-24V248a24 24 0 0124-24h48a24 24 0 0124 24v160a24 24 0 01-24 24zm-128 0H40a24 24 0 01-24-24v-96a24 24 0 0124-24h48a24 24 0 0124 24v96a24 24 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f09c339e1eb37380(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M408 64H104a56.16 56.16 0 00-56 56v192a56.16 56.16 0 0056 56h40v80l93.72-78.14a8 8 0 015.13-1.86H408a56.16 56.16 0 0056-56V120a56.16 56.16 0 00-56-56z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "160",
                    "cy": "216",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "216",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "352",
                    "cy": "216",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a4402523c13f19c9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 48H56a24 24 0 00-24 24v288a24 24 0 0024 24h72v80l117.74-80H456a24 24 0 0024-24V72a24 24 0 00-24-24zM160 248a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zM456 80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3bfe18412aedbf0f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 48H104a72.08 72.08 0 00-72 72v192a72.08 72.08 0 0072 72h24v64a16 16 0 0026.25 12.29L245.74 384H408a72.08 72.08 0 0072-72V120a72.08 72.08 0 00-72-72zM160 248a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$277c3300e2ac7abf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M408 64H104a56.16 56.16 0 00-56 56v192a56.16 56.16 0 0056 56h40v80l93.72-78.14a8 8 0 015.13-1.86H408a56.16 56.16 0 0056-56V120a56.16 56.16 0 00-56-56z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$72bc909d1acb1909(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 464v-80H56a24 24 0 01-24-24V72a24 24 0 0124-24h400a24 24 0 0124 24v288a24 24 0 01-24 24H245.74zM456 80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ef2f98c217c86978(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 464a16 16 0 01-16-16v-64h-24a72.08 72.08 0 01-72-72V120a72.08 72.08 0 0172-72h304a72.08 72.08 0 0172 72v192a72.08 72.08 0 01-72 72H245.74l-91.49 76.29A16.05 16.05 0 01144 464z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$73c39577e37173c7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M87.48 380c1.2-4.38-1.43-10.47-3.94-14.86a42.63 42.63 0 00-2.54-3.8 199.81 199.81 0 01-33-110C47.64 139.09 140.72 48 255.82 48 356.2 48 440 117.54 459.57 209.85a199 199 0 014.43 41.64c0 112.41-89.49 204.93-204.59 204.93-18.31 0-43-4.6-56.47-8.37s-26.92-8.77-30.39-10.11a31.14 31.14 0 00-11.13-2.07 30.7 30.7 0 00-12.08 2.43L81.5 462.78a15.92 15.92 0 01-4.66 1.22 9.61 9.61 0 01-9.58-9.74 15.85 15.85 0 01.6-3.29z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "160",
                    "cy": "256",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "352",
                    "cy": "256",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$272c9a1e4fc483f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M475.22 206.52c-10.34-48.65-37.76-92.93-77.22-124.68A227.4 227.4 0 00255.82 32C194.9 32 138 55.47 95.46 98.09 54.35 139.33 31.82 193.78 32 251.37a215.66 215.66 0 0035.65 118.76l4.35 6.05L48 480l114.8-28.56s2.3.77 4 1.42 16.33 6.26 31.85 10.6c12.9 3.6 39.74 9 60.77 9 59.65 0 115.35-23.1 156.83-65.06C457.36 365.77 480 310.42 480 251.49a213.5 213.5 0 00-4.78-44.97zM160 288a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$120678b0a0761247(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398 81.84A227.4 227.4 0 00255.82 32C194.9 32 138 55.47 95.46 98.09 54.35 139.33 31.82 193.78 32 251.37a215.66 215.66 0 0035.65 118.76l.19.27c.28.41.57.82.86 1.22s.65.92.73 1.05l.22.4c1.13 2 2 4.44 1.23 6.9l-18.42 66.66a29.13 29.13 0 00-1.2 7.63A25.69 25.69 0 0076.83 480a29.44 29.44 0 0010.45-2.29l67.49-24.36.85-.33a14.75 14.75 0 015.8-1.15 15.12 15.12 0 015.37 1c1.62.63 16.33 6.26 31.85 10.6 12.9 3.6 39.74 9 60.77 9 59.65 0 115.35-23.1 156.83-65.06C457.36 365.77 480 310.42 480 251.49a213.5 213.5 0 00-4.78-45c-10.34-48.62-37.76-92.9-77.22-124.65zM87.48 380zM160 288a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c5e731b0b246568a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M87.49 380c1.19-4.38-1.44-10.47-3.95-14.86a44.86 44.86 0 00-2.54-3.8 199.81 199.81 0 01-33-110C47.65 139.09 140.73 48 255.83 48 356.21 48 440 117.54 459.58 209.85a199 199 0 014.42 41.64c0 112.41-89.49 204.93-204.59 204.93-18.3 0-43-4.6-56.47-8.37s-26.92-8.77-30.39-10.11a31.09 31.09 0 00-11.12-2.07 30.71 30.71 0 00-12.09 2.43l-67.83 24.48a16 16 0 01-4.67 1.22 9.6 9.6 0 01-9.57-9.74 15.85 15.85 0 01.6-3.29z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b8e4cbb687021e4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M475.22 206.52c-10.34-48.65-37.76-92.93-77.22-124.68A227.4 227.4 0 00255.82 32C194.9 32 138 55.47 95.46 98.09 54.35 139.33 31.82 193.78 32 251.37a215.66 215.66 0 0035.65 118.76l4.35 6.05L48 480l114.8-28.56s2.3.77 4 1.42 16.33 6.26 31.85 10.6c12.9 3.6 39.74 9 60.77 9 59.65 0 115.35-23.1 156.83-65.06C457.36 365.77 480 310.42 480 251.49a213.5 213.5 0 00-4.78-44.97z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d2eec39ca39232a6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M76.83 480a25.69 25.69 0 01-25.57-25.74 29.13 29.13 0 011.2-7.63L70.88 380c.77-2.46-.1-4.94-1.23-6.9l-.22-.4c-.08-.13-.46-.66-.73-1.05s-.58-.81-.86-1.22l-.19-.27A215.66 215.66 0 0132 251.37c-.18-57.59 22.35-112 63.46-153.28C138 55.47 194.9 32 255.82 32A227.4 227.4 0 01398 81.84c39.45 31.75 66.87 76 77.21 124.68a213.5 213.5 0 014.78 45c0 58.93-22.64 114.28-63.76 155.87-41.48 42-97.18 65.06-156.83 65.06-21 0-47.87-5.36-60.77-9-15.52-4.34-30.23-10-31.85-10.6a15.12 15.12 0 00-5.37-1 14.75 14.75 0 00-5.8 1.15l-.85.33-67.48 24.38A29.44 29.44 0 0176.83 480zm-2-31.8zM87.48 380z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8a986d788e3f5efc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M431 320.6c-1-3.6 1.2-8.6 3.3-12.2a33.68 33.68 0 012.1-3.1A162 162 0 00464 215c.3-92.2-77.5-167-173.7-167-83.9 0-153.9 57.1-170.3 132.9a160.7 160.7 0 00-3.7 34.2c0 92.3 74.8 169.1 171 169.1 15.3 0 35.9-4.6 47.2-7.7s22.5-7.2 25.4-8.3a26.44 26.44 0 019.3-1.7 26 26 0 0110.1 2l56.7 20.1a13.52 13.52 0 003.9 1 8 8 0 008-8 12.85 12.85 0 00-.5-2.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M66.46 232a146.23 146.23 0 006.39 152.67c2.31 3.49 3.61 6.19 3.21 8s-11.93 61.87-11.93 61.87a8 8 0 002.71 7.68A8.17 8.17 0 0072 464a7.26 7.26 0 002.91-.6l56.21-22a15.7 15.7 0 0112 .2c18.94 7.38 39.88 12 60.83 12A159.21 159.21 0 00284 432.11"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7ec6039638fd25f6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 312.43c.77-1.11 1.51-2.26 2.27-3.34A174.55 174.55 0 00480 211.85C480.32 112.55 396.54 32 292.94 32c-90.36 0-165.74 61.49-183.4 143.12a172.81 172.81 0 00-4 36.83c0 99.4 80.56 182.11 184.16 182.11 16.47 0 38.66-4.95 50.83-8.29s24.23-7.75 27.35-8.94 8-2.41 11.89-1.29l77.42 22.38a4 4 0 005-4.86l-17.72-67.49c-1.23-5-1.39-5.94 3.53-13.14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M312.54 415.38a165.32 165.32 0 01-23.26 2.05c-42.43 0-82.5-11.2-115-32.2a184.09 184.09 0 01-53.09-49.32c-26.08-34.57-40.3-78.51-40.3-124.49 0-3.13.11-6.14.22-9.16a4.34 4.34 0 00-7.54-3.12 158.76 158.76 0 00-14.86 195.24c2.47 3.77 3.87 6.68 3.44 8.62l-14.09 72.26a4 4 0 005.22 4.53l68-24.24a16.85 16.85 0 0112.92.22c20.35 8 42.86 12.92 65.37 12.92a169.45 169.45 0 00116.63-46 4.29 4.29 0 00-3.66-7.31z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b1d025bf00fff260(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M60.44 389.17c0 .07 0 .2-.08.38.03-.12.05-.25.08-.38zM439.9 405.6a26.77 26.77 0 01-9.59-2l-56.78-20.13-.42-.17a9.88 9.88 0 00-3.91-.76 10.32 10.32 0 00-3.62.66c-1.38.52-13.81 5.19-26.85 8.77-7.07 1.94-31.68 8.27-51.43 8.27-50.48 0-97.68-19.4-132.89-54.63A183.38 183.38 0 01100.3 215.1a175.9 175.9 0 014.06-37.58c8.79-40.62 32.07-77.57 65.55-104A194.76 194.76 0 01290.3 32c52.21 0 100.86 20 137 56.18 34.16 34.27 52.88 79.33 52.73 126.87a177.86 177.86 0 01-30.3 99.15l-.19.28-.74 1c-.17.23-.34.45-.5.68l-.15.27a21.63 21.63 0 00-1.08 2.09l15.74 55.94a26.42 26.42 0 011.12 7.11 24 24 0 01-24.03 24.03z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M299.87 425.39a15.74 15.74 0 00-10.29-8.1c-5.78-1.53-12.52-1.27-17.67-1.65a201.78 201.78 0 01-128.82-58.75A199.21 199.21 0 0186.4 244.16C85 234.42 85 232 85 232a16 16 0 00-28-10.58s-7.88 8.58-11.6 17.19a162.09 162.09 0 0011 150.06C59 393 59 395 58.42 399.5c-2.73 14.11-7.51 39-10 51.91a24 24 0 008 22.92l.46.39A24.34 24.34 0 0072 480a23.42 23.42 0 009-1.79l53.51-20.65a8.05 8.05 0 015.72 0c21.07 7.84 43 12 63.78 12a176 176 0 0074.91-16.66c5.46-2.56 14-5.34 19-11.12a15 15 0 001.95-16.39z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9c723a20d8b59f5b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 176L217.6 336 160 272"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "384",
                    "height": "384",
                    "x": "64",
                    "y": "64",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$67601456551529cd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 48v416h416V48zm170 312.38l-80.6-89.57 23.79-21.41 56 62.22L350 153.46 374.54 174z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e8f1a2599bf14b8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 48H112a64.07 64.07 0 00-64 64v288a64.07 64.07 0 0064 64h288a64.07 64.07 0 0064-64V112a64.07 64.07 0 00-64-64zm-35.75 138.29l-134.4 160a16 16 0 01-12 5.71h-.27a16 16 0 01-11.89-5.3l-57.6-64a16 16 0 1123.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0124.5 20.58z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e9c1bc00eb8b784d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 176L217.6 336 160 272"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4efaabe23108b4ac(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-38 312.38l-80.6-89.57 23.79-21.41 56 62.22L350 153.46 374.54 174z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cd21c487a3528d0b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm108.25 138.29l-134.4 160a16 16 0 01-12 5.71h-.27a16 16 0 01-11.89-5.3l-57.6-64a16 16 0 1123.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0124.5 20.58z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5c87c47ba2da673a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 192L256.13 320l-47.95-48m-16.23 48L144 272m161.71-80l-51.55 59"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1ccd986f215017fc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm48.19 121.42l24.1 21.06-73.61 84.1-24.1-23.06zM191.93 342.63L121.37 272 144 249.37 214.57 320zm65 .79L185.55 272l22.64-22.62 47.16 47.21 111.13-127.17 24.1 21.06z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$699cef5fff5d5ba4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zm-16.79 192.47l51.55-59a16 16 0 0124.1 21.06l-51.55 59a16 16 0 11-24.1-21.06zm-38.86 90.85a16 16 0 01-22.62 0l-47.95-48a16 16 0 1122.64-22.62l48 48a16 16 0 01-.07 22.62zm176.8-128.79l-111.88 128a16 16 0 01-11.51 5.47h-.54a16 16 0 01-11.32-4.69l-47.94-48a16 16 0 1122.64-22.62l29.8 29.83a8 8 0 0011.68-.39l95-108.66a16 16 0 0124.1 21.06z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7716de5b221ef208(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M464 128L240 384l-96-96m0 96l-96-96m320-160L232 284"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cb7c1ada48f8c589(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "44",
                    "d": "M465 127L241 384l-92-92m-9 93l-93-93m316-165L236 273"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$87a5731fa85fe509(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M464 128L240 384l-96-96m0 96l-96-96m320-160L232 284"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1c1c61bcc7fdd85(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 128L192 384l-96-96"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$94ec96ab9564bea(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "44",
                    "d": "M416 128L192 384l-96-96"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$960b87127440bfb6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 128L192 384l-96-96"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5659b4096ca9e345(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M296 352l-96-96 96-96"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2fb648d507fadbc6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm62.63 304L296 374.63 177.37 256 296 137.37 318.63 160l-96 96z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$24b03935e009fe04(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm35.31 292.69a16 16 0 11-22.62 22.62l-96-96a16 16 0 010-22.62l96-96a16 16 0 0122.62 22.62L206.63 256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$27006c9e10bfef71(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M328 112L184 256l144 144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$251bffc1f4d95321(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M328 112L184 256l144 144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e8049e47e0dea956(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M328 112L184 256l144 144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$44bbd65ea71a3a1d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 216l-96 96-96-96"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c460576fa3d9fcb4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c114.87 0 208-93.13 208-208S370.87 48 256 48 48 141.13 48 256s93.13 208 208 208zm-96-270.63l96 96 96-96L374.63 216 256 334.63 137.37 216z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8d9ae1b52e70c501(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-100.69-28.69l-96 96a16 16 0 01-22.62 0l-96-96a16 16 0 0122.62-22.62L256 289.37l84.69-84.68a16 16 0 0122.62 22.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7f28bde9b3a42d31(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 184l144 144 144-144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a99177a32349187f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M112 184l144 144 144-144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$20aa59f5b423ddcb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 184l144 144 144-144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$44c5e7a963bc0c9e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 256c0 106 86 192 192 192s192-86 192-192S362 64 256 64 64 150 64 256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M216 352l96-96-96-96"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ddae3d7d29c90949(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm-40 326.63L193.37 352l96-96-96-96L216 137.37 334.63 256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$89fe54d9fdd0d97f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm257.37 0l-84.68-84.69a16 16 0 0122.62-22.62l96 96a16 16 0 010 22.62l-96 96a16 16 0 01-22.62-22.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4af16e87743b95c4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M184 112l144 144-144 144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$30ba74185c52cf3c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M184 112l144 144-144 144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fca8d8deb3480642(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M184 112l144 144-144 144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2b1c24d9b8138857(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 296l-96-96-96 96"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9ef61d297bb073af(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm96 270.63l-96-96-96 96L137.37 296 256 177.37 374.63 296z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3e7cd0ad2e24574(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm107.31 259.31a16 16 0 01-22.62 0L256 222.63l-84.69 84.68a16 16 0 01-22.62-22.62l96-96a16 16 0 0122.62 0l96 96a16 16 0 010 22.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f6629c9f31f9cc0e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 328l144-144 144 144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a5065777fe929981(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M112 328l144-144 144 144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$99a0f5997881ff17(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 328l144-144 144 144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$151f847384b20b36(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 64h32a48 48 0 0148 48v320a48 48 0 01-48 48H144a48 48 0 01-48-48V112a48 48 0 0148-48h32"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "160",
                    "height": "64",
                    "x": "176",
                    "y": "32",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "26.13",
                    "ry": "26.13"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f7cd6e5bb2b52058(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420 48h-68V28a12 12 0 00-12-12H172a12 12 0 00-12 12v20H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V60a12 12 0 00-12-12zm-84.13 64H176.13V80h159.74z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ee48b36c3373cde8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 48h-11.41a8 8 0 01-7.44-5.08A42.18 42.18 0 00309.87 16H202.13a42.18 42.18 0 00-39.28 26.92 8 8 0 01-7.44 5.08H144a64 64 0 00-64 64v320a64 64 0 0064 64h224a64 64 0 0064-64V112a64 64 0 00-64-64zm-48.13 64H192.13a16 16 0 010-32h127.74a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b1951cf5aba47799(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 320L192 192m0 128l128-128"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6f7dfb8edd04ffa7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm86.63 272L320 342.63l-64-64-64 64L169.37 320l64-64-64-64L192 169.37l64 64 64-64L342.63 192l-64 64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1a64b002753c9b1c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm75.31 260.69a16 16 0 11-22.62 22.62L256 278.63l-52.69 52.68a16 16 0 01-22.62-22.62L233.37 256l-52.68-52.69a16 16 0 0122.62-22.62L256 233.37l52.69-52.68a16 16 0 0122.62 22.62L278.63 256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e6b0c805fe1b1179(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 368L144 144m224 0L144 368"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$23180857b406be26(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 145.49L366.51 112 256 222.51 145.49 112 112 145.49 222.51 256 112 366.51 145.49 400 256 289.49 366.51 400 400 366.51 289.49 256 400 145.49z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$dafa347972e06fa8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1ad402c5f12713ca(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.88 240.59a8 8 0 01-6.66-6.66C320.68 192.78 290.82 168 256 168c-32.37 0-53.93 21.22-62.48 43.58a7.92 7.92 0 01-6.16 5c-27.67 4.35-50.82 22.56-51.35 54.3-.52 31.53 25.51 57.11 57 57.11H326c27.5 0 50-13.72 50-44 0-27.22-22-40.41-42.12-43.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$de68ac32c3a70c62(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm70 280H196c-33 0-60-23-60-56 0-34.21 26-53 56-56 7.28-23.9 29.5-48 64-48 36.5 0 67.55 27.23 72 72 21.49 1.12 48 14.09 48 44 0 30.28-22.5 44-50 44z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b5de6e4eca42c42d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm70 280H193.05c-31.53 0-57.56-25.58-57-57.11.53-31.74 23.68-49.95 51.35-54.3a7.92 7.92 0 006.16-5C202.07 189.22 223.63 168 256 168c33.17 0 61.85 22.49 70.14 60.21a17.75 17.75 0 0013.18 13.43C357.79 246.05 376 259.21 376 284c0 30.28-22.5 44-50 44z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$56a51470e7583bbe(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 240c-8.89-89.54-71-144-144-144-69 0-113.44 48.2-128 96-60 6-112 43.59-112 112 0 66 54 112 120 112h260c55 0 100-27.44 100-88 0-59.82-53-85.76-96-88z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M317 208L209.2 336 163 284.8"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$78128f7c9809d83c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.25 225.36c-6.52-41.18-24.05-76.4-51.11-102.46A153.57 153.57 0 00256 80c-35.5 0-68.24 11.69-94.68 33.8a156.42 156.42 0 00-45.22 63.61c-30.26 4.81-57.45 17.18-77.38 35.37C13.39 235.88 0 267.42 0 304c0 36 14.38 68.88 40.49 92.59C65.64 419.43 99.56 432 136 432h260c32.37 0 60.23-8.57 80.59-24.77C499.76 388.78 512 361.39 512 328c0-61.85-48.44-95.34-97.75-102.64zm-204.63 135l-69.22-76.7 23.76-21.44 44.62 49.46 106.29-126.2 24.47 20.61z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$303f00edb300aa39(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.44 227.25a16 16 0 01-12.12-12.39c-7.68-36.68-24.45-68.15-49.18-92A153.57 153.57 0 00256 80c-35.5 0-68.24 11.69-94.68 33.8a156.24 156.24 0 00-42 56 16 16 0 01-11.37 9.15c-27 5.62-51.07 17.34-69.18 33.87C13.39 235.88 0 267.42 0 304c0 36 14.38 68.88 40.49 92.59C65.64 419.43 99.56 432 136 432h260c32.37 0 60.23-8.57 80.59-24.77C499.76 388.78 512 361.39 512 328c0-57.57-42-90.58-87.56-100.75zm-95.2-8.94l-107.8 128a16 16 0 01-12 5.69h-.27a16 16 0 01-11.88-5.28l-45.9-50.87c-5.77-6.39-5.82-16.33.3-22.4a16 16 0 0123.16.63l33.9 37.58 96-114a16 16 0 1124.48 20.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8370c346a96b4d30(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 336h76c55 0 100-21.21 100-75.6s-53-73.47-96-75.6C391.11 99.74 329 48 256 48c-69 0-113.44 45.79-128 91.2-60 5.7-112 35.88-112 98.4S70 336 136 336h56m0 64.1l64 63.9 64-63.9M256 224v224.03"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e4f8c5f61fb7b240(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.7 189.5c-15.76-10-36.21-16.79-58.59-19.54-6.65-39.1-24.22-72.52-51.27-97.26C334.15 46.45 296.21 32 256 32c-35.35 0-68 11.08-94.37 32a149.7 149.7 0 00-45.29 60.42c-30.67 4.32-57 14.61-76.71 30C13.7 174.83 0 203.56 0 237.6 0 305 55.92 352 136 352h104V208h32v144h124c72.64 0 116-34.24 116-91.6 0-30.05-13.59-54.57-39.3-70.9zM240 419.42L191.98 371l-22.61 23L256 480l86.63-86-22.61-23L272 419.42V352h-32v67.42z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$750bd0b931b0f9ac(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.7 189.5c-13.26-8.43-29.83-14.56-48.08-17.93A16 16 0 01412 159.28c-7.86-34.51-24.6-64.13-49.15-86.58C334.15 46.45 296.21 32 256 32c-35.35 0-68 11.08-94.37 32a150.13 150.13 0 00-41.95 52.83A16.05 16.05 0 01108 125.8c-27.13 4.9-50.53 14.68-68.41 28.7C13.7 174.83 0 203.56 0 237.6 0 305 55.93 352 136 352h104V224.45c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 224v128h124c72.64 0 116-34.24 116-91.6 0-30.05-13.59-54.57-39.3-70.9zM240 425.42l-36.7-36.64a16 16 0 00-22.6 22.65l64 63.89a16 16 0 0022.6 0l64-63.89a16 16 0 00-22.6-22.65L272 425.42V352h-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7ae983db11fa8dda(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M93.72 183.25C49.49 198.05 16 233.1 16 288c0 66 54 112 120 112h184.37m147.45-22.26C485.24 363.3 496 341.61 496 312c0-59.82-53-85.76-96-88-8.89-89.54-71-144-144-144-26.16 0-48.79 6.93-67.6 18.14"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 448L64 64"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$471bf28499b4eaf1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41.37 64l22.628-22.628L470.627 448l-22.628 22.627zm-2.65 148.78C13.39 235.88 0 267.42 0 304c0 36 14.38 68.88 40.49 92.59C65.64 419.43 99.56 432 136 432h228.12L110.51 178.39c-28.01 5.39-53.09 17.33-71.79 34.39zm437.87 194.45C499.76 388.78 512 361.39 512 328c0-61.85-48.44-95.34-97.75-102.64-6.52-41.18-24.05-76.4-51.11-102.46A153.57 153.57 0 00256 80c-30.47 0-58.9 8.62-83.07 25l302.82 302.86c.25-.21.57-.41.84-.63z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$976799650a741acb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 464a15.92 15.92 0 01-11.31-4.69l-384-384a16 16 0 0122.62-22.62l384 384A16 16 0 01448 464zM38.72 196.78C13.39 219.88 0 251.42 0 288c0 36 14.38 68.88 40.49 92.59C65.64 403.43 99.56 416 136 416h192.8a8 8 0 005.66-13.66L100.88 168.76a8 8 0 00-8-2C72 173.15 53.4 183.38 38.72 196.78zm437.87 194.45C499.76 372.78 512 345.39 512 312c0-57.57-42-90.58-87.56-100.75a16 16 0 01-12.12-12.39c-7.68-36.68-24.45-68.15-49.18-92A153.57 153.57 0 00256 64c-31.12 0-60.12 9-84.62 26.1a8 8 0 00-1.14 12.26L461.68 393.8a8 8 0 0010.2.93q2.43-1.68 4.71-3.5z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c7101e0586c38872(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 240c-8.89-89.54-71-144-144-144-69 0-113.44 48.2-128 96-60 6-112 43.59-112 112 0 66 54 112 120 112h260c55 0 100-27.44 100-88 0-59.82-53-85.76-96-88z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5d3fb199f9886189(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396 432H136c-36.44 0-70.36-12.57-95.51-35.41C14.38 372.88 0 340 0 304c0-36.58 13.39-68.12 38.72-91.22 19.93-18.19 47.12-30.56 77.38-35.37a156.42 156.42 0 0145.22-63.61C187.76 91.69 220.5 80 256 80a153.57 153.57 0 01107.14 42.9c27.06 26.06 44.59 61.28 51.11 102.46C463.56 232.66 512 266.15 512 328c0 33.39-12.24 60.78-35.41 79.23C456.23 423.43 428.37 432 396 432z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$145c97157946f62(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 255.79l-64-64-64 64m64 192.42V207.79"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$85151f5d9e2a5927(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M473.66 210c-16.56-12.3-37.7-20.75-59.52-24-6.62-39.18-24.21-72.67-51.3-97.45-28.69-26.3-66.63-40.76-106.84-40.76-35.35 0-68 11.08-94.37 32.05a149.61 149.61 0 00-45.32 60.49c-29.94 4.6-57.12 16.68-77.39 34.55C13.46 197.33 0 227.24 0 261.39c0 34.52 14.49 66 40.79 88.76 25.12 21.69 58.94 33.64 95.21 33.64h104V230.42l-48 48-22.63-22.63L256 169.17l86.63 86.62L320 278.42l-48-48v153.37h124c31.34 0 59.91-8.8 80.45-24.77 23.26-18.1 35.55-44 35.55-74.83 0-29.94-13.26-55.61-38.34-74.19zM240 383.79h32v80.41h-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9090997ac1b5cb46(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M473.66 210c-14-10.38-31.2-18-49.36-22.11a16.11 16.11 0 01-12.19-12.22c-7.8-34.75-24.59-64.55-49.27-87.13C334.15 62.25 296.21 47.79 256 47.79c-35.35 0-68 11.08-94.37 32.05a150.07 150.07 0 00-42.06 53 16 16 0 01-11.31 8.87c-26.75 5.4-50.9 16.87-69.34 33.12C13.46 197.33 0 227.24 0 261.39c0 34.52 14.49 66 40.79 88.76 25.12 21.69 58.94 33.64 95.21 33.64h104V230.42l-36.69 36.69a16 16 0 01-23.16-.56c-5.8-6.37-5.24-16.3.85-22.39l63.69-63.68a16 16 0 0122.62 0L331 244.14c6.28 6.29 6.64 16.6.39 22.91a16 16 0 01-22.68.06L272 230.42v153.37h124c31.34 0 59.91-8.8 80.45-24.77 23.26-18.1 35.55-44 35.55-74.83 0-29.94-13.26-55.61-38.34-74.19zM240 448.21a16 16 0 1032 0v-64.42h-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9ef13710cd6471b3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396 432H136c-36.44 0-70.36-12.57-95.51-35.41C14.38 372.88 0 340 0 304c0-36.58 13.39-68.12 38.72-91.22 18.11-16.53 42.22-28.25 69.18-33.87a16 16 0 0011.37-9.15 156.24 156.24 0 0142.05-56C187.76 91.69 220.5 80 256 80a153.57 153.57 0 01107.14 42.9c24.73 23.81 41.5 55.28 49.18 92a16 16 0 0012.12 12.39C470 237.42 512 270.43 512 328c0 33.39-12.24 60.78-35.41 79.23C456.23 423.43 428.37 432 396 432z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ed172ba1d7640bae(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M388.31 272c47.75 0 89.77-27.77 107.69-68.92-14.21 6.18-30.9 8.61-47.38 8.61A116.31 116.31 0 01332.31 95.38c0-16.48 2.43-33.17 8.61-47.38C299.77 65.92 272 107.94 272 155.69a116.31 116.31 0 003.44 28.18"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M90.61 306.85A16.07 16.07 0 00104 293.6C116.09 220.17 169.63 176 232 176c57.93 0 96.62 37.75 112.2 77.74a15.84 15.84 0 0012.2 9.87c50 8.15 91.6 41.54 91.6 99.59 0 59.4-48.6 100.8-108 100.8H106c-49.5 0-90-24.7-90-79.2 0-48.47 38.67-72.22 74.61-77.95z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b107b33fe2ebd751(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340 480H106c-29.5 0-54.92-7.83-73.53-22.64C11.23 440.44 0 415.35 0 384.8c0-29.44 12.09-54.25 35-71.74 14.55-11.13 33.41-18.87 53.2-22 6.06-36.92 21.92-68.53 46.29-92A139.82 139.82 0 01232 160c32.33 0 62.15 10.65 86.24 30.79a142.41 142.41 0 0140.83 57.05c27.18 4.48 51.59 15.68 69.56 32.08C451.77 301 464 329.82 464 363.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm41.55-260.07c26.5 6.93 50 19.32 68.65 36.34q3.89 3.56 7.47 7.34c25.41-18.4 45.47-44.92 54.33-71.38-16.24 7.07-35.31 9.85-54.15 9.85-73.42 0-115.93-42.51-115.93-115.93 0-18.84 2.78-37.91 9.85-54.15-40.41 13.53-81 53.19-92.52 98.13a162.61 162.61 0 0179.52 36.12 173 173 0 0142.78 53.68z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d36c062603ff1539(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340 480H106c-29.5 0-54.92-7.83-73.53-22.64C11.23 440.44 0 415.35 0 384.8c0-29.44 12.09-54.25 35-71.74 12.1-9.26 27.2-16.17 43.33-20.05a16 16 0 0011.81-12.21c7.15-32.54 22.25-60.49 44.33-81.75A139.82 139.82 0 01232 160c32.33 0 62.15 10.65 86.24 30.79a142.22 142.22 0 0137.65 49.54 16.06 16.06 0 0011.12 9c24 5.22 45.42 15.78 61.62 30.56C451.77 301 464 329.82 464 363.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm170.53-270.21a16.34 16.34 0 00-1.35-15.8 16 16 0 00-19.57-5.58c-10.7 4.65-24.48 7.17-39.92 7.28-55.3.4-101.38-45-101.38-100.31 0-15.75 2.48-29.84 7.18-40.76a16.3 16.3 0 00-1.85-16.33 16 16 0 00-19.1-5c-38.63 16.82-66.18 51.51-75.27 92.54a4 4 0 003.19 4.79 162.54 162.54 0 0176.31 35.59 172.58 172.58 0 0139.64 47.84 16.35 16.35 0 009.54 7.64c23.89 7.17 45.1 18.9 62.25 34.54q4.44 4.07 8.48 8.42a4 4 0 005.16.57 129.12 129.12 0 0046.69-55.43z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$328e53d424da9118(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M100.18 241.19a15.93 15.93 0 0013.37-13.25C126.6 145.59 186.34 96 256 96c64.69 0 107.79 42.36 124.92 87a16.11 16.11 0 0012.53 10.18C449.36 202.06 496 239.21 496 304c0 66-54 112-120 112H116c-55 0-100-27.44-100-88 0-54.43 43.89-80.81 84.18-86.81z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4d63ca1287dbbfbb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376 432H116c-32.37 0-60.23-8.57-80.59-24.77C12.24 388.78 0 361.39 0 328c0-61.85 48.44-95.34 97.75-102.64 6.52-41.18 24-76.4 51.11-102.46A153.57 153.57 0 01256 80c35.5 0 68.24 11.69 94.68 33.8a156.42 156.42 0 0145.22 63.61c30.26 4.81 57.45 17.18 77.38 35.36C498.61 235.88 512 267.42 512 304c0 36-14.38 68.88-40.49 92.59C446.36 419.43 412.44 432 376 432z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d0148728fcc04871(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376 432H116c-32.37 0-60.23-8.57-80.59-24.77C12.24 388.78 0 361.39 0 328c0-57.57 42-90.58 87.56-100.75a16 16 0 0012.12-12.39c7.68-36.68 24.45-68.15 49.18-92A153.57 153.57 0 01256 80c35.5 0 68.24 11.69 94.68 33.8a156.24 156.24 0 0142.05 56 16 16 0 0011.37 9.16c27 5.61 51.07 17.33 69.18 33.85C498.61 235.88 512 267.42 512 304c0 36-14.38 68.88-40.49 92.59C446.36 419.43 412.44 432 376 432z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7e199aea94d93041(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112M192 288.1l64 63.9 64-63.9M256 160v176.03"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3259a1e710116afa(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "42",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112M192 288.1l64 63.9 64-63.9M256 160v176.03"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$66930f270498b9e0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "42",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112M192 288.1l64 63.9 64-63.9M256 160v176.03"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$def3e1518c5da583(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e02219ba50be971d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M161.98 397.63L0 256l161.98-141.63 27.65 31.61L64 256l125.63 110.02-27.65 31.61zm188.04 0l-27.65-31.61L448 256 322.37 145.98l27.65-31.61L512 256 350.02 397.63z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$428f7538b23b0cc2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112m-48-48l-96 320"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d1fb91e535386e56(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M161.98 397.63L0 256l161.98-141.63 27.65 31.61L64 256l125.63 110.02-27.65 31.61zm188.04 0l-27.65-31.61L448 256 322.37 145.98l27.65-31.61L512 256 350.02 397.63zM222.15 442L182 430.08 289.85 70 330 81.92 222.15 442z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$378ff50d7345ef0c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 389a20.91 20.91 0 01-13.82-5.2l-128-112a21 21 0 010-31.6l128-112a21 21 0 0127.66 31.61L63.89 256l109.94 96.19A21 21 0 01160 389zm192 0a21 21 0 01-13.84-36.81L448.11 256l-109.94-96.19a21 21 0 0127.66-31.61l128 112a21 21 0 010 31.6l-128 112A20.89 20.89 0 01352 389zm-144 48a21 21 0 01-20.12-27l96-320a21 21 0 1140.23 12l-96 320A21 21 0 01208 437z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c9a0715035381ea3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "346",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "166",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e2ef9e6037f68710(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "26",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "346",
                    "cy": "256",
                    "r": "26",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "166",
                    "cy": "256",
                    "r": "26",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "42",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a64413cdeafc2ebc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "26",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "346",
                    "cy": "256",
                    "r": "26",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "166",
                    "cy": "256",
                    "r": "26",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "42",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2ae67f9d643b8d92(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 389a20.91 20.91 0 01-13.82-5.2l-128-112a21 21 0 010-31.6l128-112a21 21 0 0127.66 31.61L63.89 256l109.94 96.19A21 21 0 01160 389zm192 0a21 21 0 01-13.84-36.81L448.11 256l-109.94-96.19a21 21 0 0127.66-31.61l128 112a21 21 0 010 31.6l-128 112A20.89 20.89 0 01352 389z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7fcebdf17ded4678(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456.7 242.27l-26.08-4.2a8 8 0 01-6.6-6.82c-.5-3.2-1-6.41-1.7-9.51a8.08 8.08 0 013.9-8.62l23.09-12.82a8.05 8.05 0 003.9-9.92l-4-11a7.94 7.94 0 00-9.4-5l-25.89 5a8 8 0 01-8.59-4.11q-2.25-4.2-4.8-8.41a8.16 8.16 0 01.7-9.52l17.29-19.94a8 8 0 00.3-10.62l-7.49-9a7.88 7.88 0 00-10.5-1.51l-22.69 13.63a8 8 0 01-9.39-.9c-2.4-2.11-4.9-4.21-7.4-6.22a8 8 0 01-2.5-9.11l9.4-24.75A8 8 0 00365 78.77l-10.2-5.91a8 8 0 00-10.39 2.21l-16.64 20.84a7.15 7.15 0 01-8.5 2.5s-5.6-2.3-9.8-3.71A8 8 0 01304 87l.4-26.45a8.07 8.07 0 00-6.6-8.42l-11.59-2a8.07 8.07 0 00-9.1 5.61l-8.6 25.05a8 8 0 01-7.79 5.41h-9.8a8.07 8.07 0 01-7.79-5.41l-8.6-25.05a8.07 8.07 0 00-9.1-5.61l-11.59 2a8.07 8.07 0 00-6.6 8.42l.4 26.45a8 8 0 01-5.49 7.71c-2.3.9-7.3 2.81-9.7 3.71-2.8 1-6.1.2-8.8-2.91l-16.51-20.34A8 8 0 00156.75 73l-10.2 5.91a7.94 7.94 0 00-3.3 10.09l9.4 24.75a8.06 8.06 0 01-2.5 9.11c-2.5 2-5 4.11-7.4 6.22a8 8 0 01-9.39.9L111 116.14a8 8 0 00-10.5 1.51l-7.49 9a8 8 0 00.3 10.62l17.29 19.94a8 8 0 01.7 9.52q-2.55 4-4.8 8.41a8.11 8.11 0 01-8.59 4.11l-25.89-5a8 8 0 00-9.4 5l-4 11a8.05 8.05 0 003.9 9.92L85.58 213a7.94 7.94 0 013.9 8.62c-.6 3.2-1.2 6.31-1.7 9.51a8.08 8.08 0 01-6.6 6.82l-26.08 4.2a8.09 8.09 0 00-7.1 7.92v11.72a7.86 7.86 0 007.1 7.92l26.08 4.2a8 8 0 016.6 6.82c.5 3.2 1 6.41 1.7 9.51a8.08 8.08 0 01-3.9 8.62L62.49 311.7a8.05 8.05 0 00-3.9 9.92l4 11a7.94 7.94 0 009.4 5l25.89-5a8 8 0 018.59 4.11q2.25 4.2 4.8 8.41a8.16 8.16 0 01-.7 9.52l-17.29 19.96a8 8 0 00-.3 10.62l7.49 9a7.88 7.88 0 0010.5 1.51l22.69-13.63a8 8 0 019.39.9c2.4 2.11 4.9 4.21 7.4 6.22a8 8 0 012.5 9.11l-9.4 24.75a8 8 0 003.3 10.12l10.2 5.91a8 8 0 0010.39-2.21l16.79-20.64c2.1-2.6 5.5-3.7 8.2-2.6 3.4 1.4 5.7 2.2 9.9 3.61a8 8 0 015.49 7.71l-.4 26.45a8.07 8.07 0 006.6 8.42l11.59 2a8.07 8.07 0 009.1-5.61l8.6-25a8 8 0 017.79-5.41h9.8a8.07 8.07 0 017.79 5.41l8.6 25a8.07 8.07 0 009.1 5.61l11.59-2a8.07 8.07 0 006.6-8.42l-.4-26.45a8 8 0 015.49-7.71c4.2-1.41 7-2.51 9.6-3.51s5.8-1 8.3 2.1l17 20.94A8 8 0 00355 439l10.2-5.91a7.93 7.93 0 003.3-10.12l-9.4-24.75a8.08 8.08 0 012.5-9.12c2.5-2 5-4.1 7.4-6.21a8 8 0 019.39-.9L401 395.66a8 8 0 0010.5-1.51l7.49-9a8 8 0 00-.3-10.62l-17.29-19.94a8 8 0 01-.7-9.52q2.55-4.05 4.8-8.41a8.11 8.11 0 018.59-4.11l25.89 5a8 8 0 009.4-5l4-11a8.05 8.05 0 00-3.9-9.92l-23.09-12.82a7.94 7.94 0 01-3.9-8.62c.6-3.2 1.2-6.31 1.7-9.51a8.08 8.08 0 016.6-6.82l26.08-4.2a8.09 8.09 0 007.1-7.92V250a8.25 8.25 0 00-7.27-7.73zM256 112a143.82 143.82 0 01139.38 108.12A16 16 0 01379.85 240H274.61a16 16 0 01-13.91-8.09l-52.1-91.71a16 16 0 019.85-23.39A146.94 146.94 0 01256 112zM112 256a144 144 0 0143.65-103.41 16 16 0 0125.17 3.47L233.06 248a16 16 0 010 15.87l-52.67 91.7a16 16 0 01-25.18 3.36A143.94 143.94 0 01112 256zm144 144a146.9 146.9 0 01-38.19-4.95 16 16 0 01-9.76-23.44l52.58-91.55a16 16 0 0113.88-8H379.9a16 16 0 0115.52 19.88A143.84 143.84 0 01256 400z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d9d4d04bd9247501(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 249.93a10.58 10.58 0 00-9.36-9.94L429 235.84a5.42 5.42 0 01-4.5-4.67c-.49-3.15-1-6.42-1.7-9.52a5.52 5.52 0 012.63-5.85l22.78-12.65a10.35 10.35 0 005-12.83l-3.95-10.9a10.32 10.32 0 00-12.13-6.51l-25.55 5a5.5 5.5 0 01-5.82-2.81c-1.49-2.79-3.11-5.63-4.8-8.42a5.6 5.6 0 01.44-6.5l17-19.63a10.44 10.44 0 00.39-13.77l-7.42-8.91a10.24 10.24 0 00-13.58-2l-22.37 13.43a5.39 5.39 0 01-6.39-.63c-2.47-2.17-4.95-4.26-7.37-6.19a5.45 5.45 0 01-1.72-6.21l9.26-24.4a10.35 10.35 0 00-4.31-13.07l-10.08-5.85a10.31 10.31 0 00-13.46 2.83L325 96.28a4.58 4.58 0 01-5.6 1.72c-.62-.25-5.77-2.36-9.78-3.7a5.42 5.42 0 01-3.74-5.23l.39-26.07a10.48 10.48 0 00-8.57-10.88l-11.45-2a10.45 10.45 0 00-11.75 7.17L266 82.1a5.42 5.42 0 01-5.36 3.65h-9.75a5.53 5.53 0 01-5.3-3.67l-8.46-24.67a10.46 10.46 0 00-11.77-7.25l-11.46 2a10.46 10.46 0 00-8.57 10.79l.4 26.16a5.45 5.45 0 01-3.86 5.25c-2.28.89-7.26 2.78-9.51 3.63-2 .72-4.19-.07-6-2.1l-16.26-20A10.3 10.3 0 00156.69 73l-10.06 5.83A10.36 10.36 0 00142.31 92l9.25 24.34a5.54 5.54 0 01-1.7 6.23c-2.43 2-4.92 4-7.4 6.22a5.38 5.38 0 01-6.35.64L114 115.74a10.39 10.39 0 00-13.61 2l-7.4 8.9a10.32 10.32 0 00.37 13.76l17.09 19.6a5.42 5.42 0 01.45 6.45c-1.71 2.72-3.34 5.58-4.82 8.44a5.53 5.53 0 01-5.86 2.82l-25.51-4.93a10.34 10.34 0 00-12.14 6.51l-4 10.88a10.37 10.37 0 005 12.85l22.78 12.65a5.39 5.39 0 012.65 5.92l-.23 1.24c-.53 2.8-1 5.45-1.47 8.27a5.48 5.48 0 01-4.46 4.64l-25.7 4.15A10.42 10.42 0 0048 250.16v11.58A10.26 10.26 0 0057.16 272l25.68 4.14a5.41 5.41 0 014.5 4.67c.49 3.16 1 6.42 1.7 9.52a5.52 5.52 0 01-2.63 5.85l-22.77 12.67a10.35 10.35 0 00-5 12.83l4 10.9a10.33 10.33 0 0012.13 6.51l25.55-4.95a5.5 5.5 0 015.82 2.81c1.5 2.8 3.12 5.64 4.8 8.42a5.58 5.58 0 01-.44 6.5l-17 19.64a10.41 10.41 0 00-.5 13.76l7.41 8.91a10.24 10.24 0 0013.58 2l22.37-13.43a5.39 5.39 0 016.39.63c2.48 2.17 5 4.26 7.37 6.19a5.45 5.45 0 011.72 6.21l-9.26 24.4a10.35 10.35 0 004.31 13.07l10.11 5.84a10.3 10.3 0 0013.45-2.82L187 415.92c1.39-1.73 3.6-2.5 5.24-1.84 3.47 1.44 5.8 2.25 9.93 3.63a5.44 5.44 0 013.75 5.23l-.4 26.05a10.5 10.5 0 008.57 10.88l11.45 2a10.44 10.44 0 0011.75-7.17l8.5-24.77a5.48 5.48 0 015.36-3.65h9.75a5.52 5.52 0 015.3 3.67l8.47 24.67a10.48 10.48 0 0010 7.41 9.74 9.74 0 001.78-.16l11.47-2a10.46 10.46 0 008.56-10.79l-.4-26.16a5.43 5.43 0 013.75-5.2c3.84-1.29 6.53-2.33 8.91-3.24l.6-.24c3.06-1.06 4.53.14 5.47 1.31l16.75 20.63A10.3 10.3 0 00355 439l10.07-5.83a10.35 10.35 0 004.31-13.1l-9.24-24.34a5.52 5.52 0 011.69-6.23c2.43-2 4.92-4 7.4-6.22a5.39 5.39 0 016.38-.62l22.39 13.4a10.39 10.39 0 0013.61-2l7.4-8.9a10.31 10.31 0 00-.37-13.75l-17.06-19.67a5.42 5.42 0 01-.45-6.45c1.71-2.71 3.34-5.57 4.82-8.44a5.56 5.56 0 015.86-2.82l25.48 4.97a10.34 10.34 0 0012.14-6.51l3.95-10.88a10.36 10.36 0 00-5-12.84l-22.8-12.67a5.4 5.4 0 01-2.61-5.89l.23-1.25c.53-2.8 1-5.44 1.47-8.26a5.48 5.48 0 014.46-4.64l25.7-4.14a10.43 10.43 0 009.17-10.28v-11.71zM171.59 361.27a135.12 135.12 0 01.5-210.94l60 105.61zM256 391.11a133.75 133.75 0 01-48.49-9.05L268 276.79h121.22C379.21 341.45 323.29 391.11 256 391.11zm12.06-155.9l-59.95-105.5a133.87 133.87 0 0147.89-8.82c67.29 0 123.21 49.66 133.22 114.32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ffd06c8e53485e3d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 249.93a10.58 10.58 0 00-9.36-9.94L429 235.84a5.42 5.42 0 01-4.5-4.67c-.49-3.15-1-6.42-1.7-9.52a5.52 5.52 0 012.63-5.85l22.78-12.65a10.35 10.35 0 005-12.83l-3.95-10.9a10.32 10.32 0 00-12.13-6.51l-25.55 5a5.51 5.51 0 01-5.82-2.81c-1.49-2.79-3.11-5.63-4.8-8.42a5.6 5.6 0 01.44-6.5l17-19.64a10.42 10.42 0 00.39-13.76l-7.42-8.91a10.24 10.24 0 00-13.58-2l-22.37 13.43a5.39 5.39 0 01-6.39-.63c-2.47-2.17-5-4.26-7.37-6.19a5.45 5.45 0 01-1.72-6.21l9.26-24.4a10.35 10.35 0 00-4.31-13.07l-10.09-5.89a10.3 10.3 0 00-13.45 2.83L325 96.28a4.6 4.6 0 01-5.6 1.72c-.61-.25-5.77-2.36-9.78-3.7a5.42 5.42 0 01-3.74-5.23l.39-26.07a10.48 10.48 0 00-8.57-10.88l-11.45-2a10.45 10.45 0 00-11.75 7.17L266 82.1a5.46 5.46 0 01-5.36 3.65h-9.75a5.5 5.5 0 01-5.3-3.67l-8.46-24.67a10.46 10.46 0 00-11.77-7.25l-11.47 2a10.46 10.46 0 00-8.56 10.79l.4 26.16a5.45 5.45 0 01-3.86 5.25c-2.29.89-7.26 2.79-9.52 3.63-2 .72-4.18-.07-5.94-2.1l-16.26-20A10.3 10.3 0 00156.69 73l-10.06 5.83A10.36 10.36 0 00142.31 92l9.25 24.34a5.54 5.54 0 01-1.7 6.23c-2.43 2-4.92 4-7.4 6.22a5.38 5.38 0 01-6.35.64L114 115.74a10.4 10.4 0 00-13.61 2L93 126.63a10.31 10.31 0 00.37 13.75L110.45 160a5.42 5.42 0 01.45 6.45c-1.71 2.72-3.34 5.58-4.82 8.44a5.53 5.53 0 01-5.86 2.82l-25.51-4.93a10.34 10.34 0 00-12.14 6.51l-4 10.88a10.38 10.38 0 005 12.85l22.78 12.65a5.39 5.39 0 012.65 5.92l-.24 1.27c-.52 2.79-1 5.43-1.46 8.24a5.48 5.48 0 01-4.46 4.64l-25.69 4.15A10.42 10.42 0 0048 250.16v11.58A10.26 10.26 0 0057.16 272l25.68 4.14a5.41 5.41 0 014.5 4.67c.49 3.16 1 6.42 1.7 9.52a5.52 5.52 0 01-2.63 5.85l-22.77 12.67a10.35 10.35 0 00-5 12.83l4 10.9a10.33 10.33 0 0012.13 6.51l25.55-4.95a5.49 5.49 0 015.82 2.81c1.5 2.8 3.11 5.63 4.8 8.42a5.58 5.58 0 01-.44 6.5l-17 19.63a10.41 10.41 0 00-.5 13.77l7.41 8.91a10.23 10.23 0 0013.58 2l22.37-13.43a5.39 5.39 0 016.39.63c2.48 2.17 5 4.26 7.37 6.19a5.47 5.47 0 011.73 6.21l-9.27 24.4a10.35 10.35 0 004.31 13.07l10.11 5.84a10.3 10.3 0 0013.45-2.82L187 415.92c1.4-1.73 3.6-2.5 5.23-1.84 3.48 1.44 5.81 2.25 9.94 3.63a5.44 5.44 0 013.75 5.23l-.4 26.05a10.5 10.5 0 008.57 10.88l11.45 2a10.43 10.43 0 0011.75-7.17l8.5-24.77a5.45 5.45 0 015.36-3.65h9.75a5.49 5.49 0 015.3 3.67l8.47 24.67a10.48 10.48 0 0010 7.41 9.74 9.74 0 001.78-.16l11.47-2a10.46 10.46 0 008.56-10.79l-.4-26.16a5.43 5.43 0 013.75-5.2c3.84-1.29 6.54-2.33 8.91-3.25l.6-.23c3.1-1.07 4.6.23 5.47 1.31l16.75 20.63A10.3 10.3 0 00355 439l10.07-5.83a10.35 10.35 0 004.31-13.1l-9.24-24.34a5.52 5.52 0 011.69-6.23c2.43-2 4.92-4 7.4-6.22a5.39 5.39 0 016.38-.62l22.39 13.4a10.39 10.39 0 0013.61-2l7.4-8.9a10.31 10.31 0 00-.37-13.75l-17.06-19.67a5.42 5.42 0 01-.45-6.45c1.71-2.71 3.34-5.57 4.82-8.44a5.55 5.55 0 015.86-2.82l25.48 4.97a10.34 10.34 0 0012.14-6.51l3.95-10.88a10.37 10.37 0 00-5-12.84l-22.8-12.67a5.4 5.4 0 01-2.61-5.89l.24-1.27c.52-2.79 1-5.43 1.46-8.24a5.48 5.48 0 014.46-4.64l25.69-4.14a10.43 10.43 0 009.18-10.28v-11.71zm-282.45 94a15.8 15.8 0 01-25.47 2.66 135.06 135.06 0 01.42-181.65 15.81 15.81 0 0125.5 2.77l45.65 80.35a15.85 15.85 0 010 15.74zM256 391.11a134.75 134.75 0 01-28.31-3 15.81 15.81 0 01-10.23-23.36l46-80a15.79 15.79 0 0113.7-7.93h92.14a15.8 15.8 0 0115.1 20.53c-17.49 54.32-68.4 93.76-128.4 93.76zm7.51-163.9L218 147.07a15.81 15.81 0 0110.31-23.3 134 134 0 0127.69-2.88c60 0 110.91 39.44 128.37 93.79a15.8 15.8 0 01-15.1 20.53h-92a15.78 15.78 0 01-13.76-8z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8974a10f557a0f9b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M419.1 337.45a3.94 3.94 0 00-6.1 0c-10.5 12.4-45 46.55-45 77.66 0 27 21.5 48.89 48 48.89h0c26.5 0 48-22 48-48.89 0-31.11-34.3-65.26-44.9-77.66zM387 287.9L155.61 58.36a36 36 0 00-51 0l-5.15 5.15a36 36 0 000 51l52.89 52.89 57-57L56.33 263.2a28 28 0 00.3 40l131.2 126a28.05 28.05 0 0038.9-.1c37.8-36.6 118.3-114.5 126.7-122.9 5.8-5.8 18.2-7.1 28.7-7.1h.3a6.53 6.53 0 004.57-11.2z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$43e166b66b4959bc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 320s-64 48-64 99.84c0 33.28 28.67 60.16 64 60.16s64-27 64-60.16C480 368 416 320 416 320zM144 32l-76 76 70 70L32 280l176 184 152.8-148.3L416 304zm24 116l-39.6-41 15.88-15.89L184 132z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e849dea89034d84b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 480c-35.29 0-64-29.11-64-64.88 0-33.29 28.67-65.4 44.08-82.64 1.87-2.1 3.49-3.91 4.68-5.31a19.94 19.94 0 0130.55 0c1.13 1.31 2.63 3 4.36 4.93 15.5 17.3 44.33 49.51 44.33 83.05 0 35.74-28.71 64.85-64 64.85zm-17.77-203.36L166.89 47.22a52.1 52.1 0 00-73.6 0l-4.51 4.51a53.2 53.2 0 00-15.89 37.33A51.66 51.66 0 0088.14 126l41.51 41.5L45 252a44.52 44.52 0 00-13 32 42.81 42.81 0 0013.5 30.84l131.24 126a44 44 0 0061.08-.18l124.11-120.28a15.6 15.6 0 018.23-4.29 69.21 69.21 0 0111.93-.86h.3a22.53 22.53 0 0015.84-38.59zM152.29 144.85l-41.53-41.52a20 20 0 010-28.34l5.16-5.15a20.07 20.07 0 0128.39 0L186 111.21z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d3315f0271c5d373(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "184",
                    "r": "120",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "344",
                    "cy": "328",
                    "r": "120",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "328",
                    "r": "120",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$61b5793368e1f5d7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 185a167.85 167.85 0 01134.9-18.28C382.36 99.83 325.12 48 256 48S129.64 99.83 121.1 166.67A167.85 167.85 0 01256 185zm80 146.73a167.51 167.51 0 01-52.37 118.08A135 135 0 00344 464c75 0 136-61 136-136a136 136 0 00-59.06-112.08A168.53 168.53 0 01336 331.73zm-52.42-125.54a167.87 167.87 0 0149.36 89.89 136.14 136.14 0 0058.06-95.7 135.87 135.87 0 00-107.43 5.81zM176.05 331.73a168.53 168.53 0 01-85-115.81A136 136 0 0032 328c0 75 61 136 136 136a135 135 0 0060.42-14.19 167.51 167.51 0 01-52.37-118.08zm3.01-35.65a167.87 167.87 0 0149.36-89.89A135.87 135.87 0 00121 200.38a136.14 136.14 0 0058.06 95.7zm123.84 49.25a168.22 168.22 0 01-93.8 0A135.9 135.9 0 00256 431.6a135.9 135.9 0 0046.9-86.27zM209 311.62a136 136 0 0094 0 135.93 135.93 0 00-47-87.22 135.93 135.93 0 00-47 87.22z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$de0a131dc39a1bb1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M253.72 202.53a4 4 0 004.56 0 151.88 151.88 0 01128.44-20.41 4 4 0 005.15-4C388.8 105.86 329 48 256 48s-132.8 57.86-135.87 130.15a4 4 0 005.15 4 151.88 151.88 0 01128.44 20.41zm151.59 10.03a152.53 152.53 0 01-83.08 108.23 4 4 0 00-2.28 3.69c0 1.17.05 2.34.05 3.52a151.58 151.58 0 01-47.15 109.94 4 4 0 00.64 6.31A135.24 135.24 0 00344 464c72.07 0 134.1-60.28 136-132.34a136.07 136.07 0 00-68.76-121.87 4 4 0 00-5.93 2.77z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M390.57 203.67a4 4 0 00-2.69-4.4 135.84 135.84 0 00-114.4 12.49 4 4 0 00-.64 6.29 151.92 151.92 0 0144.47 81.4 4 4 0 005.94 2.72 136.29 136.29 0 0067.32-98.5zM192 328c0-1.18 0-2.35.05-3.52a4 4 0 00-2.28-3.69 152.53 152.53 0 01-83.08-108.23 4 4 0 00-5.88-2.77 136.07 136.07 0 00-68.76 121.87C34 403.72 96 464 168.05 464a135.24 135.24 0 0070.46-19.75 4 4 0 00.64-6.31A151.58 151.58 0 01192 328z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M168 192a135.34 135.34 0 00-43.88 7.27 4 4 0 00-2.69 4.4 136.29 136.29 0 0067.32 98.5 4 4 0 005.94-2.72 151.92 151.92 0 0144.47-81.4 4 4 0 00-.64-6.29A135.18 135.18 0 00168 192zm88 144a151.44 151.44 0 01-42.72-6.12 4 4 0 00-5.15 4 135.69 135.69 0 0045.18 95.4 4 4 0 005.38 0 135.69 135.69 0 0045.18-95.4 4 4 0 00-5.15-4A151.44 151.44 0 01256 336zm46.57-27.67a135.94 135.94 0 00-43.87-81.58 4.06 4.06 0 00-5.4 0 135.94 135.94 0 00-43.87 81.58 4 4 0 002.69 4.4 136.06 136.06 0 0087.76 0 4 4 0 002.69-4.4z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$df00ca227f47b515(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M430.11 347.9c-6.6-6.1-16.3-7.6-24.6-9-11.5-1.9-15.9-4-22.6-10-14.3-12.7-14.3-31.1 0-43.8l30.3-26.9c46.4-41 46.4-108.2 0-149.2-34.2-30.1-80.1-45-127.8-45-55.7 0-113.9 20.3-158.8 60.1-83.5 73.8-83.5 194.7 0 268.5 41.5 36.7 97.5 55 152.9 55.4h1.7c55.4 0 110-17.9 148.8-52.4 14.4-12.7 11.99-36.6.1-47.7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "144",
                    "cy": "208",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "152",
                    "cy": "311",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "224",
                    "cy": "144",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "367",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "328",
                    "cy": "144",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1f38ee79002f293f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 352c-12.6-.84-21-4-28-12-14-16-14-36 5.49-52.48l32.82-29.14c50.27-44.41 50.27-117.21 0-161.63C389.26 64.14 339.54 48 287.86 48c-60.34 0-123.39 22-172 65.11-90.46 80-90.46 210.92 0 290.87 45 39.76 105.63 59.59 165.64 60h1.84c60 0 119.07-19.5 161.2-56.77C464 390 464 385 444.62 355.56 440 348 431 353 416 352zM112 208a32 32 0 1132 32 32 32 0 01-32-32zm40 135a32 32 0 1132-32 32 32 0 01-32 32zm40-199a32 32 0 1132 32 32 32 0 01-32-32zm64 271a48 48 0 1148-48 48 48 0 01-48 48zm72-239a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$702b0991ca79ed03(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M441 336.2l-.06-.05c-9.93-9.18-22.78-11.34-32.16-12.92l-.69-.12c-9.05-1.49-10.48-2.5-14.58-6.17-2.44-2.17-5.35-5.65-5.35-9.94s2.91-7.77 5.34-9.94l30.28-26.87c25.92-22.91 40.2-53.66 40.2-86.59s-14.25-63.68-40.2-86.6c-35.89-31.59-85-49-138.37-49C223.72 48 162 71.37 116 112.11c-43.87 38.77-68 90.71-68 146.24s24.16 107.47 68 146.23c21.75 19.24 47.49 34.18 76.52 44.42a266.17 266.17 0 0086.87 15h1.81c61 0 119.09-20.57 159.39-56.4 9.7-8.56 15.15-20.83 15.34-34.56.21-14.17-5.37-27.95-14.93-36.84zM112 208a32 32 0 1132 32 32 32 0 01-32-32zm40 135a32 32 0 1132-32 32 32 0 01-32 32zm40-199a32 32 0 1132 32 32 32 0 01-32-32zm64 271a48 48 0 1148-48 48 48 0 01-48 48zm72-239a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$136bd27317382da7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "63.03",
                    "height": "378.2",
                    "x": "280.48",
                    "y": "122.9",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "31.52",
                    "transform": "rotate(-45 312.002 311.994)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M178.38 178.38a31.64 31.64 0 000 44.75L223.25 268 268 223.25l-44.87-44.87a31.64 31.64 0 00-44.75 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M48 192h48M90.18 90.18l33.94 33.94M192 48v48m101.82-5.82l-33.94 33.94M124.12 259.88l-33.94 33.94"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$dd4115d6be27479e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M133.441 200.647l67.197-67.196 78.142 78.142-67.196 67.196zM301.41 234.21l-67.19 67.2L412 480l68-68-178.59-177.79zM32 176h80v32H32zm35.624-85.75l22.627-22.628 56.569 56.569-22.627 22.627zM176 32h32v80h-32zm61.32 92.195l56.569-56.569 22.627 22.627-56.569 56.569zM67.62 293.887l56.569-56.569 22.627 22.627-56.569 56.569z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b272d8f7da83faf7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 208H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16zm28.1-67.9c-4.2 0-8.3-1.7-11.3-4.7l-33.9-33.9c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l33.9 33.9c6.3 6.2 6.3 16.4 0 22.6-3 3-7 4.7-11.3 4.7zM192 112c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 8.8-7.2 16-16 16zm67.9 28.1c-8.8 0-16-7.2-16-16 0-4.2 1.7-8.3 4.7-11.3l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0 6.2 6.2 6.2 16.4 0 22.6l-33.9 33.9c-3 3-7.1 4.7-11.3 4.7zM90.2 309.8c-8.8 0-16-7.2-16-16 0-4.2 1.7-8.3 4.7-11.3l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-33.9 33.9c-3 3-7.1 4.7-11.3 4.7zm144-142.8c-18.4-18.7-48.5-19-67.2-.7s-19 48.5-.7 67.2l.7.7 39.5 39.5c3.1 3.1 8.2 3.1 11.3 0l55.9-55.9c3.1-3.1 3.1-8.2 0-11.3L234.2 167zM457 389.8L307.6 240.4c-3.1-3.1-8.2-3.1-11.3 0l-55.9 55.9c-3.1 3.1-3.1 8.2 0 11.3L389.8 457c18.4 18.7 48.5 19 67.2.7 18.7-18.4 19-48.5.7-67.2-.2-.2-.4-.5-.7-.7z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3a943a329447cf44(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M350.67 150.93l-117.2 46.88a64 64 0 00-35.66 35.66l-46.88 117.2a8 8 0 0010.4 10.4l117.2-46.88a64 64 0 0035.66-35.66l46.88-117.2a8 8 0 00-10.4-10.4zM256 280a24 24 0 1124-24 24 24 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$76114ffa15f92246(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "24"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm48 256l-160 64 64-160 160-64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$da9c53b5d394f72b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "24"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm105.07 113.33l-46.88 117.2a64 64 0 01-35.66 35.66l-117.2 46.88a8 8 0 01-10.4-10.4l46.88-117.2a64 64 0 0135.66-35.66l117.2-46.88a8 8 0 0110.4 10.4z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$166a21f2e7f13b2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M436.67 184.11a27.17 27.17 0 01-38.3 0l-22.48-22.49a27.15 27.15 0 010-38.29l50.89-50.89a.85.85 0 00-.26-1.38C393.68 57 351.09 64.15 324.05 91c-25.88 25.69-27.35 64.27-17.87 98a27 27 0 01-7.67 27.14l-173 160.76a40.76 40.76 0 1057.57 57.54l162.15-173.3a27 27 0 0126.77-7.7c33.46 8.94 71.49 7.26 97.07-17.94 27.49-27.08 33.42-74.94 20.1-102.33a.85.85 0 00-1.36-.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M224 284c-17.48-17-25.49-24.91-31-30.29a18.24 18.24 0 01-3.33-21.35 20.76 20.76 0 013.5-4.62l15.68-15.29a18.66 18.66 0 015.63-3.87 18.11 18.11 0 0120 3.62c5.45 5.29 15.43 15 33.41 32.52m49.18 46.58c40.95 38.1 90.62 83.27 110 99.41a13.46 13.46 0 01.94 19.92L394.63 444a14 14 0 01-20.29-.76c-16.53-19.18-61.09-67.11-99.27-107"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M17.34 193.5l29.41-28.74a4.71 4.71 0 013.41-1.35 4.85 4.85 0 013.41 1.35h0a9.86 9.86 0 008.19 2.77c3.83-.42 7.92-1.6 10.57-4.12 6-5.8-.94-17.23 4.34-24.54a207 207 0 0119.78-22.6c6-5.88 29.84-28.32 69.9-44.45A107.31 107.31 0 01206.67 64c22.59 0 40 10 46.26 15.67a89.54 89.54 0 0110.28 11.64 78.92 78.92 0 00-9.21-2.77 68.82 68.82 0 00-20-1.26c-13.33 1.09-29.41 7.26-38 14-13.9 11-19.87 25.72-20.81 44.71-.68 14.12 2.72 22.1 36.1 55.49a6.6 6.6 0 01-.34 9.16l-18.22 18a6.88 6.88 0 01-9.54.09c-21.94-21.94-36.65-33.09-45-38.16s-15.07-6.5-18.3-6.85a30.85 30.85 0 00-18.27 3.87 11.39 11.39 0 00-2.64 2 14.14 14.14 0 00.42 20.08l1.71 1.6a4.63 4.63 0 010 6.64L71.73 246.6a4.71 4.71 0 01-3.41 1.4 4.86 4.86 0 01-3.41-1.35l-47.57-46.43a4.88 4.88 0 010-6.72z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$16ffc737239a4a27(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.14 111.38l-81.09 80.84-48.58-48.41L448.56 63c-45.22-22-108.65-22.09-146.2 15.35-35.32 35.2-39.73 90.61-22.54 134.2L99.57 391.37a12 12 0 000 17l52.27 52.11a12 12 0 0017 0l180-180.5c43.16 16.21 98 11.64 132.74-23 37.5-37.45 37.42-100.34 15.56-145.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M365.45 308.62l-71.83 72 75.53 79.92a10.88 10.88 0 0015.65.21l60-60.46a11 11 0 00-.24-15.69zM119 212c0-4.87-4-9.33-7.45-12.78l-.25-.24-1.54-1.47a1.06 1.06 0 01-.26-.8 16.16 16.16 0 019.52-2c1.27.13 5.91.9 12.4 4.91 3.38 2.09 32.63 30.23 43.93 40.7a11 11 0 00.14 15.35l7.43 7.86 65.66-65.17-8.25-7.84a10.87 10.87 0 00-15.31-.06c-23-24.68-29-35.45-31-42.45-4.42-15.47 4.14-28 14-36 5.84-4.62 17.88-8.08 29-9a52.72 52.72 0 0111.61.6c3.47.5 6.3 1.14 7.39 1.4a68.51 68.51 0 0111 4l12-19a88.38 88.38 0 00-13.4-17.7 115.05 115.05 0 00-5.19-5.1c-7.78-7.15-28-19.2-54.59-19.2a117.38 117.38 0 00-44.77 8.82c-37.44 15.34-61.88 36.25-73.11 47.35l-.07.07A219.55 219.55 0 0067 128.56c-5.35 7.53-4.77 15.84-4.38 21.34 0 .32 0 .67.07 1a18.41 18.41 0 00-10.78-3.5A18 18 0 0039 152.73L2 189.62a6.79 6.79 0 000 9.6L65 262a6.72 6.72 0 009.5 0l37.06-37c3.44-3.44 7.44-8.14 7.44-13z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$717e417fe9c2eba4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.58 126.2a16.85 16.85 0 00-27.07-4.55l-51.15 51.15a11.15 11.15 0 01-15.66 0l-22.48-22.48a11.17 11.17 0 010-15.67l50.88-50.89a16.85 16.85 0 00-5.27-27.4c-39.71-17-89.08-7.45-120 23.29-26.81 26.61-34.83 68-22 113.7a11 11 0 01-3.16 11.1L114.77 365.1a56.76 56.76 0 1080.14 80.18L357 272.08a11 11 0 0110.9-3.17c45 12 86 4 112.43-22 15.2-15 25.81-36.17 29.89-59.71 3.83-22.2 1.41-44.44-6.64-61z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M437.33 378.41c-13.94-11.59-43.72-38.4-74.07-66.22l-66.07 70.61c28.24 30 53.8 57.85 65 70.88l.07.08A30 30 0 00383.72 464h1.1a30.11 30.11 0 0021-8.62l.07-.07 33.43-33.37a29.46 29.46 0 00-2-43.53zM118.54 214.55a20.48 20.48 0 00-3-10.76 2.76 2.76 0 012.62-4.22h.06c.84.09 5.33.74 11.7 4.61 4.73 2.87 18.23 12.08 41.73 35.54a34.23 34.23 0 007.22 22.12l66.23-61.55a33.73 33.73 0 00-21.6-9.2 2.65 2.65 0 01-.21-.26l-.65-.69-24.54-33.84a28.45 28.45 0 01-4-26.11 35.23 35.23 0 0111.78-16.35c5.69-4.41 18.53-9.72 29.44-10.62a52.92 52.92 0 0115.19.94 65.57 65.57 0 017.06 2.13 15.46 15.46 0 002.15.63 16 16 0 0016.38-25.06c-.26-.35-1.32-1.79-2.89-3.73a91.85 91.85 0 00-9.6-10.36c-8.15-7.36-29.27-19.77-57-19.77a123.13 123.13 0 00-46.3 9c-38.37 15.45-63.47 36.58-75.01 47.79l-.09.09A222.14 222.14 0 0063.7 129.5a27 27 0 00-4.7 11.77 7.33 7.33 0 01-7.71 6.17H50.2a20.65 20.65 0 00-14.59 5.9L6.16 182.05l-.32.32a20.89 20.89 0 00-.24 28.72c.19.2.37.39.57.58L53.67 258a21 21 0 0014.65 6 20.65 20.65 0 0014.59-5.9l29.46-28.79a20.51 20.51 0 006.17-14.76z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$81af6e8f04adb412(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 416V304h112m-101.8 10.23L432 432M208 96v112H96m101.8-10.23L80 80m336 128H304V96m10.23 101.8L432 80M96 304h112v112m-10.23-101.8L80 432"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b826d19dbddddd26(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M304 416V304h112m-101.8 10.23L432 432M208 96v112H96m101.8-10.23L80 80m336 128H304V96m10.23 101.8L432 80M96 304h112v112m-10.23-101.8L80 432"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$97423700fcbd45a9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 416V304h112m-101.8 10.23L432 432M208 96v112H96m101.8-10.23L80 80m336 128H304V96m10.23 101.8L432 80M96 304h112v112m-10.23-101.8L80 432"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8a2d1224d46d7f3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c-114.88 0-208-93.12-208-208S141.12 48 256 48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$34e0d251de3d1d5e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.29 32 32 132.29 32 256s100.29 224 224 224 224-100.29 224-224S379.71 32 256 32zM128.72 383.28A180 180 0 01256 76v360a178.82 178.82 0 01-127.28-52.72z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d73e6b4c0f01154f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32A224 224 0 0097.61 414.39 224 224 0 10414.39 97.61 222.53 222.53 0 00256 32zM64 256c0-105.87 86.13-192 192-192v384c-105.87 0-192-86.13-192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1704ccd60aaff91c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "336",
                    "height": "336",
                    "x": "128",
                    "y": "128",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "57",
                    "ry": "57"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M383.5 128l.5-24a56.16 56.16 0 00-56-56H112a64.19 64.19 0 00-64 64v216a56.16 56.16 0 0056 56h24"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2d3d89302ef6fe36(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 480H136a24 24 0 01-24-24V128a16 16 0 0116-16h328a24 24 0 0124 24v320a24 24 0 01-24 24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M112 80h288V56a24 24 0 00-24-24H60a28 28 0 00-28 28v316a24 24 0 0024 24h24V112a32 32 0 0132-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9c851c5a6657b8f7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 480H184a72 72 0 01-72-72V184a72 72 0 0172-72h224a72 72 0 0172 72v224a72 72 0 01-72 72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M160 80h235.88A72.12 72.12 0 00328 32H104a72 72 0 00-72 72v224a72.12 72.12 0 0048 67.88V160a80 80 0 0180-80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a1f4fb7f3f616e75(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M459.94 53.25a16.06 16.06 0 00-23.22-.56L424.35 65a8 8 0 000 11.31l11.34 11.32a8 8 0 0011.34 0l12.06-12c6.1-6.09 6.67-16.01.85-22.38zM399.34 90L218.82 270.2a9 9 0 00-2.31 3.93L208.16 299a3.91 3.91 0 004.86 4.86l24.85-8.35a9 9 0 003.93-2.31L422 112.66a9 9 0 000-12.66l-9.95-10a9 9 0 00-12.71 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6e7a1a26a4aceecf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464.37 49.2a22.07 22.07 0 00-31.88-.76l-18.31 18.25 31.18 31.1 18-17.91a22.16 22.16 0 001.01-30.68zM252.76 336H176v-76.76l9.4-9.38L323.54 112H48v352h352V188.46L262.14 326.6l-9.38 9.4zM400 143.16l32.79-32.86-31.09-31.09L368.85 112H400v31.16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M208 304h31.49L400 143.16V112h-31.15L208 272.51V304z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4ddfee0600fb32d2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M459.94 53.25a16.06 16.06 0 00-23.22-.56L424.35 65a8 8 0 000 11.31l11.34 11.32a8 8 0 0011.34 0l12.06-12c6.1-6.09 6.67-16.01.85-22.38zM399.34 90L218.82 270.2a9 9 0 00-2.31 3.93L208.16 299a3.91 3.91 0 004.86 4.86l24.85-8.35a9 9 0 003.93-2.31L422 112.66a9 9 0 000-12.66l-9.95-10a9 9 0 00-12.71 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M386.34 193.66L264.45 315.79A41.08 41.08 0 01247.58 326l-25.9 8.67a35.92 35.92 0 01-44.33-44.33l8.67-25.9a41.08 41.08 0 0110.19-16.87l122.13-121.91a8 8 0 00-5.65-13.66H104a56 56 0 00-56 56v240a56 56 0 0056 56h240a56 56 0 0056-56V199.31a8 8 0 00-13.66-5.65z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$18525b243167fccb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 48v272a48 48 0 0048 48h272"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 304V192a48 48 0 00-48-48H208m160 224v96M144 144H48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$16a70baab7b1e144(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M166 346V32h-44v90H32v44h90v224h224v90h44v-90h90v-44H166z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M346 320h44V122H192v44h154v154z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1805700c32bcfb27(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M458 346H192a26 26 0 01-26-26V54a22 22 0 00-44 0v68H54a22 22 0 000 44h68v154a70.08 70.08 0 0070 70h154v68a22 22 0 0044 0v-68h68a22 22 0 000-44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M214 166h106a26 26 0 0126 26v106a22 22 0 0044 0V192a70.08 70.08 0 00-70-70H214a22 22 0 000 44z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cf99a476b6491ddb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 341.37V170.61A32 32 0 00432.11 143l-152-88.46a47.94 47.94 0 00-48.24 0L79.89 143A32 32 0 0064 170.61v170.76A32 32 0 0079.89 369l152 88.46a48 48 0 0048.24 0l152-88.46A32 32 0 00448 341.37z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M69 153.99l187 110 187-110m-187 310v-200"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2b41f931434aa622(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 170v196.92L240 480V284L48 170zm224 310l192-113.08V170L272 284zm176-122.36zM448 144L256 32 64 144l192 112 192-112z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$417f94354c1ec3b7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.9 136.3a4 4 0 000-6.91L288.16 40.65a64.14 64.14 0 00-64.33 0L71.12 129.39a4 4 0 000 6.91L254 243.88a4 4 0 004.06 0zM54 163.51a4 4 0 00-6 3.49v173.89a48 48 0 0023.84 41.39L234 479.51a4 4 0 006-3.46V274.3a4 4 0 00-2-3.46zM272 275v201a4 4 0 006 3.46l162.15-97.23A48 48 0 00464 340.89V167a4 4 0 00-6-3.45l-184 108a4 4 0 00-2 3.45z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$69efe7278e2461a2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "104",
                    "cy": "152",
                    "r": "56",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "104",
                    "cy": "360",
                    "r": "56",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M157 175l-11 15 37 15s3.46-6.42 7-10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M154.17 334.43L460 162c-2.5-6.7-28-12-64-4-29.12 6.47-121.16 29.05-159.16 56.05C205.85 236.06 227 272 192 298c-25.61 19-44.43 22.82-44.43 22.82zm190.3-56.19L295 306.67c14.23 6.74 65.54 33.27 117 36.33 14.92.89 30 .39 39-6z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "240",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d1498774ff3f55e0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128h-48l-198.94 70.46-59.13-31.59a72.16 72.16 0 10-25.69 41.47l52.2 31.72L192 277l-43.64 26.76a71.74 71.74 0 1024.79 38L480 160zm-376.52 64a40 40 0 1140-40 40 40 0 01-40 40zm0 208a40 40 0 1140-40 40 40 0 01-40 40zm152-144a16 16 0 1116-16 16 16 0 01-16 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M343.79 259.87l-83.74 48.18L432 368h47.99l.01-32-136.21-76.13z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d615f82a86adee8d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.48 224a71.64 71.64 0 0044.76-15.66l41.5 16.89 6.82-12.63a39.15 39.15 0 014.32-6.37l14.22-14.42-41.17-24.94A72 72 0 10103.48 224zm0-112a40 40 0 11-40 40 40 40 0 0140-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 169l-5.52-12.58c-4.48-10.42-14.74-16-32.78-17.85-10.12-1-26.95-1.24-49.69 3.81-20 4.45-122.14 28.2-164.95 58.62-20.25 14.39-24.06 33.67-27.06 49.16-2.78 14.14-5 25.31-18 35-15 11.14-27.27 16.38-33.58 18.6a71.74 71.74 0 1024.79 38zm-224.52 87a16 16 0 1116-16 16 16 0 01-16 16zm-152 144a40 40 0 1140-40 40 40 0 01-40 40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M343.79 259.87l-83.74 48.18 27.63 13.08 3.62 1.74C310 331.92 359.74 356 410.53 359c3.89.23 7.47.34 10.78.34C442 359.31 453 354 459.75 350L480 336z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$30147f54269a200f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "320",
                    "x": "32",
                    "y": "64",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 448l-8-64h-80l-8 64h96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 448H144"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M32 304v48a32.09 32.09 0 0032 32h384a32.09 32.09 0 0032-32v-48zm224 64a16 16 0 1116-16 16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a2eeb6c7fa834e9a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 48H32a16 16 0 00-16 16v320a16 16 0 0016 16h168v32h-72v32h256v-32h-72v-32h168a16 16 0 0016-16V64a16 16 0 00-16-16zm-20 36v216H52V84zM240.13 354.08a16 16 0 1113.79 13.79 16 16 0 01-13.79-13.79z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f64b9cf5e956d1a2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 352a48.05 48.05 0 0048 48h133.88l-4 32H144a16 16 0 000 32h224a16 16 0 000-32h-49.88l-4-32H448a48.05 48.05 0 0048-48v-48H16zm240-16a16 16 0 11-16 16 16 16 0 0116-16zM496 96a48.05 48.05 0 00-48-48H64a48.05 48.05 0 00-48 48v192h480z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fdfc3ed96dcf988(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M35.42 188.21l207.75 269.46a16.17 16.17 0 0025.66 0l207.75-269.46a16.52 16.52 0 00.95-18.75L407.06 55.71A16.22 16.22 0 00393.27 48H118.73a16.22 16.22 0 00-13.79 7.71L34.47 169.46a16.52 16.52 0 00.95 18.75zM48 176h416"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 64l-48 112-96-128M112 64l48 112 96-128m0 400l-96-272m96 272l96-272"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bbbe49556c20073(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396.31 32H264l84.19 112.26L396.31 32zm-280.62 0l48.12 112.26L248 32H115.69zM256 74.67L192 160h128l-64-85.33zm166.95-23.61L376.26 160H488L422.95 51.06zm-333.9 0L23 160h112.74L89.05 51.06zM146.68 192H24l222.8 288h.53L146.68 192zm218.64 0L264.67 480h.53L488 192H365.32zm-35.93 0H182.61L256 400l73.39-208z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5dc174c851ee5bba(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M121.72 32a4 4 0 00-3.72 5.56l2.3 5.43 40.7 94.9a4 4 0 006.88.82L243 38.4a4 4 0 00-3.2-6.4zm298.21 26.06l-41.28 96.37a4 4 0 003.68 5.57h101a4 4 0 003.4-6.11L427 57.53a4 4 0 00-7.07.53zM85 57.57l-59.71 96.32a4 4 0 003.4 6.11h101a4 4 0 003.67-5.58L92 58.1a4 4 0 00-7-.53zM393.27 32H267.82a1.94 1.94 0 00-1.56 3.11l79.92 106.46a1.94 1.94 0 003.34-.4L391.6 43l3.4-8.34a1.92 1.92 0 00-1.7-2.66zM239 448l-89.43-253.49A3.78 3.78 0 00146 192H25.7a3.72 3.72 0 00-2.95 6l216 279.81a5.06 5.06 0 006.39 1.37 5 5 0 002.39-6.08zm247.3-256H366a3.75 3.75 0 00-3.54 2.51l-98.2 278.16a5.21 5.21 0 002.42 6.31 5.22 5.22 0 006.61-1.39L489.25 198a3.72 3.72 0 00-2.95-6zM259.2 78.93l56 74.67a4 4 0 01-3.2 6.4H200a4 4 0 01-3.2-6.4l56-74.67a4 4 0 016.4 0zm-7 310.31l-67.7-191.91a4 4 0 013.77-5.33h135.46a4 4 0 013.77 5.33l-67.73 191.91a4 4 0 01-7.54 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e2049b062f092597(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 341.37V170.61A32 32 0 00432.11 143l-152-88.46a47.94 47.94 0 00-48.24 0L79.89 143A32 32 0 0064 170.61v170.76A32 32 0 0079.89 369l152 88.46a48 48 0 0048.24 0l152-88.46A32 32 0 00448 341.37z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M69 153.99l187 110 187-110m-187 310v-200"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256",
                    "cy": "152",
                    "rx": "24",
                    "ry": "16"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "208",
                    "cy": "296",
                    "rx": "16",
                    "ry": "24"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "112",
                    "cy": "328",
                    "rx": "16",
                    "ry": "24"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "304",
                    "cy": "296",
                    "rx": "16",
                    "ry": "24"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "400",
                    "cy": "240",
                    "rx": "16",
                    "ry": "24"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "304",
                    "cy": "384",
                    "rx": "16",
                    "ry": "24"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "400",
                    "cy": "328",
                    "rx": "16",
                    "ry": "24"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5d6026931169ab49(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 366.92L240 480V284L48 170zM192 288c8.84 0 16 10.75 16 24s-7.16 24-16 24-16-10.75-16-24 7.16-24 16-24zm-96 32c8.84 0 16 10.75 16 24s-7.16 24-16 24-16-10.75-16-24 7.16-24 16-24zm176-36v196l192-113.08V170zm48 140c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm96 32c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm32 77.64zM256 32L64 144l192 112 192-112zm0 120c-13.25 0-24-7.16-24-16s10.75-16 24-16 24 7.16 24 16-10.75 16-24 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$238f7cd89c6b0ee1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.88 129.37L288.16 40.62a64.14 64.14 0 00-64.33 0L71.12 129.37a4 4 0 000 6.9L254 243.85a4 4 0 004.06 0L440.9 136.27a4 4 0 00-.02-6.9zM256 152c-13.25 0-24-7.16-24-16s10.75-16 24-16 24 7.16 24 16-10.75 16-24 16zm-18 118.81L54 163.48a4 4 0 00-6 3.46v173.92a48 48 0 0023.84 41.39L234 479.48a4 4 0 006-3.46V274.27a4 4 0 00-2-3.46zM96 368c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm96-32c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm266-172.49L274 271.56a4 4 0 00-2 3.45V476a4 4 0 006 3.46l162.15-97.23A48 48 0 00464 340.86V167a4 4 0 00-6-3.49zM320 424c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm96 32c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ce36ae6e7eef4244(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "96",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7b9c0670b34f3f07(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM256 336a80 80 0 1180-80 80.09 80.09 0 01-80 80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$265af41ef4f7f606(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 176a80 80 0 1080 80 80.09 80.09 0 00-80-80zm0 112a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM256 368a112 112 0 11112-112 112.12 112.12 0 01-112 112z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$97a0b41524dfc054(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M208 64h66.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62V432a48 48 0 01-48 48H192a48 48 0 01-48-48V304"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M288 72v120a32 32 0 0032 32h120"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M160 80v152a23.69 23.69 0 01-24 24c-12 0-24-9.1-24-24V88c0-30.59 16.57-56 48-56s48 24.8 48 55.38v138.75c0 43-27.82 77.87-72 77.87s-72-34.86-72-77.87V144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3c51af3ed28713f1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 240a8 8 0 01-8-8V48h-57.25a65.42 65.42 0 00-6.5-9.81C196.72 23.88 179.59 16 160 16c-37.68 0-64 29.61-64 72v144c0 25 20.34 40 40 40a39.57 39.57 0 0040-40V80h-32v152a7.75 7.75 0 01-8 8c-2.23 0-8-1.44-8-8V88c0-19.34 8.41-40 32-40 29.69 0 32 30.15 32 39.38v138.75c0 17.45-5.47 33.23-15.41 44.46C166.5 282 152.47 288 136 288s-30.5-6-40.59-17.41C85.47 259.36 80 243.58 80 226.13V144H48v82.13c0 51.51 33.19 89.63 80 93.53V468a12 12 0 0012 12h312a12 12 0 0012-12V240z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M308 208h146.31a2 2 0 001.42-3.41L307.41 56.27a2 2 0 00-3.41 1.42V204a4 4 0 004 4z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8a83f9c1c7fa4471(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460 240H320a48 48 0 01-48-48V52a4 4 0 00-4-4h-53.25a65.42 65.42 0 00-6.5-9.81C196.72 23.88 179.59 16 160 16c-37.68 0-64 29.61-64 72v144c0 25 20.34 40 40 40a39.57 39.57 0 0040-40V80a16 16 0 00-32 0v152a7.75 7.75 0 01-8 8c-2.23 0-8-1.44-8-8V88c0-19.34 8.41-40 32-40 29.69 0 32 30.15 32 39.38v138.75c0 17.45-5.47 33.23-15.41 44.46C166.5 282 152.47 288 136 288s-30.5-6-40.59-17.41C85.47 259.36 80 243.58 80 226.13V144a16 16 0 00-32 0v82.13c0 51.51 33.19 89.63 80 93.53V432a64 64 0 0064 64h208a64 64 0 0064-64V244a4 4 0 00-4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 208h129.81a2 2 0 001.41-3.41L307.41 60.78a2 2 0 00-3.41 1.41V192a16 16 0 0016 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9a0e4b1984818c2b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M288 304v-18c0-16.63-14.26-30-32-30s-32 13.37-32 30v18"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M304 416h-96a32 32 0 01-32-32v-48a32 32 0 0132-32h96a32 32 0 0132 32v48a32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 50.88V176a32 32 0 0032 32h125.12"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7a11be772b83f61d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M276 192h146.31a2 2 0 001.42-3.41L275.41 40.27a2 2 0 00-3.41 1.42V188a4 4 0 004 4zm-20 80c-8.82 0-16 6.28-16 14v18h32v-18c0-7.72-7.18-14-16-14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M248 224a8 8 0 01-8-8V32H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V224zm88 175.91A16.1 16.1 0 01319.91 416H192.09A16.1 16.1 0 01176 399.91V320c0-10 7-16 16-16h16v-18c0-25.36 21.53-46 48-46s48 20.64 48 46v18h16a15.8 15.8 0 0116 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$adc7aba22ac1634b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 192h129.81a2 2 0 001.41-3.41L275.41 44.78a2 2 0 00-3.41 1.41V176a16 16 0 0016 16zm-32 80c-8.82 0-16 6.28-16 14v18h32v-18c0-7.72-7.18-14-16-14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M428 224H288a48 48 0 01-48-48V36a4 4 0 00-4-4h-92a64 64 0 00-64 64v320a64 64 0 0064 64h224a64 64 0 0064-64V228a4 4 0 00-4-4zm-92 160a32 32 0 01-32 32h-96a32 32 0 01-32-32v-48a32 32 0 0132-32v-18c0-25.36 21.53-46 48-46s48 20.64 48 46v18a32 32 0 0132 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$327da4bafaf64660(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 56v120a32 32 0 0032 32h120"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$92634637a6d88bee(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 216V32H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V224H248a8 8 0 01-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M272 41.69V188a4 4 0 004 4h146.31a2 2 0 001.42-3.41L275.41 40.27a2 2 0 00-3.41 1.42z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7a625699c1e7184e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 56v120a32 32 0 0032 32h120m-232 80h160m-160 80h160"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b3d266500df7fe02(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 41.69V188a4 4 0 004 4h146.31a2 2 0 001.42-3.41L275.41 40.27a2 2 0 00-3.41 1.42z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M248 224a8 8 0 01-8-8V32H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V224zm104 160H160v-32h192zm0-80H160v-32h192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$57e72241bad8462e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M428 224H288a48 48 0 01-48-48V36a4 4 0 00-4-4h-92a64 64 0 00-64 64v320a64 64 0 0064 64h224a64 64 0 0064-64V228a4 4 0 00-4-4zm-92 160H176a16 16 0 010-32h160a16 16 0 010 32zm0-80H176a16 16 0 010-32h160a16 16 0 010 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M419.22 188.59L275.41 44.78a2 2 0 00-3.41 1.41V176a16 16 0 0016 16h129.81a2 2 0 001.41-3.41z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c32874f392bc7601(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M428 224H288a48 48 0 01-48-48V36a4 4 0 00-4-4h-92a64 64 0 00-64 64v320a64 64 0 0064 64h224a64 64 0 0064-64V228a4 4 0 00-4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M419.22 188.59L275.41 44.78a2 2 0 00-3.41 1.41V176a16 16 0 0016 16h129.81a2 2 0 001.41-3.41z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$976ea6766d761ce3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 264.13V436c0 24.3-19.05 44-42.95 44H107c-23.95 0-43-19.7-43-44V172a44.26 44.26 0 0144-44h94.12a24.55 24.55 0 0117.49 7.36l109.15 111a25.4 25.4 0 017.24 17.77z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M200 128v108a28.34 28.34 0 0028 28h108"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 128V76a44.26 44.26 0 0144-44h94a24.83 24.83 0 0117.61 7.36l109.15 111A25.09 25.09 0 01448 168v172c0 24.3-19.05 44-42.95 44H344"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M312 32v108a28.34 28.34 0 0028 28h108"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3761b64ffc0d41bb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M307.94 248L216 154.52V242a6 6 0 006 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M184 268V144H60a12 12 0 00-12 12v328a12 12 0 0012 12h248a12 12 0 0012-12V280H196a12 12 0 01-12-12zm182-148h85.94L360 26.52V114a6 6 0 006 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M340 152a12 12 0 01-12-12V16H172a12 12 0 00-12 12v84h42.12A40.81 40.81 0 01231 124.14l109.16 111a41.11 41.11 0 0111.83 29V400H452a12 12 0 0012-12V152z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1939c14357fe33b5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.39 248a4 4 0 002.86-6.8l-78.4-79.72a4 4 0 00-6.85 2.81V236a12 12 0 0012 12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M197 267a43.67 43.67 0 01-13-31v-92h-72a64.19 64.19 0 00-64 64v224a64 64 0 0064 64h144a64 64 0 0064-64V280h-92a43.61 43.61 0 01-31-13zm175-147h70.39a4 4 0 002.86-6.8l-78.4-79.72a4 4 0 00-6.85 2.81V108a12 12 0 0012 12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M372 152a44.34 44.34 0 01-44-44V16H220a60.07 60.07 0 00-60 60v36h42.12A40.81 40.81 0 01231 124.14l109.16 111a41.11 41.11 0 0111.83 29V400h53.05c32.51 0 58.95-26.92 58.95-60V152z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2231144852ec88cf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 176h40a40 40 0 0140 40v208a40 40 0 01-40 40H136a40 40 0 01-40-40V216a40 40 0 0140-40h40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 272l80 80 80-80M256 48v288"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c5831ae1c4b213e5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 160v147.37l64-64L358.63 266 256 368.63 153.37 266 176 243.37l64 64V160H92a12 12 0 00-12 12v296a12 12 0 0012 12h328a12 12 0 0012-12V172a12 12 0 00-12-12zM240 32h32v128h-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$57daba1d443a076e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376 160H272v153.37l52.69-52.68a16 16 0 0122.62 22.62l-80 80a16 16 0 01-22.62 0l-80-80a16 16 0 0122.62-22.62L240 313.37V160H136a56.06 56.06 0 00-56 56v208a56.06 56.06 0 0056 56h240a56.06 56.06 0 0056-56V216a56.06 56.06 0 00-56-56zM272 48a16 16 0 00-32 0v112h32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b9f1163217457664(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "336",
                    "height": "336",
                    "x": "128",
                    "y": "128",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "57",
                    "ry": "57"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M383.5 128l.5-24a56.16 56.16 0 00-56-56H112a64.19 64.19 0 00-64 64v216a56.16 56.16 0 0056 56h24m168-168v160m80-80H216"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d9c9894901e19889(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 80h288V56a24 24 0 00-24-24H66a34 34 0 00-34 34v310a24 24 0 0024 24h24V112a32 32 0 0132-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M456 112H136a24 24 0 00-24 24v320a24 24 0 0024 24h320a24 24 0 0024-24V136a24 24 0 00-24-24zm-64 200h-80v80h-32v-80h-80v-32h80v-80h32v80h80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f2d333ef92b9e4a5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 112H184a72 72 0 00-72 72v224a72 72 0 0072 72h224a72 72 0 0072-72V184a72 72 0 00-72-72zm-32.45 200H312v63.55c0 8.61-6.62 16-15.23 16.43A16 16 0 01280 376v-64h-63.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01216 280h64v-63.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01312 216v64h64a16 16 0 0116 16.77c-.42 8.61-7.84 15.23-16.45 15.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M395.88 80A72.12 72.12 0 00328 32H104a72 72 0 00-72 72v224a72.12 72.12 0 0048 67.88V160a80 80 0 0180-80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$148c7566ef78ce9a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M335.72 330.76C381.73 299.5 416 251.34 416 192a160 160 0 00-320 0v206.57c0 44.26 35.74 81.43 80 81.43h0c44.26 0 66.83-25.94 77.29-40 14.77-19.81 41.71-81.56 82.43-109.24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 304V184c0-48.4 43.2-88 96-88h0c52.8 0 96 39.6 96 88"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 239c25-18 79.82-15 79.82-15 26 0 41.17 29.42 26 50.6 0 0-36.86 42.4-41.86 61.4"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d77f46a4b7b9b7ee(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.48 68.09C347.09 34.5 302.88 16 256 16 159 16 80 95 80 192v206.57a97.59 97.59 0 0028 68.49A94.49 94.49 0 00176 496c19.93 0 41.06-7.69 62.8-22.87a181.46 181.46 0 0025.88-21.86C327.37 390.16 432 288.06 432 192c0-46.49-18.29-90.49-51.52-123.91zM368 200h-32v-16c0-39.7-35.89-72-80-72s-80 32.3-80 72v30.41c27.5-7.84 59.89-6.62 64.26-6.41a48 48 0 0138.62 75.9c-.3.41-.61.81-.95 1.2-16.55 19-36 45.49-38.46 55l-4.07 15.47-30.94-8.14 4.07-15.47c5.51-20.94 36.93-58.2 44.66-67.15A16 16 0 00239.82 240h-.88c-10.67-.58-42.66-.25-62.12 8l-.82.35V320h-32V184c0-57.35 50.24-104 112-104s112 46.65 112 104z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6405bd9016a36e33(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 16C159 16 80 95 80 192v206.57a97.59 97.59 0 0028 68.49A94.51 94.51 0 00176 496c36.86 0 67.18-15.62 90.12-46.42 4.48-6 9.55-14.74 15.42-24.85 15.32-26.37 36.29-62.47 63.17-80.74 25.77-17.51 47.23-39.54 62-63.72C423.51 252.94 432 223.24 432 192c0-97-78.95-176-176-176zm96 184a16 16 0 01-16-16c0-39.7-35.89-72-80-72s-80 32.3-80 72v30.42c27.19-7.84 58.4-6.72 64.28-6.42a48 48 0 0138.6 75.9c-.3.41-.61.81-.95 1.2-16.55 19-36 45.48-38.46 55a16 16 0 01-30.94-8.14c5.51-20.94 36.93-58.2 44.66-67.15A16 16 0 00239.82 240h-.88c-16.6-.89-45.89.8-62.94 8.31V304a16 16 0 01-32 0V184c0-57.35 50.24-104 112-104s112 46.65 112 104a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8d3068d015456c37(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M445.57 172.14c-16.06.1-14.48 29.73-34.49 15.75-7.43-5.18-12-12.71-21.33-15-8.15-2-16.5.08-24.55 1.47-9.15 1.58-20 2.29-26.94 9.22-6.71 6.67-10.26 15.62-17.4 22.33-13.81 13-19.64 27.19-10.7 45.57 8.6 17.67 26.59 27.26 46 26 19.07-1.27 38.88-12.33 38.33 15.38-.2 9.8 1.85 16.6 4.86 25.71 2.79 8.4 2.6 16.54 3.24 25.21 1.18 16.2 4.16 34.36 12.2 48.67l15-21.16c1.85-2.62 5.72-6.29 6.64-9.38 1.63-5.47-1.58-14.87-1.95-21s-.19-12.34-1.13-18.47c-1.32-8.59-6.4-16.64-7.1-25.13-1.29-15.81 1.6-28.43-10.58-41.65-11.76-12.75-29-15.81-45.47-13.22-8.3 1.3-41.71 6.64-28.3-12.33 2.65-3.73 7.28-6.79 10.26-10.34 2.59-3.09 4.84-8.77 7.88-11.18s17-5.18 21-3.95 8.17 7 11.64 9.56a49.89 49.89 0 0021.81 9.36c13.66 2 42.22-5.94 42-23.46-.04-8.4-7.84-20.1-10.92-27.96zM287.45 316.3c-5.33-22.44-35.82-29.94-52.26-42.11-9.45-7-17.86-17.81-30.27-18.69-5.72-.41-10.51.83-16.18-.64-5.2-1.34-9.28-4.14-14.82-3.41-10.35 1.36-16.88 12.42-28 10.92-10.55-1.42-21.42-13.76-23.82-23.81-3.08-12.92 7.14-17.11 18.09-18.26 4.57-.48 9.7-1 14.09.67 5.78 2.15 8.51 7.81 13.7 10.67 9.73 5.33 11.7-3.19 10.21-11.83-2.23-12.94-4.83-18.22 6.71-27.12 8-6.14 14.84-10.58 13.56-21.61-.76-6.48-4.31-9.41-1-15.86 2.51-4.91 9.4-9.34 13.89-12.27 11.59-7.56 49.65-7 34.1-28.16-4.57-6.21-13-17.31-21-18.83-10-1.89-14.44 9.27-21.41 14.19-7.2 5.09-21.22 10.87-28.43 3-9.7-10.59 6.43-14.07 10-21.46s-8.27-21.36-14.61-24.9l-29.81 33.43a41.52 41.52 0 008.34 31.86c5.93 7.63 15.37 10.08 15.8 20.5.42 10-1.14 15.12-7.68 22.15-2.83 3-4.83 7.26-7.71 10.07-3.53 3.43-2.22 2.38-7.73 3.32-10.36 1.75-19.18 4.45-29.19 7.21C95.34 199.94 93.8 172.69 86.2 162l-25 20.19c-.27 3.31 4.1 9.4 5.29 13 6.83 20.57 20.61 36.48 29.51 56.16 9.37 20.84 34.53 15.06 45.64 33.32 9.86 16.2-.67 36.71 6.71 53.67 5.36 12.31 18 15 26.72 24 8.91 9.09 8.72 21.53 10.08 33.36a305.22 305.22 0 007.45 41.28c1.21 4.69 2.32 10.89 5.53 14.76 2.2 2.66 9.75 4.95 6.7 5.83 4.26.7 11.85 4.68 15.4 1.76 4.68-3.84 3.43-15.66 4.24-21 2.43-15.9 10.39-31.45 21.13-43.35 10.61-11.74 25.15-19.69 34.11-33 8.73-12.98 11.36-30.49 7.74-45.68zm-33.39 26.32c-6 10.71-19.36 17.88-27.95 26.39-2.33 2.31-7.29 10.31-10.21 8.58-2.09-1.24-2.8-11.62-3.57-14a61.17 61.17 0 00-21.71-29.95c-3.13-2.37-10.89-5.45-12.68-8.7-2-3.53-.2-11.86-.13-15.7.11-5.6-2.44-14.91-1.06-20 1.6-5.87-1.48-2.33 3.77-3.49 2.77-.62 14.21 1.39 17.66 2.11 5.48 1.14 8.5 4.55 12.82 8 11.36 9.11 23.87 16.16 36.6 23.14 9.86 5.46 12.76 12.37 6.46 23.62zm-69.6-275.53c4.74 4.63 9.2 10.11 16.27 10.57 6.69.45 13-3.17 18.84 1.38 6.48 5 11.15 11.33 19.75 12.89 8.32 1.51 17.13-3.35 19.19-11.86 2-8.11-2.31-16.93-2.57-25.07 0-1.13.61-6.15-.17-7-.58-.64-5.42.08-6.16.1q-8.13.24-16.22 1.12a207.1 207.1 0 00-57.18 14.65c2.43 1.68 5.48 2.35 8.25 3.22zm171.94 56.18c8.49 0 17.11-3.8 14.37-13.62-2.3-8.23-6.22-17.16-15.76-12.72-6.07 2.82-14.67 10-15.38 17.12-.81 8.08 11.11 9.22 16.77 9.22zm-6.78 42.97c8.67 5.19 21.53 2.75 28.07-4.66 5.11-5.8 8.12-15.87 17.31-15.86a15.4 15.4 0 0110.82 4.41c3.8 3.93 3.05 7.62 3.86 12.54 1.81 11.05 13.66.63 16.75-3.65 2-2.79 4.71-6.93 3.8-10.56-.84-3.39-4.8-7-6.56-10.11-5.14-9-9.37-19.47-17.07-26.74-7.41-7-16.52-6.19-23.55 1.08-5.76 6-12.45 10.75-16.39 18.05-2.78 5.13-5.91 7.58-11.54 8.91-3.1.73-6.64 1-9.24 3.08-7.24 5.7-3.12 19.39 3.74 23.51z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e163ea8f1731dbd6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267 474l-.8-.13a.85.85 0 00.8.13zm181.9-286.22a5.51 5.51 0 00-10.67-.63A5.52 5.52 0 01433 191h-15.47a5.48 5.48 0 01-2.84-.79l-22.38-13.42a5.48 5.48 0 00-2.84-.79h-35.8a5.48 5.48 0 00-3.06.93l-44.15 29.43A5.52 5.52 0 00304 211v41.74a5.51 5.51 0 002.92 4.87l57.89 30.9a5.55 5.55 0 012.92 4.8l.27 23.49a5.53 5.53 0 002.85 4.75l23.26 12.87a5.54 5.54 0 012.85 4.83v48.6a5.52 5.52 0 009.17 4.14c9.38-8.26 22.83-20.32 24.62-23.08q4.44-6.87 8.33-14.07a207.39 207.39 0 0013.6-31c12.68-36.71 2.66-102.7-3.78-136.06zM286.4 302.8l-61.33-46a4 4 0 00-2.4-.8h-29.1a3.78 3.78 0 01-2.68-1.11l-13.72-13.72a4 4 0 00-2.83-1.17h-53.19a3.79 3.79 0 01-2.68-6.47l8.42-8.42a3.78 3.78 0 012.68-1.11h32.37a8 8 0 007.7-5.83l6.89-24.5a4 4 0 012-2.47L206 177.06a3.79 3.79 0 002.05-3.37v-12.5a3.82 3.82 0 01.68-2.17l14.6-21.02a3.75 3.75 0 011.78-1.38l20.43-7.67a3.79 3.79 0 002.46-3.55V114a3.8 3.8 0 00-1.69-3.16l-20.48-13.62A3.83 3.83 0 00222 97l-27.88 13.94a3.78 3.78 0 01-4-.41l-13.22-10.45a3.8 3.8 0 01.1-6l10.74-7.91a3.78 3.78 0 00-.09-6.16l-16.73-11.67a3.78 3.78 0 00-4-.22c-6.05 3.31-23.8 13.11-30.1 17.52a209.48 209.48 0 00-68.16 80c-1.82 3.76-4.07 7.59-4.29 11.72s-3.46 13.35-4.81 17.08a3.78 3.78 0 00.24 3.1l35.69 65.58a3.74 3.74 0 001.38 1.44l37.55 22.54a3.78 3.78 0 011.81 2.73l7.52 54.54a3.82 3.82 0 001.61 2.61l29.3 20.14a4 4 0 011.65 2.48l15.54 73.8a3.6 3.6 0 00.49 1.22c1.46 2.36 7.28 11 14.3 12.28-.65.18-1.23.59-1.88.78a47.63 47.63 0 015 1.16c2 .54 4 1 6 1.43 3.13.62 3.44 1.1 4.94-1.68 2-3.72 4.29-5 6-5.46a3.85 3.85 0 002.89-2.9l10.07-46.68a4 4 0 011.6-2.42l45-31.9a4 4 0 001.69-3.27V306a4 4 0 00-1.55-3.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M262 48s-3.65.21-4.39.23q-8.13.24-16.22 1.12A207.45 207.45 0 00184.21 64c2.43 1.68-1.75 3.22-1.75 3.22L189 80h35l24 12 21-12zm92.23 72.06l16.11-14a4 4 0 00-.94-6.65l-18.81-8.73a4 4 0 00-5.3 1.9l-7.75 16.21a4 4 0 001.49 5.11l10.46 6.54a4 4 0 004.74-.38zm75.41 20.61l-5.83-9c-.09-.14-.17-.28-.25-.43-1.05-2.15-9.74-19.7-17-26.51-5.45-5.15-7-3.67-7.43-2.53a3.77 3.77 0 01-1.19 1.6l-28.84 23.31a4 4 0 01-2.51.89h-14.93a4 4 0 00-2.83 1.17l-12 12a4 4 0 000 5.66l12 12a4 4 0 002.83 1.17h75.17a4 4 0 004-4.17l-.55-13.15a4 4 0 00-.64-2.01z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 72a184 184 0 11-130.1 53.9A182.77 182.77 0 01256 72m0-40C132.3 32 32 132.3 32 256s100.3 224 224 224 224-100.3 224-224S379.7 32 256 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4c3fc623aa2d6c54(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.74A224 224 0 1097.61 414.52 224 224 0 10414.39 97.74zM64 256.13a191.63 191.63 0 016.7-50.31c7.34 15.8 18 29.45 25.25 45.66 9.37 20.84 34.53 15.06 45.64 33.32 9.86 16.21-.67 36.71 6.71 53.67 5.36 12.31 18 15 26.72 24 8.91 9.08 8.72 21.52 10.08 33.36a305.36 305.36 0 007.45 41.27c0 .1 0 .21.08.31C117.8 411.13 64 339.8 64 256.13zm192 192a193.12 193.12 0 01-32-2.68c.11-2.71.16-5.24.43-7 2.43-15.9 10.39-31.45 21.13-43.35 10.61-11.74 25.15-19.68 34.11-33 8.78-13 11.41-30.5 7.79-45.69-5.33-22.44-35.82-29.93-52.26-42.1-9.45-7-17.86-17.82-30.27-18.7-5.72-.4-10.51.83-16.18-.63-5.2-1.35-9.28-4.15-14.82-3.42-10.35 1.36-16.88 12.42-28 10.92-10.55-1.41-21.42-13.76-23.82-23.81-3.08-12.92 7.14-17.11 18.09-18.26 4.57-.48 9.7-1 14.09.68 5.78 2.14 8.51 7.8 13.7 10.66 9.73 5.34 11.7-3.19 10.21-11.83-2.23-12.94-4.83-18.21 6.71-27.12 8-6.14 14.84-10.58 13.56-21.61-.76-6.48-4.31-9.41-1-15.86 2.51-4.91 9.4-9.34 13.89-12.27 11.59-7.56 49.65-7 34.1-28.16-4.57-6.21-13-17.31-21-18.83-10-1.89-14.44 9.27-21.41 14.19-7.2 5.09-21.22 10.87-28.43 3-9.7-10.59 6.43-14.06 10-21.46 1.65-3.45 0-8.24-2.78-12.75q5.41-2.28 11-4.23a15.6 15.6 0 008 3c6.69.44 13-3.18 18.84 1.38 6.48 5 11.15 11.32 19.75 12.88 8.32 1.51 17.13-3.34 19.19-11.86 1.25-5.18 0-10.65-1.2-16a190.83 190.83 0 01105 32.21c-2-.76-4.39-.67-7.34.7-6.07 2.82-14.67 10-15.38 17.12-.81 8.08 11.11 9.22 16.77 9.22 8.5 0 17.11-3.8 14.37-13.62-1.19-4.26-2.81-8.69-5.42-11.37a193.27 193.27 0 0118 14.14c-.09.09-.18.17-.27.27-5.76 6-12.45 10.75-16.39 18.05-2.78 5.14-5.91 7.58-11.54 8.91-3.1.73-6.64 1-9.24 3.08-7.24 5.7-3.12 19.4 3.74 23.51 8.67 5.19 21.53 2.75 28.07-4.66 5.11-5.8 8.12-15.87 17.31-15.86a15.4 15.4 0 0110.82 4.41c3.8 3.94 3.05 7.62 3.86 12.54 1.43 8.74 9.14 4 13.83-.41a192.12 192.12 0 019.24 18.77c-5.16 7.43-9.26 15.53-21.67 6.87-7.43-5.19-12-12.72-21.33-15.06-8.15-2-16.5.08-24.55 1.47-9.15 1.59-20 2.29-26.94 9.22-6.71 6.68-10.26 15.62-17.4 22.33-13.81 13-19.64 27.19-10.7 45.57 8.6 17.67 26.59 27.26 46 26 19.07-1.27 38.88-12.33 38.33 15.38-.2 9.81 1.85 16.6 4.86 25.71 2.79 8.4 2.6 16.54 3.24 25.21a158 158 0 004.74 30.07A191.75 191.75 0 01256 448.13z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$89b37d774e8a1588(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "272",
                    "x": "48",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 416v-64m0-272V48m144 416l-32-112M112 464l32-112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d54aa4f444f378dc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M468 64H278V32h-44v32H44a12 12 0 00-12 12v280a12 12 0 0012 12h78.19L89.93 470.46l36.53 9.61L161.74 368H234v64h44v-64h71.84l31 111.7 36.83-8.57L389.05 368H468a12 12 0 0012-12V76a12 12 0 00-12-12zm-26 266H70V102h372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M88 120h336v192H88z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e084b27e0dd11124(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "352",
                    "height": "208",
                    "x": "80",
                    "y": "112",
                    "rx": "12",
                    "ry": "12"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M432 64H272V48a16 16 0 00-32 0v16H80a48.05 48.05 0 00-48 48v208a48.05 48.05 0 0048 48h42.79l-26.17 91.6a16 16 0 1030.76 8.8L156.07 368H240v48a16 16 0 0032 0v-48h83.93l28.69 100.4a16 16 0 1030.76-8.8L389.21 368H432a48.05 48.05 0 0048-48V112a48.05 48.05 0 00-48-48zm16 256a16 16 0 01-16 16H80a16 16 0 01-16-16V112a16 16 0 0116-16h352a16 16 0 0116 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f3455935da16c43c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 48C192 48 96 171.69 96 286.55S160 464 256 464s160-62.59 160-177.45S320 48 256 48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c0e8308d0674ed3d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.39 381.05c-8.08 21.68-19.76 40.1-34.72 54.75-14.38 14.07-32.1 24.95-52.67 32.34C309.08 476 283.85 480 256 480s-53.08-4-75-11.86c-20.57-7.39-38.29-18.27-52.67-32.34-15-14.65-26.64-33.07-34.72-54.75C84.58 356.82 80 328.53 80 296.94c0-30.28 6.68-62.57 19.86-96A371 371 0 01151 111.42C195.78 53.56 241 32 256 32s62.67 22.4 105 79.42c18.33 24.71 38.87 58.34 51.17 89.54 13.18 33.41 19.86 65.7 19.86 96-.03 31.57-4.61 59.86-13.64 84.09z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6c2e6b58b0737495(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 480c-52.57 0-96.72-17.54-127.7-50.73C96.7 395.4 80 346.05 80 286.55 80 230.5 101.48 168 138.93 115 175.65 63 219.41 32 256 32s80.35 31 117.07 83C410.52 168 432 230.5 432 286.55c0 59.5-16.7 108.85-48.3 142.72C352.72 462.46 308.57 480 256 480z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1f3fa5db2d201a87(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "192",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$581259a125659453(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8b010a9d5bfa70ba(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6bf0dc20447d789d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "346",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "166",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e07e8da612fa7bee(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm-90 234a26 26 0 1126-26 26 26 0 01-26 26zm90 0a26 26 0 1126-26 26 26 0 01-26 26zm90 0a26 26 0 1126-26 26 26 0 01-26 26z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3a54a5a8cb6371e0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "346",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "166",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a37eee53abd4fcea(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "416",
                    "cy": "256",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "96",
                    "cy": "256",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9787693030380c73(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "416",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "96",
                    "cy": "256",
                    "r": "48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$69812e7db229e585(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "416",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "96",
                    "cy": "256",
                    "r": "48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f3d84bb67217a6c9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "346",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "166",
                    "r": "26"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$44351bf2bf83b68c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-234-90a26 26 0 1126 26 26 26 0 01-26-26zm0 90a26 26 0 1126 26 26 26 0 01-26-26zm0 90a26 26 0 1126 26 26 26 0 01-26-26z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2848c49c0686015d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "346",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "166",
                    "r": "26"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2e728e50c0adf71c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "416",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "96",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ae84e013219fe94b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "416",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "96",
                    "r": "48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8736b7c82b5c0d7e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "416",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "96",
                    "r": "48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2a666abcf670aeb6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 176v-40a40 40 0 0140-40h208a40 40 0 0140 40v240a40 40 0 01-40 40H216a40 40 0 01-40-40v-40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M272 336l80-80-80-80M48 256h288"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c9d1ee52c8c68bf1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 240h147.37l-64-64L266 153.37 368.63 256 266 358.63 243.37 336l64-64H160v148a12 12 0 0012 12h296a12 12 0 0012-12V92a12 12 0 00-12-12H172a12 12 0 00-12 12zm-128 0h128v32H32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f2a19d1afd1af2c1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 136v104h153.37l-52.68-52.69a16 16 0 0122.62-22.62l80 80a16 16 0 010 22.62l-80 80a16 16 0 01-22.62-22.62L313.37 272H160v104a56.06 56.06 0 0056 56h208a56.06 56.06 0 0056-56V136a56.06 56.06 0 00-56-56H216a56.06 56.06 0 00-56 56zM48 240a16 16 0 000 32h112v-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1f0af0d011bfa5f3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 176v-40a40 40 0 00-40-40H88a40 40 0 00-40 40v240a40 40 0 0040 40h192a40 40 0 0040-40v-40m64-160l80 80-80 80m-193-80h273"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d64dbd4907c81fed(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M335.69 272h-161v-32h161V92a12 12 0 00-12-12h-280a12 12 0 00-12 12v328a12 12 0 0012 12h280a12 12 0 0012-12zm83.37 0l-64 64 22.63 22.63L480.31 256 377.69 153.37 355.06 176l64 64h-83.37v32h83.37z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9811ab006fb7f8d9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 376V272H191a16 16 0 010-32h145V136a56.06 56.06 0 00-56-56H88a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h192a56.06 56.06 0 0056-56zm89.37-104l-52.68 52.69a16 16 0 0022.62 22.62l80-80a16 16 0 000-22.62l-80-80a16 16 0 00-22.62 22.62L425.37 240H336v32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7d732084795b8010(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432 320v112H320m101.8-10.23L304 304M80 192V80h112M90.2 90.23L208 208M320 80h112v112M421.77 90.2L304 208M192 432H80V320m10.23 101.8L208 304"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9fb4829a8394b79(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M432 320v112H320m101.8-10.23L304 304M80 192V80h112M90.2 90.23L208 208M320 80h112v112M421.77 90.2L304 208M192 432H80V320m10.23 101.8L208 304"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$40d12002f297cbf1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432 320v112H320m101.8-10.23L304 304M80 192V80h112M90.2 90.23L208 208M320 80h112v112M421.77 90.2L304 208M192 432H80V320m10.23 101.8L208 304"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$382a0d3d19376753(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M413.66 246.1H386a2 2 0 01-2-2v-77.24A38.86 38.86 0 00345.14 128H267.9a2 2 0 01-2-2V98.34c0-27.14-21.5-49.86-48.64-50.33a49.53 49.53 0 00-50.4 49.51V126a2 2 0 01-2 2H87.62A39.74 39.74 0 0048 167.62V238a2 2 0 002 2h26.91c29.37 0 53.68 25.48 54.09 54.85.42 29.87-23.51 57.15-53.29 57.15H50a2 2 0 00-2 2v70.38A39.74 39.74 0 0087.62 464H158a2 2 0 002-2v-20.93c0-30.28 24.75-56.35 55-57.06 30.1-.7 57 20.31 57 50.28V462a2 2 0 002 2h71.14A38.86 38.86 0 00384 425.14v-78a2 2 0 012-2h28.48c27.63 0 49.52-22.67 49.52-50.4s-23.2-48.64-50.34-48.64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$335f05b7e3b23bb2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M345.14 480H256v-45.71a31.3 31.3 0 00-9.59-22.65c-7.67-7.56-18.83-11.81-30.57-11.64a44.38 44.38 0 00-28.45 10.67c-5.2 4.6-11.39 12.56-11.39 24.42V480H87.62A55.68 55.68 0 0132 424.38V336h45.71c9.16 0 18.07-3.92 25.09-11a42.06 42.06 0 0012.2-29.92C114.7 273.89 97.26 256 76.91 256H32v-89.34a53.77 53.77 0 0116.53-39A55.88 55.88 0 0187.62 112h63.24V97.52A65.53 65.53 0 01217.54 32c35.49.62 64.36 30.38 64.36 66.33V112h63.24A54.28 54.28 0 01400 166.86v63.24h13.66c36.58 0 66.34 29 66.34 64.64 0 36.61-29.39 66.4-65.52 66.4H400v63.24c0 30.67-24.61 55.62-54.86 55.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e87d89b13931b8c4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M345.14 480H274a18 18 0 01-18-18v-27.71a31.32 31.32 0 00-9.71-22.77c-7.78-7.59-19.08-11.8-30.89-11.51-21.36.5-39.4 19.3-39.4 41.06V462a18 18 0 01-18 18H87.62A55.62 55.62 0 0132 424.38V354a18 18 0 0118-18h27.71c9.16 0 18.07-3.92 25.09-11a42.06 42.06 0 0012.2-29.92C114.7 273.89 97.26 256 76.91 256H50a18 18 0 01-18-18v-70.38A55.62 55.62 0 0187.62 112h55.24a8 8 0 008-8v-6.48A65.53 65.53 0 01217.54 32c35.49.62 64.36 30.38 64.36 66.33V104a8 8 0 008 8h55.24A54.86 54.86 0 01400 166.86v55.24a8 8 0 008 8h5.66c36.58 0 66.34 29 66.34 64.64 0 36.61-29.39 66.4-65.52 66.4H408a8 8 0 00-8 8v56A54.86 54.86 0 01345.14 480z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d9cc791874c0e79f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zm-176.34-64c-41.49 0-81.5-12.28-118.92-36.5-34.07-22-64.74-53.51-88.7-91v-.08c19.94-28.57 41.78-52.73 65.24-72.21a2 2 0 00.14-2.94L93.5 161.38a2 2 0 00-2.71-.12c-24.92 21-48.05 46.76-69.08 76.92a31.92 31.92 0 00-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416a239.13 239.13 0 0075.8-12.58 2 2 0 00.77-3.31l-21.58-21.58a4 4 0 00-3.83-1 204.8 204.8 0 01-51.16 6.47zm235.18-145.4c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96a227.34 227.34 0 00-74.89 12.83 2 2 0 00-.75 3.31l21.55 21.55a4 4 0 003.88 1 192.82 192.82 0 0150.21-6.69c40.69 0 80.58 12.43 118.55 37 34.71 22.4 65.74 53.88 89.76 91a.13.13 0 010 .16 310.72 310.72 0 01-64.12 72.73 2 2 0 00-.15 2.95l19.9 19.89a2 2 0 002.7.13 343.49 343.49 0 0068.64-78.48 32.2 32.2 0 00-.1-34.78z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 160a95.88 95.88 0 00-21.37 2.4 2 2 0 00-1 3.38l112.59 112.56a2 2 0 003.38-1A96 96 0 00256 160zm-90.22 73.66a2 2 0 00-3.38 1 96 96 0 00115 115 2 2 0 001-3.38z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5c1dde3b86ae81e2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M63.998 86.004l21.998-21.998L448 426.01l-21.998 21.998zM259.34 192.09l60.57 60.57a64.07 64.07 0 00-60.57-60.57zm-6.68 127.82l-60.57-60.57a64.07 64.07 0 0060.57 60.57z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 352a96 96 0 01-92.6-121.34l-69.07-69.08C66.12 187.42 39.24 221.14 16 256c26.42 44 62.56 89.24 100.2 115.18C159.38 400.92 206.33 416 255.76 416A233.47 233.47 0 00335 402.2l-53.61-53.6A95.84 95.84 0 01256 352zm0-192a96 96 0 0192.6 121.34L419.26 352c29.15-26.25 56.07-61.56 76.74-96-26.38-43.43-62.9-88.56-101.18-114.82C351.1 111.2 304.31 96 255.76 96a222.92 222.92 0 00-78.21 14.29l53.11 53.11A95.84 95.84 0 01256 160z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$833e79615d2bdf63(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zM248 315.85l-51.79-51.79a2 2 0 00-3.39 1.69 64.11 64.11 0 0053.49 53.49 2 2 0 001.69-3.39zm16-119.7L315.87 248a2 2 0 003.4-1.69 64.13 64.13 0 00-53.55-53.55 2 2 0 00-1.72 3.39z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M491 273.36a32.2 32.2 0 00-.1-34.76c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.68 96a226.54 226.54 0 00-71.82 11.79 4 4 0 00-1.56 6.63l47.24 47.24a4 4 0 003.82 1.05 96 96 0 01116 116 4 4 0 001.05 3.81l67.95 68a4 4 0 005.4.24 343.81 343.81 0 0067.24-77.4zM256 352a96 96 0 01-93.3-118.63 4 4 0 00-1.05-3.81l-66.84-66.87a4 4 0 00-5.41-.23c-24.39 20.81-47 46.13-67.67 75.72a31.92 31.92 0 00-.64 35.54c26.41 41.33 60.39 76.14 98.28 100.65C162.06 402 207.92 416 255.68 416a238.22 238.22 0 0072.64-11.55 4 4 0 001.61-6.64l-47.47-47.46a4 4 0 00-3.81-1.05A96 96 0 01256 352z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$94b4974aa3449c77(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 00-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 000-17.47C428.89 172.28 347.8 112 255.66 112z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "80",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$42757c35f933abce(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M394.82 141.18C351.1 111.2 304.31 96 255.76 96c-43.69 0-86.28 13-126.59 38.48C88.52 160.23 48.67 207 16 256c26.42 44 62.56 89.24 100.2 115.18C159.38 400.92 206.33 416 255.76 416c49 0 95.85-15.07 139.3-44.79C433.31 345 469.71 299.82 496 256c-26.38-43.43-62.9-88.56-101.18-114.82zM256 352a96 96 0 1196-96 96.11 96.11 0 01-96 96z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$249c7ca2aec24117(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M490.84 238.6c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96c-42.52 0-84.33 12.15-124.27 36.11-40.73 24.43-77.63 60.12-109.68 106.07a31.92 31.92 0 00-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416c46.71 0 93.81-14.43 136.2-41.72 38.46-24.77 72.72-59.66 99.08-100.92a32.2 32.2 0 00-.1-34.76zM256 352a96 96 0 1196-96 96.11 96.11 0 01-96 96z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a533fac686b1939e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M262.51 204.22L70 396.69C57.56 409.15 48 464 48 464s54.38-9.09 67.31-22L307.8 249.51"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "192.15",
                    "height": "64.05",
                    "x": "211.72",
                    "y": "172.19",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32.03",
                    "ry": "32.03",
                    "transform": "rotate(45 307.788 204.2)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M289.91 141s20.57 8.57 37.22-8.08l54.67-70.63c18.5-19.41 49.26-18.69 67.94 0h0c18.68 18.68 19.34 48.81 0 67.93l-70.68 54.67c-15.65 15.65-8.08 37.22-8.08 37.22M115.31 442s-26.48 17.34-44.56-.73-.75-44.58-.75-44.58"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3391c544178ad8a1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 96.22a63.84 63.84 0 00-18.95-45.61 65 65 0 00-45.71-19h-.76a61.78 61.78 0 00-44.22 19.09l-74.88 74.88-33.88-33.86-34.07 33.91-33.85 34 44 44L32 409.37V480h70.63l205.7-205.71L352 317.94l11.31-11.19c.11-.1 10.42-10.31 22.79-22.68l33.85-34-33.89-33.89L461 141.23a63.18 63.18 0 0019-45.01zM245 292.35L219.65 267l40.68-40.69 25.38 25.38z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$aa3d81fa576bb97b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461.05 51a65 65 0 00-45.71-19h-.76a61.81 61.81 0 00-44.36 19.25 12.81 12.81 0 00-1.07 1.25l-54 69.76c-5.62 7.1-12.74 8.68-16.78 4.64l-1.9-1.9a48 48 0 00-67.92 67.92l9.91 9.91a2 2 0 010 2.83L58.7 385.38C54 390.05 46.9 399.85 38.85 431c-4.06 15.71-6.51 29.66-6.61 30.24A16 16 0 0048 480a15.68 15.68 0 002.64-.22c.58-.1 14.44-2.43 30.13-6.44 31.07-7.94 41.05-15.24 45.85-20l179.77-179.79a2 2 0 012.82 0l9.92 9.92a48 48 0 0067.92-67.93l-1.59-1.54c-5-5-2.52-12.11 4.32-17.14l69.75-53.94a17.82 17.82 0 001.47-1.32 63.2 63.2 0 0019-45A63.88 63.88 0 00461.05 51zM250.78 283.9c-2.92 2.92-16.18 7.92-23.39.71s-2.24-20.42.69-23.35l33-33a2 2 0 012.83 0l19.84 19.83a2 2 0 010 2.83z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b59e25964d28338f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M322 416c0 35.35-20.65 64-56 64H134c-35.35 0-56-28.65-56-64m258-80c17.67 0 32 17.91 32 40h0c0 22.09-14.33 40-32 40H64c-17.67 0-32-17.91-32-40h0c0-22.09 14.33-40 32-40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M344 336H179.31a8 8 0 00-5.65 2.34l-26.83 26.83a4 4 0 01-5.66 0l-26.83-26.83a8 8 0 00-5.65-2.34H56a24 24 0 01-24-24h0a24 24 0 0124-24h288a24 24 0 0124 24h0a24 24 0 01-24 24zM64 276v-.22c0-55 45-83.78 100-83.78h72c55 0 100 29 100 84v-.22M241 112l7.44 63.97"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 480h139.31a32 32 0 0031.91-29.61L463 112"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 112l16-64 47-16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M224 112h256"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4abb0eec2e2c0f59(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 352H184.36l-41 35-41-35H16v24c0 30.59 21.13 55.51 47.26 56 2.43 15.12 8.31 28.78 17.16 39.47C93.51 487.28 112.54 496 134 496h132c21.46 0 40.49-8.72 53.58-24.55 8.85-10.69 14.73-24.35 17.16-39.47 13.88-.25 26.35-7.4 35-18.63A61.26 61.26 0 00384 376zm-279-32l38.33 28.19L182 320h202v-8a40.07 40.07 0 00-32-39.2c-.82-29.69-13-54.54-35.51-72C295.67 184.56 267.85 176 236 176h-72c-68.22 0-114.43 38.77-116 96.8A40.07 40.07 0 0016 312v8h89z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M463.08 96h-74.59l8.92-35.66L442 45l-10-29-62 20-14.49 60H208v32h18.75l1.86 16H236c39 0 73.66 10.9 100.12 31.52A121.9 121.9 0 01371 218.07a124.16 124.16 0 0110.73 32.65 72 72 0 0127.89 90.9A96 96 0 01416 376c0 22.34-7.6 43.63-21.4 59.95a80 80 0 01-31.83 22.95 109.21 109.21 0 01-18.53 33c-1.18 1.42-2.39 2.81-3.63 4.15H416c16 0 23-8 25-23l36.4-345H496V96z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$138915cb0cdbaf57(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 128h.09m111.46-32h-91.06l8.92-35.66 38.32-13.05c8.15-2.77 13-11.43 10.65-19.71a16 16 0 00-20.54-10.73l-47 16a16 16 0 00-10.36 11.27L355.51 96H224.45c-8.61 0-16 6.62-16.43 15.23A16 16 0 00224 128h2.75l1 8.66A8.3 8.3 0 00236 144c39 0 73.66 10.9 100.12 31.52A121.9 121.9 0 01371 218.07a123.4 123.4 0 0110.12 29.51 7.83 7.83 0 003.29 4.88 72 72 0 0126.38 86.43 7.92 7.92 0 00-.15 5.53A96 96 0 01416 376c0 22.34-7.6 43.63-21.4 59.95a80.12 80.12 0 01-28.78 21.67 8 8 0 00-4.21 4.37 108.19 108.19 0 01-17.37 29.86 2.5 2.5 0 001.9 4.11h49.21a48.22 48.22 0 0047.85-44.14L477.4 128h2.6a16 16 0 0016-16.77c-.42-8.61-7.84-15.23-16.45-15.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M108.69 320a23.87 23.87 0 0117 7l15.51 15.51a4 4 0 005.66 0L162.34 327a23.87 23.87 0 0117-7h196.58a8 8 0 008.08-7.92V312a40.07 40.07 0 00-32-39.2c-.82-29.69-13-54.54-35.51-72C295.67 184.56 267.85 176 236 176h-72c-68.22 0-114.43 38.77-116 96.8A40.07 40.07 0 0016 312a8 8 0 008 8zm77.25 32a8 8 0 00-5.66 2.34l-22.14 22.15a20 20 0 01-28.28 0l-22.14-22.15a8 8 0 00-5.66-2.34h-69.4a15.93 15.93 0 00-15.76 13.17A65.22 65.22 0 0016 376c0 30.59 21.13 55.51 47.26 56 2.43 15.12 8.31 28.78 17.16 39.47C93.51 487.28 112.54 496 134 496h132c21.46 0 40.49-8.72 53.58-24.55 8.85-10.69 14.73-24.35 17.16-39.47 26.13-.47 47.26-25.39 47.26-56a65.22 65.22 0 00-.9-10.83A15.93 15.93 0 00367.34 352z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$de0debbff8238027(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "184",
                    "r": "152",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 336v144m58-64H198"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c04915cd6756c66d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M430 190c0-95.94-78.06-174-174-174S82 94.06 82 190c0 88.49 66.4 161.77 152 172.61V394h-58v44h58v58h44v-58h58v-44h-58v-31.39c85.6-10.84 152-84.12 152-172.61zm-304 0c0-71.68 58.32-130 130-130s130 58.32 130 130-58.32 130-130 130-130-58.32-130-130z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bcb65ecf5d60514b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M430 190c0-95.94-78.06-174-174-174S82 94.06 82 190c0 88.49 66.4 161.77 152 172.61V394h-36a22 22 0 000 44h36v36a22 22 0 0044 0v-36h36a22 22 0 000-44h-36v-31.39c85.6-10.84 152-84.12 152-172.61zm-304 0c0-71.68 58.32-130 130-130s130 58.32 130 130-58.32 130-130 130-130-58.32-130-130z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f7c0249667f4451b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 80H128c-26 0-43 14-48 40L48 272v112a48.14 48.14 0 0048 48h320a48.14 48.14 0 0048-48V272l-32-152c-5-27-23-40-48-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 272h144m128 0h144m-272 0a64 64 0 00128 0M144 144h224m-240 64h256"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2fbb1931ad72fe49(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 128h256v38H128zm-16 64h288v38H112z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64H64L32 256v192h448V256zm-12 192H320a64 64 0 01-128 0H76l22-150h316z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$86c08eebd42e39d6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.66 268.7l-32-151.81C441.48 83.77 417.68 64 384 64H128c-16.8 0-31 4.69-42.1 13.94s-18.37 22.31-21.58 38.89l-32 151.87A16.65 16.65 0 0032 272v112a64 64 0 0064 64h320a64 64 0 0064-64V272a16.65 16.65 0 00-.34-3.3zm-384-145.4v-.28c3.55-18.43 13.81-27 32.29-27H384c18.61 0 28.87 8.55 32.27 26.91 0 .13.05.26.07.39l26.93 127.88a4 4 0 01-3.92 4.82H320a15.92 15.92 0 00-16 15.82 48 48 0 11-96 0A15.92 15.92 0 00192 256H72.65a4 4 0 01-3.92-4.82z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M368 160H144a16 16 0 010-32h224a16 16 0 010 32zm16 64H128a16 16 0 010-32h256a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$365e0c806c1274a1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 80H128c-26 0-43 14-48 40L48 272v112a48.14 48.14 0 0048 48h320a48.14 48.14 0 0048-48V272l-32-152c-5-27-23-40-48-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 272h144m128 0h144m-272 0a64 64 0 00128 0"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b6d0a72853d1b330(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64H64L32 256v192h448V256zm-12 192H320a64 64 0 01-128 0H76l22-150h316z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$83627bb337ddc7ad(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 336v96a48.14 48.14 0 0048 48h320a48.14 48.14 0 0048-48v-96"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 336h144m128 0h144m-272 0a64 64 0 00128 0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 32H128c-26 0-43 14-48 40L48 192v96a48.14 48.14 0 0048 48h320a48.14 48.14 0 0048-48v-96L432 72c-5-27-23-40-48-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 192h144m128 0h144m-272 0a64 64 0 00128 0"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6f95e1b8f06807f6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 16H64L32 176v144h448V176zm-12 160H320a64 64 0 01-128 0H76L98 58h316zM320 352a64 64 0 01-128 0H32v144h448V352z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b2fbb3e022c9db92(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 352H320a16 16 0 00-16 16 48 48 0 01-96 0 16 16 0 00-16-16H48a16 16 0 00-16 16v64a64.07 64.07 0 0064 64h320a64.07 64.07 0 0064-64v-64a16 16 0 00-16-16zm15.46-164.12L447.61 68.45C441.27 35.59 417.54 16 384 16H128c-16.8 0-31 4.69-42.1 13.94S67.66 52 64.4 68.4L32.54 187.88A15.9 15.9 0 0032 192v48c0 35.29 28.71 80 64 80h320c35.29 0 64-44.71 64-80v-48a15.9 15.9 0 00-.54-4.12zM440.57 176H320a15.92 15.92 0 00-16 15.82 48 48 0 11-96 0A15.92 15.92 0 00192 176H71.43a2 2 0 01-1.93-2.52L95.71 75c3.55-18.41 13.81-27 32.29-27h256c18.59 0 28.84 8.53 32.25 26.85l26.25 98.63a2 2 0 01-1.93 2.52z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7e60e6b3dd4a7919(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.66 268.7l-32-151.81C441.48 83.77 417.68 64 384 64H128c-16.8 0-31 4.69-42.1 13.94s-18.37 22.31-21.58 38.89l-32 151.87A16.65 16.65 0 0032 272v112a64 64 0 0064 64h320a64 64 0 0064-64V272a16.65 16.65 0 00-.34-3.3zm-384-145.4v-.28c3.55-18.43 13.81-27 32.29-27H384c18.61 0 28.87 8.55 32.27 26.91 0 .13.05.26.07.39l26.93 127.88a4 4 0 01-3.92 4.82H320a15.92 15.92 0 00-16 15.82 48 48 0 11-96 0A15.92 15.92 0 00192 256H72.65a4 4 0 01-3.92-4.82z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c71cc11964747064(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "320",
                    "x": "48",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "384",
                    "y": "336",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "384",
                    "y": "256",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "384",
                    "y": "176",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "384",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "48",
                    "y": "336",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "48",
                    "y": "256",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "48",
                    "y": "176",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "48",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "256",
                    "height": "160",
                    "x": "128",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "256",
                    "height": "160",
                    "x": "128",
                    "y": "256",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4363aae2fb59e291(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 80H32v352h448zM112 352v48H64v-48zm0-80v48H64v-48zm0-80v48H64v-48zm0-80v48H64v-48zm256 160H144v-32h224zm80 80v48h-48v-48zm0-80v48h-48v-48zm0-80v48h-48v-48zm0-80v48h-48v-48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f3454ee466b813c5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 80H76a44.05 44.05 0 00-44 44v264a44.05 44.05 0 0044 44h360a44.05 44.05 0 0044-44V124a44.05 44.05 0 00-44-44zM112 388a12 12 0 01-12 12H76a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12H76a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12H76a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12H76a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm241.68 124H158.32a16 16 0 010-32h195.36a16 16 0 110 32zM448 388a12 12 0 01-12 12h-24a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12h-24a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12h-24a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12h-24a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$486f7730bee84710(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 208h224m-192 64h160m-112 64h64"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$97fbd16697e818a0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm48 304h-96v-32h96zm48-64H160v-32h192zm32-64H128v-32h256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$27dfe5a6d3e70eed(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm32 304h-64a16 16 0 010-32h64a16 16 0 010 32zm48-64H176a16 16 0 010-32h160a16 16 0 010 32zm32-64H144a16 16 0 010-32h224a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8c37e89318796163(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M32 144h448M112 256h288M208 368h96"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$dd34304366c68f40(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 120h480v48H16zm80 112h320v48H96zm96 112h128v48H192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5f8d11102f494a0f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472 168H40a24 24 0 010-48h432a24 24 0 010 48zm-80 112H120a24 24 0 010-48h272a24 24 0 010 48zm-96 112h-80a24 24 0 010-48h80a24 24 0 010 48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$12f6a38136c7e190(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M390.42 75.28a10.45 10.45 0 01-5.32-1.44C340.72 50.08 302.35 40 256.35 40c-45.77 0-89.23 11.28-128.76 33.84C122 77 115.11 74.8 111.87 69a12.4 12.4 0 014.63-16.32A281.81 281.81 0 01256.35 16c49.23 0 92.23 11.28 139.39 36.48a12 12 0 014.85 16.08 11.3 11.3 0 01-10.17 6.72zm-330.79 126a11.73 11.73 0 01-6.7-2.16 12.26 12.26 0 01-2.78-16.8c22.89-33.6 52-60 86.69-78.48 72.58-38.84 165.51-39.12 238.32-.24 34.68 18.48 63.8 44.64 86.69 78a12.29 12.29 0 01-2.78 16.8 11.26 11.26 0 01-16.18-2.88c-20.8-30.24-47.15-54-78.36-70.56-66.34-35.28-151.18-35.28-217.29.24-31.44 16.8-57.79 40.8-78.59 71a10 10 0 01-9.02 5.08zM204.1 491a10.66 10.66 0 01-8.09-3.6C175.9 466.48 165 453 149.55 424c-16-29.52-24.27-65.52-24.27-104.16 0-71.28 58.71-129.36 130.84-129.36S387 248.56 387 319.84a11.56 11.56 0 11-23.11 0c0-58.08-48.32-105.36-107.72-105.36S148.4 261.76 148.4 319.84c0 34.56 7.39 66.48 21.49 92.4 14.8 27.6 25 39.36 42.77 58.08a12.67 12.67 0 010 17 12.44 12.44 0 01-8.56 3.68zm165.75-44.4c-27.51 0-51.78-7.2-71.66-21.36a129.1 129.1 0 01-55-105.36 11.57 11.57 0 1123.12 0 104.28 104.28 0 0044.84 85.44c16.41 11.52 35.6 17 58.72 17a147.41 147.41 0 0024-2.4c6.24-1.2 12.25 3.12 13.4 9.84a11.92 11.92 0 01-9.47 13.92 152.28 152.28 0 01-27.95 2.88zM323.38 496a13 13 0 01-3-.48c-36.76-10.56-60.8-24.72-86-50.4-32.37-33.36-50.16-77.76-50.16-125.28 0-38.88 31.9-70.56 71.19-70.56s71.2 31.68 71.2 70.56c0 25.68 21.5 46.56 48.08 46.56s48.08-20.88 48.08-46.56c0-90.48-75.13-163.92-167.59-163.92-65.65 0-125.75 37.92-152.79 96.72-9 19.44-13.64 42.24-13.64 67.2 0 18.72 1.61 48.24 15.48 86.64 2.32 6.24-.69 13.2-6.7 15.36a11.34 11.34 0 01-14.79-7 276.39 276.39 0 01-16.88-95c0-28.8 5.32-55 15.72-77.76 30.75-67 98.94-110.4 173.6-110.4 105.18 0 190.71 84.24 190.71 187.92 0 38.88-31.9 70.56-71.2 70.56s-71.2-31.68-71.2-70.56c.01-25.68-21.49-46.6-48.07-46.6s-48.08 20.88-48.08 46.56c0 41 15.26 79.44 43.23 108.24 22 22.56 43 35 75.59 44.4 6.24 1.68 9.71 8.4 8.09 14.64a11.39 11.39 0 01-10.87 9.16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3d1c4e08b854d2e4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M56.79 200.58l12.36 7.5 7.35-13.58C93.07 166.75 143.78 102 256 102c115 0 164 70.32 180.1 93.46l8.16 12.7L469.88 192l-8.54-13.36c-8.88-12.85-27.52-39.53-60.78-63.1C360.15 86.82 311.5 72.25 256 72.25c-128.07 0-186.69 75.11-206 107.25L42.63 192 54 198.86a14.09 14.09 0 001.63 1.1 12.57 12.57 0 001.16.62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M379.22 172.32c-35.54-28.93-78.12-44.25-123.22-44.25-97.52 0-162.31 66-183.33 131.47C53.42 320 76.82 407.61 77.8 411.36l4.38 13.81 29.93-6.43-4.74-15c-.21-.75-22.1-82.93-5.41-135.21 9-28.08 27.73-55.4 51.35-74.79C181.81 170.39 217.35 158 256 158c90.58 0 141.93 70.61 156.45 108.11 11.27 28.93 8.67 61.82-6.28 82-5.53 7.39-15.28 16.07-30.12 15.32-33.81-1.72-39.66-18.43-47.79-50.25-3.9-15.32-7.9-31.18-17.87-44-12.14-15.75-29.8-23.36-54.28-23.36-26.33 0-46.27 8.68-59.38 25.72-28.6 37.28-10 100.93-9.21 103.61l.22.85c1.41 3.86 36.08 96.65 128.93 119.68l14.77 3.21 8.09-28.71-15.27-3.43c-74.22-18.43-105.21-94.39-107.59-100.39a152.44 152.44 0 01-5.1-29.79c-1.08-14.46-.32-34.39 9.43-47.14 7.15-9.32 18.64-13.82 35-13.82 29.79 0 34.78 14.57 42.58 44.79 7.58 29.46 18 69.85 75.84 72.75 22.21 1.07 42.26-8.79 56.34-27.65 21.13-28.28 25.14-71.57 10.19-110.14-11.68-30.36-34.21-60.54-61.73-83.04z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M154.18 343.21c-3.47-28.28 1.41-71 26.55-98.78 17.44-19.29 42.79-29 75.19-29 37.49 0 65.87 16.72 84.51 49.61a154 154 0 0117.88 53.25l1.43 14.69 30-2.2a112.63 112.63 0 00-1-15.6c-.11-1.28-3.57-32.46-21-63.75-24.06-43.11-62.63-65.93-111.74-65.93-41.5 0-74.55 13.18-98.06 39.11-31.85 35.14-38.35 86.25-33.91 122.35v.33c7.97 54.53 28.97 98.14 66.12 137.14l11.6 11.22 20.95-21.79-10.34-9.79c-32.72-34.28-51.25-72.64-58.18-120.86zM132.47 72.66c11.08-6.72 50.27-26.77 123.53-26.77 87.54 0 126.44 28.72 126.87 28.93l13.9 8.86L413 58.47l-13.22-8.56c-.52-.38-1.06-.76-1.6-1.12C385.5 40.54 340.54 16 256 16c-87.71 0-132.75 26.48-143.41 33.71L99 58.52l16.2 25.21z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M390.59 415.21c-33.37 3.75-60.45-2.67-80.71-18.85-34.24-27.43-38.68-75.11-38.79-76l-1.23-14.88-30.53 2.23 1.31 15c.22 2.46 5.2 60.75 49.62 96.54 22.11 17.89 49.74 26.89 82.24 26.89a187 187 0 0021.56-1.29l16.59-2.09-6.1-29.71z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$15cb81150d9b3460(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M63.28 202a15.29 15.29 0 01-7.7-2 14.84 14.84 0 01-5.52-20.46C69.34 147.36 128 72.25 256 72.25c55.47 0 104.12 14.57 144.53 43.29 33.26 23.57 51.9 50.25 60.78 63.1a14.79 14.79 0 01-4 20.79 15.52 15.52 0 01-21.24-4C420 172.32 371 102 256 102c-112.25 0-163 64.71-179.53 92.46A15 15 0 0163.28 202z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320.49 496a15.31 15.31 0 01-3.79-.43c-92.85-23-127.52-115.82-128.93-119.68l-.22-.85c-.76-2.68-19.39-66.33 9.21-103.61 13.11-17 33.05-25.72 59.38-25.72 24.48 0 42.14 7.61 54.28 23.36 10 12.86 14 28.72 17.87 44 8.13 31.82 14 48.53 47.79 50.25 14.84.75 24.59-7.93 30.12-15.32 14.95-20.15 17.55-53 6.28-82C398 228.57 346.61 158 256 158c-38.68 0-74.22 12.43-102.72 35.79-23.59 19.35-42.28 46.67-51.28 74.75-16.69 52.28 5.2 134.46 5.41 135.21A14.83 14.83 0 0196.54 422a15.39 15.39 0 01-18.74-10.6c-1-3.75-24.38-91.4-5.1-151.82 21-65.47 85.81-131.47 183.33-131.47 45.07 0 87.65 15.32 123.19 44.25 27.52 22.5 50 52.72 61.76 82.93 14.95 38.57 10.94 81.86-10.19 110.14-14.08 18.86-34.13 28.72-56.34 27.65-57.86-2.9-68.26-43.29-75.84-72.75-7.8-30.22-12.79-44.79-42.58-44.79-16.36 0-27.85 4.5-35 13.82-9.75 12.75-10.51 32.68-9.43 47.14a152.44 152.44 0 005.1 29.79c2.38 6 33.37 82 107.59 100.39a14.88 14.88 0 0111 18.11 15.36 15.36 0 01-14.8 11.21z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M201.31 489.14a15.5 15.5 0 01-11.16-4.71c-37.16-39-58.18-82.61-66.09-137.14V347c-4.44-36.1 2.06-87.21 33.91-122.35 23.51-25.93 56.56-39.11 98.06-39.11 49.08 0 87.65 22.82 111.7 65.89 17.45 31.29 20.91 62.47 21 63.75a15.07 15.07 0 01-13.65 16.4 15.26 15.26 0 01-16.79-13.29A154 154 0 00340.43 265c-18.64-32.89-47-49.61-84.51-49.61-32.4 0-57.75 9.75-75.19 29-25.14 27.75-30 70.5-26.55 98.78 6.93 48.22 25.46 86.58 58.18 120.86a14.7 14.7 0 01-.76 21.11 15.44 15.44 0 01-10.29 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M372.5 446.18c-32.5 0-60.13-9-82.24-26.89-44.42-35.79-49.4-94.08-49.62-96.54a15.27 15.27 0 0130.45-2.36c.11.86 4.55 48.54 38.79 76 20.26 16.18 47.34 22.6 80.71 18.85a15.2 15.2 0 0116.91 13.18 14.92 14.92 0 01-13.44 16.5 187 187 0 01-21.56 1.26zm25.68-397.39C385.5 40.54 340.54 16 256 16c-88.74 0-133.81 27.11-143.78 34a11.59 11.59 0 00-1.84 1.4.36.36 0 01-.22.1 14.87 14.87 0 00-5.09 11.15 15.06 15.06 0 0015.31 14.85 15.56 15.56 0 008.88-2.79c.43-.32 39.22-28.82 126.77-28.82S382.58 74.29 383 74.5a15.25 15.25 0 009.21 3 15.06 15.06 0 0015.29-14.89 14.9 14.9 0 00-9.32-13.82z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2a62405991601a97(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M240 152c-50.71 12.21-94.15 52.31-120.3 73.43a261.14 261.14 0 00-23.81-19.58C59.53 179.29 16 176 16 176s11.37 51.53 41.36 79.83C27.37 284.14 16 335.67 16 335.67s43.53-3.29 79.89-29.85a259.18 259.18 0 0023.61-19.41c26.1 21.14 69.74 61.34 120.5 73.59l-16 56c39.43-6.67 78.86-35.51 94.72-48.25C448 362 496 279 496 256c0-22-48-106-176.89-111.73C303.52 131.78 263.76 102.72 224 96z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "416",
                    "cy": "239.99",
                    "r": "16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "20",
                    "strokeWidth": "32",
                    "d": "M378.37 356a199.22 199.22 0 010-200"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8ffe4e02c6c185cd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M335.45 256a214.83 214.83 0 0129.08-108l7.62-13.26a280.69 280.69 0 00-48.64-7.15c-21.94-16.9-54.64-36.95-92.34-43.33L208 80l13.37 61.86c-41.67 14.14-78.43 42.86-102.76 62.62q-7.06-5.91-14.78-11.55c-39.71-29-82.6-31.8-84.4-31.9L0 160l2.67 19.31c.29 2 6.79 44.73 31.65 76.52C9.46 287.63 3 330.33 2.67 332.36L0 352l19.43-1.36c1.8-.1 44.69-2.89 84.4-31.9q7.58-5.53 14.56-11.37c24.37 19.83 61.14 48.6 102.86 62.74L208 432l23.17-4.22c37.49-6.34 70.08-26.4 92-43.32a284.27 284.27 0 0049.32-7.23l-7.91-13.18A214.92 214.92 0 01335.45 256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M499.59 221.75c-5.85-9.88-16.54-24.9-34.19-40.28a209.82 209.82 0 00-62-37L392.23 164a183.22 183.22 0 00-.09 183.87l11.75 19.57a209.26 209.26 0 0061.42-36.49C497.05 303.47 512 269 512 256c0-12.31-8-26.74-12.41-34.25zM416 256a16 16 0 1116-16 16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5b4869f816138e90(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256c0-16.54-14.27-46.76-45.61-74a207.06 207.06 0 00-60.28-36.12 3.15 3.15 0 00-3.93 1.56c-.15.29-.3.57-.47.86l-9.59 15.9a183.24 183.24 0 00.07 183.78l.23.39 8.74 16a4 4 0 004.94 1.82C479.63 337.42 512 281.49 512 256zm-93.92-.14a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M335.45 256a214.8 214.8 0 0129.08-108l.12-.21 4.62-7.67a4 4 0 00-2.59-6 284.29 284.29 0 00-39.26-5.39 7.94 7.94 0 01-4.29-1.6c-19.28-14.66-57.5-40.3-96.46-46.89a16 16 0 00-18 20.18l10.62 37.17a4 4 0 01-2.42 4.84c-36.85 13.69-68.59 38.75-91.74 57.85a8 8 0 01-10.06.06q-4.72-3.75-9.69-7.39c-39.64-28.95-86.21-32.76-88.17-32.9a16 16 0 00-16.83 19.4c.42 1.93 9.19 40.69 31.7 71.61a8.09 8.09 0 010 9.55C9.57 291.52.8 330.29.38 332.22a16 16 0 0016.83 19.4c2-.14 48.53-4 88.12-32.88q4.85-3.56 9.47-7.22a8 8 0 0110.06.07c23.25 19.19 55.05 44.28 92 58a4 4 0 012.42 4.83l-10.66 37.18a16 16 0 0018 20.18c17.16-2.9 51.88-12.86 96.05-46.83a8.15 8.15 0 014.36-1.65 287.36 287.36 0 0039.22-5.3 4 4 0 002.69-5.83l-4.51-8.29A214.81 214.81 0 01335.45 256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b60583da320dcec5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352.92 80C288 80 256 144 256 144s-32-64-96.92-64c-52.76 0-94.54 44.14-95.08 96.81-1.1 109.33 86.73 187.08 183 252.42a16 16 0 0018 0c96.26-65.34 184.09-143.09 183-252.42-.54-52.67-42.32-96.81-95.08-96.81z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 256h112l48-96 48 160 48-96 32 64h128"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bf4bcda5bf3cb7a5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 272h-37.34a261.41 261.41 0 01-18.25 32H480zM32 240v32h37.34a225.1 225.1 0 01-12.4-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M304 259.78l-51.73 103.46-48-160L169.89 272H69.34c10 20.92 23.5 41.41 40.63 61.68 40.12 47.46 94.25 79.75 137 108.32l9 6 9-6c42.78-28.57 96.91-60.86 137-108.32A322.78 322.78 0 00424.41 304h-98.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M211.73 116.76l48 160L304 188.22 345.89 272h96.77A213.13 213.13 0 00464 176.65C463.37 114.54 413.54 64 352.92 64c-48.11 0-80.1 28-96.92 48.21C239.18 92 207.19 64 159.08 64 98.46 64 48.63 114.54 48 176.65A211.23 211.23 0 0056.94 240h93.17z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2f97e6bb1a8d41d1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M193.69 152.84a16 16 0 0129.64 2.56l36.4 121.36 30-59.92a16 16 0 0128.62 0L345.89 272h96.76A213.08 213.08 0 00464 176.65C463.37 114.54 413.54 64 352.92 64c-48.09 0-80 29.54-96.92 51-16.88-21.49-48.83-51-96.92-51C98.46 64 48.63 114.54 48 176.65A211.13 211.13 0 0056.93 240h93.18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M321.69 295.16L304 259.78l-33.69 67.38A16 16 0 01256 336q-.67 0-1.38-.06a16 16 0 01-14-11.34l-36.4-121.36-30 59.92A16 16 0 01160 272H69.35q14 29.29 37.27 57.66c18.77 22.88 52.8 59.46 131.39 112.81a31.84 31.84 0 0036 0c78.59-53.35 112.62-89.93 131.39-112.81a316.79 316.79 0 0019-25.66H336a16 16 0 01-14.31-8.84zM464 272h-21.35a260.11 260.11 0 01-18.25 32H464a16 16 0 000-32zM48 240a16 16 0 000 32h21.35a225.22 225.22 0 01-12.42-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5e864ae1bbcf78d1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M80 464V68.14a8 8 0 014-6.9C91.81 56.66 112.92 48 160 48c64 0 145 48 192 48a199.53 199.53 0 0077.23-15.77 2 2 0 012.77 1.85v219.36a4 4 0 01-2.39 3.65C421.37 308.7 392.33 320 352 320c-48 0-128-32-192-32s-80 16-80 16"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a833347c8551b02(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M102 480H64V57.37l4.69-4.68C72.14 49.23 92.78 32 160 32c37.21 0 78.83 14.71 115.55 27.68C305.12 70.13 333.05 80 352 80c42.83 0 72.72-14.25 73-14.4l23-11.14v259.43l-8.84 4.42C437.71 319 403.19 336 352 336c-24.14 0-54.38-7.14-86.39-14.71C229.63 312.79 192.43 304 160 304c-36.87 0-49.74 5.58-58 9.11z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2531969180bf3938(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 480a16 16 0 01-16-16V68.13a24 24 0 0111.9-20.72C88 40.38 112.38 32 160 32c37.21 0 78.83 14.71 115.55 27.68C305.12 70.13 333.05 80 352 80a183.84 183.84 0 0071-14.5 18 18 0 0125 16.58v219.36a20 20 0 01-12 18.31c-8.71 3.81-40.51 16.25-84 16.25-24.14 0-54.38-7.14-86.39-14.71C229.63 312.79 192.43 304 160 304c-36.87 0-55.74 5.58-64 9.11V464a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f6d479ffe26543bc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 320c0-93 124-165 96-272 66 0 192 96 192 272a144 144 0 01-288 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 368c0 57.71-32 80-64 80s-64-22.29-64-80 40-86 32-128c42 0 96 70.29 96 128z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$68960e345da4e3f2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M394.24 197.56a300.67 300.67 0 00-53.38-90C301.2 61.65 240 32 192 32c19 70-14.36 117.12-44.79 163.77C122 234.36 96 274.27 96 320c0 88.22 71.78 160 160 160s160-71.78 160-160c0-43.3-7.32-84.49-21.76-122.44zM288.33 418.69C278 429.69 265.05 432 256 432s-22-2.31-32.33-13.31S208 390.24 208 368c0-25.14 8.82-44.28 17.34-62.78 6.48-14.07 14.66-27.22 15.11-44.49 11.3 5.88 23.67 16.91 34.54 31.28 18.17 24 29 52.42 29 76 .01 22.23-5.41 39.76-15.66 50.68z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e5dc147bc903d0aa(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M394.23 197.56a300.43 300.43 0 00-53.37-90C301.2 61.65 249.05 32 208 32a16 16 0 00-15.48 20c13.87 53-14.88 97.07-45.31 143.72C122 234.36 96 274.27 96 320c0 88.22 71.78 160 160 160s160-71.78 160-160c0-43.3-7.32-84.49-21.77-122.44zm-105.9 221.13C278 429.69 265.05 432 256 432s-22-2.31-32.33-13.31S208 390.24 208 368c0-25.14 8.82-44.28 17.34-62.78 4.95-10.74 10-21.67 13-33.37a8 8 0 0112.49-4.51A126.48 126.48 0 01275 292c18.17 24 29 52.42 29 76 0 22.24-5.42 39.77-15.67 50.69z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4118795cbcfac3e1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zM294.34 84.28l-22.08 120.84a16 16 0 006.17 15.71 16.49 16.49 0 009.93 3.17h94.12l-38.37 47.42a4 4 0 00.28 5.34l17.07 17.07a4 4 0 005.94-.31l60.8-75.16a16.37 16.37 0 003.3-14.36 16 16 0 00-15.5-12H307.19L335.4 37.63c.05-.3.1-.59.13-.89A18.45 18.45 0 00302.73 23l-92.58 114.46a4 4 0 00.28 5.35l17.07 17.06a4 4 0 005.94-.31zm-76.56 343.29l22-120.71a16 16 0 00-6.19-15.7 16.54 16.54 0 00-9.92-3.16h-94.1l38.36-47.42a4 4 0 00-.28-5.34l-17.07-17.07a4 4 0 00-5.93.31L83.8 293.64A16.37 16.37 0 0080.5 308 16 16 0 0096 320h108.83l-28.09 154.36v.11a18.37 18.37 0 0032.5 14.53l92.61-114.46a4 4 0 00-.28-5.35l-17.07-17.06a4 4 0 00-5.94.31z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$db9efe6cde2b0aee(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M63.998 86.004l21.998-21.998L448 426.01l-21.998 21.998zM80 304h144l-32 192 108.18-129.82-148.36-148.36L80 304zm352-96H288l32-192-108.18 129.82 148.36 148.36L432 208z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$31a9d858f9ff35eb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zm-.5-244a16 16 0 00-15.5-12H307.19L335.4 37.63c.05-.3.1-.59.13-.89A18.45 18.45 0 00302.73 23l-92.58 114.46a4 4 0 00.29 5.35l151 151a4 4 0 005.94-.31l60.8-75.16A16.37 16.37 0 00431.5 204zM301.57 369.19l-151-151a4 4 0 00-5.93.31L83.8 293.64A16.37 16.37 0 0080.5 308 16 16 0 0096 320h108.83l-28.09 154.36v.11a18.37 18.37 0 0032.5 14.53l92.61-114.46a4 4 0 00-.28-5.35z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$862f1e8fd39eecd1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M315.27 33L96 304h128l-31.51 173.23a2.36 2.36 0 002.33 2.77h0a2.36 2.36 0 001.89-.95L416 208H288l31.66-173.25a2.45 2.45 0 00-2.44-2.75h0a2.42 2.42 0 00-1.95 1z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3caedda13ef8afe9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 208H288l32-192L80 304h144l-32 192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5298f562997b7786(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M194.82 496a18.36 18.36 0 01-18.1-21.53v-.11L204.83 320H96a16 16 0 01-12.44-26.06L302.73 23a18.45 18.45 0 0132.8 13.71c0 .3-.08.59-.13.89L307.19 192H416a16 16 0 0112.44 26.06L209.24 489a18.45 18.45 0 01-14.42 7z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$23cfa03906fc87c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M456.64 162.86L349.12 55.36c-13.15-13.14-28.68-7.17-41.82 6l-11.95 12c-26.13 26.13-27.62 58.38-29.42 83.31-.89 12.24-9.78 27.55-18.51 36.28L58.58 381.67c-16.35 16.33-12.69 39.42 3.73 55.84l12.17 12.17c16.36 16.35 39.43 20.16 55.86 3.74l188.83-188.8c8.74-8.74 24-17.55 36.29-18.52 24.87-1.86 58.62-4.85 83.26-29.49l11.94-11.94c13.15-13.14 19.12-28.67 5.98-41.81z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "224.68",
                    "cy": "287.28",
                    "r": "20"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M289 81l142 142"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$163e20cd83844c90(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330 16l-42.68 42.7L453.3 224.68 496 182 330 16z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "224.68",
                    "cy": "287.3",
                    "fill": "none",
                    "rx": "20.03",
                    "ry": "19.96"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M429.21 243.85L268 82.59 249.65 168 16 402l94 94 234.23-233.8zm-189 56.07a20 20 0 110-25.25 20 20 0 01-.02 25.25z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3015655319ecb3f9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462 216c9.35-9.35 15.14-19.09 17.19-28.95 2.7-12.95-1.29-25.55-11.22-35.48L360.43 44.05C346.29 29.92 322 24.07 296 50l-2 2a8 8 0 000 11.32L448.64 218a8 8 0 0011.36 0zm-211.86-62.92l-.16 2.34c-.53 7.18-6.88 19.15-13.88 26.14L47.27 370.36c-11.12 11.11-16.46 25.57-15.05 40.7C33.49 424.58 40.16 438 51 448.83L63.17 461c12.61 12.6 27.78 19 42.49 19a50.4 50.4 0 0036-15.24l188.84-188.8c7.07-7.07 18.84-13.3 26.17-13.87 17.48-1.32 43.57-3.28 67.79-15.65a4 4 0 001-6.37L271.69 86.31a4 4 0 00-6.39 1c-12.12 22.99-13.82 46.91-15.16 65.77zm-9.95 146.83a20 20 0 110-25.25 20 20 0 010 25.25z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2d4a54876a9c4d36(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M176 48h160M118 304h276M208 48v93.48a64.09 64.09 0 01-9.88 34.18L73.21 373.49C48.4 412.78 76.63 464 123.08 464h265.84c46.45 0 74.68-51.22 49.87-90.51L313.87 175.66a64.09 64.09 0 01-9.87-34.18V48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$224aa6d919382384(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M469.11 382.76L325 153.92V74h32V32H155v42h32v79.92L42.89 382.76c-13 20.64-14.78 43.73-3 65.1S71.59 480 96 480h320c24.41 0 44.32-10.76 56.1-32.14s10.04-44.46-2.99-65.1zM224.39 173.39a29.76 29.76 0 004.62-16V74h54v84.59a25.85 25.85 0 004 13.82L356.82 283H155.18z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b1eb7be5ccb28b52(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M452.32 365L327.4 167.12a48.07 48.07 0 01-7.4-25.64V64h15.56c8.61 0 16-6.62 16.43-15.23A16 16 0 00336 32H176.45c-8.61 0-16 6.62-16.43 15.23A16 16 0 00176 64h16v77.48a47.92 47.92 0 01-7.41 25.63L59.68 365a74 74 0 00-2.5 75.84C70.44 465.19 96.36 480 124.13 480h263.74c27.77 0 53.69-14.81 66.95-39.21a74 74 0 00-2.5-75.79zM211.66 184.2A79.94 79.94 0 00224 141.48V68a4 4 0 014-4h56a4 4 0 014 4v73.48a79.94 79.94 0 0012.35 42.72l57.8 91.53a8 8 0 01-6.78 12.27H160.63a8 8 0 01-6.77-12.27z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$886e20b7c3201de1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M215.08 156.92c-4.89-24-10.77-56.27-10.77-73.23A51.36 51.36 0 01256 32h0c28.55 0 51.69 23.69 51.69 51.69 0 16.5-5.85 48.95-10.77 73.23m-81.84 198.16c-4.91 24.06-10.77 56.16-10.77 73.23A51.36 51.36 0 00256 480h0c28.55 0 51.69-23.69 51.69-51.69 0-16.54-5.85-48.93-10.77-73.23m58.16-140c24.06-4.91 56.16-10.77 73.23-10.77A51.36 51.36 0 01480 256h0c0 28.55-23.69 51.69-51.69 51.69-16.5 0-48.95-5.85-73.23-10.77m-198.16-81.85c-24-4.89-56.25-10.76-73.23-10.76A51.36 51.36 0 0032 256h0c0 28.55 23.69 51.69 51.69 51.69 16.5 0 48.95-5.85 73.23-10.77"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M296.92 156.92c13.55-20.48 32.3-47.25 44.37-59.31a51.35 51.35 0 0173.1 0h0c20.19 20.19 19.8 53.3 0 73.1-11.66 11.67-38.67 30.67-59.31 44.37m-198.16 81.84c-20.48 13.55-47.25 32.3-59.31 44.37a51.35 51.35 0 000 73.1h0c20.19 20.19 53.3 19.8 73.1 0 11.67-11.66 30.67-38.67 44.37-59.31m140-58.16c20.48 13.55 47.25 32.3 59.31 44.37a51.35 51.35 0 010 73.1h0c-20.19 20.19-53.3 19.8-73.1 0-11.69-11.69-30.66-38.65-44.37-59.31m-81.84-198.16c-13.53-20.43-32.38-47.32-44.37-59.31a51.35 51.35 0 00-73.1 0h0c-20.19 20.19-19.8 53.3 0 73.1 11.61 11.61 38.7 30.68 59.31 44.37"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "64",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$67f1c1d392840647(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "43"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M475.93 303.91a67.49 67.49 0 00-47.62-115.6c-2.88 0-6.2.14-9.93.43 2.75-2.36 5.23-4.62 7.33-6.71A67.83 67.83 0 00378 66.33h-.25a67.27 67.27 0 00-47.82 20c-2.11 2.11-4.37 4.59-6.72 7.33.29-3.75.44-7.07.44-9.93a67.69 67.69 0 10-135.38 0c0 2.87.15 6.19.44 9.93-2.36-2.74-4.62-5.22-6.72-7.33a67.27 67.27 0 00-47.82-20H134A67.9 67.9 0 0086.29 182c2.1 2.09 4.58 4.35 7.34 6.72-3.74-.29-7.06-.44-9.94-.44a67.69 67.69 0 000 135.38c2.86 0 6.18-.15 9.93-.44-2.74 2.35-5.22 4.61-7.33 6.72a67.55 67.55 0 0047.82 115.42h.25A67.32 67.32 0 00182 425.71c2.09-2.1 4.35-4.58 6.71-7.33-.28 3.73-.43 7.05-.43 9.93a67.69 67.69 0 00135.38 0c0-2.87-.15-6.19-.44-9.94 2.36 2.75 4.62 5.24 6.72 7.34a67.32 67.32 0 0047.67 19.68h.25A67.5 67.5 0 00425.71 330c-2.11-2.11-4.59-4.37-7.33-6.72 3.75.29 7.07.44 9.93.44a67.27 67.27 0 0047.62-19.81zM256 341a85 85 0 1185-85 85.1 85.1 0 01-85 85z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$17237dbd6cb2b75(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M475.93 303.91a67.49 67.49 0 00-44.34-115.53 5.2 5.2 0 01-4.58-3.21 5.21 5.21 0 011-5.51A67.83 67.83 0 00378 66.33h-.25A67.13 67.13 0 00332.35 84a5.21 5.21 0 01-5.52 1 5.23 5.23 0 01-3.22-4.58 67.68 67.68 0 00-135.23 0 5.2 5.2 0 01-3.21 4.58 5.21 5.21 0 01-5.52-1 67.11 67.11 0 00-45.44-17.69H134a67.91 67.91 0 00-50 113.34 5.21 5.21 0 011 5.51 5.2 5.2 0 01-4.58 3.21 67.71 67.71 0 000 135.23 5.23 5.23 0 014.58 3.23 5.22 5.22 0 01-1 5.52 67.54 67.54 0 0050.08 113h.25A67.38 67.38 0 00179.65 428a5.21 5.21 0 015.51-1 5.2 5.2 0 013.21 4.58 67.71 67.71 0 00135.23 0 5.23 5.23 0 013.22-4.58 5.21 5.21 0 015.51 1 67.38 67.38 0 0045.29 17.42h.25a67.48 67.48 0 0050.08-113 5.22 5.22 0 01-1-5.52 5.23 5.23 0 014.58-3.22 67.31 67.31 0 0044.4-19.77zM256 336a80 80 0 1180-80 80.09 80.09 0 01-80 80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e9cfc34e5b17b2a4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 192v-72a40 40 0 0140-40h75.89a40 40 0 0122.19 6.72l27.84 18.56a40 40 0 0022.19 6.72H408a40 40 0 0140 40v40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M479.9 226.55L463.68 392a40 40 0 01-39.93 40H88.25a40 40 0 01-39.93-40L32.1 226.55A32 32 0 0164 192h384.1a32 32 0 0131.8 34.55z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$51994e8b119cf111(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.08 189.4l28.58 233.87A28 28 0 0072.52 448h367a28 28 0 0027.86-24.73l28.54-233.87A12 12 0 00484 176H28a12 12 0 00-11.92 13.4zM464 124a28 28 0 00-28-28H244.84l-48-32H76a28 28 0 00-28 28v52h416z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9e08b8e521d33e45(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 96H252.11a23.89 23.89 0 01-13.31-4L211 73.41A55.77 55.77 0 00179.89 64H104a56.06 56.06 0 00-56 56v24h416c0-30.88-25.12-48-56-48zm15.75 352H88.25a56 56 0 01-55.93-55.15L16.18 228.11v-.28A48 48 0 0164 176h384.1a48 48 0 0147.8 51.83v.28l-16.22 164.74A56 56 0 01423.75 448zm56.15-221.45z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3839d0b984505178(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M440 432H72a40 40 0 01-40-40V120a40 40 0 0140-40h75.89a40 40 0 0122.19 6.72l27.84 18.56a40 40 0 0022.19 6.72H440a40 40 0 0140 40v240a40 40 0 01-40 40zM32 192h448"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c49a23713350d07f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 420a28 28 0 0028 28h424a28 28 0 0028-28V208H16zm480-296a28 28 0 00-28-28H212.84l-48-32H44a28 28 0 00-28 28v84h480z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ea24df8e4341cc58(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 152a56 56 0 00-56-56H220.11a23.89 23.89 0 01-13.31-4L179 73.41A55.77 55.77 0 00147.89 64H72a56 56 0 00-56 56v48a8 8 0 008 8h464a8 8 0 008-8zM16 392a56 56 0 0056 56h368a56 56 0 0056-56V216a8 8 0 00-8-8H24a8 8 0 00-8 8z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$568d843c01301b68(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "192",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 175.15l-76.09 63.83L200 320h112l20.09-81.02L256 175.15zm76.09 63.83l52.87-22.4 25.78-73.26M447 269.97l-62.04-53.39m-205.05 22.4l-52.87-22.4-25.78-73.26M65 269.97l62.04-53.39M256 175.15v-57.57l64-42.64m-128-.01l64 42.65M312 320l28 48-28 71m98.74-71H342m-142-48l-28 48 28.37 71.5M101.63 368H172"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e60199e13e45beab(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm140.64 296.08h-46.77l-16.89-29 15-60.44L377.79 242l42.65 36.71a164.87 164.87 0 01-23.8 65.37zM134.21 242L164 254.67l15 60.44-16.89 29h-46.75a164.87 164.87 0 01-23.8-65.34zm249.07-92.47l-18.41 52.33-31.12 13.18L277 167.46v-35l43.86-29.22a166.87 166.87 0 0162.42 46.32zM191.14 103.2L235 132.42v35l-56.75 47.61-31.12-13.18-18.41-52.33a166.87 166.87 0 0162.42-46.32zm26.44 314.3l-20.1-50.66 16-27.51h85l16.06 27.53-20 50.6a166.23 166.23 0 01-77 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cefd2c3cd2a84629(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm143 304h-45.22a8 8 0 01-6.91-4l-16.14-27.68a8 8 0 01-.86-6l14.86-59.92a8 8 0 014.65-5.45l28.1-11.9a8 8 0 018.34 1.3l41.63 35.82a8 8 0 012.69 7.26 174.75 174.75 0 01-24.28 66.68A8 8 0 01399 352zM134.52 237.13l28.1 11.9a8 8 0 014.65 5.45l14.86 59.92a8 8 0 01-.86 6L165.13 348a8 8 0 01-6.91 4H113a8 8 0 01-6.82-3.81 174.75 174.75 0 01-24.28-66.68 8 8 0 012.69-7.26l41.63-35.82a8 8 0 018.3-1.3zm256.94-87.24l-18.07 51.38A8 8 0 01369 206l-29.58 12.53a8 8 0 01-8.26-1.24L274.9 170.1a8 8 0 01-2.9-6.1v-33.58a8 8 0 013.56-6.65l42.83-28.54a8 8 0 017.66-.67A176.92 176.92 0 01390 142a8 8 0 011.46 7.89zM193.6 95.23l42.84 28.54a8 8 0 013.56 6.65V164a8 8 0 01-2.86 6.13l-56.26 47.19a8 8 0 01-8.26 1.24L143 206a8 8 0 01-4.43-4.72L120.5 149.9a8 8 0 011.5-7.9 176.92 176.92 0 0164-47.48 8 8 0 017.6.71zm17.31 327.46L191.18 373a8 8 0 01.52-7l15.17-26a8 8 0 016.91-4h84.44a8 8 0 016.91 4l15.18 26a8 8 0 01.53 7l-19.59 49.67a8 8 0 01-5.69 4.87 176.58 176.58 0 01-79 0 8 8 0 01-5.65-4.85z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ad164ee6e8827b6f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M200 246.84c8.81 58.62-7.33 90.67-52.91 97.41-50.65 7.49-71.52-26.44-80.33-85.06-11.85-78.88 16-127.94 55.71-131.1 36.14-2.87 68.71 60.14 77.53 118.75zm23.65 162.69c3.13 33.28-14.86 64.34-42 69.66-27.4 5.36-58.71-16.37-65.09-49.19s17.75-34.56 47.32-40.21 55.99-20.4 59.77 19.74zM312 150.83c-8.81 58.62 7.33 90.67 52.9 97.41 50.66 7.49 71.52-26.44 80.33-85.06 11.86-78.89-16-128.22-55.7-131.1-36.4-2.64-68.71 60.13-77.53 118.75zm-23.65 162.7c-3.13 33.27 14.86 64.34 42 69.66 27.4 5.36 58.71-16.37 65.09-49.19s-17.75-34.56-47.32-40.22-55.99-20.4-59.77 19.75z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$96304e9b2f62f891(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M130.54 358.31c-12.83 1.88-33.95 5.38-48-10.56S56.34 293.32 51 258.92c-7.88-50.7-.06-93.43 22-120.31 13-15.83 30.06-25 49.34-26.46 16.51-1.27 41.18 5.19 65 43.19 14.92 23.81 26.27 55.44 31.14 86.77 5.88 37.82 11.61 78.18-8.44 92.65-11.31 8.17-19.43 11-38.62 15.57-15.78 3.75-28.04 6.09-40.88 7.98zm-22.82 32.53l108.89-22.46c9.2-1.9 16.58 3.16 20 18.32 11.22 49.76-4.86 109.3-55.22 109.3-47.69 0-79.47-54.36-84.66-83.58-2.37-13.25 1.01-19.53 10.99-21.58zm232.87-136.5c-19.19-4.55-27.31-7.4-38.62-15.57-20.05-14.47-14.32-54.83-8.44-92.65 4.87-31.33 16.22-63 31.14-86.77 23.8-38 48.47-44.46 65-43.19C408.93 17.63 426 26.78 439 42.61c22.08 26.88 29.9 69.61 22 120.31-5.35 34.4-17.46 72.76-31.59 88.83s-35.13 12.44-48 10.56-25.05-4.23-40.82-7.97zm63.69 40.5l-108.89-22.46c-9.2-1.9-16.58 3.16-20 18.32-11.21 49.76 4.87 109.3 55.23 109.3 47.69 0 79.47-54.36 84.66-83.58 2.36-13.25-1.02-19.53-11-21.58z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$85d85fde07b995a6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M133.83 361.27c-22.61 0-41-8.17-54.79-24.39s-22.84-40.29-28.11-75.31c-7.76-51.61-.06-95.11 21.68-122.48 12.8-16.12 29.6-25.44 48.58-26.94 16.25-1.3 40.54 5.29 64 44 14.69 24.24 25.86 56.44 30.65 88.34 5.79 38.51 1.48 66.86-13.18 86.65-11.64 15.72-29.54 25.46-53.21 29a106.46 106.46 0 01-15.62 1.13zM173 496c-13.21 0-26.6-4.23-38.66-12.36a79.79 79.79 0 01-33.52-50.6c-2.85-14.66-1.14-26.31 5.22-35.64 10.33-15.15 28.87-18.56 48.49-22.18 2.07-.38 4.17-.76 6.3-1.17 4.52-.86 9.14-2 13.62-3.11 16.78-4.14 34.14-8.43 48.47 1.75 9.59 6.8 15 18.36 16.62 35.32 1.84 19.57-2.36 39.1-11.83 55-10.19 17.11-25.47 28.42-43 31.86A61 61 0 01173 496zm205.17-230.73a106.69 106.69 0 01-15.6-1.2c-23.66-3.5-41.56-13.25-53.2-29-14.66-19.79-19-48.13-13.18-86.65 4.79-31.93 15.93-64.1 30.55-88.25 23.34-38.57 47.66-45.26 64-44.08 18.92 1.38 35.69 10.57 48.51 26.6 21.89 27.37 29.65 71 21.86 122.84-5.27 35-14.2 58.95-28.11 75.31s-32.22 24.43-54.83 24.43zM339 400a61 61 0 01-11.68-1.13c-17.56-3.44-32.84-14.75-43-31.86-9.47-15.9-13.67-35.43-11.83-55 1.6-17 7-28.52 16.62-35.33 14.33-10.17 31.69-5.89 48.47-1.74 4.48 1.1 9.1 2.24 13.62 3.11l6.29 1.17c19.63 3.61 38.17 7 48.5 22.17 6.36 9.33 8.07 21 5.22 35.64a79.78 79.78 0 01-33.52 50.61C365.56 395.78 352.17 400 339 400z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$939941687ac4d566(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M35.4 87.12l168.65 196.44A16.07 16.07 0 01208 294v119.32a7.93 7.93 0 005.39 7.59l80.15 26.67A7.94 7.94 0 00304 440V294a16.07 16.07 0 014-10.44L476.6 87.12A14 14 0 00466 64H46.05A14 14 0 0035.4 87.12z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8250503eb1246817(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48l192 240v128l128 48V288L512 48H0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1d9ee3283045f209(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 464a23.88 23.88 0 01-7.55-1.23L208.3 436.1a23.92 23.92 0 01-16.3-22.78V294.11a.44.44 0 00-.09-.13L23.26 97.54A30 30 0 0146.05 48H466a30 30 0 0122.79 49.54L320.09 294a.77.77 0 00-.09.13V440a23.93 23.93 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1a7330113b344559(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M467.51 248.83c-18.4-83.18-45.69-136.24-89.43-149.17A91.5 91.5 0 00352 96c-26.89 0-48.11 16-96 16s-69.15-16-96-16a99.09 99.09 0 00-27.2 3.66C89 112.59 61.94 165.7 43.33 248.83c-19 84.91-15.56 152 21.58 164.88 26 9 49.25-9.61 71.27-37 25-31.2 55.79-40.8 119.82-40.8s93.62 9.6 118.66 40.8c22 27.41 46.11 45.79 71.42 37.16 41.02-14.01 40.44-79.13 21.43-165.04z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "292",
                    "cy": "224",
                    "r": "20"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 288a20 20 0 1120-19.95A20 20 0 01336 288z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "336",
                    "cy": "180",
                    "r": "20"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "380",
                    "cy": "224",
                    "r": "20"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 176v96m48-48h-96"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9e41645ca7b4e3e3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M478.07 356.88L439 151c-8.86-40.35-23-71-88-71H145c-66 0-79.14 30.65-88 71L18 356.88c-7 34.12 4.43 61.25 33.37 71.81S103 423 119.18 391.3l15.42-30.52a16 16 0 0114.28-8.78h198.28a16 16 0 0114.28 8.78l15.42 30.52c16.14 31.7 38.88 48 67.81 37.39S485 391 478.07 356.88zM224 240h-48v48h-32v-48H96v-32h48v-48h32v48h48zm68 4a20 20 0 1120-20 20 20 0 01-20 20zm44 44a20 20 0 1120-20 20 20 0 01-20 20zm0-88a20 20 0 1120-20 20 20 0 01-20 20zm44 44a20 20 0 1120-20 20 20 0 01-20 20z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d34a6229bcb2cb61(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.13 245.38C461.92 149.49 430 98.31 382.65 84.33A107.13 107.13 0 00352 80c-13.71 0-25.65 3.34-38.28 6.88C298.5 91.15 281.21 96 256 96s-42.51-4.84-57.76-9.11C185.6 83.34 173.67 80 160 80a115.74 115.74 0 00-31.73 4.32c-47.1 13.92-79 65.08-100.52 161C4.61 348.54 16 413.71 59.69 428.83a56.62 56.62 0 0018.64 3.22c29.93 0 53.93-24.93 70.33-45.34 18.53-23.1 40.22-34.82 107.34-34.82 59.95 0 84.76 8.13 106.19 34.82 13.47 16.78 26.2 28.52 38.9 35.91 16.89 9.82 33.77 12 50.16 6.37 25.82-8.81 40.62-32.1 44-69.24 2.57-28.48-1.39-65.89-12.12-114.37zM208 240h-32v32a16 16 0 01-32 0v-32h-32a16 16 0 010-32h32v-32a16 16 0 0132 0v32h32a16 16 0 010 32zm84 4a20 20 0 1120-20 20 20 0 01-20 20zm44 44a20 20 0 1120-19.95A20 20 0 01336 288zm0-88a20 20 0 1120-20 20 20 0 01-20 20zm44 44a20 20 0 1120-20 20 20 0 01-20 20z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d0197451e1c1452d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 104v56h56a56 56 0 10-56-56zm0 0v56h-56a56 56 0 1156-56z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "384",
                    "height": "112",
                    "x": "64",
                    "y": "160",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 272v144a48 48 0 01-48 48H144a48 48 0 01-48-48V272m160-112v304"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e80da17e5b473a9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M346 110a34 34 0 00-68 0v34h34a34 34 0 0034-34zm-112 0a34 34 0 10-34 34h34z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M234 144h44v112h164a22 22 0 0022-22v-68a22 22 0 00-22-22h-59.82A77.95 77.95 0 00256 55.79 78 78 0 00129.81 144H70a22 22 0 00-22 22v68a22 22 0 0022 22h164zm44-34a34 34 0 1134 34h-34zm-112 0a34 34 0 1168 0v34h-34a34 34 0 01-34-34zm112 370h132a22 22 0 0022-22V288H278zM80 458a22 22 0 0022 22h132V288H80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$eae6046707ea96a9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M200 144h40v-40a40 40 0 10-40 40zm152-40a40 40 0 00-80 0v40h40a40 40 0 0040-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M80 416a64 64 0 0064 64h92a4 4 0 004-4V292a4 4 0 00-4-4H88a8 8 0 00-8 8zm160-164V144h32v108a4 4 0 004 4h140a47.93 47.93 0 0016-2.75A48.09 48.09 0 00464 208v-16a48 48 0 00-48-48h-40.54a2 2 0 01-1.7-3A72 72 0 00256 58.82 72 72 0 00138.24 141a2 2 0 01-1.7 3H96a48 48 0 00-48 48v16a48.09 48.09 0 0032 45.25A47.93 47.93 0 0096 256h140a4 4 0 004-4zm32-148a40 40 0 1140 40h-40zm-74.86-39.9A40 40 0 01240 104v40h-40a40 40 0 01-2.86-79.89zM276 480h92a64 64 0 0064-64V296a8 8 0 00-8-8H276a4 4 0 00-4 4v184a4 4 0 004 4z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$620a2f373b454da8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "160",
                    "cy": "96",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "160",
                    "cy": "416",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 368V144"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "352",
                    "cy": "160",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 208c0 128-192 48-192 160"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$601200de662382ec(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 96a64 64 0 00-58.86 89.11l-101.14 88V151.39a64 64 0 10-64 0v209.22a64 64 0 1064 0V358l154.25-134.27c1.9.17 3.81.27 5.75.27a64 64 0 000-128zM160 64a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm192-256a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$493a52ccc1324336(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 160a64 64 0 10-96.27 55.24c-2.29 29.08-20.08 37-75 48.42-17.76 3.68-35.93 7.45-52.71 13.93v-126.2a64 64 0 10-64 0v209.22a64 64 0 1064.42.24c2.39-18 16-24.33 65.26-34.52 27.43-5.67 55.78-11.54 79.78-26.95 29-18.58 44.53-46.78 46.36-83.89A64 64 0 00416 160zM160 64a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm192-256a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$458818aed855d6da(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "96",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 256H48m416 0H352"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c412e0858ce2e7a2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 224H380a128 128 0 00-247.9 0H32v64h100.05A128 128 0 00380 288h100zm-224 96a64 64 0 1164-64 64.07 64.07 0 01-64 64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3012b588c30769ab(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 224h-68a128 128 0 00-247.9 0H64a32 32 0 000 64h68.05A128 128 0 00380 288h68a32 32 0 000-64zm-192 96a64 64 0 1164-64 64.07 64.07 0 01-64 64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7d4a2c50ed4afb81(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 160l-64-64 64-64m-97 320l64 64-64 64"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "112",
                    "cy": "96",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "400",
                    "cy": "416",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 96h84a60 60 0 0160 60v212m-145 48h-84a60 60 0 01-60-60V144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ac39e4f5d992b86f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209 384h-37a28 28 0 01-28-28V152a64 64 0 10-64-1.16V356a92.1 92.1 0 0092 92h37v55.21L294.39 416 209 328.79zM113 64a32 32 0 11-32 32 32 32 0 0132-32zm319 296.61V156a92.1 92.1 0 00-92-92h-35V9.93L217.14 96 305 182.07V128h35a28 28 0 0128 28v204.61a64 64 0 1064 0zM400 448a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1323552d2d6248a4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.31 340.69A16 16 0 00191 352v32h-20a28 28 0 01-28-28V152a64 64 0 10-64-1.16V356a92.1 92.1 0 0092 92h20v32a16 16 0 0027.31 11.31l64-64a16 16 0 000-22.62zM112 64a32 32 0 11-32 32 32 32 0 0132-32zm320 296.61V156a92.1 92.1 0 00-92-92h-20V32a16 16 0 00-27.31-11.31l-64 64a16 16 0 000 22.62l64 64A16 16 0 00320 160v-32h20a28 28 0 0128 28v204.61a64 64 0 1064 0zM400 448a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8e1ef87b0e58570c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "129",
                    "cy": "96",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "129",
                    "cy": "416",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M129 144v224"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "385",
                    "cy": "288",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M129 144c0 96 112 144 208 144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$47c8410fc6b89ab4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 224a63.66 63.66 0 00-37.95 12.5L160 153.36v-2a64 64 0 10-64 0v209.25a64 64 0 1064 0V223.46l160.41 71.69A64 64 0 10384 224zM128 64a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm256-128a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a2d40a85f1f207a6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M385 224a64 64 0 00-55.33 31.89c-42.23-1.21-85.19-12.72-116.21-31.33-32.2-19.32-49.71-44-52.15-73.35a64 64 0 10-64.31.18v209.22a64 64 0 1064 0v-94.46c44.76 34 107.28 52.38 168.56 53.76A64 64 0 10385 224zM129 64a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm256-128a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b16c7d0fcf9a1796(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "96",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "416",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 256v112"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "96",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 144c0 74.67 68.92 112 128 112m128-112c0 74.67-68.92 112-128 112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3de224cb42f2158d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32a64 64 0 00-57.67 91.73l-70.83 80.82-70.19-80.1A64 64 0 10128 160c1.1 0 2.2 0 3.29-.08L224 265.7v94.91a64 64 0 1064 0v-96.05l91.78-104.71c1.39.09 2.8.15 4.22.15a64 64 0 000-128zM96 96a32 32 0 1132 32 32 32 0 01-32-32zm160 352a32 32 0 1132-32 32 32 0 01-32 32zm128-320a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6c0a8b8b7c489533(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96a64 64 0 10-96.31 55.21c-1.79 20.87-11.47 38.1-28.87 51.29C305.07 216 280.09 224 256 224s-49.07-8-66.82-21.5c-17.4-13.19-27.08-30.42-28.87-51.29a64 64 0 10-64.11.29c2.08 40.87 21.17 76.87 54.31 102C171.3 269.26 197 280.19 224 285.09v75.52a64 64 0 1064 0v-75.52c27-4.9 52.7-15.83 73.49-31.59 33.14-25.13 52.23-61.13 54.31-102A64 64 0 00448 96zM128 64a32 32 0 11-32 32 32 32 0 0132-32zm128 384a32 32 0 1132-32 32 32 0 01-32 32zm128-320a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$434fde02d530a894(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "416",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 144v224m160-208l-64-64 64-64"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "96",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "416",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M240 96h84a60 60 0 0160 60v212"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b66ee73ad18ca1b3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96a64 64 0 10-97 54.81v209.8a64 64 0 1064 0V152a64.06 64.06 0 0033-56zm-64-32a32 32 0 11-32 32 32 32 0 0132-32zm-1 384a32 32 0 1132-32 32 32 0 01-32 32zm289-87.39V156a92.1 92.1 0 00-92-92h-35V9.93L201.14 96 289 182.07V128h35a28 28 0 0128 28v204.61a64 64 0 1064 0zM384 448a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6bde859654054299(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96a64 64 0 10-96 55.39v209.22a64 64 0 1064 0V151.39A64 64 0 00192 96zm-64-32a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm288-87.39V156a92.1 92.1 0 00-92-92h-20V32a16 16 0 00-27.31-11.31l-64 64a16 16 0 000 22.62l64 64A16 16 0 00304 160v-32h20a28 28 0 0128 28v204.61a64 64 0 1064 0zM384 448a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$957e6bce5cb2b2bb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M224 232a32 32 0 0164 0m160-32h16m-400 0H48m16 0c0 96 16 128 80 128s80-32 80-128c0 0-16-16-80-16s-80 16-80 16zm384 0c0 96-16 128-80 128s-80-32-80-128c0 0 16-16 80-16s80 16 80 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1b7cec97acee37ab(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 176H16v64h21.24l12.44 112h171.87L240 241.32V240a16 16 0 0132 0v1.32L290.45 352h171.87l12.44-112H496z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$40d10c2bf7e20990(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 184h-10.9a78.72 78.72 0 00-16-7.18C419.5 171 396.26 168 368 168s-51.5 3-69.06 8.82c-14.06 4.69-20.25 9.86-22.25 11.87a47.94 47.94 0 00-41.36 0c-2-2-8.19-7.18-22.25-11.87C195.5 171 172.26 168 144 168s-51.5 3-69.06 8.82a78.72 78.72 0 00-16 7.18H48a16 16 0 000 32h.17c1 45.46 6.44 72.78 18.11 92.23a66.78 66.78 0 0031.92 28c12.23 5.24 27.22 7.79 45.8 7.79 24.15 0 58.48-3.71 77.72-35.77 9.68-16.14 15.09-37.69 17.21-70.52A16 16 0 00240 232a16 16 0 0132 0 16 16 0 001.07 5.71c2.12 32.83 7.53 54.38 17.21 70.52a66.78 66.78 0 0031.92 28c12.23 5.24 27.22 7.79 45.8 7.79 24.15 0 58.48-3.71 77.72-35.77 11.67-19.45 17.13-46.77 18.11-92.23h.17a16 16 0 000-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$76beb63e25bc0776(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 48c-58.07 0-112.67 93.13-112.67 208S197.93 464 256 464s112.67-93.13 112.67-208S314.07 48 256 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M117.33 117.33c38.24 27.15 86.38 43.34 138.67 43.34s100.43-16.19 138.67-43.34m0 277.34c-38.24-27.15-86.38-43.34-138.67-43.34s-100.43 16.19-138.67 43.34"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 48v416m208-208H48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5470dedacbdac668(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "44",
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "44",
                    "d": "M256 48c-58.07 0-112.67 93.13-112.67 208S197.93 464 256 464s112.67-93.13 112.67-208S314.07 48 256 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M117.33 121.33c38.24 27.15 86.38 43.34 138.67 43.34s100.43-16.19 138.67-43.34m0 269.34c-38.24-27.15-86.38-43.34-138.67-43.34s-100.43 16.19-138.67 43.34"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "44",
                    "d": "M256 48v416m208-208H48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1efe9a5eb2882e37(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340.75 344.49c5.91-20.7 9.82-44.75 11.31-67.84a4.41 4.41 0 00-4.46-4.65h-71.06a4.43 4.43 0 00-4.47 4.39v55.3a4.44 4.44 0 004.14 4.38 273.51 273.51 0 0159 11.39 4.45 4.45 0 005.54-2.97zm-17.17 32.82a260.05 260.05 0 00-46.6-9.09 4.42 4.42 0 00-4.91 4.29v65.24a4.47 4.47 0 006.76 3.7c15.9-9.27 29-24.84 40.84-45.43 1.94-3.36 4.89-9.15 6.67-12.69a4.29 4.29 0 00-2.76-6.02zm-88.29-8.91a256.85 256.85 0 00-46.56 8.82c-2.64.76-3.75 4.4-2.55 6.79 1.79 3.56 4 8.11 5.89 11.51 13 23 26.84 37.5 41.24 45.93a4.47 4.47 0 006.76-3.7v-65.27a4.16 4.16 0 00-4.78-4.08zm.31-96.4h-71.06a4.41 4.41 0 00-4.46 4.64c1.48 23.06 5.37 47.16 11.26 67.84a4.46 4.46 0 005.59 3 272.2 272.2 0 0159-11.36 4.44 4.44 0 004.15-4.38V276.4a4.43 4.43 0 00-4.48-4.4zM277 143.78a235.8 235.8 0 0046.5-9.14 4.3 4.3 0 002.76-6c-1.79-3.57-4.27-8.68-6.17-12.09-12.29-22-26.14-37.35-41.24-46a4.48 4.48 0 00-6.76 3.7v65.23a4.43 4.43 0 004.91 4.3zm-.46 96.22h71.06a4.39 4.39 0 004.46-4.58c-1.48-22.77-5.27-47.8-11.16-68.22a4.46 4.46 0 00-5.59-2.95c-19 5.74-38.79 10.43-59.09 12a4.4 4.4 0 00-4.15 4.32v55.11a4.4 4.4 0 004.47 4.32zM233.31 70.56c-15.42 8.57-29.17 24.43-41.47 46.37-1.91 3.41-4.19 8.11-6 11.67a4.31 4.31 0 002.76 6 225.42 225.42 0 0046.54 9.17 4.43 4.43 0 004.91-4.29V74.26a4.49 4.49 0 00-6.74-3.7zm2.61 105.7c-20.3-1.55-40.11-6.24-59.09-12a4.46 4.46 0 00-5.59 2.95c-5.89 20.42-9.68 45.45-11.16 68.22a4.39 4.39 0 004.46 4.58h71.06a4.4 4.4 0 004.47-4.34v-55.09a4.4 4.4 0 00-4.15-4.32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM176.6 430.85a219.08 219.08 0 01-12.48-19.66c-2-3.69-4.84-9.26-6.73-13.13a7.29 7.29 0 00-10.31-3.16c-4.3 2.41-10 5.72-14.13 8.43a147.29 147.29 0 01-23.57-22.43 248.83 248.83 0 0130.41-18.36c1.86-1 2.77-2.14 2.18-4.18a374.8 374.8 0 01-14.09-82.17 4.36 4.36 0 00-4.3-4.17H66.84a2 2 0 01-2-1.7A98.28 98.28 0 0164 256a96.27 96.27 0 01.86-14.29 2 2 0 012-1.7h56.74c2.29 0 4.17-1.32 4.29-3.63a372.71 372.71 0 0114-81.83 4.36 4.36 0 00-2.19-5.11 260.63 260.63 0 01-29.84-17.9 169.82 169.82 0 0123.14-22.8c4.08 2.68 9.4 5.71 13.66 8.11a7.89 7.89 0 0011-3.42c1.88-3.87 4-8.18 6.06-11.88a221.93 221.93 0 0112.54-19.91A185 185 0 01256 64c28.94 0 55.9 7 80.53 18.46a202.23 202.23 0 0112 19c2.59 4.66 5.34 10.37 7.66 15.32a4.29 4.29 0 005.92 1.94c5.38-2.91 11.21-6.26 16.34-9.63a171.36 171.36 0 0123.2 23 244.89 244.89 0 01-29.06 17.31 4.35 4.35 0 00-2.18 5.12 348.68 348.68 0 0113.85 81.4 4.33 4.33 0 004.3 4.12l56.62-.07a2 2 0 012 1.7 117.46 117.46 0 010 28.62 2 2 0 01-2 1.72h-56.67a4.35 4.35 0 00-4.3 4.17 367.4 367.4 0 01-13.87 81.3 4.45 4.45 0 002.19 5.19c5 2.59 10.57 5.48 15.37 8.42s9.55 6.08 14.13 9.34a172.73 172.73 0 01-23 22.93c-2.44-1.61-5.34-3.44-7.84-4.94-1.72-1-4.89-2.77-6.65-3.76-3.82-2.14-7.88-.54-9.79 3.4s-4.83 9.59-6.87 13.25a212.42 212.42 0 01-12.35 19.53C310.91 442.37 284.94 448 256 448s-54.77-5.63-79.4-17.15z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ac71f0cf736e96e0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 400V32l176 80-176 80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 336c-87 0-175.3 43.2-191.64 124.74C62.39 470.57 68.57 480 80 480h352c11.44 0 17.62-9.43 15.65-19.26C431.3 379.2 343 336 256 336z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cae6878b83b8c6b1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 16v304.47q8-.47 16-.47t16 .47V202.3L448 112z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M462.91 457.5c-8.54-42.85-35-78.74-76.62-103.8-32.43-19.55-72.53-31.3-114.29-33.7v95.79h-32V320c-41.79 2.4-81.89 14.15-114.32 33.7-41.59 25.06-68.08 60.95-76.62 103.8-2 9.81-.68 38.5-.68 38.5h415.21s1.28-28.69-.68-38.5z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$eb905b2897312381(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 320.46V202.3l166.62-75.73a16 16 0 000-29.14l-176-80A16 16 0 00240 32v288.46q8-.45 16-.46t16 .46z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M463.33 457.5c-8.56-42.85-35.11-78.74-76.78-103.8-32.5-19.55-72.67-31.3-114.55-33.7v79.75a16 16 0 11-32 0V320c-41.88 2.4-82.05 14.15-114.55 33.7-41.67 25.06-68.22 60.95-76.78 103.8a32.49 32.49 0 006.44 27.08C61.13 492 70 496 80 496h352c10 0 18.88-4.05 24.9-11.42a32.49 32.49 0 006.43-27.08z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a956a7a01ffdccfa(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "176",
                    "x": "48",
                    "y": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "20",
                    "ry": "20"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "176",
                    "x": "288",
                    "y": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "20",
                    "ry": "20"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "176",
                    "x": "48",
                    "y": "288",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "20",
                    "ry": "20"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "176",
                    "x": "288",
                    "y": "288",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "20",
                    "ry": "20"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$54a14fc5dce9f99(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 240H32V32h208zm240 0H272V32h208zM240 480H32V272h208zm240 0H272V272h208z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$43a93ace5c549ab2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204 240H68a36 36 0 01-36-36V68a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36zm240 0H308a36 36 0 01-36-36V68a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36zM204 480H68a36 36 0 01-36-36V308a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36zm240 0H308a36 36 0 01-36-36V308a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$39a036ac15c9278b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M277.42 247a24.68 24.68 0 00-4.08-5.47L255 223.44a21.63 21.63 0 00-6.56-4.57 20.93 20.93 0 00-23.28 4.27c-6.36 6.26-18 17.68-39 38.43C146 301.3 71.43 367.89 37.71 396.29a16 16 0 00-1.09 23.54l39 39.43a16.13 16.13 0 0023.67-.89c29.24-34.37 96.3-109 136-148.23 20.39-20.06 31.82-31.58 38.29-37.94a21.76 21.76 0 003.84-25.2zm201.01-46l-34.31-34a5.44 5.44 0 00-4-1.59 5.59 5.59 0 00-4 1.59h0a11.41 11.41 0 01-9.55 3.27c-4.48-.49-9.25-1.88-12.33-4.86-7-6.86 1.09-20.36-5.07-29a242.88 242.88 0 00-23.08-26.72c-7.06-7-34.81-33.47-81.55-52.53a123.79 123.79 0 00-47-9.24c-26.35 0-46.61 11.76-54 18.51-5.88 5.32-12 13.77-12 13.77a91.29 91.29 0 0110.81-3.2 79.53 79.53 0 0123.28-1.49C241.19 76.8 259.94 84.1 270 92c16.21 13 23.18 30.39 24.27 52.83.8 16.69-15.23 37.76-30.44 54.94a7.85 7.85 0 00.4 10.83l21.24 21.23a8 8 0 0011.14.1c13.93-13.51 31.09-28.47 40.82-34.46s17.58-7.68 21.35-8.09a35.71 35.71 0 0121.3 4.62 13.65 13.65 0 013.08 2.38c6.46 6.56 6.07 17.28-.5 23.74l-2 1.89a5.5 5.5 0 000 7.84l34.31 34a5.5 5.5 0 004 1.58 5.65 5.65 0 004-1.58L478.43 209a5.82 5.82 0 000-8z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9ca2994a44808280(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.28 256.9l-54.42-54.41a12 12 0 00-17 0L12.45 401a12 12 0 00-.27 17.2l66.05 66.28a12 12 0 0017.22-.23l198.81-210.36a12 12 0 00.02-16.99zm205.05-57.57l-43.89-43.58a21.46 21.46 0 00-15.28-6.26 21.89 21.89 0 00-12.79 4.14c0-.43.06-.85.09-1.22.45-6.5 1.15-16.32-5.2-25.22a258 258 0 00-24.8-28.74.6.6 0 00-.08-.08c-13.32-13.12-42.31-37.83-86.72-55.94A139.55 139.55 0 00257.56 32C226 32 202 46.24 192.81 54.68A53.4 53.4 0 00176 86.17L192 96s8.06-2 13.86-3.39a62.73 62.73 0 0118.45-1.15c13.19 1.09 28.79 7.64 35.69 13.09 11.7 9.41 17.33 22.09 18.26 41.09.2 4.23-9.52 21.35-24.16 39.84a8 8 0 00.61 10.62l45.37 45.37a8 8 0 0011 .25c12.07-11 30.49-28 34.67-30.59 7.69-4.73 13.19-5.64 14.7-5.8a19.18 19.18 0 0111.29 2.38 1.24 1.24 0 01-.31.95l-1.82 1.73-.3.28a21.52 21.52 0 00.05 30.54l43.95 43.68a8 8 0 0011.28 0l74.68-74.2a8 8 0 00.06-11.36z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7203678123f405e7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280.16 242.79l-26.11-26.12a32 32 0 00-45.14-.12L27.38 384.08c-6.61 6.23-10.95 14.17-11.35 23.06a32.11 32.11 0 009.21 23.94l39 39.43a.46.46 0 00.07.07A32.29 32.29 0 0087 480h1.18c8.89-.33 16.85-4.5 23.17-11.17l168.7-180.7a32 32 0 00.11-45.34zM490 190l-.31-.31-34.27-33.92a21.46 21.46 0 00-15.28-6.26 21.89 21.89 0 00-12.79 4.14c0-.43.06-.85.09-1.22.45-6.5 1.15-16.32-5.2-25.22a258 258 0 00-24.8-28.74.6.6 0 00-.08-.08c-13.32-13.12-42.31-37.83-86.72-55.94A139.55 139.55 0 00257.56 32C226 32 202 46.24 192.81 54.68a119.92 119.92 0 00-14.18 16.22 16 16 0 0018.65 24.34 74.45 74.45 0 018.58-2.63 63.46 63.46 0 0118.45-1.15c13.19 1.09 28.79 7.64 35.69 13.09 11.7 9.41 17.33 22.09 18.26 41.09.18 3.82-7.72 18.14-20 34.48a16 16 0 001.45 21l34.41 34.41a16 16 0 0022 .62c9.73-8.69 24.55-21.79 29.73-25 7.69-4.73 13.19-5.64 14.7-5.8a19.18 19.18 0 0111.29 2.38 1.24 1.24 0 01-.31.95l-1.82 1.73-.3.28a21.52 21.52 0 00.05 30.54l34.26 33.91a21.45 21.45 0 0015.28 6.25 21.7 21.7 0 0015.22-6.2l55.5-54.82c.19-.19.38-.39.56-.59A21.87 21.87 0 00490 190z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$92406894253c59b9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 320V144a32 32 0 0132-32h0a32 32 0 0132 32v112m0 0V80a32 32 0 0132-32h0a32 32 0 0132 32v160m64 1V96a32 32 0 0132-32h0a32 32 0 0132 32v224m-128-80V48a32 32 0 0132-32h0a32 32 0 0132 32v192"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 320c0 117.4 64 176 152 176s123.71-39.6 144-88l52.71-144c6.66-18.05 3.64-34.79-11.87-43.6h0c-15.52-8.82-35.91-4.28-44.31 11.68L336 320"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7f04cb999659daf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M429.58 209.08c-15.06-6.62-32.38 1.31-38.5 17.62L356 312h-11.27V80c0-17.6-13.3-32-29.55-32-16.26 0-29.55 14.4-29.55 32v151.75l-14.78.25V32c0-17.6-13.3-32-29.55-32s-29.55 14.4-29.55 32v199.75L197 232V64c0-17.6-13.3-32-29.55-32-16.26 0-29.55 14.4-29.55 32v183.75l-14.8.25V128c0-17.6-13.3-32-29.55-32S64 110.4 64 128v216c0 75.8 37.13 168 169 168 40.8 0 79.42-7 100.66-21a121.41 121.41 0 0033.72-33.31 138 138 0 0016-31.78l62.45-175.14c6.17-16.31-1.19-35.06-16.25-41.69z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c09f995a36f74b13(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432.8 211.44c-15.52-8.82-34.91-2.28-43.31 13.68l-41.38 84.41a7 7 0 01-8.93 3.43 7 7 0 01-4.41-6.52V72c0-13.91-12.85-24-26.77-24s-26 10.09-26 24v156.64A11.24 11.24 0 01271.21 240 11 11 0 01260 229V24c0-13.91-10.94-24-24.86-24S210 10.09 210 24v204.64A11.24 11.24 0 01199.21 240 11 11 0 01188 229V56c0-13.91-12.08-24-26-24s-26 11.09-26 25v187.64A11.24 11.24 0 01125.21 256 11 11 0 01114 245V120c0-13.91-11.08-24-25-24s-25.12 10.22-25 24v216c0 117.41 72 176 160 176h16c88 0 115.71-39.6 136-88l68.71-169c6.62-18 3.6-34.75-11.91-43.56z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9c2e279dc1f0cd71(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432 320V144a32 32 0 00-32-32h0a32 32 0 00-32 32v112m0 0V80a32 32 0 00-32-32h0a32 32 0 00-32 32v160m-64 1V96a32 32 0 00-32-32h0a32 32 0 00-32 32v224m128-80V48a32 32 0 00-32-32h0a32 32 0 00-32 32v192"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432 320c0 117.4-64 176-152 176s-123.71-39.6-144-88L83.33 264c-6.66-18.05-3.64-34.79 11.87-43.6h0c15.52-8.82 35.91-4.28 44.31 11.68L176 320"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$35d218396a6c9306(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M82.42 209.08c15.06-6.62 32.38 1.31 38.5 17.62L156 312h11.27V80c0-17.6 13.3-32 29.55-32 16.26 0 29.55 14.4 29.55 32v151.75l14.78.25V32c0-17.6 13.3-32 29.55-32 16.3 0 29.55 14.4 29.55 32v199.75L315 232V64c0-17.6 13.3-32 29.55-32 16.26 0 29.55 14.4 29.55 32v183.75l14.78.25V128c0-17.6 13.3-32 29.55-32C434.7 96 448 110.4 448 128v216c0 75.8-37.13 168-169 168-40.8 0-79.42-7-100.66-21a121.41 121.41 0 01-33.72-33.31 138 138 0 01-16-31.78L66.16 250.77c-6.11-16.31 1.2-35.06 16.26-41.69z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a6cec6b274080b90(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M79.2 211.44c15.52-8.82 34.91-2.28 43.31 13.68l41.38 84.41a7 7 0 008.93 3.43 7 7 0 004.41-6.52V72c0-13.91 12.85-24 26.77-24s26 10.09 26 24v156.64A11.24 11.24 0 00240.79 240 11 11 0 00252 229V24c0-13.91 10.94-24 24.86-24S302 10.09 302 24v204.64A11.24 11.24 0 00312.79 240 11 11 0 00324 229V56c0-13.91 12.08-24 26-24s26 11.09 26 25v187.64A11.24 11.24 0 00386.79 256 11 11 0 00398 245V120c0-13.91 11.08-24 25-24s25.12 10.22 25 24v216c0 117.41-72 176-160 176h-16c-88 0-115.71-39.6-136-88L67.33 255c-6.66-18-3.64-34.75 11.87-43.56z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$35c0a530311efac9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "184",
                    "cy": "232",
                    "r": "24"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256.05 384c-45.42 0-83.62-29.53-95.71-69.83a8 8 0 017.82-10.17h175.69a8 8 0 017.82 10.17c-11.99 40.3-50.2 69.83-95.62 69.83z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "328",
                    "cy": "232",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$76d567c445d7be37(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM328 208a24 24 0 11-24 24 23.94 23.94 0 0124-24zm-144 0a24 24 0 11-24 24 23.94 23.94 0 0124-24zm72.05 176c-45.42 0-83.75-29.49-95.72-69.83C159.29 310.65 158 304 158 304h196s-1.31 6.69-2.33 10.17c-11.78 40.36-50.2 69.83-95.62 69.83z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$84ccdf4321953de5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM184 208a24 24 0 11-24 24 23.94 23.94 0 0124-24zm167.67 106.17c-12 40.3-50.2 69.83-95.62 69.83s-83.62-29.53-95.72-69.83a8 8 0 017.83-10.17h175.69a8 8 0 017.82 10.17zM328 256a24 24 0 1124-24 23.94 23.94 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6902693ef80a089b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "352",
                    "height": "352",
                    "x": "80",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "224",
                    "height": "224",
                    "x": "144",
                    "y": "144",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 80V48m80 32V48M176 80V48m80 416v-32m80 32v-32m-160 32v-32m256-176h32m-32 80h32m-32-160h32M48 256h32m-32 80h32M48 176h32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f59f39e2922b9526(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 160h192v192H160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 198v-44h-32V88a24 24 0 00-24-24h-66V32h-44v32h-36V32h-44v32h-36V32h-44v32H88a24 24 0 00-24 24v66H32v44h32v36H32v44h32v36H32v44h32v66a24 24 0 0024 24h66v32h44v-32h36v32h44v-32h36v32h44v-32h66a24 24 0 0024-24v-66h32v-44h-32v-36h32v-44h-32v-36zm-352-70h256v256H128z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$34c006e1eff12110(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M352 128H160a32 32 0 00-32 32v192a32 32 0 0032 32h192a32 32 0 0032-32V160a32 32 0 00-32-32zm0 216a8 8 0 01-8 8H168a8 8 0 01-8-8V168a8 8 0 018-8h176a8 8 0 018 8z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "192",
                    "height": "192",
                    "x": "160",
                    "y": "160",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 192a16 16 0 000-32h-16v-32a64.07 64.07 0 00-64-64h-32V48a16 16 0 00-32 0v16h-48V48a16 16 0 00-32 0v16h-48V48a16 16 0 00-32 0v16h-32a64.07 64.07 0 00-64 64v32H48a16 16 0 000 32h16v48H48a16 16 0 000 32h16v48H48a16 16 0 000 32h16v32a64.07 64.07 0 0064 64h32v16a16 16 0 0032 0v-16h48v16a16 16 0 0032 0v-16h48v16a16 16 0 0032 0v-16h32a64.07 64.07 0 0064-64v-32h16a16 16 0 000-32h-16v-48h16a16 16 0 000-32h-16v-48zm-80 160a32 32 0 01-32 32H160a32 32 0 01-32-32V160a32 32 0 0132-32h192a32 32 0 0132 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$62e4a3d81f049dc7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M83 384c-13-33-35-93.37-35-128C48 141.12 149.33 48 256 48s208 93.12 208 208c0 34.63-23 97-35 128"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M108.39 270.13l-13.69 8h0c-30.23 17.7-31.7 72.41-3.38 122.2s75.87 75.81 106.1 58.12h0l13.69-8a16.16 16.16 0 005.78-21.87L130 276a15.74 15.74 0 00-21.61-5.87zm295.22 0l13.69 8h0c30.23 17.69 31.74 72.4 3.38 122.19s-75.87 75.81-106.1 58.12h0l-13.69-8a16.16 16.16 0 01-5.78-21.87L382 276a15.74 15.74 0 0121.61-5.87z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c41a5ccf9074fb0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M411.16 97.45C368.43 55.85 311.88 32 256 32S143.57 55.85 100.84 97.45C56.45 140.67 32 196 32 256s26.84 118.49 45.42 152.25S121 480 144 480c32 0 96-32 96-32L128 240l-54.42 31.73a176.07 176.07 0 01-1-18.84c0-48.57 19.32-94.1 56.15-130C164.24 88.34 210 70 256 70s91.73 18.34 127.27 52.93c36.83 35.86 56.14 81.39 56.14 130a175.56 175.56 0 01-1 18.82L384 240 272 448s64 32 96 32c23 0 48-38 66.58-71.75S480 316 480 256s-24.45-115.33-68.84-158.55z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c5ca2b477dcc30f0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M411.16 97.46C368.43 55.86 311.88 32 256 32S143.57 55.86 100.84 97.46C56.45 140.67 32 197 32 256c0 26.67 8.75 61.09 32.88 125.55S137 473 157.27 477.41c5.81 1.27 12.62 2.59 18.73 2.59a60.06 60.06 0 0030-8l14-8c15.07-8.82 19.47-28.13 10.8-43.35l-86.92-152.57a31.73 31.73 0 00-43.57-11.76l-13.69 8a56.49 56.49 0 00-14 11.59 4 4 0 01-7-2A114.68 114.68 0 0164 256c0-50.31 21-98.48 59.16-135.61C160 84.55 208.39 64 256 64s96 20.55 132.84 56.39C427 157.52 448 205.69 448 256a114.68 114.68 0 01-1.68 17.91 4 4 0 01-7 2 56.49 56.49 0 00-14-11.59l-13.69-8a31.73 31.73 0 00-43.57 11.76L281.2 420.65c-8.67 15.22-4.27 34.53 10.8 43.35l14 8a60.06 60.06 0 0030 8c6.11 0 12.92-1.32 18.73-2.59C375 473 423 446 447.12 381.55S480 282.67 480 256c0-59-24.45-115.33-68.84-158.54z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7e7fb269e8859a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 360a16 16 0 01-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06 25.22-56.33 55.53-56.33 20.4 0 35 10.63 44.1 20.41a6 6 0 008.72 0c9.11-9.78 23.7-20.41 44.1-20.41 30.31 0 55.22 25.27 55.53 56.33.28 27.1-9.31 52.13-29.3 76.5-9.38 11.44-26.4 29.73-65.7 56.41A16 16 0 01256 360z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c73e21d83003d9da(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm74.69 252.82c-8.5 10.36-39.69 38.48-74.69 63.51-35-25-66.19-53.15-74.69-63.51-20-24.37-29.58-49.4-29.3-76.5.31-31.06 25.22-56.33 55.53-56.33 22 0 37.3 12.41 46.19 22.76l2.27 2.75 2.27-2.75C267 180.29 282.42 168 304.46 168c30.31 0 55.22 25.27 55.53 56.33.28 27.09-9.31 52.12-29.3 76.49z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f12054e9c34e7af4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm74.69 252.82c-9.38 11.44-26.4 29.73-65.7 56.41a15.93 15.93 0 01-18 0c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06 25.22-56.33 55.53-56.33 20.4 0 35 10.63 44.1 20.41a6 6 0 008.72 0c9.11-9.78 23.7-20.41 44.1-20.41 30.31 0 55.22 25.27 55.53 56.33.3 27.1-9.29 52.13-29.28 76.5z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5207ecedad9aecf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M333.2 297.69c18.28-23.39 27.06-47.43 26.79-73.37-.31-31.06-25.22-56.33-55.53-56.33-20.4 0-35 10.64-44.11 20.42a5.93 5.93 0 01-8.7 0c-9.11-9.78-23.71-20.42-44.11-20.42L206 168a4 4 0 00-2.75 6.84l124 123.21a3.92 3.92 0 005.95-.36zM158.84 221a4 4 0 00-6.82 2.72v.64c-.28 27.1 9.31 52.13 29.3 76.5 9.38 11.44 26.4 29.73 65.7 56.41a15.93 15.93 0 0018 0c5.15-3.49 9.9-6.84 14.31-10a4 4 0 00.46-6.07zM336 368a15.92 15.92 0 01-11.31-4.69l-176-176a16 16 0 0122.62-22.62l176 176A16 16 0 01336 368z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$658d0b31921df4a7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm63.73 310.36l-183.14-182.3 22.74-22.51 183.19 182.36zm-63.51 4.86c-35.36-25-66.31-51.92-74.91-62.4-20-24.37-29.58-49.4-29.3-76.5a58.27 58.27 0 01.85-9.31l130.21 129.4c-3.43 2.59-16.21 11.45-26.85 18.81zm74.47-62.4l-.31.38L197.33 169a53.8 53.8 0 0110.21-1 59.34 59.34 0 0144.1 19.41L256 192l4.36-4.6a59.34 59.34 0 0144.1-19.4c30.31 0 55.22 25.27 55.53 56.33.28 27.09-9.31 52.12-29.3 76.49z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4a5cc89d1e563eff(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm23.3 299.19c-4.41 3.2-9.16 6.55-14.31 10a15.93 15.93 0 01-18 0c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5v-.64a4 4 0 016.82-2.72l120.95 120.2a4 4 0 01-.46 6.07zm68 16.12a16 16 0 01-22.62 0l-176-176a16 16 0 0122.62-22.62l176 176a16 16 0 01.01 22.62zm-14.1-65.62a3.92 3.92 0 01-6 .37l-124-123.21A4 4 0 01206 168h1.55c20.4 0 35 10.64 44.11 20.42a5.93 5.93 0 008.7 0c9.11-9.78 23.71-20.42 44.11-20.42 30.31 0 55.22 25.27 55.53 56.33.26 25.93-8.52 49.97-26.8 73.36z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$155a45ea7e9da855(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M417.84 448a15.94 15.94 0 01-11.35-4.72L40.65 75.26a16 16 0 0122.7-22.56l365.83 368a16 16 0 01-11.34 27.3zM364.92 80c-48.09 0-80 29.55-96.92 51-16.88-21.48-48.83-51-96.92-51a107.37 107.37 0 00-31 4.55L168 112c22.26 0 45.81 9 63.94 26.67a123 123 0 0121.75 28.47 16 16 0 0028.6 0 123 123 0 0121.77-28.51C322.19 121 342.66 112 364.92 112c43.15 0 78.62 36.33 79.07 81 .54 53.69-22.75 99.55-57.38 139.52l22.63 22.77c3-3.44 5.7-6.64 8.14-9.6 40-48.75 59.15-98.8 58.61-153C475.37 130.52 425.54 80 364.92 80zM268 432C180.38 372.51 91 297.6 92 193a83.69 83.69 0 012.24-18.39L69 149.14a115.1 115.1 0 00-9 43.49c-.54 54.22 18.63 104.27 58.61 153 18.77 22.87 52.8 59.45 131.39 112.8a31.84 31.84 0 0036 0c20.35-13.81 37.7-26.5 52.58-38.11l-22.66-22.81C300.25 409.6 284.09 421.05 268 432z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9c20d6b2e53af932(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64.45l389.47 389.94 22.84-22.47L54.85 42 32 64.45zm30.67 128.46c-.56 55.63 19.77 106.94 62.16 156.88 40.25 47.42 94.56 79.67 137.47 108.21l9 6 9-6c18.49-12.3 39.1-25.3 59.79-39.89L71.74 149.28a114.62 114.62 0 00-9.07 43.63zm355.16 156.88c42.39-49.94 62.72-101.25 62.16-156.88-.63-62-50.61-112.54-111.43-112.54-48.26 0-80.35 28-97.23 48.17-16.88-20.2-49-48.17-97.23-48.17A108.24 108.24 0 00142.84 85l270 270.48c1.71-1.89 3.37-3.78 4.99-5.69z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fd29f59efb91f81a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M417.84 448a16 16 0 01-11.35-4.72l-365.84-368a16 16 0 1122.7-22.56l365.83 368A16 16 0 01417.84 448zM364.92 80c-44.09 0-74.61 24.82-92.39 45.5a6 6 0 01-9.06 0C245.69 104.82 215.16 80 171.08 80a107.71 107.71 0 00-31 4.54l269.13 270.7c3-3.44 5.7-6.64 8.14-9.6 40-48.75 59.15-98.79 58.61-153C475.37 130.53 425.54 80 364.92 80zM69 149.15a115.06 115.06 0 00-9 43.49c-.54 54.21 18.63 104.25 58.61 153 18.77 22.87 52.8 59.45 131.39 112.8a31.88 31.88 0 0036 0c20.35-13.82 37.7-26.5 52.58-38.12z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3694e9079e739b6c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.92 64c-48.09 0-80 29.54-96.92 51-16.88-21.49-48.83-51-96.92-51C98.46 64 48.63 114.54 48 176.65c-.54 54.21 18.63 104.27 58.61 153 18.77 22.88 52.8 59.46 131.39 112.81a31.84 31.84 0 0036 0c78.59-53.35 112.62-89.93 131.39-112.81 40-48.74 59.15-98.8 58.61-153C463.37 114.54 413.54 64 352.92 64zM256 416V207.58c0-19.63 5.23-38.76 14.21-56.22a1.19 1.19 0 01.08-.16 123 123 0 0121.77-28.51C310.19 105 330.66 96 352.92 96c43.15 0 78.62 36.32 79.07 81C433 281.61 343.63 356.51 256 416z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d43d8210925fa501(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.92 64c-48.11 0-80.1 28-96.92 48.21C239.18 92 207.19 64 159.08 64 98.46 64 48.63 114.54 48 176.65c-.56 55.68 19.71 107 62 157 40.12 47.46 94.25 79.75 137 108.32l9 6 9-6c42.78-28.57 96.91-60.86 137-108.32 42.25-50 62.52-101.35 62-157C463.37 114.54 413.54 64 352.92 64zm24.67 249c-31.78 37.6-74.68 65.75-112.52 90.59l-9.07 6V162.23l24.59-29.54C294.53 116 318.38 96 352.92 96c43.15 0 78.62 36.32 79.07 81a178.63 178.63 0 01-12.69 68.59c-9.03 22.84-22.67 44.91-41.71 67.41z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a89f2fc5f878286d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.92 64c-48.09 0-80 29.54-96.92 51-16.88-21.49-48.83-51-96.92-51C98.46 64 48.63 114.54 48 176.65c-.54 54.21 18.63 104.27 58.61 153 18.77 22.88 52.8 59.46 131.39 112.81a31.84 31.84 0 0036 0c78.59-53.35 112.62-89.93 131.39-112.81 40-48.74 59.15-98.8 58.61-153C463.37 114.54 413.54 64 352.92 64zM256 416V207.58c0-19.63 5.23-38.76 14.21-56.22a1.19 1.19 0 01.08-.16 123 123 0 0121.77-28.51C310.19 105 330.66 96 352.92 96c43.15 0 78.62 36.32 79.07 81C433 281.61 343.63 356.51 256 416z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1c1ecbe54db5bcf7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352.92 80C288 80 256 144 256 144s-32-64-96.92-64c-52.76 0-94.54 44.14-95.08 96.81-1.1 109.33 86.73 187.08 183 252.42a16 16 0 0018 0c96.26-65.34 184.09-143.09 183-252.42-.54-52.67-42.32-96.81-95.08-96.81z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f7db050ec5305444(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 448l-9-6c-42.78-28.57-96.91-60.86-137-108.32-42.25-50-62.52-101.35-62-157C48.63 114.54 98.46 64 159.08 64c48.11 0 80.1 28 96.92 48.21C272.82 92 304.81 64 352.92 64c60.62 0 110.45 50.54 111.08 112.65.56 55.68-19.71 107-62 157-40.09 47.49-94.22 79.78-137 108.35z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c9965178a121830(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 448a32 32 0 01-18-5.57c-78.59-53.35-112.62-89.93-131.39-112.8-40-48.75-59.15-98.8-58.61-153C48.63 114.52 98.46 64 159.08 64c44.08 0 74.61 24.83 92.39 45.51a6 6 0 009.06 0C278.31 88.81 308.84 64 352.92 64c60.62 0 110.45 50.52 111.08 112.64.54 54.21-18.63 104.26-58.61 153-18.77 22.87-52.8 59.45-131.39 112.8a32 32 0 01-18 5.56z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d392a2fdd616c87c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "80",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M208 54l8 132m80 0l8-132m-96 404l8-132m80 0l8 132m154-250l-132 8m0 80l132 8M54 208l132 8m0 80l-132 8"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$531c601995e1aaf2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.29 32 32 132.29 32 256s100.29 224 224 224 224-100.29 224-224S379.71 32 256 32zm-64 224a64 64 0 1164 64 64 64 0 01-64-64zm237.24-62.29L342.91 199a104.86 104.86 0 00-29.86-29.86l5.24-86.33a185 185 0 01111 111zm-303.35-67.82a183.44 183.44 0 0167.82-43.13l5.29 86.33A104.86 104.86 0 00169.09 199l-86.33-5.24a183.44 183.44 0 0143.13-67.87zm-43.13 192.4l86.33-5.24A104.86 104.86 0 00199 342.91l-5.24 86.33a185 185 0 01-111-110.95zm303.35 67.82a183.44 183.44 0 01-67.82 43.13l-5.24-86.33a104.86 104.86 0 0029.86-29.86l86.33 5.24a183.44 183.44 0 01-43.13 67.82z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4e7bd67cecd658cf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM192.13 260.18a64 64 0 1159.69 59.69 64.07 64.07 0 01-59.69-59.69zm240-66.64l-96.37 5.84a4.06 4.06 0 01-3.44-1.59 96 96 0 00-18.07-18.07 4.06 4.06 0 01-1.59-3.44l5.84-96.37a4 4 0 015.42-3.51A193 193 0 01435.6 188.12a4 4 0 01-3.51 5.42zM193.54 79.91l5.84 96.37a4.06 4.06 0 01-1.59 3.44 96 96 0 00-18.07 18.07 4.06 4.06 0 01-3.44 1.59l-96.37-5.84a4 4 0 01-3.51-5.42A193 193 0 01188.12 76.4a4 4 0 015.42 3.51zM79.91 318.46l96.37-5.84a4.06 4.06 0 013.44 1.59 96 96 0 0018.07 18.07 4.06 4.06 0 011.59 3.44l-5.84 96.37a4 4 0 01-5.42 3.51A193 193 0 0176.4 323.88a4 4 0 013.51-5.42zm238.55 113.63l-5.84-96.37a4.06 4.06 0 011.59-3.44 96 96 0 0018.07-18.07 4.06 4.06 0 013.44-1.59l96.37 5.84a4 4 0 013.51 5.42A193 193 0 01323.88 435.6a4 4 0 01-5.42-3.51z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$617d483977969bc5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 80a176 176 0 10176 176A176 176 0 00256 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "28",
                    "d": "M200 202.29s.84-17.5 19.57-32.57C230.68 160.77 244 158.18 256 158c10.93-.14 20.69 1.67 26.53 4.45 10 4.76 29.47 16.38 29.47 41.09 0 26-17 37.81-36.37 50.8S251 281.43 251 296"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "250",
                    "cy": "348",
                    "r": "20"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$562a393b9f13edb2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M288.55 150.84c-8.09-3.86-20-6-32.72-5.82-18 .22-33.13 5.2-45 14.78-23 18.48-24.55 40.37-24.77 42.8a61.69 61.69 0 00-.09 12 3 3 0 003 2.69h21.23a3 3 0 003-3A65.7 65.7 0 01214 204c0-.11 1.14-11.7 14.36-22.34 7-5.64 16.11-8.44 27.83-8.59 9.32-.11 16.93 1.47 20.34 3.09C291 183 298 192.31 298 204.57c0 18-10.9 26.23-30.18 39.18C247.08 257.68 237 275.1 237 297v11a3 3 0 003 3h22a3 3 0 003-3v-11c0-9.16 2.23-19.13 18.44-30 19.95-13.41 42.56-28.6 42.56-62.43 0-23.14-13.3-42.23-37.45-53.73z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64zm10.44 302h-30.21a2.57 2.57 0 01-2.56-2.57v-30.2a2.57 2.57 0 012.56-2.57h30.21a2.57 2.57 0 012.56 2.57v30.2a2.57 2.57 0 01-2.56 2.57zm17-99C267.23 277.88 265 287.85 265 297v11a3 3 0 01-3 3h-22a3 3 0 01-3-3v-11c0-21.91 10.08-39.33 30.82-53.26C287.1 230.8 298 222.6 298 204.57c0-12.26-7-21.57-21.49-28.46-3.41-1.62-11-3.2-20.34-3.09-11.72.15-20.82 2.95-27.83 8.59C215.12 192.25 214 203.84 214 204a65.7 65.7 0 00-.84 10.28 3 3 0 01-3 3h-21.25a3 3 0 01-3-2.69 61.69 61.69 0 01.09-12c.22-2.43 1.8-24.32 24.77-42.8 11.91-9.58 27.06-14.56 45-14.78 12.7-.15 24.63 2 32.72 5.82 24.21 11.51 37.51 30.6 37.51 53.74 0 33.83-22.61 49.02-42.56 62.43z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3e8826513a2d59df(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64zm-6 304a20 20 0 1120-20 20 20 0 01-20 20zm33.44-102C267.23 276.88 265 286.85 265 296a14 14 0 01-28 0c0-21.91 10.08-39.33 30.82-53.26C287.1 229.8 298 221.6 298 203.57c0-12.26-7-21.57-21.49-28.46-3.41-1.62-11-3.2-20.34-3.09-11.72.15-20.82 2.95-27.83 8.59C215.12 191.25 214 202.83 214 203a14 14 0 11-28-1.35c.11-2.43 1.8-24.32 24.77-42.8 11.91-9.58 27.06-14.56 45-14.78 12.7-.15 24.63 2 32.72 5.82C312.7 161.34 326 180.43 326 203.57c0 33.83-22.61 49.02-42.56 62.43z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1043d70f33532e50(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "40",
                    "d": "M160 164s1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 298.36 248 324"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "248",
                    "cy": "399.99",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$75442ec43815afc1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "40",
                    "d": "M160 164c0-10 1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 290.36 248 316"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "56",
                    "height": "56",
                    "x": "220",
                    "y": "368",
                    "rx": "3.5",
                    "ry": "3.5"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$466c99e18985e1a0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "40",
                    "d": "M160 164s1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 298.36 248 324"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "248",
                    "cy": "399.99",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7dfc7de2247aebe4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 212v236a16 16 0 0016 16h96V328a24 24 0 0124-24h80a24 24 0 0124 24v136h96a16 16 0 0016-16V212"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M480 256L266.89 52c-5-5.28-16.69-5.34-21.78 0L32 256m368-77V64h-48v69"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$df28498826be00a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 174.74V48h-80v58.45L256 32 0 272h64v208h144V320h96v160h144V272h64l-96-97.26z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$98f3184ec34d178c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M261.56 101.28a8 8 0 00-11.06 0L66.4 277.15a8 8 0 00-2.47 5.79L63.9 448a32 32 0 0032 32H192a16 16 0 0016-16V328a8 8 0 018-8h80a8 8 0 018 8v136a16 16 0 0016 16h96.06a32 32 0 0032-32V282.94a8 8 0 00-2.47-5.79z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M490.91 244.15l-74.8-71.56V64a16 16 0 00-16-16h-48a16 16 0 00-16 16v32l-57.92-55.38C272.77 35.14 264.71 32 256 32c-8.68 0-16.72 3.14-22.14 8.63l-212.7 203.5c-6.22 6-7 15.87-1.34 22.37A16 16 0 0043 267.56L250.5 69.28a8 8 0 0111.06 0l207.52 198.28a16 16 0 0022.59-.44c6.14-6.36 5.63-16.86-.76-22.97z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$79b62263b7cca179(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M145.61 464h220.78c19.8 0 35.55-16.29 33.42-35.06C386.06 308 304 310 304 256s83.11-51 95.8-172.94c2-18.78-13.61-35.06-33.41-35.06H145.61c-19.8 0-35.37 16.28-33.41 35.06C124.89 205 208 201 208 256s-82.06 52-95.8 172.94c-2.14 18.77 13.61 35.06 33.41 35.06z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M343.3 432H169.13c-15.6 0-20-18-9.06-29.16C186.55 376 240 356.78 240 326V224c0-19.85-38-35-61.51-67.2-3.88-5.31-3.49-12.8 6.37-12.8h142.73c8.41 0 10.23 7.43 6.4 12.75C310.82 189 272 204.05 272 224v102c0 30.53 55.71 47 80.4 76.87 9.95 12.04 6.47 29.13-9.1 29.13z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fda1a26850281687(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H96v112l108 112L96 368v112h320V368L308 256l108-112zM272 224v112l91 96H148l92-96V224l-80-80h192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f1d58fd5ee6fd3f5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M415.7 427.13c-8.74-76.89-43.83-108.76-69.46-132C328.52 279 320 270.61 320 256c0-14.41 8.49-22.64 26.16-38.44 25.93-23.17 61.44-54.91 69.56-132.84a47 47 0 00-12-36.26A50.3 50.3 0 00366.39 32H145.61a50.34 50.34 0 00-37.39 16.46 47.05 47.05 0 00-11.94 36.26c8.09 77.68 43.47 109.19 69.3 132.19C183.42 232.8 192 241.09 192 256c0 15.1-8.6 23.56-26.5 39.75-25.5 23.1-60.5 54.73-69.2 131.38a46.59 46.59 0 0011.7 36.2A50.44 50.44 0 00145.61 480h220.78A50.44 50.44 0 00404 463.33a46.59 46.59 0 0011.7-36.2zM343.3 432H169.13c-15.6 0-20-18-9.06-29.16C186.55 376 240 356.78 240 326V224c0-19.85-38-35-61.51-67.2-3.88-5.31-3.49-12.8 6.37-12.8h142.73c8.41 0 10.22 7.43 6.4 12.75C310.82 189 272 204.05 272 224v102c0 30.53 55.71 47 80.4 76.87 9.95 12.04 6.47 29.13-9.1 29.13z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a51bb2e341a7b003(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 256l-96 224-62-145"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M299.42 223.48C291.74 239.75 275.18 252 256 252c-13.1 0-27-5-33.63-9.76C216.27 237.87 208 240 208 250v62a24.07 24.07 0 01-24 24h0a24.07 24.07 0 01-24-24v-56h-2c-35.35 0-62-28.65-62-64a64 64 0 0164-64h8v-8a88 88 0 01176 0v8h8a64 64 0 010 128c-21.78 0-42-13-52.59-32.51z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a94620456b7340f4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M359.72 112.37a104 104 0 00-207.44 0A80.12 80.12 0 0080 192c0 39.36 26.37 71.23 62.38 78.46a2 2 0 011.62 2v38.83c0 21.84 17.2 40.22 39 40.74a40 40 0 0041-40v-47.84a2 2 0 012.72-1.86A83.47 83.47 0 00256 268a63.18 63.18 0 0042.24-16.59 2 2 0 012.74 0A74.63 74.63 0 00352 272a80 80 0 007.72-159.63z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 300v12a72.1 72.1 0 01-58.21 70.64L256 496l92.06-192.08a105.29 105.29 0 01-49.18-14.36A93.75 93.75 0 01256 300z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ac4e0c035a54214b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183 352c-21.84-.52-39-18.9-39-40.74v-34.07a8 8 0 00-6-7.74c-33.75-8.85-58-39.71-58-77.45a80.14 80.14 0 0166.27-78.82 8 8 0 006.62-6.83 104 104 0 01206.22 0 8 8 0 006.62 6.83A80 80 0 01352 272a74.33 74.33 0 01-47.45-17.41 7.93 7.93 0 00-9.92-.14A62.89 62.89 0 01256 268a80.47 80.47 0 01-21.8-3.18 8 8 0 00-10.2 7.69V312a40 40 0 01-41 40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M263.39 299.7a8 8 0 00-7.39 7.91V312a72.11 72.11 0 01-50.69 68.76 8 8 0 00-4.91 10.78l40.91 94.8A16 16 0 00256 496a16 16 0 0014.69-9.7l73.78-172.15a8 8 0 00-6.2-11.07 106.31 106.31 0 01-35.9-11.59 8 8 0 00-7.13-.2 95 95 0 01-31.85 8.41z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$db3afb9cfdb9d7d8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "320",
                    "height": "448",
                    "x": "96",
                    "y": "32",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M208 80h96"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M333.48 284.51A39.65 39.65 0 00304 272c-11.6 0-22.09 4.41-29.54 12.43s-11.2 19.12-10.34 31C265.83 338.91 283.72 358 304 358s38.14-19.09 39.87-42.55c.88-11.78-2.82-22.77-10.39-30.94zM371.69 448H236.31a12.05 12.05 0 01-9.31-4.17 13 13 0 01-2.76-10.92c3.25-17.56 13.38-32.31 29.3-42.66C267.68 381.06 285.6 376 304 376s36.32 5.06 50.46 14.25c15.92 10.35 26.05 25.1 29.3 42.66a13 13 0 01-2.76 10.92 12.05 12.05 0 01-9.31 4.17z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ec0c4c988ca4a739(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 16H104a24 24 0 00-24 24v432a24 24 0 0024 24h304a24 24 0 0024-24V40a24 24 0 00-24-24zm-61.1 296.77a43 43 0 11-40.71-40.71 43 43 0 0140.71 40.71zM192 64h128v32H192zm192 384H224v-24.6c0-32.72 53.27-49.21 80-49.21s80 16.49 80 49.21z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5592b82203c1e8dc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 16H144a64.07 64.07 0 00-64 64v352a64.07 64.07 0 0064 64h224a64.07 64.07 0 0064-64V80a64.07 64.07 0 00-64-64zm-34.52 268.51c7.57 8.17 11.27 19.16 10.39 30.94C342.14 338.91 324.25 358 304 358s-38.17-19.09-39.88-42.55c-.86-11.9 2.81-22.91 10.34-31S292.4 272 304 272a39.65 39.65 0 0129.48 12.51zM192 80a16 16 0 0116-16h96a16 16 0 010 32h-96a16 16 0 01-16-16zm189 363.83a12.05 12.05 0 01-9.31 4.17H236.31a12.05 12.05 0 01-9.31-4.17 13 13 0 01-2.76-10.92c3.25-17.56 13.38-32.31 29.3-42.66C267.68 381.06 285.6 376 304 376s36.32 5.06 50.46 14.25c15.92 10.35 26.05 25.1 29.3 42.66a13 13 0 01-2.76 10.92z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f2cca793da8c0db1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "352",
                    "x": "48",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "336",
                    "cy": "176",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 335.79l-90.66-90.49a32 32 0 00-43.87-1.3L48 352m176 80l123.34-123.34a32 32 0 0143.11-2L464 368"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8cab109a6cb9281b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 64H56a24 24 0 00-24 24v336a24 24 0 0024 24h400a24 24 0 0024-24V88a24 24 0 00-24-24zm-124.38 64.2a48 48 0 11-43.42 43.42 48 48 0 0143.42-43.42zM76 416a12 12 0 01-12-12v-87.63L192.64 202l96.95 96.75L172.37 416zm372-12a12 12 0 01-12 12H217.63l149.53-149.53L448 333.84z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ea4efe16e61350c2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 64H96a64.07 64.07 0 00-64 64v256a64.07 64.07 0 0064 64h320a64.07 64.07 0 0064-64V128a64.07 64.07 0 00-64-64zm-80 64a48 48 0 11-48 48 48.05 48.05 0 0148-48zM96 416a32 32 0 01-32-32v-67.63l94.84-84.3a48.06 48.06 0 0165.8 1.9l64.95 64.81L172.37 416zm352-32a32 32 0 01-32 32H217.63l121.42-121.42a47.72 47.72 0 0161.64-.16L448 333.84z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d5d739dab27808e4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432 112V96a48.14 48.14 0 00-48-48H64a48.14 48.14 0 00-48 48v256a48.14 48.14 0 0048 48h16"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "400",
                    "height": "336",
                    "x": "96",
                    "y": "128",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "45.99",
                    "ry": "45.99"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "372.92",
                    "cy": "219.64",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "30.77",
                    "ry": "30.55"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M342.15 372.17L255 285.78a30.93 30.93 0 00-42.18-1.21L96 387.64M265.23 464l118.59-117.73a31 31 0 0141.46-1.87L496 402.91"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$687267dfbfd12a05(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "373.14",
                    "cy": "219.33",
                    "fill": "none",
                    "rx": "46.29",
                    "ry": "46"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M80 132v328a20 20 0 0020 20h392a20 20 0 0020-20V132a20 20 0 00-20-20H100a20 20 0 00-20 20zm293.14 41.33a46 46 0 11-46.28 46 46.19 46.19 0 0146.28-46zm-261.41 276v-95.48l122.76-110.2L328.27 337l-113 112.33zm368.27 0H259l144.58-144L480 370.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 32A20 20 0 000 52v344a20 20 0 0020 20h28V100a20 20 0 0120-20h380V52a20 20 0 00-20-20z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$276d308d7f1418c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M450.29 112H142c-34 0-62 27.51-62 61.33v245.34c0 33.82 28 61.33 62 61.33h308c34 0 62-26.18 62-60V173.33c0-33.82-27.68-61.33-61.71-61.33zm-77.15 61.34a46 46 0 11-46.28 46 46.19 46.19 0 0146.28-46.01zm-231.55 276c-17 0-29.86-13.75-29.86-30.66v-64.83l90.46-80.79a46.54 46.54 0 0163.44 1.83L328.27 337l-113 112.33zM480 418.67a30.67 30.67 0 01-30.71 30.66H259L376.08 333a46.24 46.24 0 0159.44-.16L480 370.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64A64 64 0 000 96v256a64.11 64.11 0 0048 62V152a72 72 0 0172-72h326a64.11 64.11 0 00-62-48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$371fc3994dedd8bf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 256s-48-96-126-96c-54.12 0-98 43-98 96s43.88 96 98 96c37.51 0 71-22.41 94-48m32-48s48 96 126 96c54.12 0 98-43 98-96s-43.88-96-98-96c-37.51 0-71 22.41-94 48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ffb81110f5ae1535(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382 136c-40.87 0-73.46 20.53-93.6 37.76l-.71.61-11.47 12.47 25.32 41.61 18.74-18.79C339.89 193.1 361.78 184 382 184c40.8 0 74 32.3 74 72s-33.2 72-74 72c-62 0-104.14-81.95-104.56-82.78C275 240.29 221.56 136 130 136 62.73 136 8 189.83 8 256s54.73 120 122 120c32.95 0 65.38-13.11 93.79-37.92l.61-.54 11.38-12.38-25.33-41.61-18.83 18.88C172 319.4 151.26 328 130 328c-40.8 0-74-32.3-74-72s33.2-72 74-72c62 0 104.14 81.95 104.56 82.78C237 271.71 290.44 376 382 376c67.27 0 122-53.83 122-120s-54.73-120-122-120z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3de9c5e75286f9e7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M256 256s-48-96-126-96c-54.12 0-98 43-98 96s43.88 96 98 96c30 0 56.45-13.18 78-32m48-64s48 96 126 96c54.12 0 98-43 98-96s-43.88-96-98-96c-29.37 0-56.66 13.75-78 32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e6b5b53493874e61(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M220 220h32v116"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M208 340h88"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M248 130a26 26 0 1026 26 26 26 0 00-26-26z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b2811d118e1a593e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 56C145.72 56 56 145.72 56 256s89.72 200 200 200 200-89.72 200-200S366.28 56 256 56zm0 82a26 26 0 11-26 26 26 26 0 0126-26zm64 226H200v-32h44v-88h-32v-32h64v120h44z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c6318145797e3a13(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 56C145.72 56 56 145.72 56 256s89.72 200 200 200 200-89.72 200-200S366.28 56 256 56zm0 82a26 26 0 11-26 26 26 26 0 0126-26zm48 226h-88a16 16 0 010-32h28v-88h-16a16 16 0 010-32h32a16 16 0 0116 16v104h28a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$51dd893502fce78f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "40",
                    "d": "M196 220h64v172"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "40",
                    "d": "M187 396h138"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 160a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f353627448bb305c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "40",
                    "d": "M196 220h64v172m-73 4h138"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 160a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d37c90c4f7e01c4b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "40",
                    "d": "M196 220h64v172"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "40",
                    "d": "M187 396h138"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 160a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d82e475233aa64cb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 176v160a80 80 0 010-160zm0-128v128a80 80 0 010 160v128c114.88 0 208-93.12 208-208S370.88 48 256 48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fc2cbb8a0d95469f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM256 432v-96a80 80 0 010-160V80c97.05 0 176 79 176 176s-78.95 176-176 176z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 256a80 80 0 00-80-80v160a80 80 0 0080-80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$16b2d78e2b2662a0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 176v160a80 80 0 000-160zm0-128v128a80 80 0 000 160v128c-114.88 0-208-93.12-208-208S141.12 48 256 48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$86af692bbb879e7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "320",
                    "height": "416",
                    "x": "96",
                    "y": "48",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "60",
                    "d": "M320 48v416"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4259008a1c261a84(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290 32H104a24 24 0 00-24 24v400a24 24 0 0024 24h186zm118 0h-58v448h58a24 24 0 0024-24V56a24 24 0 00-24-24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$177758f7a8ab91e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290 32H144a64.07 64.07 0 00-64 64v320a64.07 64.07 0 0064 64h146zm78 0h-18v448h18a64.07 64.07 0 0064-64V96a64.07 64.07 0 00-64-64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a78db5d167599302(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M218.1 167.17c0 13 0 25.6 4.1 37.4-43.1 50.6-156.9 184.3-167.5 194.5a20.17 20.17 0 00-6.7 15c0 8.5 5.2 16.7 9.6 21.3 6.6 6.9 34.8 33 40 28 15.4-15 18.5-19 24.8-25.2 9.5-9.3-1-28.3 2.3-36s6.8-9.2 12.5-10.4 15.8 2.9 23.7 3c8.3.1 12.8-3.4 19-9.2 5-4.6 8.6-8.9 8.7-15.6.2-9-12.8-20.9-3.1-30.4s23.7 6.2 34 5 22.8-15.5 24.1-21.6-11.7-21.8-9.7-30.7c.7-3 6.8-10 11.4-11s25 6.9 29.6 5.9c5.6-1.2 12.1-7.1 17.4-10.4 15.5 6.7 29.6 9.4 47.7 9.4 68.5 0 124-53.4 124-119.2S408.5 48 340 48s-121.9 53.37-121.9 119.17zM400 144a32 32 0 11-32-32 32 32 0 0132 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$77165a13799db5a8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.1 167.2c0 13 0 25.6 4.1 37.4-43.1 50.6-167.5 194.5-167.5 194.5l2.9 36.3s34.8 33 40 28c15.4-15 24.8-25.2 24.8-25.2l7.24-43.35 47.11-3.47 3.78-46.8 49.63-.95.49-50.09 52.69 2.1 9-18.84c15.5 6.7 29.6 9.4 47.7 9.4 68.5 0 124-53.4 124-119.2S408.5 48 340 48s-121.9 53.4-121.9 119.2zM406.85 144A38.85 38.85 0 11368 105.15 38.81 38.81 0 01406.85 144z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$91900c3b4b97eb47(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.1 167.17c0 13 0 25.6 4.1 37.4-43.1 50.6-156.9 184.3-167.5 194.5a20.17 20.17 0 00-6.7 15c0 8.5 5.2 16.7 9.6 21.3 6.6 6.9 34.8 33 40 28 15.4-15 18.5-19 24.8-25.2 9.5-9.3-1-28.3 2.3-36s6.8-9.2 12.5-10.4 15.8 2.9 23.7 3c8.3.1 12.8-3.4 19-9.2 5-4.6 8.6-8.9 8.7-15.6.2-9-12.8-20.9-3.1-30.4s23.7 6.2 34 5 22.8-15.5 24.1-21.6-11.7-21.8-9.7-30.7c.7-3 6.8-10 11.4-11s25 6.9 29.6 5.9c5.6-1.2 12.1-7.1 17.4-10.4 15.5 6.7 29.6 9.4 47.7 9.4 68.5 0 124-53.4 124-119.2S408.5 48 340 48s-121.9 53.37-121.9 119.17zM400 144a32 32 0 11-32-32 32 32 0 0132 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$13a80e82fe14fd12(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "448",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "320",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M288 192a32 32 0 11-32-32 32 32 0 0132 32z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "64",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "320",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "192",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "64",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "320",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "192",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "64",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fa961f6dc9ed543e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "80",
                    "y": "16",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "208",
                    "y": "16",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "336",
                    "y": "16",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "80",
                    "y": "144",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "208",
                    "y": "144",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "336",
                    "y": "144",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "80",
                    "y": "272",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "208",
                    "y": "272",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "208",
                    "y": "400",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "336",
                    "y": "272",
                    "rx": "8",
                    "ry": "8"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9b255f7af204a8df(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 400a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm128 256a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zM128 272a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4ec1257a1702813d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 112h288M192 64v48m80 336l96-224 96 224m-162.5-64h133M281.3 112S257 206 199 277 80 384 80 384"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 336s-35-27-72-75-56-85-56-85"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4a6cb586fd46ca3f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M363 176L246 464h47.24l24.49-58h90.54l24.49 58H480zm-26.69 186L363 279.85 389.69 362zM272 320c-.25-.19-20.59-15.77-45.42-42.67 39.58-53.64 62-114.61 71.15-143.33H352V90H214V48h-44v42H32v44h219.25c-9.52 26.95-27.05 69.5-53.79 108.36-32.68-43.44-47.14-75.88-47.33-76.22L143 152l-38 22 6.87 13.86c.89 1.56 17.19 37.9 54.71 86.57.92 1.21 1.85 2.39 2.78 3.57-49.72 56.86-89.15 79.09-89.66 79.47L64 368l23 36 19.3-11.47c2.2-1.67 41.33-24 92-80.78 24.52 26.28 43.22 40.83 44.3 41.67L255 362z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$98bfae5849dca53(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M478.33 433.6l-90-218a22 22 0 00-40.67 0l-90 218a22 22 0 1040.67 16.79L316.66 406h102.67l18.33 44.39A22 22 0 00458 464a22 22 0 0020.32-30.4zM334.83 362L368 281.65 401.17 362zm-66.99-19.08a22 22 0 00-4.89-30.7c-.2-.15-15-11.13-36.49-34.73 39.65-53.68 62.11-114.75 71.27-143.49H330a22 22 0 000-44H214V70a22 22 0 00-44 0v20H54a22 22 0 000 44h197.25c-9.52 26.95-27.05 69.5-53.79 108.36-31.41-41.68-43.08-68.65-43.17-68.87a22 22 0 00-40.58 17c.58 1.38 14.55 34.23 52.86 83.93.92 1.19 1.83 2.35 2.74 3.51-39.24 44.35-77.74 71.86-93.85 80.74a22 22 0 1021.07 38.63c2.16-1.18 48.6-26.89 101.63-85.59 22.52 24.08 38 35.44 38.93 36.1a22 22 0 0030.75-4.9z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7f55ba2ead56eeb3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "304",
                    "x": "48",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32.14",
                    "ry": "32.14"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M16 416h480"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fdd06240bd8f3a83(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.29 400a27.75 27.75 0 002.71-12V108a28 28 0 00-28-28H60a28 28 0 00-28 28v280a27.75 27.75 0 002.71 12H0v32h512v-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d727fc2c17dbd372(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 400h-28.34A47.92 47.92 0 00480 367.86V128.14A48.2 48.2 0 00431.86 80H80.14A48.2 48.2 0 0032 128.14v239.72A47.92 47.92 0 0044.34 400H16a16 16 0 000 32h480a16 16 0 000-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f380999425a7ab77(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M434.8 137.65l-149.36-68.1c-16.19-7.4-42.69-7.4-58.88 0L77.3 137.65c-17.6 8-17.6 21.09 0 29.09l148 67.5c16.89 7.7 44.69 7.7 61.58 0l148-67.5c17.52-8 17.52-21.1-.08-29.09zM160 308.52l-82.7 37.11c-17.6 8-17.6 21.1 0 29.1l148 67.5c16.89 7.69 44.69 7.69 61.58 0l148-67.5c17.6-8 17.6-21.1 0-29.1l-79.94-38.47"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 204.48l-82.8 37.16c-17.6 8-17.6 21.1 0 29.1l148 67.49c16.89 7.7 44.69 7.7 61.58 0l148-67.49c17.7-8 17.7-21.1.1-29.1L352 204.48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3566a38c001a7413(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 150L256 48 32 150l224 104 224-104zM255.71 392.95l-144.81-66.2L32 362l224 102 224-102-78.69-35.3-145.6 66.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 256l-75.53-33.53L256.1 290.6l-148.77-68.17L32 256l224 102 224-102z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$555d825af9a0a014(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 256c-13.47 0-26.94-2.39-37.44-7.17l-148-67.49C63.79 178.26 48 169.25 48 152.24s15.79-26 22.58-29.12l149.28-68.07c20.57-9.4 51.61-9.4 72.19 0l149.37 68.07c6.79 3.09 22.58 12.1 22.58 29.12s-15.79 26-22.58 29.11l-148 67.48C282.94 253.61 269.47 256 256 256zm176.76-100.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M441.36 226.81L426.27 220l-38.77 17.74-94 43c-10.5 4.8-24 7.19-37.44 7.19s-26.93-2.39-37.42-7.19l-94.07-43L85.79 220l-15.22 6.84C63.79 229.93 48 239 48 256s15.79 26.08 22.56 29.17l148 67.63C229 357.6 242.49 360 256 360s26.94-2.4 37.44-7.19l147.87-67.61c6.81-3.09 22.69-12.11 22.69-29.2s-15.77-26.07-22.64-29.19z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M441.36 330.8l-15.09-6.8-38.77 17.73-94 42.95c-10.5 4.78-24 7.18-37.44 7.18s-26.93-2.39-37.42-7.18l-94.07-43L85.79 324l-15.22 6.84C63.79 333.93 48 343 48 360s15.79 26.07 22.56 29.15l148 67.59C229 461.52 242.54 464 256 464s26.88-2.48 37.38-7.27l147.92-67.57c6.82-3.08 22.7-12.1 22.7-29.16s-15.77-26.07-22.64-29.2z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4381910eceb17f2d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M321.89 171.42C233 114 141 155.22 56 65.22c-19.8-21-8.3 235.5 98.1 332.7 77.79 71 197.9 63.08 238.4-5.92s18.28-163.17-70.61-220.58zM173 253c86 81 175 129 292 147"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6e0047ea4183b0db(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M150.38 253.68l21.94-23.3 11.65 11c73.63 69.36 147.51 111.56 234.45 133.07 11.73-32 12.77-67.22 2.64-101.58-13.44-45.59-44.74-85.31-90.49-114.86-40.25-26-76.6-32.09-115.09-38.54-21.12-3.54-43-7.2-66.85-14.43-43.78-13.28-89.69-52.74-90.15-53.13L33.4 30.15 32 63.33c-.1 2.56-2.42 63.57 14.22 147.77 17.58 89 50.24 155.85 97.07 198.63 38 34.69 87.62 53.9 136.93 53.9a185.88 185.88 0 0027.78-2.07c41.72-6.32 76.43-27.27 96-57.75-89.5-23.28-165.95-67.55-242-139.16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M467.43 384.19c-16.83-2.59-33.13-5.84-49-9.77a158.49 158.49 0 01-12.13 25.68c-.74 1.25-1.51 2.49-2.29 3.71a583.43 583.43 0 0058.55 12l15.82 2.44 4.86-31.63z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$784d60b24615e36f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M161.35 242a16 16 0 0122.62-.68c73.63 69.36 147.51 111.56 234.45 133.07 11.73-32 12.77-67.22 2.64-101.58-13.44-45.59-44.74-85.31-90.49-114.86-40.84-26.38-81.66-33.25-121.15-39.89-49.82-8.38-96.88-16.3-141.79-63.85-5-5.26-11.81-7.37-18.32-5.66-7.44 2-12.43 7.88-14.82 17.6-5.6 22.75-2 86.51 13.75 153.82 25.29 108.14 65.65 162.86 95.06 189.73 38 34.69 87.62 53.9 136.93 53.9a186 186 0 0027.77-2.04c41.71-6.32 76.43-27.27 96-57.75-89.49-23.28-165.94-67.55-242-139.16a16 16 0 01-.65-22.65zm306.08 142.19c-16.83-2.59-33.13-5.84-49-9.77a157.71 157.71 0 01-12.13 25.68c-.73 1.25-1.5 2.49-2.29 3.71a584.21 584.21 0 0058.56 12 16 16 0 104.87-31.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5c789ff6852605ca(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "368",
                    "x": "32",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 224h128M112 400h128"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "128",
                    "height": "304",
                    "x": "112",
                    "y": "160",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "416",
                    "x": "256",
                    "y": "48",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M422.46 96.11l-40.4 4.25c-11.12 1.17-19.18 11.57-17.93 23.1l34.92 321.59c1.26 11.53 11.37 20 22.49 18.84l40.4-4.25c11.12-1.17 19.18-11.57 17.93-23.1L445 115c-1.31-11.58-11.42-20.06-22.54-18.89z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7290148654fd36ed(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M84 480H28a12 12 0 01-12-12V92a12 12 0 0112-12h56a12 12 0 0112 12v376a12 12 0 01-12 12zm156-272v-52a12 12 0 00-12-12H124a12 12 0 00-12 12v52zM112 416v52a12 12 0 0012 12h104a12 12 0 0012-12v-52zm0-176h128v144H112zm228 240h-72a12 12 0 01-12-12V44a12 12 0 0112-12h72a12 12 0 0112 12v424a12 12 0 01-12 12zm29-379.3l30 367.83a12 12 0 0013.45 10.92l72.16-9a12 12 0 0010.47-12.9L465 91.21a12 12 0 00-13.2-10.94l-72.13 7.51A12 12 0 00369 100.7z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b1df6d89fa716d04(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 480H48a32 32 0 01-32-32V112a32 32 0 0132-32h16a32 32 0 0132 32v336a32 32 0 01-32 32zm176-304a32 32 0 00-32-32h-64a32 32 0 00-32 32v28a4 4 0 004 4h120a4 4 0 004-4zM112 448a32 32 0 0032 32h64a32 32 0 0032-32v-30a2 2 0 00-2-2H114a2 2 0 00-2 2z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "128",
                    "height": "144",
                    "x": "112",
                    "y": "240",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 480h-32a32 32 0 01-32-32V64a32 32 0 0132-32h32a32 32 0 0132 32v384a32 32 0 01-32 32zm175.89-34.55l-32.23-340c-1.48-15.65-16.94-27-34.53-25.31l-31.85 3c-17.59 1.67-30.65 15.71-29.17 31.36l32.23 340c1.48 15.65 16.94 27 34.53 25.31l31.85-3c17.59-1.67 30.65-15.71 29.17-31.36z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9981b117db49748c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "36",
                    "d": "M208 352h-64a96 96 0 010-192h64m96 0h64a96 96 0 010 192h-64m-140.71-96h187.42"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$513578ef5cfe42fd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M200.66 352H144a96 96 0 010-192h55.41m113.18 0H368a96 96 0 010 192h-56.66m-142.27-96h175.86"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$dcc2a1eea6eef003(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M200.66 352H144a96 96 0 010-192h55.41m113.18 0H368a96 96 0 010 192h-56.66m-142.27-96h175.86"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$41abfaccefc2bdc7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M224 184h128m-128 72h128m-128 71h128"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 258c0-106-86-192-192-192S64 152 64 258s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "184",
                    "r": "8",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "257",
                    "r": "8",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "328",
                    "r": "8",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2578b549e42f241f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-64 287.5a16 16 0 01-16 16h-16a16 16 0 01-16-16v-16a16 16 0 0116-16h16a16 16 0 0116 16zm0-71a16 16 0 01-16 16h-16a16 16 0 01-16-16v-16a16 16 0 0116-16h16a16 16 0 0116 16zm0-72a16 16 0 01-16 16h-16a16 16 0 01-16-16v-16a16 16 0 0116-16h16a16 16 0 0116 16zm176 151H212.67v-32H368zm0-71H212.67v-32H368zm0-72H212.67v-32H368z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bedf9477c352caf6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-88 302a24 24 0 1124-24 24 24 0 01-24 24zm0-71a24 24 0 1124-24 24 24 0 01-24 24zm0-73a24 24 0 1124-24 24 24 0 01-24 24zm184 135H224a16 16 0 010-32h128a16 16 0 010 32zm0-71H224a16 16 0 010-32h128a16 16 0 010 32zm0-72H224a16 16 0 010-32h128a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ad8f33ef761cfc3c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 144h288M160 256h288M160 368h288"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "80",
                    "cy": "144",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "80",
                    "cy": "256",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "80",
                    "cy": "368",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e3d9c52706ab6eab(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M144 144h320M144 256h320M144 368h320"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 128h32v32H64zm0 112h32v32H64zm0 112h32v32H64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$efee65ed324ba8b6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M160 144h288M160 256h288M160 368h288"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "80",
                    "cy": "144",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "80",
                    "cy": "256",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "80",
                    "cy": "368",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6bbb38b54bd27e48(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M256 96V56m0 400v-40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 112a144 144 0 10144 144 144 144 0 00-144-144z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M416 256h40m-400 0h40"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5d9226f11e0e5f5c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M256 96V56m0 400v-40m0-304a144 144 0 10144 144 144 144 0 00-144-144zm160 144h40m-400 0h40"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cf2b04dce42e1624(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M256 96V56m0 400v-40m0-304a144 144 0 10144 144 144 144 0 00-144-144zm160 144h40m-400 0h40"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e7d88295e7a502c5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 48c-79.5 0-144 61.39-144 137 0 87 96 224.87 131.25 272.49a15.77 15.77 0 0025.5 0C304 409.89 400 272.07 400 185c0-75.61-64.5-137-144-137z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "192",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c5c1d5f9e4cfefd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C167.67 32 96 96.51 96 176c0 128 160 304 160 304s160-176 160-304c0-79.49-71.67-144-160-144zm0 224a64 64 0 1164-64 64.07 64.07 0 01-64 64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$31b34c5169424d64(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "192",
                    "r": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c-88.22 0-160 68.65-160 153 0 40.17 18.31 93.59 54.42 158.78 29 52.34 62.55 99.67 80 123.22a31.75 31.75 0 0051.22 0c17.42-23.55 51-70.88 80-123.22C397.69 278.61 416 225.19 416 185c0-84.35-71.78-153-160-153zm0 224a64 64 0 1164-64 64.07 64.07 0 01-64 64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$dfeefc906ac3d6bc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 208v-95a80 80 0 00-160 0v95"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "320",
                    "height": "272",
                    "x": "96",
                    "y": "208",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e68dff62c36f10fe(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420 192h-68v-80a96 96 0 10-192 0v80H92a12 12 0 00-12 12v280a12 12 0 0012 12h328a12 12 0 0012-12V204a12 12 0 00-12-12zm-106 0H198v-80.75a58 58 0 11116 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f67d1a5b580fa1f0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 192h-16v-80a96 96 0 10-192 0v80h-16a64.07 64.07 0 00-64 64v176a64.07 64.07 0 0064 64h224a64.07 64.07 0 0064-64V256a64.07 64.07 0 00-64-64zm-48 0H192v-80a64 64 0 11128 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d2a0e8e04ea31c29(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 112a80 80 0 00-160 0v96"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "320",
                    "height": "272",
                    "x": "96",
                    "y": "208",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$103eeafdc21ce5fc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420 192H198v-80.75a58.08 58.08 0 0199.07-41.07A59.4 59.4 0 01314 112h38a96 96 0 10-192 0v80H92a12 12 0 00-12 12v280a12 12 0 0012 12h328a12 12 0 0012-12V204a12 12 0 00-12-12z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a17b217473253ea5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 192H192v-80a64 64 0 11128 0 16 16 0 0032 0 96 96 0 10-192 0v80h-16a64.07 64.07 0 00-64 64v176a64.07 64.07 0 0064 64h224a64.07 64.07 0 0064-64V256a64.07 64.07 0 00-64-64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5fa3eeae294c58c8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M192 176v-40a40 40 0 0140-40h160a40 40 0 0140 40v240a40 40 0 01-40 40H240c-22.09 0-48-17.91-48-40v-40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M288 336l80-80-80-80M80 256h272"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b707c68646c6fd43(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 80H192a16 16 0 00-16 16v144h153.37l-64-64L288 153.37l91.31 91.32a16 16 0 010 22.62L288 358.63 265.37 336l64-64H176v144a16 16 0 0016 16h240a16 16 0 0016-16V96a16 16 0 00-16-16zM64 240h112v32H64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a8e074a904086b9b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 80H232a56.06 56.06 0 00-56 56v104h153.37l-52.68-52.69a16 16 0 0122.62-22.62l80 80a16 16 0 010 22.62l-80 80a16 16 0 01-22.62-22.62L329.37 272H176v104c0 32.05 33.79 56 64 56h152a56.06 56.06 0 0056-56V136a56.06 56.06 0 00-56-56zM80 240a16 16 0 000 32h96v-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b10d8ca2fc7ffeb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 336v40a40 40 0 01-40 40H104a40 40 0 01-40-40V136a40 40 0 0140-40h152c22.09 0 48 17.91 48 40v40m64 160l80-80-80-80m-192 80h256"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$218b6639d83b90e5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 240h160V96a16 16 0 00-16-16H64a16 16 0 00-16 16v320a16 16 0 0016 16h240a16 16 0 0016-16V272H160zm299.31 4.69L368 153.37 345.37 176l64 64H320v32h89.37l-64 64L368 358.63l91.31-91.32a16 16 0 000-22.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8df37bc297a8ddd0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 256a16 16 0 0116-16h144V136c0-32-33.79-56-64-56H104a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h160a56.06 56.06 0 0056-56V272H176a16 16 0 01-16-16zm299.31-11.31l-80-80a16 16 0 00-22.62 22.62L409.37 240H320v32h89.37l-52.68 52.69a16 16 0 1022.62 22.62l80-80a16 16 0 000-22.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7e745e03dddda8f6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M102.41 32C62.38 32 32 64.12 32 103.78v304.45C32 447.86 64.38 480 104.41 480h303.2c40 0 72.39-32.14 72.39-71.77v-3.11c-1.35-.56-115.47-48.57-174.5-76.7-39.82 48.57-91.18 78-144.5 78-90.18 0-120.8-78.22-78.1-129.72 9.31-11.22 25.15-21.94 49.73-28 38.45-9.36 99.64 5.85 157 24.61a309.41 309.41 0 0025.46-61.67H138.34V194h91.13v-31.83H119.09v-17.75h110.38V99s0-7.65 7.82-7.65h44.55v53H391v17.75H281.84V194h89.08a359.41 359.41 0 01-37.72 94.43c27 9.69 49.31 18.88 67.39 24.89 60.32 20 77.23 22.45 79.41 22.7V103.78C480 64.12 447.6 32 407.61 32h-305.2zM152 274.73q-5.81.06-11.67.63c-11.3 1.13-32.5 6.07-44.09 16.23-34.74 30-13.94 84.93 56.37 84.93 40.87 0 81.71-25.9 113.79-67.37-41.36-20-77-34.85-114.4-34.42z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$948c437846b7b5d4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48.48 378.73a300.52 300.52 0 00152.89 95.92 262.57 262.57 0 00159.3-17.25 225.52 225.52 0 0066.79-47 6.36 6.36 0 00-2-8.53 11.76 11.76 0 00-8-.05 401.92 401.92 0 01-116.55 39.34 358.13 358.13 0 01-127.29-8.83 446.73 446.73 0 01-119.1-60.49 5 5 0 00-6.06 6.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M387.15 388.44a168.11 168.11 0 0148.94-2.23l.67.13a10 10 0 017.37 12.05A204.71 204.71 0 01429 444.47a2.55 2.55 0 001.66 3.18 2.51 2.51 0 002.23-.37A83.31 83.31 0 00464 382.86a12.44 12.44 0 00-10.22-13.22A95.75 95.75 0 00384.91 384a2.55 2.55 0 00-.57 3.55 2.52 2.52 0 002.81.89zm-82.91-63.52a164 164 0 01-28.92 25.3A135.16 135.16 0 01208.63 369a99.49 99.49 0 01-57.49-19.85 97.25 97.25 0 01-27.36-100.28 112.35 112.35 0 0165.3-69.06 367.67 367.67 0 01104.7-15.55V127A37.82 37.82 0 00261 94.72a59.9 59.9 0 00-31.17 4.08 48.89 48.89 0 00-27.13 34.67 12 12 0 01-12.58 6.72l-50.9-4.5a11.38 11.38 0 01-8.38-10.16 103.66 103.66 0 0136.61-63.45A143.86 143.86 0 01257.85 32a146.24 146.24 0 0184.27 27.67 86.82 86.82 0 0130.7 70.22V258.8a84.46 84.46 0 008 31.28l15.87 23.23a13 13 0 010 11.23l-46.99 39.71a12.5 12.5 0 01-12.68-.44 244.84 244.84 0 01-32.78-38.89zm-10.6-116.83a257.68 257.68 0 00-44 2.89A63 63 0 00208 242.54a63 63 0 003.07 54 40.6 40.6 0 0047.11 12.19 78.61 78.61 0 0035.46-55.58v-45.06"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1af3b1035ab8e184(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M112.31 268l40.36-68.69 34.65 59-67.54 115h135L289.31 432H16zm58.57-99.76l33.27-56.67L392.44 432h-66.68zM222.67 80h66.59L496 432h-66.68z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a071223315af2f68(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.91 199l42.47-73.57a8.63 8.63 0 00-3.12-11.76 8.52 8.52 0 00-11.71 3.12l-43 74.52c-32.83-15-69.78-23.35-109.52-23.35s-76.69 8.36-109.52 23.35l-43-74.52a8.6 8.6 0 10-14.88 8.64L131 199C57.8 238.64 8.19 312.77 0 399.55h512c-8.19-86.78-57.8-160.91-131.09-200.55zM138.45 327.65a21.46 21.46 0 1121.46-21.46 21.47 21.47 0 01-21.46 21.46zm235 0A21.46 21.46 0 11395 306.19a21.47 21.47 0 01-21.51 21.46z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3cbb1af520981800(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.57 256h84.85l-42.43-89.36L213.57 256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32L32 112l46.12 272L256 480l177.75-96L480 112zm88 320l-26.59-56H194.58L168 352h-40L256 72l128 280z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9ab56b406fd3b453(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.26 32 32 132.26 32 256s100.26 224 224 224 224-100.26 224-224S379.74 32 256 32zm-85 321.89a15.48 15.48 0 01-13.46 7.65 14.91 14.91 0 01-7.86-2.16 15.48 15.48 0 01-5.6-21.21l15.29-25.42a8.73 8.73 0 017.54-4.3h2.26c11.09 0 18.85 6.67 21.11 13.13zm129.45-50l-100.13.11h-66.55a15.46 15.46 0 01-15.51-16.15c.32-8.4 7.65-14.76 16-14.76h48.24l57.19-97.35-18.52-31.55C217 137 218.85 127.52 226 123a15.57 15.57 0 0121.87 5.17l9.9 16.91h.11l9.91-16.91A15.58 15.58 0 01289.6 123c7.11 4.52 8.94 14 4.74 21.22l-18.52 31.55-18 30.69-39.09 66.66v.11h57.61c7.22 0 16.27 3.88 19.93 10.12l.32.65c3.23 5.49 5.06 9.26 5.06 14.75a13.82 13.82 0 01-1.17 5.17zm77.75.11h-27.11v.11l19.82 33.71a15.8 15.8 0 01-5.17 21.53 15.53 15.53 0 01-8.08 2.27A15.71 15.71 0 01344.2 354l-29.29-49.86-18.2-31L273.23 233a38.35 38.35 0 01-.65-38c4.64-8.19 8.19-10.34 8.19-10.34L333 273h44.91c8.4 0 15.61 6.46 16 14.75A15.65 15.65 0 01378.23 304z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9bcce772a2459c6b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M201.14 64L256 32l54.86 32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 32v80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M310.86 448L256 480l-54.86-32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 480v-80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 207.51V144l53.15-31.51"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 144l67.29 40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 304.49V368l-53.15 31.51"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 368l-67.29-40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M117.15 400L64 368v-63.51"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 368l66.64-40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M394.85 112.49L448 144v63.51"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 144l-67.29 40M256 320v-64l54.86-32M256 256l-54.86-32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ebf3617b82f1577d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.13 136.86c-40.32 0-57.36 19.24-85.44 19.24-28.79 0-50.75-19.1-85.69-19.1-34.2 0-70.67 20.88-93.83 56.45-32.52 50.16-27 144.63 25.67 225.11 18.84 28.81 44 61.12 77 61.47h.6c28.68 0 37.2-18.78 76.67-19h.6c38.88 0 46.68 18.89 75.24 18.89h.6c33-.35 59.51-36.15 78.35-64.85 13.56-20.64 18.6-31 29-54.35-76.19-28.92-88.43-136.93-13.08-178.34-23-28.8-55.32-45.48-85.79-45.48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M340.25 32c-24 1.63-52 16.91-68.4 36.86-14.88 18.08-27.12 44.9-22.32 70.91h1.92c25.56 0 51.72-15.39 67-35.11 14.72-18.77 25.88-45.37 21.8-72.66z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e7a6a07204858b6f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344.1 233.6c-28.9 0-32.9 28.8-32.9 28.8h61.4s.4-28.8-28.5-28.8zm-139.3 28.8h-54.4v50h51.7c7.8-.2 22.4-2.4 22.4-24.3 0-26-19.7-25.7-19.7-25.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224 224-100.3 224-224S379.7 32 256 32zm47.2 137.6h77.1v23h-77.1v-23zm-39 120.8c0 57-59.4 55.2-59.4 55.2h-97.2v-187h97.2c29.6 0 52.9 16.3 52.9 49.8S229.2 244 229.2 244c37.6 0 35 46.4 35 46.4zm144.2-3.1h-96.9c0 34.7 32.9 32.5 32.9 32.5 31.1 0 30-20.1 30-20.1h32.9c0 53.4-64 49.7-64 49.7-76.7 0-71.8-71.5-71.8-71.5s-.1-71.8 71.8-71.8c75.7.1 65.1 81.2 65.1 81.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M218 211.3c0-19.4-13.2-19.4-13.2-19.4h-54.4v41.7h51c8.8 0 16.6-2.9 16.6-22.3z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$806a895974c00352(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.13 32.23a19.65 19.65 0 00-2.54-.23h-449C23 31.88 16.12 38.88 16 47.75a11.44 11.44 0 00.23 2.8l65.3 411.25a22.52 22.52 0 007 12.95A20 20 0 00102 480h313.18a15.45 15.45 0 0015.34-13.42l38.88-247.91H325.19l-18.46 112H205.21l-25.73-148h295.58l20.76-132c1.27-8.75-4.38-17.04-12.69-18.44z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fc51244e2a90ae5c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M410.47 279.2c-5-11.5-12.7-21.6-28.1-30.1a98.15 98.15 0 00-25.4-10 62.22 62.22 0 0016.3-11 56.37 56.37 0 0015.6-23.3 77.11 77.11 0 003.5-28.2c-1.1-16.8-4.4-33.1-13.2-44.8s-21.2-20.7-37.6-27c-12.6-4.8-25.5-7.8-45.5-8.9V32h-40v64h-32V32h-41v64H96v48h27.87c8.7 0 14.6.8 17.6 2.3a13.22 13.22 0 016.5 6c1.3 2.5 1.9 8.4 1.9 17.5V343c0 9-.6 14.8-1.9 17.4s-2 4.9-5.1 6.3-3.2 1.3-11.8 1.3h-26.4L96 416h87v64h41v-64h32v64h40v-64.4c26-1.3 44.5-4.7 59.4-10.3 19.3-7.2 34.1-17.7 44.7-31.5s14-34.9 14.93-51.2c.67-14.5-.03-33.2-4.56-43.4zM224 150h32v74h-32zm0 212v-90h32v90zm72-208.1c6 2.5 9.9 7.5 13.8 12.7 4.3 5.7 6.5 13.3 6.5 21.4 0 7.8-2.9 14.5-7.5 20.5-3.8 4.9-6.8 8.3-12.8 11.1zm28.8 186.7c-7.8 6.9-12.3 10.1-22.1 13.8a56.06 56.06 0 01-6.7 1.9v-82.8a40.74 40.74 0 0111.3 3.4c7.8 3.3 15.2 6.9 19.8 13.2a43.82 43.82 0 018 24.7c-.03 10.9-2.83 19.2-10.33 25.8z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2e2f4b5c0c4556bf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M39.93 149.25l197.4 95.32c5.14 2.45 12 3.73 18.79 3.73s13.65-1.28 18.78-3.73l197.4-95.32c10.38-5 10.38-13.18 0-18.2L274.9 35.73c-5.13-2.45-12-3.73-18.78-3.73s-13.65 1.28-18.79 3.73l-197.4 95.32c-10.38 5.02-10.38 13.18 0 18.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M472.3 246.9s-36.05-17.38-40.83-19.72-6.07-2.21-11.09.12-145.6 70.23-145.6 70.23a45.71 45.71 0 01-18.78 3.74c-6.77 0-13.65-1.29-18.78-3.74 0 0-136.85-66-143.27-69.18C87 225 85 225 78.67 228l-39 18.78c-10.38 5-10.38 13.19 0 18.2L237.1 360.3c5.13 2.45 12 3.73 18.78 3.73s13.65-1.28 18.79-3.73l197.4-95.3c10.61-4.92 10.61-13.08.23-18.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M472.3 362.75s-36.05-17.38-40.83-19.75-6.07-2.21-11.09.12S274.9 413.5 274.9 413.5a45.74 45.74 0 01-18.78 3.73c-6.77 0-13.65-1.28-18.79-3.73 0 0-136.85-66-143.26-69.18-7-3.39-9-3.39-15.29-.35l-39 18.78c-10.39 5-10.39 13.18 0 18.2l197.4 95.32c5.13 2.56 12 3.73 18.78 3.73s13.65-1.28 18.78-3.73L472.18 381c10.5-5.07 10.5-13.23.12-18.25z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bd6d27c3cf0d564f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 101.09L372.37 208.72l106.86 107.06-69.3 69.3-283.22-283.23L196 32.54l107.07 106.88L410.67 32zM32.55 196l69.3-69.31 283.22 283.24-69.3 69.3-107-106.87L101.08 480 32 410.67l107.42-107.61z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$328a7a4fc7ae0d56(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M188.8 255.93a67.2 67.2 0 1067.2-67.18 67.38 67.38 0 00-67.2 67.18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M476.75 217.79v.05a206.63 206.63 0 00-7-28.84h-.11a202.16 202.16 0 017.07 29 203.5 203.5 0 00-7.07-29h-155.4c19.05 17 31.36 40.17 31.36 67.05a86.55 86.55 0 01-12.31 44.73L231 478.45a2.44 2.44 0 010 .27v.28-.26a224 224 0 0025 1.26c6.84 0 13.61-.39 20.3-1a222.91 222.91 0 0029.78-4.74C405.68 451.52 480 362.4 480 255.94a225.25 225.25 0 00-3.25-38.15z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 345.5c-33.6 0-61.6-17.91-77.29-44.79L76 123.05l-.14-.24A224 224 0 00207.4 474.55v-.05l77.69-134.6a84.13 84.13 0 01-29.09 5.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M91.29 104.57l77.35 133.25A89.19 89.19 0 01256 166h205.17a246.51 246.51 0 00-25.78-43.94l.12.08A245.26 245.26 0 01461.17 166h.17a245.91 245.91 0 00-25.66-44 2.63 2.63 0 01-.35-.26 223.93 223.93 0 00-344.19-17.4l.14.24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$65d578dd4ca8f23f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80v352h512V80zm464 175.78c0 25.74-1.6 45.32-3.77 77.22s-19.2 54.34-59.09 57.86-95.77 3.85-145.14 3.74c-49 .11-105.14-.11-145.14-3.74s-56.8-26-59.09-57.86S48 281.52 48 255.78s.11-42.46 3.77-77.22 23-54.12 59.09-57.64 98.28-3.52 145.14-3.52 109 0 145.14 3.52 55.43 23 59.09 57.64 3.77 51.59 3.77 77.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M367.57 282.84v.77c0 17.93-11.11 28.49-25.95 28.49s-24.84-11.88-26.27-28.49c0 0-1.31-8.69-1.31-26.29a229.5 229.5 0 011.53-28.6c2.64-18.7 11.77-28.49 26.6-28.49s26.49 12.76 26.49 32.12v.55h49.58c0-24.09-6.05-45.76-18.25-59.4S369.76 153 345.8 153a108.06 108.06 0 00-33 4.73 58.82 58.82 0 00-25.94 16.61c-7.23 7.96-12.86 18.52-16.86 31.83s-6 30-6 50.27c0 19.8 1.65 36.3 4.84 49.61s8 23.87 14.4 31.79a49.76 49.76 0 0024 16.5q14.5 4.62 34 4.62c27.47 0 47.26-7 59.13-20.57S418 305.06 418 279.1h-50.65c.22 0 .22 2.75.22 3.74zm-170.27 0v.77c0 17.93-11.1 28.49-25.94 28.49s-24.84-11.88-26.27-28.49c0 0-1.31-8.69-1.31-26.29a229.5 229.5 0 011.53-28.6c2.64-18.7 11.77-28.49 26.6-28.49S198.4 213 198.4 232.35v.55H248c0-24.09-6-45.76-18.25-59.4S199.5 153 175.54 153a108.06 108.06 0 00-33 4.73 58.82 58.82 0 00-25.94 16.61c-7.26 7.92-12.86 18.48-16.93 31.79s-6 30-6 50.27c0 19.8 1.65 36.3 4.84 49.61s8 23.87 14.4 31.79a49.76 49.76 0 0024 16.5q14.51 4.62 34 4.62c27.48 0 47.27-7 59.14-20.57s17.81-33.33 17.81-59.29h-50.78c.22.04.22 2.79.22 3.78z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$af96382f133cebdb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M241.24 303.94c-15.32-10.36-30.74-20.57-46.06-30.93-2-1.38-3.43-1.48-5.5 0l-38.88 26.12C182 319.9 244 361.32 244 361.32v-53.79c0-1.22-1.55-2.78-2.76-3.59zm-46.15-63.27q23.19-15.24 46.11-30.86a7.54 7.54 0 002.8-5.34v-51.7s-62 41.12-93.26 61.94c13.7 9.16 26.67 17.91 39.78 26.44 1.02.66 3.4.28 4.57-.48zm74.75-31.32q23.71 16.07 47.63 31.82a4.3 4.3 0 003.83 0l39.76-26.47L268 152.48v53.35a4.79 4.79 0 001.84 3.52zm-11.73 21.02a5.27 5.27 0 00-4.74.17c-4.82 3-9.47 6.2-14.17 9.35-8.25 5.53-25.35 17-25.35 17l38.84 25.86a6.18 6.18 0 006.26.11l39-26s-34.07-22.66-39.84-26.49zM141 237.12v39.61l29.62-19.84L141 237.12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.29 32 32 132.29 32 256s100.29 224 224 224 224-100.29 224-224S379.71 32 256 32zm139 265c0 5.78-2.65 9.86-7.51 13.09q-61.71 41-123.29 82.19c-5.85 3.92-11.17 3.75-17-.14q-61.17-41-122.63-81.67c-5.11-3.39-7.59-7.56-7.59-13.73V217c0-6.14 2.52-10.34 7.62-13.72 40.91-27.13 81.94-54.36 122.73-81.68 5.82-3.89 11.09-4 16.94-.09q61.54 41.21 123.26 82.19c4.68 3.11 7.45 6.95 7.45 12.66z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M316.25 273.23q-22.59 15.34-45.39 30.34c-2.41 1.58-2.89 3.31-2.86 6.19v51.34l93-62-38.53-25.88c-2.3-1.61-3.89-1.57-6.22.01zm53.75 3.45v-39.62l-29.59 19.87L370 276.68z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d7077f9410e0c216(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32l35 403.22L255.77 480 413 435.15 448 32zm290.68 334.9L256.07 395l-98.46-28.24-6.75-77.76h48.26l3.43 39.56 53.59 15.16.13.28 53.47-14.85 5.64-64.15H203l-4-50h120.65l4.35-51H140l-4-49h240.58z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3df4d7e27e00096e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M295.31 122.8L222.86 64l72.68 122.64-.23-63.84z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M339.43 64v195.6h-41.6L225.6 141.28l1.94 118.32h-45.83V131.2L139.09 96c1.14 1.44 2.28 2.88 3.31 4.44 11.43 16.68 17.14 36.6 17.14 60.6 0 59-35 98.52-87.88 98.52H0v.48L228.11 448H512V205.72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M111.89 162.52c0-34.8-16.23-54.12-45.38-54.12H44.57v106.8h21.72c29.71 0 45.6-18.48 45.6-52.68z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fbec2a24c9fa2a19(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 103.28V16h-89.31l-8.9 8.78-42.15 78.48-13.25 8.74H104v119.85h82.68l7.36 8.71L104 408.72V496h89.3l8.91-8.79 42.14-78.48 13.26-8.73H408V280.13h-82.68l-7.36-8.75L408 103.28z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7f87afb60b9422f9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 66.52A50 50 0 00414.12 17L97.64 16A49.65 49.65 0 0048 65.52V392c0 27.3 22.28 48 49.64 48H368l-13-44 109 100zM324.65 329.81s-8.72-10.39-16-19.32C340.39 301.55 352.5 282 352.5 282a139 139 0 01-27.85 14.25 173.31 173.31 0 01-35.11 10.39 170.05 170.05 0 01-62.72-.24 184.45 184.45 0 01-35.59-10.4 141.46 141.46 0 01-17.68-8.21c-.73-.48-1.45-.72-2.18-1.21-.49-.24-.73-.48-1-.48-4.36-2.42-6.78-4.11-6.78-4.11s11.62 19.09 42.38 28.26c-7.27 9.18-16.23 19.81-16.23 19.81-53.51-1.69-73.85-36.47-73.85-36.47 0-77.06 34.87-139.62 34.87-139.62 34.87-25.85 67.8-25.12 67.8-25.12l2.42 2.9c-43.59 12.32-63.44 31.4-63.44 31.4s5.32-2.9 14.28-6.77c25.91-11.35 46.5-14.25 55-15.21a24 24 0 014.12-.49 205.62 205.62 0 0148.91-.48 201.62 201.62 0 0172.89 22.95s-19.13-18.15-60.3-30.45l3.39-3.86s33.17-.73 67.81 25.16c0 0 34.87 62.56 34.87 139.62 0-.28-20.35 34.5-73.86 36.19z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M212.05 218c-13.8 0-24.7 11.84-24.7 26.57s11.14 26.57 24.7 26.57c13.8 0 24.7-11.83 24.7-26.57.25-14.76-10.9-26.57-24.7-26.57zm88.38 0c-13.8 0-24.7 11.84-24.7 26.57s11.14 26.57 24.7 26.57c13.81 0 24.7-11.83 24.7-26.57S314 218 300.43 218z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$315503a613866840(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507 211.16c-1.42-1.19-14.25-10.94-41.79-10.94a132.55 132.55 0 00-21.61 1.9c-5.22-36.4-35.38-54-36.57-55l-7.36-4.28-4.75 6.9a101.65 101.65 0 00-13.06 30.45c-5 20.7-1.9 40.2 8.55 56.85-12.59 7.14-33 8.8-37.28 9H15.94A15.93 15.93 0 000 262.07a241.25 241.25 0 0014.75 86.83C26.39 379.35 43.72 402 66 415.74 91.22 431.2 132.3 440 178.6 440a344.23 344.23 0 0062.45-5.71 257.44 257.44 0 0081.69-29.73 223.55 223.55 0 0055.57-45.67c26.83-30.21 42.74-64 54.38-94h4.75c29.21 0 47.26-11.66 57.23-21.65a63.31 63.31 0 0015.2-22.36l2.14-6.18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M47.29 236.37H92.4a4 4 0 004-4v-40.48a4 4 0 00-4-4H47.29a4 4 0 00-4 4v40.44a4.16 4.16 0 004 4m62.21.04h45.12a4 4 0 004-4v-40.48a4 4 0 00-4-4H109.5a4 4 0 00-4 4v40.44a4.16 4.16 0 004 4m63.4.04H218a4 4 0 004-4v-40.48a4 4 0 00-4-4h-45.1a4 4 0 00-4 4v40.44a3.87 3.87 0 004 4m62.46.04h45.12a4 4 0 004-4v-40.48a4 4 0 00-4-4h-45.12a4 4 0 00-4 4v40.44a4 4 0 004 4M109.5 178.57h45.12a4.16 4.16 0 004-4v-40.48a4 4 0 00-4-4H109.5a4 4 0 00-4 4v40.44a4.34 4.34 0 004 4m63.4.04H218a4.16 4.16 0 004-4v-40.48a4 4 0 00-4-4h-45.1a4 4 0 00-4 4v40.44a4 4 0 004 4m62.46.04h45.12a4.16 4.16 0 004-4v-40.48a4.16 4.16 0 00-4-4h-45.12a4 4 0 00-4 4v40.44a4.16 4.16 0 004 4m0-58h45.12a4 4 0 004-4V76a4.16 4.16 0 00-4-4h-45.12a4 4 0 00-4 4v40.44a4.17 4.17 0 004 4m62.92 115.93h45.12a4 4 0 004-4v-40.48a4 4 0 00-4-4h-45.12a4 4 0 00-4 4v40.44a4.16 4.16 0 004 4"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a154f971f7881f8c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.33 32 32 132.33 32 256s100.33 224 224 224 224-100.22 224-224S379.67 32 256 32zm142.22 103.25a186.36 186.36 0 0144 108.38c-40.37-2.1-88.67-2.1-127.4 1.52-4.9-12.37-9.92-24.5-15.4-36.17 44.66-19.36 79.08-44.8 98.8-73.73zM256 69.33a185.81 185.81 0 01119.12 42.94c-20.3 25.66-52.15 48-91.82 64.86C261.6 137 236.63 102.47 210 75.28a187.51 187.51 0 0146-5.95zm-84.47 20.42c26.95 26.83 52.27 61 74.44 101C203.85 203.62 155.55 211 104 211c-9.8 0-19.36-.35-28.81-.94a186.78 186.78 0 0196.34-120.31zM69.68 247.13c10.62.47 21.35.7 32.2.59 58.8-.7 113.52-9.92 160.54-25q6.65 13.83 12.6 28.35a115.43 115.43 0 00-16.69 5c-64.28 27-114.91 70.51-142.33 123.13A186 186 0 0169.33 256c0-3 .12-5.95.35-8.87zM256 442.67a185.57 185.57 0 01-114.45-39.32c24.85-49.23 69.18-90 125.07-115.27 5.25-2.45 12.25-4.43 20.3-6.18q10 27.64 17.85 57.4A678 678 0 01322 430.42a185.06 185.06 0 01-66 12.25zm100.92-29.75a672.61 672.61 0 00-17.39-92.05c-4-15.17-8.51-29.87-13.41-44.22 36.63-3 80.5-2.57 115.38 0a186.5 186.5 0 01-84.58 136.27z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c650cb34520d62d6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.32 126.24l-120.16 78.25 120.16 78.24L136.16 361 16 282.08l120.16-78.24L16 126.24 136.16 48zm-120.8 259.52l120.16-78.25 120.16 78.25L255.68 464zm120.8-103.68l120.16-78.24-120.16-77.6L375.84 48 496 126.24l-120.16 78.25L496 282.73 375.84 361z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$646fd5b9e6b5637e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.5 15c-132 0-240 108-240 240s108 240 240 240c85.4 0 160.8-45.2 203.3-112.9a6.87 6.87 0 00-9.1-9.7 108.64 108.64 0 01-18.4 8.6c-36.8 12.6-57.1 13.1-82.1 12-27.9-1.2-61.9-10.8-85.8-25s-43.5-34.6-54.1-52.3-17-39.9-14.1-68.3c2.9-29 29.4-52.6 60.4-52.6 33.5 0 60.8 26.6 60.8 60.1 0 17-8.1 31.7-18.5 43.5-2.3 2.1-7.6 9.7 5.8 20 15.9 12.2 51.6 18 79.9 16.6s59.1-12.6 80.2-34.8c16.8-17.7 31.8-46.1 31.8-77.4C495.5 97.7 379.5 15 255.5 15z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$321c8a0b34b299c5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M86.76 255a9.89 9.89 0 004.87-1.29 9.82 9.82 0 003.65-13.43c-16.46-28.56-17.81-52.12-7.45-70 14.26-24.57 53.61-33.65 105.27-24.29a9.86 9.86 0 0011.45-7.9 9.84 9.84 0 00-7.93-11.44c-29.19-5.28-56-5.18-77.39.3-22.3 5.71-39 17.28-48.45 33.48-14 24.19-12.7 54.73 7.42 89.62a9.85 9.85 0 008.56 4.95zm274.85-111.27c32.24.42 52.61 9.31 62.79 26.86 14.21 24.48 2.52 62.81-31.27 102.52a9.82 9.82 0 007.51 16.18 9.88 9.88 0 007.52-3.46c19.12-22.47 32.35-45.54 38.25-66.71 6.14-22 4.43-42.21-5-58.38-13.8-23.78-40.13-36.15-79.59-36.67h-.14a9.83 9.83 0 00-.12 19.66zm-35.14 271.16a9.88 9.88 0 00-13.5 3.35c-16.41 27.15-36.57 42.1-56.77 42.1-28.49 0-56-29.31-73.73-78.42a9.87 9.87 0 00-12.59-5.92 9.83 9.83 0 00-6 12.58c10 27.77 23.47 50.75 39 66.46 16.11 16.34 34.55 25 53.32 25 27.38 0 53.54-18.33 73.65-51.61a9.81 9.81 0 00-3.38-13.5zm105.23-76.35a32.14 32.14 0 00-29.9 44.33c-41.8 19.5-119.8 4.79-191.87-36.62-32.91-18.9-62.16-41.86-84.6-66.39a9.9 9.9 0 00-13.91-.65 9.8 9.8 0 00-.65 13.9c23.79 26 54.68 50.28 89.33 70.18 40.28 23.13 82.27 38.63 121.43 44.81a225.54 225.54 0 0035 2.91c23.12 0 43-4.3 58.51-12.79a32.2 32.2 0 1016.7-59.68zm0 44.66a12.6 12.6 0 01-7.82-2.72 10 10 0 00-2.2-2.21 12.61 12.61 0 1110 4.93z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M82.09 338.59c.57-21.26 12.41-47 33.68-73.16 23.19-28.45 56.69-56 94.34-77.65 33.25-19.1 65.2-31.9 98.07-38.91a9.83 9.83 0 10-4.12-19.22c-34.85 7.43-68.78 21-103.79 41.09C116.09 219.09 59.9 289.88 62.46 343.9a32.32 32.32 0 1019.63-5.31zM80.3 383.2a12.5 12.5 0 1112.59-12.5 12.56 12.56 0 01-12.59 12.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256.2 96.32a32.23 32.23 0 0026.53-13.81c17.89 11.69 34 35 45.81 66.12 13 34.39 19.84 75.38 19.84 118.54 0 37.18-5.19 72.35-15 103.6a9.72 9.72 0 00.66 7.49 9.82 9.82 0 005.8 4.84 9.89 9.89 0 0012.34-6.44c10.42-33.14 15.93-70.34 15.93-109.49 0-47.17-7.77-91.77-22.47-129-14.41-36.48-34.13-62.4-57.14-75.16a32.3 32.3 0 10-32.3 33.31zm0-44.66a12.5 12.5 0 11-12.59 12.5 12.56 12.56 0 0112.59-12.5zm-5.2 191.7a24.35 24.35 0 005.16 48.16 24.68 24.68 0 005.16-.55A24.36 24.36 0 10251 243.36z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a59657658894f221(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M231.8 272v-48H376l8-48H231.8v-8.12c0-38.69 16.47-62.56 87.18-62.56 28.89 0 61.45 2.69 102.5 9.42l10.52-70A508.54 508.54 0 00315.46 32C189.26 32 135 76.4 135 158.46V176H80v48h55v48H80v48h55v33.54C135 435.6 189.23 480 315.43 480a507.76 507.76 0 00116.44-12.78l-10.58-70c-41.05 6.73-73.46 9.42-102.35 9.42-70.7 0-87.14-20.18-87.14-67.94V320h128.47l7.87-48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1137790629b5693a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M480 257.35c0-123.7-100.3-224-224-224s-224 100.3-224 224c0 111.8 81.9 204.47 189 221.29V322.12h-56.89v-64.77H221V208c0-56.13 33.45-87.16 84.61-87.16 24.51 0 50.15 4.38 50.15 4.38v55.13H327.5c-27.81 0-36.51 17.26-36.51 35v42h62.12l-9.92 64.77H291v156.54c107.1-16.81 189-109.48 189-221.31z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$66cf2f12dd84cebe(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 176a80 80 0 000-160H176a80 80 0 000 160 80 80 0 000 160 80 80 0 1080 80V176z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "336",
                    "cy": "256",
                    "r": "80"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a744208fe3b0262a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M93.19 329.38l47.45-304.07c1.64-10.37 15.55-12.82 20.46-3.55l51 95.45zM432 400l-46.74-276.79a11 11 0 00-18.54-6L80 400l159.36 91.91a33.18 33.18 0 0031.91 0zM302.36 158.93l-36.54-69.54a10.86 10.86 0 00-19.36 0L85.83 375.74z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d35af827d11743c5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.46 194.62v-.07c-.22-.76-.45-1.52-.68-2.28-.05-.19-.11-.38-.17-.56-.43-1.44-.87-2.88-1.33-4.31l-.06-.2a223.24 223.24 0 00-10-25.56 191.77 191.77 0 00-12.9-23.8 225.15 225.15 0 00-74.74-73.74A222.9 222.9 0 00256 32c-7 0-14 .34-20.82 1-24.12 2.54-64.78 11.21-97.77 40.18C257.5 11.86 417.94 85.7 404.29 223c-4.86 49-46.46 82.67-85.19 88.35a73.73 73.73 0 01-20.8.21c-94.59-13.15-88.8-90.68-60.06-123.83-38-.24-67.47 46.79-53.15 93-32.95-61.18.35-157 70.93-186-82.95-12-160.71 28.2-185.7 98.07A330.23 330.23 0 0188.07 118s-45.22 35.74-54.44 110.9c-.14 1.16-.27 2.32-.39 3.49-.05.4-.09.8-.13 1.21q-.53 5.25-.8 10.57v.81c-.07 1.48-.13 3-.17 4.46v1.25c0 1.76-.07 3.52-.07 5.29 0 123.71 100.29 224 224 224S480 379.71 480 256a224 224 0 00-8.54-61.38z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c14f16da72ad5323(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.8 32 32 132.8 32 256s100.8 224 224 224 224-100.8 224-224S379.2 32 256 32zm-82.16 280A56 56 0 11228 257.84 56 56 0 01173.84 312zm168 0A56 56 0 11396 257.84 56 56 0 01341.84 312z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$202f433b33a51104(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376.76 32H138.54C105.67 32 96 56.8 96 72.41v379.64c0 17.59 9.42 24.12 14.72 26.27s19.91 4 28.67-6.17c0 0 112.47-130.89 114.4-132.83 2.92-2.93 2.92-2.93 5.84-2.93h72.77c30.58 0 35.49-21.87 38.69-34.75 2.65-10.79 32.48-164 42.45-212.56C421.14 52 411.74 32 376.76 32zm-5.67 269.64c2.65-10.79 32.48-164 42.45-212.56m-50.85 7.59l-10 51.73c-1.19 5.65-8.28 11.6-14.86 11.6h-95.92c-10.44 0-17.91 6.14-17.91 16.6v13.45c0 10.47 7.52 17.89 18 17.89h81.85c7.38 0 14.61 8.11 13 16s-9.09 46.57-10 50.89-5.84 11.72-14.61 11.72H248c-11.7 0-15.24 1.54-23.07 11.3s-78.26 94.59-78.26 94.59c-.71.82-1.41.58-1.41-.31V95.9c0-6.69 5.8-14.53 14.48-14.53h191.14a12.42 12.42 0 0111.81 15.3z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bedbc49b5ee504ed(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.3 32 32 134.9 32 261.7c0 101.5 64.2 187.5 153.2 217.9a17.56 17.56 0 003.8.4c8.3 0 11.5-6.1 11.5-11.4 0-5.5-.2-19.9-.3-39.1a102.4 102.4 0 01-22.6 2.7c-43.1 0-52.9-33.5-52.9-33.5-10.2-26.5-24.9-33.6-24.9-33.6-19.5-13.7-.1-14.1 1.4-14.1h.1c22.5 2 34.3 23.8 34.3 23.8 11.2 19.6 26.2 25.1 39.6 25.1a63 63 0 0025.6-6c2-14.8 7.8-24.9 14.2-30.7-49.7-5.8-102-25.5-102-113.5 0-25.1 8.7-45.6 23-61.6-2.3-5.8-10-29.2 2.2-60.8a18.64 18.64 0 015-.5c8.1 0 26.4 3.1 56.6 24.1a208.21 208.21 0 01112.2 0c30.2-21 48.5-24.1 56.6-24.1a18.64 18.64 0 015 .5c12.2 31.6 4.5 55 2.2 60.8 14.3 16.1 23 36.6 23 61.6 0 88.2-52.4 107.6-102.3 113.3 8 7.1 15.2 21.1 15.2 42.5 0 30.7-.3 55.5-.3 63 0 5.4 3.1 11.5 11.4 11.5a19.35 19.35 0 004-.4C415.9 449.2 480 363.1 480 261.7 480 134.9 379.7 32 256 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$89fb1338dca2e4bd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.07 281.6l-25.18-78.08a11 11 0 00-.61-2.1l-50.5-156.94a20.08 20.08 0 00-19.17-13.82 19.77 19.77 0 00-18.95 13.94l-48.14 149.55h-152L131.34 44.59a19.76 19.76 0 00-18.86-13.94h-.11a20.15 20.15 0 00-19.12 14L42.7 201.73c0 .14-.11.26-.16.4l-25.63 79.48a29.15 29.15 0 0010.44 32.46l221.44 162.41a11.25 11.25 0 0013.38-.07l221.48-162.34a29.13 29.13 0 0010.42-32.47m-331-64.51l61.73 191.76L76.63 217.09m209.64 191.8l59.19-183.84 2.55-8h86.52L300.47 390.44M398.8 59.31l43.37 134.83h-86.82M324.16 217l-43 133.58-25.66 79.56L186.94 217M112.27 59.31l43.46 134.83H69M40.68 295.58a6.19 6.19 0 01-2.21-6.9l19-59 139.61 180.59m273.26-114.69L313.92 410.22l.52-.69L453.5 229.64l19 59a6.2 6.2 0 01-2.19 6.92"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3c930243988f1755(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 59.49v393a4.33 4.33 0 007.37 3.07L260 256 55.37 56.42A4.33 4.33 0 0048 59.49zM345.8 174L89.22 32.64l-.16-.09c-4.42-2.4-8.62 3.58-5 7.06l201.13 192.32zM84.08 472.39c-3.64 3.48.56 9.46 5 7.06l.16-.09L345.8 338l-60.61-57.95zM449.38 231l-71.65-39.46L310.36 256l67.37 64.43L449.38 281c19.49-10.77 19.49-39.23 0-50z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1ed80b132fcbc007(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M473.16 221.48l-2.26-9.59H262.46v88.22H387c-12.93 61.4-72.93 93.72-121.94 93.72-35.66 0-73.25-15-98.13-39.11a140.08 140.08 0 01-41.8-98.88c0-37.16 16.7-74.33 41-98.78s61-38.13 97.49-38.13c41.79 0 71.74 22.19 82.94 32.31l62.69-62.36C390.86 72.72 340.34 32 261.6 32c-60.75 0-119 23.27-161.58 65.71C58 139.5 36.25 199.93 36.25 256s20.58 113.48 61.3 155.6c43.51 44.92 105.13 68.4 168.58 68.4 57.73 0 112.45-22.62 151.45-63.66 38.34-40.4 58.17-96.3 58.17-154.9 0-24.67-2.48-39.32-2.59-39.96z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3f583fb5fdc5b84b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32v448h448V32zm249.67 250.83v84H235v-84l-77-140h55l46.32 97.54 44.33-97.54h52.73z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9f2dbc65eedbf425(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32l34.94 403.21L255.77 480 413 435.15 448 32zm308 132H188l4 51h176l-13.51 151.39L256 394.48l-98.68-28-6.78-77.48h48.26l3.42 39.29L256 343.07l53.42-14.92L315 264H148l-12.59-149.59H376.2z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$afec455c43e85ec3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.33 69.33a93.62 93.62 0 0193.34 93.34v186.66a93.62 93.62 0 01-93.34 93.34H162.67a93.62 93.62 0 01-93.34-93.34V162.67a93.62 93.62 0 0193.34-93.34h186.66m0-37.33H162.67C90.8 32 32 90.8 32 162.67v186.66C32 421.2 90.8 480 162.67 480h186.66C421.2 480 480 421.2 480 349.33V162.67C480 90.8 421.2 32 349.33 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M377.33 162.67a28 28 0 1128-28 27.94 27.94 0 01-28 28zM256 181.33A74.67 74.67 0 11181.33 256 74.75 74.75 0 01256 181.33m0-37.33a112 112 0 10112 112 112 112 0 00-112-112z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$275e47c915eb3466(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 153.9A102.1 102.1 0 10358.1 256 102.23 102.23 0 00256 153.9z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "402.59",
                    "cy": "116.45",
                    "r": "46.52"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M459.86 163.2l-1.95-4.28-3.11 3.52a70 70 0 01-28.06 19.32l-3 1.1 1.22 2.93A181.43 181.43 0 01439 256c0 100.92-82.1 183-183 183S73 356.92 73 256 155.08 73 256 73a180.94 180.94 0 0178.43 17.7l2.87 1.3 1.25-2.92A70.19 70.19 0 01359.21 62l3.67-2.93-4.17-2.07A221.61 221.61 0 00256 32C132.49 32 32 132.49 32 256s100.49 224 224 224 224-100.49 224-224a222.19 222.19 0 00-20.14-92.8z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$67a22161c222fa5a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M468.41 269.19c-2.64-33.39-11.76-58-31.44-57.39a1 1 0 00-.92 1.37c5.11 12.59 9.68 36.9 9.17 58.07a1 1 0 01-2 .08c-2.19-21.21-7.1-41.19-16.22-59.43a186.69 186.69 0 00-348.91 41 4 4 0 01-3.33 3.11l-8.65 1.22c-17.2 2.4-26.9 34.9-21.7 72.5s23.5 66.2 40.7 63.8l13.24-1.85a4 4 0 013.93 1.84 186.71 186.71 0 00339-56.07 4 4 0 013.68-3.08l4.4-.24c15.15-2.53 21.75-31.23 19.05-64.93zM94.5 270.42a1 1 0 011.59-1.19c9.63 10 20.25 27.65 23.32 49.86 3.24 23.05-2.24 45.2-9.13 57.87a1 1 0 01-1.84-.73c4.07-14.44 5.16-33.83 2.27-54.74-2.8-20.32-8.71-38.27-16.21-51.07zm178.77 109.79a15.53 15.53 0 01-15.41-13.83 15.48 15.48 0 1115.41 13.83zm81.84-4.72a15.37 15.37 0 1114.6-16.2 15.43 15.43 0 01-14.6 16.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M165.51 70a.31.31 0 01.1.2c.1.2.2.3.3.5v.1a5.78 5.78 0 002.3 2.7c2 1.5 5 2.4 8.6 3a63.69 63.69 0 0011.9.5 28.25 28.25 0 002.9-.2c-.4-.4-.8-.9-1.2-1.3h-1.3a52 52 0 01-11.6-.9 19.71 19.71 0 01-8.4-3.4 9.24 9.24 0 01-1.4-1.4 4.48 4.48 0 010-2.3c.5-2.3 2.4-4.8 5.5-7.4a57.25 57.25 0 0110.9-7c.9-.4 1.7-.9 2.6-1.3.1-.1.3-.1.5-.2a24.69 24.69 0 00-.2 10.5c2.3 11.9 11.6 20.3 23.2 20.6l4 24.3 12.7-3-4-23.3c10.8-4.6 16.3-16.1 14-28a25.8 25.8 0 00-3.9-9.5c-5.3-.8-15.6-.8-29.2 2.1 1.1-.3 2.1-.7 3.2-1a135.27 135.27 0 0121.5-4.2c.6-.1 1.2-.1 1.8-.2l3.5-.3h.6a61.83 61.83 0 0110.8.3 29 29 0 016.1 1.4 5.71 5.71 0 00-.9 3.2 6.12 6.12 0 004.3 5.8 25.53 25.53 0 01-2.1 2.8 26 26 0 01-2.9 2.8c-1.1.9-2.3 1.8-3.5 2.7l-6.5 3.8-.3 1.5a.35.35 0 00.2-.1l8.4-4.7c1.2-.8 2.4-1.6 3.4-2.4a29.15 29.15 0 003.2-2.8 29.86 29.86 0 002.4-2.8l.3-.6a6.14 6.14 0 005.4-6 6.06 6.06 0 00-6.1-6.1 6.81 6.81 0 00-2.8.7 24.6 24.6 0 00-8.2-2.7 63.48 63.48 0 00-15.5-.6 14.92 14.92 0 00-2.1.2 13.55 13.55 0 01-2 .2 25.15 25.15 0 00-18.7-3.7 25.86 25.86 0 00-17.8 13c-1.3.5-2.6 1.1-3.8 1.7-.7.3-1.3.6-2 .9a60.75 60.75 0 00-13.9 9.1c-3.1 2.9-4.9 5.7-5.3 8.3a6.14 6.14 0 00.7 4 2.19 2.19 0 01.3.5z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a7d30e90988706b7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32v448h448V32zm240 348c0 43.61-25.76 64.87-63.05 64.87-33.68 0-53.23-17.44-63.15-38.49l34.28-20.75c6.61 11.73 11.63 21.65 26.06 21.65 12 0 21.86-5.41 21.86-26.46V240h44zm99.35 63.87c-39.09 0-64.35-17.64-76.68-42L329 382c9 14.74 20.75 24.56 41.5 24.56 17.44 0 27.57-7.72 27.57-19.75 0-14.43-10.43-19.54-29.68-28l-10.52-4.52c-30.38-12.92-50.52-29.16-50.52-63.45 0-31.57 24.05-54.63 61.64-54.63 26.77 0 46 8.32 59.85 32.68L396 290c-7.22-12.93-15-18-27.06-18-12.33 0-20.15 7.82-20.15 18 0 12.63 7.82 17.74 25.86 25.56l10.52 4.51c35.79 15.34 55.94 31 55.94 66.16.01 37.9-29.76 57.64-69.76 57.64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$edb836133b38c314(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.57 234.62c-3.28-3.53-26.82-32.29-39.51-47.79-6.75-8.24-12.08-14.75-14.32-17.45l-.18-.22-.2-.21c-5.22-5.83-12.64-12.51-23.78-12.51a39.78 39.78 0 00-5.41.44c-.37.05-.75.11-1.15.15-2.45.27-10.06 1.5-28.14 4.48-14 2.29-35.11 5.77-38.31 6.07l-.71.06-.69.13c-10 1.78-16.62 6.22-19.56 13.19-1.55 3.68-3.22 11.15 2.94 19.86 1.53 2.22 6.83 9.56 15.94 22.17 6.06 8.4 12.87 17.82 18.75 26L259.9 275 150.66 96.05l-.2-.34-.23-.33-.44-.65C145.32 88.17 139.76 80 123.7 80c-1.13 0-2.31 0-3.63.11-4.6.25-21.42 1.57-40.89 3.11-21.49 1.69-50.9 4-54.72 4.1h-.73l-.79.08c-9.14.89-15.77 4.6-19.7 11-6.55 10.69-1.42 22.69.26 26.63C6.87 133 37.56 197.7 64.63 254.81c18 37.94 36.58 77.17 38.1 80.65a34.85 34.85 0 0032.94 21.59 46.62 46.62 0 009.86-1.1h.21l.2-.05c13.86-3.38 57.83-14.54 89.2-22.59 1.9 3.32 3.9 6.83 6 10.44 21.93 38.5 37.9 66.35 43.16 73.46C287 421 295 432 310.06 432c5.46 0 10.46-1.4 15.74-2.89l1.53-.43h.12c10.53-3 150.69-52.16 157.87-55.35l.22-.1c5.44-2.41 13.66-6.05 16.18-15.4 1.65-6.12.18-12.33-4.38-18.46l-.07-.09-.07-.09c-.85-1.1-4-5.21-8.27-10.9-9.13-12.07-23.88-31.57-36.84-48.54 17.37-4.5 38.8-10.11 43.38-11.55 11.47-3.43 14.94-10.69 16-14.73.79-3.15 1.82-11.2-5.9-18.85zm-320 58.19c-17.81 4.17-30.22 7.08-37.89 8.9-6.67-13.34-19.74-39.65-32.5-65.33-29.74-59.92-45.1-90.77-53.18-106.9l8.15-.7c13.34-1.15 31.61-2.72 41.78-3.57 16.76 28.26 74.32 125.3 96.3 162.3zM427.58 172zM310.06 416.4zm53.67-56.95c-24.21 8-37.33 12.37-44.42 14.74-6.3-10.34-20.16-33.52-32.47-54.19l115.7-29.48c5 6.81 14.57 19.72 33.46 44.93-18.07 6.04-48.2 16.02-72.27 24zm55.87-121.63l-23.76-31.53c13.67-2.39 21.54-3.77 26.15-4.6l12 14.88 11.94 14.82c-8.2 1.99-17.74 4.32-26.33 6.43z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$94a6990924a1c450(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.17 32H70.28C49.85 32 32 46.7 32 66.89v374.72C32 461.91 49.85 480 70.28 480h373.78c20.54 0 35.94-18.21 35.94-38.39V66.89C480.12 46.7 464.6 32 444.17 32zm-273.3 373.43h-64.18V205.88h64.18zM141 175.54h-.46c-20.54 0-33.84-15.29-33.84-34.43 0-19.49 13.65-34.42 34.65-34.42s33.85 14.82 34.31 34.42c-.01 19.14-13.31 34.43-34.66 34.43zm264.43 229.89h-64.18V296.32c0-26.14-9.34-44-32.56-44-17.74 0-28.24 12-32.91 23.69-1.75 4.2-2.22 9.92-2.22 15.76v113.66h-64.18V205.88h64.18v27.77c9.34-13.3 23.93-32.44 57.88-32.44 42.13 0 74 27.77 74 87.64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$aedc5452ecb3d4ed(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M475 64H37C16.58 64 0 81.38 0 102.77v306.42C0 430.59 16.58 448 37 448h438c20.38 0 37-17.41 37-38.81V102.77C512 81.38 495.42 64 475 64zM288 368h-64V256l-48 64-48-64v112H64V144h64l48 80 48-80h64zm96 0l-80-112h48.05L352 144h64v112h48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bc8a9e0f98fdebdf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 173.59c0-104.13-68.26-134.65-68.26-134.65C377.3 23.15 318.2 16.5 256.8 16h-1.51c-61.4.5-120.46 7.15-154.88 22.94 0 0-68.27 30.52-68.27 134.65 0 23.85-.46 52.35.29 82.59C34.91 358 51.11 458.37 145.32 483.29c43.43 11.49 80.73 13.89 110.76 12.24 54.47-3 85-19.42 85-19.42l-1.79-39.5s-38.93 12.27-82.64 10.77c-43.31-1.48-89-4.67-96-57.81a108.44 108.44 0 01-1-14.9 558.91 558.91 0 0096.39 12.85c32.95 1.51 63.84-1.93 95.22-5.67 60.18-7.18 112.58-44.24 119.16-78.09 10.42-53.34 9.58-130.17 9.58-130.17zm-80.54 134.16h-50V185.38c0-25.8-10.86-38.89-32.58-38.89-24 0-36.06 15.53-36.06 46.24v67h-49.66v-67c0-30.71-12-46.24-36.06-46.24-21.72 0-32.58 13.09-32.58 38.89v122.37h-50V181.67q0-38.65 19.75-61.39c13.6-15.15 31.4-22.92 53.51-22.92 25.58 0 44.95 9.82 57.75 29.48L256 147.69l12.45-20.85c12.81-19.66 32.17-29.48 57.75-29.48 22.11 0 39.91 7.77 53.51 22.92q19.79 22.72 19.75 61.39z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$52f63f632df8f7b9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M28 28v456h456V28H28zm378.83 108.04l-24.46 23.45a7.162 7.162 0 00-2.72 6.86v172.28c-.44 2.61.61 5.26 2.72 6.86l23.88 23.45v5.15H286.13v-5.15l24.74-24.02c2.43-2.43 2.43-3.15 2.43-6.86V198.81l-68.79 174.71h-9.3l-80.09-174.71v117.1c-.67 4.92.97 9.88 4.43 13.44l32.18 39.03v5.15h-91.24v-5.15l32.18-39.03c3.44-3.57 4.98-8.56 4.15-13.44V180.5c.38-3.76-1.05-7.48-3.86-10.01l-28.6-34.46v-5.15h88.81l68.65 150.55 60.35-150.55h84.66v5.16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c037d7e39a6d274c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M31.87 30.58H244.7v212.81H31.87zm235.02 0H479.7v212.81H266.89zM31.87 265.61H244.7v212.8H31.87zm235.02 0H479.7v212.8H266.89z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4f9c30e4e7805085(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 256h16v48h-16zm-248 48h129.6l-48-48H112v48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M364.5 60.1a8.79 8.79 0 01-1-.6 218.79 218.79 0 00-34.4-14.8l-5.4-1.8A223.2 223.2 0 00256 32C132.3 32 32 132.3 32 256a223.71 223.71 0 00115.4 195.8c.4.2.7.5 1.1.7a218.79 218.79 0 0034.4 14.8l5.4 1.8A222.7 222.7 0 00256 480c123.7 0 224-100.3 224-224A223.76 223.76 0 00364.5 60.1zM256 426.4a161.85 161.85 0 01-27.2-2.4 170.14 170.14 0 01-28.5-7.3c-1.9-.6-3.8-1.2-5.6-1.9a162.39 162.39 0 01-19-8.6 170.33 170.33 0 01-90.1-150.3c0-37.2 12.4-71.4 32.7-99.4l237.2 237.2c-28.1 20.3-62.3 32.7-99.5 32.7zm137.8-71L156.6 118.2c28-20.2 62.1-32.6 99.4-32.6a162.79 162.79 0 0127.2 2.4 170.14 170.14 0 0128.5 7.3c1.8.6 3.7 1.2 5.6 1.9a162 162 0 0118 8.1 170.25 170.25 0 0191.2 150.8c-.1 37.2-12.5 71.3-32.7 99.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M352 256h-34l34 34v-34zm32 0h16v48h-16zm-23.9-43.3c-8.8-4.1-22-5.7-45.6-5.7h-3.6c-12.7.1-15.9-.1-20-6.1-2.8-4.2-1-14.8 3.7-21.9a8 8 0 00.4-8.2 8.26 8.26 0 00-7-4.3 53.67 53.67 0 01-18.3-3.9c-10.6-4.5-15.6-12.1-15.6-23.1 0-25.8 21.8-27.7 22.8-27.7v-16c-12 0-38.8 11-38.8 43.7 0 17.5 9 31 25.7 38a66.58 66.58 0 0012 3.6c-3.3 9.8-3.6 20.9 1.7 28.7 9 13.3 20.3 13.2 33.3 13.1h3.5c26.3 0 34.6 2.3 38.9 4.3 5.7 2.6 6.8 7.5 6.6 15.7v1h16v-1c0-7.1.3-22.8-15.7-30.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M400 244c0-25.7-3-39.2-9.1-49.6C382.3 180 368.5 172 352 172h-17.4c2.9-8.3 5.4-19.8 3.5-30.9-3.2-18.8-19.1-30-43.1-30v16c21 0 26.1 9.1 27.4 16.7 2.5 14.5-6.8 32.1-6.9 32.3a8 8 0 00.1 7.9 8.06 8.06 0 006.9 3.9H352c10.9 0 19.4 4.9 25.1 14.6 3.1 5.3 6.9 13.5 6.9 41.4h16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d1ed48b1bf1a1bad(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M429.76 130.07L274.33 36.85a37 37 0 00-36.65 0L82.24 130.06A38.2 38.2 0 0064 162.83V349a38.26 38.26 0 0018.24 32.8L123 406.14l.23.13c20.58 10.53 28.46 10.53 37.59 10.53 32.14 0 52.11-20.8 52.11-54.29V182a8.51 8.51 0 00-8.42-8.58h-22.38a8.51 8.51 0 00-8.42 8.58v180.51a15 15 0 01-6.85 13.07c-5.9 3.6-14.47 2.84-24.14-2.15l-39.06-23.51a1.1 1.1 0 01-.48-.92V165.46a1.32 1.32 0 01.59-1.06l151.84-93a.82.82 0 01.73 0l151.93 93a1.34 1.34 0 01.55 1.1V349a1.28 1.28 0 01-.45 1l-152.06 90.65a1.22 1.22 0 01-.8 0l-38.83-23.06a7.8 7.8 0 00-7.83-.41l-.34.2c-10.72 6.35-13.6 8-23.54 11.62-1.62.59-5.43 2-5.76 5.77s3.29 6.45 6.51 8.32l51.9 31.87a35.67 35.67 0 0018.3 5.07h.58a35.87 35.87 0 0017.83-5.07l155.43-93.13A38.37 38.37 0 00448 349V162.83a38.21 38.21 0 00-18.24-32.76z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M307.88 318.05c-37.29 0-45.24-10.42-47.6-27.24a8.43 8.43 0 00-8.22-7.32h-19.8a8.44 8.44 0 00-8.26 8.58c0 14.58 5.12 62.17 83.92 62.17 24.38 0 44.66-5.7 58.63-16.49S388 311.26 388 292.55c0-37.55-24.5-47.83-72.75-54.55-49.05-6.82-49.05-10.29-49.05-17.89 0-5.47 0-18.28 35.46-18.28 25.23 0 38.74 3.19 43.06 20a8.35 8.35 0 008.06 6.67h19.87a8.24 8.24 0 006.16-2.86 8.91 8.91 0 002.12-6.44c-2.57-35.55-28.56-53.58-79.24-53.58-46.06 0-73.55 20.75-73.55 55.5 0 38.1 28.49 48.87 71.29 53.33 50 5.17 50 12.71 50 19.37.03 10.38-4.28 24.23-41.55 24.23z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e51b7de644d19431(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M227.6 213.1H256v57.1h-28.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 156v171.4h142.2V356H256v-28.6h256V156zm142.2 142.9h-28.4v-85.7H85.3v85.7H28.4V184.6h113.8zm142.2 0h-56.9v28.6h-56.9V184.6h113.8zm199.2 0h-28.4v-85.7h-28.4v85.7h-28.4v-85.7H370v85.7h-56.9V184.6h170.7v114.3z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a4a05fe7c7cfaabc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.86 290.12c-9.75 0-18.11 4.56-24.86 13.87s-10.07 20.58-10.07 34 3.43 24.91 10.07 34.12S163 386 172.86 386c9.1 0 17-4.66 23.68-13.87s10.07-20.58 10.07-34.12-3.43-24.81-10.07-34-14.54-13.89-23.68-13.89zm167.46 0c-9.64 0-18.11 4.56-24.86 13.87s-10.07 20.58-10.07 34 3.43 24.91 10.07 34.12S330.57 386 340.32 386c9.11 0 17-4.66 23.79-13.87s10.07-20.58 10.07-34.12-3.43-24.81-10.07-34-14.57-13.89-23.79-13.89z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M459.36 165c-.11 0 2.89-15.49.32-42.47-2.36-27-8-51.78-17.25-74.53 0 0-4.72.87-13.72 3.14S405 58 384.89 67.18c-19.82 9.2-40.71 21.44-62.46 36.29-14.79-4.23-36.86-6.39-66.43-6.39-28.18 0-50.25 2.16-66.43 6.39Q117.9 53.25 69.46 48q-13.81 34.13-17.14 74.75c-2.57 27 .43 42.58.43 42.58C26.71 193.82 16 234.88 16 268.78c0 26.22.75 49.94 6.54 71 6 20.91 13.6 38 22.6 51.14A147.49 147.49 0 0079 425.43c13.39 10.08 25.71 17.34 36.86 21.89 11.25 4.76 24 8.23 38.57 10.72a279.19 279.19 0 0032.68 4.34s30 1.62 69 1.62 68.89-1.62 68.89-1.62a285.25 285.25 0 0032.68-4.38 178.91 178.91 0 0038.46-10.72c11.15-4.66 23.47-11.81 37-21.89a145 145 0 0033.75-34.55c9-13.11 16.6-30.23 22.6-51.14s6.51-44.81 6.51-71.03c0-32.82-10.71-74.42-36.64-103.67zm-70.07 253.07C359.39 432.26 315.46 438 257.18 438h-2.25c-58.29 0-102.22-5.63-131.57-19.93s-44.25-43.45-44.25-87.43c0-26.32 9.21-47.66 27.32-64 7.93-7 17.57-11.92 29.57-14.84s22.93-3 33.21-2.71c10.08.43 24.22 2.38 42.11 3.79s31.39 3.25 44.79 3.25c12.53 0 29.14-2.17 55.82-4.33s46.61-3.25 59.46-1.09c13.18 2.17 24.65 6.72 34.4 15.93q28.44 25.67 28.5 64c-.11 43.98-15.22 73.24-45 87.43z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1bb27dbe57a8a1f6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.81 148.79c-.43 2.76-.93 5.58-1.49 8.48-19.17 98-84.76 131.8-168.54 131.8h-42.65a20.67 20.67 0 00-20.47 17.46l-21.84 137.84-6.18 39.07a10.86 10.86 0 009.07 12.42 10.72 10.72 0 001.7.13h75.65a18.18 18.18 0 0018-15.27l.74-3.83 14.24-90 .91-4.94a18.16 18.16 0 0118-15.3h11.31c73.3 0 130.67-29.62 147.44-115.32 7-35.8 3.38-65.69-15.16-86.72a72.27 72.27 0 00-20.73-15.82z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M385.52 51.09C363.84 26.52 324.71 16 274.63 16H129.25a20.75 20.75 0 00-20.54 17.48l-60.55 382a12.43 12.43 0 0010.39 14.22 12.58 12.58 0 001.94.15h89.76l22.54-142.29-.7 4.46a20.67 20.67 0 0120.47-17.46h42.65c83.77 0 149.36-33.86 168.54-131.8.57-2.9 1.05-5.72 1.49-8.48 5.7-36.22-.05-60.87-19.72-83.19z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b3f897f3afc4eb31(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.05 32c-123.7 0-224 100.3-224 224 0 91.7 55.2 170.5 134.1 205.2-.6-15.6-.1-34.4 3.9-51.4 4.3-18.2 28.8-122.1 28.8-122.1s-7.2-14.3-7.2-35.4c0-33.2 19.2-58 43.2-58 20.4 0 30.2 15.3 30.2 33.6 0 20.5-13.1 51.1-19.8 79.5-5.6 23.8 11.9 43.1 35.4 43.1 42.4 0 71-54.5 71-119.1 0-49.1-33.1-85.8-93.2-85.8-67.9 0-110.3 50.7-110.3 107.3 0 19.5 5.8 33.3 14.8 43.9 4.1 4.9 4.7 6.9 3.2 12.5-1.1 4.1-3.5 14-4.6 18-1.5 5.7-6.1 7.7-11.2 5.6-31.3-12.8-45.9-47-45.9-85.6 0-63.6 53.7-139.9 160.1-139.9 85.5 0 141.8 61.9 141.8 128.3 0 87.9-48.9 153.5-120.9 153.5-24.2 0-46.9-13.1-54.7-27.9 0 0-13 51.6-15.8 61.6-4.7 17.3-14 34.5-22.5 48a225.13 225.13 0 0063.5 9.2c123.7 0 224-100.3 224-224S379.75 32 256.05 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3c2a650e1e8d7c09(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399.77 203c-.8-17.1-3.3-34.5-10.8-50.1a82.45 82.45 0 00-16.5-23.2 105.59 105.59 0 00-21.3-16.3c-17.1-10.2-37.5-17-84.4-31S192 64 192 64v358.3l79.9 25.7s.1-198.8.1-299.5v-3.8c0-9.3 7.5-16.8 16.1-16.8h.5c8.5 0 15.5 7.5 15.5 16.8V278c11 5.3 29.2 9.3 41.8 9.1a47.79 47.79 0 0024-5.7 49.11 49.11 0 0018.4-17.8 78.64 78.64 0 009.9-27.3c1.87-10.8 1.97-22.1 1.57-33.3zM86.67 357.8c27.4-9.8 89.3-29.5 89.3-29.5v-47.2s-76.5 24.8-111.3 37.1c-8.6 3.1-17.3 5.9-25.7 9.5-9.8 4.1-19.4 8.7-28.1 14.8a26.29 26.29 0 00-9.2 10.1 17.36 17.36 0 00-.5 13.6c2 5.1 5.8 9.3 10.1 12.6 7.8 5.9 17.1 9.5 26.4 12.2a262.42 262.42 0 0088.4 13.3c14.5-.2 36-1.9 50-4.4v-42s-11 2.5-41.3 12.5c-4.6 1.5-9.2 3.3-14 4.3a104.87 104.87 0 01-21.6 2.2c-6.5-.3-13.2-.7-19.3-3.1-2.2-1-4.6-2.2-5.5-4.6-.8-2 .3-4 1.7-5.4 2.8-2.9 6.8-4.5 10.6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 345.9c-.1-6-3.7-11.2-7.9-15-7.1-6.3-15.9-10.3-24.7-13.5-5.5-1.9-9.3-3.3-14.7-5-25.2-8.2-51.9-11.2-78.3-11.3-8 .3-23.1.5-31 1.4-21.9 2.5-67.3 15.4-67.3 15.4v48.8s67.5-21.6 96.5-31.8a94.43 94.43 0 0130.3-4.6c6.5.2 13.2.7 19.4 3.1 2.2.9 4.5 2.2 5.5 4.5.9 2.6-.9 5-2.9 6.5-4.7 3.8-10.7 5.3-16.2 7.4-41 14.5-132.7 44.7-132.7 44.7v47s117.2-39.6 170.8-58.8c8.9-3.3 17.9-6.1 26.4-10.4 7.9-4 15.8-8.6 21.8-15.3a19.74 19.74 0 005-13.1z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4ccfae66be6c8337(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.7 352l77.72-192H356.9l-53.16 124.07L265.93 160h-39.61l-40.58 124.07-28.63-56.53-25.9 79.46 26.3 45h50.7l36.68-111.27 35 111.27zM48.79 286.09h31.65a93.39 93.39 0 0025.62-3.21l8.18-25.19 22.88-70.39a55.75 55.75 0 00-6-7.82Q113.54 160 79.59 160H0v192h48.79zm41.9-81.92q6.89 6.92 6.88 18.52t-6 18.53q-6.64 7.62-24.44 7.61H48.79v-51.58h18.42q16.59 0 23.48 6.92zm286.16 113.44l14.79-37.25h42.69l-20.26-56.51L439.41 160 512 352h-53.53l-12.4-34.39z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e360c07c3248130a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M314 36.38c-18.59-3.06-45.8-4.47-64.27-4.38a311.09 311.09 0 00-51.66 4.38c-45.74 8-54.07 24.7-54.07 55.54V128h112v16H107.62C66.06 144 32.33 193.67 32 255.12v.88a162.91 162.91 0 003.13 32c9.29 46.28 38.23 80 72.49 80H128v-54c0-31.3 20.84-59.95 55-66.1l9.87-1.23H314a56.05 56.05 0 0015.06-2A52.48 52.48 0 00368 193.68V91.92c0-28.92-24.68-50.73-54-55.54zM194.93 105.5a20.37 20.37 0 1120.3-20.3 20.29 20.29 0 01-20.3 20.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M475.28 217c-10.7-42.61-38.41-73-70.9-73h-17.71v47.45c0 39.57-26 68.22-57.74 73.13a63.54 63.54 0 01-9.69.75H198.08a60 60 0 00-15.23 1.95C160.54 273.14 144 291.7 144 315.77v101.77c0 29 29.14 46 57.73 54.31 34.21 9.95 71.48 11.75 112.42 0 27.19-7.77 53.85-23.48 53.85-54.31V384H256v-16h148.38c29.44 0 54.95-24.93 67.45-61.31A156.83 156.83 0 00480 256a160.64 160.64 0 00-4.72-39zM316.51 404a20.37 20.37 0 11-20.3 20.3 20.29 20.29 0 0120.3-20.3z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c0ad3c553890df88(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M410.66 180.72q-7.67-2.62-15.45-4.88 1.29-5.25 2.38-10.56c11.7-56.9 4.05-102.74-22.06-117.83-25-14.48-66 .61-107.36 36.69q-6.1 5.34-11.95 11-3.9-3.76-8-7.36c-43.35-38.58-86.8-54.83-112.88-39.69-25 14.51-32.43 57.6-21.9 111.53q1.58 8 3.55 15.93a320.85 320.85 0 00-17.77 5.6C48.46 198.9 16 226.73 16 255.59c0 29.82 34.84 59.72 87.77 77.85q6.44 2.19 13 4.07-2.13 8.49-3.77 17.17c-10 53-2.2 95.07 22.75 109.49 25.77 14.89 69-.41 111.14-37.31q5-4.38 10-9.25 6.32 6.11 13 11.86c40.8 35.18 81.09 49.39 106 34.93 25.75-14.94 34.12-60.14 23.25-115.13q-1.25-6.3-2.88-12.86 4.56-1.35 8.93-2.79c55-18.27 90.83-47.81 90.83-78-.02-29-33.52-57.01-85.36-74.9zm-129-81.08c35.43-30.91 68.55-43.11 83.65-34.39 16.07 9.29 22.32 46.75 12.22 95.88q-1 4.8-2.16 9.57a487.83 487.83 0 00-64.18-10.16 481.27 481.27 0 00-40.57-50.75q5.38-5.22 11.02-10.15zM157.73 280.25q6.51 12.6 13.61 24.89 7.23 12.54 15.07 24.71a435.28 435.28 0 01-44.24-7.13c4.24-13.72 9.46-27.97 15.56-42.47zm0-48.33c-6-14.19-11.08-28.15-15.25-41.63 13.7-3.07 28.3-5.58 43.52-7.48q-7.65 11.94-14.72 24.23t-13.58 24.88zm10.9 24.17q9.48-19.77 20.42-38.78 10.93-19 23.27-37.13c14.28-1.08 28.92-1.65 43.71-1.65s29.52.57 43.79 1.66q12.21 18.09 23.13 37t20.69 38.6Q334 275.63 323 294.73q-10.91 19-23 37.24c-14.25 1-29 1.55-44 1.55s-29.47-.47-43.46-1.38q-12.43-18.19-23.46-37.29t-20.48-38.76zM340.75 305q7.25-12.58 13.92-25.49a440.41 440.41 0 0116.12 42.32 434.44 434.44 0 01-44.79 7.65q7.62-12.09 14.75-24.48zm13.72-73.07q-6.64-12.65-13.81-25-7-12.18-14.59-24.06c15.31 1.94 30 4.52 43.77 7.67a439.89 439.89 0 01-15.37 41.39zm-98.24-107.45a439.75 439.75 0 0128.25 34.18q-28.35-1.35-56.74 0c9.33-12.34 18.88-23.79 28.49-34.18zM145.66 65.86c16.06-9.32 51.57 4 89 37.27 2.39 2.13 4.8 4.36 7.2 6.67A491.37 491.37 0 00201 160.51a499.12 499.12 0 00-64.06 10q-1.83-7.36-3.3-14.82c-9.05-46.23-3.06-81.08 12.02-89.83zm-23.41 251.85q-6-1.71-11.85-3.71c-23.4-8-42.73-18.44-56-29.81-11.88-10.19-17.9-20.36-17.9-28.6 0-17.51 26.06-39.85 69.52-55q8.19-2.85 16.52-5.21a493.54 493.54 0 0023.4 60.75 502.46 502.46 0 00-23.69 61.58zm111.13 93.67c-18.63 16.32-37.29 27.89-53.74 33.72-14.78 5.23-26.55 5.38-33.66 1.27-15.14-8.75-21.44-42.54-12.85-87.86q1.53-8 3.5-16a480.85 480.85 0 0064.69 9.39 501.2 501.2 0 0041.2 51c-2.98 2.93-6.03 5.75-9.14 8.48zm23.42-23.22c-9.72-10.51-19.42-22.14-28.88-34.64q13.79.54 28.08.54c9.78 0 19.46-.21 29-.64a439.33 439.33 0 01-28.2 34.74zm124.52 28.59c-2.86 15.44-8.61 25.74-15.72 29.86-15.13 8.78-47.48-2.63-82.36-32.72-4-3.44-8-7.13-12.07-11a484.54 484.54 0 0040.23-51.2 477.84 477.84 0 0065-10.05q1.47 5.94 2.6 11.64c4.81 24.3 5.5 46.28 2.32 63.47zm17.4-102.64c-2.62.87-5.32 1.71-8.06 2.53a483.26 483.26 0 00-24.31-60.94 481.52 481.52 0 0023.36-60.06c4.91 1.43 9.68 2.93 14.27 4.52 44.42 15.32 71.52 38 71.52 55.43 0 18.6-29.27 42.74-76.78 58.52z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 298.55a43 43 0 10-42.86-43 42.91 42.91 0 0042.86 43z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2884caf45ee72fd9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M324 256a36 36 0 1036 36 36 36 0 00-36-36z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "188",
                    "cy": "292",
                    "r": "36",
                    "transform": "rotate(-22.5 187.997 291.992)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M496 253.77c0-31.19-25.14-56.56-56-56.56a55.72 55.72 0 00-35.61 12.86c-35-23.77-80.78-38.32-129.65-41.27l22-79 66.41 13.2c1.9 26.48 24 47.49 50.65 47.49 28 0 50.78-23 50.78-51.21S441 48 413 48c-19.53 0-36.31 11.19-44.85 28.77l-90-17.89-31.1 109.52-4.63.13c-50.63 2.21-98.34 16.93-134.77 41.53A55.38 55.38 0 0072 197.21c-30.89 0-56 25.37-56 56.56a56.43 56.43 0 0028.11 49.06 98.65 98.65 0 00-.89 13.34c.11 39.74 22.49 77 63 105C146.36 448.77 199.51 464 256 464s109.76-15.23 149.83-42.89c40.53-28 62.85-65.27 62.85-105.06a109.32 109.32 0 00-.84-13.3A56.32 56.32 0 00496 253.77zM414 75a24 24 0 11-24 24 24 24 0 0124-24zM42.72 253.77a29.6 29.6 0 0129.42-29.71 29 29 0 0113.62 3.43c-15.5 14.41-26.93 30.41-34.07 47.68a30.23 30.23 0 01-8.97-21.4zM390.82 399c-35.74 24.59-83.6 38.14-134.77 38.14S157 423.61 121.29 399c-33-22.79-51.24-52.26-51.24-83A78.5 78.5 0 0175 288.72c5.68-15.74 16.16-30.48 31.15-43.79a155.17 155.17 0 0114.76-11.53l.3-.21.24-.17c35.72-24.52 83.52-38 134.61-38s98.9 13.51 134.62 38l.23.17.34.25A156.57 156.57 0 01406 244.92c15 13.32 25.48 28.05 31.16 43.81a85.44 85.44 0 014.31 17.67 77.29 77.29 0 01.6 9.65c-.01 30.72-18.21 60.19-51.25 82.95zm69.6-123.92c-7.13-17.28-18.56-33.29-34.07-47.72A29.09 29.09 0 01440 224a29.59 29.59 0 0129.41 29.71 30.07 30.07 0 01-8.99 21.39z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M323.23 362.22c-.25.25-25.56 26.07-67.15 26.27-42-.2-66.28-25.23-67.31-26.27a4.14 4.14 0 00-5.83 0l-13.7 13.47a4.15 4.15 0 000 5.89c3.4 3.4 34.7 34.23 86.78 34.45 51.94-.22 83.38-31.05 86.78-34.45a4.16 4.16 0 000-5.9l-13.71-13.47a4.13 4.13 0 00-5.81 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ac0ce2bc4be6d123(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M108.56 342.78a60.34 60.34 0 1060.56 60.44 60.63 60.63 0 00-60.56-60.44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M48 186.67v86.55c52 0 101.94 15.39 138.67 52.11s52 86.56 52 138.67h86.66c0-151.56-125.66-277.33-277.33-277.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M48 48v86.56c185.25 0 329.22 144.08 329.22 329.44H464C464 234.66 277.67 48 48 48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$90341594f7b7b9d5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.78 328.07c-1.47-11.92-7.51-22.26-18-30.77a3.58 3.58 0 00-.43-.44l-.53-.38-.17-.12-5.57-4-.19-.14-.71-.5a3.5 3.5 0 00-.83-.35c-17.62-10.49-46.79-17.84-91.42-2.09-10.65-17.92-11.86-32.28-4.73-54.28 1.27-3.83.09-6.36-3.71-8-7.64-3.25-18.1-1.59-25.52.37-3.46.9-5.54 2.86-6.2 5.83-4.7 22-18.36 42.1-31.57 61.5l-.78 1.14c-8.14-17.26-6.45-30.63-.78-47.38 1.13-3.34.24-5.56-2.89-7.22-8.74-4.51-21.85-1.41-27.07.13-6.62 1.93-13.72 19.82-21.65 41.24-2 5.39-3.72 10-4.75 12.15-2.45 5-4.79 10.7-7.27 16.75-5.6 13.69-11.91 29.1-20.93 38.78-3.28-7.25 1.88-18.68 6.89-29.77 5.93-13.11 11.53-25.5 5.08-33.41a11.82 11.82 0 00-8.33-4.32 13.26 13.26 0 00-6.15 1c.67-5.65.7-10.11-.95-15.5-2.36-7.69-8.49-12-16.93-11.77-19.22.56-35.48 14.88-45.75 26.8-6.84 8-22 14.1-35.31 19.45-5.26 2.23-10.26 4.23-14.43 6.23-6.65-5.62-15.1-11.29-24-17.28-25-16.78-53.33-35.81-54.31-61.61-1.4-38.11 42-65.14 79.88-84.43 28.71-14.6 53.67-24.28 76.31-29.57 31.8-7.43 58.66-5.93 79.82 4.44 11.58 5.67 17 18 13.56 30.68-9 32.95-46.29 55.53-78.18 65.69-19.21 6.12-35.56 8.68-50 7.84-18.1-1.05-32.88-10.13-39.2-14a21.18 21.18 0 00-3.2-1.8l-.29-.07a3.21 3.21 0 00-3.19 1c-1.3 1.55-.84 4-.37 5.24 6.15 16.07 18.85 26.22 37.74 30.17a92.09 92.09 0 0018.78 1.79c44.21 0 100.62-25.49 121.34-46.48 14.13-14.3 24.42-29 28.68-54.35 4.45-26.55-13.55-45-31.89-53.5-44.57-20.57-95.19-12.44-129.81-2-40.5 12.21-82.4 34.41-114.94 60.93-40.12 32.67-54.62 63-43.12 90.25 11.81 27.93 40.61 45.4 68.46 62.3 9 5.45 17.56 10.64 25.27 16-2.32 1.13-4.69 2.28-7.1 3.43-23.38 11.33-49.9 24.08-64.61 45.15-10.68 15.35-12.68 30.63-5.94 45.42 3.6 7.87 10 13.21 18.89 15.87A50 50 0 0053 432c17.31 0 36.36-7 46.73-13.47 18.32-11.5 30.19-26.94 35.29-45.89 4.54-16.86 3.45-33.61-3.15-48.56l22.45-11.32c-10.83 36-2.53 57.5 6.59 69.36 3.36 4.37 9.42 7 16.19 7.12s13-2.43 16.52-6.77c6.66-8.25 11.58-17.9 16.11-27.55-.24 6.3.06 12.68 2.21 18.09 1.93 4.87 5.11 8.1 9.21 9.34 4.36 1.33 9.47.21 14.39-3.15 22.17-15.17 37.33-51.58 49.51-80.85 1.73-4.16 3.39-8.16 5-11.9a152.5 152.5 0 0012.5 31.07c1.18 2.14 1.08 3.08-.52 4.84-2.41 2.64-5.77 5.83-9.33 9.21-10.78 10.23-24.2 23-26 34.23-.7 4.5 2.4 8.6 7.21 9.53 14.47 2.88 31.9-1.33 46.64-11.25 13.4-9 18.44-21.55 15-37.19-3.33-15.06 4.27-33.76 22.59-55.62 3 12.53 7 22.66 12.52 31.53l-.15.12c-13.34 11.65-31.62 27.6-28.78 46.95a13.35 13.35 0 005.58 9.22 14.22 14.22 0 0011.2 2.06c17.47-3.67 30.62-11.06 40.18-22.57s6.07-24.27 2.85-34.17c25-6.78 47.26-6.61 68.1.5 11.7 4 20.09 10.57 24.93 19.64 6.09 11.41 2.8 21.94-9.29 29.65-3.71 2.37-5.5 3.82-5.61 5.65a2.65 2.65 0 001 2.23c1.4 1.15 5.72 3.15 15.49-3 9-5.65 14.28-13.34 15.63-23a39 39 0 00-.01-8.01zm-399.73 25.06l-.1 1.28c-1.56 14.64-9 27.4-22.15 38-8.26 6.66-17.23 10.75-25.25 11.53-5.6.54-9.67-.22-12.09-2.27-1.81-1.53-2.78-3.82-3-7-1.64-25.48 38.32-50.8 60.81-59.13a51.39 51.39 0 011.78 17.59zm102.35-71.86c-3.7 21.09-14.49 60.9-31.45 76.35-.81.74-1.49 1-1.8.93s-.55-.44-.8-1c-5.66-13.12-3.57-35.28 5-52.69 6.59-13.42 16-22.31 26.52-25a5.29 5.29 0 011.34-.19 1.58 1.58 0 011 .27 1.64 1.64 0 01.19 1.33zm83.49 76.88c-3.19 3.33-7.56 2.88-6.53 1.66l16.24-17.24c-1.31 5.93-5.18 10.84-9.71 15.58zm67.37-14.91a14.07 14.07 0 01-4.93 1.39c-.46-9.07 8.33-19.28 17-26.09 2.33 9.46-2.44 19.46-12.07 24.7z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$24cedb4a9d32a8eb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M467.16 303.6a205.69 205.69 0 004.9-45.15c0-116.32-95.69-210.7-213.79-210.7a221.83 221.83 0 00-36.52 3A123.58 123.58 0 00155.93 32C87.55 32 32 86.72 32 154.15A119.56 119.56 0 0049 216a211.16 211.16 0 00-4.32 42.35c0 116.44 95.69 210.7 213.67 210.7a214 214 0 0039.09-3.5A125.45 125.45 0 00356.07 480C424.57 480 480 425.28 480 357.85a118 118 0 00-12.84-54.25zM368 359c-9.92 13.76-24.51 24.73-43.41 32.43S283.36 403 257.69 403c-30.69 0-56.36-5.37-76.55-15.87a101 101 0 01-35.24-30.8c-9.11-12.83-13.66-25.66-13.66-38 0-7.7 3-14.35 8.87-19.95 5.84-5.37 13.42-8.17 22.29-8.17 7.35 0 13.65 2.1 18.79 6.42 4.9 4.08 9.1 10.15 12.48 18.08A108.09 108.09 0 00207 336.15q6.32 8.22 17.86 13.65c7.82 3.62 18.2 5.48 31 5.48 17.62 0 32.09-3.73 42.94-11.08 10.74-7.12 15.88-15.75 15.88-26.25 0-8.28-2.69-14.82-8.29-19.95-5.83-5.37-13.42-9.57-22.87-12.37-9.69-3-22.87-6.18-39.21-9.56-22.17-4.67-41-10.27-56-16.57-15.28-6.42-27.65-15.4-36.76-26.48-9.22-11.32-13.77-25.55-13.77-42.24a67.86 67.86 0 0114.47-42.58c9.57-12.25 23.46-21.82 41.55-28.35 17.74-6.53 38.86-9.8 62.66-9.8 19.14 0 35.83 2.22 49.83 6.42s25.91 10.15 35.36 17.38 16.34 14.93 20.77 23 6.66 16.22 6.66 24c0 7.46-2.92 14.35-8.76 20.3a29.65 29.65 0 01-21.94 9.1c-7.93 0-14.12-1.87-18.43-5.6-4-3.5-8.17-8.87-12.72-16.69-5.37-9.91-11.79-17.85-19.14-23.45-7.24-5.36-19.14-8.16-35.71-8.16-15.29 0-27.77 3-37 9-8.87 5.72-13.19 12.37-13.19 20.18a18.26 18.26 0 004.32 12.25 38.13 38.13 0 0012.72 9.57 90.14 90.14 0 0017.15 6.53c6 1.64 15.87 4.09 29.53 7.12 17.38 3.62 33.25 7.82 47.26 12.13 14.24 4.55 26.49 10 36.52 16.45a72.93 72.93 0 0124.16 25.09c5.72 10 8.64 22.63 8.64 37.1A75.09 75.09 0 01368 359z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7ac4d60b9c1ecdf3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M126.12 315.1A47.06 47.06 0 1179.06 268h47.06zm23.72 0a47.06 47.06 0 0194.12 0v117.84a47.06 47.06 0 11-94.12 0zm47.06-188.98A47.06 47.06 0 11244 79.06v47.06zm0 23.72a47.06 47.06 0 010 94.12H79.06a47.06 47.06 0 010-94.12zm188.98 47.06a47.06 47.06 0 1147.06 47.1h-47.06zm-23.72 0a47.06 47.06 0 01-94.12 0V79.06a47.06 47.06 0 1194.12 0zM315.1 385.88a47.06 47.06 0 11-47.1 47.06v-47.06zm0-23.72a47.06 47.06 0 010-94.12h117.84a47.06 47.06 0 110 94.12z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b63180f382b71564(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 347.21a190.31 190.31 0 01-32.79-5.31c-27.28-6.63-54.84-24.26-68.12-52.43-6.9-14.63-2.64-18.59 11.86-24 14.18-5.27 29.8-7.72 36.86-23 5.89-12.76 1.13-27.76-10.41-35.49-15.71-10.53-30.35-.21-46.62 2.07 3.73-46.66 8.66-88.57-22.67-127.73C338.14 48.86 297.34 32 256.29 32s-81.86 16.86-107.81 49.33c-31.38 39.26-26.4 81.18-22.67 127.92-16.32-2.25-30.81-12.79-46.63-2.18-14.72 9.85-17 29.76-5.44 43s31.64 9.5 43.45 20.6c6.49 6.09 3.49 12.61-.35 20.14-14.48 28.4-39.26 45.74-69.84 51.56-4 .76-22.31 2.87-31 3.65 0 9.28.52 16.78 1.63 21.73 2.94 13.06 12.32 23.58 23.69 30.1 11.18 6.4 35.48 6.43 41.68 15.51 3 4.48 1.76 12.28 5.33 17.38a23.8 23.8 0 0015.37 9.75c18.61 3.61 37.32-7.2 56.42-2.1 14.85 3.95 26.52 15.87 39.26 24 15.51 9.85 32.34 16.42 50.83 17.49 38.1 2.21 59.93-18.91 90.58-36.42 19.5-11.14 38.15-3.86 58.88-2.68 20.1 1.15 23.53-9.25 29.62-24.88a27.37 27.37 0 001.54-4.85 10.52 10.52 0 002.28-1.47c2-1.57 10.55-2.34 12.76-2.86 10.28-2.44 20.34-5.15 29.17-11.2 11.31-7.76 17.65-18.5 19.58-32.64a93.73 93.73 0 001.38-15.67zM208 128c8.84 0 16 10.74 16 24s-7.16 24-16 24-16-10.74-16-24 7.16-24 16-24zm103.62 77.7c-15.25 15-35 23.3-55.62 23.3a78.37 78.37 0 01-55.66-23.34 8 8 0 0111.32-11.32A62.46 62.46 0 00256 213c16.39 0 32.15-6.64 44.39-18.7a8 8 0 0111.23 11.4zM304 176c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$48ce8e0ee0700aad(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.8 278a2.11 2.11 0 00-2 2L0 308.64l3.74 28.16a2.12 2.12 0 002.05 2 2.14 2.14 0 002-2l4.44-28.17L7.83 280a2.14 2.14 0 00-2-2zm21.05-15.68a2.13 2.13 0 00-4.26 0l-5 46.32 5 45.3a2.13 2.13 0 004.26 0l5.73-45.31-5.73-46.32zm79.32-42.73a4 4 0 00-3.87 3.87l-4 85.22 4 55.08a3.88 3.88 0 007.75 0l4.53-55.08-4.53-85.22a4 4 0 00-3.88-3.87zm-41.05 29.62a3.09 3.09 0 00-3 3l-4.52 56.45 4.51 54.63a3 3 0 006 0l5.13-54.63-5.13-56.48a3.1 3.1 0 00-2.99-2.97zm82.76 118.39a4.83 4.83 0 004.75-4.74l3.93-54.15-3.93-113.46a4.75 4.75 0 00-9.5 0l-3.49 113.45 3.49 54.17a4.81 4.81 0 004.75 4.73zm85.4.25a6.6 6.6 0 006.5-6.52l2.74-52.6-2.74-131a6.5 6.5 0 10-13 0l-2.45 131c0 .08 2.45 52.67 2.45 52.67a6.59 6.59 0 006.5 6.45zm-43.02-.2a5.67 5.67 0 005.62-5.64l3.34-53.33-3.34-114.28a5.63 5.63 0 10-11.25 0l-3 114.29 3 53.32a5.66 5.66 0 005.63 5.6zm-104.7-.5a3.53 3.53 0 003.44-3.41l4.83-55.09-4.83-52.4a3.44 3.44 0 00-6.88 0l-4.26 52.38 4.26 55.08a3.5 3.5 0 003.44 3.44zm-40.72-3.02a2.67 2.67 0 002.57-2.52l5.43-53-5.42-55a2.57 2.57 0 00-5.14 0l-4.78 55 4.78 53a2.62 2.62 0 002.56 2.53zm166.85-171.6a6.1 6.1 0 00-6.07 6.09l-2.71 110.11 2.71 53a6.07 6.07 0 0012.13 0l3-53-3-110.13a6.1 6.1 0 00-6.06-6.07zM127 367.71a4.41 4.41 0 004.31-4.3l4.23-54.71-4.28-104.7a4.32 4.32 0 00-8.63 0l-3.74 104.7 3.75 54.73a4.38 4.38 0 004.36 4.28zm47.17-5.17l3.63-53.8-3.63-117.28a5.19 5.19 0 10-10.37 0l-3.23 117.28 3.23 53.83a5.18 5.18 0 0010.36 0zM449 241.1a62.42 62.42 0 00-24.33 4.9c-5-57.18-52.61-102-110.66-102a111.92 111.92 0 00-40.28 7.58c-4.75 1.85-6 3.76-6.06 7.46V360.4a7.66 7.66 0 006.8 7.5l174.56.11c34.78 0 63-28.41 63-63.45s-28.2-63.46-63-63.46zm-194.21-82.23a7 7 0 00-6.94 7L245 308.75l2.85 51.87a6.94 6.94 0 1013.87-.06v.06l3.09-51.87-3.09-142.93a7 7 0 00-6.93-6.95z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$93910f036d144851(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 440V320h40v160H64V320h40v120z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M149.1 308.77l198.57 40.87 8.4-39.32-198.57-40.87zm26.27-93.12L359.22 300 376 263.76l-183.82-84.84zm50.95-89l156 127.78 25.74-30.52-156-127.78zM328 32l-33.39 23.8 120.82 160.37L448 192zM144 400h204v-40H144z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4461844b170180e0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M478.8 208.2a36 36 0 11-36-36 36 36 0 0136 36zM442.6 139a69.42 69.42 0 00-69.4 68.7l-43.2 62a48.86 48.86 0 00-5.4-.3 51.27 51.27 0 00-26.4 7.3L102.4 198a51.8 51.8 0 10-50.6 62.9 51.27 51.27 0 0026.4-7.3L274 332.2a51.76 51.76 0 00102.1-5.9l66.5-48.6a69.35 69.35 0 100-138.7zm0 22.9a46.45 46.45 0 11-46.5 46.5 46.54 46.54 0 0146.5-46.5zm-390.8 9a38.18 38.18 0 0133.7 20.2l-18.9-7.6v.1a30.21 30.21 0 00-22.6 56v.1l16.1 6.4a36.8 36.8 0 01-8.2.9 38.05 38.05 0 01-.1-76.1zm272.8 112.2a38.1 38.1 0 11-33.7 55.9c6.3 2.5 12.5 5 18.8 7.6a30.27 30.27 0 1022.5-56.2l-15.9-6.4a46.83 46.83 0 018.3-.9z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3a2c5c8779b66bc2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M188.8 334.07h197.33L279.47 448H83.2zM512 199H106.61L0 313h405.39zM232.2 64h196.6L322.62 177.93H125.87z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$19dac9dab57dd19a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M242.69 340.3h26.62v-72.6h67v-25.82h-67v-72.6h-26.62v72.6h-66.15v25.82h66.15zM119.26 445.18h22.59v-64.54h59.7v-20.17h-59.7v-65.34h-22.59v65.34h-59.7v20.17h59.7zM370.15 212h22.59v-64.5h60.5v-19.37h-60.5V62.79h-22.59v65.34h-59.7v19.37h59.7zM246.72 496h19.36v-46h41.15v-16.92h-41.15v-46h-19.36v46h-40.33V450h40.33zM120.07 212h21v-65.31h60.51v-18.56H141V62.79h-21v65.34H59.56v18.56h60.51zm315.65 96.84h19.36v-45.18H496v-17.74h-40.92v-45.18h-19.36v45.18h-40.33v17.74h40.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M370.15 445.18h22.59v-64.54h60.5v-20.17h-60.5v-65.34h-22.59v65.34h-59.7v20.17h59.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M307 74.08V60.37h-40.34V16h-14.52v44.37h-40.33v13.71h40.33v44.37h14.52V74.08zM56.11 305.61h14.52v-44.37H111v-13.71H70.63V204H56.11v43.56H16v14.52l40.11-.08z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f2554f180a7c55e7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M412.19 118.66a109.27 109.27 0 01-9.45-5.5 132.87 132.87 0 01-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14 23.9 350 16 350.13 16h-82.44v318.78c0 4.28 0 8.51-.18 12.69 0 .52-.05 1-.08 1.56 0 .23 0 .47-.05.71v.18a70 70 0 01-35.22 55.56 68.8 68.8 0 01-34.11 9c-38.41 0-69.54-31.32-69.54-70s31.13-70 69.54-70a68.9 68.9 0 0121.41 3.39l.1-83.94a153.14 153.14 0 00-118 34.52 161.79 161.79 0 00-35.3 43.53c-3.48 6-16.61 30.11-18.2 69.24-1 22.21 5.67 45.22 8.85 54.73v.2c2 5.6 9.75 24.71 22.38 40.82A167.53 167.53 0 00115 470.66v-.2l.2.2c39.91 27.12 84.16 25.34 84.16 25.34 7.66-.31 33.32 0 62.46-13.81 32.32-15.31 50.72-38.12 50.72-38.12a158.46 158.46 0 0027.64-45.93c7.46-19.61 9.95-43.13 9.95-52.53V176.49c1 .6 14.32 9.41 14.32 9.41s19.19 12.3 49.13 20.31c21.48 5.7 50.42 6.9 50.42 6.9v-81.84c-10.14 1.1-30.73-2.1-51.81-12.61z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$558dcf0e30ef84ef(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M390 32H120c-49.19 0-88 38.81-88 88v270c0 49.19 38.81 90 88 90h270c49.19 0 90-40.81 90-90V120c0-49.19-40.81-88-90-88zm-54 364h-52c-42.51 0-72-23.68-72-76v-80h-36v-48c42.51-11 57.95-48.32 60-80h44v72h52v56h-52l-.39 70.51c0 21.87 11 29.43 28.62 29.43L336 340z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4aa854017e2bdfbe(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.66 405.05c-1.46-.79-2.85-1.54-4-2.2-6.47-3.83-13-10.52-11.85-17.83 2.42-15.94 2.89-23.47-.49-28.79a15.61 15.61 0 00-7.67-6.2v-.06c1.41-2.56 2.26-5.66 2.83-10.12 1.44-11-5-44-13.7-70.7-8.08-24.68-29.24-50-44.7-68.56l-3.61-4.34c-23.88-28.93-24.34-38.19-26.55-82.67-.32-6.47-.69-13.8-1.17-22C329.87 41.43 304 16 256 16c-25.2 0-44.62 7.15-57.72 21.26C187.79 48.55 182 64 182 80.78c0 29.52 2 53 2.15 54.29 1.4 35.7 1 41.22-8.31 57.55-2.23 3.93-8.38 10.87-14.89 18.21-8.48 9.57-18.09 20.41-23.36 29.22-3.77 6.31-5.88 12.63-8.11 19.33-3.4 10.21-7.26 21.78-18.15 36.57-12.57 17.07-15.52 29.61-11 47.45-4.94 6.45-4.83 14.37-4.75 20.23a25.84 25.84 0 01-.3 6.09c-2.29 7.59-12.42 9.4-22 10.18-1.58.12-3.1.21-4.55.29-7.26.39-13.53.74-17.13 6.3-3.47 5.36-1.12 13.8 2.14 25.48.72 2.58 1.46 5.25 2.19 8.06 1.83 7-.16 10.48-2.68 14.84-2.44 4.21-5.21 9-5.21 17.55 0 14.67 20 18 43.05 21.94 7.36 1.24 15 2.53 22.63 4.24a225.58 225.58 0 0134.08 10.68c9.72 3.73 17.4 6.68 26.43 6.68 16.18 0 28.25-9.77 39.92-19.21l2.15-1.75c5.53-4.49 21.5-4 34.34-3.64 3.46.1 6.73.2 9.65.2h6.22c13.48-.08 31.94-.18 42.23 2.5 3.75 1 6.2 3.72 9.29 7.19 5.87 6.56 13.17 14.75 33.39 14.75 19.39 0 29.55-8.71 41.32-18.8 7.16-6.13 14.56-12.48 25.07-17.86 3.92-2 7.62-3.87 11.08-5.61 22.64-11.38 35.11-17.65 35.11-27.82 0-9.91-12.24-16.5-20.34-20.86zM211.11 88.38a13.91 13.91 0 0112.47 9c1.95 5.55 1.81 10.42.21 12.94 0 0-.22-1-.36-1.44a14.85 14.85 0 00-6.44-8.59 11.35 11.35 0 00-8.94-1.47c-4.26 1.13-8.41 5-8.91 18.79-5.16-10.47-2.31-18 .92-23 2.31-3.73 7.47-6.33 11.05-6.23zm-17.5 375C192 479.24 175.2 479 170.09 478.59c-9.81-.82-21.66-4.69-33.13-8.43-4.52-1.47-9.19-3-13.73-4.34-13.2-3.89-30.12-6.74-43.72-9-3.22-.55-6.27-1.06-9.05-1.55s-4.61-1.27-5.2-2.3c-1-1.65.38-5.25 1.93-9.41C69.27 438 72.11 430.34 72 421c0-3.91-1.47-8.3-2.84-12.56-1.62-5-3.28-10.17-1.93-12.62 1.23-2.23 6.75-2.49 11.6-2.49h2.26c3.55 0 6.62.06 8.75-.53 6.51-1.81 14.86-6.92 17.81-13.88.9-2.17 1.37-6.94 2-14 .37-4.12.74-8.37 1.22-10.58a3.55 3.55 0 012.11-2.55c1.65-.77 6.78-1.91 18.63 4.08 11.18 5.65 22.88 25.84 34.2 45.37 3.56 6.14 6.92 11.94 10.3 17.36 14.04 22.54 18.83 31.6 17.5 44.8zm128.84-31.56a68.74 68.74 0 01-4.55 10.9.58.58 0 01-1.08-.42 56.61 56.61 0 002.11-18.43c-.25-4.73-.4-7.59-2.66-8.51s-4.26.83-9.45 5.54c-1.1 1-2.36 2.14-3.78 3.4-10.8 9.47-26.88 20.68-55.61 23.37-16.84 1.59-27.59-4.63-30.92-8.14a2.16 2.16 0 00-3.07-.08 2.23 2.23 0 00-.51 2.29c2.12 6.84 1.2 12.26-.49 16.19-.95 2.2-1.85 2.05-2-.34-.25-4.64-1-9.88-3-14.19-3.11-6.94-7-14.34-8.89-17.88v-.05c3.24-1.49 8.86-4.83 11.37-10.88s4.48-18-9.82-31.74c-6.28-6.05-22.1-17.16-36.06-27-10.9-7.65-22.17-15.56-23.65-17.51-4.49-5.89-6.37-9.3-6.94-19.65.07-2.3.13-4.59.19-6.89l.27-2.49a.58.58 0 011.15 0 63.07 63.07 0 002 9.72c1.08 3.73 2.4 7.58 3.62 9.18 3.19 4.22 7.56 7.39 11.67 8.49a5.48 5.48 0 005-.72c2.93-2.33 2.65-7.6 2.19-16.34-.47-9-1.11-21.34 1.85-34.55 5.62-25 10.91-32.51 17.61-42 .86-1.22 1.75-2.47 2.65-3.79 1.44-2.08 3-4.1 4.67-6.23 7.47-9.61 15.93-20.49 13.92-40.95-.51-5.19-.76-8.83-.86-11.39a1 1 0 011.88-.59l.49.77 1.21 2c4.86 8 13.64 22.57 25.1 22.57a13.62 13.62 0 002.36-.21c23.39-3.93 51.9-30.25 52.17-30.51 3.12-3 2.84-6.14 1.64-7.91a5.18 5.18 0 00-6.45-1.72c-3.29 1.4-7.14 3.15-11.22 5-13.82 6.27-37 16.75-42.25 14.34a23.11 23.11 0 01-6.32-5.13 1 1 0 011.14-1.65c5.59 2.29 9.55 1.45 14.2-.08l1-.34c9.37-3.09 14.2-4.77 30.76-12.08a97.55 97.55 0 0116.26-5.93c4-1 6.42-1.63 7.71-4.34a6.65 6.65 0 00-.5-7.13c-1.53-1.87-4.07-2.57-7-1.9-3.22.75-4.7 3-6.41 4.49-2.4 2.05-5 4.16-17.19 8.65-27 10-34.58 10.61-45.21 3.43-9.84-6.69-15.15-13.23-15.15-16 0-2.13 5.45-5.7 8.71-7.84 1.33-.87 2.59-1.69 3.62-2.46 4.34-3.22 13-11.39 13.38-11.73 5.4-5.41 17.91-2.18 25 2.58a2.23 2.23 0 001.72.41 2.14 2.14 0 001.68-2.58c-4.2-17.46-.13-27.34 4-32.55a22.58 22.58 0 0117.48-8.48c12.81 0 21.76 10 21.76 24.42 0 11-2.82 16.79-5.48 20.3a1.73 1.73 0 01-2.58.18 1.78 1.78 0 01-.24-2.2A24.61 24.61 0 00290 114a16.58 16.58 0 00-16.84-16.67c-3.94 0-13.48 1.5-16.77 15.44a29.81 29.81 0 00-.34 11.07l.08.71c.9 7.38 15.3 12.51 27.23 15.51 11.36 2.85 13 6.22 8.84 19.63s3.11 26.23 5.7 29.57a78.3 78.3 0 018.31 12.47 93.8 93.8 0 016.62 16.48c2.17 6.79 4.05 12.65 10.63 21.22 11.07 14.4 17.66 48.64 15 78-.21 2.41-.53 4.29-.77 5.67-.43 2.53-.72 4.2.66 5.38s3.16.7 7.26-.63l3.43-1.09a109.33 109.33 0 0112.58-2.8 2.15 2.15 0 001.59-1.16c3.43-6.91 3.85-15.22 4-22.47q0-1.31.06-2.79c.19-7.77.45-18.93-2.95-32a1 1 0 011.93-.64 93 93 0 016.66 25.55c2.55 22.58-1.9 32.09-1.94 32.17a1.61 1.61 0 00.95 2.25 17.12 17.12 0 016.95 4.67c1.46 1.66.93 2.4-1.14 1.62a36.26 36.26 0 00-12.77-2.29c-10.4 0-18.09 4.95-21.51 9.19-3.19 3.94-3.7 7.67-3.83 11.27l-.06.05c-7.48-.75-12.94 1.21-17.47 6.21l-.08.09c-6.26 7.75-4 24.63-1.29 38.48 1.28 6.45 5.59 25.52 1.73 37.68zm96.1 10.07c-15.71 6.71-25.43 14.51-34 21.39-5.65 4.53-11 8.81-17.28 12.14-10.12 5.34-24.91 6.53-33.27-7.7-2.37-4-.71-9.86 1.58-17.95 3.05-10.75 7.23-25.46 3.71-44.65-.94-5.12-1.77-9.51-2.49-13.31C334 377 332.9 371.43 334 367c.63-2.45 3.43-3 5.87-3a20.83 20.83 0 012.63.19 29.51 29.51 0 007 12.1c5.7 5.86 13.63 8.83 23.56 8.85 2.1.17 25.94 1.55 36.54-22.4 1.46.18 3.65.7 4.3 2.3 1.28 3.19-.27 8.91-1.52 13.5-.9 3.31-1.68 6.16-1.63 8.37.31 16 11 22.78 25.83 32.16 1.79 1.13 3.66 2.31 5.55 3.54S445 425 445 426c-.52 4.79-20 13.16-26.45 15.91z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$97cb255cb3b6888(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 32l-32 80v304h96v64h64l64-64h80l112-112V32zm336 256l-64 64h-96l-64 64v-64h-80V80h304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 143h48v129h-48zm-112 0h48v129h-48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3e46829c865c9693(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 109.5a201.8 201.8 0 01-56.55 15.3 97.51 97.51 0 0043.33-53.6 197.74 197.74 0 01-62.56 23.5A99.14 99.14 0 00348.31 64c-54.42 0-98.46 43.4-98.46 96.9a93.21 93.21 0 002.54 22.1 280.7 280.7 0 01-203-101.3A95.69 95.69 0 0036 130.4c0 33.6 17.53 63.3 44 80.7A97.5 97.5 0 0135.22 199v1.2c0 47 34 86.1 79 95a100.76 100.76 0 01-25.94 3.4 94.38 94.38 0 01-18.51-1.8c12.51 38.5 48.92 66.5 92.05 67.3A199.59 199.59 0 0139.5 405.6a203 203 0 01-23.5-1.4A278.68 278.68 0 00166.74 448c181.36 0 280.44-147.7 280.44-275.8 0-4.2-.11-8.4-.31-12.5A198.48 198.48 0 00496 109.5z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fc9990461b40280f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 480v-36.42C160.53 439 112.25 398.06 112 336h72c1.77 26.34 23.86 46.45 56 50v-98l-26.77-7c-61-14.18-93.64-49.39-93.64-102.08C119.59 116.81 164.08 76.08 240 70V32h32v38c77.39 6.3 119 47.74 120 106h-72c-.76-24.06-15.83-43.39-48-46v92l30.82 7.28C367.61 243.46 400 277 400 332c0 64.34-43.74 105.88-128 111.32V480zm0-264v-86c-27.59 1.52-47.27 18.47-47.27 42.53 0 22.3 16.39 36.88 47.27 43.47zm32 78v92c38.15-1.54 56.38-18.92 56.38-45.77 0-24.58-18.23-41.13-56.38-46.23z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$91c70c3658543f37(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.17 32H70.28C49.85 32 32 46.7 32 66.89V441.6c0 20.31 17.85 38.4 38.28 38.4h373.78c20.54 0 35.94-18.2 35.94-38.39V66.89C480.12 46.7 464.6 32 444.17 32zM278 387H174.32l-41.57-248.56 90.75-8.62 22 176.87c20.53-33.45 45.88-86 45.88-121.87 0-19.62-3.36-33-8.61-44l82.63-16.72c9.56 15.78 13.86 32 13.86 52.57-.01 65.5-55.92 150.59-101.26 210.33z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5516e94dc3988525(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M256 48l240 416H16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8cabedc172d98761(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.9 114c-5-23.39-17.51-38.78-40.61-46.27s-64.92-4.5-94.12 16.79c-26.79 19.51-46.26 54.42-54 78.28a4 4 0 005.13 5c10.77-3.8 21.72-7.1 34-6.45 15 .8 24.51 12 24.91 25.29.3 9.79-.2 18.69-3.6 27.68-10.74 28.68-27.61 56.46-47.55 80.75a72.49 72.49 0 01-10 9.89c-10.21 8.29-18.81 6.1-25.41-5.2-5.4-9.29-9-18.88-12.2-29.08-12.4-39.67-16.81-80.84-23.81-121.52-3.3-19.48-7-39.77-18-56.86-11.6-17.79-28.61-24.58-50-22-14.7 1.8-36.91 17.49-47.81 26.39 0 0-56 46.87-81.82 71.35l21.2 27s17.91-12.49 27.51-18.29c5.7-3.39 12.4-4.09 17.2.2 4.51 3.9 9.61 9 12.31 14.1 5.7 10.69 11.2 21.88 14.7 33.37 13.2 44.27 25.51 88.64 37.81 133.22 6.3 22.78 13.9 44.17 28 63.55 19.31 26.59 39.61 32.68 70.92 21.49 25.41-9.09 46.61-26.18 66-43.87 33.11-30.18 59.12-65.36 85.52-101.14 20.41-27.67 37.31-55.67 51.41-86.95C478.5 179.74 484 147.26 476.9 114z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3427b098c64e911e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M484.7 132c3.56-11.28 0-19.48-15.75-19.48h-52.37c-13.21 0-19.31 7.18-22.87 14.86 0 0-26.94 65.6-64.56 108.13-12.2 12.3-17.79 16.4-24.4 16.4-3.56 0-8.14-4.1-8.14-15.37V131.47c0-13.32-4.06-19.47-15.25-19.47H199c-8.14 0-13.22 6.15-13.22 12.3 0 12.81 18.81 15.89 20.84 51.76V254c0 16.91-3 20-9.66 20-17.79 0-61-66.11-86.92-141.44C105 117.64 99.88 112 86.66 112H33.79C18.54 112 16 119.17 16 126.86c0 13.84 17.79 83.53 82.86 175.77 43.21 63 104.72 96.86 160.13 96.86 33.56 0 37.62-7.69 37.62-20.5v-47.66c0-15.37 3.05-17.93 13.73-17.93 7.62 0 21.35 4.09 52.36 34.33C398.28 383.6 404.38 400 424.21 400h52.36c15.25 0 22.37-7.69 18.3-22.55-4.57-14.86-21.86-36.38-44.23-62-12.2-14.34-30.5-30.23-36.09-37.92-7.62-10.25-5.59-14.35 0-23.57-.51 0 63.55-91.22 70.15-122"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b8c0f8d30c6135f1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 144.03l-55.49-96.11h-79.43L256 281.61 390.92 47.92h-79.43L256 144.03z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M409.4 47.92L256 313.61 102.6 47.92H15.74L256 464.08 496.26 47.92H409.4z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6ca593801781d412(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M179.9 388l-76.16-132 76.16 132zm0 0h152.21l76.15-132-76.15-132H179.9l-76.16 132 76.16 132zm-76.16-132l76.16-132-76.16 132z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256L376 48H239.74l-43.84 76h136.21l76.15 132-76.15 132H195.9l43.84 76H376l120-208z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M179.9 388l-76.16-132 76.16-132 43.84-76H136L16 256l120 208h87.74l-43.84-76z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cfd657f7c5929e32(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408.67 298.53a21 21 0 1120.9-21 20.85 20.85 0 01-20.9 21m-102.17 0a21 21 0 1120.9-21 20.84 20.84 0 01-20.9 21m152.09 118.86C491.1 394.08 512 359.13 512 319.51c0-71.08-68.5-129.35-154.41-129.35s-154.42 58.27-154.42 129.35 68.5 129.34 154.42 129.34c17.41 0 34.83-2.33 49.92-7 2.49-.86 3.48-1.17 4.64-1.17a16.67 16.67 0 018.13 2.34L454 462.83a11.62 11.62 0 003.48 1.17 5 5 0 004.65-4.66 14.27 14.27 0 00-.77-3.86c-.41-1.46-5-16-7.36-25.27a18.94 18.94 0 01-.33-3.47 11.4 11.4 0 015-9.35"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M246.13 178.51a24.47 24.47 0 010-48.94c12.77 0 24.38 11.65 24.38 24.47 1.16 12.82-10.45 24.47-24.38 24.47m-123.06 0A24.47 24.47 0 11147.45 154a24.57 24.57 0 01-24.38 24.47M184.6 48C82.43 48 0 116.75 0 203c0 46.61 24.38 88.56 63.85 116.53C67.34 321.84 68 327 68 329a11.38 11.38 0 01-.66 4.49C63.85 345.14 59.4 364 59.21 365s-1.16 3.5-1.16 4.66a5.49 5.49 0 005.8 5.83 7.15 7.15 0 003.49-1.17L108 351c3.49-2.33 5.81-2.33 9.29-2.33a16.33 16.33 0 015.81 1.16c18.57 5.83 39.47 8.16 60.37 8.16h10.45a133.24 133.24 0 01-5.81-38.45c0-78.08 75.47-141 168.35-141h10.45C354.1 105.1 277.48 48 184.6 48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ec07f464b7ae7ad6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M414.73 97.1A222.14 222.14 0 00256.94 32C134 32 33.92 131.58 33.87 254a220.61 220.61 0 0029.78 111L32 480l118.25-30.87a223.63 223.63 0 00106.6 27h.09c122.93 0 223-99.59 223.06-222A220.18 220.18 0 00414.73 97.1zM256.94 438.66h-.08a185.75 185.75 0 01-94.36-25.72l-6.77-4-70.17 18.32 18.73-68.09-4.41-7A183.46 183.46 0 0171.53 254c0-101.73 83.21-184.5 185.48-184.5a185 185 0 01185.33 184.64c-.04 101.74-83.21 184.52-185.4 184.52zm101.69-138.19c-5.57-2.78-33-16.2-38.08-18.05s-8.83-2.78-12.54 2.78-14.4 18-17.65 21.75-6.5 4.16-12.07 1.38-23.54-8.63-44.83-27.53c-16.57-14.71-27.75-32.87-31-38.42s-.35-8.56 2.44-11.32c2.51-2.49 5.57-6.48 8.36-9.72s3.72-5.56 5.57-9.26.93-6.94-.46-9.71-12.54-30.08-17.18-41.19c-4.53-10.82-9.12-9.35-12.54-9.52-3.25-.16-7-.2-10.69-.2a20.53 20.53 0 00-14.86 6.94c-5.11 5.56-19.51 19-19.51 46.28s20 53.68 22.76 57.38 39.3 59.73 95.21 83.76a323.11 323.11 0 0031.78 11.68c13.35 4.22 25.5 3.63 35.1 2.2 10.71-1.59 33-13.42 37.63-26.38s4.64-24.06 3.25-26.37-5.11-3.71-10.69-6.48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a1c4ca3296935e1e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 265H232v179l248 36V265zm-264 0H32v150l184 26.7V265zM480 32L232 67.4V249h248V32zM216 69.7L32 96v153h184V69.7z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bb8457de5b6fe74d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M259 271.3L226.2 367h-.1l-25.4 73.1c1.8.5 3.5.9 5.3 1.4h.3a192.51 192.51 0 0049.5 6.5 157 157 0 0024.9-1.8 184.3 184.3 0 0032.5-7.1c2.6-.8 5.2-1.7 7.8-2.6-2.8-6-8.8-19.3-9.1-19.9zM80.8 180.5C70.8 203.1 64 230.9 64 256c0 6.3.3 12.6.9 18.8 6.9 71.2 52.9 131 116.1 157.9 2.6 1.1 5.3 2.2 8 3.2L96 180.6c-8-.3-9.5.2-15.2-.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M430.2 175.4a188 188 0 00-15.1-26.6c-1.6-2.4-3.4-4.8-5.1-7.2A193 193 0 00325.1 77a189.2 189.2 0 00-69.2-13 191.51 191.51 0 00-149.4 71.7A196 196 0 0089 161.3c14.2.1 31.8.1 33.8.1 18.1 0 46-2.2 46-2.2 9.4-.6 10.4 13.1 1.1 14.2 0 0-9.4 1.1-19.8 1.6L213 362l37.8-113.3-26.8-73.6c-9.4-.5-18.1-1.6-18.1-1.6-9.4-.5-8.2-14.8 1-14.2 0 0 28.5 2.2 45.5 2.2 18.1 0 46-2.2 46-2.2 9.3-.6 10.5 13.1 1.1 14.2 0 0-9.3 1.1-19.7 1.6l62.3 185.6 17.3-57.6c8.7-22.4 13.1-40.9 13.1-55.7 0-21.3-7.7-36.1-14.3-47.6-8.7-14.3-16.9-26.3-16.9-40.4 0-15.9 12-30.7 29-30.7h2.2c26.2-.7 34.8 25.3 35.9 43v.6c.4 7.2.1 12.5.1 18.8 0 17.4-3.3 37.1-13.1 61.8l-39 112.8-22.3 65.7c1.8-.8 3.5-1.6 5.3-2.5 56.7-27.4 98-82 106.7-146.7a172.07 172.07 0 001.9-26 191.11 191.11 0 00-17.8-80.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208.06 208.06 0 0181 399.66A208.06 208.06 0 01175 64.34 206.7 206.7 0 01256 48m0-16C132.29 32 32 132.29 32 256s100.29 224 224 224 224-100.29 224-224S379.71 32 256 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9c9cae6cb30bd03c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M126.8 248.3c39.7-58.6 77.9-92.8 77.9-92.8s-42.1-48.9-92.8-67.4l-3.3-.8A224.13 224.13 0 0077.2 391c0-4.4.6-70.3 49.6-142.7zM480 256a223.71 223.71 0 00-76.6-168.7l-3.2.9c-50.7 18.5-92.9 67.4-92.9 67.4s38.2 34.2 77.9 92.8c49 72.4 49.6 138.3 49.5 142.7A222.8 222.8 0 00480 256zM201.2 80.9c29.3 13.1 54.6 34.6 54.6 34.6s25.5-21.4 54.8-34.6c36.8-16.5 64.9-11.3 72.3-9.5a224.06 224.06 0 00-253.8 0c7.2-1.8 35.2-7.1 72.1 9.5zm157.5 212C312.4 236 255.8 199 255.8 199s-56.3 37-102.7 93.9c-39.8 48.9-54.6 84.8-62.6 107.8l-1.3 4.8a224 224 0 00333.6 0l-1.4-4.8c-8-23-22.9-58.9-62.7-107.8z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$172b760cfa5285b7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.8 303.9L469 32H365L209.4 303.8a1.35 1.35 0 000 1.7l98.9 173.8c.4.7.8.7 1.6.7H413l-99.3-174.7a1.74 1.74 0 01.1-1.4zm-91.9-87.7L163 113a2 2 0 00-2-1H65l58.9 104.4a1.13 1.13 0 01.1.8L43 352h96.8a1.54 1.54 0 001.6-.9l80.5-133.7a2.44 2.44 0 000-1.2z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$378928a96efaf039(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M410.32 37.13c-13.56 0-27-.93-39.12-5.13L256 218.67 140.8 32c-12.12 4.2-24.84 5.13-38.4 5.13-13.32 0-26.52-1.05-38.4-5.13l153.6 248.15V480c12-4.08 25-5.13 38.4-5.13s26.4 1.05 38.4 5.13V280.5L448 32c-11.88 4-24.36 5.13-37.68 5.13z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f02fd0c1f300ad42(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32h-80L256 253.13 144 32H64l112.37 208H128v48h73.56L216 319v17h-88v48h88v96h80v-96h88v-48h-88v-17l14.89-31H384v-48h-48.29z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e9a29303940b49e7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M508.64 148.79c0-45-33.1-81.2-74-81.2C379.24 65 322.74 64 265 64h-18c-57.6 0-114.2 1-169.6 3.6C36.6 67.6 3.5 104 3.5 149 1 184.59-.06 220.19 0 255.79q-.15 53.4 3.4 106.9c0 45 33.1 81.5 73.9 81.5 58.2 2.7 117.9 3.9 178.6 3.8q91.2.3 178.6-3.8c40.9 0 74-36.5 74-81.5 2.4-35.7 3.5-71.3 3.4-107q.34-53.4-3.26-106.9zM207 353.89v-196.5l145 98.2z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ec1224cc4e949b3b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M421.83 293.82A144 144 0 00218.18 90.17m135.76 135.77a48 48 0 00-67.88-67.88"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M192 464v-48m-101.82 5.82l33.94-33.94M48 320h48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M286.06 158.06L172.92 271.19a32 32 0 01-45.25 0L105 248.57a32 32 0 010-45.26L218.18 90.17m203.65 203.65L308.69 407a32 32 0 01-45.26 0l-22.62-22.63a32 32 0 010-45.26l113.13-113.17M139.6 169.98l67.88 67.89m67.88 67.88l67.89 67.88"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$996145fd567c1a8b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M191.98 463.58v-48M90.16 421.4l33.94-33.94m-76.12-67.88h48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M422.2 89.82a144 144 0 00-203.71-.07l-67.88 67.88 67.88 67.89 67.88-67.89a48 48 0 0168.46.59c18.3 18.92 17.48 49.24-1.14 67.86l-67.32 67.32 67.88 67.88 66.91-66.91c56.37-56.37 57.37-148.15 1.04-204.55zM82.718 225.517l45.255-45.254 67.883 67.882L150.6 293.4zM218.49 361.27l45.254-45.254 67.882 67.882-45.255 45.255z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7df8ebaec3768cf4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M191.98 463.79v-48m-101.82 5.82l33.94-33.94m-76.12-67.88h48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M267.56 312.32l-31.11 31.11a16 16 0 000 22.63l45.26 45.25a16 16 0 0022.62 0l31.12-31.11a4 4 0 000-5.66l-62.23-62.22a4 4 0 00-5.66 0zM131.8 176.55l-31.11 31.12a16 16 0 000 22.62l45.25 45.26a16 16 0 0022.63 0l31.11-31.11a4 4 0 000-5.66l-62.22-62.23a4 4 0 00-5.66 0zm297.05-93.27a144 144 0 00-203.71-.06l-65.06 65.05a4 4 0 000 5.66l62.23 62.22a4 4 0 005.66 0l65-65.05a48 48 0 0168.46.59c18.3 18.92 17.47 49.24-1.14 67.85L295.85 284a4 4 0 000 5.66l62.22 62.23a4 4 0 005.66 0l64.08-64.08c56.37-56.34 57.37-148.13 1.04-204.53z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7e0ac348d99f21d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M441.6 171.61L266.87 85.37a24.57 24.57 0 00-21.74 0L70.4 171.61A40 40 0 0048 207.39V392c0 22.09 18.14 40 40.52 40h335c22.38 0 40.52-17.91 40.52-40V207.39a40 40 0 00-22.44-35.78z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M397.33 368L268.07 267.46a24 24 0 00-29.47 0L109.33 368m200-73l136-103m-384 0l139 105"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8555e072f825a77c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.05 168.36L263.24 65.69a16.37 16.37 0 00-14.48 0L41 168.36a16 16 0 00-9 14.31V432a16.09 16.09 0 0016.19 16h415.62A16.09 16.09 0 00480 432V182.67a16 16 0 00-8.95-14.31zM256 97.89l173 85.44-175.7 86.78-173-85.44z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f3a776052c617cfa(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448.67 154.45L274.1 68.2a41.1 41.1 0 00-36.2 0L63.33 154.45A55.6 55.6 0 0032 204.53v184.61c0 30.88 25.42 56 56.67 56h334.66c31.25 0 56.67-25.12 56.67-56V204.53a55.6 55.6 0 00-31.33-50.08zM252.38 96.82a8.22 8.22 0 017.24 0L429 180.48l-172 85a8.22 8.22 0 01-7.24 0L80.35 181.81z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ef9d88fb78ee0f4c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "320",
                    "x": "48",
                    "y": "96",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 160l144 112 144-112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2ca05c80b4d77db(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 80H48a16 16 0 00-16 16v320a16 16 0 0016 16h416a16 16 0 0016-16V96a16 16 0 00-16-16zM265.82 284.63a16 16 0 01-19.64 0L89.55 162.81l19.64-25.26L256 251.73l146.81-114.18 19.64 25.26z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1013776f4732c7a6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 96H88a40 40 0 00-40 40v240a40 40 0 0040 40h334.73a40 40 0 0040-40V239"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 160l144 112 87-65.67"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "431.95",
                    "cy": "128.05",
                    "r": "47.95"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M432 192a63.95 63.95 0 1163.95-63.95A64 64 0 01432 192zm0-95.9a32 32 0 1031.95 32 32 32 0 00-31.95-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6d18e3c9a9a659a6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M374.09 101c-.11.23-.21.46-.31.7-.34.75-.67 1.5-1 2.26l-.36.9c-.27.71-.54 1.42-.79 2.14-.12.35-.24.7-.35 1-.23.68-.44 1.37-.64 2.07l-.33 1.15q-.27 1-.51 2c-.1.41-.2.82-.28 1.23-.15.67-.28 1.36-.4 2-.08.42-.16.84-.23 1.27-.11.69-.2 1.4-.29 2.1-.05.42-.11.83-.16 1.25-.08.77-.13 1.54-.19 2.31 0 .36-.06.72-.08 1.09-.06 1.13-.09 2.27-.09 3.41 0 1 0 2 .07 2.94v.62c.05.95.12 1.89.21 2.83l.06.46c.09.87.2 1.72.32 2.57 0 .15 0 .31.07.46.14.92.31 1.84.49 2.75l.12.59c.2.92.4 1.84.64 2.75.23.92.5 1.82.77 2.71.06.19.12.38.17.57.28.88.57 1.74.88 2.59.05.15.11.29.16.43.29.78.6 1.55.92 2.32.05.14.11.28.17.42.35.83.73 1.65 1.11 2.47l.27.53c.4.82.81 1.64 1.24 2.44a64.21 64.21 0 0029.56 27.63l.37.17c1.78.8 3.59 1.53 5.45 2.17l.95.32 1.5.47c.45.14.9.26 1.36.39l1.92.5c.57.14 1.14.27 1.72.39l1.15.24 1.83.32.93.16c.9.13 1.81.24 2.72.34l.77.07c.73.07 1.47.13 2.22.17l.85.05c1 0 1.94.07 2.93.07 1.15 0 2.29 0 3.43-.09l1.09-.09c.77 0 1.54-.11 2.3-.19.42 0 .83-.1 1.25-.16.7-.08 1.41-.17 2.1-.28l1.27-.23c.68-.12 1.36-.25 2-.39l1.24-.29c.67-.16 1.35-.32 2-.51.39-.1.78-.21 1.16-.33.69-.2 1.37-.41 2.05-.63l1.07-.36c.7-.24 1.4-.5 2.1-.77l.94-.37c.74-.3 1.47-.62 2.19-.95l.77-.34c.8-.37 1.58-.77 2.36-1.17.17-.09.35-.17.52-.27.91-.48 1.8-1 2.68-1.5l.12-.07a63.95 63.95 0 10-89.21-84.88l-.21.39c-.3 1.03-.72 1.86-1.11 2.69z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M371.51 202.43l-105.69 82.2a16 16 0 01-19.64 0L89.55 162.81l19.64-25.26L256 251.73l94.36-73.39A95.81 95.81 0 01349 80H48a16 16 0 00-16 16v320a16 16 0 0016 16h416a16 16 0 0016-16V211.13a95.75 95.75 0 01-108.49-8.7z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$da839a9f2eb6395f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 128.05A64 64 0 00389.62 80a64.52 64.52 0 00-12.71 15.3v.06c-.54.9-1.05 1.82-1.55 2.74l-.24.49c-.42.79-.81 1.59-1.19 2.4-.12.25-.23.5-.34.75-.33.73-.65 1.47-.95 2.22-.13.31-.25.62-.37.93-.27.7-.53 1.4-.78 2.11l-.36 1.06c-.22.68-.43 1.37-.63 2.06-.12.39-.23.77-.33 1.16-.19.67-.35 1.35-.51 2-.1.41-.2.82-.29 1.23-.14.68-.27 1.37-.39 2-.08.42-.16.84-.23 1.26-.11.7-.2 1.41-.29 2.12-.05.41-.11.82-.16 1.24-.08.77-.13 1.54-.19 2.32 0 .36-.06.72-.08 1.08-.06 1.14-.1 2.28-.1 3.44 0 1 0 2 .08 2.94v.64q.08 1.41.21 2.82l.06.48c.09.85.19 1.69.32 2.52 0 .17 0 .35.07.52.14.91.31 1.81.49 2.71 0 .22.09.43.13.65.18.86.38 1.72.6 2.57v.19c.23.89.48 1.76.75 2.63l.21.68c.27.85.55 1.68.85 2.51.06.18.13.36.2.54.27.71.55 1.42.84 2.12.08.21.16.41.25.61.34.79.69 1.58 1.06 2.36l.33.67c.35.7.7 1.4 1.07 2.09a64.34 64.34 0 0022.14 23.81 62.22 62.22 0 007.62 4.15l.39.18q2.66 1.2 5.43 2.16l.95.32 1.5.47c.45.14.9.26 1.36.39l1.92.5 1.73.4 1.15.23 1.83.33.94.15c.9.13 1.81.25 2.72.35l.77.07c.73.06 1.47.12 2.21.16l.86.05c1 0 1.94.08 2.92.08 1.16 0 2.3 0 3.44-.1l1.08-.08c.78-.06 1.55-.11 2.32-.19l1.25-.16c.7-.09 1.41-.18 2.11-.29l1.26-.23c.68-.12 1.37-.25 2-.39l1.23-.29c.68-.16 1.36-.32 2-.51.39-.1.77-.21 1.16-.33.69-.2 1.38-.41 2.06-.63l1.06-.36c.71-.25 1.41-.51 2.11-.78l.93-.37c.75-.3 1.49-.62 2.22-.95l.75-.34c.81-.38 1.61-.77 2.4-1.19l.49-.24c.92-.5 1.84-1 2.74-1.55h.06A64.52 64.52 0 00480 170.38a63.81 63.81 0 0016-42.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M371.38 202.53l-105.56 82.1a16 16 0 01-19.64 0l-144-112a16 16 0 1119.64-25.26L256 251.73l94.22-73.28A95.86 95.86 0 01348.81 80H88a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h336a56.06 56.06 0 0056-56V211.19a95.85 95.85 0 01-108.62-8.66z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a522741809166bd8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424 80H88a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h336a56.06 56.06 0 0056-56V136a56.06 56.06 0 00-56-56zm-14.18 92.63l-144 112a16 16 0 01-19.64 0l-144-112a16 16 0 1119.64-25.26L256 251.73l134.18-104.36a16 16 0 0119.64 25.26z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9040e000389054ff(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "216",
                    "cy": "200",
                    "r": "136",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M216 352v128m56-64H160m272-304V32h-80m-16.72 96.72L432 32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e2dd7fb30623e623(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330 16v44h42.89l-37.1 37.09A157.67 157.67 0 00216 42c-87.12 0-158 70.88-158 158 0 79.66 59.26 145.72 136 156.46V394h-50v44h50v58h44v-58h50v-44h-50v-37.54c76.74-10.74 136-76.8 136-156.46a157.23 157.23 0 00-14-64.93l44-44V134h44V16zM216 314a114 114 0 11114-114 114.13 114.13 0 01-114 114z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9b3db9645fdf8a28(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M426 16h-74a22 22 0 000 44h20.89l-37.1 37.09A157.68 157.68 0 00216 42c-87.12 0-158 70.88-158 158 0 79.66 59.26 145.72 136 156.46V394h-28a22 22 0 000 44h28v36a22 22 0 0044 0v-36h28a22 22 0 000-44h-28v-37.54c76.74-10.74 136-76.8 136-156.46a157.15 157.15 0 00-14-64.92l44-44V112a22 22 0 0044 0V38a22 22 0 00-22-22zM216 314a114 114 0 11114-114 114.13 114.13 0 01-114 114z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3325b7e4921424f9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "216",
                    "cy": "296",
                    "r": "152",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 160V64h-96m-28 124L448 64"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3eedf8a66421a99(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330 48v44h58.89l-60.39 60.39c-68.2-52.86-167-48-229.54 14.57C31.12 234.81 31.12 345.19 99 413a174.21 174.21 0 00246 0c62.57-62.58 67.43-161.34 14.57-229.54L420 123.11V182h44V48zm-16.08 333.92a130.13 130.13 0 01-183.84 0c-50.69-50.68-50.69-133.16 0-183.84s133.16-50.69 183.84 0 50.69 133.16 0 183.84z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$70e7feaa70cd4678(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M442 48h-90a22 22 0 000 44h36.89l-60.39 60.39c-68.19-52.86-167-48-229.54 14.57C31.12 234.81 31.12 345.19 99 413a174.21 174.21 0 00246 0c62.57-62.58 67.43-161.35 14.57-229.54L420 123.11V160a22 22 0 0044 0V70a22 22 0 00-22-22zM313.92 381.92a130.13 130.13 0 01-183.84 0c-50.69-50.68-50.69-133.16 0-183.84s133.16-50.69 183.84 0 50.69 133.16 0 183.84z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$731565c2aca7635c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M208 208v264a23.73 23.73 0 0024 24h0a23.73 23.73 0 0024-24"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 336v136a23.73 23.73 0 0024 24h0a23.73 23.73 0 0024-24V208"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M208 192v88a23.72 23.72 0 01-24 24h0a23.72 23.72 0 01-24-24v-88a48 48 0 0148-48h96a48 48 0 0148 48v88a23.72 23.72 0 01-24 24h0a23.72 23.72 0 01-24-24v-88"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "40",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cb6c22bfe8f4bc17(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 128H176a32 32 0 00-32 32v160h48V192h8v320h52V328h8v184h52V192h8v128h48V160a32 32 0 00-32-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6c7367afc1b1b3fe(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M304 128h-96a64.19 64.19 0 00-64 64v107.52c0 10.85 8.43 20.08 19.27 20.47A20 20 0 00184 300v-99.73a8.18 8.18 0 017.47-8.25 8 8 0 018.53 8V489a23 23 0 0023 23 23 23 0 0023-23V346.34a10.24 10.24 0 019.33-10.34A10 10 0 01266 346v143a23 23 0 0023 23 23 23 0 0023-23V200.27a8.18 8.18 0 017.47-8.25 8 8 0 018.53 8v99.52c0 10.85 8.43 20.08 19.27 20.47A20 20 0 00368 300V192a64.19 64.19 0 00-64-64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9b3d9c8d3bd6022(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M313.27 124.64L198.73 51.36a32 32 0 00-29.28.35L56.51 127.49A16 16 0 0048 141.63v295.8a16 16 0 0023.49 14.14l97.82-63.79a32 32 0 0129.5-.24l111.86 73a32 32 0 0029.27-.11l115.43-75.94a16 16 0 008.63-14.2V74.57a16 16 0 00-23.49-14.14l-98 63.86a32 32 0 01-29.24.35zM328 128v336M184 48v336"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3f958c46ef9ea892(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M327.71 130.93L184 39 32 144v336l152.29-98.93L328 473l152-105V32zM312 421l-112-72V91l112 72z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7e25c7b5e1e32ba2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48.17 113.34A32 32 0 0032 141.24V438a32 32 0 0047 28.37c.43-.23.85-.47 1.26-.74l84.14-55.05a8 8 0 003.63-6.72V46.45a8 8 0 00-12.51-6.63zm164.19-74.03A8 8 0 00200 46v357.56a8 8 0 003.63 6.72l96 62.42A8 8 0 00312 466V108.67a8 8 0 00-3.64-6.73zm252.17 7.16a31.64 31.64 0 00-31.5-.88 12.07 12.07 0 00-1.25.74l-84.15 55a8 8 0 00-3.63 6.72v357.46a8 8 0 0012.52 6.63l107.07-73.46a32 32 0 0016.41-28v-296a32.76 32.76 0 00-15.47-28.21z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ea645e6a5b77f0c2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "352",
                    "r": "112",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "352",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M147 323L41.84 159.32a32 32 0 01-1.7-31.61l31-62A32 32 0 0199.78 48h312.44a32 32 0 0128.62 17.69l31 62a32 32 0 01-1.7 31.61L365 323m6-179H37m391.74-91.4L305 250M140.55 144L207 250"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$677c4497203a9a92(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 32L16 160h289.11l80.22-128H80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M496 144L424 32 298 231.08a128 128 0 00-84 0L189.53 192H43.82l86.66 134.89a128 128 0 10251 0zM256 422a70 70 0 1170-70 70.08 70.08 0 01-70 70z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "352",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2335e85887ce97ea(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "352",
                    "r": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M99.78 32a48 48 0 00-42.94 26.53l-31 62A48.26 48.26 0 0024.28 160h278.2a4 4 0 003.39-1.87l75.5-120A4 4 0 00378 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M486.17 120.56l-31-62a47.7 47.7 0 00-32.79-25.46L342.5 160 298 231.08a128 128 0 00-84 0l-23.32-37.2a4 4 0 00-3.39-1.88H51.14a4 4 0 00-3.36 6.16l82.7 128.73a128 128 0 10251 0L483.62 168a48.22 48.22 0 002.55-47.44zm-226 295.31a64 64 0 1159.69-59.69 64.08 64.08 0 01-59.68 59.69z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$24fb163d6690d087(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M429.93 174.27l-16.47-28.59a15.49 15.49 0 00-21.15-5.7l-98.39 57a4 4 0 01-6-3.5L288 80a16 16 0 00-16-16h-32a16 16 0 00-16 16l.07 113.57a4 4 0 01-6 3.5l-98.39-57a15.49 15.49 0 00-21.15 5.7l-16.46 28.6a15.42 15.42 0 005.69 21.1l98.49 57.08a4 4 0 010 6.9l-98.49 57.08a15.54 15.54 0 00-5.69 21.1l16.47 28.59a15.49 15.49 0 0021.15 5.7l98.39-57a4 4 0 016 3.5L224 432a16 16 0 0016 16h32a16 16 0 0016-16l-.07-113.67a4 4 0 016-3.5l98.39 57a15.49 15.49 0 0021.15-5.7l16.47-28.59a15.42 15.42 0 00-5.69-21.1l-98.49-57.08a4 4 0 010-6.9l98.49-57.08a15.51 15.51 0 005.68-21.11z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6ffaacfd7456ed6f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M351.9 256L460 193.6l-48-83.2-108 62.4V48h-96v124.8l-108-62.4-48 83.2L160.1 256 52 318.4l48 83.2 108-62.4V464h96V339.2l108 62.4 48-83.2L351.9 256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5c24dbbfed53994c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 464h-32a32 32 0 01-32-32l.05-85.82a4 4 0 00-6-3.47l-74.34 43.06a31.48 31.48 0 01-43-11.52l-16.5-28.64-.06-.1a31.65 31.65 0 0111.56-42.8l74.61-43.25a4 4 0 000-6.92l-74.54-43.21a31.41 31.41 0 01-11.55-43l16.44-28.55a31.48 31.48 0 0119.27-14.74 31.14 31.14 0 0123.8 3.2l74.31 43a4 4 0 006-3.47L208 80a32 32 0 0132-32h32a32 32 0 0132 32v85.72a4 4 0 006 3.47l74.34-43.06a31.51 31.51 0 0143 11.52l16.49 28.64.06.09a31.52 31.52 0 01-11.64 42.86l-74.53 43.2a4 4 0 000 6.92l74.53 43.2a31.42 31.42 0 0111.56 43l-16.44 28.55a31.48 31.48 0 01-19.27 14.74 31.14 31.14 0 01-23.8-3.2l-74.31-43a4 4 0 00-6 3.46L304 432a32 32 0 01-32 32zm-93.56-197.48zm0-21zm155.1-.08zm0 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$958ecd108a3f0e62(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "352",
                    "x": "32",
                    "y": "112",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 112V80a32 32 0 0132-32h160a32 32 0 0132 32v32m-112 96v160m80-80H176"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$619230d8e51c5ad4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M168 72h176v24H168z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M484 96H384V40a8 8 0 00-8-8H136a8 8 0 00-8 8v56H28a12 12 0 00-12 12v360a12 12 0 0012 12h456a12 12 0 0012-12V108a12 12 0 00-12-12zM168 72h176v24H168zm184 238h-74v74h-44v-74h-74v-44h74v-74h44v74h74z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d1949da34833278e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M336 64H176a16 16 0 00-16 16v16h192V80a16 16 0 00-16-16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96h-48V80a48.05 48.05 0 00-48-48H176a48.05 48.05 0 00-48 48v16H80a64.07 64.07 0 00-64 64v256a64 64 0 0064 64h352a64 64 0 0064-64V160a64.07 64.07 0 00-64-64zm-96 208h-64v64a16 16 0 01-32 0v-64h-64a16 16 0 010-32h64v-64a16 16 0 0132 0v64h64a16 16 0 010 32zm16-208H160V80a16 16 0 0116-16h160a16 16 0 0116 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$27652a6e8f84bd14(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M407.94 52.22S321.3 160 240 160H80a16 16 0 00-16 16v96a16 16 0 0016 16h160c81.3 0 167.94 108.23 167.94 108.23 6.06 8 24.06 2.52 24.06-9.83V62c0-12.31-17-18.82-24.06-9.78zM64 256s-16-6-16-32 16-32 16-32m384 54s16-4.33 16-22-16-22-16-22m-192-42v128M112 160v128"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 288v168a8 8 0 008 8h53a16 16 0 0015.29-20.73C211.91 416.39 192 386.08 192 336h16a16 16 0 0016-16v-16a16 16 0 00-16-16h-16"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2c5f000b652dbca9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 144v332a4 4 0 004 4h100.07a8 8 0 007.82-9.7L208.71 352H232a8 8 0 008-8V144zm324.18 42.55L448 185.5V36a4 4 0 00-4-4h-42.5a4 4 0 00-2.63 1L272 144v160l126.87 111a4 4 0 002.63 1H444a4 4 0 004-4V262.5l4.18-1.05C461.8 258.84 480 247.67 480 224s-18.2-34.84-27.82-37.45zM96 144H52a4 4 0 00-4 4v35.59a43 43 0 00-4.24 4.35C38.4 194.32 32 205.74 32 224c0 20.19 7.89 33.13 16 40.42V300a4 4 0 004 4h44z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1203d05c2ef57a7c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 176v.66a17.38 17.38 0 01-4.2 11.23v.05C38.4 194.32 32 205.74 32 224c0 16.55 5.3 28.23 11.68 35.91A19 19 0 0148 272a32 32 0 0032 32h8a8 8 0 008-8V152a8 8 0 00-8-8h-8a32 32 0 00-32 32zm404.18 10.55l-.93-.17a4 4 0 01-3.25-3.93V62c0-12.64-8.39-24-20.89-28.32-11.92-4.11-24.34-.76-31.68 8.53a431.18 431.18 0 01-51.31 51.69c-23.63 20-46.24 34.25-67 42.31a8 8 0 00-5.15 7.47V299a16 16 0 009.69 14.69c19.34 8.29 40.24 21.83 62 40.28a433.74 433.74 0 0151.68 52.16 26.22 26.22 0 0021.1 9.87 33.07 33.07 0 0010.44-1.74C439.71 410 448 399.05 448 386.4V265.53a4 4 0 013.33-3.94l.85-.14C461.8 258.84 480 247.67 480 224s-18.2-34.84-27.82-37.45zM240 320V152a8 8 0 00-8-8h-96a8 8 0 00-8 8v304a24 24 0 0024 24h52.45a32.66 32.66 0 0025.93-12.45 31.65 31.65 0 005.21-29.05c-1.62-5.18-3.63-11-5.77-17.19-7.91-22.9-18.34-37.07-21.12-69.32A32 32 0 00240 320z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fe53765979d5b3e1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M80 160h352M80 256h352M80 352h352"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f7a39e0787f0abc5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 384h384v-42.67H64zm0-106.67h384v-42.66H64zM64 128v42.67h384V128z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b070dc65f0533041(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M88 152h336M88 256h336M88 360h336"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f9a4d6e8e6e82ee6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M224 368h64m48-143.7v23.92c0 39.42-40.58 71.48-80 71.48h0c-39.42 0-80-32.06-80-71.48V224.3m80 95.7v48"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "160",
                    "x": "208",
                    "y": "128",
                    "rx": "48",
                    "ry": "48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$69e8dc3d79c86b65(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-48 128a48.14 48.14 0 0148-48 48.14 48.14 0 0148 48v64a48.14 48.14 0 01-48 48 48.14 48.14 0 01-48-48zm144 72.22c0 23.36-10.94 45.61-30.79 62.66A103.71 103.71 0 01272 334.26V352h32v32h-96v-32h32v-17.74a103.71 103.71 0 01-49.21-23.38c-19.85-17.05-30.79-39.3-30.79-62.66V208.3h32v39.92c0 25.66 28 55.48 64 55.48 29.6 0 64-24.23 64-55.48V208.3h32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e4fbc0cbfae63481(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-48 128a48.14 48.14 0 0148-48 48.14 48.14 0 0148 48v64a48.14 48.14 0 01-48 48 48.14 48.14 0 01-48-48zm144 72.22c0 23.36-10.94 45.61-30.79 62.66A103.71 103.71 0 01272 334.26V352h16a16 16 0 010 32h-64a16 16 0 010-32h16v-17.74a103.71 103.71 0 01-49.21-23.38c-19.85-17.05-30.79-39.3-30.79-62.66V224.3a16 16 0 0132 0v23.92c0 25.66 28 55.48 64 55.48 29.6 0 64-24.23 64-55.48V224.3a16 16 0 1132 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cd99245c1ab86dab(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208zm0-384c-97 0-176 79-176 176s79 176 176 176 176-78.95 176-176S353.05 80 256 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M352 369a15.93 15.93 0 01-11.84-5.24l-192-210a16 16 0 0123.68-21.52l192 210A16 16 0 01352 369zm0-120.78v-23.8a16.3 16.3 0 00-13.64-16.24c-9.88-1.48-18.36 6.51-18.36 16.12v23.92a43.35 43.35 0 01-3.07 15.91 4 4 0 00.76 4.16l19.19 21.1a2 2 0 003.19-.3A77.12 77.12 0 00352 248.22zM304 240v-64a48.14 48.14 0 00-48-48 48.08 48.08 0 00-41 23.1 4 4 0 00.47 4.77l84.42 92.86a2 2 0 003.46-1A47.84 47.84 0 00304 240zm-57.43 45.2l-36.46-40.11a1 1 0 00-1.74.8 48.26 48.26 0 0037.25 41 1 1 0 00.95-1.69z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M287.55 352H272v-17.74a100.33 100.33 0 0012.53-3.06 2 2 0 00.89-3.26l-21.07-23.19a3.94 3.94 0 00-3.29-1.29c-1.69.15-3.39.24-5.06.24-36 0-64-29.82-64-55.48V224.4a16.26 16.26 0 00-15.61-16.4A15.91 15.91 0 00160 224v24.22c0 23.36 10.94 45.61 30.79 62.66A103.71 103.71 0 00240 334.26V352h-15.55c-8.61 0-16 6.62-16.43 15.23A16 16 0 00224 384h64a16 16 0 0016-16.77c-.42-8.61-7.84-15.23-16.45-15.23z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bbefc13bb0712e87(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm64 200.22V208h32v40.22a77.53 77.53 0 01-13.37 43.11L316 266.4a44.11 44.11 0 004-18.18zM256 128a48.14 48.14 0 0148 48v64a48.07 48.07 0 01-1.44 11.64l-89-97.92A48.13 48.13 0 01256 128zm48 256h-96v-32h32v-17.74a103.71 103.71 0 01-49.21-23.38c-19.85-17.05-30.79-39.3-30.79-62.66V208h32v40.22c0 25.66 28 55.48 64 55.48a56.91 56.91 0 007-.45l24.52 27a99.57 99.57 0 01-15.5 4V352h32zm-95.91-141.13l40.5 44.55a48.2 48.2 0 01-40.5-44.55zm136.07 124.89l-200.5-218.5 23.68-21.52 200.5 218.5z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cdc845c6074ce3b9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 80a48.14 48.14 0 0148 48v64a47.84 47.84 0 01-.63 7.71 2 2 0 01-3.46 1l-84.42-92.86a4 4 0 01-.47-4.77A48.08 48.08 0 01256 128zm32 256h-63.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01224 352h16v-17.74a103.71 103.71 0 01-49.21-23.38c-19.85-17.05-30.79-39.3-30.79-62.66V224a15.91 15.91 0 0116.39-16A16.26 16.26 0 01192 224.4v23.82c0 25.66 28 55.48 64 55.48 1.67 0 3.37-.09 5.06-.24a3.94 3.94 0 013.29 1.29l21.07 23.19a2 2 0 01-.89 3.26 100.33 100.33 0 01-12.53 3.06V352h15.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01288 384zm-77.89-138.91l36.46 40.11a1 1 0 01-.95 1.66 48.26 48.26 0 01-37.25-41 1 1 0 011.74-.77zm152.65 119.75a16 16 0 01-22.6-1.08l-192-210a16 16 0 0123.68-21.52l192 210a16 16 0 01-1.08 22.6zM352 248.22a77.12 77.12 0 01-11.93 40.87 2 2 0 01-3.19.3l-19.19-21.1a4 4 0 01-.76-4.16 43.35 43.35 0 003.07-15.91v-23.8a16.3 16.3 0 0113.64-16.24c9.88-1.48 18.36 6.51 18.36 16.12z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e308a05e505e8c50(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M432 400L96 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M400 240v-31.55c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 208v32a111.58 111.58 0 01-2.45 23.31 4.05 4.05 0 001.07 3.69l21.82 21.81a2 2 0 003.29-.72A143.27 143.27 0 00400 240zM256 352a112.36 112.36 0 01-112-112v-31.55c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 208v32c0 74 56.1 135.12 128 143.11V432h-47.55c-8.61 0-16 6.62-16.43 15.23A16 16 0 00192 464h127.55c8.61 0 16-6.62 16.43-15.23A16 16 0 00320 432h-48v-48.89a143.08 143.08 0 0052-16.22 4 4 0 00.91-6.35L307 342.63a4 4 0 00-4.51-.78A110.78 110.78 0 01256 352zm0-272a47.18 47.18 0 0148 48v74.72a4 4 0 001.17 2.82L332.59 233a2 2 0 003.41-1.42V128.91C336 85 301 48.6 257.14 48a79.66 79.66 0 00-68.47 36.57 4 4 0 00.54 5l19.54 19.54a2 2 0 003.25-.63A47.44 47.44 0 01256 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M207.27 242.9L179.41 215a2 2 0 00-3.41 1.42V239a80.89 80.89 0 0023.45 56.9 78.55 78.55 0 0077.8 21.19 2 2 0 00.86-3.35l-24.91-24.91a4.08 4.08 0 00-2.42-1.15c-21.65-2.52-39.48-20.44-42.37-42.43a4 4 0 00-1.14-2.35z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$29964ea557c51232(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M432 400L96 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M368 192v48a111.74 111.74 0 01-2.93 25.45L390.65 291a143.07 143.07 0 009.35-51v-48zm-96 240v-48.89a143.11 143.11 0 0056.65-18.83L305 340.65A112.13 112.13 0 01144 240v-48h-32v48c0 74 56.1 135.12 128 143.11V432h-64v32h160v-32zm64-195.63V128c0-44.86-35.14-80-80-80a79.68 79.68 0 00-69 39.34"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M176 211.63V239a80.89 80.89 0 0023.45 56.9 78.55 78.55 0 0081 20.21z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3f9b5893a56d8f3f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M432 400L96 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M400 240v-31.55c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 208v32a111.68 111.68 0 01-2.68 24.38 2 2 0 00.53 1.84l22.59 22.59a2 2 0 003.29-.72A143.27 143.27 0 00400 240zM256 352a112.36 112.36 0 01-112-112v-31.55c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 208v32c0 74 56.1 135.12 128 143.11V432h-47.55c-8.61 0-16 6.62-16.43 15.23A16 16 0 00192 464h127.55c8.61 0 16-6.62 16.43-15.23A16 16 0 00320 432h-48v-48.89a143.08 143.08 0 0052-16.22 4 4 0 00.91-6.35l-18.4-18.39a3 3 0 00-3.41-.58A111 111 0 01256 352zm1.14-304a79.66 79.66 0 00-68.47 36.57 4 4 0 00.54 5L332.59 233a2 2 0 003.41-1.42V128.91C336 85 301 48.6 257.14 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M179.41 215a2 2 0 00-3.41 1.42V239a80.89 80.89 0 0023.45 56.9 78.55 78.55 0 0077.8 21.19 2 2 0 00.86-3.35z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2bbd4fea0cf258da(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M192 448h128m64-240v32c0 70.4-57.6 128-128 128h0c-70.4 0-128-57.6-128-128v-32m128 160v80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 64a63.68 63.68 0 00-64 64v111c0 35.2 29 65 64 65s64-29 64-65V128c0-36-28-64-64-64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fd94a4d80b975ea3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M192 448h128m64-240v32c0 70.4-57.6 128-128 128h0c-70.4 0-128-57.6-128-128v-32m128 160v80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 320a78.83 78.83 0 01-56.55-24.1A80.89 80.89 0 01176 239V128a79.69 79.69 0 0180-80c44.86 0 80 35.14 80 80v111c0 44.66-35.89 81-80 81z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3548a2d22c49a795(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M192 448h128m64-240v32c0 70.4-57.6 128-128 128h0c-70.4 0-128-57.6-128-128v-32m128 160v80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 320a78.83 78.83 0 01-56.55-24.1A80.89 80.89 0 01176 239V128a79.69 79.69 0 0180-80c44.86 0 80 35.14 80 80v111c0 44.66-35.89 81-80 81z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f166db87959a545d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 136c0-30.62 4.51-61.61 16-88C99.57 81.27 48 159.32 48 248c0 119.29 96.71 216 216 216 88.68 0 166.73-51.57 200-128-26.39 11.49-57.38 16-88 16-119.29 0-216-96.71-216-216z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a0133b318e4316b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.62 126.77c0-33 4.85-66.35 17.23-94.77C87.54 67.83 32 151.89 32 247.38 32 375.85 136.15 480 264.62 480c95.49 0 179.55-55.54 215.38-137.85-28.42 12.38-61.8 17.23-94.77 17.23-128.47 0-232.61-104.14-232.61-232.61z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$eaab68e04829604a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264 480A232 232 0 0132 248c0-94 54-178.28 137.61-214.67a16 16 0 0121.06 21.06C181.07 76.43 176 104.66 176 136c0 110.28 89.72 200 200 200 31.34 0 59.57-5.07 81.61-14.67a16 16 0 0121.06 21.06C442.28 426 358 480 264 480z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d185ce5f0c5bb40d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 112l80-80 80 80m-80.02-80l.02 448m-80-80l80 80 80-80m64-224l80 80-80 80M112 176l-80 80 80 80m-80-80h448"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b1c130e5fa432940(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M176 112l80-80 80 80m-80.02-80l.02 448m-80-80l80 80 80-80m64-224l80 80-80 80M112 176l-80 80 80 80m-80-80h448"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5e574532f51e06e2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 112l80-80 80 80m-80.02-80l.02 448m-80-80l80 80 80-80m64-224l80 80-80 80M112 176l-80 80 80 80m-80-80h448"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6d825a04348de43d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M240 343.31V424a32.28 32.28 0 01-21.88 30.65l-21.47 7.23c-25.9 8.71-52.65-10.75-52.65-38.32h0A34.29 34.29 0 01167.25 391l50.87-17.12A32.29 32.29 0 00240 343.24V92a16.13 16.13 0 0112.06-15.66L360.49 48.2A6 6 0 01368 54v57.76a16.13 16.13 0 01-12.12 15.67l-91.64 23.13A32.25 32.25 0 00240 181.91v39.39"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$abf2bb69b9657638(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M381.55 32.05c-18.13 4.28-126.57 31.07-156 38.19a2 2 0 00-1.55 1.94V353.3a2 2 0 01-1.32 1.88L182 369.88c-29.82 10.66-54 18.94-54 59.06 0 32.47 23.53 47.18 37.95 50a81.77 81.77 0 0015 1.08c8.89 0 31-3.59 47.52-14.24C256 448 256 448 256 415.93V169.16a2 2 0 011.49-1.94l125-33a2 2 0 001.49-1.94V34a2 2 0 00-2.43-1.95z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$38e2ac0ef9e3db1e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.83 480a55.2 55.2 0 01-32.36-10.55A56.64 56.64 0 01128 423.58a50.26 50.26 0 0134.14-47.73L213 358.73a16.25 16.25 0 0011-15.49V92a32.1 32.1 0 0124.09-31.15l108.39-28.14A22 22 0 01384 54v57.75a32.09 32.09 0 01-24.2 31.19l-91.65 23.13A16.24 16.24 0 00256 181.91V424a48.22 48.22 0 01-32.78 45.81l-21.47 7.23a56 56 0 01-17.92 2.96z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$879f9d350b60adda(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M192 218v-6c0-14.84 10-27 24.24-30.59l174.59-46.68A20 20 0 01416 154v22"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 295.94v80c0 13.91-8.93 25.59-22 30l-22 8c-25.9 8.72-52-10.42-52-38h0a33.37 33.37 0 0123-32l51-18.15c13.07-4.4 22-15.94 22-29.85V58a10 10 0 00-12.6-9.61L204 102a16.48 16.48 0 00-12 16v226c0 13.91-8.93 25.6-22 30l-52 18c-13.88 4.68-22 17.22-22 32h0c0 27.58 26.52 46.55 52 38l22-8c13.07-4.4 22-16.08 22-30v-80"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$90cd9b96242bb09d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M429.46 32.07c-23.6 6.53-205.55 58.81-250.54 71.43a4 4 0 00-2.92 3.83v247a2 2 0 01-1.33 1.89l-27.85 9.55c-19 7.44-66.82 16.68-66.82 59.19 0 35.54 24.63 51.54 45.86 54.28a52.06 52.06 0 007.81.8c7.37 0 36.38-7.08 53.3-18.08C208 448.25 208 448 208 412V202c0-.9.62-.84 1.48-1.07l188-51.92a2 2 0 012.53 2v155.54a2 2 0 01-1.36 1.89c-8.9 3-19.23 6.5-26.48 9.12C341.39 328.68 304 335.65 304 376c0 38.51 28.26 54.58 46.3 55.83a87.37 87.37 0 0021.33-1c9-1.38 24.09-5.9 38.14-14.86C432 401.79 432 401.51 432 360V34a2 2 0 00-2.54-1.93z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9798f2db9d8ca90(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M421.84 37.37a25.86 25.86 0 00-22.6-4.46L199.92 86.49A32.3 32.3 0 00176 118v226c0 6.74-4.36 12.56-11.11 14.83l-.12.05-52 18C92.88 383.53 80 402 80 423.91a55.54 55.54 0 0023.23 45.63A54.78 54.78 0 00135.34 480a55.82 55.82 0 0017.75-2.93l.38-.13 21.84-7.94A47.84 47.84 0 00208 423.91v-212c0-7.29 4.77-13.21 12.16-15.07l.21-.06L395 150.14a4 4 0 015 3.86v141.93c0 6.75-4.25 12.38-11.11 14.68l-.25.09-50.89 18.11A49.09 49.09 0 00304 375.92a55.67 55.67 0 0023.23 45.8 54.63 54.63 0 0049.88 7.35l.36-.12 21.84-7.95A47.83 47.83 0 00432 375.92V58a25.74 25.74 0 00-10.16-20.63z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8ee546fcb93a2e07(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.76 161l-186.53 82.35c-10.47 4.8-6.95 20.67 4.57 20.67H244a4 4 0 014 4v89.18c0 11.52 16 15 20.78 4.56L351 175.24A10.73 10.73 0 00336.76 161z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8b2805f709b1351d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48A208.23 208.23 0 0048 256c0 114.68 93.31 208 208 208a208.23 208.23 0 00208-208c0-114.69-93.31-208-208-208zm-8 361V264H103l259-114.11z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7a93eab3c64124fe(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zM351 175.24l-82.24 186.52c-4.79 10.47-20.78 7-20.78-4.56V268a4 4 0 00-4-4H154.8c-11.52 0-15-15.87-4.57-20.67L336.76 161A10.73 10.73 0 01351 175.24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6c30d68745a0faca(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 64L64 240.14h200a8 8 0 018 8V448z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2f8e59937dc559ca(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32L32 240h240v240L480 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9e18bf9e94bf3e8e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 464a16 16 0 01-16-16.42V264.13a8 8 0 00-8-8H64.41a16.31 16.31 0 01-15.49-10.65 16 16 0 018.41-19.87l384-176.15a16 16 0 0121.22 21.19l-176 384A16 16 0 01272 464z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9bdd14a4f7bae8a8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 415.86V72a24.07 24.07 0 00-24-24H72a24.07 24.07 0 00-24 24v352a40.12 40.12 0 0040 40h328"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 464h0a48 48 0 01-48-48V128h72a24 24 0 0124 24v264a48 48 0 01-48 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M240 128h64m-64 64h64m-192 64h192m-192 64h192m-192 64h192"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M176 208h-64a16 16 0 01-16-16v-64a16 16 0 0116-16h64a16 16 0 0116 16v64a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a02f4fbcc8c4406e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "96",
                    "y": "112",
                    "fill": "none",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M468 112h-52v304a32 32 0 0032 32 32 32 0 0032-32V124a12 12 0 00-12-12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M431.15 477.75A64.11 64.11 0 01384 416V44a12 12 0 00-12-12H44a12 12 0 00-12 12v380a56 56 0 0056 56h342.85a1.14 1.14 0 00.3-2.25zM96 208v-96h96v96zm224 192H96v-32h224zm0-64H96v-32h224zm0-64H96v-32h224zm0-64h-96v-32h96zm0-64h-96v-32h96z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$db1cd65bcb4dda6c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.91 112h-23.82a.09.09 0 00-.09.09V416a32 32 0 0032 32 32 32 0 0032-32V152.09A40.09 40.09 0 00439.91 112z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M384 416V72a40 40 0 00-40-40H72a40 40 0 00-40 40v352a56 56 0 0056 56h342.85a1.14 1.14 0 001.15-1.15 1.14 1.14 0 00-.85-1.1A64.11 64.11 0 01384 416zM96 128a16 16 0 0116-16h64a16 16 0 0116 16v64a16 16 0 01-16 16h-64a16 16 0 01-16-16zm208 272H112.45c-8.61 0-16-6.62-16.43-15.23A16 16 0 01112 368h191.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 400zm0-64H112.45c-8.61 0-16-6.62-16.43-15.23A16 16 0 01112 304h191.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 336zm0-64H112.45c-8.61 0-16-6.62-16.43-15.23A16 16 0 01112 240h191.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 272zm0-64h-63.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01240 176h63.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 208zm0-64h-63.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01240 112h63.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 144z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2af03245cd48e765(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M365.2 313c-16.33-19.34-27.86-27.47-27.86-80.8 0-48.86-25.78-66.23-47-74.67a11.39 11.39 0 01-6.34-6.68C280.29 138.6 269.88 128 256 128s-24.31 10.6-28 22.86a11.35 11.35 0 01-6.33 6.68c-21.24 8.46-47 25.8-47 74.67 0 53.33-11.54 61.46-27.87 80.8-6.77 8-.65 23 11.19 23H354C365.77 336 371.94 321 365.2 313zm-144.96 39a4 4 0 00-4 4.42C218.49 375.14 235.11 384 256 384c20.67 0 37.14-9.15 39.66-27.52a4 4 0 00-4-4.48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cf883fb7c3c5db72(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M295.68 351.43v.57h.32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M256 384c22.28 0 39.36-10.63 39.66-32H216c0 21.75 17.53 32 40 32zm39.67-32h.33l-.32-.57c0 .19-.01.38-.01.57z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 336c-22.48 0-40-10.25-40-32h80c-.3 21.37-17.71 32-40 32zm112-48H144v-28l28-36v-32.3c0-40.41 15.82-75.35 56-84.27l4-27.43h48l4 27.43c40 8.92 56 44 56 84.27V272l28 36z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d61f99c0c2ea8bea(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 336c-20.9 0-37.52-8.86-39.75-27.58a4 4 0 014-4.42h71.45a4 4 0 014 4.48C293.15 374.85 276.68 384 256 384zm98-48H158c-11.84 0-18-15-11.19-23 16.33-19.34 27.87-27.47 27.87-80.8 0-48.87 25.74-66.21 47-74.67a11.35 11.35 0 006.33-6.68C231.7 138.6 242.14 128 256 128s24.28 10.6 28 22.86a11.39 11.39 0 006.34 6.68c21.21 8.44 47 25.81 47 74.67 0 53.33 11.53 61.46 27.86 80.8 6.74 7.99.57 22.99-11.2 22.99z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f8c15037d83aad37(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M220.24 352a4 4 0 00-4 4.42C218.49 375.14 235.11 384 256 384s37.5-8.86 39.73-27.58a4 4 0 00-4-4.42zM352 378a15.93 15.93 0 01-11.84-5.24l-192-212a16 16 0 0123.68-21.52l192 212A16 16 0 01352 378zM174.68 232.21c0 53.33-11.54 61.46-27.87 80.8-6.77 8-.65 23 11.19 23h118.83a4 4 0 002.95-6.7l-98-106.87a4 4 0 00-6.94 2.52c-.1 2.33-.16 4.75-.16 7.25zM365.2 313c-16.33-19.34-27.86-27.47-27.86-80.8 0-48.86-25.78-66.23-47-74.67a11.39 11.39 0 01-6.34-6.68C280.29 138.6 269.88 128 256 128s-24.31 10.6-28 22.86a11.35 11.35 0 01-6.33 6.68c-1.28.51-2.57 1.05-3.88 1.63a4 4 0 00-1.3 6.36L361 323.21a4 4 0 006.94-2.95 12 12 0 00-2.74-7.26z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1a1cdeef7ddf767a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zM144 308l28-36v-32.3a131.83 131.83 0 012.34-25.42L285.92 336H144zm112.18 76C233.6 384 216 373.75 216 352h80c-.3 21.37-17.45 32-39.82 32zm93.48-3.74l-211-227 23.68-21.52 211 227zM368 330.85l-.32-.38-155.5-169.63a73.4 73.4 0 0115.82-5.41l4-27.43h48l4 27.43c40 8.92 56 44 56 84.27V272l28 36z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6f5aee5733dcf24a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zM146.83 313c16.33-19.34 27.86-27.47 27.86-80.8q0-3.75.2-7.26a4 4 0 017-2.52l98 106.87a4 4 0 01-2.94 6.7H158C146.18 336 140.06 321 146.83 313zm148.93 43.41C293.53 375.14 276.92 384 256 384s-37.51-8.86-39.75-27.58a4 4 0 014-4.42h71.53a4 4 0 013.98 4.42zm67 17.42a16 16 0 01-22.6-1.08l-192-212a16 16 0 0123.68-21.52l192 212a16 16 0 01-1.08 22.61zM361 323.21L216.49 165.53a4 4 0 011.3-6.36c1.31-.58 2.61-1.12 3.89-1.63a11.33 11.33 0 006.32-6.68c3.72-12.26 14.15-22.86 28-22.86s24.29 10.6 28 22.86a11.34 11.34 0 006.34 6.68c21.21 8.44 47 25.81 47 74.67 0 53.33 11.54 61.46 27.87 80.8a12.09 12.09 0 012.76 7.25 4 4 0 01-6.97 2.95z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cbbb8fde81659c9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128.51 204.59q-.37 6.15-.37 12.76C128.14 304 110 320 84.33 351.43 73.69 364.45 83 384 101.62 384H320m94.5-48.7c-18.48-23.45-30.62-47.05-30.62-118 0-79.3-40.52-107.57-73.88-121.3-4.43-1.82-8.6-6-9.95-10.55C294.21 65.54 277.82 48 256 48s-38.2 17.55-44 37.47c-1.35 4.6-5.52 8.71-10 10.53a149.57 149.57 0 00-18 8.79M320 384v16a64 64 0 01-128 0v-16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 448L64 64"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$871420993c5cfb0b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41.37 64l22.628-22.628L470.627 448l-22.628 22.627zM256 480a80.09 80.09 0 0073.3-48H182.7a80.09 80.09 0 0073.3 48zM112 227.47V288l-48 64v48h268.12L115.87 183.75a236.75 236.75 0 00-3.87 43.72zM448 352l-48-64v-60.53C400 157 372.64 95.61 304 80l-8-48h-80l-8 48a117.45 117.45 0 00-41.95 18.17l282 282z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a127f85110fba4b1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 464a15.92 15.92 0 01-11.31-4.69l-384-384a16 16 0 0122.62-22.62l384 384A16 16 0 01448 464zm-7.92-122.69c-1.66-2-3.29-4-4.89-5.93-22-26.61-35.31-42.67-35.31-118 0-39-9.33-71-27.72-95-13.56-17.73-31.89-31.18-56.05-41.12a3 3 0 01-.82-.67C306.6 51.49 282.82 32 256 32s-50.59 19.49-59.28 48.56a3.13 3.13 0 01-.81.65 157.88 157.88 0 00-21.88 11 8 8 0 00-1.49 12.49l261.78 261.74a8 8 0 0013.6-6.63 35.39 35.39 0 00-7.84-18.5zM112.14 217.35c0 75.36-13.29 91.42-35.31 118-1.6 1.93-3.23 3.89-4.89 5.93a35.16 35.16 0 00-4.65 37.62c6.17 13 19.32 21.07 34.33 21.07H312.8a8 8 0 005.66-13.66l-192-192a8 8 0 00-13.62 5q-.7 8.69-.7 18.04zM256 480a80.06 80.06 0 0070.44-42.13 4 4 0 00-3.54-5.87H189.12a4 4 0 00-3.55 5.87A80.06 80.06 0 00256 480z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7c1b567847093577(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M427.68 351.43C402 320 383.87 304 383.87 217.35 383.87 138 343.35 109.73 310 96c-4.43-1.82-8.6-6-9.95-10.55C294.2 65.54 277.8 48 256 48s-38.21 17.55-44 37.47c-1.35 4.6-5.52 8.71-9.95 10.53-33.39 13.75-73.87 41.92-73.87 121.35C128.13 304 110 320 84.32 351.43 73.68 364.45 83 384 101.61 384h308.88c18.51 0 27.77-19.61 17.19-32.57zM320 384v16a64 64 0 01-128 0v-16"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$626f812838d96e4e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 480a80.09 80.09 0 0073.3-48H182.7a80.09 80.09 0 0073.3 48zm144-192v-60.53C400 157 372.64 95.61 304 80l-8-48h-80l-8 48c-68.88 15.61-96 76.76-96 147.47V288l-48 64v48h384v-48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4377bc2d457878b5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.08 341.31c-1.66-2-3.29-4-4.89-5.93-22-26.61-35.31-42.67-35.31-118 0-39-9.33-71-27.72-95-13.56-17.73-31.89-31.18-56.05-41.12a3 3 0 01-.82-.67C306.6 51.49 282.82 32 256 32s-50.59 19.49-59.28 48.56a3.13 3.13 0 01-.81.65c-56.38 23.21-83.78 67.74-83.78 136.14 0 75.36-13.29 91.42-35.31 118-1.6 1.93-3.23 3.89-4.89 5.93a35.16 35.16 0 00-4.65 37.62c6.17 13 19.32 21.07 34.33 21.07H410.5c14.94 0 28-8.06 34.19-21a35.17 35.17 0 00-4.61-37.66zM256 480a80.06 80.06 0 0070.44-42.13 4 4 0 00-3.54-5.87H189.12a4 4 0 00-3.55 5.87A80.06 80.06 0 00256 480z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4074166c1828d759(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "192",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "64",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M224 192L171 85m117 107l53-107m-13.45 170.81l119.41.13m-147.87 57.19l72.25 95.06M184.45 255.81l-119.41.13m147.87 57.19l-72.25 95.06"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a8cacdb3e3cda369(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M223.47 335.59l-51.71 68a169.73 169.73 0 00168.48 0l-51.71-68"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M403.08 108.92a208 208 0 00-294.16 294.16 208 208 0 00294.16-294.16zM342 256a86.13 86.13 0 01-53.47 79.59l51.71 68a169.73 169.73 0 01-168.48 0l51.71-68a86 86 0 01-50.56-101.77l-85.48.09a170.21 170.21 0 0173.83-119l37.94 76.59a85.78 85.78 0 01113.6 0l37.94-76.59a170.21 170.21 0 0173.83 119l-85.48-.09A85.87 85.87 0 01342 256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$58fce8cca3e5d4f1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zM429 239.92l-93.08-.1a2 2 0 01-1.95-1.57 80.08 80.08 0 00-27.44-44.17 2 2 0 01-.54-2.43l41.32-83.43a2 2 0 012.87-.81A176.2 176.2 0 01431 237.71a2 2 0 01-2 2.21zm-220.8 20.46a48 48 0 1143.42 43.42 48 48 0 01-43.42-43.42zm-43.55-152.16L206 191.65a2 2 0 01-.54 2.43A80.08 80.08 0 00178 238.25a2 2 0 01-2 1.57l-93.08.1a2 2 0 01-2-2.21 176.2 176.2 0 0180.82-130.3 2 2 0 012.91.81zm-.37 295.34l56.31-74.09a2 2 0 012.43-.6 79.84 79.84 0 0066 0 2 2 0 012.43.6l56.31 74.09a2 2 0 01-.54 2.92 175.65 175.65 0 01-182.36 0 2 2 0 01-.58-2.92z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3369ee7346336b51(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M352 128c-32.26-2.89-64 16-96 16s-63.75-19-96-16c-64 6-96 64-96 160 0 80 64 192 111.2 192s51.94-24 80.8-24 33.59 24 80.8 24S448 368 448 288c0-96-29-154-96-160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M323.92 83.14c-21 21-45.66 27-58.82 28.79a8 8 0 01-9.1-8.73 97.6 97.6 0 0128.61-59.33c22-22 46-26.9 58.72-27.85a8 8 0 018.67 8.92 98 98 0 01-28.08 58.2z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "216",
                    "cy": "304",
                    "rx": "24",
                    "ry": "48"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "296",
                    "cy": "304",
                    "rx": "24",
                    "ry": "48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1501105562644761(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.71 159.43c-17.6-28.31-45.5-43.8-85.28-47.37-22.82-2-50.23 4.94-72.25 10.55C271.26 125.14 260 128 256 128s-15.18-2.86-25-5.39c-22.08-5.65-49.56-12.69-72.45-10.54-38.53 3.61-66 19.19-84 47.62S48 229 48 288c0 61.28 29.53 114.58 47.13 140.89C116.82 461.34 149.25 496 175.2 496c18.57 0 34.12-7.23 47.82-13.64C243 473 256 472 256 472s11 0 31.94 10.11C301.65 488.73 317.3 496 336.8 496c26.58 0 59.08-34.69 80.63-67.15C434.82 402.65 464 349.52 464 288c0-60-8-100.83-25.29-128.57zM216 352c-13.25 0-24-21.49-24-48s10.75-48 24-48 24 21.49 24 48-10.75 48-24 48zm80 0c-13.25 0-24-21.49-24-48s10.75-48 24-48 24 21.49 24 48-10.75 48-24 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M323.72 82.76C353.68 52.82 352 16.18 352 16.14s-35.77-3.76-67.23 27.67S256.06 112 256.06 112s37.68.71 67.66-29.24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2f652a4eca780224(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439 166.29c-18.67-32.57-47.46-50.81-85.57-54.23-20.18-1.8-39 3.37-57.23 8.38-14.15 3.89-27.52 7.56-40.2 7.56s-26-3.68-40.06-7.57c-18.28-5-37.18-10.26-57.43-8.36-36.39 3.41-65.51 22.11-84.31 54.08C56.82 195.76 48 236.76 48 288c0 40.4 15 90.49 40 134 12.82 22.25 47 74 87.16 74 30.77 0 47.15-9.44 59.11-16.33 8.3-4.78 13.31-7.67 21.69-7.67s13.39 2.89 21.69 7.67c12 6.89 28.35 16.33 59.15 16.33 40.17 0 74.34-51.76 87.16-74 25.07-43.5 40-93.59 40-134 .04-52.57-8.14-92.38-24.96-121.71zM216 352c-13.25 0-24-21.49-24-48s10.75-48 24-48 24 21.49 24 48-10.75 48-24 48zm80 0c-13.25 0-24-21.49-24-48s10.75-48 24-48 24 21.49 24 48-10.75 48-24 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M265.1 111.93c13.16-1.75 37.86-7.83 58.83-28.79a98 98 0 0028-58.2 8 8 0 00-8.55-8.94c-12.71.95-36.76 5.87-58.73 27.85A97.6 97.6 0 00256 103.2a8 8 0 009.1 8.73z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9c7a17f9c7f868d0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48M336 64h112v112M224 288L440 72"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2e1d4d732ea1a12f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.37 288l176-176H48v352h352V134.63l-176 176L201.37 288z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 48v32h89.37l-32 32L400 134.63l32-32V192h32V48H320z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$72f16ad00eed8b01(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 304a16 16 0 01-11.31-27.31l157.94-157.94A55.7 55.7 0 00344 112H104a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h240a56.06 56.06 0 0056-56V168a55.7 55.7 0 00-6.75-26.63L235.31 299.31A15.92 15.92 0 01224 304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48H336a16 16 0 000 32h73.37l-38.74 38.75a56.35 56.35 0 0122.62 22.62L432 102.63V176a16 16 0 0032 0V64a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$90975298d6eb4a8f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 128h80m-384 0h240m64 256h80m-384 0h240m-96-128h240m-384 0h80"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "336",
                    "cy": "128",
                    "r": "32",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "176",
                    "cy": "256",
                    "r": "32",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "336",
                    "cy": "384",
                    "r": "32",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7a4eef4150d0c2cc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M381.25 112a48 48 0 00-90.5 0H48v32h242.75a48 48 0 0090.5 0H464v-32zM176 208a48.09 48.09 0 00-45.25 32H48v32h82.75a48 48 0 0090.5 0H464v-32H221.25A48.09 48.09 0 00176 208zm160 128a48.09 48.09 0 00-45.25 32H48v32h242.75a48 48 0 0090.5 0H464v-32h-82.75A48.09 48.09 0 00336 336z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c6d26444e150dcd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 144h226.75a48 48 0 0090.5 0H448a16 16 0 000-32h-66.75a48 48 0 00-90.5 0H64a16 16 0 000 32zm384 224h-66.75a48 48 0 00-90.5 0H64a16 16 0 000 32h226.75a48 48 0 0090.5 0H448a16 16 0 000-32zm0-128H221.25a48 48 0 00-90.5 0H64a16 16 0 000 32h66.75a48 48 0 0090.5 0H448a16 16 0 000-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$87028004f7ea4aa8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M53.12 199.94l400-151.39a8 8 0 0110.33 10.33l-151.39 400a8 8 0 01-15-.34l-67.4-166.09a16 16 0 00-10.11-10.11L53.46 215a8 8 0 01-.34-15.06zM460 52L227 285"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$817269b2295c8360(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 16L15.88 208 195 289 448 64 223 317l81 179L496 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fc9cdd5803789d9c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M473 39.05a24 24 0 00-25.5-5.46L47.47 185h-.08a24 24 0 001 45.16l.41.13 137.3 58.63a16 16 0 0015.54-3.59L422 80a7.07 7.07 0 0110 10L226.66 310.26a16 16 0 00-3.59 15.54l58.65 137.38c.06.2.12.38.19.57 3.2 9.27 11.3 15.81 21.09 16.25h1a24.63 24.63 0 0023-15.46L478.39 64.62A24 24 0 00473 39.05z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4473f5e660dd8aac(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M90.61 306.85A16.07 16.07 0 00104 293.6C116.09 220.17 169.63 176 232 176c57.93 0 96.62 37.75 112.2 77.74a15.84 15.84 0 0012.2 9.87c50 8.15 91.6 41.54 91.6 99.59 0 59.4-48.6 100.8-108 100.8H106c-49.5 0-90-24.7-90-79.2 0-48.47 38.67-72.22 74.61-77.95z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384.8 271.4a80 80 0 10-123.55-92M464 208h32M336 48v32M222.86 94.86l22.63 22.63m203.65-22.63l-22.63 22.63"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2b1ad6ff4842de7e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340 480H106c-29.5 0-54.92-7.83-73.53-22.64C11.23 440.44 0 415.35 0 384.8c0-26.66 10.08-49.8 29.14-66.91 15.24-13.68 36.17-23.21 59-26.84.06 0 .08 0 .09-.05 6.44-39 23.83-72.09 50.31-95.68A140.24 140.24 0 01232 160c30.23 0 58.48 9.39 81.71 27.17a142.69 142.69 0 0145.36 60.66c29.41 4.82 54.72 17.11 73.19 35.54C453 304.11 464 331.71 464 363.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm19-232.18zm22.5-27.93a169.23 169.23 0 0145.44 19A96 96 0 00281 129.33q-2.85 2-5.54 4.2a162.47 162.47 0 0157.73 28.23 174.53 174.53 0 0148.31 58.13zM448 192h64v32h-64zM320 32h32v64h-32zm-64.65 97.63l12.45-12.45-44.62-44.63-22.63 22.63 33.17 33.17h.6a172 172 0 0121.03 1.28zm148.853-12.46l44.626-44.625 22.627 22.628-44.625 44.625z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7372ff2c644bd004(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340 480H106c-29.5 0-54.92-7.83-73.53-22.64C11.23 440.44 0 415.35 0 384.8c0-26.66 10.08-49.8 29.14-66.91 15.24-13.68 36.17-23.21 59-26.84.06 0 .08 0 .09-.05 6.44-39 23.83-72.09 50.31-95.68A140.24 140.24 0 01232 160c30.23 0 58.48 9.39 81.71 27.17a142.24 142.24 0 0142.19 53.21 16 16 0 0011.19 9c26 5.61 48.4 17.29 65.17 34C453 304.11 464 331.71 464 363.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm19-232.18zm28.89-26.14a168.8 168.8 0 0134.76 14.71 4 4 0 005.82-2.44 97 97 0 003.53-26.68c-.39-52.43-43.48-95.22-95.91-95.27A95.46 95.46 0 00281 129.33h-.06a3.38 3.38 0 001 6 162.45 162.45 0 0151.28 26.4 173.92 173.92 0 0145.32 52.51 16 16 0 009.35 7.44zM496 224h-32a16 16 0 010-32h32a16 16 0 010 32zM336 96a16 16 0 01-16-16V48a16 16 0 0132 0v32a16 16 0 01-16 16zm-90.51 37.49a15.92 15.92 0 01-11.31-4.69l-22.63-22.62a16 16 0 0122.63-22.63l22.62 22.63a16 16 0 01-11.31 27.31zm181.02 0a16 16 0 01-11.31-27.31l22.62-22.63a16 16 0 0122.63 22.63l-22.63 22.62a15.92 15.92 0 01-11.31 4.69z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b88ec0dddefb5444(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M208 192v128m96-128v128"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$32c4535700fc41fc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-32 288h-32V176h32zm96 0h-32V176h32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6ee04580958e93e4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-32 272a16 16 0 01-32 0V192a16 16 0 0132 0zm96 0a16 16 0 01-32 0V192a16 16 0 0132 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a9b40bb279034684(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 96h16v320h-16zm144 0h16v320h-16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ff0da293e2b2b3d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 432h-80V80h80zm144 0h-80V80h80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f40c2b457eb0e935(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 432h-48a16 16 0 01-16-16V96a16 16 0 0116-16h48a16 16 0 0116 16v320a16 16 0 01-16 16zm144 0h-48a16 16 0 01-16-16V96a16 16 0 0116-16h48a16 16 0 0116 16v320a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$697523c54e534ee3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M457.74 170.1a30.26 30.26 0 00-11.16-2.1h-.4c-20.17.3-42.79 19.19-54.66 47.76-14.23 34.18-7.68 69.15 14.74 78.14a30.21 30.21 0 0011.15 2.1c20.27 0 43.2-19 55.17-47.76 14.13-34.18 7.48-69.15-14.84-78.14zM327.6 303.48C299.8 257.35 287.8 240 256 240s-43.9 17.46-71.7 63.48c-23.8 39.36-71.9 42.64-83.9 76.07a50.91 50.91 0 00-3.6 19.25c0 27.19 20.8 49.2 46.4 49.2 31.8 0 75.1-25.39 112.9-25.39S337 448 368.8 448c25.6 0 46.3-22 46.3-49.2a51 51 0 00-3.7-19.25c-12-33.55-60-36.71-83.8-76.07zM192.51 196a26.53 26.53 0 004-.3c23.21-3.37 37.7-35.53 32.44-71.85C224 89.61 203.22 64 181.49 64a26.53 26.53 0 00-4 .3c-23.21 3.37-37.7 35.53-32.44 71.85C150 170.29 170.78 196 192.51 196zm174.41-59.85c5.26-36.32-9.23-68.48-32.44-71.85a26.53 26.53 0 00-4-.3c-21.73 0-42.47 25.61-47.43 59.85-5.26 36.32 9.23 68.48 32.44 71.85a26.53 26.53 0 004 .3c21.73 0 42.51-25.71 47.43-59.85zM105.77 293.9c22.39-9 28.93-44 14.72-78.14C108.53 187 85.62 168 65.38 168a30.21 30.21 0 00-11.15 2.1c-22.39 9-28.93 44-14.72 78.14C51.47 277 74.38 296 94.62 296a30.21 30.21 0 0011.15-2.1z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$182057090179b90d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M442.8 361.82c-8.8-25.1-29.31-37.82-49.11-50.12-17.23-10.71-33.5-20.83-44.14-39-29.33-50.33-45.44-80.7-93.49-80.7s-64.21 30.38-93.61 80.69c-10.65 18.21-27 28.35-44.25 39.08-19.8 12.31-40.27 25-49.1 50.05a78.06 78.06 0 00-5.1 28.29C64 430.85 96.45 464 132.4 464s83.31-18.13 123.76-18.13S343.31 464 379.71 464 448 430.85 448 390.11a78.3 78.3 0 00-5.2-28.29z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "72",
                    "cy": "216",
                    "rx": "56",
                    "ry": "72"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "184",
                    "cy": "120",
                    "rx": "56",
                    "ry": "72"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "328",
                    "cy": "120",
                    "rx": "56",
                    "ry": "72"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "440",
                    "cy": "216",
                    "rx": "56",
                    "ry": "72"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$455e816c97885c4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490.39 182.75c-5.55-13.19-14.77-22.7-26.67-27.49l-.16-.06a46.46 46.46 0 00-17-3.2h-.64c-27.24.41-55.05 23.56-69.19 57.61-10.37 24.9-11.56 51.68-3.18 71.64 5.54 13.2 14.78 22.71 26.73 27.5l.13.05a46.53 46.53 0 0017 3.2c27.5 0 55.6-23.15 70-57.65 10.24-24.87 11.37-51.63 2.98-71.6zM381.55 329.61c-15.71-9.44-30.56-18.37-40.26-34.41C314.53 250.8 298.37 224 256 224s-58.57 26.8-85.39 71.2c-9.72 16.06-24.6 25-40.36 34.48-18.07 10.86-36.74 22.08-44.8 44.16a66.93 66.93 0 00-4.65 25c0 35.95 28 65.2 62.4 65.2 17.75 0 36.64-6.15 56.63-12.66 19.22-6.26 39.09-12.73 56.27-12.73s37 6.47 56.15 12.73C332.2 457.85 351 464 368.8 464c34.35 0 62.3-29.25 62.3-65.2a67 67 0 00-4.75-25c-8.06-22.1-26.74-33.33-44.8-44.19zM150 188.85c11.9 14.93 27 23.15 42.52 23.15a42.88 42.88 0 006.33-.47c32.37-4.76 52.54-44.26 45.92-90C242 102.3 234.6 84.39 224 71.11 212.12 56.21 197 48 181.49 48a42.88 42.88 0 00-6.33.47c-32.37 4.76-52.54 44.26-45.92 90 2.76 19.2 10.16 37.09 20.76 50.38zm163.16 22.68a42.88 42.88 0 006.33.47c15.53 0 30.62-8.22 42.52-23.15 10.59-13.29 17.95-31.18 20.75-50.4 6.62-45.72-13.55-85.22-45.92-90a42.88 42.88 0 00-6.33-.47C315 48 299.88 56.21 288 71.11c-10.6 13.28-18 31.19-20.76 50.44-6.62 45.72 13.55 85.22 45.92 89.98zM111.59 308.8l.14-.05c11.93-4.79 21.16-14.29 26.69-27.48 8.38-20 7.2-46.75-3.15-71.65C120.94 175.16 92.85 152 65.38 152a46.4 46.4 0 00-17 3.2l-.14.05c-11.9 4.75-21.13 14.29-26.66 27.48-8.38 20-7.2 46.75 3.15 71.65C39.06 288.84 67.15 312 94.62 312a46.4 46.4 0 0016.97-3.2z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e92b3db34c45f2d5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M364.13 125.25L87 403l-23 45 44.99-23 277.76-277.13-22.62-22.62zm56.56-56.56l-22.62 22.62 22.62 22.63 22.62-22.63a16 16 0 000-22.62h0a16 16 0 00-22.62 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3e25aa50f16b93bd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103 464H48v-55L358.14 98.09l55.77 55.78L103 464zm322.72-322L370 86.28l31.66-30.66C406.55 50.7 414.05 48 421 48a25.91 25.91 0 0118.42 7.62l17 17A25.87 25.87 0 01464 91c0 7-2.71 14.45-7.62 19.36zm-7.52-70.83z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a1d2e5d54659c33c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M358.62 129.28L86.49 402.08 70 442l39.92-16.49 272.8-272.13-24.1-24.1zm54.45-54.44l-11.79 11.78 24.1 24.1 11.79-11.79a16.51 16.51 0 000-23.34l-.75-.75a16.51 16.51 0 00-23.35 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$37e8cc9a07a16435(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208zm0-384c-97 0-176 79-176 176s79 176 176 176 176-78.95 176-176S353.05 80 256 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M323.67 292c-17.4 0-34.21-7.72-47.34-21.73a83.76 83.76 0 01-22-51.32c-1.47-20.7 4.88-39.75 17.88-53.62S303.38 144 323.67 144c20.14 0 38.37 7.62 51.33 21.46s19.47 33 18 53.51a84 84 0 01-22 51.3C357.86 284.28 341.06 292 323.67 292zm55.81-74zm-215.66 77.36c-29.76 0-55.93-27.51-58.33-61.33-1.23-17.32 4.15-33.33 15.17-45.08s26.22-18 43.15-18 32.12 6.44 43.07 18.14 16.5 27.82 15.25 45c-2.44 33.77-28.6 61.27-58.31 61.27zm256.55 59.92c-1.59-4.7-5.46-9.71-13.22-14.46-23.46-14.33-52.32-21.91-83.48-21.91-30.57 0-60.23 7.9-83.53 22.25-26.25 16.17-43.89 39.75-51 68.18-1.68 6.69-4.13 19.14-1.51 26.11a192.18 192.18 0 00232.75-80.17zm-256.74 46.09c7.07-28.21 22.12-51.73 45.47-70.75a8 8 0 00-2.59-13.77c-12-3.83-25.7-5.88-42.69-5.88-23.82 0-49.11 6.45-68.14 18.17-5.4 3.33-10.7 4.61-14.78 5.75a192.84 192.84 0 0077.78 86.64l1.79-.14a102.82 102.82 0 013.16-20.02z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$64f46088fbb3c9b6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm69.3 96.17a72.5 72.5 0 11-72.6 72.5 72.55 72.55 0 0172.6-72.5zm-155.1 26.36a59.32 59.32 0 11-59.4 59.32 59.35 59.35 0 0159.4-59.32zm-75.85 155c24.5-13.29 55.87-19.94 75.85-19.94 15 0 34.32 3 53.33 10.2a133.05 133.05 0 00-34 27.11c-13.19 15-20.76 32.92-20.76 50.83v15a177.06 177.06 0 01-74.42-83.15zM256 432a175.12 175.12 0 01-59.4-10.33v-27.05c0-52.59 85.75-79.09 128.7-79.09 23 0 58.38 7.63 86.21 22.81A176.14 176.14 0 01256 432z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$af91405bec0e9a14(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zm-3.68 152.11c.21-1.2.44-2.4.71-3.59a66.46 66.46 0 0116.29-31.21c12.89-13.73 31.16-21.31 51.45-21.31a74.05 74.05 0 0125.06 4.26 66.69 66.69 0 0126.27 17.2 68.15 68.15 0 0118 42.14 78.46 78.46 0 010 11.4 86.19 86.19 0 01-8.2 31q-.76 1.59-1.59 3.15c-1.11 2.07-2.3 4.1-3.58 6.06a79.47 79.47 0 01-8.63 11c-13.12 14-29.92 21.73-47.31 21.73a59.61 59.61 0 01-19.17-3.18 63.47 63.47 0 01-6.1-2.43 70.76 70.76 0 01-22.07-16.12 83.76 83.76 0 01-22-51.32q-.27-3.88-.18-7.68a75.62 75.62 0 011.05-11.08zm-149.73 24.34a59.87 59.87 0 015.2-20.64 56.76 56.76 0 012.78-5.3 54.49 54.49 0 017.19-9.56 55.62 55.62 0 0114-10.82 56.84 56.84 0 018.11-3.64 63.85 63.85 0 0133.35-2.39 57 57 0 0130.78 17 57.86 57.86 0 0115.41 38.62c.05 2.11 0 4.23-.15 6.38a71.58 71.58 0 01-6 23.84 69.49 69.49 0 01-5.73 10.42 65.39 65.39 0 01-15.76 16.57c-1.5 1.07-3.06 2.07-4.67 3.07a54.21 54.21 0 01-10 4.65 49.31 49.31 0 01-16.2 2.76c-.93 0-1.86 0-2.78-.08a47.6 47.6 0 01-5.48-.62 51.19 51.19 0 01-5.35-1.23 53.54 53.54 0 01-7.72-2.89c-.84-.39-1.66-.8-2.48-1.23-18-9.49-31.57-29.16-34.23-52.12-.12-1.05-.22-2.1-.29-3.16a66.59 66.59 0 01.02-9.63zm53.92 178.6a177.27 177.27 0 01-61.94-70.65 4 4 0 011.62-5.26C117.67 316.69 141.4 311 163.82 311c17 0 30.7 2 42.69 5.88a8 8 0 012.59 13.77c-23.35 19-38.4 42.54-45.47 70.75a2.77 2.77 0 01-4.22 1.65zM256 432a175.12 175.12 0 01-65.7-12.72 4 4 0 01-2.4-4.46c.4-2.05.84-3.92 1.23-5.48 7.12-28.43 24.76-52 51-68.18 23.29-14.35 53-22.25 83.52-22.25 31.16 0 60 7.58 83.48 21.91a2.72 2.72 0 01.91 3.67A176.1 176.1 0 01256 432z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M161 295.28a47.6 47.6 0 01-5.48-.62 47.6 47.6 0 005.48.62zm-26.36-117.15a55.62 55.62 0 00-14 10.82 54.49 54.49 0 00-7.19 9.56 54.49 54.49 0 017.19-9.56 55.62 55.62 0 0114-10.82zm81.53 79.76a71.58 71.58 0 006-23.84c.15-2.15.2-4.27.15-6.38q.08 3.15-.15 6.38a71.58 71.58 0 01-6 23.84zm-81.53-79.76a56.84 56.84 0 018.11-3.64 56.84 56.84 0 00-8.11 3.64zm15.57 115.3a53.54 53.54 0 01-7.72-2.89 53.54 53.54 0 007.72 2.89zm-44.43-56.24c2.66 23 16.26 42.63 34.23 52.12-18.01-9.49-31.57-29.16-34.23-52.12zM254.34 219a83.76 83.76 0 0022 51.32 70.76 70.76 0 0022.07 16.12 70.76 70.76 0 01-22.07-16.12 83.76 83.76 0 01-22-51.32q-.27-3.88-.18-7.68-.09 3.75.18 7.68zm50.16 69.82a63.47 63.47 0 01-6.1-2.43 63.47 63.47 0 006.1 2.43zm-48.57-92.28a66.46 66.46 0 0116.29-31.21 66.46 66.46 0 00-16.29 31.21zM375 165.46a68.15 68.15 0 0118 42.14 68.15 68.15 0 00-18-42.14 66.69 66.69 0 00-26.27-17.2 66.69 66.69 0 0126.27 17.2zM393 219a86.19 86.19 0 01-8.2 31 86.19 86.19 0 008.2-31zm-138.84-7.73a75.62 75.62 0 011.06-11.14 75.62 75.62 0 00-1.06 11.14zm129.03 41.89zm-176.31-64.11a57.86 57.86 0 0115.41 38.62 57.86 57.86 0 00-15.41-38.62 57 57 0 00-30.78-17 57 57 0 0130.78 17zM190 288a54.21 54.21 0 01-10 4.65 54.21 54.21 0 0010-4.65zm-84.51-63.55a59.87 59.87 0 015.2-20.64 59.87 59.87 0 00-5.2 20.64zm89.19 60.43C193.17 286 191.61 287 190 288c1.61-1 3.17-2 4.68-3.12zm21.49-26.99a69.49 69.49 0 01-5.73 10.42 69.49 69.49 0 005.73-10.42zm-105.48-54.08a56.76 56.76 0 012.78-5.3 56.76 56.76 0 00-2.78 5.3zm83.99 81.07a65.39 65.39 0 0015.76-16.57 65.39 65.39 0 01-15.76 16.57z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$68ccb1a64ca36240(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M402 168c-2.93 40.67-33.1 72-66 72s-63.12-31.32-66-72c-3-42.31 26.37-72 66-72s69 30.46 66 72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M336 304c-65.17 0-127.84 32.37-143.54 95.41-2.08 8.34 3.15 16.59 11.72 16.59h263.65c8.57 0 13.77-8.25 11.72-16.59C463.85 335.36 401.18 304 336 304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M200 185.94c-2.34 32.48-26.72 58.06-53 58.06s-50.7-25.57-53-58.06C91.61 152.15 115.34 128 147 128s55.39 24.77 53 57.94z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M206 306c-18.05-8.27-37.93-11.45-59-11.45-52 0-102.1 25.85-114.65 76.2-1.65 6.66 2.53 13.25 9.37 13.25H154"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3148cac48efa80e5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "152",
                    "cy": "184",
                    "r": "72"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M234 296c-28.16-14.3-59.24-20-82-20-44.58 0-136 27.34-136 82v42h150v-16.07c0-19 8-38.05 22-53.93 11.17-12.68 26.81-24.45 46-34z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M340 288c-52.07 0-156 32.16-156 96v48h312v-48c0-63.84-103.93-96-156-96z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "340",
                    "cy": "168",
                    "r": "88"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$20bf8eabc0f3317a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 256c-20.56 0-40.44-9.18-56-25.84-15.13-16.25-24.37-37.92-26-61-1.74-24.62 5.77-47.26 21.14-63.76S312 80 336 80c23.83 0 45.38 9.06 60.7 25.52 15.47 16.62 23 39.22 21.26 63.63-1.67 23.11-10.9 44.77-26 61C376.44 246.82 356.57 256 336 256zm66-88zm65.83 264H204.18a27.71 27.71 0 01-22-10.67 30.22 30.22 0 01-5.26-25.79c8.42-33.81 29.28-61.85 60.32-81.08C264.79 297.4 299.86 288 336 288c36.85 0 71 9 98.71 26.05 31.11 19.13 52 47.33 60.38 81.55a30.27 30.27 0 01-5.32 25.78A27.68 27.68 0 01467.83 432zM147 260c-35.19 0-66.13-32.72-69-72.93-1.42-20.6 5-39.65 18-53.62 12.86-13.83 31-21.45 51-21.45s38 7.66 50.93 21.57c13.1 14.08 19.5 33.09 18 53.52-2.87 40.2-33.8 72.91-68.93 72.91zm65.66 31.45c-17.59-8.6-40.42-12.9-65.65-12.9-29.46 0-58.07 7.68-80.57 21.62-25.51 15.83-42.67 38.88-49.6 66.71a27.39 27.39 0 004.79 23.36A25.32 25.32 0 0041.72 400h111a8 8 0 007.87-6.57c.11-.63.25-1.26.41-1.88 8.48-34.06 28.35-62.84 57.71-83.82a8 8 0 00-.63-13.39c-1.57-.92-3.37-1.89-5.42-2.89z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2a51a0ff014fb59a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M376 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M288 304c-87 0-175.3 48-191.64 138.6-2 10.92 4.21 21.4 15.65 21.4H464c11.44 0 17.62-10.48 15.65-21.4C463.3 352 375 304 288 304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M88 176v112m56-56H32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5b9dc027567035e9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M106 304v-54h54v-36h-54v-54H70v54H16v36h54v54h36z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "288",
                    "cy": "144",
                    "r": "112"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M288 288c-69.42 0-208 42.88-208 128v64h416v-64c0-85.12-138.58-128-208-128z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$76a521a845f46994(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 256c52.79 0 99.43-49.71 104-110.82 2.27-30.7-7.36-59.33-27.12-80.6C345.33 43.57 318 32 288 32c-30.24 0-57.59 11.5-77 32.38-19.63 21.11-29.2 49.8-27 80.78C188.49 206.28 235.12 256 288 256zm207.38 183.76c-8.44-46.82-34.79-86.15-76.19-113.75C382.42 301.5 335.83 288 288 288s-94.42 13.5-131.19 38c-41.4 27.6-67.75 66.93-76.19 113.75-1.93 10.73.69 21.34 7.19 29.11A30.94 30.94 0 00112 480h352a30.94 30.94 0 0024.21-11.13c6.48-7.77 9.1-18.38 7.17-29.11zM104 288v-40h40a16 16 0 000-32h-40v-40a16 16 0 00-32 0v40H32a16 16 0 000 32h40v40a16 16 0 0032 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7a9d88f3b732f402(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zm126.42 327.25a4 4 0 01-6.14-.32 124.27 124.27 0 00-32.35-29.59C321.37 329 289.11 320 256 320s-65.37 9-90.83 25.34a124.24 124.24 0 00-32.35 29.58 4 4 0 01-6.14.32A175.32 175.32 0 0180 259c-1.63-97.31 78.22-178.76 175.57-179S432 158.81 432 256a175.32 175.32 0 01-46.68 119.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 144c-19.72 0-37.55 7.39-50.22 20.82s-19 32-17.57 51.93C191.11 256 221.52 288 256 288s64.83-32 67.79-71.24c1.48-19.74-4.8-38.14-17.68-51.82C293.39 151.44 275.59 144 256 144z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$72a76d7491922646(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm2 96a72 72 0 11-72 72 72 72 0 0172-72zm-2 288a175.55 175.55 0 01-129.18-56.6C135.66 329.62 215.06 320 256 320s120.34 9.62 129.18 55.39A175.52 175.52 0 01256 432z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a90854a52dd9599(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-50.22 116.82C218.45 151.39 236.28 144 256 144s37.39 7.44 50.11 20.94c12.89 13.68 19.16 32.06 17.68 51.82C320.83 256 290.43 288 256 288s-64.89-32-67.79-71.25c-1.47-19.92 4.79-38.36 17.57-51.93zM256 432a175.49 175.49 0 01-126-53.22 122.91 122.91 0 0135.14-33.44C190.63 329 222.89 320 256 320s65.37 9 90.83 25.34A122.87 122.87 0 01382 378.78 175.45 175.45 0 01256 432z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ac0c3eb1428ca374(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M344 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 304c-87 0-175.3 48-191.64 138.6C62.39 453.52 68.57 464 80 464h352c11.44 0 17.62-10.48 15.65-21.4C431.3 352 343 304 256 304z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1d43f7cc5c40e616(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M376 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M288 304c-87 0-175.3 48-191.64 138.6-2 10.92 4.21 21.4 15.65 21.4H464c11.44 0 17.62-10.48 15.65-21.4C463.3 352 375 304 288 304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 232H32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cff54262d1384cb9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 214h144v36H16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "288",
                    "cy": "144",
                    "r": "112"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M288 288c-69.42 0-208 42.88-208 128v64h416v-64c0-85.12-138.58-128-208-128z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d3274a263f20e9fe(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 256c52.79 0 99.43-49.71 104-110.82 2.27-30.7-7.36-59.33-27.12-80.6C345.33 43.57 318 32 288 32c-30.24 0-57.59 11.5-77 32.38-19.63 21.11-29.2 49.8-27 80.78C188.49 206.28 235.12 256 288 256zm207.38 183.76c-8.44-46.82-34.79-86.15-76.19-113.75C382.42 301.5 335.83 288 288 288s-94.42 13.5-131.19 38c-41.4 27.6-67.75 66.93-76.19 113.75-1.93 10.73.69 21.34 7.19 29.11A30.94 30.94 0 00112 480h352a30.94 30.94 0 0024.21-11.13c6.48-7.77 9.1-18.38 7.17-29.11zM144 216H32a16 16 0 000 32h112a16 16 0 000-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7d14102737f61b01(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 256a112 112 0 10-112-112 112 112 0 00112 112zm0 32c-69.42 0-208 42.88-208 128v64h416v-64c0-85.12-138.58-128-208-128z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$429d373328cee5a9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M332.64 64.58C313.18 43.57 286 32 256 32c-30.16 0-57.43 11.5-76.8 32.38-19.58 21.11-29.12 49.8-26.88 80.78C156.76 206.28 203.27 256 256 256s99.16-49.71 103.67-110.82c2.27-30.7-7.33-59.33-27.03-80.6zM432 480H80a31 31 0 01-24.2-11.13c-6.5-7.77-9.12-18.38-7.18-29.11C57.06 392.94 83.4 353.61 124.8 326c36.78-24.51 83.37-38 131.2-38s94.42 13.5 131.2 38c41.4 27.6 67.74 66.93 76.18 113.75 1.94 10.73-.68 21.34-7.18 29.11A31 31 0 01432 480z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bb8aebf418af94a7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "256",
                    "height": "480",
                    "x": "128",
                    "y": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48",
                    "transform": "rotate(-90 256 256)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M16 336v-24a8 8 0 018-8h0a16 16 0 0016-16v-64a16 16 0 00-16-16h0a8 8 0 01-8-8v-24"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bad81cbdd2f1704e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 130v252a18 18 0 0018 18h476a18 18 0 0018-18V130a18 18 0 00-18-18H18a18 18 0 00-18 18zm448 234H64V148h384z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$817d28aa0e5e75cf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 176v160a64 64 0 0064 64h384a64 64 0 0064-64V176a64 64 0 00-64-64H64a64 64 0 00-64 64zm448-32a32 32 0 0132 32v160a32 32 0 01-32 32H64a32 32 0 01-32-32v-11.35a7.94 7.94 0 014.75-7.3A32 32 0 0056 288v-64a32 32 0 00-19.25-29.35 7.94 7.94 0 01-4.75-7.3V176a32 32 0 0132-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M48 176a11.88 11.88 0 004.69 9.53A48 48 0 0172 224v64a48 48 0 01-19.31 38.47A11.88 11.88 0 0048 336a16 16 0 0016 16h384a16 16 0 0016-16V176a16 16 0 00-16-16H64a16 16 0 00-16 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 176v160a64 64 0 0064 64h384a64 64 0 0064-64V176a64 64 0 00-64-64H64a64 64 0 00-64 64zm448-32a32 32 0 0132 32v160a32 32 0 01-32 32H64a32 32 0 01-32-32v-11.35a7.94 7.94 0 014.75-7.3A32 32 0 0056 288v-64a32 32 0 00-19.25-29.35 7.94 7.94 0 01-4.75-7.3V176a32 32 0 0132-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$da7d51c5af8244be(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "256",
                    "height": "480",
                    "x": "128",
                    "y": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 16h24a8 8 0 018 8h0a16 16 0 0016 16h64a16 16 0 0016-16h0a8 8 0 018-8h24"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f2d9ccfe50dfa59f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382 0H130a18 18 0 00-18 18v476a18 18 0 0018 18h252a18 18 0 0018-18V18a18 18 0 00-18-18zM148 448V64h216v384z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7744f31a986a15d6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H176a64 64 0 00-64 64v384a64 64 0 0064 64h160a64 64 0 0064-64V64a64 64 0 00-64-64zm32 448a32 32 0 01-32 32H176a32 32 0 01-32-32V64a32 32 0 0132-32h11.35a7.94 7.94 0 017.3 4.75A32 32 0 00224 56h64a32 32 0 0029.35-19.25 7.94 7.94 0 017.3-4.75H336a32 32 0 0132 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 48a11.88 11.88 0 00-9.53 4.69A48 48 0 01288 72h-64a48 48 0 01-38.47-19.31A11.88 11.88 0 00176 48a16 16 0 00-16 16v384a16 16 0 0016 16h160a16 16 0 0016-16V64a16 16 0 00-16-16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H176a64 64 0 00-64 64v384a64 64 0 0064 64h160a64 64 0 0064-64V64a64 64 0 00-64-64zm32 448a32 32 0 01-32 32H176a32 32 0 01-32-32V64a32 32 0 0132-32h11.35a7.94 7.94 0 017.3 4.75A32 32 0 00224 56h64a32 32 0 0029.35-19.25 7.94 7.94 0 017.3-4.75H336a32 32 0 0132 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9e5c76196191a9e0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256.05 80.65Q263.94 80 272 80c106 0 192 86 192 192s-86 192-192 192A192.09 192.09 0 0189.12 330.65"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 48C141.12 48 48 141.12 48 256a207.29 207.29 0 0018.09 85L256 256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f69f8d1629058865(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M58 362.09l-6.51-14.59A224 224 0 01256 32h16v234.37z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M304 66.46v220.65L94.62 380.78A208.31 208.31 0 00272 480c114.69 0 208-93.31 208-208 0-103.81-76.45-190.1-176-205.54z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e63eb6b7773eba33(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M66.1 357a16 16 0 01-14.61-9.46A224 224 0 01256 32a16 16 0 0116 16v208a16 16 0 01-9.47 14.61l-189.9 84.95A15.93 15.93 0 0166.1 357z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M313.59 68.18A8 8 0 00304 76v180a48.07 48.07 0 01-28.4 43.82L103.13 377a8 8 0 00-3.35 11.81 208.42 208.42 0 0048.46 50.41A206.32 206.32 0 00272 480c114.69 0 208-93.31 208-208 0-100.45-71.58-184.5-166.41-203.82z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$de16139fc844473e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "96",
                    "r": "64",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M272 164a9 9 0 00-9-9h-14a9 9 0 00-9 9v293.56a32.09 32.09 0 002.49 12.38l10.07 24a3.92 3.92 0 006.88 0l10.07-24a32.09 32.09 0 002.49-12.38z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "280",
                    "cy": "72",
                    "r": "24"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4e25cca995b0d4da(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M339 99a83 83 0 10-102 80.8V464l19 32 19-32V179.8A83.28 83.28 0 00339 99zm-59-6a21 21 0 1121-21 21 21 0 01-21 21z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$48c212d82f5ca6b1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 96a80 80 0 10-96 78.39v283.17a32.09 32.09 0 002.49 12.38l10.07 24a3.92 3.92 0 006.88 0l10.07-24a32.09 32.09 0 002.49-12.38V174.39A80.13 80.13 0 00336 96zm-56 0a24 24 0 1124-24 24 24 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$faa92e5e0bf48a20(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M132.43 162c-6.24-34-4.49-45.55-3.07-68.39L132.27 47a16 16 0 0115.94-15h215.57a16 16 0 0115.94 15l2.91 46.61c1.43 22.86 3.19 34.39-3.06 68.45-5.93 32.29-43.71 133.27-43.71 238.32V472a8 8 0 01-8 8H184.12a8 8 0 01-8-8v-71.63c.01-92.47-37.46-204.3-43.69-238.37zm2.78-66h241.58"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b135029c35fdf013(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399 99.29L394 16H118.45L113 99.26c-1.29 19.24-2.23 33.14 3.73 65.66 1.67 9.11 5.22 22.66 9.73 39.82 12.61 48 33.71 128.36 33.71 195.63V496h191.68v-95.62c0-77.09 21.31-153.29 34-198.81 4.38-15.63 7.83-28 9.41-36.62 6.01-32.51 5.07-46.42 3.74-65.66zM146.23 80l2-32h215.52l2 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f854957d52f4e50d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399 99.29c-.15-2.13-.3-4.35-.44-6.68L395.69 46a32 32 0 00-31.91-30H148.21a32 32 0 00-31.91 30l-2.91 46.63c-.14 2.31-.29 4.51-.43 6.62-1.29 19.24-2.23 33.14 3.73 65.66 1.67 9.11 5.22 22.66 9.73 39.82 12.61 48 33.71 128.36 33.71 195.63V472a24 24 0 0024 24h143.74a24 24 0 0024-24v-71.62c0-77.09 21.31-153.29 34-198.81 4.38-15.63 7.83-28 9.41-36.62 5.99-32.51 5.05-46.42 3.72-65.66zm-35-47.54l1.5 24a4 4 0 01-4 4.25h-211a4 4 0 01-4-4.25l1.48-24A4 4 0 01152 48h208a4 4 0 014 3.75z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2004776e251f0f51(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M404.76 123.08C358.37 104.18 309.69 96 256 96s-106.1 9-148.9 26.68c-8.08 3.3-15.26 9-10.07 19.5C101.24 150.71 203 375 241.66 455a15.94 15.94 0 0028.72 0l144.05-312.22c3.19-6.9.9-15.4-9.67-19.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M436.38 82.68C384.31 62.08 320.17 48 256 48S128.65 60.78 75.48 82.08C70.79 84 62 88.43 64.41 95.88L74.09 120c4 8.2 8.67 8.2 15.06 8.2 1.79 0 4.29-1 7.28-2.18A442.46 442.46 0 01256 96c56.76 0 114.91 12 159.6 30 3.59 1.4 5.59 2.18 7.28 2.18 6.58 0 10.38 2.19 15-8.1L447.65 96c2.01-6-4.99-10.82-11.27-13.32z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "192",
                    "cy": "192",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "320",
                    "cy": "208",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "320",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7638493276924573(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M442.3 67.82C383.92 44.72 317.78 32 256 32c-63.57 0-129.8 12.51-186.56 35.25C49.18 75.48 42 80 42 80l22 44 37.53-16.14C147.58 89.53 199.19 80 256.51 80c57.49 0 108.09 9.23 154.75 28.25L448 124l22-44s-7-4-27.7-12.18z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "320.48",
                    "cy": "207.99",
                    "fill": "none",
                    "rx": "31.97",
                    "ry": "32.03",
                    "transform": "rotate(-44.98 320.503 207.996)"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "192.48",
                    "cy": "191.99",
                    "fill": "none",
                    "rx": "31.97",
                    "ry": "32.03",
                    "transform": "rotate(-44.98 192.49 191.992)"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256.48",
                    "cy": "319.99",
                    "fill": "none",
                    "rx": "31.97",
                    "ry": "32.03",
                    "transform": "rotate(-44.98 256.505 320)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M409.66 140.85C364.15 122.52 308.16 112 256 112a425 425 0 00-153.7 28.9c-.25.1-9.24 4.23-19 8.71 7.46 16.22 18 39.16 22.2 48.33L256 480l173.74-330.84-19.92-8.24zm-185.25 53.22a32 32 0 11-34-34 32.12 32.12 0 0134 34zm64 128a32 32 0 11-34-34 32.12 32.12 0 0134 34zm64-112a32 32 0 11-34-34 32.12 32.12 0 0134 34z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f3f9677265618e42(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M441.82 67.83C383.44 44.73 317.3 32 255.56 32 192 32 125.76 44.53 69 67.26 48.7 75.49 45.21 90 48.71 100.82L52.78 111a16 16 0 0021.31 8.69c10.8-4.76 23.93-10.54 27-11.78C145.1 89.64 198.71 80 256 80c57.47 0 108.09 9.24 154.76 28.25 4.42 1.8 14.88 6.42 26.17 11.46a16 16 0 0021.35-8.59L462 102l.34-.9c3.45-10.21.14-25.05-20.52-33.27z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M409.18 140.86C363.67 122.53 307.68 112 255.56 112a425 425 0 00-153.74 28.89c-.53.21-2.06.88-4.29 1.88a16 16 0 00-8 21.27c4 8.71 9.42 20.58 15.5 33.89C137.94 270 199.21 404 227.26 462A31.74 31.74 0 00256 480a31.73 31.73 0 0028.76-18.06l.06-.13 137.3-297.57a15.94 15.94 0 00-8.31-21.45c-2.26-.95-3.85-1.61-4.5-1.87zm-215.1 83.07a32 32 0 1129.85-29.85 32 32 0 01-29.85 29.85zm64 128a32 32 0 1129.85-29.85 32 32 0 01-29.85 29.85zm64-112a32 32 0 1129.85-29.85 32 32 0 01-29.85 29.85z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$587381a655cf3e51(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M413.48 284.46c58.87 47.24 91.61 89 80.31 108.55-17.85 30.85-138.78-5.48-270.1-81.15S.37 149.84 18.21 119c11.16-19.28 62.58-12.32 131.64 14.09"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "160",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6be32be1117a97bb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M81 274.71C90.36 363 165.26 432 256 432a174.91 174.91 0 0071.49-15.19c-40.3-16.53-84.05-38.17-127.77-63.36C157 328.86 115.84 301.5 81 274.71zm411.72 64.8c-8.5-11.31-20-23.8-34-37a205.25 205.25 0 01-11 34c28.72 29.5 33.2 45.34 32.17 48.45-2 2.23-17.05 6.89-58.15-3.53q-8.83-2.24-19.32-5.46-6.76-2.08-13.79-4.49a176.76 176.76 0 0019.54-27.25c.17-.29.35-.58.52-.88A175.39 175.39 0 00432 256a178.87 178.87 0 00-1-19c-9.57-88.17-84.4-157-175-157a175.37 175.37 0 00-106.4 35.89 177.4 177.4 0 00-45.83 51.84c-.16.29-.34.58-.51.87a175.48 175.48 0 00-13.83 30.52q-5.59-4.87-10.79-9.67c-5.39-5-10.17-9.63-14.42-14-29.57-30.26-33.09-45.61-32.16-48.45 2.16-2.43 18.1-6.54 58.13 3.55a209.88 209.88 0 0124-26.56c-18.86-5.61-35.79-9.35-50.05-11C33.41 89.47 13.3 95.52 4.35 111c-3.24 5.58-6.35 15.09-2.72 28.6C7 159.66 26.14 184 53.23 209.5c8.63 8.13 18.06 16.37 28.12 24.64 7.32 6 15 12.06 22.9 18.08q7.91 6 16.15 12T137.1 276c25.41 17.61 52.26 34.52 78.59 49.69q14.34 8.26 28.64 16t28.37 14.81c21.9 11 43.35 20.92 63.86 29.43q13.19 5.48 25.81 10.16c11.89 4.42 23.37 8.31 34.31 11.59l1.1.33c25.73 7.66 47.42 11.69 64.48 12H464c21.64 0 36.3-6.38 43.58-19 9.09-15.62 4.08-36.32-14.86-61.5z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c5ee6dbefe5c1e67(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96.85 286.62a8 8 0 00-12.53 8.25C102.07 373.28 172.3 432 256 432a175.31 175.31 0 0052.41-8 8 8 0 00.79-15 1120 1120 0 01-109.48-55.61 1126.24 1126.24 0 01-102.87-66.77zm395.87 52.89c-4.19-5.58-9.11-11.44-14.7-17.53a15.83 15.83 0 00-26.56 5.13c0 .16-.11.31-.17.47a15.75 15.75 0 003.15 16.06c22.74 25 26.42 38.51 25.48 41.36-2 2.23-17.05 6.89-58.15-3.53q-8.83-2.24-19.32-5.46-6.76-2.08-13.79-4.49a176.76 176.76 0 0019.54-27.25c.17-.29.35-.58.52-.88A175.39 175.39 0 00432 256a178.87 178.87 0 00-1-19c-9.57-88.17-84.4-157-175-157a175.37 175.37 0 00-106.4 35.89 177.4 177.4 0 00-45.83 51.84c-.16.29-.34.58-.51.87a175.48 175.48 0 00-13.83 30.52q-5.59-4.87-10.79-9.67c-5.39-5-10.17-9.63-14.42-14-29.57-30.26-33.09-45.61-32.16-48.45 2-2.23 15.54-5.87 48.62 1.31A15.82 15.82 0 0096.22 123l.36-.44a15.74 15.74 0 00-8.67-25.43A237.38 237.38 0 0064.13 93c-30.72-3.53-50.83 2.52-59.78 18-3.24 5.58-6.35 15.09-2.72 28.6C7 159.66 26.14 184 53.23 209.5c8.63 8.13 18.06 16.37 28.12 24.64 7.32 6 15 12.06 22.9 18.08q7.91 6 16.15 12T137.1 276c25.41 17.61 52.26 34.52 78.59 49.69q14.34 8.26 28.64 16t28.37 14.81c21.9 11 43.35 20.92 63.86 29.43q13.19 5.48 25.81 10.16c11.89 4.42 23.37 8.31 34.31 11.59l1.1.33c25.73 7.66 47.42 11.69 64.48 12H464c21.64 0 36.3-6.38 43.58-19 9.09-15.62 4.08-36.32-14.86-61.5z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f72e29427704d7d8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M117.23 246.7l114.45-69.14a10.78 10.78 0 0116.32 9.31v53.32l103.68-62.63a10.78 10.78 0 0116.32 9.31v138.26a10.78 10.78 0 01-16.32 9.31L248 271.81v53.32a10.78 10.78 0 01-16.32 9.31L117.23 265.3a10.89 10.89 0 010-18.6z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$de7353ec79e2bcf2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.69 93.31 208 208 208s208-93.31 208-208S370.69 48 256 48 48 141.31 48 256zm63.47 0L248 168v72.16l120-72.48v176.45l-120-72.32v71.44z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$64ed7099b9e67a87(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.69 93.31 208 208 208s208-93.31 208-208S370.69 48 256 48 48 141.31 48 256zm69.23-9.3l114.45-69.14a10.78 10.78 0 0116.32 9.31v53.32l103.68-62.63a10.78 10.78 0 0116.32 9.31v138.26a10.78 10.78 0 01-16.32 9.31L248 271.81v53.32a10.78 10.78 0 01-16.32 9.31L117.23 265.3a10.89 10.89 0 010-18.6z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4cf1f92f8b1a4ecd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M480 145.52v221c0 13.28-13 21.72-23.63 15.35L267.5 268.8c-9.24-5.53-9.24-20.07 0-25.6l188.87-113C467 123.8 480 132.24 480 145.52zm-228.57 0v221c0 13.28-13 21.72-23.63 15.35L38.93 268.8c-9.24-5.53-9.24-20.07 0-25.6l188.87-113c10.64-6.4 23.63 2.04 23.63 15.32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$44bb95e3153b3ac9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 400L256 256l240-144v288zm-240 0L16 256l240-144v288z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9ff0b121726ca79d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M30.71 229.47l188.87-113a30.54 30.54 0 0131.09-.39 33.74 33.74 0 0116.76 29.47v79.05l180.72-108.16a30.54 30.54 0 0131.09-.39A33.74 33.74 0 01496 145.52v221A33.73 33.73 0 01479.24 396a30.54 30.54 0 01-31.09-.39L267.43 287.4v79.08A33.73 33.73 0 01250.67 396a30.54 30.54 0 01-31.09-.39l-188.87-113a31.27 31.27 0 010-53z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$28c4126e166edb86(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M216.32 334.44l114.45-69.14a10.89 10.89 0 000-18.6l-114.45-69.14a10.78 10.78 0 00-16.32 9.31v138.26a10.78 10.78 0 0016.32 9.31z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$14ead2fc0fa2d23f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-56 296V168l144 88z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3f08b862c773256(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm74.77 217.3l-114.45 69.14a10.78 10.78 0 01-16.32-9.31V186.87a10.78 10.78 0 0116.32-9.31l114.45 69.14a10.89 10.89 0 010 18.6z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4dea37ee615138e7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M394.77 246.7l-114.45-69.14a10.78 10.78 0 00-16.32 9.31v53.32l-103.68-62.63a10.78 10.78 0 00-16.32 9.31v138.26a10.78 10.78 0 0016.32 9.31L264 271.81v53.32a10.78 10.78 0 0016.32 9.31l114.45-69.14a10.89 10.89 0 000-18.6z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a87ce4fc99fc1520(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm8 295.25v-71.44l-120 72.32V167.71l120 72.48V168l136.53 88z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1144d728bfd57e8b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm138.77 217.3l-114.45 69.14a10.78 10.78 0 01-16.32-9.31v-53.32l-103.68 62.63a10.78 10.78 0 01-16.32-9.31V186.87a10.78 10.78 0 0116.32-9.31L264 240.19v-53.32a10.78 10.78 0 0116.32-9.31l114.45 69.14a10.89 10.89 0 010 18.6z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d40644757e1bc7bc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M32 145.52v221c0 13.28 13 21.72 23.63 15.35l188.87-113c9.24-5.53 9.24-20.07 0-25.6l-188.87-113C45 123.8 32 132.24 32 145.52zm228.57 0v221c0 13.28 13 21.72 23.63 15.35l188.87-113c9.24-5.53 9.24-20.07 0-25.6l-188.87-113c-10.64-6.47-23.63 1.97-23.63 15.25z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1b251a25d152d195(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 400l240-144L16 112v288zm240 0l240-144-240-144v288z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e64147b6029b673b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.29 229.47l-188.87-113a30.54 30.54 0 00-31.09-.39 33.74 33.74 0 00-16.76 29.47v79.05L63.85 116.44a30.54 30.54 0 00-31.09-.39A33.74 33.74 0 0016 145.52v221A33.74 33.74 0 0032.76 396a30.54 30.54 0 0031.09-.39L244.57 287.4v79.08A33.74 33.74 0 00261.33 396a30.54 30.54 0 0031.09-.39l188.87-113a31.27 31.27 0 000-53z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fd948da8dbb16b43(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M112 111v290c0 17.44 17 28.52 31 20.16l247.9-148.37c12.12-7.25 12.12-26.33 0-33.58L143 90.84c-14-8.36-31 2.72-31 20.16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$71182c7aeabbfcd7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 448l320-192L96 64v384z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6920a571717b9b1b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M192 176a16 16 0 0116 16v53l111.68-67.46a10.78 10.78 0 0116.32 9.33v138.26a10.78 10.78 0 01-16.32 9.31L208 267v53a16 16 0 01-32 0V192a16 16 0 0116-16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ac5be4e949542809(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.69 93.31 208 208 208s208-93.31 208-208S370.69 48 256 48 48 141.31 48 256zm128-80h32v69l128-77.53v176.9L208 267v69h-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$54fa2614ba8e7324(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.69 93.31 208 208 208s208-93.31 208-208S370.69 48 256 48 48 141.31 48 256zm128-64a16 16 0 0132 0v53l111.68-67.46a10.78 10.78 0 0116.32 9.33v138.26a10.78 10.78 0 01-16.32 9.31L208 267v53a16 16 0 01-32 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$78eeaef7813a3302(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 111v290c0 17.44-17 28.52-31 20.16L121.09 272.79c-12.12-7.25-12.12-26.33 0-33.58L369 90.84c14-8.36 31 2.72 31 20.16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M112 80v352"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bed198a7c73d255d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143.47 64v163.52L416 64v384L143.47 284.48V448H96V64h47.47z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4b0157edbb17a356(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 64a16 16 0 0116 16v136.43L360.77 77.11a35.13 35.13 0 0135.77-.44c12 6.8 19.46 20 19.46 34.33v290c0 14.37-7.46 27.53-19.46 34.33a35.14 35.14 0 01-35.77-.45L128 295.57V432a16 16 0 01-32 0V80a16 16 0 0116-16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$58ba4c7194c8e500(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 176a16 16 0 00-16 16v53l-111.68-67.44a10.78 10.78 0 00-16.32 9.31v138.26a10.78 10.78 0 0016.32 9.31L304 267v53a16 16 0 0032 0V192a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$76bd2792ebc11ac7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 288h-32v-69l-128 77.37V167.49L304 245v-69h32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$322de73913b6ad92(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 272a16 16 0 01-32 0v-53l-111.68 67.44a10.78 10.78 0 01-16.32-9.31V186.87a10.78 10.78 0 0116.32-9.31L304 245v-53a16 16 0 0132 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b41c83dd90f87bb8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M112 111v290c0 17.44 17 28.52 31 20.16l247.9-148.37c12.12-7.25 12.12-26.33 0-33.58L143 90.84c-14-8.36-31 2.72-31 20.16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 80v352"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$eb9f6c9665cfaf44(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368.53 64v163.52L96 64v384l272.53-163.52V448H416V64h-47.47z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ca446ae1f52131f7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 64a16 16 0 00-16 16v136.43L151.23 77.11a35.13 35.13 0 00-35.77-.44C103.46 83.47 96 96.63 96 111v290c0 14.37 7.46 27.53 19.46 34.33a35.14 35.14 0 0035.77-.45L384 295.57V432a16 16 0 0032 0V80a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4b728b3fdaabd1bb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M133 440a35.37 35.37 0 01-17.5-4.67c-12-6.8-19.46-20-19.46-34.33V111c0-14.37 7.46-27.53 19.46-34.33a35.13 35.13 0 0135.77.45l247.85 148.36a36 36 0 010 61l-247.89 148.4A35.5 35.5 0 01133 440z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$33551288dd20f9ae(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M32 160v296a8 8 0 008 8h136V160a16 16 0 00-16-16H48a16 16 0 00-16 16zM320 48H192a16 16 0 00-16 16v400h160V64a16 16 0 00-16-16zm144 160H352a16 16 0 00-16 16v240h136a8 8 0 008-8V224a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$16942fd21ca771eb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 32h192v448H160zm224 160h112v288H384zM16 128h112v352H16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$63d2c88577a9e891(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 32H192a32 32 0 00-32 32v412a4 4 0 004 4h184a4 4 0 004-4V64a32 32 0 00-32-32zm144 160h-72a8 8 0 00-8 8v272a8 8 0 008 8h80a24 24 0 0024-24V224a32 32 0 00-32-32zM48 128a32 32 0 00-32 32v296a24 24 0 0024 24h80a8 8 0 008-8V136a8 8 0 00-8-8z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3d2d8019b1c2135e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M378 108a191.41 191.41 0 0170 148c0 106-86 192-192 192S64 362 64 256a192 192 0 0169-148m123-44v192"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3fa83181483dda33(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c-114.69 0-208-93.23-208-207.82a207.44 207.44 0 0174.76-160.13l16.9-14 28.17 33.72-16.9 14A163.72 163.72 0 0092 256.18c0 90.39 73.57 163.93 164 163.93s164-73.54 164-163.93a163.38 163.38 0 00-59.83-126.36l-17-14 28-33.82 17 14A207.13 207.13 0 01464 256.18C464 370.77 370.69 464 256 464z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M234 48h44v224h-44z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3386524e1712081a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c-114.69 0-208-93.47-208-208.35 0-62.45 27.25-121 74.76-160.55a22 22 0 1128.17 33.8C113.48 160.1 92 206.3 92 255.65 92 346.27 165.57 420 256 420s164-73.73 164-164.35A164 164 0 00360.17 129a22 22 0 1128-33.92A207.88 207.88 0 01464 255.65C464 370.53 370.69 464 256 464z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 272a22 22 0 01-22-22V70a22 22 0 0144 0v180a22 22 0 01-22 22z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$531c42792f6f9d1a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M435.25 48h-122.9a14.46 14.46 0 00-10.2 4.2L56.45 297.9a28.85 28.85 0 000 40.7l117 117a28.85 28.85 0 0040.7 0L459.75 210a14.46 14.46 0 004.2-10.2v-123a28.66 28.66 0 00-28.7-28.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M384 160a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$930587da48465246(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 32L16 320l176 176 288-288V32zm80 128a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2807d2d22ce46281(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M467 45.2A44.45 44.45 0 00435.29 32H312.36a30.63 30.63 0 00-21.52 8.89L45.09 286.59a44.82 44.82 0 000 63.32l117 117a44.83 44.83 0 0063.34 0l245.65-245.6A30.6 30.6 0 00480 199.8v-123a44.24 44.24 0 00-13-31.6zM384 160a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$68b9c6c0e1ddcbfd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M403.29 32H280.36a14.46 14.46 0 00-10.2 4.2L24.4 281.9a28.85 28.85 0 000 40.7l117 117a28.86 28.86 0 0040.71 0L427.8 194a14.46 14.46 0 004.2-10.2v-123A28.66 28.66 0 00403.29 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M352 144a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M230 480l262-262a13.81 13.81 0 004-10V80"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9a48cfbbc514e632(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 16L0 304l176 176 288-288V16zm80 128a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 64v144L216.9 471.1 242 496l270-272V64h-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$62640d6d801fd6c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 183.8v-123A44.66 44.66 0 00403.29 16H280.36a30.62 30.62 0 00-21.51 8.89L13.09 270.58a44.86 44.86 0 000 63.34l117 117a44.84 44.84 0 0063.33 0l245.69-245.61A30.6 30.6 0 00448 183.8zM352 144a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M496 64a16 16 0 00-16 16v127.37L218.69 468.69a16 16 0 1022.62 22.62l262-262A29.84 29.84 0 00512 208V80a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c6ee5f2d8bb67d3e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "256",
                    "height": "208",
                    "x": "128",
                    "y": "240",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "24.32",
                    "ry": "24.32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "392",
                    "cy": "184",
                    "r": "24"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$db35a57b260a4599(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 96V56a8 8 0 00-8-8H120a8 8 0 00-8 8v40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "208",
                    "height": "160",
                    "x": "152",
                    "y": "264",
                    "fill": "none",
                    "rx": "4",
                    "ry": "4"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "208",
                    "height": "160",
                    "x": "152",
                    "y": "264",
                    "fill": "none",
                    "rx": "4",
                    "ry": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M408 112H104a56 56 0 00-56 56v208a8 8 0 008 8h56v72a8 8 0 008 8h272a8 8 0 008-8v-72h56a8 8 0 008-8V168a56 56 0 00-56-56zm-48 308a4 4 0 01-4 4H156a4 4 0 01-4-4V268a4 4 0 014-4h200a4 4 0 014 4zm34-212.08a24 24 0 1122-22 24 24 0 01-22 22z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1f4de47c8fabe43b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 112H106a58 58 0 00-58 58v158a56 56 0 0056 56h8v39.68A40.32 40.32 0 00152.32 464h207.36A40.32 40.32 0 00400 423.68V384h8a56 56 0 0056-56V168a56 56 0 00-56-56zm-40 311.68a8.35 8.35 0 01-8.32 8.32H152.32a8.35 8.35 0 01-8.32-8.32V264.32a8.35 8.35 0 018.32-8.32h207.36a8.35 8.35 0 018.32 8.32zm26-215.76a24 24 0 1122-22 24 24 0 01-22 22zM344 48H168a56.09 56.09 0 00-55.42 48h286.84A56.09 56.09 0 00344 48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b667cd0744230a7b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M229.73 45.88L37.53 327.79a31.79 31.79 0 0011.31 46L241 476.26a31.77 31.77 0 0029.92 0l192.2-102.51a31.79 31.79 0 0011.31-46L282.27 45.88a31.8 31.8 0 00-52.54 0zM256 32v448"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ce0b06867e4ef5e0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 16L16 352l240 144 240-144zm-20 96.82v324.53L73.73 340z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e33b49307318800b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.83 319.44L295.63 36.88a48 48 0 00-79.26 0L24.17 319.44a47.1 47.1 0 0016.93 68.13l192.2 102.75a48.05 48.05 0 0045.4 0l192.2-102.75a47.1 47.1 0 0016.93-68.13zm-431.26 41a16.12 16.12 0 01-8-10.38 16.8 16.8 0 012.37-13.62L232.66 69.26c2.18-3.21 7.34-1.72 7.34 2.13v374c0 5.9-6.54 9.63-11.87 6.78z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4d4e045c4b08a335(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 320h64l64-256 64 384 64-224 32 96h64"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "432",
                    "cy": "320",
                    "r": "32",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1ef11427b373321c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M426 266a54.07 54.07 0 00-49.3 32h-24.84l-27-81a22 22 0 00-42 .92l-37.2 130.2-48-281.74a22 22 0 00-43-1.72L94.82 298H32v44h80a22 22 0 0021.34-16.66L171.69 172l46.61 273.62A22 22 0 00238.76 464H240a22 22 0 0021.15-16l44.47-149.62 9.51 28.62A22 22 0 00336 342h40.7a54 54 0 1049.3-76z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$42dda4a4d43ad72a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 272a48.09 48.09 0 00-45.25 32h-39.22l-28.35-85.06a16 16 0 00-30.56.66l-44.51 155.76-52.33-314a16 16 0 00-31.3-1.25L99.51 304H48a16 16 0 000 32h64a16 16 0 0015.52-12.12l45.34-181.37 51.36 308.12A16 16 0 00239.1 464h.91a16 16 0 0015.37-11.6l49.8-174.28 15.64 46.94A16 16 0 00336 336h50.75A48 48 0 10432 272z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f5c00d266c162671(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 336h40a40 40 0 0040-40V88a40 40 0 00-40-40H136a40 40 0 00-40 40v208a40 40 0 0040 40h40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 240l80-80 80 80m-80 224V176"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c761523834b6eb14(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 352V204.63l64 64L358.63 246 256 143.37 153.37 246 176 268.63l64-64V352H92a12 12 0 01-12-12V44a12 12 0 0112-12h328a12 12 0 0112 12v296a12 12 0 01-12 12zm-32 0h32v128h-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6ad9b598a96e5f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376 352H272V198.63l52.69 52.68a16 16 0 0022.62-22.62l-80-80a16 16 0 00-22.62 0l-80 80a16 16 0 0022.62 22.62L240 198.63V352H136a56.06 56.06 0 01-56-56V88a56.06 56.06 0 0156-56h240a56.06 56.06 0 0156 56v208a56.06 56.06 0 01-56 56zM272 464a16 16 0 01-32 0V352h32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$59ec78c6acd4075d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "336",
                    "y": "336",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "64",
                    "x": "272",
                    "y": "272",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "64",
                    "x": "416",
                    "y": "416",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "48",
                    "x": "432",
                    "y": "272",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "48",
                    "x": "272",
                    "y": "432",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "336",
                    "y": "96",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "176",
                    "x": "288",
                    "y": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "96",
                    "y": "96",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "176",
                    "x": "48",
                    "y": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "96",
                    "y": "336",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "176",
                    "x": "48",
                    "y": "288",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$559c495fe2a1ba96(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 336h80v80h-80zm-64-64h64v64h-64zm144 144h64v64h-64zm16-144h48v48h-48zM272 432h48v48h-48zm64-336h80v80h-80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 240H272V32h208zm-164-44h120V76H316zM96 96h80v80H96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M240 240H32V32h208zM76 196h120V76H76zm20 140h80v80H96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M240 480H32V272h208zM76 436h120V316H76z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bcefa34c15f7fc27(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "336",
                    "y": "336",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "64",
                    "x": "272",
                    "y": "272",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "64",
                    "x": "416",
                    "y": "416",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "48",
                    "x": "432",
                    "y": "272",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "48",
                    "x": "272",
                    "y": "432",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32H304a32 32 0 00-32 32v144a32 32 0 0032 32h144a32 32 0 0032-32V64a32 32 0 00-32-32zm-32 136a8 8 0 01-8 8h-64a8 8 0 01-8-8v-64a8 8 0 018-8h64a8 8 0 018 8zM208 32H64a32 32 0 00-32 32v144a32 32 0 0032 32h144a32 32 0 0032-32V64a32 32 0 00-32-32zm-32 136a8 8 0 01-8 8h-64a8 8 0 01-8-8v-64a8 8 0 018-8h64a8 8 0 018 8zm32 104H64a32 32 0 00-32 32v144a32 32 0 0032 32h144a32 32 0 0032-32V304a32 32 0 00-32-32zm-32 136a8 8 0 01-8 8h-64a8 8 0 01-8-8v-64a8 8 0 018-8h64a8 8 0 018 8z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4cfbac1f1b5f4b28(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$292d17fb89696005(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f64f703ffed47f4f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7c5e971b5926f089(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4b694eac9d05cd6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f3eb9efb2a4feebb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "144"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8b27331032af9937(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256.02",
                    "r": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M184.25 192.25a96 96 0 000 127.52m143.52 0a96 96 0 000-127.52m-194.49-50.97a168 168 0 000 229.44m245.44 0a168 168 0 000-229.44M435 416a240.34 240.34 0 000-320M77 96a240.34 240.34 0 000 320"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bdd1c7cdc3868732(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "rx": "36",
                    "ry": "35.99"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M188.4 350.8l-14.62-16.44a117.91 117.91 0 010-156.71l14.62-16.43 32.87 29.24-14.62 16.43a73.93 73.93 0 000 98.25l14.62 16.44zm135.2 0l-32.89-29.22 14.62-16.44a73.93 73.93 0 000-98.25l-14.62-16.43 32.87-29.24 14.62 16.43a117.91 117.91 0 010 156.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M138.24 401.76l-15-16.06a189.85 189.85 0 010-259.4l15-16.07 32.14 30.05-15 16.06a145.88 145.88 0 000 199.32l15 16.06zm235.52 0l-32.14-30 15-16.06a145.88 145.88 0 000-199.32l-15-16.06 32.14-30 15 16.07a189.85 189.85 0 010 259.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M430.73 447l-32.79-29.33 14.66-16.39a218.2 218.2 0 000-290.56l-14.67-16.38L430.72 65l14.67 16.39a262.18 262.18 0 010 349.22zm-349.46 0L66.6 430.61a262.18 262.18 0 010-349.22L81.28 65l32.79 29.34-14.68 16.38a218.2 218.2 0 000 290.56l14.66 16.39z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$86ad25c6f723897f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "36"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M190.24 341.77a22 22 0 01-16.46-7.38 118 118 0 010-156.76 22 22 0 1132.87 29.24 74 74 0 000 98.29 22 22 0 01-16.43 36.61zm131.52 0a22 22 0 01-16.43-36.61 74 74 0 000-98.29 22 22 0 1132.87-29.24 118 118 0 010 156.76 22 22 0 01-16.44 7.38z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M139.29 392.72a21.92 21.92 0 01-16.08-7 190 190 0 010-259.49 22 22 0 1132.13 30.06 146 146 0 000 199.38 22 22 0 01-16.06 37zm233.42 0a22 22 0 01-16.06-37 146 146 0 000-199.38 22 22 0 1132.13-30.06 190 190 0 010 259.49 21.92 21.92 0 01-16.07 6.95z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M429 438a22 22 0 01-16.39-36.67 218.34 218.34 0 000-290.66 22 22 0 0132.78-29.34 262.34 262.34 0 010 349.34A22 22 0 01429 438zm-346 0a21.94 21.94 0 01-16.41-7.33 262.34 262.34 0 010-349.34 22 22 0 0132.78 29.34 218.34 218.34 0 000 290.66A22 22 0 0183 438z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$320d13edae5731f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M114.61 162.85A16.07 16.07 0 00128 149.6C140.09 76.17 193.63 32 256 32c57.93 0 96.62 37.75 112.2 77.74a15.84 15.84 0 0012.2 9.87c50 8.15 91.6 41.54 91.6 99.59 0 59.4-48.6 100.8-108 100.8H130c-49.5 0-90-24.7-90-79.2 0-48.47 38.67-72.22 74.61-77.95z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 384l-32 48m112-48l-64 96m144-96l-32 48m112-48l-64 96"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9c342007ad73c321(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M364 336H130c-29.5 0-54.92-7.83-73.53-22.64C35.23 296.44 24 271.35 24 240.8c0-26.66 10.08-49.8 29.14-66.91 15.24-13.68 36.17-23.21 59-26.84.06 0 .08 0 .09-.05 6.44-39 23.83-72.09 50.31-95.68A140.24 140.24 0 01256 16c30.23 0 58.48 9.39 81.71 27.17a142.69 142.69 0 0145.36 60.66c29.41 4.82 54.72 17.11 73.19 35.54C477 160.11 488 187.71 488 219.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm19-232.18zM93.82 430.422l49.75-74.626 26.626 17.75-49.751 74.627zm47.996 48.007L223.568 355.8l26.625 17.75-81.751 122.628zm111.995-48.005l49.751-74.626 26.626 17.75-49.751 74.627zm47.997 48.006l81.752-122.627 26.625 17.75-81.751 122.628z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b148f975f40493f0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456.26 139.37c-16.77-16.73-39.17-28.41-65.17-34a16 16 0 01-11.19-9 142.24 142.24 0 00-42.19-53.21C314.48 25.39 286.23 16 256 16a140.24 140.24 0 00-93.5 35.32c-24.2 21.56-40.91 51.34-48.43 85.83a16.05 16.05 0 01-11.72 12.18c-25 6.3-35.71 12.54-49.21 24.56C34 190.93 24 214.14 24 240.8c0 30.55 11.23 55.64 32.47 72.56C75.08 328.17 100.5 336 130 336h234c33.2 0 64.11-11.46 87-32.28 23.84-21.65 37-51.67 37-84.52 0-31.49-11-59.09-31.74-79.83zM112 448a16 16 0 01-13.3-24.88l32-48a16 16 0 0126.62 17.76l-32 48A16 16 0 01112 448zm48 48a16 16 0 01-13.29-24.88l64-96a16 16 0 0126.62 17.76l-64 96A16 16 0 01160 496zm112-48a16 16 0 01-13.3-24.88l32-48a16 16 0 0126.62 17.76l-32 48A16 16 0 01272 448zm48 48a16 16 0 01-13.3-24.88l64-96a16 16 0 0126.62 17.76l-64 96A16 16 0 01320 496z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7c4bd61587ceef60(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "320",
                    "height": "416",
                    "x": "96",
                    "y": "48",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 128h160m-160 80h160m-160 80h80"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8a7ed5ca672d4a69(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 44v424a12 12 0 0012 12h328a12 12 0 0012-12V44a12 12 0 00-12-12H92a12 12 0 00-12 12zm192 260H160v-32h112zm80-80H160v-32h192zm0-80H160v-32h192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$46da68852d86eddb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32H144a64.07 64.07 0 00-64 64v320a64.07 64.07 0 0064 64h224a64.07 64.07 0 0064-64V96a64.07 64.07 0 00-64-64zM256 304h-80a16 16 0 010-32h80a16 16 0 010 32zm80-80H176a16 16 0 010-32h160a16 16 0 010 32zm0-80H176a16 16 0 010-32h160a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d9b2d5feb3046f0a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 336V48l32 16 32-16 31.94 16 32.37-16L320 64l31.79-16 31.93 16L416 48l32.01 16L480 48v224"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M480 272v112a80 80 0 01-80 80h0a80 80 0 01-80-80v-48H48a15.86 15.86 0 00-16 16c0 64 6.74 112 80 112h288"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M224 144h192m-128 80h128"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7cc15c36273dc236(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48l-32-16-32 16-32-16-32 16-32-16-32 16-32-16-32 16-48-16v256.05h224V424c0 30.93 33.07 56 64 56h12c30.93 0 52-25.07 52-56V32zM272.5 240l-.5-32h159.5l.5 32zm-64-80l-.5-32h223.5l.5 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 424V320H16v32c0 50.55 5.78 71.62 14.46 87.63C45.19 466.8 71.86 480 112 480h256s-32-20-32-56z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$654bc31f7da0f421(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.82 32.45a16.28 16.28 0 00-11.23 1.37L448 46.1l-24.8-12.4a16 16 0 00-14.31 0l-25.11 12.41L359 33.7a16 16 0 00-14.36 0L320 46.07l-24.45-12.34a16 16 0 00-14.35-.06L256 46.12l-24.8-12.43a16.05 16.05 0 00-14.33 0L192 46.1l-24.84-12.41a16 16 0 00-19.36 3.94 16.25 16.25 0 00-3.8 10.65V288l.05.05H336a32 32 0 0132 32V424c0 30.93 33.07 56 64 56h12a52 52 0 0052-52V48a16 16 0 00-12.18-15.55zM416 240H288.5c-8.64 0-16.1-6.64-16.48-15.28A16 16 0 01288 208h127.5c8.64 0 16.1 6.64 16.48 15.28A16 16 0 01416 240zm0-80H224.5c-8.64 0-16.1-6.64-16.48-15.28A16 16 0 01224 128h191.5c8.64 0 16.1 6.64 16.48 15.28A16 16 0 01416 160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 424v-88a16 16 0 00-16-16H48a32.1 32.1 0 00-32 32.05c0 50.55 5.78 71.57 14.46 87.57C45.19 466.79 71.86 480 112 480h245.68a4 4 0 002.85-6.81C351.07 463.7 336 451 336 424z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6fb5cbb1a23af16b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "256",
                    "r": "96",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "256",
                    "r": "96",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 352h256"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5a97ad032956d70f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 138a117.93 117.93 0 00-91.84 192h-72.32A118 118 0 10128 374h256a118 118 0 000-236zM54 256a74 74 0 1174 74 74.09 74.09 0 01-74-74zm330 74a74 74 0 1174-74 74.09 74.09 0 01-74 74z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5cd8e13e6a089ffe(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.79 144.05c-59.1 1.65-107.12 49.71-108.79 108.81a111.64 111.64 0 0030.36 79.77A2 2 0 01301 336h-90a2 2 0 01-1.44-3.37A111.64 111.64 0 00240 252.86c-1.63-59.1-49.65-107.16-108.75-108.81A112.12 112.12 0 0016 255.53C15.75 317.77 67 368 129.24 368h253.52C445 368 496.25 317.77 496 255.53a112.12 112.12 0 00-115.21-111.48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b0e022a441ca7d09(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "28",
                    "d": "M288 193s12.18-6-32-6a80 80 0 1080 80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "28",
                    "d": "M256 149l40 40-40 40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ab75fed31c8437fa(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.32 48 256c0 114.86 93.14 208 208 208 114.69 0 208-93.31 208-208 0-114.87-93.13-208-208-208zm94 219a94 94 0 11-94-94h4.21l-24-24L256 129.2l59.8 59.8-59.8 59.8-19.8-19.8 27.92-27.92c-2.4-.08-5.12-.08-8.12-.08a66 66 0 1066 66v-14h28z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7cb1eea784b9e57a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.32 48 256c0 114.86 93.14 208 208 208 114.69 0 208-93.31 208-208 0-114.87-93.13-208-208-208zm0 313a94 94 0 010-188h4.21l-14.11-14.1a14 14 0 0119.8-19.8l40 40a14 14 0 010 19.8l-40 40a14 14 0 01-19.8-19.8l18-18c-2.38-.1-5.1-.1-8.1-.1a66 66 0 1066 66 14 14 0 0128 0 94.11 94.11 0 01-94 94z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2d50af796f1d0505(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M320 146s24.36-12-64-12a160 160 0 10160 160"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 58l80 80-80 80"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ae0fde7ee250396a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M320 146s24.36-12-64-12a160 160 0 10160 160"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 58l80 80-80 80"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1ae0f5888b510a32(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M320 146s24.36-12-64-12a160 160 0 10160 160"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 58l80 80-80 80"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$979bd6dfba741a83(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M341.54 197.85l-11.37-13.23a103.37 103.37 0 1022.71 105.84"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M367.32 162a8.44 8.44 0 00-6 2.54l-59.54 59.54a8.61 8.61 0 006.09 14.71h59.54a8.62 8.62 0 008.62-8.62v-59.56a8.61 8.61 0 00-8.68-8.63z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$aea37693b827c233(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm120 190.77h-89l36.88-36.88-5.6-6.51a87.38 87.38 0 10-62.94 148 87.55 87.55 0 0082.42-58.25l5.37-15.13 30.17 10.67-5.3 15.13a119.4 119.4 0 11-112.62-159.18 118.34 118.34 0 0186.36 36.95l.56.62 4.31 5L376 149.81z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$798d074acdfe3061(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm120 182.15a8.62 8.62 0 01-8.62 8.62h-59.54a8.61 8.61 0 01-6.09-14.71l22.17-22.17-5.6-6.51a87.38 87.38 0 10-62.94 148 87.55 87.55 0 0082.42-58.25A16 16 0 11368 295.8a119.4 119.4 0 11-112.62-159.18 118.34 118.34 0 0186.36 36.95l.56.62 4.31 5 14.68-14.68a8.44 8.44 0 016-2.54 8.61 8.61 0 018.68 8.63z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cd7d576b4256b9c5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 148l-21.12-24.57A191.43 191.43 0 00240 64C134 64 48 150 48 256s86 192 192 192a192.09 192.09 0 00181.07-128"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 97.42V208a16 16 0 01-16 16H337.42c-14.26 0-21.4-17.23-11.32-27.31L436.69 86.1C446.77 76 464 83.16 464 97.42z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$811f492512597afd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 148l-21.12-24.57A191.43 191.43 0 00240 64C134 64 48 150 48 256s86 192 192 192a192.09 192.09 0 00181.07-128"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 68.45V220a4 4 0 01-4 4H308.45a4 4 0 01-2.83-6.83L457.17 65.62a4 4 0 016.83 2.83z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$544f8f227e3646c0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 148l-21.12-24.57A191.43 191.43 0 00240 64C134 64 48 150 48 256s86 192 192 192a192.09 192.09 0 00181.07-128"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 97.42V208a16 16 0 01-16 16H337.42c-14.26 0-21.4-17.23-11.32-27.31L436.69 86.1C446.77 76 464 83.16 464 97.42z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2c00b67b6e3e4472(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 256H176"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$578dfca469e7da11(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm96 224H160v-32h192z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b601152552a67a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 224H176a16 16 0 010-32h160a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d869b8338548031b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 256H112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e9269d33aefa27a8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 256H112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$75a0386d38823ab8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 256H112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b1b4693100711f9c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M96 304h320M96 208h320M96 112h320M96 400h320"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$992a1043ddfa7fdb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M102 304h308m-308-96h308m-308-96h308M102 400h308"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f3c33f50f429420a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M102 304h308m-308-96h308m-308-96h308M102 400h308"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$325857712fea5a5d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M96 256h320M96 176h320M96 336h320"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2f58ae10659f8030(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M102 256h308m-308-80h308M102 336h308"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$50794c3e0378af8a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M102 256h308m-308-80h308M102 336h308"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bf160838413c3ffb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 304h288m-288-96h288"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5c3002fb845b19b1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M118 304h276m-276-96h276"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5b2cd81aa0500e4d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M118 304h276m-276-96h276"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3628b8d267db0e63(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 120l48 48-48 48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 168H144a80.24 80.24 0 00-80 80v16m128 128l-48-48 48-48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 344h208a80.24 80.24 0 0080-80v-16"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e39e9477341cd622(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M320 120l48 48-48 48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M352 168H64v96m128 128l-48-48 48-48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M160 344h288v-96"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d337db0bc5139de4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 120l48 48-48 48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 168H144a80.24 80.24 0 00-80 80v16m128 128l-48-48 48-48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 344h208a80.24 80.24 0 0080-80v-16"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$280d1d0212cac8c0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 96h112v112m-10.23-101.8L111.98 400.02M208 416H96V304"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c78673a0d51b5d59(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M304 96h112v112m-10.23-101.8L111.98 400.02M208 416H96V304"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e066ebda028f5e78(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 96h112v112m-10.23-101.8L111.98 400.02M208 416H96V304"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$caea30a625a79443(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M57.49 47.74l368.43 368.43a37.28 37.28 0 010 52.72h0a37.29 37.29 0 01-52.72 0l-90-91.55a32 32 0 01-9.2-22.43v-5.53a32 32 0 00-9.52-22.78l-11.62-10.73a32 32 0 00-29.8-7.44h0a48.53 48.53 0 01-46.56-12.63l-85.43-85.44C40.39 159.68 21.74 83.15 57.49 47.74z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 32l-77.25 77.25A64 64 0 00304 154.51v14.86a16 16 0 01-4.69 11.32L288 192m32 32l11.31-11.31a16 16 0 0111.32-4.69h14.86a64 64 0 0045.26-18.75L480 112m-40-40l-80 80M200 368l-99.72 100.28a40 40 0 01-56.56 0h0a40 40 0 010-56.56L128 328"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c25639303e1c7a8b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.7 223.94h14.87a79.48 79.48 0 0056.58-23.44L496 118l-22.22-22.4-83.58 83.58-17.37-17.37 83.58-83.59-23-22.31-83.27 83.26-17.32-17.37 83.58-83.59L394 16l-82.5 81.85a79.49 79.49 0 00-23.44 56.59v14.86l-43.13 43.13L48 16C3.72 70.87 29.87 171.71 79.72 221.57l85.5 85.5c26.55 26.55 31.82 28.92 61.94 16.8 6.49-2.61 8.85-2.32 14.9 3.72l13 12.13c2.93 3 3 3.88 3 9.62v5.54c0 21.08 13.48 33.2 22.36 42.24L384 496l72-72-156.43-156.93z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M227.37 354.59c-29.82 6.11-48.11 11.74-83.08-23.23-.56-.56-1.14-1.1-1.7-1.66l-19.5-19.5L16 416l80 80 144-144z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$adf910df53407f97(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M357.57 223.94a79.48 79.48 0 0056.58-23.44l77-76.95c6.09-6.09 6.65-16 .85-22.39a16 16 0 00-23.17-.56l-68.63 68.58a12.29 12.29 0 01-17.37 0c-4.79-4.78-4.53-12.86.25-17.64l68.33-68.33a16 16 0 00-.56-23.16A15.62 15.62 0 00440.27 56a16.71 16.71 0 00-11.81 4.9l-68.27 68.26a12.29 12.29 0 01-17.37 0c-4.78-4.78-4.53-12.86.25-17.64l68.33-68.31a16 16 0 00-.56-23.16A15.62 15.62 0 00400.26 16a16.73 16.73 0 00-11.81 4.9L311.5 97.85a79.49 79.49 0 00-23.44 56.59v8.23a16 16 0 01-4.69 11.33l-35.61 35.62a4 4 0 01-5.66 0L68.82 36.33a16 16 0 00-22.58-.06C31.09 51.28 23 72.47 23 97.54c-.1 41.4 21.66 89 56.79 124.08l85.45 85.45A64.79 64.79 0 00211 326a64 64 0 0016.21-2.08 16.24 16.24 0 014.07-.53 15.93 15.93 0 0110.83 4.25l11.39 10.52a16.12 16.12 0 014.6 11.23v5.54a47.73 47.73 0 0013.77 33.65l90.05 91.57.09.1a53.29 53.29 0 0075.36-75.37L302.39 269.9a4 4 0 010-5.66L338 228.63a16 16 0 0111.32-4.69z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M211 358a97.32 97.32 0 01-68.36-28.25l-13.86-13.86a8 8 0 00-11.3 0l-85 84.56c-15.15 15.15-20.56 37.45-13.06 59.29a30.63 30.63 0 001.49 3.6C31 484 50.58 496 72 496a55.68 55.68 0 0039.64-16.44L225 365.66a4.69 4.69 0 001.32-3.72v-.26a4.63 4.63 0 00-5.15-4.27A97.09 97.09 0 01211 358z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3e39597a829f9a19(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 352l-64-64 64-64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 288h294c58.76 0 106-49.33 106-108v-20"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6a3efb9f1925f1d3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M112 352l-64-64 64-64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 288h400V160"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e5fbc401f8d15da8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 352l-64-64 64-64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 288h294c58.76 0 106-49.33 106-108v-20"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e65cc4f9126f6ebd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 352l64-64-64-64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 288H154c-58.76 0-106-49.33-106-108v-20"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4e86ca4e82e3e154(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 352l64-64-64-64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 288H48V160"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8b3932789665f6a6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 352l64-64-64-64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 288H154c-58.76 0-106-49.33-106-108v-20"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a3ba795a53a17350(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 160l-64 64 64 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 224h294c58.76 0 106 49.33 106 108v20"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$54209bcb9d906c9c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M112 160l-64 64 64 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 224h400v128"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$43ddc2e20d8e0270(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 160l-64 64 64 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 224h294c58.76 0 106 49.33 106 108v20"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f8dd148b5967abd8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 160l64 64-64 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 224H154c-58.76 0-106 49.33-106 108v20"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3343425502de68e4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 160l64 64-64 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 224H48v128"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4cc61606065fd8ce(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 160l64 64-64 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 224H154c-58.76 0-106 49.33-106 108v20"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$64bab99da5a1e160(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "160",
                    "r": "128",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M143.65 227.82L48 400l86.86-.42a16 16 0 0113.82 7.8L192 480l88.33-194.32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M366.54 224L464 400l-86.86-.42a16 16 0 00-13.82 7.8L320 480l-64-140.8"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "160",
                    "r": "64",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$297a07de1a0219e7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 336c-5.22 0-10.4-.24-15.51-.69a176.12 176.12 0 01-131.29-78.37L20 416h115l58 96 82.53-177.09A177.53 177.53 0 01256 336zm147-79.26a176.9 176.9 0 01-88.18 69.14L273.7 415.5 319 512l58-96h115z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256.02",
                    "cy": "160",
                    "r": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 16c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144S335.4 16 256 16zm0 224a80 80 0 1180-80 80.09 80.09 0 01-80 80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$56821dce50869ecf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M269 335.61q-6.33.47-12.78.47c-5.23 0-10.4-.24-15.51-.69a176.11 176.11 0 01-127.67-72.94 4 4 0 00-6.77.35l-72 129.4c-2.74 5-3.17 11-.28 15.88A16.78 16.78 0 0048.22 416h78a15.28 15.28 0 0113.62 7.33L178.5 488a16.26 16.26 0 0013.75 8c5.94-.33 12.09-4.19 14.56-9.6l66.11-145.15a4 4 0 00-3.92-5.64zm208.64 56.27l-71.53-129.17a4 4 0 00-6.74-.36 176.5 176.5 0 01-78.31 61.42 16.09 16.09 0 00-8.72 8.25l-36.86 81.1a7.92 7.92 0 000 6.6l30.27 66.59c2.45 5.41 8.59 9.36 14.52 9.69a16.3 16.3 0 0013.7-8.12l38.53-64.58c2.89-4.85 8.13-7.33 13.78-7.3h78.77c6.67 0 11.72-3.48 14-10a16.92 16.92 0 00-1.41-14.12z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256.26",
                    "cy": "160",
                    "rx": "48.01",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256.26 16c-79.42 0-144 64.59-144 144s64.61 144 144 144 144-64.6 144-144-64.59-144-144-144zm0 224a80 80 0 1180-80 80.1 80.1 0 01-80 80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$879a494dfc5acaca(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M461.81 53.81a4.4 4.4 0 00-3.3-3.39c-54.38-13.3-180 34.09-248.13 102.17a294.9 294.9 0 00-33.09 39.08c-21-1.9-42-.3-59.88 7.5-50.49 22.2-65.18 80.18-69.28 105.07a9 9 0 009.8 10.4l81.07-8.9a180.29 180.29 0 001.1 18.3 18.15 18.15 0 005.3 11.09l31.39 31.39a18.15 18.15 0 0011.1 5.3 179.91 179.91 0 0018.19 1.1l-8.89 81a9 9 0 0010.39 9.79c24.9-4 83-18.69 105.07-69.17 7.8-17.9 9.4-38.79 7.6-59.69a293.91 293.91 0 0039.19-33.09c68.38-68 115.47-190.86 102.37-247.95zM298.66 213.67a42.7 42.7 0 1160.38 0 42.65 42.65 0 01-60.38 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M109.64 352a45.06 45.06 0 00-26.35 12.84C65.67 382.52 64 448 64 448s65.52-1.67 83.15-19.31A44.73 44.73 0 00160 402.32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3393aa93d171f7ec(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.64 38.26a4.75 4.75 0 00-3.55-3.66c-58.57-14.32-193.9 36.71-267.22 110a317 317 0 00-35.63 42.1c-22.61-2-45.22-.33-64.49 8.07C52.38 218.7 36.55 281.14 32.14 308a9.64 9.64 0 0010.55 11.2l87.31-9.63a194.1 194.1 0 001.19 19.7 19.53 19.53 0 005.7 12L170.7 375a19.59 19.59 0 0012 5.7 193.53 193.53 0 0019.59 1.19l-9.58 87.2a9.65 9.65 0 0011.2 10.55c26.81-4.3 89.36-20.13 113.15-74.5 8.4-19.27 10.12-41.77 8.18-64.27a317.66 317.66 0 0042.21-35.64C441 232.05 491.74 99.74 477.64 38.26zM294.07 217.93a48 48 0 1167.86 0 47.95 47.95 0 01-67.86 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M168.4 399.43c-5.48 5.49-14.27 7.63-24.85 9.46-23.77 4.05-44.76-16.49-40.49-40.52 1.63-9.11 6.45-21.88 9.45-24.88a4.37 4.37 0 00-3.65-7.45 60 60 0 00-35.13 17.12C50.22 376.69 48 464 48 464s87.36-2.22 110.87-25.75A59.69 59.69 0 00176 403.09c.37-4.18-4.72-6.67-7.6-3.66z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5de17520b82cc17a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328.85 156.79a26.69 26.69 0 1018.88 7.81 26.6 26.6 0 00-18.88-7.81z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M477.44 50.06a.29.29 0 010-.09 20.4 20.4 0 00-15.13-15.3c-29.8-7.27-76.68.48-128.63 21.28-52.36 21-101.42 52-134.58 85.22A320.7 320.7 0 00169.55 175c-22.33-1-42 2.18-58.57 9.41-57.74 25.41-74.23 90.44-78.62 117.14a25 25 0 0027.19 29h.13l64.32-7.02c.08.82.17 1.57.24 2.26a34.36 34.36 0 009.9 20.72l31.39 31.41a34.27 34.27 0 0020.71 9.91l2.15.23-7 64.24v.13A25 25 0 00206 480a25.25 25.25 0 004.15-.34C237 475.34 302 459.05 327.34 401c7.17-16.46 10.34-36.05 9.45-58.34a314.78 314.78 0 0033.95-29.55c33.43-33.26 64.53-81.92 85.31-133.52 20.69-51.36 28.48-98.59 21.39-129.53zM370.38 224.94a58.77 58.77 0 110-83.07 58.3 58.3 0 010 83.07z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M161.93 386.44a16 16 0 00-11 2.67c-6.39 4.37-12.81 8.69-19.29 12.9-13.11 8.52-28.79-6.44-21-20l12.15-21a16 16 0 00-15.16-24.91A61.25 61.25 0 0072 353.56c-3.66 3.67-14.79 14.81-20.78 57.26A357.94 357.94 0 0048 447.59 16 16 0 0064 464h.4a359.87 359.87 0 0036.8-3.2c42.47-6 53.61-17.14 57.27-20.8a60.49 60.49 0 0017.39-35.74 16 16 0 00-13.93-17.82z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bf15c90a75c8abb1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 128c-18.9 4.25-36.8 8.94-53.7 13.95-40.5 12-75.5 27.15-105.4 41.65-19.3 9.37-26.2 13.51-51.5 28.23-58.4 33.69-93.4 77.4-93.4 142.81C112 428.55 167.6 480 256 480s144-55.81 144-129.72S339 225.24 416 128z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M264 180.19c-19.69-27-38.2-38.69-52.7-46.59C162.6 107.1 96 96 96 96c41.5 43.7 37.2 90.1 32 128 0 0-3.87 32.88 1.91 58.41"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M372 139.15C356.55 102.6 336 64 336 64s-63.32 0-135.69 64m53.17-40.43C221.25 45.81 176 32 176 32c-15.3 20.8-28.79 51.58-34.87 74.17"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$73c1249e163ba900(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 112s-17.62 0-30.51 1.39c-19 2-42.06 8-59.73 13.22-35.06 10.39-69.33 23.92-107.85 42.59-18.62 9.05-26 13.35-48 26.13l-4.5 2.67c-32.95 19-57.09 40-73.79 64.3C105.29 288.89 96 320 96 354.64c0 40.74 15.71 77.1 44.24 102.37C169 482.52 209.06 496 256 496c46.76 0 86.89-14.32 116-41.43 28.35-26.35 44-63.39 44-104.29 0-25-6.19-47-12.17-68.22-12.59-44.69-23.46-83.29 24.71-144.13C432.75 132.62 448 112 448 112zm-229 7.55C168.47 92.08 104.72 80 80 80c0 0 23.23 28.19 29.15 55.4s6.54 48.61 2.91 88.6c17.94-20.48 40.59-37.15 69.32-53.73l4.48-2.6C208 154.8 216.23 150 236 140.41c2.88-1.4 5.74-2.76 8.58-4.11A170.77 170.77 0 00219 119.55zM345.25 48s-42.53.36-86.12 21.3a280.36 280.36 0 00-32.27 18.27q3.73 1.89 7.4 3.88c3.44 1.87 7.09 4 10.9 6.29a189.7 189.7 0 0131.46 24.16c24.57-10.41 73-26.1 90.77-31.28-8-19.15-22.14-42.62-22.14-42.62zM176 16c-16 10.83-33.24 41.1-33.24 41.1a494.22 494.22 0 0148.92 15.25l17.65-11.56c8.18-5.35 16.55-10.29 25-14.77C234.31 46 202.59 24.17 176 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f57c2975e5955fc4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M429.55 119.49a16 16 0 00-17.06-7.1c-18.64 4.19-37.06 9-54.73 14.22-35.06 10.39-69.33 23.92-107.85 42.59-18.62 9.05-26 13.35-48 26.13l-4.5 2.67c-32.95 19-57.09 40-73.79 64.29C105.29 288.89 96 320 96 354.64c0 40.74 15.71 77.1 44.24 102.37C169 482.52 209.06 496 256 496c46.76 0 86.89-14.33 116-41.43 28.35-26.35 44-63.39 44-104.29 0-25-6.19-47-12.17-68.22-12.59-44.69-23.46-83.29 24.71-144.13a16 16 0 001.01-18.44zm-210.55.06C168.46 92.08 101.46 80.69 98.63 80.22A16 16 0 0081 90.55a16.47 16.47 0 003.79 16.84c31.84 33.78 32.86 68.79 28.65 104.63a4.45 4.45 0 002.5 4.54 4.44 4.44 0 005.08-.9c16.39-16.51 36.37-31.52 60.4-45.39l4.48-2.6C208 154.8 216.23 150 236 140.41l2.69-1.3a4 4 0 00.64-6.83A178.59 178.59 0 00219 119.55zm15.26-28.1c3.44 1.87 7.09 4 10.9 6.29a189.31 189.31 0 0129.57 22.39 4 4 0 004.28.76 672 672 0 0169.65-25q7-2.07 14.08-4a4 4 0 002.53-5.62c-8.27-16.83-14.67-28.9-15.15-29.79A16 16 0 00336 48c-1.91 0-33.28.36-76.87 21.3a279 279 0 00-26.39 14.51 4 4 0 00.22 6.94zm-24.93-30.66c7.3-4.77 14.74-9.22 22.25-13.31a2 2 0 00.24-3.36c-26-19.57-49.73-27-51.15-27.42a16 16 0 00-17.56 5.82 217.63 217.63 0 00-19.28 32.38 2 2 0 001.29 2.81c13.61 3.57 29.4 8.29 45.61 14.29a2 2 0 001.79-.2z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b4228f9f482669a0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "184",
                    "cy": "232",
                    "r": "24"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 288c45.42 0 83.62 29.53 95.71 69.83a8 8 0 01-7.87 10.17H168.15a8 8 0 01-7.82-10.17C172.32 317.53 210.53 288 256 288z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "328",
                    "cy": "232",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$35891f9cca6f93e0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM328 208a24 24 0 11-24 24 23.94 23.94 0 0124-24zm-144 0a24 24 0 11-24 24 23.94 23.94 0 0124-24zm72 80c45.42 0 83.75 29.49 95.72 69.83 1 3.52 2.33 10.17 2.33 10.17H158s1.31-6.69 2.33-10.17C172.11 317.47 210.53 288 256 288z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$df4e34397fb666ed(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM184 208a24 24 0 11-24 24 23.94 23.94 0 0124-24zm-23.67 149.83c12-40.3 50.2-69.83 95.62-69.83s83.62 29.53 95.71 69.83a8 8 0 01-7.82 10.17H168.15a8 8 0 01-7.82-10.17zM328 256a24 24 0 1124-24 23.94 23.94 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6ebc8ba9699b814c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M380.93 57.37A32 32 0 00358.3 48H94.22A46.21 46.21 0 0048 94.22v323.56A46.21 46.21 0 0094.22 464h323.56A46.36 46.36 0 00464 417.78V153.7a32 32 0 00-9.37-22.63zM256 416a64 64 0 1164-64 63.92 63.92 0 01-64 64zm48-224H112a16 16 0 01-16-16v-64a16 16 0 0116-16h192a16 16 0 0116 16v64a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d4d96ebec0437205(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.44 32H64a32 32 0 00-32 32v384a32 32 0 0032 32h384a32.09 32.09 0 0032-32V131.56zM112 176v-64h192v64zm223.91 179.76a80 80 0 11-83.66-83.67 80.21 80.21 0 0183.66 83.67z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e61c71731a060313(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M465.94 119.76l-73.7-73.7A47.68 47.68 0 00358.3 32H96a64 64 0 00-64 64v320a64 64 0 0064 64h320a64 64 0 0064-64V153.7a47.68 47.68 0 00-14.06-33.94zM120 112h176a8 8 0 018 8v48a8 8 0 01-8 8H120a8 8 0 01-8-8v-48a8 8 0 018-8zm139.75 319.91a80 80 0 1176.16-76.16 80.06 80.06 0 01-76.16 76.16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "352",
                    "r": "48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$663173b7fc214512(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "416",
                    "x": "48",
                    "y": "48",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "96"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M388.94 151.56c-24.46-22.28-68.72-51.4-132.94-51.4s-108.48 29.12-132.94 51.4a34.66 34.66 0 00-3.06 48.08l33.32 39.21a26.07 26.07 0 0033.6 5.21c15.92-9.83 40.91-21.64 69.1-21.64s53.18 11.81 69.1 21.64a26.07 26.07 0 0033.6-5.21L392 199.64a34.66 34.66 0 00-3.06-48.08z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1e62b620a25ae33c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 32H80a48.05 48.05 0 00-48 48v352a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V80a48.05 48.05 0 00-48-48zm-16.71 165l-52.46 61.73a27.83 27.83 0 01-37.65 4.62c-13-9.29-39.27-24.89-69.18-24.89s-56.18 15.6-69.18 24.89a27.84 27.84 0 01-37.65-4.62L96.71 197a32.12 32.12 0 01.42-42c18.93-21.31 72.3-70.87 158.87-70.87S395.94 133.72 414.87 155a32.12 32.12 0 01.42 42z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6367b0b86a4b0a55(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32H144A112.12 112.12 0 0032 144v224a112.12 112.12 0 00112 112h224a112.12 112.12 0 00112-112V144A112.12 112.12 0 00368 32zm36.21 178l-33.32 39.21A41.76 41.76 0 01339 264.05a42.32 42.32 0 01-22.29-6.38c-14.22-8.78-36.3-19.25-60.69-19.25s-46.47 10.47-60.69 19.25a41.86 41.86 0 01-54.2-8.46L107.79 210a50.48 50.48 0 014.49-70.27c27.84-25.35 75.37-55.57 143.72-55.57s115.88 30.22 143.72 55.57a50.48 50.48 0 014.49 70.27z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e377123113048a28(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M296 352h28a28 28 0 0028-28v-28m0-80v-28a28 28 0 00-28-28h-28m-80 192h-28a28 28 0 01-28-28v-28m0-80v-28a28 28 0 0128-28h28"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$34ca6d2498114a72(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-24 320h-44a44.05 44.05 0 01-44-44v-44h32v44a12 12 0 0012 12h44zm0-192h-44a12 12 0 00-12 12v44h-32v-44a44.05 44.05 0 0144-44h44zm136 148a44.05 44.05 0 01-44 44h-44v-32h44a12 12 0 0012-12v-44h32zm0-92h-32v-44a12 12 0 00-12-12h-44v-32h44a44.05 44.05 0 0144 44z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$545b3cace6e5fffc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-40 320h-28a44.05 44.05 0 01-44-44v-28a16 16 0 0132 0v28a12 12 0 0012 12h28a16 16 0 010 32zm0-192h-28a12 12 0 00-12 12v28a16 16 0 01-32 0v-28a44.05 44.05 0 0144-44h28a16 16 0 010 32zm152 148a44.05 44.05 0 01-44 44h-28a16 16 0 010-32h28a12 12 0 0012-12v-28a16 16 0 0132 0zm0-108a16 16 0 01-32 0v-28a12 12 0 00-12-12h-28a16 16 0 010-32h28a44.05 44.05 0 0144 44z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f5d27ff85ebee72f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 448h56a56 56 0 0056-56v-56m0-160v-56a56 56 0 00-56-56h-56M176 448h-56a56 56 0 01-56-56v-56m0-160v-56a56 56 0 0156-56h56"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$80964b786166e0b5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M388 466h-68v-44h68a34 34 0 0034-34v-68h44v68a78.09 78.09 0 01-78 78zm78-274h-44v-68a34 34 0 00-34-34h-68V46h68a78.09 78.09 0 0178 78zM192 466h-68a78.09 78.09 0 01-78-78v-68h44v68a34 34 0 0034 34h68zM90 192H46v-68a78.09 78.09 0 0178-78h68v44h-68a34 34 0 00-34 34z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4c15ff08f6fbd0a8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M342 444h46a56 56 0 0056-56v-46m0-172v-46a56 56 0 00-56-56h-46M170 444h-46a56 56 0 01-56-56v-46m0-172v-46a56 56 0 0156-56h46"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$274b3ba1b7ffd1b0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M32 192L256 64l224 128-224 128L32 192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 240v128l144 80 144-80V240m80 128V192M256 320v128"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$dfafc9ae58d009c5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 370.43L96 279v98.42l160 88.88 160-88.88V279l-160 91.43z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512.25 192L256 45.57-.25 192 256 338.43l208-118.86V384h48V192.14l.25-.14z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2011aaa7991e5201(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 368a16 16 0 01-7.94-2.11L108 285.84a8 8 0 00-12 6.94V368a16 16 0 008.23 14l144 80a16 16 0 0015.54 0l144-80a16 16 0 008.23-14v-75.22a8 8 0 00-12-6.94l-140.06 80.05A16 16 0 01256 368z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M495.92 190.5v-.11a16 16 0 00-8-12.28l-224-128a16 16 0 00-15.88 0l-224 128a16 16 0 000 27.78l224 128a16 16 0 0015.88 0L461 221.28a2 2 0 013 1.74v144.53c0 8.61 6.62 16 15.23 16.43A16 16 0 00496 368V192a14.76 14.76 0 00-.08-1.5z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b02530e26d8e1058(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 80a176 176 0 10176 176A176 176 0 00256 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M232 160a72 72 0 1072 72 72 72 0 00-72-72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M283.64 283.64L336 336"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$768fe1d771cb9962(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C150.13 64 64 150.13 64 256s86.13 192 192 192 192-86.13 192-192S361.87 64 256 64zm80 294.63l-54.15-54.15a88.08 88.08 0 1122.63-22.63L358.63 336z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "232",
                    "cy": "232",
                    "r": "56"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3cf21c39c92733ec(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C150.13 64 64 150.13 64 256s86.13 192 192 192 192-86.13 192-192S361.87 64 256 64zm91.31 283.31a16 16 0 01-22.62 0l-42.84-42.83a88.08 88.08 0 1122.63-22.63l42.83 42.84a16 16 0 010 22.62z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "232",
                    "cy": "232",
                    "r": "56"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b11cb41ddb9c20a4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M338.29 338.29L448 448"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2862e4c8f32930cc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 428L339.92 303.9a160.48 160.48 0 0030.72-94.58C370.64 120.37 298.27 48 209.32 48S48 120.37 48 209.32s72.37 161.32 161.32 161.32a160.48 160.48 0 0094.58-30.72L428 464zM209.32 319.69a110.38 110.38 0 11110.37-110.37 110.5 110.5 0 01-110.37 110.37z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bffb6555ea20639e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456.69 421.39L362.6 327.3a173.81 173.81 0 0034.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 00327.3 362.6l94.09 94.09a25 25 0 0035.3-35.3zM97.92 222.72a124.8 124.8 0 11124.8 124.8 124.95 124.95 0 01-124.8-124.8z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5d89ba8a24154fe2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M470.3 271.15L43.16 447.31a7.83 7.83 0 01-11.16-7V327a8 8 0 016.51-7.86l247.62-47c17.36-3.29 17.36-28.15 0-31.44l-247.63-47a8 8 0 01-6.5-7.85V72.59c0-5.74 5.88-10.26 11.16-8L470.3 241.76a16 16 0 010 29.39z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a062e1cbeaf801b2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 464l480-208L16 48v160l320 48-320 48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f84d780d4f37d508(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.59 227.05l-.16-.07L49.35 49.84A23.56 23.56 0 0027.14 52 24.65 24.65 0 0016 72.59v113.29a24 24 0 0019.52 23.57l232.93 43.07a4 4 0 010 7.86L35.53 303.45A24 24 0 0016 327v113.31A23.57 23.57 0 0026.59 460a23.94 23.94 0 0013.22 4 24.55 24.55 0 009.52-1.93L476.4 285.94l.19-.09a32 32 0 000-58.8z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6998bfeb9ce40167(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256",
                    "cy": "128",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "192",
                    "ry": "80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 214c0 44.18-86 80-192 80S64 258.18 64 214m384 86c0 44.18-86 80-192 80S64 344.18 64 300"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 127.24v257.52C64 428.52 150 464 256 464s192-35.48 192-79.24V127.24"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ca2276209ac8ff42(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M409.43 389.87C362 410 305.4 421.05 256 421.05s-105.87-11.3-153.44-31.18S48 353.16 48 353.16v38.2c0 31.15 18 43.64 67.32 64.35C153.13 471.59 203.18 480 256 480s102.87-8.41 140.68-24.29C446 435 464 422.51 464 391.36v-38.2s-7.14 16.59-54.57 36.71zM63.69 173.22c11.23 9.84 27.82 19.49 48 27.92 42.48 17.76 96.45 28.37 144.36 28.37s101.88-10.61 144.36-28.37c20.13-8.43 36.72-18.08 47.95-27.92 6.06-5.31 10.85-10.12 13.47-12.85a8 8 0 002.22-5.54v-26.16c-.84-28.79-24.71-54.41-67.21-72.14C358.83 40.71 308.84 32 256 32s-102.83 8.71-140.74 24.53C72.85 74.22 49 99.78 48.05 128.5v26.33a8 8 0 002.21 5.54c2.58 2.73 7.36 7.54 13.43 12.85z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M409.43 221.91C365 241 305.4 253.09 256 253.09s-108.87-12.27-153.43-31.18S48 185.2 48 185.2v47.36c.08 7.52 5.5 16.2 15.69 25.13 11.24 9.84 27.82 19.5 48 27.92C154.12 303.38 208.09 314 256 314s101.88-10.6 144.36-28.37c20.13-8.42 36.72-18.08 47.95-27.92 10.25-9 15.68-17.71 15.69-25.27V185.2s-10.13 17.62-54.57 36.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M409.43 306.38C362 326 305.4 337.56 256 337.56s-109.87-12.8-153.43-31.18S48 269.67 48 269.67v46.25c0 7.55 5.44 16.28 15.69 25.26 11.23 9.84 27.81 19.5 48 27.92 42.48 17.77 96.44 28.37 144.36 28.37s101.88-10.6 144.36-28.37c20.13-8.43 36.72-18.08 47.95-27.92 10.19-8.93 15.61-17.61 15.69-25.13v-46.38s-7.18 17.09-54.62 36.71z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f585b2bbc4944e58(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 428c-52.35 0-111.39-11.61-157.93-31-17.07-7.19-31.69-18.82-43.64-28a4 4 0 00-6.43 3.18v12.58c0 28.07 23.49 53.22 66.14 70.82C152.29 471.33 202.67 480 256 480s103.7-8.67 141.86-24.42C440.51 438 464 412.83 464 384.76v-12.58a4 4 0 00-6.43-3.18c-11.95 9.17-26.57 20.81-43.65 28-46.54 19.39-105.57 31-157.92 31zm208-301.49c-.81-27.65-24.18-52.4-66-69.85C359.74 40.76 309.34 32 256 32s-103.74 8.76-141.91 24.66c-41.78 17.41-65.15 42.11-66 69.69L48 144c0 6.41 5.2 16.48 14.63 24.73 11.13 9.73 27.65 19.33 47.78 27.73C153.24 214.36 207.67 225 256 225s102.76-10.68 145.59-28.58c20.13-8.4 36.65-18 47.78-27.73C458.8 160.49 464 150.42 464 144z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M413.92 226c-46.53 19.43-105.57 31-157.92 31s-111.39-11.57-157.93-31c-17.07-7.15-31.69-18.79-43.64-28a4 4 0 00-6.43 3.22V232c0 6.41 5.2 14.48 14.63 22.73 11.13 9.74 27.65 19.33 47.78 27.74C153.24 300.34 207.67 311 256 311s102.76-10.68 145.59-28.57c20.13-8.41 36.65-18 47.78-27.74C458.8 246.47 464 238.41 464 232v-30.78a4 4 0 00-6.43-3.18c-11.95 9.17-26.57 20.81-43.65 27.96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M413.92 312c-46.54 19.41-105.57 31-157.92 31s-111.39-11.59-157.93-31c-17.07-7.17-31.69-18.81-43.64-28a4 4 0 00-6.43 3.2V317c0 6.41 5.2 14.47 14.62 22.71 11.13 9.74 27.66 19.33 47.79 27.74C153.24 385.32 207.66 396 256 396s102.76-10.68 145.59-28.57c20.13-8.41 36.65-18 47.78-27.74C458.8 331.44 464 323.37 464 317v-29.8a4 4 0 00-6.43-3.18c-11.95 9.17-26.57 20.81-43.65 27.98z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8bd52569cb1789c2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M262.29 192.31a64 64 0 1057.4 57.4 64.13 64.13 0 00-57.4-57.4zM416.39 256a154.34 154.34 0 01-1.53 20.79l45.21 35.46a10.81 10.81 0 012.45 13.75l-42.77 74a10.81 10.81 0 01-13.14 4.59l-44.9-18.08a16.11 16.11 0 00-15.17 1.75A164.48 164.48 0 01325 400.8a15.94 15.94 0 00-8.82 12.14l-6.73 47.89a11.08 11.08 0 01-10.68 9.17h-85.54a11.11 11.11 0 01-10.69-8.87l-6.72-47.82a16.07 16.07 0 00-9-12.22 155.3 155.3 0 01-21.46-12.57 16 16 0 00-15.11-1.71l-44.89 18.07a10.81 10.81 0 01-13.14-4.58l-42.77-74a10.8 10.8 0 012.45-13.75l38.21-30a16.05 16.05 0 006-14.08c-.36-4.17-.58-8.33-.58-12.5s.21-8.27.58-12.35a16 16 0 00-6.07-13.94l-38.19-30A10.81 10.81 0 0149.48 186l42.77-74a10.81 10.81 0 0113.14-4.59l44.9 18.08a16.11 16.11 0 0015.17-1.75A164.48 164.48 0 01187 111.2a15.94 15.94 0 008.82-12.14l6.73-47.89A11.08 11.08 0 01213.23 42h85.54a11.11 11.11 0 0110.69 8.87l6.72 47.82a16.07 16.07 0 009 12.22 155.3 155.3 0 0121.46 12.57 16 16 0 0015.11 1.71l44.89-18.07a10.81 10.81 0 0113.14 4.58l42.77 74a10.8 10.8 0 01-2.45 13.75l-38.21 30a16.05 16.05 0 00-6.05 14.08c.33 4.14.55 8.3.55 12.47z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8290f3d153a28035(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 176a80 80 0 1080 80 80.24 80.24 0 00-80-80zm172.72 80a165.53 165.53 0 01-1.64 22.34l48.69 38.12a11.59 11.59 0 012.63 14.78l-46.06 79.52a11.64 11.64 0 01-14.14 4.93l-57.25-23a176.56 176.56 0 01-38.82 22.67l-8.56 60.78a11.93 11.93 0 01-11.51 9.86h-92.12a12 12 0 01-11.51-9.53l-8.56-60.78A169.3 169.3 0 01151.05 393L93.8 416a11.64 11.64 0 01-14.14-4.92L33.6 331.57a11.59 11.59 0 012.63-14.78l48.69-38.12A174.58 174.58 0 0183.28 256a165.53 165.53 0 011.64-22.34l-48.69-38.12a11.59 11.59 0 01-2.63-14.78l46.06-79.52a11.64 11.64 0 0114.14-4.93l57.25 23a176.56 176.56 0 0138.82-22.67l8.56-60.78A11.93 11.93 0 01209.94 26h92.12a12 12 0 0111.51 9.53l8.56 60.78A169.3 169.3 0 01361 119l57.2-23a11.64 11.64 0 0114.14 4.92l46.06 79.52a11.59 11.59 0 01-2.63 14.78l-48.69 38.12a174.58 174.58 0 011.64 22.66z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f2190816e079dff5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M470.39 300l-.47-.38-31.56-24.75a16.11 16.11 0 01-6.1-13.33v-11.56a16 16 0 016.11-13.22L469.92 212l.47-.38a26.68 26.68 0 005.9-34.06l-42.71-73.9a1.59 1.59 0 01-.13-.22A26.86 26.86 0 00401 92.14l-.35.13-37.1 14.93a15.94 15.94 0 01-14.47-1.29q-4.92-3.1-10-5.86a15.94 15.94 0 01-8.19-11.82l-5.59-39.59-.12-.72A27.22 27.22 0 00298.76 26h-85.52a26.92 26.92 0 00-26.45 22.39l-.09.56-5.57 39.67a16 16 0 01-8.13 11.82 175.21 175.21 0 00-10 5.82 15.92 15.92 0 01-14.43 1.27l-37.13-15-.35-.14a26.87 26.87 0 00-32.48 11.34l-.13.22-42.77 73.95a26.71 26.71 0 005.9 34.1l.47.38 31.56 24.75a16.11 16.11 0 016.1 13.33v11.56a16 16 0 01-6.11 13.22L42.08 300l-.47.38a26.68 26.68 0 00-5.9 34.06l42.71 73.9a1.59 1.59 0 01.13.22 26.86 26.86 0 0032.45 11.3l.35-.13 37.07-14.93a15.94 15.94 0 0114.47 1.29q4.92 3.11 10 5.86a15.94 15.94 0 018.19 11.82l5.56 39.59.12.72A27.22 27.22 0 00213.24 486h85.52a26.92 26.92 0 0026.45-22.39l.09-.56 5.57-39.67a16 16 0 018.18-11.82c3.42-1.84 6.76-3.79 10-5.82a15.92 15.92 0 0114.43-1.27l37.13 14.95.35.14a26.85 26.85 0 0032.48-11.34 2.53 2.53 0 01.13-.22l42.71-73.89a26.7 26.7 0 00-5.89-34.11zm-134.48-40.24a80 80 0 11-83.66-83.67 80.21 80.21 0 0183.66 83.67z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d68f0ce143a799a6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 320H32L184 48l152 272zm-70.68-125.49A144 144 0 11192 320"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8ccd6387fa5247cf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M363.27 336H4.73L184 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 160a160.54 160.54 0 00-32.55 3.36l87.75 157L417.81 368H183.36C203.8 432.85 264.49 480 336 480c88.22 0 160-71.78 160-160s-71.78-160-160-160z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a0b63ef5ed9f08a7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 336H32a16 16 0 01-14-23.81l152-272a16 16 0 0127.94 0l152 272A16 16 0 01336 336z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 160a161.07 161.07 0 00-32.57 3.32l74.47 133.27A48 48 0 01336 368H183.33A160 160 0 10336 160z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9bac7f6ac2bb3fa0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 192h40a40 40 0 0140 40v192a40 40 0 01-40 40H136a40 40 0 01-40-40V232a40 40 0 0140-40h40m160-64l-80-80-80 80m80 193V48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a5695bb7852e3911(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 176v161h-32V176H92a12 12 0 00-12 12v280a12 12 0 0012 12h328a12 12 0 0012-12V188a12 12 0 00-12-12zm0-83.37l64 64L358.63 134 256 31.37 153.37 134 176 156.63l64-64V176h32V92.63z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bf18a36d0c6441a3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "256",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "112",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "400",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M169.83 279.53l172.34 96.94m0-240.94l-172.34 96.94"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7b1ba0ef2ada476b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378 324a69.78 69.78 0 00-48.83 19.91L202 272.41a69.68 69.68 0 000-32.82l127.13-71.5A69.76 69.76 0 10308.87 129l-130.13 73.2a70 70 0 100 107.56L308.87 383A70 70 0 10378 324z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$df5530feb4dd0533(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 336a63.78 63.78 0 00-46.12 19.7l-148-83.27a63.85 63.85 0 000-32.86l148-83.27a63.8 63.8 0 10-15.73-27.87l-148 83.27a64 64 0 100 88.6l148 83.27A64 64 0 10384 336z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$30be1ccf14c739c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376 176H272v145a16 16 0 01-32 0V176H136a56.06 56.06 0 00-56 56v192a56.06 56.06 0 0056 56h240a56.06 56.06 0 0056-56V232a56.06 56.06 0 00-56-56zM272 86.63l52.69 52.68a16 16 0 0022.62-22.62l-80-80a16 16 0 00-22.62 0l-80 80a16 16 0 0022.62 22.62L240 86.63V176h32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9aeaefe9c78e05cc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 176L225.2 304 176 255.8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M463.1 112.37C373.68 96.33 336.71 84.45 256 48c-80.71 36.45-117.68 48.33-207.1 64.37C32.7 369.13 240.58 457.79 256 464c15.42-6.21 223.3-94.87 207.1-351.63z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a768b3700d4e19d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.07 111.36l-.79-12.53-12.36-2.21c-86.5-15.52-122.61-26.74-203.33-63.2l-6.59-3-6.59 3C168.69 69.88 132.58 81.1 46.08 96.62l-12.36 2.21-.79 12.53c-3.85 61.11 4.36 118.05 24.43 169.24A349.47 349.47 0 00129 393.11c53.47 56.73 110.24 81.37 121.07 85.73l6 2.41 6-2.41c10.83-4.36 67.6-29 121.07-85.73a349.47 349.47 0 0071.5-112.51c20.07-51.19 28.28-108.13 24.43-169.24zm-252.91 216L153.37 256l22.4-22.86 48.47 47.49 110.13-127.2 24.2 20.94z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$871fdad530748a03(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.07 111.36a16 16 0 00-13.15-14.74c-86.5-15.52-122.61-26.74-203.33-63.2a16 16 0 00-13.18 0C168.69 69.88 132.58 81.1 46.08 96.62a16 16 0 00-13.15 14.74c-3.85 61.11 4.36 118.05 24.43 169.24A349.47 349.47 0 00129 393.11c53.47 56.73 110.24 81.37 121.07 85.73a16 16 0 0012 0c10.83-4.36 67.6-29 121.07-85.73a349.47 349.47 0 0071.5-112.51c20.07-51.19 28.28-108.13 24.43-169.24zm-131 75.11l-110.8 128a16 16 0 01-11.41 5.53h-.66a16 16 0 01-11.2-4.57l-49.2-48.2a16 16 0 1122.4-22.86l37 36.29 99.7-115.13a16 16 0 0124.2 20.94z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9a252496087cc62(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M463.1 112.37C373.68 96.33 336.71 84.45 256 48c-80.71 36.45-117.68 48.33-207.1 64.37C32.7 369.13 240.58 457.79 256 464c15.42-6.21 223.3-94.87 207.1-351.63z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48c-80.71 36.45-117.68 48.33-207.1 64.37C32.7 369.13 240.58 457.79 256 464z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$936e810f4d69c56f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C174 69.06 121.38 86.46 32 96c0 77.59 5.27 133.36 25.29 184.51a348.86 348.86 0 0071.43 112.41c49.6 52.66 104.17 80.4 127.28 87.08 23.11-6.68 77.68-34.42 127.28-87.08a348.86 348.86 0 0071.43-112.41C474.73 229.36 480 173.59 480 96c-89.38-9.54-142-26.94-224-64zm161.47 233.93a309.18 309.18 0 01-63.31 99.56C316 406 276.65 428.31 256 437.36V75.8c38.75 17 68.73 28.3 97.93 36.89a613.12 613.12 0 0085.6 18.52c-1.72 60.22-8.36 99.69-22.06 134.72z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$15544a52d0b7aa25(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48.9 112.37C138.32 96.33 175.29 84.45 256 48c80.71 36.45 117.68 48.33 207.1 64.37C479.3 369.13 271.42 457.79 256 464c-15.42-6.21-223.3-94.87-207.1-351.63z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48c80.71 36.45 117.68 48.33 207.1 64.37C479.3 369.13 271.42 457.79 256 464z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$51bed8637a6ead16(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M463.1 112.37C373.68 96.33 336.71 84.45 256 48c-80.71 36.45-117.68 48.33-207.1 64.37C32.7 369.13 240.58 457.79 256 464c15.42-6.21 223.3-94.87 207.1-351.63z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a79fc08400cb9842(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C174 69.06 121.38 86.46 32 96c0 77.59 5.27 133.36 25.29 184.51a348.86 348.86 0 0071.43 112.41c49.6 52.66 104.17 80.4 127.28 87.08 23.11-6.68 77.68-34.42 127.28-87.08a348.86 348.86 0 0071.43-112.41C474.73 229.36 480 173.59 480 96c-89.38-9.54-142-26.94-224-64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9d21feeff1bec9fd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.07 111.35a16 16 0 00-13.15-14.75C379.89 81.18 343.69 69.12 266 34.16c-7.76-2.89-12.57-2.84-20 0-77.69 35-113.89 47-199.92 62.44a16 16 0 00-13.15 14.75c-3.85 61.1 4.34 118 24.36 169.15a348.86 348.86 0 0071.43 112.41c44.67 47.43 94.2 75.12 119.74 85.6a20 20 0 0015.11 0c27-10.92 74.69-37.82 119.71-85.62a348.86 348.86 0 0071.43-112.39c20.02-51.14 28.21-108.05 24.36-169.15z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cbb6780b58211369(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M314.56 48s-22.78 8-58.56 8-58.56-8-58.56-8a31.94 31.94 0 00-10.57 1.8L32 104l16.63 88 48.88 5.52a24 24 0 0121.29 24.58L112 464h288l-6.8-241.9a24 24 0 0121.29-24.58l48.88-5.52L480 104 325.13 49.8a31.94 31.94 0 00-10.57-1.8zm18.75 4.66a80 80 0 01-154.62 0"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fc554d8ff19ea1ad(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 42c-33.88 0-64-10-64-10v2a64 64 0 00128 0v-2s-30.12 10-64 10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M352 44c-5.49 47.76-46.79 85-96 85s-90.51-37.24-96-85L16 94l18 114 61.71 7.42c7.08.9 7.1.9 7.1 8.19L96 480h320l-6.81-256.39c-.21-7-.21-7 7.1-8.19L478 208l18-114z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$63989ae2cfa065dc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 96c33.08 0 60.71-25.78 64-58 .3-3-3-6-6-6a13 13 0 00-4.74.9c-.2.08-21.1 8.1-53.26 8.1s-53.1-8-53.26-8.1a16.21 16.21 0 00-5.3-.9h-.06a5.69 5.69 0 00-5.38 6c3.35 32.16 31 58 64 58z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M485.29 89.9L356 44.64a4 4 0 00-5.27 3.16 96 96 0 01-189.38 0 4 4 0 00-5.35-3.16L26.71 89.9A16 16 0 0016.28 108l16.63 88a16 16 0 0013.92 12.9l48.88 5.52a8 8 0 017.1 8.19l-7.33 240.9a16 16 0 009.1 14.94A17.49 17.49 0 00112 480h288a17.49 17.49 0 007.42-1.55 16 16 0 009.1-14.94l-7.33-240.9a8 8 0 017.1-8.19l48.88-5.52a16 16 0 0013.92-12.9l16.63-88a16 16 0 00-10.43-18.1z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$451f6ae44de7dc9b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 304l48 48-48 48m0-288l48 48-48 48M64 352h85.19a80 80 0 0066.56-35.62L256 256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 160h85.19a80 80 0 0166.56 35.62l80.5 120.76A80 80 0 00362.81 352H416m0-192h-53.19a80 80 0 00-66.56 35.62L288 208"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5f570d7e4add6118(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 304l48 48-48 48m0-288l48 48-48 48M64 352h128l60-92"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 160h128l128 192h96m0-192h-96l-32 48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d8233b9b0ddc7068(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 304l48 48-48 48m0-288l48 48-48 48M64 352h85.19a80 80 0 0066.56-35.62L256 256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 160h85.19a80 80 0 0166.56 35.62l80.5 120.76A80 80 0 00362.81 352H416m0-192h-53.19a80 80 0 00-66.56 35.62L288 208"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6ea2379d54d7f57d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 225.64v99a64 64 0 01-40.23 59.42l-23.68 9.47A32 32 0 00364.6 417l-10 50.14A16 16 0 01338.88 480H173.12a16 16 0 01-15.69-12.86L147.4 417a32 32 0 00-19.49-23.44l-23.68-9.47A64 64 0 0164 324.67V224c0-105.92 85.77-191.81 191.65-192S448 119.85 448 225.64z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "280",
                    "r": "40",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "344",
                    "cy": "280",
                    "r": "40",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 336l-16 48h32l-16-48zm0 112v32m-48-32v32m96-32v32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c635c97eaf924c5b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 16C141.31 16 48 109.31 48 224v154.83l82 32.81L146.88 496H192v-64h32v64h16v-64h32v64h16v-64h32v64h45.12L382 411.64l82-32.81V224c0-114.69-93.31-208-208-208zm-88 320a56 56 0 1156-56 56.06 56.06 0 01-56 56zm51.51 64L244 320h24l24.49 80zM344 336a56 56 0 1156-56 56.06 56.06 0 01-56 56zm104 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c776be8011490f21(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M402 76.94C362.61 37.63 310.78 16 256 16h-.37A208 208 0 0048 224v100.67A79.62 79.62 0 0098.29 399l23.71 9.42a15.92 15.92 0 019.75 11.72l10 50.13A32.09 32.09 0 00173.12 496H184a8 8 0 008-8v-39.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01224 448v40a8 8 0 008 8 8 8 0 008-8v-39.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 448v40a8 8 0 008 8 8 8 0 008-8v-39.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01320 448v40a8 8 0 008 8h10.88a32.09 32.09 0 0031.38-25.72l10-50.14a16 16 0 019.74-11.72l23.71-9.42A79.62 79.62 0 00464 324.67v-99c0-56-22-108.81-62-148.73zM171.66 335.88a56 56 0 1152.22-52.22 56 56 0 01-52.22 52.22zM281 397.25a16.37 16.37 0 01-9.3 2.75h-31.4a16.37 16.37 0 01-9.28-2.75 16 16 0 01-6.6-16.9l15.91-47.6C243 326 247.25 321 254 320.13c8.26-1 14 2.87 17.61 12.22l16 48a16 16 0 01-6.61 16.9zm66.68-61.37a56 56 0 1152.22-52.22 56 56 0 01-52.24 52.22z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a35cdc9c83be204f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 32v448m57.72-400A111.47 111.47 0 01256 96a111.47 111.47 0 01-57.72-16m0 352a112.11 112.11 0 01115.44 0m136.27-288L62.01 368m375.26-150a112.09 112.09 0 01-57.71-100M74.73 294a112.09 112.09 0 0157.71 100M62.01 144l387.98 224M74.73 218a112.09 112.09 0 0057.71-100m304.83 176a112.09 112.09 0 00-57.71 100"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$22b23a8708d987d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.88 313.27l19.25-10.64-21.28-38.51-19.25 10.64a133.42 133.42 0 00-38.54 32.1L300 256l88.07-50.86a133.42 133.42 0 0038.54 32.1l19.25 10.64 21.28-38.51-19.25-10.64a89.27 89.27 0 01-20.93-16L480 152.05 458 114l-53 30.58a89.07 89.07 0 01-3.42-26.15l.41-22-44-.82-.41 22a133.62 133.62 0 008.49 49.39L278 217.89V116.18a133.52 133.52 0 0047.06-17.33L343.9 87.5l-22.71-37.69-18.84 11.35A89.5 89.5 0 01278 71.27V16h-44v55.27a89.5 89.5 0 01-24.35-10.11l-18.84-11.35L168.1 87.5l18.84 11.35A133.52 133.52 0 00234 116.18v101.71L145.93 167a133.62 133.62 0 008.53-49.43l-.41-22-44 .82.41 22a89.07 89.07 0 01-3.42 26.15L54 114l-22 38.1 53.05 30.64a89.27 89.27 0 01-20.93 16l-19.25 10.63 21.28 38.51 19.25-10.64a133.42 133.42 0 0038.54-32.1L212 256l-88.07 50.86a133.42 133.42 0 00-38.54-32.1l-19.24-10.64-21.28 38.51 19.25 10.64a89.27 89.27 0 0120.93 16L32 360l22 38.1 53.05-30.63a89.07 89.07 0 013.42 26.15l-.41 22 44 .82.41-22a133.62 133.62 0 00-8.54-49.44L234 294.11v101.71a133.52 133.52 0 00-47.06 17.33L168.1 424.5l22.71 37.69 18.84-11.35A89.5 89.5 0 01234 440.73V496h44v-55.27a89.5 89.5 0 0124.35 10.11l18.84 11.35 22.71-37.69-18.84-11.35A133.52 133.52 0 00278 395.82V294.11L366.07 345a133.62 133.62 0 00-8.53 49.43l.41 22 44-.82-.41-22a89.07 89.07 0 013.46-26.19l53 30.63L480 360l-53-30.69a89.27 89.27 0 0120.88-16.04z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b44a323ce306bb3d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461 349l-34-19.64a89.53 89.53 0 0120.94-16 22 22 0 00-21.28-38.51 133.62 133.62 0 00-38.55 32.1L300 256l88.09-50.86a133.46 133.46 0 0038.55 32.1 22 22 0 1021.28-38.51 89.74 89.74 0 01-20.94-16l34-19.64A22 22 0 10439 125l-34 19.63a89.74 89.74 0 01-3.42-26.15A22 22 0 00380 96h-.41a22 22 0 00-22 21.59 133.61 133.61 0 008.5 49.41L278 217.89V116.18a133.5 133.5 0 0047.07-17.33 22 22 0 00-22.71-37.69A89.56 89.56 0 01278 71.27V38a22 22 0 00-44 0v33.27a89.56 89.56 0 01-24.36-10.11 22 22 0 10-22.71 37.69A133.5 133.5 0 00234 116.18v101.71L145.91 167a133.61 133.61 0 008.52-49.43 22 22 0 00-22-21.59H132a22 22 0 00-21.59 22.41 89.74 89.74 0 01-3.41 26.19L73 125a22 22 0 10-22 38.1l34 19.64a89.74 89.74 0 01-20.94 16 22 22 0 1021.28 38.51 133.62 133.62 0 0038.55-32.1L212 256l-88.09 50.86a133.62 133.62 0 00-38.55-32.1 22 22 0 10-21.28 38.51 89.74 89.74 0 0120.94 16L51 349a22 22 0 1022 38.1l34-19.63a89.74 89.74 0 013.42 26.15A22 22 0 00132 416h.41a22 22 0 0022-21.59 133.61 133.61 0 00-8.5-49.41L234 294.11v101.71a133.5 133.5 0 00-47.07 17.33 22 22 0 1022.71 37.69A89.56 89.56 0 01234 440.73V474a22 22 0 0044 0v-33.27a89.56 89.56 0 0124.36 10.11 22 22 0 0022.71-37.69A133.5 133.5 0 00278 395.82V294.11L366.09 345a133.61 133.61 0 00-8.52 49.43 22 22 0 0022 21.59h.43a22 22 0 0021.59-22.41 89.74 89.74 0 013.41-26.19l34 19.63A22 22 0 10461 349z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ddbb81dfa6ffbca9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M259.92 262.91L216.4 149.77a9 9 0 00-16.8 0l-43.52 113.14a9 9 0 01-5.17 5.17L37.77 311.6a9 9 0 000 16.8l113.14 43.52a9 9 0 015.17 5.17l43.52 113.14a9 9 0 0016.8 0l43.52-113.14a9 9 0 015.17-5.17l113.14-43.52a9 9 0 000-16.8l-113.14-43.52a9 9 0 01-5.17-5.17zM108 68L88 16 68 68 16 88l52 20 20 52 20-52 52-20-52-20zm318.67 49.33L400 48l-26.67 69.33L304 144l69.33 26.67L400 240l26.67-69.33L496 144l-69.33-26.67z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d3cb904a15c7ff5d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 512l-52.38-139.62L16 320l139.62-52.38L208 128l52.38 139.62L400 320l-139.62 52.38zM88 176l-23.57-64.43L0 88l64.43-23.57L88 0l23.57 64.43L176 88l-64.43 23.57zm312 80l-31.11-80.89L288 144l80.89-31.11L400 32l31.11 80.89L512 144l-80.89 31.11z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$69f944ec31459d8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 512a24.84 24.84 0 01-23.34-16l-39.84-103.6a16.06 16.06 0 00-9.19-9.19L32 343.34a25 25 0 010-46.68l103.6-39.84a16.06 16.06 0 009.19-9.19L184.66 144a25 25 0 0146.68 0l39.84 103.6a16.06 16.06 0 009.19 9.19l103 39.63a25.49 25.49 0 0116.63 24.1 24.82 24.82 0 01-16 22.82l-103.6 39.84a16.06 16.06 0 00-9.19 9.19L231.34 496A24.84 24.84 0 01208 512zm66.85-254.84zM88 176a14.67 14.67 0 01-13.69-9.4l-16.86-43.84a7.28 7.28 0 00-4.21-4.21L9.4 101.69a14.67 14.67 0 010-27.38l43.84-16.86a7.31 7.31 0 004.21-4.21L74.16 9.79A15 15 0 0186.23.11a14.67 14.67 0 0115.46 9.29l16.86 43.84a7.31 7.31 0 004.21 4.21l43.84 16.86a14.67 14.67 0 010 27.38l-43.84 16.86a7.28 7.28 0 00-4.21 4.21l-16.86 43.84A14.67 14.67 0 0188 176zm312 80a16 16 0 01-14.93-10.26l-22.84-59.37a8 8 0 00-4.6-4.6l-59.37-22.84a16 16 0 010-29.86l59.37-22.84a8 8 0 004.6-4.6l22.67-58.95a16.45 16.45 0 0113.17-10.57 16 16 0 0116.86 10.15l22.84 59.37a8 8 0 004.6 4.6l59.37 22.84a16 16 0 010 29.86l-59.37 22.84a8 8 0 00-4.6 4.6l-22.84 59.37A16 16 0 01400 256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b03ff139b2128cc8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.1 231.9l-47.5 75.5a31 31 0 01-7 7 30.11 30.11 0 01-35-49l75.5-47.5a10.23 10.23 0 0111.7 0 10.06 10.06 0 012.3 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 64C132.3 64 32 164.2 32 287.9a223.18 223.18 0 0056.3 148.5c1.1 1.2 2.1 2.4 3.2 3.5a25.19 25.19 0 0037.1-.1 173.13 173.13 0 01254.8 0 25.19 25.19 0 0037.1.1l3.2-3.5A223.18 223.18 0 00480 287.9C480 164.2 379.7 64 256 64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 128v32m160 128h-32m-256 0H96m69.49-90.51l-22.63-22.63m203.65 22.63l22.63-22.63"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$536e9b008d335370(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C123.46 48 16 156.55 16 290.56a243.3 243.3 0 0060.32 160.87c1.18 1.3 2.25 2.6 3.43 3.79C89.2 464 92.07 464 99.57 464s12.43 0 19.93-8.88C152 416.64 202 400 256 400s104.07 16.71 136.5 55.12C400 464 404.82 464 412.43 464s11.3 0 19.82-8.78c1.22-1.25 2.25-2.49 3.43-3.79A243.3 243.3 0 00496 290.56C496 156.55 388.54 48 256 48zm-16 64h32v64h-32zm-96 192H80v-32h64zm21.49-83.88l-45.25-45.26 22.62-22.62 45.26 45.25zM278.6 307.4a31 31 0 01-7 7 30.11 30.11 0 01-35-49L320 224zm45.28-109.91l45.26-45.25 22.62 22.62-45.25 45.26zM432 304h-64v-32h64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6d6b942e624c3f66(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.7 118.25A240 240 0 0076.32 447l.18.2c.33.35.64.71 1 1.05.74.84 1.58 1.79 2.57 2.78a41.17 41.17 0 0060.36-.42 157.13 157.13 0 01231.26 0 41.18 41.18 0 0060.65.06l3.21-3.5.18-.2a239.93 239.93 0 00-10-328.76zM240 128a16 16 0 0132 0v32a16 16 0 01-32 0zM128 304H96a16 16 0 010-32h32a16 16 0 010 32zm48.8-95.2a16 16 0 01-22.62 0l-22.63-22.62a16 16 0 0122.63-22.63l22.62 22.63a16 16 0 010 22.62zm149.3 23.1l-47.5 75.5a31 31 0 01-7 7 30.11 30.11 0 01-35-49l75.5-47.5a10.23 10.23 0 0111.7 0 10.06 10.06 0 012.3 14zm31.72-23.1a16 16 0 01-22.62-22.62l22.62-22.63a16 16 0 0122.63 22.63zm65.88 227.6zM416 304h-32a16 16 0 010-32h32a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e2a60c95fc077596(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 448H96a32.09 32.09 0 01-32-32V96a32.09 32.09 0 0132-32h320a32.09 32.09 0 0132 32v320a32.09 32.09 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3634a57cfc09345(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 48h416v416H48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a66ab86110e1a0df(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 464H96a48.05 48.05 0 01-48-48V96a48.05 48.05 0 0148-48h320a48.05 48.05 0 0148 48v320a48.05 48.05 0 01-48 48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e33c994ab9df0ac(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48v316L118 464l54-160-140-96h172l52-160z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ed6299ddd946027e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 203.3H312.36L256 32l-56.36 171.3H16l150.21 105.4-58.5 171.3L256 373.84 404.29 480l-58.61-171.3zM274.63 347.82L256 334.49v-200.1l26 78.91 7.24 22h105.39l-67.32 47.2-19.69 13.81 7.78 22.75 26.26 76.75z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4e5d894c2fe3b008(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48v316L118 464l54-160-140-96h172l52-160z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$400ff8b1ec667ec4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5028bd702b09356e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 203.3H312.36L256 32l-56.36 171.3H16l150.21 105.4-58.5 171.3L256 373.84 404.29 480l-58.61-171.3z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$eb8fc4dec48ba1e1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$183c4eef6411f306(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "160",
                    "x": "64",
                    "y": "320",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "256",
                    "x": "288",
                    "y": "224",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "368",
                    "x": "400",
                    "y": "112",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "448",
                    "x": "176",
                    "y": "32",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$194e6e80d29a8d6e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 496H48V304h80zm224 0h-80V208h80zm112 0h-80V96h80zm-224 0h-80V16h80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$75773671c0b648a7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 496H72a24 24 0 01-24-24V328a24 24 0 0124-24h32a24 24 0 0124 24v144a24 24 0 01-24 24zm224 0h-32a24 24 0 01-24-24V232a24 24 0 0124-24h32a24 24 0 0124 24v240a24 24 0 01-24 24zm112 0h-32a24 24 0 01-24-24V120a24 24 0 0124-24h32a24 24 0 0124 24v352a24 24 0 01-24 24zm-224 0h-32a24 24 0 01-24-24V40a24 24 0 0124-24h32a24 24 0 0124 24v432a24 24 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$72ddc8ed92f6d37c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M310.4 336H201.6a25.62 25.62 0 01-25.6-25.6V201.6a25.62 25.62 0 0125.6-25.6h108.8a25.62 25.62 0 0125.6 25.6v108.8a25.62 25.62 0 01-25.6 25.6z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bb215fc0500b2c3b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 288H176V176h160z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3803644d92172d57(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 262.4a25.62 25.62 0 01-25.6 25.6H201.6a25.62 25.62 0 01-25.6-25.6V201.6a25.62 25.62 0 0125.6-25.6h108.8a25.62 25.62 0 0125.6 25.6z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5c01e83fa6cd4dd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "320",
                    "height": "320",
                    "x": "96",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "24",
                    "ry": "24"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ba7cdd796d523023(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 80h352v352H80z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$94ebf75eff7e63fd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 432H120a40 40 0 01-40-40V120a40 40 0 0140-40h272a40 40 0 0140 40v272a40 40 0 01-40 40z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c1e1c5de00398e2d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 232v-80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M256 88V72m-124 60l-12-12"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "272",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 96a176 176 0 10176 176A176 176 0 00256 96z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e6ca45ef89ba21b5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 81.5V48h-48v33.5a191 191 0 00-84.43 32.13L120 86l-34 34 25.59 25.59A191.17 191.17 0 0064 272c0 105.87 86.13 192 192 192s192-86.13 192-192c0-97.74-73.42-178.66-168-190.5zM256 320a48 48 0 01-16-93.25V136h32v90.75A48 48 0 01256 320z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$aa36cd8f43023d72(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "272",
                    "r": "16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M280 81.5V72a24 24 0 00-48 0v9.5a191 191 0 00-84.43 32.13L137 103a24 24 0 00-34 34l8.6 8.6A191.17 191.17 0 0064 272c0 105.87 86.13 192 192 192s192-86.13 192-192c0-97.74-73.42-178.66-168-190.5zM256 320a48 48 0 01-16-93.25V152a16 16 0 0132 0v74.75A48 48 0 01256 320z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$262f0c929f527616(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 448V240m-384 0v208M382.47 48H129.53c-21.79 0-41.47 12-49.93 30.46L36.3 173c-14.58 31.81 9.63 67.85 47.19 69h2c31.4 0 56.85-25.18 56.85-52.23 0 27 25.46 52.23 56.86 52.23s56.8-23.38 56.8-52.23c0 27 25.45 52.23 56.85 52.23s56.86-23.38 56.86-52.23c0 28.85 25.45 52.23 56.85 52.23h1.95c37.56-1.17 61.77-37.21 47.19-69l-43.3-94.54C423.94 60 404.26 48 382.47 48zM32 464h448M136 288h80a24 24 0 0124 24v88h0-128 0v-88a24 24 0 0124-24zm152 176V312a24 24 0 0124-24h64a24 24 0 0124 24v152"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7cbe7451e639879d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 448V267.85a104.76 104.76 0 01-33.56 6.58c-1.18 0-2.3.05-3.4.05a108 108 0 01-56.86-16 108 108 0 01-56.85 16 106.16 106.16 0 01-56.51-16.2 107.84 107.84 0 01-57.2 16.2 106.14 106.14 0 01-56.85-16.42 106.14 106.14 0 01-56.85 16.42c-1.09 0-2.19 0-3.37-.05h-.06A104.66 104.66 0 0148 267.49V448H16v32h480v-32zm-240-64h-96v-76a4 4 0 014-4h88a4 4 0 014 4zm160 64h-80V308a4 4 0 014-4h72a4 4 0 014 4zm108.57-277.72L445.89 64C432 32 432 32 400 32H112c-32 0-32 0-45.94 32L19.38 170.28c-9 19.41 2.89 39.34 2.9 39.35l.41.66c.42.66 1.13 1.75 1.62 2.37.1.13.19.27.28.4l5.24 6.39 5.31 5.14.42.36a69.65 69.65 0 009.44 6.78v.05a74 74 0 0036 10.67h2.47a76.08 76.08 0 0051.89-20.31 72.38 72.38 0 005.77-6 74.18 74.18 0 005.78 6 76.08 76.08 0 0051.89 20.31c23.28 0 44.07-10 57.63-25.56a.11.11 0 01.15 0l5.66 5.26a76.09 76.09 0 0051.9 20.31c23.29 0 44.11-10 57.66-25.61 13.56 15.61 34.37 25.61 57.67 25.61h2.49a71.35 71.35 0 0035-10.7c.95-.57 1.86-1.17 2.78-1.77A71.33 71.33 0 00488 212.17l2-3c.9-2.04 11.21-20.3 2.57-38.89z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$46bd4be3df6807eb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 448h-12a4 4 0 01-4-4V273.51a4 4 0 00-5.24-3.86 104.92 104.92 0 01-28.32 4.78c-1.18 0-2.3.05-3.4.05a108.22 108.22 0 01-52.85-13.64 8.23 8.23 0 00-8 0 108.18 108.18 0 01-52.84 13.64 106.11 106.11 0 01-52.46-13.79 8.21 8.21 0 00-8.09 0 108.14 108.14 0 01-53.16 13.8 106.19 106.19 0 01-52.77-14 8.25 8.25 0 00-8.16 0 106.19 106.19 0 01-52.77 14c-1.09 0-2.19 0-3.37-.05h-.06a104.91 104.91 0 01-29.28-5.09 4 4 0 00-5.23 3.8V444a4 4 0 01-4 4H32.5c-8.64 0-16.1 6.64-16.48 15.28A16 16 0 0032 480h447.5c8.64 0 16.1-6.64 16.48-15.28A16 16 0 00480 448zm-256-68a4 4 0 01-4 4h-88a4 4 0 01-4-4v-64a12 12 0 0112-12h72a12 12 0 0112 12zm156 68h-72a4 4 0 01-4-4V316a12 12 0 0112-12h56a12 12 0 0112 12v128a4 4 0 01-4 4zm112.57-277.72l-42.92-98.49C438.41 47.62 412.74 32 384.25 32H127.7c-28.49 0-54.16 15.62-65.4 39.79l-42.92 98.49c-9 19.41 2.89 39.34 2.9 39.35l.28.45c.49.78 1.36 2 1.89 2.78.05.06.09.13.14.2l5 6.05a7.45 7.45 0 00.6.65l5 4.83.42.36a69.65 69.65 0 009.39 6.78v.05a74 74 0 0036 10.67h2.47a76.08 76.08 0 0051.89-20.31l.33-.31a7.94 7.94 0 0110.89 0l.33.31a77.3 77.3 0 00104.46 0 8 8 0 0110.87 0 77.31 77.31 0 00104.21.23 7.88 7.88 0 0110.71 0 76.81 76.81 0 0052.31 20.08h2.49a71.35 71.35 0 0035-10.7c.95-.57 1.86-1.17 2.78-1.77A71.33 71.33 0 00488 212.17l1.74-2.63q.26-.4.48-.84c1.66-3.38 10.56-20.76 2.35-38.42z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c32e86d4c9a14d53(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "288",
                    "height": "352",
                    "x": "112",
                    "y": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M208 80h96"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "288",
                    "height": "96",
                    "x": "112",
                    "y": "128",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "176",
                    "cy": "320",
                    "r": "16",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "336",
                    "cy": "320",
                    "r": "16",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 464h224m-32-32l48 48m-208-48l-48 48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a9064290c3a36230(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 16H120a24 24 0 00-24 24v336a24 24 0 0024 24h272a24 24 0 0024-24V40a24 24 0 00-24-24zM208 64h95.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 96h-95.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01208 64zm-28.53 287.82a32 32 0 1128.35-28.35 32 32 0 01-28.35 28.35zm160 0a32 32 0 1128.35-28.35 32 32 0 01-28.35 28.35zM384 144v64H128v-64zm-86 272l31.37 32H182.63L214 416h-44l-80.57 80h45.2l16-16h210.74l16 16h45.3L343 416h-45z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e14bb36942b0200(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 16H160a64.07 64.07 0 00-64 64v256a64.07 64.07 0 0064 64h192a64.07 64.07 0 0064-64V80a64.07 64.07 0 00-64-64zM208 64h96a16 16 0 010 32h-96a16 16 0 010-32zm-32 288a32 32 0 1132-32 32 32 0 01-32 32zm160 0a32 32 0 1132-32 32 32 0 01-32 32zm48-160a16 16 0 01-16 16H144a16 16 0 01-16-16v-32a16 16 0 0116-16h224a16 16 0 0116 16zm-36.69 228.69a16 16 0 00-22.62 22.62l4.68 4.69H182.63l4.68-4.69a16 16 0 00-22.62-22.62l-48 48a16 16 0 1022.62 22.62L150.63 480h210.74l11.32 11.31a16 16 0 0022.62-22.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$18f34437cb1dcda5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 48v48m0 320v48m147.08-355.08l-33.94 33.94M142.86 369.14l-33.94 33.94M464 256h-48m-320 0H48m355.08 147.08l-33.94-33.94M142.86 142.86l-33.94-33.94"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "80",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e73fb4f4641d5fa6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M234 26h44v92h-44zm0 368h44v92h-44zm104.025-251.143l65.054-65.054 31.113 31.113-65.054 65.054zM77.815 403.074l65.054-65.054 31.113 31.113-65.054 65.054zM394 234h92v44h-92zm-368 0h92v44H26zm312.029 135.14l31.112-31.113 65.054 65.054-31.112 31.112zM77.802 108.92l31.113-31.113 65.054 65.054-31.113 31.112zM256 358a102 102 0 11102-102 102.12 102.12 0 01-102 102z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b69474903e66a464(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 118a22 22 0 01-22-22V48a22 22 0 0144 0v48a22 22 0 01-22 22zm0 368a22 22 0 01-22-22v-48a22 22 0 0144 0v48a22 22 0 01-22 22zm113.14-321.14a22 22 0 01-15.56-37.55l33.94-33.94a22 22 0 0131.11 31.11l-33.94 33.94a21.93 21.93 0 01-15.55 6.44zM108.92 425.08a22 22 0 01-15.55-37.56l33.94-33.94a22 22 0 1131.11 31.11l-33.94 33.94a21.94 21.94 0 01-15.56 6.45zM464 278h-48a22 22 0 010-44h48a22 22 0 010 44zm-368 0H48a22 22 0 010-44h48a22 22 0 010 44zm307.08 147.08a21.94 21.94 0 01-15.56-6.45l-33.94-33.94a22 22 0 0131.11-31.11l33.94 33.94a22 22 0 01-15.55 37.56zM142.86 164.86a21.89 21.89 0 01-15.55-6.44l-33.94-33.94a22 22 0 0131.11-31.11l33.94 33.94a22 22 0 01-15.56 37.55zM256 358a102 102 0 11102-102 102.12 102.12 0 01-102 102z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$74db5993a1075a0b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 48l112 112-112 112m94.87-112H96m112 304L96 352l112-112m-94 112h302"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bc310f2b2bdf4569(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M304 48l112 112-112 112m94.87-112H96m112 304L96 352l112-112m-94 112h302"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b9b5f29b4060556f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 48l112 112-112 112m94.87-112H96m112 304L96 352l112-112m-94 112h302"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f51b2aa73136a529(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M464 208L352 96 240 208m112-94.87V416M48 304l112 112 112-112m-112 94V96"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fea55d5506519881(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M464 208L352 96 240 208m112-94.87V416M48 304l112 112 112-112m-112 94V96"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$72d023873b6951cf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M464 208L352 96 240 208m112-94.87V416M48 304l112 112 112-112m-112 94V96"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$fdbe352ad7d81fe4(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M351.82 271.87v-16A96.15 96.15 0 00184.09 192m-24.2 48.17v16A96.22 96.22 0 00327.81 320"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M135.87 256l23.59-23.6 24.67 23.6m192 0l-23.59 23.6-24.67-23.6"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$97910f8793daa2b1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm0 320a112.19 112.19 0 01-111.27-98.23l-8.86 8.86L113.24 256l46-46 47.55 45.48-22.12 23.12-7.2-6.88a80.26 80.26 0 00138.48 37.5l23.77 21.41A112.82 112.82 0 01256 368zm96.79-66l-47.55-45.5 22.12-23.12 6.86 6.55A80.2 80.2 0 00196 202.64l-23.82-21.37A112.18 112.18 0 01367 242.49l9.11-9.12L398.76 256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c36d66e29e723fb7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm83.69 282.65a112.24 112.24 0 01-195-61.29 16 16 0 01-20.13-24.67l23.6-23.6a16 16 0 0122.37-.25l24.67 23.6a16 16 0 01-18 26 80.25 80.25 0 00138.72 38.83 16 16 0 0123.77 21.41zm47.76-63.34l-23.6 23.6a16 16 0 01-22.37.25l-24.67-23.6a16 16 0 0117.68-26.11A80.17 80.17 0 00196 202.64a16 16 0 11-23.82-21.37 112.17 112.17 0 01194.88 61.57 16 16 0 0120.39 24.47z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bef63d079861462b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M434.67 285.59v-29.8c0-98.73-80.24-178.79-179.2-178.79a179 179 0 00-140.14 67.36m-38.53 82v29.8C76.8 355 157 435 256 435a180.45 180.45 0 00140-66.92"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M32 256l44-44 46 44m358 0l-44 44-46-44"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8c8f6fccb36957da(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M434.67 285.59v-29.8c0-98.73-80.24-178.79-179.2-178.79a179 179 0 00-140.14 67.36m-38.53 82v29.8C76.8 355 157 435 256 435a180.45 180.45 0 00140-66.92"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M32 256l44-44 46 44m358 0l-44 44-46-44"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$55aeefe1b7d95d18(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M434.67 285.59v-29.8c0-98.73-80.24-178.79-179.2-178.79a179 179 0 00-140.14 67.36m-38.53 82v29.8C76.8 355 157 435 256 435a180.45 180.45 0 00140-66.92"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M32 256l44-44 46 44m358 0l-44 44-46-44"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$aaedaf3c2b08ef8b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "352",
                    "height": "480",
                    "x": "80",
                    "y": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48",
                    "transform": "rotate(-90 256 256)"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1eb8c5ab140e77e0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 82v348a18 18 0 0018 18h476a18 18 0 0018-18V82a18 18 0 00-18-18H18A18 18 0 000 82zm448 330H64V100h384z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bb306e506c354296(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128v256a64.07 64.07 0 01-64 64H64a64.07 64.07 0 01-64-64V128a64.07 64.07 0 0164-64h384a64.07 64.07 0 0164 64zM32 384a32 32 0 0032 32h384a32 32 0 0032-32V128a32 32 0 00-32-32H64a32 32 0 00-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 128a64.07 64.07 0 0164-64h384a64.07 64.07 0 0164 64v256a64.07 64.07 0 01-64 64H64a64.07 64.07 0 01-64-64V128m480 256V128a32 32 0 00-32-32H64a32 32 0 00-32 32v256a32 32 0 0032 32h384a32 32 0 0032-32m-16 0a16 16 0 01-16 16H64a16 16 0 01-16-16V128a16 16 0 0116-16h384a16 16 0 0116 16v256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c7b7d6ea9ee9fc8c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "352",
                    "height": "480",
                    "x": "80",
                    "y": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d9be0b50957b5827(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M430 0H82a18 18 0 00-18 18v476a18 18 0 0018 18h348a18 18 0 0018-18V18a18 18 0 00-18-18zM100 448V64h312v384z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5fd08a22a10b6c9a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 512H128a64.07 64.07 0 01-64-64V64a64.07 64.07 0 0164-64h256a64.07 64.07 0 0164 64v384a64.07 64.07 0 01-64 64zM128 32a32 32 0 00-32 32v384a32 32 0 0032 32h256a32 32 0 0032-32V64a32 32 0 00-32-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M384 0a64.07 64.07 0 0164 64v384a64.07 64.07 0 01-64 64H128a64.07 64.07 0 01-64-64V64a64.07 64.07 0 0164-64h256M128 480h256a32 32 0 0032-32V64a32 32 0 00-32-32H128a32 32 0 00-32 32v384a32 32 0 0032 32m0-16a16 16 0 01-16-16V64a16 16 0 0116-16h256a16 16 0 0116 16v384a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$cb015c8d9de2316c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M39.93 327.56l-4.71-8.13A24 24 0 0144 286.64l86.87-50.07a16 16 0 0121.89 5.86l12.71 22a16 16 0 01-5.86 21.85l-86.85 50.07a24.06 24.06 0 01-32.83-8.79z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M170.68 273.72L147.12 233a24 24 0 018.8-32.78l124.46-71.75a16 16 0 0121.89 5.86l31.57 54.59a16 16 0 01-5.84 21.84L203.51 282.5a24 24 0 01-32.83-8.78zm171.17-71.51l-46.51-80.43a24 24 0 018.8-32.78l93.29-53.78A24.07 24.07 0 01430.27 44l46.51 80.43a24 24 0 01-8.8 32.79L374.69 211a24.06 24.06 0 01-32.84-8.79zM127.59 480l96.14-207.99m48.07-15.99L368.55 448"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3f9975e7ba65869a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.41 292.9l44.82 76.97 98.14-56.38-44.73-77.37L1.41 292.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M287.87 252.34l23.67-13.81-63.42-110-132.92 77C133.75 237.51 176 310 176 310l15.53-8.32c.24-.13.55 0 .83 0L102.65 496h35.16l99.05-214.25 23.24-13.4L358 464h36zM262.08 96c24.81 42.23 60.25 104.25 86.4 148.76L510.79 151 424.07 1.41z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1ed853ee3debe144(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.56 250a16 16 0 00-21.85-5.86L36 272.81a39.71 39.71 0 00-18.8 24.91 40.9 40.9 0 004.55 30.35l4.36 7.54a40 40 0 0054.62 14.62l49.67-28.63a16 16 0 005.87-21.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M382.84 440.8L288.72 254a2 2 0 01.79-2.63l8.3-4.79a16 16 0 005.86-21.86l-47.53-82.33a16 16 0 00-21.86-5.87l-86.38 49.8a39.73 39.73 0 00-18.65 24.28 34.82 34.82 0 00-1.37 9.76c.06 7.6 9.2 22.7 18.12 38.28 9.59 16.75 19.24 33.88 26.34 38.15 4.52 2.72 12.5 4.9 19.21 4.9h.84l-79.32 171.6a16 16 0 1029.05 13.42l93.68-202.65a7.94 7.94 0 013.26-3.57l19.21-11.08a2 2 0 012.78.84l93.21 185a16 16 0 0028.58-14.4zm107.37-325.06L444.09 36a40.08 40.08 0 00-54.63-14.62l-93.34 53.78a39.69 39.69 0 00-18.65 24.28 32.76 32.76 0 00-1.27 13.25c1.74 12.62 13 30.4 26.41 53.89 13.58 23.73 28.91 50.48 36.93 56.27a40.18 40.18 0 0023.18 7.37 39.77 39.77 0 0019.92-5.34L476 171.07a39.72 39.72 0 0018.79-24.84 41 41 0 00-4.58-30.49z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$da10bf4957017440(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M461.43 271.44c-5.09.37-8.24.56-13.43.56-114.88 0-208-93.12-208-208 0-5.37.2-8.69.6-14M49.65 240.56S58.84 240 64 240c114.88 0 208 93.12 208 208 0 5.38-.61 14-.61 14"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f8c58bd742f48ded(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.4 480a181 181 0 003.22-22.86c.35-4.61.53-9.31.53-14 0-100-81.34-181.32-181.32-181.32A181.72 181.72 0 0032 265.61 224.2 224.2 0 00246.4 480z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M284.63 227.37A222.73 222.73 0 01219 68.83a227.09 227.09 0 012.62-34.42A224.41 224.41 0 0034.41 221.58 227.09 227.09 0 0168.83 219a222.73 222.73 0 01158.54 65.67A222.73 222.73 0 01293 443.17c0 5.74-.22 11.54-.65 17.23s-1.11 11.51-2 17.2a224.42 224.42 0 00187.24-187.18 227.09 227.09 0 01-34.42 2.58 222.73 222.73 0 01-158.54-65.63z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M443.17 250.15a181.72 181.72 0 0036.83-3.76A224.2 224.2 0 00265.61 32a181.72 181.72 0 00-3.76 36.83c0 99.98 81.34 181.32 181.32 181.32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$767b1df3ed303961(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 256a192.55 192.55 0 0032-2.68A224 224 0 00258.68 32 192.55 192.55 0 00256 64c0 105.87 86.13 192 192 192zM253.35 480c.94-5.67 1.65-11.4 2.09-17.18.37-4.88.56-9.86.56-14.79 0-105.87-86.13-192-192-192a192.55 192.55 0 00-32 2.68A224 224 0 00253.35 480z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M289.61 222.39A222.53 222.53 0 01224 64a226.07 226.07 0 012-30A224.1 224.1 0 0034 226a226.07 226.07 0 0130-2 222.53 222.53 0 01158.39 65.61A222.53 222.53 0 01288 448c0 5.74-.22 11.53-.65 17.22q-.5 6.42-1.36 12.79A224.12 224.12 0 00478 286a226.07 226.07 0 01-30 2 222.53 222.53 0 01-158.39-65.61z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c1722ba260f2f7af(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "416",
                    "x": "32",
                    "y": "48",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M96 112l80 64-80 64m96 0h64"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ca5527aab2288c5d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 44v424a12 12 0 0012 12h456a12 12 0 0012-12V44a12 12 0 00-12-12H28a12 12 0 00-12 12zm57.51 193.5l76.88-61.5-76.88-61.5 20-25 108.1 86.5L93.5 262.49zM272 256h-96v-32h96z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c2de65f2e914c726(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 32H80a64.07 64.07 0 00-64 64v320a64.07 64.07 0 0064 64h352a64.07 64.07 0 0064-64V96a64.07 64.07 0 00-64-64zM96 256a16 16 0 01-10-28.49L150.39 176 86 124.49a16 16 0 1120-25l80 64a16 16 0 010 25l-80 64A16 16 0 0196 256zm160 0h-64a16 16 0 010-32h64a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$995843d177da77e7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M32 415.5l120-320 120 320m-42-112H74m252-64c12.19-28.69 41-48 74-48h0c46 0 80 32 80 80v144"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 358.5c0 36 26.86 58 60 58 54 0 100-27 100-106v-15c-20 0-58 1-92 5-32.77 3.86-68 19-68 58z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6f4ebccc18fdc483(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M404.42 170c-41.23 0-78.07 24.06-93.85 61.3L304 246.52l40.33 17.18 6.56-15.22c8.9-21 29.91-34.55 53.53-34.55 34.55 0 57.76 23.27 57.76 57.91v2.3c-22.12.59-48.65 2.05-72.27 4.84-54.52 6.43-87.06 36.23-87.06 79.72 0 23.16 8.72 44 24.56 58.59C342.28 431 362.55 438 384.51 438c30.86 0 57.5-7.33 77.67-22.64V438H506V271.84C506 212.83 463.28 170 404.42 170zm-19.91 225.07c-17.46 0-37.85-9.84-37.85-36.37 0-10.65 3.82-18.11 12.38-24.19 8.34-5.92 21.12-10.15 36-11.9 21.78-2.57 46.31-3.95 67-4.52-2.16 51.49-27.57 76.98-77.53 76.98zm-291.26-69.2h125.5L260.94 438H308L155 48 4 438h47.06zM156 160.71L202.25 282h-92.5z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e031c9aafea22e3c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M292.6 407.78l-120-320a22 22 0 00-41.2 0l-120 320a22 22 0 0041.2 15.44l36.16-96.42a2 2 0 011.87-1.3h122.74a2 2 0 011.87 1.3l36.16 96.42a22 22 0 0041.2-15.44zm-185.84-129l43.37-115.65a2 2 0 013.74 0l43.37 115.67a2 2 0 01-1.87 2.7h-86.74a2 2 0 01-1.87-2.7zM400.77 169.5c-41.72-.3-79.08 23.87-95 61.4a22 22 0 0040.5 17.2c8.88-20.89 29.77-34.44 53.32-34.6 32.32-.22 58.41 26.5 58.41 58.85a1.5 1.5 0 01-1.45 1.5c-21.92.61-47.92 2.07-71.12 4.8-54.75 6.44-87.43 36.29-87.43 79.85 0 23.19 8.76 44 24.67 58.68C337.6 430.93 358 438.5 380 438.5c31 0 57.69-8 77.94-23.22h.06a22 22 0 1044 .19v-143c0-56.18-45-102.56-101.23-102.97zM380 394.5c-17.53 0-38-9.43-38-36 0-10.67 3.83-18.14 12.43-24.23 8.37-5.93 21.2-10.16 36.14-11.92 21.12-2.49 44.82-3.86 65.14-4.47a2 2 0 012 2.1C455 370.1 429.46 394.5 380 394.5z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b954fcd311ecc539(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M307.72 302.27a8 8 0 01-3.72-6.75V80a48 48 0 00-48-48h0a48 48 0 00-48 48v215.52a8 8 0 01-3.71 6.74 97.51 97.51 0 00-44.19 86.07A96 96 0 00352 384a97.49 97.49 0 00-44.28-81.73zM256 112v272"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "384",
                    "r": "48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4a8cc0557aef500d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 291.24V80a64 64 0 10-128 0v211.24A113.39 113.39 0 00144 384a112 112 0 00224 0 113.39 113.39 0 00-48-92.76zM256 432a48 48 0 01-16-93.26V96h32v242.74A48 48 0 01256 432z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2b397663952f8b77(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 287.18V81c0-35.12-27.89-64.42-63-64.95a64.08 64.08 0 00-65 64v207.13a8 8 0 01-3.18 6.37A113.48 113.48 0 00144 384a112 112 0 00224 0 113.48 113.48 0 00-44.82-90.45 8 8 0 01-3.18-6.37zM254.07 432a48 48 0 01-22-89.54 16 16 0 008-13.84V112.45c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 112v216.58a16.18 16.18 0 008.15 13.94A48 48 0 01254.07 432z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5954f694c5b7e249(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M192 53.84S208 48 256 48s74 16 96 32h64a64 64 0 0164 64v48a64 64 0 01-64 64h-30a32.34 32.34 0 00-27.37 15.4S350 290.19 324 335.22 248 448 240 464c-29 0-43-22-34-47.71 10.28-29.39 23.71-54.38 27.46-87.09.54-4.78-3.14-12-8-12L96 307"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M96 241l80 2c20 1.84 32 12.4 32 30h0c0 17.6-14 28.84-32 30l-80 4c-17.6 0-32-16.4-32-34v-.17A32 32 0 0196 241zm-32-65l112 2c18 .84 32 12.41 32 30h0c0 17.61-14 28.86-32 30l-112 2a32.1 32.1 0 01-32-32h0a32.1 32.1 0 0132-32zm48-128l64 3c21 1.84 32 11.4 32 29h0c0 17.6-14.4 30-32 30l-64 2a32.09 32.09 0 01-32-32h0a32.09 32.09 0 0132-32zm-32 64l96 2c19 .84 32 12.4 32 30h0c0 17.6-13 28.84-32 30l-96 2a32.09 32.09 0 01-32-32h0a32.09 32.09 0 0132-32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$44c6189bd3f6af1b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M56 320l156.05 12-23 89.4c-6.08 26.6.7 41.87 22.39 48.62l34.69 9.85a4 4 0 004.4-1.72l129-202.34a8 8 0 016.81-3.81H496V64H378.39a48 48 0 01-15.18-2.46l-76.3-25.43a80 80 0 00-25.3-4.11H83.68c-19 0-31.5 13.52-35.23 32.16L16 206.42V280c0 22.06 18 38 40 40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M378.45 273.93A15.84 15.84 0 01386 272a15.93 15.93 0 00-7.51 1.91zm-40.59 69.29l-.13.22a2.53 2.53 0 01.13-.22c20.5-35.51 30.36-55 33.82-62-3.47 7.06-13.34 26.51-33.82 62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M372.66 279.16l-1 2a16.29 16.29 0 016.77-7.26 16.48 16.48 0 00-5.77 5.26z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3a176c949fc9cfbe(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M39.94 178l144.16 6.12c4.61.36 23.9 1.22 23.9 25.88 0 23.8-19.16 25.33-24.14 25.88L39.94 242C27.27 241.87 16 227.56 16 210s11.27-31.87 23.94-32zm141.45 131.66L74.65 318C62 318 48 301.31 48 284.12v-.33c0-16.33 11.14-29.63 24.88-29.79l108.45 1.72C208 259 208 275.16 208 282.12c0 22.88-21.8 27.14-26.61 27.54zM90.15 32l89.37 8.93C204 41.86 208 58.18 208 68.4c0 18.39-13.41 24.6-26.67 24.6l-91 3C75.78 95.78 64 81.51 64 64s11.68-31.66 26.15-32zm-34.36 71.5l126.4 6.22c9.39.63 25.81 3 25.81 26.36 0 12-4.35 25.62-25 27.53L55.79 167.5C42.65 167.35 32 154 32 136.08s10.65-32.43 23.79-32.58z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M378.45 273.93A15.84 15.84 0 01386 272a15.93 15.93 0 00-7.51 1.91zm-40.59 69.29l-.13.22a2.53 2.53 0 01.13-.22c20.5-35.51 30.36-55 33.82-62-3.47 7.06-13.34 26.51-33.82 62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M372.66 279.16l-1 2a16.29 16.29 0 016.77-7.26 16.48 16.48 0 00-5.77 5.26z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M195.94 459.38C205.37 472.67 221 480 240 480a16 16 0 0014.31-8.85c3-6.06 15.25-24 28.19-42.9 18-26.33 40.35-59.08 55.23-84.81l.13-.22c20.48-35.49 30.35-54.94 33.82-62l1-2a16.48 16.48 0 015.79-5.23A15.93 15.93 0 01386 272h25.32A84.7 84.7 0 00496 187.3v-38.6A84.7 84.7 0 00411.31 64h-48.79a17.46 17.46 0 01-9.58-2.89C330 46.13 286.66 32 240 32c-7.45 0-14.19.14-20.27.38a8 8 0 00-6.2 12.68l.1.14C222.2 57.59 224 71 224 80a61.16 61.16 0 01-5.19 24.77 17.38 17.38 0 000 14.06 63.81 63.81 0 010 50.39 17.32 17.32 0 000 14 62.13 62.13 0 010 49.58 18.13 18.13 0 000 14.68A60.41 60.41 0 01224 273c0 8.2-2 21.3-8 31.18a15.66 15.66 0 00-1.14 13.65c.38 1 .76 2.06 1.13 3.17a24.8 24.8 0 01.86 11.57c-3 19.35-9.67 36.3-16.74 54.16-3.08 7.78-6.27 15.82-9.22 24.27-6.14 17.56-4.3 35.2 5.05 48.38z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5c03ae37290b826e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 458.16S304 464 256 464s-74-16-96-32H96a64 64 0 01-64-64v-48a64 64 0 0164-64h30a32.34 32.34 0 0027.37-15.4S162 221.81 188 176.78 264 64 272 48c29 0 43 22 34 47.71-10.28 29.39-23.71 54.38-27.46 87.09-.54 4.78 3.14 12 7.95 12L416 205"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M416 271l-80-2c-20-1.84-32-12.4-32-30h0c0-17.6 14-28.84 32-30l80-4c17.6 0 32 16.4 32 34v.17A32 32 0 01416 271zm32 65l-112-2c-18-.84-32-12.41-32-30h0c0-17.61 14-28.86 32-30l112-2a32.1 32.1 0 0132 32h0a32.1 32.1 0 01-32 32zm-48 128l-64-3c-21-1.84-32-11.4-32-29h0c0-17.6 14.4-30 32-30l64-2a32.09 32.09 0 0132 32h0a32.09 32.09 0 01-32 32zm32-64l-96-2c-19-.84-32-12.4-32-30h0c0-17.6 13-28.84 32-30l96-2a32.09 32.09 0 0132 32h0a32.09 32.09 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8fed19cf20cd7dec(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 192l-156-12 23-89.4c6-26.6-.78-41.87-22.47-48.6l-34.69-9.85a4 4 0 00-4.4 1.72l-129 202.34a8 8 0 01-6.81 3.81H16V448h117.61a48 48 0 0115.18 2.46l76.3 25.43a80 80 0 0025.3 4.11h177.93c19 0 31.5-13.52 35.23-32.16L496 305.58V232c0-22.06-18-38-40-40z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5fc739d0da17caa6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.06 334l-144.16-6.13c-4.61-.36-23.9-1.21-23.9-25.87 0-23.81 19.16-25.33 24.14-25.88L472.06 270c12.67.13 23.94 14.43 23.94 32s-11.27 31.87-23.94 32zM330.61 202.33L437.35 194C450 194 464 210.68 464 227.88v.33c0 16.32-11.14 29.62-24.88 29.79l-108.45-1.73C304 253 304 236.83 304 229.88c0-22.88 21.8-27.15 26.61-27.55zM421.85 480l-89.37-8.93C308 470.14 304 453.82 304 443.59c0-18.38 13.41-24.6 26.67-24.6l91-3c14.54.23 26.32 14.5 26.32 32s-11.67 31.67-26.14 32.01zm34.36-71.5l-126.4-6.21c-9.39-.63-25.81-3-25.81-26.37 0-12 4.35-25.61 25-27.53l127.19-3.88c13.16.14 23.81 13.49 23.81 31.4s-10.65 32.43-23.79 32.58z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M133.55 238.06A15.85 15.85 0 01126 240a15.82 15.82 0 007.51-1.92zm40.59-69.28l.13-.23-.13.23c-20.5 35.51-30.36 54.95-33.82 62 3.47-7.07 13.34-26.51 33.82-62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M139.34 232.84l1-2a16.27 16.27 0 01-6.77 7.25 16.35 16.35 0 005.77-5.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M316.06 52.62C306.63 39.32 291 32 272 32a16 16 0 00-14.31 8.84c-3 6.07-15.25 24-28.19 42.91-18 26.33-40.35 59.07-55.23 84.8l-.13.23c-20.48 35.49-30.35 54.93-33.82 62l-1 2a16.35 16.35 0 01-5.79 5.22 15.82 15.82 0 01-7.53 2h-25.31A84.69 84.69 0 0016 324.69v38.61a84.69 84.69 0 0084.69 84.7h48.79a17.55 17.55 0 019.58 2.89C182 465.87 225.34 480 272 480c7.45 0 14.19-.14 20.27-.38a8 8 0 006.2-12.68l-.1-.14C289.8 454.41 288 441 288 432a61.2 61.2 0 015.19-24.77 17.36 17.36 0 000-14.05 63.81 63.81 0 010-50.39 17.32 17.32 0 000-14 62.15 62.15 0 010-49.59 18.13 18.13 0 000-14.68A60.33 60.33 0 01288 239c0-8.2 2-21.3 8-31.19a15.63 15.63 0 001.14-13.64c-.38-1-.76-2.07-1.13-3.17a24.84 24.84 0 01-.86-11.58c3-19.34 9.67-36.29 16.74-54.16 3.08-7.78 6.27-15.82 9.22-24.26 6.14-17.57 4.3-35.2-5.05-48.38z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$40cf7bd69d90c758(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M120 352l-24 48m40 32l-16 32m280-112l-24 48m40 32l-16 32M208 304l-16 96h48v80l80-112h-48l16-64m116.33-151.11H392.2C384.71 84.85 326.14 32 256 32a136.39 136.39 0 00-128.63 90.67h-4.57c-49.94 0-90.8 40.8-90.8 90.66h0C32 263.2 72.86 304 122.8 304h281.53C446 304 480 270 480 228.44h0c0-41.55-34-75.55-75.67-75.55z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6dad2dd3c0065ddc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M405.84 136.9a151.25 151.25 0 00-47.6-81.9 153 153 0 00-241.81 51.86C60.5 110.16 16 156.65 16 213.33 16 272.15 63.91 320 122.8 320h72.31L176 416h48v80l112-144h-43.51l8-32h103.84a91.56 91.56 0 001.51-183.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M74.53 407.177l38.32-76.622 28.62 14.313-38.32 76.623zm23.99 64.012l30.318-60.622 28.62 14.313-30.317 60.622zm256.021-64l38.32-76.623 28.62 14.314-38.32 76.622zm24.001 64.011l30.317-60.622 28.62 14.314-30.317 60.621z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$94f047f18cad0bb5(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 416a16 16 0 01-14.3-23.16l24-48a16 16 0 0128.62 14.32l-24 48A16 16 0 0196 416zm24 64a16 16 0 01-14.3-23.16l16-32a16 16 0 0128.62 14.32l-16 32A16 16 0 01120 480zm256-64a16 16 0 01-14.3-23.16l24-48a16 16 0 0128.62 14.32l-24 48A16 16 0 01376 416zm24 64a16 16 0 01-14.3-23.16l16-32a16 16 0 0128.62 14.32l-16 32A16 16 0 01400 480z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M405.84 136.9a151.25 151.25 0 00-47.6-81.9 153 153 0 00-241.81 51.86C60.5 110.16 16 156.65 16 213.33 16 272.15 63.91 320 122.8 320h66.31l-12.89 77.37A16 16 0 00192 416h32v64a16 16 0 0029 9.3l80-112a16 16 0 00-13-25.3h-27.51l8-32h103.84a91.56 91.56 0 001.51-183.1z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1eacda95663ad58a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M366.05 146a46.7 46.7 0 01-2.42-63.42 3.87 3.87 0 00-.22-5.26l-44.13-44.18a3.89 3.89 0 00-5.5 0l-70.34 70.34a23.62 23.62 0 00-5.71 9.24h0a23.66 23.66 0 01-14.95 15h0a23.7 23.7 0 00-9.25 5.71L33.14 313.78a3.89 3.89 0 000 5.5l44.13 44.13a3.87 3.87 0 005.26.22 46.69 46.69 0 0165.84 65.84 3.87 3.87 0 00.22 5.26l44.13 44.13a3.89 3.89 0 005.5 0l180.4-180.39a23.7 23.7 0 005.71-9.25h0a23.66 23.66 0 0114.95-15h0a23.62 23.62 0 009.24-5.71l70.34-70.34a3.89 3.89 0 000-5.5l-44.13-44.13a3.87 3.87 0 00-5.26-.22 46.7 46.7 0 01-63.42-2.32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M250.5 140.44l-16.51-16.51m60.53 60.53l-11.01-11m55.03 55.03l-11-11.01m60.53 60.53l-16.51-16.51"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$35b2488f40e353d3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M426.24 127.72l-10.94 10.94a29.67 29.67 0 01-42-42l10.94-10.94L314.52 16l-88 88-4 12.09-12.09 4L16 314.52l69.76 69.76 10.94-10.94a29.67 29.67 0 0142 42l-10.94 10.94L197.48 496l194.4-194.4 4-12.09 12.09-4 88-88zm-208.56 5.43l21.87-21.87 33 33-21.88 21.87zm43 43l21.88-21.88 32.52 32.52-21.88 21.88zm42.56 42.56l21.88-21.88 32.52 32.52-21.84 21.93zm75.57 75.56l-33-33 21.87-21.88 33 33z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1ad383e7969d8f39(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490.18 181.4l-44.13-44.13a20 20 0 00-27-1 30.81 30.81 0 01-41.68-1.6 30.81 30.81 0 01-1.6-41.67 20 20 0 00-1-27L330.6 21.82a19.91 19.91 0 00-28.13 0l-70.35 70.34a39.87 39.87 0 00-9.57 15.5 7.71 7.71 0 01-4.83 4.83 39.78 39.78 0 00-15.5 9.58l-180.4 180.4a19.91 19.91 0 000 28.13L66 374.73a20 20 0 0027 1 30.69 30.69 0 0143.28 43.28 20 20 0 001 27l44.13 44.13a19.91 19.91 0 0028.13 0l180.4-180.4a39.82 39.82 0 009.58-15.49 7.69 7.69 0 014.84-4.84 39.84 39.84 0 0015.49-9.57l70.34-70.35a19.91 19.91 0 00-.01-28.09zm-228.37-29.65a16 16 0 01-22.63 0l-11.51-11.51a16 16 0 0122.63-22.62l11.51 11.5a16 16 0 010 22.63zm44 44a16 16 0 01-22.62 0l-11-11a16 16 0 1122.63-22.63l11 11a16 16 0 01.01 22.66zm44 44a16 16 0 01-22.63 0l-11-11a16 16 0 0122.63-22.62l11 11a16 16 0 01.05 22.67zm44.43 44.54a16 16 0 01-22.63 0l-11.44-11.5a16 16 0 1122.68-22.57l11.45 11.49a16 16 0 01-.01 22.63z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1b35fab62f0f23b9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 128v144h96"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6d973128156a625c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256c0 114.69 93.32 208 208 208 114.86 0 208-93.14 208-208 0-114.69-93.31-208-208-208zm108 240H244a4 4 0 01-4-4V116a4 4 0 014-4h24a4 4 0 014 4v140h92a4 4 0 014 4v24a4 4 0 01-4 4z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e6d7c30107d8c769(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm96 240h-96a16 16 0 01-16-16V128a16 16 0 0132 0v128h80a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$baf78dcc1e52df84(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112.91 128A191.85 191.85 0 0064 254c-1.18 106.35 85.65 193.8 192 194 106.2.2 192-85.83 192-192 0-104.54-83.55-189.61-187.5-192a4.36 4.36 0 00-4.5 4.37V152"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M233.38 278.63l-79-113a8.13 8.13 0 0111.32-11.32l113 79a32.5 32.5 0 01-37.25 53.26 33.21 33.21 0 01-8.07-7.94z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$87f3fc0ebccefe10(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.12 48 48 141.12 48 256s93.12 208 208 208 208-93.12 208-208S370.88 48 256 48zm0 384c-97 0-176-78.95-176-176a174.55 174.55 0 0153.87-126.72L279 233l-19 30-125-91c-13 23-26.7 46-26.7 84 0 81.44 66.26 147.7 147.7 147.7S403.7 337.44 403.7 256c0-76.67-58.72-139.88-133.55-147v55h-28.3V79.89c4.24.07 8.94.11 14.15.11 97.05 0 176 79 176 176s-78.95 176-176 176z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$de7a7c6e55bc0503(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.12 48 48 141.12 48 256s93.12 208 208 208 208-93.12 208-208S370.88 48 256 48zm-82.33 114.34l105 71a32.5 32.5 0 01-37.25 53.26 33.21 33.21 0 01-8-8l-71-105a8.13 8.13 0 0111.32-11.32zM256 432c-97 0-176-78.95-176-176a174.55 174.55 0 0153.87-126.72 14.15 14.15 0 1119.64 20.37A146.53 146.53 0 00108.3 256c0 81.44 66.26 147.7 147.7 147.7S403.7 337.44 403.7 256c0-76.67-58.72-139.88-133.55-147v55a14.15 14.15 0 11-28.3 0V94.15A14.15 14.15 0 01256 80c97.05 0 176 79 176 176s-78.95 176-176 176z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1f1579629c14f741(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "384",
                    "x": "48",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 48v32m256-32v32"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "112",
                    "y": "224",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "13"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M464 160H48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$392ab5aeb23c5661(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 456a24 24 0 0024 24h400a24 24 0 0024-24V176H32zm80-238.86a9.14 9.14 0 019.14-9.14h109.72a9.14 9.14 0 019.14 9.14v109.72a9.14 9.14 0 01-9.14 9.14H121.14a9.14 9.14 0 01-9.14-9.14zM456 64h-55.92V32h-48v32H159.92V32h-48v32H56a23.8 23.8 0 00-24 23.77V144h448V87.77A23.8 23.8 0 00456 64z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ed537c594de920ac(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4v-12a64 64 0 00-64-64zm61 112H35a3 3 0 00-3 3v237a64 64 0 0064 64h320a64 64 0 0064-64V179a3 3 0 00-3-3zM224 307.43A28.57 28.57 0 01195.43 336h-70.86A28.57 28.57 0 0196 307.43v-70.86A28.57 28.57 0 01124.57 208h70.86A28.57 28.57 0 01224 236.57z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$993e5fe17105dcfc(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "368",
                    "cy": "256",
                    "r": "128",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "480",
                    "height": "256",
                    "x": "16",
                    "y": "128",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "128",
                    "ry": "128"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$dc8bacbb0df38522(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 112H144a144 144 0 000 288h224a144 144 0 000-288zm0 230a86 86 0 1186-86 85.88 85.88 0 01-86 86z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b0fb9c373c245177(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 112H144C64.6 112 0 176.6 0 256s64.6 144 144 144h224c79.4 0 144-64.6 144-144s-64.6-144-144-144zm0 256a112 112 0 11112-112 112.12 112.12 0 01-112 112z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9bb20664bb627b87(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 400v64m0-256v64m0-224v32m160 128H102.63a16 16 0 01-11.32-4.69L32 144l59.31-59.31A16 16 0 01102.63 80H416a16 16 0 0116 16v96a16 16 0 01-16 16zM96 400h313.37a16 16 0 0011.32-4.69L480 336l-59.31-59.31a16 16 0 00-11.32-4.69H96a16 16 0 00-16 16v96a16 16 0 0016 16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$388fd11129042eb6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 336l-80-80H278v-32h170V64H278V32h-44v32H89.37l-80 80 80 80H234v32H64v160h170v64h44v-64h144.63z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1f272a434dc13c0a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M491.31 324.69L432 265.37a31.8 31.8 0 00-22.63-9.37H272v-32h144a32 32 0 0032-32V96a32 32 0 00-32-32H272V48a16 16 0 00-32 0v16H102.63A31.8 31.8 0 0080 73.37l-59.31 59.32a16 16 0 000 22.62L80 214.63a31.8 31.8 0 0022.63 9.37H240v32H96a32 32 0 00-32 32v96a32 32 0 0032 32h144v48a16 16 0 0032 0v-48h137.37a31.8 31.8 0 0022.63-9.37l59.31-59.32a16 16 0 000-22.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6065d41c3f619b77(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M344 48h-24a16 16 0 00-16-16h-96a16 16 0 00-16 16h-24a56.16 56.16 0 00-56 56v247c0 35.3 144 65 144 65s144-29.7 144-65V104a56 56 0 00-56-56zm-88 304a48 48 0 1148-48 48 48 0 01-48 48zm96-160a16 16 0 01-16 16H176a16 16 0 01-16-16v-64a16 16 0 0116-16h160a16 16 0 0116 16zM144 464h224m-32-32l48 48m-208-48l-48 48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$74c7c376c95aefbf(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32h-64a16 16 0 00-16-16h-96a16 16 0 00-16 16h-64c-16 0-32 16-32 32v288c0 23.92 160 80 160 80s160-56.74 160-80V64c0-16-16-32-32-32zM256 352a48 48 0 1148-48 48 48 0 01-48 48zm112-152a8 8 0 01-8 8H152a8 8 0 01-8-8v-80a8 8 0 018-8h208a8 8 0 018 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M314 432l15.32 16H182.58L198 432l-32-13-76.62 77h45.2l16-16h210.74l16 16h45.3l-76.36-77.75L314 432z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ef8ad137ca68d959(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256",
                    "cy": "304",
                    "rx": "32.05",
                    "ry": "31.94",
                    "transform": "rotate(-45 256.001 304)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M352 32h-15a10 10 0 01-7.87-3.78A31.94 31.94 0 00304 16h-96a32 32 0 00-26.11 13.52A6 6 0 01177 32h-17c-36.81 0-64 28.84-64 64v255c0 23.27 25.6 42.06 83 60.94a753 753 0 0073.77 19.73 16 16 0 006.46 0A753 753 0 00333 411.94c57.4-18.88 83-37.67 83-60.94V96a64 64 0 00-64-64zm-168 96h144a8 8 0 018 8v48a8 8 0 01-8 8H184a8 8 0 01-8-8v-48a8 8 0 018-8zm76.18 239.87a64 64 0 1159.69-59.69 64.07 64.07 0 01-59.69 59.69z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M395.31 468.69L347.63 421c-6.09-6.1-16-6.66-22.38-.86a16 16 0 00-.56 23.16l4.68 4.69H182.63l4.36-4.37c6.1-6.09 6.66-16 .86-22.38a16 16 0 00-23.16-.56l-48 48a16 16 0 1022.62 22.62l11.32-11.3h210.74l11.32 11.31a16 16 0 0022.62-22.62z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1e587e0b3d79c637(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "128",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 352l-96 96M176 80l-95.98 95.98M464 128V48h-80M48 128V48h80m336 0L346.5 165.5M48 48l117.49 117.49M464 464L346.65 346.37"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1f86b0d20bd005ee(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 448.94l-48.94-49.08L464 366.92l-31.1-31.11-32.9 32.9-23.55-23.61a149.64 149.64 0 00-.1-178.45l59.55-59.56V144h44V32h-112v44h36.87l-59.55 59.55a149.65 149.65 0 00-178.59 0l-7.55-7.55 33-33L161 63.88l-33 33L107.09 76H144V32H32v112h44v-36.91L96.87 128l-33 33L95 192.05l33-33 7.56 7.57A149.18 149.18 0 00106 255.94c0 82.69 67.27 150 150 150a149.12 149.12 0 0089.44-29.67l23.51 23.58-33.14 33.05 31.11 31.1 33-33 48.9 49zm-330-193a106 106 0 11106 106 106.09 106.09 0 01-106-106z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d95905f4dad5ad6e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M458 32h-68a22 22 0 000 44h14.89l-59.57 59.57a149.69 149.69 0 00-178.64 0l-7.57-7.57 26.45-26.44a22 22 0 00-31.12-31.12L128 96.89 107.11 76H122a22 22 0 000-44H54a22 22 0 00-22 22v68a22 22 0 0044 0v-14.89L96.89 128l-26.42 26.42a22 22 0 1031.11 31.11L128 159.11l7.57 7.57A149.19 149.19 0 00106 256c0 82.71 67.29 150 150 150a149.2 149.2 0 0089.46-29.67L369 399.9l-26.54 26.54a22 22 0 0031.12 31.12l26.49-26.5 42.37 42.48a22 22 0 0031.16-31.08L431.17 400l26.39-26.39a22 22 0 00-31.12-31.12l-26.35 26.35-23.55-23.62a149.68 149.68 0 00-.11-178.49L436 107.11V122a22 22 0 0044 0V54a22 22 0 00-22-22zM150 256a106 106 0 11106 106 106.12 106.12 0 01-106-106z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d42f8aeb84dc62e9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432 144l-28.67 275.74A32 32 0 01371.55 448H140.46a32 32 0 01-31.78-28.26L80 144"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "80",
                    "x": "32",
                    "y": "64",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M312 240L200 352m112 0L200 240"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$adfc245d6e6ff4ff(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M337.46 240L312 214.54l-56 56-56-56L174.54 240l56 56-56 56L200 377.46l56-56 56 56L337.46 352l-56-56 56-56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M337.46 240L312 214.54l-56 56-56-56L174.54 240l56 56-56 56L200 377.46l56-56 56 56L337.46 352l-56-56 56-56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M64 160l29.74 282.51A24 24 0 00117.61 464h276.78a24 24 0 0023.87-21.49L448 160zm248 217.46l-56-56-56 56L174.54 352l56-56-56-56L200 214.54l56 56 56-56L337.46 240l-56 56 56 56z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "80",
                    "x": "32",
                    "y": "48",
                    "rx": "12",
                    "ry": "12"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$795cb43949047fb6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "80",
                    "x": "32",
                    "y": "48",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M74.45 160a8 8 0 00-8 8.83l26.31 252.56a1.5 1.5 0 000 .22A48 48 0 00140.45 464h231.09a48 48 0 0047.67-42.39v-.21l26.27-252.57a8 8 0 00-8-8.83zm248.86 180.69a16 16 0 11-22.63 22.62L256 318.63l-44.69 44.68a16 16 0 01-22.63-22.62L233.37 296l-44.69-44.69a16 16 0 0122.63-22.62L256 273.37l44.68-44.68a16 16 0 0122.63 22.62L278.62 296z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$23a6435b24c3ff33(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 112l20 320c.95 18.49 14.4 32 32 32h184c17.67 0 30.87-13.51 32-32l20-320"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M80 112h352"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M192 112V72h0a23.93 23.93 0 0124-24h80a23.93 23.93 0 0124 24h0v40m-64 64v224m-72-224l8 224m136-224l-8 224"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8b3050637637d13f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M296 64h-80a7.91 7.91 0 00-8 8v24h96V72a7.91 7.91 0 00-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M292 64h-72a4 4 0 00-4 4v28h80V68a4 4 0 00-4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M447.55 96H336V48a16 16 0 00-16-16H192a16 16 0 00-16 16v48H64.45L64 136h33l20.09 314A32 32 0 00149 480h214a32 32 0 0031.93-29.95L415 136h33zM176 416l-9-256h33l9 256zm96 0h-32V160h32zm24-320h-80V68a4 4 0 014-4h72a4 4 0 014 4zm40 320h-33l9-256h33z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a8c92394a9ef3c7e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M296 64h-80a7.91 7.91 0 00-8 8v24h96V72a7.91 7.91 0 00-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96h-96V72a40 40 0 00-40-40h-80a40 40 0 00-40 40v24H80a16 16 0 000 32h17l19 304.92c1.42 26.85 22 47.08 48 47.08h184c26.13 0 46.3-19.78 48-47l19-305h17a16 16 0 000-32zM192.57 416H192a16 16 0 01-16-15.43l-8-224a16 16 0 1132-1.14l8 224A16 16 0 01192.57 416zM272 400a16 16 0 01-32 0V176a16 16 0 0132 0zm32-304h-96V72a7.91 7.91 0 018-8h80a7.91 7.91 0 018 8zm32 304.57A16 16 0 01320 416h-.58A16 16 0 01304 399.43l8-224a16 16 0 1132 1.14z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$363e94a9762f8c5a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 368h112V256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 144l121.37 121.37a32 32 0 0045.26 0l50.74-50.74a32 32 0 0145.26 0L448 352"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9df2592f36ae31e0(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M352 368h112V256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M48 144l144 144 96-96 160 160"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$69e6b1b869727cd3(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 368h112V256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 144l121.37 121.37a32 32 0 0045.26 0l50.74-50.74a32 32 0 0145.26 0L448 352"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a0959efdb8893cdd(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 144h112v112"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 368l121.37-121.37a32 32 0 0145.26 0l50.74 50.74a32 32 0 0045.26 0L448 160"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c0a701fe49a610d1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M352 144h112v112"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M48 368l144-144 96 96 160-160"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$83bd4693895269da(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 144h112v112"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 368l121.37-121.37a32 32 0 0145.26 0l50.74 50.74a32 32 0 0045.26 0L448 160"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d1b56bd962c1893e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 448L256 64l208 384H48z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7bf63e4a763d2330(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32L20 464h472L256 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7eeb4b769336b581(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 464H48a16 16 0 01-14.07-23.62l208-384a16 16 0 0128.14 0l208 384A16 16 0 01464 464z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$922c2228cfa46333(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 464h160m-80 0V336m128-112c0-50.64-.08-134.63-.12-160a16 16 0 00-16-16l-223.79.26a16 16 0 00-16 15.95c0 30.58-.13 129.17-.13 159.79 0 64.28 83 112 128 112S384 288.28 384 224z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 96H48v16c0 55.22 33.55 112 80 112M384 96h80v16c0 55.22-33.55 112-80 112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$859bf709cf79aa78(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399.9 80V32H112v48H32v38c0 32 9.5 62.79 26.76 86.61 13.33 18.4 34.17 31.1 52.91 37.21 5.44 29.29 20.2 57.13 50.19 79.83 22 16.66 48.45 28.87 72.14 33.86V436h-74v44h192v-44h-74v-80.49c23.69-5 50.13-17.2 72.14-33.86 30-22.7 44.75-50.54 50.19-79.83 18.74-6.11 39.58-18.81 52.91-37.21C470.5 180.79 480 150 480 118V80zM94.4 178.8c-10.68-14.68-17.17-34.4-18.24-54.8H112v67.37c-3.94-1.14-12.92-6.12-17.6-12.57zm323.2 0c-4.6 6.61-11.6 12.58-17.6 12.58 0-22.4 0-46.29-.05-67.38h35.9c-1.08 20.4-7.85 39.9-18.25 54.8z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$666cba337b26615(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 80h-60.1a4 4 0 01-4-4V63.92a32 32 0 00-32-31.92l-223.79.26a32 32 0 00-31.94 31.93V76a4 4 0 01-4 4H48a16 16 0 00-16 16v16c0 54.53 30 112.45 76.52 125.35a7.82 7.82 0 015.55 5.9c5.77 26.89 23.52 52.5 51.41 73.61 20.91 15.83 45.85 27.5 68.27 32.48a8 8 0 016.25 7.8V444a4 4 0 01-4 4h-59.55c-8.61 0-16 6.62-16.43 15.23A16 16 0 00176 480h159.55c8.61 0 16-6.62 16.43-15.23A16 16 0 00336 448h-60a4 4 0 01-4-4v-86.86a8 8 0 016.25-7.8c22.42-5 47.36-16.65 68.27-32.48 27.89-21.11 45.64-46.72 51.41-73.61a7.82 7.82 0 015.55-5.9C450 224.45 480 166.53 480 112V96a16 16 0 00-16-16zM112 198.22a4 4 0 01-6 3.45c-10.26-6.11-17.75-15.37-22.14-21.89-11.91-17.69-19-40.67-19.79-63.63a4 4 0 014-4.15h40a4 4 0 014 4c-.02 27.45-.07 58.87-.07 82.22zm316.13-18.44c-4.39 6.52-11.87 15.78-22.13 21.89a4 4 0 01-6-3.46c0-26.51 0-56.63-.05-82.21a4 4 0 014-4h40a4 4 0 014 4.15c-.79 22.96-7.9 45.94-19.81 63.63z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7d123325c9ed208b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "272",
                    "x": "32",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32.14",
                    "ry": "32.14"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M128 416h256"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$78e9bdfe56f3aa47(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 384H24a8 8 0 01-8-8V88a8 8 0 018-8h464a8 8 0 018 8v288a8 8 0 01-8 8z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "288",
                    "height": "32",
                    "x": "112",
                    "y": "400",
                    "rx": "4",
                    "ry": "4"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8d5cca64c13ed9a6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.86 384H64.14A48.2 48.2 0 0116 335.86V128.14A48.2 48.2 0 0164.14 80h383.72A48.2 48.2 0 01496 128.14v207.72A48.2 48.2 0 01447.86 384z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M128 416h256"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ec1c3dd823d5ae79(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 272v160a32 32 0 01-32 32h0a32 32 0 01-32-32m272-160c0-114.88-93.12-208-208-208S48 157.12 48 272h0a67.88 67.88 0 0196 0h0a78.28 78.28 0 01102.31-7.27L256 272l9.69-7.27A78.28 78.28 0 01368 272h0a67.88 67.88 0 0196 0zM256 64V48"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$2e5e922fbd4d2176(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.93 280l-.26-.3c-.9-.74-1.83-1.43-2.77-2.1zm254.15 0l2.62-2.12c-.79.58-1.57 1.17-2.34 1.79z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M463.14 186.44A224.55 224.55 0 00272 48.57V32h-32v16.57A223.58 223.58 0 0032 272v22.52l12.25-11.21a62.63 62.63 0 0181.43-5.88l.22.17c.94.67 1.87 1.36 2.77 2.1q2.09 1.69 4 3.61L144 294.63l11.31-11.32a62.59 62.59 0 0181.4-5.78L240 280v152a16 16 0 01-32 0v-16h-32v16a48 48 0 0096 0V280l3.29-2.47a62.59 62.59 0 0181.4 5.78L368 294.63l11.31-11.32q1.95-1.94 4.05-3.64c.77-.62 1.55-1.21 2.34-1.79l.26-.21c24.63-18.47 60-16.13 81.81 5.64l12.23 11.2V272a223.62 223.62 0 00-16.86-85.56z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9c2a898f48b13be1(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 113.61a222.26 222.26 0 00-136.33-64.54 8.09 8.09 0 01-6.88-5.62 15.79 15.79 0 00-30.36 0 8.09 8.09 0 01-6.88 5.62A224 224 0 0032 271.52a16.41 16.41 0 007.24 13.87 16 16 0 0020.07-2.08 51.89 51.89 0 0173.31-.06 15.94 15.94 0 0022.6.15 62.59 62.59 0 0181.49-5.87 8.24 8.24 0 013.29 6.59v147.42c0 8.6-6.6 16-15.19 16.44A16 16 0 01208 432a16 16 0 00-16.29-16c-9 .16-15.9 8.11-15.7 17.1a48.06 48.06 0 0047.37 46.9c26.88.34 48.62-21.93 48.62-48.81V284.12a8.24 8.24 0 013.29-6.59 62.59 62.59 0 0181.4 5.78 16 16 0 0022.62 0 51.91 51.91 0 0173.38 0 16 16 0 0019.54 2.41 16.4 16.4 0 007.77-14.21 222.54 222.54 0 00-65.61-157.9z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d0f008f97985a43a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "36",
                    "d": "M208 352h-64a96 96 0 010-192h64m96 0h64a96 96 0 010 192h-64"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$28006107a4c9aa81(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M200.66 352H144a96 96 0 010-192h55.41m113.18 0H368a96 96 0 010 192h-56.66"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$eaf41f6bd240ed3f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M200.66 352H144a96 96 0 010-192h55.41m113.18 0H368a96 96 0 010 192h-56.66"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$219fdf373a07aa87(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M374.79 308.78L457.5 367a16 16 0 0022.5-14.62V159.62A16 16 0 00457.5 145l-82.71 58.22A16 16 0 00368 216.3v79.4a16 16 0 006.79 13.08z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M50.19 140.57A51.94 51.94 0 0032 180v152a52.15 52.15 0 0052 52h184a51.6 51.6 0 0022-4.9M208 128h60.48A51.68 51.68 0 01320 179.52V248m96 168L80 80"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3a87a7f7882f14a9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M57.376 79.998l22.627-22.627 358.63 358.63-22.627 22.628zM32 112a16 16 0 00-16 16v256a16 16 0 0016 16h288a15.89 15.89 0 009.34-3l-285-285zm304 96v-80a16 16 0 00-16-16H179.63l245.44 245.44L496 400V112z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$565901f489396381(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 179.52A67.52 67.52 0 00268.48 112h-79.2a4 4 0 00-2.82 6.83l142.71 142.71a4 4 0 006.83-2.82zM16 180v152a68 68 0 0068 68h184a67.66 67.66 0 0042.84-15.24 4 4 0 00.33-6L54.41 122a4 4 0 00-4.87-.62A68 68 0 0016 180zm448 204.39a32 32 0 01-13-2.77 15.77 15.77 0 01-2.71-1.54l-82.71-58.22A32 32 0 01352 295.7v-79.4a32 32 0 0113.58-26.16l82.71-58.22a15.77 15.77 0 012.71-1.54 32 32 0 0145 29.24v192.76a32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M416 416L80 80"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$5e9e6f2aba766d1e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M374.79 308.78L457.5 367a16 16 0 0022.5-14.62V159.62A16 16 0 00457.5 145l-82.71 58.22A16 16 0 00368 216.3v79.4a16 16 0 006.79 13.08z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M268 384H84a52.15 52.15 0 01-52-52V180a52.15 52.15 0 0152-52h184.48A51.68 51.68 0 01320 179.52V332a52.15 52.15 0 01-52 52z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$4a593ebd7952e919(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 208v-80a16 16 0 00-16-16H32a16 16 0 00-16 16v256a16 16 0 0016 16h288a16 16 0 0016-16v-80l160 96V112z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$58875fdd6485342b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 384.39a32 32 0 01-13-2.77 15.77 15.77 0 01-2.71-1.54l-82.71-58.22A32 32 0 01352 295.7v-79.4a32 32 0 0113.58-26.16l82.71-58.22a15.77 15.77 0 012.71-1.54 32 32 0 0145 29.24v192.76a32 32 0 01-32 32zM268 400H84a68.07 68.07 0 01-68-68V180a68.07 68.07 0 0168-68h184.48A67.6 67.6 0 01336 179.52V332a68.07 68.07 0 01-68 68z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a86abbe6fd48006f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M126 192H56a8 8 0 00-8 8v112a8 8 0 008 8h69.65a15.93 15.93 0 0110.14 3.54l91.47 74.89A8 8 0 00240 392V120a8 8 0 00-12.74-6.43l-91.47 74.89A15 15 0 01126 192zm194 128c9.74-19.38 16-40.84 16-64 0-23.48-6-44.42-16-64m48 176c19.48-33.92 32-64.06 32-112s-12-77.74-32-112m48 272c30-46 48-91.43 48-160s-18-113-48-160"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c38e9a6d5adaec7b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M320 320c9.74-19.38 16-40.84 16-64 0-23.48-6-44.42-16-64m48 176c19.48-33.92 32-64.06 32-112s-12-77.74-32-112m48 272c30-46 48-91.43 48-160s-18-113-48-160"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M125.65 176.1H32v159.8h93.65L256 440V72L125.65 176.1z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$9d32f9bfe527c793(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 416a23.88 23.88 0 01-14.2-4.68 8.27 8.27 0 01-.66-.51L125.76 336H56a24 24 0 01-24-24V200a24 24 0 0124-24h69.75l91.37-74.81a8.27 8.27 0 01.66-.51A24 24 0 01256 120v272a24 24 0 01-24 24zm-106.18-80zm-.27-159.86zM320 336a16 16 0 01-14.29-23.19c9.49-18.87 14.3-38 14.3-56.81 0-19.38-4.66-37.94-14.25-56.73a16 16 0 0128.5-14.54C346.19 208.12 352 231.44 352 256c0 23.86-6 47.81-17.7 71.19A16 16 0 01320 336z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M368 384a16 16 0 01-13.86-24C373.05 327.09 384 299.51 384 256c0-44.17-10.93-71.56-29.82-103.94a16 16 0 0127.64-16.12C402.92 172.11 416 204.81 416 256c0 50.43-13.06 83.29-34.13 120a16 16 0 01-13.87 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M416 432a16 16 0 01-13.39-24.74C429.85 365.47 448 323.76 448 256c0-66.5-18.18-108.62-45.49-151.39a16 16 0 1127-17.22C459.81 134.89 480 181.74 480 256c0 64.75-14.66 113.63-50.6 168.74A16 16 0 01416 432z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8b716da9eb26c2ba(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M189.65 192H120a8 8 0 00-8 8v112a8 8 0 008 8h69.65a16 16 0 0110.14 3.63l91.47 75a8 8 0 0012.74-6.46V119.83a8 8 0 00-12.74-6.44l-91.47 75a16 16 0 01-10.14 3.61zM384 320c9.74-19.41 16-40.81 16-64 0-23.51-6-44.4-16-64"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7790935b12bf805e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391.12 341.48l-28.6-14.36 7.18-14.3c9.49-18.9 14.3-38 14.3-56.82 0-19.36-4.66-37.92-14.25-56.73L362.48 185 391 170.48l7.26 14.25C410.2 208.16 416 231.47 416 256c0 23.83-6 47.78-17.7 71.18zM189.65 176.1H96v159.8h93.65L320 440V72L189.65 176.1z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$13a3c3e4d4564df7(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 416.19a23.92 23.92 0 01-14.21-4.69l-.66-.51-91.46-75H120a24 24 0 01-24-24V200a24 24 0 0124-24h69.65l91.46-75 .66-.51A24 24 0 01320 119.83v272.34a24 24 0 01-24 24zM384 336a16 16 0 01-14.29-23.18c9.49-18.9 14.3-38 14.3-56.82 0-19.36-4.66-37.92-14.25-56.73a16 16 0 0128.5-14.54C410.2 208.16 416 231.47 416 256c0 23.83-6 47.78-17.7 71.18A16 16 0 01384 336z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$13c8e88313582dae(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M157.65 192H88a8 8 0 00-8 8v112a8 8 0 008 8h69.65a16 16 0 0110.14 3.63l91.47 75a8 8 0 0012.74-6.46V119.83a8 8 0 00-12.74-6.44l-91.47 75a16 16 0 01-10.14 3.61zM352 320c9.74-19.41 16-40.81 16-64 0-23.51-6-44.4-16-64m48 176c19.48-34 32-64 32-112s-12-77.7-32-112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7866d46cbe8bbedb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M157.65 176.1H64v159.8h93.65L288 440V72L157.65 176.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 320c9.74-19.41 16-40.81 16-64 0-23.51-6-44.4-16-64m48 176c19.48-34 32-64 32-112s-12-77.7-32-112"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$15077f4342f64ca6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264 416.19a23.92 23.92 0 01-14.21-4.69l-.66-.51-91.46-75H88a24 24 0 01-24-24V200a24 24 0 0124-24h69.65l91.46-75 .66-.51A24 24 0 01288 119.83v272.34a24 24 0 01-24 24zM352 336a16 16 0 01-14.29-23.18c9.49-18.9 14.3-38 14.3-56.82 0-19.36-4.66-37.92-14.25-56.73a16 16 0 0128.5-14.54C378.2 208.16 384 231.47 384 256c0 23.83-6 47.78-17.7 71.18A16 16 0 01352 336z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M400 384a16 16 0 01-13.87-24C405 327.05 416 299.45 416 256c0-44.12-10.94-71.52-29.83-103.95A16 16 0 01413.83 136C434.92 172.16 448 204.88 448 256c0 50.36-13.06 83.24-34.12 120a16 16 0 01-13.88 8z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$44fdc12effb276b6(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M416 432L64 80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136.92v33.8a4 4 0 001.17 2.82l24 24a4 4 0 006.83-2.82v-74.15a24.53 24.53 0 00-12.67-21.72 23.91 23.91 0 00-25.55 1.83 8.27 8.27 0 00-.66.51l-31.94 26.15a4 4 0 00-.29 5.92l17.05 17.06a4 4 0 005.37.26zm0 238.16l-78.07-63.92a32 32 0 00-20.28-7.16H64v-96h50.72a4 4 0 002.82-6.83l-24-24a4 4 0 00-2.82-1.17H56a24 24 0 00-24 24v112a24 24 0 0024 24h69.76l91.36 74.8a8.27 8.27 0 00.66.51 23.93 23.93 0 0025.85 1.69A24.49 24.49 0 00256 391.45v-50.17a4 4 0 00-1.17-2.82l-24-24a4 4 0 00-6.83 2.82zM125.82 336zM352 256c0-24.56-5.81-47.88-17.75-71.27a16 16 0 00-28.5 14.54C315.34 218.06 320 236.62 320 256q0 4-.31 8.13a8 8 0 002.32 6.25l19.66 19.67a4 4 0 006.75-2A146.89 146.89 0 00352 256zm64 0c0-51.19-13.08-83.89-34.18-120.06a16 16 0 00-27.64 16.12C373.07 184.44 384 211.83 384 256c0 23.83-3.29 42.88-9.37 60.65a8 8 0 001.9 8.26l16.77 16.76a4 4 0 006.52-1.27C410.09 315.88 416 289.91 416 256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 256c0-74.26-20.19-121.11-50.51-168.61a16 16 0 10-27 17.22C429.82 147.38 448 189.5 448 256c0 47.45-8.9 82.12-23.59 113a4 4 0 00.77 4.55L443 391.39a4 4 0 006.4-1C470.88 348.22 480 307 480 256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$c57b28d9c26c3229(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M416 432L64 80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M352 256c0-24.56-5.81-47.88-17.75-71.27L327 170.47 298.48 185l7.27 14.25C315.34 218.06 320 236.62 320 256a112.91 112.91 0 01-.63 11.74l27.32 27.32A148.8 148.8 0 00352 256zm64 0c0-51.19-13.08-83.89-34.18-120.06l-8.06-13.82-27.64 16.12 8.06 13.82C373.07 184.44 384 211.83 384 256c0 25.93-3.89 46.21-11 65.33l24.5 24.51C409.19 319.68 416 292.42 416 256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 256c0-74.26-20.19-121.11-50.51-168.61l-8.61-13.49-27 17.22 8.61 13.49C429.82 147.38 448 189.5 448 256c0 48.76-9.4 84-24.82 115.55l23.7 23.7C470.16 351.39 480 309 480 256zM256 72l-73.6 58.78 73.6 73.59V72zM32 176.1v159.8h93.65L256 440V339.63L92.47 176.1H32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ae467f5620f40c63(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M416 432L64 80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M243.33 98.86a23.89 23.89 0 00-25.55 1.82l-.66.51-28.52 23.35a8 8 0 00-.59 11.85l54.33 54.33a8 8 0 0013.66-5.66v-64.49a24.51 24.51 0 00-12.67-21.71zm8 236.43L96.69 180.69A16 16 0 0085.38 176H56a24 24 0 00-24 24v112a24 24 0 0024 24h69.76l92 75.31a23.9 23.9 0 0025.87 1.69A24.51 24.51 0 00256 391.45v-44.86a16 16 0 00-4.67-11.3zM352 256c0-24.56-5.81-47.87-17.75-71.27a16 16 0 10-28.5 14.55C315.34 218.06 320 236.62 320 256q0 4-.31 8.13a8 8 0 002.32 6.25l14.36 14.36a8 8 0 0013.55-4.31A146 146 0 00352 256zm64 0c0-51.18-13.08-83.89-34.18-120.06a16 16 0 00-27.64 16.12C373.07 184.44 384 211.83 384 256c0 23.83-3.29 42.88-9.37 60.65a8 8 0 001.9 8.26L389 337.4a8 8 0 0013.13-2.79C411 311.76 416 287.26 416 256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 256c0-74.25-20.19-121.11-50.51-168.61a16 16 0 10-27 17.22C429.82 147.38 448 189.5 448 256c0 46.19-8.43 80.27-22.43 110.53a8 8 0 001.59 9l11.92 11.92a8 8 0 0012.92-2.16C471.6 344.9 480 305 480 256z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$925def62d05b2e2b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M237.65 192H168a8 8 0 00-8 8v112a8 8 0 008 8h69.65a16 16 0 0110.14 3.63l91.47 75a8 8 0 0012.74-6.46V119.83a8 8 0 00-12.74-6.44l-91.47 75a16 16 0 01-10.14 3.61z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6fa669bcf080667c(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M237.65 176.1H144v159.8h93.65L368 440V72L237.65 176.1z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f7cfc3f73466f338(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 416a23.92 23.92 0 01-14.21-4.69c-.23-.16-.44-.33-.66-.51l-91.46-74.9H168a24 24 0 01-24-24V200.07a24 24 0 0124-24h69.65l91.46-74.9c.22-.18.43-.35.66-.51A24 24 0 01368 120v272a24 24 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6e8f1eb0231a151(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M314.21 482.32l-56.77-114.74-44.89-57.39a72.82 72.82 0 01-10.13-37.05V144h15.67a40.22 40.22 0 0140.23 40.22v183.36M127.9 293.05v-74.52S165.16 144 202.42 144M370.1 274.42L304 231M170.53 478.36L224 400"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "258.32",
                    "cy": "69.48",
                    "r": "37.26",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6b67b78ffdcca40d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M315.09 481.38l-56.95-115.12-45-57.56a73.11 73.11 0 01-10.16-37.17V142h15.73A40.36 40.36 0 01259 182.32v162.52"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128.18 291.5v-74.77l64.95-65.1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M376.35 295.73l-83.95-56.38v-44.68l104.68 72.95-20.73 28.11zM175.13 498.58l-21.43-26.91 80.33-81.54 15.53 32.07-74.43 76.38z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "259.02",
                    "cy": "67.21",
                    "r": "37.38",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "16"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$a70a615519e11ad2(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M312.55 479.9l-56.42-114-44.62-57a72.37 72.37 0 01-10.06-36.9V143.64H217a40 40 0 0140 40v182.21"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M127.38 291.78v-74.07s37-74.07 74.07-74.07"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M368.09 291.78a18.49 18.49 0 01-10.26-3.11L297.7 250a21.18 21.18 0 01-9.7-17.79v-23.7a5.65 5.65 0 018.69-4.77l81.65 54.11a18.52 18.52 0 01-10.29 33.93zM171.91 493.47a18.5 18.5 0 01-14.83-7.41c-6.14-8.18-4-17.18 3.7-25.92l59.95-74.66a7.41 7.41 0 0110.76 2.06c1.56 2.54 3.38 5.65 5.19 9.09 5.24 9.95 6 16.11-1.68 25.7-8 10-52 67.44-52 67.44-2.62 2.98-7.23 3.7-11.09 3.7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "257",
                    "cy": "69.56",
                    "r": "37.04",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "16"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$1fbac520a74d7c07(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "288",
                    "x": "48",
                    "y": "144",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M411.36 144v-30A50 50 0 00352 64.9L88.64 109.85A50 50 0 0048 159v49"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M368 320a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ef02faad66ca5df9(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.5 104H432V51.52a16 16 0 00-19.14-15.69l-368 60.48a16 16 0 00-12 10.47A39.69 39.69 0 0147.5 104zm416 24h-416a16 16 0 00-16 16v288a16 16 0 0016 16h416a16 16 0 0016-16V144a16 16 0 00-16-16zM368 320a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M31.33 259.5V116c0-12.33 5.72-18.48 15.42-20 35.2-5.53 108.58-8.5 108.58-8.5s-8.33 16-27.33 16V128c18.5 0 31.33 23.5 31.33 23.5L84.83 236z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3c167ed6cb5af10f(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M95.5 104h320a87.73 87.73 0 0111.18.71 66 66 0 00-77.51-55.56L86 94.08h-.3a66 66 0 00-41.07 26.13A87.57 87.57 0 0195.5 104zm320 24h-320a64.07 64.07 0 00-64 64v192a64.07 64.07 0 0064 64h320a64.07 64.07 0 0064-64V192a64.07 64.07 0 00-64-64zM368 320a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M32 259.5V160c0-21.67 12-58 53.65-65.87C121 87.5 156 87.5 156 87.5s23 16 4 16-18.5 24.5 0 24.5 0 23.5 0 23.5L85.5 236z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$f26c4d4d09e5c765(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M85.57 446.25h340.86a32 32 0 0028.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0028.17 47.17z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M250.26 195.39l5.74 122 5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 5.95z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 397.25a20 20 0 1120-20 20 20 0 01-20 20z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6dff150d938c3442(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479 447.77L268.43 56.64a8 8 0 00-14.09 0L43.73 447.77a8 8 0 007.05 11.79H472a8 8 0 007-11.79zm-197.62-36.29h-40v-40h40zm-4-63.92h-32l-6-160h44z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6bdd06168388957e(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M449.07 399.08L278.64 82.58c-12.08-22.44-44.26-22.44-56.35 0L51.87 399.08A32 32 0 0080 446.25h340.89a32 32 0 0028.18-47.17zm-198.6-1.83a20 20 0 1120-20 20 20 0 01-20 20zm21.72-201.15l-5.74 122a16 16 0 01-32 0l-5.74-121.95a21.73 21.73 0 0121.5-22.69h.21a21.74 21.74 0 0121.73 22.7z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$430d329f687548eb(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "288",
                    "height": "288",
                    "x": "112",
                    "y": "112",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "64",
                    "ry": "64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 112V40a8 8 0 018-8h144a8 8 0 018 8v72m0 288v72a8 8 0 01-8 8H184a8 8 0 01-8-8v-72"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$e3bc16ebced24f12(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "240",
                    "height": "240",
                    "x": "136",
                    "y": "136",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M384 96h-48V16H176v80h-48a32 32 0 00-32 32v256a32 32 0 0032 32h48v80h160v-80h48a32 32 0 0032-32V128a32 32 0 00-32-32zm8 272a24 24 0 01-24 24H144a24 24 0 01-24-24V144a24 24 0 0124-24h224a24 24 0 0124 24z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$ca3d042cdf81653a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "240",
                    "height": "240",
                    "x": "136",
                    "y": "136",
                    "rx": "56",
                    "ry": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 96V32a16 16 0 00-16-16H192a16 16 0 00-16 16v64a80.09 80.09 0 00-80 80v160a80.09 80.09 0 0080 80v64a16 16 0 0016 16h128a16 16 0 0016-16v-64a80.09 80.09 0 0080-80V176a80.09 80.09 0 00-80-80zm56 224a72.08 72.08 0 01-72 72H192a72.08 72.08 0 01-72-72V192a72.08 72.08 0 0172-72h128a72.08 72.08 0 0172 72z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$16376a865ef32916(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 320c0 88.37-55.63 144-144 144s-144-55.63-144-144c0-94.83 103.23-222.85 134.89-259.88a12 12 0 0118.23 0C296.77 97.15 400 225.17 400 320z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M344 328a72 72 0 01-72 72"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$360c35a08bc4fd43(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 43.91s-144 158.3-144 270.3c0 88.36 55.64 144 144 144s144-55.64 144-144c0-112-144-270.3-144-270.3zm16 362.3v-24a60.07 60.07 0 0060-60h24a84.09 84.09 0 01-84 84z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$d8f1445c103cd853(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M265.12 60.12a12 12 0 00-18.23 0C215.23 97.15 112 225.17 112 320c0 88.37 55.64 144 144 144s144-55.63 144-144c0-94.83-103.23-222.85-134.88-259.88zM272 412a12 12 0 01-11.34-16 11.89 11.89 0 0111.41-8A60.06 60.06 0 00332 328.07a11.89 11.89 0 018-11.41A12 12 0 01356 328a84.09 84.09 0 01-84 84z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$975dce111aaf2014(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M332.41 310.59a115 115 0 00-152.8 0m213.85-61.05a201.26 201.26 0 00-274.92 0m329.18-67.43a288 288 0 00-383.44 0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 416a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$3cc03cbd1a25c24a(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "42",
                    "d": "M332.69 320a115 115 0 00-152.8 0m213.85-61a201.26 201.26 0 00-274.92 0M448 191.52a288 288 0 00-383.44 0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M300.67 384L256 433l-44.34-49a56.73 56.73 0 0188.92 0z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6eb54110be18944d(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M346.65 304.3a136 136 0 00-180.71 0 21 21 0 1027.91 31.38 94 94 0 01124.89 0 21 21 0 0027.91-31.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256.28 183.7a221.47 221.47 0 00-151.8 59.92 21 21 0 1028.68 30.67 180.28 180.28 0 01246.24 0 21 21 0 1028.68-30.67 221.47 221.47 0 00-151.8-59.92z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M462 175.86a309 309 0 00-411.44 0 21 21 0 1028 31.29 267 267 0 01355.43 0 21 21 0 0028-31.31z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256.28",
                    "cy": "393.41",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$bdda4b4b431ac800(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M398.57 80H113.43v16S87.51 272 256 272 398.57 96 398.57 96zM256 272v160"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 432H160"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 160h288"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$6c39c5d423799027(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M453 112V66.33H60.75V112l175.13 176v118H124.75v42H389v-42H277.88V288zm-336.65-3.67h281l-37.81 38H154.16z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$8026826fd2a7e7ec(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.56 94.92V80a16 16 0 00-16-16H113.44a16 16 0 00-16 16v14.92c-1.46 11.37-9.65 90.74 36.93 144.69 24.87 28.8 60.36 44.85 105.63 47.86V416h-80a16 16 0 000 32h192a16 16 0 000-32h-80V287.47c45.27-3 80.76-19.06 105.63-47.86 46.58-53.95 38.37-133.32 36.93-144.69zm-285.3 3.41a15.14 15.14 0 00.18-2.33h253.12a15.14 15.14 0 00.18 2.33 201.91 201.91 0 010 45.67H129.32a204.29 204.29 0 01-.06-45.67z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$222601f3d3e5815b(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M208 368v104a23.73 23.73 0 0024 24h0a23.73 23.73 0 0024-24"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 368v104a23.73 23.73 0 0024 24h0a23.73 23.73 0 0024-24V368m-121-94a23.73 23.73 0 01-29.84 16.18h0a23.72 23.72 0 01-16.17-29.84l25-84.28A44.85 44.85 0 01205 144h102a44.85 44.85 0 0143 32.08l25 84.28a23.72 23.72 0 01-16.17 29.84h0a23.73 23.73 0 01-29.78-16.2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "40",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M208 192l-48 160h192l-48-160"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$7b62ea4034a87fa8(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "255.75",
                    "cy": "56",
                    "r": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M310.28 191.4h.05l7.66-2.3 36.79 122.6 46-13.8-16.21-54.16c0-.12 0-.24-.07-.36l-16.84-56.12-4.71-15.74-.9-3H362l-2.51-8.45a44.84 44.84 0 00-43-32.08H195.24a44.84 44.84 0 00-43 32.08l-2.51 8.45h-.06l-.9 3-4.71 15.74-16.84 56.12c0 .12 0 .24-.07.36l-16.21 54.16 46 13.8 36.76-122.6 7.54 2.26L148.25 368h51.5v144h52V368h8v144h52V368h51.51z"
                }
            }
        ]
    })(props);
}
function $6ec9aef169c6b70a$export$b139f4060ab17f08(props) {
    return (0, $2226cc54c1b91b60$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "255.75",
                    "cy": "56",
                    "r": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M394.63 277.9l-10.33-34.41v-.11l-22.46-74.86h-.05l-2.51-8.45a44.87 44.87 0 00-43-32.08h-120a44.84 44.84 0 00-43 32.08l-2.51 8.45h-.06l-22.46 74.86v.11l-10.37 34.41c-3.12 10.39 2.3 21.66 12.57 25.14a20 20 0 0025.6-13.18l25.58-85.25 2.17-7.23a8 8 0 0115.53 2.62 7.78 7.78 0 01-.17 1.61L155.43 347.4a16 16 0 0015.32 20.6h29v114.69c0 16.46 10.53 29.31 24 29.31s24-12.85 24-29.31V368h16v114.69c0 16.46 10.53 29.31 24 29.31s24-12.85 24-29.31V368h30a16 16 0 0015.33-20.6l-43.74-145.81a7.52 7.52 0 01-.16-1.59 8 8 0 0115.54-2.63l2.17 7.23 25.57 85.25A20 20 0 00382.05 303c10.27-3.44 15.69-14.71 12.58-25.1z"
                }
            }
        ]
    })(props);
}




parcelRequire("4DE7A");

var $4DE7A = parcelRequire("4DE7A");

var $dBd5b = parcelRequire("dBd5b");

var $4DE7A = parcelRequire("4DE7A");

var $dBd5b = parcelRequire("dBd5b");

var $4DE7A = parcelRequire("4DE7A");

var $gv34t = parcelRequire("gv34t");

var $dBd5b = parcelRequire("dBd5b");

var $4DE7A = parcelRequire("4DE7A");

var $4DE7A = parcelRequire("4DE7A");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $aa92db86bf739672$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $aa92db86bf739672$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$aa92db86bf739672$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $aa92db86bf739672$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $4DE7A.useCallback)($aa92db86bf739672$export$43e446d32b3d21af(...refs), refs);
}


/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $ba30e5867cc80958$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $4DE7A.Children).toArray(children);
    const slottable = childrenArray.find($ba30e5867cc80958$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $4DE7A.Children).count(newElement) > 1) return (0, $4DE7A.Children).only(null);
                return /*#__PURE__*/ (0, $4DE7A.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $4DE7A.createElement)($ba30e5867cc80958$var$$5e63c961fc1ce211$var$SlotClone, (0, $dBd5b.default)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $4DE7A.isValidElement)(newElement) ? /*#__PURE__*/ (0, $4DE7A.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $4DE7A.createElement)($ba30e5867cc80958$var$$5e63c961fc1ce211$var$SlotClone, (0, $dBd5b.default)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$ba30e5867cc80958$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $ba30e5867cc80958$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $4DE7A.isValidElement)(children)) return /*#__PURE__*/ (0, $4DE7A.cloneElement)(children, {
        ...$ba30e5867cc80958$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0, $aa92db86bf739672$export$43e446d32b3d21af)(forwardedRef, children.ref) : children.ref
    });
    return (0, $4DE7A.Children).count(children) > 1 ? (0, $4DE7A.Children).only(null) : null;
});
$ba30e5867cc80958$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $ba30e5867cc80958$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $4DE7A.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $ba30e5867cc80958$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $4DE7A.isValidElement)(child) && child.type === $ba30e5867cc80958$export$d9f1ccf0bdb05d45;
}
function $ba30e5867cc80958$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $ba30e5867cc80958$export$be92b6f5f03c0fe9 = $ba30e5867cc80958$export$8c6ed5c666ac1360;


const $5350cbeeb3d0f7d5$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $5350cbeeb3d0f7d5$export$250ffa63cdc0d034 = $5350cbeeb3d0f7d5$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $ba30e5867cc80958$export$8c6ed5c666ac1360) : node;
        (0, $4DE7A.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $4DE7A.createElement)(Comp, (0, $dBd5b.default)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $5350cbeeb3d0f7d5$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $gv34t.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $5350cbeeb3d0f7d5$export$be92b6f5f03c0fe9 = $5350cbeeb3d0f7d5$export$250ffa63cdc0d034;


/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $de3e8ebee36ba8c1$var$$ea1ef594cf570d83$var$NAME = "VisuallyHidden";
const $de3e8ebee36ba8c1$export$439d29a4e110a164 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).span, (0, $dBd5b.default)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($de3e8ebee36ba8c1$export$439d29a4e110a164, {
    displayName: $de3e8ebee36ba8c1$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $de3e8ebee36ba8c1$export$be92b6f5f03c0fe9 = $de3e8ebee36ba8c1$export$439d29a4e110a164;


const $a2a8d5c0e241f640$var$$08b6689415b2f49a$var$NAME = "AccessibleIcon";
const $a2a8d5c0e241f640$export$5aec92af04ace2d2 = ({ children: children, label: label })=>{
    const child = (0, $4DE7A.Children).only(children);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $4DE7A.Fragment), null, /*#__PURE__*/ (0, $4DE7A.cloneElement)(child, {
        // accessibility
        "aria-hidden": "true",
        focusable: "false" // See: https://allyjs.io/tutorials/focusing-in-svg.html#making-svg-elements-focusable
    }), /*#__PURE__*/ (0, $4DE7A.createElement)((0, $de3e8ebee36ba8c1$export$be92b6f5f03c0fe9), null, label));
};
/*#__PURE__*/ Object.assign($a2a8d5c0e241f640$export$5aec92af04ace2d2, {
    displayName: $a2a8d5c0e241f640$var$$08b6689415b2f49a$var$NAME
});
const $a2a8d5c0e241f640$export$be92b6f5f03c0fe9 = $a2a8d5c0e241f640$export$5aec92af04ace2d2;


function $01fa17a3769f170b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($a2a8d5c0e241f640$export$be92b6f5f03c0fe9, {
        ...props
    });
}



var $10abdc0bd635538b$exports = {};

$10abdc0bd635538b$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "logo_horizontal.430beba6.svg";



parcelRequire("4DE7A");



function $3ca9c4908ed5ee34$var$InstanceBadge({ label: label }) {
    const offline = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.system.offline);
    const classNames = [
        "instance-badge"
    ];
    const details = $3ca9c4908ed5ee34$var$getDetails(offline, label);
    if (details.className !== undefined) classNames.push(details.className);
    // Displays a label. Nothing happens if there isn't one.
    if (details.label !== undefined) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: classNames.join(" "),
        children: details.label
    });
    else return null;
}
function $3ca9c4908ed5ee34$var$getDetails(offline, label) {
    // If a label is not provided, determine one
    if (label === undefined) {
        if (offline) return {
            label: "Demo",
            className: "instance-label-demo"
        };
        else switch((0, $63b5c9d178f1431e$export$f38a48430246a886) ?? (0, $63b5c9d178f1431e$export$83401e34d5e11bf4)){
            case "development":
                return {
                    label: "Dev",
                    className: "instance-label-development"
                };
            case "staging":
                return {
                    label: "Staging",
                    className: "instance-label-staging"
                };
            case "sandbox":
                return {
                    label: "Sandbox",
                    className: "instance-label-sandbox"
                };
            default:
                return {};
        }
    }
    return {
        label: label
    };
}
var $3ca9c4908ed5ee34$export$2e2bcd8739ae039 = $3ca9c4908ed5ee34$var$InstanceBadge;



parcelRequire("4DE7A");


var $4DE7A = parcelRequire("4DE7A");
function $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6431ef21eafb1f5a$var$_excluded = [
    "color"
];
var $6431ef21eafb1f5a$export$12f5813a529780ed = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.877197 7.49984C0.877197 3.84216 3.84234 0.877014 7.50003 0.877014C11.1577 0.877014 14.1229 3.84216 14.1229 7.49984C14.1229 11.1575 11.1577 14.1227 7.50003 14.1227C3.84234 14.1227 0.877197 11.1575 0.877197 7.49984ZM7.50003 1.82701C4.36702 1.82701 1.8272 4.36683 1.8272 7.49984C1.8272 10.6328 4.36702 13.1727 7.50003 13.1727C10.633 13.1727 13.1729 10.6328 13.1729 7.49984C13.1729 4.36683 10.633 1.82701 7.50003 1.82701ZM7.12457 9.00001C7.06994 9.12735 6.33165 11.9592 6.33165 11.9592C6.26018 12.226 5.98601 12.3843 5.71928 12.3128C5.45255 12.2413 5.29425 11.9672 5.36573 11.7004C5.36573 11.7004 6.24661 8.87268 6.24661 8.27007V6.80099L4.28763 6.27608C4.0209 6.20461 3.86261 5.93045 3.93408 5.66371C4.00555 5.39698 4.27972 5.23869 4.54645 5.31016C4.54645 5.31016 6.20042 5.87268 6.84579 5.87268H8.15505C8.80042 5.87268 10.4534 5.31042 10.4534 5.31042C10.7202 5.23895 10.9943 5.39724 11.0658 5.66397C11.1373 5.93071 10.979 6.20487 10.7122 6.27635L8.74661 6.80303V8.27007C8.74661 8.87268 9.62663 11.6971 9.62663 11.6971C9.6981 11.9639 9.5398 12.238 9.27307 12.3095C9.00634 12.381 8.73217 12.2227 8.6607 11.956C8.6607 11.956 7.91994 9.12735 7.86866 9.00001C7.81994 8.87268 7.65006 8.87268 7.65006 8.87268H7.34317C7.34317 8.87268 7.16994 8.87268 7.12457 9.00001ZM7.50043 5.12007C8.12175 5.12007 8.62543 4.61639 8.62543 3.99507C8.62543 3.37375 8.12175 2.87007 7.50043 2.87007C6.87911 2.87007 6.37543 3.37375 6.37543 3.99507C6.37543 4.61639 6.87911 5.12007 7.50043 5.12007Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1 = [
    "color"
];
var $6431ef21eafb1f5a$export$c40c07f3e63e590d = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0 1.5C0 1.22386 0.223858 1 0.5 1H2.5C2.77614 1 3 1.22386 3 1.5C3 1.77614 2.77614 2 2.5 2H0.5C0.223858 2 0 1.77614 0 1.5ZM4 1.5C4 1.22386 4.22386 1 4.5 1H14.5C14.7761 1 15 1.22386 15 1.5C15 1.77614 14.7761 2 14.5 2H4.5C4.22386 2 4 1.77614 4 1.5ZM4 4.5C4 4.22386 4.22386 4 4.5 4H11.5C11.7761 4 12 4.22386 12 4.5C12 4.77614 11.7761 5 11.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM0 7.5C0 7.22386 0.223858 7 0.5 7H2.5C2.77614 7 3 7.22386 3 7.5C3 7.77614 2.77614 8 2.5 8H0.5C0.223858 8 0 7.77614 0 7.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H4.5C4.22386 11 4 10.7761 4 10.5ZM0 13.5C0 13.2239 0.223858 13 0.5 13H2.5C2.77614 13 3 13.2239 3 13.5C3 13.7761 2.77614 14 2.5 14H0.5C0.223858 14 0 13.7761 0 13.5ZM4 13.5C4 13.2239 4.22386 13 4.5 13H14.5C14.7761 13 15 13.2239 15 13.5C15 13.7761 14.7761 14 14.5 14H4.5C4.22386 14 4 13.7761 4 13.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2 = [
    "color"
];
var $6431ef21eafb1f5a$export$315d3fae607b3916 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M10.5 1.75003C10.7107 1.75003 10.8988 1.88217 10.9703 2.08042L13.9703 10.4C14.064 10.6598 13.9293 10.9463 13.6696 11.04C13.4098 11.1336 13.1233 10.999 13.0296 10.7392L12.0477 8.01606H8.95227L7.97031 10.7392C7.87664 10.999 7.59012 11.1336 7.33035 11.04C7.07058 10.9463 6.93593 10.6598 7.0296 10.4L10.0296 2.08042C10.1011 1.88217 10.2892 1.75003 10.5 1.75003ZM10.5 3.72402L11.7411 7.16606H9.25877L10.5 3.72402ZM2.49949 2.09997C2.7204 2.09997 2.89949 2.27906 2.89949 2.49997L2.89949 9.53428L4.21664 8.21713C4.37285 8.06092 4.62612 8.06092 4.78233 8.21713C4.93854 8.37334 4.93854 8.6266 4.78233 8.78281L2.78233 10.7828C2.70732 10.8578 2.60557 10.9 2.49949 10.9C2.3934 10.9 2.29166 10.8578 2.21664 10.7828L0.216645 8.78281C0.0604349 8.6266 0.0604349 8.37334 0.216645 8.21713C0.372854 8.06092 0.62612 8.06092 0.78233 8.21713L2.09949 9.53428L2.09949 2.49997C2.09949 2.27906 2.27857 2.09997 2.49949 2.09997ZM0.0999695 13.5001C0.0999695 13.2791 0.279056 13.1001 0.499969 13.1001H14.5C14.7209 13.1001 14.9 13.2791 14.9 13.5001C14.9 13.721 14.7209 13.9001 14.5 13.9001H0.499969C0.279056 13.9001 0.0999695 13.721 0.0999695 13.5001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3 = [
    "color"
];
var $6431ef21eafb1f5a$export$28c63a2a77a6b6ba = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M9 3C9 2.44772 8.55229 2 8 2H7C6.44772 2 6 2.44772 6 3L6 14H1.5C1.22386 14 1 14.2239 1 14.5C1 14.7761 1.22386 15 1.5 15L6 15H9H13.5C13.7761 15 14 14.7761 14 14.5C14 14.2239 13.7761 14 13.5 14H9V3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4 = [
    "color"
];
var $6431ef21eafb1f5a$export$5284d356b9eb3ea0 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.99988 6C1.44759 6 0.999877 6.44772 0.999877 7L0.999877 8C0.999877 8.55228 1.44759 9 1.99988 9L6.99988 9L6.99988 13.5C6.99988 13.7761 7.22374 14 7.49988 14C7.77602 14 7.99988 13.7761 7.99988 13.5L7.99988 9L12.9999 9C13.5522 9 13.9999 8.55228 13.9999 8L13.9999 7C13.9999 6.44772 13.5522 6 12.9999 6L7.99988 6L7.99988 1.5C7.99988 1.22386 7.77602 1 7.49988 1C7.22373 1 6.99988 1.22386 6.99988 1.5L6.99988 6L1.99988 6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$5 = [
    "color"
];
var $6431ef21eafb1f5a$export$a87e0381c7863d70 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$5);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M6.99988 1C6.44759 1 5.99988 1.44772 5.99988 2V7H1.49988C1.22374 7 0.999878 7.22386 0.999878 7.5C0.999878 7.77614 1.22374 8 1.49988 8H5.99988V13C5.99988 13.5523 6.44759 14 6.99988 14H7.99988C8.55216 14 8.99988 13.5523 8.99988 13V8H13.4999C13.776 8 13.9999 7.77614 13.9999 7.5C13.9999 7.22386 13.776 7 13.4999 7H8.99988V2C8.99988 1.44772 8.55216 1 7.99988 1L6.99988 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$6 = [
    "color"
];
var $6431ef21eafb1f5a$export$43a2a6205c884160 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$6);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.499995 0.999995C0.223855 0.999995 -5.58458e-07 1.22385 -5.46388e-07 1.49999L-2.18554e-08 13.4999C-9.78492e-09 13.776 0.223855 13.9999 0.499995 13.9999C0.776136 13.9999 0.999991 13.776 0.999991 13.4999L0.999991 8.99993L12 8.99993C12.5523 8.99993 13 8.55222 13 7.99993L13 6.99994C13 6.44766 12.5523 5.99995 12 5.99995L0.999991 5.99995L0.999991 1.49999C0.999991 1.22385 0.776135 0.999995 0.499995 0.999995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$7 = [
    "color"
];
var $6431ef21eafb1f5a$export$589ba7400e24d687 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$7);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M14.4999 1C14.2237 1 13.9999 1.22386 13.9999 1.5L13.9999 6L2.99988 6C2.44759 6 1.99988 6.44772 1.99988 7L1.99988 8C1.99988 8.55228 2.44759 9 2.99988 9L13.9999 9L13.9999 13.5C13.9999 13.7761 14.2237 14 14.4999 14C14.776 14 14.9999 13.7761 14.9999 13.5L14.9999 9L14.9999 6L14.9999 1.5C14.9999 1.22386 14.776 1 14.4999 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$8 = [
    "color"
];
var $6431ef21eafb1f5a$export$359aaf594ac84c59 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$8);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.5 0C1.22386 0 1 0.223858 1 0.5C1 0.776142 1.22386 1 1.5 1H6V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V1H13.5C13.7761 1 14 0.776142 14 0.5C14 0.223858 13.7761 0 13.5 0H9H6H1.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$9 = [
    "color"
];
var $6431ef21eafb1f5a$export$c5eda4f4203e72ab = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$9);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.5 0.75L9.75 3H5.25L7.5 0.75ZM7.5 14.25L9.75 12H5.25L7.5 14.25ZM3 5.25L0.75 7.5L3 9.75V5.25ZM14.25 7.5L12 5.25V9.75L14.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$a = [
    "color"
];
var $6431ef21eafb1f5a$export$c3671dfffcc20189 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$a);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8.8914 2.1937C9.1158 2.35464 9.16725 2.66701 9.00631 2.89141L2.47388 12H13.5C13.7761 12 14 12.2239 14 12.5C14 12.7762 13.7761 13 13.5 13H1.5C1.31254 13 1.14082 12.8952 1.0552 12.7284C0.969578 12.5616 0.984438 12.361 1.09369 12.2086L8.19369 2.30862C8.35462 2.08422 8.667 2.03277 8.8914 2.1937ZM11.1 6.50001C11.1 6.22387 11.3238 6.00001 11.6 6.00001C11.8761 6.00001 12.1 6.22387 12.1 6.50001C12.1 6.77615 11.8761 7.00001 11.6 7.00001C11.3238 7.00001 11.1 6.77615 11.1 6.50001ZM10.4 4.00001C10.1239 4.00001 9.90003 4.22387 9.90003 4.50001C9.90003 4.77615 10.1239 5.00001 10.4 5.00001C10.6762 5.00001 10.9 4.77615 10.9 4.50001C10.9 4.22387 10.6762 4.00001 10.4 4.00001ZM12.1 8.50001C12.1 8.22387 12.3238 8.00001 12.6 8.00001C12.8761 8.00001 13.1 8.22387 13.1 8.50001C13.1 8.77615 12.8761 9.00001 12.6 9.00001C12.3238 9.00001 12.1 8.77615 12.1 8.50001ZM13.4 10C13.1239 10 12.9 10.2239 12.9 10.5C12.9 10.7761 13.1239 11 13.4 11C13.6762 11 13.9 10.7761 13.9 10.5C13.9 10.2239 13.6762 10 13.4 10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$b = [
    "color"
];
var $6431ef21eafb1f5a$export$64abfa02d870a554 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$b);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.30902 1C2.93025 1 2.58398 1.214 2.41459 1.55279L1.05279 4.27639C1.01807 4.34582 1 4.42238 1 4.5V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V4.5C14 4.42238 13.9819 4.34582 13.9472 4.27639L12.5854 1.55281C12.416 1.21403 12.0698 1.00003 11.691 1.00003L7.5 1.00001L3.30902 1ZM3.30902 2L7 2.00001V4H2.30902L3.30902 2ZM8 4V2.00002L11.691 2.00003L12.691 4H8ZM7.5 5H13V13H2V5H7.5ZM5.5 7C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8H9.5C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7H5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$c = [
    "color"
];
var $6431ef21eafb1f5a$export$ba8ee9ef4800b4a5 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$c);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M11.3536 3.64644C11.5488 3.8417 11.5488 4.15828 11.3536 4.35354L4.70711 11L9 11C9.27614 11 9.5 11.2239 9.5 11.5C9.5 11.7761 9.27614 12 9 12L3.5 12C3.36739 12 3.24021 11.9473 3.14645 11.8536C3.05268 11.7598 3 11.6326 3 11.5L3 5.99999C3 5.72385 3.22386 5.49999 3.5 5.49999C3.77614 5.49999 4 5.72385 4 5.99999V10.2929L10.6464 3.64643C10.8417 3.45117 11.1583 3.45117 11.3536 3.64644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$d = [
    "color"
];
var $6431ef21eafb1f5a$export$1a0b00ff4e10643e = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$d);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.64645 3.64644C3.45118 3.8417 3.45118 4.15828 3.64645 4.35354L10.2929 11L6 11C5.72386 11 5.5 11.2239 5.5 11.5C5.5 11.7761 5.72386 12 6 12L11.5 12C11.6326 12 11.7598 11.9473 11.8536 11.8536C11.9473 11.7598 12 11.6326 12 11.5L12 5.99999C12 5.72385 11.7761 5.49999 11.5 5.49999C11.2239 5.49999 11 5.72385 11 5.99999V10.2929L4.35355 3.64643C4.15829 3.45117 3.84171 3.45117 3.64645 3.64644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$e = [
    "color"
];
var $6431ef21eafb1f5a$export$1c939d3c9b6931b = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$e);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.5 2C7.77614 2 8 2.22386 8 2.5L8 11.2929L11.1464 8.14645C11.3417 7.95118 11.6583 7.95118 11.8536 8.14645C12.0488 8.34171 12.0488 8.65829 11.8536 8.85355L7.85355 12.8536C7.75979 12.9473 7.63261 13 7.5 13C7.36739 13 7.24021 12.9473 7.14645 12.8536L3.14645 8.85355C2.95118 8.65829 2.95118 8.34171 3.14645 8.14645C3.34171 7.95118 3.65829 7.95118 3.85355 8.14645L7 11.2929L7 2.5C7 2.22386 7.22386 2 7.5 2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$f = [
    "color"
];
var $6431ef21eafb1f5a$export$8afed21ef5c2afa5 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$f);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355L3.70711 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H3.70711L6.85355 11.1464C7.04882 11.3417 7.04882 11.6583 6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645L6.14645 3.14645C6.34171 2.95118 6.65829 2.95118 6.85355 3.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$g = [
    "color"
];
var $6431ef21eafb1f5a$export$9ca09caa9c849d9c = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$g);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$h = [
    "color"
];
var $6431ef21eafb1f5a$export$9f5fe8cc556ac1f3 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$h);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M11.3536 11.3536C11.5488 11.1583 11.5488 10.8417 11.3536 10.6465L4.70711 4L9 4C9.27614 4 9.5 3.77614 9.5 3.5C9.5 3.22386 9.27614 3 9 3L3.5 3C3.36739 3 3.24021 3.05268 3.14645 3.14645C3.05268 3.24022 3 3.36739 3 3.5L3 9.00001C3 9.27615 3.22386 9.50001 3.5 9.50001C3.77614 9.50001 4 9.27615 4 9.00001V4.70711L10.6464 11.3536C10.8417 11.5488 11.1583 11.5488 11.3536 11.3536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$i = [
    "color"
];
var $6431ef21eafb1f5a$export$64a9bd58f7494197 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$i);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.64645 11.3536C3.45118 11.1583 3.45118 10.8417 3.64645 10.6465L10.2929 4L6 4C5.72386 4 5.5 3.77614 5.5 3.5C5.5 3.22386 5.72386 3 6 3L11.5 3C11.6326 3 11.7598 3.05268 11.8536 3.14645C11.9473 3.24022 12 3.36739 12 3.5L12 9.00001C12 9.27615 11.7761 9.50001 11.5 9.50001C11.2239 9.50001 11 9.27615 11 9.00001V4.70711L4.35355 11.3536C4.15829 11.5488 3.84171 11.5488 3.64645 11.3536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$j = [
    "color"
];
var $6431ef21eafb1f5a$export$f1a507b991affc46 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$j);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.14645 2.14645C7.34171 1.95118 7.65829 1.95118 7.85355 2.14645L11.8536 6.14645C12.0488 6.34171 12.0488 6.65829 11.8536 6.85355C11.6583 7.04882 11.3417 7.04882 11.1464 6.85355L8 3.70711L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 3.70711L3.85355 6.85355C3.65829 7.04882 3.34171 7.04882 3.14645 6.85355C2.95118 6.65829 2.95118 6.34171 3.14645 6.14645L7.14645 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$k = [
    "color"
];
var $6431ef21eafb1f5a$export$843c734d18c2237 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$k);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.5 2H12.5C12.7761 2 13 2.22386 13 2.5V12.5C13 12.7761 12.7761 13 12.5 13H2.5C2.22386 13 2 12.7761 2 12.5V2.5C2 2.22386 2.22386 2 2.5 2ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5ZM7.5 4C7.77614 4 8 3.77614 8 3.5C8 3.22386 7.77614 3 7.5 3C7.22386 3 7 3.22386 7 3.5C7 3.77614 7.22386 4 7.5 4ZM8 5.5C8 5.77614 7.77614 6 7.5 6C7.22386 6 7 5.77614 7 5.5C7 5.22386 7.22386 5 7.5 5C7.77614 5 8 5.22386 8 5.5ZM7.5 8C7.77614 8 8 7.77614 8 7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8ZM10 7.5C10 7.77614 9.77614 8 9.5 8C9.22386 8 9 7.77614 9 7.5C9 7.22386 9.22386 7 9.5 7C9.77614 7 10 7.22386 10 7.5ZM11.5 8C11.7761 8 12 7.77614 12 7.5C12 7.22386 11.7761 7 11.5 7C11.2239 7 11 7.22386 11 7.5C11 7.77614 11.2239 8 11.5 8Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$l = [
    "color"
];
var $6431ef21eafb1f5a$export$b1f22795a41806ac = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$l);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$m = [
    "color"
];
var $6431ef21eafb1f5a$export$a7965fbad5d67169 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$m);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5 1C5 0.447715 5.44772 0 6 0H9C9.55228 0 10 0.447715 10 1V2H14C14.5523 2 15 2.44772 15 3V6C15 6.8888 14.6131 7.68734 14 8.23608V11.5C14 12.3284 13.3284 13 12.5 13H2.5C1.67157 13 1 12.3284 1 11.5V8.2359C0.38697 7.68721 0 6.88883 0 6V3C0 2.44772 0.447716 2 1 2H5V1ZM9 1V2H6V1H9ZM1 3H5H5.5H9.5H10H14V6C14 6.654 13.6866 7.23467 13.1997 7.6004C12.8655 7.85144 12.4508 8 12 8H8V7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5V8H3C2.5493 8 2.1346 7.85133 1.80029 7.60022C1.31335 7.23446 1 6.65396 1 6V3ZM7 9H3C2.64961 9 2.31292 8.93972 2 8.82905V11.5C2 11.7761 2.22386 12 2.5 12H12.5C12.7761 12 13 11.7761 13 11.5V8.82915C12.6871 8.93978 12.3504 9 12 9H8V9.5C8 9.77614 7.77614 10 7.5 10C7.22386 10 7 9.77614 7 9.5V9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$n = [
    "color"
];
var $6431ef21eafb1f5a$export$e32f68df2d27987 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$n);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.5 6H11.5C12.3284 6 13 6.67157 13 7.5C13 8.32843 12.3284 9 11.5 9H3.5C2.67157 9 2 8.32843 2 7.5C2 6.67157 2.67157 6 3.5 6ZM1 7.5C1 6.11929 2.11929 5 3.5 5H11.5C12.8807 5 14 6.11929 14 7.5C14 8.88071 12.8807 10 11.5 10H3.5C2.11929 10 1 8.88071 1 7.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$o = [
    "color"
];
var $6431ef21eafb1f5a$export$472946dc5493045a = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$o);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M11.5 1C11.7761 1 12 1.22386 12 1.5V13.5C12 13.7761 11.7761 14 11.5 14C11.2239 14 11 13.7761 11 13.5V1.5C11 1.22386 11.2239 1 11.5 1ZM9.5 3C9.77614 3 10 3.22386 10 3.5V13.5C10 13.7761 9.77614 14 9.5 14C9.22386 14 9 13.7761 9 13.5V3.5C9 3.22386 9.22386 3 9.5 3ZM13.5 3C13.7761 3 14 3.22386 14 3.5V13.5C14 13.7761 13.7761 14 13.5 14C13.2239 14 13 13.7761 13 13.5V3.5C13 3.22386 13.2239 3 13.5 3ZM5.5 4C5.77614 4 6 4.22386 6 4.5V13.5C6 13.7761 5.77614 14 5.5 14C5.22386 14 5 13.7761 5 13.5V4.5C5 4.22386 5.22386 4 5.5 4ZM1.5 5C1.77614 5 2 5.22386 2 5.5V13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5V5.5C1 5.22386 1.22386 5 1.5 5ZM7.5 5C7.77614 5 8 5.22386 8 5.5V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.5C7 5.22386 7.22386 5 7.5 5ZM3.5 7C3.77614 7 4 7.22386 4 7.5V13.5C4 13.7761 3.77614 14 3.5 14C3.22386 14 3 13.7761 3 13.5V7.5C3 7.22386 3.22386 7 3.5 7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$p = [
    "color"
];
var $6431ef21eafb1f5a$export$2235404cc2cfe93c = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$p);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8.60124 1.25086C8.60124 1.75459 8.26278 2.17927 7.80087 2.30989C10.1459 2.4647 12 4.41582 12 6.79999V10.25C12 11.0563 12.0329 11.7074 12.7236 12.0528C12.931 12.1565 13.0399 12.3892 12.9866 12.6149C12.9333 12.8406 12.7319 13 12.5 13H8.16144C8.36904 13.1832 8.49997 13.4513 8.49997 13.75C8.49997 14.3023 8.05226 14.75 7.49997 14.75C6.94769 14.75 6.49997 14.3023 6.49997 13.75C6.49997 13.4513 6.63091 13.1832 6.83851 13H2.49999C2.2681 13 2.06664 12.8406 2.01336 12.6149C1.96009 12.3892 2.06897 12.1565 2.27638 12.0528C2.96708 11.7074 2.99999 11.0563 2.99999 10.25V6.79999C2.99999 4.41537 4.85481 2.46396 7.20042 2.3098C6.73867 2.17908 6.40036 1.75448 6.40036 1.25086C6.40036 0.643104 6.89304 0.150421 7.5008 0.150421C8.10855 0.150421 8.60124 0.643104 8.60124 1.25086ZM7.49999 3.29999C5.56699 3.29999 3.99999 4.86699 3.99999 6.79999V10.25L4.00002 10.3009C4.0005 10.7463 4.00121 11.4084 3.69929 12H11.3007C10.9988 11.4084 10.9995 10.7463 11 10.3009L11 10.25V6.79999C11 4.86699 9.43299 3.29999 7.49999 3.29999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$q = [
    "color"
];
var $6431ef21eafb1f5a$export$cd91dad3f7d2f1be = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$q);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3 9C3 6.5 4.5 4.25 7.5 1.5C10.5 4.25 12 6.5 12 9C12 11.4853 9.98528 13.5 7.5 13.5C5.01472 13.5 3 11.4853 3 9ZM10.9524 8.30307C9.67347 7.82121 8.2879 8.46208 6.98956 9.06259C5.9327 9.55142 4.93365 10.0135 4.09695 9.82153C4.03357 9.55804 4 9.28294 4 9C4 7.11203 5.02686 5.27195 7.5 2.87357C9.66837 4.97639 10.725 6.65004 10.9524 8.30307Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$r = [
    "color"
];
var $6431ef21eafb1f5a$export$93cb139c864b0aec = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$r);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H11.5C11.7761 2 12 2.22386 12 2.5V13.5C12 13.6818 11.9014 13.8492 11.7424 13.9373C11.5834 14.0254 11.3891 14.0203 11.235 13.924L7.5 11.5896L3.765 13.924C3.61087 14.0203 3.41659 14.0254 3.25762 13.9373C3.09864 13.8492 3 13.6818 3 13.5V2.5ZM4 3V12.5979L6.97 10.7416C7.29427 10.539 7.70573 10.539 8.03 10.7416L11 12.5979V3H4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$s = [
    "color"
];
var $6431ef21eafb1f5a$export$77df11a9db3bfb4e = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$s);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V13.5C3 13.6818 3.09864 13.8492 3.25762 13.9373C3.41659 14.0254 3.61087 14.0203 3.765 13.924L7.5 11.5896L11.235 13.924C11.3891 14.0203 11.5834 14.0254 11.7424 13.9373C11.9014 13.8492 12 13.6818 12 13.5V2.5C12 2.22386 11.7761 2 11.5 2H3.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$t = [
    "color"
];
var $6431ef21eafb1f5a$export$2b8bb78df07fc3c1 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$t);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.25 1C0.25 0.585786 0.585786 0.25 1 0.25H14C14.4142 0.25 14.75 0.585786 14.75 1V14C14.75 14.4142 14.4142 14.75 14 14.75H1C0.585786 14.75 0.25 14.4142 0.25 14V1ZM1.75 1.75V13.25H13.25V1.75H1.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "5",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "3",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "9",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "11",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$u = [
    "color"
];
var $6431ef21eafb1f5a$export$1986587b5169c3d1 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$u);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1 13.25L14 13.25V14.75L1 14.75V13.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "13",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "13",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "13",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "13",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "5",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "5",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "3",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "3",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "9",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "9",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "11",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "11",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "13",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "13",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "1",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "1",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "1",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "1",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "1",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "1",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$v = [
    "color"
];
var $6431ef21eafb1f5a$export$9e3588048b381346 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$v);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$w = [
    "color"
];
var $6431ef21eafb1f5a$export$db4fc3403d513c1 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$w);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.5 6.625C1.01675 6.625 0.625 7.01675 0.625 7.5C0.625 7.98325 1.01675 8.375 1.5 8.375C1.98325 8.375 2.375 7.98325 2.375 7.5C2.375 7.01675 1.98325 6.625 1.5 6.625ZM5.5 6.625C5.01675 6.625 4.625 7.01675 4.625 7.5C4.625 7.98325 5.01675 8.375 5.5 8.375C5.98325 8.375 6.375 7.98325 6.375 7.5C6.375 7.01675 5.98325 6.625 5.5 6.625ZM9.5 6.625C9.01675 6.625 8.625 7.01675 8.625 7.5C8.625 7.98325 9.01675 8.375 9.5 8.375C9.98325 8.375 10.375 7.98325 10.375 7.5C10.375 7.01675 9.98325 6.625 9.5 6.625ZM12.625 7.5C12.625 7.01675 13.0168 6.625 13.5 6.625C13.9832 6.625 14.375 7.01675 14.375 7.5C14.375 7.98325 13.9832 8.375 13.5 8.375C13.0168 8.375 12.625 7.98325 12.625 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$x = [
    "color"
];
var $6431ef21eafb1f5a$export$90857351d8240996 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$x);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.75 1L1.75 14L0.249999 14L0.25 1L1.75 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("rect", {
        x: "10",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 7)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "10",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 13)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "12",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 7)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "12",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 13)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "8",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 7)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "14",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 7)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "8",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 13)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "14",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 13)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "8",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 5)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "14",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 5)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "8",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 3)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "14",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 3)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "8",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 9)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "14",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 9)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "8",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 11)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "14",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 11)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "6",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 7)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "6",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 13)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "4",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 7)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "4",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 13)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "10",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 1)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "12",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 1)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "8",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 1)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "14",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 1)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "6",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 1)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "4",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 1)",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$y = [
    "color"
];
var $6431ef21eafb1f5a$export$fc99bfbabe8fe100 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$y);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "13",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "13",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "13",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "13",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "13",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "5",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "5",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "5",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "3",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "3",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "3",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "9",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "9",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "9",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "11",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "11",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "11",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "13",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "13",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "1",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "1",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "1",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "1",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "1",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "1",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "1",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$z = [
    "color"
];
var $6431ef21eafb1f5a$export$d19e24a090b81f38 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$z);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M13.25 1L13.25 14L14.75 14L14.75 1L13.25 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 7)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 13)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 7)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 13)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 7)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 7)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 13)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 13)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 5)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 5)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 3)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 3)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 9)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 9)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 11)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 11)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 7)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 13)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 7)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 13)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 1)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 1)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 1)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 1)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 1)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 1)",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$A = [
    "color"
];
var $6431ef21eafb1f5a$export$ca09e5ae294d45cc = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$A);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$B = [
    "color"
];
var $6431ef21eafb1f5a$export$fbe2d4727aba00b7 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$B);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "13",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "5",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "3",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "9",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "11",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "7",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "1",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $4DE7A.createElement)("path", {
        d: "M1 1.49994C1 1.2238 1.22386 0.999939 1.5 0.999939H6V1.99994H2V5.99994H1V1.49994ZM13 1.99994H9V0.999939H13.5C13.7761 0.999939 14 1.2238 14 1.49994V5.99994H13V1.99994ZM1 13.4999V8.99994H2V12.9999H6V13.9999H1.5C1.22386 13.9999 1 13.7761 1 13.4999ZM13 12.9999V8.99994H14V13.4999C14 13.7761 13.7761 13.9999 13.5 13.9999H9.5V12.9999H13Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$C = [
    "color"
];
var $6431ef21eafb1f5a$export$99084cce0e645aeb = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$C);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H3.5C3.77614 7 4 7.22386 4 7.5C4 7.77614 3.77614 8 3.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5C2 11.7761 1.77614 12 1.5 12C1.22386 12 1 11.7761 1 11.5ZM3 11.5C3 11.2239 3.22386 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11ZM7 11.5C7 11.2239 7.22386 11 7.5 11C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5C10 11.2239 9.77614 11 9.5 11ZM11 11.5C11 11.2239 11.2239 11 11.5 11C11.7761 11 12 11.2239 12 11.5C12 11.7761 11.7761 12 11.5 12C11.2239 12 11 11.7761 11 11.5ZM13.5 11C13.2239 11 13 11.2239 13 11.5C13 11.7761 13.2239 12 13.5 12C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11ZM6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H8.5C8.77614 8 9 7.77614 9 7.5C9 7.22386 8.77614 7 8.5 7H6.5ZM11 7.5C11 7.22386 11.2239 7 11.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H11.5C11.2239 8 11 7.77614 11 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$D = [
    "color"
];
var $6431ef21eafb1f5a$export$c244c53943ad4d08 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$D);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M14 1.75L1 1.75L1 0.249999L14 0.25L14 1.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("rect", {
        x: "8",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 10)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "2",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 10)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "8",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 12)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "2",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 12)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "8",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 8)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "8",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 14)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "2",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 8)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "2",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 14)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "10",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 10 8)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "10",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 10 14)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "12",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 12 8)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "12",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 12 14)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "6",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 6 8)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "6",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 6 14)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "4",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 4 8)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "4",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 4 14)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "8",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 6)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "2",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 6)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "8",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 4)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "2",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 4)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "14",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 10)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "14",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 12)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "14",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 8)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "14",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 14)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "14",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 6)",
        fill: color
    }), (0, $4DE7A.createElement)("rect", {
        x: "14",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 4)",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$E = [
    "color"
];
var $6431ef21eafb1f5a$export$26dc332286fcc660 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$E);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1 3H14V4H1V3ZM1 6H14V8H1V6ZM14 10.25H1V12.75H14V10.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$F = [
    "color"
];
var $6431ef21eafb1f5a$export$adedf1569d7107de = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$F);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M12.5 2H2.5C2.22386 2 2 2.22386 2 2.5V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$G = [
    "color"
];
var $6431ef21eafb1f5a$export$742ea6014cb11378 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$G);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.99998 0.999976C1.44769 0.999976 0.999976 1.44769 0.999976 1.99998V13C0.999976 13.5523 1.44769 14 1.99998 14H13C13.5523 14 14 13.5523 14 13V1.99998C14 1.44769 13.5523 0.999976 13 0.999976H1.99998ZM1.99998 1.99998L13 1.99998V13H1.99998V1.99998ZM4.49996 3.99996C4.22382 3.99996 3.99996 4.22382 3.99996 4.49996V10.5C3.99996 10.7761 4.22382 11 4.49996 11H10.5C10.7761 11 11 10.7761 11 10.5V4.49996C11 4.22382 10.7761 3.99996 10.5 3.99996H4.49996ZM4.99996 9.99996V4.99996H9.99996V9.99996H4.99996Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$H = [
    "color"
];
var $6431ef21eafb1f5a$export$e1c22a2ee2645e36 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$H);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2 5H13C13.5523 5 14 5.44772 14 6V9C14 9.55228 13.5523 10 13 10H2C1.44772 10 1 9.55228 1 9V6C1 5.44772 1.44772 5 2 5ZM0 6C0 4.89543 0.895431 4 2 4H13C14.1046 4 15 4.89543 15 6V9C15 10.1046 14.1046 11 13 11H2C0.89543 11 0 10.1046 0 9V6ZM4.5 6.75C4.08579 6.75 3.75 7.08579 3.75 7.5C3.75 7.91421 4.08579 8.25 4.5 8.25C4.91421 8.25 5.25 7.91421 5.25 7.5C5.25 7.08579 4.91421 6.75 4.5 6.75ZM6.75 7.5C6.75 7.08579 7.08579 6.75 7.5 6.75C7.91421 6.75 8.25 7.08579 8.25 7.5C8.25 7.91421 7.91421 8.25 7.5 8.25C7.08579 8.25 6.75 7.91421 6.75 7.5ZM10.5 6.75C10.0858 6.75 9.75 7.08579 9.75 7.5C9.75 7.91421 10.0858 8.25 10.5 8.25C10.9142 8.25 11.25 7.91421 11.25 7.5C11.25 7.08579 10.9142 6.75 10.5 6.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$I = [
    "color"
];
var $6431ef21eafb1f5a$export$5fda1783bb83f57b = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$I);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.5 1C4.77614 1 5 1.22386 5 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12.5C13.3284 2 14 2.67157 14 3.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V3.5C1 2.67157 1.67157 2 2.5 2H4V1.5C4 1.22386 4.22386 1 4.5 1ZM10 3V3.5C10 3.77614 10.2239 4 10.5 4C10.7761 4 11 3.77614 11 3.5V3H12.5C12.7761 3 13 3.22386 13 3.5V5H2V3.5C2 3.22386 2.22386 3 2.5 3H4V3.5C4 3.77614 4.22386 4 4.5 4C4.77614 4 5 3.77614 5 3.5V3H10ZM2 6V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V6H2ZM7 7.5C7 7.22386 7.22386 7 7.5 7C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8C7.22386 8 7 7.77614 7 7.5ZM9.5 7C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7ZM11 7.5C11 7.22386 11.2239 7 11.5 7C11.7761 7 12 7.22386 12 7.5C12 7.77614 11.7761 8 11.5 8C11.2239 8 11 7.77614 11 7.5ZM11.5 9C11.2239 9 11 9.22386 11 9.5C11 9.77614 11.2239 10 11.5 10C11.7761 10 12 9.77614 12 9.5C12 9.22386 11.7761 9 11.5 9ZM9 9.5C9 9.22386 9.22386 9 9.5 9C9.77614 9 10 9.22386 10 9.5C10 9.77614 9.77614 10 9.5 10C9.22386 10 9 9.77614 9 9.5ZM7.5 9C7.22386 9 7 9.22386 7 9.5C7 9.77614 7.22386 10 7.5 10C7.77614 10 8 9.77614 8 9.5C8 9.22386 7.77614 9 7.5 9ZM5 9.5C5 9.22386 5.22386 9 5.5 9C5.77614 9 6 9.22386 6 9.5C6 9.77614 5.77614 10 5.5 10C5.22386 10 5 9.77614 5 9.5ZM3.5 9C3.22386 9 3 9.22386 3 9.5C3 9.77614 3.22386 10 3.5 10C3.77614 10 4 9.77614 4 9.5C4 9.22386 3.77614 9 3.5 9ZM3 11.5C3 11.2239 3.22386 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11ZM7 11.5C7 11.2239 7.22386 11 7.5 11C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5C10 11.2239 9.77614 11 9.5 11Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$J = [
    "color"
];
var $6431ef21eafb1f5a$export$1bd12807c2fea239 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$J);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2 3C1.44772 3 1 3.44772 1 4V11C1 11.5523 1.44772 12 2 12H13C13.5523 12 14 11.5523 14 11V4C14 3.44772 13.5523 3 13 3H2ZM0 4C0 2.89543 0.895431 2 2 2H13C14.1046 2 15 2.89543 15 4V11C15 12.1046 14.1046 13 13 13H2C0.895431 13 0 12.1046 0 11V4ZM2 4.25C2 4.11193 2.11193 4 2.25 4H4.75C4.88807 4 5 4.11193 5 4.25V5.75454C5 5.89261 4.88807 6.00454 4.75 6.00454H2.25C2.11193 6.00454 2 5.89261 2 5.75454V4.25ZM12.101 7.58421C12.101 9.02073 10.9365 10.1853 9.49998 10.1853C8.06346 10.1853 6.89893 9.02073 6.89893 7.58421C6.89893 6.14769 8.06346 4.98315 9.49998 4.98315C10.9365 4.98315 12.101 6.14769 12.101 7.58421ZM13.101 7.58421C13.101 9.57302 11.4888 11.1853 9.49998 11.1853C7.51117 11.1853 5.89893 9.57302 5.89893 7.58421C5.89893 5.5954 7.51117 3.98315 9.49998 3.98315C11.4888 3.98315 13.101 5.5954 13.101 7.58421Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$K = [
    "color"
];
var $6431ef21eafb1f5a$export$16dbc2701f60a606 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$K);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2 3.5C2 3.22386 2.22386 3 2.5 3H12.5C12.7761 3 13 3.22386 13 3.5V9.5C13 9.77614 12.7761 10 12.5 10H2.5C2.22386 10 2 9.77614 2 9.5V3.5ZM2 10.9146C1.4174 10.7087 1 10.1531 1 9.5V3.5C1 2.67157 1.67157 2 2.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.1531 13.5826 10.7087 13 10.9146V11.5C13 12.3284 12.3284 13 11.5 13H3.5C2.67157 13 2 12.3284 2 11.5V10.9146ZM12 11V11.5C12 11.7761 11.7761 12 11.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11H12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$L = [
    "color"
];
var $6431ef21eafb1f5a$export$cf8d533bd52e80e3 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$L);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.5 3C2.22386 3 2 3.22386 2 3.5V9.5C2 9.77614 2.22386 10 2.5 10H12.5C12.7761 10 13 9.77614 13 9.5V3.5C13 3.22386 12.7761 3 12.5 3H2.5ZM1 9.5C1 10.1531 1.4174 10.7087 2 10.9146V11.5C2 12.3284 2.67157 13 3.5 13H11.5C12.3284 13 13 12.3284 13 11.5V10.9146C13.5826 10.7087 14 10.1531 14 9.5V3.5C14 2.67157 13.3284 2 12.5 2H2.5C1.67157 2 1 2.67157 1 3.5V9.5ZM12 11.5V11H3V11.5C3 11.7761 3.22386 12 3.5 12H11.5C11.7761 12 12 11.7761 12 11.5ZM5.5 6C5.22386 6 5 6.22386 5 6.5C5 6.77614 5.22386 7 5.5 7H9.5C9.77614 7 10 6.77614 10 6.5C10 6.22386 9.77614 6 9.5 6H5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$M = [
    "color"
];
var $6431ef21eafb1f5a$export$e590b2572239e122 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$M);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2 3.5C2 3.22386 2.22386 3 2.5 3H12.5C12.7761 3 13 3.22386 13 3.5V9.5C13 9.77614 12.7761 10 12.5 10H2.5C2.22386 10 2 9.77614 2 9.5V3.5ZM2 10.9146C1.4174 10.7087 1 10.1531 1 9.5V3.5C1 2.67157 1.67157 2 2.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.1531 13.5826 10.7087 13 10.9146V11.5C13 12.3284 12.3284 13 11.5 13H3.5C2.67157 13 2 12.3284 2 11.5V10.9146ZM12 11V11.5C12 11.7761 11.7761 12 11.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11H12ZM5 6.5C5 6.22386 5.22386 6 5.5 6H7V4.5C7 4.22386 7.22386 4 7.5 4C7.77614 4 8 4.22386 8 4.5V6H9.5C9.77614 6 10 6.22386 10 6.5C10 6.77614 9.77614 7 9.5 7H8V8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5V7H5.5C5.22386 7 5 6.77614 5 6.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$N = [
    "color"
];
var $6431ef21eafb1f5a$export$73a4c78a4a00962 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$N);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.73379 9.9026 7.61934 9.95001 7.49999 9.95001C7.38064 9.95001 7.26618 9.9026 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$O = [
    "color"
];
var $6431ef21eafb1f5a$export$810196a5854768f3 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$O);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8.81809 4.18179C8.99383 4.35753 8.99383 4.64245 8.81809 4.81819L6.13629 7.49999L8.81809 10.1818C8.99383 10.3575 8.99383 10.6424 8.81809 10.8182C8.64236 10.9939 8.35743 10.9939 8.1817 10.8182L5.1817 7.81819C5.09731 7.73379 5.0499 7.61933 5.0499 7.49999C5.0499 7.38064 5.09731 7.26618 5.1817 7.18179L8.1817 4.18179C8.35743 4.00605 8.64236 4.00605 8.81809 4.18179Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$P = [
    "color"
];
var $6431ef21eafb1f5a$export$5e4a7579d3e78657 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$P);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M6.18194 4.18185C6.35767 4.00611 6.6426 4.00611 6.81833 4.18185L9.81833 7.18185C9.90272 7.26624 9.95013 7.3807 9.95013 7.50005C9.95013 7.6194 9.90272 7.73386 9.81833 7.81825L6.81833 10.8182C6.6426 10.994 6.35767 10.994 6.18194 10.8182C6.0062 10.6425 6.0062 10.3576 6.18194 10.1819L8.86374 7.50005L6.18194 4.81825C6.0062 4.64251 6.0062 4.35759 6.18194 4.18185Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$Q = [
    "color"
];
var $6431ef21eafb1f5a$export$432020ae7f5a1085 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$Q);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$R = [
    "color"
];
var $6431ef21eafb1f5a$export$7d1b8b90f61377d1 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$R);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.18179 8.81819C4.00605 8.64245 4.00605 8.35753 4.18179 8.18179L7.18179 5.18179C7.26618 5.0974 7.38064 5.04999 7.49999 5.04999C7.61933 5.04999 7.73379 5.0974 7.81819 5.18179L10.8182 8.18179C10.9939 8.35753 10.9939 8.64245 10.8182 8.81819C10.6424 8.99392 10.3575 8.99392 10.1818 8.81819L7.49999 6.13638L4.81819 8.81819C4.64245 8.99392 4.35753 8.99392 4.18179 8.81819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$S = [
    "color"
];
var $6431ef21eafb1f5a$export$83414514025c111b = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$S);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M12.5 3L2.5 3.00002C1.67157 3.00002 1 3.6716 1 4.50002V9.50003C1 10.3285 1.67157 11 2.5 11H7.50003C7.63264 11 7.75982 11.0527 7.85358 11.1465L10 13.2929V11.5C10 11.2239 10.2239 11 10.5 11H12.5C13.3284 11 14 10.3285 14 9.50003V4.5C14 3.67157 13.3284 3 12.5 3ZM2.49999 2.00002L12.5 2C13.8807 2 15 3.11929 15 4.5V9.50003C15 10.8807 13.8807 12 12.5 12H11V14.5C11 14.7022 10.8782 14.8845 10.6913 14.9619C10.5045 15.0393 10.2894 14.9965 10.1464 14.8536L7.29292 12H2.5C1.11929 12 0 10.8807 0 9.50003V4.50002C0 3.11931 1.11928 2.00003 2.49999 2.00002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$T = [
    "color"
];
var $6431ef21eafb1f5a$export$7dd004358974b05d = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$T);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$U = [
    "color"
];
var $6431ef21eafb1f5a$export$54060461b8d0e637 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$U);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$V = [
    "color"
];
var $6431ef21eafb1f5a$export$c0a1936901b0e55 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$V);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3 3H12V12H3L3 3ZM2 3C2 2.44771 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44771 13 2 12.5523 2 12V3ZM10.3498 5.51105C10.506 5.28337 10.4481 4.97212 10.2204 4.81587C9.99275 4.65961 9.6815 4.71751 9.52525 4.94519L6.64048 9.14857L5.19733 7.40889C5.02102 7.19635 4.7058 7.16699 4.49327 7.34329C4.28073 7.5196 4.25137 7.83482 4.42767 8.04735L6.2934 10.2964C6.39348 10.4171 6.54437 10.4838 6.70097 10.4767C6.85757 10.4695 7.00177 10.3894 7.09047 10.2601L10.3498 5.51105Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$W = [
    "color"
];
var $6431ef21eafb1f5a$export$4857d3f3f5f8319b = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$W);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$X = [
    "color"
];
var $6431ef21eafb1f5a$export$20bc5960c3c9eebb = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$X);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$Y = [
    "color"
];
var $6431ef21eafb1f5a$export$b837bd7eac09a33e = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$Y);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$Z = [
    "color"
];
var $6431ef21eafb1f5a$export$7f01a6cbee61a0f2 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$Z);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.13523 8.84197C3.3241 9.04343 3.64052 9.05363 3.84197 8.86477L7.5 5.43536L11.158 8.86477C11.3595 9.05363 11.6759 9.04343 11.8648 8.84197C12.0536 8.64051 12.0434 8.32409 11.842 8.13523L7.84197 4.38523C7.64964 4.20492 7.35036 4.20492 7.15803 4.38523L3.15803 8.13523C2.95657 8.32409 2.94637 8.64051 3.13523 8.84197Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$_ = [
    "color"
];
var $6431ef21eafb1f5a$export$9c1c3f5a4a271817 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$_);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.877075 7.49991C0.877075 3.84222 3.84222 0.877075 7.49991 0.877075C11.1576 0.877075 14.1227 3.84222 14.1227 7.49991C14.1227 11.1576 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1576 0.877075 7.49991ZM7.49991 1.82708C4.36689 1.82708 1.82708 4.36689 1.82708 7.49991C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49991C13.1727 4.36689 10.6329 1.82708 7.49991 1.82708Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$$ = [
    "color"
];
var $6431ef21eafb1f5a$export$10324e86d7995e4 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$$);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49991 0.877075C3.84222 0.877075 0.877075 3.84222 0.877075 7.49991C0.877075 11.1576 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1576 14.1227 7.49991C14.1227 3.84222 11.1576 0.877075 7.49991 0.877075ZM3.85768 3.15057C4.84311 2.32448 6.11342 1.82708 7.49991 1.82708C10.6329 1.82708 13.1727 4.36689 13.1727 7.49991C13.1727 8.88638 12.6753 10.1567 11.8492 11.1421L3.85768 3.15057ZM3.15057 3.85768C2.32448 4.84311 1.82708 6.11342 1.82708 7.49991C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C8.88638 13.1727 10.1567 12.6753 11.1421 11.8492L3.15057 3.85768Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$10 = [
    "color"
];
var $6431ef21eafb1f5a$export$60f3f00eeba09710 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$10);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM11 2V2.25C11 2.66421 10.6642 3 10.25 3H4.75C4.33579 3 4 2.66421 4 2.25V2H3.5C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V2.5C12 2.22386 11.7761 2 11.5 2H11Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$11 = [
    "color"
];
var $6431ef21eafb1f5a$export$1a4dc243f6e39802 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$11);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H7V13H3.5C3.22386 13 3 12.7761 3 12.5V2.5C3 2.22386 3.22386 2 3.5 2H4V2.25C4 2.66421 4.33579 3 4.75 3H10.25C10.6642 3 11 2.66421 11 2.25V2H11.5C11.7761 2 12 2.22386 12 2.5V7H13V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM9 8.5C9 8.77614 8.77614 9 8.5 9C8.22386 9 8 8.77614 8 8.5C8 8.22386 8.22386 8 8.5 8C8.77614 8 9 8.22386 9 8.5ZM10.5 9C10.7761 9 11 8.77614 11 8.5C11 8.22386 10.7761 8 10.5 8C10.2239 8 10 8.22386 10 8.5C10 8.77614 10.2239 9 10.5 9ZM13 8.5C13 8.77614 12.7761 9 12.5 9C12.2239 9 12 8.77614 12 8.5C12 8.22386 12.2239 8 12.5 8C12.7761 8 13 8.22386 13 8.5ZM14.5 9C14.7761 9 15 8.77614 15 8.5C15 8.22386 14.7761 8 14.5 8C14.2239 8 14 8.22386 14 8.5C14 8.77614 14.2239 9 14.5 9ZM15 10.5C15 10.7761 14.7761 11 14.5 11C14.2239 11 14 10.7761 14 10.5C14 10.2239 14.2239 10 14.5 10C14.7761 10 15 10.2239 15 10.5ZM14.5 13C14.7761 13 15 12.7761 15 12.5C15 12.2239 14.7761 12 14.5 12C14.2239 12 14 12.2239 14 12.5C14 12.7761 14.2239 13 14.5 13ZM14.5 15C14.7761 15 15 14.7761 15 14.5C15 14.2239 14.7761 14 14.5 14C14.2239 14 14 14.2239 14 14.5C14 14.7761 14.2239 15 14.5 15ZM8.5 11C8.77614 11 9 10.7761 9 10.5C9 10.2239 8.77614 10 8.5 10C8.22386 10 8 10.2239 8 10.5C8 10.7761 8.22386 11 8.5 11ZM9 12.5C9 12.7761 8.77614 13 8.5 13C8.22386 13 8 12.7761 8 12.5C8 12.2239 8.22386 12 8.5 12C8.77614 12 9 12.2239 9 12.5ZM8.5 15C8.77614 15 9 14.7761 9 14.5C9 14.2239 8.77614 14 8.5 14C8.22386 14 8 14.2239 8 14.5C8 14.7761 8.22386 15 8.5 15ZM11 14.5C11 14.7761 10.7761 15 10.5 15C10.2239 15 10 14.7761 10 14.5C10 14.2239 10.2239 14 10.5 14C10.7761 14 11 14.2239 11 14.5ZM12.5 15C12.7761 15 13 14.7761 13 14.5C13 14.2239 12.7761 14 12.5 14C12.2239 14 12 14.2239 12 14.5C12 14.7761 12.2239 15 12.5 15Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$12 = [
    "color"
];
var $6431ef21eafb1f5a$export$8099ab97743c966c = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$12);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.50009 0.877014C3.84241 0.877014 0.877258 3.84216 0.877258 7.49984C0.877258 11.1575 3.8424 14.1227 7.50009 14.1227C11.1578 14.1227 14.1229 11.1575 14.1229 7.49984C14.1229 3.84216 11.1577 0.877014 7.50009 0.877014ZM1.82726 7.49984C1.82726 4.36683 4.36708 1.82701 7.50009 1.82701C10.6331 1.82701 13.1729 4.36683 13.1729 7.49984C13.1729 10.6328 10.6331 13.1727 7.50009 13.1727C4.36708 13.1727 1.82726 10.6328 1.82726 7.49984ZM8 4.50001C8 4.22387 7.77614 4.00001 7.5 4.00001C7.22386 4.00001 7 4.22387 7 4.50001V7.50001C7 7.63262 7.05268 7.7598 7.14645 7.85357L9.14645 9.85357C9.34171 10.0488 9.65829 10.0488 9.85355 9.85357C10.0488 9.65831 10.0488 9.34172 9.85355 9.14646L8 7.29291V4.50001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$13 = [
    "color"
];
var $6431ef21eafb1f5a$export$8036f09137bee589 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$13);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$14 = [
    "color"
];
var $6431ef21eafb1f5a$export$32cdc32ad6ae0658 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$14);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.71144 0.796902C7.57741 0.734357 7.42257 0.734357 7.28855 0.796902L1.28855 3.5969C1.11251 3.67905 0.999993 3.85573 0.999993 4.04999V10.95C0.999993 11.1443 1.11251 11.3209 1.28855 11.4031L7.28855 14.2031C7.42257 14.2656 7.57741 14.2656 7.71144 14.2031L13.7114 11.4031C13.8875 11.3209 14 11.1443 14 10.95V4.04999C14 3.85573 13.8875 3.67905 13.7114 3.5969L7.71144 0.796902ZM7.49999 3.15674L5.98039 2.51091L7.49999 1.80176L9.01959 2.51091L7.49999 3.15674ZM7.69556 4.16018L10.2382 3.07958L12.2719 4.02865L7.49999 6.05671L2.72808 4.02865L4.76181 3.07958L7.30442 4.16018C7.42939 4.2133 7.57059 4.2133 7.69556 4.16018ZM7.99999 6.93078L13 4.80578V7.92966L11.0821 8.8119C10.7273 8.97509 10.5 9.32988 10.5 9.72039V11.7982L7.99999 12.9649V6.93078ZM11.5 11.3316L13 10.6316V9.03039L11.5 9.72039V11.3316ZM6.99999 6.93078V12.9649L4.50231 11.7993V9.72036C4.50231 9.32985 4.27499 8.97506 3.92022 8.81187L1.99999 7.92856V4.80578L6.99999 6.93078ZM1.99999 10.6316L3.50231 11.3326L3.50231 9.72036L1.99999 9.02929V10.6316Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$15 = [
    "color"
];
var $6431ef21eafb1f5a$export$bda33a04439dd942 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$15);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.877075 7.49985C0.877075 3.84216 3.84222 0.877014 7.49991 0.877014C11.1576 0.877014 14.1227 3.84216 14.1227 7.49985C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49985ZM3.78135 3.21565C4.68298 2.43239 5.83429 1.92904 7.09998 1.84089V6.53429L3.78135 3.21565ZM3.21567 3.78134C2.43242 4.68298 1.92909 5.83428 1.84095 7.09997H6.5343L3.21567 3.78134ZM6.5343 7.89997H1.84097C1.92916 9.16562 2.43253 10.3169 3.21579 11.2185L6.5343 7.89997ZM3.78149 11.7842C4.6831 12.5673 5.83435 13.0707 7.09998 13.1588V8.46566L3.78149 11.7842ZM7.89998 8.46566V13.1588C9.16559 13.0706 10.3168 12.5673 11.2184 11.7841L7.89998 8.46566ZM11.7841 11.2184C12.5673 10.3168 13.0707 9.16558 13.1588 7.89997H8.46567L11.7841 11.2184ZM8.46567 7.09997H13.1589C13.0707 5.83432 12.5674 4.68305 11.7842 3.78143L8.46567 7.09997ZM11.2185 3.21573C10.3169 2.43246 9.16565 1.92909 7.89998 1.8409V6.53429L11.2185 3.21573Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$16 = [
    "color"
];
var $6431ef21eafb1f5a$export$bfc20b5a7dea0537 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$16);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8.00012 1.5C8.00012 1.22386 7.77626 1 7.50012 1C7.22398 1 7.00012 1.22386 7.00012 1.5V13.5C7.00012 13.7761 7.22398 14 7.50012 14C7.77626 14 8.00012 13.7761 8.00012 13.5V1.5ZM3.31812 5.818C3.49386 5.64227 3.49386 5.35734 3.31812 5.18161C3.14239 5.00587 2.85746 5.00587 2.68173 5.18161L0.681729 7.18161C0.505993 7.35734 0.505993 7.64227 0.681729 7.818L2.68173 9.818C2.85746 9.99374 3.14239 9.99374 3.31812 9.818C3.49386 9.64227 3.49386 9.35734 3.31812 9.18161L2.08632 7.9498H5.50017C5.7487 7.9498 5.95017 7.74833 5.95017 7.4998C5.95017 7.25128 5.7487 7.0498 5.50017 7.0498H2.08632L3.31812 5.818ZM12.3181 5.18161C12.1424 5.00587 11.8575 5.00587 11.6817 5.18161C11.506 5.35734 11.506 5.64227 11.6817 5.818L12.9135 7.0498H9.50017C9.25164 7.0498 9.05017 7.25128 9.05017 7.4998C9.05017 7.74833 9.25164 7.9498 9.50017 7.9498H12.9135L11.6817 9.18161C11.506 9.35734 11.506 9.64227 11.6817 9.818C11.8575 9.99374 12.1424 9.99374 12.3181 9.818L14.3181 7.818C14.4939 7.64227 14.4939 7.35734 14.3181 7.18161L12.3181 5.18161Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$17 = [
    "color"
];
var $6431ef21eafb1f5a$export$38f001d9cffdd080 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$17);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.14998 14V1H0.849976V14H2.14998ZM6.14998 14V1H4.84998V14H6.14998ZM10.15 1V14H8.84998V1H10.15ZM14.15 14V1H12.85V14H14.15Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$18 = [
    "color"
];
var $6431ef21eafb1f5a$export$13d9ab7fa696f910 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$18);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M9.94969 7.49989C9.94969 8.85288 8.85288 9.94969 7.49989 9.94969C6.14691 9.94969 5.0501 8.85288 5.0501 7.49989C5.0501 6.14691 6.14691 5.0501 7.49989 5.0501C8.85288 5.0501 9.94969 6.14691 9.94969 7.49989ZM10.8632 8C10.6213 9.64055 9.20764 10.8997 7.49989 10.8997C5.79214 10.8997 4.37847 9.64055 4.13662 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H4.13659C4.37835 5.35935 5.79206 4.1001 7.49989 4.1001C9.20772 4.1001 10.6214 5.35935 10.8632 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H10.8632Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$19 = [
    "color"
];
var $6431ef21eafb1f5a$export$a8e03ddff565be2c = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$19);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.67129 3.14634C4.47603 3.34161 4.47603 3.65819 4.67129 3.85345L7.14616 6.32833C7.34142 6.52359 7.65801 6.52359 7.85327 6.32833L10.3281 3.85345C10.5234 3.65819 10.5234 3.34161 10.3281 3.14634L7.85327 0.671471C7.65801 0.476209 7.34142 0.476209 7.14616 0.671471L4.67129 3.14634ZM7.49971 5.26766L5.73195 3.4999L7.49971 1.73213L9.26748 3.4999L7.49971 5.26766ZM8.67129 7.14634C8.47603 7.34161 8.47603 7.65819 8.67129 7.85345L11.1462 10.3283C11.3414 10.5236 11.658 10.5236 11.8533 10.3283L14.3281 7.85345C14.5234 7.65819 14.5234 7.34161 14.3281 7.14634L11.8533 4.67147C11.658 4.47621 11.3414 4.47621 11.1462 4.67147L8.67129 7.14634ZM11.4997 9.26766L9.73195 7.4999L11.4997 5.73213L13.2675 7.4999L11.4997 9.26766ZM4.67129 11.8535C4.47603 11.6582 4.47603 11.3416 4.67129 11.1463L7.14616 8.67147C7.34142 8.47621 7.65801 8.47621 7.85327 8.67147L10.3281 11.1463C10.5234 11.3416 10.5234 11.6582 10.3281 11.8535L7.85327 14.3283C7.65801 14.5236 7.34142 14.5236 7.14616 14.3283L4.67129 11.8535ZM5.73195 11.4999L7.49971 13.2677L9.26748 11.4999L7.49971 9.73213L5.73195 11.4999ZM0.671288 7.14649C0.476026 7.34175 0.476026 7.65834 0.671288 7.8536L3.14616 10.3285C3.34142 10.5237 3.65801 10.5237 3.85327 10.3285L6.32814 7.8536C6.5234 7.65834 6.5234 7.34175 6.32814 7.14649L3.85327 4.67162C3.65801 4.47636 3.34142 4.47636 3.14616 4.67162L0.671288 7.14649ZM3.49972 9.26781L1.73195 7.50005L3.49972 5.73228L5.26748 7.50005L3.49972 9.26781Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1a = [
    "color"
];
var $6431ef21eafb1f5a$export$467c6b1dbd59bc1e = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1a);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.87935 1H3.9H11.1H11.1207C11.5231 0.999994 11.8553 0.999989 12.1259 1.0221C12.407 1.04506 12.6653 1.09434 12.908 1.21799C13.2843 1.40973 13.5903 1.7157 13.782 2.09202C13.9057 2.33469 13.9549 2.59304 13.9779 2.87409C14 3.14468 14 3.47686 14 3.87934V3.9V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H3.9H3.87934C3.47686 14 3.14468 14 2.87409 13.9779C2.59304 13.9549 2.33469 13.9057 2.09202 13.782C1.7157 13.5903 1.40973 13.2843 1.21799 12.908C1.09434 12.6653 1.04506 12.407 1.0221 12.1259C0.999989 11.8553 0.999994 11.5231 1 11.1207V11.1207V11.1V3.9V3.87935V3.87934C0.999994 3.47686 0.999989 3.14468 1.0221 2.87409C1.04506 2.59304 1.09434 2.33469 1.21799 2.09202C1.40973 1.7157 1.7157 1.40973 2.09202 1.21799C2.33469 1.09434 2.59304 1.04506 2.87409 1.0221C3.14469 0.999989 3.47687 0.999994 3.87935 1ZM2.95552 2.01878C2.73631 2.03669 2.62421 2.06915 2.54601 2.10899C2.35785 2.20487 2.20487 2.35785 2.10899 2.54601C2.06915 2.62421 2.03669 2.73631 2.01878 2.95552C2.00039 3.18056 2 3.47171 2 3.9V7H7V2H3.9C3.47171 2 3.18056 2.00039 2.95552 2.01878ZM7 8H2V11.1C2 11.5283 2.00039 11.8194 2.01878 12.0445C2.03669 12.2637 2.06915 12.3758 2.10899 12.454C2.20487 12.6422 2.35785 12.7951 2.54601 12.891C2.62421 12.9309 2.73631 12.9633 2.95552 12.9812C3.18056 12.9996 3.47171 13 3.9 13H7V8ZM8 8H13V11.1C13 11.5283 12.9996 11.8194 12.9812 12.0445C12.9633 12.2637 12.9309 12.3758 12.891 12.454C12.7951 12.6422 12.6422 12.7951 12.454 12.891C12.3758 12.9309 12.2637 12.9633 12.0445 12.9812C11.8194 12.9996 11.5283 13 11.1 13H8V8ZM13 7H8V2H11.1C11.5283 2 11.8194 2.00039 12.0445 2.01878C12.2637 2.03669 12.3758 2.06915 12.454 2.10899C12.6422 2.20487 12.7951 2.35785 12.891 2.54601C12.9309 2.62421 12.9633 2.73631 12.9812 2.95552C12.9996 3.18056 13 3.47171 13 3.9V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1b = [
    "color"
];
var $6431ef21eafb1f5a$export$8b4f0e3d2d9d0b5 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1b);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.85367 1.48956C7.65841 1.29429 7.34182 1.29429 7.14656 1.48956L1.48971 7.14641C1.29445 7.34167 1.29445 7.65825 1.48971 7.85352L7.14656 13.5104C7.34182 13.7056 7.65841 13.7056 7.85367 13.5104L13.5105 7.85352C13.7058 7.65825 13.7058 7.34167 13.5105 7.14641L7.85367 1.48956ZM7.5 2.55033L2.55037 7.49996L7.5 12.4496V2.55033Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1c = [
    "color"
];
var $6431ef21eafb1f5a$export$4edbb1daceb32596 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1c);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.1465 1.48959C7.34176 1.29432 7.65835 1.29432 7.85361 1.48959L13.5105 7.14644C13.7057 7.3417 13.7057 7.65829 13.5105 7.85355L7.85361 13.5104C7.65835 13.7057 7.34176 13.7057 7.1465 13.5104L1.48965 7.85355C1.29439 7.65829 1.29439 7.3417 1.48965 7.14644L7.1465 1.48959ZM7.50005 2.55025L2.55031 7.49999L7.50005 12.4497L12.4498 7.49999L7.50005 2.55025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1d = [
    "color"
];
var $6431ef21eafb1f5a$export$8a42855f849911b4 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1d);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.85361 1.48959C7.65835 1.29432 7.34176 1.29432 7.1465 1.48959L1.48965 7.14644C1.29439 7.3417 1.29439 7.65829 1.48965 7.85355L3.9645 10.3284L1.64644 12.6464C1.45118 12.8417 1.45118 13.1583 1.64644 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.6716 11.0355L7.1465 13.5104C7.34176 13.7057 7.65835 13.7057 7.85361 13.5104L13.5105 7.85355C13.7057 7.65829 13.7057 7.3417 13.5105 7.14644L11.0356 4.67154L13.3535 2.35355C13.5488 2.15829 13.5488 1.84171 13.3535 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.3285 3.96443L7.85361 1.48959ZM9.62135 4.67154L7.50005 2.55025L2.55031 7.49999L4.6716 9.62129L9.62135 4.67154ZM5.37871 10.3284L7.50005 12.4497L12.4498 7.49999L10.3285 5.37865L5.37871 10.3284Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1e = [
    "color"
];
var $6431ef21eafb1f5a$export$39c9cf5aa1336b1f = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1e);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M12.8034 7.14644C12.9986 6.95118 13.3152 6.95118 13.5105 7.14644C13.7057 7.3417 13.7057 7.65829 13.5105 7.85355C13.3152 8.04881 12.9986 8.04881 12.8034 7.85355C12.6081 7.65828 12.6081 7.3417 12.8034 7.14644ZM12.0962 8.56065C12.2915 8.75592 12.2915 9.0725 12.0962 9.26776C11.901 9.46302 11.5844 9.46302 11.3891 9.26776C11.1939 9.0725 11.1939 8.75592 11.3891 8.56065C11.5844 8.36539 11.901 8.36539 12.0962 8.56065ZM10.682 9.97487C10.8773 10.1701 10.8773 10.4867 10.682 10.682C10.4868 10.8772 10.1702 10.8772 9.97493 10.682C9.77967 10.4867 9.77967 10.1701 9.97493 9.97487C10.1702 9.7796 10.4868 9.7796 10.682 9.97487ZM9.26782 11.3891C9.46308 11.5843 9.46308 11.9009 9.26782 12.0962C9.07256 12.2915 8.75598 12.2915 8.56071 12.0962C8.36545 11.9009 8.36545 11.5843 8.56072 11.3891C8.75598 11.1938 9.07256 11.1938 9.26782 11.3891ZM7.1465 13.5104C6.95124 13.3151 6.95124 12.9986 7.1465 12.8033C7.17091 12.7789 7.19721 12.7575 7.22494 12.7392C7.41901 12.6111 7.68275 12.6324 7.85361 12.8033C8.04887 12.9986 8.04887 13.3151 7.85361 13.5104C7.65835 13.7057 7.34176 13.7057 7.1465 13.5104Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.90386 8.56065C2.7086 8.75592 2.7086 9.0725 2.90386 9.26776 3.09912 9.46302 3.41571 9.46302 3.61097 9.26776 3.80623 9.0725 3.80623 8.75592 3.61097 8.56065 3.41571 8.36539 3.09912 8.36539 2.90386 8.56065zM4.31807 9.97487C4.12281 10.1701 4.12281 10.4867 4.31807 10.682 4.51334 10.8772 4.82992 10.8772 5.02518 10.682 5.22044 10.4867 5.22044 10.1701 5.02518 9.97487 4.82992 9.7796 4.51334 9.7796 4.31807 9.97487zM5.73229 11.3891C5.53703 11.5843 5.53703 11.9009 5.73229 12.0962 5.92755 12.2914 6.24413 12.2915 6.43939 12.0962 6.63466 11.9009 6.63466 11.5843 6.43939 11.3891 6.24413 11.1938 5.92755 11.1938 5.73229 11.3891zM2.19675 7.85355C2.36761 7.68269 2.38897 7.41895 2.26082 7.22488 2.09046 6.96684 1.71063 6.92546 1.48965 7.14644 1.29439 7.3417 1.29439 7.65829 1.48965 7.85355 1.68491 8.04881 2.00149 8.04881 2.19675 7.85355zM3.61097 5.73223C3.41571 5.53696 3.09912 5.53696 2.90386 5.73223 2.7086 5.92749 2.7086 6.24407 2.90386 6.43933 3.09912 6.6346 3.41571 6.6346 3.61097 6.43933 3.80623 6.24407 3.80623 5.92749 3.61097 5.73223zM5.02518 4.31801C4.82992 4.12275 4.51334 4.12275 4.31807 4.31801 4.12281 4.51328 4.12281 4.82986 4.31807 5.02512 4.51334 5.22038 4.82992 5.22038 5.02518 5.02512 5.22044 4.82986 5.22044 4.51328 5.02518 4.31801zM6.43939 2.9038C6.24413 2.70854 5.92755 2.70854 5.73229 2.9038 5.53703 3.09906 5.53703 3.41564 5.73229 3.61091 5.92755 3.80617 6.24413 3.80617 6.43939 3.61091 6.63466 3.41564 6.63466 3.09906 6.43939 2.9038zM7.85361 1.48959C7.65835 1.29432 7.34176 1.29432 7.1465 1.48959 6.95124 1.68485 6.95124 2.00143 7.1465 2.19669 7.34176 2.39196 7.65835 2.39196 7.85361 2.19669 8.04887 2.00143 8.04887 1.68485 7.85361 1.48959zM9.26782 2.9038C9.07256 2.70854 8.75598 2.70854 8.56071 2.9038 8.36545 3.09906 8.36545 3.41564 8.56071 3.61091 8.75598 3.80617 9.07256 3.80617 9.26782 3.61091 9.46308 3.41564 9.46308 3.09906 9.26782 2.9038zM10.682 4.31801C10.4868 4.12275 10.1702 4.12275 9.97493 4.31801 9.77967 4.51328 9.77967 4.82986 9.97493 5.02512 10.1702 5.22038 10.4868 5.22038 10.682 5.02512 10.8773 4.82986 10.8773 4.51328 10.682 4.31801zM12.0962 5.73223C11.901 5.53696 11.5844 5.53696 11.3891 5.73223 11.1939 5.92749 11.1939 6.24407 11.3891 6.43933 11.5844 6.6346 11.901 6.6346 12.0962 6.43933 12.2915 6.24407 12.2915 5.92749 12.0962 5.73223z",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1f = [
    "color"
];
var $6431ef21eafb1f5a$export$6d6da6edaddd5876 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1f);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2 1.5C2 1.77614 1.77614 2 1.5 2C1.22386 2 1 1.77614 1 1.5C1 1.22386 1.22386 1 1.5 1C1.77614 1 2 1.22386 2 1.5ZM5 13H10V2L5 2L5 13ZM4 13C4 13.5523 4.44772 14 5 14H10C10.5523 14 11 13.5523 11 13V2C11 1.44772 10.5523 1 10 1H5C4.44772 1 4 1.44771 4 2V13ZM13.5 2C13.7761 2 14 1.77614 14 1.5C14 1.22386 13.7761 1 13.5 1C13.2239 1 13 1.22386 13 1.5C13 1.77614 13.2239 2 13.5 2ZM2 3.5C2 3.77614 1.77614 4 1.5 4C1.22386 4 1 3.77614 1 3.5C1 3.22386 1.22386 3 1.5 3C1.77614 3 2 3.22386 2 3.5ZM13.5 4C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3C13.2239 3 13 3.22386 13 3.5C13 3.77614 13.2239 4 13.5 4ZM2 5.5C2 5.77614 1.77614 6 1.5 6C1.22386 6 1 5.77614 1 5.5C1 5.22386 1.22386 5 1.5 5C1.77614 5 2 5.22386 2 5.5ZM13.5 6C13.7761 6 14 5.77614 14 5.5C14 5.22386 13.7761 5 13.5 5C13.2239 5 13 5.22386 13 5.5C13 5.77614 13.2239 6 13.5 6ZM2 7.5C2 7.77614 1.77614 8 1.5 8C1.22386 8 1 7.77614 1 7.5C1 7.22386 1.22386 7 1.5 7C1.77614 7 2 7.22386 2 7.5ZM13.5 8C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7C13.2239 7 13 7.22386 13 7.5C13 7.77614 13.2239 8 13.5 8ZM2 9.5C2 9.77614 1.77614 10 1.5 10C1.22386 10 1 9.77614 1 9.5C1 9.22386 1.22386 9 1.5 9C1.77614 9 2 9.22386 2 9.5ZM13.5 10C13.7761 10 14 9.77614 14 9.5C14 9.22386 13.7761 9 13.5 9C13.2239 9 13 9.22386 13 9.5C13 9.77614 13.2239 10 13.5 10ZM2 11.5C2 11.7761 1.77614 12 1.5 12C1.22386 12 1 11.7761 1 11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5ZM13.5 12C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11C13.2239 11 13 11.2239 13 11.5C13 11.7761 13.2239 12 13.5 12ZM2 13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5C1 13.2239 1.22386 13 1.5 13C1.77614 13 2 13.2239 2 13.5ZM13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1g = [
    "color"
];
var $6431ef21eafb1f5a$export$4231f341127e9d59 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1g);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M12.0697 1.76746C12.4807 1.21947 11.4605 0.454311 11.0495 1.0023C10.6385 1.55028 11.6588 2.31544 12.0697 1.76746ZM8.39263 1.07811C7.15585 0.950602 5.7823 1.16348 4.58433 1.70937C3.38552 2.25563 2.32735 3.15309 1.78844 4.41832C1.37574 5.38724 1.01715 6.28113 1.00088 7.44354C0.984724 8.59844 1.30522 9.96898 2.13174 11.928C2.61142 13.0649 4.03963 13.5446 5.13895 13.8079C6.40836 14.1119 7.80857 14.1914 8.6644 14.0742C9.36515 13.9782 10.1448 13.8284 10.7987 13.297C11.8977 12.4039 12.9009 11.3955 13.4994 10.3393C14.104 9.27221 14.3256 8.09207 13.7216 6.95324C13.5628 6.65373 13.316 6.57734 13.0412 6.4923C12.9374 6.46016 12.8295 6.42678 12.7209 6.37966C11.6211 5.90234 10.9646 5.34963 10.9135 5.02876C10.8656 4.72808 10.9221 4.51463 10.9811 4.29181C11.0129 4.17199 11.0453 4.04947 11.0626 3.90922C11.0838 3.73737 11.0814 3.33319 10.6996 3.12761C10.4048 2.96888 10.2164 2.65843 10.0407 2.36904C9.99742 2.29775 9.95492 2.22773 9.9118 2.16158C9.62634 1.72367 9.20769 1.16213 8.39263 1.07811ZM4.99899 2.61935C3.96483 3.09058 3.12554 3.83097 2.70846 4.81018C2.29808 5.77368 2.01406 6.50873 2.00079 7.45753C1.98741 8.41385 2.25043 9.6368 3.0531 11.5393C3.39181 12.3421 4.62167 12.6557 5.37186 12.8354C6.5493 13.1174 7.822 13.1802 8.52868 13.0834C9.21271 12.9897 9.74568 12.8642 10.1681 12.5209C11.229 11.6587 12.121 10.7435 12.6293 9.84635C12.9349 9.30709 13.5141 7.7028 12.6292 7.3873C10.7539 6.71875 10.262 6.06669 9.99011 5.41268C9.80915 4.97744 9.82868 4.52282 9.95741 4.07885L9.95741 4.07884C9.97662 4.0126 9.99538 3.94791 10.0334 3.88882C9.81857 3.73676 9.6515 3.55195 9.51464 3.3715C9.42876 3.25828 9.3469 3.12099 9.26197 2.97856C9.01866 2.57052 8.75018 2.12027 8.29008 2.07283C7.22889 1.96343 6.03398 2.14772 4.99899 2.61935ZM13.2081 3.77471C13.441 3.22671 12.4547 2.63606 12.0822 3.10163C11.5817 3.72732 12.9029 4.49281 13.2081 3.77471ZM14.3672 2.26031C14.9668 2.27493 15.1551 1.11603 14.5718 0.949371C13.8076 0.731026 13.5918 2.24139 14.3672 2.26031ZM14.2857 5.09098C14.8644 5.10004 15.0462 4.38222 14.4832 4.27899C13.7455 4.14375 13.5373 5.07927 14.2857 5.09098ZM6.9075 4.28672C6.46898 4.66754 6.0522 4.15185 5.97983 3.7365C5.86848 3.09744 6.33696 2.56856 6.94823 2.91156C7.43344 3.18382 7.26678 3.97471 6.9075 4.28672ZM4.94455 5.88184C5.40885 5.41754 4.59567 4.57013 4.11425 5.05154C3.83338 5.33242 4.00936 5.65376 4.23744 5.88184C4.43271 6.0771 4.74929 6.0771 4.94455 5.88184ZM6.97716 6.71984C7.31181 7.38914 8.48804 6.79159 7.99413 6.14788C7.86519 5.97983 7.68657 5.9494 7.62145 5.94207C7.21217 5.89601 6.76349 6.2925 6.97716 6.71984ZM6.98798 8.72461C7.14066 9.1188 7.51122 9.3187 7.91915 9.1633C8.27434 9.02799 8.33186 8.39689 8.17175 8.07427C8.02331 7.77514 7.63956 7.67793 7.33747 7.79417C6.98512 7.92976 6.85672 8.38708 6.98576 8.71889L6.98798 8.72461ZM10.3885 8.84081C10.7575 8.6566 11.4617 8.82771 11.4617 9.31199C11.4617 9.71286 10.9587 10.2165 10.5634 10.2826C10.1813 10.3465 9.70515 9.97581 9.76648 9.57718C9.81445 9.26539 10.1217 8.97401 10.3885 8.84081ZM7.56704 10.8432C7.33461 10.7502 7.14353 10.8601 7.11437 10.8769L7.11279 10.8778C6.90782 10.9949 6.71383 11.2439 6.6747 11.4842C6.59018 12.0034 7.13199 12.1239 7.52661 12.0987C8.2074 12.0553 8.06547 11.0426 7.56704 10.8432ZM4.8805 10.8932C5.0674 10.7723 5.15658 10.5363 5.08293 10.3153C4.93046 9.79687 4.3246 9.71252 3.96561 10.1297C3.79336 10.3299 3.80749 10.6274 3.99214 10.8105L3.99495 10.814L3.9979 10.8176C4.22025 11.0942 4.63624 11.1857 4.8805 10.8932ZM3.04695 7.81318C3.33147 8.0977 3.60077 8.15067 3.98443 8.05859C4.60826 7.90887 4.13814 6.24299 3.047 6.87296C2.70939 7.06788 2.86716 7.63339 3.04695 7.81318Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1h = [
    "color"
];
var $6431ef21eafb1f5a$export$51b6cd98f8778f0d = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1h);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1 9.50006C1 10.3285 1.67157 11.0001 2.5 11.0001H4L4 10.0001H2.5C2.22386 10.0001 2 9.7762 2 9.50006L2 2.50006C2 2.22392 2.22386 2.00006 2.5 2.00006L9.5 2.00006C9.77614 2.00006 10 2.22392 10 2.50006V4.00002H5.5C4.67158 4.00002 4 4.67159 4 5.50002V12.5C4 13.3284 4.67158 14 5.5 14H12.5C13.3284 14 14 13.3284 14 12.5V5.50002C14 4.67159 13.3284 4.00002 12.5 4.00002H11V2.50006C11 1.67163 10.3284 1.00006 9.5 1.00006H2.5C1.67157 1.00006 1 1.67163 1 2.50006V9.50006ZM5 5.50002C5 5.22388 5.22386 5.00002 5.5 5.00002H12.5C12.7761 5.00002 13 5.22388 13 5.50002V12.5C13 12.7762 12.7761 13 12.5 13H5.5C5.22386 13 5 12.7762 5 12.5V5.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1i = [
    "color"
];
var $6431ef21eafb1f5a$export$53250eb5c8bd1390 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1i);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M9.87737 12H9.9H11.5C11.7761 12 12 11.7761 12 11.5C12 11.2239 11.7761 11 11.5 11H9.9C8.77164 11 7.95545 10.9996 7.31352 10.9472C6.67744 10.8952 6.25662 10.7946 5.91103 10.6185C5.25247 10.283 4.71703 9.74753 4.38148 9.08897C4.20539 8.74338 4.10481 8.32256 4.05284 7.68648C4.00039 7.04455 4 6.22836 4 5.1V3.5C4 3.22386 3.77614 3 3.5 3C3.22386 3 3 3.22386 3 3.5V5.1V5.12263C3 6.22359 3 7.08052 3.05616 7.76791C3.11318 8.46584 3.23058 9.0329 3.49047 9.54296C3.9219 10.3897 4.61031 11.0781 5.45704 11.5095C5.9671 11.7694 6.53416 11.8868 7.23209 11.9438C7.91948 12 8.77641 12 9.87737 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1j = [
    "color"
];
var $6431ef21eafb1f5a$export$13d7020d49a403c9 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1j);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5.12263 12H5.1H3.5C3.22386 12 3 11.7761 3 11.5C3 11.2239 3.22386 11 3.5 11H5.1C6.22836 11 7.04455 10.9996 7.68648 10.9472C8.32256 10.8952 8.74338 10.7946 9.08897 10.6185C9.74753 10.283 10.283 9.74753 10.6185 9.08897C10.7946 8.74338 10.8952 8.32256 10.9472 7.68648C10.9996 7.04455 11 6.22836 11 5.1V3.5C11 3.22386 11.2239 3 11.5 3C11.7761 3 12 3.22386 12 3.5V5.1V5.12263C12 6.22359 12 7.08052 11.9438 7.76791C11.8868 8.46584 11.7694 9.0329 11.5095 9.54296C11.0781 10.3897 10.3897 11.0781 9.54296 11.5095C9.0329 11.7694 8.46584 11.8868 7.76791 11.9438C7.08052 12 6.22359 12 5.12263 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1k = [
    "color"
];
var $6431ef21eafb1f5a$export$e709160419ee2246 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1k);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M9.87737 3H9.9H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H9.9C8.77164 4 7.95545 4.00039 7.31352 4.05284C6.67744 4.10481 6.25662 4.20539 5.91103 4.38148C5.25247 4.71703 4.71703 5.25247 4.38148 5.91103C4.20539 6.25662 4.10481 6.67744 4.05284 7.31352C4.00039 7.95545 4 8.77164 4 9.9V11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5V9.9V9.87737C3 8.77641 3 7.91948 3.05616 7.23209C3.11318 6.53416 3.23058 5.9671 3.49047 5.45704C3.9219 4.61031 4.61031 3.9219 5.45704 3.49047C5.9671 3.23058 6.53416 3.11318 7.23209 3.05616C7.91948 3 8.77641 3 9.87737 3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1l = [
    "color"
];
var $6431ef21eafb1f5a$export$8e3e82083a0db3ff = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1l);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5.12263 3H5.1H3.5C3.22386 3 3 3.22386 3 3.5C3 3.77614 3.22386 4 3.5 4H5.1C6.22836 4 7.04455 4.00039 7.68648 4.05284C8.32256 4.10481 8.74338 4.20539 9.08897 4.38148C9.74753 4.71703 10.283 5.25247 10.6185 5.91103C10.7946 6.25662 10.8952 6.67744 10.9472 7.31352C10.9996 7.95545 11 8.77164 11 9.9V11.5C11 11.7761 11.2239 12 11.5 12C11.7761 12 12 11.7761 12 11.5V9.9V9.87737C12 8.77641 12 7.91948 11.9438 7.23209C11.8868 6.53416 11.7694 5.9671 11.5095 5.45704C11.0781 4.61031 10.3897 3.9219 9.54296 3.49047C9.0329 3.23058 8.46584 3.11318 7.76791 3.05616C7.08052 3 6.22359 3 5.12263 3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1m = [
    "color"
];
var $6431ef21eafb1f5a$export$3473a9c28d168741 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1m);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5.5 2L4.87935 2C4.47687 1.99999 4.14469 1.99999 3.87409 2.0221C3.59304 2.04506 3.33469 2.09434 3.09202 2.21799C2.7157 2.40973 2.40973 2.7157 2.21799 3.09202C2.09434 3.33469 2.04506 3.59304 2.0221 3.87409C1.99999 4.14468 1.99999 4.47686 2 4.87933V4.87935V5.5C2 5.77614 2.22386 6 2.5 6C2.77614 6 3 5.77614 3 5.5V4.9C3 4.47171 3.00039 4.18056 3.01878 3.95552C3.03669 3.73631 3.06915 3.62421 3.10899 3.54601C3.20487 3.35785 3.35785 3.20487 3.54601 3.10899C3.62421 3.06915 3.73631 3.03669 3.95552 3.01878C4.18056 3.00039 4.47171 3 4.9 3H5.5C5.77614 3 6 2.77614 6 2.5C6 2.22386 5.77614 2 5.5 2ZM13 9.5C13 9.22386 12.7761 9 12.5 9C12.2239 9 12 9.22386 12 9.5V10.1C12 10.5283 11.9996 10.8194 11.9812 11.0445C11.9633 11.2637 11.9309 11.3758 11.891 11.454C11.7951 11.6422 11.6422 11.7951 11.454 11.891C11.3758 11.9309 11.2637 11.9633 11.0445 11.9812C10.8194 11.9996 10.5283 12 10.1 12H9.5C9.22386 12 9 12.2239 9 12.5C9 12.7761 9.22386 13 9.5 13H10.1206C10.5231 13 10.8553 13 11.1259 12.9779C11.407 12.9549 11.6653 12.9057 11.908 12.782C12.2843 12.5903 12.5903 12.2843 12.782 11.908C12.9057 11.6653 12.9549 11.407 12.9779 11.1259C13 10.8553 13 10.5232 13 10.1207V10.1207V10.1207V10.1206V9.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V10.1C3 10.5283 3.00039 10.8194 3.01878 11.0445C3.03669 11.2637 3.06915 11.3758 3.10899 11.454C3.20487 11.6422 3.35785 11.7951 3.54601 11.891C3.62421 11.9309 3.73631 11.9633 3.95552 11.9812C4.18056 11.9996 4.47171 12 4.9 12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H4.87935C4.47687 13 4.14469 13 3.87409 12.9779C3.59304 12.9549 3.33469 12.9057 3.09202 12.782C2.7157 12.5903 2.40973 12.2843 2.21799 11.908C2.09434 11.6653 2.04506 11.407 2.0221 11.1259C1.99999 10.8553 1.99999 10.5231 2 10.1207V10.1206V10.1V9.5C2 9.22386 2.22386 9 2.5 9ZM10.1 3C10.5283 3 10.8194 3.00039 11.0445 3.01878C11.2637 3.03669 11.3758 3.06915 11.454 3.10899C11.6422 3.20487 11.7951 3.35785 11.891 3.54601C11.9309 3.62421 11.9633 3.73631 11.9812 3.95552C11.9996 4.18056 12 4.47171 12 4.9V5.5C12 5.77614 12.2239 6 12.5 6C12.7761 6 13 5.77614 13 5.5V4.87935V4.87934C13 4.47686 13 4.14468 12.9779 3.87409C12.9549 3.59304 12.9057 3.33469 12.782 3.09202C12.5903 2.7157 12.2843 2.40973 11.908 2.21799C11.6653 2.09434 11.407 2.04506 11.1259 2.0221C10.8553 1.99999 10.5231 1.99999 10.1206 2L10.1 2H9.5C9.22386 2 9 2.22386 9 2.5C9 2.77614 9.22386 3 9.5 3H10.1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1n = [
    "color"
];
var $6431ef21eafb1f5a$export$d947354b0bb44dfa = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1n);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.7217 1.84998 3.34851 3.90636 2.76336 4.99997H4.5C4.77614 4.99997 5 5.22383 5 5.49997C5 5.77611 4.77614 5.99997 4.5 5.99997H1.5C1.22386 5.99997 1 5.77611 1 5.49997V2.49997C1 2.22383 1.22386 1.99997 1.5 1.99997C1.77614 1.99997 2 2.22383 2 2.49997V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7 10V5.00001H8V10H7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1o = [
    "color"
];
var $6431ef21eafb1f5a$export$92a2757a17018399 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1o);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.72167 1.84998 3.34849 3.9064 2.76335 5H4.5C4.77614 5 5 5.22386 5 5.5C5 5.77614 4.77614 6 4.5 6H1.5C1.22386 6 1 5.77614 1 5.5V2.5C1 2.22386 1.22386 2 1.5 2C1.77614 2 2 2.22386 2 2.5V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7.5 4.00001C7.77614 4.00001 8 4.22387 8 4.50001V7.29291L9.85355 9.14646C10.0488 9.34172 10.0488 9.65831 9.85355 9.85357C9.65829 10.0488 9.34171 10.0488 9.14645 9.85357L7.14645 7.85357C7.05268 7.7598 7 7.63262 7 7.50001V4.50001C7 4.22387 7.22386 4.00001 7.5 4.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1p = [
    "color"
];
var $6431ef21eafb1f5a$export$9816aad82d905e6 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1p);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.5 8.00684e-07C3.77614 7.88614e-07 4 0.223859 4 0.500001L4 3.00006L11.5 3.00006C11.7761 3.00006 12 3.22392 12 3.50006L12 11.0001L14.5 11C14.7761 11 15 11.2238 15 11.5C15 11.7761 14.7762 12 14.5 12L12 12.0001L12 14.5C12 14.7761 11.7761 15 11.5 15C11.2239 15 11 14.7761 11 14.5L11 12.0001L3.5 12.0001C3.22386 12.0001 3 11.7762 3 11.5001L3 4.00005L0.499989 4C0.223847 4 -6.10541e-06 3.77613 -5.02576e-07 3.49999C5.13006e-06 3.22385 0.223867 3 0.50001 3L3 3.00005L3 0.500001C3 0.223859 3.22386 8.12755e-07 3.5 8.00684e-07ZM4 4.00006L4 11.0001L11 11.0001L11 4.00006L4 4.00006Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1q = [
    "color"
];
var $6431ef21eafb1f5a$export$8c97d895bfadca90 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1q);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M12.8536 2.85355C13.0488 2.65829 13.0488 2.34171 12.8536 2.14645C12.6583 1.95118 12.3417 1.95118 12.1464 2.14645L7.5 6.79289L2.85355 2.14645C2.65829 1.95118 2.34171 1.95118 2.14645 2.14645C1.95118 2.34171 1.95118 2.65829 2.14645 2.85355L6.79289 7.5L2.14645 12.1464C1.95118 12.3417 1.95118 12.6583 2.14645 12.8536C2.34171 13.0488 2.65829 13.0488 2.85355 12.8536L7.5 8.20711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L8.20711 7.5L12.8536 2.85355Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1r = [
    "color"
];
var $6431ef21eafb1f5a$export$b7fa469a3cb3cd4f = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1r);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1s = [
    "color"
];
var $6431ef21eafb1f5a$export$8710c0d3947fcfc3 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1s);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704ZM9.85358 5.14644C10.0488 5.3417 10.0488 5.65829 9.85358 5.85355L8.20713 7.49999L9.85358 9.14644C10.0488 9.3417 10.0488 9.65829 9.85358 9.85355C9.65832 10.0488 9.34173 10.0488 9.14647 9.85355L7.50002 8.2071L5.85358 9.85355C5.65832 10.0488 5.34173 10.0488 5.14647 9.85355C4.95121 9.65829 4.95121 9.3417 5.14647 9.14644L6.79292 7.49999L5.14647 5.85355C4.95121 5.65829 4.95121 5.3417 5.14647 5.14644C5.34173 4.95118 5.65832 4.95118 5.85358 5.14644L7.50002 6.79289L9.14647 5.14644C9.34173 4.95118 9.65832 4.95118 9.85358 5.14644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1t = [
    "color"
];
var $6431ef21eafb1f5a$export$d5c5855fccded9fe = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1t);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.877075 7.50207C0.877075 3.84319 3.84319 0.877075 7.50208 0.877075C11.1609 0.877075 14.1271 3.84319 14.1271 7.50207C14.1271 11.1609 11.1609 14.1271 7.50208 14.1271C3.84319 14.1271 0.877075 11.1609 0.877075 7.50207ZM1.84898 7.00003C2.0886 4.26639 4.26639 2.0886 7.00003 1.84898V4.50003C7.00003 4.77617 7.22388 5.00003 7.50003 5.00003C7.77617 5.00003 8.00003 4.77617 8.00003 4.50003V1.84862C10.7356 2.08643 12.9154 4.26502 13.1552 7.00003H10.5C10.2239 7.00003 10 7.22388 10 7.50003C10 7.77617 10.2239 8.00003 10.5 8.00003H13.1555C12.9176 10.7369 10.7369 12.9176 8.00003 13.1555V10.5C8.00003 10.2239 7.77617 10 7.50003 10C7.22388 10 7.00003 10.2239 7.00003 10.5V13.1552C4.26502 12.9154 2.08643 10.7356 1.84862 8.00003H4.50003C4.77617 8.00003 5.00003 7.77617 5.00003 7.50003C5.00003 7.22388 4.77617 7.00003 4.50003 7.00003H1.84898Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1u = [
    "color"
];
var $6431ef21eafb1f5a$export$d0fffbce0e008b09 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1u);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.5 0C7.77614 0 8 0.223858 8 0.5V1.80687C10.6922 2.0935 12.8167 4.28012 13.0068 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H12.9888C12.7094 10.6244 10.6244 12.7094 8 12.9888V14.5C8 14.7761 7.77614 15 7.5 15C7.22386 15 7 14.7761 7 14.5V13.0068C4.28012 12.8167 2.0935 10.6922 1.80687 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H1.78886C1.98376 4.21166 4.21166 1.98376 7 1.78886V0.5C7 0.223858 7.22386 0 7.5 0ZM8 12.0322V9.5C8 9.22386 7.77614 9 7.5 9C7.22386 9 7 9.22386 7 9.5V12.054C4.80517 11.8689 3.04222 10.1668 2.76344 8H5.5C5.77614 8 6 7.77614 6 7.5C6 7.22386 5.77614 7 5.5 7H2.7417C2.93252 4.73662 4.73662 2.93252 7 2.7417V5.5C7 5.77614 7.22386 6 7.5 6C7.77614 6 8 5.77614 8 5.5V2.76344C10.1668 3.04222 11.8689 4.80517 12.054 7H9.5C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8H12.0322C11.7621 10.0991 10.0991 11.7621 8 12.0322Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1v = [
    "color"
];
var $6431ef21eafb1f5a$export$18abdbf97bad2a11 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1v);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.60913 0.0634287C4.39082 0.0088505 4.16575 0.12393 4.08218 0.332867L3.1538 2.6538L0.832866 3.58218C0.702884 3.63417 0.604504 3.7437 0.566705 3.87849C0.528906 4.01329 0.555994 4.158 0.639992 4.26999L2.01148 6.09864L1.06343 9.89085C1.00944 10.1068 1.12145 10.3298 1.32691 10.4154L4.20115 11.613L5.62557 13.7496C5.73412 13.9124 5.93545 13.9864 6.12362 13.9327L9.62362 12.9327C9.62988 12.9309 9.63611 12.929 9.64229 12.9269L12.6423 11.9269C12.7923 11.8769 12.905 11.7519 12.9393 11.5976L13.9393 7.09761C13.9776 6.92506 13.9114 6.74605 13.77 6.63999L11.95 5.27499V2.99999C11.95 2.82955 11.8537 2.67373 11.7012 2.5975L8.70124 1.0975C8.67187 1.08282 8.64098 1.07139 8.60913 1.06343L4.60913 0.0634287ZM11.4323 6.01173L12.7748 7.01858L10.2119 9.15429C10.1476 9.20786 10.0995 9.2783 10.0731 9.35769L9.25382 11.8155L7.73849 10.8684C7.52774 10.7367 7.25011 10.8007 7.11839 11.0115C6.98667 11.2222 7.05074 11.4999 7.26149 11.6316L8.40341 12.3453L6.19221 12.9771L4.87441 11.0004C4.82513 10.9265 4.75508 10.8688 4.67307 10.8346L2.03046 9.73352L2.85134 6.44999H4.99999C5.24852 6.44999 5.44999 6.24852 5.44999 5.99999C5.44999 5.75146 5.24852 5.54999 4.99999 5.54999H2.72499L1.7123 4.19974L3.51407 3.47903L6.35769 4.4269C6.53655 4.48652 6.73361 4.42832 6.85138 4.28111L8.62413 2.06518L11.05 3.27811V5.19533L8.83287 6.08218C8.70996 6.13134 8.61494 6.23212 8.57308 6.35769L8.07308 7.85769C7.99449 8.09346 8.12191 8.34831 8.35769 8.4269C8.59346 8.50549 8.84831 8.37807 8.9269 8.14229L9.3609 6.84029L11.4323 6.01173ZM7.71052 1.76648L6.34462 3.47386L4.09505 2.724L4.77192 1.03183L7.71052 1.76648ZM10.2115 11.7885L12.116 11.1537L12.7745 8.19034L10.8864 9.76374L10.2115 11.7885Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1w = [
    "color"
];
var $6431ef21eafb1f5a$export$315ae6298b7de94 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1w);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1x = [
    "color"
];
var $6431ef21eafb1f5a$export$4e8767be554cec68 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1x);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.29227 0.048984C3.47033 -0.032338 3.67946 -0.00228214 3.8274 0.125891L12.8587 7.95026C13.0134 8.08432 13.0708 8.29916 13.0035 8.49251C12.9362 8.68586 12.7578 8.81866 12.5533 8.82768L9.21887 8.97474L11.1504 13.2187C11.2648 13.47 11.1538 13.7664 10.9026 13.8808L8.75024 14.8613C8.499 14.9758 8.20255 14.8649 8.08802 14.6137L6.15339 10.3703L3.86279 12.7855C3.72196 12.934 3.50487 12.9817 3.31479 12.9059C3.1247 12.8301 3 12.6461 3 12.4414V0.503792C3 0.308048 3.11422 0.130306 3.29227 0.048984ZM4 1.59852V11.1877L5.93799 9.14425C6.05238 9.02363 6.21924 8.96776 6.38319 8.99516C6.54715 9.02256 6.68677 9.12965 6.75573 9.2809L8.79056 13.7441L10.0332 13.178L8.00195 8.71497C7.93313 8.56376 7.94391 8.38824 8.03072 8.24659C8.11753 8.10494 8.26903 8.01566 8.435 8.00834L11.2549 7.88397L4 1.59852Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1y = [
    "color"
];
var $6431ef21eafb1f5a$export$d665abe9390574dd = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1y);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2C5.42215 2 6.0399 2.23054 6.42075 2.56379C6.79286 2.88939 7 3.36626 7 4V7H5.75C5.47386 7 5.25 7.22386 5.25 7.5C5.25 7.77614 5.47386 8 5.75 8H7V11C7 11.6337 6.79286 12.1106 6.42075 12.4362C6.0399 12.7695 5.42215 13 4.5 13C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14C5.57785 14 6.4601 13.7305 7.07925 13.1888C7.24168 13.0467 7.38169 12.8896 7.5 12.7198C7.61832 12.8896 7.75832 13.0467 7.92075 13.1888C8.5399 13.7305 9.42215 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.57785 13 8.9601 12.7695 8.57925 12.4362C8.20714 12.1106 8 11.6337 8 11V8H9.25C9.52614 8 9.75 7.77614 9.75 7.5C9.75 7.22386 9.52614 7 9.25 7H8V4C8 3.36626 8.20714 2.88939 8.57925 2.56379C8.9601 2.23054 9.57785 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.42215 1 8.5399 1.26946 7.92075 1.81121C7.75832 1.95333 7.61832 2.11043 7.5 2.28023C7.38168 2.11043 7.24168 1.95333 7.07925 1.81121C6.4601 1.26946 5.57785 1 4.5 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1z = [
    "color"
];
var $6431ef21eafb1f5a$export$a2bc8cb49334c5d1 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1z);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5 7.5C5 7.22386 5.22386 7 5.5 7H9.5C9.77614 7 10 7.22386 10 7.5C10 7.77614 9.77614 8 9.5 8H5.5C5.22386 8 5 7.77614 5 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1A = [
    "color"
];
var $6431ef21eafb1f5a$export$8fd9d8340b1bb79a = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1A);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.8 1L2.74967 0.99997C2.52122 0.999752 2.32429 0.999564 2.14983 1.04145C1.60136 1.17312 1.17312 1.60136 1.04145 2.14983C0.999564 2.32429 0.999752 2.52122 0.99997 2.74967L1 2.8V5.2L0.99997 5.25033C0.999752 5.47878 0.999564 5.67572 1.04145 5.85017C1.17312 6.39864 1.60136 6.82688 2.14983 6.95856C2.32429 7.00044 2.52122 7.00025 2.74967 7.00003L2.8 7H5.2L5.25033 7.00003C5.47878 7.00025 5.67572 7.00044 5.85017 6.95856C6.39864 6.82688 6.82688 6.39864 6.95856 5.85017C7.00044 5.67572 7.00025 5.47878 7.00003 5.25033L7 5.2V2.8L7.00003 2.74967C7.00025 2.52122 7.00044 2.32429 6.95856 2.14983C6.82688 1.60136 6.39864 1.17312 5.85017 1.04145C5.67572 0.999564 5.47878 0.999752 5.25033 0.99997L5.2 1H2.8ZM2.38328 2.01382C2.42632 2.00348 2.49222 2 2.8 2H5.2C5.50779 2 5.57369 2.00348 5.61672 2.01382C5.79955 2.05771 5.94229 2.20045 5.98619 2.38328C5.99652 2.42632 6 2.49222 6 2.8V5.2C6 5.50779 5.99652 5.57369 5.98619 5.61672C5.94229 5.79955 5.79955 5.94229 5.61672 5.98619C5.57369 5.99652 5.50779 6 5.2 6H2.8C2.49222 6 2.42632 5.99652 2.38328 5.98619C2.20045 5.94229 2.05771 5.79955 2.01382 5.61672C2.00348 5.57369 2 5.50779 2 5.2V2.8C2 2.49222 2.00348 2.42632 2.01382 2.38328C2.05771 2.20045 2.20045 2.05771 2.38328 2.01382ZM9.8 1L9.74967 0.99997C9.52122 0.999752 9.32429 0.999564 9.14983 1.04145C8.60136 1.17312 8.17312 1.60136 8.04145 2.14983C7.99956 2.32429 7.99975 2.52122 7.99997 2.74967L8 2.8V5.2L7.99997 5.25033C7.99975 5.47878 7.99956 5.67572 8.04145 5.85017C8.17312 6.39864 8.60136 6.82688 9.14983 6.95856C9.32429 7.00044 9.52122 7.00025 9.74967 7.00003L9.8 7H12.2L12.2503 7.00003C12.4788 7.00025 12.6757 7.00044 12.8502 6.95856C13.3986 6.82688 13.8269 6.39864 13.9586 5.85017C14.0004 5.67572 14.0003 5.47878 14 5.25033L14 5.2V2.8L14 2.74967C14.0003 2.52122 14.0004 2.32429 13.9586 2.14983C13.8269 1.60136 13.3986 1.17312 12.8502 1.04145C12.6757 0.999564 12.4788 0.999752 12.2503 0.99997L12.2 1H9.8ZM9.38328 2.01382C9.42632 2.00348 9.49222 2 9.8 2H12.2C12.5078 2 12.5737 2.00348 12.6167 2.01382C12.7995 2.05771 12.9423 2.20045 12.9862 2.38328C12.9965 2.42632 13 2.49222 13 2.8V5.2C13 5.50779 12.9965 5.57369 12.9862 5.61672C12.9423 5.79955 12.7995 5.94229 12.6167 5.98619C12.5737 5.99652 12.5078 6 12.2 6H9.8C9.49222 6 9.42632 5.99652 9.38328 5.98619C9.20045 5.94229 9.05771 5.79955 9.01382 5.61672C9.00348 5.57369 9 5.50779 9 5.2V2.8C9 2.49222 9.00348 2.42632 9.01382 2.38328C9.05771 2.20045 9.20045 2.05771 9.38328 2.01382ZM2.74967 7.99997L2.8 8H5.2L5.25033 7.99997C5.47878 7.99975 5.67572 7.99956 5.85017 8.04145C6.39864 8.17312 6.82688 8.60136 6.95856 9.14983C7.00044 9.32429 7.00025 9.52122 7.00003 9.74967L7 9.8V12.2L7.00003 12.2503C7.00025 12.4788 7.00044 12.6757 6.95856 12.8502C6.82688 13.3986 6.39864 13.8269 5.85017 13.9586C5.67572 14.0004 5.47878 14.0003 5.25033 14L5.2 14H2.8L2.74967 14C2.52122 14.0003 2.32429 14.0004 2.14983 13.9586C1.60136 13.8269 1.17312 13.3986 1.04145 12.8502C0.999564 12.6757 0.999752 12.4788 0.99997 12.2503L1 12.2V9.8L0.99997 9.74967C0.999752 9.52122 0.999564 9.32429 1.04145 9.14983C1.17312 8.60136 1.60136 8.17312 2.14983 8.04145C2.32429 7.99956 2.52122 7.99975 2.74967 7.99997ZM2.8 9C2.49222 9 2.42632 9.00348 2.38328 9.01382C2.20045 9.05771 2.05771 9.20045 2.01382 9.38328C2.00348 9.42632 2 9.49222 2 9.8V12.2C2 12.5078 2.00348 12.5737 2.01382 12.6167C2.05771 12.7995 2.20045 12.9423 2.38328 12.9862C2.42632 12.9965 2.49222 13 2.8 13H5.2C5.50779 13 5.57369 12.9965 5.61672 12.9862C5.79955 12.9423 5.94229 12.7995 5.98619 12.6167C5.99652 12.5737 6 12.5078 6 12.2V9.8C6 9.49222 5.99652 9.42632 5.98619 9.38328C5.94229 9.20045 5.79955 9.05771 5.61672 9.01382C5.57369 9.00348 5.50779 9 5.2 9H2.8ZM9.8 8L9.74967 7.99997C9.52122 7.99975 9.32429 7.99956 9.14983 8.04145C8.60136 8.17312 8.17312 8.60136 8.04145 9.14983C7.99956 9.32429 7.99975 9.52122 7.99997 9.74967L8 9.8V12.2L7.99997 12.2503C7.99975 12.4788 7.99956 12.6757 8.04145 12.8502C8.17312 13.3986 8.60136 13.8269 9.14983 13.9586C9.32429 14.0004 9.52122 14.0003 9.74967 14L9.8 14H12.2L12.2503 14C12.4788 14.0003 12.6757 14.0004 12.8502 13.9586C13.3986 13.8269 13.8269 13.3986 13.9586 12.8502C14.0004 12.6757 14.0003 12.4788 14 12.2503L14 12.2V9.8L14 9.74967C14.0003 9.52122 14.0004 9.32429 13.9586 9.14983C13.8269 8.60136 13.3986 8.17312 12.8502 8.04145C12.6757 7.99956 12.4788 7.99975 12.2503 7.99997L12.2 8H9.8ZM9.38328 9.01382C9.42632 9.00348 9.49222 9 9.8 9H12.2C12.5078 9 12.5737 9.00348 12.6167 9.01382C12.7995 9.05771 12.9423 9.20045 12.9862 9.38328C12.9965 9.42632 13 9.49222 13 9.8V12.2C13 12.5078 12.9965 12.5737 12.9862 12.6167C12.9423 12.7995 12.7995 12.9423 12.6167 12.9862C12.5737 12.9965 12.5078 13 12.2 13H9.8C9.49222 13 9.42632 12.9965 9.38328 12.9862C9.20045 12.9423 9.05771 12.7995 9.01382 12.6167C9.00348 12.5737 9 12.5078 9 12.2V9.8C9 9.49222 9.00348 9.42632 9.01382 9.38328C9.05771 9.20045 9.20045 9.05771 9.38328 9.01382Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1B = [
    "color"
];
var $6431ef21eafb1f5a$export$78a6319cfd8cd037 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1B);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1 3.25C1 3.11193 1.11193 3 1.25 3H13.75C13.8881 3 14 3.11193 14 3.25V10.75C14 10.8881 13.8881 11 13.75 11H1.25C1.11193 11 1 10.8881 1 10.75V3.25ZM1.25 2C0.559643 2 0 2.55964 0 3.25V10.75C0 11.4404 0.559644 12 1.25 12H5.07341L4.82991 13.2986C4.76645 13.6371 5.02612 13.95 5.37049 13.95H9.62951C9.97389 13.95 10.2336 13.6371 10.1701 13.2986L9.92659 12H13.75C14.4404 12 15 11.4404 15 10.75V3.25C15 2.55964 14.4404 2 13.75 2H1.25ZM9.01091 12H5.98909L5.79222 13.05H9.20778L9.01091 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1C = [
    "color"
];
var $6431ef21eafb1f5a$export$63405b713b830f28 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1C);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1D = [
    "color"
];
var $6431ef21eafb1f5a$export$e9e14b59da099a2a = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1D);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49991 0.877075C3.84222 0.877075 0.877075 3.84222 0.877075 7.49991C0.877075 11.1576 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1576 14.1227 7.49991C14.1227 3.84222 11.1576 0.877075 7.49991 0.877075ZM1.82708 7.49991C1.82708 4.36689 4.36689 1.82707 7.49991 1.82707C10.6329 1.82707 13.1727 4.36689 13.1727 7.49991C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49991ZM8.37287 7.50006C8.37287 7.98196 7.98221 8.37263 7.5003 8.37263C7.01839 8.37263 6.62773 7.98196 6.62773 7.50006C6.62773 7.01815 7.01839 6.62748 7.5003 6.62748C7.98221 6.62748 8.37287 7.01815 8.37287 7.50006ZM9.32287 7.50006C9.32287 8.50664 8.50688 9.32263 7.5003 9.32263C6.49372 9.32263 5.67773 8.50664 5.67773 7.50006C5.67773 6.49348 6.49372 5.67748 7.5003 5.67748C8.50688 5.67748 9.32287 6.49348 9.32287 7.50006Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1E = [
    "color"
];
var $6431ef21eafb1f5a$export$bf776c57f6d5a7c1 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1E);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.07451 1.82584C5.03267 1.81926 4.99014 1.81825 4.94803 1.82284C4.10683 1.91446 2.82673 2.36828 2.07115 2.77808C2.02106 2.80525 1.97621 2.84112 1.93869 2.88402C1.62502 3.24266 1.34046 3.82836 1.11706 4.38186C0.887447 4.95076 0.697293 5.55032 0.588937 5.98354C0.236232 7.39369 0.042502 9.08728 0.0174948 10.6925C0.0162429 10.7729 0.0351883 10.8523 0.0725931 10.9234C0.373679 11.496 1.02015 12.027 1.66809 12.4152C2.32332 12.8078 3.08732 13.1182 3.70385 13.1778C3.85335 13.1922 4.00098 13.1358 4.10282 13.0255C4.2572 12.8581 4.5193 12.4676 4.71745 12.1643C4.80739 12.0267 4.89157 11.8953 4.95845 11.7901C5.62023 11.9106 6.45043 11.9801 7.50002 11.9801C8.54844 11.9801 9.37796 11.9107 10.0394 11.7905C10.1062 11.8957 10.1903 12.0269 10.2801 12.1643C10.4783 12.4676 10.7404 12.8581 10.8947 13.0255C10.9966 13.1358 11.1442 13.1922 11.2937 13.1778C11.9102 13.1182 12.6742 12.8078 13.3295 12.4152C13.9774 12.027 14.6239 11.496 14.925 10.9234C14.9624 10.8523 14.9813 10.7729 14.9801 10.6925C14.9551 9.08728 14.7613 7.39369 14.4086 5.98354C14.3003 5.55032 14.1101 4.95076 13.8805 4.38186C13.6571 3.82836 13.3725 3.24266 13.0589 2.88402C13.0214 2.84112 12.9765 2.80525 12.9264 2.77808C12.1708 2.36828 10.8907 1.91446 10.0495 1.82284C10.0074 1.81825 9.96489 1.81926 9.92305 1.82584C9.71676 1.85825 9.5391 1.96458 9.40809 2.06355C9.26977 2.16804 9.1413 2.29668 9.0304 2.42682C8.86968 2.61544 8.71437 2.84488 8.61428 3.06225C8.27237 3.03501 7.90138 3.02 7.5 3.02C7.0977 3.02 6.72593 3.03508 6.38337 3.06244C6.28328 2.84501 6.12792 2.61549 5.96716 2.42682C5.85626 2.29668 5.72778 2.16804 5.58947 2.06355C5.45846 1.96458 5.2808 1.85825 5.07451 1.82584ZM11.0181 11.5382C11.0395 11.5713 11.0615 11.6051 11.0838 11.6392C11.2169 11.843 11.3487 12.0385 11.4508 12.1809C11.8475 12.0916 12.352 11.8818 12.8361 11.5917C13.3795 11.2661 13.8098 10.8918 14.0177 10.5739C13.9852 9.06758 13.7993 7.50369 13.4773 6.21648C13.38 5.82759 13.2038 5.27021 12.9903 4.74117C12.7893 4.24326 12.5753 3.82162 12.388 3.5792C11.7376 3.24219 10.7129 2.88582 10.0454 2.78987C10.0308 2.79839 10.0113 2.81102 9.98675 2.82955C9.91863 2.881 9.84018 2.95666 9.76111 3.04945C9.71959 3.09817 9.68166 3.1471 9.64768 3.19449C9.953 3.25031 10.2253 3.3171 10.4662 3.39123C11.1499 3.6016 11.6428 3.89039 11.884 4.212C12.0431 4.42408 12.0001 4.72494 11.788 4.884C11.5759 5.04306 11.2751 5.00008 11.116 4.788C11.0572 4.70961 10.8001 4.4984 10.1838 4.30877C9.58933 4.12585 8.71356 3.98 7.5 3.98C6.28644 3.98 5.41067 4.12585 4.81616 4.30877C4.19988 4.4984 3.94279 4.70961 3.884 4.788C3.72494 5.00008 3.42408 5.04306 3.212 4.884C2.99992 4.72494 2.95694 4.42408 3.116 4.212C3.35721 3.89039 3.85011 3.6016 4.53383 3.39123C4.77418 3.31727 5.04571 3.25062 5.35016 3.19488C5.31611 3.14738 5.27808 3.09831 5.23645 3.04945C5.15738 2.95666 5.07893 2.881 5.01081 2.82955C4.98628 2.81102 4.96674 2.79839 4.95217 2.78987C4.28464 2.88582 3.25999 3.24219 2.60954 3.5792C2.42226 3.82162 2.20825 4.24326 2.00729 4.74117C1.79376 5.27021 1.61752 5.82759 1.52025 6.21648C1.19829 7.50369 1.01236 9.06758 0.97986 10.5739C1.18772 10.8918 1.61807 11.2661 2.16148 11.5917C2.64557 11.8818 3.15003 12.0916 3.5468 12.1809C3.64885 12.0385 3.78065 11.843 3.9138 11.6392C3.93626 11.6048 3.95838 11.5708 3.97996 11.5375C3.19521 11.2591 2.77361 10.8758 2.50064 10.4664C2.35359 10.2458 2.4132 9.94778 2.63377 9.80074C2.85435 9.65369 3.15236 9.71329 3.29941 9.93387C3.56077 10.3259 4.24355 11.0201 7.50002 11.0201C10.7565 11.0201 11.4392 10.326 11.7006 9.93386C11.8477 9.71329 12.1457 9.65369 12.3663 9.80074C12.5869 9.94779 12.6465 10.2458 12.4994 10.4664C12.2262 10.8762 11.8041 11.2598 11.0181 11.5382ZM4.08049 7.01221C4.32412 6.74984 4.65476 6.60162 5.00007 6.59998C5.34538 6.60162 5.67603 6.74984 5.91966 7.01221C6.16329 7.27459 6.30007 7.62974 6.30007 7.99998C6.30007 8.37021 6.16329 8.72536 5.91966 8.98774C5.67603 9.25011 5.34538 9.39833 5.00007 9.39998C4.65476 9.39833 4.32412 9.25011 4.08049 8.98774C3.83685 8.72536 3.70007 8.37021 3.70007 7.99998C3.70007 7.62974 3.83685 7.27459 4.08049 7.01221ZM9.99885 6.59998C9.65354 6.60162 9.3229 6.74984 9.07926 7.01221C8.83563 7.27459 8.69885 7.62974 8.69885 7.99998C8.69885 8.37021 8.83563 8.72536 9.07926 8.98774C9.3229 9.25011 9.65354 9.39833 9.99885 9.39998C10.3442 9.39833 10.6748 9.25011 10.9184 8.98774C11.1621 8.72536 11.2989 8.37021 11.2989 7.99998C11.2989 7.62974 11.1621 7.27459 10.9184 7.01221C10.6748 6.74984 10.3442 6.60162 9.99885 6.59998Z",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1F = [
    "color"
];
var $6431ef21eafb1f5a$export$67e4f137381994a7 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1F);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1G = [
    "color"
];
var $6431ef21eafb1f5a$export$4941448a902289ea = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1G);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.5 2C7.77614 2 8 2.22386 8 2.5L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 2.5C7 2.22386 7.22386 2 7.5 2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1H = [
    "color"
];
var $6431ef21eafb1f5a$export$1638d451d4588271 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1H);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.5 9.125C8.39746 9.125 9.125 8.39746 9.125 7.5C9.125 6.60254 8.39746 5.875 7.5 5.875C6.60254 5.875 5.875 6.60254 5.875 7.5C5.875 8.39746 6.60254 9.125 7.5 9.125ZM7.5 10.125C8.94975 10.125 10.125 8.94975 10.125 7.5C10.125 6.05025 8.94975 4.875 7.5 4.875C6.05025 4.875 4.875 6.05025 4.875 7.5C4.875 8.94975 6.05025 10.125 7.5 10.125Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1I = [
    "color"
];
var $6431ef21eafb1f5a$export$5ce415a59e297ace = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1I);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M9.875 7.5C9.875 8.81168 8.81168 9.875 7.5 9.875C6.18832 9.875 5.125 8.81168 5.125 7.5C5.125 6.18832 6.18832 5.125 7.5 5.125C8.81168 5.125 9.875 6.18832 9.875 7.5Z",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1J = [
    "color"
];
var $6431ef21eafb1f5a$export$9789fa787c2a8e33 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1J);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1K = [
    "color"
];
var $6431ef21eafb1f5a$export$f50786ff8e0cdf62 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1K);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8.625 2.5C8.625 3.12132 8.12132 3.625 7.5 3.625C6.87868 3.625 6.375 3.12132 6.375 2.5C6.375 1.87868 6.87868 1.375 7.5 1.375C8.12132 1.375 8.625 1.87868 8.625 2.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM7.5 13.625C8.12132 13.625 8.625 13.1213 8.625 12.5C8.625 11.8787 8.12132 11.375 7.5 11.375C6.87868 11.375 6.375 11.8787 6.375 12.5C6.375 13.1213 6.87868 13.625 7.5 13.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1L = [
    "color"
];
var $6431ef21eafb1f5a$export$de42cbda950c1561 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1L);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.85355 2.14645C3.65829 1.95118 3.34171 1.95118 3.14645 2.14645C2.95118 2.34171 2.95118 2.65829 3.14645 2.85355L7.14645 6.85355C7.34171 7.04882 7.65829 7.04882 7.85355 6.85355L11.8536 2.85355C12.0488 2.65829 12.0488 2.34171 11.8536 2.14645C11.6583 1.95118 11.3417 1.95118 11.1464 2.14645L7.5 5.79289L3.85355 2.14645ZM3.85355 8.14645C3.65829 7.95118 3.34171 7.95118 3.14645 8.14645C2.95118 8.34171 2.95118 8.65829 3.14645 8.85355L7.14645 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L11.8536 8.85355C12.0488 8.65829 12.0488 8.34171 11.8536 8.14645C11.6583 7.95118 11.3417 7.95118 11.1464 8.14645L7.5 11.7929L3.85355 8.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1M = [
    "color"
];
var $6431ef21eafb1f5a$export$8f14af9007650906 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1M);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M6.85355 3.85355C7.04882 3.65829 7.04882 3.34171 6.85355 3.14645C6.65829 2.95118 6.34171 2.95118 6.14645 3.14645L2.14645 7.14645C1.95118 7.34171 1.95118 7.65829 2.14645 7.85355L6.14645 11.8536C6.34171 12.0488 6.65829 12.0488 6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464L3.20711 7.5L6.85355 3.85355ZM12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8.14645 7.14645C7.95118 7.34171 7.95118 7.65829 8.14645 7.85355L12.1464 11.8536C12.3417 12.0488 12.6583 12.0488 12.8536 11.8536C13.0488 11.6583 13.0488 11.3417 12.8536 11.1464L9.20711 7.5L12.8536 3.85355Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1N = [
    "color"
];
var $6431ef21eafb1f5a$export$90b329a415b2a5d4 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1N);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.14645 11.1464C1.95118 11.3417 1.95118 11.6583 2.14645 11.8536C2.34171 12.0488 2.65829 12.0488 2.85355 11.8536L6.85355 7.85355C7.04882 7.65829 7.04882 7.34171 6.85355 7.14645L2.85355 3.14645C2.65829 2.95118 2.34171 2.95118 2.14645 3.14645C1.95118 3.34171 1.95118 3.65829 2.14645 3.85355L5.79289 7.5L2.14645 11.1464ZM8.14645 11.1464C7.95118 11.3417 7.95118 11.6583 8.14645 11.8536C8.34171 12.0488 8.65829 12.0488 8.85355 11.8536L12.8536 7.85355C13.0488 7.65829 13.0488 7.34171 12.8536 7.14645L8.85355 3.14645C8.65829 2.95118 8.34171 2.95118 8.14645 3.14645C7.95118 3.34171 7.95118 3.65829 8.14645 3.85355L11.7929 7.5L8.14645 11.1464Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1O = [
    "color"
];
var $6431ef21eafb1f5a$export$4625b0d11d3861cc = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1O);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M11.1464 6.85355C11.3417 7.04882 11.6583 7.04882 11.8536 6.85355C12.0488 6.65829 12.0488 6.34171 11.8536 6.14645L7.85355 2.14645C7.65829 1.95118 7.34171 1.95118 7.14645 2.14645L3.14645 6.14645C2.95118 6.34171 2.95118 6.65829 3.14645 6.85355C3.34171 7.04882 3.65829 7.04882 3.85355 6.85355L7.5 3.20711L11.1464 6.85355ZM11.1464 12.8536C11.3417 13.0488 11.6583 13.0488 11.8536 12.8536C12.0488 12.6583 12.0488 12.3417 11.8536 12.1464L7.85355 8.14645C7.65829 7.95118 7.34171 7.95118 7.14645 8.14645L3.14645 12.1464C2.95118 12.3417 2.95118 12.6583 3.14645 12.8536C3.34171 13.0488 3.65829 13.0488 3.85355 12.8536L7.5 9.20711L11.1464 12.8536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1P = [
    "color"
];
var $6431ef21eafb1f5a$export$4e54df4252b4a99c = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1P);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1Q = [
    "color"
];
var $6431ef21eafb1f5a$export$209fdd70701c1b6e = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1Q);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("circle", {
        cx: "4.5",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "4.5",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "4.5",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "4.5",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "4.5",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "4.5",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "6.5",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "6.5",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "6.5",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "6.5",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "6.5",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "6.5",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "8.499",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "8.499",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "8.499",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "8.499",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "8.499",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "8.499",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "10.499",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "10.499",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "10.499",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "10.499",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "10.499",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $4DE7A.createElement)("circle", {
        cx: "10.499",
        cy: "12.498",
        r: ".6",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1R = [
    "color"
];
var $6431ef21eafb1f5a$export$829e9de7006febc4 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1R);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5.5 4.625C6.12132 4.625 6.625 4.12132 6.625 3.5C6.625 2.87868 6.12132 2.375 5.5 2.375C4.87868 2.375 4.375 2.87868 4.375 3.5C4.375 4.12132 4.87868 4.625 5.5 4.625ZM9.5 4.625C10.1213 4.625 10.625 4.12132 10.625 3.5C10.625 2.87868 10.1213 2.375 9.5 2.375C8.87868 2.375 8.375 2.87868 8.375 3.5C8.375 4.12132 8.87868 4.625 9.5 4.625ZM10.625 7.5C10.625 8.12132 10.1213 8.625 9.5 8.625C8.87868 8.625 8.375 8.12132 8.375 7.5C8.375 6.87868 8.87868 6.375 9.5 6.375C10.1213 6.375 10.625 6.87868 10.625 7.5ZM5.5 8.625C6.12132 8.625 6.625 8.12132 6.625 7.5C6.625 6.87868 6.12132 6.375 5.5 6.375C4.87868 6.375 4.375 6.87868 4.375 7.5C4.375 8.12132 4.87868 8.625 5.5 8.625ZM10.625 11.5C10.625 12.1213 10.1213 12.625 9.5 12.625C8.87868 12.625 8.375 12.1213 8.375 11.5C8.375 10.8787 8.87868 10.375 9.5 10.375C10.1213 10.375 10.625 10.8787 10.625 11.5ZM5.5 12.625C6.12132 12.625 6.625 12.1213 6.625 11.5C6.625 10.8787 6.12132 10.375 5.5 10.375C4.87868 10.375 4.375 10.8787 4.375 11.5C4.375 12.1213 4.87868 12.625 5.5 12.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1S = [
    "color"
];
var $6431ef21eafb1f5a$export$e6848a231b25a576 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1S);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.49998 4.09998C2.27906 4.09998 2.09998 4.27906 2.09998 4.49998C2.09998 4.72089 2.27906 4.89998 2.49998 4.89998H12.5C12.7209 4.89998 12.9 4.72089 12.9 4.49998C12.9 4.27906 12.7209 4.09998 12.5 4.09998H2.49998ZM2.49998 6.09998C2.27906 6.09998 2.09998 6.27906 2.09998 6.49998C2.09998 6.72089 2.27906 6.89998 2.49998 6.89998H12.5C12.7209 6.89998 12.9 6.72089 12.9 6.49998C12.9 6.27906 12.7209 6.09998 12.5 6.09998H2.49998ZM2.09998 8.49998C2.09998 8.27906 2.27906 8.09998 2.49998 8.09998H12.5C12.7209 8.09998 12.9 8.27906 12.9 8.49998C12.9 8.72089 12.7209 8.89998 12.5 8.89998H2.49998C2.27906 8.89998 2.09998 8.72089 2.09998 8.49998ZM2.49998 10.1C2.27906 10.1 2.09998 10.2791 2.09998 10.5C2.09998 10.7209 2.27906 10.9 2.49998 10.9H12.5C12.7209 10.9 12.9 10.7209 12.9 10.5C12.9 10.2791 12.7209 10.1 12.5 10.1H2.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1T = [
    "color"
];
var $6431ef21eafb1f5a$export$b72a86f6a31cd8d8 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1T);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.09998 12.5C4.09998 12.7209 4.27906 12.9 4.49998 12.9C4.72089 12.9 4.89998 12.7209 4.89998 12.5L4.89998 2.50002C4.89998 2.27911 4.72089 2.10003 4.49998 2.10003C4.27906 2.10003 4.09998 2.27911 4.09998 2.50002L4.09998 12.5ZM6.09998 12.5C6.09998 12.7209 6.27906 12.9 6.49998 12.9C6.72089 12.9 6.89998 12.7209 6.89998 12.5L6.89998 2.50002C6.89998 2.27911 6.72089 2.10003 6.49998 2.10003C6.27906 2.10003 6.09998 2.27911 6.09998 2.50002L6.09998 12.5ZM8.49998 12.9C8.27906 12.9 8.09998 12.7209 8.09998 12.5L8.09998 2.50002C8.09998 2.27911 8.27906 2.10002 8.49998 2.10002C8.72089 2.10002 8.89998 2.27911 8.89998 2.50002L8.89998 12.5C8.89998 12.7209 8.72089 12.9 8.49998 12.9ZM10.1 12.5C10.1 12.7209 10.2791 12.9 10.5 12.9C10.7209 12.9 10.9 12.7209 10.9 12.5L10.9 2.50002C10.9 2.27911 10.7209 2.10002 10.5 2.10002C10.2791 2.10002 10.1 2.27911 10.1 2.50002L10.1 12.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1U = [
    "color"
];
var $6431ef21eafb1f5a$export$d678e82375a26dcf = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1U);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M10.3285 1.13607C10.1332 0.940809 9.81662 0.940808 9.62136 1.13607C9.42609 1.33133 9.42609 1.64792 9.62136 1.84318L10.2744 2.49619L5.42563 6.13274L4.31805 5.02516C4.12279 4.8299 3.80621 4.8299 3.61095 5.02516C3.41569 5.22042 3.41569 5.537 3.61095 5.73226L5.02516 7.14648L6.08582 8.20714L2.81545 11.4775C2.62019 11.6728 2.62019 11.9894 2.81545 12.1846C3.01072 12.3799 3.3273 12.3799 3.52256 12.1846L6.79293 8.91425L7.85359 9.97491L9.2678 11.3891C9.46306 11.5844 9.77965 11.5844 9.97491 11.3891C10.1702 11.1939 10.1702 10.8773 9.97491 10.682L8.86733 9.57443L12.5039 4.7257L13.1569 5.37871C13.3522 5.57397 13.6687 5.57397 13.864 5.37871C14.0593 5.18345 14.0593 4.86687 13.864 4.6716L12.8033 3.61094L11.3891 2.19673L10.3285 1.13607ZM6.13992 6.84702L10.9887 3.21047L11.7896 4.01142L8.15305 8.86015L6.13992 6.84702Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1V = [
    "color"
];
var $6431ef21eafb1f5a$export$c6212c739d4cf8da = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1V);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M9.62129 1.13607C9.81656 0.940808 10.1331 0.940809 10.3284 1.13607L11.3891 2.19673L12.8033 3.61094L13.8639 4.6716C14.0592 4.86687 14.0592 5.18345 13.8639 5.37871C13.6687 5.57397 13.3521 5.57397 13.1568 5.37871L12.5038 4.7257L8.86727 9.57443L9.97485 10.682C10.1701 10.8773 10.1701 11.1939 9.97485 11.3891C9.77959 11.5844 9.463 11.5844 9.26774 11.3891L7.85353 9.97491L6.79287 8.91425L3.5225 12.1846C3.32724 12.3799 3.01065 12.3799 2.81539 12.1846C2.62013 11.9894 2.62013 11.6728 2.81539 11.4775L6.08576 8.20714L5.0251 7.14648L3.61089 5.73226C3.41563 5.537 3.41562 5.22042 3.61089 5.02516C3.80615 4.8299 4.12273 4.8299 4.31799 5.02516L5.42557 6.13274L10.2743 2.49619L9.62129 1.84318C9.42603 1.64792 9.42603 1.33133 9.62129 1.13607Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        d: "M9.62129 1.13607C9.81656 0.940808 10.1331 0.940809 10.3284 1.13607L11.3891 2.19673L12.8033 3.61094L13.8639 4.6716C14.0592 4.86687 14.0592 5.18345 13.8639 5.37871C13.6687 5.57397 13.3521 5.57397 13.1568 5.37871L12.5038 4.7257L8.86727 9.57443L9.97485 10.682C10.1701 10.8773 10.1701 11.1939 9.97485 11.3891C9.77959 11.5844 9.463 11.5844 9.26774 11.3891L7.85353 9.97491L6.79287 8.91425L3.5225 12.1846C3.32724 12.3799 3.01065 12.3799 2.81539 12.1846C2.62013 11.9894 2.62013 11.6728 2.81539 11.4775L6.08576 8.20714L5.0251 7.14648L3.61089 5.73226C3.41563 5.537 3.41562 5.22042 3.61089 5.02516C3.80615 4.8299 4.12273 4.8299 4.31799 5.02516L5.42557 6.13274L10.2743 2.49619L9.62129 1.84318C9.42603 1.64792 9.42603 1.33133 9.62129 1.13607Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1W = [
    "color"
];
var $6431ef21eafb1f5a$export$e5daec7136b0534 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1W);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49999 3.09998C7.27907 3.09998 7.09999 3.27906 7.09999 3.49998C7.09999 3.72089 7.27907 3.89998 7.49999 3.89998H14.5C14.7209 3.89998 14.9 3.72089 14.9 3.49998C14.9 3.27906 14.7209 3.09998 14.5 3.09998H7.49999ZM7.49998 5.1C7.27907 5.1 7.09998 5.27908 7.09998 5.5C7.09998 5.72091 7.27907 5.9 7.49998 5.9H14.5C14.7209 5.9 14.9 5.72091 14.9 5.5C14.9 5.27908 14.7209 5.1 14.5 5.1H7.49998ZM7.1 7.5C7.1 7.27908 7.27909 7.1 7.5 7.1H14.5C14.7209 7.1 14.9 7.27908 14.9 7.5C14.9 7.72091 14.7209 7.9 14.5 7.9H7.5C7.27909 7.9 7.1 7.72091 7.1 7.5ZM7.49998 9.1C7.27907 9.1 7.09998 9.27908 7.09998 9.5C7.09998 9.72091 7.27907 9.9 7.49998 9.9H14.5C14.7209 9.9 14.9 9.72091 14.9 9.5C14.9 9.27908 14.7209 9.1 14.5 9.1H7.49998ZM7.09998 11.5C7.09998 11.2791 7.27907 11.1 7.49998 11.1H14.5C14.7209 11.1 14.9 11.2791 14.9 11.5C14.9 11.7209 14.7209 11.9 14.5 11.9H7.49998C7.27907 11.9 7.09998 11.7209 7.09998 11.5ZM2.5 9.25003L5 6.00003H0L2.5 9.25003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1X = [
    "color"
];
var $6431ef21eafb1f5a$export$296bea1be8b4086a = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1X);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2H12V13H4.5C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14H12C12.5523 14 13 13.5523 13 13V2C13 1.44772 12.5523 1 12 1H4.5ZM6.60355 4.89645C6.40829 4.70118 6.09171 4.70118 5.89645 4.89645C5.70118 5.09171 5.70118 5.40829 5.89645 5.60355L7.29289 7H0.5C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H7.29289L5.89645 9.39645C5.70118 9.59171 5.70118 9.90829 5.89645 10.1036C6.09171 10.2988 6.40829 10.2988 6.60355 10.1036L8.85355 7.85355C9.04882 7.65829 9.04882 7.34171 8.85355 7.14645L6.60355 4.89645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1Y = [
    "color"
];
var $6431ef21eafb1f5a$export$5886b995403a6540 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1Y);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2 2.5C2 2.22386 2.22386 2 2.5 2H5.5C5.77614 2 6 2.22386 6 2.5C6 2.77614 5.77614 3 5.5 3H3V5.5C3 5.77614 2.77614 6 2.5 6C2.22386 6 2 5.77614 2 5.5V2.5ZM9 2.5C9 2.22386 9.22386 2 9.5 2H12.5C12.7761 2 13 2.22386 13 2.5V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3H9.5C9.22386 3 9 2.77614 9 2.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H2.5C2.22386 13 2 12.7761 2 12.5V9.5C2 9.22386 2.22386 9 2.5 9ZM12.5 9C12.7761 9 13 9.22386 13 9.5V12.5C13 12.7761 12.7761 13 12.5 13H9.5C9.22386 13 9 12.7761 9 12.5C9 12.2239 9.22386 12 9.5 12H12V9.5C12 9.22386 12.2239 9 12.5 9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1Z = [
    "color"
];
var $6431ef21eafb1f5a$export$c81ccc0bdd70284 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1Z);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1_ = [
    "color"
];
var $6431ef21eafb1f5a$export$808857d2db6c57a2 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1_);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.94721 0.164594C7.66569 0.0238299 7.33431 0.0238302 7.05279 0.164594L0.552786 3.41459C0.214002 3.58399 0 3.93025 0 4.30902V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V4.30902C15 3.93025 14.786 3.58399 14.4472 3.41459L7.94721 0.164594ZM13.5689 4.09349L7.5 1.05902L1.43105 4.09349L7.5 7.29136L13.5689 4.09349ZM1 4.88366V12H14V4.88366L7.70977 8.19813C7.57848 8.26731 7.42152 8.26731 7.29023 8.19813L1 4.88366Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$1$ = [
    "color"
];
var $6431ef21eafb1f5a$export$b6c544816d254f36 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$1$);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8.36052 0.72921C8.55578 0.533948 8.87236 0.533948 9.06763 0.72921L14.2708 5.93235C14.466 6.12761 14.466 6.4442 14.2708 6.63946L8.95513 11.9551L7.3466 13.5636C6.76081 14.1494 5.81106 14.1494 5.22528 13.5636L1.43635 9.7747C0.850563 9.18891 0.850563 8.23917 1.43635 7.65338L3.04488 6.04485L8.36052 0.72921ZM8.71407 1.78987L4.10554 6.3984L8.60157 10.8944L13.2101 6.28591L8.71407 1.78987ZM7.89447 11.6015L3.39843 7.10551L2.14346 8.36049C1.94819 8.55575 1.94819 8.87233 2.14346 9.06759L5.93238 12.8565C6.12765 13.0518 6.44423 13.0518 6.63949 12.8565L7.89447 11.6015Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$20 = [
    "color"
];
var $6431ef21eafb1f5a$export$b409b230b61d4724 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$20);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8.4449 0.608765C8.0183 -0.107015 6.9817 -0.107015 6.55509 0.608766L0.161178 11.3368C-0.275824 12.07 0.252503 13 1.10608 13H13.8939C14.7475 13 15.2758 12.07 14.8388 11.3368L8.4449 0.608765ZM7.4141 1.12073C7.45288 1.05566 7.54712 1.05566 7.5859 1.12073L13.9798 11.8488C14.0196 11.9154 13.9715 12 13.8939 12H1.10608C1.02849 12 0.980454 11.9154 1.02018 11.8488L7.4141 1.12073ZM6.8269 4.48611C6.81221 4.10423 7.11783 3.78663 7.5 3.78663C7.88217 3.78663 8.18778 4.10423 8.1731 4.48612L8.01921 8.48701C8.00848 8.766 7.7792 8.98664 7.5 8.98664C7.2208 8.98664 6.99151 8.766 6.98078 8.48701L6.8269 4.48611ZM8.24989 10.476C8.24989 10.8902 7.9141 11.226 7.49989 11.226C7.08567 11.226 6.74989 10.8902 6.74989 10.476C6.74989 10.0618 7.08567 9.72599 7.49989 9.72599C7.9141 9.72599 8.24989 10.0618 8.24989 10.476Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$21 = [
    "color"
];
var $6431ef21eafb1f5a$export$72b807c0098a555f = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$21);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3 1C2.44771 1 2 1.44772 2 2V13C2 13.5523 2.44772 14 3 14H10.5C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13H3V2L10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1H3ZM12.6036 4.89645C12.4083 4.70118 12.0917 4.70118 11.8964 4.89645C11.7012 5.09171 11.7012 5.40829 11.8964 5.60355L13.2929 7H6.5C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H13.2929L11.8964 9.39645C11.7012 9.59171 11.7012 9.90829 11.8964 10.1036C12.0917 10.2988 12.4083 10.2988 12.6036 10.1036L14.8536 7.85355C15.0488 7.65829 15.0488 7.34171 14.8536 7.14645L12.6036 4.89645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$22 = [
    "color"
];
var $6431ef21eafb1f5a$export$7e82c66e763fb043 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$22);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5.5 2C5.77614 2 6 2.22386 6 2.5V5.5C6 5.77614 5.77614 6 5.5 6H2.5C2.22386 6 2 5.77614 2 5.5C2 5.22386 2.22386 5 2.5 5H5V2.5C5 2.22386 5.22386 2 5.5 2ZM9.5 2C9.77614 2 10 2.22386 10 2.5V5H12.5C12.7761 5 13 5.22386 13 5.5C13 5.77614 12.7761 6 12.5 6H9.5C9.22386 6 9 5.77614 9 5.5V2.5C9 2.22386 9.22386 2 9.5 2ZM2 9.5C2 9.22386 2.22386 9 2.5 9H5.5C5.77614 9 6 9.22386 6 9.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5V10H2.5C2.22386 10 2 9.77614 2 9.5ZM9 9.5C9 9.22386 9.22386 9 9.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H10V12.5C10 12.7761 9.77614 13 9.5 13C9.22386 13 9 12.7761 9 12.5V9.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$23 = [
    "color"
];
var $6431ef21eafb1f5a$export$9bd11592bfa362e7 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$23);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$24 = [
    "color"
];
var $6431ef21eafb1f5a$export$f2c2531e46a6c1ea = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$24);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M14.7649 6.07596C14.9991 6.22231 15.0703 6.53079 14.9239 6.76495C14.4849 7.46743 13.9632 8.10645 13.3702 8.66305L14.5712 9.86406C14.7664 10.0593 14.7664 10.3759 14.5712 10.5712C14.3759 10.7664 14.0593 10.7664 13.8641 10.5712L12.6011 9.30817C11.805 9.90283 10.9089 10.3621 9.93375 10.651L10.383 12.3277C10.4544 12.5944 10.2961 12.8685 10.0294 12.94C9.76267 13.0115 9.4885 12.8532 9.41704 12.5865L8.95917 10.8775C8.48743 10.958 8.00036 10.9999 7.50001 10.9999C6.99965 10.9999 6.51257 10.958 6.04082 10.8775L5.58299 12.5864C5.51153 12.8532 5.23737 13.0115 4.97064 12.94C4.7039 12.8686 4.5456 12.5944 4.61706 12.3277L5.06625 10.651C4.09111 10.3621 3.19503 9.90282 2.3989 9.30815L1.1359 10.5712C0.940638 10.7664 0.624058 10.7664 0.428798 10.5712C0.233537 10.3759 0.233537 10.0593 0.428798 9.86405L1.62982 8.66303C1.03682 8.10643 0.515113 7.46742 0.0760677 6.76495C-0.0702867 6.53079 0.000898544 6.22231 0.235065 6.07596C0.469231 5.9296 0.777703 6.00079 0.924058 6.23496C1.40354 7.00213 1.989 7.68057 2.66233 8.2427C2.67315 8.25096 2.6837 8.25972 2.69397 8.26898C4.00897 9.35527 5.65537 9.99991 7.50001 9.99991C10.3078 9.99991 12.6564 8.5063 14.076 6.23495C14.2223 6.00079 14.5308 5.9296 14.7649 6.07596Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$25 = [
    "color"
];
var $6431ef21eafb1f5a$export$3547759c3ff9b44c = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$25);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$26 = [
    "color"
];
var $6431ef21eafb1f5a$export$620653f31aa3377e = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$26);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$27 = [
    "color"
];
var $6431ef21eafb1f5a$export$b8f42e9471d5f647 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$27);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82708 7.49972C1.82708 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82708 10.6327 1.82708 7.49972ZM5.03747 9.21395C4.87949 8.98746 4.56782 8.93193 4.34133 9.08991C4.11484 9.24789 4.05931 9.55956 4.21729 9.78605C4.93926 10.8211 6.14033 11.5 7.50004 11.5C8.85974 11.5 10.0608 10.8211 10.7828 9.78605C10.9408 9.55956 10.8852 9.24789 10.6587 9.08991C10.4323 8.93193 10.1206 8.98746 9.9626 9.21395C9.41963 9.99238 8.51907 10.5 7.50004 10.5C6.481 10.5 5.58044 9.99238 5.03747 9.21395ZM5.37503 6.84998C5.85828 6.84998 6.25003 6.45815 6.25003 5.97498C6.25003 5.4918 5.85828 5.09998 5.37503 5.09998C4.89179 5.09998 4.50003 5.4918 4.50003 5.97498C4.50003 6.45815 4.89179 6.84998 5.37503 6.84998ZM10.5 5.97498C10.5 6.45815 10.1083 6.84998 9.62503 6.84998C9.14179 6.84998 8.75003 6.45815 8.75003 5.97498C8.75003 5.4918 9.14179 5.09998 9.62503 5.09998C10.1083 5.09998 10.5 5.4918 10.5 5.97498Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$28 = [
    "color"
];
var $6431ef21eafb1f5a$export$2b3d0ca2fe16e98c = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$28);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.00005 2.04999H5.52505C4.71043 2.04999 4.05005 2.71037 4.05005 3.52499C4.05005 4.33961 4.71043 4.99999 5.52505 4.99999H7.00005V2.04999ZM7.00005 1.04999H8.00005H9.47505C10.842 1.04999 11.95 2.15808 11.95 3.52499C11.95 4.33163 11.5642 5.04815 10.9669 5.49999C11.5642 5.95184 11.95 6.66836 11.95 7.475C11.95 8.8419 10.842 9.95 9.47505 9.95C8.92236 9.95 8.41198 9.76884 8.00005 9.46266V9.95L8.00005 11.425C8.00005 12.7919 6.89195 13.9 5.52505 13.9C4.15814 13.9 3.05005 12.7919 3.05005 11.425C3.05005 10.6183 3.43593 9.90184 4.03317 9.44999C3.43593 8.99814 3.05005 8.28163 3.05005 7.475C3.05005 6.66836 3.43594 5.95184 4.03319 5.5C3.43594 5.04815 3.05005 4.33163 3.05005 3.52499C3.05005 2.15808 4.15814 1.04999 5.52505 1.04999H7.00005ZM8.00005 2.04999V4.99999H9.47505C10.2897 4.99999 10.95 4.33961 10.95 3.52499C10.95 2.71037 10.2897 2.04999 9.47505 2.04999H8.00005ZM5.52505 8.94998H7.00005L7.00005 7.4788L7.00005 7.475L7.00005 7.4712V6H5.52505C4.71043 6 4.05005 6.66038 4.05005 7.475C4.05005 8.28767 4.70727 8.94684 5.5192 8.94999L5.52505 8.94998ZM4.05005 11.425C4.05005 10.6123 4.70727 9.95315 5.5192 9.94999L5.52505 9.95H7.00005L7.00005 11.425C7.00005 12.2396 6.33967 12.9 5.52505 12.9C4.71043 12.9 4.05005 12.2396 4.05005 11.425ZM8.00005 7.47206C8.00164 6.65879 8.66141 6 9.47505 6C10.2897 6 10.95 6.66038 10.95 7.475C10.95 8.28962 10.2897 8.95 9.47505 8.95C8.66141 8.95 8.00164 8.29121 8.00005 7.47794V7.47206Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$29 = [
    "color"
];
var $6431ef21eafb1f5a$export$8c1a3d13e85d78b7 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$29);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V6H8.5C8.22386 6 8 5.77614 8 5.5V2H3.5ZM9 2.70711L11.2929 5H9V2.70711ZM2 2.5C2 1.67157 2.67157 1 3.5 1H8.5C8.63261 1 8.75979 1.05268 8.85355 1.14645L12.8536 5.14645C12.9473 5.24021 13 5.36739 13 5.5V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2a = [
    "color"
];
var $6431ef21eafb1f5a$export$3c5dbe056aa7c94f = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2a);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H9.29289L12 4.70711V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.60355C13 4.40464 12.921 4.21388 12.7803 4.07322L9.85355 1.14645C9.75979 1.05268 9.63261 1 9.5 1H3.5ZM5.25 7C4.97386 7 4.75 7.22386 4.75 7.5C4.75 7.77614 4.97386 8 5.25 8H9.75C10.0261 8 10.25 7.77614 10.25 7.5C10.25 7.22386 10.0261 7 9.75 7H5.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2b = [
    "color"
];
var $6431ef21eafb1f5a$export$ca191b730434e9b4 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2b);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V4.70711L9.29289 2H3.5ZM2 2.5C2 1.67157 2.67157 1 3.5 1H9.5C9.63261 1 9.75979 1.05268 9.85355 1.14645L12.7803 4.07322C12.921 4.21388 13 4.40464 13 4.60355V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V2.5ZM4.75 7.5C4.75 7.22386 4.97386 7 5.25 7H7V5.25C7 4.97386 7.22386 4.75 7.5 4.75C7.77614 4.75 8 4.97386 8 5.25V7H9.75C10.0261 7 10.25 7.22386 10.25 7.5C10.25 7.77614 10.0261 8 9.75 8H8V9.75C8 10.0261 7.77614 10.25 7.5 10.25C7.22386 10.25 7 10.0261 7 9.75V8H5.25C4.97386 8 4.75 7.77614 4.75 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2c = [
    "color"
];
var $6431ef21eafb1f5a$export$605674723bcc715c = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2c);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H9.08579C9.21839 2 9.34557 2.05268 9.43934 2.14645L11.8536 4.56066C11.9473 4.65443 12 4.78161 12 4.91421V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.91421C13 4.51639 12.842 4.13486 12.5607 3.85355L10.1464 1.43934C9.86514 1.15804 9.48361 1 9.08579 1H3.5ZM4.5 4C4.22386 4 4 4.22386 4 4.5C4 4.77614 4.22386 5 4.5 5H7.5C7.77614 5 8 4.77614 8 4.5C8 4.22386 7.77614 4 7.5 4H4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H10.5C10.7761 11 11 10.7761 11 10.5C11 10.2239 10.7761 10 10.5 10H4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2d = [
    "color"
];
var $6431ef21eafb1f5a$export$1a2ae984f27cf526 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2d);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5.10505 12C4.70805 12 4.4236 11.912 4.25171 11.736C4.0839 11.5559 4 11.2715 4 10.8827V4.11733C4 3.72033 4.08595 3.43588 4.25784 3.26398C4.43383 3.08799 4.71623 3 5.10505 3C6.42741 3 8.25591 3 9.02852 3C10.1373 3 11.0539 3.98153 11.0539 5.1846C11.0539 6.08501 10.6037 6.81855 9.70327 7.23602C10.8657 7.44851 11.5176 8.62787 11.5176 9.48128C11.5176 10.5125 10.9902 12 9.27734 12C8.77742 12 6.42626 12 5.10505 12ZM8.37891 8.00341H5.8V10.631H8.37891C8.9 10.631 9.6296 10.1211 9.6296 9.29877C9.6296 8.47643 8.9 8.00341 8.37891 8.00341ZM5.8 4.36903V6.69577H8.17969C8.53906 6.69577 9.27734 6.35939 9.27734 5.50002C9.27734 4.64064 8.48047 4.36903 8.17969 4.36903H5.8Z",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2e = [
    "color"
];
var $6431ef21eafb1f5a$export$79d8792587f7aca5 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2e);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.5 4.5C2.5 3.09886 3.59886 2 5 2H12.499C12.7752 2 13 2.22386 13 2.5C13 2.77614 12.7761 3 12.5 3H8.69244L8.40509 3.85458C8.18869 4.49752 7.89401 5.37197 7.58091 6.29794C7.50259 6.52956 7.42308 6.76453 7.34332 7H8.5C8.77614 7 9 7.22386 9 7.5C9 7.77614 8.77614 8 8.5 8H7.00407C6.56724 9.28543 6.16435 10.4613 5.95799 11.0386C5.63627 11.9386 5.20712 12.4857 4.66741 12.7778C4.16335 13.0507 3.64154 13.0503 3.28378 13.05L3.25 13.05C2.94624 13.05 2.7 12.8037 2.7 12.5C2.7 12.1962 2.94624 11.95 3.25 11.95C3.64182 11.95 3.9035 11.9405 4.14374 11.8105C4.36443 11.691 4.65532 11.4148 4.92217 10.6683C5.10695 10.1514 5.45375 9.14134 5.8422 8H4.5C4.22386 8 4 7.77614 4 7.5C4 7.22386 4.22386 7 4.5 7H6.18187C6.30127 6.64785 6.42132 6.29323 6.53887 5.94559C6.85175 5.02025 7.14627 4.14631 7.36256 3.50368L7.53192 3H5C4.15114 3 3.5 3.65114 3.5 4.5C3.5 4.77614 3.27614 5 3 5C2.72386 5 2.5 4.77614 2.5 4.5Z",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2f = [
    "color"
];
var $6431ef21eafb1f5a$export$f5ac866b2a77627a = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2f);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5.67494 3.50017C5.67494 3.25164 5.87641 3.05017 6.12494 3.05017H10.6249C10.8735 3.05017 11.0749 3.25164 11.0749 3.50017C11.0749 3.7487 10.8735 3.95017 10.6249 3.95017H9.00587L7.2309 11.05H8.87493C9.12345 11.05 9.32493 11.2515 9.32493 11.5C9.32493 11.7486 9.12345 11.95 8.87493 11.95H4.37493C4.1264 11.95 3.92493 11.7486 3.92493 11.5C3.92493 11.2515 4.1264 11.05 4.37493 11.05H5.99397L7.76894 3.95017H6.12494C5.87641 3.95017 5.67494 3.7487 5.67494 3.50017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2g = [
    "color"
];
var $6431ef21eafb1f5a$export$9f94aa21504b3fcd = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2g);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.79993 3.50017C4.79993 3.25164 5.0014 3.05017 5.24993 3.05017H9.74993C9.99845 3.05017 10.1999 3.25164 10.1999 3.50017C10.1999 3.7487 9.99845 3.95017 9.74993 3.95017H8.09993V11.05H9.74994C9.99847 11.05 10.1999 11.2515 10.1999 11.5C10.1999 11.7486 9.99847 11.95 9.74994 11.95H5.24994C5.00141 11.95 4.79994 11.7486 4.79994 11.5C4.79994 11.2515 5.00141 11.05 5.24994 11.05H6.89993V3.95017H5.24993C5.0014 3.95017 4.79993 3.7487 4.79993 3.50017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2h = [
    "color"
];
var $6431ef21eafb1f5a$export$88890ea574fb3a19 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2h);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.78233 2.21707C2.70732 2.14206 2.60557 2.09991 2.49949 2.09991C2.3934 2.09991 2.29166 2.14206 2.21664 2.21707L0.216645 4.21707C0.0604351 4.37328 0.0604351 4.62655 0.216645 4.78276C0.372855 4.93897 0.626121 4.93897 0.78233 4.78276L2.09949 3.4656L2.09949 11.5342L0.78233 10.2171C0.62612 10.0609 0.372854 10.0609 0.216645 10.2171C0.0604349 10.3733 0.0604349 10.6265 0.216645 10.7828L2.21664 12.7828C2.29166 12.8578 2.3934 12.8999 2.49949 12.8999C2.60557 12.8999 2.70731 12.8578 2.78233 12.7828L4.78233 10.7828C4.93854 10.6265 4.93854 10.3733 4.78233 10.2171C4.62612 10.0609 4.37285 10.0609 4.21664 10.2171L2.89949 11.5342L2.89949 3.4656L4.21664 4.78276C4.37285 4.93897 4.62612 4.93897 4.78233 4.78276C4.93854 4.62655 4.93854 4.37328 4.78233 4.21707L2.78233 2.21707ZM10.5 2.74997C10.7107 2.74997 10.8988 2.88211 10.9703 3.08036L13.9703 11.3999C14.064 11.6597 13.9293 11.9462 13.6696 12.0399C13.4098 12.1336 13.1233 11.9989 13.0296 11.7392L12.0477 9.016H8.95228L7.97033 11.7392C7.87666 11.9989 7.59013 12.1336 7.33036 12.0399C7.07059 11.9462 6.93595 11.6597 7.02962 11.3999L10.0296 3.08036C10.1011 2.88211 10.2892 2.74997 10.5 2.74997ZM10.5 4.72396L11.7412 8.166H9.25879L10.5 4.72396Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2i = [
    "color"
];
var $6431ef21eafb1f5a$export$805712ff48c03e2e = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2i);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.03791 9.98075C0.934777 9.6583 1.11603 9.37719 1.40005 9.24871C1.68408 9.12022 2.09463 9.13412 2.27071 9.45426C2.85393 10.5147 3.64599 10.7282 4.48665 10.7282C5.52721 10.7282 6.29659 10.2615 6.29659 9.45426C6.29659 8.8047 5.9119 8.46416 4.87134 8.14253L4.15872 7.92181C2.64518 7.44883 1.88842 6.69206 1.88842 5.45601C1.88842 3.79743 3.27583 2.6875 5.24342 2.6875C6.91733 2.6875 7.97409 3.33536 8.43833 4.31065C8.57087 4.58909 8.57614 4.91294 8.22794 5.19114C7.87974 5.46934 7.52351 5.34799 7.23327 5.03839C6.47215 4.22653 5.99545 4.04968 5.25604 4.04968C4.1398 4.04968 3.547 4.63618 3.547 5.27943C3.547 5.86592 3.96322 6.23169 4.94702 6.5344L5.67856 6.76143C7.22994 7.23441 7.97409 7.95964 7.97409 9.17047C7.97409 10.7723 6.69389 12.0903 4.46143 12.0903C2.86612 12.0903 1.40005 11.1131 1.03791 9.98075ZM11.8491 8.77985C10.661 8.39543 10.1649 7.86114 10.1649 6.98805C10.1649 5.86736 11.1636 5.04639 12.6128 5.04639C13.8546 5.04639 14.6629 5.63345 14.9778 6.6346C15.0443 6.84599 14.9593 6.98006 14.7475 7.0491C14.5394 7.11697 14.3176 7.09974 14.238 6.89611C13.9356 6.12273 13.352 5.76311 12.5998 5.76311C11.6467 5.76311 11.0135 6.25178 11.0135 6.91638C11.0135 7.45066 11.3464 7.75038 12.2473 8.04358L12.8348 8.23254C14.062 8.62999 14.5516 9.13821 14.5516 10.0178C14.5516 11.1972 13.481 12.0442 11.9927 12.0442C10.6439 12.0442 9.65644 11.2809 9.41979 10.3361C9.36535 10.1188 9.41192 10.0287 9.70039 9.96184C9.98886 9.89499 10.0714 9.89918 10.1715 10.1369C10.4555 10.8114 11.1531 11.3275 12.0318 11.3275C12.9914 11.3275 13.6834 10.7802 13.6834 10.0634C13.6834 9.53567 13.3961 9.28807 12.4366 8.97532L11.8491 8.77985Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2j = [
    "color"
];
var $6431ef21eafb1f5a$export$bbfc12447ec5dbe8 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2j);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V4H5V1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5V4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H4V10H1.5C1.22386 10 1 10.2239 1 10.5C1 10.7761 1.22386 11 1.5 11H4V13.5C4 13.7761 4.22386 14 4.5 14C4.77614 14 5 13.7761 5 13.5V11H10V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H11V5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H11V1.5ZM10 10V5H5V10H10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2k = [
    "color"
];
var $6431ef21eafb1f5a$export$49fa3bb64381879 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2k);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.3825 1.29567C3.46241 1.11432 3.64188 0.997284 3.84005 0.997284H11.5C11.7761 0.997284 12 1.22114 12 1.49728V5.5C12 5.77614 11.7761 6 11.5 6H8.63521L11.5288 9.16247C11.6626 9.3087 11.6974 9.52015 11.6175 9.70154C11.5376 9.88293 11.3582 10 11.16 10H8V13.5C8 13.7022 7.87818 13.8845 7.69134 13.9619C7.5045 14.0393 7.28945 13.9966 7.14645 13.8536L3.14645 9.85355C3.05268 9.75979 3 9.63261 3 9.5V5.5C3 5.22386 3.22386 5 3.5 5H6.36531L3.47105 1.83468C3.33732 1.68844 3.30259 1.47701 3.3825 1.29567ZM7.72032 5L4.97474 1.99728H11V5H7.72032ZM7.27978 6H4V9H7.5H10.0247L7.27978 6ZM4.70711 10L7 12.2929V10H4.70711Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2l = [
    "color"
];
var $6431ef21eafb1f5a$export$70208e77f6c45b17 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2l);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.07095 0.650238C6.67391 0.650238 6.32977 0.925096 6.24198 1.31231L6.0039 2.36247C5.6249 2.47269 5.26335 2.62363 4.92436 2.81013L4.01335 2.23585C3.67748 2.02413 3.23978 2.07312 2.95903 2.35386L2.35294 2.95996C2.0722 3.2407 2.0232 3.6784 2.23493 4.01427L2.80942 4.92561C2.62307 5.2645 2.47227 5.62594 2.36216 6.00481L1.31209 6.24287C0.924883 6.33065 0.650024 6.6748 0.650024 7.07183V7.92897C0.650024 8.32601 0.924883 8.67015 1.31209 8.75794L2.36228 8.99603C2.47246 9.375 2.62335 9.73652 2.80979 10.0755L2.2354 10.9867C2.02367 11.3225 2.07267 11.7602 2.35341 12.041L2.95951 12.6471C3.24025 12.9278 3.67795 12.9768 4.01382 12.7651L4.92506 12.1907C5.26384 12.377 5.62516 12.5278 6.0039 12.6379L6.24198 13.6881C6.32977 14.0753 6.67391 14.3502 7.07095 14.3502H7.92809C8.32512 14.3502 8.66927 14.0753 8.75705 13.6881L8.99505 12.6383C9.37411 12.5282 9.73573 12.3773 10.0748 12.1909L10.986 12.7653C11.3218 12.977 11.7595 12.928 12.0403 12.6473L12.6464 12.0412C12.9271 11.7604 12.9761 11.3227 12.7644 10.9869L12.1902 10.076C12.3768 9.73688 12.5278 9.37515 12.638 8.99596L13.6879 8.75794C14.0751 8.67015 14.35 8.32601 14.35 7.92897V7.07183C14.35 6.6748 14.0751 6.33065 13.6879 6.24287L12.6381 6.00488C12.528 5.62578 12.3771 5.26414 12.1906 4.92507L12.7648 4.01407C12.9766 3.6782 12.9276 3.2405 12.6468 2.95975L12.0407 2.35366C11.76 2.07292 11.3223 2.02392 10.9864 2.23565L10.0755 2.80989C9.73622 2.62328 9.37437 2.47229 8.99505 2.36209L8.75705 1.31231C8.66927 0.925096 8.32512 0.650238 7.92809 0.650238H7.07095ZM4.92053 3.81251C5.44724 3.44339 6.05665 3.18424 6.71543 3.06839L7.07095 1.50024H7.92809L8.28355 3.06816C8.94267 3.18387 9.5524 3.44302 10.0794 3.81224L11.4397 2.9547L12.0458 3.56079L11.1882 4.92117C11.5573 5.44798 11.8164 6.0575 11.9321 6.71638L13.5 7.07183V7.92897L11.932 8.28444C11.8162 8.94342 11.557 9.55301 11.1878 10.0798L12.0453 11.4402L11.4392 12.0462L10.0787 11.1886C9.55192 11.5576 8.94241 11.8166 8.28355 11.9323L7.92809 13.5002H7.07095L6.71543 11.932C6.0569 11.8162 5.44772 11.5572 4.92116 11.1883L3.56055 12.046L2.95445 11.4399L3.81213 10.0794C3.4431 9.55266 3.18403 8.94326 3.06825 8.2845L1.50002 7.92897V7.07183L3.06818 6.71632C3.18388 6.05765 3.44283 5.44833 3.81171 4.92165L2.95398 3.561L3.56008 2.95491L4.92053 3.81251ZM9.02496 7.50008C9.02496 8.34226 8.34223 9.02499 7.50005 9.02499C6.65786 9.02499 5.97513 8.34226 5.97513 7.50008C5.97513 6.65789 6.65786 5.97516 7.50005 5.97516C8.34223 5.97516 9.02496 6.65789 9.02496 7.50008ZM9.92496 7.50008C9.92496 8.83932 8.83929 9.92499 7.50005 9.92499C6.1608 9.92499 5.07513 8.83932 5.07513 7.50008C5.07513 6.16084 6.1608 5.07516 7.50005 5.07516C8.83929 5.07516 9.92496 6.16084 9.92496 7.50008Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2m = [
    "color"
];
var $6431ef21eafb1f5a$export$9a0862960670d05c = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2m);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49933 0.25C3.49635 0.25 0.25 3.49593 0.25 7.50024C0.25 10.703 2.32715 13.4206 5.2081 14.3797C5.57084 14.446 5.70302 14.2222 5.70302 14.0299C5.70302 13.8576 5.69679 13.4019 5.69323 12.797C3.67661 13.235 3.25112 11.825 3.25112 11.825C2.92132 10.9874 2.44599 10.7644 2.44599 10.7644C1.78773 10.3149 2.49584 10.3238 2.49584 10.3238C3.22353 10.375 3.60629 11.0711 3.60629 11.0711C4.25298 12.1788 5.30335 11.8588 5.71638 11.6732C5.78225 11.205 5.96962 10.8854 6.17658 10.7043C4.56675 10.5209 2.87415 9.89918 2.87415 7.12104C2.87415 6.32925 3.15677 5.68257 3.62053 5.17563C3.54576 4.99226 3.29697 4.25521 3.69174 3.25691C3.69174 3.25691 4.30015 3.06196 5.68522 3.99973C6.26337 3.83906 6.8838 3.75895 7.50022 3.75583C8.1162 3.75895 8.73619 3.83906 9.31523 3.99973C10.6994 3.06196 11.3069 3.25691 11.3069 3.25691C11.7026 4.25521 11.4538 4.99226 11.3795 5.17563C11.8441 5.68257 12.1245 6.32925 12.1245 7.12104C12.1245 9.9063 10.4292 10.5192 8.81452 10.6985C9.07444 10.9224 9.30633 11.3648 9.30633 12.0413C9.30633 13.0102 9.29742 13.7922 9.29742 14.0299C9.29742 14.2239 9.42828 14.4496 9.79591 14.3788C12.6746 13.4179 14.75 10.7025 14.75 7.50024C14.75 3.49593 11.5036 0.25 7.49933 0.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2n = [
    "color"
];
var $6431ef21eafb1f5a$export$a70e2e549144f66 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2n);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49996 1.80002C4.35194 1.80002 1.79996 4.352 1.79996 7.50002C1.79996 10.648 4.35194 13.2 7.49996 13.2C10.648 13.2 13.2 10.648 13.2 7.50002C13.2 4.352 10.648 1.80002 7.49996 1.80002ZM0.899963 7.50002C0.899963 3.85494 3.85488 0.900024 7.49996 0.900024C11.145 0.900024 14.1 3.85494 14.1 7.50002C14.1 11.1451 11.145 14.1 7.49996 14.1C3.85488 14.1 0.899963 11.1451 0.899963 7.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        d: "M13.4999 7.89998H1.49994V7.09998H13.4999V7.89998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.09991 13.5V1.5H7.89991V13.5H7.09991zM10.375 7.49998C10.375 5.32724 9.59364 3.17778 8.06183 1.75656L8.53793 1.24341C10.2396 2.82218 11.075 5.17273 11.075 7.49998 11.075 9.82724 10.2396 12.1778 8.53793 13.7566L8.06183 13.2434C9.59364 11.8222 10.375 9.67273 10.375 7.49998zM3.99969 7.5C3.99969 5.17611 4.80786 2.82678 6.45768 1.24719L6.94177 1.75281C5.4582 3.17323 4.69969 5.32389 4.69969 7.5 4.6997 9.67611 5.45822 11.8268 6.94179 13.2472L6.45769 13.7528C4.80788 12.1732 3.9997 9.8239 3.99969 7.5z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49996 3.95801C9.66928 3.95801 11.8753 4.35915 13.3706 5.19448 13.5394 5.28875 13.5998 5.50197 13.5055 5.67073 13.4113 5.83948 13.198 5.89987 13.0293 5.8056 11.6794 5.05155 9.60799 4.65801 7.49996 4.65801 5.39192 4.65801 3.32052 5.05155 1.97064 5.8056 1.80188 5.89987 1.58866 5.83948 1.49439 5.67073 1.40013 5.50197 1.46051 5.28875 1.62927 5.19448 3.12466 4.35915 5.33063 3.95801 7.49996 3.95801zM7.49996 10.85C9.66928 10.85 11.8753 10.4488 13.3706 9.6135 13.5394 9.51924 13.5998 9.30601 13.5055 9.13726 13.4113 8.9685 13.198 8.90812 13.0293 9.00238 11.6794 9.75643 9.60799 10.15 7.49996 10.15 5.39192 10.15 3.32052 9.75643 1.97064 9.00239 1.80188 8.90812 1.58866 8.9685 1.49439 9.13726 1.40013 9.30601 1.46051 9.51924 1.62927 9.6135 3.12466 10.4488 5.33063 10.85 7.49996 10.85z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2o = [
    "color"
];
var $6431ef21eafb1f5a$export$fa17e9a974485717 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2o);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M12.5 2H8V7H13V2.5C13 2.22386 12.7761 2 12.5 2ZM13 8H8V13H12.5C12.7761 13 13 12.7761 13 12.5V8ZM7 7V2H2.5C2.22386 2 2 2.22386 2 2.5V7H7ZM2 8V12.5C2 12.7761 2.22386 13 2.5 13H7V8H2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2p = [
    "color"
];
var $6431ef21eafb1f5a$export$97eeb400c5f33310 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2p);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.44995 0.949951C1.31734 0.949951 1.19016 1.00263 1.0964 1.0964C1.00263 1.19017 0.949951 1.31735 0.949951 1.44995L0.949966 3.44995C0.949969 3.7261 1.17383 3.94995 1.44997 3.94995C1.72611 3.94995 1.94997 3.72609 1.94997 3.44995L1.94995 1.94995H3.44997C3.72611 1.94995 3.94997 1.72609 3.94997 1.44995C3.94997 1.17381 3.72611 0.949951 3.44997 0.949951H1.44995ZM5.94995 0.949951C5.67381 0.949951 5.44995 1.17381 5.44995 1.44995C5.44995 1.72609 5.67381 1.94995 5.94995 1.94995H8.94995C9.22609 1.94995 9.44995 1.72609 9.44995 1.44995C9.44995 1.17381 9.22609 0.949951 8.94995 0.949951H5.94995ZM5.44995 13.45C5.44995 13.1738 5.67381 12.95 5.94995 12.95H8.94995C9.22609 12.95 9.44995 13.1738 9.44995 13.45C9.44995 13.7261 9.22609 13.95 8.94995 13.95H5.94995C5.67381 13.95 5.44995 13.7261 5.44995 13.45ZM1.94995 5.94995C1.94995 5.67381 1.72609 5.44995 1.44995 5.44995C1.17381 5.44995 0.949951 5.67381 0.949951 5.94995V8.94995C0.949951 9.22609 1.17381 9.44995 1.44995 9.44995C1.72609 9.44995 1.94995 9.22609 1.94995 8.94995V5.94995ZM13.45 5.44995C13.7261 5.44995 13.95 5.67381 13.95 5.94995V8.94995C13.95 9.22609 13.7261 9.44995 13.45 9.44995C13.1738 9.44995 12.95 9.22609 12.95 8.94995V5.94995C12.95 5.67381 13.1738 5.44995 13.45 5.44995ZM11.45 0.949951C11.1738 0.949951 10.95 1.17381 10.95 1.44995C10.95 1.72609 11.1738 1.94995 11.45 1.94995H12.9499V3.44995C12.9499 3.72609 13.1738 3.94995 13.4499 3.94995C13.7261 3.94995 13.9499 3.72609 13.9499 3.44995V1.44995C13.9499 1.17381 13.7252 0.949951 13.449 0.949951H11.45ZM1.44995 10.95C1.72609 10.95 1.94995 11.1738 1.94995 11.45V12.95H3.44997C3.72611 12.95 3.94997 13.1738 3.94997 13.45C3.94997 13.7261 3.72611 13.95 3.44997 13.95H1.44995C1.17381 13.95 0.949951 13.7261 0.949951 13.45V11.45C0.949951 11.1738 1.17381 10.95 1.44995 10.95ZM13.95 11.45C13.95 11.1738 13.7261 10.95 13.45 10.95C13.1738 10.9499 12.95 11.1738 12.95 11.4499L12.9491 12.95H11.45C11.1738 12.95 10.95 13.1738 10.95 13.45C10.95 13.7261 11.1738 13.95 11.45 13.95H13.4499C13.7261 13.95 13.9499 13.7261 13.9499 13.45L13.95 11.45Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2q = [
    "color"
];
var $6431ef21eafb1f5a$export$1106febb4d651860 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2q);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM7.00003 1.84861C4.10114 2.1017 1.82707 4.53515 1.82707 7.49972C1.82707 10.4643 4.10114 12.8977 7.00003 13.1508V1.84861ZM8.00003 13.1508C10.8988 12.8976 13.1727 10.4642 13.1727 7.49972C13.1727 4.53524 10.8988 2.10185 8.00003 1.84864V13.1508Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2r = [
    "color"
];
var $6431ef21eafb1f5a$export$991e44cd0549467c = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2r);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM7.49988 1.82689C4.36688 1.8269 1.82707 4.36672 1.82707 7.49972C1.82707 10.6327 4.36688 13.1725 7.49988 13.1726V1.82689Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2s = [
    "color"
];
var $6431ef21eafb1f5a$export$ea8e5ed9f4a6e89d = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2s);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2t = [
    "color"
];
var $6431ef21eafb1f5a$export$f9eb84fdaa009a42 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2t);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M6.8113 1.64706C6.62188 2.87918 6.68268 3.88523 6.76848 5.30499C6.78415 5.56426 6.80065 5.83732 6.81661 6.12808C6.83111 6.39208 6.63758 6.62172 6.37495 6.65217C6.11232 6.68262 5.87138 6.50334 5.82509 6.24304L5.74754 5.80698C5.64402 5.16529 5.48355 4.25481 5.17807 3.44741C4.86241 2.61312 4.4486 2.04121 3.93436 1.86044C3.64994 1.76104 3.41901 1.84279 3.25868 2.01052C3.08746 2.18962 2.9976 2.47065 3.0627 2.75399C3.2146 3.34424 3.44627 3.9167 3.69836 4.51802C3.72082 4.57158 3.74346 4.62543 3.76621 4.67954C3.9954 5.22457 4.23619 5.7972 4.41644 6.39081L4.41691 6.39238C4.562 6.87586 4.65646 7.2595 4.73086 7.56165C4.76034 7.68138 4.78667 7.78831 4.81175 7.88359C4.86768 8.09606 4.77836 8.32014 4.59161 8.43588C4.40486 8.55161 4.16445 8.53188 3.99907 8.38725C3.73749 8.15848 3.515 7.92784 3.31817 7.71802C3.27627 7.67335 3.23602 7.63018 3.19705 7.58838C3.04777 7.42826 2.91712 7.28812 2.78334 7.16029C2.45989 6.85122 2.18398 6.68004 1.80585 6.64369L1.80324 6.64343C1.56117 6.61888 1.41402 6.66441 1.31756 6.72627C1.21899 6.78947 1.11988 6.90414 1.03784 7.1123C0.976576 7.28492 1.01515 7.62987 1.1929 7.96911L1.19728 7.97747C1.40086 8.38452 1.74475 8.81587 2.18141 9.29299C2.39739 9.52898 2.62872 9.76849 2.86934 10.0174L2.87966 10.0281C3.11546 10.2721 3.35962 10.5247 3.59713 10.7827C4.4288 11.6863 5.27706 12.7538 5.4627 14H11.5087C11.5636 12.4353 11.8756 11.268 12.2875 10.1346C12.4454 9.70041 12.6121 9.28412 12.7826 8.85829C13.1097 8.04139 13.4509 7.18937 13.7705 6.10824C14.0989 4.99737 14.0097 4.37033 13.8613 4.03984C13.717 3.71858 13.4914 3.61786 13.3816 3.59606C13.1381 3.54774 13.0384 3.60947 12.9698 3.67901C12.867 3.78316 12.7698 3.98273 12.6921 4.30269C12.6166 4.61345 12.5752 4.96517 12.533 5.32501L12.5298 5.35285C12.4924 5.67242 12.4505 6.03016 12.3665 6.30098C12.3383 6.40699 12.2819 6.50407 12.1979 6.57539C12.1382 6.6261 12.0104 6.70818 11.8309 6.69312C11.5424 6.66891 11.3712 6.42143 11.365 6.14783C11.356 5.75454 11.3883 5.35864 11.4074 4.96608C11.4428 4.23646 11.477 3.5337 11.4245 2.8342L11.4242 2.82934C11.3916 2.32997 11.0493 2.00228 10.7007 1.9228C10.5305 1.88401 10.369 1.90601 10.2347 1.9835C10.103 2.05946 9.95535 2.21318 9.8574 2.51394L9.85631 2.51726C9.81525 2.6404 9.77298 2.87753 9.73606 3.2124C9.70044 3.53542 9.67337 3.91279 9.65156 4.29418C9.6329 4.62033 9.61785 4.9584 9.60434 5.26194C9.58728 5.64529 9.57267 5.97357 9.55633 6.1532C9.54983 6.22459 9.52939 6.29493 9.49501 6.35785C9.47356 6.39711 9.36115 6.60947 9.07106 6.61843C8.77917 6.62744 8.63975 6.40057 8.61698 6.35919C8.55634 6.24899 8.55066 6.11807 8.54754 5.99283C8.54474 5.88064 8.54294 5.71798 8.54174 5.54767C8.53935 5.20582 8.53935 4.81919 8.53935 4.70952C8.53935 3.6657 8.53838 2.65372 8.44714 1.64372C8.39183 1.24127 8.06278 1.00455 7.6436 1.00005C7.22399 0.995552 6.87918 1.22704 6.8113 1.64706ZM9.41219 1.3617C9.21469 0.448484 8.39913 0.00810324 7.65433 0.00011154C6.86452 -0.00836308 5.98761 0.465881 5.82365 1.49037L5.82318 1.49334C5.78239 1.7584 5.75229 2.01481 5.7309 2.26652C5.39423 1.67364 4.92622 1.14894 4.2655 0.916859C3.58661 0.679312 2.9492 0.887087 2.53582 1.31952C2.13415 1.73971 1.94438 2.36742 2.09031 2.98746L2.09269 2.99713C2.26478 3.66808 2.52396 4.30316 2.77613 4.90465C2.79814 4.95717 2.8201 5.00941 2.84194 5.06139C3.02139 5.48842 3.19378 5.89866 3.33871 6.31256C2.96404 5.98142 2.51925 5.70796 1.90276 5.6484C1.48865 5.60663 1.10391 5.67536 0.777805 5.88444C0.454239 6.0919 0.240671 6.40405 0.104187 6.75406L0.100868 6.76281C-0.10184 7.31286 0.0663312 7.97157 0.304895 8.42897C0.573704 8.96474 0.996104 9.47904 1.44372 9.96813C1.67046 10.2159 1.91136 10.4652 2.15033 10.7124L2.15682 10.7191C2.39524 10.9658 2.63217 11.2109 2.86134 11.4599C3.80937 12.49 4.50002 13.4632 4.50002 14.5C4.50002 14.7761 4.72388 15 5.00002 15H12C12.2762 15 12.5 14.7761 12.5 14.5C12.5 12.8212 12.8021 11.6462 13.2274 10.4762C13.3653 10.0968 13.5216 9.70579 13.6868 9.29247C14.0238 8.44922 14.398 7.51298 14.7295 6.39175C15.0956 5.15324 15.0559 4.25904 14.7735 3.63017C14.487 2.99208 13.9798 2.6953 13.5763 2.6152C13.1276 2.52614 12.7367 2.60475 12.4268 2.83081C12.4253 2.80773 12.4236 2.78468 12.4219 2.76167C12.3587 1.8105 11.6907 1.12285 10.923 0.947821C10.5346 0.859287 10.1111 0.900393 9.73509 1.11724C9.61852 1.18446 9.51055 1.26623 9.41219 1.3617Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2u = [
    "color"
];
var $6431ef21eafb1f5a$export$635e9dadffe43ee = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2u);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8.75432 2.0502C8.50579 2.0502 8.30432 2.25167 8.30432 2.5002C8.30432 2.74873 8.50579 2.9502 8.75432 2.9502H9.94997V7.05004H5.04997V2.9502H6.25432C6.50285 2.9502 6.70432 2.74873 6.70432 2.5002C6.70432 2.25167 6.50285 2.0502 6.25432 2.0502H2.75432C2.50579 2.0502 2.30432 2.25167 2.30432 2.5002C2.30432 2.74873 2.50579 2.9502 2.75432 2.9502H3.94997V12.0502H2.75432C2.50579 12.0502 2.30432 12.2517 2.30432 12.5002C2.30432 12.7487 2.50579 12.9502 2.75432 12.9502H6.25432C6.50285 12.9502 6.70432 12.7487 6.70432 12.5002C6.70432 12.2517 6.50285 12.0502 6.25432 12.0502H5.04997V7.95004H9.94997V12.0502H8.75432C8.50579 12.0502 8.30432 12.2517 8.30432 12.5002C8.30432 12.7487 8.50579 12.9502 8.75432 12.9502H12.2543C12.5028 12.9502 12.7043 12.7487 12.7043 12.5002C12.7043 12.2517 12.5028 12.0502 12.2543 12.0502H11.05V2.9502H12.2543C12.5028 2.9502 12.7043 2.74873 12.7043 2.5002C12.7043 2.25167 12.5028 2.0502 12.2543 2.0502H8.75432Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2v = [
    "color"
];
var $6431ef21eafb1f5a$export$16f03ed71cfb60c9 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2v);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.89346 2.35248C3.49195 2.35248 2.35248 3.49359 2.35248 4.90532C2.35248 6.38164 3.20954 7.9168 4.37255 9.33522C5.39396 10.581 6.59464 11.6702 7.50002 12.4778C8.4054 11.6702 9.60608 10.581 10.6275 9.33522C11.7905 7.9168 12.6476 6.38164 12.6476 4.90532C12.6476 3.49359 11.5081 2.35248 10.1066 2.35248C9.27059 2.35248 8.81894 2.64323 8.5397 2.95843C8.27877 3.25295 8.14623 3.58566 8.02501 3.88993C8.00391 3.9429 7.98315 3.99501 7.96211 4.04591C7.88482 4.23294 7.7024 4.35494 7.50002 4.35494C7.29765 4.35494 7.11523 4.23295 7.03793 4.04592C7.01689 3.99501 6.99612 3.94289 6.97502 3.8899C6.8538 3.58564 6.72126 3.25294 6.46034 2.95843C6.18109 2.64323 5.72945 2.35248 4.89346 2.35248ZM1.35248 4.90532C1.35248 2.94498 2.936 1.35248 4.89346 1.35248C6.0084 1.35248 6.73504 1.76049 7.20884 2.2953C7.32062 2.42147 7.41686 2.55382 7.50002 2.68545C7.58318 2.55382 7.67941 2.42147 7.79119 2.2953C8.265 1.76049 8.99164 1.35248 10.1066 1.35248C12.064 1.35248 13.6476 2.94498 13.6476 4.90532C13.6476 6.74041 12.6013 8.50508 11.4008 9.96927C10.2636 11.3562 8.92194 12.5508 8.00601 13.3664C7.94645 13.4194 7.88869 13.4709 7.83291 13.5206C7.64324 13.6899 7.3568 13.6899 7.16713 13.5206C7.11135 13.4709 7.05359 13.4194 6.99403 13.3664C6.0781 12.5508 4.73641 11.3562 3.59926 9.96927C2.39872 8.50508 1.35248 6.74041 1.35248 4.90532Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2w = [
    "color"
];
var $6431ef21eafb1f5a$export$b4120a3a3b5e8fcd = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2w);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.35248 4.90532C1.35248 2.94498 2.936 1.35248 4.89346 1.35248C6.25769 1.35248 6.86058 1.92336 7.50002 2.93545C8.13946 1.92336 8.74235 1.35248 10.1066 1.35248C12.064 1.35248 13.6476 2.94498 13.6476 4.90532C13.6476 6.74041 12.6013 8.50508 11.4008 9.96927C10.2636 11.3562 8.92194 12.5508 8.00601 13.3664C7.94645 13.4194 7.88869 13.4709 7.83291 13.5206C7.64324 13.6899 7.3568 13.6899 7.16713 13.5206C7.11135 13.4709 7.05359 13.4194 6.99403 13.3664C6.0781 12.5508 4.73641 11.3562 3.59926 9.96927C2.39872 8.50508 1.35248 6.74041 1.35248 4.90532Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2x = [
    "color"
];
var $6431ef21eafb1f5a$export$141e350c1bf9e61a = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2x);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.1813 1.68179C7.35704 1.50605 7.64196 1.50605 7.8177 1.68179L10.3177 4.18179C10.4934 4.35753 10.4934 4.64245 10.3177 4.81819C10.142 4.99392 9.85704 4.99392 9.6813 4.81819L7.9495 3.08638L7.9495 11.9136L9.6813 10.1818C9.85704 10.0061 10.142 10.0061 10.3177 10.1818C10.4934 10.3575 10.4934 10.6424 10.3177 10.8182L7.8177 13.3182C7.73331 13.4026 7.61885 13.45 7.4995 13.45C7.38015 13.45 7.26569 13.4026 7.1813 13.3182L4.6813 10.8182C4.50557 10.6424 4.50557 10.3575 4.6813 10.1818C4.85704 10.0061 5.14196 10.0061 5.3177 10.1818L7.0495 11.9136L7.0495 3.08638L5.3177 4.81819C5.14196 4.99392 4.85704 4.99392 4.6813 4.81819C4.50557 4.64245 4.50557 4.35753 4.6813 4.18179L7.1813 1.68179Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2y = [
    "color"
];
var $6431ef21eafb1f5a$export$9360f6250c6c6a8c = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2y);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M12.3536 13.3536C12.1583 13.5488 11.8417 13.5488 11.6465 13.3536L6.39645 8.10355C6.36478 8.07188 6.33824 8.03702 6.31685 8H5.00002C4.78719 8 4.59769 7.86528 4.52777 7.66426L2.12777 0.764277C2.05268 0.548387 2.13355 0.309061 2.3242 0.182972C2.51486 0.0568819 2.76674 0.0761337 2.93602 0.229734L8.336 5.12972C8.44044 5.22449 8.50001 5.35897 8.50001 5.5V5.81684C8.53702 5.83824 8.57189 5.86478 8.60356 5.89645L13.8536 11.1464C14.0488 11.3417 14.0488 11.6583 13.8536 11.8536L12.3536 13.3536ZM8.25 6.95711L7.45711 7.75L12 12.2929L12.7929 11.5L8.25 6.95711ZM3.71669 2.28845L5.35549 7H6.2929L7.50001 5.79289V5.72146L3.71669 2.28845Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2z = [
    "color"
];
var $6431ef21eafb1f5a$export$92c8767b874048d = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2z);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.07926 0.222253C7.31275 -0.007434 7.6873 -0.007434 7.92079 0.222253L14.6708 6.86227C14.907 7.09465 14.9101 7.47453 14.6778 7.71076C14.4454 7.947 14.0655 7.95012 13.8293 7.71773L13 6.90201V12.5C13 12.7761 12.7762 13 12.5 13H2.50002C2.22388 13 2.00002 12.7761 2.00002 12.5V6.90201L1.17079 7.71773C0.934558 7.95012 0.554672 7.947 0.32229 7.71076C0.0899079 7.47453 0.0930283 7.09465 0.32926 6.86227L7.07926 0.222253ZM7.50002 1.49163L12 5.91831V12H10V8.49999C10 8.22385 9.77617 7.99999 9.50002 7.99999H6.50002C6.22388 7.99999 6.00002 8.22385 6.00002 8.49999V12H3.00002V5.91831L7.50002 1.49163ZM7.00002 12H9.00002V8.99999H7.00002V12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2A = [
    "color"
];
var $6431ef21eafb1f5a$export$13a4588734565757 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2A);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.5 0.0032959C6.80473 0.0032959 6.24953 0.281106 6.25 0.749995C6.25 0.997258 6.42446 1.12014 6.57687 1.22749C6.69507 1.31074 6.8 1.38465 6.8 1.5C6.8 1.7071 6.06224 1.74264 5.19789 1.78427C3.97553 1.84314 2.5 1.91421 2.5 2.5C2.5 2.77614 2.72386 3 3 3H12C12.2761 3 12.5 2.77614 12.5 2.5C12.5 1.91421 11.0245 1.84314 9.80211 1.78427C8.93776 1.74264 8.2 1.7071 8.2 1.5C8.2 1.38465 8.30493 1.31074 8.42313 1.22749C8.57554 1.12014 8.75 0.997258 8.75 0.749995C8.75047 0.281106 8.19527 0.0032959 7.5 0.0032959ZM2.89451 6.12266C2.25806 6.52471 1.90417 7.31118 2.02473 8.0556L2.83588 12.4772C3.00993 13.3562 3.7629 14 4.66061 14H10.3373C11.2354 14 11.9884 13.3562 12.1625 12.4772L12.9736 8.05607C13.089 7.32358 12.8284 6.53276 12.1331 6.09373C11.7283 5.83013 11.6412 5.33231 12.1331 5.12796C12.8284 4.86435 12.6948 4 12 4H10.3001H6.80005H2.99996C2.30469 4 2.19878 4.89328 2.89451 5.15689C3.38642 5.33231 3.29939 5.83013 2.89451 6.12266ZM8.20006 6.25C8.20006 5.81769 8.08572 5.37615 7.90635 5L4.11093 5C4.20626 5.21312 4.2419 5.43889 4.22904 5.65521C4.19522 6.22412 3.84587 6.66899 3.48016 6.93322L3.45492 6.95146L3.42858 6.9681C3.13407 7.15414 2.95801 7.53989 3.01058 7.88749L3.81797 12.2886C3.90513 12.7154 4.26148 13 4.66061 13H10.3373C10.737 13 11.0932 12.7153 11.1804 12.2886L11.9874 7.8898C12.048 7.48247 11.8954 7.12631 11.5992 6.93927L11.5875 6.93184L11.5875 6.93176C11.1947 6.67602 10.8331 6.22785 10.7986 5.64798C10.7846 5.412 10.8264 5.19397 10.9112 5H9.05517C9.01987 5.14611 9.00006 5.31201 9.00006 5.5C9.00006 5.9745 9.21679 6.37127 9.44367 6.78662C9.69284 7.24278 9.95425 7.72136 9.95425 8.34993C9.95425 9.2698 9.49868 9.84205 8.62189 9.84205C8.13206 9.84205 7.57818 9.46097 7.57818 8.75781C7.57818 8.35279 7.71558 8.01646 7.86121 7.65998C8.0254 7.25806 8.20006 6.83051 8.20006 6.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2B = [
    "color"
];
var $6431ef21eafb1f5a$export$583b57cdbe59a84e = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2B);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M14 11.0001V4.00006L1 4.00006L1 11.0001H14ZM15 4.00006V11.0001C15 11.5523 14.5523 12.0001 14 12.0001H1C0.447715 12.0001 0 11.5523 0 11.0001V4.00006C0 3.44778 0.447715 3.00006 1 3.00006H14C14.5523 3.00006 15 3.44778 15 4.00006ZM2 5.25C2 5.11193 2.11193 5 2.25 5H5.75C5.88807 5 6 5.11193 6 5.25V9.75C6 9.88807 5.88807 10 5.75 10H2.25C2.11193 10 2 9.88807 2 9.75V5.25ZM7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H7.5ZM7 9.5C7 9.22386 7.22386 9 7.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H7.5C7.22386 10 7 9.77614 7 9.5ZM7.5 5C7.22386 5 7 5.22386 7 5.5C7 5.77614 7.22386 6 7.5 6H11.5C11.7761 6 12 5.77614 12 5.5C12 5.22386 11.7761 5 11.5 5H7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2C = [
    "color"
];
var $6431ef21eafb1f5a$export$4a122bafaa48b23d = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2C);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2D = [
    "color"
];
var $6431ef21eafb1f5a$export$7a1b52edf33ca2d9 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2D);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2E = [
    "color"
];
var $6431ef21eafb1f5a$export$f8fea9f50a4bfae6 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2E);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M6.5 1C6.22386 1 6 1.22386 6 1.5C6 1.77614 6.22386 2 6.5 2C7.12671 2 7.45718 2.20028 7.65563 2.47812C7.8781 2.78957 8 3.28837 8 4V11C8 11.7116 7.8781 12.2104 7.65563 12.5219C7.45718 12.7997 7.12671 13 6.5 13C6.22386 13 6 13.2239 6 13.5C6 13.7761 6.22386 14 6.5 14C7.37329 14 8.04282 13.7003 8.46937 13.1031C8.47976 13.0886 8.48997 13.0739 8.5 13.0591C8.51003 13.0739 8.52024 13.0886 8.53063 13.1031C8.95718 13.7003 9.62671 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.87329 13 9.54282 12.7997 9.34437 12.5219C9.1219 12.2104 9 11.7116 9 11V4C9 3.28837 9.1219 2.78957 9.34437 2.47812C9.54282 2.20028 9.87329 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.62671 1 8.95718 1.29972 8.53063 1.89688C8.52024 1.91143 8.51003 1.92611 8.5 1.9409C8.48997 1.92611 8.47976 1.91143 8.46937 1.89688C8.04282 1.29972 7.37329 1 6.5 1ZM14 5H11V4H14C14.5523 4 15 4.44772 15 5V10C15 10.5523 14.5523 11 14 11H11V10H14V5ZM6 4V5H1L1 10H6V11H1C0.447715 11 0 10.5523 0 10V5C0 4.44772 0.447715 4 1 4H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2F = [
    "color"
];
var $6431ef21eafb1f5a$export$632f10cfe13035ff = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2F);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.9091 12.909C13.2365 12.5817 13.4918 12.1895 13.6588 11.7577C13.8195 11.3443 13.9294 10.8718 13.961 10.1799C13.9926 9.48665 14.0001 9.26529 14.0001 7.50001C14.0001 5.73473 13.9926 5.51328 13.961 4.82008C13.9294 4.12821 13.8195 3.65573 13.6588 3.24228C13.4956 2.80857 13.2398 2.41567 12.9091 2.091C12.5844 1.76028 12.1915 1.50437 11.7578 1.34113C11.3443 1.18056 10.8718 1.0707 10.1799 1.03924C9.48675 1.00748 9.26537 1 7.50006 1C5.73476 1 5.51333 1.00748 4.82014 1.03912C4.12826 1.0707 3.65578 1.18056 3.24233 1.34125C2.80862 1.50447 2.41573 1.76032 2.09105 2.09098C1.76032 2.41563 1.5044 2.80852 1.34113 3.24225C1.18056 3.65573 1.0707 4.12821 1.03924 4.82008C1.00748 5.51328 1 5.73471 1 7.50001C1 9.26532 1.00748 9.48675 1.03924 10.1799C1.07083 10.8718 1.18069 11.3443 1.34138 11.7577C1.5046 12.1915 1.76045 12.5843 2.09111 12.909C2.41578 13.2397 2.80867 13.4955 3.24238 13.6587C3.65586 13.8194 4.12834 13.9293 4.82019 13.9609C5.51348 13.9925 5.73483 14 7.50012 14C9.2654 14 9.48685 13.9925 10.18 13.9609C10.8719 13.9293 11.3444 13.8194 11.7578 13.6587C12.1896 13.4917 12.5818 13.2364 12.9091 12.909ZM1.99949 6.73496C1.99974 6.94524 2.00005 7.19543 2.00005 7.50002C2.00005 7.80461 1.99974 8.0548 1.99949 8.26507C1.99849 9.08596 1.99824 9.29856 2.01963 9.7655C2.04625 10.3509 2.07823 10.7811 2.17588 11.1053C2.26976 11.417 2.37505 11.7342 2.7188 12.1171C3.06255 12.4999 3.39411 12.6733 3.81645 12.8007C4.23879 12.928 4.7696 12.9554 5.23052 12.9764C5.75332 13.0003 5.96052 13.0002 7.05714 12.9999L7.50006 12.9999C7.79304 12.9999 8.03569 13.0001 8.2409 13.0004C9.08195 13.0013 9.29425 13.0015 9.76575 12.9799C10.3512 12.9533 10.7814 12.9213 11.1056 12.8237C11.4173 12.7298 11.7345 12.6245 12.1173 12.2807C12.5001 11.937 12.6735 11.6054 12.8009 11.1831C12.9283 10.7607 12.9557 10.2299 12.9767 9.76902C13.0005 9.24689 13.0004 9.04027 13.0002 7.94749V7.94738L13.0001 7.50039L13.0001 7.05747C13.0004 5.96085 13.0005 5.75365 12.9766 5.23085C12.9556 4.76993 12.9282 4.23912 12.8009 3.81678C12.6735 3.39445 12.5001 3.06288 12.1173 2.71913C11.7345 2.37538 11.4172 2.27009 11.1056 2.17621C10.7813 2.07856 10.3511 2.04658 9.76571 2.01996C9.29421 1.99836 9.08194 1.99859 8.24092 1.99951H8.24092C8.0357 1.99974 7.79305 2.00001 7.50006 2.00001L7.05704 1.99993C5.96051 1.99964 5.75331 1.99958 5.23052 2.02343C4.7696 2.04446 4.23879 2.07183 3.81645 2.19921C3.39411 2.32659 3.06255 2.49999 2.7188 2.88281C2.37505 3.26562 2.26976 3.58286 2.17588 3.89453C2.07823 4.21874 2.04625 4.64894 2.01963 5.23437C1.99824 5.70131 1.99849 5.91401 1.99949 6.73496ZM7.49996 5.25015C6.25741 5.25015 5.25012 6.25744 5.25012 7.49999C5.25012 8.74254 6.25741 9.74983 7.49996 9.74983C8.74251 9.74983 9.7498 8.74254 9.7498 7.49999C9.7498 6.25744 8.74251 5.25015 7.49996 5.25015ZM4.25012 7.49999C4.25012 5.70515 5.70512 4.25015 7.49996 4.25015C9.2948 4.25015 10.7498 5.70515 10.7498 7.49999C10.7498 9.29483 9.2948 10.7498 7.49996 10.7498C5.70512 10.7498 4.25012 9.29483 4.25012 7.49999ZM10.9697 4.7803C11.3839 4.7803 11.7197 4.44452 11.7197 4.0303C11.7197 3.61609 11.3839 3.2803 10.9697 3.2803C10.5555 3.2803 10.2197 3.61609 10.2197 4.0303C10.2197 4.44452 10.5555 4.7803 10.9697 4.7803Z",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2G = [
    "color"
];
var $6431ef21eafb1f5a$export$97dac707ecee26f6 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2G);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5 4H1.5C1.22386 4 1 4.22386 1 4.5V10.5C1 10.7761 1.22386 11 1.5 11H13.5C13.7761 11 14 10.7761 14 10.5V4.5C14 4.22386 13.7761 4 13.5 4ZM1.5 3C0.671573 3 0 3.67157 0 4.5V10.5C0 11.3284 0.671573 12 1.5 12H13.5C14.3284 12 15 11.3284 15 10.5V4.5C15 3.67157 14.3284 3 13.5 3H1.5ZM2 5H3V6H2V5ZM5 5H4V6H5V5ZM6 5H7V6H6V5ZM9 5H8V6H9V5ZM10 5H11V6H10V5ZM13 5H12V6H13V5ZM11 7H12V8H11V7ZM13 9H12V10H13V9ZM9 7H10V8H9V7ZM8 7H7V8H8V7ZM5 7H6V8H5V7ZM4 7H3V8H4V7ZM2 9H3V10H2V9ZM11 9H4V10H11V9Z",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2H = [
    "color"
];
var $6431ef21eafb1f5a$export$73ea89eab1c37fa2 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2H);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L12.058 2.05806C12.3021 1.81398 12.6978 1.81398 12.9419 2.05806C13.186 2.30214 13.186 2.69786 12.9419 2.94194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13361 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.49998 8.49998V4.09998C5.06992 4.09998 3.09998 6.06992 3.09998 8.49998C3.09998 10.93 5.06992 12.9 7.49998 12.9C8.715 12.9 9.815 12.4075 10.6112 11.6112L7.49998 8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2I = [
    "color"
];
var $6431ef21eafb1f5a$export$b94473071ddf9fbf = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2I);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2 4.25C2 4.11193 2.11193 4 2.25 4H12.75C12.8881 4 13 4.11193 13 4.25V11.5H2V4.25ZM2.25 3C1.55964 3 1 3.55964 1 4.25V12H0V12.5C0 12.7761 0.223858 13 0.5 13H14.5C14.7761 13 15 12.7761 15 12.5V12H14V4.25C14 3.55964 13.4404 3 12.75 3H2.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2J = [
    "color"
];
var $6431ef21eafb1f5a$export$a00948e6c38bedc8 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2J);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.75432 0.819537C7.59742 0.726821 7.4025 0.726821 7.24559 0.819537L1.74559 4.06954C1.59336 4.15949 1.49996 4.32317 1.49996 4.5C1.49996 4.67683 1.59336 4.84051 1.74559 4.93046L7.24559 8.18046C7.4025 8.27318 7.59742 8.27318 7.75432 8.18046L13.2543 4.93046C13.4066 4.84051 13.5 4.67683 13.5 4.5C13.5 4.32317 13.4066 4.15949 13.2543 4.06954L7.75432 0.819537ZM7.49996 7.16923L2.9828 4.5L7.49996 1.83077L12.0171 4.5L7.49996 7.16923ZM1.5695 7.49564C1.70998 7.2579 2.01659 7.17906 2.25432 7.31954L7.49996 10.4192L12.7456 7.31954C12.9833 7.17906 13.2899 7.2579 13.4304 7.49564C13.5709 7.73337 13.4921 8.03998 13.2543 8.18046L7.75432 11.4305C7.59742 11.5232 7.4025 11.5232 7.24559 11.4305L1.74559 8.18046C1.50786 8.03998 1.42901 7.73337 1.5695 7.49564ZM1.56949 10.4956C1.70998 10.2579 2.01658 10.1791 2.25432 10.3195L7.49996 13.4192L12.7456 10.3195C12.9833 10.1791 13.2899 10.2579 13.4304 10.4956C13.5709 10.7334 13.4921 11.04 13.2543 11.1805L7.75432 14.4305C7.59742 14.5232 7.4025 14.5232 7.24559 14.4305L1.74559 11.1805C1.50785 11.04 1.42901 10.7334 1.56949 10.4956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2K = [
    "color"
];
var $6431ef21eafb1f5a$export$b5c6e0b0c099878a = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2K);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M9 2H6V13H9V2ZM10 2V13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2H10ZM2.5 2H5V13H2.5C2.22386 13 2 12.7761 2 12.5V2.5C2 2.22386 2.22386 2 2.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2L = [
    "color"
];
var $6431ef21eafb1f5a$export$2d8928fe752eaf76 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2L);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.68979 2.75C3.89667 2.74979 4.08232 2.87701 4.15679 3.07003L7.36662 11.39C7.46602 11.6477 7.33774 11.9371 7.0801 12.0365C6.82247 12.1359 6.53304 12.0076 6.43365 11.75L5.3825 9.02537H2.01133L0.966992 11.749C0.868128 12.0068 0.578964 12.1357 0.321126 12.0369C0.0632878 11.938 -0.0655864 11.6488 0.0332774 11.391L3.22344 3.07099C3.29751 2.87782 3.4829 2.75021 3.68979 2.75ZM3.69174 4.64284L5.05458 8.17537H2.33724L3.69174 4.64284ZM10.8989 5.20703C9.25818 5.20703 8.00915 6.68569 8.00915 8.60972C8.00915 10.6337 9.35818 12.0124 10.8989 12.0124C11.7214 12.0124 12.5744 11.6692 13.1543 11.0219V11.53C13.1543 11.7785 13.3557 11.98 13.6043 11.98C13.8528 11.98 14.0543 11.7785 14.0543 11.53V5.72C14.0543 5.47147 13.8528 5.27 13.6043 5.27C13.3557 5.27 13.1543 5.47147 13.1543 5.72V6.22317C12.6054 5.60095 11.7924 5.20703 10.8989 5.20703ZM13.1543 9.79823V7.30195C12.7639 6.58101 11.9414 6.05757 11.0868 6.05757C10.1088 6.05757 9.03503 6.96581 9.03503 8.60955C9.03503 10.1533 10.0088 11.1615 11.0868 11.1615C11.9701 11.1615 12.7719 10.4952 13.1543 9.79823Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2M = [
    "color"
];
var $6431ef21eafb1f5a$export$ba5807ad0c0f9980 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2M);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.69899 5.20703C2.05823 5.20703 0.809204 6.68569 0.809204 8.60972C0.809204 10.6337 2.15823 12.0124 3.69899 12.0124C4.52126 12.0124 5.37402 11.6693 5.9539 11.0223V11.53C5.9539 11.7785 6.15537 11.98 6.4039 11.98C6.65243 11.98 6.8539 11.7785 6.8539 11.53V5.72001C6.8539 5.47149 6.65243 5.27001 6.4039 5.27001C6.15537 5.27001 5.9539 5.47149 5.9539 5.72001V6.22269C5.40506 5.60075 4.59218 5.20703 3.69899 5.20703ZM5.9539 9.799V7.30117C5.56339 6.58064 4.74118 6.05757 3.8868 6.05757C2.9089 6.05757 1.83508 6.96581 1.83508 8.60955C1.83508 10.1533 2.80889 11.1615 3.8868 11.1615C4.76984 11.1615 5.57141 10.4957 5.9539 9.799ZM10.799 5.20703C9.15823 5.20703 7.9092 6.68569 7.9092 8.60972C7.9092 10.6337 9.25823 12.0124 10.799 12.0124C11.6215 12.0124 12.4744 11.6692 13.0543 11.0218V11.53C13.0543 11.7785 13.2558 11.98 13.5043 11.98C13.7529 11.98 13.9543 11.7785 13.9543 11.53V5.72C13.9543 5.47147 13.7529 5.27 13.5043 5.27C13.2558 5.27 13.0543 5.47147 13.0543 5.72V6.22318C12.5055 5.60095 11.6924 5.20703 10.799 5.20703ZM13.0543 9.79822V7.30196C12.664 6.58102 11.8415 6.05757 10.9868 6.05757C10.0089 6.05757 8.93508 6.96581 8.93508 8.60955C8.93508 10.1533 9.90889 11.1615 10.9868 11.1615C11.8702 11.1615 12.672 10.4952 13.0543 9.79822Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2N = [
    "color"
];
var $6431ef21eafb1f5a$export$7e8527e8d8b03e5e = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2N);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M11.2895 2.75C11.4964 2.74979 11.6821 2.87701 11.7565 3.07003L14.9664 11.39C15.0657 11.6477 14.9375 11.9371 14.6798 12.0365C14.4222 12.1359 14.1328 12.0076 14.0334 11.75L12.9822 9.02537H9.61106L8.56672 11.749C8.46786 12.0068 8.1787 12.1357 7.92086 12.0369C7.66302 11.938 7.53415 11.6488 7.63301 11.391L10.8232 3.07099C10.8972 2.87782 11.0826 2.75021 11.2895 2.75ZM11.2915 4.64284L12.6543 8.17537H9.93698L11.2915 4.64284ZM2.89895 5.20703C1.25818 5.20703 0.00915527 6.68569 0.00915527 8.60972C0.00915527 10.6337 1.35818 12.0124 2.89895 12.0124C3.72141 12.0124 4.57438 11.6692 5.15427 11.0219V11.53C5.15427 11.7785 5.35574 11.98 5.60427 11.98C5.8528 11.98 6.05427 11.7785 6.05427 11.53V5.72C6.05427 5.47147 5.8528 5.27 5.60427 5.27C5.35574 5.27 5.15427 5.47147 5.15427 5.72V6.22317C4.60543 5.60095 3.79236 5.20703 2.89895 5.20703ZM5.15427 9.79823V7.30195C4.76393 6.58101 3.94144 6.05757 3.08675 6.05757C2.10885 6.05757 1.03503 6.96581 1.03503 8.60955C1.03503 10.1533 2.00885 11.1615 3.08675 11.1615C3.97011 11.1615 4.77195 10.4952 5.15427 9.79823Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2O = [
    "color"
];
var $6431ef21eafb1f5a$export$9395c236dc77b2d2 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2O);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.6255 2.75C3.83478 2.75 4.02192 2.88034 4.09448 3.07664L7.16985 11.3962C7.2656 11.6552 7.13324 11.9428 6.87423 12.0386C6.61522 12.1343 6.32763 12.002 6.23188 11.7429L5.22387 9.01603H2.02712L1.01911 11.7429C0.923362 12.002 0.635774 12.1343 0.376762 12.0386C0.117749 11.9428 -0.0146052 11.6552 0.0811401 11.3962L3.15651 3.07664C3.22908 2.88034 3.41621 2.75 3.6255 2.75ZM3.6255 4.69207L4.90966 8.16603H2.34133L3.6255 4.69207ZM11.3719 2.75C11.5811 2.75 11.7683 2.88034 11.8408 3.07664L14.9162 11.3962C15.012 11.6552 14.8796 11.9428 14.6206 12.0386C14.3616 12.1343 14.074 12.002 13.9782 11.7429L12.9702 9.01603H9.77348L8.76547 11.7429C8.66972 12.002 8.38213 12.1343 8.12312 12.0386C7.86411 11.9428 7.73175 11.6552 7.8275 11.3962L10.9029 3.07664C10.9754 2.88034 11.1626 2.75 11.3719 2.75ZM11.3719 4.69207L12.656 8.16603H10.0877L11.3719 4.69207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2P = [
    "color"
];
var $6431ef21eafb1f5a$export$b5d24f94d82d9f2b = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2P);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.55293 0.999969C4.75295 0.999969 4.93372 1.11917 5.0125 1.30301L8.01106 8.29982C8.11984 8.55363 8.00226 8.84757 7.74844 8.95635C7.49463 9.06512 7.20069 8.94754 7.09191 8.69373L6.11613 6.41685H2.98973L2.01395 8.69373C1.90517 8.94754 1.61123 9.06512 1.35742 8.95635C1.1036 8.84757 0.986023 8.55363 1.0948 8.29982L4.09336 1.30301C4.17214 1.11917 4.35291 0.999969 4.55293 0.999969ZM4.55293 2.76929L5.75186 5.56685H3.354L4.55293 2.76929ZM11.0562 9.00214C11.2617 9.00214 11.4463 8.87633 11.5215 8.68502L14.2733 1.68299C14.3743 1.42598 14.2478 1.13575 13.9908 1.03475C13.7338 0.933747 13.4436 1.06021 13.3426 1.31722L11.0562 7.13514L8.76973 1.31722C8.66873 1.06021 8.3785 0.933747 8.1215 1.03475C7.86449 1.13575 7.73802 1.42598 7.83902 1.68299L10.5908 8.68502C10.666 8.87633 10.8506 9.00214 11.0562 9.00214ZM14.9537 12.4999C14.9537 12.606 14.9115 12.7077 14.8365 12.7828L12.8365 14.7828C12.6803 14.939 12.4271 14.939 12.2708 14.7828C12.1146 14.6265 12.1146 14.3733 12.2708 14.2171L13.588 12.8999H1.51937L2.83653 14.2171C2.99274 14.3733 2.99274 14.6265 2.83653 14.7828C2.68032 14.939 2.42705 14.939 2.27084 14.7828L0.270843 12.7828C0.195828 12.7077 0.153687 12.606 0.153687 12.4999C0.153687 12.3938 0.195828 12.2921 0.270843 12.2171L2.27084 10.2171C2.42705 10.0609 2.68032 10.0609 2.83653 10.2171C2.99274 10.3733 2.99274 10.6265 2.83653 10.7828L1.51937 12.0999L13.588 12.0999L12.2708 10.7828C12.1146 10.6265 12.1146 10.3733 12.2708 10.2171C12.4271 10.0609 12.6803 10.0609 12.8365 10.2171L14.8365 12.2171C14.9115 12.2921 14.9537 12.3938 14.9537 12.4999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2Q = [
    "color"
];
var $6431ef21eafb1f5a$export$afee984ac0331725 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2Q);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8.69667 0.0403541C8.90859 0.131038 9.03106 0.354857 8.99316 0.582235L8.0902 6.00001H12.5C12.6893 6.00001 12.8625 6.10701 12.9472 6.27641C13.0319 6.4458 13.0136 6.6485 12.8999 6.80001L6.89997 14.8C6.76167 14.9844 6.51521 15.0503 6.30328 14.9597C6.09135 14.869 5.96888 14.6452 6.00678 14.4178L6.90974 9H2.49999C2.31061 9 2.13748 8.893 2.05278 8.72361C1.96809 8.55422 1.98636 8.35151 2.09999 8.2L8.09997 0.200038C8.23828 0.0156255 8.48474 -0.0503301 8.69667 0.0403541ZM3.49999 8.00001H7.49997C7.64695 8.00001 7.78648 8.06467 7.88148 8.17682C7.97648 8.28896 8.01733 8.43723 7.99317 8.5822L7.33027 12.5596L11.5 7.00001H7.49997C7.353 7.00001 7.21347 6.93534 7.11846 6.8232C7.02346 6.71105 6.98261 6.56279 7.00678 6.41781L7.66968 2.44042L3.49999 8.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2R = [
    "color"
];
var $6431ef21eafb1f5a$export$9b61d117ad943959 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2R);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.78233 2.21713C3.70732 2.14212 3.60557 2.09998 3.49949 2.09998C3.3934 2.09998 3.29166 2.14212 3.21664 2.21713L1.21664 4.21713C1.06044 4.37334 1.06044 4.62661 1.21664 4.78282C1.37285 4.93903 1.62612 4.93903 1.78233 4.78282L3.09949 3.46566L3.09949 11.5343L1.78233 10.2171C1.62612 10.0609 1.37285 10.0609 1.21664 10.2171C1.06043 10.3733 1.06043 10.6266 1.21664 10.7828L3.21664 12.7828C3.29166 12.8578 3.3934 12.9 3.49949 12.9C3.60557 12.9 3.70731 12.8578 3.78233 12.7828L5.78233 10.7828C5.93854 10.6266 5.93854 10.3733 5.78233 10.2171C5.62612 10.0609 5.37285 10.0609 5.21664 10.2171L3.89949 11.5343L3.89949 3.46566L5.21664 4.78282C5.37285 4.93903 5.62612 4.93903 5.78233 4.78282C5.93854 4.62661 5.93854 4.37334 5.78233 4.21713L3.78233 2.21713ZM8.49998 3.99997C8.22383 3.99997 7.99998 4.22382 7.99998 4.49997C7.99998 4.77611 8.22383 4.99997 8.49998 4.99997H14.5C14.7761 4.99997 15 4.77611 15 4.49997C15 4.22382 14.7761 3.99997 14.5 3.99997H8.49998ZM7.99998 7.49997C7.99998 7.22382 8.22383 6.99997 8.49998 6.99997H14.5C14.7761 6.99997 15 7.22382 15 7.49997C15 7.77611 14.7761 7.99997 14.5 7.99997H8.49998C8.22383 7.99997 7.99998 7.77611 7.99998 7.49997ZM8.49998 9.99997C8.22383 9.99997 7.99998 10.2238 7.99998 10.5C7.99998 10.7761 8.22383 11 8.49998 11H14.5C14.7761 11 15 10.7761 15 10.5C15 10.2238 14.7761 9.99997 14.5 9.99997H8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2S = [
    "color"
];
var $6431ef21eafb1f5a$export$c99cd348175308cb = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2S);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.62471 4.00001L4.56402 4.00001C4.04134 3.99993 3.70687 3.99988 3.4182 4.055C2.2379 4.28039 1.29846 5.17053 1.05815 6.33035C0.999538 6.61321 0.999604 6.93998 0.999703 7.43689L0.999711 7.50001L0.999703 7.56313C0.999604 8.06004 0.999538 8.38681 1.05815 8.66967C1.29846 9.8295 2.2379 10.7196 3.4182 10.945C3.70688 11.0001 4.04135 11.0001 4.56403 11L4.62471 11H5.49971C5.77585 11 5.99971 10.7762 5.99971 10.5C5.99971 10.2239 5.77585 10 5.49971 10H4.62471C4.02084 10 3.78907 9.99777 3.60577 9.96277C2.80262 9.8094 2.19157 9.21108 2.03735 8.46678C2.00233 8.29778 1.99971 8.08251 1.99971 7.50001C1.99971 6.91752 2.00233 6.70225 2.03735 6.53324C2.19157 5.78895 2.80262 5.19062 3.60577 5.03725C3.78907 5.00225 4.02084 5.00001 4.62471 5.00001H5.49971C5.77585 5.00001 5.99971 4.77615 5.99971 4.50001C5.99971 4.22387 5.77585 4.00001 5.49971 4.00001H4.62471ZM10.3747 5.00001C10.9786 5.00001 11.2104 5.00225 11.3937 5.03725C12.1968 5.19062 12.8079 5.78895 12.9621 6.53324C12.9971 6.70225 12.9997 6.91752 12.9997 7.50001C12.9997 8.08251 12.9971 8.29778 12.9621 8.46678C12.8079 9.21108 12.1968 9.8094 11.3937 9.96277C11.2104 9.99777 10.9786 10 10.3747 10H9.49971C9.22357 10 8.99971 10.2239 8.99971 10.5C8.99971 10.7762 9.22357 11 9.49971 11H10.3747L10.4354 11C10.9581 11.0001 11.2925 11.0001 11.5812 10.945C12.7615 10.7196 13.701 9.8295 13.9413 8.66967C13.9999 8.38681 13.9998 8.06005 13.9997 7.56314L13.9997 7.50001L13.9997 7.43688C13.9998 6.93998 13.9999 6.61321 13.9413 6.33035C13.701 5.17053 12.7615 4.28039 11.5812 4.055C11.2925 3.99988 10.9581 3.99993 10.4354 4.00001L10.3747 4.00001H9.49971C9.22357 4.00001 8.99971 4.22387 8.99971 4.50001C8.99971 4.77615 9.22357 5.00001 9.49971 5.00001H10.3747ZM5.00038 7C4.72424 7 4.50038 7.22386 4.50038 7.5C4.50038 7.77614 4.72424 8 5.00038 8H10.0004C10.2765 8 10.5004 7.77614 10.5004 7.5C10.5004 7.22386 10.2765 7 10.0004 7H5.00038Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2T = [
    "color"
];
var $6431ef21eafb1f5a$export$a0f93c0a3250ca9d = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2T);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8.51194 3.00541C9.18829 2.54594 10.0435 2.53694 10.6788 2.95419C10.8231 3.04893 10.9771 3.1993 11.389 3.61119C11.8009 4.02307 11.9513 4.17714 12.046 4.32141C12.4633 4.95675 12.4543 5.81192 11.9948 6.48827C11.8899 6.64264 11.7276 6.80811 11.3006 7.23511L10.6819 7.85383C10.4867 8.04909 10.4867 8.36567 10.6819 8.56093C10.8772 8.7562 11.1938 8.7562 11.389 8.56093L12.0077 7.94221L12.0507 7.89929C12.4203 7.52976 12.6568 7.2933 12.822 7.0502C13.4972 6.05623 13.5321 4.76252 12.8819 3.77248C12.7233 3.53102 12.4922 3.30001 12.1408 2.94871L12.0961 2.90408L12.0515 2.85942C11.7002 2.508 11.4692 2.27689 11.2277 2.11832C10.2377 1.46813 8.94398 1.50299 7.95001 2.17822C7.70691 2.34336 7.47044 2.57991 7.1009 2.94955L7.058 2.99247L6.43928 3.61119C6.24401 3.80645 6.24401 4.12303 6.43928 4.31829C6.63454 4.51355 6.95112 4.51355 7.14638 4.31829L7.7651 3.69957C8.1921 3.27257 8.35757 3.11027 8.51194 3.00541ZM4.31796 7.14672C4.51322 6.95146 4.51322 6.63487 4.31796 6.43961C4.12269 6.24435 3.80611 6.24435 3.61085 6.43961L2.99213 7.05833L2.94922 7.10124C2.57957 7.47077 2.34303 7.70724 2.17788 7.95035C1.50265 8.94432 1.4678 10.238 2.11799 11.2281C2.27656 11.4695 2.50766 11.7005 2.8591 12.0518L2.90374 12.0965L2.94837 12.1411C3.29967 12.4925 3.53068 12.7237 3.77214 12.8822C4.76219 13.5324 6.05589 13.4976 7.04986 12.8223C7.29296 12.6572 7.52943 12.4206 7.89896 12.051L7.89897 12.051L7.94188 12.0081L8.5606 11.3894C8.75586 11.1941 8.75586 10.8775 8.5606 10.6823C8.36533 10.487 8.04875 10.487 7.85349 10.6823L7.23477 11.301C6.80777 11.728 6.6423 11.8903 6.48794 11.9951C5.81158 12.4546 4.95642 12.4636 4.32107 12.0464C4.17681 11.9516 4.02274 11.8012 3.61085 11.3894C3.19896 10.9775 3.0486 10.8234 2.95385 10.6791C2.53661 10.0438 2.54561 9.18863 3.00507 8.51227C3.10993 8.35791 3.27224 8.19244 3.69924 7.76544L4.31796 7.14672ZM9.62172 6.08558C9.81698 5.89032 9.81698 5.57373 9.62172 5.37847C9.42646 5.18321 9.10988 5.18321 8.91461 5.37847L5.37908 8.91401C5.18382 9.10927 5.18382 9.42585 5.37908 9.62111C5.57434 9.81637 5.89092 9.81637 6.08619 9.62111L9.62172 6.08558Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2U = [
    "color"
];
var $6431ef21eafb1f5a$export$c2a4804b810abd59 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2U);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L13.3536 2.35355ZM2.03735 8.46678C2.17398 9.12619 2.66918 9.67103 3.33886 9.89338L2.57833 10.6539C1.80843 10.2534 1.23784 9.53693 1.05815 8.66967C0.999538 8.38681 0.999604 8.06004 0.999703 7.56313L0.999711 7.50001L0.999703 7.43689C0.999604 6.93998 0.999538 6.61321 1.05815 6.33035C1.29846 5.17053 2.2379 4.28039 3.4182 4.055C3.70687 3.99988 4.04134 3.99993 4.56402 4.00001L4.62471 4.00001H5.49971C5.77585 4.00001 5.99971 4.22387 5.99971 4.50001C5.99971 4.77615 5.77585 5.00001 5.49971 5.00001H4.62471C4.02084 5.00001 3.78907 5.00225 3.60577 5.03725C2.80262 5.19062 2.19157 5.78895 2.03735 6.53324C2.00233 6.70225 1.99971 6.91752 1.99971 7.50001C1.99971 8.08251 2.00233 8.29778 2.03735 8.46678ZM12.9621 6.53324C12.8255 5.87397 12.3304 5.32922 11.661 5.10679L12.4215 4.34631C13.1912 4.74686 13.7616 5.46323 13.9413 6.33035C13.9999 6.61321 13.9998 6.93998 13.9997 7.43688L13.9997 7.50001L13.9997 7.56314C13.9998 8.06005 13.9999 8.38681 13.9413 8.66967C13.701 9.8295 12.7615 10.7196 11.5812 10.945C11.2925 11.0001 10.9581 11.0001 10.4354 11L10.3747 11H9.49971C9.22357 11 8.99971 10.7762 8.99971 10.5C8.99971 10.2239 9.22357 10 9.49971 10H10.3747C10.9786 10 11.2104 9.99777 11.3937 9.96277C12.1968 9.8094 12.8079 9.21108 12.9621 8.46678C12.9971 8.29778 12.9997 8.08251 12.9997 7.50001C12.9997 6.91752 12.9971 6.70225 12.9621 6.53324Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2V = [
    "color"
];
var $6431ef21eafb1f5a$export$c8d5b415f7d58ebc = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2V);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.50021 0C4.77635 0 5.0002 0.223853 5.0002 0.49999V2.49995C5.0002 2.77609 4.77635 2.99994 4.50021 2.99994C4.22408 2.99994 4.00022 2.77609 4.00022 2.49995V0.49999C4.00022 0.223853 4.22408 0 4.50021 0ZM0.646451 0.64647C0.84171 0.451212 1.15829 0.451212 1.35354 0.64647L2.85351 2.14644C3.04877 2.3417 3.04877 2.65827 2.85351 2.85353C2.65826 3.04879 2.34168 3.04879 2.14642 2.85353L0.646452 1.35356C0.451193 1.1583 0.451193 0.841728 0.646451 0.64647ZM0.00030517 4.49991C0.00030517 4.22377 0.224158 3.99992 0.500295 3.99992H2.50025C2.77639 3.99992 3.00024 4.22377 3.00024 4.49991C3.00024 4.77605 2.77639 4.9999 2.50025 4.9999H0.500295C0.224158 4.9999 0.00030517 4.77605 0.00030517 4.49991ZM12.0001 10.4998C12.0001 10.2236 12.2239 9.9998 12.5001 9.9998H14.5C14.7761 9.9998 15 10.2236 15 10.4998C15 10.7759 14.7761 10.9998 14.5 10.9998H12.5001C12.2239 10.9998 12.0001 10.7759 12.0001 10.4998ZM10.5001 11.9998C10.7762 11.9998 11.0001 12.2236 11.0001 12.4997V14.4997C11.0001 14.7758 10.7762 14.9997 10.5001 14.9997C10.224 14.9997 10.0001 14.7758 10.0001 14.4997V12.4997C10.0001 12.2236 10.224 11.9998 10.5001 11.9998ZM12.1462 12.1462C12.3415 11.951 12.658 11.951 12.8533 12.1462L14.3533 13.6462C14.5485 13.8415 14.5485 14.158 14.3533 14.3533C14.158 14.5485 13.8414 14.5485 13.6462 14.3533L12.1462 12.8533C11.951 12.6581 11.951 12.3415 12.1462 12.1462ZM7.76478 3.69938C8.19177 3.27238 8.35724 3.11008 8.5116 3.00522C9.18794 2.54577 10.0431 2.53677 10.6784 2.95401C10.8227 3.04875 10.9767 3.19911 11.3886 3.61099C11.8005 4.02287 11.9509 4.17694 12.0456 4.3212C12.4628 4.95653 12.4539 5.81168 11.9944 6.48802C11.8895 6.64238 11.7272 6.80785 11.3002 7.23484L10.6815 7.85354C10.4863 8.0488 10.4863 8.36538 10.6815 8.56064C10.8768 8.75589 11.1934 8.75589 11.3886 8.56064L12.0073 7.94193L12.0502 7.89903C12.4199 7.5295 12.6564 7.29303 12.8216 7.04993C13.4968 6.05598 13.5316 4.7623 12.8815 3.77228C12.7229 3.53083 12.4918 3.29982 12.1404 2.94853L12.0957 2.9039L12.0511 2.85925C11.6998 2.50782 11.4688 2.27672 11.2273 2.11816C10.2373 1.46798 8.94364 1.50284 7.94968 2.17805C7.70659 2.34319 7.47012 2.57973 7.1006 2.94936L7.1006 2.94937L7.05769 2.99228L6.43898 3.61099C6.24372 3.80625 6.24372 4.12282 6.43898 4.31808C6.63424 4.51334 6.95081 4.51334 7.14607 4.31808L7.76478 3.69938ZM2.99191 7.05807L2.94899 7.10097C2.57935 7.4705 2.34282 7.70697 2.17767 7.95006C1.50246 8.94401 1.4676 10.2377 2.11778 11.2277C2.27634 11.4692 2.50744 11.7002 2.85886 12.0515L2.85888 12.0515L2.90352 12.0961L2.94815 12.1407L2.94815 12.1407L2.94817 12.1408C3.29945 12.4922 3.53045 12.7233 3.7719 12.8818C4.76193 13.532 6.0556 13.4972 7.04956 12.8219C7.29265 12.6568 7.52912 12.4203 7.89865 12.0506L7.94155 12.0077L8.56026 11.389C8.75552 11.1937 8.75552 10.8772 8.56026 10.6819C8.365 10.4867 8.04842 10.4867 7.85317 10.6819L7.23446 11.3006C6.80747 11.7276 6.642 11.8899 6.48764 11.9948C5.8113 12.4542 4.95615 12.4632 4.32082 12.046C4.17656 11.9512 4.02249 11.8009 3.61061 11.389C3.19873 10.9771 3.04837 10.8231 2.95363 10.6788C2.53639 10.0435 2.54539 9.18832 3.00484 8.51198C3.10971 8.35761 3.27201 8.19215 3.699 7.76516L4.3177 7.14645C4.51296 6.95119 4.51296 6.63462 4.3177 6.43936C4.12245 6.2441 3.80587 6.2441 3.61061 6.43936L2.99191 7.05807Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2W = [
    "color"
];
var $6431ef21eafb1f5a$export$928cb2cfdd1b2e72 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2W);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.56427 3.99988C4.58422 3.99989 4.60445 3.99989 4.62496 3.99989H5.49996C5.7761 3.99989 5.99996 4.22375 5.99996 4.49989C5.99996 4.77603 5.7761 4.99989 5.49996 4.99989H4.62496C4.02108 4.99989 3.78932 5.00213 3.60601 5.03713C2.80287 5.1905 2.19181 5.78883 2.03759 6.53312C2.00257 6.70212 1.99996 6.91739 1.99996 7.49989C1.99996 8.08239 2.00257 8.29766 2.03759 8.46666C2.19181 9.21095 2.80287 9.80928 3.60601 9.96265C3.78932 9.99765 4.02108 9.99989 4.62496 9.99989H5.49996C5.7761 9.99989 5.99996 10.2237 5.99996 10.4999C5.99996 10.776 5.7761 10.9999 5.49996 10.9999H4.62496C4.60445 10.9999 4.58422 10.9999 4.56427 10.9999C4.04159 11 3.70712 11 3.41845 10.9449C2.23814 10.7195 1.29871 9.82937 1.05839 8.66955C0.999782 8.38669 0.999848 8.05992 0.999947 7.56301C0.999951 7.54227 0.999955 7.52123 0.999955 7.49989C0.999955 7.47855 0.999951 7.45751 0.999947 7.43677C0.999848 6.93986 0.999782 6.61309 1.05839 6.33023C1.29871 5.17041 2.23814 4.28027 3.41845 4.05488C3.70712 3.99976 4.04159 3.99981 4.56427 3.99988ZM11.3939 5.03713C11.2106 5.00213 10.9788 4.99989 10.375 4.99989H9.49996C9.22381 4.99989 8.99996 4.77603 8.99996 4.49989C8.99996 4.22375 9.22381 3.99989 9.49996 3.99989H10.375C10.3955 3.99989 10.4157 3.99989 10.4356 3.99988C10.9583 3.99981 11.2928 3.99976 11.5815 4.05488C12.7618 4.28027 13.7012 5.17041 13.9415 6.33023C14.0001 6.61309 14.0001 6.93985 14 7.43676C14 7.4575 14 7.47854 14 7.49989C14 7.52124 14 7.54228 14 7.56302C14.0001 8.05992 14.0001 8.38669 13.9415 8.66955C13.7012 9.82937 12.7618 10.7195 11.5815 10.9449C11.2928 11 10.9583 11 10.4356 10.9999C10.4157 10.9999 10.3955 10.9999 10.375 10.9999H9.49996C9.22381 10.9999 8.99996 10.776 8.99996 10.4999C8.99996 10.2237 9.22381 9.99989 9.49996 9.99989H10.375C10.9788 9.99989 11.2106 9.99765 11.3939 9.96265C12.197 9.80928 12.8081 9.21095 12.9623 8.46666C12.9973 8.29766 13 8.08239 13 7.49989C13 6.91739 12.9973 6.70212 12.9623 6.53312C12.8081 5.78883 12.197 5.1905 11.3939 5.03713Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2X = [
    "color"
];
var $6431ef21eafb1f5a$export$36a31df0698e942 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2X);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M10.6788 2.95419C10.0435 2.53694 9.18829 2.54594 8.51194 3.00541C8.35757 3.11027 8.1921 3.27257 7.7651 3.69957L7.14638 4.31829C6.95112 4.51355 6.63454 4.51355 6.43928 4.31829C6.24401 4.12303 6.24401 3.80645 6.43928 3.61119L7.058 2.99247C7.0725 2.97797 7.08679 2.96366 7.1009 2.94955C7.47044 2.57991 7.70691 2.34336 7.95001 2.17822C8.94398 1.50299 10.2377 1.46813 11.2277 2.11832C11.4692 2.27689 11.7002 2.508 12.0515 2.85942C12.0662 2.8741 12.081 2.88898 12.0961 2.90408C12.1112 2.91917 12.1261 2.93405 12.1408 2.94871C12.4922 3.30001 12.7233 3.53102 12.8819 3.77248C13.5321 4.76252 13.4972 6.05623 12.822 7.0502C12.6568 7.2933 12.4203 7.52976 12.0507 7.89929C12.0366 7.9134 12.0222 7.92771 12.0077 7.94221L11.389 8.56093C11.1938 8.7562 10.8772 8.7562 10.6819 8.56093C10.4867 8.36567 10.4867 8.04909 10.6819 7.85383L11.3006 7.23511C11.7276 6.80811 11.8899 6.64264 11.9948 6.48827C12.4543 5.81192 12.4633 4.95675 12.046 4.32141C11.9513 4.17714 11.8009 4.02307 11.389 3.61119C10.9771 3.1993 10.8231 3.04893 10.6788 2.95419ZM4.31796 6.43961C4.51322 6.63487 4.51322 6.95146 4.31796 7.14672L3.69924 7.76544C3.27224 8.19244 3.10993 8.35791 3.00507 8.51227C2.54561 9.18863 2.53661 10.0438 2.95385 10.6791C3.0486 10.8234 3.19896 10.9775 3.61085 11.3894C4.02274 11.8012 4.17681 11.9516 4.32107 12.0464C4.95642 12.4636 5.81158 12.4546 6.48794 11.9951C6.6423 11.8903 6.80777 11.728 7.23477 11.301L7.85349 10.6823C8.04875 10.487 8.36533 10.487 8.5606 10.6823C8.75586 10.8775 8.75586 11.1941 8.5606 11.3894L7.94188 12.0081C7.92738 12.0226 7.91307 12.0369 7.89897 12.051C7.52943 12.4206 7.29296 12.6572 7.04986 12.8223C6.05589 13.4976 4.76219 13.5324 3.77214 12.8822C3.53068 12.7237 3.29967 12.4925 2.94837 12.1411C2.93371 12.1264 2.91883 12.1116 2.90374 12.0965C2.88865 12.0814 2.87377 12.0665 2.8591 12.0518C2.50766 11.7005 2.27656 11.4695 2.11799 11.2281C1.4678 10.238 1.50265 8.94432 2.17788 7.95035C2.34303 7.70724 2.57957 7.47077 2.94922 7.10124C2.96333 7.08713 2.97763 7.07283 2.99213 7.05833L3.61085 6.43961C3.80611 6.24435 4.12269 6.24435 4.31796 6.43961Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2Y = [
    "color"
];
var $6431ef21eafb1f5a$export$8ec07838913349db = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2Y);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2 1C1.44772 1 1 1.44772 1 2V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V2C14 1.44772 13.5523 1 13 1H2ZM3.05 6H4.95V12H3.05V6ZM5.075 4.005C5.075 4.59871 4.59371 5.08 4 5.08C3.4063 5.08 2.925 4.59871 2.925 4.005C2.925 3.41129 3.4063 2.93 4 2.93C4.59371 2.93 5.075 3.41129 5.075 4.005ZM12 8.35713C12 6.55208 10.8334 5.85033 9.67449 5.85033C9.29502 5.83163 8.91721 5.91119 8.57874 6.08107C8.32172 6.21007 8.05265 6.50523 7.84516 7.01853H7.79179V6.00044H6V12.0047H7.90616V8.8112C7.8786 8.48413 7.98327 8.06142 8.19741 7.80987C8.41156 7.55832 8.71789 7.49825 8.95015 7.46774H9.02258C9.62874 7.46774 10.0786 7.84301 10.0786 8.78868V12.0047H11.9847L12 8.35713Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2Z = [
    "color"
];
var $6431ef21eafb1f5a$export$9b1a2d77017d0edb = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2Z);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.5 5.25C1.91421 5.25 2.25 4.91421 2.25 4.5C2.25 4.08579 1.91421 3.75 1.5 3.75C1.08579 3.75 0.75 4.08579 0.75 4.5C0.75 4.91421 1.08579 5.25 1.5 5.25ZM4 4.5C4 4.22386 4.22386 4 4.5 4H13.5C13.7761 4 14 4.22386 14 4.5C14 4.77614 13.7761 5 13.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H13.5C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H4.5ZM2.25 7.5C2.25 7.91421 1.91421 8.25 1.5 8.25C1.08579 8.25 0.75 7.91421 0.75 7.5C0.75 7.08579 1.08579 6.75 1.5 6.75C1.91421 6.75 2.25 7.08579 2.25 7.5ZM1.5 11.25C1.91421 11.25 2.25 10.9142 2.25 10.5C2.25 10.0858 1.91421 9.75 1.5 9.75C1.08579 9.75 0.75 10.0858 0.75 10.5C0.75 10.9142 1.08579 11.25 1.5 11.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2_ = [
    "color"
];
var $6431ef21eafb1f5a$export$f53936b98653a113 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2_);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5 4.63601C5 3.76031 5.24219 3.1054 5.64323 2.67357C6.03934 2.24705 6.64582 1.9783 7.5014 1.9783C8.35745 1.9783 8.96306 2.24652 9.35823 2.67208C9.75838 3.10299 10 3.75708 10 4.63325V5.99999H5V4.63601ZM4 5.99999V4.63601C4 3.58148 4.29339 2.65754 4.91049 1.99307C5.53252 1.32329 6.42675 0.978302 7.5014 0.978302C8.57583 0.978302 9.46952 1.32233 10.091 1.99162C10.7076 2.65557 11 3.57896 11 4.63325V5.99999H12C12.5523 5.99999 13 6.44771 13 6.99999V13C13 13.5523 12.5523 14 12 14H3C2.44772 14 2 13.5523 2 13V6.99999C2 6.44771 2.44772 5.99999 3 5.99999H4ZM3 6.99999H12V13H3V6.99999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$2$ = [
    "color"
];
var $6431ef21eafb1f5a$export$5f7f9efc246369d3 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$2$);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.4986 0C6.3257 0 5.36107 0.38943 4.73753 1.19361C4.23745 1.83856 4 2.68242 4 3.63325H5C5 2.84313 5.19691 2.23312 5.5278 1.80636C5.91615 1.30552 6.55152 1 7.4986 1C8.35683 1 8.96336 1.26502 9.35846 1.68623C9.75793 2.11211 10 2.76044 10 3.63601V6H3C2.44772 6 2 6.44772 2 7V13C2 13.5523 2.44772 14 3 14H12C12.5523 14 13 13.5523 13 13V7C13 6.44771 12.5523 6 12 6H11V3.63601C11 2.58135 10.7065 1.66167 10.0878 1.0021C9.46477 0.337871 8.57061 0 7.4986 0ZM3 7H12V13H3V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$30 = [
    "color"
];
var $6431ef21eafb1f5a$export$fea8b3d7473481c5 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$30);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M9 3.63601C9 2.76044 9.24207 2.11211 9.64154 1.68623C10.0366 1.26502 10.6432 1 11.5014 1C12.4485 1 13.0839 1.30552 13.4722 1.80636C13.8031 2.23312 14 2.84313 14 3.63325H15C15 2.68242 14.7626 1.83856 14.2625 1.19361C13.6389 0.38943 12.6743 0 11.5014 0C10.4294 0 9.53523 0.337871 8.91218 1.0021C8.29351 1.66167 8 2.58135 8 3.63601V6H1C0.447715 6 0 6.44772 0 7V13C0 13.5523 0.447715 14 1 14H10C10.5523 14 11 13.5523 11 13V7C11 6.44772 10.5523 6 10 6H9V3.63601ZM1 7H10V13H1V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$31 = [
    "color"
];
var $6431ef21eafb1f5a$export$ab1b7565a980cdcc = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$31);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.35355 1.85355C3.54882 1.65829 3.54882 1.34171 3.35355 1.14645C3.15829 0.951184 2.84171 0.951184 2.64645 1.14645L0.646447 3.14645C0.451184 3.34171 0.451184 3.65829 0.646447 3.85355L2.64645 5.85355C2.84171 6.04882 3.15829 6.04882 3.35355 5.85355C3.54882 5.65829 3.54882 5.34171 3.35355 5.14645L2.20711 4H9.5C11.433 4 13 5.567 13 7.5C13 7.77614 13.2239 8 13.5 8C13.7761 8 14 7.77614 14 7.5C14 5.01472 11.9853 3 9.5 3H2.20711L3.35355 1.85355ZM2 7.5C2 7.22386 1.77614 7 1.5 7C1.22386 7 1 7.22386 1 7.5C1 9.98528 3.01472 12 5.5 12H12.7929L11.6464 13.1464C11.4512 13.3417 11.4512 13.6583 11.6464 13.8536C11.8417 14.0488 12.1583 14.0488 12.3536 13.8536L14.3536 11.8536C14.5488 11.6583 14.5488 11.3417 14.3536 11.1464L12.3536 9.14645C12.1583 8.95118 11.8417 8.95118 11.6464 9.14645C11.4512 9.34171 11.4512 9.65829 11.6464 9.85355L12.7929 11H5.5C3.567 11 2 9.433 2 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$32 = [
    "color"
];
var $6431ef21eafb1f5a$export$bd662a7321ab10c4 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$32);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M13.9 0.499976C13.9 0.279062 13.7209 0.0999756 13.5 0.0999756C13.2791 0.0999756 13.1 0.279062 13.1 0.499976V1.09998H12.5C12.2791 1.09998 12.1 1.27906 12.1 1.49998C12.1 1.72089 12.2791 1.89998 12.5 1.89998H13.1V2.49998C13.1 2.72089 13.2791 2.89998 13.5 2.89998C13.7209 2.89998 13.9 2.72089 13.9 2.49998V1.89998H14.5C14.7209 1.89998 14.9 1.72089 14.9 1.49998C14.9 1.27906 14.7209 1.09998 14.5 1.09998H13.9V0.499976ZM11.8536 3.14642C12.0488 3.34168 12.0488 3.65826 11.8536 3.85353L10.8536 4.85353C10.6583 5.04879 10.3417 5.04879 10.1465 4.85353C9.9512 4.65827 9.9512 4.34169 10.1465 4.14642L11.1464 3.14643C11.3417 2.95116 11.6583 2.95116 11.8536 3.14642ZM9.85357 5.14642C10.0488 5.34168 10.0488 5.65827 9.85357 5.85353L2.85355 12.8535C2.65829 13.0488 2.34171 13.0488 2.14645 12.8535C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L9.14646 5.14642C9.34172 4.95116 9.65831 4.95116 9.85357 5.14642ZM13.5 5.09998C13.7209 5.09998 13.9 5.27906 13.9 5.49998V6.09998H14.5C14.7209 6.09998 14.9 6.27906 14.9 6.49998C14.9 6.72089 14.7209 6.89998 14.5 6.89998H13.9V7.49998C13.9 7.72089 13.7209 7.89998 13.5 7.89998C13.2791 7.89998 13.1 7.72089 13.1 7.49998V6.89998H12.5C12.2791 6.89998 12.1 6.72089 12.1 6.49998C12.1 6.27906 12.2791 6.09998 12.5 6.09998H13.1V5.49998C13.1 5.27906 13.2791 5.09998 13.5 5.09998ZM8.90002 0.499976C8.90002 0.279062 8.72093 0.0999756 8.50002 0.0999756C8.2791 0.0999756 8.10002 0.279062 8.10002 0.499976V1.09998H7.50002C7.2791 1.09998 7.10002 1.27906 7.10002 1.49998C7.10002 1.72089 7.2791 1.89998 7.50002 1.89998H8.10002V2.49998C8.10002 2.72089 8.2791 2.89998 8.50002 2.89998C8.72093 2.89998 8.90002 2.72089 8.90002 2.49998V1.89998H9.50002C9.72093 1.89998 9.90002 1.72089 9.90002 1.49998C9.90002 1.27906 9.72093 1.09998 9.50002 1.09998H8.90002V0.499976Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$33 = [
    "color"
];
var $6431ef21eafb1f5a$export$f7658c347b037c3f = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$33);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$34 = [
    "color"
];
var $6431ef21eafb1f5a$export$fca30e52ebed3683 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$34);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.49988 2.00012C1.77602 2.00012 1.99988 1.77626 1.99988 1.50012C1.99988 1.22398 1.77602 1.00012 1.49988 1.00012C1.22374 1.00012 0.999878 1.22398 0.999878 1.50012C0.999878 1.77626 1.22374 2.00012 1.49988 2.00012ZM4.49988 2.00012C4.77602 2.00012 4.99988 1.77626 4.99988 1.50012C4.99988 1.22398 4.77602 1.00012 4.49988 1.00012C4.22374 1.00012 3.99988 1.22398 3.99988 1.50012C3.99988 1.77626 4.22374 2.00012 4.49988 2.00012ZM7.99988 1.50012C7.99988 1.77626 7.77602 2.00012 7.49988 2.00012C7.22374 2.00012 6.99988 1.77626 6.99988 1.50012C6.99988 1.22398 7.22374 1.00012 7.49988 1.00012C7.77602 1.00012 7.99988 1.22398 7.99988 1.50012ZM10.4999 2.00012C10.776 2.00012 10.9999 1.77626 10.9999 1.50012C10.9999 1.22398 10.776 1.00012 10.4999 1.00012C10.2237 1.00012 9.99988 1.22398 9.99988 1.50012C9.99988 1.77626 10.2237 2.00012 10.4999 2.00012ZM13.9999 1.50012C13.9999 1.77626 13.776 2.00012 13.4999 2.00012C13.2237 2.00012 12.9999 1.77626 12.9999 1.50012C12.9999 1.22398 13.2237 1.00012 13.4999 1.00012C13.776 1.00012 13.9999 1.22398 13.9999 1.50012ZM1.49988 14.0001C1.77602 14.0001 1.99988 13.7763 1.99988 13.5001C1.99988 13.224 1.77602 13.0001 1.49988 13.0001C1.22374 13.0001 0.999878 13.224 0.999878 13.5001C0.999878 13.7763 1.22374 14.0001 1.49988 14.0001ZM1.99988 10.5001C1.99988 10.7763 1.77602 11.0001 1.49988 11.0001C1.22374 11.0001 0.999878 10.7763 0.999878 10.5001C0.999878 10.224 1.22374 10.0001 1.49988 10.0001C1.77602 10.0001 1.99988 10.224 1.99988 10.5001ZM1.49988 8.00012C1.77602 8.00012 1.99988 7.77626 1.99988 7.50012C1.99988 7.22398 1.77602 7.00012 1.49988 7.00012C1.22374 7.00012 0.999878 7.22398 0.999878 7.50012C0.999878 7.77626 1.22374 8.00012 1.49988 8.00012ZM1.99988 4.50012C1.99988 4.77626 1.77602 5.00012 1.49988 5.00012C1.22374 5.00012 0.999878 4.77626 0.999878 4.50012C0.999878 4.22398 1.22374 4.00012 1.49988 4.00012C1.77602 4.00012 1.99988 4.22398 1.99988 4.50012ZM13.4999 11.0001C13.776 11.0001 13.9999 10.7763 13.9999 10.5001C13.9999 10.224 13.776 10.0001 13.4999 10.0001C13.2237 10.0001 12.9999 10.224 12.9999 10.5001C12.9999 10.7763 13.2237 11.0001 13.4999 11.0001ZM13.9999 7.50012C13.9999 7.77626 13.776 8.00012 13.4999 8.00012C13.2237 8.00012 12.9999 7.77626 12.9999 7.50012C12.9999 7.22398 13.2237 7.00012 13.4999 7.00012C13.776 7.00012 13.9999 7.22398 13.9999 7.50012ZM13.4999 5.00012C13.776 5.00012 13.9999 4.77626 13.9999 4.50012C13.9999 4.22398 13.776 4.00012 13.4999 4.00012C13.2237 4.00012 12.9999 4.22398 12.9999 4.50012C12.9999 4.77626 13.2237 5.00012 13.4999 5.00012ZM4.99988 13.5001C4.99988 13.7763 4.77602 14.0001 4.49988 14.0001C4.22374 14.0001 3.99988 13.7763 3.99988 13.5001C3.99988 13.224 4.22374 13.0001 4.49988 13.0001C4.77602 13.0001 4.99988 13.224 4.99988 13.5001ZM7.49988 14.0001C7.77602 14.0001 7.99988 13.7763 7.99988 13.5001C7.99988 13.224 7.77602 13.0001 7.49988 13.0001C7.22374 13.0001 6.99988 13.224 6.99988 13.5001C6.99988 13.7763 7.22374 14.0001 7.49988 14.0001ZM10.9999 13.5001C10.9999 13.7763 10.776 14.0001 10.4999 14.0001C10.2237 14.0001 9.99988 13.7763 9.99988 13.5001C9.99988 13.224 10.2237 13.0001 10.4999 13.0001C10.776 13.0001 10.9999 13.224 10.9999 13.5001ZM13.4999 14.0001C13.776 14.0001 13.9999 13.7763 13.9999 13.5001C13.9999 13.224 13.776 13.0001 13.4999 13.0001C13.2237 13.0001 12.9999 13.224 12.9999 13.5001C12.9999 13.7763 13.2237 14.0001 13.4999 14.0001ZM3.99988 5.00012C3.99988 4.44784 4.44759 4.00012 4.99988 4.00012H9.99988C10.5522 4.00012 10.9999 4.44784 10.9999 5.00012V10.0001C10.9999 10.5524 10.5522 11.0001 9.99988 11.0001H4.99988C4.44759 11.0001 3.99988 10.5524 3.99988 10.0001V5.00012ZM4.99988 5.00012H9.99988V10.0001H4.99988V5.00012Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$35 = [
    "color"
];
var $6431ef21eafb1f5a$export$afa4b2f99a1f67c0 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$35);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1 2H14V13H1L1 2ZM0 2C0 1.44772 0.447715 1 1 1H14C14.5523 1 15 1.44772 15 2V13C15 13.5523 14.5523 14 14 14H1C0.447715 14 0 13.5523 0 13V2ZM4.875 7.5C4.875 6.05025 6.05025 4.875 7.5 4.875C8.94975 4.875 10.125 6.05025 10.125 7.5C10.125 8.94975 8.94975 10.125 7.5 10.125C6.05025 10.125 4.875 8.94975 4.875 7.5ZM7.5 3.875C5.49797 3.875 3.875 5.49797 3.875 7.5C3.875 9.50203 5.49797 11.125 7.5 11.125C9.50203 11.125 11.125 9.50203 11.125 7.5C11.125 5.49797 9.50203 3.875 7.5 3.875Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$36 = [
    "color"
];
var $6431ef21eafb1f5a$export$34d98fe14bf296c1 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$36);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1 1C0.447715 1 0 1.44772 0 2V13C0 13.5523 0.447715 14 1 14H14C14.5523 14 15 13.5523 15 13V2C15 1.44772 14.5523 1 14 1H1ZM7.5 10.625C9.22589 10.625 10.625 9.22589 10.625 7.5C10.625 5.77411 9.22589 4.375 7.5 4.375C5.77411 4.375 4.375 5.77411 4.375 7.5C4.375 9.22589 5.77411 10.625 7.5 10.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$37 = [
    "color"
];
var $6431ef21eafb1f5a$export$cb808a3c41736d8e = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$37);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.25 7.5C2.25 7.22386 2.47386 7 2.75 7H12.25C12.5261 7 12.75 7.22386 12.75 7.5C12.75 7.77614 12.5261 8 12.25 8H2.75C2.47386 8 2.25 7.77614 2.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$38 = [
    "color"
];
var $6431ef21eafb1f5a$export$80cd35ac42af1413 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$38);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM4.50003 7C4.22389 7 4.00003 7.22386 4.00003 7.5C4.00003 7.77614 4.22389 8 4.50003 8H10.5C10.7762 8 11 7.77614 11 7.5C11 7.22386 10.7762 7 10.5 7H4.50003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$39 = [
    "color"
];
var $6431ef21eafb1f5a$export$7829447535316b17 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$39);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.14921 3.99996C2.14921 2.97778 2.97784 2.14915 4.00002 2.14915C5.02219 2.14915 5.85083 2.97778 5.85083 3.99996C5.85083 5.02213 5.02219 5.85077 4.00002 5.85077C2.97784 5.85077 2.14921 5.02213 2.14921 3.99996ZM4.00002 1.24915C2.48079 1.24915 1.24921 2.48073 1.24921 3.99996C1.24921 5.51919 2.48079 6.75077 4.00002 6.75077C5.51925 6.75077 6.75083 5.51919 6.75083 3.99996C6.75083 2.48073 5.51925 1.24915 4.00002 1.24915ZM5.82034 11.0001L2.49998 12.8369V9.16331L5.82034 11.0001ZM2.63883 8.21159C2.17228 7.9535 1.59998 8.29093 1.59998 8.82411V13.1761C1.59998 13.7093 2.17228 14.0467 2.63883 13.7886L6.57235 11.6126C7.05389 11.3462 7.05389 10.654 6.57235 10.3876L2.63883 8.21159ZM8.30001 9.00003C8.30001 8.61343 8.61341 8.30003 9.00001 8.30003H13C13.3866 8.30003 13.7 8.61343 13.7 9.00003V13C13.7 13.3866 13.3866 13.7 13 13.7H9.00001C8.61341 13.7 8.30001 13.3866 8.30001 13V9.00003ZM9.20001 9.20003V12.8H12.8V9.20003H9.20001ZM13.4432 2.19311C13.6189 2.01737 13.6189 1.73245 13.4432 1.55671C13.2675 1.38098 12.9826 1.38098 12.8068 1.55671L11 3.36353L9.19321 1.55674C9.01748 1.381 8.73255 1.381 8.55682 1.55674C8.38108 1.73247 8.38108 2.0174 8.55682 2.19313L10.3636 3.99992L8.55682 5.80671C8.38108 5.98245 8.38108 6.26737 8.55682 6.44311C8.73255 6.61885 9.01748 6.61885 9.19321 6.44311L11 4.63632L12.8068 6.44314C12.9826 6.61887 13.2675 6.61887 13.4432 6.44314C13.6189 6.2674 13.6189 5.98247 13.4432 5.80674L11.6364 3.99992L13.4432 2.19311Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3a = [
    "color"
];
var $6431ef21eafb1f5a$export$5560e721cf131890 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3a);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3ZM3 5C3.01671 5 3.03323 4.99918 3.04952 4.99758C3.28022 6.1399 4.28967 7 5.5 7C6.71033 7 7.71978 6.1399 7.95048 4.99758C7.96677 4.99918 7.98329 5 8 5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H8C7.98329 4 7.96677 4.00082 7.95048 4.00242C7.71978 2.86009 6.71033 2 5.5 2C4.28967 2 3.28022 2.86009 3.04952 4.00242C3.03323 4.00082 3.01671 4 3 4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H3ZM11.9505 10.9976C11.7198 12.1399 10.7103 13 9.5 13C8.28967 13 7.28022 12.1399 7.04952 10.9976C7.03323 10.9992 7.01671 11 7 11H1.5C1.22386 11 1 10.7761 1 10.5C1 10.2239 1.22386 10 1.5 10H7C7.01671 10 7.03323 10.0008 7.04952 10.0024C7.28022 8.8601 8.28967 8 9.5 8C10.7103 8 11.7198 8.8601 11.9505 10.0024C11.9668 10.0008 11.9833 10 12 10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H12C11.9833 11 11.9668 10.9992 11.9505 10.9976ZM8 10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3b = [
    "color"
];
var $6431ef21eafb1f5a$export$8154ac77932ca099 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3b);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5 1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5L4 7C4 7.01671 4.00082 7.03323 4.00242 7.04952C2.86009 7.28022 2 8.28967 2 9.5C2 10.7103 2.86009 11.7198 4.00242 11.9505C4.00082 11.9668 4 11.9833 4 12V13.5C4 13.7761 4.22386 14 4.5 14C4.77614 14 5 13.7761 5 13.5V12C5 11.9833 4.99918 11.9668 4.99758 11.9505C6.1399 11.7198 7 10.7103 7 9.5C7 8.28967 6.1399 7.28022 4.99758 7.04952C4.99918 7.03323 5 7.01671 5 7L5 1.5ZM11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V3C10 3.01671 10.0008 3.03323 10.0024 3.04952C8.8601 3.28022 8 4.28967 8 5.5C8 6.71033 8.8601 7.71978 10.0024 7.95048C10.0008 7.96677 10 7.98329 10 8V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V8C11 7.98329 10.9992 7.96677 10.9976 7.95048C12.1399 7.71978 13 6.71033 13 5.5C13 4.28967 12.1399 3.28022 10.9976 3.04952C10.9992 3.03323 11 3.01671 11 3V1.5ZM4.5 8C3.67157 8 3 8.67157 3 9.5C3 10.3284 3.67157 11 4.5 11C5.32843 11 6 10.3284 6 9.5C6 8.67157 5.32843 8 4.5 8ZM9 5.5C9 4.67157 9.67157 4 10.5 4C11.3284 4 12 4.67157 12 5.5C12 6.32843 11.3284 7 10.5 7C9.67157 7 9 6.32843 9 5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3c = [
    "color"
];
var $6431ef21eafb1f5a$export$4484d2284bbfa969 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3c);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4 2.5C4 2.22386 4.22386 2 4.5 2H10.5C10.7761 2 11 2.22386 11 2.5V12.5C11 12.7761 10.7761 13 10.5 13H4.5C4.22386 13 4 12.7761 4 12.5V2.5ZM4.5 1C3.67157 1 3 1.67157 3 2.5V12.5C3 13.3284 3.67157 14 4.5 14H10.5C11.3284 14 12 13.3284 12 12.5V2.5C12 1.67157 11.3284 1 10.5 1H4.5ZM6 11.65C5.8067 11.65 5.65 11.8067 5.65 12C5.65 12.1933 5.8067 12.35 6 12.35H9C9.1933 12.35 9.35 12.1933 9.35 12C9.35 11.8067 9.1933 11.65 9 11.65H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3d = [
    "color"
];
var $6431ef21eafb1f5a$export$a2a3256d1cc3a69a = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3d);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.25925 3.16667L4.37036 5.33333V1L7.25925 3.16667ZM1 8.22222L3.88889 6.05555L1 3.88889V8.22222ZM1 14L3.88889 11.8333L1 9.66666V14ZM7.74072 8.22222L10.6296 6.05555L7.74072 3.88889V8.22222ZM14 3.16667L11.1111 5.33333V1L14 3.16667ZM11.1111 11.1111L14 8.94444L11.1111 6.77777V11.1111ZM3.88889 11.1111L1 8.94444L3.88889 6.77777V11.1111ZM4.37036 6.05555L7.25925 8.22222V3.88889L4.37036 6.05555ZM3.88889 5.33333L1 3.16667L3.88889 1V5.33333ZM7.74072 3.16667L10.6296 5.33333V1L7.74072 3.16667ZM14 8.22222L11.1111 6.05555L14 3.88889V8.22222ZM11.1111 11.8333L14 14V9.66666L11.1111 11.8333Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3e = [
    "color"
];
var $6431ef21eafb1f5a$export$41051b6be05d5fb0 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3e);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.89998 0.499976C2.89998 0.279062 2.72089 0.0999756 2.49998 0.0999756C2.27906 0.0999756 2.09998 0.279062 2.09998 0.499976V1.09998H1.49998C1.27906 1.09998 1.09998 1.27906 1.09998 1.49998C1.09998 1.72089 1.27906 1.89998 1.49998 1.89998H2.09998V2.49998C2.09998 2.72089 2.27906 2.89998 2.49998 2.89998C2.72089 2.89998 2.89998 2.72089 2.89998 2.49998V1.89998H3.49998C3.72089 1.89998 3.89998 1.72089 3.89998 1.49998C3.89998 1.27906 3.72089 1.09998 3.49998 1.09998H2.89998V0.499976ZM5.89998 3.49998C5.89998 3.27906 5.72089 3.09998 5.49998 3.09998C5.27906 3.09998 5.09998 3.27906 5.09998 3.49998V4.09998H4.49998C4.27906 4.09998 4.09998 4.27906 4.09998 4.49998C4.09998 4.72089 4.27906 4.89998 4.49998 4.89998H5.09998V5.49998C5.09998 5.72089 5.27906 5.89998 5.49998 5.89998C5.72089 5.89998 5.89998 5.72089 5.89998 5.49998V4.89998H6.49998C6.72089 4.89998 6.89998 4.72089 6.89998 4.49998C6.89998 4.27906 6.72089 4.09998 6.49998 4.09998H5.89998V3.49998ZM1.89998 6.49998C1.89998 6.27906 1.72089 6.09998 1.49998 6.09998C1.27906 6.09998 1.09998 6.27906 1.09998 6.49998V7.09998H0.499976C0.279062 7.09998 0.0999756 7.27906 0.0999756 7.49998C0.0999756 7.72089 0.279062 7.89998 0.499976 7.89998H1.09998V8.49998C1.09998 8.72089 1.27906 8.89997 1.49998 8.89997C1.72089 8.89997 1.89998 8.72089 1.89998 8.49998V7.89998H2.49998C2.72089 7.89998 2.89998 7.72089 2.89998 7.49998C2.89998 7.27906 2.72089 7.09998 2.49998 7.09998H1.89998V6.49998ZM8.54406 0.98184L8.24618 0.941586C8.03275 0.917676 7.90692 1.1655 8.02936 1.34194C8.17013 1.54479 8.29981 1.75592 8.41754 1.97445C8.91878 2.90485 9.20322 3.96932 9.20322 5.10022C9.20322 8.37201 6.82247 11.0878 3.69887 11.6097C3.45736 11.65 3.20988 11.6772 2.96008 11.6906C2.74563 11.702 2.62729 11.9535 2.77721 12.1072C2.84551 12.1773 2.91535 12.2458 2.98667 12.3128L3.05883 12.3795L3.31883 12.6045L3.50684 12.7532L3.62796 12.8433L3.81491 12.9742L3.99079 13.089C4.11175 13.1651 4.23536 13.2375 4.36157 13.3059L4.62496 13.4412L4.88553 13.5607L5.18837 13.6828L5.43169 13.7686C5.56564 13.8128 5.70149 13.8529 5.83857 13.8885C5.94262 13.9155 6.04767 13.9401 6.15405 13.9622C6.27993 13.9883 6.40713 14.0109 6.53544 14.0298L6.85241 14.0685L7.11934 14.0892C7.24637 14.0965 7.37436 14.1002 7.50322 14.1002C11.1483 14.1002 14.1032 11.1453 14.1032 7.50023C14.1032 7.25044 14.0893 7.00389 14.0623 6.76131L14.0255 6.48407C13.991 6.26083 13.9453 6.04129 13.8891 5.82642C13.8213 5.56709 13.7382 5.31398 13.6409 5.06881L13.5279 4.80132L13.4507 4.63542L13.3766 4.48666C13.2178 4.17773 13.0353 3.88295 12.8312 3.60423L12.6782 3.40352L12.4793 3.16432L12.3157 2.98361L12.1961 2.85951L12.0355 2.70246L11.8134 2.50184L11.4925 2.24191L11.2483 2.06498L10.9562 1.87446L10.6346 1.68894L10.3073 1.52378L10.1938 1.47176L9.95488 1.3706L9.67791 1.2669L9.42566 1.1846L9.10075 1.09489L8.83599 1.03486L8.54406 0.98184ZM10.4032 5.30023C10.4032 4.27588 10.2002 3.29829 9.83244 2.40604C11.7623 3.28995 13.1032 5.23862 13.1032 7.50023C13.1032 10.593 10.596 13.1002 7.50322 13.1002C6.63646 13.1002 5.81597 12.9036 5.08355 12.5522C6.5419 12.0941 7.81081 11.2082 8.74322 10.0416C8.87963 10.2284 9.10028 10.3497 9.34928 10.3497C9.76349 10.3497 10.0993 10.0139 10.0993 9.59971C10.0993 9.24256 9.84965 8.94373 9.51535 8.86816C9.57741 8.75165 9.63653 8.63334 9.6926 8.51332C9.88358 8.63163 10.1088 8.69993 10.35 8.69993C11.0403 8.69993 11.6 8.14028 11.6 7.44993C11.6 6.75976 11.0406 6.20024 10.3505 6.19993C10.3853 5.90487 10.4032 5.60464 10.4032 5.30023Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3f = [
    "color"
];
var $6431ef21eafb1f5a$export$3e0409b11e4da6d2 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3f);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.81819 0.93179C7.64245 0.756054 7.35753 0.756054 7.18179 0.93179L5.43179 2.68179C5.25605 2.85753 5.25605 3.14245 5.43179 3.31819C5.60753 3.49392 5.89245 3.49392 6.06819 3.31819L6.99999 2.38638V5.49999C6.99999 5.77613 7.22385 5.99999 7.49999 5.99999C7.77613 5.99999 7.99999 5.77613 7.99999 5.49999V2.38638L8.93179 3.31819C9.10753 3.49392 9.39245 3.49392 9.56819 3.31819C9.74392 3.14245 9.74392 2.85753 9.56819 2.68179L7.81819 0.93179ZM7.99999 9.49999C7.99999 9.22385 7.77613 8.99999 7.49999 8.99999C7.22385 8.99999 6.99999 9.22385 6.99999 9.49999V12.6136L6.06819 11.6818C5.89245 11.5061 5.60753 11.5061 5.43179 11.6818C5.25605 11.8575 5.25605 12.1424 5.43179 12.3182L7.18179 14.0682C7.35753 14.2439 7.64245 14.2439 7.81819 14.0682L9.56819 12.3182C9.74392 12.1424 9.74392 11.8575 9.56819 11.6818C9.39245 11.5061 9.10753 11.5061 8.93179 11.6818L7.99999 12.6136V9.49999ZM8.99999 7.49999C8.99999 7.22385 9.22385 6.99999 9.49999 6.99999H12.6136L11.6818 6.06819C11.5061 5.89245 11.5061 5.60753 11.6818 5.43179C11.8575 5.25605 12.1424 5.25605 12.3182 5.43179L14.0682 7.18179C14.2439 7.35753 14.2439 7.64245 14.0682 7.81819L12.3182 9.56819C12.1424 9.74392 11.8575 9.74392 11.6818 9.56819C11.5061 9.39245 11.5061 9.10753 11.6818 8.93179L12.6136 7.99999H9.49999C9.22385 7.99999 8.99999 7.77613 8.99999 7.49999ZM3.31819 6.06819L2.38638 6.99999H5.49999C5.77613 6.99999 5.99999 7.22385 5.99999 7.49999C5.99999 7.77613 5.77613 7.99999 5.49999 7.99999H2.38638L3.31819 8.93179C3.49392 9.10753 3.49392 9.39245 3.31819 9.56819C3.14245 9.74392 2.85753 9.74392 2.68179 9.56819L0.93179 7.81819C0.756054 7.64245 0.756054 7.35753 0.93179 7.18179L2.68179 5.43179C2.85753 5.25605 3.14245 5.25605 3.31819 5.43179C3.49392 5.60753 3.49392 5.89245 3.31819 6.06819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3g = [
    "color"
];
var $6431ef21eafb1f5a$export$f8668531034d5b61 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3g);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.25781 3.11684C3.67771 3.45796 3.83523 3.43193 4.62369 3.37933L12.0571 2.93299C12.2147 2.93299 12.0836 2.77571 12.0311 2.74957L10.7965 1.85711C10.56 1.67347 10.2448 1.46315 9.64083 1.51576L2.44308 2.04074C2.18059 2.06677 2.12815 2.19801 2.2327 2.30322L3.25781 3.11684ZM3.7041 4.84917V12.6704C3.7041 13.0907 3.91415 13.248 4.38693 13.222L12.5562 12.7493C13.0292 12.7233 13.0819 12.4341 13.0819 12.0927V4.32397C13.0819 3.98306 12.9508 3.79921 12.6612 3.82545L4.12422 4.32397C3.80918 4.35044 3.7041 4.50803 3.7041 4.84917ZM11.7688 5.26872C11.8212 5.50518 11.7688 5.74142 11.5319 5.76799L11.1383 5.84641V11.6205C10.7965 11.8042 10.4814 11.9092 10.2188 11.9092C9.79835 11.9092 9.69305 11.7779 9.37812 11.3844L6.80345 7.34249V11.2532L7.61816 11.437C7.61816 11.437 7.61816 11.9092 6.96086 11.9092L5.14879 12.0143C5.09615 11.9092 5.14879 11.647 5.33259 11.5944L5.80546 11.4634V6.29276L5.1489 6.24015C5.09625 6.00369 5.22739 5.66278 5.5954 5.63631L7.53935 5.50528L10.2188 9.5998V5.97765L9.53564 5.89924C9.4832 5.61018 9.69305 5.40028 9.95576 5.37425L11.7688 5.26872ZM1.83874 1.33212L9.32557 0.780787C10.245 0.701932 10.4815 0.754753 11.0594 1.17452L13.4492 2.85424C13.8436 3.14309 13.975 3.22173 13.975 3.53661V12.7493C13.975 13.3266 13.7647 13.6681 13.0293 13.7203L4.33492 14.2454C3.78291 14.2717 3.52019 14.193 3.23111 13.8253L1.47116 11.5419C1.1558 11.1216 1.02466 10.8071 1.02466 10.4392V2.25041C1.02466 1.77825 1.23504 1.38441 1.83874 1.33212Z",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3h = [
    "color"
];
var $6431ef21eafb1f5a$export$8af0311c2e327563 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3h);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.5 1.5C4.5 4.25 3 6.5 3 9C3 11.4853 5.01472 13.5 7.5 13.5C9.98528 13.5 12 11.4853 12 9C12 6.5 10.5 4.25 7.5 1.5ZM11 9C11 7.11203 9.97315 5.27195 7.5 2.87357C5.02686 5.27195 4 7.11203 4 9C4 10.933 5.567 12.5 7.5 12.5C9.433 12.5 11 10.933 11 9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3i = [
    "color"
];
var $6431ef21eafb1f5a$export$31dd750d53ed8eca = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3i);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 13C12.5523 13 13 12.5523 13 12V3C13 2.44771 12.5523 2 12 2H3C2.44771 2 2 2.44771 2 3V6.5C2 6.77614 2.22386 7 2.5 7C2.77614 7 3 6.77614 3 6.5V3H12V12H8.5C8.22386 12 8 12.2239 8 12.5C8 12.7761 8.22386 13 8.5 13H12ZM9 6.5C9 6.5001 9 6.50021 9 6.50031V6.50035V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5V7.70711L2.85355 12.8536C2.65829 13.0488 2.34171 13.0488 2.14645 12.8536C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L7.29289 7H5.5C5.22386 7 5 6.77614 5 6.5C5 6.22386 5.22386 6 5.5 6H8.5C8.56779 6 8.63244 6.01349 8.69139 6.03794C8.74949 6.06198 8.80398 6.09744 8.85143 6.14433C8.94251 6.23434 8.9992 6.35909 8.99999 6.49708L8.99999 6.49738",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3j = [
    "color"
];
var $6431ef21eafb1f5a$export$cc1d3fa780ad61dc = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3j);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.49985 1.10001C3.27894 1.10001 3.09985 1.27909 3.09985 1.50001C3.09985 1.72092 3.27894 1.90001 3.49985 1.90001H11.4999C11.7208 1.90001 11.8999 1.72092 11.8999 1.50001C11.8999 1.27909 11.7208 1.10001 11.4999 1.10001H3.49985ZM4.99995 4.25001C4.99995 3.97387 4.77609 3.75001 4.49995 3.75001C4.22381 3.75001 3.99995 3.97387 3.99995 4.25001V9.55001C3.99995 11.483 5.56695 13.05 7.49995 13.05C9.43295 13.05 11 11.483 11 9.55001V4.25001C11 3.97387 10.7761 3.75001 10.5 3.75001C10.2238 3.75001 9.99995 3.97387 9.99995 4.25001V9.55001C9.99995 10.9307 8.88066 12.05 7.49995 12.05C6.11924 12.05 4.99995 10.9307 4.99995 9.55001V4.25001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3k = [
    "color"
];
var $6431ef21eafb1f5a$export$2ff5a181c2f67fef = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3k);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.85714 2H12.1429C12.6162 2 13 2.38376 13 2.85714V12.1429C13 12.6162 12.6162 13 12.1429 13H2.85714C2.38376 13 2 12.6162 2 12.1429V2.85714C2 2.38376 2.38376 2 2.85714 2ZM1 2.85714C1 1.83147 1.83147 1 2.85714 1H12.1429C13.1685 1 14 1.83147 14 2.85714V12.1429C14 13.1685 13.1685 14 12.1429 14H2.85714C1.83147 14 1 13.1685 1 12.1429V2.85714ZM7.49988 5.00012C7.77602 5.00012 7.99988 4.77626 7.99988 4.50012C7.99988 4.22398 7.77602 4.00012 7.49988 4.00012C7.22374 4.00012 6.99988 4.22398 6.99988 4.50012C6.99988 4.77626 7.22374 5.00012 7.49988 5.00012ZM4.49988 11.0001C4.77602 11.0001 4.99988 10.7763 4.99988 10.5001C4.99988 10.224 4.77602 10.0001 4.49988 10.0001C4.22374 10.0001 3.99988 10.224 3.99988 10.5001C3.99988 10.7763 4.22374 11.0001 4.49988 11.0001ZM4.99988 7.50012C4.99988 7.77626 4.77602 8.00012 4.49988 8.00012C4.22374 8.00012 3.99988 7.77626 3.99988 7.50012C3.99988 7.22398 4.22374 7.00012 4.49988 7.00012C4.77602 7.00012 4.99988 7.22398 4.99988 7.50012ZM4.49988 5.00012C4.77602 5.00012 4.99988 4.77626 4.99988 4.50012C4.99988 4.22398 4.77602 4.00012 4.49988 4.00012C4.22374 4.00012 3.99988 4.22398 3.99988 4.50012C3.99988 4.77626 4.22374 5.00012 4.49988 5.00012ZM10.9999 10.5001C10.9999 10.7763 10.776 11.0001 10.4999 11.0001C10.2237 11.0001 9.99988 10.7763 9.99988 10.5001C9.99988 10.224 10.2237 10.0001 10.4999 10.0001C10.776 10.0001 10.9999 10.224 10.9999 10.5001ZM10.4999 8.00012C10.776 8.00012 10.9999 7.77626 10.9999 7.50012C10.9999 7.22398 10.776 7.00012 10.4999 7.00012C10.2237 7.00012 9.99988 7.22398 9.99988 7.50012C9.99988 7.77626 10.2237 8.00012 10.4999 8.00012ZM10.9999 4.50012C10.9999 4.77626 10.776 5.00012 10.4999 5.00012C10.2237 5.00012 9.99988 4.77626 9.99988 4.50012C9.99988 4.22398 10.2237 4.00012 10.4999 4.00012C10.776 4.00012 10.9999 4.22398 10.9999 4.50012ZM7.49988 11.0001C7.77602 11.0001 7.99988 10.7763 7.99988 10.5001C7.99988 10.224 7.77602 10.0001 7.49988 10.0001C7.22374 10.0001 6.99988 10.224 6.99988 10.5001C6.99988 10.7763 7.22374 11.0001 7.49988 11.0001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3l = [
    "color"
];
var $6431ef21eafb1f5a$export$7e727ef41af0217d = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3l);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.20308 1.04312C1.00481 0.954998 0.772341 1.0048 0.627577 1.16641C0.482813 1.32802 0.458794 1.56455 0.568117 1.75196L3.92115 7.50002L0.568117 13.2481C0.458794 13.4355 0.482813 13.672 0.627577 13.8336C0.772341 13.9952 1.00481 14.045 1.20308 13.9569L14.7031 7.95693C14.8836 7.87668 15 7.69762 15 7.50002C15 7.30243 14.8836 7.12337 14.7031 7.04312L1.20308 1.04312ZM4.84553 7.10002L2.21234 2.586L13.2689 7.50002L2.21234 12.414L4.84552 7.90002H9C9.22092 7.90002 9.4 7.72094 9.4 7.50002C9.4 7.27911 9.22092 7.10002 9 7.10002H4.84553Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3m = [
    "color"
];
var $6431ef21eafb1f5a$export$9b47433640e5db3a = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3m);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M6.04995 2.74998C6.04995 2.44623 5.80371 2.19998 5.49995 2.19998C5.19619 2.19998 4.94995 2.44623 4.94995 2.74998V12.25C4.94995 12.5537 5.19619 12.8 5.49995 12.8C5.80371 12.8 6.04995 12.5537 6.04995 12.25V2.74998ZM10.05 2.74998C10.05 2.44623 9.80371 2.19998 9.49995 2.19998C9.19619 2.19998 8.94995 2.44623 8.94995 2.74998V12.25C8.94995 12.5537 9.19619 12.8 9.49995 12.8C9.80371 12.8 10.05 12.5537 10.05 12.25V2.74998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3n = [
    "color"
];
var $6431ef21eafb1f5a$export$41c6eabacaa37313 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3n);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M11.8536 1.14645C11.6583 0.951184 11.3417 0.951184 11.1465 1.14645L3.71455 8.57836C3.62459 8.66832 3.55263 8.77461 3.50251 8.89155L2.04044 12.303C1.9599 12.491 2.00189 12.709 2.14646 12.8536C2.29103 12.9981 2.50905 13.0401 2.69697 12.9596L6.10847 11.4975C6.2254 11.4474 6.3317 11.3754 6.42166 11.2855L13.8536 3.85355C14.0488 3.65829 14.0488 3.34171 13.8536 3.14645L11.8536 1.14645ZM4.42166 9.28547L11.5 2.20711L12.7929 3.5L5.71455 10.5784L4.21924 11.2192L3.78081 10.7808L4.42166 9.28547Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3o = [
    "color"
];
var $6431ef21eafb1f5a$export$bedf874c76d8ae34 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3o);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M12.1464 1.14645C12.3417 0.951184 12.6583 0.951184 12.8535 1.14645L14.8535 3.14645C15.0488 3.34171 15.0488 3.65829 14.8535 3.85355L10.9109 7.79618C10.8349 7.87218 10.7471 7.93543 10.651 7.9835L6.72359 9.94721C6.53109 10.0435 6.29861 10.0057 6.14643 9.85355C5.99425 9.70137 5.95652 9.46889 6.05277 9.27639L8.01648 5.34897C8.06455 5.25283 8.1278 5.16507 8.2038 5.08907L12.1464 1.14645ZM12.5 2.20711L8.91091 5.79618L7.87266 7.87267L8.12731 8.12732L10.2038 7.08907L13.7929 3.5L12.5 2.20711ZM9.99998 2L8.99998 3H4.9C4.47171 3 4.18056 3.00039 3.95552 3.01877C3.73631 3.03668 3.62421 3.06915 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3.06915 3.62421 3.03669 3.73631 3.01878 3.95552C3.00039 4.18056 3 4.47171 3 4.9V11.1C3 11.5283 3.00039 11.8194 3.01878 12.0445C3.03669 12.2637 3.06915 12.3758 3.10899 12.454C3.20487 12.6422 3.35785 12.7951 3.54601 12.891C3.62421 12.9309 3.73631 12.9633 3.95552 12.9812C4.18056 12.9996 4.47171 13 4.9 13H11.1C11.5283 13 11.8194 12.9996 12.0445 12.9812C12.2637 12.9633 12.3758 12.9309 12.454 12.891C12.6422 12.7951 12.7951 12.6422 12.891 12.454C12.9309 12.3758 12.9633 12.2637 12.9812 12.0445C12.9996 11.8194 13 11.5283 13 11.1V6.99998L14 5.99998V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H4.9H4.87934C4.47686 14 4.14468 14 3.87409 13.9779C3.59304 13.9549 3.33469 13.9057 3.09202 13.782C2.7157 13.5903 2.40973 13.2843 2.21799 12.908C2.09434 12.6653 2.04506 12.407 2.0221 12.1259C1.99999 11.8553 1.99999 11.5231 2 11.1207V11.1206V11.1V4.9V4.87935V4.87932V4.87931C1.99999 4.47685 1.99999 4.14468 2.0221 3.87409C2.04506 3.59304 2.09434 3.33469 2.21799 3.09202C2.40973 2.71569 2.7157 2.40973 3.09202 2.21799C3.33469 2.09434 3.59304 2.04506 3.87409 2.0221C4.14468 1.99999 4.47685 1.99999 4.87932 2H4.87935H4.9H9.99998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3p = [
    "color"
];
var $6431ef21eafb1f5a$export$7dcc8f518762622d = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3p);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.5 0.875C5.49797 0.875 3.875 2.49797 3.875 4.5C3.875 6.15288 4.98124 7.54738 6.49373 7.98351C5.2997 8.12901 4.27557 8.55134 3.50407 9.31167C2.52216 10.2794 2.02502 11.72 2.02502 13.5999C2.02502 13.8623 2.23769 14.0749 2.50002 14.0749C2.76236 14.0749 2.97502 13.8623 2.97502 13.5999C2.97502 11.8799 3.42786 10.7206 4.17091 9.9883C4.91536 9.25463 6.02674 8.87499 7.49995 8.87499C8.97317 8.87499 10.0846 9.25463 10.8291 9.98831C11.5721 10.7206 12.025 11.8799 12.025 13.5999C12.025 13.8623 12.2376 14.0749 12.5 14.0749C12.7623 14.075 12.975 13.8623 12.975 13.6C12.975 11.72 12.4778 10.2794 11.4959 9.31166C10.7244 8.55135 9.70025 8.12903 8.50625 7.98352C10.0187 7.5474 11.125 6.15289 11.125 4.5C11.125 2.49797 9.50203 0.875 7.5 0.875ZM4.825 4.5C4.825 3.02264 6.02264 1.825 7.5 1.825C8.97736 1.825 10.175 3.02264 10.175 4.5C10.175 5.97736 8.97736 7.175 7.5 7.175C6.02264 7.175 4.825 5.97736 4.825 4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3q = [
    "color"
];
var $6431ef21eafb1f5a$export$b86b18d4ddcc0181 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3q);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.85001 7.50043C1.85001 4.37975 4.37963 1.85001 7.50001 1.85001C10.6204 1.85001 13.15 4.37975 13.15 7.50043C13.15 10.6211 10.6204 13.1509 7.50001 13.1509C4.37963 13.1509 1.85001 10.6211 1.85001 7.50043ZM7.50001 0.850006C3.82728 0.850006 0.850006 3.82753 0.850006 7.50043C0.850006 11.1733 3.82728 14.1509 7.50001 14.1509C11.1727 14.1509 14.15 11.1733 14.15 7.50043C14.15 3.82753 11.1727 0.850006 7.50001 0.850006ZM7.00001 8.00001V3.12811C7.16411 3.10954 7.33094 3.10001 7.50001 3.10001C9.93006 3.10001 11.9 5.07014 11.9 7.50043C11.9 7.66935 11.8905 7.83604 11.872 8.00001H7.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3r = [
    "color"
];
var $6431ef21eafb1f5a$export$d5d0c446063e1490 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3r);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3 5.5C3 7.983 4.99169 9 7 9V12.5C7 12.7761 7.22386 13 7.5 13C7.77614 13 8 12.7761 8 12.5V9V3.1H9V12.5C9 12.7761 9.22386 13 9.5 13C9.77614 13 10 12.7761 10 12.5V3.1H11.5C11.8038 3.1 12.05 2.85376 12.05 2.55C12.05 2.24624 11.8038 2 11.5 2H9.5H8H7.5H7C4.99169 2 3 3.017 3 5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3s = [
    "color"
];
var $6431ef21eafb1f5a$export$f65249e0566edf55 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3s);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M13.5 13.95C13.7485 13.95 13.95 13.7485 13.95 13.5C13.95 13.2514 13.7485 13.05 13.5 13.05L1.49995 13.05C1.25142 13.05 1.04995 13.2514 1.04995 13.5C1.04995 13.7485 1.25142 13.95 1.49995 13.95L13.5 13.95ZM11.0681 7.5683C11.2439 7.39257 11.2439 7.10764 11.0681 6.93191C10.8924 6.75617 10.6075 6.75617 10.4317 6.93191L7.94993 9.41371L7.94993 1.49998C7.94993 1.25146 7.74846 1.04998 7.49993 1.04998C7.2514 1.04998 7.04993 1.25146 7.04993 1.49998L7.04993 9.41371L4.56813 6.93191C4.39239 6.75617 4.10746 6.75617 3.93173 6.93191C3.75599 7.10764 3.75599 7.39257 3.93173 7.5683L7.18173 10.8183C7.35746 10.994 7.64239 10.994 7.81812 10.8183L11.0681 7.5683Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3t = [
    "color"
];
var $6431ef21eafb1f5a$export$d57f0cfd6aca7ffa = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3t);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.05005 13.5C2.05005 13.7485 2.25152 13.95 2.50005 13.95C2.74858 13.95 2.95005 13.7485 2.95005 13.5L2.95005 1.49995C2.95005 1.25142 2.74858 1.04995 2.50005 1.04995C2.25152 1.04995 2.05005 1.25142 2.05005 1.49995L2.05005 13.5ZM8.4317 11.0681C8.60743 11.2439 8.89236 11.2439 9.06809 11.0681C9.24383 10.8924 9.24383 10.6075 9.06809 10.4317L6.58629 7.94993L14.5 7.94993C14.7485 7.94993 14.95 7.74846 14.95 7.49993C14.95 7.2514 14.7485 7.04993 14.5 7.04993L6.58629 7.04993L9.06809 4.56813C9.24383 4.39239 9.24383 4.10746 9.06809 3.93173C8.89236 3.75599 8.60743 3.75599 8.4317 3.93173L5.1817 7.18173C5.00596 7.35746 5.00596 7.64239 5.1817 7.81812L8.4317 11.0681Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3u = [
    "color"
];
var $6431ef21eafb1f5a$export$fe9311722b59190b = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3u);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M12.95 1.50005C12.95 1.25152 12.7485 1.05005 12.5 1.05005C12.2514 1.05005 12.05 1.25152 12.05 1.50005L12.05 13.5C12.05 13.7486 12.2514 13.95 12.5 13.95C12.7485 13.95 12.95 13.7486 12.95 13.5L12.95 1.50005ZM6.5683 3.93188C6.39257 3.75614 6.10764 3.75614 5.93191 3.93188C5.75617 4.10761 5.75617 4.39254 5.93191 4.56827L8.41371 7.05007L0.499984 7.05007C0.251456 7.05007 0.0499847 7.25155 0.0499847 7.50007C0.0499846 7.7486 0.251457 7.95007 0.499984 7.95007L8.41371 7.95007L5.93191 10.4319C5.75617 10.6076 5.75617 10.8925 5.93191 11.0683C6.10764 11.244 6.39257 11.244 6.56831 11.0683L9.8183 7.81827C9.99404 7.64254 9.99404 7.35761 9.8183 7.18188L6.5683 3.93188Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3v = [
    "color"
];
var $6431ef21eafb1f5a$export$71e4148884d34eff = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3v);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.50005 1.05005C1.25152 1.05005 1.05005 1.25152 1.05005 1.50005C1.05005 1.74858 1.25152 1.95005 1.50005 1.95005L13.5 1.95005C13.7486 1.95005 13.95 1.74858 13.95 1.50005C13.95 1.25152 13.7486 1.05005 13.5 1.05005H1.50005ZM3.93188 7.43169C3.75614 7.60743 3.75614 7.89236 3.93188 8.06809C4.10761 8.24383 4.39254 8.24383 4.56827 8.06809L7.05007 5.58629V13.5C7.05007 13.7485 7.25155 13.95 7.50007 13.95C7.7486 13.95 7.95007 13.7485 7.95007 13.5L7.95007 5.58629L10.4319 8.06809C10.6076 8.24383 10.8925 8.24383 11.0683 8.06809C11.244 7.89235 11.244 7.60743 11.0683 7.43169L7.81827 4.18169C7.64254 4.00596 7.35761 4.00596 7.18188 4.18169L3.93188 7.43169Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3w = [
    "color"
];
var $6431ef21eafb1f5a$export$a6630b90defda83f = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3w);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.24182 2.32181C3.3919 2.23132 3.5784 2.22601 3.73338 2.30781L12.7334 7.05781C12.8974 7.14436 13 7.31457 13 7.5C13 7.68543 12.8974 7.85564 12.7334 7.94219L3.73338 12.6922C3.5784 12.774 3.3919 12.7687 3.24182 12.6782C3.09175 12.5877 3 12.4252 3 12.25V2.75C3 2.57476 3.09175 2.4123 3.24182 2.32181ZM4 3.57925V11.4207L11.4288 7.5L4 3.57925Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3x = [
    "color"
];
var $6431ef21eafb1f5a$export$f21ab0717a89c77f = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3x);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8 2.75C8 2.47386 7.77614 2.25 7.5 2.25C7.22386 2.25 7 2.47386 7 2.75V7H2.75C2.47386 7 2.25 7.22386 2.25 7.5C2.25 7.77614 2.47386 8 2.75 8H7V12.25C7 12.5261 7.22386 12.75 7.5 12.75C7.77614 12.75 8 12.5261 8 12.25V8H12.25C12.5261 8 12.75 7.77614 12.75 7.5C12.75 7.22386 12.5261 7 12.25 7H8V2.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3y = [
    "color"
];
var $6431ef21eafb1f5a$export$75a23c9e49a976a = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3y);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM7.50003 4C7.77617 4 8.00003 4.22386 8.00003 4.5V7H10.5C10.7762 7 11 7.22386 11 7.5C11 7.77614 10.7762 8 10.5 8H8.00003V10.5C8.00003 10.7761 7.77617 11 7.50003 11C7.22389 11 7.00003 10.7761 7.00003 10.5V8H4.50003C4.22389 8 4.00003 7.77614 4.00003 7.5C4.00003 7.22386 4.22389 7 4.50003 7H7.00003V4.5C7.00003 4.22386 7.22389 4 7.50003 4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3z = [
    "color"
];
var $6431ef21eafb1f5a$export$58a334b597cee6d6 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3z);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5.07505 4.10001C5.07505 2.91103 6.25727 1.92502 7.50005 1.92502C8.74283 1.92502 9.92505 2.91103 9.92505 4.10001C9.92505 5.19861 9.36782 5.71436 8.61854 6.37884L8.58757 6.4063C7.84481 7.06467 6.92505 7.87995 6.92505 9.5C6.92505 9.81757 7.18248 10.075 7.50005 10.075C7.81761 10.075 8.07505 9.81757 8.07505 9.5C8.07505 8.41517 8.62945 7.90623 9.38156 7.23925L9.40238 7.22079C10.1496 6.55829 11.075 5.73775 11.075 4.10001C11.075 2.12757 9.21869 0.775024 7.50005 0.775024C5.7814 0.775024 3.92505 2.12757 3.92505 4.10001C3.92505 4.41758 4.18249 4.67501 4.50005 4.67501C4.81761 4.67501 5.07505 4.41758 5.07505 4.10001ZM7.50005 13.3575C7.9833 13.3575 8.37505 12.9657 8.37505 12.4825C8.37505 11.9992 7.9833 11.6075 7.50005 11.6075C7.0168 11.6075 6.62505 11.9992 6.62505 12.4825C6.62505 12.9657 7.0168 13.3575 7.50005 13.3575Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3A = [
    "color"
];
var $6431ef21eafb1f5a$export$2548f56a2855ec74 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3A);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.877075 7.49972C0.877075 3.84204 3.84222 0.876892 7.49991 0.876892C11.1576 0.876892 14.1227 3.84204 14.1227 7.49972C14.1227 11.1574 11.1576 14.1226 7.49991 14.1226C3.84222 14.1226 0.877075 11.1574 0.877075 7.49972ZM7.49991 1.82689C4.36689 1.82689 1.82708 4.36671 1.82708 7.49972C1.82708 10.6327 4.36689 13.1726 7.49991 13.1726C10.6329 13.1726 13.1727 10.6327 13.1727 7.49972C13.1727 4.36671 10.6329 1.82689 7.49991 1.82689ZM8.24993 10.5C8.24993 10.9142 7.91414 11.25 7.49993 11.25C7.08571 11.25 6.74993 10.9142 6.74993 10.5C6.74993 10.0858 7.08571 9.75 7.49993 9.75C7.91414 9.75 8.24993 10.0858 8.24993 10.5ZM6.05003 6.25C6.05003 5.57211 6.63511 4.925 7.50003 4.925C8.36496 4.925 8.95003 5.57211 8.95003 6.25C8.95003 6.74118 8.68002 6.99212 8.21447 7.27494C8.16251 7.30651 8.10258 7.34131 8.03847 7.37854L8.03841 7.37858C7.85521 7.48497 7.63788 7.61119 7.47449 7.73849C7.23214 7.92732 6.95003 8.23198 6.95003 8.7C6.95004 9.00376 7.19628 9.25 7.50004 9.25C7.8024 9.25 8.04778 9.00601 8.05002 8.70417L8.05056 8.7033C8.05924 8.6896 8.08493 8.65735 8.15058 8.6062C8.25207 8.52712 8.36508 8.46163 8.51567 8.37436L8.51571 8.37433C8.59422 8.32883 8.68296 8.27741 8.78559 8.21506C9.32004 7.89038 10.05 7.35382 10.05 6.25C10.05 4.92789 8.93511 3.825 7.50003 3.825C6.06496 3.825 4.95003 4.92789 4.95003 6.25C4.95003 6.55376 5.19628 6.8 5.50003 6.8C5.80379 6.8 6.05003 6.55376 6.05003 6.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3B = [
    "color"
];
var $6431ef21eafb1f5a$export$62bd98fc131b5caa = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3B);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M9.42503 3.44136C10.0561 3.23654 10.7837 3.2402 11.3792 3.54623C12.7532 4.25224 13.3477 6.07191 12.7946 8C12.5465 8.8649 12.1102 9.70472 11.1861 10.5524C10.262 11.4 8.98034 11.9 8.38571 11.9C8.17269 11.9 8 11.7321 8 11.525C8 11.3179 8.17644 11.15 8.38571 11.15C9.06497 11.15 9.67189 10.7804 10.3906 10.236C10.9406 9.8193 11.3701 9.28633 11.608 8.82191C12.0628 7.93367 12.0782 6.68174 11.3433 6.34901C10.9904 6.73455 10.5295 6.95946 9.97725 6.95946C8.7773 6.95946 8.0701 5.99412 8.10051 5.12009C8.12957 4.28474 8.66032 3.68954 9.42503 3.44136ZM3.42503 3.44136C4.05614 3.23654 4.78366 3.2402 5.37923 3.54623C6.7532 4.25224 7.34766 6.07191 6.79462 8C6.54654 8.8649 6.11019 9.70472 5.1861 10.5524C4.26201 11.4 2.98034 11.9 2.38571 11.9C2.17269 11.9 2 11.7321 2 11.525C2 11.3179 2.17644 11.15 2.38571 11.15C3.06497 11.15 3.67189 10.7804 4.39058 10.236C4.94065 9.8193 5.37014 9.28633 5.60797 8.82191C6.06282 7.93367 6.07821 6.68174 5.3433 6.34901C4.99037 6.73455 4.52948 6.95946 3.97725 6.95946C2.7773 6.95946 2.0701 5.99412 2.10051 5.12009C2.12957 4.28474 2.66032 3.68954 3.42503 3.44136Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3C = [
    "color"
];
var $6431ef21eafb1f5a$export$c617f5f26da0904b = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3C);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 11.1575 3.84216 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1575 0.877045 7.49985 0.877045ZM1.82701 7.49988C1.82701 4.36686 4.36683 1.82704 7.49985 1.82704C10.6328 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6328 13.1727 7.49985 13.1727C4.36683 13.1727 1.82701 10.6329 1.82701 7.49988ZM7.49999 9.49999C8.60456 9.49999 9.49999 8.60456 9.49999 7.49999C9.49999 6.39542 8.60456 5.49999 7.49999 5.49999C6.39542 5.49999 5.49999 6.39542 5.49999 7.49999C5.49999 8.60456 6.39542 9.49999 7.49999 9.49999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3D = [
    "color"
];
var $6431ef21eafb1f5a$export$b6cede2da0e4d831 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3D);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.2 1H4.17741H4.1774C3.86936 0.999988 3.60368 0.999978 3.38609 1.02067C3.15576 1.04257 2.92825 1.09113 2.71625 1.22104C2.51442 1.34472 2.34473 1.51442 2.22104 1.71625C2.09113 1.92825 2.04257 2.15576 2.02067 2.38609C1.99998 2.60367 1.99999 2.86935 2 3.17738V3.1774V3.2V11.8V11.8226V11.8226C1.99999 12.1307 1.99998 12.3963 2.02067 12.6139C2.04257 12.8442 2.09113 13.0717 2.22104 13.2837C2.34473 13.4856 2.51442 13.6553 2.71625 13.779C2.92825 13.9089 3.15576 13.9574 3.38609 13.9793C3.60368 14 3.86937 14 4.17741 14H4.2H10.8H10.8226C11.1306 14 11.3963 14 11.6139 13.9793C11.8442 13.9574 12.0717 13.9089 12.2837 13.779C12.4856 13.6553 12.6553 13.4856 12.779 13.2837C12.9089 13.0717 12.9574 12.8442 12.9793 12.6139C13 12.3963 13 12.1306 13 11.8226V11.8V3.2V3.17741C13 2.86936 13 2.60368 12.9793 2.38609C12.9574 2.15576 12.9089 1.92825 12.779 1.71625C12.6553 1.51442 12.4856 1.34472 12.2837 1.22104C12.0717 1.09113 11.8442 1.04257 11.6139 1.02067C11.3963 0.999978 11.1306 0.999988 10.8226 1H10.8H4.2ZM3.23875 2.07368C3.26722 2.05623 3.32362 2.03112 3.48075 2.01618C3.64532 2.00053 3.86298 2 4.2 2H10.8C11.137 2 11.3547 2.00053 11.5193 2.01618C11.6764 2.03112 11.7328 2.05623 11.7613 2.07368C11.8285 2.11491 11.8851 2.17147 11.9263 2.23875C11.9438 2.26722 11.9689 2.32362 11.9838 2.48075C11.9995 2.64532 12 2.86298 12 3.2V11.8C12 12.137 11.9995 12.3547 11.9838 12.5193C11.9689 12.6764 11.9438 12.7328 11.9263 12.7613C11.8851 12.8285 11.8285 12.8851 11.7613 12.9263C11.7328 12.9438 11.6764 12.9689 11.5193 12.9838C11.3547 12.9995 11.137 13 10.8 13H4.2C3.86298 13 3.64532 12.9995 3.48075 12.9838C3.32362 12.9689 3.26722 12.9438 3.23875 12.9263C3.17147 12.8851 3.11491 12.8285 3.07368 12.7613C3.05624 12.7328 3.03112 12.6764 3.01618 12.5193C3.00053 12.3547 3 12.137 3 11.8V3.2C3 2.86298 3.00053 2.64532 3.01618 2.48075C3.03112 2.32362 3.05624 2.26722 3.07368 2.23875C3.11491 2.17147 3.17147 2.11491 3.23875 2.07368ZM5 10C4.72386 10 4.5 10.2239 4.5 10.5C4.5 10.7761 4.72386 11 5 11H8C8.27614 11 8.5 10.7761 8.5 10.5C8.5 10.2239 8.27614 10 8 10H5ZM4.5 7.5C4.5 7.22386 4.72386 7 5 7H10C10.2761 7 10.5 7.22386 10.5 7.5C10.5 7.77614 10.2761 8 10 8H5C4.72386 8 4.5 7.77614 4.5 7.5ZM5 4C4.72386 4 4.5 4.22386 4.5 4.5C4.5 4.77614 4.72386 5 5 5H10C10.2761 5 10.5 4.77614 10.5 4.5C10.5 4.22386 10.2761 4 10 4H5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3E = [
    "color"
];
var $6431ef21eafb1f5a$export$ca36f1a1d2d1ca14 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3E);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.84998 7.49998C1.84998 4.66458 4.05979 1.84998 7.49998 1.84998C10.2783 1.84998 11.6515 3.9064 12.2367 5H10.5C10.2239 5 10 5.22386 10 5.5C10 5.77614 10.2239 6 10.5 6H13.5C13.7761 6 14 5.77614 14 5.5V2.5C14 2.22386 13.7761 2 13.5 2C13.2239 2 13 2.22386 13 2.5V4.31318C12.2955 3.07126 10.6659 0.849976 7.49998 0.849976C3.43716 0.849976 0.849976 4.18537 0.849976 7.49998C0.849976 10.8146 3.43716 14.15 7.49998 14.15C9.44382 14.15 11.0622 13.3808 12.2145 12.2084C12.8315 11.5806 13.3133 10.839 13.6418 10.0407C13.7469 9.78536 13.6251 9.49315 13.3698 9.38806C13.1144 9.28296 12.8222 9.40478 12.7171 9.66014C12.4363 10.3425 12.0251 10.9745 11.5013 11.5074C10.5295 12.4963 9.16504 13.15 7.49998 13.15C4.05979 13.15 1.84998 10.3354 1.84998 7.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3F = [
    "color"
];
var $6431ef21eafb1f5a$export$7637ad60dd86d3b1 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3F);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.85355 2.14645C5.04882 2.34171 5.04882 2.65829 4.85355 2.85355L3.70711 4H9C11.4853 4 13.5 6.01472 13.5 8.5C13.5 10.9853 11.4853 13 9 13H5C4.72386 13 4.5 12.7761 4.5 12.5C4.5 12.2239 4.72386 12 5 12H9C10.933 12 12.5 10.433 12.5 8.5C12.5 6.567 10.933 5 9 5H3.70711L4.85355 6.14645C5.04882 6.34171 5.04882 6.65829 4.85355 6.85355C4.65829 7.04882 4.34171 7.04882 4.14645 6.85355L2.14645 4.85355C1.95118 4.65829 1.95118 4.34171 2.14645 4.14645L4.14645 2.14645C4.34171 1.95118 4.65829 1.95118 4.85355 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3G = [
    "color"
];
var $6431ef21eafb1f5a$export$199745d7f18c0761 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3G);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.04995 2.74995C3.04995 2.44619 2.80371 2.19995 2.49995 2.19995C2.19619 2.19995 1.94995 2.44619 1.94995 2.74995V12.25C1.94995 12.5537 2.19619 12.8 2.49995 12.8C2.80371 12.8 3.04995 12.5537 3.04995 12.25V2.74995ZM5.73333 2.30776C5.57835 2.22596 5.39185 2.23127 5.24177 2.32176C5.0917 2.41225 4.99995 2.57471 4.99995 2.74995V12.25C4.99995 12.4252 5.0917 12.5877 5.24177 12.6781C5.39185 12.7686 5.57835 12.7739 5.73333 12.6921L14.7333 7.94214C14.8973 7.85559 15 7.68539 15 7.49995C15 7.31452 14.8973 7.14431 14.7333 7.05776L5.73333 2.30776ZM5.99995 11.4207V3.5792L13.4287 7.49995L5.99995 11.4207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3H = [
    "color"
];
var $6431ef21eafb1f5a$export$8e0d2500d5bd92ef = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3H);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M6.85357 3.85355L7.65355 3.05353C8.2981 2.40901 9.42858 1.96172 10.552 1.80125C11.1056 1.72217 11.6291 1.71725 12.0564 1.78124C12.4987 1.84748 12.7698 1.97696 12.8965 2.10357C13.0231 2.23018 13.1526 2.50125 13.2188 2.94357C13.2828 3.37086 13.2779 3.89439 13.1988 4.44801C13.0383 5.57139 12.591 6.70188 11.9464 7.34645L7.49999 11.7929L6.35354 10.6465C6.15827 10.4512 5.84169 10.4512 5.64643 10.6465C5.45117 10.8417 5.45117 11.1583 5.64643 11.3536L7.14644 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L8.40073 12.3064L9.57124 14.2572C9.65046 14.3893 9.78608 14.4774 9.9389 14.4963C10.0917 14.5151 10.2447 14.4624 10.3535 14.3536L12.3535 12.3536C12.4648 12.2423 12.5172 12.0851 12.495 11.9293L12.0303 8.67679L12.6536 8.05355C13.509 7.19808 14.0117 5.82855 14.1887 4.58943C14.2784 3.9618 14.2891 3.33847 14.2078 2.79546C14.1287 2.26748 13.9519 1.74482 13.6035 1.39645C13.2552 1.04809 12.7325 0.871332 12.2045 0.792264C11.6615 0.710945 11.0382 0.721644 10.4105 0.8113C9.17143 0.988306 7.80189 1.491 6.94644 2.34642L6.32322 2.96968L3.07071 2.50504C2.91492 2.48278 2.75773 2.53517 2.64645 2.64646L0.646451 4.64645C0.537579 4.75533 0.484938 4.90829 0.50375 5.0611C0.522563 5.21391 0.61073 5.34954 0.742757 5.42876L2.69364 6.59928L2.14646 7.14645C2.0527 7.24022 2.00002 7.3674 2.00002 7.50001C2.00002 7.63261 2.0527 7.75979 2.14646 7.85356L3.64647 9.35356C3.84173 9.54883 4.15831 9.54883 4.35357 9.35356C4.54884 9.1583 4.54884 8.84172 4.35357 8.64646L3.20712 7.50001L3.85357 6.85356L6.85357 3.85355ZM10.0993 13.1936L9.12959 11.5775L11.1464 9.56067L11.4697 11.8232L10.0993 13.1936ZM3.42251 5.87041L5.43935 3.85356L3.17678 3.53034L1.80638 4.90074L3.42251 5.87041ZM2.35356 10.3535C2.54882 10.1583 2.54882 9.8417 2.35356 9.64644C2.1583 9.45118 1.84171 9.45118 1.64645 9.64644L0.646451 10.6464C0.451188 10.8417 0.451188 11.1583 0.646451 11.3535C0.841713 11.5488 1.1583 11.5488 1.35356 11.3535L2.35356 10.3535ZM3.85358 11.8536C4.04884 11.6583 4.04885 11.3417 3.85359 11.1465C3.65833 10.9512 3.34175 10.9512 3.14648 11.1465L1.14645 13.1464C0.95119 13.3417 0.951187 13.6583 1.14645 13.8535C1.34171 14.0488 1.65829 14.0488 1.85355 13.8536L3.85358 11.8536ZM5.35356 13.3535C5.54882 13.1583 5.54882 12.8417 5.35356 12.6464C5.1583 12.4512 4.84171 12.4512 4.64645 12.6464L3.64645 13.6464C3.45119 13.8417 3.45119 14.1583 3.64645 14.3535C3.84171 14.5488 4.1583 14.5488 4.35356 14.3535L5.35356 13.3535ZM9.49997 6.74881C10.1897 6.74881 10.7488 6.1897 10.7488 5.5C10.7488 4.8103 10.1897 4.25118 9.49997 4.25118C8.81026 4.25118 8.25115 4.8103 8.25115 5.5C8.25115 6.1897 8.81026 6.74881 9.49997 6.74881Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3I = [
    "color"
];
var $6431ef21eafb1f5a$export$f0960ce3e1a6f234 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3I);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.59664 2.93628C7.76085 3.06401 8.00012 2.94698 8.00012 2.73895V1.99998C9.98143 2 11.1848 2.3637 11.9105 3.08945C12.6363 3.81522 13 5.0186 13 6.99998C13 7.27613 13.2239 7.49998 13.5 7.49998C13.7761 7.49998 14 7.27613 14 6.99998C14 4.9438 13.6325 3.39719 12.6176 2.38234C11.6028 1.36752 10.0562 0.999999 8.00012 0.999984V0.261266C8.00012 0.0532293 7.76085 -0.0637944 7.59664 0.063928L6.00384 1.30277C5.87516 1.40286 5.87516 1.59735 6.00384 1.69744L7.59664 2.93628ZM9.5 5H2.5C2.22386 5 2 5.22386 2 5.5V12.5C2 12.7761 2.22386 13 2.5 13H9.5C9.77614 13 10 12.7761 10 12.5V5.5C10 5.22386 9.77614 5 9.5 5ZM2.5 4C1.67157 4 1 4.67157 1 5.5V12.5C1 13.3284 1.67157 14 2.5 14H9.5C10.3284 14 11 13.3284 11 12.5V5.5C11 4.67157 10.3284 4 9.5 4H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3J = [
    "color"
];
var $6431ef21eafb1f5a$export$f0399077805ff597 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3J);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.81832 0.68179C7.64258 0.506054 7.35766 0.506054 7.18192 0.68179L5.18192 2.68179C5.00619 2.85753 5.00619 3.14245 5.18192 3.31819C5.35766 3.49392 5.64258 3.49392 5.81832 3.31819L7.05012 2.08638L7.05012 5.50023C7.05012 5.74876 7.25159 5.95023 7.50012 5.95023C7.74865 5.95023 7.95012 5.74876 7.95012 5.50023L7.95012 2.08638L9.18192 3.31819C9.35766 3.49392 9.64258 3.49392 9.81832 3.31819C9.99406 3.14245 9.99406 2.85753 9.81832 2.68179L7.81832 0.68179ZM7.95012 12.9136V9.50023C7.95012 9.2517 7.74865 9.05023 7.50012 9.05023C7.25159 9.05023 7.05012 9.2517 7.05012 9.50023V12.9136L5.81832 11.6818C5.64258 11.5061 5.35766 11.5061 5.18192 11.6818C5.00619 11.8575 5.00619 12.1424 5.18192 12.3182L7.18192 14.3182C7.26632 14.4026 7.38077 14.45 7.50012 14.45C7.61947 14.45 7.73393 14.4026 7.81832 14.3182L9.81832 12.3182C9.99406 12.1424 9.99406 11.8575 9.81832 11.6818C9.64258 11.5061 9.35766 11.5061 9.18192 11.6818L7.95012 12.9136ZM1.49994 7.00017C1.2238 7.00017 0.999939 7.22403 0.999939 7.50017C0.999939 7.77631 1.2238 8.00017 1.49994 8.00017L13.4999 8.00017C13.7761 8.00017 13.9999 7.77631 13.9999 7.50017C13.9999 7.22403 13.7761 7.00017 13.4999 7.00017L1.49994 7.00017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3K = [
    "color"
];
var $6431ef21eafb1f5a$export$472271f3e918e2f4 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3K);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M14 12.85L1 12.85L1 14.15L14 14.15L14 12.85ZM14 8.85002L1 8.85002L1 10.15L14 10.15L14 8.85002ZM1 4.85003L14 4.85003L14 6.15003L1 6.15002L1 4.85003ZM14 0.850025L1 0.850025L1 2.15002L14 2.15002L14 0.850025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3L = [
    "color"
];
var $6431ef21eafb1f5a$export$c3403272e8c8becf = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3L);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.5 4C0.223858 4 0 4.22386 0 4.5V10.5C0 10.7761 0.223858 11 0.5 11H14.5C14.7761 11 15 10.7761 15 10.5V4.5C15 4.22386 14.7761 4 14.5 4H0.5ZM1 10V5H2.075V7.5C2.075 7.73472 2.26528 7.925 2.5 7.925C2.73472 7.925 2.925 7.73472 2.925 7.5V5H4.075V6.5C4.075 6.73472 4.26528 6.925 4.5 6.925C4.73472 6.925 4.925 6.73472 4.925 6.5V5H6.075V6.5C6.075 6.73472 6.26528 6.925 6.5 6.925C6.73472 6.925 6.925 6.73472 6.925 6.5V5H8.075V7.5C8.075 7.73472 8.26528 7.925 8.5 7.925C8.73472 7.925 8.925 7.73472 8.925 7.5V5H10.075V6.5C10.075 6.73472 10.2653 6.925 10.5 6.925C10.7347 6.925 10.925 6.73472 10.925 6.5V5H12.075V6.5C12.075 6.73472 12.2653 6.925 12.5 6.925C12.7347 6.925 12.925 6.73472 12.925 6.5V5H14V10H1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3M = [
    "color"
];
var $6431ef21eafb1f5a$export$e940813548ac56bd = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3M);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.5 0C0.223858 0 0 0.223858 0 0.5V14.5C0 14.7761 0.223858 15 0.5 15H4.5C4.77614 15 5 14.7761 5 14.5V5H14.5C14.7761 5 15 4.77614 15 4.5V0.5C15 0.223858 14.7761 0 14.5 0H0.5ZM1 4.07505L1 1H4.07502C4.07502 1 4.07502 1 4.07502 1L4.07505 4.07507L1 4.07505ZM0.999997 4.92505L1 14H4V12.925H2.75002C2.5153 12.925 2.32502 12.7348 2.32502 12.5C2.32502 12.2653 2.5153 12.075 2.75002 12.075H4V10.925H2.25002C2.0153 10.925 1.82502 10.7347 1.82502 10.5C1.82502 10.2653 2.0153 10.075 2.25002 10.075H4V8.92504L2.75002 8.92502C2.5153 8.92502 2.32502 8.73474 2.32502 8.50002C2.32503 8.26529 2.51531 8.07502 2.75003 8.07502L4 8.07504V6.92502L2.74999 6.925C2.51527 6.925 2.325 6.73472 2.325 6.5C2.325 6.26528 2.51529 6.075 2.75001 6.075L4 6.07502V4.92507L0.999997 4.92505ZM4.92505 4H6.075V2.75006C6.075 2.51534 6.26528 2.32506 6.5 2.32506C6.73472 2.32506 6.925 2.51534 6.925 2.75006V4H8.07502V2.75005C8.07502 2.51533 8.2653 2.32505 8.50002 2.32505C8.73474 2.32505 8.92502 2.51533 8.92502 2.75005V4H10.0751V2.25005C10.0751 2.01533 10.2653 1.82505 10.5001 1.82505C10.7348 1.82505 10.9251 2.01533 10.9251 2.25005V4H12.0751V2.75005C12.0751 2.51533 12.2654 2.32505 12.5001 2.32505C12.7348 2.32505 12.9251 2.51533 12.9251 2.75005V4H14V1H4.92502L4.92505 4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3N = [
    "color"
];
var $6431ef21eafb1f5a$export$ca010e7ed4ef0790 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3N);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.949988 4.48455C0.949988 5.34059 1.64395 6.03455 2.49999 6.03455C3.35603 6.03455 4.04999 5.34059 4.04999 4.48455C4.04999 3.6285 3.35603 2.93455 2.49999 2.93455C1.64395 2.93455 0.949988 3.6285 0.949988 4.48455ZM2.49999 6.93455C1.14689 6.93455 0.0499878 5.83764 0.0499878 4.48455C0.0499878 3.13145 1.14689 2.03455 2.49999 2.03455C3.85309 2.03455 4.94999 3.13145 4.94999 4.48455C4.94999 4.80813 4.88726 5.11707 4.77329 5.39985L5.73655 6.04413C5.72943 6.06656 5.72269 6.08914 5.71635 6.11188L5.56288 6.66186L5.21005 6.89773L4.21554 6.23366C3.77357 6.6672 3.168 6.93455 2.49999 6.93455ZM0.949991 10.5C0.949991 9.64394 1.64395 8.94998 2.49999 8.94998C3.35603 8.94998 4.04999 9.64394 4.04999 10.5C4.04999 11.356 3.35603 12.05 2.49999 12.05C1.64395 12.05 0.949991 11.356 0.949991 10.5ZM2.49999 8.04998C1.14689 8.04998 0.0499908 9.14688 0.0499908 10.5C0.0499908 11.8531 1.14689 12.95 2.49999 12.95C3.85309 12.95 4.94999 11.8531 4.94999 10.5C4.94999 10.1803 4.88877 9.87497 4.77743 9.595L15 2.75737L14.0486 2.85737C12.7077 2.9983 11.4091 3.40895 10.231 4.06461L7.15646 5.77564C6.92307 5.90553 6.75134 6.12339 6.67955 6.38066L6.42653 7.28737L4.22437 8.75957C3.78166 8.32091 3.17246 8.04998 2.49999 8.04998ZM7.14435 9.2149L7.15646 9.22176L10.231 10.9328C11.4091 11.5884 12.7077 11.9991 14.0486 12.14L15 12.24L8.81072 8.1003L7.14435 9.2149Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3O = [
    "color"
];
var $6431ef21eafb1f5a$export$ab8815222a429372 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3O);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2 1.5C2 1.77614 1.77614 2 1.5 2C1.22386 2 1 1.77614 1 1.5C1 1.22386 1.22386 1 1.5 1C1.77614 1 2 1.22386 2 1.5ZM2 5L2 10H13V5H2ZM2 4C1.44772 4 1 4.44772 1 5V10C1 10.5523 1.44772 11 2 11H13C13.5523 11 14 10.5523 14 10V5C14 4.44772 13.5523 4 13 4H2ZM1.5 14C1.77614 14 2 13.7761 2 13.5C2 13.2239 1.77614 13 1.5 13C1.22386 13 1 13.2239 1 13.5C1 13.7761 1.22386 14 1.5 14ZM4 1.5C4 1.77614 3.77614 2 3.5 2C3.22386 2 3 1.77614 3 1.5C3 1.22386 3.22386 1 3.5 1C3.77614 1 4 1.22386 4 1.5ZM3.5 14C3.77614 14 4 13.7761 4 13.5C4 13.2239 3.77614 13 3.5 13C3.22386 13 3 13.2239 3 13.5C3 13.7761 3.22386 14 3.5 14ZM6 1.5C6 1.77614 5.77614 2 5.5 2C5.22386 2 5 1.77614 5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5ZM5.5 14C5.77614 14 6 13.7761 6 13.5C6 13.2239 5.77614 13 5.5 13C5.22386 13 5 13.2239 5 13.5C5 13.7761 5.22386 14 5.5 14ZM8 1.5C8 1.77614 7.77614 2 7.5 2C7.22386 2 7 1.77614 7 1.5C7 1.22386 7.22386 1 7.5 1C7.77614 1 8 1.22386 8 1.5ZM7.5 14C7.77614 14 8 13.7761 8 13.5C8 13.2239 7.77614 13 7.5 13C7.22386 13 7 13.2239 7 13.5C7 13.7761 7.22386 14 7.5 14ZM10 1.5C10 1.77614 9.77614 2 9.5 2C9.22386 2 9 1.77614 9 1.5C9 1.22386 9.22386 1 9.5 1C9.77614 1 10 1.22386 10 1.5ZM9.5 14C9.77614 14 10 13.7761 10 13.5C10 13.2239 9.77614 13 9.5 13C9.22386 13 9 13.2239 9 13.5C9 13.7761 9.22386 14 9.5 14ZM12 1.5C12 1.77614 11.7761 2 11.5 2C11.2239 2 11 1.77614 11 1.5C11 1.22386 11.2239 1 11.5 1C11.7761 1 12 1.22386 12 1.5ZM11.5 14C11.7761 14 12 13.7761 12 13.5C12 13.2239 11.7761 13 11.5 13C11.2239 13 11 13.2239 11 13.5C11 13.7761 11.2239 14 11.5 14ZM14 1.5C14 1.77614 13.7761 2 13.5 2C13.2239 2 13 1.77614 13 1.5C13 1.22386 13.2239 1 13.5 1C13.7761 1 14 1.22386 14 1.5ZM13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3P = [
    "color"
];
var $6431ef21eafb1f5a$export$9a1f3409566e1d35 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3P);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M6 3.5C6 2.67157 6.67157 2 7.5 2C8.32843 2 9 2.67157 9 3.5C9 4.32843 8.32843 5 7.5 5C6.67157 5 6 4.32843 6 3.5ZM8 5.94999C9.14112 5.71836 10 4.70948 10 3.5C10 2.11929 8.88071 1 7.5 1C6.11929 1 5 2.11929 5 3.5C5 4.70948 5.85888 5.71836 7 5.94999V13.5C7 13.7761 7.22386 14 7.5 14C7.77614 14 8 13.7761 8 13.5V5.94999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3Q = [
    "color"
];
var $6431ef21eafb1f5a$export$8217100f92ae3d76 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3Q);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M10 3.5C10 4.70948 9.14112 5.71836 8 5.94999V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.94999C5.85888 5.71836 5 4.70948 5 3.5C5 2.11929 6.11929 1 7.5 1C8.88071 1 10 2.11929 10 3.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3R = [
    "color"
];
var $6431ef21eafb1f5a$export$30dea8f5f241e3b3 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3R);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".05",
        d: "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".1",
        d: "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".15",
        d: "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".2",
        d: "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".25",
        d: "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".3",
        d: "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".35",
        d: "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".4",
        d: "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".45",
        d: "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".5",
        d: "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3S = [
    "color"
];
var $6431ef21eafb1f5a$export$c7400a1254b7566e = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3S);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".05",
        d: "M12.1619 3.85182C8.35817 4.88918 4.88936 8.358 3.85199 12.1617L3.3696 12.0301C4.45356 8.05564 8.05581 4.45339 12.0303 3.36943L12.1619 3.85182Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".1",
        d: "M11.8807 3.42707C8.03441 4.50542 4.50561 8.03422 3.42726 11.8805L2.94582 11.7456C4.07129 7.73121 7.7314 4.0711 11.7458 2.94563L11.8807 3.42707Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".15",
        d: "M11.5201 3.02556C7.69092 4.16199 4.16779 7.68323 3.02805 11.512L2.54883 11.3694C3.73676 7.37869 7.38659 3.73076 11.3778 2.54623L11.5201 3.02556Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".2",
        d: "M11.0468 2.66169C7.31117 3.87664 3.87918 7.3079 2.66298 11.0434L2.18754 10.8886C3.45324 7.00109 7.00445 3.45062 10.8921 2.18621L11.0468 2.66169Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".25",
        d: "M10.5201 2.32365C6.92091 3.61447 3.62391 6.90876 2.32845 10.5073L1.858 10.338C3.20398 6.59909 6.61155 3.19424 10.3513 1.85301L10.5201 2.32365Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".3",
        d: "M9.90222 2.03122C6.50003 3.39465 3.39968 6.49367 2.03399 9.89551L1.56998 9.70924C2.98651 6.18076 6.18728 2.98133 9.71622 1.5671L9.90222 2.03122Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".35",
        d: "M9.20727 1.78873C6.06136 3.20349 3.21103 6.05203 1.79331 9.19738L1.33747 8.99192C2.80536 5.73528 5.74485 2.7976 9.0022 1.33272L9.20727 1.78873Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".4",
        d: "M8.40713 1.62085C5.59323 3.05117 3.05794 5.58509 1.62544 8.39847L1.17987 8.1716C2.66036 5.26397 5.27232 2.6534 8.18057 1.17513L8.40713 1.62085Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".45",
        d: "M7.46207 1.56747C5.08689 2.94695 2.95362 5.07912 1.57249 7.45379L1.14028 7.20241C2.56503 4.75273 4.7607 2.55818 7.21096 1.1351L7.46207 1.56747Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".5",
        d: "M6.30407 1.70487C4.51964 2.91063 2.90983 4.52061 1.7043 6.30513L1.28998 6.02524C2.5313 4.18773 4.18673 2.53214 6.02413 1.29059L6.30407 1.70487Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3T = [
    "color"
];
var $6431ef21eafb1f5a$export$126350cae9fbd558 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3T);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".05",
        d: "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".1",
        d: "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".15",
        d: "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".2",
        d: "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".25",
        d: "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".3",
        d: "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".35",
        d: "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".4",
        d: "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".45",
        d: "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".5",
        d: "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 9.1488 1.47969 10.657 2.4767 11.8162L1.64647 12.6464C1.45121 12.8417 1.45121 13.1583 1.64647 13.3535C1.84173 13.5488 2.15832 13.5488 2.35358 13.3535L3.18383 12.5233C4.34302 13.5202 5.8511 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34298 12.5233 3.1838L13.3536 2.35355C13.5488 2.15829 13.5488 1.8417 13.3536 1.64644C13.1583 1.45118 12.8417 1.45118 12.6465 1.64644L11.8162 2.47667C10.657 1.47966 9.14883 0.877045 7.49991 0.877045ZM11.1423 3.15065C10.1568 2.32449 8.88644 1.82704 7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 8.88641 2.32452 10.1568 3.15069 11.1422L11.1423 3.15065ZM3.85781 11.8493C4.84322 12.6753 6.11348 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11345 12.6754 4.84319 11.8493 3.85778L3.85781 11.8493Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3U = [
    "color"
];
var $6431ef21eafb1f5a$export$a3edb785270158f1 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3U);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".05",
        d: "M12.1398 3.88617C13.8553 4.94159 15 6.83701 15 9.00001C15 12.3137 12.3137 15 9.00002 15C6.84351 15 4.95296 13.8621 3.89569 12.1552L4.32076 11.8919C5.29069 13.4578 7.02376 14.5 9.00002 14.5C12.0376 14.5 14.5 12.0375 14.5 9.00001C14.5 7.01781 13.4516 5.28027 11.8778 4.31203L12.1398 3.88617Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".2",
        d: "M12.851 5.07321C13.8684 6.07106 14.5 7.46199 14.5 9C14.5 12.0375 12.0376 14.5 9.00004 14.5C7.46215 14.5 6.07132 13.8685 5.07349 12.8513L5.43043 12.5011C6.3381 13.4264 7.60186 14 9.00004 14C11.7614 14 14 11.7614 14 9C14 7.60171 13.4264 6.33786 12.5009 5.43017L12.851 5.07321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".35",
        d: "M13.3022 6.45071C13.7455 7.19737 14 8.06935 14 9.00001C14 11.7614 11.7614 14 9.00002 14C8.04868 14 7.15868 13.7341 6.40118 13.2724L6.66142 12.8454C7.34275 13.2607 8.14306 13.5 9.00002 13.5C11.4853 13.5 13.5 11.4853 13.5 9.00001C13.5 8.16165 13.271 7.37754 12.8722 6.70599L13.3022 6.45071Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".5",
        d: "M13.3745 7.94022C13.4566 8.28031 13.5 8.63525 13.5 9.00001C13.5 11.4853 11.4853 13.5 9.00003 13.5C8.61104 13.5 8.23323 13.4506 7.87268 13.3576L7.99759 12.8734C8.31768 12.956 8.65353 13 9.00003 13C11.2091 13 13 11.2091 13 9.00001C13 8.67509 12.9613 8.35953 12.8884 8.05757L13.3745 7.94022Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".65",
        d: "M12.9155 9.82133C12.5898 11.3813 11.3562 12.6072 9.79205 12.9215L9.69354 12.4313C11.0613 12.1565 12.1413 11.0834 12.4261 9.71915L12.9155 9.82133Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.2771 7.50253C1.2771 4.06456 4.06413 1.27753 7.5021 1.27753C10.94 1.27753 13.7271 4.06456 13.7271 7.50253C13.7271 10.9405 10.94 13.7275 7.5021 13.7275C4.06413 13.7275 1.2771 10.9405 1.2771 7.50253ZM7.5021 2.22753C4.5888 2.22753 2.2271 4.58923 2.2271 7.50253C2.2271 10.4158 4.5888 12.7775 7.5021 12.7775C10.4154 12.7775 12.7771 10.4158 12.7771 7.50253C12.7771 4.58923 10.4154 2.22753 7.5021 2.22753Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3V = [
    "color"
];
var $6431ef21eafb1f5a$export$fe819ae1b3a84d32 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3V);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5 7.50003C5 8.32845 4.32843 9.00003 3.5 9.00003C2.67157 9.00003 2 8.32845 2 7.50003C2 6.6716 2.67157 6.00003 3.5 6.00003C4.32843 6.00003 5 6.6716 5 7.50003ZM5.71313 8.66388C5.29445 9.45838 4.46048 10 3.5 10C2.11929 10 1 8.88074 1 7.50003C1 6.11931 2.11929 5.00003 3.5 5.00003C4.46048 5.00003 5.29445 5.54167 5.71313 6.33616L9.10424 4.21671C9.03643 3.98968 9 3.74911 9 3.50003C9 2.11932 10.1193 1.00003 11.5 1.00003C12.8807 1.00003 14 2.11932 14 3.50003C14 4.88074 12.8807 6.00003 11.5 6.00003C10.6915 6.00003 9.97264 5.61624 9.51566 5.0209L5.9853 7.22738C5.99502 7.31692 6 7.40789 6 7.50003C6 7.59216 5.99502 7.68312 5.9853 7.77267L9.51567 9.97915C9.97265 9.38382 10.6915 9.00003 11.5 9.00003C12.8807 9.00003 14 10.1193 14 11.5C14 12.8807 12.8807 14 11.5 14C10.1193 14 9 12.8807 9 11.5C9 11.2509 9.03643 11.0104 9.10425 10.7833L5.71313 8.66388ZM11.5 5.00003C12.3284 5.00003 13 4.32846 13 3.50003C13 2.6716 12.3284 2.00003 11.5 2.00003C10.6716 2.00003 10 2.6716 10 3.50003C10 4.32846 10.6716 5.00003 11.5 5.00003ZM13 11.5C13 12.3285 12.3284 13 11.5 13C10.6716 13 10 12.3285 10 11.5C10 10.6716 10.6716 10 11.5 10C12.3284 10 13 10.6716 13 11.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3W = [
    "color"
];
var $6431ef21eafb1f5a$export$fd8d21248a547675 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3W);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.5 5.00006C3.22386 5.00006 3 5.22392 3 5.50006L3 11.5001C3 11.7762 3.22386 12.0001 3.5 12.0001L11.5 12.0001C11.7761 12.0001 12 11.7762 12 11.5001L12 5.50006C12 5.22392 11.7761 5.00006 11.5 5.00006L10.25 5.00006C9.97386 5.00006 9.75 4.7762 9.75 4.50006C9.75 4.22392 9.97386 4.00006 10.25 4.00006L11.5 4.00006C12.3284 4.00006 13 4.67163 13 5.50006L13 11.5001C13 12.3285 12.3284 13.0001 11.5 13.0001L3.5 13.0001C2.67157 13.0001 2 12.3285 2 11.5001L2 5.50006C2 4.67163 2.67157 4.00006 3.5 4.00006L4.75 4.00006C5.02614 4.00006 5.25 4.22392 5.25 4.50006C5.25 4.7762 5.02614 5.00006 4.75 5.00006L3.5 5.00006ZM7 1.6364L5.5682 3.0682C5.39246 3.24393 5.10754 3.24393 4.9318 3.0682C4.75607 2.89246 4.75607 2.60754 4.9318 2.4318L7.1818 0.181802C7.26619 0.09741 7.38065 0.049999 7.5 0.049999C7.61935 0.049999 7.73381 0.09741 7.8182 0.181802L10.0682 2.4318C10.2439 2.60754 10.2439 2.89246 10.0682 3.0682C9.89246 3.24393 9.60754 3.24393 9.4318 3.0682L8 1.6364L8 8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5L7 1.6364Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3X = [
    "color"
];
var $6431ef21eafb1f5a$export$f584b8d6931467fb = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3X);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M12.3536 1.14645C12.1583 0.951184 11.8417 0.951184 11.6464 1.14645C11.4512 1.34171 11.4512 1.65829 11.6464 1.85355L12.7929 3H12C10.7037 3 9.71111 3.58423 8.87248 4.38931C8.20065 5.03427 7.59349 5.85684 6.99461 6.6682C6.86287 6.84668 6.73154 7.02462 6.6 7.2C5.10874 9.18835 3.49037 11 0.5 11C0.223858 11 0 11.2239 0 11.5C0 11.7761 0.223858 12 0.5 12C4.00963 12 5.89126 9.81165 7.4 7.8C7.54367 7.60845 7.6832 7.41962 7.81996 7.23454L7.82005 7.23443L7.82006 7.23441C8.41674 6.42695 8.96069 5.69085 9.56502 5.11069C10.2889 4.41577 11.0463 4 12 4H12.7929L11.6464 5.14645C11.4512 5.34171 11.4512 5.65829 11.6464 5.85355C11.8417 6.04882 12.1583 6.04882 12.3536 5.85355L14.3536 3.85355C14.5488 3.65829 14.5488 3.34171 14.3536 3.14645L12.3536 1.14645ZM0.5 3C3.35278 3 5.12992 4.44588 6.50548 6.06746L6.3762 6.24266C6.2483 6.4161 6.12293 6.58609 6 6.75C5.96397 6.79804 5.92798 6.84581 5.892 6.89331C4.57348 5.29306 3.02637 4 0.5 4C0.223858 4 0 3.77614 0 3.5C0 3.22386 0.223858 3 0.5 3ZM8.87248 10.6107C8.37284 10.131 7.90897 9.55314 7.45767 8.95468C7.64688 8.71693 7.82704 8.48061 8 8.25L8.08987 8.12987C8.58412 8.79402 9.05288 9.39766 9.56502 9.88931C10.2889 10.5842 11.0463 11 12 11H12.7929L11.6464 9.85355C11.4512 9.65829 11.4512 9.34171 11.6464 9.14645C11.8417 8.95118 12.1583 8.95118 12.3536 9.14645L14.3536 11.1464C14.5488 11.3417 14.5488 11.6583 14.3536 11.8536L12.3536 13.8536C12.1583 14.0488 11.8417 14.0488 11.6464 13.8536C11.4512 13.6583 11.4512 13.3417 11.6464 13.1464L12.7929 12H12C10.7037 12 9.71111 11.4158 8.87248 10.6107Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3Y = [
    "color"
];
var $6431ef21eafb1f5a$export$9b9cddf895f6c38e = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3Y);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M11.5 3.04999C11.7485 3.04999 11.95 3.25146 11.95 3.49999V7.49999C11.95 7.74852 11.7485 7.94999 11.5 7.94999C11.2515 7.94999 11.05 7.74852 11.05 7.49999V4.58639L4.58638 11.05H7.49999C7.74852 11.05 7.94999 11.2515 7.94999 11.5C7.94999 11.7485 7.74852 11.95 7.49999 11.95L3.49999 11.95C3.38064 11.95 3.26618 11.9026 3.18179 11.8182C3.0974 11.7338 3.04999 11.6193 3.04999 11.5L3.04999 7.49999C3.04999 7.25146 3.25146 7.04999 3.49999 7.04999C3.74852 7.04999 3.94999 7.25146 3.94999 7.49999L3.94999 10.4136L10.4136 3.94999L7.49999 3.94999C7.25146 3.94999 7.04999 3.74852 7.04999 3.49999C7.04999 3.25146 7.25146 3.04999 7.49999 3.04999L11.5 3.04999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3Z = [
    "color"
];
var $6431ef21eafb1f5a$export$5881b38319b9ceb7 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3Z);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.53731 0.826873C7.5125 0.824392 7.4875 0.824392 7.46269 0.826873L3.96269 1.17687C3.85672 1.18747 3.76025 1.24262 3.69736 1.32857L0.699771 5.42528C0.654046 5.48627 0.62647 5.56165 0.625057 5.6434C0.625019 5.6456 0.625 5.64781 0.625 5.65001C0.625 5.65052 0.625001 5.65103 0.625003 5.65153C0.625363 5.74237 0.658021 5.82559 0.712087 5.8903L7.21042 13.7883C7.28165 13.8749 7.38789 13.925 7.5 13.925C7.61211 13.925 7.71835 13.8749 7.78958 13.7883L14.2879 5.89031C14.342 5.8256 14.3746 5.74237 14.375 5.65153C14.375 5.65103 14.375 5.65052 14.375 5.65001C14.375 5.64849 14.375 5.64697 14.375 5.64545C14.3749 5.63963 14.3747 5.63382 14.3744 5.62801C14.37 5.55219 14.3431 5.48242 14.3002 5.42527L11.3026 1.32857C11.2397 1.24262 11.1433 1.18747 11.0373 1.17687L7.53731 0.826873ZM10.925 5.27501V5.25236L10.9223 5.27501H10.925ZM10.9342 5.17498H13.1877L11.2495 2.5261L10.9342 5.17498ZM10.5707 1.88395L8.04432 1.63131L10.1747 5.21034L10.5707 1.88395ZM6.95568 1.63131L4.42931 1.88395L4.82531 5.21034L6.95568 1.63131ZM3.75046 2.5261L1.81226 5.17498H4.0658L3.75046 2.5261ZM1.79416 6.02501L6.75861 12.0587L4.22371 6.0669C4.21787 6.0531 4.21314 6.0391 4.20949 6.02501H1.79416ZM5.15055 6.02501L7.49999 12.1085L9.84943 6.02501H9.78681H5.21319H5.15055ZM10.7905 6.02501C10.7869 6.0391 10.7821 6.0531 10.7763 6.0669L8.24139 12.0587L13.2058 6.02501H10.7905ZM7.5 2.18317L9.34038 5.27501H5.65962L7.5 2.18317Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3_ = [
    "color"
];
var $6431ef21eafb1f5a$export$fab36db504d71648 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3_);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.10876 14L9.46582 1H10.8178L5.46074 14H4.10876Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$3$ = [
    "color"
];
var $6431ef21eafb1f5a$export$c1a54868c36d9c70 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$3$);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M10.3004 7.49991C10.3004 8.4943 9.49426 9.30041 8.49988 9.30041C7.50549 9.30041 6.69938 8.4943 6.69938 7.49991C6.69938 6.50553 7.50549 5.69942 8.49988 5.69942C9.49426 5.69942 10.3004 6.50553 10.3004 7.49991ZM11.205 8C10.9699 9.28029 9.84816 10.2504 8.49988 10.2504C7.1516 10.2504 6.0299 9.28029 5.79473 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H5.7947C6.0298 5.71962 7.15154 4.74942 8.49988 4.74942C9.84822 4.74942 10.97 5.71962 11.2051 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H11.205Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$40 = [
    "color"
];
var $6431ef21eafb1f5a$export$389ac29f15551cc = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$40);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M14.4999 0.999994C14.2237 0.999994 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L9.99992 5.99995C9.44764 5.99995 8.99993 6.44766 8.99993 6.99994L8.99993 7.99994C8.99993 8.55222 9.44764 8.99993 9.99992 8.99993L13.9999 8.99993L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999994 14.4999 0.999994ZM4.99996 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999994 0.499996 0.999994C0.223856 0.999994 -9.7852e-09 1.22385 -2.18557e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99993L4.99996 8.99993C5.55224 8.99993 5.99995 8.55222 5.99995 7.99993L5.99995 6.99994C5.99995 6.44766 5.55224 5.99995 4.99996 5.99995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$41 = [
    "color"
];
var $6431ef21eafb1f5a$export$d6c80469522241f6 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$41);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1L9 1V5C9 5.55228 8.55228 6 8 6H7C6.44772 6 6 5.55228 6 5V1H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM7 9C6.44772 9 6 9.44771 6 10V14H1.49988C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H9V10C9 9.44772 8.55228 9 8 9H7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$42 = [
    "color"
];
var $6431ef21eafb1f5a$export$d569b77eb092ec4 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$42);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M14.4999 0.999992C14.2237 0.999992 13.9999 1.22385 13.9999 1.49999L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999992 14.4999 0.999992ZM0.499996 0.999992C0.223856 0.999992 -9.78509e-09 1.22385 -2.18556e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 1.49999C0.999992 1.22385 0.776136 0.999992 0.499996 0.999992ZM1.99998 6.99994C1.99998 6.44766 2.44769 5.99995 2.99998 5.99995L5.99995 5.99995C6.55223 5.99995 6.99994 6.44766 6.99994 6.99994L6.99994 7.99993C6.99994 8.55221 6.55223 8.99992 5.99995 8.99992L2.99998 8.99992C2.4477 8.99992 1.99998 8.55221 1.99998 7.99993L1.99998 6.99994ZM8.99993 5.99995C8.44765 5.99995 7.99993 6.44766 7.99993 6.99994L7.99993 7.99993C7.99993 8.55221 8.44765 8.99992 8.99993 8.99992L11.9999 8.99992C12.5522 8.99992 12.9999 8.55221 12.9999 7.99993L12.9999 6.99994C12.9999 6.44766 12.5522 5.99995 11.9999 5.99995L8.99993 5.99995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$43 = [
    "color"
];
var $6431ef21eafb1f5a$export$7b2a11c2d6945102 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$43);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM7 2C6.44772 2 6 2.44772 6 3V6C6 6.55228 6.44772 7 7 7H8C8.55228 7 9 6.55228 9 6V3C9 2.44772 8.55228 2 8 2H7ZM7 8C6.44772 8 6 8.44771 6 9V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V9C9 8.44772 8.55228 8 8 8H7ZM1.49988 14C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H1.49988Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$44 = [
    "color"
];
var $6431ef21eafb1f5a$export$7fee6559072912ad = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$44);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.46968 1.05085C7.64122 1.13475 7.75 1.30904 7.75 1.5V13.5C7.75 13.691 7.64122 13.8653 7.46968 13.9492C7.29813 14.0331 7.09377 14.0119 6.94303 13.8947L3.2213 11H1.5C0.671571 11 0 10.3284 0 9.5V5.5C0 4.67158 0.671573 4 1.5 4H3.2213L6.94303 1.10533C7.09377 0.988085 7.29813 0.966945 7.46968 1.05085ZM6.75 2.52232L3.69983 4.89468C3.61206 4.96294 3.50405 5 3.39286 5H1.5C1.22386 5 1 5.22386 1 5.5V9.5C1 9.77615 1.22386 10 1.5 10H3.39286C3.50405 10 3.61206 10.0371 3.69983 10.1053L6.75 12.4777V2.52232ZM10.2784 3.84804C10.4623 3.72567 10.7106 3.77557 10.833 3.95949C12.2558 6.09798 12.2558 8.90199 10.833 11.0405C10.7106 11.2244 10.4623 11.2743 10.2784 11.1519C10.0944 11.0296 10.0445 10.7813 10.1669 10.5973C11.4111 8.72728 11.4111 6.27269 10.1669 4.40264C10.0445 4.21871 10.0944 3.97041 10.2784 3.84804ZM12.6785 1.43044C12.5356 1.2619 12.2832 1.24104 12.1147 1.38386C11.9462 1.52667 11.9253 1.77908 12.0681 1.94762C14.7773 5.14488 14.7773 9.85513 12.0681 13.0524C11.9253 13.2209 11.9462 13.4733 12.1147 13.6161C12.2832 13.759 12.5356 13.7381 12.6785 13.5696C15.6406 10.0739 15.6406 4.92612 12.6785 1.43044Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$45 = [
    "color"
];
var $6431ef21eafb1f5a$export$a45f43fe1bacf3af = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$45);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8 1.5C8 1.31062 7.893 1.13749 7.72361 1.05279C7.55421 0.968093 7.35151 0.986371 7.2 1.1L3.33333 4H1.5C0.671573 4 0 4.67158 0 5.5V9.5C0 10.3284 0.671573 11 1.5 11H3.33333L7.2 13.9C7.35151 14.0136 7.55421 14.0319 7.72361 13.9472C7.893 13.8625 8 13.6894 8 13.5V1.5ZM3.8 4.9L7 2.5V12.5L3.8 10.1C3.71345 10.0351 3.60819 10 3.5 10H1.5C1.22386 10 1 9.77614 1 9.5V5.5C1 5.22386 1.22386 5 1.5 5H3.5C3.60819 5 3.71345 4.96491 3.8 4.9ZM10.833 3.95949C10.7106 3.77557 10.4623 3.72567 10.2784 3.84804C10.0944 3.97041 10.0445 4.21871 10.1669 4.40264C11.4111 6.27268 11.4111 8.72728 10.1669 10.5973C10.0445 10.7813 10.0944 11.0296 10.2784 11.1519C10.4623 11.2743 10.7106 11.2244 10.833 11.0405C12.2558 8.90199 12.2558 6.09798 10.833 3.95949Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$46 = [
    "color"
];
var $6431ef21eafb1f5a$export$9ea4d02db3207a8b = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$46);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.72361 1.05279C7.893 1.13749 8 1.31062 8 1.5V13.5C8 13.6894 7.893 13.8625 7.72361 13.9472C7.55421 14.0319 7.35151 14.0136 7.2 13.9L3.33333 11H1.5C0.671573 11 0 10.3284 0 9.5V5.5C0 4.67158 0.671573 4 1.5 4H3.33333L7.2 1.1C7.35151 0.986371 7.55421 0.968093 7.72361 1.05279ZM7 2.5L3.8 4.9C3.71345 4.96491 3.60819 5 3.5 5H1.5C1.22386 5 1 5.22386 1 5.5V9.5C1 9.77614 1.22386 10 1.5 10H3.5C3.60819 10 3.71345 10.0351 3.8 10.1L7 12.5V2.5ZM14.8536 5.14645C15.0488 5.34171 15.0488 5.65829 14.8536 5.85355L13.2071 7.5L14.8536 9.14645C15.0488 9.34171 15.0488 9.65829 14.8536 9.85355C14.6583 10.0488 14.3417 10.0488 14.1464 9.85355L12.5 8.20711L10.8536 9.85355C10.6583 10.0488 10.3417 10.0488 10.1464 9.85355C9.95118 9.65829 9.95118 9.34171 10.1464 9.14645L11.7929 7.5L10.1464 5.85355C9.95118 5.65829 9.95118 5.34171 10.1464 5.14645C10.3417 4.95118 10.6583 4.95118 10.8536 5.14645L12.5 6.79289L14.1464 5.14645C14.3417 4.95118 14.6583 4.95118 14.8536 5.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$47 = [
    "color"
];
var $6431ef21eafb1f5a$export$c28fae3b5b7c9a0b = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$47);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8 1.5C8 1.31062 7.893 1.13749 7.72361 1.05279C7.55421 0.968093 7.35151 0.986371 7.2 1.1L3.33333 4H1.5C0.671573 4 0 4.67158 0 5.5V9.5C0 10.3284 0.671573 11 1.5 11H3.33333L7.2 13.9C7.35151 14.0136 7.55421 14.0319 7.72361 13.9472C7.893 13.8625 8 13.6894 8 13.5V1.5ZM3.8 4.9L7 2.5V12.5L3.8 10.1C3.71345 10.0351 3.60819 10 3.5 10H1.5C1.22386 10 1 9.77614 1 9.5V5.5C1 5.22386 1.22386 5 1.5 5H3.5C3.60819 5 3.71345 4.96491 3.8 4.9ZM10.083 5.05577C9.96066 4.87185 9.71235 4.82195 9.52843 4.94432C9.3445 5.06669 9.2946 5.31499 9.41697 5.49892C10.2207 6.70693 10.2207 8.29303 9.41697 9.50104C9.2946 9.68496 9.3445 9.93326 9.52843 10.0556C9.71235 10.178 9.96066 10.1281 10.083 9.94418C11.0653 8.46773 11.0653 6.53222 10.083 5.05577Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$48 = [
    "color"
];
var $6431ef21eafb1f5a$export$c19d0dc844f6640 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$48);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1 1H1.5H13.5H14V1.5V13.5V14H13.5H1.5H1V13.5V1.5V1ZM2 2V13H13V2H2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$49 = [
    "color"
];
var $6431ef21eafb1f5a$export$f95b8a41f9121b54 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$49);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.75432 1.81954C7.59742 1.72682 7.4025 1.72682 7.24559 1.81954L1.74559 5.06954C1.59336 5.15949 1.49996 5.32317 1.49996 5.5C1.49996 5.67683 1.59336 5.84051 1.74559 5.93046L7.24559 9.18046C7.4025 9.27318 7.59742 9.27318 7.75432 9.18046L13.2543 5.93046C13.4066 5.84051 13.5 5.67683 13.5 5.5C13.5 5.32317 13.4066 5.15949 13.2543 5.06954L7.75432 1.81954ZM7.49996 8.16923L2.9828 5.5L7.49996 2.83077L12.0171 5.5L7.49996 8.16923ZM2.25432 8.31954C2.01658 8.17906 1.70998 8.2579 1.56949 8.49564C1.42901 8.73337 1.50785 9.03998 1.74559 9.18046L7.24559 12.4305C7.4025 12.5232 7.59742 12.5232 7.75432 12.4305L13.2543 9.18046C13.4921 9.03998 13.5709 8.73337 13.4304 8.49564C13.2899 8.2579 12.9833 8.17906 12.7456 8.31954L7.49996 11.4192L2.25432 8.31954Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4a = [
    "color"
];
var $6431ef21eafb1f5a$export$2ee28caa7f1e962e = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4a);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M6.97942 1.25171L6.9585 1.30199L5.58662 4.60039C5.54342 4.70426 5.44573 4.77523 5.3336 4.78422L1.7727 5.0697L1.71841 5.07405L1.38687 5.10063L1.08608 5.12475C0.820085 5.14607 0.712228 5.47802 0.914889 5.65162L1.14406 5.84793L1.39666 6.06431L1.43802 6.09974L4.15105 8.42374C4.23648 8.49692 4.2738 8.61176 4.24769 8.72118L3.41882 12.196L3.40618 12.249L3.32901 12.5725L3.25899 12.866C3.19708 13.1256 3.47945 13.3308 3.70718 13.1917L3.9647 13.0344L4.24854 12.861L4.29502 12.8326L7.34365 10.9705C7.43965 10.9119 7.5604 10.9119 7.6564 10.9705L10.705 12.8326L10.7515 12.861L11.0354 13.0344L11.2929 13.1917C11.5206 13.3308 11.803 13.1256 11.7411 12.866L11.671 12.5725L11.5939 12.249L11.5812 12.196L10.7524 8.72118C10.7263 8.61176 10.7636 8.49692 10.849 8.42374L13.562 6.09974L13.6034 6.06431L13.856 5.84793L14.0852 5.65162C14.2878 5.47802 14.18 5.14607 13.914 5.12475L13.6132 5.10063L13.2816 5.07405L13.2274 5.0697L9.66645 4.78422C9.55432 4.77523 9.45663 4.70426 9.41343 4.60039L8.04155 1.30199L8.02064 1.25171L7.89291 0.944609L7.77702 0.665992C7.67454 0.419604 7.32551 0.419604 7.22303 0.665992L7.10715 0.944609L6.97942 1.25171ZM7.50003 2.60397L6.50994 4.98442C6.32273 5.43453 5.89944 5.74207 5.41351 5.78103L2.84361 5.98705L4.8016 7.66428C5.17183 7.98142 5.33351 8.47903 5.2204 8.95321L4.62221 11.461L6.8224 10.1171C7.23842 9.86302 7.76164 9.86302 8.17766 10.1171L10.3778 11.461L9.77965 8.95321C9.66654 8.47903 9.82822 7.98142 10.1984 7.66428L12.1564 5.98705L9.58654 5.78103C9.10061 5.74207 8.67732 5.43453 8.49011 4.98442L7.50003 2.60397Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4b = [
    "color"
];
var $6431ef21eafb1f5a$export$b9957ed2bd2cc18b = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4b);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4c = [
    "color"
];
var $6431ef21eafb1f5a$export$fa3807a0e988146 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4c);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.84998 7.49998C1.84998 7.21321 1.87134 6.93143 1.91256 6.65615L9.56374 2.23875C9.86311 2.35627 10.15 2.49861 10.4219 2.66322L3.77065 6.50332C3.73669 6.52183 3.70482 6.5449 3.67602 6.57238C3.5911 6.65308 3.54245 6.76286 3.53682 6.87658C3.53359 6.9418 3.54451 7.00831 3.57086 7.07137C3.58927 7.1157 3.6149 7.15742 3.64744 7.19458C3.67306 7.22396 3.702 7.24941 3.73337 7.27069L7.32533 9.83813L3.87232 11.8317C2.63604 10.7953 1.84998 9.23944 1.84998 7.49998ZM8.36843 10.2751C8.37682 10.2706 8.38509 10.2659 8.39322 10.2608L9.84091 9.42499C9.84706 9.42163 9.85314 9.41812 9.85915 9.41446L11.3101 8.57677C11.3655 8.54649 11.4154 8.504 11.4554 8.44995C11.6034 8.25031 11.5616 7.96848 11.362 7.82046L7.82779 5.20017L11.2161 3.24393C12.4013 4.27963 13.15 5.80237 13.15 7.49998C13.15 7.83546 13.1207 8.16411 13.0647 8.48353L5.56875 12.8113C5.26138 12.6995 4.96646 12.5618 4.68662 12.4008L8.36843 10.2751ZM8.18149 9.34383L4.81659 6.93868L5.50918 6.53881L8.80604 8.98324L8.18149 9.34383ZM6.35875 6.04832L6.97822 5.69067L10.2751 8.13506L9.6556 8.49275L6.35875 6.04832ZM8.3318 1.91078L2.24263 5.42636C3.06941 3.33188 5.11164 1.84998 7.49998 1.84998C7.78258 1.84998 8.06033 1.87072 8.3318 1.91078ZM6.84684 13.1126C7.06114 13.1373 7.27908 13.15 7.49998 13.15C9.8246 13.15 11.8213 11.7461 12.6886 9.7399L6.84684 13.1126ZM7.49998 0.849976C3.82728 0.849976 0.849976 3.82728 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4d = [
    "color"
];
var $6431ef21eafb1f5a$export$dc6949a98411e916 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4d);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2 3C2 2.44772 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44772 13 2 12.5523 2 12V3ZM12 3H3V12H12V3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4e = [
    "color"
];
var $6431ef21eafb1f5a$export$93c9322cdb01abe0 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4e);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L11.858 2.25806C12.1021 2.01398 12.4978 2.01398 12.7419 2.25806C12.986 2.50214 12.986 2.89786 12.7419 3.14194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13362 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.99998 4.5C7.99998 4.22386 7.77612 4 7.49998 4C7.22383 4 6.99998 4.22386 6.99998 4.5V9.5C6.99998 9.77614 7.22383 10 7.49998 10C7.77612 10 7.99998 9.77614 7.99998 9.5V4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4f = [
    "color"
];
var $6431ef21eafb1f5a$export$672f8b757251d92b = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4f);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M14.4999 0.999992C14.2237 0.999992 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999992 0.499996 0.999992C0.223856 0.999992 -9.78509e-09 1.22385 -2.18556e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99992L13.9999 8.99992L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999992 14.4999 0.999992Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4g = [
    "color"
];
var $6431ef21eafb1f5a$export$dd3bd56329b5fe85 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4g);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1H6H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM9 14V1L6 1V14H1.49988C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4h = [
    "color"
];
var $6431ef21eafb1f5a$export$25ec4ecc9c5701a5 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4h);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5.00003 3.25C5.00003 2.97386 4.77617 2.75 4.50003 2.75C4.22389 2.75 4.00003 2.97386 4.00003 3.25V7.10003H2.49998C2.27906 7.10003 2.09998 7.27912 2.09998 7.50003C2.09998 7.72094 2.27906 7.90003 2.49998 7.90003H4.00003V8.55C4.00003 10.483 5.56703 12.05 7.50003 12.05C9.43303 12.05 11 10.483 11 8.55V7.90003H12.5C12.7209 7.90003 12.9 7.72094 12.9 7.50003C12.9 7.27912 12.7209 7.10003 12.5 7.10003H11V3.25C11 2.97386 10.7762 2.75 10.5 2.75C10.2239 2.75 10 2.97386 10 3.25V7.10003H5.00003V3.25ZM5.00003 7.90003V8.55C5.00003 9.93071 6.11932 11.05 7.50003 11.05C8.88074 11.05 10 9.93071 10 8.55V7.90003H5.00003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4i = [
    "color"
];
var $6431ef21eafb1f5a$export$cd27c497b93dbe8d = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4i);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.5 0C7.77614 0 8 0.223858 8 0.5V2.5C8 2.77614 7.77614 3 7.5 3C7.22386 3 7 2.77614 7 2.5V0.5C7 0.223858 7.22386 0 7.5 0ZM2.1967 2.1967C2.39196 2.00144 2.70854 2.00144 2.90381 2.1967L4.31802 3.61091C4.51328 3.80617 4.51328 4.12276 4.31802 4.31802C4.12276 4.51328 3.80617 4.51328 3.61091 4.31802L2.1967 2.90381C2.00144 2.70854 2.00144 2.39196 2.1967 2.1967ZM0.5 7C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H2.5C2.77614 8 3 7.77614 3 7.5C3 7.22386 2.77614 7 2.5 7H0.5ZM2.1967 12.8033C2.00144 12.608 2.00144 12.2915 2.1967 12.0962L3.61091 10.682C3.80617 10.4867 4.12276 10.4867 4.31802 10.682C4.51328 10.8772 4.51328 11.1938 4.31802 11.3891L2.90381 12.8033C2.70854 12.9986 2.39196 12.9986 2.1967 12.8033ZM12.5 7C12.2239 7 12 7.22386 12 7.5C12 7.77614 12.2239 8 12.5 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12.5ZM10.682 4.31802C10.4867 4.12276 10.4867 3.80617 10.682 3.61091L12.0962 2.1967C12.2915 2.00144 12.608 2.00144 12.8033 2.1967C12.9986 2.39196 12.9986 2.70854 12.8033 2.90381L11.3891 4.31802C11.1938 4.51328 10.8772 4.51328 10.682 4.31802ZM8 12.5C8 12.2239 7.77614 12 7.5 12C7.22386 12 7 12.2239 7 12.5V14.5C7 14.7761 7.22386 15 7.5 15C7.77614 15 8 14.7761 8 14.5V12.5ZM10.682 10.682C10.8772 10.4867 11.1938 10.4867 11.3891 10.682L12.8033 12.0962C12.9986 12.2915 12.9986 12.608 12.8033 12.8033C12.608 12.9986 12.2915 12.9986 12.0962 12.8033L10.682 11.3891C10.4867 11.1938 10.4867 10.8772 10.682 10.682ZM5.5 7.5C5.5 6.39543 6.39543 5.5 7.5 5.5C8.60457 5.5 9.5 6.39543 9.5 7.5C9.5 8.60457 8.60457 9.5 7.5 9.5C6.39543 9.5 5.5 8.60457 5.5 7.5ZM7.5 4.5C5.84315 4.5 4.5 5.84315 4.5 7.5C4.5 9.15685 5.84315 10.5 7.5 10.5C9.15685 10.5 10.5 9.15685 10.5 7.5C10.5 5.84315 9.15685 4.5 7.5 4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4j = [
    "color"
];
var $6431ef21eafb1f5a$export$381bc0c1798a0082 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4j);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4ZM7.67133 11C6.65183 10.175 6 8.91363 6 7.5C6 6.08637 6.65183 4.82498 7.67133 4H4.5C2.567 4 1 5.567 1 7.5C1 9.433 2.567 11 4.5 11H7.67133ZM0 7.5C0 5.01472 2.01472 3 4.5 3H10.5C12.9853 3 15 5.01472 15 7.5C15 9.98528 12.9853 12 10.5 12H4.5C2.01472 12 0 9.98528 0 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4k = [
    "color"
];
var $6431ef21eafb1f5a$export$b6fcc44f764b8899 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4k);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4l = [
    "color"
];
var $6431ef21eafb1f5a$export$560b0277c649ed6b = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4l);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8 2H12.5C12.7761 2 13 2.22386 13 2.5V5H8V2ZM7 5V2H2.5C2.22386 2 2 2.22386 2 2.5V5H7ZM2 6V9H7V6H2ZM8 6H13V9H8V6ZM8 10H13V12.5C13 12.7761 12.7761 13 12.5 13H8V10ZM2 12.5V10H7V13H2.5C2.22386 13 2 12.7761 2 12.5ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4m = [
    "color"
];
var $6431ef21eafb1f5a$export$aea5b1a1d88a7a75 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4m);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.900024 7.50002C0.900024 3.85495 3.85495 0.900024 7.50002 0.900024C11.1451 0.900024 14.1 3.85495 14.1 7.50002C14.1 11.1451 11.1451 14.1 7.50002 14.1C3.85495 14.1 0.900024 11.1451 0.900024 7.50002ZM7.50002 1.80002C4.35201 1.80002 1.80002 4.35201 1.80002 7.50002C1.80002 10.648 4.35201 13.2 7.50002 13.2C10.648 13.2 13.2 10.648 13.2 7.50002C13.2 4.35201 10.648 1.80002 7.50002 1.80002ZM3.07504 7.50002C3.07504 5.05617 5.05618 3.07502 7.50004 3.07502C9.94388 3.07502 11.925 5.05617 11.925 7.50002C11.925 9.94386 9.94388 11.925 7.50004 11.925C5.05618 11.925 3.07504 9.94386 3.07504 7.50002ZM7.50004 3.92502C5.52562 3.92502 3.92504 5.52561 3.92504 7.50002C3.92504 9.47442 5.52563 11.075 7.50004 11.075C9.47444 11.075 11.075 9.47442 11.075 7.50002C11.075 5.52561 9.47444 3.92502 7.50004 3.92502ZM7.50004 5.25002C6.2574 5.25002 5.25004 6.25739 5.25004 7.50002C5.25004 8.74266 6.2574 9.75002 7.50004 9.75002C8.74267 9.75002 9.75004 8.74266 9.75004 7.50002C9.75004 6.25738 8.74267 5.25002 7.50004 5.25002ZM6.05004 7.50002C6.05004 6.69921 6.69923 6.05002 7.50004 6.05002C8.30084 6.05002 8.95004 6.69921 8.95004 7.50002C8.95004 8.30083 8.30084 8.95002 7.50004 8.95002C6.69923 8.95002 6.05004 8.30083 6.05004 7.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4n = [
    "color"
];
var $6431ef21eafb1f5a$export$4a7d2a945910cc57 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4n);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.94993 2.95002L3.94993 4.49998C3.94993 4.74851 3.74845 4.94998 3.49993 4.94998C3.2514 4.94998 3.04993 4.74851 3.04993 4.49998V2.50004C3.04993 2.45246 3.05731 2.40661 3.07099 2.36357C3.12878 2.18175 3.29897 2.05002 3.49993 2.05002H11.4999C11.6553 2.05002 11.7922 2.12872 11.8731 2.24842C11.9216 2.32024 11.9499 2.40682 11.9499 2.50002L11.9499 2.50004V4.49998C11.9499 4.74851 11.7485 4.94998 11.4999 4.94998C11.2514 4.94998 11.0499 4.74851 11.0499 4.49998V2.95002H8.04993V12.05H9.25428C9.50281 12.05 9.70428 12.2515 9.70428 12.5C9.70428 12.7486 9.50281 12.95 9.25428 12.95H5.75428C5.50575 12.95 5.30428 12.7486 5.30428 12.5C5.30428 12.2515 5.50575 12.05 5.75428 12.05H6.94993V2.95002H3.94993Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4o = [
    "color"
];
var $6431ef21eafb1f5a$export$934aaa521722e7a1 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4o);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.89949 5.50002C3.89949 5.27911 3.7204 5.10003 3.49949 5.10003C3.27857 5.10003 3.09949 5.27911 3.09949 5.50002L3.09949 12.5343L1.78233 11.2172C1.62612 11.061 1.37285 11.061 1.21664 11.2172C1.06043 11.3734 1.06043 11.6267 1.21664 11.7829L3.21664 13.7829C3.29166 13.8579 3.3934 13.9 3.49949 13.9C3.60557 13.9 3.70732 13.8579 3.78233 13.7829L5.78233 11.7829C5.93854 11.6267 5.93854 11.3734 5.78233 11.2172C5.62612 11.061 5.37285 11.061 5.21664 11.2172L3.89949 12.5343L3.89949 5.50002ZM8.49998 13C8.22383 13 7.99998 12.7762 7.99998 12.5C7.99998 12.2239 8.22383 12 8.49998 12H14.5C14.7761 12 15 12.2239 15 12.5C15 12.7762 14.7761 13 14.5 13H8.49998ZM8.49998 10C8.22383 10 7.99998 9.77617 7.99998 9.50002C7.99998 9.22388 8.22383 9.00002 8.49998 9.00002H14.5C14.7761 9.00002 15 9.22388 15 9.50002C15 9.77617 14.7761 10 14.5 10H8.49998ZM7.99998 6.50002C7.99998 6.77617 8.22383 7.00002 8.49998 7.00002H14.5C14.7761 7.00002 15 6.77617 15 6.50002C15 6.22388 14.7761 6.00002 14.5 6.00002H8.49998C8.22383 6.00002 7.99998 6.22388 7.99998 6.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4p = [
    "color"
];
var $6431ef21eafb1f5a$export$c0990f168a0bad08 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4p);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H10.5C10.7761 7 11 7.22386 11 7.5C11 7.77614 10.7761 8 10.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM3 10.5C3 10.2239 3.22386 10 3.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H3.5C3.22386 11 3 10.7761 3 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4q = [
    "color"
];
var $6431ef21eafb1f5a$export$8ea3580a4e458099 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4q);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2.5 4C2.22386 4 2 4.22386 2 4.5C2 4.77614 2.22386 5 2.5 5H12.5C12.7761 5 13 4.77614 13 4.5C13 4.22386 12.7761 4 12.5 4H2.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4r = [
    "color"
];
var $6431ef21eafb1f5a$export$e9337773b10190a1 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4r);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H7.5C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4s = [
    "color"
];
var $6431ef21eafb1f5a$export$79a9a721b029c6d9 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4s);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.49949 14.9C3.7204 14.9 3.89949 14.7209 3.89949 14.5L3.89949 10.4657L5.21664 11.7829C5.37285 11.9391 5.62612 11.9391 5.78233 11.7829C5.93854 11.6267 5.93854 11.3734 5.78233 11.2172L3.78233 9.21718C3.70732 9.14217 3.60557 9.10002 3.49949 9.10002C3.3934 9.10002 3.29166 9.14217 3.21664 9.21718L1.21664 11.2172C1.06043 11.3734 1.06043 11.6267 1.21664 11.7829C1.37285 11.9391 1.62612 11.9391 1.78233 11.7829L3.09949 10.4657L3.09949 14.5C3.09949 14.7209 3.27857 14.9 3.49949 14.9ZM7.99998 10.5C7.99998 10.7762 8.22383 11 8.49998 11H14.5C14.7761 11 15 10.7762 15 10.5C15 10.2239 14.7761 10 14.5 10H8.49998C8.22383 10 7.99998 10.2239 7.99998 10.5ZM7.99998 7.50002C7.99998 7.77617 8.22383 8.00002 8.49998 8.00002H14.5C14.7761 8.00002 15 7.77617 15 7.50002C15 7.22388 14.7761 7.00002 14.5 7.00002H8.49998C8.22383 7.00002 7.99998 7.22388 7.99998 7.50002ZM8.49998 5.00002C8.22383 5.00002 7.99998 4.77617 7.99998 4.50002C7.99998 4.22388 8.22383 4.00002 8.49998 4.00002H14.5C14.7761 4.00002 15 4.22388 15 4.50002C15 4.77617 14.7761 5.00002 14.5 5.00002H8.49998ZM3.89949 0.500025C3.89949 0.279111 3.7204 0.100025 3.49949 0.100025C3.27857 0.100025 3.09949 0.279111 3.09949 0.500025L3.09949 4.53434L1.78233 3.21718C1.62612 3.06097 1.37285 3.06097 1.21664 3.21718C1.06043 3.37339 1.06043 3.62666 1.21664 3.78287L3.21664 5.78287C3.29166 5.85788 3.3934 5.90002 3.49949 5.90002C3.60557 5.90002 3.70732 5.85788 3.78233 5.78287L5.78233 3.78287C5.93854 3.62666 5.93854 3.37339 5.78233 3.21718C5.62612 3.06097 5.37285 3.06097 5.21664 3.21718L3.89949 4.53434L3.89949 0.500025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4t = [
    "color"
];
var $6431ef21eafb1f5a$export$2b644951427679e4 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4t);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM7 7.5C7 7.22386 7.22386 7 7.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H7.5C7.22386 8 7 7.77614 7 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H4.5C4.22386 11 4 10.7761 4 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4u = [
    "color"
];
var $6431ef21eafb1f5a$export$65298c635b1d5567 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4u);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M3.89949 9.49998C3.89949 9.72089 3.7204 9.89997 3.49949 9.89997C3.27857 9.89997 3.09949 9.72089 3.09949 9.49998L3.09949 2.46566L1.78233 3.78282C1.62612 3.93903 1.37285 3.93903 1.21664 3.78282C1.06043 3.62661 1.06043 3.37334 1.21664 3.21713L3.21664 1.21713C3.29166 1.14212 3.3934 1.09998 3.49949 1.09998C3.60557 1.09998 3.70732 1.14212 3.78233 1.21713L5.78233 3.21713C5.93854 3.37334 5.93854 3.62661 5.78233 3.78282C5.62612 3.93903 5.37285 3.93903 5.21664 3.78282L3.89949 2.46566L3.89949 9.49998ZM8.49998 1.99998C8.22383 1.99998 7.99998 2.22383 7.99998 2.49998C7.99998 2.77612 8.22383 2.99998 8.49998 2.99998H14.5C14.7761 2.99998 15 2.77612 15 2.49998C15 2.22383 14.7761 1.99998 14.5 1.99998H8.49998ZM8.49998 4.99998C8.22383 4.99998 7.99998 5.22383 7.99998 5.49998C7.99998 5.77612 8.22383 5.99998 8.49998 5.99998H14.5C14.7761 5.99998 15 5.77612 15 5.49998C15 5.22383 14.7761 4.99998 14.5 4.99998H8.49998ZM7.99998 8.49998C7.99998 8.22383 8.22383 7.99998 8.49998 7.99998H14.5C14.7761 7.99998 15 8.22383 15 8.49998C15 8.77612 14.7761 8.99998 14.5 8.99998H8.49998C8.22383 8.99998 7.99998 8.77612 7.99998 8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4v = [
    "color"
];
var $6431ef21eafb1f5a$export$2407db3e81e79ec8 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4v);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L11.9291 2.36383C11.9159 2.32246 11.897 2.28368 11.8732 2.24845C11.7923 2.12875 11.6554 2.05005 11.5001 2.05005H3.50005C3.29909 2.05005 3.1289 2.18178 3.07111 2.3636C3.05743 2.40665 3.05005 2.45249 3.05005 2.50007V4.50001C3.05005 4.74854 3.25152 4.95001 3.50005 4.95001C3.74858 4.95001 3.95005 4.74854 3.95005 4.50001V2.95005H6.95006V7.34284L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L6.95006 8.75705V12.0501H5.7544C5.50587 12.0501 5.3044 12.2515 5.3044 12.5001C5.3044 12.7486 5.50587 12.9501 5.7544 12.9501H9.2544C9.50293 12.9501 9.7044 12.7486 9.7044 12.5001C9.7044 12.2515 9.50293 12.0501 9.2544 12.0501H8.05006V7.65705L13.3536 2.35355ZM8.05006 6.24284L11.0501 3.24283V2.95005H8.05006V6.24284Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4w = [
    "color"
];
var $6431ef21eafb1f5a$export$d02861c1158d3b3d = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4w);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5 3.5C5 3.22386 5.22386 3 5.5 3H9.5C9.77614 3 10 3.22386 10 3.5V6H12.5C12.6873 6 12.8589 6.10467 12.9446 6.27121C13.0303 6.43774 13.0157 6.63821 12.9069 6.79062L7.90687 13.7906C7.81301 13.922 7.66148 14 7.5 14C7.33853 14 7.18699 13.922 7.09314 13.7906L2.09314 6.79062C1.98427 6.63821 1.96972 6.43774 2.05542 6.27121C2.14112 6.10467 2.31271 6 2.5 6H5V3.5ZM6 4V6.5C6 6.77614 5.77614 7 5.5 7H3.4716L7.5 12.6398L11.5284 7H9.5C9.22386 7 9 6.77614 9 6.5V4H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4x = [
    "color"
];
var $6431ef21eafb1f5a$export$90890f1931da847b = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4x);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1 7.5C1 7.66148 1.07798 7.81301 1.20938 7.90687L8.20938 12.9069C8.36179 13.0157 8.56226 13.0303 8.72879 12.9446C8.89533 12.8589 9 12.6873 9 12.5L9 10L11.5 10C11.7761 10 12 9.77614 12 9.5L12 5.5C12 5.22386 11.7761 5 11.5 5L9 5L9 2.5C9 2.31271 8.89533 2.14112 8.72879 2.05542C8.56226 1.96972 8.36179 1.98427 8.20938 2.09313L1.20938 7.09314C1.07798 7.18699 1 7.33853 1 7.5ZM8 3.4716L8 5.5C8 5.77614 8.22386 6 8.5 6L11 6L11 9L8.5 9C8.22386 9 8 9.22386 8 9.5L8 11.5284L2.36023 7.5L8 3.4716Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4y = [
    "color"
];
var $6431ef21eafb1f5a$export$72a6223ceb8df5ef = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4y);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M14 7.5C14 7.66148 13.922 7.81301 13.7906 7.90687L6.79062 12.9069C6.63821 13.0157 6.43774 13.0303 6.27121 12.9446C6.10467 12.8589 6 12.6873 6 12.5L6 10L3.5 10C3.22386 10 3 9.77614 3 9.5L3 5.5C3 5.22386 3.22386 5 3.5 5L6 5L6 2.5C6 2.31271 6.10467 2.14112 6.27121 2.05542C6.43774 1.96972 6.63821 1.98427 6.79062 2.09313L13.7906 7.09314C13.922 7.18699 14 7.33853 14 7.5ZM7 3.4716L7 5.5C7 5.77614 6.77614 6 6.5 6L4 6L4 9L6.5 9C6.77614 9 7 9.22386 7 9.5L7 11.5284L12.6398 7.5L7 3.4716Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4z = [
    "color"
];
var $6431ef21eafb1f5a$export$edde007a504cdbfe = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4z);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.5 1C7.66148 1 7.81301 1.07798 7.90687 1.20938L12.9069 8.20938C13.0157 8.36179 13.0303 8.56226 12.9446 8.72879C12.8589 8.89533 12.6873 9 12.5 9H10V11.5C10 11.7761 9.77614 12 9.5 12H5.5C5.22386 12 5 11.7761 5 11.5V9H2.5C2.31271 9 2.14112 8.89533 2.05542 8.72879C1.96972 8.56226 1.98427 8.36179 2.09314 8.20938L7.09314 1.20938C7.18699 1.07798 7.33853 1 7.5 1ZM3.4716 8H5.5C5.77614 8 6 8.22386 6 8.5V11H9V8.5C9 8.22386 9.22386 8 9.5 8H11.5284L7.5 2.36023L3.4716 8Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4A = [
    "color"
];
var $6431ef21eafb1f5a$export$579848c7cccecf3f = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4A);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49998 0.849976C7.22383 0.849976 6.99998 1.07383 6.99998 1.34998V3.52234C6.99998 3.79848 7.22383 4.02234 7.49998 4.02234C7.77612 4.02234 7.99998 3.79848 7.99998 3.52234V1.8718C10.8862 2.12488 13.15 4.54806 13.15 7.49998C13.15 10.6204 10.6204 13.15 7.49998 13.15C4.37957 13.15 1.84998 10.6204 1.84998 7.49998C1.84998 6.10612 2.35407 4.83128 3.19049 3.8459C3.36919 3.63538 3.34339 3.31985 3.13286 3.14115C2.92234 2.96245 2.60681 2.98825 2.42811 3.19877C1.44405 4.35808 0.849976 5.86029 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976ZM6.74049 8.08072L4.22363 4.57237C4.15231 4.47295 4.16346 4.33652 4.24998 4.25C4.33649 4.16348 4.47293 4.15233 4.57234 4.22365L8.08069 6.74051C8.56227 7.08599 8.61906 7.78091 8.19998 8.2C7.78089 8.61909 7.08597 8.56229 6.74049 8.08072Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4B = [
    "color"
];
var $6431ef21eafb1f5a$export$872ef4fe88315cc3 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4B);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4C = [
    "color"
];
var $6431ef21eafb1f5a$export$df10b15f2353def5 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4C);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M13.0502 2.74989C13.0502 2.44613 12.804 2.19989 12.5002 2.19989C12.1965 2.19989 11.9502 2.44613 11.9502 2.74989V7.2825C11.9046 7.18802 11.8295 7.10851 11.7334 7.05776L2.73338 2.30776C2.5784 2.22596 2.3919 2.23127 2.24182 2.32176C2.09175 2.41225 2 2.57471 2 2.74995V12.25C2 12.4252 2.09175 12.5877 2.24182 12.6781C2.3919 12.7686 2.5784 12.7739 2.73338 12.6921L11.7334 7.94214C11.8295 7.89139 11.9046 7.81188 11.9502 7.7174V12.2499C11.9502 12.5536 12.1965 12.7999 12.5002 12.7999C12.804 12.7999 13.0502 12.5536 13.0502 12.2499V2.74989ZM3 11.4207V3.5792L10.4288 7.49995L3 11.4207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4D = [
    "color"
];
var $6431ef21eafb1f5a$export$6130ef86fd52e250 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4D);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.94976 2.74989C1.94976 2.44613 2.196 2.19989 2.49976 2.19989C2.80351 2.19989 3.04976 2.44613 3.04976 2.74989V7.2825C3.0954 7.18802 3.17046 7.10851 3.26662 7.05776L12.2666 2.30776C12.4216 2.22596 12.6081 2.23127 12.7582 2.32176C12.9083 2.41225 13 2.57471 13 2.74995V12.25C13 12.4252 12.9083 12.5877 12.7582 12.6781C12.6081 12.7686 12.4216 12.7739 12.2666 12.6921L3.26662 7.94214C3.17046 7.89139 3.0954 7.81188 3.04976 7.7174V12.2499C3.04976 12.5536 2.80351 12.7999 2.49976 12.7999C2.196 12.7999 1.94976 12.5536 1.94976 12.2499V2.74989ZM4.57122 7.49995L12 11.4207V3.5792L4.57122 7.49995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4E = [
    "color"
];
var $6431ef21eafb1f5a$export$ee1fdf1996836514 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4E);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4F = [
    "color"
];
var $6431ef21eafb1f5a$export$287e71cda35821ff = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4F);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        opacity: ".25",
        d: "M0 0H3V3H0V0ZM6 3H3V6H0V9H3V12H0V15H3V12H6V15H9V12H12V15H15V12H12V9H15V6H12V3H15V0H12V3H9V0H6V3ZM6 6V3H9V6H6ZM6 9H3V6H6V9ZM9 9V6H12V9H9ZM9 9H6V12H9V9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4G = [
    "color"
];
var $6431ef21eafb1f5a$export$d23329de703dffc4 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4G);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5.5 1C5.22386 1 5 1.22386 5 1.5C5 1.77614 5.22386 2 5.5 2H9.5C9.77614 2 10 1.77614 10 1.5C10 1.22386 9.77614 1 9.5 1H5.5ZM3 3.5C3 3.22386 3.22386 3 3.5 3H5H10H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H11V12C11 12.5523 10.5523 13 10 13H5C4.44772 13 4 12.5523 4 12V4L3.5 4C3.22386 4 3 3.77614 3 3.5ZM5 4H10V12H5V4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4H = [
    "color"
];
var $6431ef21eafb1f5a$export$b445c2dc6993f9f8 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4H);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4 6H11L7.5 10.5L4 6Z",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4I = [
    "color"
];
var $6431ef21eafb1f5a$export$62f44957433ecfbf = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4I);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M9 4L9 11L4.5 7.5L9 4Z",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4J = [
    "color"
];
var $6431ef21eafb1f5a$export$43e4d35e8a44b537 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4J);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M6 11L6 4L10.5 7.5L6 11Z",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4K = [
    "color"
];
var $6431ef21eafb1f5a$export$9ff28f4659896371 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4K);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4 9H11L7.5 4.5L4 9Z",
        fill: color
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4L = [
    "color"
];
var $6431ef21eafb1f5a$export$890946d7e35b6ab9 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4L);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.23336 4.69629C7.23336 2.96884 8.63335 1.56857 10.36 1.56857C11.3736 1.56857 12.183 2.04804 12.7254 2.74385C13.3079 2.62467 13.8557 2.40913 14.3513 2.11508C14.1559 2.72598 13.7424 3.2396 13.2033 3.56463C13.2038 3.56568 13.2042 3.56674 13.2047 3.56779C13.7334 3.50361 14.2364 3.36302 14.7048 3.15546L14.7037 3.15715C14.3667 3.66183 13.9431 4.10736 13.4561 4.47034C13.4823 4.64672 13.4956 4.82427 13.4956 5.00079C13.4956 8.6871 10.6873 12.9746 5.52122 12.9746C3.93906 12.9746 2.46544 12.511 1.22505 11.7152C0.992632 11.5661 0.925108 11.2568 1.07423 11.0244C1.0874 11.0038 1.10183 10.9846 1.11734 10.9666C1.20582 10.8202 1.37438 10.7309 1.5554 10.7522C2.47066 10.8601 3.38568 10.7485 4.19219 10.3962C3.39226 10.0434 2.77129 9.35975 2.50204 8.51974C2.45359 8.3686 2.48835 8.20311 2.59351 8.08422C2.59716 8.0801 2.60087 8.07606 2.60464 8.0721C1.96391 7.50819 1.55973 6.68208 1.55973 5.76143V5.72759C1.55973 5.56814 1.64411 5.42059 1.78155 5.33974C1.82671 5.31317 1.87537 5.29511 1.92532 5.28558C1.70549 4.86154 1.58116 4.37984 1.58116 3.86958C1.58116 3.40165 1.58384 2.81192 1.91332 2.28081C1.98718 2.16175 2.10758 2.08915 2.2364 2.07195C2.42588 2.01237 2.64087 2.06969 2.77406 2.23302C3.86536 3.57126 5.44066 4.49583 7.23366 4.73961L7.23336 4.69629ZM5.52122 11.9746C4.73387 11.9746 3.97781 11.8435 3.27248 11.6023C4.13012 11.4538 4.95307 11.1159 5.66218 10.5602C5.81211 10.4427 5.87182 10.2435 5.81126 10.0629C5.7507 9.88234 5.583 9.75943 5.39255 9.75607C4.68968 9.74366 4.06712 9.39716 3.67793 8.86845C3.86828 8.85306 4.05428 8.82039 4.23445 8.77167C4.43603 8.71716 4.57363 8.53114 4.56674 8.32243C4.55985 8.11372 4.41029 7.93718 4.20555 7.89607C3.42694 7.73977 2.79883 7.16764 2.56169 6.42174C2.76255 6.47025 2.97102 6.4991 3.18482 6.5061C3.38563 6.51267 3.56646 6.38533 3.62795 6.19405C3.68943 6.00277 3.61666 5.79391 3.44963 5.68224C2.86523 5.29155 2.48116 4.62464 2.48116 3.86958C2.48116 3.70213 2.48352 3.55268 2.49355 3.41719C3.85115 4.79913 5.70873 5.68931 7.77588 5.79338C7.93225 5.80126 8.08328 5.73543 8.18395 5.61553C8.28463 5.49562 8.32332 5.33548 8.28851 5.18284C8.25255 5.02517 8.23336 4.86284 8.23336 4.69629C8.23336 3.52085 9.18591 2.56857 10.36 2.56857C11.5943 2.56857 12.4956 3.71208 12.4956 5.00079C12.4956 8.25709 10.0202 11.9746 5.52122 11.9746Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4M = [
    "color"
];
var $6431ef21eafb1f5a$export$4ce1642bb7f15c79 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4M);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M5.00001 2.75C5.00001 2.47386 4.77615 2.25 4.50001 2.25C4.22387 2.25 4.00001 2.47386 4.00001 2.75V8.05C4.00001 9.983 5.56702 11.55 7.50001 11.55C9.43301 11.55 11 9.983 11 8.05V2.75C11 2.47386 10.7762 2.25 10.5 2.25C10.2239 2.25 10 2.47386 10 2.75V8.05C10 9.43071 8.88072 10.55 7.50001 10.55C6.1193 10.55 5.00001 9.43071 5.00001 8.05V2.75ZM3.49998 13.1001C3.27906 13.1001 3.09998 13.2791 3.09998 13.5001C3.09998 13.721 3.27906 13.9001 3.49998 13.9001H11.5C11.7209 13.9001 11.9 13.721 11.9 13.5001C11.9 13.2791 11.7209 13.1001 11.5 13.1001H3.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4N = [
    "color"
];
var $6431ef21eafb1f5a$export$35f5c3e250802cd1 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4N);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4O = [
    "color"
];
var $6431ef21eafb1f5a$export$8df90684a752ef81 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4O);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.81825 1.18188C7.64251 1.00615 7.35759 1.00615 7.18185 1.18188L4.18185 4.18188C4.00611 4.35762 4.00611 4.64254 4.18185 4.81828C4.35759 4.99401 4.64251 4.99401 4.81825 4.81828L7.05005 2.58648V9.49996C7.05005 9.74849 7.25152 9.94996 7.50005 9.94996C7.74858 9.94996 7.95005 9.74849 7.95005 9.49996V2.58648L10.1819 4.81828C10.3576 4.99401 10.6425 4.99401 10.8182 4.81828C10.994 4.64254 10.994 4.35762 10.8182 4.18188L7.81825 1.18188ZM2.5 9.99997C2.77614 9.99997 3 10.2238 3 10.5V12C3 12.5538 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2238 12.2239 9.99997 12.5 9.99997C12.7761 9.99997 13 10.2238 13 10.5V12C13 13.104 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2238 2.22386 9.99997 2.5 9.99997Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4P = [
    "color"
];
var $6431ef21eafb1f5a$export$6e6352268496f418 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4P);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4Q = [
    "color"
];
var $6431ef21eafb1f5a$export$aff958e91ee0391a = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4Q);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 9.1488 1.47963 10.657 2.47665 11.8162L1.64643 12.6464C1.45117 12.8417 1.45117 13.1583 1.64643 13.3535C1.8417 13.5488 2.15828 13.5488 2.35354 13.3535L3.18377 12.5233C4.34296 13.5202 5.85104 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34299 12.5233 3.1838L13.3535 2.35354C13.5488 2.15827 13.5488 1.84169 13.3535 1.64643C13.1583 1.45117 12.8417 1.45117 12.6464 1.64643L11.8162 2.47668C10.657 1.47966 9.14877 0.877045 7.49985 0.877045ZM11.1422 3.15066C10.1567 2.32449 8.88639 1.82704 7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.88642 2.32446 10.1568 3.15063 11.1422L11.1422 3.15066ZM3.85776 11.8493C4.84317 12.6753 6.11343 13.1727 7.49985 13.1727C10.6328 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11346 12.6753 4.8432 11.8493 3.85779L3.85776 11.8493Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4R = [
    "color"
];
var $6431ef21eafb1f5a$export$18bf59af111847c = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4R);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7.49998 1L6.92321 2.00307L1.17498 12L0.599976 13H1.7535H13.2464H14.4L13.825 12L8.07674 2.00307L7.49998 1ZM7.49998 3.00613L2.3285 12H12.6714L7.49998 3.00613Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4S = [
    "color"
];
var $6431ef21eafb1f5a$export$4ec8735ec23c8112 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4S);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.76447 3.12199C5.63151 3.04859 6.56082 3 7.5 3C8.43918 3 9.36849 3.04859 10.2355 3.12199C11.2796 3.21037 11.9553 3.27008 12.472 3.39203C12.9425 3.50304 13.2048 3.64976 13.4306 3.88086C13.4553 3.90618 13.4902 3.94414 13.5133 3.97092C13.7126 4.20149 13.8435 4.4887 13.918 5.03283C13.9978 5.6156 14 6.37644 14 7.52493C14 8.66026 13.9978 9.41019 13.9181 9.98538C13.8439 10.5206 13.7137 10.8061 13.5125 11.0387C13.4896 11.0651 13.4541 11.1038 13.4296 11.1287C13.2009 11.3625 12.9406 11.5076 12.4818 11.6164C11.9752 11.7365 11.3143 11.7942 10.2878 11.8797C9.41948 11.9521 8.47566 12 7.5 12C6.52434 12 5.58052 11.9521 4.7122 11.8797C3.68572 11.7942 3.02477 11.7365 2.51816 11.6164C2.05936 11.5076 1.7991 11.3625 1.57037 11.1287C1.54593 11.1038 1.51035 11.0651 1.48748 11.0387C1.28628 10.8061 1.15612 10.5206 1.08193 9.98538C1.00221 9.41019 1 8.66026 1 7.52493C1 6.37644 1.00216 5.6156 1.082 5.03283C1.15654 4.4887 1.28744 4.20149 1.48666 3.97092C1.5098 3.94414 1.54468 3.90618 1.56942 3.88086C1.7952 3.64976 2.05752 3.50304 2.52796 3.39203C3.04473 3.27008 3.7204 3.21037 4.76447 3.12199ZM0 7.52493C0 5.28296 0 4.16198 0.729985 3.31713C0.766457 3.27491 0.815139 3.22194 0.854123 3.18204C1.63439 2.38339 2.64963 2.29744 4.68012 2.12555C5.56923 2.05028 6.52724 2 7.5 2C8.47276 2 9.43077 2.05028 10.3199 2.12555C12.3504 2.29744 13.3656 2.38339 14.1459 3.18204C14.1849 3.22194 14.2335 3.27491 14.27 3.31713C15 4.16198 15 5.28296 15 7.52493C15 9.74012 15 10.8477 14.2688 11.6929C14.2326 11.7348 14.1832 11.7885 14.1444 11.8281C13.3629 12.6269 12.3655 12.71 10.3709 12.8763C9.47971 12.9505 8.50782 13 7.5 13C6.49218 13 5.52028 12.9505 4.62915 12.8763C2.63446 12.71 1.63712 12.6269 0.855558 11.8281C0.816844 11.7885 0.767442 11.7348 0.731221 11.6929C0 10.8477 0 9.74012 0 7.52493ZM5.25 5.38264C5.25 5.20225 5.43522 5.08124 5.60041 5.15369L10.428 7.27105C10.6274 7.35853 10.6274 7.64147 10.428 7.72895L5.60041 9.84631C5.43522 9.91876 5.25 9.79775 5.25 9.61736V5.38264Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4T = [
    "color"
];
var $6431ef21eafb1f5a$export$6262053f5289408a = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4T);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M7 2H1.5C1.22386 2 1 2.22386 1 2.5V7H7V2ZM8 2V7H14V2.5C14 2.22386 13.7761 2 13.5 2H8ZM7 8H1V12.5C1 12.7761 1.22386 13 1.5 13H7V8ZM8 13V8H14V12.5C14 12.7761 13.7761 13 13.5 13H8ZM1.5 1C0.671573 1 0 1.67157 0 2.5V12.5C0 13.3284 0.671573 14 1.5 14H13.5C14.3284 14 15 13.3284 15 12.5V2.5C15 1.67157 14.3284 1 13.5 1H1.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4U = [
    "color"
];
var $6431ef21eafb1f5a$export$832ec864fd299632 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4U);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M1.5 2H13.5C13.7761 2 14 2.22386 14 2.5V7H1V2.5C1 2.22386 1.22386 2 1.5 2ZM1 8V12.5C1 12.7761 1.22386 13 1.5 13H13.5C13.7761 13 14 12.7761 14 12.5V8H1ZM0 2.5C0 1.67157 0.671573 1 1.5 1H13.5C14.3284 1 15 1.67157 15 2.5V12.5C15 13.3284 14.3284 14 13.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4V = [
    "color"
];
var $6431ef21eafb1f5a$export$c65e16705969a7a8 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4V);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M14 2.58711L1.85163 13H13.5C13.7761 13 14 12.7761 14 12.5V2.58711ZM0.762879 13.8067L0.825396 13.8796L0.854717 13.8545C1.05017 13.9478 1.26899 14 1.5 14H13.5C14.3284 14 15 13.3284 15 12.5V2.5C15 1.93949 14.6926 1.45078 14.2371 1.19331L14.1746 1.12037L14.1453 1.1455C13.9498 1.05222 13.731 1 13.5 1H1.5C0.671573 1 0 1.67157 0 2.5V12.5C0 13.0605 0.307435 13.5492 0.762879 13.8067ZM1 12.4129L13.1484 2H1.5C1.22386 2 1 2.22386 1 2.5V12.4129Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4W = [
    "color"
];
var $6431ef21eafb1f5a$export$96186050b98a4434 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4W);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M8 2H13.5C13.7761 2 14 2.22386 14 2.5V12.5C14 12.7761 13.7761 13 13.5 13H8V2ZM7 2H1.5C1.22386 2 1 2.22386 1 2.5V12.5C1 12.7761 1.22386 13 1.5 13H7V2ZM0 2.5C0 1.67157 0.671573 1 1.5 1H13.5C14.3284 1 15 1.67157 15 2.5V12.5C15 13.3284 14.3284 14 13.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4X = [
    "color"
];
var $6431ef21eafb1f5a$export$815859cc984b9edf = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4X);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M4.81812 4.68161C4.99386 4.85734 4.99386 5.14227 4.81812 5.318L3.08632 7.0498H11.9135L10.1817 5.318C10.006 5.14227 10.006 4.85734 10.1817 4.68161C10.3575 4.50587 10.6424 4.50587 10.8181 4.68161L13.3181 7.18161C13.4939 7.35734 13.4939 7.64227 13.3181 7.818L10.8181 10.318C10.6424 10.4937 10.3575 10.4937 10.1817 10.318C10.006 10.1423 10.006 9.85734 10.1817 9.68161L11.9135 7.9498H3.08632L4.81812 9.68161C4.99386 9.85734 4.99386 10.1423 4.81812 10.318C4.64239 10.4937 4.35746 10.4937 4.18173 10.318L1.68173 7.818C1.50599 7.64227 1.50599 7.35734 1.68173 7.18161L4.18173 4.68161C4.35746 4.50587 4.64239 4.50587 4.81812 4.68161Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4Y = [
    "color"
];
var $6431ef21eafb1f5a$export$418cedbcfc990387 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4Y);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159ZM4.25 6.5C4.25 6.22386 4.47386 6 4.75 6H6V4.75C6 4.47386 6.22386 4.25 6.5 4.25C6.77614 4.25 7 4.47386 7 4.75V6H8.25C8.52614 6 8.75 6.22386 8.75 6.5C8.75 6.77614 8.52614 7 8.25 7H7V8.25C7 8.52614 6.77614 8.75 6.5 8.75C6.22386 8.75 6 8.52614 6 8.25V7H4.75C4.47386 7 4.25 6.77614 4.25 6.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $6431ef21eafb1f5a$var$_excluded$4Z = [
    "color"
];
var $6431ef21eafb1f5a$export$fbd55a4c69e8e024 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $6431ef21eafb1f5a$var$_objectWithoutPropertiesLoose(_ref, $6431ef21eafb1f5a$var$_excluded$4Z);
    return (0, $4DE7A.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $4DE7A.createElement)("path", {
        d: "M6.5 10C8.433 10 10 8.433 10 6.5C10 4.567 8.433 3 6.5 3C4.567 3 3 4.567 3 6.5C3 8.433 4.567 10 6.5 10ZM6.5 11C7.56251 11 8.53901 10.6318 9.30884 10.0159L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L10.0159 9.30884C10.6318 8.53901 11 7.56251 11 6.5C11 4.01472 8.98528 2 6.5 2C4.01472 2 2 4.01472 2 6.5C2 8.98528 4.01472 11 6.5 11ZM4.75 6C4.47386 6 4.25 6.22386 4.25 6.5C4.25 6.77614 4.47386 7 4.75 7H8.25C8.52614 7 8.75 6.77614 8.75 6.5C8.75 6.22386 8.52614 6 8.25 6H4.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});



parcelRequire("4DE7A");

function $991e122153555cbd$var$ExternalLink({ children: children, href: href, ...restProps }) {
    const offline = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.system.offline);
    if (offline) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6dd45a7735069a79$exports.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        ...restProps,
        children: children
    });
}
var $991e122153555cbd$export$2e2bcd8739ae039 = $991e122153555cbd$var$ExternalLink;


/**
 * This component is a wrapper around tippyjs/react to provide
 * functionality common to Streetmix's implementation of it
 */ 
parcelRequire("4DE7A");
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $0a5b8b36fc539d8e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $b172a2c2fd556441$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $ee60bde14c6c67a8$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $b172a2c2fd556441$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $ee60bde14c6c67a8$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $b172a2c2fd556441$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $ee60bde14c6c67a8$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $b172a2c2fd556441$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $104603abb3b49066$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $ee60bde14c6c67a8$export$1b3bfaa9684536aa)(element) || !(0, $0a5b8b36fc539d8e$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $104603abb3b49066$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $ee60bde14c6c67a8$export$1b3bfaa9684536aa)(element) || !(0, $0a5b8b36fc539d8e$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $104603abb3b49066$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $104603abb3b49066$var$applyStyles,
    effect: $104603abb3b49066$var$effect,
    requires: [
        "computeStyles"
    ]
};


var $cf7a85d1080d7e7a$export$8960430cfd85939f = Math.max;
var $cf7a85d1080d7e7a$export$96ec731ed4dcb222 = Math.min;
var $cf7a85d1080d7e7a$export$2077e0241d6afd3c = Math.round;



function $f1e97ca3d70bb7f6$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $43d9a55b3068afdc$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $f1e97ca3d70bb7f6$export$2e2bcd8739ae039)());
}


function $a2c1a88a5a7b8c84$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $ee60bde14c6c67a8$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cf7a85d1080d7e7a$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cf7a85d1080d7e7a$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $ee60bde14c6c67a8$export$45a5e7f76e0caa8d)(element) ? (0, $b172a2c2fd556441$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $43d9a55b3068afdc$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $dd9ae6c568dbba0c$export$2e2bcd8739ae039(node) {
    var win = (0, $b172a2c2fd556441$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $a24de3fbd6179f55$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $4decb991eaed5d72$export$2e2bcd8739ae039(node) {
    if (node === (0, $b172a2c2fd556441$export$2e2bcd8739ae039)(node) || !(0, $ee60bde14c6c67a8$export$1b3bfaa9684536aa)(node)) return (0, $dd9ae6c568dbba0c$export$2e2bcd8739ae039)(node);
    else return (0, $a24de3fbd6179f55$export$2e2bcd8739ae039)(node);
}






function $86f9ed043a0d2403$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $ee60bde14c6c67a8$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $13f86a49646c2409$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $a2c1a88a5a7b8c84$export$2e2bcd8739ae039)((0, $86f9ed043a0d2403$export$2e2bcd8739ae039)(element)).left + (0, $dd9ae6c568dbba0c$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $21e2a09618359d6a$export$2e2bcd8739ae039(element) {
    return (0, $b172a2c2fd556441$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $2682bda60d5090fa$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $21e2a09618359d6a$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $5686366214aecee4$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cf7a85d1080d7e7a$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cf7a85d1080d7e7a$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $5686366214aecee4$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $ee60bde14c6c67a8$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $ee60bde14c6c67a8$export$1b3bfaa9684536aa)(offsetParent) && $5686366214aecee4$var$isElementScaled(offsetParent);
    var documentElement = (0, $86f9ed043a0d2403$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $a2c1a88a5a7b8c84$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $0a5b8b36fc539d8e$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $2682bda60d5090fa$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $4decb991eaed5d72$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $ee60bde14c6c67a8$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $a2c1a88a5a7b8c84$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $13f86a49646c2409$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $7b66e96457cd106c$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $a2c1a88a5a7b8c84$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $e6d9bd8b66c413c2$export$2e2bcd8739ae039(element) {
    if ((0, $0a5b8b36fc539d8e$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $ee60bde14c6c67a8$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $86f9ed043a0d2403$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $22c046d01a3689c1$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $0a5b8b36fc539d8e$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $ee60bde14c6c67a8$export$1b3bfaa9684536aa)(node) && (0, $2682bda60d5090fa$export$2e2bcd8739ae039)(node)) return node;
    return $22c046d01a3689c1$export$2e2bcd8739ae039((0, $e6d9bd8b66c413c2$export$2e2bcd8739ae039)(node));
}





function $4d3e4a3f9615df88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $22c046d01a3689c1$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $b172a2c2fd556441$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $2682bda60d5090fa$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($4d3e4a3f9615df88$export$2e2bcd8739ae039((0, $e6d9bd8b66c413c2$export$2e2bcd8739ae039)(target)));
}







function $1e27bf3a806fe6af$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $0a5b8b36fc539d8e$export$2e2bcd8739ae039)(element)) >= 0;
}




function $5596b98d0ad06df3$var$getTrueOffsetParent(element) {
    if (!(0, $ee60bde14c6c67a8$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $21e2a09618359d6a$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $5596b98d0ad06df3$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $f1e97ca3d70bb7f6$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $f1e97ca3d70bb7f6$export$2e2bcd8739ae039)());
    if (isIE && (0, $ee60bde14c6c67a8$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $21e2a09618359d6a$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $e6d9bd8b66c413c2$export$2e2bcd8739ae039)(element);
    if ((0, $ee60bde14c6c67a8$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $ee60bde14c6c67a8$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $0a5b8b36fc539d8e$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $21e2a09618359d6a$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $5596b98d0ad06df3$export$2e2bcd8739ae039(element) {
    var window = (0, $b172a2c2fd556441$export$2e2bcd8739ae039)(element);
    var offsetParent = $5596b98d0ad06df3$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $1e27bf3a806fe6af$export$2e2bcd8739ae039)(offsetParent) && (0, $21e2a09618359d6a$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $5596b98d0ad06df3$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $0a5b8b36fc539d8e$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $0a5b8b36fc539d8e$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $21e2a09618359d6a$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $5596b98d0ad06df3$var$getContainingBlock(element) || window;
}


var $8cbe5d6d70d17cc8$export$1e95b668f3b82d = "top";
var $8cbe5d6d70d17cc8$export$40e543e69a8b3fbb = "bottom";
var $8cbe5d6d70d17cc8$export$79ffe56a765070d2 = "right";
var $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4 = "left";
var $8cbe5d6d70d17cc8$export$dfb5619354ba860 = "auto";
var $8cbe5d6d70d17cc8$export$aec2ce47c367b8c3 = [
    $8cbe5d6d70d17cc8$export$1e95b668f3b82d,
    $8cbe5d6d70d17cc8$export$40e543e69a8b3fbb,
    $8cbe5d6d70d17cc8$export$79ffe56a765070d2,
    $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4
];
var $8cbe5d6d70d17cc8$export$b3571188c770cc5a = "start";
var $8cbe5d6d70d17cc8$export$bd5df0f255a350f8 = "end";
var $8cbe5d6d70d17cc8$export$390fd549c5303b4d = "clippingParents";
var $8cbe5d6d70d17cc8$export$d7b7311ec04a3e8f = "viewport";
var $8cbe5d6d70d17cc8$export$ae5ab1c730825774 = "popper";
var $8cbe5d6d70d17cc8$export$ca50aac9f3ba507f = "reference";
var $8cbe5d6d70d17cc8$export$368f9a87e87fa4e1 = /*#__PURE__*/ $8cbe5d6d70d17cc8$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $8cbe5d6d70d17cc8$export$b3571188c770cc5a,
        placement + "-" + $8cbe5d6d70d17cc8$export$bd5df0f255a350f8
    ]);
}, []);
var $8cbe5d6d70d17cc8$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($8cbe5d6d70d17cc8$export$aec2ce47c367b8c3, [
    $8cbe5d6d70d17cc8$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $8cbe5d6d70d17cc8$export$b3571188c770cc5a,
        placement + "-" + $8cbe5d6d70d17cc8$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $8cbe5d6d70d17cc8$export$421679a7c3d56e = "beforeRead";
var $8cbe5d6d70d17cc8$export$aafa59e2e03f2942 = "read";
var $8cbe5d6d70d17cc8$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $8cbe5d6d70d17cc8$export$c65e99957a05207c = "beforeMain";
var $8cbe5d6d70d17cc8$export$f22da7240b7add18 = "main";
var $8cbe5d6d70d17cc8$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $8cbe5d6d70d17cc8$export$8d4d2d70e7d46032 = "beforeWrite";
var $8cbe5d6d70d17cc8$export$68d8715fc104d294 = "write";
var $8cbe5d6d70d17cc8$export$70a6e5159acce2e6 = "afterWrite";
var $8cbe5d6d70d17cc8$export$d087d3878fdf71d5 = [
    $8cbe5d6d70d17cc8$export$421679a7c3d56e,
    $8cbe5d6d70d17cc8$export$aafa59e2e03f2942,
    $8cbe5d6d70d17cc8$export$6964f6c886723980,
    $8cbe5d6d70d17cc8$export$c65e99957a05207c,
    $8cbe5d6d70d17cc8$export$f22da7240b7add18,
    $8cbe5d6d70d17cc8$export$bab79516f2d662fe,
    $8cbe5d6d70d17cc8$export$8d4d2d70e7d46032,
    $8cbe5d6d70d17cc8$export$68d8715fc104d294,
    $8cbe5d6d70d17cc8$export$70a6e5159acce2e6
];


function $a6bc42e94e56ccdd$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $a6bc42e94e56ccdd$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $a6bc42e94e56ccdd$var$order(modifiers); // order based on phase
    return (0, $8cbe5d6d70d17cc8$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $5d5f523e51e9a0bb$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $9ef0b996229eac83$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $6c452e1842c49173$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $6c452e1842c49173$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $6c452e1842c49173$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $6c452e1842c49173$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $6c452e1842c49173$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $ee60bde14c6c67a8$export$45a5e7f76e0caa8d)(reference) ? (0, $4d3e4a3f9615df88$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $4d3e4a3f9615df88$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $4d3e4a3f9615df88$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $a6bc42e94e56ccdd$export$2e2bcd8739ae039)((0, $9ef0b996229eac83$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$6c452e1842c49173$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $5686366214aecee4$export$2e2bcd8739ae039)(reference, (0, $5596b98d0ad06df3$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $7b66e96457cd106c$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $5d5f523e51e9a0bb$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$6c452e1842c49173$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $6c452e1842c49173$export$8f7491d57c8f97a9 = /*#__PURE__*/ $6c452e1842c49173$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $01c194d6979e6fcc$var$passive = {
    passive: true
};
function $01c194d6979e6fcc$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $b172a2c2fd556441$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $01c194d6979e6fcc$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $01c194d6979e6fcc$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $01c194d6979e6fcc$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $01c194d6979e6fcc$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $01c194d6979e6fcc$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $01c194d6979e6fcc$var$effect,
    data: {}
};



function $2118f8638890d4e0$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $bca014efc47bfdd5$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $cfc4af360d6c3fb5$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $5cfb1826154e8dad$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $2118f8638890d4e0$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $bca014efc47bfdd5$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $8cbe5d6d70d17cc8$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $8cbe5d6d70d17cc8$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $8cbe5d6d70d17cc8$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $cfc4af360d6c3fb5$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $8cbe5d6d70d17cc8$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $8cbe5d6d70d17cc8$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $6072185af73edef1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $5cfb1826154e8dad$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6072185af73edef1$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $6072185af73edef1$var$popperOffsets,
    data: {}
};










var $908527c93f1ca2bb$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $908527c93f1ca2bb$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cf7a85d1080d7e7a$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $cf7a85d1080d7e7a$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $908527c93f1ca2bb$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4);
    var sideY = (0, $8cbe5d6d70d17cc8$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5596b98d0ad06df3$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $b172a2c2fd556441$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $86f9ed043a0d2403$export$2e2bcd8739ae039)(popper);
            if ((0, $21e2a09618359d6a$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $8cbe5d6d70d17cc8$export$1e95b668f3b82d) || (placement === (0, $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4) || placement === (0, $8cbe5d6d70d17cc8$export$79ffe56a765070d2)) && variation === (0, $8cbe5d6d70d17cc8$export$bd5df0f255a350f8)) {
            sideY = (0, $8cbe5d6d70d17cc8$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4) || (placement === (0, $8cbe5d6d70d17cc8$export$1e95b668f3b82d) || placement === (0, $8cbe5d6d70d17cc8$export$40e543e69a8b3fbb)) && variation === (0, $8cbe5d6d70d17cc8$export$bd5df0f255a350f8)) {
            sideX = (0, $8cbe5d6d70d17cc8$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $908527c93f1ca2bb$var$unsetSides);
    var _ref4 = roundOffsets === true ? $908527c93f1ca2bb$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $b172a2c2fd556441$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $908527c93f1ca2bb$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $2118f8638890d4e0$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $bca014efc47bfdd5$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $908527c93f1ca2bb$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $908527c93f1ca2bb$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $908527c93f1ca2bb$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $908527c93f1ca2bb$var$computeStyles,
    data: {}
};





function $d58e5171c05f5749$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $2118f8638890d4e0$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4),
        (0, $8cbe5d6d70d17cc8$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4),
        (0, $8cbe5d6d70d17cc8$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $d58e5171c05f5749$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $8cbe5d6d70d17cc8$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $d58e5171c05f5749$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $d58e5171c05f5749$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $d58e5171c05f5749$var$offset
};


var $109e5ff398e5937c$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $109e5ff398e5937c$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $109e5ff398e5937c$var$hash[matched];
    });
}



var $d0dd965d16573616$var$hash = {
    start: "end",
    end: "start"
};
function $d0dd965d16573616$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $d0dd965d16573616$var$hash[matched];
    });
}







function $97eecd6dbfeb29fe$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $b172a2c2fd556441$export$2e2bcd8739ae039)(element);
    var html = (0, $86f9ed043a0d2403$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $43d9a55b3068afdc$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $13f86a49646c2409$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $6219c2b5cc778e72$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $86f9ed043a0d2403$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $dd9ae6c568dbba0c$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cf7a85d1080d7e7a$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cf7a85d1080d7e7a$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $13f86a49646c2409$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $21e2a09618359d6a$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $cf7a85d1080d7e7a$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $3a77c93c318b8b2a$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $ee60bde14c6c67a8$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $44579816b69effdf$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $c3d2fd3d16fb2860$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $a2c1a88a5a7b8c84$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $c3d2fd3d16fb2860$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $8cbe5d6d70d17cc8$export$d7b7311ec04a3e8f) ? (0, $44579816b69effdf$export$2e2bcd8739ae039)((0, $97eecd6dbfeb29fe$export$2e2bcd8739ae039)(element, strategy)) : (0, $ee60bde14c6c67a8$export$45a5e7f76e0caa8d)(clippingParent) ? $c3d2fd3d16fb2860$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $44579816b69effdf$export$2e2bcd8739ae039)((0, $6219c2b5cc778e72$export$2e2bcd8739ae039)((0, $86f9ed043a0d2403$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $c3d2fd3d16fb2860$var$getClippingParents(element) {
    var clippingParents = (0, $4d3e4a3f9615df88$export$2e2bcd8739ae039)((0, $e6d9bd8b66c413c2$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $21e2a09618359d6a$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $ee60bde14c6c67a8$export$1b3bfaa9684536aa)(element) ? (0, $5596b98d0ad06df3$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $ee60bde14c6c67a8$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $ee60bde14c6c67a8$export$45a5e7f76e0caa8d)(clippingParent) && (0, $3a77c93c318b8b2a$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $0a5b8b36fc539d8e$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $c3d2fd3d16fb2860$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $c3d2fd3d16fb2860$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $c3d2fd3d16fb2860$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cf7a85d1080d7e7a$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $cf7a85d1080d7e7a$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $cf7a85d1080d7e7a$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cf7a85d1080d7e7a$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $c3d2fd3d16fb2860$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5460abfdfdb3dc2c$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $d3c67f2935dd1388$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5460abfdfdb3dc2c$export$2e2bcd8739ae039)(), paddingObject);
}


function $823e0a2db8a0144b$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $b3bf44aa17fce063$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $8cbe5d6d70d17cc8$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $8cbe5d6d70d17cc8$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $8cbe5d6d70d17cc8$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $d3c67f2935dd1388$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $823e0a2db8a0144b$export$2e2bcd8739ae039)(padding, (0, $8cbe5d6d70d17cc8$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $8cbe5d6d70d17cc8$export$ae5ab1c730825774) ? (0, $8cbe5d6d70d17cc8$export$ca50aac9f3ba507f) : (0, $8cbe5d6d70d17cc8$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $c3d2fd3d16fb2860$export$2e2bcd8739ae039)((0, $ee60bde14c6c67a8$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $86f9ed043a0d2403$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $a2c1a88a5a7b8c84$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $5cfb1826154e8dad$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $44579816b69effdf$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $8cbe5d6d70d17cc8$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $8cbe5d6d70d17cc8$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $8cbe5d6d70d17cc8$export$79ffe56a765070d2),
                (0, $8cbe5d6d70d17cc8$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $8cbe5d6d70d17cc8$export$1e95b668f3b82d),
                (0, $8cbe5d6d70d17cc8$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $5cb7e98e60cd2eec$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $8cbe5d6d70d17cc8$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $bca014efc47bfdd5$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $8cbe5d6d70d17cc8$export$368f9a87e87fa4e1) : (0, $8cbe5d6d70d17cc8$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $bca014efc47bfdd5$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $8cbe5d6d70d17cc8$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $b3bf44aa17fce063$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $2118f8638890d4e0$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $e16f104954d833b5$var$getExpandedFallbackPlacements(placement) {
    if ((0, $2118f8638890d4e0$export$2e2bcd8739ae039)(placement) === (0, $8cbe5d6d70d17cc8$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $109e5ff398e5937c$export$2e2bcd8739ae039)(placement);
    return [
        (0, $d0dd965d16573616$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $d0dd965d16573616$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $e16f104954d833b5$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $2118f8638890d4e0$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $109e5ff398e5937c$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $e16f104954d833b5$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $2118f8638890d4e0$export$2e2bcd8739ae039)(placement) === (0, $8cbe5d6d70d17cc8$export$dfb5619354ba860) ? (0, $5cb7e98e60cd2eec$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $2118f8638890d4e0$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $bca014efc47bfdd5$export$2e2bcd8739ae039)(placement) === (0, $8cbe5d6d70d17cc8$export$b3571188c770cc5a);
        var isVertical = [
            (0, $8cbe5d6d70d17cc8$export$1e95b668f3b82d),
            (0, $8cbe5d6d70d17cc8$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $b3bf44aa17fce063$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $8cbe5d6d70d17cc8$export$79ffe56a765070d2) : (0, $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $8cbe5d6d70d17cc8$export$40e543e69a8b3fbb) : (0, $8cbe5d6d70d17cc8$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $109e5ff398e5937c$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $109e5ff398e5937c$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $e16f104954d833b5$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $e16f104954d833b5$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $7f3848f2de6b91aa$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $9d70f409dd6b4c00$export$f28d906d67a997f3(min, value, max) {
    return (0, $cf7a85d1080d7e7a$export$8960430cfd85939f)(min, (0, $cf7a85d1080d7e7a$export$96ec731ed4dcb222)(value, max));
}
function $9d70f409dd6b4c00$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $9d70f409dd6b4c00$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $3f10b76dfd19317f$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $b3bf44aa17fce063$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $2118f8638890d4e0$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $bca014efc47bfdd5$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $cfc4af360d6c3fb5$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $7f3848f2de6b91aa$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $8cbe5d6d70d17cc8$export$1e95b668f3b82d) : (0, $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $8cbe5d6d70d17cc8$export$40e543e69a8b3fbb) : (0, $8cbe5d6d70d17cc8$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $8cbe5d6d70d17cc8$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $8cbe5d6d70d17cc8$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $7b66e96457cd106c$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $5460abfdfdb3dc2c$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $9d70f409dd6b4c00$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5596b98d0ad06df3$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $9d70f409dd6b4c00$export$f28d906d67a997f3)(tether ? (0, $cf7a85d1080d7e7a$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $cf7a85d1080d7e7a$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $8cbe5d6d70d17cc8$export$1e95b668f3b82d) : (0, $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $8cbe5d6d70d17cc8$export$40e543e69a8b3fbb) : (0, $8cbe5d6d70d17cc8$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $8cbe5d6d70d17cc8$export$1e95b668f3b82d),
            (0, $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $9d70f409dd6b4c00$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $9d70f409dd6b4c00$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3f10b76dfd19317f$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $3f10b76dfd19317f$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $860240a6136e29ea$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $d3c67f2935dd1388$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $823e0a2db8a0144b$export$2e2bcd8739ae039)(padding, (0, $8cbe5d6d70d17cc8$export$aec2ce47c367b8c3)));
};
function $860240a6136e29ea$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $2118f8638890d4e0$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $cfc4af360d6c3fb5$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4),
        (0, $8cbe5d6d70d17cc8$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $860240a6136e29ea$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $7b66e96457cd106c$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $8cbe5d6d70d17cc8$export$1e95b668f3b82d) : (0, $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $8cbe5d6d70d17cc8$export$40e543e69a8b3fbb) : (0, $8cbe5d6d70d17cc8$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5596b98d0ad06df3$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $9d70f409dd6b4c00$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $860240a6136e29ea$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $3a77c93c318b8b2a$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $860240a6136e29ea$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $860240a6136e29ea$var$arrow,
    effect: $860240a6136e29ea$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $b9b573e58973106d$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $b9b573e58973106d$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $8cbe5d6d70d17cc8$export$1e95b668f3b82d),
        (0, $8cbe5d6d70d17cc8$export$79ffe56a765070d2),
        (0, $8cbe5d6d70d17cc8$export$40e543e69a8b3fbb),
        (0, $8cbe5d6d70d17cc8$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $b9b573e58973106d$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $b3bf44aa17fce063$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $b3bf44aa17fce063$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $b9b573e58973106d$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $b9b573e58973106d$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $b9b573e58973106d$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $b9b573e58973106d$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $b9b573e58973106d$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $b9b573e58973106d$var$hide
};




var $1ba2806dc51e43f9$export$d34966752335dd47 = [
    (0, $01c194d6979e6fcc$export$2e2bcd8739ae039),
    (0, $6072185af73edef1$export$2e2bcd8739ae039),
    (0, $908527c93f1ca2bb$export$2e2bcd8739ae039),
    (0, $104603abb3b49066$export$2e2bcd8739ae039),
    (0, $d58e5171c05f5749$export$2e2bcd8739ae039),
    (0, $e16f104954d833b5$export$2e2bcd8739ae039),
    (0, $3f10b76dfd19317f$export$2e2bcd8739ae039),
    (0, $860240a6136e29ea$export$2e2bcd8739ae039),
    (0, $b9b573e58973106d$export$2e2bcd8739ae039)
];
var $1ba2806dc51e43f9$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $6c452e1842c49173$export$ed5e13716264f202)({
    defaultModifiers: $1ba2806dc51e43f9$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $ce2f7b59ef3db1e6$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $ce2f7b59ef3db1e6$var$BOX_CLASS = "tippy-box";
var $ce2f7b59ef3db1e6$var$CONTENT_CLASS = "tippy-content";
var $ce2f7b59ef3db1e6$var$BACKDROP_CLASS = "tippy-backdrop";
var $ce2f7b59ef3db1e6$var$ARROW_CLASS = "tippy-arrow";
var $ce2f7b59ef3db1e6$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $ce2f7b59ef3db1e6$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $ce2f7b59ef3db1e6$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $ce2f7b59ef3db1e6$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $ce2f7b59ef3db1e6$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $ce2f7b59ef3db1e6$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
}
function $ce2f7b59ef3db1e6$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === "function" ? value.apply(void 0, args) : value;
}
function $ce2f7b59ef3db1e6$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $ce2f7b59ef3db1e6$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $ce2f7b59ef3db1e6$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $ce2f7b59ef3db1e6$var$normalizeToArray(value) {
    return [].concat(value);
}
function $ce2f7b59ef3db1e6$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $ce2f7b59ef3db1e6$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $ce2f7b59ef3db1e6$var$getBasePlacement(placement) {
    return placement.split("-")[0];
}
function $ce2f7b59ef3db1e6$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $ce2f7b59ef3db1e6$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $ce2f7b59ef3db1e6$var$div() {
    return document.createElement("div");
}
function $ce2f7b59ef3db1e6$var$isElement(value) {
    return [
        "Element",
        "Fragment"
    ].some(function(type) {
        return $ce2f7b59ef3db1e6$var$isType(value, type);
    });
}
function $ce2f7b59ef3db1e6$var$isNodeList(value) {
    return $ce2f7b59ef3db1e6$var$isType(value, "NodeList");
}
function $ce2f7b59ef3db1e6$var$isMouseEvent(value) {
    return $ce2f7b59ef3db1e6$var$isType(value, "MouseEvent");
}
function $ce2f7b59ef3db1e6$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $ce2f7b59ef3db1e6$var$getArrayOfElements(value) {
    if ($ce2f7b59ef3db1e6$var$isElement(value)) return [
        value
    ];
    if ($ce2f7b59ef3db1e6$var$isNodeList(value)) return $ce2f7b59ef3db1e6$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $ce2f7b59ef3db1e6$var$arrayFrom(document.querySelectorAll(value));
}
function $ce2f7b59ef3db1e6$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $ce2f7b59ef3db1e6$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute("data-state", state);
    });
}
function $ce2f7b59ef3db1e6$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $ce2f7b59ef3db1e6$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $ce2f7b59ef3db1e6$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $ce2f7b59ef3db1e6$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
        var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $ce2f7b59ef3db1e6$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        "transitionend",
        "webkitTransitionEnd"
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $ce2f7b59ef3db1e6$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $ce2f7b59ef3db1e6$var$currentInput = {
    isTouch: false
};
var $ce2f7b59ef3db1e6$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $ce2f7b59ef3db1e6$var$onDocumentTouchStart() {
    if ($ce2f7b59ef3db1e6$var$currentInput.isTouch) return;
    $ce2f7b59ef3db1e6$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener("mousemove", $ce2f7b59ef3db1e6$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $ce2f7b59ef3db1e6$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $ce2f7b59ef3db1e6$var$lastMouseMoveTime < 20) {
        $ce2f7b59ef3db1e6$var$currentInput.isTouch = false;
        document.removeEventListener("mousemove", $ce2f7b59ef3db1e6$var$onDocumentMouseMove);
    }
    $ce2f7b59ef3db1e6$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $ce2f7b59ef3db1e6$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($ce2f7b59ef3db1e6$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $ce2f7b59ef3db1e6$var$bindGlobalEventListeners() {
    document.addEventListener("touchstart", $ce2f7b59ef3db1e6$var$onDocumentTouchStart, $ce2f7b59ef3db1e6$var$TOUCH_OPTIONS);
    window.addEventListener("blur", $ce2f7b59ef3db1e6$var$onWindowBlur);
}
var $ce2f7b59ef3db1e6$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var $ce2f7b59ef3db1e6$var$isIE11 = $ce2f7b59ef3db1e6$var$isBrowser ? !!window.msCrypto : false;
function $ce2f7b59ef3db1e6$var$createMemoryLeakWarning(method) {
    var txt = method === "destroy" ? "n already-" : " ";
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        "indicates a potential memory leak."
    ].join(" ");
}
function $ce2f7b59ef3db1e6$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
}
function $ce2f7b59ef3db1e6$var$getDevMessage(message) {
    return $ce2f7b59ef3db1e6$var$clean("\n  %ctippy.js\n\n  %c" + $ce2f7b59ef3db1e6$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $ce2f7b59ef3db1e6$var$getFormattedMessage(message) {
    return [
        $ce2f7b59ef3db1e6$var$getDevMessage(message),
        "color: #00C584; font-size: 1.3em; font-weight: bold;",
        "line-height: 1.5",
        "color: #a6a095;"
    ];
} // Assume warnings and errors never have the same message
var $ce2f7b59ef3db1e6$var$visitedMessages;
function $ce2f7b59ef3db1e6$var$resetVisitedMessages() {
    $ce2f7b59ef3db1e6$var$visitedMessages = new Set();
}
function $ce2f7b59ef3db1e6$var$warnWhen(condition, message) {
    if (condition && !$ce2f7b59ef3db1e6$var$visitedMessages.has(message)) {
        var _console;
        $ce2f7b59ef3db1e6$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $ce2f7b59ef3db1e6$var$getFormattedMessage(message));
    }
}
function $ce2f7b59ef3db1e6$var$errorWhen(condition, message) {
    if (condition && !$ce2f7b59ef3db1e6$var$visitedMessages.has(message)) {
        var _console2;
        $ce2f7b59ef3db1e6$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $ce2f7b59ef3db1e6$var$getFormattedMessage(message));
    }
}
function $ce2f7b59ef3db1e6$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === "[object Object]" && !targets.addEventListener;
    $ce2f7b59ef3db1e6$var$errorWhen(didPassFalsyValue, [
        "tippy() was passed",
        "`" + String(targets) + "`",
        "as its targets (first) argument. Valid types are: String, Element,",
        "Element[], or NodeList."
    ].join(" "));
    $ce2f7b59ef3db1e6$var$errorWhen(didPassPlainObject, [
        "tippy() was passed a plain object which is not supported as an argument",
        "for virtual positioning. Use props.getReferenceClientRect instead."
    ].join(" "));
}
var $ce2f7b59ef3db1e6$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $ce2f7b59ef3db1e6$var$renderProps = {
    allowHTML: false,
    animation: "fade",
    arrow: true,
    content: "",
    inertia: false,
    maxWidth: 350,
    role: "tooltip",
    theme: "",
    zIndex: 9999
};
var $ce2f7b59ef3db1e6$var$defaultProps = Object.assign({
    appendTo: $ce2f7b59ef3db1e6$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: "auto",
        expanded: "auto"
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: "",
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: "top",
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: "mouseenter focus",
    triggerTarget: null
}, $ce2f7b59ef3db1e6$var$pluginProps, $ce2f7b59ef3db1e6$var$renderProps);
var $ce2f7b59ef3db1e6$var$defaultKeys = Object.keys($ce2f7b59ef3db1e6$var$defaultProps);
var $ce2f7b59ef3db1e6$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $ce2f7b59ef3db1e6$var$defaultProps[key] = partialProps[key];
    });
};
function $ce2f7b59ef3db1e6$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $ce2f7b59ef3db1e6$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $ce2f7b59ef3db1e6$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($ce2f7b59ef3db1e6$var$getExtendedPassedProps(Object.assign({}, $ce2f7b59ef3db1e6$var$defaultProps, {
        plugins: plugins
    }))) : $ce2f7b59ef3db1e6$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || "").trim();
        if (!valueAsString) return acc;
        if (key === "content") acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $ce2f7b59ef3db1e6$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $ce2f7b59ef3db1e6$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $ce2f7b59ef3db1e6$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $ce2f7b59ef3db1e6$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
        content: out.aria.content === "auto" ? props.interactive ? null : "describedby" : out.aria.content
    };
    return out;
}
function $ce2f7b59ef3db1e6$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $ce2f7b59ef3db1e6$var$removeProperties($ce2f7b59ef3db1e6$var$defaultProps, Object.keys($ce2f7b59ef3db1e6$var$pluginProps));
        var didPassUnknownProp = !$ce2f7b59ef3db1e6$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $ce2f7b59ef3db1e6$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            "a plugin, forgot to pass it in an array as props.plugins.",
            "\n\n",
            "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
            "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"
        ].join(" "));
    });
}
var $ce2f7b59ef3db1e6$var$innerHTML = function innerHTML() {
    return "innerHTML";
};
function $ce2f7b59ef3db1e6$var$dangerouslySetInnerHTML(element, html) {
    element[$ce2f7b59ef3db1e6$var$innerHTML()] = html;
}
function $ce2f7b59ef3db1e6$var$createArrowElement(value) {
    var arrow = $ce2f7b59ef3db1e6$var$div();
    if (value === true) arrow.className = $ce2f7b59ef3db1e6$var$ARROW_CLASS;
    else {
        arrow.className = $ce2f7b59ef3db1e6$var$SVG_ARROW_CLASS;
        if ($ce2f7b59ef3db1e6$var$isElement(value)) arrow.appendChild(value);
        else $ce2f7b59ef3db1e6$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $ce2f7b59ef3db1e6$var$setContent(content, props) {
    if ($ce2f7b59ef3db1e6$var$isElement(props.content)) {
        $ce2f7b59ef3db1e6$var$dangerouslySetInnerHTML(content, "");
        content.appendChild(props.content);
    } else if (typeof props.content !== "function") {
        if (props.allowHTML) $ce2f7b59ef3db1e6$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $ce2f7b59ef3db1e6$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $ce2f7b59ef3db1e6$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($ce2f7b59ef3db1e6$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($ce2f7b59ef3db1e6$var$ARROW_CLASS) || node.classList.contains($ce2f7b59ef3db1e6$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($ce2f7b59ef3db1e6$var$BACKDROP_CLASS);
        })
    };
}
function $ce2f7b59ef3db1e6$var$render(instance) {
    var popper = $ce2f7b59ef3db1e6$var$div();
    var box = $ce2f7b59ef3db1e6$var$div();
    box.className = $ce2f7b59ef3db1e6$var$BOX_CLASS;
    box.setAttribute("data-state", "hidden");
    box.setAttribute("tabindex", "-1");
    var content = $ce2f7b59ef3db1e6$var$div();
    content.className = $ce2f7b59ef3db1e6$var$CONTENT_CLASS;
    content.setAttribute("data-state", "hidden");
    $ce2f7b59ef3db1e6$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $ce2f7b59ef3db1e6$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute("data-theme", nextProps.theme);
        else box.removeAttribute("data-theme");
        if (typeof nextProps.animation === "string") box.setAttribute("data-animation", nextProps.animation);
        else box.removeAttribute("data-animation");
        if (nextProps.inertia) box.setAttribute("data-inertia", "");
        else box.removeAttribute("data-inertia");
        box.style.maxWidth = typeof nextProps.maxWidth === "number" ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute("role", nextProps.role);
        else box.removeAttribute("role");
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $ce2f7b59ef3db1e6$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($ce2f7b59ef3db1e6$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($ce2f7b59ef3db1e6$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$ce2f7b59ef3db1e6$var$render.$$tippy = true;
var $ce2f7b59ef3db1e6$var$idCounter = 1;
var $ce2f7b59ef3db1e6$var$mouseMoveListeners = []; // Used by `hideAll()`
var $ce2f7b59ef3db1e6$var$mountedInstances = [];
function $ce2f7b59ef3db1e6$var$createTippy(reference, passedProps) {
    var props = $ce2f7b59ef3db1e6$var$evaluateProps(reference, Object.assign({}, $ce2f7b59ef3db1e6$var$defaultProps, $ce2f7b59ef3db1e6$var$getExtendedPassedProps($ce2f7b59ef3db1e6$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $ce2f7b59ef3db1e6$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $ce2f7b59ef3db1e6$var$idCounter++;
    var popperInstance = null;
    var plugins = $ce2f7b59ef3db1e6$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $ce2f7b59ef3db1e6$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute("data-tippy-root", "");
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute("aria-expanded");
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook("onCreate", [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener("mouseenter", function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener("mouseleave", function() {
        if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === "hold";
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $ce2f7b59ef3db1e6$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $ce2f7b59ef3db1e6$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $ce2f7b59ef3db1e6$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") return 0;
        return $ce2f7b59ef3db1e6$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $ce2f7b59ef3db1e6$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $ce2f7b59ef3db1e6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, "").trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $ce2f7b59ef3db1e6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
            else node.removeAttribute("aria-expanded");
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
        $ce2f7b59ef3db1e6$var$mouseMoveListeners = $ce2f7b59ef3db1e6$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($ce2f7b59ef3db1e6$var$currentInput.isTouch) {
            if (didTouchMove || event.type === "mousedown") return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $ce2f7b59ef3db1e6$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($ce2f7b59ef3db1e6$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $ce2f7b59ef3db1e6$var$actualContains(el, actualTarget);
        })) {
            if ($ce2f7b59ef3db1e6$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) return;
        } else invokeHook("onClickOutside", [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener("mousedown", onDocumentPress, true);
        doc.addEventListener("touchend", onDocumentPress, $ce2f7b59ef3db1e6$var$TOUCH_OPTIONS);
        doc.addEventListener("touchstart", onTouchStart, $ce2f7b59ef3db1e6$var$TOUCH_OPTIONS);
        doc.addEventListener("touchmove", onTouchMove, $ce2f7b59ef3db1e6$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener("mousedown", onDocumentPress, true);
        doc.removeEventListener("touchend", onDocumentPress, $ce2f7b59ef3db1e6$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchstart", onTouchStart, $ce2f7b59ef3db1e6$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchmove", onTouchMove, $ce2f7b59ef3db1e6$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $ce2f7b59ef3db1e6$var$updateTransitionEndListener(box, "remove", listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $ce2f7b59ef3db1e6$var$updateTransitionEndListener(box, "remove", currentTransitionEndListener);
        $ce2f7b59ef3db1e6$var$updateTransitionEndListener(box, "add", listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $ce2f7b59ef3db1e6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on("touchstart", onTrigger, {
                passive: true
            });
            on("touchend", onMouseLeave, {
                passive: true
            });
        }
        $ce2f7b59ef3db1e6$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === "manual") return;
            on(eventType, onTrigger);
            switch(eventType){
                case "mouseenter":
                    on("mouseleave", onMouseLeave);
                    break;
                case "focus":
                    on($ce2f7b59ef3db1e6$var$isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
                    break;
                case "focusin":
                    on("focusout", onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $ce2f7b59ef3db1e6$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $ce2f7b59ef3db1e6$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === "click") isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === "mousemove" && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($ce2f7b59ef3db1e6$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $ce2f7b59ef3db1e6$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $ce2f7b59ef3db1e6$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: "$$tippy",
            enabled: true,
            phase: "beforeWrite",
            requires: [
                "computeStyles"
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        "placement",
                        "reference-hidden",
                        "escaped"
                    ].forEach(function(attr) {
                        if (attr === "placement") box.setAttribute("data-placement", state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, "");
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: "flip",
                options: {
                    padding: 5
                }
            },
            {
                name: "computeStyles",
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: "arrow",
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $1ba2806dc51e43f9$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $ce2f7b59ef3db1e6$var$TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") parentNode = node.parentNode;
        else parentNode = $ce2f7b59ef3db1e6$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $ce2f7b59ef3db1e6$var$arrayFrom(popper.querySelectorAll("[data-tippy-root]"));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook("onTrigger", [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($ce2f7b59ef3db1e6$var$currentInput.isTouch && touchValue === "hold" && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook("onUntrigger", [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && [
            "mouseleave",
            "mousemove"
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook("onBeforeUpdate", [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $ce2f7b59ef3db1e6$var$evaluateProps(reference, Object.assign({}, prevProps, $ce2f7b59ef3db1e6$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $ce2f7b59ef3db1e6$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $ce2f7b59ef3db1e6$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute("aria-expanded");
        });
        else if (nextProps.triggerTarget) reference.removeAttribute("aria-expanded");
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook("onAfterUpdate", [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $ce2f7b59ef3db1e6$var$currentInput.isTouch && !instance.props.touch;
        var duration = $ce2f7b59ef3db1e6$var$getValueAtIndexOrReturn(instance.props.duration, 0, $ce2f7b59ef3db1e6$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute("disabled")) return;
        invokeHook("onShow", [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = "visible";
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = "none";
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $ce2f7b59ef3db1e6$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $ce2f7b59ef3db1e6$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $ce2f7b59ef3db1e6$var$setVisibilityState([
                    _box,
                    _content
                ], "visible");
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $ce2f7b59ef3db1e6$var$pushIfUnique($ce2f7b59ef3db1e6$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook("onMount", [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook("onShown", [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $ce2f7b59ef3db1e6$var$getValueAtIndexOrReturn(instance.props.duration, 1, $ce2f7b59ef3db1e6$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook("onHide", [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = "hidden";
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $ce2f7b59ef3db1e6$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $ce2f7b59ef3db1e6$var$setVisibilityState([
                    box,
                    content
                ], "hidden");
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener("mousemove", debouncedOnMouseMove);
        $ce2f7b59ef3db1e6$var$pushIfUnique($ce2f7b59ef3db1e6$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $ce2f7b59ef3db1e6$var$mountedInstances = $ce2f7b59ef3db1e6$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook("onHidden", [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook("onDestroy", [
            instance
        ]);
    }
}
function $ce2f7b59ef3db1e6$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $ce2f7b59ef3db1e6$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $ce2f7b59ef3db1e6$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $ce2f7b59ef3db1e6$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $ce2f7b59ef3db1e6$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $ce2f7b59ef3db1e6$var$isElement(targets) ? instances[0] : instances;
}
$ce2f7b59ef3db1e6$var$tippy.defaultProps = $ce2f7b59ef3db1e6$var$defaultProps;
$ce2f7b59ef3db1e6$var$tippy.setDefaultProps = $ce2f7b59ef3db1e6$var$setDefaultProps;
$ce2f7b59ef3db1e6$var$tippy.currentInput = $ce2f7b59ef3db1e6$var$currentInput;
var $ce2f7b59ef3db1e6$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $ce2f7b59ef3db1e6$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $ce2f7b59ef3db1e6$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $ce2f7b59ef3db1e6$var$applyStylesModifier = Object.assign({}, (0, $104603abb3b49066$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: "0",
                top: "0",
                margin: "0"
            },
            arrow: {
                position: "absolute"
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $ce2f7b59ef3db1e6$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $ce2f7b59ef3db1e6$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat("content").reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === "function" ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $ce2f7b59ef3db1e6$var$tippy($ce2f7b59ef3db1e6$var$div(), Object.assign({}, $ce2f7b59ef3db1e6$var$removeProperties(optionalProps, [
        "overrides"
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $ce2f7b59ef3db1e6$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === "number") return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $ce2f7b59ef3db1e6$var$BUBBLING_EVENTS_MAP = {
    mouseover: "mouseenter",
    focusin: "focus",
    click: "click"
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $ce2f7b59ef3db1e6$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $ce2f7b59ef3db1e6$var$removeProperties(props, [
        "target"
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: "manual",
        touch: false
    });
    var childProps = Object.assign({
        touch: $ce2f7b59ef3db1e6$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $ce2f7b59ef3db1e6$var$tippy(targets, parentProps);
    var normalizedReturnValue = $ce2f7b59ef3db1e6$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute("data-tippy-trigger") || props.trigger || $ce2f7b59ef3db1e6$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === "touchstart" && typeof childProps.touch === "boolean") return;
        if (event.type !== "touchstart" && trigger.indexOf($ce2f7b59ef3db1e6$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $ce2f7b59ef3db1e6$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, "touchstart", onTrigger, $ce2f7b59ef3db1e6$var$TOUCH_OPTIONS);
        on(reference, "mouseover", onTrigger);
        on(reference, "focusin", onTrigger);
        on(reference, "click", onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $ce2f7b59ef3db1e6$export$dd8ded329c01db79 = {
    name: "animateFill",
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $ce2f7b59ef3db1e6$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $ce2f7b59ef3db1e6$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute("data-animatefill", "");
                    box.style.overflow = "hidden";
                    instance.setProps({
                        arrow: false,
                        animation: "shift-away"
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace("ms", "")); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $ce2f7b59ef3db1e6$var$setVisibilityState([
                        backdrop
                    ], "visible");
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = "0ms";
            },
            onHide: function onHide() {
                if (backdrop) $ce2f7b59ef3db1e6$var$setVisibilityState([
                    backdrop
                ], "hidden");
            }
        };
    }
};
function $ce2f7b59ef3db1e6$var$createBackdropElement() {
    var backdrop = $ce2f7b59ef3db1e6$var$div();
    backdrop.className = $ce2f7b59ef3db1e6$var$BACKDROP_CLASS;
    $ce2f7b59ef3db1e6$var$setVisibilityState([
        backdrop
    ], "hidden");
    return backdrop;
}
var $ce2f7b59ef3db1e6$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $ce2f7b59ef3db1e6$var$activeInstances = [];
function $ce2f7b59ef3db1e6$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $ce2f7b59ef3db1e6$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $ce2f7b59ef3db1e6$var$addMouseCoordsListener(doc) {
    doc.addEventListener("mousemove", $ce2f7b59ef3db1e6$var$storeMouseCoords);
}
function $ce2f7b59ef3db1e6$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener("mousemove", $ce2f7b59ef3db1e6$var$storeMouseCoords);
}
var $ce2f7b59ef3db1e6$export$ac81526b64504ab6 = {
    name: "followCursor",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $ce2f7b59ef3db1e6$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === "initial" && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener("mousemove", onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener("mousemove", onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === "initial") {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === "horizontal" ? rect.top : y;
                    var right = followCursor === "vertical" ? rect.right : x;
                    var bottom = followCursor === "horizontal" ? rect.bottom : y;
                    var left = followCursor === "vertical" ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $ce2f7b59ef3db1e6$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $ce2f7b59ef3db1e6$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $ce2f7b59ef3db1e6$var$activeInstances = $ce2f7b59ef3db1e6$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($ce2f7b59ef3db1e6$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $ce2f7b59ef3db1e6$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($ce2f7b59ef3db1e6$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($ce2f7b59ef3db1e6$var$isMouseEvent(event)) $ce2f7b59ef3db1e6$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === "focus";
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $ce2f7b59ef3db1e6$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $ce2f7b59ef3db1e6$export$e2b668424a9c728 = {
    name: "inlinePositioning",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: "tippyInlinePositioning",
            enabled: true,
            phase: "afterWrite",
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $ce2f7b59ef3db1e6$var$getInlineBoundingClientRect($ce2f7b59ef3db1e6$var$getBasePlacement(placement), reference.getBoundingClientRect(), $ce2f7b59ef3db1e6$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($ce2f7b59ef3db1e6$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($ce2f7b59ef3db1e6$var$isMouseEvent(event)) {
                    var rects = $ce2f7b59ef3db1e6$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $ce2f7b59ef3db1e6$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case "top":
        case "bottom":
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === "top";
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case "left":
        case "right":
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === "left" ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $ce2f7b59ef3db1e6$export$4bd4b47501432316 = {
    name: "sticky",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck("reference") ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck("popper") ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $ce2f7b59ef3db1e6$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $ce2f7b59ef3db1e6$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $ce2f7b59ef3db1e6$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$ce2f7b59ef3db1e6$var$tippy.setDefaultProps({
    render: $ce2f7b59ef3db1e6$var$render
});
var $ce2f7b59ef3db1e6$export$2e2bcd8739ae039 = $ce2f7b59ef3db1e6$var$tippy;



var $4DE7A = parcelRequire("4DE7A");

var $gv34t = parcelRequire("gv34t");
function $7de18142ef01be1a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $7de18142ef01be1a$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
function $7de18142ef01be1a$var$preserveRef(ref, node) {
    if (ref) {
        if (typeof ref === "function") ref(node);
        if (({}).hasOwnProperty.call(ref, "current")) ref.current = node;
    }
}
function $7de18142ef01be1a$var$ssrSafeCreateDiv() {
    return $7de18142ef01be1a$var$isBrowser && document.createElement("div");
}
function $7de18142ef01be1a$var$toDataAttributes(attrs) {
    var dataAttrs = {
        "data-placement": attrs.placement
    };
    if (attrs.referenceHidden) dataAttrs["data-reference-hidden"] = "";
    if (attrs.escaped) dataAttrs["data-escaped"] = "";
    return dataAttrs;
}
function $7de18142ef01be1a$var$deepEqual(x, y) {
    if (x === y) return true;
    else if (typeof x === "object" && x != null && typeof y === "object" && y != null) {
        if (Object.keys(x).length !== Object.keys(y).length) return false;
        for(var prop in x){
            if (y.hasOwnProperty(prop)) {
                if (!$7de18142ef01be1a$var$deepEqual(x[prop], y[prop])) return false;
            } else return false;
        }
        return true;
    } else return false;
}
function $7de18142ef01be1a$var$uniqueByShape(arr) {
    var output = [];
    arr.forEach(function(item) {
        if (!output.find(function(outputItem) {
            return $7de18142ef01be1a$var$deepEqual(item, outputItem);
        })) output.push(item);
    });
    return output;
}
function $7de18142ef01be1a$var$deepPreserveProps(instanceProps, componentProps) {
    var _instanceProps$popper, _componentProps$poppe;
    return Object.assign({}, componentProps, {
        popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
            modifiers: $7de18142ef01be1a$var$uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
        })
    });
}
var $7de18142ef01be1a$var$useIsomorphicLayoutEffect = $7de18142ef01be1a$var$isBrowser ? (0, $4DE7A.useLayoutEffect) : (0, $4DE7A.useEffect);
function $7de18142ef01be1a$var$useMutableBox(initialValue) {
    // Using refs instead of state as it's recommended to not store imperative
    // values in state due to memory problems in React(?)
    var ref = (0, $4DE7A.useRef)();
    if (!ref.current) ref.current = typeof initialValue === "function" ? initialValue() : initialValue;
    return ref.current;
}
function $7de18142ef01be1a$var$updateClassName(box, action, classNames) {
    classNames.split(/\s+/).forEach(function(name) {
        if (name) box.classList[action](name);
    });
}
var $7de18142ef01be1a$var$classNamePlugin = {
    name: "className",
    defaultValue: "",
    fn: function fn(instance) {
        var box = instance.popper.firstElementChild;
        var isDefaultRenderFn = function isDefaultRenderFn() {
            var _instance$props$rende;
            return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
        };
        function add() {
            if (instance.props.className && !isDefaultRenderFn()) return;
            $7de18142ef01be1a$var$updateClassName(box, "add", instance.props.className);
        }
        function remove() {
            if (isDefaultRenderFn()) $7de18142ef01be1a$var$updateClassName(box, "remove", instance.props.className);
        }
        return {
            onCreate: add,
            onBeforeUpdate: remove,
            onAfterUpdate: add
        };
    }
};
function $7de18142ef01be1a$var$TippyGenerator(tippy) {
    function Tippy(_ref) {
        var children = _ref.children, content = _ref.content, visible = _ref.visible, singleton = _ref.singleton, render = _ref.render, reference = _ref.reference, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$ignoreAttributes = _ref.ignoreAttributes, ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes, __source = _ref.__source, __self = _ref.__self, restOfNativeProps = $7de18142ef01be1a$var$_objectWithoutPropertiesLoose(_ref, [
            "children",
            "content",
            "visible",
            "singleton",
            "render",
            "reference",
            "disabled",
            "ignoreAttributes",
            "__source",
            "__self"
        ]);
        var isControlledMode = visible !== undefined;
        var isSingletonMode = singleton !== undefined;
        var _useState = (0, $4DE7A.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var _useState2 = (0, $4DE7A.useState)({}), attrs = _useState2[0], setAttrs = _useState2[1];
        var _useState3 = (0, $4DE7A.useState)(), singletonContent = _useState3[0], setSingletonContent = _useState3[1];
        var mutableBox = $7de18142ef01be1a$var$useMutableBox(function() {
            return {
                container: $7de18142ef01be1a$var$ssrSafeCreateDiv(),
                renders: 1
            };
        });
        var props = Object.assign({
            ignoreAttributes: ignoreAttributes
        }, restOfNativeProps, {
            content: mutableBox.container
        });
        if (isControlledMode) {
            props.trigger = "manual";
            props.hideOnClick = false;
        }
        if (isSingletonMode) disabled = true;
        var computedProps = props;
        var plugins = props.plugins || [];
        if (render) computedProps = Object.assign({}, props, {
            plugins: isSingletonMode && singleton.data != null ? [].concat(plugins, [
                {
                    fn: function fn() {
                        return {
                            onTrigger: function onTrigger(instance, event) {
                                var node = singleton.data.children.find(function(_ref2) {
                                    var instance = _ref2.instance;
                                    return instance.reference === event.currentTarget;
                                });
                                instance.state.$$activeSingletonInstance = node.instance;
                                setSingletonContent(node.content);
                            }
                        };
                    }
                }
            ]) : plugins,
            render: function render() {
                return {
                    popper: mutableBox.container
                };
            }
        });
        var deps = [
            reference
        ].concat(children ? [
            children.type
        ] : []); // CREATE
        $7de18142ef01be1a$var$useIsomorphicLayoutEffect(function() {
            var element = reference;
            if (reference && reference.hasOwnProperty("current")) element = reference.current;
            var instance = tippy(element || mutableBox.ref || $7de18142ef01be1a$var$ssrSafeCreateDiv(), Object.assign({}, computedProps, {
                plugins: [
                    $7de18142ef01be1a$var$classNamePlugin
                ].concat(props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            if (visible) instance.show();
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps,
                setSingletonContent: setSingletonContent
            });
            setMounted(true);
            return function() {
                instance.destroy();
                singleton == null || singleton.cleanup(instance);
            };
        }, deps); // UPDATE
        $7de18142ef01be1a$var$useIsomorphicLayoutEffect(function() {
            var _instance$popperInsta;
            // Prevent this effect from running on 1st render
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var instance = mutableBox.instance;
            instance.setProps($7de18142ef01be1a$var$deepPreserveProps(instance.props, computedProps)); // Fixes #264
            (_instance$popperInsta = instance.popperInstance) == null || _instance$popperInsta.forceUpdate();
            if (disabled) instance.disable();
            else instance.enable();
            if (isControlledMode) {
                if (visible) instance.show();
                else instance.hide();
            }
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps,
                setSingletonContent: setSingletonContent
            });
        });
        $7de18142ef01be1a$var$useIsomorphicLayoutEffect(function() {
            var _instance$props$poppe;
            if (!render) return;
            var instance = mutableBox.instance;
            instance.setProps({
                popperOptions: Object.assign({}, instance.props.popperOptions, {
                    modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function(_ref3) {
                        var name = _ref3.name;
                        return name !== "$$tippyReact";
                    }), [
                        {
                            name: "$$tippyReact",
                            enabled: true,
                            phase: "beforeWrite",
                            requires: [
                                "computeStyles"
                            ],
                            fn: function fn(_ref4) {
                                var _state$modifiersData;
                                var state = _ref4.state;
                                var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
                                // loop. This expression _must_ evaluate to false when required
                                if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) setAttrs({
                                    placement: state.placement,
                                    referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                                    escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                                });
                                state.attributes.popper = {};
                            }
                        }
                    ])
                })
            });
        }, [
            attrs.placement,
            attrs.referenceHidden,
            attrs.escaped
        ].concat(deps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, children ? /*#__PURE__*/ (0, $4DE7A.cloneElement)(children, {
            ref: function ref(node) {
                mutableBox.ref = node;
                $7de18142ef01be1a$var$preserveRef(children.ref, node);
            }
        }) : null, mounted && /*#__PURE__*/ (0, $gv34t.createPortal)(render ? render($7de18142ef01be1a$var$toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container));
    }
    return Tippy;
}
function $7de18142ef01be1a$var$useSingletonGenerator(createSingleton) {
    return function useSingleton(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$overrides = _ref.overrides, overrides = _ref$overrides === void 0 ? [] : _ref$overrides;
        var _useState = (0, $4DE7A.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var mutableBox = $7de18142ef01be1a$var$useMutableBox({
            children: [],
            renders: 1
        });
        $7de18142ef01be1a$var$useIsomorphicLayoutEffect(function() {
            if (!mounted) {
                setMounted(true);
                return;
            }
            var children = mutableBox.children, sourceData = mutableBox.sourceData;
            if (!sourceData) return;
            var instance = createSingleton(children.map(function(child) {
                return child.instance;
            }), Object.assign({}, sourceData.props, {
                popperOptions: sourceData.instance.props.popperOptions,
                overrides: overrides,
                plugins: [
                    $7de18142ef01be1a$var$classNamePlugin
                ].concat(sourceData.props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            return function() {
                instance.destroy();
                mutableBox.children = children.filter(function(_ref2) {
                    var instance = _ref2.instance;
                    return !instance.state.isDestroyed;
                });
            };
        }, [
            mounted
        ]);
        $7de18142ef01be1a$var$useIsomorphicLayoutEffect(function() {
            if (!mounted) return;
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var children = mutableBox.children, instance = mutableBox.instance, sourceData = mutableBox.sourceData;
            if (!(instance && sourceData)) return;
            var _sourceData$props = sourceData.props, content = _sourceData$props.content, props = $7de18142ef01be1a$var$_objectWithoutPropertiesLoose(_sourceData$props, [
                "content"
            ]);
            instance.setProps($7de18142ef01be1a$var$deepPreserveProps(instance.props, Object.assign({}, props, {
                overrides: overrides
            })));
            instance.setInstances(children.map(function(child) {
                return child.instance;
            }));
            if (disabled) instance.disable();
            else instance.enable();
        });
        return (0, $4DE7A.useMemo)(function() {
            var source = {
                data: mutableBox,
                hook: function hook(data) {
                    mutableBox.sourceData = data;
                    mutableBox.setSingletonContent = data.setSingletonContent;
                },
                cleanup: function cleanup() {
                    mutableBox.sourceData = null;
                }
            };
            var target = {
                hook: function hook(data) {
                    var _mutableBox$instance, _mutableBox$instance2;
                    mutableBox.children = mutableBox.children.filter(function(_ref3) {
                        var instance = _ref3.instance;
                        return data.instance !== instance;
                    });
                    mutableBox.children.push(data);
                    if (((_mutableBox$instance = mutableBox.instance) == null ? void 0 : _mutableBox$instance.state.isMounted) && ((_mutableBox$instance2 = mutableBox.instance) == null ? void 0 : _mutableBox$instance2.state.$$activeSingletonInstance) === data.instance) mutableBox.setSingletonContent == null || mutableBox.setSingletonContent(data.content);
                    if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                        return child.instance;
                    }));
                },
                cleanup: function cleanup(instance) {
                    mutableBox.children = mutableBox.children.filter(function(data) {
                        return data.instance !== instance;
                    });
                    if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                        return child.instance;
                    }));
                }
            };
            return [
                source,
                target
            ];
        }, []);
    };
}
var $7de18142ef01be1a$var$forwardRef = function(Tippy, defaultProps) {
    return /*#__PURE__*/ (0, $4DE7A.forwardRef)(function TippyWrapper(_ref, _ref2) {
        var children = _ref.children, props = $7de18142ef01be1a$var$_objectWithoutPropertiesLoose(_ref, [
            "children"
        ]);
        return(/*#__PURE__*/ // If I spread them separately here, Babel adds the _extends ponyfill for
        // some reason
        (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/ (0, $4DE7A.cloneElement)(children, {
            ref: function ref(node) {
                $7de18142ef01be1a$var$preserveRef(_ref2, node);
                $7de18142ef01be1a$var$preserveRef(children.ref, node);
            }
        }) : null));
    });
};
var $7de18142ef01be1a$export$abf4268d2dd55708 = /*#__PURE__*/ $7de18142ef01be1a$var$useSingletonGenerator((0, $ce2f7b59ef3db1e6$export$374c483667c1ea9b));
var $7de18142ef01be1a$var$index = /*#__PURE__*/ $7de18142ef01be1a$var$forwardRef(/*#__PURE__*/ $7de18142ef01be1a$var$TippyGenerator((0, $ce2f7b59ef3db1e6$export$2e2bcd8739ae039)));
var $7de18142ef01be1a$export$2e2bcd8739ae039 = $7de18142ef01be1a$var$index;





const $448ac9151c2238c6$var$TOOLTIP_DEFAULT_PLACEMENT = "top";
const $448ac9151c2238c6$var$TOOLTIP_OFFSET = [
    0,
    10
];
const $448ac9151c2238c6$var$TOOLTIP_DURATION = 100;
const $448ac9151c2238c6$var$TOOLTIP_ANIMATION = "shift-toward";
const $448ac9151c2238c6$var$TOOLTIP_DELAY = [
    150,
    0
];
function $448ac9151c2238c6$var$Tooltip({ source: source, target: target, label: label, sublabel: sublabel, placement: placement = $448ac9151c2238c6$var$TOOLTIP_DEFAULT_PLACEMENT, children: children, ...props }) {
    const renderContent = (label = "", sublabel = "")=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
            children: [
                label,
                sublabel && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                    children: sublabel
                })
            ]
        });
    // Our implementation of TippyJS is predominantly used in cases where there
    // may be multiple reference elements. A "singleton" tooltip is used because
    // we need it to animate in when it appears for the first time, and animate
    // out when it leaves, but not when hovering or focusing across reference
    // elements. For more on singleton tooltips, refer to Tippy documentation:
    //
    // https://atomiks.github.io/tippyjs/#singleton
    //
    // For React components, the Tippy singleton is defined with the
    // useSingleton() hook.
    // https://github.com/atomiks/tippyjs-react#-usesingleton
    //
    // The <Tippy /> component is overloaded so that when used in a singleton
    // it functions as both the "source" (a generic tooltip instance) and
    // the "target" (a wrapper around a reference element to give it a tooltip).
    // While this may be confusing, we do not abstract over this behavior here.
    //
    // If the `source` prop is provided (this is defined by using a
    // useSingleton() hook in the parent component) we return a <Tippy />
    // instance that defines a generic tooltip with our desired behavior.
    // We define our standard behavior but these can be overwritten with
    // any of Tippy's props.
    // https://github.com/atomiks/tippyjs-react#-props
    if (typeof source !== "undefined") return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $7de18142ef01be1a$export$2e2bcd8739ae039), {
        placement: placement,
        offset: $448ac9151c2238c6$var$TOOLTIP_OFFSET,
        duration: $448ac9151c2238c6$var$TOOLTIP_DURATION,
        animation: $448ac9151c2238c6$var$TOOLTIP_ANIMATION,
        delay: $448ac9151c2238c6$var$TOOLTIP_DELAY,
        singleton: source,
        ...props
    });
    // If a `target` prop is provided (this is also defined by the useSingleton()
    // hook) we return a <Tippy /> higher-order component (HOC) that wraps the
    // reference element where a tooltip should be displayed. When <Tippy />
    // is used in this way, it doesn't take the same tooltip behavior props.
    if (typeof target !== "undefined") return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $7de18142ef01be1a$export$2e2bcd8739ae039), {
        content: renderContent(label, sublabel),
        singleton: target,
        children: children
    });
    // If neither `source` nor `target` are provided, then we assume that the
    // tooltip is a one-off (that is, not a singleton that should be reused
    // across multiple reference elements). We set this up with our standard
    // default behavior but these can be overridden with any of Tippy's props.
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $7de18142ef01be1a$export$2e2bcd8739ae039), {
        content: renderContent(label, sublabel),
        placement: placement,
        offset: $448ac9151c2238c6$var$TOOLTIP_OFFSET,
        duration: $448ac9151c2238c6$var$TOOLTIP_DURATION,
        animation: $448ac9151c2238c6$var$TOOLTIP_ANIMATION,
        delay: $448ac9151c2238c6$var$TOOLTIP_DELAY,
        ...props,
        children: children
    });
}
var $448ac9151c2238c6$export$2e2bcd8739ae039 = $448ac9151c2238c6$var$Tooltip;



function $5c67cbff9fb2340a$export$2e2bcd8739ae039({ translation: translation = "", label: label = "", tooltip: tooltip, url: url, children: children = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
    id: translation,
    defaultMessage: label
}), ...restProps }) {
    let component;
    if (url !== undefined) {
        if ((0, $ec5f57ce491b339b$export$78234eee43b97e81)(url)) component = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                href: url,
                ...restProps,
                children: [
                    children,
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$9bd11592bfa362e7), {
                        className: "menu-external-link"
                    })
                ]
            })
        });
        else component = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("a", {
                href: url,
                ...restProps,
                children: [
                    children,
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$9bd11592bfa362e7), {
                        className: "menu-external-link"
                    })
                ]
            })
        });
    } else component = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("button", {
            className: "menu-attached",
            ...restProps,
            children: [
                children,
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$4857d3f3f5f8319b), {
                    className: "menu-carat-down"
                })
            ]
        })
    });
    if (tooltip !== undefined) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
        label: tooltip,
        placement: "bottom",
        children: component
    });
    return component;
}



parcelRequire("4DE7A");

/**
 * A button component for UI buttons, or links styled to look like UI buttons.
 *
 * Sometimes you want a button to open a link, but it's better to use anchor
 * elements instead (e.g. it gives a user the choice to open in another tab.)
 * This component can conditionally render either a <button> or <a>.
 *
 * We do not globally override <button> styles because they can be used
 * semantically, in situations where we want built-in features like
 * focusability, events handling, etc. but they should not look like stylized
 * UI buttons.
 */ 

var $4DE7A = parcelRequire("4DE7A");

const $e6b8fb83be03caef$var$Button = /*#__PURE__*/ (0, $4DE7A.forwardRef)(({ children: children, className: className = "", type: type = "button", href: href = "", primary: primary = false, secondary: secondary = false, tertiary: tertiary = false, ...props }, ref)=>{
    const classNames = [
        "btn"
    ];
    if (primary) classNames.push("btn-primary");
    if (secondary) classNames.push("btn-secondary");
    if (tertiary) classNames.push("btn-tertiary");
    if (className) classNames.push(className);
    // If `href` is present, return an anchor element.
    if (href) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
        ref: ref,
        href: href,
        className: classNames.join(" "),
        ...props,
        children: children
    });
    // Otherwise, use a button element.
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
        ref: ref,
        type: type,
        className: classNames.join(" "),
        ...props,
        children: children
    });
});
$e6b8fb83be03caef$var$Button.displayName = "Button";
var $e6b8fb83be03caef$export$2e2bcd8739ae039 = $e6b8fb83be03caef$var$Button;



function $dc06d76addd0f8df$var$SignInButton({ onClick: onClick = ()=>undefined }) {
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
        primary: true,
        className: "menu-sign-in",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "menu.item.sign-in",
            defaultMessage: "Sign in"
        })
    });
}
var $dc06d76addd0f8df$export$2e2bcd8739ae039 = $dc06d76addd0f8df$var$SignInButton;



parcelRequire("4DE7A");


var $6ff8381b2b683785$exports = {};

$6ff8381b2b683785$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "streetmix-plus.68cd7941.svg";



function $f0415503ee94b3c1$var$UpgradeButton({ onClick: onClick = ()=>undefined }) {
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
        tertiary: true,
        className: "menu-upgrade",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                className: "menu-avatar-subscriber",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6ff8381b2b683785$exports))),
                alt: "Streetmix+"
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "menu.item.streetmix-plus",
                defaultMessage: "Get Streetmix+\u200E"
            })
        ]
    });
}
var $f0415503ee94b3c1$export$2e2bcd8739ae039 = $f0415503ee94b3c1$var$UpgradeButton;



parcelRequire("4DE7A");


parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");


function $aad6e9d6c00e3001$var$Avatar({ userId: userId }) {
    const { data: data } = (0, $e2f405c0a03fcace$export$9beb97f355b95ab9)(userId);
    // Loading and error states will declare an empty `src` property
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
        className: "avatar",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
            src: data?.profileImageUrl || undefined,
            alt: userId
        })
    });
}
$aad6e9d6c00e3001$var$Avatar.propTypes = {
    userId: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
};
var $aad6e9d6c00e3001$export$2e2bcd8739ae039 = $aad6e9d6c00e3001$var$Avatar;




function $fe3495b3d065acea$var$AvatarMenu({ user: user, isSubscriber: isSubscriber = false, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $d05758791eb139fa$exports.useIntl)();
    const subscriberLabel = isSubscriber ? formatMessage({
        id: "users.roles.subscriber",
        defaultMessage: "Streetmix+ member"
    }) : "";
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("button", {
        className: "menu-attached menu-avatar",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $aad6e9d6c00e3001$export$2e2bcd8739ae039), {
                userId: user.id
            }),
            isSubscriber && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                className: "menu-avatar-badge menu-avatar-subscriber",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6ff8381b2b683785$exports))),
                alt: subscriberLabel,
                title: subscriberLabel
            })
        ]
    });
}
var $fe3495b3d065acea$export$2e2bcd8739ae039 = $fe3495b3d065acea$var$AvatarMenu;



function $c4600497f2a05c41$var$MenuBar({ onMenuDropdownClick: onMenuDropdownClick }) {
    const user = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.user.signInData?.details);
    const isSubscriber = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.user.signedIn && state.user.isSubscriber);
    const offline = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.system.offline);
    const enableLocaleSettings = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.flags.LOCALES_LEVEL_1.value || state.flags.LOCALES_LEVEL_2.value || state.flags.LOCALES_LEVEL_3.value);
    const menuBarRightEl = (0, $4DE7A.useRef)(null);
    const menuBarLeftEl = (0, $4DE7A.useRef)(null);
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const languageLabel = intl.formatMessage({
        id: "settings.language.label",
        defaultMessage: "Language"
    });
    (0, $4DE7A.useEffect)(()=>{
        window.addEventListener("resize", handleWindowResize);
        // StreetNameplateContainer needs to know the left position of the right
        // menu bar when it's mounted
        window.addEventListener("stmx:streetnameplate_mounted", handleWindowResize);
        // Clean up event listeners
        return ()=>{
            window.removeEventListener("resize", handleWindowResize);
            window.removeEventListener("stmx:streetnameplate_mounted", handleWindowResize);
        };
    });
    /**
   * Handles clicks on <button> elements which result in a dropdown menu.
   * Pass in the name of this menu, and it returns (curries) a function
   * that handles the event.
   */ function handleClickMenuButton(menu) {
        return (event)=>{
            const el = event.target.closest("button");
            if (el !== null) onMenuDropdownClick(menu, el);
        };
    }
    function handleClickUpgrade() {
        // dispatch(showDialog('UPGRADE'))
        window.open("https://docs.streetmix.net/user-guide/streetmix-plus", "_blank");
    }
    function handleWindowResize() {
        // Throw this event so that the StreetName can figure out if it needs
        // to push itself lower than the menubar
        const rightMenuBarLeftPos = menuBarRightEl.current?.getBoundingClientRect().left;
        const leftMenuBarRightPos = menuBarLeftEl.current?.getBoundingClientRect().right;
        window.dispatchEvent(new CustomEvent("stmx:menu_bar_resized", {
            detail: {
                rightMenuBarLeftPos: rightMenuBarLeftPos,
                leftMenuBarRightPos: leftMenuBarRightPos
            }
        }));
    }
    function renderUserAvatar(user) {
        return user ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $fe3495b3d065acea$export$2e2bcd8739ae039), {
                user: user,
                isSubscriber: isSubscriber,
                onClick: handleClickMenuButton("identity")
            })
        }) : /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $dc06d76addd0f8df$export$2e2bcd8739ae039), {
                onClick: (0, $9be7409470745503$export$7abc584011c1e113)
            })
        });
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("nav", {
        className: "menu-bar",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("ul", {
                className: "menu-bar-left",
                ref: menuBarLeftEl,
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                        className: "menu-bar-title",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($10abdc0bd635538b$exports))),
                                alt: "Streemix",
                                className: "menu-bar-logo"
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                                children: "Streetmix"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5c67cbff9fb2340a$export$2e2bcd8739ae039), {
                        label: "Help",
                        translation: "menu.item.help",
                        onClick: handleClickMenuButton("help")
                    }),
                    !offline && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5c67cbff9fb2340a$export$2e2bcd8739ae039), {
                                label: "Contact",
                                translation: "menu.item.contact",
                                onClick: handleClickMenuButton("contact")
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5c67cbff9fb2340a$export$2e2bcd8739ae039), {
                                label: "Store",
                                translation: "menu.item.store",
                                url: "https://cottonbureau.com/people/streetmix"
                            }),
                            !isSubscriber && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $f0415503ee94b3c1$export$2e2bcd8739ae039), {
                                onClick: handleClickUpgrade
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("ul", {
                className: "menu-bar-right",
                ref: menuBarRightEl,
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5c67cbff9fb2340a$export$2e2bcd8739ae039), {
                        label: "New street",
                        translation: "menu.item.new-street",
                        url: "/new",
                        target: "_blank"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5c67cbff9fb2340a$export$2e2bcd8739ae039), {
                        label: "Share",
                        translation: "menu.item.share",
                        onClick: handleClickMenuButton("share")
                    }),
                    enableLocaleSettings && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5c67cbff9fb2340a$export$2e2bcd8739ae039), {
                        onClick: handleClickMenuButton("locale"),
                        tooltip: languageLabel,
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $01fa17a3769f170b$export$2e2bcd8739ae039), {
                            label: languageLabel,
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6ec9aef169c6b70a$export$98bfae5849dca53), {})
                        })
                    }),
                    !offline && renderUserAvatar(user)
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $3ca9c4908ed5ee34$export$2e2bcd8739ae039), {})
        ]
    });
}
var $c4600497f2a05c41$export$2e2bcd8739ae039 = $c4600497f2a05c41$var$MenuBar;




var $4DE7A = parcelRequire("4DE7A");





parcelRequire("4DE7A");
function $624ceb5de64d8d6d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $624ceb5de64d8d6d$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $624ceb5de64d8d6d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $624ceb5de64d8d6d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $624ceb5de64d8d6d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $624ceb5de64d8d6d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $624ceb5de64d8d6d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $624ceb5de64d8d6d$var$_typeof(obj);
}
function $624ceb5de64d8d6d$var$_wrapRegExp() {
    $624ceb5de64d8d6d$var$_wrapRegExp = function(re, groups) {
        return new BabelRegExp(re, void 0, groups);
    };
    var _super = RegExp.prototype, _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        return _groups.set(_this, groups || _groups.get(re)), $624ceb5de64d8d6d$var$_setPrototypeOf(_this, BabelRegExp.prototype);
    }
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            return groups[name] = result[g[name]], groups;
        }, Object.create(null));
    }
    return $624ceb5de64d8d6d$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        return result && (result.groups = buildGroups(result, this)), result;
    }, BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if ("string" == typeof substitution) {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        }
        if ("function" == typeof substitution) {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
            });
        }
        return _super[Symbol.replace].call(this, str, substitution);
    }, $624ceb5de64d8d6d$var$_wrapRegExp.apply(this, arguments);
}
function $624ceb5de64d8d6d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $624ceb5de64d8d6d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $624ceb5de64d8d6d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $624ceb5de64d8d6d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $624ceb5de64d8d6d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $624ceb5de64d8d6d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $624ceb5de64d8d6d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $624ceb5de64d8d6d$var$_setPrototypeOf(subClass, superClass);
}
function $624ceb5de64d8d6d$var$_setPrototypeOf(o, p) {
    $624ceb5de64d8d6d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $624ceb5de64d8d6d$var$_setPrototypeOf(o, p);
}
function $624ceb5de64d8d6d$var$_slicedToArray(arr, i) {
    return $624ceb5de64d8d6d$var$_arrayWithHoles(arr) || $624ceb5de64d8d6d$var$_iterableToArrayLimit(arr, i) || $624ceb5de64d8d6d$var$_unsupportedIterableToArray(arr, i) || $624ceb5de64d8d6d$var$_nonIterableRest();
}
function $624ceb5de64d8d6d$var$_toConsumableArray(arr) {
    return $624ceb5de64d8d6d$var$_arrayWithoutHoles(arr) || $624ceb5de64d8d6d$var$_iterableToArray(arr) || $624ceb5de64d8d6d$var$_unsupportedIterableToArray(arr) || $624ceb5de64d8d6d$var$_nonIterableSpread();
}
function $624ceb5de64d8d6d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $624ceb5de64d8d6d$var$_arrayLikeToArray(arr);
}
function $624ceb5de64d8d6d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $624ceb5de64d8d6d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $624ceb5de64d8d6d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $624ceb5de64d8d6d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $624ceb5de64d8d6d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $624ceb5de64d8d6d$var$_arrayLikeToArray(o, minLen);
}
function $624ceb5de64d8d6d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $624ceb5de64d8d6d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $624ceb5de64d8d6d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $624ceb5de64d8d6d$var$noop = function noop() {};
var $624ceb5de64d8d6d$var$_WINDOW = {};
var $624ceb5de64d8d6d$var$_DOCUMENT = {};
var $624ceb5de64d8d6d$var$_MUTATION_OBSERVER = null;
var $624ceb5de64d8d6d$var$_PERFORMANCE = {
    mark: $624ceb5de64d8d6d$var$noop,
    measure: $624ceb5de64d8d6d$var$noop
};
try {
    if (typeof window !== "undefined") $624ceb5de64d8d6d$var$_WINDOW = window;
    if (typeof document !== "undefined") $624ceb5de64d8d6d$var$_DOCUMENT = document;
    if (typeof MutationObserver !== "undefined") $624ceb5de64d8d6d$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") $624ceb5de64d8d6d$var$_PERFORMANCE = performance;
} catch (e) {}
var $624ceb5de64d8d6d$var$_ref = $624ceb5de64d8d6d$var$_WINDOW.navigator || {}, $624ceb5de64d8d6d$var$_ref$userAgent = $624ceb5de64d8d6d$var$_ref.userAgent, $624ceb5de64d8d6d$var$userAgent = $624ceb5de64d8d6d$var$_ref$userAgent === void 0 ? "" : $624ceb5de64d8d6d$var$_ref$userAgent;
var $624ceb5de64d8d6d$var$WINDOW = $624ceb5de64d8d6d$var$_WINDOW;
var $624ceb5de64d8d6d$var$DOCUMENT = $624ceb5de64d8d6d$var$_DOCUMENT;
var $624ceb5de64d8d6d$var$MUTATION_OBSERVER = $624ceb5de64d8d6d$var$_MUTATION_OBSERVER;
var $624ceb5de64d8d6d$var$PERFORMANCE = $624ceb5de64d8d6d$var$_PERFORMANCE;
var $624ceb5de64d8d6d$var$IS_BROWSER = !!$624ceb5de64d8d6d$var$WINDOW.document;
var $624ceb5de64d8d6d$var$IS_DOM = !!$624ceb5de64d8d6d$var$DOCUMENT.documentElement && !!$624ceb5de64d8d6d$var$DOCUMENT.head && typeof $624ceb5de64d8d6d$var$DOCUMENT.addEventListener === "function" && typeof $624ceb5de64d8d6d$var$DOCUMENT.createElement === "function";
var $624ceb5de64d8d6d$var$IS_IE = ~$624ceb5de64d8d6d$var$userAgent.indexOf("MSIE") || ~$624ceb5de64d8d6d$var$userAgent.indexOf("Trident/");
var $624ceb5de64d8d6d$var$_familyProxy, $624ceb5de64d8d6d$var$_familyProxy2, $624ceb5de64d8d6d$var$_familyProxy3, $624ceb5de64d8d6d$var$_familyProxy4, $624ceb5de64d8d6d$var$_familyProxy5;
var $624ceb5de64d8d6d$var$NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var $624ceb5de64d8d6d$var$UNITS_IN_GRID = 16;
var $624ceb5de64d8d6d$var$DEFAULT_CSS_PREFIX = "fa";
var $624ceb5de64d8d6d$var$DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var $624ceb5de64d8d6d$var$DATA_FA_I2SVG = "data-fa-i2svg";
var $624ceb5de64d8d6d$var$DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var $624ceb5de64d8d6d$var$DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var $624ceb5de64d8d6d$var$DATA_PREFIX = "data-prefix";
var $624ceb5de64d8d6d$var$DATA_ICON = "data-icon";
var $624ceb5de64d8d6d$var$HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var $624ceb5de64d8d6d$var$MUTATION_APPROACH_ASYNC = "async";
var $624ceb5de64d8d6d$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
];
var $624ceb5de64d8d6d$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $624ceb5de64d8d6d$var$FAMILY_CLASSIC = "classic";
var $624ceb5de64d8d6d$var$FAMILY_SHARP = "sharp";
var $624ceb5de64d8d6d$var$FAMILIES = [
    $624ceb5de64d8d6d$var$FAMILY_CLASSIC,
    $624ceb5de64d8d6d$var$FAMILY_SHARP
];
function $624ceb5de64d8d6d$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get: function get(target, prop) {
            return prop in target ? target[prop] : target[$624ceb5de64d8d6d$var$FAMILY_CLASSIC];
        }
    });
}
var $624ceb5de64d8d6d$var$PREFIX_TO_STYLE = $624ceb5de64d8d6d$var$familyProxy(($624ceb5de64d8d6d$var$_familyProxy = {}, $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_familyProxy, $624ceb5de64d8d6d$var$FAMILY_CLASSIC, {
    "fa": "solid",
    "fas": "solid",
    "fa-solid": "solid",
    "far": "regular",
    "fa-regular": "regular",
    "fal": "light",
    "fa-light": "light",
    "fat": "thin",
    "fa-thin": "thin",
    "fad": "duotone",
    "fa-duotone": "duotone",
    "fab": "brands",
    "fa-brands": "brands",
    "fak": "kit",
    "fakd": "kit",
    "fa-kit": "kit",
    "fa-kit-duotone": "kit"
}), $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_familyProxy, $624ceb5de64d8d6d$var$FAMILY_SHARP, {
    "fa": "solid",
    "fass": "solid",
    "fa-solid": "solid",
    "fasr": "regular",
    "fa-regular": "regular",
    "fasl": "light",
    "fa-light": "light",
    "fast": "thin",
    "fa-thin": "thin"
}), $624ceb5de64d8d6d$var$_familyProxy));
var $624ceb5de64d8d6d$var$STYLE_TO_PREFIX = $624ceb5de64d8d6d$var$familyProxy(($624ceb5de64d8d6d$var$_familyProxy2 = {}, $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_familyProxy2, $624ceb5de64d8d6d$var$FAMILY_CLASSIC, {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    duotone: "fad",
    brands: "fab",
    kit: "fak"
}), $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_familyProxy2, $624ceb5de64d8d6d$var$FAMILY_SHARP, {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
}), $624ceb5de64d8d6d$var$_familyProxy2));
var $624ceb5de64d8d6d$var$PREFIX_TO_LONG_STYLE = $624ceb5de64d8d6d$var$familyProxy(($624ceb5de64d8d6d$var$_familyProxy3 = {}, $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_familyProxy3, $624ceb5de64d8d6d$var$FAMILY_CLASSIC, {
    fab: "fa-brands",
    fad: "fa-duotone",
    fak: "fa-kit",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
}), $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_familyProxy3, $624ceb5de64d8d6d$var$FAMILY_SHARP, {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
}), $624ceb5de64d8d6d$var$_familyProxy3));
var $624ceb5de64d8d6d$var$LONG_STYLE_TO_PREFIX = $624ceb5de64d8d6d$var$familyProxy(($624ceb5de64d8d6d$var$_familyProxy4 = {}, $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_familyProxy4, $624ceb5de64d8d6d$var$FAMILY_CLASSIC, {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-kit": "fak",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
}), $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_familyProxy4, $624ceb5de64d8d6d$var$FAMILY_SHARP, {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
}), $624ceb5de64d8d6d$var$_familyProxy4));
var $624ceb5de64d8d6d$var$ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/; // eslint-disable-line no-useless-escape
var $624ceb5de64d8d6d$var$LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var $624ceb5de64d8d6d$var$FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i;
var $624ceb5de64d8d6d$var$FONT_WEIGHT_TO_PREFIX = $624ceb5de64d8d6d$var$familyProxy(($624ceb5de64d8d6d$var$_familyProxy5 = {}, $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_familyProxy5, $624ceb5de64d8d6d$var$FAMILY_CLASSIC, {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
}), $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_familyProxy5, $624ceb5de64d8d6d$var$FAMILY_SHARP, {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
}), $624ceb5de64d8d6d$var$_familyProxy5));
var $624ceb5de64d8d6d$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $624ceb5de64d8d6d$var$oneToTwenty = $624ceb5de64d8d6d$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $624ceb5de64d8d6d$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
];
var $624ceb5de64d8d6d$var$DUOTONE_CLASSES = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
};
var $624ceb5de64d8d6d$var$prefixes = new Set();
Object.keys($624ceb5de64d8d6d$var$STYLE_TO_PREFIX[$624ceb5de64d8d6d$var$FAMILY_CLASSIC]).map($624ceb5de64d8d6d$var$prefixes.add.bind($624ceb5de64d8d6d$var$prefixes));
Object.keys($624ceb5de64d8d6d$var$STYLE_TO_PREFIX[$624ceb5de64d8d6d$var$FAMILY_SHARP]).map($624ceb5de64d8d6d$var$prefixes.add.bind($624ceb5de64d8d6d$var$prefixes));
var $624ceb5de64d8d6d$var$RESERVED_CLASSES = [].concat($624ceb5de64d8d6d$var$FAMILIES, $624ceb5de64d8d6d$var$_toConsumableArray($624ceb5de64d8d6d$var$prefixes), [
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $624ceb5de64d8d6d$var$DUOTONE_CLASSES.GROUP,
    $624ceb5de64d8d6d$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $624ceb5de64d8d6d$var$DUOTONE_CLASSES.PRIMARY,
    $624ceb5de64d8d6d$var$DUOTONE_CLASSES.SECONDARY
]).concat($624ceb5de64d8d6d$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($624ceb5de64d8d6d$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $624ceb5de64d8d6d$var$initial = $624ceb5de64d8d6d$var$WINDOW.FontAwesomeConfig || {};
function $624ceb5de64d8d6d$var$getAttrConfig(attr) {
    var element = $624ceb5de64d8d6d$var$DOCUMENT.querySelector("script[" + attr + "]");
    if (element) return element.getAttribute(attr);
}
function $624ceb5de64d8d6d$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
}
if ($624ceb5de64d8d6d$var$DOCUMENT && typeof $624ceb5de64d8d6d$var$DOCUMENT.querySelector === "function") {
    var $624ceb5de64d8d6d$var$attrs = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-css-prefix",
            "cssPrefix"
        ],
        [
            "data-family-default",
            "familyDefault"
        ],
        [
            "data-style-default",
            "styleDefault"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    $624ceb5de64d8d6d$var$attrs.forEach(function(_ref) {
        var _ref2 = $624ceb5de64d8d6d$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $624ceb5de64d8d6d$var$coerce($624ceb5de64d8d6d$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $624ceb5de64d8d6d$var$initial[key] = val;
    });
}
var $624ceb5de64d8d6d$var$_default = {
    styleDefault: "solid",
    familyDefault: "classic",
    cssPrefix: $624ceb5de64d8d6d$var$DEFAULT_CSS_PREFIX,
    replacementClass: $624ceb5de64d8d6d$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present
if ($624ceb5de64d8d6d$var$initial.familyPrefix) $624ceb5de64d8d6d$var$initial.cssPrefix = $624ceb5de64d8d6d$var$initial.familyPrefix;
var $624ceb5de64d8d6d$var$_config = $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, $624ceb5de64d8d6d$var$_default), $624ceb5de64d8d6d$var$initial);
if (!$624ceb5de64d8d6d$var$_config.autoReplaceSvg) $624ceb5de64d8d6d$var$_config.observeMutations = false;
var $624ceb5de64d8d6d$var$config = {};
Object.keys($624ceb5de64d8d6d$var$_default).forEach(function(key) {
    Object.defineProperty($624ceb5de64d8d6d$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $624ceb5de64d8d6d$var$_config[key] = val;
            $624ceb5de64d8d6d$var$_onChangeCb.forEach(function(cb) {
                return cb($624ceb5de64d8d6d$var$config);
            });
        },
        get: function get() {
            return $624ceb5de64d8d6d$var$_config[key];
        }
    });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($624ceb5de64d8d6d$var$config, "familyPrefix", {
    enumerable: true,
    set: function set(val) {
        $624ceb5de64d8d6d$var$_config.cssPrefix = val;
        $624ceb5de64d8d6d$var$_onChangeCb.forEach(function(cb) {
            return cb($624ceb5de64d8d6d$var$config);
        });
    },
    get: function get() {
        return $624ceb5de64d8d6d$var$_config.cssPrefix;
    }
});
$624ceb5de64d8d6d$var$WINDOW.FontAwesomeConfig = $624ceb5de64d8d6d$var$config;
var $624ceb5de64d8d6d$var$_onChangeCb = [];
function $624ceb5de64d8d6d$var$onChange(cb) {
    $624ceb5de64d8d6d$var$_onChangeCb.push(cb);
    return function() {
        $624ceb5de64d8d6d$var$_onChangeCb.splice($624ceb5de64d8d6d$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $624ceb5de64d8d6d$var$d = $624ceb5de64d8d6d$var$UNITS_IN_GRID;
var $624ceb5de64d8d6d$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $624ceb5de64d8d6d$var$insertCss(css) {
    if (!css || !$624ceb5de64d8d6d$var$IS_DOM) return;
    var style = $624ceb5de64d8d6d$var$DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    var headChildren = $624ceb5de64d8d6d$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || "").toUpperCase();
        if ([
            "STYLE",
            "LINK"
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $624ceb5de64d8d6d$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $624ceb5de64d8d6d$var$idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function $624ceb5de64d8d6d$var$nextUniqueId() {
    var size = 12;
    var id = "";
    while(size-- > 0)id += $624ceb5de64d8d6d$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $624ceb5de64d8d6d$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $624ceb5de64d8d6d$var$classArray(node) {
    if (node.classList) return $624ceb5de64d8d6d$var$toArray(node.classList);
    else return (node.getAttribute("class") || "").split(" ").filter(function(i) {
        return i;
    });
}
function $624ceb5de64d8d6d$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $624ceb5de64d8d6d$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, '="').concat($624ceb5de64d8d6d$var$htmlEscape(attributes[attributeName]), '" ');
    }, "").trim();
}
function $624ceb5de64d8d6d$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, "");
}
function $624ceb5de64d8d6d$var$transformIsMeaningful(transform) {
    return transform.size !== $624ceb5de64d8d6d$var$meaninglessTransform.size || transform.x !== $624ceb5de64d8d6d$var$meaninglessTransform.x || transform.y !== $624ceb5de64d8d6d$var$meaninglessTransform.y || transform.rotate !== $624ceb5de64d8d6d$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $624ceb5de64d8d6d$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $624ceb5de64d8d6d$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $624ceb5de64d8d6d$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $624ceb5de64d8d6d$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = "";
    if (startCentered && $624ceb5de64d8d6d$var$IS_IE) val += "translate(".concat(transform.x / $624ceb5de64d8d6d$var$d - width / 2, "em, ").concat(transform.y / $624ceb5de64d8d6d$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $624ceb5de64d8d6d$var$d, "em), calc(-50% + ").concat(transform.y / $624ceb5de64d8d6d$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $624ceb5de64d8d6d$var$d, "em, ").concat(transform.y / $624ceb5de64d8d6d$var$d, "em) ");
    val += "scale(".concat(transform.size / $624ceb5de64d8d6d$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $624ceb5de64d8d6d$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $624ceb5de64d8d6d$var$baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-transition-delay: 0s;\n            transition-delay: 0s;\n    -webkit-transition-duration: 0s;\n            transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function $624ceb5de64d8d6d$var$css() {
    var dcp = $624ceb5de64d8d6d$var$DEFAULT_CSS_PREFIX;
    var drc = $624ceb5de64d8d6d$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $624ceb5de64d8d6d$var$config.cssPrefix;
    var rc = $624ceb5de64d8d6d$var$config.replacementClass;
    var s = $624ceb5de64d8d6d$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), "g");
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), "g");
        var rPatt = new RegExp("\\.".concat(drc), "g");
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $624ceb5de64d8d6d$var$_cssInserted = false;
function $624ceb5de64d8d6d$var$ensureCss() {
    if ($624ceb5de64d8d6d$var$config.autoAddCss && !$624ceb5de64d8d6d$var$_cssInserted) {
        $624ceb5de64d8d6d$var$insertCss($624ceb5de64d8d6d$var$css());
        $624ceb5de64d8d6d$var$_cssInserted = true;
    }
}
var $624ceb5de64d8d6d$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $624ceb5de64d8d6d$var$css,
                insertCss: $624ceb5de64d8d6d$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $624ceb5de64d8d6d$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $624ceb5de64d8d6d$var$ensureCss();
            }
        };
    }
};
var $624ceb5de64d8d6d$var$w = $624ceb5de64d8d6d$var$WINDOW || {};
if (!$624ceb5de64d8d6d$var$w[$624ceb5de64d8d6d$var$NAMESPACE_IDENTIFIER]) $624ceb5de64d8d6d$var$w[$624ceb5de64d8d6d$var$NAMESPACE_IDENTIFIER] = {};
if (!$624ceb5de64d8d6d$var$w[$624ceb5de64d8d6d$var$NAMESPACE_IDENTIFIER].styles) $624ceb5de64d8d6d$var$w[$624ceb5de64d8d6d$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$624ceb5de64d8d6d$var$w[$624ceb5de64d8d6d$var$NAMESPACE_IDENTIFIER].hooks) $624ceb5de64d8d6d$var$w[$624ceb5de64d8d6d$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$624ceb5de64d8d6d$var$w[$624ceb5de64d8d6d$var$NAMESPACE_IDENTIFIER].shims) $624ceb5de64d8d6d$var$w[$624ceb5de64d8d6d$var$NAMESPACE_IDENTIFIER].shims = [];
var $624ceb5de64d8d6d$var$namespace = $624ceb5de64d8d6d$var$w[$624ceb5de64d8d6d$var$NAMESPACE_IDENTIFIER];
var $624ceb5de64d8d6d$var$functions = [];
var $624ceb5de64d8d6d$var$listener = function listener() {
    $624ceb5de64d8d6d$var$DOCUMENT.removeEventListener("DOMContentLoaded", listener);
    $624ceb5de64d8d6d$var$loaded = 1;
    $624ceb5de64d8d6d$var$functions.map(function(fn) {
        return fn();
    });
};
var $624ceb5de64d8d6d$var$loaded = false;
if ($624ceb5de64d8d6d$var$IS_DOM) {
    $624ceb5de64d8d6d$var$loaded = ($624ceb5de64d8d6d$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($624ceb5de64d8d6d$var$DOCUMENT.readyState);
    if (!$624ceb5de64d8d6d$var$loaded) $624ceb5de64d8d6d$var$DOCUMENT.addEventListener("DOMContentLoaded", $624ceb5de64d8d6d$var$listener);
}
function $624ceb5de64d8d6d$var$domready(fn) {
    if (!$624ceb5de64d8d6d$var$IS_DOM) return;
    $624ceb5de64d8d6d$var$loaded ? setTimeout(fn, 0) : $624ceb5de64d8d6d$var$functions.push(fn);
}
function $624ceb5de64d8d6d$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === "string") return $624ceb5de64d8d6d$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($624ceb5de64d8d6d$var$joinAttributes(attributes), ">").concat(children.map($624ceb5de64d8d6d$var$toHtml).join(""), "</").concat(tag, ">");
}
function $624ceb5de64d8d6d$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $624ceb5de64d8d6d$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $624ceb5de64d8d6d$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $624ceb5de64d8d6d$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $624ceb5de64d8d6d$var$ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $624ceb5de64d8d6d$var$toHex(unicode) {
    var decoded = $624ceb5de64d8d6d$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $624ceb5de64d8d6d$var$codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $624ceb5de64d8d6d$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $624ceb5de64d8d6d$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $624ceb5de64d8d6d$var$normalizeIcons(icons);
    if (typeof $624ceb5de64d8d6d$var$namespace.hooks.addPack === "function" && !skipHooks) $624ceb5de64d8d6d$var$namespace.hooks.addPack(prefix, $624ceb5de64d8d6d$var$normalizeIcons(icons));
    else $624ceb5de64d8d6d$var$namespace.styles[prefix] = $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, $624ceb5de64d8d6d$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === "fas") $624ceb5de64d8d6d$var$defineIcons("fa", icons);
}
var $624ceb5de64d8d6d$var$duotonePathRe = [
    /*#__PURE__*/ $624ceb5de64d8d6d$var$_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $624ceb5de64d8d6d$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $624ceb5de64d8d6d$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2
    })
];
var $624ceb5de64d8d6d$var$_LONG_STYLE, $624ceb5de64d8d6d$var$_PREFIXES, $624ceb5de64d8d6d$var$_PREFIXES_FOR_FAMILY;
var $624ceb5de64d8d6d$var$styles = $624ceb5de64d8d6d$var$namespace.styles, $624ceb5de64d8d6d$var$shims = $624ceb5de64d8d6d$var$namespace.shims;
var $624ceb5de64d8d6d$var$LONG_STYLE = ($624ceb5de64d8d6d$var$_LONG_STYLE = {}, $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_LONG_STYLE, $624ceb5de64d8d6d$var$FAMILY_CLASSIC, Object.values($624ceb5de64d8d6d$var$PREFIX_TO_LONG_STYLE[$624ceb5de64d8d6d$var$FAMILY_CLASSIC])), $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_LONG_STYLE, $624ceb5de64d8d6d$var$FAMILY_SHARP, Object.values($624ceb5de64d8d6d$var$PREFIX_TO_LONG_STYLE[$624ceb5de64d8d6d$var$FAMILY_SHARP])), $624ceb5de64d8d6d$var$_LONG_STYLE);
var $624ceb5de64d8d6d$var$_defaultUsablePrefix = null;
var $624ceb5de64d8d6d$var$_byUnicode = {};
var $624ceb5de64d8d6d$var$_byLigature = {};
var $624ceb5de64d8d6d$var$_byOldName = {};
var $624ceb5de64d8d6d$var$_byOldUnicode = {};
var $624ceb5de64d8d6d$var$_byAlias = {};
var $624ceb5de64d8d6d$var$PREFIXES = ($624ceb5de64d8d6d$var$_PREFIXES = {}, $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_PREFIXES, $624ceb5de64d8d6d$var$FAMILY_CLASSIC, Object.keys($624ceb5de64d8d6d$var$PREFIX_TO_STYLE[$624ceb5de64d8d6d$var$FAMILY_CLASSIC])), $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_PREFIXES, $624ceb5de64d8d6d$var$FAMILY_SHARP, Object.keys($624ceb5de64d8d6d$var$PREFIX_TO_STYLE[$624ceb5de64d8d6d$var$FAMILY_SHARP])), $624ceb5de64d8d6d$var$_PREFIXES);
function $624ceb5de64d8d6d$var$isReserved(name) {
    return ~$624ceb5de64d8d6d$var$RESERVED_CLASSES.indexOf(name);
}
function $624ceb5de64d8d6d$var$getIconName(cssPrefix, cls) {
    var parts = cls.split("-");
    var prefix = parts[0];
    var iconName = parts.slice(1).join("-");
    if (prefix === cssPrefix && iconName !== "" && !$624ceb5de64d8d6d$var$isReserved(iconName)) return iconName;
    else return null;
}
var $624ceb5de64d8d6d$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $624ceb5de64d8d6d$var$reduce($624ceb5de64d8d6d$var$styles, function(o, style, prefix) {
            o[prefix] = $624ceb5de64d8d6d$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $624ceb5de64d8d6d$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "number";
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $624ceb5de64d8d6d$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "string";
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $624ceb5de64d8d6d$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = "far" in $624ceb5de64d8d6d$var$styles || $624ceb5de64d8d6d$var$config.autoFetchSvg;
    var shimLookups = $624ceb5de64d8d6d$var$reduce($624ceb5de64d8d6d$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === "far" && !hasRegular) prefix = "fas";
        if (typeof maybeNameMaybeUnicode === "string") acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === "number") acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $624ceb5de64d8d6d$var$_byOldName = shimLookups.names;
    $624ceb5de64d8d6d$var$_byOldUnicode = shimLookups.unicodes;
    $624ceb5de64d8d6d$var$_defaultUsablePrefix = $624ceb5de64d8d6d$var$getCanonicalPrefix($624ceb5de64d8d6d$var$config.styleDefault, {
        family: $624ceb5de64d8d6d$var$config.familyDefault
    });
};
$624ceb5de64d8d6d$var$onChange(function(c) {
    $624ceb5de64d8d6d$var$_defaultUsablePrefix = $624ceb5de64d8d6d$var$getCanonicalPrefix(c.styleDefault, {
        family: $624ceb5de64d8d6d$var$config.familyDefault
    });
});
$624ceb5de64d8d6d$var$build();
function $624ceb5de64d8d6d$var$byUnicode(prefix, unicode) {
    return ($624ceb5de64d8d6d$var$_byUnicode[prefix] || {})[unicode];
}
function $624ceb5de64d8d6d$var$byLigature(prefix, ligature) {
    return ($624ceb5de64d8d6d$var$_byLigature[prefix] || {})[ligature];
}
function $624ceb5de64d8d6d$var$byAlias(prefix, alias) {
    return ($624ceb5de64d8d6d$var$_byAlias[prefix] || {})[alias];
}
function $624ceb5de64d8d6d$var$byOldName(name) {
    return $624ceb5de64d8d6d$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $624ceb5de64d8d6d$var$byOldUnicode(unicode) {
    var oldUnicode = $624ceb5de64d8d6d$var$_byOldUnicode[unicode];
    var newUnicode = $624ceb5de64d8d6d$var$byUnicode("fas", unicode);
    return oldUnicode || (newUnicode ? {
        prefix: "fas",
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $624ceb5de64d8d6d$var$getDefaultUsablePrefix() {
    return $624ceb5de64d8d6d$var$_defaultUsablePrefix;
}
var $624ceb5de64d8d6d$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $624ceb5de64d8d6d$var$getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? $624ceb5de64d8d6d$var$FAMILY_CLASSIC : _params$family;
    var style = $624ceb5de64d8d6d$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    var prefix = $624ceb5de64d8d6d$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $624ceb5de64d8d6d$var$STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in $624ceb5de64d8d6d$var$namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
}
var $624ceb5de64d8d6d$var$PREFIXES_FOR_FAMILY = ($624ceb5de64d8d6d$var$_PREFIXES_FOR_FAMILY = {}, $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_PREFIXES_FOR_FAMILY, $624ceb5de64d8d6d$var$FAMILY_CLASSIC, Object.keys($624ceb5de64d8d6d$var$PREFIX_TO_LONG_STYLE[$624ceb5de64d8d6d$var$FAMILY_CLASSIC])), $624ceb5de64d8d6d$var$_defineProperty($624ceb5de64d8d6d$var$_PREFIXES_FOR_FAMILY, $624ceb5de64d8d6d$var$FAMILY_SHARP, Object.keys($624ceb5de64d8d6d$var$PREFIX_TO_LONG_STYLE[$624ceb5de64d8d6d$var$FAMILY_SHARP])), $624ceb5de64d8d6d$var$_PREFIXES_FOR_FAMILY);
function $624ceb5de64d8d6d$var$getCanonicalIcon(values) {
    var _famProps;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var famProps = (_famProps = {}, $624ceb5de64d8d6d$var$_defineProperty(_famProps, $624ceb5de64d8d6d$var$FAMILY_CLASSIC, "".concat($624ceb5de64d8d6d$var$config.cssPrefix, "-").concat($624ceb5de64d8d6d$var$FAMILY_CLASSIC)), $624ceb5de64d8d6d$var$_defineProperty(_famProps, $624ceb5de64d8d6d$var$FAMILY_SHARP, "".concat($624ceb5de64d8d6d$var$config.cssPrefix, "-").concat($624ceb5de64d8d6d$var$FAMILY_SHARP)), _famProps);
    var givenPrefix = null;
    var family = $624ceb5de64d8d6d$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$624ceb5de64d8d6d$var$FAMILY_CLASSIC]) || values.some(function(v) {
        return $624ceb5de64d8d6d$var$PREFIXES_FOR_FAMILY[$624ceb5de64d8d6d$var$FAMILY_CLASSIC].includes(v);
    })) family = $624ceb5de64d8d6d$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$624ceb5de64d8d6d$var$FAMILY_SHARP]) || values.some(function(v) {
        return $624ceb5de64d8d6d$var$PREFIXES_FOR_FAMILY[$624ceb5de64d8d6d$var$FAMILY_SHARP].includes(v);
    })) family = $624ceb5de64d8d6d$var$FAMILY_SHARP;
    var canonical = values.reduce(function(acc, cls) {
        var iconName = $624ceb5de64d8d6d$var$getIconName($624ceb5de64d8d6d$var$config.cssPrefix, cls);
        if ($624ceb5de64d8d6d$var$styles[cls]) {
            cls = $624ceb5de64d8d6d$var$LONG_STYLE[family].includes(cls) ? $624ceb5de64d8d6d$var$LONG_STYLE_TO_PREFIX[family][cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if ($624ceb5de64d8d6d$var$PREFIXES[family].indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = $624ceb5de64d8d6d$var$getCanonicalPrefix(cls, {
                family: family
            });
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== $624ceb5de64d8d6d$var$config.replacementClass && cls !== famProps[$624ceb5de64d8d6d$var$FAMILY_CLASSIC] && cls !== famProps[$624ceb5de64d8d6d$var$FAMILY_SHARP]) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            var shim = givenPrefix === "fa" ? $624ceb5de64d8d6d$var$byOldName(acc.iconName) : {};
            var aliasIconName = $624ceb5de64d8d6d$var$byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === "far" && !$624ceb5de64d8d6d$var$styles["far"] && $624ceb5de64d8d6d$var$styles["fas"] && !$624ceb5de64d8d6d$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = "fas";
        }
        return acc;
    }, $624ceb5de64d8d6d$var$emptyCanonicalIcon());
    if (values.includes("fa-brands") || values.includes("fab")) canonical.prefix = "fab";
    if (values.includes("fa-duotone") || values.includes("fad")) canonical.prefix = "fad";
    if (!canonical.prefix && family === $624ceb5de64d8d6d$var$FAMILY_SHARP && ($624ceb5de64d8d6d$var$styles["fass"] || $624ceb5de64d8d6d$var$config.autoFetchSvg)) {
        canonical.prefix = "fass";
        canonical.iconName = $624ceb5de64d8d6d$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (canonical.prefix === "fa" || givenPrefix === "fa") // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $624ceb5de64d8d6d$var$getDefaultUsablePrefix() || "fas";
    return canonical;
}
var $624ceb5de64d8d6d$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $624ceb5de64d8d6d$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $624ceb5de64d8d6d$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $624ceb5de64d8d6d$var$defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
                    var longPrefix = $624ceb5de64d8d6d$var$PREFIX_TO_LONG_STYLE[$624ceb5de64d8d6d$var$FAMILY_CLASSIC][key];
                    if (longPrefix) $624ceb5de64d8d6d$var$defineIcons(longPrefix, additions[key]);
                    $624ceb5de64d8d6d$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === "string") additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
var $624ceb5de64d8d6d$var$_plugins = [];
var $624ceb5de64d8d6d$var$_hooks = {};
var $624ceb5de64d8d6d$var$providers = {};
var $624ceb5de64d8d6d$var$defaultProviderKeys = Object.keys($624ceb5de64d8d6d$var$providers);
function $624ceb5de64d8d6d$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $624ceb5de64d8d6d$var$_plugins = nextPlugins;
    $624ceb5de64d8d6d$var$_hooks = {};
    Object.keys($624ceb5de64d8d6d$var$providers).forEach(function(k) {
        if ($624ceb5de64d8d6d$var$defaultProviderKeys.indexOf(k) === -1) delete $624ceb5de64d8d6d$var$providers[k];
    });
    $624ceb5de64d8d6d$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === "function") obj[tk] = mixout[tk];
            if ($624ceb5de64d8d6d$var$_typeof(mixout[tk]) === "object") Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$624ceb5de64d8d6d$var$_hooks[hook]) $624ceb5de64d8d6d$var$_hooks[hook] = [];
                $624ceb5de64d8d6d$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($624ceb5de64d8d6d$var$providers);
    });
    return obj;
}
function $624ceb5de64d8d6d$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $624ceb5de64d8d6d$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args)); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $624ceb5de64d8d6d$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $624ceb5de64d8d6d$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $624ceb5de64d8d6d$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $624ceb5de64d8d6d$var$providers[hook] ? $624ceb5de64d8d6d$var$providers[hook].apply(null, args) : undefined;
}
function $624ceb5de64d8d6d$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === "fa") iconLookup.prefix = "fas";
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $624ceb5de64d8d6d$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $624ceb5de64d8d6d$var$byAlias(prefix, iconName) || iconName;
    return $624ceb5de64d8d6d$var$iconFromMapping($624ceb5de64d8d6d$var$library.definitions, prefix, iconName) || $624ceb5de64d8d6d$var$iconFromMapping($624ceb5de64d8d6d$var$namespace.styles, prefix, iconName);
}
var $624ceb5de64d8d6d$var$library = new $624ceb5de64d8d6d$var$Library();
var $624ceb5de64d8d6d$var$noAuto = function noAuto() {
    $624ceb5de64d8d6d$var$config.autoReplaceSvg = false;
    $624ceb5de64d8d6d$var$config.observeMutations = false;
    $624ceb5de64d8d6d$var$callHooks("noAuto");
};
var $624ceb5de64d8d6d$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($624ceb5de64d8d6d$var$IS_DOM) {
            $624ceb5de64d8d6d$var$callHooks("beforeI2svg", params);
            $624ceb5de64d8d6d$var$callProvided("pseudoElements2svg", params);
            return $624ceb5de64d8d6d$var$callProvided("i2svg", params);
        } else return Promise.reject("Operation requires a DOM of some kind.");
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($624ceb5de64d8d6d$var$config.autoReplaceSvg === false) $624ceb5de64d8d6d$var$config.autoReplaceSvg = true;
        $624ceb5de64d8d6d$var$config.observeMutations = true;
        $624ceb5de64d8d6d$var$domready(function() {
            $624ceb5de64d8d6d$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $624ceb5de64d8d6d$var$callHooks("watch", params);
        });
    }
};
var $624ceb5de64d8d6d$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($624ceb5de64d8d6d$var$_typeof(_icon) === "object" && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $624ceb5de64d8d6d$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf("fa-") === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $624ceb5de64d8d6d$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $624ceb5de64d8d6d$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === "string" && (_icon.indexOf("".concat($624ceb5de64d8d6d$var$config.cssPrefix, "-")) > -1 || _icon.match($624ceb5de64d8d6d$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $624ceb5de64d8d6d$var$getCanonicalIcon(_icon.split(" "), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $624ceb5de64d8d6d$var$getDefaultUsablePrefix(),
                iconName: $624ceb5de64d8d6d$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === "string") {
            var _prefix = $624ceb5de64d8d6d$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $624ceb5de64d8d6d$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $624ceb5de64d8d6d$export$644d8ea042df96a6 = {
    noAuto: $624ceb5de64d8d6d$var$noAuto,
    config: $624ceb5de64d8d6d$var$config,
    dom: $624ceb5de64d8d6d$var$dom,
    parse: $624ceb5de64d8d6d$var$parse,
    library: $624ceb5de64d8d6d$var$library,
    findIconDefinition: $624ceb5de64d8d6d$var$findIconDefinition,
    toHtml: $624ceb5de64d8d6d$var$toHtml
};
var $624ceb5de64d8d6d$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $624ceb5de64d8d6d$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($624ceb5de64d8d6d$var$namespace.styles).length > 0 || $624ceb5de64d8d6d$var$config.autoFetchSvg) && $624ceb5de64d8d6d$var$IS_DOM && $624ceb5de64d8d6d$var$config.autoReplaceSvg) $624ceb5de64d8d6d$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $624ceb5de64d8d6d$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, "abstract", {
        get: abstractCreator
    });
    Object.defineProperty(val, "html", {
        get: function get() {
            return val.abstract.map(function(a) {
                return $624ceb5de64d8d6d$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, "node", {
        get: function get() {
            if (!$624ceb5de64d8d6d$var$IS_DOM) return;
            var container = $624ceb5de64d8d6d$var$DOCUMENT.createElement("div");
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $624ceb5de64d8d6d$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($624ceb5de64d8d6d$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes["style"] = $624ceb5de64d8d6d$var$joinStyles($624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, styles), {}, {
            "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: "svg",
            attributes: attributes,
            children: children
        }
    ];
}
function $624ceb5de64d8d6d$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($624ceb5de64d8d6d$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $624ceb5de64d8d6d$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === "fak";
    var attrClass = [
        $624ceb5de64d8d6d$var$config.replacementClass,
        iconName ? "".concat($624ceb5de64d8d6d$var$config.cssPrefix, "-").concat(iconName) : ""
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== "" || !!c;
    }).concat(extra.classes).join(" ");
    var content = {
        children: [],
        attributes: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, extra.attributes), {}, {
            "data-prefix": prefix,
            "data-icon": iconName,
            "class": attrClass,
            "role": extra.attributes.role || "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$624ceb5de64d8d6d$var$DATA_FA_I2SVG] = "";
    if (title) {
        content.children.push({
            tag: "title",
            attributes: {
                id: content.attributes["aria-labelledby"] || "title-".concat(titleId || $624ceb5de64d8d6d$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    var args = $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    var _ref2 = mask.found && main.found ? $624ceb5de64d8d6d$var$callProvided("generateAbstractMask", args) || {
        children: [],
        attributes: {}
    } : $624ceb5de64d8d6d$var$callProvided("generateAbstractIcon", args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $624ceb5de64d8d6d$var$asSymbol(args);
    else return $624ceb5de64d8d6d$var$asIcon(args);
}
function $624ceb5de64d8d6d$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    if (watchable) attributes[$624ceb5de64d8d6d$var$DATA_FA_I2SVG] = "";
    var styles = $624ceb5de64d8d6d$var$_objectSpread2({}, extra.styles);
    if ($624ceb5de64d8d6d$var$transformIsMeaningful(transform)) {
        styles["transform"] = $624ceb5de64d8d6d$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles["-webkit-transform"] = styles["transform"];
    }
    var styleString = $624ceb5de64d8d6d$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
function $624ceb5de64d8d6d$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    var styleString = $624ceb5de64d8d6d$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
var $624ceb5de64d8d6d$var$styles$1 = $624ceb5de64d8d6d$var$namespace.styles;
function $624ceb5de64d8d6d$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $624ceb5de64d8d6d$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: "g",
        attributes: {
            class: "".concat($624ceb5de64d8d6d$var$config.cssPrefix, "-").concat($624ceb5de64d8d6d$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat($624ceb5de64d8d6d$var$config.cssPrefix, "-").concat($624ceb5de64d8d6d$var$DUOTONE_CLASSES.SECONDARY),
                    fill: "currentColor",
                    d: vectorData[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat($624ceb5de64d8d6d$var$config.cssPrefix, "-").concat($624ceb5de64d8d6d$var$DUOTONE_CLASSES.PRIMARY),
                    fill: "currentColor",
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $624ceb5de64d8d6d$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $624ceb5de64d8d6d$var$maybeNotifyMissing(iconName, prefix) {
    if (!$624ceb5de64d8d6d$var$PRODUCTION && !$624ceb5de64d8d6d$var$config.showMissingIcons && iconName) console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix, '" is missing.'));
}
function $624ceb5de64d8d6d$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === "fa" && $624ceb5de64d8d6d$var$config.styleDefault !== null) prefix = $624ceb5de64d8d6d$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $624ceb5de64d8d6d$var$callProvided("missingIconAbstract") || {}
        };
        if (givenPrefix === "fa") {
            var shim = $624ceb5de64d8d6d$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $624ceb5de64d8d6d$var$styles$1[prefix] && $624ceb5de64d8d6d$var$styles$1[prefix][iconName]) {
            var icon = $624ceb5de64d8d6d$var$styles$1[prefix][iconName];
            return resolve($624ceb5de64d8d6d$var$asFoundIcon(icon));
        }
        $624ceb5de64d8d6d$var$maybeNotifyMissing(iconName, prefix);
        resolve($624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, $624ceb5de64d8d6d$var$missingIconResolutionMixin), {}, {
            icon: $624ceb5de64d8d6d$var$config.showMissingIcons && iconName ? $624ceb5de64d8d6d$var$callProvided("missingIconAbstract") || {} : {}
        }));
    });
}
var $624ceb5de64d8d6d$var$noop$1 = function noop() {};
var $624ceb5de64d8d6d$var$p = $624ceb5de64d8d6d$var$config.measurePerformance && $624ceb5de64d8d6d$var$PERFORMANCE && $624ceb5de64d8d6d$var$PERFORMANCE.mark && $624ceb5de64d8d6d$var$PERFORMANCE.measure ? $624ceb5de64d8d6d$var$PERFORMANCE : {
    mark: $624ceb5de64d8d6d$var$noop$1,
    measure: $624ceb5de64d8d6d$var$noop$1
};
var $624ceb5de64d8d6d$var$preamble = 'FA "6.5.1"';
var $624ceb5de64d8d6d$var$begin = function begin(name) {
    $624ceb5de64d8d6d$var$p.mark("".concat($624ceb5de64d8d6d$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $624ceb5de64d8d6d$var$end(name);
    };
};
var $624ceb5de64d8d6d$var$end = function end(name) {
    $624ceb5de64d8d6d$var$p.mark("".concat($624ceb5de64d8d6d$var$preamble, " ").concat(name, " ends"));
    $624ceb5de64d8d6d$var$p.measure("".concat($624ceb5de64d8d6d$var$preamble, " ").concat(name), "".concat($624ceb5de64d8d6d$var$preamble, " ").concat(name, " begins"), "".concat($624ceb5de64d8d6d$var$preamble, " ").concat(name, " ends"));
};
var $624ceb5de64d8d6d$var$perf = {
    begin: $624ceb5de64d8d6d$var$begin,
    end: $624ceb5de64d8d6d$var$end
};
var $624ceb5de64d8d6d$var$noop$2 = function noop() {};
function $624ceb5de64d8d6d$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($624ceb5de64d8d6d$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === "string";
}
function $624ceb5de64d8d6d$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($624ceb5de64d8d6d$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($624ceb5de64d8d6d$var$DATA_ICON) : null;
    return prefix && icon;
}
function $624ceb5de64d8d6d$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($624ceb5de64d8d6d$var$config.replacementClass);
}
function $624ceb5de64d8d6d$var$getMutator() {
    if ($624ceb5de64d8d6d$var$config.autoReplaceSvg === true) return $624ceb5de64d8d6d$var$mutators.replace;
    var mutator = $624ceb5de64d8d6d$var$mutators[$624ceb5de64d8d6d$var$config.autoReplaceSvg];
    return mutator || $624ceb5de64d8d6d$var$mutators.replace;
}
function $624ceb5de64d8d6d$var$createElementNS(tag) {
    return $624ceb5de64d8d6d$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function $624ceb5de64d8d6d$var$createElement(tag) {
    return $624ceb5de64d8d6d$var$DOCUMENT.createElement(tag);
}
function $624ceb5de64d8d6d$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === "svg" ? $624ceb5de64d8d6d$var$createElementNS : $624ceb5de64d8d6d$var$createElement : _params$ceFn;
    if (typeof abstractObj === "string") return $624ceb5de64d8d6d$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($624ceb5de64d8d6d$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $624ceb5de64d8d6d$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $624ceb5de64d8d6d$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(_abstract) {
                node.parentNode.insertBefore($624ceb5de64d8d6d$var$convertSVG(_abstract), node);
            });
            if (node.getAttribute($624ceb5de64d8d6d$var$DATA_FA_I2SVG) === null && $624ceb5de64d8d6d$var$config.keepOriginalSource) {
                var comment = $624ceb5de64d8d6d$var$DOCUMENT.createComment($624ceb5de64d8d6d$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var _abstract2 = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$624ceb5de64d8d6d$var$classArray(node).indexOf($624ceb5de64d8d6d$var$config.replacementClass)) return $624ceb5de64d8d6d$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($624ceb5de64d8d6d$var$config.cssPrefix, "-.*"));
        delete _abstract2[0].attributes.id;
        if (_abstract2[0].attributes.class) {
            var splitClasses = _abstract2[0].attributes.class.split(" ").reduce(function(acc, cls) {
                if (cls === $624ceb5de64d8d6d$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            _abstract2[0].attributes.class = splitClasses.toSvg.join(" ");
            if (splitClasses.toNode.length === 0) node.removeAttribute("class");
            else node.setAttribute("class", splitClasses.toNode.join(" "));
        }
        var newInnerHTML = _abstract2.map(function(a) {
            return $624ceb5de64d8d6d$var$toHtml(a);
        }).join("\n");
        node.setAttribute($624ceb5de64d8d6d$var$DATA_FA_I2SVG, "");
        node.innerHTML = newInnerHTML;
    }
};
function $624ceb5de64d8d6d$var$performOperationSync(op) {
    op();
}
function $624ceb5de64d8d6d$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === "function" ? callback : $624ceb5de64d8d6d$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $624ceb5de64d8d6d$var$performOperationSync;
        if ($624ceb5de64d8d6d$var$config.mutateApproach === $624ceb5de64d8d6d$var$MUTATION_APPROACH_ASYNC) frame = $624ceb5de64d8d6d$var$WINDOW.requestAnimationFrame || $624ceb5de64d8d6d$var$performOperationSync;
        frame(function() {
            var mutator = $624ceb5de64d8d6d$var$getMutator();
            var mark = $624ceb5de64d8d6d$var$perf.begin("mutate");
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $624ceb5de64d8d6d$var$disabled = false;
function $624ceb5de64d8d6d$var$disableObservation() {
    $624ceb5de64d8d6d$var$disabled = true;
}
function $624ceb5de64d8d6d$var$enableObservation() {
    $624ceb5de64d8d6d$var$disabled = false;
}
var $624ceb5de64d8d6d$var$mo = null;
function $624ceb5de64d8d6d$var$observe(options) {
    if (!$624ceb5de64d8d6d$var$MUTATION_OBSERVER) return;
    if (!$624ceb5de64d8d6d$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $624ceb5de64d8d6d$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $624ceb5de64d8d6d$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $624ceb5de64d8d6d$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $624ceb5de64d8d6d$var$DOCUMENT : _options$observeMutat;
    $624ceb5de64d8d6d$var$mo = new $624ceb5de64d8d6d$var$MUTATION_OBSERVER(function(objects) {
        if ($624ceb5de64d8d6d$var$disabled) return;
        var defaultPrefix = $624ceb5de64d8d6d$var$getDefaultUsablePrefix();
        $624ceb5de64d8d6d$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !$624ceb5de64d8d6d$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($624ceb5de64d8d6d$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && $624ceb5de64d8d6d$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === "attributes" && $624ceb5de64d8d6d$var$isWatched(mutationRecord.target) && ~$624ceb5de64d8d6d$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === "class" && $624ceb5de64d8d6d$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $624ceb5de64d8d6d$var$getCanonicalIcon($624ceb5de64d8d6d$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($624ceb5de64d8d6d$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($624ceb5de64d8d6d$var$DATA_ICON, iconName);
                } else if ($624ceb5de64d8d6d$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$624ceb5de64d8d6d$var$IS_DOM) return;
    $624ceb5de64d8d6d$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $624ceb5de64d8d6d$var$disconnect() {
    if (!$624ceb5de64d8d6d$var$mo) return;
    $624ceb5de64d8d6d$var$mo.disconnect();
}
function $624ceb5de64d8d6d$var$styleParser(node) {
    var style = node.getAttribute("style");
    var val = [];
    if (style) val = style.split(";").reduce(function(acc, style) {
        var styles = style.split(":");
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(":").trim();
        return acc;
    }, {});
    return val;
}
function $624ceb5de64d8d6d$var$classParser(node) {
    var existingPrefix = node.getAttribute("data-prefix");
    var existingIconName = node.getAttribute("data-icon");
    var innerText = node.innerText !== undefined ? node.innerText.trim() : "";
    var val = $624ceb5de64d8d6d$var$getCanonicalIcon($624ceb5de64d8d6d$var$classArray(node));
    if (!val.prefix) val.prefix = $624ceb5de64d8d6d$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $624ceb5de64d8d6d$var$byLigature(val.prefix, node.innerText) || $624ceb5de64d8d6d$var$byUnicode(val.prefix, $624ceb5de64d8d6d$var$toHex(node.innerText));
    if (!val.iconName && $624ceb5de64d8d6d$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $624ceb5de64d8d6d$var$attributesParser(node) {
    var extraAttributes = $624ceb5de64d8d6d$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== "class" && acc.name !== "style") acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute("title");
    var titleId = node.getAttribute("data-fa-title-id");
    if ($624ceb5de64d8d6d$var$config.autoA11y) {
        if (title) extraAttributes["aria-labelledby"] = "".concat($624ceb5de64d8d6d$var$config.replacementClass, "-title-").concat(titleId || $624ceb5de64d8d6d$var$nextUniqueId());
        else {
            extraAttributes["aria-hidden"] = "true";
            extraAttributes["focusable"] = "false";
        }
    }
    return extraAttributes;
}
function $624ceb5de64d8d6d$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $624ceb5de64d8d6d$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $624ceb5de64d8d6d$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $624ceb5de64d8d6d$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $624ceb5de64d8d6d$var$attributesParser(node);
    var pluginMeta = $624ceb5de64d8d6d$var$chainHooks("parseNodeAttributes", {}, node);
    var extraStyles = parser.styleParser ? $624ceb5de64d8d6d$var$styleParser(node) : [];
    return $624ceb5de64d8d6d$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute("title"),
        titleId: node.getAttribute("data-fa-title-id"),
        prefix: prefix,
        transform: $624ceb5de64d8d6d$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $624ceb5de64d8d6d$var$styles$2 = $624ceb5de64d8d6d$var$namespace.styles;
function $624ceb5de64d8d6d$var$generateMutation(node) {
    var nodeMeta = $624ceb5de64d8d6d$var$config.autoReplaceSvg === "nest" ? $624ceb5de64d8d6d$var$parseMeta(node, {
        styleParser: false
    }) : $624ceb5de64d8d6d$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($624ceb5de64d8d6d$var$LAYERS_TEXT_CLASSNAME)) return $624ceb5de64d8d6d$var$callProvided("generateLayersText", node, nodeMeta);
    else return $624ceb5de64d8d6d$var$callProvided("generateSvgReplacementMutation", node, nodeMeta);
}
var $624ceb5de64d8d6d$var$knownPrefixes = new Set();
$624ceb5de64d8d6d$var$FAMILIES.map(function(family) {
    $624ceb5de64d8d6d$var$knownPrefixes.add("fa-".concat(family));
});
Object.keys($624ceb5de64d8d6d$var$PREFIX_TO_STYLE[$624ceb5de64d8d6d$var$FAMILY_CLASSIC]).map($624ceb5de64d8d6d$var$knownPrefixes.add.bind($624ceb5de64d8d6d$var$knownPrefixes));
Object.keys($624ceb5de64d8d6d$var$PREFIX_TO_STYLE[$624ceb5de64d8d6d$var$FAMILY_SHARP]).map($624ceb5de64d8d6d$var$knownPrefixes.add.bind($624ceb5de64d8d6d$var$knownPrefixes));
$624ceb5de64d8d6d$var$knownPrefixes = $624ceb5de64d8d6d$var$_toConsumableArray($624ceb5de64d8d6d$var$knownPrefixes);
function $624ceb5de64d8d6d$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$624ceb5de64d8d6d$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $624ceb5de64d8d6d$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($624ceb5de64d8d6d$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($624ceb5de64d8d6d$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $624ceb5de64d8d6d$var$config.autoFetchSvg ? $624ceb5de64d8d6d$var$knownPrefixes : $624ceb5de64d8d6d$var$FAMILIES.map(function(f) {
        return "fa-".concat(f);
    }).concat(Object.keys($624ceb5de64d8d6d$var$styles$2));
    if (!prefixes.includes("fa")) prefixes.push("fa");
    var prefixesDomQuery = [
        ".".concat($624ceb5de64d8d6d$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($624ceb5de64d8d6d$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($624ceb5de64d8d6d$var$DATA_FA_I2SVG, "])");
    })).join(", ");
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $624ceb5de64d8d6d$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd("pending");
        hclRemove("complete");
    } else return Promise.resolve();
    var mark = $624ceb5de64d8d6d$var$perf.begin("onTree");
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $624ceb5de64d8d6d$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$624ceb5de64d8d6d$var$PRODUCTION) {
                if (e.name === "MissingIcon") console.error(e);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $624ceb5de64d8d6d$var$perform(resolvedMutations, function() {
                hclAdd("active");
                hclAdd("complete");
                hclRemove("pending");
                if (typeof callback === "function") callback();
                mark();
                resolve();
            });
        }).catch(function(e) {
            mark();
            reject(e);
        });
    });
}
function $624ceb5de64d8d6d$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $624ceb5de64d8d6d$var$generateMutation(node).then(function(mutation) {
        if (mutation) $624ceb5de64d8d6d$var$perform([
            mutation
        ], callback);
    });
}
function $624ceb5de64d8d6d$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $624ceb5de64d8d6d$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $624ceb5de64d8d6d$var$findIconDefinition(mask || {});
        return next(iconDefinition, $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $624ceb5de64d8d6d$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $624ceb5de64d8d6d$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $624ceb5de64d8d6d$var$domVariants($624ceb5de64d8d6d$var$_objectSpread2({
        type: "icon"
    }, iconDefinition), function() {
        $624ceb5de64d8d6d$var$callHooks("beforeDOMElementCreation", {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($624ceb5de64d8d6d$var$config.autoA11y) {
            if (title) attributes["aria-labelledby"] = "".concat($624ceb5de64d8d6d$var$config.replacementClass, "-title-").concat(titleId || $624ceb5de64d8d6d$var$nextUniqueId());
            else {
                attributes["aria-hidden"] = "true";
                attributes["focusable"] = "false";
            }
        }
        return $624ceb5de64d8d6d$var$makeInlineSvgAbstract({
            icons: {
                main: $624ceb5de64d8d6d$var$asFoundIcon(icon),
                mask: mask ? $624ceb5de64d8d6d$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, $624ceb5de64d8d6d$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $624ceb5de64d8d6d$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $624ceb5de64d8d6d$var$resolveIcons($624ceb5de64d8d6d$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $624ceb5de64d8d6d$var$onTree;
                accumulator.nodeCallback = $624ceb5de64d8d6d$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $624ceb5de64d8d6d$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            return $624ceb5de64d8d6d$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $624ceb5de64d8d6d$var$findIcon(iconName, prefix),
                    mask.iconName ? $624ceb5de64d8d6d$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $624ceb5de64d8d6d$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $624ceb5de64d8d6d$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $624ceb5de64d8d6d$var$joinStyles(styles);
            if (styleString.length > 0) attributes["style"] = styleString;
            var nextChild;
            if ($624ceb5de64d8d6d$var$transformIsMeaningful(transform)) nextChild = $624ceb5de64d8d6d$var$callProvided("generateAbstractTransformGrouping", {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $624ceb5de64d8d6d$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $624ceb5de64d8d6d$var$domVariants({
                    type: "layer"
                }, function() {
                    $624ceb5de64d8d6d$var$callHooks("beforeDOMElementCreation", {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: "span",
                            attributes: {
                                class: [
                                    "".concat($624ceb5de64d8d6d$var$config.cssPrefix, "-layers")
                                ].concat($624ceb5de64d8d6d$var$_toConsumableArray(classes)).join(" ")
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $624ceb5de64d8d6d$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $624ceb5de64d8d6d$var$domVariants({
                    type: "counter",
                    content: content
                }, function() {
                    $624ceb5de64d8d6d$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $624ceb5de64d8d6d$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($624ceb5de64d8d6d$var$config.cssPrefix, "-layers-counter")
                            ].concat($624ceb5de64d8d6d$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $624ceb5de64d8d6d$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $624ceb5de64d8d6d$var$meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $624ceb5de64d8d6d$var$domVariants({
                    type: "text",
                    content: content
                }, function() {
                    $624ceb5de64d8d6d$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $624ceb5de64d8d6d$var$makeLayersTextAbstract({
                        content: content,
                        transform: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, $624ceb5de64d8d6d$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($624ceb5de64d8d6d$var$config.cssPrefix, "-layers-text")
                            ].concat($624ceb5de64d8d6d$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($624ceb5de64d8d6d$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($624ceb5de64d8d6d$var$config.autoA11y && !title) extra.attributes["aria-hidden"] = "true";
            return Promise.resolve([
                node,
                $624ceb5de64d8d6d$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $624ceb5de64d8d6d$var$CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
var $624ceb5de64d8d6d$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
function $624ceb5de64d8d6d$var$hexValueFromContent(content) {
    var cleaned = content.replace($624ceb5de64d8d6d$var$CLEAN_CONTENT_PATTERN, "");
    var codePoint = $624ceb5de64d8d6d$var$codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= $624ceb5de64d8d6d$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $624ceb5de64d8d6d$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $624ceb5de64d8d6d$var$toHex(cleaned[0]) : $624ceb5de64d8d6d$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $624ceb5de64d8d6d$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($624ceb5de64d8d6d$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $624ceb5de64d8d6d$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($624ceb5de64d8d6d$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $624ceb5de64d8d6d$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue("font-family").match($624ceb5de64d8d6d$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue("font-weight");
        var content = styles.getPropertyValue("content");
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== "none" && content !== "") {
            var _content = styles.getPropertyValue("content");
            var family = ~[
                "Sharp"
            ].indexOf(fontFamily[2]) ? $624ceb5de64d8d6d$var$FAMILY_SHARP : $624ceb5de64d8d6d$var$FAMILY_CLASSIC;
            var prefix = ~[
                "Solid",
                "Regular",
                "Light",
                "Thin",
                "Duotone",
                "Brands",
                "Kit"
            ].indexOf(fontFamily[2]) ? $624ceb5de64d8d6d$var$STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : $624ceb5de64d8d6d$var$FONT_WEIGHT_TO_PREFIX[family][fontWeight];
            var _hexValueFromContent = $624ceb5de64d8d6d$var$hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
            var isV4 = fontFamily[0].startsWith("FontAwesome");
            var iconName = $624ceb5de64d8d6d$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $624ceb5de64d8d6d$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($624ceb5de64d8d6d$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($624ceb5de64d8d6d$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $624ceb5de64d8d6d$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$624ceb5de64d8d6d$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $624ceb5de64d8d6d$var$findIcon(iconName, prefix).then(function(main) {
                    var _abstract = $624ceb5de64d8d6d$var$makeInlineSvgAbstract($624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $624ceb5de64d8d6d$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $624ceb5de64d8d6d$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", "svg");
                    if (position === "::before") node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = _abstract.map(function(a) {
                        return $624ceb5de64d8d6d$var$toHtml(a);
                    }).join("\n");
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $624ceb5de64d8d6d$var$replace(node) {
    return Promise.all([
        $624ceb5de64d8d6d$var$replaceForPosition(node, "::before"),
        $624ceb5de64d8d6d$var$replaceForPosition(node, "::after")
    ]);
}
function $624ceb5de64d8d6d$var$processable(node) {
    return node.parentNode !== document.head && !~$624ceb5de64d8d6d$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($624ceb5de64d8d6d$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function $624ceb5de64d8d6d$var$searchPseudoElements(root) {
    if (!$624ceb5de64d8d6d$var$IS_DOM) return;
    return new Promise(function(resolve, reject) {
        var operations = $624ceb5de64d8d6d$var$toArray(root.querySelectorAll("*")).filter($624ceb5de64d8d6d$var$processable).map($624ceb5de64d8d6d$var$replace);
        var end = $624ceb5de64d8d6d$var$perf.begin("searchPseudoElements");
        $624ceb5de64d8d6d$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $624ceb5de64d8d6d$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $624ceb5de64d8d6d$var$enableObservation();
            reject();
        });
    });
}
var $624ceb5de64d8d6d$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $624ceb5de64d8d6d$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $624ceb5de64d8d6d$var$DOCUMENT : _params$node;
            if ($624ceb5de64d8d6d$var$config.searchPseudoElements) $624ceb5de64d8d6d$var$searchPseudoElements(node);
        };
    }
};
var $624ceb5de64d8d6d$var$_unwatched = false;
var $624ceb5de64d8d6d$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $624ceb5de64d8d6d$var$disableObservation();
                    $624ceb5de64d8d6d$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $624ceb5de64d8d6d$var$observe($624ceb5de64d8d6d$var$chainHooks("mutationObserverCallbacks", {}));
            },
            noAuto: function noAuto() {
                $624ceb5de64d8d6d$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($624ceb5de64d8d6d$var$_unwatched) $624ceb5de64d8d6d$var$enableObservation();
                else $624ceb5de64d8d6d$var$observe($624ceb5de64d8d6d$var$chainHooks("mutationObserverCallbacks", {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $624ceb5de64d8d6d$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(" ").reduce(function(acc, n) {
        var parts = n.toLowerCase().split("-");
        var first = parts[0];
        var rest = parts.slice(1).join("-");
        if (first && rest === "h") {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === "v") {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case "grow":
                acc.size = acc.size + rest;
                break;
            case "shrink":
                acc.size = acc.size - rest;
                break;
            case "left":
                acc.x = acc.x - rest;
                break;
            case "right":
                acc.x = acc.x + rest;
                break;
            case "up":
                acc.y = acc.y - rest;
                break;
            case "down":
                acc.y = acc.y + rest;
                break;
            case "rotate":
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $624ceb5de64d8d6d$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $624ceb5de64d8d6d$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute("data-fa-transform");
                if (transformString) accumulator.transform = $624ceb5de64d8d6d$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: "g",
                attributes: $624ceb5de64d8d6d$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: "g",
                        attributes: $624ceb5de64d8d6d$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $624ceb5de64d8d6d$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function $624ceb5de64d8d6d$var$fillBlack(_abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (_abstract.attributes && (_abstract.attributes.fill || force)) _abstract.attributes.fill = "black";
    return _abstract;
}
function $624ceb5de64d8d6d$var$deGroup(_abstract2) {
    if (_abstract2.tag === "g") return _abstract2.children;
    else return [
        _abstract2
    ];
}
var $624ceb5de64d8d6d$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute("data-fa-mask");
                var mask = !maskData ? $624ceb5de64d8d6d$var$emptyCanonicalIcon() : $624ceb5de64d8d6d$var$getCanonicalIcon(maskData.split(" ").map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $624ceb5de64d8d6d$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute("data-fa-mask-id");
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $624ceb5de64d8d6d$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: "rect",
                attributes: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, $624ceb5de64d8d6d$var$ALL_SPACE), {}, {
                    fill: "white"
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($624ceb5de64d8d6d$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: "g",
                attributes: $624ceb5de64d8d6d$var$_objectSpread2({}, trans.inner),
                children: [
                    $624ceb5de64d8d6d$var$fillBlack($624ceb5de64d8d6d$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: "g",
                attributes: $624ceb5de64d8d6d$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $624ceb5de64d8d6d$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $624ceb5de64d8d6d$var$nextUniqueId());
            var maskTag = {
                tag: "mask",
                attributes: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, $624ceb5de64d8d6d$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: "userSpaceOnUse",
                    maskContentUnits: "userSpaceOnUse"
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: "defs",
                children: [
                    {
                        tag: "clipPath",
                        attributes: {
                            id: clipId
                        },
                        children: $624ceb5de64d8d6d$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: "rect",
                attributes: $624ceb5de64d8d6d$var$_objectSpread2({
                    fill: "currentColor",
                    "clip-path": "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $624ceb5de64d8d6d$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $624ceb5de64d8d6d$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($624ceb5de64d8d6d$var$WINDOW.matchMedia) reduceMotion = $624ceb5de64d8d6d$var$WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: "currentColor"
            };
            var ANIMATION_BASE = {
                attributeType: "XML",
                repeatCount: "indefinite",
                dur: "2s"
            }; // Ring
            gChildren.push({
                tag: "path",
                attributes: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, FILL), {}, {
                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                })
            });
            var OPACITY_ANIMATE = $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: "opacity"
            });
            var dot = {
                tag: "circle",
                attributes: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, FILL), {}, {
                    cx: "256",
                    cy: "364",
                    r: "28"
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: "animate",
                attributes: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: "r",
                    values: "28;14;28;28;14;28;"
                })
            }, {
                tag: "animate",
                attributes: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: "1;0;1;1;0;1;"
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: "path",
                attributes: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, FILL), {}, {
                    opacity: "1",
                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: "animate",
                        attributes: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "1;0;0;0;0;1;"
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: "path",
                attributes: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, FILL), {}, {
                    opacity: "0",
                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                }),
                children: [
                    {
                        tag: "animate",
                        attributes: $624ceb5de64d8d6d$var$_objectSpread2($624ceb5de64d8d6d$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "0;0;1;1;0;0;"
                        })
                    }
                ]
            });
            return {
                tag: "g",
                attributes: {
                    "class": "missing"
                },
                children: gChildren
            };
        };
    }
};
var $624ceb5de64d8d6d$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute("data-fa-symbol");
                var symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
                accumulator["symbol"] = symbol;
                return accumulator;
            }
        };
    }
};
var $624ceb5de64d8d6d$var$plugins = [
    $624ceb5de64d8d6d$var$InjectCSS,
    $624ceb5de64d8d6d$var$ReplaceElements,
    $624ceb5de64d8d6d$var$Layers,
    $624ceb5de64d8d6d$var$LayersCounter,
    $624ceb5de64d8d6d$var$LayersText,
    $624ceb5de64d8d6d$var$PseudoElements,
    $624ceb5de64d8d6d$var$MutationObserver$1,
    $624ceb5de64d8d6d$var$PowerTransforms,
    $624ceb5de64d8d6d$var$Masks,
    $624ceb5de64d8d6d$var$MissingIconIndicator,
    $624ceb5de64d8d6d$var$SvgSymbols
];
$624ceb5de64d8d6d$var$registerPlugins($624ceb5de64d8d6d$var$plugins, {
    mixoutsTo: $624ceb5de64d8d6d$export$644d8ea042df96a6
});
var $624ceb5de64d8d6d$export$4f8e844b2782642c = $624ceb5de64d8d6d$export$644d8ea042df96a6.noAuto;
var $624ceb5de64d8d6d$export$e506a1d27d1eaa20 = $624ceb5de64d8d6d$export$644d8ea042df96a6.config;
var $624ceb5de64d8d6d$export$b839f963c7dc0e34 = $624ceb5de64d8d6d$export$644d8ea042df96a6.library;
var $624ceb5de64d8d6d$export$df3a06d6289f983e = $624ceb5de64d8d6d$export$644d8ea042df96a6.dom;
var $624ceb5de64d8d6d$export$98e6a39c04603d36 = $624ceb5de64d8d6d$export$644d8ea042df96a6.parse;
var $624ceb5de64d8d6d$export$221fed4a47f597a5 = $624ceb5de64d8d6d$export$644d8ea042df96a6.findIconDefinition;
var $624ceb5de64d8d6d$export$a10125c086a4df16 = $624ceb5de64d8d6d$export$644d8ea042df96a6.toHtml;
var $624ceb5de64d8d6d$export$1ca1ec8b29a4ce27 = $624ceb5de64d8d6d$export$644d8ea042df96a6.icon;
var $624ceb5de64d8d6d$export$50a222d9023da98b = $624ceb5de64d8d6d$export$644d8ea042df96a6.layer;
var $624ceb5de64d8d6d$export$6f093cfa640b7166 = $624ceb5de64d8d6d$export$644d8ea042df96a6.text;
var $624ceb5de64d8d6d$export$e575061ef2a070eb = $624ceb5de64d8d6d$export$644d8ea042df96a6.counter;



var $fmSD5 = parcelRequire("fmSD5");

var $4DE7A = parcelRequire("4DE7A");
function $ca2ffd1693af9883$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ca2ffd1693af9883$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ca2ffd1693af9883$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ca2ffd1693af9883$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ca2ffd1693af9883$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ca2ffd1693af9883$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ca2ffd1693af9883$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ca2ffd1693af9883$var$_typeof(obj);
}
function $ca2ffd1693af9883$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ca2ffd1693af9883$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ca2ffd1693af9883$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ca2ffd1693af9883$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ca2ffd1693af9883$var$_toConsumableArray(arr) {
    return $ca2ffd1693af9883$var$_arrayWithoutHoles(arr) || $ca2ffd1693af9883$var$_iterableToArray(arr) || $ca2ffd1693af9883$var$_unsupportedIterableToArray(arr) || $ca2ffd1693af9883$var$_nonIterableSpread();
}
function $ca2ffd1693af9883$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ca2ffd1693af9883$var$_arrayLikeToArray(arr);
}
function $ca2ffd1693af9883$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ca2ffd1693af9883$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ca2ffd1693af9883$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ca2ffd1693af9883$var$_arrayLikeToArray(o, minLen);
}
function $ca2ffd1693af9883$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ca2ffd1693af9883$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// Get CSS class list from a props object
function $ca2ffd1693af9883$var$classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        "fa-beat": beat,
        "fa-fade": fade,
        "fa-beat-fade": beatFade,
        "fa-bounce": bounce,
        "fa-shake": shake,
        "fa-flash": flash,
        "fa-spin": spin,
        "fa-spin-reverse": spinReverse,
        "fa-spin-pulse": spinPulse,
        "fa-pulse": pulse,
        "fa-fw": fixedWidth,
        "fa-inverse": inverse,
        "fa-border": border,
        "fa-li": listItem,
        "fa-flip": flip === true,
        "fa-flip-horizontal": flip === "horizontal" || flip === "both",
        "fa-flip-vertical": flip === "vertical" || flip === "both"
    }, $ca2ffd1693af9883$var$_defineProperty(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), $ca2ffd1693af9883$var$_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), $ca2ffd1693af9883$var$_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), $ca2ffd1693af9883$var$_defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function $ca2ffd1693af9883$var$_isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function $ca2ffd1693af9883$var$camelize(string) {
    if ($ca2ffd1693af9883$var$_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : "";
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var $ca2ffd1693af9883$var$_excluded = [
    "style"
];
function $ca2ffd1693af9883$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function $ca2ffd1693af9883$var$styleToObject(style) {
    return style.split(";").map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(":");
        var prop = $ca2ffd1693af9883$var$camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith("webkit") ? acc[$ca2ffd1693af9883$var$capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function $ca2ffd1693af9883$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === "string") return element;
    var children = (element.children || []).map(function(child) {
        return $ca2ffd1693af9883$var$convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case "class":
                acc.attrs["className"] = val;
                delete element.attributes["class"];
                break;
            case "style":
                acc.attrs["style"] = $ca2ffd1693af9883$var$styleToObject(val);
                break;
            default:
                if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[$ca2ffd1693af9883$var$camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = $ca2ffd1693af9883$var$_objectWithoutProperties(extraProps, $ca2ffd1693af9883$var$_excluded);
    mixins.attrs["style"] = $ca2ffd1693af9883$var$_objectSpread2($ca2ffd1693af9883$var$_objectSpread2({}, mixins.attrs["style"]), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        $ca2ffd1693af9883$var$_objectSpread2($ca2ffd1693af9883$var$_objectSpread2({}, mixins.attrs), remaining)
    ].concat($ca2ffd1693af9883$var$_toConsumableArray(children)));
}
var $ca2ffd1693af9883$var$PRODUCTION = false;
try {
    $ca2ffd1693af9883$var$PRODUCTION = true;
} catch (e) {}
function $ca2ffd1693af9883$var$log() {
    if (!$ca2ffd1693af9883$var$PRODUCTION && console && typeof console.error === "function") {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function $ca2ffd1693af9883$var$normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && $ca2ffd1693af9883$var$_typeof(icon) === "object" && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, $624ceb5de64d8d6d$export$98e6a39c04603d36).icon) return (0, $624ceb5de64d8d6d$export$98e6a39c04603d36).icon(icon);
     // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if (icon && $ca2ffd1693af9883$var$_typeof(icon) === "object" && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === "string") return {
        prefix: "fas",
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function $ca2ffd1693af9883$var$objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $ca2ffd1693af9883$var$_defineProperty({}, key, value) : {};
}
var $ca2ffd1693af9883$export$2b9260d4a45c8710 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).forwardRef(function(props, ref) {
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = $ca2ffd1693af9883$var$normalizeIconArgs(iconArgs);
    var classes = $ca2ffd1693af9883$var$objectWithKey("classes", [].concat($ca2ffd1693af9883$var$_toConsumableArray($ca2ffd1693af9883$var$classList(props)), $ca2ffd1693af9883$var$_toConsumableArray(className.split(" "))));
    var transform = $ca2ffd1693af9883$var$objectWithKey("transform", typeof props.transform === "string" ? (0, $624ceb5de64d8d6d$export$98e6a39c04603d36).transform(props.transform) : props.transform);
    var mask = $ca2ffd1693af9883$var$objectWithKey("mask", $ca2ffd1693af9883$var$normalizeIconArgs(maskArgs));
    var renderedIcon = (0, $624ceb5de64d8d6d$export$1ca1ec8b29a4ce27)(iconLookup, $ca2ffd1693af9883$var$_objectSpread2($ca2ffd1693af9883$var$_objectSpread2($ca2ffd1693af9883$var$_objectSpread2($ca2ffd1693af9883$var$_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        $ca2ffd1693af9883$var$log("Could not find icon", iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: ref
    };
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!$ca2ffd1693af9883$export$2b9260d4a45c8710.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return $ca2ffd1693af9883$var$convertCurry(abstract[0], extraProps);
});
$ca2ffd1693af9883$export$2b9260d4a45c8710.displayName = "FontAwesomeIcon";
$ca2ffd1693af9883$export$2b9260d4a45c8710.propTypes = {
    beat: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    border: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    beatFade: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    bounce: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    flash: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
    ]),
    maskId: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    fixedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
        true,
        false,
        "horizontal",
        "vertical",
        "both"
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
    ]),
    listItem: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    pull: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
        "right",
        "left"
    ]),
    pulse: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
        "2xs",
        "xs",
        "sm",
        "lg",
        "xl",
        "2xl",
        "1x",
        "2x",
        "3x",
        "4x",
        "5x",
        "6x",
        "7x",
        "8x",
        "9x",
        "10x"
    ]),
    spin: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    spinPulse: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    spinReverse: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    titleId: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object
    ]),
    swapOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool
};
$ca2ffd1693af9883$export$2b9260d4a45c8710.defaultProps = {
    border: false,
    className: "",
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: "",
    titleId: null,
    transform: null,
    swapOpacity: false
};
var $ca2ffd1693af9883$var$convertCurry = $ca2ffd1693af9883$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement);



var $4DE7A = parcelRequire("4DE7A");
function $35f760dc3fc04eda$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $35f760dc3fc04eda$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $35f760dc3fc04eda$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $35f760dc3fc04eda$var$sizeMap = {
    small: 16,
    medium: 32,
    large: 64
};
function $35f760dc3fc04eda$var$createIconComponent(name, defaultClassName, getSVGData) {
    var svgDataByHeight = getSVGData();
    var heights = Object.keys(svgDataByHeight);
    function Icon(_ref) {
        var ariaLabel = _ref["aria-label"], tabIndex = _ref.tabIndex, _ref$className = _ref.className, className = _ref$className === void 0 ? defaultClassName : _ref$className, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "currentColor" : _ref$fill, _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, _ref$verticalAlign = _ref.verticalAlign, verticalAlign = _ref$verticalAlign === void 0 ? "text-bottom" : _ref$verticalAlign;
        var height = $35f760dc3fc04eda$var$sizeMap[size] || size;
        var naturalHeight = $35f760dc3fc04eda$var$closestNaturalHeight(heights, height);
        var naturalWidth = svgDataByHeight[naturalHeight].width;
        var width = height * (naturalWidth / naturalHeight);
        var path = svgDataByHeight[naturalHeight].path;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("svg", {
            "aria-hidden": ariaLabel ? "false" : "true",
            tabIndex: tabIndex,
            focusable: tabIndex >= 0 ? "true" : "false",
            "aria-label": ariaLabel,
            role: "img",
            className: className,
            viewBox: "0 0 ".concat(naturalWidth, " ").concat(naturalHeight),
            width: width,
            height: height,
            fill: fill,
            style: {
                display: "inline-block",
                userSelect: "none",
                verticalAlign: verticalAlign,
                overflow: "visible"
            }
        }, path);
    }
    Icon.displayName = name;
    return Icon;
}
function $35f760dc3fc04eda$var$closestNaturalHeight(naturalHeights, height) {
    return naturalHeights.map(function(naturalHeight) {
        return parseInt(naturalHeight, 10);
    }).reduce(function(acc, naturalHeight) {
        return naturalHeight <= height ? naturalHeight : acc;
    }, naturalHeights[0]);
}
/* THIS FILE IS GENERATED. DO NOT EDIT IT. */ var $35f760dc3fc04eda$export$12f5813a529780ed = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("AccessibilityIcon", "octicon octicon-accessibility", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.923 5.302c.063.063.122.129.178.198H14A.75.75 0 0 1 14 7h-3.3l.578 5.163.362 2.997a.75.75 0 0 1-1.49.18L9.868 13H6.132l-.282 2.34a.75.75 0 0 1-1.49-.18l.362-2.997L5.3 7H2a.75.75 0 0 1 0-1.5h3.9a2.54 2.54 0 0 1 .176-.198 3 3 0 1 1 3.847 0ZM9.2 7.073h-.001a1.206 1.206 0 0 0-2.398 0L6.305 11.5h3.39ZM9.5 3a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 9.5 3Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$587fb0e8d01524db = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("AccessibilityInsetIcon", "octicon octicon-accessibility-inset", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm2 4a2 2 0 1 0-2.95 1.76 1.87 1.87 0 0 0-.32.24H3.75a.75.75 0 0 0 0 1.5h2.363l-.607 5.67a.75.75 0 1 0 1.49.16l.25-2.33h1.508l.25 2.33a.75.75 0 0 0 1.492-.16L9.888 7.5h2.362a.75.75 0 0 0 0-1.5H9.27a1.98 1.98 0 0 0-.32-.24A2 2 0 0 0 10 4Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$4a143c8822a09fb4 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("AlertIcon", "octicon octicon-alert", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.457 1.047c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0 1 14.082 15H1.918a1.75 1.75 0 0 1-1.543-2.575Zm1.763.707a.25.25 0 0 0-.44 0L1.698 13.132a.25.25 0 0 0 .22.368h12.164a.25.25 0 0 0 .22-.368Zm.53 3.996v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-.25-8.25a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0v-4.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.836 3.244c.963-1.665 3.365-1.665 4.328 0l8.967 15.504c.963 1.667-.24 3.752-2.165 3.752H3.034c-1.926 0-3.128-2.085-2.165-3.752Zm3.03.751a1.002 1.002 0 0 0-1.732 0L2.168 19.499A1.002 1.002 0 0 0 3.034 21h17.932a1.002 1.002 0 0 0 .866-1.5L12.866 3.994Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$7918f1ef0d6bf70c = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("AlertFillIcon", "octicon octicon-alert-fill", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.855.708c.5-.896 1.79-.896 2.29 0l4.675 8.351a1.312 1.312 0 0 1-1.146 1.954H1.33A1.313 1.313 0 0 1 .183 9.058ZM7 7V3H5v4Zm-1 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            })
        },
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.457 1.047c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0 1 14.082 15H1.918a1.75 1.75 0 0 1-1.543-2.575ZM8 5a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-2.5A.75.75 0 0 0 8 5Zm1 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.836 3.244c.963-1.665 3.365-1.665 4.328 0l8.967 15.504c.963 1.667-.24 3.752-2.165 3.752H3.034c-1.926 0-3.128-2.085-2.165-3.752ZM12 8.5a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 12 8.5Zm1 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$40a6e2bdd55901c0 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("AppsIcon", "octicon octicon-apps", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.5 3.25c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5A1.75 1.75 0 0 1 5.75 7.5h-2.5A1.75 1.75 0 0 1 1.5 5.75Zm7 0c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5A1.75 1.75 0 0 1 8.5 5.75Zm-7 7c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5a1.75 1.75 0 0 1-1.75-1.75Zm7 0c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5a1.75 1.75 0 0 1-1.75-1.75ZM3.25 3a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5A.25.25 0 0 0 6 5.75v-2.5A.25.25 0 0 0 5.75 3Zm7 0a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm-7 7a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm7 0a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$64abfa02d870a554 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ArchiveIcon", "octicon octicon-archive", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75v1.5A1.75 1.75 0 0 1 14.25 6H1.75A1.75 1.75 0 0 1 0 4.25ZM1.75 7a.75.75 0 0 1 .75.75v5.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-5.5a.75.75 0 0 1 1.5 0v5.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25v-5.5A.75.75 0 0 1 1.75 7Zm0-4.5a.25.25 0 0 0-.25.25v1.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25ZM6.25 8h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.75 2h18.5c.966 0 1.75.784 1.75 1.75v3.5A1.75 1.75 0 0 1 21.25 9H2.75A1.75 1.75 0 0 1 1 7.25v-3.5C1 2.784 1.784 2 2.75 2Zm18.5 1.5H2.75a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25ZM2.75 10a.75.75 0 0 1 .75.75v9.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25v-9.5a.75.75 0 0 1 1.5 0v9.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25v-9.5a.75.75 0 0 1 .75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.75 11.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$39a586317aa80eb5 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ArrowBothIcon", "octicon octicon-arrow-both", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.72 3.72a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L2.56 7h10.88l-2.22-2.22a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l2.22-2.22H2.56l2.22 2.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-3.5-3.5a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.78 5.97a.75.75 0 0 0-1.06 0l-5.25 5.25a.75.75 0 0 0 0 1.06l5.25 5.25a.75.75 0 0 0 1.06-1.06L3.81 12.5h16.38l-3.97 3.97a.75.75 0 1 0 1.06 1.06l5.25-5.25a.75.75 0 0 0 0-1.06l-5.25-5.25a.75.75 0 1 0-1.06 1.06L20.19 11H3.81l3.97-3.97a.75.75 0 0 0 0-1.06Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$1c939d3c9b6931b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ArrowDownIcon", "octicon octicon-arrow-down", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.03 8.22a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L3.47 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l2.97 2.97V3.75a.75.75 0 0 1 1.5 0v7.44l2.97-2.97a.75.75 0 0 1 1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.97 13.22a.75.75 0 0 1 1.06 0L11 18.19V3.75a.75.75 0 0 1 1.5 0v14.44l4.97-4.97a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-6.25 6.25a.75.75 0 0 1-1.06 0l-6.25-6.25a.75.75 0 0 1 0-1.06Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8b57ee4b0e98fb27 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ArrowDownLeftIcon", "octicon octicon-arrow-down-left", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.78 4.22a.75.75 0 0 1 0 1.06l-5.26 5.26h4.2a.75.75 0 0 1 0 1.5H4.71a.75.75 0 0 1-.75-.75V5.28a.75.75 0 0 1 1.5 0v4.2l5.26-5.26a.75.75 0 0 1 1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.75 8.5a.75.75 0 0 1 .75.75v7.19L16.72 6.22a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L7.56 17.5h7.19a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$814e7401971f4e15 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ArrowDownRightIcon", "octicon octicon-arrow-down-right", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.22 4.179a.75.75 0 0 1 1.06 0l5.26 5.26v-4.2a.75.75 0 0 1 1.5 0v6.01a.75.75 0 0 1-.75.75H5.28a.75.75 0 0 1 0-1.5h4.2L4.22 5.24a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M18.25 8.5a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1 0-1.5h7.19L6.22 7.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L17.5 16.44V9.25a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8afed21ef5c2afa5 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ArrowLeftIcon", "octicon octicon-arrow-left", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.78 12.53a.75.75 0 0 1-1.06 0L2.47 8.28a.75.75 0 0 1 0-1.06l4.25-4.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L4.81 7h7.44a.75.75 0 0 1 0 1.5H4.81l2.97 2.97a.75.75 0 0 1 0 1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.78 19.03a.75.75 0 0 1-1.06 0l-6.25-6.25a.75.75 0 0 1 0-1.06l6.25-6.25a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L5.81 11.5h14.44a.75.75 0 0 1 0 1.5H5.81l4.97 4.97a.75.75 0 0 1 0 1.06Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$9ca09caa9c849d9c = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ArrowRightIcon", "octicon octicon-arrow-right", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.22 2.97a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l2.97-2.97H3.75a.75.75 0 0 1 0-1.5h7.44L8.22 4.03a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.22 19.03a.75.75 0 0 1 0-1.06L18.19 13H3.75a.75.75 0 0 1 0-1.5h14.44l-4.97-4.97a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l6.25 6.25a.75.75 0 0 1 0 1.06l-6.25 6.25a.75.75 0 0 1-1.06 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$37616c26ca544529 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ArrowSwitchIcon", "octicon octicon-arrow-switch", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.22 14.78a.75.75 0 0 0 1.06-1.06L4.56 12h8.69a.75.75 0 0 0 0-1.5H4.56l1.72-1.72a.75.75 0 0 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3Zm5.56-6.5a.75.75 0 1 1-1.06-1.06l1.72-1.72H2.75a.75.75 0 0 1 0-1.5h8.69L9.72 2.28a.75.75 0 0 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.72 21.78a.75.75 0 0 0 1.06-1.06L5.56 17.5h14.69a.75.75 0 0 0 0-1.5H5.56l3.22-3.22a.75.75 0 1 0-1.06-1.06l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5Zm8.56-9.5a.75.75 0 1 1-1.06-1.06L18.44 8H3.75a.75.75 0 0 1 0-1.5h14.69l-3.22-3.22a.75.75 0 0 1 1.06-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$f1a507b991affc46 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ArrowUpIcon", "octicon octicon-arrow-up", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.47 7.78a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0l4.25 4.25a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018L9 4.81v7.44a.75.75 0 0 1-1.5 0V4.81L4.53 7.78a.75.75 0 0 1-1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M18.655 10.405a.75.75 0 0 1-1.06 0l-4.97-4.97v14.44a.75.75 0 0 1-1.5 0V5.435l-4.97 4.97a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l6.25-6.25a.75.75 0 0 1 1.06 0l6.25 6.25a.75.75 0 0 1 0 1.06Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8c53b52ced56b6d0 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ArrowUpLeftIcon", "octicon octicon-arrow-up-left", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.96 4.75A.75.75 0 0 1 4.71 4h6.01a.75.75 0 0 1 0 1.5h-4.2l5.26 5.26a.75.75 0 0 1-1.06 1.061l-5.26-5.26v4.2a.75.75 0 0 1-1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.75 15.5a.75.75 0 0 1-.75-.75v-9A.75.75 0 0 1 5.75 5h9a.75.75 0 0 1 0 1.5H7.56l10.22 10.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L6.5 7.56v7.19a.75.75 0 0 1-.75.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$ca4d2b63d3464320 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ArrowUpRightIcon", "octicon octicon-arrow-up-right", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.53 4.75A.75.75 0 0 1 5.28 4h6.01a.75.75 0 0 1 .75.75v6.01a.75.75 0 0 1-1.5 0v-4.2l-5.26 5.261a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L9.48 5.5h-4.2a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M18.25 15.5a.75.75 0 0 1-.75-.75V7.56L7.28 17.78a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L16.44 6.5H9.25a.75.75 0 0 1 0-1.5h9a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$4a0107eb20c58f1c = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BeakerIcon", "octicon octicon-beaker", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5 5.782V2.5h-.25a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5H11v3.282l3.666 5.76C15.619 13.04 14.543 15 12.767 15H3.233c-1.776 0-2.852-1.96-1.899-3.458Zm-2.4 6.565a.75.75 0 0 0 .633 1.153h9.534a.75.75 0 0 0 .633-1.153L12.225 10.5h-8.45ZM9.5 2.5h-3V6c0 .143-.04.283-.117.403L4.73 9h6.54L9.617 6.403A.746.746 0 0 1 9.5 6Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 8.807V3.5h-.563a.75.75 0 0 1 0-1.5h9.125a.75.75 0 0 1 0 1.5H16v5.307l5.125 9.301c.964 1.75-.302 3.892-2.299 3.892H5.174c-1.998 0-3.263-2.142-2.3-3.892ZM4.189 18.832a1.123 1.123 0 0 0 .985 1.668h13.652a1.123 1.123 0 0 0 .985-1.668L17.7 15H6.3ZM14.5 3.5h-5V9a.75.75 0 0 1-.093.362L7.127 13.5h9.746l-2.28-4.138A.75.75 0 0 1 14.5 9Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$2235404cc2cfe93c = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BellIcon", "octicon octicon-bell", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 16a2 2 0 0 0 1.985-1.75c.017-.137-.097-.25-.235-.25h-3.5c-.138 0-.252.113-.235.25A2 2 0 0 0 8 16ZM3 5a5 5 0 0 1 10 0v2.947c0 .05.015.098.042.139l1.703 2.555A1.519 1.519 0 0 1 13.482 13H2.518a1.516 1.516 0 0 1-1.263-2.36l1.703-2.554A.255.255 0 0 0 3 7.947Zm5-3.5A3.5 3.5 0 0 0 4.5 5v2.947c0 .346-.102.683-.294.97l-1.703 2.556a.017.017 0 0 0-.003.01l.001.006c0 .002.002.004.004.006l.006.004.007.001h10.964l.007-.001.006-.004.004-.006.001-.007a.017.017 0 0 0-.003-.01l-1.703-2.554a1.745 1.745 0 0 1-.294-.97V5A3.5 3.5 0 0 0 8 1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c3.681 0 7 2.565 7 6v4.539c0 .642.189 1.269.545 1.803l2.2 3.298A1.517 1.517 0 0 1 20.482 19H15.5a3.5 3.5 0 1 1-7 0H3.519a1.518 1.518 0 0 1-1.265-2.359l2.2-3.299A3.25 3.25 0 0 0 5 11.539V7c0-3.435 3.318-6 7-6ZM6.5 7v4.539a4.75 4.75 0 0 1-.797 2.635l-2.2 3.298-.003.01.001.007.004.006.006.004.007.001h16.964l.007-.001.006-.004.004-.006.001-.006a.017.017 0 0 0-.003-.01l-2.199-3.299a4.753 4.753 0 0 1-.798-2.635V7c0-2.364-2.383-4.5-5.5-4.5S6.5 4.636 6.5 7ZM14 19h-4a2 2 0 1 0 4 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$db2f520bd369b7e6 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BellFillIcon", "octicon octicon-bell-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 16c.9 0 1.7-.6 1.9-1.5.1-.3-.1-.5-.4-.5h-3c-.3 0-.5.2-.4.5.2.9 1 1.5 1.9 1.5ZM3 5c0-2.8 2.2-5 5-5s5 2.2 5 5v3l1.7 2.6c.2.2.3.5.3.8 0 .8-.7 1.5-1.5 1.5h-11c-.8.1-1.5-.6-1.5-1.4 0-.3.1-.6.3-.8L3 8.1V5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6 8a6 6 0 1 1 12 0v2.917c0 .703.228 1.387.65 1.95L20.7 15.6a1.5 1.5 0 0 1-1.2 2.4h-15a1.5 1.5 0 0 1-1.2-2.4l2.05-2.733a3.25 3.25 0 0 0 .65-1.95Zm6 13.5A3.502 3.502 0 0 1 8.645 19h6.71A3.502 3.502 0 0 1 12 21.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$f7b8d0021b678e0e = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BellSlashIcon", "octicon octicon-bell-slash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m4.182 4.31.016.011 10.104 7.316.013.01 1.375.996a.75.75 0 1 1-.88 1.214L13.626 13H2.518a1.516 1.516 0 0 1-1.263-2.36l1.703-2.554A.255.255 0 0 0 3 7.947V5.305L.31 3.357a.75.75 0 1 1 .88-1.214Zm7.373 7.19L4.5 6.391v1.556c0 .346-.102.683-.294.97l-1.703 2.556a.017.017 0 0 0-.003.01c0 .005.002.009.005.012l.006.004.007.001ZM8 1.5c-.997 0-1.895.416-2.534 1.086A.75.75 0 1 1 4.38 1.55 5 5 0 0 1 13 5v2.373a.75.75 0 0 1-1.5 0V5A3.5 3.5 0 0 0 8 1.5ZM8 16a2 2 0 0 1-1.985-1.75c-.017-.137.097-.25.235-.25h3.5c.138 0 .252.113.235.25A2 2 0 0 1 8 16Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.22 1.22a.75.75 0 0 1 1.06 0l20.5 20.5a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L17.94 19H15.5a3.5 3.5 0 1 1-7 0H3.518a1.516 1.516 0 0 1-1.263-2.36l2.2-3.298A3.249 3.249 0 0 0 5 11.539V7c0-.294.025-.583.073-.866L1.22 2.28a.75.75 0 0 1 0-1.06ZM6.5 7.56h-.001v3.979a4.75 4.75 0 0 1-.797 2.635l-2.2 3.298-.003.01.001.007.004.006.006.004.007.001H16.44ZM10 19a2 2 0 1 0 4 0Zm2-16.5c-1.463 0-2.8.485-3.788 1.257l-.04.032a.75.75 0 1 1-.935-1.173l.05-.04C8.548 1.59 10.212 1 12 1c3.681 0 7 2.565 7 6v4.539c0 .642.19 1.269.546 1.803l1.328 1.992a.75.75 0 1 1-1.248.832l-1.328-1.992a4.75 4.75 0 0 1-.798-2.635V7c0-2.364-2.383-4.5-5.5-4.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$5c4e80a0a9240ca3 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BlockedIcon", "octicon octicon-blocked", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.467.22a.749.749 0 0 1 .53-.22h6.006c.199 0 .389.079.53.22l4.247 4.247c.141.14.22.331.22.53v6.006a.749.749 0 0 1-.22.53l-4.247 4.247a.749.749 0 0 1-.53.22H4.997a.749.749 0 0 1-.53-.22L.22 11.533a.749.749 0 0 1-.22-.53V4.997c0-.199.079-.389.22-.53Zm.84 1.28L1.5 5.308v5.384L5.308 14.5h5.384l3.808-3.808V5.308L10.692 1.5ZM4 7.75A.75.75 0 0 1 4.75 7h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 4 7.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.638 2.22a.749.749 0 0 1 .53-.22h7.664c.199 0 .389.079.53.22l5.418 5.418c.141.14.22.332.22.53v7.664a.749.749 0 0 1-.22.53l-5.418 5.418a.749.749 0 0 1-.53.22H8.168a.749.749 0 0 1-.53-.22l-5.42-5.418a.752.752 0 0 1-.219-.53V8.168c0-.199.079-.389.22-.53l5.418-5.42ZM8.48 3.5 3.5 8.48v7.04l4.98 4.98h7.04l4.98-4.98V8.48L15.52 3.5ZM7 11.75a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$3d4d964fb74ced39 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BoldIcon", "octicon octicon-bold", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4 2h4.5a3.501 3.501 0 0 1 2.852 5.53A3.499 3.499 0 0 1 9.5 14H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm1 7v3h4.5a1.5 1.5 0 0 0 0-3Zm3.5-2a1.5 1.5 0 0 0 0-3H5v3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6 4.75c0-.69.56-1.25 1.25-1.25h5a4.752 4.752 0 0 1 3.888 7.479A5 5 0 0 1 14 20.5H7.25c-.69 0-1.25-.56-1.25-1.25ZM8.5 13v5H14a2.5 2.5 0 1 0 0-5Zm0-2.5h3.751A2.25 2.25 0 0 0 12.25 6H8.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$7807f5bbd02c545b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BookIcon", "octicon octicon-book", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 1.75A.75.75 0 0 1 .75 1h4.253c1.227 0 2.317.59 3 1.501A3.743 3.743 0 0 1 11.006 1h4.245a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75h-4.507a2.25 2.25 0 0 0-1.591.659l-.622.621a.75.75 0 0 1-1.06 0l-.622-.621A2.25 2.25 0 0 0 5.258 13H.75a.75.75 0 0 1-.75-.75Zm7.251 10.324.004-5.073-.002-2.253A2.25 2.25 0 0 0 5.003 2.5H1.5v9h3.757a3.75 3.75 0 0 1 1.994.574ZM8.755 4.75l-.004 7.322a3.752 3.752 0 0 1 1.992-.572H14.5v-9h-3.495a2.25 2.25 0 0 0-2.25 2.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 3.75A.75.75 0 0 1 .75 3h7.497c1.566 0 2.945.8 3.751 2.014A4.495 4.495 0 0 1 15.75 3h7.5a.75.75 0 0 1 .75.75v15.063a.752.752 0 0 1-.755.75l-7.682-.052a3 3 0 0 0-2.142.878l-.89.891a.75.75 0 0 1-1.061 0l-.902-.901a2.996 2.996 0 0 0-2.121-.879H.75a.75.75 0 0 1-.75-.75Zm12.75 15.232a4.503 4.503 0 0 1 2.823-.971l6.927.047V4.5h-6.75a3 3 0 0 0-3 3ZM11.247 7.497a3 3 0 0 0-3-2.997H1.5V18h6.947c1.018 0 2.006.346 2.803.98Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$93cb139c864b0aec = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BookmarkIcon", "octicon octicon-bookmark", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3 2.75C3 1.784 3.784 1 4.75 1h6.5c.966 0 1.75.784 1.75 1.75v11.5a.75.75 0 0 1-1.227.579L8 11.722l-3.773 3.107A.751.751 0 0 1 3 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.91l3.023-2.489a.75.75 0 0 1 .954 0l3.023 2.49V2.75a.25.25 0 0 0-.25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5 3.75C5 2.784 5.784 2 6.75 2h10.5c.966 0 1.75.784 1.75 1.75v17.5a.75.75 0 0 1-1.218.586L12 17.21l-5.781 4.625A.75.75 0 0 1 5 21.25Zm1.75-.25a.25.25 0 0 0-.25.25v15.94l5.031-4.026a.749.749 0 0 1 .938 0L17.5 19.69V3.75a.25.25 0 0 0-.25-.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$d22b8bd58461a421 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BookmarkFillIcon", "octicon octicon-bookmark-fill", function() {
    return {
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.69 2h10.56c.966 0 1.75.784 1.75 1.75v17.5a.75.75 0 0 1-1.218.585L12 17.21l-5.781 4.626A.75.75 0 0 1 5 21.253L4.94 3.756A1.748 1.748 0 0 1 6.69 2Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$27fe15307e1afa36 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BookmarkSlashIcon", "octicon octicon-bookmark-slash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.19 1.143 4.182 3.31l.014.01 8.486 6.145.014.01 2.994 2.168a.75.75 0 1 1-.88 1.214L13 11.547v2.703a.75.75 0 0 1-1.206.596L8 11.944l-3.794 2.902A.75.75 0 0 1 3 14.25V4.305L.31 2.357a.75.75 0 1 1 .88-1.214ZM4.5 5.39v7.341l3.044-2.328a.75.75 0 0 1 .912 0l3.044 2.328V10.46ZM5.865 1h5.385c.966 0 1.75.784 1.75 1.75v3.624a.75.75 0 0 1-1.5 0V2.75a.25.25 0 0 0-.25-.25H5.865a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.565 2.018v-.001l21.75 15.75a.75.75 0 1 1-.88 1.215L19 16.495v4.764a.748.748 0 0 1-1.219.584L12 17.21l-5.781 4.634A.75.75 0 0 1 5 21.259V6.357L.685 3.232a.75.75 0 0 1 .88-1.214ZM17.5 15.408l-11-7.965v12.254l5.031-4.032a.749.749 0 0 1 .938 0l5.031 4.032ZM7.25 2a.75.75 0 0 0 0 1.5h10a.25.25 0 0 1 .25.25v6.5a.75.75 0 0 0 1.5 0v-6.5A1.75 1.75 0 0 0 17.25 2h-10Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$dc810451588d8559 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BookmarkSlashFillIcon", "octicon octicon-bookmark-slash-fill", function() {
    return {
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m3.232 2.175 18.5 15.5a.75.75 0 1 1-.964 1.15L19 17.343v3.907a.75.75 0 0 1-1.218.585L12 17.21l-5.781 4.626A.75.75 0 0 1 5 21.253L4.947 5.569 2.268 3.325a.75.75 0 1 1 .964-1.15ZM7.421 2h9.829c.966 0 1.75.784 1.75 1.75v8.073a.75.75 0 0 1-1.232.575L6.94 3.325A.75.75 0 0 1 7.421 2Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$6211d598766c7b98 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BriefcaseIcon", "octicon octicon-briefcase", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.75 0h2.5C10.216 0 11 .784 11 1.75V3h3.25c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25v-8.5C0 3.784.784 3 1.75 3H5V1.75C5 .784 5.784 0 6.75 0ZM3.5 9.5a3.49 3.49 0 0 1-2-.627v4.377c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V8.873a3.49 3.49 0 0 1-2 .627Zm-1.75-5a.25.25 0 0 0-.25.25V6a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V4.75a.25.25 0 0 0-.25-.25H1.75ZM9.5 3V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.5 1.75C7.5.784 8.284 0 9.25 0h5.5c.966 0 1.75.784 1.75 1.75V4h4.75c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 21.25 22H2.75A1.75 1.75 0 0 1 1 20.25V5.75C1 4.784 1.784 4 2.75 4H7.5Zm-5 10.24v8.26c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25v-8.26A4.235 4.235 0 0 1 18.75 13H5.25a4.235 4.235 0 0 1-2.75-1.01Zm19-3.24v-3a.25.25 0 0 0-.25-.25H2.75a.25.25 0 0 0-.25.25v3a2.75 2.75 0 0 0 2.75 2.75h13.5a2.75 2.75 0 0 0 2.75-2.75Zm-6.5-7a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.25.25V4h6Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$18bc95dd4fe2936b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BroadcastIcon", "octicon octicon-broadcast", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.75 8.582v5.668a.75.75 0 0 1-1.5 0V8.582a1.75 1.75 0 1 1 1.5 0Zm3.983-7.125a.75.75 0 0 1 1.06.026A7.976 7.976 0 0 1 16 7c0 2.139-.84 4.083-2.207 5.517a.75.75 0 1 1-1.086-1.034A6.474 6.474 0 0 0 14.5 7a6.474 6.474 0 0 0-1.793-4.483.75.75 0 0 1 .026-1.06Zm-9.466 0c.3.286.312.76.026 1.06A6.474 6.474 0 0 0 1.5 7a6.47 6.47 0 0 0 1.793 4.483.75.75 0 0 1-1.086 1.034A7.973 7.973 0 0 1 0 7c0-2.139.84-4.083 2.207-5.517a.75.75 0 0 1 1.06-.026Zm8.556 2.321A4.988 4.988 0 0 1 13 7a4.988 4.988 0 0 1-1.177 3.222.75.75 0 1 1-1.146-.967A3.487 3.487 0 0 0 11.5 7c0-.86-.309-1.645-.823-2.255a.75.75 0 0 1 1.146-.967Zm-6.492.958A3.48 3.48 0 0 0 4.5 7a3.48 3.48 0 0 0 .823 2.255.75.75 0 0 1-1.146.967A4.981 4.981 0 0 1 3 7a4.982 4.982 0 0 1 1.188-3.236.75.75 0 1 1 1.143.972Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M20.485 2.515a.75.75 0 0 0-1.06 1.06A10.465 10.465 0 0 1 22.5 11c0 2.9-1.174 5.523-3.075 7.424a.75.75 0 0 0 1.06 1.061A11.965 11.965 0 0 0 24 11c0-3.314-1.344-6.315-3.515-8.485Zm-15.91 1.06a.75.75 0 0 0-1.06-1.06A11.965 11.965 0 0 0 0 11c0 3.313 1.344 6.314 3.515 8.485a.75.75 0 0 0 1.06-1.06A10.465 10.465 0 0 1 1.5 11c0-2.9 1.174-5.524 3.075-7.425ZM8.11 7.11a.75.75 0 0 0-1.06-1.06A6.98 6.98 0 0 0 5 11a6.98 6.98 0 0 0 2.05 4.95.75.75 0 0 0 1.06-1.061 5.48 5.48 0 0 1-1.61-3.89 5.48 5.48 0 0 1 1.61-3.888Zm8.84-1.06a.75.75 0 1 0-1.06 1.06A5.48 5.48 0 0 1 17.5 11a5.48 5.48 0 0 1-1.61 3.889.75.75 0 1 0 1.06 1.06A6.98 6.98 0 0 0 19 11a6.98 6.98 0 0 0-2.05-4.949ZM14 11a2 2 0 0 1-1.25 1.855v8.395a.75.75 0 0 1-1.5 0v-8.395A2 2 0 1 1 14 11Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$abc36f8394967e37 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BrowserIcon", "octicon octicon-browser", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25ZM14.5 6h-13v7.25c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25Zm-6-3.5v2h6V2.75a.25.25 0 0 0-.25-.25ZM5 2.5v2h2v-2Zm-3.25 0a.25.25 0 0 0-.25.25V4.5h2v-2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 3.75C0 2.784.784 2 1.75 2h20.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 22.25 22H1.75A1.75 1.75 0 0 1 0 20.25ZM22.5 7h-21v13.25c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25Zm-10-3.5v2h10V3.75a.25.25 0 0 0-.25-.25ZM7 3.5v2h4v-2Zm-5.25 0a.25.25 0 0 0-.25.25V5.5h4v-2Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$6a890007100de1ac = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("BugIcon", "octicon octicon-bug", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.72.22a.75.75 0 0 1 1.06 0l1 .999a3.488 3.488 0 0 1 2.441 0l.999-1a.748.748 0 0 1 1.265.332.75.75 0 0 1-.205.729l-.775.776c.616.63.995 1.493.995 2.444v.327c0 .1-.009.197-.025.292.408.14.764.392 1.029.722l1.968-.787a.75.75 0 0 1 .556 1.392L13 7.258V9h2.25a.75.75 0 0 1 0 1.5H13v.5c0 .409-.049.806-.141 1.186l2.17.868a.75.75 0 0 1-.557 1.392l-2.184-.873A4.997 4.997 0 0 1 8 16a4.997 4.997 0 0 1-4.288-2.427l-2.183.873a.75.75 0 0 1-.558-1.392l2.17-.868A5.036 5.036 0 0 1 3 11v-.5H.75a.75.75 0 0 1 0-1.5H3V7.258L.971 6.446a.75.75 0 0 1 .558-1.392l1.967.787c.265-.33.62-.583 1.03-.722a1.677 1.677 0 0 1-.026-.292V4.5c0-.951.38-1.814.995-2.444L4.72 1.28a.75.75 0 0 1 0-1.06Zm.53 6.28a.75.75 0 0 0-.75.75V11a3.5 3.5 0 1 0 7 0V7.25a.75.75 0 0 0-.75-.75ZM6.173 5h3.654A.172.172 0 0 0 10 4.827V4.5a2 2 0 1 0-4 0v.327c0 .096.077.173.173.173Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.72.22a.75.75 0 0 1 1.06 0l1.204 1.203A4.98 4.98 0 0 1 12 1c.717 0 1.4.151 2.016.423L15.22.22a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-.971.972A4.991 4.991 0 0 1 17 6v1.104a2.755 2.755 0 0 1 1.917 1.974l1.998-.999a.75.75 0 0 1 .67 1.342L19 10.714V13.5l3.25.003a.75.75 0 0 1 0 1.5L19 15.001V16c0 .568-.068 1.134-.204 1.686l.04.018 2.75 1.375a.75.75 0 1 1-.671 1.342l-2.638-1.319A6.998 6.998 0 0 1 12 23a6.998 6.998 0 0 1-6.197-3.742l-2.758 1.181a.752.752 0 0 1-1.064-.776.752.752 0 0 1 .474-.602l2.795-1.199A6.976 6.976 0 0 1 5 16v-.996H1.75a.75.75 0 0 1 0-1.5H5v-2.79L2.415 9.42a.75.75 0 0 1 .67-1.342l1.998.999A2.756 2.756 0 0 1 7 7.104V6a4.99 4.99 0 0 1 1.69-3.748l-.97-.972a.75.75 0 0 1 0-1.06ZM6.5 9.75V16a5.5 5.5 0 1 0 11 0V9.75c0-.69-.56-1.25-1.25-1.25h-8.5c-.69 0-1.25.56-1.25 1.25ZM8.5 7h7V6a3.5 3.5 0 1 0-7 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$e16b9b401b22a826 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CacheIcon", "octicon octicon-cache", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.5 5.724V8c0 .248.238.7 1.169 1.159.874.43 2.144.745 3.62.822a.75.75 0 1 1-.078 1.498c-1.622-.085-3.102-.432-4.204-.975a5.565 5.565 0 0 1-.507-.28V12.5c0 .133.058.318.282.551.227.237.591.483 1.101.707 1.015.447 2.47.742 4.117.742.406 0 .802-.018 1.183-.052a.751.751 0 1 1 .134 1.494C8.89 15.98 8.45 16 8 16c-1.805 0-3.475-.32-4.721-.869-.623-.274-1.173-.619-1.579-1.041-.408-.425-.7-.964-.7-1.59v-9c0-.626.292-1.165.7-1.591.406-.42.956-.766 1.579-1.04C4.525.32 6.195 0 8 0c1.806 0 3.476.32 4.721.869.623.274 1.173.619 1.579 1.041.408.425.7.964.7 1.59 0 .626-.292 1.165-.7 1.591-.406.42-.956.766-1.578 1.04C11.475 6.68 9.805 7 8 7c-1.805 0-3.475-.32-4.721-.869a6.15 6.15 0 0 1-.779-.407Zm0-2.224c0 .133.058.318.282.551.227.237.591.483 1.101.707C4.898 5.205 6.353 5.5 8 5.5c1.646 0 3.101-.295 4.118-.742.508-.224.873-.471 1.1-.708.224-.232.282-.417.282-.55 0-.133-.058-.318-.282-.551-.227-.237-.591-.483-1.101-.707C11.102 1.795 9.647 1.5 8 1.5c-1.646 0-3.101.295-4.118.742-.508.224-.873.471-1.1.708-.224.232-.282.417-.282.55Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M14.49 7.582a.375.375 0 0 0-.66-.313l-3.625 4.625a.375.375 0 0 0 .295.606h2.127l-.619 2.922a.375.375 0 0 0 .666.304l3.125-4.125A.375.375 0 0 0 15.5 11h-1.778l.769-3.418Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$5fda1783bb83f57b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CalendarIcon", "octicon octicon-calendar", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.75 0a.75.75 0 0 1 .75.75V2h5V.75a.75.75 0 0 1 1.5 0V2h1.25c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 16H2.75A1.75 1.75 0 0 1 1 14.25V3.75C1 2.784 1.784 2 2.75 2H4V.75A.75.75 0 0 1 4.75 0ZM2.5 7.5v6.75c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V7.5Zm10.75-4H2.75a.25.25 0 0 0-.25.25V6h11V3.75a.25.25 0 0 0-.25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.75 0a.75.75 0 0 1 .75.75V3h9V.75a.75.75 0 0 1 1.5 0V3h2.75c.966 0 1.75.784 1.75 1.75v16a1.75 1.75 0 0 1-1.75 1.75H3.25a1.75 1.75 0 0 1-1.75-1.75v-16C1.5 3.784 2.284 3 3.25 3H6V.75A.75.75 0 0 1 6.75 0ZM21 9.5H3v11.25c0 .138.112.25.25.25h17.5a.25.25 0 0 0 .25-.25Zm-17.75-5a.25.25 0 0 0-.25.25V8h18V4.75a.25.25 0 0 0-.25-.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$7dd004358974b05d = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CheckIcon", "octicon octicon-check", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M21.03 5.72a.75.75 0 0 1 0 1.06l-11.5 11.5a.747.747 0 0 1-1.072-.012l-5.5-5.75a.75.75 0 1 1 1.084-1.036l4.97 5.195L19.97 5.72a.75.75 0 0 1 1.06 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$f6dd727656c97851 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CheckCircleIcon", "octicon octicon-check-circle", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm1.5 0a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm10.28-1.72-4.5 4.5a.75.75 0 0 1-1.06 0l-2-2a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l1.47 1.47 3.97-3.97a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M17.28 9.28a.75.75 0 0 0-1.06-1.06l-5.97 5.97-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6.5-6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$3298acaca062aba2 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CheckCircleFillIcon", "octicon octicon-check-circle-fill", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0Zm-.705 8.737L9.63 4.403 8.392 3.166 5.295 6.263l-1.7-1.702L2.356 5.8l2.938 2.938Z"
            })
        },
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm3.78-9.72a.751.751 0 0 0-.018-1.042.751.751 0 0 0-1.042-.018L6.75 9.19 5.28 7.72a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042l2 2a.75.75 0 0 0 1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm16.28-2.72a.751.751 0 0 0-.018-1.042.751.751 0 0 0-1.042-.018l-5.97 5.97-2.47-2.47a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042l3 3a.75.75 0 0 0 1.06 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$c0a1936901b0e55 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CheckboxIcon", "octicon octicon-checkbox", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.75 1h10.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.5 2.75v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25H2.75a.25.25 0 0 0-.25.25Zm9.28 3.53-4.5 4.5a.75.75 0 0 1-1.06 0l-2-2a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l1.47 1.47 3.97-3.97a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M17.28 9.28a.75.75 0 0 0-1.06-1.06l-5.97 5.97-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6.5-6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2ZM3.5 3.75v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H3.75a.25.25 0 0 0-.25.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$ca81f537ef473f1b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ChecklistIcon", "octicon octicon-checklist", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.5 1.75v11.5c0 .138.112.25.25.25h3.17a.75.75 0 0 1 0 1.5H2.75A1.75 1.75 0 0 1 1 13.25V1.75C1 .784 1.784 0 2.75 0h8.5C12.216 0 13 .784 13 1.75v7.736a.75.75 0 0 1-1.5 0V1.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25Zm13.274 9.537v-.001l-4.557 4.45a.75.75 0 0 1-1.055-.008l-1.943-1.95a.75.75 0 0 1 1.062-1.058l1.419 1.425 4.026-3.932a.75.75 0 1 1 1.048 1.074ZM4.75 4h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM4 7.75A.75.75 0 0 1 4.75 7h2a.75.75 0 0 1 0 1.5h-2A.75.75 0 0 1 4 7.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.5 3.75a.25.25 0 0 1 .25-.25h13.5a.25.25 0 0 1 .25.25v10a.75.75 0 0 0 1.5 0v-10A1.75 1.75 0 0 0 17.25 2H3.75A1.75 1.75 0 0 0 2 3.75v16.5c0 .966.784 1.75 1.75 1.75h7a.75.75 0 0 0 0-1.5h-7a.25.25 0 0 1-.25-.25V3.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.25 7a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Zm-.75 4.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm16.28 4.53a.75.75 0 1 0-1.06-1.06l-4.97 4.97-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5.5-5.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$4857d3f3f5f8319b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ChevronDownIcon", "octicon octicon-chevron-down", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6 8.825c-.2 0-.4-.1-.5-.2l-3.3-3.3c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l2.7 2.7 2.7-2.7c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1l-3.2 3.2c-.2.2-.4.3-.6.3Z"
            })
        },
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.78 5.22a.749.749 0 0 1 0 1.06l-4.25 4.25a.749.749 0 0 1-1.06 0L3.22 6.28a.749.749 0 1 1 1.06-1.06L8 8.939l3.72-3.719a.749.749 0 0 1 1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.22 8.22a.749.749 0 0 0 0 1.06l6.25 6.25a.749.749 0 0 0 1.06 0l6.25-6.25a.749.749 0 1 0-1.06-1.06L12 13.939 6.28 8.22a.749.749 0 0 0-1.06 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$20bc5960c3c9eebb = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ChevronLeftIcon", "octicon octicon-chevron-left", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.78 12.78a.75.75 0 0 1-1.06 0L4.47 8.53a.75.75 0 0 1 0-1.06l4.25-4.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L6.06 8l3.72 3.72a.75.75 0 0 1 0 1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15.28 5.22a.75.75 0 0 1 0 1.06L9.56 12l5.72 5.72a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-6.25-6.25a.75.75 0 0 1 0-1.06l6.25-6.25a.75.75 0 0 1 1.06 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$b837bd7eac09a33e = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ChevronRightIcon", "octicon octicon-chevron-right", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.7 10c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1L6.9 6 4.2 3.3c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l3.3 3.2c.3.3.3.8 0 1.1L5.3 9.7c-.2.2-.4.3-.6.3Z"
            })
        },
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.22 3.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L9.94 8 6.22 4.28a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.72 18.78a.75.75 0 0 1 0-1.06L14.44 12 8.72 6.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l6.25 6.25a.75.75 0 0 1 0 1.06l-6.25 6.25a.75.75 0 0 1-1.06 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$7f01a6cbee61a0f2 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ChevronUpIcon", "octicon octicon-chevron-up", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6 4c-.2 0-.4.1-.5.2L2.2 7.5c-.3.3-.3.8 0 1.1.3.3.8.3 1.1 0L6 5.9l2.7 2.7c.3.3.8.3 1.1 0 .3-.3.3-.8 0-1.1L6.6 4.3C6.4 4.1 6.2 4 6 4Z"
            })
        },
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.22 10.53a.749.749 0 0 1 0-1.06l4.25-4.25a.749.749 0 0 1 1.06 0l4.25 4.25a.749.749 0 1 1-1.06 1.06L8 6.811 4.28 10.53a.749.749 0 0 1-1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M18.78 15.78a.749.749 0 0 1-1.06 0L12 10.061 6.28 15.78a.749.749 0 1 1-1.06-1.06l6.25-6.25a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 0 1 0 1.06Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$9c1c3f5a4a271817 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CircleIcon", "octicon octicon-circle", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$24060b1e22abbcab = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CircleSlashIcon", "octicon octicon-circle-slash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM3.965 13.096a6.5 6.5 0 0 0 9.131-9.131ZM1.5 8a6.474 6.474 0 0 0 1.404 4.035l9.131-9.131A6.499 6.499 0 0 0 1.5 8Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM5.834 19.227A9.464 9.464 0 0 0 12 21.5a9.5 9.5 0 0 0 9.5-9.5 9.464 9.464 0 0 0-2.273-6.166ZM2.5 12a9.464 9.464 0 0 0 2.273 6.166L18.166 4.773A9.463 9.463 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8099ab97743c966c = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ClockIcon", "octicon octicon-clock", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm7-3.25v2.992l2.028.812a.75.75 0 0 1-.557 1.392l-2.5-1A.751.751 0 0 1 7 8.25v-3.5a.75.75 0 0 1 1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.5 7.25a.75.75 0 0 0-1.5 0v5.5c0 .27.144.518.378.651l3.5 2a.75.75 0 0 0 .744-1.302L12.5 12.315V7.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$4e0abfe5b1e1c658 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ClockFillIcon", "octicon octicon-clock-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8.575-3.25a.825.825 0 1 0-1.65 0v3.5c0 .337.205.64.519.766l2.5 1a.825.825 0 0 0 .612-1.532l-1.981-.793Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11.575-4.75a.825.825 0 1 0-1.65 0v5.5c0 .296.159.57.416.716l3.5 2a.825.825 0 0 0 .818-1.432l-3.084-1.763Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$575cd077dbb2b254 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CloudIcon", "octicon octicon-cloud", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 7.25A5.225 5.225 0 0 1 7.25 2a5.222 5.222 0 0 1 4.767 3.029A4.472 4.472 0 0 1 16 9.5c0 2.505-1.995 4.5-4.5 4.5h-8A3.474 3.474 0 0 1 0 10.5c0-1.41.809-2.614 2.001-3.17Zm1.54.482a.75.75 0 0 1-.556.832c-.86.22-1.484.987-1.484 1.936 0 1.124.876 2 2 2h8c1.676 0 3-1.324 3-3s-1.324-3-3-3a.75.75 0 0 1-.709-.504A3.72 3.72 0 0 0 7.25 3.5C5.16 3.5 3.5 5.16 3.5 7.25c.002.146.014.292.035.436l.004.036.001.008Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.103 10.107c0-4.244 3.445-7.607 7.733-7.607 3.19 0 5.912 1.858 7.099 4.563l.01.022.001.006C21.348 7.345 24 10.095 24 13.536 24 17.148 21.076 20 17.431 20H5.017C2.23 20 0 17.83 0 15.06a4.899 4.899 0 0 1 3.112-4.581 7.696 7.696 0 0 1-.009-.372ZM10.836 4c-3.485 0-6.233 2.717-6.233 6.107 0 .284.022.602.052.756a.75.75 0 0 1-.552.869c-1.52.385-2.603 1.712-2.603 3.328 0 1.917 1.532 3.44 3.517 3.44h12.414c2.843 0 5.069-2.206 5.069-4.964 0-2.759-2.226-4.965-5.069-4.965a.75.75 0 0 1-.696-.47l-.179-.446C15.606 5.5 13.424 4 10.836 4Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$c97a28c99d5bd1ee = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CloudOfflineIcon", "octicon octicon-cloud-offline", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.25 2c-.69 0-1.351.13-1.957.371a.75.75 0 1 0 .554 1.394c.43-.17.903-.265 1.403-.265a3.72 3.72 0 0 1 3.541 2.496.75.75 0 0 0 .709.504c1.676 0 3 1.324 3 3a3 3 0 0 1-.681 1.92.75.75 0 0 0 1.156.955A4.496 4.496 0 0 0 16 9.5a4.472 4.472 0 0 0-3.983-4.471A5.222 5.222 0 0 0 7.25 2ZM.72 1.72a.75.75 0 0 1 1.06 0l2.311 2.31c.03.025.056.052.08.08l8.531 8.532.035.034 2.043 2.044a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-1.8-1.799a4.54 4.54 0 0 1-.42.019h-8A3.474 3.474 0 0 1 0 10.5c0-1.41.809-2.614 2.001-3.17a5.218 5.218 0 0 1 .646-2.622L.72 2.78a.75.75 0 0 1 0-1.06ZM3.5 7.25c.004.161.018.322.041.481a.75.75 0 0 1-.557.833c-.86.22-1.484.986-1.484 1.936 0 1.124.876 2 2 2h6.94L3.771 5.832A3.788 3.788 0 0 0 3.5 7.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m2.78 2.22 19.5 19.5a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-2.845-2.845a6.932 6.932 0 0 1-.944.065H5.017C2.229 20 0 17.831 0 15.059a4.899 4.899 0 0 1 3.111-4.58A7.52 7.52 0 0 1 4.36 5.922L1.72 3.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018ZM16.94 18.5 5.448 7.01a6.026 6.026 0 0 0-.794 3.853.75.75 0 0 1-.552.869c-1.52.385-2.603 1.712-2.603 3.328 0 1.917 1.532 3.44 3.517 3.44Zm-6.104-16a7.865 7.865 0 0 0-3.638.88.75.75 0 1 0 .692 1.331A6.365 6.365 0 0 1 10.836 4c2.588 0 4.77 1.5 5.72 3.655l.179.445a.75.75 0 0 0 .696.471c2.843 0 5.069 2.206 5.069 4.965a4.9 4.9 0 0 1-1.684 3.716.75.75 0 0 0 .986 1.13A6.396 6.396 0 0 0 24 13.536c0-3.44-2.652-6.191-6.054-6.445l-.002-.006a.634.634 0 0 0-.01-.022C16.749 4.358 14.026 2.5 10.837 2.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8036f09137bee589 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CodeIcon", "octicon octicon-code", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m11.28 3.22 4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L13.94 8l-3.72-3.72a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215Zm-6.56 0a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L2.06 8l3.72 3.72a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L.47 8.53a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15.22 4.97a.75.75 0 0 1 1.06 0l6.5 6.5a.75.75 0 0 1 0 1.06l-6.5 6.5a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L21.19 12l-5.97-5.97a.75.75 0 0 1 0-1.06Zm-6.44 0a.75.75 0 0 1 0 1.06L2.81 12l5.97 5.97a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-6.5-6.5a.75.75 0 0 1 0-1.06l6.5-6.5a.75.75 0 0 1 1.06 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$cb541c48306d5255 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CodeOfConductIcon", "octicon octicon-code-of-conduct", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.048 2.241c.964-.709 2.079-1.238 3.325-1.241a4.616 4.616 0 0 1 3.282 1.355c.41.408.757.86.996 1.428.238.568.348 1.206.347 1.968 0 2.193-1.505 4.254-3.081 5.862-1.496 1.526-3.213 2.796-4.249 3.563l-.22.163a.749.749 0 0 1-.895 0l-.221-.163c-1.036-.767-2.753-2.037-4.249-3.563C1.51 10.008.007 7.952.002 5.762a4.614 4.614 0 0 1 1.353-3.407C3.123.585 6.223.537 8.048 2.24Zm-1.153.983c-1.25-1.033-3.321-.967-4.48.191a3.115 3.115 0 0 0-.913 2.335c0 1.556 1.109 3.24 2.652 4.813C5.463 11.898 6.96 13.032 8 13.805c.353-.262.758-.565 1.191-.905l-1.326-1.223a.75.75 0 0 1 1.018-1.102l1.48 1.366c.328-.281.659-.577.984-.887L9.99 9.802a.75.75 0 1 1 1.019-1.103l1.384 1.28c.295-.329.566-.661.81-.995L12.92 8.7l-1.167-1.168c-.674-.671-1.78-.664-2.474.03-.268.269-.538.537-.802.797-.893.882-2.319.843-3.185-.032-.346-.35-.693-.697-1.043-1.047a.75.75 0 0 1-.04-1.016c.162-.191.336-.401.52-.623.62-.748 1.356-1.637 2.166-2.417Zm7.112 4.442c.313-.65.491-1.293.491-1.916v-.001c0-.614-.088-1.045-.23-1.385-.143-.339-.357-.633-.673-.949a3.111 3.111 0 0 0-2.218-.915c-1.092.003-2.165.627-3.226 1.602-.823.755-1.554 1.637-2.228 2.45l-.127.154.562.566a.755.755 0 0 0 1.066.02l.794-.79c1.258-1.258 3.312-1.31 4.594-.032.396.394.792.791 1.173 1.173Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.828 4.328C5.26 1.896 9.5 1.881 11.935 4.317c.024.024.046.05.067.076 1.391-1.078 2.993-1.886 4.777-1.89a6.22 6.22 0 0 1 4.424 1.825c.559.56 1.023 1.165 1.34 1.922.318.756.47 1.617.468 2.663 0 2.972-2.047 5.808-4.269 8.074-2.098 2.14-4.507 3.924-5.974 5.009l-.311.23a.752.752 0 0 1-.897 0l-.312-.23c-1.466-1.085-3.875-2.869-5.973-5.009-2.22-2.263-4.264-5.095-4.27-8.063a6.216 6.216 0 0 1 1.823-4.596Zm8.033 1.042c-1.846-1.834-5.124-1.823-6.969.022a4.712 4.712 0 0 0-1.382 3.52c0 2.332 1.65 4.79 3.839 7.022 1.947 1.986 4.184 3.66 5.66 4.752a78.214 78.214 0 0 0 2.159-1.645l-2.14-1.974a.752.752 0 0 1 1.02-1.106l2.295 2.118c.616-.52 1.242-1.08 1.85-1.672l-2.16-1.992a.753.753 0 0 1 1.021-1.106l2.188 2.02a18.963 18.963 0 0 0 1.528-1.877l-.585-.586-1.651-1.652c-1.078-1.074-2.837-1.055-3.935.043-.379.38-.76.758-1.132 1.126-1.14 1.124-2.96 1.077-4.07-.043-.489-.495-.98-.988-1.475-1.482a.752.752 0 0 1-.04-1.019c.234-.276.483-.576.745-.893.928-1.12 2.023-2.442 3.234-3.576Zm9.725 6.77c.579-1.08.92-2.167.92-3.228.002-.899-.128-1.552-.35-2.08-.22-.526-.551-.974-1.017-1.44a4.71 4.71 0 0 0-3.356-1.384c-1.66.004-3.25.951-4.77 2.346-1.18 1.084-2.233 2.353-3.188 3.506l-.351.423c.331.332.663.664.993.998a1.375 1.375 0 0 0 1.943.03c.37-.365.748-.74 1.125-1.118 1.662-1.663 4.373-1.726 6.06-.045.56.558 1.12 1.12 1.658 1.658Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$ffd8274d5306c25d = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CodeReviewIcon", "octicon octicon-code-review", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 1h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 13H8.061l-2.574 2.573A1.458 1.458 0 0 1 3 14.543V13H1.75A1.75 1.75 0 0 1 0 11.25v-8.5C0 1.784.784 1 1.75 1ZM1.5 2.75v8.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Zm5.28 1.72a.75.75 0 0 1 0 1.06L5.31 7l1.47 1.47a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 0 1 1.06 0Zm2.44 0a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L10.69 7 9.22 5.53a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.3 6.74a.75.75 0 0 1-.04 1.06l-2.908 2.7 2.908 2.7a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Zm3.44 1.06a.75.75 0 1 1 1.02-1.1l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.908-2.7-2.908-2.7Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.5 4.25c0-.966.784-1.75 1.75-1.75h17.5c.966 0 1.75.784 1.75 1.75v12.5a1.75 1.75 0 0 1-1.75 1.75h-9.69l-3.573 3.573A1.458 1.458 0 0 1 5 21.043V18.5H3.25a1.75 1.75 0 0 1-1.75-1.75ZM3.25 4a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 .75.75v3.19l3.72-3.72a.749.749 0 0 1 .53-.22h10a.25.25 0 0 0 .25-.25V4.25a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$a3f70bb211ca95d5 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CodeSquareIcon", "octicon octicon-code-square", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Zm7.47 3.97a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L10.69 8 9.22 6.53a.75.75 0 0 1 0-1.06ZM6.78 6.53 5.31 8l1.47 1.47a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-2-2a.75.75 0 0 1 0-1.06l2-2a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.3 8.24a.75.75 0 0 1-.04 1.06L7.352 12l2.908 2.7a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Zm3.44 1.06a.75.75 0 1 1 1.02-1.1l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.908-2.7-2.908-2.7Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$2912aa6a4fe1542c = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CodescanIcon", "octicon octicon-codescan", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.47 4.97a.75.75 0 0 0 0 1.06L9.94 7.5 8.47 8.97a.75.75 0 1 0 1.06 1.06l2-2a.75.75 0 0 0 0-1.06l-2-2a.75.75 0 0 0-1.06 0ZM6.53 6.03a.75.75 0 0 0-1.06-1.06l-2 2a.75.75 0 0 0 0 1.06l2 2a.75.75 0 1 0 1.06-1.06L5.06 7.5l1.47-1.47Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.246 13.307a7.501 7.501 0 1 1 1.06-1.06l2.474 2.473a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215ZM1.5 7.5a6.002 6.002 0 0 0 3.608 5.504 6.002 6.002 0 0 0 6.486-1.117.748.748 0 0 1 .292-.293A6 6 0 1 0 1.5 7.5Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.97 6.97a.75.75 0 0 0 0 1.06l2.47 2.47-2.47 2.47a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 0ZM9.03 8.03a.75.75 0 0 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06-1.06L6.56 10.5l2.47-2.47Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.5 0C16.299 0 21 4.701 21 10.5a10.457 10.457 0 0 1-2.564 6.875l4.344 4.345a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-4.345-4.344A10.459 10.459 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5S4.701 0 10.5 0Zm-9 10.5a9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$b731da09185e34de = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CodescanCheckmarkIcon", "octicon octicon-codescan-checkmark", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.28 6.28a.75.75 0 1 0-1.06-1.06L6.25 8.19l-.97-.97a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06 0l3.5-3.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.5 15a7.5 7.5 0 1 1 5.807-2.754l2.473 2.474a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-2.474-2.473A7.472 7.472 0 0 1 7.5 15Zm0-13.5a6 6 0 1 0 4.094 10.386.748.748 0 0 1 .293-.292 6.002 6.002 0 0 0 1.117-6.486A6.002 6.002 0 0 0 7.5 1.5Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15.03 8.28a.75.75 0 0 0-1.06-1.06l-5.22 5.22-2.22-2.22a.75.75 0 1 0-1.06 1.06l2.75 2.75a.75.75 0 0 0 1.06 0l5.75-5.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 10.5C0 4.701 4.701 0 10.5 0S21 4.701 21 10.5c0 2.63-.967 5.033-2.564 6.875l4.344 4.345a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-4.345-4.344A10.457 10.457 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5Zm10.5-9a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$a98136388276bfe4 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CodespacesIcon", "octicon octicon-codespaces", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 11.25c0-.966.784-1.75 1.75-1.75h12.5c.966 0 1.75.784 1.75 1.75v3A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25Zm2-9.5C2 .784 2.784 0 3.75 0h8.5C13.216 0 14 .784 14 1.75v5a1.75 1.75 0 0 1-1.75 1.75h-8.5A1.75 1.75 0 0 1 2 6.75Zm1.75-.25a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-5a.25.25 0 0 0-.25-.25Zm-2 9.5a.25.25 0 0 0-.25.25v3c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-3a.25.25 0 0 0-.25-.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7 12.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm-4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.5 3.75C3.5 2.784 4.284 2 5.25 2h13.5c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0 1 18.75 13H5.25a1.75 1.75 0 0 1-1.75-1.75Zm-2 12c0-.966.784-1.75 1.75-1.75h17.5c.966 0 1.75.784 1.75 1.75v4a1.75 1.75 0 0 1-1.75 1.75H3.25a1.75 1.75 0 0 1-1.75-1.75ZM5.25 3.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h13.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Zm-2 12a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25h17.5a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10 17.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Zm-4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$38f001d9cffdd080 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ColumnsIcon", "octicon octicon-columns", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.75 0h2.5C6.216 0 7 .784 7 1.75v12.5A1.75 1.75 0 0 1 5.25 16h-2.5A1.75 1.75 0 0 1 1 14.25V1.75C1 .784 1.784 0 2.75 0Zm8 0h2.5C14.216 0 15 .784 15 1.75v12.5A1.75 1.75 0 0 1 13.25 16h-2.5A1.75 1.75 0 0 1 9 14.25V1.75C9 .784 9.784 0 10.75 0ZM2.5 1.75v12.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Zm8 0v12.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.75 2h5.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 9.25 22h-5.5A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2Zm11 0h5.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22h-5.5A1.75 1.75 0 0 1 13 20.25V3.75c0-.966.784-1.75 1.75-1.75ZM3.5 3.75v16.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.25.25Zm11 0v16.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.25.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$e0f3610a2b19da79 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CommandPaletteIcon", "octicon octicon-command-palette", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m6.354 8.04-4.773 4.773a.75.75 0 1 0 1.061 1.06L7.945 8.57a.75.75 0 0 0 0-1.06L2.642 2.206a.75.75 0 0 0-1.06 1.061L6.353 8.04ZM8.75 11.5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.045 18.894 9.94 12 3.045 5.106a.75.75 0 0 1 1.06-1.061l7.425 7.425a.75.75 0 0 1 0 1.06l-7.424 7.425a.75.75 0 0 1-1.061-1.06Zm8.205.606a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5h-9.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$a3543c9c8473fb3d = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CommentIcon", "octicon octicon-comment", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 2.75C1 1.784 1.784 1 2.75 1h10.5c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0 1 13.25 12H9.06l-2.573 2.573A1.458 1.458 0 0 1 4 13.543V12H2.75A1.75 1.75 0 0 1 1 10.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h4.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.5 4.25c0-.966.784-1.75 1.75-1.75h17.5c.966 0 1.75.784 1.75 1.75v12.5a1.75 1.75 0 0 1-1.75 1.75h-9.69l-3.573 3.573A1.458 1.458 0 0 1 5 21.043V18.5H3.25a1.75 1.75 0 0 1-1.75-1.75ZM3.25 4a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 .75.75v3.19l3.72-3.72a.749.749 0 0 1 .53-.22h10a.25.25 0 0 0 .25-.25V4.25a.25.25 0 0 0-.25-.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$a82b67e11f494532 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CommentDiscussionIcon", "octicon octicon-comment-discussion", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 1h8.5c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 10.25 10H7.061l-2.574 2.573A1.458 1.458 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25v-5.5C0 1.784.784 1 1.75 1ZM1.5 2.75v5.5c0 .138.112.25.25.25h1a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25Zm13 2a.25.25 0 0 0-.25-.25h-.5a.75.75 0 0 1 0-1.5h.5c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 12H14v1.543a1.458 1.458 0 0 1-2.487 1.03L9.22 12.28a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l2.22 2.22v-2.19a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 1h12.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.458 1.458 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25v-9.5C0 1.784.784 1 1.75 1ZM1.5 2.75v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M22.5 8.75a.25.25 0 0 0-.25-.25h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5a.75.75 0 0 1 .53.22l2.72 2.72v-2.19a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$13d9ab7fa696f910 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CommitIcon", "octicon octicon-commit", function() {
    return {
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 11.75A.75.75 0 0 1 .75 11h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Zm17.5 0a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 17.75a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-1.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$6d6da6edaddd5876 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ContainerIcon", "octicon octicon-container", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m10.41.24 4.711 2.774c.544.316.878.897.879 1.526v5.01a1.77 1.77 0 0 1-.88 1.53l-7.753 4.521-.002.001a1.769 1.769 0 0 1-1.774 0H5.59L.873 12.85A1.761 1.761 0 0 1 0 11.327V6.292c0-.304.078-.598.22-.855l.004-.005.01-.019c.15-.262.369-.486.64-.643L8.641.239a1.752 1.752 0 0 1 1.765 0l.002.001ZM9.397 1.534l-7.17 4.182 4.116 2.388a.27.27 0 0 0 .269 0l7.152-4.148-4.115-2.422a.252.252 0 0 0-.252 0Zm-7.768 10.02 4.1 2.393V9.474a1.807 1.807 0 0 1-.138-.072L1.5 7.029v4.298c0 .095.05.181.129.227Zm8.6.642 1.521-.887v-4.45l-1.521.882ZM7.365 9.402h.001c-.044.026-.09.049-.136.071v4.472l1.5-.875V8.61Zm5.885 1.032 1.115-.65h.002a.267.267 0 0 0 .133-.232V5.264l-1.25.725Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.152.682a2.251 2.251 0 0 1 2.269 0l.007.004 6.957 4.276a2.277 2.277 0 0 1 1.126 1.964v7.516c0 .81-.432 1.56-1.133 1.968l-.002.001-11.964 7.037-.004.003c-.706.41-1.578.41-2.284 0l-.026-.015-6.503-4.502a2.268 2.268 0 0 1-1.096-1.943V9.438c0-.392.1-.77.284-1.1l.003-.006.014-.026c.197-.342.48-.627.82-.827h.002L13.152.681Zm.757 1.295h-.001L2.648 8.616l6.248 4.247a.775.775 0 0 0 .758-.01h.001l11.633-6.804-6.629-4.074a.75.75 0 0 0-.75.003ZM8.517 14.33a2.286 2.286 0 0 1-.393-.18l-.023-.014-6.102-4.147v7.003c0 .275.145.528.379.664l.025.014 6.114 4.232V14.33ZM18 9.709l-3.25 1.9v7.548L18 17.245Zm-7.59 4.438-.002.002a2.296 2.296 0 0 1-.391.18v7.612l3.233-1.902v-7.552Zm9.09-5.316v7.532l2.124-1.25a.776.776 0 0 0 .387-.671V7.363Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$7a1ae7a9220f42df = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CopilotIcon", "octicon octicon-copilot", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.25 9a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 6.25 9Zm4.25.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.86 1.77c.05.053.097.107.14.164.043-.057.09-.111.14-.164.681-.731 1.737-.9 2.943-.765 1.23.136 2.145.527 2.724 1.26.566.716.693 1.614.693 2.485 0 .572-.053 1.147-.254 1.655l.168.838.066.033A2.75 2.75 0 0 1 16 9.736V11c0 .24-.086.438-.156.567-.073.131-.16.253-.259.366-.18.21-.404.413-.605.58a10.19 10.19 0 0 1-.792.597l-.015.01-.006.004-.028.018a8.849 8.849 0 0 1-.456.281c-.307.177-.749.41-1.296.642C11.296 14.528 9.756 15 8 15c-1.756 0-3.296-.472-4.387-.935a12.28 12.28 0 0 1-1.296-.641 8.849 8.849 0 0 1-.456-.281l-.028-.02-.006-.003-.015-.01a10.593 10.593 0 0 1-.792-.596 5.264 5.264 0 0 1-.605-.58 2.133 2.133 0 0 1-.259-.367A1.189 1.189 0 0 1 0 11V9.736a2.75 2.75 0 0 1 1.52-2.46l.067-.033.167-.838C1.553 5.897 1.5 5.322 1.5 4.75c0-.87.127-1.77.693-2.485.579-.733 1.494-1.124 2.724-1.26 1.206-.134 2.262.034 2.944.765ZM3 7.824v4.261c.02.013.043.025.065.038.264.152.65.356 1.134.562.972.412 2.307.815 3.801.815 1.494 0 2.83-.403 3.8-.815.412-.174.813-.375 1.2-.6v-4.26l-.023-.116c-.49.21-1.075.291-1.727.291-1.146 0-2.06-.328-2.71-.991A3.233 3.233 0 0 1 8 6.266c-.144.269-.321.52-.54.743C6.81 7.672 5.896 8 4.75 8c-.652 0-1.236-.082-1.726-.291L3 7.824Zm6.237-5.031c-.204.218-.359.678-.242 1.614.091.726.303 1.23.618 1.553.299.304.784.54 1.638.54.922 0 1.28-.199 1.442-.38.179-.2.308-.578.308-1.37 0-.765-.123-1.242-.37-1.555-.233-.296-.693-.586-1.713-.7-1.044-.116-1.488.091-1.681.298Zm-2.472 0c-.193-.207-.637-.414-1.681-.298-1.02.114-1.48.404-1.713.7-.247.313-.37.79-.37 1.555 0 .792.129 1.17.308 1.37.162.181.52.38 1.442.38.854 0 1.339-.236 1.638-.54.315-.323.527-.827.618-1.553.117-.936-.038-1.396-.242-1.614Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.75 14a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Zm4.5 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 2c2.214 0 4.248.657 5.747 1.756.136.099.268.204.397.312.584.235 1.077.546 1.474.952.85.869 1.132 2.037 1.132 3.368 0 .368-.014.733-.052 1.086l.633 1.478.043.022A4.75 4.75 0 0 1 24 15.222v1.028c0 .529-.309.987-.565 1.293-.28.336-.636.653-.966.918a13.84 13.84 0 0 1-1.299.911l-.024.015-.006.004-.039.025c-.223.135-.45.264-.68.386-.46.245-1.122.571-1.941.895C16.845 21.344 14.561 22 12 22c-2.561 0-4.845-.656-6.479-1.303a19.046 19.046 0 0 1-1.942-.894 14.081 14.081 0 0 1-.535-.3l-.144-.087-.04-.025-.006-.004-.024-.015a13.16 13.16 0 0 1-1.299-.911 6.913 6.913 0 0 1-.967-.918C.31 17.237 0 16.779 0 16.25v-1.028a4.75 4.75 0 0 1 2.626-4.248l.043-.022.633-1.478a10.195 10.195 0 0 1-.052-1.086c0-1.331.282-2.498 1.132-3.368.397-.406.89-.717 1.474-.952.129-.108.261-.213.397-.312C7.752 2.657 9.786 2 12 2Zm-8 9.654v6.669a17.59 17.59 0 0 0 2.073.98C7.595 19.906 9.686 20.5 12 20.5c2.314 0 4.405-.594 5.927-1.197a17.59 17.59 0 0 0 2.073-.98v-6.669l-.038-.09c-.046.061-.095.12-.145.177-.793.9-2.057 1.259-3.782 1.259-1.59 0-2.738-.544-3.508-1.492a4.323 4.323 0 0 1-.355-.508h-.344a4.323 4.323 0 0 1-.355.508C10.704 12.456 9.555 13 7.965 13c-1.725 0-2.989-.359-3.782-1.259a3.026 3.026 0 0 1-.145-.177Zm6.309-1.092c.445-.547.708-1.334.851-2.301.057-.357.087-.718.09-1.079v-.031c-.001-.762-.166-1.26-.43-1.568l-.008-.01c-.341-.391-1.046-.689-2.533-.529-1.505.163-2.347.537-2.824 1.024-.462.473-.705 1.18-.705 2.32 0 .605.044 1.087.135 1.472.092.384.231.672.423.89.365.413 1.084.75 2.657.75.91 0 1.527-.223 1.964-.564.14-.11.268-.235.38-.374Zm2.504-2.497c.136 1.057.403 1.913.878 2.497.442.545 1.134.938 2.344.938 1.573 0 2.292-.337 2.657-.751.384-.435.558-1.151.558-2.361 0-1.14-.243-1.847-.705-2.319-.477-.488-1.318-.862-2.824-1.025-1.487-.161-2.192.139-2.533.529-.268.308-.437.808-.438 1.578v.02c.002.299.023.598.063.894Z"
            }))
        },
        "48": {
            "width": 48,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M21 29.5a1.5 1.5 0 0 0-3 0v4a1.5 1.5 0 0 0 3 0v-4Zm9 0a1.5 1.5 0 0 0-3 0v4a1.5 1.5 0 0 0 3 0v-4Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M34.895 8.939c1.89.602 3.378 1.472 4.41 2.73 1.397 1.703 1.736 3.837 1.55 6.19l.016.032 1.684 3.79.964.193a3.5 3.5 0 0 1 2.161 1.398l1.668 2.335c.424.593.652 1.304.652 2.033v4.86c0 1.058-.619 1.973-1.129 2.585-.56.673-1.273 1.308-1.934 1.836a26.616 26.616 0 0 1-2.597 1.824l-.048.029h-.001l-.012.008-.021.014-.058.035c-.445.27-.898.528-1.358.773a37.655 37.655 0 0 1-3.883 1.79C33.69 42.69 29.123 44 24 44c-5.123 0-9.69-1.311-12.959-2.605a38.197 38.197 0 0 1-3.884-1.79c-.46-.245-.912-.503-1.357-.773l-.08-.05-.011-.007-.001-.001-.048-.03c-.041-.025-.1-.06-.173-.107a26.449 26.449 0 0 1-2.424-1.716c-.66-.528-1.373-1.163-1.934-1.836C.619 34.473 0 33.558 0 32.5v-4.86c0-.729.228-1.44.652-2.033l1.668-2.335a3.5 3.5 0 0 1 2.161-1.398l.964-.193 1.684-3.79.015-.032c-.185-2.353.154-4.487 1.55-6.19 1.033-1.258 2.52-2.128 4.411-2.73C15.84 6.82 19.71 5.5 24 5.5c4.29 0 8.16 1.321 10.895 3.439ZM23.643 20.5v-.001a8.385 8.385 0 0 1-.946 1.894c-1.263 1.866-3.286 3.044-6.18 3.297-3.115.273-5.498-.171-7.111-1.707a5.848 5.848 0 0 1-1.077-1.405l-.329.74v13.328c.163.092.353.197.569.312a35.355 35.355 0 0 0 3.577 1.647C15.19 39.811 19.373 41 24 41c4.627 0 8.809-1.189 11.854-2.394a35.238 35.238 0 0 0 3.576-1.647c.217-.115.407-.22.57-.312V23.32l-.329-.74a5.842 5.842 0 0 1-1.078 1.404c-1.612 1.536-3.995 1.98-7.11 1.707-2.894-.253-4.917-1.431-6.18-3.297a8.427 8.427 0 0 1-.946-1.894h-.714Zm-12.514.907c.107.152.222.286.346.404.675.643 1.966 1.138 4.78.892 2.139-.187 3.277-.985 3.958-1.99.067-.1.131-.203.192-.31.607-1.067.897-2.504.968-4.242.095-2.367-.35-3.664-1.021-4.309-.623-.599-1.877-1.034-4.506-.514-2.668.527-4.082 1.322-4.832 2.235-.721.88-1.047 2.144-.869 4.174.157 1.796.474 2.934.984 3.66Zm26.679-3.183c.017-.154.033-.313.047-.478.178-2.03-.148-3.294-.869-4.174-.75-.913-2.164-1.708-4.832-2.235-2.629-.52-3.883-.085-4.506.514-.671.645-1.116 1.942-1.021 4.31.071 1.737.361 3.174.968 4.24a4.7 4.7 0 0 0 .192.31c.638.943 1.679 1.703 3.568 1.948.129.017.259.031.389.043 2.111.184 3.365-.047 4.145-.447.26-.133.467-.285.636-.445.662-.63 1.073-1.711 1.283-3.586ZM22.5 17a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2h-1a1 1 0 0 0-1 1Z"
            }))
        },
        "96": {
            "width": 96,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M38 54a4 4 0 0 1 4 4v8a4 4 0 0 1-8 0v-8a4 4 0 0 1 4-4Zm24 4a4 4 0 0 0-8 0v8a4 4 0 1 0 8 0v-8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M25.013 15.024C31.008 10.628 39.145 8 48 8c8.855 0 16.992 2.628 22.987 7.024 3.64 2.67 6.553 6.05 8.278 9.92 1.615 2.744 2.114 5.94 1.968 9.397l3.898 9.026.355.07a10.996 10.996 0 0 1 6.794 4.394l2.416 3.382A7 7 0 0 1 96 55.282V65c0 2.116-1.238 3.947-2.258 5.17-1.122 1.347-2.547 2.616-3.868 3.673a52.899 52.899 0 0 1-3.647 2.653c-.51.34-1.025.671-1.546.993l-.061.037-.036.022-.002.001-.024.015-.158.099c-.134.083-.327.201-.576.348-.704.415-1.417.815-2.139 1.199a76.495 76.495 0 0 1-7.768 3.58C67.381 85.377 58.245 88 48 88c-10.245 0-19.381-2.622-25.917-5.21a76.495 76.495 0 0 1-7.768-3.58 55.966 55.966 0 0 1-2.14-1.199 34.102 34.102 0 0 1-.733-.447l-.024-.015-.002-.001-.038-.023-.059-.036-.345-.215a54.57 54.57 0 0 1-1.2-.778 52.918 52.918 0 0 1-3.648-2.653c-1.321-1.057-2.746-2.326-3.868-3.672C1.238 68.946 0 67.116 0 65v-9.718a7 7 0 0 1 1.304-4.069l2.416-3.382a10.998 10.998 0 0 1 6.794-4.393l.355-.071 3.898-9.026c-.146-3.457.353-6.654 1.968-9.398 1.725-3.87 4.637-7.249 8.278-9.919ZM16 46.62v26.671c.326.184.706.394 1.138.624a70.399 70.399 0 0 0 7.154 3.295C30.381 79.622 38.745 82 48 82c9.255 0 17.618-2.378 23.708-4.789a70.406 70.406 0 0 0 7.154-3.296c.432-.23.812-.44 1.138-.624V46.62l-.983-2.275a11.56 11.56 0 0 1-2.281 3.065c-3.167 3.016-7.836 3.88-13.914 3.348-5.658-.495-9.622-2.8-12.098-6.457a13.9 13.9 0 0 1-.213-.324c-1.674.031-3.348.031-5.022 0-.07.109-.141.217-.213.324-2.476 3.657-6.44 5.962-12.098 6.457-6.077.532-10.747-.332-13.914-3.348a11.586 11.586 0 0 1-2.282-3.065Zm24.307-5.683c1.427-2.108 2.097-5.107 2.247-8.826.185-4.606-.683-7.105-1.965-8.337-1.187-1.139-3.597-1.991-8.71-.981-5.191 1.025-7.925 2.568-9.368 4.328-1.388 1.692-2.022 4.13-1.677 8.076.199 2.276.53 4.003 1.007 5.316.358.985.799 1.738 1.328 2.315.075.082.153.161.233.237 1.21 1.153 3.471 2.073 8.261 1.789.32-.019.65-.043.992-.073 1.952-.171 3.472-.603 4.67-1.216a7.8 7.8 0 0 0 2.982-2.628Zm15.386 0a7.8 7.8 0 0 0 2.982 2.628c1.198.613 2.718 1.045 4.67 1.216 5.475.479 7.962-.486 9.253-1.716.634-.604 1.151-1.425 1.56-2.551.478-1.314.808-3.04 1.008-5.317.345-3.946-.289-6.384-1.677-8.076-1.443-1.76-4.177-3.303-9.368-4.328-5.113-1.01-7.523-.158-8.71.981-1.282 1.232-2.15 3.731-1.965 8.337.15 3.719.82 6.718 2.247 8.826Zm-9.27-5.997a6.498 6.498 0 0 1 3.154 0l.06.015a1.498 1.498 0 0 0 1.463-.399 1.498 1.498 0 0 0-.736-2.511l-.06-.015a9.504 9.504 0 0 0-4.608 0l-.06.015a1.498 1.498 0 0 0-.73 2.508 1.5 1.5 0 0 0 1.458.402l.06-.015Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$e5748a8abdfef92a = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CopilotErrorIcon", "octicon octicon-copilot-error", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M.865 2.759v.001l14.82 10.722a.755.755 0 0 0 .188.1.751.751 0 0 1-1.063 1.025l-1.415-1.024c-.274.147-.613.315-1.008.482C11.296 14.528 9.756 15 8 15c-1.756 0-3.296-.473-4.387-.934a11.947 11.947 0 0 1-1.654-.859l-.098-.065-.028-.018-.006-.004-.015-.01a10.19 10.19 0 0 1-.792-.597 5.145 5.145 0 0 1-.605-.58 2.185 2.185 0 0 1-.259-.366A1.193 1.193 0 0 1 0 11V9.736a2.75 2.75 0 0 1 1.52-2.46l.067-.033.167-.838c-.175-.442-.238-.936-.251-1.434L.31 4.107a.75.75 0 0 1 .555-1.348ZM7.86 1.77c.05.053.097.107.14.164.043-.057.09-.111.14-.164.681-.731 1.737-.9 2.943-.765 1.23.136 2.145.527 2.724 1.26.566.716.693 1.614.693 2.485 0 .572-.053 1.147-.254 1.655l.168.838.066.033A2.75 2.75 0 0 1 16 9.736V11c0 .24-.086.438-.156.567a1.59 1.59 0 0 1-.075.125L13 9.688V7.824l-.023-.115c-.49.21-1.075.291-1.727.291-.22 0-.43-.012-.633-.036L6.824 5.22c.082-.233.143-.503.182-.813.117-.936-.038-1.396-.242-1.614-.193-.207-.637-.414-1.681-.298-.707.079-1.144.243-1.424.434l-1.251-.905c.58-.579 1.422-.899 2.51-1.02 1.205-.133 2.26.035 2.943.766ZM4.75 8c-.652 0-1.237-.081-1.727-.291L3 7.825v4.26c.387.225.788.426 1.2.6.97.412 2.306.815 3.8.815 1.494 0 2.829-.403 3.801-.815.076-.033.15-.065.22-.097L5.594 7.934A5.158 5.158 0 0 1 4.75 8Zm4.486-5.207c-.204.218-.359.678-.242 1.614.091.726.303 1.23.618 1.553.299.304.784.54 1.638.54.922 0 1.28-.199 1.442-.38.179-.2.308-.578.308-1.37 0-.765-.123-1.242-.37-1.555-.233-.296-.693-.586-1.713-.7-1.044-.116-1.488.091-1.681.298Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$6a1620fc303afef = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CopilotWarningIcon", "octicon octicon-copilot-warning", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.86 1.77c.05.053.097.107.14.164.043-.057.09-.111.14-.164.681-.731 1.737-.9 2.943-.765 1.23.136 2.145.527 2.724 1.26.566.716.693 1.614.693 2.485 0 .463-.035.929-.155 1.359a6.015 6.015 0 0 0-1.398-.616c.034-.195.053-.439.053-.743 0-.766-.123-1.242-.37-1.555-.233-.296-.693-.586-1.713-.7-1.044-.116-1.488.091-1.681.298-.204.218-.359.678-.242 1.614.06.479.172.86.332 1.158a6.014 6.014 0 0 0-2.92 2.144C5.926 7.904 5.372 8 4.75 8c-.652 0-1.237-.082-1.727-.291L3 7.824v4.261c.02.013.043.025.065.038a10.83 10.83 0 0 0 2.495 1.035c.21.629.522 1.21.916 1.726a11.883 11.883 0 0 1-2.863-.819 12.28 12.28 0 0 1-1.296-.641 8.849 8.849 0 0 1-.456-.281l-.028-.02-.006-.003-.015-.01a10.593 10.593 0 0 1-.792-.596 5.264 5.264 0 0 1-.605-.58 2.133 2.133 0 0 1-.259-.367A1.189 1.189 0 0 1 0 11V9.736a2.75 2.75 0 0 1 1.52-2.46l.067-.033.167-.838C1.553 5.897 1.5 5.322 1.5 4.75c0-.87.127-1.77.693-2.485.579-.733 1.494-1.124 2.724-1.26 1.206-.134 2.262.034 2.944.765ZM6.765 2.793c-.193-.207-.637-.414-1.681-.298-1.02.114-1.48.404-1.713.7-.247.313-.37.79-.37 1.555 0 .792.129 1.17.308 1.37.162.181.52.38 1.442.38.854 0 1.339-.236 1.638-.54.315-.323.527-.827.618-1.553.117-.936-.038-1.396-.242-1.614Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.498 14.81v.001a4.5 4.5 0 1 1 5.503-7.12 4.5 4.5 0 0 1-5.503 7.119ZM10.5 8.75V11a.75.75 0 0 0 1.5 0V8.75a.75.75 0 0 0-1.5 0Zm.75 5.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$51b6cd98f8778f0d = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CopyIcon", "octicon octicon-copy", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.024 3.75c0-.966.784-1.75 1.75-1.75H20.25c.966 0 1.75.784 1.75 1.75v11.498a1.75 1.75 0 0 1-1.75 1.75H8.774a1.75 1.75 0 0 1-1.75-1.75Zm1.75-.25a.25.25 0 0 0-.25.25v11.498c0 .139.112.25.25.25H20.25a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.995 10.749a1.75 1.75 0 0 1 1.75-1.751H5.25a.75.75 0 1 1 0 1.5H3.745a.25.25 0 0 0-.25.25L3.5 20.25c0 .138.111.25.25.25h9.5a.25.25 0 0 0 .25-.25v-1.51a.75.75 0 1 1 1.5 0v1.51A1.75 1.75 0 0 1 13.25 22h-9.5A1.75 1.75 0 0 1 2 20.25l-.005-9.501Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$a99af643ba9e93d6 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CpuIcon", "octicon octicon-cpu", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.5.75V2h3V.75a.75.75 0 0 1 1.5 0V2h1.25c.966 0 1.75.784 1.75 1.75V5h1.25a.75.75 0 0 1 0 1.5H14v3h1.25a.75.75 0 0 1 0 1.5H14v1.25A1.75 1.75 0 0 1 12.25 14H11v1.25a.75.75 0 0 1-1.5 0V14h-3v1.25a.75.75 0 0 1-1.5 0V14H3.75A1.75 1.75 0 0 1 2 12.25V11H.75a.75.75 0 0 1 0-1.5H2v-3H.75a.75.75 0 0 1 0-1.5H2V3.75C2 2.784 2.784 2 3.75 2H5V.75a.75.75 0 0 1 1.5 0Zm5.75 11.75a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25ZM5.75 5h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75v-4.5A.75.75 0 0 1 5.75 5Zm.75 4.5h3v-3h-3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.75 8h6.5a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75h-6.5a.75.75 0 0 1-.75-.75v-6.5A.75.75 0 0 1 8.75 8Zm.75 6.5h5v-5h-5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15.25 1a.75.75 0 0 1 .75.75V4h2.25c.966 0 1.75.784 1.75 1.75V8h2.25a.75.75 0 0 1 0 1.5H20v5h2.25a.75.75 0 0 1 0 1.5H20v2.25A1.75 1.75 0 0 1 18.25 20H16v2.25a.75.75 0 0 1-1.5 0V20h-5v2.25a.75.75 0 0 1-1.5 0V20H5.75A1.75 1.75 0 0 1 4 18.25V16H1.75a.75.75 0 0 1 0-1.5H4v-5H1.75a.75.75 0 0 1 0-1.5H4V5.75C4 4.784 4.784 4 5.75 4H8V1.75a.75.75 0 0 1 1.5 0V4h5V1.75a.75.75 0 0 1 .75-.75Zm3 17.5a.25.25 0 0 0 .25-.25V5.75a.25.25 0 0 0-.25-.25H5.75a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$9aecafbc92062ce3 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CreditCardIcon", "octicon octicon-credit-card", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.75 9a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 3.75C0 2.784.784 2 1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25ZM14.5 6.5h-13v5.75c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25Zm0-2.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25V5h13Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15.25 14a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25V4.75C0 3.784.784 3 1.75 3Zm-.25 7v9.25c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V10Zm0-5.25V8.5h21V4.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$63f0d8a59fc7d9b4 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("CrossReferenceIcon", "octicon octicon-cross-reference", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.75 3.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h4.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 13H9.06l-2.573 2.573A1.458 1.458 0 0 1 4 14.543V13H2.75A1.75 1.75 0 0 1 1 11.25v-7.5C1 2.784 1.784 2 2.75 2h5.5a.75.75 0 0 1 0 1.5ZM16 1.25v4.146a.25.25 0 0 1-.427.177L14.03 4.03l-3.75 3.75a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l3.75-3.75-1.543-1.543A.25.25 0 0 1 11.604 1h4.146a.25.25 0 0 1 .25.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16.5 2.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V4.06l-6.22 6.22a.75.75 0 1 1-1.06-1.06L20.94 3h-3.69a.75.75 0 0 1-.75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.25 4a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 .75.75v3.19l3.72-3.72a.75.75 0 0 1 .53-.22h10a.25.25 0 0 0 .25-.25v-6a.75.75 0 0 1 1.5 0v6a1.75 1.75 0 0 1-1.75 1.75h-9.69l-3.573 3.573A1.457 1.457 0 0 1 5 21.043V18.5H3.25a1.75 1.75 0 0 1-1.75-1.75V4.25c0-.966.784-1.75 1.75-1.75h11a.75.75 0 0 1 0 1.5h-11Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$a2bc8cb49334c5d1 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DashIcon", "octicon octicon-dash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 7.75A.75.75 0 0 1 2.75 7h10a.75.75 0 0 1 0 1.5h-10A.75.75 0 0 1 2 7.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.5 12.75a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 0 1.5H5.25a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$9f40554892cbf4af = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DatabaseIcon", "octicon octicon-database", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 3.5c0-.626.292-1.165.7-1.59.406-.422.956-.767 1.579-1.041C4.525.32 6.195 0 8 0c1.805 0 3.475.32 4.722.869.622.274 1.172.62 1.578 1.04.408.426.7.965.7 1.591v9c0 .626-.292 1.165-.7 1.59-.406.422-.956.767-1.579 1.041C11.476 15.68 9.806 16 8 16c-1.805 0-3.475-.32-4.721-.869-.623-.274-1.173-.62-1.579-1.04-.408-.426-.7-.965-.7-1.591Zm1.5 0c0 .133.058.318.282.551.227.237.591.483 1.101.707C4.898 5.205 6.353 5.5 8 5.5c1.646 0 3.101-.295 4.118-.742.508-.224.873-.471 1.1-.708.224-.232.282-.417.282-.55 0-.133-.058-.318-.282-.551-.227-.237-.591-.483-1.101-.707C11.102 1.795 9.647 1.5 8 1.5c-1.646 0-3.101.295-4.118.742-.508.224-.873.471-1.1.708-.224.232-.282.417-.282.55Zm0 4.5c0 .133.058.318.282.551.227.237.591.483 1.101.707C4.898 9.705 6.353 10 8 10c1.646 0 3.101-.295 4.118-.742.508-.224.873-.471 1.1-.708.224-.232.282-.417.282-.55V5.724c-.241.15-.503.286-.778.407C11.475 6.68 9.805 7 8 7c-1.805 0-3.475-.32-4.721-.869a6.15 6.15 0 0 1-.779-.407Zm0 2.225V12.5c0 .133.058.318.282.55.227.237.592.484 1.1.708 1.016.447 2.471.742 4.118.742 1.647 0 3.102-.295 4.117-.742.51-.224.874-.47 1.101-.707.224-.233.282-.418.282-.551v-2.275c-.241.15-.503.285-.778.406-1.247.549-2.917.869-4.722.869-1.805 0-3.475-.32-4.721-.869a6.327 6.327 0 0 1-.779-.406Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1.25c2.487 0 4.773.402 6.466 1.079.844.337 1.577.758 2.112 1.264.536.507.922 1.151.922 1.907v12.987l-.026.013h.026c0 .756-.386 1.4-.922 1.907-.535.506-1.268.927-2.112 1.264-1.693.677-3.979 1.079-6.466 1.079s-4.774-.402-6.466-1.079c-.844-.337-1.577-.758-2.112-1.264C2.886 19.9 2.5 19.256 2.5 18.5h.026l-.026-.013V5.5c0-.756.386-1.4.922-1.907.535-.506 1.268-.927 2.112-1.264C7.226 1.652 9.513 1.25 12 1.25ZM4 14.371v4.116l-.013.013H4c0 .211.103.487.453.817.351.332.898.666 1.638.962 1.475.589 3.564.971 5.909.971 2.345 0 4.434-.381 5.909-.971.739-.296 1.288-.63 1.638-.962.349-.33.453-.607.453-.817h.013L20 18.487v-4.116a7.85 7.85 0 0 1-1.534.8c-1.693.677-3.979 1.079-6.466 1.079s-4.774-.402-6.466-1.079a7.843 7.843 0 0 1-1.534-.8ZM20 12V7.871a7.85 7.85 0 0 1-1.534.8C16.773 9.348 14.487 9.75 12 9.75s-4.774-.402-6.466-1.079A7.85 7.85 0 0 1 4 7.871V12c0 .21.104.487.453.817.35.332.899.666 1.638.961 1.475.59 3.564.972 5.909.972 2.345 0 4.434-.382 5.909-.972.74-.295 1.287-.629 1.638-.96.35-.33.453-.607.453-.818ZM4 5.5c0 .211.103.487.453.817.351.332.898.666 1.638.962 1.475.589 3.564.971 5.909.971 2.345 0 4.434-.381 5.909-.971.739-.296 1.288-.63 1.638-.962.349-.33.453-.607.453-.817 0-.211-.103-.487-.453-.817-.351-.332-.898-.666-1.638-.962-1.475-.589-3.564-.971-5.909-.971-2.345 0-4.434.381-5.909.971-.739.296-1.288.63-1.638.962C4.104 5.013 4 5.29 4 5.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$3751480e384bbd82 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DependabotIcon", "octicon octicon-dependabot", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.75 7.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75Zm5.25.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.25 0h2A.75.75 0 0 1 9 .75V3.5h3.25a2.25 2.25 0 0 1 2.25 2.25V8h.75a.75.75 0 0 1 0 1.5h-.75v2.75a2.25 2.25 0 0 1-2.25 2.25h-8.5a2.25 2.25 0 0 1-2.25-2.25V9.5H.75a.75.75 0 0 1 0-1.5h.75V5.75A2.25 2.25 0 0 1 3.75 3.5H7.5v-2H6.25a.75.75 0 0 1 0-1.5ZM3 5.75v6.5c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75v-6.5a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0-.75.75Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.75 11a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Zm7.25.75a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0v-3.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.813 1h2.437a.75.75 0 0 1 .75.75V5h6.75A2.25 2.25 0 0 1 22 7.25v5.25h1.25a.75.75 0 0 1 0 1.5H22v5.75A2.25 2.25 0 0 1 19.75 22H4.25A2.25 2.25 0 0 1 2 19.75V14H.75a.75.75 0 0 1 0-1.5H2V7.25A2.25 2.25 0 0 1 4.25 5h7.25V2.5H9.813A.75.75 0 0 1 9.812 1ZM3.5 7.25v12.5c0 .414.336.75.75.75h15.5a.75.75 0 0 0 .75-.75V7.25a.75.75 0 0 0-.75-.75H4.25a.75.75 0 0 0-.75.75Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$ec27283855b6356a = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DesktopDownloadIcon", "octicon octicon-desktop-download", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m4.927 5.427 2.896 2.896a.25.25 0 0 0 .354 0l2.896-2.896A.25.25 0 0 0 10.896 5H8.75V.75a.75.75 0 1 0-1.5 0V5H5.104a.25.25 0 0 0-.177.427Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.573 2.573a.25.25 0 0 0-.073.177v7.5a.25.25 0 0 0 .25.25h12.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25h-3a.75.75 0 1 1 0-1.5h3A1.75 1.75 0 0 1 16 2.75v7.5A1.75 1.75 0 0 1 14.25 12h-3.727c.099 1.041.52 1.872 1.292 2.757A.75.75 0 0 1 11.25 16h-6.5a.75.75 0 0 1-.565-1.243c.772-.885 1.192-1.716 1.292-2.757H1.75A1.75 1.75 0 0 1 0 10.25v-7.5A1.75 1.75 0 0 1 1.75 1h3a.75.75 0 0 1 0 1.5h-3a.25.25 0 0 0-.177.073ZM6.982 12a5.72 5.72 0 0 1-.765 2.5h3.566a5.72 5.72 0 0 1-.765-2.5H6.982Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.25 9.331V.75a.75.75 0 0 1 1.5 0v8.58l1.949-2.11A.75.75 0 1 1 15.8 8.237l-3.25 3.52a.75.75 0 0 1-1.102 0l-3.25-3.52A.75.75 0 1 1 9.3 7.22l1.949 2.111Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.5 3.75v11.5c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25h-5.5a.75.75 0 0 1 0-1.5h5.5c.966 0 1.75.784 1.75 1.75v11.5A1.75 1.75 0 0 1 21.25 17h-6.204c.171 1.375.805 2.652 1.769 3.757A.752.752 0 0 1 16.25 22h-8.5a.75.75 0 0 1-.566-1.243c.965-1.105 1.599-2.382 1.77-3.757H2.75A1.75 1.75 0 0 1 1 15.25V3.75C1 2.784 1.784 2 2.75 2h5.5a.75.75 0 0 1 0 1.5h-5.5a.25.25 0 0 0-.25.25ZM10.463 17c-.126 1.266-.564 2.445-1.223 3.5h5.52c-.66-1.055-1.098-2.234-1.223-3.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$24558ca47a308df5 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DeviceCameraIcon", "octicon octicon-device-camera", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15 3c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1 0-.55.45-1 1-1h4c.55 0 1 .45 1 1Zm-4.5 9c1.94 0 3.5-1.56 3.5-3.5S12.44 5 10.5 5 7 6.56 7 8.5 8.56 12 10.5 12ZM13 8.5c0 1.38-1.13 2.5-2.5 2.5S8 9.87 8 8.5 9.13 6 10.5 6 13 7.13 13 8.5ZM6 5V4H2v1Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$e11bb7c98c7dfbc5 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DeviceCameraVideoIcon", "octicon octicon-device-camera-video", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16 3.75v8.5a.75.75 0 0 1-1.136.643L11 10.575v.675A1.75 1.75 0 0 1 9.25 13h-7.5A1.75 1.75 0 0 1 0 11.25v-6.5C0 3.784.784 3 1.75 3h7.5c.966 0 1.75.784 1.75 1.75v.675l3.864-2.318A.75.75 0 0 1 16 3.75Zm-6.5 1a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25v6.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-6.5ZM11 8.825l3.5 2.1v-5.85l-3.5 2.1Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M24 5.25v13a.75.75 0 0 1-1.136.643L16.5 15.075v2.175A1.75 1.75 0 0 1 14.75 19h-13A1.75 1.75 0 0 1 0 17.25v-11C0 5.284.784 4.5 1.75 4.5h13c.966 0 1.75.784 1.75 1.75v2.175l6.364-3.818A.75.75 0 0 1 24 5.25Zm-9 1a.25.25 0 0 0-.25-.25h-13a.25.25 0 0 0-.25.25v11c0 .138.112.25.25.25h13a.25.25 0 0 0 .25-.25v-11Zm1.5 7.075 6 3.6V6.575l-6 3.6Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$64e9f470ca3ab9af = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DeviceDesktopIcon", "octicon octicon-device-desktop", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M14.25 1c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0 1 14.25 12h-3.727c.099 1.041.52 1.872 1.292 2.757A.752.752 0 0 1 11.25 16h-6.5a.75.75 0 0 1-.565-1.243c.772-.885 1.192-1.716 1.292-2.757H1.75A1.75 1.75 0 0 1 0 10.25v-7.5C0 1.784.784 1 1.75 1ZM1.75 2.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25ZM9.018 12H6.982a5.72 5.72 0 0 1-.765 2.5h3.566a5.72 5.72 0 0 1-.765-2.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.954 17H2.75A1.75 1.75 0 0 1 1 15.25V3.75C1 2.784 1.784 2 2.75 2h18.5c.966 0 1.75.784 1.75 1.75v11.5A1.75 1.75 0 0 1 21.25 17h-6.204c.171 1.375.805 2.652 1.769 3.757A.752.752 0 0 1 16.25 22h-8.5a.75.75 0 0 1-.565-1.243c.964-1.105 1.598-2.382 1.769-3.757ZM21.5 3.75a.25.25 0 0 0-.25-.25H2.75a.25.25 0 0 0-.25.25v11.5c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25ZM13.537 17h-3.074c-.126 1.266-.564 2.445-1.223 3.5h5.52c-.659-1.055-1.098-2.234-1.223-3.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$f5f71ba58a96f313 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DeviceMobileIcon", "octicon octicon-device-mobile", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.75 0h8.5C13.216 0 14 .784 14 1.75v12.5A1.75 1.75 0 0 1 12.25 16h-8.5A1.75 1.75 0 0 1 2 14.25V1.75C2 .784 2.784 0 3.75 0ZM3.5 1.75v12.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25ZM8 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.25 5.25A.75.75 0 0 1 11 4.5h2A.75.75 0 0 1 13 6h-2a.75.75 0 0 1-.75-.75ZM12 19.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4 2.75C4 1.784 4.784 1 5.75 1h12.5c.966 0 1.75.784 1.75 1.75v18.5A1.75 1.75 0 0 1 18.25 23H5.75A1.75 1.75 0 0 1 4 21.25Zm1.75-.25a.25.25 0 0 0-.25.25v18.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$5e3451d6d1223703 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DiamondIcon", "octicon octicon-diamond", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M.527 9.237a1.75 1.75 0 0 1 0-2.474L6.777.512a1.75 1.75 0 0 1 2.475 0l6.251 6.25a1.75 1.75 0 0 1 0 2.475l-6.25 6.251a1.75 1.75 0 0 1-2.475 0L.527 9.238Zm1.06-1.414a.25.25 0 0 0 0 .354l6.251 6.25a.25.25 0 0 0 .354 0l6.25-6.25a.25.25 0 0 0 0-.354l-6.25-6.25a.25.25 0 0 0-.354 0l-6.25 6.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.527 13.237a1.75 1.75 0 0 1 0-2.474l9.272-9.273a1.75 1.75 0 0 1 2.475 0l9.272 9.273a1.75 1.75 0 0 1 0 2.474l-9.272 9.272a1.75 1.75 0 0 1-2.475 0Zm1.06-1.414a.25.25 0 0 0 0 .354l9.273 9.272a.25.25 0 0 0 .353 0l9.272-9.272a.25.25 0 0 0 0-.354l-9.272-9.272a.25.25 0 0 0-.353 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$7757fa22cc9fb809 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DiffIcon", "octicon octicon-diff", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.75 1.75V5H12a.75.75 0 0 1 0 1.5H8.75v3.25a.75.75 0 0 1-1.5 0V6.5H4A.75.75 0 0 1 4 5h3.25V1.75a.75.75 0 0 1 1.5 0ZM4 13h8a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 4 13Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.25 3.5a.75.75 0 0 1 .75.75V8.5h4.25a.75.75 0 0 1 0 1.5H13v4.25a.75.75 0 0 1-1.5 0V10H7.25a.75.75 0 0 1 0-1.5h4.25V4.25a.75.75 0 0 1 .75-.75ZM6.562 19.25a.75.75 0 0 1 .75-.75h9.938a.75.75 0 0 1 0 1.5H7.312a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$922260bf5f8ffbaa = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DiffAddedIcon", "octicon octicon-diff-added", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.75 1h10.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1Zm10.5 1.5H2.75a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25ZM8 4a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5A.75.75 0 0 1 8 4Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$3e6f00c5163da869 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DiffIgnoredIcon", "octicon octicon-diff-ignored", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.25 1c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Zm8.53 3.28-5.5 5.5a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l5.5-5.5a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$4149915caab8aa5e = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DiffModifiedIcon", "octicon octicon-diff-modified", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.25 1c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25ZM8 10a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 10Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$6e5f778d88fc462 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DiffRemovedIcon", "octicon octicon-diff-removed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.25 1c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Zm8.5 6.25h-6.5a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$316a6a88990c13e4 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DiffRenamedIcon", "octicon octicon-diff-renamed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.25 1c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Zm9.03 6.03-3.25 3.25a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.97-1.97H4.75a.75.75 0 0 1 0-1.5h4.69L7.47 5.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l3.25 3.25a.75.75 0 0 1 0 1.06Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$69ef1d9fb7859fb5 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DiscussionClosedIcon", "octicon octicon-discussion-closed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 2.75C0 1.783.784 1 1.75 1h8.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 10.25 10H7.061l-2.574 2.573A1.457 1.457 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25Zm1.75-.25a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h1a.75.75 0 0 1 .75.75v2.189L6.22 8.72a.747.747 0 0 1 .53-.22h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm12.5 2h-.5a.75.75 0 0 1 0-1.5h.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 12H14v1.543a1.457 1.457 0 0 1-2.487 1.03L9.22 12.28a.749.749 0 1 1 1.06-1.06l2.22 2.219V11.25a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm-5.47.28-3 3a.747.747 0 0 1-1.06 0l-1.5-1.5a.749.749 0 1 1 1.06-1.06l.97.969L7.72 3.72a.749.749 0 1 1 1.06 1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 2.75C0 1.783.784 1 1.75 1h12.5c.967 0 1.75.783 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.457 1.457 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.189l2.72-2.719a.747.747 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm20.5 6h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5c.199 0 .39.079.53.22l2.72 2.719V19.25a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm-9.72-3.22-5 5a.747.747 0 0 1-1.06 0l-2.5-2.5a.749.749 0 1 1 1.06-1.06L7 8.689l4.47-4.469a.749.749 0 1 1 1.06 1.06Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$2516f0e9108eb4ee = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DiscussionDuplicateIcon", "octicon octicon-discussion-duplicate", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 2.75C0 1.783.784 1 1.75 1h8.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 10.25 10H7.061l-2.574 2.573A1.457 1.457 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25Zm1.75-.25a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h1a.75.75 0 0 1 .75.75v2.189L6.22 8.72a.747.747 0 0 1 .53-.22h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm12.5 2h-.5a.75.75 0 0 1 0-1.5h.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 12H14v1.543a1.457 1.457 0 0 1-2.487 1.03L9.22 12.28a.749.749 0 1 1 1.06-1.06l2.22 2.219V11.25a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm-6.282.03L5.03 7.468a.749.749 0 1 1-1.06-1.061L6.907 3.47a.75.75 0 0 1 1.061 1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 2.75C0 1.783.784 1 1.75 1h12.5c.967 0 1.75.783 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.457 1.457 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.189l2.72-2.719a.747.747 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm20.5 6h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5c.199 0 .39.079.53.22l2.72 2.719V19.25a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25ZM11.28 5.53l-5 5a.749.749 0 1 1-1.06-1.06l5-5a.749.749 0 1 1 1.06 1.06Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$e505b62afe0037a9 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DiscussionOutdatedIcon", "octicon octicon-discussion-outdated", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 2.75C0 1.783.784 1 1.75 1h8.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 10.25 10H7.061l-2.574 2.573A1.457 1.457 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25Zm1.75-.25a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h1a.75.75 0 0 1 .75.75v2.189L6.22 8.72a.747.747 0 0 1 .53-.22h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm12.5 2h-.5a.75.75 0 0 1 0-1.5h.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 12H14v1.543a1.457 1.457 0 0 1-2.487 1.03L9.22 12.28a.749.749 0 1 1 1.06-1.06l2.22 2.219V11.25a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25ZM6.5 4v1.492l.466.187.036.015.812.375a.75.75 0 1 1-.628 1.362l-.795-.367-.92-.368A.75.75 0 0 1 5 6V4a.75.75 0 0 1 1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 2.75C0 1.783.784 1 1.75 1h12.5c.967 0 1.75.783 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.457 1.457 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.189l2.72-2.719a.747.747 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm20.5 6h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5c.199 0 .39.079.53.22l2.72 2.719V19.25a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25ZM8.5 4.75v3.14l1.15.488a.608.608 0 0 1 .037.017l1.393.681a.75.75 0 0 1-.66 1.348l-1.374-.673-1.589-.674A.751.751 0 0 1 7 8.386V4.75a.75.75 0 0 1 1.5 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$1638d451d4588271 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DotIcon", "octicon octicon-dot", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-1.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$7930088993b77a6b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DotFillIcon", "octicon octicon-dot-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$4e54df4252b4a99c = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DownloadIcon", "octicon octicon-download", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.75 14A1.75 1.75 0 0 1 1 12.25v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 14Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.25 7.689V2a.75.75 0 0 1 1.5 0v5.689l1.97-1.969a.749.749 0 1 1 1.06 1.06l-3.25 3.25a.749.749 0 0 1-1.06 0L4.22 6.78a.749.749 0 1 1 1.06-1.06l1.97 1.969Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.75 17.25a.75.75 0 0 1 .75.75v2.25c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V18a.75.75 0 0 1 1.5 0v2.25A1.75 1.75 0 0 1 18.25 22H5.75A1.75 1.75 0 0 1 4 20.25V18a.75.75 0 0 1 .75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.22 9.97a.749.749 0 0 1 1.06 0l4.97 4.969V2.75a.75.75 0 0 1 1.5 0v12.189l4.97-4.969a.749.749 0 1 1 1.06 1.06l-6.25 6.25a.749.749 0 0 1-1.06 0l-6.25-6.25a.749.749 0 0 1 0-1.06Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$10862138e9169702 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("DuplicateIcon", "octicon octicon-duplicate", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.5 3a.75.75 0 0 1 .75.75v1h1a.75.75 0 0 1 0 1.5h-1v1a.75.75 0 0 1-1.5 0v-1h-1a.75.75 0 0 1 0-1.5h1v-1A.75.75 0 0 1 10.5 3Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25v-7.5C5 .784 5.784 0 6.75 0ZM6.5 1.75v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 5A1.75 1.75 0 0 0 0 6.75v7.5C0 15.216.784 16 1.75 16h7.5A1.75 1.75 0 0 0 11 14.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.25.25 0 0 1-.25.25h-7.5a.25.25 0 0 1-.25-.25v-7.5a.25.25 0 0 1 .25-.25h1.5a.75.75 0 0 0 0-1.5h-1.5Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M14.513 6a.75.75 0 0 1 .75.75v2h1.987a.75.75 0 0 1 0 1.5h-1.987v2a.75.75 0 1 1-1.5 0v-2H11.75a.75.75 0 0 1 0-1.5h2.013v-2a.75.75 0 0 1 .75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.024 3.75c0-.966.784-1.75 1.75-1.75H20.25c.966 0 1.75.784 1.75 1.75v11.498a1.75 1.75 0 0 1-1.75 1.75H8.774a1.75 1.75 0 0 1-1.75-1.75Zm1.75-.25a.25.25 0 0 0-.25.25v11.498c0 .139.112.25.25.25H20.25a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.995 10.749a1.75 1.75 0 0 1 1.75-1.751H5.25a.75.75 0 1 1 0 1.5H3.745a.25.25 0 0 0-.25.25L3.5 20.25c0 .138.111.25.25.25h9.5a.25.25 0 0 0 .25-.25v-1.51a.75.75 0 1 1 1.5 0v1.51A1.75 1.75 0 0 1 13.25 22h-9.5A1.75 1.75 0 0 1 2 20.25l-.005-9.501Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$fc6234d5b1c606d7 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("EllipsisIcon", "octicon octicon-ellipsis", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 5.75C0 4.784.784 4 1.75 4h12.5c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0 1 14.25 12H1.75A1.75 1.75 0 0 1 0 10.25ZM12 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM7 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0ZM4 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$4b2c798a70974642 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("EyeIcon", "octicon octicon-eye", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 2c1.981 0 3.671.992 4.933 2.078 1.27 1.091 2.187 2.345 2.637 3.023a1.62 1.62 0 0 1 0 1.798c-.45.678-1.367 1.932-2.637 3.023C11.67 13.008 9.981 14 8 14c-1.981 0-3.671-.992-4.933-2.078C1.797 10.83.88 9.576.43 8.898a1.62 1.62 0 0 1 0-1.798c.45-.677 1.367-1.931 2.637-3.022C4.33 2.992 6.019 2 8 2ZM1.679 7.932a.12.12 0 0 0 0 .136c.411.622 1.241 1.75 2.366 2.717C5.176 11.758 6.527 12.5 8 12.5c1.473 0 2.825-.742 3.955-1.715 1.124-.967 1.954-2.096 2.366-2.717a.12.12 0 0 0 0-.136c-.412-.621-1.242-1.75-2.366-2.717C10.824 4.242 9.473 3.5 8 3.5c-1.473 0-2.825.742-3.955 1.715-1.124.967-1.954 2.096-2.366 2.717ZM8 10a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 10Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15.5 12a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 3.5c3.432 0 6.124 1.534 8.054 3.241 1.926 1.703 3.132 3.61 3.616 4.46a1.6 1.6 0 0 1 0 1.598c-.484.85-1.69 2.757-3.616 4.461-1.929 1.706-4.622 3.24-8.054 3.24-3.432 0-6.124-1.534-8.054-3.24C2.02 15.558.814 13.65.33 12.8a1.6 1.6 0 0 1 0-1.598c.484-.85 1.69-2.757 3.616-4.462C5.875 5.034 8.568 3.5 12 3.5ZM1.633 11.945a.115.115 0 0 0-.017.055c.001.02.006.039.017.056.441.774 1.551 2.527 3.307 4.08C6.691 17.685 9.045 19 12 19c2.955 0 5.31-1.315 7.06-2.864 1.756-1.553 2.866-3.306 3.307-4.08a.111.111 0 0 0 .017-.056.111.111 0 0 0-.017-.056c-.441-.773-1.551-2.527-3.307-4.08C17.309 6.315 14.955 5 12 5 9.045 5 6.69 6.314 4.94 7.865c-1.756 1.552-2.866 3.306-3.307 4.08Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$f2c2531e46a6c1ea = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("EyeClosedIcon", "octicon octicon-eye-closed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M.143 2.31a.75.75 0 0 1 1.047-.167l14.5 10.5a.75.75 0 1 1-.88 1.214l-2.248-1.628C11.346 13.19 9.792 14 8 14c-1.981 0-3.67-.992-4.933-2.078C1.797 10.832.88 9.577.43 8.9a1.619 1.619 0 0 1 0-1.797c.353-.533.995-1.42 1.868-2.305L.31 3.357A.75.75 0 0 1 .143 2.31Zm1.536 5.622A.12.12 0 0 0 1.657 8c0 .021.006.045.022.068.412.621 1.242 1.75 2.366 2.717C5.175 11.758 6.527 12.5 8 12.5c1.195 0 2.31-.488 3.29-1.191L9.063 9.695A2 2 0 0 1 6.058 7.52L3.529 5.688a14.207 14.207 0 0 0-1.85 2.244ZM8 3.5c-.516 0-1.017.09-1.499.251a.75.75 0 1 1-.473-1.423A6.207 6.207 0 0 1 8 2c1.981 0 3.67.992 4.933 2.078 1.27 1.091 2.187 2.345 2.637 3.023a1.62 1.62 0 0 1 0 1.798c-.11.166-.248.365-.41.587a.75.75 0 1 1-1.21-.887c.148-.201.272-.382.371-.53a.119.119 0 0 0 0-.137c-.412-.621-1.242-1.75-2.366-2.717C10.825 4.242 9.473 3.5 8 3.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.052 5.837A9.715 9.715 0 0 1 12 5c2.955 0 5.309 1.315 7.06 2.864 1.756 1.553 2.866 3.307 3.307 4.08a.11.11 0 0 1 .016.055.122.122 0 0 1-.017.06 16.766 16.766 0 0 1-1.53 2.218.75.75 0 1 0 1.163.946 18.253 18.253 0 0 0 1.67-2.42 1.607 1.607 0 0 0 .001-1.602c-.485-.85-1.69-2.757-3.616-4.46C18.124 5.034 15.432 3.5 12 3.5c-1.695 0-3.215.374-4.552.963a.75.75 0 0 0 .604 1.373Zm11.114 12.15C17.328 19.38 14.933 20.5 12 20.5c-3.432 0-6.125-1.534-8.054-3.24C2.02 15.556.814 13.648.33 12.798a1.606 1.606 0 0 1 .001-1.6A18.283 18.283 0 0 1 3.648 7.01L1.317 5.362a.75.75 0 1 1 .866-1.224l20.5 14.5a.75.75 0 1 1-.866 1.224ZM4.902 7.898c-1.73 1.541-2.828 3.273-3.268 4.044a.112.112 0 0 0-.017.059c0 .015.003.034.016.055.441.774 1.551 2.527 3.307 4.08C6.69 17.685 9.045 19 12 19c2.334 0 4.29-.82 5.874-1.927l-3.516-2.487a3.5 3.5 0 0 1-5.583-3.949L4.902 7.899Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$6e3b45b659de5ab0 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FeedDiscussionIcon", "octicon octicon-feed-discussion", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM4 5v5a1 1 0 0 0 1 1h1v1.5a.5.5 0 0 0 .854.354L8.707 11H11a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$3647c0e0c99821b2 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FeedForkedIcon", "octicon octicon-feed-forked", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM6 6.928a1.75 1.75 0 1 0-1 0V7.5A1.5 1.5 0 0 0 6.5 9h1v1.072a1.75 1.75 0 1 0 1 0V9h1A1.5 1.5 0 0 0 11 7.5v-.572a1.75 1.75 0 1 0-1 0V7.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$a4dcaa8e6d385a92 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FeedHeartIcon", "octicon octicon-feed-heart", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm2.33-11.5c-1.22 0-1.83.5-2.323 1.136C7.513 5 6.903 4.5 5.682 4.5c-1.028 0-2.169.784-2.169 2.5 0 1.499 1.493 3.433 3.246 4.517.52.321.89.479 1.248.484.357-.005.728-.163 1.247-.484C11.007 10.433 12.5 8.5 12.5 7c0-1.716-1.14-2.5-2.17-2.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$46ac012c84cfbd37 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FeedMergedIcon", "octicon octicon-feed-merged", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm.25-11.25A1.75 1.75 0 1 0 6 6.428v3.144a1.75 1.75 0 1 0 1 0V8.236A2.99 2.99 0 0 0 9 9h.571a1.75 1.75 0 1 0 0-1H9a2 2 0 0 1-1.957-1.586A1.75 1.75 0 0 0 8.25 4.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$845965101a187ab3 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FeedPersonIcon", "octicon octicon-feed-person", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm.847-8.145a2.502 2.502 0 1 0-1.694 0C5.471 8.261 4 9.775 4 11c0 .395.145.995 1 .995h6c.855 0 1-.6 1-.995 0-1.224-1.47-2.74-3.153-3.145Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$5b656c3dada47b91 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FeedRepoIcon", "octicon octicon-feed-repo", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM5.5 4A1.5 1.5 0 0 0 4 5.5v5c0 .828.5 1.5 1 1.5v-1a1 1 0 0 1 1-1h5v1h-1v1h1.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Zm.5 7.25v2.514a.25.25 0 0 0 .426.178l.898-.888a.25.25 0 0 1 .352 0l.898.888A.25.25 0 0 0 9 13.764V11H6.25a.25.25 0 0 0-.25.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$2a390681c250bed1 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FeedRocketIcon", "octicon octicon-feed-rocket", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm3.031-12a4.38 4.38 0 0 0-3.097 1.283l-.23.229c-.156.157-.308.32-.452.49H5.65a.876.876 0 0 0-.746.417l-.856 1.388a.377.377 0 0 0 .21.556l1.552.477 1.35 1.35.478 1.553a.374.374 0 0 0 .555.21l1.389-.855a.876.876 0 0 0 .416-.746V8.747c.17-.144.333-.295.49-.452l.23-.23A4.379 4.379 0 0 0 12 4.969v-.093A.876.876 0 0 0 11.124 4Zm-5.107 7.144h-.001a.809.809 0 0 0-1.33-.881c-.395.394-.564 1.258-.62 1.62a.12.12 0 0 0 .035.108.12.12 0 0 0 .108.035c.362-.056 1.226-.225 1.62-.619a.803.803 0 0 0 .188-.263Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$49060c19a6a6c823 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FeedStarIcon", "octicon octicon-feed-star", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm.252-12.932a.476.476 0 0 0-.682.195l-1.2 2.432-2.684.39a.477.477 0 0 0-.266.816l1.944 1.892-.46 2.674a.479.479 0 0 0 .694.504L8 10.709l2.4 1.261a.478.478 0 0 0 .694-.504l-.458-2.673L12.578 6.9a.479.479 0 0 0-.265-.815l-2.685-.39-1.2-2.432a.473.473 0 0 0-.176-.195Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$9092ea4ea0ee0792 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FeedTagIcon", "octicon octicon-feed-tag", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.22 6.5a.72.72 0 1 1-1.44 0 .72.72 0 0 1 1.44 0Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM4 5v3.38c.001.397.159.778.44 1.059l3.211 3.213a1.202 1.202 0 0 0 1.698 0l3.303-3.303a1.202 1.202 0 0 0 0-1.698L9.439 4.44A1.5 1.5 0 0 0 8.379 4H5a1 1 0 0 0-1 1Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$e468f280fa64cb4 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FeedTrophyIcon", "octicon octicon-feed-trophy", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11 5h1v1.146a1 1 0 0 1-.629.928L11 7.223V5ZM5 7.223l-.371-.149A1 1 0 0 1 4 6.146V5h1v2.223Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM3 5v1.146a2 2 0 0 0 1.257 1.858l.865.346a3.005 3.005 0 0 0 2.294 2.093C7.22 11.404 6.658 12 5.502 12H5.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1c-1.158 0-1.72-.595-1.916-1.557a3.005 3.005 0 0 0 2.294-2.094l.865-.346A2 2 0 0 0 13 6.146V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$8c1a3d13e85d78b7 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileIcon", "octicon octicon-file", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 1.75C2 .784 2.784 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V6h-2.75A1.75 1.75 0 0 1 9 4.25V1.5Zm6.75.062V4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm2-.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4Zm10 0v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$360ea1c46a04f469 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileAddedIcon", "octicon octicon-file-added", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 1.75C2 .784 2.784 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Zm4.48 3.758a.75.75 0 0 1 .755.745l.01 1.497h1.497a.75.75 0 0 1 0 1.5H9v1.507a.75.75 0 0 1-1.5 0V9.005l-1.502.01a.75.75 0 0 1-.01-1.5l1.507-.01-.01-1.492a.75.75 0 0 1 .745-.755Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$7845cd2940948f71 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileBadgeIcon", "octicon octicon-file-badge", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.75 1.5a.25.25 0 0 0-.25.25v11.5c0 .138.112.25.25.25h3.5a.75.75 0 0 1 0 1.5h-3.5A1.75 1.75 0 0 1 1 13.25V1.75C1 .784 1.784 0 2.75 0h8a1.75 1.75 0 0 1 1.508.862.75.75 0 1 1-1.289.768.25.25 0 0 0-.219-.13h-8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 7a3.999 3.999 0 0 1 7.605-1.733 4 4 0 0 1-1.115 4.863l.995 4.973a.75.75 0 0 1-.991.852l-2.409-.876a.248.248 0 0 0-.17 0l-2.409.876a.75.75 0 0 1-.991-.852l.994-4.973A3.994 3.994 0 0 1 8 7Zm4-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm0 6.5c-.373 0-.745-.051-1.104-.154l-.649 3.243 1.155-.42c.386-.14.81-.14 1.196 0l1.155.42-.649-3.243A4.004 4.004 0 0 1 12 11Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$99582237f60eb92e = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileBinaryIcon", "octicon octicon-file-binary", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4 1.75C4 .784 4.784 0 5.75 0h5.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v8.586A1.75 1.75 0 0 1 14.25 15h-9a.75.75 0 0 1 0-1.5h9a.25.25 0 0 0 .25-.25V6h-2.75A1.75 1.75 0 0 1 10 4.25V1.5H5.75a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0Zm-4 6C0 6.784.784 6 1.75 6h1.5C4.216 6 5 6.784 5 7.75v2.5A1.75 1.75 0 0 1 3.25 12h-1.5A1.75 1.75 0 0 1 0 10.25ZM6.75 6h1.5a.75.75 0 0 1 .75.75v3.75h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75v-3h-.75a.75.75 0 0 1 0-1.5Zm-5 1.5a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm9.75-5.938V4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H4.75a.75.75 0 0 1 0-1.5H19a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4H5a.5.5 0 0 0-.5.5v6.25a.75.75 0 0 1-1.5 0Zm12-.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 13.75C0 12.784.784 12 1.75 12h3c.966 0 1.75.784 1.75 1.75v4a1.75 1.75 0 0 1-1.75 1.75h-3A1.75 1.75 0 0 1 0 17.75Zm1.75-.25a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25ZM9 12a.75.75 0 0 0 0 1.5h1.5V18H9a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5H12v-5.25a.75.75 0 0 0-.75-.75H9Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$d587cff9ccb0570b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileCodeIcon", "octicon octicon-file-code", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4 1.75C4 .784 4.784 0 5.75 0h5.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v8.586A1.75 1.75 0 0 1 14.25 15h-9a.75.75 0 0 1 0-1.5h9a.25.25 0 0 0 .25-.25V6h-2.75A1.75 1.75 0 0 1 10 4.25V1.5H5.75a.25.25 0 0 0-.25.25v2.5a.75.75 0 0 1-1.5 0Zm1.72 4.97a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.47-1.47-1.47-1.47a.75.75 0 0 1 0-1.06ZM3.28 7.78 1.81 9.25l1.47 1.47a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-2-2a.75.75 0 0 1 0-1.06l2-2a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Zm8.22-6.218V4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H4.75a.75.75 0 0 1 0-1.5H19a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4H5a.5.5 0 0 0-.5.5v6.25a.75.75 0 0 1-1.5 0Zm12-.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.53 12.24a.75.75 0 0 1-.039 1.06l-2.639 2.45 2.64 2.45a.75.75 0 1 1-1.022 1.1l-3.23-3a.75.75 0 0 1 0-1.1l3.23-3a.75.75 0 0 1 1.06.04Zm3.979 1.06a.75.75 0 1 1 1.02-1.1l3.231 3a.75.75 0 0 1 0 1.1l-3.23 3a.75.75 0 1 1-1.021-1.1l2.639-2.45-2.64-2.45Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$75ea36f6e1616f37 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileDiffIcon", "octicon octicon-file-diff", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 1.75C1 .784 1.784 0 2.75 0h7.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16H2.75A1.75 1.75 0 0 1 1 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073ZM8 3.25a.75.75 0 0 1 .75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0V7h-1.5a.75.75 0 0 1 0-1.5h1.5V4A.75.75 0 0 1 8 3.25Zm-3 8a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.5 6.75a.75.75 0 0 0-1.5 0V9H8.75a.75.75 0 0 0 0 1.5H11v2.25a.75.75 0 0 0 1.5 0V10.5h2.25a.75.75 0 0 0 0-1.5H12.5V6.75ZM8.75 16a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5 1h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2Zm-.5 2v18a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V7.018a.5.5 0 0 0-.146-.354l-4.018-4.018a.5.5 0 0 0-.354-.146H5a.5.5 0 0 0-.5.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$3f512b4e06c5cf93 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileDirectoryIcon", "octicon octicon-file-directory", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 2.75C0 1.784.784 1 1.75 1H5c.55 0 1.07.26 1.4.7l.9 1.2a.25.25 0 0 0 .2.1h6.75c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25Zm1.75-.25a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25H7.5c-.55 0-1.07-.26-1.4-.7l-.9-1.2a.25.25 0 0 0-.2-.1Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 4.75C2 3.784 2.784 3 3.75 3h4.971c.58 0 1.12.286 1.447.765l1.404 2.063c.046.069.124.11.207.11h8.471c.966 0 1.75.783 1.75 1.75V19.25A1.75 1.75 0 0 1 20.25 21H3.75A1.75 1.75 0 0 1 2 19.25Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V7.687a.25.25 0 0 0-.25-.25h-8.471a1.75 1.75 0 0 1-1.447-.765L8.928 4.61a.252.252 0 0 0-.208-.11Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$335a75d3502de44e = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileDirectoryFillIcon", "octicon octicon-file-directory-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 1A1.75 1.75 0 0 0 0 2.75v10.5C0 14.216.784 15 1.75 15h12.5A1.75 1.75 0 0 0 16 13.25v-8.5A1.75 1.75 0 0 0 14.25 3H7.5a.25.25 0 0 1-.2-.1l-.9-1.2C6.07 1.26 5.55 1 5 1H1.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 4.75C2 3.784 2.784 3 3.75 3h4.971c.58 0 1.12.286 1.447.765l1.404 2.063c.046.069.124.11.207.11h8.471c.966 0 1.75.783 1.75 1.75V19.25A1.75 1.75 0 0 1 20.25 21H3.75A1.75 1.75 0 0 1 2 19.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$1b267c5cc56290c5 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileDirectoryOpenFillIcon", "octicon octicon-file-directory-open-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M.513 1.513A1.75 1.75 0 0 1 1.75 1h3.5c.55 0 1.07.26 1.4.7l.9 1.2a.25.25 0 0 0 .2.1H13a1 1 0 0 1 1 1v.5H2.75a.75.75 0 0 0 0 1.5h11.978a1 1 0 0 1 .994 1.117L15 13.25A1.75 1.75 0 0 1 13.25 15H1.75A1.75 1.75 0 0 1 0 13.25V2.75c0-.464.184-.91.513-1.237Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$45e0c3b06609db08 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileMediaIcon", "octicon octicon-file-media", function() {
    return {
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M21.75 21.5H2.25A1.75 1.75 0 0 1 .5 19.75V4.25c0-.966.784-1.75 1.75-1.75h19.5c.966 0 1.75.784 1.75 1.75v15.5a1.75 1.75 0 0 1-1.75 1.75ZM2.25 4a.25.25 0 0 0-.25.25v15.5c0 .138.112.25.25.25h3.178L14 10.977a1.749 1.749 0 0 1 2.506-.032L22 16.44V4.25a.25.25 0 0 0-.25-.25ZM22 19.75v-1.19l-6.555-6.554a.248.248 0 0 0-.18-.073.247.247 0 0 0-.178.077L7.497 20H21.75a.25.25 0 0 0 .25-.25ZM10.5 9.25a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Zm-1.5 0a1.75 1.75 0 1 0-3.501.001A1.75 1.75 0 0 0 9 9.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$7a31aa78af90c07 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileMovedIcon", "octicon octicon-file-moved", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 1.75C2 .784 2.784 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-3.5a.75.75 0 0 1 0-1.5h3.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073H3.75a.25.25 0 0 0-.25.25v6.5a.75.75 0 0 1-1.5 0v-6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m5.427 15.573 3.146-3.146a.25.25 0 0 0 0-.354L5.427 8.927A.25.25 0 0 0 5 9.104V11.5H.75a.75.75 0 0 0 0 1.5H5v2.396c0 .223.27.335.427.177Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$ac6910029b660cbb = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileRemovedIcon", "octicon octicon-file-removed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 1.75C2 .784 2.784 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Zm4.5 6h2.242a.75.75 0 0 1 0 1.5h-2.24l-2.254.015a.75.75 0 0 1-.01-1.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$dd207c2d9efbb369 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileSubmoduleIcon", "octicon octicon-file-submodule", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 2.75C0 1.784.784 1 1.75 1H5c.55 0 1.07.26 1.4.7l.9 1.2a.25.25 0 0 0 .2.1h6.75c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25Zm9.42 9.36 2.883-2.677a.25.25 0 0 0 0-.366L9.42 6.39a.249.249 0 0 0-.42.183V8.5H4.75a.75.75 0 0 0 0 1.5H9v1.927c0 .218.26.331.42.183Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 4.75C2 3.784 2.784 3 3.75 3h4.965a1.75 1.75 0 0 1 1.456.78l1.406 2.109a.25.25 0 0 0 .208.111h8.465c.966 0 1.75.784 1.75 1.75v11.5A1.75 1.75 0 0 1 20.25 21H3.75A1.75 1.75 0 0 1 2 19.25Zm12.78 4.97a.749.749 0 0 0-1.275.326.749.749 0 0 0 .215.734l1.72 1.72H6.75a.75.75 0 0 0 0 1.5h8.69l-1.72 1.72a.749.749 0 0 0 .326 1.275.749.749 0 0 0 .734-.215l3-3a.75.75 0 0 0 0-1.06Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$9f1ab1c55b1a75c2 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileSymlinkFileIcon", "octicon octicon-file-symlink-file", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 1.75C2 .784 2.784 0 3.75 0h5.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v8.586A1.75 1.75 0 0 1 12.25 15h-7a.75.75 0 0 1 0-1.5h7a.25.25 0 0 0 .25-.25V6H9.75A1.75 1.75 0 0 1 8 4.25V1.5H3.75a.25.25 0 0 0-.25.25V4.5a.75.75 0 0 1-1.5 0Zm-.5 10.487v1.013a.75.75 0 0 1-1.5 0v-1.012a3.748 3.748 0 0 1 3.77-3.749L4 8.49V6.573a.25.25 0 0 1 .42-.183l2.883 2.678a.25.25 0 0 1 0 .366L4.42 12.111a.25.25 0 0 1-.42-.183V9.99l-.238-.003a2.25 2.25 0 0 0-2.262 2.25Zm8-10.675V4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H4.75a.75.75 0 0 1 0-1.5H19a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4H5a.5.5 0 0 0-.5.5v6.25a.75.75 0 0 1-1.5 0Zm6.308 11.5-2.104-2.236a.751.751 0 0 1 .369-1.255.749.749 0 0 1 .723.227l3.294 3.5a.75.75 0 0 1 0 1.028l-3.294 3.5a.749.749 0 0 1-1.275-.293.751.751 0 0 1 .183-.735L9.308 16H4.09a2.59 2.59 0 0 0-2.59 2.59v3.16a.75.75 0 0 1-1.5 0v-3.16a4.09 4.09 0 0 1 4.09-4.09ZM15 2.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$4b5c933f073b4437 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FileZipIcon", "octicon octicon-file-zip", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.5 1.75v11.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.748 1.748 0 0 1 2 13.25V1.75C2 .784 2.784 0 3.75 0h5.586c.464 0 .909.185 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v8.586A1.75 1.75 0 0 1 12.25 15h-.5a.75.75 0 0 1 0-1.5h.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177L9.513 1.573a.25.25 0 0 0-.177-.073H7.25a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5h-3a.25.25 0 0 0-.25.25Zm3.75 8.75h.5c.966 0 1.75.784 1.75 1.75v3a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-3c0-.966.784-1.75 1.75-1.75ZM6 5.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 6 5.25Zm.75 2.25h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM8 6.75A.75.75 0 0 1 8.75 6h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 8 6.75ZM8.75 3h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM8 9.75A.75.75 0 0 1 8.75 9h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 8 9.75Zm-1 2.5v2.25h1v-2.25a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5 2.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h1.75a.75.75 0 0 1 0 1.5H5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2h-2.75a.75.75 0 0 1 0-1.5H19a.5.5 0 0 0 .5-.5V7.018a.5.5 0 0 0-.146-.354l-4.018-4.018a.5.5 0 0 0-.354-.146H5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.5 15.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm.75-3.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Zm-.75-2.25a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM12.25 6a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Zm-.75-2.25a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM9.75 13.5a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1ZM9 11.25a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm.75-3.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1ZM9 5.25a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 9 5.25ZM11 17h1a2 2 0 0 1 2 2v4.25a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V19a2 2 0 0 1 2-2Zm-.5 2v3.5h2V19a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$28f6150e232898de = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FilterIcon", "octicon octicon-filter", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M.75 3h14.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5ZM3 7.75A.75.75 0 0 1 3.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 7.75Zm3 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.75 6a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5H2.75ZM6 11.75a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1-.75-.75Zm4 4.938a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$81671b8187e8d7ad = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FiscalHostIcon", "octicon octicon-fiscal-host", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4 9.25h-.75a.75.75 0 0 1 0-1.5H4v-1.5h-.75a.75.75 0 0 1 0-1.5H4V3.5a1 1 0 0 1 1-1h7.5a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1ZM5.5 4v.793a.75.75 0 0 1 0 1.414v1.586a.75.75 0 0 1 0 1.414V10H12V4Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.75 14.25V14h-9.5v.25a.75.75 0 0 1-1.5 0V14A1.75 1.75 0 0 1 0 12.25V1.75C0 .784.784 0 1.75 0h12.5C15.217 0 16 .784 16 1.75v10.5A1.75 1.75 0 0 1 14.25 14v.25a.75.75 0 0 1-1.5 0ZM1.75 1.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$c1eff5f0d5951e22 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FlameIcon", "octicon octicon-flame", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.533.753V.752c.217 2.385 1.463 3.626 2.653 4.81C13.37 6.74 14.498 7.863 14.498 10c0 3.5-3 6-6.5 6S1.5 13.512 1.5 10c0-1.298.536-2.56 1.425-3.286.376-.308.862 0 1.035.454C4.46 8.487 5.581 8.419 6 8c.282-.282.341-.811-.003-1.5C4.34 3.187 7.035.75 8.77.146c.39-.137.726.194.763.607ZM7.998 14.5c2.832 0 5-1.98 5-4.5 0-1.463-.68-2.19-1.879-3.383l-.036-.037c-1.013-1.008-2.3-2.29-2.834-4.434-.322.256-.63.579-.864.953-.432.696-.621 1.58-.046 2.73.473.947.67 2.284-.278 3.232-.61.61-1.545.84-2.403.633a2.79 2.79 0 0 1-1.436-.874A3.198 3.198 0 0 0 3 10c0 2.53 2.164 4.5 4.998 4.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M14.265 1.627c0 3.545 1.869 5.327 3.479 7.021 1.54 1.62 3.006 3.163 3.006 6.102 0 4.812-3.753 8.25-8.565 8.25-4.813 0-8.935-3.421-8.935-8.25 0-2.039.962-4.011 2.509-4.899.305-.175.672.007.803.334C7.563 12.684 8.797 12.64 9.437 12c.388-.387.47-1.116-.004-2.062-2.405-4.812 1.863-8.279 4.2-8.854.336-.082.615.198.632.543ZM12.185 21.5c4.059 0 7.065-2.84 7.065-6.75 0-2.337-1.093-3.489-2.678-5.158l-.021-.023c-1.44-1.517-3.139-3.351-3.649-6.557a6.148 6.148 0 0 0-1.911 1.76c-.787 1.144-1.147 2.633-.216 4.495.603 1.205.777 2.74-.277 3.794-.657.657-1.762 1.1-2.956.586-.752-.324-1.353-.955-1.838-1.79-.567.706-.954 1.74-.954 2.893 0 3.847 3.288 6.75 7.435 6.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$567273102fa6ef96 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FoldIcon", "octicon octicon-fold", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.896 2H8.75V.75a.75.75 0 0 0-1.5 0V2H5.104a.25.25 0 0 0-.177.427l2.896 2.896a.25.25 0 0 0 .354 0l2.896-2.896A.25.25 0 0 0 10.896 2ZM8.75 15.25a.75.75 0 0 1-1.5 0V14H5.104a.25.25 0 0 1-.177-.427l2.896-2.896a.25.25 0 0 1 .354 0l2.896 2.896a.25.25 0 0 1-.177.427H8.75v1.25Zm-6.5-6.5a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM6 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 6 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM12 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 12 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 15c.199 0 .389.079.53.22l3.25 3.25a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L12 16.81l-2.72 2.72a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.25-3.25A.749.749 0 0 1 12 15Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.53 8.78a.75.75 0 0 1-1.06 0L8.22 5.53a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L12 7.19l2.72-2.72a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734ZM12 15.75a.75.75 0 0 1 .75.75v5.75a.75.75 0 0 1-1.5 0V16.5a.75.75 0 0 1 .75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 8.5a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-.75.75ZM2.75 12a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$acafa89e81b6b94a = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FoldDownIcon", "octicon octicon-fold-down", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m8.177 14.323 2.896-2.896a.25.25 0 0 0-.177-.427H8.75V7.764a.75.75 0 1 0-1.5 0V11H5.104a.25.25 0 0 0-.177.427l2.896 2.896a.25.25 0 0 0 .354 0ZM2.25 5a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM6 4.25a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5a.75.75 0 0 1 .75.75ZM8.25 5a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM12 4.25a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5a.75.75 0 0 1 .75.75Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 19a.749.749 0 0 1-.53-.22l-3.25-3.25a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215L12 17.19l2.72-2.72a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-3.25 3.25A.749.749 0 0 1 12 19Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 18a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 12 18ZM2.75 6a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 2.75 6Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 6.75 6Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$7d2a0ecee4bb68a = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("FoldUpIcon", "octicon octicon-fold-up", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.823 1.677 4.927 4.573A.25.25 0 0 0 5.104 5H7.25v3.236a.75.75 0 1 0 1.5 0V5h2.146a.25.25 0 0 0 .177-.427L8.177 1.677a.25.25 0 0 0-.354 0ZM13.75 11a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Zm-3.75.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM7.75 11a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM4 11.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM1.75 11a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.47 5.22a.75.75 0 0 1 1.06 0l3.25 3.25a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018L12 6.81 9.28 9.53a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 5.5a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0v-8A.75.75 0 0 1 12 5.5ZM2.75 18a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$70208e77f6c45b17 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("GearIcon", "octicon octicon-gear", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 0a8.2 8.2 0 0 1 .701.031C9.444.095 9.99.645 10.16 1.29l.288 1.107c.018.066.079.158.212.224.231.114.454.243.668.386.123.082.233.09.299.071l1.103-.303c.644-.176 1.392.021 1.82.63.27.385.506.792.704 1.218.315.675.111 1.422-.364 1.891l-.814.806c-.049.048-.098.147-.088.294.016.257.016.515 0 .772-.01.147.038.246.088.294l.814.806c.475.469.679 1.216.364 1.891a7.977 7.977 0 0 1-.704 1.217c-.428.61-1.176.807-1.82.63l-1.102-.302c-.067-.019-.177-.011-.3.071a5.909 5.909 0 0 1-.668.386c-.133.066-.194.158-.211.224l-.29 1.106c-.168.646-.715 1.196-1.458 1.26a8.006 8.006 0 0 1-1.402 0c-.743-.064-1.289-.614-1.458-1.26l-.289-1.106c-.018-.066-.079-.158-.212-.224a5.738 5.738 0 0 1-.668-.386c-.123-.082-.233-.09-.299-.071l-1.103.303c-.644.176-1.392-.021-1.82-.63a8.12 8.12 0 0 1-.704-1.218c-.315-.675-.111-1.422.363-1.891l.815-.806c.05-.048.098-.147.088-.294a6.214 6.214 0 0 1 0-.772c.01-.147-.038-.246-.088-.294l-.815-.806C.635 6.045.431 5.298.746 4.623a7.92 7.92 0 0 1 .704-1.217c.428-.61 1.176-.807 1.82-.63l1.102.302c.067.019.177.011.3-.071.214-.143.437-.272.668-.386.133-.066.194-.158.211-.224l.29-1.106C6.009.645 6.556.095 7.299.03 7.53.01 7.764 0 8 0Zm-.571 1.525c-.036.003-.108.036-.137.146l-.289 1.105c-.147.561-.549.967-.998 1.189-.173.086-.34.183-.5.29-.417.278-.97.423-1.529.27l-1.103-.303c-.109-.03-.175.016-.195.045-.22.312-.412.644-.573.99-.014.031-.021.11.059.19l.815.806c.411.406.562.957.53 1.456a4.709 4.709 0 0 0 0 .582c.032.499-.119 1.05-.53 1.456l-.815.806c-.081.08-.073.159-.059.19.162.346.353.677.573.989.02.03.085.076.195.046l1.102-.303c.56-.153 1.113-.008 1.53.27.161.107.328.204.501.29.447.222.85.629.997 1.189l.289 1.105c.029.109.101.143.137.146a6.6 6.6 0 0 0 1.142 0c.036-.003.108-.036.137-.146l.289-1.105c.147-.561.549-.967.998-1.189.173-.086.34-.183.5-.29.417-.278.97-.423 1.529-.27l1.103.303c.109.029.175-.016.195-.045.22-.313.411-.644.573-.99.014-.031.021-.11-.059-.19l-.815-.806c-.411-.406-.562-.957-.53-1.456a4.709 4.709 0 0 0 0-.582c-.032-.499.119-1.05.53-1.456l.815-.806c.081-.08.073-.159.059-.19a6.464 6.464 0 0 0-.573-.989c-.02-.03-.085-.076-.195-.046l-1.102.303c-.56.153-1.113.008-1.53-.27a4.44 4.44 0 0 0-.501-.29c-.447-.222-.85-.629-.997-1.189l-.289-1.105c-.029-.11-.101-.143-.137-.146a6.6 6.6 0 0 0-1.142 0ZM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM9.5 8a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 9.5 8Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1.5 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c.266 0 .532.009.797.028.763.055 1.345.617 1.512 1.304l.352 1.45c.019.078.09.171.225.221.247.089.49.19.728.302.13.061.246.044.315.002l1.275-.776c.603-.368 1.411-.353 1.99.147.402.349.78.726 1.128 1.129.501.578.515 1.386.147 1.99l-.776 1.274c-.042.069-.058.185.002.315.112.238.213.481.303.728.048.135.142.205.22.225l1.45.352c.687.167 1.249.749 1.303 1.512.038.531.038 1.063 0 1.594-.054.763-.616 1.345-1.303 1.512l-1.45.352c-.078.019-.171.09-.221.225-.089.248-.19.491-.302.728-.061.13-.044.246-.002.315l.776 1.275c.368.603.353 1.411-.147 1.99-.349.402-.726.78-1.129 1.128-.578.501-1.386.515-1.99.147l-1.274-.776c-.069-.042-.185-.058-.314.002a8.606 8.606 0 0 1-.729.303c-.135.048-.205.142-.225.22l-.352 1.45c-.167.687-.749 1.249-1.512 1.303-.531.038-1.063.038-1.594 0-.763-.054-1.345-.616-1.512-1.303l-.352-1.45c-.019-.078-.09-.171-.225-.221a8.138 8.138 0 0 1-.728-.302c-.13-.061-.246-.044-.315-.002l-1.275.776c-.603.368-1.411.353-1.99-.147-.402-.349-.78-.726-1.128-1.129-.501-.578-.515-1.386-.147-1.99l.776-1.274c.042-.069.058-.185-.002-.314a8.606 8.606 0 0 1-.303-.729c-.048-.135-.142-.205-.22-.225l-1.45-.352c-.687-.167-1.249-.749-1.304-1.512a11.158 11.158 0 0 1 0-1.594c.055-.763.617-1.345 1.304-1.512l1.45-.352c.078-.019.171-.09.221-.225.089-.248.19-.491.302-.728.061-.13.044-.246.002-.315l-.776-1.275c-.368-.603-.353-1.411.147-1.99.349-.402.726-.78 1.129-1.128.578-.501 1.386-.515 1.99-.147l1.274.776c.069.042.185.058.315-.002.238-.112.481-.213.728-.303.135-.048.205-.142.225-.22l.352-1.45c.167-.687.749-1.249 1.512-1.304C11.466 1.01 11.732 1 12 1Zm-.69 1.525c-.055.004-.135.05-.161.161l-.353 1.45a1.832 1.832 0 0 1-1.172 1.277 7.147 7.147 0 0 0-.6.249 1.833 1.833 0 0 1-1.734-.074l-1.274-.776c-.098-.06-.186-.036-.228 0a9.774 9.774 0 0 0-.976.976c-.036.042-.06.131 0 .228l.776 1.274c.314.529.342 1.18.074 1.734a7.147 7.147 0 0 0-.249.6 1.831 1.831 0 0 1-1.278 1.173l-1.45.351c-.11.027-.156.107-.16.162a9.63 9.63 0 0 0 0 1.38c.004.055.05.135.161.161l1.45.353a1.832 1.832 0 0 1 1.277 1.172c.074.204.157.404.249.6.268.553.24 1.204-.074 1.733l-.776 1.275c-.06.098-.036.186 0 .228.301.348.628.675.976.976.042.036.131.06.228 0l1.274-.776a1.83 1.83 0 0 1 1.734-.075c.196.093.396.176.6.25a1.831 1.831 0 0 1 1.173 1.278l.351 1.45c.027.11.107.156.162.16a9.63 9.63 0 0 0 1.38 0c.055-.004.135-.05.161-.161l.353-1.45a1.834 1.834 0 0 1 1.172-1.278 6.82 6.82 0 0 0 .6-.248 1.831 1.831 0 0 1 1.733.074l1.275.776c.098.06.186.036.228 0 .348-.301.675-.628.976-.976.036-.042.06-.131 0-.228l-.776-1.275a1.834 1.834 0 0 1-.075-1.733c.093-.196.176-.396.25-.6a1.831 1.831 0 0 1 1.278-1.173l1.45-.351c.11-.027.156-.107.16-.162a9.63 9.63 0 0 0 0-1.38c-.004-.055-.05-.135-.161-.161l-1.45-.353c-.626-.152-1.08-.625-1.278-1.172a6.576 6.576 0 0 0-.248-.6 1.833 1.833 0 0 1 .074-1.734l.776-1.274c.06-.098.036-.186 0-.228a9.774 9.774 0 0 0-.976-.976c-.042-.036-.131-.06-.228 0l-1.275.776a1.831 1.831 0 0 1-1.733.074 6.88 6.88 0 0 0-.6-.249 1.835 1.835 0 0 1-1.173-1.278l-.351-1.45c-.027-.11-.107-.156-.162-.16a9.63 9.63 0 0 0-1.38 0Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$89472f18b6de8cda = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("GiftIcon", "octicon octicon-gift", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 2.75A2.75 2.75 0 0 1 4.75 0c.983 0 1.873.42 2.57 1.232.268.318.497.668.68 1.042.183-.375.411-.725.68-1.044C9.376.42 10.266 0 11.25 0a2.75 2.75 0 0 1 2.45 4h.55c.966 0 1.75.784 1.75 1.75v2c0 .698-.409 1.301-1 1.582v4.918A1.75 1.75 0 0 1 13.25 16H2.75A1.75 1.75 0 0 1 1 14.25V9.332C.409 9.05 0 8.448 0 7.75v-2C0 4.784.784 4 1.75 4h.55c-.192-.375-.3-.8-.3-1.25ZM7.25 9.5H2.5v4.75c0 .138.112.25.25.25h4.5Zm1.5 0v5h4.5a.25.25 0 0 0 .25-.25V9.5Zm0-4V8h5.5a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25Zm-7 0a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h5.5V5.5h-5.5Zm3-4a1.25 1.25 0 0 0 0 2.5h2.309c-.233-.818-.542-1.401-.878-1.793-.43-.502-.915-.707-1.431-.707ZM8.941 4h2.309a1.25 1.25 0 0 0 0-2.5c-.516 0-1 .205-1.43.707-.337.392-.646.975-.879 1.793Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.75 3.75A3.75 3.75 0 0 1 7.5 0c1.455 0 3.436.901 4.5 3.11C13.064.901 15.044 0 16.5 0a3.75 3.75 0 0 1 3 6h1.75c.966 0 1.75.784 1.75 1.75v2.5c0 .698-.409 1.301-1 1.582v8.418A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25v-8.418c-.591-.282-1-.884-1-1.582v-2.5C1 6.784 1.784 6 2.75 6H4.5a3.733 3.733 0 0 1-.75-2.25ZM20.5 12h-7.75v8.5h7.5a.25.25 0 0 0 .25-.25Zm-9.25 8.5V12H3.5v8.25c0 .138.112.25.25.25Zm10-10a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25h-8.5v3Zm-18.5 0h8.5v-3h-8.5a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25Zm16-6.75A2.25 2.25 0 0 0 16.5 1.5c-1.15 0-3.433 1.007-3.72 4.5h3.72a2.25 2.25 0 0 0 2.25-2.25ZM11.22 6c-.287-3.493-2.57-4.5-3.72-4.5a2.25 2.25 0 1 0 0 4.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$c812d10d519e0edb = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("GitBranchIcon", "octicon octicon-git-branch", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.5 3.25a2.25 2.25 0 1 1 3 2.122V6A2.5 2.5 0 0 1 10 8.5H6a1 1 0 0 0-1 1v1.128a2.251 2.251 0 1 1-1.5 0V5.372a2.25 2.25 0 1 1 1.5 0v1.836A2.493 2.493 0 0 1 6 7h4a1 1 0 0 0 1-1v-.628A2.25 2.25 0 0 1 9.5 3.25Zm-6 0a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Zm8.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15 4.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM2.5 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm0-14.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM5.75 6.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 6.5Zm0 14.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 21Zm12.5-14.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 18.25 6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.75 16.75A.75.75 0 0 1 5 16V8a.75.75 0 0 1 1.5 0v8a.75.75 0 0 1-.75.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M17.5 8.75v-1H19v1a3.75 3.75 0 0 1-3.75 3.75h-7a1.75 1.75 0 0 0-1.75 1.75H5A3.25 3.25 0 0 1 8.25 11h7a2.25 2.25 0 0 0 2.25-2.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$60c2c35f336e72eb = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("GitCommitIcon", "octicon octicon-git-commit", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.93 8.5a4.002 4.002 0 0 1-7.86 0H.75a.75.75 0 0 1 0-1.5h3.32a4.002 4.002 0 0 1 7.86 0h3.32a.75.75 0 0 1 0 1.5Zm-1.43-.75a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16.944 11h4.306a.75.75 0 0 1 0 1.5h-4.306a5.001 5.001 0 0 1-9.888 0H2.75a.75.75 0 0 1 0-1.5h4.306a5.001 5.001 0 0 1 9.888 0Zm-1.444.75a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$f8d7191bd80f36 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("GitCompareIcon", "octicon octicon-git-compare", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.573.677A.25.25 0 0 1 10 .854V2.5h1A2.5 2.5 0 0 1 13.5 5v5.628a2.251 2.251 0 1 1-1.5 0V5a1 1 0 0 0-1-1h-1v1.646a.25.25 0 0 1-.427.177L7.177 3.427a.25.25 0 0 1 0-.354ZM6 12v-1.646a.25.25 0 0 1 .427-.177l2.396 2.396a.25.25 0 0 1 0 .354l-2.396 2.396A.25.25 0 0 1 6 15.146V13.5H5A2.5 2.5 0 0 1 2.5 11V5.372a2.25 2.25 0 1 1 1.5 0V11a1 1 0 0 0 1 1ZM4 3.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM12.75 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16.5 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm3.25-1.75a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.905 1.72a.75.75 0 0 1 0 1.06L12.685 4h4.065a3.75 3.75 0 0 1 3.75 3.75v8.75a.75.75 0 0 1-1.5 0V7.75a2.25 2.25 0 0 0-2.25-2.25h-4.064l1.22 1.22a.75.75 0 0 1-1.061 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.5-2.5a.75.75 0 0 1 1.06 0ZM7.5 4.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0ZM4.25 6.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 4.25 6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.095 22.28a.75.75 0 0 1 0-1.06l1.22-1.22H7.25a3.75 3.75 0 0 1-3.75-3.75V7.5a.75.75 0 0 1 1.5 0v8.75a2.25 2.25 0 0 0 2.25 2.25h4.064l-1.22-1.22a.748.748 0 0 1 .332-1.265.75.75 0 0 1 .729.205l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$578402671e214a82 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("GitMergeIcon", "octicon octicon-git-merge", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.45 5.154A4.25 4.25 0 0 0 9.25 7.5h1.378a2.251 2.251 0 1 1 0 1.5H9.25A5.734 5.734 0 0 1 5 7.123v3.505a2.25 2.25 0 1 1-1.5 0V5.372a2.25 2.25 0 1 1 1.95-.218ZM4.25 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm8.5-4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM5 3.25a.75.75 0 1 0 0 .005V3.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15 13.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm-12.5 6a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm0-14.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM5.75 6.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 6.5Zm0 14.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 21Zm12.5-6a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 18.25 15Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.5 7.25c0 2.9 2.35 5.25 5.25 5.25h4.5V14h-4.5A6.75 6.75 0 0 1 5 7.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.75 16.75A.75.75 0 0 1 5 16V8a.75.75 0 0 1 1.5 0v8a.75.75 0 0 1-.75.75Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$3aec9aa2330d4752 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("GitMergeQueueIcon", "octicon octicon-git-merge-queue", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.75 4.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM3 7.75a.75.75 0 0 1 1.5 0v2.878a2.251 2.251 0 1 1-1.5 0Zm.75 5.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm5-7.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm5.75 2.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-1.5 0a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.75 6.5a1.75 1.75 0 1 1 .001-3.501A1.75 1.75 0 0 1 5.75 6.5ZM9.5 8.75a1.75 1.75 0 1 1 3.501.001A1.75 1.75 0 0 1 9.5 8.75ZM5.75 22.5a3.25 3.25 0 0 1-.745-6.414A.81.81 0 0 1 5 16v-5a.75.75 0 0 1 1.5 0v5a.81.81 0 0 1-.005.086A3.252 3.252 0 0 1 5.75 22.5ZM4 19.25a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 4 19.25Zm11-6.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm3.25 1.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$9a124e3933109cb2 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("GitPullRequestIcon", "octicon octicon-git-pull-request", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.5 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 1.5 3.25Zm5.677-.177L9.573.677A.25.25 0 0 1 10 .854V2.5h1A2.5 2.5 0 0 1 13.5 5v5.628a2.251 2.251 0 1 1-1.5 0V5a1 1 0 0 0-1-1h-1v1.646a.25.25 0 0 1-.427.177L7.177 3.427a.25.25 0 0 1 0-.354ZM3.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm0 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm8.25.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm-14.5 0a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm0-14.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM4.75 3a1.75 1.75 0 1 0 .001 3.501A1.75 1.75 0 0 0 4.75 3Zm0 14.5a1.75 1.75 0 1 0 .001 3.501A1.75 1.75 0 0 0 4.75 17.5Zm14.5 0a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.405 1.72a.75.75 0 0 1 0 1.06L12.185 4h4.065A3.75 3.75 0 0 1 20 7.75v8.75a.75.75 0 0 1-1.5 0V7.75a2.25 2.25 0 0 0-2.25-2.25h-4.064l1.22 1.22a.75.75 0 0 1-1.061 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.5-2.5a.75.75 0 0 1 1.06 0ZM4.75 7.25A.75.75 0 0 1 5.5 8v8A.75.75 0 0 1 4 16V8a.75.75 0 0 1 .75-.75Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$5026ec832c277e74 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("GitPullRequestClosedIcon", "octicon octicon-git-pull-request-closed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.25 1A2.25 2.25 0 0 1 4 5.372v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.251 2.251 0 0 1 3.25 1Zm9.5 5.5a.75.75 0 0 1 .75.75v3.378a2.251 2.251 0 1 1-1.5 0V7.25a.75.75 0 0 1 .75-.75Zm-2.03-5.273a.75.75 0 0 1 1.06 0l.97.97.97-.97a.748.748 0 0 1 1.265.332.75.75 0 0 1-.205.729l-.97.97.97.97a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-.97-.97-.97.97a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l.97-.97-.97-.97a.75.75 0 0 1 0-1.06ZM2.5 3.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0ZM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm9.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M22.266 2.711a.75.75 0 1 0-1.061-1.06l-1.983 1.983-1.984-1.983a.75.75 0 1 0-1.06 1.06l1.983 1.983-1.983 1.984a.75.75 0 0 0 1.06 1.06l1.984-1.983 1.983 1.983a.75.75 0 0 0 1.06-1.06l-1.983-1.984 1.984-1.983ZM4.75 1.5a3.25 3.25 0 0 1 .745 6.414A.827.827 0 0 1 5.5 8v8a.827.827 0 0 1-.005.086A3.25 3.25 0 0 1 4.75 22.5a3.25 3.25 0 0 1-.745-6.414A.827.827 0 0 1 4 16V8c0-.029.002-.057.005-.086A3.25 3.25 0 0 1 4.75 1.5ZM16 19.25a3.252 3.252 0 0 1 2.5-3.163V9.625a.75.75 0 0 1 1.5 0v6.462a3.252 3.252 0 0 1-.75 6.413A3.25 3.25 0 0 1 16 19.25ZM3 4.75a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 3 4.75Zm0 14.5a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 3 19.25Zm16.25-1.75a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$51ed17e21f1e5e24 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("GitPullRequestDraftIcon", "octicon octicon-git-pull-request-draft", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.25 1A2.25 2.25 0 0 1 4 5.372v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.251 2.251 0 0 1 3.25 1Zm9.5 14a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5ZM2.5 3.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0ZM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm9.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM14 7.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm0-4.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.75 1.5a3.25 3.25 0 0 1 .745 6.414A.827.827 0 0 1 5.5 8v8a.827.827 0 0 1-.005.086A3.25 3.25 0 0 1 4.75 22.5a3.25 3.25 0 0 1-.745-6.414A.827.827 0 0 1 4 16V8c0-.029.002-.057.005-.086A3.25 3.25 0 0 1 4.75 1.5ZM16 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM3 4.75a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 3 4.75Zm0 14.5a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 3 19.25Zm16.25-1.75a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501Zm0-11.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM21 11.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$a70e2e549144f66 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("GlobeIcon", "octicon octicon-globe", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM5.78 8.75a9.64 9.64 0 0 0 1.363 4.177c.255.426.542.832.857 1.215.245-.296.551-.705.857-1.215A9.64 9.64 0 0 0 10.22 8.75Zm4.44-1.5a9.64 9.64 0 0 0-1.363-4.177c-.307-.51-.612-.919-.857-1.215a9.927 9.927 0 0 0-.857 1.215A9.64 9.64 0 0 0 5.78 7.25Zm-5.944 1.5H1.543a6.507 6.507 0 0 0 4.666 5.5c-.123-.181-.24-.365-.352-.552-.715-1.192-1.437-2.874-1.581-4.948Zm-2.733-1.5h2.733c.144-2.074.866-3.756 1.58-4.948.12-.197.237-.381.353-.552a6.507 6.507 0 0 0-4.666 5.5Zm10.181 1.5c-.144 2.074-.866 3.756-1.58 4.948-.12.197-.237.381-.353.552a6.507 6.507 0 0 0 4.666-5.5Zm2.733-1.5a6.507 6.507 0 0 0-4.666-5.5c.123.181.24.365.353.552.714 1.192 1.436 2.874 1.58 4.948Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm3.241 10.5v-.001c-.1-2.708-.992-4.904-1.89-6.452a13.919 13.919 0 0 0-1.304-1.88L12 3.11l-.047.059c-.354.425-.828 1.06-1.304 1.88-.898 1.547-1.79 3.743-1.89 6.451Zm-12.728 0h4.745c.1-3.037 1.1-5.49 2.093-7.204.39-.672.78-1.233 1.119-1.673C6.11 3.329 2.746 7 2.513 11.5Zm18.974 0C21.254 7 17.89 3.329 13.53 2.623c.339.44.729 1.001 1.119 1.673.993 1.714 1.993 4.167 2.093 7.204ZM8.787 13c.182 2.478 1.02 4.5 1.862 5.953.382.661.818 1.29 1.304 1.88l.047.057.047-.059c.354-.425.828-1.06 1.304-1.88.842-1.451 1.679-3.471 1.862-5.951Zm-1.504 0H2.552a9.505 9.505 0 0 0 7.918 8.377 15.773 15.773 0 0 1-1.119-1.673C8.413 18.085 7.47 15.807 7.283 13Zm9.434 0c-.186 2.807-1.13 5.085-2.068 6.704-.39.672-.78 1.233-1.118 1.673A9.506 9.506 0 0 0 21.447 13Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$134cbcd70c6693b8 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("GoalIcon", "octicon octicon-goal", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.637 2.363h-.001l1.676.335c.09.018.164.084.19.173a.25.25 0 0 1-.062.249l-1.373 1.374a.876.876 0 0 1-.619.256H12.31L9.45 7.611A1.5 1.5 0 1 1 6.5 8a1.501 1.501 0 0 1 1.889-1.449l2.861-2.862V2.552c0-.232.092-.455.256-.619L12.88.559a.25.25 0 0 1 .249-.062c.089.026.155.1.173.19Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 8a6 6 0 1 0 11.769-1.656.751.751 0 1 1 1.442-.413 7.502 7.502 0 0 1-12.513 7.371A7.501 7.501 0 0 1 10.069.789a.75.75 0 0 1-.413 1.442A6.001 6.001 0 0 0 2 8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5 8a3.002 3.002 0 0 0 4.699 2.476 3 3 0 0 0 1.28-2.827.748.748 0 0 1 1.045-.782.75.75 0 0 1 .445.61A4.5 4.5 0 1 1 8.516 3.53a.75.75 0 1 1-.17 1.49A3 3 0 0 0 5 8Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M20.172 6.75h-1.861l-4.566 4.564a1.874 1.874 0 1 1-1.06-1.06l4.565-4.565V3.828a.94.94 0 0 1 .275-.664l1.73-1.73a.249.249 0 0 1 .25-.063c.089.026.155.1.173.191l.46 2.301 2.3.46c.09.018.164.084.19.173a.25.25 0 0 1-.062.249l-1.731 1.73a.937.937 0 0 1-.663.275Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.625 12A9.375 9.375 0 0 0 12 21.375 9.375 9.375 0 0 0 21.375 12c0-.898-.126-1.766-.361-2.587A.75.75 0 0 1 22.455 9c.274.954.42 1.96.42 3 0 6.006-4.869 10.875-10.875 10.875S1.125 18.006 1.125 12 5.994 1.125 12 1.125c1.015-.001 2.024.14 3 .419a.75.75 0 1 1-.413 1.442A9.39 9.39 0 0 0 12 2.625 9.375 9.375 0 0 0 2.625 12Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.125 12a4.874 4.874 0 1 0 9.717-.569.748.748 0 0 1 1.047-.798c.251.112.42.351.442.625a6.373 6.373 0 0 1-10.836 5.253 6.376 6.376 0 0 1 5.236-10.844.75.75 0 1 1-.17 1.49A4.876 4.876 0 0 0 7.125 12Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$1154891bc70a7bd = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("GrabberIcon", "octicon octicon-grabber", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0-4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-4 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm5-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm6 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$717a5ffb6a14ac74 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("GraphIcon", "octicon octicon-graph", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.5 1.75V13.5h13.75a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75V1.75a.75.75 0 0 1 1.5 0Zm14.28 2.53-5.25 5.25a.75.75 0 0 1-1.06 0L7 7.06 4.28 9.78a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.25-3.25a.75.75 0 0 1 1.06 0L10 7.94l4.72-4.72a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.5 2.75a.75.75 0 0 0-1.5 0v18.5c0 .414.336.75.75.75H20a.75.75 0 0 0 0-1.5H2.5V2.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M22.28 7.78a.75.75 0 0 0-1.06-1.06l-5.72 5.72-3.72-3.72a.75.75 0 0 0-1.06 0l-6 6a.75.75 0 1 0 1.06 1.06l5.47-5.47 3.72 3.72a.75.75 0 0 0 1.06 0l6.25-6.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$fc47a954fcd1cdda = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("HashIcon", "octicon octicon-hash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.368 1.01a.75.75 0 0 1 .623.859L6.57 4.5h3.98l.46-2.868a.75.75 0 0 1 1.48.237L12.07 4.5h2.18a.75.75 0 0 1 0 1.5h-2.42l-.64 4h2.56a.75.75 0 0 1 0 1.5h-2.8l-.46 2.869a.75.75 0 0 1-1.48-.237l.42-2.632H5.45l-.46 2.869a.75.75 0 0 1-1.48-.237l.42-2.632H1.75a.75.75 0 0 1 0-1.5h2.42l.64-4H2.25a.75.75 0 0 1 0-1.5h2.8l.46-2.868a.75.75 0 0 1 .858-.622ZM9.67 10l.64-4H6.33l-.64 4Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.618 1.76a.75.75 0 0 1 .623.859L9.46 7.5h6.48l.82-5.118a.75.75 0 0 1 1.48.237L17.46 7.5h3.79a.75.75 0 0 1 0 1.5h-4.03l-.96 6h3.99a.75.75 0 0 1 0 1.5h-4.23l-.78 4.869a.75.75 0 0 1-1.48-.237l.74-4.632H8.02l-.78 4.869a.75.75 0 0 1-1.48-.237L6.5 16.5H2.745a.75.75 0 0 1 0-1.5H6.74l.96-6H3.75a.75.75 0 0 1 0-1.5h4.19l.82-5.118a.75.75 0 0 1 .858-.622ZM14.741 15l.96-6H9.22l-.96 6Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$635e9dadffe43ee = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("HeadingIcon", "octicon octicon-heading", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.75 2a.75.75 0 0 1 .75.75V7h7V2.75a.75.75 0 0 1 1.5 0v10.5a.75.75 0 0 1-1.5 0V8.5h-7v4.75a.75.75 0 0 1-1.5 0V2.75A.75.75 0 0 1 3.75 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.25 4a.75.75 0 0 1 .75.75V11h10V4.75a.75.75 0 0 1 1.5 0v14.5a.75.75 0 0 1-1.5 0V12.5H7v6.75a.75.75 0 0 1-1.5 0V4.75A.75.75 0 0 1 6.25 4Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$16f03ed71cfb60c9 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("HeartIcon", "octicon octicon-heart", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m8 14.25.345.666a.75.75 0 0 1-.69 0l-.008-.004-.018-.01a7.152 7.152 0 0 1-.31-.17 22.055 22.055 0 0 1-3.434-2.414C2.045 10.731 0 8.35 0 5.5 0 2.836 2.086 1 4.25 1 5.797 1 7.153 1.802 8 3.02 8.847 1.802 10.203 1 11.75 1 13.914 1 16 2.836 16 5.5c0 2.85-2.045 5.231-3.885 6.818a22.066 22.066 0 0 1-3.744 2.584l-.018.01-.006.003h-.002ZM4.25 2.5c-1.336 0-2.75 1.164-2.75 3 0 2.15 1.58 4.144 3.365 5.682A20.58 20.58 0 0 0 8 13.393a20.58 20.58 0 0 0 3.135-2.211C12.92 9.644 14.5 7.65 14.5 5.5c0-1.836-1.414-3-2.75-3-1.373 0-2.609.986-3.029 2.456a.749.749 0 0 1-1.442 0C6.859 3.486 5.623 2.5 4.25 2.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m12 20.703.343.667a.748.748 0 0 1-.686 0l-.003-.002-.007-.003-.025-.013a31.138 31.138 0 0 1-5.233-3.576C3.8 15.573 1 12.332 1 8.514v-.001C1 5.053 3.829 2.5 6.736 2.5 9.03 2.5 10.881 3.726 12 5.605 13.12 3.726 14.97 2.5 17.264 2.5 20.17 2.5 23 5.052 23 8.514c0 3.818-2.801 7.06-5.389 9.262a31.148 31.148 0 0 1-5.233 3.576l-.025.013-.007.003-.002.001ZM6.736 4C4.657 4 2.5 5.88 2.5 8.514c0 3.107 2.324 5.96 4.861 8.12a29.655 29.655 0 0 0 4.566 3.175l.073.041.073-.04c.271-.153.661-.38 1.13-.674.94-.588 2.19-1.441 3.436-2.502 2.537-2.16 4.861-5.013 4.861-8.12C21.5 5.88 19.343 4 17.264 4c-2.106 0-3.801 1.389-4.553 3.643a.751.751 0 0 1-1.422 0C10.537 5.389 8.841 4 6.736 4Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$b94f36847052a4cc = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("HeartFillIcon", "octicon octicon-heart-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.655 14.916v-.001h-.002l-.006-.003-.018-.01a22.066 22.066 0 0 1-3.744-2.584C2.045 10.731 0 8.35 0 5.5 0 2.836 2.086 1 4.25 1 5.797 1 7.153 1.802 8 3.02 8.847 1.802 10.203 1 11.75 1 13.914 1 16 2.836 16 5.5c0 2.85-2.044 5.231-3.886 6.818a22.094 22.094 0 0 1-3.433 2.414 7.152 7.152 0 0 1-.31.17l-.018.01-.008.004a.75.75 0 0 1-.69 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M14 20.408c-.492.308-.903.546-1.192.709-.153.086-.308.17-.463.252h-.002a.75.75 0 0 1-.686 0 16.709 16.709 0 0 1-.465-.252 31.147 31.147 0 0 1-4.803-3.34C3.8 15.572 1 12.331 1 8.513 1 5.052 3.829 2.5 6.736 2.5 9.03 2.5 10.881 3.726 12 5.605 13.12 3.726 14.97 2.5 17.264 2.5 20.17 2.5 23 5.052 23 8.514c0 3.818-2.801 7.06-5.389 9.262A31.146 31.146 0 0 1 14 20.408Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8d345d913bfb227 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("HistoryIcon", "octicon octicon-history", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m.427 1.927 1.215 1.215a8.002 8.002 0 1 1-1.6 5.685.75.75 0 1 1 1.493-.154 6.5 6.5 0 1 0 1.18-4.458l1.358 1.358A.25.25 0 0 1 3.896 6H.25A.25.25 0 0 1 0 5.75V2.104a.25.25 0 0 1 .427-.177ZM7.75 4a.75.75 0 0 1 .75.75v2.992l2.028.812a.75.75 0 0 1-.557 1.392l-2.5-1A.751.751 0 0 1 7 8.25v-3.5A.75.75 0 0 1 7.75 4Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.998 2.5A9.503 9.503 0 0 0 3.378 8H5.75a.75.75 0 0 1 0 1.5H2a1 1 0 0 1-1-1V4.75a.75.75 0 0 1 1.5 0v1.697A10.997 10.997 0 0 1 11.998 1C18.074 1 23 5.925 23 12s-4.926 11-11.002 11C6.014 23 1.146 18.223 1 12.275a.75.75 0 0 1 1.5-.037 9.5 9.5 0 0 0 9.498 9.262c5.248 0 9.502-4.253 9.502-9.5s-4.254-9.5-9.502-9.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.5 7.25a.75.75 0 0 0-1.5 0v5.5c0 .27.144.518.378.651l3.5 2a.75.75 0 0 0 .744-1.302L12.5 12.315V7.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$92c8767b874048d = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("HomeIcon", "octicon octicon-home", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.906.664a1.749 1.749 0 0 1 2.187 0l5.25 4.2c.415.332.657.835.657 1.367v7.019A1.75 1.75 0 0 1 13.25 15h-3.5a.75.75 0 0 1-.75-.75V9H7v5.25a.75.75 0 0 1-.75.75h-3.5A1.75 1.75 0 0 1 1 13.25V6.23c0-.531.242-1.034.657-1.366l5.25-4.2Zm1.25 1.171a.25.25 0 0 0-.312 0l-5.25 4.2a.25.25 0 0 0-.094.196v7.019c0 .138.112.25.25.25H5.5V8.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v5.25h2.75a.25.25 0 0 0 .25-.25V6.23a.25.25 0 0 0-.094-.195Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.03 2.59a1.501 1.501 0 0 1 1.94 0l7.5 6.363a1.5 1.5 0 0 1 .53 1.144V19.5a1.5 1.5 0 0 1-1.5 1.5h-5.75a.75.75 0 0 1-.75-.75V14h-2v6.25a.75.75 0 0 1-.75.75H4.5A1.5 1.5 0 0 1 3 19.5v-9.403c0-.44.194-.859.53-1.144ZM12 3.734l-7.5 6.363V19.5h5v-6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v6.25h5v-9.403Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$43567ad5cdf3581e = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("HomeFillIcon", "octicon octicon-home-fill", function() {
    return {
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.97 2.59a1.5 1.5 0 0 0-1.94 0l-7.5 6.363A1.5 1.5 0 0 0 3 10.097V19.5A1.5 1.5 0 0 0 4.5 21h4.75a.75.75 0 0 0 .75-.75V14h4v6.25c0 .414.336.75.75.75h4.75a1.5 1.5 0 0 0 1.5-1.5v-9.403a1.5 1.5 0 0 0-.53-1.144l-7.5-6.363Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$124ea60d66fc0e36 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("HorizontalRuleIcon", "octicon octicon-horizontal-rule", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 7.75A.75.75 0 0 1 .75 7h14.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 7.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 12.75a.75.75 0 0 1 .75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$2eec7cd412adbced = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("HourglassIcon", "octicon octicon-hourglass", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.75 1h10.5a.75.75 0 0 1 0 1.5h-.75v1.25a4.75 4.75 0 0 1-1.9 3.8l-.333.25a.25.25 0 0 0 0 .4l.333.25a4.75 4.75 0 0 1 1.9 3.8v1.25h.75a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5h.75v-1.25a4.75 4.75 0 0 1 1.9-3.8l.333-.25a.25.25 0 0 0 0-.4L5.4 7.55a4.75 4.75 0 0 1-1.9-3.8V2.5h-.75a.75.75 0 0 1 0-1.5ZM11 2.5H5v1.25c0 1.023.482 1.986 1.3 2.6l.333.25c.934.7.934 2.1 0 2.8l-.333.25a3.251 3.251 0 0 0-1.3 2.6v1.25h6v-1.25a3.251 3.251 0 0 0-1.3-2.6l-.333-.25a1.748 1.748 0 0 1 0-2.8l.333-.25a3.251 3.251 0 0 0 1.3-2.6Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.75 2h14.5a.75.75 0 0 1 0 1.5h-.75v2.982a4.75 4.75 0 0 1-2.215 4.017l-2.044 1.29a.25.25 0 0 0 0 .422l2.044 1.29a4.75 4.75 0 0 1 2.215 4.017V20.5h.75a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h.75v-2.982a4.75 4.75 0 0 1 2.215-4.017l2.044-1.29a.25.25 0 0 0 0-.422l-2.044-1.29A4.75 4.75 0 0 1 5.5 6.482V3.5h-.75a.75.75 0 0 1 0-1.5ZM17 3.5H7v2.982A3.25 3.25 0 0 0 8.516 9.23l2.044 1.29a1.75 1.75 0 0 1 0 2.96l-2.044 1.29A3.25 3.25 0 0 0 7 17.518V20.5h10v-2.982a3.25 3.25 0 0 0-1.516-2.748l-2.044-1.29a1.75 1.75 0 0 1 0-2.96l2.044-1.29A3.25 3.25 0 0 0 17 6.482Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$1754a0cdd4c4236a = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("HubotIcon", "octicon octicon-hubot", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 8a8 8 0 0 1 16 0v5.25a.75.75 0 0 1-1.5 0V8a6.5 6.5 0 1 0-13 0v5.25a.75.75 0 0 1-1.5 0Zm3-1.25C3 5.784 3.784 5 4.75 5h6.5c.966 0 1.75.784 1.75 1.75v1.5A1.75 1.75 0 0 1 11.25 10h-6.5A1.75 1.75 0 0 1 3 8.25Zm1.47-.53a.75.75 0 0 0 0 1.06l1.5 1.5a.75.75 0 0 0 1.06 0L8 7.81l.97.97a.75.75 0 0 0 1.06 0l1.5-1.5a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215l-.97.97-.97-.97a.75.75 0 0 0-1.06 0l-.97.97-.97-.97a.75.75 0 0 0-1.06 0Zm1.03 6.03a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 13C0 6.373 5.373 1 12 1s12 5.373 12 12v8.657a.75.75 0 0 1-1.5 0V13c0-5.799-4.701-10.5-10.5-10.5S1.5 7.201 1.5 13v8.657a.75.75 0 0 1-1.5 0V13Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 19.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75ZM5.25 9.5h13.5c.966 0 1.75.784 1.75 1.75v3.5a1.75 1.75 0 0 1-1.75 1.75H5.25a1.75 1.75 0 0 1-1.75-1.75v-3.5c0-.966.784-1.75 1.75-1.75Zm.22 1.47a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06 0L12 12.56l2.47 2.47a.75.75 0 0 0 1.06 0l3-3a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215L15 13.44l-2.47-2.47a.75.75 0 0 0-1.06 0L9 13.44l-2.47-2.47a.75.75 0 0 0-1.06 0Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$6d90c795789f42a2 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("IdBadgeIcon", "octicon octicon-id-badge", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3 7.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-3Zm10 .25a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 .75.75ZM10.25 11a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 0 0 1.5h2.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.25 0h1.5c.966 0 1.75.784 1.75 1.75V3h3.75c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25v-8.5C0 3.784.784 3 1.75 3H5.5V1.75C5.5.784 6.284 0 7.25 0Zm3.232 4.5A1.75 1.75 0 0 1 8.75 6h-1.5a1.75 1.75 0 0 1-1.732-1.5H1.75a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25ZM7 1.75v2.5c0 .138.112.25.25.25h1.5A.25.25 0 0 0 9 4.25v-2.5a.25.25 0 0 0-.25-.25h-1.5a.25.25 0 0 0-.25.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$4a122bafaa48b23d = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ImageIcon", "octicon octicon-image", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16 13.25A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25V2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75ZM1.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h.94l.03-.03 6.077-6.078a1.75 1.75 0 0 1 2.412-.06L14.5 10.31V2.75a.25.25 0 0 0-.25-.25Zm12.5 11a.25.25 0 0 0 .25-.25v-.917l-4.298-3.889a.25.25 0 0 0-.344.009L4.81 13.5ZM7 6a2 2 0 1 1-3.999.001A2 2 0 0 1 7 6ZM5.5 6a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.75 3h14.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 19.25 21H4.75A1.75 1.75 0 0 1 3 19.25V4.75C3 3.784 3.784 3 4.75 3Zm14.5 1.5H4.75a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h.19l9.823-9.823a1.75 1.75 0 0 1 2.475 0l2.262 2.262V4.75a.25.25 0 0 0-.25-.25Zm.25 9.56-3.323-3.323a.25.25 0 0 0-.354 0L7.061 19.5H19.25a.25.25 0 0 0 .25-.25ZM8.5 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$f146fd7f5447dd59 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("InboxIcon", "octicon octicon-inbox", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.8 2.06A1.75 1.75 0 0 1 4.41 1h7.18c.7 0 1.333.417 1.61 1.06l2.74 6.395c.04.093.06.194.06.295v4.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25v-4.5c0-.101.02-.202.06-.295Zm1.61.44a.25.25 0 0 0-.23.152L1.887 8H4.75a.75.75 0 0 1 .6.3L6.625 10h2.75l1.275-1.7a.75.75 0 0 1 .6-.3h2.863L11.82 2.652a.25.25 0 0 0-.23-.152Zm10.09 7h-2.875l-1.275 1.7a.75.75 0 0 1-.6.3h-3.5a.75.75 0 0 1-.6-.3L4.375 9.5H1.5v3.75c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.801 3.57A1.75 1.75 0 0 1 6.414 2.5h11.174c.702 0 1.337.42 1.611 1.067l3.741 8.828c.04.092.06.192.06.293v7.562A1.75 1.75 0 0 1 21.25 22H2.75A1.75 1.75 0 0 1 1 20.25v-7.5c0-.1.02-.199.059-.291L4.8 3.571ZM6.414 4a.25.25 0 0 0-.23.153L2.88 12H8a.75.75 0 0 1 .648.372L10.18 15h3.638l1.533-2.628a.75.75 0 0 1 .64-.372l5.13-.051-3.304-7.797a.25.25 0 0 0-.23-.152ZM21.5 13.445l-5.067.05-1.535 2.633a.75.75 0 0 1-.648.372h-4.5a.75.75 0 0 1-.648-.372L7.57 13.5H2.5v6.75c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$29f7ef9a1b8bcf6e = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("InfinityIcon", "octicon octicon-infinity", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 6.984c.59-.533 1.204-1.066 1.825-1.493.797-.548 1.7-.991 2.675-.991C14.414 4.5 16 6.086 16 8s-1.586 3.5-3.5 3.5c-.975 0-1.878-.444-2.675-.991-.621-.427-1.235-.96-1.825-1.493-.59.533-1.204 1.066-1.825 1.493-.797.547-1.7.991-2.675.991C1.586 11.5 0 9.914 0 8s1.586-3.5 3.5-3.5c.975 0 1.878.443 2.675.991.621.427 1.235.96 1.825 1.493ZM9.114 8c.536.483 1.052.922 1.56 1.273.704.483 1.3.727 1.826.727 1.086 0 2-.914 2-2 0-1.086-.914-2-2-2-.525 0-1.122.244-1.825.727-.51.35-1.025.79-1.561 1.273ZM3.5 6c-1.086 0-2 .914-2 2 0 1.086.914 2 2 2 .525 0 1.122-.244 1.825-.727.51-.35 1.025-.79 1.561-1.273-.536-.483-1.052-.922-1.56-1.273C4.621 6.244 4.025 6 3.5 6Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 11.16c.887-.933 1.813-1.865 2.78-2.6C15.952 7.668 17.267 7 18.75 7 21.657 7 24 9.615 24 12.25s-2.343 5.25-5.25 5.25c-1.483 0-2.798-.668-3.97-1.56-.967-.735-1.893-1.667-2.78-2.6-.887.933-1.813 1.865-2.78 2.6-1.172.892-2.487 1.56-3.97 1.56C2.343 17.5 0 14.885 0 12.25S2.343 7 5.25 7c1.483 0 2.798.667 3.97 1.56.967.735 1.893 1.667 2.78 2.6ZM5.25 8.5c-2.032 0-3.75 1.895-3.75 3.75S3.218 16 5.25 16c1.017 0 2.014-.457 3.062-1.253.89-.678 1.758-1.554 2.655-2.497-.897-.943-1.765-1.82-2.655-2.497C7.264 8.957 6.267 8.5 5.25 8.5Zm7.783 3.75c.897.943 1.765 1.82 2.655 2.497C16.736 15.543 17.733 16 18.75 16c2.032 0 3.75-1.895 3.75-3.75S20.782 8.5 18.75 8.5c-1.017 0-2.014.457-3.062 1.253-.89.678-1.758 1.554-2.655 2.497Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$2957fc44b3d2481 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("InfoIcon", "octicon octicon-info", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM6.5 7.75A.75.75 0 0 1 7.25 7h1a.75.75 0 0 1 .75.75v2.75h.25a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5h.25v-2h-.25a.75.75 0 0 1-.75-.75ZM8 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13 7.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-3 3.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v4.25h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75V12h-.75a.75.75 0 0 1-.75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$6738f79126c9668 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("IssueClosedIcon", "octicon octicon-issue-closed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.28 6.78a.75.75 0 0 0-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l3.5-3.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M17.28 9.28a.75.75 0 0 0-1.06-1.06l-5.97 5.97-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6.5-6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$36bcc74fd945fa9c = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("IssueDraftIcon", "octicon octicon-issue-draft", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M14.307 11.655a.75.75 0 0 1 .165 1.048 8.05 8.05 0 0 1-1.769 1.77.75.75 0 0 1-.883-1.214 6.552 6.552 0 0 0 1.44-1.439.75.75 0 0 1 1.047-.165Zm-2.652-9.962a.75.75 0 0 1 1.048-.165 8.05 8.05 0 0 1 1.77 1.769.75.75 0 0 1-1.214.883 6.552 6.552 0 0 0-1.439-1.44.75.75 0 0 1-.165-1.047ZM6.749.097a8.074 8.074 0 0 1 2.502 0 .75.75 0 1 1-.233 1.482 6.558 6.558 0 0 0-2.036 0A.751.751 0 0 1 6.749.097ZM.955 6.125a.75.75 0 0 1 .624.857 6.558 6.558 0 0 0 0 2.036.75.75 0 1 1-1.482.233 8.074 8.074 0 0 1 0-2.502.75.75 0 0 1 .858-.624Zm14.09 0a.75.75 0 0 1 .858.624c.13.829.13 1.673 0 2.502a.75.75 0 1 1-1.482-.233 6.558 6.558 0 0 0 0-2.036.75.75 0 0 1 .624-.857Zm-8.92 8.92a.75.75 0 0 1 .857-.624 6.558 6.558 0 0 0 2.036 0 .75.75 0 1 1 .233 1.482c-.829.13-1.673.13-2.502 0a.75.75 0 0 1-.624-.858Zm-4.432-3.39a.75.75 0 0 1 1.048.165 6.552 6.552 0 0 0 1.439 1.44.751.751 0 0 1-.883 1.212 8.05 8.05 0 0 1-1.77-1.769.75.75 0 0 1 .166-1.048Zm2.652-9.962A.75.75 0 0 1 4.18 2.74a6.556 6.556 0 0 0-1.44 1.44.751.751 0 0 1-1.212-.883 8.05 8.05 0 0 1 1.769-1.77.75.75 0 0 1 1.048.166Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M17.32 3.205a.75.75 0 0 1 1.046-.177 11.056 11.056 0 0 1 2.605 2.606.75.75 0 1 1-1.222.869 9.554 9.554 0 0 0-2.252-2.252.75.75 0 0 1-.177-1.046Zm3.475 14.115a.75.75 0 0 1 .176 1.046 11.07 11.07 0 0 1-2.605 2.605.75.75 0 1 1-.869-1.222 9.554 9.554 0 0 0 2.252-2.252.75.75 0 0 1 1.046-.177ZM2.018 9.543a.75.75 0 0 1 .615.864 9.571 9.571 0 0 0 0 3.186.75.75 0 1 1-1.48.25 11.07 11.07 0 0 1 0-3.686.75.75 0 0 1 .865-.614Zm7.525 12.439a.75.75 0 0 1 .864-.615 9.571 9.571 0 0 0 3.186 0 .75.75 0 1 1 .25 1.48 11.07 11.07 0 0 1-3.686 0 .75.75 0 0 1-.614-.865ZM6.68 3.205a.75.75 0 0 1-.177 1.046A9.558 9.558 0 0 0 4.25 6.503a.75.75 0 1 1-1.223-.87 11.056 11.056 0 0 1 2.606-2.605.75.75 0 0 1 1.046.177ZM3.205 17.32a.75.75 0 0 1 1.046.177 9.554 9.554 0 0 0 2.252 2.252.75.75 0 1 1-.87 1.223 11.056 11.056 0 0 1-2.605-2.606.75.75 0 0 1 .177-1.046Zm6.952-16.166a11.07 11.07 0 0 1 3.686 0 .75.75 0 0 1-.25 1.479 9.571 9.571 0 0 0-3.186 0 .75.75 0 1 1-.25-1.48Zm11.825 8.389a.75.75 0 0 1 .864.614 11.07 11.07 0 0 1 0 3.686.75.75 0 0 1-1.479-.25 9.571 9.571 0 0 0 0-3.186.75.75 0 0 1 .615-.864Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$9e6406dfc15cbb05 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("IssueOpenedIcon", "octicon octicon-issue-opened", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Zm9.5 2a2 2 0 1 1-.001-3.999A2 2 0 0 1 12 14Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$5daf76ad79f58bb6 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("IssueReopenedIcon", "octicon octicon-issue-reopened", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.029 2.217a6.5 6.5 0 0 1 9.437 5.11.75.75 0 1 0 1.492-.154 8 8 0 0 0-14.315-4.03L.427 1.927A.25.25 0 0 0 0 2.104V5.75A.25.25 0 0 0 .25 6h3.646a.25.25 0 0 0 .177-.427L2.715 4.215a6.491 6.491 0 0 1 2.314-1.998ZM1.262 8.169a.75.75 0 0 0-1.22.658 8.001 8.001 0 0 0 14.315 4.03l1.216 1.216a.25.25 0 0 0 .427-.177V10.25a.25.25 0 0 0-.25-.25h-3.646a.25.25 0 0 0-.177.427l1.358 1.358a6.501 6.501 0 0 1-11.751-3.11.75.75 0 0 0-.272-.506Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.06 9.06a1.5 1.5 0 1 1-2.12-2.12 1.5 1.5 0 0 1 2.12 2.12Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.38 8A9.502 9.502 0 0 1 12 2.5a9.502 9.502 0 0 1 9.215 7.182.75.75 0 1 0 1.456-.364C21.473 4.539 17.15 1 12 1a10.995 10.995 0 0 0-9.5 5.452V4.75a.75.75 0 0 0-1.5 0V8.5a1 1 0 0 0 1 1h3.75a.75.75 0 0 0 0-1.5H3.38Zm-.595 6.318a.75.75 0 0 0-1.455.364C2.527 19.461 6.85 23 12 23c4.052 0 7.592-2.191 9.5-5.451v1.701a.75.75 0 0 0 1.5 0V15.5a1 1 0 0 0-1-1h-3.75a.75.75 0 0 0 0 1.5h2.37A9.502 9.502 0 0 1 12 21.5c-4.446 0-8.181-3.055-9.215-7.182Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.414 13.414a2 2 0 1 1-2.828-2.828 2 2 0 0 1 2.828 2.828Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$68537e8e4eadb58f = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("IssueTrackedByIcon", "octicon octicon-issue-tracked-by", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.5 8a6.5 6.5 0 0 1 13 0A.75.75 0 0 0 16 8a8 8 0 1 0-8 8 .75.75 0 0 0 0-1.5A6.5 6.5 0 0 1 1.5 8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm3.573 5.823-2.896-2.896a.25.25 0 0 1 0-.354l2.896-2.896a.25.25 0 0 1 .427.177V11.5h3.25a.75.75 0 0 1 0 1.5H12v2.146a.25.25 0 0 1-.427.177Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 2.5a9.5 9.5 0 1 0 0 19 .75.75 0 0 1 0 1.5C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11a.75.75 0 0 1-1.5 0A9.5 9.5 0 0 0 12 2.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m13.759 17.48 3.728 3.314a.308.308 0 0 0 .513-.23V18h4.25a.75.75 0 0 0 0-1.5H18v-2.564a.308.308 0 0 0-.513-.23L13.76 17.02a.308.308 0 0 0 0 .46ZM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$55a6f130ee0bae8 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("IssueTracksIcon", "octicon octicon-issue-tracks", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.5 8a6.5 6.5 0 0 1 13 0A.75.75 0 0 0 16 8a8 8 0 1 0-8 8 .75.75 0 0 0 0-1.5A6.5 6.5 0 0 1 1.5 8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1.5 1.75a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Zm2.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.5 12a9.5 9.5 0 1 1 19 0 .75.75 0 0 0 1.5 0c0-6.075-4.925-11-11-11S1 5.925 1 12s4.925 11 11 11a.75.75 0 0 0 0-1.5A9.5 9.5 0 0 1 2.5 12Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm2.5 2.75a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75Zm3.75 2.75a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5h-4Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$1db7002dff4b104d = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ItalicIcon", "octicon octicon-italic", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6 2.75A.75.75 0 0 1 6.75 2h6.5a.75.75 0 0 1 0 1.5h-2.505l-3.858 9H9.25a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h2.505l3.858-9H6.75A.75.75 0 0 1 6 2.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10 4.75a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-3.514l-5.828 13h3.342a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h3.514l5.828-13H10.75a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$1ac8e353f264c451 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("IterationsIcon", "octicon octicon-iterations", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.5 7.25a4.75 4.75 0 0 1 9.5 0 .75.75 0 0 0 1.5 0 6.25 6.25 0 1 0-6.25 6.25H12v2.146c0 .223.27.335.427.177l2.896-2.896a.25.25 0 0 0 0-.354l-2.896-2.896a.25.25 0 0 0-.427.177V12H7.25A4.75 4.75 0 0 1 2.5 7.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.5 10.5a8 8 0 1 1 16 0 .75.75 0 0 0 1.5 0 9.5 9.5 0 1 0-9.5 9.5h10.94l-2.72 2.72a.75.75 0 1 0 1.06 1.06l3.735-3.735c.44-.439.44-1.151 0-1.59L19.78 14.72a.75.75 0 0 0-1.06 1.06l2.72 2.72H10.5a8 8 0 0 1-8-8Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$21bf7011fb07ee55 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("KebabHorizontalIcon", "octicon octicon-kebab-horizontal", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM1.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm13 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M20 14a2 2 0 1 1-.001-3.999A2 2 0 0 1 20 14ZM6 12a2 2 0 1 1-3.999.001A2 2 0 0 1 6 12Zm8 0a2 2 0 1 1-3.999.001A2 2 0 0 1 14 12Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$3dc0fe769dc7dcac = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("KeyIcon", "octicon octicon-key", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.5 0a5.499 5.499 0 1 1-1.288 10.848l-.932.932a.749.749 0 0 1-.53.22H7v.75a.749.749 0 0 1-.22.53l-.5.5a.749.749 0 0 1-.53.22H5v.75a.749.749 0 0 1-.22.53l-.5.5a.749.749 0 0 1-.53.22h-2A1.75 1.75 0 0 1 0 14.25v-2c0-.199.079-.389.22-.53l4.932-4.932A5.5 5.5 0 0 1 10.5 0Zm-4 5.5c-.001.431.069.86.205 1.269a.75.75 0 0 1-.181.768L1.5 12.56v1.69c0 .138.112.25.25.25h1.69l.06-.06v-1.19a.75.75 0 0 1 .75-.75h1.19l.06-.06v-1.19a.75.75 0 0 1 .75-.75h1.19l1.023-1.025a.75.75 0 0 1 .768-.18A4 4 0 1 0 6.5 5.5ZM11 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16.75 8.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15.75 0a8.25 8.25 0 1 1-2.541 16.101l-1.636 1.636a1.744 1.744 0 0 1-1.237.513H9.25a.25.25 0 0 0-.25.25v1.448a.876.876 0 0 1-.256.619l-.214.213a.75.75 0 0 1-.545.22H5.25a.25.25 0 0 0-.25.25v1A1.75 1.75 0 0 1 3.25 24h-1.5A1.75 1.75 0 0 1 0 22.25v-2.836c0-.464.185-.908.513-1.236l7.386-7.388A8.249 8.249 0 0 1 15.75 0ZM9 8.25a6.733 6.733 0 0 0 .463 2.462.75.75 0 0 1-.168.804l-7.722 7.721a.25.25 0 0 0-.073.177v2.836c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25v-1c0-.966.784-1.75 1.75-1.75H7.5v-1c0-.966.784-1.75 1.75-1.75h1.086a.25.25 0 0 0 .177-.073l1.971-1.972a.75.75 0 0 1 .804-.168A6.75 6.75 0 1 0 9 8.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$461de75d5470f3cd = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("KeyAsteriskIcon", "octicon octicon-key-asterisk", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 2.75A2.75 2.75 0 0 1 2.75 0h10.5A2.75 2.75 0 0 1 16 2.75v10.5A2.75 2.75 0 0 1 13.25 16H2.75A2.75 2.75 0 0 1 0 13.25ZM2.75 1.5c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25V2.75c0-.69-.56-1.25-1.25-1.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 4a.75.75 0 0 1 .75.75V6.7l1.69-.975a.75.75 0 0 1 .75 1.3L9.5 8l1.69.976a.75.75 0 0 1-.75 1.298L8.75 9.3v1.951a.75.75 0 0 1-1.5 0V9.299l-1.69.976a.75.75 0 0 1-.75-1.3L6.5 8l-1.69-.975a.75.75 0 0 1 .75-1.3l1.69.976V4.75A.75.75 0 0 1 8 4Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$ed49a5296f9c40ce = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("LawIcon", "octicon octicon-law", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.75.75V2h.985c.304 0 .603.08.867.231l1.29.736c.038.022.08.033.124.033h2.234a.75.75 0 0 1 0 1.5h-.427l2.111 4.692a.75.75 0 0 1-.154.838l-.53-.53.529.531-.001.002-.002.002-.006.006-.006.005-.01.01-.045.04c-.21.176-.441.327-.686.45C14.556 10.78 13.88 11 13 11a4.498 4.498 0 0 1-2.023-.454 3.544 3.544 0 0 1-.686-.45l-.045-.04-.016-.015-.006-.006-.004-.004v-.001a.75.75 0 0 1-.154-.838L12.178 4.5h-.162c-.305 0-.604-.079-.868-.231l-1.29-.736a.245.245 0 0 0-.124-.033H8.75V13h2.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h2.5V3.5h-.984a.245.245 0 0 0-.124.033l-1.289.737c-.265.15-.564.23-.869.23h-.162l2.112 4.692a.75.75 0 0 1-.154.838l-.53-.53.529.531-.001.002-.002.002-.006.006-.016.015-.045.04c-.21.176-.441.327-.686.45C4.556 10.78 3.88 11 3 11a4.498 4.498 0 0 1-2.023-.454 3.544 3.544 0 0 1-.686-.45l-.045-.04-.016-.015-.006-.006-.004-.004v-.001a.75.75 0 0 1-.154-.838L2.178 4.5H1.75a.75.75 0 0 1 0-1.5h2.234a.249.249 0 0 0 .125-.033l1.288-.737c.265-.15.564-.23.869-.23h.984V.75a.75.75 0 0 1 1.5 0Zm2.945 8.477c.285.135.718.273 1.305.273s1.02-.138 1.305-.273L13 6.327Zm-10 0c.285.135.718.273 1.305.273s1.02-.138 1.305-.273L3 6.327Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.75 2.75V4.5h1.975c.351 0 .694.106.984.303l1.697 1.154c.041.028.09.043.14.043h4.102a.75.75 0 0 1 0 1.5H20.07l3.366 7.68a.749.749 0 0 1-.23.896c-.1.074-.203.143-.31.206a6.296 6.296 0 0 1-.79.399 7.349 7.349 0 0 1-2.856.569 7.343 7.343 0 0 1-2.855-.568 6.205 6.205 0 0 1-.79-.4 3.205 3.205 0 0 1-.307-.202l-.005-.004a.749.749 0 0 1-.23-.896l3.368-7.68h-.886c-.351 0-.694-.106-.984-.303l-1.697-1.154a.246.246 0 0 0-.14-.043H12.75v14.5h4.487a.75.75 0 0 1 0 1.5H6.763a.75.75 0 0 1 0-1.5h4.487V6H9.275a.249.249 0 0 0-.14.043L7.439 7.197c-.29.197-.633.303-.984.303h-.886l3.368 7.68a.75.75 0 0 1-.209.878c-.08.065-.16.126-.31.223a6.077 6.077 0 0 1-.792.433 6.924 6.924 0 0 1-2.876.62 6.913 6.913 0 0 1-2.876-.62 6.077 6.077 0 0 1-.792-.433 3.483 3.483 0 0 1-.309-.221.762.762 0 0 1-.21-.88L3.93 7.5H2.353a.75.75 0 0 1 0-1.5h4.102c.05 0 .099-.015.141-.043l1.695-1.154c.29-.198.634-.303.985-.303h1.974V2.75a.75.75 0 0 1 1.5 0ZM2.193 15.198a5.414 5.414 0 0 0 2.557.635 5.414 5.414 0 0 0 2.557-.635L4.75 9.368Zm14.51-.024c.082.04.174.083.275.126.53.223 1.305.45 2.272.45a5.847 5.847 0 0 0 2.547-.576L19.25 9.367Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$870380bdcb26b5e8 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("LightBulbIcon", "octicon octicon-light-bulb", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 1.5c-2.363 0-4 1.69-4 3.75 0 .984.424 1.625.984 2.304l.214.253c.223.264.47.556.673.848.284.411.537.896.621 1.49a.75.75 0 0 1-1.484.211c-.04-.282-.163-.547-.37-.847a8.456 8.456 0 0 0-.542-.68c-.084-.1-.173-.205-.268-.32C3.201 7.75 2.5 6.766 2.5 5.25 2.5 2.31 4.863 0 8 0s5.5 2.31 5.5 5.25c0 1.516-.701 2.5-1.328 3.259-.095.115-.184.22-.268.319-.207.245-.383.453-.541.681-.208.3-.33.565-.37.847a.751.751 0 0 1-1.485-.212c.084-.593.337-1.078.621-1.489.203-.292.45-.584.673-.848.075-.088.147-.173.213-.253.561-.679.985-1.32.985-2.304 0-2.06-1.637-3.75-4-3.75ZM5.75 12h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM6 15.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 2.5c-3.81 0-6.5 2.743-6.5 6.119 0 1.536.632 2.572 1.425 3.56.172.215.347.422.527.635l.096.112c.21.25.427.508.63.774.404.531.783 1.128.995 1.834a.75.75 0 0 1-1.436.432c-.138-.46-.397-.89-.753-1.357a18.111 18.111 0 0 0-.582-.714l-.092-.11c-.18-.212-.37-.436-.555-.667C4.87 12.016 4 10.651 4 8.618 4 4.363 7.415 1 12 1s8 3.362 8 7.619c0 2.032-.87 3.397-1.755 4.5-.185.23-.375.454-.555.667l-.092.109c-.21.248-.405.481-.582.714-.356.467-.615.898-.753 1.357a.751.751 0 0 1-1.437-.432c.213-.706.592-1.303.997-1.834.202-.266.419-.524.63-.774l.095-.112c.18-.213.355-.42.527-.634.793-.99 1.425-2.025 1.425-3.561C18.5 5.243 15.81 2.5 12 2.5ZM8.75 18h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5Zm.75 3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$69387b41dfc808f7 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("LinkIcon", "octicon octicon-link", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m7.775 3.275 1.25-1.25a3.5 3.5 0 1 1 4.95 4.95l-2.5 2.5a3.5 3.5 0 0 1-4.95 0 .751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018 1.998 1.998 0 0 0 2.83 0l2.5-2.5a2.002 2.002 0 0 0-2.83-2.83l-1.25 1.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042Zm-4.69 9.64a1.998 1.998 0 0 0 2.83 0l1.25-1.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-1.25 1.25a3.5 3.5 0 1 1-4.95-4.95l2.5-2.5a3.5 3.5 0 0 1 4.95 0 .751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018 1.998 1.998 0 0 0-2.83 0l-2.5 2.5a1.998 1.998 0 0 0 0 2.83Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M14.78 3.653a3.936 3.936 0 1 1 5.567 5.567l-3.627 3.627a3.936 3.936 0 0 1-5.88-.353.75.75 0 0 0-1.18.928 5.436 5.436 0 0 0 8.12.486l3.628-3.628a5.436 5.436 0 1 0-7.688-7.688l-3 3a.75.75 0 0 0 1.06 1.061l3-3Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.28 11.153a3.936 3.936 0 0 1 5.88.353.75.75 0 0 0 1.18-.928 5.436 5.436 0 0 0-8.12-.486L2.592 13.72a5.436 5.436 0 1 0 7.688 7.688l3-3a.75.75 0 1 0-1.06-1.06l-3 3a3.936 3.936 0 0 1-5.567-5.568l3.627-3.627Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$2df139b4d9e44df1 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("LinkExternalIcon", "octicon octicon-link-external", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.75 2h3.5a.75.75 0 0 1 0 1.5h-3.5a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-3.5a.75.75 0 0 1 1.5 0v3.5A1.75 1.75 0 0 1 12.25 14h-8.5A1.75 1.75 0 0 1 2 12.25v-8.5C2 2.784 2.784 2 3.75 2Zm6.854-1h4.146a.25.25 0 0 1 .25.25v4.146a.25.25 0 0 1-.427.177L13.03 4.03 9.28 7.78a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.75-3.75-1.543-1.543A.25.25 0 0 1 10.604 1Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15.5 2.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V4.06l-6.22 6.22a.75.75 0 1 1-1.06-1.06L19.94 3h-3.69a.75.75 0 0 1-.75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.5 4.25c0-.966.784-1.75 1.75-1.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.25.25 0 0 0-.25.25v15.5c0 .138.112.25.25.25h15.5a.25.25 0 0 0 .25-.25v-8.5a.75.75 0 0 1 1.5 0v8.5a1.75 1.75 0 0 1-1.75 1.75H4.25a1.75 1.75 0 0 1-1.75-1.75V4.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$337139085529da4 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ListOrderedIcon", "octicon octicon-list-ordered", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5 3.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 3.25Zm0 5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 8.25Zm0 5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75ZM.924 10.32a.5.5 0 0 1-.851-.525l.001-.001.001-.002.002-.004.007-.011c.097-.144.215-.273.348-.384.228-.19.588-.392 1.068-.392.468 0 .858.181 1.126.484.259.294.377.673.377 1.038 0 .987-.686 1.495-1.156 1.845l-.047.035c-.303.225-.522.4-.654.597h1.357a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5c0-1.005.692-1.52 1.167-1.875l.035-.025c.531-.396.8-.625.8-1.078a.57.57 0 0 0-.128-.376C1.806 10.068 1.695 10 1.5 10a.658.658 0 0 0-.429.163.835.835 0 0 0-.144.153ZM2.003 2.5V6h.503a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1h.503V3.308l-.28.14a.5.5 0 0 1-.446-.895l1.003-.5a.5.5 0 0 1 .723.447Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.604 3.089A.75.75 0 0 1 4 3.75V8.5h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 1 1 0-1.5h.75V5.151l-.334.223a.75.75 0 0 1-.832-1.248l1.5-1a.75.75 0 0 1 .77-.037ZM8.75 5.5a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H8.75Zm0 6a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H8.75Zm0 6a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H8.75ZM5.5 15.75c0-.704-.271-1.286-.72-1.686a2.302 2.302 0 0 0-1.53-.564c-.535 0-1.094.178-1.53.565-.449.399-.72.982-.72 1.685a.75.75 0 0 0 1.5 0c0-.296.104-.464.217-.564A.805.805 0 0 1 3.25 15c.215 0 .406.072.533.185.113.101.217.268.217.565 0 .332-.069.48-.21.657-.092.113-.216.24-.403.419l-.147.14c-.152.144-.33.313-.52.504l-1.5 1.5a.75.75 0 0 0-.22.53v.25c0 .414.336.75.75.75H5A.75.75 0 0 0 5 19H3.31l.47-.47c.176-.176.333-.324.48-.465l.165-.156a5.98 5.98 0 0 0 .536-.566c.358-.447.539-.925.539-1.593Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$58d7dc7a4e6c368e = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ListUnorderedIcon", "octicon octicon-list-unordered", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.75 2.5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5Zm0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5Zm0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM2 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM2 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.75 5.5h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5Zm0 6h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5Zm0 6h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5ZM5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$ec1acb4261485f12 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("LocationIcon", "octicon octicon-location", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m12.596 11.596-3.535 3.536a1.5 1.5 0 0 1-2.122 0l-3.535-3.536a6.5 6.5 0 1 1 9.192-9.193 6.5 6.5 0 0 1 0 9.193Zm-1.06-8.132v-.001a5 5 0 1 0-7.072 7.072L8 14.07l3.536-3.534a5 5 0 0 0 0-7.072ZM8 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 9Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 13.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M19.071 3.429h.001c3.905 3.905 3.905 10.237 0 14.142l-5.403 5.403a2.36 2.36 0 0 1-3.336 0l-5.375-5.375-.028-.028c-3.905-3.905-3.905-10.237 0-14.142 3.904-3.905 10.236-3.905 14.141 0ZM5.99 4.489v.001a8.5 8.5 0 0 0 0 12.02l.023.024.002.002 5.378 5.378a.859.859 0 0 0 1.214 0l5.403-5.404a8.5 8.5 0 0 0-.043-11.977A8.5 8.5 0 0 0 5.99 4.489Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$37ea31f99740f2be = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("LockIcon", "octicon octicon-lock", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4 4a4 4 0 0 1 8 0v2h.25c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 12.25 15h-8.5A1.75 1.75 0 0 1 2 13.25v-5.5C2 6.784 2.784 6 3.75 6H4Zm8.25 3.5h-8.5a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25ZM10.5 6V4a2.5 2.5 0 1 0-5 0v2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6 9V7.25C6 3.845 8.503 1 12 1s6 2.845 6 6.25V9h.5a2.5 2.5 0 0 1 2.5 2.5v8a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 19.5v-8A2.5 2.5 0 0 1 5.5 9Zm-1.5 2.5v8a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-13a1 1 0 0 0-1 1Zm3-4.25V9h9V7.25c0-2.67-1.922-4.75-4.5-4.75-2.578 0-4.5 2.08-4.5 4.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$f60c77e5a3352735 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("LogIcon", "octicon octicon-log", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5 8.25a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 5 8.25ZM4 10.5A.75.75 0 0 0 4 12h4a.75.75 0 0 0 0-1.5H4Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13-.005c1.654 0 3 1.328 3 3 0 .982-.338 1.933-.783 2.818-.443.879-1.028 1.758-1.582 2.588l-.011.017c-.568.853-1.104 1.659-1.501 2.446-.398.789-.623 1.494-.623 2.136a1.5 1.5 0 1 0 2.333-1.248.75.75 0 0 1 .834-1.246A3 3 0 0 1 13 16H3a3 3 0 0 1-3-3c0-1.582.891-3.135 1.777-4.506.209-.322.418-.637.623-.946.473-.709.923-1.386 1.287-2.048H2.51c-.576 0-1.381-.133-1.907-.783A2.68 2.68 0 0 1 0 2.995a3 3 0 0 1 3-3Zm0 1.5a1.5 1.5 0 0 0-1.5 1.5c0 .476.223.834.667 1.132A.75.75 0 0 1 11.75 5.5H5.368c-.467 1.003-1.141 2.015-1.773 2.963-.192.289-.381.571-.558.845C2.13 10.711 1.5 11.916 1.5 13A1.5 1.5 0 0 0 3 14.5h7.401A2.989 2.989 0 0 1 10 13c0-.979.338-1.928.784-2.812.441-.874 1.023-1.748 1.575-2.576l.017-.026c.568-.853 1.103-1.658 1.501-2.448.398-.79.623-1.497.623-2.143 0-.838-.669-1.5-1.5-1.5Zm-10 0a1.5 1.5 0 0 0-1.5 1.5c0 .321.1.569.27.778.097.12.325.227.74.227h7.674A2.737 2.737 0 0 1 10 2.995c0-.546.146-1.059.401-1.5Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.197 10a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm-2.382 4a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm-1.581 4a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.125 0h15.75a4.11 4.11 0 0 1 2.92 1.205A4.11 4.11 0 0 1 24 4.125c0 1.384-.476 2.794-1.128 4.16-.652 1.365-1.515 2.757-2.352 4.104l-.008.013c-.849 1.368-1.669 2.691-2.28 3.97-.614 1.283-.982 2.45-.982 3.503a2.625 2.625 0 1 0 4.083-2.183.75.75 0 1 1 .834-1.247A4.126 4.126 0 0 1 19.875 24H4.5a4.125 4.125 0 0 1-4.125-4.125c0-2.234 1.258-4.656 2.59-6.902.348-.586.702-1.162 1.05-1.728.8-1.304 1.567-2.553 2.144-3.738H3.39c-.823 0-1.886-.193-2.567-1.035A3.647 3.647 0 0 1 0 4.125 4.125 4.125 0 0 1 4.125 0ZM15.75 19.875c0-1.38.476-2.786 1.128-4.15.649-1.358 1.509-2.743 2.343-4.086l.017-.028c.849-1.367 1.669-2.692 2.28-3.972.614-1.285.982-2.457.982-3.514A2.615 2.615 0 0 0 19.875 1.5a2.625 2.625 0 0 0-2.625 2.625c0 .865.421 1.509 1.167 2.009A.75.75 0 0 1 18 7.507H7.812c-.65 1.483-1.624 3.069-2.577 4.619-.334.544-.666 1.083-.98 1.612-1.355 2.287-2.38 4.371-2.38 6.137A2.625 2.625 0 0 0 4.5 22.5h12.193a4.108 4.108 0 0 1-.943-2.625ZM1.5 4.125c-.01.511.163 1.008.487 1.403.254.313.74.479 1.402.479h12.86a3.648 3.648 0 0 1-.499-1.882 4.11 4.11 0 0 1 .943-2.625H4.125A2.625 2.625 0 0 0 1.5 4.125Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$1ea2365b5279873d = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("LogoGistIcon", "octicon octicon-logo-gist", function() {
    return {
        "16": {
            "width": 25,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.7 8.73v-1h3.52v5.69c-.78.37-1.95.64-3.59.64C1.11 14.06 0 11.37 0 8.03 0 4.69 1.13 2 4.63 2c1.62 0 2.64.33 3.28.66v1.05c-1.22-.5-2-.73-3.28-.73-2.57 0-3.48 2.21-3.48 5.06 0 2.85.91 5.05 3.47 5.05.89 0 1.98-.07 2.53-.34V8.73Zm10.98.69h.03c2.22.2 2.75.95 2.75 2.23 0 1.21-.76 2.41-3.14 2.41-.75 0-1.83-.19-2.33-.39v-.94c.47.17 1.22.36 2.33.36 1.62 0 2.06-.69 2.06-1.42 0-.71-.22-1.21-1.77-1.34-2.26-.2-2.73-1-2.73-2.08 0-1.11.72-2.31 2.92-2.31.73 0 1.56.09 2.25.39v.94c-.61-.2-1.22-.36-2.27-.36-1.55 0-1.88.57-1.88 1.34 0 .69.28 1.04 1.78 1.17Zm8.58-3.33v.85h-2.42v4.87c0 .95.53 1.34 1.5 1.34.2 0 .42 0 .61-.03v.89c-.17.03-.5.05-.69.05-1.31 0-2.5-.6-2.5-2.13v-5H19.2v-.48l1.56-.44V3.9l1.08-.31v2.5h2.42Zm-13.17-.03v6.41c0 .54.19.7.67.7v.89c-1.14 0-1.72-.47-1.72-1.72V6.06h1.05Zm.25-2.33c0 .44-.34.78-.78.78a.76.76 0 0 1-.77-.78c0-.44.32-.78.77-.78s.78.34.78.78Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$84b1561256ace7fe = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("LogoGithubIcon", "octicon octicon-logo-github", function() {
    return {
        "16": {
            "width": 45,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.81 7.35v5.74c0 .04-.01.11-.06.13 0 0-1.25.89-3.31.89-2.49 0-5.44-.78-5.44-5.92S2.58 1.99 5.1 2c2.18 0 3.06.49 3.2.58.04.05.06.09.06.14L7.94 4.5c0 .09-.09.2-.2.17-.36-.11-.9-.33-2.17-.33-1.47 0-3.05.42-3.05 3.73s1.5 3.7 2.58 3.7c.92 0 1.25-.11 1.25-.11v-2.3H4.88c-.11 0-.19-.08-.19-.17V7.35c0-.09.08-.17.19-.17h3.74c.11 0 .19.08.19.17Zm35.85 2.33c0 3.43-1.11 4.41-3.05 4.41-1.64 0-2.52-.83-2.52-.83s-.04.46-.09.52c-.03.06-.08.08-.14.08h-1.48c-.1 0-.19-.08-.19-.17l.02-11.11c0-.09.08-.17.17-.17h2.13c.09 0 .17.08.17.17v3.77s.82-.53 2.02-.53l-.01-.02c1.2 0 2.97.45 2.97 3.88ZM27.68 2.43c.09 0 .17.08.17.17v11.11c0 .09-.08.17-.17.17h-2.13c-.09 0-.17-.08-.17-.17l.02-4.75h-3.31v4.75c0 .09-.08.17-.17.17h-2.13c-.08 0-.17-.08-.17-.17V2.6c0-.09.08-.17.17-.17h2.13c.09 0 .17.08.17.17v4.09h3.31V2.6c0-.09.08-.17.17-.17Zm8.26 3.64c.11 0 .19.08.19.17l-.02 7.47c0 .09-.06.17-.17.17H34.6c-.07 0-.14-.04-.16-.09-.03-.06-.08-.45-.08-.45s-1.13.77-2.52.77c-1.69 0-2.92-.55-2.92-2.75V6.25c0-.09.08-.17.17-.17h2.14c.09 0 .17.08.17.17V11c0 .75.22 1.09.97 1.09s1.3-.39 1.3-.39V6.26c0-.11.06-.19.17-.19Zm-17.406 5.971h.005a.177.177 0 0 1 .141.179v1.5c0 .07-.03.14-.09.16-.1.05-.74.22-1.27.22-1.16 0-2.86-.25-2.86-2.69V8.13h-1.11c-.09 0-.17-.08-.17-.19V6.58c0-.08.05-.15.13-.17.07-.01 1.16-.28 1.16-.28V3.96c0-.08.05-.13.14-.13h2.16c.09 0 .14.05.14.13v2.11h1.59c.08 0 .16.08.16.17v1.7c0 .11-.07.19-.16.19h-1.59v3.131c0 .47.27.83 1.05.83.247 0 .481-.049.574-.05ZM12.24 6.06c.09 0 .17.08.17.17v7.37c0 .18-.05.27-.25.27h-1.92c-.17 0-.3-.07-.3-.27V6.26c0-.11.08-.2.17-.2Zm29.99 3.78c0-1.81-.73-2.05-1.5-1.97-.6.04-1.08.34-1.08.34v3.52s.49.34 1.22.36c1.03.03 1.36-.34 1.36-2.25ZM11.19 2.68c.75 0 1.36.61 1.36 1.38 0 .77-.61 1.38-1.36 1.38-.77 0-1.38-.61-1.38-1.38 0-.77.61-1.38 1.38-1.38Zm7.34 9.35v.001l.01.01h-.001l-.005-.001v.001c-.009-.001-.015-.011-.024-.011Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$6c65bc9b1cd4941d = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MailIcon", "octicon octicon-mail", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25v-8.5C0 2.784.784 2 1.75 2ZM1.5 12.251c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V5.809L8.38 9.397a.75.75 0 0 1-.76 0L1.5 5.809v6.442Zm13-8.181v-.32a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25v.32L8 7.88Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14a1.75 1.75 0 0 1-1.75 1.75H1.75A1.75 1.75 0 0 1 0 18.75v-14C0 3.784.784 3 1.75 3ZM1.5 7.412V18.75c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V7.412l-9.52 6.433c-.592.4-1.368.4-1.96 0Zm0-2.662v.852l10.36 7a.25.25 0 0 0 .28 0l10.36-7V4.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$afa80e6d91a34fff = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MarkGithubIcon", "octicon octicon-mark-github", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 0c4.42 0 8 3.58 8 8a8.013 8.013 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27-.68 0-1.36.09-2 .27-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.45-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8c30830df44f5ccc = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MarkdownIcon", "octicon octicon-markdown", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M14.85 3c.63 0 1.15.52 1.14 1.15v7.7c0 .63-.51 1.15-1.15 1.15H1.15C.52 13 0 12.48 0 11.84V4.15C0 3.52.52 3 1.15 3ZM9 11V5H7L5.5 7 4 5H2v6h2V8l1.5 1.92L7 8v3Zm2.99.5L14.5 8H13V5h-2v3H9.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$ea0da4856fb919cc = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MegaphoneIcon", "octicon octicon-megaphone", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.25 9a.75.75 0 0 1 .75.75c0 2.142.456 3.828.733 4.653a.122.122 0 0 0 .05.064.212.212 0 0 0 .117.033h1.31c.085 0 .18-.042.258-.152a.45.45 0 0 0 .075-.366A16.743 16.743 0 0 1 6 9.75a.75.75 0 0 1 1.5 0c0 1.588.25 2.926.494 3.85.293 1.113-.504 2.4-1.783 2.4H4.9c-.686 0-1.35-.41-1.589-1.12A16.4 16.4 0 0 1 2.5 9.75.75.75 0 0 1 3.25 9Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 6a4 4 0 0 1 4-4h2.75a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75H4a4 4 0 0 1-4-4Zm4-2.5a2.5 2.5 0 1 0 0 5h2v-5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15.59.082A.75.75 0 0 1 16 .75v10.5a.75.75 0 0 1-1.189.608l-.002-.001h.001l-.014-.01a5.775 5.775 0 0 0-.422-.25 10.63 10.63 0 0 0-1.469-.64C11.576 10.484 9.536 10 6.75 10a.75.75 0 0 1 0-1.5c2.964 0 5.174.516 6.658 1.043.423.151.787.302 1.092.443V2.014c-.305.14-.669.292-1.092.443C11.924 2.984 9.713 3.5 6.75 3.5a.75.75 0 0 1 0-1.5c2.786 0 4.826-.484 6.155-.957.665-.236 1.154-.47 1.47-.64.144-.077.284-.161.421-.25l.014-.01a.75.75 0 0 1 .78-.061Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M22 1.75v14.5a.75.75 0 0 1-.399.662c-.384.204-.783-.035-1.139-.248l-.003-.002c-.09-.054-.177-.107-.261-.15a15.53 15.53 0 0 0-2-.849c-1.738-.607-4.321-1.223-7.703-1.251a.833.833 0 0 1 .005.088c0 2.279.494 4.279.906 5.547.368 1.131-.438 2.453-1.732 2.453H7.661c-.696 0-1.36-.42-1.6-1.129C5.684 20.255 5 17.811 5 14.75v-.457A5.5 5.5 0 0 1 6.5 3.5h3.75c3.505 0 6.175-.61 7.955-1.21a15.88 15.88 0 0 0 2.002-.82 9.21 9.21 0 0 0 .49-.262c.048-.028.095-.055.142-.085A.751.751 0 0 1 22 1.75ZM10.5 12.912c3.564.029 6.313.678 8.193 1.335.737.258 1.34.517 1.807.74V2.993c-.467.216-1.073.467-1.815.718-1.878.634-4.624 1.26-8.185 1.288ZM6.5 5a4 4 0 0 0 0 8H9V5Zm0 9.75c0 2.847.638 5.123.982 6.141.018.051.074.109.179.109h2.013c.087 0 .179-.043.249-.147a.396.396 0 0 0 .057-.343C9.537 19.148 9 16.986 9 14.5H6.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$bcbc995d0a05f9c0 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MentionIcon", "octicon octicon-mention", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.75 2.37a6.501 6.501 0 0 0 6.5 11.26.75.75 0 0 1 .75 1.298A7.999 7.999 0 0 1 .989 4.148 8 8 0 0 1 16 7.75v1.5a2.75 2.75 0 0 1-5.072 1.475 3.999 3.999 0 0 1-6.65-4.19A4 4 0 0 1 12 8v1.25a1.25 1.25 0 0 0 2.5 0V7.867a6.5 6.5 0 0 0-9.75-5.496ZM10.5 8a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M20.226 7.25c-2.623-4.542-8.432-6.098-12.974-3.475-4.543 2.622-6.099 8.431-3.477 12.974 2.623 4.542 8.431 6.099 12.974 3.477a.75.75 0 0 1 .75 1.299c-5.26 3.037-11.987 1.235-15.024-4.026C-.562 12.24 1.24 5.512 6.501 2.475 11.76-.562 18.488 1.24 21.525 6.501a10.959 10.959 0 0 1 1.455 4.826c.013.056.02.113.02.173v2.25a3.5 3.5 0 0 1-6.623 1.581 5.5 5.5 0 1 1 1.112-3.682.802.802 0 0 1 .011.129v1.972a2 2 0 1 0 4 0v-1.766a9.456 9.456 0 0 0-1.274-4.733ZM16 12a4 4 0 1 0-8 0 4 4 0 0 0 8 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$b0216cc98375f15e = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MeterIcon", "octicon octicon-meter", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 1.5a6.5 6.5 0 1 0 6.016 4.035.75.75 0 0 1 1.388-.57 8 8 0 1 1-4.37-4.37.75.75 0 1 1-.569 1.389A6.473 6.473 0 0 0 8 1.5Zm6.28.22a.75.75 0 0 1 0 1.06l-4.063 4.064a2.5 2.5 0 1 1-1.06-1.06L13.22 1.72a.75.75 0 0 1 1.06 0ZM7 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$734bc5bdc236c5d8 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MilestoneIcon", "octicon octicon-milestone", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.75 0a.75.75 0 0 1 .75.75V3h3.634c.414 0 .814.147 1.13.414l2.07 1.75a1.75 1.75 0 0 1 0 2.672l-2.07 1.75a1.75 1.75 0 0 1-1.13.414H8.5v5.25a.75.75 0 0 1-1.5 0V10H2.75A1.75 1.75 0 0 1 1 8.25v-3.5C1 3.784 1.784 3 2.75 3H7V.75A.75.75 0 0 1 7.75 0Zm4.384 8.5a.25.25 0 0 0 .161-.06l2.07-1.75a.248.248 0 0 0 0-.38l-2.07-1.75a.25.25 0 0 0-.161-.06H2.75a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h9.384Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.75 1a.75.75 0 0 1 .75.75V4h6.532c.42 0 .826.15 1.143.425l3.187 2.75a1.75 1.75 0 0 1 0 2.65l-3.187 2.75a1.75 1.75 0 0 1-1.143.425H12.5v9.25a.75.75 0 0 1-1.5 0V13H3.75A1.75 1.75 0 0 1 2 11.25v-5.5C2 4.783 2.784 4 3.75 4H11V1.75a.75.75 0 0 1 .75-.75Zm7.282 4.5H3.75a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h15.282c.06 0 .118-.021.163-.06l3.188-2.75a.248.248 0 0 0 0-.38l-3.188-2.75a.249.249 0 0 0-.163-.06Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$4795e9bc1ad58779 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MirrorIcon", "octicon octicon-mirror", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15.547 3.061A.75.75 0 0 1 16 3.75v8.5a.751.751 0 0 1-1.265.545l-4.5-4.25a.75.75 0 0 1 0-1.09l4.5-4.25a.75.75 0 0 1 .812-.144ZM0 12.25v-8.5a.751.751 0 0 1 1.265-.545l4.5 4.25a.75.75 0 0 1 0 1.09l-4.5 4.25A.75.75 0 0 1 0 12.25Zm1.5-6.76v5.02L4.158 8ZM11.842 8l2.658 2.51V5.49ZM8 4a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 8 4Zm.75-2.25v.5a.75.75 0 0 1-1.5 0v-.5a.75.75 0 0 1 1.5 0Zm0 6v.5a.75.75 0 0 1-1.5 0v-.5a.75.75 0 0 1 1.5 0ZM8 10a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 8 10Zm0 3a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 8 13Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M21.553 6.064A.75.75 0 0 1 22 6.75v10.5a.75.75 0 0 1-1.256.554l-5.75-5.25a.748.748 0 0 1 0-1.108l5.75-5.25a.75.75 0 0 1 .809-.132ZM2.447 17.936A.75.75 0 0 1 2 17.25V6.75a.75.75 0 0 1 1.256-.554l5.75 5.25a.748.748 0 0 1 0 1.108l-5.75 5.25a.75.75 0 0 1-.809.132ZM7.387 12 3.5 8.45v7.1L7.388 12Zm9.226 0 3.887 3.55v-7.1L16.612 12ZM12 2.75a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm0 4a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm0 8a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm0 4a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm0-8a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$41051b6be05d5fb0 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MoonIcon", "octicon octicon-moon", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.598 1.591a.749.749 0 0 1 .785-.175 7.001 7.001 0 1 1-8.967 8.967.75.75 0 0 1 .961-.96 5.5 5.5 0 0 0 7.046-7.046.75.75 0 0 1 .175-.786Zm1.616 1.945a7 7 0 0 1-7.678 7.678 5.499 5.499 0 1 0 7.678-7.678Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M14.768 3.96v.001l-.002-.005a9.08 9.08 0 0 0-.218-.779c-.13-.394.21-.8.602-.67.29.096.575.205.855.328l.01.005A10.002 10.002 0 0 1 12 22a10.002 10.002 0 0 1-9.162-5.985l-.004-.01a9.722 9.722 0 0 1-.329-.855c-.13-.392.277-.732.67-.602.257.084.517.157.78.218l.004.002A9 9 0 0 0 14.999 6a9.09 9.09 0 0 0-.231-2.04ZM16.5 6c0 5.799-4.701 10.5-10.5 10.5-.426 0-.847-.026-1.26-.075A8.5 8.5 0 1 0 16.425 4.74c.05.413.075.833.075 1.259Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$44fe5cea2c0c4d87 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MortarBoardIcon", "octicon octicon-mortar-board", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.693 1.066a.747.747 0 0 1 .614 0l7.25 3.25a.75.75 0 0 1 0 1.368L13 6.831v2.794c0 1.024-.81 1.749-1.66 2.173-.893.447-2.075.702-3.34.702-.278 0-.55-.012-.816-.036a.75.75 0 0 1 .133-1.494c.22.02.45.03.683.03 1.082 0 2.025-.221 2.67-.543.69-.345.83-.682.83-.832V7.503L8.307 8.934a.747.747 0 0 1-.614 0L4 7.28v1.663c.296.105.575.275.812.512.438.438.688 1.059.688 1.796v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-3c0-.737.25-1.358.688-1.796.237-.237.516-.407.812-.512V6.606L.443 5.684a.75.75 0 0 1 0-1.368ZM2.583 5 8 7.428 13.416 5 8 2.572ZM2.5 11.25v2.25H4v-2.25c0-.388-.125-.611-.25-.735a.697.697 0 0 0-.5-.203.707.707 0 0 0-.5.203c-.125.124-.25.347-.25.735Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.292 2.06v-.001l11.25 4.75a.749.749 0 0 1 0 1.382L19 10.108V15a.75.75 0 0 1-.11.391h-.001a2.84 2.84 0 0 1-.392.482c-.249.256-.625.58-1.163.896-1.08.638-2.776 1.23-5.334 1.23-.673 0-1.286-.041-1.846-.113a.75.75 0 0 1 .192-1.487c.492.063 1.042.1 1.654.1 2.317 0 3.746-.533 4.572-1.021.31-.178.596-.397.849-.65l.079-.085V10.74l-5.208 2.2a.75.75 0 0 1-.584 0L5.75 10.424v3.17c.502.129.96.391 1.327.758.579.578.923 1.41.923 2.428v4.5a.761.761 0 0 1-.345.634 2.157 2.157 0 0 1-.21.117 3.923 3.923 0 0 1-.52.213A6.121 6.121 0 0 1 5 22.532a6.092 6.092 0 0 1-1.925-.288 4.065 4.065 0 0 1-.52-.213 1.816 1.816 0 0 1-.22-.124.757.757 0 0 1-.335-.624v-4.5c0-1.02.344-1.85.923-2.43a2.904 2.904 0 0 1 1.327-.757V9.793L.458 8.19a.75.75 0 0 1 0-1.38l11.25-4.75a.75.75 0 0 1 .584 0ZM12 11.436 21.322 7.5 12 3.564 2.678 7.5ZM5 15c-.377 0-.745.141-1.017.413-.265.265-.483.7-.483 1.368v4.022c.299.105.797.228 1.5.228s1.201-.123 1.5-.228V16.78c0-.669-.218-1.103-.483-1.368A1.433 1.433 0 0 0 5 15Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$377cc1726837327f = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MoveToBottomIcon", "octicon octicon-move-to-bottom", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.47 10.78a.749.749 0 0 0 1.06 0l3.75-3.75a.749.749 0 1 0-1.06-1.06L8.75 8.439V1.75a.75.75 0 0 0-1.5 0v6.689L4.78 5.97a.749.749 0 1 0-1.06 1.06l3.75 3.75ZM3.75 13a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4 21.25a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1-.75-.75Zm.97-11.28a.749.749 0 0 1 1.06 0L11 14.939V2.75a.75.75 0 0 1 1.5 0v12.189l4.97-4.969a.749.749 0 1 1 1.06 1.06l-6.25 6.25a.749.749 0 0 1-1.06 0l-6.25-6.25a.749.749 0 0 1 0-1.06Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$abbe911aeef8ac4e = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MoveToEndIcon", "octicon octicon-move-to-end", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m10.78 8.53-3.75 3.75a.749.749 0 1 1-1.06-1.06l2.469-2.47H1.75a.75.75 0 0 1 0-1.5h6.689L5.97 4.78a.749.749 0 1 1 1.06-1.06l3.75 3.75a.749.749 0 0 1 0 1.06ZM13 12.25v-8.5a.75.75 0 0 1 1.5 0v8.5a.75.75 0 0 1-1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.22 5.22a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 0 1 0 1.06l-6.25 6.25a.749.749 0 1 1-1.06-1.06l4.969-4.97H1.75a.75.75 0 0 1 0-1.5h14.439L11.22 6.28a.749.749 0 0 1 0-1.06Zm10.03-1.47a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0v-15a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$58d69b94a766904b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MoveToStartIcon", "octicon octicon-move-to-start", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.22 7.47a.749.749 0 0 0 0 1.06l3.75 3.75a.749.749 0 1 0 1.06-1.06L7.561 8.75h6.689a.75.75 0 0 0 0-1.5H7.561l2.469-2.47a.749.749 0 1 0-1.06-1.06L5.22 7.47ZM3 3.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0v-8.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.78 18.78a.749.749 0 0 1-1.06 0l-6.25-6.25a.749.749 0 0 1 0-1.06l6.25-6.25a.749.749 0 1 1 1.06 1.06l-4.969 4.97H22.25a.75.75 0 0 1 0 1.5H7.811l4.969 4.97a.749.749 0 0 1 0 1.06ZM2.75 3.75a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0v-15a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$26c7c9b4256f6586 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MoveToTopIcon", "octicon octicon-move-to-top", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.53 1.22a.749.749 0 0 0-1.06 0L3.72 4.97a.749.749 0 1 0 1.06 1.06l2.47-2.469v6.689a.75.75 0 0 0 1.5 0V3.561l2.47 2.469a.749.749 0 1 0 1.06-1.06L8.53 1.22ZM3.75 13a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4 21.25a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1-.75-.75ZM5.22 9.53a.749.749 0 0 1 0-1.06l6.25-6.25a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 1 1-1.06 1.06l-4.97-4.969V16.75a.75.75 0 0 1-1.5 0V4.561L6.28 9.53a.749.749 0 0 1-1.06 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$c3be1c67d3739de0 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MultiSelectIcon", "octicon octicon-multi-select", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.75 7.5h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5Zm0 5h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5Zm-4-10h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5ZM2 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm10.314-3.082L11.07 2.417A.25.25 0 0 1 11.256 2h4.488a.25.25 0 0 1 .186.417l-2.244 2.5a.25.25 0 0 1-.372 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.75 11.5h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5Zm0 6h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5Zm-5-12h10a.75.75 0 0 1 0 1.5h-10a.75.75 0 0 1 0-1.5ZM5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM19.309 7.918l-2.245-2.501A.25.25 0 0 1 17.25 5h4.49a.25.25 0 0 1 .185.417l-2.244 2.5a.25.25 0 0 1-.372 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$673ebbe14e3d731d = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("MuteIcon", "octicon octicon-mute", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 2.75v10.5a.751.751 0 0 1-1.238.57L3.473 11H1.75A1.75 1.75 0 0 1 0 9.25v-2.5C0 5.784.784 5 1.75 5h1.722l3.29-2.82A.75.75 0 0 1 8 2.75Zm3.28 2.47L13 6.94l1.72-1.72a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L14.06 8l1.72 1.72a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L13 9.06l-1.72 1.72a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L11.94 8l-1.72-1.72a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215Zm-7.042 1.1a.752.752 0 0 1-.488.18h-2a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2c.179 0 .352.064.488.18L6.5 11.62V4.38Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 3.75v16.5a.75.75 0 0 1-1.255.555L5.46 16H2.75A1.75 1.75 0 0 1 1 14.25v-4.5C1 8.784 1.784 8 2.75 8h2.71l5.285-4.805A.75.75 0 0 1 12 3.75ZM6.255 9.305a.748.748 0 0 1-.505.195h-3a.25.25 0 0 0-.25.25v4.5c0 .138.112.25.25.25h3c.187 0 .367.069.505.195l4.245 3.86V5.445ZM16.28 8.22a.75.75 0 1 0-1.06 1.06L17.94 12l-2.72 2.72a.75.75 0 1 0 1.06 1.06L19 13.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L20.06 12l2.72-2.72a.75.75 0 0 0-1.06-1.06L19 10.94l-2.72-2.72Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$19c0c984084c753 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("NoEntryIcon", "octicon octicon-no-entry", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.25 7.25a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Zm15.75.75H5.75a.75.75 0 0 1 0-1.5h12.5a.75.75 0 0 1 0 1.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$7918cde1533be8c0 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("NoEntryFillIcon", "octicon octicon-no-entry-fill", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0Zm3 5H3v2h6Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$ee28a268adaf5c94 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("NorthStarIcon", "octicon octicon-north-star", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.5.75a.75.75 0 0 0-1.5 0v5.19L4.391 3.33a.75.75 0 1 0-1.06 1.061L5.939 7H.75a.75.75 0 0 0 0 1.5h5.19l-2.61 2.609a.75.75 0 1 0 1.061 1.06L7 9.561v5.189a.75.75 0 0 0 1.5 0V9.56l2.609 2.61a.75.75 0 1 0 1.06-1.061L9.561 8.5h5.189a.75.75 0 0 0 0-1.5H9.56l2.61-2.609a.75.75 0 0 0-1.061-1.06L8.5 5.939V.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.5 1.25a.75.75 0 0 0-1.5 0v8.69L6.447 5.385a.75.75 0 1 0-1.061 1.06L9.94 11H1.25a.75.75 0 0 0 0 1.5h8.69l-4.554 4.553a.75.75 0 0 0 1.06 1.061L11 13.561v8.689a.75.75 0 0 0 1.5 0v-8.69l4.553 4.554a.75.75 0 0 0 1.061-1.06L13.561 12.5h8.689a.75.75 0 0 0 0-1.5h-8.69l4.554-4.553a.75.75 0 1 0-1.06-1.061L12.5 9.939V1.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$70371617cfe16c87 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("NoteIcon", "octicon octicon-note", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 3.75C0 2.784.784 2 1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25ZM3.5 6.25a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75Zm.75 2.25h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 4.75C0 3.784.784 3 1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V4.75a.25.25 0 0 0-.25-.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5 8.75A.75.75 0 0 1 5.75 8h11.5a.75.75 0 0 1 0 1.5H5.75A.75.75 0 0 1 5 8.75Zm0 4a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$d54ddb7fa76bbee2 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("NumberIcon", "octicon octicon-number", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9 4.75A.75.75 0 0 1 9.75 4h4a.75.75 0 0 1 .53 1.28l-1.89 1.892c.312.076.604.18.867.319.742.391 1.244 1.063 1.244 2.005 0 .653-.231 1.208-.629 1.627-.386.408-.894.653-1.408.777-1.01.243-2.225.063-3.124-.527a.751.751 0 0 1 .822-1.254c.534.35 1.32.474 1.951.322.306-.073.53-.201.67-.349.129-.136.218-.32.218-.596 0-.308-.123-.509-.444-.678-.373-.197-.98-.318-1.806-.318a.75.75 0 0 1-.53-1.28l1.72-1.72H9.75A.75.75 0 0 1 9 4.75Zm-3.587 5.763c-.35-.05-.77.113-.983.572a.75.75 0 1 1-1.36-.632c.508-1.094 1.589-1.565 2.558-1.425 1 .145 1.872.945 1.872 2.222 0 1.433-1.088 2.192-1.79 2.681-.308.216-.571.397-.772.573H7a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75c0-.69.3-1.211.67-1.61.348-.372.8-.676 1.15-.92.8-.56 1.18-.904 1.18-1.474 0-.473-.267-.69-.587-.737ZM5.604.089A.75.75 0 0 1 6 .75v4.77h.711a.75.75 0 0 1 0 1.5H3.759a.75.75 0 0 1 0-1.5H4.5V2.15l-.334.223a.75.75 0 0 1-.832-1.248l1.5-1a.75.75 0 0 1 .77-.037Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.003 7.754a.75.75 0 0 1 .75-.75h5.232a.75.75 0 0 1 .53 1.28l-2.776 2.777c.55.097 1.057.253 1.492.483.905.477 1.504 1.284 1.504 2.418 0 .966-.471 1.75-1.172 2.27-.687.511-1.587.77-2.521.77-1.367 0-2.274-.528-2.667-.756a.75.75 0 0 1 .755-1.297c.331.193.953.553 1.912.553.673 0 1.243-.188 1.627-.473.37-.275.566-.635.566-1.067 0-.5-.219-.836-.703-1.091-.538-.284-1.375-.443-2.471-.443a.75.75 0 0 1-.53-1.28l2.643-2.644h-3.421a.75.75 0 0 1-.75-.75ZM7.88 15.215a1.4 1.4 0 0 0-1.446.83.75.75 0 0 1-1.37-.61 2.899 2.899 0 0 1 2.986-1.71c.589.06 1.139.323 1.557.743.434.446.685 1.058.685 1.778 0 1.641-1.254 2.437-2.12 2.986-.538.341-1.18.694-1.495 1.273H9.75a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75c0-1.799 1.337-2.63 2.243-3.21 1.032-.659 1.55-1.031 1.55-1.8 0-.355-.116-.584-.26-.732a1.071 1.071 0 0 0-.652-.298Zm.234-13.121a.75.75 0 0 1 .386.656V9h1.252a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1 0-1.5H7V4.103l-.853.533a.749.749 0 1 1-.795-1.272l2-1.25a.749.749 0 0 1 .762-.02Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8a496f5a1e4249b1 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("OrganizationIcon", "octicon octicon-organization", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 16A1.75 1.75 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0h8.5C11.216 0 12 .784 12 1.75v12.5c0 .085-.006.168-.018.25h2.268a.25.25 0 0 0 .25-.25V8.285a.25.25 0 0 0-.111-.208l-1.055-.703a.749.749 0 1 1 .832-1.248l1.055.703c.487.325.779.871.779 1.456v5.965A1.75 1.75 0 0 1 14.25 16h-3.5a.766.766 0 0 1-.197-.026c-.099.017-.2.026-.303.026h-3a.75.75 0 0 1-.75-.75V14h-1v1.25a.75.75 0 0 1-.75.75Zm-.25-1.75c0 .138.112.25.25.25H4v-1.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.25h2.25a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25ZM3.75 6h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM3 3.75A.75.75 0 0 1 3.75 3h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 3.75Zm4 3A.75.75 0 0 1 7.75 6h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 7 6.75ZM7.75 3h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM3 9.75A.75.75 0 0 1 3.75 9h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 9.75ZM7.75 9h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.25 12a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM5.5 9.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM6.25 5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM9 12.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm.75-4.25a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM9 5.75A.75.75 0 0 1 9.75 5h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 9 5.75ZM13.25 12a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Zm-.75-2.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM13.25 5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 20V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v17c0 .173-.022.34-.063.5H20a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.2-.4l-.5-.375a.75.75 0 0 1 .9-1.2l.5.375c.504.378.8.97.8 1.6v8a2 2 0 0 1-2 2h-3.562a.767.767 0 0 1-.166-.018c-.089.012-.18.018-.272.018h-3.75a.75.75 0 0 1-.75-.75V19h-3v2.25a.75.75 0 0 1-.75.75H4a2 2 0 0 1-2-2Zm2 .5h3v-2.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v2.25h3a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v17a.5.5 0 0 0 .5.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$4e926151f2105842 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PackageIcon", "octicon octicon-package", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m8.878.392 5.25 3.045c.54.314.872.89.872 1.514v6.098a1.75 1.75 0 0 1-.872 1.514l-5.25 3.045a1.75 1.75 0 0 1-1.756 0l-5.25-3.045A1.75 1.75 0 0 1 1 11.049V4.951c0-.624.332-1.201.872-1.514L7.122.392a1.75 1.75 0 0 1 1.756 0ZM7.875 1.69l-4.63 2.685L8 7.133l4.755-2.758-4.63-2.685a.248.248 0 0 0-.25 0ZM2.5 5.677v5.372c0 .09.047.171.125.216l4.625 2.683V8.432Zm6.25 8.271 4.625-2.683a.25.25 0 0 0 .125-.216V5.677L8.75 8.432Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.876.64V.639l8.25 4.763c.541.313.875.89.875 1.515v9.525a1.75 1.75 0 0 1-.875 1.516l-8.25 4.762a1.748 1.748 0 0 1-1.75 0l-8.25-4.763a1.75 1.75 0 0 1-.875-1.515V6.917c0-.625.334-1.202.875-1.515L11.126.64a1.748 1.748 0 0 1 1.75 0Zm-1 1.298L4.251 6.34l7.75 4.474 7.75-4.474-7.625-4.402a.248.248 0 0 0-.25 0Zm.875 19.123 7.625-4.402a.25.25 0 0 0 .125-.216V7.639l-7.75 4.474ZM3.501 7.64v8.803c0 .09.048.172.125.216l7.625 4.402v-8.947Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$10ac854e619b28ae = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PackageDependenciesIcon", "octicon octicon-package-dependencies", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.122.392a1.75 1.75 0 0 1 1.756 0l5.25 3.045c.54.313.872.89.872 1.514V7.25a.75.75 0 0 1-1.5 0V5.677L7.75 8.432v6.384a1 1 0 0 1-1.502.865L.872 12.563A1.75 1.75 0 0 1 0 11.049V4.951c0-.624.332-1.2.872-1.514ZM7.125 1.69a.248.248 0 0 0-.25 0l-4.63 2.685L7 7.133l4.755-2.758ZM1.5 11.049a.25.25 0 0 0 .125.216l4.625 2.683V8.432L1.5 5.677Zm11.672-.282L11.999 12h3.251a.75.75 0 0 1 0 1.5h-3.251l1.173 1.233a.75.75 0 1 1-1.087 1.034l-2.378-2.5a.75.75 0 0 1 0-1.034l2.378-2.5a.75.75 0 0 1 1.087 1.034Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.126.64a1.748 1.748 0 0 1 1.75 0l8.25 4.762c.103.06.199.128.286.206a.75.75 0 0 1 .554.96c.023.113.035.23.035.35v3.332a.75.75 0 0 1-1.5 0V7.64l-7.75 4.474V22.36a.75.75 0 0 1-1.125.65l-8.75-5.052a1.75 1.75 0 0 1-.875-1.515V6.917c0-.119.012-.236.035-.35a.749.749 0 0 1 .554-.96c.088-.078.184-.146.286-.205L9.126.639Zm.875 10.173v.001l7.75-4.474-7.625-4.402a.248.248 0 0 0-.25 0L2.251 6.34Zm-8.5-3.175v8.803c0 .09.048.172.125.216l7.625 4.402v-8.947Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m16.617 17.5 2.895-2.702a.75.75 0 0 0-1.024-1.096l-4.285 4a.75.75 0 0 0 0 1.096l4.285 4a.75.75 0 1 0 1.024-1.096L16.617 19h6.633a.75.75 0 0 0 0-1.5h-6.633Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$73418c33e4867499 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PackageDependentsIcon", "octicon octicon-package-dependents", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.122.392a1.75 1.75 0 0 1 1.756 0l5.25 3.045c.54.313.872.89.872 1.514V7.25a.75.75 0 0 1-1.5 0V5.677L7.75 8.432v6.384a1 1 0 0 1-1.502.865L.872 12.563A1.75 1.75 0 0 1 0 11.049V4.951c0-.624.332-1.2.872-1.514ZM7.125 1.69a.248.248 0 0 0-.25 0l-4.63 2.685L7 7.133l4.755-2.758ZM1.5 11.049a.25.25 0 0 0 .125.216l4.625 2.683V8.432L1.5 5.677Zm10.828 3.684 1.173-1.233H10.25a.75.75 0 0 1 0-1.5h3.251l-1.173-1.233a.75.75 0 1 1 1.087-1.034l2.378 2.5a.75.75 0 0 1 0 1.034l-2.378 2.5a.75.75 0 0 1-1.087-1.034Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.126.64a1.748 1.748 0 0 1 1.75 0l8.25 4.762c.103.06.199.128.286.206a.75.75 0 0 1 .554.96c.023.113.035.23.035.35v3.332a.75.75 0 0 1-1.5 0V7.64l-7.75 4.474V22.36a.75.75 0 0 1-1.125.65l-8.75-5.052a1.75 1.75 0 0 1-.875-1.515V6.917c0-.119.012-.236.035-.35a.749.749 0 0 1 .554-.96c.088-.078.184-.146.286-.205L9.126.639Zm.875 10.173v.001l7.75-4.474-7.625-4.402a.248.248 0 0 0-.25 0L2.251 6.34Zm-8.5-3.175v8.803c0 .09.048.172.125.216l7.625 4.402v-8.947Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m21.347 17.5-2.894-2.702a.75.75 0 1 1 1.023-1.096l4.286 4a.75.75 0 0 1 0 1.096l-4.286 4a.75.75 0 1 1-1.023-1.096L21.347 19h-6.633a.75.75 0 0 1 0-1.5h6.633Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$6963b889227d4aa4 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PaintbrushIcon", "octicon octicon-paintbrush", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.134 1.535c.7-.509 1.416-.942 2.076-1.155.649-.21 1.463-.267 2.069.34.603.601.568 1.411.368 2.07-.202.668-.624 1.39-1.125 2.096-1.011 1.424-2.496 2.987-3.775 4.249-1.098 1.084-2.132 1.839-3.04 2.3a3.744 3.744 0 0 1-1.055 3.217c-.431.431-1.065.691-1.657.861-.614.177-1.294.287-1.914.357A21.151 21.151 0 0 1 .797 16H.743l.007-.75H.749L.742 16a.75.75 0 0 1-.743-.742l.743-.008-.742.007v-.054a21.25 21.25 0 0 1 .13-2.284c.067-.647.187-1.287.358-1.914.17-.591.43-1.226.86-1.657a3.746 3.746 0 0 1 3.227-1.054c.466-.893 1.225-1.907 2.314-2.982 1.271-1.255 2.833-2.75 4.245-3.777ZM1.62 13.089c-.051.464-.086.929-.104 1.395.466-.018.932-.053 1.396-.104a10.511 10.511 0 0 0 1.668-.309c.526-.151.856-.325 1.011-.48a2.25 2.25 0 1 0-3.182-3.182c-.155.155-.329.485-.48 1.01a10.515 10.515 0 0 0-.309 1.67Zm10.396-10.34c-1.224.89-2.605 2.189-3.822 3.384l1.718 1.718c1.21-1.205 2.51-2.597 3.387-3.833.47-.662.78-1.227.912-1.662.134-.444.032-.551.009-.575h-.001V1.78c-.014-.014-.113-.113-.548.027-.432.14-.995.462-1.655.942Zm-4.832 7.266-.001.001a9.859 9.859 0 0 0 1.63-1.142L7.155 7.216a9.7 9.7 0 0 0-1.161 1.607c.482.302.889.71 1.19 1.192Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$bd597ed9308dedb4 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PaperAirplaneIcon", "octicon octicon-paper-airplane", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M.989 8 .064 2.68a1.342 1.342 0 0 1 1.85-1.462l13.402 5.744a1.13 1.13 0 0 1 0 2.076L1.913 14.782a1.343 1.343 0 0 1-1.85-1.463L.99 8Zm.603-5.288L2.38 7.25h4.87a.75.75 0 0 1 0 1.5H2.38l-.788 4.538L13.929 8Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.513 1.96a1.374 1.374 0 0 1 1.499-.21l19.335 9.215a1.147 1.147 0 0 1 0 2.07L3.012 22.25a1.374 1.374 0 0 1-1.947-1.46L2.49 12 1.065 3.21a1.375 1.375 0 0 1 .448-1.25Zm2.375 10.79-1.304 8.042L21.031 12 2.584 3.208l1.304 8.042h7.362a.75.75 0 0 1 0 1.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$a46755b952c02768 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PaperclipIcon", "octicon octicon-paperclip", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.212 3.02a1.753 1.753 0 0 0-2.478.003l-5.83 5.83a3.007 3.007 0 0 0-.88 2.127c0 .795.315 1.551.88 2.116.567.567 1.333.89 2.126.89.79 0 1.548-.321 2.116-.89l5.48-5.48a.75.75 0 0 1 1.061 1.06l-5.48 5.48a4.492 4.492 0 0 1-3.177 1.33c-1.2 0-2.345-.487-3.187-1.33a4.483 4.483 0 0 1-1.32-3.177c0-1.195.475-2.341 1.32-3.186l5.83-5.83a3.25 3.25 0 0 1 5.553 2.297c0 .863-.343 1.691-.953 2.301L7.439 12.39c-.375.377-.884.59-1.416.593a1.998 1.998 0 0 1-1.412-.593 1.992 1.992 0 0 1 0-2.828l5.48-5.48a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-5.48 5.48a.492.492 0 0 0 0 .707.499.499 0 0 0 .352.154.51.51 0 0 0 .356-.154l5.833-5.827a1.755 1.755 0 0 0 0-2.481Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M19.187 3.588a2.75 2.75 0 0 0-3.889 0L5.575 13.31a4.5 4.5 0 0 0 6.364 6.364l8.662-8.662a.75.75 0 0 1 1.061 1.06L13 20.735a6 6 0 0 1-8.485-8.485l9.723-9.723a4.247 4.247 0 0 1 4.124-1.139 4.247 4.247 0 0 1 3.025 3.025 4.247 4.247 0 0 1-1.139 4.124l-9.193 9.193a2.64 2.64 0 0 1-1.858.779 2.626 2.626 0 0 1-1.854-.779c-.196-.196-.338-.47-.43-.726a2.822 2.822 0 0 1-.168-.946c0-.7.284-1.373.775-1.864l8.132-8.131a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-8.131 8.132a1.148 1.148 0 0 0-.336.803c.003.204.053.405.146.587.01.018.018.028.02.032.22.215.501.332.786.332.29 0 .58-.121.798-.34l9.192-9.192a2.75 2.75 0 0 0 0-3.89Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$50e7a5e2e571d53b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PasskeyFillIcon", "octicon octicon-passkey-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.743 4.757a3.757 3.757 0 1 1 5.851 3.119 5.991 5.991 0 0 1 2.15 1.383c.17.17.257.405.258.646.003.598.001 1.197 0 1.795L11 12.778v.721a.5.5 0 0 1-.5.5H1.221a.749.749 0 0 1-.714-.784 6.004 6.004 0 0 1 3.899-5.339 3.754 3.754 0 0 1-1.663-3.119Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15.75 6.875c0 .874-.448 1.643-1.127 2.09a.265.265 0 0 0-.123.22v.59c0 .067-.026.13-.073.177l-.356.356a.125.125 0 0 0 0 .177l.356.356c.047.047.073.11.073.176v.231c0 .067-.026.13-.073.177l-.356.356a.125.125 0 0 0 0 .177l.356.356c.047.047.073.11.073.177v.287a.247.247 0 0 1-.065.168l-.8.88a.52.52 0 0 1-.77 0l-.8-.88a.247.247 0 0 1-.065-.168V9.185a.264.264 0 0 0-.123-.22 2.5 2.5 0 1 1 3.873-2.09ZM14 6.5a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.496 2a5.25 5.25 0 0 0-2.519 9.857A9.006 9.006 0 0 0 .5 20.228a.751.751 0 0 0 .728.772h5.257c3.338.001 6.677.002 10.015 0a.5.5 0 0 0 .5-.5v-4.669a.95.95 0 0 0-.171-.551 9.02 9.02 0 0 0-4.814-3.423A5.25 5.25 0 0 0 9.496 2Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M23.625 10.313c0 1.31-.672 2.464-1.691 3.134a.398.398 0 0 0-.184.33v.886a.372.372 0 0 1-.11.265l-.534.534a.188.188 0 0 0 0 .265l.534.534c.071.07.11.166.11.265v.347a.374.374 0 0 1-.11.265l-.534.534a.188.188 0 0 0 0 .265l.534.534a.37.37 0 0 1 .11.265v.431a.379.379 0 0 1-.097.253l-1.2 1.319a.781.781 0 0 1-1.156 0l-1.2-1.319a.379.379 0 0 1-.097-.253v-5.39a.398.398 0 0 0-.184-.33 3.75 3.75 0 1 1 5.809-3.134ZM21 9.75a1.125 1.125 0 1 0-2.25 0 1.125 1.125 0 0 0 2.25 0Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$a88dc56ae22bf1c = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PasteIcon", "octicon octicon-paste", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.626 3.533a.249.249 0 0 0-.126.217v9.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-9.5a.249.249 0 0 0-.126-.217.75.75 0 0 1 .752-1.298c.541.313.874.89.874 1.515v9.5A1.75 1.75 0 0 1 12.25 15h-8.5A1.75 1.75 0 0 1 2 13.25v-9.5c0-.625.333-1.202.874-1.515a.75.75 0 0 1 .752 1.298ZM5.75 1h4.5a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-4.5A.75.75 0 0 1 5 4.75v-3A.75.75 0 0 1 5.75 1Zm.75 3h3V2.5h-3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.962 2.513a.75.75 0 0 1-.475.949l-.816.272a.25.25 0 0 0-.171.237V21.25c0 .138.112.25.25.25h14.5a.25.25 0 0 0 .25-.25V3.97a.25.25 0 0 0-.17-.236l-.817-.272a.75.75 0 0 1 .474-1.424l.816.273A1.751 1.751 0 0 1 21 3.97v17.28A1.75 1.75 0 0 1 19.25 23H4.75A1.75 1.75 0 0 1 3 21.25V3.97a1.75 1.75 0 0 1 1.197-1.66l.816-.272a.75.75 0 0 1 .949.475Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7 1.75C7 .784 7.784 0 8.75 0h6.5C16.216 0 17 .784 17 1.75v1.5A1.75 1.75 0 0 1 15.25 5h-6.5A1.75 1.75 0 0 1 7 3.25Zm1.75-.25a.25.25 0 0 0-.25.25v1.5c0 .138.112.25.25.25h6.5a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$d2c72b688139a728 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PencilIcon", "octicon octicon-pencil", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.013 1.427a1.75 1.75 0 0 1 2.474 0l1.086 1.086a1.75 1.75 0 0 1 0 2.474l-8.61 8.61c-.21.21-.47.364-.756.445l-3.251.93a.75.75 0 0 1-.927-.928l.929-3.25c.081-.286.235-.547.445-.758l8.61-8.61Zm.176 4.823L9.75 4.81l-6.286 6.287a.253.253 0 0 0-.064.108l-.558 1.953 1.953-.558a.253.253 0 0 0 .108-.064Zm1.238-3.763a.25.25 0 0 0-.354 0L10.811 3.75l1.439 1.44 1.263-1.263a.25.25 0 0 0 0-.354Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M17.263 2.177a1.75 1.75 0 0 1 2.474 0l2.586 2.586a1.75 1.75 0 0 1 0 2.474L19.53 10.03l-.012.013L8.69 20.378a1.753 1.753 0 0 1-.699.409l-5.523 1.68a.748.748 0 0 1-.747-.188.748.748 0 0 1-.188-.747l1.673-5.5a1.75 1.75 0 0 1 .466-.756L14.476 4.963ZM4.708 16.361a.26.26 0 0 0-.067.108l-1.264 4.154 4.177-1.271a.253.253 0 0 0 .1-.059l10.273-9.806-2.94-2.939-10.279 9.813ZM19 8.44l2.263-2.262a.25.25 0 0 0 0-.354l-2.586-2.586a.25.25 0 0 0-.354 0L16.061 5.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$a0096b57009ecc7c = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PeopleIcon", "octicon octicon-people", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 5.5a3.5 3.5 0 1 1 5.898 2.549 5.508 5.508 0 0 1 3.034 4.084.75.75 0 1 1-1.482.235 4 4 0 0 0-7.9 0 .75.75 0 0 1-1.482-.236A5.507 5.507 0 0 1 3.102 8.05 3.493 3.493 0 0 1 2 5.5ZM11 4a3.001 3.001 0 0 1 2.22 5.018 5.01 5.01 0 0 1 2.56 3.012.749.749 0 0 1-.885.954.752.752 0 0 1-.549-.514 3.507 3.507 0 0 0-2.522-2.372.75.75 0 0 1-.574-.73v-.352a.75.75 0 0 1 .416-.672A1.5 1.5 0 0 0 11 5.5.75.75 0 0 1 11 4Zm-5.5-.5a2 2 0 1 0-.001 3.999A2 2 0 0 0 5.5 3.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.5 8a5.5 5.5 0 1 1 8.596 4.547 9.005 9.005 0 0 1 5.9 8.18.751.751 0 0 1-1.5.045 7.5 7.5 0 0 0-14.993 0 .75.75 0 0 1-1.499-.044 9.005 9.005 0 0 1 5.9-8.181A5.496 5.496 0 0 1 3.5 8ZM9 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm8.29 4c-.148 0-.292.01-.434.03a.75.75 0 1 1-.212-1.484 4.53 4.53 0 0 1 3.38 8.097 6.69 6.69 0 0 1 3.956 6.107.75.75 0 0 1-1.5 0 5.193 5.193 0 0 0-3.696-4.972l-.534-.16v-1.676l.41-.209A3.03 3.03 0 0 0 17.29 8Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$7dcc8f518762622d = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PersonIcon", "octicon octicon-person", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.561 8.073a6.005 6.005 0 0 1 3.432 5.142.75.75 0 1 1-1.498.07 4.5 4.5 0 0 0-8.99 0 .75.75 0 0 1-1.498-.07 6.004 6.004 0 0 1 3.431-5.142 3.999 3.999 0 1 1 5.123 0ZM10.5 5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 2.5a5.5 5.5 0 0 1 3.096 10.047 9.005 9.005 0 0 1 5.9 8.181.75.75 0 1 1-1.499.044 7.5 7.5 0 0 0-14.993 0 .75.75 0 0 1-1.5-.045 9.005 9.005 0 0 1 5.9-8.18A5.5 5.5 0 0 1 12 2.5ZM8 8a4 4 0 1 0 8 0 4 4 0 0 0-8 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$d6ee0666164b3f7a = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PersonAddIcon", "octicon octicon-person-add", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.9 8.548h-.001a5.528 5.528 0 0 1 3.1 4.659.75.75 0 1 1-1.498.086A4.01 4.01 0 0 0 5.5 9.5a4.01 4.01 0 0 0-4.001 3.793.75.75 0 1 1-1.498-.085 5.527 5.527 0 0 1 3.1-4.66 3.5 3.5 0 1 1 4.799 0ZM13.25 0a.75.75 0 0 1 .75.75V2h1.25a.75.75 0 0 1 0 1.5H14v1.25a.75.75 0 0 1-1.5 0V3.5h-1.25a.75.75 0 0 1 0-1.5h1.25V.75a.75.75 0 0 1 .75-.75ZM5.5 4a2 2 0 1 0-.001 3.999A2 2 0 0 0 5.5 4Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4 9.5a5 5 0 1 1 7.916 4.062 7.973 7.973 0 0 1 5.018 7.166.75.75 0 1 1-1.499.044 6.469 6.469 0 0 0-12.932 0 .75.75 0 0 1-1.499-.044 7.972 7.972 0 0 1 5.059-7.181A4.994 4.994 0 0 1 4 9.5ZM9 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm10.25-5a.75.75 0 0 1 .75.75V4h2.25a.75.75 0 0 1 0 1.5H20v2.25a.75.75 0 0 1-1.5 0V5.5h-2.25a.75.75 0 0 1 0-1.5h2.25V1.75a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$3a99346ff3f8771a = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PersonFillIcon", "octicon octicon-person-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.243 4.757a3.757 3.757 0 1 1 5.851 3.119 6.006 6.006 0 0 1 3.9 5.339.75.75 0 0 1-.715.784H2.721a.75.75 0 0 1-.714-.784 6.006 6.006 0 0 1 3.9-5.34 3.753 3.753 0 0 1-1.664-3.118Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 2.5a5.25 5.25 0 0 0-2.519 9.857 9.005 9.005 0 0 0-6.477 8.37.75.75 0 0 0 .727.773H20.27a.75.75 0 0 0 .727-.772 9.005 9.005 0 0 0-6.477-8.37A5.25 5.25 0 0 0 12 2.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8dedaee0e594ee0e = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PinIcon", "octicon octicon-pin", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.456.734a1.75 1.75 0 0 1 2.826.504l.613 1.327a3.08 3.08 0 0 0 2.084 1.707l2.454.584c1.332.317 1.8 1.972.832 2.94L11.06 10l3.72 3.72a.748.748 0 0 1-.332 1.265.75.75 0 0 1-.729-.205L10 11.06l-2.204 2.205c-.968.968-2.623.5-2.94-.832l-.584-2.454a3.08 3.08 0 0 0-1.707-2.084l-1.327-.613a1.75 1.75 0 0 1-.504-2.826ZM5.92 1.866a.253.253 0 0 0-.183-.142.251.251 0 0 0-.221.07L1.794 5.516a.251.251 0 0 0-.07.221c.015.08.068.149.142.183l1.328.613A4.582 4.582 0 0 1 5.73 9.63l.584 2.454a.251.251 0 0 0 .42.12l5.47-5.47a.25.25 0 0 0-.12-.42L9.63 5.73a4.583 4.583 0 0 1-3.098-2.537Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.886 1.553a1.75 1.75 0 0 1 2.869.604l.633 1.629a5.667 5.667 0 0 0 3.725 3.395l3.959 1.131a1.749 1.749 0 0 1 .757 2.92L16.06 15l5.594 5.595a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L15 16.061l-3.768 3.768a1.749 1.749 0 0 1-2.92-.757l-1.131-3.96a5.665 5.665 0 0 0-3.395-3.724l-1.63-.633a1.75 1.75 0 0 1-.603-2.869Zm6.589 12.912 4.293-4.294a.25.25 0 0 0-.108-.417L14.7 8.623A7.165 7.165 0 0 1 9.99 4.33L9.357 2.7a.25.25 0 0 0-.41-.086L2.614 8.946a.25.25 0 0 0 .086.41l1.63.634a7.167 7.167 0 0 1 4.294 4.71l1.13 3.96a.25.25 0 0 0 .417.108l4.294-4.293Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$a6630b90defda83f = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PlayIcon", "octicon octicon-play", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm4.879-2.773 4.264 2.559a.25.25 0 0 1 0 .428l-4.264 2.559A.25.25 0 0 1 6 10.559V5.442a.25.25 0 0 1 .379-.215Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.5 15.584V8.416a.5.5 0 0 1 .77-.42l5.576 3.583a.5.5 0 0 1 0 .842l-5.576 3.584a.5.5 0 0 1-.77-.42Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$12e0cea57aa8d2f2 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PlugIcon", "octicon octicon-plug", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4 8H2.5a1 1 0 0 0-1 1v5.25a.75.75 0 0 1-1.5 0V9a2.5 2.5 0 0 1 2.5-2.5H4V5.133a1.75 1.75 0 0 1 1.533-1.737l2.831-.353.76-.913c.332-.4.825-.63 1.344-.63h.782c.966 0 1.75.784 1.75 1.75V4h2.25a.75.75 0 0 1 0 1.5H13v4h2.25a.75.75 0 0 1 0 1.5H13v.75a1.75 1.75 0 0 1-1.75 1.75h-.782c-.519 0-1.012-.23-1.344-.63l-.761-.912-2.83-.354A1.75 1.75 0 0 1 4 9.867Zm6.276-4.91-.95 1.14a.753.753 0 0 1-.483.265l-3.124.39a.25.25 0 0 0-.219.248v4.734c0 .126.094.233.219.249l3.124.39a.752.752 0 0 1 .483.264l.95 1.14a.25.25 0 0 0 .192.09h.782a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25h-.782a.25.25 0 0 0-.192.09Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7 11.5H2.938c-.794 0-1.438.644-1.438 1.437v8.313a.75.75 0 0 1-1.5 0v-8.312A2.939 2.939 0 0 1 2.937 10H7V6.151c0-.897.678-1.648 1.57-1.74l6.055-.626 1.006-1.174A1.752 1.752 0 0 1 16.96 2h1.29c.966 0 1.75.784 1.75 1.75V6h3.25a.75.75 0 0 1 0 1.5H20V14h3.25a.75.75 0 0 1 0 1.5H20v2.25a1.75 1.75 0 0 1-1.75 1.75h-1.29a1.75 1.75 0 0 1-1.329-.611l-1.006-1.174-6.055-.627A1.749 1.749 0 0 1 7 15.348Zm9.77-7.913v.001l-1.201 1.4a.75.75 0 0 1-.492.258l-6.353.657a.25.25 0 0 0-.224.249v9.196a.25.25 0 0 0 .224.249l6.353.657c.191.02.368.112.493.258l1.2 1.401a.252.252 0 0 0 .19.087h1.29a.25.25 0 0 0 .25-.25v-14a.25.25 0 0 0-.25-.25h-1.29a.252.252 0 0 0-.19.087Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$f21ab0717a89c77f = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PlusIcon", "octicon octicon-plus", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.75 2a.75.75 0 0 1 .75.75V7h4.25a.75.75 0 0 1 0 1.5H8.5v4.25a.75.75 0 0 1-1.5 0V8.5H2.75a.75.75 0 0 1 0-1.5H7V2.75A.75.75 0 0 1 7.75 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.75 4.5a.75.75 0 0 1 .75.75V11h5.75a.75.75 0 0 1 0 1.5H12.5v5.75a.75.75 0 0 1-1.5 0V12.5H5.25a.75.75 0 0 1 0-1.5H11V5.25a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$99bb4c5ac5bf5ec5 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PlusCircleIcon", "octicon octicon-plus-circle", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm7.25-3.25v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5a.75.75 0 0 1 1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.75 7.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$219c8b8c393795b3 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ProjectIcon", "octicon octicon-project", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0ZM1.5 1.75v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25ZM11.75 3a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-1.5 0v-7.5a.75.75 0 0 1 .75-.75Zm-8.25.75a.75.75 0 0 1 1.5 0v5.5a.75.75 0 0 1-1.5 0ZM8 3a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.25 6a.75.75 0 0 0-.75.75v7.5a.75.75 0 0 0 1.5 0v-7.5A.75.75 0 0 0 7.25 6ZM12 6a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 12 6Zm4 .75a.75.75 0 0 1 1.5 0v9.5a.75.75 0 0 1-1.5 0v-9.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2ZM3.5 3.75v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H3.75a.25.25 0 0 0-.25.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$1a80f113fc555686 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ProjectRoadmapIcon", "octicon octicon-project-roadmap", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.75 7a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5ZM5 4.75A.75.75 0 0 1 5.75 4h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 5 4.75ZM6.75 10a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.75 7a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5ZM7 11.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75ZM9.75 15a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$deb880182502ec00 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ProjectSymlinkIcon", "octicon octicon-project-symlink", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16h-8.5a.75.75 0 0 1 0-1.5h8.5a.25.25 0 0 0 .25-.25V6.5h-13v1.75a.75.75 0 0 1-1.5 0ZM6.5 5h8V1.75a.25.25 0 0 0-.25-.25H6.5Zm-5 0H5V1.5H1.75a.25.25 0 0 0-.25.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.5 13.737a2.25 2.25 0 0 1 2.262-2.25L4 11.49v1.938c0 .218.26.331.42.183l2.883-2.677a.25.25 0 0 0 0-.366L4.42 7.89a.25.25 0 0 0-.42.183V9.99l-.23-.001A3.75 3.75 0 0 0 0 13.738v1.012a.75.75 0 0 0 1.5 0v-1.013Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H9.75a.75.75 0 0 1 0-1.5h10.5a.25.25 0 0 0 .25-.25V9h-17v3A.75.75 0 0 1 2 12ZM9 7.5h11.5V3.75a.25.25 0 0 0-.25-.25H9Zm-5.5 0h4v-4H3.75a.25.25 0 0 0-.25.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m9.308 14.5-2.104-2.236a.75.75 0 1 1 1.092-1.028l3.294 3.5a.75.75 0 0 1 0 1.028l-3.294 3.5a.75.75 0 1 1-1.092-1.028L9.308 16H6.09a2.59 2.59 0 0 0-2.59 2.59v2.66a.75.75 0 0 1-1.5 0v-2.66a4.09 4.09 0 0 1 4.09-4.09h3.218Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$6d9633df09ef233d = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ProjectTemplateIcon", "octicon octicon-project-template", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.5 1.75v1.562a.75.75 0 1 1-1.5 0V1.75C0 .784.784 0 1.75 0h1.562a.75.75 0 1 1 0 1.5H1.75a.25.25 0 0 0-.25.25ZM6.438 0h3.124a.75.75 0 1 1 0 1.5H6.438a.75.75 0 1 1 0-1.5Zm6.25 0h1.562C15.217 0 16 .784 16 1.75v1.562a.75.75 0 1 1-1.5 0V1.75a.25.25 0 0 0-.25-.25h-1.562a.75.75 0 1 1 0-1.5ZM1.5 6.438v3.124a.75.75 0 1 1-1.5 0V6.438a.75.75 0 1 1 1.5 0Zm14.5 0v3.124a.75.75 0 1 1-1.5 0V6.438a.75.75 0 1 1 1.5 0Zm-14.5 6.25v1.562c0 .138.112.25.25.25h1.562a.75.75 0 1 1 0 1.5H1.75A1.75 1.75 0 0 1 0 14.25v-1.562a.75.75 0 1 1 1.5 0Zm14.5 0v1.562A1.75 1.75 0 0 1 14.25 16h-1.562a.75.75 0 1 1 0-1.5h1.562a.25.25 0 0 0 .25-.25v-1.562a.75.75 0 1 1 1.5 0ZM6.438 14.5h3.124a.75.75 0 1 1 0 1.5H6.438a.75.75 0 1 1 0-1.5ZM6.5 3v1A.75.75 0 0 1 5 4V3a.75.75 0 0 1 1.5 0ZM2.25 5.75A.75.75 0 0 1 3 5h1a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Zm4.5 0A.75.75 0 0 1 7.5 5h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm-1 1a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm.75 4v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0Zm3.5-5a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.75 3.5a.25.25 0 0 0-.25.25v2.062a.75.75 0 1 1-1.5 0V3.75C2 2.783 2.783 2 3.75 2h2.062a.75.75 0 1 1 0 1.5Zm13.688-.75a.75.75 0 0 1 .75-.75h2.062c.966 0 1.75.783 1.75 1.75v2.062a.75.75 0 1 1-1.5 0V3.75a.25.25 0 0 0-.25-.25h-2.062a.75.75 0 0 1-.75-.75ZM2.75 17.438a.75.75 0 0 1 .75.75v2.062c0 .138.112.25.25.25h2.062a.75.75 0 1 1 0 1.5H3.75A1.75 1.75 0 0 1 2 20.25v-2.062a.75.75 0 0 1 .75-.75Zm18.5 0a.75.75 0 0 1 .75.75v2.062A1.75 1.75 0 0 1 20.25 22h-2.062a.75.75 0 1 1 0-1.5h2.062a.25.25 0 0 0 .25-.25v-2.062a.75.75 0 0 1 .75-.75Zm-18.5-8.25a.75.75 0 0 1 .75.75v4.124a.75.75 0 1 1-1.5 0V9.938a.75.75 0 0 1 .75-.75ZM9.188 2.75a.75.75 0 0 1 .75-.75h4.124a.75.75 0 1 1 0 1.5H9.938a.75.75 0 0 1-.75-.75Zm0 18.5a.75.75 0 0 1 .75-.75h4.124a.75.75 0 1 1 0 1.5H9.938a.75.75 0 0 1-.75-.75ZM21.25 9.188a.75.75 0 0 1 .75.75v4.124a.75.75 0 1 1-1.5 0V9.938a.75.75 0 0 1 .75-.75ZM3.75 8.25a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Zm5.5 0A.75.75 0 0 1 10 7.5h2A.75.75 0 0 1 12 9h-2a.75.75 0 0 1-.75-.75Zm-1-4.5A.75.75 0 0 1 9 4.5v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Zm0 5.5A.75.75 0 0 1 9 10v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Zm0 4.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75ZM14 8.25a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$821b06bbcfc0bc3c = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("PulseIcon", "octicon octicon-pulse", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6 2c.306 0 .582.187.696.471L10 10.731l1.304-3.26A.751.751 0 0 1 12 7h3.25a.75.75 0 0 1 0 1.5h-2.742l-1.812 4.528a.751.751 0 0 1-1.392 0L6 4.77 4.696 8.03A.75.75 0 0 1 4 8.5H.75a.75.75 0 0 1 0-1.5h2.742l1.812-4.529A.751.751 0 0 1 6 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.002 2.5a.75.75 0 0 1 .691.464l6.302 15.305 2.56-6.301a.75.75 0 0 1 .695-.468h4a.75.75 0 0 1 0 1.5h-3.495l-3.06 7.532a.75.75 0 0 1-1.389.004L8.997 5.21l-3.054 7.329A.75.75 0 0 1 5.25 13H.75a.75.75 0 0 1 0-1.5h4l3.558-8.538a.75.75 0 0 1 .694-.462Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$f314ed182f5da2a0 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("QuestionIcon", "octicon octicon-question", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM6.92 6.085h.001a.749.749 0 1 1-1.342-.67c.169-.339.436-.701.849-.977C6.845 4.16 7.369 4 8 4a2.756 2.756 0 0 1 1.637.525c.503.377.863.965.863 1.725 0 .448-.115.83-.329 1.15-.205.307-.47.513-.692.662-.109.072-.22.138-.313.195l-.006.004a6.24 6.24 0 0 0-.26.16.952.952 0 0 0-.276.245.75.75 0 0 1-1.248-.832c.184-.264.42-.489.692-.661.103-.067.207-.132.313-.195l.007-.004c.1-.061.182-.11.258-.161a.969.969 0 0 0 .277-.245C8.96 6.514 9 6.427 9 6.25a.612.612 0 0 0-.262-.525A1.27 1.27 0 0 0 8 5.5c-.369 0-.595.09-.74.187a1.01 1.01 0 0 0-.34.398ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.97 8.265a1.45 1.45 0 0 0-.487.57.75.75 0 0 1-1.341-.67c.2-.402.513-.826.997-1.148C10.627 6.69 11.244 6.5 12 6.5c.658 0 1.369.195 1.934.619a2.45 2.45 0 0 1 1.004 2.006c0 1.033-.513 1.72-1.027 2.215-.19.183-.399.358-.579.508l-.147.123a4.329 4.329 0 0 0-.435.409v1.37a.75.75 0 1 1-1.5 0v-1.473c0-.237.067-.504.247-.736.22-.28.486-.517.718-.714l.183-.153.001-.001c.172-.143.324-.27.47-.412.368-.355.569-.676.569-1.136a.953.953 0 0 0-.404-.806C12.766 8.118 12.384 8 12 8c-.494 0-.814.121-1.03.265ZM13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$62bd98fc131b5caa = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("QuoteIcon", "octicon octicon-quote", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 2.5h10.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1 0-1.5Zm4 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5Zm0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM2.5 7.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3 6.25a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.25Zm5 6.063a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75Zm0 5.937a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75ZM3.75 11a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8eec67136a89853b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ReadIcon", "octicon octicon-read", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.115.65a1.752 1.752 0 0 1 1.77 0l6.25 3.663c.536.314.865.889.865 1.51v6.427A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25V5.823c0-.621.33-1.196.865-1.51Zm1.011 1.293a.252.252 0 0 0-.252 0l-5.72 3.353L6.468 7.76a2.748 2.748 0 0 1 3.066 0l4.312-2.464-5.719-3.353ZM13.15 12.5 8.772 9.06a1.25 1.25 0 0 0-1.544 0L2.85 12.5Zm1.35-5.85-3.687 2.106 3.687 2.897ZM5.187 8.756 1.5 6.65v5.003Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.89 1.767a2.252 2.252 0 0 1 2.22 0l9.75 5.525A2.25 2.25 0 0 1 24 9.249v9.501A2.25 2.25 0 0 1 21.75 21H2.25A2.25 2.25 0 0 1 0 18.75v-9.5c0-.81.435-1.558 1.14-1.958Zm1.48 1.305a.75.75 0 0 0-.74 0l-9.316 5.28 7.41 4.233a3.75 3.75 0 0 1 4.553 0l7.41-4.234-9.317-5.28ZM20.65 19.5l-7.26-5.704a2.25 2.25 0 0 0-2.78 0L3.35 19.5Zm1.85-9.886-6.95 3.971 6.663 5.236c.089.07.161.159.21.26a.745.745 0 0 0 .077-.331ZM8.45 13.585 1.5 9.614v9.136c0 .119.028.23.076.33a.744.744 0 0 1 .21-.259Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$80f27d87499b3fd0 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("RelFilePathIcon", "octicon octicon-rel-file-path", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.94 3.045a.75.75 0 0 0-1.38-.59l-4.5 10.5a.75.75 0 1 0 1.38.59l4.5-10.5ZM5 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M19.564 4.42a.75.75 0 0 0-1.378-.59l-6.75 15.75a.75.75 0 0 0 1.378.59l6.75-15.75ZM7 18.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$3deff2d32499abf0 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ReplyIcon", "octicon octicon-reply", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.78 1.97a.75.75 0 0 1 0 1.06L3.81 6h6.44A4.75 4.75 0 0 1 15 10.75v2.5a.75.75 0 0 1-1.5 0v-2.5a3.25 3.25 0 0 0-3.25-3.25H3.81l2.97 2.97a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L1.47 7.28a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.53 5.03a.75.75 0 1 0-1.06-1.06l-6.25 6.25a.75.75 0 0 0 0 1.06l6.25 6.25a.75.75 0 1 0 1.06-1.06L5.56 11.5H17a3.248 3.248 0 0 1 3.25 3.248v4.502a.75.75 0 0 0 1.5 0v-4.502A4.748 4.748 0 0 0 17 10H5.56l4.97-4.97Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$f6ad8b175c0ae00f = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("RepoIcon", "octicon octicon-repo", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 2.5A2.5 2.5 0 0 1 4.5 0h8.75a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2h-8a1 1 0 0 0-.714 1.7.75.75 0 1 1-1.072 1.05A2.495 2.495 0 0 1 2 11.5Zm10.5-1h-8a1 1 0 0 0-1 1v6.708A2.486 2.486 0 0 1 4.5 9h8ZM5 12.25a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v3.25a.25.25 0 0 1-.4.2l-1.45-1.087a.249.249 0 0 0-.3 0L5.4 15.7a.25.25 0 0 1-.4-.2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3 2.75A2.75 2.75 0 0 1 5.75 0h14.5a.75.75 0 0 1 .75.75v20.5a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1 0-1.5h5.25v-4H6A1.5 1.5 0 0 0 4.5 18v.75c0 .716.43 1.334 1.05 1.605a.75.75 0 0 1-.6 1.374A3.251 3.251 0 0 1 3 18.75ZM19.5 1.5H5.75c-.69 0-1.25.56-1.25 1.25v12.651A2.989 2.989 0 0 1 6 15h13.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7 18.25a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5.01a.25.25 0 0 1-.397.201l-2.206-1.604a.25.25 0 0 0-.294 0L7.397 23.46a.25.25 0 0 1-.397-.2v-5.01Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$8efdb29470fa3267 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("RepoCloneIcon", "octicon octicon-repo-clone", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 1v9h10v3c0 .55-.45 1-1 1H6v2l-1.5-1.5L3 16v-2H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h7v1Zm13-1c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1h-3v1h-1V8h-1c-.55 0-1-.45-1-1V0Zm-4 11H1v2h2v-1h3v1h5Zm4-6V1h-4v4Zm0 2V6h-3v1ZM4 3H3V2h1Zm0 2H3V4h1Zm0 2H3V6h1Zm7 0V6h-1v1ZM3 8h1v1H3Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8dcafe7e23737bf1 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("RepoDeletedIcon", "octicon octicon-repo-deleted", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 2.5A2.5 2.5 0 0 1 3.5 0h8.75a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-1.5 0V1.5h-8a1 1 0 0 0-1 1v6.708A2.492 2.492 0 0 1 3.5 9h4.75a.75.75 0 0 1 0 1.5H3.5a1 1 0 1 0 0 2h4.75a.75.75 0 0 1 0 1.5H3.5A2.5 2.5 0 0 1 1 11.5v-9Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.28 10.22a.75.75 0 1 0-1.06 1.06L11.94 13l-1.72 1.72a.75.75 0 1 0 1.06 1.06L13 14.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L14.06 13l1.72-1.72a.75.75 0 1 0-1.06-1.06L13 11.94l-1.72-1.72Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$20ef8d42b776024 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("RepoForkedIcon", "octicon octicon-repo-forked", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5 5.372v.878c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75v-.878a2.25 2.25 0 1 1 1.5 0v.878a2.25 2.25 0 0 1-2.25 2.25h-1.5v2.128a2.251 2.251 0 1 1-1.5 0V8.5h-1.5A2.25 2.25 0 0 1 3.5 6.25v-.878a2.25 2.25 0 1 1 1.5 0ZM5 3.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm6.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-3 8.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.75 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM15 4.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm-12.5 0a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM5.75 6.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 6.5ZM12 21a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 12 21Zm6.25-14.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 18.25 6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.5 7.75v1A2.25 2.25 0 0 0 8.75 11h6.5a2.25 2.25 0 0 0 2.25-2.25v-1H19v1a3.75 3.75 0 0 1-3.75 3.75h-6.5A3.75 3.75 0 0 1 5 8.75v-1Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.25 16.25v-5h1.5v5h-1.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$144a2acfc46e9917 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("RepoLockedIcon", "octicon octicon-repo-locked", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 2.5A2.5 2.5 0 0 1 3.5 0h8.75a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V1.5h-8a1 1 0 0 0-1 1v6.708A2.492 2.492 0 0 1 3.5 9h2.75a.75.75 0 0 1 0 1.5H3.5a1 1 0 1 0 0 2h2.75a.75.75 0 0 1 0 1.5H3.5A2.5 2.5 0 0 1 1 11.5v-9Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9 10.168V9a3 3 0 1 1 6 0v1.168c.591.281 1 .884 1 1.582v2.5A1.75 1.75 0 0 1 14.25 16h-4.5A1.75 1.75 0 0 1 8 14.25v-2.5c0-.698.409-1.3 1-1.582ZM13.5 10V9a1.5 1.5 0 0 0-3 0v1Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 2.75A2.75 2.75 0 0 1 4.75 0h14.5a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V1.5H4.75c-.69 0-1.25.56-1.25 1.25v12.651A2.987 2.987 0 0 1 5 15h6.25a.75.75 0 0 1 0 1.5H5A1.5 1.5 0 0 0 3.5 18v1.25c0 .69.56 1.25 1.25 1.25h6a.75.75 0 0 1 0 1.5h-6A2.75 2.75 0 0 1 2 19.25V2.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15 14.5a3.5 3.5 0 1 1 7 0V16h.25c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0 1 22.25 24h-7.5A1.75 1.75 0 0 1 13 22.25v-4.5c0-.966.784-1.75 1.75-1.75H15Zm3.5-2a2 2 0 0 0-2 2V16h4v-1.5a2 2 0 0 0-2-2Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$e848eaa92ac1d05f = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("RepoPullIcon", "octicon octicon-repo-pull", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11 7h1v6c0 .55-.45 1-1 1H6v2l-1.5-1.5L3 16v-2H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v2h-1V1H2v9h9Zm2 1V6H7V4h6V2l3 3Zm-2 3H1v2h2v-1h3v1h5ZM4 2v1H3V2Zm0 2v1H3V4Zm0 2v1H3V6ZM3 9V8h1v1Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$855627263578491e = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("RepoPushIcon", "octicon octicon-repo-push", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 2.5A2.5 2.5 0 0 1 3.5 0h8.75a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V1.5h-8a1 1 0 0 0-1 1v6.708A2.493 2.493 0 0 1 3.5 9h3.25a.75.75 0 0 1 0 1.5H3.5a1 1 0 0 0 0 2h5.75a.75.75 0 0 1 0 1.5H3.5A2.5 2.5 0 0 1 1 11.5Zm13.23 7.79h-.001l-1.224-1.224v6.184a.75.75 0 0 1-1.5 0V9.066L10.28 10.29a.75.75 0 0 1-1.06-1.061l2.505-2.504a.75.75 0 0 1 1.06 0L15.29 9.23a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.75 0A2.75 2.75 0 0 0 2 2.75v16.5A2.75 2.75 0 0 0 4.75 22h11a.75.75 0 0 0 0-1.5h-11c-.69 0-1.25-.56-1.25-1.25V18A1.5 1.5 0 0 1 5 16.5h7.25a.75.75 0 0 0 0-1.5H5c-.546 0-1.059.146-1.5.401V2.75c0-.69.56-1.25 1.25-1.25H18.5v7a.75.75 0 0 0 1.5 0V.75a.75.75 0 0 0-.75-.75H4.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m20 13.903 2.202 2.359a.75.75 0 0 0 1.096-1.024l-3.5-3.75a.75.75 0 0 0-1.096 0l-3.5 3.75a.75.75 0 1 0 1.096 1.024l2.202-2.36v9.348a.75.75 0 0 0 1.5 0v-9.347Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$dac01e0ca183ddce = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("RepoTemplateIcon", "octicon octicon-repo-template", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13.25 8a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2h-.75a.75.75 0 0 1 0-1.5h.75v-.25a.75.75 0 0 1 .75-.75ZM5 12.25a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v3.25a.25.25 0 0 1-.4.2l-1.45-1.087a.249.249 0 0 0-.3 0L5.4 15.7a.25.25 0 0 1-.4-.2ZM2.75 8a.75.75 0 0 1 .75.75v.268c.083-.012.166-.018.25-.018h.5a.75.75 0 0 1 0 1.5h-.5a.25.25 0 0 0-.25.25v.75c0 .28.114.532.3.714a.75.75 0 1 1-1.05 1.072A2.495 2.495 0 0 1 2 11.5V8.75A.75.75 0 0 1 2.75 8ZM11 .75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0V1.5h-.75A.75.75 0 0 1 11 .75Zm-5 0A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 6 .75Zm0 9A.75.75 0 0 1 6.75 9h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 6 9.75ZM4.992.662a.75.75 0 0 1-.636.848c-.436.063-.783.41-.846.846a.751.751 0 0 1-1.485-.212A2.501 2.501 0 0 1 4.144.025a.75.75 0 0 1 .848.637ZM2.75 4a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 2.75 4Zm10.5 0a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.75 0A2.75 2.75 0 0 0 3 2.75v1a.75.75 0 0 0 1.5 0v-1c0-.69.56-1.25 1.25-1.25h1a.75.75 0 0 0 0-1.5h-1Zm4 0a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Zm7.5 0a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-.75-.75h-3ZM4.5 6.5a.75.75 0 0 0-1.5 0v3.75a.75.75 0 0 0 1.5 0V6.5Zm16.5 0a.75.75 0 0 0-1.5 0v3.75a.75.75 0 0 0 1.5 0V6.5ZM4.5 13.25a.75.75 0 0 0-1.5 0v5.5a3.25 3.25 0 0 0 1.95 2.98.75.75 0 1 0 .6-1.375A1.75 1.75 0 0 1 4.5 18.75V18A1.5 1.5 0 0 1 6 16.5h.75a.75.75 0 0 0 0-1.5H6c-.546 0-1.059.146-1.5.401V13.25Zm16.5 0a.75.75 0 0 0-1.5 0V15h-2.25a.75.75 0 0 0 0 1.5h2.25v4h-5.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 .75-.75v-8ZM9.75 15a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Zm-2.353 8.461A.25.25 0 0 1 7 23.26v-5.01a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5.01a.25.25 0 0 1-.397.201l-2.206-1.604a.25.25 0 0 0-.294 0L7.397 23.46Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$b82c15e73e7acb32 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ReportIcon", "octicon octicon-report", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v9.5A1.75 1.75 0 0 1 14.25 13H8.06l-2.573 2.573A1.458 1.458 0 0 1 3 14.543V13H1.75A1.75 1.75 0 0 1 0 11.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm7 2.25v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.5 4.25c0-.966.784-1.75 1.75-1.75h17.5c.966 0 1.75.784 1.75 1.75v12.5a1.75 1.75 0 0 1-1.75 1.75h-9.586a.25.25 0 0 0-.177.073l-3.5 3.5A1.458 1.458 0 0 1 5 21.043V18.5H3.25a1.75 1.75 0 0 1-1.75-1.75ZM3.25 4a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 .75.75v3.19l3.427-3.427A1.75 1.75 0 0 1 11.164 17h9.586a.25.25 0 0 0 .25-.25V4.25a.25.25 0 0 0-.25-.25ZM12 6a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 12 6Zm0 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8e0d2500d5bd92ef = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("RocketIcon", "octicon octicon-rocket", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M14.064 0h.186C15.216 0 16 .784 16 1.75v.186a8.752 8.752 0 0 1-2.564 6.186l-.458.459c-.314.314-.641.616-.979.904v3.207c0 .608-.315 1.172-.833 1.49l-2.774 1.707a.749.749 0 0 1-1.11-.418l-.954-3.102a1.214 1.214 0 0 1-.145-.125L3.754 9.816a1.218 1.218 0 0 1-.124-.145L.528 8.717a.749.749 0 0 1-.418-1.11l1.71-2.774A1.748 1.748 0 0 1 3.31 4h3.204c.288-.338.59-.665.904-.979l.459-.458A8.749 8.749 0 0 1 14.064 0ZM8.938 3.623h-.002l-.458.458c-.76.76-1.437 1.598-2.02 2.5l-1.5 2.317 2.143 2.143 2.317-1.5c.902-.583 1.74-1.26 2.499-2.02l.459-.458a7.25 7.25 0 0 0 2.123-5.127V1.75a.25.25 0 0 0-.25-.25h-.186a7.249 7.249 0 0 0-5.125 2.123ZM3.56 14.56c-.732.732-2.334 1.045-3.005 1.148a.234.234 0 0 1-.201-.064.234.234 0 0 1-.064-.201c.103-.671.416-2.273 1.15-3.003a1.502 1.502 0 1 1 2.12 2.12Zm6.94-3.935c-.088.06-.177.118-.266.175l-2.35 1.521.548 1.783 1.949-1.2a.25.25 0 0 0 .119-.213ZM3.678 8.116 5.2 5.766c.058-.09.117-.178.176-.266H3.309a.25.25 0 0 0-.213.119l-1.2 1.95ZM12 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M20.322.75h1.176a1.75 1.75 0 0 1 1.75 1.749v1.177a10.75 10.75 0 0 1-2.925 7.374l-1.228 1.304a23.699 23.699 0 0 1-1.596 1.542v5.038c0 .615-.323 1.184-.85 1.5l-4.514 2.709a.75.75 0 0 1-1.12-.488l-.963-4.572a1.305 1.305 0 0 1-.14-.129L8.04 15.96l-1.994-1.873a1.305 1.305 0 0 1-.129-.14l-4.571-.963a.75.75 0 0 1-.49-1.12l2.71-4.514c.316-.527.885-.85 1.5-.85h5.037a23.668 23.668 0 0 1 1.542-1.594l1.304-1.23A10.753 10.753 0 0 1 20.321.75Zm-6.344 4.018v-.001l-1.304 1.23a22.275 22.275 0 0 0-3.255 3.851l-2.193 3.29 1.859 1.744a.545.545 0 0 1 .034.034l1.743 1.858 3.288-2.192a22.263 22.263 0 0 0 3.854-3.257l1.228-1.303a9.251 9.251 0 0 0 2.517-6.346V2.5a.25.25 0 0 0-.25-.25h-1.177a9.252 9.252 0 0 0-6.344 2.518ZM6.5 21c-1.209 1.209-3.901 1.445-4.743 1.49a.236.236 0 0 1-.18-.067.236.236 0 0 1-.067-.18c.045-.842.281-3.534 1.49-4.743.9-.9 2.6-.9 3.5 0 .9.9.9 2.6 0 3.5Zm-.592-8.588L8.17 9.017c.23-.346.47-.685.717-1.017H5.066a.25.25 0 0 0-.214.121l-2.167 3.612ZM16 15.112c-.333.248-.672.487-1.018.718l-3.393 2.262.678 3.223 3.612-2.167a.25.25 0 0 0 .121-.214ZM17.5 8a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 17.5 8Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$472271f3e918e2f4 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("RowsIcon", "octicon octicon-rows", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16 10.75v2.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25v-2.5C0 9.784.784 9 1.75 9h12.5c.966 0 1.75.784 1.75 1.75Zm0-8v2.5A1.75 1.75 0 0 1 14.25 7H1.75A1.75 1.75 0 0 1 0 5.25v-2.5C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75Zm-1.75-.25H1.75a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm0 8H1.75a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M22 3.75v5.5A1.75 1.75 0 0 1 20.25 11H3.75A1.75 1.75 0 0 1 2 9.25v-5.5C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75Zm0 11v5.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25v-5.5c0-.966.784-1.75 1.75-1.75h16.5c.966 0 1.75.784 1.75 1.75ZM20.25 3.5H3.75a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm0 11H3.75a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$459b2edd884123b9 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("RssIcon", "octicon octicon-rss", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.002 2.725a.75.75 0 0 1 .797-.699C8.79 2.42 13.58 7.21 13.974 13.201a.75.75 0 0 1-1.497.098 10.502 10.502 0 0 0-9.776-9.776.747.747 0 0 1-.7-.798ZM2.84 7.05h-.002a7.002 7.002 0 0 1 6.113 6.111.75.75 0 0 1-1.49.178 5.503 5.503 0 0 0-4.8-4.8.75.75 0 0 1 .179-1.489ZM2 13a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.5 3.25a.75.75 0 0 1 .75-.75C14.053 2.5 22 10.447 22 20.25a.75.75 0 0 1-1.5 0C20.5 11.275 13.225 4 4.25 4a.75.75 0 0 1-.75-.75Zm.75 6.25C10.187 9.5 15 14.313 15 20.25a.75.75 0 0 1-1.5 0A9.25 9.25 0 0 0 4.25 11a.75.75 0 0 1 0-1.5ZM3.5 19a2 2 0 1 1 3.999-.001A2 2 0 0 1 3.5 19Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$19d31e296396343 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("RubyIcon", "octicon octicon-ruby", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.637 2.291A.748.748 0 0 1 4.23 2h7.54c.232 0 .451.107.593.291l3.48 4.5a.75.75 0 0 1-.072.999l-7.25 7a.75.75 0 0 1-1.042 0l-7.25-7a.75.75 0 0 1-.072-.999ZM4.598 3.5 1.754 7.177 8 13.207l6.246-6.03L11.402 3.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.873 3.26A.748.748 0 0 1 6.44 3h11.31c.223 0 .434.099.576.27l5 6a.75.75 0 0 1-.028.992l-10.75 11.5a.75.75 0 0 1-1.096 0l-10.75-11.5a.75.75 0 0 1-.02-1.003l5.19-6Zm.91 1.24L2.258 9.73 12 20.153l9.75-10.43L17.399 4.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$a2749bf554c976a = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ScreenFullIcon", "octicon octicon-screen-full", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 10a.75.75 0 0 1 .75.75v2.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 1 13.25v-2.5a.75.75 0 0 1 .75-.75Zm12.5 0a.75.75 0 0 1 .75.75v2.5A1.75 1.75 0 0 1 13.25 15h-2.5a.75.75 0 0 1 0-1.5h2.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 .75-.75ZM2.75 2.5a.25.25 0 0 0-.25.25v2.5a.75.75 0 0 1-1.5 0v-2.5C1 1.784 1.784 1 2.75 1h2.5a.75.75 0 0 1 0 1.5ZM10 1.75a.75.75 0 0 1 .75-.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.25.25 0 0 0-.25-.25h-2.5a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.75 15a.75.75 0 0 1 .75.75v3.5c0 .138.112.25.25.25h3.5a.75.75 0 0 1 0 1.5h-3.5A1.75 1.75 0 0 1 3 19.25v-3.5a.75.75 0 0 1 .75-.75Zm16.5 0a.75.75 0 0 1 .75.75v3.5A1.75 1.75 0 0 1 19.25 21h-3.5a.75.75 0 0 1 0-1.5h3.5a.25.25 0 0 0 .25-.25v-3.5a.75.75 0 0 1 .75-.75ZM4.75 4.5a.25.25 0 0 0-.25.25v3.5a.75.75 0 0 1-1.5 0v-3.5C3 3.784 3.784 3 4.75 3h3.5a.75.75 0 0 1 0 1.5ZM15 3.75a.75.75 0 0 1 .75-.75h3.5c.966 0 1.75.784 1.75 1.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.25.25 0 0 0-.25-.25h-3.5a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$b85b311f30c27e1b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ScreenNormalIcon", "octicon octicon-screen-normal", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.75 1a.75.75 0 0 1 .75.75v2.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 10 4.25v-2.5a.75.75 0 0 1 .75-.75Zm-5.5 0a.75.75 0 0 1 .75.75v2.5A1.75 1.75 0 0 1 4.25 6h-2.5a.75.75 0 0 1 0-1.5h2.5a.25.25 0 0 0 .25-.25v-2.5A.75.75 0 0 1 5.25 1ZM1 10.75a.75.75 0 0 1 .75-.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.25.25 0 0 0-.25-.25h-2.5a.75.75 0 0 1-.75-.75Zm9 1c0-.966.784-1.75 1.75-1.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.25.25 0 0 0-.25.25v2.5a.75.75 0 0 1-1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15.75 3a.75.75 0 0 1 .75.75v3.5c0 .138.112.25.25.25h3.5a.75.75 0 0 1 0 1.5h-3.5A1.75 1.75 0 0 1 15 7.25v-3.5a.75.75 0 0 1 .75-.75Zm-7.5 0a.75.75 0 0 1 .75.75v3.5A1.75 1.75 0 0 1 7.25 9h-3.5a.75.75 0 0 1 0-1.5h3.5a.25.25 0 0 0 .25-.25v-3.5A.75.75 0 0 1 8.25 3ZM3 15.75a.75.75 0 0 1 .75-.75h3.5c.966 0 1.75.784 1.75 1.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.25.25 0 0 0-.25-.25h-3.5a.75.75 0 0 1-.75-.75Zm12 1c0-.966.784-1.75 1.75-1.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.25.25 0 0 0-.25.25v3.5a.75.75 0 0 1-1.5 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$82eafebb825fc23f = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SearchIcon", "octicon octicon-search", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.68 11.74a6 6 0 0 1-7.922-8.982 6 6 0 0 1 8.982 7.922l3.04 3.04a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215ZM11.5 7a4.499 4.499 0 1 0-8.997 0A4.499 4.499 0 0 0 11.5 7Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.25 2a8.25 8.25 0 0 1 6.34 13.53l5.69 5.69a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-5.69-5.69A8.25 8.25 0 1 1 10.25 2ZM3.5 10.25a6.75 6.75 0 1 0 13.5 0 6.75 6.75 0 0 0-13.5 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$94639b65b951e28 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ServerIcon", "octicon octicon-server", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 1h12.5c.966 0 1.75.784 1.75 1.75v4c0 .372-.116.717-.314 1 .198.283.314.628.314 1v4a1.75 1.75 0 0 1-1.75 1.75H1.75A1.75 1.75 0 0 1 0 12.75v-4c0-.358.109-.707.314-1a1.739 1.739 0 0 1-.314-1v-4C0 1.784.784 1 1.75 1ZM1.5 2.75v4c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Zm.25 5.75a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25ZM7 4.75A.75.75 0 0 1 7.75 4h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 7 4.75ZM7.75 10h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM3 4.75A.75.75 0 0 1 3.75 4h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 4.75ZM3.75 10h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.75 6.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5ZM6 7.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 6 7.25Zm4 9a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Zm-3.25-.75a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.25 2h17.5c.966 0 1.75.784 1.75 1.75v7c0 .372-.116.716-.314 1 .198.284.314.628.314 1v7a1.75 1.75 0 0 1-1.75 1.75H3.25a1.75 1.75 0 0 1-1.75-1.75v-7c0-.358.109-.707.314-1a1.741 1.741 0 0 1-.314-1v-7C1.5 2.784 2.284 2 3.25 2Zm0 10.5a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25h17.5a.25.25 0 0 0 .25-.25v-7a.25.25 0 0 0-.25-.25Zm0-1.5h17.5a.25.25 0 0 0 .25-.25v-7a.25.25 0 0 0-.25-.25H3.25a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$40148c7db598e4e0 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ShareIcon", "octicon octicon-share", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.75 6.5a.25.25 0 0 0-.25.25v6.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-6.5a.25.25 0 0 0-.25-.25h-1a.75.75 0 0 1 0-1.5h1c.966 0 1.75.784 1.75 1.75v6.5A1.75 1.75 0 0 1 12.25 15h-8.5A1.75 1.75 0 0 1 2 13.25v-6.5C2 5.784 2.784 5 3.75 5h1a.75.75 0 0 1 0 1.5ZM7.823.177a.25.25 0 0 1 .354 0l2.896 2.896a.25.25 0 0 1-.177.427H8.75v5.75a.75.75 0 0 1-1.5 0V3.5H5.104a.25.25 0 0 1-.177-.427Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.5 9.75v10.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V9.75a.25.25 0 0 0-.25-.25h-2.5a.75.75 0 0 1 0-1.5h2.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 18.25 22H5.75A1.75 1.75 0 0 1 4 20.25V9.75C4 8.784 4.784 8 5.75 8h2.5a.75.75 0 0 1 0 1.5h-2.5a.25.25 0 0 0-.25.25Zm7.03-8.53 3.25 3.25a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-1.97-1.97v10.69a.75.75 0 0 1-1.5 0V3.56L9.28 5.53a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.25-3.25a.75.75 0 0 1 1.06 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$e200f86ace8b68ab = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ShareAndroidIcon", "octicon octicon-share-android", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15 3a3 3 0 0 1-5.175 2.066l-3.92 2.179a2.994 2.994 0 0 1 0 1.51l3.92 2.179a3 3 0 1 1-.73 1.31l-3.92-2.178a3 3 0 1 1 0-4.133l3.92-2.178A3 3 0 1 1 15 3Zm-1.5 10a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 13.5 13Zm-9-5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 4.5 8Zm9-5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 13.5 3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M20 5.5a3.498 3.498 0 0 1-6.062 2.385l-5.112 3.021a3.498 3.498 0 0 1 0 2.188l5.112 3.021a3.5 3.5 0 1 1-.764 1.29l-5.112-3.02a3.499 3.499 0 1 1-3.843-5.642 3.499 3.499 0 0 1 3.843.872l5.112-3.021A3.5 3.5 0 1 1 20 5.5Zm-1.5 13a2 2 0 1 0-3.999-.001 2 2 0 0 0 3.999.001Zm0-13a2 2 0 1 0-3.999-.001A2 2 0 0 0 18.5 5.5ZM5.5 14a2 2 0 1 0 .001-3.999A2 2 0 0 0 5.5 14Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$2d8598c0b89a07db = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ShieldIcon", "octicon octicon-shield", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.467.133a1.748 1.748 0 0 1 1.066 0l5.25 1.68A1.75 1.75 0 0 1 15 3.48V7c0 1.566-.32 3.182-1.303 4.682-.983 1.498-2.585 2.813-5.032 3.855a1.697 1.697 0 0 1-1.33 0c-2.447-1.042-4.049-2.357-5.032-3.855C1.32 10.182 1 8.566 1 7V3.48a1.75 1.75 0 0 1 1.217-1.667Zm.61 1.429a.25.25 0 0 0-.153 0l-5.25 1.68a.25.25 0 0 0-.174.238V7c0 1.358.275 2.666 1.057 3.86.784 1.194 2.121 2.34 4.366 3.297a.196.196 0 0 0 .154 0c2.245-.956 3.582-2.104 4.366-3.298C13.225 9.666 13.5 8.36 13.5 7V3.48a.251.251 0 0 0-.174-.237l-5.25-1.68ZM8.75 4.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 1.5 0ZM9 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13 15.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-.25-8.25a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0v-4.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.46.637a1.748 1.748 0 0 1 1.08 0l8.25 2.675A1.75 1.75 0 0 1 22 4.976V10c0 6.19-3.77 10.705-9.401 12.83a1.704 1.704 0 0 1-1.198 0C5.771 20.704 2 16.19 2 10V4.976c0-.76.49-1.43 1.21-1.664Zm.617 1.426a.253.253 0 0 0-.154 0L3.673 4.74a.25.25 0 0 0-.173.237V10c0 5.461 3.28 9.483 8.43 11.426a.199.199 0 0 0 .14 0C17.22 19.483 20.5 15.46 20.5 10V4.976a.25.25 0 0 0-.173-.237Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$da01a61080044588 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ShieldCheckIcon", "octicon octicon-shield-check", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m8.533.133 5.25 1.68A1.75 1.75 0 0 1 15 3.48V7c0 1.566-.32 3.182-1.303 4.682-.983 1.498-2.585 2.813-5.032 3.855a1.697 1.697 0 0 1-1.33 0c-2.447-1.042-4.049-2.357-5.032-3.855C1.32 10.182 1 8.566 1 7V3.48a1.75 1.75 0 0 1 1.217-1.667l5.25-1.68a1.748 1.748 0 0 1 1.066 0Zm-.61 1.429.001.001-5.25 1.68a.251.251 0 0 0-.174.237V7c0 1.36.275 2.666 1.057 3.859.784 1.194 2.121 2.342 4.366 3.298a.196.196 0 0 0 .154 0c2.245-.957 3.582-2.103 4.366-3.297C13.225 9.666 13.5 8.358 13.5 7V3.48a.25.25 0 0 0-.174-.238l-5.25-1.68a.25.25 0 0 0-.153 0ZM11.28 6.28l-3.5 3.5a.75.75 0 0 1-1.06 0l-1.5-1.5a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l.97.97 2.97-2.97a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16.53 9.78a.75.75 0 0 0-1.06-1.06L11 13.19l-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5-5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m12.54.637 8.25 2.675A1.75 1.75 0 0 1 22 4.976V10c0 6.19-3.771 10.704-9.401 12.83a1.704 1.704 0 0 1-1.198 0C5.77 20.705 2 16.19 2 10V4.976c0-.758.489-1.43 1.21-1.664L11.46.637a1.748 1.748 0 0 1 1.08 0Zm-.617 1.426-8.25 2.676a.249.249 0 0 0-.173.237V10c0 5.46 3.28 9.483 8.43 11.426a.199.199 0 0 0 .14 0C17.22 19.483 20.5 15.461 20.5 10V4.976a.25.25 0 0 0-.173-.237l-8.25-2.676a.253.253 0 0 0-.154 0Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$6f0043bfe7f5 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ShieldLockIcon", "octicon octicon-shield-lock", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m8.533.133 5.25 1.68A1.75 1.75 0 0 1 15 3.48V7c0 1.566-.32 3.182-1.303 4.682-.983 1.498-2.585 2.813-5.032 3.855a1.697 1.697 0 0 1-1.33 0c-2.447-1.042-4.049-2.357-5.032-3.855C1.32 10.182 1 8.566 1 7V3.48a1.75 1.75 0 0 1 1.217-1.667l5.25-1.68a1.748 1.748 0 0 1 1.066 0Zm-.61 1.429.001.001-5.25 1.68a.251.251 0 0 0-.174.237V7c0 1.36.275 2.666 1.057 3.859.784 1.194 2.121 2.342 4.366 3.298a.196.196 0 0 0 .154 0c2.245-.957 3.582-2.103 4.366-3.297C13.225 9.666 13.5 8.358 13.5 7V3.48a.25.25 0 0 0-.174-.238l-5.25-1.68a.25.25 0 0 0-.153 0ZM9.5 6.5c0 .536-.286 1.032-.75 1.3v2.45a.75.75 0 0 1-1.5 0V7.8A1.5 1.5 0 1 1 9.5 6.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.46 1.137a1.748 1.748 0 0 1 1.08 0l8.25 2.675A1.75 1.75 0 0 1 22 5.476V10.5c0 6.19-3.77 10.705-9.401 12.83a1.704 1.704 0 0 1-1.198 0C5.771 21.204 2 16.69 2 10.5V5.476c0-.76.49-1.43 1.21-1.664Zm.617 1.426a.253.253 0 0 0-.154 0L3.673 5.24a.25.25 0 0 0-.173.237V10.5c0 5.461 3.28 9.483 8.43 11.426a.199.199 0 0 0 .14 0c5.15-1.943 8.43-5.965 8.43-11.426V5.476a.25.25 0 0 0-.173-.237ZM13 12.232V15a1 1 0 0 1-2 0v-2.768a2 2 0 1 1 2 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$c4c430b7c5f04a60 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ShieldSlashIcon", "octicon octicon-shield-slash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.533.133a1.75 1.75 0 0 0-1.066 0l-2.091.67a.75.75 0 0 0 .457 1.428l2.09-.67a.25.25 0 0 1 .153 0l5.25 1.68a.25.25 0 0 1 .174.239V7c0 .233-.008.464-.025.694a.75.75 0 1 0 1.495.112c.02-.27.03-.538.03-.806V3.48a1.75 1.75 0 0 0-1.217-1.667L8.533.133ZM1 2.857l-.69-.5a.75.75 0 1 1 .88-1.214l14.5 10.5a.75.75 0 1 1-.88 1.214l-1.282-.928c-.995 1.397-2.553 2.624-4.864 3.608-.425.181-.905.18-1.329 0-2.447-1.042-4.049-2.356-5.032-3.855C1.32 10.182 1 8.566 1 7Zm1.5 1.086V7c0 1.358.275 2.666 1.057 3.86.784 1.194 2.121 2.34 4.366 3.297.05.02.106.02.153 0 2.127-.905 3.439-1.982 4.237-3.108Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.54 1.137a1.748 1.748 0 0 0-1.08 0L6.018 2.905a.75.75 0 1 0 .464 1.427l5.441-1.768a.239.239 0 0 1 .154 0l8.25 2.675a.249.249 0 0 1 .173.237V10.5c0 1.284-.24 2.83-.696 3.971a.75.75 0 1 0 1.392.557C21.74 13.67 22 11.927 22 10.5V5.476a1.75 1.75 0 0 0-1.21-1.664l-8.25-2.675ZM2.017 4.843l-.974-.748a.751.751 0 0 1 .914-1.19l20.5 15.75a.751.751 0 0 1-.914 1.19l-2.012-1.546-.702.852-.008.009a.07.07 0 0 1-.008.01c-1.603 1.821-3.731 3.223-6.214 4.16a1.699 1.699 0 0 1-1.198-.001C5.771 21.205 2 16.689 2 10.5V5c0-.054.006-.107.017-.157ZM3.5 5.982V10.5c0 5.461 3.281 9.483 8.431 11.426a.193.193 0 0 0 .138 0c2.283-.861 4.192-2.131 5.61-3.738l.662-.803Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8ecebf992ecfec05 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ShieldXIcon", "octicon octicon-shield-x", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m8.533.133 5.25 1.68A1.75 1.75 0 0 1 15 3.48V7c0 1.566-.32 3.182-1.303 4.682-.983 1.498-2.585 2.813-5.032 3.855a1.697 1.697 0 0 1-1.33 0c-2.447-1.042-4.049-2.357-5.032-3.855C1.32 10.182 1 8.566 1 7V3.48a1.75 1.75 0 0 1 1.217-1.667l5.25-1.68a1.748 1.748 0 0 1 1.066 0Zm-.61 1.429.001.001-5.25 1.68a.251.251 0 0 0-.174.237V7c0 1.36.275 2.666 1.057 3.859.784 1.194 2.121 2.342 4.366 3.298a.196.196 0 0 0 .154 0c2.245-.957 3.582-2.103 4.366-3.297C13.225 9.666 13.5 8.358 13.5 7V3.48a.25.25 0 0 0-.174-.238l-5.25-1.68a.25.25 0 0 0-.153 0ZM6.78 5.22 8 6.44l1.22-1.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 7.5l1.22 1.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 8.56 6.78 9.78a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L6.94 7.5 5.72 6.28a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.28 7.72a.75.75 0 0 0-1.06 1.06l2.72 2.72-2.72 2.72a.75.75 0 1 0 1.06 1.06L12 12.56l2.72 2.72a.75.75 0 1 0 1.06-1.06l-2.72-2.72 2.72-2.72a.75.75 0 0 0-1.06-1.06L12 10.44 9.28 7.72Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m12.54.637 8.25 2.675A1.75 1.75 0 0 1 22 4.976V10c0 6.19-3.771 10.704-9.401 12.83a1.704 1.704 0 0 1-1.198 0C5.77 20.705 2 16.19 2 10V4.976c0-.758.489-1.43 1.21-1.664L11.46.637a1.748 1.748 0 0 1 1.08 0Zm-.617 1.426-8.25 2.676a.249.249 0 0 0-.173.237V10c0 5.46 3.28 9.483 8.43 11.426a.199.199 0 0 0 .14 0C17.22 19.483 20.5 15.461 20.5 10V4.976a.25.25 0 0 0-.173-.237l-8.25-2.676a.253.253 0 0 0-.154 0Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$77b9724db3ed83b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SidebarCollapseIcon", "octicon octicon-sidebar-collapse", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.823 7.823a.25.25 0 0 1 0 .354l-2.396 2.396A.25.25 0 0 1 4 10.396V5.604a.25.25 0 0 1 .427-.177Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0ZM1.5 1.75v12.5c0 .138.112.25.25.25H9.5v-13H1.75a.25.25 0 0 0-.25.25ZM11 14.5h3.25a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25H11Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.22 14.47 9.69 12 7.22 9.53a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l3 3a.75.75 0 0 1 0 1.06l-3 3a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2ZM3.5 3.75v16.5c0 .138.112.25.25.25H15v-17H3.75a.25.25 0 0 0-.25.25Zm13 16.75h3.75a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H16.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$73de68ca909831b8 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SidebarExpandIcon", "octicon octicon-sidebar-expand", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m4.177 7.823 2.396-2.396A.25.25 0 0 1 7 5.604v4.792a.25.25 0 0 1-.427.177L4.177 8.177a.25.25 0 0 1 0-.354Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25H9.5v-13Zm12.5 13a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25H11v13Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.28 9.53 8.81 12l2.47 2.47a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-3-3a.75.75 0 0 1 0-1.06l3-3a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2ZM3.5 3.75v16.5c0 .138.112.25.25.25H15v-17H3.75a.25.25 0 0 0-.25.25Zm13 16.75h3.75a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H16.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$10cdd1f3e51de455 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SignInIcon", "octicon octicon-sign-in", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 2.75C2 1.784 2.784 1 3.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 2 13.25Zm6.56 4.5h5.69a.75.75 0 0 1 0 1.5H8.56l1.97 1.97a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L6.22 8.53a.75.75 0 0 1 0-1.06l3.25-3.25a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3 3.25c0-.966.784-1.75 1.75-1.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.25.25 0 0 0-.25.25v17.5c0 .138.112.25.25.25h5.5a.75.75 0 0 1 0 1.5h-5.5A1.75 1.75 0 0 1 3 20.75Zm9.994 9.5 3.3 3.484a.75.75 0 0 1-1.088 1.032l-4.5-4.75a.75.75 0 0 1 0-1.032l4.5-4.75a.75.75 0 0 1 1.088 1.032l-3.3 3.484h8.256a.75.75 0 0 1 0 1.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$5bb2595dc31bfece = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SignOutIcon", "octicon octicon-sign-out", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 2.75C2 1.784 2.784 1 3.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 2 13.25Zm10.44 4.5-1.97-1.97a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l3.25 3.25a.75.75 0 0 1 0 1.06l-3.25 3.25a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.97-1.97H6.75a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3 3.25c0-.966.784-1.75 1.75-1.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.25.25 0 0 0-.25.25v17.5c0 .138.112.25.25.25h5.5a.75.75 0 0 1 0 1.5h-5.5A1.75 1.75 0 0 1 3 20.75Zm16.006 9.5H10.75a.75.75 0 0 1 0-1.5h8.256l-3.3-3.484a.75.75 0 0 1 1.088-1.032l4.5 4.75a.75.75 0 0 1 0 1.032l-4.5 4.75a.75.75 0 0 1-1.088-1.032Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$ba6370820a7d2625 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SingleSelectIcon", "octicon octicon-single-select", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m5.06 7.356 2.795 2.833c.08.081.21.081.29 0l2.794-2.833c.13-.131.038-.356-.145-.356H5.206c-.183 0-.275.225-.145.356Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 2.75C1 1.784 1.784 1 2.75 1h10.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25Zm1.75-.25a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m7.854 10.854 3.792 3.792a.5.5 0 0 0 .708 0l3.793-3.792a.5.5 0 0 0-.354-.854H8.207a.5.5 0 0 0-.353.854Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$7d3458263f963d3 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SkipIcon", "octicon octicon-skip", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm9.78-2.22-5.5 5.5a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l5.5-5.5a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M17.28 7.78a.75.75 0 0 0-1.06-1.06l-9.5 9.5a.75.75 0 1 0 1.06 1.06l9.5-9.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$83062ed2ee1964bd = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SkipFillIcon", "octicon octicon-skip-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm11.333-2.167a.825.825 0 0 0-1.166-1.166l-5.5 5.5a.825.825 0 0 0 1.166 1.166Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm16.333-4.167a.825.825 0 0 0-1.166-1.166l-9.5 9.5a.825.825 0 0 0 1.166 1.166Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$2ec075e4def3a545 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SlidersIcon", "octicon octicon-sliders", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15 2.75a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75Zm-8.5.75v1.25a.75.75 0 0 0 1.5 0v-4a.75.75 0 0 0-1.5 0V2H1.75a.75.75 0 0 0 0 1.5H6.5Zm1.25 5.25a.75.75 0 0 0 0-1.5h-6a.75.75 0 0 0 0 1.5h6ZM15 8a.75.75 0 0 1-.75.75H11.5V10a.75.75 0 1 1-1.5 0V6a.75.75 0 0 1 1.5 0v1.25h2.75A.75.75 0 0 1 15 8Zm-9 5.25v-2a.75.75 0 0 0-1.5 0v1.25H1.75a.75.75 0 0 0 0 1.5H4.5v1.25a.75.75 0 0 0 1.5 0v-2Zm9 0a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$663870aff582477c = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SmileyIcon", "octicon octicon-smiley", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm3.82 1.636a.75.75 0 0 1 1.038.175l.007.009c.103.118.22.222.35.31.264.178.683.37 1.285.37.602 0 1.02-.192 1.285-.371.13-.088.247-.192.35-.31l.007-.008a.75.75 0 0 1 1.222.87l-.022-.015c.02.013.021.015.021.015v.001l-.001.002-.002.003-.005.007-.014.019a2.066 2.066 0 0 1-.184.213c-.16.166-.338.316-.53.445-.63.418-1.37.638-2.127.629-.946 0-1.652-.308-2.126-.63a3.331 3.331 0 0 1-.715-.657l-.014-.02-.005-.006-.002-.003v-.002h-.001l.613-.432-.614.43a.75.75 0 0 1 .183-1.044ZM12 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM5 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm5.25 2.25.592.416a97.71 97.71 0 0 0-.592-.416Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.456 14.494a.75.75 0 0 1 1.068.17 3.08 3.08 0 0 0 .572.492A3.381 3.381 0 0 0 12 15.72c.855 0 1.487-.283 1.904-.562a3.081 3.081 0 0 0 .572-.492l.021-.026a.75.75 0 0 1 1.197.905l-.027.034c-.013.016-.03.038-.052.063-.044.05-.105.119-.184.198a4.569 4.569 0 0 1-.695.566A4.88 4.88 0 0 1 12 17.22a4.88 4.88 0 0 1-2.736-.814 4.57 4.57 0 0 1-.695-.566 3.253 3.253 0 0 1-.236-.261c-.259-.332-.223-.824.123-1.084Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9 10.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM16.25 12a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$6a0a4b3755b1f7ee = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SortAscIcon", "octicon octicon-sort-asc", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M18.5 17.25a.75.75 0 0 1-1.5 0V7.56l-2.22 2.22a.75.75 0 1 1-1.06-1.06l3.5-3.5a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 0 1-1.06 1.06L18.5 7.56v9.69Zm-15.75.25a.75.75 0 0 1 0-1.5h9.5a.75.75 0 0 1 0 1.5h-9.5Zm0-5a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 0 1.5h-5.5Zm0-5a.75.75 0 0 1 0-1.5h3.5a.75.75 0 0 1 0 1.5h-3.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$42de415488f8b291 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SortDescIcon", "octicon octicon-sort-desc", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M18.5 16.44V6.75a.75.75 0 0 0-1.5 0v9.69l-2.22-2.22a.75.75 0 1 0-1.06 1.06l3.5 3.5a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 1 0-1.06-1.06l-2.22 2.22ZM2 7.25a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 2 7.25Zm0 5a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Zm0 5a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$4f977e01eaf645e6 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SparkleFillIcon", "octicon octicon-sparkle-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.53 1.282a.5.5 0 0 1 .94 0l.478 1.306a7.492 7.492 0 0 0 4.464 4.464l1.305.478a.5.5 0 0 1 0 .94l-1.305.478a7.492 7.492 0 0 0-4.464 4.464l-.478 1.305a.5.5 0 0 1-.94 0l-.478-1.305a7.492 7.492 0 0 0-4.464-4.464L1.282 8.47a.5.5 0 0 1 0-.94l1.306-.478a7.492 7.492 0 0 0 4.464-4.464Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$5ac582d13947c6ee = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SponsorTiersIcon", "octicon octicon-sponsor-tiers", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.586 1C12.268 1 13.5 2.37 13.5 4.25c0 1.745-.996 3.359-2.622 4.831-.166.15-.336.297-.509.438l1.116 5.584a.75.75 0 0 1-.991.852l-2.409-.876a.25.25 0 0 0-.17 0l-2.409.876a.75.75 0 0 1-.991-.852L5.63 9.519a13.78 13.78 0 0 1-.51-.438C3.497 7.609 2.5 5.995 2.5 4.25 2.5 2.37 3.732 1 5.414 1c.963 0 1.843.403 2.474 1.073L8 2.198l.112-.125a3.385 3.385 0 0 1 2.283-1.068L10.586 1Zm-3.621 9.495-.718 3.594 1.155-.42a1.75 1.75 0 0 1 1.028-.051l.168.051 1.154.42-.718-3.592c-.199.13-.37.235-.505.314l-.169.097a.75.75 0 0 1-.72 0 9.54 9.54 0 0 1-.515-.308l-.16-.105ZM10.586 2.5c-.863 0-1.611.58-1.866 1.459-.209.721-1.231.721-1.44 0C7.025 3.08 6.277 2.5 5.414 2.5 4.598 2.5 4 3.165 4 4.25c0 1.23.786 2.504 2.128 3.719.49.443 1.018.846 1.546 1.198l.325.21.076-.047.251-.163a13.341 13.341 0 0 0 1.546-1.198C11.214 6.754 12 5.479 12 4.25c0-1.085-.598-1.75-1.414-1.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16.004 1.25C18.311 1.25 20 3.128 20 5.75c0 2.292-1.23 4.464-3.295 6.485-.481.47-.98.909-1.482 1.31l.265 1.32 1.375 7.5a.75.75 0 0 1-.982.844l-3.512-1.207a.75.75 0 0 0-.488 0L8.37 23.209a.75.75 0 0 1-.982-.844l1.378-7.512.261-1.309c-.5-.4-1-.838-1.481-1.31C5.479 10.215 4.25 8.043 4.25 5.75c0-2.622 1.689-4.5 3.996-4.5 1.55 0 2.947.752 3.832 1.967l.047.067.047-.067a4.726 4.726 0 0 1 3.612-1.962l.22-.005ZM13.89 14.531c-.418.285-.828.542-1.218.77l-.18.103a.75.75 0 0 1-.734 0l-.071-.04-.46-.272c-.282-.173-.573-.36-.868-.562l-.121.605-1.145 6.239 2.3-.79a2.248 2.248 0 0 1 1.284-.054l.18.053 2.299.79-1.141-6.226-.125-.616ZM16.004 2.75c-1.464 0-2.731.983-3.159 2.459-.209.721-1.231.721-1.44 0-.428-1.476-1.695-2.459-3.16-2.459-1.44 0-2.495 1.173-2.495 3 0 1.811 1.039 3.647 2.844 5.412a19.624 19.624 0 0 0 3.734 2.84l-.019-.011-.184-.111.147-.088a19.81 19.81 0 0 0 3.015-2.278l.37-.352C17.46 9.397 18.5 7.561 18.5 5.75c0-1.827-1.055-3-2.496-3Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$c19d0dc844f6640 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SquareIcon", "octicon octicon-square", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4 5.75C4 4.784 4.784 4 5.75 4h4.5c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0 1 10.25 12h-4.5A1.75 1.75 0 0 1 4 10.25Zm1.75-.25a.25.25 0 0 0-.25.25v4.5c0 .138.112.25.25.25h4.5a.25.25 0 0 0 .25-.25v-4.5a.25.25 0 0 0-.25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6 7.75C6 6.784 6.784 6 7.75 6h8.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 16.25 18h-8.5A1.75 1.75 0 0 1 6 16.25Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$3a174202ac13cfc8 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SquareFillIcon", "octicon octicon-square-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.75 4h4.5c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0 1 10.25 12h-4.5A1.75 1.75 0 0 1 4 10.25v-4.5C4 4.784 4.784 4 5.75 4Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.75 6h8.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 16.25 18h-8.5A1.75 1.75 0 0 1 6 16.25v-8.5C6 6.784 6.784 6 7.75 6Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$28ef317d670d123d = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SquirrelIcon", "octicon octicon-squirrel", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.499.75a.75.75 0 0 1 1.5 0v.996C5.9 2.903 6.793 3.65 7.662 4.376l.24.202c-.036-.694.055-1.422.426-2.163C9.1.873 10.794-.045 12.622.26 14.408.558 16 1.94 16 4.25c0 1.278-.954 2.575-2.44 2.734l.146.508.065.22c.203.701.412 1.455.476 2.226.142 1.707-.4 3.03-1.487 3.898C11.714 14.671 10.27 15 8.75 15h-6a.75.75 0 0 1 0-1.5h1.376a4.484 4.484 0 0 1-.563-1.191 3.835 3.835 0 0 1-.05-2.063 4.647 4.647 0 0 1-2.025-.293.75.75 0 0 1 .525-1.406c1.357.507 2.376-.006 2.698-.318l.009-.01a.747.747 0 0 1 1.06 0 .748.748 0 0 1-.012 1.074c-.912.92-.992 1.835-.768 2.586.221.74.745 1.337 1.196 1.621H8.75c1.343 0 2.398-.296 3.074-.836.635-.507 1.036-1.31.928-2.602-.05-.603-.216-1.224-.422-1.93l-.064-.221c-.12-.407-.246-.84-.353-1.29a2.425 2.425 0 0 1-.507-.441 3.075 3.075 0 0 1-.633-1.248.75.75 0 0 1 1.455-.364c.046.185.144.436.31.627.146.168.353.305.712.305.738 0 1.25-.615 1.25-1.25 0-1.47-.95-2.315-2.123-2.51-1.172-.196-2.227.387-2.706 1.345-.46.92-.27 1.774.019 3.062l.042.19a.884.884 0 0 1 .01.05c.348.443.666.949.94 1.553a.75.75 0 1 1-1.365.62c-.553-1.217-1.32-1.94-2.3-2.768L6.7 5.527c-.814-.68-1.75-1.462-2.692-2.619a3.737 3.737 0 0 0-1.023.88c-.406.495-.663 1.036-.722 1.508.116.122.306.21.591.239.388.038.797-.06 1.032-.19a.75.75 0 0 1 .728 1.31c-.515.287-1.23.439-1.906.373-.682-.067-1.473-.38-1.879-1.193L.75 5.677V5.5c0-.984.48-1.94 1.077-2.664.46-.559 1.05-1.055 1.673-1.353V.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M18.377 3.49c-1.862-.31-3.718.62-4.456 2.095-.428.857-.691 1.624-.728 2.361-.035.71.138 1.444.67 2.252.644.854 1.199 1.913 1.608 3.346a.75.75 0 1 1-1.442.412c-.353-1.236-.82-2.135-1.372-2.865l-.008-.01c-.53-.698-1.14-1.242-1.807-1.778a50.724 50.724 0 0 0-.667-.524C9.024 7.884 7.71 6.863 6.471 5.16c-.59.287-1.248.798-1.806 1.454-.665.78-1.097 1.66-1.158 2.446.246.36.685.61 1.246.715.643.12 1.278.015 1.633-.182a.75.75 0 1 1 .728 1.311c-.723.402-1.728.516-2.637.346-.916-.172-1.898-.667-2.398-1.666L2 9.427V9.25c0-1.323.678-2.615 1.523-3.607.7-.824 1.59-1.528 2.477-1.917V2.75a.75.75 0 1 1 1.5 0v1.27c1.154 1.67 2.363 2.612 3.568 3.551.207.162.415.323.621.489.001-.063.003-.126.006-.188.052-1.034.414-2.017.884-2.958 1.06-2.118 3.594-3.313 6.044-2.904 1.225.204 2.329.795 3.125 1.748C22.546 4.713 23 5.988 23 7.5c0 1.496-.913 3.255-2.688 3.652.838 1.699 1.438 3.768 1.181 5.697-.269 2.017-1.04 3.615-2.582 4.675C17.409 22.558 15.288 23 12.5 23H4.75a.75.75 0 0 1 0-1.5h2.322c-.58-.701-.998-1.578-1.223-2.471-.327-1.3-.297-2.786.265-4.131-.92.091-1.985-.02-3.126-.445a.75.75 0 1 1 .524-1.406c1.964.733 3.428.266 4.045-.19.068-.06.137-.12.208-.18a.745.745 0 0 1 .861-.076.746.746 0 0 1 .32.368.752.752 0 0 1-.173.819c-.077.076-.16.15-.252.221-1.322 1.234-1.62 3.055-1.218 4.654.438 1.737 1.574 2.833 2.69 2.837H12.5c2.674 0 4.429-.433 5.56-1.212 1.094-.752 1.715-1.904 1.946-3.637.236-1.768-.445-3.845-1.407-5.529a.576.576 0 0 1-.012-.02 3.557 3.557 0 0 1-1.553-.94c-.556-.565-.89-1.243-1.012-1.73a.75.75 0 0 1 1.456-.364c.057.231.26.67.626 1.043.35.357.822.623 1.443.623 1.172 0 1.953-1.058 1.953-2.234 0-1.205-.357-2.127-.903-2.78-.547-.654-1.318-1.08-2.22-1.23Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$f95b8a41f9121b54 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("StackIcon", "octicon octicon-stack", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.122.392a1.75 1.75 0 0 1 1.756 0l5.003 2.902c.83.481.83 1.68 0 2.162L8.878 8.358a1.75 1.75 0 0 1-1.756 0L2.119 5.456a1.251 1.251 0 0 1 0-2.162ZM8.125 1.69a.248.248 0 0 0-.25 0l-4.63 2.685 4.63 2.685a.248.248 0 0 0 .25 0l4.63-2.685ZM1.601 7.789a.75.75 0 0 1 1.025-.273l5.249 3.044a.248.248 0 0 0 .25 0l5.249-3.044a.75.75 0 0 1 .752 1.298l-5.248 3.044a1.75 1.75 0 0 1-1.756 0L1.874 8.814A.75.75 0 0 1 1.6 7.789Zm0 3.5a.75.75 0 0 1 1.025-.273l5.249 3.044a.248.248 0 0 0 .25 0l5.249-3.044a.75.75 0 0 1 .752 1.298l-5.248 3.044a1.75 1.75 0 0 1-1.756 0l-5.248-3.044a.75.75 0 0 1-.273-1.025Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.063 1.456a1.749 1.749 0 0 1 1.874 0l8.383 5.316a1.751 1.751 0 0 1 0 2.956l-8.383 5.316a1.749 1.749 0 0 1-1.874 0L2.68 9.728a1.751 1.751 0 0 1 0-2.956Zm1.071 1.267a.25.25 0 0 0-.268 0L3.483 8.039a.25.25 0 0 0 0 .422l8.383 5.316a.25.25 0 0 0 .268 0l8.383-5.316a.25.25 0 0 0 0-.422Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.867 12.324a.75.75 0 0 1 1.035-.232l8.964 5.685a.25.25 0 0 0 .268 0l8.964-5.685a.75.75 0 0 1 .804 1.267l-8.965 5.685a1.749 1.749 0 0 1-1.874 0l-8.965-5.685a.75.75 0 0 1-.231-1.035Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.867 16.324a.75.75 0 0 1 1.035-.232l8.964 5.685a.25.25 0 0 0 .268 0l8.964-5.685a.75.75 0 0 1 .804 1.267l-8.965 5.685a1.749 1.749 0 0 1-1.874 0l-8.965-5.685a.75.75 0 0 1-.231-1.035Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$2ee28caa7f1e962e = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("StarIcon", "octicon octicon-star", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 .25a.75.75 0 0 1 .673.418l1.882 3.815 4.21.612a.75.75 0 0 1 .416 1.279l-3.046 2.97.719 4.192a.751.751 0 0 1-1.088.791L8 12.347l-3.766 1.98a.75.75 0 0 1-1.088-.79l.72-4.194L.818 6.374a.75.75 0 0 1 .416-1.28l4.21-.611L7.327.668A.75.75 0 0 1 8 .25Zm0 2.445L6.615 5.5a.75.75 0 0 1-.564.41l-3.097.45 2.24 2.184a.75.75 0 0 1 .216.664l-.528 3.084 2.769-1.456a.75.75 0 0 1 .698 0l2.77 1.456-.53-3.084a.75.75 0 0 1 .216-.664l2.24-2.183-3.096-.45a.75.75 0 0 1-.564-.41L8 2.694Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 .25a.75.75 0 0 1 .673.418l3.058 6.197 6.839.994a.75.75 0 0 1 .415 1.279l-4.948 4.823 1.168 6.811a.751.751 0 0 1-1.088.791L12 18.347l-6.117 3.216a.75.75 0 0 1-1.088-.79l1.168-6.812-4.948-4.823a.75.75 0 0 1 .416-1.28l6.838-.993L11.328.668A.75.75 0 0 1 12 .25Zm0 2.445L9.44 7.882a.75.75 0 0 1-.565.41l-5.725.832 4.143 4.038a.748.748 0 0 1 .215.664l-.978 5.702 5.121-2.692a.75.75 0 0 1 .698 0l5.12 2.692-.977-5.702a.748.748 0 0 1 .215-.664l4.143-4.038-5.725-.831a.75.75 0 0 1-.565-.41L12 2.694Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$631562bf0758540f = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("StarFillIcon", "octicon octicon-star-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 .25a.75.75 0 0 1 .673.418l1.882 3.815 4.21.612a.75.75 0 0 1 .416 1.279l-3.046 2.97.719 4.192a.751.751 0 0 1-1.088.791L8 12.347l-3.766 1.98a.75.75 0 0 1-1.088-.79l.72-4.194L.818 6.374a.75.75 0 0 1 .416-1.28l4.21-.611L7.327.668A.75.75 0 0 1 8 .25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m12.672.668 3.059 6.197 6.838.993a.75.75 0 0 1 .416 1.28l-4.948 4.823 1.168 6.812a.75.75 0 0 1-1.088.79L12 18.347l-6.116 3.216a.75.75 0 0 1-1.088-.791l1.168-6.811-4.948-4.823a.749.749 0 0 1 .416-1.279l6.838-.994L11.327.668a.75.75 0 0 1 1.345 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$dc6949a98411e916 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("StopIcon", "octicon octicon-stop", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.47.22A.749.749 0 0 1 5 0h6c.199 0 .389.079.53.22l4.25 4.25c.141.14.22.331.22.53v6a.749.749 0 0 1-.22.53l-4.25 4.25A.749.749 0 0 1 11 16H5a.749.749 0 0 1-.53-.22L.22 11.53A.749.749 0 0 1 0 11V5c0-.199.079-.389.22-.53Zm.84 1.28L1.5 5.31v5.38l3.81 3.81h5.38l3.81-3.81V5.31L10.69 1.5ZM8 4a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4Zm0 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 7a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 12 7Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.328 1.47a.749.749 0 0 1 .53-.22h8.284c.199 0 .389.079.53.22l5.858 5.858c.141.14.22.33.22.53v8.284a.749.749 0 0 1-.22.53l-5.858 5.858a.749.749 0 0 1-.53.22H7.858a.749.749 0 0 1-.53-.22L1.47 16.672a.749.749 0 0 1-.22-.53V7.858c0-.199.079-.389.22-.53Zm.84 1.28L2.75 8.169v7.662l5.419 5.419h7.662l5.419-5.418V8.168L15.832 2.75Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$93c9322cdb01abe0 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("StopwatchIcon", "octicon octicon-stopwatch", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.75.75A.75.75 0 0 1 6.5 0h3a.75.75 0 0 1 0 1.5h-.75v1l-.001.041a6.724 6.724 0 0 1 3.464 1.435l.007-.006.75-.75a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-.75.75-.006.007a6.75 6.75 0 1 1-10.548 0L2.72 5.03l-.75-.75a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l.75.75.007.006A6.72 6.72 0 0 1 7.25 2.541V1.5H6.5a.75.75 0 0 1-.75-.75ZM8 14.5a5.25 5.25 0 1 0-.001-10.501A5.25 5.25 0 0 0 8 14.5Zm.389-6.7 1.33-1.33a.75.75 0 1 1 1.061 1.06L9.45 8.861A1.503 1.503 0 0 1 8 10.75a1.499 1.499 0 1 1 .389-2.95Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.25 0h3.5a.75.75 0 0 1 0 1.5h-1v1.278a9.954 9.954 0 0 1 5.636 2.276L19.72 3.72a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-1.315 1.316A9.959 9.959 0 0 1 22 12.75c0 5.523-4.477 10-10 10s-10-4.477-10-10a9.959 9.959 0 0 1 2.535-6.654L3.22 4.78a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l1.335 1.334a9.958 9.958 0 0 1 5.635-2.276V1.5h-1a.75.75 0 0 1 0-1.5ZM12 21.25a8.5 8.5 0 1 0-.001-17.001A8.5 8.5 0 0 0 12 21.25Zm4.03-12.53a.75.75 0 0 1 0 1.06l-2.381 2.382a1.75 1.75 0 1 1-1.06-1.06l2.38-2.382a.75.75 0 0 1 1.061 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$25ec4ecc9c5701a5 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("StrikethroughIcon", "octicon octicon-strikethrough", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.055 8.5c.524.536.815 1.257.811 2.007a3.133 3.133 0 0 1-1.12 2.408C9.948 13.597 8.748 14 7.096 14c-1.706 0-3.104-.607-3.902-1.377a.751.751 0 0 1 1.042-1.079c.48.463 1.487.956 2.86.956 1.422 0 2.232-.346 2.676-.726.435-.372.594-.839.594-1.267 0-.472-.208-.857-.647-1.197-.448-.346-1.116-.623-1.951-.81H1.75a.75.75 0 0 1 0-1.5h12.5a.75.75 0 0 1 0 1.5ZM7.581 3.25c-2.036 0-2.778 1.082-2.778 1.786 0 .055.002.107.006.157a.75.75 0 0 1-1.496.114 3.506 3.506 0 0 1-.01-.271c0-1.832 1.75-3.286 4.278-3.286 1.418 0 2.721.58 3.514 1.093a.75.75 0 1 1-.814 1.26c-.64-.414-1.662-.853-2.7-.853Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m16.533 12.5.054.043c.93.75 1.538 1.77 1.538 3.066a4.13 4.13 0 0 1-1.479 3.177c-1.058.904-2.679 1.464-4.974 1.464-2.35 0-4.252-.837-5.318-1.865a.75.75 0 1 1 1.042-1.08c.747.722 2.258 1.445 4.276 1.445 2.065 0 3.296-.504 3.999-1.105a2.63 2.63 0 0 0 .954-2.036c0-.764-.337-1.38-.979-1.898-.649-.523-1.598-.931-2.76-1.211H3.75a.75.75 0 0 1 0-1.5h16.5a.75.75 0 0 1 0 1.5ZM12.36 5C9.37 5 8.105 6.613 8.105 7.848c0 .411.072.744.193 1.02a.75.75 0 0 1-1.373.603 3.988 3.988 0 0 1-.32-1.623c0-2.363 2.271-4.348 5.755-4.348 1.931 0 3.722.794 4.814 1.5a.75.75 0 1 1-.814 1.26c-.94-.607-2.448-1.26-4-1.26Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$cd27c497b93dbe8d = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SunIcon", "octicon octicon-sun", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-1.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm5.657-8.157a.75.75 0 0 1 0 1.061l-1.061 1.06a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.06-1.06a.75.75 0 0 1 1.06 0Zm-9.193 9.193a.75.75 0 0 1 0 1.06l-1.06 1.061a.75.75 0 1 1-1.061-1.06l1.06-1.061a.75.75 0 0 1 1.061 0ZM8 0a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 8 0ZM3 8a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1 0-1.5h1.5A.75.75 0 0 1 3 8Zm13 0a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5A.75.75 0 0 1 16 8Zm-8 5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 8 13Zm3.536-1.464a.75.75 0 0 1 1.06 0l1.061 1.06a.75.75 0 0 1-1.06 1.061l-1.061-1.06a.75.75 0 0 1 0-1.061ZM2.343 2.343a.75.75 0 0 1 1.061 0l1.06 1.061a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-1.06-1.06a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14Zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 1 0 0 11Zm-5.657.157a.75.75 0 0 1 0 1.06l-1.768 1.768a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.767-1.768a.75.75 0 0 1 1.061 0ZM3.515 3.515a.75.75 0 0 1 1.06 0l1.768 1.768a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L3.515 4.575a.75.75 0 0 1 0-1.06ZM12 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 12 0ZM4 12a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 4 12Zm8 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 12 20Zm12-8a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 24 12Zm-6.343 5.657a.75.75 0 0 1 1.06 0l1.768 1.768a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-1.768-1.767a.75.75 0 0 1 0-1.061Zm2.828-14.142a.75.75 0 0 1 0 1.06l-1.768 1.768a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l1.767-1.768a.75.75 0 0 1 1.061 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$6275f016a953141a = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("SyncIcon", "octicon octicon-sync", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.705 8.005a.75.75 0 0 1 .834.656 5.5 5.5 0 0 0 9.592 2.97l-1.204-1.204a.25.25 0 0 1 .177-.427h3.646a.25.25 0 0 1 .25.25v3.646a.25.25 0 0 1-.427.177l-1.38-1.38A7.002 7.002 0 0 1 1.05 8.84a.75.75 0 0 1 .656-.834ZM8 2.5a5.487 5.487 0 0 0-4.131 1.869l1.204 1.204A.25.25 0 0 1 4.896 6H1.25A.25.25 0 0 1 1 5.75V2.104a.25.25 0 0 1 .427-.177l1.38 1.38A7.002 7.002 0 0 1 14.95 7.16a.75.75 0 0 1-1.49.178A5.5 5.5 0 0 0 8 2.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.38 8A9.502 9.502 0 0 1 12 2.5a9.502 9.502 0 0 1 9.215 7.182.75.75 0 1 0 1.456-.364C21.473 4.539 17.15 1 12 1a10.995 10.995 0 0 0-9.5 5.452V4.75a.75.75 0 0 0-1.5 0V8.5a1 1 0 0 0 1 1h3.75a.75.75 0 0 0 0-1.5H3.38Zm-.595 6.318a.75.75 0 0 0-1.455.364C2.527 19.461 6.85 23 12 23c4.052 0 7.592-2.191 9.5-5.451v1.701a.75.75 0 0 0 1.5 0V15.5a1 1 0 0 0-1-1h-3.75a.75.75 0 0 0 0 1.5h2.37A9.502 9.502 0 0 1 12 21.5c-4.446 0-8.181-3.055-9.215-7.182Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$101d1271c02245ef = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TabIcon", "octicon octicon-tab", function() {
    return {
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M22 4.25a.75.75 0 0 0-1.5 0v15a.75.75 0 0 0 1.5 0v-15Zm-9.72 14.28a.75.75 0 1 1-1.06-1.06l4.97-4.97H1.75a.75.75 0 0 1 0-1.5h14.44l-4.97-4.97a.75.75 0 0 1 1.06-1.06l6.25 6.25a.75.75 0 0 1 0 1.06l-6.25 6.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$31b3da7e5240c9e6 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TabExternalIcon", "octicon octicon-tab-external", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.25 4a.25.25 0 0 0-.25.25v9a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1 0-1.5h.75V4.25c0-.966.784-1.75 1.75-1.75h9.5c.966 0 1.75.784 1.75 1.75v8.25h.75a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75v-9a.25.25 0 0 0-.25-.25h-9.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m7.97 7.97-2.75 2.75a.75.75 0 1 0 1.06 1.06l2.75-2.75 1.543 1.543a.25.25 0 0 0 .427-.177V6.25a.25.25 0 0 0-.25-.25H6.604a.25.25 0 0 0-.177.427L7.97 7.97Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$560b0277c649ed6b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TableIcon", "octicon octicon-table", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25ZM6.5 6.5v8h7.75a.25.25 0 0 0 .25-.25V6.5Zm8-1.5V1.75a.25.25 0 0 0-.25-.25H6.5V5Zm-13 1.5v7.75c0 .138.112.25.25.25H5v-8ZM5 5V1.5H1.75a.25.25 0 0 0-.25.25V5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25ZM9 9v11.5h11.25a.25.25 0 0 0 .25-.25V9Zm11.5-1.5V3.75a.25.25 0 0 0-.25-.25H9v4ZM3.5 9v11.25c0 .138.112.25.25.25H7.5V9Zm4-1.5v-4H3.75a.25.25 0 0 0-.25.25V7.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$80beb1cb95701424 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TagIcon", "octicon octicon-tag", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 7.775V2.75C1 1.784 1.784 1 2.75 1h5.025c.464 0 .91.184 1.238.513l6.25 6.25a1.75 1.75 0 0 1 0 2.474l-5.026 5.026a1.75 1.75 0 0 1-2.474 0l-6.25-6.25A1.752 1.752 0 0 1 1 7.775Zm1.5 0c0 .066.026.13.073.177l6.25 6.25a.25.25 0 0 0 .354 0l5.025-5.025a.25.25 0 0 0 0-.354l-6.25-6.25a.25.25 0 0 0-.177-.073H2.75a.25.25 0 0 0-.25.25ZM6 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.75 6.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.5 1h8.44a1.5 1.5 0 0 1 1.06.44l10.25 10.25a1.5 1.5 0 0 1 0 2.12l-8.44 8.44a1.5 1.5 0 0 1-2.12 0L1.44 12A1.497 1.497 0 0 1 1 10.94V2.5A1.5 1.5 0 0 1 2.5 1Zm0 1.5v8.44l10.25 10.25 8.44-8.44L10.94 2.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$464aecc9a55fb878 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TasklistIcon", "octicon octicon-tasklist", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2 2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm4.655 8.595a.75.75 0 0 1 0 1.06L4.03 14.28a.75.75 0 0 1-1.06 0l-1.5-1.5a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l.97.97 2.095-2.095a.75.75 0 0 1 1.06 0ZM9.75 2.5h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5Zm0 5h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5Zm0 5h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5Zm-7.25-9v3h3v-3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3 6a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm1.5 4.5h4v-4h-4Zm8.25-5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Zm0 6a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Zm0 6a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Zm-2.97-2.53a.75.75 0 0 1 0 1.06l-3.5 3.5a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l1.47 1.47 2.97-2.97a.75.75 0 0 1 1.06 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$4cb6639b7b9a0249 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TelescopeIcon", "octicon octicon-telescope", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M14.184 1.143v-.001l1.422 2.464a1.75 1.75 0 0 1-.757 2.451L3.104 11.713a1.75 1.75 0 0 1-2.275-.702l-.447-.775a1.75 1.75 0 0 1 .53-2.32L11.682.573a1.748 1.748 0 0 1 2.502.57Zm-4.709 9.32h-.001l2.644 3.863a.75.75 0 1 1-1.238.848l-1.881-2.75v2.826a.75.75 0 0 1-1.5 0v-2.826l-1.881 2.75a.75.75 0 1 1-1.238-.848l2.049-2.992a.746.746 0 0 1 .293-.253l1.809-.87a.749.749 0 0 1 .944.252ZM9.436 3.92h-.001l-4.97 3.39.942 1.63 5.42-2.61Zm3.091-2.108h.001l-1.85 1.26 1.505 2.605 2.016-.97a.247.247 0 0 0 .13-.151.247.247 0 0 0-.022-.199l-1.422-2.464a.253.253 0 0 0-.161-.119.254.254 0 0 0-.197.038ZM1.756 9.157a.25.25 0 0 0-.075.33l.447.775a.25.25 0 0 0 .325.1l1.598-.769-.83-1.436-1.465 1Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M.408 15.13a2 2 0 0 1 .59-2.642L17.038 1.33a1.999 1.999 0 0 1 2.85.602l2.828 4.644a2 2 0 0 1-.851 2.847l-17.762 8.43a2 2 0 0 1-2.59-.807Zm5.263-4.066 1.987 3.44 8.712-4.135-2.857-4.76Zm12.06-1.34.001-.001 3.49-1.656a.498.498 0 0 0 .212-.712l-2.826-4.644a.503.503 0 0 0-.713-.151l-3.148 2.19Zm-13.295 2.2L1.854 13.72a.5.5 0 0 0-.147.66l1.105 1.915a.5.5 0 0 0 .648.201l2.838-1.347ZM17.155 22.87a.75.75 0 0 0 .226-1.036l-4-6.239a.75.75 0 0 0-.941-.278l-2.75 1.25a.75.75 0 0 0-.318.274l-3.25 4.989a.75.75 0 0 0 1.256.819l3.131-4.806.51-.232v5.64a.75.75 0 1 0 1.5 0v-6.22l3.6 5.613a.75.75 0 0 0 1.036.226Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8d68df259ae2ded9 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TelescopeFillIcon", "octicon octicon-telescope-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.905.42a1.5 1.5 0 0 1 2.144.49l1.692 2.93a1.5 1.5 0 0 1-.649 2.102L2.895 11.815a1.5 1.5 0 0 1-1.95-.602l-.68-1.176a1.5 1.5 0 0 1 .455-1.99L11.905.422Zm-3.374 9.79a.75.75 0 0 1 .944.253l2.644 3.864a.751.751 0 0 1-1.238.847L9 12.424v2.826a.75.75 0 0 1-1.5 0v-2.826l-1.881 2.75a.75.75 0 1 1-1.238-.848l2.048-2.992a.752.752 0 0 1 .293-.252l1.81-.871Zm2.476-3.965v-.001l1.356-.653-1.52-2.631-1.243.848ZM3.279 8.119l.835 1.445 1.355-.653-.947-1.64Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M17.155 22.87a.75.75 0 0 0 .226-1.036l-4-6.239a.75.75 0 0 0-.941-.277l-2.75 1.25a.75.75 0 0 0-.318.273l-3.25 4.989a.75.75 0 0 0 1.256.819l3.131-4.806.51-.232v5.64a.75.75 0 1 0 1.5 0v-6.22l3.6 5.613a.75.75 0 0 0 1.036.226ZM.408 15.13a2 2 0 0 1 .59-2.642L17.038 1.33a1.999 1.999 0 0 1 2.85.602l2.828 4.644a2 2 0 0 1-.851 2.847l-17.762 8.43a2 2 0 0 1-2.59-.807Zm13.105-9.521 2.857 4.76 1.361-.646-2.984-4.973Zm-7.842 5.455-1.235.86 1.862 3.225 1.36-.645Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$9ff5547afd06adf7 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TerminalIcon", "octicon octicon-terminal", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25Zm1.75-.25a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25ZM7.25 8a.749.749 0 0 1-.22.53l-2.25 2.25a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L5.44 8 3.72 6.28a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l2.25 2.25c.141.14.22.331.22.53Zm1.5 1.5h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.25 12a.75.75 0 0 1-.22.53l-2.75 2.75a.75.75 0 0 1-1.06-1.06L7.44 12 5.22 9.78a.75.75 0 1 1 1.06-1.06l2.75 2.75c.141.14.22.331.22.53Zm2 2a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 4.75C0 3.784.784 3 1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V4.75a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$d771fc36eba591ce = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ThreeBarsIcon", "octicon octicon-three-bars", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 2.75A.75.75 0 0 1 1.75 2h12.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 2.75Zm0 5A.75.75 0 0 1 1.75 7h12.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 7.75ZM1.75 12h12.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1 0-1.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$d57a6722de6c45ee = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ThumbsdownIcon", "octicon octicon-thumbsdown", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.083 15.986c-.763-.087-1.499-.295-2.011-.884-.504-.581-.655-1.378-.655-2.299 0-.468.087-1.12.157-1.638l.015-.112H3.167c-.603 0-1.174-.086-1.669-.334a2.415 2.415 0 0 1-1.136-1.2c-.454-.998-.438-2.447-.188-4.316l.04-.306C.32 4.108.41 3.424.526 2.864c.132-.63.316-1.209.669-1.672C1.947.205 3.211.053 4.917.053c1.848 0 3.234.332 4.388.652l.474.133c.658.187 1.201.341 1.726.415a1.75 1.75 0 0 1 1.662-1.2h1c.966 0 1.75.784 1.75 1.75v7.5a1.75 1.75 0 0 1-1.75 1.75h-1a1.75 1.75 0 0 1-1.514-.872c-.259.105-.59.268-.919.508-.671.491-1.317 1.285-1.317 2.614v.5c0 1.201-.994 2.336-2.334 2.183Zm4.334-13.232c-.706-.089-1.39-.284-2.072-.479l-.441-.125c-1.096-.304-2.335-.597-3.987-.597-1.794 0-2.28.222-2.529.548-.147.193-.275.505-.393 1.07-.105.502-.188 1.124-.295 1.93l-.04.3c-.25 1.882-.19 2.933.067 3.497a.923.923 0 0 0 .443.48c.208.104.52.175.997.175h1.75c.685 0 1.295.577 1.205 1.335-.022.192-.049.39-.075.586-.066.488-.13.97-.13 1.329 0 .808.144 1.15.288 1.316.137.157.401.303 1.048.377.307.035.664-.237.664-.693v-.5c0-1.922.978-3.127 1.932-3.825a5.878 5.878 0 0 1 1.568-.809Zm1.75 6.798h1a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.596 21.957c-1.301.092-2.303-.986-2.303-2.206v-1.053c0-2.666-1.813-3.785-2.774-4.2a1.884 1.884 0 0 0-.523-.13A1.75 1.75 0 0 1 5.25 16h-1.5A1.75 1.75 0 0 1 2 14.25V3.75C2 2.784 2.784 2 3.75 2h1.5a1.75 1.75 0 0 1 1.742 1.58c.838-.06 1.667-.296 2.69-.586l.602-.17C11.748 2.419 13.497 2 15.828 2c2.188 0 3.693.204 4.583 1.372.422.554.65 1.255.816 2.05.148.708.262 1.57.396 2.58l.051.39c.319 2.386.328 4.18-.223 5.394-.293.644-.743 1.125-1.355 1.431-.59.296-1.284.404-2.036.404h-2.05l.056.429c.025.18.05.372.076.572.06.483.117 1.006.117 1.438 0 1.245-.222 2.253-.92 2.942-.684.674-1.668.879-2.743.955ZM7 5.082v7.779c.383.025.759.113 1.113.26 1.192.514 3.68 2.027 3.68 5.577v1.053c0 .436.347.734.698.71 1.021-.072 1.52-.258 1.795-.528.26-.256.473-.748.473-1.873 0-.328-.045-.768-.105-1.25l-.07-.527c-.04-.297-.079-.59-.105-.834-.082-.758.53-1.328 1.211-1.328h2.37c.625 0 1.06-.092 1.365-.245.285-.142.5-.359.66-.711.355-.78.422-2.176.102-4.574l-.05-.385c-.137-1.027-.243-1.827-.379-2.477-.152-.73-.324-1.165-.54-1.448-.386-.507-1.113-.781-3.39-.781-2.136 0-3.736.379-5.142.771-.191.052-.38.106-.568.16-1.039.296-2.059.587-3.118.651ZM3.75 3.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8c9dd934a8e6d9f2 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ThumbsupIcon", "octicon octicon-thumbsup", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M8.834.066c.763.087 1.5.295 2.01.884.505.581.656 1.378.656 2.3 0 .467-.087 1.119-.157 1.637L11.328 5h1.422c.603 0 1.174.085 1.668.333.508.254.911.679 1.137 1.2.453.998.438 2.447.188 4.316l-.04.306c-.105.79-.195 1.473-.313 2.033-.131.63-.315 1.209-.668 1.672C13.97 15.847 12.706 16 11 16c-1.848 0-3.234-.333-4.388-.653-.165-.045-.323-.09-.475-.133-.658-.186-1.2-.34-1.725-.415A1.75 1.75 0 0 1 2.75 16h-1A1.75 1.75 0 0 1 0 14.25v-7.5C0 5.784.784 5 1.75 5h1a1.75 1.75 0 0 1 1.514.872c.258-.105.59-.268.918-.508C5.853 4.874 6.5 4.079 6.5 2.75v-.5c0-1.202.994-2.337 2.334-2.184ZM4.5 13.3c.705.088 1.39.284 2.072.478l.441.125c1.096.305 2.334.598 3.987.598 1.794 0 2.28-.223 2.528-.549.147-.193.276-.505.394-1.07.105-.502.188-1.124.295-1.93l.04-.3c.25-1.882.189-2.933-.068-3.497a.921.921 0 0 0-.442-.48c-.208-.104-.52-.174-.997-.174H11c-.686 0-1.295-.577-1.206-1.336.023-.192.05-.39.076-.586.065-.488.13-.97.13-1.328 0-.809-.144-1.15-.288-1.316-.137-.158-.402-.304-1.048-.378C8.357 1.521 8 1.793 8 2.25v.5c0 1.922-.978 3.128-1.933 3.825a5.831 5.831 0 0 1-1.567.81ZM2.75 6.5h-1a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.596 2.043c1.075.076 2.059.281 2.743.956.698.688.92 1.696.92 2.941 0 .432-.057.955-.117 1.438-.026.2-.051.392-.076.572l-.056.429h2.05c.752 0 1.446.108 2.036.404.612.306 1.062.787 1.355 1.431.551 1.214.542 3.008.223 5.394l-.051.39c-.134 1.01-.248 1.872-.396 2.58-.166.795-.394 1.496-.816 2.05-.89 1.168-2.395 1.372-4.583 1.372-2.331 0-4.08-.418-5.544-.824l-.602-.17c-1.023-.29-1.852-.526-2.69-.586A1.75 1.75 0 0 1 5.25 22h-1.5A1.75 1.75 0 0 1 2 20.25V9.75C2 8.784 2.784 8 3.75 8h1.5a1.75 1.75 0 0 1 1.746 1.633 1.85 1.85 0 0 0 .523-.131c.961-.415 2.774-1.534 2.774-4.2V4.249c0-1.22 1.002-2.298 2.303-2.206ZM7 18.918c1.059.064 2.079.355 3.118.652l.568.16c1.406.39 3.006.77 5.142.77 2.277 0 3.004-.274 3.39-.781.216-.283.388-.718.54-1.448.136-.65.242-1.45.379-2.477l.05-.384c.32-2.4.253-3.795-.102-4.575-.16-.352-.375-.568-.66-.711-.305-.153-.74-.245-1.365-.245h-2.37c-.681 0-1.293-.57-1.211-1.328.026-.243.065-.537.105-.834l.07-.527c.06-.482.105-.921.105-1.25 0-1.125-.213-1.617-.473-1.873-.275-.27-.774-.455-1.795-.528-.351-.024-.698.274-.698.71v1.053c0 3.55-2.488 5.063-3.68 5.577-.372.16-.754.232-1.113.26ZM3.75 20.5h1.5a.25.25 0 0 0 .25-.25V9.75a.25.25 0 0 0-.25-.25h-1.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$3d7439614fbf4d3e = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ToolsIcon", "octicon octicon-tools", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.433 2.304A4.492 4.492 0 0 0 3.5 6c0 1.598.832 3.002 2.09 3.802.518.328.929.923.902 1.64v.008l-.164 3.337a.75.75 0 1 1-1.498-.073l.163-3.33c.002-.085-.05-.216-.207-.316A5.996 5.996 0 0 1 2 6a5.993 5.993 0 0 1 2.567-4.92 1.482 1.482 0 0 1 1.673-.04c.462.296.76.827.76 1.423v2.82c0 .082.041.16.11.206l.75.51a.25.25 0 0 0 .28 0l.75-.51A.249.249 0 0 0 9 5.282V2.463c0-.596.298-1.127.76-1.423a1.482 1.482 0 0 1 1.673.04A5.993 5.993 0 0 1 14 6a5.996 5.996 0 0 1-2.786 5.068c-.157.1-.209.23-.207.315l.163 3.33a.752.752 0 0 1-1.094.714.75.75 0 0 1-.404-.64l-.164-3.345c-.027-.717.384-1.312.902-1.64A4.495 4.495 0 0 0 12.5 6a4.492 4.492 0 0 0-1.933-3.696c-.024.017-.067.067-.067.16v2.818a1.75 1.75 0 0 1-.767 1.448l-.75.51a1.75 1.75 0 0 1-1.966 0l-.75-.51A1.75 1.75 0 0 1 5.5 5.282V2.463c0-.092-.043-.142-.067-.159Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.875 2.292a.114.114 0 0 0-.032.018A7.239 7.239 0 0 0 4.75 8.25a7.248 7.248 0 0 0 3.654 6.297c.57.327.982.955.941 1.682v.002l-.317 6.058a.75.75 0 1 1-1.498-.078l.317-6.062v-.004c.006-.09-.047-.215-.188-.296A8.749 8.749 0 0 1 3.25 8.25a8.738 8.738 0 0 1 3.732-7.169 1.547 1.547 0 0 1 1.709-.064c.484.292.809.835.809 1.46v4.714a.25.25 0 0 0 .119.213l2.25 1.385c.08.05.182.05.262 0l2.25-1.385a.25.25 0 0 0 .119-.213V2.478c0-.626.325-1.169.81-1.461a1.547 1.547 0 0 1 1.708.064 8.741 8.741 0 0 1 3.732 7.17 8.747 8.747 0 0 1-4.41 7.598c-.14.081-.193.206-.188.296v.004l.318 6.062a.75.75 0 1 1-1.498.078l-.317-6.058v-.002c-.041-.727.37-1.355.94-1.682A7.247 7.247 0 0 0 19.25 8.25a7.239 7.239 0 0 0-3.093-5.94.114.114 0 0 0-.032-.018l-.01-.001c-.003 0-.014 0-.031.01-.036.022-.084.079-.084.177V7.19c0 .608-.315 1.172-.833 1.49l-2.25 1.385a1.75 1.75 0 0 1-1.834 0l-2.25-1.384A1.752 1.752 0 0 1 8 7.192V2.477c0-.098-.048-.155-.084-.176a.068.068 0 0 0-.031-.011l-.01.001Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$d23329de703dffc4 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TrashIcon", "octicon octicon-trash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11 1.75V3h2.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H5V1.75C5 .784 5.784 0 6.75 0h2.5C10.216 0 11 .784 11 1.75ZM4.496 6.675l.66 6.6a.25.25 0 0 0 .249.225h5.19a.25.25 0 0 0 .249-.225l.66-6.6a.75.75 0 0 1 1.492.149l-.66 6.6A1.748 1.748 0 0 1 10.595 15h-5.19a1.75 1.75 0 0 1-1.741-1.575l-.66-6.6a.75.75 0 1 1 1.492-.15ZM6.5 1.75V3h3V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16 1.75V3h5.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H8V1.75C8 .784 8.784 0 9.75 0h4.5C15.216 0 16 .784 16 1.75Zm-6.5 0V3h5V1.75a.25.25 0 0 0-.25-.25h-4.5a.25.25 0 0 0-.25.25ZM4.997 6.178a.75.75 0 1 0-1.493.144L4.916 20.92a1.75 1.75 0 0 0 1.742 1.58h10.684a1.75 1.75 0 0 0 1.742-1.581l1.413-14.597a.75.75 0 0 0-1.494-.144l-1.412 14.596a.25.25 0 0 1-.249.226H6.658a.25.25 0 0 1-.249-.226L4.997 6.178Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.206 7.501a.75.75 0 0 1 .793.705l.5 8.5A.75.75 0 1 1 9 16.794l-.5-8.5a.75.75 0 0 1 .705-.793Zm6.293.793A.75.75 0 1 0 14 8.206l-.5 8.5a.75.75 0 0 0 1.498.088l.5-8.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$b445c2dc6993f9f8 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TriangleDownIcon", "octicon octicon-triangle-down", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m4.427 7.427 3.396 3.396a.25.25 0 0 0 .354 0l3.396-3.396A.25.25 0 0 0 11.396 7H4.604a.25.25 0 0 0-.177.427Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.646 15.146 5.854 9.354a.5.5 0 0 1 .353-.854h11.586a.5.5 0 0 1 .353.854l-5.793 5.792a.5.5 0 0 1-.707 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$62f44957433ecfbf = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TriangleLeftIcon", "octicon octicon-triangle-left", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.573 4.427 6.177 7.823a.25.25 0 0 0 0 .354l3.396 3.396a.25.25 0 0 0 .427-.177V4.604a.25.25 0 0 0-.427-.177Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m8.854 11.646 5.792-5.792a.5.5 0 0 1 .854.353v11.586a.5.5 0 0 1-.854.353l-5.792-5.792a.5.5 0 0 1 0-.708Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$43e4d35e8a44b537 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TriangleRightIcon", "octicon octicon-triangle-right", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m6.427 4.427 3.396 3.396a.25.25 0 0 1 0 .354l-3.396 3.396A.25.25 0 0 1 6 11.396V4.604a.25.25 0 0 1 .427-.177Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m15.146 12.354-5.792 5.792a.5.5 0 0 1-.854-.353V6.207a.5.5 0 0 1 .854-.353l5.792 5.792a.5.5 0 0 1 0 .708Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$9ff28f4659896371 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TriangleUpIcon", "octicon octicon-triangle-up", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m4.427 9.573 3.396-3.396a.25.25 0 0 1 .354 0l3.396 3.396a.25.25 0 0 1-.177.427H4.604a.25.25 0 0 1-.177-.427Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m12.354 8.854 5.792 5.792a.5.5 0 0 1-.353.854H6.207a.5.5 0 0 1-.353-.854l5.792-5.792a.5.5 0 0 1 .708 0Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$38852ed648a706e8 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TrophyIcon", "octicon octicon-trophy", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.217 6.962A3.75 3.75 0 0 1 0 3.25v-.5C0 1.784.784 1 1.75 1h1.356c.228-.585.796-1 1.462-1h6.864c.647 0 1.227.397 1.462 1h1.356c.966 0 1.75.784 1.75 1.75v.5a3.75 3.75 0 0 1-3.217 3.712 5.014 5.014 0 0 1-2.771 3.117l.144 1.446c.005.05.03.12.114.204.086.087.217.17.373.227.283.103.618.274.89.568.285.31.467.723.467 1.226v.75h1.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H4v-.75c0-.503.182-.916.468-1.226.27-.294.606-.465.889-.568.139-.048.266-.126.373-.227.084-.085.109-.153.114-.204l.144-1.446a5.015 5.015 0 0 1-2.77-3.117ZM4.5 1.568V5.5a3.5 3.5 0 1 0 7 0V1.568a.068.068 0 0 0-.068-.068H4.568a.068.068 0 0 0-.068.068Zm2.957 8.902-.12 1.204c-.093.925-.858 1.47-1.467 1.691a.766.766 0 0 0-.3.176c-.037.04-.07.093-.07.21v.75h5v-.75c0-.117-.033-.17-.07-.21a.766.766 0 0 0-.3-.176c-.609-.221-1.374-.766-1.466-1.69l-.12-1.204a5.064 5.064 0 0 1-1.087 0ZM13 2.5v2.872a2.25 2.25 0 0 0 1.5-2.122v-.5a.25.25 0 0 0-.25-.25H13Zm-10 0H1.75a.25.25 0 0 0-.25.25v.5c0 .98.626 1.813 1.5 2.122Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.09 10.121A5.251 5.251 0 0 1 1 5V3.75C1 2.784 1.784 2 2.75 2h2.364c.236-.586.81-1 1.48-1h10.812c.67 0 1.244.414 1.48 1h2.489c.966 0 1.75.784 1.75 1.75V5a5.252 5.252 0 0 1-4.219 5.149 7.01 7.01 0 0 1-4.644 5.478l.231 3.003a.5.5 0 0 0 .034.031c.079.065.303.203.836.282.838.124 1.637.81 1.637 1.807v.75h2.25a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1 0-1.5H7v-.75c0-.996.8-1.683 1.637-1.807.533-.08.757-.217.836-.282a.5.5 0 0 0 .034-.031l.231-3.003A7.012 7.012 0 0 1 5.09 10.12ZM6.5 2.594V9a5.5 5.5 0 1 0 11 0V2.594a.094.094 0 0 0-.094-.094H6.594a.094.094 0 0 0-.094.094Zm4.717 13.363-.215 2.793-.001.021-.003.043a1.212 1.212 0 0 1-.022.147c-.05.237-.194.567-.553.86-.348.286-.853.5-1.566.605a.478.478 0 0 0-.274.136.264.264 0 0 0-.083.188v.75h7v-.75a.264.264 0 0 0-.083-.188.478.478 0 0 0-.274-.136c-.713-.105-1.218-.32-1.567-.604-.358-.294-.502-.624-.552-.86a1.22 1.22 0 0 1-.025-.19l-.001-.022-.215-2.793a7.069 7.069 0 0 1-1.566 0ZM19 8.578A3.751 3.751 0 0 0 21.625 5V3.75a.25.25 0 0 0-.25-.25H19ZM5 3.5H2.75a.25.25 0 0 0-.25.25V5A3.752 3.752 0 0 0 5 8.537Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$f857f420ac44f7ca = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("TypographyIcon", "octicon octicon-typography", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.71 10H2.332l-.874 2.498a.75.75 0 0 1-1.415-.496l3.39-9.688a1.217 1.217 0 0 1 2.302.018l3.227 9.681a.75.75 0 0 1-1.423.474Zm3.13-4.358C10.53 4.374 11.87 4 13 4c1.5 0 3 .939 3 2.601v5.649a.75.75 0 0 1-1.448.275C13.995 12.82 13.3 13 12.5 13c-.77 0-1.514-.231-2.078-.709-.577-.488-.922-1.199-.922-2.041 0-.694.265-1.411.887-1.944C11 7.78 11.88 7.5 13 7.5h1.5v-.899c0-.54-.5-1.101-1.5-1.101-.869 0-1.528.282-1.84.858a.75.75 0 1 1-1.32-.716ZM6.21 8.5 4.574 3.594 2.857 8.5Zm8.29.5H13c-.881 0-1.375.22-1.637.444-.253.217-.363.5-.363.806 0 .408.155.697.39.896.249.21.63.354 1.11.354.732 0 1.26-.209 1.588-.449.35-.257.412-.495.412-.551Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.414 15H3.586l-1.631 4.505a.75.75 0 1 1-1.41-.51l5.08-14.03a1.463 1.463 0 0 1 2.75 0l5.08 14.03a.75.75 0 1 1-1.411.51Zm4.532-5.098c.913-1.683 2.703-2.205 4.284-2.205 1.047 0 2.084.312 2.878.885.801.577 1.392 1.455 1.392 2.548v8.12a.75.75 0 0 1-1.5 0v-.06l-.044.025c-.893.52-2.096.785-3.451.785-1.051 0-2.048-.315-2.795-.948-.76-.643-1.217-1.578-1.217-2.702 0-.919.349-1.861 1.168-2.563.81-.694 2-1.087 3.569-1.087H22v-1.57c0-.503-.263-.967-.769-1.332-.513-.37-1.235-.6-2.001-.6-1.319 0-2.429.43-2.966 1.42a.75.75 0 0 1-1.318-.716ZM9.87 13.5 7 5.572 4.13 13.5Zm12.13.7h-2.77c-1.331 0-2.134.333-2.593.726a1.822 1.822 0 0 0-.644 1.424c0 .689.267 1.203.686 1.557.43.365 1.065.593 1.826.593 1.183 0 2.102-.235 2.697-.581.582-.34.798-.74.798-1.134Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$87a56d71ff3174dc = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("UnfoldIcon", "octicon octicon-unfold", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m8.177.677 2.896 2.896a.25.25 0 0 1-.177.427H8.75v1.25a.75.75 0 0 1-1.5 0V4H5.104a.25.25 0 0 1-.177-.427L7.823.677a.25.25 0 0 1 .354 0ZM7.25 10.75a.75.75 0 0 1 1.5 0V12h2.146a.25.25 0 0 1 .177.427l-2.896 2.896a.25.25 0 0 1-.354 0l-2.896-2.896A.25.25 0 0 1 5.104 12H7.25v-1.25Zm-5-2a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM6 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 6 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM12 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 12 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 23a.749.749 0 0 1-.53-.22l-3.25-3.25a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215L12 21.19l2.72-2.72a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-3.25 3.25A.749.749 0 0 1 12 23Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.47 1.22a.75.75 0 0 1 1.06 0l3.25 3.25a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018L12 2.81 9.28 5.53a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042ZM12 22.25a.75.75 0 0 1-.75-.75v-5.75a.75.75 0 0 1 1.5 0v5.75a.75.75 0 0 1-.75.75ZM2.75 12a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6A.75.75 0 0 1 12 1.5Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$39927e15d1e906 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("UnlinkIcon", "octicon octicon-unlink", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12.914 5.914a2 2 0 0 0-2.828-2.828l-.837.837a.75.75 0 1 1-1.06-1.061l.836-.837a3.5 3.5 0 1 1 4.95 4.95l-.195.194a.75.75 0 0 1-1.06-1.06l.194-.195Zm-1.87 3.482a.759.759 0 0 1-.07.079c-.63.63-1.468 1.108-2.343 1.263-.89.159-1.86-.017-2.606-.763a.75.75 0 1 1 1.06-1.06c.329.327.767.438 1.284.347.493-.088 1.018-.36 1.445-.752l-1.247-.897a.709.709 0 0 1-.01-.008l-.295-.212c-.94-.597-1.984-.499-2.676.193l-2.5 2.5a2 2 0 1 0 2.828 2.828l.837-.836a.75.75 0 0 1 1.06 1.06l-.836.837a3.5 3.5 0 0 1-4.95-4.95l2.5-2.5a3.472 3.472 0 0 1 1.354-.848L2.312 3.109a.75.75 0 0 1 .876-1.218l5.93 4.27c.115.074.226.155.335.24l6.235 4.49a.75.75 0 0 1-.876 1.218l-3.768-2.713Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M20.347 3.653a3.936 3.936 0 0 0-5.567 0l-1.75 1.75a.75.75 0 0 1-1.06-1.06l1.75-1.75a5.436 5.436 0 0 1 7.688 7.687l-1.564 1.564a.75.75 0 0 1-1.06-1.06l1.563-1.564a3.936 3.936 0 0 0 0-5.567ZM9.786 12.369a.75.75 0 0 1 1.053.125c.096.122.2.24.314.353 1.348 1.348 3.386 1.587 4.89.658l-3.922-2.858a.745.745 0 0 1-.057-.037c-1.419-1.013-3.454-.787-4.784.543L3.653 14.78a3.936 3.936 0 0 0 5.567 5.567l3-3a.75.75 0 1 1 1.06 1.06l-3 3a5.436 5.436 0 1 1-7.688-7.687l3.628-3.628a5.517 5.517 0 0 1 3.014-1.547l-7.05-5.136a.75.75 0 0 1 .883-1.213l20.25 14.75a.75.75 0 0 1-.884 1.213l-5.109-3.722c-2.155 1.709-5.278 1.425-7.232-.53a5.491 5.491 0 0 1-.431-.485.75.75 0 0 1 .125-1.053Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$caf8e4bd765e502b = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("UnlockIcon", "octicon octicon-unlock", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.5 4v2h7A1.5 1.5 0 0 1 14 7.5v6a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5v-6A1.5 1.5 0 0 1 3.499 6H4V4a4 4 0 0 1 7.371-2.154.75.75 0 0 1-1.264.808A2.5 2.5 0 0 0 5.5 4Zm-2 3.5v6h9v-6h-9Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.5 7.25V9h11a2.5 2.5 0 0 1 2.5 2.5v8a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 19.5v-8A2.5 2.5 0 0 1 5.5 9H6V7.25C6 3.845 8.503 1 12 1c2.792 0 4.971 1.825 5.718 4.31a.75.75 0 1 1-1.436.432C15.71 3.84 14.079 2.5 12 2.5c-2.578 0-4.5 2.08-4.5 4.75Zm-3 4.25v8a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-13a1 1 0 0 0-1 1Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$f2d95e4d836f4853 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("UnmuteIcon", "octicon octicon-unmute", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.563 2.069A.75.75 0 0 1 8 2.75v10.5a.751.751 0 0 1-1.238.57L3.472 11H1.75A1.75 1.75 0 0 1 0 9.25v-2.5C0 5.784.784 5 1.75 5h1.723l3.289-2.82a.75.75 0 0 1 .801-.111ZM6.5 4.38 4.238 6.319a.748.748 0 0 1-.488.181h-2a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2c.179 0 .352.064.488.18L6.5 11.62Zm6.096-2.038a.75.75 0 0 1 1.06 0 8 8 0 0 1 0 11.314.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042 6.5 6.5 0 0 0 0-9.193.75.75 0 0 1 0-1.06Zm-1.06 2.121-.001.001a5 5 0 0 1 0 7.07.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734 3.5 3.5 0 0 0 0-4.95.75.75 0 1 1 1.061-1.061Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.553 3.064A.75.75 0 0 1 12 3.75v16.5a.75.75 0 0 1-1.255.555L5.46 16H2.75A1.75 1.75 0 0 1 1 14.25v-4.5C1 8.784 1.784 8 2.75 8h2.71l5.285-4.805a.752.752 0 0 1 .808-.13ZM10.5 5.445l-4.245 3.86a.748.748 0 0 1-.505.195h-3a.25.25 0 0 0-.25.25v4.5c0 .138.112.25.25.25h3c.187 0 .367.069.505.195l4.245 3.86Zm8.218-1.223a.75.75 0 0 1 1.06 0c4.296 4.296 4.296 11.26 0 15.556a.75.75 0 0 1-1.06-1.06 9.5 9.5 0 0 0 0-13.436.75.75 0 0 1 0-1.06Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M16.243 7.757a.75.75 0 1 0-1.061 1.061 4.5 4.5 0 0 1 0 6.364.75.75 0 0 0 1.06 1.06 6 6 0 0 0 0-8.485Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$65442da726e1dd57 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("UnreadIcon", "octicon octicon-unread", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.5 3.5H1.75a.25.25 0 0 0-.25.25v.32L8 7.88l3.02-1.77a.75.75 0 0 1 .758 1.295L8.379 9.397a.75.75 0 0 1-.758 0L1.5 5.809v6.441c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-4.5a.75.75 0 0 1 1.5 0v4.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25V4.513a.75.75 0 0 1 0-.027V3.75C0 2.784.784 2 1.75 2h8.75a.75.75 0 0 1 0 1.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M14 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.75 4.5a.25.25 0 0 0-.25.25v.852l10.36 7a.25.25 0 0 0 .28 0l5.69-3.845A.75.75 0 0 1 18.67 10l-5.69 3.845c-.592.4-1.368.4-1.96 0L1.5 7.412V19.25c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25v-8.5a.75.75 0 0 1 1.5 0v8.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25V4.75C0 3.784.784 3 1.75 3h15.5a.75.75 0 0 1 0 1.5H1.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M24 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$f41d6ce12454a717 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("UnverifiedIcon", "octicon octicon-unverified", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6.415.52a2.677 2.677 0 0 1 3.17 0l.928.68c.153.113.33.186.518.215l1.138.175a2.678 2.678 0 0 1 2.241 2.24l.175 1.138c.029.187.102.365.215.518l.68.928a2.677 2.677 0 0 1 0 3.17l-.68.928a1.186 1.186 0 0 0-.215.518l-.175 1.138a2.678 2.678 0 0 1-2.241 2.241l-1.138.175a1.186 1.186 0 0 0-.518.215l-.928.68a2.677 2.677 0 0 1-3.17 0l-.928-.68a1.186 1.186 0 0 0-.518-.215L3.83 14.41a2.678 2.678 0 0 1-2.24-2.24l-.175-1.138a1.186 1.186 0 0 0-.215-.518l-.68-.928a2.677 2.677 0 0 1 0-3.17l.68-.928a1.17 1.17 0 0 0 .215-.518l.175-1.14a2.678 2.678 0 0 1 2.24-2.24l1.138-.175c.187-.029.365-.102.518-.215l.928-.68Zm2.282 1.209a1.18 1.18 0 0 0-1.394 0l-.928.68a2.67 2.67 0 0 1-1.18.489l-1.136.174a1.18 1.18 0 0 0-.987.987l-.174 1.137a2.67 2.67 0 0 1-.489 1.18l-.68.927c-.305.415-.305.98 0 1.394l.68.928c.256.348.423.752.489 1.18l.174 1.136c.078.51.478.909.987.987l1.137.174c.427.066.831.233 1.18.489l.927.68c.415.305.98.305 1.394 0l.928-.68a2.67 2.67 0 0 1 1.18-.489l1.136-.174c.51-.078.909-.478.987-.987l.174-1.137c.066-.427.233-.831.489-1.18l.68-.927c.305-.415.305-.98 0-1.394l-.68-.928a2.67 2.67 0 0 1-.489-1.18l-.174-1.136a1.18 1.18 0 0 0-.987-.987l-1.137-.174a2.67 2.67 0 0 1-1.18-.489ZM6.92 6.085h.001a.75.75 0 0 1-1.342-.67c.169-.339.436-.701.849-.977C6.846 4.16 7.369 4 8 4a2.76 2.76 0 0 1 1.638.525c.502.377.862.965.862 1.725 0 .448-.115.83-.329 1.15-.205.307-.47.513-.692.662-.109.072-.22.138-.313.195l-.006.004a6.24 6.24 0 0 0-.26.16.952.952 0 0 0-.276.245.75.75 0 0 1-1.248-.832c.184-.264.42-.489.692-.661.109-.073.22-.139.313-.195l.007-.004c.1-.061.182-.11.258-.161a.969.969 0 0 0 .277-.245C8.96 6.514 9 6.427 9 6.25a.612.612 0 0 0-.262-.525A1.27 1.27 0 0 0 8 5.5c-.369 0-.595.09-.74.187a1.01 1.01 0 0 0-.34.398ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M13 16.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-2.517-7.665c.112-.223.268-.424.488-.57C11.186 8.12 11.506 8 12 8c.384 0 .766.118 1.034.319a.953.953 0 0 1 .403.806c0 .48-.218.81-.62 1.186a9.293 9.293 0 0 1-.409.354 19.8 19.8 0 0 0-.294.249c-.246.213-.524.474-.738.795l-.126.19V13.5a.75.75 0 0 0 1.5 0v-1.12c.09-.1.203-.208.347-.333.063-.055.14-.119.222-.187.166-.14.358-.3.52-.452.536-.5 1.098-1.2 1.098-2.283a2.45 2.45 0 0 0-1.003-2.006C13.37 6.695 12.658 6.5 12 6.5c-.756 0-1.373.191-1.861.517a2.944 2.944 0 0 0-.997 1.148.75.75 0 0 0 1.341.67Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.864 1.2a3.61 3.61 0 0 1 4.272 0l1.375 1.01c.274.2.593.333.929.384l1.686.259a3.61 3.61 0 0 1 3.021 3.02l.259 1.687c.051.336.183.655.384.929l1.01 1.375a3.61 3.61 0 0 1 0 4.272l-1.01 1.375a2.106 2.106 0 0 0-.384.929l-.259 1.686a3.61 3.61 0 0 1-3.02 3.021l-1.687.259a2.106 2.106 0 0 0-.929.384l-1.375 1.01a3.61 3.61 0 0 1-4.272 0l-1.375-1.01a2.106 2.106 0 0 0-.929-.384l-1.686-.259a3.61 3.61 0 0 1-3.021-3.02l-.259-1.687a2.106 2.106 0 0 0-.384-.929L1.2 14.136a3.61 3.61 0 0 1 0-4.272l1.01-1.375c.201-.274.333-.593.384-.929l.259-1.686a3.61 3.61 0 0 1 3.02-3.021l1.687-.259c.336-.051.655-.183.929-.384Zm3.384 1.209a2.11 2.11 0 0 0-2.496 0l-1.376 1.01a3.61 3.61 0 0 1-1.589.658l-1.686.258a2.111 2.111 0 0 0-1.766 1.766l-.258 1.686a3.614 3.614 0 0 1-.658 1.59l-1.01 1.375a2.11 2.11 0 0 0 0 2.496l1.01 1.376a3.61 3.61 0 0 1 .658 1.589l.258 1.686a2.11 2.11 0 0 0 1.766 1.765l1.686.26a3.613 3.613 0 0 1 1.59.657l1.375 1.01a2.11 2.11 0 0 0 2.496 0l1.376-1.01a3.61 3.61 0 0 1 1.589-.658l1.686-.258a2.11 2.11 0 0 0 1.765-1.766l.26-1.686a3.613 3.613 0 0 1 .657-1.59l1.01-1.375a2.11 2.11 0 0 0 0-2.496l-1.01-1.376a3.61 3.61 0 0 1-.658-1.589l-.258-1.686a2.111 2.111 0 0 0-1.766-1.766l-1.686-.258a3.614 3.614 0 0 1-1.59-.658Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$8df90684a752ef81 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("UploadIcon", "octicon octicon-upload", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.75 14A1.75 1.75 0 0 1 1 12.25v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 14Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M11.78 4.72a.749.749 0 1 1-1.06 1.06L8.75 3.811V9.5a.75.75 0 0 1-1.5 0V3.811L5.28 5.78a.749.749 0 1 1-1.06-1.06l3.25-3.25a.749.749 0 0 1 1.06 0l3.25 3.25Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4 20.25V18a.75.75 0 0 1 1.5 0v2.25c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V18a.75.75 0 0 1 1.5 0v2.25A1.75 1.75 0 0 1 18.25 22H5.75A1.75 1.75 0 0 1 4 20.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.22 9.53a.749.749 0 0 1 0-1.06l6.25-6.25a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 1 1-1.06 1.06l-4.97-4.969V16.75a.75.75 0 0 1-1.5 0V4.561L6.28 9.53a.749.749 0 0 1-1.06 0Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$bb5f9bdd1b41e5db = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("VerifiedIcon", "octicon octicon-verified", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m9.585.52.929.68c.153.112.331.186.518.215l1.138.175a2.678 2.678 0 0 1 2.24 2.24l.174 1.139c.029.187.103.365.215.518l.68.928a2.677 2.677 0 0 1 0 3.17l-.68.928a1.174 1.174 0 0 0-.215.518l-.175 1.138a2.678 2.678 0 0 1-2.241 2.241l-1.138.175a1.17 1.17 0 0 0-.518.215l-.928.68a2.677 2.677 0 0 1-3.17 0l-.928-.68a1.174 1.174 0 0 0-.518-.215L3.83 14.41a2.678 2.678 0 0 1-2.24-2.24l-.175-1.138a1.17 1.17 0 0 0-.215-.518l-.68-.928a2.677 2.677 0 0 1 0-3.17l.68-.928c.112-.153.186-.331.215-.518l.175-1.14a2.678 2.678 0 0 1 2.24-2.24l1.139-.175c.187-.029.365-.103.518-.215l.928-.68a2.677 2.677 0 0 1 3.17 0ZM7.303 1.728l-.927.68a2.67 2.67 0 0 1-1.18.489l-1.137.174a1.179 1.179 0 0 0-.987.987l-.174 1.136a2.677 2.677 0 0 1-.489 1.18l-.68.928a1.18 1.18 0 0 0 0 1.394l.68.927c.256.348.424.753.489 1.18l.174 1.137c.078.509.478.909.987.987l1.136.174a2.67 2.67 0 0 1 1.18.489l.928.68c.414.305.979.305 1.394 0l.927-.68a2.67 2.67 0 0 1 1.18-.489l1.137-.174a1.18 1.18 0 0 0 .987-.987l.174-1.136a2.67 2.67 0 0 1 .489-1.18l.68-.928a1.176 1.176 0 0 0 0-1.394l-.68-.927a2.686 2.686 0 0 1-.489-1.18l-.174-1.137a1.179 1.179 0 0 0-.987-.987l-1.136-.174a2.677 2.677 0 0 1-1.18-.489l-.928-.68a1.176 1.176 0 0 0-1.394 0ZM11.28 6.78l-3.75 3.75a.75.75 0 0 1-1.06 0L4.72 8.78a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L7 8.94l3.22-3.22a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M17.03 9.78a.75.75 0 0 0-1.06-1.06l-5.47 5.47-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6-6Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "m14.136 1.2 1.375 1.01c.274.201.593.333.929.384l1.687.259a3.61 3.61 0 0 1 3.02 3.021l.259 1.686c.051.336.183.655.384.929l1.01 1.375a3.61 3.61 0 0 1 0 4.272l-1.01 1.375a2.106 2.106 0 0 0-.384.929l-.259 1.687a3.61 3.61 0 0 1-3.021 3.02l-1.686.259a2.106 2.106 0 0 0-.929.384l-1.375 1.01a3.61 3.61 0 0 1-4.272 0l-1.375-1.01a2.106 2.106 0 0 0-.929-.384l-1.687-.259a3.61 3.61 0 0 1-3.02-3.021l-.259-1.686a2.117 2.117 0 0 0-.384-.929L1.2 14.136a3.61 3.61 0 0 1 0-4.272l1.01-1.375c.201-.274.333-.593.384-.929l.259-1.687a3.61 3.61 0 0 1 3.021-3.02l1.686-.259c.336-.051.655-.183.929-.384L9.864 1.2a3.61 3.61 0 0 1 4.272 0Zm-3.384 1.209-1.375 1.01a3.614 3.614 0 0 1-1.59.658l-1.686.258a2.111 2.111 0 0 0-1.766 1.766l-.258 1.686a3.61 3.61 0 0 1-.658 1.589l-1.01 1.376a2.11 2.11 0 0 0 0 2.496l1.01 1.375c.344.469.57 1.015.658 1.59l.258 1.686c.14.911.855 1.626 1.766 1.766l1.686.258a3.61 3.61 0 0 1 1.589.658l1.376 1.01a2.11 2.11 0 0 0 2.496 0l1.375-1.01a3.613 3.613 0 0 1 1.59-.657l1.686-.26a2.11 2.11 0 0 0 1.766-1.765l.258-1.686a3.61 3.61 0 0 1 .658-1.589l1.01-1.376a2.11 2.11 0 0 0 0-2.496l-1.01-1.375a3.613 3.613 0 0 1-.657-1.59l-.26-1.686a2.11 2.11 0 0 0-1.765-1.766l-1.686-.258a3.61 3.61 0 0 1-1.589-.658l-1.376-1.01a2.11 2.11 0 0 0-2.496 0Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$40e4d1cbca290dd9 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("VersionsIcon", "octicon octicon-versions", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.75 14A1.75 1.75 0 0 1 6 12.25v-8.5C6 2.784 6.784 2 7.75 2h6.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14Zm-.25-1.75c0 .138.112.25.25.25h6.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25h-6.5a.25.25 0 0 0-.25.25ZM4.9 3.508a.75.75 0 0 1-.274 1.025.249.249 0 0 0-.126.217v6.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.75 1.75 0 0 1 3 11.25v-6.5c0-.649.353-1.214.874-1.516a.75.75 0 0 1 1.025.274ZM1.625 5.533h.001a.249.249 0 0 0-.126.217v4.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.748 1.748 0 0 1 0 10.25v-4.5a1.748 1.748 0 0 1 .873-1.516.75.75 0 1 1 .752 1.299Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2Zm-.5-2a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H10a.5.5 0 0 0-.5.5ZM6.17 4.165a.75.75 0 0 1-.335 1.006c-.228.114-.295.177-.315.201a.035.035 0 0 0-.008.016.423.423 0 0 0-.012.112v13c0 .07.008.102.012.112a.03.03 0 0 0 .008.016c.02.024.087.087.315.201a.749.749 0 1 1-.67 1.342c-.272-.136-.58-.315-.81-.598C4.1 19.259 4 18.893 4 18.5v-13c0-.393.1-.759.355-1.073.23-.283.538-.462.81-.598a.75.75 0 0 1 1.006.336ZM2.15 5.624a.75.75 0 0 1-.274 1.025c-.15.087-.257.17-.32.245C1.5 6.96 1.5 6.99 1.5 7v10c0 .01 0 .04.056.106.063.074.17.158.32.245a.75.75 0 0 1-.752 1.298C.73 18.421 0 17.907 0 17V7c0-.907.73-1.42 1.124-1.65a.75.75 0 0 1 1.025.274Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$4ec8735ec23c8112 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("VideoIcon", "octicon octicon-video", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 3.75C0 2.784.784 2 1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M6 10.559V5.442a.25.25 0 0 1 .379-.215l4.264 2.559a.25.25 0 0 1 0 .428l-4.264 2.559A.25.25 0 0 1 6 10.559Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 4.75C0 3.784.784 3 1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V4.75a.25.25 0 0 0-.25-.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9 15.584V8.416a.5.5 0 0 1 .77-.42l5.576 3.583a.5.5 0 0 1 0 .842L9.77 16.005a.5.5 0 0 1-.77-.42Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$3c46f390a1e1dd55 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("WebhookIcon", "octicon octicon-webhook", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.5 4.25a2.25 2.25 0 0 1 4.5 0 .75.75 0 0 0 1.5 0 3.75 3.75 0 1 0-6.14 2.889l-2.272 4.258a.75.75 0 0 0 1.324.706L7 7.25a.75.75 0 0 0-.309-1.015A2.25 2.25 0 0 1 5.5 4.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.364 3.607a.75.75 0 0 1 1.03.257l2.608 4.349a3.75 3.75 0 1 1-.628 6.785.75.75 0 0 1 .752-1.299 2.25 2.25 0 1 0-.033-3.88.75.75 0 0 1-1.03-.256L7.107 4.636a.75.75 0 0 1 .257-1.03Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.9 8.776A.75.75 0 0 1 2.625 9.8 2.25 2.25 0 1 0 6 11.75a.75.75 0 0 1 .75-.751h5.5a.75.75 0 0 1 0 1.5H7.425a3.751 3.751 0 1 1-5.55-3.998.75.75 0 0 1 1.024.274Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$e168ed240d9b8ab4 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("WorkflowIcon", "octicon octicon-workflow", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h3.5C6.216 0 7 .784 7 1.75v3.5A1.75 1.75 0 0 1 5.25 7H4v4a1 1 0 0 0 1 1h4v-1.25C9 9.784 9.784 9 10.75 9h3.5c.966 0 1.75.784 1.75 1.75v3.5A1.75 1.75 0 0 1 14.25 16h-3.5A1.75 1.75 0 0 1 9 14.25v-.75H5A2.5 2.5 0 0 1 2.5 11V7h-.75A1.75 1.75 0 0 1 0 5.25Zm1.75-.25a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25Zm9 9a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 3a2 2 0 0 1 2-2h6.5a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2H7v4.063C7 16.355 7.644 17 8.438 17H12.5v-2.5a2 2 0 0 1 2-2H21a2 2 0 0 1 2 2V21a2 2 0 0 1-2 2h-6.5a2 2 0 0 1-2-2v-2.5H8.437A2.939 2.939 0 0 1 5.5 15.562V11.5H3a2 2 0 0 1-2-2Zm2-.5a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h6.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5ZM14.5 14a.5.5 0 0 0-.5.5V21a.5.5 0 0 0 .5.5H21a.5.5 0 0 0 .5-.5v-6.5a.5.5 0 0 0-.5-.5Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$5e658a8851ae9322 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("XIcon", "octicon octicon-x", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.72 3.72a.75.75 0 0 1 1.06 0L8 6.94l3.22-3.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 8l3.22 3.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 9.06l-3.22 3.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L6.94 8 3.72 4.78a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M5.72 5.72a.75.75 0 0 1 1.06 0L12 10.94l5.22-5.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L13.06 12l5.22 5.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L12 13.06l-5.22 5.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L10.94 12 5.72 6.78a.75.75 0 0 1 0-1.06Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$a5090bbd7fc88fde = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("XCircleIcon", "octicon octicon-x-circle", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.344 2.343h-.001a8 8 0 0 1 11.314 11.314A8.002 8.002 0 0 1 .234 10.089a8 8 0 0 1 2.11-7.746Zm1.06 10.253a6.5 6.5 0 1 0 9.108-9.275 6.5 6.5 0 0 0-9.108 9.275ZM6.03 4.97 8 6.94l1.97-1.97a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 8l1.97 1.97a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 9.06l-1.97 1.97a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L6.94 8 4.97 6.03a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.036 7.976a.75.75 0 0 0-1.06 1.06L10.939 12l-2.963 2.963a.75.75 0 1 0 1.06 1.06L12 13.06l2.963 2.964a.75.75 0 0 0 1.061-1.06L13.061 12l2.963-2.964a.75.75 0 1 0-1.06-1.06L12 10.939 9.036 7.976Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$70fa3c998d3a2ac8 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("XCircleFillIcon", "octicon octicon-x-circle-fill", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1.757 10.243a6.001 6.001 0 1 1 8.488-8.486 6.001 6.001 0 0 1-8.488 8.486ZM6 4.763l-2-2L2.763 4l2 2-2 2L4 9.237l2-2 2 2L9.237 8l-2-2 2-2L8 2.763Z"
            })
        },
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M2.343 13.657A8 8 0 1 1 13.658 2.343 8 8 0 0 1 2.343 13.657ZM6.03 4.97a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042L6.94 8 4.97 9.97a.749.749 0 0 0 .326 1.275.749.749 0 0 0 .734-.215L8 9.06l1.97 1.97a.749.749 0 0 0 1.275-.326.749.749 0 0 0-.215-.734L9.06 8l1.97-1.97a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215L8 6.94Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm8.036-4.024a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042L10.939 12l-2.963 2.963a.749.749 0 0 0 .326 1.275.749.749 0 0 0 .734-.215L12 13.06l2.963 2.964a.75.75 0 0 0 1.061-1.06L13.061 12l2.963-2.964a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215L12 10.939Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$8cd5177e02a3dea2 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ZapIcon", "octicon octicon-zap", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M9.504.43a1.516 1.516 0 0 1 2.437 1.713L10.415 5.5h2.123c1.57 0 2.346 1.909 1.22 3.004l-7.34 7.142a1.249 1.249 0 0 1-.871.354h-.302a1.25 1.25 0 0 1-1.157-1.723L5.633 10.5H3.462c-1.57 0-2.346-1.909-1.22-3.004L9.503.429Zm1.047 1.074L3.286 8.571A.25.25 0 0 0 3.462 9H6.75a.75.75 0 0 1 .694 1.034l-1.713 4.188 6.982-6.793A.25.25 0 0 0 12.538 7H9.25a.75.75 0 0 1-.683-1.06l2.008-4.418.003-.006a.036.036 0 0 0-.004-.009l-.006-.006-.008-.001c-.003 0-.006.002-.009.004Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M15.716 1.329a1.341 1.341 0 0 1 2.109 1.55L15.147 9h4.161c1.623 0 2.372 2.016 1.143 3.075L8.102 22.721a1.148 1.148 0 0 1-1.81-1.317L8.996 15H4.674c-1.619 0-2.37-2.008-1.148-3.07l12.19-10.6Zm.452 1.595L4.51 13.061a.25.25 0 0 0 .164.439h5.45a.749.749 0 0 1 .692 1.041l-2.559 6.066 11.215-9.668a.25.25 0 0 0-.164-.439H14a.75.75 0 0 1-.687-1.05Z"
            })
        }
    };
});
var $35f760dc3fc04eda$export$418cedbcfc990387 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ZoomInIcon", "octicon octicon-zoom-in", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M3.75 7.5a.75.75 0 0 1 .75-.75h2.25V4.5a.75.75 0 0 1 1.5 0v2.25h2.25a.75.75 0 0 1 0 1.5H8.25v2.25a.75.75 0 0 1-1.5 0V8.25H4.5a.75.75 0 0 1-.75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M7.5 0a7.5 7.5 0 0 1 5.807 12.247l2.473 2.473a.749.749 0 1 1-1.06 1.06l-2.473-2.473A7.5 7.5 0 1 1 7.5 0Zm-6 7.5a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M10.5 5.75a.75.75 0 0 1 .75.75v3.25h3.25a.75.75 0 0 1 0 1.5h-3.25v3.25a.75.75 0 0 1-1.5 0v-3.25H6.5a.75.75 0 0 1 0-1.5h3.25V6.5a.75.75 0 0 1 .75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 10.5C0 4.701 4.701 0 10.5 0S21 4.701 21 10.5c0 2.63-.967 5.033-2.564 6.875l4.344 4.345a.749.749 0 1 1-1.06 1.06l-4.345-4.344A10.459 10.459 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5Zm10.5-9a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$export$fbd55a4c69e8e024 = /*#__PURE__*/ $35f760dc3fc04eda$var$createIconComponent("ZoomOutIcon", "octicon octicon-zoom-out", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M4.5 6.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 7.5a7.5 7.5 0 1 1 13.307 4.747l2.473 2.473a.749.749 0 1 1-1.06 1.06l-2.473-2.473A7.5 7.5 0 0 1 0 7.5Zm7.5-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M14.5 11.25a.75.75 0 0 0 0-1.5h-8a.75.75 0 0 0 0 1.5h8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("path", {
                d: "M0 10.5C0 4.701 4.701 0 10.5 0S21 4.701 21 10.5c0 2.63-.967 5.033-2.564 6.875l4.344 4.345a.749.749 0 1 1-1.06 1.06l-4.345-4.344A10.459 10.459 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5Zm10.5-9a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9Z"
            }))
        }
    };
});
var $35f760dc3fc04eda$var$_excluded = [
    "icon",
    "children"
];
function $35f760dc3fc04eda$export$2e2bcd8739ae039(_ref) {
    var Icon = _ref.icon, children = _ref.children, props = $35f760dc3fc04eda$var$_objectWithoutProperties(_ref, $35f760dc3fc04eda$var$_excluded);
    // eslint-disable-next-line no-console
    console.warn("<Octicon> is deprecated. Use icon components on their own instead (e.g. <Octicon icon={AlertIcon} /> \u2192 <AlertIcon />)");
    return typeof Icon === "function" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement(Icon, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Children.only(children), props);
}


/**
 * Imports FontAwesome icons
 */ // "deep import" style to workaround a "Maximum call stack exceeded" issue
// that only happens with the `free-solid-svg-icons` package.
// for instance: https://github.com/FortAwesome/react-native-fontawesome/issues/123
var $431b81e4b3a34ca6$exports = {};
"use strict";
Object.defineProperty($431b81e4b3a34ca6$exports, "__esModule", {
    value: true
});
var $431b81e4b3a34ca6$var$prefix = "fas";
var $431b81e4b3a34ca6$var$iconName = "check";
var $431b81e4b3a34ca6$var$width = 448;
var $431b81e4b3a34ca6$var$height = 512;
var $431b81e4b3a34ca6$var$aliases = [
    10003,
    10004
];
var $431b81e4b3a34ca6$var$unicode = "f00c";
var $431b81e4b3a34ca6$var$svgPathData = "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z";
$431b81e4b3a34ca6$exports.definition = {
    prefix: $431b81e4b3a34ca6$var$prefix,
    iconName: $431b81e4b3a34ca6$var$iconName,
    icon: [
        $431b81e4b3a34ca6$var$width,
        $431b81e4b3a34ca6$var$height,
        $431b81e4b3a34ca6$var$aliases,
        $431b81e4b3a34ca6$var$unicode,
        $431b81e4b3a34ca6$var$svgPathData
    ]
};
$431b81e4b3a34ca6$exports.faCheck = $431b81e4b3a34ca6$exports.definition;
$431b81e4b3a34ca6$exports.prefix = $431b81e4b3a34ca6$var$prefix;
$431b81e4b3a34ca6$exports.iconName = $431b81e4b3a34ca6$var$iconName;
$431b81e4b3a34ca6$exports.width = $431b81e4b3a34ca6$var$width;
$431b81e4b3a34ca6$exports.height = $431b81e4b3a34ca6$var$height;
$431b81e4b3a34ca6$exports.ligatures = $431b81e4b3a34ca6$var$aliases;
$431b81e4b3a34ca6$exports.unicode = $431b81e4b3a34ca6$var$unicode;
$431b81e4b3a34ca6$exports.svgPathData = $431b81e4b3a34ca6$var$svgPathData;
$431b81e4b3a34ca6$exports.aliases = $431b81e4b3a34ca6$var$aliases;


var $2fe3a9c513cf47d2$exports = {};
"use strict";
Object.defineProperty($2fe3a9c513cf47d2$exports, "__esModule", {
    value: true
});
var $2fe3a9c513cf47d2$var$prefix = "fas";
var $2fe3a9c513cf47d2$var$iconName = "minus";
var $2fe3a9c513cf47d2$var$width = 448;
var $2fe3a9c513cf47d2$var$height = 512;
var $2fe3a9c513cf47d2$var$aliases = [
    8211,
    8722,
    10134,
    "subtract"
];
var $2fe3a9c513cf47d2$var$unicode = "f068";
var $2fe3a9c513cf47d2$var$svgPathData = "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z";
$2fe3a9c513cf47d2$exports.definition = {
    prefix: $2fe3a9c513cf47d2$var$prefix,
    iconName: $2fe3a9c513cf47d2$var$iconName,
    icon: [
        $2fe3a9c513cf47d2$var$width,
        $2fe3a9c513cf47d2$var$height,
        $2fe3a9c513cf47d2$var$aliases,
        $2fe3a9c513cf47d2$var$unicode,
        $2fe3a9c513cf47d2$var$svgPathData
    ]
};
$2fe3a9c513cf47d2$exports.faMinus = $2fe3a9c513cf47d2$exports.definition;
$2fe3a9c513cf47d2$exports.prefix = $2fe3a9c513cf47d2$var$prefix;
$2fe3a9c513cf47d2$exports.iconName = $2fe3a9c513cf47d2$var$iconName;
$2fe3a9c513cf47d2$exports.width = $2fe3a9c513cf47d2$var$width;
$2fe3a9c513cf47d2$exports.height = $2fe3a9c513cf47d2$var$height;
$2fe3a9c513cf47d2$exports.ligatures = $2fe3a9c513cf47d2$var$aliases;
$2fe3a9c513cf47d2$exports.unicode = $2fe3a9c513cf47d2$var$unicode;
$2fe3a9c513cf47d2$exports.svgPathData = $2fe3a9c513cf47d2$var$svgPathData;
$2fe3a9c513cf47d2$exports.aliases = $2fe3a9c513cf47d2$var$aliases;


var $fd6e980ce23de01c$exports = {};
"use strict";
Object.defineProperty($fd6e980ce23de01c$exports, "__esModule", {
    value: true
});
var $fd6e980ce23de01c$var$prefix = "fas";
var $fd6e980ce23de01c$var$iconName = "plus";
var $fd6e980ce23de01c$var$width = 448;
var $fd6e980ce23de01c$var$height = 512;
var $fd6e980ce23de01c$var$aliases = [
    10133,
    61543,
    "add"
];
var $fd6e980ce23de01c$var$unicode = "2b";
var $fd6e980ce23de01c$var$svgPathData = "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z";
$fd6e980ce23de01c$exports.definition = {
    prefix: $fd6e980ce23de01c$var$prefix,
    iconName: $fd6e980ce23de01c$var$iconName,
    icon: [
        $fd6e980ce23de01c$var$width,
        $fd6e980ce23de01c$var$height,
        $fd6e980ce23de01c$var$aliases,
        $fd6e980ce23de01c$var$unicode,
        $fd6e980ce23de01c$var$svgPathData
    ]
};
$fd6e980ce23de01c$exports.faPlus = $fd6e980ce23de01c$exports.definition;
$fd6e980ce23de01c$exports.prefix = $fd6e980ce23de01c$var$prefix;
$fd6e980ce23de01c$exports.iconName = $fd6e980ce23de01c$var$iconName;
$fd6e980ce23de01c$exports.width = $fd6e980ce23de01c$var$width;
$fd6e980ce23de01c$exports.height = $fd6e980ce23de01c$var$height;
$fd6e980ce23de01c$exports.ligatures = $fd6e980ce23de01c$var$aliases;
$fd6e980ce23de01c$exports.unicode = $fd6e980ce23de01c$var$unicode;
$fd6e980ce23de01c$exports.svgPathData = $fd6e980ce23de01c$var$svgPathData;
$fd6e980ce23de01c$exports.aliases = $fd6e980ce23de01c$var$aliases;


var $a148c1a3fa332410$exports = {};
"use strict";
Object.defineProperty($a148c1a3fa332410$exports, "__esModule", {
    value: true
});
var $a148c1a3fa332410$var$prefix = "fas";
var $a148c1a3fa332410$var$iconName = "chevron-right";
var $a148c1a3fa332410$var$width = 320;
var $a148c1a3fa332410$var$height = 512;
var $a148c1a3fa332410$var$aliases = [
    9002
];
var $a148c1a3fa332410$var$unicode = "f054";
var $a148c1a3fa332410$var$svgPathData = "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z";
$a148c1a3fa332410$exports.definition = {
    prefix: $a148c1a3fa332410$var$prefix,
    iconName: $a148c1a3fa332410$var$iconName,
    icon: [
        $a148c1a3fa332410$var$width,
        $a148c1a3fa332410$var$height,
        $a148c1a3fa332410$var$aliases,
        $a148c1a3fa332410$var$unicode,
        $a148c1a3fa332410$var$svgPathData
    ]
};
$a148c1a3fa332410$exports.faChevronRight = $a148c1a3fa332410$exports.definition;
$a148c1a3fa332410$exports.prefix = $a148c1a3fa332410$var$prefix;
$a148c1a3fa332410$exports.iconName = $a148c1a3fa332410$var$iconName;
$a148c1a3fa332410$exports.width = $a148c1a3fa332410$var$width;
$a148c1a3fa332410$exports.height = $a148c1a3fa332410$var$height;
$a148c1a3fa332410$exports.ligatures = $a148c1a3fa332410$var$aliases;
$a148c1a3fa332410$exports.unicode = $a148c1a3fa332410$var$unicode;
$a148c1a3fa332410$exports.svgPathData = $a148c1a3fa332410$var$svgPathData;
$a148c1a3fa332410$exports.aliases = $a148c1a3fa332410$var$aliases;


var $bca4ce04e29b08dc$exports = {};
"use strict";
Object.defineProperty($bca4ce04e29b08dc$exports, "__esModule", {
    value: true
});
var $bca4ce04e29b08dc$var$prefix = "fas";
var $bca4ce04e29b08dc$var$iconName = "chevron-left";
var $bca4ce04e29b08dc$var$width = 320;
var $bca4ce04e29b08dc$var$height = 512;
var $bca4ce04e29b08dc$var$aliases = [
    9001
];
var $bca4ce04e29b08dc$var$unicode = "f053";
var $bca4ce04e29b08dc$var$svgPathData = "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z";
$bca4ce04e29b08dc$exports.definition = {
    prefix: $bca4ce04e29b08dc$var$prefix,
    iconName: $bca4ce04e29b08dc$var$iconName,
    icon: [
        $bca4ce04e29b08dc$var$width,
        $bca4ce04e29b08dc$var$height,
        $bca4ce04e29b08dc$var$aliases,
        $bca4ce04e29b08dc$var$unicode,
        $bca4ce04e29b08dc$var$svgPathData
    ]
};
$bca4ce04e29b08dc$exports.faChevronLeft = $bca4ce04e29b08dc$exports.definition;
$bca4ce04e29b08dc$exports.prefix = $bca4ce04e29b08dc$var$prefix;
$bca4ce04e29b08dc$exports.iconName = $bca4ce04e29b08dc$var$iconName;
$bca4ce04e29b08dc$exports.width = $bca4ce04e29b08dc$var$width;
$bca4ce04e29b08dc$exports.height = $bca4ce04e29b08dc$var$height;
$bca4ce04e29b08dc$exports.ligatures = $bca4ce04e29b08dc$var$aliases;
$bca4ce04e29b08dc$exports.unicode = $bca4ce04e29b08dc$var$unicode;
$bca4ce04e29b08dc$exports.svgPathData = $bca4ce04e29b08dc$var$svgPathData;
$bca4ce04e29b08dc$exports.aliases = $bca4ce04e29b08dc$var$aliases;


var $e0038dd4562b915b$exports = {};
"use strict";
Object.defineProperty($e0038dd4562b915b$exports, "__esModule", {
    value: true
});
var $e0038dd4562b915b$var$prefix = "fas";
var $e0038dd4562b915b$var$iconName = "arrow-right";
var $e0038dd4562b915b$var$width = 448;
var $e0038dd4562b915b$var$height = 512;
var $e0038dd4562b915b$var$aliases = [
    8594
];
var $e0038dd4562b915b$var$unicode = "f061";
var $e0038dd4562b915b$var$svgPathData = "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z";
$e0038dd4562b915b$exports.definition = {
    prefix: $e0038dd4562b915b$var$prefix,
    iconName: $e0038dd4562b915b$var$iconName,
    icon: [
        $e0038dd4562b915b$var$width,
        $e0038dd4562b915b$var$height,
        $e0038dd4562b915b$var$aliases,
        $e0038dd4562b915b$var$unicode,
        $e0038dd4562b915b$var$svgPathData
    ]
};
$e0038dd4562b915b$exports.faArrowRight = $e0038dd4562b915b$exports.definition;
$e0038dd4562b915b$exports.prefix = $e0038dd4562b915b$var$prefix;
$e0038dd4562b915b$exports.iconName = $e0038dd4562b915b$var$iconName;
$e0038dd4562b915b$exports.width = $e0038dd4562b915b$var$width;
$e0038dd4562b915b$exports.height = $e0038dd4562b915b$var$height;
$e0038dd4562b915b$exports.ligatures = $e0038dd4562b915b$var$aliases;
$e0038dd4562b915b$exports.unicode = $e0038dd4562b915b$var$unicode;
$e0038dd4562b915b$exports.svgPathData = $e0038dd4562b915b$var$svgPathData;
$e0038dd4562b915b$exports.aliases = $e0038dd4562b915b$var$aliases;


var $436349c781cb8ff4$exports = {};
"use strict";
Object.defineProperty($436349c781cb8ff4$exports, "__esModule", {
    value: true
});
var $436349c781cb8ff4$var$prefix = "fas";
var $436349c781cb8ff4$var$iconName = "arrow-left";
var $436349c781cb8ff4$var$width = 448;
var $436349c781cb8ff4$var$height = 512;
var $436349c781cb8ff4$var$aliases = [
    8592
];
var $436349c781cb8ff4$var$unicode = "f060";
var $436349c781cb8ff4$var$svgPathData = "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z";
$436349c781cb8ff4$exports.definition = {
    prefix: $436349c781cb8ff4$var$prefix,
    iconName: $436349c781cb8ff4$var$iconName,
    icon: [
        $436349c781cb8ff4$var$width,
        $436349c781cb8ff4$var$height,
        $436349c781cb8ff4$var$aliases,
        $436349c781cb8ff4$var$unicode,
        $436349c781cb8ff4$var$svgPathData
    ]
};
$436349c781cb8ff4$exports.faArrowLeft = $436349c781cb8ff4$exports.definition;
$436349c781cb8ff4$exports.prefix = $436349c781cb8ff4$var$prefix;
$436349c781cb8ff4$exports.iconName = $436349c781cb8ff4$var$iconName;
$436349c781cb8ff4$exports.width = $436349c781cb8ff4$var$width;
$436349c781cb8ff4$exports.height = $436349c781cb8ff4$var$height;
$436349c781cb8ff4$exports.ligatures = $436349c781cb8ff4$var$aliases;
$436349c781cb8ff4$exports.unicode = $436349c781cb8ff4$var$unicode;
$436349c781cb8ff4$exports.svgPathData = $436349c781cb8ff4$var$svgPathData;
$436349c781cb8ff4$exports.aliases = $436349c781cb8ff4$var$aliases;


var $ac21c2336b784bd5$exports = {};
"use strict";
Object.defineProperty($ac21c2336b784bd5$exports, "__esModule", {
    value: true
});
var $ac21c2336b784bd5$var$prefix = "fas";
var $ac21c2336b784bd5$var$iconName = "arrow-rotate-left";
var $ac21c2336b784bd5$var$width = 512;
var $ac21c2336b784bd5$var$height = 512;
var $ac21c2336b784bd5$var$aliases = [
    8634,
    "arrow-left-rotate",
    "arrow-rotate-back",
    "arrow-rotate-backward",
    "undo"
];
var $ac21c2336b784bd5$var$unicode = "f0e2";
var $ac21c2336b784bd5$var$svgPathData = "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z";
$ac21c2336b784bd5$exports.definition = {
    prefix: $ac21c2336b784bd5$var$prefix,
    iconName: $ac21c2336b784bd5$var$iconName,
    icon: [
        $ac21c2336b784bd5$var$width,
        $ac21c2336b784bd5$var$height,
        $ac21c2336b784bd5$var$aliases,
        $ac21c2336b784bd5$var$unicode,
        $ac21c2336b784bd5$var$svgPathData
    ]
};
$ac21c2336b784bd5$exports.faArrowRotateLeft = $ac21c2336b784bd5$exports.definition;
$ac21c2336b784bd5$exports.prefix = $ac21c2336b784bd5$var$prefix;
$ac21c2336b784bd5$exports.iconName = $ac21c2336b784bd5$var$iconName;
$ac21c2336b784bd5$exports.width = $ac21c2336b784bd5$var$width;
$ac21c2336b784bd5$exports.height = $ac21c2336b784bd5$var$height;
$ac21c2336b784bd5$exports.ligatures = $ac21c2336b784bd5$var$aliases;
$ac21c2336b784bd5$exports.unicode = $ac21c2336b784bd5$var$unicode;
$ac21c2336b784bd5$exports.svgPathData = $ac21c2336b784bd5$var$svgPathData;
$ac21c2336b784bd5$exports.aliases = $ac21c2336b784bd5$var$aliases;


var $415249e817138a15$exports = {};
"use strict";
Object.defineProperty($415249e817138a15$exports, "__esModule", {
    value: true
});
var $415249e817138a15$var$prefix = "fas";
var $415249e817138a15$var$iconName = "arrow-rotate-right";
var $415249e817138a15$var$width = 512;
var $415249e817138a15$var$height = 512;
var $415249e817138a15$var$aliases = [
    8635,
    "arrow-right-rotate",
    "arrow-rotate-forward",
    "redo"
];
var $415249e817138a15$var$unicode = "f01e";
var $415249e817138a15$var$svgPathData = "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z";
$415249e817138a15$exports.definition = {
    prefix: $415249e817138a15$var$prefix,
    iconName: $415249e817138a15$var$iconName,
    icon: [
        $415249e817138a15$var$width,
        $415249e817138a15$var$height,
        $415249e817138a15$var$aliases,
        $415249e817138a15$var$unicode,
        $415249e817138a15$var$svgPathData
    ]
};
$415249e817138a15$exports.faArrowRotateRight = $415249e817138a15$exports.definition;
$415249e817138a15$exports.prefix = $415249e817138a15$var$prefix;
$415249e817138a15$exports.iconName = $415249e817138a15$var$iconName;
$415249e817138a15$exports.width = $415249e817138a15$var$width;
$415249e817138a15$exports.height = $415249e817138a15$var$height;
$415249e817138a15$exports.ligatures = $415249e817138a15$var$aliases;
$415249e817138a15$exports.unicode = $415249e817138a15$var$unicode;
$415249e817138a15$exports.svgPathData = $415249e817138a15$var$svgPathData;
$415249e817138a15$exports.aliases = $415249e817138a15$var$aliases;


var $55acb4ecd250c8b9$exports = {};
"use strict";
Object.defineProperty($55acb4ecd250c8b9$exports, "__esModule", {
    value: true
});
var $55acb4ecd250c8b9$var$prefix = "fas";
var $55acb4ecd250c8b9$var$iconName = "trash-can";
var $55acb4ecd250c8b9$var$width = 448;
var $55acb4ecd250c8b9$var$height = 512;
var $55acb4ecd250c8b9$var$aliases = [
    61460,
    "trash-alt"
];
var $55acb4ecd250c8b9$var$unicode = "f2ed";
var $55acb4ecd250c8b9$var$svgPathData = "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z";
$55acb4ecd250c8b9$exports.definition = {
    prefix: $55acb4ecd250c8b9$var$prefix,
    iconName: $55acb4ecd250c8b9$var$iconName,
    icon: [
        $55acb4ecd250c8b9$var$width,
        $55acb4ecd250c8b9$var$height,
        $55acb4ecd250c8b9$var$aliases,
        $55acb4ecd250c8b9$var$unicode,
        $55acb4ecd250c8b9$var$svgPathData
    ]
};
$55acb4ecd250c8b9$exports.faTrashCan = $55acb4ecd250c8b9$exports.definition;
$55acb4ecd250c8b9$exports.prefix = $55acb4ecd250c8b9$var$prefix;
$55acb4ecd250c8b9$exports.iconName = $55acb4ecd250c8b9$var$iconName;
$55acb4ecd250c8b9$exports.width = $55acb4ecd250c8b9$var$width;
$55acb4ecd250c8b9$exports.height = $55acb4ecd250c8b9$var$height;
$55acb4ecd250c8b9$exports.ligatures = $55acb4ecd250c8b9$var$aliases;
$55acb4ecd250c8b9$exports.unicode = $55acb4ecd250c8b9$var$unicode;
$55acb4ecd250c8b9$exports.svgPathData = $55acb4ecd250c8b9$var$svgPathData;
$55acb4ecd250c8b9$exports.aliases = $55acb4ecd250c8b9$var$aliases;


var $5b68f8d1088edca4$exports = {};
"use strict";
Object.defineProperty($5b68f8d1088edca4$exports, "__esModule", {
    value: true
});
var $5b68f8d1088edca4$var$prefix = "fas";
var $5b68f8d1088edca4$var$iconName = "screwdriver-wrench";
var $5b68f8d1088edca4$var$width = 512;
var $5b68f8d1088edca4$var$height = 512;
var $5b68f8d1088edca4$var$aliases = [
    "tools"
];
var $5b68f8d1088edca4$var$unicode = "f7d9";
var $5b68f8d1088edca4$var$svgPathData = "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h54.1l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109V104c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16V102.6c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z";
$5b68f8d1088edca4$exports.definition = {
    prefix: $5b68f8d1088edca4$var$prefix,
    iconName: $5b68f8d1088edca4$var$iconName,
    icon: [
        $5b68f8d1088edca4$var$width,
        $5b68f8d1088edca4$var$height,
        $5b68f8d1088edca4$var$aliases,
        $5b68f8d1088edca4$var$unicode,
        $5b68f8d1088edca4$var$svgPathData
    ]
};
$5b68f8d1088edca4$exports.faScrewdriverWrench = $5b68f8d1088edca4$exports.definition;
$5b68f8d1088edca4$exports.prefix = $5b68f8d1088edca4$var$prefix;
$5b68f8d1088edca4$exports.iconName = $5b68f8d1088edca4$var$iconName;
$5b68f8d1088edca4$exports.width = $5b68f8d1088edca4$var$width;
$5b68f8d1088edca4$exports.height = $5b68f8d1088edca4$var$height;
$5b68f8d1088edca4$exports.ligatures = $5b68f8d1088edca4$var$aliases;
$5b68f8d1088edca4$exports.unicode = $5b68f8d1088edca4$var$unicode;
$5b68f8d1088edca4$exports.svgPathData = $5b68f8d1088edca4$var$svgPathData;
$5b68f8d1088edca4$exports.aliases = $5b68f8d1088edca4$var$aliases;


var $7433a9a089759a34$exports = {};
"use strict";
Object.defineProperty($7433a9a089759a34$exports, "__esModule", {
    value: true
});
var $7433a9a089759a34$var$prefix = "fas";
var $7433a9a089759a34$var$iconName = "bolt";
var $7433a9a089759a34$var$width = 448;
var $7433a9a089759a34$var$height = 512;
var $7433a9a089759a34$var$aliases = [
    9889,
    "zap"
];
var $7433a9a089759a34$var$unicode = "f0e7";
var $7433a9a089759a34$var$svgPathData = "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z";
$7433a9a089759a34$exports.definition = {
    prefix: $7433a9a089759a34$var$prefix,
    iconName: $7433a9a089759a34$var$iconName,
    icon: [
        $7433a9a089759a34$var$width,
        $7433a9a089759a34$var$height,
        $7433a9a089759a34$var$aliases,
        $7433a9a089759a34$var$unicode,
        $7433a9a089759a34$var$svgPathData
    ]
};
$7433a9a089759a34$exports.faBolt = $7433a9a089759a34$exports.definition;
$7433a9a089759a34$exports.prefix = $7433a9a089759a34$var$prefix;
$7433a9a089759a34$exports.iconName = $7433a9a089759a34$var$iconName;
$7433a9a089759a34$exports.width = $7433a9a089759a34$var$width;
$7433a9a089759a34$exports.height = $7433a9a089759a34$var$height;
$7433a9a089759a34$exports.ligatures = $7433a9a089759a34$var$aliases;
$7433a9a089759a34$exports.unicode = $7433a9a089759a34$var$unicode;
$7433a9a089759a34$exports.svgPathData = $7433a9a089759a34$var$svgPathData;
$7433a9a089759a34$exports.aliases = $7433a9a089759a34$var$aliases;


var $1a9cdda55bab389c$exports = {};
"use strict";
Object.defineProperty($1a9cdda55bab389c$exports, "__esModule", {
    value: true
});
var $1a9cdda55bab389c$var$prefix = "fas";
var $1a9cdda55bab389c$var$iconName = "person";
var $1a9cdda55bab389c$var$width = 320;
var $1a9cdda55bab389c$var$height = 512;
var $1a9cdda55bab389c$var$aliases = [
    129485,
    "male"
];
var $1a9cdda55bab389c$var$unicode = "f183";
var $1a9cdda55bab389c$var$svgPathData = "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152z";
$1a9cdda55bab389c$exports.definition = {
    prefix: $1a9cdda55bab389c$var$prefix,
    iconName: $1a9cdda55bab389c$var$iconName,
    icon: [
        $1a9cdda55bab389c$var$width,
        $1a9cdda55bab389c$var$height,
        $1a9cdda55bab389c$var$aliases,
        $1a9cdda55bab389c$var$unicode,
        $1a9cdda55bab389c$var$svgPathData
    ]
};
$1a9cdda55bab389c$exports.faPerson = $1a9cdda55bab389c$exports.definition;
$1a9cdda55bab389c$exports.prefix = $1a9cdda55bab389c$var$prefix;
$1a9cdda55bab389c$exports.iconName = $1a9cdda55bab389c$var$iconName;
$1a9cdda55bab389c$exports.width = $1a9cdda55bab389c$var$width;
$1a9cdda55bab389c$exports.height = $1a9cdda55bab389c$var$height;
$1a9cdda55bab389c$exports.ligatures = $1a9cdda55bab389c$var$aliases;
$1a9cdda55bab389c$exports.unicode = $1a9cdda55bab389c$var$unicode;
$1a9cdda55bab389c$exports.svgPathData = $1a9cdda55bab389c$var$svgPathData;
$1a9cdda55bab389c$exports.aliases = $1a9cdda55bab389c$var$aliases;


var $beb41f2f74c84499$exports = {};
"use strict";
Object.defineProperty($beb41f2f74c84499$exports, "__esModule", {
    value: true
});
var $beb41f2f74c84499$var$prefix = "fas";
var $beb41f2f74c84499$var$iconName = "pencil";
var $beb41f2f74c84499$var$width = 512;
var $beb41f2f74c84499$var$height = 512;
var $beb41f2f74c84499$var$aliases = [
    9999,
    61504,
    "pencil-alt"
];
var $beb41f2f74c84499$var$unicode = "f303";
var $beb41f2f74c84499$var$svgPathData = "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z";
$beb41f2f74c84499$exports.definition = {
    prefix: $beb41f2f74c84499$var$prefix,
    iconName: $beb41f2f74c84499$var$iconName,
    icon: [
        $beb41f2f74c84499$var$width,
        $beb41f2f74c84499$var$height,
        $beb41f2f74c84499$var$aliases,
        $beb41f2f74c84499$var$unicode,
        $beb41f2f74c84499$var$svgPathData
    ]
};
$beb41f2f74c84499$exports.faPencil = $beb41f2f74c84499$exports.definition;
$beb41f2f74c84499$exports.prefix = $beb41f2f74c84499$var$prefix;
$beb41f2f74c84499$exports.iconName = $beb41f2f74c84499$var$iconName;
$beb41f2f74c84499$exports.width = $beb41f2f74c84499$var$width;
$beb41f2f74c84499$exports.height = $beb41f2f74c84499$var$height;
$beb41f2f74c84499$exports.ligatures = $beb41f2f74c84499$var$aliases;
$beb41f2f74c84499$exports.unicode = $beb41f2f74c84499$var$unicode;
$beb41f2f74c84499$exports.svgPathData = $beb41f2f74c84499$var$svgPathData;
$beb41f2f74c84499$exports.aliases = $beb41f2f74c84499$var$aliases;


var $b86fd896361703f2$exports = {};
"use strict";
Object.defineProperty($b86fd896361703f2$exports, "__esModule", {
    value: true
});
var $b86fd896361703f2$var$prefix = "fas";
var $b86fd896361703f2$var$iconName = "lock";
var $b86fd896361703f2$var$width = 448;
var $b86fd896361703f2$var$height = 512;
var $b86fd896361703f2$var$aliases = [
    128274
];
var $b86fd896361703f2$var$unicode = "f023";
var $b86fd896361703f2$var$svgPathData = "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z";
$b86fd896361703f2$exports.definition = {
    prefix: $b86fd896361703f2$var$prefix,
    iconName: $b86fd896361703f2$var$iconName,
    icon: [
        $b86fd896361703f2$var$width,
        $b86fd896361703f2$var$height,
        $b86fd896361703f2$var$aliases,
        $b86fd896361703f2$var$unicode,
        $b86fd896361703f2$var$svgPathData
    ]
};
$b86fd896361703f2$exports.faLock = $b86fd896361703f2$exports.definition;
$b86fd896361703f2$exports.prefix = $b86fd896361703f2$var$prefix;
$b86fd896361703f2$exports.iconName = $b86fd896361703f2$var$iconName;
$b86fd896361703f2$exports.width = $b86fd896361703f2$var$width;
$b86fd896361703f2$exports.height = $b86fd896361703f2$var$height;
$b86fd896361703f2$exports.ligatures = $b86fd896361703f2$var$aliases;
$b86fd896361703f2$exports.unicode = $b86fd896361703f2$var$unicode;
$b86fd896361703f2$exports.svgPathData = $b86fd896361703f2$var$svgPathData;
$b86fd896361703f2$exports.aliases = $b86fd896361703f2$var$aliases;


var $731960bb6e3da28d$exports = {};
"use strict";
Object.defineProperty($731960bb6e3da28d$exports, "__esModule", {
    value: true
});
var $731960bb6e3da28d$var$prefix = "fas";
var $731960bb6e3da28d$var$iconName = "book";
var $731960bb6e3da28d$var$width = 448;
var $731960bb6e3da28d$var$height = 512;
var $731960bb6e3da28d$var$aliases = [
    128212
];
var $731960bb6e3da28d$var$unicode = "f02d";
var $731960bb6e3da28d$var$svgPathData = "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
$731960bb6e3da28d$exports.definition = {
    prefix: $731960bb6e3da28d$var$prefix,
    iconName: $731960bb6e3da28d$var$iconName,
    icon: [
        $731960bb6e3da28d$var$width,
        $731960bb6e3da28d$var$height,
        $731960bb6e3da28d$var$aliases,
        $731960bb6e3da28d$var$unicode,
        $731960bb6e3da28d$var$svgPathData
    ]
};
$731960bb6e3da28d$exports.faBook = $731960bb6e3da28d$exports.definition;
$731960bb6e3da28d$exports.prefix = $731960bb6e3da28d$var$prefix;
$731960bb6e3da28d$exports.iconName = $731960bb6e3da28d$var$iconName;
$731960bb6e3da28d$exports.width = $731960bb6e3da28d$var$width;
$731960bb6e3da28d$exports.height = $731960bb6e3da28d$var$height;
$731960bb6e3da28d$exports.ligatures = $731960bb6e3da28d$var$aliases;
$731960bb6e3da28d$exports.unicode = $731960bb6e3da28d$var$unicode;
$731960bb6e3da28d$exports.svgPathData = $731960bb6e3da28d$var$svgPathData;
$731960bb6e3da28d$exports.aliases = $731960bb6e3da28d$var$aliases;


var $3cf7a308d6bda284$export$82e9f45cca5ba907 = "far";
var $3cf7a308d6bda284$export$864bb8d6c21fb792 = {
    prefix: "far",
    iconName: "trash-can",
    icon: [
        448,
        512,
        [
            61460,
            "trash-alt"
        ],
        "f2ed",
        "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $3cf7a308d6bda284$export$88df7ff7eb32f9dc = $3cf7a308d6bda284$export$864bb8d6c21fb792;
var $3cf7a308d6bda284$export$6563a67224e7f879 = {
    prefix: "far",
    iconName: "message",
    icon: [
        512,
        512,
        [
            "comment-alt"
        ],
        "f27a",
        "M160 368c26.5 0 48 21.5 48 48v16l72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16h96zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V474.7v-6.4V468v-4V416H112 64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L208 492z"
    ]
};
var $3cf7a308d6bda284$export$6e96904d9af0ec4a = $3cf7a308d6bda284$export$6563a67224e7f879;
var $3cf7a308d6bda284$export$ef565d07efe2b5e9 = {
    prefix: "far",
    iconName: "file-lines",
    icon: [
        384,
        512,
        [
            128441,
            128462,
            61686,
            "file-alt",
            "file-text"
        ],
        "f15c",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"
    ]
};
var $3cf7a308d6bda284$export$243b47dca32bf0b8 = $3cf7a308d6bda284$export$ef565d07efe2b5e9;
var $3cf7a308d6bda284$export$f466100bf9bf37a5 = $3cf7a308d6bda284$export$ef565d07efe2b5e9;
var $3cf7a308d6bda284$export$31c6cf6f5d38dc0 = {
    prefix: "far",
    iconName: "calendar-days",
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"
    ]
};
var $3cf7a308d6bda284$export$cbc139f33cff356 = $3cf7a308d6bda284$export$31c6cf6f5d38dc0;
var $3cf7a308d6bda284$export$f7bc8714c970afa4 = {
    prefix: "far",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M448 128l-177.6 0c1 5.2 1.6 10.5 1.6 16l0 16 32 0 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM224 144c0-17.7-14.3-32-32-32c0 0 0 0 0 0l-24 0c-66.3 0-120 53.7-120 120l0 48c0 52.5 33.7 97.1 80.7 113.4c-.5-3.1-.7-6.2-.7-9.4c0-20 9.2-37.9 23.6-49.7c-4.9-9-7.6-19.4-7.6-30.3c0-15.1 5.3-29 14-40c-8.8-11-14-24.9-14-40l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 0-40zM192 64s0 0 0 0c18 0 34.6 6 48 16l208 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-82 0c1.3 5.1 2 10.5 2 16c0 25.3-14.7 47.2-36 57.6c2.6 7 4 14.5 4 22.4c0 20-9.2 37.9-23.6 49.7c4.9 9 7.6 19.4 7.6 30.3c0 35.3-28.7 64-64 64l-64 0-24 0C75.2 448 0 372.8 0 280l0-48C0 139.2 75.2 64 168 64l24 0zm64 336c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0zm16-176c0 5.5-.7 10.9-2 16l2 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 16zm-24 64l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0z"
    ]
};
var $3cf7a308d6bda284$export$e3c56ed54f074063 = {
    prefix: "far",
    iconName: "face-smile-beam",
    icon: [
        512,
        512,
        [
            128522,
            "smile-beam"
        ],
        "f5b8",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm40-89.3l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $3cf7a308d6bda284$export$54ada6dc9690e0ca = $3cf7a308d6bda284$export$e3c56ed54f074063;
var $3cf7a308d6bda284$export$1d1fbac384a76a12 = {
    prefix: "far",
    iconName: "face-grin-stars",
    icon: [
        512,
        512,
        [
            129321,
            "grin-stars"
        ],
        "f587",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM183.2 132.6c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L176 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L242.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm160 0c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L336 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L402.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm6.3 175.8c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5c10.4-16.1-6.8-32.5-25.5-28.1z"
    ]
};
var $3cf7a308d6bda284$export$64347a5c8c402ef4 = $3cf7a308d6bda284$export$1d1fbac384a76a12;
var $3cf7a308d6bda284$export$853fd1561789e3bb = {
    prefix: "far",
    iconName: "address-book",
    icon: [
        512,
        512,
        [
            62138,
            "contact-book"
        ],
        "f2b9",
        "M384 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H208zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"
    ]
};
var $3cf7a308d6bda284$export$594b5a5d4d2e156b = $3cf7a308d6bda284$export$853fd1561789e3bb;
var $3cf7a308d6bda284$export$932912e74adb8939 = {
    prefix: "far",
    iconName: "comments",
    icon: [
        640,
        512,
        [
            128490,
            61670
        ],
        "f086",
        "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.7 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z"
    ]
};
var $3cf7a308d6bda284$export$6f95f90dd1f6d86b = {
    prefix: "far",
    iconName: "paste",
    icon: [
        512,
        512,
        [
            "file-clipboard"
        ],
        "f0ea",
        "M104.6 48H64C28.7 48 0 76.7 0 112V384c0 35.3 28.7 64 64 64h96V400H64c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H80c0 17.7 14.3 32 32 32h72.4C202 108.4 227.6 96 256 96h62c-7.1-27.6-32.2-48-62-48H215.4C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48zM144 56a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 464H256c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16l140.1 0L464 243.9V448c0 8.8-7.2 16-16 16zM256 512H448c35.3 0 64-28.7 64-64V243.9c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1H256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64z"
    ]
};
var $3cf7a308d6bda284$export$ca3229c47de163fa = $3cf7a308d6bda284$export$6f95f90dd1f6d86b;
var $3cf7a308d6bda284$export$8eee2c17ff89e724 = {
    prefix: "far",
    iconName: "face-grin-tongue-squint",
    icon: [
        512,
        512,
        [
            128541,
            "grin-tongue-squint"
        ],
        "f58a",
        "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4V392.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm116-98.9c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 416V378.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $3cf7a308d6bda284$export$4edf34c3def09a31 = $3cf7a308d6bda284$export$8eee2c17ff89e724;
var $3cf7a308d6bda284$export$ba5dc4287853ecbd = {
    prefix: "far",
    iconName: "face-flushed",
    icon: [
        512,
        512,
        [
            128563,
            "flushed"
        ],
        "f579",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM160.4 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H320c13.3 0 24-10.7 24-24s-10.7-24-24-24H192zM160 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm144-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"
    ]
};
var $3cf7a308d6bda284$export$dfd2bd012685aeac = $3cf7a308d6bda284$export$ba5dc4287853ecbd;
var $3cf7a308d6bda284$export$5b1d41cdd118ea6d = {
    prefix: "far",
    iconName: "square-caret-right",
    icon: [
        448,
        512,
        [
            "caret-square-right"
        ],
        "f152",
        "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
    ]
};
var $3cf7a308d6bda284$export$ae86c9de7e0f62fa = $3cf7a308d6bda284$export$5b1d41cdd118ea6d;
var $3cf7a308d6bda284$export$814c9edba7b84aa4 = {
    prefix: "far",
    iconName: "square-minus",
    icon: [
        448,
        512,
        [
            61767,
            "minus-square"
        ],
        "f146",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM152 232H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $3cf7a308d6bda284$export$ffe9387966b3e681 = $3cf7a308d6bda284$export$814c9edba7b84aa4;
var $3cf7a308d6bda284$export$b4d344633433e50e = {
    prefix: "far",
    iconName: "compass",
    icon: [
        512,
        512,
        [
            129517
        ],
        "f14e",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $3cf7a308d6bda284$export$a1ab39cd66c4e50e = {
    prefix: "far",
    iconName: "square-caret-down",
    icon: [
        448,
        512,
        [
            "caret-square-down"
        ],
        "f150",
        "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
    ]
};
var $3cf7a308d6bda284$export$61aea18df1c84401 = $3cf7a308d6bda284$export$a1ab39cd66c4e50e;
var $3cf7a308d6bda284$export$eca99665af566fe1 = {
    prefix: "far",
    iconName: "face-kiss-beam",
    icon: [
        512,
        512,
        [
            128537,
            "kiss-beam"
        ],
        "f597",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-68.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $3cf7a308d6bda284$export$d6ff8a73c0812e63 = $3cf7a308d6bda284$export$eca99665af566fe1;
var $3cf7a308d6bda284$export$1e80f89fe84a215b = {
    prefix: "far",
    iconName: "lightbulb",
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H226.4c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8l0 0 0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80V416H272v16c0 44.2-35.8 80-80 80z"
    ]
};
var $3cf7a308d6bda284$export$6591b1ea509be9da = {
    prefix: "far",
    iconName: "flag",
    icon: [
        448,
        512,
        [
            127988,
            61725
        ],
        "f024",
        "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24V64 350.5 400v88c0 13.3 10.7 24 24 24s24-10.7 24-24V388l80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L48 52V24zm0 77.5l96.6-24.2c27-6.7 55.5-3.6 80.4 8.8c54.9 27.4 118.7 29.7 175 6.8V334.7l-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5v-237z"
    ]
};
var $3cf7a308d6bda284$export$5bb6a0c94ad2f4bb = {
    prefix: "far",
    iconName: "square-check",
    icon: [
        448,
        512,
        [
            9745,
            9989,
            61510,
            "check-square"
        ],
        "f14a",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $3cf7a308d6bda284$export$f0c8040f596df7fe = $3cf7a308d6bda284$export$5bb6a0c94ad2f4bb;
var $3cf7a308d6bda284$export$aa13d9234890e8d3 = {
    prefix: "far",
    iconName: "circle-dot",
    icon: [
        512,
        512,
        [
            128280,
            "dot-circle"
        ],
        "f192",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $3cf7a308d6bda284$export$92bc269cb244d66a = $3cf7a308d6bda284$export$aa13d9234890e8d3;
var $3cf7a308d6bda284$export$635e4d8cc8428961 = {
    prefix: "far",
    iconName: "face-dizzy",
    icon: [
        512,
        512,
        [
            "dizzy"
        ],
        "f567",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM103 135c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9zm192 0c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $3cf7a308d6bda284$export$89a2b10dabc487e8 = $3cf7a308d6bda284$export$635e4d8cc8428961;
var $3cf7a308d6bda284$export$65a345b33858a655 = {
    prefix: "far",
    iconName: "futbol",
    icon: [
        512,
        512,
        [
            9917,
            "futbol-ball",
            "soccer-ball"
        ],
        "f1e3",
        "M435.4 361.3l-89.7-6c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-22 87.2c-14.4 3.2-29.4 4.8-44.8 4.8s-30.3-1.7-44.8-4.8l-22-87.2c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-89.7 6C61.7 335.9 51.9 307 49 276.2L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L100.4 118c19.9-22.4 44.6-40.5 72.4-52.7l69.1 57.6c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l69.1-57.6c27.8 12.2 52.5 30.3 72.4 52.7l-33.4 83.4c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9L463 276.2c-3 30.8-12.7 59.7-27.6 85.1zM256 48l.9 0h-1.8l.9 0zM56.7 196.2c.9-3 1.9-6.1 2.9-9.1l-2.9 9.1zM132 423l3.8 2.7c-1.3-.9-2.5-1.8-3.8-2.7zm248.1-.1c-1.3 1-2.7 2-4 2.9l4-2.9zm75.2-226.6l-3-9.2c1.1 3 2.1 6.1 3 9.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
    ]
};
var $3cf7a308d6bda284$export$51a344ca0a215620 = $3cf7a308d6bda284$export$65a345b33858a655;
var $3cf7a308d6bda284$export$f4a29712c724ba2d = $3cf7a308d6bda284$export$65a345b33858a655;
var $3cf7a308d6bda284$export$ba236543926e3569 = {
    prefix: "far",
    iconName: "pen-to-square",
    icon: [
        512,
        512,
        [
            "edit"
        ],
        "f044",
        "M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z"
    ]
};
var $3cf7a308d6bda284$export$7be713e57d023733 = $3cf7a308d6bda284$export$ba236543926e3569;
var $3cf7a308d6bda284$export$703272eebf5e3eea = {
    prefix: "far",
    iconName: "hourglass-half",
    icon: [
        384,
        512,
        [
            "hourglass-2"
        ],
        "f252",
        "M0 24C0 10.7 10.7 0 24 0H360c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V67c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445v19h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V445c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67V48H24C10.7 48 0 37.3 0 24zM110.5 371.5c-3.9 3.9-7.5 8.1-10.7 12.5H284.2c-3.2-4.4-6.8-8.6-10.7-12.5L192 289.9l-81.5 81.5zM284.2 128C297 110.4 304 89 304 67V48H80V67c0 22.1 7 43.4 19.8 61H284.2z"
    ]
};
var $3cf7a308d6bda284$export$f1052bbf6bf361c0 = $3cf7a308d6bda284$export$703272eebf5e3eea;
var $3cf7a308d6bda284$export$ed3f2918429d029a = {
    prefix: "far",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z"
    ]
};
var $3cf7a308d6bda284$export$f69db0b876f7d753 = {
    prefix: "far",
    iconName: "hand",
    icon: [
        512,
        512,
        [
            129306,
            9995,
            "hand-paper"
        ],
        "f256",
        "M256 0c-25.3 0-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4c-35.3 0-64 28.7-64 64V261.5l-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75H296h8c1.5 0 3-.1 4.5-.4c91.7-6.2 165-79.4 171.1-171.1c.3-1.5 .4-3 .4-4.5V160c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2V96c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C303.2 14.7 281.3 0 256 0zM240 96.1c0 0 0-.1 0-.1V64c0-8.8 7.2-16 16-16s16 7.2 16 16V95.9c0 0 0 .1 0 .1V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96c0 0 0 0 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16v55.9c0 0 0 .1 0 .1v80c0 13.3 10.7 24 24 24s24-10.7 24-24V160.1c0 0 0-.1 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16V332.9c-.1 .6-.1 1.3-.2 1.9c-3.4 69.7-59.3 125.6-129 129c-.6 0-1.3 .1-1.9 .2H296h-8.5c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V96c0-8.8 7.2-16 16-16c8.8 0 16 7.1 16 15.9V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96.1z"
    ]
};
var $3cf7a308d6bda284$export$6e6216c8b50471bb = $3cf7a308d6bda284$export$f69db0b876f7d753;
var $3cf7a308d6bda284$export$2262d6b626de1120 = {
    prefix: "far",
    iconName: "hand-spock",
    icon: [
        576,
        512,
        [
            128406
        ],
        "f259",
        "M170.2 80.8C161 47 180.8 12 214.6 2.4c34-9.6 69.4 10.2 79 44.2l30.3 107.1L337.1 84c6.6-34.7 40.1-57.5 74.8-50.9c31.4 6 53 33.9 52 64.9c10-2.6 20.8-2.8 31.5-.1c34.3 8.6 55.1 43.3 46.6 77.6L486.7 397.2C469.8 464.7 409.2 512 339.6 512c-11.2 0-22.5 0-33.7 0c-56.9 0-112.2-19-157.2-53.9l-92-71.6c-27.9-21.7-32.9-61.9-11.2-89.8s61.9-32.9 89.8-11.2l17 13.2L100.5 167.5c-13-32.9 3.2-70.1 36-83c11.1-4.4 22.7-5.4 33.7-3.7zm77.1-21.2c-2.4-8.5-11.2-13.4-19.7-11s-13.4 11.2-11 19.7l54.8 182.4c3.5 12.3-3.3 25.2-15.4 29.3s-25.3-2-30-13.9L174.9 138.1c-3.2-8.2-12.5-12.3-20.8-9s-12.3 12.5-9 20.8l73.3 185.6c12 30.3-23.7 57-49.4 37l-63.1-49.1c-7-5.4-17-4.2-22.5 2.8s-4.2 17 2.8 22.5l92 71.6c36.5 28.4 81.4 43.8 127.7 43.8c11.2 0 22.5 0 33.7 0c47.5 0 89-32.4 100.5-78.5l55.4-221.6c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-26 104C435.6 271.8 425 280 413 280c-16.5 0-28.9-15-25.8-31.2L415.7 99c1.7-8.7-4-17.1-12.7-18.7s-17.1 4-18.7 12.7L352.5 260c-2.2 11.6-12.4 20-24.2 20c-11 0-20.7-7.3-23.7-17.9L247.4 59.6z"
    ]
};
var $3cf7a308d6bda284$export$5a54c83033a0a56a = {
    prefix: "far",
    iconName: "face-kiss",
    icon: [
        512,
        512,
        [
            128535,
            "kiss"
        ],
        "f596",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 25.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 411.1 257.4 416 240 416c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.8-.5-.1-.1-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $3cf7a308d6bda284$export$c762a77aabf64fd0 = $3cf7a308d6bda284$export$5a54c83033a0a56a;
var $3cf7a308d6bda284$export$95a7394c24f57943 = {
    prefix: "far",
    iconName: "face-grin-tongue",
    icon: [
        512,
        512,
        [
            128539,
            "grin-tongue"
        ],
        "f589",
        "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4V363.6c-8.9-8-16.7-17.1-23.1-27.1c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1c-6.4 9.9-14.2 19-23 27V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 416V378.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $3cf7a308d6bda284$export$ef222816a43a4b3a = $3cf7a308d6bda284$export$95a7394c24f57943;
var $3cf7a308d6bda284$export$a831eedd2f59c62f = {
    prefix: "far",
    iconName: "chess-bishop",
    icon: [
        320,
        512,
        [
            9821
        ],
        "f43a",
        "M104 0C90.7 0 80 10.7 80 24c0 11.2 7.6 20.6 18 23.2c-7.8 8-16.1 17-24.4 27C38.2 116.7 0 178.8 0 250.9c0 44.8 24.6 72.2 48 87.8V352H96V325c0-9-5-17.2-13-21.3c-18-9.3-35-24.7-35-52.7c0-55.5 29.8-106.8 62.4-145.9c16-19.2 32.1-34.8 44.2-45.5c1.9-1.7 3.7-3.2 5.3-4.6c1.7 1.4 3.4 3 5.3 4.6c12.1 10.7 28.2 26.3 44.2 45.5c5.3 6.3 10.5 13 15.5 20L159 191c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57.8-57.8c12.8 25.9 21.2 54.3 21.2 83.8c0 28-17 43.4-35 52.7c-8 4.1-13 12.3-13 21.3v27h48V338.7c23.4-15.6 48-42.9 48-87.8c0-72.1-38.2-134.2-73.6-176.7c-8.3-9.9-16.6-19-24.4-27c10.3-2.7 18-12.1 18-23.2c0-13.3-10.7-24-24-24H160 104zM52.7 464l16.6-32H250.8l16.6 32H52.7zm207.9-80H59.5c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512H279.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"
    ]
};
var $3cf7a308d6bda284$export$1dd161850c5bc64e = {
    prefix: "far",
    iconName: "face-grin-wink",
    icon: [
        512,
        512,
        [
            "grin-wink"
        ],
        "f58c",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
var $3cf7a308d6bda284$export$2397fcd34eb12177 = $3cf7a308d6bda284$export$1dd161850c5bc64e;
var $3cf7a308d6bda284$export$bdbabf493c478cde = {
    prefix: "far",
    iconName: "face-grin-wide",
    icon: [
        512,
        512,
        [
            128515,
            "grin-alt"
        ],
        "f581",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM224 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm96 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
    ]
};
var $3cf7a308d6bda284$export$b4abebfe416d36ba = $3cf7a308d6bda284$export$bdbabf493c478cde;
var $3cf7a308d6bda284$export$c8a28356e07b9ccb = {
    prefix: "far",
    iconName: "face-frown-open",
    icon: [
        512,
        512,
        [
            128550,
            "frown-open"
        ],
        "f57a",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.4 382.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $3cf7a308d6bda284$export$c4775e66bed5d96 = $3cf7a308d6bda284$export$c8a28356e07b9ccb;
var $3cf7a308d6bda284$export$cdc9f5e7e94e76da = {
    prefix: "far",
    iconName: "hand-point-up",
    icon: [
        384,
        512,
        [
            9757
        ],
        "f0a6",
        "M64 64V241.6c5.2-1 10.5-1.6 16-1.6H96V208 64c0-8.8-7.2-16-16-16s-16 7.2-16 16zM80 288c-17.7 0-32 14.3-32 32c0 0 0 0 0 0v24c0 66.3 53.7 120 120 120h48c52.5 0 97.1-33.7 113.4-80.7c-3.1 .5-6.2 .7-9.4 .7c-20 0-37.9-9.2-49.7-23.6c-9 4.9-19.4 7.6-30.3 7.6c-15.1 0-29-5.3-40-14c-11 8.8-24.9 14-40 14H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H120 80zM0 320s0 0 0 0c0-18 6-34.6 16-48V64C16 28.7 44.7 0 80 0s64 28.7 64 64v82c5.1-1.3 10.5-2 16-2c25.3 0 47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c20 0 37.9 9.2 49.7 23.6c9-4.9 19.4-7.6 30.3-7.6c35.3 0 64 28.7 64 64v64 24c0 92.8-75.2 168-168 168H168C75.2 512 0 436.8 0 344V320zm336-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48 16c0 8.8 7.2 16 16 16s16-7.2 16-16V256zM160 240c5.5 0 10.9 .7 16 2v-2V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h16zm64 24v40c0 8.8 7.2 16 16 16s16-7.2 16-16V256 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v24z"
    ]
};
var $3cf7a308d6bda284$export$4ed9da5c3cca0ef1 = {
    prefix: "far",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [
            128278,
            61591
        ],
        "f02e",
        "M0 48C0 21.5 21.5 0 48 0l0 48V441.4l130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4V48H48V0H336c26.5 0 48 21.5 48 48V488c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488V48z"
    ]
};
var $3cf7a308d6bda284$export$f6dcbf0a940428f4 = {
    prefix: "far",
    iconName: "hand-point-down",
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M64 448l0-177.6c5.2 1 10.5 1.6 16 1.6l16 0 0 32 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16zM80 224c-17.7 0-32-14.3-32-32c0 0 0 0 0 0l0-24c0-66.3 53.7-120 120-120l48 0c52.5 0 97.1 33.7 113.4 80.7c-3.1-.5-6.2-.7-9.4-.7c-20 0-37.9 9.2-49.7 23.6c-9-4.9-19.4-7.6-30.3-7.6c-15.1 0-29 5.3-40 14c-11-8.8-24.9-14-40-14l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0-40 0zM0 192s0 0 0 0c0 18 6 34.6 16 48l0 208c0 35.3 28.7 64 64 64s64-28.7 64-64l0-82c5.1 1.3 10.5 2 16 2c25.3 0 47.2-14.7 57.6-36c7 2.6 14.5 4 22.4 4c20 0 37.9-9.2 49.7-23.6c9 4.9 19.4 7.6 30.3 7.6c35.3 0 64-28.7 64-64l0-64 0-24C384 75.2 308.8 0 216 0L168 0C75.2 0 0 75.2 0 168l0 24zm336 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zM160 272c5.5 0 10.9-.7 16-2l0 2 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 16 0zm64-24l0-40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24z"
    ]
};
var $3cf7a308d6bda284$export$72b780186370e953 = {
    prefix: "far",
    iconName: "folder",
    icon: [
        512,
        512,
        [
            128193,
            128447,
            61716,
            "folder-blank"
        ],
        "f07b",
        "M0 96C0 60.7 28.7 32 64 32H196.1c19.1 0 37.4 7.6 50.9 21.1L289.9 96H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H286.6c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7H64z"
    ]
};
var $3cf7a308d6bda284$export$9ef114244d26da0 = $3cf7a308d6bda284$export$72b780186370e953;
var $3cf7a308d6bda284$export$f5699fa0844e0188 = {
    prefix: "far",
    iconName: "user",
    icon: [
        448,
        512,
        [
            128100,
            62144
        ],
        "f007",
        "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"
    ]
};
var $3cf7a308d6bda284$export$2c5163541229363 = {
    prefix: "far",
    iconName: "square-caret-left",
    icon: [
        448,
        512,
        [
            "caret-square-left"
        ],
        "f191",
        "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
    ]
};
var $3cf7a308d6bda284$export$d0c8ba444f1f9581 = $3cf7a308d6bda284$export$2c5163541229363;
var $3cf7a308d6bda284$export$a3b0eb2cd7942125 = {
    prefix: "far",
    iconName: "star",
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"
    ]
};
var $3cf7a308d6bda284$export$861b1f13085cf122 = {
    prefix: "far",
    iconName: "chess-knight",
    icon: [
        448,
        512,
        [
            9822
        ],
        "f441",
        "M226.6 48H117.3l17.1 12.8c6 4.5 9.6 11.6 9.6 19.2s-3.6 14.7-9.6 19.2l-6.5 4.9c-10 7.5-16 19.3-16 31.9l-.3 91c0 10.2 4.9 19.9 13.2 25.8l1.9 1.3c9.9 7.1 23.3 7 33.2-.1l49.9-36.3c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5l-49.9 36.3-53.8 39.1c-7.3 5.3-13 12.2-16.9 20.1H66.8c5.3-22.1 17.8-41.9 35.9-56.3c-1.3-.8-2.6-1.7-3.8-2.6L97 291.8c-21-15-33.4-39.2-33.3-65l.3-91c.1-19.8 6.7-38.7 18.6-53.9l-.4-.3C70.7 73 64 59.6 64 45.3C64 20.3 84.3 0 109.3 0H226.6C331.2 0 416 84.8 416 189.4c0 11.1-1 22.2-2.9 33.2L390.1 352H341.3l24.5-137.8c1.5-8.2 2.2-16.5 2.2-24.8C368 111.3 304.7 48 226.6 48zM85.2 432L68.7 464H379.3l-16.6-32H85.2zm315.7-30.7l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H56.8C34.2 512 16 493.8 16 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C52.5 390.7 63.5 384 75.5 384h297c12 0 22.9 6.7 28.4 17.3zM172 128a20 20 0 1 1 0 40 20 20 0 1 1 0-40z"
    ]
};
var $3cf7a308d6bda284$export$67ca89c1ca38d559 = {
    prefix: "far",
    iconName: "face-laugh-squint",
    icon: [
        512,
        512,
        [
            "laugh-squint"
        ],
        "f59b",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm2.8-183.3l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 141.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $3cf7a308d6bda284$export$b206e700cf7084e1 = $3cf7a308d6bda284$export$67ca89c1ca38d559;
var $3cf7a308d6bda284$export$2f203616c892d415 = {
    prefix: "far",
    iconName: "face-laugh",
    icon: [
        512,
        512,
        [
            "laugh"
        ],
        "f599",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $3cf7a308d6bda284$export$6c74e314e801a4fe = $3cf7a308d6bda284$export$2f203616c892d415;
var $3cf7a308d6bda284$export$ff7e93418af88b78 = {
    prefix: "far",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [
            128194,
            128449,
            61717
        ],
        "f07c",
        "M384 480h48c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224H144c-11.4 0-21.9 6-27.6 15.9L48 357.1V96c0-8.8 7.2-16 16-16H181.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H416c8.8 0 16 7.2 16 16v32h48V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H87.7 384z"
    ]
};
var $3cf7a308d6bda284$export$97d84347d71ba297 = {
    prefix: "far",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [
            128203
        ],
        "f328",
        "M280 64h40c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h40 9.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H280zM64 112c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H304v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112H64zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $3cf7a308d6bda284$export$7b8ce73615739d30 = {
    prefix: "far",
    iconName: "chess-queen",
    icon: [
        512,
        512,
        [
            9819
        ],
        "f445",
        "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-95.2-8c-18.1 0-31.3 12.8-35.6 26.9c-8 26.2-32.4 45.2-61.2 45.2c-10 0-19.4-2.3-27.7-6.3c-7.6-3.7-16.7-3.3-24 1.2C.7 162.1-3.1 177.1 3.7 188.9L97.6 352H153l-83-144.1c40.5-2.2 75.3-25.9 93.1-59.8c22 26.8 55.4 43.9 92.8 43.9s70.8-17.1 92.8-43.9c17.8 34 52.6 57.7 93.1 59.8L359 352h55.4l93.9-163.1c6.8-11.7 3-26.7-8.6-33.8c-7.3-4.5-16.4-4.9-24-1.2c-8.4 4-17.7 6.3-27.7 6.3c-28.8 0-53.2-19-61.2-45.2C382.5 100.8 369.3 88 351.2 88c-14.5 0-26.3 8.5-32.4 19.3c-12.4 22-35.9 36.7-62.8 36.7s-50.4-14.8-62.8-36.7C187.1 96.5 175.4 88 160.8 88zM133.2 432H378.8l16.6 32H116.7l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3h-265c-12 0-22.9 6.7-28.4 17.3L68.6 452.5c-3 5.8-4.6 12.2-4.6 18.7c0 22.5 18.2 40.8 40.8 40.8H407.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
    ]
};
var $3cf7a308d6bda284$export$be38a892fe9b4098 = {
    prefix: "far",
    iconName: "hand-back-fist",
    icon: [
        448,
        512,
        [
            "hand-rock"
        ],
        "f255",
        "M144 64c0-8.8 7.2-16 16-16s16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16V264c0 31.3-20 58-48 67.9c-9.6 3.4-16 12.5-16 22.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V370.2c38-20.1 64-60.1 64-106.2V160c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5C332.8 77.1 311.9 64 288 64c-2.8 0-5.6 .2-8.3 .5C268.8 45.1 247.9 32 224 32c-2.8 0-5.6 .2-8.3 .5C204.8 13.1 183.9 0 160 0C124.7 0 96 28.7 96 64v64.3c-11.7 7.4-22.5 16.4-32 26.9l17.8 16.1L64 155.2l-9.4 10.5C40 181.8 32 202.8 32 224.6v12.8c0 49.6 24.2 96.1 64.8 124.5l13.8-19.7L96.8 361.9l8.9 6.2c6.9 4.8 14.4 8.6 22.3 11.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24V359.9c0-12.6-9.8-23.1-22.4-23.9c-7.3-.5-14.3-2.9-20.3-7.1l-13.1 18.7 13.1-18.7-8.9-6.2C96.6 303.1 80 271.3 80 237.4V224.6c0-9.9 3.7-19.4 10.3-26.8l9.4-10.5c3.8-4.2 7.9-8.1 12.3-11.6V208c0 8.8 7.2 16 16 16s16-7.2 16-16V142.3 128 64z"
    ]
};
var $3cf7a308d6bda284$export$97a81eba394c8c44 = $3cf7a308d6bda284$export$be38a892fe9b4098;
var $3cf7a308d6bda284$export$66068918abb14406 = {
    prefix: "far",
    iconName: "square-caret-up",
    icon: [
        448,
        512,
        [
            "caret-square-up"
        ],
        "f151",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 64c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
    ]
};
var $3cf7a308d6bda284$export$307ae80b26533ce5 = $3cf7a308d6bda284$export$66068918abb14406;
var $3cf7a308d6bda284$export$b532f5d25de97633 = {
    prefix: "far",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [
            "bar-chart"
        ],
        "f080",
        "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $3cf7a308d6bda284$export$2d5f754a5e5738b = $3cf7a308d6bda284$export$b532f5d25de97633;
var $3cf7a308d6bda284$export$eccfff9bfd585652 = {
    prefix: "far",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M432 48H208c-17.7 0-32 14.3-32 32V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V336h16c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zM48 448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V256H48V448zM64 128H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64z"
    ]
};
var $3cf7a308d6bda284$export$eaf727acca5a35e4 = {
    prefix: "far",
    iconName: "square-plus",
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $3cf7a308d6bda284$export$b6359eebfe900c35 = $3cf7a308d6bda284$export$eaf727acca5a35e4;
var $3cf7a308d6bda284$export$7e9f0928967e03b = {
    prefix: "far",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M448 80c8.8 0 16 7.2 16 16V415.8l-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $3cf7a308d6bda284$export$5e30548b7f8eeb95 = {
    prefix: "far",
    iconName: "folder-closed",
    icon: [
        512,
        512,
        [],
        "e185",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H289.9L247 53.1C233.5 39.6 215.2 32 196.1 32H64zM48 96c0-8.8 7.2-16 16-16H196.1c6.4 0 12.5 2.5 17 7l45.3 45.3c7.5 7.5 17.7 11.7 28.3 11.7H448c8.8 0 16 7.2 16 16v32H48V96zm0 144H464V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V240z"
    ]
};
var $3cf7a308d6bda284$export$4fbda8f64648f3b5 = {
    prefix: "far",
    iconName: "lemon",
    icon: [
        448,
        512,
        [
            127819
        ],
        "f094",
        "M368 80c-3.2 0-6.2 .4-8.9 1.3C340 86.8 313 91.9 284.8 84.6C227.4 69.7 160.2 92 110.1 142.1S37.7 259.4 52.6 316.8c7.3 28.2 2.2 55.2-3.3 74.3c-.8 2.8-1.3 5.8-1.3 8.9c0 17.7 14.3 32 32 32c3.2 0 6.2-.4 8.9-1.3c19.1-5.5 46.1-10.7 74.3-3.3c57.4 14.9 124.6-7.4 174.7-57.5s72.4-117.3 57.5-174.7c-7.3-28.2-2.2-55.2 3.3-74.3c.8-2.8 1.3-5.8 1.3-8.9c0-17.7-14.3-32-32-32zm0-48c44.2 0 80 35.8 80 80c0 7.7-1.1 15.2-3.1 22.3c-4.6 15.8-7.1 32.9-3 48.9c20.1 77.6-10.9 161.5-70 220.7s-143.1 90.2-220.7 70c-16-4.1-33-1.6-48.9 3c-7.1 2-14.6 3.1-22.3 3.1c-44.2 0-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.3c4.6-15.8 7.1-32.9 3-48.9C-14 251.3 17 167.3 76.2 108.2S219.3 18 296.8 38.1c16 4.1 33 1.6 48.9-3c7.1-2 14.6-3.1 22.3-3.1zM246.7 167c-52 15.2-96.5 59.7-111.7 111.7c-3.7 12.7-17.1 20-29.8 16.3s-20-17.1-16.3-29.8c19.8-67.7 76.6-124.5 144.3-144.3c12.7-3.7 26.1 3.6 29.8 16.3s-3.6 26.1-16.3 29.8z"
    ]
};
var $3cf7a308d6bda284$export$b4c63e9bfc7906f1 = {
    prefix: "far",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M272.2 64.6l-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9C142.8 171 129.5 176 115.8 176H96V304c20.4 .6 39.8 8.9 54.3 23.4l35.6 35.6 7 7 0 0L219.9 397c6.2 6.2 16.4 6.2 22.6 0c1.7-1.7 3-3.7 3.7-5.8c2.8-7.7 9.3-13.5 17.3-15.3s16.4 .6 22.2 6.5L296.5 393c11.6 11.6 30.4 11.6 41.9 0c5.4-5.4 8.3-12.3 8.6-19.4c.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6c9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9c-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2L505.1 128H544h40 40c8.8 0 16 7.2 16 16V352c0 17.7-14.3 32-32 32H576c-11.8 0-22.2-6.4-27.7-16H463.4c-3.4 6.7-7.9 13.1-13.5 18.7c-17.1 17.1-40.8 23.8-63 20.1c-3.6 7.3-8.5 14.1-14.6 20.2c-27.3 27.3-70 30-100.4 8.1c-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3C96 369.7 81.6 384 64 384H32c-17.7 0-32-14.3-32-32V144c0-8.8 7.2-16 16-16H56 96h19.8c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64H259c4.4 0 8.9 .2 13.2 .6zM544 320V176H496c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3 .5 35.7c9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8 .8 74.4 74.4c10 10 16.5 22.3 19.4 35.1H544zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $3cf7a308d6bda284$export$31ee86ac717db552 = {
    prefix: "far",
    iconName: "gem",
    icon: [
        512,
        512,
        [
            128142
        ],
        "f3a5",
        "M168.5 72L256 165l87.5-93h-175zM383.9 99.1L311.5 176h129L383.9 99.1zm50 124.9H256 78.1L256 420.3 433.9 224zM71.5 176h129L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"
    ]
};
var $3cf7a308d6bda284$export$86c4e45dc3302d15 = {
    prefix: "far",
    iconName: "circle-play",
    icon: [
        512,
        512,
        [
            61469,
            "play-circle"
        ],
        "f144",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9V168c0-8.7 4.7-16.7 12.3-20.9z"
    ]
};
var $3cf7a308d6bda284$export$cf04333781061c5e = $3cf7a308d6bda284$export$86c4e45dc3302d15;
var $3cf7a308d6bda284$export$c2e9877668862374 = {
    prefix: "far",
    iconName: "circle-check",
    icon: [
        512,
        512,
        [
            61533,
            "check-circle"
        ],
        "f058",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
    ]
};
var $3cf7a308d6bda284$export$be9e388158c74f29 = $3cf7a308d6bda284$export$c2e9877668862374;
var $3cf7a308d6bda284$export$229de76dfef2687f = {
    prefix: "far",
    iconName: "circle-stop",
    icon: [
        512,
        512,
        [
            62094,
            "stop-circle"
        ],
        "f28d",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var $3cf7a308d6bda284$export$47af2aad60ab3e7c = $3cf7a308d6bda284$export$229de76dfef2687f;
var $3cf7a308d6bda284$export$a75288855ea05282 = {
    prefix: "far",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M256 48V64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H256zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var $3cf7a308d6bda284$export$3f2d51c0547bf984 = {
    prefix: "far",
    iconName: "face-laugh-beam",
    icon: [
        512,
        512,
        [
            128513,
            "laugh-beam"
        ],
        "f59a",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm86.9-85.1l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $3cf7a308d6bda284$export$a88d1f4073ea9369 = $3cf7a308d6bda284$export$3f2d51c0547bf984;
var $3cf7a308d6bda284$export$5f519e9ac15ab8c3 = {
    prefix: "far",
    iconName: "registered",
    icon: [
        512,
        512,
        [
            174
        ],
        "f25d",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152V264v96c0 13.3 10.7 24 24 24s24-10.7 24-24V288h60.9l37.2 81.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8L315.7 275c21.8-14.3 36.3-39 36.3-67c0-44.2-35.8-80-80-80H184c-13.3 0-24 10.7-24 24zm48 88V176h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H208z"
    ]
};
var $3cf7a308d6bda284$export$6ea408c7266ed557 = {
    prefix: "far",
    iconName: "address-card",
    icon: [
        576,
        512,
        [
            62140,
            "contact-card",
            "vcard"
        ],
        "f2bb",
        "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H176zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"
    ]
};
var $3cf7a308d6bda284$export$4ac51eb0b298b190 = $3cf7a308d6bda284$export$6ea408c7266ed557;
var $3cf7a308d6bda284$export$91228257deb1bf18 = $3cf7a308d6bda284$export$6ea408c7266ed557;
var $3cf7a308d6bda284$export$5352cbdc070ce8d = {
    prefix: "far",
    iconName: "face-tired",
    icon: [
        512,
        512,
        [
            128555,
            "tired"
        ],
        "f5c8",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.5 64.3C196.1 302.1 223.8 288 256 288s59.9 14.1 79.5 32.3C354.5 338.1 368 362 368 384c0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm-43-173.6l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $3cf7a308d6bda284$export$3d016d62cda18371 = $3cf7a308d6bda284$export$5352cbdc070ce8d;
var $3cf7a308d6bda284$export$aa4baaed1c60f58d = {
    prefix: "far",
    iconName: "font-awesome",
    icon: [
        448,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V124.2l12.5-2.4c16.7-3.2 31.5-8.5 44.2-13.1l0 0 0 0c3.7-1.3 7.1-2.6 10.4-3.7c15.2-5.2 30.4-9.1 51.2-9.1c25.6 0 43 6 63.5 13.3l.5 .2c20.9 7.4 44.8 15.9 79.1 15.9c32.4 0 53.7-6.8 90.5-19.6V342.9l-9.5 3.3c-41.5 14.4-55.2 19.2-81 19.2c-25.7 0-43.1-6-63.6-13.3l-.6-.2c-20.8-7.4-44.8-15.8-79-15.8c-16.8 0-31 2-43.9 5c-12.9 3-20.9 16-17.9 28.9s16 20.9 28.9 17.9c9.6-2.2 20.1-3.7 32.9-3.7c25.6 0 43 6 63.5 13.3l.5 .2c20.9 7.4 44.8 15.9 79.1 15.9c34.4 0 56.4-7.7 97.8-22.2c7.5-2.6 15.5-5.4 24.4-8.5l16.2-5.5V360 72 38.4L416.2 49.3c-9.7 3.3-18.2 6.3-25.7 8.9c-41.5 14.4-55.2 19.2-81 19.2c-25.7 0-43.1-6-63.6-13.3l-.6-.2c-20.8-7.4-44.8-15.8-79-15.8c-27.8 0-48.5 5.5-66.6 11.6c-4.9 1.7-9.3 3.3-13.6 4.8c-11.9 4.3-22 7.9-34.7 10.3L48 75.4V56z"
    ]
};
var $3cf7a308d6bda284$export$102c25fde54d4843 = $3cf7a308d6bda284$export$aa4baaed1c60f58d;
var $3cf7a308d6bda284$export$6e20d421a2e0f320 = $3cf7a308d6bda284$export$aa4baaed1c60f58d;
var $3cf7a308d6bda284$export$6143da800b0e6626 = {
    prefix: "far",
    iconName: "face-smile-wink",
    icon: [
        512,
        512,
        [
            128521,
            "smile-wink"
        ],
        "f4da",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
var $3cf7a308d6bda284$export$f5dbb37f6801ee3f = $3cf7a308d6bda284$export$6143da800b0e6626;
var $3cf7a308d6bda284$export$f0858dff6e769cf6 = {
    prefix: "far",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z"
    ]
};
var $3cf7a308d6bda284$export$c341daeecdea449a = {
    prefix: "far",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm72 208c-13.3 0-24 10.7-24 24V336v56c0 13.3 10.7 24 24 24s24-10.7 24-24V360h44c42 0 76-34 76-76s-34-76-76-76H136zm68 104H160V256h44c15.5 0 28 12.5 28 28s-12.5 28-28 28z"
    ]
};
var $3cf7a308d6bda284$export$c6c3bd5f7d9b8bf2 = {
    prefix: "far",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [
            62135
        ],
        "f2b6",
        "M255.4 48.2c.2-.1 .4-.2 .6-.2s.4 .1 .6 .2L460.6 194c2.1 1.5 3.4 3.9 3.4 6.5v13.6L291.5 355.7c-20.7 17-50.4 17-71.1 0L48 214.1V200.5c0-2.6 1.2-5 3.4-6.5L255.4 48.2zM48 276.2L190 392.8c38.4 31.5 93.7 31.5 132 0L464 276.2V456c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V276.2zM256 0c-10.2 0-20.2 3.2-28.5 9.1L23.5 154.9C8.7 165.4 0 182.4 0 200.5V456c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V200.5c0-18.1-8.7-35.1-23.4-45.6L284.5 9.1C276.2 3.2 266.2 0 256 0z"
    ]
};
var $3cf7a308d6bda284$export$7a4a0e4caa1e4e6f = {
    prefix: "far",
    iconName: "file-zipper",
    icon: [
        384,
        512,
        [
            "file-archive"
        ],
        "f1c6",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16h48v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm48 112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm-6.3 71.8L82.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8H136.6c-14.5 0-27.2 9.7-30.9 23.8zM128 336h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $3cf7a308d6bda284$export$bf2047a9946b5c3f = $3cf7a308d6bda284$export$7a4a0e4caa1e4e6f;
var $3cf7a308d6bda284$export$90b4406457aae8cc = {
    prefix: "far",
    iconName: "square",
    icon: [
        448,
        512,
        [
            9632,
            9723,
            9724,
            61590
        ],
        "f0c8",
        "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $3cf7a308d6bda284$export$bab8f3647c394f48 = {
    prefix: "far",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [
            10052,
            10054
        ],
        "f2dc",
        "M224 0c13.3 0 24 10.7 24 24V70.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57v76.5l66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6v76.5l57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V441.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V297.6l-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4V137.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24z"
    ]
};
var $3cf7a308d6bda284$export$d91b374112d4f8c1 = {
    prefix: "far",
    iconName: "newspaper",
    icon: [
        512,
        512,
        [
            128240
        ],
        "f1ea",
        "M168 80c-13.3 0-24 10.7-24 24V408c0 8.4-1.4 16.5-4.1 24H440c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H168zM72 480c-39.8 0-72-32.2-72-72V112C0 98.7 10.7 88 24 88s24 10.7 24 24V408c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-39.8 32.2-72 72-72H440c39.8 0 72 32.2 72 72V408c0 39.8-32.2 72-72 72H72zM176 136c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V136zm200-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zM200 272H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $3cf7a308d6bda284$export$611ae61f02de0aa = {
    prefix: "far",
    iconName: "face-kiss-wink-heart",
    icon: [
        512,
        512,
        [
            128536,
            "kiss-wink-heart"
        ],
        "f598",
        "M338.9 446.8c-25.4 11-53.4 17.2-82.9 17.2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 22.4-3.5 43.9-10.1 64.1c3.1 4.5 5.7 9.4 7.8 14.6c12.7-1.6 25.1 .4 36.2 5c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-6.5-25.3zM296 316c0-6.9-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4C258.7 276.9 241.4 272 224 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4c-2.7-1.5-5.7-3-8.7-4.3c3.1-1.3 6-2.7 8.7-4.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm159.3-20c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C375.7 186.8 355 180 335.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
    ]
};
var $3cf7a308d6bda284$export$ebba617701dfb917 = $3cf7a308d6bda284$export$611ae61f02de0aa;
var $3cf7a308d6bda284$export$3e4892d8bf919edd = {
    prefix: "far",
    iconName: "star-half-stroke",
    icon: [
        576,
        512,
        [
            "star-half-alt"
        ],
        "f5c0",
        "M309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5zM288 384.7V79.1l52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L391 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L299.2 387.5c-3.5-1.9-7.4-2.8-11.2-2.8z"
    ]
};
var $3cf7a308d6bda284$export$c13575f42532efb3 = $3cf7a308d6bda284$export$3e4892d8bf919edd;
var $3cf7a308d6bda284$export$77cb1a465c4fe84 = {
    prefix: "far",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7L161.6 320l-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2L192 359.1l37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2L192 280.9l-37.1-47.6z"
    ]
};
var $3cf7a308d6bda284$export$3de52eeb00462407 = {
    prefix: "far",
    iconName: "face-grin-beam",
    icon: [
        512,
        512,
        [
            128516,
            "grin-beam"
        ],
        "f582",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM217.6 228.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $3cf7a308d6bda284$export$734da5249381ec7e = $3cf7a308d6bda284$export$3de52eeb00462407;
var $3cf7a308d6bda284$export$887f6345573abcac = {
    prefix: "far",
    iconName: "object-ungroup",
    icon: [
        640,
        512,
        [],
        "f248",
        "M48.2 66.8c-.1-.8-.2-1.7-.2-2.5c0-.1 0-.1 0-.2c0-8.8 7.2-16 16-16c.9 0 1.9 .1 2.8 .2C74.3 49.5 80 56.1 80 64c0 8.8-7.2 16-16 16c-7.9 0-14.5-5.7-15.8-13.2zM0 64c0 26.9 16.5 49.9 40 59.3V228.7C16.5 238.1 0 261.1 0 288c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H324.7c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V123.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H123.3C113.9 16.5 90.9 0 64 0C28.7 0 0 28.7 0 64zm368 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM324.7 88c6.5 16 19.3 28.9 35.3 35.3V228.7c-16 6.5-28.9 19.3-35.3 35.3H123.3c-6.5-16-19.3-28.9-35.3-35.3V123.3c16-6.5 28.9-19.3 35.3-35.3H324.7zM384 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 288c0 7.9-5.7 14.5-13.2 15.8c-.8 .1-1.7 .2-2.5 .2l-.2 0c-8.8 0-16-7.2-16-16c0-.9 .1-1.9 .2-2.8C49.5 277.7 56.1 272 64 272c8.8 0 16 7.2 16 16zm391.3-40h45.4c6.5 16 19.3 28.9 35.3 35.3V388.7c-16 6.5-28.9 19.3-35.3 35.3H315.3c-6.5-16-19.3-28.9-35.3-35.3V352H232v36.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H516.7c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V283.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H448v16.4c9.8 8.8 17.8 19.5 23.3 31.6zm88.9-26.7a16 16 0 1 1 31.5 5.5 16 16 0 1 1 -31.5-5.5zM271.8 450.7a16 16 0 1 1 -31.5-5.5 16 16 0 1 1 31.5 5.5zm301.5 13c-7.5-1.3-13.2-7.9-13.2-15.8c0-8.8 7.2-16 16-16c7.9 0 14.5 5.7 15.8 13.2l0 .1c.1 .9 .2 1.8 .2 2.7c0 8.8-7.2 16-16 16c-.9 0-1.9-.1-2.8-.2z"
    ]
};
var $3cf7a308d6bda284$export$1fec48c8bdd69c1d = {
    prefix: "far",
    iconName: "circle-right",
    icon: [
        512,
        512,
        [
            61838,
            "arrow-alt-circle-right"
        ],
        "f35a",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1c-4.2-4.5-10.1-7.1-16.3-7.1C266 128 256 138 256 150.3V208H160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h96v57.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.3-7.1l99.9-107.1c3.5-3.8 5.5-8.7 5.5-13.8s-2-10.1-5.5-13.8L294.6 135.1z"
    ]
};
var $3cf7a308d6bda284$export$88962ffdad8b856d = $3cf7a308d6bda284$export$1fec48c8bdd69c1d;
var $3cf7a308d6bda284$export$a6d72a9a068392b5 = {
    prefix: "far",
    iconName: "face-rolling-eyes",
    icon: [
        512,
        512,
        [
            128580,
            "meh-rolling-eyes"
        ],
        "f5a5",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 376c0 13.3 10.7 24 24 24H320c13.3 0 24-10.7 24-24s-10.7-24-24-24H192c-13.3 0-24 10.7-24 24zm-8-104c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm192-32c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    ]
};
var $3cf7a308d6bda284$export$fdc62a1bea767cc2 = $3cf7a308d6bda284$export$a6d72a9a068392b5;
var $3cf7a308d6bda284$export$40cdac24aa94a57a = {
    prefix: "far",
    iconName: "object-group",
    icon: [
        576,
        512,
        [],
        "f247",
        "M48 115.8C38.2 107 32 94.2 32 80c0-26.5 21.5-48 48-48c14.2 0 27 6.2 35.8 16H460.2c8.8-9.8 21.6-16 35.8-16c26.5 0 48 21.5 48 48c0 14.2-6.2 27-16 35.8V396.2c9.8 8.8 16 21.6 16 35.8c0 26.5-21.5 48-48 48c-14.2 0-27-6.2-35.8-16H115.8c-8.8 9.8-21.6 16-35.8 16c-26.5 0-48-21.5-48-48c0-14.2 6.2-27 16-35.8V115.8zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3V386.7c13.6 4.8 24.4 15.6 29.3 29.3H450.7c4.8-13.6 15.6-24.4 29.3-29.3V125.3c-13.6-4.8-24.4-15.6-29.3-29.3H125.3zm2.7 64c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"
    ]
};
var $3cf7a308d6bda284$export$e4b51a47a2f8b9db = {
    prefix: "far",
    iconName: "heart",
    icon: [
        512,
        512,
        [
            128153,
            128154,
            128155,
            128156,
            128420,
            129293,
            129294,
            129505,
            9829,
            10084,
            61578
        ],
        "f004",
        "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20c0 0-.1-.1-.1-.1c0 0 0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"
    ]
};
var $3cf7a308d6bda284$export$c938968e28178994 = {
    prefix: "far",
    iconName: "face-surprise",
    icon: [
        512,
        512,
        [
            128558,
            "surprise"
        ],
        "f5c2",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $3cf7a308d6bda284$export$46647c72213f53ba = $3cf7a308d6bda284$export$c938968e28178994;
var $3cf7a308d6bda284$export$fbeef2513e05ad08 = {
    prefix: "far",
    iconName: "circle-pause",
    icon: [
        512,
        512,
        [
            62092,
            "pause-circle"
        ],
        "f28b",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $3cf7a308d6bda284$export$d8cf08a0362da8db = $3cf7a308d6bda284$export$fbeef2513e05ad08;
var $3cf7a308d6bda284$export$4280b2387fbdad12 = {
    prefix: "far",
    iconName: "circle",
    icon: [
        512,
        512,
        [
            128308,
            128309,
            128992,
            128993,
            128994,
            128995,
            128996,
            9679,
            9898,
            9899,
            11044,
            61708,
            61915
        ],
        "f111",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $3cf7a308d6bda284$export$72ea8a5e4e86cd69 = {
    prefix: "far",
    iconName: "circle-up",
    icon: [
        512,
        512,
        [
            61467,
            "arrow-alt-circle-up"
        ],
        "f35b",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4c-4.5 4.2-7.1 10.1-7.1 16.3c0 12.3 10 22.3 22.3 22.3H208v96c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h57.7c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.1-16.3L269.8 117.5c-3.8-3.5-8.7-5.5-13.8-5.5s-10.1 2-13.8 5.5L135.1 217.4z"
    ]
};
var $3cf7a308d6bda284$export$3747a8ef0995eadf = $3cf7a308d6bda284$export$72ea8a5e4e86cd69;
var $3cf7a308d6bda284$export$b8d24c57c9e64933 = {
    prefix: "far",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M64 464H320c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 272V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L129.4 376H112c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h17.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8zm85.8-4c11.6 20 18.2 43.3 18.2 68s-6.6 48-18.2 68c-6.6 11.5-21.3 15.4-32.8 8.8s-15.4-21.3-8.8-32.8c7.5-12.9 11.8-27.9 11.8-44s-4.3-31.1-11.8-44c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8z"
    ]
};
var $3cf7a308d6bda284$export$6440b286d3cbac9b = {
    prefix: "far",
    iconName: "file-image",
    icon: [
        384,
        512,
        [
            128443
        ],
        "f1c5",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm69.2 46.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-41.3 59.7-11.9-19.1c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5l-40 64c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2h48 32 40 72c6 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-72-104z"
    ]
};
var $3cf7a308d6bda284$export$d7cf0978afd90002 = {
    prefix: "far",
    iconName: "circle-question",
    icon: [
        512,
        512,
        [
            62108,
            "question-circle"
        ],
        "f059",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $3cf7a308d6bda284$export$5ba67d7f2265c1a5 = $3cf7a308d6bda284$export$d7cf0978afd90002;
var $3cf7a308d6bda284$export$38c072b870a9e4ab = {
    prefix: "far",
    iconName: "face-meh-blank",
    icon: [
        512,
        512,
        [
            128566,
            "meh-blank"
        ],
        "f5a4",
        "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $3cf7a308d6bda284$export$e945435725f71e88 = $3cf7a308d6bda284$export$38c072b870a9e4ab;
var $3cf7a308d6bda284$export$b8c3e79e8c99c95b = {
    prefix: "far",
    iconName: "eye",
    icon: [
        576,
        512,
        [
            128065
        ],
        "f06e",
        "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
    ]
};
var $3cf7a308d6bda284$export$e8ea88c55e55be7c = {
    prefix: "far",
    iconName: "face-sad-cry",
    icon: [
        512,
        512,
        [
            128557,
            "sad-cry"
        ],
        "f5b3",
        "M400 406.1V288c0-13.3-10.7-24-24-24s-24 10.7-24 24V440.6c-28.7 15-61.4 23.4-96 23.4s-67.3-8.5-96-23.4V288c0-13.3-10.7-24-24-24s-24 10.7-24 24V406.1C72.6 368.2 48 315 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59-24.6 112.2-64 150.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm166.6 9.7c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C391.7 186.8 371 180 351.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9zM208 320v32c0 26.5 21.5 48 48 48s48-21.5 48-48V320c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
    ]
};
var $3cf7a308d6bda284$export$8e924e6bd422cef9 = $3cf7a308d6bda284$export$e8ea88c55e55be7c;
var $3cf7a308d6bda284$export$143d0ca7d2200f20 = {
    prefix: "far",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm97 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L79 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM257 255c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"
    ]
};
var $3cf7a308d6bda284$export$703cd98be31ec905 = {
    prefix: "far",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [
            128470
        ],
        "f2d0",
        "M.3 89.5C.1 91.6 0 93.8 0 96V224 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64V224 96c0-35.3-28.7-64-64-64H64c-2.2 0-4.4 .1-6.5 .3c-9.2 .9-17.8 3.8-25.5 8.2C21.8 46.5 13.4 55.1 7.7 65.5c-3.9 7.3-6.5 15.4-7.4 24zM48 224H464l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192z"
    ]
};
var $3cf7a308d6bda284$export$e5f78e87efbb0248 = {
    prefix: "far",
    iconName: "face-frown",
    icon: [
        512,
        512,
        [
            9785,
            "frown"
        ],
        "f119",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM174.6 384.1c-4.5 12.5-18.2 18.9-30.7 14.4s-18.9-18.2-14.4-30.7C146.9 319.4 198.9 288 256 288s109.1 31.4 126.6 79.9c4.5 12.5-2 26.2-14.4 30.7s-26.2-2-30.7-14.4C328.2 358.5 297.2 336 256 336s-72.2 22.5-81.4 48.1zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $3cf7a308d6bda284$export$43b7108508aecc5f = $3cf7a308d6bda284$export$e5f78e87efbb0248;
var $3cf7a308d6bda284$export$f62f2879ccaea13f = {
    prefix: "far",
    iconName: "floppy-disk",
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var $3cf7a308d6bda284$export$1aaa83ff70706e1e = $3cf7a308d6bda284$export$f62f2879ccaea13f;
var $3cf7a308d6bda284$export$63ffcb3d4e94cb92 = {
    prefix: "far",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $3cf7a308d6bda284$export$49ee382a2425e89c = $3cf7a308d6bda284$export$63ffcb3d4e94cb92;
var $3cf7a308d6bda284$export$5d53da7627754bc6 = {
    prefix: "far",
    iconName: "face-grin-squint",
    icon: [
        512,
        512,
        [
            128518,
            "grin-squint"
        ],
        "f585",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zm-216-161.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $3cf7a308d6bda284$export$243ae757907b1580 = $3cf7a308d6bda284$export$5d53da7627754bc6;
var $3cf7a308d6bda284$export$d97ff927c450c87f = {
    prefix: "far",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M160 64c0-8.8 7.2-16 16-16s16 7.2 16 16V200c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c7.8 0 14.3 5.6 15.7 13c1.6 8.2 7.3 15.1 15.1 18s16.7 1.6 23.3-3.6c2.7-2.1 6.1-3.4 9.9-3.4c8.8 0 16 7.2 16 16l0 16V392c0 39.8-32.2 72-72 72H272 212.3h-.9c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4L116 353.2c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V320 64zM176 0c-35.3 0-64 28.7-64 64V261.7C91.2 238 55.5 232.8 28.5 250.7C-.9 270.4-8.9 310.1 10.8 339.5L78.3 440.8c29.7 44.5 79.6 71.2 133.1 71.2h.9H272h56c66.3 0 120-53.7 120-120V288l0-16c0-35.3-28.7-64-64-64c-4.5 0-8.8 .5-13 1.3c-11.7-15.4-30.2-25.3-51-25.3c-6.9 0-13.5 1.1-19.7 3.1C288.7 170.7 269.6 160 248 160c-2.7 0-5.4 .2-8 .5V64c0-35.3-28.7-64-64-64zm48 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"
    ]
};
var $3cf7a308d6bda284$export$c578e919f2c5c135 = {
    prefix: "far",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M.2 276.3c-1.2-35.3 26.4-65 61.7-66.2l3.3-.1L57 208.1C22.5 200.5 .7 166.3 8.3 131.8S50.2 75.5 84.7 83.2l173 38.3c2.3-2.9 4.7-5.7 7.1-8.5l18.4-20.3C299.9 74.5 323.5 64 348.3 64l10.2 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 344c0 66.3-53.7 120-120 120l-8 0-96 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-.8 0-1.6 0-2.4L66.4 338c-35.3 1.2-65-26.4-66.2-61.7zm63.4-18.2c-8.8 .3-15.7 7.7-15.4 16.5s7.7 15.7 16.5 15.4l161.5-5.6c9.8-.3 18.7 5.3 22.7 14.2s2.2 19.3-4.5 26.4c-2.8 2.9-4.4 6.7-4.4 11c0 8.8 7.2 16 16 16c9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6c0 8.8 7.2 16 16 16l96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-10.2 0c-11.3 0-22 4.8-29.6 13.1l-17.5-15.9 17.5 15.9-18.4 20.3c-.6 .6-1.1 1.3-1.7 1.9l57 13.2c8.6 2 14 10.6 12 19.2s-10.6 14-19.2 12l-85.6-19.7L74.3 130c-8.6-1.9-17.2 3.5-19.1 12.2s3.5 17.2 12.2 19.1l187.5 41.6c10.2 2.3 17.8 10.9 18.7 21.4l.1 1c.6 6.6-1.5 13.1-5.8 18.1s-10.6 7.9-17.2 8.2L63.6 258.1z"
    ]
};
var $3cf7a308d6bda284$export$8ac6d81a3d5b40a1 = {
    prefix: "far",
    iconName: "face-grin-tears",
    icon: [
        640,
        512,
        [
            128514,
            "grin-tears"
        ],
        "f588",
        "M516.1 325.5c1 3 2.1 6 3.3 8.9c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c1.2-2.9 2.3-5.9 3.3-8.9C152.5 406.2 229.5 464 320 464s167.5-57.8 196.1-138.5zM320 48c-101.4 0-185.8 72.5-204.3 168.5c-6.7-3.1-14.3-4.3-22.3-3.1c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-8-1.2-15.7 .1-22.3 3.1C505.8 120.5 421.4 48 320 48zM78.5 341.1C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7zm483 0c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zM439 336.5C414.4 374.6 370.3 400 319.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1zM281.6 228.8l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0zm160 0l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0z"
    ]
};
var $3cf7a308d6bda284$export$b2f7512221512b5b = $3cf7a308d6bda284$export$8ac6d81a3d5b40a1;
var $3cf7a308d6bda284$export$3c70ffe5660af060 = {
    prefix: "far",
    iconName: "calendar-xmark",
    icon: [
        448,
        512,
        [
            "calendar-times"
        ],
        "f273",
        "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zm-95 89l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $3cf7a308d6bda284$export$99b20d7352fbcf08 = $3cf7a308d6bda284$export$3c70ffe5660af060;
var $3cf7a308d6bda284$export$b44eb38345c6a964 = {
    prefix: "far",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM80 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v16l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1L240 368v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V288z"
    ]
};
var $3cf7a308d6bda284$export$38611f1c776aba73 = {
    prefix: "far",
    iconName: "file-pdf",
    icon: [
        512,
        512,
        [],
        "f1c1",
        "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"
    ]
};
var $3cf7a308d6bda284$export$805cd88398a70581 = {
    prefix: "far",
    iconName: "comment",
    icon: [
        512,
        512,
        [
            128489,
            61669
        ],
        "f075",
        "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9c.1-.2 .2-.3 .3-.5z"
    ]
};
var $3cf7a308d6bda284$export$6f095630677adc = {
    prefix: "far",
    iconName: "envelope",
    icon: [
        512,
        512,
        [
            128386,
            9993,
            61443
        ],
        "f0e0",
        "M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
    ]
};
var $3cf7a308d6bda284$export$b9098a890f61e022 = {
    prefix: "far",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [
            9203,
            62032,
            "hourglass-empty"
        ],
        "f254",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V67c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445v19H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V445c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM192 289.9l81.5 81.5C293 391 304 417.4 304 445v19H80V445c0-27.6 11-54 30.5-73.5L192 289.9zm0-67.9l-81.5-81.5C91 121 80 94.6 80 67V48H304V67c0 27.6-11 54-30.5 73.5L192 222.1z"
    ]
};
var $3cf7a308d6bda284$export$a2f8176a0161e891 = $3cf7a308d6bda284$export$b9098a890f61e022;
var $3cf7a308d6bda284$export$5655108e1162ba45 = {
    prefix: "far",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $3cf7a308d6bda284$export$4cb736b866cbb7ec = {
    prefix: "far",
    iconName: "hard-drive",
    icon: [
        512,
        512,
        [
            128436,
            "hdd"
        ],
        "f0a0",
        "M64 80c-8.8 0-16 7.2-16 16V258c5.1-1.3 10.5-2 16-2H448c5.5 0 10.9 .7 16 2V96c0-8.8-7.2-16-16-16H64zM48 320v96c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM0 320V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V320v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320zm280 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $3cf7a308d6bda284$export$62551e9c5ba7093f = $3cf7a308d6bda284$export$4cb736b866cbb7ec;
var $3cf7a308d6bda284$export$8ff56f5ebb8416a0 = {
    prefix: "far",
    iconName: "face-grin-squint-tears",
    icon: [
        512,
        512,
        [
            129315,
            "grin-squint-tears"
        ],
        "f586",
        "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-14.8 14.8-65.7 23.6-88.3 26.7c-5.6 .9-10.3-3.9-9.5-9.5C403.3 79.9 412 29 426.8 14.2zM75 75C158.2-8.3 284.5-22.2 382.2 33.2c-1.5 4.8-2.9 9.6-4.1 14.3c-3.1 12.2-5.5 24.6-7.3 35c-80.8-53.6-190.7-44.8-261.9 26.4C37.7 180.1 28.9 290 82.5 370.8c-10.5 1.8-22.9 4.2-35 7.3c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75zm389.6 58.9c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c3.1-12.2 5.5-24.6 7.3-35c80.8 53.6 190.7 44.8 261.9-26.4c71.2-71.2 80-181.1 26.4-261.9c10.5-1.8 22.9-4.2 35-7.3zm-105.4 93c10.1-16.3 33.9-16.9 37.9 1.9c9.5 44.4-3.7 93.5-39.3 129.1s-84.8 48.8-129.1 39.3c-18.7-4-18.2-27.8-1.9-37.9c25.2-15.7 50.2-35.4 73.6-58.8s43.1-48.4 58.8-73.6zM92 265.3l97.4-29.7c11.6-3.5 22.5 7.3 19 19l-29.7 97.4c-2.6 8.6-13.4 11.3-19.8 4.9c-2-2-3.2-4.6-3.4-7.3l-5.1-56.1-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4c-6.3-6.3-3.6-17.2 4.9-19.8zm193-178.2c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8 .3 5.4 1.5 7.3 3.4c6.3 6.3 3.6 17.2-4.9 19.8l-97.4 29.7c-11.6 3.5-22.5-7.3-19-19L265.3 92c2.6-8.6 13.4-11.3 19.8-4.9zM14.9 497.1c-19.6-19.6-20-51-.7-70.3C29 412 79.8 403.2 102.4 400.1c5.6-.9 10.3 3.9 9.5 9.5c-3.2 22.5-11.9 73.5-26.7 88.3C66 517 34.5 516.6 14.9 497.1z"
    ]
};
var $3cf7a308d6bda284$export$542206d6a85f3b42 = $3cf7a308d6bda284$export$8ff56f5ebb8416a0;
var $3cf7a308d6bda284$export$1f7600fa9fdb3978 = {
    prefix: "far",
    iconName: "rectangle-list",
    icon: [
        576,
        512,
        [
            "list-alt"
        ],
        "f022",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $3cf7a308d6bda284$export$c6327a203ffc65a3 = $3cf7a308d6bda284$export$1f7600fa9fdb3978;
var $3cf7a308d6bda284$export$16768a660ae3ca9d = {
    prefix: "far",
    iconName: "calendar-plus",
    icon: [
        448,
        512,
        [],
        "f271",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192zm176 40c-13.3 0-24 10.7-24 24v48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24V352h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V256c0-13.3-10.7-24-24-24z"
    ]
};
var $3cf7a308d6bda284$export$5ae86b9da9cca3bd = {
    prefix: "far",
    iconName: "circle-left",
    icon: [
        512,
        512,
        [
            61840,
            "arrow-alt-circle-left"
        ],
        "f359",
        "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3V304h96c17.7 0 32-14.3 32-32V240c0-17.7-14.3-32-32-32H256V150.3c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L117.5 242.2c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8l99.9 107.1z"
    ]
};
var $3cf7a308d6bda284$export$5460a5b11a24996f = $3cf7a308d6bda284$export$5ae86b9da9cca3bd;
var $3cf7a308d6bda284$export$a312c7d58dd44a75 = {
    prefix: "far",
    iconName: "money-bill-1",
    icon: [
        576,
        512,
        [
            "money-bill-alt"
        ],
        "f3d1",
        "M112 112c0 35.3-28.7 64-64 64V336c35.3 0 64 28.7 64 64H464c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64H112zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm80-48c0 8.8 7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24 24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z"
    ]
};
var $3cf7a308d6bda284$export$a35d573395884c3d = $3cf7a308d6bda284$export$a312c7d58dd44a75;
var $3cf7a308d6bda284$export$95b9968e7fceb821 = {
    prefix: "far",
    iconName: "clock",
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $3cf7a308d6bda284$export$9a575facf1cab48f = $3cf7a308d6bda284$export$95b9968e7fceb821;
var $3cf7a308d6bda284$export$fb61df5d98785fa8 = {
    prefix: "far",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [
            9000
        ],
        "f11c",
        "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM176 320H400c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm-72-72c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16z"
    ]
};
var $3cf7a308d6bda284$export$8e047801a8603af7 = {
    prefix: "far",
    iconName: "closed-captioning",
    icon: [
        576,
        512,
        [],
        "f20a",
        "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
    ]
};
var $3cf7a308d6bda284$export$74f06b41ed2ca28a = {
    prefix: "far",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M160 80H512c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H490.8L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM96 96V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $3cf7a308d6bda284$export$92292137ef3cf4c8 = {
    prefix: "far",
    iconName: "face-grin",
    icon: [
        512,
        512,
        [
            128512,
            "grin"
        ],
        "f580",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $3cf7a308d6bda284$export$37e1f10b6de76621 = $3cf7a308d6bda284$export$92292137ef3cf4c8;
var $3cf7a308d6bda284$export$dc130582748497c6 = {
    prefix: "far",
    iconName: "face-meh",
    icon: [
        512,
        512,
        [
            128528,
            "meh"
        ],
        "f11a",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
    ]
};
var $3cf7a308d6bda284$export$6d2db489aaeeecd2 = $3cf7a308d6bda284$export$dc130582748497c6;
var $3cf7a308d6bda284$export$782ac893fc22249b = {
    prefix: "far",
    iconName: "id-card",
    icon: [
        576,
        512,
        [
            62147,
            "drivers-license"
        ],
        "f2c2",
        "M528 160V416c0 8.8-7.2 16-16 16H320c0-44.2-35.8-80-80-80H176c-44.2 0-80 35.8-80 80H64c-8.8 0-16-7.2-16-16V160H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"
    ]
};
var $3cf7a308d6bda284$export$8359c70e609eff64 = $3cf7a308d6bda284$export$782ac893fc22249b;
var $3cf7a308d6bda284$export$2fa35dcbc038dbe9 = {
    prefix: "far",
    iconName: "sun",
    icon: [
        512,
        512,
        [
            9728
        ],
        "f185",
        "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l18.1-98.5 98.5-18.1c8-1.5 14.7-6.9 17.8-14.4s2.2-16.1-2.4-22.8L450.9 256l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L375.7 19.7zM269.6 110l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4L402 242.4c-5.7 8.2-5.7 19 0 27.2l45.2 65.6-78.3 14.4c-9.8 1.8-17.5 9.5-19.3 19.3l-14.4 78.3L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var $3cf7a308d6bda284$export$600a1b26b33c3d47 = {
    prefix: "far",
    iconName: "face-laugh-wink",
    icon: [
        512,
        512,
        [
            "laugh-wink"
        ],
        "f59c",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
var $3cf7a308d6bda284$export$77ac40095f39933e = $3cf7a308d6bda284$export$600a1b26b33c3d47;
var $3cf7a308d6bda284$export$531badb89cf01312 = {
    prefix: "far",
    iconName: "circle-down",
    icon: [
        512,
        512,
        [
            61466,
            "arrow-alt-circle-down"
        ],
        "f358",
        "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3H304V160c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32v96H150.3C138 256 128 266 128 278.3c0 6.2 2.6 12.1 7.1 16.3l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9z"
    ]
};
var $3cf7a308d6bda284$export$ff3afbc8c0bc5d59 = $3cf7a308d6bda284$export$531badb89cf01312;
var $3cf7a308d6bda284$export$aba24ca305bbe8c1 = {
    prefix: "far",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [
            128078,
            61576
        ],
        "f165",
        "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16H286.5c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8H384c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32z"
    ]
};
var $3cf7a308d6bda284$export$3db75d5ac9e98468 = {
    prefix: "far",
    iconName: "chess-pawn",
    icon: [
        320,
        512,
        [
            9823
        ],
        "f443",
        "M232 152A72 72 0 1 0 88 152a72 72 0 1 0 144 0zm24 120H243.4l10.7 80H205.7L195 272H160 125l-10.7 80H65.9l10.7-80H64c-13.3 0-24-10.7-24-24s10.7-24 24-24c-15.1-20.1-24-45-24-72C40 85.7 93.7 32 160 32s120 53.7 120 120c0 27-8.9 51.9-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24zM52.7 464H267.3l-16.6-32H69.2L52.7 464zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384h201z"
    ]
};
var $3cf7a308d6bda284$export$3e7437bf6535bef0 = {
    prefix: "far",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [
            128179,
            62083,
            "credit-card-alt"
        ],
        "f09d",
        "M512 80c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16H512zm16 144V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"
    ]
};
var $3cf7a308d6bda284$export$5fffe8e3c36964a2 = $3cf7a308d6bda284$export$3e7437bf6535bef0;
var $3cf7a308d6bda284$export$9b6162797ab1b255 = {
    prefix: "far",
    iconName: "bell",
    icon: [
        448,
        512,
        [
            128276,
            61602
        ],
        "f0f3",
        "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v25.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112v25.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V208c0-61.9 50.1-112 112-112zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
    ]
};
var $3cf7a308d6bda284$export$cad54bead856a678 = {
    prefix: "far",
    iconName: "file",
    icon: [
        384,
        512,
        [
            128196,
            128459,
            61462
        ],
        "f15b",
        "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"
    ]
};
var $3cf7a308d6bda284$export$7a76c9d35b42d691 = {
    prefix: "far",
    iconName: "hospital",
    icon: [
        640,
        512,
        [
            127973,
            62589,
            "hospital-alt",
            "hospital-wide"
        ],
        "f0f8",
        "M232 0c-39.8 0-72 32.2-72 72v8H72C32.2 80 0 112.2 0 152V440c0 39.8 32.2 72 72 72h.2 .2 .2 .2 .2H73h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H75h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H77h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H79h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H82h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H85h.2 .2 .2 .2H86h.2 .2 .2 .2H87h.2 .2 .2 .2H88h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H98h.2 .2 .2 .2H99h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2v0H456h8v0H568c39.8 0 72-32.2 72-72V152c0-39.8-32.2-72-72-72H480V72c0-39.8-32.2-72-72-72H232zM480 128h88c13.3 0 24 10.7 24 24v40H536c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v48H536c-13.3 0-24 10.7-24 24s10.7 24 24 24h56V440c0 13.3-10.7 24-24 24H480V336 128zM72 128h88V464h-.1-.2-.2-.2H159h-.2-.2-.2H158h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H154h-.2-.2-.2H153h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H150h-.2-.2-.2H149h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H146h-.2-.2-.2H145h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H142h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H139h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H136h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H133h-.2-.2-.2-.2-.2-.2-.2-.2H131h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H128h-.2-.2-.2-.2-.2-.2-.2-.2H126h-.2-.2-.2-.2-.2-.2-.2-.2H124h-.2-.2-.2-.2-.2-.2-.2-.2H122h-.2-.2-.2-.2-.2-.2-.2-.2H120h-.2-.2-.2-.2-.2-.2-.2-.2H118h-.2-.2-.2-.2-.2-.2-.2-.2H116h-.2-.2-.2-.2-.2-.2-.2-.2H114h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H111h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H108h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H105h-.2-.2-.2-.2H104h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H100h-.2-.2-.2-.2H99h-.2-.2-.2-.2H98h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H88h-.2-.2-.2-.2H87h-.2-.2-.2-.2H86h-.2-.2-.2-.2H85h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H82h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H79h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H77h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H75h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H73h-.2-.2-.2-.2-.2H72c-13.2 0-24-10.7-24-24V336h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V240h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V152c0-13.3 10.7-24 24-24zM208 72c0-13.3 10.7-24 24-24H408c13.3 0 24 10.7 24 24V336 464H368V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H208V72zm88 24v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V168h24c8.8 0 16-7.2 16-16V136c0-8.8-7.2-16-16-16H344V96c0-8.8-7.2-16-16-16H312c-8.8 0-16 7.2-16 16z"
    ]
};
var $3cf7a308d6bda284$export$cea7736417b94a3b = $3cf7a308d6bda284$export$7a76c9d35b42d691;
var $3cf7a308d6bda284$export$69c8cc0360f017e8 = $3cf7a308d6bda284$export$7a76c9d35b42d691;
var $3cf7a308d6bda284$export$5d65c40a109eb09c = {
    prefix: "far",
    iconName: "chess-rook",
    icon: [
        448,
        512,
        [
            9820
        ],
        "f447",
        "M80 80V192c0 2.5 1.2 4.9 3.2 6.4l51.2 38.4c6.8 5.1 10.4 13.4 9.5 21.9L133.5 352H85.2l9.4-85L54.4 236.8C40.3 226.2 32 209.6 32 192V72c0-22.1 17.9-40 40-40H376c22.1 0 40 17.9 40 40V192c0 17.6-8.3 34.2-22.4 44.8L353.4 267l9.4 85H314.5l-10.4-93.3c-.9-8.4 2.7-16.8 9.5-21.9l51.2-38.4c2-1.5 3.2-3.9 3.2-6.4V80H304v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H192v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H80zm4.7 384H363.3l-16.6-32H101.2L84.7 464zm271.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H72.8C50.2 512 32 493.8 32 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C68.5 390.7 79.5 384 91.5 384h265zM208 288c-8.8 0-16-7.2-16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 8.8-7.2 16-16 16H208z"
    ]
};
var $3cf7a308d6bda284$export$228008b5e11032fa = {
    prefix: "far",
    iconName: "star-half",
    icon: [
        576,
        512,
        [
            61731
        ],
        "f089",
        "M293.3 .6c10.9 2.5 18.6 12.2 18.6 23.4V408.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.3c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9zM263.9 128.4l-28.6 58.8c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l92.5-49.4V128.4z"
    ]
};
var $3cf7a308d6bda284$export$d5713874f8fefe1b = {
    prefix: "far",
    iconName: "chess-king",
    icon: [
        448,
        512,
        [
            9818
        ],
        "f43f",
        "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V56H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v40H59.6C26.7 144 0 170.7 0 203.6c0 8.2 1.7 16.3 4.9 23.8L59.1 352h52.3L49 208.2c-.6-1.5-1-3-1-4.6c0-6.4 5.2-11.6 11.6-11.6H224 388.4c6.4 0 11.6 5.2 11.6 11.6c0 1.6-.3 3.2-1 4.6L336.5 352h52.3l54.2-124.6c3.3-7.5 4.9-15.6 4.9-23.8c0-32.9-26.7-59.6-59.6-59.6H248V104h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V24zM101.2 432H346.8l16.6 32H84.7l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3H91.5c-12 0-22.9 6.7-28.4 17.3L36.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C32 493.8 50.2 512 72.8 512H375.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
    ]
};
var $3cf7a308d6bda284$export$9a5c11a5e3d7f1e7 = {
    prefix: "far",
    iconName: "circle-user",
    icon: [
        512,
        512,
        [
            62142,
            "user-circle"
        ],
        "f2bd",
        "M406.5 399.6C387.4 352.9 341.5 320 288 320H224c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"
    ]
};
var $3cf7a308d6bda284$export$be7d974e9e0dba1a = $3cf7a308d6bda284$export$9a5c11a5e3d7f1e7;
var $3cf7a308d6bda284$export$e9bd786d30cb716c = {
    prefix: "far",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z"
    ]
};
var $3cf7a308d6bda284$export$928280bdd54fa173 = {
    prefix: "far",
    iconName: "share-from-square",
    icon: [
        576,
        512,
        [
            61509,
            "share-square"
        ],
        "f14d",
        "M400 255.4V240 208c0-8.8-7.2-16-16-16H352 336 289.5c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112h48 16 32c8.8 0 16-7.2 16-16V80 64.6L506 160 400 255.4zM336 240h16v48c0 17.7 14.3 32 32 32h3.7c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7V80H336 304 288c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4h2.5c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5l0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5H304h32zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
    ]
};
var $3cf7a308d6bda284$export$ae9e1434571f373c = $3cf7a308d6bda284$export$928280bdd54fa173;
var $3cf7a308d6bda284$export$da61665fff8aebfe = {
    prefix: "far",
    iconName: "copyright",
    icon: [
        512,
        512,
        [
            169
        ],
        "f1f9",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z"
    ]
};
var $3cf7a308d6bda284$export$fc82fb79180cd17c = {
    prefix: "far",
    iconName: "map",
    icon: [
        576,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M565.6 36.2C572.1 40.7 576 48.1 576 56V392c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5V421.2l120-45.7V90.8L48 136.5zM360 422.7V137.3l-144-48V374.7l144 48zm48-1.5l120-45.7V90.8L408 136.5V421.2z"
    ]
};
var $3cf7a308d6bda284$export$6b31a1e5968b2378 = {
    prefix: "far",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [
            128277,
            61943
        ],
        "f1f6",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6C495.5 322.9 480 278.8 480 233.4V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V51.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM224 150.3C243.6 117.7 279.3 96 320 96c61.9 0 112 50.1 112 112v25.4c0 32.7 6.4 64.8 18.7 94.5L224 150.3zM406.2 416l-60.9-48H168.3c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1v11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6H406.2zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
    ]
};
var $3cf7a308d6bda284$export$54608d0a883fea4d = {
    prefix: "far",
    iconName: "hand-lizard",
    icon: [
        512,
        512,
        [],
        "f258",
        "M72 112c-13.3 0-24 10.7-24 24s10.7 24 24 24H240c35.3 0 64 28.7 64 64s-28.7 64-64 64H136c-13.3 0-24 10.7-24 24s10.7 24 24 24H288c4.5 0 8.9 1.3 12.7 3.6l64 40c7 4.4 11.3 12.1 11.3 20.4v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V413.3L281.1 384H136c-39.8 0-72-32.2-72-72s32.2-72 72-72H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H72c-39.8 0-72-32.2-72-72S32.2 64 72 64H281.6c46.7 0 90.9 21.5 119.7 58.3l78.4 100.1c20.9 26.7 32.3 59.7 32.3 93.7V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V316.1c0-23.2-7.8-45.8-22.1-64.1L363.5 151.9c-19.7-25.2-49.9-39.9-81.9-39.9H72z"
    ]
};
var $3cf7a308d6bda284$export$b5023c446f10324 = {
    prefix: "far",
    iconName: "face-smile",
    icon: [
        512,
        512,
        [
            128578,
            "smile"
        ],
        "f118",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $3cf7a308d6bda284$export$c632b2334f0913bc = $3cf7a308d6bda284$export$b5023c446f10324;
var $3cf7a308d6bda284$export$e49e3cfceea441cc = {
    prefix: "far",
    iconName: "hand-peace",
    icon: [
        512,
        512,
        [
            9996
        ],
        "f25b",
        "M250.8 1.4c-35.2-3.7-66.6 21.8-70.3 57L174 119 156.7 69.6C145 36.3 108.4 18.8 75.1 30.5S24.2 78.8 35.9 112.1L88.7 262.2C73.5 276.7 64 297.3 64 320v0 24c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V272 256 224c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-.7 0-1.5 0-2.2 0l5.9-56.3c3.7-35.2-21.8-66.6-57-70.3zm-.2 155.4C243.9 166.9 240 179 240 192v48c0 .7 0 1.4 0 2c-5.1-1.3-10.5-2-16-2h-7.4l-5.4-15.3 17-161.3c.9-8.8 8.8-15.2 17.6-14.2s15.2 8.8 14.2 17.6l-9.5 90.1zM111.4 85.6L165.7 240H144c-4 0-8 .3-11.9 .9L81.2 96.2c-2.9-8.3 1.5-17.5 9.8-20.4s17.5 1.5 20.4 9.8zM288 192c0-8.8 7.2-16 16-16s16 7.2 16 16v32 16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192zm38.4 108c10.4 21.3 32.3 36 57.6 36c5.5 0 10.9-.7 16-2v10c0 66.3-53.7 120-120 120H232c-66.3 0-120-53.7-120-120l0-24 0 0c0-17.7 14.3-32 32-32h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2c7.9 0 15.4-1.4 22.4-4zM400 272c0 8.8-7.2 16-16 16s-16-7.2-16-16V240 224c0-8.8 7.2-16 16-16s16 7.2 16 16v32 16z"
    ]
};
var $3cf7a308d6bda284$export$fbb22081b65e4f33 = {
    prefix: "far",
    iconName: "face-grin-hearts",
    icon: [
        512,
        512,
        [
            128525,
            "grin-hearts"
        ],
        "f584",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM215.3 137.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm122.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
    ]
};
var $3cf7a308d6bda284$export$c56cf0e0c3bc5ed2 = $3cf7a308d6bda284$export$fbb22081b65e4f33;
var $3cf7a308d6bda284$export$f26673f8b10c3d46 = {
    prefix: "far",
    iconName: "building",
    icon: [
        384,
        512,
        [
            127970,
            61687
        ],
        "f1ad",
        "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16h80V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm88 40c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V104zM232 88h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V104c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V232zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V232c0-8.8 7.2-16 16-16z"
    ]
};
var $3cf7a308d6bda284$export$2ff38f330c834084 = {
    prefix: "far",
    iconName: "face-grin-beam-sweat",
    icon: [
        512,
        512,
        [
            128517,
            "grin-beam-sweat"
        ],
        "f583",
        "M476.8 126.3C497.1 120.8 512 102.7 512 81c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-9.5 12.6-27.1 37.2-36 57.5c-.3 .7-.6 1.4-.9 2.1C417.8 69.7 416 76 416 81c0 26 21.5 47 48 47c4.4 0 8.7-.6 12.8-1.7zM395.4 41.2C355.3 15.2 307.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8c-8.6 3.1-17.8 4.8-27.4 4.8c-8.9 0-17.6-1.5-25.7-4.2C454.7 185.5 464 219.7 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c48.7 0 93.4 16.7 128.9 44.7c-.6-3.8-.9-7.7-.9-11.7c0-11.4 3.8-22.4 7.1-30.5c1.3-3.1 2.7-6.2 4.3-9.3zM375 336.5c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5zM217.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"
    ]
};
var $3cf7a308d6bda284$export$14d0ccc54c5b6826 = $3cf7a308d6bda284$export$2ff38f330c834084;
var $3cf7a308d6bda284$export$c4c2f69a53bab720 = {
    prefix: "far",
    iconName: "moon",
    icon: [
        384,
        512,
        [
            127769,
            9214
        ],
        "f186",
        "M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0c-.1 0-.2 0-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z"
    ]
};
var $3cf7a308d6bda284$export$34f5c36a3e80efa2 = {
    prefix: "far",
    iconName: "calendar",
    icon: [
        448,
        512,
        [
            128197,
            128198
        ],
        "f133",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"
    ]
};
var $3cf7a308d6bda284$export$4272e56f2429da88 = {
    prefix: "far",
    iconName: "face-grin-tongue-wink",
    icon: [
        512,
        512,
        [
            128540,
            "grin-tongue-wink"
        ],
        "f58b",
        "M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4V363.5c8.8-8 16.6-17.1 23-27c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c6.5 10 14.3 19.1 23.1 27.1V416c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm176.7 12a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-.4-72a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64V378.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"
    ]
};
var $3cf7a308d6bda284$export$58099903d50aefb3 = $3cf7a308d6bda284$export$4272e56f2429da88;
var $3cf7a308d6bda284$export$76c1aa4bf9a39458 = {
    prefix: "far",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M64 464H288c8.8 0 16-7.2 16-16V384h48v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM224 304H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16V288c0 8.8 7.2 16 16 16zm-64-16V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z"
    ]
};
var $3cf7a308d6bda284$export$67a047c738fb34da = {
    prefix: "far",
    iconName: "face-angry",
    icon: [
        512,
        512,
        [
            128544,
            "angry"
        ],
        "f556",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.4-118.5c9.7-9 10.2-24.2 1.2-33.9C315.3 344.3 290.6 328 256 328s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $3cf7a308d6bda284$export$3c96c08e234498c5 = $3cf7a308d6bda284$export$67a047c738fb34da;
var $3cf7a308d6bda284$export$3896694b3e81fba7 = {
    prefix: "far",
    iconName: "rectangle-xmark",
    icon: [
        512,
        512,
        [
            62164,
            "rectangle-times",
            "times-rectangle",
            "window-close"
        ],
        "f410",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm175 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $3cf7a308d6bda284$export$eaaf26416a51dc1 = $3cf7a308d6bda284$export$3896694b3e81fba7;
var $3cf7a308d6bda284$export$10147c0014152a3f = $3cf7a308d6bda284$export$3896694b3e81fba7;
var $3cf7a308d6bda284$export$18b7775f78a3e16 = $3cf7a308d6bda284$export$3896694b3e81fba7;
var $3cf7a308d6bda284$export$b5378818301da1be = {
    prefix: "far",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [
            61913
        ],
        "f1d8",
        "M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376V479.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"
    ]
};
var $3cf7a308d6bda284$export$53dd2cacf674142a = {
    prefix: "far",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1 .2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L419.3 58.8C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L58.8 92.7C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-11.8-11.8zm-34.1-34.1l-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zM385.1 92.9l-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3L126.9 92.9C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8L92.9 385.1C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $3cf7a308d6bda284$export$bd5bd2ef56b793b1 = {
    prefix: "far",
    iconName: "face-grimace",
    icon: [
        512,
        512,
        [
            128556,
            "grimace"
        ],
        "f57f",
        "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h8V320h-8zm40 48h32V320H208v48zm96 0V320H272v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zM168 288H344c30.9 0 56 25.1 56 56s-25.1 56-56 56H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $3cf7a308d6bda284$export$3d08cd36ac1ef231 = $3cf7a308d6bda284$export$bd5bd2ef56b793b1;
var $3cf7a308d6bda284$export$23e8b4955c2d951b = {
    prefix: "far",
    iconName: "calendar-minus",
    icon: [
        448,
        512,
        [],
        "f272",
        "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM296 352H152c-13.3 0-24-10.7-24-24s10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $3cf7a308d6bda284$export$30262489773a79a3 = {
    prefix: "far",
    iconName: "circle-xmark",
    icon: [
        512,
        512,
        [
            61532,
            "times-circle",
            "xmark-circle"
        ],
        "f057",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var $3cf7a308d6bda284$export$ab0ec50720a747eb = $3cf7a308d6bda284$export$30262489773a79a3;
var $3cf7a308d6bda284$export$90ac4096df8efdee = $3cf7a308d6bda284$export$30262489773a79a3;
var $3cf7a308d6bda284$export$47e4e0d519d33497 = {
    prefix: "far",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [
            128077,
            61575
        ],
        "f164",
        "M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.2s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16H286.5c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8H384c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32z"
    ]
};
var $3cf7a308d6bda284$export$26a3f9d2784b90d8 = {
    prefix: "far",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [
            128469
        ],
        "f2d1",
        "M24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
    ]
};
var $3cf7a308d6bda284$export$7ec6541fee081990 = {
    prefix: "far",
    iconName: "square-full",
    icon: [
        512,
        512,
        [
            128997,
            128998,
            128999,
            129000,
            129001,
            129002,
            129003,
            11035,
            11036
        ],
        "f45c",
        "M464 48V464H48V48H464zM48 0H0V48 464v48H48 464h48V464 48 0H464 48z"
    ]
};
var $3cf7a308d6bda284$export$4a4e034527c933f5 = {
    prefix: "far",
    iconName: "note-sticky",
    icon: [
        448,
        512,
        [
            62026,
            "sticky-note"
        ],
        "f249",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H288V352c0-17.7 14.3-32 32-32h80V96c0-8.8-7.2-16-16-16H64zM288 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V320v5.5c0 17-6.7 33.3-18.7 45.3l-90.5 90.5c-12 12-28.3 18.7-45.3 18.7H288z"
    ]
};
var $3cf7a308d6bda284$export$80889adc5d98bf4a = $3cf7a308d6bda284$export$4a4e034527c933f5;
var $3cf7a308d6bda284$export$8a5a0dbb2a17e253 = {
    prefix: "far",
    iconName: "face-sad-tear",
    icon: [
        512,
        512,
        [
            128546,
            "sad-tear"
        ],
        "f5b4",
        "M175.9 448c-35-.1-65.5-22.6-76-54.6C67.6 356.8 48 308.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208s-93.1 208-208 208c-28.4 0-55.5-5.7-80.1-16zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 369c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C156.6 308.6 128 349 128 369zm128-65c-13.3 0-24 10.7-24 24s10.7 24 24 24c30.7 0 58.7 11.5 80 30.6c9.9 8.8 25 8 33.9-1.9s8-25-1.9-33.9C338.3 320.2 299 304 256 304zm47.6-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $3cf7a308d6bda284$export$4b5241926f692f91 = $3cf7a308d6bda284$export$8a5a0dbb2a17e253;
var $3cf7a308d6bda284$export$b276ec3dc9760d39 = {
    prefix: "far",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M64 128l177.6 0c-1 5.2-1.6 10.5-1.6 16l0 16-32 0L64 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 16c0-17.7 14.3-32 32-32c0 0 0 0 0 0l24 0c66.3 0 120 53.7 120 120l0 48c0 52.5-33.7 97.1-80.7 113.4c.5-3.1 .7-6.2 .7-9.4c0-20-9.2-37.9-23.6-49.7c4.9-9 7.6-19.4 7.6-30.3c0-15.1-5.3-29-14-40c8.8-11 14-24.9 14-40l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-40zm32-80s0 0 0 0c-18 0-34.6 6-48 16L64 80C28.7 80 0 108.7 0 144s28.7 64 64 64l82 0c-1.3 5.1-2 10.5-2 16c0 25.3 14.7 47.2 36 57.6c-2.6 7-4 14.5-4 22.4c0 20 9.2 37.9 23.6 49.7c-4.9 9-7.6 19.4-7.6 30.3c0 35.3 28.7 64 64 64l64 0 24 0c92.8 0 168-75.2 168-168l0-48c0-92.8-75.2-168-168-168l-24 0zM256 400c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0zM240 224c0 5.5 .7 10.9 2 16l-2 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0 16zm24 64l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0z"
    ]
};
var $3cf7a308d6bda284$export$f9059ea71e16fa16 = {
    faTrashCan: $3cf7a308d6bda284$export$864bb8d6c21fb792,
    faTrashAlt: $3cf7a308d6bda284$export$88df7ff7eb32f9dc,
    faMessage: $3cf7a308d6bda284$export$6563a67224e7f879,
    faCommentAlt: $3cf7a308d6bda284$export$6e96904d9af0ec4a,
    faFileLines: $3cf7a308d6bda284$export$ef565d07efe2b5e9,
    faFileAlt: $3cf7a308d6bda284$export$243b47dca32bf0b8,
    faFileText: $3cf7a308d6bda284$export$f466100bf9bf37a5,
    faCalendarDays: $3cf7a308d6bda284$export$31c6cf6f5d38dc0,
    faCalendarAlt: $3cf7a308d6bda284$export$cbc139f33cff356,
    faHandPointRight: $3cf7a308d6bda284$export$f7bc8714c970afa4,
    faFaceSmileBeam: $3cf7a308d6bda284$export$e3c56ed54f074063,
    faSmileBeam: $3cf7a308d6bda284$export$54ada6dc9690e0ca,
    faFaceGrinStars: $3cf7a308d6bda284$export$1d1fbac384a76a12,
    faGrinStars: $3cf7a308d6bda284$export$64347a5c8c402ef4,
    faAddressBook: $3cf7a308d6bda284$export$853fd1561789e3bb,
    faContactBook: $3cf7a308d6bda284$export$594b5a5d4d2e156b,
    faComments: $3cf7a308d6bda284$export$932912e74adb8939,
    faPaste: $3cf7a308d6bda284$export$6f95f90dd1f6d86b,
    faFileClipboard: $3cf7a308d6bda284$export$ca3229c47de163fa,
    faFaceGrinTongueSquint: $3cf7a308d6bda284$export$8eee2c17ff89e724,
    faGrinTongueSquint: $3cf7a308d6bda284$export$4edf34c3def09a31,
    faFaceFlushed: $3cf7a308d6bda284$export$ba5dc4287853ecbd,
    faFlushed: $3cf7a308d6bda284$export$dfd2bd012685aeac,
    faSquareCaretRight: $3cf7a308d6bda284$export$5b1d41cdd118ea6d,
    faCaretSquareRight: $3cf7a308d6bda284$export$ae86c9de7e0f62fa,
    faSquareMinus: $3cf7a308d6bda284$export$814c9edba7b84aa4,
    faMinusSquare: $3cf7a308d6bda284$export$ffe9387966b3e681,
    faCompass: $3cf7a308d6bda284$export$b4d344633433e50e,
    faSquareCaretDown: $3cf7a308d6bda284$export$a1ab39cd66c4e50e,
    faCaretSquareDown: $3cf7a308d6bda284$export$61aea18df1c84401,
    faFaceKissBeam: $3cf7a308d6bda284$export$eca99665af566fe1,
    faKissBeam: $3cf7a308d6bda284$export$d6ff8a73c0812e63,
    faLightbulb: $3cf7a308d6bda284$export$1e80f89fe84a215b,
    faFlag: $3cf7a308d6bda284$export$6591b1ea509be9da,
    faSquareCheck: $3cf7a308d6bda284$export$5bb6a0c94ad2f4bb,
    faCheckSquare: $3cf7a308d6bda284$export$f0c8040f596df7fe,
    faCircleDot: $3cf7a308d6bda284$export$aa13d9234890e8d3,
    faDotCircle: $3cf7a308d6bda284$export$92bc269cb244d66a,
    faFaceDizzy: $3cf7a308d6bda284$export$635e4d8cc8428961,
    faDizzy: $3cf7a308d6bda284$export$89a2b10dabc487e8,
    faFutbol: $3cf7a308d6bda284$export$65a345b33858a655,
    faFutbolBall: $3cf7a308d6bda284$export$51a344ca0a215620,
    faSoccerBall: $3cf7a308d6bda284$export$f4a29712c724ba2d,
    faPenToSquare: $3cf7a308d6bda284$export$ba236543926e3569,
    faEdit: $3cf7a308d6bda284$export$7be713e57d023733,
    faHourglassHalf: $3cf7a308d6bda284$export$703272eebf5e3eea,
    faHourglass2: $3cf7a308d6bda284$export$f1052bbf6bf361c0,
    faEyeSlash: $3cf7a308d6bda284$export$ed3f2918429d029a,
    faHand: $3cf7a308d6bda284$export$f69db0b876f7d753,
    faHandPaper: $3cf7a308d6bda284$export$6e6216c8b50471bb,
    faHandSpock: $3cf7a308d6bda284$export$2262d6b626de1120,
    faFaceKiss: $3cf7a308d6bda284$export$5a54c83033a0a56a,
    faKiss: $3cf7a308d6bda284$export$c762a77aabf64fd0,
    faFaceGrinTongue: $3cf7a308d6bda284$export$95a7394c24f57943,
    faGrinTongue: $3cf7a308d6bda284$export$ef222816a43a4b3a,
    faChessBishop: $3cf7a308d6bda284$export$a831eedd2f59c62f,
    faFaceGrinWink: $3cf7a308d6bda284$export$1dd161850c5bc64e,
    faGrinWink: $3cf7a308d6bda284$export$2397fcd34eb12177,
    faFaceGrinWide: $3cf7a308d6bda284$export$bdbabf493c478cde,
    faGrinAlt: $3cf7a308d6bda284$export$b4abebfe416d36ba,
    faFaceFrownOpen: $3cf7a308d6bda284$export$c8a28356e07b9ccb,
    faFrownOpen: $3cf7a308d6bda284$export$c4775e66bed5d96,
    faHandPointUp: $3cf7a308d6bda284$export$cdc9f5e7e94e76da,
    faBookmark: $3cf7a308d6bda284$export$4ed9da5c3cca0ef1,
    faHandPointDown: $3cf7a308d6bda284$export$f6dcbf0a940428f4,
    faFolder: $3cf7a308d6bda284$export$72b780186370e953,
    faFolderBlank: $3cf7a308d6bda284$export$9ef114244d26da0,
    faUser: $3cf7a308d6bda284$export$f5699fa0844e0188,
    faSquareCaretLeft: $3cf7a308d6bda284$export$2c5163541229363,
    faCaretSquareLeft: $3cf7a308d6bda284$export$d0c8ba444f1f9581,
    faStar: $3cf7a308d6bda284$export$a3b0eb2cd7942125,
    faChessKnight: $3cf7a308d6bda284$export$861b1f13085cf122,
    faFaceLaughSquint: $3cf7a308d6bda284$export$67ca89c1ca38d559,
    faLaughSquint: $3cf7a308d6bda284$export$b206e700cf7084e1,
    faFaceLaugh: $3cf7a308d6bda284$export$2f203616c892d415,
    faLaugh: $3cf7a308d6bda284$export$6c74e314e801a4fe,
    faFolderOpen: $3cf7a308d6bda284$export$ff7e93418af88b78,
    faClipboard: $3cf7a308d6bda284$export$97d84347d71ba297,
    faChessQueen: $3cf7a308d6bda284$export$7b8ce73615739d30,
    faHandBackFist: $3cf7a308d6bda284$export$be38a892fe9b4098,
    faHandRock: $3cf7a308d6bda284$export$97a81eba394c8c44,
    faSquareCaretUp: $3cf7a308d6bda284$export$66068918abb14406,
    faCaretSquareUp: $3cf7a308d6bda284$export$307ae80b26533ce5,
    faChartBar: $3cf7a308d6bda284$export$b532f5d25de97633,
    faBarChart: $3cf7a308d6bda284$export$2d5f754a5e5738b,
    faWindowRestore: $3cf7a308d6bda284$export$eccfff9bfd585652,
    faSquarePlus: $3cf7a308d6bda284$export$eaf727acca5a35e4,
    faPlusSquare: $3cf7a308d6bda284$export$b6359eebfe900c35,
    faImage: $3cf7a308d6bda284$export$7e9f0928967e03b,
    faFolderClosed: $3cf7a308d6bda284$export$5e30548b7f8eeb95,
    faLemon: $3cf7a308d6bda284$export$4fbda8f64648f3b5,
    faHandshake: $3cf7a308d6bda284$export$b4c63e9bfc7906f1,
    faGem: $3cf7a308d6bda284$export$31ee86ac717db552,
    faCirclePlay: $3cf7a308d6bda284$export$86c4e45dc3302d15,
    faPlayCircle: $3cf7a308d6bda284$export$cf04333781061c5e,
    faCircleCheck: $3cf7a308d6bda284$export$c2e9877668862374,
    faCheckCircle: $3cf7a308d6bda284$export$be9e388158c74f29,
    faCircleStop: $3cf7a308d6bda284$export$229de76dfef2687f,
    faStopCircle: $3cf7a308d6bda284$export$47af2aad60ab3e7c,
    faIdBadge: $3cf7a308d6bda284$export$a75288855ea05282,
    faFaceLaughBeam: $3cf7a308d6bda284$export$3f2d51c0547bf984,
    faLaughBeam: $3cf7a308d6bda284$export$a88d1f4073ea9369,
    faRegistered: $3cf7a308d6bda284$export$5f519e9ac15ab8c3,
    faAddressCard: $3cf7a308d6bda284$export$6ea408c7266ed557,
    faContactCard: $3cf7a308d6bda284$export$4ac51eb0b298b190,
    faVcard: $3cf7a308d6bda284$export$91228257deb1bf18,
    faFaceTired: $3cf7a308d6bda284$export$5352cbdc070ce8d,
    faTired: $3cf7a308d6bda284$export$3d016d62cda18371,
    faFontAwesome: $3cf7a308d6bda284$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $3cf7a308d6bda284$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $3cf7a308d6bda284$export$6e20d421a2e0f320,
    faFaceSmileWink: $3cf7a308d6bda284$export$6143da800b0e6626,
    faSmileWink: $3cf7a308d6bda284$export$f5dbb37f6801ee3f,
    faFileWord: $3cf7a308d6bda284$export$f0858dff6e769cf6,
    faFilePowerpoint: $3cf7a308d6bda284$export$c341daeecdea449a,
    faEnvelopeOpen: $3cf7a308d6bda284$export$c6c3bd5f7d9b8bf2,
    faFileZipper: $3cf7a308d6bda284$export$7a4a0e4caa1e4e6f,
    faFileArchive: $3cf7a308d6bda284$export$bf2047a9946b5c3f,
    faSquare: $3cf7a308d6bda284$export$90b4406457aae8cc,
    faSnowflake: $3cf7a308d6bda284$export$bab8f3647c394f48,
    faNewspaper: $3cf7a308d6bda284$export$d91b374112d4f8c1,
    faFaceKissWinkHeart: $3cf7a308d6bda284$export$611ae61f02de0aa,
    faKissWinkHeart: $3cf7a308d6bda284$export$ebba617701dfb917,
    faStarHalfStroke: $3cf7a308d6bda284$export$3e4892d8bf919edd,
    faStarHalfAlt: $3cf7a308d6bda284$export$c13575f42532efb3,
    faFileExcel: $3cf7a308d6bda284$export$77cb1a465c4fe84,
    faFaceGrinBeam: $3cf7a308d6bda284$export$3de52eeb00462407,
    faGrinBeam: $3cf7a308d6bda284$export$734da5249381ec7e,
    faObjectUngroup: $3cf7a308d6bda284$export$887f6345573abcac,
    faCircleRight: $3cf7a308d6bda284$export$1fec48c8bdd69c1d,
    faArrowAltCircleRight: $3cf7a308d6bda284$export$88962ffdad8b856d,
    faFaceRollingEyes: $3cf7a308d6bda284$export$a6d72a9a068392b5,
    faMehRollingEyes: $3cf7a308d6bda284$export$fdc62a1bea767cc2,
    faObjectGroup: $3cf7a308d6bda284$export$40cdac24aa94a57a,
    faHeart: $3cf7a308d6bda284$export$e4b51a47a2f8b9db,
    faFaceSurprise: $3cf7a308d6bda284$export$c938968e28178994,
    faSurprise: $3cf7a308d6bda284$export$46647c72213f53ba,
    faCirclePause: $3cf7a308d6bda284$export$fbeef2513e05ad08,
    faPauseCircle: $3cf7a308d6bda284$export$d8cf08a0362da8db,
    faCircle: $3cf7a308d6bda284$export$4280b2387fbdad12,
    faCircleUp: $3cf7a308d6bda284$export$72ea8a5e4e86cd69,
    faArrowAltCircleUp: $3cf7a308d6bda284$export$3747a8ef0995eadf,
    faFileAudio: $3cf7a308d6bda284$export$b8d24c57c9e64933,
    faFileImage: $3cf7a308d6bda284$export$6440b286d3cbac9b,
    faCircleQuestion: $3cf7a308d6bda284$export$d7cf0978afd90002,
    faQuestionCircle: $3cf7a308d6bda284$export$5ba67d7f2265c1a5,
    faFaceMehBlank: $3cf7a308d6bda284$export$38c072b870a9e4ab,
    faMehBlank: $3cf7a308d6bda284$export$e945435725f71e88,
    faEye: $3cf7a308d6bda284$export$b8c3e79e8c99c95b,
    faFaceSadCry: $3cf7a308d6bda284$export$e8ea88c55e55be7c,
    faSadCry: $3cf7a308d6bda284$export$8e924e6bd422cef9,
    faFileCode: $3cf7a308d6bda284$export$143d0ca7d2200f20,
    faWindowMaximize: $3cf7a308d6bda284$export$703cd98be31ec905,
    faFaceFrown: $3cf7a308d6bda284$export$e5f78e87efbb0248,
    faFrown: $3cf7a308d6bda284$export$43b7108508aecc5f,
    faFloppyDisk: $3cf7a308d6bda284$export$f62f2879ccaea13f,
    faSave: $3cf7a308d6bda284$export$1aaa83ff70706e1e,
    faCommentDots: $3cf7a308d6bda284$export$63ffcb3d4e94cb92,
    faCommenting: $3cf7a308d6bda284$export$49ee382a2425e89c,
    faFaceGrinSquint: $3cf7a308d6bda284$export$5d53da7627754bc6,
    faGrinSquint: $3cf7a308d6bda284$export$243ae757907b1580,
    faHandPointer: $3cf7a308d6bda284$export$d97ff927c450c87f,
    faHandScissors: $3cf7a308d6bda284$export$c578e919f2c5c135,
    faFaceGrinTears: $3cf7a308d6bda284$export$8ac6d81a3d5b40a1,
    faGrinTears: $3cf7a308d6bda284$export$b2f7512221512b5b,
    faCalendarXmark: $3cf7a308d6bda284$export$3c70ffe5660af060,
    faCalendarTimes: $3cf7a308d6bda284$export$99b20d7352fbcf08,
    faFileVideo: $3cf7a308d6bda284$export$b44eb38345c6a964,
    faFilePdf: $3cf7a308d6bda284$export$38611f1c776aba73,
    faComment: $3cf7a308d6bda284$export$805cd88398a70581,
    faEnvelope: $3cf7a308d6bda284$export$6f095630677adc,
    faHourglass: $3cf7a308d6bda284$export$b9098a890f61e022,
    faHourglassEmpty: $3cf7a308d6bda284$export$a2f8176a0161e891,
    faCalendarCheck: $3cf7a308d6bda284$export$5655108e1162ba45,
    faHardDrive: $3cf7a308d6bda284$export$4cb736b866cbb7ec,
    faHdd: $3cf7a308d6bda284$export$62551e9c5ba7093f,
    faFaceGrinSquintTears: $3cf7a308d6bda284$export$8ff56f5ebb8416a0,
    faGrinSquintTears: $3cf7a308d6bda284$export$542206d6a85f3b42,
    faRectangleList: $3cf7a308d6bda284$export$1f7600fa9fdb3978,
    faListAlt: $3cf7a308d6bda284$export$c6327a203ffc65a3,
    faCalendarPlus: $3cf7a308d6bda284$export$16768a660ae3ca9d,
    faCircleLeft: $3cf7a308d6bda284$export$5ae86b9da9cca3bd,
    faArrowAltCircleLeft: $3cf7a308d6bda284$export$5460a5b11a24996f,
    faMoneyBill1: $3cf7a308d6bda284$export$a312c7d58dd44a75,
    faMoneyBillAlt: $3cf7a308d6bda284$export$a35d573395884c3d,
    faClock: $3cf7a308d6bda284$export$95b9968e7fceb821,
    faClockFour: $3cf7a308d6bda284$export$9a575facf1cab48f,
    faKeyboard: $3cf7a308d6bda284$export$fb61df5d98785fa8,
    faClosedCaptioning: $3cf7a308d6bda284$export$8e047801a8603af7,
    faImages: $3cf7a308d6bda284$export$74f06b41ed2ca28a,
    faFaceGrin: $3cf7a308d6bda284$export$92292137ef3cf4c8,
    faGrin: $3cf7a308d6bda284$export$37e1f10b6de76621,
    faFaceMeh: $3cf7a308d6bda284$export$dc130582748497c6,
    faMeh: $3cf7a308d6bda284$export$6d2db489aaeeecd2,
    faIdCard: $3cf7a308d6bda284$export$782ac893fc22249b,
    faDriversLicense: $3cf7a308d6bda284$export$8359c70e609eff64,
    faSun: $3cf7a308d6bda284$export$2fa35dcbc038dbe9,
    faFaceLaughWink: $3cf7a308d6bda284$export$600a1b26b33c3d47,
    faLaughWink: $3cf7a308d6bda284$export$77ac40095f39933e,
    faCircleDown: $3cf7a308d6bda284$export$531badb89cf01312,
    faArrowAltCircleDown: $3cf7a308d6bda284$export$ff3afbc8c0bc5d59,
    faThumbsDown: $3cf7a308d6bda284$export$aba24ca305bbe8c1,
    faChessPawn: $3cf7a308d6bda284$export$3db75d5ac9e98468,
    faCreditCard: $3cf7a308d6bda284$export$3e7437bf6535bef0,
    faCreditCardAlt: $3cf7a308d6bda284$export$5fffe8e3c36964a2,
    faBell: $3cf7a308d6bda284$export$9b6162797ab1b255,
    faFile: $3cf7a308d6bda284$export$cad54bead856a678,
    faHospital: $3cf7a308d6bda284$export$7a76c9d35b42d691,
    faHospitalAlt: $3cf7a308d6bda284$export$cea7736417b94a3b,
    faHospitalWide: $3cf7a308d6bda284$export$69c8cc0360f017e8,
    faChessRook: $3cf7a308d6bda284$export$5d65c40a109eb09c,
    faStarHalf: $3cf7a308d6bda284$export$228008b5e11032fa,
    faChessKing: $3cf7a308d6bda284$export$d5713874f8fefe1b,
    faCircleUser: $3cf7a308d6bda284$export$9a5c11a5e3d7f1e7,
    faUserCircle: $3cf7a308d6bda284$export$be7d974e9e0dba1a,
    faCopy: $3cf7a308d6bda284$export$e9bd786d30cb716c,
    faShareFromSquare: $3cf7a308d6bda284$export$928280bdd54fa173,
    faShareSquare: $3cf7a308d6bda284$export$ae9e1434571f373c,
    faCopyright: $3cf7a308d6bda284$export$da61665fff8aebfe,
    faMap: $3cf7a308d6bda284$export$fc82fb79180cd17c,
    faBellSlash: $3cf7a308d6bda284$export$6b31a1e5968b2378,
    faHandLizard: $3cf7a308d6bda284$export$54608d0a883fea4d,
    faFaceSmile: $3cf7a308d6bda284$export$b5023c446f10324,
    faSmile: $3cf7a308d6bda284$export$c632b2334f0913bc,
    faHandPeace: $3cf7a308d6bda284$export$e49e3cfceea441cc,
    faFaceGrinHearts: $3cf7a308d6bda284$export$fbb22081b65e4f33,
    faGrinHearts: $3cf7a308d6bda284$export$c56cf0e0c3bc5ed2,
    faBuilding: $3cf7a308d6bda284$export$f26673f8b10c3d46,
    faFaceGrinBeamSweat: $3cf7a308d6bda284$export$2ff38f330c834084,
    faGrinBeamSweat: $3cf7a308d6bda284$export$14d0ccc54c5b6826,
    faMoon: $3cf7a308d6bda284$export$c4c2f69a53bab720,
    faCalendar: $3cf7a308d6bda284$export$34f5c36a3e80efa2,
    faFaceGrinTongueWink: $3cf7a308d6bda284$export$4272e56f2429da88,
    faGrinTongueWink: $3cf7a308d6bda284$export$58099903d50aefb3,
    faClone: $3cf7a308d6bda284$export$76c1aa4bf9a39458,
    faFaceAngry: $3cf7a308d6bda284$export$67a047c738fb34da,
    faAngry: $3cf7a308d6bda284$export$3c96c08e234498c5,
    faRectangleXmark: $3cf7a308d6bda284$export$3896694b3e81fba7,
    faRectangleTimes: $3cf7a308d6bda284$export$eaaf26416a51dc1,
    faTimesRectangle: $3cf7a308d6bda284$export$10147c0014152a3f,
    faWindowClose: $3cf7a308d6bda284$export$18b7775f78a3e16,
    faPaperPlane: $3cf7a308d6bda284$export$b5378818301da1be,
    faLifeRing: $3cf7a308d6bda284$export$53dd2cacf674142a,
    faFaceGrimace: $3cf7a308d6bda284$export$bd5bd2ef56b793b1,
    faGrimace: $3cf7a308d6bda284$export$3d08cd36ac1ef231,
    faCalendarMinus: $3cf7a308d6bda284$export$23e8b4955c2d951b,
    faCircleXmark: $3cf7a308d6bda284$export$30262489773a79a3,
    faTimesCircle: $3cf7a308d6bda284$export$ab0ec50720a747eb,
    faXmarkCircle: $3cf7a308d6bda284$export$90ac4096df8efdee,
    faThumbsUp: $3cf7a308d6bda284$export$47e4e0d519d33497,
    faWindowMinimize: $3cf7a308d6bda284$export$26a3f9d2784b90d8,
    faSquareFull: $3cf7a308d6bda284$export$7ec6541fee081990,
    faNoteSticky: $3cf7a308d6bda284$export$4a4e034527c933f5,
    faStickyNote: $3cf7a308d6bda284$export$80889adc5d98bf4a,
    faFaceSadTear: $3cf7a308d6bda284$export$8a5a0dbb2a17e253,
    faSadTear: $3cf7a308d6bda284$export$4b5241926f692f91,
    faHandPointLeft: $3cf7a308d6bda284$export$b276ec3dc9760d39
};


var $42f4e3f18906b0d1$export$82e9f45cca5ba907 = "fab";
var $42f4e3f18906b0d1$export$155bdf1ceac204e7 = {
    prefix: "fab",
    iconName: "monero",
    icon: [
        496,
        512,
        [],
        "f3d0",
        "M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"
    ]
};
var $42f4e3f18906b0d1$export$3a040ca24382cf1c = {
    prefix: "fab",
    iconName: "hooli",
    icon: [
        640,
        512,
        [],
        "f427",
        "M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"
    ]
};
var $42f4e3f18906b0d1$export$2de47f03337052b6 = {
    prefix: "fab",
    iconName: "yelp",
    icon: [
        384,
        512,
        [],
        "f1e9",
        "M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"
    ]
};
var $42f4e3f18906b0d1$export$acc882c0b0e9e801 = {
    prefix: "fab",
    iconName: "cc-visa",
    icon: [
        576,
        512,
        [],
        "f1f0",
        "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
    ]
};
var $42f4e3f18906b0d1$export$8226e5267dd86de3 = {
    prefix: "fab",
    iconName: "lastfm",
    icon: [
        512,
        512,
        [],
        "f202",
        "M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"
    ]
};
var $42f4e3f18906b0d1$export$c0b2d6cff425a846 = {
    prefix: "fab",
    iconName: "shopware",
    icon: [
        512,
        512,
        [],
        "f5b5",
        "M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"
    ]
};
var $42f4e3f18906b0d1$export$e36098165f3fc869 = {
    prefix: "fab",
    iconName: "creative-commons-nc",
    icon: [
        496,
        512,
        [],
        "f4e8",
        "M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"
    ]
};
var $42f4e3f18906b0d1$export$a4ddb2c7f767be70 = {
    prefix: "fab",
    iconName: "aws",
    icon: [
        640,
        512,
        [],
        "f375",
        "M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"
    ]
};
var $42f4e3f18906b0d1$export$d65557a7abc2c5dc = {
    prefix: "fab",
    iconName: "redhat",
    icon: [
        512,
        512,
        [],
        "f7bc",
        "M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"
    ]
};
var $42f4e3f18906b0d1$export$73b6ef60226f6801 = {
    prefix: "fab",
    iconName: "yoast",
    icon: [
        448,
        512,
        [],
        "f2b1",
        "M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"
    ]
};
var $42f4e3f18906b0d1$export$7a31e37b2189232c = {
    prefix: "fab",
    iconName: "cloudflare",
    icon: [
        640,
        512,
        [],
        "e07d",
        "M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"
    ]
};
var $42f4e3f18906b0d1$export$c6f6a1beb6102ac = {
    prefix: "fab",
    iconName: "ups",
    icon: [
        384,
        512,
        [],
        "f7e0",
        "M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"
    ]
};
var $42f4e3f18906b0d1$export$b64ce7c5d150db12 = {
    prefix: "fab",
    iconName: "pixiv",
    icon: [
        448,
        512,
        [],
        "e640",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm171.5 84c41 0 76.3 12.9 101.4 35.2l0 0c25.2 22.2 39.8 54.1 39.8 88.8c.1 35.3-16.6 66.3-42.4 87c-25.9 20.8-60.6 32.4-98.8 32.4c-43.5 0-83.8-16.1-83.8-16.1v51.8c7.4 2.2 19.7 7 11.9 14.8H104.8c-7.7-7.8 3.6-12.4 12.1-14.8V175.5C97.1 190.9 87 204.3 81.8 214.2c6 19.4-5.3 18.5-5.3 18.5L56 199.7s72.7-83.7 179.5-83.7zm-3.6 222.9c30 0 56-11.3 73.9-29.2c17.9-18.1 27.9-41.6 28-70.2c-.1-29.3-9.5-54.6-26.7-73.6c-17.2-18.9-42.7-31.3-75.2-31.4c-26.7-.1-59.8 9-80.2 23.7V323.1c18.6 9.3 46.8 15.9 80.2 15.8z"
    ]
};
var $42f4e3f18906b0d1$export$9ab35a48e8f904bf = {
    prefix: "fab",
    iconName: "wpexplorer",
    icon: [
        512,
        512,
        [],
        "f2de",
        "M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"
    ]
};
var $42f4e3f18906b0d1$export$1661cbacae81932b = {
    prefix: "fab",
    iconName: "dyalog",
    icon: [
        416,
        512,
        [],
        "f399",
        "M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"
    ]
};
var $42f4e3f18906b0d1$export$76a6a7e968d921fe = {
    prefix: "fab",
    iconName: "bity",
    icon: [
        496,
        512,
        [],
        "f37a",
        "M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"
    ]
};
var $42f4e3f18906b0d1$export$a14b012b76f98910 = {
    prefix: "fab",
    iconName: "stackpath",
    icon: [
        448,
        512,
        [],
        "f842",
        "M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"
    ]
};
var $42f4e3f18906b0d1$export$6c0bc096306cebf8 = {
    prefix: "fab",
    iconName: "buysellads",
    icon: [
        448,
        512,
        [],
        "f20d",
        "M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"
    ]
};
var $42f4e3f18906b0d1$export$e0a21844bf49ca8e = {
    prefix: "fab",
    iconName: "first-order",
    icon: [
        448,
        512,
        [],
        "f2b0",
        "M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"
    ]
};
var $42f4e3f18906b0d1$export$fb06254b4488a5b6 = {
    prefix: "fab",
    iconName: "modx",
    icon: [
        448,
        512,
        [],
        "f285",
        "M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"
    ]
};
var $42f4e3f18906b0d1$export$b6ff6f33a85ee805 = {
    prefix: "fab",
    iconName: "guilded",
    icon: [
        448,
        512,
        [],
        "e07e",
        "M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"
    ]
};
var $42f4e3f18906b0d1$export$13bd8782a2ce17e7 = {
    prefix: "fab",
    iconName: "vnv",
    icon: [
        640,
        512,
        [],
        "f40b",
        "M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"
    ]
};
var $42f4e3f18906b0d1$export$c989752ecb8b3fae = {
    prefix: "fab",
    iconName: "square-js",
    icon: [
        448,
        512,
        [
            "js-square"
        ],
        "f3b9",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM180.9 444.9c-33.7 0-53.2-17.4-63.2-38.5L152 385.7c6.6 11.7 12.6 21.6 27.1 21.6c13.8 0 22.6-5.4 22.6-26.5V237.7h42.1V381.4c0 43.6-25.6 63.5-62.9 63.5zm85.8-43L301 382.1c9 14.7 20.8 25.6 41.5 25.6c17.4 0 28.6-8.7 28.6-20.8c0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5c0-31.6 24.1-55.6 61.6-55.6c26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18c-12.3 0-20.1 7.8-20.1 18c0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2c0 37.8-29.8 58.6-69.7 58.6c-39.1 0-64.4-18.6-76.7-43z"
    ]
};
var $42f4e3f18906b0d1$export$d9bf3211f885d573 = $42f4e3f18906b0d1$export$c989752ecb8b3fae;
var $42f4e3f18906b0d1$export$b3b8195c77f1f877 = {
    prefix: "fab",
    iconName: "microsoft",
    icon: [
        448,
        512,
        [],
        "f3ca",
        "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"
    ]
};
var $42f4e3f18906b0d1$export$39d59e523abf051d = {
    prefix: "fab",
    iconName: "qq",
    icon: [
        448,
        512,
        [],
        "f1d6",
        "M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"
    ]
};
var $42f4e3f18906b0d1$export$9bf8457cc97dd02e = {
    prefix: "fab",
    iconName: "orcid",
    icon: [
        512,
        512,
        [],
        "f8d2",
        "M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"
    ]
};
var $42f4e3f18906b0d1$export$25a84a6ff654acd1 = {
    prefix: "fab",
    iconName: "java",
    icon: [
        384,
        512,
        [],
        "f4e4",
        "M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"
    ]
};
var $42f4e3f18906b0d1$export$6e249797a4721568 = {
    prefix: "fab",
    iconName: "invision",
    icon: [
        448,
        512,
        [],
        "f7b0",
        "M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"
    ]
};
var $42f4e3f18906b0d1$export$d93ab92a56e88ce6 = {
    prefix: "fab",
    iconName: "creative-commons-pd-alt",
    icon: [
        496,
        512,
        [],
        "f4ed",
        "M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"
    ]
};
var $42f4e3f18906b0d1$export$961762d5b3aedd8d = {
    prefix: "fab",
    iconName: "centercode",
    icon: [
        512,
        512,
        [],
        "f380",
        "M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"
    ]
};
var $42f4e3f18906b0d1$export$91d5526742c32d42 = {
    prefix: "fab",
    iconName: "glide-g",
    icon: [
        448,
        512,
        [],
        "f2a6",
        "M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"
    ]
};
var $42f4e3f18906b0d1$export$51e679e8d2e3f8c1 = {
    prefix: "fab",
    iconName: "drupal",
    icon: [
        448,
        512,
        [],
        "f1a9",
        "M303.973,108.136C268.2,72.459,234.187,38.35,224.047,0c-9.957,38.35-44.25,72.459-80.019,108.136C90.467,161.7,29.716,222.356,29.716,313.436c-2.337,107.3,82.752,196.18,190.053,198.517S415.948,429.2,418.285,321.9q.091-4.231,0-8.464C418.285,222.356,357.534,161.7,303.973,108.136Zm-174.326,223a130.282,130.282,0,0,0-15.211,24.153,4.978,4.978,0,0,1-3.319,2.766h-1.659c-4.333,0-9.219-8.481-9.219-8.481h0c-1.29-2.028-2.489-4.149-3.687-6.361l-.83-1.752c-11.247-25.72-1.475-62.318-1.475-62.318h0a160.585,160.585,0,0,1,23.231-49.873A290.8,290.8,0,0,1,138.5,201.613l9.219,9.219,43.512,44.434a4.979,4.979,0,0,1,0,6.638L145.78,312.33h0Zm96.612,127.311a67.2,67.2,0,0,1-49.781-111.915c14.2-16.871,31.528-33.464,50.334-55.313,22.309,23.785,36.875,40.1,51.164,57.986a28.413,28.413,0,0,1,2.95,4.425,65.905,65.905,0,0,1,11.984,37.981,66.651,66.651,0,0,1-66.466,66.836ZM352.371,351.6h0a7.743,7.743,0,0,1-6.176,5.347H344.9a11.249,11.249,0,0,1-6.269-5.07h0a348.21,348.21,0,0,0-39.456-48.952L281.387,284.49,222.3,223.185a497.888,497.888,0,0,1-35.4-36.322,12.033,12.033,0,0,0-.922-1.382,35.4,35.4,0,0,1-4.7-9.219V174.51a31.346,31.346,0,0,1,9.218-27.656c11.432-11.431,22.955-22.954,33.833-34.939,11.984,13.275,24.8,26,37.428,38.627h0a530.991,530.991,0,0,1,69.6,79.1,147.494,147.494,0,0,1,27.011,83.8A134.109,134.109,0,0,1,352.371,351.6Z"
    ]
};
var $42f4e3f18906b0d1$export$66507f26cc60b31e = {
    prefix: "fab",
    iconName: "hire-a-helper",
    icon: [
        512,
        512,
        [],
        "f3b0",
        "M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"
    ]
};
var $42f4e3f18906b0d1$export$5040b13190e5beb7 = {
    prefix: "fab",
    iconName: "creative-commons-by",
    icon: [
        496,
        512,
        [],
        "f4e7",
        "M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"
    ]
};
var $42f4e3f18906b0d1$export$72fd5838af249737 = {
    prefix: "fab",
    iconName: "unity",
    icon: [
        448,
        512,
        [],
        "e049",
        "M243.583 91.6027L323.695 138.384C326.575 140.026 326.68 144.583 323.695 146.225L228.503 201.854C225.623 203.55 222.22 203.444 219.549 201.854L124.357 146.225C121.425 144.636 121.373 139.973 124.357 138.384L204.417 91.6027V0L0 119.417V358.252L78.3843 312.477V218.914C78.3319 215.576 82.2066 213.192 85.0865 214.993L180.279 270.622C183.159 272.318 184.782 275.338 184.782 278.464V389.669C184.834 393.007 180.959 395.391 178.079 393.589L97.9673 346.808L19.583 392.583L224 512L428.417 392.583L350.033 346.808L269.921 393.589C267.093 395.338 263.114 393.06 263.218 389.669V278.464C263.218 275.126 265.051 272.159 267.721 270.622L362.914 214.993C365.741 213.245 369.72 215.47 369.616 218.914V312.477L448 358.252V119.417L243.583 0V91.6027Z"
    ]
};
var $42f4e3f18906b0d1$export$4d4f65ec2f52482 = {
    prefix: "fab",
    iconName: "whmcs",
    icon: [
        448,
        512,
        [],
        "f40d",
        "M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"
    ]
};
var $42f4e3f18906b0d1$export$193ac2f517f63e63 = {
    prefix: "fab",
    iconName: "rocketchat",
    icon: [
        576,
        512,
        [],
        "f3e8",
        "M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"
    ]
};
var $42f4e3f18906b0d1$export$a6bf4d62e541f988 = {
    prefix: "fab",
    iconName: "vk",
    icon: [
        448,
        512,
        [],
        "f189",
        "M31.4907 63.4907C0 94.9813 0 145.671 0 247.04V264.96C0 366.329 0 417.019 31.4907 448.509C62.9813 480 113.671 480 215.04 480H232.96C334.329 480 385.019 480 416.509 448.509C448 417.019 448 366.329 448 264.96V247.04C448 145.671 448 94.9813 416.509 63.4907C385.019 32 334.329 32 232.96 32H215.04C113.671 32 62.9813 32 31.4907 63.4907ZM75.6 168.267H126.747C128.427 253.76 166.133 289.973 196 297.44V168.267H244.16V242C273.653 238.827 304.64 205.227 315.093 168.267H363.253C359.313 187.435 351.46 205.583 340.186 221.579C328.913 237.574 314.461 251.071 297.733 261.227C316.41 270.499 332.907 283.63 346.132 299.751C359.357 315.873 369.01 334.618 374.453 354.747H321.44C316.555 337.262 306.614 321.61 292.865 309.754C279.117 297.899 262.173 290.368 244.16 288.107V354.747H238.373C136.267 354.747 78.0267 284.747 75.6 168.267Z"
    ]
};
var $42f4e3f18906b0d1$export$f1679625ed434576 = {
    prefix: "fab",
    iconName: "untappd",
    icon: [
        640,
        512,
        [],
        "f405",
        "M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"
    ]
};
var $42f4e3f18906b0d1$export$da9f5a873e107292 = {
    prefix: "fab",
    iconName: "mailchimp",
    icon: [
        448,
        512,
        [],
        "f59e",
        "M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"
    ]
};
var $42f4e3f18906b0d1$export$928cd5ee6ccd55c0 = {
    prefix: "fab",
    iconName: "css3-alt",
    icon: [
        384,
        512,
        [],
        "f38b",
        "M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"
    ]
};
var $42f4e3f18906b0d1$export$307bcbd032fbb8d3 = {
    prefix: "fab",
    iconName: "square-reddit",
    icon: [
        448,
        512,
        [
            "reddit-square"
        ],
        "f1a2",
        "M64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32zM305.9 166.4c20.6 0 37.3-16.7 37.3-37.3s-16.7-37.3-37.3-37.3c-18 0-33.1 12.8-36.6 29.8c-30.2 3.2-53.8 28.8-53.8 59.9l0 .2c-32.8 1.4-62.8 10.7-86.6 25.5c-8.8-6.8-19.9-10.9-32-10.9c-28.9 0-52.3 23.4-52.3 52.3c0 21 12.3 39 30.1 47.4c1.7 60.7 67.9 109.6 149.3 109.6s147.6-48.9 149.3-109.7c17.7-8.4 29.9-26.4 29.9-47.3c0-28.9-23.4-52.3-52.3-52.3c-12 0-23 4-31.9 10.8c-24-14.9-54.3-24.2-87.5-25.4l0-.1c0-22.2 16.5-40.7 37.9-43.7l0 0c3.9 16.5 18.7 28.7 36.3 28.7zM155 248.1c14.6 0 25.8 15.4 25 34.4s-11.8 25.9-26.5 25.9s-27.5-7.7-26.6-26.7s13.5-33.5 28.1-33.5zm166.4 33.5c.9 19-12 26.7-26.6 26.7s-25.6-6.9-26.5-25.9c-.9-19 10.3-34.4 25-34.4s27.3 14.6 28.1 33.5zm-42.1 49.6c-9 21.5-30.3 36.7-55.1 36.7s-46.1-15.1-55.1-36.7c-1.1-2.6 .7-5.4 3.4-5.7c16.1-1.6 33.5-2.5 51.7-2.5s35.6 .9 51.7 2.5c2.7 .3 4.5 3.1 3.4 5.7z"
    ]
};
var $42f4e3f18906b0d1$export$f8480c75bb6acc77 = $42f4e3f18906b0d1$export$307bcbd032fbb8d3;
var $42f4e3f18906b0d1$export$2ea137a3f22bc61 = {
    prefix: "fab",
    iconName: "vimeo-v",
    icon: [
        448,
        512,
        [],
        "f27d",
        "M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"
    ]
};
var $42f4e3f18906b0d1$export$d023cd407bbc3cab = {
    prefix: "fab",
    iconName: "contao",
    icon: [
        512,
        512,
        [],
        "f26d",
        "M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"
    ]
};
var $42f4e3f18906b0d1$export$128da80f2cbe244a = {
    prefix: "fab",
    iconName: "square-font-awesome",
    icon: [
        448,
        512,
        [],
        "e5ad",
        "M384.5,32.5h-320c-35.3,0-64,28.7-64,64v320c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64v-320 C448.5,61.2,419.8,32.5,384.5,32.5z M336.5,312.5c-31.6,11.2-41.2,16-59.8,16c-31.4,0-43.2-16-74.6-16c-10.2,0-18.2,1.6-25.6,4v-32 c7.4-2.2,15.4-4,25.6-4c31.2,0,43.2,16,74.6,16c10.2,0,17.8-1.4,27.8-4.6v-96c-10,3.2-17.6,4.6-27.8,4.6c-31.4,0-43.2-16-74.6-16 c-25.4,0-37.4,10.4-57.6,14.4v153.6c0,8.8-7.2,16-16,16c-8.8,0-16-7.2-16-16v-192c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16v6.4 c20.2-4,32.2-14.4,57.6-14.4c31.2,0,43.2,16,74.6,16c18.6,0,28.2-4.8,59.8-16V312.5z"
    ]
};
var $42f4e3f18906b0d1$export$9005bf63ad3e3083 = {
    prefix: "fab",
    iconName: "deskpro",
    icon: [
        480,
        512,
        [],
        "f38f",
        "M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"
    ]
};
var $42f4e3f18906b0d1$export$ec6cecf928f83afa = {
    prefix: "fab",
    iconName: "brave",
    icon: [
        448,
        512,
        [],
        "e63c",
        "M145.5 0H224h78.5l44.7 50.8s39.3-10.9 57.8 7.6s33.8 34.9 33.8 34.9l-12 29.5 15.3 43.7s-44.9 170.2-50.1 191c-10.4 40.9-17.4 56.8-46.9 77.5s-82.9 56.8-91.6 62.2c-1.9 1.2-3.9 2.5-5.9 3.9c-7.5 5.1-15.8 10.8-23.5 10.8l0 0 0 0c-7.7 0-16.1-5.7-23.5-10.8c-2-1.4-4-2.8-5.9-3.9c-8.7-5.5-62.1-41.5-91.6-62.2s-36.5-36.6-46.9-77.5c-5.3-20.8-50.1-191-50.1-191l15.3-43.7L9.2 93.3s15.3-16.4 33.8-34.9s57.8-7.6 57.8-7.6L145.5 0zM224 407.6l0 0c3.7 0 8.9-4.7 13-8.4c.6-.5 1.2-1.1 1.7-1.5c4.2-3.7 47.8-37.5 51-39.8s5.4-6.5 1.9-8.7c-2.8-1.7-10-5.5-20.3-10.8c-3-1.6-6.3-3.2-9.7-5c-15.4-8-34.5-14.7-37.5-14.7l0 0 0 0c-3 0-22.1 6.8-37.5 14.7c-3.5 1.8-6.7 3.5-9.7 5c-10.3 5.3-17.6 9.1-20.3 10.8c-3.6 2.2-1.4 6.4 1.9 8.7s46.8 36.1 51 39.8c.5 .5 1.1 1 1.7 1.5c4.1 3.7 9.3 8.4 13 8.4l0 0zm0-165.7l0 0c4.7 0 17.6-3 26.4-5l0 0 2-.5c7.8-1.8 7.3-6.3 6.4-13c-.1-.8-.2-1.6-.3-2.4c-.6-6.1-5.8-33.1-9.1-50.3c-1.1-5.8-2-10.5-2.4-12.9c-1.5-8.1-.6-9.4 .7-11.3c.2-.3 .5-.7 .7-1.1c1.4-2.3 16-6.2 27.9-9.5l0 0c2.5-.7 4.8-1.3 6.9-1.9c10.6-3 32.4-.6 44.2 .6c1.8 .2 3.4 .4 4.7 .5c9.6 .9 10.4 2.3 7.2 3.8c-2.3 1.1-16.2 6.3-28.7 10.9l0 0 0 0c-4.7 1.8-9.2 3.5-12.8 4.8c-1.5 .5-3 1.1-4.5 1.7c-12.5 4.6-27.2 10-28.9 19.4c-1.5 8.3 5.2 19.9 11.3 30.3l0 0c1.6 2.8 3.2 5.5 4.6 8.1c6.3 11.9 6.5 13.3 6.1 18.1c-.4 3.9-14.5 12.7-22.4 17.6l0 0c-1.8 1.1-3.3 2.1-4.2 2.7c-.8 .5-2.1 1.4-3.8 2.4c-8.6 5.2-26.3 16-26.3 22.5c0 7.8 24.6 28.1 32.4 33.2s28.9 16.1 37.9 17.8s23-8.5 31.2-23.8c7.7-14.4 1.7-28.5-3.2-40l-.9-2.2c-4.5-10.6 1.9-17 6.2-21.3l0 0c.5-.5 1-1 1.4-1.4L377.7 194c1.3-1.3 2.5-2.6 3.7-3.8l0 0c5.8-5.7 10.8-10.5 10.8-22.8c0-14.9-57.5-84.5-57.5-84.5s-48.5 9.3-55.1 9.3c-5.2 0-15.3-3.5-25.8-7.1l0 0c-2.7-.9-5.4-1.9-8-2.7C232.8 78.1 224 78 224 78l0 0 0 0s-8.7 0-21.8 4.4c-2.7 .9-5.4 1.8-8 2.7l0 0c-10.5 3.6-20.6 7.1-25.8 7.1c-6.5 0-55.1-9.3-55.1-9.3s-57.5 69.6-57.5 84.5c0 12.3 4.9 17.1 10.8 22.8l0 0c1.2 1.2 2.5 2.4 3.7 3.8l43.1 45.8c.4 .5 .9 .9 1.4 1.4l0 0c4.3 4.3 10.6 10.7 6.2 21.3l-.9 2.2c-4.9 11.5-11 25.6-3.2 40c8.2 15.3 22.2 25.5 31.2 23.8s30.1-12.7 37.9-17.8s32.4-25.4 32.4-33.2c0-6.5-17.7-17.3-26.3-22.5c-1.7-1-3.1-1.9-3.8-2.4c-.9-.6-2.4-1.5-4.2-2.7c-7.9-4.9-22-13.7-22.4-17.6c-.4-4.8-.3-6.2 6.1-18.1c1.3-2.5 2.9-5.3 4.6-8.1c6-10.4 12.8-22 11.3-30.3c-1.7-9.4-16.4-14.8-28.9-19.4c-1.6-.6-3.1-1.1-4.5-1.7c-3.6-1.4-8.1-3.1-12.8-4.8l-.1 0c-12.5-4.7-26.4-9.9-28.7-10.9c-3.2-1.5-2.3-2.8 7.2-3.8c1.3-.1 2.9-.3 4.7-.5c11.8-1.3 33.6-3.6 44.2-.6c2.1 .6 4.4 1.2 6.9 1.9c11.9 3.2 26.5 7.2 27.9 9.5c.2 .4 .5 .7 .7 1.1c1.3 1.9 2.2 3.2 .7 11.3c-.4 2.4-1.3 7.1-2.4 12.9c-3.3 17.2-8.5 44.2-9.1 50.3c-.1 .8-.2 1.7-.3 2.4c-.8 6.7-1.4 11.2 6.4 13l2 .5 0 0c8.8 2 21.8 5 26.4 5l0 0z"
    ]
};
var $42f4e3f18906b0d1$export$36ca6be2e064d2cd = {
    prefix: "fab",
    iconName: "sistrix",
    icon: [
        448,
        512,
        [],
        "f3ee",
        "M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"
    ]
};
var $42f4e3f18906b0d1$export$526087fb4de86dae = {
    prefix: "fab",
    iconName: "square-instagram",
    icon: [
        448,
        512,
        [
            "instagram-square"
        ],
        "e055",
        "M194.4 211.7a53.3 53.3 0 1 0 59.3 88.7 53.3 53.3 0 1 0 -59.3-88.7zm142.3-68.4c-5.2-5.2-11.5-9.3-18.4-12c-18.1-7.1-57.6-6.8-83.1-6.5c-4.1 0-7.9 .1-11.2 .1c-3.3 0-7.2 0-11.4-.1c-25.5-.3-64.8-.7-82.9 6.5c-6.9 2.7-13.1 6.8-18.4 12s-9.3 11.5-12 18.4c-7.1 18.1-6.7 57.7-6.5 83.2c0 4.1 .1 7.9 .1 11.1s0 7-.1 11.1c-.2 25.5-.6 65.1 6.5 83.2c2.7 6.9 6.8 13.1 12 18.4s11.5 9.3 18.4 12c18.1 7.1 57.6 6.8 83.1 6.5c4.1 0 7.9-.1 11.2-.1c3.3 0 7.2 0 11.4 .1c25.5 .3 64.8 .7 82.9-6.5c6.9-2.7 13.1-6.8 18.4-12s9.3-11.5 12-18.4c7.2-18 6.8-57.4 6.5-83c0-4.2-.1-8.1-.1-11.4s0-7.1 .1-11.4c.3-25.5 .7-64.9-6.5-83l0 0c-2.7-6.9-6.8-13.1-12-18.4zm-67.1 44.5A82 82 0 1 1 178.4 324.2a82 82 0 1 1 91.1-136.4zm29.2-1.3c-3.1-2.1-5.6-5.1-7.1-8.6s-1.8-7.3-1.1-11.1s2.6-7.1 5.2-9.8s6.1-4.5 9.8-5.2s7.6-.4 11.1 1.1s6.5 3.9 8.6 7s3.2 6.8 3.2 10.6c0 2.5-.5 5-1.4 7.3s-2.4 4.4-4.1 6.2s-3.9 3.2-6.2 4.2s-4.8 1.5-7.3 1.5l0 0c-3.8 0-7.5-1.1-10.6-3.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM357 389c-18.7 18.7-41.4 24.6-67 25.9c-26.4 1.5-105.6 1.5-132 0c-25.6-1.3-48.3-7.2-67-25.9s-24.6-41.4-25.8-67c-1.5-26.4-1.5-105.6 0-132c1.3-25.6 7.1-48.3 25.8-67s41.5-24.6 67-25.8c26.4-1.5 105.6-1.5 132 0c25.6 1.3 48.3 7.1 67 25.8s24.6 41.4 25.8 67c1.5 26.3 1.5 105.4 0 131.9c-1.3 25.6-7.1 48.3-25.8 67z"
    ]
};
var $42f4e3f18906b0d1$export$ccb1f25058292a04 = $42f4e3f18906b0d1$export$526087fb4de86dae;
var $42f4e3f18906b0d1$export$fb3fd8e112e1fa28 = {
    prefix: "fab",
    iconName: "battle-net",
    icon: [
        512,
        512,
        [],
        "f835",
        "M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"
    ]
};
var $42f4e3f18906b0d1$export$daa019c708da49e9 = {
    prefix: "fab",
    iconName: "the-red-yeti",
    icon: [
        512,
        512,
        [],
        "f69d",
        "M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"
    ]
};
var $42f4e3f18906b0d1$export$ca115ee475bced67 = {
    prefix: "fab",
    iconName: "square-hacker-news",
    icon: [
        448,
        512,
        [
            "hacker-news-square"
        ],
        "f3af",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM21 229.2c0 0 .1-.1 .1-.2s.1-.2 .2-.2c0 .1 0 .3-.1 .4H21zM239.2 384H207.8V281.3L128 128h37.3c41.5 77.7 48.1 95.8 54.1 112c1.6 4.3 3.1 8.5 5.2 13.6c3.2-7 5.1-11.9 7.1-17.3c5.9-15.3 12.8-33.2 53.5-108.3H320L239.2 283.1V384z"
    ]
};
var $42f4e3f18906b0d1$export$310b7424f1f97fc = $42f4e3f18906b0d1$export$ca115ee475bced67;
var $42f4e3f18906b0d1$export$9c65bd68cbc68ec9 = {
    prefix: "fab",
    iconName: "edge",
    icon: [
        512,
        512,
        [],
        "f282",
        "M120.1 37.44C161.1 12.23 207.7-.7753 255 .0016C423 .0016 512 123.8 512 219.5C511.9 252.2 499 283.4 476.1 306.7C453.2 329.9 422.1 343.2 389.4 343.7C314.2 343.7 297.9 320.6 297.9 311.7C297.9 307.9 299.1 305.5 302.7 302.3L303.7 301.1L304.1 299.5C314.6 288 320 273.3 320 257.9C320 179.2 237.8 115.2 136 115.2C98.46 114.9 61.46 124.1 28.48 142.1C55.48 84.58 111.2 44.5 119.8 38.28C120.6 37.73 120.1 37.44 120.1 37.44V37.44zM135.7 355.5C134.3 385.5 140.3 415.5 152.1 442.7C165.7 469.1 184.8 493.7 208.6 512C149.1 500.5 97.11 468.1 59.2 422.7C21.12 376.3 0 318.4 0 257.9C0 206.7 62.4 163.5 136 163.5C172.6 162.9 208.4 174.4 237.8 196.2L234.2 197.4C182.7 215 135.7 288.1 135.7 355.5V355.5zM469.8 400L469.1 400.1C457.3 418.9 443.2 435.2 426.9 449.6C396.1 477.6 358.8 495.1 318.1 499.5C299.5 499.8 281.3 496.3 264.3 488.1C238.7 477.8 217.2 458.1 202.7 435.1C188.3 411.2 181.6 383.4 183.7 355.5C183.1 335.4 189.1 315.2 198.7 297.3C212.6 330.4 236.2 358.6 266.3 378.1C296.4 397.6 331.8 407.6 367.7 406.7C398.7 407 429.8 400 457.9 386.2L459.8 385.3C463.7 383 467.5 381.4 471.4 385.3C475.9 390.2 473.2 394.5 470.2 399.3C470 399.5 469.9 399.8 469.8 400V400z"
    ]
};
var $42f4e3f18906b0d1$export$2a1c6a809b4fdc7f = {
    prefix: "fab",
    iconName: "threads",
    icon: [
        448,
        512,
        [],
        "e618",
        "M331.5 235.7c2.2 .9 4.2 1.9 6.3 2.8c29.2 14.1 50.6 35.2 61.8 61.4c15.7 36.5 17.2 95.8-30.3 143.2c-36.2 36.2-80.3 52.5-142.6 53h-.3c-70.2-.5-124.1-24.1-160.4-70.2c-32.3-41-48.9-98.1-49.5-169.6V256v-.2C17 184.3 33.6 127.2 65.9 86.2C102.2 40.1 156.2 16.5 226.4 16h.3c70.3 .5 124.9 24 162.3 69.9c18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4c-29.2-35.8-73-54.2-130.5-54.6c-57 .5-100.1 18.8-128.2 54.4C72.1 146.1 58.5 194.3 58 256c.5 61.7 14.1 109.9 40.3 143.3c28 35.6 71.2 53.9 128.2 54.4c51.4-.4 85.4-12.6 113.7-40.9c32.3-32.2 31.7-71.8 21.4-95.9c-6.1-14.2-17.1-26-31.9-34.9c-3.7 26.9-11.8 48.3-24.7 64.8c-17.1 21.8-41.4 33.6-72.7 35.3c-23.6 1.3-46.3-4.4-63.9-16c-20.8-13.8-33-34.8-34.3-59.3c-2.5-48.3 35.7-83 95.2-86.4c21.1-1.2 40.9-.3 59.2 2.8c-2.4-14.8-7.3-26.6-14.6-35.2c-10-11.7-25.6-17.7-46.2-17.8H227c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1h.8c62.6 .4 99.9 39.5 103.7 107.7l-.2 .2zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3c25.6-1.4 54.6-11.4 59.5-73.2c-13.2-2.9-27.8-4.4-43.4-4.4c-4.8 0-9.6 .1-14.4 .4c-42.9 2.4-57.2 23.2-56.2 41.8l-.1 .1z"
    ]
};
var $42f4e3f18906b0d1$export$29d678db44edc00 = {
    prefix: "fab",
    iconName: "napster",
    icon: [
        496,
        512,
        [],
        "f3d2",
        "M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"
    ]
};
var $42f4e3f18906b0d1$export$8176f1a0ece4380c = {
    prefix: "fab",
    iconName: "square-snapchat",
    icon: [
        448,
        512,
        [
            "snapchat-square"
        ],
        "f2ad",
        "M384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H384a64,64,0,0,0,64-64V96A64,64,0,0,0,384,32Zm-3.907,319.309-.083.1a32.364,32.364,0,0,1-8.717,6.823,90.26,90.26,0,0,1-20.586,8.2,12.694,12.694,0,0,0-3.852,1.76c-2.158,1.909-2.1,4.64-4.4,8.55a23.137,23.137,0,0,1-6.84,7.471c-6.707,4.632-14.244,4.923-22.23,5.23-7.214.274-15.39.581-24.729,3.669-3.761,1.245-7.753,3.694-12.377,6.533-11.265,6.9-26.68,16.353-52.3,16.353s-40.925-9.4-52.106-16.279c-4.657-2.888-8.675-5.362-12.543-6.64-9.339-3.08-17.516-3.4-24.729-3.67-7.986-.307-15.523-.6-22.231-5.229a23.085,23.085,0,0,1-6.01-6.11c-3.2-4.632-2.855-7.8-5.254-9.895a13.428,13.428,0,0,0-4.1-1.834,89.986,89.986,0,0,1-20.313-8.127,32.905,32.905,0,0,1-8.3-6.284c-6.583-6.757-8.276-14.776-5.686-21.824,3.436-9.338,11.571-12.111,19.4-16.262,14.776-8.027,26.348-18.055,34.433-29.884a68.236,68.236,0,0,0,5.985-10.567c.789-2.158.772-3.329.241-4.416a7.386,7.386,0,0,0-2.208-2.217c-2.532-1.676-5.113-3.353-6.882-4.5-3.27-2.141-5.868-3.818-7.529-4.98-6.267-4.383-10.65-9.04-13.4-14.245a28.4,28.4,0,0,1-1.369-23.584c4.134-10.924,14.469-17.706,26.978-17.706a37.141,37.141,0,0,1,7.845.83c.689.15,1.37.307,2.042.482-.108-7.43.058-15.357.722-23.119,2.358-27.261,11.912-41.589,21.874-52.994a86.836,86.836,0,0,1,22.28-17.931C188.254,100.383,205.312,96,224,96s35.828,4.383,50.944,13.016a87.169,87.169,0,0,1,22.239,17.9c9.961,11.406,19.516,25.709,21.874,52.995a231.194,231.194,0,0,1,.713,23.118c.673-.174,1.362-.332,2.051-.481a37.131,37.131,0,0,1,7.844-.83c12.5,0,22.82,6.782,26.971,17.706a28.37,28.37,0,0,1-1.4,23.559c-2.74,5.2-7.123,9.861-13.39,14.244-1.668,1.187-4.258,2.864-7.529,4.981-1.835,1.187-4.541,2.947-7.164,4.682a6.856,6.856,0,0,0-1.951,2.034c-.506,1.046-.539,2.191.166,4.208a69.015,69.015,0,0,0,6.085,10.792c8.268,12.1,20.188,22.313,35.454,30.407,1.486.772,2.98,1.5,4.441,2.258.722.332,1.569.763,2.491,1.3,4.9,2.723,9.2,6.01,11.455,12.153C387.821,336.915,386.269,344.7,380.093,351.309Zm-16.719-18.461c-50.313-24.314-58.332-61.918-58.689-64.749-.431-3.379-.921-6.035,2.806-9.472,3.594-3.328,19.541-13.19,23.965-16.278,7.33-5.114,10.534-10.219,8.16-16.495-1.66-4.316-5.686-5.976-9.961-5.976a18.5,18.5,0,0,0-3.993.448c-8.035,1.743-15.838,5.769-20.354,6.857a7.1,7.1,0,0,1-1.66.224c-2.408,0-3.279-1.071-3.088-3.968.564-8.783,1.759-25.925.373-41.937-1.884-22.032-8.99-32.948-17.432-42.6-4.051-4.624-23.135-24.654-59.536-24.654S168.53,134.359,164.479,139c-8.434,9.654-15.531,20.57-17.432,42.6-1.386,16.013-.141,33.147.373,41.937.166,2.756-.68,3.968-3.088,3.968a7.1,7.1,0,0,1-1.66-.224c-4.507-1.087-12.31-5.113-20.346-6.856a18.494,18.494,0,0,0-3.993-.449c-4.25,0-8.3,1.636-9.961,5.977-2.374,6.276.847,11.381,8.168,16.494,4.425,3.088,20.371,12.958,23.966,16.279,3.719,3.437,3.237,6.093,2.805,9.471-.356,2.79-8.384,40.394-58.689,64.749-2.946,1.428-7.96,4.45.88,9.331,13.88,7.628,23.111,6.807,30.3,11.43,6.093,3.927,2.5,12.394,6.923,15.449,5.454,3.76,21.583-.266,42.335,6.6,17.433,5.744,28.116,22.015,58.963,22.015s41.788-16.3,58.938-21.973c20.795-6.865,36.89-2.839,42.336-6.6,4.433-3.055.822-11.522,6.923-15.448,7.181-4.624,16.411-3.8,30.3-11.472C371.36,337.355,366.346,334.333,363.374,332.848Z"
    ]
};
var $42f4e3f18906b0d1$export$20f908cf15afb04b = $42f4e3f18906b0d1$export$8176f1a0ece4380c;
var $42f4e3f18906b0d1$export$74ebd8f5ac37d070 = {
    prefix: "fab",
    iconName: "google-plus-g",
    icon: [
        640,
        512,
        [],
        "f0d5",
        "M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"
    ]
};
var $42f4e3f18906b0d1$export$4fb55b03537dc8e3 = {
    prefix: "fab",
    iconName: "artstation",
    icon: [
        512,
        512,
        [],
        "f77a",
        "M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"
    ]
};
var $42f4e3f18906b0d1$export$4401a9960e402a1c = {
    prefix: "fab",
    iconName: "markdown",
    icon: [
        640,
        512,
        [],
        "f60f",
        "M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"
    ]
};
var $42f4e3f18906b0d1$export$fd6b8582f52b208a = {
    prefix: "fab",
    iconName: "sourcetree",
    icon: [
        448,
        512,
        [],
        "f7d3",
        "M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"
    ]
};
var $42f4e3f18906b0d1$export$384e1aaf24320a2d = {
    prefix: "fab",
    iconName: "google-plus",
    icon: [
        512,
        512,
        [],
        "f2b3",
        "M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"
    ]
};
var $42f4e3f18906b0d1$export$f59fd74fa97e6ae5 = {
    prefix: "fab",
    iconName: "diaspora",
    icon: [
        512,
        512,
        [],
        "f791",
        "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"
    ]
};
var $42f4e3f18906b0d1$export$b14039dbb12386bc = {
    prefix: "fab",
    iconName: "foursquare",
    icon: [
        368,
        512,
        [],
        "f180",
        "M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"
    ]
};
var $42f4e3f18906b0d1$export$2c0cf6f85294daec = {
    prefix: "fab",
    iconName: "stack-overflow",
    icon: [
        384,
        512,
        [],
        "f16c",
        "M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"
    ]
};
var $42f4e3f18906b0d1$export$edfa6885dbf62839 = {
    prefix: "fab",
    iconName: "github-alt",
    icon: [
        480,
        512,
        [],
        "f113",
        "M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
    ]
};
var $42f4e3f18906b0d1$export$699e806dfe31d90b = {
    prefix: "fab",
    iconName: "phoenix-squadron",
    icon: [
        512,
        512,
        [],
        "f511",
        "M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"
    ]
};
var $42f4e3f18906b0d1$export$e4b095fb96bd3e1 = {
    prefix: "fab",
    iconName: "pagelines",
    icon: [
        384,
        512,
        [],
        "f18c",
        "M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"
    ]
};
var $42f4e3f18906b0d1$export$8819d592a12ec37e = {
    prefix: "fab",
    iconName: "algolia",
    icon: [
        512,
        512,
        [],
        "f36c",
        "M256 0C116.1 0 2 112.7 0 252.1C-2 393.6 112.9 510.8 254.5 511.6c43.7 .3 85.9-10.4 123.3-30.7c3.6-2 4.2-7 1.1-9.7l-24-21.2c-4.9-4.3-11.8-5.5-17.8-3c-26.1 11.1-54.5 16.8-83.7 16.4C139 461.9 46.5 366.8 48.3 252.4C50.1 139.5 142.6 48.2 256 48.2H463.7V417.2L345.9 312.5c-3.8-3.4-9.7-2.7-12.7 1.3c-18.9 25-49.7 40.6-83.9 38.2c-47.5-3.3-85.9-41.5-89.5-88.9c-4.2-56.6 40.6-103.9 96.3-103.9c50.4 0 91.9 38.8 96.2 88c.4 4.4 2.4 8.5 5.7 11.4l30.7 27.2c3.5 3.1 9 1.2 9.9-3.4c2.2-11.8 3-24.2 2.1-36.8c-4.9-72-63.3-130-135.4-134.4c-82.7-5.1-151.8 59.5-154 140.6c-2.1 78.9 62.6 147 141.6 148.7c33 .7 63.6-9.6 88.3-27.6L495 509.4c6.6 5.8 17 1.2 17-7.7V9.7c0-5.4-4.4-9.7-9.7-9.7H256z"
    ]
};
var $42f4e3f18906b0d1$export$1052bcfc0bf56d5d = {
    prefix: "fab",
    iconName: "red-river",
    icon: [
        448,
        512,
        [],
        "f3e3",
        "M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"
    ]
};
var $42f4e3f18906b0d1$export$976ebfab93ea9362 = {
    prefix: "fab",
    iconName: "creative-commons-sa",
    icon: [
        496,
        512,
        [],
        "f4ef",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"
    ]
};
var $42f4e3f18906b0d1$export$3fbc2591308fa490 = {
    prefix: "fab",
    iconName: "safari",
    icon: [
        512,
        512,
        [],
        "f267",
        "M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"
    ]
};
var $42f4e3f18906b0d1$export$4675affbae76524d = {
    prefix: "fab",
    iconName: "google",
    icon: [
        488,
        512,
        [],
        "f1a0",
        "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
    ]
};
var $42f4e3f18906b0d1$export$dda4448112663ba = {
    prefix: "fab",
    iconName: "square-font-awesome-stroke",
    icon: [
        448,
        512,
        [
            "font-awesome-alt"
        ],
        "f35c",
        "M201.6,152c-25.4,0-37.4,10.4-57.6,14.4V160c0-8.8-7.2-16-16-16s-16,7.2-16,16v192c0,0.8,0.1,1.6,0.2,2.4 c0.1,0.4,0.1,0.8,0.2,1.2c1.6,7.1,8,12.4,15.6,12.4s14-5.3,15.6-12.4c0.1-0.4,0.2-0.8,0.2-1.2c0.1-0.8,0.2-1.6,0.2-2.4V198.4 c4-0.8,7.7-1.8,11.2-3c14.3-4.7,26-11.4,46.4-11.4c31.4,0,43.2,16,74.6,16c8.9,0,15.9-1.1,24.2-3.5c1.2-0.3,2.4-0.7,3.6-1.1v96 c-10,3.2-17.6,4.6-27.8,4.6c-31.4,0-43.4-16-74.6-16c-10.2,0-18.2,1.8-25.6,4v32c7.4-2.4,15.4-4,25.6-4c31.4,0,43.2,16,74.6,16 c18.6,0,28.2-4.8,59.8-16V152c-31.6,11.2-41.2,16-59.8,16C244.8,168,232.8,152,201.6,152z M384,32H64C28.7,32,0,60.7,0,96v320 c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64V96C448,60.7,419.3,32,384,32z M416,416c0,17.6-14.4,32-32,32H64 c-17.6,0-32-14.4-32-32V96c0-17.6,14.4-32,32-32h320c17.6,0,32,14.4,32,32V416z"
    ]
};
var $42f4e3f18906b0d1$export$85f790d14ecf253e = $42f4e3f18906b0d1$export$dda4448112663ba;
var $42f4e3f18906b0d1$export$f200be919c1eaf0d = {
    prefix: "fab",
    iconName: "atlassian",
    icon: [
        512,
        512,
        [],
        "f77b",
        "M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"
    ]
};
var $42f4e3f18906b0d1$export$ed0a679f653cc1ec = {
    prefix: "fab",
    iconName: "linkedin-in",
    icon: [
        448,
        512,
        [],
        "f0e1",
        "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
    ]
};
var $42f4e3f18906b0d1$export$c5c4219467aa9953 = {
    prefix: "fab",
    iconName: "digital-ocean",
    icon: [
        512,
        512,
        [],
        "f391",
        "M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"
    ]
};
var $42f4e3f18906b0d1$export$3f240983de3f5d10 = {
    prefix: "fab",
    iconName: "nimblr",
    icon: [
        384,
        512,
        [],
        "f5a8",
        "M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"
    ]
};
var $42f4e3f18906b0d1$export$8d89e361d79b386e = {
    prefix: "fab",
    iconName: "chromecast",
    icon: [
        512,
        512,
        [],
        "f838",
        "M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"
    ]
};
var $42f4e3f18906b0d1$export$acd6dee6975fc503 = {
    prefix: "fab",
    iconName: "evernote",
    icon: [
        384,
        512,
        [],
        "f839",
        "M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"
    ]
};
var $42f4e3f18906b0d1$export$5d439911ece032d6 = {
    prefix: "fab",
    iconName: "hacker-news",
    icon: [
        448,
        512,
        [],
        "f1d4",
        "M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
    ]
};
var $42f4e3f18906b0d1$export$e443cc965f82dd02 = {
    prefix: "fab",
    iconName: "creative-commons-sampling",
    icon: [
        496,
        512,
        [],
        "f4f0",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"
    ]
};
var $42f4e3f18906b0d1$export$1a30438e2bd95428 = {
    prefix: "fab",
    iconName: "adversal",
    icon: [
        512,
        512,
        [],
        "f36a",
        "M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"
    ]
};
var $42f4e3f18906b0d1$export$cf9c9b2132d3672c = {
    prefix: "fab",
    iconName: "creative-commons",
    icon: [
        496,
        512,
        [],
        "f25e",
        "M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"
    ]
};
var $42f4e3f18906b0d1$export$17b7e34aba803644 = {
    prefix: "fab",
    iconName: "watchman-monitoring",
    icon: [
        512,
        512,
        [],
        "e087",
        "M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"
    ]
};
var $42f4e3f18906b0d1$export$324e0175b7ef27f7 = {
    prefix: "fab",
    iconName: "fonticons",
    icon: [
        448,
        512,
        [],
        "f280",
        "M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"
    ]
};
var $42f4e3f18906b0d1$export$5c0c3408fef47d33 = {
    prefix: "fab",
    iconName: "weixin",
    icon: [
        576,
        512,
        [],
        "f1d7",
        "M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"
    ]
};
var $42f4e3f18906b0d1$export$621d1ced1e254c1c = {
    prefix: "fab",
    iconName: "shirtsinbulk",
    icon: [
        448,
        512,
        [],
        "f214",
        "M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"
    ]
};
var $42f4e3f18906b0d1$export$f02422936d21d2f4 = {
    prefix: "fab",
    iconName: "codepen",
    icon: [
        512,
        512,
        [],
        "f1cb",
        "M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"
    ]
};
var $42f4e3f18906b0d1$export$9ce7fda0737f89e7 = {
    prefix: "fab",
    iconName: "git-alt",
    icon: [
        448,
        512,
        [],
        "f841",
        "M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"
    ]
};
var $42f4e3f18906b0d1$export$c2221e2ed2fea622 = {
    prefix: "fab",
    iconName: "lyft",
    icon: [
        512,
        512,
        [],
        "f3c3",
        "M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"
    ]
};
var $42f4e3f18906b0d1$export$344ccb7aebcc7cfa = {
    prefix: "fab",
    iconName: "rev",
    icon: [
        448,
        512,
        [],
        "f5b2",
        "M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"
    ]
};
var $42f4e3f18906b0d1$export$b138356c7d4344fd = {
    prefix: "fab",
    iconName: "windows",
    icon: [
        448,
        512,
        [],
        "f17a",
        "M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"
    ]
};
var $42f4e3f18906b0d1$export$2c1079aeb76cd815 = {
    prefix: "fab",
    iconName: "wizards-of-the-coast",
    icon: [
        640,
        512,
        [],
        "f730",
        "M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"
    ]
};
var $42f4e3f18906b0d1$export$d20d4c95d5790834 = {
    prefix: "fab",
    iconName: "square-viadeo",
    icon: [
        448,
        512,
        [
            "viadeo-square"
        ],
        "f2aa",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM118.3 381.2c-68-73.6-19.8-196.1 81.2-196.1c13.3 0 26.6 2.1 39.1 6.7c-4.3 8.4-7.3 17.6-8.4 27.1c-9.7-4.1-20.2-6-30.7-6c-48.8 0-84.6 41.7-84.6 88.9c0 43 28.5 78.7 69.5 85.9c61.5-24 72.9-117.6 72.9-175v0c0-7.3 0-14.8-.6-22.1c-11.2-32.9-26.6-64.6-44.2-94.5c27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70c0 54.1-21.9 99-68.3 128.2l-2.4 .2c50 1 86.2-38.6 86.2-87.2c0-12.2-2.1-24.3-6.9-35.7c9.5-1.9 18.5-5.6 26.4-10.5c15.3 36.6 12.6 87.3-22.8 125.6c-42.4 46.2-120 46.6-162.4 0zM274.6 217.6c21.9-12 49.6-30.7 62.3-53c1.5-3 4.1-8.6 4.5-12c-12.5 27.9-44.2 49.8-73.9 56.7c-4.7-7.3-7.5-15.5-7.5-24.3c0-10.3 5.2-24.1 12.9-31.6c8.3-7.9 18-10.9 27.9-14.1c16-5.1 32.5-10.3 44.5-35.9c32.5 46.2 13.1 130.3-36.3 130.3c-13.3 0-25.1-7.1-34.4-16.1z"
    ]
};
var $42f4e3f18906b0d1$export$46c94e3313db0253 = $42f4e3f18906b0d1$export$d20d4c95d5790834;
var $42f4e3f18906b0d1$export$61e6f6fcefd81d6e = {
    prefix: "fab",
    iconName: "meetup",
    icon: [
        512,
        512,
        [],
        "f2e0",
        "M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"
    ]
};
var $42f4e3f18906b0d1$export$47b9420154e916ca = {
    prefix: "fab",
    iconName: "centos",
    icon: [
        448,
        512,
        [],
        "f789",
        "M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"
    ]
};
var $42f4e3f18906b0d1$export$64d8cc39326ee7a8 = {
    prefix: "fab",
    iconName: "adn",
    icon: [
        496,
        512,
        [],
        "f170",
        "M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"
    ]
};
var $42f4e3f18906b0d1$export$616a6b084ab35801 = {
    prefix: "fab",
    iconName: "cloudsmith",
    icon: [
        512,
        512,
        [],
        "f384",
        "M512 227.6v56.9L284.4 512H227.6L0 284.4V227.6L227.6 0h56.9L512 227.6zm-256 162a133.6 133.6 0 1 0 0-267.1 133.6 133.6 0 1 0 0 267.1z"
    ]
};
var $42f4e3f18906b0d1$export$d668d8d9da44b43e = {
    prefix: "fab",
    iconName: "opensuse",
    icon: [
        640,
        512,
        [],
        "e62b",
        "M471.1 102.7s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3c-51.9-1.8-122.8-4.3-223 57.3c-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.1 307 7 335.1c3.3 12.8 8.9 24.9 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4c44.4 3.9 78.1-16 90-53.3c8.2-25.8 0-63.6-31.5-82.9c-25.6-15.7-53.3-12.1-69.2-1.6c-13.9 9.2-21.8 23.5-21.6 39.2c.3 27.8 24.3 42.6 41.5 42.6c5.4 0 10.7-.9 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9c0-12.1-11.6-14.8-16.8-13.9c-2.9 .5-4.5 2-11.8 2.4c-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9c32.3 2.8 47.7 40.7 28.5 65.7C135 388.5 76.7 388 53.6 344.4c-26-49.2 12.7-111.2 87-98.4c33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3c56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8c5.6-33.8 39.7-18.4 82.4-17.4c66.5 .4 102.1-27 103.1-28c3.7-3.1 6.5-15.8 7-17.7c1.3-5.1-3.2-2.4-3.2-2.4c-8.7 5.2-30.5 15.2-50.9 15.6c-25.3 .5-76.2-25.4-81.6-28.2c-.3-.4 .1 1.2-11-25.5c88.4 58.3 118.3 40.5 145.2 21.7c.8-.6 4.3-2.9 3.6-5.7c-13.8-48.1-22.4-62.7-34.5-69.6c-37-21.6-125-34.7-129.2-35.3c.1-.1-.9-.3-.9 .7l0 0zm135.6 75.4a37.6 37.6 0 1 1 -75.2-2.6 37.6 37.6 0 1 1 75.2 2.6zm-36.6-27.9a26.3 26.3 0 1 0 -1.7 52.5 26.3 26.3 0 1 0 1.7-52.5zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.6 0 15.6v0z"
    ]
};
var $42f4e3f18906b0d1$export$ef7de58d3fe843ba = {
    prefix: "fab",
    iconName: "pied-piper-alt",
    icon: [
        576,
        512,
        [],
        "f1a8",
        "M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"
    ]
};
var $42f4e3f18906b0d1$export$fc95d67ac3aa8c53 = {
    prefix: "fab",
    iconName: "square-dribbble",
    icon: [
        448,
        512,
        [
            "dribbble-square"
        ],
        "f397",
        "M165.9 132.5c-38.3 18-66.8 53.3-75.7 95.7c6.1 .1 62.4 .3 126.4-16.7c-22.7-40.2-47.1-74.1-50.7-79zm26.1-9.1c3.8 5.1 28.6 38.9 51 80c48.6-18.3 69.1-45.9 71.6-49.4C281 124.2 235.3 112.9 192 123.4zM277.4 382c-2-12-10-53.8-29.2-103.6c-55.1 18.8-93.8 56.4-108.1 85.6c40.5 31.6 93.3 36.7 137.3 18zM227.8 232.6C159.6 253 93.4 252.2 87.4 252c0 .7 0 1.4 0 2.1s0 1.4 0 2.1c0 35.1 13.3 67.1 35.1 91.4c22.2-37.9 67.1-77.9 116.5-91.8c-3.4-7.8-7.2-15.5-11.1-23.2zm72.5 136.9c30.7-20.7 52.5-53.6 58.6-91.6c-4.6-1.5-42.3-12.7-85.1-5.8c17.9 49.1 25.1 89.1 26.5 97.4zm-34.8-119c45.5-5.7 90.7 3.4 95.2 4.4c-.3-32.3-11.8-61.9-30.9-85.1c-2.9 3.9-25.8 33.2-76.3 53.9c4.8 9.8 8.3 17.8 12 26.8zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM224 416a160 160 0 1 1 0-320 160 160 0 1 1 0 320z"
    ]
};
var $42f4e3f18906b0d1$export$ff55221913bb3cd0 = $42f4e3f18906b0d1$export$fc95d67ac3aa8c53;
var $42f4e3f18906b0d1$export$248fddd2c856e8cc = {
    prefix: "fab",
    iconName: "codiepie",
    icon: [
        472,
        512,
        [],
        "f284",
        "M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"
    ]
};
var $42f4e3f18906b0d1$export$4c16416edc1f091a = {
    prefix: "fab",
    iconName: "node",
    icon: [
        640,
        512,
        [],
        "f419",
        "M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"
    ]
};
var $42f4e3f18906b0d1$export$4176cb98e090fc09 = {
    prefix: "fab",
    iconName: "mix",
    icon: [
        448,
        512,
        [],
        "f3cb",
        "M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"
    ]
};
var $42f4e3f18906b0d1$export$7c80ad2689275b29 = {
    prefix: "fab",
    iconName: "steam",
    icon: [
        496,
        512,
        [],
        "f1b6",
        "M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"
    ]
};
var $42f4e3f18906b0d1$export$37af1170a8e0c21b = {
    prefix: "fab",
    iconName: "cc-apple-pay",
    icon: [
        576,
        512,
        [],
        "f416",
        "M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"
    ]
};
var $42f4e3f18906b0d1$export$d271dfaa2c63aec5 = {
    prefix: "fab",
    iconName: "scribd",
    icon: [
        384,
        512,
        [],
        "f28a",
        "M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"
    ]
};
var $42f4e3f18906b0d1$export$b30079bac9ebcf2a = {
    prefix: "fab",
    iconName: "debian",
    icon: [
        448,
        512,
        [],
        "e60b",
        "M380.2 245.6c3-7.6 5.5-14 5.2-24.4l-4.3 9c4.4-13.2 4-27.1 3.6-40.4c-.2-6-.3-11.8 0-17.4l-1.8-.5c-1.5-45.2-40.6-93.1-75.3-109.4c-30-13.8-76.1-16.2-97.3-5.8c1.3-1.1 4.2-2 6.8-2.7l.3-.1c3.3-1 6-1.7 4-2.9c-19.2 1.9-24.9 5.5-31.1 9.4l-.1 0c-4.6 2.9-9.5 6-20.3 8.7c-3.5 3.4 1.7 2 5.8 .9l0 0c4.1-1.1 7.2-1.9-.1 2.4c-3.5 1-6.6 1.3-9.6 1.6l-.1 0c-8.3 .8-15.8 1.6-30.7 17c.8 1.3 3.4-.2 5.3-1.3l.1-.1c2.3-1.4 3.4-2-1.7 4.4c-19.1-2.4-60.3 43.7-69.1 59l4.6 .8c-3.2 8-6.8 14.8-10 20.8c-4.3 8.1-7.9 14.9-8.7 21.3c-.3 5.1-1 11-1.7 17.3l0 0c-.1 1-.2 2-.3 3l-.1 .6c-3 27.3-6.7 60.8 3.9 73l-1.3 13c.6 1.2 1.1 2.3 1.6 3.5c.2 .4 .4 .8 .5 1.1l0 0 0 0 0 0 0 0 0 0 0 0 0 0c1 2.1 2 4.2 3.3 6.2l-3 .2c7 22.1 10.8 22.5 15.1 22.9l0 0c4.4 .4 9.3 .9 18.7 24.2c-2.7-.9-5.5-1.9-9.4-7.2c-.5 4.1 5.8 16.3 13.1 25.8l-3.1 3.6c2.1 3.7 4.8 6.2 7.6 8.8l0 0 0 0c1 .9 2.1 1.9 3.1 2.9c-11.9-6.5 3.2 13.7 11.9 25.2c.8 1.1 1.5 2 2.2 2.9l0 0 0 0 0 0 0 0 0 0c1.4 1.9 2.5 3.4 2.9 4.1l2.4-4.2c-.3 6.1 4.3 13.9 13.1 24.7l7.3-.3c3 6 14 16.7 20.7 17.2l-4.4 5.8c8.1 2.6 10.3 4.3 12.7 6.2c2.6 2.1 5.4 4.3 16.1 8.1l-4.2-7.4c3.5 3 6.2 5.9 8.8 8.7l.1 .1c5.2 5.6 9.9 10.6 19.7 15.3c10.7 3.7 16.6 4.7 22.7 5.8c.3 0 .6 .1 .9 .1c5.4 .8 11.2 1.8 20.8 4.5c-1.1-.1-2.2-.1-3.3-.1h0c-2.3-.1-4.7-.1-7-.1l0 0 0 0 0 0 0 0 0 0 0 0 0 0c-14.4-.2-29.2-.4-42.7-5.2C107.8 480.5 19.5 367.2 26 250.6c-.6-9.9-.3-20.9 0-30.7c.4-13.5 .7-24.8-1.6-28.3l1-3.1c5.3-17.4 11.7-38.2 23.8-62.8l-.1-.2v-.1c.4 .4 3.4 3.4 8.8-5.8c.8-1.8 1.6-3.7 2.4-5.6c.5-1.1 .9-2.2 1.4-3.2c2.5-6.1 5.1-12.3 8.4-17.9l2.6-.6c1.7-10.1 17-23.8 29.8-35.2l1.1-1c5.7-5.1 10.7-9.7 13.6-13.1l.7 4.4c17-15.9 44.6-27.5 65.6-36.4l.5-.2c4.8-2 9.3-3.9 13.3-5.7c-3.4 3.8 2.2 2.7 10 1c4.8-1 10.4-2.1 15.3-2.4l-3.9 2.1c-2.7 1.4-5.4 2.8-8 4.6c8.1-2 11.7-1.4 15.7-.8l.3 0c3.5 .6 7.3 1.2 14.6 .2c-5.6 .8-12.3 3-11.2 3.8c7.9 .9 12.8-.1 17.2-1l.2 0c5.5-1.1 10.3-2 19.3 .9l-1-4.8c7.3 2.6 12.7 4.3 17.5 5.8l.5 .1c10 3 17.6 5.3 34.2 14.1c3.2 .2 5.3-.5 7.4-1.2l.1 0c3.6-1.1 7-2.1 15.2 1.2c.3 .5 .5 1 .7 1.4c.1 .2 .2 .5 .3 .7l0 .1c1 2.6 1.8 4.6 14.6 12.1c1.7-.7-2.7-4.7-6.4-8.2c0 0 0 0-.1-.1c-.2-.1-.3-.3-.5-.4c32.2 17.3 67.3 54.1 78 93.5c-6-11.1-5.2-5.5-4.3 .5c.6 4 1.2 8.1-.2 7.5c4.5 12.1 8.1 24.5 10.4 37.4l-.8-2.9-.1-.3c-3.3-11.9-9.6-34.3-19.9-49.3c-.4 4.3-2.8 3.9-5.2 3.5l-.1 0 0 0c-3.3-.6-6.2-1.1-1.9 12.6c2.6 3.8 3.1 2.4 3.5 1.1l0 0c.5-1.5 .9-2.7 4.7 5.2c.1 4.1 1 8.2 2.1 12.7l0 0 0 0 .1 .6c.1 .3 .1 .5 .2 .8l.1 .6c.6 2.6 1.3 5.4 1.8 8.4c-1.1-.2-2.3-2.2-3.4-4.2c-1.4-2.4-2.8-4.7-3.7-3.2c2.4 11.5 6.5 17.4 8 18.3c-.3 .6-.6 .7-1.1 .7c-.8 0-1.8 .1-1.9 5.3c.7 13.7 3.3 12.5 5.3 11.6l0 0c.6-.3 1.2-.6 1.7-.4c-.6 2.5-1.6 5.1-2.7 7.9c-2.8 7.1-6 15.4-3.4 26.1c-.8-3-2-6-3.1-8.9l-.1-.4c-.2-.5-.4-1-.6-1.5l0 0c-.3-.8-.6-1.6-.9-2.3c-.6 4.4-.3 7.7-.1 10.6c0 .2 0 .5 0 .7c.4 5.3 .7 10-3 19.9c4.3-14.2 3.8-26.9-.2-20.8c1 10.9-3.7 20.4-8 28.9l-.1 .2c-3.6 7.1-6.8 13.5-5.9 19.3l-5.2-7.1c-7.5 10.9-7 13.3-6.5 15.5l0 .1c.5 1.9 1 3.8-3.4 10.8c1.7-2.9 1.3-3.6 1-4.2l0 0c-.4-.8-.7-1.5 1.7-5.1c-1.6 .1-5.5 3.9-10.1 8.5c-3.9 3.9-8.5 8.4-12.8 11.8c-37.5 30.1-82.3 34-125.6 17.8c.2-1-.2-2.1-3.1-4.1c-36.8-28.2-58.5-52.1-50.9-107.5c2.1-1.6 3.6-5.8 5.3-10.8l0 0 0 0 .2-.4 .1-.3 0-.1c2.9-8.4 6.5-18.8 14.3-23.8c7.8-17.3 31.3-33.3 56.4-33.7c25.6-1.4 47.2 13.7 58.1 27.9c-19.8-18.4-52.1-24-79.7-10.4c-28.2 12.7-45 43.8-42.5 74.7c.3-.4 .6-.6 .9-.8l0 0s0 0 0 0c0 0 .1-.1 .1-.1l.1-.1c.6-.5 1.1-.9 1.4-3.3c-.9 60.2 64.8 104.3 112.1 82l.6 1.3c12.7-3.5 15.9-6.5 20.3-10.7l.1-.1 0 0c2.2-2.1 4.7-4.5 8.9-7.3c-.3 .7-1.3 1.7-2.4 2.7c-2.2 2.1-4.6 4.5-1.6 4.6c5-1.3 18.5-13.4 28.5-22.3l0 0 0 0c.6-.5 1.2-1 1.7-1.5c1.5-1.3 2.8-2.5 4-3.6l0 0 .3-.3c1.9-4.2 1.6-5.6 1.3-7l0-.1c-.4-1.6-.8-3.3 2.4-9.6l7.3-3.7c.8-2.1 1.5-4.1 2.2-6c.2-.6 .5-1.2 .7-1.8l-.4-.2zM349.3 34.3l-.2-.1 .2 .1 0 0zM247.8 334.1c-6-3-13.7-8.9-14.8-11.4l-.4 .3c-.3 .6-.5 1.3-.2 2.2c-12.2-5.7-23.4-14.3-32.6-24.9c4.9 7.1 10.1 14.1 17 19.5c-6.9-2.3-15.1-11.8-21.6-19.3l-.1-.1c-4.3-5-7.9-9.1-9.7-9.5c19.8 35.5 80.5 62.3 112.3 49c-14.7 .5-33.4 .3-49.9-5.8zm79.3-119.7l-.1-.2c-.5-1.5-1.1-3.1-1.7-3.4c1.4-5.8 5.4-10.7 4.4 4.6c-1 3.8-1.8 1.5-2.6-1zm-4.2 22.2c-1.3 7.9-5 15.5-10.1 22.5c.2-2-1.2-2.4-2.6-2.8l0 0c-2.9-.8-5.9-1.6 5.6-16.1c-.5 1.9-2.1 4.6-3.7 7.3l0 0 0 0-.3 .4c-3.6 5.9-6.7 11 4 4.3l1-1.8c2.6-4.5 5-8.8 6-13.8h.1zm-55.6 33.9c7.1 .6 14.1 .6 21-1.1c-2.5 2.4-5.2 4.8-8.3 7.2c-11.1-1.7-21.2-6-12.7-6.1zm-92.6 11.6c3.6 7.1 6.4 11.5 9 15.7l.1 .2c2.3 3.7 4.4 7.1 6.8 11.7c-5.1-4.2-8.7-9.5-12.5-15l-.3-.5c-1.4-2.1-2.8-4.2-4.4-6.2l1.2-5.9h.1zm7.5-9.6c1.6 3.3 3.2 6.4 5.7 9.1l2.6 7.7-1.3-2.1c-3.2-5.3-6.3-10.6-8-16.7l.8 1.6 .2 .4zm238.9-41.6c-2.3 17.4-7.7 34.6-16 50.3c7.6-14.9 12.5-30.9 14.8-47.2l1.2-3.1zM35.6 110.6c.4 .8 1.4 .5 2.3 .3c1.9-.5 3.6-.9-.1 7.6c-.5 .3-1 .7-1.5 1l0 0 0 0c-1.4 .9-2.8 1.9-3.9 3c1.9-3.8 3.5-7.4 3.2-11.9zM25.3 152.3c-.7 3.7-1.5 7.9-3.4 13.9c.2-1.9 0-3.5-.2-4.9l0-.1c-.4-3.4-.7-6.3 4.3-12.8c-.3 1.2-.5 2.5-.7 3.8v.1z"
    ]
};
var $42f4e3f18906b0d1$export$b2dcd141e150a391 = {
    prefix: "fab",
    iconName: "openid",
    icon: [
        448,
        512,
        [],
        "f19b",
        "M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"
    ]
};
var $42f4e3f18906b0d1$export$792bea9ca32c60da = {
    prefix: "fab",
    iconName: "instalod",
    icon: [
        512,
        512,
        [],
        "e081",
        "M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"
    ]
};
var $42f4e3f18906b0d1$export$fe553f3645c5aefa = {
    prefix: "fab",
    iconName: "expeditedssl",
    icon: [
        496,
        512,
        [],
        "f23e",
        "M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"
    ]
};
var $42f4e3f18906b0d1$export$23a4f18e8bd9f913 = {
    prefix: "fab",
    iconName: "sellcast",
    icon: [
        448,
        512,
        [],
        "f2da",
        "M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"
    ]
};
var $42f4e3f18906b0d1$export$58fc652e3c488143 = {
    prefix: "fab",
    iconName: "square-twitter",
    icon: [
        448,
        512,
        [
            "twitter-square"
        ],
        "f081",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM351.3 199.3v0c0 86.7-66 186.6-186.6 186.6c-37.2 0-71.7-10.8-100.7-29.4c5.3 .6 10.4 .8 15.8 .8c30.7 0 58.9-10.4 81.4-28c-28.8-.6-53-19.5-61.3-45.5c10.1 1.5 19.2 1.5 29.6-1.2c-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3c-9-6-16.4-14.1-21.5-23.6s-7.8-20.2-7.7-31c0-12.2 3.2-23.4 8.9-33.1c32.3 39.8 80.8 65.8 135.2 68.6c-9.3-44.5 24-80.6 64-80.6c18.9 0 35.9 7.9 47.9 20.7c14.8-2.8 29-8.3 41.6-15.8c-4.9 15.2-15.2 28-28.8 36.1c13.2-1.4 26-5.1 37.8-10.2c-8.9 13.1-20.1 24.7-32.9 34c.2 2.8 .2 5.7 .2 8.5z"
    ]
};
var $42f4e3f18906b0d1$export$270370f3feaf6b90 = $42f4e3f18906b0d1$export$58fc652e3c488143;
var $42f4e3f18906b0d1$export$f9a04980ef22b6b0 = {
    prefix: "fab",
    iconName: "r-project",
    icon: [
        581,
        512,
        [],
        "f4f7",
        "M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"
    ]
};
var $42f4e3f18906b0d1$export$fc15ee5b2eab0af4 = {
    prefix: "fab",
    iconName: "delicious",
    icon: [
        448,
        512,
        [],
        "f1a5",
        "M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"
    ]
};
var $42f4e3f18906b0d1$export$1fa830857b3a4dc7 = {
    prefix: "fab",
    iconName: "freebsd",
    icon: [
        448,
        512,
        [],
        "f3a4",
        "M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"
    ]
};
var $42f4e3f18906b0d1$export$3e0cc9b4555f8145 = {
    prefix: "fab",
    iconName: "vuejs",
    icon: [
        448,
        512,
        [],
        "f41f",
        "M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"
    ]
};
var $42f4e3f18906b0d1$export$233214294e90ff53 = {
    prefix: "fab",
    iconName: "accusoft",
    icon: [
        640,
        512,
        [],
        "f369",
        "M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"
    ]
};
var $42f4e3f18906b0d1$export$d11e9e62a1442448 = {
    prefix: "fab",
    iconName: "ioxhost",
    icon: [
        640,
        512,
        [],
        "f208",
        "M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"
    ]
};
var $42f4e3f18906b0d1$export$e6a0ac478bf76bf2 = {
    prefix: "fab",
    iconName: "fonticons-fi",
    icon: [
        384,
        512,
        [],
        "f3a2",
        "M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"
    ]
};
var $42f4e3f18906b0d1$export$500760921a1e1f4e = {
    prefix: "fab",
    iconName: "app-store",
    icon: [
        512,
        512,
        [],
        "f36f",
        "M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
    ]
};
var $42f4e3f18906b0d1$export$dd0d0d0b3b519db5 = {
    prefix: "fab",
    iconName: "cc-mastercard",
    icon: [
        576,
        512,
        [],
        "f1f1",
        "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
    ]
};
var $42f4e3f18906b0d1$export$a0c8448ba3e387bc = {
    prefix: "fab",
    iconName: "itunes-note",
    icon: [
        384,
        512,
        [],
        "f3b5",
        "M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"
    ]
};
var $42f4e3f18906b0d1$export$36cd41563937ec03 = {
    prefix: "fab",
    iconName: "golang",
    icon: [
        640,
        512,
        [],
        "e40f",
        "M400.1 194.8C389.2 197.6 380.2 199.1 371 202.4C363.7 204.3 356.3 206.3 347.8 208.5L347.2 208.6C343 209.8 342.6 209.9 338.7 205.4C334 200.1 330.6 196.7 324.1 193.5C304.4 183.9 285.4 186.7 267.7 198.2C246.5 211.9 235.6 232.2 235.9 257.4C236.2 282.4 253.3 302.9 277.1 306.3C299.1 309.1 316.9 301.7 330.9 285.8C333 283.2 334.9 280.5 337 277.5V277.5L337 277.5C337.8 276.5 338.5 275.4 339.3 274.2H279.2C272.7 274.2 271.1 270.2 273.3 264.9C277.3 255.2 284.8 239 289.2 230.9C290.1 229.1 292.3 225.1 296.1 225.1H397.2C401.7 211.7 409 198.2 418.8 185.4C441.5 155.5 468.1 139.9 506 133.4C537.8 127.8 567.7 130.9 594.9 149.3C619.5 166.1 634.7 188.9 638.8 218.8C644.1 260.9 631.9 295.1 602.1 324.4C582.4 345.3 557.2 358.4 528.2 364.3C522.6 365.3 517.1 365.8 511.7 366.3C508.8 366.5 506 366.8 503.2 367.1C474.9 366.5 449 358.4 427.2 339.7C411.9 326.4 401.3 310.1 396.1 291.2C392.4 298.5 388.1 305.6 382.1 312.3C360.5 341.9 331.2 360.3 294.2 365.2C263.6 369.3 235.3 363.4 210.3 344.7C187.3 327.2 174.2 304.2 170.8 275.5C166.7 241.5 176.7 210.1 197.2 184.2C219.4 155.2 248.7 136.8 284.5 130.3C313.8 124.1 341.8 128.4 367.1 145.6C383.6 156.5 395.4 171.4 403.2 189.5C405.1 192.3 403.8 193.9 400.1 194.8zM48.3 200.4C47.05 200.4 46.74 199.8 47.36 198.8L53.91 190.4C54.53 189.5 56.09 188.9 57.34 188.9H168.6C169.8 188.9 170.1 189.8 169.5 190.7L164.2 198.8C163.6 199.8 162 200.7 161.1 200.7L48.3 200.4zM1.246 229.1C0 229.1-.3116 228.4 .3116 227.5L6.855 219.1C7.479 218.2 9.037 217.5 10.28 217.5H152.4C153.6 217.5 154.2 218.5 153.9 219.4L151.4 226.9C151.1 228.1 149.9 228.8 148.6 228.8L1.246 229.1zM75.72 255.9C75.1 256.8 75.41 257.7 76.65 257.7L144.6 258C145.5 258 146.8 257.1 146.8 255.9L147.4 248.4C147.4 247.1 146.8 246.2 145.5 246.2H83.2C81.95 246.2 80.71 247.1 80.08 248.1L75.72 255.9zM577.2 237.9C577 235.3 576.9 233.1 576.5 230.9C570.9 200.1 542.5 182.6 512.9 189.5C483.9 196 465.2 214.4 458.4 243.7C452.8 268 464.6 292.6 487 302.6C504.2 310.1 521.3 309.2 537.8 300.7C562.4 287.1 575.8 268 577.4 241.2C577.3 240 577.3 238.9 577.2 237.9z"
    ]
};
var $42f4e3f18906b0d1$export$f06b8625c0ebb13a = {
    prefix: "fab",
    iconName: "kickstarter",
    icon: [
        448,
        512,
        [],
        "f3bb",
        "M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48zM199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z"
    ]
};
var $42f4e3f18906b0d1$export$fdcdacf548a335ed = {
    prefix: "fab",
    iconName: "grav",
    icon: [
        512,
        512,
        [],
        "f2d6",
        "M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"
    ]
};
var $42f4e3f18906b0d1$export$75bd846ccb390b1e = {
    prefix: "fab",
    iconName: "weibo",
    icon: [
        512,
        512,
        [],
        "f18a",
        "M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"
    ]
};
var $42f4e3f18906b0d1$export$e1cced2e7ea20eff = {
    prefix: "fab",
    iconName: "uncharted",
    icon: [
        448,
        512,
        [],
        "e084",
        "M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"
    ]
};
var $42f4e3f18906b0d1$export$44a54556e145bddf = {
    prefix: "fab",
    iconName: "firstdraft",
    icon: [
        384,
        512,
        [],
        "f3a1",
        "M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"
    ]
};
var $42f4e3f18906b0d1$export$1082b39fc1076b43 = {
    prefix: "fab",
    iconName: "square-youtube",
    icon: [
        448,
        512,
        [
            61798,
            "youtube-square"
        ],
        "f431",
        "M282 256.2l-95.2-54.1V310.3L282 256.2zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm14.4 136.1c7.6 28.6 7.6 88.2 7.6 88.2s0 59.6-7.6 88.1c-4.2 15.8-16.5 27.7-32.2 31.9C337.9 384 224 384 224 384s-113.9 0-142.2-7.6c-15.7-4.2-28-16.1-32.2-31.9C42 315.9 42 256.3 42 256.3s0-59.7 7.6-88.2c4.2-15.8 16.5-28.2 32.2-32.4C110.1 128 224 128 224 128s113.9 0 142.2 7.7c15.7 4.2 28 16.6 32.2 32.4z"
    ]
};
var $42f4e3f18906b0d1$export$8992da42b645c563 = $42f4e3f18906b0d1$export$1082b39fc1076b43;
var $42f4e3f18906b0d1$export$6657c749288c4042 = {
    prefix: "fab",
    iconName: "wikipedia-w",
    icon: [
        640,
        512,
        [],
        "f266",
        "M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"
    ]
};
var $42f4e3f18906b0d1$export$66f88c21efa6f12d = {
    prefix: "fab",
    iconName: "wpressr",
    icon: [
        496,
        512,
        [
            "rendact"
        ],
        "f3e4",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"
    ]
};
var $42f4e3f18906b0d1$export$d06b08e37a8aaaec = $42f4e3f18906b0d1$export$66f88c21efa6f12d;
var $42f4e3f18906b0d1$export$65f66dc47afb97bd = {
    prefix: "fab",
    iconName: "angellist",
    icon: [
        448,
        512,
        [],
        "f209",
        "M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"
    ]
};
var $42f4e3f18906b0d1$export$ba5a2dfe23db8bb6 = {
    prefix: "fab",
    iconName: "galactic-republic",
    icon: [
        496,
        512,
        [],
        "f50c",
        "M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"
    ]
};
var $42f4e3f18906b0d1$export$d637dd7b404459cf = {
    prefix: "fab",
    iconName: "nfc-directional",
    icon: [
        512,
        512,
        [],
        "e530",
        "M211.8 488.6C213.4 491.1 213.9 494.2 213.2 497.1C212.6 500 210.8 502.6 208.3 504.2C205.7 505.8 202.7 506.3 199.7 505.7C138.3 491.8 84.1 455.8 47.53 404.5C10.97 353.2-5.395 290.3 1.57 227.7C8.536 165 38.34 107.2 85.29 65.21C132.2 23.2 193-.0131 256 0C257.5 0 258.1 .2931 260.3 .8627C261.7 1.432 262.1 2.267 264 3.319C265.1 4.371 265.9 5.619 266.5 6.993C267 8.367 267.3 9.839 267.3 11.32V112.3L291.8 86.39C292.8 85.31 294 84.44 295.4 83.84C296.7 83.23 298.2 82.9 299.7 82.86C301.2 82.81 302.6 83.06 304 83.59C305.4 84.12 306.7 84.92 307.8 85.94C308.8 86.96 309.7 88.18 310.3 89.54C310.9 90.89 311.3 92.35 311.3 93.84C311.3 95.32 311.1 96.8 310.6 98.18C310 99.57 309.2 100.8 308.2 101.9L264.2 148.5C263.1 149.6 261.9 150.5 260.5 151.1C259 151.7 257.5 152 255.1 152C254.5 152 252.9 151.7 251.5 151.1C250.1 150.5 248.8 149.6 247.8 148.5L203.7 101.9C201.7 99.74 200.6 96.83 200.7 93.84C200.7 90.84 202 87.1 204.2 85.94C206.4 83.88 209.3 82.77 212.3 82.86C215.3 82.94 218.1 84.21 220.2 86.39L244.7 112.4V22.89C188.3 25.64 134.9 48.73 94.23 87.87C53.58 127 28.49 179.6 23.61 235.8C18.73 292 34.38 348.1 67.68 393.7C100.1 439.2 149.7 471.2 204.7 483.6C207.6 484.3 210.2 486.1 211.8 488.6L211.8 488.6zM171.4 126.1C170.6 127.4 169.5 128.5 168.3 129.3C147.8 143.2 131.1 161.9 119.5 183.8C107.9 205.7 101.8 230.1 101.8 254.9C101.8 279.7 107.9 304.1 119.5 325.1C131.1 347.9 147.8 366.6 168.3 380.5C170.8 382.2 172.5 384.8 173 387.8C173.6 390.7 172.1 393.8 171.3 396.2C169.6 398.7 166.1 400.4 164 400.1C161.1 401.5 158 400.9 155.6 399.2C132 383.2 112.8 361.7 99.46 336.5C86.15 311.4 79.19 283.4 79.19 254.9C79.19 226.5 86.15 198.4 99.46 173.3C112.8 148.1 132 126.6 155.6 110.6C156.8 109.8 158.2 109.2 159.6 108.8C161.1 108.5 162.6 108.5 164.1 108.8C165.5 109 166.9 109.6 168.2 110.4C169.5 111.2 170.5 112.3 171.4 113.5C172.2 114.7 172.8 116.1 173.1 117.6C173.4 119.1 173.4 120.6 173.1 122C172.8 123.5 172.3 124.9 171.4 126.1H171.4zM340.9 383.5C341.7 382.3 342.8 381.2 343.1 380.4V380.3C364.4 366.3 381.1 347.6 392.7 325.7C404.2 303.9 410.2 279.5 410.2 254.8C410.2 230.1 404.2 205.7 392.7 183.8C381.1 161.1 364.4 143.3 343.1 129.3C342.8 128.5 341.7 127.4 340.9 126.2C340.1 124.9 339.5 123.5 339.3 122.1C338.1 120.6 339 119.1 339.3 117.7C339.6 116.2 340.2 114.8 341 113.6C341.9 112.4 342.1 111.3 344.2 110.5C345.4 109.7 346.8 109.2 348.3 108.9C349.8 108.6 351.2 108.6 352.7 108.9C354.2 109.2 355.5 109.8 356.8 110.7C380.2 126.7 399.5 148.2 412.7 173.3C426 198.4 432.1 226.4 432.1 254.8C432.1 283.3 426 311.3 412.7 336.4C399.5 361.5 380.2 383 356.8 399C355.5 399.9 354.2 400.5 352.7 400.8C351.2 401.1 349.8 401.1 348.3 400.8C346.8 400.5 345.4 399.1 344.2 399.2C342.1 398.4 341.9 397.3 341 396.1C340.2 394.9 339.6 393.5 339.3 392C339 390.6 338.1 389.1 339.3 387.6C339.5 386.2 340.1 384.8 340.9 383.5V383.5zM312.3 6.307C368.5 19.04 418.7 50.28 455 95.01C485.4 132.6 504.6 178 510.3 226C515.9 274 507.9 322.7 487.1 366.3C466.2 409.9 433.5 446.8 392.6 472.6C351.7 498.3 304.4 512 256 512C254.5 512 253.1 511.7 251.7 511.1C250.3 510.6 249.1 509.7 248 508.7C246.1 507.6 246.1 506.4 245.6 505C245 503.6 244.7 502.2 244.7 500.7V401.5L220.2 427.5C218.1 429.7 215.3 430.1 212.3 431.1C209.3 431.2 206.4 430 204.2 427.1C202 425.9 200.7 423.1 200.7 420.1C200.6 417.1 201.7 414.2 203.7 412L247.8 365.4C249.1 363.2 252.9 362 255.1 362C259.1 362 262 363.2 264.2 365.4L308.2 412C310.3 414.2 311.4 417.1 311.3 420.1C311.2 423.1 309.9 425.9 307.8 427.1C305.6 430 302.7 431.2 299.7 431.1C296.7 430.1 293.8 429.7 291.8 427.5L267.3 401.6V489.1C323.7 486.3 377.1 463.3 417.8 424.1C458.5 384.1 483.6 332.4 488.5 276.2C493.3 219.1 477.7 163.9 444.4 118.3C411.1 72.75 362.4 40.79 307.4 28.36C305.9 28.03 304.6 27.42 303.3 26.57C302.1 25.71 301.1 24.63 300.3 23.37C299.5 22.12 298.1 20.72 298.7 19.26C298.5 17.8 298.5 16.3 298.8 14.85C299.2 13.41 299.8 12.04 300.6 10.82C301.5 9.61 302.6 8.577 303.8 7.784C305.1 6.99 306.5 6.451 307.9 6.198C309.4 5.945 310.9 5.982 312.3 6.307L312.3 6.307zM353.1 256.1C353.1 287.5 335.6 317.2 303.8 339.6C301.7 341.1 299 341.9 296.4 341.6C293.7 341.4 291.2 340.3 289.4 338.4L219.3 268.6C217.1 266.5 215.1 263.6 215.9 260.6C215.9 257.6 217.1 254.7 219.2 252.6C221.4 250.5 224.2 249.3 227.2 249.3C230.2 249.3 233.1 250.5 235.2 252.6L298.3 315.4C319.1 298.3 330.5 277.5 330.5 256.1C330.5 232.2 316.4 209.1 290.8 191C288.3 189.3 286.7 186.7 286.2 183.7C285.7 180.8 286.3 177.7 288.1 175.3C289.8 172.8 292.4 171.2 295.4 170.7C298.3 170.2 301.4 170.8 303.8 172.6C335.6 195 353.1 224.7 353.1 256.1V256.1zM216.7 341.5C213.7 342 210.7 341.3 208.2 339.6C176.5 317.2 158.1 287.5 158.1 256.1C158.1 224.7 176.5 195 208.2 172.6C210.4 171 213.1 170.3 215.7 170.5C218.4 170.8 220.8 171.9 222.7 173.8L292.8 243.6C294.9 245.7 296.1 248.6 296.1 251.6C296.1 254.6 294.1 257.4 292.8 259.6C290.7 261.7 287.8 262.9 284.9 262.9C281.9 262.9 278.1 261.7 276.9 259.6L213.8 196.7C192.9 214 181.6 234.7 181.6 256.1C181.6 279.1 195.7 303.1 221.3 321.1C223.7 322.9 225.4 325.5 225.9 328.5C226.4 331.4 225.7 334.4 224 336.9C222.3 339.3 219.6 341 216.7 341.5L216.7 341.5z"
    ]
};
var $42f4e3f18906b0d1$export$78370b1b91348c9e = {
    prefix: "fab",
    iconName: "skype",
    icon: [
        448,
        512,
        [],
        "f17e",
        "M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
    ]
};
var $42f4e3f18906b0d1$export$ae307621d0877ba2 = {
    prefix: "fab",
    iconName: "joget",
    icon: [
        496,
        512,
        [],
        "f3b7",
        "M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"
    ]
};
var $42f4e3f18906b0d1$export$8cf9f3ca16e668b0 = {
    prefix: "fab",
    iconName: "fedora",
    icon: [
        448,
        512,
        [],
        "f798",
        "M.0413 255.8C.1219 132.2 100.3 32 224 32C347.7 32 448 132.3 448 256C448 379.7 347.8 479.9 224.1 480H50.93C22.84 480 .0832 457.3 .0416 429.2H0V255.8H.0413zM342.6 192.7C342.6 153 307 124.2 269.4 124.2C234.5 124.2 203.6 150.5 199.3 184.1C199.1 187.9 198.9 189.1 198.9 192.6C198.8 213.7 198.9 235.4 198.1 257C199 283.1 199.1 309.1 198.1 333.6C198.1 360.7 178.7 379.1 153.4 379.1C128.1 379.1 107.6 358.9 107.6 333.6C108.1 305.9 130.2 288.3 156.1 287.5H156.3L182.6 287.3V250L156.3 250.2C109.2 249.8 71.72 286.7 70.36 333.6C70.36 379.2 107.9 416.5 153.4 416.5C196.4 416.5 232.1 382.9 236 340.9L236.2 287.4L268.8 287.1C294.1 287.3 293.8 249.3 268.6 249.8L236.2 250.1C236.2 243.7 236.3 237.3 236.3 230.9C236.4 218.2 236.4 205.5 236.2 192.7C236.3 176.2 252 161.5 269.4 161.5C286.9 161.5 305.3 170.2 305.3 192.7C305.3 195.9 305.2 197.8 305 199C303.1 209.5 310.2 219.4 320.7 220.9C331.3 222.4 340.9 214.8 341.9 204.3C342.5 200.1 342.6 196.4 342.6 192.7H342.6z"
    ]
};
var $42f4e3f18906b0d1$export$4823078d958b443a = {
    prefix: "fab",
    iconName: "stripe-s",
    icon: [
        384,
        512,
        [],
        "f42a",
        "M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"
    ]
};
var $42f4e3f18906b0d1$export$75b94550e27ccec5 = {
    prefix: "fab",
    iconName: "meta",
    icon: [
        640,
        512,
        [],
        "e49b",
        "M640 317.9C640 409.2 600.6 466.4 529.7 466.4C467.1 466.4 433.9 431.8 372.8 329.8L341.4 277.2C333.1 264.7 326.9 253 320.2 242.2C300.1 276 273.1 325.2 273.1 325.2C206.1 441.8 168.5 466.4 116.2 466.4C43.42 466.4 0 409.1 0 320.5C0 177.5 79.78 42.4 183.9 42.4C234.1 42.4 277.7 67.08 328.7 131.9C365.8 81.8 406.8 42.4 459.3 42.4C558.4 42.4 640 168.1 640 317.9H640zM287.4 192.2C244.5 130.1 216.5 111.7 183 111.7C121.1 111.7 69.22 217.8 69.22 321.7C69.22 370.2 87.7 397.4 118.8 397.4C149 397.4 167.8 378.4 222 293.6C222 293.6 246.7 254.5 287.4 192.2V192.2zM531.2 397.4C563.4 397.4 578.1 369.9 578.1 322.5C578.1 198.3 523.8 97.08 454.9 97.08C421.7 97.08 393.8 123 360 175.1C369.4 188.9 379.1 204.1 389.3 220.5L426.8 282.9C485.5 377 500.3 397.4 531.2 397.4L531.2 397.4z"
    ]
};
var $42f4e3f18906b0d1$export$bfe42001388ccf42 = {
    prefix: "fab",
    iconName: "laravel",
    icon: [
        512,
        512,
        [],
        "f3bd",
        "M504.4,115.83a5.72,5.72,0,0,0-.28-.68,8.52,8.52,0,0,0-.53-1.25,6,6,0,0,0-.54-.71,9.36,9.36,0,0,0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84,8.84,0,0,0-.9-.68L404.4,55.55a8,8,0,0,0-8,0L300.12,111h0a8.07,8.07,0,0,0-.88.69,7.68,7.68,0,0,0-.78.6,8.23,8.23,0,0,0-.72.93c-.17.24-.39.45-.54.71a9.7,9.7,0,0,0-.52,1.25c-.08.23-.21.44-.28.68a8.08,8.08,0,0,0-.28,2.08V223.18l-80.22,46.19V63.44a7.8,7.8,0,0,0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35,8.35,0,0,0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36,9.36,0,0,0-.72-.94,9.46,9.46,0,0,0-.78-.6,9.8,9.8,0,0,0-.88-.68h0L115.61,1.07a8,8,0,0,0-8,0L11.34,56.49h0a6.52,6.52,0,0,0-.88.69,7.81,7.81,0,0,0-.79.6,8.15,8.15,0,0,0-.71.93c-.18.25-.4.46-.55.72a7.88,7.88,0,0,0-.51,1.24,6.46,6.46,0,0,0-.29.67,8.18,8.18,0,0,0-.28,2.1v329.7a8,8,0,0,0,4,6.95l192.5,110.84a8.83,8.83,0,0,0,1.33.54c.21.08.41.2.63.26a7.92,7.92,0,0,0,4.1,0c.2-.05.37-.16.55-.22a8.6,8.6,0,0,0,1.4-.58L404.4,400.09a8,8,0,0,0,4-6.95V287.88l92.24-53.11a8,8,0,0,0,4-7V117.92A8.63,8.63,0,0,0,504.4,115.83ZM111.6,17.28h0l80.19,46.15-80.2,46.18L31.41,63.44Zm88.25,60V278.6l-46.53,26.79-33.69,19.4V123.5l46.53-26.79Zm0,412.78L23.37,388.5V77.32L57.06,96.7l46.52,26.8V338.68a6.94,6.94,0,0,0,.12.9,8,8,0,0,0,.16,1.18h0a5.92,5.92,0,0,0,.38.9,6.38,6.38,0,0,0,.42,1v0a8.54,8.54,0,0,0,.6.78,7.62,7.62,0,0,0,.66.84l0,0c.23.22.52.38.77.58a8.93,8.93,0,0,0,.86.66l0,0,0,0,92.19,52.18Zm8-106.17-80.06-45.32,84.09-48.41,92.26-53.11,80.13,46.13-58.8,33.56Zm184.52,4.57L215.88,490.11V397.8L346.6,323.2l45.77-26.15Zm0-119.13L358.68,250l-46.53-26.79V131.79l33.69,19.4L392.37,178Zm8-105.28-80.2-46.17,80.2-46.16,80.18,46.15Zm8,105.28V178L455,151.19l33.68-19.4v91.39h0Z"
    ]
};
var $42f4e3f18906b0d1$export$d309e8b75a17a518 = {
    prefix: "fab",
    iconName: "hotjar",
    icon: [
        512,
        512,
        [],
        "f3b1",
        "M361.5 0c0 131.6-80.7 176.8-140.2 209.4c-.6 .3-1.1 .6-1.6 .9c-53.8 30.2-88.7 49.8-89.6 122H32C32 200.8 112.7 155.6 172.2 123C227 93.2 262.5 73 262.5 0h98.9zM301 302.6c54.8-29.8 90.3-50 90.3-123h98c0 131.6-80.7 176.7-140.2 209.4c-54.8 29.8-90.3 50-90.3 123h-98c0-131.6 80.7-176.8 140.2-209.4z"
    ]
};
var $42f4e3f18906b0d1$export$ad4174fe3fc4abe2 = {
    prefix: "fab",
    iconName: "bluetooth-b",
    icon: [
        320,
        512,
        [],
        "f294",
        "M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"
    ]
};
var $42f4e3f18906b0d1$export$628b421165d7d11a = {
    prefix: "fab",
    iconName: "square-letterboxd",
    icon: [
        448,
        512,
        [],
        "e62e",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM105.1 187C66.4 187 35 218.3 35 257s31.4 70 70.1 70c24.8 0 46.5-12.8 59-32.2l.5-.7-.4-.6c-6.5-10.6-10.2-23.1-10.2-36.5c0-13.6 3.9-26.3 10.6-37.1c-12.4-19.8-34.4-32.9-59.5-32.9zM224 187c-24.8 0-46.5 12.8-59 32.2l-.5 .7 .4 .6c6.5 10.6 10.2 23.1 10.2 36.5c0 13.6-3.9 26.3-10.6 37.1C176.9 313.8 198.9 327 224 327c24.8 0 46.5-12.8 59-32.2l.5-.7-.4-.6c-6.5-10.6-10.2-23.1-10.2-36.5c0-13.6 3.9-26.3 10.6-37.1C271.1 200.2 249.1 187 224 187zm118.9 0c-24.8 0-46.5 12.8-59 32.2l-.5 .7 .4 .6c6.5 10.6 10.2 23.1 10.2 36.5c0 13.6-3.9 26.3-10.6 37.1c12.4 19.8 34.4 32.9 59.5 32.9c38.7 0 70.1-31.3 70.1-70s-31.4-70-70.1-70z"
    ]
};
var $42f4e3f18906b0d1$export$439612f87b462a40 = {
    prefix: "fab",
    iconName: "sticker-mule",
    icon: [
        576,
        512,
        [],
        "f3f7",
        "M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"
    ]
};
var $42f4e3f18906b0d1$export$72df0aea6a5da9de = {
    prefix: "fab",
    iconName: "creative-commons-zero",
    icon: [
        496,
        512,
        [],
        "f4f3",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"
    ]
};
var $42f4e3f18906b0d1$export$51de6451f4c7b107 = {
    prefix: "fab",
    iconName: "hips",
    icon: [
        640,
        512,
        [],
        "f452",
        "M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"
    ]
};
var $42f4e3f18906b0d1$export$907c17a7f1d6a0d3 = {
    prefix: "fab",
    iconName: "behance",
    icon: [
        576,
        512,
        [],
        "f1b4",
        "M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"
    ]
};
var $42f4e3f18906b0d1$export$97dd0b04d798af1a = {
    prefix: "fab",
    iconName: "reddit",
    icon: [
        512,
        512,
        [],
        "f1a1",
        "M0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256L37.1 512c-13.7 0-20.5-16.5-10.9-26.2L75 437C28.7 390.7 0 326.7 0 256zM349.6 153.6c23.6 0 42.7-19.1 42.7-42.7s-19.1-42.7-42.7-42.7c-20.6 0-37.8 14.6-41.8 34c-34.5 3.7-61.4 33-61.4 68.4l0 .2c-37.5 1.6-71.8 12.3-99 29.1c-10.1-7.8-22.8-12.5-36.5-12.5c-33 0-59.8 26.8-59.8 59.8c0 24 14.1 44.6 34.4 54.1c2 69.4 77.6 125.2 170.6 125.2s168.7-55.9 170.6-125.3c20.2-9.6 34.1-30.2 34.1-54c0-33-26.8-59.8-59.8-59.8c-13.7 0-26.3 4.6-36.4 12.4c-27.4-17-62.1-27.7-100-29.1l0-.2c0-25.4 18.9-46.5 43.4-49.9l0 0c4.4 18.8 21.3 32.8 41.5 32.8zM177.1 246.9c16.7 0 29.5 17.6 28.5 39.3s-13.5 29.6-30.3 29.6s-31.4-8.8-30.4-30.5s15.4-38.3 32.1-38.3zm190.1 38.3c1 21.7-13.7 30.5-30.4 30.5s-29.3-7.9-30.3-29.6c-1-21.7 11.8-39.3 28.5-39.3s31.2 16.6 32.1 38.3zm-48.1 56.7c-10.3 24.6-34.6 41.9-63 41.9s-52.7-17.3-63-41.9c-1.2-2.9 .8-6.2 3.9-6.5c18.4-1.9 38.3-2.9 59.1-2.9s40.7 1 59.1 2.9c3.1 .3 5.1 3.6 3.9 6.5z"
    ]
};
var $42f4e3f18906b0d1$export$c8d4525a5e9ad3ad = {
    prefix: "fab",
    iconName: "discord",
    icon: [
        640,
        512,
        [],
        "f392",
        "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"
    ]
};
var $42f4e3f18906b0d1$export$430df45ec2fae593 = {
    prefix: "fab",
    iconName: "chrome",
    icon: [
        512,
        512,
        [],
        "f268",
        "M0 256C0 209.4 12.47 165.6 34.27 127.1L144.1 318.3C166 357.5 207.9 384 256 384C270.3 384 283.1 381.7 296.8 377.4L220.5 509.6C95.9 492.3 0 385.3 0 256zM365.1 321.6C377.4 302.4 384 279.1 384 256C384 217.8 367.2 183.5 340.7 160H493.4C505.4 189.6 512 222.1 512 256C512 397.4 397.4 511.1 256 512L365.1 321.6zM477.8 128H256C193.1 128 142.3 172.1 130.5 230.7L54.19 98.47C101 38.53 174 0 256 0C350.8 0 433.5 51.48 477.8 128V128zM168 256C168 207.4 207.4 168 256 168C304.6 168 344 207.4 344 256C344 304.6 304.6 344 256 344C207.4 344 168 304.6 168 256z"
    ]
};
var $42f4e3f18906b0d1$export$e36cec8e481a3a4b = {
    prefix: "fab",
    iconName: "app-store-ios",
    icon: [
        448,
        512,
        [],
        "f370",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"
    ]
};
var $42f4e3f18906b0d1$export$4a929e0a1abf7e41 = {
    prefix: "fab",
    iconName: "cc-discover",
    icon: [
        576,
        512,
        [],
        "f1f2",
        "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
    ]
};
var $42f4e3f18906b0d1$export$a24323c111493948 = {
    prefix: "fab",
    iconName: "wpbeginner",
    icon: [
        512,
        512,
        [],
        "f297",
        "M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"
    ]
};
var $42f4e3f18906b0d1$export$259f76b402dd445f = {
    prefix: "fab",
    iconName: "confluence",
    icon: [
        512,
        512,
        [],
        "f78d",
        "M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"
    ]
};
var $42f4e3f18906b0d1$export$b4e2b27ee3ee1821 = {
    prefix: "fab",
    iconName: "shoelace",
    icon: [
        512,
        512,
        [],
        "e60c",
        "M404.9 331c2.2-1.1 4.4-2.3 6.5-3.7l8.3-4.8c1.5-1.1 4.4-3.4 8.7-6.7l.5-.5c3.4-3.4 7.2-5 11.3-4.9c1.8 0 3.9 .5 6.4 1.5l31-27.5c.9-.7 1.7-1.3 2.6-1.8h.2c3.3-1.9 6-1.8 8.2 .4c3.9 2.1 4.2 5.6 .9 10.6L456.9 322c.2 .5 .4 1 .4 1.5c.5 2.2 .3 4.4-.5 6.6c-.7 1.5-1.8 2.9-3.1 4.2c-1.4 1.4-2.7 2.8-4.2 4.2l-18.8 13.7c-1.7 1.2-3.4 2.3-5.1 3.3c-2.1 1.3-4.3 2.5-6.6 3.6c-1 .4-1.9 .9-2.9 1.3c-5.9 2.5-11.9 4.2-18.2 5c-2.9 24.5-11.3 47.1-25.1 67.8c-17.5 25.7-41.4 45.4-71.8 58.8c-30.2 13.5-63 20.2-98.2 20.2c-48.6-.5-88-11.4-118.2-32.8C49.5 454.4 32 421.5 32 380.3v-5.6c1.2-28.1 9.5-54.6 24.8-79.8c15.1-24.9 37.1-41.7 66.1-50.5c14.9-4.4 29.9-6.6 45-6.6c15.5 0 31.6 2.9 48.1 8.6s35.2 15.5 55.9 29.5L326 312.2c15.1 9.8 28.8 16.5 41.2 20c-2.6-25.1-11.7-46.6-27.3-64.5c-15.7-18.1-35.6-31.3-59.9-39.7l-23.3-8c-21.4-7.5-37.3-14.9-47.7-22.2c-28.2-19.1-43.8-45.2-47-78.5l-.5-9.8c0-32.1 13-58.9 39-80.5C223.5 9.7 251.1 0 283 0c24 0 45.6 6.9 64.7 20.8c19.2 14 30.1 33.8 32.6 59.4l.5 10c0 18.6-4.8 34.5-14.4 47.7c-9.8 13.2-18.5 19.9-26 19.9c-1.6-.1-3.1-.3-4.5-.6l-34 32c-5.5 3-9.2 2.5-11.1-1.6c-1.9-2.2-1.8-4.9 .5-8.2l.2-.2c.5-.7 1.2-1.5 2-2.4l31.6-30c-.4-1.5-.6-3.1-.6-4.8c0-4.1 1.6-7.6 4.9-10.4c13.8-12.4 20.8-26.7 20.8-42.8c0-16-6.1-29.5-18.2-40.4s-28.7-16.5-49.7-16.8c-26.2 0-47.8 7.9-64.7 23.7S192.3 89.9 192.3 112c0 17.8 6.9 33.9 20.6 48.3c13.6 14.2 34.6 25.4 63 33.5c39.8 11.5 70.2 31 91.3 58.3c18.7 24.2 29.1 51.3 31.3 81.4c2.2-.7 4.3-1.5 6.5-2.6zM294.1 178.7c0 1.1 .6 1.6 1.8 1.6c.1 0 9.7-8.9 28.8-26.6c0-2.4-5.1 .9-15.3 10c-10.2 9.2-15.3 14.2-15.3 14.9zm8 6.4c0-1-.5-1.5-1.5-1.5c-1.1 0-2.1 .5-2.9 1.6c-1.9-.1-3.3 .1-4.2 .7c-.4 .2-.5 .5-.5 .7c0 .7 .5 1.3 1.5 1.6h3.3c2.9-1.1 4.4-2.2 4.4-3.3zm22.6-19.9c0-2.8-1.6-2.8-4.9 0c-1.6 1.5-3.6 3.5-6 6.2c-.8 .6-2.6 2.2-5.3 4.9c-2.8 2.9-4.2 4.7-4.2 5.3l.2 1.3c.7 .2 1.2 .4 1.5 .4c.1 0 3.3-2.9 9.5-8.7s9.3-8.9 9.3-9.3zm159.7 120l-30.6 27c1.8 1 3.2 2.4 4 4.2l30.2-27c.2-1.2 .1-2.2-.5-2.9c-.6-.5-1.6-.9-3.1-1.3zm-1.6-.9l-.7-.7-27 21.9 1.6 2 26-23.1zM366.6 363.9c-8-2.1-15.4-4.6-22.2-7.5c-15.3-6.2-34.3-17-57-32.4L250 298.7c-15.8-10.1-30.2-17.6-43.2-22.6c-13.1-4.9-26-7.3-38.6-7.3h-5.5c-32.2 1.7-57.2 13.8-75 36.2c-16.6 20.8-25 45.3-25 73.6c0 31.8 12.8 56.7 38.2 74.7c25.4 18.1 60.2 27.1 104.4 27.1c34.7 0 64-6.2 87.8-18.6c23.7-12.4 42.1-28.8 55.2-49.2c9.8-15.5 15.9-31.8 18.2-48.8z"
    ]
};
var $42f4e3f18906b0d1$export$7add95166ef0248a = {
    prefix: "fab",
    iconName: "mdb",
    icon: [
        576,
        512,
        [],
        "f8ca",
        "M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"
    ]
};
var $42f4e3f18906b0d1$export$81d728fa770edbe1 = {
    prefix: "fab",
    iconName: "dochub",
    icon: [
        416,
        512,
        [],
        "f394",
        "M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"
    ]
};
var $42f4e3f18906b0d1$export$3c152d640f62968e = {
    prefix: "fab",
    iconName: "accessible-icon",
    icon: [
        448,
        512,
        [
            62107
        ],
        "f368",
        "M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"
    ]
};
var $42f4e3f18906b0d1$export$ddb611ff59fc9802 = {
    prefix: "fab",
    iconName: "ebay",
    icon: [
        640,
        512,
        [],
        "f4f4",
        "M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"
    ]
};
var $42f4e3f18906b0d1$export$ebc1e565fd80a447 = {
    prefix: "fab",
    iconName: "amazon",
    icon: [
        448,
        512,
        [],
        "f270",
        "M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"
    ]
};
var $42f4e3f18906b0d1$export$3997191a5880488f = {
    prefix: "fab",
    iconName: "unsplash",
    icon: [
        448,
        512,
        [],
        "e07c",
        "M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"
    ]
};
var $42f4e3f18906b0d1$export$a67629e1d516967d = {
    prefix: "fab",
    iconName: "yarn",
    icon: [
        496,
        512,
        [],
        "f7e3",
        "M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"
    ]
};
var $42f4e3f18906b0d1$export$c334a5e9c1f73381 = {
    prefix: "fab",
    iconName: "square-steam",
    icon: [
        448,
        512,
        [
            "steam-square"
        ],
        "f1b7",
        "M165.6 309.1c18.6 7.7 27.3 28.9 19.6 47.4s-29 27.2-47.6 19.4l-28.5-11.8c5 10.6 13.8 19.4 25.4 24.2c25.2 10.5 54.1-1.4 64.6-26.5c5.1-12.1 5.1-25.5 .1-37.7c-5.1-12.1-14.5-21.6-26.7-26.7c-12.1-5-25-4.8-36.4-.5l29.5 12.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V240.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8c-31.8 0-58.5-22.7-64.5-52.7L0 319.2V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM241.9 196.2a58.4 58.4 0 1 0 116.8 0 58.4 58.4 0 1 0 -116.8 0zm14.6-.1a43.9 43.9 0 1 1 87.8 0 43.9 43.9 0 1 1 -87.8 0z"
    ]
};
var $42f4e3f18906b0d1$export$b0e9b012d636da0a = $42f4e3f18906b0d1$export$c334a5e9c1f73381;
var $42f4e3f18906b0d1$export$4adb509bb23593b0 = {
    prefix: "fab",
    iconName: "500px",
    icon: [
        448,
        512,
        [],
        "f26e",
        "M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"
    ]
};
var $42f4e3f18906b0d1$export$8974793285f35ac8 = {
    prefix: "fab",
    iconName: "square-vimeo",
    icon: [
        448,
        512,
        [
            "vimeo-square"
        ],
        "f194",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM318.5 309.5C275 366 238.2 394.3 208.1 394.3c-18.7 0-34.4-17.2-47.3-51.6c-3.8-13.9-7.3-26.9-10.5-39c-18.2-68.3-28.6-107.4-46.2-107.4c-2.4 0-10.8 5-25.1 15.1L64 192c7-6.1 13.9-12.4 20.6-18.5c29.1-26.3 55.6-50.3 73.5-51.9c24.9-2.4 40.2 14.6 46 51.1c20.5 129.6 29.6 149.2 66.8 90.5c13.4-21.2 20.6-37.2 21.5-48.3c3.4-32.8-25.6-30.6-45.2-22.2c15.7-51.5 45.8-76.5 90.1-75.1c32.9 1 48.4 22.4 46.5 64c-1.4 31.1-23.2 73.8-65.3 127.9z"
    ]
};
var $42f4e3f18906b0d1$export$78628c2da1e685b5 = $42f4e3f18906b0d1$export$8974793285f35ac8;
var $42f4e3f18906b0d1$export$50ef858a08ddd1e5 = {
    prefix: "fab",
    iconName: "asymmetrik",
    icon: [
        576,
        512,
        [],
        "f372",
        "M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"
    ]
};
var $42f4e3f18906b0d1$export$aa4baaed1c60f58d = {
    prefix: "fab",
    iconName: "font-awesome",
    icon: [
        448,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M448 48V384C385 407 366 416 329 416C266 416 242 384 179 384C159 384 143 388 128 392V328C143 324 159 320 179 320C242 320 266 352 329 352C349 352 364 349 384 343V135C364 141 349 144 329 144C266 144 242 112 179 112C128 112 104 133 64 141V448C64 466 50 480 32 480S0 466 0 448V64C0 46 14 32 32 32S64 46 64 64V77C104 69 128 48 179 48C242 48 266 80 329 80C366 80 385 71 448 48Z"
    ]
};
var $42f4e3f18906b0d1$export$102c25fde54d4843 = $42f4e3f18906b0d1$export$aa4baaed1c60f58d;
var $42f4e3f18906b0d1$export$6e20d421a2e0f320 = $42f4e3f18906b0d1$export$aa4baaed1c60f58d;
var $42f4e3f18906b0d1$export$cf1aa567b9609235 = {
    prefix: "fab",
    iconName: "gratipay",
    icon: [
        496,
        512,
        [],
        "f184",
        "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"
    ]
};
var $42f4e3f18906b0d1$export$a649d390c50fd6df = {
    prefix: "fab",
    iconName: "apple",
    icon: [
        384,
        512,
        [],
        "f179",
        "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
    ]
};
var $42f4e3f18906b0d1$export$f5cdac644000a430 = {
    prefix: "fab",
    iconName: "hive",
    icon: [
        512,
        512,
        [],
        "e07f",
        "M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"
    ]
};
var $42f4e3f18906b0d1$export$cd2223c7b77bd41c = {
    prefix: "fab",
    iconName: "gitkraken",
    icon: [
        592,
        512,
        [],
        "f3a6",
        "M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"
    ]
};
var $42f4e3f18906b0d1$export$c80d8749c6106849 = {
    prefix: "fab",
    iconName: "keybase",
    icon: [
        448,
        512,
        [],
        "f4f5",
        "M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"
    ]
};
var $42f4e3f18906b0d1$export$fbfbf4eeb373a6ab = {
    prefix: "fab",
    iconName: "apple-pay",
    icon: [
        640,
        512,
        [],
        "f415",
        "M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"
    ]
};
var $42f4e3f18906b0d1$export$369427eba18eb826 = {
    prefix: "fab",
    iconName: "padlet",
    icon: [
        640,
        512,
        [],
        "e4a0",
        "M297.9 0L298 .001C305.6 .1078 312.4 4.72 315.5 11.78L447.5 320.3L447.8 320.2L448 320.6L445.2 330.6L402.3 488.6C398.6 504.8 382.6 514.9 366.5 511.2L298.1 495.6L229.6 511.2C213.5 514.9 197.5 504.8 193.8 488.6L150.9 330.6L148.2 320.6L148.3 320.2L280.4 11.78C283.4 4.797 290.3 .1837 297.9 .0006L297.9 0zM160.1 322.1L291.1 361.2L298 483.7L305.9 362.2L436.5 322.9L436.7 322.8L305.7 347.9L297.1 27.72L291.9 347.9L160.1 322.1zM426 222.6L520.4 181.6H594.2L437.2 429.2L468.8 320.2L426 222.6zM597.5 181.4L638.9 257.6C642.9 265.1 635 273.5 627.3 269.8L579.7 247.1L597.5 181.4zM127.3 318.5L158.7 430L1.61 154.5C-4.292 144.1 7.128 132.5 17.55 138.3L169.4 222.5L127.3 318.5z"
    ]
};
var $42f4e3f18906b0d1$export$448eb0f9d8323c85 = {
    prefix: "fab",
    iconName: "amazon-pay",
    icon: [
        640,
        512,
        [],
        "f42c",
        "M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"
    ]
};
var $42f4e3f18906b0d1$export$be5db653ba5b5871 = {
    prefix: "fab",
    iconName: "square-github",
    icon: [
        448,
        512,
        [
            "github-square"
        ],
        "f092",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM265.8 407.7c0-1.8 0-6 .1-11.6c.1-11.4 .1-28.8 .1-43.7c0-15.6-5.2-25.5-11.3-30.7c37-4.1 76-9.2 76-73.1c0-18.2-6.5-27.3-17.1-39c1.7-4.3 7.4-22-1.7-45c-13.9-4.3-45.7 17.9-45.7 17.9c-13.2-3.7-27.5-5.6-41.6-5.6s-28.4 1.9-41.6 5.6c0 0-31.8-22.2-45.7-17.9c-9.1 22.9-3.5 40.6-1.7 45c-10.6 11.7-15.6 20.8-15.6 39c0 63.6 37.3 69 74.3 73.1c-4.8 4.3-9.1 11.7-10.6 22.3c-9.5 4.3-33.8 11.7-48.3-13.9c-9.1-15.8-25.5-17.1-25.5-17.1c-16.2-.2-1.1 10.2-1.1 10.2c10.8 5 18.4 24.2 18.4 24.2c9.7 29.7 56.1 19.7 56.1 19.7c0 9 .1 21.7 .1 30.6c0 4.8 .1 8.6 .1 10c0 4.3-3 9.5-11.5 8C106 393.6 59.8 330.8 59.8 257.4c0-91.8 70.2-161.5 162-161.5s166.2 69.7 166.2 161.5c.1 73.4-44.7 136.3-110.7 158.3c-8.4 1.5-11.5-3.7-11.5-8zm-90.5-54.8c-.2-1.5 1.1-2.8 3-3.2c1.9-.2 3.7 .6 3.9 1.9c.3 1.3-1 2.6-3 3c-1.9 .4-3.7-.4-3.9-1.7zm-9.1 3.2c-2.2 .2-3.7-.9-3.7-2.4c0-1.3 1.5-2.4 3.5-2.4c1.9-.2 3.7 .9 3.7 2.4c0 1.3-1.5 2.4-3.5 2.4zm-14.3-2.2c-1.9-.4-3.2-1.9-2.8-3.2s2.4-1.9 4.1-1.5c2 .6 3.3 2.1 2.8 3.4c-.4 1.3-2.4 1.9-4.1 1.3zm-12.5-7.3c-1.5-1.3-1.9-3.2-.9-4.1c.9-1.1 2.8-.9 4.3 .6c1.3 1.3 1.8 3.3 .9 4.1c-.9 1.1-2.8 .9-4.3-.6zm-8.5-10c-1.1-1.5-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3c1.1 1.5 1.1 3.3 0 4.1c-.9 .6-2.6 0-3.7-1.5zm-6.3-8.8c-1.1-1.3-1.3-2.8-.4-3.5c.9-.9 2.4-.4 3.5 .6c1.1 1.3 1.3 2.8 .4 3.5c-.9 .9-2.4 .4-3.5-.6zm-6-6.4c-1.3-.6-1.9-1.7-1.5-2.6c.4-.6 1.5-.9 2.8-.4c1.3 .7 1.9 1.8 1.5 2.6c-.4 .9-1.7 1.1-2.8 .4z"
    ]
};
var $42f4e3f18906b0d1$export$5fe0a956971aa3c2 = $42f4e3f18906b0d1$export$be5db653ba5b5871;
var $42f4e3f18906b0d1$export$7872bf6ac6945976 = {
    prefix: "fab",
    iconName: "stumbleupon",
    icon: [
        512,
        512,
        [],
        "f1a4",
        "M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"
    ]
};
var $42f4e3f18906b0d1$export$c9127779112e2ff8 = {
    prefix: "fab",
    iconName: "fedex",
    icon: [
        640,
        512,
        [],
        "f797",
        "M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"
    ]
};
var $42f4e3f18906b0d1$export$3d9357caf53f9b59 = {
    prefix: "fab",
    iconName: "phoenix-framework",
    icon: [
        640,
        512,
        [],
        "f3dc",
        "M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"
    ]
};
var $42f4e3f18906b0d1$export$c18d8940c93637ce = {
    prefix: "fab",
    iconName: "shopify",
    icon: [
        448,
        512,
        [],
        "e057",
        "M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"
    ]
};
var $42f4e3f18906b0d1$export$a38c2efcceaf5a01 = {
    prefix: "fab",
    iconName: "neos",
    icon: [
        512,
        512,
        [],
        "f612",
        "M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"
    ]
};
var $42f4e3f18906b0d1$export$75f15eb229650b3a = {
    prefix: "fab",
    iconName: "square-threads",
    icon: [
        448,
        512,
        [],
        "e619",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM294.2 244.3c19.5 9.3 33.7 23.5 41.2 40.9c10.4 24.3 11.4 63.9-20.2 95.4c-24.2 24.1-53.5 35-95.1 35.3h-.2c-46.8-.3-82.8-16.1-106.9-46.8C91.5 341.8 80.4 303.7 80 256v-.1-.1c.4-47.7 11.5-85.7 33-113.1c24.2-30.7 60.2-46.5 106.9-46.8h.2c46.9 .3 83.3 16 108.2 46.6c12.3 15.1 21.3 33.3 27 54.4l-26.9 7.2c-4.7-17.2-11.9-31.9-21.4-43.6c-19.4-23.9-48.7-36.1-87-36.4c-38 .3-66.8 12.5-85.5 36.2c-17.5 22.3-26.6 54.4-26.9 95.5c.3 41.1 9.4 73.3 26.9 95.5c18.7 23.8 47.4 36 85.5 36.2c34.3-.3 56.9-8.4 75.8-27.3c21.5-21.5 21.1-47.9 14.2-64c-4-9.4-11.4-17.3-21.3-23.3c-2.4 18-7.9 32.2-16.5 43.2c-11.4 14.5-27.7 22.4-48.4 23.5c-15.7 .9-30.8-2.9-42.6-10.7c-13.9-9.2-22-23.2-22.9-39.5c-1.7-32.2 23.8-55.3 63.5-57.6c14.1-.8 27.3-.2 39.5 1.9c-1.6-9.9-4.9-17.7-9.8-23.4c-6.7-7.8-17.1-11.8-30.8-11.9h-.4c-11 0-26 3.1-35.6 17.6l-23-15.8c12.8-19.4 33.6-30.1 58.5-30.1h.6c41.8 .3 66.6 26.3 69.1 71.8c1.4 .6 2.8 1.2 4.2 1.9l.1 .5zm-71.8 67.5c17-.9 36.4-7.6 39.7-48.8c-8.8-1.9-18.6-2.9-29-2.9c-3.2 0-6.4 .1-9.6 .3c-28.6 1.6-38.1 15.5-37.4 27.9c.9 16.7 19 24.5 36.4 23.6l-.1-.1z"
    ]
};
var $42f4e3f18906b0d1$export$5fb7eeed7d5e4dea = {
    prefix: "fab",
    iconName: "hackerrank",
    icon: [
        512,
        512,
        [],
        "f5f7",
        "M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"
    ]
};
var $42f4e3f18906b0d1$export$5c5693a4f82cd9eb = {
    prefix: "fab",
    iconName: "researchgate",
    icon: [
        448,
        512,
        [],
        "f4f8",
        "M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"
    ]
};
var $42f4e3f18906b0d1$export$dcdf312747bb3471 = {
    prefix: "fab",
    iconName: "swift",
    icon: [
        448,
        512,
        [],
        "f8e1",
        "M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"
    ]
};
var $42f4e3f18906b0d1$export$9df3e2a7a3f59b3b = {
    prefix: "fab",
    iconName: "angular",
    icon: [
        448,
        512,
        [],
        "f420",
        "M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"
    ]
};
var $42f4e3f18906b0d1$export$90ae1a3824ece6f2 = {
    prefix: "fab",
    iconName: "speakap",
    icon: [
        448,
        512,
        [],
        "f3f3",
        "M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"
    ]
};
var $42f4e3f18906b0d1$export$a9e7bf021125ee89 = {
    prefix: "fab",
    iconName: "angrycreative",
    icon: [
        640,
        512,
        [],
        "f36e",
        "M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"
    ]
};
var $42f4e3f18906b0d1$export$9ee2f35ed1fe0fd4 = {
    prefix: "fab",
    iconName: "y-combinator",
    icon: [
        448,
        512,
        [],
        "f23b",
        "M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"
    ]
};
var $42f4e3f18906b0d1$export$c966a5d80266ef06 = {
    prefix: "fab",
    iconName: "empire",
    icon: [
        496,
        512,
        [],
        "f1d1",
        "M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"
    ]
};
var $42f4e3f18906b0d1$export$9e2c7c55d2fddd0 = {
    prefix: "fab",
    iconName: "envira",
    icon: [
        448,
        512,
        [],
        "f299",
        "M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"
    ]
};
var $42f4e3f18906b0d1$export$ed92c068824a8084 = {
    prefix: "fab",
    iconName: "google-scholar",
    icon: [
        512,
        512,
        [],
        "e63b",
        "M390.9 298.5c0 0 0 .1 .1 .1c9.2 19.4 14.4 41.1 14.4 64C405.3 445.1 338.5 512 256 512s-149.3-66.9-149.3-149.3c0-22.9 5.2-44.6 14.4-64h0c1.7-3.6 3.6-7.2 5.6-10.7c4.4-7.6 9.4-14.7 15-21.3c27.4-32.6 68.5-53.3 114.4-53.3c33.6 0 64.6 11.1 89.6 29.9c9.1 6.9 17.4 14.7 24.8 23.5c5.6 6.6 10.6 13.8 15 21.3c2 3.4 3.8 7 5.5 10.5zm26.4-18.8c-30.1-58.4-91-98.4-161.3-98.4s-131.2 40-161.3 98.4L0 202.7 256 0 512 202.7l-94.7 77.1z"
    ]
};
var $42f4e3f18906b0d1$export$1c14974e1904bc76 = {
    prefix: "fab",
    iconName: "square-gitlab",
    icon: [
        448,
        512,
        [
            "gitlab-square"
        ],
        "e5ae",
        "M0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm337.5 12.5l44.6 116.4 .4 1.2c5.6 16.8 7.2 35.2 2.3 52.5c-5 17.2-15.4 32.4-29.8 43.3l-.2 .1-68.4 51.2-54.1 40.9c-.5 .2-1.1 .5-1.7 .8c-2 1-4.4 2-6.7 2c-3 0-6.8-1.8-8.3-2.8l-54.2-40.9L93.5 322.3l-.4-.3-.2-.1c-14.3-10.8-24.8-26-29.7-43.3s-4.2-35.7 2.2-52.5l.5-1.2 44.7-116.4c.9-2.3 2.5-4.3 4.5-5.6c1.6-1 3.4-1.6 5.2-1.8c1.3-.7 2.1-.4 3.4 .1c.6 .2 1.2 .5 2 .7c1 .4 1.6 .9 2.4 1.5c.6 .4 1.2 1 2.1 1.5c1.2 1.4 2.2 3 2.7 4.8l29.2 92.2H285l30.2-92.2c.5-1.8 1.4-3.4 2.6-4.8s2.8-2.4 4.5-3.1c1.7-.6 3.6-.9 5.4-.7s3.6 .8 5.2 1.8c2 1.3 3.7 3.3 4.6 5.6z"
    ]
};
var $42f4e3f18906b0d1$export$4459a47a802afa29 = $42f4e3f18906b0d1$export$1c14974e1904bc76;
var $42f4e3f18906b0d1$export$9d71d8f56add75cb = {
    prefix: "fab",
    iconName: "studiovinari",
    icon: [
        512,
        512,
        [],
        "f3f8",
        "M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"
    ]
};
var $42f4e3f18906b0d1$export$13581f4cc240d7d9 = {
    prefix: "fab",
    iconName: "pied-piper",
    icon: [
        480,
        512,
        [],
        "f2ae",
        "M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"
    ]
};
var $42f4e3f18906b0d1$export$8898e76262ada01d = {
    prefix: "fab",
    iconName: "wordpress",
    icon: [
        512,
        512,
        [],
        "f19a",
        "M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"
    ]
};
var $42f4e3f18906b0d1$export$91dcff48b72c75ce = {
    prefix: "fab",
    iconName: "product-hunt",
    icon: [
        512,
        512,
        [],
        "f288",
        "M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"
    ]
};
var $42f4e3f18906b0d1$export$53a067e7149deea9 = {
    prefix: "fab",
    iconName: "firefox",
    icon: [
        512,
        512,
        [],
        "f269",
        "M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"
    ]
};
var $42f4e3f18906b0d1$export$fcbc58842fe8e217 = {
    prefix: "fab",
    iconName: "linode",
    icon: [
        448,
        512,
        [],
        "f2b8",
        "M366.036,186.867l-59.5,36.871-.838,36.871-29.329-19.273-39.384,24.3c2.238,55.211,2.483,59.271,2.51,59.5l-97.2,65.359L127.214,285.748l108.1-62.01L195.09,197.761l-75.417,38.547L98.723,93.015,227.771,43.574,136.432,0,10.737,39.385,38.39,174.3l41.9,32.681L48.445,222.062,69.394,323.457,98.723,351.11,77.774,363.679l16.76,78.769L160.733,512c-10.8-74.842-11.658-78.641-11.725-78.773l77.925-55.3c16.759-12.57,15.083-10.894,15.083-10.894l.838,24.3,33.519,28.491-.838-77.093,46.927-33.519,26.815-18.435-2.514,36.033,25.139,17.6,6.7-74.579,58.657-43.575Z"
    ]
};
var $42f4e3f18906b0d1$export$cc058e4fd428aead = {
    prefix: "fab",
    iconName: "goodreads",
    icon: [
        448,
        512,
        [],
        "f3a8",
        "M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"
    ]
};
var $42f4e3f18906b0d1$export$df58e66e423b11a0 = {
    prefix: "fab",
    iconName: "square-odnoklassniki",
    icon: [
        448,
        512,
        [
            "odnoklassniki-square"
        ],
        "f264",
        "M224 137.1a39.9 39.9 0 1 0 0 79.7 39.9 39.9 0 1 0 0-79.7zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM224 95.9A81 81 0 1 1 224 258a81 81 0 1 1 0-162.1zm59.3 168.3c16.8-13.2 29.5-5.5 34.1 3.6c7.8 16-1.1 23.7-21.5 37c-17.1 10.9-40.7 15.2-56.2 16.8l13 12.9 47.7 47.7c17.4 17.9-11 45.8-28.6 28.6c-12-12.2-29.5-29.7-47.7-47.9l0 0-47.7 47.9c-17.7 17.2-46-11-28.4-28.6c3.7-3.7 7.9-7.9 12.5-12.5c10.4-10.4 22.6-22.7 35.2-35.2l12.9-12.9c-15.4-1.6-39.3-5.7-56.6-16.8c-20.3-13.3-29.3-20.9-21.4-37c4.6-9.1 17.3-16.8 34.1-3.6c0 0 22.7 18 59.3 18s59.3-18 59.3-18z"
    ]
};
var $42f4e3f18906b0d1$export$8bab3f1c73ff1d0 = $42f4e3f18906b0d1$export$df58e66e423b11a0;
var $42f4e3f18906b0d1$export$49c67105b922997 = {
    prefix: "fab",
    iconName: "jsfiddle",
    icon: [
        576,
        512,
        [],
        "f1cc",
        "M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"
    ]
};
var $42f4e3f18906b0d1$export$6b9a61f04a3c9eb4 = {
    prefix: "fab",
    iconName: "sith",
    icon: [
        448,
        512,
        [],
        "f512",
        "M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"
    ]
};
var $42f4e3f18906b0d1$export$9ce81750a9f73ac4 = {
    prefix: "fab",
    iconName: "themeisle",
    icon: [
        512,
        512,
        [],
        "f2b2",
        "M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"
    ]
};
var $42f4e3f18906b0d1$export$e504e93b36693690 = {
    prefix: "fab",
    iconName: "page4",
    icon: [
        496,
        512,
        [],
        "f3d7",
        "M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"
    ]
};
var $42f4e3f18906b0d1$export$459e822cce028974 = {
    prefix: "fab",
    iconName: "hashnode",
    icon: [
        512,
        512,
        [],
        "e499",
        "M35.19 171.1C-11.72 217.1-11.72 294 35.19 340.9L171.1 476.8C217.1 523.7 294 523.7 340.9 476.8L476.8 340.9C523.7 294 523.7 217.1 476.8 171.1L340.9 35.19C294-11.72 217.1-11.72 171.1 35.19L35.19 171.1zM315.5 315.5C282.6 348.3 229.4 348.3 196.6 315.5C163.7 282.6 163.7 229.4 196.6 196.6C229.4 163.7 282.6 163.7 315.5 196.6C348.3 229.4 348.3 282.6 315.5 315.5z"
    ]
};
var $42f4e3f18906b0d1$export$e62f4d94322d112c = {
    prefix: "fab",
    iconName: "react",
    icon: [
        512,
        512,
        [],
        "f41b",
        "M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"
    ]
};
var $42f4e3f18906b0d1$export$c4a0e7e817efc4de = {
    prefix: "fab",
    iconName: "cc-paypal",
    icon: [
        576,
        512,
        [],
        "f1f4",
        "M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"
    ]
};
var $42f4e3f18906b0d1$export$c1ba640907c93eb6 = {
    prefix: "fab",
    iconName: "squarespace",
    icon: [
        512,
        512,
        [],
        "f5be",
        "M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"
    ]
};
var $42f4e3f18906b0d1$export$235ca29d6ed8f50f = {
    prefix: "fab",
    iconName: "cc-stripe",
    icon: [
        576,
        512,
        [],
        "f1f5",
        "M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"
    ]
};
var $42f4e3f18906b0d1$export$82bc9680d7d55560 = {
    prefix: "fab",
    iconName: "creative-commons-share",
    icon: [
        496,
        512,
        [],
        "f4f2",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"
    ]
};
var $42f4e3f18906b0d1$export$7bb8936d912f16ef = {
    prefix: "fab",
    iconName: "bitcoin",
    icon: [
        512,
        512,
        [],
        "f379",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"
    ]
};
var $42f4e3f18906b0d1$export$644ebffaf375bd06 = {
    prefix: "fab",
    iconName: "keycdn",
    icon: [
        512,
        512,
        [],
        "f3ba",
        "M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"
    ]
};
var $42f4e3f18906b0d1$export$76e4000ae88923a5 = {
    prefix: "fab",
    iconName: "opera",
    icon: [
        496,
        512,
        [],
        "f26a",
        "M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"
    ]
};
var $42f4e3f18906b0d1$export$4ec4278290df08a8 = {
    prefix: "fab",
    iconName: "itch-io",
    icon: [
        512,
        512,
        [],
        "f83a",
        "M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"
    ]
};
var $42f4e3f18906b0d1$export$b92d594113fd14c4 = {
    prefix: "fab",
    iconName: "umbraco",
    icon: [
        510,
        512,
        [],
        "f8e8",
        "M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"
    ]
};
var $42f4e3f18906b0d1$export$85ca259eee71d856 = {
    prefix: "fab",
    iconName: "galactic-senate",
    icon: [
        512,
        512,
        [],
        "f50d",
        "M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"
    ]
};
var $42f4e3f18906b0d1$export$188bec0355fe7cb3 = {
    prefix: "fab",
    iconName: "ubuntu",
    icon: [
        576,
        512,
        [],
        "f7df",
        "M469.2 75A75.6 75.6 0 1 0 317.9 75a75.6 75.6 0 1 0 151.2 0zM154.2 240.7A75.6 75.6 0 1 0 3 240.7a75.6 75.6 0 1 0 151.2 0zM57 346C75.6 392.9 108 433 150 461.1s91.5 42.6 142 41.7c-14.7-18.6-22.9-41.5-23.2-65.2c-6.8-.9-13.3-2.1-19.5-3.4c-26.8-5.7-51.9-17.3-73.6-34s-39.3-38.1-51.7-62.5c-20.9 9.9-44.5 12.8-67.1 8.2zm395.1 89.8a75.6 75.6 0 1 0 -151.2 0 75.6 75.6 0 1 0 151.2 0zM444 351.6c18.5 14.8 31.6 35.2 37.2 58.2c33.3-41.3 52.6-92.2 54.8-145.2s-12.5-105.4-42.2-149.4c-8.6 21.5-24 39.6-43.8 51.6c15.4 28.6 22.9 60.8 21.9 93.2s-10.7 64-28 91.6zM101.1 135.4c12.4 2.7 24.3 7.5 35.1 14.3c16.6-24.2 38.9-44.1 64.8-58S255.8 70.4 285.2 70c.2-5.9 .9-11.9 2-17.7c3.6-16.7 11.1-32.3 21.8-45.5c-47.7-3.8-95.4 6-137.6 28.5S94.3 91.7 70.8 133.4c2.7-.2 5.3-.3 8-.3c7.5 0 15 .8 22.4 2.3z"
    ]
};
var $42f4e3f18906b0d1$export$89aeef49dacedf59 = {
    prefix: "fab",
    iconName: "draft2digital",
    icon: [
        480,
        512,
        [],
        "f396",
        "M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"
    ]
};
var $42f4e3f18906b0d1$export$4124a45a674b7b36 = {
    prefix: "fab",
    iconName: "stripe",
    icon: [
        640,
        512,
        [],
        "f429",
        "M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"
    ]
};
var $42f4e3f18906b0d1$export$f5c2efa520323804 = {
    prefix: "fab",
    iconName: "houzz",
    icon: [
        448,
        512,
        [],
        "f27c",
        "M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"
    ]
};
var $42f4e3f18906b0d1$export$5b7cd580ca5d0c32 = {
    prefix: "fab",
    iconName: "gg",
    icon: [
        512,
        512,
        [],
        "f260",
        "M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"
    ]
};
var $42f4e3f18906b0d1$export$f3f333bdcc61afcd = {
    prefix: "fab",
    iconName: "dhl",
    icon: [
        640,
        512,
        [],
        "f790",
        "M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"
    ]
};
var $42f4e3f18906b0d1$export$bfa4536fab29fa25 = {
    prefix: "fab",
    iconName: "square-pinterest",
    icon: [
        448,
        512,
        [
            "pinterest-square"
        ],
        "f0d3",
        "M384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h72.6l-2.2-.8c-5.4-48.1-3.1-57.5 15.7-134.7c3.9-16 8.5-35 13.9-57.9c0 0-7.3-14.8-7.3-36.5c0-70.7 75.5-78 75.5-25c0 13.5-5.4 31.1-11.2 49.8c-3.3 10.6-6.6 21.5-9.1 32c-5.7 24.5 12.3 44.4 36.4 44.4c43.7 0 77.2-46 77.2-112.4c0-58.8-42.3-99.9-102.6-99.9C153 139 112 191.4 112 245.6c0 21.1 8.2 43.7 18.3 56c2 2.4 2.3 4.5 1.7 7c-1.1 4.7-3.1 12.9-4.7 19.2c-1 4-1.8 7.3-2.1 8.6c-1.1 4.5-3.5 5.5-8.2 3.3c-30.6-14.3-49.8-59.1-49.8-95.1C67.2 167.1 123.4 96 229.4 96c85.2 0 151.4 60.7 151.4 141.8c0 84.6-53.3 152.7-127.4 152.7c-24.9 0-48.3-12.9-56.3-28.2c0 0-12.3 46.9-15.3 58.4c-5 19.3-17.6 42.9-27.4 59.3H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64z"
    ]
};
var $42f4e3f18906b0d1$export$67aa35027cc046c7 = $42f4e3f18906b0d1$export$bfa4536fab29fa25;
var $42f4e3f18906b0d1$export$28ff226a626fb008 = {
    prefix: "fab",
    iconName: "xing",
    icon: [
        384,
        512,
        [],
        "f168",
        "M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"
    ]
};
var $42f4e3f18906b0d1$export$11c2ed8ca6d46555 = {
    prefix: "fab",
    iconName: "blackberry",
    icon: [
        512,
        512,
        [],
        "f37b",
        "M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"
    ]
};
var $42f4e3f18906b0d1$export$10c9e6deac1c2eeb = {
    prefix: "fab",
    iconName: "creative-commons-pd",
    icon: [
        496,
        512,
        [],
        "f4ec",
        "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"
    ]
};
var $42f4e3f18906b0d1$export$6fcce83c026197c = {
    prefix: "fab",
    iconName: "playstation",
    icon: [
        576,
        512,
        [],
        "f3df",
        "M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"
    ]
};
var $42f4e3f18906b0d1$export$1079c541f45f51d0 = {
    prefix: "fab",
    iconName: "quinscape",
    icon: [
        512,
        512,
        [],
        "f459",
        "M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"
    ]
};
var $42f4e3f18906b0d1$export$df0a28abd4a08bff = {
    prefix: "fab",
    iconName: "less",
    icon: [
        640,
        512,
        [],
        "f41d",
        "M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"
    ]
};
var $42f4e3f18906b0d1$export$fb78f7bb43feec45 = {
    prefix: "fab",
    iconName: "blogger-b",
    icon: [
        448,
        512,
        [],
        "f37d",
        "M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"
    ]
};
var $42f4e3f18906b0d1$export$b1b65e1549fc9915 = {
    prefix: "fab",
    iconName: "opencart",
    icon: [
        640,
        512,
        [],
        "f23d",
        "M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"
    ]
};
var $42f4e3f18906b0d1$export$ff24f295c905f144 = {
    prefix: "fab",
    iconName: "vine",
    icon: [
        384,
        512,
        [],
        "f1ca",
        "M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"
    ]
};
var $42f4e3f18906b0d1$export$95b71ec8a2f59bf0 = {
    prefix: "fab",
    iconName: "signal-messenger",
    icon: [
        512,
        512,
        [],
        "e663",
        "M194.6 7.5l5.8 23.3C177.7 36.3 156 45.3 136 57.4L123.7 36.8c22-13.3 45.9-23.2 70.9-29.3zm122.9 0l-5.8 23.3C334.3 36.3 356 45.3 376 57.4l12.4-20.6c-22-13.3-46-23.2-71-29.3zM36.8 123.7c-13.3 22-23.2 45.9-29.3 70.9l23.3 5.8C36.3 177.7 45.3 156 57.4 136L36.8 123.7zM24 256c0-11.6 .9-23.3 2.6-34.8L2.9 217.6c-3.8 25.4-3.8 51.3 0 76.7l23.7-3.6C24.9 279.3 24 267.6 24 256zM388.3 475.2L376 454.6c-20 12.1-41.6 21-64.2 26.6l5.8 23.3c24.9-6.2 48.8-16 70.8-29.3zM488 256c0 11.6-.9 23.3-2.6 34.8l23.7 3.6c3.8-25.4 3.8-51.3 0-76.7l-23.7 3.6c1.7 11.5 2.6 23.1 2.6 34.8zm16.5 61.4l-23.3-5.8c-5.6 22.7-14.5 44.3-26.6 64.3l20.6 12.4c13.3-22 23.2-46 29.3-71zm-213.8 168c-23 3.5-46.5 3.5-69.5 0l-3.6 23.7c25.4 3.8 51.3 3.8 76.7 0l-3.6-23.7zm152-91.8c-13.8 18.7-30.4 35.3-49.2 49.1l14.2 19.3c20.7-15.2 39-33.4 54.2-54.1l-19.3-14.4zM393.6 69.2c18.8 13.8 35.3 30.4 49.2 49.2L462.1 104C446.9 83.4 428.6 65.1 408 49.9L393.6 69.2zM69.2 118.4c13.8-18.8 30.4-35.3 49.2-49.2L104 49.9C83.4 65.1 65.1 83.4 49.9 104l19.3 14.4zm406 5.3L454.6 136c12.1 20 21 41.6 26.6 64.2l23.3-5.8c-6.2-24.9-16-48.8-29.3-70.8zm-254-97.1c23-3.5 46.5-3.5 69.5 0l3.6-23.7C268.9-1 243.1-1 217.6 2.9l3.6 23.7zM81.6 468.4L32 480l11.6-49.6L20.2 425 8.6 474.5c-.9 4-.8 8.1 .3 12.1s3.2 7.5 6.1 10.4s6.5 5 10.4 6.1s8.1 1.2 12.1 .3L87 492l-5.4-23.6zM25.2 403.6L48.6 409l8-34.4c-11.7-19.6-20.4-40.8-25.8-63L7.5 317.4c5.2 21.2 13.2 41.7 23.6 60.8l-5.9 25.3zm112 52l-34.4 8 5.4 23.4 25.3-5.9c19.2 10.4 39.6 18.4 60.8 23.6l5.8-23.3c-22.1-5.5-43.3-14.3-62.8-26l-.2 .2zM256 48c-37.2 0-73.6 10-105.6 28.9s-58.4 46-76.3 78.6s-26.9 69.3-25.8 106.4s12 73.3 31.8 104.8L60 452l85.3-20c27.3 17.2 58.2 27.8 90.3 31s64.5-1.1 94.6-12.6s57.2-29.8 79-53.6s37.8-52.2 46.8-83.2s10.5-63.6 4.7-95.3s-19-61.6-38.4-87.4s-44.5-46.7-73.4-61S288.3 48 256 48z"
    ]
};
var $42f4e3f18906b0d1$export$1aaa7b292157aaf7 = {
    prefix: "fab",
    iconName: "paypal",
    icon: [
        384,
        512,
        [],
        "f1ed",
        "M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"
    ]
};
var $42f4e3f18906b0d1$export$bc1566dfb0a3651b = {
    prefix: "fab",
    iconName: "gitlab",
    icon: [
        512,
        512,
        [],
        "f296",
        "M503.5 204.6L502.8 202.8L433.1 21.02C431.7 17.45 429.2 14.43 425.9 12.38C423.5 10.83 420.8 9.865 417.9 9.57C415 9.275 412.2 9.653 409.5 10.68C406.8 11.7 404.4 13.34 402.4 15.46C400.5 17.58 399.1 20.13 398.3 22.9L351.3 166.9H160.8L113.7 22.9C112.9 20.13 111.5 17.59 109.6 15.47C107.6 13.35 105.2 11.72 102.5 10.7C99.86 9.675 96.98 9.295 94.12 9.587C91.26 9.878 88.51 10.83 86.08 12.38C82.84 14.43 80.33 17.45 78.92 21.02L9.267 202.8L8.543 204.6C-1.484 230.8-2.72 259.6 5.023 286.6C12.77 313.5 29.07 337.3 51.47 354.2L51.74 354.4L52.33 354.8L158.3 434.3L210.9 474L242.9 498.2C246.6 500.1 251.2 502.5 255.9 502.5C260.6 502.5 265.2 500.1 268.9 498.2L300.9 474L353.5 434.3L460.2 354.4L460.5 354.1C482.9 337.2 499.2 313.5 506.1 286.6C514.7 259.6 513.5 230.8 503.5 204.6z"
    ]
};
var $42f4e3f18906b0d1$export$26fe3ad1dc9d4c5b = {
    prefix: "fab",
    iconName: "typo3",
    icon: [
        448,
        512,
        [],
        "f42b",
        "M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"
    ]
};
var $42f4e3f18906b0d1$export$9fbf70587b6b0dcc = {
    prefix: "fab",
    iconName: "reddit-alien",
    icon: [
        512,
        512,
        [],
        "f281",
        "M373 138.6c-25.2 0-46.3-17.5-51.9-41l0 0c-30.6 4.3-54.2 30.7-54.2 62.4l0 .2c47.4 1.8 90.6 15.1 124.9 36.3c12.6-9.7 28.4-15.5 45.5-15.5c41.3 0 74.7 33.4 74.7 74.7c0 29.8-17.4 55.5-42.7 67.5c-2.4 86.8-97 156.6-213.2 156.6S45.5 410.1 43 323.4C17.6 311.5 0 285.7 0 255.7c0-41.3 33.4-74.7 74.7-74.7c17.2 0 33 5.8 45.7 15.6c34-21.1 76.8-34.4 123.7-36.4l0-.3c0-44.3 33.7-80.9 76.8-85.5C325.8 50.2 347.2 32 373 32c29.4 0 53.3 23.9 53.3 53.3s-23.9 53.3-53.3 53.3zM157.5 255.3c-20.9 0-38.9 20.8-40.2 47.9s17.1 38.1 38 38.1s36.6-9.8 37.8-36.9s-14.7-49.1-35.7-49.1zM395 303.1c-1.2-27.1-19.2-47.9-40.2-47.9s-36.9 22-35.7 49.1c1.2 27.1 16.9 36.9 37.8 36.9s39.3-11 38-38.1zm-60.1 70.8c1.5-3.6-1-7.7-4.9-8.1c-23-2.3-47.9-3.6-73.8-3.6s-50.8 1.3-73.8 3.6c-3.9 .4-6.4 4.5-4.9 8.1c12.9 30.8 43.3 52.4 78.7 52.4s65.8-21.6 78.7-52.4z"
    ]
};
var $42f4e3f18906b0d1$export$d0632e92ebe1197f = {
    prefix: "fab",
    iconName: "yahoo",
    icon: [
        512,
        512,
        [],
        "f19e",
        "M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"
    ]
};
var $42f4e3f18906b0d1$export$9743e7788f64058a = {
    prefix: "fab",
    iconName: "dailymotion",
    icon: [
        448,
        512,
        [],
        "e052",
        "M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"
    ]
};
var $42f4e3f18906b0d1$export$c40f060084205fb6 = {
    prefix: "fab",
    iconName: "affiliatetheme",
    icon: [
        512,
        512,
        [],
        "f36b",
        "M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"
    ]
};
var $42f4e3f18906b0d1$export$96d17626187f6e34 = {
    prefix: "fab",
    iconName: "pied-piper-pp",
    icon: [
        448,
        512,
        [],
        "f1a7",
        "M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"
    ]
};
var $42f4e3f18906b0d1$export$3de8f256f5aadacf = {
    prefix: "fab",
    iconName: "bootstrap",
    icon: [
        576,
        512,
        [],
        "f836",
        "M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"
    ]
};
var $42f4e3f18906b0d1$export$f31d1294fef45f = {
    prefix: "fab",
    iconName: "odnoklassniki",
    icon: [
        320,
        512,
        [],
        "f263",
        "M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"
    ]
};
var $42f4e3f18906b0d1$export$a64aa05b0287bdaf = {
    prefix: "fab",
    iconName: "nfc-symbol",
    icon: [
        576,
        512,
        [],
        "e531",
        "M392.9 32.43C400.6 31.1 408.6 32.89 414.1 37.41C498.2 96.14 544 173.7 544 255.1C544 338.2 498.2 415.9 414.1 474.6C409.3 478.6 402.4 480.5 395.5 479.9C388.5 479.3 382 476.3 377.1 471.4L193.7 288.7C188.1 283.2 185 275.7 184.1 267.8C184.1 260 188.1 252.5 193.6 246.9C199.2 241.4 206.7 238.2 214.5 238.2C222.4 238.2 229.9 241.3 235.4 246.8L400.5 411.2C455.1 366.5 484.8 312 484.8 255.1C484.8 193.5 447.9 132.9 380.9 85.76C374.5 81.24 370.1 74.35 368.8 66.62C367.4 58.89 369.2 50.94 373.8 44.53C378.3 38.12 385.2 33.77 392.9 32.43V32.43zM186.9 479.6C179.2 480.9 171.3 479.1 164.8 474.6C81.67 415.9 35.84 338.2 35.84 255.1C35.84 173.7 81.67 96.14 164.8 37.41C170.5 33.4 177.4 31.53 184.4 32.12C191.3 32.71 197.8 35.72 202.7 40.63L386.1 223.3C391.7 228.8 394.8 236.3 394.8 244.2C394.9 251.1 391.8 259.5 386.2 265.1C380.7 270.6 373.2 273.8 365.3 273.8C357.5 273.8 349.1 270.7 344.4 265.2L179.3 100.7C124.7 145.9 95.03 199.9 95.03 255.1C95.03 318.5 131.9 379.1 198.1 426.2C205.4 430.8 209.7 437.6 211.1 445.4C212.4 453.1 210.6 461.1 206.1 467.5C201.6 473.9 194.7 478.2 186.9 479.6V479.6z"
    ]
};
var $42f4e3f18906b0d1$export$1aeaa8a5ac0e3463 = {
    prefix: "fab",
    iconName: "mintbit",
    icon: [
        512,
        512,
        [],
        "e62f",
        "M73.2 512V438.9H365.7V365.7h73.2V219.4H512V0H292.6V73.1H146.3v73.2H73.2V438.9H0V512H73.2zm73.1-219.4h73.2v73.1H146.3V292.6zm73.2-73.1h73.1v73.1H219.4V219.4zm73.1 0V146.3h73.2v73.1H292.6zM365.7 73.1h73.2v73.2H365.7V73.1z"
    ]
};
var $42f4e3f18906b0d1$export$b5ebb163fdb5edfd = {
    prefix: "fab",
    iconName: "ethereum",
    icon: [
        320,
        512,
        [],
        "f42e",
        "M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"
    ]
};
var $42f4e3f18906b0d1$export$7c461c4ee7c07c19 = {
    prefix: "fab",
    iconName: "speaker-deck",
    icon: [
        512,
        512,
        [],
        "f83c",
        "M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"
    ]
};
var $42f4e3f18906b0d1$export$bcf1858bdc40caa3 = {
    prefix: "fab",
    iconName: "creative-commons-nc-eu",
    icon: [
        496,
        512,
        [],
        "f4e9",
        "M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"
    ]
};
var $42f4e3f18906b0d1$export$a4dfebb823a477ff = {
    prefix: "fab",
    iconName: "patreon",
    icon: [
        512,
        512,
        [],
        "f3d9",
        "M489.7 153.8c-.1-65.4-51-119-110.7-138.3C304.8-8.5 207-5 136.1 28.4C50.3 68.9 23.3 157.7 22.3 246.2C21.5 319 28.7 510.6 136.9 512c80.3 1 92.3-102.5 129.5-152.3c26.4-35.5 60.5-45.5 102.4-55.9c72-17.8 121.1-74.7 121-150z"
    ]
};
var $42f4e3f18906b0d1$export$862396e708985a99 = {
    prefix: "fab",
    iconName: "avianex",
    icon: [
        512,
        512,
        [],
        "f374",
        "M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"
    ]
};
var $42f4e3f18906b0d1$export$e644e4a8cae83fb3 = {
    prefix: "fab",
    iconName: "ello",
    icon: [
        496,
        512,
        [],
        "f5f1",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"
    ]
};
var $42f4e3f18906b0d1$export$380164e9d6cdbec2 = {
    prefix: "fab",
    iconName: "gofore",
    icon: [
        400,
        512,
        [],
        "f3a7",
        "M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"
    ]
};
var $42f4e3f18906b0d1$export$a219f36955efe01a = {
    prefix: "fab",
    iconName: "bimobject",
    icon: [
        448,
        512,
        [],
        "f378",
        "M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"
    ]
};
var $42f4e3f18906b0d1$export$3d9997b304f32d18 = {
    prefix: "fab",
    iconName: "brave-reverse",
    icon: [
        448,
        512,
        [],
        "e63d",
        "M298 0c3 0 5.8 1.3 7.8 3.6l38.1 44c.5-.1 1-.2 1.5-.3c9.2-1.6 18.6-2.2 27.7-1.2c11.6 1.4 21.5 5.4 28.9 12.9c7.7 7.8 15.4 15.8 22.6 23.6c2.5 2.7 4.9 5.2 6.9 7.4c.7 .8 1.4 1.5 1.9 2c3.4 3.7 4.2 8.1 2.7 11.9l-9.8 24.6 13.1 38.1c.7 2 .8 4.1 .2 6.2c-.1 .4-.1 .4-.5 2.1c-.6 2.3-.6 2.3-1.5 5.8c-1.6 6.3-3.5 13.3-5.4 20.9c-5.6 21.6-11.2 43.2-16.4 63.4c-12.9 49.9-21.4 82.7-23.4 90.9c-11.1 44.5-19.9 60-48.3 80.3c-24.9 17.8-76.8 53.6-86.8 60c-1 .6-2 1.3-3.4 2.3c-.5 .4-3.2 2.2-3.9 2.7c-4.9 3.3-8.3 5.5-12.1 7.3c-4.7 2.2-9.3 3.5-13.9 3.5s-9.1-1.2-13.9-3.5c-3.7-1.8-7.2-3.9-12.1-7.3c-.8-.5-3.4-2.4-3.9-2.7c-1.4-1-2.5-1.7-3.4-2.3c-10-6.4-61.9-42.1-86.8-60c-28.4-20.4-37.2-35.8-48.3-80.3c-2-8.2-10.5-41-23.3-90.5c-5.3-20.6-10.9-42.2-16.5-63.8c-2-7.6-3.8-14.6-5.4-20.9c-.9-3.5-.9-3.5-1.5-5.8c-.4-1.7-.4-1.7-.5-2.1c-.5-2-.4-4.2 .2-6.2l13.1-38.1L11.8 104c-1.5-3.8-.7-8.2 2-11.2c1.2-1.3 1.8-2 2.6-2.8c2-2.2 4.4-4.7 6.9-7.4C30.6 74.9 38.3 66.9 46 59.1c7.4-7.5 17.3-11.6 28.9-12.9c9.1-1.1 18.5-.5 27.7 1.2c.5 .1 1 .2 1.5 .3l38.1-44C144.2 1.3 147 0 150 0H298zm-4.7 21.1H154.7L115.6 66.2c-2.6 3-6.7 4.3-10.6 3.2c-.2-.1-.7-.2-1.5-.4c-1.3-.3-2.9-.6-4.5-.9c-7.4-1.3-14.9-1.8-21.7-1C70 68 64.3 70.3 60.7 74c-7.6 7.7-15.2 15.6-22.3 23.3c-1.7 1.8-3.3 3.5-4.8 5.1l8.8 22c1 2.4 1 5 .2 7.5L29.2 170.6c.4 1.4 .5 1.9 1.2 4.8c1.6 6.3 3.5 13.3 5.4 20.9c5.6 21.6 11.2 43.2 16.4 63.4c12.9 50 21.4 82.8 23.4 91C85.7 390.8 92 402 115.8 419c24.6 17.6 76.3 53.2 85.9 59.3c1.2 .8 2.5 1.6 4 2.7c.6 .4 3.2 2.2 3.9 2.7c4 2.8 6.7 4.4 9.2 5.6c2.2 1 3.9 1.5 5.1 1.5s2.9-.5 5.1-1.5c2.5-1.2 5.2-2.8 9.2-5.6c.7-.5 3.3-2.3 3.9-2.7c1.6-1.1 2.8-1.9 4-2.7c9.6-6.1 61.3-41.7 85.9-59.3c23.8-17.1 30.2-28.2 40.1-68.3c2.1-8.3 10.5-41.1 23.3-90.7c5.3-20.6 10.9-42.2 16.5-63.8c2-7.6 3.8-14.6 5.4-20.9c.7-2.9 .9-3.4 1.2-4.8l-13.3-38.8c-.8-2.4-.8-5.1 .2-7.5l8.8-22c-1.5-1.6-3.1-3.3-4.8-5.1c-7.2-7.6-14.7-15.5-22.3-23.3c-3.7-3.7-9.3-6-16.6-6.9c-6.8-.8-14.4-.3-21.7 1c-1.7 .3-3.2 .6-4.5 .9c-.8 .2-1.3 .3-1.5 .4c-3.8 1.1-7.9-.2-10.6-3.2L293.3 21.1zM224 316c2.8 0 20.9 6.5 35.4 14.1s25 13 28.3 15.2s1.3 6.2-1.7 8.4s-44.1 34.6-48.1 38.2s-9.8 9.5-13.8 9.5s-9.8-5.9-13.8-9.5s-45.1-36-48.1-38.2s-5.1-6.2-1.7-8.4s13.9-7.5 28.3-15.2s32.5-14.1 35.4-14.1zm.1-230.7c.7 0 8.8 .2 20.5 4.2c12.3 4.2 25.7 9.4 31.9 9.4s51.9-8.9 51.9-8.9s54.2 66.7 54.2 81s-6.8 18-13.7 25.4s-36.8 39.8-40.7 43.9s-11.9 10.5-7.1 21.8s11.7 25.8 3.9 40.4s-21 24.4-29.4 22.8s-28.4-12.2-35.7-17.1s-30.5-24.3-30.5-31.8s24-20.8 28.4-23.9s24.7-14.8 25.1-19.4s.3-6-5.7-17.4s-16.7-26.7-14.9-36.8s19.1-15.4 31.5-20.2s36.2-13.7 39.2-15.1s2.2-2.7-6.8-3.6s-34.6-4.3-46.1-1.1s-31.2 8.2-32.8 10.9s-3 2.7-1.4 11.8s10.1 52.8 10.9 60.6s2.4 12.9-5.8 14.8s-22.1 5.2-26.8 5.2s-18.6-3.3-26.8-5.2s-6.6-7-5.8-14.8s9.3-51.5 10.9-60.6s.2-9.2-1.4-11.8s-21.3-7.6-32.8-10.9s-37.1 .2-46.1 1.1s-9.8 2.2-6.8 3.6s26.8 10.4 39.2 15.1s29.7 10 31.5 20.2s-9 25.4-14.9 36.8s-6.1 12.8-5.7 17.4s20.6 16.4 25.1 19.4s28.4 16.4 28.4 23.9s-23.2 27-30.5 31.8s-27.2 15.4-35.7 17.1s-21.7-8.2-29.4-22.8s-.8-29.1 3.9-40.4s-3.3-17.7-7.1-21.8s-33.8-36.5-40.7-43.9s-13.7-11.2-13.7-25.4s54.2-81 54.2-81s45.8 8.9 51.9 8.9s19.5-5.2 31.9-9.4s20.6-4.2 20.6-4.2l.1 0z"
    ]
};
var $42f4e3f18906b0d1$export$890714bb00316cc = {
    prefix: "fab",
    iconName: "facebook-f",
    icon: [
        320,
        512,
        [],
        "f39e",
        "M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"
    ]
};
var $42f4e3f18906b0d1$export$e94511deb1df63ce = {
    prefix: "fab",
    iconName: "square-google-plus",
    icon: [
        448,
        512,
        [
            "google-plus-square"
        ],
        "f0d4",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM64 256c0-55.3 44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4c-34.1 0-61.9 28.2-61.9 63.2c0 34.9 27.8 63.2 61.9 63.2c39.6 0 54.4-28.5 56.8-43.1H164V241.8h94.4c1 5 1.6 10.1 1.6 16.6c0 57.1-38.3 97.6-96 97.6c-55.3 0-100-44.7-100-100zm291 18.2v29H325.8v-29h-29V245h29V216H355v29h29v29.2H355z"
    ]
};
var $42f4e3f18906b0d1$export$d546947149d9505a = $42f4e3f18906b0d1$export$e94511deb1df63ce;
var $42f4e3f18906b0d1$export$2a745e3ef2838c53 = {
    prefix: "fab",
    iconName: "mandalorian",
    icon: [
        448,
        512,
        [],
        "f50f",
        "M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"
    ]
};
var $42f4e3f18906b0d1$export$ea0bc2cd8d60b806 = {
    prefix: "fab",
    iconName: "first-order-alt",
    icon: [
        496,
        512,
        [],
        "f50a",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"
    ]
};
var $42f4e3f18906b0d1$export$89cf1df24c6f1e2 = {
    prefix: "fab",
    iconName: "osi",
    icon: [
        512,
        512,
        [],
        "f41a",
        "M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"
    ]
};
var $42f4e3f18906b0d1$export$6fd7b581d1a20a14 = {
    prefix: "fab",
    iconName: "google-wallet",
    icon: [
        448,
        512,
        [],
        "f1ee",
        "M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"
    ]
};
var $42f4e3f18906b0d1$export$8ffeba28c1feff0d = {
    prefix: "fab",
    iconName: "d-and-d-beyond",
    icon: [
        640,
        512,
        [],
        "f6ca",
        "M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"
    ]
};
var $42f4e3f18906b0d1$export$10deb29d7dbf2418 = {
    prefix: "fab",
    iconName: "periscope",
    icon: [
        448,
        512,
        [],
        "f3da",
        "M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"
    ]
};
var $42f4e3f18906b0d1$export$beb89eeaf726c65a = {
    prefix: "fab",
    iconName: "fulcrum",
    icon: [
        320,
        512,
        [],
        "f50b",
        "M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"
    ]
};
var $42f4e3f18906b0d1$export$fdf6053d73314ca6 = {
    prefix: "fab",
    iconName: "cloudscale",
    icon: [
        448,
        512,
        [],
        "f383",
        "M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"
    ]
};
var $42f4e3f18906b0d1$export$e4fb88a0423b6fee = {
    prefix: "fab",
    iconName: "forumbee",
    icon: [
        448,
        512,
        [],
        "f211",
        "M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"
    ]
};
var $42f4e3f18906b0d1$export$e6a3c752190fa3cb = {
    prefix: "fab",
    iconName: "mizuni",
    icon: [
        496,
        512,
        [],
        "f3cc",
        "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"
    ]
};
var $42f4e3f18906b0d1$export$3f1891b85805675f = {
    prefix: "fab",
    iconName: "schlix",
    icon: [
        448,
        512,
        [],
        "f3ea",
        "M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"
    ]
};
var $42f4e3f18906b0d1$export$ca49464b0602c8ef = {
    prefix: "fab",
    iconName: "square-xing",
    icon: [
        448,
        512,
        [
            "xing-square"
        ],
        "f169",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM93.8 320.2c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6 .2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2c-3.5 6.2-7.7 9.1-12.6 9.1H93.8zm163.5-33.4v.2l65.5 119c2.8 5.1 .1 10.1-6 10.1H270.2c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c1.8-3.2 22.9-40.4 63.3-111.6c11.7-20.7 25.1-44.3 40.1-70.8c3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10L257.3 286.8z"
    ]
};
var $42f4e3f18906b0d1$export$3f616d72d818a1a6 = $42f4e3f18906b0d1$export$ca49464b0602c8ef;
var $42f4e3f18906b0d1$export$cf8fa465ef81d073 = {
    prefix: "fab",
    iconName: "bandcamp",
    icon: [
        512,
        512,
        [],
        "f2d5",
        "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"
    ]
};
var $42f4e3f18906b0d1$export$f70eba4216b4419a = {
    prefix: "fab",
    iconName: "wpforms",
    icon: [
        448,
        512,
        [],
        "f298",
        "M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"
    ]
};
var $42f4e3f18906b0d1$export$623057fac7dabd52 = {
    prefix: "fab",
    iconName: "cloudversify",
    icon: [
        616,
        512,
        [],
        "f385",
        "M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"
    ]
};
var $42f4e3f18906b0d1$export$216644b0c66e66a5 = {
    prefix: "fab",
    iconName: "usps",
    icon: [
        576,
        512,
        [],
        "f7e1",
        "M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"
    ]
};
var $42f4e3f18906b0d1$export$e7e4dbda4df6110f = {
    prefix: "fab",
    iconName: "megaport",
    icon: [
        496,
        512,
        [],
        "f5a3",
        "M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"
    ]
};
var $42f4e3f18906b0d1$export$9b8374b50472190d = {
    prefix: "fab",
    iconName: "magento",
    icon: [
        448,
        512,
        [],
        "f3c4",
        "M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"
    ]
};
var $42f4e3f18906b0d1$export$8218f3fbb2f89724 = {
    prefix: "fab",
    iconName: "spotify",
    icon: [
        496,
        512,
        [],
        "f1bc",
        "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"
    ]
};
var $42f4e3f18906b0d1$export$5247a00f0c0b93a3 = {
    prefix: "fab",
    iconName: "optin-monster",
    icon: [
        576,
        512,
        [],
        "f23c",
        "M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"
    ]
};
var $42f4e3f18906b0d1$export$cfbbba1261e4e2d2 = {
    prefix: "fab",
    iconName: "fly",
    icon: [
        384,
        512,
        [],
        "f417",
        "M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"
    ]
};
var $42f4e3f18906b0d1$export$f731696770842fd2 = {
    prefix: "fab",
    iconName: "aviato",
    icon: [
        640,
        512,
        [],
        "f421",
        "M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"
    ]
};
var $42f4e3f18906b0d1$export$5f69a5b38e12c984 = {
    prefix: "fab",
    iconName: "itunes",
    icon: [
        448,
        512,
        [],
        "f3b4",
        "M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"
    ]
};
var $42f4e3f18906b0d1$export$883d4844d275b117 = {
    prefix: "fab",
    iconName: "cuttlefish",
    icon: [
        440,
        512,
        [],
        "f38c",
        "M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"
    ]
};
var $42f4e3f18906b0d1$export$eba2747efc67a397 = {
    prefix: "fab",
    iconName: "blogger",
    icon: [
        448,
        512,
        [],
        "f37c",
        "M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"
    ]
};
var $42f4e3f18906b0d1$export$4fc2e88e3ac2b091 = {
    prefix: "fab",
    iconName: "flickr",
    icon: [
        448,
        512,
        [],
        "f16e",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"
    ]
};
var $42f4e3f18906b0d1$export$c16cb0c14aa5beed = {
    prefix: "fab",
    iconName: "viber",
    icon: [
        512,
        512,
        [],
        "f409",
        "M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"
    ]
};
var $42f4e3f18906b0d1$export$5803ef8c86f9786d = {
    prefix: "fab",
    iconName: "soundcloud",
    icon: [
        640,
        512,
        [],
        "f1be",
        "M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"
    ]
};
var $42f4e3f18906b0d1$export$1902312a1701467c = {
    prefix: "fab",
    iconName: "digg",
    icon: [
        512,
        512,
        [],
        "f1a6",
        "M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"
    ]
};
var $42f4e3f18906b0d1$export$9ea61fa1ff3225c6 = {
    prefix: "fab",
    iconName: "tencent-weibo",
    icon: [
        384,
        512,
        [],
        "f1d5",
        "M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"
    ]
};
var $42f4e3f18906b0d1$export$3d0320148c8ebcd6 = {
    prefix: "fab",
    iconName: "letterboxd",
    icon: [
        640,
        512,
        [],
        "e62d",
        "M521.3 128C586.9 128 640 181.1 640 246.6s-53.1 118.6-118.7 118.6c-42.5 0-79.7-22.3-100.7-55.8c11.4-18.2 18-39.7 18-62.8s-6.6-44.6-18-62.8l0 0 .8-1.2c20.8-32.3 56.8-53.9 97.9-54.6l2 0zM320 128c42.5 0 79.7 22.3 100.7 55.8c-11.4 18.2-18 39.7-18 62.8s6.6 44.6 18 62.8l0 0-.8 1.2c-20.8 32.3-56.8 53.9-97.9 54.6l-2 0c-42.5 0-79.7-22.3-100.7-55.8c11.4-18.2 18-39.7 18-62.8s-6.6-44.6-18-62.8l0 0 .8-1.2c20.8-32.3 56.8-53.9 97.9-54.6l2 0zm-201.3 0c42.5 0 79.7 22.3 100.7 55.8c-11.4 18.2-18 39.7-18 62.8s6.6 44.6 18 62.8l0 0-.8 1.2c-20.8 32.3-56.8 53.9-97.9 54.6l-2 0C53.1 365.1 0 312.1 0 246.6S53.1 128 118.7 128z"
    ]
};
var $42f4e3f18906b0d1$export$5420457350c35845 = {
    prefix: "fab",
    iconName: "symfony",
    icon: [
        512,
        512,
        [],
        "f83d",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"
    ]
};
var $42f4e3f18906b0d1$export$a33f03bc723e6603 = {
    prefix: "fab",
    iconName: "maxcdn",
    icon: [
        512,
        512,
        [],
        "f136",
        "M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"
    ]
};
var $42f4e3f18906b0d1$export$c7956780474e39de = {
    prefix: "fab",
    iconName: "etsy",
    icon: [
        384,
        512,
        [],
        "f2d7",
        "M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"
    ]
};
var $42f4e3f18906b0d1$export$6c28dada3398f534 = {
    prefix: "fab",
    iconName: "facebook-messenger",
    icon: [
        512,
        512,
        [],
        "f39f",
        "M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"
    ]
};
var $42f4e3f18906b0d1$export$83a2d14204e40d9a = {
    prefix: "fab",
    iconName: "audible",
    icon: [
        640,
        512,
        [],
        "f373",
        "M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"
    ]
};
var $42f4e3f18906b0d1$export$4c12ad86c5e9c2a9 = {
    prefix: "fab",
    iconName: "think-peaks",
    icon: [
        576,
        512,
        [],
        "f731",
        "M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"
    ]
};
var $42f4e3f18906b0d1$export$34797550194301d4 = {
    prefix: "fab",
    iconName: "bilibili",
    icon: [
        512,
        512,
        [],
        "e3d9",
        "M488.6 104.1C505.3 122.2 513 143.8 511.9 169.8V372.2C511.5 398.6 502.7 420.3 485.4 437.3C468.2 454.3 446.3 463.2 419.9 464H92.02C65.57 463.2 43.81 454.2 26.74 436.8C9.682 419.4 .7667 396.5 0 368.2V169.8C.7667 143.8 9.682 122.2 26.74 104.1C43.81 87.75 65.57 78.77 92.02 78H121.4L96.05 52.19C90.3 46.46 87.42 39.19 87.42 30.4C87.42 21.6 90.3 14.34 96.05 8.603C101.8 2.868 109.1 0 117.9 0C126.7 0 134 2.868 139.8 8.603L213.1 78H301.1L375.6 8.603C381.7 2.868 389.2 0 398 0C406.8 0 414.1 2.868 419.9 8.603C425.6 14.34 428.5 21.6 428.5 30.4C428.5 39.19 425.6 46.46 419.9 52.19L394.6 78L423.9 78C450.3 78.77 471.9 87.75 488.6 104.1H488.6zM449.8 173.8C449.4 164.2 446.1 156.4 439.1 150.3C433.9 144.2 425.1 140.9 416.4 140.5H96.05C86.46 140.9 78.6 144.2 72.47 150.3C66.33 156.4 63.07 164.2 62.69 173.8V368.2C62.69 377.4 65.95 385.2 72.47 391.7C78.99 398.2 86.85 401.5 96.05 401.5H416.4C425.6 401.5 433.4 398.2 439.7 391.7C446 385.2 449.4 377.4 449.8 368.2L449.8 173.8zM185.5 216.5C191.8 222.8 195.2 230.6 195.6 239.7V273C195.2 282.2 191.9 289.9 185.8 296.2C179.6 302.5 171.8 305.7 162.2 305.7C152.6 305.7 144.7 302.5 138.6 296.2C132.5 289.9 129.2 282.2 128.8 273V239.7C129.2 230.6 132.6 222.8 138.9 216.5C145.2 210.2 152.1 206.9 162.2 206.5C171.4 206.9 179.2 210.2 185.5 216.5H185.5zM377 216.5C383.3 222.8 386.7 230.6 387.1 239.7V273C386.7 282.2 383.4 289.9 377.3 296.2C371.2 302.5 363.3 305.7 353.7 305.7C344.1 305.7 336.3 302.5 330.1 296.2C323.1 289.9 320.7 282.2 320.4 273V239.7C320.7 230.6 324.1 222.8 330.4 216.5C336.7 210.2 344.5 206.9 353.7 206.5C362.9 206.9 370.7 210.2 377 216.5H377z"
    ]
};
var $42f4e3f18906b0d1$export$c6087bbc62da6f90 = {
    prefix: "fab",
    iconName: "erlang",
    icon: [
        640,
        512,
        [],
        "f39d",
        "M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"
    ]
};
var $42f4e3f18906b0d1$export$fd0513a3aa908a67 = {
    prefix: "fab",
    iconName: "x-twitter",
    icon: [
        512,
        512,
        [],
        "e61b",
        "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
    ]
};
var $42f4e3f18906b0d1$export$8fc0685430a4202e = {
    prefix: "fab",
    iconName: "cotton-bureau",
    icon: [
        512,
        512,
        [],
        "f89e",
        "M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"
    ]
};
var $42f4e3f18906b0d1$export$fc2c1db4698b6c91 = {
    prefix: "fab",
    iconName: "dashcube",
    icon: [
        448,
        512,
        [],
        "f210",
        "M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"
    ]
};
var $42f4e3f18906b0d1$export$a02285afcee8b3ba = {
    prefix: "fab",
    iconName: "42-group",
    icon: [
        640,
        512,
        [
            "innosoft"
        ],
        "e080",
        "M320 96V416C341.011 416 361.818 411.861 381.23 403.821C400.641 395.78 418.28 383.995 433.138 369.138C447.995 354.28 459.78 336.641 467.821 317.23C475.861 297.818 480 277.011 480 256C480 234.989 475.861 214.182 467.821 194.771C459.78 175.359 447.995 157.72 433.138 142.863C418.28 128.005 400.641 116.22 381.23 108.179C361.818 100.139 341.011 96 320 96ZM0 256L160.002 416L320.003 256L160.002 96L0 256ZM480 256C480 277.011 484.138 297.818 492.179 317.23C500.219 336.643 512.005 354.28 526.862 369.138C541.72 383.995 559.357 395.781 578.77 403.821C598.182 411.862 618.989 416 640 416V96C597.565 96 556.869 112.858 526.862 142.863C496.857 172.869 480 213.565 480 256Z"
    ]
};
var $42f4e3f18906b0d1$export$da8db9965333c744 = $42f4e3f18906b0d1$export$a02285afcee8b3ba;
var $42f4e3f18906b0d1$export$d511b4edf7fbac5a = {
    prefix: "fab",
    iconName: "stack-exchange",
    icon: [
        448,
        512,
        [],
        "f18d",
        "M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"
    ]
};
var $42f4e3f18906b0d1$export$66726053c0c0ec32 = {
    prefix: "fab",
    iconName: "elementor",
    icon: [
        512,
        512,
        [],
        "f430",
        "M.361 256C.361 397 114 511 255 511C397 511 511 397 511 256C511 116 397 2.05 255 2.05C114 2.05 .361 116 .361 256zM192 150V363H149V150H192zM234 150H362V193H234V150zM362 235V278H234V235H362zM234 320H362V363H234V320z"
    ]
};
var $42f4e3f18906b0d1$export$9d16a5780aab9cd3 = {
    prefix: "fab",
    iconName: "square-pied-piper",
    icon: [
        448,
        512,
        [
            "pied-piper-square"
        ],
        "e01e",
        "M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"
    ]
};
var $42f4e3f18906b0d1$export$95ddae6b65597c6e = $42f4e3f18906b0d1$export$9d16a5780aab9cd3;
var $42f4e3f18906b0d1$export$157e4276d9138bda = {
    prefix: "fab",
    iconName: "creative-commons-nd",
    icon: [
        496,
        512,
        [],
        "f4eb",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"
    ]
};
var $42f4e3f18906b0d1$export$a226dd96512e144 = {
    prefix: "fab",
    iconName: "palfed",
    icon: [
        576,
        512,
        [],
        "f3d8",
        "M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"
    ]
};
var $42f4e3f18906b0d1$export$349f4fc9997a1bf0 = {
    prefix: "fab",
    iconName: "superpowers",
    icon: [
        448,
        512,
        [],
        "f2dd",
        "M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"
    ]
};
var $42f4e3f18906b0d1$export$e73a6c635a57ef10 = {
    prefix: "fab",
    iconName: "resolving",
    icon: [
        496,
        512,
        [],
        "f3e7",
        "M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"
    ]
};
var $42f4e3f18906b0d1$export$2c743c09f4269e9c = {
    prefix: "fab",
    iconName: "xbox",
    icon: [
        512,
        512,
        [],
        "f412",
        "M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"
    ]
};
var $42f4e3f18906b0d1$export$e72de9688042e327 = {
    prefix: "fab",
    iconName: "searchengin",
    icon: [
        460,
        512,
        [],
        "f3eb",
        "M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"
    ]
};
var $42f4e3f18906b0d1$export$f310e79ae35a251f = {
    prefix: "fab",
    iconName: "tiktok",
    icon: [
        448,
        512,
        [],
        "e07b",
        "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
    ]
};
var $42f4e3f18906b0d1$export$8545d76ecd01ec19 = {
    prefix: "fab",
    iconName: "square-facebook",
    icon: [
        448,
        512,
        [
            "facebook-square"
        ],
        "f082",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h98.2V334.2H109.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H255V480H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $42f4e3f18906b0d1$export$cd6ab8ed6a9ec7a4 = $42f4e3f18906b0d1$export$8545d76ecd01ec19;
var $42f4e3f18906b0d1$export$36a9439e8de2df70 = {
    prefix: "fab",
    iconName: "renren",
    icon: [
        512,
        512,
        [],
        "f18b",
        "M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"
    ]
};
var $42f4e3f18906b0d1$export$5cb68a24a0b7bdf6 = {
    prefix: "fab",
    iconName: "linux",
    icon: [
        448,
        512,
        [],
        "f17c",
        "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"
    ]
};
var $42f4e3f18906b0d1$export$c4c84939b8784e10 = {
    prefix: "fab",
    iconName: "glide",
    icon: [
        448,
        512,
        [],
        "f2a5",
        "M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"
    ]
};
var $42f4e3f18906b0d1$export$b38fbe0cd1e4c67d = {
    prefix: "fab",
    iconName: "linkedin",
    icon: [
        448,
        512,
        [],
        "f08c",
        "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
    ]
};
var $42f4e3f18906b0d1$export$418b99079caf9b9b = {
    prefix: "fab",
    iconName: "hubspot",
    icon: [
        512,
        512,
        [],
        "f3b2",
        "M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"
    ]
};
var $42f4e3f18906b0d1$export$bd9dbf3c3b0bdc5e = {
    prefix: "fab",
    iconName: "deploydog",
    icon: [
        512,
        512,
        [],
        "f38e",
        "M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"
    ]
};
var $42f4e3f18906b0d1$export$154857d90d308f7c = {
    prefix: "fab",
    iconName: "twitch",
    icon: [
        512,
        512,
        [],
        "f1e8",
        "M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"
    ]
};
var $42f4e3f18906b0d1$export$cab2db22e59af947 = {
    prefix: "fab",
    iconName: "ravelry",
    icon: [
        512,
        512,
        [],
        "f2d9",
        "M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"
    ]
};
var $42f4e3f18906b0d1$export$83d047b1c09d253 = {
    prefix: "fab",
    iconName: "mixer",
    icon: [
        512,
        512,
        [],
        "e056",
        "M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"
    ]
};
var $42f4e3f18906b0d1$export$37794c0b0ffc1e44 = {
    prefix: "fab",
    iconName: "square-lastfm",
    icon: [
        448,
        512,
        [
            "lastfm-square"
        ],
        "f203",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM210.7 280.8c-1.8-5.5-3.4-10.8-5-15.9c-12.9-41.9-21-68.4-58-68.4c-22.4 0-45.1 16.1-45.1 61.2c0 35.2 18 57.2 43.3 57.2c28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8c0-57.9 28.6-92 82.5-92c67.9 0 79.3 35.3 96.4 88.4c1.4 4.4 2.9 8.9 4.4 13.5c8.8 26.8 24.2 46.2 61.2 46.2c24.9 0 38.1-5.5 38.1-19.1c0-17.5-16.9-21.2-40-26.4c-3.2-.7-6.5-1.4-9.9-2.2c-30.4-7.3-42.5-23.1-42.5-48c0-40 32.3-52.4 65.2-52.4c37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4c-16.1 0-26 7.3-26 19.8c0 11 4.8 17.6 20.9 21.3c2.2 .5 4.5 1 6.7 1.4c31.1 6.5 65.1 13.7 65.1 56.1c.1 36.7-30.7 50.6-76.1 50.6c-63.4 0-85.4-28.6-97.1-64.1z"
    ]
};
var $42f4e3f18906b0d1$export$c2f59587d6a3a574 = $42f4e3f18906b0d1$export$37794c0b0ffc1e44;
var $42f4e3f18906b0d1$export$b73c31bd90a3782e = {
    prefix: "fab",
    iconName: "vimeo",
    icon: [
        448,
        512,
        [],
        "f40a",
        "M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"
    ]
};
var $42f4e3f18906b0d1$export$a580d86d20b50be3 = {
    prefix: "fab",
    iconName: "mendeley",
    icon: [
        640,
        512,
        [],
        "f7b3",
        "M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"
    ]
};
var $42f4e3f18906b0d1$export$6fb93399039178f9 = {
    prefix: "fab",
    iconName: "uniregistry",
    icon: [
        384,
        512,
        [],
        "f404",
        "M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"
    ]
};
var $42f4e3f18906b0d1$export$e71a35e82f13ad7f = {
    prefix: "fab",
    iconName: "figma",
    icon: [
        384,
        512,
        [],
        "f799",
        "M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"
    ]
};
var $42f4e3f18906b0d1$export$c02c848648d47b55 = {
    prefix: "fab",
    iconName: "creative-commons-remix",
    icon: [
        496,
        512,
        [],
        "f4ee",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"
    ]
};
var $42f4e3f18906b0d1$export$3f0dada7ec074193 = {
    prefix: "fab",
    iconName: "cc-amazon-pay",
    icon: [
        576,
        512,
        [],
        "f42d",
        "M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"
    ]
};
var $42f4e3f18906b0d1$export$e4589d83245ae1b2 = {
    prefix: "fab",
    iconName: "dropbox",
    icon: [
        528,
        512,
        [],
        "f16b",
        "M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"
    ]
};
var $42f4e3f18906b0d1$export$8256451a9905291a = {
    prefix: "fab",
    iconName: "instagram",
    icon: [
        448,
        512,
        [],
        "f16d",
        "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
    ]
};
var $42f4e3f18906b0d1$export$f4e59d0d43aeb784 = {
    prefix: "fab",
    iconName: "cmplid",
    icon: [
        640,
        512,
        [],
        "e360",
        "M226.119,388.165a3.816,3.816,0,0,0-2.294-3.5,3.946,3.946,0,0,0-1.629-.385L72.6,384.3a19.243,19.243,0,0,1-17.924-26.025L81.585,255.692a35.72,35.72,0,0,1,32.373-26H262.525a7.07,7.07,0,0,0,6.392-5.194l10.769-41.131a3.849,3.849,0,0,0-2.237-4.937,3.755,3.755,0,0,0-1.377-.261c-.063,0-.126,0-.189.005H127.38a106.8,106.8,0,0,0-96.99,77.1L3.483,358.824A57.469,57.469,0,0,0,57.314,436q1.43,0,2.86-.072H208.742a7.131,7.131,0,0,0,6.391-5.193L225.839,389.6A3.82,3.82,0,0,0,226.119,388.165ZM306.658,81.2a3.861,3.861,0,0,0,.251-1.367A3.813,3.813,0,0,0,303.079,76c-.064,0-.128,0-.192,0h-41A7.034,7.034,0,0,0,255.5,81.2l-21.347,80.915h51.131ZM180.364,368.249H231.5L263.452,245.69H212.321ZM511.853,79.723a3.809,3.809,0,0,0-3.8-3.661c-.058,0-.137,0-.23.007h-41a7.1,7.1,0,0,0-6.584,5.129L368.91,430.634a3.54,3.54,0,0,0-.262,1.335,3.873,3.873,0,0,0,3.864,3.863c.056,0,.112,0,.169,0h41a7.068,7.068,0,0,0,6.392-5.193L511.533,81.2A3.624,3.624,0,0,0,511.853,79.723ZM324.649,384.47h-41a7.2,7.2,0,0,0-6.392,5.194L266.52,430.8a3.662,3.662,0,0,0-.268,1.374A3.783,3.783,0,0,0,270.023,436c.06,0,.166,0,.3-.012h40.905a7.036,7.036,0,0,0,6.391-5.193l10.769-41.131a3.75,3.75,0,0,0-3.445-5.208c-.108,0-.217,0-.326.014Zm311.324-308.4h-41a7.066,7.066,0,0,0-6.392,5.129l-91.46,349.436a4.073,4.073,0,0,0-.229,1.347,3.872,3.872,0,0,0,3.863,3.851c.056,0,.112,0,.169,0h40.968a7.1,7.1,0,0,0,6.392-5.193L639.68,81.2a3.624,3.624,0,0,0,.32-1.475,3.841,3.841,0,0,0-3.821-3.564c-.068,0-.137,0-.206.006ZM371.562,225.236l10.8-41.1a4.369,4.369,0,0,0,.227-1.388,3.869,3.869,0,0,0-3.861-3.842c-.057,0-.113,0-.169,0h-41.1a7.292,7.292,0,0,0-6.391,5.226l-10.834,41.1a4.417,4.417,0,0,0-.26,1.493c0,.069,0,.138,0,.206a3.776,3.776,0,0,0,3.757,3.507c.076,0,.18,0,.3-.012h41.129A7.034,7.034,0,0,0,371.562,225.236Z"
    ]
};
var $42f4e3f18906b0d1$export$f32e8672931b41ff = {
    prefix: "fab",
    iconName: "upwork",
    icon: [
        448,
        512,
        [],
        "e641",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM270.8 274.3c5.2 8.4 23.6 29.9 51.5 29.9v0c25.2 0 44.9-20.2 44.9-49.7s-19.4-49.7-44.9-49.7s-44.9 16.7-51.5 69.5zm-26.7-41.8c7.3-30.5 32.7-60.1 78.2-60.1l0 0c45.1 0 80.9 35.2 80.9 82.2s-35.9 81.9-80.9 81.9c-.6 0-1.1 0-1.7 0c-.5 0-1.1 0-1.6 0h-.1c-14.5-.5-28.7-4.8-40.9-12.6c-4.7-2.8-9.1-6-13.4-9.5l-12.8 78.4H214.9l19.4-110.6c-20.8-29.1-31.6-62.4-36.2-79.7V255c0 48-30.5 81.5-74.2 81.5c-22 0-41-8-54.8-23.3c-13.4-14.8-20.8-35.5-20.8-58.3V176.8H84.5l-.3 78.2c0 28.4 14.5 49.3 39.8 49.3s38.2-20.9 38.2-49.3V176.8h62.8c4.8 19.3 10.9 40.1 19.2 55.6z"
    ]
};
var $42f4e3f18906b0d1$export$86108d0b79007794 = {
    prefix: "fab",
    iconName: "facebook",
    icon: [
        512,
        512,
        [
            62000
        ],
        "f09a",
        "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"
    ]
};
var $42f4e3f18906b0d1$export$957b7296da5b4490 = {
    prefix: "fab",
    iconName: "gripfire",
    icon: [
        384,
        512,
        [],
        "f3ac",
        "M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"
    ]
};
var $42f4e3f18906b0d1$export$3a376d0f2ecfb7d0 = {
    prefix: "fab",
    iconName: "jedi-order",
    icon: [
        448,
        512,
        [],
        "f50e",
        "M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"
    ]
};
var $42f4e3f18906b0d1$export$27afc16078b5f3ac = {
    prefix: "fab",
    iconName: "uikit",
    icon: [
        448,
        512,
        [],
        "f403",
        "M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"
    ]
};
var $42f4e3f18906b0d1$export$a5097e0b1bb080b7 = {
    prefix: "fab",
    iconName: "fort-awesome-alt",
    icon: [
        512,
        512,
        [],
        "f3a3",
        "M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"
    ]
};
var $42f4e3f18906b0d1$export$cc29519275365076 = {
    prefix: "fab",
    iconName: "phabricator",
    icon: [
        496,
        512,
        [],
        "f3db",
        "M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"
    ]
};
var $42f4e3f18906b0d1$export$d0ceedb643a91662 = {
    prefix: "fab",
    iconName: "ussunnah",
    icon: [
        482,
        512,
        [],
        "f407",
        "M481.9 268.1A240.9 240.9 0 1 1 .1 268a240.9 240.9 0 1 1 481.9 0zM24.5 268a216.5 216.5 0 1 0 432.9 0A216.5 216.5 0 1 0 24.5 268zm385.9 63.3c-12.7 0-21.6-1.9-26.7-5.9c-5.5-4.3-8.2-12.3-8.2-23.8V205.1c0-6.5-5.2-20.2-15.7-41.2c7 0 17-9.1 30-27.2V284.5c0 11 2.4 19.4 7 25.3c3.7 4.7 10.1 8.9 19 12.6c1.2 .4 2.6 .9 4.1 1.4c2.9 .9 6.3 2.1 10.3 3.5c-1.8 2.7-8.3 4-19.9 4zm-219 0c-1.3 2.4-3.6 5.5-6.8 9.4l-18.5 22.5c-1-6.1-4-13-9.3-20.6s-9.7-11.4-13.4-11.4h-8.3H53.6c3.3-5.3 4.9-8.8 4.9-10.8c0-2-.8-5.3-2.4-9.7c-1.5-4.4-2.4-8.5-2.4-12.4c0-7.4 2.1-13.9 6.3-19.3L80 253.4l-7.1-17.7L89 215.9l6.7 16.8 8-10.3c-1.8 6.4-2.6 12.3-2.6 17.7c0 4.2 2.8 13.3 8.3 27.3l16.2 40.7H135h8 .3c2.8 .4 7.7 5 14.6 13.9c1.8 2.4 4.3 5.8 7.7 10.2c1.4 1.9 2.9 3.9 4.6 6.1c1.3-2.3 2-4.6 2-7.1c0-2-1.3-6.6-4-13.4L163 304.1c-4-10.6-6.1-17.7-6.1-21.3c0-6.3 1.9-12.3 5.8-17.9c.5-.6 1-1.3 1.5-1.9c4.4-5.6 8.8-11.1 13.3-16.5c-1.1 4.6-1.7 8.7-1.7 12c0 3.7 1.7 9.9 5.1 18.8l7.9 20.4c1.9 4.7 3 8.2 3.7 10.3h17.6 8.3l-.9-2.6c-1.4-3.9-4-7-7.7-9.3l15.6-20.1 12.3 32h13.4L245 292.2c-1.5-3.9-4-7-7.7-9.3L253 262.8 270.3 308h13.4l-11.4-29.4c-1.5-3.9-4-7-7.7-9.3l15.6-20L302.6 308h10.3 8.3 7.6c1.5 0 3-1.1 4.5-3.1s2.2-4.1 2.2-6.3V205.1c0-6.5-4.5-20.3-13.7-41.2c5.4 0 14.1-9.1 26.2-27.2V300.2c0 7.2 .6 12 1.7 14.6c1.6 3.4 5.3 6.2 11.1 8.2c-3.9 5.6-8.7 8.5-14.5 8.5H321.1h-8.3H210.5h-19zM93.4 287.3c-2.7-6.7-4-11.7-4-15c-.6 1.2-2.4 3.7-5.4 7.6c-1.4 1.9-2.2 3.7-2.2 5.3c0 2.6 .8 5.7 2.2 9.3l5.6 13.9h0c5 0 9 0 11.9-.1l-8.2-20.9zm13.5-72.4c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3zm-27.6 0c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3zm87 27.5c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3z"
    ]
};
var $42f4e3f18906b0d1$export$c30a6352a2a5e8ea = {
    prefix: "fab",
    iconName: "earlybirds",
    icon: [
        480,
        512,
        [],
        "f39a",
        "M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"
    ]
};
var $42f4e3f18906b0d1$export$83b68077d321f3ad = {
    prefix: "fab",
    iconName: "trade-federation",
    icon: [
        496,
        512,
        [],
        "f513",
        "M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"
    ]
};
var $42f4e3f18906b0d1$export$2ea4e300aa12cd0a = {
    prefix: "fab",
    iconName: "autoprefixer",
    icon: [
        640,
        512,
        [],
        "f41c",
        "M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"
    ]
};
var $42f4e3f18906b0d1$export$45bdf388845cdf99 = {
    prefix: "fab",
    iconName: "whatsapp",
    icon: [
        448,
        512,
        [],
        "f232",
        "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
    ]
};
var $42f4e3f18906b0d1$export$4dcd48fd9c0bdd2d = {
    prefix: "fab",
    iconName: "slideshare",
    icon: [
        512,
        512,
        [],
        "f1e7",
        "M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"
    ]
};
var $42f4e3f18906b0d1$export$cfa707f90d6b79ec = {
    prefix: "fab",
    iconName: "google-play",
    icon: [
        512,
        512,
        [],
        "f3ab",
        "M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
    ]
};
var $42f4e3f18906b0d1$export$6f9febfcc8ac97d4 = {
    prefix: "fab",
    iconName: "viadeo",
    icon: [
        448,
        512,
        [],
        "f2a9",
        "M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"
    ]
};
var $42f4e3f18906b0d1$export$c5b04bbf0f48913a = {
    prefix: "fab",
    iconName: "line",
    icon: [
        512,
        512,
        [],
        "f3c0",
        "M311 196.8v81.3c0 2.1-1.6 3.7-3.7 3.7h-13c-1.3 0-2.4-.7-3-1.5l-37.3-50.3v48.2c0 2.1-1.6 3.7-3.7 3.7h-13c-2.1 0-3.7-1.6-3.7-3.7V196.9c0-2.1 1.6-3.7 3.7-3.7h12.9c1.1 0 2.4 .6 3 1.6l37.3 50.3V196.9c0-2.1 1.6-3.7 3.7-3.7h13c2.1-.1 3.8 1.6 3.8 3.5zm-93.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 2.1 1.6 3.7 3.7 3.7h13c2.1 0 3.7-1.6 3.7-3.7V196.8c0-1.9-1.6-3.7-3.7-3.7zm-31.4 68.1H150.3V196.8c0-2.1-1.6-3.7-3.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 1 .3 1.8 1 2.5c.7 .6 1.5 1 2.5 1h52.2c2.1 0 3.7-1.6 3.7-3.7v-13c0-1.9-1.6-3.7-3.5-3.7zm193.7-68.1H327.3c-1.9 0-3.7 1.6-3.7 3.7v81.3c0 1.9 1.6 3.7 3.7 3.7h52.2c2.1 0 3.7-1.6 3.7-3.7V265c0-2.1-1.6-3.7-3.7-3.7H344V247.7h35.5c2.1 0 3.7-1.6 3.7-3.7V230.9c0-2.1-1.6-3.7-3.7-3.7H344V213.5h35.5c2.1 0 3.7-1.6 3.7-3.7v-13c-.1-1.9-1.7-3.7-3.7-3.7zM512 93.4V419.4c-.1 51.2-42.1 92.7-93.4 92.6H92.6C41.4 511.9-.1 469.8 0 418.6V92.6C.1 41.4 42.2-.1 93.4 0H419.4c51.2 .1 92.7 42.1 92.6 93.4zM441.6 233.5c0-83.4-83.7-151.3-186.4-151.3s-186.4 67.9-186.4 151.3c0 74.7 66.3 137.4 155.9 149.3c21.8 4.7 19.3 12.7 14.4 42.1c-.8 4.7-3.8 18.4 16.1 10.1s107.3-63.2 146.5-108.2c27-29.7 39.9-59.8 39.9-93.1z"
    ]
};
var $42f4e3f18906b0d1$export$631c05505a17faa8 = {
    prefix: "fab",
    iconName: "google-drive",
    icon: [
        512,
        512,
        [],
        "f3aa",
        "M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"
    ]
};
var $42f4e3f18906b0d1$export$c2417738aeefe7e6 = {
    prefix: "fab",
    iconName: "servicestack",
    icon: [
        496,
        512,
        [],
        "f3ec",
        "M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"
    ]
};
var $42f4e3f18906b0d1$export$8b48c2e6e01a12e0 = {
    prefix: "fab",
    iconName: "simplybuilt",
    icon: [
        512,
        512,
        [],
        "f215",
        "M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"
    ]
};
var $42f4e3f18906b0d1$export$de75f8fcf71dfed9 = {
    prefix: "fab",
    iconName: "bitbucket",
    icon: [
        512,
        512,
        [
            61810
        ],
        "f171",
        "M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"
    ]
};
var $42f4e3f18906b0d1$export$c85bcd118a7a17ff = {
    prefix: "fab",
    iconName: "imdb",
    icon: [
        448,
        512,
        [],
        "f2d8",
        "M89.5 323.6H53.93V186.2H89.5V323.6zM156.1 250.5L165.2 186.2H211.5V323.6H180.5V230.9L167.1 323.6H145.8L132.8 232.9L132.7 323.6H101.5V186.2H147.6C148.1 194.5 150.4 204.3 151.9 215.6L156.1 250.5zM223.7 323.6V186.2H250.3C267.3 186.2 277.3 187.1 283.3 188.6C289.4 190.3 294 192.8 297.2 196.5C300.3 199.8 302.3 203.1 303 208.5C303.9 212.9 304.4 221.6 304.4 234.7V282.9C304.4 295.2 303.7 303.4 302.5 307.6C301.4 311.7 299.4 315 296.5 317.3C293.7 319.7 290.1 321.4 285.8 322.3C281.6 323.1 275.2 323.6 266.7 323.6H223.7zM259.2 209.7V299.1C264.3 299.1 267.5 298.1 268.6 296.8C269.7 294.8 270.4 289.2 270.4 280.1V226.8C270.4 220.6 270.3 216.6 269.7 214.8C269.4 213 268.5 211.8 267.1 210.1C265.7 210.1 263 209.7 259.2 209.7V209.7zM316.5 323.6V186.2H350.6V230.1C353.5 227.7 356.7 225.2 360.1 223.5C363.7 222 368.9 221.1 372.9 221.1C377.7 221.1 381.8 221.9 385.2 223.3C388.6 224.8 391.2 226.8 393.2 229.5C394.9 232.1 395.9 234.8 396.3 237.3C396.7 239.9 396.1 245.3 396.1 253.5V292.1C396.1 300.3 396.3 306.4 395.3 310.5C394.2 314.5 391.5 318.1 387.5 320.1C383.4 324 378.6 325.4 372.9 325.4C368.9 325.4 363.7 324.5 360.2 322.9C356.7 321.1 353.5 318.4 350.6 314.9L348.5 323.6L316.5 323.6zM361.6 302.9C362.3 301.1 362.6 296.9 362.6 290.4V255C362.6 249.4 362.3 245.5 361.5 243.8C360.8 241.9 357.8 241.1 355.7 241.1C353.7 241.1 352.3 241.9 351.6 243.4C351 244.9 350.6 248.8 350.6 255V291.4C350.6 297.5 351 301.4 351.8 303C352.4 304.7 353.9 305.5 355.9 305.5C358.1 305.5 360.1 304.7 361.6 302.9L361.6 302.9zM418.4 32.04C434.1 33.27 447.1 47.28 447.1 63.92V448.1C447.1 464.5 435.2 478.5 418.9 479.1C418.6 479.1 418.4 480 418.1 480H29.88C29.6 480 29.32 479.1 29.04 479.9C13.31 478.5 1.093 466.1 0 449.7L.0186 61.78C1.081 45.88 13.82 33.09 30.26 31.1H417.7C417.9 31.1 418.2 32.01 418.4 32.04L418.4 32.04zM30.27 41.26C19 42.01 10.02 51.01 9.257 62.4V449.7C9.63 455.1 11.91 460.2 15.7 464C19.48 467.9 24.51 470.3 29.89 470.7H418.1C429.6 469.7 438.7 459.1 438.7 448.1V63.91C438.7 58.17 436.6 52.65 432.7 48.45C428.8 44.24 423.4 41.67 417.7 41.26L30.27 41.26z"
    ]
};
var $42f4e3f18906b0d1$export$17ab471305a2654c = {
    prefix: "fab",
    iconName: "deezer",
    icon: [
        576,
        512,
        [],
        "e077",
        "M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"
    ]
};
var $42f4e3f18906b0d1$export$910e018904f54b08 = {
    prefix: "fab",
    iconName: "raspberry-pi",
    icon: [
        407,
        512,
        [],
        "f7bb",
        "M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"
    ]
};
var $42f4e3f18906b0d1$export$78c2aea9064d90bd = {
    prefix: "fab",
    iconName: "jira",
    icon: [
        496,
        512,
        [],
        "f7b1",
        "M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"
    ]
};
var $42f4e3f18906b0d1$export$b29e4ebead927988 = {
    prefix: "fab",
    iconName: "docker",
    icon: [
        640,
        512,
        [],
        "f395",
        "M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"
    ]
};
var $42f4e3f18906b0d1$export$63c4c3c3c5975c3e = {
    prefix: "fab",
    iconName: "screenpal",
    icon: [
        512,
        512,
        [],
        "e570",
        "M233.5 22.49C233.5 10.07 243.6 0 256 0C268.4 0 278.5 10.07 278.5 22.49C278.5 34.91 268.4 44.98 256 44.98C243.6 44.98 233.5 34.91 233.5 22.49zM313.4 259C313.4 290.7 287.7 316.4 256 316.4C224.3 316.4 198.6 290.7 198.6 259C198.6 227.3 224.3 201.6 256 201.6C287.7 201.6 313.4 227.3 313.4 259zM337.2 350C359.5 330.1 373.7 302.7 377.1 273H496.6C493.1 334.4 466.2 392.2 421.4 434.4C376.7 476.6 317.5 500.2 256 500.2C194.5 500.2 135.3 476.6 90.56 434.4C45.83 392.2 18.94 334.4 15.39 273H135.1C138.5 302.7 152.7 330.1 175 350C197.3 369.9 226.2 380.9 256.1 380.9C285.1 380.9 314.8 369.9 337.2 350zM73.14 140.3C73.54 152.7 63.81 163.1 51.39 163.5C38.97 163.9 28.59 154.2 28.18 141.8C27.78 129.3 37.52 118.9 49.94 118.5C62.35 118.1 72.74 127.9 73.14 140.3zM438.9 141C438.9 128.6 448.9 118.5 461.4 118.5C473.8 118.5 483.8 128.6 483.8 141C483.8 153.5 473.8 163.5 461.4 163.5C448.9 163.5 438.9 153.5 438.9 141zM317.9 95.27C300.6 109.1 278.7 118.1 256 118.1C233.3 118.1 211.4 109.1 194.1 95.27C176.8 80.55 165.3 60.18 161.7 37.78C176.8 31.37 192.5 26.52 208.6 23.31C208.6 35.88 213.6 47.93 222.5 56.82C231.4 65.7 243.4 70.7 256 70.7C268.6 70.7 280.6 65.7 289.5 56.82C298.4 47.93 303.4 35.88 303.4 23.31C319.5 26.52 335.2 31.37 350.3 37.78C346.7 60.18 335.2 80.55 317.9 95.27H317.9zM82.78 231C61.42 238.6 38.06 238.4 16.86 230.4C18.82 214.1 22.46 198.1 27.71 182.5C33.1 185.6 39.05 187.6 45.22 188.5C51.39 189.3 57.67 188.9 63.68 187.3C69.69 185.6 75.33 182.9 80.27 179.1C85.21 175.3 89.36 170.6 92.47 165.2C95.58 159.8 97.61 153.8 98.42 147.7C99.23 141.5 98.83 135.2 97.22 129.2C95.61 123.2 92.83 117.6 89.04 112.6C85.25 107.7 80.53 103.5 75.14 100.4C85.96 88.11 98.01 76.94 111.1 67.07C128.7 81.42 140.6 101.6 144.7 123.9C148.8 146.2 144.8 169.3 133.5 188.9C122.1 208.5 104.1 223.4 82.78 231V231zM429.2 231.1C407.9 223.5 389.9 208.5 378.5 188.9C367.2 169.3 363.3 146.2 367.4 123.9C371.5 101.7 383.4 81.54 400.9 67.19C414 77.04 426.1 88.21 436.9 100.5C426.2 106.9 418.5 117.2 415.4 129.3C412.2 141.3 413.1 154.1 420.2 164.9C426.4 175.7 436.6 183.6 448.6 186.9C460.6 190.2 473.5 188.6 484.3 182.6C489.6 198.1 493.2 214.2 495.2 230.4C473.1 238.5 450.6 238.7 429.2 231.1L429.2 231.1z"
    ]
};
var $42f4e3f18906b0d1$export$f77d9ddfdff1e2a7 = {
    prefix: "fab",
    iconName: "bluetooth",
    icon: [
        448,
        512,
        [],
        "f293",
        "M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"
    ]
};
var $42f4e3f18906b0d1$export$56aff378d7858517 = {
    prefix: "fab",
    iconName: "gitter",
    icon: [
        384,
        512,
        [],
        "f426",
        "M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"
    ]
};
var $42f4e3f18906b0d1$export$8fb5b89b3d7583de = {
    prefix: "fab",
    iconName: "d-and-d",
    icon: [
        576,
        512,
        [],
        "f38d",
        "M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"
    ]
};
var $42f4e3f18906b0d1$export$d5808a1a9747be4c = {
    prefix: "fab",
    iconName: "microblog",
    icon: [
        448,
        512,
        [],
        "e01a",
        "M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"
    ]
};
var $42f4e3f18906b0d1$export$e24e559a44f492e1 = {
    prefix: "fab",
    iconName: "cc-diners-club",
    icon: [
        576,
        512,
        [],
        "f24c",
        "M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"
    ]
};
var $42f4e3f18906b0d1$export$6d2eed3a88c7ed1a = {
    prefix: "fab",
    iconName: "gg-circle",
    icon: [
        512,
        512,
        [],
        "f261",
        "M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"
    ]
};
var $42f4e3f18906b0d1$export$238a02799aabf743 = {
    prefix: "fab",
    iconName: "pied-piper-hat",
    icon: [
        640,
        512,
        [],
        "f4e5",
        "M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"
    ]
};
var $42f4e3f18906b0d1$export$36ebae5de28f5e9e = {
    prefix: "fab",
    iconName: "kickstarter-k",
    icon: [
        384,
        512,
        [],
        "f3bc",
        "M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185v-70.6z"
    ]
};
var $42f4e3f18906b0d1$export$d51f17330f9046ea = {
    prefix: "fab",
    iconName: "yandex",
    icon: [
        256,
        512,
        [],
        "f413",
        "M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"
    ]
};
var $42f4e3f18906b0d1$export$7dcb0372cc290c0e = {
    prefix: "fab",
    iconName: "readme",
    icon: [
        576,
        512,
        [],
        "f4d5",
        "M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"
    ]
};
var $42f4e3f18906b0d1$export$d1a4948b9a07ae7c = {
    prefix: "fab",
    iconName: "html5",
    icon: [
        384,
        512,
        [],
        "f13b",
        "M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"
    ]
};
var $42f4e3f18906b0d1$export$cb60511a0f837c82 = {
    prefix: "fab",
    iconName: "sellsy",
    icon: [
        640,
        512,
        [],
        "f213",
        "M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"
    ]
};
var $42f4e3f18906b0d1$export$5afc94dc87b38719 = {
    prefix: "fab",
    iconName: "sass",
    icon: [
        640,
        512,
        [],
        "f41e",
        "M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"
    ]
};
var $42f4e3f18906b0d1$export$304e26e1efc5b1a4 = {
    prefix: "fab",
    iconName: "wirsindhandwerk",
    icon: [
        512,
        512,
        [
            "wsh"
        ],
        "e2d0",
        "M50.77161,479.81213h83.36071V367.84741l-83.36071,47.009Zm329.04675,0h82.35022V414.85645l-82.35022-47.009Zm.00568-448V251.568L256.1759,179.1861,134.50378,251.568V31.81213H50.77161V392.60565L256.1759,270.31909,462.16858,392.60565V31.81213Z"
    ]
};
var $42f4e3f18906b0d1$export$c6d19319c89c1ce4 = $42f4e3f18906b0d1$export$304e26e1efc5b1a4;
var $42f4e3f18906b0d1$export$25d99c8ee7e610e5 = {
    prefix: "fab",
    iconName: "buromobelexperte",
    icon: [
        448,
        512,
        [],
        "f37f",
        "M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"
    ]
};
var $42f4e3f18906b0d1$export$fb5e089c1f25c80c = {
    prefix: "fab",
    iconName: "salesforce",
    icon: [
        640,
        512,
        [],
        "f83b",
        "M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"
    ]
};
var $42f4e3f18906b0d1$export$4a726382b32e57cc = {
    prefix: "fab",
    iconName: "octopus-deploy",
    icon: [
        512,
        512,
        [],
        "e082",
        "M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"
    ]
};
var $42f4e3f18906b0d1$export$86efffc3e85d2a9 = {
    prefix: "fab",
    iconName: "medapps",
    icon: [
        320,
        512,
        [],
        "f3c6",
        "M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"
    ]
};
var $42f4e3f18906b0d1$export$ffa3f5d32fe6bc0e = {
    prefix: "fab",
    iconName: "ns8",
    icon: [
        640,
        512,
        [],
        "f3d5",
        "M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"
    ]
};
var $42f4e3f18906b0d1$export$e1681fe8211dd475 = {
    prefix: "fab",
    iconName: "pinterest-p",
    icon: [
        384,
        512,
        [],
        "f231",
        "M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"
    ]
};
var $42f4e3f18906b0d1$export$aa79881dfcf87a16 = {
    prefix: "fab",
    iconName: "apper",
    icon: [
        640,
        512,
        [],
        "f371",
        "M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"
    ]
};
var $42f4e3f18906b0d1$export$c2ee281dce8eb9d5 = {
    prefix: "fab",
    iconName: "fort-awesome",
    icon: [
        512,
        512,
        [],
        "f286",
        "M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"
    ]
};
var $42f4e3f18906b0d1$export$8d560f87da34bcc1 = {
    prefix: "fab",
    iconName: "waze",
    icon: [
        512,
        512,
        [],
        "f83f",
        "M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"
    ]
};
var $42f4e3f18906b0d1$export$4f0eff72b7493340 = {
    prefix: "fab",
    iconName: "cc-jcb",
    icon: [
        576,
        512,
        [],
        "f24b",
        "M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"
    ]
};
var $42f4e3f18906b0d1$export$3770724b51125ef1 = {
    prefix: "fab",
    iconName: "snapchat",
    icon: [
        512,
        512,
        [
            62124,
            "snapchat-ghost"
        ],
        "f2ab",
        "M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"
    ]
};
var $42f4e3f18906b0d1$export$e6e855f745e10958 = $42f4e3f18906b0d1$export$3770724b51125ef1;
var $42f4e3f18906b0d1$export$318074701514e1 = {
    prefix: "fab",
    iconName: "fantasy-flight-games",
    icon: [
        512,
        512,
        [],
        "f6dc",
        "M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"
    ]
};
var $42f4e3f18906b0d1$export$8a8ef141dcbeda7b = {
    prefix: "fab",
    iconName: "rust",
    icon: [
        512,
        512,
        [],
        "e07a",
        "M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"
    ]
};
var $42f4e3f18906b0d1$export$423f2efa0d73b5f9 = {
    prefix: "fab",
    iconName: "wix",
    icon: [
        640,
        512,
        [],
        "f5cf",
        "M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"
    ]
};
var $42f4e3f18906b0d1$export$3a09eb8c07c8379f = {
    prefix: "fab",
    iconName: "square-behance",
    icon: [
        448,
        512,
        [
            "behance-square"
        ],
        "f1b5",
        "M155.3 318.4c17.2 0 31.2-6.1 31.2-25.4c0-19.7-11.7-27.4-30.3-27.5h-46v52.9h45.1zm-5.4-129.6H110.3v44.8H153c15.1 0 25.8-6.6 25.8-22.9c0-17.7-13.7-21.9-28.9-21.9zm129.5 74.8h62.2c-1.7-18.5-11.3-29.7-30.5-29.7c-18.3 0-30.5 11.4-31.7 29.7zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM349.5 185H271.7V166.1h77.8V185zM193.7 243.7c23.6 6.7 35 27.5 35 51.6c0 39-32.7 55.7-67.6 55.9H68v-192h90.5c32.9 0 61.4 9.3 61.4 47.5c0 19.3-9 28.8-26.2 37zm118.7-38.6c43.5 0 67.6 34.3 67.6 75.4c0 1.6-.1 3.3-.2 5c0 .8-.1 1.5-.1 2.2H279.5c0 22.2 11.7 35.3 34.1 35.3c11.6 0 26.5-6.2 30.2-18.1h33.7c-10.4 31.9-31.9 46.8-65.1 46.8c-43.8 0-71.1-29.7-71.1-73c0-41.8 28.7-73.6 71.1-73.6z"
    ]
};
var $42f4e3f18906b0d1$export$bb4b7fb598656746 = $42f4e3f18906b0d1$export$3a09eb8c07c8379f;
var $42f4e3f18906b0d1$export$9be373796460fb80 = {
    prefix: "fab",
    iconName: "supple",
    icon: [
        640,
        512,
        [],
        "f3f9",
        "M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"
    ]
};
var $42f4e3f18906b0d1$export$b4c5293ffb331d6a = {
    prefix: "fab",
    iconName: "webflow",
    icon: [
        640,
        512,
        [],
        "e65c",
        "M640 64L435.8 463.2H244l85.5-165.5h-3.8C255.1 389.3 149.9 449.5 0 463.2V300.1s95.9-5.7 152.3-64.9H0V64H171.1V204.8l3.8 0L244.9 64H374.3V203.9l3.8 0L450.7 64H640z"
    ]
};
var $42f4e3f18906b0d1$export$50bb8725ea3b3e34 = {
    prefix: "fab",
    iconName: "rebel",
    icon: [
        512,
        512,
        [],
        "f1d0",
        "M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"
    ]
};
var $42f4e3f18906b0d1$export$f32e22910f9b44 = {
    prefix: "fab",
    iconName: "css3",
    icon: [
        512,
        512,
        [],
        "f13c",
        "M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"
    ]
};
var $42f4e3f18906b0d1$export$ffbc7f79ed77f082 = {
    prefix: "fab",
    iconName: "staylinked",
    icon: [
        440,
        512,
        [],
        "f3f5",
        "M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"
    ]
};
var $42f4e3f18906b0d1$export$a03842279a704aae = {
    prefix: "fab",
    iconName: "kaggle",
    icon: [
        320,
        512,
        [],
        "f5fa",
        "M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"
    ]
};
var $42f4e3f18906b0d1$export$1aecd37105f38798 = {
    prefix: "fab",
    iconName: "space-awesome",
    icon: [
        512,
        512,
        [],
        "e5ac",
        "M96 256H128V512H0V352H32V320H64V288H96V256zM512 352V512H384V256H416V288H448V320H480V352H512zM320 64H352V448H320V416H192V448H160V64H192V32H224V0H288V32H320V64zM288 128H224V192H288V128z"
    ]
};
var $42f4e3f18906b0d1$export$36a61c57a904744e = {
    prefix: "fab",
    iconName: "deviantart",
    icon: [
        320,
        512,
        [],
        "f1bd",
        "M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"
    ]
};
var $42f4e3f18906b0d1$export$4b1cbad29e4915c6 = {
    prefix: "fab",
    iconName: "cpanel",
    icon: [
        640,
        512,
        [],
        "f388",
        "M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"
    ]
};
var $42f4e3f18906b0d1$export$659cd0fc2157d001 = {
    prefix: "fab",
    iconName: "goodreads-g",
    icon: [
        384,
        512,
        [],
        "f3a9",
        "M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"
    ]
};
var $42f4e3f18906b0d1$export$ccce513bbd3bef1d = {
    prefix: "fab",
    iconName: "square-git",
    icon: [
        448,
        512,
        [
            "git-square"
        ],
        "f1d2",
        "M120.8 335.5c-5.9-.4-12.6-.8-20.2-1.3c-3.3 4.1-6.6 8.4-6.6 13.5c0 18.5 65.5 18.5 65.5-1.5c0-8.3-7.4-8.7-38.8-10.7zm7.8-117.9c-32.3 0-33.7 44.5-.7 44.5c32.5 0 31.7-44.5 .7-44.5zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM243.9 172.2c-14.5 0-22.9-8.4-22.9-22.9c0-14.5 8.4-22.3 22.9-22.3c14.7 0 23.1 7.8 23.1 22.3s-8.4 22.9-23.1 22.9zM149.6 195h49.5l0 21.6-23.4 1.8c4.6 5.8 9.4 14 9.4 25.7c0 48.7-57.2 47.2-74.2 42.4l-8.4 13.4c5 .3 9.8 .6 14.3 .8c56.3 3.2 80.5 4.6 80.5 38.5c0 29.2-25.7 45.7-69.9 45.7c-46 0-63.5-11.6-63.5-31.7c0-11.4 5.1-17.5 14-25.9c-8.4-3.5-11.2-9.9-11.2-16.8c0-9.6 7.4-16.3 23-30.6l.2-.2c-12.4-6.1-21.8-19.3-21.8-38.1c0-51.6 56.6-53.3 81.6-46.8zM270.5 303.1l13 1.8 0 20.1H211.1V304.9c2.7-.4 5-.7 6.9-.9c9.9-1.2 10.1-1.3 10.1-6V223.3c0-4.4-.9-4.7-10.1-7.8c-1.9-.7-4.2-1.4-6.9-2.4l2.8-20.6h52.6V298c0 4.1 .2 4.6 4.1 5.1zm106.6-10.4L384 315c-10.9 5.4-26.9 10.2-41.4 10.2c-30.2 0-41.7-12.2-41.7-40.9V217.7c0-.8 0-1.4-.2-1.8c-.8-1.2-4.2-.7-19.6-.7V192.6c22.3-2.5 31.2-13.7 34-41.4h24.2c0 33.3-.6 38 .7 38.6c.3 .1 .7 0 1.3 0h35.8v25.4H339.3v60.7c0 .2 0 .5 0 .9c-.2 6.3-.9 30.4 37.9 15.9z"
    ]
};
var $42f4e3f18906b0d1$export$545247d36a0c2435 = $42f4e3f18906b0d1$export$ccce513bbd3bef1d;
var $42f4e3f18906b0d1$export$b22e93e631701aa0 = {
    prefix: "fab",
    iconName: "square-tumblr",
    icon: [
        448,
        512,
        [
            "tumblr-square"
        ],
        "f174",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM256.8 416c-75.5 0-91.9-55.5-91.9-87.9v-90H135.2c-3.4 0-6.2-2.8-6.2-6.2V189.4c0-4.5 2.8-8.5 7.1-10c38.8-13.7 50.9-47.5 52.7-73.2c.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2H249.1V321c0 21.4 14.8 33.5 42.5 22.4c3-1.2 5.6-2 8-1.4c2.2 .5 3.6 2.1 4.6 4.9L318 387.1c1 3.2 2 6.7-.3 9.1c-8.5 9.1-31.2 19.8-60.9 19.8z"
    ]
};
var $42f4e3f18906b0d1$export$b3979340ece626fe = $42f4e3f18906b0d1$export$b22e93e631701aa0;
var $42f4e3f18906b0d1$export$33a1efa865dd0849 = {
    prefix: "fab",
    iconName: "trello",
    icon: [
        448,
        512,
        [],
        "f181",
        "M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"
    ]
};
var $42f4e3f18906b0d1$export$e119d42c61b568e2 = {
    prefix: "fab",
    iconName: "creative-commons-nc-jp",
    icon: [
        496,
        512,
        [],
        "f4ea",
        "M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"
    ]
};
var $42f4e3f18906b0d1$export$17e9384897437d5a = {
    prefix: "fab",
    iconName: "get-pocket",
    icon: [
        448,
        512,
        [],
        "f265",
        "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"
    ]
};
var $42f4e3f18906b0d1$export$53e7f606db333d60 = {
    prefix: "fab",
    iconName: "perbyte",
    icon: [
        448,
        512,
        [],
        "e083",
        "M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"
    ]
};
var $42f4e3f18906b0d1$export$b84863db58925c09 = {
    prefix: "fab",
    iconName: "grunt",
    icon: [
        384,
        512,
        [],
        "f3ad",
        "M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"
    ]
};
var $42f4e3f18906b0d1$export$33e64266c9adb232 = {
    prefix: "fab",
    iconName: "weebly",
    icon: [
        512,
        512,
        [],
        "f5cc",
        "M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"
    ]
};
var $42f4e3f18906b0d1$export$38091cf7f8c68318 = {
    prefix: "fab",
    iconName: "connectdevelop",
    icon: [
        576,
        512,
        [],
        "f20e",
        "M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"
    ]
};
var $42f4e3f18906b0d1$export$c6c358b395e9032d = {
    prefix: "fab",
    iconName: "leanpub",
    icon: [
        576,
        512,
        [],
        "f212",
        "M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"
    ]
};
var $42f4e3f18906b0d1$export$161a3454c1d6abdb = {
    prefix: "fab",
    iconName: "black-tie",
    icon: [
        448,
        512,
        [],
        "f27e",
        "M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"
    ]
};
var $42f4e3f18906b0d1$export$ec9cce37001091c7 = {
    prefix: "fab",
    iconName: "themeco",
    icon: [
        448,
        512,
        [],
        "f5c6",
        "M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"
    ]
};
var $42f4e3f18906b0d1$export$15d5df18b87754e3 = {
    prefix: "fab",
    iconName: "python",
    icon: [
        448,
        512,
        [],
        "f3e2",
        "M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"
    ]
};
var $42f4e3f18906b0d1$export$d3988148e7ca3c41 = {
    prefix: "fab",
    iconName: "android",
    icon: [
        576,
        512,
        [],
        "f17b",
        "M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"
    ]
};
var $42f4e3f18906b0d1$export$d367d9d00bf47408 = {
    prefix: "fab",
    iconName: "bots",
    icon: [
        640,
        512,
        [],
        "e340",
        "M86.344,197.834a51.767,51.767,0,0,0-41.57,20.058V156.018a8.19,8.19,0,0,0-8.19-8.19H8.19A8.19,8.19,0,0,0,0,156.018V333.551a8.189,8.189,0,0,0,8.19,8.189H36.584a8.189,8.189,0,0,0,8.19-8.189v-8.088c11.628,13.373,25.874,19.769,41.573,19.769,34.6,0,61.922-26.164,61.922-73.843C148.266,225.452,121.229,197.834,86.344,197.834ZM71.516,305.691c-9.593,0-21.221-4.942-26.745-12.5V250.164c5.528-7.558,17.152-12.791,26.745-12.791,17.734,0,31.107,13.082,31.107,34.013C102.623,292.609,89.25,305.691,71.516,305.691Zm156.372-59.032a17.4,17.4,0,1,0,17.4,17.4A17.4,17.4,0,0,0,227.888,246.659ZM273.956,156.7V112.039a13.308,13.308,0,1,0-10.237,0V156.7a107.49,107.49,0,1,0,10.237,0Zm85.993,107.367c0,30.531-40.792,55.281-91.112,55.281s-91.111-24.75-91.111-55.281,40.792-55.281,91.111-55.281S359.949,233.532,359.949,264.062Zm-50.163,17.4a17.4,17.4,0,1,0-17.4-17.4h0A17.4,17.4,0,0,0,309.786,281.466ZM580.7,250.455c-14.828-2.617-22.387-3.78-22.387-9.885,0-5.523,7.268-9.884,17.735-9.884a65.56,65.56,0,0,1,34.484,10.1,8.171,8.171,0,0,0,11.288-2.468c.07-.11.138-.221.2-.333l8.611-14.886a8.2,8.2,0,0,0-2.867-11.123,99.863,99.863,0,0,0-52.014-14.138c-38.956,0-60.179,21.514-60.179,46.225,0,36.342,33.725,41.864,57.563,45.642,13.373,2.326,24.13,4.361,24.13,11.048,0,6.4-5.523,10.757-18.9,10.757-13.552,0-30.994-6.222-42.623-13.579a8.206,8.206,0,0,0-11.335,2.491c-.035.054-.069.108-.1.164l-10.2,16.891a8.222,8.222,0,0,0,2.491,11.066c15.224,10.3,37.663,16.692,59.441,16.692,40.409,0,63.957-19.769,63.957-46.515C640,260.63,604.537,254.816,580.7,250.455Zm-95.928,60.787a8.211,8.211,0,0,0-9.521-5.938,23.168,23.168,0,0,1-4.155.387c-7.849,0-12.5-6.106-12.5-14.245V240.28h20.349a8.143,8.143,0,0,0,8.141-8.143V209.466a8.143,8.143,0,0,0-8.141-8.143H458.594V171.091a8.143,8.143,0,0,0-8.143-8.143H422.257a8.143,8.143,0,0,0-8.143,8.143h0v30.232H399a8.143,8.143,0,0,0-8.143,8.143h0v22.671A8.143,8.143,0,0,0,399,240.28h15.115v63.667c0,27.037,15.408,41.282,43.9,41.282,12.183,0,21.383-2.2,27.6-5.446a8.161,8.161,0,0,0,4.145-9.278Z"
    ]
};
var $42f4e3f18906b0d1$export$8190ad5ab3a607e2 = {
    prefix: "fab",
    iconName: "free-code-camp",
    icon: [
        576,
        512,
        [],
        "f2c5",
        "M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"
    ]
};
var $42f4e3f18906b0d1$export$906602f6a1e50bdd = {
    prefix: "fab",
    iconName: "hornbill",
    icon: [
        512,
        512,
        [],
        "f592",
        "M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"
    ]
};
var $42f4e3f18906b0d1$export$530d32089c3347d5 = {
    prefix: "fab",
    iconName: "js",
    icon: [
        448,
        512,
        [],
        "f3b8",
        "M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
    ]
};
var $42f4e3f18906b0d1$export$4ee0aea9bb537f01 = {
    prefix: "fab",
    iconName: "ideal",
    icon: [
        576,
        512,
        [],
        "e013",
        "M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"
    ]
};
var $42f4e3f18906b0d1$export$61f81190d1a8b4b = {
    prefix: "fab",
    iconName: "git",
    icon: [
        512,
        512,
        [],
        "f1d3",
        "M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"
    ]
};
var $42f4e3f18906b0d1$export$dad56877d4f4a953 = {
    prefix: "fab",
    iconName: "dev",
    icon: [
        448,
        512,
        [],
        "f6cc",
        "M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"
    ]
};
var $42f4e3f18906b0d1$export$e999ee7aa7883e37 = {
    prefix: "fab",
    iconName: "sketch",
    icon: [
        512,
        512,
        [],
        "f7c6",
        "M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"
    ]
};
var $42f4e3f18906b0d1$export$6bf616a61d0b7bf3 = {
    prefix: "fab",
    iconName: "yandex-international",
    icon: [
        320,
        512,
        [],
        "f414",
        "M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"
    ]
};
var $42f4e3f18906b0d1$export$2bcb24672b4bf6e6 = {
    prefix: "fab",
    iconName: "cc-amex",
    icon: [
        576,
        512,
        [],
        "f1f3",
        "M0 432c0 26.5 21.5 48 48 48H528c26.5 0 48-21.5 48-48v-1.1H514.3l-31.9-35.1-31.9 35.1H246.8V267.1H181L262.7 82.4h78.6l28.1 63.2V82.4h97.2L483.5 130l17-47.6H576V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80V432zm440.4-21.7L482.6 364l42 46.3H576l-68-72.1 68-72.1H525.4l-42 46.7-41.5-46.7H390.5L458 338.6l-67.4 71.6V377.1h-83V354.9h80.9V322.6H307.6V300.2h83V267.1h-122V410.3H440.4zm96.3-72L576 380.2V296.9l-39.3 41.4zm-36.3-92l36.9-100.6V246.3H576V103H515.8l-32.2 89.3L451.7 103H390.5V246.1L327.3 103H276.1L213.7 246.3h43l11.9-28.7h65.9l12 28.7h82.7V146L466 246.3h34.4zM282 185.4l19.5-46.9 19.4 46.9H282z"
    ]
};
var $42f4e3f18906b0d1$export$2b557426f8d6820b = {
    prefix: "fab",
    iconName: "uber",
    icon: [
        448,
        512,
        [],
        "f402",
        "M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"
    ]
};
var $42f4e3f18906b0d1$export$64e4bc4b496fbbdf = {
    prefix: "fab",
    iconName: "github",
    icon: [
        496,
        512,
        [],
        "f09b",
        "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
    ]
};
var $42f4e3f18906b0d1$export$e1ae2a8de48825fb = {
    prefix: "fab",
    iconName: "php",
    icon: [
        640,
        512,
        [],
        "f457",
        "M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"
    ]
};
var $42f4e3f18906b0d1$export$994c329bc073af57 = {
    prefix: "fab",
    iconName: "alipay",
    icon: [
        448,
        512,
        [],
        "f642",
        "M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"
    ]
};
var $42f4e3f18906b0d1$export$2373b132177332f8 = {
    prefix: "fab",
    iconName: "youtube",
    icon: [
        576,
        512,
        [
            61802
        ],
        "f167",
        "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
    ]
};
var $42f4e3f18906b0d1$export$b2254aecfa43ac3e = {
    prefix: "fab",
    iconName: "skyatlas",
    icon: [
        640,
        512,
        [],
        "f216",
        "M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"
    ]
};
var $42f4e3f18906b0d1$export$db16178b6453c842 = {
    prefix: "fab",
    iconName: "firefox-browser",
    icon: [
        512,
        512,
        [],
        "e007",
        "M130.22 127.548C130.38 127.558 130.3 127.558 130.22 127.548V127.548ZM481.64 172.898C471.03 147.398 449.56 119.898 432.7 111.168C446.42 138.058 454.37 165.048 457.4 185.168C457.405 185.306 457.422 185.443 457.45 185.578C429.87 116.828 383.098 89.1089 344.9 28.7479C329.908 5.05792 333.976 3.51792 331.82 4.08792L331.7 4.15792C284.99 30.1109 256.365 82.5289 249.12 126.898C232.503 127.771 216.219 131.895 201.19 139.035C199.838 139.649 198.736 140.706 198.066 142.031C197.396 143.356 197.199 144.87 197.506 146.323C197.7 147.162 198.068 147.951 198.586 148.639C199.103 149.327 199.76 149.899 200.512 150.318C201.264 150.737 202.096 150.993 202.954 151.071C203.811 151.148 204.676 151.045 205.491 150.768L206.011 150.558C221.511 143.255 238.408 139.393 255.541 139.238C318.369 138.669 352.698 183.262 363.161 201.528C350.161 192.378 326.811 183.338 304.341 187.248C392.081 231.108 368.541 381.784 246.951 376.448C187.487 373.838 149.881 325.467 146.421 285.648C146.421 285.648 157.671 243.698 227.041 243.698C234.541 243.698 255.971 222.778 256.371 216.698C256.281 214.698 213.836 197.822 197.281 181.518C188.434 172.805 184.229 168.611 180.511 165.458C178.499 163.75 176.392 162.158 174.201 160.688C168.638 141.231 168.399 120.638 173.51 101.058C148.45 112.468 128.96 130.508 114.8 146.428H114.68C105.01 134.178 105.68 93.7779 106.25 85.3479C106.13 84.8179 99.022 89.0159 98.1 89.6579C89.5342 95.7103 81.5528 102.55 74.26 110.088C57.969 126.688 30.128 160.242 18.76 211.318C14.224 231.701 12 255.739 12 263.618C12 398.318 121.21 507.508 255.92 507.508C376.56 507.508 478.939 420.281 496.35 304.888C507.922 228.192 481.64 173.82 481.64 172.898Z"
    ]
};
var $42f4e3f18906b0d1$export$a51c205a2c2f1780 = {
    prefix: "fab",
    iconName: "replyd",
    icon: [
        448,
        512,
        [],
        "f3e6",
        "M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"
    ]
};
var $42f4e3f18906b0d1$export$fd2c25240484ff41 = {
    prefix: "fab",
    iconName: "suse",
    icon: [
        640,
        512,
        [],
        "f7d6",
        "M593.1 192.6A10.4 10.4 0 1 1 604.5 210a10.4 10.4 0 1 1 -11.4-17.4zm-47.1 12.2a38.5 38.5 0 1 1 75-17.6 38.5 38.5 0 1 1 -75 17.6zM433.7 336.7c3.2 4.6 5.8 9 7.3 13.4c1 3.1 2.4 7.3 5.5 8.9c.2 .1 .3 .2 .5 .2c5.7 2.1 20.3 1.7 20.3 1.7h26.8c2.3 0 22.4 0 21.9-2.3c-2.4-10.8-14.9-12.7-24.4-18.3c-8.7-5.2-17-11.1-20.8-21.3c-2-5.2-.8-17.4 2.6-21.8c2.5-3.2 6.1-5.3 10-6.2c4.3-.9 8.8-.1 13.1 .3c5.3 .5 10.6 1.5 15.9 2.2c10.3 1.3 20.6 1.9 31 1.6c17.1-.5 34.2-3.2 50.4-8.7c11.3-3.8 22.4-8.9 32-16.1c10.9-8.1 8.1-7.4-3-6.2c-13.3 1.4-26.6 1.6-39.9 .8c-12.4-.7-24.7-2.2-35.9-7.9c-8.8-4.6-16.4-9.1-23.4-16.2c-1-1.1-1.7-4.2 .2-6.2c1.9-1.9 5.8-.8 7 .2c12.2 10.2 30.5 18.6 49.3 19.5c10.2 .5 20.1 .7 30.4 .3c5.1-.2 12.8-.2 17.9-.3c2.6 0 9.8 .7 11.2-2.1c.4-.8 .4-1.8 .3-2.7c-1.5-40.9-4.5-86.9-47.3-106.5c-31.9-14.6-79.7-37.2-99.9-46.6c-4.7-2.2-10.2 1.3-10.2 6.5c0 13.6 .7 33.3 .7 51.1c-9.7-9.9-26-16.1-38.4-21.8c-14.1-6.5-28.7-12-43.5-16.6c-29.8-9.2-60.7-14.9-91.7-18c-35.2-3.5-71-1.8-105.7 5.3C147 115.1 90.8 142.6 48.2 182.7C22.1 207.3 1.6 242.4 .2 277.9c-2 50.3 12.1 77.3 38 105.2c41.3 44.4 130.2 50.6 166.2-2c16.2-23.7 19.7-55.8 8-82c-11.8-26.2-38.8-45.1-67.4-46c-22.2-.7-45.9 10.6-54.5 31.1c-6.5 15.7-2.8 35.1 9 47.3c4.6 4.8 10.9 8.7 17.7 7.1c4-.9 7.4-3.9 8-8c.9-6-4.4-9.9-7.6-14.5c-5.8-8.3-4.7-20.9 2.7-27.9c6.2-6 15.3-7.8 23.9-7.7c8 0 16.2 1.4 23.1 5.5c9.7 5.7 16.2 16.2 18.4 27.2c6.7 33-20.2 59.9-56.6 62c-18.6 1.1-37.6-3.8-52.1-15.5C40.1 329.9 31.1 269.4 73.2 237c40-30.7 90.4-22.8 120.2-6.8c23.8 12.8 41.5 33.6 55 56.7c6.7 11.6 12.5 23.7 17.8 36.1c5.1 11.8 9.9 23.8 20.2 32.5c6.8 5.8 15.2 5.6 24.1 5.6h50.8c6.9 0 5.2-4.6 2.2-7.7c-6.7-6.9-16.4-8.4-25.4-10.9c-20.5-5.6-18.4-32.8-12.7-32.8c18.3 0 18.9 .6 34.9 .3c23.2-.3 30.2-1.7 48.3 5c9.7 3.6 19 13.1 25.1 21.7z"
    ]
};
var $42f4e3f18906b0d1$export$595f8e07121dc03e = {
    prefix: "fab",
    iconName: "jenkins",
    icon: [
        512,
        512,
        [],
        "f3b6",
        "M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"
    ]
};
var $42f4e3f18906b0d1$export$ca61170983a00686 = {
    prefix: "fab",
    iconName: "twitter",
    icon: [
        512,
        512,
        [],
        "f099",
        "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
    ]
};
var $42f4e3f18906b0d1$export$b86b24e51d58f6b5 = {
    prefix: "fab",
    iconName: "rockrms",
    icon: [
        496,
        512,
        [],
        "f3e9",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"
    ]
};
var $42f4e3f18906b0d1$export$d42c613d35559431 = {
    prefix: "fab",
    iconName: "pinterest",
    icon: [
        496,
        512,
        [],
        "f0d2",
        "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"
    ]
};
var $42f4e3f18906b0d1$export$de04abdf8e0bcc15 = {
    prefix: "fab",
    iconName: "buffer",
    icon: [
        448,
        512,
        [],
        "f837",
        "M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"
    ]
};
var $42f4e3f18906b0d1$export$2002216d2d7747f0 = {
    prefix: "fab",
    iconName: "npm",
    icon: [
        576,
        512,
        [],
        "f3d4",
        "M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"
    ]
};
var $42f4e3f18906b0d1$export$a5122f6c6ec2779c = {
    prefix: "fab",
    iconName: "yammer",
    icon: [
        512,
        512,
        [],
        "f840",
        "M500.676,159.486a12.779,12.779,0,0,0-6.4-8.282,13.954,13.954,0,0,0-10.078-1.125L457.8,156.7l-.043-.2-22.3,5.785-1.243.333-.608-2.17A369.037,369.037,0,0,0,347.538,4.289a14.1,14.1,0,0,0-19.784-.463l-102.9,102.747H24.947A24.9,24.9,0,0,0,0,131.417V380.38a24.963,24.963,0,0,0,24.918,24.9H224.986L328.072,508a13.667,13.667,0,0,0,19.327,0c.126-.126.249-.255.37-.385a368.025,368.025,0,0,0,69.577-107.374,403.45,403.45,0,0,0,17.3-50.8v-.028l20.406,5.336.029-.073L483.345,362a20.253,20.253,0,0,0,2.619.5,13.359,13.359,0,0,0,4.139-.072,13.5,13.5,0,0,0,10.515-9.924,415.855,415.855,0,0,0,.058-193.013ZM337.125,24.65l.013.014h-.013Zm-110.2,165.161L174.311,281.1a11.338,11.338,0,0,0-1.489,5.655v46.189a22.04,22.04,0,0,1-22.041,22h-3.4A22.068,22.068,0,0,1,125.3,332.962V287.294a11.532,11.532,0,0,0-1.388-5.51l-51.6-92.2a21.988,21.988,0,0,1,19.264-32.726h3.268a22.059,22.059,0,0,1,19.611,11.916l36.357,70.281,37.515-70.512a22.066,22.066,0,0,1,38.556-.695,21.7,21.7,0,0,1,0,21.967ZM337.145,24.673a348.147,348.147,0,0,1,75.8,141.335l.564,1.952-114.134,29.6V131.417a25.006,25.006,0,0,0-24.947-24.9H255.067Zm60.5,367.305v-.043l-.014.014a347.19,347.19,0,0,1-60.177,95.227l-82.2-81.893h19.177a24.978,24.978,0,0,0,24.947-24.9v-66.2l114.6,29.862A385.191,385.191,0,0,1,397.648,391.978Zm84-52.45.015.014-50.618-13.131L299.379,292.1V219.572l119.746-30.99,4.468-1.157,39.54-10.253,18.511-4.816A393,393,0,0,1,481.644,339.528Z"
    ]
};
var $42f4e3f18906b0d1$export$fcf54005da871608 = {
    prefix: "fab",
    iconName: "btc",
    icon: [
        384,
        512,
        [],
        "f15a",
        "M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"
    ]
};
var $42f4e3f18906b0d1$export$657a51e82ea8ac80 = {
    prefix: "fab",
    iconName: "dribbble",
    icon: [
        512,
        512,
        [],
        "f17d",
        "M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"
    ]
};
var $42f4e3f18906b0d1$export$ef143c65b9462290 = {
    prefix: "fab",
    iconName: "stumbleupon-circle",
    icon: [
        496,
        512,
        [],
        "f1a3",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"
    ]
};
var $42f4e3f18906b0d1$export$26bd7ea5833d2643 = {
    prefix: "fab",
    iconName: "internet-explorer",
    icon: [
        512,
        512,
        [],
        "f26b",
        "M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"
    ]
};
var $42f4e3f18906b0d1$export$28d0d3c268c6e8c2 = {
    prefix: "fab",
    iconName: "stubber",
    icon: [
        448,
        512,
        [],
        "e5c7",
        "M136.5 294.2l58.8 22.9c9.1-36.8 25.4-61.1 55-61.1c49.4 0 71.4 63.6 142.4 63.6c15.6 0 35.9-2.8 55.3-13.3V368c0 61.8-50.4 112-112.3 112H0l41.8-56L0 368l41.7-56L0 256.1l41.8-56L0 144.1 41.8 88 0 32H335.7C397.6 32 448 82.3 448 144.1v51.3c-9.2 36.3-25.9 60.6-55 60.6c-49.6 0-71.6-63.5-142.4-63.5c-35.9 0-95.2 14.6-114.1 101.6h0z"
    ]
};
var $42f4e3f18906b0d1$export$b508fd54409de914 = {
    prefix: "fab",
    iconName: "telegram",
    icon: [
        496,
        512,
        [
            62462,
            "telegram-plane"
        ],
        "f2c6",
        "M248,8C111.033,8,0,119.033,0,256S111.033,504,248,504,496,392.967,496,256,384.967,8,248,8ZM362.952,176.66c-3.732,39.215-19.881,134.378-28.1,178.3-3.476,18.584-10.322,24.816-16.948,25.425-14.4,1.326-25.338-9.517-39.287-18.661-21.827-14.308-34.158-23.215-55.346-37.177-24.485-16.135-8.612-25,5.342-39.5,3.652-3.793,67.107-61.51,68.335-66.746.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.608,69.142-14.845,10.194-26.894,9.934c-8.855-.191-25.888-5.006-38.551-9.123-15.531-5.048-27.875-7.717-26.8-16.291q.84-6.7,18.45-13.7,108.446-47.248,144.628-62.3c68.872-28.647,83.183-33.623,92.511-33.789,2.052-.034,6.639.474,9.61,2.885a10.452,10.452,0,0,1,3.53,6.716A43.765,43.765,0,0,1,362.952,176.66Z"
    ]
};
var $42f4e3f18906b0d1$export$dd32dc1ad06228ec = $42f4e3f18906b0d1$export$b508fd54409de914;
var $42f4e3f18906b0d1$export$39ef7a19d18012df = {
    prefix: "fab",
    iconName: "old-republic",
    icon: [
        496,
        512,
        [],
        "f510",
        "M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"
    ]
};
var $42f4e3f18906b0d1$export$4001fe5db20c0fd2 = {
    prefix: "fab",
    iconName: "odysee",
    icon: [
        512,
        512,
        [],
        "e5c6",
        "M406.7 463c-42.3 30.8-94.4 49-150.7 49C144.9 512 50.3 441.2 14.9 342.2c2.4 1.7 5.9 3.6 7.9 4.4c16.3 7.4 40.1-5.4 62.9-28.7c6.9-6.9 14.4-12.4 22.8-17.3c18.3-11.9 37.6-20.8 58.4-27.2c0 0 22.3 34.2 43.1 74.8s-22.3 54-27.2 54c-.3 0-.8 0-1.5-.1c-11-.5-70-3-56 51.1c14.9 57.4 97.5 36.6 139.6 8.9s31.7-118.3 31.7-118.3c41.1-6.4 54 37.1 57.9 59.4c.8 4.6 1.1 9.9 1.4 15.5c1.1 21.2 2.3 45.6 35.3 46.4c5.3 0 10.6-.8 15.5-2zm-95.3-23.7c-2-.5-3.5-2.5-3-5c1-2.5 3-3.5 5-3s3.5 3 3 5s-2.5 3.5-5 3zm-207-95.6c1.5-.5 3.5 1 4 3c0 2-1 4-3 4c-1.5 .5-3.5-1-4-3c-.5-1.5 1-3.5 3-4zM451.8 421C489.3 376.4 512 318.8 512 256c0-67.5-26.1-128.9-68.8-174.7c-.1 23.5-6.1 48.2-16.8 69.2c-11.9 20.3-49 58.9-69.8 78.7c-.7 .3-1.1 .9-1.5 1.4c-.2 .2-.3 .4-.5 .6c-5 6.9-4 16.8 3 21.8c21.3 15.8 56.4 45.6 59.4 72.8c3.5 34.9 27.9 75.6 34.2 86.2l0 0c.8 1.3 1.3 2.1 1.4 2.4c0 2.2-.4 4.3-.8 6.5zM390.7 251c-.5 3 1 5.9 4 6.4s5.9-1 6.4-4s-1-5.9-4-6.4c-3-1-5.9 1-6.4 4zm61.4-60.9l-11.4 5.4-3 12.9-5.4-11.4-12.9-3 11.4-5.4 3-12.9 5.4 11.4 12.9 3zM395.5 41.3c-16.2 8.2-22.1 32.8-29 61.4l0 0c-.3 1.4-.7 2.8-1 4.2c-9.5 38.5-30.6 37.6-41.7 37.2c-1.1 0-2-.1-2.9-.1c-5.1 0-6-4-8.9-17.1c-2.6-12.1-6.9-32-17.9-63.6C271.4-2.5 211.4 13.9 165.9 41.1C110.6 74.2 131.5 143 146.1 190.5c.7 2.2 1.4 4.4 2 6.6c-4 4-13.8 7.5-26 11.9c-12.1 4.3-26.6 9.5-40.3 16.9C47.9 243.9 11.5 274.9 2 288.5C.7 277.8 0 267 0 256C0 114.6 114.6 0 256 0c51.4 0 99.4 15.2 139.5 41.3zM58.9 189.6c-1.5-2-4.5-3-6.4-1.5s-3 4.5-1.5 6.4s4.5 3 6.4 1.5c2.5-1.5 3-4.5 1.5-6.4zM327.3 64.9c2-1.5 5-.5 6.4 1.5c1.5 2.5 1 5.4-1.5 6.4c-2 1.5-5 .5-6.4-1.5s-.5-5 1.5-6.4zM95.1 105c-.5 1.5 .5 3 2 3c1.5 .5 3-.5 3-2c.5-1.5-.5-3-2-3s-3 .5-3 2zm84.7-.5c-3.5-43.1 37.1-54 37.1-54c44.1-15.4 56 5.9 66.4 37.6s3 42.6-38.6 58.9s-61.9-4.5-64.9-42.6zm89.6 14.9h1c2.5 0 5-2 5-5c2-6.9 1-14.4-2-20.8c-1.5-2-4-3.5-6.4-2.5c-3 1-4.5 4-3.5 6.9c2 4.5 3 9.9 1.5 14.9c-.5 3 1.5 5.9 4.5 6.4zm-9.9-41.6c-2 0-4-1-5-3s-2-3.5-3-5c-2-2-2-5.4 0-7.4s5.4-2 7.4 0c2 2.5 3.5 5 5 7.4s.5 5.9-2.5 7.4c-.6 0-1 .2-1.3 .3c-.2 .1-.4 .2-.6 .2z"
    ]
};
var $42f4e3f18906b0d1$export$ee0c07b824da892f = {
    prefix: "fab",
    iconName: "square-whatsapp",
    icon: [
        448,
        512,
        [
            "whatsapp-square"
        ],
        "f40c",
        "M92.1 254.6c0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6L152 365.2l4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8c0-35.2-15.2-68.3-40.1-93.2c-25-25-58-38.7-93.2-38.7c-72.7 0-131.8 59.1-131.9 131.8zM274.8 330c-12.6 1.9-22.4 .9-47.5-9.9c-36.8-15.9-61.8-51.5-66.9-58.7c-.4-.6-.7-.9-.8-1.1c-2-2.6-16.2-21.5-16.2-41c0-18.4 9-27.9 13.2-32.3c.3-.3 .5-.5 .7-.8c3.6-4 7.9-5 10.6-5c2.6 0 5.3 0 7.6 .1c.3 0 .5 0 .8 0c2.3 0 5.2 0 8.1 6.8c1.2 2.9 3 7.3 4.9 11.8c3.3 8 6.7 16.3 7.3 17.6c1 2 1.7 4.3 .3 6.9c-3.4 6.8-6.9 10.4-9.3 13c-3.1 3.2-4.5 4.7-2.3 8.6c15.3 26.3 30.6 35.4 53.9 47.1c4 2 6.3 1.7 8.6-1c2.3-2.6 9.9-11.6 12.5-15.5c2.6-4 5.3-3.3 8.9-2s23.1 10.9 27.1 12.9c.8 .4 1.5 .7 2.1 1c2.8 1.4 4.7 2.3 5.5 3.6c.9 1.9 .9 9.9-2.4 19.1c-3.3 9.3-19.1 17.7-26.7 18.8zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM148.1 393.9L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5c29.9 30 47.9 69.8 47.9 112.2c0 87.4-72.7 158.5-160.1 158.5c-26.6 0-52.7-6.7-75.8-19.3z"
    ]
};
var $42f4e3f18906b0d1$export$6fd1d044d66a938d = $42f4e3f18906b0d1$export$ee0c07b824da892f;
var $42f4e3f18906b0d1$export$ad65a356f9456393 = {
    prefix: "fab",
    iconName: "node-js",
    icon: [
        448,
        512,
        [],
        "f3d3",
        "M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"
    ]
};
var $42f4e3f18906b0d1$export$68bace18bdcdfc53 = {
    prefix: "fab",
    iconName: "edge-legacy",
    icon: [
        512,
        512,
        [],
        "e078",
        "M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"
    ]
};
var $42f4e3f18906b0d1$export$c597531345e00f14 = {
    prefix: "fab",
    iconName: "slack",
    icon: [
        448,
        512,
        [
            62447,
            "slack-hash"
        ],
        "f198",
        "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"
    ]
};
var $42f4e3f18906b0d1$export$46ef626e3b64d22 = $42f4e3f18906b0d1$export$c597531345e00f14;
var $42f4e3f18906b0d1$export$2d7cd04bce6afc11 = {
    prefix: "fab",
    iconName: "medrt",
    icon: [
        544,
        512,
        [],
        "f3c8",
        "M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"
    ]
};
var $42f4e3f18906b0d1$export$701b05aa394c8392 = {
    prefix: "fab",
    iconName: "usb",
    icon: [
        640,
        512,
        [],
        "f287",
        "M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"
    ]
};
var $42f4e3f18906b0d1$export$ae279e8a7a5b9476 = {
    prefix: "fab",
    iconName: "tumblr",
    icon: [
        320,
        512,
        [],
        "f173",
        "M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"
    ]
};
var $42f4e3f18906b0d1$export$f796d2c05c7c6dbd = {
    prefix: "fab",
    iconName: "vaadin",
    icon: [
        448,
        512,
        [],
        "f408",
        "M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"
    ]
};
var $42f4e3f18906b0d1$export$e9b10b4b8b90dca5 = {
    prefix: "fab",
    iconName: "quora",
    icon: [
        448,
        512,
        [],
        "f2c4",
        "M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"
    ]
};
var $42f4e3f18906b0d1$export$e42e88e46d22eb98 = {
    prefix: "fab",
    iconName: "square-x-twitter",
    icon: [
        448,
        512,
        [],
        "e61a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"
    ]
};
var $42f4e3f18906b0d1$export$1bc30ca2ce539d7f = {
    prefix: "fab",
    iconName: "reacteurope",
    icon: [
        576,
        512,
        [],
        "f75d",
        "M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"
    ]
};
var $42f4e3f18906b0d1$export$c1f031b95dadaa21 = {
    prefix: "fab",
    iconName: "medium",
    icon: [
        640,
        512,
        [
            62407,
            "medium-m"
        ],
        "f23a",
        "M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"
    ]
};
var $42f4e3f18906b0d1$export$a29b11db7eed2052 = $42f4e3f18906b0d1$export$c1f031b95dadaa21;
var $42f4e3f18906b0d1$export$2ffb27c42275836a = {
    prefix: "fab",
    iconName: "amilia",
    icon: [
        448,
        512,
        [],
        "f36d",
        "M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"
    ]
};
var $42f4e3f18906b0d1$export$642f133169ca9ebe = {
    prefix: "fab",
    iconName: "mixcloud",
    icon: [
        640,
        512,
        [],
        "f289",
        "M212.98 346.566H179.789V195.114L185.973 173.47H175.262L137.127 346.566H76.1069L37.7323 173.47H27.276L33.1913 195.114V346.566H0V165H65.6506L102.248 338.096H110.747L147.329 165H212.98L212.98 346.566ZM544.459 283.589L458.434 345.655V307.534L531.329 255.776L458.434 204.017V165.896L544.459 228.231H553.721L640 165.896V204.017L566.866 255.776L640 307.549V345.655L553.721 283.589H544.459ZM430.157 272.311H248.113V239.255H430.157V272.311Z"
    ]
};
var $42f4e3f18906b0d1$export$5193bd9feb923609 = {
    prefix: "fab",
    iconName: "flipboard",
    icon: [
        448,
        512,
        [],
        "f44d",
        "M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"
    ]
};
var $42f4e3f18906b0d1$export$e75485903cf50ab7 = {
    prefix: "fab",
    iconName: "viacoin",
    icon: [
        384,
        512,
        [],
        "f237",
        "M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"
    ]
};
var $42f4e3f18906b0d1$export$19d8e57a729f8d94 = {
    prefix: "fab",
    iconName: "critical-role",
    icon: [
        448,
        512,
        [],
        "f6c9",
        "M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"
    ]
};
var $42f4e3f18906b0d1$export$b431c4dc6e2095fc = {
    prefix: "fab",
    iconName: "sitrox",
    icon: [
        448,
        512,
        [],
        "e44a",
        "M212.439 0.00846128V0H448V128H64C64 57.6008 141.755 0.475338 212.439 0.00846128ZM237.256 192V192.007C307.135 192.475 384 249.6 384 320H210.809V319.995C140.915 319.563 64 262.424 64 192H237.256ZM235.565 511.993C306.251 511.521 384 454.399 384 384H0V512H235.565V511.993Z"
    ]
};
var $42f4e3f18906b0d1$export$5311546a7fb29bad = {
    prefix: "fab",
    iconName: "discourse",
    icon: [
        448,
        512,
        [],
        "f393",
        "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"
    ]
};
var $42f4e3f18906b0d1$export$4c7981055454786f = {
    prefix: "fab",
    iconName: "joomla",
    icon: [
        448,
        512,
        [],
        "f1aa",
        "M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"
    ]
};
var $42f4e3f18906b0d1$export$1dd6c03244d1cf01 = {
    prefix: "fab",
    iconName: "mastodon",
    icon: [
        448,
        512,
        [],
        "f4f6",
        "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"
    ]
};
var $42f4e3f18906b0d1$export$a8bcb0976aa786fb = {
    prefix: "fab",
    iconName: "airbnb",
    icon: [
        448,
        512,
        [],
        "f834",
        "M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"
    ]
};
var $42f4e3f18906b0d1$export$568095dca08f5ff3 = {
    prefix: "fab",
    iconName: "wolf-pack-battalion",
    icon: [
        512,
        512,
        [],
        "f514",
        "M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"
    ]
};
var $42f4e3f18906b0d1$export$e08e0c43c651f28e = {
    prefix: "fab",
    iconName: "buy-n-large",
    icon: [
        576,
        512,
        [],
        "f8a6",
        "M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"
    ]
};
var $42f4e3f18906b0d1$export$100b84dda223030b = {
    prefix: "fab",
    iconName: "gulp",
    icon: [
        256,
        512,
        [],
        "f3ae",
        "M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"
    ]
};
var $42f4e3f18906b0d1$export$f7edf083e5c27672 = {
    prefix: "fab",
    iconName: "creative-commons-sampling-plus",
    icon: [
        496,
        512,
        [],
        "f4f1",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"
    ]
};
var $42f4e3f18906b0d1$export$7ea49f2cb08b52c1 = {
    prefix: "fab",
    iconName: "strava",
    icon: [
        384,
        512,
        [],
        "f428",
        "M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"
    ]
};
var $42f4e3f18906b0d1$export$c09ea58a6f21cb3c = {
    prefix: "fab",
    iconName: "ember",
    icon: [
        640,
        512,
        [],
        "f423",
        "M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"
    ]
};
var $42f4e3f18906b0d1$export$c9a287a4ab49306f = {
    prefix: "fab",
    iconName: "canadian-maple-leaf",
    icon: [
        512,
        512,
        [],
        "f785",
        "M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"
    ]
};
var $42f4e3f18906b0d1$export$619d787387e2c15e = {
    prefix: "fab",
    iconName: "teamspeak",
    icon: [
        576,
        512,
        [],
        "f4f9",
        "M152.8 37.2c-32.2 38.1-56.1 82.6-69.9 130.5c0 .2-.1 .3-.1 .5C43.5 184.4 16 223 16 268c0 59.6 48.4 108 108 108s108-48.4 108-108c0-53.5-38.9-97.9-90-106.5c15.7-41.8 40.4-79.6 72.3-110.7c1.8-1.6 4-2.6 6.3-3.1c37.2-11.5 76.7-13.3 114.8-5.2C454.7 67.6 534 180.7 517.1 301.3c-8.4 62.6-38.6 112.7-87.7 151.4c-50.1 39.7-107.5 54.3-170.2 52.2l-24-1c12.4 2.8 25 4.9 37.6 6.3c40.7 4.2 81.4 2.1 120.1-12.5c94-35.5 149.3-102.3 162.9-202.5c4.8-52.6-5.8-105.4-30.8-152C454.6 11.3 290.8-38.4 159 32c-2.4 1.4-4.5 3.1-6.3 5.2zM309.4 433.9c-2.1 11.5-4.2 21.9-14.6 31.3c53.2-1 123.2-29.2 161.8-97.1c39.7-69.9 37.6-139.9-6.3-207.8C413.8 105 360.5 77.9 293.7 73.7c1.5 2.3 3.2 4.4 5.2 6.3l5.2 6.3c25.1 31.3 37.6 67.9 42.8 107.5c2.1 15.7-1 30.3-13.6 41.8c-4.2 3.1-5.2 6.3-4.2 10.4l7.3 17.7L365.7 318c5.2 11.5 4.2 19.8-6.3 28.2c-3.2 2.5-6.7 4.6-10.4 6.3l-18.8 8.4 3.1 13.6c3.1 6.3 1 12.5-3.1 17.7c-2.5 2.4-3.8 5.9-3.1 9.4c2.1 11.5-2.1 19.8-12.5 25.1c-2.1 1-4.2 5.2-5.2 7.3zm-133.6-3.1c16.7 11.5 34.5 20.9 53.2 26.1c24 5.2 41.8-6.3 44.9-30.3c1-8.4 5.2-14.6 12.5-17.7c7.3-4.2 8.4-7.3 2.1-13.6l-9.4-8.4 13.6-4.2c6.3-2.1 7.3-5.2 5.2-11.5c-1.4-3-2.4-6.2-3.1-9.4c-3.1-14.6-2.1-15.7 11.5-18.8c8.4-3.1 15.7-6.3 21.9-12.5c3.1-2.1 3.1-4.2 1-8.4l-16.7-30.3c-1-1.9-2.1-3.8-3.1-5.7c-6.4-11.7-13-23.6-15.7-37.1c-2.1-9.4-1-17.7 8.4-24c5.2-4.2 8.4-9.4 8.4-16.7c-.4-10.1-1.5-20.3-3.1-30.3c-6.3-37.6-23-68.9-51.2-95c-5.2-4.2-9.4-6.3-16.7-4.2L203.9 91.5c2 1.2 4 2.4 6 3.6l0 0c6.3 3.7 12.2 7.3 17 12.1c30.3 26.1 41.8 61.6 45.9 100.2c1 8.4 0 16.7-7.3 21.9c-8.4 5.2-10.4 12.5-7.3 20.9c4.9 13.2 10.4 26 16.7 38.6L291.6 318c-6.3 8.4-13.6 11.5-21.9 14.6c-12.5 3.1-14.6 7.3-10.4 20.9c.6 1.5 1.4 2.8 2.1 4.2c2.1 5.2 1 8.4-4.2 10.4l-12.5 3.1 5.2 4.2 4.2 4.2c4.2 5.2 4.2 8.4-2.1 10.4c-7.3 4.2-11.5 9.4-11.5 17.7c0 12.5-7.3 19.8-18.8 24c-3.8 1-7.6 1.5-11.5 1l-34.5-2.1z"
    ]
};
var $42f4e3f18906b0d1$export$72c88c198f2680b = {
    prefix: "fab",
    iconName: "pushed",
    icon: [
        432,
        512,
        [],
        "f3e1",
        "M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"
    ]
};
var $42f4e3f18906b0d1$export$1e35be7b9c7acc1f = {
    prefix: "fab",
    iconName: "wordpress-simple",
    icon: [
        512,
        512,
        [],
        "f411",
        "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"
    ]
};
var $42f4e3f18906b0d1$export$cb3944b58accd310 = {
    prefix: "fab",
    iconName: "nutritionix",
    icon: [
        400,
        512,
        [],
        "f3d6",
        "M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"
    ]
};
var $42f4e3f18906b0d1$export$d30ca94800bf542b = {
    prefix: "fab",
    iconName: "wodu",
    icon: [
        640,
        512,
        [],
        "e088",
        "M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"
    ]
};
var $42f4e3f18906b0d1$export$6d89c09f17c54b19 = {
    prefix: "fab",
    iconName: "google-pay",
    icon: [
        640,
        512,
        [],
        "e079",
        "M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"
    ]
};
var $42f4e3f18906b0d1$export$fd8d76c5b86b3d2b = {
    prefix: "fab",
    iconName: "intercom",
    icon: [
        448,
        512,
        [],
        "f7af",
        "M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"
    ]
};
var $42f4e3f18906b0d1$export$16e69e0d77404518 = {
    prefix: "fab",
    iconName: "zhihu",
    icon: [
        640,
        512,
        [],
        "f63f",
        "M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"
    ]
};
var $42f4e3f18906b0d1$export$80de216c9d46bac = {
    prefix: "fab",
    iconName: "korvue",
    icon: [
        446,
        512,
        [],
        "f42f",
        "M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"
    ]
};
var $42f4e3f18906b0d1$export$4fe14f0ab3be9a3 = {
    prefix: "fab",
    iconName: "pix",
    icon: [
        512,
        512,
        [],
        "e43a",
        "M242.4 292.5C247.8 287.1 257.1 287.1 262.5 292.5L339.5 369.5C353.7 383.7 372.6 391.5 392.6 391.5H407.7L310.6 488.6C280.3 518.1 231.1 518.1 200.8 488.6L103.3 391.2H112.6C132.6 391.2 151.5 383.4 165.7 369.2L242.4 292.5zM262.5 218.9C256.1 224.4 247.9 224.5 242.4 218.9L165.7 142.2C151.5 127.1 132.6 120.2 112.6 120.2H103.3L200.7 22.76C231.1-7.586 280.3-7.586 310.6 22.76L407.8 119.9H392.6C372.6 119.9 353.7 127.7 339.5 141.9L262.5 218.9zM112.6 142.7C126.4 142.7 139.1 148.3 149.7 158.1L226.4 234.8C233.6 241.1 243 245.6 252.5 245.6C261.9 245.6 271.3 241.1 278.5 234.8L355.5 157.8C365.3 148.1 378.8 142.5 392.6 142.5H430.3L488.6 200.8C518.9 231.1 518.9 280.3 488.6 310.6L430.3 368.9H392.6C378.8 368.9 365.3 363.3 355.5 353.5L278.5 276.5C264.6 262.6 240.3 262.6 226.4 276.6L149.7 353.2C139.1 363 126.4 368.6 112.6 368.6H80.78L22.76 310.6C-7.586 280.3-7.586 231.1 22.76 200.8L80.78 142.7H112.6z"
    ]
};
var $42f4e3f18906b0d1$export$c2ce1e5693cbcd01 = {
    prefix: "fab",
    iconName: "steam-symbol",
    icon: [
        448,
        512,
        [],
        "f3f6",
        "M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"
    ]
};
var $42f4e3f18906b0d1$export$3fa11687d7bc6a48 = {
    faMonero: $42f4e3f18906b0d1$export$155bdf1ceac204e7,
    faHooli: $42f4e3f18906b0d1$export$3a040ca24382cf1c,
    faYelp: $42f4e3f18906b0d1$export$2de47f03337052b6,
    faCcVisa: $42f4e3f18906b0d1$export$acc882c0b0e9e801,
    faLastfm: $42f4e3f18906b0d1$export$8226e5267dd86de3,
    faShopware: $42f4e3f18906b0d1$export$c0b2d6cff425a846,
    faCreativeCommonsNc: $42f4e3f18906b0d1$export$e36098165f3fc869,
    faAws: $42f4e3f18906b0d1$export$a4ddb2c7f767be70,
    faRedhat: $42f4e3f18906b0d1$export$d65557a7abc2c5dc,
    faYoast: $42f4e3f18906b0d1$export$73b6ef60226f6801,
    faCloudflare: $42f4e3f18906b0d1$export$7a31e37b2189232c,
    faUps: $42f4e3f18906b0d1$export$c6f6a1beb6102ac,
    faPixiv: $42f4e3f18906b0d1$export$b64ce7c5d150db12,
    faWpexplorer: $42f4e3f18906b0d1$export$9ab35a48e8f904bf,
    faDyalog: $42f4e3f18906b0d1$export$1661cbacae81932b,
    faBity: $42f4e3f18906b0d1$export$76a6a7e968d921fe,
    faStackpath: $42f4e3f18906b0d1$export$a14b012b76f98910,
    faBuysellads: $42f4e3f18906b0d1$export$6c0bc096306cebf8,
    faFirstOrder: $42f4e3f18906b0d1$export$e0a21844bf49ca8e,
    faModx: $42f4e3f18906b0d1$export$fb06254b4488a5b6,
    faGuilded: $42f4e3f18906b0d1$export$b6ff6f33a85ee805,
    faVnv: $42f4e3f18906b0d1$export$13bd8782a2ce17e7,
    faSquareJs: $42f4e3f18906b0d1$export$c989752ecb8b3fae,
    faJsSquare: $42f4e3f18906b0d1$export$d9bf3211f885d573,
    faMicrosoft: $42f4e3f18906b0d1$export$b3b8195c77f1f877,
    faQq: $42f4e3f18906b0d1$export$39d59e523abf051d,
    faOrcid: $42f4e3f18906b0d1$export$9bf8457cc97dd02e,
    faJava: $42f4e3f18906b0d1$export$25a84a6ff654acd1,
    faInvision: $42f4e3f18906b0d1$export$6e249797a4721568,
    faCreativeCommonsPdAlt: $42f4e3f18906b0d1$export$d93ab92a56e88ce6,
    faCentercode: $42f4e3f18906b0d1$export$961762d5b3aedd8d,
    faGlideG: $42f4e3f18906b0d1$export$91d5526742c32d42,
    faDrupal: $42f4e3f18906b0d1$export$51e679e8d2e3f8c1,
    faHireAHelper: $42f4e3f18906b0d1$export$66507f26cc60b31e,
    faCreativeCommonsBy: $42f4e3f18906b0d1$export$5040b13190e5beb7,
    faUnity: $42f4e3f18906b0d1$export$72fd5838af249737,
    faWhmcs: $42f4e3f18906b0d1$export$4d4f65ec2f52482,
    faRocketchat: $42f4e3f18906b0d1$export$193ac2f517f63e63,
    faVk: $42f4e3f18906b0d1$export$a6bf4d62e541f988,
    faUntappd: $42f4e3f18906b0d1$export$f1679625ed434576,
    faMailchimp: $42f4e3f18906b0d1$export$da9f5a873e107292,
    faCss3Alt: $42f4e3f18906b0d1$export$928cd5ee6ccd55c0,
    faSquareReddit: $42f4e3f18906b0d1$export$307bcbd032fbb8d3,
    faRedditSquare: $42f4e3f18906b0d1$export$f8480c75bb6acc77,
    faVimeoV: $42f4e3f18906b0d1$export$2ea137a3f22bc61,
    faContao: $42f4e3f18906b0d1$export$d023cd407bbc3cab,
    faSquareFontAwesome: $42f4e3f18906b0d1$export$128da80f2cbe244a,
    faDeskpro: $42f4e3f18906b0d1$export$9005bf63ad3e3083,
    faBrave: $42f4e3f18906b0d1$export$ec6cecf928f83afa,
    faSistrix: $42f4e3f18906b0d1$export$36ca6be2e064d2cd,
    faSquareInstagram: $42f4e3f18906b0d1$export$526087fb4de86dae,
    faInstagramSquare: $42f4e3f18906b0d1$export$ccb1f25058292a04,
    faBattleNet: $42f4e3f18906b0d1$export$fb3fd8e112e1fa28,
    faTheRedYeti: $42f4e3f18906b0d1$export$daa019c708da49e9,
    faSquareHackerNews: $42f4e3f18906b0d1$export$ca115ee475bced67,
    faHackerNewsSquare: $42f4e3f18906b0d1$export$310b7424f1f97fc,
    faEdge: $42f4e3f18906b0d1$export$9c65bd68cbc68ec9,
    faThreads: $42f4e3f18906b0d1$export$2a1c6a809b4fdc7f,
    faNapster: $42f4e3f18906b0d1$export$29d678db44edc00,
    faSquareSnapchat: $42f4e3f18906b0d1$export$8176f1a0ece4380c,
    faSnapchatSquare: $42f4e3f18906b0d1$export$20f908cf15afb04b,
    faGooglePlusG: $42f4e3f18906b0d1$export$74ebd8f5ac37d070,
    faArtstation: $42f4e3f18906b0d1$export$4fb55b03537dc8e3,
    faMarkdown: $42f4e3f18906b0d1$export$4401a9960e402a1c,
    faSourcetree: $42f4e3f18906b0d1$export$fd6b8582f52b208a,
    faGooglePlus: $42f4e3f18906b0d1$export$384e1aaf24320a2d,
    faDiaspora: $42f4e3f18906b0d1$export$f59fd74fa97e6ae5,
    faFoursquare: $42f4e3f18906b0d1$export$b14039dbb12386bc,
    faStackOverflow: $42f4e3f18906b0d1$export$2c0cf6f85294daec,
    faGithubAlt: $42f4e3f18906b0d1$export$edfa6885dbf62839,
    faPhoenixSquadron: $42f4e3f18906b0d1$export$699e806dfe31d90b,
    faPagelines: $42f4e3f18906b0d1$export$e4b095fb96bd3e1,
    faAlgolia: $42f4e3f18906b0d1$export$8819d592a12ec37e,
    faRedRiver: $42f4e3f18906b0d1$export$1052bcfc0bf56d5d,
    faCreativeCommonsSa: $42f4e3f18906b0d1$export$976ebfab93ea9362,
    faSafari: $42f4e3f18906b0d1$export$3fbc2591308fa490,
    faGoogle: $42f4e3f18906b0d1$export$4675affbae76524d,
    faSquareFontAwesomeStroke: $42f4e3f18906b0d1$export$dda4448112663ba,
    faFontAwesomeAlt: $42f4e3f18906b0d1$export$85f790d14ecf253e,
    faAtlassian: $42f4e3f18906b0d1$export$f200be919c1eaf0d,
    faLinkedinIn: $42f4e3f18906b0d1$export$ed0a679f653cc1ec,
    faDigitalOcean: $42f4e3f18906b0d1$export$c5c4219467aa9953,
    faNimblr: $42f4e3f18906b0d1$export$3f240983de3f5d10,
    faChromecast: $42f4e3f18906b0d1$export$8d89e361d79b386e,
    faEvernote: $42f4e3f18906b0d1$export$acd6dee6975fc503,
    faHackerNews: $42f4e3f18906b0d1$export$5d439911ece032d6,
    faCreativeCommonsSampling: $42f4e3f18906b0d1$export$e443cc965f82dd02,
    faAdversal: $42f4e3f18906b0d1$export$1a30438e2bd95428,
    faCreativeCommons: $42f4e3f18906b0d1$export$cf9c9b2132d3672c,
    faWatchmanMonitoring: $42f4e3f18906b0d1$export$17b7e34aba803644,
    faFonticons: $42f4e3f18906b0d1$export$324e0175b7ef27f7,
    faWeixin: $42f4e3f18906b0d1$export$5c0c3408fef47d33,
    faShirtsinbulk: $42f4e3f18906b0d1$export$621d1ced1e254c1c,
    faCodepen: $42f4e3f18906b0d1$export$f02422936d21d2f4,
    faGitAlt: $42f4e3f18906b0d1$export$9ce7fda0737f89e7,
    faLyft: $42f4e3f18906b0d1$export$c2221e2ed2fea622,
    faRev: $42f4e3f18906b0d1$export$344ccb7aebcc7cfa,
    faWindows: $42f4e3f18906b0d1$export$b138356c7d4344fd,
    faWizardsOfTheCoast: $42f4e3f18906b0d1$export$2c1079aeb76cd815,
    faSquareViadeo: $42f4e3f18906b0d1$export$d20d4c95d5790834,
    faViadeoSquare: $42f4e3f18906b0d1$export$46c94e3313db0253,
    faMeetup: $42f4e3f18906b0d1$export$61e6f6fcefd81d6e,
    faCentos: $42f4e3f18906b0d1$export$47b9420154e916ca,
    faAdn: $42f4e3f18906b0d1$export$64d8cc39326ee7a8,
    faCloudsmith: $42f4e3f18906b0d1$export$616a6b084ab35801,
    faOpensuse: $42f4e3f18906b0d1$export$d668d8d9da44b43e,
    faPiedPiperAlt: $42f4e3f18906b0d1$export$ef7de58d3fe843ba,
    faSquareDribbble: $42f4e3f18906b0d1$export$fc95d67ac3aa8c53,
    faDribbbleSquare: $42f4e3f18906b0d1$export$ff55221913bb3cd0,
    faCodiepie: $42f4e3f18906b0d1$export$248fddd2c856e8cc,
    faNode: $42f4e3f18906b0d1$export$4c16416edc1f091a,
    faMix: $42f4e3f18906b0d1$export$4176cb98e090fc09,
    faSteam: $42f4e3f18906b0d1$export$7c80ad2689275b29,
    faCcApplePay: $42f4e3f18906b0d1$export$37af1170a8e0c21b,
    faScribd: $42f4e3f18906b0d1$export$d271dfaa2c63aec5,
    faDebian: $42f4e3f18906b0d1$export$b30079bac9ebcf2a,
    faOpenid: $42f4e3f18906b0d1$export$b2dcd141e150a391,
    faInstalod: $42f4e3f18906b0d1$export$792bea9ca32c60da,
    faExpeditedssl: $42f4e3f18906b0d1$export$fe553f3645c5aefa,
    faSellcast: $42f4e3f18906b0d1$export$23a4f18e8bd9f913,
    faSquareTwitter: $42f4e3f18906b0d1$export$58fc652e3c488143,
    faTwitterSquare: $42f4e3f18906b0d1$export$270370f3feaf6b90,
    faRProject: $42f4e3f18906b0d1$export$f9a04980ef22b6b0,
    faDelicious: $42f4e3f18906b0d1$export$fc15ee5b2eab0af4,
    faFreebsd: $42f4e3f18906b0d1$export$1fa830857b3a4dc7,
    faVuejs: $42f4e3f18906b0d1$export$3e0cc9b4555f8145,
    faAccusoft: $42f4e3f18906b0d1$export$233214294e90ff53,
    faIoxhost: $42f4e3f18906b0d1$export$d11e9e62a1442448,
    faFonticonsFi: $42f4e3f18906b0d1$export$e6a0ac478bf76bf2,
    faAppStore: $42f4e3f18906b0d1$export$500760921a1e1f4e,
    faCcMastercard: $42f4e3f18906b0d1$export$dd0d0d0b3b519db5,
    faItunesNote: $42f4e3f18906b0d1$export$a0c8448ba3e387bc,
    faGolang: $42f4e3f18906b0d1$export$36cd41563937ec03,
    faKickstarter: $42f4e3f18906b0d1$export$f06b8625c0ebb13a,
    faGrav: $42f4e3f18906b0d1$export$fdcdacf548a335ed,
    faWeibo: $42f4e3f18906b0d1$export$75bd846ccb390b1e,
    faUncharted: $42f4e3f18906b0d1$export$e1cced2e7ea20eff,
    faFirstdraft: $42f4e3f18906b0d1$export$44a54556e145bddf,
    faSquareYoutube: $42f4e3f18906b0d1$export$1082b39fc1076b43,
    faYoutubeSquare: $42f4e3f18906b0d1$export$8992da42b645c563,
    faWikipediaW: $42f4e3f18906b0d1$export$6657c749288c4042,
    faWpressr: $42f4e3f18906b0d1$export$66f88c21efa6f12d,
    faRendact: $42f4e3f18906b0d1$export$d06b08e37a8aaaec,
    faAngellist: $42f4e3f18906b0d1$export$65f66dc47afb97bd,
    faGalacticRepublic: $42f4e3f18906b0d1$export$ba5a2dfe23db8bb6,
    faNfcDirectional: $42f4e3f18906b0d1$export$d637dd7b404459cf,
    faSkype: $42f4e3f18906b0d1$export$78370b1b91348c9e,
    faJoget: $42f4e3f18906b0d1$export$ae307621d0877ba2,
    faFedora: $42f4e3f18906b0d1$export$8cf9f3ca16e668b0,
    faStripeS: $42f4e3f18906b0d1$export$4823078d958b443a,
    faMeta: $42f4e3f18906b0d1$export$75b94550e27ccec5,
    faLaravel: $42f4e3f18906b0d1$export$bfe42001388ccf42,
    faHotjar: $42f4e3f18906b0d1$export$d309e8b75a17a518,
    faBluetoothB: $42f4e3f18906b0d1$export$ad4174fe3fc4abe2,
    faSquareLetterboxd: $42f4e3f18906b0d1$export$628b421165d7d11a,
    faStickerMule: $42f4e3f18906b0d1$export$439612f87b462a40,
    faCreativeCommonsZero: $42f4e3f18906b0d1$export$72df0aea6a5da9de,
    faHips: $42f4e3f18906b0d1$export$51de6451f4c7b107,
    faBehance: $42f4e3f18906b0d1$export$907c17a7f1d6a0d3,
    faReddit: $42f4e3f18906b0d1$export$97dd0b04d798af1a,
    faDiscord: $42f4e3f18906b0d1$export$c8d4525a5e9ad3ad,
    faChrome: $42f4e3f18906b0d1$export$430df45ec2fae593,
    faAppStoreIos: $42f4e3f18906b0d1$export$e36cec8e481a3a4b,
    faCcDiscover: $42f4e3f18906b0d1$export$4a929e0a1abf7e41,
    faWpbeginner: $42f4e3f18906b0d1$export$a24323c111493948,
    faConfluence: $42f4e3f18906b0d1$export$259f76b402dd445f,
    faShoelace: $42f4e3f18906b0d1$export$b4e2b27ee3ee1821,
    faMdb: $42f4e3f18906b0d1$export$7add95166ef0248a,
    faDochub: $42f4e3f18906b0d1$export$81d728fa770edbe1,
    faAccessibleIcon: $42f4e3f18906b0d1$export$3c152d640f62968e,
    faEbay: $42f4e3f18906b0d1$export$ddb611ff59fc9802,
    faAmazon: $42f4e3f18906b0d1$export$ebc1e565fd80a447,
    faUnsplash: $42f4e3f18906b0d1$export$3997191a5880488f,
    faYarn: $42f4e3f18906b0d1$export$a67629e1d516967d,
    faSquareSteam: $42f4e3f18906b0d1$export$c334a5e9c1f73381,
    faSteamSquare: $42f4e3f18906b0d1$export$b0e9b012d636da0a,
    fa500px: $42f4e3f18906b0d1$export$4adb509bb23593b0,
    faSquareVimeo: $42f4e3f18906b0d1$export$8974793285f35ac8,
    faVimeoSquare: $42f4e3f18906b0d1$export$78628c2da1e685b5,
    faAsymmetrik: $42f4e3f18906b0d1$export$50ef858a08ddd1e5,
    faFontAwesome: $42f4e3f18906b0d1$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $42f4e3f18906b0d1$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $42f4e3f18906b0d1$export$6e20d421a2e0f320,
    faGratipay: $42f4e3f18906b0d1$export$cf1aa567b9609235,
    faApple: $42f4e3f18906b0d1$export$a649d390c50fd6df,
    faHive: $42f4e3f18906b0d1$export$f5cdac644000a430,
    faGitkraken: $42f4e3f18906b0d1$export$cd2223c7b77bd41c,
    faKeybase: $42f4e3f18906b0d1$export$c80d8749c6106849,
    faApplePay: $42f4e3f18906b0d1$export$fbfbf4eeb373a6ab,
    faPadlet: $42f4e3f18906b0d1$export$369427eba18eb826,
    faAmazonPay: $42f4e3f18906b0d1$export$448eb0f9d8323c85,
    faSquareGithub: $42f4e3f18906b0d1$export$be5db653ba5b5871,
    faGithubSquare: $42f4e3f18906b0d1$export$5fe0a956971aa3c2,
    faStumbleupon: $42f4e3f18906b0d1$export$7872bf6ac6945976,
    faFedex: $42f4e3f18906b0d1$export$c9127779112e2ff8,
    faPhoenixFramework: $42f4e3f18906b0d1$export$3d9357caf53f9b59,
    faShopify: $42f4e3f18906b0d1$export$c18d8940c93637ce,
    faNeos: $42f4e3f18906b0d1$export$a38c2efcceaf5a01,
    faSquareThreads: $42f4e3f18906b0d1$export$75f15eb229650b3a,
    faHackerrank: $42f4e3f18906b0d1$export$5fb7eeed7d5e4dea,
    faResearchgate: $42f4e3f18906b0d1$export$5c5693a4f82cd9eb,
    faSwift: $42f4e3f18906b0d1$export$dcdf312747bb3471,
    faAngular: $42f4e3f18906b0d1$export$9df3e2a7a3f59b3b,
    faSpeakap: $42f4e3f18906b0d1$export$90ae1a3824ece6f2,
    faAngrycreative: $42f4e3f18906b0d1$export$a9e7bf021125ee89,
    faYCombinator: $42f4e3f18906b0d1$export$9ee2f35ed1fe0fd4,
    faEmpire: $42f4e3f18906b0d1$export$c966a5d80266ef06,
    faEnvira: $42f4e3f18906b0d1$export$9e2c7c55d2fddd0,
    faGoogleScholar: $42f4e3f18906b0d1$export$ed92c068824a8084,
    faSquareGitlab: $42f4e3f18906b0d1$export$1c14974e1904bc76,
    faGitlabSquare: $42f4e3f18906b0d1$export$4459a47a802afa29,
    faStudiovinari: $42f4e3f18906b0d1$export$9d71d8f56add75cb,
    faPiedPiper: $42f4e3f18906b0d1$export$13581f4cc240d7d9,
    faWordpress: $42f4e3f18906b0d1$export$8898e76262ada01d,
    faProductHunt: $42f4e3f18906b0d1$export$91dcff48b72c75ce,
    faFirefox: $42f4e3f18906b0d1$export$53a067e7149deea9,
    faLinode: $42f4e3f18906b0d1$export$fcbc58842fe8e217,
    faGoodreads: $42f4e3f18906b0d1$export$cc058e4fd428aead,
    faSquareOdnoklassniki: $42f4e3f18906b0d1$export$df58e66e423b11a0,
    faOdnoklassnikiSquare: $42f4e3f18906b0d1$export$8bab3f1c73ff1d0,
    faJsfiddle: $42f4e3f18906b0d1$export$49c67105b922997,
    faSith: $42f4e3f18906b0d1$export$6b9a61f04a3c9eb4,
    faThemeisle: $42f4e3f18906b0d1$export$9ce81750a9f73ac4,
    faPage4: $42f4e3f18906b0d1$export$e504e93b36693690,
    faHashnode: $42f4e3f18906b0d1$export$459e822cce028974,
    faReact: $42f4e3f18906b0d1$export$e62f4d94322d112c,
    faCcPaypal: $42f4e3f18906b0d1$export$c4a0e7e817efc4de,
    faSquarespace: $42f4e3f18906b0d1$export$c1ba640907c93eb6,
    faCcStripe: $42f4e3f18906b0d1$export$235ca29d6ed8f50f,
    faCreativeCommonsShare: $42f4e3f18906b0d1$export$82bc9680d7d55560,
    faBitcoin: $42f4e3f18906b0d1$export$7bb8936d912f16ef,
    faKeycdn: $42f4e3f18906b0d1$export$644ebffaf375bd06,
    faOpera: $42f4e3f18906b0d1$export$76e4000ae88923a5,
    faItchIo: $42f4e3f18906b0d1$export$4ec4278290df08a8,
    faUmbraco: $42f4e3f18906b0d1$export$b92d594113fd14c4,
    faGalacticSenate: $42f4e3f18906b0d1$export$85ca259eee71d856,
    faUbuntu: $42f4e3f18906b0d1$export$188bec0355fe7cb3,
    faDraft2digital: $42f4e3f18906b0d1$export$89aeef49dacedf59,
    faStripe: $42f4e3f18906b0d1$export$4124a45a674b7b36,
    faHouzz: $42f4e3f18906b0d1$export$f5c2efa520323804,
    faGg: $42f4e3f18906b0d1$export$5b7cd580ca5d0c32,
    faDhl: $42f4e3f18906b0d1$export$f3f333bdcc61afcd,
    faSquarePinterest: $42f4e3f18906b0d1$export$bfa4536fab29fa25,
    faPinterestSquare: $42f4e3f18906b0d1$export$67aa35027cc046c7,
    faXing: $42f4e3f18906b0d1$export$28ff226a626fb008,
    faBlackberry: $42f4e3f18906b0d1$export$11c2ed8ca6d46555,
    faCreativeCommonsPd: $42f4e3f18906b0d1$export$10c9e6deac1c2eeb,
    faPlaystation: $42f4e3f18906b0d1$export$6fcce83c026197c,
    faQuinscape: $42f4e3f18906b0d1$export$1079c541f45f51d0,
    faLess: $42f4e3f18906b0d1$export$df0a28abd4a08bff,
    faBloggerB: $42f4e3f18906b0d1$export$fb78f7bb43feec45,
    faOpencart: $42f4e3f18906b0d1$export$b1b65e1549fc9915,
    faVine: $42f4e3f18906b0d1$export$ff24f295c905f144,
    faSignalMessenger: $42f4e3f18906b0d1$export$95b71ec8a2f59bf0,
    faPaypal: $42f4e3f18906b0d1$export$1aaa7b292157aaf7,
    faGitlab: $42f4e3f18906b0d1$export$bc1566dfb0a3651b,
    faTypo3: $42f4e3f18906b0d1$export$26fe3ad1dc9d4c5b,
    faRedditAlien: $42f4e3f18906b0d1$export$9fbf70587b6b0dcc,
    faYahoo: $42f4e3f18906b0d1$export$d0632e92ebe1197f,
    faDailymotion: $42f4e3f18906b0d1$export$9743e7788f64058a,
    faAffiliatetheme: $42f4e3f18906b0d1$export$c40f060084205fb6,
    faPiedPiperPp: $42f4e3f18906b0d1$export$96d17626187f6e34,
    faBootstrap: $42f4e3f18906b0d1$export$3de8f256f5aadacf,
    faOdnoklassniki: $42f4e3f18906b0d1$export$f31d1294fef45f,
    faNfcSymbol: $42f4e3f18906b0d1$export$a64aa05b0287bdaf,
    faMintbit: $42f4e3f18906b0d1$export$1aeaa8a5ac0e3463,
    faEthereum: $42f4e3f18906b0d1$export$b5ebb163fdb5edfd,
    faSpeakerDeck: $42f4e3f18906b0d1$export$7c461c4ee7c07c19,
    faCreativeCommonsNcEu: $42f4e3f18906b0d1$export$bcf1858bdc40caa3,
    faPatreon: $42f4e3f18906b0d1$export$a4dfebb823a477ff,
    faAvianex: $42f4e3f18906b0d1$export$862396e708985a99,
    faEllo: $42f4e3f18906b0d1$export$e644e4a8cae83fb3,
    faGofore: $42f4e3f18906b0d1$export$380164e9d6cdbec2,
    faBimobject: $42f4e3f18906b0d1$export$a219f36955efe01a,
    faBraveReverse: $42f4e3f18906b0d1$export$3d9997b304f32d18,
    faFacebookF: $42f4e3f18906b0d1$export$890714bb00316cc,
    faSquareGooglePlus: $42f4e3f18906b0d1$export$e94511deb1df63ce,
    faGooglePlusSquare: $42f4e3f18906b0d1$export$d546947149d9505a,
    faMandalorian: $42f4e3f18906b0d1$export$2a745e3ef2838c53,
    faFirstOrderAlt: $42f4e3f18906b0d1$export$ea0bc2cd8d60b806,
    faOsi: $42f4e3f18906b0d1$export$89cf1df24c6f1e2,
    faGoogleWallet: $42f4e3f18906b0d1$export$6fd7b581d1a20a14,
    faDAndDBeyond: $42f4e3f18906b0d1$export$8ffeba28c1feff0d,
    faPeriscope: $42f4e3f18906b0d1$export$10deb29d7dbf2418,
    faFulcrum: $42f4e3f18906b0d1$export$beb89eeaf726c65a,
    faCloudscale: $42f4e3f18906b0d1$export$fdf6053d73314ca6,
    faForumbee: $42f4e3f18906b0d1$export$e4fb88a0423b6fee,
    faMizuni: $42f4e3f18906b0d1$export$e6a3c752190fa3cb,
    faSchlix: $42f4e3f18906b0d1$export$3f1891b85805675f,
    faSquareXing: $42f4e3f18906b0d1$export$ca49464b0602c8ef,
    faXingSquare: $42f4e3f18906b0d1$export$3f616d72d818a1a6,
    faBandcamp: $42f4e3f18906b0d1$export$cf8fa465ef81d073,
    faWpforms: $42f4e3f18906b0d1$export$f70eba4216b4419a,
    faCloudversify: $42f4e3f18906b0d1$export$623057fac7dabd52,
    faUsps: $42f4e3f18906b0d1$export$216644b0c66e66a5,
    faMegaport: $42f4e3f18906b0d1$export$e7e4dbda4df6110f,
    faMagento: $42f4e3f18906b0d1$export$9b8374b50472190d,
    faSpotify: $42f4e3f18906b0d1$export$8218f3fbb2f89724,
    faOptinMonster: $42f4e3f18906b0d1$export$5247a00f0c0b93a3,
    faFly: $42f4e3f18906b0d1$export$cfbbba1261e4e2d2,
    faAviato: $42f4e3f18906b0d1$export$f731696770842fd2,
    faItunes: $42f4e3f18906b0d1$export$5f69a5b38e12c984,
    faCuttlefish: $42f4e3f18906b0d1$export$883d4844d275b117,
    faBlogger: $42f4e3f18906b0d1$export$eba2747efc67a397,
    faFlickr: $42f4e3f18906b0d1$export$4fc2e88e3ac2b091,
    faViber: $42f4e3f18906b0d1$export$c16cb0c14aa5beed,
    faSoundcloud: $42f4e3f18906b0d1$export$5803ef8c86f9786d,
    faDigg: $42f4e3f18906b0d1$export$1902312a1701467c,
    faTencentWeibo: $42f4e3f18906b0d1$export$9ea61fa1ff3225c6,
    faLetterboxd: $42f4e3f18906b0d1$export$3d0320148c8ebcd6,
    faSymfony: $42f4e3f18906b0d1$export$5420457350c35845,
    faMaxcdn: $42f4e3f18906b0d1$export$a33f03bc723e6603,
    faEtsy: $42f4e3f18906b0d1$export$c7956780474e39de,
    faFacebookMessenger: $42f4e3f18906b0d1$export$6c28dada3398f534,
    faAudible: $42f4e3f18906b0d1$export$83a2d14204e40d9a,
    faThinkPeaks: $42f4e3f18906b0d1$export$4c12ad86c5e9c2a9,
    faBilibili: $42f4e3f18906b0d1$export$34797550194301d4,
    faErlang: $42f4e3f18906b0d1$export$c6087bbc62da6f90,
    faXTwitter: $42f4e3f18906b0d1$export$fd0513a3aa908a67,
    faCottonBureau: $42f4e3f18906b0d1$export$8fc0685430a4202e,
    faDashcube: $42f4e3f18906b0d1$export$fc2c1db4698b6c91,
    fa42Group: $42f4e3f18906b0d1$export$a02285afcee8b3ba,
    faInnosoft: $42f4e3f18906b0d1$export$da8db9965333c744,
    faStackExchange: $42f4e3f18906b0d1$export$d511b4edf7fbac5a,
    faElementor: $42f4e3f18906b0d1$export$66726053c0c0ec32,
    faSquarePiedPiper: $42f4e3f18906b0d1$export$9d16a5780aab9cd3,
    faPiedPiperSquare: $42f4e3f18906b0d1$export$95ddae6b65597c6e,
    faCreativeCommonsNd: $42f4e3f18906b0d1$export$157e4276d9138bda,
    faPalfed: $42f4e3f18906b0d1$export$a226dd96512e144,
    faSuperpowers: $42f4e3f18906b0d1$export$349f4fc9997a1bf0,
    faResolving: $42f4e3f18906b0d1$export$e73a6c635a57ef10,
    faXbox: $42f4e3f18906b0d1$export$2c743c09f4269e9c,
    faSearchengin: $42f4e3f18906b0d1$export$e72de9688042e327,
    faTiktok: $42f4e3f18906b0d1$export$f310e79ae35a251f,
    faSquareFacebook: $42f4e3f18906b0d1$export$8545d76ecd01ec19,
    faFacebookSquare: $42f4e3f18906b0d1$export$cd6ab8ed6a9ec7a4,
    faRenren: $42f4e3f18906b0d1$export$36a9439e8de2df70,
    faLinux: $42f4e3f18906b0d1$export$5cb68a24a0b7bdf6,
    faGlide: $42f4e3f18906b0d1$export$c4c84939b8784e10,
    faLinkedin: $42f4e3f18906b0d1$export$b38fbe0cd1e4c67d,
    faHubspot: $42f4e3f18906b0d1$export$418b99079caf9b9b,
    faDeploydog: $42f4e3f18906b0d1$export$bd9dbf3c3b0bdc5e,
    faTwitch: $42f4e3f18906b0d1$export$154857d90d308f7c,
    faRavelry: $42f4e3f18906b0d1$export$cab2db22e59af947,
    faMixer: $42f4e3f18906b0d1$export$83d047b1c09d253,
    faSquareLastfm: $42f4e3f18906b0d1$export$37794c0b0ffc1e44,
    faLastfmSquare: $42f4e3f18906b0d1$export$c2f59587d6a3a574,
    faVimeo: $42f4e3f18906b0d1$export$b73c31bd90a3782e,
    faMendeley: $42f4e3f18906b0d1$export$a580d86d20b50be3,
    faUniregistry: $42f4e3f18906b0d1$export$6fb93399039178f9,
    faFigma: $42f4e3f18906b0d1$export$e71a35e82f13ad7f,
    faCreativeCommonsRemix: $42f4e3f18906b0d1$export$c02c848648d47b55,
    faCcAmazonPay: $42f4e3f18906b0d1$export$3f0dada7ec074193,
    faDropbox: $42f4e3f18906b0d1$export$e4589d83245ae1b2,
    faInstagram: $42f4e3f18906b0d1$export$8256451a9905291a,
    faCmplid: $42f4e3f18906b0d1$export$f4e59d0d43aeb784,
    faUpwork: $42f4e3f18906b0d1$export$f32e8672931b41ff,
    faFacebook: $42f4e3f18906b0d1$export$86108d0b79007794,
    faGripfire: $42f4e3f18906b0d1$export$957b7296da5b4490,
    faJediOrder: $42f4e3f18906b0d1$export$3a376d0f2ecfb7d0,
    faUikit: $42f4e3f18906b0d1$export$27afc16078b5f3ac,
    faFortAwesomeAlt: $42f4e3f18906b0d1$export$a5097e0b1bb080b7,
    faPhabricator: $42f4e3f18906b0d1$export$cc29519275365076,
    faUssunnah: $42f4e3f18906b0d1$export$d0ceedb643a91662,
    faEarlybirds: $42f4e3f18906b0d1$export$c30a6352a2a5e8ea,
    faTradeFederation: $42f4e3f18906b0d1$export$83b68077d321f3ad,
    faAutoprefixer: $42f4e3f18906b0d1$export$2ea4e300aa12cd0a,
    faWhatsapp: $42f4e3f18906b0d1$export$45bdf388845cdf99,
    faSlideshare: $42f4e3f18906b0d1$export$4dcd48fd9c0bdd2d,
    faGooglePlay: $42f4e3f18906b0d1$export$cfa707f90d6b79ec,
    faViadeo: $42f4e3f18906b0d1$export$6f9febfcc8ac97d4,
    faLine: $42f4e3f18906b0d1$export$c5b04bbf0f48913a,
    faGoogleDrive: $42f4e3f18906b0d1$export$631c05505a17faa8,
    faServicestack: $42f4e3f18906b0d1$export$c2417738aeefe7e6,
    faSimplybuilt: $42f4e3f18906b0d1$export$8b48c2e6e01a12e0,
    faBitbucket: $42f4e3f18906b0d1$export$de75f8fcf71dfed9,
    faImdb: $42f4e3f18906b0d1$export$c85bcd118a7a17ff,
    faDeezer: $42f4e3f18906b0d1$export$17ab471305a2654c,
    faRaspberryPi: $42f4e3f18906b0d1$export$910e018904f54b08,
    faJira: $42f4e3f18906b0d1$export$78c2aea9064d90bd,
    faDocker: $42f4e3f18906b0d1$export$b29e4ebead927988,
    faScreenpal: $42f4e3f18906b0d1$export$63c4c3c3c5975c3e,
    faBluetooth: $42f4e3f18906b0d1$export$f77d9ddfdff1e2a7,
    faGitter: $42f4e3f18906b0d1$export$56aff378d7858517,
    faDAndD: $42f4e3f18906b0d1$export$8fb5b89b3d7583de,
    faMicroblog: $42f4e3f18906b0d1$export$d5808a1a9747be4c,
    faCcDinersClub: $42f4e3f18906b0d1$export$e24e559a44f492e1,
    faGgCircle: $42f4e3f18906b0d1$export$6d2eed3a88c7ed1a,
    faPiedPiperHat: $42f4e3f18906b0d1$export$238a02799aabf743,
    faKickstarterK: $42f4e3f18906b0d1$export$36ebae5de28f5e9e,
    faYandex: $42f4e3f18906b0d1$export$d51f17330f9046ea,
    faReadme: $42f4e3f18906b0d1$export$7dcb0372cc290c0e,
    faHtml5: $42f4e3f18906b0d1$export$d1a4948b9a07ae7c,
    faSellsy: $42f4e3f18906b0d1$export$cb60511a0f837c82,
    faSass: $42f4e3f18906b0d1$export$5afc94dc87b38719,
    faWirsindhandwerk: $42f4e3f18906b0d1$export$304e26e1efc5b1a4,
    faWsh: $42f4e3f18906b0d1$export$c6d19319c89c1ce4,
    faBuromobelexperte: $42f4e3f18906b0d1$export$25d99c8ee7e610e5,
    faSalesforce: $42f4e3f18906b0d1$export$fb5e089c1f25c80c,
    faOctopusDeploy: $42f4e3f18906b0d1$export$4a726382b32e57cc,
    faMedapps: $42f4e3f18906b0d1$export$86efffc3e85d2a9,
    faNs8: $42f4e3f18906b0d1$export$ffa3f5d32fe6bc0e,
    faPinterestP: $42f4e3f18906b0d1$export$e1681fe8211dd475,
    faApper: $42f4e3f18906b0d1$export$aa79881dfcf87a16,
    faFortAwesome: $42f4e3f18906b0d1$export$c2ee281dce8eb9d5,
    faWaze: $42f4e3f18906b0d1$export$8d560f87da34bcc1,
    faCcJcb: $42f4e3f18906b0d1$export$4f0eff72b7493340,
    faSnapchat: $42f4e3f18906b0d1$export$3770724b51125ef1,
    faSnapchatGhost: $42f4e3f18906b0d1$export$e6e855f745e10958,
    faFantasyFlightGames: $42f4e3f18906b0d1$export$318074701514e1,
    faRust: $42f4e3f18906b0d1$export$8a8ef141dcbeda7b,
    faWix: $42f4e3f18906b0d1$export$423f2efa0d73b5f9,
    faSquareBehance: $42f4e3f18906b0d1$export$3a09eb8c07c8379f,
    faBehanceSquare: $42f4e3f18906b0d1$export$bb4b7fb598656746,
    faSupple: $42f4e3f18906b0d1$export$9be373796460fb80,
    faWebflow: $42f4e3f18906b0d1$export$b4c5293ffb331d6a,
    faRebel: $42f4e3f18906b0d1$export$50bb8725ea3b3e34,
    faCss3: $42f4e3f18906b0d1$export$f32e22910f9b44,
    faStaylinked: $42f4e3f18906b0d1$export$ffbc7f79ed77f082,
    faKaggle: $42f4e3f18906b0d1$export$a03842279a704aae,
    faSpaceAwesome: $42f4e3f18906b0d1$export$1aecd37105f38798,
    faDeviantart: $42f4e3f18906b0d1$export$36a61c57a904744e,
    faCpanel: $42f4e3f18906b0d1$export$4b1cbad29e4915c6,
    faGoodreadsG: $42f4e3f18906b0d1$export$659cd0fc2157d001,
    faSquareGit: $42f4e3f18906b0d1$export$ccce513bbd3bef1d,
    faGitSquare: $42f4e3f18906b0d1$export$545247d36a0c2435,
    faSquareTumblr: $42f4e3f18906b0d1$export$b22e93e631701aa0,
    faTumblrSquare: $42f4e3f18906b0d1$export$b3979340ece626fe,
    faTrello: $42f4e3f18906b0d1$export$33a1efa865dd0849,
    faCreativeCommonsNcJp: $42f4e3f18906b0d1$export$e119d42c61b568e2,
    faGetPocket: $42f4e3f18906b0d1$export$17e9384897437d5a,
    faPerbyte: $42f4e3f18906b0d1$export$53e7f606db333d60,
    faGrunt: $42f4e3f18906b0d1$export$b84863db58925c09,
    faWeebly: $42f4e3f18906b0d1$export$33e64266c9adb232,
    faConnectdevelop: $42f4e3f18906b0d1$export$38091cf7f8c68318,
    faLeanpub: $42f4e3f18906b0d1$export$c6c358b395e9032d,
    faBlackTie: $42f4e3f18906b0d1$export$161a3454c1d6abdb,
    faThemeco: $42f4e3f18906b0d1$export$ec9cce37001091c7,
    faPython: $42f4e3f18906b0d1$export$15d5df18b87754e3,
    faAndroid: $42f4e3f18906b0d1$export$d3988148e7ca3c41,
    faBots: $42f4e3f18906b0d1$export$d367d9d00bf47408,
    faFreeCodeCamp: $42f4e3f18906b0d1$export$8190ad5ab3a607e2,
    faHornbill: $42f4e3f18906b0d1$export$906602f6a1e50bdd,
    faJs: $42f4e3f18906b0d1$export$530d32089c3347d5,
    faIdeal: $42f4e3f18906b0d1$export$4ee0aea9bb537f01,
    faGit: $42f4e3f18906b0d1$export$61f81190d1a8b4b,
    faDev: $42f4e3f18906b0d1$export$dad56877d4f4a953,
    faSketch: $42f4e3f18906b0d1$export$e999ee7aa7883e37,
    faYandexInternational: $42f4e3f18906b0d1$export$6bf616a61d0b7bf3,
    faCcAmex: $42f4e3f18906b0d1$export$2bcb24672b4bf6e6,
    faUber: $42f4e3f18906b0d1$export$2b557426f8d6820b,
    faGithub: $42f4e3f18906b0d1$export$64e4bc4b496fbbdf,
    faPhp: $42f4e3f18906b0d1$export$e1ae2a8de48825fb,
    faAlipay: $42f4e3f18906b0d1$export$994c329bc073af57,
    faYoutube: $42f4e3f18906b0d1$export$2373b132177332f8,
    faSkyatlas: $42f4e3f18906b0d1$export$b2254aecfa43ac3e,
    faFirefoxBrowser: $42f4e3f18906b0d1$export$db16178b6453c842,
    faReplyd: $42f4e3f18906b0d1$export$a51c205a2c2f1780,
    faSuse: $42f4e3f18906b0d1$export$fd2c25240484ff41,
    faJenkins: $42f4e3f18906b0d1$export$595f8e07121dc03e,
    faTwitter: $42f4e3f18906b0d1$export$ca61170983a00686,
    faRockrms: $42f4e3f18906b0d1$export$b86b24e51d58f6b5,
    faPinterest: $42f4e3f18906b0d1$export$d42c613d35559431,
    faBuffer: $42f4e3f18906b0d1$export$de04abdf8e0bcc15,
    faNpm: $42f4e3f18906b0d1$export$2002216d2d7747f0,
    faYammer: $42f4e3f18906b0d1$export$a5122f6c6ec2779c,
    faBtc: $42f4e3f18906b0d1$export$fcf54005da871608,
    faDribbble: $42f4e3f18906b0d1$export$657a51e82ea8ac80,
    faStumbleuponCircle: $42f4e3f18906b0d1$export$ef143c65b9462290,
    faInternetExplorer: $42f4e3f18906b0d1$export$26bd7ea5833d2643,
    faStubber: $42f4e3f18906b0d1$export$28d0d3c268c6e8c2,
    faTelegram: $42f4e3f18906b0d1$export$b508fd54409de914,
    faTelegramPlane: $42f4e3f18906b0d1$export$dd32dc1ad06228ec,
    faOldRepublic: $42f4e3f18906b0d1$export$39ef7a19d18012df,
    faOdysee: $42f4e3f18906b0d1$export$4001fe5db20c0fd2,
    faSquareWhatsapp: $42f4e3f18906b0d1$export$ee0c07b824da892f,
    faWhatsappSquare: $42f4e3f18906b0d1$export$6fd1d044d66a938d,
    faNodeJs: $42f4e3f18906b0d1$export$ad65a356f9456393,
    faEdgeLegacy: $42f4e3f18906b0d1$export$68bace18bdcdfc53,
    faSlack: $42f4e3f18906b0d1$export$c597531345e00f14,
    faSlackHash: $42f4e3f18906b0d1$export$46ef626e3b64d22,
    faMedrt: $42f4e3f18906b0d1$export$2d7cd04bce6afc11,
    faUsb: $42f4e3f18906b0d1$export$701b05aa394c8392,
    faTumblr: $42f4e3f18906b0d1$export$ae279e8a7a5b9476,
    faVaadin: $42f4e3f18906b0d1$export$f796d2c05c7c6dbd,
    faQuora: $42f4e3f18906b0d1$export$e9b10b4b8b90dca5,
    faSquareXTwitter: $42f4e3f18906b0d1$export$e42e88e46d22eb98,
    faReacteurope: $42f4e3f18906b0d1$export$1bc30ca2ce539d7f,
    faMedium: $42f4e3f18906b0d1$export$c1f031b95dadaa21,
    faMediumM: $42f4e3f18906b0d1$export$a29b11db7eed2052,
    faAmilia: $42f4e3f18906b0d1$export$2ffb27c42275836a,
    faMixcloud: $42f4e3f18906b0d1$export$642f133169ca9ebe,
    faFlipboard: $42f4e3f18906b0d1$export$5193bd9feb923609,
    faViacoin: $42f4e3f18906b0d1$export$e75485903cf50ab7,
    faCriticalRole: $42f4e3f18906b0d1$export$19d8e57a729f8d94,
    faSitrox: $42f4e3f18906b0d1$export$b431c4dc6e2095fc,
    faDiscourse: $42f4e3f18906b0d1$export$5311546a7fb29bad,
    faJoomla: $42f4e3f18906b0d1$export$4c7981055454786f,
    faMastodon: $42f4e3f18906b0d1$export$1dd6c03244d1cf01,
    faAirbnb: $42f4e3f18906b0d1$export$a8bcb0976aa786fb,
    faWolfPackBattalion: $42f4e3f18906b0d1$export$568095dca08f5ff3,
    faBuyNLarge: $42f4e3f18906b0d1$export$e08e0c43c651f28e,
    faGulp: $42f4e3f18906b0d1$export$100b84dda223030b,
    faCreativeCommonsSamplingPlus: $42f4e3f18906b0d1$export$f7edf083e5c27672,
    faStrava: $42f4e3f18906b0d1$export$7ea49f2cb08b52c1,
    faEmber: $42f4e3f18906b0d1$export$c09ea58a6f21cb3c,
    faCanadianMapleLeaf: $42f4e3f18906b0d1$export$c9a287a4ab49306f,
    faTeamspeak: $42f4e3f18906b0d1$export$619d787387e2c15e,
    faPushed: $42f4e3f18906b0d1$export$72c88c198f2680b,
    faWordpressSimple: $42f4e3f18906b0d1$export$1e35be7b9c7acc1f,
    faNutritionix: $42f4e3f18906b0d1$export$cb3944b58accd310,
    faWodu: $42f4e3f18906b0d1$export$d30ca94800bf542b,
    faGooglePay: $42f4e3f18906b0d1$export$6d89c09f17c54b19,
    faIntercom: $42f4e3f18906b0d1$export$fd8d76c5b86b3d2b,
    faZhihu: $42f4e3f18906b0d1$export$16e69e0d77404518,
    faKorvue: $42f4e3f18906b0d1$export$80de216c9d46bac,
    faPix: $42f4e3f18906b0d1$export$4fe14f0ab3be9a3,
    faSteamSymbol: $42f4e3f18906b0d1$export$c2ce1e5693cbcd01
};


const $5cbf5c54789c9bf6$export$e08ef55150a91249 = (0, $3cf7a308d6bda284$export$e9bd786d30cb716c);
const $5cbf5c54789c9bf6$export$62a054fae6e6f973 = (0, $ac21c2336b784bd5$exports.faArrowRotateLeft);
const $5cbf5c54789c9bf6$export$4e2abe3ed27cb5b0 = (0, $415249e817138a15$exports.faArrowRotateRight);
const $5cbf5c54789c9bf6$export$466bbee6e6a284b = (0, $5b68f8d1088edca4$exports.faScrewdriverWrench);
const $5cbf5c54789c9bf6$export$3b56639456b6b3f2 = (0, $55acb4ecd250c8b9$exports.faTrashCan);
const $5cbf5c54789c9bf6$export$c3a286456a7fc447 = (0, $2fe3a9c513cf47d2$exports.faMinus);
const $5cbf5c54789c9bf6$export$ac0a08e828b286ea = (0, $fd6e980ce23de01c$exports.faPlus);
const $5cbf5c54789c9bf6$export$2eb6285dfd63f7a9 = (0, $431b81e4b3a34ca6$exports.faCheck);
const $5cbf5c54789c9bf6$export$b12295f157163bb8 = (0, $e0038dd4562b915b$exports.faArrowRight);
const $5cbf5c54789c9bf6$export$6406395d5497fca3 = (0, $436349c781cb8ff4$exports.faArrowLeft);
const $5cbf5c54789c9bf6$export$acbe832e28edcfdb = (0, $a148c1a3fa332410$exports.faChevronRight);
const $5cbf5c54789c9bf6$export$731a703adf2141b2 = (0, $bca4ce04e29b08dc$exports.faChevronLeft);
const $5cbf5c54789c9bf6$export$51677d1de3f29ffe = (0, $7433a9a089759a34$exports.faBolt);
const $5cbf5c54789c9bf6$export$d35aec3187b330df = (0, $1a9cdda55bab389c$exports.faPerson);
const $5cbf5c54789c9bf6$export$ebaa24fafb6b0272 = (0, $beb41f2f74c84499$exports.faPencil);
const $5cbf5c54789c9bf6$export$e6d53d6f898a52bd = (0, $b86fd896361703f2$exports.faLock);
const $5cbf5c54789c9bf6$export$c4e1d559e4bb2186 = (0, $731960bb6e3da28d$exports.faBook);
const $5cbf5c54789c9bf6$export$6e372e7f4f398099 = (0, $3cf7a308d6bda284$export$d7cf0978afd90002);
const $5cbf5c54789c9bf6$export$ec177a8f005395b0 = (0, $42f4e3f18906b0d1$export$c8d4525a5e9ad3ad);
const $5cbf5c54789c9bf6$export$33632592fe819e14 = (0, $42f4e3f18906b0d1$export$cd6ab8ed6a9ec7a4);
const $5cbf5c54789c9bf6$export$109434bfc77d8653 = (0, $42f4e3f18906b0d1$export$64e4bc4b496fbbdf);
const $5cbf5c54789c9bf6$export$ac4cd6516d67ab5e = (0, $42f4e3f18906b0d1$export$8256451a9905291a);
const $5cbf5c54789c9bf6$export$f299cdb208ba459c = (0, $42f4e3f18906b0d1$export$1dd6c03244d1cf01);
const $5cbf5c54789c9bf6$export$967b6866ef1e4584 = (0, $42f4e3f18906b0d1$export$ca61170983a00686);


var $a28dadc48470da0b$exports = {};

$a28dadc48470da0b$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "forums.51f20df5.svg";


var $3619d5667f44ac04$exports = {};

$3619d5667f44ac04$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "google.7467d21e.svg";


var $f6f2ffe9790ae094$exports = {};

$f6f2ffe9790ae094$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "slack.f7fc8c2e.svg";


const $103c196c178bbe41$var$OCTICON_DEFAULT_CLASSNAME = "octicon";
// Preserve, don't replace default Octicon classname
function $103c196c178bbe41$var$octiconClassNames(className) {
    return [
        $103c196c178bbe41$var$OCTICON_DEFAULT_CLASSNAME,
        className
    ].join(" ").trim();
}
function $103c196c178bbe41$var$Icon({ icon: icon, className: className = "" }) {
    switch(icon){
        case "copy":
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $35f760dc3fc04eda$export$10862138e9169702), {
                size: 16,
                className: $103c196c178bbe41$var$octiconClassNames(className)
            });
        case "discord":
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                className: className,
                icon: (0, $5cbf5c54789c9bf6$export$ec177a8f005395b0)
            });
        case "facebook":
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                className: className,
                icon: (0, $5cbf5c54789c9bf6$export$33632592fe819e14)
            });
        case "github":
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                className: className,
                icon: (0, $5cbf5c54789c9bf6$export$109434bfc77d8653)
            });
        case "instagram":
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                className: className,
                icon: (0, $5cbf5c54789c9bf6$export$ac4cd6516d67ab5e)
            });
        case "mastodon":
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                className: className,
                icon: (0, $5cbf5c54789c9bf6$export$f299cdb208ba459c)
            });
        case "twitter":
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                className: className,
                icon: (0, $5cbf5c54789c9bf6$export$967b6866ef1e4584)
            });
        case "book":
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                className: className,
                icon: (0, $5cbf5c54789c9bf6$export$c4e1d559e4bb2186)
            });
        case "slack":
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                className: className,
                src: (0, (/*@__PURE__*/$parcel$interopDefault($f6f2ffe9790ae094$exports))),
                alt: ""
            });
        case "forums":
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                className: className,
                src: (0, (/*@__PURE__*/$parcel$interopDefault($a28dadc48470da0b$exports))),
                alt: ""
            });
        case "google":
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                className: className,
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3619d5667f44ac04$exports))),
                alt: ""
            });
        case "trash":
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $35f760dc3fc04eda$export$d23329de703dffc4), {
                size: 16,
                className: $103c196c178bbe41$var$octiconClassNames(className)
            });
        case "tools":
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $35f760dc3fc04eda$export$3d7439614fbf4d3e), {
                size: 16,
                className: $103c196c178bbe41$var$octiconClassNames(className)
            });
        case "sun":
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $35f760dc3fc04eda$export$cd27c497b93dbe8d), {
                size: 16,
                className: $103c196c178bbe41$var$octiconClassNames(className)
            });
    }
}
var $103c196c178bbe41$export$2e2bcd8739ae039 = $103c196c178bbe41$var$Icon;



parcelRequire("4DE7A");


function $7009de4fb98cd52f$var$KeyboardKey({ icon: icon, children: children }) {
    if (icon !== undefined) // The `title` property on <kbd> is suggested to provide
    // accessible text for the icon being displayed. In this
    // case we use the `children` prop as the `title`, which
    // means it's necessary for this to be a simple string content
    // and not a React component
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("kbd", {
        className: "key key-icon",
        title: children,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
            icon: icon
        })
    });
    // A `title` property is not required here because the
    // child elements provide their own text
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("kbd", {
        className: "key",
        children: children
    });
}
var $7009de4fb98cd52f$export$2e2bcd8739ae039 = $7009de4fb98cd52f$var$KeyboardKey;







var $4DE7A = parcelRequire("4DE7A");

var $dBd5b = parcelRequire("dBd5b");

var $50biD = parcelRequire("50biD");

var $2ogmM = parcelRequire("2ogmM");

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $39470642cf75d743$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $46a64476ee4c4435$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $39470642cf75d743$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}


function $ec485baf39b44dbc$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $ec485baf39b44dbc$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $ec485baf39b44dbc$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $ec485baf39b44dbc$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



var $4DE7A = parcelRequire("4DE7A");

var $50biD = parcelRequire("50biD");

var $2ogmM = parcelRequire("2ogmM");


var $4DE7A = parcelRequire("4DE7A");

var $gv34t = parcelRequire("gv34t");
var $902fbc3548aeb8fd$export$2e2bcd8739ae039 = {
    disabled: false
};




var $4DE7A = parcelRequire("4DE7A");
var $5cfecb0d1f2ac607$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createContext(null);


var $b4b4348c0d9a781d$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0bbe1d2d2979a273$export$bb38bb9a1161268 = "unmounted";
var $0bbe1d2d2979a273$export$84cbff306f539230 = "exited";
var $0bbe1d2d2979a273$export$df38205c966be359 = "entering";
var $0bbe1d2d2979a273$export$78e9e6e3e014d60a = "entered";
var $0bbe1d2d2979a273$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0bbe1d2d2979a273$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $2ogmM.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0bbe1d2d2979a273$export$84cbff306f539230;
                _this.appearStatus = $0bbe1d2d2979a273$export$df38205c966be359;
            } else initialStatus = $0bbe1d2d2979a273$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0bbe1d2d2979a273$export$bb38bb9a1161268;
        else initialStatus = $0bbe1d2d2979a273$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0bbe1d2d2979a273$export$bb38bb9a1161268) return {
            status: $0bbe1d2d2979a273$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0bbe1d2d2979a273$export$df38205c966be359 && status !== $0bbe1d2d2979a273$export$78e9e6e3e014d60a) nextStatus = $0bbe1d2d2979a273$export$df38205c966be359;
            } else if (status === $0bbe1d2d2979a273$export$df38205c966be359 || status === $0bbe1d2d2979a273$export$78e9e6e3e014d60a) nextStatus = $0bbe1d2d2979a273$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0bbe1d2d2979a273$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($gv34t))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $b4b4348c0d9a781d$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0bbe1d2d2979a273$export$84cbff306f539230) this.setState({
            status: $0bbe1d2d2979a273$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($gv34t))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $902fbc3548aeb8fd$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0bbe1d2d2979a273$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0bbe1d2d2979a273$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0bbe1d2d2979a273$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($gv34t))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $902fbc3548aeb8fd$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0bbe1d2d2979a273$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0bbe1d2d2979a273$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0bbe1d2d2979a273$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($gv34t))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0bbe1d2d2979a273$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $50biD.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, $5cfecb0d1f2ac607$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Component);
$0bbe1d2d2979a273$var$Transition.contextType = (0, $5cfecb0d1f2ac607$export$2e2bcd8739ae039);
$0bbe1d2d2979a273$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0bbe1d2d2979a273$var$noop() {}
$0bbe1d2d2979a273$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0bbe1d2d2979a273$var$noop,
    onEntering: $0bbe1d2d2979a273$var$noop,
    onEntered: $0bbe1d2d2979a273$var$noop,
    onExit: $0bbe1d2d2979a273$var$noop,
    onExiting: $0bbe1d2d2979a273$var$noop,
    onExited: $0bbe1d2d2979a273$var$noop
};
$0bbe1d2d2979a273$var$Transition.UNMOUNTED = $0bbe1d2d2979a273$export$bb38bb9a1161268;
$0bbe1d2d2979a273$var$Transition.EXITED = $0bbe1d2d2979a273$export$84cbff306f539230;
$0bbe1d2d2979a273$var$Transition.ENTERING = $0bbe1d2d2979a273$export$df38205c966be359;
$0bbe1d2d2979a273$var$Transition.ENTERED = $0bbe1d2d2979a273$export$78e9e6e3e014d60a;
$0bbe1d2d2979a273$var$Transition.EXITING = $0bbe1d2d2979a273$export$4aacc83d4d59139f;
var $0bbe1d2d2979a273$export$2e2bcd8739ae039 = $0bbe1d2d2979a273$var$Transition;




var $13c11db3c6cdc4a8$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $46a64476ee4c4435$export$2e2bcd8739ae039)(node, c);
    });
};
var $13c11db3c6cdc4a8$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $ec485baf39b44dbc$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $13c11db3c6cdc4a8$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $2ogmM.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $b4b4348c0d9a781d$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $13c11db3c6cdc4a8$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $13c11db3c6cdc4a8$var$removeClass(node, baseClassName);
        if (activeClassName) $13c11db3c6cdc4a8$var$removeClass(node, activeClassName);
        if (doneClassName) $13c11db3c6cdc4a8$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $50biD.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, $0bbe1d2d2979a273$export$2e2bcd8739ae039), (0, $dBd5b.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Component);
$13c11db3c6cdc4a8$var$CSSTransition.defaultProps = {
    classNames: ""
};
$13c11db3c6cdc4a8$var$CSSTransition.propTypes = {};
var $13c11db3c6cdc4a8$export$2e2bcd8739ae039 = $13c11db3c6cdc4a8$var$CSSTransition;




function $44dd3ad0e152777a$var$Menu({ className: className = "", isActive: isActive = false, menuItemNode: menuItemNode, alignOpposite: alignOpposite, onShow: onShow = ()=>undefined, onHide: onHide = ()=>undefined, children: children }) {
    const ref = (0, $4DE7A.useRef)(null);
    const contentDirection = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.app.contentDirection);
    const handleResize = (0, $4DE7A.useCallback)(()=>{
        $44dd3ad0e152777a$var$updateMenuPosition(ref.current, menuItemNode, contentDirection, alignOpposite);
    }, [
        menuItemNode,
        contentDirection,
        alignOpposite
    ]);
    (0, $4DE7A.useEffect)(()=>{
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    });
    /**
   * When the menu is shown or hidden, update its visual position and/or
   * run optional callback functions.
   */ (0, $4DE7A.useLayoutEffect)(()=>{
        if (isActive) {
            // Only update the menu position before showing it
            // When hiding, the menu position stays where it is
            $44dd3ad0e152777a$var$updateMenuPosition(ref.current, menuItemNode, contentDirection, alignOpposite);
            // Optional callback
            onShow();
        } else if (!isActive) // Optional callback
        onHide();
    }, [
        isActive,
        menuItemNode,
        contentDirection,
        alignOpposite,
        onShow,
        onHide
    ]);
    const classNames = [
        "menu"
    ];
    if (className) classNames.push(className);
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $13c11db3c6cdc4a8$export$2e2bcd8739ae039), {
        appear: true,
        in: isActive,
        timeout: 100,
        classNames: "menu-visible",
        mountOnEnter: true,
        unmountOnExit: true,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
            className: classNames.join(" "),
            ref: ref,
            children: children
        })
    });
}
/**
 * Determines actual position of the menu, based on the menu item position prop
 * passed in by <MenuBar />, and returns an object with left and top values for
 * absolute positioning.
 */ function $44dd3ad0e152777a$var$getMenuPosition(el, menuItemNode, contentDirection = "ltr", alignOpposite = false // whether element is right-aligned
) {
    if (!el || !menuItemNode) return;
    // Calculate left position
    let left;
    // `rtl` content alignment
    if (contentDirection === "rtl") {
        // If the menu width exceeds the left-most edge, or the `alignOpposite`
        // prop is true, the menu is aligned to the left-most edge
        const right = menuItemNode.offsetLeft + menuItemNode.offsetWidth;
        if (right - el.offsetWidth < 0 || alignOpposite) left = 0;
        else // Otherwise, align menu with the right edge of the menu item
        left = right - el.offsetWidth;
    } else {
        // `ltr` content alignment (default)
        // Get maximum (right-most) edge of menu bar
        const parent = el.parentNode;
        const maxXPos = parent?.offsetWidth;
        // If the menu width exceeds the right-most edge, or the `alignOpposite`
        // prop is true, the menu is aligned to the right-most edge
        if (menuItemNode.offsetLeft + el.offsetWidth > maxXPos || alignOpposite) left = maxXPos - el.offsetWidth;
        else // Otherwise, align menu with the left edge of the menu item
        left = menuItemNode.offsetLeft;
    }
    // Get top position
    // Top of menu aligns with bottom of menu item
    const top = menuItemNode.offsetTop + menuItemNode.offsetHeight;
    return {
        left: left,
        top: top
    };
}
function $44dd3ad0e152777a$var$updateMenuPosition(el, menuItemNode, contentDirection = "ltr", alignOpposite = false // whether element is right-aligned
) {
    const pos = $44dd3ad0e152777a$var$getMenuPosition(el, menuItemNode, contentDirection, alignOpposite);
    // Set element position and make it visible
    if (el && pos !== undefined) {
        el.style.left = pos.left.toString() + "px";
        el.style.top = pos.top.toString() + "px";
    }
}
var $44dd3ad0e152777a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $4DE7A.memo)($44dd3ad0e152777a$var$Menu);



const $dde8de4482129dd7$var$shiftKey = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $7009de4fb98cd52f$export$2e2bcd8739ae039), {
    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
        id: "key.shift",
        defaultMessage: "Shift"
    })
});
function $dde8de4482129dd7$var$HelpMenu(props) {
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    (0, $4DE7A.useEffect)(()=>{
        // Set up keyboard shortcuts
        (0, $89f2807011121cdf$export$bc520ed1c57f0d75)("?", {
            shiftKey: "optional"
        }, ()=>dispatch((0, $cdf0aaca62d15025$export$61e0a65f251cfdb3)("ABOUT")));
        return ()=>{
            (0, $89f2807011121cdf$export$86df18839624bc06)("?", ()=>dispatch((0, $cdf0aaca62d15025$export$61e0a65f251cfdb3)("ABOUT")));
        };
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $44dd3ad0e152777a$export$2e2bcd8739ae039), {
        ...props,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("a", {
                onClick: ()=>dispatch((0, $cdf0aaca62d15025$export$61e0a65f251cfdb3)("ABOUT")),
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$7a1b52edf33ca2d9), {
                        className: "menu-item-icon-radix"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "menu.item.about",
                        defaultMessage: "About Streetmix\u2026"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("a", {
                onClick: ()=>dispatch((0, $cdf0aaca62d15025$export$61e0a65f251cfdb3)("WHATS_NEW")),
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$8e0d2500d5bd92ef), {
                        className: "menu-item-icon-radix"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "dialogs.whatsnew.heading",
                        defaultMessage: "What\u2019s new in Streetmix? [en]\u200E"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                href: "https://docs.streetmix.net/user-guide/intro",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                        icon: "book",
                        className: "menu-item-icon"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "menu.help.guidebook-link",
                        defaultMessage: "Guidebook"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "help-menu-shortcuts",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$97dac707ecee26f6), {
                        className: "menu-item-icon-radix"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "menu.help.keyboard-label",
                        defaultMessage: "Keyboard shortcuts:"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("table", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $7009de4fb98cd52f$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "key.backspace",
                                                    defaultMessage: "Backspace"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "menu.help.remove-instruction",
                                                    defaultMessage: "Remove a segment you\u2019re pointing at"
                                                }),
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "menu.help.remove-shift-instruction",
                                                    defaultMessage: "(hold {shiftKey} to remove all)\u200E",
                                                    values: {
                                                        shiftKey: $dde8de4482129dd7$var$shiftKey
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("td", {
                                            dir: "ltr",
                                            children: [
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "key.minus",
                                                    defaultMessage: "Minus",
                                                    children: (label)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $7009de4fb98cd52f$export$2e2bcd8739ae039), {
                                                            icon: (0, $5cbf5c54789c9bf6$export$c3a286456a7fc447),
                                                            children: label
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "key.plus",
                                                    defaultMessage: "Plus",
                                                    children: (label)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $7009de4fb98cd52f$export$2e2bcd8739ae039), {
                                                            icon: (0, $5cbf5c54789c9bf6$export$ac0a08e828b286ea),
                                                            children: label
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "menu.help.change-instruction",
                                                    defaultMessage: "Change width of a segment you\u2019re pointing at"
                                                }),
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "menu.help.change-shift-instruction",
                                                    defaultMessage: "(hold {shiftKey} for more precision)\u200E",
                                                    values: {
                                                        shiftKey: $dde8de4482129dd7$var$shiftKey
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("td", {
                                            dir: "ltr",
                                            children: [
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "key.left-arrow",
                                                    defaultMessage: "Left arrow",
                                                    children: (label)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $7009de4fb98cd52f$export$2e2bcd8739ae039), {
                                                            icon: (0, $5cbf5c54789c9bf6$export$6406395d5497fca3),
                                                            children: label
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "key.right-arrow",
                                                    defaultMessage: "Right arrow",
                                                    children: (label)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $7009de4fb98cd52f$export$2e2bcd8739ae039), {
                                                            icon: (0, $5cbf5c54789c9bf6$export$b12295f157163bb8),
                                                            children: label
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "menu.help.move-instruction",
                                                    defaultMessage: "Move around the street"
                                                }),
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "menu.help.move-shift-instruction",
                                                    defaultMessage: "(hold {shiftKey} to jump to edges)\u200E",
                                                    values: {
                                                        shiftKey: $dde8de4482129dd7$var$shiftKey
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $dde8de4482129dd7$export$2e2bcd8739ae039 = $dde8de4482129dd7$var$HelpMenu;



parcelRequire("4DE7A");







function $85585844c82cd60c$var$ContactMenu(props) {
    const dispatch = (0, $c738fd431d4d7b5f$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $44dd3ad0e152777a$export$2e2bcd8739ae039), {
        ...props,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                href: "https://strt.mx/discord",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                        icon: "discord",
                        className: "menu-item-icon"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "menu.contact.discord",
                        defaultMessage: "Join Discord chat"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$9bd11592bfa362e7), {
                        className: "menu-item-external-link"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                href: "https://github.com/streetmix/streetmix/",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                        icon: "github",
                        className: "menu-item-icon"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "menu.contact.github",
                        defaultMessage: "View source code on GitHub"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$9bd11592bfa362e7), {
                        className: "menu-item-external-link"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("a", {
                onClick: (e)=>{
                    dispatch((0, $cdf0aaca62d15025$export$61e0a65f251cfdb3)("NEWSLETTER"));
                },
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$c81ccc0bdd70284), {
                        className: "menu-item-icon-radix"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "menu.contact.newsletter",
                        defaultMessage: "Subscribe to our newsletter"
                    })
                ]
            })
        ]
    });
}
var $85585844c82cd60c$export$2e2bcd8739ae039 = $85585844c82cd60c$var$ContactMenu;



parcelRequire("4DE7A");



function $ecde5dc7dc456d3b$var$ContributeMenu(props) {
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $44dd3ad0e152777a$export$2e2bcd8739ae039), {
        ...props,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
            href: "https://opencollective.com/streetmix/",
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "menu.contribute.donate",
                defaultMessage: "Donate"
            })
        })
    });
}
var $ecde5dc7dc456d3b$export$2e2bcd8739ae039 = $ecde5dc7dc456d3b$var$ContributeMenu;




var $4DE7A = parcelRequire("4DE7A");











function $f5f1c8557fc5cc11$var$IdentityMenu(props) {
    const user = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.signInData?.details || {});
    const isSubscriber = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.signedIn && state.user.isSubscriber);
    const offline = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.system.offline);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const handleClickMyStreets = (0, $4DE7A.useCallback)((event)=>{
        event.preventDefault();
        dispatch((0, $8d60d83c2ee769b2$export$a2488c4469b72767)({
            userId: user.id
        }));
    }, [
        user.id,
        dispatch
    ]);
    const isAdmin = user?.roles?.includes((0, (/*@__PURE__*/$parcel$interopDefault($98448114ff4d3ef1$exports))).ADMIN.value);
    const myStreetsLink = user.id ? `/${user.id}` : "";
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $44dd3ad0e152777a$export$2e2bcd8739ae039), {
        ...props,
        className: "identity-menu",
        children: [
            !offline && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "identity-section",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                className: "identity-avatar-name",
                                children: [
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                        className: "identity-avatar-name-left",
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $aad6e9d6c00e3001$export$2e2bcd8739ae039), {
                                            userId: user.id
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                        className: "identity-avatar-name-right",
                                        children: [
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                                className: "identity-avatar-display-name",
                                                children: user.displayName || user.id
                                            }),
                                            user.displayName && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                                className: "menu-item-subtext",
                                                children: user.id
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                className: "identity-roles",
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("ul", {
                                    children: [
                                        isSubscriber && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                                            className: "role-badge-subscriber",
                                            children: [
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                                                    className: "subscriber-icon",
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6ff8381b2b683785$exports))),
                                                    alt: ""
                                                }),
                                                "Streetmix+\u200E"
                                            ]
                                        }),
                                        isAdmin && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
                                            className: "role-badge-admin",
                                            children: "Admin"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("a", {
                        href: myStreetsLink,
                        onClick: handleClickMyStreets,
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$2ee28caa7f1e962e), {
                                className: "menu-item-icon-radix"
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "menu.item.my-streets",
                                defaultMessage: "My streets"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("a", {
                onClick: ()=>dispatch((0, $cdf0aaca62d15025$export$61e0a65f251cfdb3)("SETTINGS")),
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$5560e721cf131890), {
                        className: "menu-item-icon-radix"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "menu.item.settings",
                        defaultMessage: "Settings"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("a", {
                className: "menu-item",
                onClick: (0, $9be7409470745503$export$7c4b99b23af54de1),
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$72b807c0098a555f), {
                        className: "menu-item-icon-radix"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "menu.item.sign-out",
                        defaultMessage: "Sign out"
                    })
                ]
            })
        ]
    });
}
var $f5f1c8557fc5cc11$export$2e2bcd8739ae039 = $f5f1c8557fc5cc11$var$IdentityMenu;



parcelRequire("4DE7A");








parcelRequire("4DE7A");

/**
 * The <LoadingSpinner /> is an element that only displays a visual spinner.
 * It is up to the parent element or component to handle placement
 * and accessibility. The spinner does not come with a text label. If
 * you need a text label, the parent component should provide one.
 *
 * The `size` prop allows you to create a smaller spinner ideal for inline
 * UI situations, but the size can also be overriden via CSS (see stylesheet).
 */ function $62d2815b920e2bc5$var$LoadingSpinner({ size: size = "normal" }) {
    const classNames = [
        "loading-spinner"
    ];
    if (size === "small") classNames.push("loading-spinner-small");
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: classNames.join(" ")
    });
}
var $62d2815b920e2bc5$export$2e2bcd8739ae039 = $62d2815b920e2bc5$var$LoadingSpinner;




function $d591b534d03b784e$var$LocaleMenu(props) {
    const locale = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.locale.locale || (0, $b8c344dce25738f3$export$1af4c7e47ad72f44));
    const requestedLocale = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.locale.requestedLocale);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const filteredLocales = (0, $4daaf0496059b305$export$dcd88f9e8a73bead)();
    const actuallySelectedLocale = (0, $4daaf0496059b305$export$f706f5d6959e9268)(locale);
    async function selectLocale(newLocale) {
        if (locale === newLocale) return;
        await dispatch((0, $0083fa256c596554$export$7343075cd7f756c5)(newLocale));
        // Hide the menu after a locale is selected.
        // Note: because the application's tree is actually remounted with new
        // locale context, the menu doesn't animate away. It just disappears.
        // We still have to dispatch the clearMenus() so that the Redux store
        // knows that the menu has closed.
        dispatch((0, $3857de86d8e7589b$export$72f2284798989788)());
    }
    function renderLocaleOptions() {
        // Render each option
        return filteredLocales.map((locale)=>{
            const classNames = [
                "menu-item"
            ];
            if (locale.value === actuallySelectedLocale) classNames.push("menu-item-selected");
            // TODO: ARIA roles and attributes have been added to help with
            // testing, but these are not actually to accessible spec
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                className: classNames.join(" "),
                onClick: (event)=>selectLocale(locale.value),
                role: "option",
                "aria-selected": locale.value === actuallySelectedLocale,
                children: [
                    locale.value === requestedLocale && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $62d2815b920e2bc5$export$2e2bcd8739ae039), {
                        size: "small"
                    }),
                    locale.value === actuallySelectedLocale && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                        className: "menu-item-icon",
                        icon: (0, $5cbf5c54789c9bf6$export$2eb6285dfd63f7a9)
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("span", {
                        children: [
                            locale.label,
                            "\u200E"
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                        className: "menu-item-subtext",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: locale.key,
                            defaultMessage: locale.name
                        })
                    })
                ]
            }, locale.value);
        });
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $44dd3ad0e152777a$export$2e2bcd8739ae039), {
        ...props,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("ul", {
            className: "menu-item-group",
            role: "listbox",
            "aria-labelledby": "settings-menu-language-select",
            children: renderLocaleOptions()
        })
    });
}
var $d591b534d03b784e$export$2e2bcd8739ae039 = $d591b534d03b784e$var$LocaleMenu;




var $4DE7A = parcelRequire("4DE7A");



var $882752c91649655e$exports = {};
"use strict";
var $a421268835e310cf$exports = {};
$a421268835e310cf$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $882752c91649655e$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $882752c91649655e$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $882752c91649655e$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $882752c91649655e$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $a421268835e310cf$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $882752c91649655e$var$clipboardToIE11Formatting[options.format] || $882752c91649655e$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $882752c91649655e$var$format("message" in options ? options.message : $882752c91649655e$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$882752c91649655e$exports = $882752c91649655e$var$copy;








/**
 * Returns the current page URL.
 * This may eventually change to a short URL generator - strt.mx
 */ function $06da6c623a84aca7$export$763c1df6bf22be84() {
    return window.location.href;
}







const $0cc428f614398fec$var$LS_SHARE_MASTODON = "share:mastodon-domain";
const $0cc428f614398fec$var$MASTODON_DEFAULT_DOMAIN = "mastodon.social";
function $0cc428f614398fec$var$ShareMenu(props) {
    const offline = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.system.offline);
    const signedIn = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.user.signedIn || false);
    const userId = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.user.signInData?.userId ?? "");
    const street = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.street);
    const dispatch = (0, $c738fd431d4d7b5f$export$8ad76b76a4c905f8)();
    const [shareUrl, setShareUrl] = (0, $4DE7A.useState)("");
    const shareViaLinkInputRef = (0, $4DE7A.useRef)(null);
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    (0, $4DE7A.useEffect)(()=>{
        updateLinks();
    });
    function updateLinks() {
        setShareUrl((0, $06da6c623a84aca7$export$763c1df6bf22be84)());
    }
    function getSharingMessage() {
        let message = "";
        if (typeof street.creatorId === "string") {
            if (signedIn && street.creatorId === userId) {
                if (typeof street.name === "string") message = intl.formatMessage({
                    id: "menu.share.messages.my-street",
                    defaultMessage: "Check out my street, {streetName}, on Streetmix!"
                }, {
                    streetName: street.name
                });
                else message = intl.formatMessage({
                    id: "menu.share.messages.my-street-unnamed",
                    defaultMessage: "Check out my street on Streetmix!"
                });
            } else if (typeof street.name === "string") message = intl.formatMessage({
                id: "menu.share.messages.someone-elses-street",
                defaultMessage: "Check out {streetName} by {streetCreator} on Streetmix!"
            }, {
                streetName: street.name,
                streetCreator: `@${street.creatorId}`
            });
            else message = intl.formatMessage({
                id: "menu.share.messages.someone-elses-street-unnamed",
                defaultMessage: "Check out this street by {streetCreator} on Streetmix!"
            }, {
                streetCreator: `@${street.creatorId}`
            });
        } else if (typeof street.name === "string") message = intl.formatMessage({
            id: "menu.share.messages.anonymous-creator-street",
            defaultMessage: "Check out {streetName} on Streetmix!"
        }, {
            streetName: street.name
        });
        else message = intl.formatMessage({
            id: "menu.share.messages.anonymous-creator-street-unnamed",
            defaultMessage: "Check out this street on Streetmix!"
        });
        return message;
    }
    function handleShow() {
        // Make sure links are updated when the menu is opened
        updateLinks();
        // Auto-focus and select link when share menu is active
        window.setTimeout(()=>{
            if (!shareViaLinkInputRef.current) return;
            shareViaLinkInputRef.current.focus();
            shareViaLinkInputRef.current.select();
        }, 200);
    }
    function handleClickSaveAsImage(event) {
        event.preventDefault();
        dispatch((0, $cdf0aaca62d15025$export$61e0a65f251cfdb3)("SAVE_AS_IMAGE"));
    }
    function handleClickSignIn(event) {
        event.preventDefault();
        (0, $9be7409470745503$export$7abc584011c1e113)();
    }
    function handleClickPrint(event) {
        event.preventDefault();
        // Manually dispatch printing state here. Workaround for Chrome bug where
        // calling window.print() programatically (even with a timeout) render a
        // blank image instead
        dispatch((0, $9dbab908c178b0dc$export$e000c6e7623fb0b)());
        window.setTimeout(function() {
            window.print();
        }, 0);
    }
    function handleShareToMastodon(event) {
        // Get the Mastodon domain. User might have specified one in localstorage,
        // so use it if specified, otherwise use the "main" Mastodon instance
        const domain = window.prompt("Enter your Mastodon instance domain", window.localStorage.getItem($0cc428f614398fec$var$LS_SHARE_MASTODON) ?? $0cc428f614398fec$var$MASTODON_DEFAULT_DOMAIN);
        // Remember the value for later, because a person is likely to be
        // using the same instance for every share
        try {
            if (domain !== null) window.localStorage.setItem($0cc428f614398fec$var$LS_SHARE_MASTODON, domain);
            else window.localStorage.removeItem($0cc428f614398fec$var$LS_SHARE_MASTODON);
        } catch (err) {
            // Catch and continue if there is an error
            console.error(`Error writing to ${$0cc428f614398fec$var$LS_SHARE_MASTODON} on localStorage`);
        }
        // Bail if we don't have a domain
        if (domain === null) return;
        // Build the URL
        const url = "https://" + encodeURIComponent(domain) + "/share?text=" + encodeURIComponent(getSharingMessage()) + "&url=" + encodeURIComponent(shareUrl);
        // Open a window on the share page
        window.open(url, "_blank");
    }
    const shareText = getSharingMessage();
    const twitterLink = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(shareText) + "&url=" + encodeURIComponent(shareUrl);
    const facebookLink = "https://www.facebook.com/dialog/feed?app_id=" + encodeURIComponent((0, $63b5c9d178f1431e$export$f04aeb1fc450ccb6) ?? "") + "&redirect_uri=" + encodeURIComponent(shareUrl) + "&link=" + encodeURIComponent(shareUrl) + "&name=" + encodeURIComponent((0, $3c6cc20750b66eb4$export$23286240952da4c9)(street)) + "&description=" + encodeURIComponent(shareText);
    const signInLink = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
        onClick: handleClickSignIn,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            defaultMessage: "Sign in",
            id: "menu.share.sign-in-twitter-link"
        })
    });
    const signInPromo = !signedIn ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "share-sign-in-promo",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "menu.share.sign-in-link",
            defaultMessage: "{signInLink} for nicer links to your streets and your personal street gallery",
            values: {
                signInLink: signInLink
            }
        })
    }) : null;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $44dd3ad0e152777a$export$2e2bcd8739ae039), {
        onShow: handleShow,
        className: "share-menu",
        ...props,
        children: [
            !offline && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                children: [
                    signInPromo,
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "share-via-link-container",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$a0f93c0a3250ca9d), {
                                className: "menu-item-icon-radix"
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "menu.share.link",
                                defaultMessage: "Copy and paste this link to share:"
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                className: "share-via-link-form",
                                children: [
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("input", {
                                        className: "share-via-link",
                                        type: "text",
                                        value: shareUrl,
                                        spellCheck: "false",
                                        ref: shareViaLinkInputRef,
                                        readOnly: true
                                    }),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                        title: intl.formatMessage({
                                            id: "menu.share.copy-to-clipboard",
                                            defaultMessage: "Copy to clipboard"
                                        }),
                                        onClick: (event)=>{
                                            event.preventDefault();
                                            (0, (/*@__PURE__*/$parcel$interopDefault($882752c91649655e$exports)))(shareUrl);
                                        },
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                                            icon: "copy"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("a", {
                        onClick: handleShareToMastodon,
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                                icon: "mastodon",
                                className: "menu-item-icon"
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "menu.share.mastodon",
                                defaultMessage: "Share using Mastodon"
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$9bd11592bfa362e7), {
                                className: "menu-item-external-link"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                        href: twitterLink,
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                                icon: "twitter",
                                className: "menu-item-icon"
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "menu.share.twitter",
                                defaultMessage: "Share using Twitter"
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$9bd11592bfa362e7), {
                                className: "menu-item-external-link"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                        href: facebookLink,
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                                icon: "facebook",
                                className: "menu-item-icon"
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "menu.share.facebook",
                                defaultMessage: "Share using Facebook"
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$9bd11592bfa362e7), {
                                className: "menu-item-external-link"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                        href: `https://3dstreet.app/#${window.location.href}`,
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$315ae6298b7de94), {
                                className: "menu-item-icon-radix"
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "menu.share.3dstreet",
                                defaultMessage: "Open in 3DStreet"
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$9bd11592bfa362e7), {
                                className: "menu-item-external-link"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("a", {
                onClick: handleClickPrint,
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6ec9aef169c6b70a$export$c6ee5f2d8bb67d3e), {
                        className: "menu-item-icon"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "menu.share.print",
                        defaultMessage: "Print\u2026"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("a", {
                id: "save-as-image",
                onClick: handleClickSaveAsImage,
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$4e54df4252b4a99c), {
                        className: "menu-item-icon-radix"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "menu.share.save",
                        defaultMessage: "Save as image\u2026"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                        className: "menu-item-subtext",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "menu.share.save-byline",
                            defaultMessage: "For including in a report, blog, etc."
                        })
                    })
                ]
            })
        ]
    });
}
var $0cc428f614398fec$export$2e2bcd8739ae039 = $0cc428f614398fec$var$ShareMenu;



function $a78007a68e8b8c3f$var$MenusContainer() {
    const activeMenu = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.menus);
    const [activeMenuItemNode, setActiveMenuItemNode] = (0, $4DE7A.useState)(null);
    const dispatch = (0, $c738fd431d4d7b5f$export$8ad76b76a4c905f8)();
    (0, $4DE7A.useEffect)(()=>{
        // Hide menus if page loses visibility.
        document.addEventListener("visibilitychange", handleVisibilityChange, false);
        // Hide menus if a click occurs outside of a menu or menu button
        document.addEventListener("pointerdown", onBodyMouseDown);
        // Set up keypress listener to hide menus if visible
        (0, $89f2807011121cdf$export$bc520ed1c57f0d75)("esc", hideAllMenus);
        return ()=>{
            document.removeEventListener("visibilitychange", handleVisibilityChange, false);
            document.removeEventListener("pointerdown", onBodyMouseDown);
            (0, $89f2807011121cdf$export$86df18839624bc06)("esc", hideAllMenus);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Force document.body to become the active element when there is no longer
    // an open menu.
    (0, $4DE7A.useEffect)(()=>{
        if (activeMenu === null) document.body.focus();
    }, [
        activeMenu
    ]);
    /**
   * Callback function passed to the MenuBar component.
   * Clicked buttons that have a menu component will report back to this component
   * what was clicked and a reference to that element, which is then passed to
   * individual menus.
   *
   * @param {string} menu - name of the menu that was clicked
   * @param {HTMLElement} node - reference to the menu item button, used to position menu
   */ function handleMenuDropdownClick(menu, node) {
        // If the clicked menu is already active, it's toggled off.
        if (activeMenu === menu) {
            setActiveMenuItemNode(null);
            dispatch((0, $3857de86d8e7589b$export$978857af675b1906)(null));
        } else {
            setActiveMenuItemNode(node);
            dispatch((0, $3857de86d8e7589b$export$978857af675b1906)(menu));
        }
    }
    /**
   * This event handler callback will close menus if a click occurs outside
   * of a menu or a menu button.
   * This remains in use despite the useOnClickOutside() hook, which
   * can't apply in this situation because we need to listen on two elements.
   */ function onBodyMouseDown(event) {
        if (event.target.closest(".menu, .menu-attached") === null) hideAllMenus();
    }
    function handleVisibilityChange() {
        if (document.hidden) hideAllMenus();
    }
    function hideAllMenus() {
        dispatch((0, $3857de86d8e7589b$export$72f2284798989788)());
        setActiveMenuItemNode(null);
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $c4600497f2a05c41$export$2e2bcd8739ae039), {
                onMenuDropdownClick: handleMenuDropdownClick
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "menus-container",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $dde8de4482129dd7$export$2e2bcd8739ae039), {
                        isActive: activeMenu === "help",
                        menuItemNode: activeMenuItemNode
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $85585844c82cd60c$export$2e2bcd8739ae039), {
                        isActive: activeMenu === "contact",
                        menuItemNode: activeMenuItemNode
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ecde5dc7dc456d3b$export$2e2bcd8739ae039), {
                        isActive: activeMenu === "contribute",
                        menuItemNode: activeMenuItemNode
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d591b534d03b784e$export$2e2bcd8739ae039), {
                        isActive: activeMenu === "locale",
                        menuItemNode: activeMenuItemNode
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $0cc428f614398fec$export$2e2bcd8739ae039), {
                        isActive: activeMenu === "share",
                        menuItemNode: activeMenuItemNode
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $f5f1c8557fc5cc11$export$2e2bcd8739ae039), {
                        isActive: activeMenu === "identity",
                        menuItemNode: activeMenuItemNode,
                        alignOpposite: true
                    })
                ]
            })
        ]
    });
}
var $a78007a68e8b8c3f$export$2e2bcd8739ae039 = $a78007a68e8b8c3f$var$MenusContainer;




var $4DE7A = parcelRequire("4DE7A");





var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");


const $1b80e7badd3600dc$var$MAX_STREET_NAME_WIDTH = 50;
/**
 * Some processing needed to display street name
 *
 * @public for main street name ¯\_(ツ)_/¯
 * @params {string} name - Street name to check
 */ function $1b80e7badd3600dc$var$normalizeStreetName(name) {
    if (!name) return "";
    name = name.trim();
    if (name.length > $1b80e7badd3600dc$var$MAX_STREET_NAME_WIDTH) name = name.substr(0, $1b80e7badd3600dc$var$MAX_STREET_NAME_WIDTH) + "\u2026";
    return name;
}
$1b80e7badd3600dc$var$StreetName.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    childRef: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    editable: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool
};
function $1b80e7badd3600dc$var$StreetName(props) {
    const { name: name = "", childRef: childRef, onClick: onClick = ()=>{}, editable: editable = false } = props;
    const [isHovered, setHovered] = (0, $4DE7A.useState)(false);
    function handleMouseEnter() {
        setHovered(true);
    }
    function handleMouseLeave() {
        setHovered(false);
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "street-name",
        ref: childRef,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: onClick,
        children: [
            editable && isHovered && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "street-name-hover-prompt",
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "street.rename",
                    defaultMessage: "Click to rename"
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "street-name-text",
                children: $1b80e7badd3600dc$var$normalizeStreetName(name) || /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "street.default-name",
                    defaultMessage: "Unnamed St"
                })
            })
        ]
    });
}
var $1b80e7badd3600dc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).memo($1b80e7badd3600dc$var$StreetName);



parcelRequire("4DE7A");



var $4DE7A = parcelRequire("4DE7A");
















function $8041aaeb3f701cec$export$6fd14b847fc8d23c(width) {
    return async (dispatch, getState)=>{
        await dispatch((0, $8b007b7ac0907036$export$c61bfb5183745fe1)(width));
        await dispatch($8041aaeb3f701cec$export$b2eeaeff46616de5());
    };
}
const $8041aaeb3f701cec$export$b2eeaeff46616de5 = ()=>{
    return async (dispatch, getState)=>{
        const street = getState().street;
        const updatedStreet = (0, $d07093f2761e7137$export$c5f7f64da67f2025)(street);
        await dispatch((0, $8b007b7ac0907036$export$6a7fdf0c7a380248)(updatedStreet.segments, updatedStreet.occupiedWidth, updatedStreet.remainingWidth));
        // ToDo: Refactor this out to be dispatched as well
        (0, $8d9791e5769125e5$export$f86dbb9897d7ebae)();
    };
};
const $8041aaeb3f701cec$export$1103dc2b4ceb6805 = (dataNo)=>{
    return async (dispatch, getState)=>{
        await dispatch((0, $8b007b7ac0907036$export$d0365e48b58231c3)(dataNo, false));
        await dispatch($8041aaeb3f701cec$export$b2eeaeff46616de5());
    };
};
const $8041aaeb3f701cec$export$914352425a81b663 = ()=>{
    return async (dispatch, getState)=>{
        await dispatch((0, $8b007b7ac0907036$export$a69bfd14b8dc5d4d)());
        await dispatch($8041aaeb3f701cec$export$b2eeaeff46616de5());
    };
};
const $8041aaeb3f701cec$export$a3560afcf086fff0 = (isVisible)=>{
    return async (dispatch, getState)=>{
        await dispatch((0, $8b007b7ac0907036$export$69ad636194e76aaf)(isVisible));
        await dispatch($8041aaeb3f701cec$export$b2eeaeff46616de5());
    };
};
const $8041aaeb3f701cec$export$f4638f2b755d1b4d = (source)=>{
    return async (dispatch, getState)=>{
        await dispatch((0, $8b007b7ac0907036$export$5e4f004acdec411e)(source));
        await dispatch($8041aaeb3f701cec$export$b2eeaeff46616de5());
    };
};
const $8041aaeb3f701cec$export$834095b984dd9c8d = (dataNo, add, precise, origWidth, resizeType = (0, $edbb716917ec500c$export$fb22fa3ad2794469))=>{
    return async (dispatch, getState)=>{
        const units = getState().street.units;
        let resolution;
        if (precise) resolution = (0, $edbb716917ec500c$export$12e0a54c23e0f7be)((0, $edbb716917ec500c$export$824fe03c7a14ac41), units);
        else resolution = (0, $edbb716917ec500c$export$12e0a54c23e0f7be)(resizeType, units);
        let increment = resolution;
        if (!add) increment = -increment;
        (0, $edbb716917ec500c$export$3058040811eebf87)();
        const width = (0, $edbb716917ec500c$export$e06f682fb9edb199)(origWidth + increment, resolution);
        await dispatch((0, $8b007b7ac0907036$export$e370ec602acb2164)(dataNo, width));
        await dispatch($8041aaeb3f701cec$export$b2eeaeff46616de5());
    };
};
const $8041aaeb3f701cec$var$createStreetFromResponse = (response)=>{
    const street = (0, $762e491bbbc71e6b$export$2e2bcd8739ae039)(response.data.street);
    street.creatorId = response.creatorId || null;
    street.originalStreetId = response.originalStreetId || null;
    street.updatedAt = response.updatedAt || null;
    street.name = response.name || null;
    street.location = response.data.street.location || null;
    street.editCount = response.data.street.editCount || 0;
    street.segments = street.segments.map((segment)=>{
        segment.warnings = [];
        segment.variant = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, segment.variantString);
        return segment;
    });
    return street;
};
const $8041aaeb3f701cec$export$5fb9e92b8c98fefe = ()=>{
    return async (dispatch, getState)=>{
        const lastStreetId = getState().app.priorLastStreetId;
        const { id: id, namespacedId: namespacedId } = getState().street;
        try {
            // check this later
            // eslint-disable-next-line import/no-named-as-default-member
            const response = await (0, $4ff1018a457d25d0$export$2e2bcd8739ae039).getStreet(lastStreetId);
            const data = response.data;
            const street = $8041aaeb3f701cec$var$createStreetFromResponse(data);
            (0, $8d9791e5769125e5$export$996926525e13f61e)(true);
            await dispatch((0, $91ffa8e8b26e8ad0$export$f558026a994b6051)({
                lastStreetId: data.id,
                lastStreetNamespacedId: data.namespacedId,
                lastStreetCreatorId: street.creatorId
            }));
            dispatch((0, $8b007b7ac0907036$export$abace6e40841f465)(street));
            if (id) dispatch((0, $8b007b7ac0907036$export$750a818a04268f3)(id, namespacedId));
            else dispatch((0, $8b007b7ac0907036$export$750a818a04268f3)(data.id, data.namespacedId));
            dispatch((0, $8b007b7ac0907036$export$2d8fcfbae302074f)(lastStreetId));
            await dispatch($8041aaeb3f701cec$export$b2eeaeff46616de5());
            (0, $8d9791e5769125e5$export$996926525e13f61e)(false);
            (0, $8d9791e5769125e5$export$ed20678efa7800e4)();
            (0, $a7e2543fa152618e$export$6d965942225efd51)(false);
        } catch (error) {
            dispatch((0, $5e173785b5fcb8ed$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).NEW_STREET_SERVER_FAILURE, true));
        }
    };
};



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");





// eslint-disable-next-line react/prop-types
function $011266c6aae26b89$var$renderStreetWidthRemaining({ remainingWidth: remainingWidth, units: units }) {
    const width = (0, $83fecf775ebd2a37$export$f87bc2ba75a381c)(Math.abs(remainingWidth), units);
    if (remainingWidth > 0) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
        className: "street-width-under",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "width.under",
            defaultMessage: "({width} room)",
            values: {
                width: width
            }
        })
    });
    else if (remainingWidth < 0) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
        className: "street-width-over",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "width.over",
            defaultMessage: "({width} over)",
            values: {
                width: width
            }
        })
    });
    return null;
}
$011266c6aae26b89$var$StreetMetaWidthLabel.propTypes = {
    street: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        units: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        occupiedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        remainingWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
    }).isRequired,
    editable: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired
};
function $011266c6aae26b89$var$StreetMetaWidthLabel(props) {
    const { street: street, editable: editable, onClick: onClick } = props;
    const width = (0, $83fecf775ebd2a37$export$f87bc2ba75a381c)(street.width, street.units);
    // A title attribute is provided only when street width is editable
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const title = intl.formatMessage({
        id: "tooltip.street-width",
        defaultMessage: "Change width of the street"
    });
    // Apply a class when street width is editable for styling
    let className = "street-width";
    if (editable) className += " street-width-editable";
    const component = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("span", {
        className: className,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$c3403272e8c8becf), {}),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "width.label",
                defaultMessage: "{width} width",
                values: {
                    width: width
                }
            }),
            $011266c6aae26b89$var$renderStreetWidthRemaining(street),
            editable && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$4857d3f3f5f8319b), {
                className: "menu-carat-down"
            })
        ]
    });
    if (editable) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
        label: title,
        placement: "bottom",
        children: component
    });
    return component;
}
var $011266c6aae26b89$export$2e2bcd8739ae039 = $011266c6aae26b89$var$StreetMetaWidthLabel;




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");







const $b38cfd4acd082c28$var$DEFAULT_STREET_WIDTHS = [
    40,
    60,
    80
];
// Custom hook to focus an element after it's mounted
// To use, call this function in a ref prop
function $b38cfd4acd082c28$var$useFocus() {
    const el = (0, $4DE7A.useRef)(null);
    (0, $4DE7A.useEffect)(()=>{
        el.current.focus();
    }, []);
    return el;
}
$b38cfd4acd082c28$var$StreetMetaWidthMenu.propTypes = {
    street: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        units: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        occupiedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
    }).isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired
};
function $b38cfd4acd082c28$var$StreetMetaWidthMenu({ street: street, onChange: onChange }) {
    function handleChange(event) {
        onChange(event.target.value);
    }
    function renderOption(width, units) {
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("option", {
            value: width,
            children: (0, $83fecf775ebd2a37$export$f87bc2ba75a381c)(width, units)
        }, width);
    }
    // Get ready to render
    const { formatMessage: formatMessage } = (0, $d05758791eb139fa$exports.useIntl)();
    const { units: units, width: width, occupiedWidth: occupiedWidth } = street;
    // Create options for default widths. This will also convert the widths
    // the proper units for the street.
    const defaultWidths = $b38cfd4acd082c28$var$DEFAULT_STREET_WIDTHS.map((width)=>(0, $d07093f2761e7137$export$2c2a96700b1e1660)(width, units));
    const DefaultWidthOptions = defaultWidths.map((width)=>renderOption(width, units));
    // If the street width doesn't match any of the default widths,
    // render another choice representing the current width
    const CustomWidthOption = defaultWidths.indexOf(Number.parseFloat(width)) === -1 ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("option", {
                disabled: true
            }),
            renderOption(width, units)
        ]
    }) : null;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
        label: formatMessage({
            id: "tooltip.street-width",
            defaultMessage: "Change width of the street"
        }),
        placement: "bottom",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("select", {
            // Focus the <select> element after mounting
            ref: $b38cfd4acd082c28$var$useFocus(),
            onChange: handleChange,
            value: width,
            className: "street-width-select",
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("option", {
                    disabled: true,
                    children: formatMessage({
                        id: "width.occupied",
                        defaultMessage: "Occupied width:"
                    })
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("option", {
                    disabled: true,
                    children: (0, $83fecf775ebd2a37$export$f87bc2ba75a381c)(occupiedWidth, units)
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("option", {
                    disabled: true
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("option", {
                    disabled: true,
                    children: formatMessage({
                        id: "width.building",
                        defaultMessage: "Building-to-building width:"
                    })
                }),
                DefaultWidthOptions,
                CustomWidthOption,
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("option", {
                    value: (0, $2a9a05c10189c2fe$export$c5891348590052ef),
                    children: formatMessage({
                        id: "width.different",
                        defaultMessage: "Different width\u2026"
                    })
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("option", {
                    disabled: true
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("option", {
                    id: "switch-to-imperial-units",
                    value: (0, $2a9a05c10189c2fe$export$7af673c5969ee7ae),
                    disabled: units === (0, $c098fdb90228b950$export$c9756beb4aae2c8d),
                    children: formatMessage({
                        id: "width.imperial",
                        defaultMessage: "Switch to imperial units (feet)"
                    })
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("option", {
                    id: "switch-to-metric-units",
                    value: (0, $2a9a05c10189c2fe$export$71fb380783452ca7),
                    disabled: units === (0, $c098fdb90228b950$export$95a57d0e83881bf),
                    children: formatMessage({
                        id: "width.metric",
                        defaultMessage: "Switch to metric units"
                    })
                })
            ]
        })
    });
}
var $b38cfd4acd082c28$export$2e2bcd8739ae039 = $b38cfd4acd082c28$var$StreetMetaWidthMenu;




function $34e00e92e8444ed3$var$StreetMetaWidthContainer(props) {
    const street = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street);
    const editable = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>!state.app.readOnly && state.flags.EDIT_STREET_WIDTH.value);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const [isEditing, setEditing] = (0, $4DE7A.useState)(false);
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    /**
   * When the street width label is clicked, only allow editing if street
   * width is not read-only
   */ const handleClickLabel = (event)=>{
        if (editable) setEditing(true);
    };
    /**
   * Handles changes to the <select> dropdown rendered in <StreetMetaWidthMenu />
   *
   * @param {string} - value from selected <option>
   */ const handleChangeMenuSelection = (value)=>{
        setEditing(false);
        const { units: units, width: width, occupiedWidth: occupiedWidth } = street;
        const selection = Number.parseInt(value, 10);
        switch(selection){
            case 0, $2a9a05c10189c2fe$export$71fb380783452ca7:
                (0, $2fdd636378463894$export$79f1031a34509c7)((0, $c098fdb90228b950$export$95a57d0e83881bf));
                break;
            case 0, $2a9a05c10189c2fe$export$7af673c5969ee7ae:
                (0, $2fdd636378463894$export$79f1031a34509c7)((0, $c098fdb90228b950$export$c9756beb4aae2c8d));
                break;
            // Prompt for new street width
            case 0, $2a9a05c10189c2fe$export$c5891348590052ef:
                {
                    const promptValue = (0, $d07093f2761e7137$export$2c2a96700b1e1660)(occupiedWidth, units);
                    const promptString = intl.formatMessage({
                        id: "prompt.new-width",
                        defaultMessage: "New street width (from {minWidth} to {maxWidth}):"
                    }, {
                        minWidth: (0, $83fecf775ebd2a37$export$f87bc2ba75a381c)((0, $2a9a05c10189c2fe$export$1d24f35997388cf), units),
                        maxWidth: (0, $83fecf775ebd2a37$export$f87bc2ba75a381c)((0, $2a9a05c10189c2fe$export$59cfd33ad5cf1eb5), units)
                    });
                    const inputWidth = window.prompt(promptString, (0, $83fecf775ebd2a37$export$f87bc2ba75a381c)(promptValue, units));
                    if (inputWidth) {
                        const newWidth = (0, $d07093f2761e7137$export$2c2a96700b1e1660)((0, $83fecf775ebd2a37$export$53a59fd02fe9885d)(inputWidth, units), units);
                        dispatch((0, $8041aaeb3f701cec$export$6fd14b847fc8d23c)(newWidth));
                    }
                    break;
                }
            // Do nothing if the selection is the original width
            case width:
                break;
            // Change width to the desired selection
            default:
                if (selection) dispatch((0, $8041aaeb3f701cec$export$6fd14b847fc8d23c)(selection));
                break;
        }
    };
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
        className: "street-metadata-width",
        children: isEditing ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $b38cfd4acd082c28$export$2e2bcd8739ae039), {
            street: street,
            onChange: handleChangeMenuSelection
        }) : /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $011266c6aae26b89$export$2e2bcd8739ae039), {
            street: street,
            editable: editable,
            onClick: handleClickLabel
        })
    });
}
var $34e00e92e8444ed3$export$2e2bcd8739ae039 = $34e00e92e8444ed3$var$StreetMetaWidthContainer;



parcelRequire("4DE7A");







function $df51851e22288fbd$var$StreetMetaAuthor(props) {
    const creatorId = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street.creatorId);
    const signedIn = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.signedIn);
    const userId = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.signInData?.userId || "");
    const { data: creatorProfile } = (0, $e2f405c0a03fcace$export$9beb97f355b95ab9)(creatorId);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    function handleClickAuthor(event) {
        if (event) event.preventDefault();
        dispatch((0, $8d60d83c2ee769b2$export$a2488c4469b72767)({
            userId: creatorId
        }));
    }
    let user;
    if (creatorId && (!signedIn || creatorId !== userId)) user = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $aad6e9d6c00e3001$export$2e2bcd8739ae039), {
                userId: creatorId
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                href: "/" + creatorId,
                onClick: handleClickAuthor,
                children: creatorProfile?.displayName || creatorId
            })
        ]
    });
    else if (!creatorId && (signedIn || !(0, $846d9bfc81d2582a$export$adbfba29f0dd9074)())) user = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
        id: "users.anonymous",
        defaultMessage: "Anonymous"
    });
    if (!user) return null;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("span", {
        className: "street-metadata-author",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6ec9aef169c6b70a$export$cba28ec6c7fb0a0d), {}),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "users.byline",
                defaultMessage: "by {user}",
                values: {
                    user: user
                }
            })
        ]
    });
}
var $df51851e22288fbd$export$2e2bcd8739ae039 = $df51851e22288fbd$var$StreetMetaAuthor;



parcelRequire("4DE7A");



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");

const $949370bb2e225fbf$var$MINUTES_AGO = 600000;
const $949370bb2e225fbf$var$SECONDS_AGO = 60000;
/**
 * Compares two date objects to see if they are the same day
 *
 * @param {Date} a - first date to compare
 * @param {Date} b - second date to compare
 */ function $949370bb2e225fbf$var$isSameDay(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
function $949370bb2e225fbf$export$2e2bcd8739ae039(props) {
    const now = new Date();
    const date = new Date(props.value);
    const diff = now - date;
    if (diff >= 0) {
        if (diff < $949370bb2e225fbf$var$SECONDS_AGO) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("time", {
            dateTime: props.value,
            title: props.value,
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "datetime.seconds-ago",
                defaultMessage: "A few seconds ago"
            })
        });
        if (diff < $949370bb2e225fbf$var$MINUTES_AGO) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("time", {
            dateTime: props.value,
            title: props.value,
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "datetime.minutes-ago",
                defaultMessage: "A few minutes ago"
            })
        });
    }
    if ($949370bb2e225fbf$var$isSameDay(date, now)) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
        id: "datetime.today",
        defaultMessage: "Today at {time}",
        values: {
            time: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("time", {
                dateTime: props.value,
                title: props.value,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedTime), {
                    timeZone: props.timezone,
                    value: props.value,
                    hour: "numeric",
                    minute: "numeric"
                })
            })
        }
    });
    const yesterday = new Date(now.getTime() - 86400000);
    if ($949370bb2e225fbf$var$isSameDay(date, yesterday)) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
        id: "datetime.yesterday",
        defaultMessage: "Yesterday at {time}",
        values: {
            time: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("time", {
                dateTime: props.value,
                title: props.value,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedTime), {
                    timeZone: props.timezone,
                    value: props.value,
                    hour: "numeric",
                    minute: "numeric"
                })
            })
        }
    });
    // Same year
    if (now.getFullYear() === date.getFullYear()) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("time", {
        dateTime: props.value,
        title: props.value,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedDate), {
            value: props.value,
            month: "long",
            day: "numeric"
        })
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("time", {
        dateTime: props.value,
        title: props.value,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedDate), {
            value: props.value,
            year: "numeric",
            month: "long",
            day: "numeric"
        })
    });
}
$949370bb2e225fbf$export$2e2bcd8739ae039.propTypes = {
    // prop should match an ISO date string, e.g. "2018-04-24T23:37:55.21Z"
    value: (props, propName, componentName)=>{
        if (!/^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+Z$/.test(props[propName]) && typeof props[propName] !== "undefined") return new Error("Invalid prop `" + propName + "` supplied to" + " `" + componentName + "`. It should be an ISO date string." + " Validation failed. Value: `" + props[propName] + "`");
    },
    timezone: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
};



// Milliseconds that must have elapsed before recent edits display timestamp
const $351225547e67ff84$var$TIME_LIMIT = 6000;
function $351225547e67ff84$var$StreetMetaDate(props) {
    const updatedAt = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street.updatedAt || state.street.clientUpdatedAt);
    if (!updatedAt) return null;
    // In the user has just edited the street, don't display the "seconds ago" timestamp.
    if (new Date() - new Date(updatedAt) < $351225547e67ff84$var$TIME_LIMIT && (0, $846d9bfc81d2582a$export$adbfba29f0dd9074)()) return null;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("span", {
        className: "street-metadata-date",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6ec9aef169c6b70a$export$1b35fab62f0f23b9), {}),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $949370bb2e225fbf$export$2e2bcd8739ae039), {
                value: updatedAt
            })
        ]
    });
}
var $351225547e67ff84$export$2e2bcd8739ae039 = $351225547e67ff84$var$StreetMetaDate;



parcelRequire("4DE7A");





function $99fa3f8b061ff6e7$var$StreetMetaGeotag(props) {
    const street = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street);
    const editable = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>!state.app.readOnly && state.flags.GEOTAG.value);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    // Render nothing if there is no street location, and geolocation is not enabled
    if (!editable && !street.location) return null;
    function handleClickGeotag(event) {
        event.preventDefault();
        dispatch((0, $cdf0aaca62d15025$export$61e0a65f251cfdb3)("GEOTAG"));
    }
    function getGeotagText() {
        const { hierarchy: hierarchy } = street.location;
        const unknownLabel = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "dialogs.geotag.unknown-location",
            defaultMessage: "Unknown location"
        });
        let text = hierarchy.locality ? hierarchy.locality : hierarchy.region ? hierarchy.region : hierarchy.neighbourhood ? hierarchy.neighbourhood : null;
        if (text && hierarchy.country) text = text + ", " + hierarchy.country;
        return text || unknownLabel;
    }
    // Determine what text label to render
    const geotagText = street.location ? getGeotagText() : /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
        id: "dialogs.geotag.add-location",
        defaultMessage: "Add location"
    });
    const title = intl.formatMessage({
        id: "tooltip.geotag",
        defaultMessage: "Change location"
    });
    if (editable) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
        label: title,
        placement: "bottom",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("span", {
            className: "street-metadata-map",
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6ec9aef169c6b70a$export$e7d88295e7a502c5), {}),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                    onClick: handleClickGeotag,
                    children: geotagText
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
        className: "street-metadata-map",
        children: geotagText
    });
}
var $99fa3f8b061ff6e7$export$2e2bcd8739ae039 = $99fa3f8b061ff6e7$var$StreetMetaGeotag;



parcelRequire("4DE7A");




var $64e9a2b98996ad01$exports = {};
(function(global1, factory) {
    factory($64e9a2b98996ad01$exports);
})($64e9a2b98996ad01$exports, function(exports1) {
    "use strict";
    var domain;
    // This constructor is used to store event handlers. Instantiating this is
    // faster than explicitly calling `Object.create(null)` to get a "clean" empty
    // object (tested with v8 v4.9).
    function EventHandlers() {}
    EventHandlers.prototype = Object.create(null);
    function EventEmitter() {
        EventEmitter.init.call(this);
    }
    // nodejs oddity
    // require('events') === require('events').EventEmitter
    EventEmitter.EventEmitter = EventEmitter;
    EventEmitter.usingDomains = false;
    EventEmitter.prototype.domain = undefined;
    EventEmitter.prototype._events = undefined;
    EventEmitter.prototype._maxListeners = undefined;
    // By default EventEmitters will print a warning if more than 10 listeners are
    // added to it. This is a useful default which helps finding memory leaks.
    EventEmitter.defaultMaxListeners = 10;
    EventEmitter.init = function() {
        this.domain = null;
        if (EventEmitter.usingDomains) // if there is an active domain, then attach to it.
        domain.active && domain.Domain;
        if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
            this._events = new EventHandlers();
            this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || undefined;
    };
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== "number" || n < 0 || isNaN(n)) throw new TypeError('"n" argument must be a positive number');
        this._maxListeners = n;
        return this;
    };
    function $getMaxListeners(that) {
        if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
        return that._maxListeners;
    }
    EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return $getMaxListeners(this);
    };
    // These standalone emit* functions are used to optimize calling of event
    // handlers for fast cases because emit() itself often has a variable number of
    // arguments and can be deoptimized because of that. These functions always have
    // the same number of arguments and thus do not get deoptimized, so the code
    // inside them can execute faster.
    function emitNone(handler, isFn, self1) {
        if (isFn) handler.call(self1);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].call(self1);
        }
    }
    function emitOne(handler, isFn, self1, arg1) {
        if (isFn) handler.call(self1, arg1);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1);
        }
    }
    function emitTwo(handler, isFn, self1, arg1, arg2) {
        if (isFn) handler.call(self1, arg1, arg2);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2);
        }
    }
    function emitThree(handler, isFn, self1, arg1, arg2, arg3) {
        if (isFn) handler.call(self1, arg1, arg2, arg3);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2, arg3);
        }
    }
    function emitMany(handler, isFn, self1, args) {
        if (isFn) handler.apply(self1, args);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].apply(self1, args);
        }
    }
    EventEmitter.prototype.emit = function emit(type) {
        var er, handler, len, args, i, events, domain;
        var doError = type === "error";
        events = this._events;
        if (events) doError = doError && events.error == null;
        else if (!doError) return false;
        domain = this.domain;
        // If there is no 'error' event listener then throw.
        if (doError) {
            er = arguments[1];
            if (domain) {
                if (!er) er = new Error('Uncaught, unspecified "error" event');
                er.domainEmitter = this;
                er.domain = domain;
                er.domainThrown = false;
                domain.emit("error", er);
            } else if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
                err.context = er;
                throw err;
            }
            return false;
        }
        handler = events[type];
        if (!handler) return false;
        var isFn = typeof handler === "function";
        len = arguments.length;
        switch(len){
            // fast cases
            case 1:
                emitNone(handler, isFn, this);
                break;
            case 2:
                emitOne(handler, isFn, this, arguments[1]);
                break;
            case 3:
                emitTwo(handler, isFn, this, arguments[1], arguments[2]);
                break;
            case 4:
                emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
                break;
            // slower
            default:
                args = new Array(len - 1);
                for(i = 1; i < len; i++)args[i - 1] = arguments[i];
                emitMany(handler, isFn, this, args);
        }
        return true;
    };
    function _addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;
        if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
        events = target._events;
        if (!events) {
            events = target._events = new EventHandlers();
            target._eventsCount = 0;
        } else {
            // To avoid recursion in the case that type === "newListener"! Before
            // adding it to the listeners, first emit "newListener".
            if (events.newListener) {
                target.emit("newListener", type, listener.listener ? listener.listener : listener);
                // Re-assign `events` because a newListener handler could have caused the
                // this._events to be assigned to a new object
                events = target._events;
            }
            existing = events[type];
        }
        if (!existing) {
            // Optimize the case of one listener. Don't need the extra array object.
            existing = events[type] = listener;
            ++target._eventsCount;
        } else {
            if (typeof existing === "function") // Adding the second element, need to change to array.
            existing = events[type] = prepend ? [
                listener,
                existing
            ] : [
                existing,
                listener
            ];
            else // If we've already got an array, just append.
            if (prepend) existing.unshift(listener);
            else existing.push(listener);
            // Check for listener leak
            if (!existing.warned) {
                m = $getMaxListeners(target);
                if (m && m > 0 && existing.length > m) {
                    existing.warned = true;
                    var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + type + " listeners added. " + "Use emitter.setMaxListeners() to increase limit");
                    w.name = "MaxListenersExceededWarning";
                    w.emitter = target;
                    w.type = type;
                    w.count = existing.length;
                    emitWarning(w);
                }
            }
        }
        return target;
    }
    function emitWarning(e) {
        typeof console.warn === "function" ? console.warn(e) : console.log(e);
    }
    EventEmitter.prototype.addListener = function addListener(type, listener) {
        return _addListener(this, type, listener, false);
    };
    EventEmitter.prototype.on = EventEmitter.prototype.addListener;
    EventEmitter.prototype.prependListener = function prependListener(type, listener) {
        return _addListener(this, type, listener, true);
    };
    function _onceWrap(target, type, listener) {
        var fired = false;
        function g() {
            target.removeListener(type, g);
            if (!fired) {
                fired = true;
                listener.apply(target, arguments);
            }
        }
        g.listener = listener;
        return g;
    }
    EventEmitter.prototype.once = function once(type, listener) {
        if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
        this.on(type, _onceWrap(this, type, listener));
        return this;
    };
    EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
        if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
        this.prependListener(type, _onceWrap(this, type, listener));
        return this;
    };
    // emits a 'removeListener' event iff the listener was removed
    EventEmitter.prototype.removeListener = function removeListener(type, listener) {
        var list, events, position, i, originalListener;
        if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
        events = this._events;
        if (!events) return this;
        list = events[type];
        if (!list) return this;
        if (list === listener || list.listener && list.listener === listener) {
            if (--this._eventsCount === 0) this._events = new EventHandlers();
            else {
                delete events[type];
                if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
            }
        } else if (typeof list !== "function") {
            position = -1;
            for(i = list.length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
            }
            if (position < 0) return this;
            if (list.length === 1) {
                list[0] = undefined;
                if (--this._eventsCount === 0) {
                    this._events = new EventHandlers();
                    return this;
                } else delete events[type];
            } else spliceOne(list, position);
            if (events.removeListener) this.emit("removeListener", type, originalListener || listener);
        }
        return this;
    };
    EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
        var listeners, events;
        events = this._events;
        if (!events) return this;
        // not listening for removeListener, no need to emit
        if (!events.removeListener) {
            if (arguments.length === 0) {
                this._events = new EventHandlers();
                this._eventsCount = 0;
            } else if (events[type]) {
                if (--this._eventsCount === 0) this._events = new EventHandlers();
                else delete events[type];
            }
            return this;
        }
        // emit removeListener for all listeners on all events
        if (arguments.length === 0) {
            var keys = Object.keys(events);
            for(var i = 0, key; i < keys.length; ++i){
                key = keys[i];
                if (key === "removeListener") continue;
                this.removeAllListeners(key);
            }
            this.removeAllListeners("removeListener");
            this._events = new EventHandlers();
            this._eventsCount = 0;
            return this;
        }
        listeners = events[type];
        if (typeof listeners === "function") this.removeListener(type, listeners);
        else if (listeners) // LIFO order
        do this.removeListener(type, listeners[listeners.length - 1]);
        while (listeners[0]);
        return this;
    };
    EventEmitter.prototype.listeners = function listeners(type) {
        var evlistener;
        var ret;
        var events = this._events;
        if (!events) ret = [];
        else {
            evlistener = events[type];
            if (!evlistener) ret = [];
            else if (typeof evlistener === "function") ret = [
                evlistener.listener || evlistener
            ];
            else ret = unwrapListeners(evlistener);
        }
        return ret;
    };
    EventEmitter.listenerCount = function(emitter, type) {
        if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
        else return listenerCount.call(emitter, type);
    };
    EventEmitter.prototype.listenerCount = listenerCount;
    function listenerCount(type) {
        var events = this._events;
        if (events) {
            var evlistener = events[type];
            if (typeof evlistener === "function") return 1;
            else if (evlistener) return evlistener.length;
        }
        return 0;
    }
    EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
    };
    // About 1.5x faster than the two-arg version of Array#splice().
    function spliceOne(list, index) {
        for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
        list.pop();
    }
    function arrayClone(arr, i) {
        var copy = new Array(i);
        while(i--)copy[i] = arr[i];
        return copy;
    }
    function unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
        return ret;
    }
    var global$1 = typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var inited = false;
    function init() {
        inited = true;
        var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        for(var i = 0, len = code.length; i < len; ++i){
            lookup[i] = code[i];
            revLookup[code.charCodeAt(i)] = i;
        }
        revLookup["-".charCodeAt(0)] = 62;
        revLookup["_".charCodeAt(0)] = 63;
    }
    function toByteArray(b64) {
        if (!inited) init();
        var i, j, l, tmp, placeHolders, arr;
        var len = b64.length;
        if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        // the number of equal signs (place holders)
        // if there are two placeholders, than the two characters before it
        // represent one byte
        // if there is only one, then the three characters before it represent 2 bytes
        // this is just a cheap hack to not do indexOf twice
        placeHolders = b64[len - 2] === "=" ? 2 : b64[len - 1] === "=" ? 1 : 0;
        // base64 is 4/3 + up to two characters of the original data
        arr = new Arr(len * 3 / 4 - placeHolders);
        // if there are placeholders, only get up to the last complete 4 chars
        l = placeHolders > 0 ? len - 4 : len;
        var L = 0;
        for(i = 0, j = 0; i < l; i += 4, j += 3){
            tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
            arr[L++] = tmp >> 16 & 0xFF;
            arr[L++] = tmp >> 8 & 0xFF;
            arr[L++] = tmp & 0xFF;
        }
        if (placeHolders === 2) {
            tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
            arr[L++] = tmp & 0xFF;
        } else if (placeHolders === 1) {
            tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
            arr[L++] = tmp >> 8 & 0xFF;
            arr[L++] = tmp & 0xFF;
        }
        return arr;
    }
    function tripletToBase64(num) {
        return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
    }
    function encodeChunk(uint8, start, end) {
        var tmp;
        var output = [];
        for(var i = start; i < end; i += 3){
            tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
            output.push(tripletToBase64(tmp));
        }
        return output.join("");
    }
    function fromByteArray(uint8) {
        if (!inited) init();
        var tmp;
        var len = uint8.length;
        var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
        var output = "";
        var parts = [];
        var maxChunkLength = 16383; // must be multiple of 3
        // go through the array every three bytes, we'll deal with trailing stuff later
        for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
        // pad the end with zeros, but make sure to not forget the extra bytes
        if (extraBytes === 1) {
            tmp = uint8[len - 1];
            output += lookup[tmp >> 2];
            output += lookup[tmp << 4 & 0x3F];
            output += "==";
        } else if (extraBytes === 2) {
            tmp = (uint8[len - 2] << 8) + uint8[len - 1];
            output += lookup[tmp >> 10];
            output += lookup[tmp >> 4 & 0x3F];
            output += lookup[tmp << 2 & 0x3F];
            output += "=";
        }
        parts.push(output);
        return parts.join("");
    }
    function read(buffer, offset, isLE, mLen, nBytes) {
        var e, m;
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var nBits = -7;
        var i = isLE ? nBytes - 1 : 0;
        var d = isLE ? -1 : 1;
        var s = buffer[offset + i];
        i += d;
        e = s & (1 << -nBits) - 1;
        s >>= -nBits;
        nBits += eLen;
        for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
        m = e & (1 << -nBits) - 1;
        e >>= -nBits;
        nBits += mLen;
        for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
        if (e === 0) e = 1 - eBias;
        else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
        else {
            m = m + Math.pow(2, mLen);
            e = e - eBias;
        }
        return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
    }
    function write(buffer, value, offset, isLE, mLen, nBytes) {
        var e, m, c;
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
        var i = isLE ? 0 : nBytes - 1;
        var d = isLE ? 1 : -1;
        var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
        value = Math.abs(value);
        if (isNaN(value) || value === Infinity) {
            m = isNaN(value) ? 1 : 0;
            e = eMax;
        } else {
            e = Math.floor(Math.log(value) / Math.LN2);
            if (value * (c = Math.pow(2, -e)) < 1) {
                e--;
                c *= 2;
            }
            if (e + eBias >= 1) value += rt / c;
            else value += rt * Math.pow(2, 1 - eBias);
            if (value * c >= 2) {
                e++;
                c /= 2;
            }
            if (e + eBias >= eMax) {
                m = 0;
                e = eMax;
            } else if (e + eBias >= 1) {
                m = (value * c - 1) * Math.pow(2, mLen);
                e = e + eBias;
            } else {
                m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                e = 0;
            }
        }
        for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
        e = e << mLen | m;
        eLen += mLen;
        for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
        buffer[offset + i - d] |= s * 128;
    }
    var toString = {}.toString;
    var isArray = Array.isArray || function(arr) {
        return toString.call(arr) == "[object Array]";
    };
    var INSPECT_MAX_BYTES = 50;
    /**
   * If `Buffer.TYPED_ARRAY_SUPPORT`:
   *   === true    Use Uint8Array implementation (fastest)
   *   === false   Use Object implementation (most compatible, even IE6)
   *
   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
   * Opera 11.6+, iOS 4.2+.
   *
   * Due to various browser bugs, sometimes the Object implementation will be used even
   * when the browser supports typed arrays.
   *
   * Note:
   *
   *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
   *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
   *
   *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
   *
   *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
   *     incorrect length in some situations.

   * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
   * get the Object implementation, which is slower but behaves correctly.
   */ Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined ? global$1.TYPED_ARRAY_SUPPORT : true;
    function kMaxLength() {
        return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
    }
    function createBuffer(that, length) {
        if (kMaxLength() < length) throw new RangeError("Invalid typed array length");
        if (Buffer.TYPED_ARRAY_SUPPORT) {
            // Return an augmented `Uint8Array` instance, for best performance
            that = new Uint8Array(length);
            that.__proto__ = Buffer.prototype;
        } else {
            // Fallback: Return an object instance of the Buffer class
            if (that === null) that = new Buffer(length);
            that.length = length;
        }
        return that;
    }
    /**
   * The Buffer constructor returns instances of `Uint8Array` that have their
   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
   * returns a single octet.
   *
   * The `Uint8Array` prototype remains unmodified.
   */ function Buffer(arg, encodingOrOffset, length) {
        if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
        // Common case.
        if (typeof arg === "number") {
            if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
            return allocUnsafe(this, arg);
        }
        return from(this, arg, encodingOrOffset, length);
    }
    Buffer.poolSize = 8192; // not used by this implementation
    // TODO: Legacy, not needed anymore. Remove in next major version.
    Buffer._augment = function(arr) {
        arr.__proto__ = Buffer.prototype;
        return arr;
    };
    function from(that, value, encodingOrOffset, length) {
        if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
        if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
        if (typeof value === "string") return fromString(that, value, encodingOrOffset);
        return fromObject(that, value);
    }
    /**
   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
   * if value is a number.
   * Buffer.from(str[, encoding])
   * Buffer.from(array)
   * Buffer.from(buffer)
   * Buffer.from(arrayBuffer[, byteOffset[, length]])
   **/ Buffer.from = function(value, encodingOrOffset, length) {
        return from(null, value, encodingOrOffset, length);
    };
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        Buffer.prototype.__proto__ = Uint8Array.prototype;
        Buffer.__proto__ = Uint8Array;
    }
    function assertSize(size) {
        if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
        else if (size < 0) throw new RangeError('"size" argument must not be negative');
    }
    function alloc(that, size, fill, encoding) {
        assertSize(size);
        if (size <= 0) return createBuffer(that, size);
        if (fill !== undefined) // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpretted as a start offset.
        return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
        return createBuffer(that, size);
    }
    /**
   * Creates a new filled Buffer instance.
   * alloc(size[, fill[, encoding]])
   **/ Buffer.alloc = function(size, fill, encoding) {
        return alloc(null, size, fill, encoding);
    };
    function allocUnsafe(that, size) {
        assertSize(size);
        that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
        if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
        return that;
    }
    /**
   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
   * */ Buffer.allocUnsafe = function(size) {
        return allocUnsafe(null, size);
    };
    /**
   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
   */ Buffer.allocUnsafeSlow = function(size) {
        return allocUnsafe(null, size);
    };
    function fromString(that, string, encoding) {
        if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
        if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
        var length = byteLength(string, encoding) | 0;
        that = createBuffer(that, length);
        var actual = that.write(string, encoding);
        if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        that = that.slice(0, actual);
        return that;
    }
    function fromArrayLike(that, array) {
        var length = array.length < 0 ? 0 : checked(array.length) | 0;
        that = createBuffer(that, length);
        for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
        return that;
    }
    function fromArrayBuffer(that, array, byteOffset, length) {
        array.byteLength; // this throws if `array` is not a valid ArrayBuffer
        if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
        if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
        if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
        else if (length === undefined) array = new Uint8Array(array, byteOffset);
        else array = new Uint8Array(array, byteOffset, length);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
            // Return an augmented `Uint8Array` instance, for best performance
            that = array;
            that.__proto__ = Buffer.prototype;
        } else // Fallback: Return an object instance of the Buffer class
        that = fromArrayLike(that, array);
        return that;
    }
    function fromObject(that, obj) {
        if (internalIsBuffer(obj)) {
            var len = checked(obj.length) | 0;
            that = createBuffer(that, len);
            if (that.length === 0) return that;
            obj.copy(that, 0, 0, len);
            return that;
        }
        if (obj) {
            if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
                if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
                return fromArrayLike(that, obj);
            }
            if (obj.type === "Buffer" && isArray(obj.data)) return fromArrayLike(that, obj.data);
        }
        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
    }
    function checked(length) {
        // Note: cannot use `length < kMaxLength()` here because that fails when
        // length is NaN (which is otherwise coerced to zero.)
        if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
        return length | 0;
    }
    Buffer.isBuffer = isBuffer;
    function internalIsBuffer(b) {
        return !!(b != null && b._isBuffer);
    }
    Buffer.compare = function compare(a, b) {
        if (!internalIsBuffer(a) || !internalIsBuffer(b)) throw new TypeError("Arguments must be Buffers");
        if (a === b) return 0;
        var x = a.length;
        var y = b.length;
        for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    Buffer.isEncoding = function isEncoding(encoding) {
        switch(String(encoding).toLowerCase()){
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return true;
            default:
                return false;
        }
    };
    Buffer.concat = function concat(list, length) {
        if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (list.length === 0) return Buffer.alloc(0);
        var i;
        if (length === undefined) {
            length = 0;
            for(i = 0; i < list.length; ++i)length += list[i].length;
        }
        var buffer = Buffer.allocUnsafe(length);
        var pos = 0;
        for(i = 0; i < list.length; ++i){
            var buf = list[i];
            if (!internalIsBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
            buf.copy(buffer, pos);
            pos += buf.length;
        }
        return buffer;
    };
    function byteLength(string, encoding) {
        if (internalIsBuffer(string)) return string.length;
        if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
        if (typeof string !== "string") string = "" + string;
        var len = string.length;
        if (len === 0) return 0;
        // Use a for loop to avoid recursion
        var loweredCase = false;
        for(;;)switch(encoding){
            case "ascii":
            case "latin1":
            case "binary":
                return len;
            case "utf8":
            case "utf-8":
            case undefined:
                return utf8ToBytes(string).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return len * 2;
            case "hex":
                return len >>> 1;
            case "base64":
                return base64ToBytes(string).length;
            default:
                if (loweredCase) return utf8ToBytes(string).length // assume utf8
                ;
                encoding = ("" + encoding).toLowerCase();
                loweredCase = true;
        }
    }
    Buffer.byteLength = byteLength;
    function slowToString(encoding, start, end) {
        var loweredCase = false;
        // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
        // property of a typed array.
        // This behaves neither like String nor Uint8Array in that we set start/end
        // to their upper/lower bounds if the value passed is out of range.
        // undefined is handled specially as per ECMA-262 6th Edition,
        // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
        if (start === undefined || start < 0) start = 0;
        // Return early if start > this.length. Done here to prevent potential uint32
        // coercion fail below.
        if (start > this.length) return "";
        if (end === undefined || end > this.length) end = this.length;
        if (end <= 0) return "";
        // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
        end >>>= 0;
        start >>>= 0;
        if (end <= start) return "";
        if (!encoding) encoding = "utf8";
        while(true)switch(encoding){
            case "hex":
                return hexSlice(this, start, end);
            case "utf8":
            case "utf-8":
                return utf8Slice(this, start, end);
            case "ascii":
                return asciiSlice(this, start, end);
            case "latin1":
            case "binary":
                return latin1Slice(this, start, end);
            case "base64":
                return base64Slice(this, start, end);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return utf16leSlice(this, start, end);
            default:
                if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                encoding = (encoding + "").toLowerCase();
                loweredCase = true;
        }
    }
    // The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
    // Buffer instances.
    Buffer.prototype._isBuffer = true;
    function swap(b, n, m) {
        var i = b[n];
        b[n] = b[m];
        b[m] = i;
    }
    Buffer.prototype.swap16 = function swap16() {
        var len = this.length;
        if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
        for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
        return this;
    };
    Buffer.prototype.swap32 = function swap32() {
        var len = this.length;
        if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
        for(var i = 0; i < len; i += 4){
            swap(this, i, i + 3);
            swap(this, i + 1, i + 2);
        }
        return this;
    };
    Buffer.prototype.swap64 = function swap64() {
        var len = this.length;
        if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
        for(var i = 0; i < len; i += 8){
            swap(this, i, i + 7);
            swap(this, i + 1, i + 6);
            swap(this, i + 2, i + 5);
            swap(this, i + 3, i + 4);
        }
        return this;
    };
    Buffer.prototype.toString = function toString() {
        var length = this.length | 0;
        if (length === 0) return "";
        if (arguments.length === 0) return utf8Slice(this, 0, length);
        return slowToString.apply(this, arguments);
    };
    Buffer.prototype.equals = function equals(b) {
        if (!internalIsBuffer(b)) throw new TypeError("Argument must be a Buffer");
        if (this === b) return true;
        return Buffer.compare(this, b) === 0;
    };
    Buffer.prototype.inspect = function inspect() {
        var str = "";
        var max = INSPECT_MAX_BYTES;
        if (this.length > 0) {
            str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
            if (this.length > max) str += " ... ";
        }
        return "<Buffer " + str + ">";
    };
    Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
        if (!internalIsBuffer(target)) throw new TypeError("Argument must be a Buffer");
        if (start === undefined) start = 0;
        if (end === undefined) end = target ? target.length : 0;
        if (thisStart === undefined) thisStart = 0;
        if (thisEnd === undefined) thisEnd = this.length;
        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
        if (thisStart >= thisEnd && start >= end) return 0;
        if (thisStart >= thisEnd) return -1;
        if (start >= end) return 1;
        start >>>= 0;
        end >>>= 0;
        thisStart >>>= 0;
        thisEnd >>>= 0;
        if (this === target) return 0;
        var x = thisEnd - thisStart;
        var y = end - start;
        var len = Math.min(x, y);
        var thisCopy = this.slice(thisStart, thisEnd);
        var targetCopy = target.slice(start, end);
        for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
        // Empty buffer means no match
        if (buffer.length === 0) return -1;
        // Normalize byteOffset
        if (typeof byteOffset === "string") {
            encoding = byteOffset;
            byteOffset = 0;
        } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
        else if (byteOffset < -2147483648) byteOffset = -2147483648;
        byteOffset = +byteOffset; // Coerce to Number.
        if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : buffer.length - 1;
        // Normalize byteOffset: negative offsets start from the end of the buffer
        if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
        if (byteOffset >= buffer.length) {
            if (dir) return -1;
            else byteOffset = buffer.length - 1;
        } else if (byteOffset < 0) {
            if (dir) byteOffset = 0;
            else return -1;
        }
        // Normalize val
        if (typeof val === "string") val = Buffer.from(val, encoding);
        // Finally, search either indexOf (if dir is true) or lastIndexOf
        if (internalIsBuffer(val)) {
            // Special case: looking for empty string/buffer always fails
            if (val.length === 0) return -1;
            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
        } else if (typeof val === "number") {
            val = val & 0xFF; // Search for a byte value [0-255]
            if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
                if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
            return arrayIndexOf(buffer, [
                val
            ], byteOffset, encoding, dir);
        }
        throw new TypeError("val must be string, number or Buffer");
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
        var indexSize = 1;
        var arrLength = arr.length;
        var valLength = val.length;
        if (encoding !== undefined) {
            encoding = String(encoding).toLowerCase();
            if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
                if (arr.length < 2 || val.length < 2) return -1;
                indexSize = 2;
                arrLength /= 2;
                valLength /= 2;
                byteOffset /= 2;
            }
        }
        function read(buf, i) {
            if (indexSize === 1) return buf[i];
            else return buf.readUInt16BE(i * indexSize);
        }
        var i;
        if (dir) {
            var foundIndex = -1;
            for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1) foundIndex = i;
                if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
            } else {
                if (foundIndex !== -1) i -= i - foundIndex;
                foundIndex = -1;
            }
        } else {
            if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
            for(i = byteOffset; i >= 0; i--){
                var found = true;
                for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                }
                if (found) return i;
            }
        }
        return -1;
    }
    Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
        return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
        offset = Number(offset) || 0;
        var remaining = buf.length - offset;
        if (!length) length = remaining;
        else {
            length = Number(length);
            if (length > remaining) length = remaining;
        }
        // must be an even number of digits
        var strLen = string.length;
        if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
        if (length > strLen / 2) length = strLen / 2;
        for(var i = 0; i < length; ++i){
            var parsed = parseInt(string.substr(i * 2, 2), 16);
            if (isNaN(parsed)) return i;
            buf[offset + i] = parsed;
        }
        return i;
    }
    function utf8Write(buf, string, offset, length) {
        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
        return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function latin1Write(buf, string, offset, length) {
        return asciiWrite(buf, string, offset, length);
    }
    function base64Write(buf, string, offset, length) {
        return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer.prototype.write = function write(string, offset, length, encoding) {
        // Buffer#write(string)
        if (offset === undefined) {
            encoding = "utf8";
            length = this.length;
            offset = 0;
        // Buffer#write(string, encoding)
        } else if (length === undefined && typeof offset === "string") {
            encoding = offset;
            length = this.length;
            offset = 0;
        // Buffer#write(string, offset[, length][, encoding])
        } else if (isFinite(offset)) {
            offset = offset | 0;
            if (isFinite(length)) {
                length = length | 0;
                if (encoding === undefined) encoding = "utf8";
            } else {
                encoding = length;
                length = undefined;
            }
        // legacy write(string, encoding, offset, length) - remove in v0.13
        } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        var remaining = this.length - offset;
        if (length === undefined || length > remaining) length = remaining;
        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        if (!encoding) encoding = "utf8";
        var loweredCase = false;
        for(;;)switch(encoding){
            case "hex":
                return hexWrite(this, string, offset, length);
            case "utf8":
            case "utf-8":
                return utf8Write(this, string, offset, length);
            case "ascii":
                return asciiWrite(this, string, offset, length);
            case "latin1":
            case "binary":
                return latin1Write(this, string, offset, length);
            case "base64":
                // Warning: maxLength not taken into account in base64Write
                return base64Write(this, string, offset, length);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return ucs2Write(this, string, offset, length);
            default:
                if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                encoding = ("" + encoding).toLowerCase();
                loweredCase = true;
        }
    };
    Buffer.prototype.toJSON = function toJSON() {
        return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
        };
    };
    function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) return fromByteArray(buf);
        else return fromByteArray(buf.slice(start, end));
    }
    function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        var res = [];
        var i = start;
        while(i < end){
            var firstByte = buf[i];
            var codePoint = null;
            var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
            if (i + bytesPerSequence <= end) {
                var secondByte, thirdByte, fourthByte, tempCodePoint;
                switch(bytesPerSequence){
                    case 1:
                        if (firstByte < 0x80) codePoint = firstByte;
                        break;
                    case 2:
                        secondByte = buf[i + 1];
                        if ((secondByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                            if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                        }
                        break;
                    case 3:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                        }
                        break;
                    case 4:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        fourthByte = buf[i + 3];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                        }
                }
            }
            if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xFFFD;
                bytesPerSequence = 1;
            } else if (codePoint > 0xFFFF) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000;
                res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                codePoint = 0xDC00 | codePoint & 0x3FF;
            }
            res.push(codePoint);
            i += bytesPerSequence;
        }
        return decodeCodePointsArray(res);
    }
    // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    var MAX_ARGUMENTS_LENGTH = 0x1000;
    function decodeCodePointsArray(codePoints) {
        var len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
        ;
        // Decode in chunks to avoid "call stack size exceeded".
        var res = "";
        var i = 0;
        while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
        return res;
    }
    function asciiSlice(buf, start, end) {
        var ret = "";
        end = Math.min(buf.length, end);
        for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
        return ret;
    }
    function latin1Slice(buf, start, end) {
        var ret = "";
        end = Math.min(buf.length, end);
        for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
        return ret;
    }
    function hexSlice(buf, start, end) {
        var len = buf.length;
        if (!start || start < 0) start = 0;
        if (!end || end < 0 || end > len) end = len;
        var out = "";
        for(var i = start; i < end; ++i)out += toHex(buf[i]);
        return out;
    }
    function utf16leSlice(buf, start, end) {
        var bytes = buf.slice(start, end);
        var res = "";
        for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
        return res;
    }
    Buffer.prototype.slice = function slice(start, end) {
        var len = this.length;
        start = ~~start;
        end = end === undefined ? len : ~~end;
        if (start < 0) {
            start += len;
            if (start < 0) start = 0;
        } else if (start > len) start = len;
        if (end < 0) {
            end += len;
            if (end < 0) end = 0;
        } else if (end > len) end = len;
        if (end < start) end = start;
        var newBuf;
        if (Buffer.TYPED_ARRAY_SUPPORT) {
            newBuf = this.subarray(start, end);
            newBuf.__proto__ = Buffer.prototype;
        } else {
            var sliceLen = end - start;
            newBuf = new Buffer(sliceLen, undefined);
            for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
        }
        return newBuf;
    };
    /*
   * Need to make sure that buffer isn't trying to write out of bounds.
   */ function checkOffset(offset, ext, length) {
        if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
        if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
    }
    Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
        offset = offset | 0;
        byteLength = byteLength | 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset];
        var mul = 1;
        var i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        return val;
    };
    Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
        offset = offset | 0;
        byteLength = byteLength | 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset + --byteLength];
        var mul = 1;
        while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
        return val;
    };
    Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 1, this.length);
        return this[offset];
    };
    Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
    };
    Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
    };
    Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 4, this.length);
        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
    };
    Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
        offset = offset | 0;
        byteLength = byteLength | 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset];
        var mul = 1;
        var i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
        offset = offset | 0;
        byteLength = byteLength | 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var i = byteLength;
        var mul = 1;
        var val = this[offset + --i];
        while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 1, this.length);
        if (!(this[offset] & 0x80)) return this[offset];
        return (0xff - this[offset] + 1) * -1;
    };
    Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 2, this.length);
        var val = this[offset] | this[offset + 1] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 2, this.length);
        var val = this[offset + 1] | this[offset] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 4, this.length);
        return read(this, offset, true, 23, 4);
    };
    Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 4, this.length);
        return read(this, offset, false, 23, 4);
    };
    Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 8, this.length);
        return read(this, offset, true, 52, 8);
    };
    Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 8, this.length);
        return read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
        if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
        if (offset + ext > buf.length) throw new RangeError("Index out of range");
    }
    Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset | 0;
        byteLength = byteLength | 0;
        if (!noAssert) {
            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        var mul = 1;
        var i = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset | 0;
        byteLength = byteLength | 0;
        if (!noAssert) {
            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        var i = byteLength - 1;
        var mul = 1;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
        if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
        this[offset] = value & 0xff;
        return offset + 1;
    };
    function objectWriteUInt16(buf, value, offset, littleEndian) {
        if (value < 0) value = 0xffff + value + 1;
        for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
    }
    Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset] = value & 0xff;
            this[offset + 1] = value >>> 8;
        } else objectWriteUInt16(this, value, offset, true);
        return offset + 2;
    };
    Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset] = value >>> 8;
            this[offset + 1] = value & 0xff;
        } else objectWriteUInt16(this, value, offset, false);
        return offset + 2;
    };
    function objectWriteUInt32(buf, value, offset, littleEndian) {
        if (value < 0) value = 0xffffffff + value + 1;
        for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
    }
    Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset + 3] = value >>> 24;
            this[offset + 2] = value >>> 16;
            this[offset + 1] = value >>> 8;
            this[offset] = value & 0xff;
        } else objectWriteUInt32(this, value, offset, true);
        return offset + 4;
    };
    Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset] = value >>> 24;
            this[offset + 1] = value >>> 16;
            this[offset + 2] = value >>> 8;
            this[offset + 3] = value & 0xff;
        } else objectWriteUInt32(this, value, offset, false);
        return offset + 4;
    };
    Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) {
            var limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        var i = 0;
        var mul = 1;
        var sub = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) {
            var limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        var i = byteLength - 1;
        var mul = 1;
        var sub = 0;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
        if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
        if (value < 0) value = 0xff + value + 1;
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset] = value & 0xff;
            this[offset + 1] = value >>> 8;
        } else objectWriteUInt16(this, value, offset, true);
        return offset + 2;
    };
    Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset] = value >>> 8;
            this[offset + 1] = value & 0xff;
        } else objectWriteUInt16(this, value, offset, false);
        return offset + 2;
    };
    Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset] = value & 0xff;
            this[offset + 1] = value >>> 8;
            this[offset + 2] = value >>> 16;
            this[offset + 3] = value >>> 24;
        } else objectWriteUInt32(this, value, offset, true);
        return offset + 4;
    };
    Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        if (value < 0) value = 0xffffffff + value + 1;
        if (Buffer.TYPED_ARRAY_SUPPORT) {
            this[offset] = value >>> 24;
            this[offset + 1] = value >>> 16;
            this[offset + 2] = value >>> 8;
            this[offset + 3] = value & 0xff;
        } else objectWriteUInt32(this, value, offset, false);
        return offset + 4;
    };
    function checkIEEE754(buf, value, offset, ext, max, min) {
        if (offset + ext > buf.length) throw new RangeError("Index out of range");
        if (offset < 0) throw new RangeError("Index out of range");
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
        if (!noAssert) checkIEEE754(buf, value, offset, 4);
        write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
    }
    Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
        if (!noAssert) checkIEEE754(buf, value, offset, 8);
        write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
    }
    Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
    };
    // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer.prototype.copy = function copy(target, targetStart, start, end) {
        if (!start) start = 0;
        if (!end && end !== 0) end = this.length;
        if (targetStart >= target.length) targetStart = target.length;
        if (!targetStart) targetStart = 0;
        if (end > 0 && end < start) end = start;
        // Copy 0 bytes; we're done
        if (end === start) return 0;
        if (target.length === 0 || this.length === 0) return 0;
        // Fatal error conditions
        if (targetStart < 0) throw new RangeError("targetStart out of bounds");
        if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
        if (end < 0) throw new RangeError("sourceEnd out of bounds");
        // Are we oob?
        if (end > this.length) end = this.length;
        if (target.length - targetStart < end - start) end = target.length - targetStart + start;
        var len = end - start;
        var i;
        if (this === target && start < targetStart && targetStart < end) // descending copy from end
        for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
        else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
        for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
        else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
        return len;
    };
    // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer.prototype.fill = function fill(val, start, end, encoding) {
        // Handle string cases:
        if (typeof val === "string") {
            if (typeof start === "string") {
                encoding = start;
                start = 0;
                end = this.length;
            } else if (typeof end === "string") {
                encoding = end;
                end = this.length;
            }
            if (val.length === 1) {
                var code = val.charCodeAt(0);
                if (code < 256) val = code;
            }
            if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
            if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        } else if (typeof val === "number") val = val & 255;
        // Invalid ranges are not set to a default, so can range check early.
        if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
        if (end <= start) return this;
        start = start >>> 0;
        end = end === undefined ? this.length : end >>> 0;
        if (!val) val = 0;
        var i;
        if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
        else {
            var bytes = internalIsBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
            var len = bytes.length;
            for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
        }
        return this;
    };
    // HELPER FUNCTIONS
    // ================
    var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
    function base64clean(str) {
        // Node strips out invalid characters like \n and \t from the string, base64-js does not
        str = stringtrim(str).replace(INVALID_BASE64_RE, "");
        // Node converts strings with length < 2 to ''
        if (str.length < 2) return "";
        // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
        while(str.length % 4 !== 0)str = str + "=";
        return str;
    }
    function stringtrim(str) {
        if (str.trim) return str.trim();
        return str.replace(/^\s+|\s+$/g, "");
    }
    function toHex(n) {
        if (n < 16) return "0" + n.toString(16);
        return n.toString(16);
    }
    function utf8ToBytes(string, units) {
        units = units || Infinity;
        var codePoint;
        var length = string.length;
        var leadSurrogate = null;
        var bytes = [];
        for(var i = 0; i < length; ++i){
            codePoint = string.charCodeAt(i);
            // is surrogate component
            if (codePoint > 0xD7FF && codePoint < 0xE000) {
                // last char was a lead
                if (!leadSurrogate) {
                    // no lead yet
                    if (codePoint > 0xDBFF) {
                        // unexpected trail
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } else if (i + 1 === length) {
                        // unpaired lead
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    }
                    // valid lead
                    leadSurrogate = codePoint;
                    continue;
                }
                // 2 leads in a row
                if (codePoint < 0xDC00) {
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    leadSurrogate = codePoint;
                    continue;
                }
                // valid surrogate pair
                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
            } else if (leadSurrogate) // valid bmp char, but last char was a lead
            {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            }
            leadSurrogate = null;
            // encode utf8
            if (codePoint < 0x80) {
                if ((units -= 1) < 0) break;
                bytes.push(codePoint);
            } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break;
                bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break;
                bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break;
                bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else throw new Error("Invalid code point");
        }
        return bytes;
    }
    function asciiToBytes(str) {
        var byteArray = [];
        for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
        return byteArray;
    }
    function utf16leToBytes(str, units) {
        var c, hi, lo;
        var byteArray = [];
        for(var i = 0; i < str.length; ++i){
            if ((units -= 2) < 0) break;
            c = str.charCodeAt(i);
            hi = c >> 8;
            lo = c % 256;
            byteArray.push(lo);
            byteArray.push(hi);
        }
        return byteArray;
    }
    function base64ToBytes(str) {
        return toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
        for(var i = 0; i < length; ++i){
            if (i + offset >= dst.length || i >= src.length) break;
            dst[i + offset] = src[i];
        }
        return i;
    }
    function isnan(val) {
        return val !== val // eslint-disable-line no-self-compare
        ;
    }
    // the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
    // The _isBuffer check is for Safari 5-7 support, because it's missing
    // Object.prototype.constructor. Remove this eventually
    function isBuffer(obj) {
        return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj));
    }
    function isFastBuffer(obj) {
        return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
    }
    // For Node v0.10 support. Remove this eventually.
    function isSlowBuffer(obj) {
        return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isFastBuffer(obj.slice(0, 0));
    }
    // shim for using process in browser
    // based off https://github.com/defunctzombie/node-process/blob/master/browser.js
    function defaultSetTimout() {
        throw new Error("setTimeout has not been defined");
    }
    function defaultClearTimeout() {
        throw new Error("clearTimeout has not been defined");
    }
    var cachedSetTimeout = defaultSetTimout;
    var cachedClearTimeout = defaultClearTimeout;
    if (typeof global$1.setTimeout === "function") cachedSetTimeout = setTimeout;
    if (typeof global$1.clearTimeout === "function") cachedClearTimeout = clearTimeout;
    function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
        return setTimeout(fun, 0);
        // if setTimeout wasn't available but was latter defined
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
        }
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
        } catch (e) {
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                return cachedSetTimeout.call(this, fun, 0);
            }
        }
    }
    function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
        return clearTimeout(marker);
        // if clearTimeout wasn't available but was latter defined
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
        }
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
        } catch (e) {
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                return cachedClearTimeout.call(null, marker);
            } catch (e) {
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                return cachedClearTimeout.call(this, marker);
            }
        }
    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;
    function cleanUpNextTick() {
        if (!draining || !currentQueue) return;
        draining = false;
        if (currentQueue.length) queue = currentQueue.concat(queue);
        else queueIndex = -1;
        if (queue.length) drainQueue();
    }
    function drainQueue() {
        if (draining) return;
        var timeout = runTimeout(cleanUpNextTick);
        draining = true;
        var len = queue.length;
        while(len){
            currentQueue = queue;
            queue = [];
            while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
            queueIndex = -1;
            len = queue.length;
        }
        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
    }
    function nextTick(fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
        queue.push(new Item(fun, args));
        if (queue.length === 1 && !draining) runTimeout(drainQueue);
    }
    // v8 likes predictible objects
    function Item(fun, array) {
        this.fun = fun;
        this.array = array;
    }
    Item.prototype.run = function() {
        this.fun.apply(null, this.array);
    };
    // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
    var performance = global$1.performance || {};
    var performanceNow = performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function() {
        return new Date().getTime();
    };
    var inherits;
    if (typeof Object.create === "function") inherits = function inherits(ctor, superCtor) {
        // implementation from standard node.js 'util' module
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    };
    else inherits = function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    };
    var inherits$1 = inherits;
    var formatRegExp = /%[sdj%]/g;
    function format(f) {
        if (!isString(f)) {
            var objects = [];
            for(var i = 0; i < arguments.length; i++)objects.push(inspect(arguments[i]));
            return objects.join(" ");
        }
        var i = 1;
        var args = arguments;
        var len = args.length;
        var str = String(f).replace(formatRegExp, function(x) {
            if (x === "%%") return "%";
            if (i >= len) return x;
            switch(x){
                case "%s":
                    return String(args[i++]);
                case "%d":
                    return Number(args[i++]);
                case "%j":
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return "[Circular]";
                    }
                default:
                    return x;
            }
        });
        for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += " " + x;
        else str += " " + inspect(x);
        return str;
    }
    // Mark that a method should not be used.
    // Returns a modified function which warns once by default.
    // If --no-deprecation is set, then it is a no-op.
    function deprecate(fn, msg) {
        // Allow for deprecating things in the process of starting up.
        if (isUndefined(global$1.process)) return function() {
            return deprecate(fn, msg).apply(this, arguments);
        };
        var warned = false;
        function deprecated() {
            if (!warned) {
                console.error(msg);
                warned = true;
            }
            return fn.apply(this, arguments);
        }
        return deprecated;
    }
    var debugs = {};
    var debugEnviron;
    function debuglog(set) {
        if (isUndefined(debugEnviron)) debugEnviron = "";
        set = set.toUpperCase();
        if (!debugs[set]) {
            if (new RegExp("\\b" + set + "\\b", "i").test(debugEnviron)) {
                var pid = 0;
                debugs[set] = function() {
                    var msg = format.apply(null, arguments);
                    console.error("%s %d: %s", set, pid, msg);
                };
            } else debugs[set] = function() {};
        }
        return debugs[set];
    }
    /**
   * Echos the value of a value. Trys to print the value out
   * in the best way possible given the different types.
   *
   * @param {Object} obj The object to print out.
   * @param {Object} opts Optional options object that alters the output.
   */ /* legacy: obj, showHidden, depth, colors*/ function inspect(obj, opts) {
        // default options
        var ctx = {
            seen: [],
            stylize: stylizeNoColor
        };
        // legacy...
        if (arguments.length >= 3) ctx.depth = arguments[2];
        if (arguments.length >= 4) ctx.colors = arguments[3];
        if (isBoolean(opts)) // legacy...
        ctx.showHidden = opts;
        else if (opts) // got an "options" object
        _extend(ctx, opts);
        // set default options
        if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
        if (isUndefined(ctx.depth)) ctx.depth = 2;
        if (isUndefined(ctx.colors)) ctx.colors = false;
        if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
        if (ctx.colors) ctx.stylize = stylizeWithColor;
        return formatValue(ctx, obj, ctx.depth);
    }
    // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
    inspect.colors = {
        "bold": [
            1,
            22
        ],
        "italic": [
            3,
            23
        ],
        "underline": [
            4,
            24
        ],
        "inverse": [
            7,
            27
        ],
        "white": [
            37,
            39
        ],
        "grey": [
            90,
            39
        ],
        "black": [
            30,
            39
        ],
        "blue": [
            34,
            39
        ],
        "cyan": [
            36,
            39
        ],
        "green": [
            32,
            39
        ],
        "magenta": [
            35,
            39
        ],
        "red": [
            31,
            39
        ],
        "yellow": [
            33,
            39
        ]
    };
    // Don't use 'blue' not visible on cmd.exe
    inspect.styles = {
        "special": "cyan",
        "number": "yellow",
        "boolean": "yellow",
        "undefined": "grey",
        "null": "bold",
        "string": "green",
        "date": "magenta",
        // "name": intentionally not styling
        "regexp": "red"
    };
    function stylizeWithColor(str, styleType) {
        var style = inspect.styles[styleType];
        if (style) return "\x1b[" + inspect.colors[style][0] + "m" + str + "\x1b[" + inspect.colors[style][1] + "m";
        else return str;
    }
    function stylizeNoColor(str, styleType) {
        return str;
    }
    function arrayToHash(array) {
        var hash = {};
        array.forEach(function(val, idx) {
            hash[val] = true;
        });
        return hash;
    }
    function formatValue(ctx, value, recurseTimes) {
        // Provide a hook for user-specified inspect functions.
        // Check that value is an object with an inspect function on it
        if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
        value.inspect !== inspect && // Also filter out any prototype objects using the circular check.
        !(value.constructor && value.constructor.prototype === value)) {
            var ret = value.inspect(recurseTimes, ctx);
            if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
            return ret;
        }
        // Primitive types cannot have properties
        var primitive = formatPrimitive(ctx, value);
        if (primitive) return primitive;
        // Look up the keys of the object.
        var keys = Object.keys(value);
        var visibleKeys = arrayToHash(keys);
        if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
        // IE doesn't make error fields non-enumerable
        // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
        if (isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return formatError(value);
        // Some type of object without properties can be shortcutted.
        if (keys.length === 0) {
            if (isFunction(value)) {
                var name = value.name ? ": " + value.name : "";
                return ctx.stylize("[Function" + name + "]", "special");
            }
            if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
            if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
            if (isError(value)) return formatError(value);
        }
        var base = "", array = false, braces = [
            "{",
            "}"
        ];
        // Make Array say that they are Array
        if (isArray$1(value)) {
            array = true;
            braces = [
                "[",
                "]"
            ];
        }
        // Make functions say that they are functions
        if (isFunction(value)) {
            var n = value.name ? ": " + value.name : "";
            base = " [Function" + n + "]";
        }
        // Make RegExps say that they are RegExps
        if (isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
        // Make dates with properties first say the date
        if (isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
        // Make error with message first say the error
        if (isError(value)) base = " " + formatError(value);
        if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
        if (recurseTimes < 0) {
            if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
            else return ctx.stylize("[Object]", "special");
        }
        ctx.seen.push(value);
        var output;
        if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
        else output = keys.map(function(key) {
            return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
        });
        ctx.seen.pop();
        return reduceToSingleString(output, base, braces);
    }
    function formatPrimitive(ctx, value) {
        if (isUndefined(value)) return ctx.stylize("undefined", "undefined");
        if (isString(value)) {
            var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
            return ctx.stylize(simple, "string");
        }
        if (isNumber(value)) return ctx.stylize("" + value, "number");
        if (isBoolean(value)) return ctx.stylize("" + value, "boolean");
        // For some reason typeof null is "object", so special case here.
        if (isNull(value)) return ctx.stylize("null", "null");
    }
    function formatError(value) {
        return "[" + Error.prototype.toString.call(value) + "]";
    }
    function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
        var output = [];
        for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
        else output.push("");
        keys.forEach(function(key) {
            if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
        });
        return output;
    }
    function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
        var name, str, desc;
        desc = Object.getOwnPropertyDescriptor(value, key) || {
            value: value[key]
        };
        if (desc.get) {
            if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
            else str = ctx.stylize("[Getter]", "special");
        } else if (desc.set) str = ctx.stylize("[Setter]", "special");
        if (!hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
        if (!str) {
            if (ctx.seen.indexOf(desc.value) < 0) {
                if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
                else str = formatValue(ctx, desc.value, recurseTimes - 1);
                if (str.indexOf("\n") > -1) {
                    if (array) str = str.split("\n").map(function(line) {
                        return "  " + line;
                    }).join("\n").substr(2);
                    else str = "\n" + str.split("\n").map(function(line) {
                        return "   " + line;
                    }).join("\n");
                }
            } else str = ctx.stylize("[Circular]", "special");
        }
        if (isUndefined(name)) {
            if (array && key.match(/^\d+$/)) return str;
            name = JSON.stringify("" + key);
            if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                name = name.substr(1, name.length - 2);
                name = ctx.stylize(name, "name");
            } else {
                name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
                name = ctx.stylize(name, "string");
            }
        }
        return name + ": " + str;
    }
    function reduceToSingleString(output, base, braces) {
        var length = output.reduce(function(prev, cur) {
            cur.indexOf("\n");
            return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0);
        if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
        return braces[0] + base + " " + output.join(", ") + " " + braces[1];
    }
    // NOTE: These type checking functions intentionally don't use `instanceof`
    // because it is fragile and can be easily faked with `Object.create()`.
    function isArray$1(ar) {
        return Array.isArray(ar);
    }
    function isBoolean(arg) {
        return typeof arg === "boolean";
    }
    function isNull(arg) {
        return arg === null;
    }
    function isNumber(arg) {
        return typeof arg === "number";
    }
    function isString(arg) {
        return typeof arg === "string";
    }
    function isUndefined(arg) {
        return arg === void 0;
    }
    function isRegExp(re) {
        return isObject(re) && objectToString(re) === "[object RegExp]";
    }
    function isObject(arg) {
        return typeof arg === "object" && arg !== null;
    }
    function isDate(d) {
        return isObject(d) && objectToString(d) === "[object Date]";
    }
    function isError(e) {
        return isObject(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
    }
    function isFunction(arg) {
        return typeof arg === "function";
    }
    function objectToString(o) {
        return Object.prototype.toString.call(o);
    }
    function _extend(origin, add) {
        // Don't do anything if add isn't an object
        if (!add || !isObject(add)) return origin;
        var keys = Object.keys(add);
        var i = keys.length;
        while(i--)origin[keys[i]] = add[keys[i]];
        return origin;
    }
    function hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    function BufferList() {
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function(s) {
        if (this.length === 0) return "";
        var p = this.head;
        var ret = "" + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function(n) {
        if (this.length === 0) return Buffer.alloc(0);
        if (this.length === 1) return this.head.data;
        var ret = Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            p.data.copy(ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    // Copyright Joyent, Inc. and other Node contributors.
    var isBufferEncoding = Buffer.isEncoding || function(encoding) {
        switch(encoding && encoding.toLowerCase()){
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
            case "raw":
                return true;
            default:
                return false;
        }
    };
    function assertEncoding(encoding) {
        if (encoding && !isBufferEncoding(encoding)) throw new Error("Unknown encoding: " + encoding);
    }
    // StringDecoder provides an interface for efficiently splitting a series of
    // buffers into a series of JS strings without breaking apart multi-byte
    // characters. CESU-8 is handled as part of the UTF-8 encoding.
    //
    // @TODO Handling all encodings inside a single object makes it very difficult
    // to reason about this code, so it should be split up in the future.
    // @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
    // points as used by CESU-8.
    function StringDecoder(encoding) {
        this.encoding = (encoding || "utf8").toLowerCase().replace(/[-_]/, "");
        assertEncoding(encoding);
        switch(this.encoding){
            case "utf8":
                // CESU-8 represents each of Surrogate Pair by 3-bytes
                this.surrogateSize = 3;
                break;
            case "ucs2":
            case "utf16le":
                // UTF-16 represents each of Surrogate Pair by 2-bytes
                this.surrogateSize = 2;
                this.detectIncompleteChar = utf16DetectIncompleteChar;
                break;
            case "base64":
                // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
                this.surrogateSize = 3;
                this.detectIncompleteChar = base64DetectIncompleteChar;
                break;
            default:
                this.write = passThroughWrite;
                return;
        }
        // Enough space to store all bytes of a single character. UTF-8 needs 4
        // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
        this.charBuffer = new Buffer(6);
        // Number of bytes received for the current incomplete multi-byte character.
        this.charReceived = 0;
        // Number of bytes expected for the current incomplete multi-byte character.
        this.charLength = 0;
    }
    // write decodes the given buffer and returns it as JS string that is
    // guaranteed to not contain any partial multi-byte characters. Any partial
    // character found at the end of the buffer is buffered up, and will be
    // returned when calling write again with the remaining bytes.
    //
    // Note: Converting a Buffer containing an orphan surrogate to a String
    // currently works, but converting a String to a Buffer (via `new Buffer`, or
    // Buffer#write) will replace incomplete surrogates with the unicode
    // replacement character. See https://codereview.chromium.org/121173009/ .
    StringDecoder.prototype.write = function(buffer) {
        var charStr = "";
        // if our last write ended with an incomplete multibyte character
        while(this.charLength){
            // determine how many remaining bytes this buffer has to offer for this char
            var available = buffer.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : buffer.length;
            // add the new bytes to the char buffer
            buffer.copy(this.charBuffer, this.charReceived, 0, available);
            this.charReceived += available;
            if (this.charReceived < this.charLength) // still not enough chars in this buffer? wait for more ...
            return "";
            // remove bytes belonging to the current character from the buffer
            buffer = buffer.slice(available, buffer.length);
            // get the character that was split
            charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
            // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
            var charCode = charStr.charCodeAt(charStr.length - 1);
            if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                this.charLength += this.surrogateSize;
                charStr = "";
                continue;
            }
            this.charReceived = this.charLength = 0;
            // if there are no more bytes in this buffer, just emit our char
            if (buffer.length === 0) return charStr;
            break;
        }
        // determine and set charLength / charReceived
        this.detectIncompleteChar(buffer);
        var end = buffer.length;
        if (this.charLength) {
            // buffer the incomplete character bytes we got
            buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
            end -= this.charReceived;
        }
        charStr += buffer.toString(this.encoding, 0, end);
        var end = charStr.length - 1;
        var charCode = charStr.charCodeAt(end);
        // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
        if (charCode >= 0xD800 && charCode <= 0xDBFF) {
            var size = this.surrogateSize;
            this.charLength += size;
            this.charReceived += size;
            this.charBuffer.copy(this.charBuffer, size, 0, size);
            buffer.copy(this.charBuffer, 0, 0, size);
            return charStr.substring(0, end);
        }
        // or just emit the charStr
        return charStr;
    };
    // detectIncompleteChar determines if there is an incomplete UTF-8 character at
    // the end of the given buffer. If so, it sets this.charLength to the byte
    // length that character, and sets this.charReceived to the number of bytes
    // that are available for this character.
    StringDecoder.prototype.detectIncompleteChar = function(buffer) {
        // determine how many bytes we have to check at the end of this buffer
        var i = buffer.length >= 3 ? 3 : buffer.length;
        // Figure out if one of the last i bytes of our buffer announces an
        // incomplete char.
        for(; i > 0; i--){
            var c = buffer[buffer.length - i];
            // See http://en.wikipedia.org/wiki/UTF-8#Description
            // 110XXXXX
            if (i == 1 && c >> 5 == 0x06) {
                this.charLength = 2;
                break;
            }
            // 1110XXXX
            if (i <= 2 && c >> 4 == 0x0E) {
                this.charLength = 3;
                break;
            }
            // 11110XXX
            if (i <= 3 && c >> 3 == 0x1E) {
                this.charLength = 4;
                break;
            }
        }
        this.charReceived = i;
    };
    StringDecoder.prototype.end = function(buffer) {
        var res = "";
        if (buffer && buffer.length) res = this.write(buffer);
        if (this.charReceived) {
            var cr = this.charReceived;
            var buf = this.charBuffer;
            var enc = this.encoding;
            res += buf.slice(0, cr).toString(enc);
        }
        return res;
    };
    function passThroughWrite(buffer) {
        return buffer.toString(this.encoding);
    }
    function utf16DetectIncompleteChar(buffer) {
        this.charReceived = buffer.length % 2;
        this.charLength = this.charReceived ? 2 : 0;
    }
    function base64DetectIncompleteChar(buffer) {
        this.charReceived = buffer.length % 3;
        this.charLength = this.charReceived ? 3 : 0;
    }
    Readable.ReadableState = ReadableState;
    var debug = debuglog("stream");
    inherits$1(Readable, EventEmitter);
    function prependListener(emitter, event, fn) {
        // Sadly this is not cacheable as some libraries bundle their own
        // event emitter implementation with them.
        if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
        else {
            // This is a hack to make sure that our error handler is attached before any
            // userland ones.  NEVER DO THIS. This is here only because this code needs
            // to continue to work with older versions of Node.js that do not include
            // the prependListener() method. The goal is to eventually remove this hack.
            if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
            else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
            else emitter._events[event] = [
                fn,
                emitter._events[event]
            ];
        }
    }
    function listenerCount$1(emitter, type) {
        return emitter.listeners(type).length;
    }
    function ReadableState(options, stream) {
        options = options || {};
        // object stream flag. Used to make read(n) ignore n and to
        // make all the buffer merging and length checks go away
        this.objectMode = !!options.objectMode;
        if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
        // the point at which it stops calling _read() to fill the buffer
        // Note: 0 is a valid value, means "don't call _read preemptively ever"
        var hwm = options.highWaterMark;
        var defaultHwm = this.objectMode ? 16 : 16384;
        this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
        // cast to ints.
        this.highWaterMark = ~~this.highWaterMark;
        // A linked list is used to store data chunks instead of an array because the
        // linked list can remove elements from the beginning faster than
        // array.shift()
        this.buffer = new BufferList();
        this.length = 0;
        this.pipes = null;
        this.pipesCount = 0;
        this.flowing = null;
        this.ended = false;
        this.endEmitted = false;
        this.reading = false;
        // a flag to be able to tell if the onwrite cb is called immediately,
        // or on a later tick.  We set this to true at first, because any
        // actions that shouldn't happen until "later" should generally also
        // not happen before the first write call.
        this.sync = true;
        // whenever we return null, then we set a flag to say
        // that we're awaiting a 'readable' event emission.
        this.needReadable = false;
        this.emittedReadable = false;
        this.readableListening = false;
        this.resumeScheduled = false;
        // Crypto is kind of old and crusty.  Historically, its default string
        // encoding is 'binary' so we have to make this configurable.
        // Everything else in the universe uses 'utf8', though.
        this.defaultEncoding = options.defaultEncoding || "utf8";
        // when piping, we only care about 'readable' events that happen
        // after read()ing all the bytes and not getting any pushback.
        this.ranOut = false;
        // the number of writers that are awaiting a drain event in .pipe()s
        this.awaitDrain = 0;
        // if true, a maybeReadMore has been scheduled
        this.readingMore = false;
        this.decoder = null;
        this.encoding = null;
        if (options.encoding) {
            this.decoder = new StringDecoder(options.encoding);
            this.encoding = options.encoding;
        }
    }
    function Readable(options) {
        if (!(this instanceof Readable)) return new Readable(options);
        this._readableState = new ReadableState(options, this);
        // legacy
        this.readable = true;
        if (options && typeof options.read === "function") this._read = options.read;
        EventEmitter.call(this);
    }
    // Manually shove something into the read() buffer.
    // This returns true if the highWaterMark has not been hit yet,
    // similar to how Writable.write() returns true if you should
    // write() some more.
    Readable.prototype.push = function(chunk, encoding) {
        var state = this._readableState;
        if (!state.objectMode && typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = Buffer.from(chunk, encoding);
                encoding = "";
            }
        }
        return readableAddChunk(this, state, chunk, encoding, false);
    };
    // Unshift should *always* be something directly out of read()
    Readable.prototype.unshift = function(chunk) {
        var state = this._readableState;
        return readableAddChunk(this, state, chunk, "", true);
    };
    Readable.prototype.isPaused = function() {
        return this._readableState.flowing === false;
    };
    function readableAddChunk(stream, state, chunk, encoding, addToFront) {
        var er = chunkInvalid(state, chunk);
        if (er) stream.emit("error", er);
        else if (chunk === null) {
            state.reading = false;
            onEofChunk(stream, state);
        } else if (state.objectMode || chunk && chunk.length > 0) {
            if (state.ended && !addToFront) {
                var e = new Error("stream.push() after EOF");
                stream.emit("error", e);
            } else if (state.endEmitted && addToFront) {
                var _e = new Error("stream.unshift() after end event");
                stream.emit("error", _e);
            } else {
                var skipAdd;
                if (state.decoder && !addToFront && !encoding) {
                    chunk = state.decoder.write(chunk);
                    skipAdd = !state.objectMode && chunk.length === 0;
                }
                if (!addToFront) state.reading = false;
                // Don't add to the buffer if we've decoded to an empty string chunk and
                // we're not in object mode
                if (!skipAdd) {
                    // if we want the data now, just emit it.
                    if (state.flowing && state.length === 0 && !state.sync) {
                        stream.emit("data", chunk);
                        stream.read(0);
                    } else {
                        // update the buffer info.
                        state.length += state.objectMode ? 1 : chunk.length;
                        if (addToFront) state.buffer.unshift(chunk);
                        else state.buffer.push(chunk);
                        if (state.needReadable) emitReadable(stream);
                    }
                }
                maybeReadMore(stream, state);
            }
        } else if (!addToFront) state.reading = false;
        return needMoreData(state);
    }
    // if it's past the high water mark, we can push in some more.
    // Also, if we have no data yet, we can stand some
    // more bytes.  This is to work around cases where hwm=0,
    // such as the repl.  Also, if the push() triggered a
    // readable event, and the user called read(largeNumber) such that
    // needReadable was set, then we ought to push more, so that another
    // 'readable' event will be triggered.
    function needMoreData(state) {
        return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
    }
    // backwards compatibility.
    Readable.prototype.setEncoding = function(enc) {
        this._readableState.decoder = new StringDecoder(enc);
        this._readableState.encoding = enc;
        return this;
    };
    // Don't raise the hwm > 8MB
    var MAX_HWM = 0x800000;
    function computeNewHighWaterMark(n) {
        if (n >= MAX_HWM) n = MAX_HWM;
        else {
            // Get the next highest power of 2 to prevent increasing hwm excessively in
            // tiny amounts
            n--;
            n |= n >>> 1;
            n |= n >>> 2;
            n |= n >>> 4;
            n |= n >>> 8;
            n |= n >>> 16;
            n++;
        }
        return n;
    }
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function howMuchToRead(n, state) {
        if (n <= 0 || state.length === 0 && state.ended) return 0;
        if (state.objectMode) return 1;
        if (n !== n) {
            // Only flow one buffer at a time
            if (state.flowing && state.length) return state.buffer.head.data.length;
            else return state.length;
        }
        // If we're asking for more than the current hwm, then raise the hwm.
        if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
        if (n <= state.length) return n;
        // Don't have enough
        if (!state.ended) {
            state.needReadable = true;
            return 0;
        }
        return state.length;
    }
    // you can override either this method, or the async _read(n) below.
    Readable.prototype.read = function(n) {
        debug("read", n);
        n = parseInt(n, 10);
        var state = this._readableState;
        var nOrig = n;
        if (n !== 0) state.emittedReadable = false;
        // if we're doing read(0) to trigger a readable event, but we
        // already have a bunch of data in the buffer, then just trigger
        // the 'readable' event and move on.
        if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
            debug("read: emitReadable", state.length, state.ended);
            if (state.length === 0 && state.ended) endReadable(this);
            else emitReadable(this);
            return null;
        }
        n = howMuchToRead(n, state);
        // if we've ended, and we're now clear, then finish it up.
        if (n === 0 && state.ended) {
            if (state.length === 0) endReadable(this);
            return null;
        }
        // All the actual chunk generation logic needs to be
        // *below* the call to _read.  The reason is that in certain
        // synthetic stream cases, such as passthrough streams, _read
        // may be a completely synchronous operation which may change
        // the state of the read buffer, providing enough data when
        // before there was *not* enough.
        //
        // So, the steps are:
        // 1. Figure out what the state of things will be after we do
        // a read from the buffer.
        //
        // 2. If that resulting state will trigger a _read, then call _read.
        // Note that this may be asynchronous, or synchronous.  Yes, it is
        // deeply ugly to write APIs this way, but that still doesn't mean
        // that the Readable class should behave improperly, as streams are
        // designed to be sync/async agnostic.
        // Take note if the _read call is sync or async (ie, if the read call
        // has returned yet), so that we know whether or not it's safe to emit
        // 'readable' etc.
        //
        // 3. Actually pull the requested chunks out of the buffer and return.
        // if we need a readable event, then we need to do some reading.
        var doRead = state.needReadable;
        debug("need readable", doRead);
        // if we currently have less than the highWaterMark, then also read some
        if (state.length === 0 || state.length - n < state.highWaterMark) {
            doRead = true;
            debug("length less than watermark", doRead);
        }
        // however, if we've ended, then there's no point, and if we're already
        // reading, then it's unnecessary.
        if (state.ended || state.reading) {
            doRead = false;
            debug("reading or ended", doRead);
        } else if (doRead) {
            debug("do read");
            state.reading = true;
            state.sync = true;
            // if the length is currently zero, then we *need* a readable event.
            if (state.length === 0) state.needReadable = true;
            // call internal read method
            this._read(state.highWaterMark);
            state.sync = false;
            // If _read pushed data synchronously, then `reading` will be false,
            // and we need to re-evaluate how much data we can return to the user.
            if (!state.reading) n = howMuchToRead(nOrig, state);
        }
        var ret;
        if (n > 0) ret = fromList(n, state);
        else ret = null;
        if (ret === null) {
            state.needReadable = true;
            n = 0;
        } else state.length -= n;
        if (state.length === 0) {
            // If we have nothing in the buffer, then we want to know
            // as soon as we *do* get something into the buffer.
            if (!state.ended) state.needReadable = true;
            // If we tried to read() past the EOF, then emit end on the next tick.
            if (nOrig !== n && state.ended) endReadable(this);
        }
        if (ret !== null) this.emit("data", ret);
        return ret;
    };
    function chunkInvalid(state, chunk) {
        var er = null;
        if (!isBuffer(chunk) && typeof chunk !== "string" && chunk !== null && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
        return er;
    }
    function onEofChunk(stream, state) {
        if (state.ended) return;
        if (state.decoder) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) {
                state.buffer.push(chunk);
                state.length += state.objectMode ? 1 : chunk.length;
            }
        }
        state.ended = true;
        // emit 'readable' now to make sure it gets picked up.
        emitReadable(stream);
    }
    // Don't emit readable right away in sync mode, because this can trigger
    // another read() call => stack overflow.  This way, it might trigger
    // a nextTick recursion warning, but that's not so bad.
    function emitReadable(stream) {
        var state = stream._readableState;
        state.needReadable = false;
        if (!state.emittedReadable) {
            debug("emitReadable", state.flowing);
            state.emittedReadable = true;
            if (state.sync) nextTick(emitReadable_, stream);
            else emitReadable_(stream);
        }
    }
    function emitReadable_(stream) {
        debug("emit readable");
        stream.emit("readable");
        flow(stream);
    }
    // at this point, the user has presumably seen the 'readable' event,
    // and called read() to consume some data.  that may have triggered
    // in turn another _read(n) call, in which case reading = true if
    // it's in progress.
    // However, if we're not ended, or reading, and the length < hwm,
    // then go ahead and try to read some more preemptively.
    function maybeReadMore(stream, state) {
        if (!state.readingMore) {
            state.readingMore = true;
            nextTick(maybeReadMore_, stream, state);
        }
    }
    function maybeReadMore_(stream, state) {
        var len = state.length;
        while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
            debug("maybeReadMore read 0");
            stream.read(0);
            if (len === state.length) break;
            else len = state.length;
        }
        state.readingMore = false;
    }
    // abstract method.  to be overridden in specific implementation classes.
    // call cb(er, data) where data is <= n in length.
    // for virtual (non-string, non-buffer) streams, "length" is somewhat
    // arbitrary, and perhaps not very meaningful.
    Readable.prototype._read = function(n) {
        this.emit("error", new Error("not implemented"));
    };
    Readable.prototype.pipe = function(dest, pipeOpts) {
        var src = this;
        var state = this._readableState;
        switch(state.pipesCount){
            case 0:
                state.pipes = dest;
                break;
            case 1:
                state.pipes = [
                    state.pipes,
                    dest
                ];
                break;
            default:
                state.pipes.push(dest);
                break;
        }
        state.pipesCount += 1;
        debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
        var doEnd = !pipeOpts || pipeOpts.end !== false;
        var endFn = doEnd ? onend : cleanup;
        if (state.endEmitted) nextTick(endFn);
        else src.once("end", endFn);
        dest.on("unpipe", onunpipe);
        function onunpipe(readable) {
            debug("onunpipe");
            if (readable === src) cleanup();
        }
        function onend() {
            debug("onend");
            dest.end();
        }
        // when the dest drains, it reduces the awaitDrain counter
        // on the source.  This would be more elegant with a .once()
        // handler in flow(), but adding and removing repeatedly is
        // too slow.
        var ondrain = pipeOnDrain(src);
        dest.on("drain", ondrain);
        var cleanedUp = false;
        function cleanup() {
            debug("cleanup");
            // cleanup event handlers once the pipe is broken
            dest.removeListener("close", onclose);
            dest.removeListener("finish", onfinish);
            dest.removeListener("drain", ondrain);
            dest.removeListener("error", onerror);
            dest.removeListener("unpipe", onunpipe);
            src.removeListener("end", onend);
            src.removeListener("end", cleanup);
            src.removeListener("data", ondata);
            cleanedUp = true;
            // if the reader is waiting for a drain event from this
            // specific writer, then it would cause it to never start
            // flowing again.
            // So, if this is awaiting a drain, then we just call it now.
            // If we don't know, then assume that we are waiting for one.
            if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
        }
        // If the user pushes more data while we're writing to dest then we'll end up
        // in ondata again. However, we only want to increase awaitDrain once because
        // dest will only emit one 'drain' event for the multiple writes.
        // => Introduce a guard on increasing awaitDrain.
        var increasedAwaitDrain = false;
        src.on("data", ondata);
        function ondata(chunk) {
            debug("ondata");
            increasedAwaitDrain = false;
            var ret = dest.write(chunk);
            if (false === ret && !increasedAwaitDrain) {
                // If the user unpiped during `dest.write()`, it is possible
                // to get stuck in a permanently paused state if that write
                // also returned false.
                // => Check whether `dest` is still a piping destination.
                if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                    debug("false write response, pause", src._readableState.awaitDrain);
                    src._readableState.awaitDrain++;
                    increasedAwaitDrain = true;
                }
                src.pause();
            }
        }
        // if the dest has an error, then stop piping into it.
        // however, don't suppress the throwing behavior for this.
        function onerror(er) {
            debug("onerror", er);
            unpipe();
            dest.removeListener("error", onerror);
            if (listenerCount$1(dest, "error") === 0) dest.emit("error", er);
        }
        // Make sure our error handler is attached before userland ones.
        prependListener(dest, "error", onerror);
        // Both close and finish should trigger unpipe, but only once.
        function onclose() {
            dest.removeListener("finish", onfinish);
            unpipe();
        }
        dest.once("close", onclose);
        function onfinish() {
            debug("onfinish");
            dest.removeListener("close", onclose);
            unpipe();
        }
        dest.once("finish", onfinish);
        function unpipe() {
            debug("unpipe");
            src.unpipe(dest);
        }
        // tell the dest that it's being piped to
        dest.emit("pipe", src);
        // start the flow if it hasn't been started already.
        if (!state.flowing) {
            debug("pipe resume");
            src.resume();
        }
        return dest;
    };
    function pipeOnDrain(src) {
        return function() {
            var state = src._readableState;
            debug("pipeOnDrain", state.awaitDrain);
            if (state.awaitDrain) state.awaitDrain--;
            if (state.awaitDrain === 0 && src.listeners("data").length) {
                state.flowing = true;
                flow(src);
            }
        };
    }
    Readable.prototype.unpipe = function(dest) {
        var state = this._readableState;
        // if we're not piping anywhere, then do nothing.
        if (state.pipesCount === 0) return this;
        // just one destination.  most common case.
        if (state.pipesCount === 1) {
            // passed in one, but it's not the right one.
            if (dest && dest !== state.pipes) return this;
            if (!dest) dest = state.pipes;
            // got a match.
            state.pipes = null;
            state.pipesCount = 0;
            state.flowing = false;
            if (dest) dest.emit("unpipe", this);
            return this;
        }
        // slow case. multiple pipe destinations.
        if (!dest) {
            // remove all.
            var dests = state.pipes;
            var len = state.pipesCount;
            state.pipes = null;
            state.pipesCount = 0;
            state.flowing = false;
            for(var _i = 0; _i < len; _i++)dests[_i].emit("unpipe", this);
            return this;
        }
        // try to find the right one.
        var i = indexOf(state.pipes, dest);
        if (i === -1) return this;
        state.pipes.splice(i, 1);
        state.pipesCount -= 1;
        if (state.pipesCount === 1) state.pipes = state.pipes[0];
        dest.emit("unpipe", this);
        return this;
    };
    // set up data events if they are asked for
    // Ensure readable listeners eventually get something
    Readable.prototype.on = function(ev, fn) {
        var res = EventEmitter.prototype.on.call(this, ev, fn);
        if (ev === "data") // Start flowing on next tick if stream isn't explicitly paused
        {
            if (this._readableState.flowing !== false) this.resume();
        } else if (ev === "readable") {
            var state = this._readableState;
            if (!state.endEmitted && !state.readableListening) {
                state.readableListening = state.needReadable = true;
                state.emittedReadable = false;
                if (!state.reading) nextTick(nReadingNextTick, this);
                else if (state.length) emitReadable(this);
            }
        }
        return res;
    };
    Readable.prototype.addListener = Readable.prototype.on;
    function nReadingNextTick(self1) {
        debug("readable nexttick read 0");
        self1.read(0);
    }
    // pause() and resume() are remnants of the legacy readable stream API
    // If the user uses them, then switch into old mode.
    Readable.prototype.resume = function() {
        var state = this._readableState;
        if (!state.flowing) {
            debug("resume");
            state.flowing = true;
            resume(this, state);
        }
        return this;
    };
    function resume(stream, state) {
        if (!state.resumeScheduled) {
            state.resumeScheduled = true;
            nextTick(resume_, stream, state);
        }
    }
    function resume_(stream, state) {
        if (!state.reading) {
            debug("resume read 0");
            stream.read(0);
        }
        state.resumeScheduled = false;
        state.awaitDrain = 0;
        stream.emit("resume");
        flow(stream);
        if (state.flowing && !state.reading) stream.read(0);
    }
    Readable.prototype.pause = function() {
        debug("call pause flowing=%j", this._readableState.flowing);
        if (false !== this._readableState.flowing) {
            debug("pause");
            this._readableState.flowing = false;
            this.emit("pause");
        }
        return this;
    };
    function flow(stream) {
        var state = stream._readableState;
        debug("flow", state.flowing);
        while(state.flowing && stream.read() !== null);
    }
    // wrap an old-style stream as the async data source.
    // This is *not* part of the readable stream interface.
    // It is an ugly unfortunate mess of history.
    Readable.prototype.wrap = function(stream) {
        var state = this._readableState;
        var paused = false;
        var self1 = this;
        stream.on("end", function() {
            debug("wrapped end");
            if (state.decoder && !state.ended) {
                var chunk = state.decoder.end();
                if (chunk && chunk.length) self1.push(chunk);
            }
            self1.push(null);
        });
        stream.on("data", function(chunk) {
            debug("wrapped data");
            if (state.decoder) chunk = state.decoder.write(chunk);
            // don't skip over falsy values in objectMode
            if (state.objectMode && (chunk === null || chunk === undefined)) return;
            else if (!state.objectMode && (!chunk || !chunk.length)) return;
            var ret = self1.push(chunk);
            if (!ret) {
                paused = true;
                stream.pause();
            }
        });
        // proxy all the other methods.
        // important when wrapping filters and duplexes.
        for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function(method) {
            return function() {
                return stream[method].apply(stream, arguments);
            };
        }(i);
        // proxy certain important events.
        var events = [
            "error",
            "close",
            "destroy",
            "pause",
            "resume"
        ];
        forEach(events, function(ev) {
            stream.on(ev, self1.emit.bind(self1, ev));
        });
        // when we try to consume some more bytes, simply unpause the
        // underlying stream.
        self1._read = function(n) {
            debug("wrapped _read", n);
            if (paused) {
                paused = false;
                stream.resume();
            }
        };
        return self1;
    };
    // exposed for testing purposes only.
    Readable._fromList = fromList;
    // Pluck off n bytes from an array of buffers.
    // Length is the combined lengths of all the buffers in the list.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function fromList(n, state) {
        // nothing buffered
        if (state.length === 0) return null;
        var ret;
        if (state.objectMode) ret = state.buffer.shift();
        else if (!n || n >= state.length) {
            // read it all, truncate the list
            if (state.decoder) ret = state.buffer.join("");
            else if (state.buffer.length === 1) ret = state.buffer.head.data;
            else ret = state.buffer.concat(state.length);
            state.buffer.clear();
        } else // read part of list
        ret = fromListPartial(n, state.buffer, state.decoder);
        return ret;
    }
    // Extracts only enough buffered data to satisfy the amount requested.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function fromListPartial(n, list, hasStrings) {
        var ret;
        if (n < list.head.data.length) {
            // slice is the same for buffers and strings
            ret = list.head.data.slice(0, n);
            list.head.data = list.head.data.slice(n);
        } else if (n === list.head.data.length) // first chunk is a perfect match
        ret = list.shift();
        else // result spans more than one buffer
        ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
        return ret;
    }
    // Copies a specified amount of characters from the list of buffered data
    // chunks.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function copyFromBufferString(n, list) {
        var p = list.head;
        var c = 1;
        var ret = p.data;
        n -= ret.length;
        while(p = p.next){
            var str = p.data;
            var nb = n > str.length ? str.length : n;
            if (nb === str.length) ret += str;
            else ret += str.slice(0, n);
            n -= nb;
            if (n === 0) {
                if (nb === str.length) {
                    ++c;
                    if (p.next) list.head = p.next;
                    else list.head = list.tail = null;
                } else {
                    list.head = p;
                    p.data = str.slice(nb);
                }
                break;
            }
            ++c;
        }
        list.length -= c;
        return ret;
    }
    // Copies a specified amount of bytes from the list of buffered data chunks.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function copyFromBuffer(n, list) {
        var ret = Buffer.allocUnsafe(n);
        var p = list.head;
        var c = 1;
        p.data.copy(ret);
        n -= p.data.length;
        while(p = p.next){
            var buf = p.data;
            var nb = n > buf.length ? buf.length : n;
            buf.copy(ret, ret.length - n, 0, nb);
            n -= nb;
            if (n === 0) {
                if (nb === buf.length) {
                    ++c;
                    if (p.next) list.head = p.next;
                    else list.head = list.tail = null;
                } else {
                    list.head = p;
                    p.data = buf.slice(nb);
                }
                break;
            }
            ++c;
        }
        list.length -= c;
        return ret;
    }
    function endReadable(stream) {
        var state = stream._readableState;
        // If we get here before consuming all the bytes, then that is a
        // bug in node.  Should never happen.
        if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
        if (!state.endEmitted) {
            state.ended = true;
            nextTick(endReadableNT, state, stream);
        }
    }
    function endReadableNT(state, stream) {
        // Check that we didn't get one last unshift.
        if (!state.endEmitted && state.length === 0) {
            state.endEmitted = true;
            stream.readable = false;
            stream.emit("end");
        }
    }
    function forEach(xs, f) {
        for(var i = 0, l = xs.length; i < l; i++)f(xs[i], i);
    }
    function indexOf(xs, x) {
        for(var i = 0, l = xs.length; i < l; i++){
            if (xs[i] === x) return i;
        }
        return -1;
    }
    // A bit simpler than readable streams.
    Writable.WritableState = WritableState;
    inherits$1(Writable, EventEmitter);
    function nop() {}
    function WriteReq(chunk, encoding, cb) {
        this.chunk = chunk;
        this.encoding = encoding;
        this.callback = cb;
        this.next = null;
    }
    function WritableState(options, stream) {
        Object.defineProperty(this, "buffer", {
            get: deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")
        });
        options = options || {};
        // object stream flag to indicate whether or not this stream
        // contains buffers or objects.
        this.objectMode = !!options.objectMode;
        if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
        // the point at which write() starts returning false
        // Note: 0 is a valid value, means that we always return false if
        // the entire buffer is not flushed immediately on write()
        var hwm = options.highWaterMark;
        var defaultHwm = this.objectMode ? 16 : 16384;
        this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
        // cast to ints.
        this.highWaterMark = ~~this.highWaterMark;
        this.needDrain = false;
        // at the start of calling end()
        this.ending = false;
        // when end() has been called, and returned
        this.ended = false;
        // when 'finish' is emitted
        this.finished = false;
        // should we decode strings into buffers before passing to _write?
        // this is here so that some node-core streams can optimize string
        // handling at a lower level.
        var noDecode = options.decodeStrings === false;
        this.decodeStrings = !noDecode;
        // Crypto is kind of old and crusty.  Historically, its default string
        // encoding is 'binary' so we have to make this configurable.
        // Everything else in the universe uses 'utf8', though.
        this.defaultEncoding = options.defaultEncoding || "utf8";
        // not an actual buffer we keep track of, but a measurement
        // of how much we're waiting to get pushed to some underlying
        // socket or file.
        this.length = 0;
        // a flag to see when we're in the middle of a write.
        this.writing = false;
        // when true all writes will be buffered until .uncork() call
        this.corked = 0;
        // a flag to be able to tell if the onwrite cb is called immediately,
        // or on a later tick.  We set this to true at first, because any
        // actions that shouldn't happen until "later" should generally also
        // not happen before the first write call.
        this.sync = true;
        // a flag to know if we're processing previously buffered items, which
        // may call the _write() callback in the same tick, so that we don't
        // end up in an overlapped onwrite situation.
        this.bufferProcessing = false;
        // the callback that's passed to _write(chunk,cb)
        this.onwrite = function(er) {
            onwrite(stream, er);
        };
        // the callback that the user supplies to write(chunk,encoding,cb)
        this.writecb = null;
        // the amount that is being written when _write is called.
        this.writelen = 0;
        this.bufferedRequest = null;
        this.lastBufferedRequest = null;
        // number of pending user-supplied write callbacks
        // this must be 0 before 'finish' can be emitted
        this.pendingcb = 0;
        // emit prefinish if the only thing we're waiting for is _write cbs
        // This is relevant for synchronous Transform streams
        this.prefinished = false;
        // True if the error was already emitted and should not be thrown again
        this.errorEmitted = false;
        // count buffered requests
        this.bufferedRequestCount = 0;
        // allocate the first CorkedRequest, there is always
        // one allocated and free to use, and we maintain at most two
        this.corkedRequestsFree = new CorkedRequest(this);
    }
    WritableState.prototype.getBuffer = function writableStateGetBuffer() {
        var current = this.bufferedRequest;
        var out = [];
        while(current){
            out.push(current);
            current = current.next;
        }
        return out;
    };
    function Writable(options) {
        // Writable ctor is applied to Duplexes, though they're not
        // instanceof Writable, they're instanceof Readable.
        if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);
        this._writableState = new WritableState(options, this);
        // legacy.
        this.writable = true;
        if (options) {
            if (typeof options.write === "function") this._write = options.write;
            if (typeof options.writev === "function") this._writev = options.writev;
        }
        EventEmitter.call(this);
    }
    // Otherwise people can pipe Writable streams, which is just wrong.
    Writable.prototype.pipe = function() {
        this.emit("error", new Error("Cannot pipe, not readable"));
    };
    function writeAfterEnd(stream, cb) {
        var er = new Error("write after end");
        // TODO: defer error events consistently everywhere, not just the cb
        stream.emit("error", er);
        nextTick(cb, er);
    }
    // If we get something that is not a buffer, string, null, or undefined,
    // and we're not in objectMode, then that's an error.
    // Otherwise stream chunks are all considered to be of length=1, and the
    // watermarks determine how many objects to keep in the buffer, rather than
    // how many bytes or characters.
    function validChunk(stream, state, chunk, cb) {
        var valid = true;
        var er = false;
        // Always throw error if a null is written
        // if we are not in object mode then throw
        // if it is not a buffer, string, or undefined.
        if (chunk === null) er = new TypeError("May not write null values to stream");
        else if (!Buffer.isBuffer(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
        if (er) {
            stream.emit("error", er);
            nextTick(cb, er);
            valid = false;
        }
        return valid;
    }
    Writable.prototype.write = function(chunk, encoding, cb) {
        var state = this._writableState;
        var ret = false;
        if (typeof encoding === "function") {
            cb = encoding;
            encoding = null;
        }
        if (Buffer.isBuffer(chunk)) encoding = "buffer";
        else if (!encoding) encoding = state.defaultEncoding;
        if (typeof cb !== "function") cb = nop;
        if (state.ended) writeAfterEnd(this, cb);
        else if (validChunk(this, state, chunk, cb)) {
            state.pendingcb++;
            ret = writeOrBuffer(this, state, chunk, encoding, cb);
        }
        return ret;
    };
    Writable.prototype.cork = function() {
        var state = this._writableState;
        state.corked++;
    };
    Writable.prototype.uncork = function() {
        var state = this._writableState;
        if (state.corked) {
            state.corked--;
            if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
        }
    };
    Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
        // node::ParseEncoding() requires lower case.
        if (typeof encoding === "string") encoding = encoding.toLowerCase();
        if (!([
            "hex",
            "utf8",
            "utf-8",
            "ascii",
            "binary",
            "base64",
            "ucs2",
            "ucs-2",
            "utf16le",
            "utf-16le",
            "raw"
        ].indexOf((encoding + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + encoding);
        this._writableState.defaultEncoding = encoding;
        return this;
    };
    function decodeChunk(state, chunk, encoding) {
        if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = Buffer.from(chunk, encoding);
        return chunk;
    }
    // if we're already writing something, then just put this
    // in the queue, and wait our turn.  Otherwise, call _write
    // If we return false, then we need a drain event, so set that flag.
    function writeOrBuffer(stream, state, chunk, encoding, cb) {
        chunk = decodeChunk(state, chunk, encoding);
        if (Buffer.isBuffer(chunk)) encoding = "buffer";
        var len = state.objectMode ? 1 : chunk.length;
        state.length += len;
        var ret = state.length < state.highWaterMark;
        // we must ensure that previous needDrain will not be reset to false.
        if (!ret) state.needDrain = true;
        if (state.writing || state.corked) {
            var last = state.lastBufferedRequest;
            state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
            if (last) last.next = state.lastBufferedRequest;
            else state.bufferedRequest = state.lastBufferedRequest;
            state.bufferedRequestCount += 1;
        } else doWrite(stream, state, false, len, chunk, encoding, cb);
        return ret;
    }
    function doWrite(stream, state, writev, len, chunk, encoding, cb) {
        state.writelen = len;
        state.writecb = cb;
        state.writing = true;
        state.sync = true;
        if (writev) stream._writev(chunk, state.onwrite);
        else stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    function onwriteError(stream, state, sync, er, cb) {
        --state.pendingcb;
        if (sync) nextTick(cb, er);
        else cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
    }
    function onwriteStateUpdate(state) {
        state.writing = false;
        state.writecb = null;
        state.length -= state.writelen;
        state.writelen = 0;
    }
    function onwrite(stream, er) {
        var state = stream._writableState;
        var sync = state.sync;
        var cb = state.writecb;
        onwriteStateUpdate(state);
        if (er) onwriteError(stream, state, sync, er, cb);
        else {
            // Check if we're actually ready to finish, but don't emit yet
            var finished = needFinish(state);
            if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
            if (sync) /*<replacement>*/ nextTick(afterWrite, stream, state, finished, cb);
            else afterWrite(stream, state, finished, cb);
        }
    }
    function afterWrite(stream, state, finished, cb) {
        if (!finished) onwriteDrain(stream, state);
        state.pendingcb--;
        cb();
        finishMaybe(stream, state);
    }
    // Must force callback to be called on nextTick, so that we don't
    // emit 'drain' before the write() consumer gets the 'false' return
    // value, and has a chance to attach a 'drain' listener.
    function onwriteDrain(stream, state) {
        if (state.length === 0 && state.needDrain) {
            state.needDrain = false;
            stream.emit("drain");
        }
    }
    // if there's something in the buffer waiting, then process it
    function clearBuffer(stream, state) {
        state.bufferProcessing = true;
        var entry = state.bufferedRequest;
        if (stream._writev && entry && entry.next) {
            // Fast case, write everything using _writev()
            var l = state.bufferedRequestCount;
            var buffer = new Array(l);
            var holder = state.corkedRequestsFree;
            holder.entry = entry;
            var count = 0;
            while(entry){
                buffer[count] = entry;
                entry = entry.next;
                count += 1;
            }
            doWrite(stream, state, true, state.length, buffer, "", holder.finish);
            // doWrite is almost always async, defer these to save a bit of time
            // as the hot path ends with doWrite
            state.pendingcb++;
            state.lastBufferedRequest = null;
            if (holder.next) {
                state.corkedRequestsFree = holder.next;
                holder.next = null;
            } else state.corkedRequestsFree = new CorkedRequest(state);
        } else {
            // Slow case, write chunks one-by-one
            while(entry){
                var chunk = entry.chunk;
                var encoding = entry.encoding;
                var cb = entry.callback;
                var len = state.objectMode ? 1 : chunk.length;
                doWrite(stream, state, false, len, chunk, encoding, cb);
                entry = entry.next;
                // if we didn't call the onwrite immediately, then
                // it means that we need to wait until it does.
                // also, that means that the chunk and cb are currently
                // being processed, so move the buffer counter past them.
                if (state.writing) break;
            }
            if (entry === null) state.lastBufferedRequest = null;
        }
        state.bufferedRequestCount = 0;
        state.bufferedRequest = entry;
        state.bufferProcessing = false;
    }
    Writable.prototype._write = function(chunk, encoding, cb) {
        cb(new Error("not implemented"));
    };
    Writable.prototype._writev = null;
    Writable.prototype.end = function(chunk, encoding, cb) {
        var state = this._writableState;
        if (typeof chunk === "function") {
            cb = chunk;
            chunk = null;
            encoding = null;
        } else if (typeof encoding === "function") {
            cb = encoding;
            encoding = null;
        }
        if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
        // .end() fully uncorks
        if (state.corked) {
            state.corked = 1;
            this.uncork();
        }
        // ignore unnecessary end() calls.
        if (!state.ending && !state.finished) endWritable(this, state, cb);
    };
    function needFinish(state) {
        return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
    }
    function prefinish(stream, state) {
        if (!state.prefinished) {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
    function finishMaybe(stream, state) {
        var need = needFinish(state);
        if (need) {
            if (state.pendingcb === 0) {
                prefinish(stream, state);
                state.finished = true;
                stream.emit("finish");
            } else prefinish(stream, state);
        }
        return need;
    }
    function endWritable(stream, state, cb) {
        state.ending = true;
        finishMaybe(stream, state);
        if (cb) {
            if (state.finished) nextTick(cb);
            else stream.once("finish", cb);
        }
        state.ended = true;
        stream.writable = false;
    }
    // It seems a linked list but it is not
    // there will be only 2 of these for each stream
    function CorkedRequest(state) {
        var _this = this;
        this.next = null;
        this.entry = null;
        this.finish = function(err) {
            var entry = _this.entry;
            _this.entry = null;
            while(entry){
                var cb = entry.callback;
                state.pendingcb--;
                cb(err);
                entry = entry.next;
            }
            if (state.corkedRequestsFree) state.corkedRequestsFree.next = _this;
            else state.corkedRequestsFree = _this;
        };
    }
    inherits$1(Duplex, Readable);
    var keys = Object.keys(Writable.prototype);
    for(var v = 0; v < keys.length; v++){
        var method = keys[v];
        if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
    }
    function Duplex(options) {
        if (!(this instanceof Duplex)) return new Duplex(options);
        Readable.call(this, options);
        Writable.call(this, options);
        if (options && options.readable === false) this.readable = false;
        if (options && options.writable === false) this.writable = false;
        this.allowHalfOpen = true;
        if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
        this.once("end", onend);
    }
    // the no-half-open enforcer
    function onend() {
        // if we allow half-open state, or if the writable side ended,
        // then we're ok.
        if (this.allowHalfOpen || this._writableState.ended) return;
        // no more data can be written.
        // But allow more writes to happen in this tick.
        nextTick(onEndNT, this);
    }
    function onEndNT(self1) {
        self1.end();
    }
    // a transform stream is a readable/writable stream where you do
    inherits$1(Transform, Duplex);
    function TransformState(stream) {
        this.afterTransform = function(er, data) {
            return afterTransform(stream, er, data);
        };
        this.needTransform = false;
        this.transforming = false;
        this.writecb = null;
        this.writechunk = null;
        this.writeencoding = null;
    }
    function afterTransform(stream, er, data) {
        var ts = stream._transformState;
        ts.transforming = false;
        var cb = ts.writecb;
        if (!cb) return stream.emit("error", new Error("no writecb in Transform class"));
        ts.writechunk = null;
        ts.writecb = null;
        if (data !== null && data !== undefined) stream.push(data);
        cb(er);
        var rs = stream._readableState;
        rs.reading = false;
        if (rs.needReadable || rs.length < rs.highWaterMark) stream._read(rs.highWaterMark);
    }
    function Transform(options) {
        if (!(this instanceof Transform)) return new Transform(options);
        Duplex.call(this, options);
        this._transformState = new TransformState(this);
        // when the writable side finishes, then flush out anything remaining.
        var stream = this;
        // start out asking for a readable event once data is transformed.
        this._readableState.needReadable = true;
        // we have implemented the _read method, and done the other things
        // that Readable wants before the first _read call, so unset the
        // sync guard flag.
        this._readableState.sync = false;
        if (options) {
            if (typeof options.transform === "function") this._transform = options.transform;
            if (typeof options.flush === "function") this._flush = options.flush;
        }
        this.once("prefinish", function() {
            if (typeof this._flush === "function") this._flush(function(er) {
                done(stream, er);
            });
            else done(stream);
        });
    }
    Transform.prototype.push = function(chunk, encoding) {
        this._transformState.needTransform = false;
        return Duplex.prototype.push.call(this, chunk, encoding);
    };
    // This is the part where you do stuff!
    // override this function in implementation classes.
    // 'chunk' is an input chunk.
    //
    // Call `push(newChunk)` to pass along transformed output
    // to the readable side.  You may call 'push' zero or more times.
    //
    // Call `cb(err)` when you are done with this chunk.  If you pass
    // an error, then that'll put the hurt on the whole operation.  If you
    // never call cb(), then you'll never get another chunk.
    Transform.prototype._transform = function(chunk, encoding, cb) {
        throw new Error("Not implemented");
    };
    Transform.prototype._write = function(chunk, encoding, cb) {
        var ts = this._transformState;
        ts.writecb = cb;
        ts.writechunk = chunk;
        ts.writeencoding = encoding;
        if (!ts.transforming) {
            var rs = this._readableState;
            if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
        }
    };
    // Doesn't matter what the args are here.
    // _transform does all the work.
    // That we got here means that the readable side wants more data.
    Transform.prototype._read = function(n) {
        var ts = this._transformState;
        if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
            ts.transforming = true;
            this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
        } else // mark that we need a transform, so that any data that comes in
        // will get processed, now that we've asked for it.
        ts.needTransform = true;
    };
    function done(stream, er) {
        if (er) return stream.emit("error", er);
        // if there's nothing in the write buffer, then that means
        // that nothing more will ever be provided
        var ws = stream._writableState;
        var ts = stream._transformState;
        if (ws.length) throw new Error("Calling transform done when ws.length != 0");
        if (ts.transforming) throw new Error("Calling transform done when still transforming");
        return stream.push(null);
    }
    inherits$1(PassThrough, Transform);
    function PassThrough(options) {
        if (!(this instanceof PassThrough)) return new PassThrough(options);
        Transform.call(this, options);
    }
    PassThrough.prototype._transform = function(chunk, encoding, cb) {
        cb(null, chunk);
    };
    inherits$1(Stream, EventEmitter);
    Stream.Readable = Readable;
    Stream.Writable = Writable;
    Stream.Duplex = Duplex;
    Stream.Transform = Transform;
    Stream.PassThrough = PassThrough;
    // Backwards-compat with node 0.4.x
    Stream.Stream = Stream;
    // old-style streams.  Note that the pipe method (the only relevant
    // part of this class) is overridden in the Readable class.
    function Stream() {
        EventEmitter.call(this);
    }
    Stream.prototype.pipe = function(dest, options) {
        var source = this;
        function ondata(chunk) {
            if (dest.writable) {
                if (false === dest.write(chunk) && source.pause) source.pause();
            }
        }
        source.on("data", ondata);
        function ondrain() {
            if (source.readable && source.resume) source.resume();
        }
        dest.on("drain", ondrain);
        // If the 'end' option is not supplied, dest.end() will be called when
        // source gets the 'end' or 'close' events.  Only dest.end() once.
        if (!dest._isStdio && (!options || options.end !== false)) {
            source.on("end", onend);
            source.on("close", onclose);
        }
        var didOnEnd = false;
        function onend() {
            if (didOnEnd) return;
            didOnEnd = true;
            dest.end();
        }
        function onclose() {
            if (didOnEnd) return;
            didOnEnd = true;
            if (typeof dest.destroy === "function") dest.destroy();
        }
        // don't leave dangling pipes when there are errors.
        function onerror(er) {
            cleanup();
            if (EventEmitter.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
        }
        source.on("error", onerror);
        dest.on("error", onerror);
        // remove all the event listeners that were added.
        function cleanup() {
            source.removeListener("data", ondata);
            dest.removeListener("drain", ondrain);
            source.removeListener("end", onend);
            source.removeListener("close", onclose);
            source.removeListener("error", onerror);
            dest.removeListener("error", onerror);
            source.removeListener("end", cleanup);
            source.removeListener("close", cleanup);
            dest.removeListener("close", cleanup);
        }
        source.on("end", cleanup);
        source.on("close", cleanup);
        dest.on("close", cleanup);
        dest.emit("pipe", source);
        // Allow for unix-like usage: A.pipe(B).pipe(C)
        return dest;
    };
    function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _assertThisInitialized(self1) {
        if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self1;
    }
    function _possibleConstructorReturn(self1, call) {
        if (call && (typeof call === "object" || typeof call === "function")) return call;
        return _assertThisInitialized(self1);
    }
    function _toArray(arr) {
        return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        }
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArray(iter) {
        if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
    /*
  The MIT License (MIT)

  Copyright (c) 2016 CoderPuppy

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.

  */ var _endianness;
    function endianness() {
        if (typeof _endianness === "undefined") {
            var a = new ArrayBuffer(2);
            var b = new Uint8Array(a);
            var c = new Uint16Array(a);
            b[0] = 1;
            b[1] = 2;
            if (c[0] === 258) _endianness = "BE";
            else if (c[0] === 513) _endianness = "LE";
            else throw new Error("unable to figure out endianess");
        }
        return _endianness;
    }
    function hostname() {
        if (typeof global$1.location !== "undefined") return global$1.location.hostname;
        else return "";
    }
    function loadavg() {
        return [];
    }
    function uptime() {
        return 0;
    }
    function freemem() {
        return Number.MAX_VALUE;
    }
    function totalmem() {
        return Number.MAX_VALUE;
    }
    function cpus() {
        return [];
    }
    function type() {
        return "Browser";
    }
    function release() {
        if (typeof global$1.navigator !== "undefined") return global$1.navigator.appVersion;
        return "";
    }
    function networkInterfaces() {}
    function getNetworkInterfaces() {}
    function tmpDir() {
        return "/tmp";
    }
    var tmpdir = tmpDir;
    var EOL = "\n";
    var os = {
        EOL: EOL,
        tmpdir: tmpdir,
        tmpDir: tmpDir,
        networkInterfaces: networkInterfaces,
        getNetworkInterfaces: getNetworkInterfaces,
        release: release,
        type: type,
        cpus: cpus,
        totalmem: totalmem,
        freemem: freemem,
        uptime: uptime,
        loadavg: loadavg,
        hostname: hostname,
        endianness: endianness
    };
    var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
    /**
   * lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */ /** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
    /** `Object#toString` result references. */ var funcTag = "[object Function]", genTag = "[object GeneratorFunction]", symbolTag = "[object Symbol]";
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */ function isHostObject(value) {
        // Many host objects are `Object` objects that can coerce to strings
        // despite having improperly defined `toString` methods.
        var result = false;
        if (value != null && typeof value.toString != "function") try {
            result = !!(value + "");
        } catch (e) {}
        return result;
    }
    /** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
    /** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
    /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
    }();
    /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
    /** Used to check objects for own properties. */ var hasOwnProperty$1 = objectProto.hasOwnProperty;
    /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */ var objectToString$1 = objectProto.toString;
    /** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty$1).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    /** Built-in value references. */ var Symbol$1 = root.Symbol, splice = arrayProto.splice;
    /* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
    /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
    /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */ function Hash(entries) {
        var index = -1, length = entries ? entries.length : 0;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */ function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
    }
    /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */ function hashDelete(key) {
        return this.has(key) && delete this.__data__[key];
    }
    /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */ function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
            var result = data[key];
            return result === HASH_UNDEFINED ? undefined : result;
        }
        return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
    }
    /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined : hasOwnProperty$1.call(data, key);
    }
    /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */ function hashSet(key, value) {
        var data = this.__data__;
        data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
        return this;
    }
    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */ function ListCache(entries) {
        var index = -1, length = entries ? entries.length : 0;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */ function listCacheClear() {
        this.__data__ = [];
    }
    /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */ function listCacheDelete(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) return false;
        var lastIndex = data.length - 1;
        if (index == lastIndex) data.pop();
        else splice.call(data, index, 1);
        return true;
    }
    /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */ function listCacheGet(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        return index < 0 ? undefined : data[index][1];
    }
    /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
    }
    /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */ function listCacheSet(key, value) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) data.push([
            key,
            value
        ]);
        else data[index][1] = value;
        return this;
    }
    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */ function MapCache(entries) {
        var index = -1, length = entries ? entries.length : 0;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */ function mapCacheClear() {
        this.__data__ = {
            "hash": new Hash,
            "map": new (Map || ListCache),
            "string": new Hash
        };
    }
    /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */ function mapCacheDelete(key) {
        return getMapData(this, key)["delete"](key);
    }
    /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */ function mapCacheGet(key) {
        return getMapData(this, key).get(key);
    }
    /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function mapCacheHas(key) {
        return getMapData(this, key).has(key);
    }
    /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */ function mapCacheSet(key, value) {
        getMapData(this, key).set(key, value);
        return this;
    }
    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function assocIndexOf(array, key) {
        var length = array.length;
        while(length--){
            if (eq(array[length][0], key)) return length;
        }
        return -1;
    }
    /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */ function baseGet(object, path) {
        path = isKey(path, object) ? [
            path
        ] : castPath(path);
        var index = 0, length = path.length;
        while(object != null && index < length)object = object[toKey(path[index++])];
        return index && index == length ? object : undefined;
    }
    /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */ function baseIsNative(value) {
        if (!isObject$1(value) || isMasked(value)) return false;
        var pattern = isFunction$1(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
    }
    /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */ function baseToString(value) {
        // Exit early for strings to avoid a performance hit in some environments.
        if (typeof value == "string") return value;
        if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
        var result = value + "";
        return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {Array} Returns the cast property path array.
   */ function castPath(value) {
        return isArray$2(value) ? value : stringToPath(value);
    }
    /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */ function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */ function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined;
    }
    /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */ function isKey(value, object) {
        if (isArray$2(value)) return false;
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
    }
    /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */ function isKeyable(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */ function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
    }
    /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */ var stringToPath = memoize(function(string) {
        string = toString$1(string);
        var result = [];
        if (reLeadingDot.test(string)) result.push("");
        string.replace(rePropName, function(match, number, quote, string) {
            result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
        });
        return result;
    });
    /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */ function toKey(value) {
        if (typeof value == "string" || isSymbol(value)) return value;
        var result = value + "";
        return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to process.
   * @returns {string} Returns the source code.
   */ function toSource(func) {
        if (func != null) {
            try {
                return funcToString.call(func);
            } catch (e) {}
            try {
                return func + "";
            } catch (e) {}
        }
        return "";
    }
    /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */ function memoize(func, resolver) {
        if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
        var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) return cache.get(key);
            var result = func.apply(this, args);
            memoized.cache = cache.set(key, result);
            return result;
        };
        memoized.cache = new (memoize.Cache || MapCache);
        return memoized;
    }
    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;
    /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */ function eq(value, other) {
        return value === other || value !== value && other !== other;
    }
    /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */ var isArray$2 = Array.isArray;
    /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */ function isFunction$1(value) {
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 8-9 which returns 'object' for typed array and other constructors.
        var tag = isObject$1(value) ? objectToString$1.call(value) : "";
        return tag == funcTag || tag == genTag;
    }
    /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */ function isObject$1(value) {
        var type = typeof value;
        return !!value && (type == "object" || type == "function");
    }
    /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */ function isObjectLike(value) {
        return !!value && typeof value == "object";
    }
    /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */ function isSymbol(value) {
        return typeof value == "symbol" || isObjectLike(value) && objectToString$1.call(value) == symbolTag;
    }
    /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */ function toString$1(value) {
        return value == null ? "" : baseToString(value);
    }
    /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */ function get(object, path, defaultValue) {
        var result = object == null ? undefined : baseGet(object, path);
        return result === undefined ? defaultValue : result;
    }
    var lodash_get = get;
    function getProp(obj, path, defaultValue) {
        return obj[path] === undefined ? defaultValue : obj[path];
    }
    function setProp(obj, path, value) {
        var pathArray = Array.isArray(path) ? path : path.split(".");
        var _pathArray = _toArray(pathArray), key = _pathArray[0], restPath = _pathArray.slice(1);
        var newValue = pathArray.length > 1 ? setProp(obj[key] || {}, restPath, value) : value;
        return Object.assign({}, obj, _defineProperty({}, key, newValue));
    }
    function unsetProp(obj, path) {
        var pathArray = Array.isArray(path) ? path : path.split(".");
        var _pathArray2 = _toArray(pathArray), key = _pathArray2[0], restPath = _pathArray2.slice(1);
        if (_typeof(obj[key]) !== "object") // This will never be hit in the current code because unwind does the check before calling unsetProp
        /* istanbul ignore next */ return obj;
        if (pathArray.length === 1) return Object.keys(obj).filter(function(prop) {
            return prop !== key;
        }).reduce(function(acc, prop) {
            return Object.assign(acc, _defineProperty({}, prop, obj[prop]));
        }, {});
        return unsetProp(obj[key], restPath);
    }
    function flattenReducer(acc, arr) {
        try {
            // This is faster but susceptible to `RangeError: Maximum call stack size exceeded`
            acc.push.apply(acc, _toConsumableArray(arr));
            return acc;
        } catch (err) {
            // Fallback to a slower but safer option
            return acc.concat(arr);
        }
    }
    function fastJoin(arr, separator) {
        var isFirst = true;
        return arr.reduce(function(acc, elem) {
            if (elem === null || elem === undefined) elem = "";
            if (isFirst) {
                isFirst = false;
                return "".concat(elem);
            }
            return "".concat(acc).concat(separator).concat(elem);
        }, "");
    }
    var utils = {
        getProp: getProp,
        setProp: setProp,
        unsetProp: unsetProp,
        fastJoin: fastJoin,
        flattenReducer: flattenReducer
    };
    var getProp$1 = utils.getProp, fastJoin$1 = utils.fastJoin, flattenReducer$1 = utils.flattenReducer;
    var JSON2CSVBase = /*#__PURE__*/ function() {
        function JSON2CSVBase(opts) {
            _classCallCheck(this, JSON2CSVBase);
            this.opts = this.preprocessOpts(opts);
        }
        /**
     * Check passing opts and set defaults.
     *
     * @param {Json2CsvOptions} opts Options object containing fields,
     * delimiter, default value, quote mark, header, etc.
     */ _createClass(JSON2CSVBase, [
            {
                key: "preprocessOpts",
                value: function preprocessOpts(opts) {
                    var processedOpts = Object.assign({}, opts);
                    processedOpts.transforms = !Array.isArray(processedOpts.transforms) ? processedOpts.transforms ? [
                        processedOpts.transforms
                    ] : [] : processedOpts.transforms;
                    processedOpts.delimiter = processedOpts.delimiter || ",";
                    processedOpts.eol = processedOpts.eol || os.EOL;
                    processedOpts.quote = typeof processedOpts.quote === "string" ? processedOpts.quote : '"';
                    processedOpts.escapedQuote = typeof processedOpts.escapedQuote === "string" ? processedOpts.escapedQuote : "".concat(processedOpts.quote).concat(processedOpts.quote);
                    processedOpts.header = processedOpts.header !== false;
                    processedOpts.includeEmptyRows = processedOpts.includeEmptyRows || false;
                    processedOpts.withBOM = processedOpts.withBOM || false;
                    return processedOpts;
                }
            },
            {
                key: "preprocessFieldsInfo",
                value: function preprocessFieldsInfo(fields) {
                    var _this = this;
                    return fields.map(function(fieldInfo) {
                        if (typeof fieldInfo === "string") return {
                            label: fieldInfo,
                            value: fieldInfo.includes(".") || fieldInfo.includes("[") ? function(row) {
                                return lodash_get(row, fieldInfo, _this.opts.defaultValue);
                            } : function(row) {
                                return getProp$1(row, fieldInfo, _this.opts.defaultValue);
                            }
                        };
                        if (_typeof(fieldInfo) === "object") {
                            var defaultValue = "default" in fieldInfo ? fieldInfo.default : _this.opts.defaultValue;
                            if (typeof fieldInfo.value === "string") return {
                                label: fieldInfo.label || fieldInfo.value,
                                value: fieldInfo.value.includes(".") || fieldInfo.value.includes("[") ? function(row) {
                                    return lodash_get(row, fieldInfo.value, defaultValue);
                                } : function(row) {
                                    return getProp$1(row, fieldInfo.value, defaultValue);
                                }
                            };
                            if (typeof fieldInfo.value === "function") {
                                var label = fieldInfo.label || fieldInfo.value.name || "";
                                var field = {
                                    label: label,
                                    default: defaultValue
                                };
                                return {
                                    label: label,
                                    value: function value(row) {
                                        var value = fieldInfo.value(row, field);
                                        return value === null || value === undefined ? defaultValue : value;
                                    }
                                };
                            }
                        }
                        throw new Error("Invalid field info option. " + JSON.stringify(fieldInfo));
                    });
                }
            },
            {
                key: "getHeader",
                value: function getHeader() {
                    var _this2 = this;
                    return fastJoin$1(this.opts.fields.map(function(fieldInfo) {
                        return _this2.processValue(fieldInfo.label);
                    }), this.opts.delimiter);
                }
            },
            {
                key: "preprocessRow",
                value: function preprocessRow(row) {
                    return this.opts.transforms.reduce(function(rows, transform) {
                        return rows.map(function(row) {
                            return transform(row);
                        }).reduce(flattenReducer$1, []);
                    }, [
                        row
                    ]);
                }
            },
            {
                key: "processRow",
                value: function processRow(row) {
                    var _this3 = this;
                    if (!row) return undefined;
                    var processedRow = this.opts.fields.map(function(fieldInfo) {
                        return _this3.processCell(row, fieldInfo);
                    });
                    if (!this.opts.includeEmptyRows && processedRow.every(function(field) {
                        return field === undefined;
                    })) return undefined;
                    return fastJoin$1(processedRow, this.opts.delimiter);
                }
            },
            {
                key: "processCell",
                value: function processCell(row, fieldInfo) {
                    return this.processValue(fieldInfo.value(row));
                }
            },
            {
                key: "processValue",
                value: function processValue(value) {
                    if (value === null || value === undefined) return undefined;
                    var valueType = _typeof(value);
                    if (valueType !== "boolean" && valueType !== "number" && valueType !== "string") {
                        value = JSON.stringify(value);
                        if (value === undefined) return undefined;
                        if (value[0] === '"') value = value.replace(/^"(.+)"$/, "$1");
                    }
                    if (typeof value === "string") {
                        if (this.opts.excelStrings) {
                            if (value.includes(this.opts.quote)) value = value.replace(new RegExp(this.opts.quote, "g"), "".concat(this.opts.escapedQuote).concat(this.opts.escapedQuote));
                            value = '"=""'.concat(value, '"""');
                        } else {
                            if (value.includes(this.opts.quote)) value = value.replace(new RegExp(this.opts.quote, "g"), this.opts.escapedQuote);
                            value = "".concat(this.opts.quote).concat(value).concat(this.opts.quote);
                        }
                    }
                    return value;
                }
            }
        ]);
        return JSON2CSVBase;
    }();
    var JSON2CSVBase_1 = JSON2CSVBase;
    var fastJoin$2 = utils.fastJoin, flattenReducer$2 = utils.flattenReducer;
    var JSON2CSVParser = /*#__PURE__*/ function(_JSON2CSVBase) {
        _inherits(JSON2CSVParser, _JSON2CSVBase);
        function JSON2CSVParser(opts) {
            var _this;
            _classCallCheck(this, JSON2CSVParser);
            _this = _possibleConstructorReturn(this, _getPrototypeOf(JSON2CSVParser).call(this, opts));
            if (_this.opts.fields) _this.opts.fields = _this.preprocessFieldsInfo(_this.opts.fields);
            return _this;
        }
        /**
     * Main function that converts json to csv.
     *
     * @param {Array|Object} data Array of JSON objects to be converted to CSV
     * @returns {String} The CSV formated data as a string
     */ _createClass(JSON2CSVParser, [
            {
                key: "parse",
                value: function parse(data) {
                    var processedData = this.preprocessData(data);
                    if (!this.opts.fields) {
                        this.opts.fields = processedData.reduce(function(fields, item) {
                            Object.keys(item).forEach(function(field) {
                                if (!fields.includes(field)) fields.push(field);
                            });
                            return fields;
                        }, []);
                        this.opts.fields = this.preprocessFieldsInfo(this.opts.fields);
                    }
                    var header = this.opts.header ? this.getHeader() : "";
                    var rows = this.processData(processedData);
                    var csv = (this.opts.withBOM ? "\uFEFF" : "") + header + (header && rows ? this.opts.eol : "") + rows;
                    return csv;
                }
            },
            {
                key: "preprocessData",
                value: function preprocessData(data) {
                    var _this2 = this;
                    var processedData = Array.isArray(data) ? data : [
                        data
                    ];
                    if (!this.opts.fields && (processedData.length === 0 || _typeof(processedData[0]) !== "object")) throw new Error('Data should not be empty or the "fields" option should be included');
                    if (this.opts.transforms.length === 0) return processedData;
                    return processedData.map(function(row) {
                        return _this2.preprocessRow(row);
                    }).reduce(flattenReducer$2, []);
                }
            },
            {
                key: "processData",
                value: function processData(data) {
                    var _this3 = this;
                    return fastJoin$2(data.map(function(row) {
                        return _this3.processRow(row);
                    }).filter(function(row) {
                        return row;
                    }), this.opts.eol);
                }
            }
        ]);
        return JSON2CSVParser;
    }(JSON2CSVBase_1);
    var JSON2CSVParser_1 = JSON2CSVParser;
    /*global Buffer*/ // Named constants with unique integer values
    var C = {};
    // Tokens
    var LEFT_BRACE = C.LEFT_BRACE = 0x1;
    var RIGHT_BRACE = C.RIGHT_BRACE = 0x2;
    var LEFT_BRACKET = C.LEFT_BRACKET = 0x3;
    var RIGHT_BRACKET = C.RIGHT_BRACKET = 0x4;
    var COLON = C.COLON = 0x5;
    var COMMA = C.COMMA = 0x6;
    var TRUE = C.TRUE = 0x7;
    var FALSE = C.FALSE = 0x8;
    var NULL = C.NULL = 0x9;
    var STRING = C.STRING = 0xa;
    var NUMBER = C.NUMBER = 0xb;
    // Tokenizer States
    var START = C.START = 0x11;
    var STOP = C.STOP = 0x12;
    var TRUE1 = C.TRUE1 = 0x21;
    var TRUE2 = C.TRUE2 = 0x22;
    var TRUE3 = C.TRUE3 = 0x23;
    var FALSE1 = C.FALSE1 = 0x31;
    var FALSE2 = C.FALSE2 = 0x32;
    var FALSE3 = C.FALSE3 = 0x33;
    var FALSE4 = C.FALSE4 = 0x34;
    var NULL1 = C.NULL1 = 0x41;
    var NULL2 = C.NULL2 = 0x42;
    var NULL3 = C.NULL3 = 0x43;
    var NUMBER1 = C.NUMBER1 = 0x51;
    var NUMBER3 = C.NUMBER3 = 0x53;
    var STRING1 = C.STRING1 = 0x61;
    var STRING2 = C.STRING2 = 0x62;
    var STRING3 = C.STRING3 = 0x63;
    var STRING4 = C.STRING4 = 0x64;
    var STRING5 = C.STRING5 = 0x65;
    var STRING6 = C.STRING6 = 0x66;
    // Parser States
    var VALUE = C.VALUE = 0x71;
    var KEY = C.KEY = 0x72;
    // Parser Modes
    var OBJECT = C.OBJECT = 0x81;
    var ARRAY = C.ARRAY = 0x82;
    // Character constants
    var BACK_SLASH = "\\".charCodeAt(0);
    var FORWARD_SLASH = "/".charCodeAt(0);
    var BACKSPACE = "\b".charCodeAt(0);
    var FORM_FEED = "\f".charCodeAt(0);
    var NEWLINE = "\n".charCodeAt(0);
    var CARRIAGE_RETURN = "\r".charCodeAt(0);
    var TAB = "	".charCodeAt(0);
    var STRING_BUFFER_SIZE = 65536;
    function Parser() {
        this.tState = START;
        this.value = undefined;
        this.string = undefined; // string data
        this.stringBuffer = Buffer.alloc ? Buffer.alloc(STRING_BUFFER_SIZE) : new Buffer(STRING_BUFFER_SIZE);
        this.stringBufferOffset = 0;
        this.unicode = undefined; // unicode escapes
        this.highSurrogate = undefined;
        this.key = undefined;
        this.mode = undefined;
        this.stack = [];
        this.state = VALUE;
        this.bytes_remaining = 0; // number of bytes remaining in multi byte utf8 char to read after split boundary
        this.bytes_in_sequence = 0; // bytes in multi byte utf8 char to read
        this.temp_buffs = {
            "2": new Buffer(2),
            "3": new Buffer(3),
            "4": new Buffer(4)
        }; // for rebuilding chars split before boundary is reached
        // Stream offset
        this.offset = -1;
    }
    // Slow code to string converter (only used when throwing syntax errors)
    Parser.toknam = function(code) {
        var keys = Object.keys(C);
        for(var i = 0, l = keys.length; i < l; i++){
            var key = keys[i];
            if (C[key] === code) return key;
        }
        return code && "0x" + code.toString(16);
    };
    var proto = Parser.prototype;
    proto.onError = function(err) {
        throw err;
    };
    proto.charError = function(buffer, i) {
        this.tState = STOP;
        this.onError(new Error("Unexpected " + JSON.stringify(String.fromCharCode(buffer[i])) + " at position " + i + " in state " + Parser.toknam(this.tState)));
    };
    proto.appendStringChar = function(char) {
        if (this.stringBufferOffset >= STRING_BUFFER_SIZE) {
            this.string += this.stringBuffer.toString("utf8");
            this.stringBufferOffset = 0;
        }
        this.stringBuffer[this.stringBufferOffset++] = char;
    };
    proto.appendStringBuf = function(buf, start, end) {
        var size = buf.length;
        if (typeof start === "number") {
            if (typeof end === "number") {
                if (end < 0) // adding a negative end decreeses the size
                size = buf.length - start + end;
                else size = end - start;
            } else size = buf.length - start;
        }
        if (size < 0) size = 0;
        if (this.stringBufferOffset + size > STRING_BUFFER_SIZE) {
            this.string += this.stringBuffer.toString("utf8", 0, this.stringBufferOffset);
            this.stringBufferOffset = 0;
        }
        buf.copy(this.stringBuffer, this.stringBufferOffset, start, end);
        this.stringBufferOffset += size;
    };
    proto.write = function(buffer) {
        if (typeof buffer === "string") buffer = new Buffer(buffer);
        var n;
        for(var i = 0, l = buffer.length; i < l; i++){
            if (this.tState === START) {
                n = buffer[i];
                this.offset++;
                if (n === 0x7b) this.onToken(LEFT_BRACE, "{"); // {
                else if (n === 0x7d) this.onToken(RIGHT_BRACE, "}"); // }
                else if (n === 0x5b) this.onToken(LEFT_BRACKET, "["); // [
                else if (n === 0x5d) this.onToken(RIGHT_BRACKET, "]"); // ]
                else if (n === 0x3a) this.onToken(COLON, ":"); // :
                else if (n === 0x2c) this.onToken(COMMA, ","); // ,
                else if (n === 0x74) this.tState = TRUE1; // t
                else if (n === 0x66) this.tState = FALSE1; // f
                else if (n === 0x6e) this.tState = NULL1; // n
                else if (n === 0x22) {
                    this.string = "";
                    this.stringBufferOffset = 0;
                    this.tState = STRING1;
                } else if (n === 0x2d) {
                    this.string = "-";
                    this.tState = NUMBER1; // -
                } else {
                    if (n >= 0x30 && n < 0x40) {
                        this.string = String.fromCharCode(n);
                        this.tState = NUMBER3;
                    } else if (n === 0x20 || n === 0x09 || n === 0x0a || n === 0x0d) ;
                    else return this.charError(buffer, i);
                }
            } else if (this.tState === STRING1) {
                n = buffer[i]; // get current byte from buffer
                // check for carry over of a multi byte char split between data chunks
                // & fill temp buffer it with start of this data chunk up to the boundary limit set in the last iteration
                if (this.bytes_remaining > 0) {
                    for(var j = 0; j < this.bytes_remaining; j++)this.temp_buffs[this.bytes_in_sequence][this.bytes_in_sequence - this.bytes_remaining + j] = buffer[j];
                    this.appendStringBuf(this.temp_buffs[this.bytes_in_sequence]);
                    this.bytes_in_sequence = this.bytes_remaining = 0;
                    i = i + j - 1;
                } else if (this.bytes_remaining === 0 && n >= 128) {
                    if (n <= 193 || n > 244) return this.onError(new Error("Invalid UTF-8 character at position " + i + " in state " + Parser.toknam(this.tState)));
                    if (n >= 194 && n <= 223) this.bytes_in_sequence = 2;
                    if (n >= 224 && n <= 239) this.bytes_in_sequence = 3;
                    if (n >= 240 && n <= 244) this.bytes_in_sequence = 4;
                    if (this.bytes_in_sequence + i > buffer.length) {
                        for(var k = 0; k <= buffer.length - 1 - i; k++)this.temp_buffs[this.bytes_in_sequence][k] = buffer[i + k]; // fill temp buffer of correct size with bytes available in this chunk
                        this.bytes_remaining = i + this.bytes_in_sequence - buffer.length;
                        i = buffer.length - 1;
                    } else {
                        this.appendStringBuf(buffer, i, i + this.bytes_in_sequence);
                        i = i + this.bytes_in_sequence - 1;
                    }
                } else if (n === 0x22) {
                    this.tState = START;
                    this.string += this.stringBuffer.toString("utf8", 0, this.stringBufferOffset);
                    this.stringBufferOffset = 0;
                    this.onToken(STRING, this.string);
                    this.offset += Buffer.byteLength(this.string, "utf8") + 1;
                    this.string = undefined;
                } else if (n === 0x5c) this.tState = STRING2;
                else if (n >= 0x20) this.appendStringChar(n);
                else return this.charError(buffer, i);
            } else if (this.tState === STRING2) {
                n = buffer[i];
                if (n === 0x22) {
                    this.appendStringChar(n);
                    this.tState = STRING1;
                } else if (n === 0x5c) {
                    this.appendStringChar(BACK_SLASH);
                    this.tState = STRING1;
                } else if (n === 0x2f) {
                    this.appendStringChar(FORWARD_SLASH);
                    this.tState = STRING1;
                } else if (n === 0x62) {
                    this.appendStringChar(BACKSPACE);
                    this.tState = STRING1;
                } else if (n === 0x66) {
                    this.appendStringChar(FORM_FEED);
                    this.tState = STRING1;
                } else if (n === 0x6e) {
                    this.appendStringChar(NEWLINE);
                    this.tState = STRING1;
                } else if (n === 0x72) {
                    this.appendStringChar(CARRIAGE_RETURN);
                    this.tState = STRING1;
                } else if (n === 0x74) {
                    this.appendStringChar(TAB);
                    this.tState = STRING1;
                } else if (n === 0x75) {
                    this.unicode = "";
                    this.tState = STRING3;
                } else return this.charError(buffer, i);
            } else if (this.tState === STRING3 || this.tState === STRING4 || this.tState === STRING5 || this.tState === STRING6) {
                n = buffer[i];
                // 0-9 A-F a-f
                if (n >= 0x30 && n < 0x40 || n > 0x40 && n <= 0x46 || n > 0x60 && n <= 0x66) {
                    this.unicode += String.fromCharCode(n);
                    if (this.tState++ === STRING6) {
                        var intVal = parseInt(this.unicode, 16);
                        this.unicode = undefined;
                        if (this.highSurrogate !== undefined && intVal >= 0xDC00 && intVal < 57344) {
                            this.appendStringBuf(new Buffer(String.fromCharCode(this.highSurrogate, intVal)));
                            this.highSurrogate = undefined;
                        } else if (this.highSurrogate === undefined && intVal >= 0xD800 && intVal < 56320) this.highSurrogate = intVal;
                        else {
                            if (this.highSurrogate !== undefined) {
                                this.appendStringBuf(new Buffer(String.fromCharCode(this.highSurrogate)));
                                this.highSurrogate = undefined;
                            }
                            this.appendStringBuf(new Buffer(String.fromCharCode(intVal)));
                        }
                        this.tState = STRING1;
                    }
                } else return this.charError(buffer, i);
            } else if (this.tState === NUMBER1 || this.tState === NUMBER3) {
                n = buffer[i];
                switch(n){
                    case 0x30:
                    case 0x31:
                    case 0x32:
                    case 0x33:
                    case 0x34:
                    case 0x35:
                    case 0x36:
                    case 0x37:
                    case 0x38:
                    case 0x39:
                    case 0x2e:
                    case 0x65:
                    case 0x45:
                    case 0x2b:
                    case 0x2d:
                        this.string += String.fromCharCode(n);
                        this.tState = NUMBER3;
                        break;
                    default:
                        this.tState = START;
                        var result = Number(this.string);
                        if (isNaN(result)) return this.charError(buffer, i);
                        if (this.string.match(/[0-9]+/) == this.string && result.toString() != this.string) // Long string of digits which is an ID string and not valid and/or safe JavaScript integer Number
                        this.onToken(STRING, this.string);
                        else this.onToken(NUMBER, result);
                        this.offset += this.string.length - 1;
                        this.string = undefined;
                        i--;
                        break;
                }
            } else if (this.tState === TRUE1) {
                if (buffer[i] === 0x72) this.tState = TRUE2;
                else return this.charError(buffer, i);
            } else if (this.tState === TRUE2) {
                if (buffer[i] === 0x75) this.tState = TRUE3;
                else return this.charError(buffer, i);
            } else if (this.tState === TRUE3) {
                if (buffer[i] === 0x65) {
                    this.tState = START;
                    this.onToken(TRUE, true);
                    this.offset += 3;
                } else return this.charError(buffer, i);
            } else if (this.tState === FALSE1) {
                if (buffer[i] === 0x61) this.tState = FALSE2;
                else return this.charError(buffer, i);
            } else if (this.tState === FALSE2) {
                if (buffer[i] === 0x6c) this.tState = FALSE3;
                else return this.charError(buffer, i);
            } else if (this.tState === FALSE3) {
                if (buffer[i] === 0x73) this.tState = FALSE4;
                else return this.charError(buffer, i);
            } else if (this.tState === FALSE4) {
                if (buffer[i] === 0x65) {
                    this.tState = START;
                    this.onToken(FALSE, false);
                    this.offset += 4;
                } else return this.charError(buffer, i);
            } else if (this.tState === NULL1) {
                if (buffer[i] === 0x75) this.tState = NULL2;
                else return this.charError(buffer, i);
            } else if (this.tState === NULL2) {
                if (buffer[i] === 0x6c) this.tState = NULL3;
                else return this.charError(buffer, i);
            } else if (this.tState === NULL3) {
                if (buffer[i] === 0x6c) {
                    this.tState = START;
                    this.onToken(NULL, null);
                    this.offset += 3;
                } else return this.charError(buffer, i);
            }
        }
    };
    proto.onToken = function(token, value) {
    // Override this to get events
    };
    proto.parseError = function(token, value) {
        this.tState = STOP;
        this.onError(new Error("Unexpected " + Parser.toknam(token) + (value ? "(" + JSON.stringify(value) + ")" : "") + " in state " + Parser.toknam(this.state)));
    };
    proto.push = function() {
        this.stack.push({
            value: this.value,
            key: this.key,
            mode: this.mode
        });
    };
    proto.pop = function() {
        var value = this.value;
        var parent = this.stack.pop();
        this.value = parent.value;
        this.key = parent.key;
        this.mode = parent.mode;
        this.emit(value);
        if (!this.mode) this.state = VALUE;
    };
    proto.emit = function(value) {
        if (this.mode) this.state = COMMA;
        this.onValue(value);
    };
    proto.onValue = function(value) {
    // Override me
    };
    proto.onToken = function(token, value) {
        if (this.state === VALUE) {
            if (token === STRING || token === NUMBER || token === TRUE || token === FALSE || token === NULL) {
                if (this.value) this.value[this.key] = value;
                this.emit(value);
            } else if (token === LEFT_BRACE) {
                this.push();
                if (this.value) this.value = this.value[this.key] = {};
                else this.value = {};
                this.key = undefined;
                this.state = KEY;
                this.mode = OBJECT;
            } else if (token === LEFT_BRACKET) {
                this.push();
                if (this.value) this.value = this.value[this.key] = [];
                else this.value = [];
                this.key = 0;
                this.mode = ARRAY;
                this.state = VALUE;
            } else if (token === RIGHT_BRACE) {
                if (this.mode === OBJECT) this.pop();
                else return this.parseError(token, value);
            } else if (token === RIGHT_BRACKET) {
                if (this.mode === ARRAY) this.pop();
                else return this.parseError(token, value);
            } else return this.parseError(token, value);
        } else if (this.state === KEY) {
            if (token === STRING) {
                this.key = value;
                this.state = COLON;
            } else if (token === RIGHT_BRACE) this.pop();
            else return this.parseError(token, value);
        } else if (this.state === COLON) {
            if (token === COLON) this.state = VALUE;
            else return this.parseError(token, value);
        } else if (this.state === COMMA) {
            if (token === COMMA) {
                if (this.mode === ARRAY) {
                    this.key++;
                    this.state = VALUE;
                } else if (this.mode === OBJECT) this.state = KEY;
            } else if (token === RIGHT_BRACKET && this.mode === ARRAY || token === RIGHT_BRACE && this.mode === OBJECT) this.pop();
            else return this.parseError(token, value);
        } else return this.parseError(token, value);
    };
    Parser.C = C;
    var jsonparse = Parser;
    var Transform$1 = Stream.Transform;
    var JSON2CSVTransform = /*#__PURE__*/ function(_Transform) {
        _inherits(JSON2CSVTransform, _Transform);
        function JSON2CSVTransform(opts, transformOpts) {
            var _this;
            _classCallCheck(this, JSON2CSVTransform);
            _this = _possibleConstructorReturn(this, _getPrototypeOf(JSON2CSVTransform).call(this, transformOpts)); // Inherit methods from JSON2CSVBase since extends doesn't
            // allow multiple inheritance and manually preprocess opts
            Object.getOwnPropertyNames(JSON2CSVBase_1.prototype).forEach(function(key) {
                return _this[key] = JSON2CSVBase_1.prototype[key];
            });
            _this.opts = _this.preprocessOpts(opts);
            _this._data = "";
            _this._hasWritten = false;
            if (_this._readableState.objectMode) _this.initObjectModeParse();
            else if (_this.opts.ndjson) _this.initNDJSONParse();
            else _this.initJSONParser();
            if (_this.opts.withBOM) _this.push("\uFEFF");
            if (_this.opts.fields) {
                _this.opts.fields = _this.preprocessFieldsInfo(_this.opts.fields);
                _this.pushHeader();
            }
            return _this;
        }
        /**
     * Init the transform with a parser to process data in object mode.
     * It receives JSON objects one by one and send them to `pushLine for processing.
     */ _createClass(JSON2CSVTransform, [
            {
                key: "initObjectModeParse",
                value: function initObjectModeParse() {
                    var transform = this;
                    this.parser = {
                        write: function write(line) {
                            transform.pushLine(line);
                        },
                        getPendingData: function getPendingData() {
                            return undefined;
                        }
                    };
                }
            },
            {
                key: "initNDJSONParse",
                value: function initNDJSONParse() {
                    var transform = this;
                    this.parser = {
                        _data: "",
                        write: function write(chunk) {
                            this._data += chunk.toString();
                            var lines = this._data.split("\n").map(function(line) {
                                return line.trim();
                            }).filter(function(line) {
                                return line !== "";
                            });
                            var pendingData = false;
                            lines.forEach(function(line, i) {
                                try {
                                    transform.pushLine(JSON.parse(line));
                                } catch (e) {
                                    if (i === lines.length - 1) pendingData = true;
                                    else {
                                        e.message = "Invalid JSON (".concat(line, ")");
                                        transform.emit("error", e);
                                    }
                                }
                            });
                            this._data = pendingData ? this._data.slice(this._data.lastIndexOf("\n")) : "";
                        },
                        getPendingData: function getPendingData() {
                            return this._data;
                        }
                    };
                }
            },
            {
                key: "initJSONParser",
                value: function initJSONParser() {
                    var transform = this;
                    this.parser = new jsonparse();
                    this.parser.onValue = function(value) {
                        if (this.stack.length !== this.depthToEmit) return;
                        transform.pushLine(value);
                    };
                    this.parser._onToken = this.parser.onToken;
                    this.parser.onToken = function(token, value) {
                        transform.parser._onToken(token, value);
                        if (this.stack.length === 0 && !transform.opts.fields && this.mode !== jsonparse.C.ARRAY && this.mode !== jsonparse.C.OBJECT) this.onError(new Error('Data should not be empty or the "fields" option should be included'));
                        if (this.stack.length === 1) {
                            if (this.depthToEmit === undefined) // If Array emit its content, else emit itself
                            this.depthToEmit = this.mode === jsonparse.C.ARRAY ? 1 : 0;
                            if (this.depthToEmit !== 0 && this.stack.length === 1) // No need to store the whole root array in memory
                            this.value = undefined;
                        }
                    };
                    this.parser.getPendingData = function() {
                        return this.value;
                    };
                    this.parser.onError = function(err) {
                        if (err.message.includes("Unexpected")) err.message = "Invalid JSON (".concat(err.message, ")");
                        transform.emit("error", err);
                    };
                }
            },
            {
                key: "_transform",
                value: function _transform(chunk, encoding, done) {
                    this.parser.write(chunk);
                    done();
                }
            },
            {
                key: "_flush",
                value: function _flush(done) {
                    if (this.parser.getPendingData()) done(new Error("Invalid data received from stdin", this.parser.getPendingData()));
                    done();
                }
            },
            {
                key: "pushHeader",
                value: function pushHeader() {
                    if (this.opts.header) {
                        var header = this.getHeader();
                        this.emit("header", header);
                        this.push(header);
                        this._hasWritten = true;
                    }
                }
            },
            {
                key: "pushLine",
                value: function pushLine(data) {
                    var _this2 = this;
                    var processedData = this.preprocessRow(data);
                    if (!this._hasWritten) {
                        this.opts.fields = this.opts.fields || this.preprocessFieldsInfo(Object.keys(processedData[0]));
                        this.pushHeader();
                    }
                    processedData.forEach(function(row) {
                        var line = _this2.processRow(row, _this2.opts);
                        if (line === undefined) return;
                        _this2.emit("line", line);
                        _this2.push(_this2._hasWritten ? _this2.opts.eol + line : line);
                        _this2._hasWritten = true;
                    });
                }
            }
        ]);
        return JSON2CSVTransform;
    }(Transform$1);
    var JSON2CSVTransform_1 = JSON2CSVTransform;
    var Transform$2 = Stream.Transform;
    var fastJoin$3 = utils.fastJoin;
    var JSON2CSVAsyncParser = /*#__PURE__*/ function() {
        function JSON2CSVAsyncParser(opts, transformOpts) {
            _classCallCheck(this, JSON2CSVAsyncParser);
            this.input = new Transform$2(transformOpts);
            this.input._read = function() {};
            this.transform = new JSON2CSVTransform_1(opts, transformOpts);
            this.processor = this.input.pipe(this.transform);
        }
        _createClass(JSON2CSVAsyncParser, [
            {
                key: "fromInput",
                value: function fromInput(input) {
                    if (this._input) throw new Error("Async parser already has an input.");
                    this._input = input;
                    this.input = this._input.pipe(this.processor);
                    return this;
                }
            },
            {
                key: "throughTransform",
                value: function throughTransform(transform) {
                    if (this._output) throw new Error("Can't add transforms once an output has been added.");
                    this.processor = this.processor.pipe(transform);
                    return this;
                }
            },
            {
                key: "toOutput",
                value: function toOutput(output) {
                    if (this._output) throw new Error("Async parser already has an output.");
                    this._output = output;
                    this.processor = this.processor.pipe(output);
                    return this;
                }
            },
            {
                key: "promise",
                value: function promise() {
                    var _this = this;
                    var returnCSV = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                    return new Promise(function(resolve, reject) {
                        if (!returnCSV) {
                            _this.processor.on("finish", function() {
                                return resolve();
                            }).on("error", function(err) {
                                return reject(err);
                            });
                            return;
                        }
                        var csvBuffer = [];
                        _this.processor.on("data", function(chunk) {
                            return csvBuffer.push(chunk.toString());
                        }).on("finish", function() {
                            return resolve(fastJoin$3(csvBuffer, ""));
                        }).on("error", function(err) {
                            return reject(err);
                        });
                    });
                }
            }
        ]);
        return JSON2CSVAsyncParser;
    }();
    var JSON2CSVAsyncParser_1 = JSON2CSVAsyncParser;
    /**
   * Performs the flattening of a data row recursively
   *
   * @param {String} separator Separator to be used as the flattened field name
   * @returns {Object => Object} Flattened object
   */ function flatten() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$objects = _ref.objects, objects = _ref$objects === void 0 ? true : _ref$objects, _ref$arrays = _ref.arrays, arrays = _ref$arrays === void 0 ? false : _ref$arrays, _ref$separator = _ref.separator, separator = _ref$separator === void 0 ? "." : _ref$separator;
        function step(obj, flatDataRow, currentPath) {
            Object.keys(obj).forEach(function(key) {
                var newPath = currentPath ? "".concat(currentPath).concat(separator).concat(key) : key;
                var value = obj[key];
                if (objects && _typeof(value) === "object" && value !== null && !Array.isArray(value) && Object.prototype.toString.call(value.toJSON) !== "[object Function]" && Object.keys(value).length) {
                    step(value, flatDataRow, newPath);
                    return;
                }
                if (arrays && Array.isArray(value)) {
                    step(value, flatDataRow, newPath);
                    return;
                }
                flatDataRow[newPath] = value;
            });
            return flatDataRow;
        }
        return function(dataRow) {
            return step(dataRow, {});
        };
    }
    var flatten_1 = flatten;
    var setProp$1 = utils.setProp, unsetProp$1 = utils.unsetProp, flattenReducer$3 = utils.flattenReducer;
    function getUnwindablePaths(obj, currentPath) {
        return Object.keys(obj).reduce(function(unwindablePaths, key) {
            var newPath = currentPath ? "".concat(currentPath, ".").concat(key) : key;
            var value = obj[key];
            if (_typeof(value) === "object" && value !== null && !Array.isArray(value) && Object.prototype.toString.call(value.toJSON) !== "[object Function]" && Object.keys(value).length) unwindablePaths = unwindablePaths.concat(getUnwindablePaths(value, newPath));
            else if (Array.isArray(value)) {
                unwindablePaths.push(newPath);
                unwindablePaths = unwindablePaths.concat(value.map(function(arrObj) {
                    return getUnwindablePaths(arrObj, newPath);
                }).reduce(flattenReducer$3, []).filter(function(item, index, arr) {
                    return arr.indexOf(item) !== index;
                }));
            }
            return unwindablePaths;
        }, []);
    }
    /**
   * Performs the unwind recursively in specified sequence
   *
   * @param {String[]} unwindPaths The paths as strings to be used to deconstruct the array
   * @returns {Object => Array} Array of objects containing all rows after unwind of chosen paths
  */ function unwind() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$paths = _ref.paths, paths = _ref$paths === void 0 ? undefined : _ref$paths, _ref$blankOut = _ref.blankOut, blankOut = _ref$blankOut === void 0 ? false : _ref$blankOut;
        function unwindReducer(rows, unwindPath) {
            return rows.map(function(row) {
                var unwindArray = lodash_get(row, unwindPath);
                if (!Array.isArray(unwindArray)) return row;
                if (!unwindArray.length) return unsetProp$1(row, unwindPath);
                return unwindArray.map(function(unwindRow, index) {
                    var clonedRow = blankOut && index > 0 ? {} : row;
                    return setProp$1(clonedRow, unwindPath, unwindRow);
                });
            }).reduce(flattenReducer$3, []);
        }
        paths = Array.isArray(paths) ? paths : paths ? [
            paths
        ] : undefined;
        return function(dataRow) {
            return (paths || getUnwindablePaths(dataRow)).reduce(unwindReducer, [
                dataRow
            ]);
        };
    }
    var unwind_1 = unwind;
    var Readable$1 = Stream.Readable;
    var Parser$1 = JSON2CSVParser_1;
    var AsyncParser = JSON2CSVAsyncParser_1;
    var Transform$3 = JSON2CSVTransform_1; // Convenience method to keep the API similar to version 3.X
    var parse = function parse(data, opts) {
        return new JSON2CSVParser_1(opts).parse(data);
    };
    var parseAsync = function parseAsync(data, opts, transformOpts) {
        try {
            if (!(data instanceof Readable$1)) transformOpts = Object.assign({}, transformOpts, {
                objectMode: true
            });
            var asyncParser = new JSON2CSVAsyncParser_1(opts, transformOpts);
            var promise = asyncParser.promise();
            if (Array.isArray(data)) {
                data.forEach(function(item) {
                    return asyncParser.input.push(item);
                });
                asyncParser.input.push(null);
            } else if (data instanceof Readable$1) asyncParser.fromInput(data);
            else {
                asyncParser.input.push(data);
                asyncParser.input.push(null);
            }
            return promise;
        } catch (err) {
            return Promise.reject(err);
        }
    };
    var transforms = {
        flatten: flatten_1,
        unwind: unwind_1
    };
    var json2csv = {
        Parser: Parser$1,
        AsyncParser: AsyncParser,
        Transform: Transform$3,
        parse: parse,
        parseAsync: parseAsync,
        transforms: transforms
    };
    exports1.AsyncParser = AsyncParser;
    exports1.Parser = Parser$1;
    exports1.Transform = Transform$3;
    exports1.default = json2csv;
    exports1.parse = parse;
    exports1.parseAsync = parseAsync;
    exports1.transforms = transforms;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});




var $f3de836a3961a74a$exports = {};
$f3de836a3961a74a$exports = JSON.parse('{"common":{"id":"common","__comment":"This is a special type of data source that cannot be selected on its own but provides common values that other data sources inherit from.","segments":{"magic-carpet":{"average":2,"potential":3}}},"giz":{"id":"giz","source_title":"Passenger capacity of different transport modes","source_author":"Transformative Urban Mobility Initiative (TUMI)","source_url":"https://www.transformative-mobility.org/publications/passenger-capacity-of-different-transport-modes","typical_lane_width":3.5,"typical_lane_width_ft":11.5,"segments":{"sidewalk":{"average":15000,"potential":15000},"drive-lane":{"average":1500,"potential":2000,"variants":{"car-type:pedestrian":{"inherits":"sidewalk"}}},"bike-lane":{"average":12000,"potential":12000,"variants":{"bike-direction:twoway-left":{"average":24000,"potential":24000},"bike-direction:twoway-right":{"average":24000,"potential":24000}}},"scooter":{"inherits":"bike-lane"},"light-rail":{"average":18000,"potential":20000},"streetcar":{"inherits":"light-rail"},"bus-lane":{"average":5000,"potential":8000},"brt-lane":{"average":14000,"potential":24000}}},"nacto":{"id":"nacto","source_title":"Transit Street Design Guide (2016)","source_author":"NACTO","source_url":"https://nacto.org/publication/transit-street-design-guide/introduction/why/designing-move-people/","typical_lane_width":3,"typical_lane_width_ft":10,"segments":{"drive-lane":{"minimum":600,"potential":1600,"variants":{"car-type:pedestrian":{"inherits":"sidewalk"}}},"bus-lane":{"minimum":1000,"potential":2800},"bike-lane":{"average":3750,"variants":{"bike-direction:twoway-left":{"average":7500},"bike-direction:twoway-right":{"average":7500}}},"scooter":{"inherits":"bike-lane"},"brt-lane":{"minimum":4000,"potential":8000},"sidewalk":{"average":9000},"light-rail":{"average":10000,"potential":25000},"streetcar":{"inherits":"light-rail"}}},"vancouver":{"id":"vancouver","source_title":"People Moving Capacity: Vancouver Urban Transportation Modes (2017)","source_author":"City of Vancouver","source_url":"https://twitter.com/BrentToderian/status/953085021744611328","typical_lane_width":3,"typical_lane_width_ft":10,"segments":{"drive-lane":{"minimum":700,"average":850,"potential":1000,"variants":{"car-type:pedestrian":{"inherits":"sidewalk"}}},"bus-lane":{"minimum":1000,"average":1700,"potential":2000},"bike-lane":{"minimum":2000,"potential":3000,"variants":{"bike-direction:twoway-left":{"minimum":4000,"potential":6000},"bike-direction:twoway-right":{"minimum":4000,"potential":6000}}},"scooter":{"inherits":"bike-lane"},"brt-lane":{"minimum":3000,"average":3500,"potential":4000},"sidewalk":{"minimum":5000,"average":5500,"potential":6500},"light-rail":{"minimum":2000,"potential":2500},"streetcar":{"inherits":"light-rail"}}}}');


const $403f4a82e85beb9f$var$BASE_DATA_SOURCE = "common";
const $403f4a82e85beb9f$var$CAPACITIES = $403f4a82e85beb9f$var$processCapacityData();
/**
 * When this module is initialized, process SOURCE_DATA:
 * - Each data source should inherit values from "common".
 * - Each segment with inherited values should inherit those values
 * - Add a special source for "none". This can be used as a backup
 *   in case a source is specified but it no longer exists or becomes
 *   removed in the future. Code that works with the entire capacity
 *   source object should handle the "none" case manually.
 */ function $403f4a82e85beb9f$var$processCapacityData() {
    const processed = {
    };
    const sourceKeys = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($f3de836a3961a74a$exports))));
    for(let i = 0; i < sourceKeys.length; i++){
        const sourceKey = sourceKeys[i];
        const data = (0, (/*@__PURE__*/$parcel$interopDefault($f3de836a3961a74a$exports)))[sourceKey];
        // Skip the "common" data source from processing
        if (data.id === $403f4a82e85beb9f$var$BASE_DATA_SOURCE) continue;
        processed[sourceKey] = {
            ...data,
            segments: {
                // Clone "common" segments into our processed definition
                ...(0, (/*@__PURE__*/$parcel$interopDefault($f3de836a3961a74a$exports)))[$403f4a82e85beb9f$var$BASE_DATA_SOURCE].segments,
                // Iterate through source segment data and process each.
                ...$403f4a82e85beb9f$var$processInheritedValues(data.segments)
            }
        };
    }
    return processed;
}
/**
 * Utility function for processing inherited values. Accepts an object
 * whose keys are segments and values are objects. If the value contains
 * the "inherits" property it will replace the value with inherited values.
 * Otherwise the object data is passed through.
 *
 * @param {Object} definitions - object to process
 * @param {Object} inheritSource - optional source of inherited values
 */ function $403f4a82e85beb9f$var$processInheritedValues(definitions, inheritSource) {
    const processed = {};
    const source = inheritSource || definitions;
    const keys = Object.keys(definitions);
    for(let j = 0; j < keys.length; j++){
        const key = keys[j];
        const segment = definitions[key];
        // Process inherited segments
        // Processed segments clone original data to prevent
        // other code from modifying the source
        let clone;
        if (segment.inherits) clone = {
            ...source[segment.inherits]
        };
        else clone = {
            ...segment
        };
        // Process variants, if present
        if (segment.variants) clone.variants = $403f4a82e85beb9f$var$processInheritedValues(segment.variants, definitions);
        processed[key] = clone;
    }
    return processed;
}
function $403f4a82e85beb9f$export$795d613bdc2453ad() {
    return $403f4a82e85beb9f$var$CAPACITIES;
}
function $403f4a82e85beb9f$export$2f9594ac3fc4865a(source = (0, $2a9a05c10189c2fe$export$9c2554d45cd8fa3)) {
    return $403f4a82e85beb9f$var$CAPACITIES[source];
}
function $403f4a82e85beb9f$export$b79e9cb93bcb351(segment, source) {
    let capacity = $403f4a82e85beb9f$export$2f9594ac3fc4865a(source).segments[segment.type];
    // If definition has variants, use that instead
    if (capacity?.variants && segment.variant) Object.entries(segment.variant).forEach((entry)=>{
        const key = entry.join(":");
        if (capacity.variants?.[key]) capacity = capacity.variants[key];
    });
    // If a segment has capacity data, but something makes it zero capacity,
    // return modified values here.
    if (capacity && segment?.warnings && (segment.warnings[0, $e1cc3cddc7acf1a4$export$bd07f8babb22a89f] || segment.warnings[0, $e1cc3cddc7acf1a4$export$1603ba7a45cd1a72])) return {
        average: 0,
        potential: 0
    };
    if (capacity) return {
        // Temporary: map minimum values to average
        average: capacity.average ?? capacity.minimum ?? undefined,
        // Temporary: map undefined potential values from average
        potential: capacity.potential ?? capacity.average ?? undefined
    };
    // Returns null value if capacity is not defined
    return null;
}
function $403f4a82e85beb9f$export$da50bfba905adb3e(street) {
    const { segments: segments, capacitySource: capacitySource } = street;
    const segmentCapacities = segments.map((segment)=>$403f4a82e85beb9f$export$b79e9cb93bcb351(segment, capacitySource));
    const sum = (total, num)=>{
        if (!Number.isInteger(num)) return total;
        return total + num;
    };
    const average = segmentCapacities.map((capacity)=>capacity?.average || 0).reduce(sum, 0);
    const potential = segmentCapacities.map((capacity)=>capacity?.potential || 0).reduce(sum, 0);
    return {
        average: average,
        potential: potential
    };
}
function $403f4a82e85beb9f$export$277fe1e3e6bf94ed(street) {
    const { segments: segments, capacitySource: capacitySource } = street;
    const capacities = segments// Iterate through each segment to determine its capacity
    .map((segment)=>({
            type: segment.type,
            capacity: $403f4a82e85beb9f$export$b79e9cb93bcb351(segment, capacitySource)
        }))// Drop all segments without capacity information
    .filter((segment)=>segment.capacity !== null)// Combine capacity values of segments of the same type
    .reduce((accumulator, { type: type, capacity: capacity })=>{
        accumulator[type] = $403f4a82e85beb9f$var$mergeCapacity(accumulator[type], capacity);
        return accumulator;
    }, {});
    // Convert object back to array and sort, first by increasing
    // average, then by increasing potential
    return Object.keys(capacities).map((key)=>({
            type: key,
            capacity: capacities[key]
        })).sort($403f4a82e85beb9f$var$sortByCapacity);
}
function $403f4a82e85beb9f$var$mergeCapacity(a = {}, b) {
    return {
        average: (a.average || 0) + b.average,
        potential: (a.potential || 0) + b.potential
    };
}
function $403f4a82e85beb9f$var$sortByCapacity(a, b) {
    const a1 = a.capacity.average;
    const b1 = b.capacity.average;
    const a2 = a.capacity.potential;
    const b2 = b.capacity.potential;
    if (a1 < b1) return -1;
    if (a1 > b1) return 1;
    if (a2 < b2) return -1;
    if (a2 > b2) return 1;
    return 0;
}
function $403f4a82e85beb9f$export$a08f02ee267cf6eb(data, streetName) {
    const fields = [
        "type",
        "averageCapacity",
        "potentialCapacity"
    ];
    const opts = {
        fields: fields
    };
    const formattedData = data.map((row)=>({
            type: row.type,
            averageCapacity: row.capacity.average,
            potentialCapacity: row.capacity.potential
        }));
    try {
        const csv = (0, $64e9a2b98996ad01$exports.parse)(formattedData, opts);
        const downloadLink = document.createElement("a");
        const blob = new Blob([
            "\uFEFF",
            csv
        ]);
        const url = URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = `${streetName}_capacity.csv`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
    } catch (err) {
        console.error(err);
    }
}




function $c097e071171a44ae$var$StreetMetaAnalytics(props) {
    const street = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street);
    const locale = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.locale.locale);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const averageCapacity = (0, $403f4a82e85beb9f$export$da50bfba905adb3e)(street).average;
    const title = intl.formatMessage({
        id: "dialogs.analytics.heading",
        defaultMessage: "Analytics"
    });
    // If zero capacity, don't display anything
    if (averageCapacity > 0) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
        label: title,
        placement: "bottom",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("span", {
            className: "street-metadata-analytics",
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6ec9aef169c6b70a$export$33551288dd20f9ae), {}),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                    onClick: ()=>dispatch((0, $cdf0aaca62d15025$export$61e0a65f251cfdb3)("ANALYTICS")),
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "capacity.ppl-per-hour",
                        defaultMessage: "{capacity} people/hr",
                        values: {
                            capacity: (0, $9d270f5a79da1a95$export$f5dd818bff069720)(averageCapacity, locale)
                        }
                    })
                })
            ]
        })
    });
    return null;
}
var $c097e071171a44ae$export$2e2bcd8739ae039 = $c097e071171a44ae$var$StreetMetaAnalytics;



function $fe379ed50e737e09$var$StreetMeta(props) {
    const enableAnalytics = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.flags.ANALYTICS && state.flags.ANALYTICS.value || false);
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "street-metadata",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $34e00e92e8444ed3$export$2e2bcd8739ae039), {}),
            enableAnalytics && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $c097e071171a44ae$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $99fa3f8b061ff6e7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $df51851e22288fbd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $351225547e67ff84$export$2e2bcd8739ae039), {})
        ]
    });
}
var $fe379ed50e737e09$export$2e2bcd8739ae039 = $fe379ed50e737e09$var$StreetMeta;



function $97611685388f7b5d$var$StreetNameplateContainer(props) {
    const isVisible = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>!state.ui.welcomePanelVisible);
    const isEditable = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>!state.app.readOnly && state.flags.EDIT_STREET_NAME.value);
    const streetName = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street.name);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const streetNameEl = (0, $4DE7A.useRef)(null);
    const lastSentCoords = (0, $4DE7A.useRef)(null);
    const [menuCoords, setMenuCoords] = (0, $4DE7A.useState)({});
    const [streetNameCoords, setStreetNameCoords] = (0, $4DE7A.useState)({
        left: 0,
        width: 0
    });
    (0, $4DE7A.useEffect)(()=>{
        window.addEventListener("resize", updateCoords);
        window.addEventListener("stmx:menu_bar_resized", updatePositions);
        window.dispatchEvent(new CustomEvent("stmx:streetnameplate_mounted"));
        return ()=>{
            window.removeEventListener("resize", updateCoords);
            window.removeEventListener("stmx:menu_bar_resized", updatePositions);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const updateCoords = (0, $4DE7A.useCallback)(()=>{
        const rect = streetNameEl.current.getBoundingClientRect();
        const coords = {
            left: rect.left,
            width: rect.width
        };
        if (!lastSentCoords.current || coords.left !== lastSentCoords.current.left || coords.width !== lastSentCoords.current.width) {
            lastSentCoords.current = coords;
            handleResizeStreetName(coords);
        }
    }, []);
    // Only update coords when something affects the size of the nameplate,
    // prevents excessive cascading renders
    (0, $4DE7A.useEffect)(()=>{
        updateCoords();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        streetName
    ]);
    function handleResizeStreetName(coords) {
        setStreetNameCoords({
            left: coords.left,
            width: coords.width
        });
    }
    function updatePositions(event) {
        if (event.detail) setMenuCoords(event.detail);
    }
    function determineClassNames() {
        const classNames = [
            "street-nameplate-container"
        ];
        if (streetNameCoords.left < menuCoords.leftMenuBarRightPos || streetNameCoords.left + streetNameCoords.width > menuCoords.rightMenuBarLeftPos) classNames.push("move-down-for-menu");
        // <StreetNameplateContainer /> might stick out from underneath the
        // <WelcomePanel /> when it's visible. We've checked the store to see if
        // the panel is visible, and if so, this component is not. In this case,
        // momentarily keep the UI clean by hiding it until the panel goes away.
        if (!isVisible) classNames.push("hidden");
        return classNames;
    }
    function handleClickStreetName() {
        if (!isEditable) return;
        const newName = window.prompt(intl.formatMessage({
            id: "prompt.new-street",
            defaultMessage: "New street name:"
        }), streetName || intl.formatMessage({
            id: "street.default-name",
            defaultMessage: "Unnamed St"
        }));
        if (newName) dispatch((0, $8b007b7ac0907036$export$eb36756120db063a)(newName, true));
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: determineClassNames().join(" "),
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $1b80e7badd3600dc$export$2e2bcd8739ae039), {
                editable: isEditable,
                childRef: streetNameEl,
                name: streetName,
                onClick: handleClickStreetName
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $fe379ed50e737e09$export$2e2bcd8739ae039), {})
        ]
    });
}
var $97611685388f7b5d$export$2e2bcd8739ae039 = $97611685388f7b5d$var$StreetNameplateContainer;




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");












parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");








$4f4cc5139f548a9e$var$EditableLabel.propTypes = {
    // Label can be string, or React element (if translated by ReactIntl)
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).node,
    segment: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
            (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd),
            (0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492)
        ])
    ])
};
function $4f4cc5139f548a9e$var$EditableLabel(props) {
    const { label: label, segment: segment, position: position } = props;
    const isSubscriber = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.isSubscriber);
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const handleClick = (event)=>{
        (0, $2f44915f6f87dcf5$export$d56d73a7ccbe2018)(segment, position);
    };
    // If position is a string, it's a building, and buildings are currently not
    // editable at all, so render a label with no interactivity
    if (typeof position === "string") return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "info-bubble-label",
        children: label
    });
    if (isSubscriber) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "info-bubble-label info-bubble-label-editable",
        onClick: handleClick,
        children: [
            label,
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                className: "info-bubble-label-editable-icon",
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                    icon: (0, $5cbf5c54789c9bf6$export$ebaa24fafb6b0272)
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
        label: intl.formatMessage({
            id: "plus.locked.sub-edit",
            defaultMessage: "Upgrade to Streetmix+ to edit"
        }),
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
            className: "info-bubble-label info-bubble-label-editable",
            children: [
                label,
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                    className: "info-bubble-label-editable-icon",
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                        icon: (0, $5cbf5c54789c9bf6$export$e6d53d6f898a52bd)
                    })
                })
            ]
        })
    });
}
var $4f4cc5139f548a9e$export$2e2bcd8739ae039 = $4f4cc5139f548a9e$var$EditableLabel;



parcelRequire("4DE7A");

function $c2dd87b9410638e7$var$Triangle({ highlight: highlight = false }) {
    const triangleClassNames = [
        "info-bubble-triangle"
    ];
    if (highlight) triangleClassNames.push("info-bubble-triangle-highlight");
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: triangleClassNames.join(" ")
    });
}
var $c2dd87b9410638e7$export$2e2bcd8739ae039 = $c2dd87b9410638e7$var$Triangle;



parcelRequire("4DE7A");







function $c69d896ab581d870$export$d0365e48b58231c3(position) {
    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hide();
    // This makes sure that the drag handles on the segment
    // don't appear briefly after animating away
    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hideSegment();
    // Update the store
    // ToDo: Refactor all other methods that use this to update the store via there dispatch
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$d0365e48b58231c3)(position, false));
    (0, $2f44915f6f87dcf5$export$b2eeaeff46616de5)();
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ed796acc6691d871$export$2cb648f4e71e8121)({
        message: (0, $4daaf0496059b305$export$25868d1e8e76735f)("toast.segment-deleted", "The segment has been removed."),
        component: "TOAST_UNDO"
    }));
}
function $c69d896ab581d870$export$3dd503bd2daab402() {
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $8b007b7ac0907036$export$a69bfd14b8dc5d4d)());
    (0, $2f44915f6f87dcf5$export$b2eeaeff46616de5)();
    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hide();
    (0, $81878321270eabd6$export$2e2bcd8739ae039).dispatch((0, $ed796acc6691d871$export$2cb648f4e71e8121)({
        message: (0, $4daaf0496059b305$export$25868d1e8e76735f)("toast.all-segments-deleted", "All segments have been removed."),
        component: "TOAST_UNDO"
    }));
}





function $461af081e394ba37$var$RemoveButton({ segment: segment }) {
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const handleClick = (event)=>{
        // Prevent this “leaking” to a segment below
        event.preventDefault();
        // Power move: a shift key will remove all segments
        if (event.shiftKey) (0, $c69d896ab581d870$export$3dd503bd2daab402)();
        else // Otherwise, remove one segment
        (0, $c69d896ab581d870$export$d0365e48b58231c3)(segment);
    };
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
        className: "info-bubble-remove",
        tabIndex: -1,
        title: intl.formatMessage({
            id: "tooltip.remove-segment",
            defaultMessage: "Remove segment"
        }),
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                icon: "trash",
                className: "remove-icon"
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "btn.remove",
                defaultMessage: "Remove"
            })
        ]
    });
}
var $461af081e394ba37$export$2e2bcd8739ae039 = $461af081e394ba37$var$RemoveButton;



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");





var $cbfbf79b56a6cddd$exports = {};
$cbfbf79b56a6cddd$exports = JSON.parse('{"building":{"waterfront":{"id":"waterfront","title":"Waterfront"},"grass":{"id":"grass","title":"Grass"},"fence":{"id":"fence","title":"Empty lot"},"parking-lot":{"id":"car","title":"Parking lot"},"residential":{"id":"residential","title":"Home"},"narrow":{"id":"building-thin","title":"Narrow building"},"wide":{"id":"building-wide","title":"Wide building"},"arcade":{"id":"building-arcade","title":"Arcade building"},"compound-wall":{"id":"compound-wall","title":"Compound wall","unlockCondition":"SIGN_IN"}},"ground":{"concrete":{"id":"concrete","color":"#ff0000","title":"Concrete"},"asphalt":{"id":"asphalt","color":"#292a29","title":"Asphalt"}},"direction":{"inbound":{"id":"direction-inbound","title":"Inbound"},"outbound":{"id":"direction-outbound","title":"Outbound"}},"bike-direction":{"inbound":{"id":"direction-inbound","title":"Inbound"},"outbound":{"id":"direction-outbound","title":"Outbound"},"twoway-left":{"id":"direction-twoway-left","title":"Two-way (left-hand)","enableWithFlag":"VARIANT_TWOWAY_BIKES","unlockWithFlag":"VARIANT_TWOWAY_BIKES_UNLOCKED","unlockCondition":"SUBSCRIBE"},"twoway-right":{"id":"direction-twoway-right","title":"Two-way (right-hand)","enableWithFlag":"VARIANT_TWOWAY_BIKES","unlockWithFlag":"VARIANT_TWOWAY_BIKES_UNLOCKED","unlockCondition":"SUBSCRIBE"}},"parking-lane-direction":{"inbound":{"id":"direction-inbound","title":"Inbound"},"outbound":{"id":"direction-outbound","title":"Outbound"},"sideways":{"id":"direction-both","title":"Perpendicular"},"angled-front-left":{"id":"direction-down-left","title":"Angled"},"angled-front-right":{"id":"direction-down-right","title":"Angled"},"angled-rear-left":{"id":"direction-up-left","title":"Angled"},"angled-rear-right":{"id":"direction-up-right","title":"Angled"}},"tree-type":{"big":{"id":"tree","title":"Tree"},"palm-tree":{"id":"palm-tree","title":"Palm tree"}},"lamp-orientation":{"left":{"id":"direction-left","title":"Left"},"both":{"id":"direction-both","title":"Both"},"right":{"id":"direction-right","title":"Right"}},"lamp-type":{"modern":{"id":"lamp-modern","title":"Modern"},"traditional":{"id":"lamp-traditional-right","title":"Traditional"},"pride":{"id":"rainbow","title":"Modern with pride banner"}},"bench-orientation":{"left":{"id":"direction-left","title":"Left"},"center":{"id":"direction-both","title":"Center"},"right":{"id":"direction-right","title":"Right"}},"turn-lane-orientation":{"left":{"id":"turn-lane-left","title":"Left"},"left-straight":{"id":"turn-lane-left-straight","title":"Left and straight"},"straight":{"id":"turn-lane-straight","title":"Straight"},"right-straight":{"id":"turn-lane-right-straight","title":"Right and straight"},"right":{"id":"turn-lane-right","title":"Right"},"both":{"id":"turn-lane-both","title":"Both"},"left-right-straight":{"id":"turn-lane-left-right-straight","title":"Left, right and straight"},"shared":{"id":"turn-lane-shared","title":"Shared"}},"divider-type":{"median":{"id":"median","title":"Median"},"striped-buffer":{"id":"buffer","title":"Striped buffer"},"planting-strip":{"id":"grass","title":"Planting strip"},"planter-box":{"id":"planter-box","title":"Planter box"},"bush":{"id":"bush","title":"Planting strip with a bush"},"flowers":{"id":"flowers","title":"Planting strip with flowers"},"big-tree":{"id":"tree","title":"Planting strip with a tree"},"palm-tree":{"id":"palm-tree","title":"Planting strip with a palm tree"},"bollard":{"id":"bollard","title":"Bollard"},"dome":{"id":"dome","title":"Traffic exclusion dome"}},"crosswalk-type":{"zebra-crossing":{"id":"buffer","title":"Crosswalk"},"zebra-crossing-bike":{"id":"buffer","title":"Bike crossing"}},"orientation":{"left":{"id":"orientation-left","title":"Left"},"right":{"id":"orientation-right","title":"Right"}},"public-transit-asphalt":{"regular":{"id":"asphalt","color":"#292a29","title":"Asphalt"},"colored":{"id":"asphalt","color":"#9b1f22","title":"Red lane"},"grass":{"id":"grass","title":"Grass"}},"bus-asphalt":{"regular":{"id":"asphalt","color":"#292a29","title":"Asphalt"},"colored":{"id":"asphalt","color":"#9b1f22","title":"Red lane"},"shared":{"id":"sharrow","title":"Shared bus/bike lane"}},"bus-type":{"typical":{"id":"bus","title":"Typical bus"},"double-decker":{"id":"double-decker-bus","title":"Double decker bus","unlockCondition":"SUBSCRIBE"},"av-shuttle":{"id":"av-shuttle","title":"Autonomous shuttle","unlockCondition":"SUBSCRIBE"}},"brt-asphalt":{"regular":{"id":"asphalt","color":"#292a29","title":"Asphalt"},"red":{"id":"asphalt","color":"#9b1f22","title":"Red lane"}},"brt-station-orientation":{"left":{"id":"orientation-left","title":"Left"},"right":{"id":"orientation-right","title":"Right"},"center":{"id":"orientation-center","title":"Center"}},"bike-asphalt":{"regular":{"id":"asphalt","color":"#292a29","title":"Asphalt"},"green":{"id":"asphalt","color":"#2b6750","title":"Green lane"},"red":{"id":"asphalt","color":"#9b1f22","title":"Red lane "}},"transit-shelter-elevation":{"street-level":{"id":"elevation-lower","title":"Street level"},"light-rail":{"id":"elevation-higher","title":"Light rail platform"}},"bike-rack-elevation":{"sidewalk-parallel":{"id":"direction-both","title":"Parallel parking, sidewalk level"},"sidewalk":{"id":"elevation-higher","title":"Perpendicular parking, sidewalk level"},"road":{"id":"elevation-lower","title":"Perpendicular parking, road level"}},"car-type":{"car":{"id":"car","title":"Car"},"car-with-bus":{"id":"car-with-bus","title":"Car with bus","unlockCondition":"SUBSCRIBE","unlockWithFlag":"VARIANT_MIXED_DRIVE_LANES_1"},"car-with-bike":{"id":"car-with-bike","title":"Car with bike","unlockCondition":"SUBSCRIBE","unlockWithFlag":"VARIANT_MIXED_DRIVE_LANES_2"},"sharrow":{"id":"sharrow","title":"Sharrow"},"truck":{"id":"truck","title":"Truck"},"microvan":{"id":"microvan","title":"Microvan","unlockCondition":"SUBSCRIBE"},"av":{"id":"rideshare","title":"Autonomous vehicle","unlockCondition":"SIGN_IN"},"motorcycle-sidecar":{"id":"motorcycle-sidecar","title":"Motorcycle with sidecar","unlockCondition":"SIGN_IN"},"pedestrian":{"id":"sidewalk-density-normal","title":"Pedestrian","unlockCondition":"SIGN_IN"}},"sidewalk-density":{"dense":{"id":"sidewalk-density-dense","title":"Dense"},"normal":{"id":"sidewalk-density-normal","title":"Normal"},"sparse":{"id":"sidewalk-density-sparse","title":"Sparse"},"empty":{"id":"","title":"Empty"}},"parking-lane-orientation":{"left":{"id":"orientation-left","title":"Left"},"right":{"id":"orientation-right","title":"Right"}},"wayfinding-type":{"large":{"id":"wayfinding-large","title":"Large"},"medium":{"id":"wayfinding-medium","title":"Medium"},"small":{"id":"wayfinding-small","title":"Small"}},"flex-type":{"taxi":{"id":"taxi","title":"Taxi"},"rideshare":{"id":"rideshare","title":"Rideshare"}},"waiting-area":{"sparse":{"id":"sidewalk-density-sparse","title":"Someone"},"empty":{"id":"","title":"No one"}},"scooter-elevation":{"sidewalk":{"id":"elevation-higher","title":"Sidewalk level"},"road":{"id":"elevation-lower","title":"Road level"}},"scooter-riders":{"empty":{"id":"","title":"No one"},"sparse":{"id":"sidewalk-density-sparse","title":"Someone"}},"magic-carpet-occupants":{"aladdin":{"id":"aladdin","title":"Aladdin"},"jasmine":{"id":"jasmine","title":"Jasmine"},"aladdin-jasmine":{"id":"aladdin-jasmine","title":"Aladdin & Jasmine"},"jasmine-aladdin":{"id":"jasmine-aladdin","title":"Jasmine & Aladdin"}},"occupants":{"empty":{"id":"","title":"Empty"},"occupied":{"id":"sidewalk-density-normal","title":"Occupied"}},"elevation":{"sidewalk":{"id":"elevation-higher","title":"Sidewalk level"},"road":{"id":"elevation-lower","title":"Street level"}},"temporary-barrier-type":{"traffic-cone":{"id":"traffic-cone","title":"Traffic cone"},"barricade":{"id":"barricade","title":"Barricade"},"jersey-barrier-concrete":{"id":"jersey-barrier","title":"Jersey barrier (concrete)"},"jersey-barrier-plastic":{"id":"jersey-barrier","color":"#ef9c74","title":"Jersey barrier (plastic)"}},"drainage-sides":{"slanted":{"id":"drainage-slanted","title":"Slanted sides"},"vertical":{"id":"drainage-vertical","title":"Vertical sides"}},"brt-bus":{},"vendor-type":{"handcart":{"id":"vendor-handcart","title":"Vendor with hand cart"},"table":{"id":"vendor-table","title":"Vendor at table"},"tarp":{"id":"vendor-tarp","title":"Vendor on tarp on ground"},"platform":{"id":"vendor-platform","title":"Vendor at platform"}}}');









parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");








function $3c0a4f4b1db9b912$var$ElevationControl({ position: position, segment: segment, forceEnable: forceEnable = false }) {
    const isSubscriber = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.isSubscriber);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    function isVariantCurrentlySelected(set, selection) {
        let bool;
        switch(selection){
            case "sidewalk":
                bool = segment.elevation === 1;
                break;
            case "road":
                bool = segment.elevation === 0;
                break;
            default:
                bool = false;
                break;
        }
        return bool;
    }
    function getButtonOnClickHandler(set, selection) {
        let elevation;
        switch(selection){
            case "sidewalk":
                elevation = 1;
                break;
            case "road":
                elevation = 0;
                break;
        }
        return (event)=>{
            dispatch((0, $8b007b7ac0907036$export$ab16e687658adf3f)(position, {
                elevation: elevation
            }));
            (0, $2f44915f6f87dcf5$export$b2eeaeff46616de5)();
        };
    }
    function renderButton(set, selection) {
        const icon = (0, (/*@__PURE__*/$parcel$interopDefault($cbfbf79b56a6cddd$exports)))[set][selection];
        if (!icon) return null;
        let title = intl.formatMessage({
            id: `variant-icons.${set}|${selection}`,
            defaultMessage: icon.title
        });
        // Only subscribers can do this
        let isLocked = false;
        if (!isSubscriber && !forceEnable) {
            isLocked = true;
            const unlockConditionText = intl.formatMessage({
                id: "plus.locked.sub",
                // Default message ends with a Unicode-only left-right order mark
                // to allow for proper punctuation in `rtl` text direction
                // This character is hidden from editors by default!
                defaultMessage: "Upgrade to Streetmix+ to use!\u200E"
            });
            title += " \u2014 " + unlockConditionText;
        }
        const isSelected = isVariantCurrentlySelected(set, selection);
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
            title: title,
            className: isSelected ? "variant-selected" : null,
            disabled: isSelected || isLocked,
            onClick: getButtonOnClickHandler(set, selection),
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("svg", {
                    xmlns: "http://www.w3.org/1999/svg",
                    xmlnsXlink: "http://www.w3.org/1999/xlink",
                    className: "icon",
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("use", {
                        xlinkHref: `#icon-${icon.id}`
                    })
                }),
                isLocked && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                    icon: (0, $5cbf5c54789c9bf6$export$e6d53d6f898a52bd)
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            renderButton("elevation", "sidewalk"),
            renderButton("elevation", "road")
        ]
    });
}
$3c0a4f4b1db9b912$var$ElevationControl.propTypes = {
    position: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    segment: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        elevation: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
    }),
    forceEnable: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool
};
var $3c0a4f4b1db9b912$export$2e2bcd8739ae039 = $3c0a4f4b1db9b912$var$ElevationControl;


$35f7ba03d53715a0$var$Variants.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
            (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd),
            (0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492)
        ])
    ])
};
function $35f7ba03d53715a0$var$Variants(props) {
    const { type: type, position: position } = props;
    // Get the appropriate variant information
    const variant = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>{
        if (position === (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd)) return state.street.leftBuildingVariant;
        else if (position === (0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492)) return state.street.rightBuildingVariant;
        else if (Number.isInteger(position) && state.street.segments[position]) return state.street.segments[position].variantString;
    });
    const segment = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>{
        if (Number.isInteger(position) && state.street.segments[position]) return state.street.segments[position];
    });
    const flags = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.flags);
    const isSignedIn = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.signedIn);
    const isSubscriber = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.isSubscriber);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    let variantSets = [];
    let elevationToggle = false;
    switch(type){
        case 0, $4fd11a0514b0f864$export$d460bc3f6742cc13:
            {
                const segmentInfo = (0, $0cc5ae9f1eba4866$export$c3985e6b9763d4c2)(segment.type);
                if (segmentInfo) variantSets = segmentInfo.variants;
                if (segmentInfo?.enableElevation) elevationToggle = true;
                break;
            }
        case 0, $4fd11a0514b0f864$export$e446af77b1e2d289:
        case 0, $4fd11a0514b0f864$export$f3a5b4072e475415:
            variantSets = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($cbfbf79b56a6cddd$exports))).building);
            break;
        default:
            break;
    }
    // Remove any empty entries
    variantSets = variantSets.filter((x)=>x !== "");
    function isVariantCurrentlySelected(set, selection) {
        let bool;
        switch(type){
            case 0, $4fd11a0514b0f864$export$d460bc3f6742cc13:
                {
                    const obj = (0, $f22063bb59944341$export$4ad6a18860f0a250)(segment.type, variant);
                    bool = selection === obj[set];
                    break;
                }
            case 0, $4fd11a0514b0f864$export$e446af77b1e2d289:
            case 0, $4fd11a0514b0f864$export$f3a5b4072e475415:
                bool = selection === variant;
                break;
            default:
                bool = false;
                break;
        }
        return bool;
    }
    function getButtonOnClickHandler(set, selection) {
        let handler;
        switch(type){
            case 0, $4fd11a0514b0f864$export$d460bc3f6742cc13:
                handler = (event)=>{
                    dispatch((0, $8b007b7ac0907036$export$1fcfea2408a636c0)(position, set, selection));
                    (0, $2f44915f6f87dcf5$export$b2eeaeff46616de5)();
                };
                break;
            case 0, $4fd11a0514b0f864$export$e446af77b1e2d289:
                handler = (event)=>{
                    dispatch((0, $8b007b7ac0907036$export$42d56e5baa9ff42b)((0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd), selection));
                };
                break;
            case 0, $4fd11a0514b0f864$export$f3a5b4072e475415:
                handler = (event)=>{
                    dispatch((0, $8b007b7ac0907036$export$42d56e5baa9ff42b)((0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492), selection));
                };
                break;
            default:
                handler = ()=>{};
                break;
        }
        return handler;
    }
    function renderButton(set, selection) {
        const icon = (0, (/*@__PURE__*/$parcel$interopDefault($cbfbf79b56a6cddd$exports)))[set][selection];
        if (!icon) return null;
        // If a variant is disabled by feature flag, skip it
        if (icon.enableWithFlag) {
            const flag = flags[icon.enableWithFlag];
            if (!flag || !flag.value) return null;
        }
        let title = intl.formatMessage({
            id: `variant-icons.${set}|${selection}`,
            defaultMessage: icon.title
        });
        let isLocked = false;
        // If there is an enable condition, add a note to the tooltip if it
        // is locked for a reason (e.g. must sign in, must be a subscriber)
        // If an "unlock flag" is set, enable the thing
        if (icon.unlockCondition && !(icon.unlockWithFlag && flags[icon.unlockWithFlag]?.value === true)) {
            let unlockConditionText;
            switch(icon.unlockCondition){
                case "SUBSCRIBE":
                    if (!isSubscriber) {
                        isLocked = true;
                        unlockConditionText = intl.formatMessage({
                            id: "plus.locked.sub",
                            // Default message ends with a Unicode-only left-right order mark
                            // to allow for proper punctuation in `rtl` text direction
                            // This character is hidden from editors by default!
                            defaultMessage: "Upgrade to Streetmix+ to use!\u200E"
                        });
                    }
                    break;
                case "SIGN_IN":
                default:
                    if (!isSignedIn) {
                        isLocked = true;
                        unlockConditionText = intl.formatMessage({
                            id: "plus.locked.user",
                            // Default message ends with a Unicode-only left-right order mark
                            // to allow for proper punctuation in `rtl` text direction
                            // This character is hidden from editors by default!
                            defaultMessage: "Sign in to use!\u200E"
                        });
                    }
                    break;
            }
            if (unlockConditionText) title += " \u2014 " + unlockConditionText;
        }
        const isSelected = isVariantCurrentlySelected(set, selection);
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
            title: title,
            className: isSelected ? "variant-selected" : null,
            disabled: isSelected || isLocked,
            onClick: getButtonOnClickHandler(set, selection),
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("svg", {
                    xmlns: "http://www.w3.org/1999/svg",
                    xmlnsXlink: "http://www.w3.org/1999/xlink",
                    className: "icon",
                    style: icon.color ? {
                        fill: icon.color
                    } : null,
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("use", {
                        xlinkHref: `#icon-${icon.id}`
                    })
                }),
                isLocked && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                    icon: (0, $5cbf5c54789c9bf6$export$e6d53d6f898a52bd)
                })
            ]
        }, set + "." + selection);
    }
    function renderVariantsSelection() {
        const variantEls = [];
        switch(type){
            case 0, $4fd11a0514b0f864$export$d460bc3f6742cc13:
                {
                    let first = true;
                    // Each segment has some allowed variant sets (e.g. "direction")
                    for(const variant in variantSets){
                        const set = variantSets[variant];
                        // New row for each variant set
                        if (!first) {
                            const el = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("hr", {}, set);
                            variantEls.push(el);
                        } else first = false;
                        // Each variant set has some selection choices.
                        // VARIANT_ICONS is an object containing a list of what
                        // each of the selections are and data for building an icon.
                        // Different segments may refer to the same variant set
                        // ("direction" is a good example of this)
                        for(const selection in (0, (/*@__PURE__*/$parcel$interopDefault($cbfbf79b56a6cddd$exports)))[set]){
                            const el = renderButton(set, selection);
                            variantEls.push(el);
                        }
                    }
                    if (elevationToggle === true) {
                        // Street vendors always have enabled elevation controls
                        // regardless of subscriber state
                        const forceEnable = segment.type === "street-vendor" || flags.ELEVATION_CONTROLS_UNLOCKED.value === true;
                        // React wants a unique key here
                        variantEls.push(/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("hr", {}, "elevation_divider"));
                        variantEls.push(/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $3c0a4f4b1db9b912$export$2e2bcd8739ae039), {
                            position: position,
                            segment: segment,
                            forceEnable: forceEnable
                        }, "elevation_control"));
                    }
                    break;
                }
            case 0, $4fd11a0514b0f864$export$e446af77b1e2d289:
            case 0, $4fd11a0514b0f864$export$f3a5b4072e475415:
                {
                    const els = variantSets.map((building)=>renderButton("building", building));
                    variantEls.push(...els);
                    break;
                }
            default:
                break;
        }
        return variantEls;
    }
    // Do not render this component if there are no variants to select
    if (!variantSets || variantSets.length === 0) return null;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "variants",
        children: renderVariantsSelection()
    });
}
var $35f7ba03d53715a0$export$2e2bcd8739ae039 = $35f7ba03d53715a0$var$Variants;



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");








var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");





const $6cb7998e651a42e4$var$EDIT_INPUT_DELAY = 200;
$6cb7998e651a42e4$var$UpDownInput.propTypes = {
    // Raw input value must always be a number type which can be
    // compared with the minValue and maxValue.
    value: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    minValue: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    maxValue: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    // Formatter functions are used to optionally format raw values
    // for display. These functions should return a number or a string.
    // `inputValueFormatter` formats a value that is displayed when
    // a user has focused or hovered over the <input> element. If this
    // function is unspecified, the display value remains the raw
    // `value` prop.
    inputValueFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    // `displayValueFormatter` formats a value that is displayed inside
    // the <input> element when it is not being edited. If this
    // function is unspecified, the display value remains the raw
    // `value` prop.
    displayValueFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    // Handler functions are specified by the parent component. These
    // handlers should be responsible for validating raw inputs and
    // updating street data.
    onClickUp: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    onClickDown: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    onUpdatedValue: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    // When `true`, the input box and buttons are disabled
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    // Tooltip text
    inputTooltip: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    upTooltip: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    downTooltip: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    // If enabled, allow auto-update of values during input. This can
    // currently cause buggy and unexpected behavior, so it's disabled
    // by default.
    allowAutoUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool
};
function $6cb7998e651a42e4$var$UpDownInput(props) {
    // Destructure props with default values
    const { value: value, minValue: minValue, maxValue: maxValue, inputValueFormatter: inputValueFormatter = (value)=>value, displayValueFormatter: displayValueFormatter = (value)=>value, onClickUp: onClickUp = ()=>{}, onClickDown: onClickDown = ()=>{}, onUpdatedValue: onUpdatedValue = ()=>{}, disabled: disabled = false, inputTooltip: inputTooltip = "Change value", upTooltip: upTooltip = "Increment", downTooltip: downTooltip = "Decrement", allowAutoUpdate: allowAutoUpdate = false } = props;
    const oldValue = (0, $4DE7A.useRef)(null);
    const inputEl = (0, $4DE7A.useRef)();
    const [isEditing, setIsEditing] = (0, $4DE7A.useState)(false);
    const [isHovered, setIsHovered] = (0, $4DE7A.useState)(false);
    // If the initial `value` prop is `null` or undefined, the displayValue must
    // be initiated as an empty string, otherwise React throws a warning about
    // uncontrolled inputs when the value is changed later
    // The display value is not necessarily the same as the raw `value`. It is
    // usually the "pretty" formatted value.
    const [displayValue, setDisplayValue] = (0, $4DE7A.useState)(value ?? "");
    // This is the "dirty" user input value. This should be the input value when
    // it's set, otherwise display the formatted `displayValue`. This can be an
    // empty string, which is always valid user input.
    const [userInputValue, setUserInputValue] = (0, $4DE7A.useState)(null);
    // If `allowAutoUpdate` is true, input updates call onUpdatedValue handler
    // after a debounced amount of time. This can cause unexpected and buggy
    // behavior right now because it seems that updating the value can reset the
    // `isEditing` state internally, which makes it really hard for the user to
    // use the text input element. TODO: look into what causes this!
    const debounceUpdateValue = (0, $952fa6927178102c$export$2e2bcd8739ae039)(onUpdatedValue, $6cb7998e651a42e4$var$EDIT_INPUT_DELAY);
    // Depending on what happens, set the display value of the <input> element.
    (0, $4DE7A.useEffect)(()=>{
        // If component is disabled, display nothing
        if (disabled) {
            setDisplayValue("");
            return;
        }
        // If the `value` prop is `null` or undefined, display nothing
        if (value === null || typeof value === "undefined") {
            setDisplayValue("");
            return;
        }
        // If input is being edited (or hovered, which displays its "raw" value),
        // display the value without units. The `inputValueFormatter` function is
        // run, which takes into account the user's preferred units.
        if (isEditing || isHovered) {
            if (userInputValue !== null) // If there is user input, always display that.
            setDisplayValue(userInputValue);
            else // Otherwise, display the value from props
            setDisplayValue(inputValueFormatter(value));
            return;
        }
        // In all other cases, display the "prettified" value inside the input,
        // which is the "raw" value formatted using the correct unit conversion
        // and unit label.
        setDisplayValue(displayValueFormatter(value));
    }, [
        value,
        userInputValue,
        disabled,
        isEditing,
        isHovered,
        inputValueFormatter,
        displayValueFormatter
    ]);
    /**
   * If UI is going to enter user-editing mode, immediately
   * save the previous value in case editing is cancelled
   */ (0, $4DE7A.useEffect)(()=>{
        if (isEditing === true) oldValue.current = value;
        else // reset dirty `userInputValue`
        setUserInputValue(null);
    // We only want to save the old value once, not every time it changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEditing
    ]);
    function handleClickIncrement(event) {
        setIsEditing(false);
        onClickUp(event);
    }
    function handleClickDecrement(event) {
        setIsEditing(false);
        onClickDown(event);
    }
    function handleInputClick(event) {
        // Bail if already in editing mode.
        if (isEditing) return;
        setIsEditing(true);
    }
    /**
   * Somehow, the double-click to select all text is broken, so this
   * manually puts it back
   */ function handleInputDoubleClick(event) {
        event.target.select();
    }
    function handleInputChange(event) {
        const value = event.target.value;
        // Update the input element to display user input
        setUserInputValue(value);
        // Send the value to the parent's handler function
        // using the debounced version of `onUpdatedValue`
        if (allowAutoUpdate) debounceUpdateValue(value);
    }
    function handleInputBlur(event) {
        setIsHovered(false);
        setIsEditing(false);
        if (!allowAutoUpdate) onUpdatedValue(event.target.value);
    }
    /**
   * Necessary to prevent blur event from being called on a mousedown(?)
   * The observed effect is that if a user is editing/focused on the input,
   * and they click on it again, the blur event handler is called and the
   * input value momentarily changes to the unblurred (prettified) value.
   * Not sure what causes this, but this handler fixes that issue.
   */ function handleInputMouseDown(event) {
        // Bail if already in editing mode.
        if (isEditing) return;
        setIsEditing(true);
    }
    /**
   * On mouse over, UI assumes user is ready to edit.
   */ function handleInputMouseOver(event) {
        // Bail if already in editing mode.
        if (isEditing) return;
        setIsHovered(true);
        // Automatically select the value on hover so that it's easy to start
        // typing new values. In React, this only works if the .select() is called
        // at the end of the execution stack, so we put it inside a setTimeout()
        // with a timeout of zero. We also must store the reference to the event
        // target because the React synthetic event will not persist into the
        // `setTimeout` function.
        const target = event.target;
        window.setTimeout(()=>{
            target.focus();
            target.select();
        }, 0);
    }
    /**
   * On mouse out, if user is not editing, UI returns to default view.
   */ function handleInputMouseOut(event) {
        // Bail if already in editing mode.
        if (isEditing) return;
        // On mouse out, we want to blur but the onBlur handler is not
        // called in a test environment. Just in case, we also reset the
        // the isHovered and isEditing state here.
        setIsHovered(false);
        setIsEditing(false);
        event.target.blur();
        if (!allowAutoUpdate) onUpdatedValue(event.target.value);
    }
    function handleInputKeyDown(event) {
        switch(event.key){
            case "Enter":
                onUpdatedValue(event.target.value);
                setIsEditing(false);
                inputEl.current.focus();
                inputEl.current.select();
                break;
            case "Esc":
            case "Escape":
                // Lose focus from input but place focus on body
                inputEl.current.blur();
                document.body.focus();
                // Reset editing or hover state
                setIsEditing(false);
                setIsHovered(false);
                onUpdatedValue(oldValue.current);
                break;
        }
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "up-down-input",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                className: "up-down-input-decrement",
                title: downTooltip,
                tabIndex: -1,
                onClick: handleClickDecrement,
                disabled: disabled || (minValue ? value <= minValue : false),
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                    icon: (0, $5cbf5c54789c9bf6$export$c3a286456a7fc447)
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("input", {
                type: "text",
                className: "up-down-input-element",
                title: inputTooltip,
                disabled: disabled,
                value: displayValue,
                onChange: handleInputChange,
                onClick: handleInputClick,
                onDoubleClick: handleInputDoubleClick,
                onBlur: handleInputBlur,
                onMouseDown: handleInputMouseDown,
                onMouseOver: handleInputMouseOver,
                onMouseOut: handleInputMouseOut,
                onKeyDown: handleInputKeyDown,
                ref: inputEl
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                className: "up-down-input-increment",
                title: upTooltip,
                tabIndex: -1,
                onClick: handleClickIncrement,
                disabled: disabled || (maxValue ? value >= maxValue : false),
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                    icon: (0, $5cbf5c54789c9bf6$export$ac0a08e828b286ea)
                })
            })
        ]
    });
}
var $6cb7998e651a42e4$export$2e2bcd8739ae039 = $6cb7998e651a42e4$var$UpDownInput;


$4cf2f03bb8c2a808$var$WidthControl.propTypes = {
    position: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
};
function $4cf2f03bb8c2a808$var$WidthControl({ position: position }) {
    const value = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street.segments[position] && state.street.segments[position].width || null);
    const units = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street.units);
    const locale = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.locale.locale);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const handleIncrement = (event)=>{
        const precise = event.shiftKey;
        dispatch((0, $8041aaeb3f701cec$export$834095b984dd9c8d)(position, true, precise, value));
    };
    const handleDecrement = (event)=>{
        const precise = event.shiftKey;
        dispatch((0, $8041aaeb3f701cec$export$834095b984dd9c8d)(position, false, precise, value));
    };
    /**
   * When given a new value from input, process it, then update the model.
   * Right now the data exists in two places: in Redux, and in the DOM.
   * Eventually we want to transition to fully Redux but while other parts
   * of the application still depends on DOM we must update both places at
   * the same time.
   *
   * If the input must be debounced, used the debounced function instead.
   *
   * @param {string} value - raw input
   */ const updateModel = (value)=>{
        const processedValue = (0, $83fecf775ebd2a37$export$53a59fd02fe9885d)(value, units);
        if (processedValue) (0, $edbb716917ec500c$export$825f60ee61d83e5f)(position, (0, $edbb716917ec500c$export$56609dbdc016f0b0), processedValue, units);
    };
    /**
   * Given a raw numerical value, format it and return a decorated string for when
   * the input is being edited.
   *
   * @param {Number} value - raw value
   * @returns {string} - a decorated value
   */ const inputValueFormatter = (value)=>{
        return (0, $83fecf775ebd2a37$export$a05e78ee40994883)(value, units, locale);
    };
    /**
   * Given a raw numerical value, format it and return a decorated string for display
   * when the input is not being edited.
   *
   * @param {Number} value - raw value
   * @returns {string} - a decorated value
   */ const displayValueFormatter = (value)=>{
        return (0, $83fecf775ebd2a37$export$f87bc2ba75a381c)(value, units);
    };
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "non-variant",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6cb7998e651a42e4$export$2e2bcd8739ae039), {
            value: value,
            minValue: (0, $e1cc3cddc7acf1a4$export$256c1c4ce479d4eb),
            maxValue: (0, $e1cc3cddc7acf1a4$export$2b083f3fca24a6b6),
            inputValueFormatter: inputValueFormatter,
            displayValueFormatter: displayValueFormatter,
            onClickUp: handleIncrement,
            onClickDown: handleDecrement,
            onUpdatedValue: updateModel,
            inputTooltip: intl.formatMessage({
                id: "tooltip.segment-width",
                defaultMessage: "Change width of the segment"
            }),
            upTooltip: intl.formatMessage({
                id: "tooltip.increase-width",
                defaultMessage: "Increase width (hold Shift for more precision)"
            }),
            downTooltip: intl.formatMessage({
                id: "tooltip.decrease-width",
                defaultMessage: "Decrease width (hold Shift for more precision)"
            })
        })
    });
}
var $4cf2f03bb8c2a808$export$2e2bcd8739ae039 = $4cf2f03bb8c2a808$var$WidthControl;



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");







$0b2bba8022ff749d$var$BuildingHeightControl.propTypes = {
    position: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
        (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd),
        (0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492)
    ])
};
function $0b2bba8022ff749d$var$BuildingHeightControl({ position: position }) {
    const units = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street.units);
    // Get the appropriate building data based on which side of street it's on
    const variant = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>position === (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd) ? state.street.leftBuildingVariant : position === (0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492) ? state.street.rightBuildingVariant : null);
    const value = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>position === (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd) ? state.street.leftBuildingHeight : position === (0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492) ? state.street.rightBuildingHeight : null);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const handleIncrement = ()=>{
        dispatch((0, $8b007b7ac0907036$export$2ddfb6d386c1281f)(position));
    };
    const handleDecrement = ()=>{
        dispatch((0, $8b007b7ac0907036$export$3774ee57e8d91092)(position));
    };
    /**
   * When given a new value from input, process it, then update the model.
   *
   * If the input must be debounced, used the debounced function instead.
   *
   * @param {string} value - raw input
   */ const updateModel = (value)=>{
        if (value) dispatch((0, $8b007b7ac0907036$export$149c168440d6be8)(position, value));
    };
    /**
   * Given a raw numerical value, format it and return a decorated string.
   *
   * @param {Number} value - raw value
   * @returns {string} - a decorated value
   */ const displayValueFormatter = (value)=>{
        return (0, $2690ac3abe906938$export$d0cdab6355f6b245)(variant, position, value, units, intl.formatMessage);
    };
    const isNotFloored = !(0, $2690ac3abe906938$export$68f9303c71cd9a6d)[variant].hasFloors;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "non-variant building-height",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6cb7998e651a42e4$export$2e2bcd8739ae039), {
            disabled: isNotFloored,
            value: isNotFloored ? null : value,
            minValue: 1,
            maxValue: (0, $e1cc3cddc7acf1a4$export$9b73353ccd49a9a9),
            displayValueFormatter: displayValueFormatter,
            onClickUp: handleIncrement,
            onClickDown: handleDecrement,
            onUpdatedValue: updateModel,
            inputTooltip: intl.formatMessage({
                id: "tooltip.building-height",
                defaultMessage: "Change the number of floors"
            }),
            upTooltip: intl.formatMessage({
                id: "tooltip.add-floor",
                defaultMessage: "Add floor"
            }),
            downTooltip: intl.formatMessage({
                id: "tooltip.remove-floor",
                defaultMessage: "Remove floor"
            }),
            allowAutoUpdate: true
        })
    });
}
var $0b2bba8022ff749d$export$2e2bcd8739ae039 = $0b2bba8022ff749d$var$BuildingHeightControl;



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");


var $b2b0edefeadf1398$exports = {};

$b2b0edefeadf1398$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "warning_alert.4eede6c8.svg";


var $5dd307bb8d3233ea$exports = {};

$5dd307bb8d3233ea$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "warning_error.77ec3a4f.svg";


const $31e9b3a2ad7b2fcb$var$Warnings = (props)=>{
    const { segment: segment } = props;
    const messages = [];
    if (!segment || !segment.warnings) return null;
    if (segment.warnings[0, $e1cc3cddc7acf1a4$export$fccc01258576ea7b]) messages.push({
        type: "alert",
        message: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "segments.warnings.dangerous",
            defaultMessage: "This segment represents a dangerous existing condition."
        })
    });
    if (segment.warnings[0, $e1cc3cddc7acf1a4$export$bd07f8babb22a89f]) messages.push({
        type: "error",
        message: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "segments.warnings.does-not-fit",
            defaultMessage: "This segment doesn\u2019t fit within the street."
        })
    });
    if (segment.warnings[0, $e1cc3cddc7acf1a4$export$1603ba7a45cd1a72]) messages.push({
        type: "error",
        message: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "segments.warnings.not-wide",
            defaultMessage: "This segment might not be wide enough."
        })
    });
    if (segment.warnings[0, $e1cc3cddc7acf1a4$export$529213ff1df6a1b5]) messages.push({
        type: "error",
        message: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "segments.warnings.too-wide",
            defaultMessage: "This segment might be too wide."
        })
    });
    if (messages.length > 0) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "info-bubble-warnings",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("ul", {
            children: messages.map((item)=>{
                let icon;
                switch(item.type){
                    case "alert":
                        icon = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b2b0edefeadf1398$exports))),
                            alt: ""
                        });
                        break;
                    case "error":
                    default:
                        icon = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5dd307bb8d3233ea$exports))),
                            alt: ""
                        });
                        break;
                }
                return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                    className: `info-bubble-warning-${item.type}`,
                    children: [
                        icon,
                        " ",
                        item.message
                    ]
                }, item.message.props.id);
            })
        })
    });
    return null;
};
$31e9b3a2ad7b2fcb$var$Warnings.propTypes = {
    segment: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        warnings: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool)
    })
};
var $31e9b3a2ad7b2fcb$export$2e2bcd8739ae039 = $31e9b3a2ad7b2fcb$var$Warnings;



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");








var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");


// Register `Raw` in tree:
/// <reference types="mdast-util-to-hast" />
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Nodes} Nodes
 * @typedef {import('hast').Parents} Parents
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-to-jsx-runtime').Components} JsxRuntimeComponents
 * @typedef {import('remark-rehype').Options} RemarkRehypeOptions
 * @typedef {import('unist-util-visit').BuildVisitor<Root>} Visitor
 * @typedef {import('unified').PluggableList} PluggableList
 */ /**
 * @callback AllowElement
 *   Filter elements.
 * @param {Readonly<Element>} element
 *   Element to check.
 * @param {number} index
 *   Index of `element` in `parent`.
 * @param {Readonly<Parents> | undefined} parent
 *   Parent of `element`.
 * @returns {boolean | null | undefined}
 *   Whether to allow `element` (default: `false`).
 *
 * @typedef {Partial<JsxRuntimeComponents>} Components
 *   Map tag names to components.
 *
 * @typedef Deprecation
 *   Deprecation.
 * @property {string} from
 *   Old field.
 * @property {string} id
 *   ID in readme.
 * @property {keyof Options} [to]
 *   New field.
 *
 * @typedef Options
 *   Configuration.
 * @property {AllowElement | null | undefined} [allowElement]
 *   Filter elements (optional);
 *   `allowedElements` / `disallowedElements` is used first.
 * @property {ReadonlyArray<string> | null | undefined} [allowedElements]
 *   Tag names to allow (default: all tag names);
 *   cannot combine w/ `disallowedElements`.
 * @property {string | null | undefined} [children]
 *   Markdown.
 * @property {string | null | undefined} [className]
 *   Wrap in a `div` with this class name.
 * @property {Components | null | undefined} [components]
 *   Map tag names to components.
 * @property {ReadonlyArray<string> | null | undefined} [disallowedElements]
 *   Tag names to disallow (default: `[]`);
 *   cannot combine w/ `allowedElements`.
 * @property {PluggableList | null | undefined} [rehypePlugins]
 *   List of rehype plugins to use.
 * @property {PluggableList | null | undefined} [remarkPlugins]
 *   List of remark plugins to use.
 * @property {Readonly<RemarkRehypeOptions> | null | undefined} [remarkRehypeOptions]
 *   Options to pass through to `remark-rehype`.
 * @property {boolean | null | undefined} [skipHtml=false]
 *   Ignore HTML in markdown completely (default: `false`).
 * @property {boolean | null | undefined} [unwrapDisallowed=false]
 *   Extract (unwrap) what’s in disallowed elements (default: `false`);
 *   normally when say `strong` is not allowed, it and it’s children are dropped,
 *   with `unwrapDisallowed` the element itself is replaced by its children.
 * @property {UrlTransform | null | undefined} [urlTransform]
 *   Change URLs (default: `defaultUrlTransform`)
 *
 * @callback UrlTransform
 *   Transform all URLs.
 * @param {string} url
 *   URL.
 * @param {string} key
 *   Property name (example: `'href'`).
 * @param {Readonly<Element>} node
 *   Node.
 * @returns {string | null | undefined}
 *   Transformed URL (optional).
 */ function $5875a1670b965514$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $5875a1670b965514$export$411ce8e5a71e3069() {}
function $5875a1670b965514$export$dcb8b3f0e2de7e49() {}
function $5875a1670b965514$export$565e9d9bd6b6e0d4() {}


// Register MDX nodes in mdast:
/// <reference types="mdast-util-mdx-expression" />
/// <reference types="mdast-util-mdx-jsx" />
/// <reference types="mdast-util-mdxjs-esm" />
/**
 * @typedef {import('estree').Identifier} Identifier
 * @typedef {import('estree').Literal} Literal
 * @typedef {import('estree').MemberExpression} MemberExpression
 * @typedef {import('estree').Expression} Expression
 * @typedef {import('estree').Program} Program
 *
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Nodes} Nodes
 * @typedef {import('hast').Parents} Parents
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 *
 * @typedef {import('mdast-util-mdx-expression').MdxFlowExpressionHast} MdxFlowExpression
 * @typedef {import('mdast-util-mdx-expression').MdxTextExpressionHast} MdxTextExpression
 *
 * @typedef {import('mdast-util-mdx-jsx').MdxJsxFlowElementHast} MdxJsxFlowElement
 * @typedef {import('mdast-util-mdx-jsx').MdxJsxTextElementHast} MdxJsxTextElement
 *
 * @typedef {import('mdast-util-mdxjs-esm').MdxjsEsmHast} MdxjsEsm
 *
 * @typedef {import('property-information').Schema} Schema
 *
 * @typedef {import('unist').Position} Position
 *
 * @typedef {import('./components.js').Components} Components
 */ /**
 * @typedef {JSX.Element | string | null | undefined} Child
 *   Child.
 *
 * @callback Create
 *   Create something in development or production.
 * @param {Nodes} node
 *   hast node.
 * @param {unknown} type
 *   Fragment symbol or tag name.
 * @param {Props} props
 *   Properties and children.
 * @param {string | undefined} key
 *   Key.
 * @returns {JSX.Element}
 *   Result.
 *
 * @callback CreateEvaluater
 *   Create an evaluator that turns ESTree ASTs from embedded MDX into values.
 * @returns {Evaluater}
 *   Evaluater.
 *
 * @typedef {'html' | 'react'} ElementAttributeNameCase
 *   Casing to use for attribute names.
 *
 *   HTML casing is for example `class`, `stroke-linecap`, `xml:lang`.
 *   React casing is for example `className`, `strokeLinecap`, `xmlLang`.
 *
 * @callback EvaluateExpression
 *   Turn an MDX expression into a value.
 * @param {Expression} expression
 *   ESTree expression.
 * @returns {unknown}
 *   Result of expression.
 *
 * @callback EvaluateProgram
 *   Turn an MDX program (export/import statements) into a value.
 * @param {Program} expression
 *   ESTree program.
 * @returns {unknown}
 *   Result of program;
 *   should likely be `undefined` as ESM changes the scope but doesn’t yield
 *   something.
 *
 * @typedef Evaluater
 *   Evaluator that turns ESTree ASTs from embedded MDX into values.
 * @property {EvaluateExpression} evaluateExpression
 *   Evaluate an expression.
 * @property {EvaluateProgram} evaluateProgram
 *   Evaluate a program.
 *
 * @typedef {[string, Value]} Field
 *   Property field.
 *
 * @typedef {unknown} Fragment
 *   Represent the children, typically a symbol.
 *
 * @callback Jsx
 *   Create a production element.
 * @param {unknown} type
 *   Element type: `Fragment` symbol, tag name (`string`), component.
 * @param {Props} props
 *   Element props, `children`, and maybe `node`.
 * @param {string | undefined} [key]
 *   Dynamicly generated key to use.
 * @returns {JSX.Element}
 *   Element from your framework.
 *
 * @callback JsxDev
 *   Create a development element.
 * @param {unknown} type
 *   Element type: `Fragment` symbol, tag name (`string`), component.
 * @param {Props} props
 *   Element props, `children`, and maybe `node`.
 * @param {string | undefined} key
 *   Dynamicly generated key to use.
 * @param {boolean} isStaticChildren
 *   Whether two or more children are passed (in an array), which is whether
 *   `jsxs` or `jsx` would be used.
 * @param {Source} source
 *   Info about source.
 * @param {undefined} self
 *   Nothing (this is used by frameworks that have components, we don’t).
 * @returns {JSX.Element}
 *   Element from your framework.
 *
 * @typedef {{children?: Array<Child> | Child, node?: Element | MdxJsxFlowElement | MdxJsxTextElement | undefined, [prop: string]: Array<Child> | Child | Element | MdxJsxFlowElement | MdxJsxTextElement | Value | undefined}} Props
 *   Properties and children.
 *
 * @typedef RegularFields
 *   Configuration.
 * @property {Partial<Components> | null | undefined} [components]
 *   Components to use (optional).
 * @property {CreateEvaluater | null | undefined} [createEvaluater]
 *   Create an evaluator that turns ESTree ASTs into values (optional).
 * @property {ElementAttributeNameCase | null | undefined} [elementAttributeNameCase='react']
 *   Specify casing to use for attribute names (default: `'react'`).
 * @property {string | null | undefined} [filePath]
 *   File path to the original source file (optional).
 *
 *   Passed in source info to `jsxDEV` when using the automatic runtime with
 *   `development: true`.
 * @property {boolean | null | undefined} [ignoreInvalidStyle=false]
 *   Ignore invalid CSS in `style` props (default: `false`);
 *   the default behavior is to throw an error.
 * @property {boolean | null | undefined} [passKeys=true]
 *   Generate keys to optimize frameworks that support them (default: `true`).
 *
 *   > 👉 **Note**: Solid currently fails if keys are passed.
 * @property {boolean | null | undefined} [passNode=false]
 *   Pass the hast element node to components (default: `false`).
 * @property {Space | null | undefined} [space='html']
 *   Whether `tree` is in the `'html'` or `'svg'` space (default: `'html'`).
 *
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it.
 * @property {StylePropertyNameCase | null | undefined} [stylePropertyNameCase='dom']
 *   Specify casing to use for property names in `style` objects (default:
 *   `'dom'`).
 * @property {boolean | null | undefined} [tableCellAlignToStyle=true]
 *   Turn obsolete `align` props on `td` and `th` into CSS `style` props
 *   (default: `true`).
 *
 * @typedef RuntimeDevelopment
 *   Runtime fields when development is on.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {true} development
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off).
 * @property {Jsx | null | undefined} [jsx]
 *   Dynamic JSX (optional).
 * @property {JsxDev} jsxDEV
 *   Development JSX.
 * @property {Jsx | null | undefined} [jsxs]
 *   Static JSX (optional).
 *
 * @typedef RuntimeProduction
 *   Runtime fields when development is off.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {false | null | undefined} [development]
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off) (optional).
 * @property {Jsx} jsx
 *   Dynamic JSX.
 * @property {JsxDev | null | undefined} [jsxDEV]
 *   Development JSX (optional).
 * @property {Jsx} jsxs
 *   Static JSX.
 *
 * @typedef RuntimeUnknown
 *   Runtime fields when development might be on or off.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {boolean} development
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off).
 * @property {Jsx | null | undefined} [jsx]
 *   Dynamic JSX (optional).
 * @property {JsxDev | null | undefined} [jsxDEV]
 *   Development JSX (optional).
 * @property {Jsx | null | undefined} [jsxs]
 *   Static JSX (optional).
 *
 * @typedef Source
 *   Info about source.
 * @property {number | undefined} columnNumber
 *   Column where thing starts (0-indexed).
 * @property {string | undefined} fileName
 *   Name of source file.
 * @property {number | undefined} lineNumber
 *   Line where thing starts (1-indexed).
 *
 * @typedef {'html' | 'svg'} Space
 *   Namespace.
 *
 *   > 👉 **Note**: hast is not XML.
 *   > It supports SVG as embedded in HTML.
 *   > It does not support the features available in XML.
 *   > Passing SVG might break but fragments of modern SVG should be fine.
 *   > Use `xast` if you need to support SVG as XML.
 *
 * @typedef State
 *   Info passed around.
 * @property {unknown} Fragment
 *   Fragment symbol.
 * @property {Array<Parents>} ancestors
 *   Stack of parents.
 * @property {Partial<Components>} components
 *   Components to swap.
 * @property {Create} create
 *   Create something in development or production.
 * @property {ElementAttributeNameCase} elementAttributeNameCase
 *   Casing to use for attribute names.
 * @property {Evaluater | undefined} evaluater
 *   Evaluator that turns ESTree ASTs into values.
 * @property {string | undefined} filePath
 *   File path.
 * @property {boolean} ignoreInvalidStyle
 *   Ignore invalid CSS in `style` props.
 * @property {boolean} passKeys
 *   Generate keys to optimize frameworks that support them.
 * @property {boolean} passNode
 *   Pass `node` to components.
 * @property {Schema} schema
 *   Current schema.
 * @property {StylePropertyNameCase} stylePropertyNameCase
 *   Casing to use for property names in `style` objects.
 * @property {boolean} tableCellAlignToStyle
 *   Turn obsolete `align` props on `td` and `th` into CSS `style` props.
 *
 * @typedef {Record<string, string>} Style
 *   Style map.
 *
 * @typedef {'css' | 'dom'} StylePropertyNameCase
 *   Casing to use for property names in `style` objects.
 *
 *   CSS casing is for example `background-color` and `-webkit-line-clamp`.
 *   DOM casing is for example `backgroundColor` and `WebkitLineClamp`.
 *
 * @typedef {Style | boolean | number | string} Value
 *   Primitive property value and `Style` map.
 */ /**
 * @typedef {RuntimeDevelopment & RegularFields} Development
 *   Configuration (development).
 * @typedef {Development | Production | Unknown} Options
 *   Configuration.
 * @typedef {RegularFields & RuntimeProduction} Production
 *   Configuration (production).
 * @typedef {RegularFields & RuntimeUnknown} Unknown
 *   Configuration (production or development).
 */ /**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $9b3a19d2a847e4ea$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || "");
    let index = input.indexOf(",");
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(",", start);
    }
    return tokens;
}
function $9b3a19d2a847e4ea$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === "" ? [
        ...values,
        ""
    ] : values;
    return input.join((settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")).trim();
}



/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [jsx=false]
 *   Support JSX identifiers (default: `false`).
 */ const $4db71400c71eb638$var$startRe = /[$_\p{ID_Start}]/u;
const $4db71400c71eb638$var$contRe = /[$_\u{200C}\u{200D}\p{ID_Continue}]/u;
const $4db71400c71eb638$var$contReJsx = /[-$_\u{200C}\u{200D}\p{ID_Continue}]/u;
const $4db71400c71eb638$var$nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
const $4db71400c71eb638$var$nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
/** @type {Options} */ const $4db71400c71eb638$var$emptyOptions = {};
function $4db71400c71eb638$export$b3571188c770cc5a(code) {
    return code ? $4db71400c71eb638$var$startRe.test(String.fromCodePoint(code)) : false;
}
function $4db71400c71eb638$export$10eb6dc47bf009dc(code, options) {
    const settings = options || $4db71400c71eb638$var$emptyOptions;
    const re = settings.jsx ? $4db71400c71eb638$var$contReJsx : $4db71400c71eb638$var$contRe;
    return code ? re.test(String.fromCodePoint(code)) : false;
}
function $4db71400c71eb638$export$a8ff84c12d48cfa6(name, options) {
    const settings = options || $4db71400c71eb638$var$emptyOptions;
    const re = settings.jsx ? $4db71400c71eb638$var$nameReJsx : $4db71400c71eb638$var$nameRe;
    return re.test(name);
}


/**
 * @typedef {import('hast').Nodes} Nodes
 */ // HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $d1fe4e3f8d991a92$var$re = /[ \t\n\f\r]/g;
function $d1fe4e3f8d991a92$export$7af1228ff777d175(thing) {
    return typeof thing === "object" ? thing.type === "text" ? $d1fe4e3f8d991a92$var$empty(thing.value) : false : $d1fe4e3f8d991a92$var$empty(thing);
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $d1fe4e3f8d991a92$var$empty(value) {
    return value.replace($d1fe4e3f8d991a92$var$re, "") === "";
}


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $bb7719558ef6c3ed$export$a3295358bff77e(value) {
    return value.toLowerCase();
}


class $d936ed1a6c034529$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $d936ed1a6c034529$export$c4868e4a24d48fad.prototype.space = null;
$d936ed1a6c034529$export$c4868e4a24d48fad.prototype.boolean = false;
$d936ed1a6c034529$export$c4868e4a24d48fad.prototype.booleanish = false;
$d936ed1a6c034529$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$d936ed1a6c034529$export$c4868e4a24d48fad.prototype.number = false;
$d936ed1a6c034529$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$d936ed1a6c034529$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$d936ed1a6c034529$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$d936ed1a6c034529$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$d936ed1a6c034529$export$c4868e4a24d48fad.prototype.defined = false;


var $e0703a20d1ffbd8c$exports = {};

$parcel$export($e0703a20d1ffbd8c$exports, "boolean", function () { return $e0703a20d1ffbd8c$export$4a21f16c33752377; });
$parcel$export($e0703a20d1ffbd8c$exports, "booleanish", function () { return $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f; });
$parcel$export($e0703a20d1ffbd8c$exports, "overloadedBoolean", function () { return $e0703a20d1ffbd8c$export$242ac3d3042558aa; });
$parcel$export($e0703a20d1ffbd8c$exports, "number", function () { return $e0703a20d1ffbd8c$export$98e628dec113755e; });
$parcel$export($e0703a20d1ffbd8c$exports, "spaceSeparated", function () { return $e0703a20d1ffbd8c$export$ab8645c862eb5a3e; });
$parcel$export($e0703a20d1ffbd8c$exports, "commaSeparated", function () { return $e0703a20d1ffbd8c$export$9c8d678629b3d3; });
$parcel$export($e0703a20d1ffbd8c$exports, "commaOrSpaceSeparated", function () { return $e0703a20d1ffbd8c$export$2ad25cfebf36cacd; });
let $e0703a20d1ffbd8c$var$powers = 0;
const $e0703a20d1ffbd8c$export$4a21f16c33752377 = $e0703a20d1ffbd8c$var$increment();
const $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f = $e0703a20d1ffbd8c$var$increment();
const $e0703a20d1ffbd8c$export$242ac3d3042558aa = $e0703a20d1ffbd8c$var$increment();
const $e0703a20d1ffbd8c$export$98e628dec113755e = $e0703a20d1ffbd8c$var$increment();
const $e0703a20d1ffbd8c$export$ab8645c862eb5a3e = $e0703a20d1ffbd8c$var$increment();
const $e0703a20d1ffbd8c$export$9c8d678629b3d3 = $e0703a20d1ffbd8c$var$increment();
const $e0703a20d1ffbd8c$export$2ad25cfebf36cacd = $e0703a20d1ffbd8c$var$increment();
function $e0703a20d1ffbd8c$var$increment() {
    return 2 ** ++$e0703a20d1ffbd8c$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $7c305981474dbb8e$var$checks = Object.keys($e0703a20d1ffbd8c$exports);
class $7c305981474dbb8e$export$ea6b9f0064e88c9b extends (0, $d936ed1a6c034529$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $7c305981474dbb8e$var$mark(this, "space", space);
        if (typeof mask === "number") while(++index < $7c305981474dbb8e$var$checks.length){
            const check = $7c305981474dbb8e$var$checks[index];
            $7c305981474dbb8e$var$mark(this, $7c305981474dbb8e$var$checks[index], (mask & $e0703a20d1ffbd8c$exports[check]) === $e0703a20d1ffbd8c$exports[check]);
        }
    }
}
$7c305981474dbb8e$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $7c305981474dbb8e$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}



const $3e1e4cbbdf2d0d54$var$valid = /^data[-\w.:]+$/i;
const $3e1e4cbbdf2d0d54$var$dash = /-[a-z]/g;
const $3e1e4cbbdf2d0d54$var$cap = /[A-Z]/g;
function $3e1e4cbbdf2d0d54$export$71aa6c912b956294(schema, value) {
    const normal = (0, $bb7719558ef6c3ed$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $d936ed1a6c034529$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === "data" && $3e1e4cbbdf2d0d54$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") {
            // Turn it into a property.
            const rest = value.slice(5).replace($3e1e4cbbdf2d0d54$var$dash, $3e1e4cbbdf2d0d54$var$camelcase);
            prop = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$3e1e4cbbdf2d0d54$var$dash.test(rest)) {
                let dashes = rest.replace($3e1e4cbbdf2d0d54$var$cap, $3e1e4cbbdf2d0d54$var$kebab);
                if (dashes.charAt(0) !== "-") dashes = "-" + dashes;
                value = "data" + dashes;
            }
        }
        Type = (0, $7c305981474dbb8e$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $3e1e4cbbdf2d0d54$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $3e1e4cbbdf2d0d54$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $8a9529b9b91a5d6a$export$d8abd7e5fb6871f9 = {
    classId: "classID",
    dataType: "datatype",
    itemId: "itemID",
    strokeDashArray: "strokeDasharray",
    strokeDashOffset: "strokeDashoffset",
    strokeLineCap: "strokeLinecap",
    strokeLineJoin: "strokeLinejoin",
    strokeMiterLimit: "strokeMiterlimit",
    typeOf: "typeof",
    xLinkActuate: "xlinkActuate",
    xLinkArcRole: "xlinkArcrole",
    xLinkHref: "xlinkHref",
    xLinkRole: "xlinkRole",
    xLinkShow: "xlinkShow",
    xLinkTitle: "xlinkTitle",
    xLinkType: "xlinkType",
    xmlnsXLink: "xmlnsXlink"
};

/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $70f40d6a9ab432ea$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $70f40d6a9ab432ea$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $70f40d6a9ab432ea$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $70f40d6a9ab432ea$export$19342e026b58ebb7.prototype.space = null;


function $802e505598891f73$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $70f40d6a9ab432ea$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ 


const $5f77f18afddbbcb5$var$own = {}.hasOwnProperty;
function $5f77f18afddbbcb5$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($5f77f18afddbbcb5$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $7c305981474dbb8e$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $bb7719558ef6c3ed$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $bb7719558ef6c3ed$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $70f40d6a9ab432ea$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $2d6c074786ecc4d6$export$2bd1230ec7600845 = (0, $5f77f18afddbbcb5$export$185802fd694ee1f5)({
    space: "xlink",
    transform (_, prop) {
        return "xlink:" + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $26a06749c2180c5a$export$f2913fe8983302e = (0, $5f77f18afddbbcb5$export$185802fd694ee1f5)({
    space: "xml",
    transform (_, prop) {
        return "xml:" + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $66b0aca412b3d004$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $307494e9388f4dbc$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $66b0aca412b3d004$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $be1a124f54d7687d$export$e20c24a128671213 = (0, $5f77f18afddbbcb5$export$185802fd694ee1f5)({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: (0, $307494e9388f4dbc$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $4205156d9af4e0e7$export$4d2d26490572750a = (0, $5f77f18afddbbcb5$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        ariaColIndex: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        ariaColSpan: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        ariaControls: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        ariaLevel: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        ariaPressed: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        ariaRowIndex: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        ariaRowSpan: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        ariaSelected: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        ariaValueMin: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        ariaValueNow: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $457cba691d143dfb$export$c0bb0b647f701bb5 = (0, $5f77f18afddbbcb5$export$185802fd694ee1f5)({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: (0, $307494e9388f4dbc$export$32b9e4cec9c208e1),
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $e0703a20d1ffbd8c$export$9c8d678629b3d3),
        acceptCharset: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        accessKey: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        allowPaymentRequest: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        allowUserMedia: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        autoFocus: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        autoPlay: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        blocking: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        capture: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        charSet: null,
        checked: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        cite: null,
        className: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        cols: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        controls: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        controlsList: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        coords: (0, $e0703a20d1ffbd8c$export$98e628dec113755e) | (0, $e0703a20d1ffbd8c$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        defer: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        download: (0, $e0703a20d1ffbd8c$export$242ac3d3042558aa),
        draggable: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        height: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        hidden: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        high: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        httpEquiv: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        itemRef: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        itemScope: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        itemType: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        low: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        multiple: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        muted: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        noValidate: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        optimum: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        pattern: null,
        ping: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        required: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        reversed: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        rows: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        rowSpan: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        sandbox: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        seamless: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        selected: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        shadowRootMode: null,
        shape: null,
        size: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        spellCheck: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        useMap: null,
        value: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        width: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        declare: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        leftMargin: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        marginWidth: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        noResize: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        noHref: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        noShade: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        noWrap: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $e0703a20d1ffbd8c$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        disableRemotePlayback: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $0598cd96ce2881ed$export$7ed1367e7fa1ad68 = (0, $5f77f18afddbbcb5$export$185802fd694ee1f5)({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        transformOrigin: "transform-origin",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: (0, $66b0aca412b3d004$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $e0703a20d1ffbd8c$export$2ad25cfebf36cacd),
        accentHeight: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        amplitude: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        className: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        diffuseConstant: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $e0703a20d1ffbd8c$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $e0703a20d1ffbd8c$export$9c8d678629b3d3),
        g2: (0, $e0703a20d1ffbd8c$export$9c8d678629b3d3),
        glyphName: (0, $e0703a20d1ffbd8c$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        horizOriginX: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        horizOriginY: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        id: null,
        ideographic: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        k: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        k1: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        k2: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        k3: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        k4: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        kernelMatrix: (0, $e0703a20d1ffbd8c$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        overlineThickness: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $e0703a20d1ffbd8c$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        pointsAtY: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        pointsAtZ: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $e0703a20d1ffbd8c$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $e0703a20d1ffbd8c$export$2ad25cfebf36cacd),
        rev: (0, $e0703a20d1ffbd8c$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $e0703a20d1ffbd8c$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $e0703a20d1ffbd8c$export$2ad25cfebf36cacd),
        requiredFonts: (0, $e0703a20d1ffbd8c$export$2ad25cfebf36cacd),
        requiredFormats: (0, $e0703a20d1ffbd8c$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        specularExponent: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        strikethroughThickness: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $e0703a20d1ffbd8c$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        strokeOpacity: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $e0703a20d1ffbd8c$export$2ad25cfebf36cacd),
        tabIndex: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        targetY: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $e0703a20d1ffbd8c$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        underlineThickness: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        vMathematical: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        vIdeographic: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        vertOriginX: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        vertOriginY: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $e0703a20d1ffbd8c$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});





const $5ded0a034e3dc5e9$export$c0bb0b647f701bb5 = (0, $802e505598891f73$export$4950aa0f605343fb)([
    (0, $26a06749c2180c5a$export$f2913fe8983302e),
    (0, $2d6c074786ecc4d6$export$2bd1230ec7600845),
    (0, $be1a124f54d7687d$export$e20c24a128671213),
    (0, $4205156d9af4e0e7$export$4d2d26490572750a),
    (0, $457cba691d143dfb$export$c0bb0b647f701bb5)
], "html");
const $5ded0a034e3dc5e9$export$7ed1367e7fa1ad68 = (0, $802e505598891f73$export$4950aa0f605343fb)([
    (0, $26a06749c2180c5a$export$f2913fe8983302e),
    (0, $2d6c074786ecc4d6$export$2bd1230ec7600845),
    (0, $be1a124f54d7687d$export$e20c24a128671213),
    (0, $4205156d9af4e0e7$export$4d2d26490572750a),
    (0, $0598cd96ce2881ed$export$7ed1367e7fa1ad68)
], "svg");


/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $fab9e1f1a10b7278$export$98e6a39c04603d36(value) {
    const input = String(value || "").trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $fab9e1f1a10b7278$export$fac44ee5b035f737(values) {
    return values.join(" ").trim();
}


var $cfc43389dda3d956$exports = {};
"use strict";
var $cfc43389dda3d956$var$__importDefault = $cfc43389dda3d956$exports && $cfc43389dda3d956$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($cfc43389dda3d956$exports, "__esModule", {
    value: true
});

var $cfc43389dda3d956$var$inline_style_parser_1 = $cfc43389dda3d956$var$__importDefault((parcelRequire("aOZ8D")));
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */ function $cfc43389dda3d956$var$StyleToObject(style, iterator) {
    var styleObject = null;
    if (!style || typeof style !== "string") return styleObject;
    var declarations = (0, $cfc43389dda3d956$var$inline_style_parser_1.default)(style);
    var hasIterator = typeof iterator === "function";
    declarations.forEach(function(declaration) {
        if (declaration.type !== "declaration") return;
        var property = declaration.property, value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}
$cfc43389dda3d956$exports.default = $cfc43389dda3d956$var$StyleToObject;


var // ensure compatibility with rollup umd build
$83c4722eac8666ea$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($cfc43389dda3d956$exports))).default || (0, (/*@__PURE__*/$parcel$interopDefault($cfc43389dda3d956$exports)));


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $01cb538eb16fcb3b$export$da309cdce9dc2a25 = $01cb538eb16fcb3b$var$point("end");
const $01cb538eb16fcb3b$export$771bf3e4949bfbee = $01cb538eb16fcb3b$var$point("start");
/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $01cb538eb16fcb3b$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        if (typeof point.line === "number" && point.line > 0 && typeof point.column === "number" && point.column > 0) return {
            line: point.line,
            column: point.column,
            offset: typeof point.offset === "number" && point.offset > -1 ? point.offset : undefined
        };
    }
}
function $01cb538eb16fcb3b$export$5880b8b5730aff45(node) {
    const start = $01cb538eb16fcb3b$export$771bf3e4949bfbee(node);
    const end = $01cb538eb16fcb3b$export$da309cdce9dc2a25(node);
    if (start && end) return {
        start: start,
        end: end
    };
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<Node> | null | undefined} [ancestors]
 *   Stack of (inclusive) ancestor nodes surrounding the message (optional).
 * @property {Error | null | undefined} [cause]
 *   Original error cause of the message (optional).
 * @property {Point | Position | null | undefined} [place]
 *   Place of message (optional).
 * @property {string | null | undefined} [ruleId]
 *   Category of message (optional, example: `'my-rule'`).
 * @property {string | null | undefined} [source]
 *   Namespace of who sent the message (optional, example: `'my-package'`).
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $021a6f7cf488cf5d$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ("position" in value || "type" in value) return $021a6f7cf488cf5d$var$position(value.position);
    // Position.
    if ("start" in value || "end" in value) return $021a6f7cf488cf5d$var$position(value);
    // Point.
    if ("line" in value || "column" in value) return $021a6f7cf488cf5d$var$point(value);
    // ?
    return "";
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $021a6f7cf488cf5d$var$point(point) {
    return $021a6f7cf488cf5d$var$index(point && point.line) + ":" + $021a6f7cf488cf5d$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $021a6f7cf488cf5d$var$position(pos) {
    return $021a6f7cf488cf5d$var$point(pos && pos.start) + "-" + $021a6f7cf488cf5d$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $021a6f7cf488cf5d$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}


class $480e2cf54697d41d$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // eslint-disable-next-line complexity
    constructor(causeOrReason, optionsOrParentOrPlace, origin){
        super();
        if (typeof optionsOrParentOrPlace === "string") {
            origin = optionsOrParentOrPlace;
            optionsOrParentOrPlace = undefined;
        }
        /** @type {string} */ let reason = "";
        /** @type {Options} */ let options = {};
        let legacyCause = false;
        if (optionsOrParentOrPlace) {
            // Point.
            if ("line" in optionsOrParentOrPlace && "column" in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ("start" in optionsOrParentOrPlace && "end" in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ("type" in optionsOrParentOrPlace) options = {
                ancestors: [
                    optionsOrParentOrPlace
                ],
                place: optionsOrParentOrPlace.position
            };
            else options = {
                ...optionsOrParentOrPlace
            };
        }
        if (typeof causeOrReason === "string") reason = causeOrReason;
        else if (!options.cause && causeOrReason) {
            legacyCause = true;
            reason = causeOrReason.message;
            options.cause = causeOrReason;
        }
        if (!options.ruleId && !options.source && typeof origin === "string") {
            const index = origin.indexOf(":");
            if (index === -1) options.ruleId = origin;
            else {
                options.source = origin.slice(0, index);
                options.ruleId = origin.slice(index + 1);
            }
        }
        if (!options.place && options.ancestors && options.ancestors) {
            const parent = options.ancestors[options.ancestors.length - 1];
            if (parent) options.place = parent.position;
        }
        const start = options.place && "start" in options.place ? options.place.start : options.place;
        /* eslint-disable no-unused-expressions */ /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */ this.ancestors = options.ancestors || undefined;
        /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */ this.cause = options.cause || undefined;
        /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */ this.column = start ? start.column : undefined;
        /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */ this.fatal = undefined;
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */ this.file;
        // Field from `Error`.
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = reason;
        /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */ this.line = start ? start.line : undefined;
        // Field from `Error`.
        /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $021a6f7cf488cf5d$export$c304dd45fe166145)(options.place) || "1:1";
        /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */ this.place = options.place || undefined;
        /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */ this.ruleId = options.ruleId || undefined;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */ this.source = options.source || undefined;
        // Field from `Error`.
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = legacyCause && options.cause && typeof options.cause.stack === "string" ? options.cause.stack : "";
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */ this.expected;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */ this.note;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */ this.url;
    /* eslint-enable no-unused-expressions */ }
}
$480e2cf54697d41d$export$752e5c445fe834ef.prototype.file = "";
$480e2cf54697d41d$export$752e5c445fe834ef.prototype.name = "";
$480e2cf54697d41d$export$752e5c445fe834ef.prototype.reason = "";
$480e2cf54697d41d$export$752e5c445fe834ef.prototype.message = "";
$480e2cf54697d41d$export$752e5c445fe834ef.prototype.stack = "";
$480e2cf54697d41d$export$752e5c445fe834ef.prototype.column = undefined;
$480e2cf54697d41d$export$752e5c445fe834ef.prototype.line = undefined;
$480e2cf54697d41d$export$752e5c445fe834ef.prototype.ancestors = undefined;
$480e2cf54697d41d$export$752e5c445fe834ef.prototype.cause = undefined;
$480e2cf54697d41d$export$752e5c445fe834ef.prototype.fatal = undefined;
$480e2cf54697d41d$export$752e5c445fe834ef.prototype.place = undefined;
$480e2cf54697d41d$export$752e5c445fe834ef.prototype.ruleId = undefined;
$480e2cf54697d41d$export$752e5c445fe834ef.prototype.source = undefined;


const $fe1d66ce7da7f6a7$var$own = {}.hasOwnProperty;
/** @type {Map<string, number>} */ const $fe1d66ce7da7f6a7$var$emptyMap = new Map();
const $fe1d66ce7da7f6a7$var$cap = /[A-Z]/g;
const $fe1d66ce7da7f6a7$var$dashSomething = /-([a-z])/g;
// `react-dom` triggers a warning for *any* white space in tables.
// To follow GFM, `mdast-util-to-hast` injects line endings between elements.
// Other tools might do so too, but they don’t do here, so we remove all of
// that.
// See: <https://github.com/facebook/react/pull/7081>.
// See: <https://github.com/facebook/react/pull/7515>.
// See: <https://github.com/remarkjs/remark-react/issues/64>.
// See: <https://github.com/rehypejs/rehype-react/pull/29>.
// See: <https://github.com/rehypejs/rehype-react/pull/32>.
// See: <https://github.com/rehypejs/rehype-react/pull/45>.
const $fe1d66ce7da7f6a7$var$tableElements = new Set([
    "table",
    "tbody",
    "thead",
    "tfoot",
    "tr"
]);
const $fe1d66ce7da7f6a7$var$tableCellElement = new Set([
    "td",
    "th"
]);
const $fe1d66ce7da7f6a7$var$docs = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function $fe1d66ce7da7f6a7$export$59c10052b2dee561(tree, options) {
    if (!options || options.Fragment === undefined) throw new TypeError("Expected `Fragment` in options");
    const filePath = options.filePath || undefined;
    /** @type {Create} */ let create;
    if (options.development) {
        if (typeof options.jsxDEV !== "function") throw new TypeError("Expected `jsxDEV` in options when `development: true`");
        create = $fe1d66ce7da7f6a7$var$developmentCreate(filePath, options.jsxDEV);
    } else {
        if (typeof options.jsx !== "function") throw new TypeError("Expected `jsx` in production options");
        if (typeof options.jsxs !== "function") throw new TypeError("Expected `jsxs` in production options");
        create = $fe1d66ce7da7f6a7$var$productionCreate(filePath, options.jsx, options.jsxs);
    }
    /** @type {State} */ const state = {
        Fragment: options.Fragment,
        ancestors: [],
        components: options.components || {},
        create: create,
        elementAttributeNameCase: options.elementAttributeNameCase || "react",
        evaluater: options.createEvaluater ? options.createEvaluater() : undefined,
        filePath: filePath,
        ignoreInvalidStyle: options.ignoreInvalidStyle || false,
        passKeys: options.passKeys !== false,
        passNode: options.passNode || false,
        schema: options.space === "svg" ? (0, $5ded0a034e3dc5e9$export$7ed1367e7fa1ad68) : (0, $5ded0a034e3dc5e9$export$c0bb0b647f701bb5),
        stylePropertyNameCase: options.stylePropertyNameCase || "dom",
        tableCellAlignToStyle: options.tableCellAlignToStyle !== false
    };
    const result = $fe1d66ce7da7f6a7$var$one(state, tree, undefined);
    // JSX element.
    if (result && typeof result !== "string") return result;
    // Text node or something that turned into nothing.
    return state.create(tree, state.Fragment, {
        children: result || undefined
    }, undefined);
}
/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Nodes} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $fe1d66ce7da7f6a7$var$one(state, node, key) {
    if (node.type === "element") return $fe1d66ce7da7f6a7$var$element(state, node, key);
    if (node.type === "mdxFlowExpression" || node.type === "mdxTextExpression") return $fe1d66ce7da7f6a7$var$mdxExpression(state, node);
    if (node.type === "mdxJsxFlowElement" || node.type === "mdxJsxTextElement") return $fe1d66ce7da7f6a7$var$mdxJsxElement(state, node, key);
    if (node.type === "mdxjsEsm") return $fe1d66ce7da7f6a7$var$mdxEsm(state, node);
    if (node.type === "root") return $fe1d66ce7da7f6a7$var$root(state, node, key);
    if (node.type === "text") return $fe1d66ce7da7f6a7$var$text(state, node);
}
/**
 * Handle element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $fe1d66ce7da7f6a7$var$element(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.tagName.toLowerCase() === "svg" && parentSchema.space === "html") {
        schema = (0, $5ded0a034e3dc5e9$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = $fe1d66ce7da7f6a7$var$findComponentFromName(state, node.tagName, false);
    const props = $fe1d66ce7da7f6a7$var$createElementProps(state, node);
    let children = $fe1d66ce7da7f6a7$var$createChildren(state, node);
    if ($fe1d66ce7da7f6a7$var$tableElements.has(node.tagName)) children = children.filter(function(child) {
        return typeof child === "string" ? !(0, $d1fe4e3f8d991a92$export$7af1228ff777d175)(child) : true;
    });
    $fe1d66ce7da7f6a7$var$addNode(state, props, type, node);
    $fe1d66ce7da7f6a7$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle MDX expression.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxFlowExpression | MdxTextExpression} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $fe1d66ce7da7f6a7$var$mdxExpression(state, node) {
    if (node.data && node.data.estree && state.evaluater) {
        const program = node.data.estree;
        const expression = program.body[0];
        (0, $5875a1670b965514$export$dcb8b3f0e2de7e49)(expression.type === "ExpressionStatement");
        // Assume result is a child.
        return /** @type {Child | undefined} */ state.evaluater.evaluateExpression(expression.expression);
    }
    $fe1d66ce7da7f6a7$var$crashEstree(state, node.position);
}
/**
 * Handle MDX ESM.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxjsEsm} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $fe1d66ce7da7f6a7$var$mdxEsm(state, node) {
    if (node.data && node.data.estree && state.evaluater) // Assume result is a child.
    return /** @type {Child | undefined} */ state.evaluater.evaluateProgram(node.data.estree);
    $fe1d66ce7da7f6a7$var$crashEstree(state, node.position);
}
/**
 * Handle MDX JSX.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElement | MdxJsxTextElement} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $fe1d66ce7da7f6a7$var$mdxJsxElement(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.name === "svg" && parentSchema.space === "html") {
        schema = (0, $5ded0a034e3dc5e9$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = node.name === null ? state.Fragment : $fe1d66ce7da7f6a7$var$findComponentFromName(state, node.name, true);
    const props = $fe1d66ce7da7f6a7$var$createJsxElementProps(state, node);
    const children = $fe1d66ce7da7f6a7$var$createChildren(state, node);
    $fe1d66ce7da7f6a7$var$addNode(state, props, type, node);
    $fe1d66ce7da7f6a7$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Root} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $fe1d66ce7da7f6a7$var$root(state, node, key) {
    /** @type {Props} */ const props = {};
    $fe1d66ce7da7f6a7$var$addChildren(props, $fe1d66ce7da7f6a7$var$createChildren(state, node));
    return state.create(node, state.Fragment, props, key);
}
/**
 * Handle text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Text} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $fe1d66ce7da7f6a7$var$text(_, node) {
    return node.value;
}
/**
 * Add `node` to props.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Props} props
 *   Props.
 * @param {unknown} type
 *   Type.
 * @param {Element | MdxJsxFlowElement | MdxJsxTextElement} node
 *   Node.
 * @returns {undefined}
 *   Nothing.
 */ function $fe1d66ce7da7f6a7$var$addNode(state, props, type, node) {
    // If this is swapped out for a component:
    if (typeof type !== "string" && type !== state.Fragment && state.passNode) props.node = node;
}
/**
 * Add children to props.
 *
 * @param {Props} props
 *   Props.
 * @param {Array<Child>} children
 *   Children.
 * @returns {undefined}
 *   Nothing.
 */ function $fe1d66ce7da7f6a7$var$addChildren(props, children) {
    if (children.length > 0) {
        const value = children.length > 1 ? children : children[0];
        if (value) props.children = value;
    }
}
/**
 * @param {string | undefined} _
 *   Path to file.
 * @param {Jsx} jsx
 *   Dynamic.
 * @param {Jsx} jsxs
 *   Static.
 * @returns {Create}
 *   Create a production element.
 */ function $fe1d66ce7da7f6a7$var$productionCreate(_, jsx, jsxs) {
    return create;
    /** @type {Create} */ function create(_, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const fn = isStaticChildren ? jsxs : jsx;
        return key ? fn(type, props, key) : fn(type, props);
    }
}
/**
 * @param {string | undefined} filePath
 *   Path to file.
 * @param {JsxDev} jsxDEV
 *   Development.
 * @returns {Create}
 *   Create a development element.
 */ function $fe1d66ce7da7f6a7$var$developmentCreate(filePath, jsxDEV) {
    return create;
    /** @type {Create} */ function create(node, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const point = (0, $01cb538eb16fcb3b$export$771bf3e4949bfbee)(node);
        return jsxDEV(type, props, key, isStaticChildren, {
            columnNumber: point ? point.column - 1 : undefined,
            fileName: filePath,
            lineNumber: point ? point.line : undefined
        }, undefined);
    }
}
/**
 * Create props from an element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current element.
 * @returns {Props}
 *   Props.
 */ function $fe1d66ce7da7f6a7$var$createElementProps(state, node) {
    /** @type {Props} */ const props = {};
    /** @type {string | undefined} */ let alignValue;
    /** @type {string} */ let prop;
    for(prop in node.properties)if (prop !== "children" && $fe1d66ce7da7f6a7$var$own.call(node.properties, prop)) {
        const result = $fe1d66ce7da7f6a7$var$createProperty(state, prop, node.properties[prop]);
        if (result) {
            const [key, value] = result;
            if (state.tableCellAlignToStyle && key === "align" && typeof value === "string" && $fe1d66ce7da7f6a7$var$tableCellElement.has(node.tagName)) alignValue = value;
            else props[key] = value;
        }
    }
    if (alignValue) {
        // Assume style is an object.
        const style = /** @type {Style} */ props.style || (props.style = {});
        style[state.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = alignValue;
    }
    return props;
}
/**
 * Create props from a JSX element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElement | MdxJsxTextElement} node
 *   Current JSX element.
 * @returns {Props}
 *   Props.
 */ function $fe1d66ce7da7f6a7$var$createJsxElementProps(state, node) {
    /** @type {Props} */ const props = {};
    for (const attribute of node.attributes)if (attribute.type === "mdxJsxExpressionAttribute") {
        if (attribute.data && attribute.data.estree && state.evaluater) {
            const program = attribute.data.estree;
            const expression = program.body[0];
            (0, $5875a1670b965514$export$dcb8b3f0e2de7e49)(expression.type === "ExpressionStatement");
            const objectExpression = expression.expression;
            (0, $5875a1670b965514$export$dcb8b3f0e2de7e49)(objectExpression.type === "ObjectExpression");
            const property = objectExpression.properties[0];
            (0, $5875a1670b965514$export$dcb8b3f0e2de7e49)(property.type === "SpreadElement");
            Object.assign(props, state.evaluater.evaluateExpression(property.argument));
        } else $fe1d66ce7da7f6a7$var$crashEstree(state, node.position);
    } else {
        // For JSX, the author is responsible of passing in the correct values.
        const name = attribute.name;
        /** @type {unknown} */ let value;
        if (attribute.value && typeof attribute.value === "object") {
            if (attribute.value.data && attribute.value.data.estree && state.evaluater) {
                const program = attribute.value.data.estree;
                const expression = program.body[0];
                (0, $5875a1670b965514$export$dcb8b3f0e2de7e49)(expression.type === "ExpressionStatement");
                value = state.evaluater.evaluateExpression(expression.expression);
            } else $fe1d66ce7da7f6a7$var$crashEstree(state, node.position);
        } else value = attribute.value === null ? true : attribute.value;
        // Assume a prop.
        props[name] = /** @type {Props[keyof Props]} */ value;
    }
    return props;
}
/**
 * Create children.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Parents} node
 *   Current element.
 * @returns {Array<Child>}
 *   Children.
 */ function $fe1d66ce7da7f6a7$var$createChildren(state, node) {
    /** @type {Array<Child>} */ const children = [];
    let index = -1;
    /** @type {Map<string, number>} */ // Note: test this when Solid doesn’t want to merge my upcoming PR.
    /* c8 ignore next */ const countsByName = state.passKeys ? new Map() : $fe1d66ce7da7f6a7$var$emptyMap;
    while(++index < node.children.length){
        const child = node.children[index];
        /** @type {string | undefined} */ let key;
        if (state.passKeys) {
            const name = child.type === "element" ? child.tagName : child.type === "mdxJsxFlowElement" || child.type === "mdxJsxTextElement" ? child.name : undefined;
            if (name) {
                const count = countsByName.get(name) || 0;
                key = name + "-" + count;
                countsByName.set(name, count + 1);
            }
        }
        const result = $fe1d66ce7da7f6a7$var$one(state, child, key);
        if (result !== undefined) children.push(result);
    }
    return children;
}
/**
 * Handle a property.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Field | undefined}
 *   Field for runtime, optional.
 */ function $fe1d66ce7da7f6a7$var$createProperty(state, prop, value) {
    const info = (0, $3e1e4cbbdf2d0d54$export$71aa6c912b956294)(state.schema, prop);
    // Ignore nullish and `NaN` values.
    if (value === null || value === undefined || typeof value === "number" && Number.isNaN(value)) return;
    if (Array.isArray(value)) // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? (0, $9b3a19d2a847e4ea$export$fac44ee5b035f737)(value) : (0, $fab9e1f1a10b7278$export$fac44ee5b035f737)(value);
    // React only accepts `style` as object.
    if (info.property === "style") {
        let styleObject = typeof value === "object" ? value : $fe1d66ce7da7f6a7$var$parseStyle(state, String(value));
        if (state.stylePropertyNameCase === "css") styleObject = $fe1d66ce7da7f6a7$var$transformStylesToCssCasing(styleObject);
        return [
            "style",
            styleObject
        ];
    }
    return [
        state.elementAttributeNameCase === "react" && info.space ? (0, $8a9529b9b91a5d6a$export$d8abd7e5fb6871f9)[info.property] || info.property : info.attribute,
        value
    ];
}
/**
 * Parse a CSS declaration to an object.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} value
 *   CSS declarations.
 * @returns {Style}
 *   Properties.
 * @throws
 *   Throws `VFileMessage` when CSS cannot be parsed.
 */ function $fe1d66ce7da7f6a7$var$parseStyle(state, value) {
    /** @type {Style} */ const result = {};
    try {
        // @ts-expect-error: `style-to-object` types are broken.
        (0, $83c4722eac8666ea$export$2e2bcd8739ae039)(value, replacer);
    } catch (error) {
        if (!state.ignoreInvalidStyle) {
            const cause = /** @type {Error} */ error;
            const message = new (0, $480e2cf54697d41d$export$752e5c445fe834ef)("Cannot parse `style` attribute", {
                ancestors: state.ancestors,
                cause: cause,
                ruleId: "style",
                source: "hast-util-to-jsx-runtime"
            });
            message.file = state.filePath || undefined;
            message.url = $fe1d66ce7da7f6a7$var$docs + "#cannot-parse-style-attribute";
            throw message;
        }
    }
    return result;
    /**
   * Add a CSS property (normal, so with dashes) to `result` as a DOM CSS
   * property.
   *
   * @param {string} name
   *   Key.
   * @param {string} value
   *   Value
   * @returns {undefined}
   *   Nothing.
   */ function replacer(name, value) {
        let key = name;
        if (key.slice(0, 2) !== "--") {
            if (key.slice(0, 4) === "-ms-") key = "ms-" + key.slice(4);
            key = key.replace($fe1d66ce7da7f6a7$var$dashSomething, $fe1d66ce7da7f6a7$var$toCamel);
        }
        result[key] = value;
    }
}
/**
 * Create a JSX name from a string.
 *
 * @param {State} state
 *   To do.
 * @param {string} name
 *   Name.
 * @param {boolean} allowExpression
 *   Allow member expressions and identifiers.
 * @returns {unknown}
 *   To do.
 */ function $fe1d66ce7da7f6a7$var$findComponentFromName(state, name, allowExpression) {
    /** @type {Identifier | Literal | MemberExpression} */ let result;
    if (!allowExpression) result = {
        type: "Literal",
        value: name
    };
    else if (name.includes(".")) {
        const identifiers = name.split(".");
        let index = -1;
        /** @type {Identifier | Literal | MemberExpression | undefined} */ let node;
        while(++index < identifiers.length){
            /** @type {Identifier | Literal} */ const prop = (0, $4db71400c71eb638$export$a8ff84c12d48cfa6)(identifiers[index]) ? {
                type: "Identifier",
                name: identifiers[index]
            } : {
                type: "Literal",
                value: identifiers[index]
            };
            node = node ? {
                type: "MemberExpression",
                object: node,
                property: prop,
                computed: Boolean(index && prop.type === "Literal"),
                optional: false
            } : prop;
        }
        (0, $5875a1670b965514$export$dcb8b3f0e2de7e49)(node, "always a result");
        result = node;
    } else result = (0, $4db71400c71eb638$export$a8ff84c12d48cfa6)(name) && !/^[a-z]/.test(name) ? {
        type: "Identifier",
        name: name
    } : {
        type: "Literal",
        value: name
    };
    // Only literals can be passed in `components` currently.
    // No identifiers / member expressions.
    if (result.type === "Literal") {
        const name = /** @type {keyof JSX.IntrinsicElements} */ result.value;
        return $fe1d66ce7da7f6a7$var$own.call(state.components, name) ? state.components[name] : name;
    }
    // Assume component.
    if (state.evaluater) return state.evaluater.evaluateExpression(result);
    $fe1d66ce7da7f6a7$var$crashEstree(state);
}
/**
 * @param {State} state
 * @param {Position | undefined} [place]
 * @returns {never}
 */ function $fe1d66ce7da7f6a7$var$crashEstree(state, place) {
    const message = new (0, $480e2cf54697d41d$export$752e5c445fe834ef)("Cannot handle MDX estrees without `createEvaluater`", {
        ancestors: state.ancestors,
        place: place,
        ruleId: "mdx-estree",
        source: "hast-util-to-jsx-runtime"
    });
    message.file = state.filePath || undefined;
    message.url = $fe1d66ce7da7f6a7$var$docs + "#cannot-handle-mdx-estrees-without-createevaluater";
    throw message;
}
/**
 * Transform a DOM casing style object to a CSS casing style object.
 *
 * @param {Style} domCasing
 * @returns {Style}
 */ function $fe1d66ce7da7f6a7$var$transformStylesToCssCasing(domCasing) {
    /** @type {Style} */ const cssCasing = {};
    /** @type {string} */ let from;
    for(from in domCasing)if ($fe1d66ce7da7f6a7$var$own.call(domCasing, from)) cssCasing[$fe1d66ce7da7f6a7$var$transformStyleToCssCasing(from)] = domCasing[from];
    return cssCasing;
}
/**
 * Transform a DOM casing style field to a CSS casing style field.
 *
 * @param {string} from
 * @returns {string}
 */ function $fe1d66ce7da7f6a7$var$transformStyleToCssCasing(from) {
    let to = from.replace($fe1d66ce7da7f6a7$var$cap, $fe1d66ce7da7f6a7$var$toDash);
    // Handle `ms-xxx` -> `-ms-xxx`.
    if (to.slice(0, 3) === "ms-") to = "-" + to;
    return to;
}
/**
 * Make `$1` capitalized.
 *
 * @param {string} _
 *   Whatever.
 * @param {string} $1
 *   Single ASCII alphabetical.
 * @returns {string}
 *   Capitalized `$1`.
 */ function $fe1d66ce7da7f6a7$var$toCamel(_, $1) {
    return $1.toUpperCase();
}
/**
 * Make `$0` dash cased.
 *
 * @param {string} $0
 *   Capitalized ASCII leter.
 * @returns {string}
 *   Dash and lower letter.
 */ function $fe1d66ce7da7f6a7$var$toDash($0) {
    return "-" + $0.toLowerCase();
}


/**
 * HTML URL properties.
 *
 * Each key is a property name and each value is a list of tag names it applies
 * to or `null` if it applies to all elements.
 *
 * @type {Record<string, Array<string> | null>}
 */ const $737e11ed1c2fa8be$export$de3e062aedff083a = {
    action: [
        "form"
    ],
    cite: [
        "blockquote",
        "del",
        "ins",
        "q"
    ],
    data: [
        "object"
    ],
    formAction: [
        "button",
        "input"
    ],
    href: [
        "a",
        "area",
        "base",
        "link"
    ],
    icon: [
        "menuitem"
    ],
    itemId: null,
    manifest: [
        "html"
    ],
    ping: [
        "a",
        "area"
    ],
    poster: [
        "video"
    ],
    src: [
        "audio",
        "embed",
        "iframe",
        "img",
        "input",
        "script",
        "source",
        "track",
        "video"
    ]
};



/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} FromMarkdownOptions
 * @typedef {import('unified').Parser<Root>} Parser
 * @typedef {import('unified').Processor<Root>} Processor
 */ /**
 * @typedef {Omit<FromMarkdownOptions, 'extensions' | 'mdastExtensions'>} Options
 */ /**
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 *
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Omit<Parent, 'children' | 'type'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | null | undefined | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {undefined | void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {undefined}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Fragment | Nodes>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {(this: CompileContext) => undefined} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {(this: CompileContext, node: Nodes, token: Token, onError?: OnEnterError) => undefined} enter
 *   Enter a node.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => undefined} exit
 *   Exit a node.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 * @property {CompileData} data
 *   Info passed around; key/value store.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ /**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $d13246a53d1de810$var$emptyOptions = {};
function $d13246a53d1de810$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $d13246a53d1de810$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
    return $d13246a53d1de810$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $d13246a53d1de810$var$one(value, includeImageAlt, includeHtml) {
    if ($d13246a53d1de810$var$node(value)) {
        if ("value" in value) return value.type === "html" && !includeHtml ? "" : value.value;
        if (includeImageAlt && "alt" in value && value.alt) return value.alt;
        if ("children" in value) return $d13246a53d1de810$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $d13246a53d1de810$var$all(value, includeImageAlt, includeHtml);
    return "";
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $d13246a53d1de810$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $d13246a53d1de810$var$one(values[index], includeImageAlt, includeHtml);
    return result.join("");
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $d13246a53d1de810$var$node(value) {
    return Boolean(value && typeof value === "object");
}


/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Options} Options
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @typedef {import('micromark-util-types').Compile} Compile
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').CompileData} CompileData
 * @typedef {import('micromark-util-types').CompileOptions} CompileOptions
 * @typedef {import('micromark-util-types').Definition} Definition
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Handle} Handle
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedHtmlExtension} NormalizedHtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ /// <reference lib="dom" />
/* eslint-env browser */ const $e591f5eaa3eaa02c$var$element = document.createElement("i");
function $e591f5eaa3eaa02c$export$289b6a6320f709b4(value) {
    const characterReference = "&" + value + ";";
    $e591f5eaa3eaa02c$var$element.innerHTML = characterReference;
    const char = $e591f5eaa3eaa02c$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    if (char.charCodeAt(char.length - 1) === 59 /* `;` */  && value !== "semi") return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    return char === characterReference ? false : char;
}


/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $ecc6f0995065efa5$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $ecc6f0995065efa5$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $ecc6f0995065efa5$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ 
const $fd2dab30576a1d5a$var$hasOwnProperty = {}.hasOwnProperty;
function $fd2dab30576a1d5a$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$fd2dab30576a1d5a$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 */ function $fd2dab30576a1d5a$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $fd2dab30576a1d5a$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$fd2dab30576a1d5a$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $fd2dab30576a1d5a$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {undefined}
 */ function $fd2dab30576a1d5a$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    (0, $ecc6f0995065efa5$export$869882364835d202)(existing, 0, 0, before);
}
function $fd2dab30576a1d5a$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$fd2dab30576a1d5a$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 */ function $fd2dab30576a1d5a$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $fd2dab30576a1d5a$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $43185c060ae7b472$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}


const $5d1966fb92bbc611$var$characterReferences = {
    '"': "quot",
    "&": "amp",
    "<": "lt",
    ">": "gt"
};
function $5d1966fb92bbc611$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return "&" + $5d1966fb92bbc611$var$characterReferences[value] + ";";
    }
}


/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $f1e2acc7cd93570b$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, "")// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 */ const $b9b72a00b0e3d592$var$unicodePunctuationInternal = $b9b72a00b0e3d592$var$regexCheck(/\p{P}/u);
const $b9b72a00b0e3d592$export$d65d6b62c24d5436 = $b9b72a00b0e3d592$var$regexCheck(/[A-Za-z]/);
const $b9b72a00b0e3d592$export$75c76db11865a9f4 = $b9b72a00b0e3d592$var$regexCheck(/[\dA-Za-z]/);
const $b9b72a00b0e3d592$export$4397998b34fe597d = $b9b72a00b0e3d592$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $b9b72a00b0e3d592$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $b9b72a00b0e3d592$export$ca8b5b1a6c320e6e = $b9b72a00b0e3d592$var$regexCheck(/\d/);
const $b9b72a00b0e3d592$export$eca2752363989806 = $b9b72a00b0e3d592$var$regexCheck(/[\dA-Fa-f]/);
const $b9b72a00b0e3d592$export$35794a7d1db99380 = $b9b72a00b0e3d592$var$regexCheck(/[!-/:-@[-`{-~]/);
function $b9b72a00b0e3d592$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $b9b72a00b0e3d592$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $b9b72a00b0e3d592$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
function $b9b72a00b0e3d592$export$aa04114dd888a7a0(code) {
    return $b9b72a00b0e3d592$export$35794a7d1db99380(code) || $b9b72a00b0e3d592$var$unicodePunctuationInternal(code);
}
const $b9b72a00b0e3d592$export$a0ff789c034ffdf4 = $b9b72a00b0e3d592$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $b9b72a00b0e3d592$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}



function $03f7185aba47aa5e$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $5d1966fb92bbc611$export$c564cdbbe6da493)($03f7185aba47aa5e$export$e42a3e39590d28b5(url || ""));
    if (!protocol) return value;
    const colon = value.indexOf(":");
    const questionMark = value.indexOf("?");
    const numberSign = value.indexOf("#");
    const slash = value.indexOf("/");
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return "";
}
function $03f7185aba47aa5e$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = "";
        // A correct percent encoded value.
        if (code === 37 && (0, $b9b72a00b0e3d592$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $b9b72a00b0e3d592$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = "";
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join("") + value.slice(start);
}


const $255a813659dc7b4d$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $255a813659dc7b4d$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $255a813659dc7b4d$var$protocolSrc = /^https?$/i;
function $255a813659dc7b4d$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $fd2dab30576a1d5a$export$eaf8c406dfb0a620)([
        defaultHandlers
    ].concat(settings.htmlExtensions || []));
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        tightStack: tightStack,
        definitions: definitions
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        encode: encode,
        raw: raw,
        tag: tag,
        buffer: buffer,
        resume: resume,
        setData: setData,
        getData: getData
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {Array<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) // @ts-expect-error Hush, it’s a line ending.
            lineEndingStyle = events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === "enter") listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === "enter") {
                    body = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(head, body);
        head = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($255a813659dc7b4d$var$hasOwnProperty.call(handles, kind) && handle) handle.call(Object.assign({
                sliceSerialize: result[index][2].sliceSerialize
            }, context), result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join("");
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {Array<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0 // Skip open.
        ;
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === "exit") atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === "enter" && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join("");
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData("lastWasTag", true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData("lastWasTag");
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || "\n");
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData("ignoreEncode") ? value : (0, $5d1966fb92bbc611$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag("<ol");
        setData("expectFirstItem", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag("<ul");
        setData("expectFirstItem", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData("expectFirstItem")) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData("expectFirstItem")) tag(">");
        else onexitlistitem();
        lineEndingIfNeeded();
        tag("<li>");
        setData("expectFirstItem");
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData("lastWasTag");
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag("</ol>");
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag("</ul>");
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData("lastWasTag") && !getData("slurpAllLineEndings")) lineEndingIfNeeded();
        tag("</li>");
        setData("slurpAllLineEndings");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag("<blockquote>");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag("</blockquote>");
        setData("slurpAllLineEndings");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag("<p>");
        }
        setData("slurpAllLineEndings");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData("slurpAllLineEndings", true);
        else tag("</p>");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag("<pre><code");
        setData("fencesCount", 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData("fencesCount") || 0;
        if (!count) {
            tag(">");
            setData("slurpOneLineEnding", true);
        }
        setData("fencesCount", count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag("<pre><code>");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData("fencesCount");
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData("lastWasTag")) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData("flowCodeSeenData")) lineEndingIfNeeded();
        tag("</code></pre>");
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData("flowCodeSeenData");
        setData("fencesCount");
        setData("slurpOneLineEnding");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined // Disallow tags.
        ;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer() // We can have line endings in the resource, ignore them.
        ;
        mediaStack[mediaStack.length - 1].destination = "";
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData("ignoreEncode", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData("ignoreEncode");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1 // Skip current.
        ;
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $f1e2acc7cd93570b$export$806d55e226cfcd08)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $03f7185aba47aa5e$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $255a813659dc7b4d$var$protocolSrc) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $03f7185aba47aa5e$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $255a813659dc7b4d$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : "");
        if (media.image) tag(" />");
        else {
            tag(">");
            raw(media.label);
            tag("</a>");
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData("ignoreEncode", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData("ignoreEncode");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $f1e2acc7cd93570b$export$806d55e226cfcd08)(media.labelId);
        resume();
        if (!$255a813659dc7b4d$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData("slurpAllLineEndings", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData("headingRank")) return;
        setData("headingRank", this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag("<h" + getData("headingRank") + ">");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData("slurpAllLineEndings");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData("slurpAllLineEndings", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag("</h" + getData("headingRank") + ">");
        setData("headingRank");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData("headingRank", this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag("<h" + getData("headingRank") + ">");
        raw(value);
        tag("</h" + getData("headingRank") + ">");
        setData("slurpAllLineEndings");
        setData("headingRank");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData("slurpAllLineEndings")) return;
        if (getData("slurpOneLineEnding")) {
            setData("slurpOneLineEnding");
            return;
        }
        if (getData("inCodeText")) {
            raw(" ");
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData("flowCodeSeenData", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag("<br />");
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData("ignoreEncode");
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData("ignoreEncode", true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag("<em>");
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag("<strong>");
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData("inCodeText", true);
        tag("<code>");
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData("inCodeText");
        tag("</code>");
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag("</em>");
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag("</strong>");
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag("<hr />");
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        let value = this.sliceSerialize(token);
        // @ts-expect-error `decodeNamedCharacterReference` can return false for
        // invalid named character references, but everything we’ve tokenized is
        // valid.
        value = getData("characterReferenceType") ? (0, $43185c060ae7b472$export$15a69557afac2c20)(value, getData("characterReferenceType") === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $e591f5eaa3eaa02c$export$289b6a6320f709b4)(value);
        raw(encode(value));
        setData("characterReferenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $03f7185aba47aa5e$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $255a813659dc7b4d$var$protocolHref) + '">');
        raw(encode(uri));
        tag("</a>");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $03f7185aba47aa5e$export$d130a2d684099e5a)("mailto:" + uri) + '">');
        raw(encode(uri));
        tag("</a>");
    }
}


/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ 
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $b310eae96fead042$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $9a89462744fdce2c$export$a7db06668cad9adb = {
    tokenize: $9a89462744fdce2c$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $9a89462744fdce2c$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 


const $4d955f035131dc42$export$5a7bfc01df82fcd1 = {
    tokenize: $4d955f035131dc42$var$initializeDocument
};
/** @type {Construct} */ const $4d955f035131dc42$var$containerConstruct = {
    tokenize: $4d955f035131dc42$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $4d955f035131dc42$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $ecc6f0995065efa5$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($4d955f035131dc42$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($4d955f035131dc42$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {undefined}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $ecc6f0995065efa5$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {undefined}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4d955f035131dc42$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $56a8bb0e02b317f2$export$d50d28ce3ab2a612 = {
    tokenize: $56a8bb0e02b317f2$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $56a8bb0e02b317f2$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code) ? (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
function $6477516ca0d11a14$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                Object.assign(jumps, $6477516ca0d11a14$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $ecc6f0995065efa5$export$869882364835d202)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $6477516ca0d11a14$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $ecc6f0995065efa5$export$869882364835d202)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $a289c1c2e8888eb9$export$a7db06668cad9adb = {
    tokenize: $a289c1c2e8888eb9$var$tokenizeContent,
    resolve: $a289c1c2e8888eb9$var$resolveContent
};
/** @type {Construct} */ const $a289c1c2e8888eb9$var$continuationConstruct = {
    tokenize: $a289c1c2e8888eb9$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $a289c1c2e8888eb9$var$resolveContent(events) {
    (0, $6477516ca0d11a14$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a289c1c2e8888eb9$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) return effects.check($a289c1c2e8888eb9$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a289c1c2e8888eb9$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $e22b5a47e221bc78$export$ccc7b0636abaffc3 = {
    tokenize: $e22b5a47e221bc78$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $e22b5a47e221bc78$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $56a8bb0e02b317f2$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $a289c1c2e8888eb9$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $67b39d34790a3521$export$50397835cbfdbc24 = {
    resolveAll: $67b39d34790a3521$var$createResolver()
};
const $67b39d34790a3521$export$22b082955e083ec3 = $67b39d34790a3521$var$initializeFactory("string");
const $67b39d34790a3521$export$6f093cfa640b7166 = $67b39d34790a3521$var$initializeFactory("text");
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $67b39d34790a3521$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $67b39d34790a3521$var$createResolver(field === "text" ? $67b39d34790a3521$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $67b39d34790a3521$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $67b39d34790a3521$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {undefined}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {undefined}
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $eff70a65658efd43$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $3e8001ea6a67b0ae$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $eff70a65658efd43$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $3e8001ea6a67b0ae$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $3e8001ea6a67b0ae$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {undefined}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : "tokenize" in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {undefined}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $ecc6f0995065efa5$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $3e8001ea6a67b0ae$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === "string") view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $3e8001ea6a67b0ae$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === "string") value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "	";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}


var $51f8a35418c65a67$exports = {};

$parcel$export($51f8a35418c65a67$exports, "document", function () { return $51f8a35418c65a67$export$5a7bfc01df82fcd1; });
$parcel$export($51f8a35418c65a67$exports, "contentInitial", function () { return $51f8a35418c65a67$export$5a2181fb44b58173; });
$parcel$export($51f8a35418c65a67$exports, "flowInitial", function () { return $51f8a35418c65a67$export$cf8bead395eff824; });
$parcel$export($51f8a35418c65a67$exports, "flow", function () { return $51f8a35418c65a67$export$ccc7b0636abaffc3; });
$parcel$export($51f8a35418c65a67$exports, "string", function () { return $51f8a35418c65a67$export$22b082955e083ec3; });
$parcel$export($51f8a35418c65a67$exports, "text", function () { return $51f8a35418c65a67$export$6f093cfa640b7166; });
$parcel$export($51f8a35418c65a67$exports, "insideSpan", function () { return $51f8a35418c65a67$export$d44f260a3f9b69f5; });
$parcel$export($51f8a35418c65a67$exports, "attentionMarkers", function () { return $51f8a35418c65a67$export$b9c0b60d74426aea; });
$parcel$export($51f8a35418c65a67$exports, "disable", function () { return $51f8a35418c65a67$export$e20fbacbb41798b; });
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
function $0baa81874e84e1c8$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $b9b72a00b0e3d592$export$a30284361b3814b7)(code) || (0, $b9b72a00b0e3d592$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $b9b72a00b0e3d592$export$aa04114dd888a7a0)(code)) return 2;
}



const $d5e4bd0183c7e151$export$45b92471da762af7 = {
    name: "attention",
    tokenize: $d5e4bd0183c7e151$var$tokenizeAttention,
    resolveAll: $d5e4bd0183c7e151$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $d5e4bd0183c7e151$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $d5e4bd0183c7e151$var$movePoint(start, -use);
            $d5e4bd0183c7e151$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(nextEvents, (0, $eff70a65658efd43$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $ecc6f0995065efa5$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d5e4bd0183c7e151$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $0baa81874e84e1c8$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter("attentionSequence");
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit("attentionSequence");
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $0baa81874e84e1c8$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {undefined}
 */ function $d5e4bd0183c7e151$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $88b1b03cce9b0e0b$export$17ddf85e4c916ad6 = {
    name: "autolink",
    tokenize: $88b1b03cce9b0e0b$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $88b1b03cce9b0e0b$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $b9b72a00b0e3d592$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $b9b72a00b0e3d592$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $b9b72a00b0e3d592$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $b9b72a00b0e3d592$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $b9b72a00b0e3d592$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $b9b72a00b0e3d592$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $b9b72a00b0e3d592$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $d70d027215e6b189$export$200dcd0a5903c968 = {
    name: "blockQuote",
    tokenize: $d70d027215e6b189$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $d70d027215e6b189$var$tokenizeBlockQuoteContinuation
    },
    exit: $d70d027215e6b189$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d70d027215e6b189$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d70d027215e6b189$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($d70d027215e6b189$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $d70d027215e6b189$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $e39f9581a39b7783$export$2005478564e78d96 = {
    name: "characterEscape",
    tokenize: $e39f9581a39b7783$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e39f9581a39b7783$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $b9b72a00b0e3d592$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $b1396d9d9b089919$export$e31905600aaf3d8e = {
    name: "characterReference",
    tokenize: $b1396d9d9b089919$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b1396d9d9b089919$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $b9b72a00b0e3d592$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $b9b72a00b0e3d592$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $b9b72a00b0e3d592$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $b9b72a00b0e3d592$export$75c76db11865a9f4) && !(0, $e591f5eaa3eaa02c$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/** @type {Construct} */ const $fac2ed2d5570db9b$var$nonLazyContinuation = {
    tokenize: $fac2ed2d5570db9b$var$tokenizeNonLazyContinuation,
    partial: true
};
const $fac2ed2d5570db9b$export$c23e4921f8d87e7c = {
    name: "codeFenced",
    tokenize: $fac2ed2d5570db9b$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fac2ed2d5570db9b$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code) ? (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($fac2ed2d5570db9b$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code) ? (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) return effects.check($fac2ed2d5570db9b$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code) ? (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code) ? (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fac2ed2d5570db9b$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $87dcc8b69e430028$export$47910b7ab28d1853 = {
    name: "codeIndented",
    tokenize: $87dcc8b69e430028$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $87dcc8b69e430028$var$furtherStart = {
    tokenize: $87dcc8b69e430028$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $87dcc8b69e430028$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) return effects.attempt($87dcc8b69e430028$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $87dcc8b69e430028$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $37ebbf606f49290f$export$d24f93e715f9df88 = {
    name: "codeText",
    tokenize: $37ebbf606f49290f$var$tokenizeCodeText,
    resolve: $37ebbf606f49290f$var$resolveCodeText,
    previous: $37ebbf606f49290f$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $37ebbf606f49290f$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $37ebbf606f49290f$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $37ebbf606f49290f$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $35269db5a0008191$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $b9b72a00b0e3d592$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $b9b72a00b0e3d592$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $b9b72a00b0e3d592$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $4288d49bc3b75dda$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && "_hiddenFootnoteSupport" in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 

function $75f332df58c5c03f$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 

function $9d4de28195ac5b7d$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




const $89b8a98bb462d791$export$69f215ed977cdb73 = {
    name: "definition",
    tokenize: $89b8a98bb462d791$var$tokenizeDefinition
};
/** @type {Construct} */ const $89b8a98bb462d791$var$titleBefore = {
    tokenize: $89b8a98bb462d791$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $89b8a98bb462d791$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $4288d49bc3b75dda$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $f1e2acc7cd93570b$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $b9b72a00b0e3d592$export$a30284361b3814b7)(code) ? (0, $9d4de28195ac5b7d$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $35269db5a0008191$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($89b8a98bb462d791$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code) ? (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $89b8a98bb462d791$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $b9b72a00b0e3d592$export$a30284361b3814b7)(code) ? (0, $9d4de28195ac5b7d$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $75f332df58c5c03f$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code) ? (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $86e43c81e8e245fb$export$86c573ab9e06f418 = {
    name: "hardBreakEscape",
    tokenize: $86e43c81e8e245fb$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $86e43c81e8e245fb$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $bdd4b8370aa98760$export$3871e9deb360695c = {
    name: "headingAtx",
    tokenize: $bdd4b8370aa98760$var$tokenizeHeadingAtx,
    resolve: $bdd4b8370aa98760$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $bdd4b8370aa98760$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $ecc6f0995065efa5$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $bdd4b8370aa98760$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $b9b72a00b0e3d592$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $b9b72a00b0e3d592$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $6a30b1e80df385b4$export$7364aee1c59d1879 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
const $6a30b1e80df385b4$export$948e66da505d080 = [
    "pre",
    "script",
    "style",
    "textarea"
];



const $c14f9a435cb4b1fd$export$476ac411cb7d0d8f = {
    name: "htmlFlow",
    tokenize: $c14f9a435cb4b1fd$var$tokenizeHtmlFlow,
    resolveTo: $c14f9a435cb4b1fd$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $c14f9a435cb4b1fd$var$blankLineBefore = {
    tokenize: $c14f9a435cb4b1fd$var$tokenizeBlankLineBefore,
    partial: true
};
const $c14f9a435cb4b1fd$var$nonLazyContinuationStart = {
    tokenize: $c14f9a435cb4b1fd$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $c14f9a435cb4b1fd$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c14f9a435cb4b1fd$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $b9b72a00b0e3d592$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $b9b72a00b0e3d592$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $b9b72a00b0e3d592$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $b9b72a00b0e3d592$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $6a30b1e80df385b4$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $6a30b1e80df385b4$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $b9b72a00b0e3d592$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $b9b72a00b0e3d592$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $b9b72a00b0e3d592$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $b9b72a00b0e3d592$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($c14f9a435cb4b1fd$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($c14f9a435cb4b1fd$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $6a30b1e80df385b4$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $b9b72a00b0e3d592$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c14f9a435cb4b1fd$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c14f9a435cb4b1fd$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $56a8bb0e02b317f2$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $1f89ad6bb661adb2$export$398af27f284914fe = {
    name: "htmlText",
    tokenize: $1f89ad6bb661adb2$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1f89ad6bb661adb2$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $b9b72a00b0e3d592$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $b9b72a00b0e3d592$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $b9b72a00b0e3d592$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $b9b72a00b0e3d592$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $b9b72a00b0e3d592$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $b9b72a00b0e3d592$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $b9b72a00b0e3d592$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $b9b72a00b0e3d592$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $b9b72a00b0e3d592$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $b9b72a00b0e3d592$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code) ? (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 







const $9ef5aec22ca130db$export$470a5dafbbf62654 = {
    name: "labelEnd",
    tokenize: $9ef5aec22ca130db$var$tokenizeLabelEnd,
    resolveTo: $9ef5aec22ca130db$var$resolveToLabelEnd,
    resolveAll: $9ef5aec22ca130db$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $9ef5aec22ca130db$var$resourceConstruct = {
    tokenize: $9ef5aec22ca130db$var$tokenizeResource
};
/** @type {Construct} */ const $9ef5aec22ca130db$var$referenceFullConstruct = {
    tokenize: $9ef5aec22ca130db$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $9ef5aec22ca130db$var$referenceCollapsedConstruct = {
    tokenize: $9ef5aec22ca130db$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $9ef5aec22ca130db$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $9ef5aec22ca130db$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(media, [
        [
            "enter",
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(media, (0, $eff70a65658efd43$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $ecc6f0995065efa5$export$4cbf152802aa238)(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    (0, $ecc6f0995065efa5$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9ef5aec22ca130db$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $f1e2acc7cd93570b$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($9ef5aec22ca130db$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($9ef5aec22ca130db$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($9ef5aec22ca130db$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9ef5aec22ca130db$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $b9b72a00b0e3d592$export$a30284361b3814b7)(code) ? (0, $9d4de28195ac5b7d$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $35269db5a0008191$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $b9b72a00b0e3d592$export$a30284361b3814b7)(code) ? (0, $9d4de28195ac5b7d$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $75f332df58c5c03f$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $b9b72a00b0e3d592$export$a30284361b3814b7)(code) ? (0, $9d4de28195ac5b7d$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9ef5aec22ca130db$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $4288d49bc3b75dda$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $f1e2acc7cd93570b$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9ef5aec22ca130db$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $6b79cdab8bd4e7df$export$3d754936e25aa5f5 = {
    name: "labelStartImage",
    tokenize: $6b79cdab8bd4e7df$var$tokenizeLabelStartImage,
    resolveAll: (0, $9ef5aec22ca130db$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6b79cdab8bd4e7df$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $25a2356ef1b5e158$export$5c0cee0701a3b584 = {
    name: "labelStartLink",
    tokenize: $25a2356ef1b5e158$var$tokenizeLabelStartLink,
    resolveAll: (0, $9ef5aec22ca130db$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $25a2356ef1b5e158$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $a37fd6a256b0ef84$export$8e62e0ad51c97b2 = {
    name: "lineEnding",
    tokenize: $a37fd6a256b0ef84$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a37fd6a256b0ef84$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $b8f13847d500c5d8$export$ba7b13e047416c03 = {
    name: "thematicBreak",
    tokenize: $b8f13847d500c5d8$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b8f13847d500c5d8$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code) ? (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $d1837665f8063aa5$export$8837f4fc672e936d = {
    name: "list",
    tokenize: $d1837665f8063aa5$var$tokenizeListStart,
    continuation: {
        tokenize: $d1837665f8063aa5$var$tokenizeListContinuation
    },
    exit: $d1837665f8063aa5$var$tokenizeListEnd
};
/** @type {Construct} */ const $d1837665f8063aa5$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $d1837665f8063aa5$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $d1837665f8063aa5$var$indentConstruct = {
    tokenize: $d1837665f8063aa5$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $d1837665f8063aa5$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $b9b72a00b0e3d592$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $b8f13847d500c5d8$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $b9b72a00b0e3d592$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $56a8bb0e02b317f2$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($d1837665f8063aa5$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $d1837665f8063aa5$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $56a8bb0e02b317f2$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($d1837665f8063aa5$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, effects.attempt($d1837665f8063aa5$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $d1837665f8063aa5$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $d1837665f8063aa5$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $d1837665f8063aa5$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $abb4232e80ae0432$export$e104e2de391dfde9 = {
    name: "setextUnderline",
    tokenize: $abb4232e80ae0432$var$tokenizeSetextUnderline,
    resolveTo: $abb4232e80ae0432$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $abb4232e80ae0432$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $abb4232e80ae0432$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $b9b72a00b0e3d592$export$2c6cf65c1127992a)(code) ? (0, $b310eae96fead042$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $b9b72a00b0e3d592$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $51f8a35418c65a67$export$5a7bfc01df82fcd1 = {
    [42]: (0, $d1837665f8063aa5$export$8837f4fc672e936d),
    [43]: (0, $d1837665f8063aa5$export$8837f4fc672e936d),
    [45]: (0, $d1837665f8063aa5$export$8837f4fc672e936d),
    [48]: (0, $d1837665f8063aa5$export$8837f4fc672e936d),
    [49]: (0, $d1837665f8063aa5$export$8837f4fc672e936d),
    [50]: (0, $d1837665f8063aa5$export$8837f4fc672e936d),
    [51]: (0, $d1837665f8063aa5$export$8837f4fc672e936d),
    [52]: (0, $d1837665f8063aa5$export$8837f4fc672e936d),
    [53]: (0, $d1837665f8063aa5$export$8837f4fc672e936d),
    [54]: (0, $d1837665f8063aa5$export$8837f4fc672e936d),
    [55]: (0, $d1837665f8063aa5$export$8837f4fc672e936d),
    [56]: (0, $d1837665f8063aa5$export$8837f4fc672e936d),
    [57]: (0, $d1837665f8063aa5$export$8837f4fc672e936d),
    [62]: (0, $d70d027215e6b189$export$200dcd0a5903c968)
};
const $51f8a35418c65a67$export$5a2181fb44b58173 = {
    [91]: (0, $89b8a98bb462d791$export$69f215ed977cdb73)
};
const $51f8a35418c65a67$export$cf8bead395eff824 = {
    [-2]: (0, $87dcc8b69e430028$export$47910b7ab28d1853),
    [-1]: (0, $87dcc8b69e430028$export$47910b7ab28d1853),
    [32]: (0, $87dcc8b69e430028$export$47910b7ab28d1853)
};
const $51f8a35418c65a67$export$ccc7b0636abaffc3 = {
    [35]: (0, $bdd4b8370aa98760$export$3871e9deb360695c),
    [42]: (0, $b8f13847d500c5d8$export$ba7b13e047416c03),
    [45]: [
        (0, $abb4232e80ae0432$export$e104e2de391dfde9),
        (0, $b8f13847d500c5d8$export$ba7b13e047416c03)
    ],
    [60]: (0, $c14f9a435cb4b1fd$export$476ac411cb7d0d8f),
    [61]: (0, $abb4232e80ae0432$export$e104e2de391dfde9),
    [95]: (0, $b8f13847d500c5d8$export$ba7b13e047416c03),
    [96]: (0, $fac2ed2d5570db9b$export$c23e4921f8d87e7c),
    [126]: (0, $fac2ed2d5570db9b$export$c23e4921f8d87e7c)
};
const $51f8a35418c65a67$export$22b082955e083ec3 = {
    [38]: (0, $b1396d9d9b089919$export$e31905600aaf3d8e),
    [92]: (0, $e39f9581a39b7783$export$2005478564e78d96)
};
const $51f8a35418c65a67$export$6f093cfa640b7166 = {
    [-5]: (0, $a37fd6a256b0ef84$export$8e62e0ad51c97b2),
    [-4]: (0, $a37fd6a256b0ef84$export$8e62e0ad51c97b2),
    [-3]: (0, $a37fd6a256b0ef84$export$8e62e0ad51c97b2),
    [33]: (0, $6b79cdab8bd4e7df$export$3d754936e25aa5f5),
    [38]: (0, $b1396d9d9b089919$export$e31905600aaf3d8e),
    [42]: (0, $d5e4bd0183c7e151$export$45b92471da762af7),
    [60]: [
        (0, $88b1b03cce9b0e0b$export$17ddf85e4c916ad6),
        (0, $1f89ad6bb661adb2$export$398af27f284914fe)
    ],
    [91]: (0, $25a2356ef1b5e158$export$5c0cee0701a3b584),
    [92]: [
        (0, $86e43c81e8e245fb$export$86c573ab9e06f418),
        (0, $e39f9581a39b7783$export$2005478564e78d96)
    ],
    [93]: (0, $9ef5aec22ca130db$export$470a5dafbbf62654),
    [95]: (0, $d5e4bd0183c7e151$export$45b92471da762af7),
    [96]: (0, $37ebbf606f49290f$export$d24f93e715f9df88)
};
const $51f8a35418c65a67$export$d44f260a3f9b69f5 = {
    null: [
        (0, $d5e4bd0183c7e151$export$45b92471da762af7),
        (0, $67b39d34790a3521$export$50397835cbfdbc24)
    ]
};
const $51f8a35418c65a67$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $51f8a35418c65a67$export$e20fbacbb41798b = {
    null: []
};


function $ed863885b9cd36b7$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $fd2dab30576a1d5a$export$86a865d89ef3c690)([
        $51f8a35418c65a67$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $9a89462744fdce2c$export$a7db06668cad9adb)),
        document: create((0, $4d955f035131dc42$export$5a7bfc01df82fcd1)),
        flow: create((0, $e22b5a47e221bc78$export$ccc7b0636abaffc3)),
        string: create((0, $67b39d34790a3521$export$22b082955e083ec3)),
        text: create((0, $67b39d34790a3521$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $3e8001ea6a67b0ae$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $bb69af1210753d2c$export$bd0e6e1378a871d7(events) {
    while(!(0, $6477516ca0d11a14$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $4c463b0f5d59a965$var$search = /[\0\t\n\r]/g;
function $4c463b0f5d59a965$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = "";
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === "string" ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = "";
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $4c463b0f5d59a965$var$search.lastIndex = startPosition;
            match = $4c463b0f5d59a965$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


function $50850a416979e153$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return (0, $255a813659dc7b4d$export$ef7acd7185315e22)(options)((0, $bb69af1210753d2c$export$bd0e6e1378a871d7)((0, $ed863885b9cd36b7$export$98e6a39c04603d36)(options).document().write((0, $4c463b0f5d59a965$export$fc37fe19dfda43ee)()(value, encoding, true))));
}





const $2910ea32358c7847$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $2910ea32358c7847$export$a0fb664af7d0cc44(value) {
    return value.replace($2910ea32358c7847$var$characterEscapeOrReference, $2910ea32358c7847$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $2910ea32358c7847$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $43185c060ae7b472$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $e591f5eaa3eaa02c$export$289b6a6320f709b4)($2) || $0;
}





const $1afb40a70956d022$var$own = {}.hasOwnProperty;
function $1afb40a70956d022$export$d744d789c09bfde6(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $1afb40a70956d022$var$compiler(options)((0, $bb69af1210753d2c$export$bd0e6e1378a871d7)((0, $ed863885b9cd36b7$export$98e6a39c04603d36)(options).document().write((0, $4c463b0f5d59a965$export$fc37fe19dfda43ee)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $1afb40a70956d022$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $1afb40a70956d022$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: "root",
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($1afb40a70956d022$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $1afb40a70956d022$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $1afb40a70956d022$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $1afb40a70956d022$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === "enter") containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === "enter") {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: "listItem",
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        "enter",
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {undefined}
   */ function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Nodes} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {undefined}
   *   Nothing.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        node.position = {
            start: $1afb40a70956d022$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {undefined}
   *   Nothing.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + (0, $021a6f7cf488cf5d$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $1afb40a70956d022$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $1afb40a70956d022$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $d13246a53d1de810$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, "");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $f1e2acc7cd93570b$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $1afb40a70956d022$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $1afb40a70956d022$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $1afb40a70956d022$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $2910ea32358c7847$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $f1e2acc7cd93570b$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === "link") {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = "collapsed";
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $f1e2acc7cd93570b$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = "full";
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $43185c060ae7b472$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $e591f5eaa3eaa02c$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $1afb40a70956d022$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: "heading",
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: "break"
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: "html",
            value: ""
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: "text",
            value: ""
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $1afb40a70956d022$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $1afb40a70956d022$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $1afb40a70956d022$var$configure(combined, value);
        else $1afb40a70956d022$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $1afb40a70956d022$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($1afb40a70956d022$var$own.call(extension, key)) switch(key){
        case "canContainEols":
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case "transforms":
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case "enter":
        case "exit":
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $1afb40a70956d022$var$defaultOnError(left, right) {
    if (left) throw new Error("Cannot close `" + left.type + "` (" + (0, $021a6f7cf488cf5d$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + "): a different token (`" + right.type + "`, " + (0, $021a6f7cf488cf5d$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is open");
    else throw new Error("Cannot close document, a token (`" + right.type + "`, " + (0, $021a6f7cf488cf5d$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is still open");
}


function $dd4e018775450ff7$export$2e2bcd8739ae039(options) {
    /** @type {Processor} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    const self = this;
    self.parser = parser;
    /**
   * @type {Parser}
   */ function parser(doc) {
        return (0, $1afb40a70956d022$export$d744d789c09bfde6)(doc, {
            ...self.data("settings"),
            ...options,
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data("micromarkExtensions") || [],
            mdastExtensions: self.data("fromMarkdownExtensions") || []
        });
    }
}


// Include `data` fields in mdast and `raw` nodes in hast.
/// <reference types="mdast-util-to-hast" />
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor} Processor
 * @typedef {import('vfile').VFile} VFile
 */ /**
 * @callback TransformBridge
 *   Bridge-mode.
 *
 *   Runs the destination with the new hast tree.
 *   Discards result.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {Promise<undefined>}
 *   Nothing.
 *
 * @callback TransformMutate
 *  Mutate-mode.
 *
 *  Further transformers run on the hast tree.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {HastRoot}
 *   Tree (hast).
 */ /**
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('./state.js').Options} Options
 */ 
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @callback FootnoteBackContentTemplate
 *   Generate content for the backreference dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent> | ElementContent | string}
 *   Content for the backreference when linking back from definitions to their
 *   reference.
 *
 * @callback FootnoteBackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ const $485210c3540a02ed$export$1cd1943b3a73bbe8 = -1;
const $485210c3540a02ed$export$a44b4f3d5b73db95 = 0;
const $485210c3540a02ed$export$b119f07080a207ba = 1;
const $485210c3540a02ed$export$8b8a958a7f6f130c = 2;
const $485210c3540a02ed$export$501a7fac1df67a49 = 3;
const $485210c3540a02ed$export$cd2b220b1ea851b2 = 4;
const $485210c3540a02ed$export$ce970371e0e850bc = 5;
const $485210c3540a02ed$export$5e8f180ef0142226 = 6;
const $485210c3540a02ed$export$103bedf43ba882db = 7;
const $485210c3540a02ed$export$9f2207c8fceeefa8 = 8; // export const SYMBOL = 9;


const $e64f78b882c85dbf$var$env = typeof self === "object" ? self : globalThis;
const $e64f78b882c85dbf$var$deserializer = ($, _)=>{
    const as = (out, index)=>{
        $.set(index, out);
        return out;
    };
    const unpair = (index)=>{
        if ($.has(index)) return $.get(index);
        const [type, value] = _[index];
        switch(type){
            case 0, $485210c3540a02ed$export$a44b4f3d5b73db95:
            case 0, $485210c3540a02ed$export$1cd1943b3a73bbe8:
                return as(value, index);
            case 0, $485210c3540a02ed$export$b119f07080a207ba:
                {
                    const arr = as([], index);
                    for (const index of value)arr.push(unpair(index));
                    return arr;
                }
            case 0, $485210c3540a02ed$export$8b8a958a7f6f130c:
                {
                    const object = as({}, index);
                    for (const [key, index] of value)object[unpair(key)] = unpair(index);
                    return object;
                }
            case 0, $485210c3540a02ed$export$501a7fac1df67a49:
                return as(new Date(value), index);
            case 0, $485210c3540a02ed$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as(new RegExp(source, flags), index);
                }
            case 0, $485210c3540a02ed$export$ce970371e0e850bc:
                {
                    const map = as(new Map, index);
                    for (const [key, index] of value)map.set(unpair(key), unpair(index));
                    return map;
                }
            case 0, $485210c3540a02ed$export$5e8f180ef0142226:
                {
                    const set = as(new Set, index);
                    for (const index of value)set.add(unpair(index));
                    return set;
                }
            case 0, $485210c3540a02ed$export$103bedf43ba882db:
                {
                    const { name: name, message: message } = value;
                    return as(new $e64f78b882c85dbf$var$env[name](message), index);
                }
            case 0, $485210c3540a02ed$export$9f2207c8fceeefa8:
                return as(BigInt(value), index);
            case "BigInt":
                return as(Object(BigInt(value)), index);
        }
        return as(new $e64f78b882c85dbf$var$env[type](value), index);
    };
    return unpair;
};
const $e64f78b882c85dbf$export$efcd34ab6248d3cd = (serialized)=>$e64f78b882c85dbf$var$deserializer(new Map, serialized)(0);



const $1f1e993bc4dfa7e7$var$EMPTY = "";
const { toString: $1f1e993bc4dfa7e7$var$toString } = {};
const { keys: $1f1e993bc4dfa7e7$var$keys } = Object;
const $1f1e993bc4dfa7e7$var$typeOf = (value)=>{
    const type = typeof value;
    if (type !== "object" || !value) return [
        (0, $485210c3540a02ed$export$a44b4f3d5b73db95),
        type
    ];
    const asString = $1f1e993bc4dfa7e7$var$toString.call(value).slice(8, -1);
    switch(asString){
        case "Array":
            return [
                (0, $485210c3540a02ed$export$b119f07080a207ba),
                $1f1e993bc4dfa7e7$var$EMPTY
            ];
        case "Object":
            return [
                (0, $485210c3540a02ed$export$8b8a958a7f6f130c),
                $1f1e993bc4dfa7e7$var$EMPTY
            ];
        case "Date":
            return [
                (0, $485210c3540a02ed$export$501a7fac1df67a49),
                $1f1e993bc4dfa7e7$var$EMPTY
            ];
        case "RegExp":
            return [
                (0, $485210c3540a02ed$export$cd2b220b1ea851b2),
                $1f1e993bc4dfa7e7$var$EMPTY
            ];
        case "Map":
            return [
                (0, $485210c3540a02ed$export$ce970371e0e850bc),
                $1f1e993bc4dfa7e7$var$EMPTY
            ];
        case "Set":
            return [
                (0, $485210c3540a02ed$export$5e8f180ef0142226),
                $1f1e993bc4dfa7e7$var$EMPTY
            ];
    }
    if (asString.includes("Array")) return [
        (0, $485210c3540a02ed$export$b119f07080a207ba),
        asString
    ];
    if (asString.includes("Error")) return [
        (0, $485210c3540a02ed$export$103bedf43ba882db),
        asString
    ];
    return [
        (0, $485210c3540a02ed$export$8b8a958a7f6f130c),
        asString
    ];
};
const $1f1e993bc4dfa7e7$var$shouldSkip = ([TYPE, type])=>TYPE === (0, $485210c3540a02ed$export$a44b4f3d5b73db95) && (type === "function" || type === "symbol");
const $1f1e993bc4dfa7e7$var$serializer = (strict, json, $, _)=>{
    const as = (out, value)=>{
        const index = _.push(out) - 1;
        $.set(value, index);
        return index;
    };
    const pair = (value)=>{
        if ($.has(value)) return $.get(value);
        let [TYPE, type] = $1f1e993bc4dfa7e7$var$typeOf(value);
        switch(TYPE){
            case 0, $485210c3540a02ed$export$a44b4f3d5b73db95:
                {
                    let entry = value;
                    switch(type){
                        case "bigint":
                            TYPE = (0, $485210c3540a02ed$export$9f2207c8fceeefa8);
                            entry = value.toString();
                            break;
                        case "function":
                        case "symbol":
                            if (strict) throw new TypeError("unable to serialize " + type);
                            entry = null;
                            break;
                        case "undefined":
                            return as([
                                (0, $485210c3540a02ed$export$1cd1943b3a73bbe8)
                            ], value);
                    }
                    return as([
                        TYPE,
                        entry
                    ], value);
                }
            case 0, $485210c3540a02ed$export$b119f07080a207ba:
                {
                    if (type) return as([
                        type,
                        [
                            ...value
                        ]
                    ], value);
                    const arr = [];
                    const index = as([
                        TYPE,
                        arr
                    ], value);
                    for (const entry of value)arr.push(pair(entry));
                    return index;
                }
            case 0, $485210c3540a02ed$export$8b8a958a7f6f130c:
                {
                    if (type) switch(type){
                        case "BigInt":
                            return as([
                                type,
                                value.toString()
                            ], value);
                        case "Boolean":
                        case "Number":
                        case "String":
                            return as([
                                type,
                                value.valueOf()
                            ], value);
                    }
                    if (json && "toJSON" in value) return pair(value.toJSON());
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const key of $1f1e993bc4dfa7e7$var$keys(value))if (strict || !$1f1e993bc4dfa7e7$var$shouldSkip($1f1e993bc4dfa7e7$var$typeOf(value[key]))) entries.push([
                        pair(key),
                        pair(value[key])
                    ]);
                    return index;
                }
            case 0, $485210c3540a02ed$export$501a7fac1df67a49:
                return as([
                    TYPE,
                    value.toISOString()
                ], value);
            case 0, $485210c3540a02ed$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as([
                        TYPE,
                        {
                            source: source,
                            flags: flags
                        }
                    ], value);
                }
            case 0, $485210c3540a02ed$export$ce970371e0e850bc:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const [key, entry] of value)if (strict || !($1f1e993bc4dfa7e7$var$shouldSkip($1f1e993bc4dfa7e7$var$typeOf(key)) || $1f1e993bc4dfa7e7$var$shouldSkip($1f1e993bc4dfa7e7$var$typeOf(entry)))) entries.push([
                        pair(key),
                        pair(entry)
                    ]);
                    return index;
                }
            case 0, $485210c3540a02ed$export$5e8f180ef0142226:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const entry of value)if (strict || !$1f1e993bc4dfa7e7$var$shouldSkip($1f1e993bc4dfa7e7$var$typeOf(entry))) entries.push(pair(entry));
                    return index;
                }
        }
        const { message: message } = value;
        return as([
            TYPE,
            {
                name: type,
                message: message
            }
        ], value);
    };
    return pair;
};
const $1f1e993bc4dfa7e7$export$dfdc1655ccc5b9cb = (value, { json: json, lossy: lossy } = {})=>{
    const _ = [];
    return $1f1e993bc4dfa7e7$var$serializer(!(json || lossy), !!json, new Map, _)(value), _;
};


var /**
 * @typedef {Array<string,any>} Record a type representation
 */ /**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */ $3573a2413dd5feeb$export$2e2bcd8739ae039 = typeof structuredClone === "function" ? /* c8 ignore start */ (any, options)=>options && ("json" in options || "lossy" in options) ? (0, $e64f78b882c85dbf$export$efcd34ab6248d3cd)((0, $1f1e993bc4dfa7e7$export$dfdc1655ccc5b9cb)(any, options)) : structuredClone(any) : (any, options)=>(0, $e64f78b882c85dbf$export$efcd34ab6248d3cd)((0, $1f1e993bc4dfa7e7$export$dfdc1655ccc5b9cb)(any, options));



function $8a709c06dbd5e74e$export$4a6e1c4b9e5bc5d1(_, rereferenceIndex) {
    /** @type {Array<ElementContent>} */ const result = [
        {
            type: "text",
            value: "\u21A9"
        }
    ];
    if (rereferenceIndex > 1) result.push({
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            {
                type: "text",
                value: String(rereferenceIndex)
            }
        ]
    });
    return result;
}
function $8a709c06dbd5e74e$export$d83e66a407212d3b(referenceIndex, rereferenceIndex) {
    return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
function $8a709c06dbd5e74e$export$adb608be33961c98(state) {
    const clobberPrefix = typeof state.options.clobberPrefix === "string" ? state.options.clobberPrefix : "user-content-";
    const footnoteBackContent = state.options.footnoteBackContent || $8a709c06dbd5e74e$export$4a6e1c4b9e5bc5d1;
    const footnoteBackLabel = state.options.footnoteBackLabel || $8a709c06dbd5e74e$export$d83e66a407212d3b;
    const footnoteLabel = state.options.footnoteLabel || "Footnotes";
    const footnoteLabelTagName = state.options.footnoteLabelTagName || "h2";
    const footnoteLabelProperties = state.options.footnoteLabelProperties || {
        className: [
            "sr-only"
        ]
    };
    /** @type {Array<ElementContent>} */ const listItems = [];
    let referenceIndex = -1;
    while(++referenceIndex < state.footnoteOrder.length){
        const def = state.footnoteById.get(state.footnoteOrder[referenceIndex]);
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $03f7185aba47aa5e$export$e42a3e39590d28b5)(id.toLowerCase());
        let rereferenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        const counts = state.footnoteCounts.get(id);
        // eslint-disable-next-line no-unmodified-loop-condition
        while(counts !== undefined && ++rereferenceIndex <= counts){
            if (backReferences.length > 0) backReferences.push({
                type: "text",
                value: " "
            });
            let children = typeof footnoteBackContent === "string" ? footnoteBackContent : footnoteBackContent(referenceIndex, rereferenceIndex);
            if (typeof children === "string") children = {
                type: "text",
                value: children
            };
            backReferences.push({
                type: "element",
                tagName: "a",
                properties: {
                    href: "#" + clobberPrefix + "fnref-" + safeId + (rereferenceIndex > 1 ? "-" + rereferenceIndex : ""),
                    dataFootnoteBackref: "",
                    ariaLabel: typeof footnoteBackLabel === "string" ? footnoteBackLabel : footnoteBackLabel(referenceIndex, rereferenceIndex),
                    className: [
                        "data-footnote-backref"
                    ]
                },
                children: Array.isArray(children) ? children : [
                    children
                ]
            });
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === "element" && tail.tagName === "p") {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === "text") tailTail.value += " ";
            else tail.children.push({
                type: "text",
                value: " "
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: "element",
            tagName: "li",
            properties: {
                id: clobberPrefix + "fn-" + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: "element",
        tagName: "section",
        properties: {
            dataFootnotes: true,
            className: [
                "footnotes"
            ]
        },
        children: [
            {
                type: "element",
                tagName: footnoteLabelTagName,
                properties: {
                    ...(0, $3573a2413dd5feeb$export$2e2bcd8739ae039)(footnoteLabelProperties),
                    id: "footnote-label"
                },
                children: [
                    {
                        type: "text",
                        value: footnoteLabel
                    }
                ]
            },
            {
                type: "text",
                value: "\n"
            },
            {
                type: "element",
                tagName: "ol",
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: "text",
                value: "\n"
            }
        ]
    };
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').RootContent} HastRootContent
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('mdast').Parents} MdastParents
 *
 * @typedef {import('./footer.js').FootnoteBackContentTemplate} FootnoteBackContentTemplate
 * @typedef {import('./footer.js').FootnoteBackLabelTemplate} FootnoteBackLabelTemplate
 */ /**
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | undefined} parent
 *   Parent of `node`.
 * @returns {Array<HastElementContent> | HastElementContent | undefined}
 *   hast node.
 *
 * @typedef {Partial<Record<MdastNodes['type'], Handler>>} Handlers
 *   Handle nodes.
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree (default:
 *   `false`).
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` property on footnotes to prevent them from
 *   *clobbering* (default: `'user-content-'`).
 *
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {FootnoteBackContentTemplate | string | null | undefined} [footnoteBackContent]
 *   Content of the backreference back to references (default: `defaultFootnoteBackContent`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackContent(_, rereferenceIndex) {
 *     const result = [{type: 'text', value: '↩'}]
 *
 *     if (rereferenceIndex > 1) {
 *       result.push({
 *         type: 'element',
 *         tagName: 'sup',
 *         properties: {},
 *         children: [{type: 'text', value: String(rereferenceIndex)}]
 *       })
 *     }
 *
 *     return result
 *   }
 *   ```
 *
 *   This content is used in the `a` element of each backreference (the `↩`
 *   links).
 * @property {FootnoteBackLabelTemplate | string | null | undefined} [footnoteBackLabel]
 *   Label to describe the backreference back to references (default:
 *   `defaultFootnoteBackLabel`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *   }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `ariaLabel` property on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Textual label to use for the footnotes section (default: `'Footnotes'`).
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (default: `{className:
 *   ['sr-only']}`).
 *
 *   Change it to show the label and add other properties.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different properties.
 *
 *   > 👉 **Note**: `id: 'footnote-label'` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   HTML tag name to use for the footnote label element (default: `'h2'`).
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes (optional).
 * @property {Array<MdastNodes['type']> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed)
 *   (optional).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes (optional).
 *
 * @typedef State
 *   Info passed around.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => HastElement | Type} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {Map<string, MdastDefinition>} definitionById
 *   Definitions by their identifier.
 * @property {Map<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Map<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {(node: MdastNodes, parent: MdastParents | undefined) => Array<HastElementContent> | HastElementContent | undefined} one
 *   Transform an mdast node to hast.
 * @property {Options} options
 *   Configuration.
 * @property {(from: MdastNodes, node: HastNodes) => undefined} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastRootContent>(nodes: Array<Type>, loose?: boolean | undefined) => Array<HastText | Type>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 */ 
/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $9548b9d02e4b6e05$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $9548b9d02e4b6e05$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== "number" || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite index");
    if (parent !== undefined && parent !== null && (!$9548b9d02e4b6e05$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error("Expected parent node");
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error("Expected both parent and index");
    return $9548b9d02e4b6e05$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $9548b9d02e4b6e05$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $9548b9d02e4b6e05$var$ok;
    if (typeof test === "function") return $9548b9d02e4b6e05$var$castFactory(test);
    if (typeof test === "object") return Array.isArray(test) ? $9548b9d02e4b6e05$var$anyFactory(test) : $9548b9d02e4b6e05$var$propsFactory(test);
    if (typeof test === "string") return $9548b9d02e4b6e05$var$typeFactory(test);
    throw new Error("Expected function, string, or object as test");
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $9548b9d02e4b6e05$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $9548b9d02e4b6e05$export$9c68d69a4c5bbcf9(tests[index]);
    return $9548b9d02e4b6e05$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $9548b9d02e4b6e05$var$propsFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $9548b9d02e4b6e05$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {Record<string, unknown>} */ /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $9548b9d02e4b6e05$var$typeFactory(check) {
    return $9548b9d02e4b6e05$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $9548b9d02e4b6e05$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($9548b9d02e4b6e05$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === "number" ? index : undefined, parent || undefined));
    }
}
function $9548b9d02e4b6e05$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $9548b9d02e4b6e05$var$looksLikeANode(value) {
    return value !== null && typeof value === "object" && "type" in value;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $ddeb5604035c7cc0$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $31a84d10499e2461$var$empty = [];
const $31a84d10499e2461$export$f4d8133c446fe484 = true;
const $31a84d10499e2461$export$7f100f842f565dc9 = false;
const $31a84d10499e2461$export$8773f85c2fb2c116 = "skip";
function $31a84d10499e2461$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $9548b9d02e4b6e05$export$9c68d69a4c5bbcf9)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === "object" ? node : {};
        if (typeof value.type === "string") {
            const name = // `hast`
            typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            Object.defineProperty(visit, "name", {
                value: "node (" + (0, $ddeb5604035c7cc0$export$35e9368ef982300f)(node.type + (name ? "<" + name + ">" : "")) + ")"
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $31a84d10499e2461$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $31a84d10499e2461$var$toResult(visitor(node, parents));
                if (result[0] === $31a84d10499e2461$export$7f100f842f565dc9) return result;
            }
            if ("children" in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $31a84d10499e2461$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $31a84d10499e2461$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $31a84d10499e2461$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "number") return [
        $31a84d10499e2461$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $31a84d10499e2461$var$empty : [
        value
    ];
}


function $493950d893275058$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === "function" && typeof visitorOrReverse !== "function") {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $31a84d10499e2461$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $942b2bb6d5fe5967$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "blockquote",
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $099dac5075229d58$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "br",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: "text",
            value: "\n"
        }
    ];
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $7960e9ccec869c20$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + "\n" : "";
    /** @type {Properties} */ const properties = {};
    if (node.lang) properties.className = [
        "language-" + node.lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: "element",
        tagName: "code",
        properties: properties,
        children: [
            {
                type: "text",
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: "element",
        tagName: "pre",
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $266793a321c0e6ab$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "del",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $b8133f48068d8395$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "em",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('../state.js').State} State
 */ 
function $76fd154fd48bbc00$export$7f87ee744075c1ba(state, node) {
    const clobberPrefix = typeof state.options.clobberPrefix === "string" ? state.options.clobberPrefix : "user-content-";
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $03f7185aba47aa5e$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    let reuseCounter = state.footnoteCounts.get(id);
    if (reuseCounter === undefined) {
        reuseCounter = 0;
        state.footnoteOrder.push(id);
        counter = state.footnoteOrder.length;
    } else counter = index + 1;
    reuseCounter += 1;
    state.footnoteCounts.set(id, reuseCounter);
    /** @type {Element} */ const link = {
        type: "element",
        tagName: "a",
        properties: {
            href: "#" + clobberPrefix + "fn-" + safeId,
            id: clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                "footnote-label"
            ]
        },
        children: [
            {
                type: "text",
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $f8da997183183884$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "h" + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Html} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ // Make VS Code show references to the above types.
"";
function $ae0acff3ef45b87f$export$c0bb0b647f701bb5(state, node) {
    if (state.options.allowDangerousHtml) {
        /** @type {Raw} */ const result = {
            type: "raw",
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    return undefined;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Reference} Reference
 *
 * @typedef {import('./state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $c0da553a7217e1e5$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = "]";
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return [
        {
            type: "text",
            value: "![" + node.alt + suffix
        }
    ];
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift({
        type: "text",
        value: "["
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push({
        type: "text",
        value: suffix
    });
    return contents;
}


function $decf6d502494f725$export$f281796f6bc3b8db(state, node) {
    const id = String(node.identifier).toUpperCase();
    const def = state.definitionById.get(id);
    if (!def) return (0, $c0da553a7217e1e5$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $03f7185aba47aa5e$export$e42a3e39590d28b5)(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
function $97532acab175219d$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $03f7185aba47aa5e$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $7c6f18e4d19d0b7e$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: "text",
        value: node.value.replace(/\r?\n|\r/g, " ")
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "code",
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 

function $b81297b5ad4c78dc$export$e6c469b1b7b2bc6a(state, node) {
    const id = String(node.identifier).toUpperCase();
    const def = state.definitionById.get(id);
    if (!def) return (0, $c0da553a7217e1e5$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $03f7185aba47aa5e$export$e42a3e39590d28b5)(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
function $b560d8b5e215081d$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $03f7185aba47aa5e$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $1ad637c3d9331f44$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $1ad637c3d9331f44$var$listLoose(parent) : $1ad637c3d9331f44$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === "boolean") {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === "element" && head.tagName === "p") paragraph = head;
        else {
            paragraph = {
                type: "element",
                tagName: "p",
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: "text",
            value: " "
        });
        paragraph.children.unshift({
            type: "element",
            tagName: "input",
            properties: {
                type: "checkbox",
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            "task-list-item"
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== "element" || child.tagName !== "p") children.push({
            type: "text",
            value: "\n"
        });
        if (child.type === "element" && child.tagName === "p" && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) children.push({
        type: "text",
        value: "\n"
    });
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "li",
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $1ad637c3d9331f44$var$listLoose(node) {
    let loose = false;
    if (node.type === "list") {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $1ad637c3d9331f44$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $1ad637c3d9331f44$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === null || spread === undefined ? node.children.length > 1 : spread;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $59b564ea496d8cc8$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === "number" && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
            properties.className = [
                "contains-task-list"
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: node.ordered ? "ol" : "ul",
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $417e88789a997079$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "p",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Parents} HastParents
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $6530eafb6fab5eff$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: "root",
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $6d56905b72dc5280$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "strong",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
function $0a995bb9bc98930f$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: "element",
            tagName: "thead",
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: "element",
            tagName: "tbody",
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $01cb538eb16fcb3b$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $01cb538eb16fcb3b$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start && end) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "table",
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $5c0a8c0845eb403f$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? "th" : "td";
    // To do: option to use `style`?
    const align = parent && parent.type === "table" ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: "element",
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(cell, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "tr",
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $7910fb0bbe8053f9$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "td",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ const $afd7c262713c1a8d$var$tab = 9 /* `\t` */ ;
const $afd7c262713c1a8d$var$space = 32 /* ` ` */ ;
function $afd7c262713c1a8d$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($afd7c262713c1a8d$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($afd7c262713c1a8d$var$trimLine(source.slice(last), last > 0, false));
    return lines.join("");
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $afd7c262713c1a8d$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $afd7c262713c1a8d$var$tab || code === $afd7c262713c1a8d$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $afd7c262713c1a8d$var$tab || code === $afd7c262713c1a8d$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}


function $d8328d4da483013b$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: "text",
        value: (0, $afd7c262713c1a8d$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $15b62cb781a5eeb4$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "hr",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $5f5d7c624df3b6e5$export$455ce229eb3d2472 = {
    blockquote: $942b2bb6d5fe5967$export$67dc04e652a298ca,
    break: (0, $099dac5075229d58$export$371da9dd35aba193),
    code: $7960e9ccec869c20$export$6565f9f03506010b,
    delete: (0, $266793a321c0e6ab$export$19426ff118fe8be),
    emphasis: $b8133f48068d8395$export$bef81ba411953b51,
    footnoteReference: $76fd154fd48bbc00$export$7f87ee744075c1ba,
    heading: $f8da997183183884$export$46e4a324ac90507f,
    html: $ae0acff3ef45b87f$export$c0bb0b647f701bb5,
    imageReference: $decf6d502494f725$export$f281796f6bc3b8db,
    image: $97532acab175219d$export$5c452ff88e35e47d,
    inlineCode: $7c6f18e4d19d0b7e$export$91b9bee19a0d8569,
    linkReference: $b81297b5ad4c78dc$export$e6c469b1b7b2bc6a,
    link: $b560d8b5e215081d$export$9c30223ca0a664fb,
    listItem: $1ad637c3d9331f44$export$76c7e83ecc9cdf05,
    list: $59b564ea496d8cc8$export$8837f4fc672e936d,
    paragraph: $417e88789a997079$export$9c206ddddb32a9b,
    root: // @ts-expect-error: root is different, but hard to type.
    $6530eafb6fab5eff$export$e8e78c978b129247,
    strong: $6d56905b72dc5280$export$59ae2c325a998f89,
    table: $0a995bb9bc98930f$export$9852986a3ec5f6a0,
    tableCell: $7910fb0bbe8053f9$export$e1e720e5f4603e6a,
    tableRow: $5c0a8c0845eb403f$export$ce666bf02318c957,
    text: $d8328d4da483013b$export$6f093cfa640b7166,
    thematicBreak: $15b62cb781a5eeb4$export$ba7b13e047416c03,
    toml: $5f5d7c624df3b6e5$var$ignore,
    yaml: $5f5d7c624df3b6e5$var$ignore,
    definition: $5f5d7c624df3b6e5$var$ignore,
    footnoteDefinition: $5f5d7c624df3b6e5$var$ignore
};
// Return nothing for nodes that are ignored.
function $5f5d7c624df3b6e5$var$ignore() {
    return undefined;
}


const $55f4243ff99bac46$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $55f4243ff99bac46$var$emptyOptions = {};
function $55f4243ff99bac46$export$e6a0daad8304de(tree, options) {
    const settings = options || $55f4243ff99bac46$var$emptyOptions;
    /** @type {Map<string, MdastDefinition>} */ const definitionById = new Map();
    /** @type {Map<string, MdastFootnoteDefinition>} */ const footnoteById = new Map();
    /** @type {Map<string, number>} */ const footnoteCounts = new Map();
    /** @type {Handlers} */ // @ts-expect-error: the root handler returns a root.
    // Hard to type.
    const handlers = {
        ...(0, $5f5d7c624df3b6e5$export$455ce229eb3d2472),
        ...settings.handlers
    };
    /** @type {State} */ const state = {
        all: all,
        applyData: $55f4243ff99bac46$var$applyData,
        definitionById: definitionById,
        footnoteById: footnoteById,
        footnoteCounts: footnoteCounts,
        footnoteOrder: [],
        handlers: handlers,
        one: one,
        options: settings,
        patch: $55f4243ff99bac46$var$patch,
        wrap: $55f4243ff99bac46$export$4997ffc0176396a6
    };
    (0, $493950d893275058$export$bf638b60ea8b89b7)(tree, function(node) {
        if (node.type === "definition" || node.type === "footnoteDefinition") {
            const map = node.type === "definition" ? definitionById : footnoteById;
            const id = String(node.identifier).toUpperCase();
            // Mimick CM behavior of link definitions.
            // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/9032189/lib/index.js#L20-L21>.
            if (!map.has(id)) // @ts-expect-error: node type matches map.
            map.set(id, node);
        }
    });
    return state;
    /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | undefined} [parent]
   *   Parent of `node`.
   * @returns {Array<HastElementContent> | HastElementContent | undefined}
   *   Resulting hast node.
   */ function one(node, parent) {
        const type = node.type;
        const handle = state.handlers[type];
        if ($55f4243ff99bac46$var$own.call(state.handlers, type) && handle) return handle(state, node, parent);
        if (state.options.passThrough && state.options.passThrough.includes(type)) {
            if ("children" in node) {
                const { children: children, ...shallow } = node;
                const result = (0, $3573a2413dd5feeb$export$2e2bcd8739ae039)(shallow);
                // @ts-expect-error: TS doesn’t understand…
                result.children = state.all(node);
                // @ts-expect-error: TS doesn’t understand…
                return result;
            }
            // @ts-expect-error: it’s custom.
            return (0, $3573a2413dd5feeb$export$2e2bcd8739ae039)(node);
        }
        const unknown = state.options.unknownHandler || $55f4243ff99bac46$var$defaultUnknownHandler;
        return unknown(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function all(parent) {
        /** @type {Array<HastElementContent>} */ const values = [];
        if ("children" in parent) {
            const nodes = parent.children;
            let index = -1;
            while(++index < nodes.length){
                const result = state.one(nodes[index], parent);
                // To do: see if we van clean this? Can we merge texts?
                if (result) {
                    if (index && nodes[index - 1].type === "break") {
                        if (!Array.isArray(result) && result.type === "text") result.value = $55f4243ff99bac46$var$trimMarkdownSpaceStart(result.value);
                        if (!Array.isArray(result) && result.type === "element") {
                            const head = result.children[0];
                            if (head && head.type === "text") head.value = $55f4243ff99bac46$var$trimMarkdownSpaceStart(head.value);
                        }
                    }
                    if (Array.isArray(result)) values.push(...result);
                    else values.push(result);
                }
            }
        }
        return values;
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {undefined}
 *   Nothing.
 */ function $55f4243ff99bac46$var$patch(from, to) {
    if (from.position) to.position = (0, $01cb538eb16fcb3b$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {HastElement | Type}
 *   Nothing.
 */ function $55f4243ff99bac46$var$applyData(from, to) {
    /** @type {HastElement | Type} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === "string") {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === "element") result.tagName = hName;
            else {
                /** @type {Array<HastElementContent>} */ // @ts-expect-error: assume no doctypes in `root`.
                const children = "children" in result ? result.children : [
                    result
                ];
                result = {
                    type: "element",
                    tagName: hName,
                    properties: {},
                    children: children
                };
            }
        }
        if (result.type === "element" && hProperties) Object.assign(result.properties, (0, $3573a2413dd5feeb$export$2e2bcd8739ae039)(hProperties));
        if ("children" in result && result.children && hChildren !== null && hChildren !== undefined) result.children = hChildren;
    }
    return result;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastElement | HastText}
 *   Resulting hast node.
 */ function $55f4243ff99bac46$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastElement | HastText} */ const result = "value" in node && !($55f4243ff99bac46$var$own.call(data, "hProperties") || $55f4243ff99bac46$var$own.call(data, "hChildren")) ? {
        type: "text",
        value: node.value
    } : {
        type: "element",
        tagName: "div",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $55f4243ff99bac46$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<HastText | Type>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: "text",
        value: "\n"
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: "text",
            value: "\n"
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: "text",
        value: "\n"
    });
    return result;
}
/**
 * Trim spaces and tabs at the start of `value`.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Result.
 */ function $55f4243ff99bac46$var$trimMarkdownSpaceStart(value) {
    let index = 0;
    let code = value.charCodeAt(index);
    while(code === 9 || code === 32){
        index++;
        code = value.charCodeAt(index);
    }
    return value.slice(index);
}


function $9a7cbfa0f2b63581$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $55f4243ff99bac46$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, undefined);
    const foot = (0, $8a709c06dbd5e74e$export$adb608be33961c98)(state);
    /** @type {HastNodes} */ const result = Array.isArray(node) ? {
        type: "root",
        children: node
    } : node || {
        type: "root",
        children: []
    };
    if (foot) {
        // If there’s a footer, there were definitions, meaning block
        // content.
        // So `result` is a parent node.
        (0, $5875a1670b965514$export$dcb8b3f0e2de7e49)("children" in result);
        result.children.push({
            type: "text",
            value: "\n"
        }, foot);
    }
    return result;
}


function $7c8a298979572166$export$2e2bcd8739ae039(destination, options) {
    if (destination && "run" in destination) /**
     * @type {TransformBridge}
     */ return async function(tree, file) {
        // Cast because root in -> root out.
        const hastTree = /** @type {HastRoot} */ (0, $9a7cbfa0f2b63581$export$c0e4c5cf07538633)(tree, options);
        await destination.run(hastTree, file);
    };
    /**
   * @type {TransformMutate}
   */ return function(tree) {
        // Cast because root in -> root out.
        return /** @type {HastRoot} */ (0, $9a7cbfa0f2b63581$export$c0e4c5cf07538633)(tree, options || destination);
    };
}


/**
 * @typedef {import('trough').Pipeline} Pipeline
 *
 * @typedef {import('unist').Node} Node
 *
 * @typedef {import('vfile').Compatible} Compatible
 * @typedef {import('vfile').Value} Value
 *
 * @typedef {import('../index.js').CompileResultMap} CompileResultMap
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Settings} Settings
 */ /**
 * @typedef {CompileResultMap[keyof CompileResultMap]} CompileResults
 *   Acceptable results from compilers.
 *
 *   To register custom results, add them to
 *   {@link CompileResultMap `CompileResultMap`}.
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the compiler receives (default: `Node`).
 * @template {CompileResults} [Result=CompileResults]
 *   The thing that the compiler yields (default: `CompileResults`).
 * @callback Compiler
 *   A **compiler** handles the compiling of a syntax tree to something else
 *   (in most cases, text) (TypeScript type).
 *
 *   It is used in the stringify phase and called with a {@link Node `Node`}
 *   and {@link VFile `VFile`} representation of the document to compile.
 *   It should return the textual representation of the given tree (typically
 *   `string`).
 *
 *   > 👉 **Note**: unified typically compiles by serializing: most compilers
 *   > return `string` (or `Uint8Array`).
 *   > Some compilers, such as the one configured with
 *   > [`rehype-react`][rehype-react], return other values (in this case, a
 *   > React tree).
 *   > If you’re using a compiler that doesn’t serialize, expect different
 *   > result values.
 *   >
 *   > To register custom results in TypeScript, add them to
 *   > {@link CompileResultMap `CompileResultMap`}.
 *
 *   [rehype-react]: https://github.com/rehypejs/rehype-react
 * @param {Tree} tree
 *   Tree to compile.
 * @param {VFile} file
 *   File associated with `tree`.
 * @returns {Result}
 *   New content: compiled text (`string` or `Uint8Array`, for `file.value`) or
 *   something else (for `file.result`).
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the parser yields (default: `Node`)
 * @callback Parser
 *   A **parser** handles the parsing of text to a syntax tree.
 *
 *   It is used in the parse phase and is called with a `string` and
 *   {@link VFile `VFile`} of the document to parse.
 *   It must return the syntax tree representation of the given file
 *   ({@link Node `Node`}).
 * @param {string} document
 *   Document to parse.
 * @param {VFile} file
 *   File associated with `document`.
 * @returns {Tree}
 *   Node representing the given file.
 */ /**
 * @typedef {(
 *   Plugin<Array<any>, any, any> |
 *   PluginTuple<Array<any>, any, any> |
 *   Preset
 * )} Pluggable
 *   Union of the different ways to add plugins and settings.
 */ /**
 * @typedef {Array<Pluggable>} PluggableList
 *   List of plugins and presets.
 */ // Note: we can’t use `callback` yet as it messes up `this`:
//  <https://github.com/microsoft/TypeScript/issues/55197>.
/**
 * @template {Array<unknown>} [PluginParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=Node]
 *   Value that is expected as input (default: `Node`).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be
 *       `string`.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be the
 *       node it expects.
 * @template [Output=Input]
 *   Value that is yielded as output (default: `Input`).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be
 *       result it yields.
 * @typedef {(
 *   (this: Processor, ...parameters: PluginParameters) =>
 *     Input extends string ? // Parser.
 *        Output extends Node | undefined ? undefined | void : never :
 *     Output extends CompileResults ? // Compiler.
 *        Input extends Node | undefined ? undefined | void : never :
 *     Transformer<
 *       Input extends Node ? Input : Node,
 *       Output extends Node ? Output : Node
 *     > | undefined | void
 * )} Plugin
 *   Single plugin.
 *
 *   Plugins configure the processors they are applied on in the following
 *   ways:
 *
 *   *   they change the processor, such as the parser, the compiler, or by
 *       configuring data
 *   *   they specify how to handle trees and files
 *
 *   In practice, they are functions that can receive options and configure the
 *   processor (`this`).
 *
 *   > 👉 **Note**: plugins are called when the processor is *frozen*, not when
 *   > they are applied.
 */ /**
 * Tuple of a plugin and its configuration.
 *
 * The first item is a plugin, the rest are its parameters.
 *
 * @template {Array<unknown>} [TupleParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=undefined]
 *   Value that is expected as input (optional).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be
 *       `string`.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be the
 *       node it expects.
 * @template [Output=undefined] (optional).
 *   Value that is yielded as output.
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be
 *       result it yields.
 * @typedef {(
 *   [
 *     plugin: Plugin<TupleParameters, Input, Output>,
 *     ...parameters: TupleParameters
 *   ]
 * )} PluginTuple
 */ /**
 * @typedef Preset
 *   Sharable configuration.
 *
 *   They can contain plugins and settings.
 * @property {PluggableList | undefined} [plugins]
 *   List of plugins and presets (optional).
 * @property {Settings | undefined} [settings]
 *   Shared settings for parsers and compilers (optional).
 */ /**
 * @template {VFile} [File=VFile]
 *   The file that the callback receives (default: `VFile`).
 * @callback ProcessCallback
 *   Callback called when the process is done.
 *
 *   Called with either an error or a result.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {File | undefined} [file]
 *   Processed file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Tree=Node]
 *   The tree that the callback receives (default: `Node`).
 * @callback RunCallback
 *   Callback called when transformers are done.
 *
 *   Called with either an error or results.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {Tree | undefined} [tree]
 *   Transformed tree (optional).
 * @param {VFile | undefined} [file]
 *   File (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Output=Node]
 *   Node type that the transformer yields (default: `Node`).
 * @callback TransformCallback
 *   Callback passed to transforms.
 *
 *   If the signature of a `transformer` accepts a third argument, the
 *   transformer may perform asynchronous operations, and must call it.
 * @param {Error | undefined} [error]
 *   Fatal error to stop the process (optional).
 * @param {Output | undefined} [tree]
 *   New, changed, tree (optional).
 * @param {VFile | undefined} [file]
 *   New, changed, file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Input=Node]
 *   Node type that the transformer expects (default: `Node`).
 * @template {Node} [Output=Input]
 *   Node type that the transformer yields (default: `Input`).
 * @callback Transformer
 *   Transformers handle syntax trees and files.
 *
 *   They are functions that are called each time a syntax tree and file are
 *   passed through the run phase.
 *   When an error occurs in them (either because it’s thrown, returned,
 *   rejected, or passed to `next`), the process stops.
 *
 *   The run phase is handled by [`trough`][trough], see its documentation for
 *   the exact semantics of these functions.
 *
 *   > 👉 **Note**: you should likely ignore `next`: don’t accept it.
 *   > it supports callback-style async work.
 *   > But promises are likely easier to reason about.
 *
 *   [trough]: https://github.com/wooorm/trough#function-fninput-next
 * @param {Input} tree
 *   Tree to handle.
 * @param {VFile} file
 *   File to handle.
 * @param {TransformCallback<Output>} next
 *   Callback.
 * @returns {(
 *   Promise<Output | undefined | void> |
 *   Promise<never> | // For some reason this is needed separately.
 *   Output |
 *   Error |
 *   undefined |
 *   void
 * )}
 *   If you accept `next`, nothing.
 *   Otherwise:
 *
 *   *   `Error` — fatal error to stop the process
 *   *   `Promise<undefined>` or `undefined` — the next transformer keeps using
 *       same tree
 *   *   `Promise<Node>` or `Node` — new, changed, tree
 */ /**
 * @template {Node | undefined} ParseTree
 *   Output of `parse`.
 * @template {Node | undefined} HeadTree
 *   Input for `run`.
 * @template {Node | undefined} TailTree
 *   Output for `run`.
 * @template {Node | undefined} CompileTree
 *   Input of `stringify`.
 * @template {CompileResults | undefined} CompileResult
 *   Output of `stringify`.
 * @template {Node | string | undefined} Input
 *   Input of plugin.
 * @template Output
 *   Output of plugin (optional).
 * @typedef {(
 *   Input extends string
 *     ? Output extends Node | undefined
 *       ? // Parser.
 *         Processor<
 *           Output extends undefined ? ParseTree : Output,
 *           HeadTree,
 *           TailTree,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Output extends CompileResults
 *     ? Input extends Node | undefined
 *       ? // Compiler.
 *         Processor<
 *           ParseTree,
 *           HeadTree,
 *           TailTree,
 *           Input extends undefined ? CompileTree : Input,
 *           Output extends undefined ? CompileResult : Output
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Input extends Node | undefined
 *     ? Output extends Node | undefined
 *       ? // Transform.
 *         Processor<
 *           ParseTree,
 *           HeadTree extends undefined ? Input : HeadTree,
 *           Output extends undefined ? TailTree : Output,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : // Unknown.
 *       Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 * )} UsePlugin
 *   Create a processor based on the input/output of a {@link Plugin plugin}.
 */ /**
 * @template {CompileResults | undefined} Result
 *   Node type that the transformer yields.
 * @typedef {(
 *   Result extends Value | undefined ?
 *     VFile :
 *     VFile & {result: Result}
 *   )} VFileWithOutput
 *   Type to generate a {@link VFile `VFile`} corresponding to a compiler result.
 *
 *   If a result that is not acceptable on a `VFile` is used, that will
 *   be stored on the `result` field of {@link VFile `VFile`}.
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $87d1dd4eb0f7386f$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}


var $c2b48272b756d53c$exports = {};
"use strict";
var $c2b48272b756d53c$var$hasOwn = Object.prototype.hasOwnProperty;
var $c2b48272b756d53c$var$toStr = Object.prototype.toString;
var $c2b48272b756d53c$var$defineProperty = Object.defineProperty;
var $c2b48272b756d53c$var$gOPD = Object.getOwnPropertyDescriptor;
var $c2b48272b756d53c$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $c2b48272b756d53c$var$toStr.call(arr) === "[object Array]";
};
var $c2b48272b756d53c$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $c2b48272b756d53c$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $c2b48272b756d53c$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $c2b48272b756d53c$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $c2b48272b756d53c$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $c2b48272b756d53c$var$setProperty = function setProperty(target, options) {
    if ($c2b48272b756d53c$var$defineProperty && options.name === "__proto__") $c2b48272b756d53c$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $c2b48272b756d53c$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$c2b48272b756d53c$var$hasOwn.call(obj, name)) return void 0;
        else if ($c2b48272b756d53c$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $c2b48272b756d53c$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$c2b48272b756d53c$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $c2b48272b756d53c$var$getProperty(target, name);
            copy = $c2b48272b756d53c$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($c2b48272b756d53c$var$isPlainObject(copy) || (copyIsArray = $c2b48272b756d53c$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $c2b48272b756d53c$var$isArray(src) ? src : [];
                    } else clone = src && $c2b48272b756d53c$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $c2b48272b756d53c$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $c2b48272b756d53c$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};



function $d0ddc93c59bf5825$export$2e2bcd8739ae039(value) {
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


/**
 * @typedef {(error?: Error|null|undefined, ...output: Array<any>) => void} Callback
 * @typedef {(...input: Array<any>) => any} Middleware
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add `fn` (middleware) to the list.
 * @typedef {{run: Run, use: Use}} Pipeline
 *   Middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 */ function $224eedccd5e938f5$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== "function") throw new TypeError("Expected function as last argument, not " + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error|null|undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $224eedccd5e938f5$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== "function") throw new TypeError("Expected `middelware` to be a function, not " + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $224eedccd5e938f5$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result instanceof Promise) result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 * @typedef {import('vfile-message').Options} MessageOptions
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {Options | URL | VFile | Value} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {string | null | undefined} [basename]
 *   Set `basename` (name).
 * @property {string | null | undefined} [cwd]
 *   Set `cwd` (working directory).
 * @property {Data | null | undefined} [data]
 *   Set `data` (associated info).
 * @property {string | null | undefined} [dirname]
 *   Set `dirname` (path w/o basename).
 * @property {string | null | undefined} [extname]
 *   Set `extname` (extension with dot).
 * @property {Array<string> | null | undefined} [history]
 *   Set `history` (paths the file moved between).
 * @property {URL | string | null | undefined} [path]
 *   Set `path` (current path).
 * @property {string | null | undefined} [stem]
 *   Set `stem` (name without extension).
 * @property {Value | null | undefined} [value]
 *   Set `value` (the contents of the file).
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/60adcb0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {Record<string, unknown> & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template [Settings=ReporterSettings]
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ 
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $2c2574e37a886a6b$export$bb654e07daaf8c3a = {
    basename: $2c2574e37a886a6b$var$basename,
    dirname: $2c2574e37a886a6b$var$dirname,
    extname: $2c2574e37a886a6b$var$extname,
    join: $2c2574e37a886a6b$var$join,
    sep: "/"
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | null | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $2c2574e37a886a6b$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $2c2574e37a886a6b$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.codePointAt(index) === ext.codePointAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $2c2574e37a886a6b$var$dirname(path) {
    $2c2574e37a886a6b$var$assertPath(path);
    if (path.length === 0) return ".";
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.codePointAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.codePointAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.codePointAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $2c2574e37a886a6b$var$extname(path) {
    $2c2574e37a886a6b$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.codePointAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $2c2574e37a886a6b$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $2c2574e37a886a6b$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + "/" + segments[index];
    }
    return joined === undefined ? "." : $2c2574e37a886a6b$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $2c2574e37a886a6b$var$normalize(path) {
    $2c2574e37a886a6b$var$assertPath(path);
    const absolute = path.codePointAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $2c2574e37a886a6b$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = ".";
    if (value.length > 0 && path.codePointAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $2c2574e37a886a6b$var$normalizeString(path, allowAboveRoot) {
    let result = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.codePointAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.codePointAt(result.length - 1) !== 46 /* `.` */  || result.codePointAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $2c2574e37a886a6b$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $53479f0f3ab6c50b$export$97a5aaf482767187 = {
    cwd: $53479f0f3ab6c50b$var$cwd
};
function $53479f0f3ab6c50b$var$cwd() {
    return "/";
}


/**
 * Checks if a value has the shape of a WHATWG URL object.
 *
 * Using a symbol or instanceof would not be able to recognize URL objects
 * coming from other implementations (e.g. in Electron), so instead we are
 * checking some well known properties for a lack of a better test.
 *
 * We use `href` and `protocol` as they are the only properties that are
 * easy to retrieve and calculate due to the lazy nature of the getters.
 *
 * We check for auth attribute to distinguish legacy url instance with
 * WHATWG URL instance.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js#L720>
function $167ae1eac1bd1fae$export$8304a22d431f958(fileUrlOrPath) {
    return Boolean(fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && "href" in fileUrlOrPath && fileUrlOrPath.href && "protocol" in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === undefined);
}


function $244d9f18a4831769$export$9b2b676c902de799(path) {
    if (typeof path === "string") path = new URL(path);
    else if (!(0, $167ae1eac1bd1fae$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + "`");
        error.code = "ERR_INVALID_ARG_TYPE";
        throw error;
    }
    if (path.protocol !== "file:") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError("The URL must be of scheme file");
        error.code = "ERR_INVALID_URL_SCHEME";
        throw error;
    }
    return $244d9f18a4831769$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $244d9f18a4831769$var$getPathFromURLPosix(url) {
    if (url.hostname !== "") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = "ERR_INVALID_FILE_URL_HOST";
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.codePointAt(index) === 37 /* `%` */  && pathname.codePointAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.codePointAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError("File URL path must not include encoded / characters");
            error.code = "ERR_INVALID_FILE_URL_PATH";
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 */ const $63f8f524359e772a$var$order = /** @type {const} */ [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
class $63f8f524359e772a$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if ((0, $167ae1eac1bd1fae$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else if (typeof value === "string" || $63f8f524359e772a$var$isUint8Array(value)) options = {
            value: value
        };
        else options = value;
        /* eslint-disable no-unused-expressions */ /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $53479f0f3ab6c50b$export$97a5aaf482767187).cwd();
        /**
     * Place to store custom info (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of file paths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $63f8f524359e772a$var$order.length){
            const prop = $63f8f524359e772a$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === "history" ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$63f8f524359e772a$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */ get basename() {
        return typeof this.path === "string" ? (0, $2c2574e37a886a6b$export$bb654e07daaf8c3a).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */ set basename(basename) {
        $63f8f524359e772a$var$assertNonEmpty(basename, "basename");
        $63f8f524359e772a$var$assertPart(basename, "basename");
        this.path = (0, $2c2574e37a886a6b$export$bb654e07daaf8c3a).join(this.dirname || "", basename);
    }
    /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */ get dirname() {
        return typeof this.path === "string" ? (0, $2c2574e37a886a6b$export$bb654e07daaf8c3a).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */ set dirname(dirname) {
        $63f8f524359e772a$var$assertPath(this.basename, "dirname");
        this.path = (0, $2c2574e37a886a6b$export$bb654e07daaf8c3a).join(dirname || "", this.basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */ get extname() {
        return typeof this.path === "string" ? (0, $2c2574e37a886a6b$export$bb654e07daaf8c3a).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */ set extname(extname) {
        $63f8f524359e772a$var$assertPart(extname, "extname");
        $63f8f524359e772a$var$assertPath(this.dirname, "extname");
        if (extname) {
            if (extname.codePointAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
            if (extname.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = (0, $2c2574e37a886a6b$export$bb654e07daaf8c3a).join(this.dirname, this.stem + (extname || ""));
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */ set path(path) {
        if ((0, $167ae1eac1bd1fae$export$8304a22d431f958)(path)) path = (0, $244d9f18a4831769$export$9b2b676c902de799)(path);
        $63f8f524359e772a$var$assertNonEmpty(path, "path");
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */ get stem() {
        return typeof this.path === "string" ? (0, $2c2574e37a886a6b$export$bb654e07daaf8c3a).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */ set stem(stem) {
        $63f8f524359e772a$var$assertNonEmpty(stem, "stem");
        $63f8f524359e772a$var$assertPart(stem, "stem");
        this.path = (0, $2c2574e37a886a6b$export$bb654e07daaf8c3a).join(this.dirname || "", stem + (this.extname || ""));
    }
    // Normal prototypal methods.
    /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */ fail(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = true;
        throw message;
    }
    /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = undefined;
        return message;
    }
    /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(causeOrReason, optionsOrParentOrPlace, origin) {
        const message = new (0, $480e2cf54697d41d$export$752e5c445fe834ef)(// @ts-expect-error: the overloads are fine.
        causeOrReason, optionsOrParentOrPlace, origin);
        if (this.path) {
            message.name = this.path + ":" + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        if (this.value === undefined) return "";
        if (typeof this.value === "string") return this.value;
        const decoder = new TextDecoder(encoding || undefined);
        return decoder.decode(this.value);
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {undefined}
 *   Nothing.
 */ function $63f8f524359e772a$var$assertPart(part, name) {
    if (part && part.includes((0, $2c2574e37a886a6b$export$bb654e07daaf8c3a).sep)) throw new Error("`" + name + "` cannot be a path: did not expect `" + (0, $2c2574e37a886a6b$export$bb654e07daaf8c3a).sep + "`");
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $63f8f524359e772a$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $63f8f524359e772a$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $63f8f524359e772a$var$isUint8Array(value) {
    return Boolean(value && typeof value === "object" && "byteLength" in value && "byteOffset" in value);
}


const $edfa1fb7fbf8d26e$export$b7de1db558410812 = /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */ /** @type {unknown} */ /**
       * @this {Function}
       * @param {string | symbol} property
       * @returns {(...parameters: Array<unknown>) => unknown}
       */ function(property) {
    const self = this;
    const constr = self.constructor;
    const proto = /** @type {Record<string | symbol, Function>} */ // Prototypes do exist.
    // type-coverage:ignore-next-line
    constr.prototype;
    const func = proto[property];
    /** @type {(...parameters: Array<unknown>) => unknown} */ const apply = function() {
        return func.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    const names = Object.getOwnPropertyNames(func);
    for (const p of names){
        const descriptor = Object.getOwnPropertyDescriptor(func, p);
        if (descriptor) Object.defineProperty(apply, p, descriptor);
    }
    return apply;
};


// To do: next major: drop `Compiler`, `Parser`: prefer lowercase.
// To do: we could start yielding `never` in TS when a parser is missing and
// `parse` is called.
// Currently, we allow directly setting `processor.parser`, which is untyped.
const $548fca1143d17b1d$var$own = {}.hasOwnProperty;
class $548fca1143d17b1d$export$c30cd198d731db19 extends (0, $edfa1fb7fbf8d26e$export$b7de1db558410812) {
    /**
   * Create a processor.
   */ constructor(){
        // If `Processor()` is called (w/o new), `copy` is called instead.
        super("copy");
        /**
     * Compiler to use (deprecated).
     *
     * @deprecated
     *   Use `compiler` instead.
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.Compiler = undefined;
        /**
     * Parser to use (deprecated).
     *
     * @deprecated
     *   Use `parser` instead.
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.Parser = undefined;
        // Note: the following fields are considered private.
        // However, they are needed for tests, and TSC generates an untyped
        // `private freezeIndex` field for, which trips `type-coverage` up.
        // Instead, we use `@deprecated` to visualize that they shouldn’t be used.
        /**
     * Internal list of configured plugins.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Array<PluginTuple<Array<unknown>>>}
     */ this.attachers = [];
        /**
     * Compiler to use.
     *
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.compiler = undefined;
        /**
     * Internal state to track where we are while freezing.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {number}
     */ this.freezeIndex = -1;
        /**
     * Internal state to track whether we’re frozen.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {boolean | undefined}
     */ this.frozen = undefined;
        /**
     * Internal state.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Data}
     */ this.namespace = {};
        /**
     * Parser to use.
     *
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.parser = undefined;
        /**
     * Internal list of configured transformers.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Pipeline}
     */ this.transformers = (0, $224eedccd5e938f5$export$91b56f5ca106aa43)();
    }
    /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@link Processor `Processor`}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */ copy() {
        // Cast as the type parameters will be the same after attaching.
        const destination = /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */ new $548fca1143d17b1d$export$c30cd198d731db19();
        let index = -1;
        while(++index < this.attachers.length){
            const attacher = this.attachers[index];
            destination.use(...attacher);
        }
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($c2b48272b756d53c$exports)))(true, {}, this.namespace));
        return destination;
    }
    /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > 👉 **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > 👉 **Note**: to register custom data in TypeScript, augment the
   * > {@link Data `Data`} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */ data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $548fca1143d17b1d$var$assertUnfrozen("data", this.frozen);
                this.namespace[key] = value;
                return this;
            }
            // Get `key`.
            return $548fca1143d17b1d$var$own.call(this.namespace, key) && this.namespace[key] || undefined;
        }
        // Set space.
        if (key) {
            $548fca1143d17b1d$var$assertUnfrozen("data", this.frozen);
            this.namespace = key;
            return this;
        }
        // Get space.
        return this.namespace;
    }
    /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */ freeze() {
        if (this.frozen) return this;
        // Cast so that we can type plugins easier.
        // Plugins are supposed to be usable on different processors, not just on
        // this exact processor.
        const self = /** @type {Processor} */ /** @type {unknown} */ this;
        while(++this.freezeIndex < this.attachers.length){
            const [attacher, ...options] = this.attachers[this.freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            const transformer = attacher.call(self, ...options);
            if (typeof transformer === "function") this.transformers.use(transformer);
        }
        this.frozen = true;
        this.freezeIndex = Number.POSITIVE_INFINITY;
        return this;
    }
    /**
   * Parse text to a syntax tree.
   *
   * > 👉 **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */ parse(file) {
        this.freeze();
        const realFile = $548fca1143d17b1d$var$vfile(file);
        const parser = this.parser || this.Parser;
        $548fca1143d17b1d$var$assertParser("parse", parser);
        return parser(String(realFile), realFile);
    }
    /**
   * Process the given file as configured on the processor.
   *
   * > 👉 **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ process(file, done) {
        const self = this;
        this.freeze();
        $548fca1143d17b1d$var$assertParser("process", this.parser || this.Parser);
        $548fca1143d17b1d$var$assertCompiler("process", this.compiler || this.Compiler);
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {((file: VFileWithOutput<CompileResult>) => undefined | void) | undefined} resolve
     * @param {(error: Error | undefined) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            const realFile = $548fca1143d17b1d$var$vfile(file);
            // Assume `ParseTree` (the result of the parser) matches `HeadTree` (the
            // input of the first transform).
            const parseTree = /** @type {HeadTree extends undefined ? Node : HeadTree} */ /** @type {unknown} */ self.parse(realFile);
            self.run(parseTree, realFile, function(error, tree, file) {
                if (error || !tree || !file) return realDone(error);
                // Assume `TailTree` (the output of the last transform) matches
                // `CompileTree` (the input of the compiler).
                const compileTree = /** @type {CompileTree extends undefined ? Node : CompileTree} */ /** @type {unknown} */ tree;
                const compileResult = self.stringify(compileTree, file);
                if ($548fca1143d17b1d$var$looksLikeAValue(compileResult)) file.value = compileResult;
                else file.result = compileResult;
                realDone(error, /** @type {VFileWithOutput<CompileResult>} */ file);
            });
            /**
       * @param {Error | undefined} error
       * @param {VFileWithOutput<CompileResult> | undefined} [file]
       * @returns {undefined}
       */ function realDone(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else {
                    (0, $5875a1670b965514$export$dcb8b3f0e2de7e49)(done, "`done` is defined if `resolve` is not");
                    done(undefined, file);
                }
            }
        }
    }
    /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ processSync(file) {
        /** @type {boolean} */ let complete = false;
        /** @type {VFileWithOutput<CompileResult> | undefined} */ let result;
        this.freeze();
        $548fca1143d17b1d$var$assertParser("processSync", this.parser || this.Parser);
        $548fca1143d17b1d$var$assertCompiler("processSync", this.compiler || this.Compiler);
        this.process(file, realDone);
        $548fca1143d17b1d$var$assertDone("processSync", "process", complete);
        (0, $5875a1670b965514$export$dcb8b3f0e2de7e49)(result, "we either bailed on an error or have a tree");
        return result;
        /**
     * @type {ProcessCallback<VFileWithOutput<CompileResult>>}
     */ function realDone(error, file) {
            complete = true;
            (0, $87d1dd4eb0f7386f$export$dd911e13ecb11e05)(error);
            result = file;
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * > 👉 **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */ run(tree, file, done) {
        $548fca1143d17b1d$var$assertNode(tree);
        this.freeze();
        const transformers = this.transformers;
        if (!done && typeof file === "function") {
            done = file;
            file = undefined;
        }
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {(
     *   ((tree: TailTree extends undefined ? Node : TailTree) => undefined | void) |
     *   undefined
     * )} resolve
     * @param {(error: Error) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            (0, $5875a1670b965514$export$dcb8b3f0e2de7e49)(typeof file !== "function", "`file` can\u2019t be a `done` anymore, we checked");
            const realFile = $548fca1143d17b1d$var$vfile(file);
            transformers.run(tree, realFile, realDone);
            /**
       * @param {Error | undefined} error
       * @param {Node} outputTree
       * @param {VFile} file
       * @returns {undefined}
       */ function realDone(error, outputTree, file) {
                const resultingTree = /** @type {TailTree extends undefined ? Node : TailTree} */ outputTree || tree;
                if (error) reject(error);
                else if (resolve) resolve(resultingTree);
                else {
                    (0, $5875a1670b965514$export$dcb8b3f0e2de7e49)(done, "`done` is defined if `resolve` is not");
                    done(undefined, resultingTree, file);
                }
            }
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */ runSync(tree, file) {
        /** @type {boolean} */ let complete = false;
        /** @type {(TailTree extends undefined ? Node : TailTree) | undefined} */ let result;
        this.run(tree, file, realDone);
        $548fca1143d17b1d$var$assertDone("runSync", "run", complete);
        (0, $5875a1670b965514$export$dcb8b3f0e2de7e49)(result, "we either bailed on an error or have a tree");
        return result;
        /**
     * @type {RunCallback<TailTree extends undefined ? Node : TailTree>}
     */ function realDone(error, tree) {
            (0, $87d1dd4eb0f7386f$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * Compile a syntax tree.
   *
   * > 👉 **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ stringify(tree, file) {
        this.freeze();
        const realFile = $548fca1143d17b1d$var$vfile(file);
        const compiler = this.compiler || this.Compiler;
        $548fca1143d17b1d$var$assertCompiler("stringify", compiler);
        $548fca1143d17b1d$var$assertNode(tree);
        return compiler(tree, realFile);
    }
    /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > 👉 **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */ use(value, ...parameters) {
        const attachers = this.attachers;
        const namespace = this.namespace;
        $548fca1143d17b1d$var$assertUnfrozen("use", this.frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin(value, parameters);
        else if (typeof value === "object") {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError("Expected usable value, not `" + value + "`");
        return this;
        /**
     * @param {Pluggable} value
     * @returns {undefined}
     */ function add(value) {
            if (typeof value === "function") addPlugin(value, []);
            else if (typeof value === "object") {
                if (Array.isArray(value)) {
                    const [plugin, ...parameters] = /** @type {PluginTuple<Array<unknown>>} */ value;
                    addPlugin(plugin, parameters);
                } else addPreset(value);
            } else throw new TypeError("Expected usable value, not `" + value + "`");
        }
        /**
     * @param {Preset} result
     * @returns {undefined}
     */ function addPreset(result) {
            if (!("plugins" in result) && !("settings" in result)) throw new Error("Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither");
            addList(result.plugins);
            if (result.settings) namespace.settings = (0, (/*@__PURE__*/$parcel$interopDefault($c2b48272b756d53c$exports)))(true, namespace.settings, result.settings);
        }
        /**
     * @param {PluggableList | null | undefined} plugins
     * @returns {undefined}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
        }
        /**
     * @param {Plugin} plugin
     * @param {Array<unknown>} parameters
     * @returns {undefined}
     */ function addPlugin(plugin, parameters) {
            let index = -1;
            let entryIndex = -1;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entryIndex = index;
                break;
            }
            if (entryIndex === -1) attachers.push([
                plugin,
                ...parameters
            ]);
            else if (parameters.length > 0) {
                let [primary, ...rest] = parameters;
                const currentPrimary = attachers[entryIndex][1];
                if ((0, $d0ddc93c59bf5825$export$2e2bcd8739ae039)(currentPrimary) && (0, $d0ddc93c59bf5825$export$2e2bcd8739ae039)(primary)) primary = (0, (/*@__PURE__*/$parcel$interopDefault($c2b48272b756d53c$exports)))(true, currentPrimary, primary);
                attachers[entryIndex] = [
                    plugin,
                    primary,
                    ...rest
                ];
            }
        }
    }
}
const $548fca1143d17b1d$export$7cc1b2fe10c52bb = new $548fca1143d17b1d$export$c30cd198d731db19().freeze();
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $548fca1143d17b1d$var$assertParser(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `parser`");
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $548fca1143d17b1d$var$assertCompiler(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `compiler`");
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $548fca1143d17b1d$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot call `" + name + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $548fca1143d17b1d$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $d0ddc93c59bf5825$export$2e2bcd8739ae039)(node) || typeof node.type !== "string") throw new TypeError("Expected node, got `" + node + "`");
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $548fca1143d17b1d$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {VFile}
 */ function $548fca1143d17b1d$var$vfile(value) {
    return $548fca1143d17b1d$var$looksLikeAVFile(value) ? value : new (0, $63f8f524359e772a$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {value is VFile}
 */ function $548fca1143d17b1d$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === "object" && "message" in value && "messages" in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is Value}
 */ function $548fca1143d17b1d$var$looksLikeAValue(value) {
    return typeof value === "string" || $548fca1143d17b1d$var$isUint8Array(value);
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $548fca1143d17b1d$var$isUint8Array(value) {
    return Boolean(value && typeof value === "object" && "byteLength" in value && "byteOffset" in value);
}




const $565501693a7c6ee6$var$changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
/** @type {PluggableList} */ const $565501693a7c6ee6$var$emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */ const $565501693a7c6ee6$var$emptyRemarkRehypeOptions = {
    allowDangerousHtml: true
};
const $565501693a7c6ee6$var$safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */ const $565501693a7c6ee6$var$deprecations = [
    {
        from: "astPlugins",
        id: "remove-buggy-html-in-markdown-parser"
    },
    {
        from: "allowDangerousHtml",
        id: "remove-buggy-html-in-markdown-parser"
    },
    {
        from: "allowNode",
        id: "replace-allownode-allowedtypes-and-disallowedtypes",
        to: "allowElement"
    },
    {
        from: "allowedTypes",
        id: "replace-allownode-allowedtypes-and-disallowedtypes",
        to: "allowedElements"
    },
    {
        from: "disallowedTypes",
        id: "replace-allownode-allowedtypes-and-disallowedtypes",
        to: "disallowedElements"
    },
    {
        from: "escapeHtml",
        id: "remove-buggy-html-in-markdown-parser"
    },
    {
        from: "includeElementIndex",
        id: "#remove-includeelementindex"
    },
    {
        from: "includeNodeIndex",
        id: "change-includenodeindex-to-includeelementindex"
    },
    {
        from: "linkTarget",
        id: "remove-linktarget"
    },
    {
        from: "plugins",
        id: "change-plugins-to-remarkplugins",
        to: "remarkPlugins"
    },
    {
        from: "rawSourcePos",
        id: "#remove-rawsourcepos"
    },
    {
        from: "renderers",
        id: "change-renderers-to-components",
        to: "components"
    },
    {
        from: "source",
        id: "change-source-to-children",
        to: "children"
    },
    {
        from: "sourcePos",
        id: "#remove-sourcepos"
    },
    {
        from: "transformImageUri",
        id: "#add-urltransform",
        to: "urlTransform"
    },
    {
        from: "transformLinkUri",
        id: "#add-urltransform",
        to: "urlTransform"
    }
];
function $565501693a7c6ee6$export$7460c8b7e4ce9582(options) {
    const allowedElements = options.allowedElements;
    const allowElement = options.allowElement;
    const children = options.children || "";
    const className = options.className;
    const components = options.components;
    const disallowedElements = options.disallowedElements;
    const rehypePlugins = options.rehypePlugins || $565501693a7c6ee6$var$emptyPlugins;
    const remarkPlugins = options.remarkPlugins || $565501693a7c6ee6$var$emptyPlugins;
    const remarkRehypeOptions = options.remarkRehypeOptions ? {
        ...options.remarkRehypeOptions,
        ...$565501693a7c6ee6$var$emptyRemarkRehypeOptions
    } : $565501693a7c6ee6$var$emptyRemarkRehypeOptions;
    const skipHtml = options.skipHtml;
    const unwrapDisallowed = options.unwrapDisallowed;
    const urlTransform = options.urlTransform || $565501693a7c6ee6$export$ca5e94754123e2f3;
    const processor = (0, $548fca1143d17b1d$export$7cc1b2fe10c52bb)().use((0, $dd4e018775450ff7$export$2e2bcd8739ae039)).use(remarkPlugins).use((0, $7c8a298979572166$export$2e2bcd8739ae039), remarkRehypeOptions).use(rehypePlugins);
    const file = new (0, $63f8f524359e772a$export$93dff69eb10dc7ce)();
    if (typeof children === "string") file.value = children;
    else (0, $5875a1670b965514$export$565e9d9bd6b6e0d4)("Unexpected value `" + children + "` for `children` prop, expected `string`");
    if (allowedElements && disallowedElements) (0, $5875a1670b965514$export$565e9d9bd6b6e0d4)("Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other");
    for (const deprecation of $565501693a7c6ee6$var$deprecations)if (Object.hasOwn(options, deprecation.from)) (0, $5875a1670b965514$export$565e9d9bd6b6e0d4)("Unexpected `" + deprecation.from + "` prop, " + (deprecation.to ? "use `" + deprecation.to + "` instead" : "remove it") + " (see <" + $565501693a7c6ee6$var$changelog + "#" + deprecation.id + "> for more info)");
    const mdastTree = processor.parse(file);
    /** @type {Nodes} */ let hastTree = processor.runSync(mdastTree, file);
    // Wrap in `div` if there’s a class name.
    if (className) hastTree = {
        type: "element",
        tagName: "div",
        properties: {
            className: className
        },
        // Assume no doctypes.
        children: /** @type {Array<ElementContent>} */ hastTree.type === "root" ? hastTree.children : [
            hastTree
        ]
    };
    (0, $493950d893275058$export$bf638b60ea8b89b7)(hastTree, transform);
    return (0, $fe1d66ce7da7f6a7$export$59c10052b2dee561)(hastTree, {
        Fragment: $6dd45a7735069a79$exports.Fragment,
        components: components,
        ignoreInvalidStyle: true,
        jsx: $6dd45a7735069a79$exports.jsx,
        jsxs: $6dd45a7735069a79$exports.jsxs,
        passKeys: true,
        passNode: true
    });
    /** @type {Visitor} */ function transform(node, index, parent) {
        if (node.type === "raw" && parent && typeof index === "number") {
            if (skipHtml) parent.children.splice(index, 1);
            else parent.children[index] = {
                type: "text",
                value: node.value
            };
            return index;
        }
        if (node.type === "element") {
            /** @type {string} */ let key;
            for(key in 0, $737e11ed1c2fa8be$export$de3e062aedff083a)if (Object.hasOwn((0, $737e11ed1c2fa8be$export$de3e062aedff083a), key) && Object.hasOwn(node.properties, key)) {
                const value = node.properties[key];
                const test = (0, $737e11ed1c2fa8be$export$de3e062aedff083a)[key];
                if (test === null || test.includes(node.tagName)) node.properties[key] = urlTransform(String(value || ""), key, node);
            }
        }
        if (node.type === "element") {
            let remove = allowedElements ? !allowedElements.includes(node.tagName) : disallowedElements ? disallowedElements.includes(node.tagName) : false;
            if (!remove && allowElement && typeof index === "number") remove = !allowElement(node, index, parent);
            if (remove && parent && typeof index === "number") {
                if (unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
        }
    }
}
function $565501693a7c6ee6$export$ca5e94754123e2f3(value) {
    // Same as:
    // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
    // But without the `encode` part.
    const colon = value.indexOf(":");
    const questionMark = value.indexOf("?");
    const numberSign = value.indexOf("#");
    const slash = value.indexOf("/");
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    $565501693a7c6ee6$var$safeProtocol.test(value.slice(0, colon))) return value;
    return "";
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-is-element').Test} Test
 */ /**
 * @callback CreateContent
 *   Create a target for the element.
 * @param {Element} element
 *   Element to check.
 * @returns {Array<ElementContent> | ElementContent | null | undefined}
 *   Content to add.
 *
 * @callback CreateProperties
 *   Create properties for an element.
 * @param {Element} element
 *   Element to check.
 * @returns {Properties | null | undefined}
 *   Properties to add.
 *
 * @callback CreateRel
 *   Create a `rel` for the element.
 * @param {Element} element
 *   Element to check.
 * @returns {Array<string> | string | null | undefined}
 *   `rel` to use.
 *
 * @callback CreateTarget
 *   Create a `target` for the element.
 * @param {Element} element
 *   Element to check.
 * @returns {Target | null | undefined}
 *   `target` to use.
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<ElementContent> | CreateContent | ElementContent | null | undefined} [content]
 *   Content to insert at the end of external links (optional); will be
 *   inserted in a `<span>` element; useful for improving accessibility by
 *   giving users advanced warning when opening a new window.
 * @property {CreateProperties | Properties | null | undefined} [contentProperties]
 *   Properties to add to the `span` wrapping `content` (optional).
 * @property {CreateProperties | Properties | null | undefined} [properties]
 *   Properties to add to the link itself (optional).
 * @property {Array<string> | null | undefined} [protocols=['http', 'https']]
 *   Protocols to check, such as `mailto` or `tel` (default: `['http',
 *   'https']`).
 * @property {Array<string> | CreateRel | string | null | undefined} [rel=['nofollow']]
 *   Link types to hint about the referenced documents (default:
 *   `['nofollow']`); pass an empty array (`[]`) to not set `rel`s on links;
 *   when using a `target`, add `noopener` and `noreferrer` to avoid
 *   exploitation of the `window.opener` API.
 * @property {CreateTarget | Target | null | undefined} [target]
 *   How to display referenced documents; the default (nothing) is to not set
 *   `target`s on links.
 * @property {Test | null | undefined} [test]
 *   Extra test to define which external link elements are modified (optional);
 *   any test that can be given to `hast-util-is-element` is supported.
 *
 * @typedef {'_blank' | '_parent' | '_self' | '_top'} Target
 *   Target.
 */ 
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Parents} Parents
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is an element.
 * @param {unknown} this
 *   Context object (`this`) to call `test` with
 * @param {unknown} [element]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   Position of `element` in its parent.
 * @param {Parents | null | undefined} [parent]
 *   Parent of `element`.
 * @returns {boolean}
 *   Whether this is an element and passes a test.
 *
 * @typedef {Array<TestFunction | string> | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary element.
 *
 *   * when `string`, checks that the element has that tag name
 *   * when `function`, see `TestFunction`
 *   * when `Array`, checks if one of the subtests pass
 *
 * @callback TestFunction
 *   Check if an element passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Element} element
 *   An element.
 * @param {number | undefined} [index]
 *   Position of `element` in its parent.
 * @param {Parents | undefined} [parent]
 *   Parent of `element`.
 * @returns {boolean | undefined | void}
 *   Whether this element passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `element` is an `Element` and whether it passes the given test.
 *
 * @param element
 *   Thing to check, typically `element`.
 * @param test
 *   Check for a specific element.
 * @param index
 *   Position of `element` in its parent.
 * @param parent
 *   Parent of `element`.
 * @param context
 *   Context object (`this`) to call `test` with.
 * @returns
 *   Whether `element` is an `Element` and passes a test.
 * @throws
 *   When an incorrect `test`, `index`, or `parent` is given; there is no error
 *   thrown when `element` is not a node or not an element.
 */ const $59599c10941e40af$export$45a5e7f76e0caa8d = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends TestFunction>(element: unknown, test: Condition, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & Predicate<Condition, Element>) &
   *   (<Condition extends string>(element: unknown, test: Condition, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & {tagName: Condition}) &
   *   ((element?: null | undefined) => false) &
   *   ((element: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element) &
   *   ((element: unknown, test?: Test, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [element]
     * @param {Test | undefined} [test]
     * @param {number | null | undefined} [index]
     * @param {Parents | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(element, test, index, parent, context) {
    const check = $59599c10941e40af$export$26aad476166fd89e(test);
    if (index !== null && index !== undefined && (typeof index !== "number" || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite `index`");
    if (parent !== null && parent !== undefined && (!parent.type || !parent.children)) throw new Error("Expected valid `parent`");
    if ((index === null || index === undefined) !== (parent === null || parent === undefined)) throw new Error("Expected both `index` and `parent`");
    return $59599c10941e40af$var$looksLikeAnElement(element) ? check.call(context, element, index, parent) : false;
};
const $59599c10941e40af$export$26aad476166fd89e = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends TestFunction>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & Predicate<Condition, Element>) &
   *   (<Condition extends string>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & {tagName: Condition}) &
   *   ((test?: null | undefined) => (element?: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test | null | undefined} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $59599c10941e40af$var$element;
    if (typeof test === "string") return $59599c10941e40af$var$tagNameFactory(test);
    // Assume array.
    if (typeof test === "object") return $59599c10941e40af$var$anyFactory(test);
    if (typeof test === "function") return $59599c10941e40af$var$castFactory(test);
    throw new Error("Expected function, string, or array as `test`");
};
/**
 * Handle multiple tests.
 *
 * @param {Array<TestFunction | string>} tests
 * @returns {Check}
 */ function $59599c10941e40af$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $59599c10941e40af$export$26aad476166fd89e(tests[index]);
    return $59599c10941e40af$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn a string into a test for an element with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $59599c10941e40af$var$tagNameFactory(check) {
    return $59599c10941e40af$var$castFactory(tagName);
    /**
   * @param {Element} element
   * @returns {boolean}
   */ function tagName(element) {
        return element.tagName === check;
    }
}
/**
 * Turn a custom test into a test for an element that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $59599c10941e40af$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($59599c10941e40af$var$looksLikeAnElement(value) && testFunction.call(this, value, typeof index === "number" ? index : undefined, parent || undefined));
    }
}
/**
 * Make sure something is an element.
 *
 * @param {unknown} element
 * @returns {element is Element}
 */ function $59599c10941e40af$var$element(element) {
    return Boolean(element && typeof element === "object" && "type" in element && element.type === "element" && "tagName" in element && typeof element.tagName === "string");
}
/**
 * @param {unknown} value
 * @returns {value is Element}
 */ function $59599c10941e40af$var$looksLikeAnElement(value) {
    return value !== null && typeof value === "object" && "type" in value && "tagName" in value;
}


// Scheme: https://tools.ietf.org/html/rfc3986#section-3.1
// Absolute URL: https://tools.ietf.org/html/rfc3986#section-4.3
const $14182b7f5848af5c$var$ABSOLUTE_URL_REGEX = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/;
// Windows paths like `c:\`
const $14182b7f5848af5c$var$WINDOWS_PATH_REGEX = /^[a-zA-Z]:\\/;
function $14182b7f5848af5c$export$2e2bcd8739ae039(url) {
    if (typeof url !== "string") throw new TypeError(`Expected a \`string\`, got \`${typeof url}\``);
    if ($14182b7f5848af5c$var$WINDOWS_PATH_REGEX.test(url)) return false;
    return $14182b7f5848af5c$var$ABSOLUTE_URL_REGEX.test(url);
}




const $fc5c74b62a0ad7be$var$defaultProtocols = [
    "http",
    "https"
];
const $fc5c74b62a0ad7be$var$defaultRel = [
    "nofollow"
];
/** @type {Options} */ const $fc5c74b62a0ad7be$var$emptyOptions = {};
function $fc5c74b62a0ad7be$export$2e2bcd8739ae039(options) {
    const settings = options || $fc5c74b62a0ad7be$var$emptyOptions;
    const protocols = settings.protocols || $fc5c74b62a0ad7be$var$defaultProtocols;
    const is = (0, $59599c10941e40af$export$26aad476166fd89e)(settings.test);
    /**
   * Transform.
   *
   * @param {Root} tree
   *   Tree.
   * @returns {undefined}
   *   Nothing.
   */ return function(tree) {
        (0, $493950d893275058$export$bf638b60ea8b89b7)(tree, "element", function(node, index, parent) {
            if (node.tagName === "a" && typeof node.properties.href === "string" && is(node, index, parent)) {
                const url = node.properties.href;
                if ((0, $14182b7f5848af5c$export$2e2bcd8739ae039)(url) ? protocols.includes(url.slice(0, url.indexOf(":"))) : url.startsWith("//")) {
                    const contentRaw = $fc5c74b62a0ad7be$var$createIfNeeded(settings.content, node);
                    const content = contentRaw && !Array.isArray(contentRaw) ? [
                        contentRaw
                    ] : contentRaw;
                    const relRaw = $fc5c74b62a0ad7be$var$createIfNeeded(settings.rel, node) || $fc5c74b62a0ad7be$var$defaultRel;
                    const rel = typeof relRaw === "string" ? (0, $fab9e1f1a10b7278$export$98e6a39c04603d36)(relRaw) : relRaw;
                    const target = $fc5c74b62a0ad7be$var$createIfNeeded(settings.target, node);
                    const properties = $fc5c74b62a0ad7be$var$createIfNeeded(settings.properties, node);
                    if (properties) Object.assign(node.properties, (0, $3573a2413dd5feeb$export$2e2bcd8739ae039)(properties));
                    if (rel.length > 0) node.properties.rel = [
                        ...rel
                    ];
                    if (target) node.properties.target = target;
                    if (content) {
                        const properties = $fc5c74b62a0ad7be$var$createIfNeeded(settings.contentProperties, node) || {};
                        node.children.push({
                            type: "element",
                            tagName: "span",
                            properties: (0, $3573a2413dd5feeb$export$2e2bcd8739ae039)(properties),
                            children: (0, $3573a2413dd5feeb$export$2e2bcd8739ae039)(content)
                        });
                    }
                }
            }
        });
    };
}
/**
 * Call a function to get a return value or use the value.
 *
 * @template T
 *   Type of value.
 * @param {T} value
 *   Value.
 * @param {Element} element
 *   Element.
 * @returns {T extends Function ? ReturnType<T> : T}
 *   Result.
 */ function $fc5c74b62a0ad7be$var$createIfNeeded(value, element) {
    return typeof value === "function" ? value(element) : value;
}






const $f31a521fa07acd33$var$TRANSITION_DURATION = 250;
const $f31a521fa07acd33$var$DEFAULT_STYLE = {
    opacity: 0,
    transformOrigin: "50% 0",
    transform: "rotateX(20deg) translateY(100px)",
    transition: `opacity ${$f31a521fa07acd33$var$TRANSITION_DURATION}ms, transform ${$f31a521fa07acd33$var$TRANSITION_DURATION}ms`
};
const $f31a521fa07acd33$var$TRANSITION_STYLES = {
    entering: {
        opacity: 1,
        transform: "none"
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
$f31a521fa07acd33$var$DescriptionPanel.propTypes = {
    visible: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    image: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    content: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    caption: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    onClickHide: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    bubbleY: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    offline: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool
};
function $f31a521fa07acd33$var$DescriptionPanel({ visible: visible = false, image: image, content: content, caption: caption, onClickHide: onClickHide = ()=>{}, bubbleY: bubbleY, offline: offline = false }) {
    const [highlightTriangle, setHighlightTriangle] = (0, $4DE7A.useState)(false);
    function unhighlightTriangleDelayed() {
        window.setTimeout(()=>{
            setHighlightTriangle(false);
        }, 200);
    }
    function handleToggleHighlightTriangle() {
        setHighlightTriangle(!highlightTriangle);
    }
    function handleClickHide(event) {
        onClickHide();
        unhighlightTriangleDelayed();
    }
    // TODO document magic numbers
    const height = (0, $7e17dc93f2b84ce7$export$8734426d8f1593a2)() + 300 - bubbleY + "px";
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $0bbe1d2d2979a273$export$2e2bcd8739ae039), {
        in: visible,
        timeout: $f31a521fa07acd33$var$TRANSITION_DURATION,
        children: (state)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "description-canvas",
                style: {
                    ...$f31a521fa07acd33$var$DEFAULT_STYLE,
                    ...$f31a521fa07acd33$var$TRANSITION_STYLES[state],
                    height: height
                },
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "description",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                            className: "description-content",
                            children: [
                                image && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                                    src: `/images/info-bubble-examples/${image}`,
                                    alt: caption || ""
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                    className: "description-text",
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $565501693a7c6ee6$export$7460c8b7e4ce9582), {
                                            allowedElements: [
                                                "p",
                                                "em",
                                                "strong",
                                                "ol",
                                                "ul",
                                                "li",
                                                "blockquote",
                                                "h1",
                                                !offline && "a"
                                            ],
                                            unwrapDisallowed: true,
                                            rehypePlugins: [
                                                [
                                                    (0, $fc5c74b62a0ad7be$export$2e2bcd8739ae039),
                                                    {
                                                        rel: "noopener noreferrer",
                                                        target: "_blank"
                                                    }
                                                ]
                                            ],
                                            children: content
                                        }),
                                        caption && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("footer", {
                                            children: [
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "segments.description.photo-credit",
                                                    defaultMessage: "Photo:"
                                                }),
                                                "\xa0",
                                                caption
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "description-close",
                        onClick: handleClickHide,
                        onMouseOver: handleToggleHighlightTriangle,
                        onMouseOut: handleToggleHighlightTriangle,
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "btn.close",
                            defaultMessage: "Close"
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $c2dd87b9410638e7$export$2e2bcd8739ae039), {
                        highlight: highlightTriangle
                    })
                ]
            })
    });
}
var $f31a521fa07acd33$export$2e2bcd8739ae039 = $f31a521fa07acd33$var$DescriptionPanel;


function $933a148ff2d63bda$var$getDescriptionData(type, variantString) {
    if (!type) return null;
    const segmentInfo = (0, $0cc5ae9f1eba4866$export$c3985e6b9763d4c2)(type);
    const variantInfo = (0, $0cc5ae9f1eba4866$export$a7e4a724089e6511)(type, variantString);
    if (variantInfo && variantInfo.description) return variantInfo.description;
    else if (segmentInfo && segmentInfo.description) return segmentInfo.description;
    return null;
}
$933a148ff2d63bda$var$Description.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    variantString: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    updateHoverPolygon: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    updateBubbleDimensions: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    onMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    onMouseOut: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    infoBubbleEl: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object
};
function $933a148ff2d63bda$var$Description(props) {
    const descriptionVisible = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.infoBubble.descriptionVisible);
    const offline = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.system.offline);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    function handleClickShow() {
        dispatch((0, $d00d4a7cfa2eb020$export$cc5a1e335d2e250d)());
        props.updateBubbleDimensions();
        props.updateHoverPolygon();
        (0, $89f2807011121cdf$export$bc520ed1c57f0d75)("esc", handleClickHide);
    }
    function handleClickHide() {
        dispatch((0, $d00d4a7cfa2eb020$export$5a112bdb8c45cc8d)());
        props.updateBubbleDimensions();
        props.updateHoverPolygon();
        (0, $89f2807011121cdf$export$86df18839624bc06)("esc", handleClickHide);
    }
    const description = $933a148ff2d63bda$var$getDescriptionData(props.type, props.variantString);
    if (!description || !props.infoBubbleEl) return null;
    // If the description content doesn't exist or hasn't been translated, bail.
    const content = (0, $4daaf0496059b305$export$25868d1e8e76735f)(`descriptions.${description.key}.content`, null, {
        ns: "segment-info"
    });
    if (!content) return null;
    const defaultPrompt = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
        id: "segments.learn-more",
        defaultMessage: "Learn more"
    });
    // TODO: use FormattedMessage
    const prompt = (0, $4daaf0496059b305$export$25868d1e8e76735f)(`descriptions.${description.key}.prompt`, defaultPrompt, {
        ns: "segment-info"
    });
    const imageCaption = (0, $4daaf0496059b305$export$25868d1e8e76735f)(`descriptions.${description.key}.imageCaption`, null, {
        ns: "segment-info"
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "description-prompt",
                onClick: handleClickShow,
                onMouseOver: props.onMouseOver,
                onMouseOut: props.onMouseOut,
                children: prompt
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $f31a521fa07acd33$export$2e2bcd8739ae039), {
                visible: descriptionVisible,
                onClickHide: handleClickHide,
                image: description.image,
                content: content,
                caption: imageCaption,
                offline: offline,
                bubbleY: Number.parseInt(props.infoBubbleEl.style.top)
            })
        ]
    });
}
var $933a148ff2d63bda$export$2e2bcd8739ae039 = $933a148ff2d63bda$var$Description;





const $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE = 20;
const $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_MOUSE = 10;
const $2c229c5a65dffcfe$var$DESCRIPTION_HOVER_POLYGON_MARGIN = 200;
const $2c229c5a65dffcfe$var$MIN_TOP_MARGIN_FROM_VIEWPORT = 150;
// The menu bar has extended to 30px margin, but we can't change
// this because a lesser number will currently cause the description
// panel to potentially be offscreen.
const $2c229c5a65dffcfe$var$MIN_SIDE_MARGIN_FROM_VIEWPORT = 50;
const $2c229c5a65dffcfe$var$HOVER_POLYGON_DEBOUNCE = 50;
class $2c229c5a65dffcfe$export$a3c326e584f93a09 extends (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Component {
    static propTypes = {
        // Provided by Redux connect mapStateToProps
        visible: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool.isRequired,
        descriptionVisible: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
        mouseInside: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
        position: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
                (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd),
                (0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492)
            ])
        ]),
        street: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object,
        locale: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object,
        // Provided by Redux connect mapDispatchToProps
        setInfoBubbleMouseInside: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
        updateHoverPolygon: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func
    };
    static defaultProps = {
        visible: false
    };
    constructor(props){
        super(props);
        // Stores a ref to the element
        this.el = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createRef();
        this.segmentEl = (0, $2f44915f6f87dcf5$export$a3c673416be46295)(props.position);
        this.streetOuterEl = null;
        this.state = {
            type: null,
            highlightTriangle: false
        };
        // Register keyboard shortcuts to hide info bubble
        // Only hide if it's currently visible, and if the
        // description is NOT visible. (If the description
        // is visible, the escape key should hide that first.)
        (0, $89f2807011121cdf$export$bc520ed1c57f0d75)("esc", {
            condition: ()=>this.props.visible && !this.props.descriptionVisible
        }, ()=>{
            (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hide();
            (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hideSegment(false);
        });
    }
    /**
   * Sets state when the infobubble is pointing at a building
   *
   * @param {Object} nextProps
   * @param {Object} prevState
   */ static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.position === (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd)) return {
            type: (0, $4fd11a0514b0f864$export$e446af77b1e2d289)
        };
        else if (nextProps.position === (0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492)) return {
            type: (0, $4fd11a0514b0f864$export$f3a5b4072e475415)
        };
        else if (Number.isFinite(nextProps.position)) return {
            type: (0, $4fd11a0514b0f864$export$d460bc3f6742cc13)
        };
        else return {
            type: null
        };
    }
    componentDidMount() {
        // This listener hides the info bubble when the mouse leaves the
        // document area. Do not normalize it to a pointerleave event
        // because it doesn't make sense for other pointer types
        document.addEventListener("mouseleave", this.hide);
        // Cache reference to this element
        this.streetOuterEl = document.querySelector("#street-section-outer");
    }
    getSnapshotBeforeUpdate(prevProps, prevState) {
        const wasBuilding = prevState.type !== (0, $4fd11a0514b0f864$export$d460bc3f6742cc13);
        if (!this.el || !this.el.current) return null;
        if (!wasBuilding && this.props.position === (0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492)) return window.innerWidth - $2c229c5a65dffcfe$var$MIN_SIDE_MARGIN_FROM_VIEWPORT;
        return null;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        this.segmentEl = (0, $2f44915f6f87dcf5$export$a3c673416be46295)(this.props.position);
        this.setInfoBubblePosition();
        this.updateBubbleDimensions(snapshot);
        // Add or remove event listener based on whether infobubble was shown or hidden
        if (prevProps.visible === false && this.props.visible === true) document.body.addEventListener("mousemove", this.handleBodyMouseMove);
        else if (prevProps.visible === true && this.props.visible === false) document.body.removeEventListener("mousemove", this.handleBodyMouseMove);
        // This appears to be needed to prevent a flicker during mouseover of the infobubble.
        // However because this affects props, it triggers a secondary render() in React and
        // incurs a small performance hit.
        // TODO: can we optimize this away without introducing the flicker?
        this.updateHoverPolygon((0, $62b1ef0171009a7b$export$8a66765a71c06fe6).considerMouseX, (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).considerMouseY);
    }
    componentWillUnmount() {
        // Clean up event listener
        document.removeEventListener("mouseleave", this.hide);
    }
    componentDidCatch(error) {
        console.error(error);
    }
    hide = ()=>{
        (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hide();
    };
    // TODO: verify this continues to work with pointer / touch taps
    handleMouseEnter = (event)=>{
        this.props.setInfoBubbleMouseInside(true);
        this.updateHoverPolygon();
    };
    handleMouseLeave = (event)=>{
        this.props.setInfoBubbleMouseInside(false);
        // Returns focus to body when pointer leaves the info bubble area
        // so that keyboard commands respond to pointer position rather than
        // any focused buttons/inputs
        (0, $a23f2f80a71fc2aa$export$25f99d22563e3d91)();
    };
    handleBodyMouseMove = (event)=>{
        const mouseX = event.pageX;
        const mouseY = event.pageY;
        if (this.props.visible) {
            if (!(0, $62b1ef0171009a7b$export$8a66765a71c06fe6)._withinHoverPolygon(mouseX, mouseY)) (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).show(false);
        }
        this.debouncedUpdateHoverPolygon(mouseX, mouseY);
    };
    handleDescriptionOver = (event)=>{
        this.setState({
            highlightTriangle: true
        });
    };
    handleDescriptionOut = (event)=>{
        this.setState({
            highlightTriangle: false
        });
    };
    updateHoverPolygon = (mouseX, mouseY)=>{
        const hoverPolygon = this.createHoverPolygon(mouseX, mouseY);
        this.props.updateHoverPolygon(hoverPolygon);
    };
    debouncedUpdateHoverPolygon = (0, $952fa6927178102c$export$2e2bcd8739ae039)(this.updateHoverPolygon, $2c229c5a65dffcfe$var$HOVER_POLYGON_DEBOUNCE);
    // TODO: make this a pure(r) function
    createHoverPolygon = (mouseX, mouseY)=>{
        // `hoverPolygon` is an array of points as [x, y] values. Values should
        // draw a shape counter-clockwise. The final value must match the first
        // value in order to create an enclosed polygon.
        let hoverPolygon = [];
        if (!this.props.visible) return hoverPolygon;
        // Bail if any reference to an element no longer exists
        if (!this.el || !this.el.current || !this.segmentEl) return;
        const bubbleWidth = this.el.current.offsetWidth;
        const bubbleHeight = this.el.current.offsetHeight;
        const bubbleX = Number.parseInt(this.el.current.style.left);
        const bubbleY = Number.parseInt(this.el.current.style.top);
        if (this.props.mouseInside && !this.props.descriptionVisible) {
            const pos = (0, $ec5f57ce491b339b$export$a92df11a83653854)(this.segmentEl);
            // Left X position of segment element
            const segmentLeftX = pos[0] - document.querySelector("#street-section-outer").scrollLeft;
            // Right X position of segment element
            const segmentRightX = segmentLeftX + this.segmentEl.offsetWidth;
            // Left X position of segment element with margin (edge of the hover polygon)
            const hitboxLeftX = segmentLeftX - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE;
            // Right X position of segment element with margin (edge of the hover polygon)
            const hitboxRightX = segmentRightX + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE;
            // Top Y position of segment element
            const segmentTopY = pos[1];
            // Bottom Y position of segment element
            const segmentBottomY = segmentTopY + this.segmentEl.offsetHeight;
            // Bottom Y position of segment element with margin
            const hitboxBottomY = segmentBottomY + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE;
            hoverPolygon = [
                // Top left of infobubble
                [
                    bubbleX - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE,
                    bubbleY - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE
                ],
                // Bottom left of infobubble
                [
                    bubbleX - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE,
                    bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE
                ],
                // Diagonal line to hit edge of segment
                [
                    hitboxLeftX,
                    bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE + 120
                ],
                // Bottom left of segment
                [
                    hitboxLeftX,
                    hitboxBottomY
                ],
                // Bottom right of segment
                [
                    hitboxRightX,
                    hitboxBottomY
                ],
                // Point at which to begin diagonal line to infobubble
                [
                    hitboxRightX,
                    bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE + 120
                ],
                // Bottom right of infobubble
                [
                    bubbleX + bubbleWidth + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE,
                    bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE
                ],
                // Top right of infobubble
                [
                    bubbleX + bubbleWidth + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE,
                    bubbleY - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE
                ],
                // Top left of infobubble (starting point)
                [
                    bubbleX - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE,
                    bubbleY - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE
                ]
            ];
        } else {
            let bottomY = mouseY - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_MOUSE;
            if (bottomY < bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE) bottomY = bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE;
            let bottomY2 = mouseY + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_MOUSE;
            if (bottomY2 < bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE) bottomY2 = bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE;
            if (this.props.descriptionVisible) {
                bottomY = bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$DESCRIPTION_HOVER_POLYGON_MARGIN + 300;
                bottomY2 = bottomY;
                hoverPolygon = [
                    [
                        bubbleX - $2c229c5a65dffcfe$var$DESCRIPTION_HOVER_POLYGON_MARGIN,
                        bubbleY - $2c229c5a65dffcfe$var$DESCRIPTION_HOVER_POLYGON_MARGIN
                    ],
                    [
                        bubbleX - $2c229c5a65dffcfe$var$DESCRIPTION_HOVER_POLYGON_MARGIN,
                        bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$DESCRIPTION_HOVER_POLYGON_MARGIN + 300
                    ],
                    [
                        bubbleX + bubbleWidth + $2c229c5a65dffcfe$var$DESCRIPTION_HOVER_POLYGON_MARGIN,
                        bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$DESCRIPTION_HOVER_POLYGON_MARGIN + 300
                    ],
                    [
                        bubbleX + bubbleWidth + $2c229c5a65dffcfe$var$DESCRIPTION_HOVER_POLYGON_MARGIN,
                        bubbleY - $2c229c5a65dffcfe$var$DESCRIPTION_HOVER_POLYGON_MARGIN
                    ],
                    [
                        bubbleX - $2c229c5a65dffcfe$var$DESCRIPTION_HOVER_POLYGON_MARGIN,
                        bubbleY - $2c229c5a65dffcfe$var$DESCRIPTION_HOVER_POLYGON_MARGIN
                    ]
                ];
            } else {
                let diffX = 60 - (mouseY - bubbleY) / 5;
                if (diffX < 0) diffX = 0;
                else if (diffX > 50) diffX = 50;
                hoverPolygon = [
                    [
                        bubbleX - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE,
                        bubbleY - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE
                    ],
                    [
                        bubbleX - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE,
                        bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE
                    ],
                    [
                        (bubbleX - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE + mouseX - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_MOUSE - diffX) / 2,
                        bottomY + (bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE - bottomY) * 0.2
                    ],
                    [
                        mouseX - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_MOUSE - diffX,
                        bottomY
                    ],
                    [
                        mouseX - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_MOUSE,
                        bottomY2
                    ],
                    [
                        mouseX + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_MOUSE,
                        bottomY2
                    ],
                    [
                        mouseX + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_MOUSE + diffX,
                        bottomY
                    ],
                    [
                        (bubbleX + bubbleWidth + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE + mouseX + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_MOUSE + diffX) / 2,
                        bottomY + (bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE - bottomY) * 0.2
                    ],
                    [
                        bubbleX + bubbleWidth + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE,
                        bubbleY + bubbleHeight + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE
                    ],
                    [
                        bubbleX + bubbleWidth + $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE,
                        bubbleY - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE
                    ],
                    [
                        bubbleX - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE,
                        bubbleY - $2c229c5a65dffcfe$var$INFO_BUBBLE_MARGIN_BUBBLE
                    ]
                ];
            }
        }
        return hoverPolygon;
    };
    /**
   * TODO: consolidate this with the dim calc in updateBubbleDimensions? do we need snapshot here?
   */ setInfoBubblePosition = ()=>{
        if (!this.segmentEl || !this.el || !this.el.current || !this.props.visible) return;
        // Determine dimensions and X/Y layout
        const bubbleWidth = this.el.current.offsetWidth;
        const bubbleHeight = this.el.current.offsetHeight;
        const pos = (0, $ec5f57ce491b339b$export$a92df11a83653854)(this.segmentEl);
        let bubbleX = pos[0] - this.streetOuterEl.scrollLeft;
        let bubbleY = pos[1];
        // TODO const
        bubbleY -= bubbleHeight - 20;
        if (bubbleY < $2c229c5a65dffcfe$var$MIN_TOP_MARGIN_FROM_VIEWPORT) bubbleY = $2c229c5a65dffcfe$var$MIN_TOP_MARGIN_FROM_VIEWPORT;
        bubbleX += this.segmentEl.offsetWidth / 2;
        bubbleX -= bubbleWidth / 2;
        if (bubbleX < $2c229c5a65dffcfe$var$MIN_SIDE_MARGIN_FROM_VIEWPORT) bubbleX = $2c229c5a65dffcfe$var$MIN_SIDE_MARGIN_FROM_VIEWPORT;
        else if (bubbleX > window.innerWidth - bubbleWidth - $2c229c5a65dffcfe$var$MIN_SIDE_MARGIN_FROM_VIEWPORT) bubbleX = window.innerWidth - bubbleWidth - $2c229c5a65dffcfe$var$MIN_SIDE_MARGIN_FROM_VIEWPORT;
        this.el.current.style.left = bubbleX + "px";
        this.el.current.style.top = bubbleY + "px";
    };
    updateBubbleDimensions = (snapshot)=>{
        if (!this.el || !this.el.current) return;
        let bubbleHeight;
        const el = this.el.current.querySelector(".description-canvas");
        if (this.props.descriptionVisible && el) {
            const pos = (0, $ec5f57ce491b339b$export$a92df11a83653854)(el);
            bubbleHeight = pos[1] + el.offsetHeight - 38;
        } else bubbleHeight = this.el.current.offsetHeight;
        const height = bubbleHeight + 30;
        this.el.current.style.webkitTransformOrigin = "50% " + height + "px";
        this.el.current.style.MozTransformOrigin = "50% " + height + "px";
        this.el.current.style.transformOrigin = "50% " + height + "px";
        // When the infoBubble needed to be shown for the right building, the offsetWidth
        // used to calculate the left style was from the previous rendering of this component.
        // This meant that if the last time the infoBubble was shown was for a segment, then the
        // offsetWidth used to calculate the new left style would be smaller than it should be.
        // The current solution is to manually recalculate the left style and set the style
        // when hovering over the right building.
        if (snapshot) {
            const bubbleX = snapshot - this.el.current.offsetWidth;
            this.el.current.style.left = bubbleX + "px";
        }
    };
    /**
   * Retrieve name from segment data. It should also find the equivalent strings from the
   * translation files if provided.
   */ getLabel = ()=>{
        let id;
        let defaultMessage = "";
        // Return label if provided
        if (this.state.type === (0, $4fd11a0514b0f864$export$d460bc3f6742cc13)) {
            const segment = this.props.street.segments[this.props.position];
            if (segment && segment.label) return segment.label;
        }
        // Otherwise need to do a lookup
        switch(this.state.type){
            case 0, $4fd11a0514b0f864$export$d460bc3f6742cc13:
                {
                    const segment = this.props.street.segments[this.props.position];
                    if (segment) {
                        const segmentInfo = (0, $0cc5ae9f1eba4866$export$c3985e6b9763d4c2)(segment.type);
                        const variantInfo = (0, $0cc5ae9f1eba4866$export$a7e4a724089e6511)(segment.type, segment.variantString);
                        const key = variantInfo.nameKey || segmentInfo.nameKey;
                        id = `segments.${key}`;
                        defaultMessage = variantInfo.name || segmentInfo.name;
                    }
                    break;
                }
            case 0, $4fd11a0514b0f864$export$e446af77b1e2d289:
                {
                    const key = this.props.street.leftBuildingVariant;
                    id = `buildings.${key}.name`;
                    defaultMessage = (0, $2690ac3abe906938$export$68f9303c71cd9a6d)[key].label;
                    break;
                }
            case 0, $4fd11a0514b0f864$export$f3a5b4072e475415:
                {
                    const key = this.props.street.rightBuildingVariant;
                    id = `buildings.${key}.name`;
                    defaultMessage = (0, $2690ac3abe906938$export$68f9303c71cd9a6d)[key].label;
                    break;
                }
            default:
                break;
        }
        return id ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.IntlProvider), {
            locale: this.props.locale.locale,
            messages: this.props.locale.segmentInfo,
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: id,
                defaultMessage: defaultMessage
            })
        }) : null;
    };
    render() {
        const type = this.state.type;
        const canBeDeleted = type === (0, $4fd11a0514b0f864$export$d460bc3f6742cc13) && this.props.position !== null;
        // Set class names
        const classNames = [
            "info-bubble"
        ];
        classNames.push(type === (0, $4fd11a0514b0f864$export$d460bc3f6742cc13) ? "info-bubble-type-segment" : "info-bubble-type-building");
        if (this.props.visible) classNames.push("visible");
        if (this.props.descriptionVisible) classNames.push("show-description");
        // Determine position
        let position;
        switch(type){
            case 0, $4fd11a0514b0f864$export$d460bc3f6742cc13:
                position = this.props.position;
                break;
            case 0, $4fd11a0514b0f864$export$e446af77b1e2d289:
                position = (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd);
                break;
            case 0, $4fd11a0514b0f864$export$f3a5b4072e475415:
                position = (0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492);
                break;
            default:
                position = null;
                break;
        }
        // Determine width or height control type
        let widthOrHeightControl;
        switch(type){
            case 0, $4fd11a0514b0f864$export$d460bc3f6742cc13:
                widthOrHeightControl = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $4cf2f03bb8c2a808$export$2e2bcd8739ae039), {
                    position: position
                });
                break;
            case 0, $4fd11a0514b0f864$export$e446af77b1e2d289:
            case 0, $4fd11a0514b0f864$export$f3a5b4072e475415:
                widthOrHeightControl = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $0b2bba8022ff749d$export$2e2bcd8739ae039), {
                    position: position
                });
                break;
            default:
                widthOrHeightControl = null;
                break;
        }
        const segment = this.props.street.segments[this.props.position] || {};
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
            className: classNames.join(" "),
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onTouchStart: this.handleTouchStart,
            ref: this.el,
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $c2dd87b9410638e7$export$2e2bcd8739ae039), {
                    highlight: this.state.highlightTriangle
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("header", {
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $4f4cc5139f548a9e$export$2e2bcd8739ae039), {
                            label: this.getLabel(),
                            segment: segment,
                            position: this.props.position
                        }),
                        canBeDeleted && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $461af081e394ba37$export$2e2bcd8739ae039), {
                            segment: this.props.position
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                    className: "info-bubble-controls",
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.IntlProvider), {
                            locale: this.props.locale.locale,
                            messages: this.props.locale.segmentInfo,
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $35f7ba03d53715a0$export$2e2bcd8739ae039), {
                                type: type,
                                position: position
                            })
                        }),
                        widthOrHeightControl
                    ]
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $31e9b3a2ad7b2fcb$export$2e2bcd8739ae039), {
                    segment: segment
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $933a148ff2d63bda$export$2e2bcd8739ae039), {
                    type: segment.type,
                    variantString: segment.variantString,
                    updateBubbleDimensions: this.updateBubbleDimensions,
                    onMouseOver: this.handleDescriptionOver,
                    onMouseOut: this.handleDescriptionOut,
                    infoBubbleEl: this.el.current,
                    updateHoverPolygon: this.updateHoverPolygon
                })
            ]
        });
    }
}
function $2c229c5a65dffcfe$var$mapStateToProps(state) {
    return {
        visible: state.infoBubble.visible,
        descriptionVisible: state.infoBubble.descriptionVisible,
        mouseInside: state.infoBubble.mouseInside,
        position: state.ui.activeSegment,
        street: state.street,
        system: state.system,
        locale: state.locale
    };
}
const $2c229c5a65dffcfe$var$mapDispatchToProps = {
    setInfoBubbleMouseInside: $d00d4a7cfa2eb020$export$627024eef420e1c1,
    updateHoverPolygon: $d00d4a7cfa2eb020$export$444e9dbe49f408c2
};
var $2c229c5a65dffcfe$export$2e2bcd8739ae039 = (0, $a4829965bb94612b$export$2e2bcd8739ae039)($2c229c5a65dffcfe$var$mapStateToProps, $2c229c5a65dffcfe$var$mapDispatchToProps)($2c229c5a65dffcfe$export$a3c326e584f93a09);



parcelRequire("4DE7A");

/**
 * The Palette is the UI element at the bottom of the screen that shows all the
 * available street segments. Users can drag and drop segments from the palette
 * onto the street.
 */ 

var $4DE7A = parcelRequire("4DE7A");


/**
 * Adds scroll buttons to UI elements.
 */ 

var $4DE7A = parcelRequire("4DE7A");






const $d1eb3c02169e64a6$var$SCROLL_ANIMATE_DURATION = 300 // in ms
;
const $d1eb3c02169e64a6$var$WrappedScrollable = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function Scrollable(props, ref) {
    const { className: className, onScroll: onScroll = ()=>undefined, allowKeyboardScroll: allowKeyboardScroll = false, children: children } = props;
    const scrollerEl = (0, $4DE7A.useRef)(null);
    const leftButtonEl = (0, $4DE7A.useRef)(null);
    const rightButtonEl = (0, $4DE7A.useRef)(null);
    (0, $4DE7A.useEffect)(()=>{
        window.addEventListener("resize", checkButtonVisibilityState);
        checkButtonVisibilityState();
        return ()=>{
            window.removeEventListener("resize", checkButtonVisibilityState);
        };
    });
    (0, $4DE7A.useEffect)(()=>{
        if (allowKeyboardScroll) {
            (0, $89f2807011121cdf$export$bc520ed1c57f0d75)("left", handleClickLeft);
            (0, $89f2807011121cdf$export$bc520ed1c57f0d75)("right", handleClickRight);
        }
        return ()=>{
            if (allowKeyboardScroll) {
                (0, $89f2807011121cdf$export$86df18839624bc06)("left", handleClickLeft);
                (0, $89f2807011121cdf$export$86df18839624bc06)("right", handleClickRight);
            }
        };
    });
    (0, $4DE7A.useLayoutEffect)(()=>{
        if (leftButtonEl.current) leftButtonEl.current.style.left = "-15px";
        if (rightButtonEl.current) rightButtonEl.current.style.right = "-15px";
    });
    function handleClickLeft(event) {
        const el = scrollerEl.current;
        if (el === null) return;
        const position = el.scrollLeft - (el.offsetWidth - 150 // TODO: document magic number
        );
        (0, $ec5f57ce491b339b$export$e3607ec2d7a891c4)(el, {
            scrollLeft: position
        }, $d1eb3c02169e64a6$var$SCROLL_ANIMATE_DURATION);
    }
    function handleClickRight(event) {
        const el = scrollerEl.current;
        if (!el) return;
        const position = el.scrollLeft + (el.offsetWidth - 150 // TODO: document magic number
        );
        (0, $ec5f57ce491b339b$export$e3607ec2d7a891c4)(el, {
            scrollLeft: position
        }, $d1eb3c02169e64a6$var$SCROLL_ANIMATE_DURATION);
    }
    function handleScrollContainer(event) {
        checkButtonVisibilityState();
        // If parent has provided its own onScroll handler function, call that now.
        onScroll(event);
    }
    function checkButtonVisibilityState() {
        const el = scrollerEl.current;
        if (!el) return;
        const dir = window.getComputedStyle(el).direction;
        // Swap left and right buttons if direction is `rtl`
        const left = dir === "rtl" ? rightButtonEl.current : leftButtonEl.current;
        const right = dir === "rtl" ? leftButtonEl.current : rightButtonEl.current;
        // We set styles manually instead of setting `disabled` as before; it's
        // because a button in a disabled state doesn't seem to get onClick
        // handlers attached.
        if (left) {
            if (el.scrollLeft === 0) {
                left.style.opacity = "0";
                left.style.pointerEvents = "none";
                left.setAttribute("hidden", "true");
                left.setAttribute("tabindex", "-1");
            } else {
                left.style.opacity = "1";
                left.style.pointerEvents = "auto";
                left.removeAttribute("hidden");
                left.setAttribute("tabindex", "0");
            }
        }
        // scrollLeft will be a negative value if direction is `rtl`,
        // and a positive value if direction is `ltr`.
        // Math.abs() is used to guarantee a positive value for the comparison.
        if (right) {
            if (Math.abs(el.scrollLeft) === el.scrollWidth - el.offsetWidth) {
                right.style.opacity = "0";
                right.style.pointerEvents = "none";
                right.setAttribute("hidden", "true");
                right.setAttribute("tabindex", "-1");
            } else {
                right.style.opacity = "1";
                right.style.pointerEvents = "auto";
                right.removeAttribute("hidden");
                right.setAttribute("tabindex", "0");
            }
        }
    }
    const containerClassName = className !== undefined ? `${className}-scrollable-container` : "";
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: containerClassName,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                className: "scrollable scroll-left",
                onClick: handleClickLeft,
                ref: leftButtonEl,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                    icon: (0, $5cbf5c54789c9bf6$export$731a703adf2141b2)
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: className,
                onScroll: handleScrollContainer,
                ref: scrollerEl,
                style: {
                    // Prevent overscroll from doing forward/back
                    // navigation on some browsers
                    overscrollBehaviorX: "contain"
                },
                children: children
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                className: "scrollable scroll-right",
                onClick: handleClickRight,
                ref: rightButtonEl,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                    icon: (0, $5cbf5c54789c9bf6$export$acbe832e28edcfdb)
                })
            })
        ]
    });
});
var $d1eb3c02169e64a6$export$2e2bcd8739ae039 = $d1eb3c02169e64a6$var$WrappedScrollable;



/**
 * Segments in the Palette component render differently (and have differen
 * logic and behavior) to segments rendered on the street.
 */ 
parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");




function $efcd7e8d00124713$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $efcd7e8d00124713$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $efcd7e8d00124713$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $efcd7e8d00124713$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $efcd7e8d00124713$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $efcd7e8d00124713$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $efcd7e8d00124713$var$isCallingCanDrag = false;
var $efcd7e8d00124713$var$isCallingIsDragging = false;
var $efcd7e8d00124713$export$af934094fb48ddf = /*#__PURE__*/ function() {
    function DragSourceMonitorImpl(manager) {
        $efcd7e8d00124713$var$_classCallCheck(this, DragSourceMonitorImpl);
        $efcd7e8d00124713$var$_defineProperty(this, "internalMonitor", void 0);
        $efcd7e8d00124713$var$_defineProperty(this, "sourceId", null);
        this.internalMonitor = manager.getMonitor();
    }
    $efcd7e8d00124713$var$_createClass(DragSourceMonitorImpl, [
        {
            key: "receiveHandlerId",
            value: function receiveHandlerId(sourceId) {
                this.sourceId = sourceId;
            }
        },
        {
            key: "getHandlerId",
            value: function getHandlerId() {
                return this.sourceId;
            }
        },
        {
            key: "canDrag",
            value: function canDrag() {
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(!$efcd7e8d00124713$var$isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
                try {
                    $efcd7e8d00124713$var$isCallingCanDrag = true;
                    return this.internalMonitor.canDragSource(this.sourceId);
                } finally{
                    $efcd7e8d00124713$var$isCallingCanDrag = false;
                }
            }
        },
        {
            key: "isDragging",
            value: function isDragging() {
                if (!this.sourceId) return false;
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(!$efcd7e8d00124713$var$isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
                try {
                    $efcd7e8d00124713$var$isCallingIsDragging = true;
                    return this.internalMonitor.isDraggingSource(this.sourceId);
                } finally{
                    $efcd7e8d00124713$var$isCallingIsDragging = false;
                }
            }
        },
        {
            key: "subscribeToStateChange",
            value: function subscribeToStateChange(listener, options) {
                return this.internalMonitor.subscribeToStateChange(listener, options);
            }
        },
        {
            key: "isDraggingSource",
            value: function isDraggingSource(sourceId) {
                return this.internalMonitor.isDraggingSource(sourceId);
            }
        },
        {
            key: "isOverTarget",
            value: function isOverTarget(targetId, options) {
                return this.internalMonitor.isOverTarget(targetId, options);
            }
        },
        {
            key: "getTargetIds",
            value: function getTargetIds() {
                return this.internalMonitor.getTargetIds();
            }
        },
        {
            key: "isSourcePublic",
            value: function isSourcePublic() {
                return this.internalMonitor.isSourcePublic();
            }
        },
        {
            key: "getSourceId",
            value: function getSourceId() {
                return this.internalMonitor.getSourceId();
            }
        },
        {
            key: "subscribeToOffsetChange",
            value: function subscribeToOffsetChange(listener) {
                return this.internalMonitor.subscribeToOffsetChange(listener);
            }
        },
        {
            key: "canDragSource",
            value: function canDragSource(sourceId) {
                return this.internalMonitor.canDragSource(sourceId);
            }
        },
        {
            key: "canDropOnTarget",
            value: function canDropOnTarget(targetId) {
                return this.internalMonitor.canDropOnTarget(targetId);
            }
        },
        {
            key: "getItemType",
            value: function getItemType() {
                return this.internalMonitor.getItemType();
            }
        },
        {
            key: "getItem",
            value: function getItem() {
                return this.internalMonitor.getItem();
            }
        },
        {
            key: "getDropResult",
            value: function getDropResult() {
                return this.internalMonitor.getDropResult();
            }
        },
        {
            key: "didDrop",
            value: function didDrop() {
                return this.internalMonitor.didDrop();
            }
        },
        {
            key: "getInitialClientOffset",
            value: function getInitialClientOffset() {
                return this.internalMonitor.getInitialClientOffset();
            }
        },
        {
            key: "getInitialSourceClientOffset",
            value: function getInitialSourceClientOffset() {
                return this.internalMonitor.getInitialSourceClientOffset();
            }
        },
        {
            key: "getSourceClientOffset",
            value: function getSourceClientOffset() {
                return this.internalMonitor.getSourceClientOffset();
            }
        },
        {
            key: "getClientOffset",
            value: function getClientOffset() {
                return this.internalMonitor.getClientOffset();
            }
        },
        {
            key: "getDifferenceFromInitialOffset",
            value: function getDifferenceFromInitialOffset() {
                return this.internalMonitor.getDifferenceFromInitialOffset();
            }
        }
    ]);
    return DragSourceMonitorImpl;
}();

function $e363ee57e8e93320$export$38b18180ae58b09b(type, target, manager) {
    var registry = manager.getRegistry();
    var targetId = registry.addTarget(type, target);
    return [
        targetId,
        function() {
            return registry.removeTarget(targetId);
        }
    ];
}
function $e363ee57e8e93320$export$51c814b9e17958c(type, source, manager) {
    var registry = manager.getRegistry();
    var sourceId = registry.addSource(type, source);
    return [
        sourceId,
        function() {
            return registry.removeSource(sourceId);
        }
    ];
}



var $4DE7A = parcelRequire("4DE7A");
function $3120d1ee18286303$var$throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === "string") return;
    var displayName = element.type.displayName || element.type.name || "the component";
    throw new Error("Only native element nodes can now be passed to React DnD connectors." + "You can either wrap ".concat(displayName, " into a <div>, or turn it into a ") + "drag source or a drop target itself.");
}
function $3120d1ee18286303$var$wrapHookToRecognizeElement(hook) {
    return function() {
        var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        // When passed a node, call the hook straight away.
        if (!(0, $4DE7A.isValidElement)(elementOrNode)) {
            var node = elementOrNode;
            hook(node, options); // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        } // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        var element = elementOrNode;
        $3120d1ee18286303$var$throwIfCompositeComponentElement(element); // When no options are passed, use the hook directly
        var ref = options ? function(node) {
            return hook(node, options);
        } : hook;
        return $3120d1ee18286303$var$cloneWithRef(element, ref);
    };
}
function $3120d1ee18286303$export$d8dcaf80ab4f6cb7(hooks) {
    var wrappedHooks = {};
    Object.keys(hooks).forEach(function(key) {
        var hook = hooks[key]; // ref objects should be passed straight through without wrapping
        if (key.endsWith("Ref")) wrappedHooks[key] = hooks[key];
        else {
            var wrappedHook = $3120d1ee18286303$var$wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = function() {
                return wrappedHook;
            };
        }
    });
    return wrappedHooks;
}
function $3120d1ee18286303$var$setRef(ref, node) {
    if (typeof ref === "function") ref(node);
    else ref.current = node;
}
function $3120d1ee18286303$var$cloneWithRef(element, newRef) {
    var previousRef = element.ref;
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof previousRef !== "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, $4DE7A.cloneElement)(element, {
        ref: newRef
    });
    else return (0, $4DE7A.cloneElement)(element, {
        ref: function ref(node) {
            $3120d1ee18286303$var$setRef(previousRef, node);
            $3120d1ee18286303$var$setRef(newRef, node);
        }
    });
}


function $52360539e7864b82$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $52360539e7864b82$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $52360539e7864b82$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $52360539e7864b82$var$_typeof(obj);
}
function $52360539e7864b82$export$4f9f5282de18fc69(obj) {
    return obj !== null && $52360539e7864b82$var$_typeof(obj) === "object" && Object.prototype.hasOwnProperty.call(obj, "current");
}


function $91edbb15e5e7db4c$export$d36bdfa510afb180(objA, objB, compare, compareContext) {
    var compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) return !!compareResult;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB); // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) return false;
    }
    return true;
}


function $2d677526b18c5d53$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2d677526b18c5d53$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2d677526b18c5d53$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2d677526b18c5d53$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2d677526b18c5d53$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $2d677526b18c5d53$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $2d677526b18c5d53$export$9a7176fb37ab5028 = /*#__PURE__*/ function() {
    // The drop target may either be attached via ref or connect function
    // The drag preview may either be attached via ref or connect function
    function SourceConnector(backend) {
        var _this = this;
        $2d677526b18c5d53$var$_classCallCheck(this, SourceConnector);
        $2d677526b18c5d53$var$_defineProperty(this, "hooks", (0, $3120d1ee18286303$export$d8dcaf80ab4f6cb7)({
            dragSource: function dragSource(node, options) {
                _this.clearDragSource();
                _this.dragSourceOptions = options || null;
                if ((0, $52360539e7864b82$export$4f9f5282de18fc69)(node)) _this.dragSourceRef = node;
                else _this.dragSourceNode = node;
                _this.reconnectDragSource();
            },
            dragPreview: function dragPreview(node, options) {
                _this.clearDragPreview();
                _this.dragPreviewOptions = options || null;
                if ((0, $52360539e7864b82$export$4f9f5282de18fc69)(node)) _this.dragPreviewRef = node;
                else _this.dragPreviewNode = node;
                _this.reconnectDragPreview();
            }
        }));
        $2d677526b18c5d53$var$_defineProperty(this, "handlerId", null);
        $2d677526b18c5d53$var$_defineProperty(this, "dragSourceRef", null);
        $2d677526b18c5d53$var$_defineProperty(this, "dragSourceNode", void 0);
        $2d677526b18c5d53$var$_defineProperty(this, "dragSourceOptionsInternal", null);
        $2d677526b18c5d53$var$_defineProperty(this, "dragSourceUnsubscribe", void 0);
        $2d677526b18c5d53$var$_defineProperty(this, "dragPreviewRef", null);
        $2d677526b18c5d53$var$_defineProperty(this, "dragPreviewNode", void 0);
        $2d677526b18c5d53$var$_defineProperty(this, "dragPreviewOptionsInternal", null);
        $2d677526b18c5d53$var$_defineProperty(this, "dragPreviewUnsubscribe", void 0);
        $2d677526b18c5d53$var$_defineProperty(this, "lastConnectedHandlerId", null);
        $2d677526b18c5d53$var$_defineProperty(this, "lastConnectedDragSource", null);
        $2d677526b18c5d53$var$_defineProperty(this, "lastConnectedDragSourceOptions", null);
        $2d677526b18c5d53$var$_defineProperty(this, "lastConnectedDragPreview", null);
        $2d677526b18c5d53$var$_defineProperty(this, "lastConnectedDragPreviewOptions", null);
        $2d677526b18c5d53$var$_defineProperty(this, "backend", void 0);
        this.backend = backend;
    }
    $2d677526b18c5d53$var$_createClass(SourceConnector, [
        {
            key: "receiveHandlerId",
            value: function receiveHandlerId(newHandlerId) {
                if (this.handlerId === newHandlerId) return;
                this.handlerId = newHandlerId;
                this.reconnect();
            }
        },
        {
            key: "connectTarget",
            get: function get() {
                return this.dragSource;
            }
        },
        {
            key: "dragSourceOptions",
            get: function get() {
                return this.dragSourceOptionsInternal;
            },
            set: function set(options) {
                this.dragSourceOptionsInternal = options;
            }
        },
        {
            key: "dragPreviewOptions",
            get: function get() {
                return this.dragPreviewOptionsInternal;
            },
            set: function set(options) {
                this.dragPreviewOptionsInternal = options;
            }
        },
        {
            key: "reconnect",
            value: function reconnect() {
                this.reconnectDragSource();
                this.reconnectDragPreview();
            }
        },
        {
            key: "reconnectDragSource",
            value: function reconnectDragSource() {
                var dragSource = this.dragSource; // if nothing has changed then don't resubscribe
                var didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
                if (didChange) this.disconnectDragSource();
                if (!this.handlerId) return;
                if (!dragSource) {
                    this.lastConnectedDragSource = dragSource;
                    return;
                }
                if (didChange) {
                    this.lastConnectedHandlerId = this.handlerId;
                    this.lastConnectedDragSource = dragSource;
                    this.lastConnectedDragSourceOptions = this.dragSourceOptions;
                    this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
                }
            }
        },
        {
            key: "reconnectDragPreview",
            value: function reconnectDragPreview() {
                var dragPreview = this.dragPreview; // if nothing has changed then don't resubscribe
                var didChange = this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
                if (didChange) this.disconnectDragPreview();
                if (!this.handlerId) return;
                if (!dragPreview) {
                    this.lastConnectedDragPreview = dragPreview;
                    return;
                }
                if (didChange) {
                    this.lastConnectedHandlerId = this.handlerId;
                    this.lastConnectedDragPreview = dragPreview;
                    this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
                    this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
                }
            }
        },
        {
            key: "didHandlerIdChange",
            value: function didHandlerIdChange() {
                return this.lastConnectedHandlerId !== this.handlerId;
            }
        },
        {
            key: "didConnectedDragSourceChange",
            value: function didConnectedDragSourceChange() {
                return this.lastConnectedDragSource !== this.dragSource;
            }
        },
        {
            key: "didConnectedDragPreviewChange",
            value: function didConnectedDragPreviewChange() {
                return this.lastConnectedDragPreview !== this.dragPreview;
            }
        },
        {
            key: "didDragSourceOptionsChange",
            value: function didDragSourceOptionsChange() {
                return !(0, $91edbb15e5e7db4c$export$d36bdfa510afb180)(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
            }
        },
        {
            key: "didDragPreviewOptionsChange",
            value: function didDragPreviewOptionsChange() {
                return !(0, $91edbb15e5e7db4c$export$d36bdfa510afb180)(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
            }
        },
        {
            key: "disconnectDragSource",
            value: function disconnectDragSource() {
                if (this.dragSourceUnsubscribe) {
                    this.dragSourceUnsubscribe();
                    this.dragSourceUnsubscribe = undefined;
                }
            }
        },
        {
            key: "disconnectDragPreview",
            value: function disconnectDragPreview() {
                if (this.dragPreviewUnsubscribe) {
                    this.dragPreviewUnsubscribe();
                    this.dragPreviewUnsubscribe = undefined;
                    this.dragPreviewNode = null;
                    this.dragPreviewRef = null;
                }
            }
        },
        {
            key: "dragSource",
            get: function get() {
                return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
            }
        },
        {
            key: "dragPreview",
            get: function get() {
                return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
            }
        },
        {
            key: "clearDragSource",
            value: function clearDragSource() {
                this.dragSourceNode = null;
                this.dragSourceRef = null;
            }
        },
        {
            key: "clearDragPreview",
            value: function clearDragPreview() {
                this.dragPreviewNode = null;
                this.dragPreviewRef = null;
            }
        }
    ]);
    return SourceConnector;
}();


function $b1cde746e5ea11e6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b1cde746e5ea11e6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b1cde746e5ea11e6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b1cde746e5ea11e6$var$_typeof(obj);
}
function $b1cde746e5ea11e6$export$c4f820ef5e50813b(instanceRef) {
    var currentRef = instanceRef.current;
    if (currentRef == null) return null;
    else if (currentRef.decoratedRef) // go through the private field in decorateHandler to avoid the invariant hit
    return currentRef.decoratedRef.current;
    else return currentRef;
}
function $b1cde746e5ea11e6$export$2ca7f0b8a8f94fe1(Component) {
    return Component && Component.prototype && typeof Component.prototype.render === "function";
}
function $b1cde746e5ea11e6$export$33d680f1b0a94ab9(C) {
    var _item$$$typeof;
    var item = C;
    return (item === null || item === void 0 ? void 0 : (_item$$$typeof = item.$$typeof) === null || _item$$$typeof === void 0 ? void 0 : _item$$$typeof.toString()) === "Symbol(react.forward_ref)";
}
function $b1cde746e5ea11e6$export$a77111fb0da893fd(C) {
    return $b1cde746e5ea11e6$export$2ca7f0b8a8f94fe1(C) || $b1cde746e5ea11e6$export$33d680f1b0a94ab9(C);
}
function $b1cde746e5ea11e6$export$ffeaa70abe2dcf1c(functionName, signature) {
    var i, arg;
}
function $b1cde746e5ea11e6$export$f6e2535fb5126e54(input) {
    return typeof input === "function";
}
function $b1cde746e5ea11e6$export$8793edee2d425525() {}
function $b1cde746e5ea11e6$var$isObjectLike(input) {
    return $b1cde746e5ea11e6$var$_typeof(input) === "object" && input !== null;
}
function $b1cde746e5ea11e6$export$53b83ca8eaab0383(input) {
    if (!$b1cde746e5ea11e6$var$isObjectLike(input)) return false;
    if (Object.getPrototypeOf(input) === null) return true;
    var proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}
function $b1cde746e5ea11e6$export$2698d5b4be829db6(type, allowArray) {
    return typeof type === "string" || $b1cde746e5ea11e6$var$_typeof(type) === "symbol" || !!allowArray && Array.isArray(type) && type.every(function(t) {
        return $b1cde746e5ea11e6$export$2698d5b4be829db6(t, false);
    });
}




var $4DE7A = parcelRequire("4DE7A");





function $8365fff33646601b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8365fff33646601b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8365fff33646601b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8365fff33646601b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8365fff33646601b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8365fff33646601b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $8365fff33646601b$export$252720412a173de = /*#__PURE__*/ function() {
    function Disposable(action) {
        $8365fff33646601b$var$_classCallCheck(this, Disposable);
        $8365fff33646601b$var$_defineProperty(this, "isDisposed", false);
        $8365fff33646601b$var$_defineProperty(this, "action", void 0);
        this.action = (0, $b1cde746e5ea11e6$export$f6e2535fb5126e54)(action) ? action : (0, $b1cde746e5ea11e6$export$8793edee2d425525);
    }
    /** Performs the task of cleaning up resources. */ $8365fff33646601b$var$_createClass(Disposable, [
        {
            key: "dispose",
            value: function dispose() {
                if (!this.isDisposed) {
                    this.action();
                    this.isDisposed = true;
                }
            }
        }
    ], [
        {
            key: "isDisposable",
            value: /**
     * Gets the disposable that does nothing when disposed.
     */ /**
     * Validates whether the given object is a disposable
     * @param {Object} Object to test whether it has a dispose method
     * @returns {Boolean} true if a disposable object, else false.
     */ function isDisposable(d) {
                return Boolean(d && (0, $b1cde746e5ea11e6$export$f6e2535fb5126e54)(d.dispose));
            }
        },
        {
            key: "_fixup",
            value: function _fixup(result) {
                return Disposable.isDisposable(result) ? result : Disposable.empty;
            }
        },
        {
            key: "create",
            value: function create(action) {
                return new Disposable(action);
            }
        }
    ]);
    return Disposable;
}();
/**
 * Represents a group of disposable resources that are disposed together.
 * @constructor
 */ $8365fff33646601b$var$_defineProperty($8365fff33646601b$export$252720412a173de, "empty", {
    dispose: (0, $b1cde746e5ea11e6$export$8793edee2d425525)
});
var $8365fff33646601b$export$9ad012e5c3534b20 = /*#__PURE__*/ function() {
    function CompositeDisposable() {
        $8365fff33646601b$var$_classCallCheck(this, CompositeDisposable);
        $8365fff33646601b$var$_defineProperty(this, "isDisposed", false);
        $8365fff33646601b$var$_defineProperty(this, "disposables", void 0);
        for(var _len = arguments.length, disposables = new Array(_len), _key = 0; _key < _len; _key++)disposables[_key] = arguments[_key];
        this.disposables = disposables;
    }
    /**
   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
   * @param {Any} item Disposable to add.
   */ $8365fff33646601b$var$_createClass(CompositeDisposable, [
        {
            key: "add",
            value: function add(item) {
                if (this.isDisposed) item.dispose();
                else this.disposables.push(item);
            }
        },
        {
            key: "remove",
            value: function remove(item) {
                var shouldDispose = false;
                if (!this.isDisposed) {
                    var idx = this.disposables.indexOf(item);
                    if (idx !== -1) {
                        shouldDispose = true;
                        this.disposables.splice(idx, 1);
                        item.dispose();
                    }
                }
                return shouldDispose;
            }
        },
        {
            key: "clear",
            value: function clear() {
                if (!this.isDisposed) {
                    var len = this.disposables.length;
                    var currentDisposables = new Array(len);
                    for(var i = 0; i < len; i++)currentDisposables[i] = this.disposables[i];
                    this.disposables = [];
                    for(var _i = 0; _i < len; _i++)currentDisposables[_i].dispose();
                }
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (!this.isDisposed) {
                    this.isDisposed = true;
                    var len = this.disposables.length;
                    var currentDisposables = new Array(len);
                    for(var i = 0; i < len; i++)currentDisposables[i] = this.disposables[i];
                    this.disposables = [];
                    for(var _i2 = 0; _i2 < len; _i2++)currentDisposables[_i2].dispose();
                }
            }
        }
    ]);
    return CompositeDisposable;
}();
var $8365fff33646601b$export$9c59780726206893 = /*#__PURE__*/ function() {
    function SerialDisposable() {
        $8365fff33646601b$var$_classCallCheck(this, SerialDisposable);
        $8365fff33646601b$var$_defineProperty(this, "isDisposed", false);
        $8365fff33646601b$var$_defineProperty(this, "current", void 0);
    }
    $8365fff33646601b$var$_createClass(SerialDisposable, [
        {
            key: "getDisposable",
            value: /**
     * Gets the underlying disposable.
     * @returns {Any} the underlying disposable.
     */ function getDisposable() {
                return this.current;
            }
        },
        {
            key: "setDisposable",
            value: function setDisposable(value) {
                var shouldDispose = this.isDisposed;
                if (!shouldDispose) {
                    var old = this.current;
                    this.current = value;
                    if (old) old.dispose();
                }
                if (shouldDispose && value) value.dispose();
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (!this.isDisposed) {
                    this.isDisposed = true;
                    var old = this.current;
                    this.current = undefined;
                    if (old) old.dispose();
                }
            }
        }
    ]);
    return SerialDisposable;
}();



var $34Pgq = parcelRequire("34Pgq");
function $78f2df3bcc3325ac$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $78f2df3bcc3325ac$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $78f2df3bcc3325ac$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $78f2df3bcc3325ac$var$_typeof(obj);
}
function $78f2df3bcc3325ac$var$_slicedToArray(arr, i) {
    return $78f2df3bcc3325ac$var$_arrayWithHoles(arr) || $78f2df3bcc3325ac$var$_iterableToArrayLimit(arr, i) || $78f2df3bcc3325ac$var$_unsupportedIterableToArray(arr, i) || $78f2df3bcc3325ac$var$_nonIterableRest();
}
function $78f2df3bcc3325ac$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $78f2df3bcc3325ac$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $78f2df3bcc3325ac$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $78f2df3bcc3325ac$var$_arrayLikeToArray(o, minLen);
}
function $78f2df3bcc3325ac$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $78f2df3bcc3325ac$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $78f2df3bcc3325ac$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $78f2df3bcc3325ac$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $78f2df3bcc3325ac$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $78f2df3bcc3325ac$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $78f2df3bcc3325ac$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $78f2df3bcc3325ac$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $78f2df3bcc3325ac$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $78f2df3bcc3325ac$var$_setPrototypeOf(subClass, superClass);
}
function $78f2df3bcc3325ac$var$_setPrototypeOf(o, p) {
    $78f2df3bcc3325ac$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $78f2df3bcc3325ac$var$_setPrototypeOf(o, p);
}
function $78f2df3bcc3325ac$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $78f2df3bcc3325ac$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $78f2df3bcc3325ac$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $78f2df3bcc3325ac$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $78f2df3bcc3325ac$var$_possibleConstructorReturn(this, result);
    };
}
function $78f2df3bcc3325ac$var$_possibleConstructorReturn(self, call) {
    if (call && ($78f2df3bcc3325ac$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $78f2df3bcc3325ac$var$_assertThisInitialized(self);
}
function $78f2df3bcc3325ac$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $78f2df3bcc3325ac$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $78f2df3bcc3325ac$var$_getPrototypeOf(o) {
    $78f2df3bcc3325ac$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $78f2df3bcc3325ac$var$_getPrototypeOf(o);
}
function $78f2df3bcc3325ac$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $78f2df3bcc3325ac$export$868ec1615c0ccfd8(_ref) {
    var DecoratedComponent = _ref.DecoratedComponent, createHandler = _ref.createHandler, createMonitor = _ref.createMonitor, createConnector = _ref.createConnector, registerHandler = _ref.registerHandler, containerDisplayName = _ref.containerDisplayName, getType = _ref.getType, collect = _ref.collect, options = _ref.options;
    var _options$arePropsEqua = options.arePropsEqual, arePropsEqual = _options$arePropsEqua === void 0 ? (0, $91edbb15e5e7db4c$export$d36bdfa510afb180) : _options$arePropsEqua;
    var Decorated = DecoratedComponent;
    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || "Component";
    var DragDropContainer = /*#__PURE__*/ function(_Component) {
        $78f2df3bcc3325ac$var$_inherits(DragDropContainer, _Component);
        var _super = $78f2df3bcc3325ac$var$_createSuper(DragDropContainer);
        function DragDropContainer(props) {
            var _this;
            $78f2df3bcc3325ac$var$_classCallCheck(this, DragDropContainer);
            _this = _super.call(this, props);
            $78f2df3bcc3325ac$var$_defineProperty($78f2df3bcc3325ac$var$_assertThisInitialized(_this), "decoratedRef", (0, $4DE7A.createRef)());
            $78f2df3bcc3325ac$var$_defineProperty($78f2df3bcc3325ac$var$_assertThisInitialized(_this), "handlerId", void 0);
            $78f2df3bcc3325ac$var$_defineProperty($78f2df3bcc3325ac$var$_assertThisInitialized(_this), "manager", void 0);
            $78f2df3bcc3325ac$var$_defineProperty($78f2df3bcc3325ac$var$_assertThisInitialized(_this), "handlerMonitor", void 0);
            $78f2df3bcc3325ac$var$_defineProperty($78f2df3bcc3325ac$var$_assertThisInitialized(_this), "handlerConnector", void 0);
            $78f2df3bcc3325ac$var$_defineProperty($78f2df3bcc3325ac$var$_assertThisInitialized(_this), "handler", void 0);
            $78f2df3bcc3325ac$var$_defineProperty($78f2df3bcc3325ac$var$_assertThisInitialized(_this), "disposable", void 0);
            $78f2df3bcc3325ac$var$_defineProperty($78f2df3bcc3325ac$var$_assertThisInitialized(_this), "currentType", void 0);
            $78f2df3bcc3325ac$var$_defineProperty($78f2df3bcc3325ac$var$_assertThisInitialized(_this), "handleChange", function() {
                var nextState = _this.getCurrentState();
                if (!(0, $91edbb15e5e7db4c$export$d36bdfa510afb180)(nextState, _this.state)) _this.setState(nextState);
            });
            _this.disposable = new (0, $8365fff33646601b$export$9c59780726206893)();
            _this.receiveProps(props);
            _this.dispose();
            return _this;
        }
        $78f2df3bcc3325ac$var$_createClass(DragDropContainer, [
            {
                key: "getHandlerId",
                value: function getHandlerId() {
                    return this.handlerId;
                }
            },
            {
                key: "getDecoratedComponentInstance",
                value: function getDecoratedComponentInstance() {
                    (0, $2daa4a08f076625e$export$f5708dca728d7177)(this.decoratedRef.current, "In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()");
                    return this.decoratedRef.current;
                }
            },
            {
                key: "shouldComponentUpdate",
                value: function shouldComponentUpdate(nextProps, nextState) {
                    return !arePropsEqual(nextProps, this.props) || !(0, $91edbb15e5e7db4c$export$d36bdfa510afb180)(nextState, this.state);
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.disposable = new (0, $8365fff33646601b$export$9c59780726206893)();
                    this.currentType = undefined;
                    this.receiveProps(this.props);
                    this.handleChange();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (!arePropsEqual(this.props, prevProps)) {
                        this.receiveProps(this.props);
                        this.handleChange();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.dispose();
                }
            },
            {
                key: "receiveProps",
                value: function receiveProps(props) {
                    if (!this.handler) return;
                    this.handler.receiveProps(props);
                    this.receiveType(getType(props));
                }
            },
            {
                key: "receiveType",
                value: function receiveType(type) {
                    if (!this.handlerMonitor || !this.manager || !this.handlerConnector) return;
                    if (type === this.currentType) return;
                    this.currentType = type;
                    var _registerHandler = registerHandler(type, this.handler, this.manager), _registerHandler2 = $78f2df3bcc3325ac$var$_slicedToArray(_registerHandler, 2), handlerId = _registerHandler2[0], unregister = _registerHandler2[1];
                    this.handlerId = handlerId;
                    this.handlerMonitor.receiveHandlerId(handlerId);
                    this.handlerConnector.receiveHandlerId(handlerId);
                    var globalMonitor = this.manager.getMonitor();
                    var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, {
                        handlerIds: [
                            handlerId
                        ]
                    });
                    this.disposable.setDisposable(new (0, $8365fff33646601b$export$9ad012e5c3534b20)(new (0, $8365fff33646601b$export$252720412a173de)(unsubscribe), new (0, $8365fff33646601b$export$252720412a173de)(unregister)));
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    this.disposable.dispose();
                    if (this.handlerConnector) this.handlerConnector.receiveHandlerId(null);
                }
            },
            {
                key: "getCurrentState",
                value: function getCurrentState() {
                    if (!this.handlerConnector) return {};
                    var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor, this.props);
                    return nextState;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    return (0, $6dd45a7735069a79$exports.jsx)((0, $da3b103bf3c94d3b$export$2d5c5ceac203fc1e).Consumer, {
                        children: function children(_ref2) {
                            var dragDropManager = _ref2.dragDropManager;
                            _this2.receiveDragDropManager(dragDropManager);
                            if (typeof requestAnimationFrame !== "undefined") requestAnimationFrame(function() {
                                var _this2$handlerConnect;
                                return (_this2$handlerConnect = _this2.handlerConnector) === null || _this2$handlerConnect === void 0 ? void 0 : _this2$handlerConnect.reconnect();
                            });
                            return (0, $6dd45a7735069a79$exports.jsx)(Decorated, Object.assign({}, _this2.props, _this2.getCurrentState(), {
                                // NOTE: if Decorated is a Function Component, decoratedRef will not be populated unless it's a refforwarding component.
                                ref: (0, $b1cde746e5ea11e6$export$a77111fb0da893fd)(Decorated) ? _this2.decoratedRef : null
                            }), void 0);
                        }
                    }, void 0);
                }
            },
            {
                key: "receiveDragDropManager",
                value: function receiveDragDropManager(dragDropManager) {
                    if (this.manager !== undefined) return;
                    (0, $2daa4a08f076625e$export$f5708dca728d7177)(dragDropManager !== undefined, "Could not find the drag and drop manager in the context of %s. Make sure to render a DndProvider component in your top-level component. Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#could-not-find-the-drag-and-drop-manager-in-the-context", displayName, displayName);
                    if (dragDropManager === undefined) return;
                    this.manager = dragDropManager;
                    this.handlerMonitor = createMonitor(dragDropManager);
                    this.handlerConnector = createConnector(dragDropManager.getBackend());
                    this.handler = createHandler(this.handlerMonitor, this.decoratedRef);
                }
            }
        ]);
        return DragDropContainer;
    }((0, $4DE7A.Component));
    $78f2df3bcc3325ac$var$_defineProperty(DragDropContainer, "DecoratedComponent", DecoratedComponent);
    $78f2df3bcc3325ac$var$_defineProperty(DragDropContainer, "displayName", "".concat(containerDisplayName, "(").concat(displayName, ")"));
    return (0, (/*@__PURE__*/$parcel$interopDefault($34Pgq)))(DragDropContainer, DecoratedComponent);
}




function $68e9e49f217a4df3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $68e9e49f217a4df3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $68e9e49f217a4df3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $68e9e49f217a4df3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $68e9e49f217a4df3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $68e9e49f217a4df3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $68e9e49f217a4df3$var$ALLOWED_SPEC_METHODS = [
    "canDrag",
    "beginDrag",
    "isDragging",
    "endDrag"
];
var $68e9e49f217a4df3$var$REQUIRED_SPEC_METHODS = [
    "beginDrag"
];
var $68e9e49f217a4df3$var$SourceImpl = /*#__PURE__*/ function() {
    function SourceImpl(spec, monitor, ref) {
        var _this = this;
        $68e9e49f217a4df3$var$_classCallCheck(this, SourceImpl);
        $68e9e49f217a4df3$var$_defineProperty(this, "props", null);
        $68e9e49f217a4df3$var$_defineProperty(this, "spec", void 0);
        $68e9e49f217a4df3$var$_defineProperty(this, "monitor", void 0);
        $68e9e49f217a4df3$var$_defineProperty(this, "ref", void 0);
        $68e9e49f217a4df3$var$_defineProperty(this, "beginDrag", function() {
            if (!_this.props) return;
            var item = _this.spec.beginDrag(_this.props, _this.monitor, _this.ref.current);
            return item;
        });
        this.spec = spec;
        this.monitor = monitor;
        this.ref = ref;
    }
    $68e9e49f217a4df3$var$_createClass(SourceImpl, [
        {
            key: "receiveProps",
            value: function receiveProps(props) {
                this.props = props;
            }
        },
        {
            key: "canDrag",
            value: function canDrag() {
                if (!this.props) return false;
                if (!this.spec.canDrag) return true;
                return this.spec.canDrag(this.props, this.monitor);
            }
        },
        {
            key: "isDragging",
            value: function isDragging(globalMonitor, sourceId) {
                if (!this.props) return false;
                if (!this.spec.isDragging) return sourceId === globalMonitor.getSourceId();
                return this.spec.isDragging(this.props, this.monitor);
            }
        },
        {
            key: "endDrag",
            value: function endDrag() {
                if (!this.props) return;
                if (!this.spec.endDrag) return;
                this.spec.endDrag(this.props, this.monitor, (0, $b1cde746e5ea11e6$export$c4f820ef5e50813b)(this.ref));
            }
        }
    ]);
    return SourceImpl;
}();
function $68e9e49f217a4df3$export$a1c3dcd79687eab1(spec) {
    Object.keys(spec).forEach(function(key) {
        (0, $2daa4a08f076625e$export$f5708dca728d7177)($68e9e49f217a4df3$var$ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have some of the following keys: %s. Instead received a specification with an unexpected "%s" key. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', $68e9e49f217a4df3$var$ALLOWED_SPEC_METHODS.join(", "), key);
        (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof spec[key] === "function", "Expected %s in the drag source specification to be a function. Instead received a specification with %s: %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source", key, key, spec[key]);
    });
    $68e9e49f217a4df3$var$REQUIRED_SPEC_METHODS.forEach(function(key) {
        (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof spec[key] === "function", "Expected %s in the drag source specification to be a function. Instead received a specification with %s: %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source", key, key, spec[key]);
    });
    return function createSource(monitor, ref) {
        return new $68e9e49f217a4df3$var$SourceImpl(spec, monitor, ref);
    };
}


function $7595e846cc562683$export$ab54abbdde9d5f2(type, spec, collect) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    (0, $b1cde746e5ea11e6$export$ffeaa70abe2dcf1c)("DragSource", "type, spec, collect[, options]", type, spec, collect, options);
    var getType = type;
    if (typeof type !== "function") {
        (0, $2daa4a08f076625e$export$f5708dca728d7177)((0, $b1cde746e5ea11e6$export$2698d5b4be829db6)(type), 'Expected "type" provided as the first argument to DragSource to be a string, or a function that returns a string given the current props. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', type);
        getType = function getType() {
            return type;
        };
    }
    (0, $2daa4a08f076625e$export$f5708dca728d7177)((0, $b1cde746e5ea11e6$export$53b83ca8eaab0383)(spec), 'Expected "spec" provided as the second argument to DragSource to be a plain object. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', spec);
    var createSource = (0, $68e9e49f217a4df3$export$a1c3dcd79687eab1)(spec);
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof collect === "function", 'Expected "collect" provided as the third argument to DragSource to be a function that returns a plain object of props to inject. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', collect);
    (0, $2daa4a08f076625e$export$f5708dca728d7177)((0, $b1cde746e5ea11e6$export$53b83ca8eaab0383)(options), 'Expected "options" provided as the fourth argument to DragSource to be a plain object when specified. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', collect);
    return function decorateSource(DecoratedComponent) {
        return (0, $78f2df3bcc3325ac$export$868ec1615c0ccfd8)({
            containerDisplayName: "DragSource",
            createHandler: createSource,
            registerHandler: (0, $e363ee57e8e93320$export$51c814b9e17958c),
            createConnector: function createConnector(backend) {
                return new (0, $2d677526b18c5d53$export$9a7176fb37ab5028)(backend);
            },
            createMonitor: function createMonitor(manager) {
                return new (0, $efcd7e8d00124713$export$af934094fb48ddf)(manager);
            },
            DecoratedComponent: DecoratedComponent,
            getType: getType,
            collect: collect,
            options: options
        });
    };
}









$4ed287471404a1ad$var$SegmentForPalette.propTypes = {
    // Provided by react-dnd
    connectDragSource: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    connectDragPreview: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    // Provided by parent
    segment: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object,
    unlockCondition: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
        "SIGN_IN",
        "SUBSCRIBE"
    ]),
    randSeed: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
    ]),
    tooltipTarget: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object
};
function $4ed287471404a1ad$var$SegmentForPalette({ segment: segment, unlockCondition: unlockCondition, randSeed: randSeed, tooltipTarget: tooltipTarget, ...props }) {
    const flags = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.flags);
    const isSignedIn = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.signedIn);
    const isSubscriber = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.isSubscriber);
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    props.connectDragPreview((0, $a7f417e231983d05$export$bf32f66787bcad4b)(), {
        captureDraggingState: true
    });
    // Get localized display names
    function getLabel(segment) {
        const defaultMessage = segment.name;
        return intl.formatMessage({
            id: `segments.${segment.nameKey}`,
            defaultMessage: defaultMessage
        });
    }
    const classNames = [
        "segment",
        "segment-in-palette"
    ];
    let isLocked = false;
    let sublabel = null;
    if (unlockCondition && !(segment.unlockWithFlag && flags[segment.unlockWithFlag]?.value === true)) switch(unlockCondition){
        case "SUBSCRIBE":
            if (!isSubscriber) {
                classNames.push("segment-disabled");
                isLocked = true;
                sublabel = intl.formatMessage({
                    id: "plus.locked.sub",
                    // Default message ends with a Unicode-only left-right order mark
                    // to allow for proper punctuation in `rtl` text direction
                    // This character is hidden from editors by default!
                    defaultMessage: "Upgrade to Streetmix+ to use!\u200E"
                });
            }
            break;
        case "SIGN_IN":
        default:
            if (!isSignedIn) {
                classNames.push("segment-disabled");
                isLocked = true;
                sublabel = intl.formatMessage({
                    id: "plus.locked.user",
                    // Default message ends with a Unicode-only left-right order mark
                    // to allow for proper punctuation in `rtl` text direction
                    // This character is hidden from editors by default!
                    defaultMessage: "Sign in to use!\u200E"
                });
            }
            break;
    }
    const thumbnail = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(`thumbnails--${segment.id}`)?.src || (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("thumbnails--missing")?.src;
    const node = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
        className: classNames.join(" "),
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
                target: tooltipTarget,
                label: getLabel(segment),
                sublabel: sublabel,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                    tabIndex: "0",
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                        className: "segment-image",
                        src: thumbnail
                    })
                })
            }),
            isLocked && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                icon: (0, $5cbf5c54789c9bf6$export$e6d53d6f898a52bd)
            })
        ]
    });
    // If disabled, return node as-is.
    // Otherwise, return node wrapped with react-dnd abilities.
    if (isLocked) return node;
    else return props.connectDragSource(node);
}
var $4ed287471404a1ad$export$2e2bcd8739ae039 = (0, $7595e846cc562683$export$ab54abbdde9d5f2)((0, $b6e16a46f37cea3c$export$4624c240901a6889).PALETTE_SEGMENT, (0, $b6e16a46f37cea3c$export$26ee54c509c9c33), (0, $b6e16a46f37cea3c$export$547f4e518ca74a90))($4ed287471404a1ad$var$SegmentForPalette);





function $5a9521677524fa11$var$PaletteItems(props) {
    const flags = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.flags);
    const locale = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.locale);
    const [source, target] = (0, $7de18142ef01be1a$export$abf4268d2dd55708)();
    const scrollable = (0, $4DE7A.useRef)();
    // `randSeed` is stored as a ref so that its value does not change
    // on every re-render
    const randSeed = (0, $4DE7A.useRef)((0, $5bb3a44e0e01d545$export$29ee64aa80b9fa13)());
    (0, $4DE7A.useEffect)(()=>{
        if (scrollable.current) window.setTimeout(scrollable.current.checkButtonVisibilityState, 0);
    }, []);
    const segments = (0, $0cc5ae9f1eba4866$export$999c0cd701be1fe2)();
    // For each segment, filter out the ones that have been disabled
    // by feature flag
    const displayedSegments = segments.filter((segment)=>!segment.enableWithFlag || segment.enableWithFlag && flags[segment.enableWithFlag]?.value).map((segment)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $4ed287471404a1ad$export$2e2bcd8739ae039), {
            segment: segment,
            unlockCondition: segment.unlockCondition,
            randSeed: randSeed.current,
            tooltipTarget: target
        }, segment.id));
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
                source: source
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d1eb3c02169e64a6$export$2e2bcd8739ae039), {
                className: "palette-items",
                ref: scrollable,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.IntlProvider), {
                    locale: locale.locale,
                    messages: locale.segmentInfo,
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("ul", {
                        children: displayedSegments
                    })
                })
            })
        ]
    });
}
var $5a9521677524fa11$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).memo($5a9521677524fa11$var$PaletteItems);



parcelRequire("4DE7A");



function $3310d98772388ff5$var$PaletteTrashcan(props) {
    // Display the trashcan when user is dragging an _existing_ segment on the street.
    // Don't display the trashcan when the user is dragging a _new_ segment from the palette.
    // `draggedSegment` is `null` when no drag action is being performed.
    // `draggedSegment` is `undefined` when the user is dragging a _new_ segment.
    // Don't use a falsy check, as `draggedSegment` is `0` for the first segment.
    const visible = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.ui.draggingState && Number.isInteger(state.ui.draggingState.draggedSegment));
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "palette-trashcan",
        hidden: !visible,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "palette.remove",
            defaultMessage: "Drag here to remove"
        })
    });
}
var $3310d98772388ff5$export$2e2bcd8739ae039 = $3310d98772388ff5$var$PaletteTrashcan;




var $4DE7A = parcelRequire("4DE7A");






function $261b34c04009807a$var$EnvironmentButton(props) {
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    function handleClickTools() {
        dispatch((0, $cb9eeb171d537a5a$export$8cfc7625e381dff9)());
    }
    const label = intl.formatMessage({
        id: "tools.environment.tooltip",
        defaultMessage: "Environment editor"
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
        label: label,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
            onClick: handleClickTools,
            title: label,
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                icon: "sun"
            })
        })
    });
}
var $261b34c04009807a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).memo($261b34c04009807a$var$EnvironmentButton);




var $4DE7A = parcelRequire("4DE7A");








function $251e7892e24cd0e6$var$UndoRedo(props) {
    const undoPosition = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.history.position);
    const undoStack = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.history.stack);
    const [source, target] = (0, $7de18142ef01be1a$export$abf4268d2dd55708)();
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    // Don’t allow undo/redo unless you own the street
    function isUndoAvailable() {
        return undoPosition > 0 && (0, $846d9bfc81d2582a$export$adbfba29f0dd9074)();
    }
    function isRedoAvailable() {
        return undoPosition >= 0 && undoPosition < undoStack.length - 1 && (0, $846d9bfc81d2582a$export$adbfba29f0dd9074)();
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
                source: source
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
                target: target,
                label: intl.formatMessage({
                    id: "btn.undo",
                    defaultMessage: "Undo"
                }),
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                    onClick: ()=>dispatch((0, $7e4b1d33bc4e936e$export$6e8acc5113ad37bb)()),
                    disabled: !isUndoAvailable(),
                    title: intl.formatMessage({
                        id: "btn.undo",
                        defaultMessage: "Undo"
                    }),
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                        icon: (0, $5cbf5c54789c9bf6$export$62a054fae6e6f973)
                    })
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
                target: target,
                label: intl.formatMessage({
                    id: "btn.redo",
                    defaultMessage: "Redo"
                }),
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                    onClick: ()=>dispatch((0, $7e4b1d33bc4e936e$export$1a0a23265463691b)()),
                    disabled: !isRedoAvailable(),
                    title: intl.formatMessage({
                        id: "btn.redo",
                        defaultMessage: "Redo"
                    }),
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                        icon: (0, $5cbf5c54789c9bf6$export$4e2abe3ed27cb5b0)
                    })
                })
            })
        ]
    });
}
var $251e7892e24cd0e6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).memo($251e7892e24cd0e6$var$UndoRedo);



// NOTE: The "palette-container" div element is used to recalculate layout
// inside the global window resize handler. If you rename the element, you
// must also update the querySelector in that handler. Also, please do not
// introduce logic that conditionally renders the palette during app usage,
// as it will not call the resize handler to update layout positioning.
function $2f361047f0e45571$var$PaletteContainer(props) {
    const readOnly = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.app.readOnly);
    const everythingLoaded = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.app.everythingLoaded);
    // Do not render the palette if app is in read-only mode
    if (readOnly) return null;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "palette-container-outer",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
            className: "palette-container",
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                    className: "palette-commands palette-commands-left",
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $261b34c04009807a$export$2e2bcd8739ae039), {})
                }),
                everythingLoaded && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5a9521677524fa11$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                    className: "palette-commands palette-commands-right",
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $251e7892e24cd0e6$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $3310d98772388ff5$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
var $2f361047f0e45571$export$2e2bcd8739ae039 = $2f361047f0e45571$var$PaletteContainer;



parcelRequire("4DE7A");



var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");
/**
 * This is a stock error boundary component.
 * See https://reactjs.org/docs/error-boundaries.html
 */ class $d95a0e0635013952$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    // eslint-disable-next-line n/handle-callback-err
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        // Log out a message
        console.error(error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            if (this.props.fallbackElement) return this.props.fallbackElement;
            else // TODO: render a better custom fallback UI
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                children: "Something went wrong."
            });
        }
        return this.props.children;
    }
}
$d95a0e0635013952$var$ErrorBoundary.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).node,
    fallbackElement: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).node
};
var $d95a0e0635013952$export$2e2bcd8739ae039 = $d95a0e0635013952$var$ErrorBoundary;


/**
 * About Streetmix (dialog box)
 *
 * Renders the "About" dialog box.
 *
 */ 

var $4DE7A = parcelRequire("4DE7A");




var $86674f7ec3f79cd1$exports = {};

$86674f7ec3f79cd1$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "numo.8fff37bf.svg";


var $ffd3a7a0bc553a20$exports = {};

$ffd3a7a0bc553a20$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "codeforamerica.506a3ceb.png";


var $edadbf5c8405e524$exports = {};

$edadbf5c8405e524$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "mozilla.a364f65c.svg";




var $4DE7A = parcelRequire("4DE7A");


parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");


function $cb65beb3bbbc03e2$var$TeamMember(props) {
    const { name: name, title: title, mugshotFile: mugshotFile, url: url } = props;
    const style = {};
    if (mugshotFile) style.backgroundImage = `url('/images/team/${mugshotFile}')`;
    const displayName = url ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
        href: url,
        children: name
    }) : name;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "team-member",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "team-member-mugshot",
                style: style
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                className: "team-member-name",
                children: displayName
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                className: "team-member-title",
                children: title
            })
        ]
    });
}
$cb65beb3bbbc03e2$var$TeamMember.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    mugshotFile: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    url: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
};
var $cb65beb3bbbc03e2$export$2e2bcd8739ae039 = $cb65beb3bbbc03e2$var$TeamMember;


var $6774dbc67cf0fdcc$exports = {};
$6774dbc67cf0fdcc$exports = JSON.parse('{"team":[{"name":"Lou Huang","title":"project lead","mugshotFile":"lou.jpg","url":"https://louhuang.com","active":true,"original":true},{"name":"Katie Lewis","title":"art director, illustrator","mugshotFile":"katie.jpg","url":"https://twitter.com/klizlewis","active":true,"original":true},{"name":"Anselm Bradford","title":"media production","mugshotFile":"anselm.jpg","url":"https://twitter.com/anselmbradford","active":false,"original":true},{"name":"Drew Dara-Abrams","title":"fullstack engineer","mugshotFile":"drew.jpg","url":"https://drew.dara-abrams.com","active":false},{"name":"Elizabeth Ferrao","title":"product manager","mugshotFile":"elizabeth.jpg","active":false},{"name":"Ezra Spier","title":"engineer, marketing","mugshotFile":"ezra.jpg","url":"http://ahhrrr.com","active":false,"original":true},{"name":"Mandy Kong","mugshotFile":"mandy.jpg","title":"fullstack engineer","active":false},{"name":"Marc H\xe9bert","title":"design anthropologist","mugshotFile":"marc.jpg","url":"https://www.linkedin.com/pub/marc-hebert/1/2bb/66","active":false,"original":true},{"name":"Marcin Wichary","title":"designer, project manager","mugshotFile":"marcin.jpg","url":"https://aresluna.org","active":false,"original":true},{"name":"Oluwaseun Omoyajowo","mugshotFile":"oluwaseun.jpg","title":"fullstack engineer","url":"https://twitter.com/oluwaseunOmoya","active":false},{"name":"Ryder Ross","mugshotFile":"ryder.jpg","title":"fullstack engineer","active":false},{"name":"Shaunak Kashyap","title":"backend engineer","mugshotFile":"shaunak.jpg","url":"https://twitter.com/shaunak","active":false,"original":true},{"name":"Shemar Dacosta","mugshotFile":"shemar.jpg","title":"frontend engineer","active":false},{"name":"Tomasz Magulski","mugshotFile":"tomasz.jpg","title":"engineer","active":false},{"name":"Trey Hahn","mugshotFile":"trey.jpg","title":"localization project manager","url":"https://www.linkedin.com/in/treyhahn/","active":false},{"name":"Whitman Schorn","mugshotFile":"whitman.jpg","title":"engineer","url":"https://whitmanschorn.com","active":false}],"contributors":{"additional-illustrations":["Brian Wamsley","Claudio Olivares Medina","Doneliza Joaquin","Enrico Ferreguti","Jon Reese","Peter Welte"],"additional-code":["Alex Ellis","Ali Idrees","Andr\xe9 Lins","Annabel Church","Anton Panasenko","Andrew Gilbert","Ayush Rawal","Brewal Derouet","Cody Moss","Don McCurdy","Dwiki Arlan","Eric Sherman","Joe James-Rodriguez","Kieran Farr","Maciej Kus","Mila Frerichs","Paulius Kuzmickas","Rados\u0142aw Miernik","Tanya Yakovleva","Tommi Vainikainen"],"additional-contributors":[["Aline Reynolds","writer and researcher"],["Amir Reavis-Bey","database migration"],["Patrick McDonnell","illustrations styleguide"],["Jeremy Lechtzin","legal counsel"],["Justine Braisted","branding"],["Lisa Ratner","user experience"],["Mebrak Tareke","communications"],["Nick Doiron","right-to-left localization"],["Wendy Fok","project manager"]],"special-thanks":["Adrian Mak","Jeff Speck","Molly King",["Billy Riggs","ReStreet"],["Michael Boswell","ReStreet"],["Pia Mancini","OpenCollective"],"Matt Hampel","Brandon Liu",["Debs Schrimmer","Lyft"],["Rob McPherson","Skip"],["Carlos Pardo","NUMO"],{"label":"Code for America","people":["Alex Tran","Andrew Hyder","Dave Guarino","Jen Pahlka","Mike Migurski","SaraT Mayer"]},{"label":"NEW INC","people":["Alex Darby","Julia Kaganskiy","Kelsa Trom","Michelle Carollo","Rasu Jilani","Stephanie Pereira"]},{"label":"Civic Hall","people":["Ellen Mendlow","Shaneka Ramdeen"]}]},"translators":{"am":["Gashaw Aberra","Carolyne Mimano"],"ar":["Diana M. Alhaj","Zakaria Shekhreet"],"ca":["Max Eritja","Ignasi Gustems"],"cs":["Ji\u0159\xed Podhoreck\xfd"],"zh":["Crystal Xing","Maggie Dong","Ricky Tsui","Summer Pan","Wen Jing Jiang"],"fi":["Aleksi Kinnunen"],"fr":["Denis Devill\xe9","Jean-Louis Stanus","Philippe Provost"],"de":["Julia Tahedl","Martin Niegl","Max Maa\xdf"],"id":["Fuad Alghaffary"],"it":["Enrico Ferreguti","Marco Scarselli"],"ja":["Hitomi Narakawa","Satoshi Iida"],"ko":["Sunha Park","Hanbyul Jo","Jaeheon Kim"],"nb-no":["Anders Hartmann","B\xf8rge A. Roum"],"pl":["Honorata Grzesikowska","Tomasz Magulski","Weronika Grzejszczak","Wojciech Patelka"],"pt-br":["Carlos Jimenez","Stephan Garcia",["Carolina Guido","Urb-i"],["Paulo Franco","Urb-i"],["Yuval Fogelson","Urb-i"]],"ru":["Artem Savin","Olya Arakhouskaya"],"es-419":["Lina Marcela Qui\xf1ones"],"es-es":["Pau Mart\xed Talens"],"es-mx":["David Soto Pad\xedn","Paco Marquez","Patricio M. Ruiz Abr\xedn"],"sv":["Jakob Fahlstedt","Dennis Haagensen"],"tr":["Hayrettin G\xfcn\xe7","Hande S\u0131\u011F\u0131n"]}}');



// NOTE: on testing this component
//
// The `<Credits />` component is rendered inside of a snapshot of `<AboutDialog />`
// and does not need to be unit-tested on its own. When `<AboutDialog />` renders a
// snapshot, it uses a mock version of `credits.json`. This allows the component to
// test rendering logic without needing to change the snapshot when the credits
// themselves change.
function $00666099222ada85$var$alphabetizeNames(a, b) {
    // Ignore case
    const nameA = a.name.toLowerCase();
    const nameB = b.name.toLowerCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    // If names are equal
    return 0;
}
// This is a temporary stash of English-language labels for credits
// because right now we don't have a way to fall back when a label is untranslated.
// We can remove this once this has been built into our localization infrastructure.
const $00666099222ada85$var$UNTRANSLATED_LABELS = {
    advisors: "Advisors",
    "additional-illustrations": "Additional illustrations",
    "additional-code": "Additional code",
    "additional-contributors": "Additional contributors",
    "special-thanks": "Special thanks to",
    ar: "Arabic",
    ca: "Catalan",
    de: "German",
    en: "English",
    es: "Spanish",
    "es-mx": "Spanish (Mexico)",
    "es-419": "Spanish (Latin America)",
    fi: "Finnish",
    fr: "French",
    it: "Italian",
    ja: "Japanese",
    ko: "Korean",
    "nb-no": "Norwegian Bokm\xe5l",
    pl: "Polish",
    "pt-br": "Portuguese (Brazil)",
    ru: "Russian",
    sv: "Swedish",
    zh: "Chinese"
};
function $00666099222ada85$var$Credits(props) {
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "credits.original-team-heading",
                    defaultMessage: "Original project team"
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "credits-team credits-team-past",
                children: (0, (/*@__PURE__*/$parcel$interopDefault($6774dbc67cf0fdcc$exports))).team.filter((person)=>person.original === true).sort($00666099222ada85$var$alphabetizeNames).map((person)=>/*#__PURE__*/ (0, $4DE7A.createElement)((0, $cb65beb3bbbc03e2$export$2e2bcd8739ae039), {
                        ...person,
                        key: person.name
                    }))
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "credits.core-contributors",
                    defaultMessage: "Core contributors"
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "credits-team credits-team-past",
                children: (0, (/*@__PURE__*/$parcel$interopDefault($6774dbc67cf0fdcc$exports))).team.filter((person)=>!person.original).sort($00666099222ada85$var$alphabetizeNames).map((person)=>/*#__PURE__*/ (0, $4DE7A.createElement)((0, $cb65beb3bbbc03e2$export$2e2bcd8739ae039), {
                        ...person,
                        key: person.name
                    }))
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "credits-container",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "credits-credits-left",
                        children: Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($6774dbc67cf0fdcc$exports))).contributors).map(([key, value])=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h3", {
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: `credits.${key}`,
                                            defaultMessage: $00666099222ada85$var$UNTRANSLATED_LABELS[key]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("ul", {
                                        children: value.sort().map((name)=>Array.isArray(name) ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                                                children: [
                                                    name[0],
                                                    ", ",
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("i", {
                                                        children: name[1]
                                                    })
                                                ]
                                            }, name[0]) : typeof name === "string" ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
                                                children: name
                                            }, name) : /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h4", {
                                                        children: name.label
                                                    }),
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("ul", {
                                                        children: name.people.map((person)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
                                                                children: person
                                                            }, person))
                                                    })
                                                ]
                                            }, name.label))
                                    })
                                ]
                            }, key))
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "credits-credits-right",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h3", {
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "credits.translators",
                                    defaultMessage: "Translators"
                                })
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("ul", {
                                children: Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($6774dbc67cf0fdcc$exports))).translators).map(([key, value])=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h4", {
                                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: `i18n.lang.${key}`,
                                                    defaultMessage: $00666099222ada85$var$UNTRANSLATED_LABELS[key]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("ul", {
                                                children: value.sort().map((name)=>Array.isArray(name) ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                                                        children: [
                                                            name[0],
                                                            ", ",
                                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("i", {
                                                                children: name[1]
                                                            })
                                                        ]
                                                    }, name[0]) : /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
                                                        children: name
                                                    }, name))
                                            })
                                        ]
                                    }, key))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $00666099222ada85$export$2e2bcd8739ae039 = $00666099222ada85$var$Credits;



parcelRequire("4DE7A");


function $c4dd23572be26c0b$var$SocialLinks(props) {
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("ul", {
        className: "social-links",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                    href: "https://github.com/streetmix/",
                    title: "GitHub",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                        icon: "github",
                        className: "social-github"
                    })
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                    href: "https://strt.mx/discord",
                    title: "Discord",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                        icon: "discord",
                        className: "social-discord"
                    })
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                    href: "https://urbanists.social/@streetmix",
                    title: "Mastodon",
                    target: "_blank",
                    rel: "me noopener noreferrer",
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                        icon: "mastodon",
                        className: "social-mastodon"
                    })
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                    href: "https://twitter.com/streetmix",
                    title: "Twitter",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                        icon: "twitter",
                        className: "social-twitter"
                    })
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                    href: "https://www.instagram.com/streetmixapp/",
                    title: "Instagram",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                        icon: "instagram",
                        className: "social-instagram"
                    })
                })
            })
        ]
    });
}
var $c4dd23572be26c0b$export$2e2bcd8739ae039 = $c4dd23572be26c0b$var$SocialLinks;


/**
 * Dialog
 *
 * These things are actually modals, since they block the main window.
 * They're positioned over everything else in the app and will prevent
 * interaction with the rest of the app until it's closed.
 *
 * Clicking on the modal's backdrop will automatically close the modal.
 * We used to have dialogs that prevented this form of closing, but
 * they're not used anymore, so this functionality has been removed.
 * Modals that behave differently from each other is probably not a
 * great idea.
 *
 * Only one modal window is shown at a time. Nested modals aren't supported.
 */ 

var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");




var $4DE7A = parcelRequire("4DE7A");



function $f9d7843891fda220$var$CloseButton({ title: title, className: className = "close", onClick: onClick, ...restProps }) {
    const defaultTitle = (0, $d05758791eb139fa$exports.useIntl)().formatMessage({
        id: "btn.dismiss",
        defaultMessage: "Dismiss"
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
        className: className,
        onClick: onClick,
        title: title ?? defaultTitle,
        ...restProps,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $35f760dc3fc04eda$export$5e658a8851ae9322), {
            size: 16
        })
    });
}
var $f9d7843891fda220$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $4DE7A.memo)($f9d7843891fda220$var$CloseButton);


/**
 * useOnClickOutside React Hook
 * from https://usehooks.com/useOnClickOutside/
 *
 * This hook allows you to detect clicks outside of a specified element.
 * For example, use this to close a modal when any element outside of the modal
 * is clicked. By abstracting this logic out into a hook we can easily use it
 * across all of our components that need this kind of functionality (dropdown
 * menus, tooltips, etc).
 */ 
var $4DE7A = parcelRequire("4DE7A");
function $baa5f10dda5386f3$export$9afc64c180e82dc4(ref, handler) {
    (0, $4DE7A.useEffect)(()=>{
        const listener = (event)=>{
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target)) return;
            handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new
    // function on every render that will cause this effect
    // callback/cleanup to run every render. It's not a big deal
    // but to optimize you can wrap handler in useCallback before
    // passing it into this hook.
    [
        ref,
        handler
    ]);
}





$33ed200ba87fcf5c$var$Dialog.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired
};
function $33ed200ba87fcf5c$var$Dialog({ children: children }) {
    // Appear state controls transition in/out
    const dialogEl = (0, $4DE7A.useRef)(null);
    const [appear, setAppear] = (0, $4DE7A.useState)(true);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    // Set up handler to close dialogs when clicking outside of it
    (0, $baa5f10dda5386f3$export$9afc64c180e82dc4)(dialogEl, handleClose);
    // Set up keypress listener to close dialogs if open
    (0, $4DE7A.useEffect)(()=>{
        (0, $89f2807011121cdf$export$bc520ed1c57f0d75)("esc", handleClose);
        return ()=>{
            (0, $89f2807011121cdf$export$86df18839624bc06)("esc", handleClose);
        };
    }, []);
    // On "close", we animate the dialog out
    function handleClose() {
        setAppear(false);
    }
    // When the animation is complete, then we clear dialog state
    function handleExit() {
        dispatch((0, $cdf0aaca62d15025$export$8c29086285c64d2d)());
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $13c11db3c6cdc4a8$export$2e2bcd8739ae039), {
        appear: true,
        in: appear,
        timeout: 80,
        classNames: "dialog-transition",
        onExited: handleExit,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
            className: "dialog-box-container",
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                    className: "dialog-box-backdrop"
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                    className: "dialog-box",
                    role: "dialog",
                    ref: dialogEl,
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $f9d7843891fda220$export$2e2bcd8739ae039), {
                            onClick: handleClose
                        }),
                        children(handleClose)
                    ]
                })
            ]
        })
    });
}
var $33ed200ba87fcf5c$export$2e2bcd8739ae039 = $33ed200ba87fcf5c$var$Dialog;



function $3b091dd2036ada6f$var$AboutDialog(props) {
    const offline = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.system.offline);
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $33ed200ba87fcf5c$export$2e2bcd8739ae039), {
        children: (closeDialog)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "about-dialog",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("header", {
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($10abdc0bd635538b$exports))),
                                alt: "Streetmix (logo)",
                                className: "about-dialog-logo"
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "dialogs.about.heading",
                                    defaultMessage: "About Streetmix."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "dialog-content",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                            className: "about-dialog-content",
                            children: [
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                    className: "about-dialog-left",
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                id: "dialogs.about.description",
                                                defaultMessage: "Design, remix, and share your street. Add bike paths, widen sidewalks or traffic lanes, learn how all of this can impact your community."
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $c4dd23572be26c0b$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h3", {
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                id: "dialogs.about.partners",
                                                defaultMessage: "Partners"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("ul", {
                                            className: "about-dialog-sponsors",
                                            children: [
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                        href: "https://numo.global/",
                                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($86674f7ec3f79cd1$exports))),
                                                            alt: "New Urban Mobility Alliance"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                        href: "https://codeforamerica.org/",
                                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ffd3a7a0bc553a20$exports))),
                                                            alt: "Code for America"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h3", {
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                id: "dialogs.about.sponsors",
                                                defaultMessage: "Sponsors"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("ul", {
                                            className: "about-dialog-sponsors",
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                    href: "https://www.mozilla.org/en-US/moss/",
                                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($edadbf5c8405e524$exports))),
                                                        alt: "Mozilla Open Source Support"
                                                    })
                                                })
                                            })
                                        }),
                                        !offline && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                                                    href: "https://streetmix.net/terms-of-service/",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                        id: "dialogs.about.tos-link",
                                                        defaultMessage: "Terms of service"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                                                    href: "https://streetmix.net/privacy-policy/",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                        id: "dialogs.about.privacy-link",
                                                        defaultMessage: "Privacy policy"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                    className: "about-dialog-right",
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $00666099222ada85$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                            className: "credits-container",
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h3", {
                                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                            id: "dialogs.about.acknowledgements",
                                                            defaultMessage: "Acknowledgements"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("ul", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                                        id: "dialogs.about.font-designed-by",
                                                                        defaultMessage: "{fontName} font designed by {fontAuthor}.",
                                                                        values: {
                                                                            fontName: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                                                href: "https://manropefont.com/",
                                                                                children: "Manrope"
                                                                            }),
                                                                            fontAuthor: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                                                href: "https://gent.media/",
                                                                                children: "Mikhail Shiranda"
                                                                            })
                                                                        }
                                                                    }),
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                                        id: "dialogs.about.license-label",
                                                                        defaultMessage: "(<a>License</a>)",
                                                                        values: {
                                                                            // eslint-disable-next-line react/display-name
                                                                            a: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                                                    href: "https://scripts.sil.org/cms/scripts/page.php?site_id=nrsi&id=OFL",
                                                                                    title: "SIL Open Font License, Version 1.1",
                                                                                    children: chunks
                                                                                })
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                                        id: "dialogs.about.font-designed-by",
                                                                        defaultMessage: "{fontName} font designed by {fontAuthor}.",
                                                                        values: {
                                                                            fontName: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                                                href: "https://hubertfischer.com/work/type-rubik",
                                                                                children: "Rubik"
                                                                            }),
                                                                            fontAuthor: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                                                href: "https://hubertfischer.com/",
                                                                                children: "Hubert & Fischer"
                                                                            })
                                                                        }
                                                                    }),
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                                        id: "dialogs.about.license-label",
                                                                        defaultMessage: "(<a>License</a>)",
                                                                        values: {
                                                                            // eslint-disable-next-line react/display-name
                                                                            a: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                                                    href: "https://scripts.sil.org/cms/scripts/page.php?site_id=nrsi&id=OFL",
                                                                                    title: "SIL Open Font License, Version 1.1",
                                                                                    children: chunks
                                                                                })
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                                        id: "dialogs.about.font-designed-by",
                                                                        defaultMessage: "{fontName} font designed by {fontAuthor}.",
                                                                        values: {
                                                                            fontName: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                                                href: "https://delvefonts.com/fonts/overpass/",
                                                                                children: "Overpass"
                                                                            }),
                                                                            fontAuthor: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                                                href: "https://delvefonts.com/",
                                                                                children: "Delve Fonts"
                                                                            })
                                                                        }
                                                                    }),
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                                        id: "dialogs.about.license-label",
                                                                        defaultMessage: "(<a>License</a>)",
                                                                        values: {
                                                                            // eslint-disable-next-line react/display-name
                                                                            a: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                                                    href: "https://github.com/RedHatOfficial/Overpass/blob/master/OFL.txt",
                                                                                    title: "SIL Open Font License, Version 1.1",
                                                                                    children: chunks
                                                                                })
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                                        id: "dialogs.about.emoji-by",
                                                                        defaultMessage: "Emoji by {author}.",
                                                                        values: {
                                                                            author: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                                                href: "https://openmoji.org/",
                                                                                children: "OpenMoji"
                                                                            })
                                                                        }
                                                                    }),
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                                        id: "dialogs.about.license-label",
                                                                        defaultMessage: "(<a>License</a>)",
                                                                        values: {
                                                                            // eslint-disable-next-line react/display-name
                                                                            a: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                                                    href: "https://creativecommons.org/licenses/by-sa/4.0/#",
                                                                                    title: "Creative Commons Share Alike License 4.0 (CC BY-SA 4.0)",
                                                                                    children: chunks
                                                                                })
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                                        id: "dialogs.about.icons-by",
                                                                        defaultMessage: "Icons by {author}.",
                                                                        values: {
                                                                            author: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                                                href: "https://fontawesome.com/",
                                                                                children: "Font Awesome"
                                                                            })
                                                                        }
                                                                    }),
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                                        id: "dialogs.about.license-label",
                                                                        defaultMessage: "(<a>License</a>)",
                                                                        values: {
                                                                            // eslint-disable-next-line react/display-name
                                                                            a: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                                                    href: "https://fontawesome.com/license/free",
                                                                                    title: "Creative Commons Share Alike License 4.0 (CC BY-SA 4.0)",
                                                                                    children: chunks
                                                                                })
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
                        className: "dialog-primary-action",
                        onClick: closeDialog,
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "btn.close",
                            defaultMessage: "Close"
                        })
                    })
                ]
            })
    });
}
var $3b091dd2036ada6f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).memo($3b091dd2036ada6f$var$AboutDialog);


/**
 * Street Analytics (dialog box)
 *
 * Renders the "Analytics" dialog box.
 *
 */ 

var $4DE7A = parcelRequire("4DE7A");




parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");


$4506383de6fe6d56$export$2e2bcd8739ae039.propTypes = {
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
};
function $4506383de6fe6d56$export$2e2bcd8739ae039(props) {
    const getCCLinkByLocale = (locale)=>{
        let url, label;
        switch(locale){
            case "ar":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.ar";
                label = "Creative Commons \u0646\u064E\u0633\u0628 \u0627\u0644\u0645\u064F\u0635\u0646\u064E\u0651\u0641 - \u0627\u0644\u062A\u0631\u062E\u064A\u0635 \u0628\u0627\u0644\u0645\u062B\u0644 4.0 \u062F\u0648\u0644\u064A (CC BY-SA 4.0)";
                break;
            case "ca":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.ca";
                label = "Reconeixement-CompartirIgual 4.0 Internacional (CC BY-SA 4.0)";
                break;
            case "de":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.de";
                // Official label
                // label = 'Creative Commons Namensnennung - Weitergabe unter gleichen Bedingungen 4.0 International (CC BY-SA 4.0)'
                // Translated by Julia Tahedl
                label = "Creative Commons Namensnennung - Share Alike 4.0 international (CC BY-SA 4.0)";
                break;
            case "es":
            case "es-MX":
            case "es-419":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.es";
                label = "Creative Commons Atribuci\xf3n-CompartirIgual 4.0 Internacional (CC BY-SA 4.0)";
                break;
            case "fi":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.fi";
                label = "Creative Commons Nime\xe4-JaaSamoin 4.0 Kansainv\xe4linen (CC BY-SA 4.0)";
                break;
            case "fr":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.fr";
                label = "Creative Commons Attribution - Partage dans les M\xeames Conditions 4.0 International (CC BY-SA 4.0)";
                break;
            case "it":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.it";
                label = "Attribuzione - Condividi allo stesso modo 4.0 Internazionale (CC BY-SA 4.0)";
                break;
            case "ja":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.ja";
                label = "\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u30FB\u30B3\u30E2\u30F3\u30BA \u8868\u793A - \u7D99\u627F 4.0 \u56FD\u969B (CC BY-SA 4.0)";
                break;
            case "ko":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.ko";
                label = "\uC800\uC791\uC790\uD45C\uC2DC-\uB3D9\uC77C\uC870\uAC74\uBCC0\uACBD\uD5C8\uB77D 4.0 \uAD6D\uC81C (CC BY-SA 4.0)";
                break;
            case "pl":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.pl";
                label = "Creative Commons Uznanie autorstwa-Na tych samych warunkach 4.0 Mi\u0119dzynarodowe (CC BY-SA 4.0)";
                break;
            case "pt":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.pt";
                label = "Creative Commons Atribui\xe7\xe3o-CompartilhaIgual 4.0 Internacional (CC BY-SA 4.0)";
                break;
            case "pt-BR":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.pt_BR";
                label = "Creative Commons Atribui\xe7\xe3o-CompartilhaIgual 4.0 Internacional (CC BY-SA 4.0)";
                break;
            case "ru":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.ru";
                label = "Creative Commons \xabAttribution-ShareAlike\xbb (\xab\u0410\u0442\u0440\u0438\u0431\u0443\u0446\u0438\u044F \u2014 \u041D\u0430 \u0442\u0435\u0445 \u0436\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445\xbb) 4.0 \u0412\u0441\u0435\u043C\u0438\u0440\u043D\u0430\u044F (CC BY-SA 4.0)";
                break;
            case "sv":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.sv";
                label = "Creative Commons Erk\xe4nnande-DelaLika 4.0 Internationell (CC BY-SA 4.0)";
                break;
            case "zh":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.zh";
                label = "Creative Commons \u7F72\u540D-\u76F8\u540C\u65B9\u5F0F\u5171\u4EAB 4.0 \u56FD\u9645 (CC BY-SA 4.0)";
            // eslint-disable-next-line no-fallthrough
            case "zh-Hant":
            case "zh-TW":
                url = "https://creativecommons.org/licenses/by-sa/4.0/deed.zh_TW";
                label = "Creative Commons \u59D3\u540D\u6A19\u793A-\u76F8\u540C\u65B9\u5F0F\u5206\u4EAB 4.0 \u570B\u969B (CC BY-SA 4.0)";
                break;
            case "en":
            default:
                url = "https://creativecommons.org/licenses/by-sa/4.0/";
                label = "Creative Commons Attribution-ShareAlike 4.0 International (CC BY-SA 4.0)";
                break;
        }
        return {
            url: url,
            label: label
        };
    };
    const renderCCLink = (locale)=>{
        const { url: url, label: label } = getCCLinkByLocale(locale);
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
            href: url,
            children: [
                label,
                "\u200E"
            ]
        });
    };
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
        id: "dialogs.save.license",
        defaultMessage: "This Streetmix-created image may be reused anywhere, for any purpose, under the {licenseLink} license.",
        values: {
            // Get locale-specific license links!
            licenseLink: renderCCLink(props.locale)
        }
    });
}



/**
 * Custom stylized checkbox component, so we control the look and
 * feel instead of relying on browser's default styles.
 */ 

var $4DE7A = parcelRequire("4DE7A");



// This stores an incrementing number for unique IDs.
let $58ebe1a968472eb7$var$idCounter = 1;
function $58ebe1a968472eb7$var$Checkbox(props) {
    const { children: children, checked: checked = false, disabled: disabled = false, value: value, onChange: onChange = ()=>undefined, id: id, className: className = "", // Remainder of props will be applied to the containing <div> element
    // for instance, `style`, data attributes, etc.
    ...restProps } = props;
    // This is a controlled component. The `useState` hook maintains
    // this component's internal state, and sets the initial state
    // based on the `checked` prop (which is `false` by default).
    const [isChecked, setChecked] = (0, $4DE7A.useState)(checked);
    // An `id` is required to associate a `label` with an `input` element.
    // You can provide one manually in props, otherwise, this component
    // will generate a unique id value for each instance. Generated ids
    // are not meant to be accessed by other code or CSS selectors.
    const elementId = (0, $4DE7A.useRef)(id);
    if (elementId.current === undefined) // This exists in an if statement to check if the ref value is present
    // to prevent the counter from incrementing on every render
    elementId.current = `checkbox-id-${$58ebe1a968472eb7$var$idCounter++}`;
    const classNames = [
        "checkbox-item"
    ];
    if (className) classNames.push(className);
    // When the value is changed, we update the state, and we also call
    // any `onChange` handler that is provided by the parent via props.
    const handleChange = (event)=>{
        setChecked(!isChecked);
        onChange(event);
    };
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: classNames.join(" "),
        ...restProps,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("input", {
                type: "checkbox",
                id: elementId.current,
                checked: isChecked,
                value: value,
                disabled: disabled,
                onChange: handleChange
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("label", {
                htmlFor: elementId.current,
                children: children
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                icon: (0, $5cbf5c54789c9bf6$export$2eb6285dfd63f7a9)
            })
        ]
    });
}
var $58ebe1a968472eb7$export$2e2bcd8739ae039 = $58ebe1a968472eb7$var$Checkbox;











var $4DE7A = parcelRequire("4DE7A");






function $f7d530f3bc1f26e9$var$CapacitySources(props) {
    const source = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street?.capacitySource || (0, $2a9a05c10189c2fe$export$9c2554d45cd8fa3));
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const [selectedSource, setSelectedSource] = (0, $4DE7A.useState)(source);
    function handleChangeSource(event) {
        setSelectedSource(event.target.value);
        dispatch((0, $8041aaeb3f701cec$export$f4638f2b755d1b4d)(event.target.value));
    }
    // Retrieve all data sources, and make it an array
    const sources = Object.values((0, $403f4a82e85beb9f$export$795d613bdc2453ad)());
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("strong", {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "dialogs.analytics.capacity-data-source",
                        defaultMessage: "Capacity data source"
                    }),
                    ":\u200E"
                ]
            }),
            " ",
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("select", {
                disabled: !(0, $846d9bfc81d2582a$export$adbfba29f0dd9074)(),
                value: selectedSource,
                onChange: handleChangeSource,
                children: sources.map(({ source_author: label, id: id })=>{
                    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("option", {
                        value: id,
                        children: label
                    }, id);
                })
            })
        ]
    });
}
var $f7d530f3bc1f26e9$export$2e2bcd8739ae039 = $f7d530f3bc1f26e9$var$CapacitySources;



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");




parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");


$f0db2ccbffb10732$var$CapacityMessage.propTypes = {
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string.isRequired,
    average: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number.isRequired,
    potential: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number.isRequired
};
function $f0db2ccbffb10732$var$CapacityMessage({ locale: locale, average: average, potential: potential }) {
    const isSingleAmount = average === potential;
    const defaultMessage = isSingleAmount ? "{amount} people/hour" : "{average} \u2014 {potential} people/hour";
    const id = isSingleAmount ? "dialogs.analytics.segment-summary-single" : "dialogs.analytics.segment-summary";
    const options = {
        maximumSignificantDigits: 3
    };
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
        id: id,
        defaultMessage: defaultMessage,
        values: {
            amount: (0, $9d270f5a79da1a95$export$f5dd818bff069720)(average, locale, options),
            average: (0, $9d270f5a79da1a95$export$f5dd818bff069720)(average, locale, options),
            potential: (0, $9d270f5a79da1a95$export$f5dd818bff069720)(potential, locale, options)
        }
    });
}
var $f0db2ccbffb10732$export$2e2bcd8739ae039 = $f0db2ccbffb10732$var$CapacityMessage;



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");
// src/index.ts
// src/hooks/useChain.ts

var $4DE7A = parcelRequire("4DE7A");
var $f4733daa0cafd2a7$var$__defProp = Object.defineProperty;
var $f4733daa0cafd2a7$var$__export = (target, all)=>{
    for(var name in all)$f4733daa0cafd2a7$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $f4733daa0cafd2a7$export$cceeabf822b64fc0 = {};
$f4733daa0cafd2a7$var$__export($f4733daa0cafd2a7$export$cceeabf822b64fc0, {
    assign: ()=>$f4733daa0cafd2a7$var$assign,
    colors: ()=>$f4733daa0cafd2a7$var$colors,
    createStringInterpolator: ()=>$f4733daa0cafd2a7$var$createStringInterpolator,
    skipAnimation: ()=>$f4733daa0cafd2a7$var$skipAnimation,
    to: ()=>$f4733daa0cafd2a7$var$to,
    willAdvance: ()=>$f4733daa0cafd2a7$var$willAdvance
});
// ../rafz/dist/react-spring_rafz.modern.mjs
var $f4733daa0cafd2a7$var$updateQueue = $f4733daa0cafd2a7$var$makeQueue();
var $f4733daa0cafd2a7$export$27f233d61a9e2fa4 = (fn)=>$f4733daa0cafd2a7$var$schedule(fn, $f4733daa0cafd2a7$var$updateQueue);
var $f4733daa0cafd2a7$var$writeQueue = $f4733daa0cafd2a7$var$makeQueue();
$f4733daa0cafd2a7$export$27f233d61a9e2fa4.write = (fn)=>$f4733daa0cafd2a7$var$schedule(fn, $f4733daa0cafd2a7$var$writeQueue);
var $f4733daa0cafd2a7$var$onStartQueue = $f4733daa0cafd2a7$var$makeQueue();
$f4733daa0cafd2a7$export$27f233d61a9e2fa4.onStart = (fn)=>$f4733daa0cafd2a7$var$schedule(fn, $f4733daa0cafd2a7$var$onStartQueue);
var $f4733daa0cafd2a7$var$onFrameQueue = $f4733daa0cafd2a7$var$makeQueue();
$f4733daa0cafd2a7$export$27f233d61a9e2fa4.onFrame = (fn)=>$f4733daa0cafd2a7$var$schedule(fn, $f4733daa0cafd2a7$var$onFrameQueue);
var $f4733daa0cafd2a7$var$onFinishQueue = $f4733daa0cafd2a7$var$makeQueue();
$f4733daa0cafd2a7$export$27f233d61a9e2fa4.onFinish = (fn)=>$f4733daa0cafd2a7$var$schedule(fn, $f4733daa0cafd2a7$var$onFinishQueue);
var $f4733daa0cafd2a7$var$timeouts = [];
$f4733daa0cafd2a7$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $f4733daa0cafd2a7$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $f4733daa0cafd2a7$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $f4733daa0cafd2a7$var$timeouts.splice(i, 1);
        $f4733daa0cafd2a7$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $f4733daa0cafd2a7$var$timeouts.splice($f4733daa0cafd2a7$var$findTimeout(time), 0, timeout);
    $f4733daa0cafd2a7$var$pendingCount += 1;
    $f4733daa0cafd2a7$var$start();
    return timeout;
};
var $f4733daa0cafd2a7$var$findTimeout = (time)=>~(~$f4733daa0cafd2a7$var$timeouts.findIndex((t)=>t.time > time) || ~$f4733daa0cafd2a7$var$timeouts.length);
$f4733daa0cafd2a7$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $f4733daa0cafd2a7$var$onStartQueue.delete(fn);
    $f4733daa0cafd2a7$var$onFrameQueue.delete(fn);
    $f4733daa0cafd2a7$var$onFinishQueue.delete(fn);
    $f4733daa0cafd2a7$var$updateQueue.delete(fn);
    $f4733daa0cafd2a7$var$writeQueue.delete(fn);
};
$f4733daa0cafd2a7$export$27f233d61a9e2fa4.sync = (fn)=>{
    $f4733daa0cafd2a7$var$sync = true;
    $f4733daa0cafd2a7$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $f4733daa0cafd2a7$var$sync = false;
};
$f4733daa0cafd2a7$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $f4733daa0cafd2a7$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $f4733daa0cafd2a7$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $f4733daa0cafd2a7$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$f4733daa0cafd2a7$export$27f233d61a9e2fa4.use = (impl)=>$f4733daa0cafd2a7$var$nativeRaf = impl;
$f4733daa0cafd2a7$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$f4733daa0cafd2a7$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$f4733daa0cafd2a7$export$27f233d61a9e2fa4.catch = console.error;
$f4733daa0cafd2a7$export$27f233d61a9e2fa4.frameLoop = "always";
$f4733daa0cafd2a7$export$27f233d61a9e2fa4.advance = ()=>{
    if ($f4733daa0cafd2a7$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $f4733daa0cafd2a7$var$update();
};
var $f4733daa0cafd2a7$var$ts = -1;
var $f4733daa0cafd2a7$var$pendingCount = 0;
var $f4733daa0cafd2a7$var$sync = false;
function $f4733daa0cafd2a7$var$schedule(fn, queue) {
    if ($f4733daa0cafd2a7$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $f4733daa0cafd2a7$var$start();
    }
}
function $f4733daa0cafd2a7$var$start() {
    if ($f4733daa0cafd2a7$var$ts < 0) {
        $f4733daa0cafd2a7$var$ts = 0;
        if ($f4733daa0cafd2a7$export$27f233d61a9e2fa4.frameLoop !== "demand") $f4733daa0cafd2a7$var$nativeRaf($f4733daa0cafd2a7$var$loop);
    }
}
function $f4733daa0cafd2a7$var$stop() {
    $f4733daa0cafd2a7$var$ts = -1;
}
function $f4733daa0cafd2a7$var$loop() {
    if (~$f4733daa0cafd2a7$var$ts) {
        $f4733daa0cafd2a7$var$nativeRaf($f4733daa0cafd2a7$var$loop);
        $f4733daa0cafd2a7$export$27f233d61a9e2fa4.batchedUpdates($f4733daa0cafd2a7$var$update);
    }
}
function $f4733daa0cafd2a7$var$update() {
    const prevTs = $f4733daa0cafd2a7$var$ts;
    $f4733daa0cafd2a7$var$ts = $f4733daa0cafd2a7$export$27f233d61a9e2fa4.now();
    const count = $f4733daa0cafd2a7$var$findTimeout($f4733daa0cafd2a7$var$ts);
    if (count) {
        $f4733daa0cafd2a7$var$eachSafely($f4733daa0cafd2a7$var$timeouts.splice(0, count), (t)=>t.handler());
        $f4733daa0cafd2a7$var$pendingCount -= count;
    }
    if (!$f4733daa0cafd2a7$var$pendingCount) {
        $f4733daa0cafd2a7$var$stop();
        return;
    }
    $f4733daa0cafd2a7$var$onStartQueue.flush();
    $f4733daa0cafd2a7$var$updateQueue.flush(prevTs ? Math.min(64, $f4733daa0cafd2a7$var$ts - prevTs) : 16.667);
    $f4733daa0cafd2a7$var$onFrameQueue.flush();
    $f4733daa0cafd2a7$var$writeQueue.flush();
    $f4733daa0cafd2a7$var$onFinishQueue.flush();
}
function $f4733daa0cafd2a7$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $f4733daa0cafd2a7$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $f4733daa0cafd2a7$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $f4733daa0cafd2a7$var$pendingCount -= current.size;
                $f4733daa0cafd2a7$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $f4733daa0cafd2a7$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $f4733daa0cafd2a7$var$eachSafely(values, each2) {
    values.forEach((value)=>{
        try {
            each2(value);
        } catch (e) {
            $f4733daa0cafd2a7$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
// src/helpers.ts
function $f4733daa0cafd2a7$export$8793edee2d425525() {}
var $f4733daa0cafd2a7$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $f4733daa0cafd2a7$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $f4733daa0cafd2a7$export$248d38f6296296c5(a, b) {
    if ($f4733daa0cafd2a7$export$226b3eccf92c9ed9.arr(a)) {
        if (!$f4733daa0cafd2a7$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $f4733daa0cafd2a7$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $f4733daa0cafd2a7$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($f4733daa0cafd2a7$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $f4733daa0cafd2a7$export$45b10814cc054894 = (a)=>$f4733daa0cafd2a7$export$226b3eccf92c9ed9.und(a) ? [] : $f4733daa0cafd2a7$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $f4733daa0cafd2a7$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $f4733daa0cafd2a7$export$79b2f7037acddd43(items, iterator);
    }
}
var $f4733daa0cafd2a7$export$7ba486852759e806 = (queue, ...args)=>$f4733daa0cafd2a7$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $f4733daa0cafd2a7$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $f4733daa0cafd2a7$var$createStringInterpolator;
var $f4733daa0cafd2a7$var$to;
var $f4733daa0cafd2a7$var$colors = null;
var $f4733daa0cafd2a7$var$skipAnimation = false;
var $f4733daa0cafd2a7$var$willAdvance = $f4733daa0cafd2a7$export$8793edee2d425525;
var $f4733daa0cafd2a7$var$assign = (globals)=>{
    if (globals.to) $f4733daa0cafd2a7$var$to = globals.to;
    if (globals.now) $f4733daa0cafd2a7$export$27f233d61a9e2fa4.now = globals.now;
    if (globals.colors !== void 0) $f4733daa0cafd2a7$var$colors = globals.colors;
    if (globals.skipAnimation != null) $f4733daa0cafd2a7$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $f4733daa0cafd2a7$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) $f4733daa0cafd2a7$export$27f233d61a9e2fa4.use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) $f4733daa0cafd2a7$export$27f233d61a9e2fa4.batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $f4733daa0cafd2a7$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) $f4733daa0cafd2a7$export$27f233d61a9e2fa4.frameLoop = globals.frameLoop;
};
// src/FrameLoop.ts
var $f4733daa0cafd2a7$var$startQueue = /* @__PURE__ */ new Set();
var $f4733daa0cafd2a7$var$currentFrame = [];
var $f4733daa0cafd2a7$var$prevFrame = [];
var $f4733daa0cafd2a7$var$priority = 0;
var $f4733daa0cafd2a7$export$a57f5080a3bcc90a = {
    get idle () {
        return !$f4733daa0cafd2a7$var$startQueue.size && !$f4733daa0cafd2a7$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($f4733daa0cafd2a7$var$priority > animation.priority) {
            $f4733daa0cafd2a7$var$startQueue.add(animation);
            $f4733daa0cafd2a7$export$27f233d61a9e2fa4.onStart($f4733daa0cafd2a7$var$flushStartQueue);
        } else {
            $f4733daa0cafd2a7$var$startSafely(animation);
            $f4733daa0cafd2a7$export$27f233d61a9e2fa4($f4733daa0cafd2a7$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $f4733daa0cafd2a7$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($f4733daa0cafd2a7$var$priority) $f4733daa0cafd2a7$export$27f233d61a9e2fa4.onFrame(()=>$f4733daa0cafd2a7$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $f4733daa0cafd2a7$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $f4733daa0cafd2a7$var$currentFrame.splice(prevIndex, 1);
                $f4733daa0cafd2a7$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $f4733daa0cafd2a7$var$currentFrame = [];
        $f4733daa0cafd2a7$var$startQueue.clear();
    }
};
function $f4733daa0cafd2a7$var$flushStartQueue() {
    $f4733daa0cafd2a7$var$startQueue.forEach($f4733daa0cafd2a7$var$startSafely);
    $f4733daa0cafd2a7$var$startQueue.clear();
    $f4733daa0cafd2a7$export$27f233d61a9e2fa4($f4733daa0cafd2a7$var$advance);
}
function $f4733daa0cafd2a7$var$startSafely(animation) {
    if (!$f4733daa0cafd2a7$var$currentFrame.includes(animation)) $f4733daa0cafd2a7$var$startUnsafely(animation);
}
function $f4733daa0cafd2a7$var$startUnsafely(animation) {
    $f4733daa0cafd2a7$var$currentFrame.splice($f4733daa0cafd2a7$var$findIndex($f4733daa0cafd2a7$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $f4733daa0cafd2a7$var$advance(dt) {
    const nextFrame = $f4733daa0cafd2a7$var$prevFrame;
    for(let i = 0; i < $f4733daa0cafd2a7$var$currentFrame.length; i++){
        const animation = $f4733daa0cafd2a7$var$currentFrame[i];
        $f4733daa0cafd2a7$var$priority = animation.priority;
        if (!animation.idle) {
            $f4733daa0cafd2a7$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $f4733daa0cafd2a7$var$priority = 0;
    $f4733daa0cafd2a7$var$prevFrame = $f4733daa0cafd2a7$var$currentFrame;
    $f4733daa0cafd2a7$var$prevFrame.length = 0;
    $f4733daa0cafd2a7$var$currentFrame = nextFrame;
    return $f4733daa0cafd2a7$var$currentFrame.length > 0;
}
function $f4733daa0cafd2a7$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $f4733daa0cafd2a7$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $f4733daa0cafd2a7$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $f4733daa0cafd2a7$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $f4733daa0cafd2a7$var$PERCENTAGE = $f4733daa0cafd2a7$var$NUMBER + "%";
function $f4733daa0cafd2a7$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $f4733daa0cafd2a7$export$8972dc0e6ad9238f = new RegExp("rgb" + $f4733daa0cafd2a7$var$call($f4733daa0cafd2a7$var$NUMBER, $f4733daa0cafd2a7$var$NUMBER, $f4733daa0cafd2a7$var$NUMBER));
var $f4733daa0cafd2a7$export$4e46ac54fc82cf3b = new RegExp("rgba" + $f4733daa0cafd2a7$var$call($f4733daa0cafd2a7$var$NUMBER, $f4733daa0cafd2a7$var$NUMBER, $f4733daa0cafd2a7$var$NUMBER, $f4733daa0cafd2a7$var$NUMBER));
var $f4733daa0cafd2a7$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $f4733daa0cafd2a7$var$call($f4733daa0cafd2a7$var$NUMBER, $f4733daa0cafd2a7$var$PERCENTAGE, $f4733daa0cafd2a7$var$PERCENTAGE));
var $f4733daa0cafd2a7$export$810b04175080204c = new RegExp("hsla" + $f4733daa0cafd2a7$var$call($f4733daa0cafd2a7$var$NUMBER, $f4733daa0cafd2a7$var$PERCENTAGE, $f4733daa0cafd2a7$var$PERCENTAGE, $f4733daa0cafd2a7$var$NUMBER));
var $f4733daa0cafd2a7$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $f4733daa0cafd2a7$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $f4733daa0cafd2a7$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $f4733daa0cafd2a7$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $f4733daa0cafd2a7$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $f4733daa0cafd2a7$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($f4733daa0cafd2a7$var$colors && $f4733daa0cafd2a7$var$colors[color] !== void 0) return $f4733daa0cafd2a7$var$colors[color];
    if (match = $f4733daa0cafd2a7$export$8972dc0e6ad9238f.exec(color)) return ($f4733daa0cafd2a7$var$parse255(match[1]) << 24 | // r
    $f4733daa0cafd2a7$var$parse255(match[2]) << 16 | // g
    $f4733daa0cafd2a7$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $f4733daa0cafd2a7$export$4e46ac54fc82cf3b.exec(color)) return ($f4733daa0cafd2a7$var$parse255(match[1]) << 24 | // r
    $f4733daa0cafd2a7$var$parse255(match[2]) << 16 | // g
    $f4733daa0cafd2a7$var$parse255(match[3]) << 8 | // b
    $f4733daa0cafd2a7$var$parse1(match[4])) >>> // a
    0;
    if (match = $f4733daa0cafd2a7$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $f4733daa0cafd2a7$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $f4733daa0cafd2a7$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $f4733daa0cafd2a7$export$8f4a7c0bb78e6ea8.exec(color)) return ($f4733daa0cafd2a7$var$hslToRgb($f4733daa0cafd2a7$var$parse360(match[1]), // h
    $f4733daa0cafd2a7$var$parsePercentage(match[2]), // s
    $f4733daa0cafd2a7$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $f4733daa0cafd2a7$export$810b04175080204c.exec(color)) return ($f4733daa0cafd2a7$var$hslToRgb($f4733daa0cafd2a7$var$parse360(match[1]), // h
    $f4733daa0cafd2a7$var$parsePercentage(match[2]), // s
    $f4733daa0cafd2a7$var$parsePercentage(match[3])) | $f4733daa0cafd2a7$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $f4733daa0cafd2a7$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $f4733daa0cafd2a7$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $f4733daa0cafd2a7$var$hue2rgb(p, q, h + 1 / 3);
    const g = $f4733daa0cafd2a7$var$hue2rgb(p, q, h);
    const b = $f4733daa0cafd2a7$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $f4733daa0cafd2a7$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $f4733daa0cafd2a7$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $f4733daa0cafd2a7$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $f4733daa0cafd2a7$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $f4733daa0cafd2a7$export$61db176b839af1f(input) {
    let int32Color = $f4733daa0cafd2a7$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $f4733daa0cafd2a7$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($f4733daa0cafd2a7$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($f4733daa0cafd2a7$export$226b3eccf92c9ed9.arr(range)) return $f4733daa0cafd2a7$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($f4733daa0cafd2a7$export$226b3eccf92c9ed9.str(range.output[0])) return $f4733daa0cafd2a7$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $f4733daa0cafd2a7$var$findRange(input, inputRange);
        return $f4733daa0cafd2a7$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $f4733daa0cafd2a7$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $f4733daa0cafd2a7$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $f4733daa0cafd2a7$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $f4733daa0cafd2a7$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $f4733daa0cafd2a7$var$c1 = 1.70158;
var $f4733daa0cafd2a7$var$c2 = $f4733daa0cafd2a7$var$c1 * 1.525;
var $f4733daa0cafd2a7$var$c3 = $f4733daa0cafd2a7$var$c1 + 1;
var $f4733daa0cafd2a7$var$c4 = 2 * Math.PI / 3;
var $f4733daa0cafd2a7$var$c5 = 2 * Math.PI / 4.5;
var $f4733daa0cafd2a7$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $f4733daa0cafd2a7$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$f4733daa0cafd2a7$var$c3 * x * x * x - $f4733daa0cafd2a7$var$c1 * x * x,
    easeOutBack: (x)=>1 + $f4733daa0cafd2a7$var$c3 * Math.pow(x - 1, 3) + $f4733daa0cafd2a7$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($f4733daa0cafd2a7$var$c2 + 1) * 2 * x - $f4733daa0cafd2a7$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($f4733daa0cafd2a7$var$c2 + 1) * (x * 2 - 2) + $f4733daa0cafd2a7$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $f4733daa0cafd2a7$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $f4733daa0cafd2a7$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $f4733daa0cafd2a7$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $f4733daa0cafd2a7$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $f4733daa0cafd2a7$var$bounceOut(1 - x),
    easeOutBounce: $f4733daa0cafd2a7$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $f4733daa0cafd2a7$var$bounceOut(1 - 2 * x)) / 2 : (1 + $f4733daa0cafd2a7$var$bounceOut(2 * x - 1)) / 2,
    steps: $f4733daa0cafd2a7$var$steps
};
// src/fluids.ts
var $f4733daa0cafd2a7$var$$get = Symbol.for("FluidValue.get");
var $f4733daa0cafd2a7$var$$observers = Symbol.for("FluidValue.observers");
var $f4733daa0cafd2a7$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$f4733daa0cafd2a7$var$$get]);
var $f4733daa0cafd2a7$export$e37b7520edd66839 = (arg)=>arg && arg[$f4733daa0cafd2a7$var$$get] ? arg[$f4733daa0cafd2a7$var$$get]() : arg;
var $f4733daa0cafd2a7$export$133f54e9f7cf1796 = (target)=>target[$f4733daa0cafd2a7$var$$observers] || null;
function $f4733daa0cafd2a7$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $f4733daa0cafd2a7$export$31752c40a5fab62a(target, event) {
    const observers = target[$f4733daa0cafd2a7$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $f4733daa0cafd2a7$export$8cbca1207adce0c0(observer2, event);
    });
}
var $f4733daa0cafd2a7$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $f4733daa0cafd2a7$export$a3b4618659637aa3(this, get);
    }
};
$f4733daa0cafd2a7$var$$get, $f4733daa0cafd2a7$var$$observers;
var $f4733daa0cafd2a7$export$a3b4618659637aa3 = (target, get)=>$f4733daa0cafd2a7$var$setHidden(target, $f4733daa0cafd2a7$var$$get, get);
function $f4733daa0cafd2a7$export$72d604e3f8d000a5(target, observer2) {
    if (target[$f4733daa0cafd2a7$var$$get]) {
        let observers = target[$f4733daa0cafd2a7$var$$observers];
        if (!observers) $f4733daa0cafd2a7$var$setHidden(target, $f4733daa0cafd2a7$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $f4733daa0cafd2a7$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$f4733daa0cafd2a7$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$f4733daa0cafd2a7$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $f4733daa0cafd2a7$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $f4733daa0cafd2a7$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $f4733daa0cafd2a7$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $f4733daa0cafd2a7$var$unitRegex = new RegExp(`(${$f4733daa0cafd2a7$var$numberRegex.source})(%|[a-z]+)`, "i");
var $f4733daa0cafd2a7$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $f4733daa0cafd2a7$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $f4733daa0cafd2a7$var$variableToRgba = (input)=>{
    const [token, fallback] = $f4733daa0cafd2a7$var$parseCSSVariable(input);
    if (!token || $f4733daa0cafd2a7$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $f4733daa0cafd2a7$var$cssVariableRegex.test(fallback)) return $f4733daa0cafd2a7$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $f4733daa0cafd2a7$var$parseCSSVariable = (current)=>{
    const match = $f4733daa0cafd2a7$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $f4733daa0cafd2a7$var$namedColorRegex;
var $f4733daa0cafd2a7$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $f4733daa0cafd2a7$export$4759a013d387347a = (config)=>{
    if (!$f4733daa0cafd2a7$var$namedColorRegex) $f4733daa0cafd2a7$var$namedColorRegex = $f4733daa0cafd2a7$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($f4733daa0cafd2a7$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $f4733daa0cafd2a7$export$e37b7520edd66839(value).replace($f4733daa0cafd2a7$var$cssVariableRegex, $f4733daa0cafd2a7$var$variableToRgba).replace($f4733daa0cafd2a7$var$colorRegex, $f4733daa0cafd2a7$export$61db176b839af1f).replace($f4733daa0cafd2a7$var$namedColorRegex, $f4733daa0cafd2a7$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($f4733daa0cafd2a7$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$f4733daa0cafd2a7$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$f4733daa0cafd2a7$var$unitRegex.test(output[0]) && output.find((value)=>$f4733daa0cafd2a7$var$unitRegex.test(value))?.replace($f4733daa0cafd2a7$var$numberRegex, "");
        let i = 0;
        return output[0].replace($f4733daa0cafd2a7$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($f4733daa0cafd2a7$var$rgbaRegex, $f4733daa0cafd2a7$var$rgbaRound);
    };
};
// src/deprecations.ts
var $f4733daa0cafd2a7$export$82e9f45cca5ba907 = "react-spring: ";
var $f4733daa0cafd2a7$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$f4733daa0cafd2a7$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $f4733daa0cafd2a7$var$warnInterpolate = $f4733daa0cafd2a7$export$d2de3aaeafa91619(console.warn);
function $f4733daa0cafd2a7$export$2abfcde8ae218ba8() {
    $f4733daa0cafd2a7$var$warnInterpolate(`${$f4733daa0cafd2a7$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $f4733daa0cafd2a7$var$warnDirectCall = $f4733daa0cafd2a7$export$d2de3aaeafa91619(console.warn);
function $f4733daa0cafd2a7$export$d99d974913ad3b12() {
    $f4733daa0cafd2a7$var$warnDirectCall(`${$f4733daa0cafd2a7$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $f4733daa0cafd2a7$export$75bed621f62abfa9(value) {
    return $f4733daa0cafd2a7$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$f4733daa0cafd2a7$export$48d7c418edadb60c() && $f4733daa0cafd2a7$var$cssVariableRegex.test(value) || value in ($f4733daa0cafd2a7$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $f4733daa0cafd2a7$var$observer;
var $f4733daa0cafd2a7$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $f4733daa0cafd2a7$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        return $f4733daa0cafd2a7$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $f4733daa0cafd2a7$var$resizeElement(handler, target) {
    if (!$f4733daa0cafd2a7$var$observer) {
        if (typeof ResizeObserver !== "undefined") $f4733daa0cafd2a7$var$observer = new ResizeObserver($f4733daa0cafd2a7$var$handleObservation);
    }
    let elementHandlers = $f4733daa0cafd2a7$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $f4733daa0cafd2a7$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($f4733daa0cafd2a7$var$observer) $f4733daa0cafd2a7$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $f4733daa0cafd2a7$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $f4733daa0cafd2a7$var$observer) $f4733daa0cafd2a7$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $f4733daa0cafd2a7$var$listeners = /* @__PURE__ */ new Set();
var $f4733daa0cafd2a7$var$cleanupWindowResizeHandler;
var $f4733daa0cafd2a7$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $f4733daa0cafd2a7$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $f4733daa0cafd2a7$var$resizeWindow = (callback)=>{
    $f4733daa0cafd2a7$var$listeners.add(callback);
    if (!$f4733daa0cafd2a7$var$cleanupWindowResizeHandler) $f4733daa0cafd2a7$var$cleanupWindowResizeHandler = $f4733daa0cafd2a7$var$createResizeHandler();
    return ()=>{
        $f4733daa0cafd2a7$var$listeners.delete(callback);
        if (!$f4733daa0cafd2a7$var$listeners.size && $f4733daa0cafd2a7$var$cleanupWindowResizeHandler) {
            $f4733daa0cafd2a7$var$cleanupWindowResizeHandler();
            $f4733daa0cafd2a7$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $f4733daa0cafd2a7$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $f4733daa0cafd2a7$var$resizeWindow(callback);
    else return $f4733daa0cafd2a7$var$resizeElement(callback, container);
};
// src/progress.ts
var $f4733daa0cafd2a7$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $f4733daa0cafd2a7$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $f4733daa0cafd2a7$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $f4733daa0cafd2a7$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container["scroll" + length] - this.container["client" + length];
            axis.progress = $f4733daa0cafd2a7$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $f4733daa0cafd2a7$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $f4733daa0cafd2a7$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $f4733daa0cafd2a7$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $f4733daa0cafd2a7$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $f4733daa0cafd2a7$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $f4733daa0cafd2a7$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $f4733daa0cafd2a7$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $f4733daa0cafd2a7$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$f4733daa0cafd2a7$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $f4733daa0cafd2a7$var$scrollListeners.set(container, listener);
        const target = $f4733daa0cafd2a7$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $f4733daa0cafd2a7$var$resizeListeners.set(container, $f4733daa0cafd2a7$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $f4733daa0cafd2a7$var$scrollListeners.get(container);
    $f4733daa0cafd2a7$export$27f233d61a9e2fa4(animateScroll);
    return ()=>{
        $f4733daa0cafd2a7$export$27f233d61a9e2fa4.cancel(animateScroll);
        const containerHandlers2 = $f4733daa0cafd2a7$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $f4733daa0cafd2a7$var$scrollListeners.get(container);
        $f4733daa0cafd2a7$var$scrollListeners.delete(container);
        if (listener) {
            $f4733daa0cafd2a7$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $f4733daa0cafd2a7$var$resizeListeners.get(container)?.();
        }
    };
};
function $f4733daa0cafd2a7$export$fe4300aa8eebea86(init) {
    const ref = (0, $4DE7A.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $f4733daa0cafd2a7$export$700979bc83e7db82 = $f4733daa0cafd2a7$export$48d7c418edadb60c() ? (0, $4DE7A.useEffect) : (0, $4DE7A.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $f4733daa0cafd2a7$var$useIsMounted = ()=>{
    const isMounted = (0, $4DE7A.useRef)(false);
    $f4733daa0cafd2a7$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $f4733daa0cafd2a7$export$91db9bc4f8ac944a() {
    const update2 = (0, $4DE7A.useState)()[1];
    const isMounted = $f4733daa0cafd2a7$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update2(Math.random());
    };
}
function $f4733daa0cafd2a7$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $4DE7A.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $4DE7A.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $f4733daa0cafd2a7$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $4DE7A.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $f4733daa0cafd2a7$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $f4733daa0cafd2a7$export$392544347a18b6ea = (effect)=>(0, $4DE7A.useEffect)(effect, $f4733daa0cafd2a7$var$emptyDeps);
var $f4733daa0cafd2a7$var$emptyDeps = [];
function $f4733daa0cafd2a7$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $4DE7A.useRef)();
    (0, $4DE7A.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $f4733daa0cafd2a7$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $4DE7A.useState)(null);
    $f4733daa0cafd2a7$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $f4733daa0cafd2a7$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        mql.addEventListener("change", handleMediaChange);
        return ()=>{
            mql.removeEventListener("change", handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $4DE7A = parcelRequire("4DE7A");
// src/Animated.ts


var $4DE7A = parcelRequire("4DE7A");
var $c0c9304e52ac9c4e$var$$node = Symbol.for("Animated:node");
var $c0c9304e52ac9c4e$export$3df5e165e801a70f = (value)=>!!value && value[$c0c9304e52ac9c4e$var$$node] === value;
var $c0c9304e52ac9c4e$export$6b63995194a3a9e4 = (owner)=>owner && owner[$c0c9304e52ac9c4e$var$$node];
var $c0c9304e52ac9c4e$export$b553cb5b22b81b04 = (owner, node)=>(0, $f4733daa0cafd2a7$export$5c74248ea0e35446)(owner, $c0c9304e52ac9c4e$var$$node, node);
var $c0c9304e52ac9c4e$export$ccab2b64c5d440 = (owner)=>owner && owner[$c0c9304e52ac9c4e$var$$node] && owner[$c0c9304e52ac9c4e$var$$node].getPayload();
var $c0c9304e52ac9c4e$export$31627395a3b18e54 = class {
    constructor(){
        $c0c9304e52ac9c4e$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $c0c9304e52ac9c4e$export$cb1e8f3c05d37ad5 = class extends $c0c9304e52ac9c4e$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new $c0c9304e52ac9c4e$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $c0c9304e52ac9c4e$export$f6c6c4cbd7fa5b93 = class extends $c0c9304e52ac9c4e$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $f4733daa0cafd2a7$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new $c0c9304e52ac9c4e$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $f4733daa0cafd2a7$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $c0c9304e52ac9c4e$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $c0c9304e52ac9c4e$export$f1b0b9e366a6e2d4 = class extends $c0c9304e52ac9c4e$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $f4733daa0cafd2a7$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($c0c9304e52ac9c4e$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $f4733daa0cafd2a7$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $f4733daa0cafd2a7$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $f4733daa0cafd2a7$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($c0c9304e52ac9c4e$var$TreeContext.dependencies && (0, $f4733daa0cafd2a7$export$57ea7e3a7f6280c7)(source)) $c0c9304e52ac9c4e$var$TreeContext.dependencies.add(source);
        const payload = $c0c9304e52ac9c4e$export$ccab2b64c5d440(source);
        if (payload) (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $c0c9304e52ac9c4e$export$ede394683406942d = class extends $c0c9304e52ac9c4e$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new $c0c9304e52ac9c4e$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($c0c9304e52ac9c4e$var$makeAnimated));
        return true;
    }
};
function $c0c9304e52ac9c4e$var$makeAnimated(value) {
    const nodeType = (0, $f4733daa0cafd2a7$export$75bed621f62abfa9)(value) ? $c0c9304e52ac9c4e$export$f6c6c4cbd7fa5b93 : $c0c9304e52ac9c4e$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $c0c9304e52ac9c4e$export$e6b77ddbe47b132e(value) {
    const parentNode = $c0c9304e52ac9c4e$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).arr(value) ? $c0c9304e52ac9c4e$export$ede394683406942d : (0, $f4733daa0cafd2a7$export$75bed621f62abfa9)(value) ? $c0c9304e52ac9c4e$export$f6c6c4cbd7fa5b93 : $c0c9304e52ac9c4e$export$cb1e8f3c05d37ad5;
}
var $c0c9304e52ac9c4e$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $4DE7A.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $4DE7A.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $4DE7A.useCallback)((value)=>{
            instanceRef.current = $c0c9304e52ac9c4e$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $c0c9304e52ac9c4e$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $f4733daa0cafd2a7$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $c0c9304e52ac9c4e$var$PropsObserver(callback, deps);
        const observerRef = (0, $4DE7A.useRef)();
        (0, $f4733daa0cafd2a7$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(deps, (dep)=>(0, $f4733daa0cafd2a7$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $f4733daa0cafd2a7$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $f4733daa0cafd2a7$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $4DE7A.useEffect)(callback, []);
        (0, $f4733daa0cafd2a7$export$392544347a18b6ea)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(observer2.deps, (dep)=>(0, $f4733daa0cafd2a7$export$7a0eb830d336339b)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $4DE7A.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $c0c9304e52ac9c4e$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $f4733daa0cafd2a7$export$27f233d61a9e2fa4).write(this.update);
    }
};
function $c0c9304e52ac9c4e$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $c0c9304e52ac9c4e$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $c0c9304e52ac9c4e$export$f1b0b9e366a6e2d4(props);
    $c0c9304e52ac9c4e$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $c0c9304e52ac9c4e$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $c0c9304e52ac9c4e$var$cacheKey = Symbol.for("AnimatedComponent");
var $c0c9304e52ac9c4e$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $c0c9304e52ac9c4e$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $c0c9304e52ac9c4e$var$getDisplayName(Component) || "Anonymous";
        if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $c0c9304e52ac9c4e$var$withAnimated(Component, hostConfig));
        else Component = Component[$c0c9304e52ac9c4e$var$cacheKey] || (Component[$c0c9304e52ac9c4e$var$cacheKey] = $c0c9304e52ac9c4e$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $f4733daa0cafd2a7$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).arr(components)) key = $c0c9304e52ac9c4e$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $c0c9304e52ac9c4e$var$getDisplayName = (arg)=>(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


// src/utils.ts
var $d14b2d9515273daa$export$b24b633b1364b94b = class {
};


function $2c03db10edbdd570$var$callProp(value, ...args) {
    return (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
var $2c03db10edbdd570$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $f4733daa0cafd2a7$export$45b10814cc054894)(value).includes(key)));
var $2c03db10edbdd570$var$resolveProp = (prop, key)=>(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
var $2c03db10edbdd570$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $2c03db10edbdd570$var$noopTransform = (value)=>value;
var $2c03db10edbdd570$var$getDefaultProps = (props, transform = $2c03db10edbdd570$var$noopTransform)=>{
    let keys = $2c03db10edbdd570$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $2c03db10edbdd570$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $2c03db10edbdd570$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $2c03db10edbdd570$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $f4733daa0cafd2a7$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$2c03db10edbdd570$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $2c03db10edbdd570$export$b971039a739bf227(props) {
    const to2 = $2c03db10edbdd570$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $f4733daa0cafd2a7$export$f4c6fe153f5a944e)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $2c03db10edbdd570$var$computeGoal(value) {
    value = (0, $f4733daa0cafd2a7$export$e37b7520edd66839)(value);
    return (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).arr(value) ? value.map($2c03db10edbdd570$var$computeGoal) : (0, $f4733daa0cafd2a7$export$75bed621f62abfa9)(value) ? (0, $f4733daa0cafd2a7$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $2c03db10edbdd570$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $2c03db10edbdd570$var$isAsyncTo(to2) {
    return (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(to2) || (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).arr(to2) && (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).obj(to2[0]);
}
function $2c03db10edbdd570$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $2c03db10edbdd570$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $2c03db10edbdd570$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $f4733daa0cafd2a7$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $2c03db10edbdd570$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $2c03db10edbdd570$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $2c03db10edbdd570$var$defaults = {
    ...$2c03db10edbdd570$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $f4733daa0cafd2a7$export$15a0bf1b4bbacad8).linear,
    clamp: false
};
var $2c03db10edbdd570$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $2c03db10edbdd570$var$defaults);
    }
};
function $2c03db10edbdd570$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $2c03db10edbdd570$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $2c03db10edbdd570$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $2c03db10edbdd570$var$defaults)if (config2[key] == null) config2[key] = $2c03db10edbdd570$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $2c03db10edbdd570$var$sanitizeConfig(config2, props) {
    if (!(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(props.tension) || !(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(props.damping) || !(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $2c03db10edbdd570$var$emptyArray = [];
var $2c03db10edbdd570$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $2c03db10edbdd570$var$emptyArray;
        this.toValues = null;
        this.fromValues = $2c03db10edbdd570$var$emptyArray;
        this.config = new $2c03db10edbdd570$var$AnimationConfig();
        this.immediate = false;
    }
};
function $2c03db10edbdd570$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $2c03db10edbdd570$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $2c03db10edbdd570$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $2c03db10edbdd570$var$matchProp(pause, key);
            delay = $2c03db10edbdd570$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $f4733daa0cafd2a7$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $f4733daa0cafd2a7$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $f4733daa0cafd2a7$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $2c03db10edbdd570$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $2c03db10edbdd570$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $2c03db10edbdd570$var$getNoopResult(target.get()) : $2c03db10edbdd570$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $2c03db10edbdd570$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $2c03db10edbdd570$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $2c03db10edbdd570$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $2c03db10edbdd570$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $2c03db10edbdd570$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $2c03db10edbdd570$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $2c03db10edbdd570$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $2c03db10edbdd570$export$d362d093fa99dc7();
            const skipAnimationSignal = new $2c03db10edbdd570$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $f4733daa0cafd2a7$export$cceeabf822b64fc0).skipAnimation) {
                    $2c03db10edbdd570$var$stopAsync(state);
                    skipAnimationSignal.result = $2c03db10edbdd570$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $f4733daa0cafd2a7$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $f4733daa0cafd2a7$export$cceeabf822b64fc0).skipAnimation) {
            $2c03db10edbdd570$var$stopAsync(state);
            return $2c03db10edbdd570$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $2c03db10edbdd570$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $2c03db10edbdd570$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $2c03db10edbdd570$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(onRest)) (0, $f4733daa0cafd2a7$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $2c03db10edbdd570$var$stopAsync(state, cancelId) {
    (0, $f4733daa0cafd2a7$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $2c03db10edbdd570$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $2c03db10edbdd570$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $2c03db10edbdd570$var$isFrameValue = (value)=>value instanceof $2c03db10edbdd570$export$8229896f80e2495e;
var $2c03db10edbdd570$var$nextId = 1;
var $2c03db10edbdd570$export$8229896f80e2495e = class extends (0, $f4733daa0cafd2a7$export$aff8e1ac1a016a2) {
    constructor(){
        super(...arguments);
        this.id = $2c03db10edbdd570$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $c0c9304e52ac9c4e$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $f4733daa0cafd2a7$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $f4733daa0cafd2a7$export$2abfcde8ae218ba8)();
        return (0, $f4733daa0cafd2a7$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $f4733daa0cafd2a7$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $f4733daa0cafd2a7$export$a57f5080a3bcc90a).sort(this);
        (0, $f4733daa0cafd2a7$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $2c03db10edbdd570$var$$P = Symbol.for("SpringPhase");
var $2c03db10edbdd570$var$HAS_ANIMATED = 1;
var $2c03db10edbdd570$var$IS_ANIMATING = 2;
var $2c03db10edbdd570$var$IS_PAUSED = 4;
var $2c03db10edbdd570$var$hasAnimated = (target)=>(target[$2c03db10edbdd570$var$$P] & $2c03db10edbdd570$var$HAS_ANIMATED) > 0;
var $2c03db10edbdd570$var$isAnimating = (target)=>(target[$2c03db10edbdd570$var$$P] & $2c03db10edbdd570$var$IS_ANIMATING) > 0;
var $2c03db10edbdd570$var$isPaused = (target)=>(target[$2c03db10edbdd570$var$$P] & $2c03db10edbdd570$var$IS_PAUSED) > 0;
var $2c03db10edbdd570$var$setActiveBit = (target, active)=>active ? target[$2c03db10edbdd570$var$$P] |= $2c03db10edbdd570$var$IS_ANIMATING | $2c03db10edbdd570$var$HAS_ANIMATED : target[$2c03db10edbdd570$var$$P] &= ~$2c03db10edbdd570$var$IS_ANIMATING;
var $2c03db10edbdd570$var$setPausedBit = (target, paused)=>paused ? target[$2c03db10edbdd570$var$$P] |= $2c03db10edbdd570$var$IS_PAUSED : target[$2c03db10edbdd570$var$$P] &= ~$2c03db10edbdd570$var$IS_PAUSED;
// src/SpringValue.ts
var $2c03db10edbdd570$export$5854d13427d5a954 = class extends $2c03db10edbdd570$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $2c03db10edbdd570$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(arg1) || !(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($2c03db10edbdd570$var$isAnimating(this) || this._state.asyncTo) || $2c03db10edbdd570$var$isPaused(this);
    }
    get goal() {
        return (0, $f4733daa0cafd2a7$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $c0c9304e52ac9c4e$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $c0c9304e52ac9c4e$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $2c03db10edbdd570$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $2c03db10edbdd570$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $2c03db10edbdd570$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $c0c9304e52ac9c4e$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $f4733daa0cafd2a7$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $f4733daa0cafd2a7$export$45b10814cc054894)((0, $f4733daa0cafd2a7$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $c0c9304e52ac9c4e$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $c0c9304e52ac9c4e$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $f4733daa0cafd2a7$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $f4733daa0cafd2a7$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($2c03db10edbdd570$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $f4733daa0cafd2a7$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(to2)) queue = [
            (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$2c03db10edbdd570$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $2c03db10edbdd570$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $f4733daa0cafd2a7$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).obj(to2) ? to2[key] : to2;
        if (to2 == null || $2c03db10edbdd570$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$2c03db10edbdd570$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $f4733daa0cafd2a7$export$e37b7520edd66839)(from);
            if (!(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $c0c9304e52ac9c4e$export$6b63995194a3a9e4)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $2c03db10edbdd570$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $2c03db10edbdd570$var$resolveProp(value, key) : value));
        $2c03db10edbdd570$var$mergeActiveFn(this, props, "onProps");
        $2c03db10edbdd570$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $2c03db10edbdd570$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$2c03db10edbdd570$var$isPaused(this)) {
                        $2c03db10edbdd570$var$setPausedBit(this, true);
                        (0, $f4733daa0cafd2a7$export$7ba486852759e806)(state.pauseQueue);
                        $2c03db10edbdd570$var$sendEvent(this, "onPause", $2c03db10edbdd570$var$getFinishedResult(this, $2c03db10edbdd570$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($2c03db10edbdd570$var$isPaused(this)) {
                        $2c03db10edbdd570$var$setPausedBit(this, false);
                        if ($2c03db10edbdd570$var$isAnimating(this)) this._resume();
                        (0, $f4733daa0cafd2a7$export$7ba486852759e806)(state.resumeQueue);
                        $2c03db10edbdd570$var$sendEvent(this, "onResume", $2c03db10edbdd570$var$getFinishedResult(this, $2c03db10edbdd570$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $2c03db10edbdd570$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($2c03db10edbdd570$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($2c03db10edbdd570$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $f4733daa0cafd2a7$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $f4733daa0cafd2a7$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $f4733daa0cafd2a7$export$248d38f6296296c5)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $2c03db10edbdd570$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $2c03db10edbdd570$var$mergeConfig(config2, $2c03db10edbdd570$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $2c03db10edbdd570$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $c0c9304e52ac9c4e$export$6b63995194a3a9e4)(this);
        if (!node || (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(to2)) return resolve($2c03db10edbdd570$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(from) && $2c03db10edbdd570$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $2c03db10edbdd570$var$computeGoal(to2);
        const isAnimatable = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).num(goal) || (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).arr(goal) || (0, $f4733daa0cafd2a7$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $2c03db10edbdd570$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $c0c9304e52ac9c4e$export$e6b77ddbe47b132e)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $f4733daa0cafd2a7$export$57ea7e3a7f6280c7)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$2c03db10edbdd570$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $f4733daa0cafd2a7$export$248d38f6296296c5)($2c03db10edbdd570$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $f4733daa0cafd2a7$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $f4733daa0cafd2a7$export$248d38f6296296c5)(config2.decay, decay) || !(0, $f4733daa0cafd2a7$export$248d38f6296296c5)(config2.velocity, velocity)) started = true;
        }
        if (finished && $2c03db10edbdd570$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $f4733daa0cafd2a7$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $f4733daa0cafd2a7$export$57ea7e3a7f6280c7)(to2) ? null : goalType == (0, $c0c9304e52ac9c4e$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $f4733daa0cafd2a7$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)($2c03db10edbdd570$var$ACTIVE_EVENTS, (type)=>$2c03db10edbdd570$var$mergeActiveFn(this, props, type));
                const result = $2c03db10edbdd570$var$getFinishedResult(this, $2c03db10edbdd570$var$checkFinished(this, prevTo));
                (0, $f4733daa0cafd2a7$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $f4733daa0cafd2a7$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $2c03db10edbdd570$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($2c03db10edbdd570$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($2c03db10edbdd570$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($2c03db10edbdd570$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $f4733daa0cafd2a7$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $f4733daa0cafd2a7$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $f4733daa0cafd2a7$export$57ea7e3a7f6280c7)(to2)) {
            (0, $f4733daa0cafd2a7$export$72d604e3f8d000a5)(to2, this);
            if ($2c03db10edbdd570$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $f4733daa0cafd2a7$export$57ea7e3a7f6280c7)(to2)) (0, $f4733daa0cafd2a7$export$7a0eb830d336339b)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $f4733daa0cafd2a7$export$e37b7520edd66839)(arg);
        if (!(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $c0c9304e52ac9c4e$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $f4733daa0cafd2a7$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $c0c9304e52ac9c4e$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $c0c9304e52ac9c4e$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $f4733daa0cafd2a7$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $c0c9304e52ac9c4e$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $2c03db10edbdd570$var$sendEvent(this, "onStart", $2c03db10edbdd570$var$getFinishedResult(this, $2c03db10edbdd570$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $2c03db10edbdd570$var$callProp(this.animation.onChange, value, this);
        }
        $2c03db10edbdd570$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $c0c9304e52ac9c4e$export$6b63995194a3a9e4)(this).reset((0, $f4733daa0cafd2a7$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$2c03db10edbdd570$var$isAnimating(this)) {
            $2c03db10edbdd570$var$setActiveBit(this, true);
            if (!$2c03db10edbdd570$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $f4733daa0cafd2a7$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $f4733daa0cafd2a7$export$a57f5080a3bcc90a).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($2c03db10edbdd570$var$isAnimating(this)) {
            $2c03db10edbdd570$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $f4733daa0cafd2a7$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $2c03db10edbdd570$var$getCancelledResult(this.get()) : $2c03db10edbdd570$var$getFinishedResult(this.get(), $2c03db10edbdd570$var$checkFinished(this, goal ?? anim.to));
            (0, $f4733daa0cafd2a7$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $2c03db10edbdd570$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $2c03db10edbdd570$var$checkFinished(target, to2) {
    const goal = $2c03db10edbdd570$var$computeGoal(to2);
    const value = $2c03db10edbdd570$var$computeGoal(target.get());
    return (0, $f4733daa0cafd2a7$export$248d38f6296296c5)(value, goal);
}
function $2c03db10edbdd570$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $2c03db10edbdd570$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $2c03db10edbdd570$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $2c03db10edbdd570$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $2c03db10edbdd570$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $2c03db10edbdd570$var$createUpdate(props) {
    const { to: to2, from: from } = props = $2c03db10edbdd570$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).obj(to2)) $2c03db10edbdd570$var$findDefined(to2, keys);
    if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).obj(from)) $2c03db10edbdd570$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $2c03db10edbdd570$var$declareUpdate(props) {
    const update2 = $2c03db10edbdd570$var$createUpdate(props);
    if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(update2.default)) update2.default = $2c03db10edbdd570$var$getDefaultProps(update2);
    return update2;
}
function $2c03db10edbdd570$var$findDefined(values, keys) {
    (0, $f4733daa0cafd2a7$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
var $2c03db10edbdd570$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $2c03db10edbdd570$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $2c03db10edbdd570$var$getDefaultProp(props, type) ? $2c03db10edbdd570$var$resolveProp(props[type], target.key) : void 0;
}
function $2c03db10edbdd570$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $2c03db10edbdd570$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $2c03db10edbdd570$var$nextId2 = 1;
var $2c03db10edbdd570$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $2c03db10edbdd570$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($2c03db10edbdd570$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $f4733daa0cafd2a7$export$45b10814cc054894)(props).map($2c03db10edbdd570$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $2c03db10edbdd570$var$prepareKeys(this, queue);
        return $2c03db10edbdd570$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)((0, $f4733daa0cafd2a7$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $2c03db10edbdd570$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)((0, $f4733daa0cafd2a7$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)((0, $f4733daa0cafd2a7$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $f4733daa0cafd2a7$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $f4733daa0cafd2a7$export$4909b86c8034bf73)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $f4733daa0cafd2a7$export$4909b86c8034bf73)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $f4733daa0cafd2a7$export$4909b86c8034bf73)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $f4733daa0cafd2a7$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
};
function $2c03db10edbdd570$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$2c03db10edbdd570$var$flushUpdate(ctrl, props))).then((results)=>$2c03db10edbdd570$var$getCombinedResult(ctrl, results));
}
async function $2c03db10edbdd570$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).arr(to2) || (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)($2c03db10edbdd570$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $f4733daa0cafd2a7$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $2c03db10edbdd570$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($2c03db10edbdd570$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $f4733daa0cafd2a7$export$8793edee2d425525),
            resume: (0, $f4733daa0cafd2a7$export$8793edee2d425525),
            start (props2, resolve) {
                if (cancel) {
                    $2c03db10edbdd570$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($2c03db10edbdd570$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($2c03db10edbdd570$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $2c03db10edbdd570$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $2c03db10edbdd570$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $2c03db10edbdd570$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $2c03db10edbdd570$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $f4733daa0cafd2a7$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $2c03db10edbdd570$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)((0, $f4733daa0cafd2a7$export$45b10814cc054894)(props), (props2)=>{
        if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(props2.keys)) props2 = $2c03db10edbdd570$var$createUpdate(props2);
        if (!(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $2c03db10edbdd570$var$prepareSprings(springs, props2, (key)=>{
            return $2c03db10edbdd570$var$createSpring(key);
        });
    });
    $2c03db10edbdd570$var$setSprings(ctrl, springs);
    return springs;
}
function $2c03db10edbdd570$var$setSprings(ctrl, springs) {
    (0, $f4733daa0cafd2a7$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $f4733daa0cafd2a7$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $2c03db10edbdd570$var$createSpring(key, observer) {
    const spring = new $2c03db10edbdd570$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $f4733daa0cafd2a7$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $2c03db10edbdd570$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $2c03db10edbdd570$var$prepareKeys(ctrl, queue) {
    (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(queue, (props)=>{
        $2c03db10edbdd570$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $2c03db10edbdd570$var$createSpring(key, ctrl);
        });
    });
}
var $2c03db10edbdd570$export$f12a216ec50d2cf1 = ({ children: children, ...props })=>{
    const inherited = (0, $4DE7A.useContext)($2c03db10edbdd570$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $f4733daa0cafd2a7$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $2c03db10edbdd570$var$ctx;
    return /* @__PURE__ */ $4DE7A.createElement(Provider, {
        value: props
    }, children);
};
var $2c03db10edbdd570$var$ctx = $2c03db10edbdd570$var$makeContext($2c03db10edbdd570$export$f12a216ec50d2cf1, {});
$2c03db10edbdd570$export$f12a216ec50d2cf1.Provider = $2c03db10edbdd570$var$ctx.Provider;
$2c03db10edbdd570$export$f12a216ec50d2cf1.Consumer = $2c03db10edbdd570$var$ctx.Consumer;
function $2c03db10edbdd570$var$makeContext(target, init) {
    Object.assign(target, $4DE7A.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $2c03db10edbdd570$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $f4733daa0cafd2a7$export$d99d974913ad3b12)();
        const results = [];
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update2 = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $2c03db10edbdd570$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $4DE7A.useMemo)(()=>propsFn || arguments.length == 3 ? $2c03db10edbdd570$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $4DE7A.useRef)(0);
    const forceUpdate = (0, $f4733daa0cafd2a7$export$91db9bc4f8ac944a)();
    const state = (0, $4DE7A.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $2c03db10edbdd570$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $2c03db10edbdd570$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $2c03db10edbdd570$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($2c03db10edbdd570$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $4DE7A.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $f4733daa0cafd2a7$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $4DE7A.useMemo)(()=>{
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $2c03db10edbdd570$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $4DE7A.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $2c03db10edbdd570$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $2c03db10edbdd570$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$2c03db10edbdd570$var$getSprings(ctrl, updates[i]));
    const context = (0, $4DE7A.useContext)($2c03db10edbdd570$export$f12a216ec50d2cf1);
    const prevContext = (0, $f4733daa0cafd2a7$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $2c03db10edbdd570$var$hasProps(context);
    (0, $f4733daa0cafd2a7$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $2c03db10edbdd570$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $f4733daa0cafd2a7$export$392544347a18b6ea)(()=>()=>{
            (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $2c03db10edbdd570$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $2c03db10edbdd570$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $2c03db10edbdd570$var$initSpringRef = ()=>$2c03db10edbdd570$export$2471ae76e2946684();
var $2c03db10edbdd570$export$564bff9c23cad2ca = ()=>(0, $4DE7A.useState)($2c03db10edbdd570$var$initSpringRef)[0];
var $2c03db10edbdd570$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $f4733daa0cafd2a7$export$fe4300aa8eebea86)(()=>new $2c03db10edbdd570$export$5854d13427d5a954(initial, props));
    (0, $f4733daa0cafd2a7$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $2c03db10edbdd570$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $2c03db10edbdd570$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $f4733daa0cafd2a7$export$700979bc83e7db82)(()=>{
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $2c03db10edbdd570$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $2c03db10edbdd570$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $4DE7A.useMemo)(()=>propsFn || arguments.length == 3 ? $2c03db10edbdd570$export$2471ae76e2946684() : void 0, []);
    const items = (0, $f4733daa0cafd2a7$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $4DE7A.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $f4733daa0cafd2a7$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $f4733daa0cafd2a7$export$392544347a18b6ea)(()=>{
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $2c03db10edbdd570$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $2c03db10edbdd570$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $f4733daa0cafd2a7$export$700979bc83e7db82)(()=>(0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $2c03db10edbdd570$var$detachRefs(ctrl, ref);
            $2c03db10edbdd570$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $2c03db10edbdd570$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $f4733daa0cafd2a7$export$91db9bc4f8ac944a)();
    const defaultProps = $2c03db10edbdd570$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $4DE7A.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $4DE7A.useRef)(false);
    (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $2c03db10edbdd570$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $2c03db10edbdd570$var$callProp(to2, t.item, i);
        to2 = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).obj(to2) ? $2c03db10edbdd570$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $2c03db10edbdd570$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $2c03db10edbdd570$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $2c03db10edbdd570$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $2c03db10edbdd570$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $2c03db10edbdd570$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $4DE7A.useContext)($2c03db10edbdd570$export$f12a216ec50d2cf1);
    const prevContext = (0, $f4733daa0cafd2a7$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $2c03db10edbdd570$var$hasProps(context);
    (0, $f4733daa0cafd2a7$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $f4733daa0cafd2a7$export$700979bc83e7db82)(()=>{
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $2c03db10edbdd570$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $4DE7A.createElement($4DE7A.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $4DE7A.createElement(elem.type, {
                ...elem.props,
                key: (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).str(t.key) || (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $2c03db10edbdd570$var$nextKey = 1;
function $2c03db10edbdd570$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $2c03db10edbdd570$var$nextKey++;
        });
    }
    return (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(keys) ? items : (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $f4733daa0cafd2a7$export$45b10814cc054894)(keys);
}
var $2c03db10edbdd570$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $2c03db10edbdd570$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $f4733daa0cafd2a7$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $f4733daa0cafd2a7$export$d4d89fd61e5416ee)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $2c03db10edbdd570$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $2c03db10edbdd570$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $f4733daa0cafd2a7$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $f4733daa0cafd2a7$export$45b39e67d4ce4921)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $2c03db10edbdd570$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $2c03db10edbdd570$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $4DE7A.useState)(false);
    const ref = (0, $4DE7A.useRef)();
    const propsFn = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $2c03db10edbdd570$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $f4733daa0cafd2a7$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $2c03db10edbdd570$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $2c03db10edbdd570$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($2c03db10edbdd570$export$c4af9125706c4d30(props));
}
function $2c03db10edbdd570$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $2c03db10edbdd570$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $2c03db10edbdd570$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $2c03db10edbdd570$export$7b286972b8d8ccbf(items, props)(children);
}
var $2c03db10edbdd570$export$b0cc4f9860136880 = class extends $2c03db10edbdd570$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $f4733daa0cafd2a7$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $c0c9304e52ac9c4e$export$e6b77ddbe47b132e)(value);
        (0, $c0c9304e52ac9c4e$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $f4733daa0cafd2a7$export$248d38f6296296c5)(value, oldValue)) {
            (0, $c0c9304e52ac9c4e$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $2c03db10edbdd570$var$checkIdle(this._active)) $2c03db10edbdd570$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $f4733daa0cafd2a7$export$e37b7520edd66839)) : (0, $f4733daa0cafd2a7$export$45b10814cc054894)((0, $f4733daa0cafd2a7$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$2c03db10edbdd570$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)((0, $c0c9304e52ac9c4e$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $f4733daa0cafd2a7$export$cceeabf822b64fc0).skipAnimation) {
                (0, $f4733daa0cafd2a7$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $2c03db10edbdd570$var$becomeIdle(this);
            } else (0, $f4733daa0cafd2a7$export$a57f5080a3bcc90a).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)((0, $f4733daa0cafd2a7$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $f4733daa0cafd2a7$export$57ea7e3a7f6280c7)(source)) (0, $f4733daa0cafd2a7$export$72d604e3f8d000a5)(source, this);
            if ($2c03db10edbdd570$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)((0, $f4733daa0cafd2a7$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $f4733daa0cafd2a7$export$57ea7e3a7f6280c7)(source)) (0, $f4733daa0cafd2a7$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $2c03db10edbdd570$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $f4733daa0cafd2a7$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($2c03db10edbdd570$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $2c03db10edbdd570$var$isIdle(source) {
    return source.idle !== false;
}
function $2c03db10edbdd570$var$checkIdle(active) {
    return !active.size || Array.from(active).every($2c03db10edbdd570$var$isIdle);
}
function $2c03db10edbdd570$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)((0, $c0c9304e52ac9c4e$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $f4733daa0cafd2a7$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $2c03db10edbdd570$export$2c618a4308a30424 = (source, ...args)=>new $2c03db10edbdd570$export$b0cc4f9860136880(source, args);
var $2c03db10edbdd570$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $f4733daa0cafd2a7$export$2abfcde8ae218ba8)(), new $2c03db10edbdd570$export$b0cc4f9860136880(source, args));
(0, $f4733daa0cafd2a7$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $f4733daa0cafd2a7$export$4759a013d387347a,
    to: (source, args)=>new $2c03db10edbdd570$export$b0cc4f9860136880(source, args)
});
var $2c03db10edbdd570$export$722fbec263ad908a = (0, $f4733daa0cafd2a7$export$a57f5080a3bcc90a).advance;



var $gv34t = parcelRequire("gv34t");


// src/applyAnimatedValues.ts
var $80a1228f70d6ae64$var$isCustomPropRE = /^--/;
function $80a1228f70d6ae64$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$80a1228f70d6ae64$var$isCustomPropRE.test(name) && !($80a1228f70d6ae64$var$isUnitlessNumber.hasOwnProperty(name) && $80a1228f70d6ae64$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $80a1228f70d6ae64$var$attributeCache = {};
function $80a1228f70d6ae64$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $80a1228f70d6ae64$var$attributeCache[name] || ($80a1228f70d6ae64$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $80a1228f70d6ae64$var$dangerousStyleValue(name, style[name]);
        if ($80a1228f70d6ae64$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $80a1228f70d6ae64$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $80a1228f70d6ae64$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $80a1228f70d6ae64$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$80a1228f70d6ae64$var$isUnitlessNumber = Object.keys($80a1228f70d6ae64$var$isUnitlessNumber).reduce((acc, prop)=>{
    $80a1228f70d6ae64$var$prefixes.forEach((prefix)=>acc[$80a1228f70d6ae64$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $80a1228f70d6ae64$var$isUnitlessNumber);
var $80a1228f70d6ae64$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $80a1228f70d6ae64$var$pxTransforms = /^(translate)/;
var $80a1228f70d6ae64$var$degTransforms = /^(rotate|skew)/;
var $80a1228f70d6ae64$var$addUnit = (value, unit)=>(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
var $80a1228f70d6ae64$var$isValueIdentity = (value, id)=>(0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$80a1228f70d6ae64$var$isValueIdentity(v, id)) : (0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
var $80a1228f70d6ae64$var$AnimatedStyle = class extends (0, $c0c9304e52ac9c4e$export$f1b0b9e366a6e2d4) {
    constructor({ x: x, y: y, z: z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$80a1228f70d6ae64$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $80a1228f70d6ae64$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $f4733daa0cafd2a7$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($80a1228f70d6ae64$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $80a1228f70d6ae64$var$pxTransforms.test(key) ? "px" : $80a1228f70d6ae64$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $f4733daa0cafd2a7$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$80a1228f70d6ae64$var$addUnit(deg, unit)})`,
                        $80a1228f70d6ae64$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$80a1228f70d6ae64$var$addUnit(v, unit)).join(",")})`,
                        $80a1228f70d6ae64$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $80a1228f70d6ae64$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $80a1228f70d6ae64$var$FluidTransform = class extends (0, $f4733daa0cafd2a7$export$aff8e1ac1a016a2) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $f4733daa0cafd2a7$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $f4733daa0cafd2a7$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $f4733daa0cafd2a7$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(input, (value)=>(0, $f4733daa0cafd2a7$export$57ea7e3a7f6280c7)(value) && (0, $f4733daa0cafd2a7$export$72d604e3f8d000a5)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $f4733daa0cafd2a7$export$79b2f7037acddd43)(input, (value)=>(0, $f4733daa0cafd2a7$export$57ea7e3a7f6280c7)(value) && (0, $f4733daa0cafd2a7$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $f4733daa0cafd2a7$export$31752c40a5fab62a)(this, event);
    }
};
// src/primitives.ts
var $80a1228f70d6ae64$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $f4733daa0cafd2a7$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $gv34t.unstable_batchedUpdates),
    createStringInterpolator: $f4733daa0cafd2a7$export$4759a013d387347a,
    colors: $f4733daa0cafd2a7$export$8f45430ccf837300
});
var $80a1228f70d6ae64$var$host = (0, $c0c9304e52ac9c4e$export$4ee5c78f6dcbcef)($80a1228f70d6ae64$var$primitives, {
    applyAnimatedValues: $80a1228f70d6ae64$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $80a1228f70d6ae64$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
var $80a1228f70d6ae64$export$407448d2b89b1813 = $80a1228f70d6ae64$var$host.animated;


const $cb25c588320cd649$var$BAR_MODIFIER = 0.65;
function $cb25c588320cd649$var$CapacityBar({ average: average, potential: potential, max: max }) {
    // Like react-spring's pre-defined `config.slow` but with slightly
    // less tension and friction
    const sharedConfig = {
        mass: 1,
        tension: 250,
        friction: 40
    };
    const averageSpringProps = (0, $2c03db10edbdd570$export$c4af9125706c4d30)({
        config: sharedConfig,
        width: `${average / potential * 100}%`
    });
    const maxSpringProps = (0, $2c03db10edbdd570$export$c4af9125706c4d30)({
        config: sharedConfig,
        width: `${potential / max * $cb25c588320cd649$var$BAR_MODIFIER * 100}%`
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $80a1228f70d6ae64$export$407448d2b89b1813).div, {
        className: "capacity-bars",
        style: maxSpringProps,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "capacity-bar capacity-bar-potential",
                style: {
                    width: "100%"
                },
                children: "\xa0"
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $80a1228f70d6ae64$export$407448d2b89b1813).div, {
                className: "capacity-bar capacity-bar-average",
                style: averageSpringProps,
                children: "\xa0"
            })
        ]
    });
}
$cb25c588320cd649$var$CapacityBar.propTypes = {
    average: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number.isRequired,
    potential: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number.isRequired,
    max: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number.isRequired
};
var $cb25c588320cd649$export$2e2bcd8739ae039 = $cb25c588320cd649$var$CapacityBar;



const $c86186e032928349$var$BAR_COLORS = 4;
$c86186e032928349$var$SegmentAnalytics.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number.isRequired,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string.isRequired,
    max: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number.isRequired,
    capacity: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        average: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        potential: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
    }).isRequired
};
function $c86186e032928349$var$SegmentAnalytics({ index: index, type: type, max: max, capacity: capacity }) {
    const locale = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.locale.locale);
    const { average: average, potential: potential } = capacity;
    const label = (0, $2f44915f6f87dcf5$export$d5e75d6299e9897e)(type, locale);
    const colorScheme = index % $c86186e032928349$var$BAR_COLORS + 1;
    if (average === 0) return null;
    let ImageElement;
    switch(type){
        case "magic-carpet":
            ImageElement = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                src: (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("vehicles--magic-carpet-jasmine").src,
                style: {
                    width: "100%",
                    marginTop: "-22%"
                }
            });
            break;
        case "drive-lane":
            ImageElement = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                src: (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("vehicles--car-inbound").src,
                style: {
                    width: "100%",
                    marginTop: "-10%"
                }
            });
            break;
        case "bike-lane":
            ImageElement = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                src: (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("bikes--biker-01-inbound").src,
                style: {
                    width: "45%",
                    marginTop: "0%"
                }
            });
            break;
        case "brt-lane":
            ImageElement = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                src: (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("transit--brt-bus-inbound").src,
                style: {
                    width: "85%",
                    marginTop: "-5%"
                }
            });
            break;
        case "sidewalk":
            ImageElement = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                        src: (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("people--people-01").src
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                        src: (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("people--people-06").src,
                        style: {
                            marginLeft: "-40%"
                        }
                    })
                ]
            });
            break;
        case "scooter":
            ImageElement = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                src: (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("scooters--scooter-inbound").src,
                style: {
                    width: "38%",
                    marginTop: "0%"
                }
            });
            break;
        case "light-rail":
            ImageElement = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                src: (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("transit--light-rail-inbound").src,
                style: {
                    width: "65%",
                    marginTop: "-15%"
                }
            });
            break;
        case "bus-lane":
            ImageElement = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                src: (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("transit--bus-inbound").src,
                style: {
                    width: "90%",
                    marginTop: "0%"
                }
            });
            break;
        case "streetcar":
            ImageElement = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                src: (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get("transit--streetcar-inbound").src,
                style: {
                    width: "80%",
                    marginTop: "-15%"
                }
            });
            break;
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "segment-analytics",
        "data-color": colorScheme,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "capacity-icon",
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                    className: "capacity-icon-image",
                    children: ImageElement
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $cb25c588320cd649$export$2e2bcd8739ae039), {
                average: average,
                potential: potential,
                max: max
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "capacity-text",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "capacity-label",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "capacity-summary",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $f0db2ccbffb10732$export$2e2bcd8739ae039), {
                            average: average,
                            potential: potential,
                            locale: locale
                        })
                    })
                ]
            })
        ]
    });
}
var $c86186e032928349$export$2e2bcd8739ae039 = $c86186e032928349$var$SegmentAnalytics;




function $fd7ddb8da442b787$var$AnalyticsDialog(props) {
    const street = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street);
    const locale = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.locale.locale);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const max = (0, $4DE7A.useRef)(null);
    const [isVisible, setVisible] = (0, $4DE7A.useState)(street.showAnalytics);
    const toggleVisible = ()=>{
        setVisible(!isVisible);
        dispatch((0, $8041aaeb3f701cec$export$a3560afcf086fff0)(!isVisible));
    };
    const capacityData = (0, $403f4a82e85beb9f$export$2f9594ac3fc4865a)(street.capacitySource);
    const capacity = (0, $403f4a82e85beb9f$export$da50bfba905adb3e)(street);
    const options = {
        maximumSignificantDigits: 3
    };
    const summary = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
        id: "dialogs.analytics.street-summary",
        defaultMessage: "Your street has an estimated average traffic of {averageTotal} people per hour, and potential for up to {potentialTotal} people per hour.",
        values: {
            averageTotal: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("b", {
                children: (0, $9d270f5a79da1a95$export$f5dd818bff069720)(capacity.average, locale, options)
            }),
            potentialTotal: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("b", {
                children: (0, $9d270f5a79da1a95$export$f5dd818bff069720)(capacity.potential, locale, options)
            })
        }
    });
    // Displays typical lane width from the data source, if present. Values are
    // manually set for each unit type (metric or imperial) instead of using the
    // `prettifyWidth` helper, which has imprecise rounding. While every data
    // source we have right now does have an assumed lane width, this property
    // is optional, in case of future data sources that calculate capacity using
    // lane width as an input variable.
    let laneWidth;
    if (capacityData.typical_lane_width) {
        if (street.units === (0, $c098fdb90228b950$export$c9756beb4aae2c8d)) laneWidth = `${capacityData.typical_lane_width_ft} ft`;
        else laneWidth = `${capacityData.typical_lane_width} m`;
    }
    const widthText = laneWidth && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
        id: "dialogs.analytics.typical-lane-width",
        defaultMessage: "Capacity values are based on {laneWidth}-wide lanes.",
        values: {
            laneWidth: laneWidth
        }
    });
    const rolledUp = (0, $403f4a82e85beb9f$export$277fe1e3e6bf94ed)(street);
    // Store the maximum capacity across renders, when the data source may
    // change. This way, data sources with lower values show more intuitive
    // animation between the relative differences. (Note: one downside of this
    // method is that the 'max' is only calculated with data sources that are
    // being tried - we don't calculate the max across _all_ data sources right
    // away. The City of Vancouver data (with the lowest capacity numbers) will
    // display at max width, even though it would be significantly shorter if
    // you switched to the TUMI/GIZ data first and then back to Vancouver. This
    // is a tradeoff I'm willing to live with, unless user feedback really
    // requires us to chnage this.)
    max.current = Math.max(max.current, ...rolledUp.map((item)=>item.capacity.potential));
    function exportCSV() {
        const name = street.name || intl.formatMessage({
            id: "street.default-name",
            defaultMessage: "Unnamed St"
        });
        (0, $403f4a82e85beb9f$export$a08f02ee267cf6eb)(rolledUp, name);
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $33ed200ba87fcf5c$export$2e2bcd8739ae039), {
        children: (closeDialog)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "analytics-dialog",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("header", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "dialogs.analytics.heading",
                                defaultMessage: "Analytics"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "dialog-content",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                className: "analytics-dialog-content",
                                children: [
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
                                        children: [
                                            summary,
                                            " ",
                                            widthText
                                        ]
                                    }),
                                    rolledUp.map((item, index)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $c86186e032928349$export$2e2bcd8739ae039), {
                                            index: index,
                                            max: max.current,
                                            type: item.type,
                                            capacity: item.capacity
                                        }, index)),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("strong", {
                                                children: [
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                        id: "dialogs.analytics.source",
                                                        defaultMessage: "Source"
                                                    }),
                                                    ":"
                                                ]
                                            }),
                                            " ",
                                            capacityData.source_url ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                href: capacityData.source_url,
                                                children: capacityData.source_title
                                            }) : capacityData.source_title,
                                            ", ",
                                            capacityData.source_author
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("hr", {}),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                className: "dialog-actions",
                                children: [
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $f7d530f3bc1f26e9$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $58ebe1a968472eb7$export$2e2bcd8739ae039), {
                                        id: "show-analytics",
                                        checked: isVisible,
                                        onChange: toggleVisible,
                                        disabled: !(0, $846d9bfc81d2582a$export$adbfba29f0dd9074)(),
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "dialogs.analytics.toggle-visible",
                                            defaultMessage: "Show capacity counts in segment labels"
                                        })
                                    }),
                                    !(0, $846d9bfc81d2582a$export$adbfba29f0dd9074)() && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
                                        className: "analytics-settings-notice",
                                        children: [
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                                                icon: (0, $5cbf5c54789c9bf6$export$6e372e7f4f398099)
                                            }),
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                id: "dialogs.analytics.settings-notice",
                                                defaultMessage: "Street owners can change these settings."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                        primary: true,
                                        onClick: exportCSV,
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "dialogs.analytics.export-csv",
                                            defaultMessage: "Export as CSV"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("footer", {
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $4506383de6fe6d56$export$2e2bcd8739ae039), {
                                            locale: locale
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
                        className: "dialog-primary-action",
                        onClick: closeDialog,
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "btn.close",
                            defaultMessage: "Close"
                        })
                    })
                ]
            })
    });
}
var $fd7ddb8da442b787$export$2e2bcd8739ae039 = $fd7ddb8da442b787$var$AnalyticsDialog;


/**
 * Feature flags (dialog box)
 *
 * Secret menu.
 *
 */ 
parcelRequire("4DE7A");





function $4aa8b2e155366235$var$FeatureFlagDialog(props) {
    const flags = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.flags);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    function renderFlagList() {
        return Object.entries(flags).map(([key, flag])=>{
            const slugifyKey = key.toLowerCase().replace(/_/g, "-");
            const htmlLabel = `feature-flag__input--${slugifyKey}`;
            // If the setting has changed, display it differently
            const isNotDefault = flag.defaultValue !== flag.value;
            const labelClassName = isNotDefault ? "feature-flag-label-modified" : "";
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $58ebe1a968472eb7$export$2e2bcd8739ae039), {
                    id: htmlLabel,
                    onChange: (event)=>{
                        dispatch((0, $1ac426dbdd197303$export$4672beabf7ff6568)({
                            flag: key,
                            value: event.target.checked
                        }));
                    },
                    checked: flags[key].value,
                    disabled: flag.enabled === false,
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                        className: labelClassName,
                        children: flag.label
                    })
                })
            }, key);
        });
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $33ed200ba87fcf5c$export$2e2bcd8739ae039), {
        children: (closeDialog)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "feature-flag-dialog",
                dir: "ltr",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("header", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                            children: "Feature flags"
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "dialog-content",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("ul", {
                            children: renderFlagList()
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
                        className: "dialog-primary-action",
                        onClick: closeDialog,
                        children: "Close"
                    })
                ]
            })
    });
}
var $4aa8b2e155366235$export$2e2bcd8739ae039 = $4aa8b2e155366235$var$FeatureFlagDialog;


/* global L */ 

var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");

var $gv34t = parcelRequire("gv34t");


var $4DE7A = parcelRequire("4DE7A");

var $gv34t = parcelRequire("gv34t");

var $4DE7A = parcelRequire("4DE7A");
const $48924cf5e94f2169$export$b8efcc4bff45e15b = 1;
function $48924cf5e94f2169$export$fb237fa819e17281(map) {
    return Object.freeze({
        __version: $48924cf5e94f2169$export$b8efcc4bff45e15b,
        map: map
    });
}
function $48924cf5e94f2169$export$9efaf186a2224858(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const $48924cf5e94f2169$export$7de1b54b0142048f = (0, $4DE7A.createContext)(null);
const $48924cf5e94f2169$export$a24c9fc2f87814b2 = $48924cf5e94f2169$export$7de1b54b0142048f.Provider;
function $48924cf5e94f2169$export$ea59151b8430a4e9() {
    const context = (0, $4DE7A.useContext)($48924cf5e94f2169$export$7de1b54b0142048f);
    if (context == null) throw new Error("No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>");
    return context;
}


function $9bfd6ffb571e9494$export$96eac748c3f41e82(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance: instance, context: context } = useElement(props).current;
        (0, $4DE7A.useImperativeHandle)(forwardedRef, ()=>instance);
        return props.children == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, $48924cf5e94f2169$export$a24c9fc2f87814b2), {
            value: context
        }, props.children);
    }
    return /*#__PURE__*/ (0, $4DE7A.forwardRef)(ContainerComponent);
}
function $9bfd6ffb571e9494$export$bc37ddc24ed05446(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = (0, $4DE7A.useState)(false);
        const { instance: instance } = useElement(props, setOpen).current;
        (0, $4DE7A.useImperativeHandle)(forwardedRef, ()=>instance);
        (0, $4DE7A.useEffect)(function updateOverlay() {
            if (isOpen) instance.update();
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0, $gv34t.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0, $4DE7A.forwardRef)(OverlayComponent);
}
function $9bfd6ffb571e9494$export$18af5c7a9e9b3664(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance: instance } = useElement(props).current;
        (0, $4DE7A.useImperativeHandle)(forwardedRef, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0, $4DE7A.forwardRef)(LeafComponent);
}



var $4DE7A = parcelRequire("4DE7A");

function $31864fa8d5afd470$export$28d24ab3914549cd(useElement) {
    return function useLeafletControl(props) {
        const context = (0, $48924cf5e94f2169$export$ea59151b8430a4e9)();
        const elementRef = useElement(props, context);
        const { instance: instance } = elementRef.current;
        const positionRef = (0, $4DE7A.useRef)(props.position);
        const { position: position } = props;
        (0, $4DE7A.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0, $4DE7A.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}



var $4DE7A = parcelRequire("4DE7A");
function $9b60fd734490143b$export$a080ff44e8067a44(instance, context, container) {
    return Object.freeze({
        instance: instance,
        context: context,
        container: container
    });
}
function $9b60fd734490143b$export$2e66ec8a7fb1892f(createElement, updateElement) {
    if (updateElement == null) return function useImmutableLeafletElement(props, context) {
        const elementRef = (0, $4DE7A.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        return elementRef;
    };
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0, $4DE7A.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        const propsRef = (0, $4DE7A.useRef)(props);
        const { instance: instance } = elementRef.current;
        (0, $4DE7A.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            context
        ]);
        return elementRef;
    };
}



var $4DE7A = parcelRequire("4DE7A");

var $4DE7A = parcelRequire("4DE7A");
function $e1a350a5fb94c67d$export$46b870813daca3d4(map, attribution) {
    const attributionRef = (0, $4DE7A.useRef)(attribution);
    (0, $4DE7A.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) map.attributionControl.removeAttribution(attributionRef.current);
            if (attribution != null) map.attributionControl.addAttribution(attribution);
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}




var $4DE7A = parcelRequire("4DE7A");
function $c055d01666184290$export$8ce912bc34d0dbea(element, eventHandlers) {
    const eventHandlersRef = (0, $4DE7A.useRef)();
    (0, $4DE7A.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) element.instance.on(eventHandlers);
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) element.instance.off(eventHandlersRef.current);
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}


function $06d8be2e1457b286$export$6ee5d263358f5c0e(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane: pane
    } : props;
}


function $84d984ed347b7cb8$export$cd00a227f8cfb2c2(element, context) {
    (0, $4DE7A.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            context.layerContainer?.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function $84d984ed347b7cb8$export$73f852c6a5abdefa(useElement) {
    return function useLayer(props) {
        const context = (0, $48924cf5e94f2169$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $06d8be2e1457b286$export$6ee5d263358f5c0e)(props, context), context);
        (0, $e1a350a5fb94c67d$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $c055d01666184290$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        $84d984ed347b7cb8$export$cd00a227f8cfb2c2(elementRef.current, context);
        return elementRef;
    };
}






function $460abd0d163fff40$export$d5eca53b0accc0e0(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0, $48924cf5e94f2169$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $06d8be2e1457b286$export$6ee5d263358f5c0e)(props, context), context);
        (0, $e1a350a5fb94c67d$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $c055d01666184290$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}



var $4DE7A = parcelRequire("4DE7A");




function $79242766df6bf05a$export$d0296329a1f118ca(element, props) {
    const optionsRef = (0, $4DE7A.useRef)();
    (0, $4DE7A.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            const options = props.pathOptions ?? {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function $79242766df6bf05a$export$5fea2fe6048fc3db(useElement) {
    return function usePath(props) {
        const context = (0, $48924cf5e94f2169$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $06d8be2e1457b286$export$6ee5d263358f5c0e)(props, context), context);
        (0, $c055d01666184290$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        (0, $84d984ed347b7cb8$export$cd00a227f8cfb2c2)(elementRef.current, context);
        $79242766df6bf05a$export$d0296329a1f118ca(elementRef.current, props);
        return elementRef;
    };
}


function $7b4709b1ad3cceea$export$896a3ef451e396c4(createInstance) {
    function createElement(props, context) {
        return (0, $9b60fd734490143b$export$a080ff44e8067a44)(createInstance(props), context);
    }
    const useElement = (0, $9b60fd734490143b$export$2e66ec8a7fb1892f)(createElement);
    const useControl = (0, $31864fa8d5afd470$export$28d24ab3914549cd)(useElement);
    return (0, $9bfd6ffb571e9494$export$18af5c7a9e9b3664)(useControl);
}
function $7b4709b1ad3cceea$export$8a4d5778bce4c3ac(createElement, updateElement) {
    const useElement = (0, $9b60fd734490143b$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $84d984ed347b7cb8$export$73f852c6a5abdefa)(useElement);
    return (0, $9bfd6ffb571e9494$export$96eac748c3f41e82)(useLayer);
}
function $7b4709b1ad3cceea$export$7d18e209be943d7d(createElement, useLifecycle) {
    const useElement = (0, $9b60fd734490143b$export$2e66ec8a7fb1892f)(createElement);
    const useOverlay = (0, $460abd0d163fff40$export$d5eca53b0accc0e0)(useElement, useLifecycle);
    return (0, $9bfd6ffb571e9494$export$bc37ddc24ed05446)(useOverlay);
}
function $7b4709b1ad3cceea$export$5e776dbe3c7d2790(createElement, updateElement) {
    const useElement = (0, $9b60fd734490143b$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const usePath = (0, $79242766df6bf05a$export$5fea2fe6048fc3db)(useElement);
    return (0, $9bfd6ffb571e9494$export$96eac748c3f41e82)(usePath);
}
function $7b4709b1ad3cceea$export$4f432c6de5c4ddb8(createElement, updateElement) {
    const useElement = (0, $9b60fd734490143b$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $84d984ed347b7cb8$export$73f852c6a5abdefa)(useElement);
    return (0, $9bfd6ffb571e9494$export$18af5c7a9e9b3664)(useLayer);
}


var $4c6e51fb35ab0982$exports = {};
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory($4c6e51fb35ab0982$exports);
})($4c6e51fb35ab0982$exports, function(exports1) {
    "use strict";
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error("No value provided for variable " + str);
            else if (typeof value === "function") value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window["webkit" + name] || window["moz" + name] || window["ms" + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === "function" ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === "undefined" || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === "object") for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== "string") console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== "function") {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === "object" && "x" in x && "y" in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === "number" || "x" in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === "number" || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== "object") {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === "object" && "lat" in a) return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: "EPSG:3857",
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: "EPSG:900913"
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS("http://www.w3.org/2000/svg", name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = "", i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? "L" : "M") + p.x + " " + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? "z" : "x" : "";
        }
        // SVG complains about empty path strings
        return str || "M0 0";
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = "ActiveXObject" in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = "msLaunchUri" in navigator && !("documentMode" in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains("webkit");
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains("android");
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains("android 2") || userAgentContains("android 3");
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains("chrome");
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains("gecko") && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains("safari");
    var phantom = userAgentContains("phantom");
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = "OTransition" in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf("Win") === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && "transition" in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = "MozPerspective" in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = "ontouchstart" in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("testPassiveEventSupport", falseFn, opts);
            window.removeEventListener("testPassiveEventSupport", falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement("canvas").getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate("svg").createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement("div");
        div.innerHTML = "<svg/>";
        return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement("div");
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = "url(#default#VML)";
            return shape && typeof shape.adj === "object";
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf("Mac") === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf("Linux") === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? "MSPointerDown" : "pointerdown";
    var POINTER_MOVE = Browser.msPointer ? "MSPointerMove" : "pointermove";
    var POINTER_UP = Browser.msPointer ? "MSPointerUp" : "pointerup";
    var POINTER_CANCEL = Browser.msPointer ? "MSPointerCancel" : "pointercancel";
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === "touchstart") _addPointerDocListener();
        if (!handle[type]) {
            console.warn("wrong event specified:", type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn("wrong event specified:", type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = "dblclick";
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener("dblclick", handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener("click", simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener("dblclick", handlers.dblclick);
        obj.removeEventListener("click", handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        "transform",
        "webkitTransform",
        "OTransform",
        "MozTransform",
        "msTransform"
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        "webkitTransition",
        "transition",
        "OTransition",
        "MozTransition",
        "msTransition"
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === "string" ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === "auto") && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === "auto" ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || "";
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + " " : "") + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ("opacity" in el.style) el.style.opacity = value;
        else if ("filter" in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale ? " scale(" + scale + ")" : "");
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + "px";
            el.style.top = point.y + "px";
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ("onselectstart" in document) {
        disableTextSelection = function() {
            on(window, "selectstart", preventDefault);
        };
        enableTextSelection = function() {
            off(window, "selectstart", preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            "userSelect",
            "WebkitUserSelect",
            "OUserSelect",
            "MozUserSelect",
            "msUserSelect"
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = "none";
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, "dragstart", preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, "dragstart", preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = "none";
        on(window, "keydown", restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, "keydown", restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === "object") for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = "_leaflet_events";
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === "object") for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") handler = addDoubleTapListener(obj, handler);
        else if ("addEventListener" in obj) {
            if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === "mouseenter" || type === "mouseleave") {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent("on" + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? "_" + stamp(context) : "");
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") removeDoubleTapListener(obj, handler);
        else if ("removeEventListener" in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent("on" + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, "wheel", stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, "mousedown touchstart dblclick contextmenu", stopPropagation);
        el["_leaflet_disable_click"] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire("start");
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire("step");
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire("end");
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error("Bounds are not valid.");
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire("moveend");
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    "step": this._onPanTransitionStep,
                    "end": this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire("movestart");
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, "leaflet-pan-anim");
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire("move").fire("moveend");
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens("moveend", this._panInsideMaxBounds)) this.off("moveend", this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on("moveend", this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire("move");
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, "moveend"), 200);
                } else this.fire("moveend");
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire("resize", {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire("viewreset");
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!("geolocation" in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: "Geolocation not supported."
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire("locationerror", {
                code: c,
                message: "Geolocation error: " + message + "."
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === "number") data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire("locationfound", data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off("moveend", this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire("unload");
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === "string" ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error("Map container not found.");
            else if (container._leaflet_id) throw new Error("Map container is already initialized.");
            on(container, "scroll", this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, "leaflet-container" + (Browser.touch ? " leaflet-touch" : "") + (Browser.retina ? " leaflet-retina" : "") + (Browser.ielt9 ? " leaflet-oldie" : "") + (Browser.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
            var position = getStyle(container, "position");
            if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") container.style.position = "relative";
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane("mapPane", this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane("tilePane");
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane("overlayPane");
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane("shadowPane");
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane("markerPane");
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane("tooltipPane");
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane("popupPane");
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, "leaflet-zoom-hide");
                addClass(panes.shadowPane, "leaflet-zoom-hide");
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire("viewprereset");
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire("viewreset");
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire("load");
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire("zoomstart");
            if (!noMoveStart) this.fire("movestart");
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire("zoom", data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire("move", data);
            } else if (data && data.pinch) this.fire("zoom", data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire("zoomend");
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire("moveend");
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, "resize", this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el["_leaflet_disable_click"]) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === "mousedown") // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            "click",
            "dblclick",
            "mouseover",
            "mouseout",
            "contextmenu"
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === "click") {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = "preclick";
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === "contextmenu") preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on("load", callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire("move");
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, "leaflet-pan-anim");
            this.fire("moveend");
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1("div", "leaflet-proxy leaflet-zoom-animated");
            this._panes.mapPane.appendChild(proxy);
            this.on("zoomanim", function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on("load moveend", this._animMoveEnd, this);
            this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off("load moveend", this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, "leaflet-zoom-anim");
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire("zoomanim", {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, "leaflet-zoom-anim");
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire("zoom");
            delete this._tempFireZoomEvent;
            this.fire("move");
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: "topright"
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, "leaflet-control");
            if (pos.indexOf("bottom") !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on("unload", this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off("unload", this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + " " + l + hSide;
                corners[vSide + hSide] = create$1("div", className, container);
            }
            createCorner("top", "left");
            createCorner("top", "right");
            createCorner("bottom", "left");
            createCorner("bottom", "right");
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: "topright",
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on("add remove", this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off("add remove", this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, "leaflet-control-layers-expanded");
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, "leaflet-control-layers-scrollbar");
                this._section.style.height = acceptableHeight + "px";
            } else removeClass(this._section, "leaflet-control-layers-scrollbar");
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, "leaflet-control-layers-expanded");
            return this;
        },
        _initLayout: function() {
            var className = "leaflet-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute("aria-haspopup", true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1("section", className + "-list");
            if (collapsed) {
                this._map.on("click", this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1("a", className + "-toggle", container);
            link.href = "#";
            link.title = "Layers";
            link.setAttribute("role", "button");
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1("div", className + "-base", section);
            this._separator = create$1("div", className + "-separator", section);
            this._overlaysList = create$1("div", className + "-overlays", section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on("add remove", this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
            var radioFragment = document.createElement("div");
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement("input");
                input.type = "checkbox";
                input.className = "leaflet-control-layers-selector";
                input.defaultChecked = checked;
            } else input = this._createRadioElement("leaflet-base-layers_" + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, "click", this._onInputClick, this);
            var name = document.createElement("span");
            name.innerHTML = " " + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement("span");
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, "click", preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, "click", preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: "topleft",
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: "Zoom in",
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: "Zoom out"
        },
        onAdd: function(map) {
            var zoomName = "leaflet-control-zoom", container = create$1("div", zoomName + " leaflet-bar"), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
            this._updateDisabled();
            map.on("zoomend zoomlevelschange", this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1("a", className, container);
            link.innerHTML = html;
            link.href = "#";
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute("role", "button");
            link.setAttribute("aria-label", title);
            disableClickPropagation(link);
            on(link, "click", stop);
            on(link, "click", fn, this);
            on(link, "click", this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = "leaflet-disabled";
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "false");
            this._zoomOutButton.setAttribute("aria-disabled", "false");
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute("aria-disabled", "true");
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute("aria-disabled", "true");
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: "bottomleft",
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = "leaflet-control-scale", container = create$1("div", className), options = this.options;
            this._addScales(options, className + "-line", container);
            map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1("div", className, container);
            if (options.imperial) this._iScale = create$1("div", className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + " m" : meters / 1000 + " km";
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + "px";
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: "bottomright",
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + " " : "") + "Leaflet</a>"
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1("div", "leaflet-control-attribution");
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on("layeradd", this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once("remove", function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(", "));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? "touchstart mousedown" : "mousedown";
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, "leaflet-zoom-anim")) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire("down");
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === "mousedown";
            on(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
            on(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire("dragstart");
                this._moved = true;
                addClass(document.body, "leaflet-dragging");
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, "leaflet-drag-target");
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire("predrag", e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire("drag", e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, "leaflet-dragging");
            if (this._lastTarget) {
                removeClass(this._lastTarget, "leaflet-drag-target");
                this._lastTarget = null;
            }
            off(document, "mousemove touchmove", this._onMove, this);
            off(document, "mouseup touchend touchcancel", this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire("dragend", {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
    }
    function _flat(latlngs) {
        console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: "EPSG:3395",
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: "EPSG:4326",
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: "overlayPane",
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once("remove", function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire("add");
            map.fire("layeradd", {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error("The provided object is not a Layer.");
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire("layerremove", {
                    layer: layer
                });
                layer.fire("remove");
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire("zoomlevelschange");
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke("setZIndex", zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire("layeradd", {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire("layerremove", {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke("setStyle", style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon("icon", oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon("shadow", oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === "icon") throw new Error("iconUrl not set in Icon options (see the docs).");
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + "Size"];
            if (typeof sizeOption === "number") sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = "leaflet-marker-" + name + " " + (options.className || "");
            if (anchor) {
                img.style.marginLeft = -anchor.x + "px";
                img.style.marginTop = -anchor.y + "px";
            }
            if (size) {
                img.style.width = size.x + "px";
                img.style.height = size.y + "px";
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement("img");
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: "marker-icon.png",
            iconRetinaUrl: "marker-icon-2x.png",
            shadowUrl: "marker-shadow.png",
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== "string") IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1("div", "leaflet-default-icon-path", document.body);
            var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage"); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return "";
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, "leaflet-marker-draggable");
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire("move", e).fire("drag", e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire("moveend").fire("dragend", e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: "",
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: "Marker",
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: "markerPane",
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: "shadowPane",
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on("zoomanim", this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off("zoomanim", this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === "IMG") icon.alt = options.alt || "";
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = "0";
                icon.setAttribute("role", "button");
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, "focus", this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = "";
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, "focus", this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, "leaflet-interactive");
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: "#3388ff",
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: "round",
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: "round",
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: "evenodd",
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === "number") // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === "function") style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case "Point":
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case "MultiPoint":
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case "LineString":
            case "MultiLineString":
                latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case "Polygon":
            case "MultiPolygon":
                latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case "GeometryCollection":
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: "Feature",
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case "FeatureCollection":
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error("Invalid GeoJSON object.");
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === "Feature" || geojson.type === "FeatureCollection") return geojson;
        return {
            type: "Feature",
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: "Point",
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "LineString",
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "Polygon",
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: "MultiPoint",
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === "MultiPoint") return this.toMultiPoint(precision);
            var isGeometryCollection = type === "GeometryCollection", jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === "FeatureCollection") jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: "GeometryCollection"
            });
            return {
                type: "FeatureCollection",
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: "",
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: "",
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ""
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, "leaflet-interactive");
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "IMG";
            var img = this._image = wasElementSupplied ? this._url : create$1("img");
            addClass(img, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(img, "leaflet-zoom-animated");
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, "load");
            img.onerror = bind(this._overlayOnError, this, "error");
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + "px";
            image.style.height = size.y + "px";
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire("error");
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "VIDEO";
            var vid = this._image = wasElementSupplied ? this._url : create$1("video");
            addClass(vid, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(vid, "leaflet-zoom-animated");
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, "load");
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName("source");
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) vid.style["objectFit"] = "fill";
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1("source");
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(el, "leaflet-zoom-animated");
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: "",
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ""
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, "leaflet-interactive");
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, "leaflet-interactive");
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = "hidden";
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = "";
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error("Unable to get source layer LatLng.");
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
            if (typeof content === "string") node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire("contentupdate");
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + "px";
            this._container.style.left = left + "px";
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: "popupPane",
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire("popupopen", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire("popupopen", {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on("preclick", stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire("popupclose", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire("popupclose", {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off("preclick", stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-popup", container = this._container = create$1("div", prefix + " " + (this.options.className || "") + " leaflet-zoom-animated");
            var wrapper = this._wrapper = create$1("div", prefix + "-content-wrapper", container);
            this._contentNode = create$1("div", prefix + "-content", wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, "contextmenu", stopPropagation);
            this._tipContainer = create$1("div", prefix + "-tip-container", container);
            this._tip = create$1("div", prefix + "-tip", this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1("a", prefix + "-close-button", container);
                closeButton.setAttribute("role", "button"); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute("aria-label", "Close popup");
                closeButton.href = "#close";
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, "click", function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = "";
            style.whiteSpace = "nowrap";
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + "px";
            style.whiteSpace = "";
            style.height = "";
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + "px";
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire("autopanstart").panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: "tooltipPane",
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: "auto",
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire("tooltipopen", {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire("tooltipopen", {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire("tooltipclose", {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire("tooltipclose", {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            this._contentNode = this._container = create$1("div", className);
            this._container.setAttribute("role", "tooltip");
            this._container.setAttribute("id", "leaflet-tooltip-" + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === "top") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === "bottom") {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === "center") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === "right") {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === "left") {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = "right";
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = "left";
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, "leaflet-tooltip-right");
            removeClass(container, "leaflet-tooltip-left");
            removeClass(container, "leaflet-tooltip-top");
            removeClass(container, "leaflet-tooltip-bottom");
            addClass(container, "leaflet-tooltip-" + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? "off" : "on", events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) {
                on(el, "focus", function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, "blur", this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) el.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once("moveend", function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: "leaflet-div-icon"
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : "";
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
            }
            this._setIconStyles(div, "icon");
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: "tilePane",
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: "",
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1("div", "leaflet-layer " + (this.options.className || ""));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error("Attempted to load an infinite number of tiles");
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire("loading");
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ":" + coords.y + ":" + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(":"), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire("tileunload", {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, "leaflet-tile");
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + "px";
            tile.style.height = tileSize.y + "px";
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire("tileloadstart", {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire("tileerror", {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, "leaflet-tile-loaded");
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire("tileload", {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire("load");
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: "abc",
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: "",
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === "string") options.subdomains = options.subdomains.split("");
            this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement("img");
            on(tile, "load", bind(this._tileOnLoad, this, done, tile));
            on(tile, "error", bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === "") tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === "string") tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = "";
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? "@2x" : "",
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data["y"] = invertedY;
                data["-y"] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute("src") !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire("tileabort", {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute("src", emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: "WMS",
            request: "GetMap",
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: "",
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: "",
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: "image/jpeg",
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: "1.1.1"
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(","), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, "leaflet-zoom-animated");
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
            this.off("update", this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement("canvas");
            on(container, "mousemove", this._onMouseMove, this);
            on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
            on(container, "mouseout", this._handleMouseOut, this);
            container["_leaflet_disable_events"] = true;
            this._ctx = container.getContext("2d");
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + "px";
            container.style.height = size.y + "px";
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire("update");
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === "string") {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || "evenodd");
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, "leaflet-interactive");
                this._fireEvent([
                    layer
                ], e, "mouseout");
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, "leaflet-interactive"); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, "mouseover");
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
            return function(name) {
                return document.createElement("<lvml:" + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1("div", "leaflet-vml-container");
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire("update");
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate("shape");
            addClass(container, "leaflet-vml-shape " + (this.options.className || ""));
            container.coordsize = "1 1";
            layer._path = vmlCreate("path");
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate("stroke");
                container.appendChild(stroke);
                stroke.weight = options.weight + "px";
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
                else stroke.dashStyle = "";
                stroke.endcap = options.lineCap.replace("butt", "flat");
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate("fill");
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create("svg");
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute("pointer-events", "none");
            this._rootGroup = create("g");
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute("width", size.x);
                container.setAttribute("height", size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute("viewBox", [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(" "));
            this.fire("update");
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create("path");
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, "leaflet-interactive");
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute("stroke", options.color);
                path.setAttribute("stroke-opacity", options.opacity);
                path.setAttribute("stroke-width", options.weight);
                path.setAttribute("stroke-linecap", options.lineCap);
                path.setAttribute("stroke-linejoin", options.lineJoin);
                if (options.dashArray) path.setAttribute("stroke-dasharray", options.dashArray);
                else path.removeAttribute("stroke-dasharray");
                if (options.dashOffset) path.setAttribute("stroke-dashoffset", options.dashOffset);
                else path.removeAttribute("stroke-dashoffset");
            } else path.setAttribute("stroke", "none");
            if (options.fill) {
                path.setAttribute("fill", options.fillColor || options.color);
                path.setAttribute("fill-opacity", options.fillOpacity);
                path.setAttribute("fill-rule", options.fillRule || "evenodd");
            } else path.setAttribute("fill", "none");
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
            // drawing a circle with two half-arcs
            var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute("d", path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === "overlayPane" || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on("unload", this._destroy, this);
        },
        addHooks: function() {
            on(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1("div", "leaflet-zoom-box", this._container);
                addClass(this._container, "leaflet-crosshair");
                this._map.fire("boxzoomstart");
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + "px";
            this._box.style.height = size.y + "px";
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, "leaflet-crosshair");
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire("boxzoomend", {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook("addHandler", "boxZoom", BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === "center") map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on("predrag", this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on("predrag", this._onPreDragWrap, this);
                    map.on("zoomend", this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, "leaflet-grab leaflet-touch-drag");
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-grab");
            removeClass(this._map._container, "leaflet-touch-drag");
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire("movestart").fire("dragstart");
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire("move", e).fire("drag", e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire("dragend", e);
            if (noInertia) map.fire("moveend");
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire("moveend");
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook("addHandler", "dragging", Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = "0";
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire("focus");
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire("blur");
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook("addHandler", "keyboard", Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, "wheel", this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === "center") map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, "touchend", preventDefault);
                on(document, "touchend touchcancel", this._cancelClickPrevent);
                this._simulateEvent("contextmenu", first);
            }, this), tapHoldDelay);
            on(document, "touchend touchcancel contextmenu", this._cancel, this);
            on(document, "touchmove", this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, "touchend", preventDefault);
            off(document, "touchend touchcancel", cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, "touchend touchcancel contextmenu", this._cancel, this);
            off(document, "touchmove", this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook("addHandler", "tapHold", TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, "leaflet-touch-zoom");
            on(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-touch-zoom");
            off(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== "center") this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, "touchmove", this._onTouchMove, this);
            on(document, "touchend touchcancel", this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === "center") {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, "touchmove", this._onTouchMove, this);
            off(document, "touchend touchcancel", this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook("addHandler", "touchZoom", TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});


const $8242fca73e03cb77$export$5af5c3cc9905683 = (0, $7b4709b1ad3cceea$export$896a3ef451e396c4)(function createAttributionControl(props) {
    return new (0, $4c6e51fb35ab0982$exports.Control).Attribution(props);
});




var $4DE7A = parcelRequire("4DE7A");
function $423fe21ae6edb563$var$_extends() {
    $423fe21ae6edb563$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $423fe21ae6edb563$var$_extends.apply(this, arguments);
}
function $423fe21ae6edb563$var$MapContainerComponent({ bounds: bounds, boundsOptions: boundsOptions, center: center, children: children, className: className, id: id, placeholder: placeholder, style: style, whenReady: whenReady, zoom: zoom, ...options }, forwardedRef) {
    const [props] = (0, $4DE7A.useState)({
        className: className,
        id: id,
        style: style
    });
    const [context, setContext] = (0, $4DE7A.useState)(null);
    (0, $4DE7A.useImperativeHandle)(forwardedRef, ()=>context?.map ?? null, [
        context
    ]);
    const mapRef = (0, $4DE7A.useCallback)((node)=>{
        if (node !== null && context === null) {
            const map = new (0, $4c6e51fb35ab0982$exports.Map)(node, options);
            if (center != null && zoom != null) map.setView(center, zoom);
            else if (bounds != null) map.fitBounds(bounds, boundsOptions);
            if (whenReady != null) map.whenReady(whenReady);
            setContext((0, $48924cf5e94f2169$export$fb237fa819e17281)(map));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $4DE7A.useEffect)(()=>{
        return ()=>{
            context?.map.remove();
        };
    }, [
        context
    ]);
    const contents = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, $48924cf5e94f2169$export$a24c9fc2f87814b2), {
        value: context
    }, children) : placeholder ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("div", $423fe21ae6edb563$var$_extends({}, props, {
        ref: mapRef
    }), contents);
}
const $423fe21ae6edb563$export$23f3dfd47374502b = /*#__PURE__*/ (0, $4DE7A.forwardRef)($423fe21ae6edb563$var$MapContainerComponent);

function $574b52cc7e574c19$export$b39104a5f1b9296f(layer, props, prevProps) {
    const { opacity: opacity, zIndex: zIndex } = props;
    if (opacity != null && opacity !== prevProps.opacity) layer.setOpacity(opacity);
    if (zIndex != null && zIndex !== prevProps.zIndex) layer.setZIndex(zIndex);
}



const $7233333e91d1be1b$export$f52ee31d61d0b27b = (0, $7b4709b1ad3cceea$export$4f432c6de5c4ddb8)(function createTileLayer({ url: url, ...options }, context) {
    const layer = new (0, $4c6e51fb35ab0982$exports.TileLayer)(url, (0, $06d8be2e1457b286$export$6ee5d263358f5c0e)(options, context));
    return (0, $9b60fd734490143b$export$a080ff44e8067a44)(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    (0, $574b52cc7e574c19$export$b39104a5f1b9296f)(layer, props, prevProps);
    const { url: url } = props;
    if (url != null && url !== prevProps.url) layer.setUrl(url);
});



var $4DE7A = parcelRequire("4DE7A");
function $8fe4cafbb9a984d1$export$86f8f9f08863e403() {
    return (0, $48924cf5e94f2169$export$ea59151b8430a4e9)().map;
}
function $8fe4cafbb9a984d1$export$4c2959913f5c7962(type, handler) {
    const map = $8fe4cafbb9a984d1$export$86f8f9f08863e403();
    (0, $4DE7A.useEffect)(function addMapEventHandler() {
        // @ts-ignore event type
        map.on(type, handler);
        return function removeMapEventHandler() {
            // @ts-ignore event type
            map.off(type, handler);
        };
    }, [
        map,
        type,
        handler
    ]);
    return map;
}
function $8fe4cafbb9a984d1$export$1c51e2c234152172(handlers) {
    const map = $8fe4cafbb9a984d1$export$86f8f9f08863e403();
    (0, $4DE7A.useEffect)(function addMapEventHandlers() {
        map.on(handlers);
        return function removeMapEventHandlers() {
            map.off(handlers);
        };
    }, [
        map,
        handlers
    ]);
    return map;
}



const $b047875379dd78b6$export$dd36b6cb96de1ba3 = (0, $7b4709b1ad3cceea$export$896a3ef451e396c4)(function createZoomControl(props) {
    return new (0, $4c6e51fb35ab0982$exports.Control).Zoom(props);
});








parcelRequire("4DE7A");

function $e640fbda60949eac$var$ErrorBanner(props) {
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "geotag-error-banner",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "dialogs.geotag.geotag-unavailable",
            defaultMessage: "Geocoding services are currently unavailable. You can view the map, but you won\u2019t be able to change this street\u2019s location."
        })
    });
}
var $e640fbda60949eac$export$2e2bcd8739ae039 = $e640fbda60949eac$var$ErrorBanner;




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");

var $f065551dd03a23b0$exports = {};



(function(global, factory) {
    $f065551dd03a23b0$exports = factory((parcelRequire("4DE7A")), (parcelRequire("fmSD5")), (parcelRequire("4Fm0Q")));
})($f065551dd03a23b0$exports, function(React, PropTypes, Downshift) {
    "use strict";
    React = React && React.hasOwnProperty("default") ? React["default"] : React;
    PropTypes = PropTypes && PropTypes.hasOwnProperty("default") ? PropTypes["default"] : PropTypes;
    Downshift = Downshift && Downshift.hasOwnProperty("default") ? Downshift["default"] : Downshift;
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);
            if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
            ownKeys.forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
        }
        return target;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    class DownshiftPelias extends React.Component {
        constructor(props){
            super(props);
            _defineProperty(this, "handleInputValueChange", (inputValue, stateAndHelpers)=>{
                // Runs `handleInputValueChange` if provided by parent
                if (typeof this.props.handleInputValueChange === "function") this.props.handleInputValueChange(inputValue, stateAndHelpers);
                this.doAutocomplete(inputValue);
            });
            _defineProperty(this, "doAutocomplete", (inputValue)=>{
                const timestamp = Date.now();
                this.lastInputTimestamp = timestamp;
                if (!inputValue) {
                    this.setState({
                        pending: false,
                        results: null
                    });
                    return;
                }
                this.setState({
                    pending: true
                });
                this.props.pelias.autocomplete.setSearchTerm(inputValue).execute().then((response)=>{
                    // Only display the results if the timestamp associated
                    // with this request is still current
                    if (timestamp === this.lastInputTimestamp) this.setState({
                        pending: false,
                        results: response
                    });
                }).catch((error)=>{
                    console.log(error);
                    if (timestamp === this.lastInputTimestamp) this.setState({
                        pending: false,
                        error: true
                    });
                });
            });
            _defineProperty(this, "doSearch", (inputValue)=>{
                const timestamp = Date.now();
                this.lastInputTimestamp = timestamp;
                if (!inputValue) {
                    this.setState({
                        pending: false,
                        results: null
                    });
                    return;
                }
                this.setState({
                    pending: true
                });
                this.props.pelias.search.setSearchTerm(inputValue).execute().then((response)=>{
                    // Only display the results if the timestamp associated
                    // with this request is still current
                    if (timestamp === this.lastInputTimestamp) this.setState({
                        pending: false,
                        results: response
                    });
                }).catch((error)=>{
                    console.log(error);
                    if (timestamp === this.lastInputTimestamp) this.setState({
                        pending: false,
                        error: true
                    });
                });
            });
            _defineProperty(this, "defaultItemToString", (item)=>item ? item.properties.label : "");
            this.state = {
                results: null,
                pending: false,
                error: false // For internal use only to track when inputs are being made,
            };
            this.lastInputTimestamp = Date.now();
        }
        render() {
            return React.createElement(Downshift, _extends({
                onChange: this.handleChange,
                onInputValueChange: this.handleInputValueChange,
                itemToString: this.props.itemToString || this.defaultItemToString
            }, this.props), (_ref)=>{
                let _getInputProps = _ref.getInputProps, highlightedIndex = _ref.highlightedIndex, inputValue = _ref.inputValue, args = _objectWithoutProperties(_ref, [
                    "getInputProps",
                    "highlightedIndex",
                    "inputValue"
                ]);
                return this.props.children(_objectSpread({}, args, {
                    highlightedIndex: // Put back the stuff we destructured
                    highlightedIndex,
                    inputValue: inputValue,
                    // Modify the `onKeyDown` prop of input props so that it handles the "Enter"
                    // key being pressed, by default.
                    getInputProps: (args)=>_getInputProps(_objectSpread({}, args, {
                            onKeyDown: (event)=>{
                                // Run `onKeyDown` from parent <input> element, if provided
                                if (args && typeof args.onKeyDown === "function") args.onKeyDown(event);
                                 // If `enter` key is pressed and nothing in the menu is highlighted,
                                // then perform a search by calling `doSearch`. This retrieves
                                // results Pelias's search query endpoint.
                                if (event.key === "Enter" && highlightedIndex === null) {
                                    // Bail if default Downshift behavior is prevented
                                    if (event.nativeEvent.preventDownshiftDefault === true) return;
                                    this.doSearch(inputValue);
                                }
                            }
                        })),
                    doSearch: ()=>{
                        this.doSearch(inputValue);
                    },
                    results: this.state.results,
                    pending: this.state.pending,
                    error: this.state.error
                }));
            });
        }
    }
    _defineProperty(DownshiftPelias, "propTypes", {
        children: PropTypes.func.isRequired,
        pelias: PropTypes.shape({
            search: PropTypes.shape({
                setSearchTerm: PropTypes.func.isRequired,
                execute: PropTypes.func.isRequired
            }).isRequired,
            autocomplete: PropTypes.object.isRequired
        }).isRequired,
        itemToString: PropTypes.func
    });
    return DownshiftPelias;
});


var $4c39ecc980a42696$exports = {};
"use strict";
var $4c39ecc980a42696$var$__importDefault = $4c39ecc980a42696$exports && $4c39ecc980a42696$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($4c39ecc980a42696$exports, "__esModule", {
    value: true
});

const $4c39ecc980a42696$var$lib_1 = $4c39ecc980a42696$var$__importDefault((parcelRequire("3yVPP")));
$4c39ecc980a42696$exports.default = $4c39ecc980a42696$var$lib_1.default;



$3e23de606960f620$var$GeoSearch.propTypes = {
    handleSearchResults: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    focus: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        lat: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        lng: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
    })
};
function $3e23de606960f620$var$GeoSearch({ handleSearchResults: handleSearchResults, focus: focus = {
    lat: 0,
    lng: 0
} }) {
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const inputEl = (0, $4DE7A.useRef)();
    function handleClickClearSearch(clearSelection) {
        clearSelection();
        inputEl.current.focus();
    }
    function handleChange(selection) {
        if (!selection) return;
        handleSearchResults(selection.geometry.coordinates.reverse(), selection.properties);
        inputEl.current.focus();
    }
    function renderSuggestion(item, index, inputValue, getItemProps) {
        const label = item.properties.label;
        // Highlight the input query
        const regex = new RegExp(`(${inputValue})`, "gi");
        const parts = label.split(regex);
        const highlighted = parts.map((part, index)=>{
            if (part.toLowerCase() === inputValue.toLowerCase()) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("strong", {
                children: part
            }, index);
            return part;
        });
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("li", {
            ...getItemProps({
                className: "geotag-suggestion",
                key: item.properties.gid,
                index: index,
                item: item
            }),
            children: highlighted
        });
    }
    const pelias = new (0, (/*@__PURE__*/$parcel$interopDefault($4c39ecc980a42696$exports)))({
        peliasUrl: `https://${(0, $63b5c9d178f1431e$export$669561b7c46fd3f7)}`,
        apiKey: (0, $63b5c9d178f1431e$export$620b2e0c341943a2)
    });
    pelias.search.setBoundaryCircle({
        lat: focus.lat,
        lon: focus.lng,
        radius: 10
    });
    pelias.autocomplete.setFocusPoint({
        lat: focus.lat,
        lon: focus.lng
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f065551dd03a23b0$exports))), {
        pelias: pelias,
        onChange: handleChange,
        children: ({ getInputProps: getInputProps, getMenuProps: getMenuProps, getItemProps: getItemProps, clearSelection: clearSelection, inputValue: inputValue, isOpen: isOpen, results: results })=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "geotag-input-form",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("input", {
                        ...getInputProps({
                            className: "geotag-input",
                            autoFocus: true,
                            ref: inputEl,
                            placeholder: intl.formatMessage({
                                id: "dialogs.geotag.search",
                                defaultMessage: "Search for a location"
                            })
                        })
                    }),
                    inputValue && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                        title: intl.formatMessage({
                            id: "dialogs.geotag.clear-search",
                            defaultMessage: "Clear search"
                        }),
                        className: "geotag-input-clear",
                        onClick: ()=>{
                            handleClickClearSearch(clearSelection);
                        },
                        children: "\xd7"
                    }),
                    isOpen && results && results.features.length > 0 && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "geotag-suggestions-container",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("ul", {
                            ...getMenuProps({
                                className: "geotag-suggestions-list"
                            }),
                            children: results.features.map((item, index)=>renderSuggestion(item, index, inputValue, getItemProps))
                        })
                    })
                ]
            })
    });
}
var $3e23de606960f620$export$2e2bcd8739ae039 = $3e23de606960f620$var$GeoSearch;



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");




var $4DE7A = parcelRequire("4DE7A");
const $ef173d254312be9c$export$129a32eedafa97c5 = (0, $7b4709b1ad3cceea$export$7d18e209be943d7d)(function createPopup(props, context) {
    const popup = new (0, $4c6e51fb35ab0982$exports.Popup)(props, context.overlayContainer);
    return (0, $9b60fd734490143b$export$a080ff44e8067a44)(popup, context);
}, function usePopupLifecycle(element, context, { position: position }, setOpen) {
    (0, $4DE7A.useEffect)(function addPopup() {
        const { instance: instance } = element;
        function onPopupOpen(event) {
            if (event.popup === instance) {
                instance.update();
                setOpen(true);
            }
        }
        function onPopupClose(event) {
            if (event.popup === instance) setOpen(false);
        }
        context.map.on({
            popupopen: onPopupOpen,
            popupclose: onPopupClose
        });
        if (context.overlayContainer == null) {
            // Attach to a Map
            if (position != null) instance.setLatLng(position);
            instance.openOn(context.map);
        } else // Attach to container component
        context.overlayContainer.bindPopup(instance);
        return function removePopup() {
            context.map.off({
                popupopen: onPopupOpen,
                popupclose: onPopupClose
            });
            context.overlayContainer?.unbindPopup();
            context.map.removeLayer(instance);
        };
    }, [
        element,
        context,
        setOpen,
        position
    ]);
});



const $f0316399362fac61$var$POPUP_MAX_WIDTH = 300;
const $f0316399362fac61$var$POPUP_OFFSET = [
    0,
    -30
];
const $f0316399362fac61$var$LocationPopup = (props)=>{
    const { label: label, position: position, isEditable: isEditable = false, isClearable: isClearable = false, handleClear: handleClear, handleConfirm: handleConfirm } = props;
    if (!position) return null;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $ef173d254312be9c$export$129a32eedafa97c5), {
        position: position,
        offset: $f0316399362fac61$var$POPUP_OFFSET,
        maxWidth: $f0316399362fac61$var$POPUP_MAX_WIDTH,
        closeButton: false,
        closeOnClick: false,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "geotag-location-label",
                children: label
            }),
            isEditable && (isClearable ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                    tertiary: true,
                    onClick: handleClear,
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "dialogs.geotag.clear-location",
                        defaultMessage: "Clear location"
                    })
                })
            }) : /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                    primary: true,
                    onClick: handleConfirm,
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "dialogs.geotag.confirm-location",
                        defaultMessage: "Confirm location"
                    })
                })
            }))
        ]
    });
};
$f0316399362fac61$var$LocationPopup.propTypes = {
    position: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        lat: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        lng: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
    }),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    isEditable: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    isClearable: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    handleConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    handleClear: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func
};
var $f0316399362fac61$export$2e2bcd8739ae039 = $f0316399362fac61$var$LocationPopup;




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");


const $7808a52abb1693d3$export$e98856a975cab58e = (0, $7b4709b1ad3cceea$export$8a4d5778bce4c3ac)(function createMarker({ position: position, ...options }, ctx) {
    const marker = new (0, $4c6e51fb35ab0982$exports.Marker)(position, options);
    return (0, $9b60fd734490143b$export$a080ff44e8067a44)(marker, (0, $48924cf5e94f2169$export$9efaf186a2224858)(ctx, {
        overlayContainer: marker
    }));
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) marker.setLatLng(props.position);
    if (props.icon != null && props.icon !== prevProps.icon) marker.setIcon(props.icon);
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) marker.setZIndexOffset(props.zIndexOffset);
    if (props.opacity != null && props.opacity !== prevProps.opacity) marker.setOpacity(props.opacity);
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) marker.dragging.enable();
        else marker.dragging.disable();
    }
});


function $7271bffc0eba1873$var$LocationMarker({ position: position, geocodeAvailable: geocodeAvailable, onDragStart: onDragStart, onDragEnd: onDragEnd }) {
    const ref = (0, $4DE7A.useRef)(null);
    const eventHandlers = (0, $4DE7A.useMemo)(()=>({
            dragstart (event) {
                const marker = ref.current;
                if (marker !== null) onDragStart(event);
            },
            dragend (event) {
                const marker = ref.current;
                if (marker !== null) onDragEnd(event);
            }
        }), [
        onDragStart,
        onDragEnd
    ]);
    return position ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $7808a52abb1693d3$export$e98856a975cab58e), {
        ref: ref,
        position: position,
        draggable: geocodeAvailable,
        eventHandlers: eventHandlers
    }) : null;
}
$7271bffc0eba1873$var$LocationMarker.propTypes = {
    position: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        lat: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        lng: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
    }),
    geocodeAvailable: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    onDragStart: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    onDragEnd: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired
};
var $7271bffc0eba1873$export$2e2bcd8739ae039 = $7271bffc0eba1873$var$LocationMarker;



const $567607fb3af07abf$var$ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
const $567607fb3af07abf$var$REVERSE_GEOCODE_API = `https://${(0, $63b5c9d178f1431e$export$669561b7c46fd3f7)}/v1/reverse`;
const $567607fb3af07abf$var$REVERSE_GEOCODE_ENDPOINT = `${$567607fb3af07abf$var$REVERSE_GEOCODE_API}?api_key=${(0, $63b5c9d178f1431e$export$620b2e0c341943a2)}`;
const $567607fb3af07abf$var$MAP_TILES = "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png";
const $567607fb3af07abf$var$MAP_TILES_2X = "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@2x.png";
const $567607fb3af07abf$var$MAP_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution" target="_blank" rel="noopener noreferrer">CARTO</a>';
// This is the same attribution prefix as Leaflet v1.9.3, except that we set
// link target and rel properties. Have to keep this up to date, or possibly
// propose features to Leaflet.
const $567607fb3af07abf$var$MAP_ATTRIBUTION_PREFIX = `<a href="https://leafletjs.com" title="A JavaScript library for interactive maps" target="_blank" rel="noopener noreferrer">${$567607fb3af07abf$var$ukrainianFlag} Leaflet</a>`;
// zoom level for a closer, 'street' zoom level
const $567607fb3af07abf$var$MAP_LOCATION_ZOOM = 12;
// Default location if geo IP not detected; this hovers over the Atlantic Ocean
const $567607fb3af07abf$var$DEFAULT_MAP_ZOOM = 2;
const $567607fb3af07abf$var$DEFAULT_MAP_LOCATION = {
    lat: 10.45,
    lng: -10.78
};
// Override icon paths in stock Leaflet's stylesheet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: "/images/marker-icon-2x.png",
    iconUrl: "/images/marker-icon.png",
    shadowUrl: "/images/marker-shadow.png"
});
function $567607fb3af07abf$var$getInitialState(props) {
    // Determine initial map center, and what to display
    let mapCenter, zoom, markerLocation, label;
    // If street has a location object, use its position and data
    if (props.street.location) {
        mapCenter = props.street.location.latlng;
        zoom = $567607fb3af07abf$var$MAP_LOCATION_ZOOM;
        markerLocation = props.street.location.latlng;
        label = props.street.location.label;
    /* If we've previously saved marker position, re-use that information
     This can be better described. This is an intermediary state that can happen when:

      1) A user is viewing a street without a geotagged location.
      They open the dialog box and search for a street location.
      A search result is selected and a marker is dropped on the map.

      2) Without confirming the location, the user exits the dialog box.
      Because a location is not confirmed, the street does not attach to the location.

      3) The user re-opens the dialog box.
      The previous state (with an unconfirmed location and map marker) is recovered.
      */ } else if (props.markerLocation) {
        mapCenter = props.markerLocation;
        zoom = $567607fb3af07abf$var$MAP_LOCATION_ZOOM;
        markerLocation = props.markerLocation;
        label = props.addressInformation.label;
    // If there's no prior location data, use the user's location, if available
    // In this case, display the map view, but no marker or popup
    } else if (props.userLocation && props.userLocation.longitude) {
        mapCenter = {
            lat: props.userLocation.latitude,
            lng: props.userLocation.longitude
        };
        zoom = $567607fb3af07abf$var$MAP_LOCATION_ZOOM;
    // As a last resort, show an overview of the world.
    } else {
        mapCenter = $567607fb3af07abf$var$DEFAULT_MAP_LOCATION;
        zoom = $567607fb3af07abf$var$DEFAULT_MAP_ZOOM;
    }
    return {
        mapCenter: mapCenter,
        zoom: zoom,
        markerLocation: markerLocation,
        label: label
    };
}
/*
This Dialog uses the generic Dialog component and combines it with the GeoSearch
and LocationPopup components as well as a map to display the coordinates on
It handles:
setting, displaying, and clearing location information associated with a 'street'
user permission checks for whether location can be updated for a street based on the user
reverse geocodeing based on user input (the user can click on the map to reverse geocode at the
  clicked point, or it can drag the marker to a new location to confirm)

It is tested primary via cypress at the moment
 */ function $567607fb3af07abf$var$GeotagDialog() {
    // this kinda goofy props object is a result of refactoring
    // some legacy code. definetly worth refactoring further in the future
    // if it causes other problems or confusion
    const props = {
        street: (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street),
        markerLocation: (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.map.markerLocation),
        addressInformation: (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.map.addressInformation),
        userLocation: (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.geolocation.data),
        offline: (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.system.offline)
    };
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const initialState = $567607fb3af07abf$var$getInitialState(props);
    const [mapCenter, setMapCenter] = (0, $4DE7A.useState)(initialState.mapCenter);
    const [zoom, setZoom] = (0, $4DE7A.useState)(initialState.zoom);
    const [markerLocation, setMarkerLocation] = (0, $4DE7A.useState)(initialState.markerLocation);
    const [label, setLabel] = (0, $4DE7A.useState)(initialState.label);
    const [renderPopup, setRenderPopup] = (0, $4DE7A.useState)(!!initialState.markerLocation);
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const geocodeAvailable = !!(0, $63b5c9d178f1431e$export$620b2e0c341943a2) && !!(0, $63b5c9d178f1431e$export$669561b7c46fd3f7) && !props.offline;
    // `dpi` is a bad name for what is supposed to be referring to the devicePixelRatio
    // value. A devicePixelRatio higher than 1 (e.g. Retina or 4k monitors) will load
    // higher resolution map tiles.
    const dpi = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.system.devicePixelRatio || 1.0);
    const tileUrl = dpi > 1 ? $567607fb3af07abf$var$MAP_TILES_2X : $567607fb3af07abf$var$MAP_TILES;
    // Child component to handle click events in MapContainer
    function MapClick(props) {
        const map = (0, $8fe4cafbb9a984d1$export$1c51e2c234152172)({
            click (event) {
                if (!geocodeAvailable) return;
                const latlng = event.latlng;
                const zoom = map.getZoom();
                reverseGeocode(latlng).then((res)=>{
                    const latlng = {
                        lat: res.features[0].geometry.coordinates[1],
                        lng: res.features[0].geometry.coordinates[0]
                    };
                    setZoom(zoom);
                    updateMap(latlng, res.features[0].properties, res.features[0].label);
                });
            }
        });
        return null;
    }
    const handleMarkerDragStart = (event)=>{
        setRenderPopup(false);
    };
    const handleMarkerDragEnd = (event)=>{
        const latlng = event.target.getLatLng();
        reverseGeocode(latlng).then((res)=>{
            updateMap(latlng, res.features[0].properties);
        });
    };
    const handleConfirmLocation = (event)=>{
        const { markerLocation: markerLocation, addressInformation: addressInformation } = props;
        const location = {
            latlng: markerLocation,
            wofId: addressInformation.id,
            label: addressInformation.label,
            hierarchy: {
                country: addressInformation.country,
                region: addressInformation.region,
                locality: addressInformation.locality,
                neighbourhood: addressInformation.neighbourhood,
                street: addressInformation.street
            },
            geometryId: null,
            intersectionId: null
        };
        (0, $gv34t.unstable_batchedUpdates)(()=>{
            dispatch((0, $8b007b7ac0907036$export$f664da56b7f6aade)(location));
            dispatch((0, $8b007b7ac0907036$export$eb36756120db063a)(location.hierarchy.street, false));
        });
    };
    const handleClearLocation = (event)=>{
        dispatch((0, $8b007b7ac0907036$export$951047f7fbed997e)());
    };
    const reverseGeocode = (latlng)=>{
        const url = `${$567607fb3af07abf$var$REVERSE_GEOCODE_ENDPOINT}&point.lat=${latlng.lat}&point.lon=${latlng.lng}`;
        return window.fetch(url).then((response)=>response.json());
    };
    // Search dialog state dosen't sync up with map state (IMO should clear or update with label)
    const handleSearchResults = (point, locationProperties)=>{
        const latlng = {
            lat: point[0],
            lng: point[1]
        };
        updateMap(latlng, locationProperties);
    };
    function updateMap(latlng, locationProperties) {
        /*
    after the location position is updated,
    we need to update the map UI elements
    an update place information in the store
    */ setRenderPopup(true);
        setMarkerLocation(latlng);
        setLabel(locationProperties.label);
        setMapCenter(latlng);
        dispatch((0, $5b2c2d9c813ed442$export$190ceb974fb80f01)({
            markerLocation: latlng,
            addressInformation: locationProperties
        }));
    }
    /**
   * Determines if the street location can be saved or edited.
   */ const canEditLocation = ()=>{
        const { street: street } = props;
        // The street is editable if either of the following conditions are true:
        //  - If there is a street owner, and it's equal to the current user
        //  - If there is no street owner
        //  - If there is no street location saved.
        return (0, $846d9bfc81d2582a$export$adbfba29f0dd9074)() || !street.creatorId || !street.location;
    };
    /**
   * Location can be cleared from a street that has a saved location, and
   * if that location is equal to the current marker position.
   * This does not check for street ownership. See `canEditLocation()` for that.
   */ const canClearLocation = ()=>{
        const { location: location } = props.street;
        return location && location.latlng.lat === markerLocation.lat && location.latlng.lng === markerLocation.lng;
    };
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $33ed200ba87fcf5c$export$2e2bcd8739ae039), {
        children: (closeDialog)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "geotag-dialog",
                children: [
                    geocodeAvailable ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "geotag-input-container",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $3e23de606960f620$export$2e2bcd8739ae039), {
                            handleSearchResults: handleSearchResults,
                            focus: mapCenter
                        })
                    }) : /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e640fbda60949eac$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $423fe21ae6edb563$export$23f3dfd47374502b), {
                        center: mapCenter,
                        zoomControl: false,
                        attributionControl: false,
                        zoom: zoom,
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $7233333e91d1be1b$export$f52ee31d61d0b27b), {
                                attribution: $567607fb3af07abf$var$MAP_ATTRIBUTION,
                                url: tileUrl
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $b047875379dd78b6$export$dd36b6cb96de1ba3), {
                                zoomInTitle: intl.formatMessage({
                                    id: "dialogs.geotag.zoom-in",
                                    defaultMessage: "Zoom in"
                                }),
                                zoomOutTitle: intl.formatMessage({
                                    id: "dialogs.geotag.zoom-out",
                                    defaultMessage: "Zoom out"
                                })
                            }),
                            renderPopup && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $f0316399362fac61$export$2e2bcd8739ae039), {
                                position: markerLocation,
                                label: label,
                                isEditable: geocodeAvailable && canEditLocation(),
                                isClearable: geocodeAvailable && canClearLocation(),
                                handleConfirm: (e)=>{
                                    handleConfirmLocation(e);
                                    closeDialog();
                                },
                                handleClear: (e)=>{
                                    handleClearLocation(e);
                                    closeDialog();
                                }
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $7271bffc0eba1873$export$2e2bcd8739ae039), {
                                position: markerLocation,
                                geocodeAvailable: geocodeAvailable,
                                onDragStart: handleMarkerDragStart,
                                onDragEnd: handleMarkerDragEnd
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)(MapClick, {}),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $8242fca73e03cb77$export$5af5c3cc9905683), {
                                prefix: $567607fb3af07abf$var$MAP_ATTRIBUTION_PREFIX
                            })
                        ]
                    })
                ]
            })
    });
}
$567607fb3af07abf$var$GeotagDialog.propTypes = {
    // Provided by Redux store
    street: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object,
    markerLocation: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        lat: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        lng: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
    }),
    addressInformation: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object,
    userLocation: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        latitude: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        longitude: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
    }),
    offline: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool
};
var $567607fb3af07abf$export$2e2bcd8739ae039 = $567607fb3af07abf$var$GeotagDialog;


/**
 * Save as Image (dialog box)
 *
 * Handles interaction on the "Save as image" dialog box.
 *
 */ 

var $4DE7A = parcelRequire("4DE7A");


var $8712dbc7585918b9$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($8712dbc7585918b9$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $8712dbc7585918b9$exports = g;
});












parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");




var $4DE7A = parcelRequire("4DE7A");


var $dBd5b = parcelRequire("dBd5b");

var $4DE7A = parcelRequire("4DE7A");
function $67aa2c30cf03439c$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}




var $4DE7A = parcelRequire("4DE7A");
function $23b8c385a06d9331$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $4DE7A.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $4DE7A.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $4DE7A.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $4DE7A.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $23b8c385a06d9331$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $4DE7A.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $4DE7A.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $4DE7A.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $4DE7A.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $4DE7A.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $4DE7A.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $23b8c385a06d9331$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $23b8c385a06d9331$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $4DE7A.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}



var $dBd5b = parcelRequire("dBd5b");

var $4DE7A = parcelRequire("4DE7A");




var $4DE7A = parcelRequire("4DE7A");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $8944a0c09755b6a8$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $4DE7A.useRef)(callback);
    (0, $4DE7A.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $4DE7A.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}



var $4DE7A = parcelRequire("4DE7A");

/**
 * Listens for when the escape key is down
 */ function $27425b30bb5a3b9f$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $8944a0c09755b6a8$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $4DE7A.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $3d95d7edc075365a$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $3d95d7edc075365a$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $3d95d7edc075365a$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $3d95d7edc075365a$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $3d95d7edc075365a$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $3d95d7edc075365a$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $4DE7A.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $3d95d7edc075365a$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $4DE7A.useContext)($3d95d7edc075365a$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $4DE7A.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $4DE7A.useState)({});
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $3d95d7edc075365a$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $3d95d7edc075365a$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $27425b30bb5a3b9f$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $4DE7A.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $3d95d7edc075365a$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $3d95d7edc075365a$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $3d95d7edc075365a$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $4DE7A.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $3d95d7edc075365a$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $4DE7A.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($3d95d7edc075365a$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($3d95d7edc075365a$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).div, (0, $dBd5b.default)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($3d95d7edc075365a$export$177fb62ff3ec1f22, {
    displayName: $3d95d7edc075365a$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $3d95d7edc075365a$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $3d95d7edc075365a$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const context = (0, $4DE7A.useContext)($3d95d7edc075365a$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $4DE7A.useRef)(null);
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $4DE7A.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).div, (0, $dBd5b.default)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($3d95d7edc075365a$export$4d5eb2109db14228, {
    displayName: $3d95d7edc075365a$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $3d95d7edc075365a$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $8944a0c09755b6a8$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $4DE7A.useRef)(false);
    const handleClickRef = (0, $4DE7A.useRef)(()=>{});
    (0, $4DE7A.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $3d95d7edc075365a$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($3d95d7edc075365a$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $3d95d7edc075365a$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $8944a0c09755b6a8$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $4DE7A.useRef)(false);
    (0, $4DE7A.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $3d95d7edc075365a$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($3d95d7edc075365a$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $3d95d7edc075365a$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($3d95d7edc075365a$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $3d95d7edc075365a$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $5350cbeeb3d0f7d5$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $3d95d7edc075365a$export$be92b6f5f03c0fe9 = $3d95d7edc075365a$export$177fb62ff3ec1f22;
const $3d95d7edc075365a$export$aecb2ddcb55c95be = $3d95d7edc075365a$export$4d5eb2109db14228;



var $4DE7A = parcelRequire("4DE7A");
/** Number of components which have requested interest to have focus guards */ let $bc3ad09dc36390a4$var$$3db38b7d1fb3fe6a$var$count = 0;
function $bc3ad09dc36390a4$export$ac5b58043b79449b(props) {
    $bc3ad09dc36390a4$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $bc3ad09dc36390a4$export$b7ece24a22aeda8c() {
    (0, $4DE7A.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $bc3ad09dc36390a4$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $bc3ad09dc36390a4$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $bc3ad09dc36390a4$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($bc3ad09dc36390a4$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $bc3ad09dc36390a4$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $bc3ad09dc36390a4$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $bc3ad09dc36390a4$export$be92b6f5f03c0fe9 = $bc3ad09dc36390a4$export$ac5b58043b79449b;



var $dBd5b = parcelRequire("dBd5b");

var $4DE7A = parcelRequire("4DE7A");



const $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $d859dac27aeeb2f6$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container1, setContainer] = (0, $4DE7A.useState)(null);
    const onMountAutoFocus = (0, $8944a0c09755b6a8$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $8944a0c09755b6a8$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $4DE7A.useRef)(null);
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $4DE7A.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $4DE7A.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$focus(container1);
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $4DE7A.useEffect)(()=>{
        if (container1) {
            $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$focusFirst($d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$removeLinks($d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $4DE7A.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).div, (0, $dBd5b.default)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($d859dac27aeeb2f6$export$20e40289641fbbb6, {
    displayName: $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$focus(element, { select: select = false } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$focusScopesStack = $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $d859dac27aeeb2f6$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $d859dac27aeeb2f6$export$be92b6f5f03c0fe9 = $d859dac27aeeb2f6$export$20e40289641fbbb6;



var $4DE7A = parcelRequire("4DE7A");

var $4DE7A = parcelRequire("4DE7A");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $84c4e9f0e68dd20d$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $4DE7A.useLayoutEffect) : ()=>{};


const $cc2dc425846fc689$var$$1746a345f3d73bb7$var$useReactId = $4DE7A["useId".toString()] || (()=>undefined);
let $cc2dc425846fc689$var$$1746a345f3d73bb7$var$count = 0;
function $cc2dc425846fc689$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $4DE7A.useState($cc2dc425846fc689$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $84c4e9f0e68dd20d$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($cc2dc425846fc689$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



var $dBd5b = parcelRequire("dBd5b");

var $4DE7A = parcelRequire("4DE7A");
const $9dc74473cb797fcb$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $9dc74473cb797fcb$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $9dc74473cb797fcb$export$803cd8101b6c182b = /*#__PURE__*/ $9dc74473cb797fcb$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $9dc74473cb797fcb$export$27b07d8a310ed8b5[0], side + "-" + $9dc74473cb797fcb$export$27b07d8a310ed8b5[1]), []);
const $9dc74473cb797fcb$export$96ec731ed4dcb222 = Math.min;
const $9dc74473cb797fcb$export$8960430cfd85939f = Math.max;
const $9dc74473cb797fcb$export$2077e0241d6afd3c = Math.round;
const $9dc74473cb797fcb$export$a3fe094919f356fd = Math.floor;
const $9dc74473cb797fcb$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $9dc74473cb797fcb$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $9dc74473cb797fcb$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $9dc74473cb797fcb$export$7d15b64cf5a3a4c4(start, value, end) {
    return $9dc74473cb797fcb$export$8960430cfd85939f(start, $9dc74473cb797fcb$export$96ec731ed4dcb222(value, end));
}
function $9dc74473cb797fcb$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $9dc74473cb797fcb$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $9dc74473cb797fcb$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $9dc74473cb797fcb$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $9dc74473cb797fcb$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $9dc74473cb797fcb$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($9dc74473cb797fcb$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $9dc74473cb797fcb$export$2b57e0052a6d6d4c(placement) {
    return $9dc74473cb797fcb$export$8a000a963141ac32($9dc74473cb797fcb$export$f28e8f882010718a(placement));
}
function $9dc74473cb797fcb$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $9dc74473cb797fcb$export$f0989780f32bfcda(placement);
    const alignmentAxis = $9dc74473cb797fcb$export$2b57e0052a6d6d4c(placement);
    const length = $9dc74473cb797fcb$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $9dc74473cb797fcb$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $9dc74473cb797fcb$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $9dc74473cb797fcb$export$496432a3699e50b1(placement) {
    const oppositePlacement = $9dc74473cb797fcb$export$9c5e28bad23365fa(placement);
    return [
        $9dc74473cb797fcb$export$2b182c584985588b(placement),
        oppositePlacement,
        $9dc74473cb797fcb$export$2b182c584985588b(oppositePlacement)
    ];
}
function $9dc74473cb797fcb$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$9dc74473cb797fcb$var$oppositeAlignmentMap[alignment]);
}
function $9dc74473cb797fcb$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $9dc74473cb797fcb$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $9dc74473cb797fcb$export$f0989780f32bfcda(placement);
    let list = $9dc74473cb797fcb$var$getSideList($9dc74473cb797fcb$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($9dc74473cb797fcb$export$2b182c584985588b));
    }
    return list;
}
function $9dc74473cb797fcb$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$9dc74473cb797fcb$var$oppositeSideMap[side]);
}
function $9dc74473cb797fcb$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $9dc74473cb797fcb$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $9dc74473cb797fcb$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $9dc74473cb797fcb$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $a4af5f4c17aa3b7e$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $9dc74473cb797fcb$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $9dc74473cb797fcb$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $9dc74473cb797fcb$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $9dc74473cb797fcb$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $9dc74473cb797fcb$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $a4af5f4c17aa3b7e$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $a4af5f4c17aa3b7e$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $a4af5f4c17aa3b7e$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $a4af5f4c17aa3b7e$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $9dc74473cb797fcb$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $9dc74473cb797fcb$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $9dc74473cb797fcb$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $9dc74473cb797fcb$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $a4af5f4c17aa3b7e$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $9dc74473cb797fcb$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $9dc74473cb797fcb$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $9dc74473cb797fcb$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $9dc74473cb797fcb$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $9dc74473cb797fcb$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $9dc74473cb797fcb$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $9dc74473cb797fcb$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $9dc74473cb797fcb$export$f0989780f32bfcda)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $a4af5f4c17aa3b7e$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $9dc74473cb797fcb$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $9dc74473cb797fcb$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $9dc74473cb797fcb$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $9dc74473cb797fcb$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $9dc74473cb797fcb$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $a4af5f4c17aa3b7e$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $9dc74473cb797fcb$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $9dc74473cb797fcb$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $9dc74473cb797fcb$export$803cd8101b6c182b) ? $a4af5f4c17aa3b7e$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $a4af5f4c17aa3b7e$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $9dc74473cb797fcb$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $9dc74473cb797fcb$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $9dc74473cb797fcb$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $9dc74473cb797fcb$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $a4af5f4c17aa3b7e$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $9dc74473cb797fcb$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $9dc74473cb797fcb$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $9dc74473cb797fcb$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $9dc74473cb797fcb$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $9dc74473cb797fcb$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $9dc74473cb797fcb$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $a4af5f4c17aa3b7e$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $9dc74473cb797fcb$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $a4af5f4c17aa3b7e$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $a4af5f4c17aa3b7e$var$isAnySideFullyClipped(overflow) {
    return (0, $9dc74473cb797fcb$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $a4af5f4c17aa3b7e$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $9dc74473cb797fcb$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $a4af5f4c17aa3b7e$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $a4af5f4c17aa3b7e$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $a4af5f4c17aa3b7e$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $a4af5f4c17aa3b7e$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $a4af5f4c17aa3b7e$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $a4af5f4c17aa3b7e$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $a4af5f4c17aa3b7e$var$getBoundingRect(rects) {
    const minX = (0, $9dc74473cb797fcb$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $9dc74473cb797fcb$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $9dc74473cb797fcb$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $9dc74473cb797fcb$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $a4af5f4c17aa3b7e$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $9dc74473cb797fcb$export$ee05aea0aeecbad4)($a4af5f4c17aa3b7e$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $a4af5f4c17aa3b7e$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $9dc74473cb797fcb$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $a4af5f4c17aa3b7e$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $9dc74473cb797fcb$export$ee05aea0aeecbad4)($a4af5f4c17aa3b7e$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $9dc74473cb797fcb$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $9dc74473cb797fcb$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $9dc74473cb797fcb$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $9dc74473cb797fcb$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $9dc74473cb797fcb$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $9dc74473cb797fcb$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $a4af5f4c17aa3b7e$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $9dc74473cb797fcb$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $9dc74473cb797fcb$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $9dc74473cb797fcb$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $9dc74473cb797fcb$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $a4af5f4c17aa3b7e$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $a4af5f4c17aa3b7e$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $a4af5f4c17aa3b7e$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $9dc74473cb797fcb$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $a4af5f4c17aa3b7e$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $9dc74473cb797fcb$export$f28e8f882010718a)((0, $9dc74473cb797fcb$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $9dc74473cb797fcb$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $9dc74473cb797fcb$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $9dc74473cb797fcb$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $a4af5f4c17aa3b7e$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $9dc74473cb797fcb$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $9dc74473cb797fcb$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $9dc74473cb797fcb$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $9dc74473cb797fcb$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $9dc74473cb797fcb$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $a4af5f4c17aa3b7e$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $9dc74473cb797fcb$export$fef61f332f2c0afc)(options, state);
            const overflow = await $a4af5f4c17aa3b7e$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $9dc74473cb797fcb$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $9dc74473cb797fcb$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $9dc74473cb797fcb$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $9dc74473cb797fcb$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $9dc74473cb797fcb$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $9dc74473cb797fcb$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $9dc74473cb797fcb$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $9dc74473cb797fcb$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $9dc74473cb797fcb$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $9dc74473cb797fcb$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $9dc74473cb797fcb$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $684ace2525bbb361$export$651544f548703224(node) {
    if ($684ace2525bbb361$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $684ace2525bbb361$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $684ace2525bbb361$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($684ace2525bbb361$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $684ace2525bbb361$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $684ace2525bbb361$export$38b2d434cce3ea22(value).Node;
}
function $684ace2525bbb361$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $684ace2525bbb361$export$38b2d434cce3ea22(value).Element;
}
function $684ace2525bbb361$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $684ace2525bbb361$export$38b2d434cce3ea22(value).HTMLElement;
}
function $684ace2525bbb361$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $684ace2525bbb361$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $684ace2525bbb361$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $684ace2525bbb361$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $684ace2525bbb361$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($684ace2525bbb361$export$651544f548703224(element));
}
function $684ace2525bbb361$export$d6c4e8150c35fed1(element) {
    const webkit = $684ace2525bbb361$export$78551043582a6a98();
    const css = $684ace2525bbb361$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $684ace2525bbb361$export$940d8225183e1404(element) {
    let currentNode = $684ace2525bbb361$export$4e12058fc4d51d56(element);
    while($684ace2525bbb361$export$1b3bfaa9684536aa(currentNode) && !$684ace2525bbb361$export$d1162fb0b6d4cd51(currentNode)){
        if ($684ace2525bbb361$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $684ace2525bbb361$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $684ace2525bbb361$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $684ace2525bbb361$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($684ace2525bbb361$export$651544f548703224(node));
}
function $684ace2525bbb361$export$3735103072e4a80(element) {
    return $684ace2525bbb361$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $684ace2525bbb361$export$dc8fc79fa2800137(element) {
    if ($684ace2525bbb361$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $684ace2525bbb361$export$4e12058fc4d51d56(node) {
    if ($684ace2525bbb361$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $684ace2525bbb361$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $684ace2525bbb361$export$e495491855dc5418(node);
    return $684ace2525bbb361$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $684ace2525bbb361$export$7cd01a57c8ca906c(node) {
    const parentNode = $684ace2525bbb361$export$4e12058fc4d51d56(node);
    if ($684ace2525bbb361$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($684ace2525bbb361$export$1b3bfaa9684536aa(parentNode) && $684ace2525bbb361$export$989e911fa9af580a(parentNode)) return parentNode;
    return $684ace2525bbb361$export$7cd01a57c8ca906c(parentNode);
}
function $684ace2525bbb361$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $684ace2525bbb361$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $684ace2525bbb361$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $684ace2525bbb361$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $684ace2525bbb361$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $684ace2525bbb361$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $2103fce8ba4d18e1$var$getCssDimensions(element) {
    const css = (0, $684ace2525bbb361$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $684ace2525bbb361$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $9dc74473cb797fcb$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $9dc74473cb797fcb$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $2103fce8ba4d18e1$var$unwrapElement(element) {
    return !(0, $684ace2525bbb361$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $2103fce8ba4d18e1$var$getScale(element) {
    const domElement = $2103fce8ba4d18e1$var$unwrapElement(element);
    if (!(0, $684ace2525bbb361$export$1b3bfaa9684536aa)(domElement)) return (0, $9dc74473cb797fcb$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $2103fce8ba4d18e1$var$getCssDimensions(domElement);
    let x = ($ ? (0, $9dc74473cb797fcb$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $9dc74473cb797fcb$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $2103fce8ba4d18e1$var$noOffsets = /*#__PURE__*/ (0, $9dc74473cb797fcb$export$a397704b5e280835)(0);
function $2103fce8ba4d18e1$var$getVisualOffsets(element) {
    const win = (0, $684ace2525bbb361$export$38b2d434cce3ea22)(element);
    if (!(0, $684ace2525bbb361$export$78551043582a6a98)() || !win.visualViewport) return $2103fce8ba4d18e1$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $2103fce8ba4d18e1$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $684ace2525bbb361$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $2103fce8ba4d18e1$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $2103fce8ba4d18e1$var$unwrapElement(element);
    let scale = (0, $9dc74473cb797fcb$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $684ace2525bbb361$export$45a5e7f76e0caa8d)(offsetParent)) scale = $2103fce8ba4d18e1$var$getScale(offsetParent);
        } else scale = $2103fce8ba4d18e1$var$getScale(element);
    }
    const visualOffsets = $2103fce8ba4d18e1$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $2103fce8ba4d18e1$var$getVisualOffsets(domElement) : (0, $9dc74473cb797fcb$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $684ace2525bbb361$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $684ace2525bbb361$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $684ace2525bbb361$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $2103fce8ba4d18e1$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $684ace2525bbb361$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $684ace2525bbb361$export$38b2d434cce3ea22)(currentIFrame).frameElement;
        }
    }
    return (0, $9dc74473cb797fcb$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $2103fce8ba4d18e1$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $684ace2525bbb361$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $684ace2525bbb361$export$e495491855dc5418)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $9dc74473cb797fcb$export$a397704b5e280835)(1);
    const offsets = (0, $9dc74473cb797fcb$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $684ace2525bbb361$export$651544f548703224)(offsetParent) !== "body" || (0, $684ace2525bbb361$export$989e911fa9af580a)(documentElement)) scroll = (0, $684ace2525bbb361$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $684ace2525bbb361$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $2103fce8ba4d18e1$var$getBoundingClientRect(offsetParent);
            scale = $2103fce8ba4d18e1$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $2103fce8ba4d18e1$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $2103fce8ba4d18e1$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $2103fce8ba4d18e1$var$getBoundingClientRect((0, $684ace2525bbb361$export$e495491855dc5418)(element)).left + (0, $684ace2525bbb361$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $2103fce8ba4d18e1$var$getDocumentRect(element) {
    const html = (0, $684ace2525bbb361$export$e495491855dc5418)(element);
    const scroll = (0, $684ace2525bbb361$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $9dc74473cb797fcb$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $9dc74473cb797fcb$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $2103fce8ba4d18e1$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $684ace2525bbb361$export$3735103072e4a80)(body).direction === "rtl") x += (0, $9dc74473cb797fcb$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $2103fce8ba4d18e1$var$getViewportRect(element, strategy) {
    const win = (0, $684ace2525bbb361$export$38b2d434cce3ea22)(element);
    const html = (0, $684ace2525bbb361$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $684ace2525bbb361$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $2103fce8ba4d18e1$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $2103fce8ba4d18e1$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $684ace2525bbb361$export$1b3bfaa9684536aa)(element) ? $2103fce8ba4d18e1$var$getScale(element) : (0, $9dc74473cb797fcb$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $2103fce8ba4d18e1$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $2103fce8ba4d18e1$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $2103fce8ba4d18e1$var$getDocumentRect((0, $684ace2525bbb361$export$e495491855dc5418)(element));
    else if ((0, $684ace2525bbb361$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $2103fce8ba4d18e1$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $2103fce8ba4d18e1$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $9dc74473cb797fcb$export$ee05aea0aeecbad4)(rect);
}
function $2103fce8ba4d18e1$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $684ace2525bbb361$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $684ace2525bbb361$export$45a5e7f76e0caa8d)(parentNode) || (0, $684ace2525bbb361$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $684ace2525bbb361$export$3735103072e4a80)(parentNode).position === "fixed" || $2103fce8ba4d18e1$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $2103fce8ba4d18e1$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $684ace2525bbb361$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $684ace2525bbb361$export$45a5e7f76e0caa8d)(el) && (0, $684ace2525bbb361$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $684ace2525bbb361$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $684ace2525bbb361$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $684ace2525bbb361$export$45a5e7f76e0caa8d)(currentNode) && !(0, $684ace2525bbb361$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $684ace2525bbb361$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $684ace2525bbb361$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $684ace2525bbb361$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $2103fce8ba4d18e1$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $684ace2525bbb361$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $2103fce8ba4d18e1$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $2103fce8ba4d18e1$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $2103fce8ba4d18e1$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $9dc74473cb797fcb$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $9dc74473cb797fcb$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $9dc74473cb797fcb$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $9dc74473cb797fcb$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $2103fce8ba4d18e1$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $2103fce8ba4d18e1$var$getDimensions(element) {
    return $2103fce8ba4d18e1$var$getCssDimensions(element);
}
function $2103fce8ba4d18e1$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $684ace2525bbb361$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $684ace2525bbb361$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $2103fce8ba4d18e1$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $9dc74473cb797fcb$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $684ace2525bbb361$export$651544f548703224)(offsetParent) !== "body" || (0, $684ace2525bbb361$export$989e911fa9af580a)(documentElement)) scroll = (0, $684ace2525bbb361$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $2103fce8ba4d18e1$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $2103fce8ba4d18e1$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $2103fce8ba4d18e1$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $684ace2525bbb361$export$1b3bfaa9684536aa)(element) || (0, $684ace2525bbb361$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $2103fce8ba4d18e1$var$getOffsetParent(element, polyfill) {
    const window = (0, $684ace2525bbb361$export$38b2d434cce3ea22)(element);
    if (!(0, $684ace2525bbb361$export$1b3bfaa9684536aa)(element)) return window;
    let offsetParent = $2103fce8ba4d18e1$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $684ace2525bbb361$export$71535ffaa902797f)(offsetParent) && (0, $684ace2525bbb361$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $2103fce8ba4d18e1$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $684ace2525bbb361$export$651544f548703224)(offsetParent) === "html" || (0, $684ace2525bbb361$export$651544f548703224)(offsetParent) === "body" && (0, $684ace2525bbb361$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $684ace2525bbb361$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $684ace2525bbb361$export$940d8225183e1404)(element) || window;
}
const $2103fce8ba4d18e1$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $2103fce8ba4d18e1$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $2103fce8ba4d18e1$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $2103fce8ba4d18e1$var$isRTL(element) {
    return (0, $684ace2525bbb361$export$3735103072e4a80)(element).direction === "rtl";
}
const $2103fce8ba4d18e1$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $2103fce8ba4d18e1$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $684ace2525bbb361$export$e495491855dc5418,
    getClippingRect: $2103fce8ba4d18e1$var$getClippingRect,
    getOffsetParent: $2103fce8ba4d18e1$var$getOffsetParent,
    getElementRects: $2103fce8ba4d18e1$var$getElementRects,
    getClientRects: $2103fce8ba4d18e1$var$getClientRects,
    getDimensions: $2103fce8ba4d18e1$var$getDimensions,
    getScale: $2103fce8ba4d18e1$var$getScale,
    isElement: $684ace2525bbb361$export$45a5e7f76e0caa8d,
    isRTL: $2103fce8ba4d18e1$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $2103fce8ba4d18e1$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $684ace2525bbb361$export$e495491855dc5418)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $9dc74473cb797fcb$export$a3fe094919f356fd)(top);
        const insetRight = (0, $9dc74473cb797fcb$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $9dc74473cb797fcb$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $9dc74473cb797fcb$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $9dc74473cb797fcb$export$8960430cfd85939f)(0, (0, $9dc74473cb797fcb$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $2103fce8ba4d18e1$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $2103fce8ba4d18e1$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $684ace2525bbb361$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $684ace2525bbb361$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $2103fce8ba4d18e1$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $2103fce8ba4d18e1$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $2103fce8ba4d18e1$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $2103fce8ba4d18e1$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $2103fce8ba4d18e1$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $a4af5f4c17aa3b7e$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $4DE7A = parcelRequire("4DE7A");

var $gv34t = parcelRequire("gv34t");
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $4a269991c134b58a$export$f2120bbfa5450bd2 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $a4af5f4c17aa3b7e$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            } else if (element) return (0, $a4af5f4c17aa3b7e$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $4a269991c134b58a$var$index = typeof document !== "undefined" ? (0, $4DE7A.useLayoutEffect) : (0, $4DE7A.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $4a269991c134b58a$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length, i, keys;
    if (a && b && typeof a == "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$4a269991c134b58a$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$4a269991c134b58a$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $4a269991c134b58a$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $4a269991c134b58a$var$roundByDPR(element, value) {
    const dpr = $4a269991c134b58a$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $4a269991c134b58a$var$useLatestRef(value) {
    const ref = $4DE7A.useRef(value);
    $4a269991c134b58a$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $4a269991c134b58a$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $4DE7A.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $4DE7A.useState(middleware);
    if (!$4a269991c134b58a$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $4DE7A.useState(null);
    const [_floating, _setFloating] = $4DE7A.useState(null);
    const setReference = $4DE7A.useCallback((node)=>{
        if (node != referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, [
        _setReference
    ]);
    const setFloating = $4DE7A.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, [
        _setFloating
    ]);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $4DE7A.useRef(null);
    const floatingRef = $4DE7A.useRef(null);
    const dataRef = $4DE7A.useRef(data);
    const whileElementsMountedRef = $4a269991c134b58a$var$useLatestRef(whileElementsMounted);
    const platformRef = $4a269991c134b58a$var$useLatestRef(platform);
    const update = $4DE7A.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $2103fce8ba4d18e1$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$4a269991c134b58a$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $gv34t.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $4a269991c134b58a$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $4DE7A.useRef(false);
    $4a269991c134b58a$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $4a269991c134b58a$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            else update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef
    ]);
    const refs = $4DE7A.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $4DE7A.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $4DE7A.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $4a269991c134b58a$var$roundByDPR(elements.floating, data.x);
        const y = $4a269991c134b58a$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$4a269991c134b58a$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $4DE7A.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}



var $dBd5b = parcelRequire("dBd5b");

var $4DE7A = parcelRequire("4DE7A");

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $28ca040dd31ae53b$var$$7e8f5cd07187803e$var$NAME = "Arrow";
const $28ca040dd31ae53b$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).svg, (0, $dBd5b.default)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $4DE7A.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($28ca040dd31ae53b$export$21b07c8f274aebd5, {
    displayName: $28ca040dd31ae53b$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $28ca040dd31ae53b$export$be92b6f5f03c0fe9 = $28ca040dd31ae53b$export$21b07c8f274aebd5;








var $4DE7A = parcelRequire("4DE7A");

function $9c4a442f1f3cde52$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $4DE7A.useState)(undefined);
    (0, $84c4e9f0e68dd20d$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"]; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}


const $26c142bb4de6d27e$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
const $26c142bb4de6d27e$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$createPopperContext, $26c142bb4de6d27e$export$722aac194ae923] = (0, $23b8c385a06d9331$export$50c7b4e9d9f19c1)($26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$PopperProvider, $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$createPopperContext($26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $26c142bb4de6d27e$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = (0, $4DE7A.useState)(null);
    return /*#__PURE__*/ (0, $4DE7A.createElement)($26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($26c142bb4de6d27e$export$badac9ada3a0bdf9, {
    displayName: $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $26c142bb4de6d27e$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$usePopperContext($26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $4DE7A.useRef)(null);
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $4DE7A.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).div, (0, $dBd5b.default)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($26c142bb4de6d27e$export$ecd4e1ccab6ed6d, {
    displayName: $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$useContentContext] = $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$createPopperContext($26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $26c142bb4de6d27e$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$usePopperContext($26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $4DE7A.useState)(null);
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $4DE7A.useState)(null);
    const arrowSize = (0, $9c4a442f1f3cde52$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $4a269991c134b58a$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $2103fce8ba4d18e1$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $a4af5f4c17aa3b7e$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $a4af5f4c17aa3b7e$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $a4af5f4c17aa3b7e$export$7bf07e38f3dc4b69)() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $a4af5f4c17aa3b7e$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $a4af5f4c17aa3b7e$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $4a269991c134b58a$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $a4af5f4c17aa3b7e$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $8944a0c09755b6a8$export$25bec8c6f54ee79a)(onPlaced);
    (0, $84c4e9f0e68dd20d$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $4DE7A.useState)();
    (0, $84c4e9f0e68dd20d$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $4DE7A.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(" ")
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $4DE7A.createElement)($26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).div, (0, $dBd5b.default)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? "none" : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/*#__PURE__*/ Object.assign($26c142bb4de6d27e$export$bc4ae5855d3c4fc, {
    displayName: $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
const $26c142bb4de6d27e$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $4DE7A.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$useContentContext($26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $4DE7A.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : undefined
        }
    }, /*#__PURE__*/ (0, $4DE7A.createElement)((0, $28ca040dd31ae53b$export$be92b6f5f03c0fe9), (0, $dBd5b.default)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
        }
    }))));
});
/*#__PURE__*/ Object.assign($26c142bb4de6d27e$export$79d62cd4e10a3fd0, {
    displayName: $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $26c142bb4de6d27e$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
const $26c142bb4de6d27e$export$be92b6f5f03c0fe9 = $26c142bb4de6d27e$export$badac9ada3a0bdf9;
const $26c142bb4de6d27e$export$b688253958b8dfe7 = $26c142bb4de6d27e$export$ecd4e1ccab6ed6d;
const $26c142bb4de6d27e$export$7c6e2c02157bb7d2 = $26c142bb4de6d27e$export$bc4ae5855d3c4fc;
const $26c142bb4de6d27e$export$21b07c8f274aebd5 = $26c142bb4de6d27e$export$79d62cd4e10a3fd0;



var $dBd5b = parcelRequire("dBd5b");

var $4DE7A = parcelRequire("4DE7A");

var $gv34t = parcelRequire("gv34t");

/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $bb954d95b9468bf8$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $bb954d95b9468bf8$export$602eac185826482c = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gv34t))).createPortal(/*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).div, (0, $dBd5b.default)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($bb954d95b9468bf8$export$602eac185826482c, {
    displayName: $bb954d95b9468bf8$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $bb954d95b9468bf8$export$be92b6f5f03c0fe9 = $bb954d95b9468bf8$export$602eac185826482c;



var $4DE7A = parcelRequire("4DE7A");

var $gv34t = parcelRequire("gv34t");


function $6329cd9c86a9a60c$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $4DE7A.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $6329cd9c86a9a60c$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $6329cd9c86a9a60c$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $4DE7A.Children).only(children);
    const ref = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $4DE7A.cloneElement)(child, {
        ref: ref
    }) : null;
};
$6329cd9c86a9a60c$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $6329cd9c86a9a60c$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $4DE7A.useState)();
    const stylesRef = (0, $4DE7A.useRef)({});
    const prevPresentRef = (0, $4DE7A.useRef)(present);
    const prevAnimationNameRef = (0, $4DE7A.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $6329cd9c86a9a60c$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $4DE7A.useEffect)(()=>{
        const currentAnimationName = $6329cd9c86a9a60c$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $84c4e9f0e68dd20d$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $6329cd9c86a9a60c$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $84c4e9f0e68dd20d$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $6329cd9c86a9a60c$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $gv34t.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $6329cd9c86a9a60c$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $4DE7A.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $6329cd9c86a9a60c$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}





var $4DE7A = parcelRequire("4DE7A");

function $e92f93e2f069d351$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $e92f93e2f069d351$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $8944a0c09755b6a8$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $4DE7A.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $e92f93e2f069d351$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $4DE7A.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $4DE7A.useRef)(value);
    const handleChange = (0, $8944a0c09755b6a8$export$25bec8c6f54ee79a)(onChange);
    (0, $4DE7A.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}


var $55f1678c6f50cb19$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $55f1678c6f50cb19$var$counterMap = new WeakMap();
var $55f1678c6f50cb19$var$uncontrolledNodes = new WeakMap();
var $55f1678c6f50cb19$var$markerMap = {};
var $55f1678c6f50cb19$var$lockCount = 0;
var $55f1678c6f50cb19$var$unwrapHost = function(node) {
    return node && (node.host || $55f1678c6f50cb19$var$unwrapHost(node.parentNode));
};
var $55f1678c6f50cb19$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $55f1678c6f50cb19$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $55f1678c6f50cb19$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $55f1678c6f50cb19$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$55f1678c6f50cb19$var$markerMap[markerName]) $55f1678c6f50cb19$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $55f1678c6f50cb19$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($55f1678c6f50cb19$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $55f1678c6f50cb19$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $55f1678c6f50cb19$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $55f1678c6f50cb19$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $55f1678c6f50cb19$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $55f1678c6f50cb19$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$55f1678c6f50cb19$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $55f1678c6f50cb19$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $55f1678c6f50cb19$var$lockCount--;
        if (!$55f1678c6f50cb19$var$lockCount) {
            // clear
            $55f1678c6f50cb19$var$counterMap = new WeakMap();
            $55f1678c6f50cb19$var$counterMap = new WeakMap();
            $55f1678c6f50cb19$var$uncontrolledNodes = new WeakMap();
            $55f1678c6f50cb19$var$markerMap = {};
        }
    };
};
var $55f1678c6f50cb19$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $55f1678c6f50cb19$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $55f1678c6f50cb19$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $55f1678c6f50cb19$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $55f1678c6f50cb19$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $55f1678c6f50cb19$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $55f1678c6f50cb19$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $55f1678c6f50cb19$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($55f1678c6f50cb19$export$cc95fea82d705fca() ? $55f1678c6f50cb19$export$59151cc8db999a24 : $55f1678c6f50cb19$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



var $eIwgG = parcelRequire("eIwgG");

var $4DE7A = parcelRequire("4DE7A");

var $eIwgG = parcelRequire("eIwgG");

var $4DE7A = parcelRequire("4DE7A");
var $816dbc7c3fa233c7$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $816dbc7c3fa233c7$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $816dbc7c3fa233c7$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $816dbc7c3fa233c7$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";


/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $52ddae664cb194c1$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $4DE7A = parcelRequire("4DE7A");
function $7957542ec1abbe96$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $4DE7A.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


function $ad95dd56eb6887d5$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $7957542ec1abbe96$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $52ddae664cb194c1$export$d734136a7b018efe)(ref, newValue);
        });
    });
}



var $eIwgG = parcelRequire("eIwgG");
function $2d4b1301e47ecad0$var$ItoI(a) {
    return a;
}
function $2d4b1301e47ecad0$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $2d4b1301e47ecad0$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $2d4b1301e47ecad0$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $2d4b1301e47ecad0$var$ItoI;
    return $2d4b1301e47ecad0$var$innerCreateMedium(defaults, middleware);
}
function $2d4b1301e47ecad0$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $2d4b1301e47ecad0$var$innerCreateMedium(null);
    medium.options = (0, $eIwgG.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $5012891f77b47382$export$e27363444bedfeac = (0, $2d4b1301e47ecad0$export$e13ec7dd7a14088d)();


var $206b7ac96a17962a$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $206b7ac96a17962a$export$22940b497e769dee = $4DE7A.forwardRef(function(props, parentRef) {
    var ref = $4DE7A.useRef(null);
    var _a = $4DE7A.useState({
        onScrollCapture: $206b7ac96a17962a$var$nothing,
        onWheelCapture: $206b7ac96a17962a$var$nothing,
        onTouchMoveCapture: $206b7ac96a17962a$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $eIwgG.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $ad95dd56eb6887d5$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, rest), callbacks);
    return $4DE7A.createElement($4DE7A.Fragment, null, enabled && $4DE7A.createElement(SideCar, {
        sideCar: (0, $5012891f77b47382$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $4DE7A.cloneElement($4DE7A.Children.only(children), (0, $eIwgG.__assign)((0, $eIwgG.__assign)({}, containerProps), {
        ref: containerRef
    })) : $4DE7A.createElement(Container, (0, $eIwgG.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$206b7ac96a17962a$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$206b7ac96a17962a$export$22940b497e769dee.classNames = {
    fullWidth: (0, $816dbc7c3fa233c7$export$898e37bbd2a0ae4e),
    zeroRight: (0, $816dbc7c3fa233c7$export$1da7500147d4bc3)
};



var $eIwgG = parcelRequire("eIwgG");

var $4DE7A = parcelRequire("4DE7A");
var $154472013809b274$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $eIwgG.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $4DE7A.createElement(Target, (0, $eIwgG.__assign)({}, rest));
};
$154472013809b274$var$SideCar.isSideCarExport = true;
function $154472013809b274$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $154472013809b274$var$SideCar;
}



var $eIwgG = parcelRequire("eIwgG");

var $4DE7A = parcelRequire("4DE7A");

var $4DE7A = parcelRequire("4DE7A");

var $4DE7A = parcelRequire("4DE7A");
var $1973020da3075048$var$currentNonce;
var $1973020da3075048$export$c5f670b24c0ae95a = function(nonce) {
    $1973020da3075048$var$currentNonce = nonce;
};
var $1973020da3075048$export$2b85b721e524d74b = function() {
    if ($1973020da3075048$var$currentNonce) return $1973020da3075048$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $24819a976cc7a5c6$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $1973020da3075048$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $24819a976cc7a5c6$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $24819a976cc7a5c6$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $24819a976cc7a5c6$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $24819a976cc7a5c6$var$makeStyleTag()) {
                    $24819a976cc7a5c6$var$injectStyles(stylesheet, style);
                    $24819a976cc7a5c6$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $bfd64d7eb7196bb8$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $24819a976cc7a5c6$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $4DE7A.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $6d554c84d3ff6ff5$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $bfd64d7eb7196bb8$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $38108bcfa71775c9$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $38108bcfa71775c9$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $38108bcfa71775c9$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $38108bcfa71775c9$var$parse(left),
        $38108bcfa71775c9$var$parse(top),
        $38108bcfa71775c9$var$parse(right)
    ];
};
var $38108bcfa71775c9$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $38108bcfa71775c9$export$efed13b5d0ca3386;
    var offsets = $38108bcfa71775c9$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $f6ec1b67aa6cfb46$var$Style = (0, $6d554c84d3ff6ff5$export$c1248ee86ba532c8)();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $f6ec1b67aa6cfb46$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $816dbc7c3fa233c7$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $816dbc7c3fa233c7$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $816dbc7c3fa233c7$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $816dbc7c3fa233c7$export$1da7500147d4bc3), " .").concat((0, $816dbc7c3fa233c7$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $816dbc7c3fa233c7$export$898e37bbd2a0ae4e), " .").concat((0, $816dbc7c3fa233c7$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat((0, $816dbc7c3fa233c7$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $f6ec1b67aa6cfb46$export$9aa43b459c5ae9b9 = function(props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? "margin" : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $4DE7A.useMemo(function() {
        return (0, $38108bcfa71775c9$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $4DE7A.createElement($f6ec1b67aa6cfb46$var$Style, {
        styles: $f6ec1b67aa6cfb46$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $257b4ed3a7909f18$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $257b4ed3a7909f18$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $257b4ed3a7909f18$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $257b4ed3a7909f18$var$options, $257b4ed3a7909f18$var$options);
    // @ts-ignore
    window.removeEventListener("test", $257b4ed3a7909f18$var$options, $257b4ed3a7909f18$var$options);
} catch (err) {
    $257b4ed3a7909f18$var$passiveSupported = false;
}
var $257b4ed3a7909f18$export$10a6e88623fa9454 = $257b4ed3a7909f18$var$passiveSupported ? {
    passive: false
} : false;


var $398390c00013a3bf$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $398390c00013a3bf$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$398390c00013a3bf$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $398390c00013a3bf$var$elementCouldBeVScrolled = function(node) {
    return $398390c00013a3bf$var$elementCanBeScrolled(node, "overflowY");
};
var $398390c00013a3bf$var$elementCouldBeHScrolled = function(node) {
    return $398390c00013a3bf$var$elementCanBeScrolled(node, "overflowX");
};
var $398390c00013a3bf$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $398390c00013a3bf$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $398390c00013a3bf$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $398390c00013a3bf$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $398390c00013a3bf$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $398390c00013a3bf$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $398390c00013a3bf$var$elementCouldBeVScrolled(node) : $398390c00013a3bf$var$elementCouldBeHScrolled(node);
};
var $398390c00013a3bf$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $398390c00013a3bf$var$getVScrollVariables(node) : $398390c00013a3bf$var$getHScrollVariables(node);
};
var $398390c00013a3bf$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $398390c00013a3bf$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $398390c00013a3bf$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $398390c00013a3bf$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($398390c00013a3bf$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $beaefb3a97d713a2$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $beaefb3a97d713a2$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $beaefb3a97d713a2$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $beaefb3a97d713a2$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $beaefb3a97d713a2$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $beaefb3a97d713a2$var$idCounter = 0;
var $beaefb3a97d713a2$var$lockStack = [];
function $beaefb3a97d713a2$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $4DE7A.useRef([]);
    var touchStartRef = $4DE7A.useRef([
        0,
        0
    ]);
    var activeAxis = $4DE7A.useRef();
    var id = $4DE7A.useState($beaefb3a97d713a2$var$idCounter++)[0];
    var Style = $4DE7A.useState(function() {
        return (0, $6d554c84d3ff6ff5$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $4DE7A.useRef(props);
    $4DE7A.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $4DE7A.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $eIwgG.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($beaefb3a97d713a2$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $4DE7A.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $beaefb3a97d713a2$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $398390c00013a3bf$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $398390c00013a3bf$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $398390c00013a3bf$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $4DE7A.useCallback(function(_event) {
        var event = _event;
        if (!$beaefb3a97d713a2$var$lockStack.length || $beaefb3a97d713a2$var$lockStack[$beaefb3a97d713a2$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $beaefb3a97d713a2$export$39efaa2ca254a28d(event) : $beaefb3a97d713a2$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $beaefb3a97d713a2$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($beaefb3a97d713a2$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $4DE7A.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $4DE7A.useCallback(function(event) {
        touchStartRef.current = $beaefb3a97d713a2$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $4DE7A.useCallback(function(event) {
        shouldCancel(event.type, $beaefb3a97d713a2$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $4DE7A.useCallback(function(event) {
        shouldCancel(event.type, $beaefb3a97d713a2$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $4DE7A.useEffect(function() {
        $beaefb3a97d713a2$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $257b4ed3a7909f18$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $257b4ed3a7909f18$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $257b4ed3a7909f18$export$10a6e88623fa9454));
        return function() {
            $beaefb3a97d713a2$var$lockStack = $beaefb3a97d713a2$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $257b4ed3a7909f18$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $257b4ed3a7909f18$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $257b4ed3a7909f18$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $4DE7A.createElement($4DE7A.Fragment, null, inert ? $4DE7A.createElement(Style, {
        styles: $beaefb3a97d713a2$var$generateStyle(id)
    }) : null, removeScrollBar ? $4DE7A.createElement((0, $f6ec1b67aa6cfb46$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $009df333767b5192$export$2e2bcd8739ae039 = (0, $154472013809b274$export$6cacc8fb0a9b94ce)((0, $5012891f77b47382$export$e27363444bedfeac), (0, $beaefb3a97d713a2$export$a09dbff87b5da2d));


var $bcba6237aeac7ec4$var$ReactRemoveScroll = $4DE7A.forwardRef(function(props, ref) {
    return $4DE7A.createElement((0, $206b7ac96a17962a$export$22940b497e769dee), (0, $eIwgG.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $009df333767b5192$export$2e2bcd8739ae039)
    }));
});
$bcba6237aeac7ec4$var$ReactRemoveScroll.classNames = (0, $206b7ac96a17962a$export$22940b497e769dee).classNames;
var $bcba6237aeac7ec4$export$2e2bcd8739ae039 = $bcba6237aeac7ec4$var$ReactRemoveScroll;


/* -------------------------------------------------------------------------------------------------
 * Popover
 * -----------------------------------------------------------------------------------------------*/ const $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$POPOVER_NAME = "Popover";
const [$743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$createPopoverContext, $743359cfd7bd9338$export$c8393c9e73286932] = (0, $23b8c385a06d9331$export$50c7b4e9d9f19c1)($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$POPOVER_NAME, [
    (0, $26c142bb4de6d27e$export$722aac194ae923)
]);
const $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopperScope = (0, $26c142bb4de6d27e$export$722aac194ae923)();
const [$743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PopoverProvider, $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopoverContext] = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$createPopoverContext($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$POPOVER_NAME);
const $743359cfd7bd9338$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = false } = props;
    const popperScope = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const triggerRef = (0, $4DE7A.useRef)(null);
    const [hasCustomAnchor, setHasCustomAnchor] = (0, $4DE7A.useState)(false);
    const [open = false, setOpen] = (0, $e92f93e2f069d351$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $26c142bb4de6d27e$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $4DE7A.createElement)($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PopoverProvider, {
        scope: __scopePopover,
        contentId: (0, $cc2dc425846fc689$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $4DE7A.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        hasCustomAnchor: hasCustomAnchor,
        onCustomAnchorAdd: (0, $4DE7A.useCallback)(()=>setHasCustomAnchor(true), []),
        onCustomAnchorRemove: (0, $4DE7A.useCallback)(()=>setHasCustomAnchor(false), []),
        modal: modal
    }, children));
};
/*#__PURE__*/ Object.assign($743359cfd7bd9338$export$5b6b19405a83ff9d, {
    displayName: $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$POPOVER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverAnchor
 * -----------------------------------------------------------------------------------------------*/ const $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME = "PopoverAnchor";
const $743359cfd7bd9338$export$96e5381f42521a79 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...anchorProps } = props;
    const context = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopoverContext($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd, onCustomAnchorRemove: onCustomAnchorRemove } = context;
    (0, $4DE7A.useEffect)(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $26c142bb4de6d27e$export$b688253958b8dfe7), (0, $dBd5b.default)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($743359cfd7bd9338$export$96e5381f42521a79, {
    displayName: $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverTrigger
 * -----------------------------------------------------------------------------------------------*/ const $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME = "PopoverTrigger";
const $743359cfd7bd9338$export$7dacb05d26466c3 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...triggerProps } = props;
    const context = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopoverContext($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).button, (0, $dBd5b.default)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
    return context.hasCustomAnchor ? trigger : /*#__PURE__*/ (0, $4DE7A.createElement)((0, $26c142bb4de6d27e$export$b688253958b8dfe7), (0, $dBd5b.default)({
        asChild: true
    }, popperScope), trigger);
});
/*#__PURE__*/ Object.assign($743359cfd7bd9338$export$7dacb05d26466c3, {
    displayName: $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverPortal
 * -----------------------------------------------------------------------------------------------*/ const $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PORTAL_NAME = "PopoverPortal";
const [$743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PortalProvider, $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePortalContext] = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$createPopoverContext($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, {
    forceMount: undefined
});
const $743359cfd7bd9338$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover, forceMount: forceMount, children: children, container: container } = props;
    const context = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopoverContext($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $4DE7A.createElement)($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $4DE7A.createElement)((0, $6329cd9c86a9a60c$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $4DE7A.createElement)((0, $bb954d95b9468bf8$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($743359cfd7bd9338$export$dd679ffb4362d2d4, {
    displayName: $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverContent
 * -----------------------------------------------------------------------------------------------*/ const $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$CONTENT_NAME = "PopoverContent";
const $743359cfd7bd9338$export$d7e1f420b25549ff = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const portalContext = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePortalContext($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopoverContext($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $6329cd9c86a9a60c$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $4DE7A.createElement)($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PopoverContentModal, (0, $dBd5b.default)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $4DE7A.createElement)($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal, (0, $dBd5b.default)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($743359cfd7bd9338$export$d7e1f420b25549ff, {
    displayName: $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PopoverContentModal = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const context = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopoverContext($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = (0, $4DE7A.useRef)(null);
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = (0, $4DE7A.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $4DE7A.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $55f1678c6f50cb19$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $bcba6237aeac7ec4$export$2e2bcd8739ae039), {
        as: (0, $ba30e5867cc80958$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    }, /*#__PURE__*/ (0, $4DE7A.createElement)($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $dBd5b.default)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            if (!isRightClickOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            isRightClickOutsideRef.current = isRightClick;
        }, {
            checkForDefaultPrevented: false
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        })
    })));
});
const $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const context = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopoverContext($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = (0, $4DE7A.useRef)(false);
    const hasPointerDownOutsideRef = (0, $4DE7A.useRef)(false);
    return /*#__PURE__*/ (0, $4DE7A.createElement)($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $dBd5b.default)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$PopoverContentImpl = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopoverContext($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, __scopePopover);
    const popperScope = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover); // Make sure the whole tree has focus guards as our `Popover` may be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $bc3ad09dc36390a4$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $d859dac27aeeb2f6$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $4DE7A.createElement)((0, $3d95d7edc075365a$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onInteractOutside: onInteractOutside,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0, $4DE7A.createElement)((0, $26c142bb4de6d27e$export$7c6e2c02157bb7d2), (0, $dBd5b.default)({
        "data-state": $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$getState(context.open),
        role: "dialog",
        id: context.contentId
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
            "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
            "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * PopoverClose
 * -----------------------------------------------------------------------------------------------*/ const $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$CLOSE_NAME = "PopoverClose";
const $743359cfd7bd9338$export$d6ac43ebaa40d53e = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...closeProps } = props;
    const context = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopoverContext($743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$CLOSE_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).button, (0, $dBd5b.default)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($743359cfd7bd9338$export$d6ac43ebaa40d53e, {
    displayName: $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$CLOSE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverArrow
 * -----------------------------------------------------------------------------------------------*/ const $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$ARROW_NAME = "PopoverArrow";
const $743359cfd7bd9338$export$3152841115e061b2 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...arrowProps } = props;
    const popperScope = $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $26c142bb4de6d27e$export$21b07c8f274aebd5), (0, $dBd5b.default)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($743359cfd7bd9338$export$3152841115e061b2, {
    displayName: $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $743359cfd7bd9338$var$$cb5cc270b50c6fcd$var$getState(open) {
    return open ? "open" : "closed";
}
const $743359cfd7bd9338$export$be92b6f5f03c0fe9 = $743359cfd7bd9338$export$5b6b19405a83ff9d;
const $743359cfd7bd9338$export$b688253958b8dfe7 = $743359cfd7bd9338$export$96e5381f42521a79;
const $743359cfd7bd9338$export$41fb9f06171c75f4 = $743359cfd7bd9338$export$7dacb05d26466c3;
const $743359cfd7bd9338$export$602eac185826482c = $743359cfd7bd9338$export$dd679ffb4362d2d4;
const $743359cfd7bd9338$export$7c6e2c02157bb7d2 = $743359cfd7bd9338$export$d7e1f420b25549ff;
const $743359cfd7bd9338$export$f39c2d165cd861fe = $743359cfd7bd9338$export$d6ac43ebaa40d53e;
const $743359cfd7bd9338$export$21b07c8f274aebd5 = $743359cfd7bd9338$export$3152841115e061b2;





const $5e40c6e7d2ea15a8$var$PopoverContent = /*#__PURE__*/ (0, $4DE7A.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)($743359cfd7bd9338$export$7c6e2c02157bb7d2, {
        ...props,
        ref: ref,
        children: [
            children,
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($743359cfd7bd9338$export$21b07c8f274aebd5, {
                className: "popover-arrow"
            })
        ]
    }));
$5e40c6e7d2ea15a8$var$PopoverContent.displayName = "PopoverContent";
function $5e40c6e7d2ea15a8$var$Popover({ label: label, children: children }) {
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const a11yLabel = label || intl.formatMessage({
        id: "settings.info-tooltip",
        defaultMessage: "Description"
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)($743359cfd7bd9338$export$be92b6f5f03c0fe9, {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($743359cfd7bd9338$export$41fb9f06171c75f4, {
                asChild: true,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
                    className: "popover-trigger",
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $01fa17a3769f170b$export$2e2bcd8739ae039), {
                        label: a11yLabel,
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$7a1b52edf33ca2d9), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($5e40c6e7d2ea15a8$var$PopoverContent, {
                side: "top",
                collisionPadding: 10,
                arrowPadding: 6,
                className: "popover-content",
                children: children
            })
        ]
    });
}
var $5e40c6e7d2ea15a8$export$2e2bcd8739ae039 = $5e40c6e7d2ea15a8$var$Popover;




var $4DE7A = parcelRequire("4DE7A");

var $dBd5b = parcelRequire("dBd5b");

var $4DE7A = parcelRequire("4DE7A");
function $f51af6d812e19f61$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}








var $4DE7A = parcelRequire("4DE7A");
function $762650820aff843b$export$5cae361ad82dce8b(value) {
    const ref = (0, $4DE7A.useRef)({
        value: value,
        previous: value
    }); // We compare values before making an update to ensure that
    // a change has been made. This ensures the previous value is
    // persisted correctly between renders.
    return (0, $4DE7A.useMemo)(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}





var $4DE7A = parcelRequire("4DE7A");



// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $6a369b93e8d909a0$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $23b8c385a06d9331$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, $ba30e5867cc80958$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef(null);
        const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, $ba30e5867cc80958$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}


const $c88e74c34a89b481$var$$faa2e61a3361514f$var$PAGE_KEYS = [
    "PageUp",
    "PageDown"
];
const $c88e74c34a89b481$var$$faa2e61a3361514f$var$ARROW_KEYS = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
];
const $c88e74c34a89b481$var$$faa2e61a3361514f$var$BACK_KEYS = {
    "from-left": [
        "Home",
        "PageDown",
        "ArrowDown",
        "ArrowLeft"
    ],
    "from-right": [
        "Home",
        "PageDown",
        "ArrowDown",
        "ArrowRight"
    ],
    "from-bottom": [
        "Home",
        "PageDown",
        "ArrowDown",
        "ArrowLeft"
    ],
    "from-top": [
        "Home",
        "PageDown",
        "ArrowUp",
        "ArrowLeft"
    ]
};
/* -------------------------------------------------------------------------------------------------
 * Slider
 * -----------------------------------------------------------------------------------------------*/ const $c88e74c34a89b481$var$$faa2e61a3361514f$var$SLIDER_NAME = "Slider";
const [$c88e74c34a89b481$var$$faa2e61a3361514f$var$Collection, $c88e74c34a89b481$var$$faa2e61a3361514f$var$useCollection, $c88e74c34a89b481$var$$faa2e61a3361514f$var$createCollectionScope] = (0, $6a369b93e8d909a0$export$c74125a8e3af6bb2)($c88e74c34a89b481$var$$faa2e61a3361514f$var$SLIDER_NAME);
const [$c88e74c34a89b481$var$$faa2e61a3361514f$var$createSliderContext, $c88e74c34a89b481$export$ef72632d7b901f97] = (0, $23b8c385a06d9331$export$50c7b4e9d9f19c1)($c88e74c34a89b481$var$$faa2e61a3361514f$var$SLIDER_NAME, [
    $c88e74c34a89b481$var$$faa2e61a3361514f$var$createCollectionScope
]);
const [$c88e74c34a89b481$var$$faa2e61a3361514f$var$SliderProvider, $c88e74c34a89b481$var$$faa2e61a3361514f$var$useSliderContext] = $c88e74c34a89b481$var$$faa2e61a3361514f$var$createSliderContext($c88e74c34a89b481$var$$faa2e61a3361514f$var$SLIDER_NAME);
const $c88e74c34a89b481$export$472062a354075cee = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { name: name, min: min = 0, max: max = 100, step: step = 1, orientation: orientation = "horizontal", disabled: disabled = false, minStepsBetweenThumbs: minStepsBetweenThumbs = 0, defaultValue: defaultValue = [
        min
    ], value: value1, onValueChange: onValueChange = ()=>{}, onValueCommit: onValueCommit = ()=>{}, inverted: inverted = false, ...sliderProps } = props;
    const [slider, setSlider] = (0, $4DE7A.useState)(null);
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setSlider(node));
    const thumbRefs = (0, $4DE7A.useRef)(new Set());
    const valueIndexToChangeRef = (0, $4DE7A.useRef)(0);
    const isHorizontal = orientation === "horizontal"; // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = slider ? Boolean(slider.closest("form")) : true;
    const SliderOrientation = isHorizontal ? $c88e74c34a89b481$var$$faa2e61a3361514f$var$SliderHorizontal : $c88e74c34a89b481$var$$faa2e61a3361514f$var$SliderVertical;
    const [values = [], setValues] = (0, $e92f93e2f069d351$export$6f32135080cb4c3)({
        prop: value1,
        defaultProp: defaultValue,
        onChange: (value)=>{
            var _thumbs$valueIndexToC;
            const thumbs = [
                ...thumbRefs.current
            ];
            (_thumbs$valueIndexToC = thumbs[valueIndexToChangeRef.current]) === null || _thumbs$valueIndexToC === void 0 || _thumbs$valueIndexToC.focus();
            onValueChange(value);
        }
    });
    const valuesBeforeSlideStartRef = (0, $4DE7A.useRef)(values);
    function handleSlideStart(value) {
        const closestIndex = $c88e74c34a89b481$var$$faa2e61a3361514f$var$getClosestValueIndex(values, value);
        updateValues(value, closestIndex);
    }
    function handleSlideMove(value) {
        updateValues(value, valueIndexToChangeRef.current);
    }
    function handleSlideEnd() {
        const prevValue = valuesBeforeSlideStartRef.current[valueIndexToChangeRef.current];
        const nextValue = values[valueIndexToChangeRef.current];
        const hasChanged = nextValue !== prevValue;
        if (hasChanged) onValueCommit(values);
    }
    function updateValues(value, atIndex, { commit: commit } = {
        commit: false
    }) {
        const decimalCount = $c88e74c34a89b481$var$$faa2e61a3361514f$var$getDecimalCount(step);
        const snapToStep = $c88e74c34a89b481$var$$faa2e61a3361514f$var$roundValue(Math.round((value - min) / step) * step + min, decimalCount);
        const nextValue = (0, $f51af6d812e19f61$export$7d15b64cf5a3a4c4)(snapToStep, [
            min,
            max
        ]);
        setValues((prevValues = [])=>{
            const nextValues = $c88e74c34a89b481$var$$faa2e61a3361514f$var$getNextSortedValues(prevValues, nextValue, atIndex);
            if ($c88e74c34a89b481$var$$faa2e61a3361514f$var$hasMinStepsBetweenValues(nextValues, minStepsBetweenThumbs * step)) {
                valueIndexToChangeRef.current = nextValues.indexOf(nextValue);
                const hasChanged = String(nextValues) !== String(prevValues);
                if (hasChanged && commit) onValueCommit(nextValues);
                return hasChanged ? nextValues : prevValues;
            } else return prevValues;
        });
    }
    return /*#__PURE__*/ (0, $4DE7A.createElement)($c88e74c34a89b481$var$$faa2e61a3361514f$var$SliderProvider, {
        scope: props.__scopeSlider,
        disabled: disabled,
        min: min,
        max: max,
        valueIndexToChangeRef: valueIndexToChangeRef,
        thumbs: thumbRefs.current,
        values: values,
        orientation: orientation
    }, /*#__PURE__*/ (0, $4DE7A.createElement)($c88e74c34a89b481$var$$faa2e61a3361514f$var$Collection.Provider, {
        scope: props.__scopeSlider
    }, /*#__PURE__*/ (0, $4DE7A.createElement)($c88e74c34a89b481$var$$faa2e61a3361514f$var$Collection.Slot, {
        scope: props.__scopeSlider
    }, /*#__PURE__*/ (0, $4DE7A.createElement)(SliderOrientation, (0, $dBd5b.default)({
        "aria-disabled": disabled,
        "data-disabled": disabled ? "" : undefined
    }, sliderProps, {
        ref: composedRefs,
        onPointerDown: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(sliderProps.onPointerDown, ()=>{
            if (!disabled) valuesBeforeSlideStartRef.current = values;
        }),
        min: min,
        max: max,
        inverted: inverted,
        onSlideStart: disabled ? undefined : handleSlideStart,
        onSlideMove: disabled ? undefined : handleSlideMove,
        onSlideEnd: disabled ? undefined : handleSlideEnd,
        onHomeKeyDown: ()=>!disabled && updateValues(min, 0, {
                commit: true
            }),
        onEndKeyDown: ()=>!disabled && updateValues(max, values.length - 1, {
                commit: true
            }),
        onStepKeyDown: ({ event: event, direction: stepDirection })=>{
            if (!disabled) {
                const isPageKey = $c88e74c34a89b481$var$$faa2e61a3361514f$var$PAGE_KEYS.includes(event.key);
                const isSkipKey = isPageKey || event.shiftKey && $c88e74c34a89b481$var$$faa2e61a3361514f$var$ARROW_KEYS.includes(event.key);
                const multiplier = isSkipKey ? 10 : 1;
                const atIndex = valueIndexToChangeRef.current;
                const value = values[atIndex];
                const stepInDirection = step * multiplier * stepDirection;
                updateValues(value + stepInDirection, atIndex, {
                    commit: true
                });
            }
        }
    })))), isFormControl && values.map((value, index)=>/*#__PURE__*/ (0, $4DE7A.createElement)($c88e74c34a89b481$var$$faa2e61a3361514f$var$BubbleInput, {
            key: index,
            name: name ? name + (values.length > 1 ? "[]" : "") : undefined,
            value: value
        })));
});
/*#__PURE__*/ Object.assign($c88e74c34a89b481$export$472062a354075cee, {
    displayName: $c88e74c34a89b481$var$$faa2e61a3361514f$var$SLIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SliderHorizontal
 * -----------------------------------------------------------------------------------------------*/ const [$c88e74c34a89b481$var$$faa2e61a3361514f$var$SliderOrientationProvider, $c88e74c34a89b481$var$$faa2e61a3361514f$var$useSliderOrientationContext] = $c88e74c34a89b481$var$$faa2e61a3361514f$var$createSliderContext($c88e74c34a89b481$var$$faa2e61a3361514f$var$SLIDER_NAME, {
    startEdge: "left",
    endEdge: "right",
    size: "width",
    direction: 1
});
const $c88e74c34a89b481$var$$faa2e61a3361514f$var$SliderHorizontal = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { min: min, max: max, dir: dir, inverted: inverted, onSlideStart: onSlideStart, onSlideMove: onSlideMove, onSlideEnd: onSlideEnd, onStepKeyDown: onStepKeyDown, ...sliderProps } = props;
    const [slider, setSlider] = (0, $4DE7A.useState)(null);
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setSlider(node));
    const rectRef = (0, $4DE7A.useRef)();
    const direction = (0, $ca61ba5b50f7e65b$export$b39126d51d94e6f3)(dir);
    const isDirectionLTR = direction === "ltr";
    const isSlidingFromLeft = isDirectionLTR && !inverted || !isDirectionLTR && inverted;
    function getValueFromPointer(pointerPosition) {
        const rect = rectRef.current || slider.getBoundingClientRect();
        const input = [
            0,
            rect.width
        ];
        const output = isSlidingFromLeft ? [
            min,
            max
        ] : [
            max,
            min
        ];
        const value = $c88e74c34a89b481$var$$faa2e61a3361514f$var$linearScale(input, output);
        rectRef.current = rect;
        return value(pointerPosition - rect.left);
    }
    return /*#__PURE__*/ (0, $4DE7A.createElement)($c88e74c34a89b481$var$$faa2e61a3361514f$var$SliderOrientationProvider, {
        scope: props.__scopeSlider,
        startEdge: isSlidingFromLeft ? "left" : "right",
        endEdge: isSlidingFromLeft ? "right" : "left",
        direction: isSlidingFromLeft ? 1 : -1,
        size: "width"
    }, /*#__PURE__*/ (0, $4DE7A.createElement)($c88e74c34a89b481$var$$faa2e61a3361514f$var$SliderImpl, (0, $dBd5b.default)({
        dir: direction,
        "data-orientation": "horizontal"
    }, sliderProps, {
        ref: composedRefs,
        style: {
            ...sliderProps.style,
            ["--radix-slider-thumb-transform"]: "translateX(-50%)"
        },
        onSlideStart: (event)=>{
            const value = getValueFromPointer(event.clientX);
            onSlideStart === null || onSlideStart === void 0 || onSlideStart(value);
        },
        onSlideMove: (event)=>{
            const value = getValueFromPointer(event.clientX);
            onSlideMove === null || onSlideMove === void 0 || onSlideMove(value);
        },
        onSlideEnd: ()=>{
            rectRef.current = undefined;
            onSlideEnd === null || onSlideEnd === void 0 || onSlideEnd();
        },
        onStepKeyDown: (event)=>{
            const slideDirection = isSlidingFromLeft ? "from-left" : "from-right";
            const isBackKey = $c88e74c34a89b481$var$$faa2e61a3361514f$var$BACK_KEYS[slideDirection].includes(event.key);
            onStepKeyDown === null || onStepKeyDown === void 0 || onStepKeyDown({
                event: event,
                direction: isBackKey ? -1 : 1
            });
        }
    })));
});
/* -------------------------------------------------------------------------------------------------
 * SliderVertical
 * -----------------------------------------------------------------------------------------------*/ const $c88e74c34a89b481$var$$faa2e61a3361514f$var$SliderVertical = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { min: min, max: max, inverted: inverted, onSlideStart: onSlideStart, onSlideMove: onSlideMove, onSlideEnd: onSlideEnd, onStepKeyDown: onStepKeyDown, ...sliderProps } = props;
    const sliderRef = (0, $4DE7A.useRef)(null);
    const ref = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, sliderRef);
    const rectRef = (0, $4DE7A.useRef)();
    const isSlidingFromBottom = !inverted;
    function getValueFromPointer(pointerPosition) {
        const rect = rectRef.current || sliderRef.current.getBoundingClientRect();
        const input = [
            0,
            rect.height
        ];
        const output = isSlidingFromBottom ? [
            max,
            min
        ] : [
            min,
            max
        ];
        const value = $c88e74c34a89b481$var$$faa2e61a3361514f$var$linearScale(input, output);
        rectRef.current = rect;
        return value(pointerPosition - rect.top);
    }
    return /*#__PURE__*/ (0, $4DE7A.createElement)($c88e74c34a89b481$var$$faa2e61a3361514f$var$SliderOrientationProvider, {
        scope: props.__scopeSlider,
        startEdge: isSlidingFromBottom ? "bottom" : "top",
        endEdge: isSlidingFromBottom ? "top" : "bottom",
        size: "height",
        direction: isSlidingFromBottom ? 1 : -1
    }, /*#__PURE__*/ (0, $4DE7A.createElement)($c88e74c34a89b481$var$$faa2e61a3361514f$var$SliderImpl, (0, $dBd5b.default)({
        "data-orientation": "vertical"
    }, sliderProps, {
        ref: ref,
        style: {
            ...sliderProps.style,
            ["--radix-slider-thumb-transform"]: "translateY(50%)"
        },
        onSlideStart: (event)=>{
            const value = getValueFromPointer(event.clientY);
            onSlideStart === null || onSlideStart === void 0 || onSlideStart(value);
        },
        onSlideMove: (event)=>{
            const value = getValueFromPointer(event.clientY);
            onSlideMove === null || onSlideMove === void 0 || onSlideMove(value);
        },
        onSlideEnd: ()=>{
            rectRef.current = undefined;
            onSlideEnd === null || onSlideEnd === void 0 || onSlideEnd();
        },
        onStepKeyDown: (event)=>{
            const slideDirection = isSlidingFromBottom ? "from-bottom" : "from-top";
            const isBackKey = $c88e74c34a89b481$var$$faa2e61a3361514f$var$BACK_KEYS[slideDirection].includes(event.key);
            onStepKeyDown === null || onStepKeyDown === void 0 || onStepKeyDown({
                event: event,
                direction: isBackKey ? -1 : 1
            });
        }
    })));
});
/* -------------------------------------------------------------------------------------------------
 * SliderImpl
 * -----------------------------------------------------------------------------------------------*/ const $c88e74c34a89b481$var$$faa2e61a3361514f$var$SliderImpl = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, onSlideStart: onSlideStart, onSlideMove: onSlideMove, onSlideEnd: onSlideEnd, onHomeKeyDown: onHomeKeyDown, onEndKeyDown: onEndKeyDown, onStepKeyDown: onStepKeyDown, ...sliderProps } = props;
    const context = $c88e74c34a89b481$var$$faa2e61a3361514f$var$useSliderContext($c88e74c34a89b481$var$$faa2e61a3361514f$var$SLIDER_NAME, __scopeSlider);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).span, (0, $dBd5b.default)({}, sliderProps, {
        ref: forwardedRef,
        onKeyDown: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key === "Home") {
                onHomeKeyDown(event); // Prevent scrolling to page start
                event.preventDefault();
            } else if (event.key === "End") {
                onEndKeyDown(event); // Prevent scrolling to page end
                event.preventDefault();
            } else if ($c88e74c34a89b481$var$$faa2e61a3361514f$var$PAGE_KEYS.concat($c88e74c34a89b481$var$$faa2e61a3361514f$var$ARROW_KEYS).includes(event.key)) {
                onStepKeyDown(event); // Prevent scrolling for directional key presses
                event.preventDefault();
            }
        }),
        onPointerDown: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
            const target = event.target;
            target.setPointerCapture(event.pointerId); // Prevent browser focus behaviour because we focus a thumb manually when values change.
            event.preventDefault(); // Touch devices have a delay before focusing so won't focus if touch immediately moves
            // away from target (sliding). We want thumb to focus regardless.
            if (context.thumbs.has(target)) target.focus();
            else onSlideStart(event);
        }),
        onPointerMove: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
            const target = event.target;
            if (target.hasPointerCapture(event.pointerId)) onSlideMove(event);
        }),
        onPointerUp: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onPointerUp, (event)=>{
            const target = event.target;
            if (target.hasPointerCapture(event.pointerId)) {
                target.releasePointerCapture(event.pointerId);
                onSlideEnd(event);
            }
        })
    }));
});
/* -------------------------------------------------------------------------------------------------
 * SliderTrack
 * -----------------------------------------------------------------------------------------------*/ const $c88e74c34a89b481$var$$faa2e61a3361514f$var$TRACK_NAME = "SliderTrack";
const $c88e74c34a89b481$export$105594979f116971 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, ...trackProps } = props;
    const context = $c88e74c34a89b481$var$$faa2e61a3361514f$var$useSliderContext($c88e74c34a89b481$var$$faa2e61a3361514f$var$TRACK_NAME, __scopeSlider);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).span, (0, $dBd5b.default)({
        "data-disabled": context.disabled ? "" : undefined,
        "data-orientation": context.orientation
    }, trackProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($c88e74c34a89b481$export$105594979f116971, {
    displayName: $c88e74c34a89b481$var$$faa2e61a3361514f$var$TRACK_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SliderRange
 * -----------------------------------------------------------------------------------------------*/ const $c88e74c34a89b481$var$$faa2e61a3361514f$var$RANGE_NAME = "SliderRange";
const $c88e74c34a89b481$export$a5cf38a7a000fe77 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, ...rangeProps } = props;
    const context = $c88e74c34a89b481$var$$faa2e61a3361514f$var$useSliderContext($c88e74c34a89b481$var$$faa2e61a3361514f$var$RANGE_NAME, __scopeSlider);
    const orientation = $c88e74c34a89b481$var$$faa2e61a3361514f$var$useSliderOrientationContext($c88e74c34a89b481$var$$faa2e61a3361514f$var$RANGE_NAME, __scopeSlider);
    const ref = (0, $4DE7A.useRef)(null);
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const valuesCount = context.values.length;
    const percentages = context.values.map((value)=>$c88e74c34a89b481$var$$faa2e61a3361514f$var$convertValueToPercentage(value, context.min, context.max));
    const offsetStart = valuesCount > 1 ? Math.min(...percentages) : 0;
    const offsetEnd = 100 - Math.max(...percentages);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).span, (0, $dBd5b.default)({
        "data-orientation": context.orientation,
        "data-disabled": context.disabled ? "" : undefined
    }, rangeProps, {
        ref: composedRefs,
        style: {
            ...props.style,
            [orientation.startEdge]: offsetStart + "%",
            [orientation.endEdge]: offsetEnd + "%"
        }
    }));
});
/*#__PURE__*/ Object.assign($c88e74c34a89b481$export$a5cf38a7a000fe77, {
    displayName: $c88e74c34a89b481$var$$faa2e61a3361514f$var$RANGE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SliderThumb
 * -----------------------------------------------------------------------------------------------*/ const $c88e74c34a89b481$var$$faa2e61a3361514f$var$THUMB_NAME = "SliderThumb";
const $c88e74c34a89b481$export$2c1b491743890dec = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const getItems = $c88e74c34a89b481$var$$faa2e61a3361514f$var$useCollection(props.__scopeSlider);
    const [thumb, setThumb] = (0, $4DE7A.useState)(null);
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setThumb(node));
    const index = (0, $4DE7A.useMemo)(()=>thumb ? getItems().findIndex((item)=>item.ref.current === thumb) : -1, [
        getItems,
        thumb
    ]);
    return /*#__PURE__*/ (0, $4DE7A.createElement)($c88e74c34a89b481$var$$faa2e61a3361514f$var$SliderThumbImpl, (0, $dBd5b.default)({}, props, {
        ref: composedRefs,
        index: index
    }));
});
const $c88e74c34a89b481$var$$faa2e61a3361514f$var$SliderThumbImpl = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, index: index, ...thumbProps } = props;
    const context = $c88e74c34a89b481$var$$faa2e61a3361514f$var$useSliderContext($c88e74c34a89b481$var$$faa2e61a3361514f$var$THUMB_NAME, __scopeSlider);
    const orientation = $c88e74c34a89b481$var$$faa2e61a3361514f$var$useSliderOrientationContext($c88e74c34a89b481$var$$faa2e61a3361514f$var$THUMB_NAME, __scopeSlider);
    const [thumb, setThumb] = (0, $4DE7A.useState)(null);
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setThumb(node));
    const size = (0, $9c4a442f1f3cde52$export$1ab7ae714698c4b8)(thumb); // We cast because index could be `-1` which would return undefined
    const value = context.values[index];
    const percent = value === undefined ? 0 : $c88e74c34a89b481$var$$faa2e61a3361514f$var$convertValueToPercentage(value, context.min, context.max);
    const label = $c88e74c34a89b481$var$$faa2e61a3361514f$var$getLabel(index, context.values.length);
    const orientationSize = size === null || size === void 0 ? void 0 : size[orientation.size];
    const thumbInBoundsOffset = orientationSize ? $c88e74c34a89b481$var$$faa2e61a3361514f$var$getThumbInBoundsOffset(orientationSize, percent, orientation.direction) : 0;
    (0, $4DE7A.useEffect)(()=>{
        if (thumb) {
            context.thumbs.add(thumb);
            return ()=>{
                context.thumbs.delete(thumb);
            };
        }
    }, [
        thumb,
        context.thumbs
    ]);
    return /*#__PURE__*/ (0, $4DE7A.createElement)("span", {
        style: {
            transform: "var(--radix-slider-thumb-transform)",
            position: "absolute",
            [orientation.startEdge]: `calc(${percent}% + ${thumbInBoundsOffset}px)`
        }
    }, /*#__PURE__*/ (0, $4DE7A.createElement)($c88e74c34a89b481$var$$faa2e61a3361514f$var$Collection.ItemSlot, {
        scope: props.__scopeSlider
    }, /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).span, (0, $dBd5b.default)({
        role: "slider",
        "aria-label": props["aria-label"] || label,
        "aria-valuemin": context.min,
        "aria-valuenow": value,
        "aria-valuemax": context.max,
        "aria-orientation": context.orientation,
        "data-orientation": context.orientation,
        "data-disabled": context.disabled ? "" : undefined,
        tabIndex: context.disabled ? undefined : 0
    }, thumbProps, {
        ref: composedRefs,
        style: value === undefined ? {
            display: "none"
        } : props.style,
        onFocus: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onFocus, ()=>{
            context.valueIndexToChangeRef.current = index;
        })
    }))));
});
/*#__PURE__*/ Object.assign($c88e74c34a89b481$export$2c1b491743890dec, {
    displayName: $c88e74c34a89b481$var$$faa2e61a3361514f$var$THUMB_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $c88e74c34a89b481$var$$faa2e61a3361514f$var$BubbleInput = (props)=>{
    const { value: value, ...inputProps } = props;
    const ref = (0, $4DE7A.useRef)(null);
    const prevValue = (0, $762650820aff843b$export$5cae361ad82dce8b)(value); // Bubble value change to parents (e.g form change event)
    (0, $4DE7A.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("input", {
                bubbles: true
            });
            setValue.call(input, value);
            input.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    /**
   * We purposefully do not use `type="hidden"` here otherwise forms that
   * wrap it will not be able to access its value via the FormData API.
   *
   * We purposefully do not add the `value` attribute here to allow the value
   * to be set programatically and bubble to any parent form `onChange` event.
   * Adding the `value` will cause React to consider the programatic
   * dispatch a duplicate and it will get swallowed.
   */ return /*#__PURE__*/ (0, $4DE7A.createElement)("input", (0, $dBd5b.default)({
        style: {
            display: "none"
        }
    }, inputProps, {
        ref: ref,
        defaultValue: value
    }));
};
function $c88e74c34a89b481$var$$faa2e61a3361514f$var$getNextSortedValues(prevValues = [], nextValue, atIndex) {
    const nextValues = [
        ...prevValues
    ];
    nextValues[atIndex] = nextValue;
    return nextValues.sort((a, b)=>a - b);
}
function $c88e74c34a89b481$var$$faa2e61a3361514f$var$convertValueToPercentage(value, min, max) {
    const maxSteps = max - min;
    const percentPerStep = 100 / maxSteps;
    const percentage = percentPerStep * (value - min);
    return (0, $f51af6d812e19f61$export$7d15b64cf5a3a4c4)(percentage, [
        0,
        100
    ]);
}
/**
 * Returns a label for each thumb when there are two or more thumbs
 */ function $c88e74c34a89b481$var$$faa2e61a3361514f$var$getLabel(index, totalValues) {
    if (totalValues > 2) return `Value ${index + 1} of ${totalValues}`;
    else if (totalValues === 2) return [
        "Minimum",
        "Maximum"
    ][index];
    else return undefined;
}
/**
 * Given a `values` array and a `nextValue`, determine which value in
 * the array is closest to `nextValue` and return its index.
 *
 * @example
 * // returns 1
 * getClosestValueIndex([10, 30], 25);
 */ function $c88e74c34a89b481$var$$faa2e61a3361514f$var$getClosestValueIndex(values, nextValue) {
    if (values.length === 1) return 0;
    const distances = values.map((value)=>Math.abs(value - nextValue));
    const closestDistance = Math.min(...distances);
    return distances.indexOf(closestDistance);
}
/**
 * Offsets the thumb centre point while sliding to ensure it remains
 * within the bounds of the slider when reaching the edges
 */ function $c88e74c34a89b481$var$$faa2e61a3361514f$var$getThumbInBoundsOffset(width, left, direction) {
    const halfWidth = width / 2;
    const halfPercent = 50;
    const offset = $c88e74c34a89b481$var$$faa2e61a3361514f$var$linearScale([
        0,
        halfPercent
    ], [
        0,
        halfWidth
    ]);
    return (halfWidth - offset(left) * direction) * direction;
}
/**
 * Gets an array of steps between each value.
 *
 * @example
 * // returns [1, 9]
 * getStepsBetweenValues([10, 11, 20]);
 */ function $c88e74c34a89b481$var$$faa2e61a3361514f$var$getStepsBetweenValues(values) {
    return values.slice(0, -1).map((value, index)=>values[index + 1] - value);
}
/**
 * Verifies the minimum steps between all values is greater than or equal
 * to the expected minimum steps.
 *
 * @example
 * // returns false
 * hasMinStepsBetweenValues([1,2,3], 2);
 *
 * @example
 * // returns true
 * hasMinStepsBetweenValues([1,2,3], 1);
 */ function $c88e74c34a89b481$var$$faa2e61a3361514f$var$hasMinStepsBetweenValues(values, minStepsBetweenValues) {
    if (minStepsBetweenValues > 0) {
        const stepsBetweenValues = $c88e74c34a89b481$var$$faa2e61a3361514f$var$getStepsBetweenValues(values);
        const actualMinStepsBetweenValues = Math.min(...stepsBetweenValues);
        return actualMinStepsBetweenValues >= minStepsBetweenValues;
    }
    return true;
} // https://github.com/tmcw-up-for-adoption/simple-linear-scale/blob/master/index.js
function $c88e74c34a89b481$var$$faa2e61a3361514f$var$linearScale(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        const ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}
function $c88e74c34a89b481$var$$faa2e61a3361514f$var$getDecimalCount(value) {
    return (String(value).split(".")[1] || "").length;
}
function $c88e74c34a89b481$var$$faa2e61a3361514f$var$roundValue(value, decimalCount) {
    const rounder = Math.pow(10, decimalCount);
    return Math.round(value * rounder) / rounder;
}
const $c88e74c34a89b481$export$be92b6f5f03c0fe9 = $c88e74c34a89b481$export$472062a354075cee;
const $c88e74c34a89b481$export$13921ac0cc260818 = $c88e74c34a89b481$export$105594979f116971;
const $c88e74c34a89b481$export$9a58ef0d7ad3278c = $c88e74c34a89b481$export$a5cf38a7a000fe77;
const $c88e74c34a89b481$export$6521433ed15a34db = $c88e74c34a89b481$export$2c1b491743890dec;



// eslint-disable-next-line react/display-name
const $83cff76755b4a0f6$var$Slider = /*#__PURE__*/ (0, $4DE7A.forwardRef)(({ value: value, defaultValue: defaultValue, className: className, ...props }, ref)=>{
    const displayValues = value ?? defaultValue ?? [];
    const classNames = [
        "slider-root"
    ];
    if (className !== undefined) classNames.push(className);
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)($c88e74c34a89b481$export$472062a354075cee, {
        value: value,
        defaultValue: defaultValue,
        ref: ref,
        className: classNames.join(" "),
        ...props,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($c88e74c34a89b481$export$13921ac0cc260818, {
                className: "slider-track",
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($c88e74c34a89b481$export$9a58ef0d7ad3278c, {
                    className: "slider-range"
                })
            }),
            displayValues.map((_, i)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($c88e74c34a89b481$export$6521433ed15a34db, {
                    className: "slider-thumb"
                }, i))
        ]
    });
});
var $83cff76755b4a0f6$export$2e2bcd8739ae039 = $83cff76755b4a0f6$var$Slider;



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");





function $292e67e840fa392a$var$StreetmixPlusPrompt({ children: children }) {
    function handleClickUpgrade(event) {
        event.preventDefault();
        // dispatch(showDialog('UPGRADE'))
        window.open("https://docs.streetmix.net/user-guide/streetmix-plus", "_blank");
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "streetmix-plus-locked-banner",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                        icon: (0, $5cbf5c54789c9bf6$export$e6d53d6f898a52bd)
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "plus.locked.label",
                        defaultMessage: "Locked"
                    })
                ]
            }),
            children,
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "streetmix-plus-prompt",
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                    onClick: handleClickUpgrade,
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "plus.locked.action",
                        defaultMessage: "Get Streetmix+\u200E"
                    })
                })
            })
        ]
    });
}
$292e67e840fa392a$var$StreetmixPlusPrompt.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).node
};
var $292e67e840fa392a$export$2e2bcd8739ae039 = $292e67e840fa392a$var$StreetmixPlusPrompt;




const $304d6d5c401e2d16$var$MIN_IMAGE_MULTIPLIER = 1;
const $304d6d5c401e2d16$var$MAX_IMAGE_MULTIPLIER = 5;
function $304d6d5c401e2d16$var$CustomScale({ scale: scale, baseDimensions: baseDimensions = {}, onChange: onChange = ()=>{} }) {
    const units = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.settings.units);
    const allowCustomScale = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.flags.SAVE_AS_IMAGE_CUSTOM_DPI.value);
    const { width: width = 0, height: height = 0 } = baseDimensions;
    function handleChangeScale([value]) {
        if (!allowCustomScale) return;
        // Make sure value is within range
        const scale = Math.min(Math.max($304d6d5c401e2d16$var$MIN_IMAGE_MULTIPLIER, value), $304d6d5c401e2d16$var$MAX_IMAGE_MULTIPLIER);
        onChange(scale);
    }
    const classNames = [
        "custom-scale-control"
    ];
    if (!allowCustomScale) classNames.push("custom-scale-disabled");
    const description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
        id: "dialogs.save.option-custom-scale.description",
        defaultMessage: "Download image up to 500% of original size."
    });
    // TODO: Metric unit scale should not use dpi but dots per cm?
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "custom-scale",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "custom-scale-label",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "dialogs.save.option-custom-scale",
                        defaultMessage: "Custom scale"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                        className: "custom-scale-popover",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5e40c6e7d2ea15a8$export$2e2bcd8739ae039), {
                            children: !allowCustomScale ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $292e67e840fa392a$export$2e2bcd8739ae039), {
                                children: description
                            }) : description
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: classNames.join(" "),
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $83cff76755b4a0f6$export$2e2bcd8739ae039), {
                        id: "custom-scale",
                        min: $304d6d5c401e2d16$var$MIN_IMAGE_MULTIPLIER,
                        max: $304d6d5c401e2d16$var$MAX_IMAGE_MULTIPLIER,
                        step: 0.25,
                        value: [
                            scale
                        ],
                        disabled: !allowCustomScale,
                        onValueChange: handleChangeScale
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: `custom-scale-info ${allowCustomScale ? "" : "custom-scale-info-disabled"}`,
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("strong", {
                                children: [
                                    scale * 100,
                                    "%"
                                ]
                            }),
                            " \u2014\xa0",
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "dialogs.save.digital-size",
                                defaultMessage: "Digital size"
                            }),
                            ": ",
                            Math.floor(width * scale),
                            " px \u2A2F ",
                            Math.floor(height * scale),
                            " px \u2014\xa0",
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "dialogs.save.print-size",
                                defaultMessage: "Print size"
                            }),
                            ":",
                            " ",
                            units === (0, $c098fdb90228b950$export$95a57d0e83881bf) ? `${(width * scale / 300 * 2.54).toFixed(2)} cm \u{2A2F} ${(height * scale / 300 * 2.54).toFixed(2)} cm` : `${(width * scale / 300).toFixed(2)}\u{2033} \u{2A2F} ${(height * scale / 300).toFixed(2)}\u{2033}`,
                            " ",
                            "(300 dpi)"
                        ]
                    })
                ]
            })
        ]
    });
}
$304d6d5c401e2d16$var$CustomScale.propTypes = {
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number.isRequired,
    baseDimensions: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        width: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        height: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
    }).isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func
};
var $304d6d5c401e2d16$export$2e2bcd8739ae039 = $304d6d5c401e2d16$var$CustomScale;




const $b4ecdd2ce7605a57$var$DEFAULT_IMAGE_DPI = 2;
function $b4ecdd2ce7605a57$var$SaveAsImageDialog(props) {
    const imageCanvas = (0, $4DE7A.useRef)();
    const [scale, setScale] = (0, $4DE7A.useState)(1);
    const [isLoading, setIsLoading] = (0, $4DE7A.useState)(false);
    const [isSaving, setIsSaving] = (0, $4DE7A.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $4DE7A.useState)(null);
    const [errorMessage2, setErrorMessage2] = (0, $4DE7A.useState)(null);
    const [downloadDataUrl, setDownloadDataUrl] = (0, $4DE7A.useState)("");
    const [baseDimensions, setBaseDimensions] = (0, $4DE7A.useState)({});
    const locale = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.locale.locale);
    const transparentSky = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.settings.saveAsImageTransparentSky);
    const segmentNames = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.settings.saveAsImageSegmentNamesAndWidths);
    const streetName = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.settings.saveAsImageStreetName);
    // even if watermarks are off, override if user isn't subscribed
    const watermark = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.settings.saveAsImageWatermark || !state.user.isSubscriber);
    const street = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street);
    const name = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street.name);
    const isSubscriber = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.isSubscriber);
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    (0, $4DE7A.useEffect)(()=>{
        updatePreview();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $4DE7A.useEffect)(()=>{
        setIsLoading(true);
        // Update preview when props change; make a slight delay because there is
        // a slight lag on image creation, but it's so short it feels weird.
        // Time delay makes the "Loading" feel "right."
        window.setTimeout(()=>{
            updatePreview();
        }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        transparentSky,
        segmentNames,
        streetName,
        watermark
    ]);
    function makeFilename() {
        let filename = (0, $ec5f57ce491b339b$export$bb4bab168f0533a8)(name);
        if (!filename) filename = "street";
        filename += ".png";
        return filename;
    }
    // When options change, this changes props.
    const handleChangeOptionTransparentSky = (event)=>{
        dispatch((0, $91ffa8e8b26e8ad0$export$f558026a994b6051)({
            saveAsImageTransparentSky: event.target.checked
        }));
    };
    const handleChangeOptionSegmentNames = (event)=>{
        dispatch((0, $91ffa8e8b26e8ad0$export$f558026a994b6051)({
            saveAsImageSegmentNamesAndWidths: event.target.checked
        }));
    };
    const handleChangeOptionStreetName = (event)=>{
        dispatch((0, $91ffa8e8b26e8ad0$export$f558026a994b6051)({
            saveAsImageStreetName: event.target.checked
        }));
    };
    const handleChangeOptionWatermark = (event)=>{
        dispatch((0, $91ffa8e8b26e8ad0$export$f558026a994b6051)({
            saveAsImageWatermark: event.target.checked
        }));
    };
    const handleChangeScale = (value)=>{
        setErrorMessage2(false) // Clears "too big" error if present
        ;
        setScale(value);
    };
    const handlePreviewLoaded = ()=>{
        setIsLoading(false);
    };
    const handlePreviewError = ()=>{
        setIsLoading(false);
        setErrorMessage(intl.formatMessage({
            id: "dialogs.save.error-preview",
            defaultMessage: "There was an error displaying a preview image."
        }));
    };
    /**
   * When download links are clicked, convert the dataURL to a blob for download.
   * Designed to get around a limitation in IE where a dataURL is not downloadable
   * directly (https://msdn.microsoft.com/en-us/library/cc848897(v=vs.85).aspx)
   */ const handleClickDownloadImage = (event)=>{
        event.preventDefault();
        setIsSaving(true);
        try {
            // Update the image with the actual size before saving.
            // Images that are too large can throw an error, so catch it
            // and show an error
            updatePreviewImage(scale);
        } catch (err) {
            setIsSaving(false);
            setErrorMessage2(true);
            return;
        }
        imageCanvas.current.toBlob((blob)=>{
            const filename = makeFilename();
            (0, $8712dbc7585918b9$exports.saveAs)(blob, filename);
            window.setTimeout(()=>{
                setIsSaving(false);
            }, 0);
        });
    };
    const updatePreviewImage = (scale = 1)=>{
        // The preview is rendered at the default scale at first.
        imageCanvas.current = (0, $464cf4d7282b8d55$export$1948dfdf2eab675b)(street, transparentSky, segmentNames, streetName, $b4ecdd2ce7605a57$var$DEFAULT_IMAGE_DPI * scale, watermark);
    };
    const updatePreview = ()=>{
        updatePreviewImage(1);
        // Only set base dimensions when preview is generated at scale = 1.
        // The custom slider will update target dimensions by multiplying base * scale
        // which is faster than rendering the entire image and reading its dimensions.
        setBaseDimensions({
            width: imageCanvas.current?.width,
            height: imageCanvas.current?.height
        });
        // .toDataURL is not available on IE11 when SVGs are part of the canvas.
        // The error in catch() should not appear on any of the newer evergreen browsers.
        try {
            const dataUrl = imageCanvas.current.toDataURL("image/png");
            setDownloadDataUrl(dataUrl);
            setErrorMessage(null);
        } catch (e) {
            setErrorMessage(intl.formatMessage({
                id: "dialogs.save.error-unavailable",
                defaultMessage: "Saving to image is not available on this browser."
            }));
        }
    };
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $33ed200ba87fcf5c$export$2e2bcd8739ae039), {
        children: ()=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "save-as-image-dialog",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("header", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "dialogs.save.heading",
                                defaultMessage: "Save as image"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "dialog-content",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                className: "save-as-image-options",
                                children: [
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $58ebe1a968472eb7$export$2e2bcd8739ae039), {
                                        onChange: handleChangeOptionSegmentNames,
                                        checked: segmentNames,
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "dialogs.save.option-labels",
                                            defaultMessage: "Segment names and widths"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $58ebe1a968472eb7$export$2e2bcd8739ae039), {
                                        onChange: handleChangeOptionStreetName,
                                        checked: streetName,
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "dialogs.save.option-name",
                                            defaultMessage: "Street name"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $58ebe1a968472eb7$export$2e2bcd8739ae039), {
                                        onChange: handleChangeOptionTransparentSky,
                                        checked: transparentSky,
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "dialogs.save.option-sky",
                                            defaultMessage: "Transparent sky"
                                        })
                                    }),
                                    isSubscriber ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $58ebe1a968472eb7$export$2e2bcd8739ae039), {
                                        onChange: handleChangeOptionWatermark,
                                        checked: watermark,
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "dialogs.save.option-watermark",
                                            defaultMessage: "Watermark"
                                        })
                                    }) : /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
                                        label: intl.formatMessage({
                                            id: "plus.locked.sub",
                                            // Default message ends with a Unicode-only left-right order mark
                                            // to allow for proper punctuation in `rtl` text direction
                                            // This character is hidden from editors by default!
                                            defaultMessage: "Upgrade to Streetmix+ to use!\u200E"
                                        }),
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                            className: "checkbox-item",
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $58ebe1a968472eb7$export$2e2bcd8739ae039), {
                                                onChange: handleChangeOptionWatermark,
                                                checked: watermark,
                                                disabled: !isSubscriber,
                                                children: [
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                        id: "dialogs.save.option-watermark",
                                                        defaultMessage: "Watermark"
                                                    }),
                                                    "\xa0",
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                                                        icon: (0, $5cbf5c54789c9bf6$export$e6d53d6f898a52bd)
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                className: "save-as-image-preview",
                                children: [
                                    !errorMessage && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                        className: "save-as-image-preview-image",
                                        children: [
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                                className: "save-as-image-preview-loading",
                                                style: {
                                                    display: !isLoading && "none"
                                                },
                                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "dialogs.save.loading",
                                                    defaultMessage: "Loading\u2026"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                                                src: downloadDataUrl,
                                                onLoad: handlePreviewLoaded,
                                                onError: handlePreviewError,
                                                alt: intl.formatMessage({
                                                    id: "dialogs.save.preview-image-alt",
                                                    defaultMessage: "Preview"
                                                })
                                            })
                                        ]
                                    }),
                                    errorMessage && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                        className: "save-as-image-preview-error",
                                        children: errorMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $304d6d5c401e2d16$export$2e2bcd8739ae039), {
                                scale: scale,
                                baseDimensions: baseDimensions,
                                onChange: handleChangeScale
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                className: "save-as-image-download",
                                children: [
                                    errorMessage2 && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                                        className: "save-as-image-too-large-error",
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "dialogs.save.error-too-large",
                                            defaultMessage: "This image is too big and we were not able to create it. Please try a smaller custom size."
                                        })
                                    }),
                                    !errorMessage && !isSaving ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                        primary: true,
                                        onClick: handleClickDownloadImage,
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "dialogs.save.save-button",
                                            defaultMessage: "Save to your computer\u2026"
                                        })
                                    }) : // TODO: When saving, show busy cursor and "Please wait"
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                        primary: true,
                                        disabled: true,
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "dialogs.save.save-button",
                                            defaultMessage: "Save to your computer\u2026"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("footer", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $4506383de6fe6d56$export$2e2bcd8739ae039), {
                            locale: locale
                        })
                    })
                ]
            })
    });
}
var $b4ecdd2ce7605a57$export$2e2bcd8739ae039 = $b4ecdd2ce7605a57$var$SaveAsImageDialog;




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");







parcelRequire("4DE7A");




var $4DE7A = parcelRequire("4DE7A");

var $dBd5b = parcelRequire("dBd5b");

var $4DE7A = parcelRequire("4DE7A");







/* -------------------------------------------------------------------------------------------------
 * Switch
 * -----------------------------------------------------------------------------------------------*/ const $5f886f5977694b0c$var$$6be4966fd9bbc698$var$SWITCH_NAME = "Switch";
const [$5f886f5977694b0c$var$$6be4966fd9bbc698$var$createSwitchContext, $5f886f5977694b0c$export$cf7f5f17f69cbd43] = (0, $23b8c385a06d9331$export$50c7b4e9d9f19c1)($5f886f5977694b0c$var$$6be4966fd9bbc698$var$SWITCH_NAME);
const [$5f886f5977694b0c$var$$6be4966fd9bbc698$var$SwitchProvider, $5f886f5977694b0c$var$$6be4966fd9bbc698$var$useSwitchContext] = $5f886f5977694b0c$var$$6be4966fd9bbc698$var$createSwitchContext($5f886f5977694b0c$var$$6be4966fd9bbc698$var$SWITCH_NAME);
const $5f886f5977694b0c$export$b5d5cf8927ab7262 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, ...switchProps } = props;
    const [button, setButton] = (0, $4DE7A.useState)(null);
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = (0, $4DE7A.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    const [checked = false, setChecked] = (0, $e92f93e2f069d351$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    return /*#__PURE__*/ (0, $4DE7A.createElement)($5f886f5977694b0c$var$$6be4966fd9bbc698$var$SwitchProvider, {
        scope: __scopeSwitch,
        checked: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).button, (0, $dBd5b.default)({
        type: "button",
        role: "switch",
        "aria-checked": checked,
        "aria-required": required,
        "data-state": $5f886f5977694b0c$var$$6be4966fd9bbc698$var$getState(checked),
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        value: value
    }, switchProps, {
        ref: composedRefs,
        onClick: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onClick, (event)=>{
            setChecked((prevChecked)=>!prevChecked);
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if switch is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect switch updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0, $4DE7A.createElement)($5f886f5977694b0c$var$$6be4966fd9bbc698$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: "translateX(-100%)"
        }
    }));
});
/*#__PURE__*/ Object.assign($5f886f5977694b0c$export$b5d5cf8927ab7262, {
    displayName: $5f886f5977694b0c$var$$6be4966fd9bbc698$var$SWITCH_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SwitchThumb
 * -----------------------------------------------------------------------------------------------*/ const $5f886f5977694b0c$var$$6be4966fd9bbc698$var$THUMB_NAME = "SwitchThumb";
const $5f886f5977694b0c$export$4d07bf653ea69106 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, ...thumbProps } = props;
    const context = $5f886f5977694b0c$var$$6be4966fd9bbc698$var$useSwitchContext($5f886f5977694b0c$var$$6be4966fd9bbc698$var$THUMB_NAME, __scopeSwitch);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).span, (0, $dBd5b.default)({
        "data-state": $5f886f5977694b0c$var$$6be4966fd9bbc698$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : undefined
    }, thumbProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($5f886f5977694b0c$export$4d07bf653ea69106, {
    displayName: $5f886f5977694b0c$var$$6be4966fd9bbc698$var$THUMB_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $5f886f5977694b0c$var$$6be4966fd9bbc698$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = (0, $4DE7A.useRef)(null);
    const prevChecked = (0, $762650820aff843b$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $9c4a442f1f3cde52$export$1ab7ae714698c4b8)(control); // Bubble checked change to parents (e.g form change event)
    (0, $4DE7A.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0, $4DE7A.createElement)("input", (0, $dBd5b.default)({
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    }));
};
function $5f886f5977694b0c$var$$6be4966fd9bbc698$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
const $5f886f5977694b0c$export$be92b6f5f03c0fe9 = $5f886f5977694b0c$export$b5d5cf8927ab7262;
const $5f886f5977694b0c$export$6521433ed15a34db = $5f886f5977694b0c$export$4d07bf653ea69106;



// This stores an incrementing number for unique IDs.
let $2386255afa7bc7eb$var$idCounter = 1;
function $2386255afa7bc7eb$var$Switch(props) {
    const { id: id, className: className, children: children, ...restProps } = props;
    // An `id` associates a `label` with the Radix UI Switch component.
    // You can provide one manually in props, otherwise, this component
    // will generate a unique id value for each instance. Generated ids
    // are not meant to be accessed by other code or CSS selectors.
    const elementId = (0, $4DE7A.useRef)(id);
    if (elementId.current === undefined) // This exists in an if statement to check if the ref value is present
    // to prevent the counter from incrementing on every render
    elementId.current = `switch-id-${$2386255afa7bc7eb$var$idCounter++}`;
    const classNames = [
        "switch-root"
    ];
    if (className !== undefined) classNames.push(className);
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "switch-item",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($5f886f5977694b0c$export$be92b6f5f03c0fe9, {
                id: elementId.current,
                className: classNames.join(" "),
                ...restProps,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($5f886f5977694b0c$export$6521433ed15a34db, {
                    className: "switch-thumb"
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("label", {
                htmlFor: elementId.current,
                children: children
            })
        ]
    });
}
var $2386255afa7bc7eb$export$2e2bcd8739ae039 = $2386255afa7bc7eb$var$Switch;


function $025d5bf14bce1fb9$var$FeatureFlagSettings(props) {
    const flags = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.flags);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    function renderFlagList() {
        return Object.entries(flags).map(([key, flag])=>{
            const slugifyKey = key.toLowerCase().replace(/_/g, "-");
            const htmlLabel = `feature-flag__input--${slugifyKey}`;
            // If the setting has changed, display it differently
            const isNotDefault = flag.defaultValue !== flag.value;
            const labelClassName = isNotDefault ? "feature-flag-label-modified" : "";
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "settings-item",
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $2386255afa7bc7eb$export$2e2bcd8739ae039), {
                    id: htmlLabel,
                    onCheckedChange: (checked)=>{
                        dispatch((0, $1ac426dbdd197303$export$4672beabf7ff6568)({
                            flag: key,
                            value: checked
                        }));
                    },
                    checked: flags[key].value,
                    disabled: flag.enabled === false,
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                        className: labelClassName,
                        children: flag.label
                    })
                })
            }, key);
        });
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h2", {
                children: "Feature flags"
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: "Feature flags are administrator-level settings that can adjust or toggle Streetmix functionality. They can change at any time. Use at your own risk."
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("hr", {}),
            renderFlagList()
        ]
    });
}
var $025d5bf14bce1fb9$export$2e2bcd8739ae039 = $025d5bf14bce1fb9$var$FeatureFlagSettings;



parcelRequire("4DE7A");






parcelRequire("4DE7A");





var $4DE7A = parcelRequire("4DE7A");

var $dBd5b = parcelRequire("dBd5b");

var $4DE7A = parcelRequire("4DE7A");





var $dBd5b = parcelRequire("dBd5b");

var $4DE7A = parcelRequire("4DE7A");









const $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$Collection, $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$useCollection, $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$createCollectionScope] = (0, $6a369b93e8d909a0$export$c74125a8e3af6bb2)($7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $7a903e631ac6b5a1$export$c7109489551a4f4] = (0, $23b8c385a06d9331$export$50c7b4e9d9f19c1)($7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext] = $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const $7a903e631ac6b5a1$export$8699f7c8af148338 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $4DE7A.createElement)($7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $4DE7A.createElement)($7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $4DE7A.createElement)($7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0, $dBd5b.default)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($7a903e631ac6b5a1$export$8699f7c8af148338, {
    displayName: $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, ...groupProps } = props;
    const ref = (0, $4DE7A.useRef)(null);
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $ca61ba5b50f7e65b$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $e92f93e2f069d351$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0, $4DE7A.useState)(false);
    const handleEntryFocus = (0, $8944a0c09755b6a8$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0, $4DE7A.useRef)(false);
    const [focusableItemsCount, setFocusableItemsCount] = (0, $4DE7A.useState)(0);
    (0, $4DE7A.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0, $4DE7A.createElement)($7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0, $4DE7A.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0, $4DE7A.useCallback)(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: (0, $4DE7A.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: (0, $4DE7A.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), [])
    }, /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).div, (0, $dBd5b.default)({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...props.style
        },
        onMouseDown: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable);
                    const activeItem = items.find((item)=>item.active);
                    const currentItem = items.find((item)=>item.id === currentTabStopId);
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current);
                    $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $7a903e631ac6b5a1$export$ab9df7c53fe8454 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, ...itemProps } = props;
    const autoId = (0, $cc2dc425846fc689$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext($7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove } = context;
    (0, $4DE7A.useEffect)(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ (0, $4DE7A.createElement)($7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).span, (0, $dBd5b.default)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
        onKeyDown: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable);
                let candidateNodes = items.map((item)=>item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev") candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($7a903e631ac6b5a1$export$ab9df7c53fe8454, {
    displayName: $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return undefined;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return undefined;
    return $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $7a903e631ac6b5a1$var$$d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $7a903e631ac6b5a1$export$be92b6f5f03c0fe9 = $7a903e631ac6b5a1$export$8699f7c8af148338;
const $7a903e631ac6b5a1$export$6d08773d2e66f8f2 = $7a903e631ac6b5a1$export$ab9df7c53fe8454;







/* -------------------------------------------------------------------------------------------------
 * Radio
 * -----------------------------------------------------------------------------------------------*/ const $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$RADIO_NAME = "Radio";
const [$6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$createRadioContext, $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$export$67d2296460f1b002] = (0, $23b8c385a06d9331$export$50c7b4e9d9f19c1)($6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$RADIO_NAME);
const [$6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$RadioProvider, $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$useRadioContext] = $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$createRadioContext($6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$RADIO_NAME);
const $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$export$d7b12c4107be0d61 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio, name: name, checked: checked = false, required: required, disabled: disabled, value: value = "on", onCheck: onCheck, ...radioProps } = props;
    const [button, setButton] = (0, $4DE7A.useState)(null);
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = (0, $4DE7A.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    return /*#__PURE__*/ (0, $4DE7A.createElement)($6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$RadioProvider, {
        scope: __scopeRadio,
        checked: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).button, (0, $dBd5b.default)({
        type: "button",
        role: "radio",
        "aria-checked": checked,
        "data-state": $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$getState(checked),
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        value: value
    }, radioProps, {
        ref: composedRefs,
        onClick: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(props.onClick, (event)=>{
            // radios cannot be unchecked so we only communicate a checked state
            if (!checked) onCheck === null || onCheck === void 0 || onCheck();
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if radio is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect radio updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0, $4DE7A.createElement)($6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: "translateX(-100%)"
        }
    }));
});
/*#__PURE__*/ Object.assign($6fb4175b7fa3d91a$var$$ce77a8961b41be9e$export$d7b12c4107be0d61, {
    displayName: $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$RADIO_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioIndicator
 * -----------------------------------------------------------------------------------------------*/ const $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$INDICATOR_NAME = "RadioIndicator";
const $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$export$d35a9ffa9a04f9e7 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio, forceMount: forceMount, ...indicatorProps } = props;
    const context = $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$useRadioContext($6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$INDICATOR_NAME, __scopeRadio);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $6329cd9c86a9a60c$export$99c2b779aa4e8b8b), {
        present: forceMount || context.checked
    }, /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).span, (0, $dBd5b.default)({
        "data-state": $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : undefined
    }, indicatorProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($6fb4175b7fa3d91a$var$$ce77a8961b41be9e$export$d35a9ffa9a04f9e7, {
    displayName: $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = (0, $4DE7A.useRef)(null);
    const prevChecked = (0, $762650820aff843b$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $9c4a442f1f3cde52$export$1ab7ae714698c4b8)(control); // Bubble checked change to parents (e.g form change event)
    (0, $4DE7A.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0, $4DE7A.createElement)("input", (0, $dBd5b.default)({
        type: "radio",
        "aria-hidden": true,
        defaultChecked: checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    }));
};
function $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
const $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$ARROW_KEYS = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
];
/* -------------------------------------------------------------------------------------------------
 * RadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME = "RadioGroup";
const [$6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$createRadioGroupContext, $6fb4175b7fa3d91a$export$c547093f11b76da2] = (0, $23b8c385a06d9331$export$50c7b4e9d9f19c1)($6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME, [
    (0, $7a903e631ac6b5a1$export$c7109489551a4f4),
    $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$export$67d2296460f1b002
]);
const $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$useRovingFocusGroupScope = (0, $7a903e631ac6b5a1$export$c7109489551a4f4)();
const $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$useRadioScope = $6fb4175b7fa3d91a$var$$ce77a8961b41be9e$export$67d2296460f1b002();
const [$6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$RadioGroupProvider, $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$useRadioGroupContext] = $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$createRadioGroupContext($6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME);
const $6fb4175b7fa3d91a$export$a98f0dcb43a68a25 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, name: name, defaultValue: defaultValue, value: valueProp, required: required = false, disabled: disabled = false, orientation: orientation, dir: dir, loop: loop = true, onValueChange: onValueChange, ...groupProps } = props;
    const rovingFocusGroupScope = $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const direction = (0, $ca61ba5b50f7e65b$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $e92f93e2f069d351$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /*#__PURE__*/ (0, $4DE7A.createElement)($6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$RadioGroupProvider, {
        scope: __scopeRadioGroup,
        name: name,
        required: required,
        disabled: disabled,
        value: value,
        onValueChange: setValue
    }, /*#__PURE__*/ (0, $4DE7A.createElement)((0, $7a903e631ac6b5a1$export$be92b6f5f03c0fe9), (0, $dBd5b.default)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: orientation,
        dir: direction,
        loop: loop
    }), /*#__PURE__*/ (0, $4DE7A.createElement)((0, $5350cbeeb3d0f7d5$export$250ffa63cdc0d034).div, (0, $dBd5b.default)({
        role: "radiogroup",
        "aria-required": required,
        "aria-orientation": orientation,
        "data-disabled": disabled ? "" : undefined,
        dir: direction
    }, groupProps, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($6fb4175b7fa3d91a$export$a98f0dcb43a68a25, {
    displayName: $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$ITEM_NAME = "RadioGroupItem";
const $6fb4175b7fa3d91a$export$9f866c100ef519e4 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, disabled: disabled, ...itemProps } = props;
    const context = $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$useRadioGroupContext($6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$ITEM_NAME, __scopeRadioGroup);
    const isDisabled = context.disabled || disabled;
    const rovingFocusGroupScope = $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const radioScope = $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$useRadioScope(__scopeRadioGroup);
    const ref = (0, $4DE7A.useRef)(null);
    const composedRefs = (0, $aa92db86bf739672$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const checked = context.value === itemProps.value;
    const isArrowKeyPressedRef = (0, $4DE7A.useRef)(false);
    (0, $4DE7A.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if ($6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$ARROW_KEYS.includes(event.key)) isArrowKeyPressedRef.current = true;
        };
        const handleKeyUp = ()=>isArrowKeyPressedRef.current = false;
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    return /*#__PURE__*/ (0, $4DE7A.createElement)((0, $7a903e631ac6b5a1$export$6d08773d2e66f8f2), (0, $dBd5b.default)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !isDisabled,
        active: checked
    }), /*#__PURE__*/ (0, $4DE7A.createElement)($6fb4175b7fa3d91a$var$$ce77a8961b41be9e$export$d7b12c4107be0d61, (0, $dBd5b.default)({
        disabled: isDisabled,
        required: context.required,
        checked: checked
    }, radioScope, itemProps, {
        name: context.name,
        ref: composedRefs,
        onCheck: ()=>context.onValueChange(itemProps.value),
        onKeyDown: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)((event)=>{
            // According to WAI ARIA, radio groups don't activate items on enter keypress
            if (event.key === "Enter") event.preventDefault();
        }),
        onFocus: (0, $67aa2c30cf03439c$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>{
            var _ref$current;
            /**
       * Our `RovingFocusGroup` will focus the radio when navigating with arrow keys
       * and we need to "check" it in that case. We click it to "check" it (instead
       * of updating `context.value`) so that the radio change event fires.
       */ if (isArrowKeyPressedRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.click();
        })
    })));
});
/*#__PURE__*/ Object.assign($6fb4175b7fa3d91a$export$9f866c100ef519e4, {
    displayName: $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioGroupIndicator
 * -----------------------------------------------------------------------------------------------*/ const $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$INDICATOR_NAME = "RadioGroupIndicator";
const $6fb4175b7fa3d91a$export$5fb54c671a65c88 = /*#__PURE__*/ (0, $4DE7A.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, ...indicatorProps } = props;
    const radioScope = $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$useRadioScope(__scopeRadioGroup);
    return /*#__PURE__*/ (0, $4DE7A.createElement)($6fb4175b7fa3d91a$var$$ce77a8961b41be9e$export$d35a9ffa9a04f9e7, (0, $dBd5b.default)({}, radioScope, indicatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($6fb4175b7fa3d91a$export$5fb54c671a65c88, {
    displayName: $6fb4175b7fa3d91a$var$$f99a8c78507165f7$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $6fb4175b7fa3d91a$export$be92b6f5f03c0fe9 = $6fb4175b7fa3d91a$export$a98f0dcb43a68a25;
const $6fb4175b7fa3d91a$export$6d08773d2e66f8f2 = $6fb4175b7fa3d91a$export$9f866c100ef519e4;
const $6fb4175b7fa3d91a$export$adb584737d712b70 = $6fb4175b7fa3d91a$export$5fb54c671a65c88;



// This stores an incrementing number for unique IDs.
let $5d8cb2eb0c1a32f5$var$idCounter = 1;
function $5d8cb2eb0c1a32f5$var$RadioGroup(props) {
    const { id: id, className: className = "", values: values, ...restProps } = props;
    // An `id` associates a `label` with the Radix UI RadioGroup component.
    // You can provide one manually in props, otherwise, this component
    // will generate a unique id value for each instance. Generated ids
    // are not meant to be accessed by other code or CSS selectors.
    const elementId = (0, $4DE7A.useRef)(id);
    const idValue = elementId.current ?? `radio-group-id-${$5d8cb2eb0c1a32f5$var$idCounter++}`;
    if (elementId.current === undefined) // This exists in an if statement to check if the ref value is present
    // to prevent the counter from incrementing on every render
    elementId.current = `radio-group-id-${$5d8cb2eb0c1a32f5$var$idCounter++}`;
    const classNames = [
        "radio-group-root"
    ];
    if (className) classNames.push(className);
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($6fb4175b7fa3d91a$export$be92b6f5f03c0fe9, {
        className: classNames.join(" "),
        ...restProps,
        children: values.map((props, i)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($5d8cb2eb0c1a32f5$var$RadioGroupItem, {
                id: `${idValue}_${i}`,
                ...props
            }, `${idValue}_${i}`))
    });
}
function $5d8cb2eb0c1a32f5$var$RadioGroupItem({ id: id, value: value, label: label, sublabel: sublabel = "", disabled: disabled = false, required: required = false }) {
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "radio-group-item",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($6fb4175b7fa3d91a$export$6d08773d2e66f8f2, {
                className: "radio-group-radio",
                id: id,
                value: value,
                disabled: disabled,
                required: required,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($6fb4175b7fa3d91a$export$adb584737d712b70, {
                    className: "radio-group-indicator"
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("label", {
                htmlFor: id,
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                        className: "radio-group-label",
                        children: label
                    }),
                    sublabel && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                        className: "radio-group-sublabel",
                        children: sublabel
                    })
                ]
            })
        ]
    });
}
var $5d8cb2eb0c1a32f5$export$2e2bcd8739ae039 = $5d8cb2eb0c1a32f5$var$RadioGroup;




function $8c8d7031ea8c0545$var$AppearanceSettings(props) {
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "settings.appearance.label",
                    defaultMessage: "Appearance"
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($8c8d7031ea8c0545$var$ColorModeSettings, {})
        ]
    });
}
function $8c8d7031ea8c0545$var$ColorModeSettings(props) {
    const colorMode = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.settings.colorMode);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    function handleValueChange(value) {
        dispatch((0, $91ffa8e8b26e8ad0$export$c017d343292b73d0)(value));
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("h3", {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "settings.theme.label",
                        defaultMessage: "Theme"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5e40c6e7d2ea15a8$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "settings.theme.description",
                            defaultMessage: "Sets user interface color scheme."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5d8cb2eb0c1a32f5$export$2e2bcd8739ae039), {
                name: "color-mode",
                value: colorMode,
                defaultValue: (0, $ea458c15ce872cdc$export$d741617d68d238f5),
                onValueChange: handleValueChange,
                values: [
                    {
                        value: (0, $ea458c15ce872cdc$export$d741617d68d238f5),
                        label: intl.formatMessage({
                            id: "settings.theme.light",
                            defaultMessage: "Light theme"
                        })
                    },
                    {
                        value: (0, $ea458c15ce872cdc$export$fb86e74aa5a87996),
                        label: intl.formatMessage({
                            id: "settings.theme.dark",
                            defaultMessage: "Dark theme"
                        })
                    },
                    {
                        value: (0, $ea458c15ce872cdc$export$6897e1d0e3ecb51c),
                        label: intl.formatMessage({
                            id: "settings.theme.system",
                            defaultMessage: "Use system preference"
                        })
                    }
                ]
            })
        ]
    });
}
var $8c8d7031ea8c0545$export$2e2bcd8739ae039 = $8c8d7031ea8c0545$var$AppearanceSettings;



parcelRequire("4DE7A");





// This is user-level setting! It does not adjust street units, as
// it did in the past. The main effect is that you only see this
// for new streets.
function $78115cc1d0ac50ef$var$UnitSettings(props) {
    const units = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.settings.units);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    function handleValueChange(value) {
        if (value === "metric") dispatch((0, $91ffa8e8b26e8ad0$export$df095147a62dd3c4)((0, $c098fdb90228b950$export$95a57d0e83881bf)));
        else dispatch((0, $91ffa8e8b26e8ad0$export$df095147a62dd3c4)((0, $c098fdb90228b950$export$c9756beb4aae2c8d)));
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "settings.units.label",
                    defaultMessage: "Units"
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5d8cb2eb0c1a32f5$export$2e2bcd8739ae039), {
                name: "units",
                value: units === (0, $c098fdb90228b950$export$95a57d0e83881bf) ? "metric" : "imperial",
                defaultValue: "metric",
                onValueChange: handleValueChange,
                values: [
                    {
                        value: "metric",
                        label: intl.formatMessage({
                            id: "settings.units.metric",
                            defaultMessage: "Metric units (meters)"
                        })
                    },
                    {
                        value: "imperial",
                        label: intl.formatMessage({
                            id: "settings.units.imperial",
                            defaultMessage: "Imperial units (feet)"
                        })
                    }
                ]
            })
        ]
    });
}
var $78115cc1d0ac50ef$export$2e2bcd8739ae039 = $78115cc1d0ac50ef$var$UnitSettings;


function $43586bd49d8def50$var$GeneralSettings(props) {
    const flags = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.flags);
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h2", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "settings.general.label",
                            defaultMessage: "General"
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("hr", {})
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $78115cc1d0ac50ef$export$2e2bcd8739ae039), {}),
            flags.COLOR_MODE_TOGGLE.value && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $8c8d7031ea8c0545$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h2", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "settings.misc.label",
                            defaultMessage: "Miscellaneous"
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)($43586bd49d8def50$var$SillyClownSetting, {})
                ]
            })
        ]
    });
}
/**
 * Silly clowns is a feature flag that is also now user-editable.
 */ function $43586bd49d8def50$var$SillyClownSetting(props) {
    const flag = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.flags.SILLY_CLOWNS);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    function handleCheckedChange(checked) {
        dispatch((0, $1ac426dbdd197303$export$4672beabf7ff6568)({
            flag: "SILLY_CLOWNS",
            value: checked
        }));
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "settings-item",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $2386255afa7bc7eb$export$2e2bcd8739ae039), {
                onCheckedChange: handleCheckedChange,
                checked: flag.value,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "settings.misc.silly-clowns",
                    defaultMessage: "Silly clowns"
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5e40c6e7d2ea15a8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "settings.misc.silly-clowns-description",
                    defaultMessage: "Enables Easter eggs."
                })
            })
        ]
    });
}
var $43586bd49d8def50$export$2e2bcd8739ae039 = $43586bd49d8def50$var$GeneralSettings;



parcelRequire("4DE7A");






function $6d6897905a011b89$var$LanguageSettings(props) {
    const locale = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.locale.locale || (0, $b8c344dce25738f3$export$1af4c7e47ad72f44));
    // const requestedLocale = useSelector((state) => state.locale.requestedLocale)
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const availableLocales = (0, $4daaf0496059b305$export$dcd88f9e8a73bead)();
    const actuallySelectedLocale = (0, $4daaf0496059b305$export$f706f5d6959e9268)(locale);
    async function handleValueChange(newLocale) {
        await dispatch((0, $0083fa256c596554$export$7343075cd7f756c5)(newLocale));
    }
    function makeLocaleValues(availableLocales) {
        return availableLocales.map((locale)=>({
                value: locale.value,
                label: locale.label,
                sublabel: intl.formatMessage({
                    id: locale.key,
                    defaultMessage: locale.name
                })
            }));
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "settings.language.label",
                    defaultMessage: "Language"
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5d8cb2eb0c1a32f5$export$2e2bcd8739ae039), {
                name: "language",
                value: actuallySelectedLocale,
                defaultValue: (0, $b8c344dce25738f3$export$1af4c7e47ad72f44),
                onValueChange: handleValueChange,
                values: makeLocaleValues(availableLocales)
            })
        ]
    });
}
var $6d6897905a011b89$export$2e2bcd8739ae039 = $6d6897905a011b89$var$LanguageSettings;




var $4DE7A = parcelRequire("4DE7A");








const $465f55e8f4c4d508$var$DISPLAY_NAME_MAX_CHARS = 30;
const $465f55e8f4c4d508$var$DISPLAY_NAME_MAX_CHARS_WARN = $465f55e8f4c4d508$var$DISPLAY_NAME_MAX_CHARS - 10;
function $465f55e8f4c4d508$var$ProfileSettings(props) {
    const displayNameInputRef = (0, $4DE7A.useRef)();
    const user = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.signInData?.details);
    const [displayNameValue, setDisplayNameValue] = (0, $4DE7A.useState)(user.displayName || user.id);
    const [isEditing, setEditing] = (0, $4DE7A.useState)(false);
    const [isPending, setPending] = (0, $4DE7A.useState)(false);
    const [isError, setError] = (0, $4DE7A.useState)(false);
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    function handleEditDisplayName(event) {
        setEditing(true);
        // Focuses the input and selects it if has the default username
        // setTimeout of 0 is needed to run after render
        window.setTimeout(()=>{
            if (displayNameInputRef.current) {
                displayNameInputRef.current.focus();
                if (displayNameValue === user.id) displayNameInputRef.current.select();
            }
        }, 0);
    }
    function handleResetDisplayName(event) {
        setEditing(false);
        setDisplayNameValue(user.displayName || user.id);
    }
    function handleChangeDisplayName(event) {
        setDisplayNameValue(event.target.value);
    }
    async function handleSaveDisplayName(event) {
        setPending(true);
        try {
            // Update display name
            await (0, $4ff1018a457d25d0$export$bf950db3913272ff)(user.id, {
                displayName: displayNameValue
            });
            // Update local data for it
            dispatch((0, $ca8c478b1d098cf7$export$acb032659de1ea6d)(displayNameValue));
            // Restore editing state
            setError(false);
            // "Thinking time"
            window.setTimeout(()=>{
                setEditing(false);
                setPending(false);
            }, 500);
        } catch (err) {
            console.error("Profile settings error", err);
            // "Thinking time"
            window.setTimeout(()=>{
                setError(true);
                setPending(false);
                if (displayNameInputRef.current) displayNameInputRef.current.focus();
            }, 500);
        }
    }
    function handleSubmit(event) {
        event.preventDefault();
        handleSaveDisplayName(event);
    }
    // Not signed-in users shouldn't see this,
    // but if they somehow access it, just refuse to render
    if (!user) return null;
    const messages = [];
    if (isEditing && !isPending && displayNameValue.length >= $465f55e8f4c4d508$var$DISPLAY_NAME_MAX_CHARS_WARN) messages.push(intl.formatMessage({
        id: "settings.profile.display-name-characters-remaining",
        defaultMessage: "Characters remaining: {currentNum} ({maxNum} maximum)"
    }, {
        currentNum: $465f55e8f4c4d508$var$DISPLAY_NAME_MAX_CHARS - displayNameValue.length,
        maxNum: $465f55e8f4c4d508$var$DISPLAY_NAME_MAX_CHARS
    }));
    if (isError) messages.push(intl.formatMessage({
        id: "settings.profile..display-name-error",
        defaultMessage: "Display name could not be saved"
    }));
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "settings.profile.label",
                    defaultMessage: "Profile"
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "profile-settings-item",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("h3", {
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "settings.profile.username",
                                defaultMessage: "Username"
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5e40c6e7d2ea15a8$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "settings.profile.username-description",
                                    defaultMessage: "Your username is a unique account identifier."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "profile-settings-editable",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                children: user.id
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                className: "profile-settings-button",
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                    disabled: true,
                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                        id: "btn.edit",
                                        defaultMessage: "Edit"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "profile-settings-item",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("h3", {
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("label", {
                                htmlFor: "display-name-input",
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "settings.profile.display-name",
                                    defaultMessage: "Display name"
                                })
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5e40c6e7d2ea15a8$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "settings.profile.display-name-description",
                                    defaultMessage: "Your display name is how you appear to other users in Streetmix."
                                })
                            })
                        ]
                    }),
                    isEditing ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "profile-settings-editable",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("form", {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("input", {
                                        ref: displayNameInputRef,
                                        id: "display-name-input",
                                        type: "text",
                                        value: displayNameValue,
                                        onChange: handleChangeDisplayName,
                                        disabled: isPending,
                                        maxLength: $465f55e8f4c4d508$var$DISPLAY_NAME_MAX_CHARS
                                    })
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                    className: "profile-settings-button",
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                            onClick: handleSaveDisplayName,
                                            primary: true,
                                            disabled: isPending,
                                            children: [
                                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "btn.save",
                                                    defaultMessage: "Save"
                                                }),
                                                isPending && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                                    className: "profile-settings-pending",
                                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $62d2815b920e2bc5$export$2e2bcd8739ae039), {
                                                        size: "small"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                            onClick: handleResetDisplayName,
                                            tertiary: true,
                                            disabled: isPending,
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                id: "btn.cancel",
                                                defaultMessage: "Cancel"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "profile-settings-editable",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                children: user.displayName || /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                                    className: "profile-display-name-not-set",
                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                        id: "settings.profile.display-name-not-set",
                                        defaultMessage: "You have not added a display name yet."
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                className: "profile-settings-button",
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                    onClick: handleEditDisplayName,
                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                        id: "btn.edit",
                                        defaultMessage: "Edit"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "profile-display-name-messages",
                        children: messages.map((m)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                children: m
                            }, m))
                    })
                ]
            })
        ]
    });
}
var $465f55e8f4c4d508$export$2e2bcd8739ae039 = $465f55e8f4c4d508$var$ProfileSettings;




$54dced87cf1606c2$var$SettingsDialog.propTypes = {
    category: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
};
/**
 * Settings shown/modified in this dialog should apply at user-level.
 * Users that are not signed in (anonymous) are applied for the browser
 * session. Don't use this for street-level settings.
 */ function $54dced87cf1606c2$var$SettingsDialog({ category: category = "profile" }) {
    const user = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user?.signInData?.details || {});
    const [activeCategory, setActiveCategory] = (0, $4DE7A.useState)(category);
    const { roles: roles = [] } = user;
    const showFlags = (0, $63b5c9d178f1431e$export$83401e34d5e11bf4) !== "production" || roles.includes((0, (/*@__PURE__*/$parcel$interopDefault($98448114ff4d3ef1$exports))).ADMIN.value);
    function handleSelectCategory(category) {
        setActiveCategory(category);
    }
    let SettingsPanel;
    switch(activeCategory){
        case "feature-flags":
            SettingsPanel = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $025d5bf14bce1fb9$export$2e2bcd8739ae039), {});
            break;
        case "general":
            SettingsPanel = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $43586bd49d8def50$export$2e2bcd8739ae039), {});
            break;
        case "language":
            SettingsPanel = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6d6897905a011b89$export$2e2bcd8739ae039), {});
            break;
        case "profile":
            SettingsPanel = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $465f55e8f4c4d508$export$2e2bcd8739ae039), {});
            break;
        case "units":
            SettingsPanel = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $78115cc1d0ac50ef$export$2e2bcd8739ae039), {});
            break;
        default:
            SettingsPanel = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                children: "Not implemented"
            });
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $33ed200ba87fcf5c$export$2e2bcd8739ae039), {
        children: (closeDialog)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "settings-dialog",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("header", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                // TODO: Rename translation key
                                // id="settings.heading"
                                id: "menu.item.settings",
                                defaultMessage: "Settings"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "dialog-content dialog-content-bleed",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                            className: "settings-dialog-content",
                            children: [
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                    className: "settings-dialog-left",
                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                                                onClick: ()=>handleSelectCategory("profile"),
                                                className: activeCategory === "profile" ? "settings-menu-active" : "",
                                                children: [
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$7dcc8f518762622d), {
                                                        className: "settings-menu-icon"
                                                    }),
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                        id: "settings.profile.label",
                                                        defaultMessage: "Profile"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                                                onClick: ()=>handleSelectCategory("general"),
                                                className: activeCategory === "general" ? "settings-menu-active" : "",
                                                children: [
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$5560e721cf131890), {
                                                        className: "settings-menu-icon"
                                                    }),
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                        id: "settings.general.label",
                                                        defaultMessage: "General"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                                                onClick: ()=>handleSelectCategory("language"),
                                                className: activeCategory === "language" ? "settings-menu-active" : "",
                                                children: [
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$a70e2e549144f66), {
                                                        className: "settings-menu-icon"
                                                    }),
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                        id: "settings.language.label",
                                                        defaultMessage: "Language"
                                                    })
                                                ]
                                            }),
                                            showFlags && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                                                onClick: ()=>handleSelectCategory("feature-flags"),
                                                className: activeCategory === "feature-flags" ? "settings-menu-active" : "",
                                                children: [
                                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6431ef21eafb1f5a$export$afee984ac0331725), {
                                                        className: "settings-menu-icon"
                                                    }),
                                                    "Feature flags"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                    className: "settings-dialog-right",
                                    children: SettingsPanel
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
                        className: "dialog-primary-action",
                        onClick: closeDialog,
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "btn.close",
                            defaultMessage: "Close"
                        })
                    })
                ]
            })
    });
}
var $54dced87cf1606c2$export$2e2bcd8739ae039 = $54dced87cf1606c2$var$SettingsDialog;




var $4DE7A = parcelRequire("4DE7A");







class $26ab41e3a7b01a4f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Component {
    constructor(props){
        super(props);
        this.state = {
            email: "",
            emailSent: false,
            sendingEmail: false,
            error: false,
            signingIn: false
        };
        this.emailInputEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createRef();
    }
    componentDidMount = ()=>{
        this.emailInputEl.current.focus();
    };
    handleChange = (event)=>{
        const target = event.target;
        const name = target.name;
        const value = target.value;
        this.setState({
            [name]: value
        });
    };
    handleFacebookSignIn = (event)=>{
        event.preventDefault();
        this.setState({
            signingIn: true
        });
        (0, $f3d8f18722148e05$export$12c5a7cb8eb9b109)();
    };
    handleGoogleSignIn = (event)=>{
        event.preventDefault();
        this.setState({
            signingIn: true
        });
        (0, $f3d8f18722148e05$export$d31f12173d341be5)();
    };
    handleTwitterSignIn = (event)=>{
        event.preventDefault();
        this.setState({
            signingIn: true
        });
        (0, $f3d8f18722148e05$export$96352d11af64d2e5)();
    };
    handleGoEmailSignIn = (error, res)=>{
        if (error) {
            console.error(error);
            return;
        }
        this.setState({
            sendingEmail: false,
            emailSent: true,
            // Reset error state
            error: false
        });
    };
    handleEmailResend = (event)=>{
        event.preventDefault();
        this.setState({
            emailSent: false
        });
    };
    handleSubmit = (event)=>{
        event.preventDefault();
        // Note: we don't validate the input here;
        // we let HTML5 <input type="email" required /> do validation
        (0, $f3d8f18722148e05$export$d3179f1c9b9fc645)(this.state.email, this.handleGoEmailSignIn);
        this.setState({
            sendingEmail: true
        });
    };
    renderErrorMessage = ()=>{
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
            className: "sign-in-error-message",
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "dialogs.sign-in.email-invalid",
                defaultMessage: "Oops! That didn\u2019t look like a valid email address. Please try again."
            })
        });
    };
    renderSignInWaiting = ()=>{
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $33ed200ba87fcf5c$export$2e2bcd8739ae039), {
            children: ()=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                    className: "sign-in-dialog",
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("header", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                                className: "sign-in-loading-message",
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "dialogs.sign-in.loading-message",
                                    defaultMessage: "Signing you in\u2026"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                            className: "dialog-content sign-in-loading",
                            "aria-live": "polite",
                            "aria-busy": "true",
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $62d2815b920e2bc5$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
        });
    };
    renderEmailSent = ()=>{
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $33ed200ba87fcf5c$export$2e2bcd8739ae039), {
            children: ()=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                    className: "sign-in-dialog",
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("header", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                                className: "sign-in-loading-message",
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "dialogs.sign-in.loading-message",
                                    defaultMessage: "Signing you in\u2026"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                            className: "dialog-content sign-in-email-sent",
                            children: [
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                        id: "dialogs.sign-in.sent-message-with-email",
                                        defaultMessage: "We\u2019ve sent an email to {email}. Please follow the instructions there to continue signing in!",
                                        values: {
                                            email: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                                                className: "sign-in-email",
                                                children: this.state.email
                                            })
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
                                    className: "sign-in-resend",
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "dialogs.sign-in.email-unreceived",
                                            defaultMessage: "Didn\u2019t receive it?"
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                                            onClick: this.handleEmailResend,
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                id: "dialogs.sign-in.resend-email",
                                                defaultMessage: "Resend email"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
        });
    };
    render() {
        const { sendingEmail: sendingEmail, emailSent: emailSent, signingIn: signingIn } = this.state;
        if (sendingEmail || signingIn) return this.renderSignInWaiting();
        else if (emailSent) return this.renderEmailSent();
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $33ed200ba87fcf5c$export$2e2bcd8739ae039), {
            children: (closeDialog)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                    className: "sign-in-dialog",
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("header", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "dialogs.sign-in.heading",
                                    defaultMessage: "Sign in / Sign up"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                            className: "dialog-content",
                            children: [
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                        id: "dialogs.sign-in.description",
                                        defaultMessage: "Save your first design or sign in to access your past designs."
                                    })
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("form", {
                                    onSubmit: this.handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("label", {
                                            htmlFor: "sign-in-email-input",
                                            className: "sign-in-email-label",
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                id: "dialogs.sign-in.email-label",
                                                defaultMessage: "Email"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("input", {
                                            type: "email",
                                            id: "sign-in-email-input",
                                            ref: this.emailInputEl,
                                            value: this.state.email,
                                            className: "sign-in-input " + (this.state.error ? "sign-in-input-error" : ""),
                                            name: "email",
                                            onChange: this.handleChange,
                                            placeholder: "test@test.com",
                                            required: true
                                        }),
                                        this.state.error && this.renderErrorMessage(),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                            className: "sign-in-email-password-note",
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("small", {
                                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "dialogs.sign-in.email-description",
                                                    defaultMessage: "We\u2019ll send you a link to sign in. No password is required."
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                            type: "submit",
                                            primary: true,
                                            className: "sign-in-button sign-in-email-button",
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                id: "dialogs.sign-in.button.email",
                                                defaultMessage: "Continue with email"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                    className: "sign-in-social-heading",
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("hr", {}),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                id: "dialogs.sign-in.social-heading",
                                                defaultMessage: "or"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                    tertiary: true,
                                    className: "sign-in-button sign-in-social-button sign-in-twitter-button",
                                    onClick: this.handleTwitterSignIn,
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                                            icon: "twitter"
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "dialogs.sign-in.button.twitter",
                                            defaultMessage: "Continue with Twitter"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                    tertiary: true,
                                    className: "sign-in-button sign-in-social-button sign-in-google-button",
                                    onClick: this.handleGoogleSignIn,
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                                            icon: "google"
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "dialogs.sign-in.button.google",
                                            defaultMessage: "Continue with Google"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                    tertiary: true,
                                    className: "sign-in-button sign-in-social-button sign-in-facebook-button",
                                    onClick: this.handleFacebookSignIn,
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                                            icon: "facebook"
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "dialogs.sign-in.button.facebook",
                                            defaultMessage: "Continue with Facebook"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("footer", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                className: "sign-in-disclaimer",
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "dialogs.sign-in.tos",
                                    defaultMessage: "By clicking one of these buttons, I agree to the {tosLink} and {privacyLink}.",
                                    values: {
                                        tosLink: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                                            href: "/terms-of-service",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                id: "dialogs.sign-in.tos-link-label",
                                                defaultMessage: "terms of service"
                                            })
                                        }),
                                        privacyLink: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                                            href: "/privacy-policy",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                id: "dialogs.sign-in.privacy-link-label",
                                                defaultMessage: "privacy policy"
                                            })
                                        })
                                    }
                                })
                            })
                        })
                    ]
                })
        });
    }
}




var $4DE7A = parcelRequire("4DE7A");









const $3c8e62993ba0e84f$var$WhatsNewDialog = ()=>{
    const locale = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.locale.locale);
    const [state, setSubmitState] = (0, $4DE7A.useState)("LOADING");
    const [content, setContent] = (0, $4DE7A.useState)(null);
    const [scrollShade, setScrollShade] = (0, $4DE7A.useState)(false);
    (0, $4DE7A.useEffect)(()=>{
        getContent();
    }, []);
    const onScroll = (event)=>{
        if (event.target.scrollTop > 30) setScrollShade(true);
        else setScrollShade(false);
    };
    async function getContent() {
        try {
            const response = await (0, $4ff1018a457d25d0$export$52ce36ac14d2526d)();
            setContent(response.data);
            setSubmitState("OK");
        } catch (error) {
            // The error handling here handles both server errors (e.g. 404, 500, etc)
            // as well as client side errors (e.g. user is offline). Both situations
            // will display the same generic error for now.
            setSubmitState("ERROR");
        }
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $33ed200ba87fcf5c$export$2e2bcd8739ae039), {
        children: (closeDialog)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "whats-new-dialog",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("header", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "dialogs.whatsnew.heading",
                                defaultMessage: "What\u2019s new in Streetmix?\u200E"
                            })
                        })
                    }),
                    locale.startsWith("en") === false && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "whats-new-language-banner",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "dialogs.whatsnew.english-only",
                            defaultMessage: "This information is provided in English only."
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "dialog-content dialog-content-bleed",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                className: "whats-new-content",
                                onScroll: onScroll,
                                children: [
                                    state === "OK" && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $565501693a7c6ee6$export$7460c8b7e4ce9582), {
                                        allowedElements: [
                                            "p",
                                            "em",
                                            "strong",
                                            "ol",
                                            "ul",
                                            "li",
                                            "blockquote",
                                            "h1",
                                            "h2",
                                            "h3",
                                            "a",
                                            "img"
                                        ],
                                        unwrapDisallowed: true,
                                        urlTransform: (url)=>{
                                            return url.replace("/img/", "/images/");
                                        },
                                        rehypePlugins: [
                                            [
                                                (0, $fc5c74b62a0ad7be$export$2e2bcd8739ae039),
                                                {
                                                    rel: "noopener noreferrer",
                                                    target: "_blank"
                                                }
                                            ]
                                        ],
                                        children: content
                                    }),
                                    state === "LOADING" && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                        className: "whats-new-loading",
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $62d2815b920e2bc5$export$2e2bcd8739ae039), {})
                                    }),
                                    state === "ERROR" && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "generic-error-description",
                                            defaultMessage: "We\u2019re sorry \u2013 something went wrong."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                className: `whats-new-scroll-shade${scrollShade ? " visible" : ""}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
                        className: "dialog-primary-action",
                        onClick: closeDialog,
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "btn.close",
                            defaultMessage: "Close"
                        })
                    })
                ]
            })
    });
};
var $3c8e62993ba0e84f$export$2e2bcd8739ae039 = $3c8e62993ba0e84f$var$WhatsNewDialog;




var $4DE7A = parcelRequire("4DE7A");


var $4DE7A = parcelRequire("4DE7A");
var $9935f8dc37ededb4$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $9935f8dc37ededb4$var$isDateObject = (value1)=>value1 instanceof Date;
var $9935f8dc37ededb4$var$isNullOrUndefined = (value1)=>value1 == null;
const $9935f8dc37ededb4$var$isObjectType = (value1)=>typeof value1 === "object";
var $9935f8dc37ededb4$var$isObject = (value1)=>!$9935f8dc37ededb4$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $9935f8dc37ededb4$var$isObjectType(value1) && !$9935f8dc37ededb4$var$isDateObject(value1);
var $9935f8dc37ededb4$var$getEventValue = (event)=>$9935f8dc37ededb4$var$isObject(event) && event.target ? $9935f8dc37ededb4$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $9935f8dc37ededb4$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $9935f8dc37ededb4$var$isNameInFieldArray = (names, name)=>names.has($9935f8dc37ededb4$var$getNodeParentName(name));
var $9935f8dc37ededb4$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $9935f8dc37ededb4$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $9935f8dc37ededb4$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $9935f8dc37ededb4$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($9935f8dc37ededb4$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $9935f8dc37ededb4$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$9935f8dc37ededb4$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $9935f8dc37ededb4$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $9935f8dc37ededb4$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $9935f8dc37ededb4$var$isUndefined = (val)=>val === undefined;
var $9935f8dc37ededb4$export$3988ae62b71be9a3 = (obj, path, defaultValue)=>{
    if (!path || !$9935f8dc37ededb4$var$isObject(obj)) return defaultValue;
    const result = $9935f8dc37ededb4$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$9935f8dc37ededb4$var$isNullOrUndefined(result) ? result : result[key], obj);
    return $9935f8dc37ededb4$var$isUndefined(result) || result === obj ? $9935f8dc37ededb4$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
var $9935f8dc37ededb4$var$isBoolean = (value1)=>typeof value1 === "boolean";
const $9935f8dc37ededb4$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $9935f8dc37ededb4$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $9935f8dc37ededb4$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $9935f8dc37ededb4$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $9935f8dc37ededb4$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useContext($9935f8dc37ededb4$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $9935f8dc37ededb4$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement($9935f8dc37ededb4$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $9935f8dc37ededb4$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $9935f8dc37ededb4$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $9935f8dc37ededb4$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $9935f8dc37ededb4$var$isEmptyObject = (value1)=>$9935f8dc37ededb4$var$isObject(value1) && !Object.keys(value1).length;
var $9935f8dc37ededb4$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $9935f8dc37ededb4$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $9935f8dc37ededb4$var$VALIDATION_MODE.all));
};
var $9935f8dc37ededb4$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $9935f8dc37ededb4$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $9935f8dc37ededb4$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $9935f8dc37ededb4$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $9935f8dc37ededb4$export$606f11b2eb45ecc6(props) {
    const methods = $9935f8dc37ededb4$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef(name);
    _name.current = name;
    $9935f8dc37ededb4$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $9935f8dc37ededb4$var$shouldSubscribeByName(_name.current, value1.name, exact) && $9935f8dc37ededb4$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $9935f8dc37ededb4$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $9935f8dc37ededb4$var$isString = (value1)=>typeof value1 === "string";
var $9935f8dc37ededb4$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($9935f8dc37ededb4$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $9935f8dc37ededb4$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $9935f8dc37ededb4$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $9935f8dc37ededb4$export$3c773aa2b84f29e0(props) {
    const methods = $9935f8dc37ededb4$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef(name);
    _name.current = name;
    $9935f8dc37ededb4$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($9935f8dc37ededb4$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($9935f8dc37ededb4$var$cloneObject($9935f8dc37ededb4$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $9935f8dc37ededb4$var$isKey = (value1)=>/^\w*$/.test(value1);
var $9935f8dc37ededb4$var$stringToPath = (input)=>$9935f8dc37ededb4$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
function $9935f8dc37ededb4$export$adaa4cf7ef1b65be(object, path, value1) {
    let index = -1;
    const tempPath = $9935f8dc37ededb4$var$isKey(path) ? [
        path
    ] : $9935f8dc37ededb4$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $9935f8dc37ededb4$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $9935f8dc37ededb4$export$e8c786024a2b0a79(props) {
    const methods = $9935f8dc37ededb4$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $9935f8dc37ededb4$var$isNameInFieldArray(control._names.array, name);
    const value1 = $9935f8dc37ededb4$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $9935f8dc37ededb4$export$3988ae62b71be9a3(control._formValues, name, $9935f8dc37ededb4$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $9935f8dc37ededb4$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef(control.register(name, {
        ...props.rules,
        value: value1
    }));
    _registerProps.current = control.register(name, props.rules);
    (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $9935f8dc37ededb4$var$cloneObject($9935f8dc37ededb4$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $9935f8dc37ededb4$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($9935f8dc37ededb4$var$isUndefined($9935f8dc37ededb4$export$3988ae62b71be9a3(control._formValues, name))) $9935f8dc37ededb4$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useEffect(()=>{
        if ($9935f8dc37ededb4$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$9935f8dc37ededb4$var$isBoolean(disabled) ? {
                disabled: disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $9935f8dc37ededb4$var$getEventValue(event),
                        name: name
                    },
                    type: $9935f8dc37ededb4$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $9935f8dc37ededb4$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $9935f8dc37ededb4$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$9935f8dc37ededb4$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$9935f8dc37ededb4$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$9935f8dc37ededb4$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$9935f8dc37ededb4$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $9935f8dc37ededb4$export$bd0bf19f25da8474 = (props)=>props.render($9935f8dc37ededb4$export$e8c786024a2b0a79(props));
const $9935f8dc37ededb4$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $9935f8dc37ededb4$export$a7fed597f4b8afd8(props) {
    const methods = $9935f8dc37ededb4$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $9935f8dc37ededb4$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, $9935f8dc37ededb4$export$3988ae62b71be9a3(data, name));
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $9935f8dc37ededb4$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
const $9935f8dc37ededb4$var$focusFieldBy = (fields, callback, fieldsNames)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus) {
                    _f.ref.focus();
                    break;
                } else if (_f.refs && _f.refs[0].focus) {
                    _f.refs[0].focus();
                    break;
                }
            } else if ($9935f8dc37ededb4$var$isObject(currentField)) $9935f8dc37ededb4$var$focusFieldBy(currentField, callback);
        }
    }
};
var $9935f8dc37ededb4$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $9935f8dc37ededb4$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $9935f8dc37ededb4$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$9935f8dc37ededb4$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $9935f8dc37ededb4$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $9935f8dc37ededb4$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $9935f8dc37ededb4$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $9935f8dc37ededb4$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $9935f8dc37ededb4$var$VALIDATION_MODE.all,
        isOnTouch: mode === $9935f8dc37ededb4$var$VALIDATION_MODE.onTouched
    });
var $9935f8dc37ededb4$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
var $9935f8dc37ededb4$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $9935f8dc37ededb4$var$compact($9935f8dc37ededb4$export$3988ae62b71be9a3(errors, name));
    $9935f8dc37ededb4$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $9935f8dc37ededb4$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $9935f8dc37ededb4$var$isFileInput = (element)=>element.type === "file";
var $9935f8dc37ededb4$var$isFunction = (value1)=>typeof value1 === "function";
var $9935f8dc37ededb4$var$isHTMLElement = (value1)=>{
    if (!$9935f8dc37ededb4$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $9935f8dc37ededb4$var$isMessage = (value1)=>$9935f8dc37ededb4$var$isString(value1);
var $9935f8dc37ededb4$var$isRadioInput = (element)=>element.type === "radio";
var $9935f8dc37ededb4$var$isRegex = (value1)=>value1 instanceof RegExp;
const $9935f8dc37ededb4$var$defaultResult = {
    value: false,
    isValid: false
};
const $9935f8dc37ededb4$var$validResult = {
    value: true,
    isValid: true
};
var $9935f8dc37ededb4$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$9935f8dc37ededb4$var$isUndefined(options[0].attributes.value) ? $9935f8dc37ededb4$var$isUndefined(options[0].value) || options[0].value === "" ? $9935f8dc37ededb4$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $9935f8dc37ededb4$var$validResult : $9935f8dc37ededb4$var$defaultResult;
    }
    return $9935f8dc37ededb4$var$defaultResult;
};
const $9935f8dc37ededb4$var$defaultReturn = {
    isValid: false,
    value: null
};
var $9935f8dc37ededb4$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $9935f8dc37ededb4$var$defaultReturn) : $9935f8dc37ededb4$var$defaultReturn;
function $9935f8dc37ededb4$var$getValidateError(result, ref, type = "validate") {
    if ($9935f8dc37ededb4$var$isMessage(result) || Array.isArray(result) && result.every($9935f8dc37ededb4$var$isMessage) || $9935f8dc37ededb4$var$isBoolean(result) && !result) return {
        type: type,
        message: $9935f8dc37ededb4$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $9935f8dc37ededb4$var$getValueAndMessage = (validationData)=>$9935f8dc37ededb4$var$isObject(validationData) && !$9935f8dc37ededb4$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $9935f8dc37ededb4$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $9935f8dc37ededb4$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($9935f8dc37ededb4$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $9935f8dc37ededb4$var$isRadioInput(ref);
    const isCheckBox = $9935f8dc37ededb4$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $9935f8dc37ededb4$var$isFileInput(ref)) && $9935f8dc37ededb4$var$isUndefined(ref.value) && $9935f8dc37ededb4$var$isUndefined(inputValue) || $9935f8dc37ededb4$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $9935f8dc37ededb4$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $9935f8dc37ededb4$var$INPUT_VALIDATION_RULES.maxLength, minType = $9935f8dc37ededb4$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $9935f8dc37ededb4$var$isNullOrUndefined(inputValue)) || $9935f8dc37ededb4$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$9935f8dc37ededb4$var$getCheckboxValue(refs).isValid || isRadio && !$9935f8dc37ededb4$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $9935f8dc37ededb4$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $9935f8dc37ededb4$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $9935f8dc37ededb4$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($9935f8dc37ededb4$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$9935f8dc37ededb4$var$isNullOrUndefined(min) || !$9935f8dc37ededb4$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $9935f8dc37ededb4$var$getValueAndMessage(max);
        const minOutput = $9935f8dc37ededb4$var$getValueAndMessage(min);
        if (!$9935f8dc37ededb4$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$9935f8dc37ededb4$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$9935f8dc37ededb4$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($9935f8dc37ededb4$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($9935f8dc37ededb4$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $9935f8dc37ededb4$var$INPUT_VALIDATION_RULES.max, $9935f8dc37ededb4$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($9935f8dc37ededb4$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $9935f8dc37ededb4$var$getValueAndMessage(maxLength);
        const minLengthOutput = $9935f8dc37ededb4$var$getValueAndMessage(minLength);
        const exceedMax = !$9935f8dc37ededb4$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$9935f8dc37ededb4$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $9935f8dc37ededb4$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $9935f8dc37ededb4$var$getValueAndMessage(pattern);
        if ($9935f8dc37ededb4$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $9935f8dc37ededb4$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($9935f8dc37ededb4$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($9935f8dc37ededb4$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $9935f8dc37ededb4$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($9935f8dc37ededb4$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($9935f8dc37ededb4$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$9935f8dc37ededb4$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $9935f8dc37ededb4$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$9935f8dc37ededb4$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
function $9935f8dc37ededb4$var$append(data, value1) {
    return [
        ...data,
        ...$9935f8dc37ededb4$var$convertToArrayPayload(value1)
    ];
}
var $9935f8dc37ededb4$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $9935f8dc37ededb4$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$9935f8dc37ededb4$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $9935f8dc37ededb4$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($9935f8dc37ededb4$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
function $9935f8dc37ededb4$var$prepend(data, value1) {
    return [
        ...$9935f8dc37ededb4$var$convertToArrayPayload(value1),
        ...$9935f8dc37ededb4$var$convertToArrayPayload(data)
    ];
}
function $9935f8dc37ededb4$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $9935f8dc37ededb4$var$compact(temp).length ? temp : [];
}
var $9935f8dc37ededb4$var$removeArrayAt = (data, index)=>$9935f8dc37ededb4$var$isUndefined(index) ? [] : $9935f8dc37ededb4$var$removeAtIndexes(data, $9935f8dc37ededb4$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $9935f8dc37ededb4$var$swapArrayAt = (data, indexA, indexB)=>{
    data[indexA] = [
        data[indexB],
        data[indexB] = data[indexA]
    ][0];
};
function $9935f8dc37ededb4$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $9935f8dc37ededb4$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $9935f8dc37ededb4$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$9935f8dc37ededb4$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $9935f8dc37ededb4$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $9935f8dc37ededb4$var$isKey(path) ? [
        path
    ] : $9935f8dc37ededb4$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $9935f8dc37ededb4$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($9935f8dc37ededb4$var$isObject(childObject) && $9935f8dc37ededb4$var$isEmptyObject(childObject) || Array.isArray(childObject) && $9935f8dc37ededb4$var$isEmptyArray(childObject))) $9935f8dc37ededb4$var$unset(object, paths.slice(0, -1));
    return object;
}
var $9935f8dc37ededb4$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $9935f8dc37ededb4$export$310131896651d559(props) {
    const methods = $9935f8dc37ededb4$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef(control._getFieldArray(name).map($9935f8dc37ededb4$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $9935f8dc37ededb4$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $9935f8dc37ededb4$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($9935f8dc37ededb4$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append$1 = (value1, options)=>{
        const appendValue = $9935f8dc37ededb4$var$convertToArrayPayload($9935f8dc37ededb4$var$cloneObject(value1));
        const updatedFieldArrayValues = $9935f8dc37ededb4$var$append(control._getFieldArray(name), appendValue);
        control._names.focus = $9935f8dc37ededb4$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $9935f8dc37ededb4$var$append(ids.current, appendValue.map($9935f8dc37ededb4$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $9935f8dc37ededb4$var$append, {
            argA: $9935f8dc37ededb4$var$fillEmptyArray(value1)
        });
    };
    const prepend$1 = (value1, options)=>{
        const prependValue = $9935f8dc37ededb4$var$convertToArrayPayload($9935f8dc37ededb4$var$cloneObject(value1));
        const updatedFieldArrayValues = $9935f8dc37ededb4$var$prepend(control._getFieldArray(name), prependValue);
        control._names.focus = $9935f8dc37ededb4$var$getFocusFieldName(name, 0, options);
        ids.current = $9935f8dc37ededb4$var$prepend(ids.current, prependValue.map($9935f8dc37ededb4$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $9935f8dc37ededb4$var$prepend, {
            argA: $9935f8dc37ededb4$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $9935f8dc37ededb4$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $9935f8dc37ededb4$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $9935f8dc37ededb4$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $9935f8dc37ededb4$var$convertToArrayPayload($9935f8dc37ededb4$var$cloneObject(value1));
        const updatedFieldArrayValues = $9935f8dc37ededb4$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $9935f8dc37ededb4$var$getFocusFieldName(name, index, options);
        ids.current = $9935f8dc37ededb4$var$insert(ids.current, index, insertValue.map($9935f8dc37ededb4$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $9935f8dc37ededb4$var$insert, {
            argA: index,
            argB: $9935f8dc37ededb4$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $9935f8dc37ededb4$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $9935f8dc37ededb4$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $9935f8dc37ededb4$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $9935f8dc37ededb4$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $9935f8dc37ededb4$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $9935f8dc37ededb4$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $9935f8dc37ededb4$var$cloneObject(value1);
        const updatedFieldArrayValues = $9935f8dc37ededb4$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $9935f8dc37ededb4$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $9935f8dc37ededb4$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $9935f8dc37ededb4$var$convertToArrayPayload($9935f8dc37ededb4$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($9935f8dc37ededb4$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useEffect(()=>{
        control._state.action = false;
        $9935f8dc37ededb4$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$9935f8dc37ededb4$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $9935f8dc37ededb4$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $9935f8dc37ededb4$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $9935f8dc37ededb4$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $9935f8dc37ededb4$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) $9935f8dc37ededb4$var$validateField(field, control._formValues, control._options.criteriaMode === $9935f8dc37ededb4$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$9935f8dc37ededb4$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $9935f8dc37ededb4$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $9935f8dc37ededb4$var$focusFieldBy(control._fields, (key)=>!!key && key.startsWith(control._names.focus || ""));
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useEffect(()=>{
        !$9935f8dc37ededb4$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useCallback(prepend$1, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useCallback(append$1, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $9935f8dc37ededb4$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
function $9935f8dc37ededb4$var$createSubject() {
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
}
var $9935f8dc37ededb4$var$isPrimitive = (value1)=>$9935f8dc37ededb4$var$isNullOrUndefined(value1) || !$9935f8dc37ededb4$var$isObjectType(value1);
function $9935f8dc37ededb4$var$deepEqual(object1, object2) {
    if ($9935f8dc37ededb4$var$isPrimitive(object1) || $9935f8dc37ededb4$var$isPrimitive(object2)) return object1 === object2;
    if ($9935f8dc37ededb4$var$isDateObject(object1) && $9935f8dc37ededb4$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($9935f8dc37ededb4$var$isDateObject(val1) && $9935f8dc37ededb4$var$isDateObject(val2) || $9935f8dc37ededb4$var$isObject(val1) && $9935f8dc37ededb4$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$9935f8dc37ededb4$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $9935f8dc37ededb4$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $9935f8dc37ededb4$var$isRadioOrCheckbox = (ref)=>$9935f8dc37ededb4$var$isRadioInput(ref) || $9935f8dc37ededb4$var$isCheckBoxInput(ref);
var $9935f8dc37ededb4$var$live = (ref)=>$9935f8dc37ededb4$var$isHTMLElement(ref) && ref.isConnected;
var $9935f8dc37ededb4$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($9935f8dc37ededb4$var$isFunction(data[key])) return true;
    }
    return false;
};
function $9935f8dc37ededb4$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($9935f8dc37ededb4$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $9935f8dc37ededb4$var$isObject(data[key]) && !$9935f8dc37ededb4$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $9935f8dc37ededb4$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$9935f8dc37ededb4$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $9935f8dc37ededb4$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($9935f8dc37ededb4$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $9935f8dc37ededb4$var$isObject(data[key]) && !$9935f8dc37ededb4$var$objectHasFunction(data[key])) {
            if ($9935f8dc37ededb4$var$isUndefined(formValues) || $9935f8dc37ededb4$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $9935f8dc37ededb4$var$markFieldsDirty(data[key], []) : {
                ...$9935f8dc37ededb4$var$markFieldsDirty(data[key])
            };
            else $9935f8dc37ededb4$var$getDirtyFieldsFromDefaultValues(data[key], $9935f8dc37ededb4$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$9935f8dc37ededb4$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $9935f8dc37ededb4$var$getDirtyFields = (defaultValues, formValues)=>$9935f8dc37ededb4$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $9935f8dc37ededb4$var$markFieldsDirty(formValues));
var $9935f8dc37ededb4$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$9935f8dc37ededb4$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $9935f8dc37ededb4$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $9935f8dc37ededb4$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($9935f8dc37ededb4$var$isFileInput(ref)) return ref.files;
    if ($9935f8dc37ededb4$var$isRadioInput(ref)) return $9935f8dc37ededb4$var$getRadioValue(_f.refs).value;
    if ($9935f8dc37ededb4$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($9935f8dc37ededb4$var$isCheckBoxInput(ref)) return $9935f8dc37ededb4$var$getCheckboxValue(_f.refs).value;
    return $9935f8dc37ededb4$var$getFieldValueAs($9935f8dc37ededb4$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $9935f8dc37ededb4$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name);
        field && $9935f8dc37ededb4$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $9935f8dc37ededb4$var$getRuleValue = (rule)=>$9935f8dc37ededb4$var$isUndefined(rule) ? rule : $9935f8dc37ededb4$var$isRegex(rule) ? rule.source : $9935f8dc37ededb4$var$isObject(rule) ? $9935f8dc37ededb4$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $9935f8dc37ededb4$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $9935f8dc37ededb4$var$schemaErrorLookup(errors, _fields, name) {
    const error = $9935f8dc37ededb4$export$3988ae62b71be9a3(errors, name);
    if (error || $9935f8dc37ededb4$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $9935f8dc37ededb4$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $9935f8dc37ededb4$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $9935f8dc37ededb4$var$unsetEmptyArray = (ref, name)=>!$9935f8dc37ededb4$var$compact($9935f8dc37ededb4$export$3988ae62b71be9a3(ref, name)).length && $9935f8dc37ededb4$var$unset(ref, name);
const $9935f8dc37ededb4$var$defaultOptions = {
    mode: $9935f8dc37ededb4$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $9935f8dc37ededb4$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $9935f8dc37ededb4$var$createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...$9935f8dc37ededb4$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $9935f8dc37ededb4$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {}
    };
    let _fields = {};
    let _defaultValues = $9935f8dc37ededb4$var$isObject(_options.defaultValues) || $9935f8dc37ededb4$var$isObject(_options.values) ? $9935f8dc37ededb4$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $9935f8dc37ededb4$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $9935f8dc37ededb4$var$createSubject(),
        array: $9935f8dc37ededb4$var$createSubject(),
        state: $9935f8dc37ededb4$var$createSubject()
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    const validationModeBeforeSubmit = $9935f8dc37ededb4$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $9935f8dc37ededb4$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $9935f8dc37ededb4$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $9935f8dc37ededb4$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (value1)=>_proxyFormState.isValidating && _subjects.state.next({
            isValidating: value1
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($9935f8dc37ededb4$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($9935f8dc37ededb4$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $9935f8dc37ededb4$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($9935f8dc37ededb4$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($9935f8dc37ededb4$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $9935f8dc37ededb4$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $9935f8dc37ededb4$export$3988ae62b71be9a3(_formValues, name, $9935f8dc37ededb4$var$isUndefined(value1) ? $9935f8dc37ededb4$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $9935f8dc37ededb4$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $9935f8dc37ededb4$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = $9935f8dc37ededb4$var$deepEqual($9935f8dc37ededb4$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = $9935f8dc37ededb4$export$3988ae62b71be9a3(_formState.dirtyFields, name);
            isCurrentFieldPristine ? $9935f8dc37ededb4$var$unset(_formState.dirtyFields, name) : $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $9935f8dc37ededb4$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $9935f8dc37ededb4$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $9935f8dc37ededb4$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $9935f8dc37ededb4$var$unset(_formState.errors, name);
        }
        if ((error ? !$9935f8dc37ededb4$var$deepEqual(previousFieldError, error) : previousFieldError) || !$9935f8dc37ededb4$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $9935f8dc37ededb4$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name)=>_options.resolver(_formValues, _options.context, $9935f8dc37ededb4$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $9935f8dc37ededb4$export$3988ae62b71be9a3(errors, name);
            error ? $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $9935f8dc37ededb4$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await $9935f8dc37ededb4$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($9935f8dc37ededb4$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $9935f8dc37ededb4$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $9935f8dc37ededb4$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$9935f8dc37ededb4$var$live(ref)) : !$9935f8dc37ededb4$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formValues, name, data), !$9935f8dc37ededb4$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$9935f8dc37ededb4$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $9935f8dc37ededb4$var$isUndefined(defaultValue) ? _defaultValues : $9935f8dc37ededb4$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$9935f8dc37ededb4$var$compact($9935f8dc37ededb4$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $9935f8dc37ededb4$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formValues, name, $9935f8dc37ededb4$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $9935f8dc37ededb4$var$isHTMLElement(fieldReference.ref) && $9935f8dc37ededb4$var$isNullOrUndefined(value1) ? "" : value1;
                if ($9935f8dc37ededb4$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($9935f8dc37ededb4$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($9935f8dc37ededb4$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$9935f8dc37ededb4$var$isPrimitive(fieldValue) || field && !field._f) && !$9935f8dc37ededb4$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $9935f8dc37ededb4$var$cloneObject(value1);
        $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $9935f8dc37ededb4$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$9935f8dc37ededb4$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $9935f8dc37ededb4$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: name,
            values: {
                ..._formValues
            }
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $9935f8dc37ededb4$var$getFieldValue(field._f) : $9935f8dc37ededb4$var$getEventValue(event);
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $9935f8dc37ededb4$var$EVENTS.BLUR || event.type === $9935f8dc37ededb4$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$9935f8dc37ededb4$var$hasValidation(field._f) && !_options.resolver && !$9935f8dc37ededb4$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $9935f8dc37ededb4$var$skipValidation(isBlurEvent, $9935f8dc37ededb4$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $9935f8dc37ededb4$var$isWatched(name, _names, isBlurEvent);
            $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$9935f8dc37ededb4$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                const previousErrorLookupResult = $9935f8dc37ededb4$var$schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = $9935f8dc37ededb4$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = $9935f8dc37ededb4$var$isEmptyObject(errors);
            } else {
                error = (await $9935f8dc37ededb4$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === $9935f8dc37ededb4$export$3988ae62b71be9a3(_formValues, name, fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $9935f8dc37ededb4$var$convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($9935f8dc37ededb4$var$isUndefined(name) ? name : fieldNames);
            isValid = $9935f8dc37ededb4$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$9935f8dc37ededb4$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$9935f8dc37ededb4$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors,
            isValidating: false
        });
        options.shouldFocus && !validationResult && $9935f8dc37ededb4$var$focusFieldBy(_fields, (key)=>key && $9935f8dc37ededb4$export$3988ae62b71be9a3(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return $9935f8dc37ededb4$var$isUndefined(fieldNames) ? values : $9935f8dc37ededb4$var$isString(fieldNames) ? $9935f8dc37ededb4$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$9935f8dc37ededb4$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$9935f8dc37ededb4$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$9935f8dc37ededb4$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$9935f8dc37ededb4$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $9935f8dc37ededb4$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $9935f8dc37ededb4$var$convertToArrayPayload(name).forEach((inputName)=>$9935f8dc37ededb4$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$9935f8dc37ededb4$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $9935f8dc37ededb4$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $9935f8dc37ededb4$var$unset(_fields, fieldName);
                $9935f8dc37ededb4$var$unset(_formValues, fieldName);
            }
            !options.keepError && $9935f8dc37ededb4$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $9935f8dc37ededb4$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $9935f8dc37ededb4$var$unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $9935f8dc37ededb4$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields })=>{
        if ($9935f8dc37ededb4$var$isBoolean(disabled)) {
            const value1 = disabled ? undefined : $9935f8dc37ededb4$export$3988ae62b71be9a3(_formValues, name, $9935f8dc37ededb4$var$getFieldValue(field ? field._f : $9935f8dc37ededb4$export$3988ae62b71be9a3(fields, name)._f));
            $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_formValues, name, value1);
            updateTouchAndDirty(name, value1, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $9935f8dc37ededb4$var$isBoolean(options.disabled);
        $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $9935f8dc37ededb4$var$getRuleValue(options.min),
                max: $9935f8dc37ededb4$var$getRuleValue(options.max),
                minLength: $9935f8dc37ededb4$var$getRuleValue(options.minLength),
                maxLength: $9935f8dc37ededb4$var$getRuleValue(options.maxLength),
                pattern: $9935f8dc37ededb4$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $9935f8dc37ededb4$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $9935f8dc37ededb4$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($9935f8dc37ededb4$var$live),
                                    fieldRef,
                                    ...Array.isArray($9935f8dc37ededb4$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($9935f8dc37ededb4$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $9935f8dc37ededb4$var$focusFieldBy(_fields, (key)=>key && $9935f8dc37ededb4$export$3988ae62b71be9a3(_formState.errors, key), _names.mount);
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $9935f8dc37ededb4$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $9935f8dc37ededb4$var$unset(_formState.errors, "root");
            if ($9935f8dc37ededb4$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                await onValid(fieldValues, e);
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $9935f8dc37ededb4$var$isEmptyObject(_formState.errors),
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
        };
    const resetField = (name, options = {})=>{
        if ($9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name)) {
            if ($9935f8dc37ededb4$var$isUndefined(options.defaultValue)) setValue(name, $9935f8dc37ededb4$export$3988ae62b71be9a3(_defaultValues, name));
            else {
                setValue(name, options.defaultValue);
                $9935f8dc37ededb4$export$adaa4cf7ef1b65be(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) $9935f8dc37ededb4$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $9935f8dc37ededb4$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $9935f8dc37ededb4$export$3988ae62b71be9a3(_defaultValues, name)) : _getDirty();
            }
            if (!options.keepError) {
                $9935f8dc37ededb4$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $9935f8dc37ededb4$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $9935f8dc37ededb4$var$cloneObject(updatedValues);
        const values = formValues && !$9935f8dc37ededb4$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) for (const fieldName of _names.mount)$9935f8dc37ededb4$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $9935f8dc37ededb4$export$adaa4cf7ef1b65be(values, fieldName, $9935f8dc37ededb4$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $9935f8dc37ededb4$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($9935f8dc37ededb4$var$isWeb && $9935f8dc37ededb4$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($9935f8dc37ededb4$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $9935f8dc37ededb4$var$cloneObject(_defaultValues) : {} : $9935f8dc37ededb4$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$9935f8dc37ededb4$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $9935f8dc37ededb4$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($9935f8dc37ededb4$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $9935f8dc37ededb4$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$9935f8dc37ededb4$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $9935f8dc37ededb4$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $9935f8dc37ededb4$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        defaultValues: $9935f8dc37ededb4$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$9935f8dc37ededb4$var$createFormControl(props, ()=>updateFormState((formState)=>({
                    ...formState
                }))),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $9935f8dc37ededb4$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($9935f8dc37ededb4$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useEffect(()=>{
        if (props.values && !$9935f8dc37ededb4$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $9935f8dc37ededb4$var$getProxyFormState(formState, control);
    return _formControl.current;
}





/**
 * Converts a JavaScript object of key-value pairs (which is the format of
 * a given payload from react-hook-form's `handleSubmit()`) into a string
 * that would normally be submitted by a form to an endpoint that expects
 * a 'application/x-www-form-urlencoded' MIME-type. This function is generic
 * and can be ported to a common utility module if we ever need it in more
 * than one place.
 *
 * @param {Object} data - provided by react-hook-form's `handleSubmit()`
 * @returns {string} - data expected by the newsletter POST endpoint
 */ function $557a3dd332259238$var$jsObjectToFormBody(data) {
    const formBody = [];
    for(const property in data){
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(data[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    return formBody.join("&");
}
const $557a3dd332259238$var$NewsletterDialog = (props)=>{
    const { register: register, handleSubmit: handleSubmit } = (0, $9935f8dc37ededb4$export$87c0cf8eb5a167e0)({
        progressive: true
    });
    const [submitState, setSubmitState] = (0, $4DE7A.useState)("DEFAULT");
    const onSubmit = async (data)=>{
        setSubmitState("PENDING");
        const formBody = $557a3dd332259238$var$jsObjectToFormBody(data);
        try {
            const res = await window.fetch("https://buttondown.email/api/emails/embed-subscribe/streetmix", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: formBody
            });
            if (res.status === 200) setSubmitState("OK");
            else // Errors are generic for now.
            setSubmitState("ERROR");
        } catch (err) {
            // The error handling in the try block handles failures on the remote
            // server (e.g. 404, 500, etc). The error handling in the catch block
            // handles failures if the fetch fails on the client side (e.g. user is
            // offline). Both situations will display the same generic error for now.
            setSubmitState("ERROR");
        }
    };
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $33ed200ba87fcf5c$export$2e2bcd8739ae039), {
        children: (closeDialog)=>{
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "newsletter-dialog",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("header", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "dialogs.newsletter.heading",
                                defaultMessage: "Subscribe to our newsletter"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "dialog-content",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "dialogs.newsletter.description",
                                    defaultMessage: "We send occasional email updates through our newsletter, just several times a year. Sign up to ensure you don\u2019t miss a thing!"
                                })
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("form", {
                                onSubmit: handleSubmit(onSubmit),
                                children: [
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("label", {
                                        htmlFor: "bd-email",
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "dialogs.newsletter.email-label",
                                            defaultMessage: "Enter your email"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("input", {
                                        type: "email",
                                        name: "email",
                                        id: "bd-email",
                                        placeholder: "test@example.com",
                                        ...register("email", {
                                            required: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("input", {
                                        type: "hidden",
                                        name: "tag",
                                        value: "via app",
                                        ...register("tag")
                                    }),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("input", {
                                        type: "hidden",
                                        name: "embed",
                                        value: "1",
                                        ...register("embed")
                                    }),
                                    submitState === "DEFAULT" && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                        className: "subscribe-buttons",
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                            primary: true,
                                            type: "submit",
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                id: "dialogs.newsletter.subscribe",
                                                defaultMessage: "Subscribe"
                                            })
                                        })
                                    }),
                                    submitState === "PENDING" && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                        className: "subscribe-buttons",
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                            disabled: true,
                                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                id: "dialogs.newsletter.subscribe-pending",
                                                defaultMessage: "Please wait..."
                                            })
                                        })
                                    }),
                                    submitState === "OK" && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "dialogs.newsletter.ok-message",
                                                    defaultMessage: "<strong>Thank you! You\u2019re almost subscribed.</strong> We\u2019ve sent you an email to confirm your address. Click it and you\u2019re in!",
                                                    values: {
                                                        // eslint-disable-next-line react/display-name
                                                        strong: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("strong", {
                                                                children: chunks
                                                            })
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                                className: "subscribe-buttons",
                                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                                    onClick: closeDialog,
                                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                        id: "btn.close",
                                                        defaultMessage: "Close"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    submitState === "ERROR" && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                                className: "subscribe-error",
                                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                    id: "dialogs.newsletter.error-message",
                                                    defaultMessage: "Uh oh! Something went wrong with the subscription process. This might be a temporary system error. Please try again later!"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                                className: "subscribe-buttons",
                                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                                    primary: true,
                                                    type: "submit",
                                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                        id: "dialogs.newsletter.subscribe",
                                                        defaultMessage: "Subscribe"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
};
var $557a3dd332259238$export$2e2bcd8739ae039 = $557a3dd332259238$var$NewsletterDialog;




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");






const $67a49accb7fb1b45$var$DEFAULT_BODY = "Thank you for using Streetmix! For only $5/month, the Enthusiast Plan lets users support Streetmix while also gaining access to new experimental features. Plus your avatar gets a neat badge!";
const $67a49accb7fb1b45$var$UpgradeDialog = ({ userId: userId, roles: roles })=>{
    const [loading, setLoading] = (0, $4DE7A.useState)(false);
    const [error, setError] = (0, $4DE7A.useState)(null);
    const [data, setData] = (0, $4DE7A.useState)(null);
    const hasTier1 = roles.includes((0, (/*@__PURE__*/$parcel$interopDefault($98448114ff4d3ef1$exports))).SUBSCRIBER_1.value);
    // eslint-disable-next-line
    async function onToken(token) {
        const requestBody = {
            userId: userId,
            token: token
        };
        setLoading(true);
        try {
            const { data: data } = await (0, $c4e1eb2fba6bd6ed$export$2e2bcd8739ae039).post("/services/pay", requestBody);
            setData(data);
        } catch (err) {
            setError(err);
        }
        setLoading(false);
    }
    let activePanel;
    if (hasTier1) activePanel = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "upgrade.hasTier1",
            defaultMessage: "Thanks for supporting Streetmix!"
        })
    });
    else if (loading) activePanel = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "upgrade.loading",
            defaultMessage: "Loading..."
        })
    });
    else if (error) activePanel = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "upgrade.error",
                defaultMessage: "We encountered an error:"
            }),
            error
        ]
    });
    else if (data) activePanel = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "upgrade.success",
            defaultMessage: "Thank you! Please refresh this page to see your upgrades."
        })
    });
    else activePanel = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6dd45a7735069a79$exports.Fragment), {
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "upgrade.body",
                defaultMessage: $67a49accb7fb1b45$var$DEFAULT_BODY
            })
        })
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $33ed200ba87fcf5c$export$2e2bcd8739ae039), {
        children: (closeDialog)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "upgrade-dialog",
                dir: "ltr",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("header", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "upgrade.title",
                                defaultMessage: "Upgrade"
                            })
                        })
                    }),
                    activePanel
                ]
            })
    });
};
function $67a49accb7fb1b45$var$mapStateToProps(state) {
    const { userId: userId } = state.user.signInData || {};
    const roles = state.user.signInData?.details?.roles || [];
    return {
        userId: userId,
        roles: roles
    };
}
$67a49accb7fb1b45$var$UpgradeDialog.propTypes = {
    userId: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string.isRequired,
    roles: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string).isRequired
};
var $67a49accb7fb1b45$export$2e2bcd8739ae039 = (0, $a4829965bb94612b$export$2e2bcd8739ae039)($67a49accb7fb1b45$var$mapStateToProps)($67a49accb7fb1b45$var$UpgradeDialog);



parcelRequire("4DE7A");




function $6aa140b895cb43f6$var$SentimentSurveyDialog(props) {
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $33ed200ba87fcf5c$export$2e2bcd8739ae039), {
        children: (closeDialog)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "sentiment-survey-about-dialog",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "dialog-content",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h3", {
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "sentiment.about-header",
                                    defaultMessage: "We want to understand how people feel about streets"
                                })
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "sentiment.about-article.paragraph-1",
                                    defaultMessage: "Many streets are designed by civil engineers, but we believe that design should include everyone\u2019s point of view. In partnership with the <a>New Urban Mobility Alliance</a> (NUMO), we\u2019re conducting this one-question survey to do just that.",
                                    values: {
                                        // eslint-disable-next-line react/display-name
                                        a: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                                href: "https://www.numo.global/",
                                                children: chunks
                                            })
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "sentiment.about-article.paragraph-2",
                                    defaultMessage: "We will analyze your responses so that we can infer which street characteristics will induce which feelings. In the future, we plan to incorporate these insights back into design recommendations for Streetmix users."
                                })
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "sentiment.about-article.paragraph-3",
                                    defaultMessage: "You can only vote once per street, but you can encourage others to cast their own vote by sharing your streets or a random street with the link <a>https://streetmix.net/survey/</a>.",
                                    values: {
                                        // eslint-disable-next-line react/display-name
                                        a: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                                                href: "https://streetmix.net/survey/",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: chunks
                                            })
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
                        className: "dialog-primary-action",
                        onClick: closeDialog,
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "btn.okay",
                            defaultMessage: "Okay!"
                        })
                    })
                ]
            })
    });
}
var $6aa140b895cb43f6$export$2e2bcd8739ae039 = $6aa140b895cb43f6$var$SentimentSurveyDialog;



parcelRequire("4DE7A");




/**
 * The error dialog is displayed in place of another dialog if something
 * goes wrong in the other dialog.
 *
 * If _this_ component throws an error, the universe blows up.
 */ function $8b4e42d65ae5c137$var$ErrorDialog(props) {
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $33ed200ba87fcf5c$export$2e2bcd8739ae039), {
        children: (closeDialog)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "dialog-error",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("header", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "dialogs.error.heading",
                                defaultMessage: "Oops!"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "dialog-content",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "dialogs.error.text",
                                defaultMessage: "Something unexpected happened \uD83D\uDE22. We\u2019ve logged the error, but if you can remember what happened on the way here, <a>please tell us about it</a>. This could also be a temporary problem, so please try one more time.",
                                values: {
                                    // eslint-disable-next-line react/display-name
                                    a: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                            href: "https://github.com/streetmix/streetmix/issues/new",
                                            children: chunks
                                        })
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
                        className: "dialog-primary-action",
                        onClick: closeDialog,
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "btn.close",
                            defaultMessage: "Close"
                        })
                    })
                ]
            })
    });
}
var $8b4e42d65ae5c137$export$2e2bcd8739ae039 = $8b4e42d65ae5c137$var$ErrorDialog;


const $4ee6e5a0b0b769a7$var$DIALOG_COMPONENTS = {
    ABOUT: (0, $3b091dd2036ada6f$export$2e2bcd8739ae039),
    ANALYTICS: (0, $fd7ddb8da442b787$export$2e2bcd8739ae039),
    FEATURE_FLAGS: (0, $4aa8b2e155366235$export$2e2bcd8739ae039),
    GEOTAG: (0, $567607fb3af07abf$export$2e2bcd8739ae039),
    SAVE_AS_IMAGE: (0, $b4ecdd2ce7605a57$export$2e2bcd8739ae039),
    SETTINGS: (0, $54dced87cf1606c2$export$2e2bcd8739ae039),
    SIGN_IN: (0, $26ab41e3a7b01a4f$export$2e2bcd8739ae039),
    WHATS_NEW: (0, $3c8e62993ba0e84f$export$2e2bcd8739ae039),
    NEWSLETTER: (0, $557a3dd332259238$export$2e2bcd8739ae039),
    UPGRADE: (0, $67a49accb7fb1b45$export$2e2bcd8739ae039),
    SENTIMENT_SURVEY: (0, $6aa140b895cb43f6$export$2e2bcd8739ae039)
};
function $4ee6e5a0b0b769a7$var$DialogRoot(props) {
    const name = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.dialogs.name);
    // Bail if no dialog name is provided
    if (!name) return null;
    // Get the dialog we want, then render it
    const Dialog = $4ee6e5a0b0b769a7$var$DIALOG_COMPONENTS[name];
    // Wrap Dialog with an ErrorBoundary wrapper to catch errors
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d95a0e0635013952$export$2e2bcd8739ae039), {
        fallbackElement: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $8b4e42d65ae5c137$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)(Dialog, {})
    });
}
var $4ee6e5a0b0b769a7$export$2e2bcd8739ae039 = $4ee6e5a0b0b769a7$var$DialogRoot;



parcelRequire("4DE7A");



var $6177c5d530cbfa68$exports = {};
"use strict";
var $b22145cffc394ae8$exports = {};
"use strict";
function $b22145cffc394ae8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b22145cffc394ae8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b22145cffc394ae8$var$_typeof(obj);
}
Object.defineProperty($b22145cffc394ae8$exports, "__esModule", {
    value: true
});
Object.defineProperty($b22145cffc394ae8$exports, "DraggableCore", {
    enumerable: true,
    get: function get() {
        return $b22145cffc394ae8$var$_DraggableCore.default;
    }
});
$b22145cffc394ae8$exports.default = void 0;

var $b22145cffc394ae8$var$React = $b22145cffc394ae8$var$_interopRequireWildcard((parcelRequire("4DE7A")));

var $b22145cffc394ae8$var$_propTypes = $b22145cffc394ae8$var$_interopRequireDefault((parcelRequire("fmSD5")));

var $b22145cffc394ae8$var$_reactDom = $b22145cffc394ae8$var$_interopRequireDefault((parcelRequire("gv34t")));

var $b22145cffc394ae8$var$_clsx2 = $b22145cffc394ae8$var$_interopRequireDefault((parcelRequire("ccOiY")));

var $aZZKx = parcelRequire("aZZKx");

var $kNRmj = parcelRequire("kNRmj");

var $euSu7 = parcelRequire("euSu7");

var $b22145cffc394ae8$var$_DraggableCore = $b22145cffc394ae8$var$_interopRequireDefault((parcelRequire("eOfHa")));

var $b22145cffc394ae8$var$_log = $b22145cffc394ae8$var$_interopRequireDefault((parcelRequire("9jJTo")));
var $b22145cffc394ae8$var$_excluded = [
    "axis",
    "bounds",
    "children",
    "defaultPosition",
    "defaultClassName",
    "defaultClassNameDragging",
    "defaultClassNameDragged",
    "position",
    "positionOffset",
    "scale"
];
function $b22145cffc394ae8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b22145cffc394ae8$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b22145cffc394ae8$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b22145cffc394ae8$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $b22145cffc394ae8$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b22145cffc394ae8$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b22145cffc394ae8$var$_extends() {
    $b22145cffc394ae8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b22145cffc394ae8$var$_extends.apply(this, arguments);
}
function $b22145cffc394ae8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b22145cffc394ae8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b22145cffc394ae8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b22145cffc394ae8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b22145cffc394ae8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b22145cffc394ae8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b22145cffc394ae8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b22145cffc394ae8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b22145cffc394ae8$var$_slicedToArray(arr, i) {
    return $b22145cffc394ae8$var$_arrayWithHoles(arr) || $b22145cffc394ae8$var$_iterableToArrayLimit(arr, i) || $b22145cffc394ae8$var$_unsupportedIterableToArray(arr, i) || $b22145cffc394ae8$var$_nonIterableRest();
}
function $b22145cffc394ae8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b22145cffc394ae8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b22145cffc394ae8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b22145cffc394ae8$var$_arrayLikeToArray(o, minLen);
}
function $b22145cffc394ae8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b22145cffc394ae8$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b22145cffc394ae8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b22145cffc394ae8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b22145cffc394ae8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b22145cffc394ae8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b22145cffc394ae8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b22145cffc394ae8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b22145cffc394ae8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $b22145cffc394ae8$var$_setPrototypeOf(subClass, superClass);
}
function $b22145cffc394ae8$var$_setPrototypeOf(o, p) {
    $b22145cffc394ae8$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b22145cffc394ae8$var$_setPrototypeOf(o, p);
}
function $b22145cffc394ae8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b22145cffc394ae8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b22145cffc394ae8$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b22145cffc394ae8$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b22145cffc394ae8$var$_possibleConstructorReturn(this, result);
    };
}
function $b22145cffc394ae8$var$_possibleConstructorReturn(self, call) {
    if (call && ($b22145cffc394ae8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b22145cffc394ae8$var$_assertThisInitialized(self);
}
function $b22145cffc394ae8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b22145cffc394ae8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b22145cffc394ae8$var$_getPrototypeOf(o) {
    $b22145cffc394ae8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b22145cffc394ae8$var$_getPrototypeOf(o);
}
function $b22145cffc394ae8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
//
// Define <Draggable>
//
var $b22145cffc394ae8$var$Draggable = /*#__PURE__*/ function(_React$Component) {
    $b22145cffc394ae8$var$_inherits(Draggable, _React$Component);
    var _super = $b22145cffc394ae8$var$_createSuper(Draggable);
    function Draggable(props) {
        var _this;
        $b22145cffc394ae8$var$_classCallCheck(this, Draggable);
        _this = _super.call(this, props);
        $b22145cffc394ae8$var$_defineProperty($b22145cffc394ae8$var$_assertThisInitialized(_this), "onDragStart", function(e, coreData) {
            (0, $b22145cffc394ae8$var$_log.default)("Draggable: onDragStart: %j", coreData); // Short-circuit if user's callback killed it.
            var shouldStart = _this.props.onStart(e, (0, $kNRmj.createDraggableData)($b22145cffc394ae8$var$_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            _this.setState({
                dragging: true,
                dragged: true
            });
        });
        $b22145cffc394ae8$var$_defineProperty($b22145cffc394ae8$var$_assertThisInitialized(_this), "onDrag", function(e, coreData) {
            if (!_this.state.dragging) return false;
            (0, $b22145cffc394ae8$var$_log.default)("Draggable: onDrag: %j", coreData);
            var uiData = (0, $kNRmj.createDraggableData)($b22145cffc394ae8$var$_assertThisInitialized(_this), coreData);
            var newState = {
                x: uiData.x,
                y: uiData.y
            }; // Keep within bounds.
            if (_this.props.bounds) {
                // Save original x and y.
                var x = newState.x, y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += _this.state.slackX;
                newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.
                var _getBoundPosition = (0, $kNRmj.getBoundPosition)($b22145cffc394ae8$var$_assertThisInitialized(_this), newState.x, newState.y), _getBoundPosition2 = $b22145cffc394ae8$var$_slicedToArray(_getBoundPosition, 2), newStateX = _getBoundPosition2[0], newStateY = _getBoundPosition2[1];
                newState.x = newStateX;
                newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = _this.state.slackX + (x - newState.x);
                newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - _this.state.x;
                uiData.deltaY = newState.y - _this.state.y;
            } // Short-circuit if user's callback killed it.
            var shouldUpdate = _this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            _this.setState(newState);
        });
        $b22145cffc394ae8$var$_defineProperty($b22145cffc394ae8$var$_assertThisInitialized(_this), "onDragStop", function(e, coreData) {
            if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.
            var shouldContinue = _this.props.onStop(e, (0, $kNRmj.createDraggableData)($b22145cffc394ae8$var$_assertThisInitialized(_this), coreData));
            if (shouldContinue === false) return false;
            (0, $b22145cffc394ae8$var$_log.default)("Draggable: onDragStop: %j", coreData);
            var newState = {
                dragging: false,
                slackX: 0,
                slackY: 0
            }; // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            var controlled = Boolean(_this.props.position);
            if (controlled) {
                var _this$props$position = _this.props.position, x = _this$props$position.x, y = _this$props$position.y;
                newState.x = x;
                newState.y = y;
            }
            _this.setState(newState);
        });
        _this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: $b22145cffc394ae8$var$_objectSpread({}, props.position),
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
        return _this;
    }
    $b22145cffc394ae8$var$_createClass(Draggable, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Check to see if the element passed is an instanceof SVGElement
                if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) this.setState({
                    isElementSVG: true
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.setState({
                    dragging: false
                }); // prevents invariant if unmounted while dragging
            } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
        },
        {
            key: "findDOMNode",
            value: function findDOMNode() /*: ?HTMLElement*/ {
                var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;
                return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : $b22145cffc394ae8$var$_reactDom.default.findDOMNode(this);
            }
        },
        {
            key: "render",
            value: function render() /*: ReactElement<any>*/ {
                var _clsx;
                var _this$props2 = this.props, axis = _this$props2.axis, bounds = _this$props2.bounds, children = _this$props2.children, defaultPosition = _this$props2.defaultPosition, defaultClassName = _this$props2.defaultClassName, defaultClassNameDragging = _this$props2.defaultClassNameDragging, defaultClassNameDragged = _this$props2.defaultClassNameDragged, position = _this$props2.position, positionOffset = _this$props2.positionOffset, scale = _this$props2.scale, draggableCoreProps = $b22145cffc394ae8$var$_objectWithoutProperties(_this$props2, $b22145cffc394ae8$var$_excluded);
                var style = {};
                var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.
                var controlled = Boolean(position);
                var draggable = !controlled || this.state.dragging;
                var validPosition = position || defaultPosition;
                var transformOpts = {
                    // Set left if horizontal drag is enabled
                    x: (0, $kNRmj.canDragX)(this) && draggable ? this.state.x : validPosition.x,
                    // Set top if vertical drag is enabled
                    y: (0, $kNRmj.canDragY)(this) && draggable ? this.state.y : validPosition.y
                }; // If this element was SVG, we use the `transform` attribute.
                if (this.state.isElementSVG) svgTransform = (0, $aZZKx.createSVGTransform)(transformOpts, positionOffset);
                else // Add a CSS transform to move the element around. This allows us to move the element around
                // without worrying about whether or not it is relatively or absolutely positioned.
                // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
                // has a clean slate.
                style = (0, $aZZKx.createCSSTransform)(transformOpts, positionOffset);
                 // Mark with class while dragging
                var className = (0, $b22145cffc394ae8$var$_clsx2.default)(children.props.className || "", defaultClassName, (_clsx = {}, $b22145cffc394ae8$var$_defineProperty(_clsx, defaultClassNameDragging, this.state.dragging), $b22145cffc394ae8$var$_defineProperty(_clsx, defaultClassNameDragged, this.state.dragged), _clsx)); // Reuse the child provided
                // This makes it flexible to use whatever element is wanted (div, ul, etc)
                return /*#__PURE__*/ $b22145cffc394ae8$var$React.createElement($b22145cffc394ae8$var$_DraggableCore.default, $b22145cffc394ae8$var$_extends({}, draggableCoreProps, {
                    onStart: this.onDragStart,
                    onDrag: this.onDrag,
                    onStop: this.onDragStop
                }), /*#__PURE__*/ $b22145cffc394ae8$var$React.cloneElement($b22145cffc394ae8$var$React.Children.only(children), {
                    className: className,
                    style: $b22145cffc394ae8$var$_objectSpread($b22145cffc394ae8$var$_objectSpread({}, children.props.style), style),
                    transform: svgTransform
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: // Arity (props, state)
            function getDerivedStateFromProps(_ref, _ref2) /*: ?$Shape<DraggableState>*/ {
                var position = _ref.position;
                var prevPropsPosition = _ref2.prevPropsPosition;
                // Set x/y if a new position is provided in props that is different than the previous.
                if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
                    (0, $b22145cffc394ae8$var$_log.default)("Draggable: getDerivedStateFromProps %j", {
                        position: position,
                        prevPropsPosition: prevPropsPosition
                    });
                    return {
                        x: position.x,
                        y: position.y,
                        prevPropsPosition: $b22145cffc394ae8$var$_objectSpread({}, position)
                    };
                }
                return null;
            }
        }
    ]);
    return Draggable;
}($b22145cffc394ae8$var$React.Component);
$b22145cffc394ae8$exports.default = $b22145cffc394ae8$var$Draggable;
$b22145cffc394ae8$var$_defineProperty($b22145cffc394ae8$var$Draggable, "displayName", "Draggable");
$b22145cffc394ae8$var$_defineProperty($b22145cffc394ae8$var$Draggable, "propTypes", $b22145cffc394ae8$var$_objectSpread($b22145cffc394ae8$var$_objectSpread({}, $b22145cffc394ae8$var$_DraggableCore.default.propTypes), {}, {
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: $b22145cffc394ae8$var$_propTypes.default.oneOf([
        "both",
        "x",
        "y",
        "none"
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: $b22145cffc394ae8$var$_propTypes.default.oneOfType([
        $b22145cffc394ae8$var$_propTypes.default.shape({
            left: $b22145cffc394ae8$var$_propTypes.default.number,
            right: $b22145cffc394ae8$var$_propTypes.default.number,
            top: $b22145cffc394ae8$var$_propTypes.default.number,
            bottom: $b22145cffc394ae8$var$_propTypes.default.number
        }),
        $b22145cffc394ae8$var$_propTypes.default.string,
        $b22145cffc394ae8$var$_propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: $b22145cffc394ae8$var$_propTypes.default.string,
    defaultClassNameDragging: $b22145cffc394ae8$var$_propTypes.default.string,
    defaultClassNameDragged: $b22145cffc394ae8$var$_propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: $b22145cffc394ae8$var$_propTypes.default.shape({
        x: $b22145cffc394ae8$var$_propTypes.default.number,
        y: $b22145cffc394ae8$var$_propTypes.default.number
    }),
    positionOffset: $b22145cffc394ae8$var$_propTypes.default.shape({
        x: $b22145cffc394ae8$var$_propTypes.default.oneOfType([
            $b22145cffc394ae8$var$_propTypes.default.number,
            $b22145cffc394ae8$var$_propTypes.default.string
        ]),
        y: $b22145cffc394ae8$var$_propTypes.default.oneOfType([
            $b22145cffc394ae8$var$_propTypes.default.number,
            $b22145cffc394ae8$var$_propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: $b22145cffc394ae8$var$_propTypes.default.shape({
        x: $b22145cffc394ae8$var$_propTypes.default.number,
        y: $b22145cffc394ae8$var$_propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $euSu7.dontSetMe,
    style: $euSu7.dontSetMe,
    transform: $euSu7.dontSetMe
}));
$b22145cffc394ae8$var$_defineProperty($b22145cffc394ae8$var$Draggable, "defaultProps", $b22145cffc394ae8$var$_objectSpread($b22145cffc394ae8$var$_objectSpread({}, $b22145cffc394ae8$var$_DraggableCore.default.defaultProps), {}, {
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
}));


var $6177c5d530cbfa68$var$Draggable = $b22145cffc394ae8$exports.default, $6177c5d530cbfa68$var$DraggableCore = $b22145cffc394ae8$exports.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
$6177c5d530cbfa68$exports = $6177c5d530cbfa68$var$Draggable;
$6177c5d530cbfa68$exports.default = $6177c5d530cbfa68$var$Draggable;
$6177c5d530cbfa68$exports.DraggableCore = $6177c5d530cbfa68$var$DraggableCore;









parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");









$a72f9a72787939bf$var$EnvironmentSelector.propTypes = {
    enabled: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    handleSelect: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func
};
function $a72f9a72787939bf$var$EnvironmentSelector({ enabled: enabled, selected: selected, handleSelect: handleSelect }) {
    const locale = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.locale);
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    function handleClick(event, env) {
        if (enabled) handleSelect(env.id);
    }
    const envs = (0, $3506aa481686351c$export$c69de11924434777)();
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.IntlProvider), {
        locale: locale.locale,
        messages: locale.segmentInfo,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
            className: "environment-selector",
            children: envs.map((env)=>{
                const { id: id, name: name, iconStyle: iconStyle } = env;
                const classNames = [
                    "environment-item"
                ];
                const label = intl.formatMessage({
                    id: `environs.${id}`,
                    defaultMessage: name
                });
                if (selected === id) classNames.push("environment-active");
                else if (!selected && id === (0, $2a9a05c10189c2fe$export$cb0b75edbeba6d1a)) classNames.push("environment-active");
                if (!enabled && selected !== id) classNames.push("environment-disabled");
                return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
                    label: label,
                    placement: "bottom",
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("button", {
                        "aria-label": label,
                        className: classNames.join(" "),
                        style: iconStyle,
                        onClick: (event)=>handleClick(event, env),
                        children: [
                            !enabled && selected !== id && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                        className: "environment-disabled-overlay"
                                    }),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                                        icon: (0, $5cbf5c54789c9bf6$export$e6d53d6f898a52bd)
                                    })
                                ]
                            }),
                            env.iconImage && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                                src: (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(env.iconImage)?.src,
                                alt: "",
                                style: {
                                    width: "100%",
                                    height: "100%",
                                    pointerEvents: "none",
                                    userSelect: "none"
                                },
                                draggable: false
                            })
                        ]
                    })
                }, id);
            })
        })
    });
}
var $a72f9a72787939bf$export$2e2bcd8739ae039 = $a72f9a72787939bf$var$EnvironmentSelector;



function $85aafb34888eeb6d$var$EnvironmentEditor(props) {
    const selected = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street.environment || (0, $2a9a05c10189c2fe$export$cb0b75edbeba6d1a));
    const show = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.ui.toolboxVisible || false);
    const isSubscriber = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.isSubscriber || false);
    const locale = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.locale);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    function handleClose(event) {
        dispatch((0, $cb9eeb171d537a5a$export$8cfc7625e381dff9)());
    }
    function handleSelect(id) {
        dispatch((0, $8b007b7ac0907036$export$333037a86af0852f)(id));
    }
    const transitions = (0, $2c03db10edbdd570$export$7b286972b8d8ccbf)(show, {
        from: {
            opacity: 0,
            scale: 0.75,
            pointerEvents: "none"
        },
        enter: {
            opacity: 1,
            scale: 1,
            pointerEvents: "auto"
        },
        leave: {
            opacity: 0,
            scale: 0.85,
            pointerEvents: "none"
        },
        config: {
            tension: 300,
            friction: 5,
            clamp: true
        }
    });
    return transitions((style, item)=>item && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6177c5d530cbfa68$exports))), {
            bounds: "parent",
            handle: "header",
            cancel: ".close",
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "environment-editor environment-editor-container-outer",
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $80a1228f70d6ae64$export$407448d2b89b1813).div, {
                    className: "environment-editor-container-inner",
                    style: style,
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("header", {
                            children: [
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("h3", {
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                                            icon: "sun"
                                        }),
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "tools.environment.heading",
                                            defaultMessage: "Environment"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $f9d7843891fda220$export$2e2bcd8739ae039), {
                                    onClick: handleClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                            className: "environment-editor-content",
                            children: [
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.IntlProvider), {
                                    locale: locale.locale,
                                    messages: locale.segmentInfo,
                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $a72f9a72787939bf$export$2e2bcd8739ae039), {
                                        enabled: isSubscriber,
                                        selected: selected,
                                        handleSelect: handleSelect
                                    })
                                }),
                                !isSubscriber && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                    className: "environment-upgrade-box",
                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $292e67e840fa392a$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "plus.prompt.text",
                                            defaultMessage: "This feature is only available to Streetmix+ users.\u200E"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        }));
}
var $85aafb34888eeb6d$export$2e2bcd8739ae039 = $85aafb34888eeb6d$var$EnvironmentEditor;




var $4DE7A = parcelRequire("4DE7A");




parcelRequire("4DE7A");




var $4DE7A = parcelRequire("4DE7A");




function $23e399a9e0efbf15$var$GalleryError() {
    const userId = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.gallery.userId);
    const dispatch = (0, $c738fd431d4d7b5f$export$8ad76b76a4c905f8)();
    const handleRetry = (0, $4DE7A.useCallback)(()=>{
        dispatch((0, $8d60d83c2ee769b2$export$a2488c4469b72767)({
            userId: userId
        }));
    }, [
        userId,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "gallery-error",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "gallery.fail",
                    defaultMessage: "Failed to load the gallery."
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                onClick: handleRetry,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "btn.try-again",
                    defaultMessage: "Try again"
                })
            })
        ]
    });
}
var $23e399a9e0efbf15$export$2e2bcd8739ae039 = $23e399a9e0efbf15$var$GalleryError;



parcelRequire("4DE7A");

function $793a594da2211e2e$var$GalleryLoading() {
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "gallery-loading",
        "aria-live": "polite",
        "aria-busy": "true",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $62d2815b920e2bc5$export$2e2bcd8739ae039), {})
    });
}
var $793a594da2211e2e$export$2e2bcd8739ae039 = $793a594da2211e2e$var$GalleryLoading;




var $4DE7A = parcelRequire("4DE7A");











var $4DE7A = parcelRequire("4DE7A");









const $b7bd0c8e4d153b2e$var$THUMBNAIL_WIDTH = 180;
const $b7bd0c8e4d153b2e$var$THUMBNAIL_HEIGHT = 110;
const $b7bd0c8e4d153b2e$var$THUMBNAIL_MULTIPLIER = 0.2;
function $b7bd0c8e4d153b2e$var$GalleryStreetItem(props) {
    const { street: street, showStreetOwner: showStreetOwner = true, selected: selected = false, allowDelete: allowDelete = false, doSelect: doSelect, doDelete: doDelete } = props;
    const dpi = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.system.devicePixelRatio || 1);
    const { data: creatorProfile } = (0, $e2f405c0a03fcace$export$9beb97f355b95ab9)(street.creatorId);
    const [isError, setError] = (0, $4DE7A.useState)(false);
    const thumbnailEl = (0, $4DE7A.useRef)(null);
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    // Effect hook draws thumbnail to canvas element after mounting
    (0, $4DE7A.useLayoutEffect)(()=>{
        if (thumbnailEl.current === null) return;
        const ctx = thumbnailEl.current.getContext("2d");
        if (ctx === null) return;
        try {
            (0, $0cbfb6ac69a402ec$export$c20d51295249d0f5)(ctx, street.data.street, {
                // TODO: document magic number 2
                width: $b7bd0c8e4d153b2e$var$THUMBNAIL_WIDTH * 2,
                height: $b7bd0c8e4d153b2e$var$THUMBNAIL_HEIGHT * 2,
                dpi: dpi,
                multiplier: $b7bd0c8e4d153b2e$var$THUMBNAIL_MULTIPLIER,
                silhouette: false,
                bottomAligned: false,
                transparentSky: false,
                segmentNamesAndWidths: false,
                streetName: false,
                watermark: false
            });
        } catch (error) {
            setError(true);
        }
    }, [
        thumbnailEl,
        street,
        dpi
    ]);
    // Define event handlers
    function handleSelectStreet(event) {
        event.preventDefault();
        if (event.shiftKey || event.ctrlKey || event.metaKey) return;
        doSelect(street.id);
    }
    function handleDeleteStreet(event) {
        event.preventDefault();
        event.stopPropagation();
        const message = intl.formatMessage({
            id: "prompt.delete-street",
            defaultMessage: "Are you sure you want to permanently delete {streetName}? This cannot be undone."
        }, {
            streetName: street.name ?? intl.formatMessage({
                id: "street.default-name",
                defaultMessage: "Unnamed St"
            })
        });
        if (window.confirm(message)) doDelete(street.id);
    }
    // Bail if there is no street data
    // TODO: handle data errors better
    if (street.data === undefined) {
        console.error("No street data!", street);
        return null;
    }
    const classNames = [
        "gallery-street-item"
    ];
    if (selected) classNames.push("gallery-selected");
    if (showStreetOwner) classNames.push("gallery-with-owner");
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: classNames.join(" "),
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("a", {
                href: (0, $4b803bff0fdd2b7e$export$2caf090e31c8ca49)(street),
                onClick: handleSelectStreet,
                children: [
                    isError ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "gallery-street-item-error",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "gallery.thumbnail-error",
                            defaultMessage: "Thumbnail image is not available."
                        })
                    }) : /* TODO: document magic number 2 */ /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "gallery-street-item-canvas",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("canvas", {
                                    width: $b7bd0c8e4d153b2e$var$THUMBNAIL_WIDTH * dpi * 2,
                                    height: $b7bd0c8e4d153b2e$var$THUMBNAIL_HEIGHT * dpi * 2,
                                    ref: thumbnailEl
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                    className: "gallery-street-item-ground"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $1b80e7badd3600dc$export$2e2bcd8739ae039), {
                        name: street.name
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                        className: "gallery-street-item-date",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $949370bb2e225fbf$export$2e2bcd8739ae039), {
                            value: street.updatedAt
                        })
                    }),
                    showStreetOwner && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                        className: "gallery-street-item-creator",
                        children: creatorProfile?.displayName ?? street.creatorId ?? intl.formatMessage({
                            id: "users.anonymous",
                            defaultMessage: "Anonymous"
                        })
                    })
                ]
            }),
            allowDelete && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
                className: "gallery-street-item-delete",
                onClick: handleDeleteStreet,
                title: intl.formatMessage({
                    id: "gallery.delete-street-tooltip",
                    defaultMessage: "Delete street"
                }),
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $103c196c178bbe41$export$2e2bcd8739ae039), {
                    icon: "trash"
                })
            })
        ]
    });
}
var $b7bd0c8e4d153b2e$export$2e2bcd8739ae039 = $b7bd0c8e4d153b2e$var$GalleryStreetItem;




function $2f3bfeae23989b21$var$GalleryContents({ user: user }) {
    const streets = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.gallery.streets ?? []);
    const currentStreetId = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.street.id ?? null);
    const isOwnedByCurrentUser = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.user.signedIn && state.gallery.userId === state.user.signInData?.userId);
    const dispatch = (0, $c738fd431d4d7b5f$export$8ad76b76a4c905f8)();
    const galleryEl = (0, $4DE7A.useRef)(null);
    const [selectedStreet, setSelectedStreet] = (0, $4DE7A.useState)(currentStreetId);
    (0, $4DE7A.useLayoutEffect)(()=>{
        if (selectedStreet !== undefined) {
            const selectedEl = document.querySelector(".gallery-selected");
            // Make sure the element exists -- sometimes it hasn't rendered yet
            if (selectedEl) {
                // Note: smooth scroll is not supported in all browsers
                selectedEl.scrollIntoView({
                    behavior: "smooth",
                    inline: "nearest"
                });
                // We need this to prevent scrollIntoView from moving things
                // upward and trying to reveal the hidden scrollbar area
                if (galleryEl.current?.parentElement) galleryEl.current.parentElement.scrollTop = 0;
            }
        }
    }, [
        selectedStreet
    ]);
    function selectStreet(streetId) {
        setSelectedStreet(streetId);
        (0, $ff38ac1d71741186$export$6889ba5d1a5cf5ad)(streetId);
    }
    function deleteStreet(streetId) {
        if (streetId === currentStreetId) {
            setSelectedStreet(null);
            (0, $5af1a42dad139206$export$3879b24e8245693d)((0, $5af1a42dad139206$export$4fd720569787ab6f).NO_STREET, false);
        }
        (0, $a7e2543fa152618e$export$f3d0bdebcf71c93b)(streetId);
        // Optimistic delete: don't re-fetch, just remove street from memory
        // and let the change in data store trigger a re-render
        dispatch((0, $11a2d10829f32488$export$242a355b0f5dc10e)(streetId));
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "gallery-header",
                ref: galleryEl,
                children: [
                    user?.id !== undefined && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $aad6e9d6c00e3001$export$2e2bcd8739ae039), {
                        userId: user.id
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "gallery-label",
                        children: user?.displayName ?? user?.id ?? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "gallery.all",
                            defaultMessage: "All streets"
                        })
                    }),
                    user?.id !== undefined && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                        className: "gallery-street-count",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "gallery.street-count",
                            defaultMessage: "{count, plural, =0 {No streets yet} one {# street} other {# streets}}",
                            values: {
                                count: streets.length
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "gallery-streets-container",
                children: [
                    isOwnedByCurrentUser && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "gallery-user-buttons",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                href: (0, $ea458c15ce872cdc$export$3ae46e95ba6bc5da),
                                className: "gallery-new-street",
                                rel: "noopener noreferrer",
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "btn.create",
                                    defaultMessage: "Create new street"
                                })
                            }),
                            selectedStreet !== null ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                href: (0, $ea458c15ce872cdc$export$429952ed111074be),
                                className: "gallery-copy-last-street",
                                rel: "noopener noreferrer",
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "btn.copy",
                                    defaultMessage: "Make a copy"
                                })
                            }) : /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                className: "gallery-copy-last-street",
                                disabled: true,
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "btn.copy",
                                    defaultMessage: "Make a copy"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d1eb3c02169e64a6$export$2e2bcd8739ae039), {
                        className: "streets",
                        allowKeyboardScroll: true,
                        children: streets.map((item)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $b7bd0c8e4d153b2e$export$2e2bcd8739ae039), {
                                street: item,
                                selected: selectedStreet === item.id,
                                doSelect: selectStreet,
                                doDelete: deleteStreet,
                                showStreetOwner: !user || !(user?.id === item.creatorId),
                                allowDelete: isOwnedByCurrentUser
                            }, item.id))
                    })
                ]
            })
        ]
    });
}
var $2f3bfeae23989b21$export$2e2bcd8739ae039 = $2f3bfeae23989b21$var$GalleryContents;


// This component only handles switching between display modes
function $cce964c1a51e29c4$var$GalleryPanel() {
    // Mode is set in state after streets have loaded
    // We use RTK Query to load user data in this component
    // There might be a better way of combining these requests!
    const mode = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.gallery.mode);
    const userId = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.gallery.userId);
    const { data: data, isError: isError, isLoading: isLoading } = (0, $e2f405c0a03fcace$export$9beb97f355b95ab9)(userId);
    let childElements;
    if (mode === "loading" || isLoading) childElements = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $793a594da2211e2e$export$2e2bcd8739ae039), {});
    else if (mode === "error" || isError) childElements = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $23e399a9e0efbf15$export$2e2bcd8739ae039), {});
    else if (mode === "gallery") // It is not necessary to have a user property to load the gallery
    childElements = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $2f3bfeae23989b21$export$2e2bcd8739ae039), {
        user: data
    });
    else childElements = null;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "gallery-panel",
        children: childElements
    });
}
var $cce964c1a51e29c4$export$2e2bcd8739ae039 = $cce964c1a51e29c4$var$GalleryPanel;



parcelRequire("4DE7A");

// The Gallery 'Shield' renders across the entire screen behind the gallery
// and creates a space for the user to click to dismiss the gallery
// very similar to a modal
function $8835e6a733f88f0b$var$GalleryShield({ visible: visible = false, onClick: onClick = ()=>{} }) {
    if (visible) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "gallery-shield",
        "data-testid": "gallery-shield",
        onClick: onClick
    });
    return null;
}
var $8835e6a733f88f0b$export$2e2bcd8739ae039 = $8835e6a733f88f0b$var$GalleryShield;



function $6659bdc3248eb800$var$Gallery() {
    const { visible: visible, instant: instant } = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.gallery);
    const dispatch = (0, $c738fd431d4d7b5f$export$8ad76b76a4c905f8)();
    const hide = (0, $4DE7A.useCallback)(()=>{
        dispatch((0, $8d60d83c2ee769b2$export$4e47f300f46a8155)());
    }, [
        dispatch
    ]);
    (0, $4DE7A.useEffect)(()=>{
        // Only register the esc keybind when Gallery is visible
        if (visible) (0, $89f2807011121cdf$export$bc520ed1c57f0d75)("esc", hide);
        else (0, $89f2807011121cdf$export$86df18839624bc06)("esc", hide);
        // Clean up the keybind when unmounted
        return ()=>{
            (0, $89f2807011121cdf$export$86df18839624bc06)("esc", hide);
        };
    }, [
        visible,
        hide
    ]);
    (0, $4DE7A.useEffect)(()=>{
        if (visible) {
            if (instant) document.body.classList.add("gallery-no-move-transition");
            document.body.classList.add("gallery-visible");
            if (instant) window.setTimeout(function() {
                document.body.classList.remove("gallery-no-move-transition");
            }, 0);
        } else {
            if (instant) document.body.classList.add("gallery-no-move-transition");
            document.body.classList.remove("gallery-visible");
            if (instant) window.setTimeout(function() {
                document.body.classList.remove("gallery-no-move-transition");
            }, 0);
        }
    }, [
        visible,
        instant
    ]);
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "gallery",
        "aria-hidden": !visible,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $cce964c1a51e29c4$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $8835e6a733f88f0b$export$2e2bcd8739ae039), {
                visible: visible,
                onClick: hide
            })
        ]
    });
}
var $6659bdc3248eb800$export$2e2bcd8739ae039 = $6659bdc3248eb800$var$Gallery;




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");


var $4DE7A = parcelRequire("4DE7A");



var $34Pgq = parcelRequire("34Pgq");


function $cf096e789a051aea$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $cf096e789a051aea$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $cf096e789a051aea$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $cf096e789a051aea$var$_typeof(obj);
}
function $cf096e789a051aea$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cf096e789a051aea$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cf096e789a051aea$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cf096e789a051aea$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cf096e789a051aea$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $cf096e789a051aea$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $cf096e789a051aea$var$_setPrototypeOf(subClass, superClass);
}
function $cf096e789a051aea$var$_setPrototypeOf(o, p) {
    $cf096e789a051aea$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cf096e789a051aea$var$_setPrototypeOf(o, p);
}
function $cf096e789a051aea$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cf096e789a051aea$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $cf096e789a051aea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $cf096e789a051aea$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $cf096e789a051aea$var$_possibleConstructorReturn(this, result);
    };
}
function $cf096e789a051aea$var$_possibleConstructorReturn(self, call) {
    if (call && ($cf096e789a051aea$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $cf096e789a051aea$var$_assertThisInitialized(self);
}
function $cf096e789a051aea$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $cf096e789a051aea$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $cf096e789a051aea$var$_getPrototypeOf(o) {
    $cf096e789a051aea$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cf096e789a051aea$var$_getPrototypeOf(o);
}
function $cf096e789a051aea$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cf096e789a051aea$export$642fdce9ca643b02(collect) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $b1cde746e5ea11e6$export$ffeaa70abe2dcf1c)("DragLayer", "collect[, options]", collect, options);
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof collect === "function", 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', "Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-layer", collect);
    (0, $2daa4a08f076625e$export$f5708dca728d7177)((0, $b1cde746e5ea11e6$export$53b83ca8eaab0383)(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-layer', options);
    return function decorateLayer(DecoratedComponent) {
        var Decorated = DecoratedComponent;
        var _options$arePropsEqua = options.arePropsEqual, arePropsEqual = _options$arePropsEqua === void 0 ? (0, $91edbb15e5e7db4c$export$d36bdfa510afb180) : _options$arePropsEqua;
        var displayName = Decorated.displayName || Decorated.name || "Component";
        var DragLayerContainer = /*#__PURE__*/ function(_Component) {
            $cf096e789a051aea$var$_inherits(DragLayerContainer, _Component);
            var _super = $cf096e789a051aea$var$_createSuper(DragLayerContainer);
            function DragLayerContainer() {
                var _this;
                $cf096e789a051aea$var$_classCallCheck(this, DragLayerContainer);
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _super.call.apply(_super, [
                    this
                ].concat(args));
                $cf096e789a051aea$var$_defineProperty($cf096e789a051aea$var$_assertThisInitialized(_this), "manager", void 0);
                $cf096e789a051aea$var$_defineProperty($cf096e789a051aea$var$_assertThisInitialized(_this), "isCurrentlyMounted", false);
                $cf096e789a051aea$var$_defineProperty($cf096e789a051aea$var$_assertThisInitialized(_this), "unsubscribeFromOffsetChange", void 0);
                $cf096e789a051aea$var$_defineProperty($cf096e789a051aea$var$_assertThisInitialized(_this), "unsubscribeFromStateChange", void 0);
                $cf096e789a051aea$var$_defineProperty($cf096e789a051aea$var$_assertThisInitialized(_this), "ref", (0, $4DE7A.createRef)());
                $cf096e789a051aea$var$_defineProperty($cf096e789a051aea$var$_assertThisInitialized(_this), "handleChange", function() {
                    if (!_this.isCurrentlyMounted) return;
                    var nextState = _this.getCurrentState();
                    if (!(0, $91edbb15e5e7db4c$export$d36bdfa510afb180)(nextState, _this.state)) _this.setState(nextState);
                });
                return _this;
            }
            $cf096e789a051aea$var$_createClass(DragLayerContainer, [
                {
                    key: "getDecoratedComponentInstance",
                    value: function getDecoratedComponentInstance() {
                        (0, $2daa4a08f076625e$export$f5708dca728d7177)(this.ref.current, "In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()");
                        return this.ref.current;
                    }
                },
                {
                    key: "shouldComponentUpdate",
                    value: function shouldComponentUpdate(nextProps, nextState) {
                        return !arePropsEqual(nextProps, this.props) || !(0, $91edbb15e5e7db4c$export$d36bdfa510afb180)(nextState, this.state);
                    }
                },
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        this.isCurrentlyMounted = true;
                        this.handleChange();
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        this.isCurrentlyMounted = false;
                        if (this.unsubscribeFromOffsetChange) {
                            this.unsubscribeFromOffsetChange();
                            this.unsubscribeFromOffsetChange = undefined;
                        }
                        if (this.unsubscribeFromStateChange) {
                            this.unsubscribeFromStateChange();
                            this.unsubscribeFromStateChange = undefined;
                        }
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        var _this2 = this;
                        return (0, $6dd45a7735069a79$exports.jsx)((0, $da3b103bf3c94d3b$export$2d5c5ceac203fc1e).Consumer, {
                            children: function children(_ref) {
                                var dragDropManager = _ref.dragDropManager;
                                if (dragDropManager === undefined) return null;
                                _this2.receiveDragDropManager(dragDropManager); // Let componentDidMount fire to initialize the collected state
                                if (!_this2.isCurrentlyMounted) return null;
                                return (0, $6dd45a7735069a79$exports.jsx)(Decorated, Object.assign({}, _this2.props, _this2.state, {
                                    ref: (0, $b1cde746e5ea11e6$export$a77111fb0da893fd)(Decorated) ? _this2.ref : null
                                }), void 0);
                            }
                        }, void 0);
                    }
                },
                {
                    key: "receiveDragDropManager",
                    value: function receiveDragDropManager(dragDropManager) {
                        if (this.manager !== undefined) return;
                        this.manager = dragDropManager;
                        (0, $2daa4a08f076625e$export$f5708dca728d7177)($cf096e789a051aea$var$_typeof(dragDropManager) === "object", "Could not find the drag and drop manager in the context of %s. Make sure to render a DndProvider component in your top-level component. Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#could-not-find-the-drag-and-drop-manager-in-the-context", displayName, displayName);
                        var monitor = this.manager.getMonitor();
                        this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
                        this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
                    }
                },
                {
                    key: "getCurrentState",
                    value: function getCurrentState() {
                        if (!this.manager) return {};
                        var monitor = this.manager.getMonitor();
                        return collect(monitor, this.props);
                    }
                }
            ]);
            return DragLayerContainer;
        }((0, $4DE7A.Component));
        $cf096e789a051aea$var$_defineProperty(DragLayerContainer, "displayName", "DragLayer(".concat(displayName, ")"));
        $cf096e789a051aea$var$_defineProperty(DragLayerContainer, "DecoratedComponent", DecoratedComponent);
        return (0, (/*@__PURE__*/$parcel$interopDefault($34Pgq)))(DragLayerContainer, DecoratedComponent);
    };
}




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");





const $30cdd43412d19a3f$var$GROUND_BASELINE = 400;
const $30cdd43412d19a3f$var$CANVAS_HEIGHT = 480;
const $30cdd43412d19a3f$var$CANVAS_GROUND = 35;
const $30cdd43412d19a3f$var$CANVAS_BASELINE = $30cdd43412d19a3f$var$CANVAS_HEIGHT - $30cdd43412d19a3f$var$CANVAS_GROUND;
class $30cdd43412d19a3f$var$SegmentCanvas extends (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).PureComponent {
    static propTypes = {
        actualWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number.isRequired,
        type: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string.isRequired,
        variantString: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string.isRequired,
        randSeed: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
        ]),
        groundBaseline: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        elevation: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        dpi: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        updatePerspective: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func
    };
    static defaultProps = {
        groundBaseline: $30cdd43412d19a3f$var$GROUND_BASELINE,
        updatePerspective: ()=>{}
    };
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
        this.canvasEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createRef();
    }
    componentDidMount() {
        this.props.updatePerspective(this.canvasEl.current);
        this.drawSegment();
        // Normally this.drawSegment() on its own works just fine, except in
        // Safari where the canvases are missing assets unless something is
        // interacted with, after which all canvases are redrawn. This doesn't
        // seem to be an asset loading issue, this is a Safari bug. By putting
        // drawSegment() in a setTimeout() we're trying to force a second
        // canvas render on mount in order to unstick the Safari bug.
        window.setTimeout(()=>{
            this.drawSegment();
        }, 0);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.variantString !== this.props.variantString) this.props.updatePerspective(this.canvasEl.current);
        this.drawSegment();
    }
    componentDidCatch(error, info) {
        this.setState({
            error: error
        });
    }
    drawSegment = ()=>{
        const canvas = this.canvasEl.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        (0, $2f44915f6f87dcf5$export$23deed70993953e5)(ctx, this.props.type, this.props.variantString, this.props.actualWidth, 0, this.props.groundBaseline, this.props.elevation, this.props.randSeed, 1, this.props.dpi);
    };
    render() {
        // Determine the maximum width of the artwork for this segment
        const variantInfo = (0, $0cc5ae9f1eba4866$export$a7e4a724089e6511)(this.props.type, this.props.variantString);
        const dimensions = (0, $2f44915f6f87dcf5$export$ef14b8f1a495a8b9)(variantInfo, this.props.actualWidth);
        const totalWidth = dimensions.right - dimensions.left;
        // If the graphics are wider than the width of the segment, then we will draw
        // our canvas a little bigger to make sure that the graphics aren't truncated.
        const displayWidth = totalWidth > this.props.actualWidth ? totalWidth : this.props.actualWidth;
        // Determine dimensions to draw DOM element
        const elementWidth = displayWidth * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381);
        const elementHeight = $30cdd43412d19a3f$var$CANVAS_BASELINE;
        // Determine size of canvas
        const canvasWidth = Math.round(elementWidth * this.props.dpi);
        const canvasHeight = elementHeight * this.props.dpi;
        const canvasStyle = {
            width: Math.round(elementWidth),
            height: elementHeight,
            left: dimensions.left * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381)
        };
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("canvas", {
            className: "segment-image",
            ref: this.canvasEl,
            width: canvasWidth,
            height: canvasHeight,
            style: canvasStyle
        });
    }
}
function $30cdd43412d19a3f$var$mapStateToProps(state) {
    return {
        dpi: state.system.devicePixelRatio,
        redrawCanvas: state.flags.DEBUG_SEGMENT_CANVAS_RECTANGLES.value
    };
}
var $30cdd43412d19a3f$export$2e2bcd8739ae039 = (0, $a4829965bb94612b$export$2e2bcd8739ae039)($30cdd43412d19a3f$var$mapStateToProps)($30cdd43412d19a3f$var$SegmentCanvas);




const $3f737bae02311d39$var$DRAG_OFFSET_Y_PALETTE = -490;
const $3f737bae02311d39$var$MAX_DRAG_DEGREE = 20;
class $3f737bae02311d39$var$SegmentDragLayer extends (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).PureComponent {
    static propTypes = {
        isDragging: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool.isRequired,
        currentOffset: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
            x: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
            y: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
        }),
        item: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object,
        type: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
    };
    floatingEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createRef();
    getSnapshotBeforeUpdate(prevProps) {
        const { currentOffset: currentOffset } = this.props;
        const prevMouseX = prevProps.currentOffset && prevProps.currentOffset.x;
        if (!currentOffset || !prevMouseX) return null;
        let deg = currentOffset.x - prevMouseX;
        if (deg > $3f737bae02311d39$var$MAX_DRAG_DEGREE) deg = $3f737bae02311d39$var$MAX_DRAG_DEGREE;
        else if (deg < -$3f737bae02311d39$var$MAX_DRAG_DEGREE) deg = -$3f737bae02311d39$var$MAX_DRAG_DEGREE;
        return deg;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.isDragging) this.getSegmentStyle(snapshot);
    }
    getSegmentStyle = (deg = 0)=>{
        const { currentOffset: currentOffset, item: item } = this.props;
        if (!currentOffset || !this.floatingEl.current) return;
        let { x: x, y: y } = currentOffset;
        if (this.props.type === (0, $b6e16a46f37cea3c$export$4624c240901a6889).PALETTE_SEGMENT) {
            x -= item.actualWidth * 4 // TODO: document magic number, probably TILE_SIZE * PALETTE_MULTIPLIER
            ;
            y += $3f737bae02311d39$var$DRAG_OFFSET_Y_PALETTE;
        }
        const transform = `translate(${x}px, ${y}px) rotateZ(${deg}deg)`;
        this.floatingEl.current.style.transform = transform;
        this.floatingEl.current.style["-webkit-transform"] = transform;
    };
    render() {
        const { isDragging: isDragging, item: item, type: type } = this.props;
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
            className: "segment-drag-layer",
            children: isDragging && (type === (0, $b6e16a46f37cea3c$export$4624c240901a6889).SEGMENT || type === (0, $b6e16a46f37cea3c$export$4624c240901a6889).PALETTE_SEGMENT) && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "floating segment",
                ref: this.floatingEl,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $30cdd43412d19a3f$export$2e2bcd8739ae039), {
                    randSeed: item.id,
                    ...item
                })
            })
        });
    }
}
function $3f737bae02311d39$var$collect(monitor) {
    return {
        item: monitor.getItem(),
        type: monitor.getItemType(),
        currentOffset: monitor.getSourceClientOffset(),
        isDragging: monitor.isDragging()
    };
}
var $3f737bae02311d39$export$2e2bcd8739ae039 = (0, $cf096e789a051aea$export$642fdce9ca643b02)($3f737bae02311d39$var$collect)($3f737bae02311d39$var$SegmentDragLayer);




var $4DE7A = parcelRequire("4DE7A");

/**
 * Draws a polygon of the "Tognazzini zone" area.
 *
 * @param {HTMLCanvasElement} canvas - canvas element to draw to
 * @param {Array} polygon - array of points for the polygon
 */ const $3c433e41350f0a75$var$drawPolygon = (canvas, polygon)=>{
    // Early exit if polygon or canvas isn't set
    if (!polygon.length || !polygon[0].length) return;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    // Clear the canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    // Draw the path
    ctx.strokeStyle = "red";
    ctx.fillStyle = "rgba(255, 0, 0, .1)";
    ctx.beginPath();
    ctx.moveTo(polygon[0][0], polygon[0][1]);
    for(let i = 1; i < polygon.length; i++)ctx.lineTo(polygon[i][0], polygon[i][1]);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
};
const $3c433e41350f0a75$var$DebugHoverPolygon = (props)=>{
    // When the window / viewport resizes, set the width and
    // height of the canvas element.
    const el = (0, $4DE7A.useRef)(null);
    const enabled = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.flags.INFO_BUBBLE_HOVER_POLYGON.value || false);
    const hoverPolygon = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.infoBubble.hoverPolygon || []);
    const handleResize = ()=>{
        if (!el.current) return;
        el.current.width = window.innerWidth;
        el.current.height = window.innerHeight;
    };
    (0, $4DE7A.useEffect)(()=>{
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    });
    // Draw the polygon area.
    (0, $4DE7A.useEffect)(()=>{
        if (enabled) $3c433e41350f0a75$var$drawPolygon(el.current, hoverPolygon);
    }, [
        hoverPolygon,
        enabled
    ]);
    // Render component if enabled.
    if (enabled) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "debug-hover-polygon",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("canvas", {
            width: window.innerWidth,
            height: window.innerHeight,
            ref: el
        })
    });
    // Bail if disabled
    return null;
};
var $3c433e41350f0a75$export$2e2bcd8739ae039 = $3c433e41350f0a75$var$DebugHoverPolygon;




var $4DE7A = parcelRequire("4DE7A");




parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");


$9b459f7d828eccca$var$Toast.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        mode: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
            "success",
            "warning"
        ]),
        message: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
        action: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
    }),
    setRef: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    handleClose: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    handleAction: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).node
};
function $9b459f7d828eccca$var$Toast(props) {
    const { item: item, setRef: setRef, handleClose: handleClose, handleAction: handleAction = ()=>{}, className: className, children: children } = props;
    const { mode: mode, title: title, message: message, action: action } = item;
    const classNames = [
        "toast"
    ];
    if (mode) classNames.push("toast-" + mode);
    if (className) classNames.push(className);
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: classNames.join(" "),
        ref: setRef,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
            className: "toast-content",
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $f9d7843891fda220$export$2e2bcd8739ae039), {
                    onClick: handleClose
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                    className: "toast-body",
                    children: [
                        title && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h3", {
                            children: title
                        }),
                        children || /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                            className: "toast-message",
                            children: message
                        })
                    ]
                }),
                action && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                    className: "toast-action",
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
                        onClick: handleAction,
                        children: action
                    })
                })
            ]
        })
    });
}
var $9b459f7d828eccca$export$2e2bcd8739ae039 = $9b459f7d828eccca$var$Toast;



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");




function $38bf1f4c309ebf74$var$ToastUndo(props) {
    const { item: item, setRef: setRef, handleClose: handleClose } = props;
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    // TODO: Restore functionality describes in issue #306.
    // The "undo" button always undoes the last action. If this toast
    // is still visible, and a user makes additional edits to the street,
    // the undo button will revert the last edit, not the action that
    // triggered this toast.
    // A previous solution was to hide this toast when the street is
    // updated and saved, but this has been broken in the react-spring toast
    // implementation for some time.
    // A new solution is to know which undo step triggered the toast,
    // and if the undo action is still relevant, it is performed when clicked.
    // Otherwise the undo action is rendered inert.
    // We can't do this right now because undos don't have an ID to key off of.
    function handleAction(event) {
        dispatch((0, $7e4b1d33bc4e936e$export$6e8acc5113ad37bb)());
        handleClose(event);
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $9b459f7d828eccca$export$2e2bcd8739ae039), {
        setRef: setRef,
        handleClose: handleClose,
        handleAction: handleAction,
        item: {
            ...item,
            action: item.action || intl.formatMessage({
                id: "btn.undo",
                defaultMessage: "Undo"
            })
        }
    });
}
// Renders a specific type of Toast with Undo button.
$38bf1f4c309ebf74$var$ToastUndo.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
            "TOAST_UNDO"
        ]),
        message: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string.isRequired,
        action: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
    }),
    setRef: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    handleClose: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired
};
var $38bf1f4c309ebf74$export$2e2bcd8739ae039 = $38bf1f4c309ebf74$var$ToastUndo;



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");



// Renders a specific type of Toast with Sign in button.
$4a5b6f4fe1f0adb7$var$ToastSignIn.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
            "TOAST_SIGN_IN"
        ]),
        message: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string.isRequired,
        action: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
    }),
    setRef: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    handleClose: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired
};
function $4a5b6f4fe1f0adb7$var$ToastSignIn(props) {
    const { item: item, setRef: setRef, handleClose: handleClose } = props;
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    function handleAction(event) {
        (0, $9be7409470745503$export$7abc584011c1e113)();
        handleClose(event);
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $9b459f7d828eccca$export$2e2bcd8739ae039), {
        setRef: setRef,
        handleClose: handleClose,
        handleAction: handleAction,
        item: {
            ...item,
            action: item.action || intl.formatMessage({
                id: "menu.item.sign-in",
                defaultMessage: "Sign in"
            })
        }
    });
}
var $4a5b6f4fe1f0adb7$export$2e2bcd8739ae039 = $4a5b6f4fe1f0adb7$var$ToastSignIn;




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");


// Renders a specific type of Toast for no-connection message.
$a55fcac896cbfb7c$var$ToastNoConnection.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
            "TOAST_NO_CONNECTION"
        ]),
        action: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
    }),
    setRef: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    handleClose: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired
};
function $a55fcac896cbfb7c$var$ToastNoConnection(props) {
    const { item: item, setRef: setRef, handleClose: handleClose } = props;
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    // This toast is usually called with a infinite duration (it never
    // closes after a certain amount of time has passsed). It will close
    // if someone interacts with it, but it also needs to close
    // automatically when the connection is restored or re-attempted.
    // This event listener handles that.
    (0, $4DE7A.useEffect)(()=>{
        window.addEventListener("online", handleClose);
        return ()=>{
            window.removeEventListener("online", handleClose);
        };
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $9b459f7d828eccca$export$2e2bcd8739ae039), {
        setRef: setRef,
        handleClose: handleClose,
        handleAction: handleClose,
        item: {
            ...item,
            action: item.action || intl.formatMessage({
                id: "btn.dismiss",
                defaultMessage: "Dismiss"
            })
        },
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "msg.no-connection",
            defaultMessage: "Streetmix is having trouble connecting to the Internet."
        })
    });
}
var $a55fcac896cbfb7c$export$2e2bcd8739ae039 = $a55fcac896cbfb7c$var$ToastNoConnection;




var $4DE7A = parcelRequire("4DE7A");


var $fmSD5 = parcelRequire("fmSD5");


var $034448cdb064f160$exports = {};

$034448cdb064f160$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "wm-icon-animated.b8b2b365.svg";





// Renders a specific type of Toast for Web Monetized users that are not signed in.
$aec5207e84d27848$var$ToastWebMonetization.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
            "TOAST_WEB_MONETIZATION"
        ]),
        action: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
    }),
    setRef: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    handleClose: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired
};
function $aec5207e84d27848$var$ToastWebMonetization(props) {
    const { item: item, setRef: setRef, handleClose: handleClose } = props;
    const signedIn = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.signedIn);
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    // It's possible to encounter a race condition where a user's signed-in
    // state becomes `true` after this toast has already displayed. If that
    // happens, this automatically closes the toast.
    (0, $4DE7A.useEffect)(()=>{
        if (signedIn) handleClose();
    }, [
        signedIn,
        handleClose
    ]);
    // Monetization can stop in certain cases, such as when a user switches
    // to another tab. In that event, close the toast.
    (0, $4DE7A.useEffect)(()=>{
        document.monetization.addEventListener("monetizationstop", handleClose);
        return ()=>{
            document.monetization.removeEventListener("monetizationstop", handleClose);
        };
    });
    function handleAction(event) {
        (0, $9be7409470745503$export$7abc584011c1e113)();
        handleClose(event);
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $9b459f7d828eccca$export$2e2bcd8739ae039), {
        setRef: setRef,
        handleClose: handleClose,
        handleAction: handleAction,
        className: "toast-web-monetization",
        item: {
            ...item,
            mode: "success",
            action: intl.formatMessage({
                id: "menu.item.sign-in",
                defaultMessage: "Sign in"
            })
        },
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "toast-icon-header",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($034448cdb064f160$exports))),
                        alt: "Web Monetization icon",
                        className: "wm-icon"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h3", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "plus.web-monetization.thanks",
                            defaultMessage: "Thanks for your support!\u200E"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "plus.web-monetization.not-signed-in",
                    defaultMessage: "Your browser is sending Web Monetization payments. Sign in now to access your Streetmix+ benefits!\u200E"
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("strong", {
                        children: "Deprecation warning:"
                    }),
                    " The Coil plugin has been discontinued since February 2, 2023. We encourage all Coil plugin users to migrate to another service for Streetmix+ benefits.",
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                        href: "https://strt.mx/plus#coil",
                        children: "Learn more."
                    })
                ]
            })
        ]
    });
}
var $aec5207e84d27848$export$2e2bcd8739ae039 = $aec5207e84d27848$var$ToastWebMonetization;



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");




// Renders a specific type of Toast for Web Monetized users that are not signed in.
$7ec5cc30731eb2bc$var$ToastWebMonetizationSuccess.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
            "TOAST_WEB_MONETIZATION_SUCCESS"
        ]),
        action: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
    }),
    setRef: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    handleClose: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired
};
function $7ec5cc30731eb2bc$var$ToastWebMonetizationSuccess(props) {
    const { item: item, setRef: setRef, handleClose: handleClose } = props;
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    function handleAction(event) {
        window.open("https://docs.streetmix.net/user-guide/streetmix-plus", "_blank");
        handleClose(event);
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $9b459f7d828eccca$export$2e2bcd8739ae039), {
        setRef: setRef,
        handleClose: handleClose,
        handleAction: handleAction,
        className: "toast-web-monetization",
        item: {
            ...item,
            mode: "success",
            action: intl.formatMessage({
                id: "plus.web-monetization.learn-more",
                defaultMessage: "Learn more"
            })
        },
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "toast-icon-header",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($034448cdb064f160$exports))),
                        alt: "Web Monetization icon",
                        className: "wm-icon"
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h3", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "plus.web-monetization.thanks",
                            defaultMessage: "Thanks for your support!\u200E"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "plus.web-monetization.signed-in",
                    defaultMessage: "Your Web Monetization subscription gives you full access to Streetmix+ benefits.\u200E"
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("strong", {
                        children: "Deprecation warning:"
                    }),
                    " The Coil plugin has been discontinued since February 2, 2023. We encourage all Coil plugin users to migrate to another service for Streetmix+ benefits.",
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                        href: "https://strt.mx/plus#coil",
                        children: "Learn more."
                    })
                ]
            })
        ]
    });
}
var $7ec5cc30731eb2bc$export$2e2bcd8739ae039 = $7ec5cc30731eb2bc$var$ToastWebMonetizationSuccess;



const $3cadb6a82c779756$var$TOAST_SPRING_CONFIG = {
    tension: 488,
    friction: 36,
    precision: 0.01
};
const $3cadb6a82c779756$var$TOAST_DISPLAY_TIMEOUT = 6000;
const $3cadb6a82c779756$var$TOAST_MAX_TO_DISPLAY = 5;
/**
 * Based on react-spring "Notification hub" example.
 * https://codesandbox.io/s/v1i1t
 */ function $3cadb6a82c779756$var$ToastContainer(props) {
    const config = $3cadb6a82c779756$var$TOAST_SPRING_CONFIG;
    const [refMap] = (0, $4DE7A.useState)(()=>new WeakMap());
    const [cancelMap] = (0, $4DE7A.useState)(()=>new WeakMap());
    const toasts = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.toasts);
    const contentDirection = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.app.contentDirection);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const items = toasts.length >= $3cadb6a82c779756$var$TOAST_MAX_TO_DISPLAY ? toasts.slice(toasts.length - $3cadb6a82c779756$var$TOAST_MAX_TO_DISPLAY) : toasts;
    const transitions = (0, $2c03db10edbdd570$export$7b286972b8d8ccbf)(items, {
        from: {
            opacity: 0,
            height: 0,
            x: contentDirection === "rtl" ? -300 : 300,
            // `life` is just a variable name used by the react-spring example, it
            // has no special meaning. This is the only property that decreases
            // based on the `duration` property set in config
            life: "100%"
        },
        keys: (item)=>item.timestamp,
        enter: (item)=>async (next, cancel)=>{
                cancelMap.set(item, cancel);
                await next({
                    // Animate height to create space for the toast. Using
                    // `getBoundingClientRect()` gets us more precise values (decimals)
                    // and the +10 adds a margin between this and the next toast.
                    height: refMap.get(item).getBoundingClientRect().height + 10
                });
                await next({
                    opacity: 1,
                    x: 0
                });
                await next({
                    life: "0%"
                });
            },
        leave: [
            // First animate transition out
            {
                opacity: 0,
                x: contentDirection === "rtl" ? -300 : 300
            },
            {
                // Then animate height to zero so that subsequent messages "slide" upwards
                height: 0
            }
        ],
        onRest: (result, ctrl, item)=>{
            dispatch((0, $ed796acc6691d871$export$2babc7f6097192ff)(item.timestamp));
        },
        config: (item, index, phase)=>(key)=>phase === "enter" && key === "life" ? {
                    duration: item.duration ?? $3cadb6a82c779756$var$TOAST_DISPLAY_TIMEOUT
                } : config
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "toast-container",
        children: transitions(({ life: life, ...style }, item)=>{
            const setRef = (ref)=>ref && refMap.set(item, ref);
            const handleClose = (event)=>{
                // Not all instances of this function is called by an event handler
                if (event) event.stopPropagation();
                if (cancelMap.has(item) && life.get() !== "0%") cancelMap.get(item)();
            };
            let childComponent;
            switch(item.component){
                case "TOAST_UNDO":
                    childComponent = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $38bf1f4c309ebf74$export$2e2bcd8739ae039), {
                        setRef: setRef,
                        handleClose: handleClose,
                        item: item
                    });
                    break;
                case "TOAST_SIGN_IN":
                    childComponent = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $4a5b6f4fe1f0adb7$export$2e2bcd8739ae039), {
                        setRef: setRef,
                        handleClose: handleClose,
                        item: item
                    });
                    break;
                case "TOAST_WEB_MONETIZATION":
                    childComponent = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $aec5207e84d27848$export$2e2bcd8739ae039), {
                        setRef: setRef,
                        handleClose: handleClose
                    });
                    break;
                case "TOAST_WEB_MONETIZATION_SUCCESS":
                    childComponent = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $7ec5cc30731eb2bc$export$2e2bcd8739ae039), {
                        setRef: setRef,
                        handleClose: handleClose
                    });
                    break;
                case "TOAST_NO_CONNECTION":
                    childComponent = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $a55fcac896cbfb7c$export$2e2bcd8739ae039), {
                        setRef: setRef,
                        handleClose: handleClose,
                        item: item
                    });
                    break;
                default:
                    childComponent = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $9b459f7d828eccca$export$2e2bcd8739ae039), {
                        setRef: setRef,
                        handleClose: handleClose,
                        item: item
                    });
                    break;
            }
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $80a1228f70d6ae64$export$407448d2b89b1813).div, {
                style: style,
                children: childComponent
            });
        })
    });
}
var $3cadb6a82c779756$export$2e2bcd8739ae039 = $3cadb6a82c779756$var$ToastContainer;




var $4DE7A = parcelRequire("4DE7A");




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");









var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");




const $de187a18bf1dd34d$var$MAX_COMMENT_LENGTH = 280;
$de187a18bf1dd34d$var$VoteComment.propTypes = {
    streetId: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
};
function $de187a18bf1dd34d$var$VoteComment({ streetId: streetId }) {
    const [comment, setComment] = (0, $4DE7A.useState)("");
    const [isPending, setPending] = (0, $4DE7A.useState)(false);
    const [isComplete, setComplete] = (0, $4DE7A.useState)(false);
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    function handleSubmitComment(event) {
        setPending(true);
        try {
            // Only run if streetId is actually present.
            if (streetId) (0, $4ff1018a457d25d0$export$4ce1f0e4022d30be)({
                id: streetId,
                comment: comment
            });
        } catch (error) {
            console.error(error);
        }
        // Post comment here
        window.setTimeout(()=>{
            // Assume completion; fail silently on errors
            setComplete(true);
        }, 1000);
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "sentiment-survey-done-comment",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("input", {
                type: "text",
                value: comment,
                maxLength: $de187a18bf1dd34d$var$MAX_COMMENT_LENGTH,
                onChange: (e)=>setComment(e.target.value),
                placeholder: intl.formatMessage({
                    id: "sentiment.comment.example",
                    defaultMessage: "(for instance, \u201CI liked the trees.\u201D)"
                })
            }),
            isComplete ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "sentiment.comment.thanks",
                defaultMessage: "Got it!"
            }) : isPending ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $62d2815b920e2bc5$export$2e2bcd8739ae039), {
                size: "small"
            }) : /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                secondary: true,
                onClick: handleSubmitComment,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "sentiment.comment.submit",
                    defaultMessage: "Submit"
                })
            })
        ]
    });
}
var $de187a18bf1dd34d$export$2e2bcd8739ae039 = $de187a18bf1dd34d$var$VoteComment;



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");


$5ea27a06cc5f641b$var$SentimentIcon.propTypes = {
    score: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOf([
        -1,
        -0.5,
        0,
        0.5,
        1
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        localizationKey: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
        defaultMessage: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
    }),
    imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
};
function $5ea27a06cc5f641b$var$SentimentIcon({ score: score, label: label, imgSrc: imgSrc, className: className }) {
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    const text = intl.formatMessage({
        id: label.localizationKey,
        defaultMessage: label.defaultMessage
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: `sentiment-icon ${className}`,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
            src: imgSrc,
            draggable: "false",
            alt: text
        })
    });
}
var $5ea27a06cc5f641b$export$2e2bcd8739ae039 = $5ea27a06cc5f641b$var$SentimentIcon;


var $629e3b3ee3296f5d$exports = {};

$629e3b3ee3296f5d$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "1F620.49614bd7.svg";


var $3871c569c13447f1$exports = {};

$3871c569c13447f1$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "1F641.c7d9ee53.svg";


var $856425986e664a3a$exports = {};

$856425986e664a3a$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "1F610.71d15170.svg";


var $8cda10b32cd32920$exports = {};

$8cda10b32cd32920$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "1F60A.8a356ca2.svg";


var $54af3edb700ee81e$exports = {};

$54af3edb700ee81e$exports = (parcelRequire("kjrOk")).getBundleURL("5D0wD") + "1F60D.827fe010.svg";


const $11748848c09bf8c7$var$SCORE_DATA = [
    {
        score: -1,
        label: {
            localizationKey: "sentiment.answer.rating-1",
            defaultMessage: "Absolutely not"
        },
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($629e3b3ee3296f5d$exports))),
        className: "sentiment-1"
    },
    {
        score: -0.5,
        label: {
            localizationKey: "sentiment.answer.rating-2",
            defaultMessage: "Not very much"
        },
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($3871c569c13447f1$exports))),
        className: "sentiment-2"
    },
    {
        score: 0,
        label: {
            localizationKey: "sentiment.answer.rating-3",
            defaultMessage: "It\u2019s so-so"
        },
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($856425986e664a3a$exports))),
        className: "sentiment-3"
    },
    {
        score: 0.5,
        label: {
            localizationKey: "sentiment.answer.rating-4",
            defaultMessage: "A little bit"
        },
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($8cda10b32cd32920$exports))),
        className: "sentiment-4"
    },
    {
        score: 1,
        label: {
            localizationKey: "sentiment.answer.rating-5",
            defaultMessage: "Quite a lot"
        },
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($54af3edb700ee81e$exports))),
        className: "sentiment-5"
    }
];
function $11748848c09bf8c7$export$c0db5b52e4e93261(score) {
    return $11748848c09bf8c7$var$SCORE_DATA.find((d)=>d.score === score);
}
function $11748848c09bf8c7$export$f588a75a49439452() {
    return $11748848c09bf8c7$var$SCORE_DATA;
}



$f8f70cb877af9118$var$VoteReceipt.propTypes = {
    score: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    handleClose: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    streetId: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
};
function $f8f70cb877af9118$var$VoteReceipt({ score: score, handleClose: handleClose, streetId: streetId }) {
    const doneEl = (0, $4DE7A.useRef)(null);
    // When a score is received, we animate the background container
    // in first (which "fades out" the original content, then fade in
    // the new content on top of it.)
    (0, $4DE7A.useEffect)(()=>{
        if (score !== null) window.setTimeout(()=>{
            if (!doneEl.current) return;
            doneEl.current.classList.add("visible");
            window.setTimeout(()=>{
                if (!doneEl.current) return;
                doneEl.current.querySelector("div").classList.add("visible");
            }, 600);
        }, 1200);
    }, [
        score
    ]);
    if (score === null) return null;
    const vote = (0, $11748848c09bf8c7$export$c0db5b52e4e93261)(score);
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "sentiment-survey-done-container",
        ref: doneEl,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
            className: "sentiment-survey-done-content",
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h2", {
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "sentiment.thank-you",
                        defaultMessage: "Thank you!"
                    })
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                    className: "sentiment-survey-done-text",
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5ea27a06cc5f641b$export$2e2bcd8739ae039), {
                                ...vote
                            })
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("strong", {
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "sentiment.prompt.joyful",
                                            defaultMessage: "Would you say this street feels <em>joyful</em>?",
                                            values: {
                                                // eslint-disable-next-line react/display-name
                                                em: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("em", {
                                                        children: chunks
                                                    })
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "sentiment.done.response",
                                            defaultMessage: "You responded {score}.",
                                            values: {
                                                score: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("em", {
                                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                                        id: vote.label.localizationKey,
                                                        defaultMessage: vote.label.defaultMessage
                                                    })
                                                })
                                            }
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "sentiment.comment.prompt",
                                            defaultMessage: "Tell us why:"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $de187a18bf1dd34d$export$2e2bcd8739ae039), {
                                    streetId: streetId
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                    className: "sentiment-survey-done-buttons",
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                            primary: true,
                            href: "/survey",
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "sentiment.done.vote-another",
                                defaultMessage: "Vote on another!"
                            })
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                            tertiary: true,
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "sentiment.done.really-done",
                                defaultMessage: "All done!"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
var $f8f70cb877af9118$export$2e2bcd8739ae039 = $f8f70cb877af9118$var$VoteReceipt;



parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");




$29a342aecaf04677$var$VoteButtons.propTypes = {
    handleVote: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    selectedScore: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
};
function $29a342aecaf04677$var$VoteButtons({ handleVote: handleVote, selectedScore: selectedScore }) {
    const [source, target] = (0, $7de18142ef01be1a$export$abf4268d2dd55708)();
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
                placement: "bottom",
                source: source
            }),
            (0, $11748848c09bf8c7$export$f588a75a49439452)().map((vote)=>{
                const label = intl.formatMessage({
                    id: vote.label.localizationKey,
                    defaultMessage: vote.label.defaultMessage
                });
                return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $448ac9151c2238c6$export$2e2bcd8739ae039), {
                    label: label,
                    target: target,
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
                        className: [
                            "sentiment-button",
                            selectedScore === vote.score ? "sentiment-selected" : ""
                        ].join(" ").trim(),
                        onClick: (e)=>handleVote(vote.score, event),
                        disabled: selectedScore !== null,
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $5ea27a06cc5f641b$export$2e2bcd8739ae039), {
                            ...vote
                        })
                    })
                }, vote.score);
            })
        ]
    });
}
var $29a342aecaf04677$export$2e2bcd8739ae039 = $29a342aecaf04677$var$VoteButtons;



function $b32bf68e44ba6f70$var$SentimentSurvey({ visible: visible = false, onClose: onClose = ()=>{}, handleVote: handleVote, streetId: streetId }) {
    const [score, setScore] = (0, $4DE7A.useState)(null);
    const isUserSignedIn = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.user.signedIn);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const transitions = (0, $2c03db10edbdd570$export$7b286972b8d8ccbf)(visible, {
        from: {
            y: -50,
            opacity: 0
        },
        enter: {
            y: 0,
            opacity: 1
        },
        leave: {
            y: -50,
            opacity: 0
        },
        config: (0, $2c03db10edbdd570$export$e506a1d27d1eaa20).wobbly
    });
    const classNames = [
        "sentiment-survey-container"
    ];
    if (visible === true) classNames.push("sentiment-survey-visible");
    function handleClick(score, event) {
        // Do not handle this vote if the user is not signed in.
        // These vote buttons are normally blocked if the user is not signed in,
        // but we have to verify this in case that DOM element fails or is user-
        // edited out of existence.
        if (!isUserSignedIn) return;
        setScore(score);
        handleVote(score);
    }
    function handleClickAbout(event) {
        dispatch((0, $cdf0aaca62d15025$export$61e0a65f251cfdb3)("SENTIMENT_SURVEY"));
    }
    function handleClickSignIn(event) {
        (0, $9be7409470745503$export$7abc584011c1e113)();
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: classNames.join(" "),
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "sentiment-survey-background"
            }),
            transitions((style, item)=>item && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $80a1228f70d6ae64$export$407448d2b89b1813).div, {
                    className: "sentiment-survey-dialog",
                    style: style,
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $f9d7843891fda220$export$2e2bcd8739ae039), {
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "sentiment.prompt.intro",
                                defaultMessage: "<strong>Pardon the interruption.</strong> We\u2019d love your feedback on this street.",
                                values: {
                                    // eslint-disable-next-line react/display-name
                                    strong: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("strong", {
                                            children: chunks
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h2", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "sentiment.prompt.joyful",
                                defaultMessage: "Would you say this street feels <em>joyful</em>?",
                                values: {
                                    // eslint-disable-next-line react/display-name
                                    em: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("em", {
                                            children: chunks
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("sub", {
                            children: isUserSignedIn ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "sentiment.prompt.choose-one",
                                defaultMessage: "(choose one)"
                            }) : /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "sentiment.sign-in-prompt",
                                defaultMessage: "Please sign in now to make your voice heard."
                            })
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                            className: "sentiment-survey-buttons",
                            children: [
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $29a342aecaf04677$export$2e2bcd8739ae039), {
                                    handleVote: handleClick,
                                    selectedScore: score
                                }),
                                !isUserSignedIn && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                                    className: "sentiment-survey-sign-in-prompt",
                                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                                        primary: true,
                                        onClick: handleClickSignIn,
                                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                            id: "menu.item.sign-in",
                                            defaultMessage: "Sign in"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                            className: "sentiment-survey-about-link",
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
                                className: "link-like",
                                onClick: handleClickAbout,
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "sentiment.about-link",
                                    defaultMessage: "Why am I seeing this?"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $f8f70cb877af9118$export$2e2bcd8739ae039), {
                            score: score,
                            handleClose: onClose,
                            streetId: streetId
                        })
                    ]
                }))
        ]
    });
}
$b32bf68e44ba6f70$var$SentimentSurvey.propTypes = {
    visible: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
    handleVote: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
    streetId: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
};
var $b32bf68e44ba6f70$export$2e2bcd8739ae039 = $b32bf68e44ba6f70$var$SentimentSurvey;


const $9536f6319e688cb2$var$SURVEY_DELAY_BEFORE_APPEAR = 5000 // in ms
;
function $9536f6319e688cb2$var$SentimentSurveyContainer(props) {
    const [isVisible, setVisible] = (0, $4DE7A.useState)(false);
    const [isDismissed, setDismissed] = (0, $4DE7A.useState)(false);
    const [streetId, setStreetId] = (0, $4DE7A.useState)(null);
    const street = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street);
    const isEnabled = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>// Enabled when the feature flag is true
        state.flags.SENTIMENT_SURVEY?.value === true && // Enabled if locale is English (or any other supported locale; for
        // now, this is going to be hard-coded when needed)
        [
            "en",
            "es-419"
        ].includes(state.locale.locale) && // Show if user is not the same the current street's creator
        state.user.signInData?.userId !== street.creatorId && // Show if gallery is not open
        state.gallery.visible === false && // Show if the street is geolocated
        street.location !== null && // Show if the street has had more than a number of edits to it
        street.editCount > 10 && // Show if the street segments fit street width exactly
        street.remainingWidth === 0);
    (0, $4DE7A.useEffect)(()=>{
        if (!isDismissed) window.setTimeout(()=>{
            setVisible(true);
        }, $9536f6319e688cb2$var$SURVEY_DELAY_BEFORE_APPEAR);
    // only re-run the effect if the value of isDismissed has changed
    // previously, the useEffect hook was getting called several times
    }, [
        isDismissed
    ]);
    function handleClose() {
        setDismissed(true);
        setVisible(false);
    }
    async function handleVote(score) {
        // Post the vote information immediately
        // Let's allow this to fail silently (if there is a problem, the user
        // doesn't need to know, but we still log the error internally)
        try {
            const response = await (0, $4ff1018a457d25d0$export$58f7aad3486f5b80)({
                score: score,
                data: street,
                streetId: street.id
            });
            if (response.status === 200) setStreetId(response.data.savedBallot.id);
        } catch (error) {
            console.error(error);
        }
    }
    if (isEnabled) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $b32bf68e44ba6f70$export$2e2bcd8739ae039), {
        visible: isVisible,
        onClose: handleClose,
        handleVote: handleVote,
        streetId: streetId
    });
    return null;
}
var $9536f6319e688cb2$export$2e2bcd8739ae039 = $9536f6319e688cb2$var$SentimentSurveyContainer;




var $6effca967e0cc0d0$exports = {};
$6effca967e0cc0d0$exports = JSON.parse('{"display":false,"lede":"We stand with the Black community and against police brutality.","link":"https://blacklivesmatters.carrd.co/","linkText":"Learn about ways you can help.","_lede":"We\u2019ve got swag!","_text":"And so can you. Streetmix t-shirts and hoodies are now available!","_link":"https://cottonbureau.com/people/streetmix","_linkText":"Take me to the store","_localStorageKey":"notification-store-dismissed"}');




var $4DE7A = parcelRequire("4DE7A");




function $e02cc5ac5505ac75$var$DebugInfo() {
    const panelEl = (0, $4DE7A.useRef)(null);
    const textareaEl = (0, $4DE7A.useRef)(null);
    const [isVisible, setVisible] = (0, $4DE7A.useState)(false);
    const settings = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.settings);
    const street = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.street);
    const flags = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.flags);
    const history = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.history);
    const user = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.user);
    // Register keyboard input for show (shift-D)
    (0, $4DE7A.useEffect)(()=>{
        window.addEventListener("keydown", showDebugInfo);
        return ()=>{
            window.removeEventListener("keydown", showDebugInfo);
        };
    });
    // Handle esc keybinding
    // This appears to be used because there is a problem with registerKeypress()
    (0, $4DE7A.useEffect)(()=>{
        if (isVisible) // Set up keypress listener to close debug window
        window.addEventListener("keydown", hideDebugInfo);
        else // Remove keypress listener
        window.removeEventListener("keydown", hideDebugInfo);
        // Clean up in case component is unmounted before hiding
        return ()=>{
            window.removeEventListener("keydown", hideDebugInfo);
        };
    }, [
        isVisible
    ]);
    // Handle DOM effects when show / hide
    // useLayoutEffect helps with timing issues with DOM manipulation
    (0, $4DE7A.useLayoutEffect)(()=>{
        if (textareaEl.current === null) return;
        if (isVisible) {
            textareaEl.current.value = JSON.stringify({
                street: street,
                user: user,
                settings: settings,
                flags: flags,
                history: history
            }, null, 2);
            textareaEl.current.focus();
            textareaEl.current.select();
            // Prevent scrolling to bottom of textarea after select
            // NOTE: this is still not 100% deterministic, not sure why
            window.setTimeout(()=>{
                if (textareaEl.current) textareaEl.current.scrollTop = 0;
            }, 0);
        }
    }, [
        isVisible,
        settings,
        street,
        flags,
        history,
        user
    ]);
    // This should only be called when the debug window becomes invisible.
    // This will also be called once during component initialization, that
    // __should__ be okay.
    (0, $4DE7A.useLayoutEffect)(()=>{
        if (!isVisible) // This is a very aggressive focus puller. Don't ever call this in
        // an effect that has other dependencies!
        (0, $a23f2f80a71fc2aa$export$25f99d22563e3d91)();
    }, [
        isVisible
    ]);
    // Set up handler to close dialogs when clicking outside of it
    (0, $baa5f10dda5386f3$export$9afc64c180e82dc4)(panelEl, ()=>{
        setVisible(false);
    });
    function showDebugInfo(event) {
        const el = event.target;
        // Do not display debug info when the key combo is pressed inside of an input element
        if (event.key === "D" && !/input|textarea/i.test(el?.tagName)) setVisible(true);
    }
    function hideDebugInfo(event) {
        if (event.key === "Esc" || event.key === "Escape") setVisible(false);
    }
    if (isVisible) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "debug-container",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
            className: "debug-panel",
            ref: panelEl,
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h2", {
                    children: "Debug"
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("textarea", {
                    readOnly: true,
                    wrap: "off",
                    ref: textareaEl
                })
            ]
        })
    });
    // Don't render any DOM if invisible
    return null;
}
var $e02cc5ac5505ac75$export$2e2bcd8739ae039 = $e02cc5ac5505ac75$var$DebugInfo;


/**
 * It's kinda the same as BlockingError, but not
 *
 * Blocking shield is an overlay over the screen that prevents
 * interaction. At its most basic version it is fully transparent
 * and allows other UI to take priority (e.g. gallery). At other
 * times it can be "darkened" (creating a translucent overlay)
 * showing messages or errors.
 */ 

var $4DE7A = parcelRequire("4DE7A");





const $c19d754c5d86a407$var$BLOCKING_SHIELD_DARKEN_DELAY = 800;
const $c19d754c5d86a407$var$BLOCKING_SHIELD_TOO_SLOW_DELAY = 10000;
class $c19d754c5d86a407$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Component {
    constructor(props){
        super(props);
        this.el = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createRef();
        this.blockingShieldTimerId = -1;
        this.blockingShieldTooSlowTimerId = -1;
        this.state = {
            visible: false,
            mode: "load",
            errorType: null,
            immediate: false,
            darken: false,
            showCancel: false
        };
    }
    /* TODO: move blocking shield state to Redux store */ componentDidMount() {
        window.addEventListener("stmx:show_blocking_shield", this.showBlockingShield);
        window.addEventListener("stmx:darken_blocking_shield", this.darkenBlockingShield);
        window.addEventListener("stmx:hide_blocking_shield", this.hide);
    }
    componentWillUnmount() {
        window.removeEventListener("stmx:show_blocking_shield", this.showBlockingShield);
        window.removeEventListener("stmx:darken_blocking_shield", this.darkenBlockingShield);
        window.removeEventListener("stmx:hide_blocking_shield", this.hide);
    }
    clearTimers = ()=>{
        window.clearTimeout(this.blockingShieldTimerId);
        window.clearTimeout(this.blockingShieldTooSlowTimerId);
    };
    showBlockingShield = (event)=>{
        this.clearTimers();
        this.setState({
            visible: true,
            // Internet Explorer and some other browsers may not support `event.detail`
            // See Sentry #STREETMIX-2MM
            //  https://sentry.io/share/issue/25aaf22cd58647b8b3402f77875fd5ee/
            mode: event.detail && event.detail.mode || "load"
        });
        this.blockingShieldTimerId = window.setTimeout(()=>{
            this.setState({
                darken: true
            });
        }, $c19d754c5d86a407$var$BLOCKING_SHIELD_DARKEN_DELAY);
        this.blockingShieldTooSlowTimerId = window.setTimeout(()=>{
            this.setState({
                errorType: "too-slow"
            });
        }, $c19d754c5d86a407$var$BLOCKING_SHIELD_TOO_SLOW_DELAY);
    };
    darkenBlockingShield = (event)=>{
        this.clearTimers();
        this.setState({
            visible: true,
            immediate: true,
            errorType: "try-again",
            showCancel: event.detail && event.detail.showCancel || true
        });
    };
    handleClickTryAgain = (event)=>{
        this.setState({
            errorType: null,
            showCancel: false
        });
        (0, $ec6ccb5735a32e28$export$3094dd6b6c3704b6)();
    };
    handleClickCancel = (event)=>{
        this.hide();
        (0, $ec6ccb5735a32e28$export$d3587b5143154d9)();
    };
    hide = ()=>{
        this.clearTimers();
        this.setState({
            visible: false,
            errorType: null,
            immediate: false,
            darken: false,
            showCancel: false
        });
    };
    render() {
        const classNames = [
            "blocking-shield"
        ];
        if (this.state.visible) classNames.push("visible");
        if (this.state.immediate) classNames.push("darken-immediately");
        if (this.state.darken) classNames.push("darken");
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
            className: classNames.join(" "),
            ref: this.el,
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                    className: "message",
                    children: [
                        this.state.mode === "load" && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "msg.loading",
                            defaultMessage: "Loading\u2026"
                        }),
                        this.state.mode === "remix" && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "msg.remixing",
                            defaultMessage: "Remixing\u2026"
                        })
                    ]
                }),
                this.state.errorType === "try-again" && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                    className: "error-content",
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "msg.no-connection",
                                defaultMessage: "Streetmix is having trouble connecting to the Internet."
                            })
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                            onClick: this.handleClickTryAgain,
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "btn.try-again",
                                defaultMessage: "Try again"
                            })
                        }),
                        this.state.showCancel && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                            onClick: this.handleClickCancel,
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "btn.cancel",
                                defaultMessage: "Cancel"
                            })
                        })
                    ]
                }),
                this.state.errorType === "too-slow" && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                    className: "error-content",
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "msg.slow-connection-1",
                                defaultMessage: "Streetmix wasn\u2019t able to connect to the Internet in awhile now."
                            })
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "msg.slow-connection-2",
                                defaultMessage: "You might want to reload the page and try again. Please note you might lose the latest change to the street. Sorry!"
                            })
                        }),
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                            onClick: (0, $f3d8f18722148e05$export$d3501e855596718a),
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "btn.reload",
                                defaultMessage: "Reload"
                            })
                        })
                    ]
                })
            ]
        });
    }
}


/**
 * BlockingError.jsx
 *
 * Displays a blocking error message on top of the application.
 *
 * @module BlockingError
 */ 
parcelRequire("4DE7A");









function $7d35f471242169e1$var$BlockingError(props) {
    const errorType = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.errors.errorType);
    const street = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street);
    const { data: creatorProfile } = (0, $e2f405c0a03fcace$export$9beb97f355b95ab9)(street.creatorId);
    let title = "";
    let description = "";
    let cta = "";
    const homeButton = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
        primary: true,
        onClick: (0, $f3d8f18722148e05$export$7f31ee2b5ad7de8c),
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "error.button.return",
            defaultMessage: "Return to Streetmix"
        })
    });
    const linkToUser = (street)=>{
        return street && street.creatorId ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("a", {
            href: "/" + street.creatorId,
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $aad6e9d6c00e3001$export$2e2bcd8739ae039), {
                    userId: street.creatorId
                }),
                creatorProfile?.displayName || street.creatorId
            ]
        }) : null;
    };
    const reloadButton = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
        primary: true,
        onClick: (0, $f3d8f18722148e05$export$d3501e855596718a),
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "error.button.reload",
            defaultMessage: "Reload the page"
        })
    });
    const tryAgainButton = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
        primary: true,
        onClick: (0, $f3d8f18722148e05$export$a22ca88ad1ac21dd),
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "error.button.try-again",
            defaultMessage: "Try again"
        })
    });
    const signInButton = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
        primary: true,
        onClick: (0, $9be7409470745503$export$7abc584011c1e113),
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
            id: "menu.item.sign-in",
            defaultMessage: "Sign in"
        })
    });
    const pleaseLetUsKnow = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
        id: "error.please-try-again-contact-us",
        defaultMessage: "Please try again later. If you still need help, please <a>contact us</a>.",
        values: {
            // eslint-disable-next-line react/display-name
            a: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                    href: "https://docs.streetmix.net/community",
                    children: chunks
                })
        }
    });
    const needHelpLink = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
        className: "error-help-link",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
            href: "https://docs.streetmix.net/user-guide/support/troubleshooting",
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.need-help-link",
                defaultMessage: "Need help?"
            })
        })
    });
    switch(errorType){
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).NOT_FOUND:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.page-not-found-title",
                defaultMessage: "Page not found."
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "error.page-not-found-description",
                    defaultMessage: "Oh, boy. There is no page with this address!"
                })
            });
            cta = homeButton;
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).STREET_404:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.street-not-found-title",
                defaultMessage: "Street not found."
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "error.street-not-found-description",
                    defaultMessage: "Oh, boy. There is no street with this link!"
                })
            });
            cta = homeButton;
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).STREET_404_BUT_LINK_TO_USER:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.street-not-found-title",
                defaultMessage: "Street not found."
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "error.street-not-found-but-user-description",
                    defaultMessage: "There is no street with this link! But you can look at other streets by {user}",
                    values: {
                        user: linkToUser(street)
                    }
                })
            });
            cta = homeButton;
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).STREET_410_BUT_LINK_TO_USER:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.street-deleted-title",
                defaultMessage: "This street has been deleted."
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "error.street-deleted-description",
                    defaultMessage: "There is no longer a street with this link, but you can look at other streets by {user}",
                    values: {
                        user: linkToUser(street)
                    }
                })
            });
            cta = homeButton;
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).SIGN_OUT:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.sign-out-title",
                defaultMessage: "You are now signed out."
            });
            cta = homeButton;
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).NO_STREET:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "msg.no-street",
                defaultMessage: "No street selected."
            });
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).GALLERY_STREET_FAILURE:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "msg.having-trouble",
                defaultMessage: "Having trouble\u2026"
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "error.gallery-street-failure-description",
                    defaultMessage: "We\u2019re having trouble loading this street."
                })
            });
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).FORCE_RELOAD_SIGN_OUT:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.reload-sign-out-title",
                defaultMessage: "You signed out in another window."
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "error.please-reload",
                    defaultMessage: "Please reload this page to return to Streetmix."
                })
            });
            cta = reloadButton;
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).FORCE_RELOAD_SIGN_IN:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.reload-sign-in-title",
                defaultMessage: "You signed in in another window."
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "error.please-reload",
                    defaultMessage: "Please reload this page to return to Streetmix."
                })
            });
            cta = reloadButton;
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).AUTH_EXPIRED:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.auth-expired",
                defaultMessage: "We automatically signed you out due to inactivity."
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "error.sign-in-again",
                    defaultMessage: "Please sign in again."
                })
            });
            cta = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                children: [
                    signInButton,
                    "\xa0",
                    homeButton
                ]
            });
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).STREET_DELETED_ELSEWHERE:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.street-deleted-elsewhere-title",
                defaultMessage: "This street has been deleted elsewhere."
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "error.street-deleted-elsewhere-description",
                    defaultMessage: "This street has been deleted in another browser."
                })
            });
            cta = homeButton;
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).NEW_STREET_SERVER_FAILURE:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "msg.having-trouble",
                defaultMessage: "Having trouble\u2026"
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "msg.trouble-loading",
                    defaultMessage: "We\u2019re having trouble loading Streetmix."
                })
            });
            cta = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                children: [
                    tryAgainButton,
                    needHelpLink
                ]
            });
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).SIGN_IN_SERVER_FAILURE:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "msg.having-trouble",
                defaultMessage: "Having trouble\u2026"
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "msg.trouble-loading",
                        defaultMessage: "We\u2019re having trouble loading Streetmix."
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "error.error-code",
                        defaultMessage: "(Error {code}.)",
                        values: {
                            code: "15A"
                        }
                    })
                ]
            });
            cta = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                children: [
                    tryAgainButton,
                    needHelpLink
                ]
            });
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).SIGN_IN_401:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "msg.having-trouble",
                defaultMessage: "Having trouble\u2026"
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "msg.trouble-loading",
                        defaultMessage: "We\u2019re having trouble loading Streetmix."
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "error.error-code",
                        defaultMessage: "(Error {code}.)",
                        values: {
                            code: "RM1"
                        }
                    })
                ]
            });
            cta = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                children: [
                    tryAgainButton,
                    needHelpLink
                ]
            });
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).STREET_DATA_FAILURE:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "msg.having-trouble",
                defaultMessage: "Having trouble\u2026"
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "msg.trouble-loading",
                        defaultMessage: "We\u2019re having trouble loading Streetmix."
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "error.error-code",
                        defaultMessage: "(Error {code}.)",
                        values: {
                            code: "9B"
                        }
                    })
                ]
            });
            cta = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                children: [
                    tryAgainButton,
                    needHelpLink
                ]
            });
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).ACCESS_DENIED:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.access-denied-title",
                defaultMessage: "You are not signed in."
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "error.access-denied-description",
                    defaultMessage: "You cancelled the sign in process."
                })
            });
            cta = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                children: [
                    homeButton,
                    needHelpLink
                ]
            });
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).AUTH_PROBLEM_NO_TWITTER_REQUEST_TOKEN:
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).AUTH_PROBLEM_NO_TWITTER_ACCESS_TOKEN:
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).AUTH_PROBLEM_NO_ACCESS_TOKEN:
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).AUTH_PROBLEM_API_PROBLEM:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.auth-api-problem-title",
                defaultMessage: "There was a problem with signing you in."
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "error.auth-api-problem-description",
                        defaultMessage: "There was a problem with authentication."
                    }),
                    "\xa0",
                    pleaseLetUsKnow
                ]
            });
            cta = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                children: [
                    homeButton,
                    needHelpLink
                ]
            });
            break;
        // Deprecated.
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).UNSUPPORTED_BROWSER:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.unsupported-browser-title",
                defaultMessage: "Streetmix doesn\u2019t work on your browser."
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "error.unsupported-browser-description",
                            defaultMessage: "Sorry about that. You might want to try <chrome_link>Chrome</chrome_link>, <firefox_link>Firefox</firefox_link>, <edge_link>Microsoft Edge</edge_link>, or Safari.",
                            values: {
                                // eslint-disable-next-line react/display-name
                                chrome_link: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                        href: "https://www.google.com/chrome",
                                        children: chunks
                                    }),
                                // eslint-disable-next-line react/display-name
                                firefox_link: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                        href: "https://www.mozilla.org/firefox",
                                        children: chunks
                                    }),
                                // eslint-disable-next-line react/display-name
                                edge_link: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                        href: "https://www.microsoft.com/en-us/windows/microsoft-edge",
                                        children: chunks
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "error.unsupported-browser-internet-explorer",
                            defaultMessage: "Are you on Internet Explorer? <a>Find out more.</a>",
                            values: {
                                // eslint-disable-next-line react/display-name
                                a: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                        href: "https://docs.streetmix.net/user-guide/support/faq#internet-explorer",
                                        children: chunks
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "error.unsupported-browser-contact-us",
                            defaultMessage: "If you think your browser should be supported, please <a>contact us</a>.",
                            values: {
                                // eslint-disable-next-line react/display-name
                                a: (chunks)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                                        href: "https://docs.streetmix.net/community",
                                        children: chunks
                                    })
                            }
                        })
                    })
                ]
            });
            break;
        case (0, $5af1a42dad139206$export$4fd720569787ab6f).CANNOT_CREATE_NEW_STREET_ON_PHONE:
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.cannot-create-new-street-on-phone-title",
                defaultMessage: "Streetmix works on tablets and desktops only."
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "error.cannot-create-new-street-on-phone-description",
                    defaultMessage: "If you follow another link to a specific street, you can view it on your phone \u2013 but you cannot yet create new streets."
                })
            });
            cta = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                primary: true,
                onClick: (0, $f3d8f18722148e05$export$a87b9917f4982a24),
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "error.button.view-example",
                    defaultMessage: "View an example street"
                })
            });
            break;
        default:
            // also ERRORS.GENERIC_ERROR
            title = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "error.generic-error-title",
                defaultMessage: "Something went wrong."
            });
            description = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "error.generic-error-description",
                        defaultMessage: "We\u2019re sorry \u2013 something went wrong."
                    }),
                    "\xa0",
                    pleaseLetUsKnow
                ]
            });
            cta = homeButton;
            break;
    }
    return errorType ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        id: "error",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
            className: "error-content",
            children: [
                errorType !== (0, $5af1a42dad139206$export$4fd720569787ab6f).NO_STREET && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                    className: "streetmix-logo"
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                    className: "error-text",
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                            children: title
                        }),
                        description
                    ]
                }),
                cta
            ]
        })
    }) : null;
}
var $7d35f471242169e1$export$2e2bcd8739ae039 = $7d35f471242169e1$var$BlockingError;


/**
 * StreetView.jsx
 *
 * Renders the street view.
 *
 * @module StreetView
 */ 

var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");



var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");







class $63767c842c1edb41$var$Building extends (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Component {
    static propTypes = {
        // Provided by parent
        position: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string.isRequired,
        buildingWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        updatePerspective: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
        // Provided by Redux store
        street: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object,
        activeSegment: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
        leftBuildingEditable: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
        rightBuildingEditable: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
        // Provided by Redux action dispatchers
        addBuildingFloor: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
        removeBuildingFloor: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func
    };
    static defaultProps = {
        leftBuildingEditable: true,
        rightBuildingEditable: true
    };
    constructor(props){
        super(props);
        this.state = {
            variant: props.position === (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd) ? "leftBuildingVariant" : "rightBuildingVariant",
            height: props.position === (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd) ? "leftBuildingHeight" : "rightBuildingHeight",
            oldBuildingEnter: true,
            newBuildingEnter: false,
            switchBuildings: false,
            isEditable: true
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.leftBuildingEditable === false && props.position === (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd)) return {
            isEditable: false
        };
        else if (props.rightBuildingEditable === false && props.position === (0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492)) return {
            isEditable: false
        };
        else return {
            isEditable: true
        };
    }
    componentDidUpdate(prevProps, prevState) {
        const { street: street, position: position, buildingWidth: buildingWidth } = this.props;
        const { variant: variant, height: height } = this.state;
        const lastOverflow = prevProps.street.remainingWidth < 0;
        const streetOverflow = street.remainingWidth < 0;
        if (prevProps.street[height] !== street[height] || lastOverflow !== streetOverflow || street[variant] && prevProps.buildingWidth !== buildingWidth) (0, $2690ac3abe906938$export$1078ade21bd4346)(this.streetSectionBuilding, street[variant], position, street[height], streetOverflow);
        if (prevProps.street[variant] && prevProps.street[variant] !== street[variant]) {
            if (this.shouldBuildingAnimate(prevProps.street, street)) this.handleSwitchBuildings();
            else (0, $2690ac3abe906938$export$1078ade21bd4346)(this.streetSectionBuilding, street[variant], position, street[height], streetOverflow);
        }
        if (prevState.switchBuildings !== this.state.switchBuildings) {
            this.props.updatePerspective(this.oldStreetSectionBuilding);
            this.props.updatePerspective(this.streetSectionBuilding);
            (0, $2690ac3abe906938$export$1078ade21bd4346)(this.streetSectionBuilding, street[variant], position, street[height], streetOverflow);
        }
    }
    handleBuildingMouseEnter = (event)=>{
        if (!this.state.isEditable) return;
        window.addEventListener("keydown", this.handleKeyDown);
        let type;
        if (this.props.position === (0, $e1cc3cddc7acf1a4$export$7211beef3b5b06fd)) type = (0, $4fd11a0514b0f864$export$e446af77b1e2d289);
        else if (this.props.position === (0, $e1cc3cddc7acf1a4$export$876aaa6ed6810492)) type = (0, $4fd11a0514b0f864$export$f3a5b4072e475415);
        (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).considerShowing(event, this.streetSectionBuilding, type);
    };
    handleBuildingMouseLeave = (event)=>{
        if (!this.state.isEditable) return;
        window.removeEventListener("keydown", this.handleKeyDown);
        if ((0, $62b1ef0171009a7b$export$8a66765a71c06fe6).considerSegmentEl === this.streetSectionBuilding) (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).dontConsiderShowing();
    };
    handleKeyDown = (event)=>{
        if (!this.state.isEditable) return;
        const negative = event.key === "-";
        // Plus (+) may only triggered with shift key, so also check if
        // the same physical key (Equal) is pressed
        const positive = event.key === "+" || event.code === "Equal";
        const variant = this.props.street[this.state.variant];
        const hasFloors = (0, $2690ac3abe906938$export$68f9303c71cd9a6d)[variant].hasFloors;
        if (negative && hasFloors) this.props.removeBuildingFloor(this.props.position);
        else if (positive && hasFloors) this.props.addBuildingFloor(this.props.position);
        event.preventDefault();
    };
    changeRefs = (ref, isOldBuilding)=>{
        if (!this.state.switchBuildings && !isOldBuilding) return;
        if (this.state.switchBuildings && isOldBuilding) this.oldStreetSectionBuilding = ref;
        else this.streetSectionBuilding = ref;
    };
    handleSwitchBuildings = ()=>{
        this.setState({
            switchBuildings: !this.state.switchBuildings,
            newBuildingEnter: !this.state.newBuildingEnter,
            oldBuildingEnter: !this.state.oldBuildingEnter
        });
    };
    // Animate if the only changes in street object are:
    // editCount, rightBuildingVariant (or leftBuildingVariant), updatedAt, and clientUpdatedAt
    shouldBuildingAnimate = (oldStreet, newStreet)=>{
        let userUpdated = true;
        for(const key in newStreet)if (oldStreet[key] !== newStreet[key]) {
            userUpdated = [
                "editCount",
                this.state.variant,
                "updatedAt",
                "clientUpdatedAt"
            ].includes(key);
            if (!userUpdated) return false;
        }
        return userUpdated;
    };
    renderBuilding = (building)=>{
        const isOldBuilding = building === "old";
        const style = {
            [this.props.position]: `-${this.props.buildingWidth}px`,
            width: this.props.buildingWidth + "px"
        };
        const classNames = [
            "street-section-building"
        ];
        // Add a class name for building position
        classNames.push(`street-segment-building-${this.props.position}`);
        if (isOldBuilding && this.props.activeSegment === this.props.position) classNames.push("hover");
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("section", {
            className: classNames.join(" "),
            ref: (ref)=>{
                this.changeRefs(ref, isOldBuilding);
            },
            onMouseEnter: this.handleBuildingMouseEnter,
            onMouseLeave: this.handleBuildingMouseLeave,
            style: style,
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "hover-bk"
            })
        });
    };
    render() {
        const { newBuildingEnter: newBuildingEnter, oldBuildingEnter: oldBuildingEnter } = this.state;
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $13c11db3c6cdc4a8$export$2e2bcd8739ae039), {
                    in: newBuildingEnter,
                    timeout: 250,
                    classNames: "switching-in",
                    onEntered: this.handleSwitchBuildings,
                    unmountOnExit: true,
                    children: this.renderBuilding("new")
                }, "new-building"),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $13c11db3c6cdc4a8$export$2e2bcd8739ae039), {
                    in: oldBuildingEnter,
                    timeout: 250,
                    classNames: "switching-away",
                    unmountOnExit: true,
                    children: this.renderBuilding("old")
                }, "old-building")
            ]
        });
    }
}
function $63767c842c1edb41$var$mapStateToProps(state) {
    return {
        street: state.street,
        activeSegment: typeof state.ui.activeSegment === "string" ? state.ui.activeSegment : null,
        leftBuildingEditable: state.flags.EDIT_BUILDINGS_LEFT.value,
        rightBuildingEditable: state.flags.EDIT_BUILDINGS_RIGHT.value
    };
}
const $63767c842c1edb41$var$mapDispatchToProps = {
    removeBuildingFloor: $8b007b7ac0907036$export$3774ee57e8d91092,
    addBuildingFloor: $8b007b7ac0907036$export$2ddfb6d386c1281f
};
var $63767c842c1edb41$export$2e2bcd8739ae039 = (0, $a4829965bb94612b$export$2e2bcd8739ae039)($63767c842c1edb41$var$mapStateToProps, $63767c842c1edb41$var$mapDispatchToProps)($63767c842c1edb41$var$Building);




var $4DE7A = parcelRequire("4DE7A");







function $e7eba4b896e98618$var$ResizeGuides() {
    const isVisible = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)(({ ui: ui })=>ui.resizeGuidesVisible);
    const segmentId = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)(({ ui: ui })=>ui.activeSegment);
    const segment = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)(({ street: street })=>segmentId !== null ? street.segments[segmentId] : null);
    const remainingWidth = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)(({ street: street })=>street.remainingWidth);
    // Calculate render position when the resize guides become visible.
    // The position is memoized to prevent unnecessary re-renders during a
    // resize drag action. Its appearance should remain the same throughout the
    // entire drag action.
    const display = (0, $4DE7A.useMemo)(()=>$e7eba4b896e98618$var$calculateStyles(isVisible, segmentId, segment, remainingWidth), // The `segment` and `remainingWidth` values may change during the resize
    // action, but they should NOT update this calculation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isVisible,
        segmentId
    ]);
    if (!isVisible || segment === null) return null;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "resize-guides",
        style: display.style,
        children: [
            display.minGuideStyle && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "resize-guide resize-guide-min",
                style: display.minGuideStyle,
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "resize-guide-min-before",
                        children: [
                            "\xab ",
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "segments.resize.min",
                                defaultMessage: "Min"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "resize-guide-min-after",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "segments.resize.min",
                                defaultMessage: "Min"
                            }),
                            " \xbb"
                        ]
                    })
                ]
            }),
            display.maxGuideStyle && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "resize-guide resize-guide-max",
                style: display.maxGuideStyle,
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "resize-guide-max-before",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "segments.resize.max",
                                defaultMessage: "Max"
                            }),
                            " \xbb"
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                        className: "resize-guide-max-after",
                        children: [
                            "\xab ",
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "segments.resize.max",
                                defaultMessage: "Max"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $e7eba4b896e98618$var$calculateStyles(isVisible, segmentId, segment, remainingWidth) {
    if (!isVisible || segmentId === null || segment === null) return {};
    // TODO: fix type of variantInfo
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const variantInfo = (0, $0cc5ae9f1eba4866$export$a7e4a724089e6511)(segment.type, segment.variantString);
    // If the variant has a minimum width defined, we show minimum-width guides
    const minWidth = variantInfo.minWidth ?? undefined;
    // Maximum-width guides are based on several factors:
    // - If the variant does not have a maximum width defined, then the segment's
    //   maximum width is the remaining width of the street, if any
    // - If the variant has a maximum width defined, then the segment is limited
    //   to that definition, or the remaining width of the street, whichever is
    //   is lower.
    // - Lastly, there is an edge case. If the segment has a _minimum_ width
    //   defined, but there isn't any remaining space after the segment has hit
    //   the minimum width, then we don't show the maximum guide at all.
    const actualRemainingWidth = remainingWidth + segment.width;
    const shouldUseRemainingWidth = actualRemainingWidth > 0 && (typeof variantInfo.minWidth === "undefined" && actualRemainingWidth >= (0, $e1cc3cddc7acf1a4$export$256c1c4ce479d4eb) || actualRemainingWidth >= variantInfo.minWidth) && (typeof variantInfo.maxWidth === "undefined" || actualRemainingWidth <= variantInfo.maxWidth);
    // Calculate the centerline of the segment (its left offset plus half its width)
    const el = (0, $2f44915f6f87dcf5$export$a3c673416be46295)(segmentId);
    const [posX] = (0, $ec5f57ce491b339b$export$640758d8e8e3d19e)(el);
    const centerline = posX + el.offsetWidth / 2;
    // Returns styles used to position the guides
    return {
        style: {
            left: centerline
        },
        minGuideStyle: $e7eba4b896e98618$var$getStyle(minWidth),
        maxGuideStyle: shouldUseRemainingWidth ? $e7eba4b896e98618$var$getStyle(actualRemainingWidth) : $e7eba4b896e98618$var$getStyle(variantInfo.maxWidth)
    };
}
function $e7eba4b896e98618$var$getStyle(width) {
    if (typeof width !== "number") return undefined;
    const pixelWidth = width * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381);
    return {
        width: `${pixelWidth}px`,
        marginLeft: -pixelWidth / 2 + "px"
    };
}
var $e7eba4b896e98618$export$2e2bcd8739ae039 = $e7eba4b896e98618$var$ResizeGuides;



parcelRequire("4DE7A");


parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");




parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");



var $4DE7A = parcelRequire("4DE7A");


function $0f00ce0d5ef3f14c$var$MeasurementText(props) {
    const { value: value, units: units = (0, $c098fdb90228b950$export$95a57d0e83881bf), locale: locale } = props;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
        children: (0, $83fecf775ebd2a37$export$f87bc2ba75a381c)(value, units, locale)
    });
}
var // This component is memoized because `prettifyWidth()` can be expensive
$0f00ce0d5ef3f14c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $4DE7A.memo)($0f00ce0d5ef3f14c$var$MeasurementText);





$8e47ee5943ef2907$var$SegmentLabelContainer.propTypes = {
    // Label can be a string or a React element, e.g. <FormattedMessage />.
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).element
    ]).isRequired,
    showCapacity: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
    capacity: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number.isRequired,
    units: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string.isRequired
};
function $8e47ee5943ef2907$var$SegmentLabelContainer(props) {
    const { label: label, showCapacity: showCapacity = false, capacity: capacity, width: width, units: units = (0, $c098fdb90228b950$export$95a57d0e83881bf), locale: locale } = props;
    const gridClassNames = [
        "segment-grid"
    ];
    // Add class names for measurement grid marks
    if (units === (0, $c098fdb90228b950$export$95a57d0e83881bf)) gridClassNames.push("units-metric");
    else gridClassNames.push("units-imperial");
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "segment-label-container",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: gridClassNames.join(" ")
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "segment-width",
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $0f00ce0d5ef3f14c$export$2e2bcd8739ae039), {
                    value: width,
                    units: units,
                    locale: locale
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                className: "segment-label",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                        className: "segment-name",
                        children: label
                    }),
                    showCapacity && capacity !== null && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                        className: "segment-capacity",
                        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                            id: "capacity.ppl-per-hour",
                            defaultMessage: "{capacity} people/hr",
                            values: {
                                capacity: (0, $9d270f5a79da1a95$export$f5dd818bff069720)(capacity, locale)
                            }
                        })
                    })
                ]
            })
        ]
    });
}
var $8e47ee5943ef2907$export$2e2bcd8739ae039 = $8e47ee5943ef2907$var$SegmentLabelContainer;



/**
 * This is a "presentational" component in the React presentational/container
 * component pattern. Its "container" (parent) component, <EmptySegmentContainer />,
 * determines and passes the `width` and `left` props to this component.
 */ $bee6ab8bd93fe44d$var$EmptySegment.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    left: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
};
function $bee6ab8bd93fe44d$var$EmptySegment({ width: width = 0, left: left = 0 }) {
    const units = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street.units);
    const locale = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.locale.locale);
    // Do not render if width is a negative number
    if (width <= 0) return null;
    // Inline style specifies size and position
    // `width` and `left` are provided as real-world measurements. This is
    // multiplied by TILE_SIZE to get the pixel dimension and offset.
    const style = {
        width: width * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) + "px",
        left: left * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) + "px"
    };
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "segment segment-empty",
        style: style,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $8e47ee5943ef2907$export$2e2bcd8739ae039), {
            label: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                id: "section.empty",
                defaultMessage: "Empty space"
            }),
            width: width,
            units: units,
            locale: locale
        })
    });
}
var $bee6ab8bd93fe44d$export$2e2bcd8739ae039 = $bee6ab8bd93fe44d$var$EmptySegment;


/**
 * This is a "container" component in the React presentational/container
 * component pattern. This component determines how many child <EmptySegment />
 * components are rendered, how wide they are, and where they are positioned.
 */ function $66176b535eaeb5ab$var$EmptySegmentContainer(props) {
    const remainingWidth = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street.remainingWidth);
    const occupiedWidth = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street.occupiedWidth);
    const emptySegments = [];
    // If there is no remaining width, display nothing
    if (remainingWidth > 0) {
        // If street is not occupied by any segments, then only display one empty segment
        // at the full width of the street (which equals `remainingWidth`)
        if (!occupiedWidth) emptySegments.push({
            width: remainingWidth
        });
        else {
            // If the street has segments, then we display 2 segments of equal width at the
            // left and right side of the street by splitting the remaining width in half.
            const width = remainingWidth / 2;
            emptySegments.push({
                width: width,
                left: 0
            }, {
                width: width,
                left: width + occupiedWidth
            });
        }
    }
    return emptySegments.map(({ width: width, left: left }, i)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $bee6ab8bd93fe44d$export$2e2bcd8739ae039), {
            width: width,
            left: left
        }, i));
}
var $66176b535eaeb5ab$export$2e2bcd8739ae039 = $66176b535eaeb5ab$var$EmptySegmentContainer;









var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");



$9400cb10b4353838$var$ScrollIndicators.propTypes = {
    left: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    right: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
    scrollStreet: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired
};
function $9400cb10b4353838$var$ScrollIndicators({ scrollStreet: scrollStreet, left: left = 0, right: right = 0 }) {
    const intl = (0, $d05758791eb139fa$exports.useIntl)();
    /**
   * Sets up and takes down event listeners for keys.
   *  - Left arrow scrolls left one screen
   *  - Right arrow scrolls right one screen
   *  - If shift is pressed, screen scrolls to extents.
   */ (0, $4DE7A.useEffect)(()=>{
        (0, $89f2807011121cdf$export$bc520ed1c57f0d75)([
            "left",
            "shift left"
        ], handleScrollLeft);
        (0, $89f2807011121cdf$export$bc520ed1c57f0d75)([
            "right",
            "shift right"
        ], handleScrollRight);
        return ()=>{
            (0, $89f2807011121cdf$export$86df18839624bc06)([
                "left",
                "shift left"
            ], handleScrollLeft);
            (0, $89f2807011121cdf$export$86df18839624bc06)([
                "right",
                "shift right"
            ], handleScrollRight);
        };
    });
    function handleScrollLeft(event) {
        scrollStreet(true, event.shiftKey);
    }
    function handleScrollRight(event) {
        scrollStreet(false, event.shiftKey);
    }
    const scrollLeftLabel = intl.formatMessage({
        id: "tooltip.scroll-street-left",
        defaultMessage: "Scroll street left"
    });
    const scrollRightLabel = intl.formatMessage({
        id: "tooltip.scroll-street-right",
        defaultMessage: "Scroll street right"
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "street-scroll-indicators",
        children: [
            left > 0 && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
                className: "street-scroll-indicator-left",
                onClick: handleScrollLeft,
                title: scrollLeftLabel,
                "aria-label": scrollLeftLabel,
                children: Array(left + 1).join("\u2039")
            }),
            right > 0 && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("button", {
                className: "street-scroll-indicator-right",
                onClick: handleScrollRight,
                title: scrollRightLabel,
                "aria-label": scrollRightLabel,
                children: Array(right + 1).join("\u203A")
            })
        ]
    });
}
var $9400cb10b4353838$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).memo($9400cb10b4353838$var$ScrollIndicators);



parcelRequire("4DE7A");





var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");



function $79b69f8f22e9c382$var$SkyBackground(props) {
    const { environment: environment } = props;
    const transitions = (0, $2c03db10edbdd570$export$7b286972b8d8ccbf)(environment, {
        from: {
            opacity: 0
        },
        enter: {
            opacity: 1
        },
        leave: {
            opacity: 0
        },
        config: {
            duration: 500
        }
    });
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "sky-background",
        children: transitions((style, item)=>/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $80a1228f70d6ae64$export$407448d2b89b1813).div, {
                className: "sky-background-color",
                style: {
                    ...style,
                    ...(0, $3506aa481686351c$export$553e874a5cd79aa6)(item).style
                }
            }))
    });
}
$79b69f8f22e9c382$var$SkyBackground.propTypes = {
    environment: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string
};
var $79b69f8f22e9c382$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).memo($79b69f8f22e9c382$var$SkyBackground);




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");

var $50biD = parcelRequire("50biD");

var $dBd5b = parcelRequire("dBd5b");

var $aw3S5 = parcelRequire("aw3S5");

var $2ogmM = parcelRequire("2ogmM");


var $4DE7A = parcelRequire("4DE7A");


var $4DE7A = parcelRequire("4DE7A");
function $c6be7a318383424e$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $4DE7A.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $4DE7A.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $c6be7a318383424e$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $c6be7a318383424e$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $c6be7a318383424e$export$fa71e2345c31d7a2(props, onExited) {
    return $c6be7a318383424e$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $4DE7A.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $c6be7a318383424e$var$getProp(child, "appear", props),
            enter: $c6be7a318383424e$var$getProp(child, "enter", props),
            exit: $c6be7a318383424e$var$getProp(child, "exit", props)
        });
    });
}
function $c6be7a318383424e$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $c6be7a318383424e$export$bbc8a025727ea824(nextProps.children);
    var children = $c6be7a318383424e$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $4DE7A.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $4DE7A.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $4DE7A.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $c6be7a318383424e$var$getProp(child, "exit", nextProps),
            enter: $c6be7a318383424e$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $4DE7A.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $4DE7A.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $4DE7A.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $c6be7a318383424e$var$getProp(child, "exit", nextProps),
            enter: $c6be7a318383424e$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $993dfbd6bca145d3$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $993dfbd6bca145d3$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $993dfbd6bca145d3$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $2ogmM.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $aw3S5.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $c6be7a318383424e$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $c6be7a318383424e$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $c6be7a318383424e$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $dBd5b.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $50biD.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $993dfbd6bca145d3$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, $5cfecb0d1f2ac607$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement((0, $5cfecb0d1f2ac607$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Component);
$993dfbd6bca145d3$var$TransitionGroup.propTypes = {};
$993dfbd6bca145d3$var$TransitionGroup.defaultProps = $993dfbd6bca145d3$var$defaultProps;
var $993dfbd6bca145d3$export$2e2bcd8739ae039 = $993dfbd6bca145d3$var$TransitionGroup;




$d6a292cb6db73b3b$var$SkyObjects.propTypes = {
    objects: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).shape({
        images: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        height: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        top: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        left: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
    }))
};
function $d6a292cb6db73b3b$var$SkyObjects({ objects: objects = [] }) {
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $993dfbd6bca145d3$export$2e2bcd8739ae039), {
        className: "sky-background-objects",
        children: objects.map((object)=>{
            const img = (0, $898fc845a8d311b5$export$6c746a5570b8b35c).get(object.image);
            // Render only if asset is found
            if (img) return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $13c11db3c6cdc4a8$export$2e2bcd8739ae039), {
                timeout: {
                    enter: 0,
                    exit: 500
                },
                classNames: "sky-background-object",
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                    style: {
                        width: object.width,
                        height: object.height,
                        position: "absolute",
                        left: `calc(${object.left * 100}% - (${object.width}px / 2)`,
                        top: `calc(${object.top * 100}% - (${object.height}px / 2)`
                    },
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
                        src: img.src,
                        style: {
                            width: "100%",
                            height: "100%"
                        }
                    })
                })
            }, object.image);
            // Render nothing if asset is missing
            // We cannot pass `null` to <TransitionGroup>, it will throw an error
            // So we pass a Fragment, which must also have a key because it is
            // inside an array
            // TODO: Render placeholder ("dev") asset? That way it will be more
            // obvious that something is missing, and work on placement/size can
            // be done even if an actual asset isn't ready yet.
            return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Fragment, {}, object.image);
        })
    });
}
var $d6a292cb6db73b3b$export$2e2bcd8739ae039 = $d6a292cb6db73b3b$var$SkyObjects;



const $6657d9504ff3e699$var$REAR_CLOUD_PARALLAX_SPEED = 0.25;
const $6657d9504ff3e699$var$FRONT_CLOUD_PARALLAX_SPEED = 0.5;
function $6657d9504ff3e699$var$SkyContainer(props) {
    const { scrollPos: scrollPos = 0 } = props;
    const environment = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.street.environment || (0, $2a9a05c10189c2fe$export$cb0b75edbeba6d1a));
    const animations = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.flags.ENVIRONMENT_ANIMATIONS?.value || false);
    const environs = (0, $3506aa481686351c$export$553e874a5cd79aa6)(environment);
    const frontCloudStyle = {
        ...$6657d9504ff3e699$var$getCloudPosition(true, scrollPos),
        opacity: environs.cloudOpacity ?? null
    };
    const rearCloudStyle = {
        ...$6657d9504ff3e699$var$getCloudPosition(false, scrollPos),
        opacity: environs.cloudOpacity ?? null
    };
    const foregroundStyle = {};
    if (typeof environs.foregroundGradient !== "undefined") {
        foregroundStyle.backgroundImage = (0, $3506aa481686351c$export$c59a9ae64e82508e)(environs.foregroundGradient);
        foregroundStyle.opacity = 1;
    } else foregroundStyle.opacity = 0;
    const classes = [
        "street-section-sky"
    ];
    if (animations) classes.push("environment-animations");
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("section", {
        className: classes.join(" "),
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $79b69f8f22e9c382$export$2e2bcd8739ae039), {
                environment: environment
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d6a292cb6db73b3b$export$2e2bcd8739ae039), {
                objects: environs.backgroundObjects
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "rear-clouds",
                style: rearCloudStyle
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "front-clouds",
                style: frontCloudStyle
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "sky-foreground",
                style: foregroundStyle
            })
        ]
    });
}
function $6657d9504ff3e699$var$getCloudPosition(isFront, scrollPos) {
    const speed = isFront ? $6657d9504ff3e699$var$FRONT_CLOUD_PARALLAX_SPEED : $6657d9504ff3e699$var$REAR_CLOUD_PARALLAX_SPEED;
    const pos = scrollPos * speed;
    return {
        backgroundPosition: `-${pos}px 0`
    };
}
var $6657d9504ff3e699$export$2e2bcd8739ae039 = $6657d9504ff3e699$var$SkyContainer;




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");


function $3e389feed1c86b8a$var$getDirtElementHeight() {
    const streetSectionTop = (0, $7e17dc93f2b84ce7$export$8734426d8f1593a2)();
    return window.innerHeight - streetSectionTop - 400 + 180;
}
const $3e389feed1c86b8a$var$StreetViewDirt = ({ buildingWidth: buildingWidth })=>{
    const dirtStyle = {
        marginLeft: -buildingWidth + "px",
        marginRight: -buildingWidth + "px",
        height: $3e389feed1c86b8a$var$getDirtElementHeight() + "px"
    };
    const width = `${buildingWidth}px`;
    // On window resize, figure out what height it should be and apply it
    const dirtEl = (0, $4DE7A.useRef)(null);
    (0, $4DE7A.useEffect)(()=>{
        function handleResize() {
            dirtEl.current.style.height = $3e389feed1c86b8a$var$getDirtElementHeight() + "px";
        }
        // Set window listener to do this
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("section", {
        className: "street-section-dirt",
        ref: dirtEl,
        style: dirtStyle,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "street-section-dirt-left",
                style: {
                    width: width
                }
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "street-section-dirt-right",
                style: {
                    width: width
                }
            })
        ]
    });
};
$3e389feed1c86b8a$var$StreetViewDirt.propTypes = {
    buildingWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
};
var $3e389feed1c86b8a$export$2e2bcd8739ae039 = $3e389feed1c86b8a$var$StreetViewDirt;




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");



function $51c10c5521aedf12$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $51c10c5521aedf12$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $51c10c5521aedf12$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $51c10c5521aedf12$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $51c10c5521aedf12$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $51c10c5521aedf12$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $51c10c5521aedf12$var$isCallingCanDrop = false;
var $51c10c5521aedf12$export$9fe8834769ae8ddf = /*#__PURE__*/ function() {
    function DropTargetMonitorImpl(manager) {
        $51c10c5521aedf12$var$_classCallCheck(this, DropTargetMonitorImpl);
        $51c10c5521aedf12$var$_defineProperty(this, "internalMonitor", void 0);
        $51c10c5521aedf12$var$_defineProperty(this, "targetId", null);
        this.internalMonitor = manager.getMonitor();
    }
    $51c10c5521aedf12$var$_createClass(DropTargetMonitorImpl, [
        {
            key: "receiveHandlerId",
            value: function receiveHandlerId(targetId) {
                this.targetId = targetId;
            }
        },
        {
            key: "getHandlerId",
            value: function getHandlerId() {
                return this.targetId;
            }
        },
        {
            key: "subscribeToStateChange",
            value: function subscribeToStateChange(listener, options) {
                return this.internalMonitor.subscribeToStateChange(listener, options);
            }
        },
        {
            key: "canDrop",
            value: function canDrop() {
                // Cut out early if the target id has not been set. This should prevent errors
                // where the user has an older version of dnd-core like in
                // https://github.com/react-dnd/react-dnd/issues/1310
                if (!this.targetId) return false;
                (0, $2daa4a08f076625e$export$f5708dca728d7177)(!$51c10c5521aedf12$var$isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
                try {
                    $51c10c5521aedf12$var$isCallingCanDrop = true;
                    return this.internalMonitor.canDropOnTarget(this.targetId);
                } finally{
                    $51c10c5521aedf12$var$isCallingCanDrop = false;
                }
            }
        },
        {
            key: "isOver",
            value: function isOver(options) {
                if (!this.targetId) return false;
                return this.internalMonitor.isOverTarget(this.targetId, options);
            }
        },
        {
            key: "getItemType",
            value: function getItemType() {
                return this.internalMonitor.getItemType();
            }
        },
        {
            key: "getItem",
            value: function getItem() {
                return this.internalMonitor.getItem();
            }
        },
        {
            key: "getDropResult",
            value: function getDropResult() {
                return this.internalMonitor.getDropResult();
            }
        },
        {
            key: "didDrop",
            value: function didDrop() {
                return this.internalMonitor.didDrop();
            }
        },
        {
            key: "getInitialClientOffset",
            value: function getInitialClientOffset() {
                return this.internalMonitor.getInitialClientOffset();
            }
        },
        {
            key: "getInitialSourceClientOffset",
            value: function getInitialSourceClientOffset() {
                return this.internalMonitor.getInitialSourceClientOffset();
            }
        },
        {
            key: "getSourceClientOffset",
            value: function getSourceClientOffset() {
                return this.internalMonitor.getSourceClientOffset();
            }
        },
        {
            key: "getClientOffset",
            value: function getClientOffset() {
                return this.internalMonitor.getClientOffset();
            }
        },
        {
            key: "getDifferenceFromInitialOffset",
            value: function getDifferenceFromInitialOffset() {
                return this.internalMonitor.getDifferenceFromInitialOffset();
            }
        }
    ]);
    return DropTargetMonitorImpl;
}();




function $d51a6a1f66d44bdb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d51a6a1f66d44bdb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d51a6a1f66d44bdb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d51a6a1f66d44bdb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d51a6a1f66d44bdb$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d51a6a1f66d44bdb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d51a6a1f66d44bdb$export$ed6d7b7bc55193cf = /*#__PURE__*/ function() {
    // The drop target may either be attached via ref or connect function
    function TargetConnector(backend) {
        var _this = this;
        $d51a6a1f66d44bdb$var$_classCallCheck(this, TargetConnector);
        $d51a6a1f66d44bdb$var$_defineProperty(this, "hooks", (0, $3120d1ee18286303$export$d8dcaf80ab4f6cb7)({
            dropTarget: function dropTarget(node, options) {
                _this.clearDropTarget();
                _this.dropTargetOptions = options;
                if ((0, $52360539e7864b82$export$4f9f5282de18fc69)(node)) _this.dropTargetRef = node;
                else _this.dropTargetNode = node;
                _this.reconnect();
            }
        }));
        $d51a6a1f66d44bdb$var$_defineProperty(this, "handlerId", null);
        $d51a6a1f66d44bdb$var$_defineProperty(this, "dropTargetRef", null);
        $d51a6a1f66d44bdb$var$_defineProperty(this, "dropTargetNode", void 0);
        $d51a6a1f66d44bdb$var$_defineProperty(this, "dropTargetOptionsInternal", null);
        $d51a6a1f66d44bdb$var$_defineProperty(this, "unsubscribeDropTarget", void 0);
        $d51a6a1f66d44bdb$var$_defineProperty(this, "lastConnectedHandlerId", null);
        $d51a6a1f66d44bdb$var$_defineProperty(this, "lastConnectedDropTarget", null);
        $d51a6a1f66d44bdb$var$_defineProperty(this, "lastConnectedDropTargetOptions", null);
        $d51a6a1f66d44bdb$var$_defineProperty(this, "backend", void 0);
        this.backend = backend;
    }
    $d51a6a1f66d44bdb$var$_createClass(TargetConnector, [
        {
            key: "connectTarget",
            get: function get() {
                return this.dropTarget;
            }
        },
        {
            key: "reconnect",
            value: function reconnect() {
                // if nothing has changed then don't resubscribe
                var didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
                if (didChange) this.disconnectDropTarget();
                var dropTarget = this.dropTarget;
                if (!this.handlerId) return;
                if (!dropTarget) {
                    this.lastConnectedDropTarget = dropTarget;
                    return;
                }
                if (didChange) {
                    this.lastConnectedHandlerId = this.handlerId;
                    this.lastConnectedDropTarget = dropTarget;
                    this.lastConnectedDropTargetOptions = this.dropTargetOptions;
                    this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
                }
            }
        },
        {
            key: "receiveHandlerId",
            value: function receiveHandlerId(newHandlerId) {
                if (newHandlerId === this.handlerId) return;
                this.handlerId = newHandlerId;
                this.reconnect();
            }
        },
        {
            key: "dropTargetOptions",
            get: function get() {
                return this.dropTargetOptionsInternal;
            },
            set: function set(options) {
                this.dropTargetOptionsInternal = options;
            }
        },
        {
            key: "didHandlerIdChange",
            value: function didHandlerIdChange() {
                return this.lastConnectedHandlerId !== this.handlerId;
            }
        },
        {
            key: "didDropTargetChange",
            value: function didDropTargetChange() {
                return this.lastConnectedDropTarget !== this.dropTarget;
            }
        },
        {
            key: "didOptionsChange",
            value: function didOptionsChange() {
                return !(0, $91edbb15e5e7db4c$export$d36bdfa510afb180)(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
            }
        },
        {
            key: "disconnectDropTarget",
            value: function disconnectDropTarget() {
                if (this.unsubscribeDropTarget) {
                    this.unsubscribeDropTarget();
                    this.unsubscribeDropTarget = undefined;
                }
            }
        },
        {
            key: "dropTarget",
            get: function get() {
                return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
            }
        },
        {
            key: "clearDropTarget",
            value: function clearDropTarget() {
                this.dropTargetRef = null;
                this.dropTargetNode = null;
            }
        }
    ]);
    return TargetConnector;
}();






function $6ad6f1b834b74783$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6ad6f1b834b74783$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6ad6f1b834b74783$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6ad6f1b834b74783$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6ad6f1b834b74783$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6ad6f1b834b74783$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6ad6f1b834b74783$var$ALLOWED_SPEC_METHODS = [
    "canDrop",
    "hover",
    "drop"
];
var $6ad6f1b834b74783$var$TargetImpl = /*#__PURE__*/ function() {
    function TargetImpl(spec, monitor, ref) {
        $6ad6f1b834b74783$var$_classCallCheck(this, TargetImpl);
        $6ad6f1b834b74783$var$_defineProperty(this, "props", null);
        $6ad6f1b834b74783$var$_defineProperty(this, "spec", void 0);
        $6ad6f1b834b74783$var$_defineProperty(this, "monitor", void 0);
        $6ad6f1b834b74783$var$_defineProperty(this, "ref", void 0);
        this.spec = spec;
        this.monitor = monitor;
        this.ref = ref;
    }
    $6ad6f1b834b74783$var$_createClass(TargetImpl, [
        {
            key: "receiveProps",
            value: function receiveProps(props) {
                this.props = props;
            }
        },
        {
            key: "receiveMonitor",
            value: function receiveMonitor(monitor) {
                this.monitor = monitor;
            }
        },
        {
            key: "canDrop",
            value: function canDrop() {
                if (!this.spec.canDrop) return true;
                return this.spec.canDrop(this.props, this.monitor);
            }
        },
        {
            key: "hover",
            value: function hover() {
                if (!this.spec.hover || !this.props) return;
                this.spec.hover(this.props, this.monitor, (0, $b1cde746e5ea11e6$export$c4f820ef5e50813b)(this.ref));
            }
        },
        {
            key: "drop",
            value: function drop() {
                if (!this.spec.drop) return undefined;
                var dropResult = this.spec.drop(this.props, this.monitor, this.ref.current);
                return dropResult;
            }
        }
    ]);
    return TargetImpl;
}();
function $6ad6f1b834b74783$export$b0ebe228609540b7(spec) {
    Object.keys(spec).forEach(function(key) {
        (0, $2daa4a08f076625e$export$f5708dca728d7177)($6ad6f1b834b74783$var$ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have some of the following keys: %s. Instead received a specification with an unexpected "%s" key. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', $6ad6f1b834b74783$var$ALLOWED_SPEC_METHODS.join(", "), key);
        (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof spec[key] === "function", "Expected %s in the drop target specification to be a function. Instead received a specification with %s: %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target", key, key, spec[key]);
    });
    return function createTarget(monitor, ref) {
        return new $6ad6f1b834b74783$var$TargetImpl(spec, monitor, ref);
    };
}


function $b2465e193d4f6a86$export$79660a248b11010(type, spec, collect) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    (0, $b1cde746e5ea11e6$export$ffeaa70abe2dcf1c)("DropTarget", "type, spec, collect[, options]", type, spec, collect, options);
    var getType = type;
    if (typeof type !== "function") {
        (0, $2daa4a08f076625e$export$f5708dca728d7177)((0, $b1cde746e5ea11e6$export$2698d5b4be829db6)(type, true), 'Expected "type" provided as the first argument to DropTarget to be a string, an array of strings, or a function that returns either given the current props. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', type);
        getType = function getType() {
            return type;
        };
    }
    (0, $2daa4a08f076625e$export$f5708dca728d7177)((0, $b1cde746e5ea11e6$export$53b83ca8eaab0383)(spec), 'Expected "spec" provided as the second argument to DropTarget to be a plain object. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', spec);
    var createTarget = (0, $6ad6f1b834b74783$export$b0ebe228609540b7)(spec);
    (0, $2daa4a08f076625e$export$f5708dca728d7177)(typeof collect === "function", 'Expected "collect" provided as the third argument to DropTarget to be a function that returns a plain object of props to inject. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', collect);
    (0, $2daa4a08f076625e$export$f5708dca728d7177)((0, $b1cde746e5ea11e6$export$53b83ca8eaab0383)(options), 'Expected "options" provided as the fourth argument to DropTarget to be a plain object when specified. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', collect);
    return function decorateTarget(DecoratedComponent) {
        return (0, $78f2df3bcc3325ac$export$868ec1615c0ccfd8)({
            containerDisplayName: "DropTarget",
            createHandler: createTarget,
            registerHandler: (0, $e363ee57e8e93320$export$38b18180ae58b09b),
            createMonitor: function createMonitor(manager) {
                return new (0, $51c10c5521aedf12$export$9fe8834769ae8ddf)(manager);
            },
            createConnector: function createConnector(backend) {
                return new (0, $d51a6a1f66d44bdb$export$ed6d7b7bc55193cf)(backend);
            },
            DecoratedComponent: DecoratedComponent,
            getType: getType,
            collect: collect,
            options: options
        });
    };
}



/**
 * Replacement for lodash's flow().
 *
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * This is the vanilla JS implementation via
 * https://youmightnotneed.com/lodash/#flow
 *
 * WARNING: This is not a drop in replacement solution and it might not work
 * for some edge cases.
 *
 * @param {Array} funcs - array of functions
 * @returns Function
 */ function $06c855fec1fdf3c0$export$ccc7b0636abaffc3(funcs) {
    return (...args)=>funcs.reduce((prev, fnc)=>[
                fnc(...prev)
            ], args)[0];
}




var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");
















var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");




$6bc26bbf338bd94d$var$SegmentDragHandles.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
};
function $6bc26bbf338bd94d$var$SegmentDragHandles({ width: width }) {
    const infoBubbleHovered = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.infoBubble.mouseInside);
    const descriptionVisible = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.infoBubble.descriptionVisible);
    const display = infoBubbleHovered || descriptionVisible ? "none" : null;
    // To prevent drag handles from overlapping each other when the segmen
    // widths are very small, we calculate an X-position adjustment when the
    // value of `width` is less than 60px. The X position adjustment follows
    // the linear equation y = 0.5x - 35 (where `x` is `width`).
    // For example:
    //    width = 36 ==> adjustX = -11px
    //    width = 12 ==> adjustX = -29px
    const adjustX = width < 60 ? `${0.5 * width - 35}px` : null;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                className: "drag-handle drag-handle-left",
                style: {
                    display: display,
                    left: adjustX
                },
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                    icon: (0, $5cbf5c54789c9bf6$export$731a703adf2141b2)
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                className: "drag-handle drag-handle-right",
                style: {
                    display: display,
                    right: adjustX
                },
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca2ffd1693af9883$export$2b9260d4a45c8710), {
                    icon: (0, $5cbf5c54789c9bf6$export$acbe832e28edcfdb)
                })
            })
        ]
    });
}
var $6bc26bbf338bd94d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).memo($6bc26bbf338bd94d$var$SegmentDragHandles);








class $9dbf90ddc201dc7c$export$d53aa5c5ab432700 extends (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Component {
    static propTypes = {
        // Provided by parent
        dataNo: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        enableAnalytics: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
        segment: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object.isRequired,
        actualWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number.isRequired,
        units: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        segmentPos: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        updateSegmentData: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
        updatePerspective: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
        // Provided by store
        locale: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
        descriptionVisible: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool,
        activeSegment: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        capacitySource: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).string,
        setActiveSegment: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
        incrementSegmentWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
        removeSegmentAction: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
        clearSegmentsAction: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
        addToast: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
        // Provided by react-dnd DragSource and DropTarget
        connectDragSource: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
        connectDragPreview: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
        connectDropTarget: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func,
        isDragging: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool
    };
    constructor(props){
        super(props);
        this.initialRender = true;
        this.state = {
            switchSegments: false,
            oldVariant: props.segment.variantString
        };
    }
    componentDidMount = ()=>{
        this.props.updateSegmentData(this.streetSegment, this.props.dataNo, this.props.segmentPos);
        this.props.connectDragPreview((0, $a7f417e231983d05$export$bf32f66787bcad4b)(), {
            captureDraggingState: true
        });
    };
    componentDidUpdate(prevProps, prevState) {
        // TODO: there should be checks if the calls to the prop methods should be made in the first place. see discussion here: https://github.com/streetmix/streetmix/pull/1227#discussion_r263536187
        // During a segment removal or a dragging action, the infoBubble temporarily does not appear
        // for the hovered/dragged segment. Once the removal or drag action ends, the infoBubble for
        // the active segment should be shown. The following IF statement checks to see if a removal
        // or drag action occurred previously to this segment and displays the infoBubble for the
        // segment if it is equal to the activeSegment and no infoBubble was shown already.
        const wasDragging = prevProps.isDragging && !this.props.isDragging || this.initialRender && (this.props.activeSegment || this.props.activeSegment === 0);
        this.initialRender = false;
        if (wasDragging && this.props.activeSegment === this.props.dataNo) (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).considerShowing(false, this.streetSegment, (0, $4fd11a0514b0f864$export$d460bc3f6742cc13));
        if (prevProps.segment.variantString && prevProps.segment.variantString !== this.props.segment.variantString) this.handleSwitchSegments(prevProps.segment.variantString);
        // Also animate the switching if elevation changes.
        // Maybe we don't always do this forever, but it makes it match
        // existing elevation variant behavior
        if (prevProps.segment.elevation !== undefined && prevProps.segment.elevation !== this.props.segment.elevation) this.handleSwitchSegments(prevProps.segment.variantString);
        this.props.updateSegmentData(this.streetSegment, this.props.dataNo, this.props.segmentPos);
    }
    componentWillUnmount = ()=>{
        document.removeEventListener("keydown", this.handleKeyDown);
    };
    handleSwitchSegments = (oldVariant)=>{
        this.setState({
            switchSegments: !this.state.switchSegments,
            oldVariant: this.state.switchSegments ? this.props.segment.variantString : oldVariant
        });
    };
    calculateSegmentWidths = ()=>{
        let actualWidth = this.props.actualWidth;
        actualWidth = (0, $edbb716917ec500c$export$e06f682fb9edb199)(actualWidth, (0, $edbb716917ec500c$export$12e0a54c23e0f7be)((0, $edbb716917ec500c$export$bef0bdcd5a467cae), this.props.units));
        return actualWidth;
    };
    handleSegmentMouseEnter = (event)=>{
        // Immediately after a segment move action, react-dnd can incorrectly trigger this handler
        // on the segment that exists in the previous segment's spot. The bug is tracked here
        // (https://github.com/streetmix/streetmix/pull/1262) and here (https://github.com/react-dnd/react-dnd/issues/1102).
        // We work around this by setting `__BUGFIX_SUPPRESS_WRONG_MOUSEENTER_HANDLER` to `true`
        // immediately after the move action, which prevents us from firing this event handler one
        // time. This is suppressed once, then reset.
        if ((0, $b6e16a46f37cea3c$export$3663c9a87c5e8e0)() === true) {
            (0, $b6e16a46f37cea3c$export$4883359709ecef8e)();
            return;
        }
        this.props.setActiveSegment(this.props.dataNo);
        document.addEventListener("keydown", this.handleKeyDown);
        (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).considerShowing(event, this.streetSegment, (0, $4fd11a0514b0f864$export$d460bc3f6742cc13));
    };
    handleSegmentMouseLeave = ()=>{
        document.removeEventListener("keydown", this.handleKeyDown);
        (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).dontConsiderShowing();
    };
    renderSegmentCanvas = (variantType)=>{
        const isOldVariant = variantType === "old";
        const { segment: segment, connectDragSource: connectDragSource, connectDropTarget: connectDropTarget } = this.props;
        // The segment ID is a string that uniquely identifies the segment
        // and can be used as a consistent and reliable seed for a PRNG
        const randSeed = segment.id;
        return connectDragSource(connectDropTarget(/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
            className: "segment-canvas-container",
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $30cdd43412d19a3f$export$2e2bcd8739ae039), {
                actualWidth: this.props.actualWidth,
                type: segment.type,
                variantString: isOldVariant ? this.state.oldVariant : segment.variantString,
                randSeed: randSeed,
                elevation: segment.elevation,
                updatePerspective: this.props.updatePerspective
            })
        })));
    };
    /**
   * Decreases segment width
   *
   * @param {Number} position - segment position
   * @param {Boolean} finetune - true if shift key is pressed
   */ decrementSegmentWidth(position, finetune) {
        this.props.incrementSegmentWidth(position, false, finetune, this.props.actualWidth, (0, $edbb716917ec500c$export$fb22fa3ad2794469));
    }
    /**
   * Increases segment width
   *
   * @param {Number} position - segment position
   * @param {Boolean} finetune - true if shift key is pressed
   */ incrementSegmentWidth(position, finetune) {
        this.props.incrementSegmentWidth(position, true, finetune, this.props.actualWidth, (0, $edbb716917ec500c$export$fb22fa3ad2794469));
    }
    handleKeyDown = (event)=>{
        switch(event.key){
            case "-":
                if (event.metaKey || event.ctrlKey || event.altKey) return;
                event.preventDefault();
                this.decrementSegmentWidth(this.props.dataNo, event.shiftKey);
                break;
            // Plus (+) may only triggered with shift key, so also check if
            // the same physical key (Equal) is pressed
            case "+":
            case "=":
                if (event.metaKey || event.ctrlKey || event.altKey) return;
                event.preventDefault();
                this.incrementSegmentWidth(this.props.dataNo, event.shiftKey);
                break;
            case "Backspace":
            case "Delete":
                // Prevent deletion from occurring if the description is visible
                if (this.props.descriptionVisible) return;
                // If the shift key is pressed, we remove all segments
                if (event.shiftKey === true) {
                    this.props.clearSegmentsAction();
                    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hide();
                    this.props.addToast({
                        message: (0, $4daaf0496059b305$export$25868d1e8e76735f)("toast.all-segments-deleted", "All segments have been removed."),
                        component: "TOAST_UNDO"
                    });
                } else {
                    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hide();
                    (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).hideSegment();
                    this.props.addToast({
                        message: (0, $4daaf0496059b305$export$25868d1e8e76735f)("toast.segment-deleted", "The segment has been removed."),
                        component: "TOAST_UNDO"
                    });
                    this.props.removeSegmentAction(this.props.dataNo, false);
                }
                break;
            default:
                break;
        }
    };
    render() {
        const { segment: segment, enableAnalytics: enableAnalytics = true, capacitySource: capacitySource } = this.props;
        const segmentInfo = (0, $0cc5ae9f1eba4866$export$c3985e6b9763d4c2)(segment.type);
        // Get localized names from store, fall back to segment default names if translated
        // text is not found. TODO: port to react-intl/formatMessage later.
        const displayName = segment.label || (0, $2f44915f6f87dcf5$export$d5e75d6299e9897e)(segment.type, segment.variantString);
        const average = (0, $403f4a82e85beb9f$export$b79e9cb93bcb351)(segment, capacitySource)?.average ?? null;
        const actualWidth = this.calculateSegmentWidths();
        const elementWidth = actualWidth * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381);
        const translate = "translateX(" + this.props.segmentPos + "px)";
        const segmentStyle = {
            width: elementWidth + "px",
            // In a street, certain segments have stacking priority over others (expressed as z-index).
            // Setting a z-index here will clobber a separate z-index (applied via CSS) when hovered by mouse pointer
            zIndex: this.props.isDragging ? 0 : segmentInfo.zIndex,
            WebkitTransform: translate,
            transform: translate
        };
        const classNames = [
            "segment"
        ];
        if (this.props.isDragging) classNames.push("dragged-out");
        else if (this.props.activeSegment === this.props.dataNo) classNames.push("hover", "show-drag-handles");
        // Palette segments don't have `segment` defined
        if (segment && segment.warnings) {
            if (segment.warnings[0, $e1cc3cddc7acf1a4$export$bd07f8babb22a89f] || segment.warnings[0, $e1cc3cddc7acf1a4$export$1603ba7a45cd1a72] || segment.warnings[0, $e1cc3cddc7acf1a4$export$529213ff1df6a1b5]) classNames.push("warning");
            if (segment.warnings[0, $e1cc3cddc7acf1a4$export$bd07f8babb22a89f]) classNames.push("outside");
        }
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
            style: segmentStyle,
            className: classNames.join(" "),
            "data-testid": "segment",
            ref: (ref)=>{
                this.streetSegment = ref;
            },
            onMouseEnter: this.handleSegmentMouseEnter,
            onMouseLeave: this.handleSegmentMouseLeave,
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $8e47ee5943ef2907$export$2e2bcd8739ae039), {
                    label: displayName,
                    width: actualWidth,
                    units: this.props.units,
                    locale: this.props.locale,
                    capacity: average,
                    showCapacity: enableAnalytics
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6bc26bbf338bd94d$export$2e2bcd8739ae039), {
                    width: elementWidth
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $13c11db3c6cdc4a8$export$2e2bcd8739ae039), {
                    in: !this.state.switchSegments,
                    classNames: "switching-away",
                    timeout: 250,
                    onExited: this.handleSwitchSegments,
                    unmountOnExit: true,
                    children: this.renderSegmentCanvas("old")
                }, "old-variant"),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $13c11db3c6cdc4a8$export$2e2bcd8739ae039), {
                    in: this.state.switchSegments,
                    classNames: "switching-in",
                    timeout: 250,
                    unmountOnExit: true,
                    children: this.renderSegmentCanvas("new")
                }, "new-variant"),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                    className: "hover-bk"
                })
            ]
        });
    }
}
function $9dbf90ddc201dc7c$var$mapStateToProps(state) {
    return {
        enableAnalytics: state.flags.ANALYTICS.value && state.street.showAnalytics,
        locale: state.locale.locale,
        descriptionVisible: state.infoBubble.descriptionVisible,
        activeSegment: typeof state.ui.activeSegment === "number" ? state.ui.activeSegment : null,
        capacitySource: state.street.capacitySource
    };
}
const $9dbf90ddc201dc7c$var$mapDispatchToProps = {
    clearSegmentsAction: $8041aaeb3f701cec$export$914352425a81b663,
    incrementSegmentWidth: $8041aaeb3f701cec$export$834095b984dd9c8d,
    removeSegmentAction: $8041aaeb3f701cec$export$1103dc2b4ceb6805,
    setActiveSegment: $cb9eeb171d537a5a$export$20b4b8898e0d9c76,
    addToast: $ed796acc6691d871$export$2cb648f4e71e8121
};
var $9dbf90ddc201dc7c$export$2e2bcd8739ae039 = (0, $06c855fec1fdf3c0$export$ccc7b0636abaffc3)([
    (0, $7595e846cc562683$export$ab54abbdde9d5f2)((0, $b6e16a46f37cea3c$export$4624c240901a6889).SEGMENT, (0, $b6e16a46f37cea3c$export$980f51409408fd87), (0, $b6e16a46f37cea3c$export$547f4e518ca74a90)),
    (0, $b2465e193d4f6a86$export$79660a248b11010)([
        (0, $b6e16a46f37cea3c$export$4624c240901a6889).SEGMENT,
        (0, $b6e16a46f37cea3c$export$4624c240901a6889).PALETTE_SEGMENT
    ], (0, $b6e16a46f37cea3c$export$c1a15083e52d3549), (0, $b6e16a46f37cea3c$export$24f60742cb520ad4)),
    (0, $a4829965bb94612b$export$2e2bcd8739ae039)($9dbf90ddc201dc7c$var$mapStateToProps, $9dbf90ddc201dc7c$var$mapDispatchToProps)
])($9dbf90ddc201dc7c$export$d53aa5c5ab432700);





class $54dc2dbfe5807df8$export$fc68b00178015e7 extends (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Component {
    static propTypes = {
        // Provided by parent
        resizeType: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        setBuildingWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
        updatePerspective: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func.isRequired,
        draggingType: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number,
        // Provided by store
        street: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object.isRequired,
        draggingState: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object,
        // Provided by DropTarget
        connectDropTarget: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).func
    };
    // Internal "state", but does not affect renders, so it is not React state
    withinCanvas = null;
    // Placeholder for a ref.
    // TODO: Upgrade to createRef(), but this is currently broken when placed on
    // an element inside of react-dnd's `connectDragSource`.
    // Info: https://github.com/react-dnd/react-dnd/issues/998
    streetSectionEditable = null;
    componentDidMount() {
        this.props.setBuildingWidth(this.streetSectionEditable);
    }
    componentDidUpdate(prevProps) {
        const { resizeType: resizeType, draggingState: draggingState } = this.props;
        if (resizeType && !prevProps.resizeType || prevProps.draggingType === (0, $e1cc3cddc7acf1a4$export$e9db4516ea26d802) && !this.props.draggingType) this.props.setBuildingWidth(this.streetSectionEditable);
        if (prevProps.street.id !== this.props.street.id || prevProps.street.width !== this.props.street.width) (0, $edbb716917ec500c$export$3058040811eebf87)();
        const dragEvents = [
            "dragover",
            "touchmove"
        ];
        if (!prevProps.draggingState && draggingState) dragEvents.forEach((type)=>{
            window.addEventListener(type, this.updateWithinCanvas);
        });
        else if (prevProps.draggingState && !draggingState) dragEvents.forEach((type)=>{
            window.removeEventListener(type, this.updateWithinCanvas);
        });
    }
    updateWithinCanvas = (event)=>{
        const withinCanvas = (0, $b6e16a46f37cea3c$export$f964eeba1b6307d)(event, this.streetSectionEditable);
        if (withinCanvas) document.body.classList.remove("not-within-canvas");
        else document.body.classList.add("not-within-canvas");
        if (this.withinCanvas !== withinCanvas) this.withinCanvas = withinCanvas;
    };
    updateSegmentData = (ref, dataNo, segmentPos)=>{
        const { segments: segments } = this.props.street;
        const segment = segments[dataNo];
        if (segment) {
            ref.dataNo = dataNo;
            ref.savedLeft = Math.round(segmentPos);
        }
    };
    handleSwitchSegmentAway = (el)=>{
        el.classList.add("create");
        el.style.left = el.savedLeft + "px";
        this.props.updatePerspective(el);
    };
    calculateSegmentPos = (dataNo)=>{
        const { segments: segments, remainingWidth: remainingWidth } = this.props.street;
        const { draggingState: draggingState } = this.props;
        let currPos = 0;
        for(let i = 0; i < dataNo; i++){
            const width = draggingState && draggingState.draggedSegment === i ? 0 : segments[i].width * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381);
            currPos += width;
        }
        let mainLeft = remainingWidth;
        if (draggingState && segments[draggingState.draggedSegment] !== undefined) {
            const draggedWidth = segments[draggingState.draggedSegment].width || 0;
            mainLeft += draggedWidth;
        }
        mainLeft = mainLeft * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) / 2;
        if (draggingState && this.withinCanvas) {
            mainLeft -= (0, $e1cc3cddc7acf1a4$export$f5d69cc55972365c);
            const spaceBetweenSegments = (0, $b6e16a46f37cea3c$export$7cfc0c87baff46a6)(dataNo, draggingState);
            return mainLeft + currPos + spaceBetweenSegments;
        } else return mainLeft + currPos;
    };
    onExitAnimations = (child)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).cloneElement(child, {
            exit: !this.props.street.immediateRemoval
        });
    };
    renderStreetSegments = ()=>{
        const { segments: segments, units: units, immediateRemoval: immediateRemoval } = this.props.street;
        const streetId = this.props.street.id;
        return segments.map((segment, i)=>{
            const segmentPos = this.calculateSegmentPos(i);
            const segmentEl = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $13c11db3c6cdc4a8$export$2e2bcd8739ae039), {
                timeout: 250,
                classNames: "switching-away",
                exit: !immediateRemoval,
                onExit: this.handleSwitchSegmentAway,
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $9dbf90ddc201dc7c$export$2e2bcd8739ae039), {
                    dataNo: i,
                    segment: {
                        ...segment
                    },
                    actualWidth: segment.width,
                    units: units,
                    segmentPos: segmentPos,
                    updateSegmentData: this.updateSegmentData,
                    updatePerspective: this.props.updatePerspective
                })
            }, `${streetId}.${segment.id}`);
            return segmentEl;
        });
    };
    render() {
        const { connectDropTarget: connectDropTarget } = this.props;
        const style = {
            width: this.props.street.width * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381) + "px"
        };
        return connectDropTarget(/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
            id: "street-section-editable",
            style: style,
            ref: (ref)=>{
                this.streetSectionEditable = ref;
            },
            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $993dfbd6bca145d3$export$2e2bcd8739ae039), {
                component: null,
                enter: false,
                childFactory: this.onExitAnimations,
                children: this.renderStreetSegments()
            }, this.props.street.id)
        }, this.props.street.id));
    }
}
function $54dc2dbfe5807df8$var$mapStateToProps(state) {
    return {
        street: state.street,
        draggingState: state.ui.draggingState
    };
}
var $54dc2dbfe5807df8$export$2e2bcd8739ae039 = (0, $06c855fec1fdf3c0$export$ccc7b0636abaffc3)([
    (0, $b2465e193d4f6a86$export$79660a248b11010)([
        (0, $b6e16a46f37cea3c$export$4624c240901a6889).SEGMENT,
        (0, $b6e16a46f37cea3c$export$4624c240901a6889).PALETTE_SEGMENT
    ], (0, $b6e16a46f37cea3c$export$ab49c599a2b7246), (0, $b6e16a46f37cea3c$export$24f60742cb520ad4)),
    (0, $a4829965bb94612b$export$2e2bcd8739ae039)($54dc2dbfe5807df8$var$mapStateToProps)
])($54dc2dbfe5807df8$export$fc68b00178015e7);



const $d87c846213d6e663$var$SEGMENT_RESIZED = 1;
const $d87c846213d6e663$var$STREETVIEW_RESIZED = 2;
class $d87c846213d6e663$var$StreetView extends (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).Component {
    static propTypes = {
        street: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).object.isRequired,
        draggingType: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).number
    };
    constructor(props){
        super(props);
        this.state = {
            isStreetScrolling: false,
            scrollIndicators: {
                left: 0,
                right: 0
            },
            resizeType: null,
            buildingWidth: 0
        };
        this.sectionEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createRef();
        this.sectionCanvasEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4DE7A))).createRef();
    }
    componentDidMount() {
        this.handleStreetResize();
        window.addEventListener("resize", this.handleStreetResize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleStreetResize);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.street.width !== this.props.street.width) // We are permitted one setState in componentDidUpdate if
        // it's inside of a condition, like it is now.
        this.handleStreetResize();
        // Two cases where scrollLeft might have to be updated:
        // 1) Building width has changed due to segments being dragged in/out of StreetView or being resized
        // 2) Street width changed causing remainingWidth to change, but not building width
        if (prevState.buildingWidth !== this.state.buildingWidth || prevState.resizeType === $d87c846213d6e663$var$STREETVIEW_RESIZED && !this.state.resizeType) {
            const deltaX = this.state.buildingWidth - prevState.buildingWidth;
            // If segment was resized (either dragged or incremented), update scrollLeft to make up for margin change.
            if (prevState.resizeType === $d87c846213d6e663$var$SEGMENT_RESIZED || prevState.resizeType === this.state.resizeType) this.updateScrollLeft(deltaX);
            else if (prevState.resizeType === $d87c846213d6e663$var$STREETVIEW_RESIZED) {
                // If StreetView was resized/changed (either viewport, streetWidth, or street itself),
                // update scrollLeft to center street view and check if margins need to be updated.
                this.updateScrollLeft();
                this.resizeStreetExtent($d87c846213d6e663$var$SEGMENT_RESIZED, true);
            }
        }
        // Updating margins when segment is resized by dragging is handled in resizing.js
        if (prevProps.street.occupiedWidth !== this.props.street.occupiedWidth && this.props.draggingType !== (0, $e1cc3cddc7acf1a4$export$e9db4516ea26d802)) {
            // Check if occupiedWidth changed because segment was changed (resized, added, or removed)
            // or because gallery street was changed, and update accordingly.
            const resizeType = this.props.street.id !== prevProps.street.id ? $d87c846213d6e663$var$STREETVIEW_RESIZED : $d87c846213d6e663$var$SEGMENT_RESIZED;
            const dontDelay = resizeType === $d87c846213d6e663$var$STREETVIEW_RESIZED;
            this.resizeStreetExtent(resizeType, dontDelay);
        }
    }
    resizeStreetExtent = (resizeType, dontDelay)=>{
        const marginUpdated = (0, $edbb716917ec500c$export$3686c0f8435095fd)(this.sectionCanvasEl.current, this.sectionEl.current, dontDelay);
        if (marginUpdated) this.setState({
            resizeType: resizeType
        });
    };
    updateScrollLeft = (deltaX)=>{
        let scrollLeft = this.sectionEl.current.scrollLeft;
        if (deltaX) scrollLeft += deltaX;
        else {
            const streetWidth = this.props.street.width * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381);
            const currBuildingSpace = this.state.buildingWidth ? this.state.buildingWidth : (0, $e1cc3cddc7acf1a4$export$8b837123dd5f6a79);
            scrollLeft = (streetWidth + currBuildingSpace * 2 - window.innerWidth) / 2;
        }
        this.sectionEl.current.scrollLeft = scrollLeft;
    };
    onResize = ()=>{
        if (!this.sectionCanvasEl.current) return;
        const viewportWidth = window.innerWidth;
        const streetWidth = this.props.street.width * (0, $e1cc3cddc7acf1a4$export$cf9ad17145f68381);
        let streetSectionCanvasLeft = (viewportWidth - streetWidth) / 2 - (0, $e1cc3cddc7acf1a4$export$8b837123dd5f6a79);
        if (streetSectionCanvasLeft < 0) streetSectionCanvasLeft = 0;
        this.sectionCanvasEl.current.style.width = streetWidth + "px";
        this.sectionCanvasEl.current.style.left = streetSectionCanvasLeft + "px";
        return {
            resizeType: $d87c846213d6e663$var$STREETVIEW_RESIZED
        };
    };
    handleStreetResize = ()=>{
        // Place all scroll-based positioning effects inside of a "raf"
        // callback for better performance.
        window.requestAnimationFrame(()=>{
            const resizeState = this.onResize();
            const scrollIndicators = this.calculateScrollIndicators();
            this.setState({
                ...resizeState,
                scrollIndicators: scrollIndicators
            });
        });
    };
    /**
   * Event handler for street scrolling.
   */ handleStreetScroll = (event)=>{
        (0, $62b1ef0171009a7b$export$8a66765a71c06fe6).suppress();
        // Place all scroll-based positioning effects inside of a "raf"
        // callback for better performance.
        window.requestAnimationFrame(()=>{
            const scrollIndicators = this.calculateScrollIndicators();
            this.setState({
                scrollIndicators: scrollIndicators,
                scrollPos: this.getStreetScrollPosition()
            });
        });
    };
    /**
   * Based on street width and scroll position, determine how many
   * left and right "scroll indicator" arrows to display. This number
   * is calculated as the street scrolls and stored in state.
   */ calculateScrollIndicators = ()=>{
        const el = this.sectionEl.current;
        if (!el) return;
        let scrollIndicatorsLeft;
        let scrollIndicatorsRight;
        if (el.scrollWidth <= el.offsetWidth) {
            scrollIndicatorsLeft = 0;
            scrollIndicatorsRight = 0;
        } else {
            const left = el.scrollLeft / (el.scrollWidth - el.offsetWidth);
            // TODO const off max width street
            let posMax = Math.round(this.props.street.width / (0, $2a9a05c10189c2fe$export$59cfd33ad5cf1eb5) * 6);
            if (posMax < 2) posMax = 2;
            scrollIndicatorsLeft = Math.round(posMax * left);
            if (left > 0 && scrollIndicatorsLeft === 0) scrollIndicatorsLeft = 1;
            if (left < 1.0 && scrollIndicatorsLeft === posMax) scrollIndicatorsLeft = posMax - 1;
            scrollIndicatorsRight = posMax - scrollIndicatorsLeft;
        }
        return {
            left: scrollIndicatorsLeft,
            right: scrollIndicatorsRight
        };
    };
    scrollStreet = (left, far = false)=>{
        const el = this.sectionEl.current;
        let newScrollLeft;
        if (left) {
            if (far) newScrollLeft = 0;
            else newScrollLeft = el.scrollLeft - el.offsetWidth * 0.5;
        } else if (far) newScrollLeft = el.scrollWidth - el.offsetWidth;
        else newScrollLeft = el.scrollLeft + el.offsetWidth * 0.5;
        (0, $ec5f57ce491b339b$export$e3607ec2d7a891c4)(el, {
            scrollLeft: newScrollLeft
        }, 300);
    };
    setBuildingWidth = (el)=>{
        const pos = (0, $ec5f57ce491b339b$export$a92df11a83653854)(el);
        let width = pos[0];
        if (width < 0) width = 0;
        this.setState({
            buildingWidth: width,
            resizeType: null
        });
    };
    getStreetScrollPosition = ()=>{
        return this.sectionEl.current?.scrollLeft ?? 0;
    };
    /**
   * Updates a segment or building's CSS `perspective-origin` property according
   * to its current position in the street and on the screen, which is used
   * when it animates in or out. Because this reads and writes to DOM, only call
   * this function after a render. Do not set state or call other side effects
   * from this function.
   *
   * @params (HTMLElement) - the element to apply CSS to
   */ updatePerspective = (el)=>{
        if (!el) return;
        const pos = (0, $ec5f57ce491b339b$export$a92df11a83653854)(el);
        const scrollPos = this.getStreetScrollPosition();
        const perspective = -(pos[0] - scrollPos - window.innerWidth / 2);
        el.style.webkitPerspectiveOrigin = perspective / 2 + "px 50%";
        el.style.MozPerspectiveOrigin = perspective / 2 + "px 50%";
        el.style.perspectiveOrigin = perspective / 2 + "px 50%";
    };
    render() {
        return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("section", {
                    id: "street-section-outer",
                    onScroll: this.handleStreetScroll,
                    ref: this.sectionEl,
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("section", {
                        id: "street-section-inner",
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("section", {
                                id: "street-section-canvas",
                                ref: this.sectionCanvasEl,
                                children: [
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $63767c842c1edb41$export$2e2bcd8739ae039), {
                                        position: "left",
                                        buildingWidth: this.state.buildingWidth,
                                        updatePerspective: this.updatePerspective
                                    }),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $63767c842c1edb41$export$2e2bcd8739ae039), {
                                        position: "right",
                                        buildingWidth: this.state.buildingWidth,
                                        updatePerspective: this.updatePerspective
                                    }),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $54dc2dbfe5807df8$export$2e2bcd8739ae039), {
                                        resizeType: this.state.resizeType,
                                        setBuildingWidth: this.setBuildingWidth,
                                        updatePerspective: this.updatePerspective,
                                        draggingType: this.props.draggingType
                                    }),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e7eba4b896e98618$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $66176b535eaeb5ab$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $3e389feed1c86b8a$export$2e2bcd8739ae039), {
                                        buildingWidth: this.state.buildingWidth
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $9400cb10b4353838$export$2e2bcd8739ae039), {
                                left: this.state.scrollIndicators.left,
                                right: this.state.scrollIndicators.right,
                                scrollStreet: this.scrollStreet
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6657d9504ff3e699$export$2e2bcd8739ae039), {
                    scrollPos: this.state.scrollPos
                })
            ]
        });
    }
}
function $d87c846213d6e663$var$mapStateToProps(state) {
    return {
        street: state.street,
        draggingType: state.ui.draggingType
    };
}
var $d87c846213d6e663$export$2e2bcd8739ae039 = (0, $a4829965bb94612b$export$2e2bcd8739ae039)($d87c846213d6e663$var$mapStateToProps)($d87c846213d6e663$var$StreetView);




var $4DE7A = parcelRequire("4DE7A");

var $gv34t = parcelRequire("gv34t");




function $3d56f340f0424ee6$var$PrintContainer(props) {
    const isPrinting = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.app.printing);
    const street = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const printImage = (0, $4DE7A.useRef)(null);
    (0, $4DE7A.useEffect)(()=>{
        const beforeprintHandler = ()=>{
            // `flushSync` is a rarely used React feature that forces updates to
            // synchronously "flush" to DOM in order to play nicely with the
            // browser. We *need* to do this during the `beforeprint` event
            // otherwise there's nothing to print!
            // https://beta.reactjs.org/reference/react-dom/flushSync
            (0, $gv34t.flushSync)(()=>{
                dispatch((0, $9dbab908c178b0dc$export$e000c6e7623fb0b)());
            });
        };
        const afterprintHandler = ()=>dispatch((0, $9dbab908c178b0dc$export$616269833dda0c1)());
        // Add event listeners to handle a print event
        window.addEventListener("beforeprint", beforeprintHandler);
        window.addEventListener("afterprint", afterprintHandler);
        // Clean up listeners
        return ()=>{
            window.removeEventListener("beforeprint", beforeprintHandler);
            window.removeEventListener("afterprint", afterprintHandler);
        };
    }, [
        dispatch
    ]);
    if (isPrinting) // Caches the image to a ref. This DOM element is only visible in a print
    // media query, but leaving it around after printing is over allows
    // debugging the print result after the print action is done.
    printImage.current = (0, $464cf4d7282b8d55$export$1948dfdf2eab675b)(street, true, true, false).toDataURL("image/png");
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "print-container",
        children: printImage.current && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("img", {
            src: printImage.current
        })
    });
}
var $3d56f340f0424ee6$export$2e2bcd8739ae039 = $3d56f340f0424ee6$var$PrintContainer;




var $4DE7A = parcelRequire("4DE7A");








var $4DE7A = parcelRequire("4DE7A");





function $eec5f5ee0bda66ad$var$NewStreet(props) {
    const newStreetPreference = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.settings.newStreetPreference);
    const priorLastStreetId = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.app.priorLastStreetId);
    const street = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    // If welcomeType is WELCOME_NEW_STREET, there is an additional state
    // property that determines which of the new street modes is selected
    let selectedNewStreetType;
    switch(newStreetPreference){
        case 0, $2a9a05c10189c2fe$export$fe67c041c7fe7c2:
            selectedNewStreetType = "new-street-empty";
            break;
        case 0, $2a9a05c10189c2fe$export$a312938bcd95f73c:
        default:
            selectedNewStreetType = "new-street-default";
            break;
    }
    const [state, setState] = (0, $4DE7A.useState)({
        selectedNewStreetType: selectedNewStreetType
    });
    // Handles changing the "checked" state of the input buttons.
    function handleChangeNewStreetType(event) {
        setState({
            selectedNewStreetType: event.target.id
        });
    }
    function handleGetLastStreet(event) {
        dispatch((0, $8041aaeb3f701cec$export$5fb9e92b8c98fefe)());
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "welcome-panel-content new-street",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "dialogs.new-street.heading",
                    defaultMessage: "Here\u2019s your new street."
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("input", {
                                type: "radio",
                                name: "new-street",
                                id: "new-street-default",
                                checked: state.selectedNewStreetType === "new-street-default" || !state.selectedNewStreetType,
                                onChange: handleChangeNewStreetType,
                                onClick: (0, $8a3f808dfa88cc0c$export$1563f5079ee61708)
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("label", {
                                htmlFor: "new-street-default",
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "dialogs.new-street.default",
                                    defaultMessage: "Start with an example street"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("input", {
                                type: "radio",
                                name: "new-street",
                                id: "new-street-empty",
                                checked: state.selectedNewStreetType === "new-street-empty",
                                onChange: handleChangeNewStreetType,
                                onClick: (0, $8a3f808dfa88cc0c$export$a20f0d151f82e88e)
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("label", {
                                htmlFor: "new-street-empty",
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "dialogs.new-street.empty",
                                    defaultMessage: "Start with an empty street"
                                })
                            })
                        ]
                    }),
                    priorLastStreetId && priorLastStreetId !== street.id && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("input", {
                                type: "radio",
                                name: "new-street",
                                id: "new-street-last",
                                checked: state.selectedNewStreetType === "new-street-last",
                                onChange: handleChangeNewStreetType,
                                onClick: handleGetLastStreet
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("label", {
                                htmlFor: "new-street-last",
                                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                    id: "dialogs.new-street.last",
                                    defaultMessage: "Start with a copy of last street"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $eec5f5ee0bda66ad$export$2e2bcd8739ae039 = $eec5f5ee0bda66ad$var$NewStreet;



parcelRequire("4DE7A");








function $1b678b7a9d32e923$var$FirstTimeExistingStreet(props) {
    const street = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.street);
    const { data: creatorProfile } = (0, $e2f405c0a03fcace$export$9beb97f355b95ab9)(street.creatorId);
    function handleGoNewStreet(event) {
        (0, $bf0e96131613bbb0$export$f4b50a5a69b60bc2)();
        (0, $f3d8f18722148e05$export$a22ca88ad1ac21dd)(true);
    }
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "welcome-panel-content first-time-existing-street",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "dialogs.welcome.heading",
                    defaultMessage: "Welcome to Streetmix."
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "paragraph",
                children: street.creatorId ? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "dialogs.welcome.existing.intro",
                    defaultMessage: "This is {streetName} made by {creator}.",
                    values: {
                        streetName: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $1b80e7badd3600dc$export$2e2bcd8739ae039), {
                            name: street.name
                        }),
                        creator: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $aad6e9d6c00e3001$export$2e2bcd8739ae039), {
                                    userId: street.creatorId
                                }),
                                " ",
                                creatorProfile?.displayName || street.creatorId
                            ]
                        })
                    }
                }) : /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "dialogs.welcome.existing.intro-without-creator",
                    defaultMessage: "This is {streetName}.",
                    values: {
                        streetName: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $1b80e7badd3600dc$export$2e2bcd8739ae039), {
                            name: street.name
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                className: "important",
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "dialogs.welcome.existing.instruct",
                    defaultMessage: "Remix it by moving some segments around, or {startYourOwnStreet}.",
                    values: {
                        startYourOwnStreet: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e6b8fb83be03caef$export$2e2bcd8739ae039), {
                            onClick: handleGoNewStreet,
                            children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                                id: "dialogs.welcome.existing.instruct-start-own-street",
                                defaultMessage: "Start your own street"
                            })
                        })
                    }
                })
            })
        ]
    });
}
var $1b678b7a9d32e923$export$2e2bcd8739ae039 = $1b678b7a9d32e923$var$FirstTimeExistingStreet;



parcelRequire("4DE7A");

function $f7960cd9f6e73b3f$var$FirstTimeNewStreet(props) {
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "welcome-panel-content first-time-new-street",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("h1", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "dialogs.welcome.heading",
                    defaultMessage: "Welcome to Streetmix."
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "dialogs.welcome.new.intro",
                    defaultMessage: "Design, remix, and share your neighborhood street. Add trees or bike paths, widen sidewalks or traffic lanes, learn how your decisions can impact your community."
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("p", {
                className: "important",
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "dialogs.welcome.new.instruction",
                    defaultMessage: "Start by moving some segments around."
                })
            })
        ]
    });
}
var $f7960cd9f6e73b3f$export$2e2bcd8739ae039 = $f7960cd9f6e73b3f$var$FirstTimeNewStreet;



const $bf0e96131613bbb0$var$WELCOME_NONE = 0;
const $bf0e96131613bbb0$var$WELCOME_NEW_STREET = 1;
const $bf0e96131613bbb0$var$WELCOME_FIRST_TIME_NEW_STREET = 2;
const $bf0e96131613bbb0$var$WELCOME_FIRST_TIME_EXISTING_STREET = 3;
// In the past, dismissing the welcome panel would set this flag in
// LocalStorage, and the next time a welcome panel would be shown for a
// returning user, the presence of this flag would show different content (or
// not display the welcome panel at all).
//
// This naming convention caused confusion during the conversion to a
// React function component, because in reality there are two states we care
// about:
// - the welcome panel is dismissed _for the session_ (and will not re-apppear
//   _this session_)
// - the user is a first-time user, and dismissing the welcome panel changes
//   its content _in the future_
//
// The first value is ephemeral state, ao it is set only for the duration of
// the session and is discarded if the tab is closed. We want to keep using
// `dismissed` to label this state.
//
// The second value is persistent state. This is the one that's saved to
// LocalStorage and is retrieved when the app is loaded to determine what
// type of welcome message will be displayed. The LocalStorage key name
// is now no longer what it means, but for now we keep it for backwards
// compatibility
const $bf0e96131613bbb0$var$LOCAL_STORAGE_RETURNING_USER = "settings-welcome-dismissed";
function $bf0e96131613bbb0$var$WelcomePanel(props) {
    const { readOnly: readOnly, everythingLoaded: everythingLoaded } = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.app);
    const { welcomePanelVisible: isVisible, welcomePanelDismissed: isDismissed } = (0, $5be681cecefb99e4$export$2105062e25df4afe)((state)=>state.ui);
    const dispatch = (0, $80615d9151c4c54f$export$8ad76b76a4c905f8)();
    const [welcomeType, setWelcomeType] = (0, $4DE7A.useState)($bf0e96131613bbb0$var$WELCOME_NONE);
    const [isReturningUser, setIsReturningUser] = (0, $4DE7A.useState)($bf0e96131613bbb0$var$getIsReturningUserFromLocalStorage());
    // Do not show under the following conditions:
    // If app is read-only
    // If app has not fully loaded yet
    // If user has dismissed the panel this session
    // If the welcome type is WELCOME_NONE
    //
    // When rendering, the dispatch call below affects the state of another
    // component (`StreetNameplateContainer`), which throws an error in React.
    // This is considered a bug, despite the functionality behaving as expected.
    // The fix is to wrap this in `useEffect` so that the dispatch call occurs
    // after the render is done. For more information see the discussion at
    // https://github.com/streetmix/streetmix/issues/2324
    (0, $4DE7A.useEffect)(()=>{
        if (!readOnly && everythingLoaded && !isDismissed && welcomeType !== $bf0e96131613bbb0$var$WELCOME_NONE) dispatch((0, $cb9eeb171d537a5a$export$a7ea15a59aa12c50)());
    });
    const handleWelcomeDismissed = (0, $4DE7A.useCallback)(()=>{
        // Certain events will dismiss the welcome panel. If already
        // invisible, do nothing.
        if (welcomeType === $bf0e96131613bbb0$var$WELCOME_NONE) return;
        setWelcomeType($bf0e96131613bbb0$var$WELCOME_NONE);
        setIsReturningUser(true);
        $bf0e96131613bbb0$export$f4b50a5a69b60bc2();
        dispatch((0, $cb9eeb171d537a5a$export$3369e50a27dc5360)());
    }, [
        welcomeType,
        dispatch
    ]);
    // When everything is loaded, determine what type of welcome panel to show
    (0, $4DE7A.useEffect)(()=>{
        function determineWelcomeType() {
            let welcomeType = $bf0e96131613bbb0$var$WELCOME_NONE;
            if ((0, $20dec064f3771e9c$export$1fc0f6205829e19c)() === (0, $20dec064f3771e9c$export$240b20df485e8ed6).NEW_STREET) {
                if ((0, $9be7409470745503$export$1ae390d25d018ea4)() || isReturningUser) welcomeType = $bf0e96131613bbb0$var$WELCOME_NEW_STREET;
                else welcomeType = $bf0e96131613bbb0$var$WELCOME_FIRST_TIME_NEW_STREET;
            } else if (!isReturningUser) welcomeType = $bf0e96131613bbb0$var$WELCOME_FIRST_TIME_EXISTING_STREET;
            return welcomeType;
        }
        if (everythingLoaded === true) setWelcomeType(determineWelcomeType());
    }, [
        everythingLoaded,
        isReturningUser
    ]);
    // Set up and tear down when a welcome panel is shown
    (0, $4DE7A.useEffect)(()=>{
        // Do nothing with this hook if the panel is not visible
        if (isVisible === false) return;
        // Hide welcome panel on certain events
        window.addEventListener("stmx:receive_gallery_street", handleWelcomeDismissed);
        window.addEventListener("stmx:save_street", handleWelcomeDismissed);
        // Hide welcome panel when someone presses Escape
        (0, $89f2807011121cdf$export$bc520ed1c57f0d75)("esc", handleWelcomeDismissed);
        return ()=>{
            // Clean up event listeners
            window.removeEventListener("stmx:receive_gallery_street", handleWelcomeDismissed);
            window.removeEventListener("stmx:save_street", handleWelcomeDismissed);
            (0, $89f2807011121cdf$export$86df18839624bc06)("esc", handleWelcomeDismissed);
        };
    }, [
        isVisible,
        dispatch,
        handleWelcomeDismissed
    ]);
    // Figure out what to display inside the panel
    let welcomeContent;
    switch(welcomeType){
        case $bf0e96131613bbb0$var$WELCOME_FIRST_TIME_NEW_STREET:
            welcomeContent = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $f7960cd9f6e73b3f$export$2e2bcd8739ae039), {});
            break;
        case $bf0e96131613bbb0$var$WELCOME_FIRST_TIME_EXISTING_STREET:
            welcomeContent = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $1b678b7a9d32e923$export$2e2bcd8739ae039), {});
            break;
        case $bf0e96131613bbb0$var$WELCOME_NEW_STREET:
            welcomeContent = /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $eec5f5ee0bda66ad$export$2e2bcd8739ae039), {});
            break;
        case $bf0e96131613bbb0$var$WELCOME_NONE:
        default:
            welcomeContent = null;
            break;
    }
    // Do not render if the panel is not visible
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
        className: "welcome-panel-container",
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
            className: "welcome-panel",
            children: [
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $f9d7843891fda220$export$2e2bcd8739ae039), {
                    onClick: handleWelcomeDismissed
                }),
                welcomeContent
            ]
        })
    });
}
var $bf0e96131613bbb0$export$2e2bcd8739ae039 = $bf0e96131613bbb0$var$WelcomePanel;
function $bf0e96131613bbb0$export$f4b50a5a69b60bc2() {
    window.localStorage[$bf0e96131613bbb0$var$LOCAL_STORAGE_RETURNING_USER] = "true";
}
/**
 * Retrieves LocalStorage state for whether whether user is a returning user
 */ function $bf0e96131613bbb0$var$getIsReturningUserFromLocalStorage() {
    const localSetting = window.localStorage[$bf0e96131613bbb0$var$LOCAL_STORAGE_RETURNING_USER];
    if (localSetting) return JSON.parse(localSetting);
    return false;
}




var $4DE7A = parcelRequire("4DE7A");






const $67c00b6fbd271875$var$TRANSITION_DURATION = 250;
const $67c00b6fbd271875$var$TRANSITION_BASE_STYLE = {
    transition: `margin ${$67c00b6fbd271875$var$TRANSITION_DURATION}ms ease-out`
};
// NOTE: Notification is passed in as a prop, rather than directly imported
// from notification.json in this file, in order to make it easier to test.
function $67c00b6fbd271875$var$NotificationBar({ notification: notification = {} }) {
    const locale = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.locale);
    const { display: display = false, lede: lede, text: text, link: link, linkText: linkText, localStorageKey: localStorageKey } = notification;
    let shouldDisplay = display;
    // If dismissed, don't display again.
    if (localStorageKey !== undefined && window.localStorage[localStorageKey] !== undefined && JSON.parse(window.localStorage[localStorageKey]) === true) shouldDisplay = false;
    const [show, setShow] = (0, $4DE7A.useState)(shouldDisplay);
    const [height, setHeight] = (0, $4DE7A.useState)(0);
    const el = (0, $4DE7A.useRef)(null);
    const handleClickDismiss = ()=>{
        if (el.current === null) return;
        const height = el.current.getBoundingClientRect().height;
        setHeight(height);
        setShow(false);
    };
    const handleExited = ()=>{
        try {
            if (localStorageKey !== undefined) window.localStorage[localStorageKey] = JSON.stringify(true);
        } catch (error) {
        // Cannot modify localstorage.
        }
    };
    // If no one turns this on explicitly, don't display anything
    if (!display || lede === undefined && text === undefined && link === undefined) return null;
    // If locale isn't English, don't display; we don't localize these messages
    if (locale.locale !== "en") return null;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $0bbe1d2d2979a273$export$2e2bcd8739ae039), {
        in: show,
        timeout: $67c00b6fbd271875$var$TRANSITION_DURATION,
        onExited: handleExited,
        unmountOnExit: true,
        children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
            className: "notification-bar",
            ref: el,
            style: {
                ...$67c00b6fbd271875$var$TRANSITION_BASE_STYLE,
                marginTop: `-${height}px`
            },
            children: [
                lede !== undefined && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("strong", {
                            className: "notification-bar-intro",
                            children: lede
                        }),
                        " "
                    ]
                }),
                text !== undefined && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                            className: "notification-bar-text",
                            children: text
                        }),
                        " "
                    ]
                }),
                link !== undefined && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                    href: link,
                    className: "notification-bar-link",
                    children: linkText ?? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                        id: "msg.more-info",
                        defaultMessage: "More info"
                    })
                }),
                /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $f9d7843891fda220$export$2e2bcd8739ae039), {
                    onClick: handleClickDismiss
                })
            ]
        })
    });
}
var $67c00b6fbd271875$export$2e2bcd8739ae039 = $67c00b6fbd271875$var$NotificationBar;







var $4DE7A = parcelRequire("4DE7A");

var $fmSD5 = parcelRequire("fmSD5");
// note: see _chrome.scss for styles
function $e168e2c8c34ed4fd$var$Loading({ isLoading: isLoading = true }) {
    const loadingStuckNotice = (0, $4DE7A.useRef)();
    (0, $4DE7A.useLayoutEffect)(()=>{
        // A "not loading" troubleshooting popup to provide a "way out" of totally
        // frozen UIs. Display this after 10 seconds if this component is still visible.
        const timer = window.setTimeout(function() {
            const el = loadingStuckNotice.current;
            if (!el) return;
            el.style.opacity = "1";
            el.style.transform = "translateY(0)";
            el.setAttribute("aria-hidden", "false");
        }, 10000);
        return ()=>{
            window.clearTimeout(timer);
        };
    });
    // The `hidden` attribute is more semantically correct for removing
    // elements that are no longer relevant from the view. This was defined
    // in HTML5 and will not be available in older browsers, but newer browsers
    // will benefit from using it.
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        id: "loading",
        className: isLoading ? "" : "hidden",
        hidden: !isLoading,
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "streetmix-logo"
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("div", {
                className: "loading-spinner"
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                ref: loadingStuckNotice,
                className: "loading-stuck",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("strong", {
                        children: "Not loading?"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                        href: "https://docs.streetmix.net/user-guide/support/troubleshooting",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Troubleshooting tips"
                    })
                ]
            })
        ]
    });
}
$e168e2c8c34ed4fd$var$Loading.propTypes = {
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($fmSD5))).bool
};
var $e168e2c8c34ed4fd$export$2e2bcd8739ae039 = $e168e2c8c34ed4fd$var$Loading;



parcelRequire("4DE7A");





function $6d5c0035c0205039$var$SponsorBanner() {
    const isSubscriber = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.user.isSubscriber);
    // Subscribers don't see sponsor banners
    if (isSubscriber) return null;
    // Bail if configuration is undefined
    if ((0, $63b5c9d178f1431e$export$8732fc1e436c2534) === undefined) return null;
    let banner = {};
    try {
        banner = JSON.parse((0, $63b5c9d178f1431e$export$8732fc1e436c2534));
    } catch (err) {
        console.log("Unable to parse sponsor banner configuration:", err);
    }
    const { lede: lede, text: text, link: link, linkText: linkText } = banner;
    // If we're missing all the pieces, bail
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (!lede && !text && !link) return null;
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
        className: "sponsor-banner",
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                className: "sponsor-title",
                children: "Sponsor"
            }),
            lede && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("strong", {
                        className: "notification-bar-intro",
                        children: lede
                    }),
                    " "
                ]
            }),
            text && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                        className: "notification-bar-text",
                        children: text
                    }),
                    " "
                ]
            }),
            link && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $991e122153555cbd$export$2e2bcd8739ae039), {
                href: link,
                className: "notification-bar-link",
                children: linkText ?? /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.FormattedMessage), {
                    id: "msg.more-info",
                    defaultMessage: "More info"
                })
            }),
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                children: "."
            }),
            "\xa0\xa0\xa0",
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("span", {
                className: "sponsor-banner-misc",
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)("a", {
                    href: "https://about.streetmix.net/sponsorship/",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: "(What are sponsors?)"
                })
            })
        ]
    });
}
var $6d5c0035c0205039$export$2e2bcd8739ae039 = $6d5c0035c0205039$var$SponsorBanner;


function $e87a489c9aaebe09$var$App() {
    const [isLoading, setLoading] = (0, $4DE7A.useState)(true);
    const locale = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.locale);
    const dir = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.app.contentDirection) // TODO use real type
    ;
    const everythingLoaded = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.app.everythingLoaded);
    const colorMode = (0, $c738fd431d4d7b5f$export$2105062e25df4afe)((state)=>state.settings.colorMode);
    const dispatch = (0, $c738fd431d4d7b5f$export$8ad76b76a4c905f8)();
    // TODO: Move other initialization methods here.
    (0, $4DE7A.useEffect)(()=>{
        const init = async ()=>{
            // Initialize feature flags
            await dispatch((0, $1ac426dbdd197303$export$a20893735c88ec6c)());
            // Turn off loading after initial loading is done
            setLoading(false);
        };
        init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // After loading, do ancient DOM stuff
    (0, $4DE7A.useEffect)(()=>{
        if (!isLoading && everythingLoaded) (0, $7e17dc93f2b84ce7$export$c7b050c836e7ea75)();
    }, [
        isLoading,
        everythingLoaded
    ]);
    // Set color mode on top level DOM element
    (0, $4DE7A.useEffect)(()=>{
        // Element is guaranteed to exist
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        document.querySelector("html").dataset.colorMode = colorMode;
    }, [
        colorMode
    ]);
    return /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $6dd45a7735069a79$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e168e2c8c34ed4fd$export$2e2bcd8739ae039), {
                isLoading: isLoading || !everythingLoaded
            }),
            !isLoading && everythingLoaded && /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $ca61ba5b50f7e65b$export$c760c09fdd558351), {
                dir: dir,
                children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d05758791eb139fa$exports.IntlProvider), {
                    locale: locale.locale,
                    messages: locale.messages,
                    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)((0, $4c46f063ffae98fb$export$9861489d68213f9c), {
                        backend: (0, $55109fca61883a44$export$2e2bcd8739ae039),
                        options: (0, $3ff372f1a8f93628$export$2e2bcd8739ae039),
                        context: window,
                        children: [
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $67c00b6fbd271875$export$2e2bcd8739ae039), {
                                notification: (0, (/*@__PURE__*/$parcel$interopDefault($6effca967e0cc0d0$exports)))
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $c19d754c5d86a407$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $7d35f471242169e1$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6659bdc3248eb800$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $4ee6e5a0b0b769a7$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e02cc5ac5505ac75$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $3d56f340f0424ee6$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsxs)("div", {
                                className: "main-screen",
                                children: [
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $a78007a68e8b8c3f$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $97611685388f7b5d$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $2c229c5a65dffcfe$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $3c433e41350f0a75$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $bf0e96131613bbb0$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $2f361047f0e45571$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $85aafb34888eeb6d$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $3f737bae02311d39$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $d87c846213d6e663$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $3cadb6a82c779756$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $9536f6319e688cb2$export$2e2bcd8739ae039), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $6d5c0035c0205039$export$2e2bcd8739ae039), {})
                        ]
                    })
                }, locale.locale)
            })
        ]
    });
}
var $e87a489c9aaebe09$export$2e2bcd8739ae039 = $e87a489c9aaebe09$var$App;


// Error tracking
// Load this before all other modules. Only load when run in production.
if (window.location.hostname === "streetmix.net" || window.location.hostname === "www.streetmix.net") $df1078b31513eaed$export$2cd8252107eb640b({
    dsn: "https://fac2c23600414d2fb78c128cdbdeaf6f@sentry.io/82756",
    allowUrls: [
        /streetmix\.net/,
        /www\.streetmix\.net/
    ]
});
// Accept HMR in Parcel
// NOTE: HMR is broken; changes will throw "Uncaught (in promise) TypeError:
// global is undefined" in hmrApplyUpdates
// also -- since porting this file to TS, `module` will be undefined and
// will crash the app.
// There is not a known workaround; HMR may be disabled until porting
// bundler to Vite.
// if (module?.hot) {
//   module.hot.accept()
// }
// Mount React components
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const $f9975c4956b6640a$var$container = document.getElementById("react-app");
const $f9975c4956b6640a$var$root = (0, $a4406f9443c22771$export$882461b6382ed46c)($f9975c4956b6640a$var$container);
$f9975c4956b6640a$var$root.render(/*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $4dd147938665f4da$export$2e2bcd8739ae039), {
    store: (0, $81878321270eabd6$export$2e2bcd8739ae039),
    children: /*#__PURE__*/ (0, $6dd45a7735069a79$exports.jsx)((0, $e87a489c9aaebe09$export$2e2bcd8739ae039), {})
}));
(0, $09d66509dd0bbd69$export$2a47f398eeff8b01)();

})();
//# sourceMappingURL=main.js.map
